
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$exportWildcard(dest, source) {
  Object.keys(source).forEach(function(key) {
    if (key === 'default' || key === '__esModule' || Object.prototype.hasOwnProperty.call(dest, key)) {
      return;
    }

    Object.defineProperty(dest, key, {
      enumerable: true,
      get: function get() {
        return source[key];
      }
    });
  });

  return dest;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
function $parcel$import(url) {
  url = parcelRequire.i?.[url] || url;
  return import($parcel$distDir + url);
}

function $parcel$extendImportMap(map) {
  Object.assign(parcelRequire.i ??= {}, map);
}
var $parcel$distDir = "./";

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequirecb85"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequirecb85"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("iaang", function(module, exports) {

$parcel$export(module.exports, "Fragment", function () { return $d391354401191e20$export$ffb0004e005737fa; }, function (v) { return $d391354401191e20$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "jsx", function () { return $d391354401191e20$export$34b9dba7ce09269b; }, function (v) { return $d391354401191e20$export$34b9dba7ce09269b = v; });
$parcel$export(module.exports, "jsxs", function () { return $d391354401191e20$export$25062201e9e25d76; }, function (v) { return $d391354401191e20$export$25062201e9e25d76 = v; });
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $d391354401191e20$export$ffb0004e005737fa;
var $d391354401191e20$export$34b9dba7ce09269b;
var $d391354401191e20$export$25062201e9e25d76;
'use strict';

var $gJYWc = parcelRequire("gJYWc");
var $d391354401191e20$var$k = Symbol.for("react.element"), $d391354401191e20$var$l = Symbol.for("react.fragment"), $d391354401191e20$var$m = Object.prototype.hasOwnProperty, $d391354401191e20$var$n = $gJYWc.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, $d391354401191e20$var$p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $d391354401191e20$var$q(c, a, g) {
    var b, d = {}, e = null, h = null;
    void 0 !== g && (e = "" + g);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (h = a.ref);
    for(b in a)$d391354401191e20$var$m.call(a, b) && !$d391354401191e20$var$p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: $d391354401191e20$var$k,
        type: c,
        key: e,
        ref: h,
        props: d,
        _owner: $d391354401191e20$var$n.current
    };
}
$d391354401191e20$export$ffb0004e005737fa = $d391354401191e20$var$l;
$d391354401191e20$export$34b9dba7ce09269b = $d391354401191e20$var$q;
$d391354401191e20$export$25062201e9e25d76 = $d391354401191e20$var$q;

});
parcelRegister("gJYWc", function(module, exports) {
'use strict';

module.exports = (parcelRequire("ihHTa"));

});
parcelRegister("ihHTa", function(module, exports) {

$parcel$export(module.exports, "Children", function () { return $d4fbdbf202f03b28$export$dca3b0875bd9a954; }, function (v) { return $d4fbdbf202f03b28$export$dca3b0875bd9a954 = v; });
$parcel$export(module.exports, "Component", function () { return $d4fbdbf202f03b28$export$16fa2f45be04daa8; }, function (v) { return $d4fbdbf202f03b28$export$16fa2f45be04daa8 = v; });
$parcel$export(module.exports, "Fragment", function () { return $d4fbdbf202f03b28$export$ffb0004e005737fa; }, function (v) { return $d4fbdbf202f03b28$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Profiler", function () { return $d4fbdbf202f03b28$export$e2c29f18771995cb; }, function (v) { return $d4fbdbf202f03b28$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "PureComponent", function () { return $d4fbdbf202f03b28$export$221d75b3f55bb0bd; }, function (v) { return $d4fbdbf202f03b28$export$221d75b3f55bb0bd = v; });
$parcel$export(module.exports, "StrictMode", function () { return $d4fbdbf202f03b28$export$5f8d39834fd61797; }, function (v) { return $d4fbdbf202f03b28$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $d4fbdbf202f03b28$export$74bf444e3cd11ea5; }, function (v) { return $d4fbdbf202f03b28$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $d4fbdbf202f03b28$export$ae55be85d98224ed; }, function (v) { return $d4fbdbf202f03b28$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "act", function () { return $d4fbdbf202f03b28$export$3ba232387fd5d6dd; }, function (v) { return $d4fbdbf202f03b28$export$3ba232387fd5d6dd = v; });
$parcel$export(module.exports, "cloneElement", function () { return $d4fbdbf202f03b28$export$e530037191fcd5d7; }, function (v) { return $d4fbdbf202f03b28$export$e530037191fcd5d7 = v; });
$parcel$export(module.exports, "createContext", function () { return $d4fbdbf202f03b28$export$fd42f52fd3ae1109; }, function (v) { return $d4fbdbf202f03b28$export$fd42f52fd3ae1109 = v; });
$parcel$export(module.exports, "createElement", function () { return $d4fbdbf202f03b28$export$c8a8987d4410bf2d; }, function (v) { return $d4fbdbf202f03b28$export$c8a8987d4410bf2d = v; });
$parcel$export(module.exports, "createFactory", function () { return $d4fbdbf202f03b28$export$d38cd72104c1f0e9; }, function (v) { return $d4fbdbf202f03b28$export$d38cd72104c1f0e9 = v; });
$parcel$export(module.exports, "createRef", function () { return $d4fbdbf202f03b28$export$7d1e3a5e95ceca43; }, function (v) { return $d4fbdbf202f03b28$export$7d1e3a5e95ceca43 = v; });
$parcel$export(module.exports, "forwardRef", function () { return $d4fbdbf202f03b28$export$257a8862b851cb5b; }, function (v) { return $d4fbdbf202f03b28$export$257a8862b851cb5b = v; });
$parcel$export(module.exports, "isValidElement", function () { return $d4fbdbf202f03b28$export$a8257692ac88316c; }, function (v) { return $d4fbdbf202f03b28$export$a8257692ac88316c = v; });
$parcel$export(module.exports, "lazy", function () { return $d4fbdbf202f03b28$export$488013bae63b21da; }, function (v) { return $d4fbdbf202f03b28$export$488013bae63b21da = v; });
$parcel$export(module.exports, "memo", function () { return $d4fbdbf202f03b28$export$7c73462e0d25e514; }, function (v) { return $d4fbdbf202f03b28$export$7c73462e0d25e514 = v; });
$parcel$export(module.exports, "startTransition", function () { return $d4fbdbf202f03b28$export$7568632d0d33d16d; }, function (v) { return $d4fbdbf202f03b28$export$7568632d0d33d16d = v; });
$parcel$export(module.exports, "unstable_act", function () { return $d4fbdbf202f03b28$export$88948ce120ea2619; }, function (v) { return $d4fbdbf202f03b28$export$88948ce120ea2619 = v; });
$parcel$export(module.exports, "useCallback", function () { return $d4fbdbf202f03b28$export$35808ee640e87ca7; }, function (v) { return $d4fbdbf202f03b28$export$35808ee640e87ca7 = v; });
$parcel$export(module.exports, "useContext", function () { return $d4fbdbf202f03b28$export$fae74005e78b1a27; }, function (v) { return $d4fbdbf202f03b28$export$fae74005e78b1a27 = v; });
$parcel$export(module.exports, "useDebugValue", function () { return $d4fbdbf202f03b28$export$dc8fbce3eb94dc1e; }, function (v) { return $d4fbdbf202f03b28$export$dc8fbce3eb94dc1e = v; });
$parcel$export(module.exports, "useDeferredValue", function () { return $d4fbdbf202f03b28$export$6a7bc4e911dc01cf; }, function (v) { return $d4fbdbf202f03b28$export$6a7bc4e911dc01cf = v; });
$parcel$export(module.exports, "useEffect", function () { return $d4fbdbf202f03b28$export$6d9c69b0de29b591; }, function (v) { return $d4fbdbf202f03b28$export$6d9c69b0de29b591 = v; });
$parcel$export(module.exports, "useId", function () { return $d4fbdbf202f03b28$export$f680877a34711e37; }, function (v) { return $d4fbdbf202f03b28$export$f680877a34711e37 = v; });
$parcel$export(module.exports, "useImperativeHandle", function () { return $d4fbdbf202f03b28$export$d5a552a76deda3c2; }, function (v) { return $d4fbdbf202f03b28$export$d5a552a76deda3c2 = v; });
$parcel$export(module.exports, "useInsertionEffect", function () { return $d4fbdbf202f03b28$export$aaabe4eda9ed9969; }, function (v) { return $d4fbdbf202f03b28$export$aaabe4eda9ed9969 = v; });
$parcel$export(module.exports, "useLayoutEffect", function () { return $d4fbdbf202f03b28$export$e5c5a5f917a5871c; }, function (v) { return $d4fbdbf202f03b28$export$e5c5a5f917a5871c = v; });
$parcel$export(module.exports, "useMemo", function () { return $d4fbdbf202f03b28$export$1538c33de8887b59; }, function (v) { return $d4fbdbf202f03b28$export$1538c33de8887b59 = v; });
$parcel$export(module.exports, "useReducer", function () { return $d4fbdbf202f03b28$export$13e3392192263954; }, function (v) { return $d4fbdbf202f03b28$export$13e3392192263954 = v; });
$parcel$export(module.exports, "useRef", function () { return $d4fbdbf202f03b28$export$b8f5890fc79d6aca; }, function (v) { return $d4fbdbf202f03b28$export$b8f5890fc79d6aca = v; });
$parcel$export(module.exports, "useState", function () { return $d4fbdbf202f03b28$export$60241385465d0a34; }, function (v) { return $d4fbdbf202f03b28$export$60241385465d0a34 = v; });
$parcel$export(module.exports, "useSyncExternalStore", function () { return $d4fbdbf202f03b28$export$306c0aa65ff9ec16; }, function (v) { return $d4fbdbf202f03b28$export$306c0aa65ff9ec16 = v; });
$parcel$export(module.exports, "useTransition", function () { return $d4fbdbf202f03b28$export$7b286972b8d8ccbf; }, function (v) { return $d4fbdbf202f03b28$export$7b286972b8d8ccbf = v; });
$parcel$export(module.exports, "version", function () { return $d4fbdbf202f03b28$export$83d89fbfd8236492; }, function (v) { return $d4fbdbf202f03b28$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $d4fbdbf202f03b28$export$dca3b0875bd9a954;
var $d4fbdbf202f03b28$export$16fa2f45be04daa8;
var $d4fbdbf202f03b28$export$ffb0004e005737fa;
var $d4fbdbf202f03b28$export$e2c29f18771995cb;
var $d4fbdbf202f03b28$export$221d75b3f55bb0bd;
var $d4fbdbf202f03b28$export$5f8d39834fd61797;
var $d4fbdbf202f03b28$export$74bf444e3cd11ea5;
var $d4fbdbf202f03b28$export$ae55be85d98224ed;
var $d4fbdbf202f03b28$export$3ba232387fd5d6dd;
var $d4fbdbf202f03b28$export$e530037191fcd5d7;
var $d4fbdbf202f03b28$export$fd42f52fd3ae1109;
var $d4fbdbf202f03b28$export$c8a8987d4410bf2d;
var $d4fbdbf202f03b28$export$d38cd72104c1f0e9;
var $d4fbdbf202f03b28$export$7d1e3a5e95ceca43;
var $d4fbdbf202f03b28$export$257a8862b851cb5b;
var $d4fbdbf202f03b28$export$a8257692ac88316c;
var $d4fbdbf202f03b28$export$488013bae63b21da;
var $d4fbdbf202f03b28$export$7c73462e0d25e514;
var $d4fbdbf202f03b28$export$7568632d0d33d16d;
var $d4fbdbf202f03b28$export$88948ce120ea2619;
var $d4fbdbf202f03b28$export$35808ee640e87ca7;
var $d4fbdbf202f03b28$export$fae74005e78b1a27;
var $d4fbdbf202f03b28$export$dc8fbce3eb94dc1e;
var $d4fbdbf202f03b28$export$6a7bc4e911dc01cf;
var $d4fbdbf202f03b28$export$6d9c69b0de29b591;
var $d4fbdbf202f03b28$export$f680877a34711e37;
var $d4fbdbf202f03b28$export$d5a552a76deda3c2;
var $d4fbdbf202f03b28$export$aaabe4eda9ed9969;
var $d4fbdbf202f03b28$export$e5c5a5f917a5871c;
var $d4fbdbf202f03b28$export$1538c33de8887b59;
var $d4fbdbf202f03b28$export$13e3392192263954;
var $d4fbdbf202f03b28$export$b8f5890fc79d6aca;
var $d4fbdbf202f03b28$export$60241385465d0a34;
var $d4fbdbf202f03b28$export$306c0aa65ff9ec16;
var $d4fbdbf202f03b28$export$7b286972b8d8ccbf;
var $d4fbdbf202f03b28$export$83d89fbfd8236492;
'use strict';
var $d4fbdbf202f03b28$var$l = Symbol.for("react.element"), $d4fbdbf202f03b28$var$n = Symbol.for("react.portal"), $d4fbdbf202f03b28$var$p = Symbol.for("react.fragment"), $d4fbdbf202f03b28$var$q = Symbol.for("react.strict_mode"), $d4fbdbf202f03b28$var$r = Symbol.for("react.profiler"), $d4fbdbf202f03b28$var$t = Symbol.for("react.provider"), $d4fbdbf202f03b28$var$u = Symbol.for("react.context"), $d4fbdbf202f03b28$var$v = Symbol.for("react.forward_ref"), $d4fbdbf202f03b28$var$w = Symbol.for("react.suspense"), $d4fbdbf202f03b28$var$x = Symbol.for("react.memo"), $d4fbdbf202f03b28$var$y = Symbol.for("react.lazy"), $d4fbdbf202f03b28$var$z = Symbol.iterator;
function $d4fbdbf202f03b28$var$A(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $d4fbdbf202f03b28$var$z && a[$d4fbdbf202f03b28$var$z] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $d4fbdbf202f03b28$var$B = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $d4fbdbf202f03b28$var$C = Object.assign, $d4fbdbf202f03b28$var$D = {};
function $d4fbdbf202f03b28$var$E(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $d4fbdbf202f03b28$var$D;
    this.updater = e || $d4fbdbf202f03b28$var$B;
}
$d4fbdbf202f03b28$var$E.prototype.isReactComponent = {};
$d4fbdbf202f03b28$var$E.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, a, b, "setState");
};
$d4fbdbf202f03b28$var$E.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $d4fbdbf202f03b28$var$F() {}
$d4fbdbf202f03b28$var$F.prototype = $d4fbdbf202f03b28$var$E.prototype;
function $d4fbdbf202f03b28$var$G(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $d4fbdbf202f03b28$var$D;
    this.updater = e || $d4fbdbf202f03b28$var$B;
}
var $d4fbdbf202f03b28$var$H = $d4fbdbf202f03b28$var$G.prototype = new $d4fbdbf202f03b28$var$F;
$d4fbdbf202f03b28$var$H.constructor = $d4fbdbf202f03b28$var$G;
$d4fbdbf202f03b28$var$C($d4fbdbf202f03b28$var$H, $d4fbdbf202f03b28$var$E.prototype);
$d4fbdbf202f03b28$var$H.isPureReactComponent = !0;
var $d4fbdbf202f03b28$var$I = Array.isArray, $d4fbdbf202f03b28$var$J = Object.prototype.hasOwnProperty, $d4fbdbf202f03b28$var$K = {
    current: null
}, $d4fbdbf202f03b28$var$L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $d4fbdbf202f03b28$var$M(a, b, e) {
    var d, c = {}, k = null, h = null;
    if (null != b) for(d in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)$d4fbdbf202f03b28$var$J.call(b, d) && !$d4fbdbf202f03b28$var$L.hasOwnProperty(d) && (c[d] = b[d]);
    var g = arguments.length - 2;
    if (1 === g) c.children = e;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        c.children = f;
    }
    if (a && a.defaultProps) for(d in g = a.defaultProps, g)void 0 === c[d] && (c[d] = g[d]);
    return {
        $$typeof: $d4fbdbf202f03b28$var$l,
        type: a,
        key: k,
        ref: h,
        props: c,
        _owner: $d4fbdbf202f03b28$var$K.current
    };
}
function $d4fbdbf202f03b28$var$N(a, b) {
    return {
        $$typeof: $d4fbdbf202f03b28$var$l,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $d4fbdbf202f03b28$var$O(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $d4fbdbf202f03b28$var$l;
}
function $d4fbdbf202f03b28$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $d4fbdbf202f03b28$var$P = /\/+/g;
function $d4fbdbf202f03b28$var$Q(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $d4fbdbf202f03b28$var$escape("" + a.key) : b.toString(36);
}
function $d4fbdbf202f03b28$var$R(a, b, e, d, c) {
    var k = typeof a;
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $d4fbdbf202f03b28$var$l:
                case $d4fbdbf202f03b28$var$n:
                    h = !0;
            }
    }
    if (h) return h = a, c = c(h), a = "" === d ? "." + $d4fbdbf202f03b28$var$Q(h, 0) : d, $d4fbdbf202f03b28$var$I(c) ? (e = "", null != a && (e = a.replace($d4fbdbf202f03b28$var$P, "$&/") + "/"), $d4fbdbf202f03b28$var$R(c, b, e, "", function(a) {
        return a;
    })) : null != c && ($d4fbdbf202f03b28$var$O(c) && (c = $d4fbdbf202f03b28$var$N(c, e + (!c.key || h && h.key === c.key ? "" : ("" + c.key).replace($d4fbdbf202f03b28$var$P, "$&/") + "/") + a)), b.push(c)), 1;
    h = 0;
    d = "" === d ? "." : d + ":";
    if ($d4fbdbf202f03b28$var$I(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = d + $d4fbdbf202f03b28$var$Q(k, g);
        h += $d4fbdbf202f03b28$var$R(k, b, e, f, c);
    }
    else if (f = $d4fbdbf202f03b28$var$A(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = d + $d4fbdbf202f03b28$var$Q(k, g++), h += $d4fbdbf202f03b28$var$R(k, b, e, f, c);
    else if ("object" === k) throw b = String(a), Error("Objects are not valid as a React child (found: " + ("[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b) + "). If you meant to render a collection of children, use an array instead.");
    return h;
}
function $d4fbdbf202f03b28$var$S(a, b, e) {
    if (null == a) return a;
    var d = [], c = 0;
    $d4fbdbf202f03b28$var$R(a, d, "", "", function(a) {
        return b.call(e, a, c++);
    });
    return d;
}
function $d4fbdbf202f03b28$var$T(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        b.then(function(b) {
            if (0 === a._status || -1 === a._status) a._status = 1, a._result = b;
        }, function(b) {
            if (0 === a._status || -1 === a._status) a._status = 2, a._result = b;
        });
        -1 === a._status && (a._status = 0, a._result = b);
    }
    if (1 === a._status) return a._result.default;
    throw a._result;
}
var $d4fbdbf202f03b28$var$U = {
    current: null
}, $d4fbdbf202f03b28$var$V = {
    transition: null
}, $d4fbdbf202f03b28$var$W = {
    ReactCurrentDispatcher: $d4fbdbf202f03b28$var$U,
    ReactCurrentBatchConfig: $d4fbdbf202f03b28$var$V,
    ReactCurrentOwner: $d4fbdbf202f03b28$var$K
};
function $d4fbdbf202f03b28$var$X() {
    throw Error("act(...) is not supported in production builds of React.");
}
$d4fbdbf202f03b28$export$dca3b0875bd9a954 = {
    map: $d4fbdbf202f03b28$var$S,
    forEach: function(a, b, e) {
        $d4fbdbf202f03b28$var$S(a, function() {
            b.apply(this, arguments);
        }, e);
    },
    count: function(a) {
        var b = 0;
        $d4fbdbf202f03b28$var$S(a, function() {
            b++;
        });
        return b;
    },
    toArray: function(a) {
        return $d4fbdbf202f03b28$var$S(a, function(a) {
            return a;
        }) || [];
    },
    only: function(a) {
        if (!$d4fbdbf202f03b28$var$O(a)) throw Error("React.Children.only expected to receive a single React element child.");
        return a;
    }
};
$d4fbdbf202f03b28$export$16fa2f45be04daa8 = $d4fbdbf202f03b28$var$E;
$d4fbdbf202f03b28$export$ffb0004e005737fa = $d4fbdbf202f03b28$var$p;
$d4fbdbf202f03b28$export$e2c29f18771995cb = $d4fbdbf202f03b28$var$r;
$d4fbdbf202f03b28$export$221d75b3f55bb0bd = $d4fbdbf202f03b28$var$G;
$d4fbdbf202f03b28$export$5f8d39834fd61797 = $d4fbdbf202f03b28$var$q;
$d4fbdbf202f03b28$export$74bf444e3cd11ea5 = $d4fbdbf202f03b28$var$w;
$d4fbdbf202f03b28$export$ae55be85d98224ed = $d4fbdbf202f03b28$var$W;
$d4fbdbf202f03b28$export$3ba232387fd5d6dd = $d4fbdbf202f03b28$var$X;
$d4fbdbf202f03b28$export$e530037191fcd5d7 = function(a, b, e) {
    if (null === a || void 0 === a) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + a + ".");
    var d = $d4fbdbf202f03b28$var$C({}, a.props), c = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = $d4fbdbf202f03b28$var$K.current);
        void 0 !== b.key && (c = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)$d4fbdbf202f03b28$var$J.call(b, f) && !$d4fbdbf202f03b28$var$L.hasOwnProperty(f) && (d[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) d.children = e;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        d.children = g;
    }
    return {
        $$typeof: $d4fbdbf202f03b28$var$l,
        type: a.type,
        key: c,
        ref: k,
        props: d,
        _owner: h
    };
};
$d4fbdbf202f03b28$export$fd42f52fd3ae1109 = function(a) {
    a = {
        $$typeof: $d4fbdbf202f03b28$var$u,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null,
        _defaultValue: null,
        _globalName: null
    };
    a.Provider = {
        $$typeof: $d4fbdbf202f03b28$var$t,
        _context: a
    };
    return a.Consumer = a;
};
$d4fbdbf202f03b28$export$c8a8987d4410bf2d = $d4fbdbf202f03b28$var$M;
$d4fbdbf202f03b28$export$d38cd72104c1f0e9 = function(a) {
    var b = $d4fbdbf202f03b28$var$M.bind(null, a);
    b.type = a;
    return b;
};
$d4fbdbf202f03b28$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$d4fbdbf202f03b28$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $d4fbdbf202f03b28$var$v,
        render: a
    };
};
$d4fbdbf202f03b28$export$a8257692ac88316c = $d4fbdbf202f03b28$var$O;
$d4fbdbf202f03b28$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $d4fbdbf202f03b28$var$y,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: $d4fbdbf202f03b28$var$T
    };
};
$d4fbdbf202f03b28$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $d4fbdbf202f03b28$var$x,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$d4fbdbf202f03b28$export$7568632d0d33d16d = function(a) {
    var b = $d4fbdbf202f03b28$var$V.transition;
    $d4fbdbf202f03b28$var$V.transition = {};
    try {
        a();
    } finally{
        $d4fbdbf202f03b28$var$V.transition = b;
    }
};
$d4fbdbf202f03b28$export$88948ce120ea2619 = $d4fbdbf202f03b28$var$X;
$d4fbdbf202f03b28$export$35808ee640e87ca7 = function(a, b) {
    return $d4fbdbf202f03b28$var$U.current.useCallback(a, b);
};
$d4fbdbf202f03b28$export$fae74005e78b1a27 = function(a) {
    return $d4fbdbf202f03b28$var$U.current.useContext(a);
};
$d4fbdbf202f03b28$export$dc8fbce3eb94dc1e = function() {};
$d4fbdbf202f03b28$export$6a7bc4e911dc01cf = function(a) {
    return $d4fbdbf202f03b28$var$U.current.useDeferredValue(a);
};
$d4fbdbf202f03b28$export$6d9c69b0de29b591 = function(a, b) {
    return $d4fbdbf202f03b28$var$U.current.useEffect(a, b);
};
$d4fbdbf202f03b28$export$f680877a34711e37 = function() {
    return $d4fbdbf202f03b28$var$U.current.useId();
};
$d4fbdbf202f03b28$export$d5a552a76deda3c2 = function(a, b, e) {
    return $d4fbdbf202f03b28$var$U.current.useImperativeHandle(a, b, e);
};
$d4fbdbf202f03b28$export$aaabe4eda9ed9969 = function(a, b) {
    return $d4fbdbf202f03b28$var$U.current.useInsertionEffect(a, b);
};
$d4fbdbf202f03b28$export$e5c5a5f917a5871c = function(a, b) {
    return $d4fbdbf202f03b28$var$U.current.useLayoutEffect(a, b);
};
$d4fbdbf202f03b28$export$1538c33de8887b59 = function(a, b) {
    return $d4fbdbf202f03b28$var$U.current.useMemo(a, b);
};
$d4fbdbf202f03b28$export$13e3392192263954 = function(a, b, e) {
    return $d4fbdbf202f03b28$var$U.current.useReducer(a, b, e);
};
$d4fbdbf202f03b28$export$b8f5890fc79d6aca = function(a) {
    return $d4fbdbf202f03b28$var$U.current.useRef(a);
};
$d4fbdbf202f03b28$export$60241385465d0a34 = function(a) {
    return $d4fbdbf202f03b28$var$U.current.useState(a);
};
$d4fbdbf202f03b28$export$306c0aa65ff9ec16 = function(a, b, e) {
    return $d4fbdbf202f03b28$var$U.current.useSyncExternalStore(a, b, e);
};
$d4fbdbf202f03b28$export$7b286972b8d8ccbf = function() {
    return $d4fbdbf202f03b28$var$U.current.useTransition();
};
$d4fbdbf202f03b28$export$83d89fbfd8236492 = "18.3.1";

});



parcelRegister("56Lv3", function(module, exports) {

$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $3b825bc58ae06391$export$ae55be85d98224ed; }, function (v) { return $3b825bc58ae06391$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "createPortal", function () { return $3b825bc58ae06391$export$d39a5bbd09211389; }, function (v) { return $3b825bc58ae06391$export$d39a5bbd09211389 = v; });
$parcel$export(module.exports, "createRoot", function () { return $3b825bc58ae06391$export$882461b6382ed46c; }, function (v) { return $3b825bc58ae06391$export$882461b6382ed46c = v; });
$parcel$export(module.exports, "findDOMNode", function () { return $3b825bc58ae06391$export$466bfc07425424d5; }, function (v) { return $3b825bc58ae06391$export$466bfc07425424d5 = v; });
$parcel$export(module.exports, "flushSync", function () { return $3b825bc58ae06391$export$cd75ccfd720a3cd4; }, function (v) { return $3b825bc58ae06391$export$cd75ccfd720a3cd4 = v; });
$parcel$export(module.exports, "hydrate", function () { return $3b825bc58ae06391$export$fa8d919ba61d84db; }, function (v) { return $3b825bc58ae06391$export$fa8d919ba61d84db = v; });
$parcel$export(module.exports, "hydrateRoot", function () { return $3b825bc58ae06391$export$757ceba2d55c277e; }, function (v) { return $3b825bc58ae06391$export$757ceba2d55c277e = v; });
$parcel$export(module.exports, "render", function () { return $3b825bc58ae06391$export$b3890eb0ae9dca99; }, function (v) { return $3b825bc58ae06391$export$b3890eb0ae9dca99 = v; });
$parcel$export(module.exports, "unmountComponentAtNode", function () { return $3b825bc58ae06391$export$502457920280e6be; }, function (v) { return $3b825bc58ae06391$export$502457920280e6be = v; });
$parcel$export(module.exports, "unstable_batchedUpdates", function () { return $3b825bc58ae06391$export$c78a37762a8d58e1; }, function (v) { return $3b825bc58ae06391$export$c78a37762a8d58e1 = v; });
$parcel$export(module.exports, "unstable_renderSubtreeIntoContainer", function () { return $3b825bc58ae06391$export$dc54d992c10e8a18; }, function (v) { return $3b825bc58ae06391$export$dc54d992c10e8a18 = v; });
$parcel$export(module.exports, "version", function () { return $3b825bc58ae06391$export$83d89fbfd8236492; }, function (v) { return $3b825bc58ae06391$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $3b825bc58ae06391$export$ae55be85d98224ed;
var $3b825bc58ae06391$export$d39a5bbd09211389;
var $3b825bc58ae06391$export$882461b6382ed46c;
var $3b825bc58ae06391$export$466bfc07425424d5;
var $3b825bc58ae06391$export$cd75ccfd720a3cd4;
var $3b825bc58ae06391$export$fa8d919ba61d84db;
var $3b825bc58ae06391$export$757ceba2d55c277e;
var $3b825bc58ae06391$export$b3890eb0ae9dca99;
var $3b825bc58ae06391$export$502457920280e6be;
var $3b825bc58ae06391$export$c78a37762a8d58e1;
var $3b825bc58ae06391$export$dc54d992c10e8a18;
var $3b825bc58ae06391$export$83d89fbfd8236492;
'use strict';

var $gJYWc = parcelRequire("gJYWc");

var $3tRGX = parcelRequire("3tRGX");
function $3b825bc58ae06391$var$p(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $3b825bc58ae06391$var$da = new Set, $3b825bc58ae06391$var$ea = {};
function $3b825bc58ae06391$var$fa(a, b) {
    $3b825bc58ae06391$var$ha(a, b);
    $3b825bc58ae06391$var$ha(a + "Capture", b);
}
function $3b825bc58ae06391$var$ha(a, b) {
    $3b825bc58ae06391$var$ea[a] = b;
    for(a = 0; a < b.length; a++)$3b825bc58ae06391$var$da.add(b[a]);
}
var $3b825bc58ae06391$var$ia = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $3b825bc58ae06391$var$ja = Object.prototype.hasOwnProperty, $3b825bc58ae06391$var$ka = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $3b825bc58ae06391$var$la = {}, $3b825bc58ae06391$var$ma = {};
function $3b825bc58ae06391$var$oa(a) {
    if ($3b825bc58ae06391$var$ja.call($3b825bc58ae06391$var$ma, a)) return !0;
    if ($3b825bc58ae06391$var$ja.call($3b825bc58ae06391$var$la, a)) return !1;
    if ($3b825bc58ae06391$var$ka.test(a)) return $3b825bc58ae06391$var$ma[a] = !0;
    $3b825bc58ae06391$var$la[a] = !0;
    return !1;
}
function $3b825bc58ae06391$var$pa(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function $3b825bc58ae06391$var$qa(a, b, c, d) {
    if (null === b || "undefined" === typeof b || $3b825bc58ae06391$var$pa(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function $3b825bc58ae06391$var$v(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var $3b825bc58ae06391$var$z = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    $3b825bc58ae06391$var$z[a] = new $3b825bc58ae06391$var$v(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    $3b825bc58ae06391$var$z[b] = new $3b825bc58ae06391$var$v(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    $3b825bc58ae06391$var$z[a] = new $3b825bc58ae06391$var$v(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    $3b825bc58ae06391$var$z[a] = new $3b825bc58ae06391$var$v(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    $3b825bc58ae06391$var$z[a] = new $3b825bc58ae06391$var$v(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    $3b825bc58ae06391$var$z[a] = new $3b825bc58ae06391$var$v(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    $3b825bc58ae06391$var$z[a] = new $3b825bc58ae06391$var$v(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    $3b825bc58ae06391$var$z[a] = new $3b825bc58ae06391$var$v(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    $3b825bc58ae06391$var$z[a] = new $3b825bc58ae06391$var$v(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var $3b825bc58ae06391$var$ra = /[\-:]([a-z])/g;
function $3b825bc58ae06391$var$sa(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace($3b825bc58ae06391$var$ra, $3b825bc58ae06391$var$sa);
    $3b825bc58ae06391$var$z[b] = new $3b825bc58ae06391$var$v(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace($3b825bc58ae06391$var$ra, $3b825bc58ae06391$var$sa);
    $3b825bc58ae06391$var$z[b] = new $3b825bc58ae06391$var$v(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace($3b825bc58ae06391$var$ra, $3b825bc58ae06391$var$sa);
    $3b825bc58ae06391$var$z[b] = new $3b825bc58ae06391$var$v(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    $3b825bc58ae06391$var$z[a] = new $3b825bc58ae06391$var$v(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
$3b825bc58ae06391$var$z.xlinkHref = new $3b825bc58ae06391$var$v("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    $3b825bc58ae06391$var$z[a] = new $3b825bc58ae06391$var$v(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function $3b825bc58ae06391$var$ta(a, b, c, d) {
    var e = $3b825bc58ae06391$var$z.hasOwnProperty(b) ? $3b825bc58ae06391$var$z[b] : null;
    if (null !== e ? 0 !== e.type : d || !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1]) $3b825bc58ae06391$var$qa(b, c, e, d) && (c = null), d || null === e ? $3b825bc58ae06391$var$oa(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c)));
}
var $3b825bc58ae06391$var$ua = $gJYWc.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, $3b825bc58ae06391$var$va = Symbol.for("react.element"), $3b825bc58ae06391$var$wa = Symbol.for("react.portal"), $3b825bc58ae06391$var$ya = Symbol.for("react.fragment"), $3b825bc58ae06391$var$za = Symbol.for("react.strict_mode"), $3b825bc58ae06391$var$Aa = Symbol.for("react.profiler"), $3b825bc58ae06391$var$Ba = Symbol.for("react.provider"), $3b825bc58ae06391$var$Ca = Symbol.for("react.context"), $3b825bc58ae06391$var$Da = Symbol.for("react.forward_ref"), $3b825bc58ae06391$var$Ea = Symbol.for("react.suspense"), $3b825bc58ae06391$var$Fa = Symbol.for("react.suspense_list"), $3b825bc58ae06391$var$Ga = Symbol.for("react.memo"), $3b825bc58ae06391$var$Ha = Symbol.for("react.lazy");
Symbol.for("react.scope");
Symbol.for("react.debug_trace_mode");
var $3b825bc58ae06391$var$Ia = Symbol.for("react.offscreen");
Symbol.for("react.legacy_hidden");
Symbol.for("react.cache");
Symbol.for("react.tracing_marker");
var $3b825bc58ae06391$var$Ja = Symbol.iterator;
function $3b825bc58ae06391$var$Ka(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $3b825bc58ae06391$var$Ja && a[$3b825bc58ae06391$var$Ja] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $3b825bc58ae06391$var$A = Object.assign, $3b825bc58ae06391$var$La;
function $3b825bc58ae06391$var$Ma(a) {
    if (void 0 === $3b825bc58ae06391$var$La) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        $3b825bc58ae06391$var$La = b && b[1] || "";
    }
    return "\n" + $3b825bc58ae06391$var$La + a;
}
var $3b825bc58ae06391$var$Na = !1;
function $3b825bc58ae06391$var$Oa(a, b) {
    if (!a || $3b825bc58ae06391$var$Na) return "";
    $3b825bc58ae06391$var$Na = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (l) {
                    var d = l;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (l) {
                    d = l;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (l) {
                d = l;
            }
            a();
        }
    } catch (l) {
        if (l && d && "string" === typeof l.stack) {
            for(var e = l.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) {
                        var k = "\n" + e[g].replace(" at new ", " at ");
                        a.displayName && k.includes("<anonymous>") && (k = k.replace("<anonymous>", a.displayName));
                        return k;
                    }
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        $3b825bc58ae06391$var$Na = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? $3b825bc58ae06391$var$Ma(a) : "";
}
function $3b825bc58ae06391$var$Pa(a) {
    switch(a.tag){
        case 5:
            return $3b825bc58ae06391$var$Ma(a.type);
        case 16:
            return $3b825bc58ae06391$var$Ma("Lazy");
        case 13:
            return $3b825bc58ae06391$var$Ma("Suspense");
        case 19:
            return $3b825bc58ae06391$var$Ma("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = $3b825bc58ae06391$var$Oa(a.type, !1), a;
        case 11:
            return a = $3b825bc58ae06391$var$Oa(a.type.render, !1), a;
        case 1:
            return a = $3b825bc58ae06391$var$Oa(a.type, !0), a;
        default:
            return "";
    }
}
function $3b825bc58ae06391$var$Qa(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case $3b825bc58ae06391$var$ya:
            return "Fragment";
        case $3b825bc58ae06391$var$wa:
            return "Portal";
        case $3b825bc58ae06391$var$Aa:
            return "Profiler";
        case $3b825bc58ae06391$var$za:
            return "StrictMode";
        case $3b825bc58ae06391$var$Ea:
            return "Suspense";
        case $3b825bc58ae06391$var$Fa:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case $3b825bc58ae06391$var$Ca:
            return (a.displayName || "Context") + ".Consumer";
        case $3b825bc58ae06391$var$Ba:
            return (a._context.displayName || "Context") + ".Provider";
        case $3b825bc58ae06391$var$Da:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case $3b825bc58ae06391$var$Ga:
            return b = a.displayName || null, null !== b ? b : $3b825bc58ae06391$var$Qa(a.type) || "Memo";
        case $3b825bc58ae06391$var$Ha:
            b = a._payload;
            a = a._init;
            try {
                return $3b825bc58ae06391$var$Qa(a(b));
            } catch (c) {}
    }
    return null;
}
function $3b825bc58ae06391$var$Ra(a) {
    var b = a.type;
    switch(a.tag){
        case 24:
            return "Cache";
        case 9:
            return (b.displayName || "Context") + ".Consumer";
        case 10:
            return (b._context.displayName || "Context") + ".Provider";
        case 18:
            return "DehydratedFragment";
        case 11:
            return a = b.render, a = a.displayName || a.name || "", b.displayName || ("" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
        case 7:
            return "Fragment";
        case 5:
            return b;
        case 4:
            return "Portal";
        case 3:
            return "Root";
        case 6:
            return "Text";
        case 16:
            return $3b825bc58ae06391$var$Qa(b);
        case 8:
            return b === $3b825bc58ae06391$var$za ? "StrictMode" : "Mode";
        case 22:
            return "Offscreen";
        case 12:
            return "Profiler";
        case 21:
            return "Scope";
        case 13:
            return "Suspense";
        case 19:
            return "SuspenseList";
        case 25:
            return "TracingMarker";
        case 1:
        case 0:
        case 17:
        case 2:
        case 14:
        case 15:
            if ("function" === typeof b) return b.displayName || b.name || null;
            if ("string" === typeof b) return b;
    }
    return null;
}
function $3b825bc58ae06391$var$Sa(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return a;
        case "object":
            return a;
        default:
            return "";
    }
}
function $3b825bc58ae06391$var$Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function $3b825bc58ae06391$var$Ua(a) {
    var b = $3b825bc58ae06391$var$Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function $3b825bc58ae06391$var$Va(a) {
    a._valueTracker || (a._valueTracker = $3b825bc58ae06391$var$Ua(a));
}
function $3b825bc58ae06391$var$Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = $3b825bc58ae06391$var$Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function $3b825bc58ae06391$var$Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function $3b825bc58ae06391$var$Ya(a, b) {
    var c = b.checked;
    return $3b825bc58ae06391$var$A({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function $3b825bc58ae06391$var$Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = $3b825bc58ae06391$var$Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function $3b825bc58ae06391$var$ab(a, b) {
    b = b.checked;
    null != b && $3b825bc58ae06391$var$ta(a, "checked", b, !1);
}
function $3b825bc58ae06391$var$bb(a, b) {
    $3b825bc58ae06391$var$ab(a, b);
    var c = $3b825bc58ae06391$var$Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? $3b825bc58ae06391$var$cb(a, b.type, c) : b.hasOwnProperty("defaultValue") && $3b825bc58ae06391$var$cb(a, b.type, $3b825bc58ae06391$var$Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function $3b825bc58ae06391$var$db(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function $3b825bc58ae06391$var$cb(a, b, c) {
    if ("number" !== b || $3b825bc58ae06391$var$Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
var $3b825bc58ae06391$var$eb = Array.isArray;
function $3b825bc58ae06391$var$fb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + $3b825bc58ae06391$var$Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function $3b825bc58ae06391$var$gb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error($3b825bc58ae06391$var$p(91));
    return $3b825bc58ae06391$var$A({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function $3b825bc58ae06391$var$hb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error($3b825bc58ae06391$var$p(92));
            if ($3b825bc58ae06391$var$eb(c)) {
                if (1 < c.length) throw Error($3b825bc58ae06391$var$p(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: $3b825bc58ae06391$var$Sa(c)
    };
}
function $3b825bc58ae06391$var$ib(a, b) {
    var c = $3b825bc58ae06391$var$Sa(b.value), d = $3b825bc58ae06391$var$Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function $3b825bc58ae06391$var$jb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
function $3b825bc58ae06391$var$kb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function $3b825bc58ae06391$var$lb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? $3b825bc58ae06391$var$kb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var $3b825bc58ae06391$var$mb, $3b825bc58ae06391$var$nb = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if ("http://www.w3.org/2000/svg" !== a.namespaceURI || "innerHTML" in a) a.innerHTML = b;
    else {
        $3b825bc58ae06391$var$mb = $3b825bc58ae06391$var$mb || document.createElement("div");
        $3b825bc58ae06391$var$mb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = $3b825bc58ae06391$var$mb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function $3b825bc58ae06391$var$ob(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var $3b825bc58ae06391$var$pb = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, $3b825bc58ae06391$var$qb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys($3b825bc58ae06391$var$pb).forEach(function(a) {
    $3b825bc58ae06391$var$qb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        $3b825bc58ae06391$var$pb[b] = $3b825bc58ae06391$var$pb[a];
    });
});
function $3b825bc58ae06391$var$rb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || $3b825bc58ae06391$var$pb.hasOwnProperty(a) && $3b825bc58ae06391$var$pb[a] ? ("" + b).trim() : b + "px";
}
function $3b825bc58ae06391$var$sb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = $3b825bc58ae06391$var$rb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var $3b825bc58ae06391$var$tb = $3b825bc58ae06391$var$A({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function $3b825bc58ae06391$var$ub(a, b) {
    if (b) {
        if ($3b825bc58ae06391$var$tb[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error($3b825bc58ae06391$var$p(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error($3b825bc58ae06391$var$p(60));
            if ("object" !== typeof b.dangerouslySetInnerHTML || !("__html" in b.dangerouslySetInnerHTML)) throw Error($3b825bc58ae06391$var$p(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error($3b825bc58ae06391$var$p(62));
    }
}
function $3b825bc58ae06391$var$vb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $3b825bc58ae06391$var$wb = null;
function $3b825bc58ae06391$var$xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var $3b825bc58ae06391$var$yb = null, $3b825bc58ae06391$var$zb = null, $3b825bc58ae06391$var$Ab = null;
function $3b825bc58ae06391$var$Bb(a) {
    if (a = $3b825bc58ae06391$var$Cb(a)) {
        if ("function" !== typeof $3b825bc58ae06391$var$yb) throw Error($3b825bc58ae06391$var$p(280));
        var b = a.stateNode;
        b && (b = $3b825bc58ae06391$var$Db(b), $3b825bc58ae06391$var$yb(a.stateNode, a.type, b));
    }
}
function $3b825bc58ae06391$var$Eb(a) {
    $3b825bc58ae06391$var$zb ? $3b825bc58ae06391$var$Ab ? $3b825bc58ae06391$var$Ab.push(a) : $3b825bc58ae06391$var$Ab = [
        a
    ] : $3b825bc58ae06391$var$zb = a;
}
function $3b825bc58ae06391$var$Fb() {
    if ($3b825bc58ae06391$var$zb) {
        var a = $3b825bc58ae06391$var$zb, b = $3b825bc58ae06391$var$Ab;
        $3b825bc58ae06391$var$Ab = $3b825bc58ae06391$var$zb = null;
        $3b825bc58ae06391$var$Bb(a);
        if (b) for(a = 0; a < b.length; a++)$3b825bc58ae06391$var$Bb(b[a]);
    }
}
function $3b825bc58ae06391$var$Gb(a, b) {
    return a(b);
}
function $3b825bc58ae06391$var$Hb() {}
var $3b825bc58ae06391$var$Ib = !1;
function $3b825bc58ae06391$var$Jb(a, b, c) {
    if ($3b825bc58ae06391$var$Ib) return a(b, c);
    $3b825bc58ae06391$var$Ib = !0;
    try {
        return $3b825bc58ae06391$var$Gb(a, b, c);
    } finally{
        if ($3b825bc58ae06391$var$Ib = !1, null !== $3b825bc58ae06391$var$zb || null !== $3b825bc58ae06391$var$Ab) $3b825bc58ae06391$var$Hb(), $3b825bc58ae06391$var$Fb();
    }
}
function $3b825bc58ae06391$var$Kb(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = $3b825bc58ae06391$var$Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error($3b825bc58ae06391$var$p(231, b, typeof c));
    return c;
}
var $3b825bc58ae06391$var$Lb = !1;
if ($3b825bc58ae06391$var$ia) try {
    var $3b825bc58ae06391$var$Mb = {};
    Object.defineProperty($3b825bc58ae06391$var$Mb, "passive", {
        get: function() {
            $3b825bc58ae06391$var$Lb = !0;
        }
    });
    window.addEventListener("test", $3b825bc58ae06391$var$Mb, $3b825bc58ae06391$var$Mb);
    window.removeEventListener("test", $3b825bc58ae06391$var$Mb, $3b825bc58ae06391$var$Mb);
} catch (a) {
    $3b825bc58ae06391$var$Lb = !1;
}
function $3b825bc58ae06391$var$Nb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (m) {
        this.onError(m);
    }
}
var $3b825bc58ae06391$var$Ob = !1, $3b825bc58ae06391$var$Pb = null, $3b825bc58ae06391$var$Qb = !1, $3b825bc58ae06391$var$Rb = null, $3b825bc58ae06391$var$Sb = {
    onError: function(a) {
        $3b825bc58ae06391$var$Ob = !0;
        $3b825bc58ae06391$var$Pb = a;
    }
};
function $3b825bc58ae06391$var$Tb(a, b, c, d, e, f, g, h, k) {
    $3b825bc58ae06391$var$Ob = !1;
    $3b825bc58ae06391$var$Pb = null;
    $3b825bc58ae06391$var$Nb.apply($3b825bc58ae06391$var$Sb, arguments);
}
function $3b825bc58ae06391$var$Ub(a, b, c, d, e, f, g, h, k) {
    $3b825bc58ae06391$var$Tb.apply(this, arguments);
    if ($3b825bc58ae06391$var$Ob) {
        if ($3b825bc58ae06391$var$Ob) {
            var l = $3b825bc58ae06391$var$Pb;
            $3b825bc58ae06391$var$Ob = !1;
            $3b825bc58ae06391$var$Pb = null;
        } else throw Error($3b825bc58ae06391$var$p(198));
        $3b825bc58ae06391$var$Qb || ($3b825bc58ae06391$var$Qb = !0, $3b825bc58ae06391$var$Rb = l);
    }
}
function $3b825bc58ae06391$var$Vb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 4098) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function $3b825bc58ae06391$var$Wb(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function $3b825bc58ae06391$var$Xb(a) {
    if ($3b825bc58ae06391$var$Vb(a) !== a) throw Error($3b825bc58ae06391$var$p(188));
}
function $3b825bc58ae06391$var$Yb(a) {
    var b = a.alternate;
    if (!b) {
        b = $3b825bc58ae06391$var$Vb(a);
        if (null === b) throw Error($3b825bc58ae06391$var$p(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return $3b825bc58ae06391$var$Xb(e), a;
                if (f === d) return $3b825bc58ae06391$var$Xb(e), b;
                f = f.sibling;
            }
            throw Error($3b825bc58ae06391$var$p(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error($3b825bc58ae06391$var$p(189));
            }
        }
        if (c.alternate !== d) throw Error($3b825bc58ae06391$var$p(190));
    }
    if (3 !== c.tag) throw Error($3b825bc58ae06391$var$p(188));
    return c.stateNode.current === c ? a : b;
}
function $3b825bc58ae06391$var$Zb(a) {
    a = $3b825bc58ae06391$var$Yb(a);
    return null !== a ? $3b825bc58ae06391$var$$b(a) : null;
}
function $3b825bc58ae06391$var$$b(a) {
    if (5 === a.tag || 6 === a.tag) return a;
    for(a = a.child; null !== a;){
        var b = $3b825bc58ae06391$var$$b(a);
        if (null !== b) return b;
        a = a.sibling;
    }
    return null;
}
var $3b825bc58ae06391$var$ac = $3tRGX.unstable_scheduleCallback, $3b825bc58ae06391$var$bc = $3tRGX.unstable_cancelCallback, $3b825bc58ae06391$var$cc = $3tRGX.unstable_shouldYield, $3b825bc58ae06391$var$dc = $3tRGX.unstable_requestPaint, $3b825bc58ae06391$var$B = $3tRGX.unstable_now, $3b825bc58ae06391$var$ec = $3tRGX.unstable_getCurrentPriorityLevel, $3b825bc58ae06391$var$fc = $3tRGX.unstable_ImmediatePriority, $3b825bc58ae06391$var$gc = $3tRGX.unstable_UserBlockingPriority, $3b825bc58ae06391$var$hc = $3tRGX.unstable_NormalPriority, $3b825bc58ae06391$var$ic = $3tRGX.unstable_LowPriority, $3b825bc58ae06391$var$jc = $3tRGX.unstable_IdlePriority, $3b825bc58ae06391$var$kc = null, $3b825bc58ae06391$var$lc = null;
function $3b825bc58ae06391$var$mc(a) {
    if ($3b825bc58ae06391$var$lc && "function" === typeof $3b825bc58ae06391$var$lc.onCommitFiberRoot) try {
        $3b825bc58ae06391$var$lc.onCommitFiberRoot($3b825bc58ae06391$var$kc, a, void 0, 128 === (a.current.flags & 128));
    } catch (b) {}
}
var $3b825bc58ae06391$var$oc = Math.clz32 ? Math.clz32 : $3b825bc58ae06391$var$nc, $3b825bc58ae06391$var$pc = Math.log, $3b825bc58ae06391$var$qc = Math.LN2;
function $3b825bc58ae06391$var$nc(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - ($3b825bc58ae06391$var$pc(a) / $3b825bc58ae06391$var$qc | 0) | 0;
}
var $3b825bc58ae06391$var$rc = 64, $3b825bc58ae06391$var$sc = 4194304;
function $3b825bc58ae06391$var$tc(a) {
    switch(a & -a){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return a & 4194240;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return a & 130023424;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 1073741824;
        default:
            return a;
    }
}
function $3b825bc58ae06391$var$uc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return 0;
    var d = 0, e = a.suspendedLanes, f = a.pingedLanes, g = c & 268435455;
    if (0 !== g) {
        var h = g & ~e;
        0 !== h ? d = $3b825bc58ae06391$var$tc(h) : (f &= g, 0 !== f && (d = $3b825bc58ae06391$var$tc(f)));
    } else g = c & ~e, 0 !== g ? d = $3b825bc58ae06391$var$tc(g) : 0 !== f && (d = $3b825bc58ae06391$var$tc(f));
    if (0 === d) return 0;
    if (0 !== b && b !== d && 0 === (b & e) && (e = d & -d, f = b & -b, e >= f || 16 === e && 0 !== (f & 4194240))) return b;
    0 !== (d & 4) && (d |= c & 16);
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - $3b825bc58ae06391$var$oc(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function $3b825bc58ae06391$var$vc(a, b) {
    switch(a){
        case 1:
        case 2:
        case 4:
            return b + 250;
        case 8:
        case 16:
        case 32:
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return b + 5E3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return -1;
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $3b825bc58ae06391$var$wc(a, b) {
    for(var c = a.suspendedLanes, d = a.pingedLanes, e = a.expirationTimes, f = a.pendingLanes; 0 < f;){
        var g = 31 - $3b825bc58ae06391$var$oc(f), h = 1 << g, k = e[g];
        if (-1 === k) {
            if (0 === (h & c) || 0 !== (h & d)) e[g] = $3b825bc58ae06391$var$vc(h, b);
        } else k <= b && (a.expiredLanes |= h);
        f &= ~h;
    }
}
function $3b825bc58ae06391$var$xc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function $3b825bc58ae06391$var$yc() {
    var a = $3b825bc58ae06391$var$rc;
    $3b825bc58ae06391$var$rc <<= 1;
    0 === ($3b825bc58ae06391$var$rc & 4194240) && ($3b825bc58ae06391$var$rc = 64);
    return a;
}
function $3b825bc58ae06391$var$zc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function $3b825bc58ae06391$var$Ac(a, b, c) {
    a.pendingLanes |= b;
    536870912 !== b && (a.suspendedLanes = 0, a.pingedLanes = 0);
    a = a.eventTimes;
    b = 31 - $3b825bc58ae06391$var$oc(b);
    a[b] = c;
}
function $3b825bc58ae06391$var$Bc(a, b) {
    var c = a.pendingLanes & ~b;
    a.pendingLanes = b;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= b;
    a.mutableReadLanes &= b;
    a.entangledLanes &= b;
    b = a.entanglements;
    var d = a.eventTimes;
    for(a = a.expirationTimes; 0 < c;){
        var e = 31 - $3b825bc58ae06391$var$oc(c), f = 1 << e;
        b[e] = 0;
        d[e] = -1;
        a[e] = -1;
        c &= ~f;
    }
}
function $3b825bc58ae06391$var$Cc(a, b) {
    var c = a.entangledLanes |= b;
    for(a = a.entanglements; c;){
        var d = 31 - $3b825bc58ae06391$var$oc(c), e = 1 << d;
        e & b | a[d] & b && (a[d] |= b);
        c &= ~e;
    }
}
var $3b825bc58ae06391$var$C = 0;
function $3b825bc58ae06391$var$Dc(a) {
    a &= -a;
    return 1 < a ? 4 < a ? 0 !== (a & 268435455) ? 16 : 536870912 : 4 : 1;
}
var $3b825bc58ae06391$var$Ec, $3b825bc58ae06391$var$Fc, $3b825bc58ae06391$var$Gc, $3b825bc58ae06391$var$Hc, $3b825bc58ae06391$var$Ic, $3b825bc58ae06391$var$Jc = !1, $3b825bc58ae06391$var$Kc = [], $3b825bc58ae06391$var$Lc = null, $3b825bc58ae06391$var$Mc = null, $3b825bc58ae06391$var$Nc = null, $3b825bc58ae06391$var$Oc = new Map, $3b825bc58ae06391$var$Pc = new Map, $3b825bc58ae06391$var$Qc = [], $3b825bc58ae06391$var$Rc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function $3b825bc58ae06391$var$Sc(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            $3b825bc58ae06391$var$Lc = null;
            break;
        case "dragenter":
        case "dragleave":
            $3b825bc58ae06391$var$Mc = null;
            break;
        case "mouseover":
        case "mouseout":
            $3b825bc58ae06391$var$Nc = null;
            break;
        case "pointerover":
        case "pointerout":
            $3b825bc58ae06391$var$Oc.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $3b825bc58ae06391$var$Pc.delete(b.pointerId);
    }
}
function $3b825bc58ae06391$var$Tc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = {
        blockedOn: b,
        domEventName: c,
        eventSystemFlags: d,
        nativeEvent: f,
        targetContainers: [
            e
        ]
    }, null !== b && (b = $3b825bc58ae06391$var$Cb(b), null !== b && $3b825bc58ae06391$var$Fc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function $3b825bc58ae06391$var$Uc(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return $3b825bc58ae06391$var$Lc = $3b825bc58ae06391$var$Tc($3b825bc58ae06391$var$Lc, a, b, c, d, e), !0;
        case "dragenter":
            return $3b825bc58ae06391$var$Mc = $3b825bc58ae06391$var$Tc($3b825bc58ae06391$var$Mc, a, b, c, d, e), !0;
        case "mouseover":
            return $3b825bc58ae06391$var$Nc = $3b825bc58ae06391$var$Tc($3b825bc58ae06391$var$Nc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            $3b825bc58ae06391$var$Oc.set(f, $3b825bc58ae06391$var$Tc($3b825bc58ae06391$var$Oc.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, $3b825bc58ae06391$var$Pc.set(f, $3b825bc58ae06391$var$Tc($3b825bc58ae06391$var$Pc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function $3b825bc58ae06391$var$Vc(a) {
    var b = $3b825bc58ae06391$var$Wc(a.target);
    if (null !== b) {
        var c = $3b825bc58ae06391$var$Vb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = $3b825bc58ae06391$var$Wb(c), null !== b) {
                    a.blockedOn = b;
                    $3b825bc58ae06391$var$Ic(a.priority, function() {
                        $3b825bc58ae06391$var$Gc(c);
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.current.memoizedState.isDehydrated) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function $3b825bc58ae06391$var$Xc(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = $3b825bc58ae06391$var$Yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null === c) {
            c = a.nativeEvent;
            var d = new c.constructor(c.type, c);
            $3b825bc58ae06391$var$wb = d;
            c.target.dispatchEvent(d);
            $3b825bc58ae06391$var$wb = null;
        } else return b = $3b825bc58ae06391$var$Cb(c), null !== b && $3b825bc58ae06391$var$Fc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function $3b825bc58ae06391$var$Zc(a, b, c) {
    $3b825bc58ae06391$var$Xc(a) && c.delete(b);
}
function $3b825bc58ae06391$var$$c() {
    $3b825bc58ae06391$var$Jc = !1;
    null !== $3b825bc58ae06391$var$Lc && $3b825bc58ae06391$var$Xc($3b825bc58ae06391$var$Lc) && ($3b825bc58ae06391$var$Lc = null);
    null !== $3b825bc58ae06391$var$Mc && $3b825bc58ae06391$var$Xc($3b825bc58ae06391$var$Mc) && ($3b825bc58ae06391$var$Mc = null);
    null !== $3b825bc58ae06391$var$Nc && $3b825bc58ae06391$var$Xc($3b825bc58ae06391$var$Nc) && ($3b825bc58ae06391$var$Nc = null);
    $3b825bc58ae06391$var$Oc.forEach($3b825bc58ae06391$var$Zc);
    $3b825bc58ae06391$var$Pc.forEach($3b825bc58ae06391$var$Zc);
}
function $3b825bc58ae06391$var$ad(a, b) {
    a.blockedOn === b && (a.blockedOn = null, $3b825bc58ae06391$var$Jc || ($3b825bc58ae06391$var$Jc = !0, $3tRGX.unstable_scheduleCallback($3tRGX.unstable_NormalPriority, $3b825bc58ae06391$var$$c)));
}
function $3b825bc58ae06391$var$bd(a) {
    function b(b) {
        return $3b825bc58ae06391$var$ad(b, a);
    }
    if (0 < $3b825bc58ae06391$var$Kc.length) {
        $3b825bc58ae06391$var$ad($3b825bc58ae06391$var$Kc[0], a);
        for(var c = 1; c < $3b825bc58ae06391$var$Kc.length; c++){
            var d = $3b825bc58ae06391$var$Kc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== $3b825bc58ae06391$var$Lc && $3b825bc58ae06391$var$ad($3b825bc58ae06391$var$Lc, a);
    null !== $3b825bc58ae06391$var$Mc && $3b825bc58ae06391$var$ad($3b825bc58ae06391$var$Mc, a);
    null !== $3b825bc58ae06391$var$Nc && $3b825bc58ae06391$var$ad($3b825bc58ae06391$var$Nc, a);
    $3b825bc58ae06391$var$Oc.forEach(b);
    $3b825bc58ae06391$var$Pc.forEach(b);
    for(c = 0; c < $3b825bc58ae06391$var$Qc.length; c++)d = $3b825bc58ae06391$var$Qc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < $3b825bc58ae06391$var$Qc.length && (c = $3b825bc58ae06391$var$Qc[0], null === c.blockedOn);)$3b825bc58ae06391$var$Vc(c), null === c.blockedOn && $3b825bc58ae06391$var$Qc.shift();
}
var $3b825bc58ae06391$var$cd = $3b825bc58ae06391$var$ua.ReactCurrentBatchConfig, $3b825bc58ae06391$var$dd = !0;
function $3b825bc58ae06391$var$ed(a, b, c, d) {
    var e = $3b825bc58ae06391$var$C, f = $3b825bc58ae06391$var$cd.transition;
    $3b825bc58ae06391$var$cd.transition = null;
    try {
        $3b825bc58ae06391$var$C = 1, $3b825bc58ae06391$var$fd(a, b, c, d);
    } finally{
        $3b825bc58ae06391$var$C = e, $3b825bc58ae06391$var$cd.transition = f;
    }
}
function $3b825bc58ae06391$var$gd(a, b, c, d) {
    var e = $3b825bc58ae06391$var$C, f = $3b825bc58ae06391$var$cd.transition;
    $3b825bc58ae06391$var$cd.transition = null;
    try {
        $3b825bc58ae06391$var$C = 4, $3b825bc58ae06391$var$fd(a, b, c, d);
    } finally{
        $3b825bc58ae06391$var$C = e, $3b825bc58ae06391$var$cd.transition = f;
    }
}
function $3b825bc58ae06391$var$fd(a, b, c, d) {
    if ($3b825bc58ae06391$var$dd) {
        var e = $3b825bc58ae06391$var$Yc(a, b, c, d);
        if (null === e) $3b825bc58ae06391$var$hd(a, b, d, $3b825bc58ae06391$var$id, c), $3b825bc58ae06391$var$Sc(a, d);
        else if ($3b825bc58ae06391$var$Uc(e, a, b, c, d)) d.stopPropagation();
        else if ($3b825bc58ae06391$var$Sc(a, d), b & 4 && -1 < $3b825bc58ae06391$var$Rc.indexOf(a)) {
            for(; null !== e;){
                var f = $3b825bc58ae06391$var$Cb(e);
                null !== f && $3b825bc58ae06391$var$Ec(f);
                f = $3b825bc58ae06391$var$Yc(a, b, c, d);
                null === f && $3b825bc58ae06391$var$hd(a, b, d, $3b825bc58ae06391$var$id, c);
                if (f === e) break;
                e = f;
            }
            null !== e && d.stopPropagation();
        } else $3b825bc58ae06391$var$hd(a, b, d, null, c);
    }
}
var $3b825bc58ae06391$var$id = null;
function $3b825bc58ae06391$var$Yc(a, b, c, d) {
    $3b825bc58ae06391$var$id = null;
    a = $3b825bc58ae06391$var$xb(d);
    a = $3b825bc58ae06391$var$Wc(a);
    if (null !== a) {
        if (b = $3b825bc58ae06391$var$Vb(a), null === b) a = null;
        else if (c = b.tag, 13 === c) {
            a = $3b825bc58ae06391$var$Wb(b);
            if (null !== a) return a;
            a = null;
        } else if (3 === c) {
            if (b.stateNode.current.memoizedState.isDehydrated) return 3 === b.tag ? b.stateNode.containerInfo : null;
            a = null;
        } else b !== a && (a = null);
    }
    $3b825bc58ae06391$var$id = a;
    return null;
}
function $3b825bc58ae06391$var$jd(a) {
    switch(a){
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 1;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "toggle":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 4;
        case "message":
            switch($3b825bc58ae06391$var$ec()){
                case $3b825bc58ae06391$var$fc:
                    return 1;
                case $3b825bc58ae06391$var$gc:
                    return 4;
                case $3b825bc58ae06391$var$hc:
                case $3b825bc58ae06391$var$ic:
                    return 16;
                case $3b825bc58ae06391$var$jc:
                    return 536870912;
                default:
                    return 16;
            }
        default:
            return 16;
    }
}
var $3b825bc58ae06391$var$kd = null, $3b825bc58ae06391$var$ld = null, $3b825bc58ae06391$var$md = null;
function $3b825bc58ae06391$var$nd() {
    if ($3b825bc58ae06391$var$md) return $3b825bc58ae06391$var$md;
    var a, b = $3b825bc58ae06391$var$ld, c = b.length, d, e = "value" in $3b825bc58ae06391$var$kd ? $3b825bc58ae06391$var$kd.value : $3b825bc58ae06391$var$kd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return $3b825bc58ae06391$var$md = e.slice(a, 1 < d ? 1 - d : void 0);
}
function $3b825bc58ae06391$var$od(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function $3b825bc58ae06391$var$pd() {
    return !0;
}
function $3b825bc58ae06391$var$qd() {
    return !1;
}
function $3b825bc58ae06391$var$rd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? $3b825bc58ae06391$var$pd : $3b825bc58ae06391$var$qd;
        this.isPropagationStopped = $3b825bc58ae06391$var$qd;
        return this;
    }
    $3b825bc58ae06391$var$A(b.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = $3b825bc58ae06391$var$pd);
        },
        stopPropagation: function() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = $3b825bc58ae06391$var$pd);
        },
        persist: function() {},
        isPersistent: $3b825bc58ae06391$var$pd
    });
    return b;
}
var $3b825bc58ae06391$var$sd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $3b825bc58ae06391$var$td = $3b825bc58ae06391$var$rd($3b825bc58ae06391$var$sd), $3b825bc58ae06391$var$ud = $3b825bc58ae06391$var$A({}, $3b825bc58ae06391$var$sd, {
    view: 0,
    detail: 0
}), $3b825bc58ae06391$var$vd = $3b825bc58ae06391$var$rd($3b825bc58ae06391$var$ud), $3b825bc58ae06391$var$wd, $3b825bc58ae06391$var$xd, $3b825bc58ae06391$var$yd, $3b825bc58ae06391$var$Ad = $3b825bc58ae06391$var$A({}, $3b825bc58ae06391$var$ud, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $3b825bc58ae06391$var$zd,
    button: 0,
    buttons: 0,
    relatedTarget: function(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        a !== $3b825bc58ae06391$var$yd && ($3b825bc58ae06391$var$yd && "mousemove" === a.type ? ($3b825bc58ae06391$var$wd = a.screenX - $3b825bc58ae06391$var$yd.screenX, $3b825bc58ae06391$var$xd = a.screenY - $3b825bc58ae06391$var$yd.screenY) : $3b825bc58ae06391$var$xd = $3b825bc58ae06391$var$wd = 0, $3b825bc58ae06391$var$yd = a);
        return $3b825bc58ae06391$var$wd;
    },
    movementY: function(a) {
        return "movementY" in a ? a.movementY : $3b825bc58ae06391$var$xd;
    }
}), $3b825bc58ae06391$var$Bd = $3b825bc58ae06391$var$rd($3b825bc58ae06391$var$Ad), $3b825bc58ae06391$var$Cd = $3b825bc58ae06391$var$A({}, $3b825bc58ae06391$var$Ad, {
    dataTransfer: 0
}), $3b825bc58ae06391$var$Dd = $3b825bc58ae06391$var$rd($3b825bc58ae06391$var$Cd), $3b825bc58ae06391$var$Ed = $3b825bc58ae06391$var$A({}, $3b825bc58ae06391$var$ud, {
    relatedTarget: 0
}), $3b825bc58ae06391$var$Fd = $3b825bc58ae06391$var$rd($3b825bc58ae06391$var$Ed), $3b825bc58ae06391$var$Gd = $3b825bc58ae06391$var$A({}, $3b825bc58ae06391$var$sd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $3b825bc58ae06391$var$Hd = $3b825bc58ae06391$var$rd($3b825bc58ae06391$var$Gd), $3b825bc58ae06391$var$Id = $3b825bc58ae06391$var$A({}, $3b825bc58ae06391$var$sd, {
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), $3b825bc58ae06391$var$Jd = $3b825bc58ae06391$var$rd($3b825bc58ae06391$var$Id), $3b825bc58ae06391$var$Kd = $3b825bc58ae06391$var$A({}, $3b825bc58ae06391$var$sd, {
    data: 0
}), $3b825bc58ae06391$var$Ld = $3b825bc58ae06391$var$rd($3b825bc58ae06391$var$Kd), $3b825bc58ae06391$var$Md = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $3b825bc58ae06391$var$Nd = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $3b825bc58ae06391$var$Od = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $3b825bc58ae06391$var$Pd(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = $3b825bc58ae06391$var$Od[a]) ? !!b[a] : !1;
}
function $3b825bc58ae06391$var$zd() {
    return $3b825bc58ae06391$var$Pd;
}
var $3b825bc58ae06391$var$Qd = $3b825bc58ae06391$var$A({}, $3b825bc58ae06391$var$ud, {
    key: function(a) {
        if (a.key) {
            var b = $3b825bc58ae06391$var$Md[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = $3b825bc58ae06391$var$od(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? $3b825bc58ae06391$var$Nd[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $3b825bc58ae06391$var$zd,
    charCode: function(a) {
        return "keypress" === a.type ? $3b825bc58ae06391$var$od(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? $3b825bc58ae06391$var$od(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), $3b825bc58ae06391$var$Rd = $3b825bc58ae06391$var$rd($3b825bc58ae06391$var$Qd), $3b825bc58ae06391$var$Sd = $3b825bc58ae06391$var$A({}, $3b825bc58ae06391$var$Ad, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $3b825bc58ae06391$var$Td = $3b825bc58ae06391$var$rd($3b825bc58ae06391$var$Sd), $3b825bc58ae06391$var$Ud = $3b825bc58ae06391$var$A({}, $3b825bc58ae06391$var$ud, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $3b825bc58ae06391$var$zd
}), $3b825bc58ae06391$var$Vd = $3b825bc58ae06391$var$rd($3b825bc58ae06391$var$Ud), $3b825bc58ae06391$var$Wd = $3b825bc58ae06391$var$A({}, $3b825bc58ae06391$var$sd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $3b825bc58ae06391$var$Xd = $3b825bc58ae06391$var$rd($3b825bc58ae06391$var$Wd), $3b825bc58ae06391$var$Yd = $3b825bc58ae06391$var$A({}, $3b825bc58ae06391$var$Ad, {
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $3b825bc58ae06391$var$Zd = $3b825bc58ae06391$var$rd($3b825bc58ae06391$var$Yd), $3b825bc58ae06391$var$$d = [
    9,
    13,
    27,
    32
], $3b825bc58ae06391$var$ae = $3b825bc58ae06391$var$ia && "CompositionEvent" in window, $3b825bc58ae06391$var$be = null;
$3b825bc58ae06391$var$ia && "documentMode" in document && ($3b825bc58ae06391$var$be = document.documentMode);
var $3b825bc58ae06391$var$ce = $3b825bc58ae06391$var$ia && "TextEvent" in window && !$3b825bc58ae06391$var$be, $3b825bc58ae06391$var$de = $3b825bc58ae06391$var$ia && (!$3b825bc58ae06391$var$ae || $3b825bc58ae06391$var$be && 8 < $3b825bc58ae06391$var$be && 11 >= $3b825bc58ae06391$var$be), $3b825bc58ae06391$var$ee = String.fromCharCode(32), $3b825bc58ae06391$var$fe = !1;
function $3b825bc58ae06391$var$ge(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $3b825bc58ae06391$var$$d.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $3b825bc58ae06391$var$he(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var $3b825bc58ae06391$var$ie = !1;
function $3b825bc58ae06391$var$je(a, b) {
    switch(a){
        case "compositionend":
            return $3b825bc58ae06391$var$he(b);
        case "keypress":
            if (32 !== b.which) return null;
            $3b825bc58ae06391$var$fe = !0;
            return $3b825bc58ae06391$var$ee;
        case "textInput":
            return a = b.data, a === $3b825bc58ae06391$var$ee && $3b825bc58ae06391$var$fe ? null : a;
        default:
            return null;
    }
}
function $3b825bc58ae06391$var$ke(a, b) {
    if ($3b825bc58ae06391$var$ie) return "compositionend" === a || !$3b825bc58ae06391$var$ae && $3b825bc58ae06391$var$ge(a, b) ? (a = $3b825bc58ae06391$var$nd(), $3b825bc58ae06391$var$md = $3b825bc58ae06391$var$ld = $3b825bc58ae06391$var$kd = null, $3b825bc58ae06391$var$ie = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return $3b825bc58ae06391$var$de && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var $3b825bc58ae06391$var$le = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $3b825bc58ae06391$var$me(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!$3b825bc58ae06391$var$le[a.type] : "textarea" === b ? !0 : !1;
}
function $3b825bc58ae06391$var$ne(a, b, c, d) {
    $3b825bc58ae06391$var$Eb(d);
    b = $3b825bc58ae06391$var$oe(b, "onChange");
    0 < b.length && (c = new $3b825bc58ae06391$var$td("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var $3b825bc58ae06391$var$pe = null, $3b825bc58ae06391$var$qe = null;
function $3b825bc58ae06391$var$re(a) {
    $3b825bc58ae06391$var$se(a, 0);
}
function $3b825bc58ae06391$var$te(a) {
    var b = $3b825bc58ae06391$var$ue(a);
    if ($3b825bc58ae06391$var$Wa(b)) return a;
}
function $3b825bc58ae06391$var$ve(a, b) {
    if ("change" === a) return b;
}
var $3b825bc58ae06391$var$we = !1;
if ($3b825bc58ae06391$var$ia) {
    var $3b825bc58ae06391$var$xe;
    if ($3b825bc58ae06391$var$ia) {
        var $3b825bc58ae06391$var$ye = "oninput" in document;
        if (!$3b825bc58ae06391$var$ye) {
            var $3b825bc58ae06391$var$ze = document.createElement("div");
            $3b825bc58ae06391$var$ze.setAttribute("oninput", "return;");
            $3b825bc58ae06391$var$ye = "function" === typeof $3b825bc58ae06391$var$ze.oninput;
        }
        $3b825bc58ae06391$var$xe = $3b825bc58ae06391$var$ye;
    } else $3b825bc58ae06391$var$xe = !1;
    $3b825bc58ae06391$var$we = $3b825bc58ae06391$var$xe && (!document.documentMode || 9 < document.documentMode);
}
function $3b825bc58ae06391$var$Ae() {
    $3b825bc58ae06391$var$pe && ($3b825bc58ae06391$var$pe.detachEvent("onpropertychange", $3b825bc58ae06391$var$Be), $3b825bc58ae06391$var$qe = $3b825bc58ae06391$var$pe = null);
}
function $3b825bc58ae06391$var$Be(a) {
    if ("value" === a.propertyName && $3b825bc58ae06391$var$te($3b825bc58ae06391$var$qe)) {
        var b = [];
        $3b825bc58ae06391$var$ne(b, $3b825bc58ae06391$var$qe, a, $3b825bc58ae06391$var$xb(a));
        $3b825bc58ae06391$var$Jb($3b825bc58ae06391$var$re, b);
    }
}
function $3b825bc58ae06391$var$Ce(a, b, c) {
    "focusin" === a ? ($3b825bc58ae06391$var$Ae(), $3b825bc58ae06391$var$pe = b, $3b825bc58ae06391$var$qe = c, $3b825bc58ae06391$var$pe.attachEvent("onpropertychange", $3b825bc58ae06391$var$Be)) : "focusout" === a && $3b825bc58ae06391$var$Ae();
}
function $3b825bc58ae06391$var$De(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return $3b825bc58ae06391$var$te($3b825bc58ae06391$var$qe);
}
function $3b825bc58ae06391$var$Ee(a, b) {
    if ("click" === a) return $3b825bc58ae06391$var$te(b);
}
function $3b825bc58ae06391$var$Fe(a, b) {
    if ("input" === a || "change" === a) return $3b825bc58ae06391$var$te(b);
}
function $3b825bc58ae06391$var$Ge(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $3b825bc58ae06391$var$He = "function" === typeof Object.is ? Object.is : $3b825bc58ae06391$var$Ge;
function $3b825bc58ae06391$var$Ie(a, b) {
    if ($3b825bc58ae06391$var$He(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++){
        var e = c[d];
        if (!$3b825bc58ae06391$var$ja.call(b, e) || !$3b825bc58ae06391$var$He(a[e], b[e])) return !1;
    }
    return !0;
}
function $3b825bc58ae06391$var$Je(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function $3b825bc58ae06391$var$Ke(a, b) {
    var c = $3b825bc58ae06391$var$Je(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = $3b825bc58ae06391$var$Je(c);
    }
}
function $3b825bc58ae06391$var$Le(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? $3b825bc58ae06391$var$Le(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function $3b825bc58ae06391$var$Me() {
    for(var a = window, b = $3b825bc58ae06391$var$Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = $3b825bc58ae06391$var$Xa(a.document);
    }
    return b;
}
function $3b825bc58ae06391$var$Ne(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
function $3b825bc58ae06391$var$Oe(a) {
    var b = $3b825bc58ae06391$var$Me(), c = a.focusedElem, d = a.selectionRange;
    if (b !== c && c && c.ownerDocument && $3b825bc58ae06391$var$Le(c.ownerDocument.documentElement, c)) {
        if (null !== d && $3b825bc58ae06391$var$Ne(c)) {
            if (b = d.start, a = d.end, void 0 === a && (a = b), "selectionStart" in c) c.selectionStart = b, c.selectionEnd = Math.min(a, c.value.length);
            else if (a = (b = c.ownerDocument || document) && b.defaultView || window, a.getSelection) {
                a = a.getSelection();
                var e = c.textContent.length, f = Math.min(d.start, e);
                d = void 0 === d.end ? f : Math.min(d.end, e);
                !a.extend && f > d && (e = d, d = f, f = e);
                e = $3b825bc58ae06391$var$Ke(c, f);
                var g = $3b825bc58ae06391$var$Ke(c, d);
                e && g && (1 !== a.rangeCount || a.anchorNode !== e.node || a.anchorOffset !== e.offset || a.focusNode !== g.node || a.focusOffset !== g.offset) && (b = b.createRange(), b.setStart(e.node, e.offset), a.removeAllRanges(), f > d ? (a.addRange(b), a.extend(g.node, g.offset)) : (b.setEnd(g.node, g.offset), a.addRange(b)));
            }
        }
        b = [];
        for(a = c; a = a.parentNode;)1 === a.nodeType && b.push({
            element: a,
            left: a.scrollLeft,
            top: a.scrollTop
        });
        "function" === typeof c.focus && c.focus();
        for(c = 0; c < b.length; c++)a = b[c], a.element.scrollLeft = a.left, a.element.scrollTop = a.top;
    }
}
var $3b825bc58ae06391$var$Pe = $3b825bc58ae06391$var$ia && "documentMode" in document && 11 >= document.documentMode, $3b825bc58ae06391$var$Qe = null, $3b825bc58ae06391$var$Re = null, $3b825bc58ae06391$var$Se = null, $3b825bc58ae06391$var$Te = !1;
function $3b825bc58ae06391$var$Ue(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    $3b825bc58ae06391$var$Te || null == $3b825bc58ae06391$var$Qe || $3b825bc58ae06391$var$Qe !== $3b825bc58ae06391$var$Xa(d) || (d = $3b825bc58ae06391$var$Qe, "selectionStart" in d && $3b825bc58ae06391$var$Ne(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), $3b825bc58ae06391$var$Se && $3b825bc58ae06391$var$Ie($3b825bc58ae06391$var$Se, d) || ($3b825bc58ae06391$var$Se = d, d = $3b825bc58ae06391$var$oe($3b825bc58ae06391$var$Re, "onSelect"), 0 < d.length && (b = new $3b825bc58ae06391$var$td("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = $3b825bc58ae06391$var$Qe)));
}
function $3b825bc58ae06391$var$Ve(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var $3b825bc58ae06391$var$We = {
    animationend: $3b825bc58ae06391$var$Ve("Animation", "AnimationEnd"),
    animationiteration: $3b825bc58ae06391$var$Ve("Animation", "AnimationIteration"),
    animationstart: $3b825bc58ae06391$var$Ve("Animation", "AnimationStart"),
    transitionend: $3b825bc58ae06391$var$Ve("Transition", "TransitionEnd")
}, $3b825bc58ae06391$var$Xe = {}, $3b825bc58ae06391$var$Ye = {};
$3b825bc58ae06391$var$ia && ($3b825bc58ae06391$var$Ye = document.createElement("div").style, "AnimationEvent" in window || (delete $3b825bc58ae06391$var$We.animationend.animation, delete $3b825bc58ae06391$var$We.animationiteration.animation, delete $3b825bc58ae06391$var$We.animationstart.animation), "TransitionEvent" in window || delete $3b825bc58ae06391$var$We.transitionend.transition);
function $3b825bc58ae06391$var$Ze(a) {
    if ($3b825bc58ae06391$var$Xe[a]) return $3b825bc58ae06391$var$Xe[a];
    if (!$3b825bc58ae06391$var$We[a]) return a;
    var b = $3b825bc58ae06391$var$We[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in $3b825bc58ae06391$var$Ye) return $3b825bc58ae06391$var$Xe[a] = b[c];
    return a;
}
var $3b825bc58ae06391$var$$e = $3b825bc58ae06391$var$Ze("animationend"), $3b825bc58ae06391$var$af = $3b825bc58ae06391$var$Ze("animationiteration"), $3b825bc58ae06391$var$bf = $3b825bc58ae06391$var$Ze("animationstart"), $3b825bc58ae06391$var$cf = $3b825bc58ae06391$var$Ze("transitionend"), $3b825bc58ae06391$var$df = new Map, $3b825bc58ae06391$var$ef = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
function $3b825bc58ae06391$var$ff(a, b) {
    $3b825bc58ae06391$var$df.set(a, b);
    $3b825bc58ae06391$var$fa(b, [
        a
    ]);
}
for(var $3b825bc58ae06391$var$gf = 0; $3b825bc58ae06391$var$gf < $3b825bc58ae06391$var$ef.length; $3b825bc58ae06391$var$gf++){
    var $3b825bc58ae06391$var$hf = $3b825bc58ae06391$var$ef[$3b825bc58ae06391$var$gf], $3b825bc58ae06391$var$jf = $3b825bc58ae06391$var$hf.toLowerCase(), $3b825bc58ae06391$var$kf = $3b825bc58ae06391$var$hf[0].toUpperCase() + $3b825bc58ae06391$var$hf.slice(1);
    $3b825bc58ae06391$var$ff($3b825bc58ae06391$var$jf, "on" + $3b825bc58ae06391$var$kf);
}
$3b825bc58ae06391$var$ff($3b825bc58ae06391$var$$e, "onAnimationEnd");
$3b825bc58ae06391$var$ff($3b825bc58ae06391$var$af, "onAnimationIteration");
$3b825bc58ae06391$var$ff($3b825bc58ae06391$var$bf, "onAnimationStart");
$3b825bc58ae06391$var$ff("dblclick", "onDoubleClick");
$3b825bc58ae06391$var$ff("focusin", "onFocus");
$3b825bc58ae06391$var$ff("focusout", "onBlur");
$3b825bc58ae06391$var$ff($3b825bc58ae06391$var$cf, "onTransitionEnd");
$3b825bc58ae06391$var$ha("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$3b825bc58ae06391$var$ha("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$3b825bc58ae06391$var$ha("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$3b825bc58ae06391$var$ha("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$3b825bc58ae06391$var$fa("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$3b825bc58ae06391$var$fa("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$3b825bc58ae06391$var$fa("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$3b825bc58ae06391$var$fa("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$3b825bc58ae06391$var$fa("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$3b825bc58ae06391$var$fa("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $3b825bc58ae06391$var$lf = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $3b825bc58ae06391$var$mf = new Set("cancel close invalid load scroll toggle".split(" ").concat($3b825bc58ae06391$var$lf));
function $3b825bc58ae06391$var$nf(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    $3b825bc58ae06391$var$Ub(d, b, void 0, a);
    a.currentTarget = null;
}
function $3b825bc58ae06391$var$se(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $3b825bc58ae06391$var$nf(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $3b825bc58ae06391$var$nf(e, h, l);
                f = k;
            }
        }
    }
    if ($3b825bc58ae06391$var$Qb) throw a = $3b825bc58ae06391$var$Rb, $3b825bc58ae06391$var$Qb = !1, $3b825bc58ae06391$var$Rb = null, a;
}
function $3b825bc58ae06391$var$D(a, b) {
    var c = b[$3b825bc58ae06391$var$of];
    void 0 === c && (c = b[$3b825bc58ae06391$var$of] = new Set);
    var d = a + "__bubble";
    c.has(d) || ($3b825bc58ae06391$var$pf(b, a, 2, !1), c.add(d));
}
function $3b825bc58ae06391$var$qf(a, b, c) {
    var d = 0;
    b && (d |= 4);
    $3b825bc58ae06391$var$pf(c, a, d, b);
}
var $3b825bc58ae06391$var$rf = "_reactListening" + Math.random().toString(36).slice(2);
function $3b825bc58ae06391$var$sf(a) {
    if (!a[$3b825bc58ae06391$var$rf]) {
        a[$3b825bc58ae06391$var$rf] = !0;
        $3b825bc58ae06391$var$da.forEach(function(b) {
            "selectionchange" !== b && ($3b825bc58ae06391$var$mf.has(b) || $3b825bc58ae06391$var$qf(b, !1, a), $3b825bc58ae06391$var$qf(b, !0, a));
        });
        var b = 9 === a.nodeType ? a : a.ownerDocument;
        null === b || b[$3b825bc58ae06391$var$rf] || (b[$3b825bc58ae06391$var$rf] = !0, $3b825bc58ae06391$var$qf("selectionchange", !1, b));
    }
}
function $3b825bc58ae06391$var$pf(a, b, c, d) {
    switch($3b825bc58ae06391$var$jd(b)){
        case 1:
            var e = $3b825bc58ae06391$var$ed;
            break;
        case 4:
            e = $3b825bc58ae06391$var$gd;
            break;
        default:
            e = $3b825bc58ae06391$var$fd;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !$3b825bc58ae06391$var$Lb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function $3b825bc58ae06391$var$hd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = $3b825bc58ae06391$var$Wc(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    $3b825bc58ae06391$var$Jb(function() {
        var d = f, e = $3b825bc58ae06391$var$xb(c), g = [];
        a: {
            var h = $3b825bc58ae06391$var$df.get(a);
            if (void 0 !== h) {
                var k = $3b825bc58ae06391$var$td, n = a;
                switch(a){
                    case "keypress":
                        if (0 === $3b825bc58ae06391$var$od(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = $3b825bc58ae06391$var$Rd;
                        break;
                    case "focusin":
                        n = "focus";
                        k = $3b825bc58ae06391$var$Fd;
                        break;
                    case "focusout":
                        n = "blur";
                        k = $3b825bc58ae06391$var$Fd;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = $3b825bc58ae06391$var$Fd;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = $3b825bc58ae06391$var$Bd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = $3b825bc58ae06391$var$Dd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = $3b825bc58ae06391$var$Vd;
                        break;
                    case $3b825bc58ae06391$var$$e:
                    case $3b825bc58ae06391$var$af:
                    case $3b825bc58ae06391$var$bf:
                        k = $3b825bc58ae06391$var$Hd;
                        break;
                    case $3b825bc58ae06391$var$cf:
                        k = $3b825bc58ae06391$var$Xd;
                        break;
                    case "scroll":
                        k = $3b825bc58ae06391$var$vd;
                        break;
                    case "wheel":
                        k = $3b825bc58ae06391$var$Zd;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = $3b825bc58ae06391$var$Jd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = $3b825bc58ae06391$var$Td;
                }
                var t = 0 !== (b & 4), J = !t && "scroll" === a, x = t ? null !== h ? h + "Capture" : null : h;
                t = [];
                for(var w = d, u; null !== w;){
                    u = w;
                    var F = u.stateNode;
                    5 === u.tag && null !== F && (u = F, null !== x && (F = $3b825bc58ae06391$var$Kb(w, x), null != F && t.push($3b825bc58ae06391$var$tf(w, F, u))));
                    if (J) break;
                    w = w.return;
                }
                0 < t.length && (h = new k(h, n, null, c, e), g.push({
                    event: h,
                    listeners: t
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && c !== $3b825bc58ae06391$var$wb && (n = c.relatedTarget || c.fromElement) && ($3b825bc58ae06391$var$Wc(n) || n[$3b825bc58ae06391$var$uf])) break a;
                if (k || h) {
                    h = e.window === e ? e : (h = e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (n = c.relatedTarget || c.toElement, k = d, n = n ? $3b825bc58ae06391$var$Wc(n) : null, null !== n && (J = $3b825bc58ae06391$var$Vb(n), n !== J || 5 !== n.tag && 6 !== n.tag)) n = null;
                    } else k = null, n = d;
                    if (k !== n) {
                        t = $3b825bc58ae06391$var$Bd;
                        F = "onMouseLeave";
                        x = "onMouseEnter";
                        w = "mouse";
                        if ("pointerout" === a || "pointerover" === a) t = $3b825bc58ae06391$var$Td, F = "onPointerLeave", x = "onPointerEnter", w = "pointer";
                        J = null == k ? h : $3b825bc58ae06391$var$ue(k);
                        u = null == n ? h : $3b825bc58ae06391$var$ue(n);
                        h = new t(F, w + "leave", k, c, e);
                        h.target = J;
                        h.relatedTarget = u;
                        F = null;
                        $3b825bc58ae06391$var$Wc(e) === d && (t = new t(x, w + "enter", n, c, e), t.target = u, t.relatedTarget = J, F = t);
                        J = F;
                        if (k && n) b: {
                            t = k;
                            x = n;
                            w = 0;
                            for(u = t; u; u = $3b825bc58ae06391$var$vf(u))w++;
                            u = 0;
                            for(F = x; F; F = $3b825bc58ae06391$var$vf(F))u++;
                            for(; 0 < w - u;)t = $3b825bc58ae06391$var$vf(t), w--;
                            for(; 0 < u - w;)x = $3b825bc58ae06391$var$vf(x), u--;
                            for(; w--;){
                                if (t === x || null !== x && t === x.alternate) break b;
                                t = $3b825bc58ae06391$var$vf(t);
                                x = $3b825bc58ae06391$var$vf(x);
                            }
                            t = null;
                        }
                        else t = null;
                        null !== k && $3b825bc58ae06391$var$wf(g, h, k, t, !1);
                        null !== n && null !== J && $3b825bc58ae06391$var$wf(g, J, n, t, !0);
                    }
                }
            }
            a: {
                h = d ? $3b825bc58ae06391$var$ue(d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var na = $3b825bc58ae06391$var$ve;
                else if ($3b825bc58ae06391$var$me(h)) {
                    if ($3b825bc58ae06391$var$we) na = $3b825bc58ae06391$var$Fe;
                    else {
                        na = $3b825bc58ae06391$var$De;
                        var xa = $3b825bc58ae06391$var$Ce;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (na = $3b825bc58ae06391$var$Ee);
                if (na && (na = na(a, d))) {
                    $3b825bc58ae06391$var$ne(g, na, c, e);
                    break a;
                }
                xa && xa(a, h, d);
                "focusout" === a && (xa = h._wrapperState) && xa.controlled && "number" === h.type && $3b825bc58ae06391$var$cb(h, "number", h.value);
            }
            xa = d ? $3b825bc58ae06391$var$ue(d) : window;
            switch(a){
                case "focusin":
                    if ($3b825bc58ae06391$var$me(xa) || "true" === xa.contentEditable) $3b825bc58ae06391$var$Qe = xa, $3b825bc58ae06391$var$Re = d, $3b825bc58ae06391$var$Se = null;
                    break;
                case "focusout":
                    $3b825bc58ae06391$var$Se = $3b825bc58ae06391$var$Re = $3b825bc58ae06391$var$Qe = null;
                    break;
                case "mousedown":
                    $3b825bc58ae06391$var$Te = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $3b825bc58ae06391$var$Te = !1;
                    $3b825bc58ae06391$var$Ue(g, c, e);
                    break;
                case "selectionchange":
                    if ($3b825bc58ae06391$var$Pe) break;
                case "keydown":
                case "keyup":
                    $3b825bc58ae06391$var$Ue(g, c, e);
            }
            var $a;
            if ($3b825bc58ae06391$var$ae) b: {
                switch(a){
                    case "compositionstart":
                        var ba = "onCompositionStart";
                        break b;
                    case "compositionend":
                        ba = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        ba = "onCompositionUpdate";
                        break b;
                }
                ba = void 0;
            }
            else $3b825bc58ae06391$var$ie ? $3b825bc58ae06391$var$ge(a, c) && (ba = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (ba = "onCompositionStart");
            ba && ($3b825bc58ae06391$var$de && "ko" !== c.locale && ($3b825bc58ae06391$var$ie || "onCompositionStart" !== ba ? "onCompositionEnd" === ba && $3b825bc58ae06391$var$ie && ($a = $3b825bc58ae06391$var$nd()) : ($3b825bc58ae06391$var$kd = e, $3b825bc58ae06391$var$ld = "value" in $3b825bc58ae06391$var$kd ? $3b825bc58ae06391$var$kd.value : $3b825bc58ae06391$var$kd.textContent, $3b825bc58ae06391$var$ie = !0)), xa = $3b825bc58ae06391$var$oe(d, ba), 0 < xa.length && (ba = new $3b825bc58ae06391$var$Ld(ba, a, null, c, e), g.push({
                event: ba,
                listeners: xa
            }), $a ? ba.data = $a : ($a = $3b825bc58ae06391$var$he(c), null !== $a && (ba.data = $a))));
            if ($a = $3b825bc58ae06391$var$ce ? $3b825bc58ae06391$var$je(a, c) : $3b825bc58ae06391$var$ke(a, c)) d = $3b825bc58ae06391$var$oe(d, "onBeforeInput"), 0 < d.length && (e = new $3b825bc58ae06391$var$Ld("onBeforeInput", "beforeinput", null, c, e), g.push({
                event: e,
                listeners: d
            }), e.data = $a);
        }
        $3b825bc58ae06391$var$se(g, b);
    });
}
function $3b825bc58ae06391$var$tf(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function $3b825bc58ae06391$var$oe(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = $3b825bc58ae06391$var$Kb(a, c), null != f && d.unshift($3b825bc58ae06391$var$tf(a, f, e)), f = $3b825bc58ae06391$var$Kb(a, b), null != f && d.push($3b825bc58ae06391$var$tf(a, f, e)));
        a = a.return;
    }
    return d;
}
function $3b825bc58ae06391$var$vf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function $3b825bc58ae06391$var$wf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = $3b825bc58ae06391$var$Kb(c, f), null != k && g.unshift($3b825bc58ae06391$var$tf(c, k, h))) : e || (k = $3b825bc58ae06391$var$Kb(c, f), null != k && g.push($3b825bc58ae06391$var$tf(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
var $3b825bc58ae06391$var$xf = /\r\n?/g, $3b825bc58ae06391$var$yf = /\u0000|\uFFFD/g;
function $3b825bc58ae06391$var$zf(a) {
    return ("string" === typeof a ? a : "" + a).replace($3b825bc58ae06391$var$xf, "\n").replace($3b825bc58ae06391$var$yf, "");
}
function $3b825bc58ae06391$var$Af(a, b, c) {
    b = $3b825bc58ae06391$var$zf(b);
    if ($3b825bc58ae06391$var$zf(a) !== b && c) throw Error($3b825bc58ae06391$var$p(425));
}
function $3b825bc58ae06391$var$Bf() {}
var $3b825bc58ae06391$var$Cf = null, $3b825bc58ae06391$var$Df = null;
function $3b825bc58ae06391$var$Ef(a, b) {
    return "textarea" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var $3b825bc58ae06391$var$Ff = "function" === typeof setTimeout ? setTimeout : void 0, $3b825bc58ae06391$var$Gf = "function" === typeof clearTimeout ? clearTimeout : void 0, $3b825bc58ae06391$var$Hf = "function" === typeof Promise ? Promise : void 0, $3b825bc58ae06391$var$Jf = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $3b825bc58ae06391$var$Hf ? function(a) {
    return $3b825bc58ae06391$var$Hf.resolve(null).then(a).catch($3b825bc58ae06391$var$If);
} : $3b825bc58ae06391$var$Ff;
function $3b825bc58ae06391$var$If(a) {
    setTimeout(function() {
        throw a;
    });
}
function $3b825bc58ae06391$var$Kf(a, b) {
    var c = b, d = 0;
    do {
        var e = c.nextSibling;
        a.removeChild(c);
        if (e && 8 === e.nodeType) {
            if (c = e.data, "/$" === c) {
                if (0 === d) {
                    a.removeChild(e);
                    $3b825bc58ae06391$var$bd(b);
                    return;
                }
                d--;
            } else "$" !== c && "$?" !== c && "$!" !== c || d++;
        }
        c = e;
    }while (c);
    $3b825bc58ae06391$var$bd(b);
}
function $3b825bc58ae06391$var$Lf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
        if (8 === b) {
            b = a.data;
            if ("$" === b || "$!" === b || "$?" === b) break;
            if ("/$" === b) return null;
        }
    }
    return a;
}
function $3b825bc58ae06391$var$Mf(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var $3b825bc58ae06391$var$Nf = Math.random().toString(36).slice(2), $3b825bc58ae06391$var$Of = "__reactFiber$" + $3b825bc58ae06391$var$Nf, $3b825bc58ae06391$var$Pf = "__reactProps$" + $3b825bc58ae06391$var$Nf, $3b825bc58ae06391$var$uf = "__reactContainer$" + $3b825bc58ae06391$var$Nf, $3b825bc58ae06391$var$of = "__reactEvents$" + $3b825bc58ae06391$var$Nf, $3b825bc58ae06391$var$Qf = "__reactListeners$" + $3b825bc58ae06391$var$Nf, $3b825bc58ae06391$var$Rf = "__reactHandles$" + $3b825bc58ae06391$var$Nf;
function $3b825bc58ae06391$var$Wc(a) {
    var b = a[$3b825bc58ae06391$var$Of];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[$3b825bc58ae06391$var$uf] || c[$3b825bc58ae06391$var$Of]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = $3b825bc58ae06391$var$Mf(a); null !== a;){
                if (c = a[$3b825bc58ae06391$var$Of]) return c;
                a = $3b825bc58ae06391$var$Mf(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function $3b825bc58ae06391$var$Cb(a) {
    a = a[$3b825bc58ae06391$var$Of] || a[$3b825bc58ae06391$var$uf];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function $3b825bc58ae06391$var$ue(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error($3b825bc58ae06391$var$p(33));
}
function $3b825bc58ae06391$var$Db(a) {
    return a[$3b825bc58ae06391$var$Pf] || null;
}
var $3b825bc58ae06391$var$Sf = [], $3b825bc58ae06391$var$Tf = -1;
function $3b825bc58ae06391$var$Uf(a) {
    return {
        current: a
    };
}
function $3b825bc58ae06391$var$E(a) {
    0 > $3b825bc58ae06391$var$Tf || (a.current = $3b825bc58ae06391$var$Sf[$3b825bc58ae06391$var$Tf], $3b825bc58ae06391$var$Sf[$3b825bc58ae06391$var$Tf] = null, $3b825bc58ae06391$var$Tf--);
}
function $3b825bc58ae06391$var$G(a, b) {
    $3b825bc58ae06391$var$Tf++;
    $3b825bc58ae06391$var$Sf[$3b825bc58ae06391$var$Tf] = a.current;
    a.current = b;
}
var $3b825bc58ae06391$var$Vf = {}, $3b825bc58ae06391$var$H = $3b825bc58ae06391$var$Uf($3b825bc58ae06391$var$Vf), $3b825bc58ae06391$var$Wf = $3b825bc58ae06391$var$Uf(!1), $3b825bc58ae06391$var$Xf = $3b825bc58ae06391$var$Vf;
function $3b825bc58ae06391$var$Yf(a, b) {
    var c = a.type.contextTypes;
    if (!c) return $3b825bc58ae06391$var$Vf;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function $3b825bc58ae06391$var$Zf(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function $3b825bc58ae06391$var$$f() {
    $3b825bc58ae06391$var$E($3b825bc58ae06391$var$Wf);
    $3b825bc58ae06391$var$E($3b825bc58ae06391$var$H);
}
function $3b825bc58ae06391$var$ag(a, b, c) {
    if ($3b825bc58ae06391$var$H.current !== $3b825bc58ae06391$var$Vf) throw Error($3b825bc58ae06391$var$p(168));
    $3b825bc58ae06391$var$G($3b825bc58ae06391$var$H, b);
    $3b825bc58ae06391$var$G($3b825bc58ae06391$var$Wf, c);
}
function $3b825bc58ae06391$var$bg(a, b, c) {
    var d = a.stateNode;
    b = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in b)) throw Error($3b825bc58ae06391$var$p(108, $3b825bc58ae06391$var$Ra(a) || "Unknown", e));
    return $3b825bc58ae06391$var$A({}, c, d);
}
function $3b825bc58ae06391$var$cg(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || $3b825bc58ae06391$var$Vf;
    $3b825bc58ae06391$var$Xf = $3b825bc58ae06391$var$H.current;
    $3b825bc58ae06391$var$G($3b825bc58ae06391$var$H, a);
    $3b825bc58ae06391$var$G($3b825bc58ae06391$var$Wf, $3b825bc58ae06391$var$Wf.current);
    return !0;
}
function $3b825bc58ae06391$var$dg(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error($3b825bc58ae06391$var$p(169));
    c ? (a = $3b825bc58ae06391$var$bg(a, b, $3b825bc58ae06391$var$Xf), d.__reactInternalMemoizedMergedChildContext = a, $3b825bc58ae06391$var$E($3b825bc58ae06391$var$Wf), $3b825bc58ae06391$var$E($3b825bc58ae06391$var$H), $3b825bc58ae06391$var$G($3b825bc58ae06391$var$H, a)) : $3b825bc58ae06391$var$E($3b825bc58ae06391$var$Wf);
    $3b825bc58ae06391$var$G($3b825bc58ae06391$var$Wf, c);
}
var $3b825bc58ae06391$var$eg = null, $3b825bc58ae06391$var$fg = !1, $3b825bc58ae06391$var$gg = !1;
function $3b825bc58ae06391$var$hg(a) {
    null === $3b825bc58ae06391$var$eg ? $3b825bc58ae06391$var$eg = [
        a
    ] : $3b825bc58ae06391$var$eg.push(a);
}
function $3b825bc58ae06391$var$ig(a) {
    $3b825bc58ae06391$var$fg = !0;
    $3b825bc58ae06391$var$hg(a);
}
function $3b825bc58ae06391$var$jg() {
    if (!$3b825bc58ae06391$var$gg && null !== $3b825bc58ae06391$var$eg) {
        $3b825bc58ae06391$var$gg = !0;
        var a = 0, b = $3b825bc58ae06391$var$C;
        try {
            var c = $3b825bc58ae06391$var$eg;
            for($3b825bc58ae06391$var$C = 1; a < c.length; a++){
                var d = c[a];
                do d = d(!0);
                while (null !== d);
            }
            $3b825bc58ae06391$var$eg = null;
            $3b825bc58ae06391$var$fg = !1;
        } catch (e) {
            throw null !== $3b825bc58ae06391$var$eg && ($3b825bc58ae06391$var$eg = $3b825bc58ae06391$var$eg.slice(a + 1)), $3b825bc58ae06391$var$ac($3b825bc58ae06391$var$fc, $3b825bc58ae06391$var$jg), e;
        } finally{
            $3b825bc58ae06391$var$C = b, $3b825bc58ae06391$var$gg = !1;
        }
    }
    return null;
}
var $3b825bc58ae06391$var$kg = [], $3b825bc58ae06391$var$lg = 0, $3b825bc58ae06391$var$mg = null, $3b825bc58ae06391$var$ng = 0, $3b825bc58ae06391$var$og = [], $3b825bc58ae06391$var$pg = 0, $3b825bc58ae06391$var$qg = null, $3b825bc58ae06391$var$rg = 1, $3b825bc58ae06391$var$sg = "";
function $3b825bc58ae06391$var$tg(a, b) {
    $3b825bc58ae06391$var$kg[$3b825bc58ae06391$var$lg++] = $3b825bc58ae06391$var$ng;
    $3b825bc58ae06391$var$kg[$3b825bc58ae06391$var$lg++] = $3b825bc58ae06391$var$mg;
    $3b825bc58ae06391$var$mg = a;
    $3b825bc58ae06391$var$ng = b;
}
function $3b825bc58ae06391$var$ug(a, b, c) {
    $3b825bc58ae06391$var$og[$3b825bc58ae06391$var$pg++] = $3b825bc58ae06391$var$rg;
    $3b825bc58ae06391$var$og[$3b825bc58ae06391$var$pg++] = $3b825bc58ae06391$var$sg;
    $3b825bc58ae06391$var$og[$3b825bc58ae06391$var$pg++] = $3b825bc58ae06391$var$qg;
    $3b825bc58ae06391$var$qg = a;
    var d = $3b825bc58ae06391$var$rg;
    a = $3b825bc58ae06391$var$sg;
    var e = 32 - $3b825bc58ae06391$var$oc(d) - 1;
    d &= ~(1 << e);
    c += 1;
    var f = 32 - $3b825bc58ae06391$var$oc(b) + e;
    if (30 < f) {
        var g = e - e % 5;
        f = (d & (1 << g) - 1).toString(32);
        d >>= g;
        e -= g;
        $3b825bc58ae06391$var$rg = 1 << 32 - $3b825bc58ae06391$var$oc(b) + e | c << e | d;
        $3b825bc58ae06391$var$sg = f + a;
    } else $3b825bc58ae06391$var$rg = 1 << f | c << e | d, $3b825bc58ae06391$var$sg = a;
}
function $3b825bc58ae06391$var$vg(a) {
    null !== a.return && ($3b825bc58ae06391$var$tg(a, 1), $3b825bc58ae06391$var$ug(a, 1, 0));
}
function $3b825bc58ae06391$var$wg(a) {
    for(; a === $3b825bc58ae06391$var$mg;)$3b825bc58ae06391$var$mg = $3b825bc58ae06391$var$kg[--$3b825bc58ae06391$var$lg], $3b825bc58ae06391$var$kg[$3b825bc58ae06391$var$lg] = null, $3b825bc58ae06391$var$ng = $3b825bc58ae06391$var$kg[--$3b825bc58ae06391$var$lg], $3b825bc58ae06391$var$kg[$3b825bc58ae06391$var$lg] = null;
    for(; a === $3b825bc58ae06391$var$qg;)$3b825bc58ae06391$var$qg = $3b825bc58ae06391$var$og[--$3b825bc58ae06391$var$pg], $3b825bc58ae06391$var$og[$3b825bc58ae06391$var$pg] = null, $3b825bc58ae06391$var$sg = $3b825bc58ae06391$var$og[--$3b825bc58ae06391$var$pg], $3b825bc58ae06391$var$og[$3b825bc58ae06391$var$pg] = null, $3b825bc58ae06391$var$rg = $3b825bc58ae06391$var$og[--$3b825bc58ae06391$var$pg], $3b825bc58ae06391$var$og[$3b825bc58ae06391$var$pg] = null;
}
var $3b825bc58ae06391$var$xg = null, $3b825bc58ae06391$var$yg = null, $3b825bc58ae06391$var$I = !1, $3b825bc58ae06391$var$zg = null;
function $3b825bc58ae06391$var$Ag(a, b) {
    var c = $3b825bc58ae06391$var$Bg(5, null, null, 0);
    c.elementType = "DELETED";
    c.stateNode = b;
    c.return = a;
    b = a.deletions;
    null === b ? (a.deletions = [
        c
    ], a.flags |= 16) : b.push(c);
}
function $3b825bc58ae06391$var$Cg(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, $3b825bc58ae06391$var$xg = a, $3b825bc58ae06391$var$yg = $3b825bc58ae06391$var$Lf(b.firstChild), !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, $3b825bc58ae06391$var$xg = a, $3b825bc58ae06391$var$yg = null, !0) : !1;
        case 13:
            return b = 8 !== b.nodeType ? null : b, null !== b ? (c = null !== $3b825bc58ae06391$var$qg ? {
                id: $3b825bc58ae06391$var$rg,
                overflow: $3b825bc58ae06391$var$sg
            } : null, a.memoizedState = {
                dehydrated: b,
                treeContext: c,
                retryLane: 1073741824
            }, c = $3b825bc58ae06391$var$Bg(18, null, null, 0), c.stateNode = b, c.return = a, a.child = c, $3b825bc58ae06391$var$xg = a, $3b825bc58ae06391$var$yg = null, !0) : !1;
        default:
            return !1;
    }
}
function $3b825bc58ae06391$var$Dg(a) {
    return 0 !== (a.mode & 1) && 0 === (a.flags & 128);
}
function $3b825bc58ae06391$var$Eg(a) {
    if ($3b825bc58ae06391$var$I) {
        var b = $3b825bc58ae06391$var$yg;
        if (b) {
            var c = b;
            if (!$3b825bc58ae06391$var$Cg(a, b)) {
                if ($3b825bc58ae06391$var$Dg(a)) throw Error($3b825bc58ae06391$var$p(418));
                b = $3b825bc58ae06391$var$Lf(c.nextSibling);
                var d = $3b825bc58ae06391$var$xg;
                b && $3b825bc58ae06391$var$Cg(a, b) ? $3b825bc58ae06391$var$Ag(d, c) : (a.flags = a.flags & -4097 | 2, $3b825bc58ae06391$var$I = !1, $3b825bc58ae06391$var$xg = a);
            }
        } else {
            if ($3b825bc58ae06391$var$Dg(a)) throw Error($3b825bc58ae06391$var$p(418));
            a.flags = a.flags & -4097 | 2;
            $3b825bc58ae06391$var$I = !1;
            $3b825bc58ae06391$var$xg = a;
        }
    }
}
function $3b825bc58ae06391$var$Fg(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    $3b825bc58ae06391$var$xg = a;
}
function $3b825bc58ae06391$var$Gg(a) {
    if (a !== $3b825bc58ae06391$var$xg) return !1;
    if (!$3b825bc58ae06391$var$I) return $3b825bc58ae06391$var$Fg(a), $3b825bc58ae06391$var$I = !0, !1;
    var b;
    (b = 3 !== a.tag) && !(b = 5 !== a.tag) && (b = a.type, b = "head" !== b && "body" !== b && !$3b825bc58ae06391$var$Ef(a.type, a.memoizedProps));
    if (b && (b = $3b825bc58ae06391$var$yg)) {
        if ($3b825bc58ae06391$var$Dg(a)) throw $3b825bc58ae06391$var$Hg(), Error($3b825bc58ae06391$var$p(418));
        for(; b;)$3b825bc58ae06391$var$Ag(a, b), b = $3b825bc58ae06391$var$Lf(b.nextSibling);
    }
    $3b825bc58ae06391$var$Fg(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error($3b825bc58ae06391$var$p(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            $3b825bc58ae06391$var$yg = $3b825bc58ae06391$var$Lf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            $3b825bc58ae06391$var$yg = null;
        }
    } else $3b825bc58ae06391$var$yg = $3b825bc58ae06391$var$xg ? $3b825bc58ae06391$var$Lf(a.stateNode.nextSibling) : null;
    return !0;
}
function $3b825bc58ae06391$var$Hg() {
    for(var a = $3b825bc58ae06391$var$yg; a;)a = $3b825bc58ae06391$var$Lf(a.nextSibling);
}
function $3b825bc58ae06391$var$Ig() {
    $3b825bc58ae06391$var$yg = $3b825bc58ae06391$var$xg = null;
    $3b825bc58ae06391$var$I = !1;
}
function $3b825bc58ae06391$var$Jg(a) {
    null === $3b825bc58ae06391$var$zg ? $3b825bc58ae06391$var$zg = [
        a
    ] : $3b825bc58ae06391$var$zg.push(a);
}
var $3b825bc58ae06391$var$Kg = $3b825bc58ae06391$var$ua.ReactCurrentBatchConfig;
function $3b825bc58ae06391$var$Lg(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error($3b825bc58ae06391$var$p(309));
                var d = c.stateNode;
            }
            if (!d) throw Error($3b825bc58ae06391$var$p(147, a));
            var e = d, f = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === f) return b.ref;
            b = function(a) {
                var b = e.refs;
                null === a ? delete b[f] : b[f] = a;
            };
            b._stringRef = f;
            return b;
        }
        if ("string" !== typeof a) throw Error($3b825bc58ae06391$var$p(284));
        if (!c._owner) throw Error($3b825bc58ae06391$var$p(290, a));
    }
    return a;
}
function $3b825bc58ae06391$var$Mg(a, b) {
    a = Object.prototype.toString.call(b);
    throw Error($3b825bc58ae06391$var$p(31, "[object Object]" === a ? "object with keys {" + Object.keys(b).join(", ") + "}" : a));
}
function $3b825bc58ae06391$var$Ng(a) {
    var b = a._init;
    return b(a._payload);
}
function $3b825bc58ae06391$var$Og(a) {
    function b(b, c) {
        if (a) {
            var d = b.deletions;
            null === d ? (b.deletions = [
                c
            ], b.flags |= 16) : d.push(c);
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = $3b825bc58ae06391$var$Pg(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return b.flags |= 1048576, c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags |= 2, c) : d;
        b.flags |= 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags |= 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = $3b825bc58ae06391$var$Qg(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        var f = c.type;
        if (f === $3b825bc58ae06391$var$ya) return m(a, b, c.props.children, d, c.key);
        if (null !== b && (b.elementType === f || "object" === typeof f && null !== f && f.$$typeof === $3b825bc58ae06391$var$Ha && $3b825bc58ae06391$var$Ng(f) === b.type)) return d = e(b, c.props), d.ref = $3b825bc58ae06391$var$Lg(a, b, c), d.return = a, d;
        d = $3b825bc58ae06391$var$Rg(c.type, c.key, c.props, null, a.mode, d);
        d.ref = $3b825bc58ae06391$var$Lg(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = $3b825bc58ae06391$var$Sg(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function m(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = $3b825bc58ae06391$var$Tg(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function q(a, b, c) {
        if ("string" === typeof b && "" !== b || "number" === typeof b) return b = $3b825bc58ae06391$var$Qg("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case $3b825bc58ae06391$var$va:
                    return c = $3b825bc58ae06391$var$Rg(b.type, b.key, b.props, null, a.mode, c), c.ref = $3b825bc58ae06391$var$Lg(a, null, b), c.return = a, c;
                case $3b825bc58ae06391$var$wa:
                    return b = $3b825bc58ae06391$var$Sg(b, a.mode, c), b.return = a, b;
                case $3b825bc58ae06391$var$Ha:
                    var d = b._init;
                    return q(a, d(b._payload), c);
            }
            if ($3b825bc58ae06391$var$eb(b) || $3b825bc58ae06391$var$Ka(b)) return b = $3b825bc58ae06391$var$Tg(b, a.mode, c, null), b.return = a, b;
            $3b825bc58ae06391$var$Mg(a, b);
        }
        return null;
    }
    function r(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c && "" !== c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case $3b825bc58ae06391$var$va:
                    return c.key === e ? k(a, b, c, d) : null;
                case $3b825bc58ae06391$var$wa:
                    return c.key === e ? l(a, b, c, d) : null;
                case $3b825bc58ae06391$var$Ha:
                    return e = c._init, r(a, b, e(c._payload), d);
            }
            if ($3b825bc58ae06391$var$eb(c) || $3b825bc58ae06391$var$Ka(c)) return null !== e ? null : m(a, b, c, d, null);
            $3b825bc58ae06391$var$Mg(a, c);
        }
        return null;
    }
    function y(a, b, c, d, e) {
        if ("string" === typeof d && "" !== d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case $3b825bc58ae06391$var$va:
                    return a = a.get(null === d.key ? c : d.key) || null, k(b, a, d, e);
                case $3b825bc58ae06391$var$wa:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
                case $3b825bc58ae06391$var$Ha:
                    var f = d._init;
                    return y(a, b, c, f(d._payload), e);
            }
            if ($3b825bc58ae06391$var$eb(d) || $3b825bc58ae06391$var$Ka(d)) return a = a.get(c) || null, m(b, a, d, e, null);
            $3b825bc58ae06391$var$Mg(b, d);
        }
        return null;
    }
    function n(e, g, h, k) {
        for(var l = null, m = null, u = g, w = g = 0, x = null; null !== u && w < h.length; w++){
            u.index > w ? (x = u, u = null) : x = u.sibling;
            var n = r(e, u, h[w], k);
            if (null === n) {
                null === u && (u = x);
                break;
            }
            a && u && null === n.alternate && b(e, u);
            g = f(n, g, w);
            null === m ? l = n : m.sibling = n;
            m = n;
            u = x;
        }
        if (w === h.length) return c(e, u), $3b825bc58ae06391$var$I && $3b825bc58ae06391$var$tg(e, w), l;
        if (null === u) {
            for(; w < h.length; w++)u = q(e, h[w], k), null !== u && (g = f(u, g, w), null === m ? l = u : m.sibling = u, m = u);
            $3b825bc58ae06391$var$I && $3b825bc58ae06391$var$tg(e, w);
            return l;
        }
        for(u = d(e, u); w < h.length; w++)x = y(u, e, w, h[w], k), null !== x && (a && null !== x.alternate && u.delete(null === x.key ? w : x.key), g = f(x, g, w), null === m ? l = x : m.sibling = x, m = x);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        $3b825bc58ae06391$var$I && $3b825bc58ae06391$var$tg(e, w);
        return l;
    }
    function t(e, g, h, k) {
        var l = $3b825bc58ae06391$var$Ka(h);
        if ("function" !== typeof l) throw Error($3b825bc58ae06391$var$p(150));
        h = l.call(h);
        if (null == h) throw Error($3b825bc58ae06391$var$p(151));
        for(var u = l = null, m = g, w = g = 0, x = null, n = h.next(); null !== m && !n.done; w++, n = h.next()){
            m.index > w ? (x = m, m = null) : x = m.sibling;
            var t = r(e, m, n.value, k);
            if (null === t) {
                null === m && (m = x);
                break;
            }
            a && m && null === t.alternate && b(e, m);
            g = f(t, g, w);
            null === u ? l = t : u.sibling = t;
            u = t;
            m = x;
        }
        if (n.done) return c(e, m), $3b825bc58ae06391$var$I && $3b825bc58ae06391$var$tg(e, w), l;
        if (null === m) {
            for(; !n.done; w++, n = h.next())n = q(e, n.value, k), null !== n && (g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
            $3b825bc58ae06391$var$I && $3b825bc58ae06391$var$tg(e, w);
            return l;
        }
        for(m = d(e, m); !n.done; w++, n = h.next())n = y(m, e, w, n.value, k), null !== n && (a && null !== n.alternate && m.delete(null === n.key ? w : n.key), g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
        a && m.forEach(function(a) {
            return b(e, a);
        });
        $3b825bc58ae06391$var$I && $3b825bc58ae06391$var$tg(e, w);
        return l;
    }
    function J(a, d, f, h) {
        "object" === typeof f && null !== f && f.type === $3b825bc58ae06391$var$ya && null === f.key && (f = f.props.children);
        if ("object" === typeof f && null !== f) {
            switch(f.$$typeof){
                case $3b825bc58ae06391$var$va:
                    a: {
                        for(var k = f.key, l = d; null !== l;){
                            if (l.key === k) {
                                k = f.type;
                                if (k === $3b825bc58ae06391$var$ya) {
                                    if (7 === l.tag) {
                                        c(a, l.sibling);
                                        d = e(l, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                } else if (l.elementType === k || "object" === typeof k && null !== k && k.$$typeof === $3b825bc58ae06391$var$Ha && $3b825bc58ae06391$var$Ng(k) === l.type) {
                                    c(a, l.sibling);
                                    d = e(l, f.props);
                                    d.ref = $3b825bc58ae06391$var$Lg(a, l, f);
                                    d.return = a;
                                    a = d;
                                    break a;
                                }
                                c(a, l);
                                break;
                            } else b(a, l);
                            l = l.sibling;
                        }
                        f.type === $3b825bc58ae06391$var$ya ? (d = $3b825bc58ae06391$var$Tg(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = $3b825bc58ae06391$var$Rg(f.type, f.key, f.props, null, a.mode, h), h.ref = $3b825bc58ae06391$var$Lg(a, d, f), h.return = a, a = h);
                    }
                    return g(a);
                case $3b825bc58ae06391$var$wa:
                    a: {
                        for(l = f.key; null !== d;){
                            if (d.key === l) {
                                if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                    c(a, d.sibling);
                                    d = e(d, f.children || []);
                                    d.return = a;
                                    a = d;
                                    break a;
                                } else {
                                    c(a, d);
                                    break;
                                }
                            } else b(a, d);
                            d = d.sibling;
                        }
                        d = $3b825bc58ae06391$var$Sg(f, a.mode, h);
                        d.return = a;
                        a = d;
                    }
                    return g(a);
                case $3b825bc58ae06391$var$Ha:
                    return l = f._init, J(a, d, l(f._payload), h);
            }
            if ($3b825bc58ae06391$var$eb(f)) return n(a, d, f, h);
            if ($3b825bc58ae06391$var$Ka(f)) return t(a, d, f, h);
            $3b825bc58ae06391$var$Mg(a, f);
        }
        return "string" === typeof f && "" !== f || "number" === typeof f ? (f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = $3b825bc58ae06391$var$Qg(f, a.mode, h), d.return = a, a = d), g(a)) : c(a, d);
    }
    return J;
}
var $3b825bc58ae06391$var$Ug = $3b825bc58ae06391$var$Og(!0), $3b825bc58ae06391$var$Vg = $3b825bc58ae06391$var$Og(!1), $3b825bc58ae06391$var$Wg = $3b825bc58ae06391$var$Uf(null), $3b825bc58ae06391$var$Xg = null, $3b825bc58ae06391$var$Yg = null, $3b825bc58ae06391$var$Zg = null;
function $3b825bc58ae06391$var$$g() {
    $3b825bc58ae06391$var$Zg = $3b825bc58ae06391$var$Yg = $3b825bc58ae06391$var$Xg = null;
}
function $3b825bc58ae06391$var$ah(a) {
    var b = $3b825bc58ae06391$var$Wg.current;
    $3b825bc58ae06391$var$E($3b825bc58ae06391$var$Wg);
    a._currentValue = b;
}
function $3b825bc58ae06391$var$bh(a, b, c) {
    for(; null !== a;){
        var d = a.alternate;
        (a.childLanes & b) !== b ? (a.childLanes |= b, null !== d && (d.childLanes |= b)) : null !== d && (d.childLanes & b) !== b && (d.childLanes |= b);
        if (a === c) break;
        a = a.return;
    }
}
function $3b825bc58ae06391$var$ch(a, b) {
    $3b825bc58ae06391$var$Xg = a;
    $3b825bc58ae06391$var$Zg = $3b825bc58ae06391$var$Yg = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && ($3b825bc58ae06391$var$dh = !0), a.firstContext = null);
}
function $3b825bc58ae06391$var$eh(a) {
    var b = a._currentValue;
    if ($3b825bc58ae06391$var$Zg !== a) {
        if (a = {
            context: a,
            memoizedValue: b,
            next: null
        }, null === $3b825bc58ae06391$var$Yg) {
            if (null === $3b825bc58ae06391$var$Xg) throw Error($3b825bc58ae06391$var$p(308));
            $3b825bc58ae06391$var$Yg = a;
            $3b825bc58ae06391$var$Xg.dependencies = {
                lanes: 0,
                firstContext: a
            };
        } else $3b825bc58ae06391$var$Yg = $3b825bc58ae06391$var$Yg.next = a;
    }
    return b;
}
var $3b825bc58ae06391$var$fh = null;
function $3b825bc58ae06391$var$gh(a) {
    null === $3b825bc58ae06391$var$fh ? $3b825bc58ae06391$var$fh = [
        a
    ] : $3b825bc58ae06391$var$fh.push(a);
}
function $3b825bc58ae06391$var$hh(a, b, c, d) {
    var e = b.interleaved;
    null === e ? (c.next = c, $3b825bc58ae06391$var$gh(b)) : (c.next = e.next, e.next = c);
    b.interleaved = c;
    return $3b825bc58ae06391$var$ih(a, d);
}
function $3b825bc58ae06391$var$ih(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
var $3b825bc58ae06391$var$jh = !1;
function $3b825bc58ae06391$var$kh(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            interleaved: null,
            lanes: 0
        },
        effects: null
    };
}
function $3b825bc58ae06391$var$lh(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function $3b825bc58ae06391$var$mh(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $3b825bc58ae06391$var$nh(a, b, c) {
    var d = a.updateQueue;
    if (null === d) return null;
    d = d.shared;
    if (0 !== ($3b825bc58ae06391$var$K & 2)) {
        var e = d.pending;
        null === e ? b.next = b : (b.next = e.next, e.next = b);
        d.pending = b;
        return $3b825bc58ae06391$var$ih(a, c);
    }
    e = d.interleaved;
    null === e ? (b.next = b, $3b825bc58ae06391$var$gh(d)) : (b.next = e.next, e.next = b);
    d.interleaved = b;
    return $3b825bc58ae06391$var$ih(a, c);
}
function $3b825bc58ae06391$var$oh(a, b, c) {
    b = b.updateQueue;
    if (null !== b && (b = b.shared, 0 !== (c & 4194240))) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $3b825bc58ae06391$var$Cc(a, c);
    }
}
function $3b825bc58ae06391$var$ph(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function $3b825bc58ae06391$var$qh(a, b, c, d) {
    var e = a.updateQueue;
    $3b825bc58ae06391$var$jh = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var m = a.alternate;
        null !== m && (m = m.updateQueue, h = m.lastBaseUpdate, h !== g && (null === h ? m.firstBaseUpdate = l : h.next = l, m.lastBaseUpdate = k));
    }
    if (null !== f) {
        var q = e.baseState;
        g = 0;
        m = l = k = null;
        h = f;
        do {
            var r = h.lane, y = h.eventTime;
            if ((d & r) === r) {
                null !== m && (m = m.next = {
                    eventTime: y,
                    lane: 0,
                    tag: h.tag,
                    payload: h.payload,
                    callback: h.callback,
                    next: null
                });
                a: {
                    var n = a, t = h;
                    r = b;
                    y = c;
                    switch(t.tag){
                        case 1:
                            n = t.payload;
                            if ("function" === typeof n) {
                                q = n.call(y, q, r);
                                break a;
                            }
                            q = n;
                            break a;
                        case 3:
                            n.flags = n.flags & -65537 | 128;
                        case 0:
                            n = t.payload;
                            r = "function" === typeof n ? n.call(y, q, r) : n;
                            if (null === r || void 0 === r) break a;
                            q = $3b825bc58ae06391$var$A({}, q, r);
                            break a;
                        case 2:
                            $3b825bc58ae06391$var$jh = !0;
                    }
                }
                null !== h.callback && 0 !== h.lane && (a.flags |= 64, r = e.effects, null === r ? e.effects = [
                    h
                ] : r.push(h));
            } else y = {
                eventTime: y,
                lane: r,
                tag: h.tag,
                payload: h.payload,
                callback: h.callback,
                next: null
            }, null === m ? (l = m = y, k = q) : m = m.next = y, g |= r;
            h = h.next;
            if (null === h) {
                if (h = e.shared.pending, null === h) break;
                else r = h, h = r.next, r.next = null, e.lastBaseUpdate = r, e.shared.pending = null;
            }
        }while (1);
        null === m && (k = q);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = m;
        b = e.shared.interleaved;
        if (null !== b) {
            e = b;
            do g |= e.lane, e = e.next;
            while (e !== b);
        } else null === f && (e.shared.lanes = 0);
        $3b825bc58ae06391$var$rh |= g;
        a.lanes = g;
        a.memoizedState = q;
    }
}
function $3b825bc58ae06391$var$sh(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error($3b825bc58ae06391$var$p(191, e));
            e.call(d);
        }
    }
}
var $3b825bc58ae06391$var$th = {}, $3b825bc58ae06391$var$uh = $3b825bc58ae06391$var$Uf($3b825bc58ae06391$var$th), $3b825bc58ae06391$var$vh = $3b825bc58ae06391$var$Uf($3b825bc58ae06391$var$th), $3b825bc58ae06391$var$wh = $3b825bc58ae06391$var$Uf($3b825bc58ae06391$var$th);
function $3b825bc58ae06391$var$xh(a) {
    if (a === $3b825bc58ae06391$var$th) throw Error($3b825bc58ae06391$var$p(174));
    return a;
}
function $3b825bc58ae06391$var$yh(a, b) {
    $3b825bc58ae06391$var$G($3b825bc58ae06391$var$wh, b);
    $3b825bc58ae06391$var$G($3b825bc58ae06391$var$vh, a);
    $3b825bc58ae06391$var$G($3b825bc58ae06391$var$uh, $3b825bc58ae06391$var$th);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : $3b825bc58ae06391$var$lb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = $3b825bc58ae06391$var$lb(b, a);
    }
    $3b825bc58ae06391$var$E($3b825bc58ae06391$var$uh);
    $3b825bc58ae06391$var$G($3b825bc58ae06391$var$uh, b);
}
function $3b825bc58ae06391$var$zh() {
    $3b825bc58ae06391$var$E($3b825bc58ae06391$var$uh);
    $3b825bc58ae06391$var$E($3b825bc58ae06391$var$vh);
    $3b825bc58ae06391$var$E($3b825bc58ae06391$var$wh);
}
function $3b825bc58ae06391$var$Ah(a) {
    $3b825bc58ae06391$var$xh($3b825bc58ae06391$var$wh.current);
    var b = $3b825bc58ae06391$var$xh($3b825bc58ae06391$var$uh.current);
    var c = $3b825bc58ae06391$var$lb(b, a.type);
    b !== c && ($3b825bc58ae06391$var$G($3b825bc58ae06391$var$vh, a), $3b825bc58ae06391$var$G($3b825bc58ae06391$var$uh, c));
}
function $3b825bc58ae06391$var$Bh(a) {
    $3b825bc58ae06391$var$vh.current === a && ($3b825bc58ae06391$var$E($3b825bc58ae06391$var$uh), $3b825bc58ae06391$var$E($3b825bc58ae06391$var$vh));
}
var $3b825bc58ae06391$var$L = $3b825bc58ae06391$var$Uf(0);
function $3b825bc58ae06391$var$Ch(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 128)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var $3b825bc58ae06391$var$Dh = [];
function $3b825bc58ae06391$var$Eh() {
    for(var a = 0; a < $3b825bc58ae06391$var$Dh.length; a++)$3b825bc58ae06391$var$Dh[a]._workInProgressVersionPrimary = null;
    $3b825bc58ae06391$var$Dh.length = 0;
}
var $3b825bc58ae06391$var$Fh = $3b825bc58ae06391$var$ua.ReactCurrentDispatcher, $3b825bc58ae06391$var$Gh = $3b825bc58ae06391$var$ua.ReactCurrentBatchConfig, $3b825bc58ae06391$var$Hh = 0, $3b825bc58ae06391$var$M = null, $3b825bc58ae06391$var$N = null, $3b825bc58ae06391$var$O = null, $3b825bc58ae06391$var$Ih = !1, $3b825bc58ae06391$var$Jh = !1, $3b825bc58ae06391$var$Kh = 0, $3b825bc58ae06391$var$Lh = 0;
function $3b825bc58ae06391$var$P() {
    throw Error($3b825bc58ae06391$var$p(321));
}
function $3b825bc58ae06391$var$Mh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!$3b825bc58ae06391$var$He(a[c], b[c])) return !1;
    return !0;
}
function $3b825bc58ae06391$var$Nh(a, b, c, d, e, f) {
    $3b825bc58ae06391$var$Hh = f;
    $3b825bc58ae06391$var$M = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    $3b825bc58ae06391$var$Fh.current = null === a || null === a.memoizedState ? $3b825bc58ae06391$var$Oh : $3b825bc58ae06391$var$Ph;
    a = c(d, e);
    if ($3b825bc58ae06391$var$Jh) {
        f = 0;
        do {
            $3b825bc58ae06391$var$Jh = !1;
            $3b825bc58ae06391$var$Kh = 0;
            if (25 <= f) throw Error($3b825bc58ae06391$var$p(301));
            f += 1;
            $3b825bc58ae06391$var$O = $3b825bc58ae06391$var$N = null;
            b.updateQueue = null;
            $3b825bc58ae06391$var$Fh.current = $3b825bc58ae06391$var$Qh;
            a = c(d, e);
        }while ($3b825bc58ae06391$var$Jh);
    }
    $3b825bc58ae06391$var$Fh.current = $3b825bc58ae06391$var$Rh;
    b = null !== $3b825bc58ae06391$var$N && null !== $3b825bc58ae06391$var$N.next;
    $3b825bc58ae06391$var$Hh = 0;
    $3b825bc58ae06391$var$O = $3b825bc58ae06391$var$N = $3b825bc58ae06391$var$M = null;
    $3b825bc58ae06391$var$Ih = !1;
    if (b) throw Error($3b825bc58ae06391$var$p(300));
    return a;
}
function $3b825bc58ae06391$var$Sh() {
    var a = 0 !== $3b825bc58ae06391$var$Kh;
    $3b825bc58ae06391$var$Kh = 0;
    return a;
}
function $3b825bc58ae06391$var$Th() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $3b825bc58ae06391$var$O ? $3b825bc58ae06391$var$M.memoizedState = $3b825bc58ae06391$var$O = a : $3b825bc58ae06391$var$O = $3b825bc58ae06391$var$O.next = a;
    return $3b825bc58ae06391$var$O;
}
function $3b825bc58ae06391$var$Uh() {
    if (null === $3b825bc58ae06391$var$N) {
        var a = $3b825bc58ae06391$var$M.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = $3b825bc58ae06391$var$N.next;
    var b = null === $3b825bc58ae06391$var$O ? $3b825bc58ae06391$var$M.memoizedState : $3b825bc58ae06391$var$O.next;
    if (null !== b) $3b825bc58ae06391$var$O = b, $3b825bc58ae06391$var$N = a;
    else {
        if (null === a) throw Error($3b825bc58ae06391$var$p(310));
        $3b825bc58ae06391$var$N = a;
        a = {
            memoizedState: $3b825bc58ae06391$var$N.memoizedState,
            baseState: $3b825bc58ae06391$var$N.baseState,
            baseQueue: $3b825bc58ae06391$var$N.baseQueue,
            queue: $3b825bc58ae06391$var$N.queue,
            next: null
        };
        null === $3b825bc58ae06391$var$O ? $3b825bc58ae06391$var$M.memoizedState = $3b825bc58ae06391$var$O = a : $3b825bc58ae06391$var$O = $3b825bc58ae06391$var$O.next = a;
    }
    return $3b825bc58ae06391$var$O;
}
function $3b825bc58ae06391$var$Vh(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function $3b825bc58ae06391$var$Wh(a) {
    var b = $3b825bc58ae06391$var$Uh(), c = b.queue;
    if (null === c) throw Error($3b825bc58ae06391$var$p(311));
    c.lastRenderedReducer = a;
    var d = $3b825bc58ae06391$var$N, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        f = e.next;
        d = d.baseState;
        var h = g = null, k = null, l = f;
        do {
            var m = l.lane;
            if (($3b825bc58ae06391$var$Hh & m) === m) null !== k && (k = k.next = {
                lane: 0,
                action: l.action,
                hasEagerState: l.hasEagerState,
                eagerState: l.eagerState,
                next: null
            }), d = l.hasEagerState ? l.eagerState : a(d, l.action);
            else {
                var q = {
                    lane: m,
                    action: l.action,
                    hasEagerState: l.hasEagerState,
                    eagerState: l.eagerState,
                    next: null
                };
                null === k ? (h = k = q, g = d) : k = k.next = q;
                $3b825bc58ae06391$var$M.lanes |= m;
                $3b825bc58ae06391$var$rh |= m;
            }
            l = l.next;
        }while (null !== l && l !== f);
        null === k ? g = d : k.next = h;
        $3b825bc58ae06391$var$He(d, b.memoizedState) || ($3b825bc58ae06391$var$dh = !0);
        b.memoizedState = d;
        b.baseState = g;
        b.baseQueue = k;
        c.lastRenderedState = d;
    }
    a = c.interleaved;
    if (null !== a) {
        e = a;
        do f = e.lane, $3b825bc58ae06391$var$M.lanes |= f, $3b825bc58ae06391$var$rh |= f, e = e.next;
        while (e !== a);
    } else null === e && (c.lanes = 0);
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function $3b825bc58ae06391$var$Xh(a) {
    var b = $3b825bc58ae06391$var$Uh(), c = b.queue;
    if (null === c) throw Error($3b825bc58ae06391$var$p(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        $3b825bc58ae06391$var$He(f, b.memoizedState) || ($3b825bc58ae06391$var$dh = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function $3b825bc58ae06391$var$Yh() {}
function $3b825bc58ae06391$var$Zh(a, b) {
    var c = $3b825bc58ae06391$var$M, d = $3b825bc58ae06391$var$Uh(), e = b(), f = !$3b825bc58ae06391$var$He(d.memoizedState, e);
    f && (d.memoizedState = e, $3b825bc58ae06391$var$dh = !0);
    d = d.queue;
    $3b825bc58ae06391$var$$h($3b825bc58ae06391$var$ai.bind(null, c, d, a), [
        a
    ]);
    if (d.getSnapshot !== b || f || null !== $3b825bc58ae06391$var$O && $3b825bc58ae06391$var$O.memoizedState.tag & 1) {
        c.flags |= 2048;
        $3b825bc58ae06391$var$bi(9, $3b825bc58ae06391$var$ci.bind(null, c, d, e, b), void 0, null);
        if (null === $3b825bc58ae06391$var$Q) throw Error($3b825bc58ae06391$var$p(349));
        0 !== ($3b825bc58ae06391$var$Hh & 30) || $3b825bc58ae06391$var$di(c, b, e);
    }
    return e;
}
function $3b825bc58ae06391$var$di(a, b, c) {
    a.flags |= 16384;
    a = {
        getSnapshot: b,
        value: c
    };
    b = $3b825bc58ae06391$var$M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $3b825bc58ae06391$var$M.updateQueue = b, b.stores = [
        a
    ]) : (c = b.stores, null === c ? b.stores = [
        a
    ] : c.push(a));
}
function $3b825bc58ae06391$var$ci(a, b, c, d) {
    b.value = c;
    b.getSnapshot = d;
    $3b825bc58ae06391$var$ei(b) && $3b825bc58ae06391$var$fi(a);
}
function $3b825bc58ae06391$var$ai(a, b, c) {
    return c(function() {
        $3b825bc58ae06391$var$ei(b) && $3b825bc58ae06391$var$fi(a);
    });
}
function $3b825bc58ae06391$var$ei(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var c = b();
        return !$3b825bc58ae06391$var$He(a, c);
    } catch (d) {
        return !0;
    }
}
function $3b825bc58ae06391$var$fi(a) {
    var b = $3b825bc58ae06391$var$ih(a, 1);
    null !== b && $3b825bc58ae06391$var$gi(b, a, 1, -1);
}
function $3b825bc58ae06391$var$hi(a) {
    var b = $3b825bc58ae06391$var$Th();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = {
        pending: null,
        interleaved: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $3b825bc58ae06391$var$Vh,
        lastRenderedState: a
    };
    b.queue = a;
    a = a.dispatch = $3b825bc58ae06391$var$ii.bind(null, $3b825bc58ae06391$var$M, a);
    return [
        b.memoizedState,
        a
    ];
}
function $3b825bc58ae06391$var$bi(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = $3b825bc58ae06391$var$M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $3b825bc58ae06391$var$M.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function $3b825bc58ae06391$var$ji() {
    return $3b825bc58ae06391$var$Uh().memoizedState;
}
function $3b825bc58ae06391$var$ki(a, b, c, d) {
    var e = $3b825bc58ae06391$var$Th();
    $3b825bc58ae06391$var$M.flags |= a;
    e.memoizedState = $3b825bc58ae06391$var$bi(1 | b, c, void 0, void 0 === d ? null : d);
}
function $3b825bc58ae06391$var$li(a, b, c, d) {
    var e = $3b825bc58ae06391$var$Uh();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== $3b825bc58ae06391$var$N) {
        var g = $3b825bc58ae06391$var$N.memoizedState;
        f = g.destroy;
        if (null !== d && $3b825bc58ae06391$var$Mh(d, g.deps)) {
            e.memoizedState = $3b825bc58ae06391$var$bi(b, c, f, d);
            return;
        }
    }
    $3b825bc58ae06391$var$M.flags |= a;
    e.memoizedState = $3b825bc58ae06391$var$bi(1 | b, c, f, d);
}
function $3b825bc58ae06391$var$mi(a, b) {
    return $3b825bc58ae06391$var$ki(8390656, 8, a, b);
}
function $3b825bc58ae06391$var$$h(a, b) {
    return $3b825bc58ae06391$var$li(2048, 8, a, b);
}
function $3b825bc58ae06391$var$ni(a, b) {
    return $3b825bc58ae06391$var$li(4, 2, a, b);
}
function $3b825bc58ae06391$var$oi(a, b) {
    return $3b825bc58ae06391$var$li(4, 4, a, b);
}
function $3b825bc58ae06391$var$pi(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function $3b825bc58ae06391$var$qi(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return $3b825bc58ae06391$var$li(4, 4, $3b825bc58ae06391$var$pi.bind(null, b, a), c);
}
function $3b825bc58ae06391$var$ri() {}
function $3b825bc58ae06391$var$si(a, b) {
    var c = $3b825bc58ae06391$var$Uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $3b825bc58ae06391$var$Mh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $3b825bc58ae06391$var$ti(a, b) {
    var c = $3b825bc58ae06391$var$Uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $3b825bc58ae06391$var$Mh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $3b825bc58ae06391$var$ui(a, b, c) {
    if (0 === ($3b825bc58ae06391$var$Hh & 21)) return a.baseState && (a.baseState = !1, $3b825bc58ae06391$var$dh = !0), a.memoizedState = c;
    $3b825bc58ae06391$var$He(c, b) || (c = $3b825bc58ae06391$var$yc(), $3b825bc58ae06391$var$M.lanes |= c, $3b825bc58ae06391$var$rh |= c, a.baseState = !0);
    return b;
}
function $3b825bc58ae06391$var$vi(a, b) {
    var c = $3b825bc58ae06391$var$C;
    $3b825bc58ae06391$var$C = 0 !== c && 4 > c ? c : 4;
    a(!0);
    var d = $3b825bc58ae06391$var$Gh.transition;
    $3b825bc58ae06391$var$Gh.transition = {};
    try {
        a(!1), b();
    } finally{
        $3b825bc58ae06391$var$C = c, $3b825bc58ae06391$var$Gh.transition = d;
    }
}
function $3b825bc58ae06391$var$wi() {
    return $3b825bc58ae06391$var$Uh().memoizedState;
}
function $3b825bc58ae06391$var$xi(a, b, c) {
    var d = $3b825bc58ae06391$var$yi(a);
    c = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($3b825bc58ae06391$var$zi(a)) $3b825bc58ae06391$var$Ai(b, c);
    else if (c = $3b825bc58ae06391$var$hh(a, b, c, d), null !== c) {
        var e = $3b825bc58ae06391$var$R();
        $3b825bc58ae06391$var$gi(c, a, d, e);
        $3b825bc58ae06391$var$Bi(c, b, d);
    }
}
function $3b825bc58ae06391$var$ii(a, b, c) {
    var d = $3b825bc58ae06391$var$yi(a), e = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($3b825bc58ae06391$var$zi(a)) $3b825bc58ae06391$var$Ai(b, e);
    else {
        var f = a.alternate;
        if (0 === a.lanes && (null === f || 0 === f.lanes) && (f = b.lastRenderedReducer, null !== f)) try {
            var g = b.lastRenderedState, h = f(g, c);
            e.hasEagerState = !0;
            e.eagerState = h;
            if ($3b825bc58ae06391$var$He(h, g)) {
                var k = b.interleaved;
                null === k ? (e.next = e, $3b825bc58ae06391$var$gh(b)) : (e.next = k.next, k.next = e);
                b.interleaved = e;
                return;
            }
        } catch (l) {} finally{}
        c = $3b825bc58ae06391$var$hh(a, b, e, d);
        null !== c && (e = $3b825bc58ae06391$var$R(), $3b825bc58ae06391$var$gi(c, a, d, e), $3b825bc58ae06391$var$Bi(c, b, d));
    }
}
function $3b825bc58ae06391$var$zi(a) {
    var b = a.alternate;
    return a === $3b825bc58ae06391$var$M || null !== b && b === $3b825bc58ae06391$var$M;
}
function $3b825bc58ae06391$var$Ai(a, b) {
    $3b825bc58ae06391$var$Jh = $3b825bc58ae06391$var$Ih = !0;
    var c = a.pending;
    null === c ? b.next = b : (b.next = c.next, c.next = b);
    a.pending = b;
}
function $3b825bc58ae06391$var$Bi(a, b, c) {
    if (0 !== (c & 4194240)) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $3b825bc58ae06391$var$Cc(a, c);
    }
}
var $3b825bc58ae06391$var$Rh = {
    readContext: $3b825bc58ae06391$var$eh,
    useCallback: $3b825bc58ae06391$var$P,
    useContext: $3b825bc58ae06391$var$P,
    useEffect: $3b825bc58ae06391$var$P,
    useImperativeHandle: $3b825bc58ae06391$var$P,
    useInsertionEffect: $3b825bc58ae06391$var$P,
    useLayoutEffect: $3b825bc58ae06391$var$P,
    useMemo: $3b825bc58ae06391$var$P,
    useReducer: $3b825bc58ae06391$var$P,
    useRef: $3b825bc58ae06391$var$P,
    useState: $3b825bc58ae06391$var$P,
    useDebugValue: $3b825bc58ae06391$var$P,
    useDeferredValue: $3b825bc58ae06391$var$P,
    useTransition: $3b825bc58ae06391$var$P,
    useMutableSource: $3b825bc58ae06391$var$P,
    useSyncExternalStore: $3b825bc58ae06391$var$P,
    useId: $3b825bc58ae06391$var$P,
    unstable_isNewReconciler: !1
}, $3b825bc58ae06391$var$Oh = {
    readContext: $3b825bc58ae06391$var$eh,
    useCallback: function(a, b) {
        $3b825bc58ae06391$var$Th().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: $3b825bc58ae06391$var$eh,
    useEffect: $3b825bc58ae06391$var$mi,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return $3b825bc58ae06391$var$ki(4194308, 4, $3b825bc58ae06391$var$pi.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return $3b825bc58ae06391$var$ki(4194308, 4, a, b);
    },
    useInsertionEffect: function(a, b) {
        return $3b825bc58ae06391$var$ki(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = $3b825bc58ae06391$var$Th();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = $3b825bc58ae06391$var$Th();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = {
            pending: null,
            interleaved: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        d.queue = a;
        a = a.dispatch = $3b825bc58ae06391$var$xi.bind(null, $3b825bc58ae06391$var$M, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: function(a) {
        var b = $3b825bc58ae06391$var$Th();
        a = {
            current: a
        };
        return b.memoizedState = a;
    },
    useState: $3b825bc58ae06391$var$hi,
    useDebugValue: $3b825bc58ae06391$var$ri,
    useDeferredValue: function(a) {
        return $3b825bc58ae06391$var$Th().memoizedState = a;
    },
    useTransition: function() {
        var a = $3b825bc58ae06391$var$hi(!1), b = a[0];
        a = $3b825bc58ae06391$var$vi.bind(null, a[1]);
        $3b825bc58ae06391$var$Th().memoizedState = a;
        return [
            b,
            a
        ];
    },
    useMutableSource: function() {},
    useSyncExternalStore: function(a, b, c) {
        var d = $3b825bc58ae06391$var$M, e = $3b825bc58ae06391$var$Th();
        if ($3b825bc58ae06391$var$I) {
            if (void 0 === c) throw Error($3b825bc58ae06391$var$p(407));
            c = c();
        } else {
            c = b();
            if (null === $3b825bc58ae06391$var$Q) throw Error($3b825bc58ae06391$var$p(349));
            0 !== ($3b825bc58ae06391$var$Hh & 30) || $3b825bc58ae06391$var$di(d, b, c);
        }
        e.memoizedState = c;
        var f = {
            value: c,
            getSnapshot: b
        };
        e.queue = f;
        $3b825bc58ae06391$var$mi($3b825bc58ae06391$var$ai.bind(null, d, f, a), [
            a
        ]);
        d.flags |= 2048;
        $3b825bc58ae06391$var$bi(9, $3b825bc58ae06391$var$ci.bind(null, d, f, c, b), void 0, null);
        return c;
    },
    useId: function() {
        var a = $3b825bc58ae06391$var$Th(), b = $3b825bc58ae06391$var$Q.identifierPrefix;
        if ($3b825bc58ae06391$var$I) {
            var c = $3b825bc58ae06391$var$sg;
            var d = $3b825bc58ae06391$var$rg;
            c = (d & ~(1 << 32 - $3b825bc58ae06391$var$oc(d) - 1)).toString(32) + c;
            b = ":" + b + "R" + c;
            c = $3b825bc58ae06391$var$Kh++;
            0 < c && (b += "H" + c.toString(32));
            b += ":";
        } else c = $3b825bc58ae06391$var$Lh++, b = ":" + b + "r" + c.toString(32) + ":";
        return a.memoizedState = b;
    },
    unstable_isNewReconciler: !1
}, $3b825bc58ae06391$var$Ph = {
    readContext: $3b825bc58ae06391$var$eh,
    useCallback: $3b825bc58ae06391$var$si,
    useContext: $3b825bc58ae06391$var$eh,
    useEffect: $3b825bc58ae06391$var$$h,
    useImperativeHandle: $3b825bc58ae06391$var$qi,
    useInsertionEffect: $3b825bc58ae06391$var$ni,
    useLayoutEffect: $3b825bc58ae06391$var$oi,
    useMemo: $3b825bc58ae06391$var$ti,
    useReducer: $3b825bc58ae06391$var$Wh,
    useRef: $3b825bc58ae06391$var$ji,
    useState: function() {
        return $3b825bc58ae06391$var$Wh($3b825bc58ae06391$var$Vh);
    },
    useDebugValue: $3b825bc58ae06391$var$ri,
    useDeferredValue: function(a) {
        var b = $3b825bc58ae06391$var$Uh();
        return $3b825bc58ae06391$var$ui(b, $3b825bc58ae06391$var$N.memoizedState, a);
    },
    useTransition: function() {
        var a = $3b825bc58ae06391$var$Wh($3b825bc58ae06391$var$Vh)[0], b = $3b825bc58ae06391$var$Uh().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $3b825bc58ae06391$var$Yh,
    useSyncExternalStore: $3b825bc58ae06391$var$Zh,
    useId: $3b825bc58ae06391$var$wi,
    unstable_isNewReconciler: !1
}, $3b825bc58ae06391$var$Qh = {
    readContext: $3b825bc58ae06391$var$eh,
    useCallback: $3b825bc58ae06391$var$si,
    useContext: $3b825bc58ae06391$var$eh,
    useEffect: $3b825bc58ae06391$var$$h,
    useImperativeHandle: $3b825bc58ae06391$var$qi,
    useInsertionEffect: $3b825bc58ae06391$var$ni,
    useLayoutEffect: $3b825bc58ae06391$var$oi,
    useMemo: $3b825bc58ae06391$var$ti,
    useReducer: $3b825bc58ae06391$var$Xh,
    useRef: $3b825bc58ae06391$var$ji,
    useState: function() {
        return $3b825bc58ae06391$var$Xh($3b825bc58ae06391$var$Vh);
    },
    useDebugValue: $3b825bc58ae06391$var$ri,
    useDeferredValue: function(a) {
        var b = $3b825bc58ae06391$var$Uh();
        return null === $3b825bc58ae06391$var$N ? b.memoizedState = a : $3b825bc58ae06391$var$ui(b, $3b825bc58ae06391$var$N.memoizedState, a);
    },
    useTransition: function() {
        var a = $3b825bc58ae06391$var$Xh($3b825bc58ae06391$var$Vh)[0], b = $3b825bc58ae06391$var$Uh().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $3b825bc58ae06391$var$Yh,
    useSyncExternalStore: $3b825bc58ae06391$var$Zh,
    useId: $3b825bc58ae06391$var$wi,
    unstable_isNewReconciler: !1
};
function $3b825bc58ae06391$var$Ci(a, b) {
    if (a && a.defaultProps) {
        b = $3b825bc58ae06391$var$A({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
function $3b825bc58ae06391$var$Di(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $3b825bc58ae06391$var$A({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var $3b825bc58ae06391$var$Ei = {
    isMounted: function(a) {
        return (a = a._reactInternals) ? $3b825bc58ae06391$var$Vb(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternals;
        var d = $3b825bc58ae06391$var$R(), e = $3b825bc58ae06391$var$yi(a), f = $3b825bc58ae06391$var$mh(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $3b825bc58ae06391$var$nh(a, f, e);
        null !== b && ($3b825bc58ae06391$var$gi(b, a, e, d), $3b825bc58ae06391$var$oh(b, a, e));
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternals;
        var d = $3b825bc58ae06391$var$R(), e = $3b825bc58ae06391$var$yi(a), f = $3b825bc58ae06391$var$mh(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $3b825bc58ae06391$var$nh(a, f, e);
        null !== b && ($3b825bc58ae06391$var$gi(b, a, e, d), $3b825bc58ae06391$var$oh(b, a, e));
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternals;
        var c = $3b825bc58ae06391$var$R(), d = $3b825bc58ae06391$var$yi(a), e = $3b825bc58ae06391$var$mh(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        b = $3b825bc58ae06391$var$nh(a, e, d);
        null !== b && ($3b825bc58ae06391$var$gi(b, a, d, c), $3b825bc58ae06391$var$oh(b, a, d));
    }
};
function $3b825bc58ae06391$var$Fi(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !$3b825bc58ae06391$var$Ie(c, d) || !$3b825bc58ae06391$var$Ie(e, f) : !0;
}
function $3b825bc58ae06391$var$Gi(a, b, c) {
    var d = !1, e = $3b825bc58ae06391$var$Vf;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = $3b825bc58ae06391$var$eh(f) : (e = $3b825bc58ae06391$var$Zf(b) ? $3b825bc58ae06391$var$Xf : $3b825bc58ae06391$var$H.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? $3b825bc58ae06391$var$Yf(a, e) : $3b825bc58ae06391$var$Vf);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = $3b825bc58ae06391$var$Ei;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function $3b825bc58ae06391$var$Hi(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && $3b825bc58ae06391$var$Ei.enqueueReplaceState(b, b.state, null);
}
function $3b825bc58ae06391$var$Ii(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = {};
    $3b825bc58ae06391$var$kh(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = $3b825bc58ae06391$var$eh(f) : (f = $3b825bc58ae06391$var$Zf(b) ? $3b825bc58ae06391$var$Xf : $3b825bc58ae06391$var$H.current, e.context = $3b825bc58ae06391$var$Yf(a, f));
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && ($3b825bc58ae06391$var$Di(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && $3b825bc58ae06391$var$Ei.enqueueReplaceState(e, e.state, null), $3b825bc58ae06391$var$qh(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4194308);
}
function $3b825bc58ae06391$var$Ji(a, b) {
    try {
        var c = "", d = b;
        do c += $3b825bc58ae06391$var$Pa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e,
        digest: null
    };
}
function $3b825bc58ae06391$var$Ki(a, b, c) {
    return {
        value: a,
        source: null,
        stack: null != c ? c : null,
        digest: null != b ? b : null
    };
}
function $3b825bc58ae06391$var$Li(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var $3b825bc58ae06391$var$Mi = "function" === typeof WeakMap ? WeakMap : Map;
function $3b825bc58ae06391$var$Ni(a, b, c) {
    c = $3b825bc58ae06391$var$mh(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        $3b825bc58ae06391$var$Oi || ($3b825bc58ae06391$var$Oi = !0, $3b825bc58ae06391$var$Pi = d);
        $3b825bc58ae06391$var$Li(a, b);
    };
    return c;
}
function $3b825bc58ae06391$var$Qi(a, b, c) {
    c = $3b825bc58ae06391$var$mh(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            return d(e);
        };
        c.callback = function() {
            $3b825bc58ae06391$var$Li(a, b);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        $3b825bc58ae06391$var$Li(a, b);
        "function" !== typeof d && (null === $3b825bc58ae06391$var$Ri ? $3b825bc58ae06391$var$Ri = new Set([
            this
        ]) : $3b825bc58ae06391$var$Ri.add(this));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
function $3b825bc58ae06391$var$Si(a, b, c) {
    var d = a.pingCache;
    if (null === d) {
        d = a.pingCache = new $3b825bc58ae06391$var$Mi;
        var e = new Set;
        d.set(b, e);
    } else e = d.get(b), void 0 === e && (e = new Set, d.set(b, e));
    e.has(c) || (e.add(c), a = $3b825bc58ae06391$var$Ti.bind(null, a, b, c), b.then(a, a));
}
function $3b825bc58ae06391$var$Ui(a) {
    do {
        var b;
        if (b = 13 === a.tag) b = a.memoizedState, b = null !== b ? null !== b.dehydrated ? !0 : !1 : !0;
        if (b) return a;
        a = a.return;
    }while (null !== a);
    return null;
}
function $3b825bc58ae06391$var$Vi(a, b, c, d, e) {
    if (0 === (a.mode & 1)) return a === b ? a.flags |= 65536 : (a.flags |= 128, c.flags |= 131072, c.flags &= -52805, 1 === c.tag && (null === c.alternate ? c.tag = 17 : (b = $3b825bc58ae06391$var$mh(-1, 1), b.tag = 2, $3b825bc58ae06391$var$nh(c, b, 1))), c.lanes |= 1), a;
    a.flags |= 65536;
    a.lanes = e;
    return a;
}
var $3b825bc58ae06391$var$Wi = $3b825bc58ae06391$var$ua.ReactCurrentOwner, $3b825bc58ae06391$var$dh = !1;
function $3b825bc58ae06391$var$Xi(a, b, c, d) {
    b.child = null === a ? $3b825bc58ae06391$var$Vg(b, null, c, d) : $3b825bc58ae06391$var$Ug(b, a.child, c, d);
}
function $3b825bc58ae06391$var$Yi(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    $3b825bc58ae06391$var$ch(b, e);
    d = $3b825bc58ae06391$var$Nh(a, b, c, d, f, e);
    c = $3b825bc58ae06391$var$Sh();
    if (null !== a && !$3b825bc58ae06391$var$dh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $3b825bc58ae06391$var$Zi(a, b, e);
    $3b825bc58ae06391$var$I && c && $3b825bc58ae06391$var$vg(b);
    b.flags |= 1;
    $3b825bc58ae06391$var$Xi(a, b, d, e);
    return b.child;
}
function $3b825bc58ae06391$var$$i(a, b, c, d, e) {
    if (null === a) {
        var f = c.type;
        if ("function" === typeof f && !$3b825bc58ae06391$var$aj(f) && void 0 === f.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = f, $3b825bc58ae06391$var$bj(a, b, f, d, e);
        a = $3b825bc58ae06391$var$Rg(c.type, null, d, b, b.mode, e);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    f = a.child;
    if (0 === (a.lanes & e)) {
        var g = f.memoizedProps;
        c = c.compare;
        c = null !== c ? c : $3b825bc58ae06391$var$Ie;
        if (c(g, d) && a.ref === b.ref) return $3b825bc58ae06391$var$Zi(a, b, e);
    }
    b.flags |= 1;
    a = $3b825bc58ae06391$var$Pg(f, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function $3b825bc58ae06391$var$bj(a, b, c, d, e) {
    if (null !== a) {
        var f = a.memoizedProps;
        if ($3b825bc58ae06391$var$Ie(f, d) && a.ref === b.ref) {
            if ($3b825bc58ae06391$var$dh = !1, b.pendingProps = d = f, 0 !== (a.lanes & e)) 0 !== (a.flags & 131072) && ($3b825bc58ae06391$var$dh = !0);
            else return b.lanes = a.lanes, $3b825bc58ae06391$var$Zi(a, b, e);
        }
    }
    return $3b825bc58ae06391$var$cj(a, b, c, d, e);
}
function $3b825bc58ae06391$var$dj(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode) {
        if (0 === (b.mode & 1)) b.memoizedState = {
            baseLanes: 0,
            cachePool: null,
            transitions: null
        }, $3b825bc58ae06391$var$G($3b825bc58ae06391$var$ej, $3b825bc58ae06391$var$fj), $3b825bc58ae06391$var$fj |= c;
        else {
            if (0 === (c & 1073741824)) return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
                baseLanes: a,
                cachePool: null,
                transitions: null
            }, b.updateQueue = null, $3b825bc58ae06391$var$G($3b825bc58ae06391$var$ej, $3b825bc58ae06391$var$fj), $3b825bc58ae06391$var$fj |= a, null;
            b.memoizedState = {
                baseLanes: 0,
                cachePool: null,
                transitions: null
            };
            d = null !== f ? f.baseLanes : c;
            $3b825bc58ae06391$var$G($3b825bc58ae06391$var$ej, $3b825bc58ae06391$var$fj);
            $3b825bc58ae06391$var$fj |= d;
        }
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, $3b825bc58ae06391$var$G($3b825bc58ae06391$var$ej, $3b825bc58ae06391$var$fj), $3b825bc58ae06391$var$fj |= d;
    $3b825bc58ae06391$var$Xi(a, b, e, c);
    return b.child;
}
function $3b825bc58ae06391$var$gj(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 512, b.flags |= 2097152;
}
function $3b825bc58ae06391$var$cj(a, b, c, d, e) {
    var f = $3b825bc58ae06391$var$Zf(c) ? $3b825bc58ae06391$var$Xf : $3b825bc58ae06391$var$H.current;
    f = $3b825bc58ae06391$var$Yf(b, f);
    $3b825bc58ae06391$var$ch(b, e);
    c = $3b825bc58ae06391$var$Nh(a, b, c, d, f, e);
    d = $3b825bc58ae06391$var$Sh();
    if (null !== a && !$3b825bc58ae06391$var$dh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $3b825bc58ae06391$var$Zi(a, b, e);
    $3b825bc58ae06391$var$I && d && $3b825bc58ae06391$var$vg(b);
    b.flags |= 1;
    $3b825bc58ae06391$var$Xi(a, b, c, e);
    return b.child;
}
function $3b825bc58ae06391$var$hj(a, b, c, d, e) {
    if ($3b825bc58ae06391$var$Zf(c)) {
        var f = !0;
        $3b825bc58ae06391$var$cg(b);
    } else f = !1;
    $3b825bc58ae06391$var$ch(b, e);
    if (null === b.stateNode) $3b825bc58ae06391$var$ij(a, b), $3b825bc58ae06391$var$Gi(b, c, d), $3b825bc58ae06391$var$Ii(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = $3b825bc58ae06391$var$eh(l) : (l = $3b825bc58ae06391$var$Zf(c) ? $3b825bc58ae06391$var$Xf : $3b825bc58ae06391$var$H.current, l = $3b825bc58ae06391$var$Yf(b, l));
        var m = c.getDerivedStateFromProps, q = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate;
        q || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && $3b825bc58ae06391$var$Hi(b, g, d, l);
        $3b825bc58ae06391$var$jh = !1;
        var r = b.memoizedState;
        g.state = r;
        $3b825bc58ae06391$var$qh(b, d, g, e);
        k = b.memoizedState;
        h !== d || r !== k || $3b825bc58ae06391$var$Wf.current || $3b825bc58ae06391$var$jh ? ("function" === typeof m && ($3b825bc58ae06391$var$Di(b, c, m, d), k = b.memoizedState), (h = $3b825bc58ae06391$var$jh || $3b825bc58ae06391$var$Fi(b, c, h, d, r, k, l)) ? (q || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4194308)) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), d = !1);
    } else {
        g = b.stateNode;
        $3b825bc58ae06391$var$lh(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : $3b825bc58ae06391$var$Ci(b.type, h);
        g.props = l;
        q = b.pendingProps;
        r = g.context;
        k = c.contextType;
        "object" === typeof k && null !== k ? k = $3b825bc58ae06391$var$eh(k) : (k = $3b825bc58ae06391$var$Zf(c) ? $3b825bc58ae06391$var$Xf : $3b825bc58ae06391$var$H.current, k = $3b825bc58ae06391$var$Yf(b, k));
        var y = c.getDerivedStateFromProps;
        (m = "function" === typeof y || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== q || r !== k) && $3b825bc58ae06391$var$Hi(b, g, d, k);
        $3b825bc58ae06391$var$jh = !1;
        r = b.memoizedState;
        g.state = r;
        $3b825bc58ae06391$var$qh(b, d, g, e);
        var n = b.memoizedState;
        h !== q || r !== n || $3b825bc58ae06391$var$Wf.current || $3b825bc58ae06391$var$jh ? ("function" === typeof y && ($3b825bc58ae06391$var$Di(b, c, y, d), n = b.memoizedState), (l = $3b825bc58ae06391$var$jh || $3b825bc58ae06391$var$Fi(b, c, l, d, r, n, k) || !1) ? (m || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, n, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, n, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 1024)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), b.memoizedProps = d, b.memoizedState = n), g.props = d, g.state = n, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), d = !1);
    }
    return $3b825bc58ae06391$var$jj(a, b, c, d, f, e);
}
function $3b825bc58ae06391$var$jj(a, b, c, d, e, f) {
    $3b825bc58ae06391$var$gj(a, b);
    var g = 0 !== (b.flags & 128);
    if (!d && !g) return e && $3b825bc58ae06391$var$dg(b, c, !1), $3b825bc58ae06391$var$Zi(a, b, f);
    d = b.stateNode;
    $3b825bc58ae06391$var$Wi.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.flags |= 1;
    null !== a && g ? (b.child = $3b825bc58ae06391$var$Ug(b, a.child, null, f), b.child = $3b825bc58ae06391$var$Ug(b, null, h, f)) : $3b825bc58ae06391$var$Xi(a, b, h, f);
    b.memoizedState = d.state;
    e && $3b825bc58ae06391$var$dg(b, c, !0);
    return b.child;
}
function $3b825bc58ae06391$var$kj(a) {
    var b = a.stateNode;
    b.pendingContext ? $3b825bc58ae06391$var$ag(a, b.pendingContext, b.pendingContext !== b.context) : b.context && $3b825bc58ae06391$var$ag(a, b.context, !1);
    $3b825bc58ae06391$var$yh(a, b.containerInfo);
}
function $3b825bc58ae06391$var$lj(a, b, c, d, e) {
    $3b825bc58ae06391$var$Ig();
    $3b825bc58ae06391$var$Jg(e);
    b.flags |= 256;
    $3b825bc58ae06391$var$Xi(a, b, c, d);
    return b.child;
}
var $3b825bc58ae06391$var$mj = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0
};
function $3b825bc58ae06391$var$nj(a) {
    return {
        baseLanes: a,
        cachePool: null,
        transitions: null
    };
}
function $3b825bc58ae06391$var$oj(a, b, c) {
    var d = b.pendingProps, e = $3b825bc58ae06391$var$L.current, f = !1, g = 0 !== (b.flags & 128), h;
    (h = g) || (h = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    if (h) f = !0, b.flags &= -129;
    else if (null === a || null !== a.memoizedState) e |= 1;
    $3b825bc58ae06391$var$G($3b825bc58ae06391$var$L, e & 1);
    if (null === a) {
        $3b825bc58ae06391$var$Eg(b);
        a = b.memoizedState;
        if (null !== a && (a = a.dehydrated, null !== a)) return 0 === (b.mode & 1) ? b.lanes = 1 : "$!" === a.data ? b.lanes = 8 : b.lanes = 1073741824, null;
        g = d.children;
        a = d.fallback;
        return f ? (d = b.mode, f = b.child, g = {
            mode: "hidden",
            children: g
        }, 0 === (d & 1) && null !== f ? (f.childLanes = 0, f.pendingProps = g) : f = $3b825bc58ae06391$var$pj(g, d, 0, null), a = $3b825bc58ae06391$var$Tg(a, d, c, null), f.return = b, a.return = b, f.sibling = a, b.child = f, b.child.memoizedState = $3b825bc58ae06391$var$nj(c), b.memoizedState = $3b825bc58ae06391$var$mj, a) : $3b825bc58ae06391$var$qj(b, g);
    }
    e = a.memoizedState;
    if (null !== e && (h = e.dehydrated, null !== h)) return $3b825bc58ae06391$var$rj(a, b, g, d, h, e, c);
    if (f) {
        f = d.fallback;
        g = b.mode;
        e = a.child;
        h = e.sibling;
        var k = {
            mode: "hidden",
            children: d.children
        };
        0 === (g & 1) && b.child !== e ? (d = b.child, d.childLanes = 0, d.pendingProps = k, b.deletions = null) : (d = $3b825bc58ae06391$var$Pg(e, k), d.subtreeFlags = e.subtreeFlags & 14680064);
        null !== h ? f = $3b825bc58ae06391$var$Pg(h, f) : (f = $3b825bc58ae06391$var$Tg(f, g, c, null), f.flags |= 2);
        f.return = b;
        d.return = b;
        d.sibling = f;
        b.child = d;
        d = f;
        f = b.child;
        g = a.child.memoizedState;
        g = null === g ? $3b825bc58ae06391$var$nj(c) : {
            baseLanes: g.baseLanes | c,
            cachePool: null,
            transitions: g.transitions
        };
        f.memoizedState = g;
        f.childLanes = a.childLanes & ~c;
        b.memoizedState = $3b825bc58ae06391$var$mj;
        return d;
    }
    f = a.child;
    a = f.sibling;
    d = $3b825bc58ae06391$var$Pg(f, {
        mode: "visible",
        children: d.children
    });
    0 === (b.mode & 1) && (d.lanes = c);
    d.return = b;
    d.sibling = null;
    null !== a && (c = b.deletions, null === c ? (b.deletions = [
        a
    ], b.flags |= 16) : c.push(a));
    b.child = d;
    b.memoizedState = null;
    return d;
}
function $3b825bc58ae06391$var$qj(a, b) {
    b = $3b825bc58ae06391$var$pj({
        mode: "visible",
        children: b
    }, a.mode, 0, null);
    b.return = a;
    return a.child = b;
}
function $3b825bc58ae06391$var$sj(a, b, c, d) {
    null !== d && $3b825bc58ae06391$var$Jg(d);
    $3b825bc58ae06391$var$Ug(b, a.child, null, c);
    a = $3b825bc58ae06391$var$qj(b, b.pendingProps.children);
    a.flags |= 2;
    b.memoizedState = null;
    return a;
}
function $3b825bc58ae06391$var$rj(a, b, c, d, e, f, g) {
    if (c) {
        if (b.flags & 256) return b.flags &= -257, d = $3b825bc58ae06391$var$Ki(Error($3b825bc58ae06391$var$p(422))), $3b825bc58ae06391$var$sj(a, b, g, d);
        if (null !== b.memoizedState) return b.child = a.child, b.flags |= 128, null;
        f = d.fallback;
        e = b.mode;
        d = $3b825bc58ae06391$var$pj({
            mode: "visible",
            children: d.children
        }, e, 0, null);
        f = $3b825bc58ae06391$var$Tg(f, e, g, null);
        f.flags |= 2;
        d.return = b;
        f.return = b;
        d.sibling = f;
        b.child = d;
        0 !== (b.mode & 1) && $3b825bc58ae06391$var$Ug(b, a.child, null, g);
        b.child.memoizedState = $3b825bc58ae06391$var$nj(g);
        b.memoizedState = $3b825bc58ae06391$var$mj;
        return f;
    }
    if (0 === (b.mode & 1)) return $3b825bc58ae06391$var$sj(a, b, g, null);
    if ("$!" === e.data) {
        d = e.nextSibling && e.nextSibling.dataset;
        if (d) var h = d.dgst;
        d = h;
        f = Error($3b825bc58ae06391$var$p(419));
        d = $3b825bc58ae06391$var$Ki(f, d, void 0);
        return $3b825bc58ae06391$var$sj(a, b, g, d);
    }
    h = 0 !== (g & a.childLanes);
    if ($3b825bc58ae06391$var$dh || h) {
        d = $3b825bc58ae06391$var$Q;
        if (null !== d) {
            switch(g & -g){
                case 4:
                    e = 2;
                    break;
                case 16:
                    e = 8;
                    break;
                case 64:
                case 128:
                case 256:
                case 512:
                case 1024:
                case 2048:
                case 4096:
                case 8192:
                case 16384:
                case 32768:
                case 65536:
                case 131072:
                case 262144:
                case 524288:
                case 1048576:
                case 2097152:
                case 4194304:
                case 8388608:
                case 16777216:
                case 33554432:
                case 67108864:
                    e = 32;
                    break;
                case 536870912:
                    e = 268435456;
                    break;
                default:
                    e = 0;
            }
            e = 0 !== (e & (d.suspendedLanes | g)) ? 0 : e;
            0 !== e && e !== f.retryLane && (f.retryLane = e, $3b825bc58ae06391$var$ih(a, e), $3b825bc58ae06391$var$gi(d, a, e, -1));
        }
        $3b825bc58ae06391$var$tj();
        d = $3b825bc58ae06391$var$Ki(Error($3b825bc58ae06391$var$p(421)));
        return $3b825bc58ae06391$var$sj(a, b, g, d);
    }
    if ("$?" === e.data) return b.flags |= 128, b.child = a.child, b = $3b825bc58ae06391$var$uj.bind(null, a), e._reactRetry = b, null;
    a = f.treeContext;
    $3b825bc58ae06391$var$yg = $3b825bc58ae06391$var$Lf(e.nextSibling);
    $3b825bc58ae06391$var$xg = b;
    $3b825bc58ae06391$var$I = !0;
    $3b825bc58ae06391$var$zg = null;
    null !== a && ($3b825bc58ae06391$var$og[$3b825bc58ae06391$var$pg++] = $3b825bc58ae06391$var$rg, $3b825bc58ae06391$var$og[$3b825bc58ae06391$var$pg++] = $3b825bc58ae06391$var$sg, $3b825bc58ae06391$var$og[$3b825bc58ae06391$var$pg++] = $3b825bc58ae06391$var$qg, $3b825bc58ae06391$var$rg = a.id, $3b825bc58ae06391$var$sg = a.overflow, $3b825bc58ae06391$var$qg = b);
    b = $3b825bc58ae06391$var$qj(b, d.children);
    b.flags |= 4096;
    return b;
}
function $3b825bc58ae06391$var$vj(a, b, c) {
    a.lanes |= b;
    var d = a.alternate;
    null !== d && (d.lanes |= b);
    $3b825bc58ae06391$var$bh(a.return, b, c);
}
function $3b825bc58ae06391$var$wj(a, b, c, d, e) {
    var f = a.memoizedState;
    null === f ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e
    } : (f.isBackwards = b, f.rendering = null, f.renderingStartTime = 0, f.last = d, f.tail = c, f.tailMode = e);
}
function $3b825bc58ae06391$var$xj(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    $3b825bc58ae06391$var$Xi(a, b, d.children, c);
    d = $3b825bc58ae06391$var$L.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 128;
    else {
        if (null !== a && 0 !== (a.flags & 128)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && $3b825bc58ae06391$var$vj(a, c, b);
            else if (19 === a.tag) $3b825bc58ae06391$var$vj(a, c, b);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    $3b825bc58ae06391$var$G($3b825bc58ae06391$var$L, d);
    if (0 === (b.mode & 1)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === $3b825bc58ae06391$var$Ch(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            $3b825bc58ae06391$var$wj(b, !1, e, c, f);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === $3b825bc58ae06391$var$Ch(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            $3b825bc58ae06391$var$wj(b, !0, c, null, f);
            break;
        case "together":
            $3b825bc58ae06391$var$wj(b, !1, null, null, void 0);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function $3b825bc58ae06391$var$ij(a, b) {
    0 === (b.mode & 1) && null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
}
function $3b825bc58ae06391$var$Zi(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    $3b825bc58ae06391$var$rh |= b.lanes;
    if (0 === (c & b.childLanes)) return null;
    if (null !== a && b.child !== a.child) throw Error($3b825bc58ae06391$var$p(153));
    if (null !== b.child) {
        a = b.child;
        c = $3b825bc58ae06391$var$Pg(a, a.pendingProps);
        b.child = c;
        for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = $3b825bc58ae06391$var$Pg(a, a.pendingProps), c.return = b;
        c.sibling = null;
    }
    return b.child;
}
function $3b825bc58ae06391$var$yj(a, b, c) {
    switch(b.tag){
        case 3:
            $3b825bc58ae06391$var$kj(b);
            $3b825bc58ae06391$var$Ig();
            break;
        case 5:
            $3b825bc58ae06391$var$Ah(b);
            break;
        case 1:
            $3b825bc58ae06391$var$Zf(b.type) && $3b825bc58ae06391$var$cg(b);
            break;
        case 4:
            $3b825bc58ae06391$var$yh(b, b.stateNode.containerInfo);
            break;
        case 10:
            var d = b.type._context, e = b.memoizedProps.value;
            $3b825bc58ae06391$var$G($3b825bc58ae06391$var$Wg, d._currentValue);
            d._currentValue = e;
            break;
        case 13:
            d = b.memoizedState;
            if (null !== d) {
                if (null !== d.dehydrated) return $3b825bc58ae06391$var$G($3b825bc58ae06391$var$L, $3b825bc58ae06391$var$L.current & 1), b.flags |= 128, null;
                if (0 !== (c & b.child.childLanes)) return $3b825bc58ae06391$var$oj(a, b, c);
                $3b825bc58ae06391$var$G($3b825bc58ae06391$var$L, $3b825bc58ae06391$var$L.current & 1);
                a = $3b825bc58ae06391$var$Zi(a, b, c);
                return null !== a ? a.sibling : null;
            }
            $3b825bc58ae06391$var$G($3b825bc58ae06391$var$L, $3b825bc58ae06391$var$L.current & 1);
            break;
        case 19:
            d = 0 !== (c & b.childLanes);
            if (0 !== (a.flags & 128)) {
                if (d) return $3b825bc58ae06391$var$xj(a, b, c);
                b.flags |= 128;
            }
            e = b.memoizedState;
            null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
            $3b825bc58ae06391$var$G($3b825bc58ae06391$var$L, $3b825bc58ae06391$var$L.current);
            if (d) break;
            else return null;
        case 22:
        case 23:
            return b.lanes = 0, $3b825bc58ae06391$var$dj(a, b, c);
    }
    return $3b825bc58ae06391$var$Zi(a, b, c);
}
var $3b825bc58ae06391$var$zj, $3b825bc58ae06391$var$Aj, $3b825bc58ae06391$var$Bj, $3b825bc58ae06391$var$Cj;
$3b825bc58ae06391$var$zj = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
$3b825bc58ae06391$var$Aj = function() {};
$3b825bc58ae06391$var$Bj = function(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        $3b825bc58ae06391$var$xh($3b825bc58ae06391$var$uh.current);
        var f = null;
        switch(c){
            case "input":
                e = $3b825bc58ae06391$var$Ya(a, e);
                d = $3b825bc58ae06391$var$Ya(a, d);
                f = [];
                break;
            case "select":
                e = $3b825bc58ae06391$var$A({}, e, {
                    value: void 0
                });
                d = $3b825bc58ae06391$var$A({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = $3b825bc58ae06391$var$gb(a, e);
                d = $3b825bc58ae06391$var$gb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = $3b825bc58ae06391$var$Bf);
        }
        $3b825bc58ae06391$var$ub(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && ($3b825bc58ae06391$var$ea.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && ($3b825bc58ae06391$var$ea.hasOwnProperty(l) ? (null != k && "onScroll" === l && $3b825bc58ae06391$var$D("scroll", a), f || h === k || (f = [])) : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
$3b825bc58ae06391$var$Cj = function(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function $3b825bc58ae06391$var$Dj(a, b) {
    if (!$3b825bc58ae06391$var$I) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function $3b825bc58ae06391$var$S(a) {
    var b = null !== a.alternate && a.alternate.child === a.child, c = 0, d = 0;
    if (b) for(var e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags & 14680064, d |= e.flags & 14680064, e.return = a, e = e.sibling;
    else for(e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags, d |= e.flags, e.return = a, e = e.sibling;
    a.subtreeFlags |= d;
    a.childLanes = c;
    return b;
}
function $3b825bc58ae06391$var$Ej(a, b, c) {
    var d = b.pendingProps;
    $3b825bc58ae06391$var$wg(b);
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $3b825bc58ae06391$var$S(b), null;
        case 1:
            return $3b825bc58ae06391$var$Zf(b.type) && $3b825bc58ae06391$var$$f(), $3b825bc58ae06391$var$S(b), null;
        case 3:
            d = b.stateNode;
            $3b825bc58ae06391$var$zh();
            $3b825bc58ae06391$var$E($3b825bc58ae06391$var$Wf);
            $3b825bc58ae06391$var$E($3b825bc58ae06391$var$H);
            $3b825bc58ae06391$var$Eh();
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) $3b825bc58ae06391$var$Gg(b) ? b.flags |= 4 : null === a || a.memoizedState.isDehydrated && 0 === (b.flags & 256) || (b.flags |= 1024, null !== $3b825bc58ae06391$var$zg && ($3b825bc58ae06391$var$Fj($3b825bc58ae06391$var$zg), $3b825bc58ae06391$var$zg = null));
            $3b825bc58ae06391$var$Aj(a, b);
            $3b825bc58ae06391$var$S(b);
            return null;
        case 5:
            $3b825bc58ae06391$var$Bh(b);
            var e = $3b825bc58ae06391$var$xh($3b825bc58ae06391$var$wh.current);
            c = b.type;
            if (null !== a && null != b.stateNode) $3b825bc58ae06391$var$Bj(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error($3b825bc58ae06391$var$p(166));
                    $3b825bc58ae06391$var$S(b);
                    return null;
                }
                a = $3b825bc58ae06391$var$xh($3b825bc58ae06391$var$uh.current);
                if ($3b825bc58ae06391$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.type;
                    var f = b.memoizedProps;
                    d[$3b825bc58ae06391$var$Of] = b;
                    d[$3b825bc58ae06391$var$Pf] = f;
                    a = 0 !== (b.mode & 1);
                    switch(c){
                        case "dialog":
                            $3b825bc58ae06391$var$D("cancel", d);
                            $3b825bc58ae06391$var$D("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            $3b825bc58ae06391$var$D("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < $3b825bc58ae06391$var$lf.length; e++)$3b825bc58ae06391$var$D($3b825bc58ae06391$var$lf[e], d);
                            break;
                        case "source":
                            $3b825bc58ae06391$var$D("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            $3b825bc58ae06391$var$D("error", d);
                            $3b825bc58ae06391$var$D("load", d);
                            break;
                        case "details":
                            $3b825bc58ae06391$var$D("toggle", d);
                            break;
                        case "input":
                            $3b825bc58ae06391$var$Za(d, f);
                            $3b825bc58ae06391$var$D("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            $3b825bc58ae06391$var$D("invalid", d);
                            break;
                        case "textarea":
                            $3b825bc58ae06391$var$hb(d, f), $3b825bc58ae06391$var$D("invalid", d);
                    }
                    $3b825bc58ae06391$var$ub(c, f);
                    e = null;
                    for(var g in f)if (f.hasOwnProperty(g)) {
                        var h = f[g];
                        "children" === g ? "string" === typeof h ? d.textContent !== h && (!0 !== f.suppressHydrationWarning && $3b825bc58ae06391$var$Af(d.textContent, h, a), e = [
                            "children",
                            h
                        ]) : "number" === typeof h && d.textContent !== "" + h && (!0 !== f.suppressHydrationWarning && $3b825bc58ae06391$var$Af(d.textContent, h, a), e = [
                            "children",
                            "" + h
                        ]) : $3b825bc58ae06391$var$ea.hasOwnProperty(g) && null != h && "onScroll" === g && $3b825bc58ae06391$var$D("scroll", d);
                    }
                    switch(c){
                        case "input":
                            $3b825bc58ae06391$var$Va(d);
                            $3b825bc58ae06391$var$db(d, f, !0);
                            break;
                        case "textarea":
                            $3b825bc58ae06391$var$Va(d);
                            $3b825bc58ae06391$var$jb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = $3b825bc58ae06391$var$Bf);
                    }
                    d = e;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    "http://www.w3.org/1999/xhtml" === a && (a = $3b825bc58ae06391$var$kb(c));
                    "http://www.w3.org/1999/xhtml" === a ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script>\x3c/script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[$3b825bc58ae06391$var$Of] = b;
                    a[$3b825bc58ae06391$var$Pf] = d;
                    $3b825bc58ae06391$var$zj(a, b, !1, !1);
                    b.stateNode = a;
                    a: {
                        g = $3b825bc58ae06391$var$vb(c, d);
                        switch(c){
                            case "dialog":
                                $3b825bc58ae06391$var$D("cancel", a);
                                $3b825bc58ae06391$var$D("close", a);
                                e = d;
                                break;
                            case "iframe":
                            case "object":
                            case "embed":
                                $3b825bc58ae06391$var$D("load", a);
                                e = d;
                                break;
                            case "video":
                            case "audio":
                                for(e = 0; e < $3b825bc58ae06391$var$lf.length; e++)$3b825bc58ae06391$var$D($3b825bc58ae06391$var$lf[e], a);
                                e = d;
                                break;
                            case "source":
                                $3b825bc58ae06391$var$D("error", a);
                                e = d;
                                break;
                            case "img":
                            case "image":
                            case "link":
                                $3b825bc58ae06391$var$D("error", a);
                                $3b825bc58ae06391$var$D("load", a);
                                e = d;
                                break;
                            case "details":
                                $3b825bc58ae06391$var$D("toggle", a);
                                e = d;
                                break;
                            case "input":
                                $3b825bc58ae06391$var$Za(a, d);
                                e = $3b825bc58ae06391$var$Ya(a, d);
                                $3b825bc58ae06391$var$D("invalid", a);
                                break;
                            case "option":
                                e = d;
                                break;
                            case "select":
                                a._wrapperState = {
                                    wasMultiple: !!d.multiple
                                };
                                e = $3b825bc58ae06391$var$A({}, d, {
                                    value: void 0
                                });
                                $3b825bc58ae06391$var$D("invalid", a);
                                break;
                            case "textarea":
                                $3b825bc58ae06391$var$hb(a, d);
                                e = $3b825bc58ae06391$var$gb(a, d);
                                $3b825bc58ae06391$var$D("invalid", a);
                                break;
                            default:
                                e = d;
                        }
                        $3b825bc58ae06391$var$ub(c, e);
                        h = e;
                        for(f in h)if (h.hasOwnProperty(f)) {
                            var k = h[f];
                            "style" === f ? $3b825bc58ae06391$var$sb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && $3b825bc58ae06391$var$nb(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && $3b825bc58ae06391$var$ob(a, k) : "number" === typeof k && $3b825bc58ae06391$var$ob(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && ($3b825bc58ae06391$var$ea.hasOwnProperty(f) ? null != k && "onScroll" === f && $3b825bc58ae06391$var$D("scroll", a) : null != k && $3b825bc58ae06391$var$ta(a, f, k, g));
                        }
                        switch(c){
                            case "input":
                                $3b825bc58ae06391$var$Va(a);
                                $3b825bc58ae06391$var$db(a, d, !1);
                                break;
                            case "textarea":
                                $3b825bc58ae06391$var$Va(a);
                                $3b825bc58ae06391$var$jb(a);
                                break;
                            case "option":
                                null != d.value && a.setAttribute("value", "" + $3b825bc58ae06391$var$Sa(d.value));
                                break;
                            case "select":
                                a.multiple = !!d.multiple;
                                f = d.value;
                                null != f ? $3b825bc58ae06391$var$fb(a, !!d.multiple, f, !1) : null != d.defaultValue && $3b825bc58ae06391$var$fb(a, !!d.multiple, d.defaultValue, !0);
                                break;
                            default:
                                "function" === typeof e.onClick && (a.onclick = $3b825bc58ae06391$var$Bf);
                        }
                        switch(c){
                            case "button":
                            case "input":
                            case "select":
                            case "textarea":
                                d = !!d.autoFocus;
                                break a;
                            case "img":
                                d = !0;
                                break a;
                            default:
                                d = !1;
                        }
                    }
                    d && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            }
            $3b825bc58ae06391$var$S(b);
            return null;
        case 6:
            if (a && null != b.stateNode) $3b825bc58ae06391$var$Cj(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error($3b825bc58ae06391$var$p(166));
                c = $3b825bc58ae06391$var$xh($3b825bc58ae06391$var$wh.current);
                $3b825bc58ae06391$var$xh($3b825bc58ae06391$var$uh.current);
                if ($3b825bc58ae06391$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.memoizedProps;
                    d[$3b825bc58ae06391$var$Of] = b;
                    if (f = d.nodeValue !== c) {
                        if (a = $3b825bc58ae06391$var$xg, null !== a) switch(a.tag){
                            case 3:
                                $3b825bc58ae06391$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                                break;
                            case 5:
                                !0 !== a.memoizedProps.suppressHydrationWarning && $3b825bc58ae06391$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                        }
                    }
                    f && (b.flags |= 4);
                } else d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[$3b825bc58ae06391$var$Of] = b, b.stateNode = d;
            }
            $3b825bc58ae06391$var$S(b);
            return null;
        case 13:
            $3b825bc58ae06391$var$E($3b825bc58ae06391$var$L);
            d = b.memoizedState;
            if (null === a || null !== a.memoizedState && null !== a.memoizedState.dehydrated) {
                if ($3b825bc58ae06391$var$I && null !== $3b825bc58ae06391$var$yg && 0 !== (b.mode & 1) && 0 === (b.flags & 128)) $3b825bc58ae06391$var$Hg(), $3b825bc58ae06391$var$Ig(), b.flags |= 98560, f = !1;
                else if (f = $3b825bc58ae06391$var$Gg(b), null !== d && null !== d.dehydrated) {
                    if (null === a) {
                        if (!f) throw Error($3b825bc58ae06391$var$p(318));
                        f = b.memoizedState;
                        f = null !== f ? f.dehydrated : null;
                        if (!f) throw Error($3b825bc58ae06391$var$p(317));
                        f[$3b825bc58ae06391$var$Of] = b;
                    } else $3b825bc58ae06391$var$Ig(), 0 === (b.flags & 128) && (b.memoizedState = null), b.flags |= 4;
                    $3b825bc58ae06391$var$S(b);
                    f = !1;
                } else null !== $3b825bc58ae06391$var$zg && ($3b825bc58ae06391$var$Fj($3b825bc58ae06391$var$zg), $3b825bc58ae06391$var$zg = null), f = !0;
                if (!f) return b.flags & 65536 ? b : null;
            }
            if (0 !== (b.flags & 128)) return b.lanes = c, b;
            d = null !== d;
            d !== (null !== a && null !== a.memoizedState) && d && (b.child.flags |= 8192, 0 !== (b.mode & 1) && (null === a || 0 !== ($3b825bc58ae06391$var$L.current & 1) ? 0 === $3b825bc58ae06391$var$T && ($3b825bc58ae06391$var$T = 3) : $3b825bc58ae06391$var$tj()));
            null !== b.updateQueue && (b.flags |= 4);
            $3b825bc58ae06391$var$S(b);
            return null;
        case 4:
            return $3b825bc58ae06391$var$zh(), $3b825bc58ae06391$var$Aj(a, b), null === a && $3b825bc58ae06391$var$sf(b.stateNode.containerInfo), $3b825bc58ae06391$var$S(b), null;
        case 10:
            return $3b825bc58ae06391$var$ah(b.type._context), $3b825bc58ae06391$var$S(b), null;
        case 17:
            return $3b825bc58ae06391$var$Zf(b.type) && $3b825bc58ae06391$var$$f(), $3b825bc58ae06391$var$S(b), null;
        case 19:
            $3b825bc58ae06391$var$E($3b825bc58ae06391$var$L);
            f = b.memoizedState;
            if (null === f) return $3b825bc58ae06391$var$S(b), null;
            d = 0 !== (b.flags & 128);
            g = f.rendering;
            if (null === g) {
                if (d) $3b825bc58ae06391$var$Dj(f, !1);
                else {
                    if (0 !== $3b825bc58ae06391$var$T || null !== a && 0 !== (a.flags & 128)) for(a = b.child; null !== a;){
                        g = $3b825bc58ae06391$var$Ch(a);
                        if (null !== g) {
                            b.flags |= 128;
                            $3b825bc58ae06391$var$Dj(f, !1);
                            d = g.updateQueue;
                            null !== d && (b.updateQueue = d, b.flags |= 4);
                            b.subtreeFlags = 0;
                            d = c;
                            for(c = b.child; null !== c;)f = c, a = d, f.flags &= 14680066, g = f.alternate, null === g ? (f.childLanes = 0, f.lanes = a, f.child = null, f.subtreeFlags = 0, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null, f.stateNode = null) : (f.childLanes = g.childLanes, f.lanes = g.lanes, f.child = g.child, f.subtreeFlags = 0, f.deletions = null, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, f.type = g.type, a = g.dependencies, f.dependencies = null === a ? null : {
                                lanes: a.lanes,
                                firstContext: a.firstContext
                            }), c = c.sibling;
                            $3b825bc58ae06391$var$G($3b825bc58ae06391$var$L, $3b825bc58ae06391$var$L.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== f.tail && $3b825bc58ae06391$var$B() > $3b825bc58ae06391$var$Gj && (b.flags |= 128, d = !0, $3b825bc58ae06391$var$Dj(f, !1), b.lanes = 4194304);
                }
            } else {
                if (!d) {
                    if (a = $3b825bc58ae06391$var$Ch(g), null !== a) {
                        if (b.flags |= 128, d = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), $3b825bc58ae06391$var$Dj(f, !0), null === f.tail && "hidden" === f.tailMode && !g.alternate && !$3b825bc58ae06391$var$I) return $3b825bc58ae06391$var$S(b), null;
                    } else 2 * $3b825bc58ae06391$var$B() - f.renderingStartTime > $3b825bc58ae06391$var$Gj && 1073741824 !== c && (b.flags |= 128, d = !0, $3b825bc58ae06391$var$Dj(f, !1), b.lanes = 4194304);
                }
                f.isBackwards ? (g.sibling = b.child, b.child = g) : (c = f.last, null !== c ? c.sibling = g : b.child = g, f.last = g);
            }
            if (null !== f.tail) return b = f.tail, f.rendering = b, f.tail = b.sibling, f.renderingStartTime = $3b825bc58ae06391$var$B(), b.sibling = null, c = $3b825bc58ae06391$var$L.current, $3b825bc58ae06391$var$G($3b825bc58ae06391$var$L, d ? c & 1 | 2 : c & 1), b;
            $3b825bc58ae06391$var$S(b);
            return null;
        case 22:
        case 23:
            return $3b825bc58ae06391$var$Hj(), d = null !== b.memoizedState, null !== a && null !== a.memoizedState !== d && (b.flags |= 8192), d && 0 !== (b.mode & 1) ? 0 !== ($3b825bc58ae06391$var$fj & 1073741824) && ($3b825bc58ae06391$var$S(b), b.subtreeFlags & 6 && (b.flags |= 8192)) : $3b825bc58ae06391$var$S(b), null;
        case 24:
            return null;
        case 25:
            return null;
    }
    throw Error($3b825bc58ae06391$var$p(156, b.tag));
}
function $3b825bc58ae06391$var$Ij(a, b) {
    $3b825bc58ae06391$var$wg(b);
    switch(b.tag){
        case 1:
            return $3b825bc58ae06391$var$Zf(b.type) && $3b825bc58ae06391$var$$f(), a = b.flags, a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 3:
            return $3b825bc58ae06391$var$zh(), $3b825bc58ae06391$var$E($3b825bc58ae06391$var$Wf), $3b825bc58ae06391$var$E($3b825bc58ae06391$var$H), $3b825bc58ae06391$var$Eh(), a = b.flags, 0 !== (a & 65536) && 0 === (a & 128) ? (b.flags = a & -65537 | 128, b) : null;
        case 5:
            return $3b825bc58ae06391$var$Bh(b), null;
        case 13:
            $3b825bc58ae06391$var$E($3b825bc58ae06391$var$L);
            a = b.memoizedState;
            if (null !== a && null !== a.dehydrated) {
                if (null === b.alternate) throw Error($3b825bc58ae06391$var$p(340));
                $3b825bc58ae06391$var$Ig();
            }
            a = b.flags;
            return a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 19:
            return $3b825bc58ae06391$var$E($3b825bc58ae06391$var$L), null;
        case 4:
            return $3b825bc58ae06391$var$zh(), null;
        case 10:
            return $3b825bc58ae06391$var$ah(b.type._context), null;
        case 22:
        case 23:
            return $3b825bc58ae06391$var$Hj(), null;
        case 24:
            return null;
        default:
            return null;
    }
}
var $3b825bc58ae06391$var$Jj = !1, $3b825bc58ae06391$var$U = !1, $3b825bc58ae06391$var$Kj = "function" === typeof WeakSet ? WeakSet : Set, $3b825bc58ae06391$var$V = null;
function $3b825bc58ae06391$var$Lj(a, b) {
    var c = a.ref;
    if (null !== c) {
        if ("function" === typeof c) try {
            c(null);
        } catch (d) {
            $3b825bc58ae06391$var$W(a, b, d);
        }
        else c.current = null;
    }
}
function $3b825bc58ae06391$var$Mj(a, b, c) {
    try {
        c();
    } catch (d) {
        $3b825bc58ae06391$var$W(a, b, d);
    }
}
var $3b825bc58ae06391$var$Nj = !1;
function $3b825bc58ae06391$var$Oj(a, b) {
    $3b825bc58ae06391$var$Cf = $3b825bc58ae06391$var$dd;
    a = $3b825bc58ae06391$var$Me();
    if ($3b825bc58ae06391$var$Ne(a)) {
        if ("selectionStart" in a) var c = {
            start: a.selectionStart,
            end: a.selectionEnd
        };
        else a: {
            c = (c = a.ownerDocument) && c.defaultView || window;
            var d = c.getSelection && c.getSelection();
            if (d && 0 !== d.rangeCount) {
                c = d.anchorNode;
                var e = d.anchorOffset, f = d.focusNode;
                d = d.focusOffset;
                try {
                    c.nodeType, f.nodeType;
                } catch (F) {
                    c = null;
                    break a;
                }
                var g = 0, h = -1, k = -1, l = 0, m = 0, q = a, r = null;
                b: for(;;){
                    for(var y;;){
                        q !== c || 0 !== e && 3 !== q.nodeType || (h = g + e);
                        q !== f || 0 !== d && 3 !== q.nodeType || (k = g + d);
                        3 === q.nodeType && (g += q.nodeValue.length);
                        if (null === (y = q.firstChild)) break;
                        r = q;
                        q = y;
                    }
                    for(;;){
                        if (q === a) break b;
                        r === c && ++l === e && (h = g);
                        r === f && ++m === d && (k = g);
                        if (null !== (y = q.nextSibling)) break;
                        q = r;
                        r = q.parentNode;
                    }
                    q = y;
                }
                c = -1 === h || -1 === k ? null : {
                    start: h,
                    end: k
                };
            } else c = null;
        }
        c = c || {
            start: 0,
            end: 0
        };
    } else c = null;
    $3b825bc58ae06391$var$Df = {
        focusedElem: a,
        selectionRange: c
    };
    $3b825bc58ae06391$var$dd = !1;
    for($3b825bc58ae06391$var$V = b; null !== $3b825bc58ae06391$var$V;)if (b = $3b825bc58ae06391$var$V, a = b.child, 0 !== (b.subtreeFlags & 1028) && null !== a) a.return = b, $3b825bc58ae06391$var$V = a;
    else for(; null !== $3b825bc58ae06391$var$V;){
        b = $3b825bc58ae06391$var$V;
        try {
            var n = b.alternate;
            if (0 !== (b.flags & 1024)) switch(b.tag){
                case 0:
                case 11:
                case 15:
                    break;
                case 1:
                    if (null !== n) {
                        var t = n.memoizedProps, J = n.memoizedState, x = b.stateNode, w = x.getSnapshotBeforeUpdate(b.elementType === b.type ? t : $3b825bc58ae06391$var$Ci(b.type, t), J);
                        x.__reactInternalSnapshotBeforeUpdate = w;
                    }
                    break;
                case 3:
                    var u = b.stateNode.containerInfo;
                    1 === u.nodeType ? u.textContent = "" : 9 === u.nodeType && u.documentElement && u.removeChild(u.documentElement);
                    break;
                case 5:
                case 6:
                case 4:
                case 17:
                    break;
                default:
                    throw Error($3b825bc58ae06391$var$p(163));
            }
        } catch (F) {
            $3b825bc58ae06391$var$W(b, b.return, F);
        }
        a = b.sibling;
        if (null !== a) {
            a.return = b.return;
            $3b825bc58ae06391$var$V = a;
            break;
        }
        $3b825bc58ae06391$var$V = b.return;
    }
    n = $3b825bc58ae06391$var$Nj;
    $3b825bc58ae06391$var$Nj = !1;
    return n;
}
function $3b825bc58ae06391$var$Pj(a, b, c) {
    var d = b.updateQueue;
    d = null !== d ? d.lastEffect : null;
    if (null !== d) {
        var e = d = d.next;
        do {
            if ((e.tag & a) === a) {
                var f = e.destroy;
                e.destroy = void 0;
                void 0 !== f && $3b825bc58ae06391$var$Mj(b, c, f);
            }
            e = e.next;
        }while (e !== d);
    }
}
function $3b825bc58ae06391$var$Qj(a, b) {
    b = b.updateQueue;
    b = null !== b ? b.lastEffect : null;
    if (null !== b) {
        var c = b = b.next;
        do {
            if ((c.tag & a) === a) {
                var d = c.create;
                c.destroy = d();
            }
            c = c.next;
        }while (c !== b);
    }
}
function $3b825bc58ae06391$var$Rj(a) {
    var b = a.ref;
    if (null !== b) {
        var c = a.stateNode;
        switch(a.tag){
            case 5:
                a = c;
                break;
            default:
                a = c;
        }
        "function" === typeof b ? b(a) : b.current = a;
    }
}
function $3b825bc58ae06391$var$Sj(a) {
    var b = a.alternate;
    null !== b && (a.alternate = null, $3b825bc58ae06391$var$Sj(b));
    a.child = null;
    a.deletions = null;
    a.sibling = null;
    5 === a.tag && (b = a.stateNode, null !== b && (delete b[$3b825bc58ae06391$var$Of], delete b[$3b825bc58ae06391$var$Pf], delete b[$3b825bc58ae06391$var$of], delete b[$3b825bc58ae06391$var$Qf], delete b[$3b825bc58ae06391$var$Rf]));
    a.stateNode = null;
    a.return = null;
    a.dependencies = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.stateNode = null;
    a.updateQueue = null;
}
function $3b825bc58ae06391$var$Tj(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function $3b825bc58ae06391$var$Uj(a) {
    a: for(;;){
        for(; null === a.sibling;){
            if (null === a.return || $3b825bc58ae06391$var$Tj(a.return)) return null;
            a = a.return;
        }
        a.sibling.return = a.return;
        for(a = a.sibling; 5 !== a.tag && 6 !== a.tag && 18 !== a.tag;){
            if (a.flags & 2) continue a;
            if (null === a.child || 4 === a.tag) continue a;
            else a.child.return = a, a = a.child;
        }
        if (!(a.flags & 2)) return a.stateNode;
    }
}
function $3b825bc58ae06391$var$Vj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = $3b825bc58ae06391$var$Bf));
    else if (4 !== d && (a = a.child, null !== a)) for($3b825bc58ae06391$var$Vj(a, b, c), a = a.sibling; null !== a;)$3b825bc58ae06391$var$Vj(a, b, c), a = a.sibling;
}
function $3b825bc58ae06391$var$Wj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for($3b825bc58ae06391$var$Wj(a, b, c), a = a.sibling; null !== a;)$3b825bc58ae06391$var$Wj(a, b, c), a = a.sibling;
}
var $3b825bc58ae06391$var$X = null, $3b825bc58ae06391$var$Xj = !1;
function $3b825bc58ae06391$var$Yj(a, b, c) {
    for(c = c.child; null !== c;)$3b825bc58ae06391$var$Zj(a, b, c), c = c.sibling;
}
function $3b825bc58ae06391$var$Zj(a, b, c) {
    if ($3b825bc58ae06391$var$lc && "function" === typeof $3b825bc58ae06391$var$lc.onCommitFiberUnmount) try {
        $3b825bc58ae06391$var$lc.onCommitFiberUnmount($3b825bc58ae06391$var$kc, c);
    } catch (h) {}
    switch(c.tag){
        case 5:
            $3b825bc58ae06391$var$U || $3b825bc58ae06391$var$Lj(c, b);
        case 6:
            var d = $3b825bc58ae06391$var$X, e = $3b825bc58ae06391$var$Xj;
            $3b825bc58ae06391$var$X = null;
            $3b825bc58ae06391$var$Yj(a, b, c);
            $3b825bc58ae06391$var$X = d;
            $3b825bc58ae06391$var$Xj = e;
            null !== $3b825bc58ae06391$var$X && ($3b825bc58ae06391$var$Xj ? (a = $3b825bc58ae06391$var$X, c = c.stateNode, 8 === a.nodeType ? a.parentNode.removeChild(c) : a.removeChild(c)) : $3b825bc58ae06391$var$X.removeChild(c.stateNode));
            break;
        case 18:
            null !== $3b825bc58ae06391$var$X && ($3b825bc58ae06391$var$Xj ? (a = $3b825bc58ae06391$var$X, c = c.stateNode, 8 === a.nodeType ? $3b825bc58ae06391$var$Kf(a.parentNode, c) : 1 === a.nodeType && $3b825bc58ae06391$var$Kf(a, c), $3b825bc58ae06391$var$bd(a)) : $3b825bc58ae06391$var$Kf($3b825bc58ae06391$var$X, c.stateNode));
            break;
        case 4:
            d = $3b825bc58ae06391$var$X;
            e = $3b825bc58ae06391$var$Xj;
            $3b825bc58ae06391$var$X = c.stateNode.containerInfo;
            $3b825bc58ae06391$var$Xj = !0;
            $3b825bc58ae06391$var$Yj(a, b, c);
            $3b825bc58ae06391$var$X = d;
            $3b825bc58ae06391$var$Xj = e;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            if (!$3b825bc58ae06391$var$U && (d = c.updateQueue, null !== d && (d = d.lastEffect, null !== d))) {
                e = d = d.next;
                do {
                    var f = e, g = f.destroy;
                    f = f.tag;
                    void 0 !== g && (0 !== (f & 2) ? $3b825bc58ae06391$var$Mj(c, b, g) : 0 !== (f & 4) && $3b825bc58ae06391$var$Mj(c, b, g));
                    e = e.next;
                }while (e !== d);
            }
            $3b825bc58ae06391$var$Yj(a, b, c);
            break;
        case 1:
            if (!$3b825bc58ae06391$var$U && ($3b825bc58ae06391$var$Lj(c, b), d = c.stateNode, "function" === typeof d.componentWillUnmount)) try {
                d.props = c.memoizedProps, d.state = c.memoizedState, d.componentWillUnmount();
            } catch (h) {
                $3b825bc58ae06391$var$W(c, b, h);
            }
            $3b825bc58ae06391$var$Yj(a, b, c);
            break;
        case 21:
            $3b825bc58ae06391$var$Yj(a, b, c);
            break;
        case 22:
            c.mode & 1 ? ($3b825bc58ae06391$var$U = (d = $3b825bc58ae06391$var$U) || null !== c.memoizedState, $3b825bc58ae06391$var$Yj(a, b, c), $3b825bc58ae06391$var$U = d) : $3b825bc58ae06391$var$Yj(a, b, c);
            break;
        default:
            $3b825bc58ae06391$var$Yj(a, b, c);
    }
}
function $3b825bc58ae06391$var$ak(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new $3b825bc58ae06391$var$Kj);
        b.forEach(function(b) {
            var d = $3b825bc58ae06391$var$bk.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
function $3b825bc58ae06391$var$ck(a, b) {
    var c = b.deletions;
    if (null !== c) for(var d = 0; d < c.length; d++){
        var e = c[d];
        try {
            var f = a, g = b, h = g;
            a: for(; null !== h;){
                switch(h.tag){
                    case 5:
                        $3b825bc58ae06391$var$X = h.stateNode;
                        $3b825bc58ae06391$var$Xj = !1;
                        break a;
                    case 3:
                        $3b825bc58ae06391$var$X = h.stateNode.containerInfo;
                        $3b825bc58ae06391$var$Xj = !0;
                        break a;
                    case 4:
                        $3b825bc58ae06391$var$X = h.stateNode.containerInfo;
                        $3b825bc58ae06391$var$Xj = !0;
                        break a;
                }
                h = h.return;
            }
            if (null === $3b825bc58ae06391$var$X) throw Error($3b825bc58ae06391$var$p(160));
            $3b825bc58ae06391$var$Zj(f, g, e);
            $3b825bc58ae06391$var$X = null;
            $3b825bc58ae06391$var$Xj = !1;
            var k = e.alternate;
            null !== k && (k.return = null);
            e.return = null;
        } catch (l) {
            $3b825bc58ae06391$var$W(e, b, l);
        }
    }
    if (b.subtreeFlags & 12854) for(b = b.child; null !== b;)$3b825bc58ae06391$var$dk(b, a), b = b.sibling;
}
function $3b825bc58ae06391$var$dk(a, b) {
    var c = a.alternate, d = a.flags;
    switch(a.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $3b825bc58ae06391$var$ck(b, a);
            $3b825bc58ae06391$var$ek(a);
            if (d & 4) {
                try {
                    $3b825bc58ae06391$var$Pj(3, a, a.return), $3b825bc58ae06391$var$Qj(3, a);
                } catch (t) {
                    $3b825bc58ae06391$var$W(a, a.return, t);
                }
                try {
                    $3b825bc58ae06391$var$Pj(5, a, a.return);
                } catch (t) {
                    $3b825bc58ae06391$var$W(a, a.return, t);
                }
            }
            break;
        case 1:
            $3b825bc58ae06391$var$ck(b, a);
            $3b825bc58ae06391$var$ek(a);
            d & 512 && null !== c && $3b825bc58ae06391$var$Lj(c, c.return);
            break;
        case 5:
            $3b825bc58ae06391$var$ck(b, a);
            $3b825bc58ae06391$var$ek(a);
            d & 512 && null !== c && $3b825bc58ae06391$var$Lj(c, c.return);
            if (a.flags & 32) {
                var e = a.stateNode;
                try {
                    $3b825bc58ae06391$var$ob(e, "");
                } catch (t) {
                    $3b825bc58ae06391$var$W(a, a.return, t);
                }
            }
            if (d & 4 && (e = a.stateNode, null != e)) {
                var f = a.memoizedProps, g = null !== c ? c.memoizedProps : f, h = a.type, k = a.updateQueue;
                a.updateQueue = null;
                if (null !== k) try {
                    "input" === h && "radio" === f.type && null != f.name && $3b825bc58ae06391$var$ab(e, f);
                    $3b825bc58ae06391$var$vb(h, g);
                    var l = $3b825bc58ae06391$var$vb(h, f);
                    for(g = 0; g < k.length; g += 2){
                        var m = k[g], q = k[g + 1];
                        "style" === m ? $3b825bc58ae06391$var$sb(e, q) : "dangerouslySetInnerHTML" === m ? $3b825bc58ae06391$var$nb(e, q) : "children" === m ? $3b825bc58ae06391$var$ob(e, q) : $3b825bc58ae06391$var$ta(e, m, q, l);
                    }
                    switch(h){
                        case "input":
                            $3b825bc58ae06391$var$bb(e, f);
                            break;
                        case "textarea":
                            $3b825bc58ae06391$var$ib(e, f);
                            break;
                        case "select":
                            var r = e._wrapperState.wasMultiple;
                            e._wrapperState.wasMultiple = !!f.multiple;
                            var y = f.value;
                            null != y ? $3b825bc58ae06391$var$fb(e, !!f.multiple, y, !1) : r !== !!f.multiple && (null != f.defaultValue ? $3b825bc58ae06391$var$fb(e, !!f.multiple, f.defaultValue, !0) : $3b825bc58ae06391$var$fb(e, !!f.multiple, f.multiple ? [] : "", !1));
                    }
                    e[$3b825bc58ae06391$var$Pf] = f;
                } catch (t) {
                    $3b825bc58ae06391$var$W(a, a.return, t);
                }
            }
            break;
        case 6:
            $3b825bc58ae06391$var$ck(b, a);
            $3b825bc58ae06391$var$ek(a);
            if (d & 4) {
                if (null === a.stateNode) throw Error($3b825bc58ae06391$var$p(162));
                e = a.stateNode;
                f = a.memoizedProps;
                try {
                    e.nodeValue = f;
                } catch (t) {
                    $3b825bc58ae06391$var$W(a, a.return, t);
                }
            }
            break;
        case 3:
            $3b825bc58ae06391$var$ck(b, a);
            $3b825bc58ae06391$var$ek(a);
            if (d & 4 && null !== c && c.memoizedState.isDehydrated) try {
                $3b825bc58ae06391$var$bd(b.containerInfo);
            } catch (t) {
                $3b825bc58ae06391$var$W(a, a.return, t);
            }
            break;
        case 4:
            $3b825bc58ae06391$var$ck(b, a);
            $3b825bc58ae06391$var$ek(a);
            break;
        case 13:
            $3b825bc58ae06391$var$ck(b, a);
            $3b825bc58ae06391$var$ek(a);
            e = a.child;
            e.flags & 8192 && (f = null !== e.memoizedState, e.stateNode.isHidden = f, !f || null !== e.alternate && null !== e.alternate.memoizedState || ($3b825bc58ae06391$var$fk = $3b825bc58ae06391$var$B()));
            d & 4 && $3b825bc58ae06391$var$ak(a);
            break;
        case 22:
            m = null !== c && null !== c.memoizedState;
            a.mode & 1 ? ($3b825bc58ae06391$var$U = (l = $3b825bc58ae06391$var$U) || m, $3b825bc58ae06391$var$ck(b, a), $3b825bc58ae06391$var$U = l) : $3b825bc58ae06391$var$ck(b, a);
            $3b825bc58ae06391$var$ek(a);
            if (d & 8192) {
                l = null !== a.memoizedState;
                if ((a.stateNode.isHidden = l) && !m && 0 !== (a.mode & 1)) for($3b825bc58ae06391$var$V = a, m = a.child; null !== m;){
                    for(q = $3b825bc58ae06391$var$V = m; null !== $3b825bc58ae06391$var$V;){
                        r = $3b825bc58ae06391$var$V;
                        y = r.child;
                        switch(r.tag){
                            case 0:
                            case 11:
                            case 14:
                            case 15:
                                $3b825bc58ae06391$var$Pj(4, r, r.return);
                                break;
                            case 1:
                                $3b825bc58ae06391$var$Lj(r, r.return);
                                var n = r.stateNode;
                                if ("function" === typeof n.componentWillUnmount) {
                                    d = r;
                                    c = r.return;
                                    try {
                                        b = d, n.props = b.memoizedProps, n.state = b.memoizedState, n.componentWillUnmount();
                                    } catch (t) {
                                        $3b825bc58ae06391$var$W(d, c, t);
                                    }
                                }
                                break;
                            case 5:
                                $3b825bc58ae06391$var$Lj(r, r.return);
                                break;
                            case 22:
                                if (null !== r.memoizedState) {
                                    $3b825bc58ae06391$var$gk(q);
                                    continue;
                                }
                        }
                        null !== y ? (y.return = r, $3b825bc58ae06391$var$V = y) : $3b825bc58ae06391$var$gk(q);
                    }
                    m = m.sibling;
                }
                a: for(m = null, q = a;;){
                    if (5 === q.tag) {
                        if (null === m) {
                            m = q;
                            try {
                                e = q.stateNode, l ? (f = e.style, "function" === typeof f.setProperty ? f.setProperty("display", "none", "important") : f.display = "none") : (h = q.stateNode, k = q.memoizedProps.style, g = void 0 !== k && null !== k && k.hasOwnProperty("display") ? k.display : null, h.style.display = $3b825bc58ae06391$var$rb("display", g));
                            } catch (t) {
                                $3b825bc58ae06391$var$W(a, a.return, t);
                            }
                        }
                    } else if (6 === q.tag) {
                        if (null === m) try {
                            q.stateNode.nodeValue = l ? "" : q.memoizedProps;
                        } catch (t) {
                            $3b825bc58ae06391$var$W(a, a.return, t);
                        }
                    } else if ((22 !== q.tag && 23 !== q.tag || null === q.memoizedState || q === a) && null !== q.child) {
                        q.child.return = q;
                        q = q.child;
                        continue;
                    }
                    if (q === a) break a;
                    for(; null === q.sibling;){
                        if (null === q.return || q.return === a) break a;
                        m === q && (m = null);
                        q = q.return;
                    }
                    m === q && (m = null);
                    q.sibling.return = q.return;
                    q = q.sibling;
                }
            }
            break;
        case 19:
            $3b825bc58ae06391$var$ck(b, a);
            $3b825bc58ae06391$var$ek(a);
            d & 4 && $3b825bc58ae06391$var$ak(a);
            break;
        case 21:
            break;
        default:
            $3b825bc58ae06391$var$ck(b, a), $3b825bc58ae06391$var$ek(a);
    }
}
function $3b825bc58ae06391$var$ek(a) {
    var b = a.flags;
    if (b & 2) {
        try {
            a: {
                for(var c = a.return; null !== c;){
                    if ($3b825bc58ae06391$var$Tj(c)) {
                        var d = c;
                        break a;
                    }
                    c = c.return;
                }
                throw Error($3b825bc58ae06391$var$p(160));
            }
            switch(d.tag){
                case 5:
                    var e = d.stateNode;
                    d.flags & 32 && ($3b825bc58ae06391$var$ob(e, ""), d.flags &= -33);
                    var f = $3b825bc58ae06391$var$Uj(a);
                    $3b825bc58ae06391$var$Wj(a, f, e);
                    break;
                case 3:
                case 4:
                    var g = d.stateNode.containerInfo, h = $3b825bc58ae06391$var$Uj(a);
                    $3b825bc58ae06391$var$Vj(a, h, g);
                    break;
                default:
                    throw Error($3b825bc58ae06391$var$p(161));
            }
        } catch (k) {
            $3b825bc58ae06391$var$W(a, a.return, k);
        }
        a.flags &= -3;
    }
    b & 4096 && (a.flags &= -4097);
}
function $3b825bc58ae06391$var$hk(a, b, c) {
    $3b825bc58ae06391$var$V = a;
    $3b825bc58ae06391$var$ik(a, b, c);
}
function $3b825bc58ae06391$var$ik(a, b, c) {
    for(var d = 0 !== (a.mode & 1); null !== $3b825bc58ae06391$var$V;){
        var e = $3b825bc58ae06391$var$V, f = e.child;
        if (22 === e.tag && d) {
            var g = null !== e.memoizedState || $3b825bc58ae06391$var$Jj;
            if (!g) {
                var h = e.alternate, k = null !== h && null !== h.memoizedState || $3b825bc58ae06391$var$U;
                h = $3b825bc58ae06391$var$Jj;
                var l = $3b825bc58ae06391$var$U;
                $3b825bc58ae06391$var$Jj = g;
                if (($3b825bc58ae06391$var$U = k) && !l) for($3b825bc58ae06391$var$V = e; null !== $3b825bc58ae06391$var$V;)g = $3b825bc58ae06391$var$V, k = g.child, 22 === g.tag && null !== g.memoizedState ? $3b825bc58ae06391$var$jk(e) : null !== k ? (k.return = g, $3b825bc58ae06391$var$V = k) : $3b825bc58ae06391$var$jk(e);
                for(; null !== f;)$3b825bc58ae06391$var$V = f, $3b825bc58ae06391$var$ik(f, b, c), f = f.sibling;
                $3b825bc58ae06391$var$V = e;
                $3b825bc58ae06391$var$Jj = h;
                $3b825bc58ae06391$var$U = l;
            }
            $3b825bc58ae06391$var$kk(a, b, c);
        } else 0 !== (e.subtreeFlags & 8772) && null !== f ? (f.return = e, $3b825bc58ae06391$var$V = f) : $3b825bc58ae06391$var$kk(a, b, c);
    }
}
function $3b825bc58ae06391$var$kk(a) {
    for(; null !== $3b825bc58ae06391$var$V;){
        var b = $3b825bc58ae06391$var$V;
        if (0 !== (b.flags & 8772)) {
            var c = b.alternate;
            try {
                if (0 !== (b.flags & 8772)) switch(b.tag){
                    case 0:
                    case 11:
                    case 15:
                        $3b825bc58ae06391$var$U || $3b825bc58ae06391$var$Qj(5, b);
                        break;
                    case 1:
                        var d = b.stateNode;
                        if (b.flags & 4 && !$3b825bc58ae06391$var$U) {
                            if (null === c) d.componentDidMount();
                            else {
                                var e = b.elementType === b.type ? c.memoizedProps : $3b825bc58ae06391$var$Ci(b.type, c.memoizedProps);
                                d.componentDidUpdate(e, c.memoizedState, d.__reactInternalSnapshotBeforeUpdate);
                            }
                        }
                        var f = b.updateQueue;
                        null !== f && $3b825bc58ae06391$var$sh(b, f, d);
                        break;
                    case 3:
                        var g = b.updateQueue;
                        if (null !== g) {
                            c = null;
                            if (null !== b.child) switch(b.child.tag){
                                case 5:
                                    c = b.child.stateNode;
                                    break;
                                case 1:
                                    c = b.child.stateNode;
                            }
                            $3b825bc58ae06391$var$sh(b, g, c);
                        }
                        break;
                    case 5:
                        var h = b.stateNode;
                        if (null === c && b.flags & 4) {
                            c = h;
                            var k = b.memoizedProps;
                            switch(b.type){
                                case "button":
                                case "input":
                                case "select":
                                case "textarea":
                                    k.autoFocus && c.focus();
                                    break;
                                case "img":
                                    k.src && (c.src = k.src);
                            }
                        }
                        break;
                    case 6:
                        break;
                    case 4:
                        break;
                    case 12:
                        break;
                    case 13:
                        if (null === b.memoizedState) {
                            var l = b.alternate;
                            if (null !== l) {
                                var m = l.memoizedState;
                                if (null !== m) {
                                    var q = m.dehydrated;
                                    null !== q && $3b825bc58ae06391$var$bd(q);
                                }
                            }
                        }
                        break;
                    case 19:
                    case 17:
                    case 21:
                    case 22:
                    case 23:
                    case 25:
                        break;
                    default:
                        throw Error($3b825bc58ae06391$var$p(163));
                }
                $3b825bc58ae06391$var$U || b.flags & 512 && $3b825bc58ae06391$var$Rj(b);
            } catch (r) {
                $3b825bc58ae06391$var$W(b, b.return, r);
            }
        }
        if (b === a) {
            $3b825bc58ae06391$var$V = null;
            break;
        }
        c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $3b825bc58ae06391$var$V = c;
            break;
        }
        $3b825bc58ae06391$var$V = b.return;
    }
}
function $3b825bc58ae06391$var$gk(a) {
    for(; null !== $3b825bc58ae06391$var$V;){
        var b = $3b825bc58ae06391$var$V;
        if (b === a) {
            $3b825bc58ae06391$var$V = null;
            break;
        }
        var c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $3b825bc58ae06391$var$V = c;
            break;
        }
        $3b825bc58ae06391$var$V = b.return;
    }
}
function $3b825bc58ae06391$var$jk(a) {
    for(; null !== $3b825bc58ae06391$var$V;){
        var b = $3b825bc58ae06391$var$V;
        try {
            switch(b.tag){
                case 0:
                case 11:
                case 15:
                    var c = b.return;
                    try {
                        $3b825bc58ae06391$var$Qj(4, b);
                    } catch (k) {
                        $3b825bc58ae06391$var$W(b, c, k);
                    }
                    break;
                case 1:
                    var d = b.stateNode;
                    if ("function" === typeof d.componentDidMount) {
                        var e = b.return;
                        try {
                            d.componentDidMount();
                        } catch (k) {
                            $3b825bc58ae06391$var$W(b, e, k);
                        }
                    }
                    var f = b.return;
                    try {
                        $3b825bc58ae06391$var$Rj(b);
                    } catch (k) {
                        $3b825bc58ae06391$var$W(b, f, k);
                    }
                    break;
                case 5:
                    var g = b.return;
                    try {
                        $3b825bc58ae06391$var$Rj(b);
                    } catch (k) {
                        $3b825bc58ae06391$var$W(b, g, k);
                    }
            }
        } catch (k) {
            $3b825bc58ae06391$var$W(b, b.return, k);
        }
        if (b === a) {
            $3b825bc58ae06391$var$V = null;
            break;
        }
        var h = b.sibling;
        if (null !== h) {
            h.return = b.return;
            $3b825bc58ae06391$var$V = h;
            break;
        }
        $3b825bc58ae06391$var$V = b.return;
    }
}
var $3b825bc58ae06391$var$lk = Math.ceil, $3b825bc58ae06391$var$mk = $3b825bc58ae06391$var$ua.ReactCurrentDispatcher, $3b825bc58ae06391$var$nk = $3b825bc58ae06391$var$ua.ReactCurrentOwner, $3b825bc58ae06391$var$ok = $3b825bc58ae06391$var$ua.ReactCurrentBatchConfig, $3b825bc58ae06391$var$K = 0, $3b825bc58ae06391$var$Q = null, $3b825bc58ae06391$var$Y = null, $3b825bc58ae06391$var$Z = 0, $3b825bc58ae06391$var$fj = 0, $3b825bc58ae06391$var$ej = $3b825bc58ae06391$var$Uf(0), $3b825bc58ae06391$var$T = 0, $3b825bc58ae06391$var$pk = null, $3b825bc58ae06391$var$rh = 0, $3b825bc58ae06391$var$qk = 0, $3b825bc58ae06391$var$rk = 0, $3b825bc58ae06391$var$sk = null, $3b825bc58ae06391$var$tk = null, $3b825bc58ae06391$var$fk = 0, $3b825bc58ae06391$var$Gj = Infinity, $3b825bc58ae06391$var$uk = null, $3b825bc58ae06391$var$Oi = !1, $3b825bc58ae06391$var$Pi = null, $3b825bc58ae06391$var$Ri = null, $3b825bc58ae06391$var$vk = !1, $3b825bc58ae06391$var$wk = null, $3b825bc58ae06391$var$xk = 0, $3b825bc58ae06391$var$yk = 0, $3b825bc58ae06391$var$zk = null, $3b825bc58ae06391$var$Ak = -1, $3b825bc58ae06391$var$Bk = 0;
function $3b825bc58ae06391$var$R() {
    return 0 !== ($3b825bc58ae06391$var$K & 6) ? $3b825bc58ae06391$var$B() : -1 !== $3b825bc58ae06391$var$Ak ? $3b825bc58ae06391$var$Ak : $3b825bc58ae06391$var$Ak = $3b825bc58ae06391$var$B();
}
function $3b825bc58ae06391$var$yi(a) {
    if (0 === (a.mode & 1)) return 1;
    if (0 !== ($3b825bc58ae06391$var$K & 2) && 0 !== $3b825bc58ae06391$var$Z) return $3b825bc58ae06391$var$Z & -$3b825bc58ae06391$var$Z;
    if (null !== $3b825bc58ae06391$var$Kg.transition) return 0 === $3b825bc58ae06391$var$Bk && ($3b825bc58ae06391$var$Bk = $3b825bc58ae06391$var$yc()), $3b825bc58ae06391$var$Bk;
    a = $3b825bc58ae06391$var$C;
    if (0 !== a) return a;
    a = window.event;
    a = void 0 === a ? 16 : $3b825bc58ae06391$var$jd(a.type);
    return a;
}
function $3b825bc58ae06391$var$gi(a, b, c, d) {
    if (50 < $3b825bc58ae06391$var$yk) throw $3b825bc58ae06391$var$yk = 0, $3b825bc58ae06391$var$zk = null, Error($3b825bc58ae06391$var$p(185));
    $3b825bc58ae06391$var$Ac(a, c, d);
    if (0 === ($3b825bc58ae06391$var$K & 2) || a !== $3b825bc58ae06391$var$Q) a === $3b825bc58ae06391$var$Q && (0 === ($3b825bc58ae06391$var$K & 2) && ($3b825bc58ae06391$var$qk |= c), 4 === $3b825bc58ae06391$var$T && $3b825bc58ae06391$var$Ck(a, $3b825bc58ae06391$var$Z)), $3b825bc58ae06391$var$Dk(a, d), 1 === c && 0 === $3b825bc58ae06391$var$K && 0 === (b.mode & 1) && ($3b825bc58ae06391$var$Gj = $3b825bc58ae06391$var$B() + 500, $3b825bc58ae06391$var$fg && $3b825bc58ae06391$var$jg());
}
function $3b825bc58ae06391$var$Dk(a, b) {
    var c = a.callbackNode;
    $3b825bc58ae06391$var$wc(a, b);
    var d = $3b825bc58ae06391$var$uc(a, a === $3b825bc58ae06391$var$Q ? $3b825bc58ae06391$var$Z : 0);
    if (0 === d) null !== c && $3b825bc58ae06391$var$bc(c), a.callbackNode = null, a.callbackPriority = 0;
    else if (b = d & -d, a.callbackPriority !== b) {
        null != c && $3b825bc58ae06391$var$bc(c);
        if (1 === b) 0 === a.tag ? $3b825bc58ae06391$var$ig($3b825bc58ae06391$var$Ek.bind(null, a)) : $3b825bc58ae06391$var$hg($3b825bc58ae06391$var$Ek.bind(null, a)), $3b825bc58ae06391$var$Jf(function() {
            0 === ($3b825bc58ae06391$var$K & 6) && $3b825bc58ae06391$var$jg();
        }), c = null;
        else {
            switch($3b825bc58ae06391$var$Dc(d)){
                case 1:
                    c = $3b825bc58ae06391$var$fc;
                    break;
                case 4:
                    c = $3b825bc58ae06391$var$gc;
                    break;
                case 16:
                    c = $3b825bc58ae06391$var$hc;
                    break;
                case 536870912:
                    c = $3b825bc58ae06391$var$jc;
                    break;
                default:
                    c = $3b825bc58ae06391$var$hc;
            }
            c = $3b825bc58ae06391$var$Fk(c, $3b825bc58ae06391$var$Gk.bind(null, a));
        }
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function $3b825bc58ae06391$var$Gk(a, b) {
    $3b825bc58ae06391$var$Ak = -1;
    $3b825bc58ae06391$var$Bk = 0;
    if (0 !== ($3b825bc58ae06391$var$K & 6)) throw Error($3b825bc58ae06391$var$p(327));
    var c = a.callbackNode;
    if ($3b825bc58ae06391$var$Hk() && a.callbackNode !== c) return null;
    var d = $3b825bc58ae06391$var$uc(a, a === $3b825bc58ae06391$var$Q ? $3b825bc58ae06391$var$Z : 0);
    if (0 === d) return null;
    if (0 !== (d & 30) || 0 !== (d & a.expiredLanes) || b) b = $3b825bc58ae06391$var$Ik(a, d);
    else {
        b = d;
        var e = $3b825bc58ae06391$var$K;
        $3b825bc58ae06391$var$K |= 2;
        var f = $3b825bc58ae06391$var$Jk();
        if ($3b825bc58ae06391$var$Q !== a || $3b825bc58ae06391$var$Z !== b) $3b825bc58ae06391$var$uk = null, $3b825bc58ae06391$var$Gj = $3b825bc58ae06391$var$B() + 500, $3b825bc58ae06391$var$Kk(a, b);
        for(;;)try {
            $3b825bc58ae06391$var$Lk();
            break;
        } catch (h) {
            $3b825bc58ae06391$var$Mk(a, h);
        }
        $3b825bc58ae06391$var$$g();
        $3b825bc58ae06391$var$mk.current = f;
        $3b825bc58ae06391$var$K = e;
        null !== $3b825bc58ae06391$var$Y ? b = 0 : ($3b825bc58ae06391$var$Q = null, $3b825bc58ae06391$var$Z = 0, b = $3b825bc58ae06391$var$T);
    }
    if (0 !== b) {
        2 === b && (e = $3b825bc58ae06391$var$xc(a), 0 !== e && (d = e, b = $3b825bc58ae06391$var$Nk(a, e)));
        if (1 === b) throw c = $3b825bc58ae06391$var$pk, $3b825bc58ae06391$var$Kk(a, 0), $3b825bc58ae06391$var$Ck(a, d), $3b825bc58ae06391$var$Dk(a, $3b825bc58ae06391$var$B()), c;
        if (6 === b) $3b825bc58ae06391$var$Ck(a, d);
        else {
            e = a.current.alternate;
            if (0 === (d & 30) && !$3b825bc58ae06391$var$Ok(e) && (b = $3b825bc58ae06391$var$Ik(a, d), 2 === b && (f = $3b825bc58ae06391$var$xc(a), 0 !== f && (d = f, b = $3b825bc58ae06391$var$Nk(a, f))), 1 === b)) throw c = $3b825bc58ae06391$var$pk, $3b825bc58ae06391$var$Kk(a, 0), $3b825bc58ae06391$var$Ck(a, d), $3b825bc58ae06391$var$Dk(a, $3b825bc58ae06391$var$B()), c;
            a.finishedWork = e;
            a.finishedLanes = d;
            switch(b){
                case 0:
                case 1:
                    throw Error($3b825bc58ae06391$var$p(345));
                case 2:
                    $3b825bc58ae06391$var$Pk(a, $3b825bc58ae06391$var$tk, $3b825bc58ae06391$var$uk);
                    break;
                case 3:
                    $3b825bc58ae06391$var$Ck(a, d);
                    if ((d & 130023424) === d && (b = $3b825bc58ae06391$var$fk + 500 - $3b825bc58ae06391$var$B(), 10 < b)) {
                        if (0 !== $3b825bc58ae06391$var$uc(a, 0)) break;
                        e = a.suspendedLanes;
                        if ((e & d) !== d) {
                            $3b825bc58ae06391$var$R();
                            a.pingedLanes |= a.suspendedLanes & e;
                            break;
                        }
                        a.timeoutHandle = $3b825bc58ae06391$var$Ff($3b825bc58ae06391$var$Pk.bind(null, a, $3b825bc58ae06391$var$tk, $3b825bc58ae06391$var$uk), b);
                        break;
                    }
                    $3b825bc58ae06391$var$Pk(a, $3b825bc58ae06391$var$tk, $3b825bc58ae06391$var$uk);
                    break;
                case 4:
                    $3b825bc58ae06391$var$Ck(a, d);
                    if ((d & 4194240) === d) break;
                    b = a.eventTimes;
                    for(e = -1; 0 < d;){
                        var g = 31 - $3b825bc58ae06391$var$oc(d);
                        f = 1 << g;
                        g = b[g];
                        g > e && (e = g);
                        d &= ~f;
                    }
                    d = e;
                    d = $3b825bc58ae06391$var$B() - d;
                    d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * $3b825bc58ae06391$var$lk(d / 1960)) - d;
                    if (10 < d) {
                        a.timeoutHandle = $3b825bc58ae06391$var$Ff($3b825bc58ae06391$var$Pk.bind(null, a, $3b825bc58ae06391$var$tk, $3b825bc58ae06391$var$uk), d);
                        break;
                    }
                    $3b825bc58ae06391$var$Pk(a, $3b825bc58ae06391$var$tk, $3b825bc58ae06391$var$uk);
                    break;
                case 5:
                    $3b825bc58ae06391$var$Pk(a, $3b825bc58ae06391$var$tk, $3b825bc58ae06391$var$uk);
                    break;
                default:
                    throw Error($3b825bc58ae06391$var$p(329));
            }
        }
    }
    $3b825bc58ae06391$var$Dk(a, $3b825bc58ae06391$var$B());
    return a.callbackNode === c ? $3b825bc58ae06391$var$Gk.bind(null, a) : null;
}
function $3b825bc58ae06391$var$Nk(a, b) {
    var c = $3b825bc58ae06391$var$sk;
    a.current.memoizedState.isDehydrated && ($3b825bc58ae06391$var$Kk(a, b).flags |= 256);
    a = $3b825bc58ae06391$var$Ik(a, b);
    2 !== a && (b = $3b825bc58ae06391$var$tk, $3b825bc58ae06391$var$tk = c, null !== b && $3b825bc58ae06391$var$Fj(b));
    return a;
}
function $3b825bc58ae06391$var$Fj(a) {
    null === $3b825bc58ae06391$var$tk ? $3b825bc58ae06391$var$tk = a : $3b825bc58ae06391$var$tk.push.apply($3b825bc58ae06391$var$tk, a);
}
function $3b825bc58ae06391$var$Ok(a) {
    for(var b = a;;){
        if (b.flags & 16384) {
            var c = b.updateQueue;
            if (null !== c && (c = c.stores, null !== c)) for(var d = 0; d < c.length; d++){
                var e = c[d], f = e.getSnapshot;
                e = e.value;
                try {
                    if (!$3b825bc58ae06391$var$He(f(), e)) return !1;
                } catch (g) {
                    return !1;
                }
            }
        }
        c = b.child;
        if (b.subtreeFlags & 16384 && null !== c) c.return = b, b = c;
        else {
            if (b === a) break;
            for(; null === b.sibling;){
                if (null === b.return || b.return === a) return !0;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return !0;
}
function $3b825bc58ae06391$var$Ck(a, b) {
    b &= ~$3b825bc58ae06391$var$rk;
    b &= ~$3b825bc58ae06391$var$qk;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - $3b825bc58ae06391$var$oc(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function $3b825bc58ae06391$var$Ek(a) {
    if (0 !== ($3b825bc58ae06391$var$K & 6)) throw Error($3b825bc58ae06391$var$p(327));
    $3b825bc58ae06391$var$Hk();
    var b = $3b825bc58ae06391$var$uc(a, 0);
    if (0 === (b & 1)) return $3b825bc58ae06391$var$Dk(a, $3b825bc58ae06391$var$B()), null;
    var c = $3b825bc58ae06391$var$Ik(a, b);
    if (0 !== a.tag && 2 === c) {
        var d = $3b825bc58ae06391$var$xc(a);
        0 !== d && (b = d, c = $3b825bc58ae06391$var$Nk(a, d));
    }
    if (1 === c) throw c = $3b825bc58ae06391$var$pk, $3b825bc58ae06391$var$Kk(a, 0), $3b825bc58ae06391$var$Ck(a, b), $3b825bc58ae06391$var$Dk(a, $3b825bc58ae06391$var$B()), c;
    if (6 === c) throw Error($3b825bc58ae06391$var$p(345));
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    $3b825bc58ae06391$var$Pk(a, $3b825bc58ae06391$var$tk, $3b825bc58ae06391$var$uk);
    $3b825bc58ae06391$var$Dk(a, $3b825bc58ae06391$var$B());
    return null;
}
function $3b825bc58ae06391$var$Qk(a, b) {
    var c = $3b825bc58ae06391$var$K;
    $3b825bc58ae06391$var$K |= 1;
    try {
        return a(b);
    } finally{
        $3b825bc58ae06391$var$K = c, 0 === $3b825bc58ae06391$var$K && ($3b825bc58ae06391$var$Gj = $3b825bc58ae06391$var$B() + 500, $3b825bc58ae06391$var$fg && $3b825bc58ae06391$var$jg());
    }
}
function $3b825bc58ae06391$var$Rk(a) {
    null !== $3b825bc58ae06391$var$wk && 0 === $3b825bc58ae06391$var$wk.tag && 0 === ($3b825bc58ae06391$var$K & 6) && $3b825bc58ae06391$var$Hk();
    var b = $3b825bc58ae06391$var$K;
    $3b825bc58ae06391$var$K |= 1;
    var c = $3b825bc58ae06391$var$ok.transition, d = $3b825bc58ae06391$var$C;
    try {
        if ($3b825bc58ae06391$var$ok.transition = null, $3b825bc58ae06391$var$C = 1, a) return a();
    } finally{
        $3b825bc58ae06391$var$C = d, $3b825bc58ae06391$var$ok.transition = c, $3b825bc58ae06391$var$K = b, 0 === ($3b825bc58ae06391$var$K & 6) && $3b825bc58ae06391$var$jg();
    }
}
function $3b825bc58ae06391$var$Hj() {
    $3b825bc58ae06391$var$fj = $3b825bc58ae06391$var$ej.current;
    $3b825bc58ae06391$var$E($3b825bc58ae06391$var$ej);
}
function $3b825bc58ae06391$var$Kk(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, $3b825bc58ae06391$var$Gf(c));
    if (null !== $3b825bc58ae06391$var$Y) for(c = $3b825bc58ae06391$var$Y.return; null !== c;){
        var d = c;
        $3b825bc58ae06391$var$wg(d);
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && $3b825bc58ae06391$var$$f();
                break;
            case 3:
                $3b825bc58ae06391$var$zh();
                $3b825bc58ae06391$var$E($3b825bc58ae06391$var$Wf);
                $3b825bc58ae06391$var$E($3b825bc58ae06391$var$H);
                $3b825bc58ae06391$var$Eh();
                break;
            case 5:
                $3b825bc58ae06391$var$Bh(d);
                break;
            case 4:
                $3b825bc58ae06391$var$zh();
                break;
            case 13:
                $3b825bc58ae06391$var$E($3b825bc58ae06391$var$L);
                break;
            case 19:
                $3b825bc58ae06391$var$E($3b825bc58ae06391$var$L);
                break;
            case 10:
                $3b825bc58ae06391$var$ah(d.type._context);
                break;
            case 22:
            case 23:
                $3b825bc58ae06391$var$Hj();
        }
        c = c.return;
    }
    $3b825bc58ae06391$var$Q = a;
    $3b825bc58ae06391$var$Y = a = $3b825bc58ae06391$var$Pg(a.current, null);
    $3b825bc58ae06391$var$Z = $3b825bc58ae06391$var$fj = b;
    $3b825bc58ae06391$var$T = 0;
    $3b825bc58ae06391$var$pk = null;
    $3b825bc58ae06391$var$rk = $3b825bc58ae06391$var$qk = $3b825bc58ae06391$var$rh = 0;
    $3b825bc58ae06391$var$tk = $3b825bc58ae06391$var$sk = null;
    if (null !== $3b825bc58ae06391$var$fh) {
        for(b = 0; b < $3b825bc58ae06391$var$fh.length; b++)if (c = $3b825bc58ae06391$var$fh[b], d = c.interleaved, null !== d) {
            c.interleaved = null;
            var e = d.next, f = c.pending;
            if (null !== f) {
                var g = f.next;
                f.next = e;
                d.next = g;
            }
            c.pending = d;
        }
        $3b825bc58ae06391$var$fh = null;
    }
    return a;
}
function $3b825bc58ae06391$var$Mk(a, b) {
    do {
        var c = $3b825bc58ae06391$var$Y;
        try {
            $3b825bc58ae06391$var$$g();
            $3b825bc58ae06391$var$Fh.current = $3b825bc58ae06391$var$Rh;
            if ($3b825bc58ae06391$var$Ih) {
                for(var d = $3b825bc58ae06391$var$M.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                $3b825bc58ae06391$var$Ih = !1;
            }
            $3b825bc58ae06391$var$Hh = 0;
            $3b825bc58ae06391$var$O = $3b825bc58ae06391$var$N = $3b825bc58ae06391$var$M = null;
            $3b825bc58ae06391$var$Jh = !1;
            $3b825bc58ae06391$var$Kh = 0;
            $3b825bc58ae06391$var$nk.current = null;
            if (null === c || null === c.return) {
                $3b825bc58ae06391$var$T = 1;
                $3b825bc58ae06391$var$pk = b;
                $3b825bc58ae06391$var$Y = null;
                break;
            }
            a: {
                var f = a, g = c.return, h = c, k = b;
                b = $3b825bc58ae06391$var$Z;
                h.flags |= 32768;
                if (null !== k && "object" === typeof k && "function" === typeof k.then) {
                    var l = k, m = h, q = m.tag;
                    if (0 === (m.mode & 1) && (0 === q || 11 === q || 15 === q)) {
                        var r = m.alternate;
                        r ? (m.updateQueue = r.updateQueue, m.memoizedState = r.memoizedState, m.lanes = r.lanes) : (m.updateQueue = null, m.memoizedState = null);
                    }
                    var y = $3b825bc58ae06391$var$Ui(g);
                    if (null !== y) {
                        y.flags &= -257;
                        $3b825bc58ae06391$var$Vi(y, g, h, f, b);
                        y.mode & 1 && $3b825bc58ae06391$var$Si(f, l, b);
                        b = y;
                        k = l;
                        var n = b.updateQueue;
                        if (null === n) {
                            var t = new Set;
                            t.add(k);
                            b.updateQueue = t;
                        } else n.add(k);
                        break a;
                    } else {
                        if (0 === (b & 1)) {
                            $3b825bc58ae06391$var$Si(f, l, b);
                            $3b825bc58ae06391$var$tj();
                            break a;
                        }
                        k = Error($3b825bc58ae06391$var$p(426));
                    }
                } else if ($3b825bc58ae06391$var$I && h.mode & 1) {
                    var J = $3b825bc58ae06391$var$Ui(g);
                    if (null !== J) {
                        0 === (J.flags & 65536) && (J.flags |= 256);
                        $3b825bc58ae06391$var$Vi(J, g, h, f, b);
                        $3b825bc58ae06391$var$Jg($3b825bc58ae06391$var$Ji(k, h));
                        break a;
                    }
                }
                f = k = $3b825bc58ae06391$var$Ji(k, h);
                4 !== $3b825bc58ae06391$var$T && ($3b825bc58ae06391$var$T = 2);
                null === $3b825bc58ae06391$var$sk ? $3b825bc58ae06391$var$sk = [
                    f
                ] : $3b825bc58ae06391$var$sk.push(f);
                f = g;
                do {
                    switch(f.tag){
                        case 3:
                            f.flags |= 65536;
                            b &= -b;
                            f.lanes |= b;
                            var x = $3b825bc58ae06391$var$Ni(f, k, b);
                            $3b825bc58ae06391$var$ph(f, x);
                            break a;
                        case 1:
                            h = k;
                            var w = f.type, u = f.stateNode;
                            if (0 === (f.flags & 128) && ("function" === typeof w.getDerivedStateFromError || null !== u && "function" === typeof u.componentDidCatch && (null === $3b825bc58ae06391$var$Ri || !$3b825bc58ae06391$var$Ri.has(u)))) {
                                f.flags |= 65536;
                                b &= -b;
                                f.lanes |= b;
                                var F = $3b825bc58ae06391$var$Qi(f, h, b);
                                $3b825bc58ae06391$var$ph(f, F);
                                break a;
                            }
                    }
                    f = f.return;
                }while (null !== f);
            }
            $3b825bc58ae06391$var$Sk(c);
        } catch (na) {
            b = na;
            $3b825bc58ae06391$var$Y === c && null !== c && ($3b825bc58ae06391$var$Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function $3b825bc58ae06391$var$Jk() {
    var a = $3b825bc58ae06391$var$mk.current;
    $3b825bc58ae06391$var$mk.current = $3b825bc58ae06391$var$Rh;
    return null === a ? $3b825bc58ae06391$var$Rh : a;
}
function $3b825bc58ae06391$var$tj() {
    if (0 === $3b825bc58ae06391$var$T || 3 === $3b825bc58ae06391$var$T || 2 === $3b825bc58ae06391$var$T) $3b825bc58ae06391$var$T = 4;
    null === $3b825bc58ae06391$var$Q || 0 === ($3b825bc58ae06391$var$rh & 268435455) && 0 === ($3b825bc58ae06391$var$qk & 268435455) || $3b825bc58ae06391$var$Ck($3b825bc58ae06391$var$Q, $3b825bc58ae06391$var$Z);
}
function $3b825bc58ae06391$var$Ik(a, b) {
    var c = $3b825bc58ae06391$var$K;
    $3b825bc58ae06391$var$K |= 2;
    var d = $3b825bc58ae06391$var$Jk();
    if ($3b825bc58ae06391$var$Q !== a || $3b825bc58ae06391$var$Z !== b) $3b825bc58ae06391$var$uk = null, $3b825bc58ae06391$var$Kk(a, b);
    for(;;)try {
        $3b825bc58ae06391$var$Tk();
        break;
    } catch (e) {
        $3b825bc58ae06391$var$Mk(a, e);
    }
    $3b825bc58ae06391$var$$g();
    $3b825bc58ae06391$var$K = c;
    $3b825bc58ae06391$var$mk.current = d;
    if (null !== $3b825bc58ae06391$var$Y) throw Error($3b825bc58ae06391$var$p(261));
    $3b825bc58ae06391$var$Q = null;
    $3b825bc58ae06391$var$Z = 0;
    return $3b825bc58ae06391$var$T;
}
function $3b825bc58ae06391$var$Tk() {
    for(; null !== $3b825bc58ae06391$var$Y;)$3b825bc58ae06391$var$Uk($3b825bc58ae06391$var$Y);
}
function $3b825bc58ae06391$var$Lk() {
    for(; null !== $3b825bc58ae06391$var$Y && !$3b825bc58ae06391$var$cc();)$3b825bc58ae06391$var$Uk($3b825bc58ae06391$var$Y);
}
function $3b825bc58ae06391$var$Uk(a) {
    var b = $3b825bc58ae06391$var$Vk(a.alternate, a, $3b825bc58ae06391$var$fj);
    a.memoizedProps = a.pendingProps;
    null === b ? $3b825bc58ae06391$var$Sk(a) : $3b825bc58ae06391$var$Y = b;
    $3b825bc58ae06391$var$nk.current = null;
}
function $3b825bc58ae06391$var$Sk(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 32768)) {
            if (c = $3b825bc58ae06391$var$Ej(c, b, $3b825bc58ae06391$var$fj), null !== c) {
                $3b825bc58ae06391$var$Y = c;
                return;
            }
        } else {
            c = $3b825bc58ae06391$var$Ij(c, b);
            if (null !== c) {
                c.flags &= 32767;
                $3b825bc58ae06391$var$Y = c;
                return;
            }
            if (null !== a) a.flags |= 32768, a.subtreeFlags = 0, a.deletions = null;
            else {
                $3b825bc58ae06391$var$T = 6;
                $3b825bc58ae06391$var$Y = null;
                return;
            }
        }
        b = b.sibling;
        if (null !== b) {
            $3b825bc58ae06391$var$Y = b;
            return;
        }
        $3b825bc58ae06391$var$Y = b = a;
    }while (null !== b);
    0 === $3b825bc58ae06391$var$T && ($3b825bc58ae06391$var$T = 5);
}
function $3b825bc58ae06391$var$Pk(a, b, c) {
    var d = $3b825bc58ae06391$var$C, e = $3b825bc58ae06391$var$ok.transition;
    try {
        $3b825bc58ae06391$var$ok.transition = null, $3b825bc58ae06391$var$C = 1, $3b825bc58ae06391$var$Wk(a, b, c, d);
    } finally{
        $3b825bc58ae06391$var$ok.transition = e, $3b825bc58ae06391$var$C = d;
    }
    return null;
}
function $3b825bc58ae06391$var$Wk(a, b, c, d) {
    do $3b825bc58ae06391$var$Hk();
    while (null !== $3b825bc58ae06391$var$wk);
    if (0 !== ($3b825bc58ae06391$var$K & 6)) throw Error($3b825bc58ae06391$var$p(327));
    c = a.finishedWork;
    var e = a.finishedLanes;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error($3b825bc58ae06391$var$p(177));
    a.callbackNode = null;
    a.callbackPriority = 0;
    var f = c.lanes | c.childLanes;
    $3b825bc58ae06391$var$Bc(a, f);
    a === $3b825bc58ae06391$var$Q && ($3b825bc58ae06391$var$Y = $3b825bc58ae06391$var$Q = null, $3b825bc58ae06391$var$Z = 0);
    0 === (c.subtreeFlags & 2064) && 0 === (c.flags & 2064) || $3b825bc58ae06391$var$vk || ($3b825bc58ae06391$var$vk = !0, $3b825bc58ae06391$var$Fk($3b825bc58ae06391$var$hc, function() {
        $3b825bc58ae06391$var$Hk();
        return null;
    }));
    f = 0 !== (c.flags & 15990);
    if (0 !== (c.subtreeFlags & 15990) || f) {
        f = $3b825bc58ae06391$var$ok.transition;
        $3b825bc58ae06391$var$ok.transition = null;
        var g = $3b825bc58ae06391$var$C;
        $3b825bc58ae06391$var$C = 1;
        var h = $3b825bc58ae06391$var$K;
        $3b825bc58ae06391$var$K |= 4;
        $3b825bc58ae06391$var$nk.current = null;
        $3b825bc58ae06391$var$Oj(a, c);
        $3b825bc58ae06391$var$dk(c, a);
        $3b825bc58ae06391$var$Oe($3b825bc58ae06391$var$Df);
        $3b825bc58ae06391$var$dd = !!$3b825bc58ae06391$var$Cf;
        $3b825bc58ae06391$var$Df = $3b825bc58ae06391$var$Cf = null;
        a.current = c;
        $3b825bc58ae06391$var$hk(c, a, e);
        $3b825bc58ae06391$var$dc();
        $3b825bc58ae06391$var$K = h;
        $3b825bc58ae06391$var$C = g;
        $3b825bc58ae06391$var$ok.transition = f;
    } else a.current = c;
    $3b825bc58ae06391$var$vk && ($3b825bc58ae06391$var$vk = !1, $3b825bc58ae06391$var$wk = a, $3b825bc58ae06391$var$xk = e);
    f = a.pendingLanes;
    0 === f && ($3b825bc58ae06391$var$Ri = null);
    $3b825bc58ae06391$var$mc(c.stateNode, d);
    $3b825bc58ae06391$var$Dk(a, $3b825bc58ae06391$var$B());
    if (null !== b) for(d = a.onRecoverableError, c = 0; c < b.length; c++)e = b[c], d(e.value, {
        componentStack: e.stack,
        digest: e.digest
    });
    if ($3b825bc58ae06391$var$Oi) throw $3b825bc58ae06391$var$Oi = !1, a = $3b825bc58ae06391$var$Pi, $3b825bc58ae06391$var$Pi = null, a;
    0 !== ($3b825bc58ae06391$var$xk & 1) && 0 !== a.tag && $3b825bc58ae06391$var$Hk();
    f = a.pendingLanes;
    0 !== (f & 1) ? a === $3b825bc58ae06391$var$zk ? $3b825bc58ae06391$var$yk++ : ($3b825bc58ae06391$var$yk = 0, $3b825bc58ae06391$var$zk = a) : $3b825bc58ae06391$var$yk = 0;
    $3b825bc58ae06391$var$jg();
    return null;
}
function $3b825bc58ae06391$var$Hk() {
    if (null !== $3b825bc58ae06391$var$wk) {
        var a = $3b825bc58ae06391$var$Dc($3b825bc58ae06391$var$xk), b = $3b825bc58ae06391$var$ok.transition, c = $3b825bc58ae06391$var$C;
        try {
            $3b825bc58ae06391$var$ok.transition = null;
            $3b825bc58ae06391$var$C = 16 > a ? 16 : a;
            if (null === $3b825bc58ae06391$var$wk) var d = !1;
            else {
                a = $3b825bc58ae06391$var$wk;
                $3b825bc58ae06391$var$wk = null;
                $3b825bc58ae06391$var$xk = 0;
                if (0 !== ($3b825bc58ae06391$var$K & 6)) throw Error($3b825bc58ae06391$var$p(331));
                var e = $3b825bc58ae06391$var$K;
                $3b825bc58ae06391$var$K |= 4;
                for($3b825bc58ae06391$var$V = a.current; null !== $3b825bc58ae06391$var$V;){
                    var f = $3b825bc58ae06391$var$V, g = f.child;
                    if (0 !== ($3b825bc58ae06391$var$V.flags & 16)) {
                        var h = f.deletions;
                        if (null !== h) {
                            for(var k = 0; k < h.length; k++){
                                var l = h[k];
                                for($3b825bc58ae06391$var$V = l; null !== $3b825bc58ae06391$var$V;){
                                    var m = $3b825bc58ae06391$var$V;
                                    switch(m.tag){
                                        case 0:
                                        case 11:
                                        case 15:
                                            $3b825bc58ae06391$var$Pj(8, m, f);
                                    }
                                    var q = m.child;
                                    if (null !== q) q.return = m, $3b825bc58ae06391$var$V = q;
                                    else for(; null !== $3b825bc58ae06391$var$V;){
                                        m = $3b825bc58ae06391$var$V;
                                        var r = m.sibling, y = m.return;
                                        $3b825bc58ae06391$var$Sj(m);
                                        if (m === l) {
                                            $3b825bc58ae06391$var$V = null;
                                            break;
                                        }
                                        if (null !== r) {
                                            r.return = y;
                                            $3b825bc58ae06391$var$V = r;
                                            break;
                                        }
                                        $3b825bc58ae06391$var$V = y;
                                    }
                                }
                            }
                            var n = f.alternate;
                            if (null !== n) {
                                var t = n.child;
                                if (null !== t) {
                                    n.child = null;
                                    do {
                                        var J = t.sibling;
                                        t.sibling = null;
                                        t = J;
                                    }while (null !== t);
                                }
                            }
                            $3b825bc58ae06391$var$V = f;
                        }
                    }
                    if (0 !== (f.subtreeFlags & 2064) && null !== g) g.return = f, $3b825bc58ae06391$var$V = g;
                    else b: for(; null !== $3b825bc58ae06391$var$V;){
                        f = $3b825bc58ae06391$var$V;
                        if (0 !== (f.flags & 2048)) switch(f.tag){
                            case 0:
                            case 11:
                            case 15:
                                $3b825bc58ae06391$var$Pj(9, f, f.return);
                        }
                        var x = f.sibling;
                        if (null !== x) {
                            x.return = f.return;
                            $3b825bc58ae06391$var$V = x;
                            break b;
                        }
                        $3b825bc58ae06391$var$V = f.return;
                    }
                }
                var w = a.current;
                for($3b825bc58ae06391$var$V = w; null !== $3b825bc58ae06391$var$V;){
                    g = $3b825bc58ae06391$var$V;
                    var u = g.child;
                    if (0 !== (g.subtreeFlags & 2064) && null !== u) u.return = g, $3b825bc58ae06391$var$V = u;
                    else b: for(g = w; null !== $3b825bc58ae06391$var$V;){
                        h = $3b825bc58ae06391$var$V;
                        if (0 !== (h.flags & 2048)) try {
                            switch(h.tag){
                                case 0:
                                case 11:
                                case 15:
                                    $3b825bc58ae06391$var$Qj(9, h);
                            }
                        } catch (na) {
                            $3b825bc58ae06391$var$W(h, h.return, na);
                        }
                        if (h === g) {
                            $3b825bc58ae06391$var$V = null;
                            break b;
                        }
                        var F = h.sibling;
                        if (null !== F) {
                            F.return = h.return;
                            $3b825bc58ae06391$var$V = F;
                            break b;
                        }
                        $3b825bc58ae06391$var$V = h.return;
                    }
                }
                $3b825bc58ae06391$var$K = e;
                $3b825bc58ae06391$var$jg();
                if ($3b825bc58ae06391$var$lc && "function" === typeof $3b825bc58ae06391$var$lc.onPostCommitFiberRoot) try {
                    $3b825bc58ae06391$var$lc.onPostCommitFiberRoot($3b825bc58ae06391$var$kc, a);
                } catch (na) {}
                d = !0;
            }
            return d;
        } finally{
            $3b825bc58ae06391$var$C = c, $3b825bc58ae06391$var$ok.transition = b;
        }
    }
    return !1;
}
function $3b825bc58ae06391$var$Xk(a, b, c) {
    b = $3b825bc58ae06391$var$Ji(c, b);
    b = $3b825bc58ae06391$var$Ni(a, b, 1);
    a = $3b825bc58ae06391$var$nh(a, b, 1);
    b = $3b825bc58ae06391$var$R();
    null !== a && ($3b825bc58ae06391$var$Ac(a, 1, b), $3b825bc58ae06391$var$Dk(a, b));
}
function $3b825bc58ae06391$var$W(a, b, c) {
    if (3 === a.tag) $3b825bc58ae06391$var$Xk(a, a, c);
    else for(; null !== b;){
        if (3 === b.tag) {
            $3b825bc58ae06391$var$Xk(b, a, c);
            break;
        } else if (1 === b.tag) {
            var d = b.stateNode;
            if ("function" === typeof b.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === $3b825bc58ae06391$var$Ri || !$3b825bc58ae06391$var$Ri.has(d))) {
                a = $3b825bc58ae06391$var$Ji(c, a);
                a = $3b825bc58ae06391$var$Qi(b, a, 1);
                b = $3b825bc58ae06391$var$nh(b, a, 1);
                a = $3b825bc58ae06391$var$R();
                null !== b && ($3b825bc58ae06391$var$Ac(b, 1, a), $3b825bc58ae06391$var$Dk(b, a));
                break;
            }
        }
        b = b.return;
    }
}
function $3b825bc58ae06391$var$Ti(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = $3b825bc58ae06391$var$R();
    a.pingedLanes |= a.suspendedLanes & c;
    $3b825bc58ae06391$var$Q === a && ($3b825bc58ae06391$var$Z & c) === c && (4 === $3b825bc58ae06391$var$T || 3 === $3b825bc58ae06391$var$T && ($3b825bc58ae06391$var$Z & 130023424) === $3b825bc58ae06391$var$Z && 500 > $3b825bc58ae06391$var$B() - $3b825bc58ae06391$var$fk ? $3b825bc58ae06391$var$Kk(a, 0) : $3b825bc58ae06391$var$rk |= c);
    $3b825bc58ae06391$var$Dk(a, b);
}
function $3b825bc58ae06391$var$Yk(a, b) {
    0 === b && (0 === (a.mode & 1) ? b = 1 : (b = $3b825bc58ae06391$var$sc, $3b825bc58ae06391$var$sc <<= 1, 0 === ($3b825bc58ae06391$var$sc & 130023424) && ($3b825bc58ae06391$var$sc = 4194304)));
    var c = $3b825bc58ae06391$var$R();
    a = $3b825bc58ae06391$var$ih(a, b);
    null !== a && ($3b825bc58ae06391$var$Ac(a, b, c), $3b825bc58ae06391$var$Dk(a, c));
}
function $3b825bc58ae06391$var$uj(a) {
    var b = a.memoizedState, c = 0;
    null !== b && (c = b.retryLane);
    $3b825bc58ae06391$var$Yk(a, c);
}
function $3b825bc58ae06391$var$bk(a, b) {
    var c = 0;
    switch(a.tag){
        case 13:
            var d = a.stateNode;
            var e = a.memoizedState;
            null !== e && (c = e.retryLane);
            break;
        case 19:
            d = a.stateNode;
            break;
        default:
            throw Error($3b825bc58ae06391$var$p(314));
    }
    null !== d && d.delete(b);
    $3b825bc58ae06391$var$Yk(a, c);
}
var $3b825bc58ae06391$var$Vk;
$3b825bc58ae06391$var$Vk = function(a, b, c) {
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || $3b825bc58ae06391$var$Wf.current) $3b825bc58ae06391$var$dh = !0;
        else {
            if (0 === (a.lanes & c) && 0 === (b.flags & 128)) return $3b825bc58ae06391$var$dh = !1, $3b825bc58ae06391$var$yj(a, b, c);
            $3b825bc58ae06391$var$dh = 0 !== (a.flags & 131072) ? !0 : !1;
        }
    } else $3b825bc58ae06391$var$dh = !1, $3b825bc58ae06391$var$I && 0 !== (b.flags & 1048576) && $3b825bc58ae06391$var$ug(b, $3b825bc58ae06391$var$ng, b.index);
    b.lanes = 0;
    switch(b.tag){
        case 2:
            var d = b.type;
            $3b825bc58ae06391$var$ij(a, b);
            a = b.pendingProps;
            var e = $3b825bc58ae06391$var$Yf(b, $3b825bc58ae06391$var$H.current);
            $3b825bc58ae06391$var$ch(b, c);
            e = $3b825bc58ae06391$var$Nh(null, b, d, a, e, c);
            var f = $3b825bc58ae06391$var$Sh();
            b.flags |= 1;
            "object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof ? (b.tag = 1, b.memoizedState = null, b.updateQueue = null, $3b825bc58ae06391$var$Zf(d) ? (f = !0, $3b825bc58ae06391$var$cg(b)) : f = !1, b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null, $3b825bc58ae06391$var$kh(b), e.updater = $3b825bc58ae06391$var$Ei, b.stateNode = e, e._reactInternals = b, $3b825bc58ae06391$var$Ii(b, d, a, c), b = $3b825bc58ae06391$var$jj(null, b, d, !0, f, c)) : (b.tag = 0, $3b825bc58ae06391$var$I && f && $3b825bc58ae06391$var$vg(b), $3b825bc58ae06391$var$Xi(null, b, e, c), b = b.child);
            return b;
        case 16:
            d = b.elementType;
            a: {
                $3b825bc58ae06391$var$ij(a, b);
                a = b.pendingProps;
                e = d._init;
                d = e(d._payload);
                b.type = d;
                e = b.tag = $3b825bc58ae06391$var$Zk(d);
                a = $3b825bc58ae06391$var$Ci(d, a);
                switch(e){
                    case 0:
                        b = $3b825bc58ae06391$var$cj(null, b, d, a, c);
                        break a;
                    case 1:
                        b = $3b825bc58ae06391$var$hj(null, b, d, a, c);
                        break a;
                    case 11:
                        b = $3b825bc58ae06391$var$Yi(null, b, d, a, c);
                        break a;
                    case 14:
                        b = $3b825bc58ae06391$var$$i(null, b, d, $3b825bc58ae06391$var$Ci(d.type, a), c);
                        break a;
                }
                throw Error($3b825bc58ae06391$var$p(306, d, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $3b825bc58ae06391$var$Ci(d, e), $3b825bc58ae06391$var$cj(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $3b825bc58ae06391$var$Ci(d, e), $3b825bc58ae06391$var$hj(a, b, d, e, c);
        case 3:
            a: {
                $3b825bc58ae06391$var$kj(b);
                if (null === a) throw Error($3b825bc58ae06391$var$p(387));
                d = b.pendingProps;
                f = b.memoizedState;
                e = f.element;
                $3b825bc58ae06391$var$lh(a, b);
                $3b825bc58ae06391$var$qh(b, d, null, c);
                var g = b.memoizedState;
                d = g.element;
                if (f.isDehydrated) {
                    if (f = {
                        element: d,
                        isDehydrated: !1,
                        cache: g.cache,
                        pendingSuspenseBoundaries: g.pendingSuspenseBoundaries,
                        transitions: g.transitions
                    }, b.updateQueue.baseState = f, b.memoizedState = f, b.flags & 256) {
                        e = $3b825bc58ae06391$var$Ji(Error($3b825bc58ae06391$var$p(423)), b);
                        b = $3b825bc58ae06391$var$lj(a, b, d, c, e);
                        break a;
                    } else if (d !== e) {
                        e = $3b825bc58ae06391$var$Ji(Error($3b825bc58ae06391$var$p(424)), b);
                        b = $3b825bc58ae06391$var$lj(a, b, d, c, e);
                        break a;
                    } else for($3b825bc58ae06391$var$yg = $3b825bc58ae06391$var$Lf(b.stateNode.containerInfo.firstChild), $3b825bc58ae06391$var$xg = b, $3b825bc58ae06391$var$I = !0, $3b825bc58ae06391$var$zg = null, c = $3b825bc58ae06391$var$Vg(b, null, d, c), b.child = c; c;)c.flags = c.flags & -3 | 4096, c = c.sibling;
                } else {
                    $3b825bc58ae06391$var$Ig();
                    if (d === e) {
                        b = $3b825bc58ae06391$var$Zi(a, b, c);
                        break a;
                    }
                    $3b825bc58ae06391$var$Xi(a, b, d, c);
                }
                b = b.child;
            }
            return b;
        case 5:
            return $3b825bc58ae06391$var$Ah(b), null === a && $3b825bc58ae06391$var$Eg(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, $3b825bc58ae06391$var$Ef(d, e) ? g = null : null !== f && $3b825bc58ae06391$var$Ef(d, f) && (b.flags |= 32), $3b825bc58ae06391$var$gj(a, b), $3b825bc58ae06391$var$Xi(a, b, g, c), b.child;
        case 6:
            return null === a && $3b825bc58ae06391$var$Eg(b), null;
        case 13:
            return $3b825bc58ae06391$var$oj(a, b, c);
        case 4:
            return $3b825bc58ae06391$var$yh(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = $3b825bc58ae06391$var$Ug(b, null, d, c) : $3b825bc58ae06391$var$Xi(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $3b825bc58ae06391$var$Ci(d, e), $3b825bc58ae06391$var$Yi(a, b, d, e, c);
        case 7:
            return $3b825bc58ae06391$var$Xi(a, b, b.pendingProps, c), b.child;
        case 8:
            return $3b825bc58ae06391$var$Xi(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return $3b825bc58ae06391$var$Xi(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                f = b.memoizedProps;
                g = e.value;
                $3b825bc58ae06391$var$G($3b825bc58ae06391$var$Wg, d._currentValue);
                d._currentValue = g;
                if (null !== f) {
                    if ($3b825bc58ae06391$var$He(f.value, g)) {
                        if (f.children === e.children && !$3b825bc58ae06391$var$Wf.current) {
                            b = $3b825bc58ae06391$var$Zi(a, b, c);
                            break a;
                        }
                    } else for(f = b.child, null !== f && (f.return = b); null !== f;){
                        var h = f.dependencies;
                        if (null !== h) {
                            g = f.child;
                            for(var k = h.firstContext; null !== k;){
                                if (k.context === d) {
                                    if (1 === f.tag) {
                                        k = $3b825bc58ae06391$var$mh(-1, c & -c);
                                        k.tag = 2;
                                        var l = f.updateQueue;
                                        if (null !== l) {
                                            l = l.shared;
                                            var m = l.pending;
                                            null === m ? k.next = k : (k.next = m.next, m.next = k);
                                            l.pending = k;
                                        }
                                    }
                                    f.lanes |= c;
                                    k = f.alternate;
                                    null !== k && (k.lanes |= c);
                                    $3b825bc58ae06391$var$bh(f.return, c, b);
                                    h.lanes |= c;
                                    break;
                                }
                                k = k.next;
                            }
                        } else if (10 === f.tag) g = f.type === b.type ? null : f.child;
                        else if (18 === f.tag) {
                            g = f.return;
                            if (null === g) throw Error($3b825bc58ae06391$var$p(341));
                            g.lanes |= c;
                            h = g.alternate;
                            null !== h && (h.lanes |= c);
                            $3b825bc58ae06391$var$bh(g, c, b);
                            g = f.sibling;
                        } else g = f.child;
                        if (null !== g) g.return = f;
                        else for(g = f; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            f = g.sibling;
                            if (null !== f) {
                                f.return = g.return;
                                g = f;
                                break;
                            }
                            g = g.return;
                        }
                        f = g;
                    }
                }
                $3b825bc58ae06391$var$Xi(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, d = b.pendingProps.children, $3b825bc58ae06391$var$ch(b, c), e = $3b825bc58ae06391$var$eh(e), d = d(e), b.flags |= 1, $3b825bc58ae06391$var$Xi(a, b, d, c), b.child;
        case 14:
            return d = b.type, e = $3b825bc58ae06391$var$Ci(d, b.pendingProps), e = $3b825bc58ae06391$var$Ci(d.type, e), $3b825bc58ae06391$var$$i(a, b, d, e, c);
        case 15:
            return $3b825bc58ae06391$var$bj(a, b, b.type, b.pendingProps, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $3b825bc58ae06391$var$Ci(d, e), $3b825bc58ae06391$var$ij(a, b), b.tag = 1, $3b825bc58ae06391$var$Zf(d) ? (a = !0, $3b825bc58ae06391$var$cg(b)) : a = !1, $3b825bc58ae06391$var$ch(b, c), $3b825bc58ae06391$var$Gi(b, d, e), $3b825bc58ae06391$var$Ii(b, d, e, c), $3b825bc58ae06391$var$jj(null, b, d, !0, a, c);
        case 19:
            return $3b825bc58ae06391$var$xj(a, b, c);
        case 22:
            return $3b825bc58ae06391$var$dj(a, b, c);
    }
    throw Error($3b825bc58ae06391$var$p(156, b.tag));
};
function $3b825bc58ae06391$var$Fk(a, b) {
    return $3b825bc58ae06391$var$ac(a, b);
}
function $3b825bc58ae06391$var$$k(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $3b825bc58ae06391$var$Bg(a, b, c, d) {
    return new $3b825bc58ae06391$var$$k(a, b, c, d);
}
function $3b825bc58ae06391$var$aj(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function $3b825bc58ae06391$var$Zk(a) {
    if ("function" === typeof a) return $3b825bc58ae06391$var$aj(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === $3b825bc58ae06391$var$Da) return 11;
        if (a === $3b825bc58ae06391$var$Ga) return 14;
    }
    return 2;
}
function $3b825bc58ae06391$var$Pg(a, b) {
    var c = a.alternate;
    null === c ? (c = $3b825bc58ae06391$var$Bg(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.subtreeFlags = 0, c.deletions = null);
    c.flags = a.flags & 14680064;
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function $3b825bc58ae06391$var$Rg(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) $3b825bc58ae06391$var$aj(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case $3b825bc58ae06391$var$ya:
            return $3b825bc58ae06391$var$Tg(c.children, e, f, b);
        case $3b825bc58ae06391$var$za:
            g = 8;
            e |= 8;
            break;
        case $3b825bc58ae06391$var$Aa:
            return a = $3b825bc58ae06391$var$Bg(12, c, b, e | 2), a.elementType = $3b825bc58ae06391$var$Aa, a.lanes = f, a;
        case $3b825bc58ae06391$var$Ea:
            return a = $3b825bc58ae06391$var$Bg(13, c, b, e), a.elementType = $3b825bc58ae06391$var$Ea, a.lanes = f, a;
        case $3b825bc58ae06391$var$Fa:
            return a = $3b825bc58ae06391$var$Bg(19, c, b, e), a.elementType = $3b825bc58ae06391$var$Fa, a.lanes = f, a;
        case $3b825bc58ae06391$var$Ia:
            return $3b825bc58ae06391$var$pj(c, e, f, b);
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case $3b825bc58ae06391$var$Ba:
                    g = 10;
                    break a;
                case $3b825bc58ae06391$var$Ca:
                    g = 9;
                    break a;
                case $3b825bc58ae06391$var$Da:
                    g = 11;
                    break a;
                case $3b825bc58ae06391$var$Ga:
                    g = 14;
                    break a;
                case $3b825bc58ae06391$var$Ha:
                    g = 16;
                    d = null;
                    break a;
            }
            throw Error($3b825bc58ae06391$var$p(130, null == a ? a : typeof a, ""));
    }
    b = $3b825bc58ae06391$var$Bg(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function $3b825bc58ae06391$var$Tg(a, b, c, d) {
    a = $3b825bc58ae06391$var$Bg(7, a, d, b);
    a.lanes = c;
    return a;
}
function $3b825bc58ae06391$var$pj(a, b, c, d) {
    a = $3b825bc58ae06391$var$Bg(22, a, d, b);
    a.elementType = $3b825bc58ae06391$var$Ia;
    a.lanes = c;
    a.stateNode = {
        isHidden: !1
    };
    return a;
}
function $3b825bc58ae06391$var$Qg(a, b, c) {
    a = $3b825bc58ae06391$var$Bg(6, a, null, b);
    a.lanes = c;
    return a;
}
function $3b825bc58ae06391$var$Sg(a, b, c) {
    b = $3b825bc58ae06391$var$Bg(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function $3b825bc58ae06391$var$al(a, b, c, d, e) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.pendingContext = this.context = null;
    this.callbackPriority = 0;
    this.eventTimes = $3b825bc58ae06391$var$zc(0);
    this.expirationTimes = $3b825bc58ae06391$var$zc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $3b825bc58ae06391$var$zc(0);
    this.identifierPrefix = d;
    this.onRecoverableError = e;
    this.mutableSourceEagerHydrationData = null;
}
function $3b825bc58ae06391$var$bl(a, b, c, d, e, f, g, h, k) {
    a = new $3b825bc58ae06391$var$al(a, b, c, h, k);
    1 === b ? (b = 1, !0 === f && (b |= 8)) : b = 0;
    f = $3b825bc58ae06391$var$Bg(3, null, null, b);
    a.current = f;
    f.stateNode = a;
    f.memoizedState = {
        element: d,
        isDehydrated: c,
        cache: null,
        transitions: null,
        pendingSuspenseBoundaries: null
    };
    $3b825bc58ae06391$var$kh(f);
    return a;
}
function $3b825bc58ae06391$var$cl(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $3b825bc58ae06391$var$wa,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function $3b825bc58ae06391$var$dl(a) {
    if (!a) return $3b825bc58ae06391$var$Vf;
    a = a._reactInternals;
    a: {
        if ($3b825bc58ae06391$var$Vb(a) !== a || 1 !== a.tag) throw Error($3b825bc58ae06391$var$p(170));
        var b = a;
        do {
            switch(b.tag){
                case 3:
                    b = b.stateNode.context;
                    break a;
                case 1:
                    if ($3b825bc58ae06391$var$Zf(b.type)) {
                        b = b.stateNode.__reactInternalMemoizedMergedChildContext;
                        break a;
                    }
            }
            b = b.return;
        }while (null !== b);
        throw Error($3b825bc58ae06391$var$p(171));
    }
    if (1 === a.tag) {
        var c = a.type;
        if ($3b825bc58ae06391$var$Zf(c)) return $3b825bc58ae06391$var$bg(a, c, b);
    }
    return b;
}
function $3b825bc58ae06391$var$el(a, b, c, d, e, f, g, h, k) {
    a = $3b825bc58ae06391$var$bl(c, d, !0, a, e, f, g, h, k);
    a.context = $3b825bc58ae06391$var$dl(null);
    c = a.current;
    d = $3b825bc58ae06391$var$R();
    e = $3b825bc58ae06391$var$yi(c);
    f = $3b825bc58ae06391$var$mh(d, e);
    f.callback = void 0 !== b && null !== b ? b : null;
    $3b825bc58ae06391$var$nh(c, f, e);
    a.current.lanes = e;
    $3b825bc58ae06391$var$Ac(a, e, d);
    $3b825bc58ae06391$var$Dk(a, d);
    return a;
}
function $3b825bc58ae06391$var$fl(a, b, c, d) {
    var e = b.current, f = $3b825bc58ae06391$var$R(), g = $3b825bc58ae06391$var$yi(e);
    c = $3b825bc58ae06391$var$dl(c);
    null === b.context ? b.context = c : b.pendingContext = c;
    b = $3b825bc58ae06391$var$mh(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    a = $3b825bc58ae06391$var$nh(e, b, g);
    null !== a && ($3b825bc58ae06391$var$gi(a, e, g, f), $3b825bc58ae06391$var$oh(a, e, g));
    return g;
}
function $3b825bc58ae06391$var$gl(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function $3b825bc58ae06391$var$hl(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function $3b825bc58ae06391$var$il(a, b) {
    $3b825bc58ae06391$var$hl(a, b);
    (a = a.alternate) && $3b825bc58ae06391$var$hl(a, b);
}
function $3b825bc58ae06391$var$jl() {
    return null;
}
var $3b825bc58ae06391$var$kl = "function" === typeof reportError ? reportError : function(a) {
    console.error(a);
};
function $3b825bc58ae06391$var$ll(a) {
    this._internalRoot = a;
}
$3b825bc58ae06391$var$ml.prototype.render = $3b825bc58ae06391$var$ll.prototype.render = function(a) {
    var b = this._internalRoot;
    if (null === b) throw Error($3b825bc58ae06391$var$p(409));
    $3b825bc58ae06391$var$fl(a, b, null, null);
};
$3b825bc58ae06391$var$ml.prototype.unmount = $3b825bc58ae06391$var$ll.prototype.unmount = function() {
    var a = this._internalRoot;
    if (null !== a) {
        this._internalRoot = null;
        var b = a.containerInfo;
        $3b825bc58ae06391$var$Rk(function() {
            $3b825bc58ae06391$var$fl(null, a, null, null);
        });
        b[$3b825bc58ae06391$var$uf] = null;
    }
};
function $3b825bc58ae06391$var$ml(a) {
    this._internalRoot = a;
}
$3b825bc58ae06391$var$ml.prototype.unstable_scheduleHydration = function(a) {
    if (a) {
        var b = $3b825bc58ae06391$var$Hc();
        a = {
            blockedOn: null,
            target: a,
            priority: b
        };
        for(var c = 0; c < $3b825bc58ae06391$var$Qc.length && 0 !== b && b < $3b825bc58ae06391$var$Qc[c].priority; c++);
        $3b825bc58ae06391$var$Qc.splice(c, 0, a);
        0 === c && $3b825bc58ae06391$var$Vc(a);
    }
};
function $3b825bc58ae06391$var$nl(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType);
}
function $3b825bc58ae06391$var$ol(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function $3b825bc58ae06391$var$pl() {}
function $3b825bc58ae06391$var$ql(a, b, c, d, e) {
    if (e) {
        if ("function" === typeof d) {
            var f = d;
            d = function() {
                var a = $3b825bc58ae06391$var$gl(g);
                f.call(a);
            };
        }
        var g = $3b825bc58ae06391$var$el(b, d, a, 0, null, !1, !1, "", $3b825bc58ae06391$var$pl);
        a._reactRootContainer = g;
        a[$3b825bc58ae06391$var$uf] = g.current;
        $3b825bc58ae06391$var$sf(8 === a.nodeType ? a.parentNode : a);
        $3b825bc58ae06391$var$Rk();
        return g;
    }
    for(; e = a.lastChild;)a.removeChild(e);
    if ("function" === typeof d) {
        var h = d;
        d = function() {
            var a = $3b825bc58ae06391$var$gl(k);
            h.call(a);
        };
    }
    var k = $3b825bc58ae06391$var$bl(a, 0, !1, null, null, !1, !1, "", $3b825bc58ae06391$var$pl);
    a._reactRootContainer = k;
    a[$3b825bc58ae06391$var$uf] = k.current;
    $3b825bc58ae06391$var$sf(8 === a.nodeType ? a.parentNode : a);
    $3b825bc58ae06391$var$Rk(function() {
        $3b825bc58ae06391$var$fl(b, k, c, d);
    });
    return k;
}
function $3b825bc58ae06391$var$rl(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = $3b825bc58ae06391$var$gl(g);
                h.call(a);
            };
        }
        $3b825bc58ae06391$var$fl(b, g, a, e);
    } else g = $3b825bc58ae06391$var$ql(c, b, a, e, d);
    return $3b825bc58ae06391$var$gl(g);
}
$3b825bc58ae06391$var$Ec = function(a) {
    switch(a.tag){
        case 3:
            var b = a.stateNode;
            if (b.current.memoizedState.isDehydrated) {
                var c = $3b825bc58ae06391$var$tc(b.pendingLanes);
                0 !== c && ($3b825bc58ae06391$var$Cc(b, c | 1), $3b825bc58ae06391$var$Dk(b, $3b825bc58ae06391$var$B()), 0 === ($3b825bc58ae06391$var$K & 6) && ($3b825bc58ae06391$var$Gj = $3b825bc58ae06391$var$B() + 500, $3b825bc58ae06391$var$jg()));
            }
            break;
        case 13:
            $3b825bc58ae06391$var$Rk(function() {
                var b = $3b825bc58ae06391$var$ih(a, 1);
                if (null !== b) {
                    var c = $3b825bc58ae06391$var$R();
                    $3b825bc58ae06391$var$gi(b, a, 1, c);
                }
            }), $3b825bc58ae06391$var$il(a, 1);
    }
};
$3b825bc58ae06391$var$Fc = function(a) {
    if (13 === a.tag) {
        var b = $3b825bc58ae06391$var$ih(a, 134217728);
        if (null !== b) {
            var c = $3b825bc58ae06391$var$R();
            $3b825bc58ae06391$var$gi(b, a, 134217728, c);
        }
        $3b825bc58ae06391$var$il(a, 134217728);
    }
};
$3b825bc58ae06391$var$Gc = function(a) {
    if (13 === a.tag) {
        var b = $3b825bc58ae06391$var$yi(a), c = $3b825bc58ae06391$var$ih(a, b);
        if (null !== c) {
            var d = $3b825bc58ae06391$var$R();
            $3b825bc58ae06391$var$gi(c, a, b, d);
        }
        $3b825bc58ae06391$var$il(a, b);
    }
};
$3b825bc58ae06391$var$Hc = function() {
    return $3b825bc58ae06391$var$C;
};
$3b825bc58ae06391$var$Ic = function(a, b) {
    var c = $3b825bc58ae06391$var$C;
    try {
        return $3b825bc58ae06391$var$C = a, b();
    } finally{
        $3b825bc58ae06391$var$C = c;
    }
};
$3b825bc58ae06391$var$yb = function(a, b, c) {
    switch(b){
        case "input":
            $3b825bc58ae06391$var$bb(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = $3b825bc58ae06391$var$Db(d);
                        if (!e) throw Error($3b825bc58ae06391$var$p(90));
                        $3b825bc58ae06391$var$Wa(d);
                        $3b825bc58ae06391$var$bb(d, e);
                    }
                }
            }
            break;
        case "textarea":
            $3b825bc58ae06391$var$ib(a, c);
            break;
        case "select":
            b = c.value, null != b && $3b825bc58ae06391$var$fb(a, !!c.multiple, b, !1);
    }
};
$3b825bc58ae06391$var$Gb = $3b825bc58ae06391$var$Qk;
$3b825bc58ae06391$var$Hb = $3b825bc58ae06391$var$Rk;
var $3b825bc58ae06391$var$sl = {
    usingClientEntryPoint: !1,
    Events: [
        $3b825bc58ae06391$var$Cb,
        $3b825bc58ae06391$var$ue,
        $3b825bc58ae06391$var$Db,
        $3b825bc58ae06391$var$Eb,
        $3b825bc58ae06391$var$Fb,
        $3b825bc58ae06391$var$Qk
    ]
}, $3b825bc58ae06391$var$tl = {
    findFiberByHostInstance: $3b825bc58ae06391$var$Wc,
    bundleType: 0,
    version: "18.3.1",
    rendererPackageName: "react-dom"
};
var $3b825bc58ae06391$var$ul = {
    bundleType: $3b825bc58ae06391$var$tl.bundleType,
    version: $3b825bc58ae06391$var$tl.version,
    rendererPackageName: $3b825bc58ae06391$var$tl.rendererPackageName,
    rendererConfig: $3b825bc58ae06391$var$tl.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setErrorHandler: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: $3b825bc58ae06391$var$ua.ReactCurrentDispatcher,
    findHostInstanceByFiber: function(a) {
        a = $3b825bc58ae06391$var$Zb(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: $3b825bc58ae06391$var$tl.findFiberByHostInstance || $3b825bc58ae06391$var$jl,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null,
    reconcilerVersion: "18.3.1-next-f1338f8080-20240426"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $3b825bc58ae06391$var$vl = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$3b825bc58ae06391$var$vl.isDisabled && $3b825bc58ae06391$var$vl.supportsFiber) try {
        $3b825bc58ae06391$var$kc = $3b825bc58ae06391$var$vl.inject($3b825bc58ae06391$var$ul), $3b825bc58ae06391$var$lc = $3b825bc58ae06391$var$vl;
    } catch (a) {}
}
$3b825bc58ae06391$export$ae55be85d98224ed = $3b825bc58ae06391$var$sl;
$3b825bc58ae06391$export$d39a5bbd09211389 = function(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!$3b825bc58ae06391$var$nl(b)) throw Error($3b825bc58ae06391$var$p(200));
    return $3b825bc58ae06391$var$cl(a, b, null, c);
};
$3b825bc58ae06391$export$882461b6382ed46c = function(a, b) {
    if (!$3b825bc58ae06391$var$nl(a)) throw Error($3b825bc58ae06391$var$p(299));
    var c = !1, d = "", e = $3b825bc58ae06391$var$kl;
    null !== b && void 0 !== b && (!0 === b.unstable_strictMode && (c = !0), void 0 !== b.identifierPrefix && (d = b.identifierPrefix), void 0 !== b.onRecoverableError && (e = b.onRecoverableError));
    b = $3b825bc58ae06391$var$bl(a, 1, !1, null, null, c, !1, d, e);
    a[$3b825bc58ae06391$var$uf] = b.current;
    $3b825bc58ae06391$var$sf(8 === a.nodeType ? a.parentNode : a);
    return new $3b825bc58ae06391$var$ll(b);
};
$3b825bc58ae06391$export$466bfc07425424d5 = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error($3b825bc58ae06391$var$p(188));
        a = Object.keys(a).join(",");
        throw Error($3b825bc58ae06391$var$p(268, a));
    }
    a = $3b825bc58ae06391$var$Zb(b);
    a = null === a ? null : a.stateNode;
    return a;
};
$3b825bc58ae06391$export$cd75ccfd720a3cd4 = function(a) {
    return $3b825bc58ae06391$var$Rk(a);
};
$3b825bc58ae06391$export$fa8d919ba61d84db = function(a, b, c) {
    if (!$3b825bc58ae06391$var$ol(b)) throw Error($3b825bc58ae06391$var$p(200));
    return $3b825bc58ae06391$var$rl(null, a, b, !0, c);
};
$3b825bc58ae06391$export$757ceba2d55c277e = function(a, b, c) {
    if (!$3b825bc58ae06391$var$nl(a)) throw Error($3b825bc58ae06391$var$p(405));
    var d = null != c && c.hydratedSources || null, e = !1, f = "", g = $3b825bc58ae06391$var$kl;
    null !== c && void 0 !== c && (!0 === c.unstable_strictMode && (e = !0), void 0 !== c.identifierPrefix && (f = c.identifierPrefix), void 0 !== c.onRecoverableError && (g = c.onRecoverableError));
    b = $3b825bc58ae06391$var$el(b, null, a, 1, null != c ? c : null, e, !1, f, g);
    a[$3b825bc58ae06391$var$uf] = b.current;
    $3b825bc58ae06391$var$sf(a);
    if (d) for(a = 0; a < d.length; a++)c = d[a], e = c._getVersion, e = e(c._source), null == b.mutableSourceEagerHydrationData ? b.mutableSourceEagerHydrationData = [
        c,
        e
    ] : b.mutableSourceEagerHydrationData.push(c, e);
    return new $3b825bc58ae06391$var$ml(b);
};
$3b825bc58ae06391$export$b3890eb0ae9dca99 = function(a, b, c) {
    if (!$3b825bc58ae06391$var$ol(b)) throw Error($3b825bc58ae06391$var$p(200));
    return $3b825bc58ae06391$var$rl(null, a, b, !1, c);
};
$3b825bc58ae06391$export$502457920280e6be = function(a) {
    if (!$3b825bc58ae06391$var$ol(a)) throw Error($3b825bc58ae06391$var$p(40));
    return a._reactRootContainer ? ($3b825bc58ae06391$var$Rk(function() {
        $3b825bc58ae06391$var$rl(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[$3b825bc58ae06391$var$uf] = null;
        });
    }), !0) : !1;
};
$3b825bc58ae06391$export$c78a37762a8d58e1 = $3b825bc58ae06391$var$Qk;
$3b825bc58ae06391$export$dc54d992c10e8a18 = function(a, b, c, d) {
    if (!$3b825bc58ae06391$var$ol(c)) throw Error($3b825bc58ae06391$var$p(200));
    if (null == a || void 0 === a._reactInternals) throw Error($3b825bc58ae06391$var$p(38));
    return $3b825bc58ae06391$var$rl(a, b, c, !1, d);
};
$3b825bc58ae06391$export$83d89fbfd8236492 = "18.3.1-next-f1338f8080-20240426";

});
parcelRegister("3tRGX", function(module, exports) {
'use strict';

module.exports = (parcelRequire("7Z3bJ"));

});
parcelRegister("7Z3bJ", function(module, exports) {

$parcel$export(module.exports, "unstable_now", function () { return $5d00b400b7ddc577$export$c4744153514ff05d; }, function (v) { return $5d00b400b7ddc577$export$c4744153514ff05d = v; });
$parcel$export(module.exports, "unstable_IdlePriority", function () { return $5d00b400b7ddc577$export$3e506c1ccc9cc1a7; }, function (v) { return $5d00b400b7ddc577$export$3e506c1ccc9cc1a7 = v; });
$parcel$export(module.exports, "unstable_ImmediatePriority", function () { return $5d00b400b7ddc577$export$e26fe2ed2fa76875; }, function (v) { return $5d00b400b7ddc577$export$e26fe2ed2fa76875 = v; });
$parcel$export(module.exports, "unstable_LowPriority", function () { return $5d00b400b7ddc577$export$502329bbf4b505b1; }, function (v) { return $5d00b400b7ddc577$export$502329bbf4b505b1 = v; });
$parcel$export(module.exports, "unstable_NormalPriority", function () { return $5d00b400b7ddc577$export$6e3807111c4874c4; }, function (v) { return $5d00b400b7ddc577$export$6e3807111c4874c4 = v; });
$parcel$export(module.exports, "unstable_Profiling", function () { return $5d00b400b7ddc577$export$c27134553091fb3a; }, function (v) { return $5d00b400b7ddc577$export$c27134553091fb3a = v; });
$parcel$export(module.exports, "unstable_UserBlockingPriority", function () { return $5d00b400b7ddc577$export$33ee1acdc04fd2a2; }, function (v) { return $5d00b400b7ddc577$export$33ee1acdc04fd2a2 = v; });
$parcel$export(module.exports, "unstable_cancelCallback", function () { return $5d00b400b7ddc577$export$b00a404bbd5edef2; }, function (v) { return $5d00b400b7ddc577$export$b00a404bbd5edef2 = v; });
$parcel$export(module.exports, "unstable_continueExecution", function () { return $5d00b400b7ddc577$export$8352ce38b91d0c62; }, function (v) { return $5d00b400b7ddc577$export$8352ce38b91d0c62 = v; });
$parcel$export(module.exports, "unstable_forceFrameRate", function () { return $5d00b400b7ddc577$export$d66a1c1c77bd778b; }, function (v) { return $5d00b400b7ddc577$export$d66a1c1c77bd778b = v; });
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", function () { return $5d00b400b7ddc577$export$d3dfb8e4810cb555; }, function (v) { return $5d00b400b7ddc577$export$d3dfb8e4810cb555 = v; });
$parcel$export(module.exports, "unstable_getFirstCallbackNode", function () { return $5d00b400b7ddc577$export$839f9183b0465a69; }, function (v) { return $5d00b400b7ddc577$export$839f9183b0465a69 = v; });
$parcel$export(module.exports, "unstable_next", function () { return $5d00b400b7ddc577$export$72fdf0e06517287b; }, function (v) { return $5d00b400b7ddc577$export$72fdf0e06517287b = v; });
$parcel$export(module.exports, "unstable_pauseExecution", function () { return $5d00b400b7ddc577$export$4b844e58a3e414b4; }, function (v) { return $5d00b400b7ddc577$export$4b844e58a3e414b4 = v; });
$parcel$export(module.exports, "unstable_requestPaint", function () { return $5d00b400b7ddc577$export$816d2913ae6b83b1; }, function (v) { return $5d00b400b7ddc577$export$816d2913ae6b83b1 = v; });
$parcel$export(module.exports, "unstable_runWithPriority", function () { return $5d00b400b7ddc577$export$61bcfe829111a1d0; }, function (v) { return $5d00b400b7ddc577$export$61bcfe829111a1d0 = v; });
$parcel$export(module.exports, "unstable_scheduleCallback", function () { return $5d00b400b7ddc577$export$7ee8c9beb337bc3f; }, function (v) { return $5d00b400b7ddc577$export$7ee8c9beb337bc3f = v; });
$parcel$export(module.exports, "unstable_shouldYield", function () { return $5d00b400b7ddc577$export$b5836b71941fa3ed; }, function (v) { return $5d00b400b7ddc577$export$b5836b71941fa3ed = v; });
$parcel$export(module.exports, "unstable_wrapCallback", function () { return $5d00b400b7ddc577$export$cf845f2c119da08a; }, function (v) { return $5d00b400b7ddc577$export$cf845f2c119da08a = v; });
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $5d00b400b7ddc577$export$c4744153514ff05d;
var $5d00b400b7ddc577$export$3e506c1ccc9cc1a7;
var $5d00b400b7ddc577$export$e26fe2ed2fa76875;
var $5d00b400b7ddc577$export$502329bbf4b505b1;
var $5d00b400b7ddc577$export$6e3807111c4874c4;
var $5d00b400b7ddc577$export$c27134553091fb3a;
var $5d00b400b7ddc577$export$33ee1acdc04fd2a2;
var $5d00b400b7ddc577$export$b00a404bbd5edef2;
var $5d00b400b7ddc577$export$8352ce38b91d0c62;
var $5d00b400b7ddc577$export$d66a1c1c77bd778b;
var $5d00b400b7ddc577$export$d3dfb8e4810cb555;
var $5d00b400b7ddc577$export$839f9183b0465a69;
var $5d00b400b7ddc577$export$72fdf0e06517287b;
var $5d00b400b7ddc577$export$4b844e58a3e414b4;
var $5d00b400b7ddc577$export$816d2913ae6b83b1;
var $5d00b400b7ddc577$export$61bcfe829111a1d0;
var $5d00b400b7ddc577$export$7ee8c9beb337bc3f;
var $5d00b400b7ddc577$export$b5836b71941fa3ed;
var $5d00b400b7ddc577$export$cf845f2c119da08a;
'use strict';
function $5d00b400b7ddc577$var$f(a, b) {
    var c = a.length;
    a.push(b);
    a: for(; 0 < c;){
        var d = c - 1 >>> 1, e = a[d];
        if (0 < $5d00b400b7ddc577$var$g(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $5d00b400b7ddc577$var$h(a) {
    return 0 === a.length ? null : a[0];
}
function $5d00b400b7ddc577$var$k(a) {
    if (0 === a.length) return null;
    var b = a[0], c = a.pop();
    if (c !== b) {
        a[0] = c;
        a: for(var d = 0, e = a.length, w = e >>> 1; d < w;){
            var m = 2 * (d + 1) - 1, C = a[m], n = m + 1, x = a[n];
            if (0 > $5d00b400b7ddc577$var$g(C, c)) n < e && 0 > $5d00b400b7ddc577$var$g(x, C) ? (a[d] = x, a[n] = c, d = n) : (a[d] = C, a[m] = c, d = m);
            else if (n < e && 0 > $5d00b400b7ddc577$var$g(x, c)) a[d] = x, a[n] = c, d = n;
            else break a;
        }
    }
    return b;
}
function $5d00b400b7ddc577$var$g(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $5d00b400b7ddc577$var$l = performance;
    $5d00b400b7ddc577$export$c4744153514ff05d = function() {
        return $5d00b400b7ddc577$var$l.now();
    };
} else {
    var $5d00b400b7ddc577$var$p = Date, $5d00b400b7ddc577$var$q = $5d00b400b7ddc577$var$p.now();
    $5d00b400b7ddc577$export$c4744153514ff05d = function() {
        return $5d00b400b7ddc577$var$p.now() - $5d00b400b7ddc577$var$q;
    };
}
var $5d00b400b7ddc577$var$r = [], $5d00b400b7ddc577$var$t = [], $5d00b400b7ddc577$var$u = 1, $5d00b400b7ddc577$var$v = null, $5d00b400b7ddc577$var$y = 3, $5d00b400b7ddc577$var$z = !1, $5d00b400b7ddc577$var$A = !1, $5d00b400b7ddc577$var$B = !1, $5d00b400b7ddc577$var$D = "function" === typeof setTimeout ? setTimeout : null, $5d00b400b7ddc577$var$E = "function" === typeof clearTimeout ? clearTimeout : null, $5d00b400b7ddc577$var$F = "undefined" !== typeof setImmediate ? setImmediate : null;
"undefined" !== typeof navigator && void 0 !== navigator.scheduling && void 0 !== navigator.scheduling.isInputPending && navigator.scheduling.isInputPending.bind(navigator.scheduling);
function $5d00b400b7ddc577$var$G(a) {
    for(var b = $5d00b400b7ddc577$var$h($5d00b400b7ddc577$var$t); null !== b;){
        if (null === b.callback) $5d00b400b7ddc577$var$k($5d00b400b7ddc577$var$t);
        else if (b.startTime <= a) $5d00b400b7ddc577$var$k($5d00b400b7ddc577$var$t), b.sortIndex = b.expirationTime, $5d00b400b7ddc577$var$f($5d00b400b7ddc577$var$r, b);
        else break;
        b = $5d00b400b7ddc577$var$h($5d00b400b7ddc577$var$t);
    }
}
function $5d00b400b7ddc577$var$H(a) {
    $5d00b400b7ddc577$var$B = !1;
    $5d00b400b7ddc577$var$G(a);
    if (!$5d00b400b7ddc577$var$A) {
        if (null !== $5d00b400b7ddc577$var$h($5d00b400b7ddc577$var$r)) $5d00b400b7ddc577$var$A = !0, $5d00b400b7ddc577$var$I($5d00b400b7ddc577$var$J);
        else {
            var b = $5d00b400b7ddc577$var$h($5d00b400b7ddc577$var$t);
            null !== b && $5d00b400b7ddc577$var$K($5d00b400b7ddc577$var$H, b.startTime - a);
        }
    }
}
function $5d00b400b7ddc577$var$J(a, b) {
    $5d00b400b7ddc577$var$A = !1;
    $5d00b400b7ddc577$var$B && ($5d00b400b7ddc577$var$B = !1, $5d00b400b7ddc577$var$E($5d00b400b7ddc577$var$L), $5d00b400b7ddc577$var$L = -1);
    $5d00b400b7ddc577$var$z = !0;
    var c = $5d00b400b7ddc577$var$y;
    try {
        $5d00b400b7ddc577$var$G(b);
        for($5d00b400b7ddc577$var$v = $5d00b400b7ddc577$var$h($5d00b400b7ddc577$var$r); null !== $5d00b400b7ddc577$var$v && (!($5d00b400b7ddc577$var$v.expirationTime > b) || a && !$5d00b400b7ddc577$var$M());){
            var d = $5d00b400b7ddc577$var$v.callback;
            if ("function" === typeof d) {
                $5d00b400b7ddc577$var$v.callback = null;
                $5d00b400b7ddc577$var$y = $5d00b400b7ddc577$var$v.priorityLevel;
                var e = d($5d00b400b7ddc577$var$v.expirationTime <= b);
                b = $5d00b400b7ddc577$export$c4744153514ff05d();
                "function" === typeof e ? $5d00b400b7ddc577$var$v.callback = e : $5d00b400b7ddc577$var$v === $5d00b400b7ddc577$var$h($5d00b400b7ddc577$var$r) && $5d00b400b7ddc577$var$k($5d00b400b7ddc577$var$r);
                $5d00b400b7ddc577$var$G(b);
            } else $5d00b400b7ddc577$var$k($5d00b400b7ddc577$var$r);
            $5d00b400b7ddc577$var$v = $5d00b400b7ddc577$var$h($5d00b400b7ddc577$var$r);
        }
        if (null !== $5d00b400b7ddc577$var$v) var w = !0;
        else {
            var m = $5d00b400b7ddc577$var$h($5d00b400b7ddc577$var$t);
            null !== m && $5d00b400b7ddc577$var$K($5d00b400b7ddc577$var$H, m.startTime - b);
            w = !1;
        }
        return w;
    } finally{
        $5d00b400b7ddc577$var$v = null, $5d00b400b7ddc577$var$y = c, $5d00b400b7ddc577$var$z = !1;
    }
}
var $5d00b400b7ddc577$var$N = !1, $5d00b400b7ddc577$var$O = null, $5d00b400b7ddc577$var$L = -1, $5d00b400b7ddc577$var$P = 5, $5d00b400b7ddc577$var$Q = -1;
function $5d00b400b7ddc577$var$M() {
    return $5d00b400b7ddc577$export$c4744153514ff05d() - $5d00b400b7ddc577$var$Q < $5d00b400b7ddc577$var$P ? !1 : !0;
}
function $5d00b400b7ddc577$var$R() {
    if (null !== $5d00b400b7ddc577$var$O) {
        var a = $5d00b400b7ddc577$export$c4744153514ff05d();
        $5d00b400b7ddc577$var$Q = a;
        var b = !0;
        try {
            b = $5d00b400b7ddc577$var$O(!0, a);
        } finally{
            b ? $5d00b400b7ddc577$var$S() : ($5d00b400b7ddc577$var$N = !1, $5d00b400b7ddc577$var$O = null);
        }
    } else $5d00b400b7ddc577$var$N = !1;
}
var $5d00b400b7ddc577$var$S;
if ("function" === typeof $5d00b400b7ddc577$var$F) $5d00b400b7ddc577$var$S = function() {
    $5d00b400b7ddc577$var$F($5d00b400b7ddc577$var$R);
};
else if ("undefined" !== typeof MessageChannel) {
    var $5d00b400b7ddc577$var$T = new MessageChannel, $5d00b400b7ddc577$var$U = $5d00b400b7ddc577$var$T.port2;
    $5d00b400b7ddc577$var$T.port1.onmessage = $5d00b400b7ddc577$var$R;
    $5d00b400b7ddc577$var$S = function() {
        $5d00b400b7ddc577$var$U.postMessage(null);
    };
} else $5d00b400b7ddc577$var$S = function() {
    $5d00b400b7ddc577$var$D($5d00b400b7ddc577$var$R, 0);
};
function $5d00b400b7ddc577$var$I(a) {
    $5d00b400b7ddc577$var$O = a;
    $5d00b400b7ddc577$var$N || ($5d00b400b7ddc577$var$N = !0, $5d00b400b7ddc577$var$S());
}
function $5d00b400b7ddc577$var$K(a, b) {
    $5d00b400b7ddc577$var$L = $5d00b400b7ddc577$var$D(function() {
        a($5d00b400b7ddc577$export$c4744153514ff05d());
    }, b);
}
$5d00b400b7ddc577$export$3e506c1ccc9cc1a7 = 5;
$5d00b400b7ddc577$export$e26fe2ed2fa76875 = 1;
$5d00b400b7ddc577$export$502329bbf4b505b1 = 4;
$5d00b400b7ddc577$export$6e3807111c4874c4 = 3;
$5d00b400b7ddc577$export$c27134553091fb3a = null;
$5d00b400b7ddc577$export$33ee1acdc04fd2a2 = 2;
$5d00b400b7ddc577$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$5d00b400b7ddc577$export$8352ce38b91d0c62 = function() {
    $5d00b400b7ddc577$var$A || $5d00b400b7ddc577$var$z || ($5d00b400b7ddc577$var$A = !0, $5d00b400b7ddc577$var$I($5d00b400b7ddc577$var$J));
};
$5d00b400b7ddc577$export$d66a1c1c77bd778b = function(a) {
    0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $5d00b400b7ddc577$var$P = 0 < a ? Math.floor(1E3 / a) : 5;
};
$5d00b400b7ddc577$export$d3dfb8e4810cb555 = function() {
    return $5d00b400b7ddc577$var$y;
};
$5d00b400b7ddc577$export$839f9183b0465a69 = function() {
    return $5d00b400b7ddc577$var$h($5d00b400b7ddc577$var$r);
};
$5d00b400b7ddc577$export$72fdf0e06517287b = function(a) {
    switch($5d00b400b7ddc577$var$y){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $5d00b400b7ddc577$var$y;
    }
    var c = $5d00b400b7ddc577$var$y;
    $5d00b400b7ddc577$var$y = b;
    try {
        return a();
    } finally{
        $5d00b400b7ddc577$var$y = c;
    }
};
$5d00b400b7ddc577$export$4b844e58a3e414b4 = function() {};
$5d00b400b7ddc577$export$816d2913ae6b83b1 = function() {};
$5d00b400b7ddc577$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $5d00b400b7ddc577$var$y;
    $5d00b400b7ddc577$var$y = a;
    try {
        return b();
    } finally{
        $5d00b400b7ddc577$var$y = c;
    }
};
$5d00b400b7ddc577$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $5d00b400b7ddc577$export$c4744153514ff05d();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: $5d00b400b7ddc577$var$u++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, $5d00b400b7ddc577$var$f($5d00b400b7ddc577$var$t, a), null === $5d00b400b7ddc577$var$h($5d00b400b7ddc577$var$r) && a === $5d00b400b7ddc577$var$h($5d00b400b7ddc577$var$t) && ($5d00b400b7ddc577$var$B ? ($5d00b400b7ddc577$var$E($5d00b400b7ddc577$var$L), $5d00b400b7ddc577$var$L = -1) : $5d00b400b7ddc577$var$B = !0, $5d00b400b7ddc577$var$K($5d00b400b7ddc577$var$H, c - d))) : (a.sortIndex = e, $5d00b400b7ddc577$var$f($5d00b400b7ddc577$var$r, a), $5d00b400b7ddc577$var$A || $5d00b400b7ddc577$var$z || ($5d00b400b7ddc577$var$A = !0, $5d00b400b7ddc577$var$I($5d00b400b7ddc577$var$J)));
    return a;
};
$5d00b400b7ddc577$export$b5836b71941fa3ed = $5d00b400b7ddc577$var$M;
$5d00b400b7ddc577$export$cf845f2c119da08a = function(a) {
    var b = $5d00b400b7ddc577$var$y;
    return function() {
        var c = $5d00b400b7ddc577$var$y;
        $5d00b400b7ddc577$var$y = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $5d00b400b7ddc577$var$y = c;
        }
    };
};

});



parcelRegister("6vfKF", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';

var $dry2W = parcelRequire("dry2W");
function $4bc1db4cf0ee3eed$var$emptyFunction() {}
function $4bc1db4cf0ee3eed$var$emptyFunctionWithReset() {}
$4bc1db4cf0ee3eed$var$emptyFunctionWithReset.resetWarningCache = $4bc1db4cf0ee3eed$var$emptyFunction;
module.exports = function() {
    function shim(props, propName, componentName, location, propFullName, secret) {
        if (secret === $dry2W) // It is still safe when called from React.
        return;
        var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        err.name = 'Invariant Violation';
        throw err;
    }
    shim.isRequired = shim;
    function getShim() {
        return shim;
    }
    // Important!
    // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
    var ReactPropTypes = {
        array: shim,
        bigint: shim,
        bool: shim,
        func: shim,
        number: shim,
        object: shim,
        string: shim,
        symbol: shim,
        any: shim,
        arrayOf: getShim,
        element: shim,
        elementType: shim,
        instanceOf: getShim,
        node: shim,
        objectOf: getShim,
        oneOf: getShim,
        oneOfType: getShim,
        shape: getShim,
        exact: getShim,
        checkPropTypes: $4bc1db4cf0ee3eed$var$emptyFunctionWithReset,
        resetWarningCache: $4bc1db4cf0ee3eed$var$emptyFunction
    };
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
};

});
parcelRegister("dry2W", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
var $9c9834e516aea350$var$ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
module.exports = $9c9834e516aea350$var$ReactPropTypesSecret;

});


parcelRegister("3ku9g", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return (parcelRequire("lqJfJ")).default; });

var $lqJfJ = parcelRequire("lqJfJ");

});
parcelRegister("lqJfJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f99f20e8c95a37ec$export$2e2bcd8739ae039; });
/**
 * WARNING: Don't import this directly.
 * Use `MuiError` from `@mui/internal-babel-macros/MuiError.macro` instead.
 * @param {number} code
 */ function $f99f20e8c95a37ec$export$2e2bcd8739ae039(code) {
    // Apply babel-plugin-transform-template-literals in loose mode
    // loose mode is safe if we're concatenating primitives
    // see https://babeljs.io/docs/en/babel-plugin-transform-template-literals#loose
    /* eslint-disable prefer-template */ let url = 'https://mui.com/production-error/?code=' + code;
    for(let i = 1; i < arguments.length; i += 1)// rest params over-transpile for this case
    // eslint-disable-next-line prefer-rest-params
    url += '&args[]=' + encodeURIComponent(arguments[i]);
    return 'Minified MUI error #' + code + '; visit ' + url + ' for the full message.';
/* eslint-enable prefer-template */ }

});


parcelRegister("lqyB7", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return (parcelRequire("cGwaF")).default; });

var $cGwaF = parcelRequire("cGwaF");

});
parcelRegister("cGwaF", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $93c25cc6e1f17531$export$2e2bcd8739ae039; });
function $93c25cc6e1f17531$var$clamp(val, min = Number.MIN_SAFE_INTEGER, max = Number.MAX_SAFE_INTEGER) {
    return Math.max(min, Math.min(val, max));
}
var $93c25cc6e1f17531$export$2e2bcd8739ae039 = $93c25cc6e1f17531$var$clamp;

});


parcelRegister("k5gu5", function(module, exports) {

$parcel$export(module.exports, "AsyncMode", function () { return $e9f10fb52638c346$export$2b8d127b894957b9; }, function (v) { return $e9f10fb52638c346$export$2b8d127b894957b9 = v; });
$parcel$export(module.exports, "ConcurrentMode", function () { return $e9f10fb52638c346$export$cea3a54a6425200c; }, function (v) { return $e9f10fb52638c346$export$cea3a54a6425200c = v; });
$parcel$export(module.exports, "ContextConsumer", function () { return $e9f10fb52638c346$export$a7c73072b1a182ae; }, function (v) { return $e9f10fb52638c346$export$a7c73072b1a182ae = v; });
$parcel$export(module.exports, "ContextProvider", function () { return $e9f10fb52638c346$export$9f27bc3417b4524d; }, function (v) { return $e9f10fb52638c346$export$9f27bc3417b4524d = v; });
$parcel$export(module.exports, "Element", function () { return $e9f10fb52638c346$export$db77ccec0bb4ccac; }, function (v) { return $e9f10fb52638c346$export$db77ccec0bb4ccac = v; });
$parcel$export(module.exports, "ForwardRef", function () { return $e9f10fb52638c346$export$8392c0c9d3dcbd35; }, function (v) { return $e9f10fb52638c346$export$8392c0c9d3dcbd35 = v; });
$parcel$export(module.exports, "Fragment", function () { return $e9f10fb52638c346$export$ffb0004e005737fa; }, function (v) { return $e9f10fb52638c346$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Lazy", function () { return $e9f10fb52638c346$export$b624eff549462981; }, function (v) { return $e9f10fb52638c346$export$b624eff549462981 = v; });
$parcel$export(module.exports, "Memo", function () { return $e9f10fb52638c346$export$7897aa7841a5380c; }, function (v) { return $e9f10fb52638c346$export$7897aa7841a5380c = v; });
$parcel$export(module.exports, "Portal", function () { return $e9f10fb52638c346$export$602eac185826482c; }, function (v) { return $e9f10fb52638c346$export$602eac185826482c = v; });
$parcel$export(module.exports, "Profiler", function () { return $e9f10fb52638c346$export$e2c29f18771995cb; }, function (v) { return $e9f10fb52638c346$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "StrictMode", function () { return $e9f10fb52638c346$export$5f8d39834fd61797; }, function (v) { return $e9f10fb52638c346$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $e9f10fb52638c346$export$74bf444e3cd11ea5; }, function (v) { return $e9f10fb52638c346$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "isAsyncMode", function () { return $e9f10fb52638c346$export$92387174baf9b227; }, function (v) { return $e9f10fb52638c346$export$92387174baf9b227 = v; });
$parcel$export(module.exports, "isConcurrentMode", function () { return $e9f10fb52638c346$export$ec112efeb987d9c6; }, function (v) { return $e9f10fb52638c346$export$ec112efeb987d9c6 = v; });
$parcel$export(module.exports, "isContextConsumer", function () { return $e9f10fb52638c346$export$b706b080d889d2c9; }, function (v) { return $e9f10fb52638c346$export$b706b080d889d2c9 = v; });
$parcel$export(module.exports, "isContextProvider", function () { return $e9f10fb52638c346$export$5be5a87408f70ddc; }, function (v) { return $e9f10fb52638c346$export$5be5a87408f70ddc = v; });
$parcel$export(module.exports, "isElement", function () { return $e9f10fb52638c346$export$45a5e7f76e0caa8d; }, function (v) { return $e9f10fb52638c346$export$45a5e7f76e0caa8d = v; });
$parcel$export(module.exports, "isForwardRef", function () { return $e9f10fb52638c346$export$455c2e768291efa6; }, function (v) { return $e9f10fb52638c346$export$455c2e768291efa6 = v; });
$parcel$export(module.exports, "isFragment", function () { return $e9f10fb52638c346$export$9522e17588c12572; }, function (v) { return $e9f10fb52638c346$export$9522e17588c12572 = v; });
$parcel$export(module.exports, "isLazy", function () { return $e9f10fb52638c346$export$2110ac352bb060b9; }, function (v) { return $e9f10fb52638c346$export$2110ac352bb060b9 = v; });
$parcel$export(module.exports, "isMemo", function () { return $e9f10fb52638c346$export$56885ab8b9c456ab; }, function (v) { return $e9f10fb52638c346$export$56885ab8b9c456ab = v; });
$parcel$export(module.exports, "isPortal", function () { return $e9f10fb52638c346$export$d927fcb6adf8f9de; }, function (v) { return $e9f10fb52638c346$export$d927fcb6adf8f9de = v; });
$parcel$export(module.exports, "isProfiler", function () { return $e9f10fb52638c346$export$b82d16f27459e05a; }, function (v) { return $e9f10fb52638c346$export$b82d16f27459e05a = v; });
$parcel$export(module.exports, "isStrictMode", function () { return $e9f10fb52638c346$export$522c17b4f5e123e8; }, function (v) { return $e9f10fb52638c346$export$522c17b4f5e123e8 = v; });
$parcel$export(module.exports, "isSuspense", function () { return $e9f10fb52638c346$export$1aabd8a0274ecfd6; }, function (v) { return $e9f10fb52638c346$export$1aabd8a0274ecfd6 = v; });
$parcel$export(module.exports, "isValidElementType", function () { return $e9f10fb52638c346$export$9b621391a187a31a; }, function (v) { return $e9f10fb52638c346$export$9b621391a187a31a = v; });
$parcel$export(module.exports, "typeOf", function () { return $e9f10fb52638c346$export$f5bbd400c2f4426f; }, function (v) { return $e9f10fb52638c346$export$f5bbd400c2f4426f = v; });
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $e9f10fb52638c346$export$2b8d127b894957b9;
var $e9f10fb52638c346$export$cea3a54a6425200c;
var $e9f10fb52638c346$export$a7c73072b1a182ae;
var $e9f10fb52638c346$export$9f27bc3417b4524d;
var $e9f10fb52638c346$export$db77ccec0bb4ccac;
var $e9f10fb52638c346$export$8392c0c9d3dcbd35;
var $e9f10fb52638c346$export$ffb0004e005737fa;
var $e9f10fb52638c346$export$b624eff549462981;
var $e9f10fb52638c346$export$7897aa7841a5380c;
var $e9f10fb52638c346$export$602eac185826482c;
var $e9f10fb52638c346$export$e2c29f18771995cb;
var $e9f10fb52638c346$export$5f8d39834fd61797;
var $e9f10fb52638c346$export$74bf444e3cd11ea5;
var $e9f10fb52638c346$export$92387174baf9b227;
var $e9f10fb52638c346$export$ec112efeb987d9c6;
var $e9f10fb52638c346$export$b706b080d889d2c9;
var $e9f10fb52638c346$export$5be5a87408f70ddc;
var $e9f10fb52638c346$export$45a5e7f76e0caa8d;
var $e9f10fb52638c346$export$455c2e768291efa6;
var $e9f10fb52638c346$export$9522e17588c12572;
var $e9f10fb52638c346$export$2110ac352bb060b9;
var $e9f10fb52638c346$export$56885ab8b9c456ab;
var $e9f10fb52638c346$export$d927fcb6adf8f9de;
var $e9f10fb52638c346$export$b82d16f27459e05a;
var $e9f10fb52638c346$export$522c17b4f5e123e8;
var $e9f10fb52638c346$export$1aabd8a0274ecfd6;
var $e9f10fb52638c346$export$9b621391a187a31a;
var $e9f10fb52638c346$export$f5bbd400c2f4426f;
'use strict';
var $e9f10fb52638c346$var$b = "function" === typeof Symbol && Symbol.for, $e9f10fb52638c346$var$c = $e9f10fb52638c346$var$b ? Symbol.for("react.element") : 60103, $e9f10fb52638c346$var$d = $e9f10fb52638c346$var$b ? Symbol.for("react.portal") : 60106, $e9f10fb52638c346$var$e = $e9f10fb52638c346$var$b ? Symbol.for("react.fragment") : 60107, $e9f10fb52638c346$var$f = $e9f10fb52638c346$var$b ? Symbol.for("react.strict_mode") : 60108, $e9f10fb52638c346$var$g = $e9f10fb52638c346$var$b ? Symbol.for("react.profiler") : 60114, $e9f10fb52638c346$var$h = $e9f10fb52638c346$var$b ? Symbol.for("react.provider") : 60109, $e9f10fb52638c346$var$k = $e9f10fb52638c346$var$b ? Symbol.for("react.context") : 60110, $e9f10fb52638c346$var$l = $e9f10fb52638c346$var$b ? Symbol.for("react.async_mode") : 60111, $e9f10fb52638c346$var$m = $e9f10fb52638c346$var$b ? Symbol.for("react.concurrent_mode") : 60111, $e9f10fb52638c346$var$n = $e9f10fb52638c346$var$b ? Symbol.for("react.forward_ref") : 60112, $e9f10fb52638c346$var$p = $e9f10fb52638c346$var$b ? Symbol.for("react.suspense") : 60113, $e9f10fb52638c346$var$q = $e9f10fb52638c346$var$b ? Symbol.for("react.suspense_list") : 60120, $e9f10fb52638c346$var$r = $e9f10fb52638c346$var$b ? Symbol.for("react.memo") : 60115, $e9f10fb52638c346$var$t = $e9f10fb52638c346$var$b ? Symbol.for("react.lazy") : 60116, $e9f10fb52638c346$var$v = $e9f10fb52638c346$var$b ? Symbol.for("react.block") : 60121, $e9f10fb52638c346$var$w = $e9f10fb52638c346$var$b ? Symbol.for("react.fundamental") : 60117, $e9f10fb52638c346$var$x = $e9f10fb52638c346$var$b ? Symbol.for("react.responder") : 60118, $e9f10fb52638c346$var$y = $e9f10fb52638c346$var$b ? Symbol.for("react.scope") : 60119;
function $e9f10fb52638c346$var$z(a) {
    if ("object" === typeof a && null !== a) {
        var u = a.$$typeof;
        switch(u){
            case $e9f10fb52638c346$var$c:
                switch(a = a.type, a){
                    case $e9f10fb52638c346$var$l:
                    case $e9f10fb52638c346$var$m:
                    case $e9f10fb52638c346$var$e:
                    case $e9f10fb52638c346$var$g:
                    case $e9f10fb52638c346$var$f:
                    case $e9f10fb52638c346$var$p:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $e9f10fb52638c346$var$k:
                            case $e9f10fb52638c346$var$n:
                            case $e9f10fb52638c346$var$t:
                            case $e9f10fb52638c346$var$r:
                            case $e9f10fb52638c346$var$h:
                                return a;
                            default:
                                return u;
                        }
                }
            case $e9f10fb52638c346$var$d:
                return u;
        }
    }
}
function $e9f10fb52638c346$var$A(a) {
    return $e9f10fb52638c346$var$z(a) === $e9f10fb52638c346$var$m;
}
$e9f10fb52638c346$export$2b8d127b894957b9 = $e9f10fb52638c346$var$l;
$e9f10fb52638c346$export$cea3a54a6425200c = $e9f10fb52638c346$var$m;
$e9f10fb52638c346$export$a7c73072b1a182ae = $e9f10fb52638c346$var$k;
$e9f10fb52638c346$export$9f27bc3417b4524d = $e9f10fb52638c346$var$h;
$e9f10fb52638c346$export$db77ccec0bb4ccac = $e9f10fb52638c346$var$c;
$e9f10fb52638c346$export$8392c0c9d3dcbd35 = $e9f10fb52638c346$var$n;
$e9f10fb52638c346$export$ffb0004e005737fa = $e9f10fb52638c346$var$e;
$e9f10fb52638c346$export$b624eff549462981 = $e9f10fb52638c346$var$t;
$e9f10fb52638c346$export$7897aa7841a5380c = $e9f10fb52638c346$var$r;
$e9f10fb52638c346$export$602eac185826482c = $e9f10fb52638c346$var$d;
$e9f10fb52638c346$export$e2c29f18771995cb = $e9f10fb52638c346$var$g;
$e9f10fb52638c346$export$5f8d39834fd61797 = $e9f10fb52638c346$var$f;
$e9f10fb52638c346$export$74bf444e3cd11ea5 = $e9f10fb52638c346$var$p;
$e9f10fb52638c346$export$92387174baf9b227 = function(a) {
    return $e9f10fb52638c346$var$A(a) || $e9f10fb52638c346$var$z(a) === $e9f10fb52638c346$var$l;
};
$e9f10fb52638c346$export$ec112efeb987d9c6 = $e9f10fb52638c346$var$A;
$e9f10fb52638c346$export$b706b080d889d2c9 = function(a) {
    return $e9f10fb52638c346$var$z(a) === $e9f10fb52638c346$var$k;
};
$e9f10fb52638c346$export$5be5a87408f70ddc = function(a) {
    return $e9f10fb52638c346$var$z(a) === $e9f10fb52638c346$var$h;
};
$e9f10fb52638c346$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $e9f10fb52638c346$var$c;
};
$e9f10fb52638c346$export$455c2e768291efa6 = function(a) {
    return $e9f10fb52638c346$var$z(a) === $e9f10fb52638c346$var$n;
};
$e9f10fb52638c346$export$9522e17588c12572 = function(a) {
    return $e9f10fb52638c346$var$z(a) === $e9f10fb52638c346$var$e;
};
$e9f10fb52638c346$export$2110ac352bb060b9 = function(a) {
    return $e9f10fb52638c346$var$z(a) === $e9f10fb52638c346$var$t;
};
$e9f10fb52638c346$export$56885ab8b9c456ab = function(a) {
    return $e9f10fb52638c346$var$z(a) === $e9f10fb52638c346$var$r;
};
$e9f10fb52638c346$export$d927fcb6adf8f9de = function(a) {
    return $e9f10fb52638c346$var$z(a) === $e9f10fb52638c346$var$d;
};
$e9f10fb52638c346$export$b82d16f27459e05a = function(a) {
    return $e9f10fb52638c346$var$z(a) === $e9f10fb52638c346$var$g;
};
$e9f10fb52638c346$export$522c17b4f5e123e8 = function(a) {
    return $e9f10fb52638c346$var$z(a) === $e9f10fb52638c346$var$f;
};
$e9f10fb52638c346$export$1aabd8a0274ecfd6 = function(a) {
    return $e9f10fb52638c346$var$z(a) === $e9f10fb52638c346$var$p;
};
$e9f10fb52638c346$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $e9f10fb52638c346$var$e || a === $e9f10fb52638c346$var$m || a === $e9f10fb52638c346$var$g || a === $e9f10fb52638c346$var$f || a === $e9f10fb52638c346$var$p || a === $e9f10fb52638c346$var$q || "object" === typeof a && null !== a && (a.$$typeof === $e9f10fb52638c346$var$t || a.$$typeof === $e9f10fb52638c346$var$r || a.$$typeof === $e9f10fb52638c346$var$h || a.$$typeof === $e9f10fb52638c346$var$k || a.$$typeof === $e9f10fb52638c346$var$n || a.$$typeof === $e9f10fb52638c346$var$w || a.$$typeof === $e9f10fb52638c346$var$x || a.$$typeof === $e9f10fb52638c346$var$y || a.$$typeof === $e9f10fb52638c346$var$v);
};
$e9f10fb52638c346$export$f5bbd400c2f4426f = $e9f10fb52638c346$var$z;

});

parcelRegister("b3LQA", function(module, exports) {
function $80d516ff880ca176$var$_extends() {
    return module.exports = $80d516ff880ca176$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $80d516ff880ca176$var$_extends.apply(null, arguments);
}
module.exports = $80d516ff880ca176$var$_extends, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("5S2Z8", function(module, exports) {
function $44644facbdc24156$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
module.exports = $44644facbdc24156$var$_objectWithoutPropertiesLoose, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("9Ie0W", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $7123180742c952f0$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "internal_processStyles", function () { return $7123180742c952f0$export$e00380445f2b9e0c; });
$parcel$export(module.exports, "ThemeContext", function () { return (parcelRequire("ll1Nc")).T; });
$parcel$export(module.exports, "keyframes", function () { return (parcelRequire("d0nrV")).keyframes; });
$parcel$export(module.exports, "css", function () { return (parcelRequire("d0nrV")).css; });
$parcel$export(module.exports, "StyledEngineProvider", function () { return (parcelRequire("2dJfV")).default; });
$parcel$export(module.exports, "GlobalStyles", function () { return (parcelRequire("TgYhg")).default; });
/**
 * @mui/styled-engine v5.16.14
 *
 * @license MIT
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 
var $aq7Z4 = parcelRequire("aq7Z4");

var $d0nrV = parcelRequire("d0nrV");
var $ll1Nc = parcelRequire("ll1Nc");

var $2dJfV = parcelRequire("2dJfV");

var $TgYhg = parcelRequire("TgYhg");
'use client';
function $7123180742c952f0$export$2e2bcd8739ae039(tag, options) {
    const stylesFactory = (0, $aq7Z4.default)(tag, options);
    var styles, style;
    return stylesFactory;
}
const $7123180742c952f0$export$e00380445f2b9e0c = (tag, processor)=>{
    // Emotion attaches all the styles as `__emotion_styles`.
    // Ref: https://github.com/emotion-js/emotion/blob/16d971d0da229596d6bcc39d282ba9753c9ee7cf/packages/styled/src/base.js#L186
    if (Array.isArray(tag.__emotion_styles)) tag.__emotion_styles = processor(tag.__emotion_styles);
};

});
parcelRegister("aq7Z4", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $79628692ce3862ac$export$2e2bcd8739ae039; });

var $e2fjg = parcelRequire("e2fjg");
parcelRequire("b3LQA");

parcelRequire("hs5T6");
parcelRequire("fPM9Q");
parcelRequire("9nBLf");
parcelRequire("gJYWc");
parcelRequire("f3Y7Z");
var $79628692ce3862ac$var$tags = [
    'a',
    'abbr',
    'address',
    'area',
    'article',
    'aside',
    'audio',
    'b',
    'base',
    'bdi',
    'bdo',
    'big',
    'blockquote',
    'body',
    'br',
    'button',
    'canvas',
    'caption',
    'cite',
    'code',
    'col',
    'colgroup',
    'data',
    'datalist',
    'dd',
    'del',
    'details',
    'dfn',
    'dialog',
    'div',
    'dl',
    'dt',
    'em',
    'embed',
    'fieldset',
    'figcaption',
    'figure',
    'footer',
    'form',
    'h1',
    'h2',
    'h3',
    'h4',
    'h5',
    'h6',
    'head',
    'header',
    'hgroup',
    'hr',
    'html',
    'i',
    'iframe',
    'img',
    'input',
    'ins',
    'kbd',
    'keygen',
    'label',
    'legend',
    'li',
    'link',
    'main',
    'map',
    'mark',
    'marquee',
    'menu',
    'menuitem',
    'meta',
    'meter',
    'nav',
    'noscript',
    'object',
    'ol',
    'optgroup',
    'option',
    'output',
    'p',
    'param',
    'picture',
    'pre',
    'progress',
    'q',
    'rp',
    'rt',
    'ruby',
    's',
    'samp',
    'script',
    'section',
    'select',
    'small',
    'source',
    'span',
    'strong',
    'style',
    'sub',
    'summary',
    'sup',
    'table',
    'tbody',
    'td',
    'textarea',
    'tfoot',
    'th',
    'thead',
    'time',
    'title',
    'tr',
    'track',
    'u',
    'ul',
    'var',
    'video',
    'wbr',
    'circle',
    'clipPath',
    'defs',
    'ellipse',
    'foreignObject',
    'g',
    'image',
    'line',
    'linearGradient',
    'mask',
    'path',
    'pattern',
    'polygon',
    'polyline',
    'radialGradient',
    'rect',
    'stop',
    'svg',
    'text',
    'tspan'
];
// bind it to avoid mutating the original function
var $79628692ce3862ac$export$2e2bcd8739ae039 = (0, $e2fjg.default).bind(null);
$79628692ce3862ac$var$tags.forEach(function(tagName) {
    $79628692ce3862ac$export$2e2bcd8739ae039[tagName] = $79628692ce3862ac$export$2e2bcd8739ae039(tagName);
});

});
parcelRegister("e2fjg", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a37d20cbc69dfd2a$export$2e2bcd8739ae039; });

var $3VnFq = parcelRequire("3VnFq");
parcelRequire("d0nrV");
var $ll1Nc = parcelRequire("ll1Nc");

var $hs5T6 = parcelRequire("hs5T6");

var $fPM9Q = parcelRequire("fPM9Q");

var $9nBLf = parcelRequire("9nBLf");

var $gJYWc = parcelRequire("gJYWc");

var $f3Y7Z = parcelRequire("f3Y7Z");
var $a37d20cbc69dfd2a$var$isBrowser = typeof document !== 'undefined';
var $a37d20cbc69dfd2a$var$isDevelopment = false;
var $a37d20cbc69dfd2a$var$testOmitPropsOnStringTag = (0, $f3Y7Z.default);
var $a37d20cbc69dfd2a$var$testOmitPropsOnComponent = function testOmitPropsOnComponent(key) {
    return key !== 'theme';
};
var $a37d20cbc69dfd2a$var$getDefaultShouldForwardProp = function getDefaultShouldForwardProp(tag) {
    return typeof tag === 'string' && // 96 is one less than the char code
    // for "a" so this is checking that
    // it's a lowercase character
    tag.charCodeAt(0) > 96 ? $a37d20cbc69dfd2a$var$testOmitPropsOnStringTag : $a37d20cbc69dfd2a$var$testOmitPropsOnComponent;
};
var $a37d20cbc69dfd2a$var$composeShouldForwardProps = function composeShouldForwardProps(tag, options, isReal) {
    var shouldForwardProp;
    if (options) {
        var optionsShouldForwardProp = options.shouldForwardProp;
        shouldForwardProp = tag.__emotion_forwardProp && optionsShouldForwardProp ? function(propName) {
            return tag.__emotion_forwardProp(propName) && optionsShouldForwardProp(propName);
        } : optionsShouldForwardProp;
    }
    if (typeof shouldForwardProp !== 'function' && isReal) shouldForwardProp = tag.__emotion_forwardProp;
    return shouldForwardProp;
};
var $a37d20cbc69dfd2a$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serialized = _ref.serialized, isStringTag = _ref.isStringTag;
    (0, $9nBLf.registerStyles)(cache, serialized, isStringTag);
    var rules = (0, $fPM9Q.useInsertionEffectAlwaysWithSyncFallback)(function() {
        return (0, $9nBLf.insertStyles)(cache, serialized, isStringTag);
    });
    if (!$a37d20cbc69dfd2a$var$isBrowser && rules !== undefined) {
        var _ref2;
        var serializedNames = serialized.name;
        var next = serialized.next;
        while(next !== undefined){
            serializedNames += ' ' + next.name;
            next = next.next;
        }
        return /*#__PURE__*/ $gJYWc.createElement("style", (_ref2 = {}, _ref2["data-emotion"] = cache.key + " " + serializedNames, _ref2.dangerouslySetInnerHTML = {
            __html: rules
        }, _ref2.nonce = cache.sheet.nonce, _ref2));
    }
    return null;
};
var $a37d20cbc69dfd2a$export$2e2bcd8739ae039 = function createStyled(tag, options) {
    var isReal = tag.__emotion_real === tag;
    var baseTag = isReal && tag.__emotion_base || tag;
    var identifierName;
    var targetClassName;
    if (options !== undefined) {
        identifierName = options.label;
        targetClassName = options.target;
    }
    var shouldForwardProp = $a37d20cbc69dfd2a$var$composeShouldForwardProps(tag, options, isReal);
    var defaultShouldForwardProp = shouldForwardProp || $a37d20cbc69dfd2a$var$getDefaultShouldForwardProp(baseTag);
    var shouldUseAs = !defaultShouldForwardProp('as');
    return function() {
        // eslint-disable-next-line prefer-rest-params
        var args = arguments;
        var styles = isReal && tag.__emotion_styles !== undefined ? tag.__emotion_styles.slice(0) : [];
        if (identifierName !== undefined) styles.push("label:" + identifierName + ";");
        if (args[0] == null || args[0].raw === undefined) // eslint-disable-next-line prefer-spread
        styles.push.apply(styles, args);
        else {
            var templateStringsArr = args[0];
            styles.push(templateStringsArr[0]);
            var len = args.length;
            var i = 1;
            for(; i < len; i++)styles.push(args[i], templateStringsArr[i]);
        }
        var Styled = (0, $ll1Nc.w)(function(props, cache, ref) {
            var FinalTag = shouldUseAs && props.as || baseTag;
            var className = '';
            var classInterpolations = [];
            var mergedProps = props;
            if (props.theme == null) {
                mergedProps = {};
                for(var key in props)mergedProps[key] = props[key];
                mergedProps.theme = $gJYWc.useContext((0, $ll1Nc.T));
            }
            if (typeof props.className === 'string') className = (0, $9nBLf.getRegisteredStyles)(cache.registered, classInterpolations, props.className);
            else if (props.className != null) className = props.className + " ";
            var serialized = (0, $hs5T6.serializeStyles)(styles.concat(classInterpolations), cache.registered, mergedProps);
            className += cache.key + "-" + serialized.name;
            if (targetClassName !== undefined) className += " " + targetClassName;
            var finalShouldForwardProp = shouldUseAs && shouldForwardProp === undefined ? $a37d20cbc69dfd2a$var$getDefaultShouldForwardProp(FinalTag) : defaultShouldForwardProp;
            var newProps = {};
            for(var _key in props){
                if (shouldUseAs && _key === 'as') continue;
                if (finalShouldForwardProp(_key)) newProps[_key] = props[_key];
            }
            newProps.className = className;
            if (ref) newProps.ref = ref;
            return /*#__PURE__*/ $gJYWc.createElement($gJYWc.Fragment, null, /*#__PURE__*/ $gJYWc.createElement($a37d20cbc69dfd2a$var$Insertion, {
                cache: cache,
                serialized: serialized,
                isStringTag: typeof FinalTag === 'string'
            }), /*#__PURE__*/ $gJYWc.createElement(FinalTag, newProps));
        });
        Styled.displayName = identifierName !== undefined ? identifierName : "Styled(" + (typeof baseTag === 'string' ? baseTag : baseTag.displayName || baseTag.name || 'Component') + ")";
        Styled.defaultProps = tag.defaultProps;
        Styled.__emotion_real = Styled;
        Styled.__emotion_base = baseTag;
        Styled.__emotion_styles = styles;
        Styled.__emotion_forwardProp = shouldForwardProp;
        Object.defineProperty(Styled, 'toString', {
            value: function value() {
                if (targetClassName === undefined && $a37d20cbc69dfd2a$var$isDevelopment) return 'NO_COMPONENT_SELECTOR';
                return "." + targetClassName;
            }
        });
        Styled.withComponent = function(nextTag, nextOptions) {
            var newStyled = createStyled(nextTag, (0, $3VnFq.default)({}, options, nextOptions, {
                shouldForwardProp: $a37d20cbc69dfd2a$var$composeShouldForwardProps(Styled, nextOptions, true)
            }));
            return newStyled.apply(void 0, styles);
        };
        return Styled;
    };
};

});
parcelRegister("3VnFq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2db90dc0ca46422d$export$2e2bcd8739ae039; });
function $2db90dc0ca46422d$export$2e2bcd8739ae039() {
    return $2db90dc0ca46422d$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $2db90dc0ca46422d$export$2e2bcd8739ae039.apply(null, arguments);
}

});

parcelRegister("d0nrV", function(module, exports) {

$parcel$export(module.exports, "Global", function () { return $977d770011515e59$export$98f03c5d19621d70; });
$parcel$export(module.exports, "css", function () { return $977d770011515e59$export$dbf350e5966cf602; });
$parcel$export(module.exports, "keyframes", function () { return $977d770011515e59$export$d25ddfdf17c3ad3e; });
$parcel$export(module.exports, "ThemeContext", function () { return (parcelRequire("ll1Nc")).T; });
$parcel$export(module.exports, "withEmotionCache", function () { return (parcelRequire("ll1Nc")).w; });

var $ll1Nc = parcelRequire("ll1Nc");

var $gJYWc = parcelRequire("gJYWc");

var $9nBLf = parcelRequire("9nBLf");

var $fPM9Q = parcelRequire("fPM9Q");

var $hs5T6 = parcelRequire("hs5T6");
parcelRequire("dAa5b");
parcelRequire("b3LQA");
parcelRequire("jwT2u");

parcelRequire("gMU8G");
var $977d770011515e59$export$c8a8987d4410bf2d = function jsx(type, props) {
    // eslint-disable-next-line prefer-rest-params
    var args = arguments;
    if (props == null || !(0, $ll1Nc.h).call(props, 'css')) return $gJYWc.createElement.apply(undefined, args);
    var argsLength = args.length;
    var createElementArgArray = new Array(argsLength);
    createElementArgArray[0] = (0, $ll1Nc.E);
    createElementArgArray[1] = (0, $ll1Nc.c)(type, props);
    for(var i = 2; i < argsLength; i++)createElementArgArray[i] = args[i];
    return $gJYWc.createElement.apply(null, createElementArgArray);
};
(function(_jsx) {
    var JSX;
    JSX || (JSX = _jsx.JSX || (_jsx.JSX = {}));
})($977d770011515e59$export$c8a8987d4410bf2d || ($977d770011515e59$export$c8a8987d4410bf2d = {}));
// initial render from browser, insertBefore context.sheet.tags[0] or if a style hasn't been inserted there yet, appendChild
// initial client-side render from SSR, use place of hydrating tag
var $977d770011515e59$export$98f03c5d19621d70 = /* #__PURE__ */ (0, $ll1Nc.w)(function(props, cache) {
    var styles = props.styles;
    var serialized = (0, $hs5T6.serializeStyles)([
        styles
    ], undefined, $gJYWc.useContext((0, $ll1Nc.T)));
    if (!(0, $ll1Nc.i)) {
        var _ref;
        var serializedNames = serialized.name;
        var serializedStyles = serialized.styles;
        var next = serialized.next;
        while(next !== undefined){
            serializedNames += ' ' + next.name;
            serializedStyles += next.styles;
            next = next.next;
        }
        var shouldCache = cache.compat === true;
        var rules = cache.insert("", {
            name: serializedNames,
            styles: serializedStyles
        }, cache.sheet, shouldCache);
        if (shouldCache) return null;
        return /*#__PURE__*/ $gJYWc.createElement("style", (_ref = {}, _ref["data-emotion"] = cache.key + "-global " + serializedNames, _ref.dangerouslySetInnerHTML = {
            __html: rules
        }, _ref.nonce = cache.sheet.nonce, _ref));
    } // yes, i know these hooks are used conditionally
    // but it is based on a constant that will never change at runtime
    // it's effectively like having two implementations and switching them out
    // so it's not actually breaking anything
    var sheetRef = $gJYWc.useRef();
    (0, $fPM9Q.useInsertionEffectWithLayoutFallback)(function() {
        var key = cache.key + "-global"; // use case of https://github.com/emotion-js/emotion/issues/2675
        var sheet = new cache.sheet.constructor({
            key: key,
            nonce: cache.sheet.nonce,
            container: cache.sheet.container,
            speedy: cache.sheet.isSpeedy
        });
        var rehydrating = false;
        var node = document.querySelector("style[data-emotion=\"" + key + " " + serialized.name + "\"]");
        if (cache.sheet.tags.length) sheet.before = cache.sheet.tags[0];
        if (node !== null) {
            rehydrating = true; // clear the hash so this node won't be recognizable as rehydratable by other <Global/>s
            node.setAttribute('data-emotion', key);
            sheet.hydrate([
                node
            ]);
        }
        sheetRef.current = [
            sheet,
            rehydrating
        ];
        return function() {
            sheet.flush();
        };
    }, [
        cache
    ]);
    (0, $fPM9Q.useInsertionEffectWithLayoutFallback)(function() {
        var sheetRefCurrent = sheetRef.current;
        var sheet = sheetRefCurrent[0], rehydrating = sheetRefCurrent[1];
        if (rehydrating) {
            sheetRefCurrent[1] = false;
            return;
        }
        if (serialized.next !== undefined) // insert keyframes
        (0, $9nBLf.insertStyles)(cache, serialized.next, true);
        if (sheet.tags.length) {
            // if this doesn't exist then it will be null so the style element will be appended
            var element = sheet.tags[sheet.tags.length - 1].nextElementSibling;
            sheet.before = element;
            sheet.flush();
        }
        cache.insert("", serialized, sheet, false);
    }, [
        cache,
        serialized.name
    ]);
    return null;
});
function $977d770011515e59$export$dbf350e5966cf602() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return (0, $hs5T6.serializeStyles)(args);
}
function $977d770011515e59$export$d25ddfdf17c3ad3e() {
    var insertable = $977d770011515e59$export$dbf350e5966cf602.apply(void 0, arguments);
    var name = "animation-" + insertable.name;
    return {
        name: name,
        styles: "@keyframes " + name + "{" + insertable.styles + "}",
        anim: 1,
        toString: function toString() {
            return "_EMO_" + this.name + "_" + this.styles + "_EMO_";
        }
    };
}
var $977d770011515e59$var$classnames = function classnames(args) {
    var len = args.length;
    var i = 0;
    var cls = '';
    for(; i < len; i++){
        var arg = args[i];
        if (arg == null) continue;
        var toAdd = void 0;
        switch(typeof arg){
            case 'boolean':
                break;
            case 'object':
                if (Array.isArray(arg)) toAdd = classnames(arg);
                else {
                    toAdd = '';
                    for(var k in arg)if (arg[k] && k) {
                        toAdd && (toAdd += ' ');
                        toAdd += k;
                    }
                }
                break;
            default:
                toAdd = arg;
        }
        if (toAdd) {
            cls && (cls += ' ');
            cls += toAdd;
        }
    }
    return cls;
};
function $977d770011515e59$var$merge(registered, css, className) {
    var registeredStyles = [];
    var rawClassName = (0, $9nBLf.getRegisteredStyles)(registered, registeredStyles, className);
    if (registeredStyles.length < 2) return className;
    return rawClassName + css(registeredStyles);
}
var $977d770011515e59$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serializedArr = _ref.serializedArr;
    var rules = (0, $fPM9Q.useInsertionEffectAlwaysWithSyncFallback)(function() {
        var rules = '';
        for(var i = 0; i < serializedArr.length; i++){
            var res = (0, $9nBLf.insertStyles)(cache, serializedArr[i], false);
            if (!(0, $ll1Nc.i) && res !== undefined) rules += res;
        }
        if (!(0, $ll1Nc.i)) return rules;
    });
    if (!(0, $ll1Nc.i) && rules.length !== 0) {
        var _ref2;
        return /*#__PURE__*/ $gJYWc.createElement("style", (_ref2 = {}, _ref2["data-emotion"] = cache.key + " " + serializedArr.map(function(serialized) {
            return serialized.name;
        }).join(' '), _ref2.dangerouslySetInnerHTML = {
            __html: rules
        }, _ref2.nonce = cache.sheet.nonce, _ref2));
    }
    return null;
};
var $977d770011515e59$export$9b9c0f9d9f3552b8 = /* #__PURE__ */ (0, $ll1Nc.w)(function(props, cache) {
    var hasRendered = false;
    var serializedArr = [];
    var css = function css() {
        if (hasRendered && (0, $ll1Nc.a)) throw new Error('css can only be used during render');
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        var serialized = (0, $hs5T6.serializeStyles)(args, cache.registered);
        serializedArr.push(serialized); // registration has to happen here as the result of this might get consumed by `cx`
        (0, $9nBLf.registerStyles)(cache, serialized, false);
        return cache.key + "-" + serialized.name;
    };
    var cx = function cx() {
        if (hasRendered && (0, $ll1Nc.a)) throw new Error('cx can only be used during render');
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        return $977d770011515e59$var$merge(cache.registered, css, $977d770011515e59$var$classnames(args));
    };
    var content = {
        css: css,
        cx: cx,
        theme: $gJYWc.useContext((0, $ll1Nc.T))
    };
    var ele = props.children(content);
    hasRendered = true;
    return /*#__PURE__*/ $gJYWc.createElement($gJYWc.Fragment, null, /*#__PURE__*/ $gJYWc.createElement($977d770011515e59$var$Insertion, {
        cache: cache,
        serializedArr: serializedArr
    }), ele);
});

});
parcelRegister("ll1Nc", function(module, exports) {

$parcel$export(module.exports, "a", function () { return $f88cf3138ab983c5$export$407448d2b89b1813; });
$parcel$export(module.exports, "i", function () { return $f88cf3138ab983c5$export$23f2a1d2818174ef; });
$parcel$export(module.exports, "C", function () { return $f88cf3138ab983c5$export$e7094788287c5e9b; });
$parcel$export(module.exports, "w", function () { return $f88cf3138ab983c5$export$efccba1c4a2ef57b; });
$parcel$export(module.exports, "T", function () { return $f88cf3138ab983c5$export$971d5caa766a69d7; });
$parcel$export(module.exports, "h", function () { return $f88cf3138ab983c5$export$dda1d9f60106f0e9; });
$parcel$export(module.exports, "c", function () { return $f88cf3138ab983c5$export$db3b6bfb95261072; });
$parcel$export(module.exports, "E", function () { return $f88cf3138ab983c5$export$a9c23c6ac3fc3eca; });

var $gJYWc = parcelRequire("gJYWc");

var $dAa5b = parcelRequire("dAa5b");

var $3VnFq = parcelRequire("3VnFq");

var $jwT2u = parcelRequire("jwT2u");

var $1hncf = parcelRequire("1hncf");

var $9nBLf = parcelRequire("9nBLf");

var $hs5T6 = parcelRequire("hs5T6");

var $fPM9Q = parcelRequire("fPM9Q");
var $f88cf3138ab983c5$export$407448d2b89b1813 = false;
var $f88cf3138ab983c5$export$23f2a1d2818174ef = typeof document !== 'undefined';
var $f88cf3138ab983c5$var$EmotionCacheContext = /* #__PURE__ */ $gJYWc.createContext(// because this module is primarily intended for the browser and node
// but it's also required in react native and similar environments sometimes
// and we could have a special build just for that
// but this is much easier and the native packages
// might use a different theme context in the future anyway
typeof HTMLElement !== 'undefined' ? /* #__PURE__ */ (0, $dAa5b.default)({
    key: 'css'
}) : null);
var $f88cf3138ab983c5$export$e7094788287c5e9b = $f88cf3138ab983c5$var$EmotionCacheContext.Provider;
var $f88cf3138ab983c5$export$71511d61b312f219 = function useEmotionCache() {
    return (0, $gJYWc.useContext)($f88cf3138ab983c5$var$EmotionCacheContext);
};
var $f88cf3138ab983c5$export$efccba1c4a2ef57b = function withEmotionCache(func) {
    return /*#__PURE__*/ (0, $gJYWc.forwardRef)(function(props, ref) {
        // the cache will never be null in the browser
        var cache = (0, $gJYWc.useContext)($f88cf3138ab983c5$var$EmotionCacheContext);
        return func(props, cache, ref);
    });
};
if (!$f88cf3138ab983c5$export$23f2a1d2818174ef) $f88cf3138ab983c5$export$efccba1c4a2ef57b = function withEmotionCache(func) {
    return function(props) {
        var cache = (0, $gJYWc.useContext)($f88cf3138ab983c5$var$EmotionCacheContext);
        if (cache === null) {
            // yes, we're potentially creating this on every render
            // it doesn't actually matter though since it's only on the server
            // so there will only every be a single render
            // that could change in the future because of suspense and etc. but for now,
            // this works and i don't want to optimise for a future thing that we aren't sure about
            cache = (0, $dAa5b.default)({
                key: 'css'
            });
            return /*#__PURE__*/ $gJYWc.createElement($f88cf3138ab983c5$var$EmotionCacheContext.Provider, {
                value: cache
            }, func(props, cache));
        } else return func(props, cache);
    };
};
var $f88cf3138ab983c5$export$971d5caa766a69d7 = /* #__PURE__ */ $gJYWc.createContext({});
var $f88cf3138ab983c5$export$3b14a55fb2447963 = function useTheme() {
    return $gJYWc.useContext($f88cf3138ab983c5$export$971d5caa766a69d7);
};
var $f88cf3138ab983c5$var$getTheme = function getTheme(outerTheme, theme) {
    if (typeof theme === 'function') {
        var mergedTheme = theme(outerTheme);
        return mergedTheme;
    }
    return (0, $3VnFq.default)({}, outerTheme, theme);
};
var $f88cf3138ab983c5$var$createCacheWithTheme = /* #__PURE__ */ (0, $jwT2u.default)(function(outerTheme) {
    return (0, $jwT2u.default)(function(theme) {
        return $f88cf3138ab983c5$var$getTheme(outerTheme, theme);
    });
});
var $f88cf3138ab983c5$export$8b22cf2602fb60ce = function ThemeProvider(props) {
    var theme = $gJYWc.useContext($f88cf3138ab983c5$export$971d5caa766a69d7);
    if (props.theme !== theme) theme = $f88cf3138ab983c5$var$createCacheWithTheme(theme)(props.theme);
    return /*#__PURE__*/ $gJYWc.createElement($f88cf3138ab983c5$export$971d5caa766a69d7.Provider, {
        value: theme
    }, props.children);
};
function $f88cf3138ab983c5$export$4368d992c4eafac0(Component) {
    var componentName = Component.displayName || Component.name || 'Component';
    var WithTheme = /*#__PURE__*/ $gJYWc.forwardRef(function render(props, ref) {
        var theme = $gJYWc.useContext($f88cf3138ab983c5$export$971d5caa766a69d7);
        return /*#__PURE__*/ $gJYWc.createElement(Component, (0, $3VnFq.default)({
            theme: theme,
            ref: ref
        }, props));
    });
    WithTheme.displayName = "WithTheme(" + componentName + ")";
    return (0, $1hncf.default)(WithTheme, Component);
}
var $f88cf3138ab983c5$export$dda1d9f60106f0e9 = {}.hasOwnProperty;
var $f88cf3138ab983c5$var$typePropName = '__EMOTION_TYPE_PLEASE_DO_NOT_USE__';
var $f88cf3138ab983c5$export$db3b6bfb95261072 = function createEmotionProps(type, props) {
    var newProps = {};
    for(var _key in props)if ($f88cf3138ab983c5$export$dda1d9f60106f0e9.call(props, _key)) newProps[_key] = props[_key];
    newProps[$f88cf3138ab983c5$var$typePropName] = type; // Runtime labeling is an opt-in feature because:
    return newProps;
};
var $f88cf3138ab983c5$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serialized = _ref.serialized, isStringTag = _ref.isStringTag;
    (0, $9nBLf.registerStyles)(cache, serialized, isStringTag);
    var rules = (0, $fPM9Q.useInsertionEffectAlwaysWithSyncFallback)(function() {
        return (0, $9nBLf.insertStyles)(cache, serialized, isStringTag);
    });
    if (!$f88cf3138ab983c5$export$23f2a1d2818174ef && rules !== undefined) {
        var _ref2;
        var serializedNames = serialized.name;
        var next = serialized.next;
        while(next !== undefined){
            serializedNames += ' ' + next.name;
            next = next.next;
        }
        return /*#__PURE__*/ $gJYWc.createElement("style", (_ref2 = {}, _ref2["data-emotion"] = cache.key + " " + serializedNames, _ref2.dangerouslySetInnerHTML = {
            __html: rules
        }, _ref2.nonce = cache.sheet.nonce, _ref2));
    }
    return null;
};
var $f88cf3138ab983c5$var$Emotion = /* #__PURE__ */ $f88cf3138ab983c5$export$efccba1c4a2ef57b(function(props, cache, ref) {
    var cssProp = props.css; // so that using `css` from `emotion` and passing the result to the css prop works
    // not passing the registered cache to serializeStyles because it would
    // make certain babel optimisations not possible
    if (typeof cssProp === 'string' && cache.registered[cssProp] !== undefined) cssProp = cache.registered[cssProp];
    var WrappedComponent = props[$f88cf3138ab983c5$var$typePropName];
    var registeredStyles = [
        cssProp
    ];
    var className = '';
    if (typeof props.className === 'string') className = (0, $9nBLf.getRegisteredStyles)(cache.registered, registeredStyles, props.className);
    else if (props.className != null) className = props.className + " ";
    var serialized = (0, $hs5T6.serializeStyles)(registeredStyles, undefined, $gJYWc.useContext($f88cf3138ab983c5$export$971d5caa766a69d7));
    className += cache.key + "-" + serialized.name;
    var newProps = {};
    for(var _key2 in props)if ($f88cf3138ab983c5$export$dda1d9f60106f0e9.call(props, _key2) && _key2 !== 'css' && _key2 !== $f88cf3138ab983c5$var$typePropName && !$f88cf3138ab983c5$export$407448d2b89b1813) newProps[_key2] = props[_key2];
    newProps.className = className;
    if (ref) newProps.ref = ref;
    return /*#__PURE__*/ $gJYWc.createElement($gJYWc.Fragment, null, /*#__PURE__*/ $gJYWc.createElement($f88cf3138ab983c5$var$Insertion, {
        cache: cache,
        serialized: serialized,
        isStringTag: typeof WrappedComponent === 'string'
    }), /*#__PURE__*/ $gJYWc.createElement(WrappedComponent, newProps));
});
var $f88cf3138ab983c5$export$a9c23c6ac3fc3eca = $f88cf3138ab983c5$var$Emotion;

});
parcelRegister("dAa5b", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9e36755c6c761b93$export$2e2bcd8739ae039; });

var $6alQJ = parcelRequire("6alQJ");

var $imPMl = parcelRequire("imPMl");

var $jwT2u = parcelRequire("jwT2u");

var $7VXY1 = parcelRequire("7VXY1");
var $9e36755c6c761b93$var$isBrowser = typeof document !== 'undefined';
var $9e36755c6c761b93$var$identifierWithPointTracking = function identifierWithPointTracking(begin, points, index) {
    var previous = 0;
    var character = 0;
    while(true){
        previous = character;
        character = (0, $imPMl.peek)(); // &\f
        if (previous === 38 && character === 12) points[index] = 1;
        if ((0, $imPMl.token)(character)) break;
        (0, $imPMl.next)();
    }
    return (0, $imPMl.slice)(begin, (0, $imPMl.position));
};
var $9e36755c6c761b93$var$toRules = function toRules(parsed, points) {
    // pretend we've started with a comma
    var index = -1;
    var character = 44;
    do switch((0, $imPMl.token)(character)){
        case 0:
            // &\f
            if (character === 38 && (0, $imPMl.peek)() === 12) // this is not 100% correct, we don't account for literal sequences here - like for example quoted strings
            // stylis inserts \f after & to know when & where it should replace this sequence with the context selector
            // and when it should just concatenate the outer and inner selectors
            // it's very unlikely for this sequence to actually appear in a different context, so we just leverage this fact here
            points[index] = 1;
            parsed[index] += $9e36755c6c761b93$var$identifierWithPointTracking((0, $imPMl.position) - 1, points, index);
            break;
        case 2:
            parsed[index] += (0, $imPMl.delimit)(character);
            break;
        case 4:
            // comma
            if (character === 44) {
                // colon
                parsed[++index] = (0, $imPMl.peek)() === 58 ? '&\f' : '';
                points[index] = parsed[index].length;
                break;
            }
        // fallthrough
        default:
            parsed[index] += (0, $imPMl.from)(character);
    }
    while (character = (0, $imPMl.next)());
    return parsed;
};
var $9e36755c6c761b93$var$getRules = function getRules(value, points) {
    return (0, $imPMl.dealloc)($9e36755c6c761b93$var$toRules((0, $imPMl.alloc)(value), points));
}; // WeakSet would be more appropriate, but only WeakMap is supported in IE11
var $9e36755c6c761b93$var$fixedElements = /* #__PURE__ */ new WeakMap();
var $9e36755c6c761b93$var$compat = function compat(element) {
    if (element.type !== 'rule' || !element.parent || // positive .length indicates that this rule contains pseudo
    // negative .length indicates that this rule has been already prefixed
    element.length < 1) return;
    var value = element.value;
    var parent = element.parent;
    var isImplicitRule = element.column === parent.column && element.line === parent.line;
    while(parent.type !== 'rule'){
        parent = parent.parent;
        if (!parent) return;
    } // short-circuit for the simplest case
    if (element.props.length === 1 && value.charCodeAt(0) !== 58 && !$9e36755c6c761b93$var$fixedElements.get(parent)) return;
     // if this is an implicitly inserted rule (the one eagerly inserted at the each new nested level)
    // then the props has already been manipulated beforehand as they that array is shared between it and its "rule parent"
    if (isImplicitRule) return;
    $9e36755c6c761b93$var$fixedElements.set(element, true);
    var points = [];
    var rules = $9e36755c6c761b93$var$getRules(value, points);
    var parentRules = parent.props;
    for(var i = 0, k = 0; i < rules.length; i++)for(var j = 0; j < parentRules.length; j++, k++)element.props[k] = points[i] ? rules[i].replace(/&\f/g, parentRules[j]) : parentRules[j] + " " + rules[i];
};
var $9e36755c6c761b93$var$removeLabel = function removeLabel(element) {
    if (element.type === 'decl') {
        var value = element.value;
        if (value.charCodeAt(0) === 108 && // charcode for b
        value.charCodeAt(2) === 98) {
            // this ignores label
            element["return"] = '';
            element.value = '';
        }
    }
};
/* eslint-disable no-fallthrough */ function $9e36755c6c761b93$var$prefix(value, length) {
    switch((0, $imPMl.hash)(value, length)){
        // color-adjust
        case 5103:
            return (0, $imPMl.WEBKIT) + 'print-' + value + value;
        // animation, animation-(delay|direction|duration|fill-mode|iteration-count|name|play-state|timing-function)
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return (0, $imPMl.WEBKIT) + value + value;
        // appearance, user-select, transform, hyphens, text-size-adjust
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return (0, $imPMl.WEBKIT) + value + (0, $imPMl.MOZ) + value + (0, $imPMl.MS) + value + value;
        // flex, flex-direction
        case 6828:
        case 4268:
            return (0, $imPMl.WEBKIT) + value + (0, $imPMl.MS) + value + value;
        // order
        case 6165:
            return (0, $imPMl.WEBKIT) + value + (0, $imPMl.MS) + 'flex-' + value + value;
        // align-items
        case 5187:
            return (0, $imPMl.WEBKIT) + value + (0, $imPMl.replace)(value, /(\w+).+(:[^]+)/, (0, $imPMl.WEBKIT) + 'box-$1$2' + (0, $imPMl.MS) + 'flex-$1$2') + value;
        // align-self
        case 5443:
            return (0, $imPMl.WEBKIT) + value + (0, $imPMl.MS) + 'flex-item-' + (0, $imPMl.replace)(value, /flex-|-self/, '') + value;
        // align-content
        case 4675:
            return (0, $imPMl.WEBKIT) + value + (0, $imPMl.MS) + 'flex-line-pack' + (0, $imPMl.replace)(value, /align-content|flex-|-self/, '') + value;
        // flex-shrink
        case 5548:
            return (0, $imPMl.WEBKIT) + value + (0, $imPMl.MS) + (0, $imPMl.replace)(value, 'shrink', 'negative') + value;
        // flex-basis
        case 5292:
            return (0, $imPMl.WEBKIT) + value + (0, $imPMl.MS) + (0, $imPMl.replace)(value, 'basis', 'preferred-size') + value;
        // flex-grow
        case 6060:
            return (0, $imPMl.WEBKIT) + 'box-' + (0, $imPMl.replace)(value, '-grow', '') + (0, $imPMl.WEBKIT) + value + (0, $imPMl.MS) + (0, $imPMl.replace)(value, 'grow', 'positive') + value;
        // transition
        case 4554:
            return (0, $imPMl.WEBKIT) + (0, $imPMl.replace)(value, /([^-])(transform)/g, '$1' + (0, $imPMl.WEBKIT) + '$2') + value;
        // cursor
        case 6187:
            return (0, $imPMl.replace)((0, $imPMl.replace)((0, $imPMl.replace)(value, /(zoom-|grab)/, (0, $imPMl.WEBKIT) + '$1'), /(image-set)/, (0, $imPMl.WEBKIT) + '$1'), value, '') + value;
        // background, background-image
        case 5495:
        case 3959:
            return (0, $imPMl.replace)(value, /(image-set\([^]*)/, (0, $imPMl.WEBKIT) + '$1' + '$`$1');
        // justify-content
        case 4968:
            return (0, $imPMl.replace)((0, $imPMl.replace)(value, /(.+:)(flex-)?(.*)/, (0, $imPMl.WEBKIT) + 'box-pack:$3' + (0, $imPMl.MS) + 'flex-pack:$3'), /s.+-b[^;]+/, 'justify') + (0, $imPMl.WEBKIT) + value + value;
        // (margin|padding)-inline-(start|end)
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return (0, $imPMl.replace)(value, /(.+)-inline(.+)/, (0, $imPMl.WEBKIT) + '$1$2') + value;
        // (min|max)?(width|height|inline-size|block-size)
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            // stretch, max-content, min-content, fill-available
            if ((0, $imPMl.strlen)(value) - 1 - length > 6) switch((0, $imPMl.charat)(value, length + 1)){
                // (m)ax-content, (m)in-content
                case 109:
                    // -
                    if ((0, $imPMl.charat)(value, length + 4) !== 45) break;
                // (f)ill-available, (f)it-content
                case 102:
                    return (0, $imPMl.replace)(value, /(.+:)(.+)-([^]+)/, '$1' + (0, $imPMl.WEBKIT) + '$2-$3' + '$1' + (0, $imPMl.MOZ) + ((0, $imPMl.charat)(value, length + 3) == 108 ? '$3' : '$2-$3')) + value;
                // (s)tretch
                case 115:
                    return ~(0, $imPMl.indexof)(value, 'stretch') ? $9e36755c6c761b93$var$prefix((0, $imPMl.replace)(value, 'stretch', 'fill-available'), length) + value : value;
            }
            break;
        // position: sticky
        case 4949:
            // (s)ticky?
            if ((0, $imPMl.charat)(value, length + 1) !== 115) break;
        // display: (flex|inline-flex)
        case 6444:
            switch((0, $imPMl.charat)(value, (0, $imPMl.strlen)(value) - 3 - (~(0, $imPMl.indexof)(value, '!important') && 10))){
                // stic(k)y
                case 107:
                    return (0, $imPMl.replace)(value, ':', ':' + (0, $imPMl.WEBKIT)) + value;
                // (inline-)?fl(e)x
                case 101:
                    return (0, $imPMl.replace)(value, /(.+:)([^;!]+)(;|!.+)?/, '$1' + (0, $imPMl.WEBKIT) + ((0, $imPMl.charat)(value, 14) === 45 ? 'inline-' : '') + 'box$3' + '$1' + (0, $imPMl.WEBKIT) + '$2$3' + '$1' + (0, $imPMl.MS) + '$2box$3') + value;
            }
            break;
        // writing-mode
        case 5936:
            switch((0, $imPMl.charat)(value, length + 11)){
                // vertical-l(r)
                case 114:
                    return (0, $imPMl.WEBKIT) + value + (0, $imPMl.MS) + (0, $imPMl.replace)(value, /[svh]\w+-[tblr]{2}/, 'tb') + value;
                // vertical-r(l)
                case 108:
                    return (0, $imPMl.WEBKIT) + value + (0, $imPMl.MS) + (0, $imPMl.replace)(value, /[svh]\w+-[tblr]{2}/, 'tb-rl') + value;
                // horizontal(-)tb
                case 45:
                    return (0, $imPMl.WEBKIT) + value + (0, $imPMl.MS) + (0, $imPMl.replace)(value, /[svh]\w+-[tblr]{2}/, 'lr') + value;
            }
            return (0, $imPMl.WEBKIT) + value + (0, $imPMl.MS) + value + value;
    }
    return value;
}
var $9e36755c6c761b93$var$prefixer = function prefixer(element, index, children, callback) {
    if (element.length > -1) {
        if (!element["return"]) switch(element.type){
            case 0, $imPMl.DECLARATION:
                element["return"] = $9e36755c6c761b93$var$prefix(element.value, element.length);
                break;
            case 0, $imPMl.KEYFRAMES:
                return (0, $imPMl.serialize)([
                    (0, $imPMl.copy)(element, {
                        value: (0, $imPMl.replace)(element.value, '@', '@' + (0, $imPMl.WEBKIT))
                    })
                ], callback);
            case 0, $imPMl.RULESET:
                if (element.length) return (0, $imPMl.combine)(element.props, function(value) {
                    switch((0, $imPMl.match)(value, /(::plac\w+|:read-\w+)/)){
                        // :read-(only|write)
                        case ':read-only':
                        case ':read-write':
                            return (0, $imPMl.serialize)([
                                (0, $imPMl.copy)(element, {
                                    props: [
                                        (0, $imPMl.replace)(value, /:(read-\w+)/, ':' + (0, $imPMl.MOZ) + '$1')
                                    ]
                                })
                            ], callback);
                        // :placeholder
                        case '::placeholder':
                            return (0, $imPMl.serialize)([
                                (0, $imPMl.copy)(element, {
                                    props: [
                                        (0, $imPMl.replace)(value, /:(plac\w+)/, ':' + (0, $imPMl.WEBKIT) + 'input-$1')
                                    ]
                                }),
                                (0, $imPMl.copy)(element, {
                                    props: [
                                        (0, $imPMl.replace)(value, /:(plac\w+)/, ':' + (0, $imPMl.MOZ) + '$1')
                                    ]
                                }),
                                (0, $imPMl.copy)(element, {
                                    props: [
                                        (0, $imPMl.replace)(value, /:(plac\w+)/, (0, $imPMl.MS) + 'input-$1')
                                    ]
                                })
                            ], callback);
                    }
                    return '';
                });
        }
    }
};
var $9e36755c6c761b93$var$getServerStylisCache = $9e36755c6c761b93$var$isBrowser ? undefined : (0, $jwT2u.default)(function() {
    return (0, $7VXY1.default)(function() {
        return {};
    });
});
var $9e36755c6c761b93$var$defaultStylisPlugins = [
    $9e36755c6c761b93$var$prefixer
];
var $9e36755c6c761b93$export$2e2bcd8739ae039 = function createCache(options) {
    var key = options.key;
    if ($9e36755c6c761b93$var$isBrowser && key === 'css') {
        var ssrStyles = document.querySelectorAll("style[data-emotion]:not([data-s])"); // get SSRed styles out of the way of React's hydration
        // document.head is a safe place to move them to(though note document.head is not necessarily the last place they will be)
        // note this very very intentionally targets all style elements regardless of the key to ensure
        // that creating a cache works inside of render of a React component
        Array.prototype.forEach.call(ssrStyles, function(node) {
            // we want to only move elements which have a space in the data-emotion attribute value
            // because that indicates that it is an Emotion 11 server-side rendered style elements
            // while we will already ignore Emotion 11 client-side inserted styles because of the :not([data-s]) part in the selector
            // Emotion 10 client-side inserted styles did not have data-s (but importantly did not have a space in their data-emotion attributes)
            // so checking for the space ensures that loading Emotion 11 after Emotion 10 has inserted some styles
            // will not result in the Emotion 10 styles being destroyed
            var dataEmotionAttribute = node.getAttribute('data-emotion');
            if (dataEmotionAttribute.indexOf(' ') === -1) return;
            document.head.appendChild(node);
            node.setAttribute('data-s', '');
        });
    }
    var stylisPlugins = options.stylisPlugins || $9e36755c6c761b93$var$defaultStylisPlugins;
    var inserted = {};
    var container;
    var nodesToHydrate = [];
    if ($9e36755c6c761b93$var$isBrowser) {
        container = options.container || document.head;
        Array.prototype.forEach.call(// means that the style elements we're looking at are only Emotion 11 server-rendered style elements
        document.querySelectorAll("style[data-emotion^=\"" + key + " \"]"), function(node) {
            var attrib = node.getAttribute("data-emotion").split(' ');
            for(var i = 1; i < attrib.length; i++)inserted[attrib[i]] = true;
            nodesToHydrate.push(node);
        });
    }
    var _insert;
    var omnipresentPlugins = [
        $9e36755c6c761b93$var$compat,
        $9e36755c6c761b93$var$removeLabel
    ];
    if (!$9e36755c6c761b93$var$getServerStylisCache) {
        var currentSheet;
        var finalizingPlugins = [
            (0, $imPMl.stringify),
            (0, $imPMl.rulesheet)(function(rule) {
                currentSheet.insert(rule);
            })
        ];
        var serializer = (0, $imPMl.middleware)(omnipresentPlugins.concat(stylisPlugins, finalizingPlugins));
        var stylis = function stylis(styles) {
            return (0, $imPMl.serialize)((0, $imPMl.compile)(styles), serializer);
        };
        _insert = function insert(selector, serialized, sheet, shouldCache) {
            currentSheet = sheet;
            stylis(selector ? selector + "{" + serialized.styles + "}" : serialized.styles);
            if (shouldCache) cache.inserted[serialized.name] = true;
        };
    } else {
        var _finalizingPlugins = [
            (0, $imPMl.stringify)
        ];
        var _serializer = (0, $imPMl.middleware)(omnipresentPlugins.concat(stylisPlugins, _finalizingPlugins));
        var _stylis = function _stylis(styles) {
            return (0, $imPMl.serialize)((0, $imPMl.compile)(styles), _serializer);
        };
        var serverStylisCache = $9e36755c6c761b93$var$getServerStylisCache(stylisPlugins)(key);
        var getRules = function getRules(selector, serialized) {
            var name = serialized.name;
            if (serverStylisCache[name] === undefined) serverStylisCache[name] = _stylis(selector ? selector + "{" + serialized.styles + "}" : serialized.styles);
            return serverStylisCache[name];
        };
        _insert = function _insert(selector, serialized, sheet, shouldCache) {
            var name = serialized.name;
            var rules = getRules(selector, serialized);
            if (cache.compat === undefined) {
                // in regular mode, we don't set the styles on the inserted cache
                // since we don't need to and that would be wasting memory
                // we return them so that they are rendered in a style tag
                if (shouldCache) cache.inserted[name] = true;
                return rules;
            } else {
                // in compat mode, we put the styles on the inserted cache so
                // that emotion-server can pull out the styles
                // except when we don't want to cache it which was in Global but now
                // is nowhere but we don't want to do a major right now
                // and just in case we're going to leave the case here
                // it's also not affecting client side bundle size
                // so it's really not a big deal
                if (shouldCache) cache.inserted[name] = rules;
                else return rules;
            }
        };
    }
    var cache = {
        key: key,
        sheet: new (0, $6alQJ.StyleSheet)({
            key: key,
            container: container,
            nonce: options.nonce,
            speedy: options.speedy,
            prepend: options.prepend,
            insertionPoint: options.insertionPoint
        }),
        nonce: options.nonce,
        inserted: inserted,
        registered: {},
        insert: _insert
    };
    cache.sheet.hydrate(nodesToHydrate);
    return cache;
};

});
parcelRegister("6alQJ", function(module, exports) {

$parcel$export(module.exports, "StyleSheet", function () { return $47d4a01b34472741$export$9d753cd7ae895cce; });
var $47d4a01b34472741$var$isDevelopment = false;
/*

Based off glamor's StyleSheet, thanks Sunil ❤️

high performance StyleSheet for css-in-js systems

- uses multiple style tags behind the scenes for millions of rules
- uses `insertRule` for appending in production for *much* faster performance

// usage

import { StyleSheet } from '@emotion/sheet'

let styleSheet = new StyleSheet({ key: '', container: document.head })

styleSheet.insert('#box { border: 1px solid red; }')
- appends a css rule into the stylesheet

styleSheet.flush()
- empties the stylesheet of all its contents

*/ function $47d4a01b34472741$var$sheetForTag(tag) {
    if (tag.sheet) return tag.sheet;
     // this weirdness brought to you by firefox
    /* istanbul ignore next */ for(var i = 0; i < document.styleSheets.length; i++){
        if (document.styleSheets[i].ownerNode === tag) return document.styleSheets[i];
    } // this function should always return with a value
    // TS can't understand it though so we make it stop complaining here
    return undefined;
}
function $47d4a01b34472741$var$createStyleElement(options) {
    var tag = document.createElement('style');
    tag.setAttribute('data-emotion', options.key);
    if (options.nonce !== undefined) tag.setAttribute('nonce', options.nonce);
    tag.appendChild(document.createTextNode(''));
    tag.setAttribute('data-s', '');
    return tag;
}
var $47d4a01b34472741$export$9d753cd7ae895cce = /*#__PURE__*/ function() {
    // Using Node instead of HTMLElement since container may be a ShadowRoot
    function StyleSheet(options) {
        var _this = this;
        this._insertTag = function(tag) {
            var before;
            if (_this.tags.length === 0) {
                if (_this.insertionPoint) before = _this.insertionPoint.nextSibling;
                else if (_this.prepend) before = _this.container.firstChild;
                else before = _this.before;
            } else before = _this.tags[_this.tags.length - 1].nextSibling;
            _this.container.insertBefore(tag, before);
            _this.tags.push(tag);
        };
        this.isSpeedy = options.speedy === undefined ? !$47d4a01b34472741$var$isDevelopment : options.speedy;
        this.tags = [];
        this.ctr = 0;
        this.nonce = options.nonce; // key is the value of the data-emotion attribute, it's used to identify different sheets
        this.key = options.key;
        this.container = options.container;
        this.prepend = options.prepend;
        this.insertionPoint = options.insertionPoint;
        this.before = null;
    }
    var _proto = StyleSheet.prototype;
    _proto.hydrate = function hydrate(nodes) {
        nodes.forEach(this._insertTag);
    };
    _proto.insert = function insert(rule) {
        // the max length is how many rules we have per style tag, it's 65000 in speedy mode
        // it's 1 in dev because we insert source maps that map a single rule to a location
        // and you can only have one source map per style tag
        if (this.ctr % (this.isSpeedy ? 65000 : 1) === 0) this._insertTag($47d4a01b34472741$var$createStyleElement(this));
        var tag = this.tags[this.tags.length - 1];
        if (this.isSpeedy) {
            var sheet = $47d4a01b34472741$var$sheetForTag(tag);
            try {
                // this is the ultrafast version, works across browsers
                // the big drawback is that the css won't be editable in devtools
                sheet.insertRule(rule, sheet.cssRules.length);
            } catch (e) {}
        } else tag.appendChild(document.createTextNode(rule));
        this.ctr++;
    };
    _proto.flush = function flush() {
        this.tags.forEach(function(tag) {
            var _tag$parentNode;
            return (_tag$parentNode = tag.parentNode) == null ? void 0 : _tag$parentNode.removeChild(tag);
        });
        this.tags = [];
        this.ctr = 0;
    };
    return StyleSheet;
}();

});

parcelRegister("imPMl", function(module, exports) {

$parcel$export(module.exports, "MS", function () { return $42596a5caca5c2a1$export$71ad59f2e432cfe8; });
$parcel$export(module.exports, "MOZ", function () { return $42596a5caca5c2a1$export$2c0f367103c8d01c; });
$parcel$export(module.exports, "WEBKIT", function () { return $42596a5caca5c2a1$export$39dfd62a25e0fe93; });
$parcel$export(module.exports, "RULESET", function () { return $42596a5caca5c2a1$export$aa3a2e812ca8570d; });
$parcel$export(module.exports, "DECLARATION", function () { return $42596a5caca5c2a1$export$527d108ccf083c2b; });
$parcel$export(module.exports, "KEYFRAMES", function () { return $42596a5caca5c2a1$export$b44a8529a35fcb60; });
$parcel$export(module.exports, "from", function () { return $42596a5caca5c2a1$export$6788812c4e6611e6; });
$parcel$export(module.exports, "hash", function () { return $42596a5caca5c2a1$export$d6af199866bfb566; });
$parcel$export(module.exports, "charat", function () { return $42596a5caca5c2a1$export$a9db5e087081082d; });
$parcel$export(module.exports, "match", function () { return $42596a5caca5c2a1$export$4659b591c19bdf3d; });
$parcel$export(module.exports, "replace", function () { return $42596a5caca5c2a1$export$77ad94ebf1c2b9ed; });
$parcel$export(module.exports, "indexof", function () { return $42596a5caca5c2a1$export$f8e21b1e77979a08; });
$parcel$export(module.exports, "strlen", function () { return $42596a5caca5c2a1$export$36776f635604f274; });
$parcel$export(module.exports, "combine", function () { return $42596a5caca5c2a1$export$1be1fc439b849fdf; });
$parcel$export(module.exports, "position", function () { return $42596a5caca5c2a1$export$5880b8b5730aff45; });
$parcel$export(module.exports, "copy", function () { return $42596a5caca5c2a1$export$784d13d8ee351f07; });
$parcel$export(module.exports, "next", function () { return $42596a5caca5c2a1$export$48cfd1e771a65c4f; });
$parcel$export(module.exports, "peek", function () { return $42596a5caca5c2a1$export$4d3fb11e950abb9e; });
$parcel$export(module.exports, "slice", function () { return $42596a5caca5c2a1$export$58adb3bec8346d0f; });
$parcel$export(module.exports, "token", function () { return $42596a5caca5c2a1$export$9e1725a4cfeada27; });
$parcel$export(module.exports, "alloc", function () { return $42596a5caca5c2a1$export$2de70f21292aac9e; });
$parcel$export(module.exports, "dealloc", function () { return $42596a5caca5c2a1$export$45918ac1574455b1; });
$parcel$export(module.exports, "delimit", function () { return $42596a5caca5c2a1$export$410ac95b9ec204b8; });
$parcel$export(module.exports, "compile", function () { return $42596a5caca5c2a1$export$ef7acd7185315e22; });
$parcel$export(module.exports, "serialize", function () { return $42596a5caca5c2a1$export$dfdc1655ccc5b9cb; });
$parcel$export(module.exports, "stringify", function () { return $42596a5caca5c2a1$export$fac44ee5b035f737; });
$parcel$export(module.exports, "middleware", function () { return $42596a5caca5c2a1$export$5a7767152ae0305f; });
$parcel$export(module.exports, "rulesheet", function () { return $42596a5caca5c2a1$export$38bcb760f1d4871c; });
var $42596a5caca5c2a1$export$71ad59f2e432cfe8 = "-ms-";
var $42596a5caca5c2a1$export$2c0f367103c8d01c = "-moz-";
var $42596a5caca5c2a1$export$39dfd62a25e0fe93 = "-webkit-";
var $42596a5caca5c2a1$export$a29989082612d0d9 = "comm";
var $42596a5caca5c2a1$export$aa3a2e812ca8570d = "rule";
var $42596a5caca5c2a1$export$527d108ccf083c2b = "decl";
var $42596a5caca5c2a1$export$d3d35020fa5b54f0 = "@page";
var $42596a5caca5c2a1$export$500415a86c544f73 = "@media";
var $42596a5caca5c2a1$export$a763edbf796b780a = "@import";
var $42596a5caca5c2a1$export$2790aeb8b4e5c826 = "@charset";
var $42596a5caca5c2a1$export$1cc683e23b84b133 = "@viewport";
var $42596a5caca5c2a1$export$9447a5efea57e862 = "@supports";
var $42596a5caca5c2a1$export$ef011b4e114b1fba = "@document";
var $42596a5caca5c2a1$export$6aad947bda0f3f46 = "@namespace";
var $42596a5caca5c2a1$export$b44a8529a35fcb60 = "@keyframes";
var $42596a5caca5c2a1$export$2c16de31893252e6 = "@font-face";
var $42596a5caca5c2a1$export$3d846dd52e150c6f = "@counter-style";
var $42596a5caca5c2a1$export$22314bfbb57653fe = "@font-feature-values";
var $42596a5caca5c2a1$export$d773506282b3cfe6 = "@layer";
var $42596a5caca5c2a1$export$2335f513bbd82c6d = Math.abs;
var $42596a5caca5c2a1$export$6788812c4e6611e6 = String.fromCharCode;
var $42596a5caca5c2a1$export$e6e34fd1f2686227 = Object.assign;
function $42596a5caca5c2a1$export$d6af199866bfb566(e, r) {
    return $42596a5caca5c2a1$export$a9db5e087081082d(e, 0) ^ 45 ? (((r << 2 ^ $42596a5caca5c2a1$export$a9db5e087081082d(e, 0)) << 2 ^ $42596a5caca5c2a1$export$a9db5e087081082d(e, 1)) << 2 ^ $42596a5caca5c2a1$export$a9db5e087081082d(e, 2)) << 2 ^ $42596a5caca5c2a1$export$a9db5e087081082d(e, 3) : 0;
}
function $42596a5caca5c2a1$export$87c2784dc9fc4ab(e) {
    return e.trim();
}
function $42596a5caca5c2a1$export$4659b591c19bdf3d(e, r) {
    return (e = r.exec(e)) ? e[0] : e;
}
function $42596a5caca5c2a1$export$77ad94ebf1c2b9ed(e, r, a) {
    return e.replace(r, a);
}
function $42596a5caca5c2a1$export$f8e21b1e77979a08(e, r) {
    return e.indexOf(r);
}
function $42596a5caca5c2a1$export$a9db5e087081082d(e, r) {
    return e.charCodeAt(r) | 0;
}
function $42596a5caca5c2a1$export$2f35ab04d2335697(e, r, a) {
    return e.slice(r, a);
}
function $42596a5caca5c2a1$export$36776f635604f274(e) {
    return e.length;
}
function $42596a5caca5c2a1$export$f9084667e487ed46(e) {
    return e.length;
}
function $42596a5caca5c2a1$export$10d8903dec122b9d(e, r) {
    return r.push(e), e;
}
function $42596a5caca5c2a1$export$1be1fc439b849fdf(e, r) {
    return e.map(r).join("");
}
var $42596a5caca5c2a1$export$53f1d5ea8de3d7c = 1;
var $42596a5caca5c2a1$export$4e0c71f277ca26b3 = 1;
var $42596a5caca5c2a1$export$f24224f1c91d8156 = 0;
var $42596a5caca5c2a1$export$5880b8b5730aff45 = 0;
var $42596a5caca5c2a1$export$c0306caf338ac095 = 0;
var $42596a5caca5c2a1$export$30a86d91af8ff6e6 = "";
function $42596a5caca5c2a1$export$35059013cd4a06db(e, r, a, n, c, s, t) {
    return {
        value: e,
        root: r,
        parent: a,
        type: n,
        props: c,
        children: s,
        line: $42596a5caca5c2a1$export$53f1d5ea8de3d7c,
        column: $42596a5caca5c2a1$export$4e0c71f277ca26b3,
        length: t,
        return: ""
    };
}
function $42596a5caca5c2a1$export$784d13d8ee351f07(e, r) {
    return $42596a5caca5c2a1$export$e6e34fd1f2686227($42596a5caca5c2a1$export$35059013cd4a06db("", null, null, "", null, null, 0), e, {
        length: -e.length
    }, r);
}
function $42596a5caca5c2a1$export$eba6f6f03b0a92e7() {
    return $42596a5caca5c2a1$export$c0306caf338ac095;
}
function $42596a5caca5c2a1$export$232faf9add678146() {
    $42596a5caca5c2a1$export$c0306caf338ac095 = $42596a5caca5c2a1$export$5880b8b5730aff45 > 0 ? $42596a5caca5c2a1$export$a9db5e087081082d($42596a5caca5c2a1$export$30a86d91af8ff6e6, --$42596a5caca5c2a1$export$5880b8b5730aff45) : 0;
    if ($42596a5caca5c2a1$export$4e0c71f277ca26b3--, $42596a5caca5c2a1$export$c0306caf338ac095 === 10) $42596a5caca5c2a1$export$4e0c71f277ca26b3 = 1, $42596a5caca5c2a1$export$53f1d5ea8de3d7c--;
    return $42596a5caca5c2a1$export$c0306caf338ac095;
}
function $42596a5caca5c2a1$export$48cfd1e771a65c4f() {
    $42596a5caca5c2a1$export$c0306caf338ac095 = $42596a5caca5c2a1$export$5880b8b5730aff45 < $42596a5caca5c2a1$export$f24224f1c91d8156 ? $42596a5caca5c2a1$export$a9db5e087081082d($42596a5caca5c2a1$export$30a86d91af8ff6e6, $42596a5caca5c2a1$export$5880b8b5730aff45++) : 0;
    if ($42596a5caca5c2a1$export$4e0c71f277ca26b3++, $42596a5caca5c2a1$export$c0306caf338ac095 === 10) $42596a5caca5c2a1$export$4e0c71f277ca26b3 = 1, $42596a5caca5c2a1$export$53f1d5ea8de3d7c++;
    return $42596a5caca5c2a1$export$c0306caf338ac095;
}
function $42596a5caca5c2a1$export$4d3fb11e950abb9e() {
    return $42596a5caca5c2a1$export$a9db5e087081082d($42596a5caca5c2a1$export$30a86d91af8ff6e6, $42596a5caca5c2a1$export$5880b8b5730aff45);
}
function $42596a5caca5c2a1$export$e88cb2efb12ae807() {
    return $42596a5caca5c2a1$export$5880b8b5730aff45;
}
function $42596a5caca5c2a1$export$58adb3bec8346d0f(e, r) {
    return $42596a5caca5c2a1$export$2f35ab04d2335697($42596a5caca5c2a1$export$30a86d91af8ff6e6, e, r);
}
function $42596a5caca5c2a1$export$9e1725a4cfeada27(e) {
    switch(e){
        case 0:
        case 9:
        case 10:
        case 13:
        case 32:
            return 5;
        case 33:
        case 43:
        case 44:
        case 47:
        case 62:
        case 64:
        case 126:
        case 59:
        case 123:
        case 125:
            return 4;
        case 58:
            return 3;
        case 34:
        case 39:
        case 40:
        case 91:
            return 2;
        case 41:
        case 93:
            return 1;
    }
    return 0;
}
function $42596a5caca5c2a1$export$2de70f21292aac9e(e) {
    return $42596a5caca5c2a1$export$53f1d5ea8de3d7c = $42596a5caca5c2a1$export$4e0c71f277ca26b3 = 1, $42596a5caca5c2a1$export$f24224f1c91d8156 = $42596a5caca5c2a1$export$36776f635604f274($42596a5caca5c2a1$export$30a86d91af8ff6e6 = e), $42596a5caca5c2a1$export$5880b8b5730aff45 = 0, [];
}
function $42596a5caca5c2a1$export$45918ac1574455b1(e) {
    return $42596a5caca5c2a1$export$30a86d91af8ff6e6 = "", e;
}
function $42596a5caca5c2a1$export$410ac95b9ec204b8(e) {
    return $42596a5caca5c2a1$export$87c2784dc9fc4ab($42596a5caca5c2a1$export$58adb3bec8346d0f($42596a5caca5c2a1$export$5880b8b5730aff45 - 1, $42596a5caca5c2a1$export$c889f2fcc19dbf12(e === 91 ? e + 2 : e === 40 ? e + 1 : e)));
}
function $42596a5caca5c2a1$export$660b2ee2d4fb4eff(e) {
    return $42596a5caca5c2a1$export$45918ac1574455b1($42596a5caca5c2a1$export$5f8c09e3ae6f64e1($42596a5caca5c2a1$export$2de70f21292aac9e(e)));
}
function $42596a5caca5c2a1$export$7af1228ff777d175(e) {
    while($42596a5caca5c2a1$export$c0306caf338ac095 = $42596a5caca5c2a1$export$4d3fb11e950abb9e())if ($42596a5caca5c2a1$export$c0306caf338ac095 < 33) $42596a5caca5c2a1$export$48cfd1e771a65c4f();
    else break;
    return $42596a5caca5c2a1$export$9e1725a4cfeada27(e) > 2 || $42596a5caca5c2a1$export$9e1725a4cfeada27($42596a5caca5c2a1$export$c0306caf338ac095) > 3 ? "" : " ";
}
function $42596a5caca5c2a1$export$5f8c09e3ae6f64e1(e) {
    while($42596a5caca5c2a1$export$48cfd1e771a65c4f())switch($42596a5caca5c2a1$export$9e1725a4cfeada27($42596a5caca5c2a1$export$c0306caf338ac095)){
        case 0:
            $42596a5caca5c2a1$export$10d8903dec122b9d($42596a5caca5c2a1$export$c2ab62c7bf24634($42596a5caca5c2a1$export$5880b8b5730aff45 - 1), e);
            break;
        case 2:
            $42596a5caca5c2a1$export$10d8903dec122b9d($42596a5caca5c2a1$export$410ac95b9ec204b8($42596a5caca5c2a1$export$c0306caf338ac095), e);
            break;
        default:
            $42596a5caca5c2a1$export$10d8903dec122b9d($42596a5caca5c2a1$export$6788812c4e6611e6($42596a5caca5c2a1$export$c0306caf338ac095), e);
    }
    return e;
}
function $42596a5caca5c2a1$export$955ba06d119e085e(e, r) {
    while(--r && $42596a5caca5c2a1$export$48cfd1e771a65c4f())if ($42596a5caca5c2a1$export$c0306caf338ac095 < 48 || $42596a5caca5c2a1$export$c0306caf338ac095 > 102 || $42596a5caca5c2a1$export$c0306caf338ac095 > 57 && $42596a5caca5c2a1$export$c0306caf338ac095 < 65 || $42596a5caca5c2a1$export$c0306caf338ac095 > 70 && $42596a5caca5c2a1$export$c0306caf338ac095 < 97) break;
    return $42596a5caca5c2a1$export$58adb3bec8346d0f(e, $42596a5caca5c2a1$export$e88cb2efb12ae807() + (r < 6 && $42596a5caca5c2a1$export$4d3fb11e950abb9e() == 32 && $42596a5caca5c2a1$export$48cfd1e771a65c4f() == 32));
}
function $42596a5caca5c2a1$export$c889f2fcc19dbf12(e) {
    while($42596a5caca5c2a1$export$48cfd1e771a65c4f())switch($42596a5caca5c2a1$export$c0306caf338ac095){
        case e:
            return $42596a5caca5c2a1$export$5880b8b5730aff45;
        case 34:
        case 39:
            if (e !== 34 && e !== 39) $42596a5caca5c2a1$export$c889f2fcc19dbf12($42596a5caca5c2a1$export$c0306caf338ac095);
            break;
        case 40:
            if (e === 41) $42596a5caca5c2a1$export$c889f2fcc19dbf12(e);
            break;
        case 92:
            $42596a5caca5c2a1$export$48cfd1e771a65c4f();
            break;
    }
    return $42596a5caca5c2a1$export$5880b8b5730aff45;
}
function $42596a5caca5c2a1$export$4254d4e2b3745c4c(e, r) {
    while($42596a5caca5c2a1$export$48cfd1e771a65c4f())if (e + $42596a5caca5c2a1$export$c0306caf338ac095 === 57) break;
    else if (e + $42596a5caca5c2a1$export$c0306caf338ac095 === 84 && $42596a5caca5c2a1$export$4d3fb11e950abb9e() === 47) break;
    return "/*" + $42596a5caca5c2a1$export$58adb3bec8346d0f(r, $42596a5caca5c2a1$export$5880b8b5730aff45 - 1) + "*" + $42596a5caca5c2a1$export$6788812c4e6611e6(e === 47 ? e : $42596a5caca5c2a1$export$48cfd1e771a65c4f());
}
function $42596a5caca5c2a1$export$c2ab62c7bf24634(e) {
    while(!$42596a5caca5c2a1$export$9e1725a4cfeada27($42596a5caca5c2a1$export$4d3fb11e950abb9e()))$42596a5caca5c2a1$export$48cfd1e771a65c4f();
    return $42596a5caca5c2a1$export$58adb3bec8346d0f(e, $42596a5caca5c2a1$export$5880b8b5730aff45);
}
function $42596a5caca5c2a1$export$ef7acd7185315e22(e) {
    return $42596a5caca5c2a1$export$45918ac1574455b1($42596a5caca5c2a1$export$98e6a39c04603d36("", null, null, null, [
        ""
    ], e = $42596a5caca5c2a1$export$2de70f21292aac9e(e), 0, [
        0
    ], e));
}
function $42596a5caca5c2a1$export$98e6a39c04603d36(e, r, a, n, c, s, t, u, i) {
    var f = 0;
    var o = 0;
    var l = t;
    var v = 0;
    var p = 0;
    var h = 0;
    var b = 1;
    var w = 1;
    var d = 1;
    var $ = 0;
    var g = "";
    var m = c;
    var x = s;
    var y = n;
    var j = g;
    while(w)switch(h = $, $ = $42596a5caca5c2a1$export$48cfd1e771a65c4f()){
        case 40:
            if (h != 108 && $42596a5caca5c2a1$export$a9db5e087081082d(j, l - 1) == 58) {
                if ($42596a5caca5c2a1$export$f8e21b1e77979a08(j += $42596a5caca5c2a1$export$77ad94ebf1c2b9ed($42596a5caca5c2a1$export$410ac95b9ec204b8($), "&", "&\f"), "&\f") != -1) d = -1;
                break;
            }
        case 34:
        case 39:
        case 91:
            j += $42596a5caca5c2a1$export$410ac95b9ec204b8($);
            break;
        case 9:
        case 10:
        case 13:
        case 32:
            j += $42596a5caca5c2a1$export$7af1228ff777d175(h);
            break;
        case 92:
            j += $42596a5caca5c2a1$export$955ba06d119e085e($42596a5caca5c2a1$export$e88cb2efb12ae807() - 1, 7);
            continue;
        case 47:
            switch($42596a5caca5c2a1$export$4d3fb11e950abb9e()){
                case 42:
                case 47:
                    $42596a5caca5c2a1$export$10d8903dec122b9d($42596a5caca5c2a1$export$4a34f930e789283c($42596a5caca5c2a1$export$4254d4e2b3745c4c($42596a5caca5c2a1$export$48cfd1e771a65c4f(), $42596a5caca5c2a1$export$e88cb2efb12ae807()), r, a), i);
                    break;
                default:
                    j += "/";
            }
            break;
        case 123 * b:
            u[f++] = $42596a5caca5c2a1$export$36776f635604f274(j) * d;
        case 125 * b:
        case 59:
        case 0:
            switch($){
                case 0:
                case 125:
                    w = 0;
                case 59 + o:
                    if (d == -1) j = $42596a5caca5c2a1$export$77ad94ebf1c2b9ed(j, /\f/g, "");
                    if (p > 0 && $42596a5caca5c2a1$export$36776f635604f274(j) - l) $42596a5caca5c2a1$export$10d8903dec122b9d(p > 32 ? $42596a5caca5c2a1$export$f8483753829ec8f3(j + ";", n, a, l - 1) : $42596a5caca5c2a1$export$f8483753829ec8f3($42596a5caca5c2a1$export$77ad94ebf1c2b9ed(j, " ", "") + ";", n, a, l - 2), i);
                    break;
                case 59:
                    j += ";";
                default:
                    $42596a5caca5c2a1$export$10d8903dec122b9d(y = $42596a5caca5c2a1$export$3307ffa7023ede1e(j, r, a, f, o, c, u, g, m = [], x = [], l), s);
                    if ($ === 123) {
                        if (o === 0) $42596a5caca5c2a1$export$98e6a39c04603d36(j, r, y, y, m, s, l, u, x);
                        else switch(v === 99 && $42596a5caca5c2a1$export$a9db5e087081082d(j, 3) === 110 ? 100 : v){
                            case 100:
                            case 108:
                            case 109:
                            case 115:
                                $42596a5caca5c2a1$export$98e6a39c04603d36(e, y, y, n && $42596a5caca5c2a1$export$10d8903dec122b9d($42596a5caca5c2a1$export$3307ffa7023ede1e(e, y, y, 0, 0, c, u, g, c, m = [], l), x), c, x, l, u, n ? m : x);
                                break;
                            default:
                                $42596a5caca5c2a1$export$98e6a39c04603d36(j, y, y, y, [
                                    ""
                                ], x, 0, u, x);
                        }
                    }
            }
            f = o = p = 0, b = d = 1, g = j = "", l = t;
            break;
        case 58:
            l = 1 + $42596a5caca5c2a1$export$36776f635604f274(j), p = h;
        default:
            if (b < 1) {
                if ($ == 123) --b;
                else if ($ == 125 && b++ == 0 && $42596a5caca5c2a1$export$232faf9add678146() == 125) continue;
            }
            switch(j += $42596a5caca5c2a1$export$6788812c4e6611e6($), $ * b){
                case 38:
                    d = o > 0 ? 1 : (j += "\f", -1);
                    break;
                case 44:
                    u[f++] = ($42596a5caca5c2a1$export$36776f635604f274(j) - 1) * d, d = 1;
                    break;
                case 64:
                    if ($42596a5caca5c2a1$export$4d3fb11e950abb9e() === 45) j += $42596a5caca5c2a1$export$410ac95b9ec204b8($42596a5caca5c2a1$export$48cfd1e771a65c4f());
                    v = $42596a5caca5c2a1$export$4d3fb11e950abb9e(), o = l = $42596a5caca5c2a1$export$36776f635604f274(g = j += $42596a5caca5c2a1$export$c2ab62c7bf24634($42596a5caca5c2a1$export$e88cb2efb12ae807())), $++;
                    break;
                case 45:
                    if (h === 45 && $42596a5caca5c2a1$export$36776f635604f274(j) == 2) b = 0;
            }
    }
    return s;
}
function $42596a5caca5c2a1$export$3307ffa7023ede1e(e, r, a, n, s, t, u, i, f, o, l) {
    var v = s - 1;
    var p = s === 0 ? t : [
        ""
    ];
    var h = $42596a5caca5c2a1$export$f9084667e487ed46(p);
    for(var b = 0, w = 0, d = 0; b < n; ++b)for(var $ = 0, k = $42596a5caca5c2a1$export$2f35ab04d2335697(e, v + 1, v = $42596a5caca5c2a1$export$2335f513bbd82c6d(w = u[b])), m = e; $ < h; ++$)if (m = $42596a5caca5c2a1$export$87c2784dc9fc4ab(w > 0 ? p[$] + " " + k : $42596a5caca5c2a1$export$77ad94ebf1c2b9ed(k, /&\f/g, p[$]))) f[d++] = m;
    return $42596a5caca5c2a1$export$35059013cd4a06db(e, r, a, s === 0 ? $42596a5caca5c2a1$export$aa3a2e812ca8570d : i, f, o, l);
}
function $42596a5caca5c2a1$export$4a34f930e789283c(e, r, a) {
    return $42596a5caca5c2a1$export$35059013cd4a06db(e, r, a, $42596a5caca5c2a1$export$a29989082612d0d9, $42596a5caca5c2a1$export$6788812c4e6611e6($42596a5caca5c2a1$export$eba6f6f03b0a92e7()), $42596a5caca5c2a1$export$2f35ab04d2335697(e, 2, -2), 0);
}
function $42596a5caca5c2a1$export$f8483753829ec8f3(e, r, a, n) {
    return $42596a5caca5c2a1$export$35059013cd4a06db(e, r, a, $42596a5caca5c2a1$export$527d108ccf083c2b, $42596a5caca5c2a1$export$2f35ab04d2335697(e, 0, n), $42596a5caca5c2a1$export$2f35ab04d2335697(e, n + 1, -1), n);
}
function $42596a5caca5c2a1$export$82e9f45cca5ba907(n, c, s) {
    switch($42596a5caca5c2a1$export$d6af199866bfb566(n, c)){
        case 5103:
            return $42596a5caca5c2a1$export$39dfd62a25e0fe93 + "print-" + n + n;
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return $42596a5caca5c2a1$export$39dfd62a25e0fe93 + n + n;
        case 4789:
            return $42596a5caca5c2a1$export$2c0f367103c8d01c + n + n;
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return $42596a5caca5c2a1$export$39dfd62a25e0fe93 + n + $42596a5caca5c2a1$export$2c0f367103c8d01c + n + $42596a5caca5c2a1$export$71ad59f2e432cfe8 + n + n;
        case 5936:
            switch($42596a5caca5c2a1$export$a9db5e087081082d(n, c + 11)){
                case 114:
                    return $42596a5caca5c2a1$export$39dfd62a25e0fe93 + n + $42596a5caca5c2a1$export$71ad59f2e432cfe8 + $42596a5caca5c2a1$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "tb") + n;
                case 108:
                    return $42596a5caca5c2a1$export$39dfd62a25e0fe93 + n + $42596a5caca5c2a1$export$71ad59f2e432cfe8 + $42596a5caca5c2a1$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "tb-rl") + n;
                case 45:
                    return $42596a5caca5c2a1$export$39dfd62a25e0fe93 + n + $42596a5caca5c2a1$export$71ad59f2e432cfe8 + $42596a5caca5c2a1$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "lr") + n;
            }
        case 6828:
        case 4268:
        case 2903:
            return $42596a5caca5c2a1$export$39dfd62a25e0fe93 + n + $42596a5caca5c2a1$export$71ad59f2e432cfe8 + n + n;
        case 6165:
            return $42596a5caca5c2a1$export$39dfd62a25e0fe93 + n + $42596a5caca5c2a1$export$71ad59f2e432cfe8 + "flex-" + n + n;
        case 5187:
            return $42596a5caca5c2a1$export$39dfd62a25e0fe93 + n + $42596a5caca5c2a1$export$77ad94ebf1c2b9ed(n, /(\w+).+(:[^]+)/, $42596a5caca5c2a1$export$39dfd62a25e0fe93 + "box-$1$2" + $42596a5caca5c2a1$export$71ad59f2e432cfe8 + "flex-$1$2") + n;
        case 5443:
            return $42596a5caca5c2a1$export$39dfd62a25e0fe93 + n + $42596a5caca5c2a1$export$71ad59f2e432cfe8 + "flex-item-" + $42596a5caca5c2a1$export$77ad94ebf1c2b9ed(n, /flex-|-self/g, "") + (!$42596a5caca5c2a1$export$4659b591c19bdf3d(n, /flex-|baseline/) ? $42596a5caca5c2a1$export$71ad59f2e432cfe8 + "grid-row-" + $42596a5caca5c2a1$export$77ad94ebf1c2b9ed(n, /flex-|-self/g, "") : "") + n;
        case 4675:
            return $42596a5caca5c2a1$export$39dfd62a25e0fe93 + n + $42596a5caca5c2a1$export$71ad59f2e432cfe8 + "flex-line-pack" + $42596a5caca5c2a1$export$77ad94ebf1c2b9ed(n, /align-content|flex-|-self/g, "") + n;
        case 5548:
            return $42596a5caca5c2a1$export$39dfd62a25e0fe93 + n + $42596a5caca5c2a1$export$71ad59f2e432cfe8 + $42596a5caca5c2a1$export$77ad94ebf1c2b9ed(n, "shrink", "negative") + n;
        case 5292:
            return $42596a5caca5c2a1$export$39dfd62a25e0fe93 + n + $42596a5caca5c2a1$export$71ad59f2e432cfe8 + $42596a5caca5c2a1$export$77ad94ebf1c2b9ed(n, "basis", "preferred-size") + n;
        case 6060:
            return $42596a5caca5c2a1$export$39dfd62a25e0fe93 + "box-" + $42596a5caca5c2a1$export$77ad94ebf1c2b9ed(n, "-grow", "") + $42596a5caca5c2a1$export$39dfd62a25e0fe93 + n + $42596a5caca5c2a1$export$71ad59f2e432cfe8 + $42596a5caca5c2a1$export$77ad94ebf1c2b9ed(n, "grow", "positive") + n;
        case 4554:
            return $42596a5caca5c2a1$export$39dfd62a25e0fe93 + $42596a5caca5c2a1$export$77ad94ebf1c2b9ed(n, /([^-])(transform)/g, "$1" + $42596a5caca5c2a1$export$39dfd62a25e0fe93 + "$2") + n;
        case 6187:
            return $42596a5caca5c2a1$export$77ad94ebf1c2b9ed($42596a5caca5c2a1$export$77ad94ebf1c2b9ed($42596a5caca5c2a1$export$77ad94ebf1c2b9ed(n, /(zoom-|grab)/, $42596a5caca5c2a1$export$39dfd62a25e0fe93 + "$1"), /(image-set)/, $42596a5caca5c2a1$export$39dfd62a25e0fe93 + "$1"), n, "") + n;
        case 5495:
        case 3959:
            return $42596a5caca5c2a1$export$77ad94ebf1c2b9ed(n, /(image-set\([^]*)/, $42596a5caca5c2a1$export$39dfd62a25e0fe93 + "$1" + "$`$1");
        case 4968:
            return $42596a5caca5c2a1$export$77ad94ebf1c2b9ed($42596a5caca5c2a1$export$77ad94ebf1c2b9ed(n, /(.+:)(flex-)?(.*)/, $42596a5caca5c2a1$export$39dfd62a25e0fe93 + "box-pack:$3" + $42596a5caca5c2a1$export$71ad59f2e432cfe8 + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + $42596a5caca5c2a1$export$39dfd62a25e0fe93 + n + n;
        case 4200:
            if (!$42596a5caca5c2a1$export$4659b591c19bdf3d(n, /flex-|baseline/)) return $42596a5caca5c2a1$export$71ad59f2e432cfe8 + "grid-column-align" + $42596a5caca5c2a1$export$2f35ab04d2335697(n, c) + n;
            break;
        case 2592:
        case 3360:
            return $42596a5caca5c2a1$export$71ad59f2e432cfe8 + $42596a5caca5c2a1$export$77ad94ebf1c2b9ed(n, "template-", "") + n;
        case 4384:
        case 3616:
            if (s && s.some(function(e, r) {
                return c = r, $42596a5caca5c2a1$export$4659b591c19bdf3d(e.props, /grid-\w+-end/);
            })) return ~$42596a5caca5c2a1$export$f8e21b1e77979a08(n + (s = s[c].value), "span") ? n : $42596a5caca5c2a1$export$71ad59f2e432cfe8 + $42596a5caca5c2a1$export$77ad94ebf1c2b9ed(n, "-start", "") + n + $42596a5caca5c2a1$export$71ad59f2e432cfe8 + "grid-row-span:" + (~$42596a5caca5c2a1$export$f8e21b1e77979a08(s, "span") ? $42596a5caca5c2a1$export$4659b591c19bdf3d(s, /\d+/) : +$42596a5caca5c2a1$export$4659b591c19bdf3d(s, /\d+/) - +$42596a5caca5c2a1$export$4659b591c19bdf3d(n, /\d+/)) + ";";
            return $42596a5caca5c2a1$export$71ad59f2e432cfe8 + $42596a5caca5c2a1$export$77ad94ebf1c2b9ed(n, "-start", "") + n;
        case 4896:
        case 4128:
            return s && s.some(function(e) {
                return $42596a5caca5c2a1$export$4659b591c19bdf3d(e.props, /grid-\w+-start/);
            }) ? n : $42596a5caca5c2a1$export$71ad59f2e432cfe8 + $42596a5caca5c2a1$export$77ad94ebf1c2b9ed($42596a5caca5c2a1$export$77ad94ebf1c2b9ed(n, "-end", "-span"), "span ", "") + n;
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return $42596a5caca5c2a1$export$77ad94ebf1c2b9ed(n, /(.+)-inline(.+)/, $42596a5caca5c2a1$export$39dfd62a25e0fe93 + "$1$2") + n;
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            if ($42596a5caca5c2a1$export$36776f635604f274(n) - 1 - c > 6) switch($42596a5caca5c2a1$export$a9db5e087081082d(n, c + 1)){
                case 109:
                    if ($42596a5caca5c2a1$export$a9db5e087081082d(n, c + 4) !== 45) break;
                case 102:
                    return $42596a5caca5c2a1$export$77ad94ebf1c2b9ed(n, /(.+:)(.+)-([^]+)/, "$1" + $42596a5caca5c2a1$export$39dfd62a25e0fe93 + "$2-$3" + "$1" + $42596a5caca5c2a1$export$2c0f367103c8d01c + ($42596a5caca5c2a1$export$a9db5e087081082d(n, c + 3) == 108 ? "$3" : "$2-$3")) + n;
                case 115:
                    return ~$42596a5caca5c2a1$export$f8e21b1e77979a08(n, "stretch") ? $42596a5caca5c2a1$export$82e9f45cca5ba907($42596a5caca5c2a1$export$77ad94ebf1c2b9ed(n, "stretch", "fill-available"), c, s) + n : n;
            }
            break;
        case 5152:
        case 5920:
            return $42596a5caca5c2a1$export$77ad94ebf1c2b9ed(n, /(.+?):(\d+)(\s*\/\s*(span)?\s*(\d+))?(.*)/, function(r, a, c, s, t, u, i) {
                return $42596a5caca5c2a1$export$71ad59f2e432cfe8 + a + ":" + c + i + (s ? $42596a5caca5c2a1$export$71ad59f2e432cfe8 + a + "-span:" + (t ? u : +u - +c) + i : "") + n;
            });
        case 4949:
            if ($42596a5caca5c2a1$export$a9db5e087081082d(n, c + 6) === 121) return $42596a5caca5c2a1$export$77ad94ebf1c2b9ed(n, ":", ":" + $42596a5caca5c2a1$export$39dfd62a25e0fe93) + n;
            break;
        case 6444:
            switch($42596a5caca5c2a1$export$a9db5e087081082d(n, $42596a5caca5c2a1$export$a9db5e087081082d(n, 14) === 45 ? 18 : 11)){
                case 120:
                    return $42596a5caca5c2a1$export$77ad94ebf1c2b9ed(n, /(.+:)([^;\s!]+)(;|(\s+)?!.+)?/, "$1" + $42596a5caca5c2a1$export$39dfd62a25e0fe93 + ($42596a5caca5c2a1$export$a9db5e087081082d(n, 14) === 45 ? "inline-" : "") + "box$3" + "$1" + $42596a5caca5c2a1$export$39dfd62a25e0fe93 + "$2$3" + "$1" + $42596a5caca5c2a1$export$71ad59f2e432cfe8 + "$2box$3") + n;
                case 100:
                    return $42596a5caca5c2a1$export$77ad94ebf1c2b9ed(n, ":", ":" + $42596a5caca5c2a1$export$71ad59f2e432cfe8) + n;
            }
            break;
        case 5719:
        case 2647:
        case 2135:
        case 3927:
        case 2391:
            return $42596a5caca5c2a1$export$77ad94ebf1c2b9ed(n, "scroll-", "scroll-snap-") + n;
    }
    return n;
}
function $42596a5caca5c2a1$export$dfdc1655ccc5b9cb(e, r) {
    var a = "";
    var n = $42596a5caca5c2a1$export$f9084667e487ed46(e);
    for(var c = 0; c < n; c++)a += r(e[c], c, e, r) || "";
    return a;
}
function $42596a5caca5c2a1$export$fac44ee5b035f737(e, r, a, t) {
    switch(e.type){
        case $42596a5caca5c2a1$export$d773506282b3cfe6:
            if (e.children.length) break;
        case $42596a5caca5c2a1$export$a763edbf796b780a:
        case $42596a5caca5c2a1$export$527d108ccf083c2b:
            return e.return = e.return || e.value;
        case $42596a5caca5c2a1$export$a29989082612d0d9:
            return "";
        case $42596a5caca5c2a1$export$b44a8529a35fcb60:
            return e.return = e.value + "{" + $42596a5caca5c2a1$export$dfdc1655ccc5b9cb(e.children, t) + "}";
        case $42596a5caca5c2a1$export$aa3a2e812ca8570d:
            e.value = e.props.join(",");
    }
    return $42596a5caca5c2a1$export$36776f635604f274(a = $42596a5caca5c2a1$export$dfdc1655ccc5b9cb(e.children, t)) ? e.return = e.value + "{" + a + "}" : "";
}
function $42596a5caca5c2a1$export$5a7767152ae0305f(e) {
    var r = $42596a5caca5c2a1$export$f9084667e487ed46(e);
    return function(a, n, c, s) {
        var t = "";
        for(var u = 0; u < r; u++)t += e[u](a, n, c, s) || "";
        return t;
    };
}
function $42596a5caca5c2a1$export$38bcb760f1d4871c(e) {
    return function(r) {
        if (!r.root) {
            if (r = r.return) e(r);
        }
    };
}
function $42596a5caca5c2a1$export$e08c7d021b829b7a(n, t, u, i) {
    if (n.length > -1) {
        if (!n.return) switch(n.type){
            case $42596a5caca5c2a1$export$527d108ccf083c2b:
                n.return = $42596a5caca5c2a1$export$82e9f45cca5ba907(n.value, n.length, u);
                return;
            case $42596a5caca5c2a1$export$b44a8529a35fcb60:
                return $42596a5caca5c2a1$export$dfdc1655ccc5b9cb([
                    $42596a5caca5c2a1$export$784d13d8ee351f07(n, {
                        value: $42596a5caca5c2a1$export$77ad94ebf1c2b9ed(n.value, "@", "@" + $42596a5caca5c2a1$export$39dfd62a25e0fe93)
                    })
                ], i);
            case $42596a5caca5c2a1$export$aa3a2e812ca8570d:
                if (n.length) return $42596a5caca5c2a1$export$1be1fc439b849fdf(n.props, function(c) {
                    switch($42596a5caca5c2a1$export$4659b591c19bdf3d(c, /(::plac\w+|:read-\w+)/)){
                        case ":read-only":
                        case ":read-write":
                            return $42596a5caca5c2a1$export$dfdc1655ccc5b9cb([
                                $42596a5caca5c2a1$export$784d13d8ee351f07(n, {
                                    props: [
                                        $42596a5caca5c2a1$export$77ad94ebf1c2b9ed(c, /:(read-\w+)/, ":" + $42596a5caca5c2a1$export$2c0f367103c8d01c + "$1")
                                    ]
                                })
                            ], i);
                        case "::placeholder":
                            return $42596a5caca5c2a1$export$dfdc1655ccc5b9cb([
                                $42596a5caca5c2a1$export$784d13d8ee351f07(n, {
                                    props: [
                                        $42596a5caca5c2a1$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, ":" + $42596a5caca5c2a1$export$39dfd62a25e0fe93 + "input-$1")
                                    ]
                                }),
                                $42596a5caca5c2a1$export$784d13d8ee351f07(n, {
                                    props: [
                                        $42596a5caca5c2a1$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, ":" + $42596a5caca5c2a1$export$2c0f367103c8d01c + "$1")
                                    ]
                                }),
                                $42596a5caca5c2a1$export$784d13d8ee351f07(n, {
                                    props: [
                                        $42596a5caca5c2a1$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, $42596a5caca5c2a1$export$71ad59f2e432cfe8 + "input-$1")
                                    ]
                                })
                            ], i);
                    }
                    return "";
                });
        }
    }
}
function $42596a5caca5c2a1$export$76a88f7de6507443(e) {
    switch(e.type){
        case $42596a5caca5c2a1$export$aa3a2e812ca8570d:
            e.props = e.props.map(function(r) {
                return $42596a5caca5c2a1$export$1be1fc439b849fdf($42596a5caca5c2a1$export$660b2ee2d4fb4eff(r), function(r, a, n) {
                    switch($42596a5caca5c2a1$export$a9db5e087081082d(r, 0)){
                        case 12:
                            return $42596a5caca5c2a1$export$2f35ab04d2335697(r, 1, $42596a5caca5c2a1$export$36776f635604f274(r));
                        case 0:
                        case 40:
                        case 43:
                        case 62:
                        case 126:
                            return r;
                        case 58:
                            if (n[++a] === "global") n[a] = "", n[++a] = "\f" + $42596a5caca5c2a1$export$2f35ab04d2335697(n[a], a = 1, -1);
                        case 32:
                            return a === 1 ? "" : r;
                        default:
                            switch(a){
                                case 0:
                                    e = r;
                                    return $42596a5caca5c2a1$export$f9084667e487ed46(n) > 1 ? "" : r;
                                case a = $42596a5caca5c2a1$export$f9084667e487ed46(n) - 1:
                                case 2:
                                    return a === 2 ? r + e + e : r + e;
                                default:
                                    return r;
                            }
                    }
                });
            });
    }
}

});

parcelRegister("jwT2u", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e37bb31c78c65b4d$export$2e2bcd8739ae039; });
var $e37bb31c78c65b4d$export$2e2bcd8739ae039 = function weakMemoize(func) {
    var cache = new WeakMap();
    return function(arg) {
        if (cache.has(arg)) // Use non-null assertion because we just checked that the cache `has` it
        // This allows us to remove `undefined` from the return value
        return cache.get(arg);
        var ret = func(arg);
        cache.set(arg, ret);
        return ret;
    };
};

});

parcelRegister("7VXY1", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5c6c5f7732f98f34$export$2e2bcd8739ae039; });
function $5c6c5f7732f98f34$export$2e2bcd8739ae039(fn) {
    var cache = Object.create(null);
    return function(arg) {
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}

});


parcelRegister("1hncf", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0ee95f5747dad74f$export$2e2bcd8739ae039; });

var $gMU8G = parcelRequire("gMU8G");
// this file isolates this package that is not tree-shakeable
// and if this module doesn't actually contain any logic of its own
// then Rollup just use 'hoist-non-react-statics' directly in other chunks
var $0ee95f5747dad74f$export$2e2bcd8739ae039 = function(targetComponent, sourceComponent) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($gMU8G)))(targetComponent, sourceComponent);
};

});
parcelRegister("gMU8G", function(module, exports) {
'use strict';

var $7vG36 = parcelRequire("7vG36");
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */ var $c38cad10894f21e2$var$REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};
var $c38cad10894f21e2$var$KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};
var $c38cad10894f21e2$var$FORWARD_REF_STATICS = {
    '$$typeof': true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
};
var $c38cad10894f21e2$var$MEMO_STATICS = {
    '$$typeof': true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
};
var $c38cad10894f21e2$var$TYPE_STATICS = {};
$c38cad10894f21e2$var$TYPE_STATICS[$7vG36.ForwardRef] = $c38cad10894f21e2$var$FORWARD_REF_STATICS;
$c38cad10894f21e2$var$TYPE_STATICS[$7vG36.Memo] = $c38cad10894f21e2$var$MEMO_STATICS;
function $c38cad10894f21e2$var$getStatics(component) {
    // React v16.11 and below
    if ($7vG36.isMemo(component)) return $c38cad10894f21e2$var$MEMO_STATICS;
     // React v16.12 and above
    return $c38cad10894f21e2$var$TYPE_STATICS[component['$$typeof']] || $c38cad10894f21e2$var$REACT_STATICS;
}
var $c38cad10894f21e2$var$defineProperty = Object.defineProperty;
var $c38cad10894f21e2$var$getOwnPropertyNames = Object.getOwnPropertyNames;
var $c38cad10894f21e2$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $c38cad10894f21e2$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $c38cad10894f21e2$var$getPrototypeOf = Object.getPrototypeOf;
var $c38cad10894f21e2$var$objectPrototype = Object.prototype;
function $c38cad10894f21e2$var$hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== 'string') {
        // don't hoist over string (html) components
        if ($c38cad10894f21e2$var$objectPrototype) {
            var inheritedComponent = $c38cad10894f21e2$var$getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== $c38cad10894f21e2$var$objectPrototype) $c38cad10894f21e2$var$hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
        }
        var keys = $c38cad10894f21e2$var$getOwnPropertyNames(sourceComponent);
        if ($c38cad10894f21e2$var$getOwnPropertySymbols) keys = keys.concat($c38cad10894f21e2$var$getOwnPropertySymbols(sourceComponent));
        var targetStatics = $c38cad10894f21e2$var$getStatics(targetComponent);
        var sourceStatics = $c38cad10894f21e2$var$getStatics(sourceComponent);
        for(var i = 0; i < keys.length; ++i){
            var key = keys[i];
            if (!$c38cad10894f21e2$var$KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                var descriptor = $c38cad10894f21e2$var$getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    // Avoid failures from read-only properties
                    $c38cad10894f21e2$var$defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }
    }
    return targetComponent;
}
module.exports = $c38cad10894f21e2$var$hoistNonReactStatics;

});
parcelRegister("7vG36", function(module, exports) {
'use strict';

module.exports = (parcelRequire("k5gu5"));

});



parcelRegister("9nBLf", function(module, exports) {

$parcel$export(module.exports, "getRegisteredStyles", function () { return $6d438d99b0ecd739$export$95d99596f328fd52; });
$parcel$export(module.exports, "registerStyles", function () { return $6d438d99b0ecd739$export$580009a5da2a8b4b; });
$parcel$export(module.exports, "insertStyles", function () { return $6d438d99b0ecd739$export$6f077d94b33a01aa; });
var $6d438d99b0ecd739$var$isBrowser = typeof document !== 'undefined';
function $6d438d99b0ecd739$export$95d99596f328fd52(registered, registeredStyles, classNames) {
    var rawClassName = '';
    classNames.split(' ').forEach(function(className) {
        if (registered[className] !== undefined) registeredStyles.push(registered[className] + ";");
        else if (className) rawClassName += className + " ";
    });
    return rawClassName;
}
var $6d438d99b0ecd739$export$580009a5da2a8b4b = function registerStyles(cache, serialized, isStringTag) {
    var className = cache.key + "-" + serialized.name;
    if (// class name could be used further down
    // the tree but if it's a string tag, we know it won't
    // so we don't have to add it to registered cache.
    // this improves memory usage since we can avoid storing the whole style string
    (isStringTag === false || // we need to always store it if we're in compat mode and
    // in node since emotion-server relies on whether a style is in
    // the registered cache to know whether a style is global or not
    // also, note that this check will be dead code eliminated in the browser
    $6d438d99b0ecd739$var$isBrowser === false && cache.compat !== undefined) && cache.registered[className] === undefined) cache.registered[className] = serialized.styles;
};
var $6d438d99b0ecd739$export$6f077d94b33a01aa = function insertStyles(cache, serialized, isStringTag) {
    $6d438d99b0ecd739$export$580009a5da2a8b4b(cache, serialized, isStringTag);
    var className = cache.key + "-" + serialized.name;
    if (cache.inserted[serialized.name] === undefined) {
        var stylesForSSR = '';
        var current = serialized;
        do {
            var maybeStyles = cache.insert(serialized === current ? "." + className : '', current, cache.sheet, true);
            if (!$6d438d99b0ecd739$var$isBrowser && maybeStyles !== undefined) stylesForSSR += maybeStyles;
            current = current.next;
        }while (current !== undefined);
        if (!$6d438d99b0ecd739$var$isBrowser && stylesForSSR.length !== 0) return stylesForSSR;
    }
};

});

parcelRegister("hs5T6", function(module, exports) {

$parcel$export(module.exports, "serializeStyles", function () { return $cb499e5eb71a6c0c$export$6321afa313b251b5; });

var $8QzsW = parcelRequire("8QzsW");

var $6BGKX = parcelRequire("6BGKX");

var $7VXY1 = parcelRequire("7VXY1");
var $cb499e5eb71a6c0c$var$isDevelopment = false;
var $cb499e5eb71a6c0c$var$hyphenateRegex = /[A-Z]|^ms/g;
var $cb499e5eb71a6c0c$var$animationRegex = /_EMO_([^_]+?)_([^]*?)_EMO_/g;
var $cb499e5eb71a6c0c$var$isCustomProperty = function isCustomProperty(property) {
    return property.charCodeAt(1) === 45;
};
var $cb499e5eb71a6c0c$var$isProcessableValue = function isProcessableValue(value) {
    return value != null && typeof value !== 'boolean';
};
var $cb499e5eb71a6c0c$var$processStyleName = /* #__PURE__ */ (0, $7VXY1.default)(function(styleName) {
    return $cb499e5eb71a6c0c$var$isCustomProperty(styleName) ? styleName : styleName.replace($cb499e5eb71a6c0c$var$hyphenateRegex, '-$&').toLowerCase();
});
var $cb499e5eb71a6c0c$var$processStyleValue = function processStyleValue(key, value) {
    switch(key){
        case 'animation':
        case 'animationName':
            if (typeof value === 'string') return value.replace($cb499e5eb71a6c0c$var$animationRegex, function(match, p1, p2) {
                $cb499e5eb71a6c0c$var$cursor = {
                    name: p1,
                    styles: p2,
                    next: $cb499e5eb71a6c0c$var$cursor
                };
                return p1;
            });
    }
    if ((0, $6BGKX.default)[key] !== 1 && !$cb499e5eb71a6c0c$var$isCustomProperty(key) && typeof value === 'number' && value !== 0) return value + 'px';
    return value;
};
var $cb499e5eb71a6c0c$var$noComponentSelectorMessage = "Component selectors can only be used in conjunction with @emotion/babel-plugin, the swc Emotion plugin, or another Emotion-aware compiler transform.";
function $cb499e5eb71a6c0c$var$handleInterpolation(mergedProps, registered, interpolation) {
    if (interpolation == null) return '';
    var componentSelector = interpolation;
    if (componentSelector.__emotion_styles !== undefined) return componentSelector;
    switch(typeof interpolation){
        case 'boolean':
            return '';
        case 'object':
            var keyframes = interpolation;
            if (keyframes.anim === 1) {
                $cb499e5eb71a6c0c$var$cursor = {
                    name: keyframes.name,
                    styles: keyframes.styles,
                    next: $cb499e5eb71a6c0c$var$cursor
                };
                return keyframes.name;
            }
            var serializedStyles = interpolation;
            if (serializedStyles.styles !== undefined) {
                var next = serializedStyles.next;
                if (next !== undefined) // not the most efficient thing ever but this is a pretty rare case
                // and there will be very few iterations of this generally
                while(next !== undefined){
                    $cb499e5eb71a6c0c$var$cursor = {
                        name: next.name,
                        styles: next.styles,
                        next: $cb499e5eb71a6c0c$var$cursor
                    };
                    next = next.next;
                }
                var styles = serializedStyles.styles + ";";
                return styles;
            }
            return $cb499e5eb71a6c0c$var$createStringFromObject(mergedProps, registered, interpolation);
        case 'function':
            if (mergedProps !== undefined) {
                var previousCursor = $cb499e5eb71a6c0c$var$cursor;
                var result = interpolation(mergedProps);
                $cb499e5eb71a6c0c$var$cursor = previousCursor;
                return $cb499e5eb71a6c0c$var$handleInterpolation(mergedProps, registered, result);
            }
            break;
    } // finalize string values (regular strings and functions interpolated into css calls)
    var asString = interpolation;
    if (registered == null) return asString;
    var cached = registered[asString];
    return cached !== undefined ? cached : asString;
}
function $cb499e5eb71a6c0c$var$createStringFromObject(mergedProps, registered, obj) {
    var string = '';
    if (Array.isArray(obj)) for(var i = 0; i < obj.length; i++)string += $cb499e5eb71a6c0c$var$handleInterpolation(mergedProps, registered, obj[i]) + ";";
    else for(var key in obj){
        var value = obj[key];
        if (typeof value !== 'object') {
            var asString = value;
            if (registered != null && registered[asString] !== undefined) string += key + "{" + registered[asString] + "}";
            else if ($cb499e5eb71a6c0c$var$isProcessableValue(asString)) string += $cb499e5eb71a6c0c$var$processStyleName(key) + ":" + $cb499e5eb71a6c0c$var$processStyleValue(key, asString) + ";";
        } else {
            if (key === 'NO_COMPONENT_SELECTOR' && $cb499e5eb71a6c0c$var$isDevelopment) throw new Error($cb499e5eb71a6c0c$var$noComponentSelectorMessage);
            if (Array.isArray(value) && typeof value[0] === 'string' && (registered == null || registered[value[0]] === undefined)) {
                for(var _i = 0; _i < value.length; _i++)if ($cb499e5eb71a6c0c$var$isProcessableValue(value[_i])) string += $cb499e5eb71a6c0c$var$processStyleName(key) + ":" + $cb499e5eb71a6c0c$var$processStyleValue(key, value[_i]) + ";";
            } else {
                var interpolated = $cb499e5eb71a6c0c$var$handleInterpolation(mergedProps, registered, value);
                switch(key){
                    case 'animation':
                    case 'animationName':
                        string += $cb499e5eb71a6c0c$var$processStyleName(key) + ":" + interpolated + ";";
                        break;
                    default:
                        string += key + "{" + interpolated + "}";
                }
            }
        }
    }
    return string;
}
var $cb499e5eb71a6c0c$var$labelPattern = /label:\s*([^\s;{]+)\s*(;|$)/g; // this is the cursor for keyframes
// keyframes are stored on the SerializedStyles object as a linked list
var $cb499e5eb71a6c0c$var$cursor;
function $cb499e5eb71a6c0c$export$6321afa313b251b5(args, registered, mergedProps) {
    if (args.length === 1 && typeof args[0] === 'object' && args[0] !== null && args[0].styles !== undefined) return args[0];
    var stringMode = true;
    var styles = '';
    $cb499e5eb71a6c0c$var$cursor = undefined;
    var strings = args[0];
    if (strings == null || strings.raw === undefined) {
        stringMode = false;
        styles += $cb499e5eb71a6c0c$var$handleInterpolation(mergedProps, registered, strings);
    } else {
        var asTemplateStringsArr = strings;
        styles += asTemplateStringsArr[0];
    } // we start at 1 since we've already handled the first arg
    for(var i = 1; i < args.length; i++){
        styles += $cb499e5eb71a6c0c$var$handleInterpolation(mergedProps, registered, args[i]);
        if (stringMode) {
            var templateStringsArr = strings;
            styles += templateStringsArr[i];
        }
    } // using a global regex with .exec is stateful so lastIndex has to be reset each time
    $cb499e5eb71a6c0c$var$labelPattern.lastIndex = 0;
    var identifierName = '';
    var match; // https://esbench.com/bench/5b809c2cf2949800a0f61fb5
    while((match = $cb499e5eb71a6c0c$var$labelPattern.exec(styles)) !== null)identifierName += '-' + match[1];
    var name = (0, $8QzsW.default)(styles) + identifierName;
    return {
        name: name,
        styles: styles,
        next: $cb499e5eb71a6c0c$var$cursor
    };
}

});
parcelRegister("8QzsW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $670eb0d2316b96d2$export$2e2bcd8739ae039; });
/* eslint-disable */ // Inspired by https://github.com/garycourt/murmurhash-js
// Ported from https://github.com/aappleby/smhasher/blob/61a0530f28277f2e850bfc39600ce61d02b518de/src/MurmurHash2.cpp#L37-L86
function $670eb0d2316b96d2$export$2e2bcd8739ae039(str) {
    // 'm' and 'r' are mixing constants generated offline.
    // They're not really 'magic', they just happen to work well.
    // const m = 0x5bd1e995;
    // const r = 24;
    // Initialize the hash
    var h = 0; // Mix 4 bytes at a time into the hash
    var k, i = 0, len = str.length;
    for(; len >= 4; ++i, len -= 4){
        k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
        k = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16);
        k ^= /* k >>> r: */ k >>> 24;
        h = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16) ^ /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Handle the last few bytes of the input array
    switch(len){
        case 3:
            h ^= (str.charCodeAt(i + 2) & 0xff) << 16;
        case 2:
            h ^= (str.charCodeAt(i + 1) & 0xff) << 8;
        case 1:
            h ^= str.charCodeAt(i) & 0xff;
            h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Do a few final mixes of the hash to ensure the last few
    // bytes are well-incorporated.
    h ^= h >>> 13;
    h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    return ((h ^ h >>> 15) >>> 0).toString(36);
}

});

parcelRegister("6BGKX", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4cf75d4f79a4152d$export$2e2bcd8739ae039; });
var $4cf75d4f79a4152d$export$2e2bcd8739ae039 = {
    animationIterationCount: 1,
    aspectRatio: 1,
    borderImageOutset: 1,
    borderImageSlice: 1,
    borderImageWidth: 1,
    boxFlex: 1,
    boxFlexGroup: 1,
    boxOrdinalGroup: 1,
    columnCount: 1,
    columns: 1,
    flex: 1,
    flexGrow: 1,
    flexPositive: 1,
    flexShrink: 1,
    flexNegative: 1,
    flexOrder: 1,
    gridRow: 1,
    gridRowEnd: 1,
    gridRowSpan: 1,
    gridRowStart: 1,
    gridColumn: 1,
    gridColumnEnd: 1,
    gridColumnSpan: 1,
    gridColumnStart: 1,
    msGridRow: 1,
    msGridRowSpan: 1,
    msGridColumn: 1,
    msGridColumnSpan: 1,
    fontWeight: 1,
    lineHeight: 1,
    opacity: 1,
    order: 1,
    orphans: 1,
    scale: 1,
    tabSize: 1,
    widows: 1,
    zIndex: 1,
    zoom: 1,
    WebkitLineClamp: 1,
    // SVG-related properties
    fillOpacity: 1,
    floodOpacity: 1,
    stopOpacity: 1,
    strokeDasharray: 1,
    strokeDashoffset: 1,
    strokeMiterlimit: 1,
    strokeOpacity: 1,
    strokeWidth: 1
};

});


parcelRegister("fPM9Q", function(module, exports) {

$parcel$export(module.exports, "useInsertionEffectAlwaysWithSyncFallback", function () { return $b870f99391901538$export$db21c7ffa21794e7; });
$parcel$export(module.exports, "useInsertionEffectWithLayoutFallback", function () { return $b870f99391901538$export$811a713a7276cb9d; });

var $gJYWc = parcelRequire("gJYWc");
var $b870f99391901538$var$isBrowser = typeof document !== 'undefined';
var $b870f99391901538$var$syncFallback = function syncFallback(create) {
    return create();
};
var $b870f99391901538$var$useInsertionEffect = $gJYWc.useInsertionEffect ? $gJYWc.useInsertionEffect : false;
var $b870f99391901538$export$db21c7ffa21794e7 = !$b870f99391901538$var$isBrowser ? $b870f99391901538$var$syncFallback : $b870f99391901538$var$useInsertionEffect || $b870f99391901538$var$syncFallback;
var $b870f99391901538$export$811a713a7276cb9d = $b870f99391901538$var$useInsertionEffect || $gJYWc.useLayoutEffect;

});



parcelRegister("f3Y7Z", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $af75c6f77edfe7ec$export$2e2bcd8739ae039; });

var $7VXY1 = parcelRequire("7VXY1");
// eslint-disable-next-line no-undef
var $af75c6f77edfe7ec$var$reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|disableRemotePlayback|download|draggable|encType|enterKeyHint|fetchpriority|fetchPriority|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/; // https://esbench.com/bench/5bfee68a4cd7e6009ef61d23
var $af75c6f77edfe7ec$export$2e2bcd8739ae039 = /* #__PURE__ */ (0, $7VXY1.default)(function(prop) {
    return $af75c6f77edfe7ec$var$reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111 && prop.charCodeAt(1) === 110 && prop.charCodeAt(2) < 91;
});

});



parcelRegister("2dJfV", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $19dfe68b90c92c0b$export$2e2bcd8739ae039; });
parcelRequire("gJYWc");


var $ll1Nc = parcelRequire("ll1Nc");

var $dAa5b = parcelRequire("dAa5b");

var $9wx12 = parcelRequire("9wx12");
'use client';
let $19dfe68b90c92c0b$var$cache;
if (typeof document === 'object') $19dfe68b90c92c0b$var$cache = (0, $dAa5b.default)({
    key: 'css',
    prepend: true
});
function $19dfe68b90c92c0b$export$2e2bcd8739ae039(props) {
    const { injectFirst: injectFirst, children: children } = props;
    return injectFirst && $19dfe68b90c92c0b$var$cache ? /*#__PURE__*/ (0, $9wx12.jsx)((0, $ll1Nc.C), {
        value: $19dfe68b90c92c0b$var$cache,
        children: children
    }) : children;
}

});
parcelRegister("9wx12", function(module, exports) {
'use strict';

module.exports = (parcelRequire("iaang"));

});


parcelRegister("TgYhg", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0a624d4ca449caf2$export$2e2bcd8739ae039; });
parcelRequire("gJYWc");


var $d0nrV = parcelRequire("d0nrV");

var $9wx12 = parcelRequire("9wx12");
'use client';
function $0a624d4ca449caf2$var$isEmpty(obj) {
    return obj === undefined || obj === null || Object.keys(obj).length === 0;
}
function $0a624d4ca449caf2$export$2e2bcd8739ae039(props) {
    const { styles: styles, defaultTheme: defaultTheme = {} } = props;
    const globalStyles = typeof styles === 'function' ? (themeInput)=>styles($0a624d4ca449caf2$var$isEmpty(themeInput) ? defaultTheme : themeInput) : styles;
    return /*#__PURE__*/ (0, $9wx12.jsx)((0, $d0nrV.Global), {
        styles: globalStyles
    });
}

});


parcelRegister("iJr6q", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return (parcelRequire("hdsnN")).default; });

var $hdsnN = parcelRequire("hdsnN");

});
parcelRegister("hdsnN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c889aaca23931d45$export$2e2bcd8739ae039; });

var $lqJfJ = parcelRequire("lqJfJ");
function $c889aaca23931d45$export$2e2bcd8739ae039(string) {
    if (typeof string !== 'string') throw new Error((0, $lqJfJ.default)(7));
    return string.charAt(0).toUpperCase() + string.slice(1);
}

});


parcelRegister("2fj9v", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return (parcelRequire("cTyf7")).default; });

var $cTyf7 = parcelRequire("cTyf7");
$parcel$exportWildcard(module.exports, $cTyf7);

});
parcelRegister("cTyf7", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "getFunctionName", function () { return $96352f0180397269$export$aad197c7121a6651; });
$parcel$export(module.exports, "default", function () { return $96352f0180397269$export$2e2bcd8739ae039; });

var $dXakg = parcelRequire("dXakg");
// Simplified polyfill for IE11 support
// https://github.com/JamesMGreene/Function.name/blob/58b314d4a983110c3682f1228f845d39ccca1817/Function.name.js#L3
const $96352f0180397269$var$fnNameMatchRegex = /^\s*function(?:\s|\s*\/\*.*\*\/\s*)+([^(\s/]*)\s*/;
function $96352f0180397269$export$aad197c7121a6651(fn) {
    const match = `${fn}`.match($96352f0180397269$var$fnNameMatchRegex);
    const name = match && match[1];
    return name || '';
}
function $96352f0180397269$var$getFunctionComponentName(Component, fallback = '') {
    return Component.displayName || Component.name || $96352f0180397269$export$aad197c7121a6651(Component) || fallback;
}
function $96352f0180397269$var$getWrappedName(outerType, innerType, wrapperName) {
    const functionName = $96352f0180397269$var$getFunctionComponentName(innerType);
    return outerType.displayName || (functionName !== '' ? `${wrapperName}(${functionName})` : wrapperName);
}
function $96352f0180397269$export$2e2bcd8739ae039(Component) {
    if (Component == null) return undefined;
    if (typeof Component === 'string') return Component;
    if (typeof Component === 'function') return $96352f0180397269$var$getFunctionComponentName(Component, 'Component');
    // TypeScript can't have components as objects but they exist in the form of `memo` or `Suspense`
    if (typeof Component === 'object') switch(Component.$$typeof){
        case 0, $dXakg.ForwardRef:
            return $96352f0180397269$var$getWrappedName(Component, Component.render, 'ForwardRef');
        case 0, $dXakg.Memo:
            return $96352f0180397269$var$getWrappedName(Component, Component.type, 'memo');
        default:
            return undefined;
    }
    return undefined;
}

});
parcelRegister("dXakg", function(module, exports) {
'use strict';

module.exports = (parcelRequire("dVPdY"));

});
parcelRegister("dVPdY", function(module, exports) {

$parcel$export(module.exports, "ContextConsumer", function () { return $a24855557fe37940$export$a7c73072b1a182ae; }, function (v) { return $a24855557fe37940$export$a7c73072b1a182ae = v; });
$parcel$export(module.exports, "ContextProvider", function () { return $a24855557fe37940$export$9f27bc3417b4524d; }, function (v) { return $a24855557fe37940$export$9f27bc3417b4524d = v; });
$parcel$export(module.exports, "Element", function () { return $a24855557fe37940$export$db77ccec0bb4ccac; }, function (v) { return $a24855557fe37940$export$db77ccec0bb4ccac = v; });
$parcel$export(module.exports, "ForwardRef", function () { return $a24855557fe37940$export$8392c0c9d3dcbd35; }, function (v) { return $a24855557fe37940$export$8392c0c9d3dcbd35 = v; });
$parcel$export(module.exports, "Fragment", function () { return $a24855557fe37940$export$ffb0004e005737fa; }, function (v) { return $a24855557fe37940$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Lazy", function () { return $a24855557fe37940$export$b624eff549462981; }, function (v) { return $a24855557fe37940$export$b624eff549462981 = v; });
$parcel$export(module.exports, "Memo", function () { return $a24855557fe37940$export$7897aa7841a5380c; }, function (v) { return $a24855557fe37940$export$7897aa7841a5380c = v; });
$parcel$export(module.exports, "Portal", function () { return $a24855557fe37940$export$602eac185826482c; }, function (v) { return $a24855557fe37940$export$602eac185826482c = v; });
$parcel$export(module.exports, "Profiler", function () { return $a24855557fe37940$export$e2c29f18771995cb; }, function (v) { return $a24855557fe37940$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "StrictMode", function () { return $a24855557fe37940$export$5f8d39834fd61797; }, function (v) { return $a24855557fe37940$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $a24855557fe37940$export$74bf444e3cd11ea5; }, function (v) { return $a24855557fe37940$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "SuspenseList", function () { return $a24855557fe37940$export$998bcd577473dd93; }, function (v) { return $a24855557fe37940$export$998bcd577473dd93 = v; });
$parcel$export(module.exports, "isContextConsumer", function () { return $a24855557fe37940$export$b706b080d889d2c9; }, function (v) { return $a24855557fe37940$export$b706b080d889d2c9 = v; });
$parcel$export(module.exports, "isContextProvider", function () { return $a24855557fe37940$export$5be5a87408f70ddc; }, function (v) { return $a24855557fe37940$export$5be5a87408f70ddc = v; });
$parcel$export(module.exports, "isElement", function () { return $a24855557fe37940$export$45a5e7f76e0caa8d; }, function (v) { return $a24855557fe37940$export$45a5e7f76e0caa8d = v; });
$parcel$export(module.exports, "isForwardRef", function () { return $a24855557fe37940$export$455c2e768291efa6; }, function (v) { return $a24855557fe37940$export$455c2e768291efa6 = v; });
$parcel$export(module.exports, "isFragment", function () { return $a24855557fe37940$export$9522e17588c12572; }, function (v) { return $a24855557fe37940$export$9522e17588c12572 = v; });
$parcel$export(module.exports, "isLazy", function () { return $a24855557fe37940$export$2110ac352bb060b9; }, function (v) { return $a24855557fe37940$export$2110ac352bb060b9 = v; });
$parcel$export(module.exports, "isMemo", function () { return $a24855557fe37940$export$56885ab8b9c456ab; }, function (v) { return $a24855557fe37940$export$56885ab8b9c456ab = v; });
$parcel$export(module.exports, "isPortal", function () { return $a24855557fe37940$export$d927fcb6adf8f9de; }, function (v) { return $a24855557fe37940$export$d927fcb6adf8f9de = v; });
$parcel$export(module.exports, "isProfiler", function () { return $a24855557fe37940$export$b82d16f27459e05a; }, function (v) { return $a24855557fe37940$export$b82d16f27459e05a = v; });
$parcel$export(module.exports, "isStrictMode", function () { return $a24855557fe37940$export$522c17b4f5e123e8; }, function (v) { return $a24855557fe37940$export$522c17b4f5e123e8 = v; });
$parcel$export(module.exports, "isSuspense", function () { return $a24855557fe37940$export$1aabd8a0274ecfd6; }, function (v) { return $a24855557fe37940$export$1aabd8a0274ecfd6 = v; });
$parcel$export(module.exports, "isSuspenseList", function () { return $a24855557fe37940$export$3d6c20d97e46b957; }, function (v) { return $a24855557fe37940$export$3d6c20d97e46b957 = v; });
$parcel$export(module.exports, "isValidElementType", function () { return $a24855557fe37940$export$9b621391a187a31a; }, function (v) { return $a24855557fe37940$export$9b621391a187a31a = v; });
$parcel$export(module.exports, "typeOf", function () { return $a24855557fe37940$export$f5bbd400c2f4426f; }, function (v) { return $a24855557fe37940$export$f5bbd400c2f4426f = v; });
/**
 * @license React
 * react-is.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $a24855557fe37940$export$a7c73072b1a182ae;
var $a24855557fe37940$export$9f27bc3417b4524d;
var $a24855557fe37940$export$db77ccec0bb4ccac;
var $a24855557fe37940$export$8392c0c9d3dcbd35;
var $a24855557fe37940$export$ffb0004e005737fa;
var $a24855557fe37940$export$b624eff549462981;
var $a24855557fe37940$export$7897aa7841a5380c;
var $a24855557fe37940$export$602eac185826482c;
var $a24855557fe37940$export$e2c29f18771995cb;
var $a24855557fe37940$export$5f8d39834fd61797;
var $a24855557fe37940$export$74bf444e3cd11ea5;
var $a24855557fe37940$export$998bcd577473dd93;
var $a24855557fe37940$export$b706b080d889d2c9;
var $a24855557fe37940$export$5be5a87408f70ddc;
var $a24855557fe37940$export$45a5e7f76e0caa8d;
var $a24855557fe37940$export$455c2e768291efa6;
var $a24855557fe37940$export$9522e17588c12572;
var $a24855557fe37940$export$2110ac352bb060b9;
var $a24855557fe37940$export$56885ab8b9c456ab;
var $a24855557fe37940$export$d927fcb6adf8f9de;
var $a24855557fe37940$export$b82d16f27459e05a;
var $a24855557fe37940$export$522c17b4f5e123e8;
var $a24855557fe37940$export$1aabd8a0274ecfd6;
var $a24855557fe37940$export$3d6c20d97e46b957;
var $a24855557fe37940$export$9b621391a187a31a;
var $a24855557fe37940$export$f5bbd400c2f4426f;
"use strict";
var $a24855557fe37940$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $a24855557fe37940$var$REACT_PORTAL_TYPE = Symbol.for("react.portal"), $a24855557fe37940$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), $a24855557fe37940$var$REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), $a24855557fe37940$var$REACT_PROFILER_TYPE = Symbol.for("react.profiler");
Symbol.for("react.provider");
var $a24855557fe37940$var$REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), $a24855557fe37940$var$REACT_CONTEXT_TYPE = Symbol.for("react.context"), $a24855557fe37940$var$REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), $a24855557fe37940$var$REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), $a24855557fe37940$var$REACT_SUSPENSE_LIST_TYPE = Symbol.for("react.suspense_list"), $a24855557fe37940$var$REACT_MEMO_TYPE = Symbol.for("react.memo"), $a24855557fe37940$var$REACT_LAZY_TYPE = Symbol.for("react.lazy"), $a24855557fe37940$var$REACT_OFFSCREEN_TYPE = Symbol.for("react.offscreen"), $a24855557fe37940$var$REACT_CLIENT_REFERENCE = Symbol.for("react.client.reference");
function $a24855557fe37940$var$typeOf(object) {
    if ("object" === typeof object && null !== object) {
        var $$typeof = object.$$typeof;
        switch($$typeof){
            case $a24855557fe37940$var$REACT_ELEMENT_TYPE:
                switch(object = object.type, object){
                    case $a24855557fe37940$var$REACT_FRAGMENT_TYPE:
                    case $a24855557fe37940$var$REACT_PROFILER_TYPE:
                    case $a24855557fe37940$var$REACT_STRICT_MODE_TYPE:
                    case $a24855557fe37940$var$REACT_SUSPENSE_TYPE:
                    case $a24855557fe37940$var$REACT_SUSPENSE_LIST_TYPE:
                        return object;
                    default:
                        switch(object = object && object.$$typeof, object){
                            case $a24855557fe37940$var$REACT_CONTEXT_TYPE:
                            case $a24855557fe37940$var$REACT_FORWARD_REF_TYPE:
                            case $a24855557fe37940$var$REACT_LAZY_TYPE:
                            case $a24855557fe37940$var$REACT_MEMO_TYPE:
                                return object;
                            case $a24855557fe37940$var$REACT_CONSUMER_TYPE:
                                return object;
                            default:
                                return $$typeof;
                        }
                }
            case $a24855557fe37940$var$REACT_PORTAL_TYPE:
                return $$typeof;
        }
    }
}
$a24855557fe37940$export$a7c73072b1a182ae = $a24855557fe37940$var$REACT_CONSUMER_TYPE;
$a24855557fe37940$export$9f27bc3417b4524d = $a24855557fe37940$var$REACT_CONTEXT_TYPE;
$a24855557fe37940$export$db77ccec0bb4ccac = $a24855557fe37940$var$REACT_ELEMENT_TYPE;
$a24855557fe37940$export$8392c0c9d3dcbd35 = $a24855557fe37940$var$REACT_FORWARD_REF_TYPE;
$a24855557fe37940$export$ffb0004e005737fa = $a24855557fe37940$var$REACT_FRAGMENT_TYPE;
$a24855557fe37940$export$b624eff549462981 = $a24855557fe37940$var$REACT_LAZY_TYPE;
$a24855557fe37940$export$7897aa7841a5380c = $a24855557fe37940$var$REACT_MEMO_TYPE;
$a24855557fe37940$export$602eac185826482c = $a24855557fe37940$var$REACT_PORTAL_TYPE;
$a24855557fe37940$export$e2c29f18771995cb = $a24855557fe37940$var$REACT_PROFILER_TYPE;
$a24855557fe37940$export$5f8d39834fd61797 = $a24855557fe37940$var$REACT_STRICT_MODE_TYPE;
$a24855557fe37940$export$74bf444e3cd11ea5 = $a24855557fe37940$var$REACT_SUSPENSE_TYPE;
$a24855557fe37940$export$998bcd577473dd93 = $a24855557fe37940$var$REACT_SUSPENSE_LIST_TYPE;
$a24855557fe37940$export$b706b080d889d2c9 = function(object) {
    return $a24855557fe37940$var$typeOf(object) === $a24855557fe37940$var$REACT_CONSUMER_TYPE;
};
$a24855557fe37940$export$5be5a87408f70ddc = function(object) {
    return $a24855557fe37940$var$typeOf(object) === $a24855557fe37940$var$REACT_CONTEXT_TYPE;
};
$a24855557fe37940$export$45a5e7f76e0caa8d = function(object) {
    return "object" === typeof object && null !== object && object.$$typeof === $a24855557fe37940$var$REACT_ELEMENT_TYPE;
};
$a24855557fe37940$export$455c2e768291efa6 = function(object) {
    return $a24855557fe37940$var$typeOf(object) === $a24855557fe37940$var$REACT_FORWARD_REF_TYPE;
};
$a24855557fe37940$export$9522e17588c12572 = function(object) {
    return $a24855557fe37940$var$typeOf(object) === $a24855557fe37940$var$REACT_FRAGMENT_TYPE;
};
$a24855557fe37940$export$2110ac352bb060b9 = function(object) {
    return $a24855557fe37940$var$typeOf(object) === $a24855557fe37940$var$REACT_LAZY_TYPE;
};
$a24855557fe37940$export$56885ab8b9c456ab = function(object) {
    return $a24855557fe37940$var$typeOf(object) === $a24855557fe37940$var$REACT_MEMO_TYPE;
};
$a24855557fe37940$export$d927fcb6adf8f9de = function(object) {
    return $a24855557fe37940$var$typeOf(object) === $a24855557fe37940$var$REACT_PORTAL_TYPE;
};
$a24855557fe37940$export$b82d16f27459e05a = function(object) {
    return $a24855557fe37940$var$typeOf(object) === $a24855557fe37940$var$REACT_PROFILER_TYPE;
};
$a24855557fe37940$export$522c17b4f5e123e8 = function(object) {
    return $a24855557fe37940$var$typeOf(object) === $a24855557fe37940$var$REACT_STRICT_MODE_TYPE;
};
$a24855557fe37940$export$1aabd8a0274ecfd6 = function(object) {
    return $a24855557fe37940$var$typeOf(object) === $a24855557fe37940$var$REACT_SUSPENSE_TYPE;
};
$a24855557fe37940$export$3d6c20d97e46b957 = function(object) {
    return $a24855557fe37940$var$typeOf(object) === $a24855557fe37940$var$REACT_SUSPENSE_LIST_TYPE;
};
$a24855557fe37940$export$9b621391a187a31a = function(type) {
    return "string" === typeof type || "function" === typeof type || type === $a24855557fe37940$var$REACT_FRAGMENT_TYPE || type === $a24855557fe37940$var$REACT_PROFILER_TYPE || type === $a24855557fe37940$var$REACT_STRICT_MODE_TYPE || type === $a24855557fe37940$var$REACT_SUSPENSE_TYPE || type === $a24855557fe37940$var$REACT_SUSPENSE_LIST_TYPE || type === $a24855557fe37940$var$REACT_OFFSCREEN_TYPE || "object" === typeof type && null !== type && (type.$$typeof === $a24855557fe37940$var$REACT_LAZY_TYPE || type.$$typeof === $a24855557fe37940$var$REACT_MEMO_TYPE || type.$$typeof === $a24855557fe37940$var$REACT_CONTEXT_TYPE || type.$$typeof === $a24855557fe37940$var$REACT_CONSUMER_TYPE || type.$$typeof === $a24855557fe37940$var$REACT_FORWARD_REF_TYPE || type.$$typeof === $a24855557fe37940$var$REACT_CLIENT_REFERENCE || void 0 !== type.getModuleId) ? !0 : !1;
};
$a24855557fe37940$export$f5bbd400c2f4426f = $a24855557fe37940$var$typeOf;

});




parcelRegister("9TIAj", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return (parcelRequire("hvWfk")).default; });
$parcel$export(module.exports, "private_createBreakpoints", function () { return (parcelRequire("4Xtmw")).default; });
$parcel$export(module.exports, "unstable_applyStyles", function () { return (parcelRequire("hURNW")).default; });

var $hvWfk = parcelRequire("hvWfk");

var $4Xtmw = parcelRequire("4Xtmw");

var $hURNW = parcelRequire("hURNW");

});
parcelRegister("hvWfk", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cc0283635a31ecc6$export$2e2bcd8739ae039; });

var $3VnFq = parcelRequire("3VnFq");

var $cTAWX = parcelRequire("cTAWX");

var $dvHXN = parcelRequire("dvHXN");

var $4Xtmw = parcelRequire("4Xtmw");

var $2salh = parcelRequire("2salh");

var $tCKxg = parcelRequire("tCKxg");

var $k1l9i = parcelRequire("k1l9i");

var $gVCQf = parcelRequire("gVCQf");

var $hURNW = parcelRequire("hURNW");
const $cc0283635a31ecc6$var$_excluded = [
    "breakpoints",
    "palette",
    "spacing",
    "shape"
];
function $cc0283635a31ecc6$var$createTheme(options = {}, ...args) {
    const { breakpoints: breakpointsInput = {}, palette: paletteInput = {}, spacing: spacingInput, shape: shapeInput = {} } = options, other = (0, $cTAWX.default)(options, $cc0283635a31ecc6$var$_excluded);
    const breakpoints = (0, $4Xtmw.default)(breakpointsInput);
    const spacing = (0, $tCKxg.default)(spacingInput);
    let muiTheme = (0, $dvHXN.default)({
        breakpoints: breakpoints,
        direction: 'ltr',
        components: {},
        // Inject component definitions.
        palette: (0, $3VnFq.default)({
            mode: 'light'
        }, paletteInput),
        spacing: spacing,
        shape: (0, $3VnFq.default)({}, (0, $2salh.default), shapeInput)
    }, other);
    muiTheme.applyStyles = (0, $hURNW.default);
    muiTheme = args.reduce((acc, argument)=>(0, $dvHXN.default)(acc, argument), muiTheme);
    muiTheme.unstable_sxConfig = (0, $3VnFq.default)({}, (0, $gVCQf.default), other == null ? void 0 : other.unstable_sxConfig);
    muiTheme.unstable_sx = function sx(props) {
        return (0, $k1l9i.default)({
            sx: props,
            theme: this
        });
    };
    return muiTheme;
}
var $cc0283635a31ecc6$export$2e2bcd8739ae039 = $cc0283635a31ecc6$var$createTheme;

});
parcelRegister("cTAWX", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $96374895e7e2a60d$export$2e2bcd8739ae039; });
function $96374895e7e2a60d$export$2e2bcd8739ae039(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}

});

parcelRegister("dvHXN", function(module, exports) {

$parcel$export(module.exports, "isPlainObject", function () { return $9d6045d066ceae17$export$53b83ca8eaab0383; });
$parcel$export(module.exports, "default", function () { return $9d6045d066ceae17$export$2e2bcd8739ae039; });

var $3VnFq = parcelRequire("3VnFq");

var $gJYWc = parcelRequire("gJYWc");
function $9d6045d066ceae17$export$53b83ca8eaab0383(item) {
    if (typeof item !== 'object' || item === null) return false;
    const prototype = Object.getPrototypeOf(item);
    return (prototype === null || prototype === Object.prototype || Object.getPrototypeOf(prototype) === null) && !(Symbol.toStringTag in item) && !(Symbol.iterator in item);
}
function $9d6045d066ceae17$var$deepClone(source) {
    if (/*#__PURE__*/ $gJYWc.isValidElement(source) || !$9d6045d066ceae17$export$53b83ca8eaab0383(source)) return source;
    const output = {};
    Object.keys(source).forEach((key)=>{
        output[key] = $9d6045d066ceae17$var$deepClone(source[key]);
    });
    return output;
}
function $9d6045d066ceae17$export$2e2bcd8739ae039(target, source, options = {
    clone: true
}) {
    const output = options.clone ? (0, $3VnFq.default)({}, target) : target;
    if ($9d6045d066ceae17$export$53b83ca8eaab0383(target) && $9d6045d066ceae17$export$53b83ca8eaab0383(source)) Object.keys(source).forEach((key)=>{
        if (/*#__PURE__*/ $gJYWc.isValidElement(source[key])) output[key] = source[key];
        else if ($9d6045d066ceae17$export$53b83ca8eaab0383(source[key]) && // Avoid prototype pollution
        Object.prototype.hasOwnProperty.call(target, key) && $9d6045d066ceae17$export$53b83ca8eaab0383(target[key])) // Since `output` is a clone of `target` and we have narrowed `target` in this block we can cast to the same type.
        output[key] = $9d6045d066ceae17$export$2e2bcd8739ae039(target[key], source[key], options);
        else if (options.clone) output[key] = $9d6045d066ceae17$export$53b83ca8eaab0383(source[key]) ? $9d6045d066ceae17$var$deepClone(source[key]) : source[key];
        else output[key] = source[key];
    });
    return output;
}

});

parcelRegister("4Xtmw", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $39c372d2990aa75f$export$2e2bcd8739ae039; });

var $cTAWX = parcelRequire("cTAWX");

var $3VnFq = parcelRequire("3VnFq");
const $39c372d2990aa75f$var$_excluded = [
    "values",
    "unit",
    "step"
];
const $39c372d2990aa75f$export$ebf128a87553cecf = [
    'xs',
    'sm',
    'md',
    'lg',
    'xl'
];
const $39c372d2990aa75f$var$sortBreakpointsValues = (values)=>{
    const breakpointsAsArray = Object.keys(values).map((key)=>({
            key: key,
            val: values[key]
        })) || [];
    // Sort in ascending order
    breakpointsAsArray.sort((breakpoint1, breakpoint2)=>breakpoint1.val - breakpoint2.val);
    return breakpointsAsArray.reduce((acc, obj)=>{
        return (0, $3VnFq.default)({}, acc, {
            [obj.key]: obj.val
        });
    }, {});
};
function $39c372d2990aa75f$export$2e2bcd8739ae039(breakpoints) {
    const { values: // The breakpoint **start** at this value.
    // For instance with the first breakpoint xs: [xs, sm).
    values = {
        xs: 0,
        // phone
        sm: 600,
        // tablet
        md: 900,
        // small laptop
        lg: 1200,
        // desktop
        xl: 1536 // large screen
    }, unit: unit = 'px', step: step = 5 } = breakpoints, other = (0, $cTAWX.default)(breakpoints, $39c372d2990aa75f$var$_excluded);
    const sortedValues = $39c372d2990aa75f$var$sortBreakpointsValues(values);
    const keys = Object.keys(sortedValues);
    function up(key) {
        const value = typeof values[key] === 'number' ? values[key] : key;
        return `@media (min-width:${value}${unit})`;
    }
    function down(key) {
        const value = typeof values[key] === 'number' ? values[key] : key;
        return `@media (max-width:${value - step / 100}${unit})`;
    }
    function between(start, end) {
        const endIndex = keys.indexOf(end);
        return `@media (min-width:${typeof values[start] === 'number' ? values[start] : start}${unit}) and ` + `(max-width:${(endIndex !== -1 && typeof values[keys[endIndex]] === 'number' ? values[keys[endIndex]] : end) - step / 100}${unit})`;
    }
    function only(key) {
        if (keys.indexOf(key) + 1 < keys.length) return between(key, keys[keys.indexOf(key) + 1]);
        return up(key);
    }
    function not(key) {
        // handle first and last key separately, for better readability
        const keyIndex = keys.indexOf(key);
        if (keyIndex === 0) return up(keys[1]);
        if (keyIndex === keys.length - 1) return down(keys[keyIndex]);
        return between(key, keys[keys.indexOf(key) + 1]).replace('@media', '@media not all and');
    }
    return (0, $3VnFq.default)({
        keys: keys,
        values: sortedValues,
        up: up,
        down: down,
        between: between,
        only: only,
        not: not,
        unit: unit
    }, other);
}

});

parcelRegister("2salh", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1c96380b5f8025b8$export$2e2bcd8739ae039; });
const $1c96380b5f8025b8$var$shape = {
    borderRadius: 4
};
var $1c96380b5f8025b8$export$2e2bcd8739ae039 = $1c96380b5f8025b8$var$shape;

});

parcelRegister("tCKxg", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0590c467e92ec58d$export$2e2bcd8739ae039; });

var $9xkBg = parcelRequire("9xkBg");
function $0590c467e92ec58d$export$2e2bcd8739ae039(spacingInput = 8) {
    // Already transformed.
    if (spacingInput.mui) return spacingInput;
    // Material Design layouts are visually balanced. Most measurements align to an 8dp grid, which aligns both spacing and the overall layout.
    // Smaller components, such as icons, can align to a 4dp grid.
    // https://m2.material.io/design/layout/understanding-layout.html
    const transform = (0, $9xkBg.createUnarySpacing)({
        spacing: spacingInput
    });
    const spacing = (...argsInput)=>{
        const args = argsInput.length === 0 ? [
            1
        ] : argsInput;
        return args.map((argument)=>{
            const output = transform(argument);
            return typeof output === 'number' ? `${output}px` : output;
        }).join(' ');
    };
    spacing.mui = true;
    return spacing;
}

});
parcelRegister("9xkBg", function(module, exports) {

$parcel$export(module.exports, "createUnaryUnit", function () { return $6f172ce2ac35c2f7$export$cb5ee237cce814a2; });
$parcel$export(module.exports, "createUnarySpacing", function () { return $6f172ce2ac35c2f7$export$1def6f833384e3d1; });
$parcel$export(module.exports, "getValue", function () { return $6f172ce2ac35c2f7$export$bf7199a9ebcb84a9; });
$parcel$export(module.exports, "margin", function () { return $6f172ce2ac35c2f7$export$7ede87f9b603dd3c; });
$parcel$export(module.exports, "padding", function () { return $6f172ce2ac35c2f7$export$6f98e8eaf0be1996; });


var $dEfmb = parcelRequire("dEfmb");

var $cx2bP = parcelRequire("cx2bP");

var $2zVBC = parcelRequire("2zVBC");

var $lMrl0 = parcelRequire("lMrl0");
const $6f172ce2ac35c2f7$var$properties = {
    m: 'margin',
    p: 'padding'
};
const $6f172ce2ac35c2f7$var$directions = {
    t: 'Top',
    r: 'Right',
    b: 'Bottom',
    l: 'Left',
    x: [
        'Left',
        'Right'
    ],
    y: [
        'Top',
        'Bottom'
    ]
};
const $6f172ce2ac35c2f7$var$aliases = {
    marginX: 'mx',
    marginY: 'my',
    paddingX: 'px',
    paddingY: 'py'
};
// memoize() impact:
// From 300,000 ops/sec
// To 350,000 ops/sec
const $6f172ce2ac35c2f7$var$getCssProperties = (0, $lMrl0.default)((prop)=>{
    // It's not a shorthand notation.
    if (prop.length > 2) {
        if ($6f172ce2ac35c2f7$var$aliases[prop]) prop = $6f172ce2ac35c2f7$var$aliases[prop];
        else return [
            prop
        ];
    }
    const [a, b] = prop.split('');
    const property = $6f172ce2ac35c2f7$var$properties[a];
    const direction = $6f172ce2ac35c2f7$var$directions[b] || '';
    return Array.isArray(direction) ? direction.map((dir)=>property + dir) : [
        property + direction
    ];
});
const $6f172ce2ac35c2f7$export$aab52a0dde05ad8a = [
    'm',
    'mt',
    'mr',
    'mb',
    'ml',
    'mx',
    'my',
    'margin',
    'marginTop',
    'marginRight',
    'marginBottom',
    'marginLeft',
    'marginX',
    'marginY',
    'marginInline',
    'marginInlineStart',
    'marginInlineEnd',
    'marginBlock',
    'marginBlockStart',
    'marginBlockEnd'
];
const $6f172ce2ac35c2f7$export$f8397d44f03ab6ad = [
    'p',
    'pt',
    'pr',
    'pb',
    'pl',
    'px',
    'py',
    'padding',
    'paddingTop',
    'paddingRight',
    'paddingBottom',
    'paddingLeft',
    'paddingX',
    'paddingY',
    'paddingInline',
    'paddingInlineStart',
    'paddingInlineEnd',
    'paddingBlock',
    'paddingBlockStart',
    'paddingBlockEnd'
];
const $6f172ce2ac35c2f7$var$spacingKeys = [
    ...$6f172ce2ac35c2f7$export$aab52a0dde05ad8a,
    ...$6f172ce2ac35c2f7$export$f8397d44f03ab6ad
];
function $6f172ce2ac35c2f7$export$cb5ee237cce814a2(theme, themeKey, defaultValue, propName) {
    var _getPath;
    const themeSpacing = (_getPath = (0, $cx2bP.getPath)(theme, themeKey, false)) != null ? _getPath : defaultValue;
    if (typeof themeSpacing === 'number') return (abs)=>{
        if (typeof abs === 'string') return abs;
        return themeSpacing * abs;
    };
    if (Array.isArray(themeSpacing)) return (abs)=>{
        if (typeof abs === 'string') return abs;
        return themeSpacing[abs];
    };
    if (typeof themeSpacing === 'function') return themeSpacing;
    return ()=>undefined;
}
function $6f172ce2ac35c2f7$export$1def6f833384e3d1(theme) {
    return $6f172ce2ac35c2f7$export$cb5ee237cce814a2(theme, 'spacing', 8, 'spacing');
}
function $6f172ce2ac35c2f7$export$bf7199a9ebcb84a9(transformer, propValue) {
    if (typeof propValue === 'string' || propValue == null) return propValue;
    const abs = Math.abs(propValue);
    const transformed = transformer(abs);
    if (propValue >= 0) return transformed;
    if (typeof transformed === 'number') return -transformed;
    return `-${transformed}`;
}
function $6f172ce2ac35c2f7$export$1dc0036b298ea8d1(cssProperties, transformer) {
    return (propValue)=>cssProperties.reduce((acc, cssProperty)=>{
            acc[cssProperty] = $6f172ce2ac35c2f7$export$bf7199a9ebcb84a9(transformer, propValue);
            return acc;
        }, {});
}
function $6f172ce2ac35c2f7$var$resolveCssProperty(props, keys, prop, transformer) {
    // Using a hash computation over an array iteration could be faster, but with only 28 items,
    // it's doesn't worth the bundle size.
    if (keys.indexOf(prop) === -1) return null;
    const cssProperties = $6f172ce2ac35c2f7$var$getCssProperties(prop);
    const styleFromPropValue = $6f172ce2ac35c2f7$export$1dc0036b298ea8d1(cssProperties, transformer);
    const propValue = props[prop];
    return (0, $dEfmb.handleBreakpoints)(props, propValue, styleFromPropValue);
}
function $6f172ce2ac35c2f7$var$style(props, keys) {
    const transformer = $6f172ce2ac35c2f7$export$1def6f833384e3d1(props.theme);
    return Object.keys(props).map((prop)=>$6f172ce2ac35c2f7$var$resolveCssProperty(props, keys, prop, transformer)).reduce((0, $2zVBC.default), {});
}
function $6f172ce2ac35c2f7$export$7ede87f9b603dd3c(props) {
    return $6f172ce2ac35c2f7$var$style(props, $6f172ce2ac35c2f7$export$aab52a0dde05ad8a);
}
$6f172ce2ac35c2f7$export$7ede87f9b603dd3c.propTypes = {};
$6f172ce2ac35c2f7$export$7ede87f9b603dd3c.filterProps = $6f172ce2ac35c2f7$export$aab52a0dde05ad8a;
function $6f172ce2ac35c2f7$export$6f98e8eaf0be1996(props) {
    return $6f172ce2ac35c2f7$var$style(props, $6f172ce2ac35c2f7$export$f8397d44f03ab6ad);
}
$6f172ce2ac35c2f7$export$6f98e8eaf0be1996.propTypes = {};
$6f172ce2ac35c2f7$export$6f98e8eaf0be1996.filterProps = $6f172ce2ac35c2f7$export$f8397d44f03ab6ad;
function $6f172ce2ac35c2f7$var$spacing(props) {
    return $6f172ce2ac35c2f7$var$style(props, $6f172ce2ac35c2f7$var$spacingKeys);
}
$6f172ce2ac35c2f7$var$spacing.propTypes = {};
$6f172ce2ac35c2f7$var$spacing.filterProps = $6f172ce2ac35c2f7$var$spacingKeys;
var $6f172ce2ac35c2f7$export$2e2bcd8739ae039 = $6f172ce2ac35c2f7$var$spacing;

});
parcelRegister("dEfmb", function(module, exports) {

$parcel$export(module.exports, "values", function () { return $9efaec54a912b59c$export$68c286be0e7e55b7; });
$parcel$export(module.exports, "handleBreakpoints", function () { return $9efaec54a912b59c$export$88347efdb2e19abd; });
$parcel$export(module.exports, "createEmptyBreakpointObject", function () { return $9efaec54a912b59c$export$1f2600516e91381f; });
$parcel$export(module.exports, "removeUnusedBreakpoints", function () { return $9efaec54a912b59c$export$8922c90b6e020726; });
$parcel$export(module.exports, "mergeBreakpointsInOrder", function () { return $9efaec54a912b59c$export$b89a003a1e05c0ee; });
$parcel$export(module.exports, "resolveBreakpointValues", function () { return $9efaec54a912b59c$export$980e6a259d807490; });

var $3VnFq = parcelRequire("3VnFq");


var $dvHXN = parcelRequire("dvHXN");

var $2zVBC = parcelRequire("2zVBC");
const $9efaec54a912b59c$export$68c286be0e7e55b7 = {
    xs: 0,
    // phone
    sm: 600,
    // tablet
    md: 900,
    // small laptop
    lg: 1200,
    // desktop
    xl: 1536 // large screen
};
const $9efaec54a912b59c$var$defaultBreakpoints = {
    // Sorted ASC by size. That's important.
    // It can't be configured as it's used statically for propTypes.
    keys: [
        'xs',
        'sm',
        'md',
        'lg',
        'xl'
    ],
    up: (key)=>`@media (min-width:${$9efaec54a912b59c$export$68c286be0e7e55b7[key]}px)`
};
function $9efaec54a912b59c$export$88347efdb2e19abd(props, propValue, styleFromPropValue) {
    const theme = props.theme || {};
    if (Array.isArray(propValue)) {
        const themeBreakpoints = theme.breakpoints || $9efaec54a912b59c$var$defaultBreakpoints;
        return propValue.reduce((acc, item, index)=>{
            acc[themeBreakpoints.up(themeBreakpoints.keys[index])] = styleFromPropValue(propValue[index]);
            return acc;
        }, {});
    }
    if (typeof propValue === 'object') {
        const themeBreakpoints = theme.breakpoints || $9efaec54a912b59c$var$defaultBreakpoints;
        return Object.keys(propValue).reduce((acc, breakpoint)=>{
            // key is breakpoint
            if (Object.keys(themeBreakpoints.values || $9efaec54a912b59c$export$68c286be0e7e55b7).indexOf(breakpoint) !== -1) {
                const mediaKey = themeBreakpoints.up(breakpoint);
                acc[mediaKey] = styleFromPropValue(propValue[breakpoint], breakpoint);
            } else {
                const cssKey = breakpoint;
                acc[cssKey] = propValue[cssKey];
            }
            return acc;
        }, {});
    }
    const output = styleFromPropValue(propValue);
    return output;
}
function $9efaec54a912b59c$var$breakpoints(styleFunction) {
    // false positive
    // eslint-disable-next-line react/function-component-definition
    const newStyleFunction = (props)=>{
        const theme = props.theme || {};
        const base = styleFunction(props);
        const themeBreakpoints = theme.breakpoints || $9efaec54a912b59c$var$defaultBreakpoints;
        const extended = themeBreakpoints.keys.reduce((acc, key)=>{
            if (props[key]) {
                acc = acc || {};
                acc[themeBreakpoints.up(key)] = styleFunction((0, $3VnFq.default)({
                    theme: theme
                }, props[key]));
            }
            return acc;
        }, null);
        return (0, $2zVBC.default)(base, extended);
    };
    newStyleFunction.propTypes = {};
    newStyleFunction.filterProps = [
        'xs',
        'sm',
        'md',
        'lg',
        'xl',
        ...styleFunction.filterProps
    ];
    return newStyleFunction;
}
function $9efaec54a912b59c$export$1f2600516e91381f(breakpointsInput = {}) {
    var _breakpointsInput$key;
    const breakpointsInOrder = (_breakpointsInput$key = breakpointsInput.keys) == null ? void 0 : _breakpointsInput$key.reduce((acc, key)=>{
        const breakpointStyleKey = breakpointsInput.up(key);
        acc[breakpointStyleKey] = {};
        return acc;
    }, {});
    return breakpointsInOrder || {};
}
function $9efaec54a912b59c$export$8922c90b6e020726(breakpointKeys, style) {
    return breakpointKeys.reduce((acc, key)=>{
        const breakpointOutput = acc[key];
        const isBreakpointUnused = !breakpointOutput || Object.keys(breakpointOutput).length === 0;
        if (isBreakpointUnused) delete acc[key];
        return acc;
    }, style);
}
function $9efaec54a912b59c$export$b89a003a1e05c0ee(breakpointsInput, ...styles) {
    const emptyBreakpoints = $9efaec54a912b59c$export$1f2600516e91381f(breakpointsInput);
    const mergedOutput = [
        emptyBreakpoints,
        ...styles
    ].reduce((prev, next)=>(0, $dvHXN.default)(prev, next), {});
    return $9efaec54a912b59c$export$8922c90b6e020726(Object.keys(emptyBreakpoints), mergedOutput);
}
function $9efaec54a912b59c$export$ead4e80eca2ebb85(breakpointValues, themeBreakpoints) {
    // fixed value
    if (typeof breakpointValues !== 'object') return {};
    const base = {};
    const breakpointsKeys = Object.keys(themeBreakpoints);
    if (Array.isArray(breakpointValues)) breakpointsKeys.forEach((breakpoint, i)=>{
        if (i < breakpointValues.length) base[breakpoint] = true;
    });
    else breakpointsKeys.forEach((breakpoint)=>{
        if (breakpointValues[breakpoint] != null) base[breakpoint] = true;
    });
    return base;
}
function $9efaec54a912b59c$export$980e6a259d807490({ values: breakpointValues, breakpoints: themeBreakpoints, base: customBase }) {
    const base = customBase || $9efaec54a912b59c$export$ead4e80eca2ebb85(breakpointValues, themeBreakpoints);
    const keys = Object.keys(base);
    if (keys.length === 0) return breakpointValues;
    let previous;
    return keys.reduce((acc, breakpoint, i)=>{
        if (Array.isArray(breakpointValues)) {
            acc[breakpoint] = breakpointValues[i] != null ? breakpointValues[i] : breakpointValues[previous];
            previous = i;
        } else if (typeof breakpointValues === 'object') {
            acc[breakpoint] = breakpointValues[breakpoint] != null ? breakpointValues[breakpoint] : breakpointValues[previous];
            previous = breakpoint;
        } else acc[breakpoint] = breakpointValues;
        return acc;
    }, {});
}
var $9efaec54a912b59c$export$2e2bcd8739ae039 = $9efaec54a912b59c$var$breakpoints;

});
parcelRegister("2zVBC", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1e0b88fa21eae0ff$export$2e2bcd8739ae039; });

var $dvHXN = parcelRequire("dvHXN");
function $1e0b88fa21eae0ff$var$merge(acc, item) {
    if (!item) return acc;
    return (0, $dvHXN.default)(acc, item, {
        clone: false // No need to clone deep, it's way faster.
    });
}
var $1e0b88fa21eae0ff$export$2e2bcd8739ae039 = $1e0b88fa21eae0ff$var$merge;

});


parcelRegister("cx2bP", function(module, exports) {

$parcel$export(module.exports, "getPath", function () { return $91fa43ed621cc9e3$export$2aa3fd96c49a84a8; });
$parcel$export(module.exports, "getStyleValue", function () { return $91fa43ed621cc9e3$export$741ad47189a64aa0; });
$parcel$export(module.exports, "default", function () { return $91fa43ed621cc9e3$export$2e2bcd8739ae039; });

var $hdsnN = parcelRequire("hdsnN");


var $dEfmb = parcelRequire("dEfmb");
function $91fa43ed621cc9e3$export$2aa3fd96c49a84a8(obj, path, checkVars = true) {
    if (!path || typeof path !== 'string') return null;
    // Check if CSS variables are used
    if (obj && obj.vars && checkVars) {
        const val = `vars.${path}`.split('.').reduce((acc, item)=>acc && acc[item] ? acc[item] : null, obj);
        if (val != null) return val;
    }
    return path.split('.').reduce((acc, item)=>{
        if (acc && acc[item] != null) return acc[item];
        return null;
    }, obj);
}
function $91fa43ed621cc9e3$export$741ad47189a64aa0(themeMapping, transform, propValueFinal, userValue = propValueFinal) {
    let value;
    if (typeof themeMapping === 'function') value = themeMapping(propValueFinal);
    else if (Array.isArray(themeMapping)) value = themeMapping[propValueFinal] || userValue;
    else value = $91fa43ed621cc9e3$export$2aa3fd96c49a84a8(themeMapping, propValueFinal) || userValue;
    if (transform) value = transform(value, userValue, themeMapping);
    return value;
}
function $91fa43ed621cc9e3$var$style(options) {
    const { prop: prop, cssProperty: cssProperty = options.prop, themeKey: themeKey, transform: transform } = options;
    // false positive
    // eslint-disable-next-line react/function-component-definition
    const fn = (props)=>{
        if (props[prop] == null) return null;
        const propValue = props[prop];
        const theme = props.theme;
        const themeMapping = $91fa43ed621cc9e3$export$2aa3fd96c49a84a8(theme, themeKey) || {};
        const styleFromPropValue = (propValueFinal)=>{
            let value = $91fa43ed621cc9e3$export$741ad47189a64aa0(themeMapping, transform, propValueFinal);
            if (propValueFinal === value && typeof propValueFinal === 'string') // Haven't found value
            value = $91fa43ed621cc9e3$export$741ad47189a64aa0(themeMapping, transform, `${prop}${propValueFinal === 'default' ? '' : (0, $hdsnN.default)(propValueFinal)}`, propValueFinal);
            if (cssProperty === false) return value;
            return {
                [cssProperty]: value
            };
        };
        return (0, $dEfmb.handleBreakpoints)(props, propValue, styleFromPropValue);
    };
    fn.propTypes = {};
    fn.filterProps = [
        prop
    ];
    return fn;
}
var $91fa43ed621cc9e3$export$2e2bcd8739ae039 = $91fa43ed621cc9e3$var$style;

});

parcelRegister("lMrl0", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fdb3495e7e25dfee$export$2e2bcd8739ae039; });
function $fdb3495e7e25dfee$export$2e2bcd8739ae039(fn) {
    const cache = {};
    return (arg)=>{
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}

});



parcelRegister("k1l9i", function(module, exports) {

$parcel$export(module.exports, "unstable_createStyleFunctionSx", function () { return $e9344e6512230164$export$7d53d8bf2911e013; });
$parcel$export(module.exports, "default", function () { return $e9344e6512230164$export$2e2bcd8739ae039; });

var $hdsnN = parcelRequire("hdsnN");

var $2zVBC = parcelRequire("2zVBC");

var $cx2bP = parcelRequire("cx2bP");

var $dEfmb = parcelRequire("dEfmb");

var $gVCQf = parcelRequire("gVCQf");
function $e9344e6512230164$var$objectsHaveSameKeys(...objects) {
    const allKeys = objects.reduce((keys, object)=>keys.concat(Object.keys(object)), []);
    const union = new Set(allKeys);
    return objects.every((object)=>union.size === Object.keys(object).length);
}
function $e9344e6512230164$var$callIfFn(maybeFn, arg) {
    return typeof maybeFn === 'function' ? maybeFn(arg) : maybeFn;
}
function $e9344e6512230164$export$7d53d8bf2911e013() {
    function getThemeValue(prop, val, theme, config) {
        const props = {
            [prop]: val,
            theme: theme
        };
        const options = config[prop];
        if (!options) return {
            [prop]: val
        };
        const { cssProperty: cssProperty = prop, themeKey: themeKey, transform: transform, style: style } = options;
        if (val == null) return null;
        // TODO v6: remove, see https://github.com/mui/material-ui/pull/38123
        if (themeKey === 'typography' && val === 'inherit') return {
            [prop]: val
        };
        const themeMapping = (0, $cx2bP.getPath)(theme, themeKey) || {};
        if (style) return style(props);
        const styleFromPropValue = (propValueFinal)=>{
            let value = (0, $cx2bP.getStyleValue)(themeMapping, transform, propValueFinal);
            if (propValueFinal === value && typeof propValueFinal === 'string') // Haven't found value
            value = (0, $cx2bP.getStyleValue)(themeMapping, transform, `${prop}${propValueFinal === 'default' ? '' : (0, $hdsnN.default)(propValueFinal)}`, propValueFinal);
            if (cssProperty === false) return value;
            return {
                [cssProperty]: value
            };
        };
        return (0, $dEfmb.handleBreakpoints)(props, val, styleFromPropValue);
    }
    function styleFunctionSx(props) {
        var _theme$unstable_sxCon;
        const { sx: sx, theme: theme = {} } = props || {};
        if (!sx) return null; // Emotion & styled-components will neglect null
        const config = (_theme$unstable_sxCon = theme.unstable_sxConfig) != null ? _theme$unstable_sxCon : (0, $gVCQf.default);
        /*
     * Receive `sxInput` as object or callback
     * and then recursively check keys & values to create media query object styles.
     * (the result will be used in `styled`)
     */ function traverse(sxInput) {
            let sxObject = sxInput;
            if (typeof sxInput === 'function') sxObject = sxInput(theme);
            else if (typeof sxInput !== 'object') // value
            return sxInput;
            if (!sxObject) return null;
            const emptyBreakpoints = (0, $dEfmb.createEmptyBreakpointObject)(theme.breakpoints);
            const breakpointsKeys = Object.keys(emptyBreakpoints);
            let css = emptyBreakpoints;
            Object.keys(sxObject).forEach((styleKey)=>{
                const value = $e9344e6512230164$var$callIfFn(sxObject[styleKey], theme);
                if (value !== null && value !== undefined) {
                    if (typeof value === 'object') {
                        if (config[styleKey]) css = (0, $2zVBC.default)(css, getThemeValue(styleKey, value, theme, config));
                        else {
                            const breakpointsValues = (0, $dEfmb.handleBreakpoints)({
                                theme: theme
                            }, value, (x)=>({
                                    [styleKey]: x
                                }));
                            if ($e9344e6512230164$var$objectsHaveSameKeys(breakpointsValues, value)) css[styleKey] = styleFunctionSx({
                                sx: value,
                                theme: theme
                            });
                            else css = (0, $2zVBC.default)(css, breakpointsValues);
                        }
                    } else css = (0, $2zVBC.default)(css, getThemeValue(styleKey, value, theme, config));
                }
            });
            return (0, $dEfmb.removeUnusedBreakpoints)(breakpointsKeys, css);
        }
        return Array.isArray(sx) ? sx.map(traverse) : traverse(sx);
    }
    return styleFunctionSx;
}
const $e9344e6512230164$var$styleFunctionSx = $e9344e6512230164$export$7d53d8bf2911e013();
$e9344e6512230164$var$styleFunctionSx.filterProps = [
    'sx'
];
var $e9344e6512230164$export$2e2bcd8739ae039 = $e9344e6512230164$var$styleFunctionSx;

});
parcelRegister("gVCQf", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c53019574a4ed6a9$export$2e2bcd8739ae039; });

var $9xkBg = parcelRequire("9xkBg");

var $fJG7S = parcelRequire("fJG7S");

var $4cVAM = parcelRequire("4cVAM");

var $74IQt = parcelRequire("74IQt");

var $lFRup = parcelRequire("lFRup");
const $c53019574a4ed6a9$var$defaultSxConfig = {
    // borders
    border: {
        themeKey: 'borders',
        transform: (0, $fJG7S.borderTransform)
    },
    borderTop: {
        themeKey: 'borders',
        transform: (0, $fJG7S.borderTransform)
    },
    borderRight: {
        themeKey: 'borders',
        transform: (0, $fJG7S.borderTransform)
    },
    borderBottom: {
        themeKey: 'borders',
        transform: (0, $fJG7S.borderTransform)
    },
    borderLeft: {
        themeKey: 'borders',
        transform: (0, $fJG7S.borderTransform)
    },
    borderColor: {
        themeKey: 'palette'
    },
    borderTopColor: {
        themeKey: 'palette'
    },
    borderRightColor: {
        themeKey: 'palette'
    },
    borderBottomColor: {
        themeKey: 'palette'
    },
    borderLeftColor: {
        themeKey: 'palette'
    },
    outline: {
        themeKey: 'borders',
        transform: (0, $fJG7S.borderTransform)
    },
    outlineColor: {
        themeKey: 'palette'
    },
    borderRadius: {
        themeKey: 'shape.borderRadius',
        style: (0, $fJG7S.borderRadius)
    },
    // palette
    color: {
        themeKey: 'palette',
        transform: (0, $74IQt.paletteTransform)
    },
    bgcolor: {
        themeKey: 'palette',
        cssProperty: 'backgroundColor',
        transform: (0, $74IQt.paletteTransform)
    },
    backgroundColor: {
        themeKey: 'palette',
        transform: (0, $74IQt.paletteTransform)
    },
    // spacing
    p: {
        style: (0, $9xkBg.padding)
    },
    pt: {
        style: (0, $9xkBg.padding)
    },
    pr: {
        style: (0, $9xkBg.padding)
    },
    pb: {
        style: (0, $9xkBg.padding)
    },
    pl: {
        style: (0, $9xkBg.padding)
    },
    px: {
        style: (0, $9xkBg.padding)
    },
    py: {
        style: (0, $9xkBg.padding)
    },
    padding: {
        style: (0, $9xkBg.padding)
    },
    paddingTop: {
        style: (0, $9xkBg.padding)
    },
    paddingRight: {
        style: (0, $9xkBg.padding)
    },
    paddingBottom: {
        style: (0, $9xkBg.padding)
    },
    paddingLeft: {
        style: (0, $9xkBg.padding)
    },
    paddingX: {
        style: (0, $9xkBg.padding)
    },
    paddingY: {
        style: (0, $9xkBg.padding)
    },
    paddingInline: {
        style: (0, $9xkBg.padding)
    },
    paddingInlineStart: {
        style: (0, $9xkBg.padding)
    },
    paddingInlineEnd: {
        style: (0, $9xkBg.padding)
    },
    paddingBlock: {
        style: (0, $9xkBg.padding)
    },
    paddingBlockStart: {
        style: (0, $9xkBg.padding)
    },
    paddingBlockEnd: {
        style: (0, $9xkBg.padding)
    },
    m: {
        style: (0, $9xkBg.margin)
    },
    mt: {
        style: (0, $9xkBg.margin)
    },
    mr: {
        style: (0, $9xkBg.margin)
    },
    mb: {
        style: (0, $9xkBg.margin)
    },
    ml: {
        style: (0, $9xkBg.margin)
    },
    mx: {
        style: (0, $9xkBg.margin)
    },
    my: {
        style: (0, $9xkBg.margin)
    },
    margin: {
        style: (0, $9xkBg.margin)
    },
    marginTop: {
        style: (0, $9xkBg.margin)
    },
    marginRight: {
        style: (0, $9xkBg.margin)
    },
    marginBottom: {
        style: (0, $9xkBg.margin)
    },
    marginLeft: {
        style: (0, $9xkBg.margin)
    },
    marginX: {
        style: (0, $9xkBg.margin)
    },
    marginY: {
        style: (0, $9xkBg.margin)
    },
    marginInline: {
        style: (0, $9xkBg.margin)
    },
    marginInlineStart: {
        style: (0, $9xkBg.margin)
    },
    marginInlineEnd: {
        style: (0, $9xkBg.margin)
    },
    marginBlock: {
        style: (0, $9xkBg.margin)
    },
    marginBlockStart: {
        style: (0, $9xkBg.margin)
    },
    marginBlockEnd: {
        style: (0, $9xkBg.margin)
    },
    // display
    displayPrint: {
        cssProperty: false,
        transform: (value)=>({
                '@media print': {
                    display: value
                }
            })
    },
    display: {},
    overflow: {},
    textOverflow: {},
    visibility: {},
    whiteSpace: {},
    // flexbox
    flexBasis: {},
    flexDirection: {},
    flexWrap: {},
    justifyContent: {},
    alignItems: {},
    alignContent: {},
    order: {},
    flex: {},
    flexGrow: {},
    flexShrink: {},
    alignSelf: {},
    justifyItems: {},
    justifySelf: {},
    // grid
    gap: {
        style: (0, $4cVAM.gap)
    },
    rowGap: {
        style: (0, $4cVAM.rowGap)
    },
    columnGap: {
        style: (0, $4cVAM.columnGap)
    },
    gridColumn: {},
    gridRow: {},
    gridAutoFlow: {},
    gridAutoColumns: {},
    gridAutoRows: {},
    gridTemplateColumns: {},
    gridTemplateRows: {},
    gridTemplateAreas: {},
    gridArea: {},
    // positions
    position: {},
    zIndex: {
        themeKey: 'zIndex'
    },
    top: {},
    right: {},
    bottom: {},
    left: {},
    // shadows
    boxShadow: {
        themeKey: 'shadows'
    },
    // sizing
    width: {
        transform: (0, $lFRup.sizingTransform)
    },
    maxWidth: {
        style: (0, $lFRup.maxWidth)
    },
    minWidth: {
        transform: (0, $lFRup.sizingTransform)
    },
    height: {
        transform: (0, $lFRup.sizingTransform)
    },
    maxHeight: {
        transform: (0, $lFRup.sizingTransform)
    },
    minHeight: {
        transform: (0, $lFRup.sizingTransform)
    },
    boxSizing: {},
    // typography
    fontFamily: {
        themeKey: 'typography'
    },
    fontSize: {
        themeKey: 'typography'
    },
    fontStyle: {
        themeKey: 'typography'
    },
    fontWeight: {
        themeKey: 'typography'
    },
    letterSpacing: {},
    textTransform: {},
    lineHeight: {},
    textAlign: {},
    typography: {
        cssProperty: false,
        themeKey: 'typography'
    }
};
var $c53019574a4ed6a9$export$2e2bcd8739ae039 = $c53019574a4ed6a9$var$defaultSxConfig;

});
parcelRegister("fJG7S", function(module, exports) {

$parcel$export(module.exports, "borderTransform", function () { return $b74bbc5a139b6abb$export$34e2febe53ae29cc; });
$parcel$export(module.exports, "borderRadius", function () { return $b74bbc5a139b6abb$export$7a57f79000377ca2; });


var $cx2bP = parcelRequire("cx2bP");

var $2VoLz = parcelRequire("2VoLz");

var $9xkBg = parcelRequire("9xkBg");

var $dEfmb = parcelRequire("dEfmb");
function $b74bbc5a139b6abb$export$34e2febe53ae29cc(value) {
    if (typeof value !== 'number') return value;
    return `${value}px solid`;
}
function $b74bbc5a139b6abb$var$createBorderStyle(prop, transform) {
    return (0, $cx2bP.default)({
        prop: prop,
        themeKey: 'borders',
        transform: transform
    });
}
const $b74bbc5a139b6abb$export$1edee58a52776cd9 = $b74bbc5a139b6abb$var$createBorderStyle('border', $b74bbc5a139b6abb$export$34e2febe53ae29cc);
const $b74bbc5a139b6abb$export$f9a7b6bd24892946 = $b74bbc5a139b6abb$var$createBorderStyle('borderTop', $b74bbc5a139b6abb$export$34e2febe53ae29cc);
const $b74bbc5a139b6abb$export$5abca33e6be905d2 = $b74bbc5a139b6abb$var$createBorderStyle('borderRight', $b74bbc5a139b6abb$export$34e2febe53ae29cc);
const $b74bbc5a139b6abb$export$e2ce9f12a980a822 = $b74bbc5a139b6abb$var$createBorderStyle('borderBottom', $b74bbc5a139b6abb$export$34e2febe53ae29cc);
const $b74bbc5a139b6abb$export$47658cca1a909427 = $b74bbc5a139b6abb$var$createBorderStyle('borderLeft', $b74bbc5a139b6abb$export$34e2febe53ae29cc);
const $b74bbc5a139b6abb$export$e7fb0694ba2404fc = $b74bbc5a139b6abb$var$createBorderStyle('borderColor');
const $b74bbc5a139b6abb$export$126a92c968acdb85 = $b74bbc5a139b6abb$var$createBorderStyle('borderTopColor');
const $b74bbc5a139b6abb$export$85cc51cb8fbb8c0e = $b74bbc5a139b6abb$var$createBorderStyle('borderRightColor');
const $b74bbc5a139b6abb$export$340b0327727f6d1a = $b74bbc5a139b6abb$var$createBorderStyle('borderBottomColor');
const $b74bbc5a139b6abb$export$60beef91a985b4bf = $b74bbc5a139b6abb$var$createBorderStyle('borderLeftColor');
const $b74bbc5a139b6abb$export$f9258c55612cbed7 = $b74bbc5a139b6abb$var$createBorderStyle('outline', $b74bbc5a139b6abb$export$34e2febe53ae29cc);
const $b74bbc5a139b6abb$export$621fe586efeb64b9 = $b74bbc5a139b6abb$var$createBorderStyle('outlineColor');
const $b74bbc5a139b6abb$export$7a57f79000377ca2 = (props)=>{
    if (props.borderRadius !== undefined && props.borderRadius !== null) {
        const transformer = (0, $9xkBg.createUnaryUnit)(props.theme, 'shape.borderRadius', 4, 'borderRadius');
        const styleFromPropValue = (propValue)=>({
                borderRadius: (0, $9xkBg.getValue)(transformer, propValue)
            });
        return (0, $dEfmb.handleBreakpoints)(props, props.borderRadius, styleFromPropValue);
    }
    return null;
};
$b74bbc5a139b6abb$export$7a57f79000377ca2.propTypes = {};
$b74bbc5a139b6abb$export$7a57f79000377ca2.filterProps = [
    'borderRadius'
];
const $b74bbc5a139b6abb$var$borders = (0, $2VoLz.default)($b74bbc5a139b6abb$export$1edee58a52776cd9, $b74bbc5a139b6abb$export$f9a7b6bd24892946, $b74bbc5a139b6abb$export$5abca33e6be905d2, $b74bbc5a139b6abb$export$e2ce9f12a980a822, $b74bbc5a139b6abb$export$47658cca1a909427, $b74bbc5a139b6abb$export$e7fb0694ba2404fc, $b74bbc5a139b6abb$export$126a92c968acdb85, $b74bbc5a139b6abb$export$85cc51cb8fbb8c0e, $b74bbc5a139b6abb$export$340b0327727f6d1a, $b74bbc5a139b6abb$export$60beef91a985b4bf, $b74bbc5a139b6abb$export$7a57f79000377ca2, $b74bbc5a139b6abb$export$f9258c55612cbed7, $b74bbc5a139b6abb$export$621fe586efeb64b9);
var $b74bbc5a139b6abb$export$2e2bcd8739ae039 = $b74bbc5a139b6abb$var$borders;

});
parcelRegister("2VoLz", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $22141db32ba351e5$export$2e2bcd8739ae039; });

var $2zVBC = parcelRequire("2zVBC");
function $22141db32ba351e5$var$compose(...styles) {
    const handlers = styles.reduce((acc, style)=>{
        style.filterProps.forEach((prop)=>{
            acc[prop] = style;
        });
        return acc;
    }, {});
    // false positive
    // eslint-disable-next-line react/function-component-definition
    const fn = (props)=>{
        return Object.keys(props).reduce((acc, prop)=>{
            if (handlers[prop]) return (0, $2zVBC.default)(acc, handlers[prop](props));
            return acc;
        }, {});
    };
    fn.propTypes = {};
    fn.filterProps = styles.reduce((acc, style)=>acc.concat(style.filterProps), []);
    return fn;
}
var $22141db32ba351e5$export$2e2bcd8739ae039 = $22141db32ba351e5$var$compose;

});


parcelRegister("4cVAM", function(module, exports) {

$parcel$export(module.exports, "gap", function () { return $3104f50dc9afec8d$export$5df9adcb0db95e1e; });
$parcel$export(module.exports, "columnGap", function () { return $3104f50dc9afec8d$export$ec60d70ff941a580; });
$parcel$export(module.exports, "rowGap", function () { return $3104f50dc9afec8d$export$8a833ffa5f5dbeda; });

var $cx2bP = parcelRequire("cx2bP");

var $2VoLz = parcelRequire("2VoLz");

var $9xkBg = parcelRequire("9xkBg");

var $dEfmb = parcelRequire("dEfmb");

const $3104f50dc9afec8d$export$5df9adcb0db95e1e = (props)=>{
    if (props.gap !== undefined && props.gap !== null) {
        const transformer = (0, $9xkBg.createUnaryUnit)(props.theme, 'spacing', 8, 'gap');
        const styleFromPropValue = (propValue)=>({
                gap: (0, $9xkBg.getValue)(transformer, propValue)
            });
        return (0, $dEfmb.handleBreakpoints)(props, props.gap, styleFromPropValue);
    }
    return null;
};
$3104f50dc9afec8d$export$5df9adcb0db95e1e.propTypes = {};
$3104f50dc9afec8d$export$5df9adcb0db95e1e.filterProps = [
    'gap'
];
const $3104f50dc9afec8d$export$ec60d70ff941a580 = (props)=>{
    if (props.columnGap !== undefined && props.columnGap !== null) {
        const transformer = (0, $9xkBg.createUnaryUnit)(props.theme, 'spacing', 8, 'columnGap');
        const styleFromPropValue = (propValue)=>({
                columnGap: (0, $9xkBg.getValue)(transformer, propValue)
            });
        return (0, $dEfmb.handleBreakpoints)(props, props.columnGap, styleFromPropValue);
    }
    return null;
};
$3104f50dc9afec8d$export$ec60d70ff941a580.propTypes = {};
$3104f50dc9afec8d$export$ec60d70ff941a580.filterProps = [
    'columnGap'
];
const $3104f50dc9afec8d$export$8a833ffa5f5dbeda = (props)=>{
    if (props.rowGap !== undefined && props.rowGap !== null) {
        const transformer = (0, $9xkBg.createUnaryUnit)(props.theme, 'spacing', 8, 'rowGap');
        const styleFromPropValue = (propValue)=>({
                rowGap: (0, $9xkBg.getValue)(transformer, propValue)
            });
        return (0, $dEfmb.handleBreakpoints)(props, props.rowGap, styleFromPropValue);
    }
    return null;
};
$3104f50dc9afec8d$export$8a833ffa5f5dbeda.propTypes = {};
$3104f50dc9afec8d$export$8a833ffa5f5dbeda.filterProps = [
    'rowGap'
];
const $3104f50dc9afec8d$export$baf44164ca3a34e8 = (0, $cx2bP.default)({
    prop: 'gridColumn'
});
const $3104f50dc9afec8d$export$8f7213a1cd01e832 = (0, $cx2bP.default)({
    prop: 'gridRow'
});
const $3104f50dc9afec8d$export$b0e0abbc49ba668 = (0, $cx2bP.default)({
    prop: 'gridAutoFlow'
});
const $3104f50dc9afec8d$export$bcd8b929d4b4142 = (0, $cx2bP.default)({
    prop: 'gridAutoColumns'
});
const $3104f50dc9afec8d$export$e5039a674e14c828 = (0, $cx2bP.default)({
    prop: 'gridAutoRows'
});
const $3104f50dc9afec8d$export$42bd9088661ffb03 = (0, $cx2bP.default)({
    prop: 'gridTemplateColumns'
});
const $3104f50dc9afec8d$export$920682ae05b999bc = (0, $cx2bP.default)({
    prop: 'gridTemplateRows'
});
const $3104f50dc9afec8d$export$1b88fbdd482fd33a = (0, $cx2bP.default)({
    prop: 'gridTemplateAreas'
});
const $3104f50dc9afec8d$export$bdb486e40d52d26f = (0, $cx2bP.default)({
    prop: 'gridArea'
});
const $3104f50dc9afec8d$var$grid = (0, $2VoLz.default)($3104f50dc9afec8d$export$5df9adcb0db95e1e, $3104f50dc9afec8d$export$ec60d70ff941a580, $3104f50dc9afec8d$export$8a833ffa5f5dbeda, $3104f50dc9afec8d$export$baf44164ca3a34e8, $3104f50dc9afec8d$export$8f7213a1cd01e832, $3104f50dc9afec8d$export$b0e0abbc49ba668, $3104f50dc9afec8d$export$bcd8b929d4b4142, $3104f50dc9afec8d$export$e5039a674e14c828, $3104f50dc9afec8d$export$42bd9088661ffb03, $3104f50dc9afec8d$export$920682ae05b999bc, $3104f50dc9afec8d$export$1b88fbdd482fd33a, $3104f50dc9afec8d$export$bdb486e40d52d26f);
var $3104f50dc9afec8d$export$2e2bcd8739ae039 = $3104f50dc9afec8d$var$grid;

});

parcelRegister("74IQt", function(module, exports) {

$parcel$export(module.exports, "paletteTransform", function () { return $526bb1737eea2e88$export$dbaffd4420ea0ac6; });

var $cx2bP = parcelRequire("cx2bP");

var $2VoLz = parcelRequire("2VoLz");
function $526bb1737eea2e88$export$dbaffd4420ea0ac6(value, userValue) {
    if (userValue === 'grey') return userValue;
    return value;
}
const $526bb1737eea2e88$export$35e9368ef982300f = (0, $cx2bP.default)({
    prop: 'color',
    themeKey: 'palette',
    transform: $526bb1737eea2e88$export$dbaffd4420ea0ac6
});
const $526bb1737eea2e88$export$2506f56c10355b33 = (0, $cx2bP.default)({
    prop: 'bgcolor',
    cssProperty: 'backgroundColor',
    themeKey: 'palette',
    transform: $526bb1737eea2e88$export$dbaffd4420ea0ac6
});
const $526bb1737eea2e88$export$8c5a050822fd698c = (0, $cx2bP.default)({
    prop: 'backgroundColor',
    themeKey: 'palette',
    transform: $526bb1737eea2e88$export$dbaffd4420ea0ac6
});
const $526bb1737eea2e88$var$palette = (0, $2VoLz.default)($526bb1737eea2e88$export$35e9368ef982300f, $526bb1737eea2e88$export$2506f56c10355b33, $526bb1737eea2e88$export$8c5a050822fd698c);
var $526bb1737eea2e88$export$2e2bcd8739ae039 = $526bb1737eea2e88$var$palette;

});

parcelRegister("lFRup", function(module, exports) {

$parcel$export(module.exports, "sizingTransform", function () { return $fc76eb399c2fbe9f$export$8afece71750ec241; });
$parcel$export(module.exports, "maxWidth", function () { return $fc76eb399c2fbe9f$export$488fda99655ff65a; });

var $cx2bP = parcelRequire("cx2bP");

var $2VoLz = parcelRequire("2VoLz");

var $dEfmb = parcelRequire("dEfmb");
function $fc76eb399c2fbe9f$export$8afece71750ec241(value) {
    return value <= 1 && value !== 0 ? `${value * 100}%` : value;
}
const $fc76eb399c2fbe9f$export$7e3df82ee760448c = (0, $cx2bP.default)({
    prop: 'width',
    transform: $fc76eb399c2fbe9f$export$8afece71750ec241
});
const $fc76eb399c2fbe9f$export$488fda99655ff65a = (props)=>{
    if (props.maxWidth !== undefined && props.maxWidth !== null) {
        const styleFromPropValue = (propValue)=>{
            var _props$theme, _props$theme2;
            const breakpoint = ((_props$theme = props.theme) == null || (_props$theme = _props$theme.breakpoints) == null || (_props$theme = _props$theme.values) == null ? void 0 : _props$theme[propValue]) || (0, $dEfmb.values)[propValue];
            if (!breakpoint) return {
                maxWidth: $fc76eb399c2fbe9f$export$8afece71750ec241(propValue)
            };
            if (((_props$theme2 = props.theme) == null || (_props$theme2 = _props$theme2.breakpoints) == null ? void 0 : _props$theme2.unit) !== 'px') return {
                maxWidth: `${breakpoint}${props.theme.breakpoints.unit}`
            };
            return {
                maxWidth: breakpoint
            };
        };
        return (0, $dEfmb.handleBreakpoints)(props, props.maxWidth, styleFromPropValue);
    }
    return null;
};
$fc76eb399c2fbe9f$export$488fda99655ff65a.filterProps = [
    'maxWidth'
];
const $fc76eb399c2fbe9f$export$ee148fbbe8357dd2 = (0, $cx2bP.default)({
    prop: 'minWidth',
    transform: $fc76eb399c2fbe9f$export$8afece71750ec241
});
const $fc76eb399c2fbe9f$export$ac607276a8fe9f0a = (0, $cx2bP.default)({
    prop: 'height',
    transform: $fc76eb399c2fbe9f$export$8afece71750ec241
});
const $fc76eb399c2fbe9f$export$dc0d8bd0b94f8570 = (0, $cx2bP.default)({
    prop: 'maxHeight',
    transform: $fc76eb399c2fbe9f$export$8afece71750ec241
});
const $fc76eb399c2fbe9f$export$a43cf604e12f3b17 = (0, $cx2bP.default)({
    prop: 'minHeight',
    transform: $fc76eb399c2fbe9f$export$8afece71750ec241
});
const $fc76eb399c2fbe9f$export$ffed9f14fb65e276 = (0, $cx2bP.default)({
    prop: 'size',
    cssProperty: 'width',
    transform: $fc76eb399c2fbe9f$export$8afece71750ec241
});
const $fc76eb399c2fbe9f$export$905076ed6620e671 = (0, $cx2bP.default)({
    prop: 'size',
    cssProperty: 'height',
    transform: $fc76eb399c2fbe9f$export$8afece71750ec241
});
const $fc76eb399c2fbe9f$export$6ccc93f785106a58 = (0, $cx2bP.default)({
    prop: 'boxSizing'
});
const $fc76eb399c2fbe9f$var$sizing = (0, $2VoLz.default)($fc76eb399c2fbe9f$export$7e3df82ee760448c, $fc76eb399c2fbe9f$export$488fda99655ff65a, $fc76eb399c2fbe9f$export$ee148fbbe8357dd2, $fc76eb399c2fbe9f$export$ac607276a8fe9f0a, $fc76eb399c2fbe9f$export$dc0d8bd0b94f8570, $fc76eb399c2fbe9f$export$a43cf604e12f3b17, $fc76eb399c2fbe9f$export$6ccc93f785106a58);
var $fc76eb399c2fbe9f$export$2e2bcd8739ae039 = $fc76eb399c2fbe9f$var$sizing;

});



parcelRegister("hURNW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d0b16712e3df9448$export$2e2bcd8739ae039; });
/**
 * A universal utility to style components with multiple color modes. Always use it from the theme object.
 * It works with:
 *  - [Basic theme](https://mui.com/material-ui/customization/dark-mode/)
 *  - [CSS theme variables](https://mui.com/material-ui/experimental-api/css-theme-variables/overview/)
 *  - Zero-runtime engine
 *
 * Tips: Use an array over object spread and place `theme.applyStyles()` last.
 *
 * ✅ [{ background: '#e5e5e5' }, theme.applyStyles('dark', { background: '#1c1c1c' })]
 *
 * 🚫 { background: '#e5e5e5', ...theme.applyStyles('dark', { background: '#1c1c1c' })}
 *
 * @example
 * 1. using with `styled`:
 * ```jsx
 *   const Component = styled('div')(({ theme }) => [
 *     { background: '#e5e5e5' },
 *     theme.applyStyles('dark', {
 *       background: '#1c1c1c',
 *       color: '#fff',
 *     }),
 *   ]);
 * ```
 *
 * @example
 * 2. using with `sx` prop:
 * ```jsx
 *   <Box sx={theme => [
 *     { background: '#e5e5e5' },
 *     theme.applyStyles('dark', {
 *        background: '#1c1c1c',
 *        color: '#fff',
 *      }),
 *     ]}
 *   />
 * ```
 *
 * @example
 * 3. theming a component:
 * ```jsx
 *   extendTheme({
 *     components: {
 *       MuiButton: {
 *         styleOverrides: {
 *           root: ({ theme }) => [
 *             { background: '#e5e5e5' },
 *             theme.applyStyles('dark', {
 *               background: '#1c1c1c',
 *               color: '#fff',
 *             }),
 *           ],
 *         },
 *       }
 *     }
 *   })
 *```
 */ function $d0b16712e3df9448$export$2e2bcd8739ae039(key, styles) {
    // @ts-expect-error this is 'any' type
    const theme = this;
    if (theme.vars && typeof theme.getColorSchemeSelector === 'function') {
        // If CssVarsProvider is used as a provider,
        // returns '* :where([data-mui-color-scheme="light|dark"]) &'
        const selector = theme.getColorSchemeSelector(key).replace(/(\[[^\]]+\])/, '*:where($1)');
        return {
            [selector]: styles
        };
    }
    if (theme.palette.mode === key) return styles;
    return {};
}

});



parcelRegister("igGEn", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return (parcelRequire("k1l9i")).default; });
$parcel$export(module.exports, "unstable_createStyleFunctionSx", function () { return (parcelRequire("k1l9i")).unstable_createStyleFunctionSx; });
$parcel$export(module.exports, "extendSxProp", function () { return (parcelRequire("01deC")).default; });
$parcel$export(module.exports, "unstable_defaultSxConfig", function () { return (parcelRequire("gVCQf")).default; });

var $k1l9i = parcelRequire("k1l9i");

var $01deC = parcelRequire("01deC");

var $gVCQf = parcelRequire("gVCQf");

});
parcelRegister("01deC", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $003a5c4266f21194$export$2e2bcd8739ae039; });

var $3VnFq = parcelRequire("3VnFq");

var $cTAWX = parcelRequire("cTAWX");

var $dvHXN = parcelRequire("dvHXN");

var $gVCQf = parcelRequire("gVCQf");
const $003a5c4266f21194$var$_excluded = [
    "sx"
];
const $003a5c4266f21194$var$splitProps = (props)=>{
    var _props$theme$unstable, _props$theme;
    const result = {
        systemProps: {},
        otherProps: {}
    };
    const config = (_props$theme$unstable = props == null || (_props$theme = props.theme) == null ? void 0 : _props$theme.unstable_sxConfig) != null ? _props$theme$unstable : (0, $gVCQf.default);
    Object.keys(props).forEach((prop)=>{
        if (config[prop]) result.systemProps[prop] = props[prop];
        else result.otherProps[prop] = props[prop];
    });
    return result;
};
function $003a5c4266f21194$export$2e2bcd8739ae039(props) {
    const { sx: inSx } = props, other = (0, $cTAWX.default)(props, $003a5c4266f21194$var$_excluded);
    const { systemProps: systemProps, otherProps: otherProps } = $003a5c4266f21194$var$splitProps(other);
    let finalSx;
    if (Array.isArray(inSx)) finalSx = [
        systemProps,
        ...inSx
    ];
    else if (typeof inSx === 'function') finalSx = (...args)=>{
        const result = inSx(...args);
        if (!(0, $dvHXN.isPlainObject)(result)) return systemProps;
        return (0, $3VnFq.default)({}, systemProps, result);
    };
    else finalSx = (0, $3VnFq.default)({}, systemProps, inSx);
    return (0, $3VnFq.default)({}, otherProps, {
        sx: finalSx
    });
}

});


parcelRegister("lXMfO", function(module, exports) {
"use strict";
'use client';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $ezPqr.default;
    }
});

var $ezPqr = parcelRequire("ezPqr");

});
parcelRegister("ezPqr", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a9cc399dbd01e304$export$2e2bcd8739ae039; });

var $3VnFq = parcelRequire("3VnFq");

var $gJYWc = parcelRequire("gJYWc");

var $962me = parcelRequire("962me");

var $9wx12 = parcelRequire("9wx12");
'use client';
function $a9cc399dbd01e304$export$2e2bcd8739ae039(path, displayName) {
    function Component(props, ref) {
        return /*#__PURE__*/ (0, $9wx12.jsx)((0, $962me.default), (0, $3VnFq.default)({
            "data-testid": `${displayName}Icon`,
            ref: ref
        }, props, {
            children: path
        }));
    }
    Component.muiName = (0, $962me.default).muiName;
    return /*#__PURE__*/ $gJYWc.memo(/*#__PURE__*/ $gJYWc.forwardRef(Component));
}

});
parcelRegister("962me", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $69f680bd49db207d$export$2e2bcd8739ae039; });

var $3VnFq = parcelRequire("3VnFq");

var $cTAWX = parcelRequire("cTAWX");

var $gJYWc = parcelRequire("gJYWc");


var $2w6IV = parcelRequire("2w6IV");

var $3e4LV = parcelRequire("3e4LV");

var $cVrVk = parcelRequire("cVrVk");

var $8pLcn = parcelRequire("8pLcn");

var $HGmne = parcelRequire("HGmne");

var $28iAq = parcelRequire("28iAq");

var $9wx12 = parcelRequire("9wx12");
'use client';
const $69f680bd49db207d$var$_excluded = [
    "children",
    "className",
    "color",
    "component",
    "fontSize",
    "htmlColor",
    "inheritViewBox",
    "titleAccess",
    "viewBox"
];
const $69f680bd49db207d$var$useUtilityClasses = (ownerState)=>{
    const { color: color, fontSize: fontSize, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            color !== 'inherit' && `color${(0, $cVrVk.default)(color)}`,
            `fontSize${(0, $cVrVk.default)(fontSize)}`
        ]
    };
    return (0, $3e4LV.default)(slots, (0, $28iAq.getSvgIconUtilityClass), classes);
};
const $69f680bd49db207d$var$SvgIconRoot = (0, $HGmne.default)('svg', {
    name: 'MuiSvgIcon',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.color !== 'inherit' && styles[`color${(0, $cVrVk.default)(ownerState.color)}`],
            styles[`fontSize${(0, $cVrVk.default)(ownerState.fontSize)}`]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>{
    var _theme$transitions, _theme$transitions$cr, _theme$transitions2, _theme$typography, _theme$typography$pxT, _theme$typography2, _theme$typography2$px, _theme$typography3, _theme$typography3$px, _palette$ownerState$c, _palette, _palette2, _palette3;
    return {
        userSelect: 'none',
        width: '1em',
        height: '1em',
        display: 'inline-block',
        // the <svg> will define the property that has `currentColor`
        // for example heroicons uses fill="none" and stroke="currentColor"
        fill: ownerState.hasSvgAsChild ? undefined : 'currentColor',
        flexShrink: 0,
        transition: (_theme$transitions = theme.transitions) == null || (_theme$transitions$cr = _theme$transitions.create) == null ? void 0 : _theme$transitions$cr.call(_theme$transitions, 'fill', {
            duration: (_theme$transitions2 = theme.transitions) == null || (_theme$transitions2 = _theme$transitions2.duration) == null ? void 0 : _theme$transitions2.shorter
        }),
        fontSize: ({
            inherit: 'inherit',
            small: ((_theme$typography = theme.typography) == null || (_theme$typography$pxT = _theme$typography.pxToRem) == null ? void 0 : _theme$typography$pxT.call(_theme$typography, 20)) || '1.25rem',
            medium: ((_theme$typography2 = theme.typography) == null || (_theme$typography2$px = _theme$typography2.pxToRem) == null ? void 0 : _theme$typography2$px.call(_theme$typography2, 24)) || '1.5rem',
            large: ((_theme$typography3 = theme.typography) == null || (_theme$typography3$px = _theme$typography3.pxToRem) == null ? void 0 : _theme$typography3$px.call(_theme$typography3, 35)) || '2.1875rem'
        })[ownerState.fontSize],
        // TODO v5 deprecate, v6 remove for sx
        color: (_palette$ownerState$c = (_palette = (theme.vars || theme).palette) == null || (_palette = _palette[ownerState.color]) == null ? void 0 : _palette.main) != null ? _palette$ownerState$c : ({
            action: (_palette2 = (theme.vars || theme).palette) == null || (_palette2 = _palette2.action) == null ? void 0 : _palette2.active,
            disabled: (_palette3 = (theme.vars || theme).palette) == null || (_palette3 = _palette3.action) == null ? void 0 : _palette3.disabled,
            inherit: undefined
        })[ownerState.color]
    };
});
const $69f680bd49db207d$var$SvgIcon = /*#__PURE__*/ $gJYWc.forwardRef(function SvgIcon(inProps, ref) {
    const props = (0, $8pLcn.useDefaultProps)({
        props: inProps,
        name: 'MuiSvgIcon'
    });
    const { children: children, className: className, color: color = 'inherit', component: component = 'svg', fontSize: fontSize = 'medium', htmlColor: htmlColor, inheritViewBox: inheritViewBox = false, titleAccess: titleAccess, viewBox: viewBox = '0 0 24 24' } = props, other = (0, $cTAWX.default)(props, $69f680bd49db207d$var$_excluded);
    const hasSvgAsChild = /*#__PURE__*/ $gJYWc.isValidElement(children) && children.type === 'svg';
    const ownerState = (0, $3VnFq.default)({}, props, {
        color: color,
        component: component,
        fontSize: fontSize,
        instanceFontSize: inProps.fontSize,
        inheritViewBox: inheritViewBox,
        viewBox: viewBox,
        hasSvgAsChild: hasSvgAsChild
    });
    const more = {};
    if (!inheritViewBox) more.viewBox = viewBox;
    const classes = $69f680bd49db207d$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $9wx12.jsxs)($69f680bd49db207d$var$SvgIconRoot, (0, $3VnFq.default)({
        as: component,
        className: (0, $2w6IV.default)(classes.root, className),
        focusable: "false",
        color: htmlColor,
        "aria-hidden": titleAccess ? undefined : true,
        role: titleAccess ? 'img' : undefined,
        ref: ref
    }, more, other, hasSvgAsChild && children.props, {
        ownerState: ownerState,
        children: [
            hasSvgAsChild ? children.props.children : children,
            titleAccess ? /*#__PURE__*/ (0, $9wx12.jsx)("title", {
                children: titleAccess
            }) : null
        ]
    }));
});
$69f680bd49db207d$var$SvgIcon.muiName = 'SvgIcon';
var $69f680bd49db207d$export$2e2bcd8739ae039 = $69f680bd49db207d$var$SvgIcon;

});
parcelRegister("2w6IV", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $01c3f0647efaa98e$export$2e2bcd8739ae039; });
function $01c3f0647efaa98e$var$r(e) {
    var t, f, n = "";
    if ("string" == typeof e || "number" == typeof e) n += e;
    else if ("object" == typeof e) {
        if (Array.isArray(e)) {
            var o = e.length;
            for(t = 0; t < o; t++)e[t] && (f = $01c3f0647efaa98e$var$r(e[t])) && (n && (n += " "), n += f);
        } else for(f in e)e[f] && (n && (n += " "), n += f);
    }
    return n;
}
function $01c3f0647efaa98e$export$4f5d2d50c9deca37() {
    for(var e, t, f = 0, n = "", o = arguments.length; f < o; f++)(e = arguments[f]) && (t = $01c3f0647efaa98e$var$r(e)) && (n && (n += " "), n += t);
    return n;
}
var $01c3f0647efaa98e$export$2e2bcd8739ae039 = $01c3f0647efaa98e$export$4f5d2d50c9deca37;

});

parcelRegister("3e4LV", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $25966182abc604fb$export$2e2bcd8739ae039; });
function $25966182abc604fb$export$2e2bcd8739ae039(slots, getUtilityClass, classes) {
    const output = {};
    Object.keys(slots).forEach(// `Object.keys(slots)` can't be wider than `T` because we infer `T` from `slots`.
    // @ts-expect-error https://github.com/microsoft/TypeScript/pull/12253#issuecomment-263132208
    (slot)=>{
        output[slot] = slots[slot].reduce((acc, key)=>{
            if (key) {
                const utilityClass = getUtilityClass(key);
                if (utilityClass !== '') acc.push(utilityClass);
                if (classes && classes[key]) acc.push(classes[key]);
            }
            return acc;
        }, []).join(' ');
    });
    return output;
}

});

parcelRegister("cVrVk", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $969077f23a71f3b5$export$2e2bcd8739ae039; });

var $hdsnN = parcelRequire("hdsnN");
var $969077f23a71f3b5$export$2e2bcd8739ae039 = (0, $hdsnN.default);

});

parcelRegister("8pLcn", function(module, exports) {

$parcel$export(module.exports, "useDefaultProps", function () { return $6205452f9e656b51$export$2440da353cedad43; });

var $3VnFq = parcelRequire("3VnFq");
parcelRequire("gJYWc");


var $43DQp = parcelRequire("43DQp");

var $9wx12 = parcelRequire("9wx12");
'use client';
function $6205452f9e656b51$var$DefaultPropsProvider(props) {
    return /*#__PURE__*/ (0, $9wx12.jsx)((0, $43DQp.default), (0, $3VnFq.default)({}, props));
}
var $6205452f9e656b51$export$2e2bcd8739ae039 = $6205452f9e656b51$var$DefaultPropsProvider;
function $6205452f9e656b51$export$2440da353cedad43(params) {
    return (0, $43DQp.useDefaultProps)(params);
}

});
parcelRegister("43DQp", function(module, exports) {

$parcel$export(module.exports, "useDefaultProps", function () { return $2f4659774ad9721b$export$2440da353cedad43; });
$parcel$export(module.exports, "default", function () { return $2f4659774ad9721b$export$2e2bcd8739ae039; });

var $gJYWc = parcelRequire("gJYWc");


var $11GxC = parcelRequire("11GxC");

var $9wx12 = parcelRequire("9wx12");
'use client';
const $2f4659774ad9721b$var$PropsContext = /*#__PURE__*/ $gJYWc.createContext(undefined);
function $2f4659774ad9721b$var$DefaultPropsProvider({ value: value, children: children }) {
    return /*#__PURE__*/ (0, $9wx12.jsx)($2f4659774ad9721b$var$PropsContext.Provider, {
        value: value,
        children: children
    });
}
function $2f4659774ad9721b$var$getThemeProps(params) {
    const { theme: theme, name: name, props: props } = params;
    if (!theme || !theme.components || !theme.components[name]) return props;
    const config = theme.components[name];
    if (config.defaultProps) // compatible with v5 signature
    return (0, $11GxC.default)(config.defaultProps, props);
    if (!config.styleOverrides && !config.variants) // v6 signature, no property 'defaultProps'
    return (0, $11GxC.default)(config, props);
    return props;
}
function $2f4659774ad9721b$export$2440da353cedad43({ props: props, name: name }) {
    const ctx = $gJYWc.useContext($2f4659774ad9721b$var$PropsContext);
    return $2f4659774ad9721b$var$getThemeProps({
        props: props,
        name: name,
        theme: {
            components: ctx
        }
    });
}
var $2f4659774ad9721b$export$2e2bcd8739ae039 = $2f4659774ad9721b$var$DefaultPropsProvider;

});
parcelRegister("11GxC", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0bf6e244d47d9de1$export$2e2bcd8739ae039; });

var $3VnFq = parcelRequire("3VnFq");
function $0bf6e244d47d9de1$export$2e2bcd8739ae039(defaultProps, props) {
    const output = (0, $3VnFq.default)({}, props);
    Object.keys(defaultProps).forEach((propName)=>{
        if (propName.toString().match(/^(components|slots)$/)) output[propName] = (0, $3VnFq.default)({}, defaultProps[propName], output[propName]);
        else if (propName.toString().match(/^(componentsProps|slotProps)$/)) {
            const defaultSlotProps = defaultProps[propName] || {};
            const slotProps = props[propName];
            output[propName] = {};
            if (!slotProps || !Object.keys(slotProps)) // Reduce the iteration if the slot props is empty
            output[propName] = defaultSlotProps;
            else if (!defaultSlotProps || !Object.keys(defaultSlotProps)) // Reduce the iteration if the default slot props is empty
            output[propName] = slotProps;
            else {
                output[propName] = (0, $3VnFq.default)({}, slotProps);
                Object.keys(defaultSlotProps).forEach((slotPropName)=>{
                    output[propName][slotPropName] = $0bf6e244d47d9de1$export$2e2bcd8739ae039(defaultSlotProps[slotPropName], slotProps[slotPropName]);
                });
            }
        } else if (output[propName] === undefined) output[propName] = defaultProps[propName];
    });
    return output;
}

});



parcelRegister("HGmne", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0834e00deeebd54c$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "rootShouldForwardProp", function () { return (parcelRequire("8ttSm")).default; });

var $b97Ic = parcelRequire("b97Ic");

var $iNcPC = parcelRequire("iNcPC");

var $8Ho5h = parcelRequire("8Ho5h");

var $8ttSm = parcelRequire("8ttSm");

var $67P0f = parcelRequire("67P0f");
'use client';
const $0834e00deeebd54c$var$styled = (0, (/*@__PURE__*/$parcel$interopDefault($b97Ic)))({
    themeId: (0, $8Ho5h.default),
    defaultTheme: $iNcPC.default,
    rootShouldForwardProp: $8ttSm.default
});
var $0834e00deeebd54c$export$2e2bcd8739ae039 = $0834e00deeebd54c$var$styled;

});
parcelRegister("b97Ic", function(module, exports) {
"use strict";

var $hrFuR = parcelRequire("hrFuR");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $81d6846029a0d3b6$var$createStyled;
module.exports.shouldForwardProp = $81d6846029a0d3b6$var$shouldForwardProp;
module.exports.systemDefaultTheme = void 0;

var $81d6846029a0d3b6$var$_extends2 = $hrFuR((parcelRequire("b3LQA")));

var $81d6846029a0d3b6$var$_objectWithoutPropertiesLoose2 = $hrFuR((parcelRequire("5S2Z8")));

var $81d6846029a0d3b6$var$_styledEngine = $81d6846029a0d3b6$var$_interopRequireWildcard((parcelRequire("9Ie0W")));

var $dvHXN = parcelRequire("dvHXN");

var $81d6846029a0d3b6$var$_capitalize = $hrFuR((parcelRequire("iJr6q")));

var $81d6846029a0d3b6$var$_getDisplayName = $hrFuR((parcelRequire("2fj9v")));

var $81d6846029a0d3b6$var$_createTheme = $hrFuR((parcelRequire("9TIAj")));

var $81d6846029a0d3b6$var$_styleFunctionSx = $hrFuR((parcelRequire("igGEn")));
const $81d6846029a0d3b6$var$_excluded = [
    "ownerState"
], $81d6846029a0d3b6$var$_excluded2 = [
    "variants"
], $81d6846029a0d3b6$var$_excluded3 = [
    "name",
    "slot",
    "skipVariantsResolver",
    "skipSx",
    "overridesResolver"
];
/* eslint-disable no-underscore-dangle */ function $81d6846029a0d3b6$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($81d6846029a0d3b6$var$_getRequireWildcardCache = function(e) {
        return e ? t : r;
    })(e);
}
function $81d6846029a0d3b6$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        default: e
    };
    var t = $81d6846029a0d3b6$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n.default = e, t && t.set(e, n), n;
}
function $81d6846029a0d3b6$var$isEmpty(obj) {
    return Object.keys(obj).length === 0;
}
// https://github.com/emotion-js/emotion/blob/26ded6109fcd8ca9875cc2ce4564fee678a3f3c5/packages/styled/src/utils.js#L40
function $81d6846029a0d3b6$var$isStringTag(tag) {
    return typeof tag === 'string' && // 96 is one less than the char code
    // for "a" so this is checking that
    // it's a lowercase character
    tag.charCodeAt(0) > 96;
}
// Update /system/styled/#api in case if this changes
function $81d6846029a0d3b6$var$shouldForwardProp(prop) {
    return prop !== 'ownerState' && prop !== 'theme' && prop !== 'sx' && prop !== 'as';
}
const $81d6846029a0d3b6$var$systemDefaultTheme = module.exports.systemDefaultTheme = (0, $81d6846029a0d3b6$var$_createTheme.default)();
const $81d6846029a0d3b6$var$lowercaseFirstLetter = (string)=>{
    if (!string) return string;
    return string.charAt(0).toLowerCase() + string.slice(1);
};
function $81d6846029a0d3b6$var$resolveTheme({ defaultTheme: defaultTheme, theme: theme, themeId: themeId }) {
    return $81d6846029a0d3b6$var$isEmpty(theme) ? defaultTheme : theme[themeId] || theme;
}
function $81d6846029a0d3b6$var$defaultOverridesResolver(slot) {
    if (!slot) return null;
    return (props, styles)=>styles[slot];
}
function $81d6846029a0d3b6$var$processStyleArg(callableStyle, _ref) {
    let { ownerState: ownerState } = _ref, props = (0, $81d6846029a0d3b6$var$_objectWithoutPropertiesLoose2.default)(_ref, $81d6846029a0d3b6$var$_excluded);
    const resolvedStylesArg = typeof callableStyle === 'function' ? callableStyle((0, $81d6846029a0d3b6$var$_extends2.default)({
        ownerState: ownerState
    }, props)) : callableStyle;
    if (Array.isArray(resolvedStylesArg)) return resolvedStylesArg.flatMap((resolvedStyle)=>$81d6846029a0d3b6$var$processStyleArg(resolvedStyle, (0, $81d6846029a0d3b6$var$_extends2.default)({
            ownerState: ownerState
        }, props)));
    if (!!resolvedStylesArg && typeof resolvedStylesArg === 'object' && Array.isArray(resolvedStylesArg.variants)) {
        const { variants: variants = [] } = resolvedStylesArg, otherStyles = (0, $81d6846029a0d3b6$var$_objectWithoutPropertiesLoose2.default)(resolvedStylesArg, $81d6846029a0d3b6$var$_excluded2);
        let result = otherStyles;
        variants.forEach((variant)=>{
            let isMatch = true;
            if (typeof variant.props === 'function') isMatch = variant.props((0, $81d6846029a0d3b6$var$_extends2.default)({
                ownerState: ownerState
            }, props, ownerState));
            else Object.keys(variant.props).forEach((key)=>{
                if ((ownerState == null ? void 0 : ownerState[key]) !== variant.props[key] && props[key] !== variant.props[key]) isMatch = false;
            });
            if (isMatch) {
                if (!Array.isArray(result)) result = [
                    result
                ];
                result.push(typeof variant.style === 'function' ? variant.style((0, $81d6846029a0d3b6$var$_extends2.default)({
                    ownerState: ownerState
                }, props, ownerState)) : variant.style);
            }
        });
        return result;
    }
    return resolvedStylesArg;
}
function $81d6846029a0d3b6$var$createStyled(input = {}) {
    const { themeId: themeId, defaultTheme: defaultTheme = $81d6846029a0d3b6$var$systemDefaultTheme, rootShouldForwardProp: rootShouldForwardProp = $81d6846029a0d3b6$var$shouldForwardProp, slotShouldForwardProp: slotShouldForwardProp = $81d6846029a0d3b6$var$shouldForwardProp } = input;
    const systemSx = (props)=>{
        return (0, $81d6846029a0d3b6$var$_styleFunctionSx.default)((0, $81d6846029a0d3b6$var$_extends2.default)({}, props, {
            theme: $81d6846029a0d3b6$var$resolveTheme((0, $81d6846029a0d3b6$var$_extends2.default)({}, props, {
                defaultTheme: defaultTheme,
                themeId: themeId
            }))
        }));
    };
    systemSx.__mui_systemSx = true;
    return (tag, inputOptions = {})=>{
        // Filter out the `sx` style function from the previous styled component to prevent unnecessary styles generated by the composite components.
        (0, $81d6846029a0d3b6$var$_styledEngine.internal_processStyles)(tag, (styles)=>styles.filter((style)=>!(style != null && style.__mui_systemSx)));
        const { name: componentName, slot: componentSlot, skipVariantsResolver: inputSkipVariantsResolver, skipSx: inputSkipSx, overridesResolver: // TODO v6: remove `lowercaseFirstLetter()` in the next major release
        // For more details: https://github.com/mui/material-ui/pull/37908
        overridesResolver = $81d6846029a0d3b6$var$defaultOverridesResolver($81d6846029a0d3b6$var$lowercaseFirstLetter(componentSlot)) } = inputOptions, options = (0, $81d6846029a0d3b6$var$_objectWithoutPropertiesLoose2.default)(inputOptions, $81d6846029a0d3b6$var$_excluded3);
        // if skipVariantsResolver option is defined, take the value, otherwise, true for root and false for other slots.
        const skipVariantsResolver = inputSkipVariantsResolver !== undefined ? inputSkipVariantsResolver : // TODO v6: remove `Root` in the next major release
        // For more details: https://github.com/mui/material-ui/pull/37908
        componentSlot && componentSlot !== 'Root' && componentSlot !== 'root' || false;
        const skipSx = inputSkipSx || false;
        let label;
        let shouldForwardPropOption = $81d6846029a0d3b6$var$shouldForwardProp;
        // TODO v6: remove `Root` in the next major release
        // For more details: https://github.com/mui/material-ui/pull/37908
        if (componentSlot === 'Root' || componentSlot === 'root') shouldForwardPropOption = rootShouldForwardProp;
        else if (componentSlot) // any other slot specified
        shouldForwardPropOption = slotShouldForwardProp;
        else if ($81d6846029a0d3b6$var$isStringTag(tag)) // for string (html) tag, preserve the behavior in emotion & styled-components.
        shouldForwardPropOption = undefined;
        const defaultStyledResolver = (0, $81d6846029a0d3b6$var$_styledEngine.default)(tag, (0, $81d6846029a0d3b6$var$_extends2.default)({
            shouldForwardProp: shouldForwardPropOption,
            label: label
        }, options));
        const transformStyleArg = (stylesArg)=>{
            // On the server Emotion doesn't use React.forwardRef for creating components, so the created
            // component stays as a function. This condition makes sure that we do not interpolate functions
            // which are basically components used as a selectors.
            if (typeof stylesArg === 'function' && stylesArg.__emotion_real !== stylesArg || (0, $dvHXN.isPlainObject)(stylesArg)) return (props)=>$81d6846029a0d3b6$var$processStyleArg(stylesArg, (0, $81d6846029a0d3b6$var$_extends2.default)({}, props, {
                    theme: $81d6846029a0d3b6$var$resolveTheme({
                        theme: props.theme,
                        defaultTheme: defaultTheme,
                        themeId: themeId
                    })
                }));
            return stylesArg;
        };
        const muiStyledResolver = (styleArg, ...expressions)=>{
            let transformedStyleArg = transformStyleArg(styleArg);
            const expressionsWithDefaultTheme = expressions ? expressions.map(transformStyleArg) : [];
            if (componentName && overridesResolver) expressionsWithDefaultTheme.push((props)=>{
                const theme = $81d6846029a0d3b6$var$resolveTheme((0, $81d6846029a0d3b6$var$_extends2.default)({}, props, {
                    defaultTheme: defaultTheme,
                    themeId: themeId
                }));
                if (!theme.components || !theme.components[componentName] || !theme.components[componentName].styleOverrides) return null;
                const styleOverrides = theme.components[componentName].styleOverrides;
                const resolvedStyleOverrides = {};
                // TODO: v7 remove iteration and use `resolveStyleArg(styleOverrides[slot])` directly
                Object.entries(styleOverrides).forEach(([slotKey, slotStyle])=>{
                    resolvedStyleOverrides[slotKey] = $81d6846029a0d3b6$var$processStyleArg(slotStyle, (0, $81d6846029a0d3b6$var$_extends2.default)({}, props, {
                        theme: theme
                    }));
                });
                return overridesResolver(props, resolvedStyleOverrides);
            });
            if (componentName && !skipVariantsResolver) expressionsWithDefaultTheme.push((props)=>{
                var _theme$components;
                const theme = $81d6846029a0d3b6$var$resolveTheme((0, $81d6846029a0d3b6$var$_extends2.default)({}, props, {
                    defaultTheme: defaultTheme,
                    themeId: themeId
                }));
                const themeVariants = theme == null || (_theme$components = theme.components) == null || (_theme$components = _theme$components[componentName]) == null ? void 0 : _theme$components.variants;
                return $81d6846029a0d3b6$var$processStyleArg({
                    variants: themeVariants
                }, (0, $81d6846029a0d3b6$var$_extends2.default)({}, props, {
                    theme: theme
                }));
            });
            if (!skipSx) expressionsWithDefaultTheme.push(systemSx);
            const numOfCustomFnsApplied = expressionsWithDefaultTheme.length - expressions.length;
            if (Array.isArray(styleArg) && numOfCustomFnsApplied > 0) {
                const placeholders = new Array(numOfCustomFnsApplied).fill('');
                // If the type is array, than we need to add placeholders in the template for the overrides, variants and the sx styles.
                transformedStyleArg = [
                    ...styleArg,
                    ...placeholders
                ];
                transformedStyleArg.raw = [
                    ...styleArg.raw,
                    ...placeholders
                ];
            }
            const Component = defaultStyledResolver(transformedStyleArg, ...expressionsWithDefaultTheme);
            if (tag.muiName) Component.muiName = tag.muiName;
            return Component;
        };
        if (defaultStyledResolver.withConfig) muiStyledResolver.withConfig = defaultStyledResolver.withConfig;
        return muiStyledResolver;
    };
}

});
parcelRegister("hrFuR", function(module, exports) {
function $cb3525a8cd63543e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
module.exports = $cb3525a8cd63543e$var$_interopRequireDefault, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("iNcPC", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $dae6c1a81faf0750$export$2e2bcd8739ae039; });

var $3vNtX = parcelRequire("3vNtX");
'use client';
const $dae6c1a81faf0750$var$defaultTheme = (0, $3vNtX.default)();
var $dae6c1a81faf0750$export$2e2bcd8739ae039 = $dae6c1a81faf0750$var$defaultTheme;

});
parcelRegister("3vNtX", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $28eaa67b295fc205$export$2e2bcd8739ae039; });

var $3VnFq = parcelRequire("3VnFq");

var $cTAWX = parcelRequire("cTAWX");

var $lqJfJ = parcelRequire("lqJfJ");

var $dvHXN = parcelRequire("dvHXN");

var $k1l9i = parcelRequire("k1l9i");
var $gVCQf = parcelRequire("gVCQf");

var $hvWfk = parcelRequire("hvWfk");


var $cEhRN = parcelRequire("cEhRN");

var $j6JV3 = parcelRequire("j6JV3");

var $erqN8 = parcelRequire("erqN8");

var $gvCbb = parcelRequire("gvCbb");

var $dpLny = parcelRequire("dpLny");

var $2CiDg = parcelRequire("2CiDg");
const $28eaa67b295fc205$var$_excluded = [
    "breakpoints",
    "mixins",
    "spacing",
    "palette",
    "transitions",
    "typography",
    "shape"
];
function $28eaa67b295fc205$var$createTheme(options = {}, ...args) {
    const { mixins: mixinsInput = {}, palette: paletteInput = {}, transitions: transitionsInput = {}, typography: typographyInput = {} } = options, other = (0, $cTAWX.default)(options, $28eaa67b295fc205$var$_excluded);
    if (options.vars && // The error should throw only for the root theme creation because user is not allowed to use a custom node `vars`.
    // `generateCssVars` is the closest identifier for checking that the `options` is a result of `extendTheme` with CSS variables so that user can create new theme for nested ThemeProvider.
    options.generateCssVars === undefined) throw new Error((0, $lqJfJ.default)(18));
    const palette = (0, $j6JV3.default)(paletteInput);
    const systemTheme = (0, $hvWfk.default)(options);
    let muiTheme = (0, $dvHXN.default)(systemTheme, {
        mixins: (0, $cEhRN.default)(systemTheme.breakpoints, mixinsInput),
        palette: palette,
        // Don't use [...shadows] until you've verified its transpiled code is not invoking the iterator protocol.
        shadows: (0, $gvCbb.default).slice(),
        typography: (0, $erqN8.default)(palette, typographyInput),
        transitions: (0, $dpLny.default)(transitionsInput),
        zIndex: (0, $3VnFq.default)({}, (0, $2CiDg.default))
    });
    muiTheme = (0, $dvHXN.default)(muiTheme, other);
    muiTheme = args.reduce((acc, argument)=>(0, $dvHXN.default)(acc, argument), muiTheme);
    var component;
    muiTheme.unstable_sxConfig = (0, $3VnFq.default)({}, (0, $gVCQf.default), other == null ? void 0 : other.unstable_sxConfig);
    muiTheme.unstable_sx = function sx(props) {
        return (0, $k1l9i.default)({
            sx: props,
            theme: this
        });
    };
    return muiTheme;
}
let $28eaa67b295fc205$var$warnedOnce = false;
function $28eaa67b295fc205$export$c469355549431d9b(...args) {
    return $28eaa67b295fc205$var$createTheme(...args);
}
var $28eaa67b295fc205$export$2e2bcd8739ae039 = $28eaa67b295fc205$var$createTheme;

});
parcelRegister("cEhRN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $02605f4bfbb9fee4$export$2e2bcd8739ae039; });

var $3VnFq = parcelRequire("3VnFq");
function $02605f4bfbb9fee4$export$2e2bcd8739ae039(breakpoints, mixins) {
    return (0, $3VnFq.default)({
        toolbar: {
            minHeight: 56,
            [breakpoints.up('xs')]: {
                '@media (orientation: landscape)': {
                    minHeight: 48
                }
            },
            [breakpoints.up('sm')]: {
                minHeight: 64
            }
        }
    }, mixins);
}

});

parcelRegister("j6JV3", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $de92327adf1f6d40$export$2e2bcd8739ae039; });

var $3VnFq = parcelRequire("3VnFq");

var $cTAWX = parcelRequire("cTAWX");

var $lqJfJ = parcelRequire("lqJfJ");

var $dvHXN = parcelRequire("dvHXN");

var $fwsmC = parcelRequire("fwsmC");

var $b558z = parcelRequire("b558z");

var $a5ztd = parcelRequire("a5ztd");

var $5Nipq = parcelRequire("5Nipq");

var $3wf8R = parcelRequire("3wf8R");

var $hd4O0 = parcelRequire("hd4O0");

var $4Ym2o = parcelRequire("4Ym2o");

var $9nAFK = parcelRequire("9nAFK");

var $aZ8CB = parcelRequire("aZ8CB");
const $de92327adf1f6d40$var$_excluded = [
    "mode",
    "contrastThreshold",
    "tonalOffset"
];
const $de92327adf1f6d40$export$a43af521ac8c3202 = {
    // The colors used to style the text.
    text: {
        // The most important text.
        primary: 'rgba(0, 0, 0, 0.87)',
        // Secondary text.
        secondary: 'rgba(0, 0, 0, 0.6)',
        // Disabled text have even lower visual prominence.
        disabled: 'rgba(0, 0, 0, 0.38)'
    },
    // The color used to divide different elements.
    divider: 'rgba(0, 0, 0, 0.12)',
    // The background colors used to style the surfaces.
    // Consistency between these values is important.
    background: {
        paper: (0, $b558z.default).white,
        default: (0, $b558z.default).white
    },
    // The colors used to style the action elements.
    action: {
        // The color of an active action like an icon button.
        active: 'rgba(0, 0, 0, 0.54)',
        // The color of an hovered action.
        hover: 'rgba(0, 0, 0, 0.04)',
        hoverOpacity: 0.04,
        // The color of a selected action.
        selected: 'rgba(0, 0, 0, 0.08)',
        selectedOpacity: 0.08,
        // The color of a disabled action.
        disabled: 'rgba(0, 0, 0, 0.26)',
        // The background color of a disabled action.
        disabledBackground: 'rgba(0, 0, 0, 0.12)',
        disabledOpacity: 0.38,
        focus: 'rgba(0, 0, 0, 0.12)',
        focusOpacity: 0.12,
        activatedOpacity: 0.12
    }
};
const $de92327adf1f6d40$export$55ce6f3a06c59543 = {
    text: {
        primary: (0, $b558z.default).white,
        secondary: 'rgba(255, 255, 255, 0.7)',
        disabled: 'rgba(255, 255, 255, 0.5)',
        icon: 'rgba(255, 255, 255, 0.5)'
    },
    divider: 'rgba(255, 255, 255, 0.12)',
    background: {
        paper: '#121212',
        default: '#121212'
    },
    action: {
        active: (0, $b558z.default).white,
        hover: 'rgba(255, 255, 255, 0.08)',
        hoverOpacity: 0.08,
        selected: 'rgba(255, 255, 255, 0.16)',
        selectedOpacity: 0.16,
        disabled: 'rgba(255, 255, 255, 0.3)',
        disabledBackground: 'rgba(255, 255, 255, 0.12)',
        disabledOpacity: 0.38,
        focus: 'rgba(255, 255, 255, 0.12)',
        focusOpacity: 0.12,
        activatedOpacity: 0.24
    }
};
function $de92327adf1f6d40$var$addLightOrDark(intent, direction, shade, tonalOffset) {
    const tonalOffsetLight = tonalOffset.light || tonalOffset;
    const tonalOffsetDark = tonalOffset.dark || tonalOffset * 1.5;
    if (!intent[direction]) {
        if (intent.hasOwnProperty(shade)) intent[direction] = intent[shade];
        else if (direction === 'light') intent.light = (0, $fwsmC.lighten)(intent.main, tonalOffsetLight);
        else if (direction === 'dark') intent.dark = (0, $fwsmC.darken)(intent.main, tonalOffsetDark);
    }
}
function $de92327adf1f6d40$var$getDefaultPrimary(mode = 'light') {
    if (mode === 'dark') return {
        main: (0, $4Ym2o.default)[200],
        light: (0, $4Ym2o.default)[50],
        dark: (0, $4Ym2o.default)[400]
    };
    return {
        main: (0, $4Ym2o.default)[700],
        light: (0, $4Ym2o.default)[400],
        dark: (0, $4Ym2o.default)[800]
    };
}
function $de92327adf1f6d40$var$getDefaultSecondary(mode = 'light') {
    if (mode === 'dark') return {
        main: (0, $5Nipq.default)[200],
        light: (0, $5Nipq.default)[50],
        dark: (0, $5Nipq.default)[400]
    };
    return {
        main: (0, $5Nipq.default)[500],
        light: (0, $5Nipq.default)[300],
        dark: (0, $5Nipq.default)[700]
    };
}
function $de92327adf1f6d40$var$getDefaultError(mode = 'light') {
    if (mode === 'dark') return {
        main: (0, $3wf8R.default)[500],
        light: (0, $3wf8R.default)[300],
        dark: (0, $3wf8R.default)[700]
    };
    return {
        main: (0, $3wf8R.default)[700],
        light: (0, $3wf8R.default)[400],
        dark: (0, $3wf8R.default)[800]
    };
}
function $de92327adf1f6d40$var$getDefaultInfo(mode = 'light') {
    if (mode === 'dark') return {
        main: (0, $9nAFK.default)[400],
        light: (0, $9nAFK.default)[300],
        dark: (0, $9nAFK.default)[700]
    };
    return {
        main: (0, $9nAFK.default)[700],
        light: (0, $9nAFK.default)[500],
        dark: (0, $9nAFK.default)[900]
    };
}
function $de92327adf1f6d40$var$getDefaultSuccess(mode = 'light') {
    if (mode === 'dark') return {
        main: (0, $aZ8CB.default)[400],
        light: (0, $aZ8CB.default)[300],
        dark: (0, $aZ8CB.default)[700]
    };
    return {
        main: (0, $aZ8CB.default)[800],
        light: (0, $aZ8CB.default)[500],
        dark: (0, $aZ8CB.default)[900]
    };
}
function $de92327adf1f6d40$var$getDefaultWarning(mode = 'light') {
    if (mode === 'dark') return {
        main: (0, $hd4O0.default)[400],
        light: (0, $hd4O0.default)[300],
        dark: (0, $hd4O0.default)[700]
    };
    return {
        main: '#ed6c02',
        // closest to orange[800] that pass 3:1.
        light: (0, $hd4O0.default)[500],
        dark: (0, $hd4O0.default)[900]
    };
}
function $de92327adf1f6d40$export$2e2bcd8739ae039(palette) {
    const { mode: mode = 'light', contrastThreshold: contrastThreshold = 3, tonalOffset: tonalOffset = 0.2 } = palette, other = (0, $cTAWX.default)(palette, $de92327adf1f6d40$var$_excluded);
    const primary = palette.primary || $de92327adf1f6d40$var$getDefaultPrimary(mode);
    const secondary = palette.secondary || $de92327adf1f6d40$var$getDefaultSecondary(mode);
    const error = palette.error || $de92327adf1f6d40$var$getDefaultError(mode);
    const info = palette.info || $de92327adf1f6d40$var$getDefaultInfo(mode);
    const success = palette.success || $de92327adf1f6d40$var$getDefaultSuccess(mode);
    const warning = palette.warning || $de92327adf1f6d40$var$getDefaultWarning(mode);
    // Use the same logic as
    // Bootstrap: https://github.com/twbs/bootstrap/blob/1d6e3710dd447de1a200f29e8fa521f8a0908f70/scss/_functions.scss#L59
    // and material-components-web https://github.com/material-components/material-components-web/blob/ac46b8863c4dab9fc22c4c662dc6bd1b65dd652f/packages/mdc-theme/_functions.scss#L54
    function getContrastText(background) {
        const contrastText = (0, $fwsmC.getContrastRatio)(background, $de92327adf1f6d40$export$55ce6f3a06c59543.text.primary) >= contrastThreshold ? $de92327adf1f6d40$export$55ce6f3a06c59543.text.primary : $de92327adf1f6d40$export$a43af521ac8c3202.text.primary;
        return contrastText;
    }
    const augmentColor = ({ color: color, name: name, mainShade: mainShade = 500, lightShade: lightShade = 300, darkShade: darkShade = 700 })=>{
        color = (0, $3VnFq.default)({}, color);
        if (!color.main && color[mainShade]) color.main = color[mainShade];
        if (!color.hasOwnProperty('main')) throw new Error((0, $lqJfJ.default)(11, name ? ` (${name})` : '', mainShade));
        if (typeof color.main !== 'string') throw new Error((0, $lqJfJ.default)(12, name ? ` (${name})` : '', JSON.stringify(color.main)));
        $de92327adf1f6d40$var$addLightOrDark(color, 'light', lightShade, tonalOffset);
        $de92327adf1f6d40$var$addLightOrDark(color, 'dark', darkShade, tonalOffset);
        if (!color.contrastText) color.contrastText = getContrastText(color.main);
        return color;
    };
    const modes = {
        dark: $de92327adf1f6d40$export$55ce6f3a06c59543,
        light: $de92327adf1f6d40$export$a43af521ac8c3202
    };
    const paletteOutput = (0, $dvHXN.default)((0, $3VnFq.default)({
        // A collection of common colors.
        common: (0, $3VnFq.default)({}, (0, $b558z.default)),
        mode: // prevent mutable object.
        // The palette mode, can be light or dark.
        mode,
        // The colors used to represent primary interface elements for a user.
        primary: augmentColor({
            color: primary,
            name: 'primary'
        }),
        // The colors used to represent secondary interface elements for a user.
        secondary: augmentColor({
            color: secondary,
            name: 'secondary',
            mainShade: 'A400',
            lightShade: 'A200',
            darkShade: 'A700'
        }),
        // The colors used to represent interface elements that the user should be made aware of.
        error: augmentColor({
            color: error,
            name: 'error'
        }),
        // The colors used to represent potentially dangerous actions or important messages.
        warning: augmentColor({
            color: warning,
            name: 'warning'
        }),
        // The colors used to present information to the user that is neutral and not necessarily important.
        info: augmentColor({
            color: info,
            name: 'info'
        }),
        // The colors used to indicate the successful completion of an action that user triggered.
        success: augmentColor({
            color: success,
            name: 'success'
        }),
        grey: // The grey colors.
        $a5ztd.default,
        contrastThreshold: // Used by `getContrastText()` to maximize the contrast between
        // the background and the text.
        contrastThreshold,
        getContrastText: // Takes a background color and returns the text color that maximizes the contrast.
        getContrastText,
        augmentColor: // Generate a rich color object.
        augmentColor,
        tonalOffset: // Used by the functions below to shift a color's luminance by approximately
        // two indexes within its tonal palette.
        // E.g., shift from Red 500 to Red 300 or Red 700.
        tonalOffset
    }, modes[mode]), other);
    return paletteOutput;
}

});
parcelRegister("fwsmC", function(module, exports) {
"use strict";

var $hrFuR = parcelRequire("hrFuR");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.alpha = $b4cfd8a2b82a8490$var$alpha;
module.exports.blend = $b4cfd8a2b82a8490$var$blend;
module.exports.colorChannel = void 0;
module.exports.darken = $b4cfd8a2b82a8490$var$darken;
module.exports.decomposeColor = $b4cfd8a2b82a8490$var$decomposeColor;
module.exports.emphasize = $b4cfd8a2b82a8490$var$emphasize;
module.exports.getContrastRatio = $b4cfd8a2b82a8490$var$getContrastRatio;
module.exports.getLuminance = $b4cfd8a2b82a8490$var$getLuminance;
module.exports.hexToRgb = $b4cfd8a2b82a8490$var$hexToRgb;
module.exports.hslToRgb = $b4cfd8a2b82a8490$var$hslToRgb;
module.exports.lighten = $b4cfd8a2b82a8490$var$lighten;
module.exports.private_safeAlpha = $b4cfd8a2b82a8490$var$private_safeAlpha;
module.exports.private_safeColorChannel = void 0;
module.exports.private_safeDarken = $b4cfd8a2b82a8490$var$private_safeDarken;
module.exports.private_safeEmphasize = $b4cfd8a2b82a8490$var$private_safeEmphasize;
module.exports.private_safeLighten = $b4cfd8a2b82a8490$var$private_safeLighten;
module.exports.recomposeColor = $b4cfd8a2b82a8490$var$recomposeColor;
module.exports.rgbToHex = $b4cfd8a2b82a8490$var$rgbToHex;

var $b4cfd8a2b82a8490$var$_formatMuiErrorMessage2 = $hrFuR((parcelRequire("3ku9g")));

var $b4cfd8a2b82a8490$var$_clamp = $hrFuR((parcelRequire("lqyB7")));
/* eslint-disable @typescript-eslint/naming-convention */ /**
 * Returns a number whose value is limited to the given range.
 * @param {number} value The value to be clamped
 * @param {number} min The lower boundary of the output range
 * @param {number} max The upper boundary of the output range
 * @returns {number} A number in the range [min, max]
 */ function $b4cfd8a2b82a8490$var$clampWrapper(value, min = 0, max = 1) {
    return (0, $b4cfd8a2b82a8490$var$_clamp.default)(value, min, max);
}
/**
 * Converts a color from CSS hex format to CSS rgb format.
 * @param {string} color - Hex color, i.e. #nnn or #nnnnnn
 * @returns {string} A CSS rgb color string
 */ function $b4cfd8a2b82a8490$var$hexToRgb(color) {
    color = color.slice(1);
    const re = new RegExp(`.{1,${color.length >= 6 ? 2 : 1}}`, 'g');
    let colors = color.match(re);
    if (colors && colors[0].length === 1) colors = colors.map((n)=>n + n);
    return colors ? `rgb${colors.length === 4 ? 'a' : ''}(${colors.map((n, index)=>{
        return index < 3 ? parseInt(n, 16) : Math.round(parseInt(n, 16) / 255 * 1000) / 1000;
    }).join(', ')})` : '';
}
function $b4cfd8a2b82a8490$var$intToHex(int) {
    const hex = int.toString(16);
    return hex.length === 1 ? `0${hex}` : hex;
}
/**
 * Returns an object with the type and values of a color.
 *
 * Note: Does not support rgb % values.
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @returns {object} - A MUI color object: {type: string, values: number[]}
 */ function $b4cfd8a2b82a8490$var$decomposeColor(color) {
    // Idempotent
    if (color.type) return color;
    if (color.charAt(0) === '#') return $b4cfd8a2b82a8490$var$decomposeColor($b4cfd8a2b82a8490$var$hexToRgb(color));
    const marker = color.indexOf('(');
    const type = color.substring(0, marker);
    if ([
        'rgb',
        'rgba',
        'hsl',
        'hsla',
        'color'
    ].indexOf(type) === -1) throw new Error((0, $b4cfd8a2b82a8490$var$_formatMuiErrorMessage2.default)(9, color));
    let values = color.substring(marker + 1, color.length - 1);
    let colorSpace;
    if (type === 'color') {
        values = values.split(' ');
        colorSpace = values.shift();
        if (values.length === 4 && values[3].charAt(0) === '/') values[3] = values[3].slice(1);
        if ([
            'srgb',
            'display-p3',
            'a98-rgb',
            'prophoto-rgb',
            'rec-2020'
        ].indexOf(colorSpace) === -1) throw new Error((0, $b4cfd8a2b82a8490$var$_formatMuiErrorMessage2.default)(10, colorSpace));
    } else values = values.split(',');
    values = values.map((value)=>parseFloat(value));
    return {
        type: type,
        values: values,
        colorSpace: colorSpace
    };
}
/**
 * Returns a channel created from the input color.
 *
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @returns {string} - The channel for the color, that can be used in rgba or hsla colors
 */ const $b4cfd8a2b82a8490$var$colorChannel = (color)=>{
    const decomposedColor = $b4cfd8a2b82a8490$var$decomposeColor(color);
    return decomposedColor.values.slice(0, 3).map((val, idx)=>decomposedColor.type.indexOf('hsl') !== -1 && idx !== 0 ? `${val}%` : val).join(' ');
};
module.exports.colorChannel = $b4cfd8a2b82a8490$var$colorChannel;
const $b4cfd8a2b82a8490$var$private_safeColorChannel = (color, warning)=>{
    try {
        return $b4cfd8a2b82a8490$var$colorChannel(color);
    } catch (error) {
        return color;
    }
};
/**
 * Converts a color object with type and values to a string.
 * @param {object} color - Decomposed color
 * @param {string} color.type - One of: 'rgb', 'rgba', 'hsl', 'hsla', 'color'
 * @param {array} color.values - [n,n,n] or [n,n,n,n]
 * @returns {string} A CSS color string
 */ module.exports.private_safeColorChannel = $b4cfd8a2b82a8490$var$private_safeColorChannel;
function $b4cfd8a2b82a8490$var$recomposeColor(color) {
    const { type: type, colorSpace: colorSpace } = color;
    let { values: values } = color;
    if (type.indexOf('rgb') !== -1) // Only convert the first 3 values to int (i.e. not alpha)
    values = values.map((n, i)=>i < 3 ? parseInt(n, 10) : n);
    else if (type.indexOf('hsl') !== -1) {
        values[1] = `${values[1]}%`;
        values[2] = `${values[2]}%`;
    }
    if (type.indexOf('color') !== -1) values = `${colorSpace} ${values.join(' ')}`;
    else values = `${values.join(', ')}`;
    return `${type}(${values})`;
}
/**
 * Converts a color from CSS rgb format to CSS hex format.
 * @param {string} color - RGB color, i.e. rgb(n, n, n)
 * @returns {string} A CSS rgb color string, i.e. #nnnnnn
 */ function $b4cfd8a2b82a8490$var$rgbToHex(color) {
    // Idempotent
    if (color.indexOf('#') === 0) return color;
    const { values: values } = $b4cfd8a2b82a8490$var$decomposeColor(color);
    return `#${values.map((n, i)=>$b4cfd8a2b82a8490$var$intToHex(i === 3 ? Math.round(255 * n) : n)).join('')}`;
}
/**
 * Converts a color from hsl format to rgb format.
 * @param {string} color - HSL color values
 * @returns {string} rgb color values
 */ function $b4cfd8a2b82a8490$var$hslToRgb(color) {
    color = $b4cfd8a2b82a8490$var$decomposeColor(color);
    const { values: values } = color;
    const h = values[0];
    const s = values[1] / 100;
    const l = values[2] / 100;
    const a = s * Math.min(l, 1 - l);
    const f = (n, k = (n + h / 30) % 12)=>l - a * Math.max(Math.min(k - 3, 9 - k, 1), -1);
    let type = 'rgb';
    const rgb = [
        Math.round(f(0) * 255),
        Math.round(f(8) * 255),
        Math.round(f(4) * 255)
    ];
    if (color.type === 'hsla') {
        type += 'a';
        rgb.push(values[3]);
    }
    return $b4cfd8a2b82a8490$var$recomposeColor({
        type: type,
        values: rgb
    });
}
/**
 * The relative brightness of any point in a color space,
 * normalized to 0 for darkest black and 1 for lightest white.
 *
 * Formula: https://www.w3.org/TR/WCAG20-TECHS/G17.html#G17-tests
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @returns {number} The relative brightness of the color in the range 0 - 1
 */ function $b4cfd8a2b82a8490$var$getLuminance(color) {
    color = $b4cfd8a2b82a8490$var$decomposeColor(color);
    let rgb = color.type === 'hsl' || color.type === 'hsla' ? $b4cfd8a2b82a8490$var$decomposeColor($b4cfd8a2b82a8490$var$hslToRgb(color)).values : color.values;
    rgb = rgb.map((val)=>{
        if (color.type !== 'color') val /= 255; // normalized
        return val <= 0.03928 ? val / 12.92 : ((val + 0.055) / 1.055) ** 2.4;
    });
    // Truncate at 3 digits
    return Number((0.2126 * rgb[0] + 0.7152 * rgb[1] + 0.0722 * rgb[2]).toFixed(3));
}
/**
 * Calculates the contrast ratio between two colors.
 *
 * Formula: https://www.w3.org/TR/WCAG20-TECHS/G17.html#G17-tests
 * @param {string} foreground - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @param {string} background - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @returns {number} A contrast ratio value in the range 0 - 21.
 */ function $b4cfd8a2b82a8490$var$getContrastRatio(foreground, background) {
    const lumA = $b4cfd8a2b82a8490$var$getLuminance(foreground);
    const lumB = $b4cfd8a2b82a8490$var$getLuminance(background);
    return (Math.max(lumA, lumB) + 0.05) / (Math.min(lumA, lumB) + 0.05);
}
/**
 * Sets the absolute transparency of a color.
 * Any existing alpha values are overwritten.
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @param {number} value - value to set the alpha channel to in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */ function $b4cfd8a2b82a8490$var$alpha(color, value) {
    color = $b4cfd8a2b82a8490$var$decomposeColor(color);
    value = $b4cfd8a2b82a8490$var$clampWrapper(value);
    if (color.type === 'rgb' || color.type === 'hsl') color.type += 'a';
    if (color.type === 'color') color.values[3] = `/${value}`;
    else color.values[3] = value;
    return $b4cfd8a2b82a8490$var$recomposeColor(color);
}
function $b4cfd8a2b82a8490$var$private_safeAlpha(color, value, warning) {
    try {
        return $b4cfd8a2b82a8490$var$alpha(color, value);
    } catch (error) {
        return color;
    }
}
/**
 * Darkens a color.
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @param {number} coefficient - multiplier in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */ function $b4cfd8a2b82a8490$var$darken(color, coefficient) {
    color = $b4cfd8a2b82a8490$var$decomposeColor(color);
    coefficient = $b4cfd8a2b82a8490$var$clampWrapper(coefficient);
    if (color.type.indexOf('hsl') !== -1) color.values[2] *= 1 - coefficient;
    else if (color.type.indexOf('rgb') !== -1 || color.type.indexOf('color') !== -1) for(let i = 0; i < 3; i += 1)color.values[i] *= 1 - coefficient;
    return $b4cfd8a2b82a8490$var$recomposeColor(color);
}
function $b4cfd8a2b82a8490$var$private_safeDarken(color, coefficient, warning) {
    try {
        return $b4cfd8a2b82a8490$var$darken(color, coefficient);
    } catch (error) {
        return color;
    }
}
/**
 * Lightens a color.
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @param {number} coefficient - multiplier in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */ function $b4cfd8a2b82a8490$var$lighten(color, coefficient) {
    color = $b4cfd8a2b82a8490$var$decomposeColor(color);
    coefficient = $b4cfd8a2b82a8490$var$clampWrapper(coefficient);
    if (color.type.indexOf('hsl') !== -1) color.values[2] += (100 - color.values[2]) * coefficient;
    else if (color.type.indexOf('rgb') !== -1) for(let i = 0; i < 3; i += 1)color.values[i] += (255 - color.values[i]) * coefficient;
    else if (color.type.indexOf('color') !== -1) for(let i = 0; i < 3; i += 1)color.values[i] += (1 - color.values[i]) * coefficient;
    return $b4cfd8a2b82a8490$var$recomposeColor(color);
}
function $b4cfd8a2b82a8490$var$private_safeLighten(color, coefficient, warning) {
    try {
        return $b4cfd8a2b82a8490$var$lighten(color, coefficient);
    } catch (error) {
        return color;
    }
}
/**
 * Darken or lighten a color, depending on its luminance.
 * Light colors are darkened, dark colors are lightened.
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @param {number} coefficient=0.15 - multiplier in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */ function $b4cfd8a2b82a8490$var$emphasize(color, coefficient = 0.15) {
    return $b4cfd8a2b82a8490$var$getLuminance(color) > 0.5 ? $b4cfd8a2b82a8490$var$darken(color, coefficient) : $b4cfd8a2b82a8490$var$lighten(color, coefficient);
}
function $b4cfd8a2b82a8490$var$private_safeEmphasize(color, coefficient, warning) {
    try {
        return $b4cfd8a2b82a8490$var$emphasize(color, coefficient);
    } catch (error) {
        return color;
    }
}
/**
 * Blend a transparent overlay color with a background color, resulting in a single
 * RGB color.
 * @param {string} background - CSS color
 * @param {string} overlay - CSS color
 * @param {number} opacity - Opacity multiplier in the range 0 - 1
 * @param {number} [gamma=1.0] - Gamma correction factor. For gamma-correct blending, 2.2 is usual.
 */ function $b4cfd8a2b82a8490$var$blend(background, overlay, opacity, gamma = 1.0) {
    const blendChannel = (b, o)=>Math.round((b ** (1 / gamma) * (1 - opacity) + o ** (1 / gamma) * opacity) ** gamma);
    const backgroundColor = $b4cfd8a2b82a8490$var$decomposeColor(background);
    const overlayColor = $b4cfd8a2b82a8490$var$decomposeColor(overlay);
    const rgb = [
        blendChannel(backgroundColor.values[0], overlayColor.values[0]),
        blendChannel(backgroundColor.values[1], overlayColor.values[1]),
        blendChannel(backgroundColor.values[2], overlayColor.values[2])
    ];
    return $b4cfd8a2b82a8490$var$recomposeColor({
        type: 'rgb',
        values: rgb
    });
}

});

parcelRegister("b558z", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $81142578aea6fc7f$export$2e2bcd8739ae039; });
const $81142578aea6fc7f$var$common = {
    black: '#000',
    white: '#fff'
};
var $81142578aea6fc7f$export$2e2bcd8739ae039 = $81142578aea6fc7f$var$common;

});

parcelRegister("a5ztd", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7585e2a31f2e10e2$export$2e2bcd8739ae039; });
const $7585e2a31f2e10e2$var$grey = {
    50: '#fafafa',
    100: '#f5f5f5',
    200: '#eeeeee',
    300: '#e0e0e0',
    400: '#bdbdbd',
    500: '#9e9e9e',
    600: '#757575',
    700: '#616161',
    800: '#424242',
    900: '#212121',
    A100: '#f5f5f5',
    A200: '#eeeeee',
    A400: '#bdbdbd',
    A700: '#616161'
};
var $7585e2a31f2e10e2$export$2e2bcd8739ae039 = $7585e2a31f2e10e2$var$grey;

});

parcelRegister("5Nipq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $437fcf03e8d4cb08$export$2e2bcd8739ae039; });
const $437fcf03e8d4cb08$var$purple = {
    50: '#f3e5f5',
    100: '#e1bee7',
    200: '#ce93d8',
    300: '#ba68c8',
    400: '#ab47bc',
    500: '#9c27b0',
    600: '#8e24aa',
    700: '#7b1fa2',
    800: '#6a1b9a',
    900: '#4a148c',
    A100: '#ea80fc',
    A200: '#e040fb',
    A400: '#d500f9',
    A700: '#aa00ff'
};
var $437fcf03e8d4cb08$export$2e2bcd8739ae039 = $437fcf03e8d4cb08$var$purple;

});

parcelRegister("3wf8R", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $29001b2137c56fb3$export$2e2bcd8739ae039; });
const $29001b2137c56fb3$var$red = {
    50: '#ffebee',
    100: '#ffcdd2',
    200: '#ef9a9a',
    300: '#e57373',
    400: '#ef5350',
    500: '#f44336',
    600: '#e53935',
    700: '#d32f2f',
    800: '#c62828',
    900: '#b71c1c',
    A100: '#ff8a80',
    A200: '#ff5252',
    A400: '#ff1744',
    A700: '#d50000'
};
var $29001b2137c56fb3$export$2e2bcd8739ae039 = $29001b2137c56fb3$var$red;

});

parcelRegister("hd4O0", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c87760d98b7bb4e0$export$2e2bcd8739ae039; });
const $c87760d98b7bb4e0$var$orange = {
    50: '#fff3e0',
    100: '#ffe0b2',
    200: '#ffcc80',
    300: '#ffb74d',
    400: '#ffa726',
    500: '#ff9800',
    600: '#fb8c00',
    700: '#f57c00',
    800: '#ef6c00',
    900: '#e65100',
    A100: '#ffd180',
    A200: '#ffab40',
    A400: '#ff9100',
    A700: '#ff6d00'
};
var $c87760d98b7bb4e0$export$2e2bcd8739ae039 = $c87760d98b7bb4e0$var$orange;

});

parcelRegister("4Ym2o", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $39eddc3abcd16f8d$export$2e2bcd8739ae039; });
const $39eddc3abcd16f8d$var$blue = {
    50: '#e3f2fd',
    100: '#bbdefb',
    200: '#90caf9',
    300: '#64b5f6',
    400: '#42a5f5',
    500: '#2196f3',
    600: '#1e88e5',
    700: '#1976d2',
    800: '#1565c0',
    900: '#0d47a1',
    A100: '#82b1ff',
    A200: '#448aff',
    A400: '#2979ff',
    A700: '#2962ff'
};
var $39eddc3abcd16f8d$export$2e2bcd8739ae039 = $39eddc3abcd16f8d$var$blue;

});

parcelRegister("9nAFK", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6d42b56a4e05ef73$export$2e2bcd8739ae039; });
const $6d42b56a4e05ef73$var$lightBlue = {
    50: '#e1f5fe',
    100: '#b3e5fc',
    200: '#81d4fa',
    300: '#4fc3f7',
    400: '#29b6f6',
    500: '#03a9f4',
    600: '#039be5',
    700: '#0288d1',
    800: '#0277bd',
    900: '#01579b',
    A100: '#80d8ff',
    A200: '#40c4ff',
    A400: '#00b0ff',
    A700: '#0091ea'
};
var $6d42b56a4e05ef73$export$2e2bcd8739ae039 = $6d42b56a4e05ef73$var$lightBlue;

});

parcelRegister("aZ8CB", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7ff649f81ef30d45$export$2e2bcd8739ae039; });
const $7ff649f81ef30d45$var$green = {
    50: '#e8f5e9',
    100: '#c8e6c9',
    200: '#a5d6a7',
    300: '#81c784',
    400: '#66bb6a',
    500: '#4caf50',
    600: '#43a047',
    700: '#388e3c',
    800: '#2e7d32',
    900: '#1b5e20',
    A100: '#b9f6ca',
    A200: '#69f0ae',
    A400: '#00e676',
    A700: '#00c853'
};
var $7ff649f81ef30d45$export$2e2bcd8739ae039 = $7ff649f81ef30d45$var$green;

});


parcelRegister("erqN8", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a8385e871ed7230b$export$2e2bcd8739ae039; });

var $3VnFq = parcelRequire("3VnFq");

var $cTAWX = parcelRequire("cTAWX");

var $dvHXN = parcelRequire("dvHXN");
const $a8385e871ed7230b$var$_excluded = [
    "fontFamily",
    "fontSize",
    "fontWeightLight",
    "fontWeightRegular",
    "fontWeightMedium",
    "fontWeightBold",
    "htmlFontSize",
    "allVariants",
    "pxToRem"
];
function $a8385e871ed7230b$var$round(value) {
    return Math.round(value * 1e5) / 1e5;
}
const $a8385e871ed7230b$var$caseAllCaps = {
    textTransform: 'uppercase'
};
const $a8385e871ed7230b$var$defaultFontFamily = '"Roboto", "Helvetica", "Arial", sans-serif';
function $a8385e871ed7230b$export$2e2bcd8739ae039(palette, typography) {
    const _ref = typeof typography === 'function' ? typography(palette) : typography, { fontFamily: fontFamily = $a8385e871ed7230b$var$defaultFontFamily, fontSize: // The default font size of the Material Specification.
    fontSize = 14, fontWeightLight: // px
    fontWeightLight = 300, fontWeightRegular: fontWeightRegular = 400, fontWeightMedium: fontWeightMedium = 500, fontWeightBold: fontWeightBold = 700, htmlFontSize: // Tell MUI what's the font-size on the html element.
    // 16px is the default font-size used by browsers.
    htmlFontSize = 16, allVariants: // Apply the CSS properties to all the variants.
    allVariants, pxToRem: pxToRem2 } = _ref, other = (0, $cTAWX.default)(_ref, $a8385e871ed7230b$var$_excluded);
    const coef = fontSize / 14;
    const pxToRem = pxToRem2 || ((size)=>`${size / htmlFontSize * coef}rem`);
    const buildVariant = (fontWeight, size, lineHeight, letterSpacing, casing)=>(0, $3VnFq.default)({
            fontFamily: fontFamily,
            fontWeight: fontWeight,
            fontSize: pxToRem(size),
            lineHeight: // Unitless following https://meyerweb.com/eric/thoughts/2006/02/08/unitless-line-heights/
            lineHeight
        }, fontFamily === $a8385e871ed7230b$var$defaultFontFamily ? {
            letterSpacing: `${$a8385e871ed7230b$var$round(letterSpacing / size)}em`
        } : {}, casing, allVariants);
    const variants = {
        h1: buildVariant(fontWeightLight, 96, 1.167, -1.5),
        h2: buildVariant(fontWeightLight, 60, 1.2, -0.5),
        h3: buildVariant(fontWeightRegular, 48, 1.167, 0),
        h4: buildVariant(fontWeightRegular, 34, 1.235, 0.25),
        h5: buildVariant(fontWeightRegular, 24, 1.334, 0),
        h6: buildVariant(fontWeightMedium, 20, 1.6, 0.15),
        subtitle1: buildVariant(fontWeightRegular, 16, 1.75, 0.15),
        subtitle2: buildVariant(fontWeightMedium, 14, 1.57, 0.1),
        body1: buildVariant(fontWeightRegular, 16, 1.5, 0.15),
        body2: buildVariant(fontWeightRegular, 14, 1.43, 0.15),
        button: buildVariant(fontWeightMedium, 14, 1.75, 0.4, $a8385e871ed7230b$var$caseAllCaps),
        caption: buildVariant(fontWeightRegular, 12, 1.66, 0.4),
        overline: buildVariant(fontWeightRegular, 12, 2.66, 1, $a8385e871ed7230b$var$caseAllCaps),
        // TODO v6: Remove handling of 'inherit' variant from the theme as it is already handled in Material UI's Typography component. Also, remember to remove the associated types.
        inherit: {
            fontFamily: 'inherit',
            fontWeight: 'inherit',
            fontSize: 'inherit',
            lineHeight: 'inherit',
            letterSpacing: 'inherit'
        }
    };
    return (0, $dvHXN.default)((0, $3VnFq.default)({
        htmlFontSize: htmlFontSize,
        pxToRem: pxToRem,
        fontFamily: fontFamily,
        fontSize: fontSize,
        fontWeightLight: fontWeightLight,
        fontWeightRegular: fontWeightRegular,
        fontWeightMedium: fontWeightMedium,
        fontWeightBold: fontWeightBold
    }, variants), other, {
        clone: false // No need to clone deep
    });
}

});

parcelRegister("gvCbb", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c04d2833ac269ee3$export$2e2bcd8739ae039; });
const $c04d2833ac269ee3$var$shadowKeyUmbraOpacity = 0.2;
const $c04d2833ac269ee3$var$shadowKeyPenumbraOpacity = 0.14;
const $c04d2833ac269ee3$var$shadowAmbientShadowOpacity = 0.12;
function $c04d2833ac269ee3$var$createShadow(...px) {
    return [
        `${px[0]}px ${px[1]}px ${px[2]}px ${px[3]}px rgba(0,0,0,${$c04d2833ac269ee3$var$shadowKeyUmbraOpacity})`,
        `${px[4]}px ${px[5]}px ${px[6]}px ${px[7]}px rgba(0,0,0,${$c04d2833ac269ee3$var$shadowKeyPenumbraOpacity})`,
        `${px[8]}px ${px[9]}px ${px[10]}px ${px[11]}px rgba(0,0,0,${$c04d2833ac269ee3$var$shadowAmbientShadowOpacity})`
    ].join(',');
}
// Values from https://github.com/material-components/material-components-web/blob/be8747f94574669cb5e7add1a7c54fa41a89cec7/packages/mdc-elevation/_variables.scss
const $c04d2833ac269ee3$var$shadows = [
    'none',
    $c04d2833ac269ee3$var$createShadow(0, 2, 1, -1, 0, 1, 1, 0, 0, 1, 3, 0),
    $c04d2833ac269ee3$var$createShadow(0, 3, 1, -2, 0, 2, 2, 0, 0, 1, 5, 0),
    $c04d2833ac269ee3$var$createShadow(0, 3, 3, -2, 0, 3, 4, 0, 0, 1, 8, 0),
    $c04d2833ac269ee3$var$createShadow(0, 2, 4, -1, 0, 4, 5, 0, 0, 1, 10, 0),
    $c04d2833ac269ee3$var$createShadow(0, 3, 5, -1, 0, 5, 8, 0, 0, 1, 14, 0),
    $c04d2833ac269ee3$var$createShadow(0, 3, 5, -1, 0, 6, 10, 0, 0, 1, 18, 0),
    $c04d2833ac269ee3$var$createShadow(0, 4, 5, -2, 0, 7, 10, 1, 0, 2, 16, 1),
    $c04d2833ac269ee3$var$createShadow(0, 5, 5, -3, 0, 8, 10, 1, 0, 3, 14, 2),
    $c04d2833ac269ee3$var$createShadow(0, 5, 6, -3, 0, 9, 12, 1, 0, 3, 16, 2),
    $c04d2833ac269ee3$var$createShadow(0, 6, 6, -3, 0, 10, 14, 1, 0, 4, 18, 3),
    $c04d2833ac269ee3$var$createShadow(0, 6, 7, -4, 0, 11, 15, 1, 0, 4, 20, 3),
    $c04d2833ac269ee3$var$createShadow(0, 7, 8, -4, 0, 12, 17, 2, 0, 5, 22, 4),
    $c04d2833ac269ee3$var$createShadow(0, 7, 8, -4, 0, 13, 19, 2, 0, 5, 24, 4),
    $c04d2833ac269ee3$var$createShadow(0, 7, 9, -4, 0, 14, 21, 2, 0, 5, 26, 4),
    $c04d2833ac269ee3$var$createShadow(0, 8, 9, -5, 0, 15, 22, 2, 0, 6, 28, 5),
    $c04d2833ac269ee3$var$createShadow(0, 8, 10, -5, 0, 16, 24, 2, 0, 6, 30, 5),
    $c04d2833ac269ee3$var$createShadow(0, 8, 11, -5, 0, 17, 26, 2, 0, 6, 32, 5),
    $c04d2833ac269ee3$var$createShadow(0, 9, 11, -5, 0, 18, 28, 2, 0, 7, 34, 6),
    $c04d2833ac269ee3$var$createShadow(0, 9, 12, -6, 0, 19, 29, 2, 0, 7, 36, 6),
    $c04d2833ac269ee3$var$createShadow(0, 10, 13, -6, 0, 20, 31, 3, 0, 8, 38, 7),
    $c04d2833ac269ee3$var$createShadow(0, 10, 13, -6, 0, 21, 33, 3, 0, 8, 40, 7),
    $c04d2833ac269ee3$var$createShadow(0, 10, 14, -6, 0, 22, 35, 3, 0, 8, 42, 7),
    $c04d2833ac269ee3$var$createShadow(0, 11, 14, -7, 0, 23, 36, 3, 0, 9, 44, 8),
    $c04d2833ac269ee3$var$createShadow(0, 11, 15, -7, 0, 24, 38, 3, 0, 9, 46, 8)
];
var $c04d2833ac269ee3$export$2e2bcd8739ae039 = $c04d2833ac269ee3$var$shadows;

});

parcelRegister("dpLny", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9c425ca44f377e2d$export$2e2bcd8739ae039; });

var $cTAWX = parcelRequire("cTAWX");

var $3VnFq = parcelRequire("3VnFq");
const $9c425ca44f377e2d$var$_excluded = [
    "duration",
    "easing",
    "delay"
];
const $9c425ca44f377e2d$export$24c5ac7c37452e7d = {
    // This is the most common easing curve.
    easeInOut: 'cubic-bezier(0.4, 0, 0.2, 1)',
    // Objects enter the screen at full velocity from off-screen and
    // slowly decelerate to a resting point.
    easeOut: 'cubic-bezier(0.0, 0, 0.2, 1)',
    // Objects leave the screen at full velocity. They do not decelerate when off-screen.
    easeIn: 'cubic-bezier(0.4, 0, 1, 1)',
    // The sharp curve is used by objects that may return to the screen at any time.
    sharp: 'cubic-bezier(0.4, 0, 0.6, 1)'
};
const $9c425ca44f377e2d$export$1f34108aa9eb96ab = {
    shortest: 150,
    shorter: 200,
    short: 250,
    // most basic recommended timing
    standard: 300,
    // this is to be used in complex animations
    complex: 375,
    // recommended when something is entering screen
    enteringScreen: 225,
    // recommended when something is leaving screen
    leavingScreen: 195
};
function $9c425ca44f377e2d$var$formatMs(milliseconds) {
    return `${Math.round(milliseconds)}ms`;
}
function $9c425ca44f377e2d$var$getAutoHeightDuration(height) {
    if (!height) return 0;
    const constant = height / 36;
    // https://www.wolframalpha.com/input/?i=(4+%2B+15+*+(x+%2F+36+)+**+0.25+%2B+(x+%2F+36)+%2F+5)+*+10
    return Math.round((4 + 15 * constant ** 0.25 + constant / 5) * 10);
}
function $9c425ca44f377e2d$export$2e2bcd8739ae039(inputTransitions) {
    const mergedEasing = (0, $3VnFq.default)({}, $9c425ca44f377e2d$export$24c5ac7c37452e7d, inputTransitions.easing);
    const mergedDuration = (0, $3VnFq.default)({}, $9c425ca44f377e2d$export$1f34108aa9eb96ab, inputTransitions.duration);
    const create = (props = [
        'all'
    ], options = {})=>{
        const { duration: durationOption = mergedDuration.standard, easing: easingOption = mergedEasing.easeInOut, delay: delay = 0 } = options, other = (0, $cTAWX.default)(options, $9c425ca44f377e2d$var$_excluded);
        return (Array.isArray(props) ? props : [
            props
        ]).map((animatedProp)=>`${animatedProp} ${typeof durationOption === 'string' ? durationOption : $9c425ca44f377e2d$var$formatMs(durationOption)} ${easingOption} ${typeof delay === 'string' ? delay : $9c425ca44f377e2d$var$formatMs(delay)}`).join(',');
    };
    return (0, $3VnFq.default)({
        getAutoHeightDuration: $9c425ca44f377e2d$var$getAutoHeightDuration,
        create: create
    }, inputTransitions, {
        easing: mergedEasing,
        duration: mergedDuration
    });
}

});

parcelRegister("2CiDg", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1e7d955cac2f691e$export$2e2bcd8739ae039; });
// We need to centralize the zIndex definitions as they work
// like global values in the browser.
const $1e7d955cac2f691e$var$zIndex = {
    mobileStepper: 1000,
    fab: 1050,
    speedDial: 1050,
    appBar: 1100,
    drawer: 1200,
    modal: 1300,
    snackbar: 1400,
    tooltip: 1500
};
var $1e7d955cac2f691e$export$2e2bcd8739ae039 = $1e7d955cac2f691e$var$zIndex;

});



parcelRegister("8Ho5h", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6555057e62ac3337$export$2e2bcd8739ae039; });
var $6555057e62ac3337$export$2e2bcd8739ae039 = '$$material';

});

parcelRegister("8ttSm", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $62b834dc7e42d0c0$export$2e2bcd8739ae039; });

var $67P0f = parcelRequire("67P0f");
const $62b834dc7e42d0c0$var$rootShouldForwardProp = (prop)=>(0, $67P0f.default)(prop) && prop !== 'classes';
var $62b834dc7e42d0c0$export$2e2bcd8739ae039 = $62b834dc7e42d0c0$var$rootShouldForwardProp;

});
parcelRegister("67P0f", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $475af5ab4fc240e8$export$2e2bcd8739ae039; });
// copied from @mui/system/createStyled
function $475af5ab4fc240e8$var$slotShouldForwardProp(prop) {
    return prop !== 'ownerState' && prop !== 'theme' && prop !== 'sx' && prop !== 'as';
}
var $475af5ab4fc240e8$export$2e2bcd8739ae039 = $475af5ab4fc240e8$var$slotShouldForwardProp;

});



parcelRegister("28iAq", function(module, exports) {

$parcel$export(module.exports, "getSvgIconUtilityClass", function () { return $18dabf0580d96366$export$c7c50641356bdfa5; });

var $i8nzj = parcelRequire("i8nzj");

var $1kRHf = parcelRequire("1kRHf");
function $18dabf0580d96366$export$c7c50641356bdfa5(slot) {
    return (0, $1kRHf.default)('MuiSvgIcon', slot);
}
const $18dabf0580d96366$var$svgIconClasses = (0, $i8nzj.default)('MuiSvgIcon', [
    'root',
    'colorPrimary',
    'colorSecondary',
    'colorAction',
    'colorError',
    'colorDisabled',
    'fontSizeInherit',
    'fontSizeSmall',
    'fontSizeMedium',
    'fontSizeLarge'
]);
var $18dabf0580d96366$export$2e2bcd8739ae039 = $18dabf0580d96366$var$svgIconClasses;

});
parcelRegister("i8nzj", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d33b4193dc78136c$export$2e2bcd8739ae039; });

var $1kRHf = parcelRequire("1kRHf");
function $d33b4193dc78136c$export$2e2bcd8739ae039(componentName, slots, globalStatePrefix = 'Mui') {
    const result = {};
    slots.forEach((slot)=>{
        result[slot] = (0, $1kRHf.default)(componentName, slot, globalStatePrefix);
    });
    return result;
}

});
parcelRegister("1kRHf", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0f914fb5ef21cabe$export$2e2bcd8739ae039; });

var $56WoG = parcelRequire("56WoG");
const $0f914fb5ef21cabe$export$9d6b9120de57c54 = {
    active: 'active',
    checked: 'checked',
    completed: 'completed',
    disabled: 'disabled',
    error: 'error',
    expanded: 'expanded',
    focused: 'focused',
    focusVisible: 'focusVisible',
    open: 'open',
    readOnly: 'readOnly',
    required: 'required',
    selected: 'selected'
};
function $0f914fb5ef21cabe$export$2e2bcd8739ae039(componentName, slot, globalStatePrefix = 'Mui') {
    const globalStateClass = $0f914fb5ef21cabe$export$9d6b9120de57c54[slot];
    return globalStateClass ? `${globalStatePrefix}-${globalStateClass}` : `${(0, $56WoG.default).generate(componentName)}-${slot}`;
}
function $0f914fb5ef21cabe$export$34c0130b1f3e8ae3(slot) {
    return $0f914fb5ef21cabe$export$9d6b9120de57c54[slot] !== undefined;
}

});
parcelRegister("56WoG", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3b8acfbd5838efa2$export$2e2bcd8739ae039; });
const $3b8acfbd5838efa2$var$defaultGenerator = (componentName)=>componentName;
const $3b8acfbd5838efa2$var$createClassNameGenerator = ()=>{
    let generate = $3b8acfbd5838efa2$var$defaultGenerator;
    return {
        configure (generator) {
            generate = generator;
        },
        generate (componentName) {
            return generate(componentName);
        },
        reset () {
            generate = $3b8acfbd5838efa2$var$defaultGenerator;
        }
    };
};
const $3b8acfbd5838efa2$var$ClassNameGenerator = $3b8acfbd5838efa2$var$createClassNameGenerator();
var $3b8acfbd5838efa2$export$2e2bcd8739ae039 = $3b8acfbd5838efa2$var$ClassNameGenerator;

});







parcelRegister("8xWNp", function(module, exports) {
"use strict";
var $638f03764e88228b$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

const $638f03764e88228b$var$PostgrestQueryBuilder_1 = $638f03764e88228b$var$__importDefault((parcelRequire("cVXnb")));

const $638f03764e88228b$var$PostgrestFilterBuilder_1 = $638f03764e88228b$var$__importDefault((parcelRequire("fXZ9e")));

var $82qXh = parcelRequire("82qXh");
/**
 * PostgREST client.
 *
 * @typeParam Database - Types for the schema from the [type
 * generator](https://supabase.com/docs/reference/javascript/next/typescript-support)
 *
 * @typeParam SchemaName - Postgres schema to switch to. Must be a string
 * literal, the same one passed to the constructor. If the schema is not
 * `"public"`, this must be supplied manually.
 */ class $638f03764e88228b$var$PostgrestClient {
    /**
     * Perform a query on a table or a view.
     *
     * @param relation - The table or view name to query
     */ from(relation) {
        const url = new URL(`${this.url}/${relation}`);
        return new $638f03764e88228b$var$PostgrestQueryBuilder_1.default(url, {
            headers: Object.assign({}, this.headers),
            schema: this.schemaName,
            fetch: this.fetch
        });
    }
    /**
     * Select a schema to query or perform an function (rpc) call.
     *
     * The schema needs to be on the list of exposed schemas inside Supabase.
     *
     * @param schema - The schema to query
     */ schema(schema) {
        return new $638f03764e88228b$var$PostgrestClient(this.url, {
            headers: this.headers,
            schema: schema,
            fetch: this.fetch
        });
    }
    /**
     * Perform a function call.
     *
     * @param fn - The function name to call
     * @param args - The arguments to pass to the function call
     * @param options - Named parameters
     * @param options.head - When set to `true`, `data` will not be returned.
     * Useful if you only need the count.
     * @param options.get - When set to `true`, the function will be called with
     * read-only access mode.
     * @param options.count - Count algorithm to use to count rows returned by the
     * function. Only applicable for [set-returning
     * functions](https://www.postgresql.org/docs/current/functions-srf.html).
     *
     * `"exact"`: Exact but slow count algorithm. Performs a `COUNT(*)` under the
     * hood.
     *
     * `"planned"`: Approximated but fast count algorithm. Uses the Postgres
     * statistics under the hood.
     *
     * `"estimated"`: Uses exact count for low numbers and planned count for high
     * numbers.
     */ rpc(fn, args = {}, { head: head = false, get: get = false, count: count } = {}) {
        let method;
        const url = new URL(`${this.url}/rpc/${fn}`);
        let body;
        if (head || get) {
            method = head ? 'HEAD' : 'GET';
            Object.entries(args)// params with undefined value needs to be filtered out, otherwise it'll
            // show up as `?param=undefined`
            .filter(([_, value])=>value !== undefined)// array values need special syntax
            .map(([name, value])=>[
                    name,
                    Array.isArray(value) ? `{${value.join(',')}}` : `${value}`
                ]).forEach(([name, value])=>{
                url.searchParams.append(name, value);
            });
        } else {
            method = 'POST';
            body = args;
        }
        const headers = Object.assign({}, this.headers);
        if (count) headers['Prefer'] = `count=${count}`;
        return new $638f03764e88228b$var$PostgrestFilterBuilder_1.default({
            method: method,
            url: url,
            headers: headers,
            schema: this.schemaName,
            body: body,
            fetch: this.fetch,
            allowEmpty: false
        });
    }
    // TODO: Add back shouldThrowOnError once we figure out the typings
    /**
     * Creates a PostgREST client.
     *
     * @param url - URL of the PostgREST endpoint
     * @param options - Named parameters
     * @param options.headers - Custom headers
     * @param options.schema - Postgres schema to switch to
     * @param options.fetch - Custom fetch
     */ constructor(url, { headers: headers = {}, schema: schema, fetch: fetch } = {}){
        this.url = url;
        this.headers = Object.assign(Object.assign({}, $82qXh.DEFAULT_HEADERS), headers);
        this.schemaName = schema;
        this.fetch = fetch;
    }
}
module.exports.default = $638f03764e88228b$var$PostgrestClient;

});
parcelRegister("cVXnb", function(module, exports) {
"use strict";
var $96a8dd1f5c390c81$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

const $96a8dd1f5c390c81$var$PostgrestFilterBuilder_1 = $96a8dd1f5c390c81$var$__importDefault((parcelRequire("fXZ9e")));
class $96a8dd1f5c390c81$var$PostgrestQueryBuilder {
    /**
     * Perform a SELECT query on the table or view.
     *
     * @param columns - The columns to retrieve, separated by commas. Columns can be renamed when returned with `customName:columnName`
     *
     * @param options - Named parameters
     *
     * @param options.head - When set to `true`, `data` will not be returned.
     * Useful if you only need the count.
     *
     * @param options.count - Count algorithm to use to count rows in the table or view.
     *
     * `"exact"`: Exact but slow count algorithm. Performs a `COUNT(*)` under the
     * hood.
     *
     * `"planned"`: Approximated but fast count algorithm. Uses the Postgres
     * statistics under the hood.
     *
     * `"estimated"`: Uses exact count for low numbers and planned count for high
     * numbers.
     */ select(columns, { head: head = false, count: count } = {}) {
        const method = head ? 'HEAD' : 'GET';
        // Remove whitespaces except when quoted
        let quoted = false;
        const cleanedColumns = (columns !== null && columns !== void 0 ? columns : '*').split('').map((c)=>{
            if (/\s/.test(c) && !quoted) return '';
            if (c === '"') quoted = !quoted;
            return c;
        }).join('');
        this.url.searchParams.set('select', cleanedColumns);
        if (count) this.headers['Prefer'] = `count=${count}`;
        return new $96a8dd1f5c390c81$var$PostgrestFilterBuilder_1.default({
            method: method,
            url: this.url,
            headers: this.headers,
            schema: this.schema,
            fetch: this.fetch,
            allowEmpty: false
        });
    }
    /**
     * Perform an INSERT into the table or view.
     *
     * By default, inserted rows are not returned. To return it, chain the call
     * with `.select()`.
     *
     * @param values - The values to insert. Pass an object to insert a single row
     * or an array to insert multiple rows.
     *
     * @param options - Named parameters
     *
     * @param options.count - Count algorithm to use to count inserted rows.
     *
     * `"exact"`: Exact but slow count algorithm. Performs a `COUNT(*)` under the
     * hood.
     *
     * `"planned"`: Approximated but fast count algorithm. Uses the Postgres
     * statistics under the hood.
     *
     * `"estimated"`: Uses exact count for low numbers and planned count for high
     * numbers.
     *
     * @param options.defaultToNull - Make missing fields default to `null`.
     * Otherwise, use the default value for the column. Only applies for bulk
     * inserts.
     */ insert(values, { count: count, defaultToNull: defaultToNull = true } = {}) {
        const method = 'POST';
        const prefersHeaders = [];
        if (this.headers['Prefer']) prefersHeaders.push(this.headers['Prefer']);
        if (count) prefersHeaders.push(`count=${count}`);
        if (!defaultToNull) prefersHeaders.push('missing=default');
        this.headers['Prefer'] = prefersHeaders.join(',');
        if (Array.isArray(values)) {
            const columns = values.reduce((acc, x)=>acc.concat(Object.keys(x)), []);
            if (columns.length > 0) {
                const uniqueColumns = [
                    ...new Set(columns)
                ].map((column)=>`"${column}"`);
                this.url.searchParams.set('columns', uniqueColumns.join(','));
            }
        }
        return new $96a8dd1f5c390c81$var$PostgrestFilterBuilder_1.default({
            method: method,
            url: this.url,
            headers: this.headers,
            schema: this.schema,
            body: values,
            fetch: this.fetch,
            allowEmpty: false
        });
    }
    /**
     * Perform an UPSERT on the table or view. Depending on the column(s) passed
     * to `onConflict`, `.upsert()` allows you to perform the equivalent of
     * `.insert()` if a row with the corresponding `onConflict` columns doesn't
     * exist, or if it does exist, perform an alternative action depending on
     * `ignoreDuplicates`.
     *
     * By default, upserted rows are not returned. To return it, chain the call
     * with `.select()`.
     *
     * @param values - The values to upsert with. Pass an object to upsert a
     * single row or an array to upsert multiple rows.
     *
     * @param options - Named parameters
     *
     * @param options.onConflict - Comma-separated UNIQUE column(s) to specify how
     * duplicate rows are determined. Two rows are duplicates if all the
     * `onConflict` columns are equal.
     *
     * @param options.ignoreDuplicates - If `true`, duplicate rows are ignored. If
     * `false`, duplicate rows are merged with existing rows.
     *
     * @param options.count - Count algorithm to use to count upserted rows.
     *
     * `"exact"`: Exact but slow count algorithm. Performs a `COUNT(*)` under the
     * hood.
     *
     * `"planned"`: Approximated but fast count algorithm. Uses the Postgres
     * statistics under the hood.
     *
     * `"estimated"`: Uses exact count for low numbers and planned count for high
     * numbers.
     *
     * @param options.defaultToNull - Make missing fields default to `null`.
     * Otherwise, use the default value for the column. This only applies when
     * inserting new rows, not when merging with existing rows under
     * `ignoreDuplicates: false`. This also only applies when doing bulk upserts.
     */ upsert(values, { onConflict: onConflict, ignoreDuplicates: ignoreDuplicates = false, count: count, defaultToNull: defaultToNull = true } = {}) {
        const method = 'POST';
        const prefersHeaders = [
            `resolution=${ignoreDuplicates ? 'ignore' : 'merge'}-duplicates`
        ];
        if (onConflict !== undefined) this.url.searchParams.set('on_conflict', onConflict);
        if (this.headers['Prefer']) prefersHeaders.push(this.headers['Prefer']);
        if (count) prefersHeaders.push(`count=${count}`);
        if (!defaultToNull) prefersHeaders.push('missing=default');
        this.headers['Prefer'] = prefersHeaders.join(',');
        if (Array.isArray(values)) {
            const columns = values.reduce((acc, x)=>acc.concat(Object.keys(x)), []);
            if (columns.length > 0) {
                const uniqueColumns = [
                    ...new Set(columns)
                ].map((column)=>`"${column}"`);
                this.url.searchParams.set('columns', uniqueColumns.join(','));
            }
        }
        return new $96a8dd1f5c390c81$var$PostgrestFilterBuilder_1.default({
            method: method,
            url: this.url,
            headers: this.headers,
            schema: this.schema,
            body: values,
            fetch: this.fetch,
            allowEmpty: false
        });
    }
    /**
     * Perform an UPDATE on the table or view.
     *
     * By default, updated rows are not returned. To return it, chain the call
     * with `.select()` after filters.
     *
     * @param values - The values to update with
     *
     * @param options - Named parameters
     *
     * @param options.count - Count algorithm to use to count updated rows.
     *
     * `"exact"`: Exact but slow count algorithm. Performs a `COUNT(*)` under the
     * hood.
     *
     * `"planned"`: Approximated but fast count algorithm. Uses the Postgres
     * statistics under the hood.
     *
     * `"estimated"`: Uses exact count for low numbers and planned count for high
     * numbers.
     */ update(values, { count: count } = {}) {
        const method = 'PATCH';
        const prefersHeaders = [];
        if (this.headers['Prefer']) prefersHeaders.push(this.headers['Prefer']);
        if (count) prefersHeaders.push(`count=${count}`);
        this.headers['Prefer'] = prefersHeaders.join(',');
        return new $96a8dd1f5c390c81$var$PostgrestFilterBuilder_1.default({
            method: method,
            url: this.url,
            headers: this.headers,
            schema: this.schema,
            body: values,
            fetch: this.fetch,
            allowEmpty: false
        });
    }
    /**
     * Perform a DELETE on the table or view.
     *
     * By default, deleted rows are not returned. To return it, chain the call
     * with `.select()` after filters.
     *
     * @param options - Named parameters
     *
     * @param options.count - Count algorithm to use to count deleted rows.
     *
     * `"exact"`: Exact but slow count algorithm. Performs a `COUNT(*)` under the
     * hood.
     *
     * `"planned"`: Approximated but fast count algorithm. Uses the Postgres
     * statistics under the hood.
     *
     * `"estimated"`: Uses exact count for low numbers and planned count for high
     * numbers.
     */ delete({ count: count } = {}) {
        const method = 'DELETE';
        const prefersHeaders = [];
        if (count) prefersHeaders.push(`count=${count}`);
        if (this.headers['Prefer']) prefersHeaders.unshift(this.headers['Prefer']);
        this.headers['Prefer'] = prefersHeaders.join(',');
        return new $96a8dd1f5c390c81$var$PostgrestFilterBuilder_1.default({
            method: method,
            url: this.url,
            headers: this.headers,
            schema: this.schema,
            fetch: this.fetch,
            allowEmpty: false
        });
    }
    constructor(url, { headers: headers = {}, schema: schema, fetch: fetch }){
        this.url = url;
        this.headers = headers;
        this.schema = schema;
        this.fetch = fetch;
    }
}
module.exports.default = $96a8dd1f5c390c81$var$PostgrestQueryBuilder;

});
parcelRegister("fXZ9e", function(module, exports) {
"use strict";
var $b9fbcc6bd64097df$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

const $b9fbcc6bd64097df$var$PostgrestTransformBuilder_1 = $b9fbcc6bd64097df$var$__importDefault((parcelRequire("kJn3v")));
class $b9fbcc6bd64097df$var$PostgrestFilterBuilder extends $b9fbcc6bd64097df$var$PostgrestTransformBuilder_1.default {
    /**
     * Match only rows where `column` is equal to `value`.
     *
     * To check if the value of `column` is NULL, you should use `.is()` instead.
     *
     * @param column - The column to filter on
     * @param value - The value to filter with
     */ eq(column, value) {
        this.url.searchParams.append(column, `eq.${value}`);
        return this;
    }
    /**
     * Match only rows where `column` is not equal to `value`.
     *
     * @param column - The column to filter on
     * @param value - The value to filter with
     */ neq(column, value) {
        this.url.searchParams.append(column, `neq.${value}`);
        return this;
    }
    /**
     * Match only rows where `column` is greater than `value`.
     *
     * @param column - The column to filter on
     * @param value - The value to filter with
     */ gt(column, value) {
        this.url.searchParams.append(column, `gt.${value}`);
        return this;
    }
    /**
     * Match only rows where `column` is greater than or equal to `value`.
     *
     * @param column - The column to filter on
     * @param value - The value to filter with
     */ gte(column, value) {
        this.url.searchParams.append(column, `gte.${value}`);
        return this;
    }
    /**
     * Match only rows where `column` is less than `value`.
     *
     * @param column - The column to filter on
     * @param value - The value to filter with
     */ lt(column, value) {
        this.url.searchParams.append(column, `lt.${value}`);
        return this;
    }
    /**
     * Match only rows where `column` is less than or equal to `value`.
     *
     * @param column - The column to filter on
     * @param value - The value to filter with
     */ lte(column, value) {
        this.url.searchParams.append(column, `lte.${value}`);
        return this;
    }
    /**
     * Match only rows where `column` matches `pattern` case-sensitively.
     *
     * @param column - The column to filter on
     * @param pattern - The pattern to match with
     */ like(column, pattern) {
        this.url.searchParams.append(column, `like.${pattern}`);
        return this;
    }
    /**
     * Match only rows where `column` matches all of `patterns` case-sensitively.
     *
     * @param column - The column to filter on
     * @param patterns - The patterns to match with
     */ likeAllOf(column, patterns) {
        this.url.searchParams.append(column, `like(all).{${patterns.join(',')}}`);
        return this;
    }
    /**
     * Match only rows where `column` matches any of `patterns` case-sensitively.
     *
     * @param column - The column to filter on
     * @param patterns - The patterns to match with
     */ likeAnyOf(column, patterns) {
        this.url.searchParams.append(column, `like(any).{${patterns.join(',')}}`);
        return this;
    }
    /**
     * Match only rows where `column` matches `pattern` case-insensitively.
     *
     * @param column - The column to filter on
     * @param pattern - The pattern to match with
     */ ilike(column, pattern) {
        this.url.searchParams.append(column, `ilike.${pattern}`);
        return this;
    }
    /**
     * Match only rows where `column` matches all of `patterns` case-insensitively.
     *
     * @param column - The column to filter on
     * @param patterns - The patterns to match with
     */ ilikeAllOf(column, patterns) {
        this.url.searchParams.append(column, `ilike(all).{${patterns.join(',')}}`);
        return this;
    }
    /**
     * Match only rows where `column` matches any of `patterns` case-insensitively.
     *
     * @param column - The column to filter on
     * @param patterns - The patterns to match with
     */ ilikeAnyOf(column, patterns) {
        this.url.searchParams.append(column, `ilike(any).{${patterns.join(',')}}`);
        return this;
    }
    /**
     * Match only rows where `column` IS `value`.
     *
     * For non-boolean columns, this is only relevant for checking if the value of
     * `column` is NULL by setting `value` to `null`.
     *
     * For boolean columns, you can also set `value` to `true` or `false` and it
     * will behave the same way as `.eq()`.
     *
     * @param column - The column to filter on
     * @param value - The value to filter with
     */ is(column, value) {
        this.url.searchParams.append(column, `is.${value}`);
        return this;
    }
    /**
     * Match only rows where `column` is included in the `values` array.
     *
     * @param column - The column to filter on
     * @param values - The values array to filter with
     */ in(column, values) {
        const cleanedValues = Array.from(new Set(values)).map((s)=>{
            // handle postgrest reserved characters
            // https://postgrest.org/en/v7.0.0/api.html#reserved-characters
            if (typeof s === 'string' && new RegExp('[,()]').test(s)) return `"${s}"`;
            else return `${s}`;
        }).join(',');
        this.url.searchParams.append(column, `in.(${cleanedValues})`);
        return this;
    }
    /**
     * Only relevant for jsonb, array, and range columns. Match only rows where
     * `column` contains every element appearing in `value`.
     *
     * @param column - The jsonb, array, or range column to filter on
     * @param value - The jsonb, array, or range value to filter with
     */ contains(column, value) {
        if (typeof value === 'string') // range types can be inclusive '[', ']' or exclusive '(', ')' so just
        // keep it simple and accept a string
        this.url.searchParams.append(column, `cs.${value}`);
        else if (Array.isArray(value)) // array
        this.url.searchParams.append(column, `cs.{${value.join(',')}}`);
        else // json
        this.url.searchParams.append(column, `cs.${JSON.stringify(value)}`);
        return this;
    }
    /**
     * Only relevant for jsonb, array, and range columns. Match only rows where
     * every element appearing in `column` is contained by `value`.
     *
     * @param column - The jsonb, array, or range column to filter on
     * @param value - The jsonb, array, or range value to filter with
     */ containedBy(column, value) {
        if (typeof value === 'string') // range
        this.url.searchParams.append(column, `cd.${value}`);
        else if (Array.isArray(value)) // array
        this.url.searchParams.append(column, `cd.{${value.join(',')}}`);
        else // json
        this.url.searchParams.append(column, `cd.${JSON.stringify(value)}`);
        return this;
    }
    /**
     * Only relevant for range columns. Match only rows where every element in
     * `column` is greater than any element in `range`.
     *
     * @param column - The range column to filter on
     * @param range - The range to filter with
     */ rangeGt(column, range) {
        this.url.searchParams.append(column, `sr.${range}`);
        return this;
    }
    /**
     * Only relevant for range columns. Match only rows where every element in
     * `column` is either contained in `range` or greater than any element in
     * `range`.
     *
     * @param column - The range column to filter on
     * @param range - The range to filter with
     */ rangeGte(column, range) {
        this.url.searchParams.append(column, `nxl.${range}`);
        return this;
    }
    /**
     * Only relevant for range columns. Match only rows where every element in
     * `column` is less than any element in `range`.
     *
     * @param column - The range column to filter on
     * @param range - The range to filter with
     */ rangeLt(column, range) {
        this.url.searchParams.append(column, `sl.${range}`);
        return this;
    }
    /**
     * Only relevant for range columns. Match only rows where every element in
     * `column` is either contained in `range` or less than any element in
     * `range`.
     *
     * @param column - The range column to filter on
     * @param range - The range to filter with
     */ rangeLte(column, range) {
        this.url.searchParams.append(column, `nxr.${range}`);
        return this;
    }
    /**
     * Only relevant for range columns. Match only rows where `column` is
     * mutually exclusive to `range` and there can be no element between the two
     * ranges.
     *
     * @param column - The range column to filter on
     * @param range - The range to filter with
     */ rangeAdjacent(column, range) {
        this.url.searchParams.append(column, `adj.${range}`);
        return this;
    }
    /**
     * Only relevant for array and range columns. Match only rows where
     * `column` and `value` have an element in common.
     *
     * @param column - The array or range column to filter on
     * @param value - The array or range value to filter with
     */ overlaps(column, value) {
        if (typeof value === 'string') // range
        this.url.searchParams.append(column, `ov.${value}`);
        else // array
        this.url.searchParams.append(column, `ov.{${value.join(',')}}`);
        return this;
    }
    /**
     * Only relevant for text and tsvector columns. Match only rows where
     * `column` matches the query string in `query`.
     *
     * @param column - The text or tsvector column to filter on
     * @param query - The query text to match with
     * @param options - Named parameters
     * @param options.config - The text search configuration to use
     * @param options.type - Change how the `query` text is interpreted
     */ textSearch(column, query, { config: config, type: type } = {}) {
        let typePart = '';
        if (type === 'plain') typePart = 'pl';
        else if (type === 'phrase') typePart = 'ph';
        else if (type === 'websearch') typePart = 'w';
        const configPart = config === undefined ? '' : `(${config})`;
        this.url.searchParams.append(column, `${typePart}fts${configPart}.${query}`);
        return this;
    }
    /**
     * Match only rows where each column in `query` keys is equal to its
     * associated value. Shorthand for multiple `.eq()`s.
     *
     * @param query - The object to filter with, with column names as keys mapped
     * to their filter values
     */ match(query) {
        Object.entries(query).forEach(([column, value])=>{
            this.url.searchParams.append(column, `eq.${value}`);
        });
        return this;
    }
    /**
     * Match only rows which doesn't satisfy the filter.
     *
     * Unlike most filters, `opearator` and `value` are used as-is and need to
     * follow [PostgREST
     * syntax](https://postgrest.org/en/stable/api.html#operators). You also need
     * to make sure they are properly sanitized.
     *
     * @param column - The column to filter on
     * @param operator - The operator to be negated to filter with, following
     * PostgREST syntax
     * @param value - The value to filter with, following PostgREST syntax
     */ not(column, operator, value) {
        this.url.searchParams.append(column, `not.${operator}.${value}`);
        return this;
    }
    /**
     * Match only rows which satisfy at least one of the filters.
     *
     * Unlike most filters, `filters` is used as-is and needs to follow [PostgREST
     * syntax](https://postgrest.org/en/stable/api.html#operators). You also need
     * to make sure it's properly sanitized.
     *
     * It's currently not possible to do an `.or()` filter across multiple tables.
     *
     * @param filters - The filters to use, following PostgREST syntax
     * @param options - Named parameters
     * @param options.referencedTable - Set this to filter on referenced tables
     * instead of the parent table
     * @param options.foreignTable - Deprecated, use `referencedTable` instead
     */ or(filters, { foreignTable: foreignTable, referencedTable: referencedTable = foreignTable } = {}) {
        const key = referencedTable ? `${referencedTable}.or` : 'or';
        this.url.searchParams.append(key, `(${filters})`);
        return this;
    }
    /**
     * Match only rows which satisfy the filter. This is an escape hatch - you
     * should use the specific filter methods wherever possible.
     *
     * Unlike most filters, `opearator` and `value` are used as-is and need to
     * follow [PostgREST
     * syntax](https://postgrest.org/en/stable/api.html#operators). You also need
     * to make sure they are properly sanitized.
     *
     * @param column - The column to filter on
     * @param operator - The operator to filter with, following PostgREST syntax
     * @param value - The value to filter with, following PostgREST syntax
     */ filter(column, operator, value) {
        this.url.searchParams.append(column, `${operator}.${value}`);
        return this;
    }
}
module.exports.default = $b9fbcc6bd64097df$var$PostgrestFilterBuilder;

});
parcelRegister("kJn3v", function(module, exports) {
"use strict";
var $f179e4fb29d2cc86$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

const $f179e4fb29d2cc86$var$PostgrestBuilder_1 = $f179e4fb29d2cc86$var$__importDefault((parcelRequire("4YeQi")));
class $f179e4fb29d2cc86$var$PostgrestTransformBuilder extends $f179e4fb29d2cc86$var$PostgrestBuilder_1.default {
    /**
     * Perform a SELECT on the query result.
     *
     * By default, `.insert()`, `.update()`, `.upsert()`, and `.delete()` do not
     * return modified rows. By calling this method, modified rows are returned in
     * `data`.
     *
     * @param columns - The columns to retrieve, separated by commas
     */ select(columns) {
        // Remove whitespaces except when quoted
        let quoted = false;
        const cleanedColumns = (columns !== null && columns !== void 0 ? columns : '*').split('').map((c)=>{
            if (/\s/.test(c) && !quoted) return '';
            if (c === '"') quoted = !quoted;
            return c;
        }).join('');
        this.url.searchParams.set('select', cleanedColumns);
        if (this.headers['Prefer']) this.headers['Prefer'] += ',';
        this.headers['Prefer'] += 'return=representation';
        return this;
    }
    /**
     * Order the query result by `column`.
     *
     * You can call this method multiple times to order by multiple columns.
     *
     * You can order referenced tables, but it only affects the ordering of the
     * parent table if you use `!inner` in the query.
     *
     * @param column - The column to order by
     * @param options - Named parameters
     * @param options.ascending - If `true`, the result will be in ascending order
     * @param options.nullsFirst - If `true`, `null`s appear first. If `false`,
     * `null`s appear last.
     * @param options.referencedTable - Set this to order a referenced table by
     * its columns
     * @param options.foreignTable - Deprecated, use `options.referencedTable`
     * instead
     */ order(column, { ascending: ascending = true, nullsFirst: nullsFirst, foreignTable: foreignTable, referencedTable: referencedTable = foreignTable } = {}) {
        const key = referencedTable ? `${referencedTable}.order` : 'order';
        const existingOrder = this.url.searchParams.get(key);
        this.url.searchParams.set(key, `${existingOrder ? `${existingOrder},` : ''}${column}.${ascending ? 'asc' : 'desc'}${nullsFirst === undefined ? '' : nullsFirst ? '.nullsfirst' : '.nullslast'}`);
        return this;
    }
    /**
     * Limit the query result by `count`.
     *
     * @param count - The maximum number of rows to return
     * @param options - Named parameters
     * @param options.referencedTable - Set this to limit rows of referenced
     * tables instead of the parent table
     * @param options.foreignTable - Deprecated, use `options.referencedTable`
     * instead
     */ limit(count, { foreignTable: foreignTable, referencedTable: referencedTable = foreignTable } = {}) {
        const key = typeof referencedTable === 'undefined' ? 'limit' : `${referencedTable}.limit`;
        this.url.searchParams.set(key, `${count}`);
        return this;
    }
    /**
     * Limit the query result by starting at an offset `from` and ending at the offset `to`.
     * Only records within this range are returned.
     * This respects the query order and if there is no order clause the range could behave unexpectedly.
     * The `from` and `to` values are 0-based and inclusive: `range(1, 3)` will include the second, third
     * and fourth rows of the query.
     *
     * @param from - The starting index from which to limit the result
     * @param to - The last index to which to limit the result
     * @param options - Named parameters
     * @param options.referencedTable - Set this to limit rows of referenced
     * tables instead of the parent table
     * @param options.foreignTable - Deprecated, use `options.referencedTable`
     * instead
     */ range(from, to, { foreignTable: foreignTable, referencedTable: referencedTable = foreignTable } = {}) {
        const keyOffset = typeof referencedTable === 'undefined' ? 'offset' : `${referencedTable}.offset`;
        const keyLimit = typeof referencedTable === 'undefined' ? 'limit' : `${referencedTable}.limit`;
        this.url.searchParams.set(keyOffset, `${from}`);
        // Range is inclusive, so add 1
        this.url.searchParams.set(keyLimit, `${to - from + 1}`);
        return this;
    }
    /**
     * Set the AbortSignal for the fetch request.
     *
     * @param signal - The AbortSignal to use for the fetch request
     */ abortSignal(signal) {
        this.signal = signal;
        return this;
    }
    /**
     * Return `data` as a single object instead of an array of objects.
     *
     * Query result must be one row (e.g. using `.limit(1)`), otherwise this
     * returns an error.
     */ single() {
        this.headers['Accept'] = 'application/vnd.pgrst.object+json';
        return this;
    }
    /**
     * Return `data` as a single object instead of an array of objects.
     *
     * Query result must be zero or one row (e.g. using `.limit(1)`), otherwise
     * this returns an error.
     */ maybeSingle() {
        // Temporary partial fix for https://github.com/supabase/postgrest-js/issues/361
        // Issue persists e.g. for `.insert([...]).select().maybeSingle()`
        if (this.method === 'GET') this.headers['Accept'] = 'application/json';
        else this.headers['Accept'] = 'application/vnd.pgrst.object+json';
        this.isMaybeSingle = true;
        return this;
    }
    /**
     * Return `data` as a string in CSV format.
     */ csv() {
        this.headers['Accept'] = 'text/csv';
        return this;
    }
    /**
     * Return `data` as an object in [GeoJSON](https://geojson.org) format.
     */ geojson() {
        this.headers['Accept'] = 'application/geo+json';
        return this;
    }
    /**
     * Return `data` as the EXPLAIN plan for the query.
     *
     * You need to enable the
     * [db_plan_enabled](https://supabase.com/docs/guides/database/debugging-performance#enabling-explain)
     * setting before using this method.
     *
     * @param options - Named parameters
     *
     * @param options.analyze - If `true`, the query will be executed and the
     * actual run time will be returned
     *
     * @param options.verbose - If `true`, the query identifier will be returned
     * and `data` will include the output columns of the query
     *
     * @param options.settings - If `true`, include information on configuration
     * parameters that affect query planning
     *
     * @param options.buffers - If `true`, include information on buffer usage
     *
     * @param options.wal - If `true`, include information on WAL record generation
     *
     * @param options.format - The format of the output, can be `"text"` (default)
     * or `"json"`
     */ explain({ analyze: analyze = false, verbose: verbose = false, settings: settings = false, buffers: buffers = false, wal: wal = false, format: format = 'text' } = {}) {
        var _a;
        const options = [
            analyze ? 'analyze' : null,
            verbose ? 'verbose' : null,
            settings ? 'settings' : null,
            buffers ? 'buffers' : null,
            wal ? 'wal' : null
        ].filter(Boolean).join('|');
        // An Accept header can carry multiple media types but postgrest-js always sends one
        const forMediatype = (_a = this.headers['Accept']) !== null && _a !== void 0 ? _a : 'application/json';
        this.headers['Accept'] = `application/vnd.pgrst.plan+${format}; for="${forMediatype}"; options=${options};`;
        if (format === 'json') return this;
        else return this;
    }
    /**
     * Rollback the query.
     *
     * `data` will still be returned, but the query is not committed.
     */ rollback() {
        var _a;
        if (((_a = this.headers['Prefer']) !== null && _a !== void 0 ? _a : '').trim().length > 0) this.headers['Prefer'] += ',tx=rollback';
        else this.headers['Prefer'] = 'tx=rollback';
        return this;
    }
    /**
     * Override the type of the returned `data`.
     *
     * @typeParam NewResult - The new result type to override with
     * @deprecated Use overrideTypes<yourType, { merge: false }>() method at the end of your call chain instead
     */ returns() {
        return this;
    }
}
module.exports.default = $f179e4fb29d2cc86$var$PostgrestTransformBuilder;

});
parcelRegister("4YeQi", function(module, exports) {
"use strict";
var $39e84770b8d97f5f$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

// @ts-ignore
const $39e84770b8d97f5f$var$node_fetch_1 = $39e84770b8d97f5f$var$__importDefault((parcelRequire("ff1Or")));

const $39e84770b8d97f5f$var$PostgrestError_1 = $39e84770b8d97f5f$var$__importDefault((parcelRequire("7LSLT")));
class $39e84770b8d97f5f$var$PostgrestBuilder {
    /**
     * If there's an error with the query, throwOnError will reject the promise by
     * throwing the error instead of returning it as part of a successful response.
     *
     * {@link https://github.com/supabase/supabase-js/issues/92}
     */ throwOnError() {
        this.shouldThrowOnError = true;
        return this;
    }
    /**
     * Set an HTTP header for the request.
     */ setHeader(name, value) {
        this.headers = Object.assign({}, this.headers);
        this.headers[name] = value;
        return this;
    }
    then(onfulfilled, onrejected) {
        // https://postgrest.org/en/stable/api.html#switching-schemas
        if (this.schema === undefined) ;
        else if ([
            'GET',
            'HEAD'
        ].includes(this.method)) this.headers['Accept-Profile'] = this.schema;
        else this.headers['Content-Profile'] = this.schema;
        if (this.method !== 'GET' && this.method !== 'HEAD') this.headers['Content-Type'] = 'application/json';
        // NOTE: Invoke w/o `this` to avoid illegal invocation error.
        // https://github.com/supabase/postgrest-js/pull/247
        const _fetch = this.fetch;
        let res = _fetch(this.url.toString(), {
            method: this.method,
            headers: this.headers,
            body: JSON.stringify(this.body),
            signal: this.signal
        }).then(async (res)=>{
            var _a, _b, _c;
            let error = null;
            let data = null;
            let count = null;
            let status = res.status;
            let statusText = res.statusText;
            if (res.ok) {
                if (this.method !== 'HEAD') {
                    const body = await res.text();
                    if (body === '') ;
                    else if (this.headers['Accept'] === 'text/csv') data = body;
                    else if (this.headers['Accept'] && this.headers['Accept'].includes('application/vnd.pgrst.plan+text')) data = body;
                    else data = JSON.parse(body);
                }
                const countHeader = (_a = this.headers['Prefer']) === null || _a === void 0 ? void 0 : _a.match(/count=(exact|planned|estimated)/);
                const contentRange = (_b = res.headers.get('content-range')) === null || _b === void 0 ? void 0 : _b.split('/');
                if (countHeader && contentRange && contentRange.length > 1) count = parseInt(contentRange[1]);
                // Temporary partial fix for https://github.com/supabase/postgrest-js/issues/361
                // Issue persists e.g. for `.insert([...]).select().maybeSingle()`
                if (this.isMaybeSingle && this.method === 'GET' && Array.isArray(data)) {
                    if (data.length > 1) {
                        error = {
                            // https://github.com/PostgREST/postgrest/blob/a867d79c42419af16c18c3fb019eba8df992626f/src/PostgREST/Error.hs#L553
                            code: 'PGRST116',
                            details: `Results contain ${data.length} rows, application/vnd.pgrst.object+json requires 1 row`,
                            hint: null,
                            message: 'JSON object requested, multiple (or no) rows returned'
                        };
                        data = null;
                        count = null;
                        status = 406;
                        statusText = 'Not Acceptable';
                    } else if (data.length === 1) data = data[0];
                    else data = null;
                }
            } else {
                const body = await res.text();
                try {
                    error = JSON.parse(body);
                    // Workaround for https://github.com/supabase/postgrest-js/issues/295
                    if (Array.isArray(error) && res.status === 404) {
                        data = [];
                        error = null;
                        status = 200;
                        statusText = 'OK';
                    }
                } catch (_d) {
                    // Workaround for https://github.com/supabase/postgrest-js/issues/295
                    if (res.status === 404 && body === '') {
                        status = 204;
                        statusText = 'No Content';
                    } else error = {
                        message: body
                    };
                }
                if (error && this.isMaybeSingle && ((_c = error === null || error === void 0 ? void 0 : error.details) === null || _c === void 0 ? void 0 : _c.includes('0 rows'))) {
                    error = null;
                    status = 200;
                    statusText = 'OK';
                }
                if (error && this.shouldThrowOnError) throw new $39e84770b8d97f5f$var$PostgrestError_1.default(error);
            }
            const postgrestResponse = {
                error: error,
                data: data,
                count: count,
                status: status,
                statusText: statusText
            };
            return postgrestResponse;
        });
        if (!this.shouldThrowOnError) res = res.catch((fetchError)=>{
            var _a, _b, _c;
            return {
                error: {
                    message: `${(_a = fetchError === null || fetchError === void 0 ? void 0 : fetchError.name) !== null && _a !== void 0 ? _a : 'FetchError'}: ${fetchError === null || fetchError === void 0 ? void 0 : fetchError.message}`,
                    details: `${(_b = fetchError === null || fetchError === void 0 ? void 0 : fetchError.stack) !== null && _b !== void 0 ? _b : ''}`,
                    hint: '',
                    code: `${(_c = fetchError === null || fetchError === void 0 ? void 0 : fetchError.code) !== null && _c !== void 0 ? _c : ''}`
                },
                data: null,
                count: null,
                status: 0,
                statusText: ''
            };
        });
        return res.then(onfulfilled, onrejected);
    }
    /**
     * Override the type of the returned `data`.
     *
     * @typeParam NewResult - The new result type to override with
     * @deprecated Use overrideTypes<yourType, { merge: false }>() method at the end of your call chain instead
     */ returns() {
        /* istanbul ignore next */ return this;
    }
    /**
     * Override the type of the returned `data` field in the response.
     *
     * @typeParam NewResult - The new type to cast the response data to
     * @typeParam Options - Optional type configuration (defaults to { merge: true })
     * @typeParam Options.merge - When true, merges the new type with existing return type. When false, replaces the existing types entirely (defaults to true)
     * @example
     * ```typescript
     * // Merge with existing types (default behavior)
     * const query = supabase
     *   .from('users')
     *   .select()
     *   .overrideTypes<{ custom_field: string }>()
     *
     * // Replace existing types completely
     * const replaceQuery = supabase
     *   .from('users')
     *   .select()
     *   .overrideTypes<{ id: number; name: string }, { merge: false }>()
     * ```
     * @returns A PostgrestBuilder instance with the new type
     */ overrideTypes() {
        return this;
    }
    constructor(builder){
        this.shouldThrowOnError = false;
        this.method = builder.method;
        this.url = builder.url;
        this.headers = builder.headers;
        this.schema = builder.schema;
        this.body = builder.body;
        this.shouldThrowOnError = builder.shouldThrowOnError;
        this.signal = builder.signal;
        this.isMaybeSingle = builder.isMaybeSingle;
        if (builder.fetch) this.fetch = builder.fetch;
        else if (typeof fetch === 'undefined') this.fetch = $39e84770b8d97f5f$var$node_fetch_1.default;
        else this.fetch = fetch;
    }
}
module.exports.default = $39e84770b8d97f5f$var$PostgrestBuilder;

});
parcelRegister("ff1Or", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "fetch", function () { return $b189a9aa21066eb7$export$e7aa7bc5c1b3cfb3; });
$parcel$export(module.exports, "default", function () { return $b189a9aa21066eb7$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "Headers", function () { return $b189a9aa21066eb7$export$79b704688b15c0f4; });
$parcel$export(module.exports, "Request", function () { return $b189a9aa21066eb7$export$7fa6c5b6f8193917; });
$parcel$export(module.exports, "Response", function () { return $b189a9aa21066eb7$export$9f633d56d7ec90d3; });
"use strict";
// ref: https://github.com/tc39/proposal-global
var $b189a9aa21066eb7$var$getGlobal = function() {
    // the only reliable means to get the global object is
    // `Function('return this')()`
    // However, this causes CSP violations in Chrome apps.
    if (typeof self !== 'undefined') return self;
    if (typeof window !== 'undefined') return window;
    if (typeof $parcel$global !== 'undefined') return $parcel$global;
    throw new Error('unable to locate global object');
};
var $b189a9aa21066eb7$var$globalObject = $b189a9aa21066eb7$var$getGlobal();
const $b189a9aa21066eb7$export$e7aa7bc5c1b3cfb3 = $b189a9aa21066eb7$var$globalObject.fetch;
var $b189a9aa21066eb7$export$2e2bcd8739ae039 = $b189a9aa21066eb7$var$globalObject.fetch.bind($b189a9aa21066eb7$var$globalObject);
const $b189a9aa21066eb7$export$79b704688b15c0f4 = $b189a9aa21066eb7$var$globalObject.Headers;
const $b189a9aa21066eb7$export$7fa6c5b6f8193917 = $b189a9aa21066eb7$var$globalObject.Request;
const $b189a9aa21066eb7$export$9f633d56d7ec90d3 = $b189a9aa21066eb7$var$globalObject.Response;

});

parcelRegister("7LSLT", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
/**
 * Error format
 *
 * {@link https://postgrest.org/en/stable/api.html?highlight=options#errors-and-http-status-codes}
 */ class $5a8768adce789c5d$var$PostgrestError extends Error {
    constructor(context){
        super(context.message);
        this.name = 'PostgrestError';
        this.details = context.details;
        this.hint = context.hint;
        this.code = context.code;
    }
}
module.exports.default = $5a8768adce789c5d$var$PostgrestError;

});





parcelRegister("82qXh", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DEFAULT_HEADERS = void 0;

var $ie0Yr = parcelRequire("ie0Yr");
module.exports.DEFAULT_HEADERS = {
    'X-Client-Info': `postgrest-js/${$ie0Yr.version}`
};

});
parcelRegister("ie0Yr", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.version = void 0;
module.exports.version = '0.0.0-automated';

});



parcelRegister("jwdj5", function(module, exports) {
module.exports = $parcel$import("i89wO").then(()=>parcelRequire('e0qna'));

});

parcelRegister("5ASxT", function(module, exports) {
/* Mapbox GL JS is Copyright © 2020 Mapbox and subject to the Mapbox Terms of Service ((https://www.mapbox.com/legal/tos/). */ (function(global, factory) {
    module.exports = factory();
})(module.exports, function() {
    'use strict';
    /* eslint-disable */ var shared, worker, mapboxgl;
    // define gets called three times: one for each chunk. we rely on the order
    // they're imported to know which is which
    function define(_, chunk) {
        if (!shared) shared = chunk;
        else if (!worker) worker = chunk;
        else {
            var workerBundleString = "self.onerror = function() { console.error('An error occurred while parsing the WebWorker bundle. This is most likely due to improper transpilation by Babel; please see https://docs.mapbox.com/mapbox-gl-js/guides/install/#transpiling'); }; var sharedChunk = {}; (" + shared + ")(sharedChunk); (" + worker + ")(sharedChunk); self.onerror = null;";
            var sharedChunk = {};
            shared(sharedChunk);
            mapboxgl = chunk(sharedChunk);
            if (typeof window !== 'undefined' && window && window.URL && window.URL.createObjectURL) mapboxgl.workerUrl = window.URL.createObjectURL(new Blob([
                workerBundleString
            ], {
                type: 'text/javascript'
            }));
        }
    }
    define([
        "exports"
    ], function(t1) {
        function e(t1) {
            return t1 && t1.__esModule && Object.prototype.hasOwnProperty.call(t1, "default") ? t1.default : t1;
        }
        var r, n = {}, i = {};
        function a() {
            if (r) return i;
            r = 1, Object.defineProperty(i, "__esModule", {
                value: !0
            }), i.setMatrixArrayType = function(t1) {
                i.ARRAY_TYPE = e = t1;
            }, i.toRadian = function(t1) {
                return t1 * a;
            }, i.equals = function(e, r) {
                return Math.abs(e - r) <= t1 * Math.max(1, Math.abs(e), Math.abs(r));
            }, i.RANDOM = i.ARRAY_TYPE = i.EPSILON = void 0;
            var t1 = 1e-6;
            i.EPSILON = t1;
            var e = "undefined" != typeof Float32Array ? Float32Array : Array;
            i.ARRAY_TYPE = e;
            var n = Math.random;
            i.RANDOM = n;
            var a = Math.PI / 180;
            return Math.hypot || (Math.hypot = function() {
                for(var t1 = 0, e = arguments.length; e--;)t1 += arguments[e] * arguments[e];
                return Math.sqrt(t1);
            }), i;
        }
        var s, o = {};
        function l() {
            if (s) return o;
            function t1(e) {
                return t1 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(t1) {
                    return typeof t1;
                } : function(t1) {
                    return t1 && "function" == typeof Symbol && t1.constructor === Symbol && t1 !== Symbol.prototype ? "symbol" : typeof t1;
                }, t1(e);
            }
            s = 1, Object.defineProperty(o, "__esModule", {
                value: !0
            }), o.create = function() {
                var t1 = new e.ARRAY_TYPE(4);
                return e.ARRAY_TYPE != Float32Array && (t1[1] = 0, t1[2] = 0), t1[0] = 1, t1[3] = 1, t1;
            }, o.clone = function(t1) {
                var r = new e.ARRAY_TYPE(4);
                return r[0] = t1[0], r[1] = t1[1], r[2] = t1[2], r[3] = t1[3], r;
            }, o.copy = function(t1, e) {
                return t1[0] = e[0], t1[1] = e[1], t1[2] = e[2], t1[3] = e[3], t1;
            }, o.identity = function(t1) {
                return t1[0] = 1, t1[1] = 0, t1[2] = 0, t1[3] = 1, t1;
            }, o.fromValues = function(t1, r, n, i) {
                var a = new e.ARRAY_TYPE(4);
                return a[0] = t1, a[1] = r, a[2] = n, a[3] = i, a;
            }, o.set = function(t1, e, r, n, i) {
                return t1[0] = e, t1[1] = r, t1[2] = n, t1[3] = i, t1;
            }, o.transpose = function(t1, e) {
                if (t1 === e) {
                    var r = e[1];
                    t1[1] = e[2], t1[2] = r;
                } else t1[0] = e[0], t1[1] = e[2], t1[2] = e[1], t1[3] = e[3];
                return t1;
            }, o.invert = function(t1, e) {
                var r = e[0], n = e[1], i = e[2], a = e[3], s = r * a - i * n;
                return s ? (t1[0] = a * (s = 1 / s), t1[1] = -n * s, t1[2] = -i * s, t1[3] = r * s, t1) : null;
            }, o.adjoint = function(t1, e) {
                var r = e[0];
                return t1[0] = e[3], t1[1] = -e[1], t1[2] = -e[2], t1[3] = r, t1;
            }, o.determinant = function(t1) {
                return t1[0] * t1[3] - t1[2] * t1[1];
            }, o.multiply = n, o.rotate = function(t1, e, r) {
                var n = e[0], i = e[1], a = e[2], s = e[3], o = Math.sin(r), l = Math.cos(r);
                return t1[0] = n * l + a * o, t1[1] = i * l + s * o, t1[2] = n * -o + a * l, t1[3] = i * -o + s * l, t1;
            }, o.scale = function(t1, e, r) {
                var n = e[1], i = e[2], a = e[3], s = r[0], o = r[1];
                return t1[0] = e[0] * s, t1[1] = n * s, t1[2] = i * o, t1[3] = a * o, t1;
            }, o.fromRotation = function(t1, e) {
                var r = Math.sin(e), n = Math.cos(e);
                return t1[0] = n, t1[1] = r, t1[2] = -r, t1[3] = n, t1;
            }, o.fromScaling = function(t1, e) {
                return t1[0] = e[0], t1[1] = 0, t1[2] = 0, t1[3] = e[1], t1;
            }, o.str = function(t1) {
                return "mat2(" + t1[0] + ", " + t1[1] + ", " + t1[2] + ", " + t1[3] + ")";
            }, o.frob = function(t1) {
                return Math.hypot(t1[0], t1[1], t1[2], t1[3]);
            }, o.LDU = function(t1, e, r, n) {
                return t1[2] = n[2] / n[0], r[0] = n[0], r[1] = n[1], r[3] = n[3] - t1[2] * r[1], [
                    t1,
                    e,
                    r
                ];
            }, o.add = function(t1, e, r) {
                return t1[0] = e[0] + r[0], t1[1] = e[1] + r[1], t1[2] = e[2] + r[2], t1[3] = e[3] + r[3], t1;
            }, o.subtract = i, o.exactEquals = function(t1, e) {
                return t1[0] === e[0] && t1[1] === e[1] && t1[2] === e[2] && t1[3] === e[3];
            }, o.equals = function(t1, r) {
                var n = t1[0], i = t1[1], a = t1[2], s = t1[3], o = r[0], l = r[1], u = r[2], c = r[3];
                return Math.abs(n - o) <= e.EPSILON * Math.max(1, Math.abs(n), Math.abs(o)) && Math.abs(i - l) <= e.EPSILON * Math.max(1, Math.abs(i), Math.abs(l)) && Math.abs(a - u) <= e.EPSILON * Math.max(1, Math.abs(a), Math.abs(u)) && Math.abs(s - c) <= e.EPSILON * Math.max(1, Math.abs(s), Math.abs(c));
            }, o.multiplyScalar = function(t1, e, r) {
                return t1[0] = e[0] * r, t1[1] = e[1] * r, t1[2] = e[2] * r, t1[3] = e[3] * r, t1;
            }, o.multiplyScalarAndAdd = function(t1, e, r, n) {
                return t1[0] = e[0] + r[0] * n, t1[1] = e[1] + r[1] * n, t1[2] = e[2] + r[2] * n, t1[3] = e[3] + r[3] * n, t1;
            }, o.sub = o.mul = void 0;
            var e = function(e, n) {
                if (e && e.__esModule) return e;
                if (null === e || "object" !== t1(e) && "function" != typeof e) return {
                    default: e
                };
                var i = r(void 0);
                if (i && i.has(e)) return i.get(e);
                var a = {}, s = Object.defineProperty && Object.getOwnPropertyDescriptor;
                for(var o in e)if ("default" !== o && Object.prototype.hasOwnProperty.call(e, o)) {
                    var l = s ? Object.getOwnPropertyDescriptor(e, o) : null;
                    l && (l.get || l.set) ? Object.defineProperty(a, o, l) : a[o] = e[o];
                }
                return a.default = e, i && i.set(e, a), a;
            }(a());
            function r(t1) {
                if ("function" != typeof WeakMap) return null;
                var e = new WeakMap, n = new WeakMap;
                return (r = function(t1) {
                    return t1 ? n : e;
                })(t1);
            }
            function n(t1, e, r) {
                var n = e[0], i = e[1], a = e[2], s = e[3], o = r[0], l = r[1], u = r[2], c = r[3];
                return t1[0] = n * o + a * l, t1[1] = i * o + s * l, t1[2] = n * u + a * c, t1[3] = i * u + s * c, t1;
            }
            function i(t1, e, r) {
                return t1[0] = e[0] - r[0], t1[1] = e[1] - r[1], t1[2] = e[2] - r[2], t1[3] = e[3] - r[3], t1;
            }
            return o.mul = n, o.sub = i, o;
        }
        var u, c = {};
        function h() {
            if (u) return c;
            function t1(e) {
                return t1 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(t1) {
                    return typeof t1;
                } : function(t1) {
                    return t1 && "function" == typeof Symbol && t1.constructor === Symbol && t1 !== Symbol.prototype ? "symbol" : typeof t1;
                }, t1(e);
            }
            u = 1, Object.defineProperty(c, "__esModule", {
                value: !0
            }), c.create = function() {
                var t1 = new e.ARRAY_TYPE(6);
                return e.ARRAY_TYPE != Float32Array && (t1[1] = 0, t1[2] = 0, t1[4] = 0, t1[5] = 0), t1[0] = 1, t1[3] = 1, t1;
            }, c.clone = function(t1) {
                var r = new e.ARRAY_TYPE(6);
                return r[0] = t1[0], r[1] = t1[1], r[2] = t1[2], r[3] = t1[3], r[4] = t1[4], r[5] = t1[5], r;
            }, c.copy = function(t1, e) {
                return t1[0] = e[0], t1[1] = e[1], t1[2] = e[2], t1[3] = e[3], t1[4] = e[4], t1[5] = e[5], t1;
            }, c.identity = function(t1) {
                return t1[0] = 1, t1[1] = 0, t1[2] = 0, t1[3] = 1, t1[4] = 0, t1[5] = 0, t1;
            }, c.fromValues = function(t1, r, n, i, a, s) {
                var o = new e.ARRAY_TYPE(6);
                return o[0] = t1, o[1] = r, o[2] = n, o[3] = i, o[4] = a, o[5] = s, o;
            }, c.set = function(t1, e, r, n, i, a, s) {
                return t1[0] = e, t1[1] = r, t1[2] = n, t1[3] = i, t1[4] = a, t1[5] = s, t1;
            }, c.invert = function(t1, e) {
                var r = e[0], n = e[1], i = e[2], a = e[3], s = e[4], o = e[5], l = r * a - n * i;
                return l ? (t1[0] = a * (l = 1 / l), t1[1] = -n * l, t1[2] = -i * l, t1[3] = r * l, t1[4] = (i * o - a * s) * l, t1[5] = (n * s - r * o) * l, t1) : null;
            }, c.determinant = function(t1) {
                return t1[0] * t1[3] - t1[1] * t1[2];
            }, c.multiply = n, c.rotate = function(t1, e, r) {
                var n = e[0], i = e[1], a = e[2], s = e[3], o = e[4], l = e[5], u = Math.sin(r), c = Math.cos(r);
                return t1[0] = n * c + a * u, t1[1] = i * c + s * u, t1[2] = n * -u + a * c, t1[3] = i * -u + s * c, t1[4] = o, t1[5] = l, t1;
            }, c.scale = function(t1, e, r) {
                var n = e[1], i = e[2], a = e[3], s = e[4], o = e[5], l = r[0], u = r[1];
                return t1[0] = e[0] * l, t1[1] = n * l, t1[2] = i * u, t1[3] = a * u, t1[4] = s, t1[5] = o, t1;
            }, c.translate = function(t1, e, r) {
                var n = e[0], i = e[1], a = e[2], s = e[3], o = e[4], l = e[5], u = r[0], c = r[1];
                return t1[0] = n, t1[1] = i, t1[2] = a, t1[3] = s, t1[4] = n * u + a * c + o, t1[5] = i * u + s * c + l, t1;
            }, c.fromRotation = function(t1, e) {
                var r = Math.sin(e), n = Math.cos(e);
                return t1[0] = n, t1[1] = r, t1[2] = -r, t1[3] = n, t1[4] = 0, t1[5] = 0, t1;
            }, c.fromScaling = function(t1, e) {
                return t1[0] = e[0], t1[1] = 0, t1[2] = 0, t1[3] = e[1], t1[4] = 0, t1[5] = 0, t1;
            }, c.fromTranslation = function(t1, e) {
                return t1[0] = 1, t1[1] = 0, t1[2] = 0, t1[3] = 1, t1[4] = e[0], t1[5] = e[1], t1;
            }, c.str = function(t1) {
                return "mat2d(" + t1[0] + ", " + t1[1] + ", " + t1[2] + ", " + t1[3] + ", " + t1[4] + ", " + t1[5] + ")";
            }, c.frob = function(t1) {
                return Math.hypot(t1[0], t1[1], t1[2], t1[3], t1[4], t1[5], 1);
            }, c.add = function(t1, e, r) {
                return t1[0] = e[0] + r[0], t1[1] = e[1] + r[1], t1[2] = e[2] + r[2], t1[3] = e[3] + r[3], t1[4] = e[4] + r[4], t1[5] = e[5] + r[5], t1;
            }, c.subtract = i, c.multiplyScalar = function(t1, e, r) {
                return t1[0] = e[0] * r, t1[1] = e[1] * r, t1[2] = e[2] * r, t1[3] = e[3] * r, t1[4] = e[4] * r, t1[5] = e[5] * r, t1;
            }, c.multiplyScalarAndAdd = function(t1, e, r, n) {
                return t1[0] = e[0] + r[0] * n, t1[1] = e[1] + r[1] * n, t1[2] = e[2] + r[2] * n, t1[3] = e[3] + r[3] * n, t1[4] = e[4] + r[4] * n, t1[5] = e[5] + r[5] * n, t1;
            }, c.exactEquals = function(t1, e) {
                return t1[0] === e[0] && t1[1] === e[1] && t1[2] === e[2] && t1[3] === e[3] && t1[4] === e[4] && t1[5] === e[5];
            }, c.equals = function(t1, r) {
                var n = t1[0], i = t1[1], a = t1[2], s = t1[3], o = t1[4], l = t1[5], u = r[0], c = r[1], h = r[2], p = r[3], f = r[4], d = r[5];
                return Math.abs(n - u) <= e.EPSILON * Math.max(1, Math.abs(n), Math.abs(u)) && Math.abs(i - c) <= e.EPSILON * Math.max(1, Math.abs(i), Math.abs(c)) && Math.abs(a - h) <= e.EPSILON * Math.max(1, Math.abs(a), Math.abs(h)) && Math.abs(s - p) <= e.EPSILON * Math.max(1, Math.abs(s), Math.abs(p)) && Math.abs(o - f) <= e.EPSILON * Math.max(1, Math.abs(o), Math.abs(f)) && Math.abs(l - d) <= e.EPSILON * Math.max(1, Math.abs(l), Math.abs(d));
            }, c.sub = c.mul = void 0;
            var e = function(e, n) {
                if (e && e.__esModule) return e;
                if (null === e || "object" !== t1(e) && "function" != typeof e) return {
                    default: e
                };
                var i = r(void 0);
                if (i && i.has(e)) return i.get(e);
                var a = {}, s = Object.defineProperty && Object.getOwnPropertyDescriptor;
                for(var o in e)if ("default" !== o && Object.prototype.hasOwnProperty.call(e, o)) {
                    var l = s ? Object.getOwnPropertyDescriptor(e, o) : null;
                    l && (l.get || l.set) ? Object.defineProperty(a, o, l) : a[o] = e[o];
                }
                return a.default = e, i && i.set(e, a), a;
            }(a());
            function r(t1) {
                if ("function" != typeof WeakMap) return null;
                var e = new WeakMap, n = new WeakMap;
                return (r = function(t1) {
                    return t1 ? n : e;
                })(t1);
            }
            function n(t1, e, r) {
                var n = e[0], i = e[1], a = e[2], s = e[3], o = e[4], l = e[5], u = r[0], c = r[1], h = r[2], p = r[3], f = r[4], d = r[5];
                return t1[0] = n * u + a * c, t1[1] = i * u + s * c, t1[2] = n * h + a * p, t1[3] = i * h + s * p, t1[4] = n * f + a * d + o, t1[5] = i * f + s * d + l, t1;
            }
            function i(t1, e, r) {
                return t1[0] = e[0] - r[0], t1[1] = e[1] - r[1], t1[2] = e[2] - r[2], t1[3] = e[3] - r[3], t1[4] = e[4] - r[4], t1[5] = e[5] - r[5], t1;
            }
            return c.mul = n, c.sub = i, c;
        }
        var p, f = {};
        function d() {
            if (p) return f;
            function t1(e) {
                return t1 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(t1) {
                    return typeof t1;
                } : function(t1) {
                    return t1 && "function" == typeof Symbol && t1.constructor === Symbol && t1 !== Symbol.prototype ? "symbol" : typeof t1;
                }, t1(e);
            }
            p = 1, Object.defineProperty(f, "__esModule", {
                value: !0
            }), f.create = function() {
                var t1 = new e.ARRAY_TYPE(9);
                return e.ARRAY_TYPE != Float32Array && (t1[1] = 0, t1[2] = 0, t1[3] = 0, t1[5] = 0, t1[6] = 0, t1[7] = 0), t1[0] = 1, t1[4] = 1, t1[8] = 1, t1;
            }, f.fromMat4 = function(t1, e) {
                return t1[0] = e[0], t1[1] = e[1], t1[2] = e[2], t1[3] = e[4], t1[4] = e[5], t1[5] = e[6], t1[6] = e[8], t1[7] = e[9], t1[8] = e[10], t1;
            }, f.clone = function(t1) {
                var r = new e.ARRAY_TYPE(9);
                return r[0] = t1[0], r[1] = t1[1], r[2] = t1[2], r[3] = t1[3], r[4] = t1[4], r[5] = t1[5], r[6] = t1[6], r[7] = t1[7], r[8] = t1[8], r;
            }, f.copy = function(t1, e) {
                return t1[0] = e[0], t1[1] = e[1], t1[2] = e[2], t1[3] = e[3], t1[4] = e[4], t1[5] = e[5], t1[6] = e[6], t1[7] = e[7], t1[8] = e[8], t1;
            }, f.fromValues = function(t1, r, n, i, a, s, o, l, u) {
                var c = new e.ARRAY_TYPE(9);
                return c[0] = t1, c[1] = r, c[2] = n, c[3] = i, c[4] = a, c[5] = s, c[6] = o, c[7] = l, c[8] = u, c;
            }, f.set = function(t1, e, r, n, i, a, s, o, l, u) {
                return t1[0] = e, t1[1] = r, t1[2] = n, t1[3] = i, t1[4] = a, t1[5] = s, t1[6] = o, t1[7] = l, t1[8] = u, t1;
            }, f.identity = function(t1) {
                return t1[0] = 1, t1[1] = 0, t1[2] = 0, t1[3] = 0, t1[4] = 1, t1[5] = 0, t1[6] = 0, t1[7] = 0, t1[8] = 1, t1;
            }, f.transpose = function(t1, e) {
                if (t1 === e) {
                    var r = e[1], n = e[2], i = e[5];
                    t1[1] = e[3], t1[2] = e[6], t1[3] = r, t1[5] = e[7], t1[6] = n, t1[7] = i;
                } else t1[0] = e[0], t1[1] = e[3], t1[2] = e[6], t1[3] = e[1], t1[4] = e[4], t1[5] = e[7], t1[6] = e[2], t1[7] = e[5], t1[8] = e[8];
                return t1;
            }, f.invert = function(t1, e) {
                var r = e[0], n = e[1], i = e[2], a = e[3], s = e[4], o = e[5], l = e[6], u = e[7], c = e[8], h = c * s - o * u, p = -c * a + o * l, f = u * a - s * l, d = r * h + n * p + i * f;
                return d ? (t1[0] = h * (d = 1 / d), t1[1] = (-c * n + i * u) * d, t1[2] = (o * n - i * s) * d, t1[3] = p * d, t1[4] = (c * r - i * l) * d, t1[5] = (-o * r + i * a) * d, t1[6] = f * d, t1[7] = (-u * r + n * l) * d, t1[8] = (s * r - n * a) * d, t1) : null;
            }, f.adjoint = function(t1, e) {
                var r = e[0], n = e[1], i = e[2], a = e[3], s = e[4], o = e[5], l = e[6], u = e[7], c = e[8];
                return t1[0] = s * c - o * u, t1[1] = i * u - n * c, t1[2] = n * o - i * s, t1[3] = o * l - a * c, t1[4] = r * c - i * l, t1[5] = i * a - r * o, t1[6] = a * u - s * l, t1[7] = n * l - r * u, t1[8] = r * s - n * a, t1;
            }, f.determinant = function(t1) {
                var e = t1[3], r = t1[4], n = t1[5], i = t1[6], a = t1[7], s = t1[8];
                return t1[0] * (s * r - n * a) + t1[1] * (-s * e + n * i) + t1[2] * (a * e - r * i);
            }, f.multiply = n, f.translate = function(t1, e, r) {
                var n = e[0], i = e[1], a = e[2], s = e[3], o = e[4], l = e[5], u = e[6], c = e[7], h = e[8], p = r[0], f = r[1];
                return t1[0] = n, t1[1] = i, t1[2] = a, t1[3] = s, t1[4] = o, t1[5] = l, t1[6] = p * n + f * s + u, t1[7] = p * i + f * o + c, t1[8] = p * a + f * l + h, t1;
            }, f.rotate = function(t1, e, r) {
                var n = e[0], i = e[1], a = e[2], s = e[3], o = e[4], l = e[5], u = e[6], c = e[7], h = e[8], p = Math.sin(r), f = Math.cos(r);
                return t1[0] = f * n + p * s, t1[1] = f * i + p * o, t1[2] = f * a + p * l, t1[3] = f * s - p * n, t1[4] = f * o - p * i, t1[5] = f * l - p * a, t1[6] = u, t1[7] = c, t1[8] = h, t1;
            }, f.scale = function(t1, e, r) {
                var n = r[0], i = r[1];
                return t1[0] = n * e[0], t1[1] = n * e[1], t1[2] = n * e[2], t1[3] = i * e[3], t1[4] = i * e[4], t1[5] = i * e[5], t1[6] = e[6], t1[7] = e[7], t1[8] = e[8], t1;
            }, f.fromTranslation = function(t1, e) {
                return t1[0] = 1, t1[1] = 0, t1[2] = 0, t1[3] = 0, t1[4] = 1, t1[5] = 0, t1[6] = e[0], t1[7] = e[1], t1[8] = 1, t1;
            }, f.fromRotation = function(t1, e) {
                var r = Math.sin(e), n = Math.cos(e);
                return t1[0] = n, t1[1] = r, t1[2] = 0, t1[3] = -r, t1[4] = n, t1[5] = 0, t1[6] = 0, t1[7] = 0, t1[8] = 1, t1;
            }, f.fromScaling = function(t1, e) {
                return t1[0] = e[0], t1[1] = 0, t1[2] = 0, t1[3] = 0, t1[4] = e[1], t1[5] = 0, t1[6] = 0, t1[7] = 0, t1[8] = 1, t1;
            }, f.fromMat2d = function(t1, e) {
                return t1[0] = e[0], t1[1] = e[1], t1[2] = 0, t1[3] = e[2], t1[4] = e[3], t1[5] = 0, t1[6] = e[4], t1[7] = e[5], t1[8] = 1, t1;
            }, f.fromQuat = function(t1, e) {
                var r = e[0], n = e[1], i = e[2], a = e[3], s = r + r, o = n + n, l = i + i, u = r * s, c = n * s, h = n * o, p = i * s, f = i * o, d = i * l, m = a * s, y = a * o, g = a * l;
                return t1[0] = 1 - h - d, t1[3] = c - g, t1[6] = p + y, t1[1] = c + g, t1[4] = 1 - u - d, t1[7] = f - m, t1[2] = p - y, t1[5] = f + m, t1[8] = 1 - u - h, t1;
            }, f.normalFromMat4 = function(t1, e) {
                var r = e[0], n = e[1], i = e[2], a = e[3], s = e[4], o = e[5], l = e[6], u = e[7], c = e[8], h = e[9], p = e[10], f = e[11], d = e[12], m = e[13], y = e[14], g = e[15], x = r * o - n * s, v = r * l - i * s, b = r * u - a * s, _ = n * l - i * o, w = n * u - a * o, M = i * u - a * l, A = c * m - h * d, S = c * y - p * d, I = c * g - f * d, P = h * y - p * m, z = h * g - f * m, E = p * g - f * y, k = x * E - v * z + b * P + _ * I - w * S + M * A;
                return k ? (t1[0] = (o * E - l * z + u * P) * (k = 1 / k), t1[1] = (l * I - s * E - u * S) * k, t1[2] = (s * z - o * I + u * A) * k, t1[3] = (i * z - n * E - a * P) * k, t1[4] = (r * E - i * I + a * S) * k, t1[5] = (n * I - r * z - a * A) * k, t1[6] = (m * M - y * w + g * _) * k, t1[7] = (y * b - d * M - g * v) * k, t1[8] = (d * w - m * b + g * x) * k, t1) : null;
            }, f.projection = function(t1, e, r) {
                return t1[0] = 2 / e, t1[1] = 0, t1[2] = 0, t1[3] = 0, t1[4] = -2 / r, t1[5] = 0, t1[6] = -1, t1[7] = 1, t1[8] = 1, t1;
            }, f.str = function(t1) {
                return "mat3(" + t1[0] + ", " + t1[1] + ", " + t1[2] + ", " + t1[3] + ", " + t1[4] + ", " + t1[5] + ", " + t1[6] + ", " + t1[7] + ", " + t1[8] + ")";
            }, f.frob = function(t1) {
                return Math.hypot(t1[0], t1[1], t1[2], t1[3], t1[4], t1[5], t1[6], t1[7], t1[8]);
            }, f.add = function(t1, e, r) {
                return t1[0] = e[0] + r[0], t1[1] = e[1] + r[1], t1[2] = e[2] + r[2], t1[3] = e[3] + r[3], t1[4] = e[4] + r[4], t1[5] = e[5] + r[5], t1[6] = e[6] + r[6], t1[7] = e[7] + r[7], t1[8] = e[8] + r[8], t1;
            }, f.subtract = i, f.multiplyScalar = function(t1, e, r) {
                return t1[0] = e[0] * r, t1[1] = e[1] * r, t1[2] = e[2] * r, t1[3] = e[3] * r, t1[4] = e[4] * r, t1[5] = e[5] * r, t1[6] = e[6] * r, t1[7] = e[7] * r, t1[8] = e[8] * r, t1;
            }, f.multiplyScalarAndAdd = function(t1, e, r, n) {
                return t1[0] = e[0] + r[0] * n, t1[1] = e[1] + r[1] * n, t1[2] = e[2] + r[2] * n, t1[3] = e[3] + r[3] * n, t1[4] = e[4] + r[4] * n, t1[5] = e[5] + r[5] * n, t1[6] = e[6] + r[6] * n, t1[7] = e[7] + r[7] * n, t1[8] = e[8] + r[8] * n, t1;
            }, f.exactEquals = function(t1, e) {
                return t1[0] === e[0] && t1[1] === e[1] && t1[2] === e[2] && t1[3] === e[3] && t1[4] === e[4] && t1[5] === e[5] && t1[6] === e[6] && t1[7] === e[7] && t1[8] === e[8];
            }, f.equals = function(t1, r) {
                var n = t1[0], i = t1[1], a = t1[2], s = t1[3], o = t1[4], l = t1[5], u = t1[6], c = t1[7], h = t1[8], p = r[0], f = r[1], d = r[2], m = r[3], y = r[4], g = r[5], x = r[6], v = r[7], b = r[8];
                return Math.abs(n - p) <= e.EPSILON * Math.max(1, Math.abs(n), Math.abs(p)) && Math.abs(i - f) <= e.EPSILON * Math.max(1, Math.abs(i), Math.abs(f)) && Math.abs(a - d) <= e.EPSILON * Math.max(1, Math.abs(a), Math.abs(d)) && Math.abs(s - m) <= e.EPSILON * Math.max(1, Math.abs(s), Math.abs(m)) && Math.abs(o - y) <= e.EPSILON * Math.max(1, Math.abs(o), Math.abs(y)) && Math.abs(l - g) <= e.EPSILON * Math.max(1, Math.abs(l), Math.abs(g)) && Math.abs(u - x) <= e.EPSILON * Math.max(1, Math.abs(u), Math.abs(x)) && Math.abs(c - v) <= e.EPSILON * Math.max(1, Math.abs(c), Math.abs(v)) && Math.abs(h - b) <= e.EPSILON * Math.max(1, Math.abs(h), Math.abs(b));
            }, f.sub = f.mul = void 0;
            var e = function(e, n) {
                if (e && e.__esModule) return e;
                if (null === e || "object" !== t1(e) && "function" != typeof e) return {
                    default: e
                };
                var i = r(void 0);
                if (i && i.has(e)) return i.get(e);
                var a = {}, s = Object.defineProperty && Object.getOwnPropertyDescriptor;
                for(var o in e)if ("default" !== o && Object.prototype.hasOwnProperty.call(e, o)) {
                    var l = s ? Object.getOwnPropertyDescriptor(e, o) : null;
                    l && (l.get || l.set) ? Object.defineProperty(a, o, l) : a[o] = e[o];
                }
                return a.default = e, i && i.set(e, a), a;
            }(a());
            function r(t1) {
                if ("function" != typeof WeakMap) return null;
                var e = new WeakMap, n = new WeakMap;
                return (r = function(t1) {
                    return t1 ? n : e;
                })(t1);
            }
            function n(t1, e, r) {
                var n = e[0], i = e[1], a = e[2], s = e[3], o = e[4], l = e[5], u = e[6], c = e[7], h = e[8], p = r[0], f = r[1], d = r[2], m = r[3], y = r[4], g = r[5], x = r[6], v = r[7], b = r[8];
                return t1[0] = p * n + f * s + d * u, t1[1] = p * i + f * o + d * c, t1[2] = p * a + f * l + d * h, t1[3] = m * n + y * s + g * u, t1[4] = m * i + y * o + g * c, t1[5] = m * a + y * l + g * h, t1[6] = x * n + v * s + b * u, t1[7] = x * i + v * o + b * c, t1[8] = x * a + v * l + b * h, t1;
            }
            function i(t1, e, r) {
                return t1[0] = e[0] - r[0], t1[1] = e[1] - r[1], t1[2] = e[2] - r[2], t1[3] = e[3] - r[3], t1[4] = e[4] - r[4], t1[5] = e[5] - r[5], t1[6] = e[6] - r[6], t1[7] = e[7] - r[7], t1[8] = e[8] - r[8], t1;
            }
            return f.mul = n, f.sub = i, f;
        }
        var m, y = {};
        function g() {
            if (m) return y;
            function t1(e) {
                return t1 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(t1) {
                    return typeof t1;
                } : function(t1) {
                    return t1 && "function" == typeof Symbol && t1.constructor === Symbol && t1 !== Symbol.prototype ? "symbol" : typeof t1;
                }, t1(e);
            }
            m = 1, Object.defineProperty(y, "__esModule", {
                value: !0
            }), y.create = function() {
                var t1 = new e.ARRAY_TYPE(16);
                return e.ARRAY_TYPE != Float32Array && (t1[1] = 0, t1[2] = 0, t1[3] = 0, t1[4] = 0, t1[6] = 0, t1[7] = 0, t1[8] = 0, t1[9] = 0, t1[11] = 0, t1[12] = 0, t1[13] = 0, t1[14] = 0), t1[0] = 1, t1[5] = 1, t1[10] = 1, t1[15] = 1, t1;
            }, y.clone = function(t1) {
                var r = new e.ARRAY_TYPE(16);
                return r[0] = t1[0], r[1] = t1[1], r[2] = t1[2], r[3] = t1[3], r[4] = t1[4], r[5] = t1[5], r[6] = t1[6], r[7] = t1[7], r[8] = t1[8], r[9] = t1[9], r[10] = t1[10], r[11] = t1[11], r[12] = t1[12], r[13] = t1[13], r[14] = t1[14], r[15] = t1[15], r;
            }, y.copy = function(t1, e) {
                return t1[0] = e[0], t1[1] = e[1], t1[2] = e[2], t1[3] = e[3], t1[4] = e[4], t1[5] = e[5], t1[6] = e[6], t1[7] = e[7], t1[8] = e[8], t1[9] = e[9], t1[10] = e[10], t1[11] = e[11], t1[12] = e[12], t1[13] = e[13], t1[14] = e[14], t1[15] = e[15], t1;
            }, y.fromValues = function(t1, r, n, i, a, s, o, l, u, c, h, p, f, d, m, y) {
                var g = new e.ARRAY_TYPE(16);
                return g[0] = t1, g[1] = r, g[2] = n, g[3] = i, g[4] = a, g[5] = s, g[6] = o, g[7] = l, g[8] = u, g[9] = c, g[10] = h, g[11] = p, g[12] = f, g[13] = d, g[14] = m, g[15] = y, g;
            }, y.set = function(t1, e, r, n, i, a, s, o, l, u, c, h, p, f, d, m, y) {
                return t1[0] = e, t1[1] = r, t1[2] = n, t1[3] = i, t1[4] = a, t1[5] = s, t1[6] = o, t1[7] = l, t1[8] = u, t1[9] = c, t1[10] = h, t1[11] = p, t1[12] = f, t1[13] = d, t1[14] = m, t1[15] = y, t1;
            }, y.identity = n, y.transpose = function(t1, e) {
                if (t1 === e) {
                    var r = e[1], n = e[2], i = e[3], a = e[6], s = e[7], o = e[11];
                    t1[1] = e[4], t1[2] = e[8], t1[3] = e[12], t1[4] = r, t1[6] = e[9], t1[7] = e[13], t1[8] = n, t1[9] = a, t1[11] = e[14], t1[12] = i, t1[13] = s, t1[14] = o;
                } else t1[0] = e[0], t1[1] = e[4], t1[2] = e[8], t1[3] = e[12], t1[4] = e[1], t1[5] = e[5], t1[6] = e[9], t1[7] = e[13], t1[8] = e[2], t1[9] = e[6], t1[10] = e[10], t1[11] = e[14], t1[12] = e[3], t1[13] = e[7], t1[14] = e[11], t1[15] = e[15];
                return t1;
            }, y.invert = function(t1, e) {
                var r = e[0], n = e[1], i = e[2], a = e[3], s = e[4], o = e[5], l = e[6], u = e[7], c = e[8], h = e[9], p = e[10], f = e[11], d = e[12], m = e[13], y = e[14], g = e[15], x = r * o - n * s, v = r * l - i * s, b = r * u - a * s, _ = n * l - i * o, w = n * u - a * o, M = i * u - a * l, A = c * m - h * d, S = c * y - p * d, I = c * g - f * d, P = h * y - p * m, z = h * g - f * m, E = p * g - f * y, k = x * E - v * z + b * P + _ * I - w * S + M * A;
                return k ? (t1[0] = (o * E - l * z + u * P) * (k = 1 / k), t1[1] = (i * z - n * E - a * P) * k, t1[2] = (m * M - y * w + g * _) * k, t1[3] = (p * w - h * M - f * _) * k, t1[4] = (l * I - s * E - u * S) * k, t1[5] = (r * E - i * I + a * S) * k, t1[6] = (y * b - d * M - g * v) * k, t1[7] = (c * M - p * b + f * v) * k, t1[8] = (s * z - o * I + u * A) * k, t1[9] = (n * I - r * z - a * A) * k, t1[10] = (d * w - m * b + g * x) * k, t1[11] = (h * b - c * w - f * x) * k, t1[12] = (o * S - s * P - l * A) * k, t1[13] = (r * P - n * S + i * A) * k, t1[14] = (m * v - d * _ - y * x) * k, t1[15] = (c * _ - h * v + p * x) * k, t1) : null;
            }, y.adjoint = function(t1, e) {
                var r = e[0], n = e[1], i = e[2], a = e[3], s = e[4], o = e[5], l = e[6], u = e[7], c = e[8], h = e[9], p = e[10], f = e[11], d = e[12], m = e[13], y = e[14], g = e[15];
                return t1[0] = o * (p * g - f * y) - h * (l * g - u * y) + m * (l * f - u * p), t1[1] = -(n * (p * g - f * y) - h * (i * g - a * y) + m * (i * f - a * p)), t1[2] = n * (l * g - u * y) - o * (i * g - a * y) + m * (i * u - a * l), t1[3] = -(n * (l * f - u * p) - o * (i * f - a * p) + h * (i * u - a * l)), t1[4] = -(s * (p * g - f * y) - c * (l * g - u * y) + d * (l * f - u * p)), t1[5] = r * (p * g - f * y) - c * (i * g - a * y) + d * (i * f - a * p), t1[6] = -(r * (l * g - u * y) - s * (i * g - a * y) + d * (i * u - a * l)), t1[7] = r * (l * f - u * p) - s * (i * f - a * p) + c * (i * u - a * l), t1[8] = s * (h * g - f * m) - c * (o * g - u * m) + d * (o * f - u * h), t1[9] = -(r * (h * g - f * m) - c * (n * g - a * m) + d * (n * f - a * h)), t1[10] = r * (o * g - u * m) - s * (n * g - a * m) + d * (n * u - a * o), t1[11] = -(r * (o * f - u * h) - s * (n * f - a * h) + c * (n * u - a * o)), t1[12] = -(s * (h * y - p * m) - c * (o * y - l * m) + d * (o * p - l * h)), t1[13] = r * (h * y - p * m) - c * (n * y - i * m) + d * (n * p - i * h), t1[14] = -(r * (o * y - l * m) - s * (n * y - i * m) + d * (n * l - i * o)), t1[15] = r * (o * p - l * h) - s * (n * p - i * h) + c * (n * l - i * o), t1;
            }, y.determinant = function(t1) {
                var e = t1[0], r = t1[1], n = t1[2], i = t1[3], a = t1[4], s = t1[5], o = t1[6], l = t1[7], u = t1[8], c = t1[9], h = t1[10], p = t1[11], f = t1[12], d = t1[13], m = t1[14], y = t1[15];
                return (e * s - r * a) * (h * y - p * m) - (e * o - n * a) * (c * y - p * d) + (e * l - i * a) * (c * m - h * d) + (r * o - n * s) * (u * y - p * f) - (r * l - i * s) * (u * m - h * f) + (n * l - i * o) * (u * d - c * f);
            }, y.multiply = i, y.translate = function(t1, e, r) {
                var n, i, a, s, o, l, u, c, h, p, f, d, m = r[0], y = r[1], g = r[2];
                return e === t1 ? (t1[12] = e[0] * m + e[4] * y + e[8] * g + e[12], t1[13] = e[1] * m + e[5] * y + e[9] * g + e[13], t1[14] = e[2] * m + e[6] * y + e[10] * g + e[14], t1[15] = e[3] * m + e[7] * y + e[11] * g + e[15]) : (i = e[1], a = e[2], s = e[3], o = e[4], l = e[5], u = e[6], c = e[7], h = e[8], p = e[9], f = e[10], d = e[11], t1[0] = n = e[0], t1[1] = i, t1[2] = a, t1[3] = s, t1[4] = o, t1[5] = l, t1[6] = u, t1[7] = c, t1[8] = h, t1[9] = p, t1[10] = f, t1[11] = d, t1[12] = n * m + o * y + h * g + e[12], t1[13] = i * m + l * y + p * g + e[13], t1[14] = a * m + u * y + f * g + e[14], t1[15] = s * m + c * y + d * g + e[15]), t1;
            }, y.scale = function(t1, e, r) {
                var n = r[0], i = r[1], a = r[2];
                return t1[0] = e[0] * n, t1[1] = e[1] * n, t1[2] = e[2] * n, t1[3] = e[3] * n, t1[4] = e[4] * i, t1[5] = e[5] * i, t1[6] = e[6] * i, t1[7] = e[7] * i, t1[8] = e[8] * a, t1[9] = e[9] * a, t1[10] = e[10] * a, t1[11] = e[11] * a, t1[12] = e[12], t1[13] = e[13], t1[14] = e[14], t1[15] = e[15], t1;
            }, y.rotate = function(t1, r, n, i) {
                var a, s, o, l, u, c, h, p, f, d, m, y, g, x, v, b, _, w, M, A, S, I, P, z, E = i[0], k = i[1], T = i[2], B = Math.hypot(E, k, T);
                return B < e.EPSILON ? null : (E *= B = 1 / B, k *= B, T *= B, a = Math.sin(n), s = Math.cos(n), u = r[1], c = r[2], h = r[3], f = r[5], d = r[6], m = r[7], g = r[9], x = r[10], v = r[11], b = E * E * (o = 1 - s) + s, M = E * k * o - T * a, A = k * k * o + s, S = T * k * o + E * a, I = E * T * o + k * a, P = k * T * o - E * a, z = T * T * o + s, t1[0] = (l = r[0]) * b + (p = r[4]) * (_ = k * E * o + T * a) + (y = r[8]) * (w = T * E * o - k * a), t1[1] = u * b + f * _ + g * w, t1[2] = c * b + d * _ + x * w, t1[3] = h * b + m * _ + v * w, t1[4] = l * M + p * A + y * S, t1[5] = u * M + f * A + g * S, t1[6] = c * M + d * A + x * S, t1[7] = h * M + m * A + v * S, t1[8] = l * I + p * P + y * z, t1[9] = u * I + f * P + g * z, t1[10] = c * I + d * P + x * z, t1[11] = h * I + m * P + v * z, r !== t1 && (t1[12] = r[12], t1[13] = r[13], t1[14] = r[14], t1[15] = r[15]), t1);
            }, y.rotateX = function(t1, e, r) {
                var n = Math.sin(r), i = Math.cos(r), a = e[4], s = e[5], o = e[6], l = e[7], u = e[8], c = e[9], h = e[10], p = e[11];
                return e !== t1 && (t1[0] = e[0], t1[1] = e[1], t1[2] = e[2], t1[3] = e[3], t1[12] = e[12], t1[13] = e[13], t1[14] = e[14], t1[15] = e[15]), t1[4] = a * i + u * n, t1[5] = s * i + c * n, t1[6] = o * i + h * n, t1[7] = l * i + p * n, t1[8] = u * i - a * n, t1[9] = c * i - s * n, t1[10] = h * i - o * n, t1[11] = p * i - l * n, t1;
            }, y.rotateY = function(t1, e, r) {
                var n = Math.sin(r), i = Math.cos(r), a = e[0], s = e[1], o = e[2], l = e[3], u = e[8], c = e[9], h = e[10], p = e[11];
                return e !== t1 && (t1[4] = e[4], t1[5] = e[5], t1[6] = e[6], t1[7] = e[7], t1[12] = e[12], t1[13] = e[13], t1[14] = e[14], t1[15] = e[15]), t1[0] = a * i - u * n, t1[1] = s * i - c * n, t1[2] = o * i - h * n, t1[3] = l * i - p * n, t1[8] = a * n + u * i, t1[9] = s * n + c * i, t1[10] = o * n + h * i, t1[11] = l * n + p * i, t1;
            }, y.rotateZ = function(t1, e, r) {
                var n = Math.sin(r), i = Math.cos(r), a = e[0], s = e[1], o = e[2], l = e[3], u = e[4], c = e[5], h = e[6], p = e[7];
                return e !== t1 && (t1[8] = e[8], t1[9] = e[9], t1[10] = e[10], t1[11] = e[11], t1[12] = e[12], t1[13] = e[13], t1[14] = e[14], t1[15] = e[15]), t1[0] = a * i + u * n, t1[1] = s * i + c * n, t1[2] = o * i + h * n, t1[3] = l * i + p * n, t1[4] = u * i - a * n, t1[5] = c * i - s * n, t1[6] = h * i - o * n, t1[7] = p * i - l * n, t1;
            }, y.fromTranslation = function(t1, e) {
                return t1[0] = 1, t1[1] = 0, t1[2] = 0, t1[3] = 0, t1[4] = 0, t1[5] = 1, t1[6] = 0, t1[7] = 0, t1[8] = 0, t1[9] = 0, t1[10] = 1, t1[11] = 0, t1[12] = e[0], t1[13] = e[1], t1[14] = e[2], t1[15] = 1, t1;
            }, y.fromScaling = function(t1, e) {
                return t1[0] = e[0], t1[1] = 0, t1[2] = 0, t1[3] = 0, t1[4] = 0, t1[5] = e[1], t1[6] = 0, t1[7] = 0, t1[8] = 0, t1[9] = 0, t1[10] = e[2], t1[11] = 0, t1[12] = 0, t1[13] = 0, t1[14] = 0, t1[15] = 1, t1;
            }, y.fromRotation = function(t1, r, n) {
                var i, a, s, o = n[0], l = n[1], u = n[2], c = Math.hypot(o, l, u);
                return c < e.EPSILON ? null : (o *= c = 1 / c, l *= c, u *= c, i = Math.sin(r), a = Math.cos(r), t1[0] = o * o * (s = 1 - a) + a, t1[1] = l * o * s + u * i, t1[2] = u * o * s - l * i, t1[3] = 0, t1[4] = o * l * s - u * i, t1[5] = l * l * s + a, t1[6] = u * l * s + o * i, t1[7] = 0, t1[8] = o * u * s + l * i, t1[9] = l * u * s - o * i, t1[10] = u * u * s + a, t1[11] = 0, t1[12] = 0, t1[13] = 0, t1[14] = 0, t1[15] = 1, t1);
            }, y.fromXRotation = function(t1, e) {
                var r = Math.sin(e), n = Math.cos(e);
                return t1[0] = 1, t1[1] = 0, t1[2] = 0, t1[3] = 0, t1[4] = 0, t1[5] = n, t1[6] = r, t1[7] = 0, t1[8] = 0, t1[9] = -r, t1[10] = n, t1[11] = 0, t1[12] = 0, t1[13] = 0, t1[14] = 0, t1[15] = 1, t1;
            }, y.fromYRotation = function(t1, e) {
                var r = Math.sin(e), n = Math.cos(e);
                return t1[0] = n, t1[1] = 0, t1[2] = -r, t1[3] = 0, t1[4] = 0, t1[5] = 1, t1[6] = 0, t1[7] = 0, t1[8] = r, t1[9] = 0, t1[10] = n, t1[11] = 0, t1[12] = 0, t1[13] = 0, t1[14] = 0, t1[15] = 1, t1;
            }, y.fromZRotation = function(t1, e) {
                var r = Math.sin(e), n = Math.cos(e);
                return t1[0] = n, t1[1] = r, t1[2] = 0, t1[3] = 0, t1[4] = -r, t1[5] = n, t1[6] = 0, t1[7] = 0, t1[8] = 0, t1[9] = 0, t1[10] = 1, t1[11] = 0, t1[12] = 0, t1[13] = 0, t1[14] = 0, t1[15] = 1, t1;
            }, y.fromRotationTranslation = s, y.fromQuat2 = function(t1, r) {
                var n = new e.ARRAY_TYPE(3), i = -r[0], a = -r[1], o = -r[2], l = r[3], u = r[4], c = r[5], h = r[6], p = r[7], f = i * i + a * a + o * o + l * l;
                return f > 0 ? (n[0] = 2 * (u * l + p * i + c * o - h * a) / f, n[1] = 2 * (c * l + p * a + h * i - u * o) / f, n[2] = 2 * (h * l + p * o + u * a - c * i) / f) : (n[0] = 2 * (u * l + p * i + c * o - h * a), n[1] = 2 * (c * l + p * a + h * i - u * o), n[2] = 2 * (h * l + p * o + u * a - c * i)), s(t1, r, n), t1;
            }, y.getTranslation = function(t1, e) {
                return t1[0] = e[12], t1[1] = e[13], t1[2] = e[14], t1;
            }, y.getScaling = o, y.getRotation = function(t1, r) {
                var n = new e.ARRAY_TYPE(3);
                o(n, r);
                var i = 1 / n[0], a = 1 / n[1], s = 1 / n[2], l = r[0] * i, u = r[1] * a, c = r[2] * s, h = r[4] * i, p = r[5] * a, f = r[6] * s, d = r[8] * i, m = r[9] * a, y = r[10] * s, g = l + p + y, x = 0;
                return g > 0 ? (x = 2 * Math.sqrt(g + 1), t1[3] = .25 * x, t1[0] = (f - m) / x, t1[1] = (d - c) / x, t1[2] = (u - h) / x) : l > p && l > y ? (x = 2 * Math.sqrt(1 + l - p - y), t1[3] = (f - m) / x, t1[0] = .25 * x, t1[1] = (u + h) / x, t1[2] = (d + c) / x) : p > y ? (x = 2 * Math.sqrt(1 + p - l - y), t1[3] = (d - c) / x, t1[0] = (u + h) / x, t1[1] = .25 * x, t1[2] = (f + m) / x) : (x = 2 * Math.sqrt(1 + y - l - p), t1[3] = (u - h) / x, t1[0] = (d + c) / x, t1[1] = (f + m) / x, t1[2] = .25 * x), t1;
            }, y.fromRotationTranslationScale = function(t1, e, r, n) {
                var i = e[0], a = e[1], s = e[2], o = e[3], l = i + i, u = a + a, c = s + s, h = i * l, p = i * u, f = i * c, d = a * u, m = a * c, y = s * c, g = o * l, x = o * u, v = o * c, b = n[0], _ = n[1], w = n[2];
                return t1[0] = (1 - (d + y)) * b, t1[1] = (p + v) * b, t1[2] = (f - x) * b, t1[3] = 0, t1[4] = (p - v) * _, t1[5] = (1 - (h + y)) * _, t1[6] = (m + g) * _, t1[7] = 0, t1[8] = (f + x) * w, t1[9] = (m - g) * w, t1[10] = (1 - (h + d)) * w, t1[11] = 0, t1[12] = r[0], t1[13] = r[1], t1[14] = r[2], t1[15] = 1, t1;
            }, y.fromRotationTranslationScaleOrigin = function(t1, e, r, n, i) {
                var a = e[0], s = e[1], o = e[2], l = e[3], u = a + a, c = s + s, h = o + o, p = a * u, f = a * c, d = a * h, m = s * c, y = s * h, g = o * h, x = l * u, v = l * c, b = l * h, _ = n[0], w = n[1], M = n[2], A = i[0], S = i[1], I = i[2], P = (1 - (m + g)) * _, z = (f + b) * _, E = (d - v) * _, k = (f - b) * w, T = (1 - (p + g)) * w, B = (y + x) * w, C = (d + v) * M, V = (y - x) * M, D = (1 - (p + m)) * M;
                return t1[0] = P, t1[1] = z, t1[2] = E, t1[3] = 0, t1[4] = k, t1[5] = T, t1[6] = B, t1[7] = 0, t1[8] = C, t1[9] = V, t1[10] = D, t1[11] = 0, t1[12] = r[0] + A - (P * A + k * S + C * I), t1[13] = r[1] + S - (z * A + T * S + V * I), t1[14] = r[2] + I - (E * A + B * S + D * I), t1[15] = 1, t1;
            }, y.fromQuat = function(t1, e) {
                var r = e[0], n = e[1], i = e[2], a = e[3], s = r + r, o = n + n, l = i + i, u = r * s, c = n * s, h = n * o, p = i * s, f = i * o, d = i * l, m = a * s, y = a * o, g = a * l;
                return t1[0] = 1 - h - d, t1[1] = c + g, t1[2] = p - y, t1[3] = 0, t1[4] = c - g, t1[5] = 1 - u - d, t1[6] = f + m, t1[7] = 0, t1[8] = p + y, t1[9] = f - m, t1[10] = 1 - u - h, t1[11] = 0, t1[12] = 0, t1[13] = 0, t1[14] = 0, t1[15] = 1, t1;
            }, y.frustum = function(t1, e, r, n, i, a, s) {
                var o = 1 / (r - e), l = 1 / (i - n), u = 1 / (a - s);
                return t1[0] = 2 * a * o, t1[1] = 0, t1[2] = 0, t1[3] = 0, t1[4] = 0, t1[5] = 2 * a * l, t1[6] = 0, t1[7] = 0, t1[8] = (r + e) * o, t1[9] = (i + n) * l, t1[10] = (s + a) * u, t1[11] = -1, t1[12] = 0, t1[13] = 0, t1[14] = s * a * 2 * u, t1[15] = 0, t1;
            }, y.perspectiveNO = l, y.perspectiveZO = function(t1, e, r, n, i) {
                var a, s = 1 / Math.tan(e / 2);
                return t1[0] = s / r, t1[1] = 0, t1[2] = 0, t1[3] = 0, t1[4] = 0, t1[5] = s, t1[6] = 0, t1[7] = 0, t1[8] = 0, t1[9] = 0, t1[11] = -1, t1[12] = 0, t1[13] = 0, t1[15] = 0, null != i && i !== 1 / 0 ? (t1[10] = i * (a = 1 / (n - i)), t1[14] = i * n * a) : (t1[10] = -1, t1[14] = -n), t1;
            }, y.perspectiveFromFieldOfView = function(t1, e, r, n) {
                var i = Math.tan(e.upDegrees * Math.PI / 180), a = Math.tan(e.downDegrees * Math.PI / 180), s = Math.tan(e.leftDegrees * Math.PI / 180), o = Math.tan(e.rightDegrees * Math.PI / 180), l = 2 / (s + o), u = 2 / (i + a);
                return t1[0] = l, t1[1] = 0, t1[2] = 0, t1[3] = 0, t1[4] = 0, t1[5] = u, t1[6] = 0, t1[7] = 0, t1[8] = -(s - o) * l * .5, t1[9] = (i - a) * u * .5, t1[10] = n / (r - n), t1[11] = -1, t1[12] = 0, t1[13] = 0, t1[14] = n * r / (r - n), t1[15] = 0, t1;
            }, y.orthoNO = u, y.orthoZO = function(t1, e, r, n, i, a, s) {
                var o = 1 / (e - r), l = 1 / (n - i), u = 1 / (a - s);
                return t1[0] = -2 * o, t1[1] = 0, t1[2] = 0, t1[3] = 0, t1[4] = 0, t1[5] = -2 * l, t1[6] = 0, t1[7] = 0, t1[8] = 0, t1[9] = 0, t1[10] = u, t1[11] = 0, t1[12] = (e + r) * o, t1[13] = (i + n) * l, t1[14] = a * u, t1[15] = 1, t1;
            }, y.lookAt = function(t1, r, i, a) {
                var s, o, l, u, c, h, p, f, d, m, y = r[0], g = r[1], x = r[2], v = a[0], b = a[1], _ = a[2], w = i[0], M = i[1], A = i[2];
                return Math.abs(y - w) < e.EPSILON && Math.abs(g - M) < e.EPSILON && Math.abs(x - A) < e.EPSILON ? n(t1) : (p = y - w, f = g - M, d = x - A, s = b * (d *= m = 1 / Math.hypot(p, f, d)) - _ * (f *= m), o = _ * (p *= m) - v * d, l = v * f - b * p, (m = Math.hypot(s, o, l)) ? (s *= m = 1 / m, o *= m, l *= m) : (s = 0, o = 0, l = 0), u = f * l - d * o, c = d * s - p * l, h = p * o - f * s, (m = Math.hypot(u, c, h)) ? (u *= m = 1 / m, c *= m, h *= m) : (u = 0, c = 0, h = 0), t1[0] = s, t1[1] = u, t1[2] = p, t1[3] = 0, t1[4] = o, t1[5] = c, t1[6] = f, t1[7] = 0, t1[8] = l, t1[9] = h, t1[10] = d, t1[11] = 0, t1[12] = -(s * y + o * g + l * x), t1[13] = -(u * y + c * g + h * x), t1[14] = -(p * y + f * g + d * x), t1[15] = 1, t1);
            }, y.targetTo = function(t1, e, r, n) {
                var i = e[0], a = e[1], s = e[2], o = n[0], l = n[1], u = n[2], c = i - r[0], h = a - r[1], p = s - r[2], f = c * c + h * h + p * p;
                f > 0 && (c *= f = 1 / Math.sqrt(f), h *= f, p *= f);
                var d = l * p - u * h, m = u * c - o * p, y = o * h - l * c;
                return (f = d * d + m * m + y * y) > 0 && (d *= f = 1 / Math.sqrt(f), m *= f, y *= f), t1[0] = d, t1[1] = m, t1[2] = y, t1[3] = 0, t1[4] = h * y - p * m, t1[5] = p * d - c * y, t1[6] = c * m - h * d, t1[7] = 0, t1[8] = c, t1[9] = h, t1[10] = p, t1[11] = 0, t1[12] = i, t1[13] = a, t1[14] = s, t1[15] = 1, t1;
            }, y.str = function(t1) {
                return "mat4(" + t1[0] + ", " + t1[1] + ", " + t1[2] + ", " + t1[3] + ", " + t1[4] + ", " + t1[5] + ", " + t1[6] + ", " + t1[7] + ", " + t1[8] + ", " + t1[9] + ", " + t1[10] + ", " + t1[11] + ", " + t1[12] + ", " + t1[13] + ", " + t1[14] + ", " + t1[15] + ")";
            }, y.frob = function(t1) {
                return Math.hypot(t1[0], t1[1], t1[2], t1[3], t1[4], t1[5], t1[6], t1[7], t1[8], t1[9], t1[10], t1[11], t1[12], t1[13], t1[14], t1[15]);
            }, y.add = function(t1, e, r) {
                return t1[0] = e[0] + r[0], t1[1] = e[1] + r[1], t1[2] = e[2] + r[2], t1[3] = e[3] + r[3], t1[4] = e[4] + r[4], t1[5] = e[5] + r[5], t1[6] = e[6] + r[6], t1[7] = e[7] + r[7], t1[8] = e[8] + r[8], t1[9] = e[9] + r[9], t1[10] = e[10] + r[10], t1[11] = e[11] + r[11], t1[12] = e[12] + r[12], t1[13] = e[13] + r[13], t1[14] = e[14] + r[14], t1[15] = e[15] + r[15], t1;
            }, y.subtract = c, y.multiplyScalar = function(t1, e, r) {
                return t1[0] = e[0] * r, t1[1] = e[1] * r, t1[2] = e[2] * r, t1[3] = e[3] * r, t1[4] = e[4] * r, t1[5] = e[5] * r, t1[6] = e[6] * r, t1[7] = e[7] * r, t1[8] = e[8] * r, t1[9] = e[9] * r, t1[10] = e[10] * r, t1[11] = e[11] * r, t1[12] = e[12] * r, t1[13] = e[13] * r, t1[14] = e[14] * r, t1[15] = e[15] * r, t1;
            }, y.multiplyScalarAndAdd = function(t1, e, r, n) {
                return t1[0] = e[0] + r[0] * n, t1[1] = e[1] + r[1] * n, t1[2] = e[2] + r[2] * n, t1[3] = e[3] + r[3] * n, t1[4] = e[4] + r[4] * n, t1[5] = e[5] + r[5] * n, t1[6] = e[6] + r[6] * n, t1[7] = e[7] + r[7] * n, t1[8] = e[8] + r[8] * n, t1[9] = e[9] + r[9] * n, t1[10] = e[10] + r[10] * n, t1[11] = e[11] + r[11] * n, t1[12] = e[12] + r[12] * n, t1[13] = e[13] + r[13] * n, t1[14] = e[14] + r[14] * n, t1[15] = e[15] + r[15] * n, t1;
            }, y.exactEquals = function(t1, e) {
                return t1[0] === e[0] && t1[1] === e[1] && t1[2] === e[2] && t1[3] === e[3] && t1[4] === e[4] && t1[5] === e[5] && t1[6] === e[6] && t1[7] === e[7] && t1[8] === e[8] && t1[9] === e[9] && t1[10] === e[10] && t1[11] === e[11] && t1[12] === e[12] && t1[13] === e[13] && t1[14] === e[14] && t1[15] === e[15];
            }, y.equals = function(t1, r) {
                var n = t1[0], i = t1[1], a = t1[2], s = t1[3], o = t1[4], l = t1[5], u = t1[6], c = t1[7], h = t1[8], p = t1[9], f = t1[10], d = t1[11], m = t1[12], y = t1[13], g = t1[14], x = t1[15], v = r[0], b = r[1], _ = r[2], w = r[3], M = r[4], A = r[5], S = r[6], I = r[7], P = r[8], z = r[9], E = r[10], k = r[11], T = r[12], B = r[13], C = r[14], V = r[15];
                return Math.abs(n - v) <= e.EPSILON * Math.max(1, Math.abs(n), Math.abs(v)) && Math.abs(i - b) <= e.EPSILON * Math.max(1, Math.abs(i), Math.abs(b)) && Math.abs(a - _) <= e.EPSILON * Math.max(1, Math.abs(a), Math.abs(_)) && Math.abs(s - w) <= e.EPSILON * Math.max(1, Math.abs(s), Math.abs(w)) && Math.abs(o - M) <= e.EPSILON * Math.max(1, Math.abs(o), Math.abs(M)) && Math.abs(l - A) <= e.EPSILON * Math.max(1, Math.abs(l), Math.abs(A)) && Math.abs(u - S) <= e.EPSILON * Math.max(1, Math.abs(u), Math.abs(S)) && Math.abs(c - I) <= e.EPSILON * Math.max(1, Math.abs(c), Math.abs(I)) && Math.abs(h - P) <= e.EPSILON * Math.max(1, Math.abs(h), Math.abs(P)) && Math.abs(p - z) <= e.EPSILON * Math.max(1, Math.abs(p), Math.abs(z)) && Math.abs(f - E) <= e.EPSILON * Math.max(1, Math.abs(f), Math.abs(E)) && Math.abs(d - k) <= e.EPSILON * Math.max(1, Math.abs(d), Math.abs(k)) && Math.abs(m - T) <= e.EPSILON * Math.max(1, Math.abs(m), Math.abs(T)) && Math.abs(y - B) <= e.EPSILON * Math.max(1, Math.abs(y), Math.abs(B)) && Math.abs(g - C) <= e.EPSILON * Math.max(1, Math.abs(g), Math.abs(C)) && Math.abs(x - V) <= e.EPSILON * Math.max(1, Math.abs(x), Math.abs(V));
            }, y.sub = y.mul = y.ortho = y.perspective = void 0;
            var e = function(e, n) {
                if (e && e.__esModule) return e;
                if (null === e || "object" !== t1(e) && "function" != typeof e) return {
                    default: e
                };
                var i = r(void 0);
                if (i && i.has(e)) return i.get(e);
                var a = {}, s = Object.defineProperty && Object.getOwnPropertyDescriptor;
                for(var o in e)if ("default" !== o && Object.prototype.hasOwnProperty.call(e, o)) {
                    var l = s ? Object.getOwnPropertyDescriptor(e, o) : null;
                    l && (l.get || l.set) ? Object.defineProperty(a, o, l) : a[o] = e[o];
                }
                return a.default = e, i && i.set(e, a), a;
            }(a());
            function r(t1) {
                if ("function" != typeof WeakMap) return null;
                var e = new WeakMap, n = new WeakMap;
                return (r = function(t1) {
                    return t1 ? n : e;
                })(t1);
            }
            function n(t1) {
                return t1[0] = 1, t1[1] = 0, t1[2] = 0, t1[3] = 0, t1[4] = 0, t1[5] = 1, t1[6] = 0, t1[7] = 0, t1[8] = 0, t1[9] = 0, t1[10] = 1, t1[11] = 0, t1[12] = 0, t1[13] = 0, t1[14] = 0, t1[15] = 1, t1;
            }
            function i(t1, e, r) {
                var n = e[0], i = e[1], a = e[2], s = e[3], o = e[4], l = e[5], u = e[6], c = e[7], h = e[8], p = e[9], f = e[10], d = e[11], m = e[12], y = e[13], g = e[14], x = e[15], v = r[0], b = r[1], _ = r[2], w = r[3];
                return t1[0] = v * n + b * o + _ * h + w * m, t1[1] = v * i + b * l + _ * p + w * y, t1[2] = v * a + b * u + _ * f + w * g, t1[3] = v * s + b * c + _ * d + w * x, t1[4] = (v = r[4]) * n + (b = r[5]) * o + (_ = r[6]) * h + (w = r[7]) * m, t1[5] = v * i + b * l + _ * p + w * y, t1[6] = v * a + b * u + _ * f + w * g, t1[7] = v * s + b * c + _ * d + w * x, t1[8] = (v = r[8]) * n + (b = r[9]) * o + (_ = r[10]) * h + (w = r[11]) * m, t1[9] = v * i + b * l + _ * p + w * y, t1[10] = v * a + b * u + _ * f + w * g, t1[11] = v * s + b * c + _ * d + w * x, t1[12] = (v = r[12]) * n + (b = r[13]) * o + (_ = r[14]) * h + (w = r[15]) * m, t1[13] = v * i + b * l + _ * p + w * y, t1[14] = v * a + b * u + _ * f + w * g, t1[15] = v * s + b * c + _ * d + w * x, t1;
            }
            function s(t1, e, r) {
                var n = e[0], i = e[1], a = e[2], s = e[3], o = n + n, l = i + i, u = a + a, c = n * o, h = n * l, p = n * u, f = i * l, d = i * u, m = a * u, y = s * o, g = s * l, x = s * u;
                return t1[0] = 1 - (f + m), t1[1] = h + x, t1[2] = p - g, t1[3] = 0, t1[4] = h - x, t1[5] = 1 - (c + m), t1[6] = d + y, t1[7] = 0, t1[8] = p + g, t1[9] = d - y, t1[10] = 1 - (c + f), t1[11] = 0, t1[12] = r[0], t1[13] = r[1], t1[14] = r[2], t1[15] = 1, t1;
            }
            function o(t1, e) {
                var r = e[4], n = e[5], i = e[6], a = e[8], s = e[9], o = e[10];
                return t1[0] = Math.hypot(e[0], e[1], e[2]), t1[1] = Math.hypot(r, n, i), t1[2] = Math.hypot(a, s, o), t1;
            }
            function l(t1, e, r, n, i) {
                var a, s = 1 / Math.tan(e / 2);
                return t1[0] = s / r, t1[1] = 0, t1[2] = 0, t1[3] = 0, t1[4] = 0, t1[5] = s, t1[6] = 0, t1[7] = 0, t1[8] = 0, t1[9] = 0, t1[11] = -1, t1[12] = 0, t1[13] = 0, t1[15] = 0, null != i && i !== 1 / 0 ? (t1[10] = (i + n) * (a = 1 / (n - i)), t1[14] = 2 * i * n * a) : (t1[10] = -1, t1[14] = -2 * n), t1;
            }
            function u(t1, e, r, n, i, a, s) {
                var o = 1 / (e - r), l = 1 / (n - i), u = 1 / (a - s);
                return t1[0] = -2 * o, t1[1] = 0, t1[2] = 0, t1[3] = 0, t1[4] = 0, t1[5] = -2 * l, t1[6] = 0, t1[7] = 0, t1[8] = 0, t1[9] = 0, t1[10] = 2 * u, t1[11] = 0, t1[12] = (e + r) * o, t1[13] = (i + n) * l, t1[14] = (s + a) * u, t1[15] = 1, t1;
            }
            function c(t1, e, r) {
                return t1[0] = e[0] - r[0], t1[1] = e[1] - r[1], t1[2] = e[2] - r[2], t1[3] = e[3] - r[3], t1[4] = e[4] - r[4], t1[5] = e[5] - r[5], t1[6] = e[6] - r[6], t1[7] = e[7] - r[7], t1[8] = e[8] - r[8], t1[9] = e[9] - r[9], t1[10] = e[10] - r[10], t1[11] = e[11] - r[11], t1[12] = e[12] - r[12], t1[13] = e[13] - r[13], t1[14] = e[14] - r[14], t1[15] = e[15] - r[15], t1;
            }
            return y.perspective = l, y.ortho = u, y.mul = i, y.sub = c, y;
        }
        var x, v = {}, b = {};
        function _() {
            if (x) return b;
            function t1(e) {
                return t1 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(t1) {
                    return typeof t1;
                } : function(t1) {
                    return t1 && "function" == typeof Symbol && t1.constructor === Symbol && t1 !== Symbol.prototype ? "symbol" : typeof t1;
                }, t1(e);
            }
            x = 1, Object.defineProperty(b, "__esModule", {
                value: !0
            }), b.create = n, b.clone = function(t1) {
                var r = new e.ARRAY_TYPE(3);
                return r[0] = t1[0], r[1] = t1[1], r[2] = t1[2], r;
            }, b.length = i, b.fromValues = function(t1, r, n) {
                var i = new e.ARRAY_TYPE(3);
                return i[0] = t1, i[1] = r, i[2] = n, i;
            }, b.copy = function(t1, e) {
                return t1[0] = e[0], t1[1] = e[1], t1[2] = e[2], t1;
            }, b.set = function(t1, e, r, n) {
                return t1[0] = e, t1[1] = r, t1[2] = n, t1;
            }, b.add = function(t1, e, r) {
                return t1[0] = e[0] + r[0], t1[1] = e[1] + r[1], t1[2] = e[2] + r[2], t1;
            }, b.subtract = s, b.multiply = o, b.divide = l, b.ceil = function(t1, e) {
                return t1[0] = Math.ceil(e[0]), t1[1] = Math.ceil(e[1]), t1[2] = Math.ceil(e[2]), t1;
            }, b.floor = function(t1, e) {
                return t1[0] = Math.floor(e[0]), t1[1] = Math.floor(e[1]), t1[2] = Math.floor(e[2]), t1;
            }, b.min = function(t1, e, r) {
                return t1[0] = Math.min(e[0], r[0]), t1[1] = Math.min(e[1], r[1]), t1[2] = Math.min(e[2], r[2]), t1;
            }, b.max = function(t1, e, r) {
                return t1[0] = Math.max(e[0], r[0]), t1[1] = Math.max(e[1], r[1]), t1[2] = Math.max(e[2], r[2]), t1;
            }, b.round = function(t1, e) {
                return t1[0] = Math.round(e[0]), t1[1] = Math.round(e[1]), t1[2] = Math.round(e[2]), t1;
            }, b.scale = function(t1, e, r) {
                return t1[0] = e[0] * r, t1[1] = e[1] * r, t1[2] = e[2] * r, t1;
            }, b.scaleAndAdd = function(t1, e, r, n) {
                return t1[0] = e[0] + r[0] * n, t1[1] = e[1] + r[1] * n, t1[2] = e[2] + r[2] * n, t1;
            }, b.distance = u, b.squaredDistance = c, b.squaredLength = h, b.negate = function(t1, e) {
                return t1[0] = -e[0], t1[1] = -e[1], t1[2] = -e[2], t1;
            }, b.inverse = function(t1, e) {
                return t1[0] = 1 / e[0], t1[1] = 1 / e[1], t1[2] = 1 / e[2], t1;
            }, b.normalize = function(t1, e) {
                var r = e[0], n = e[1], i = e[2], a = r * r + n * n + i * i;
                return a > 0 && (a = 1 / Math.sqrt(a)), t1[0] = e[0] * a, t1[1] = e[1] * a, t1[2] = e[2] * a, t1;
            }, b.dot = p, b.cross = function(t1, e, r) {
                var n = e[0], i = e[1], a = e[2], s = r[0], o = r[1], l = r[2];
                return t1[0] = i * l - a * o, t1[1] = a * s - n * l, t1[2] = n * o - i * s, t1;
            }, b.lerp = function(t1, e, r, n) {
                var i = e[0], a = e[1], s = e[2];
                return t1[0] = i + n * (r[0] - i), t1[1] = a + n * (r[1] - a), t1[2] = s + n * (r[2] - s), t1;
            }, b.hermite = function(t1, e, r, n, i, a) {
                var s = a * a, o = s * (2 * a - 3) + 1, l = s * (a - 2) + a, u = s * (a - 1), c = s * (3 - 2 * a);
                return t1[0] = e[0] * o + r[0] * l + n[0] * u + i[0] * c, t1[1] = e[1] * o + r[1] * l + n[1] * u + i[1] * c, t1[2] = e[2] * o + r[2] * l + n[2] * u + i[2] * c, t1;
            }, b.bezier = function(t1, e, r, n, i, a) {
                var s = 1 - a, o = s * s, l = a * a, u = o * s, c = 3 * a * o, h = 3 * l * s, p = l * a;
                return t1[0] = e[0] * u + r[0] * c + n[0] * h + i[0] * p, t1[1] = e[1] * u + r[1] * c + n[1] * h + i[1] * p, t1[2] = e[2] * u + r[2] * c + n[2] * h + i[2] * p, t1;
            }, b.random = function(t1, r) {
                r = r || 1;
                var n = 2 * e.RANDOM() * Math.PI, i = 2 * e.RANDOM() - 1, a = Math.sqrt(1 - i * i) * r;
                return t1[0] = Math.cos(n) * a, t1[1] = Math.sin(n) * a, t1[2] = i * r, t1;
            }, b.transformMat4 = function(t1, e, r) {
                var n = e[0], i = e[1], a = e[2], s = r[3] * n + r[7] * i + r[11] * a + r[15];
                return t1[0] = (r[0] * n + r[4] * i + r[8] * a + r[12]) / (s = s || 1), t1[1] = (r[1] * n + r[5] * i + r[9] * a + r[13]) / s, t1[2] = (r[2] * n + r[6] * i + r[10] * a + r[14]) / s, t1;
            }, b.transformMat3 = function(t1, e, r) {
                var n = e[0], i = e[1], a = e[2];
                return t1[0] = n * r[0] + i * r[3] + a * r[6], t1[1] = n * r[1] + i * r[4] + a * r[7], t1[2] = n * r[2] + i * r[5] + a * r[8], t1;
            }, b.transformQuat = function(t1, e, r) {
                var n = r[0], i = r[1], a = r[2], s = e[0], o = e[1], l = e[2], u = i * l - a * o, c = a * s - n * l, h = n * o - i * s, p = i * h - a * c, f = a * u - n * h, d = n * c - i * u, m = 2 * r[3];
                return c *= m, h *= m, f *= 2, d *= 2, t1[0] = s + (u *= m) + (p *= 2), t1[1] = o + c + f, t1[2] = l + h + d, t1;
            }, b.rotateX = function(t1, e, r, n) {
                var i = [], a = [];
                return i[0] = e[0] - r[0], i[1] = e[1] - r[1], i[2] = e[2] - r[2], a[0] = i[0], a[1] = i[1] * Math.cos(n) - i[2] * Math.sin(n), a[2] = i[1] * Math.sin(n) + i[2] * Math.cos(n), t1[0] = a[0] + r[0], t1[1] = a[1] + r[1], t1[2] = a[2] + r[2], t1;
            }, b.rotateY = function(t1, e, r, n) {
                var i = [], a = [];
                return i[0] = e[0] - r[0], i[1] = e[1] - r[1], i[2] = e[2] - r[2], a[0] = i[2] * Math.sin(n) + i[0] * Math.cos(n), a[1] = i[1], a[2] = i[2] * Math.cos(n) - i[0] * Math.sin(n), t1[0] = a[0] + r[0], t1[1] = a[1] + r[1], t1[2] = a[2] + r[2], t1;
            }, b.rotateZ = function(t1, e, r, n) {
                var i = [], a = [];
                return i[0] = e[0] - r[0], i[1] = e[1] - r[1], i[2] = e[2] - r[2], a[0] = i[0] * Math.cos(n) - i[1] * Math.sin(n), a[1] = i[0] * Math.sin(n) + i[1] * Math.cos(n), a[2] = i[2], t1[0] = a[0] + r[0], t1[1] = a[1] + r[1], t1[2] = a[2] + r[2], t1;
            }, b.angle = function(t1, e) {
                var r = t1[0], n = t1[1], i = t1[2], a = e[0], s = e[1], o = e[2], l = Math.sqrt(r * r + n * n + i * i) * Math.sqrt(a * a + s * s + o * o), u = l && p(t1, e) / l;
                return Math.acos(Math.min(Math.max(u, -1), 1));
            }, b.zero = function(t1) {
                return t1[0] = 0, t1[1] = 0, t1[2] = 0, t1;
            }, b.str = function(t1) {
                return "vec3(" + t1[0] + ", " + t1[1] + ", " + t1[2] + ")";
            }, b.exactEquals = function(t1, e) {
                return t1[0] === e[0] && t1[1] === e[1] && t1[2] === e[2];
            }, b.equals = function(t1, r) {
                var n = t1[0], i = t1[1], a = t1[2], s = r[0], o = r[1], l = r[2];
                return Math.abs(n - s) <= e.EPSILON * Math.max(1, Math.abs(n), Math.abs(s)) && Math.abs(i - o) <= e.EPSILON * Math.max(1, Math.abs(i), Math.abs(o)) && Math.abs(a - l) <= e.EPSILON * Math.max(1, Math.abs(a), Math.abs(l));
            }, b.forEach = b.sqrLen = b.len = b.sqrDist = b.dist = b.div = b.mul = b.sub = void 0;
            var e = function(e, n) {
                if (e && e.__esModule) return e;
                if (null === e || "object" !== t1(e) && "function" != typeof e) return {
                    default: e
                };
                var i = r(void 0);
                if (i && i.has(e)) return i.get(e);
                var a = {}, s = Object.defineProperty && Object.getOwnPropertyDescriptor;
                for(var o in e)if ("default" !== o && Object.prototype.hasOwnProperty.call(e, o)) {
                    var l = s ? Object.getOwnPropertyDescriptor(e, o) : null;
                    l && (l.get || l.set) ? Object.defineProperty(a, o, l) : a[o] = e[o];
                }
                return a.default = e, i && i.set(e, a), a;
            }(a());
            function r(t1) {
                if ("function" != typeof WeakMap) return null;
                var e = new WeakMap, n = new WeakMap;
                return (r = function(t1) {
                    return t1 ? n : e;
                })(t1);
            }
            function n() {
                var t1 = new e.ARRAY_TYPE(3);
                return e.ARRAY_TYPE != Float32Array && (t1[0] = 0, t1[1] = 0, t1[2] = 0), t1;
            }
            function i(t1) {
                return Math.hypot(t1[0], t1[1], t1[2]);
            }
            function s(t1, e, r) {
                return t1[0] = e[0] - r[0], t1[1] = e[1] - r[1], t1[2] = e[2] - r[2], t1;
            }
            function o(t1, e, r) {
                return t1[0] = e[0] * r[0], t1[1] = e[1] * r[1], t1[2] = e[2] * r[2], t1;
            }
            function l(t1, e, r) {
                return t1[0] = e[0] / r[0], t1[1] = e[1] / r[1], t1[2] = e[2] / r[2], t1;
            }
            function u(t1, e) {
                return Math.hypot(e[0] - t1[0], e[1] - t1[1], e[2] - t1[2]);
            }
            function c(t1, e) {
                var r = e[0] - t1[0], n = e[1] - t1[1], i = e[2] - t1[2];
                return r * r + n * n + i * i;
            }
            function h(t1) {
                var e = t1[0], r = t1[1], n = t1[2];
                return e * e + r * r + n * n;
            }
            function p(t1, e) {
                return t1[0] * e[0] + t1[1] * e[1] + t1[2] * e[2];
            }
            b.sub = s, b.mul = o, b.div = l, b.dist = u, b.sqrDist = c, b.len = i, b.sqrLen = h;
            var f, d = (f = n(), function(t1, e, r, n, i, a) {
                var s, o;
                for(e || (e = 3), r || (r = 0), o = n ? Math.min(n * e + r, t1.length) : t1.length, s = r; s < o; s += e)f[0] = t1[s], f[1] = t1[s + 1], f[2] = t1[s + 2], i(f, f, a), t1[s] = f[0], t1[s + 1] = f[1], t1[s + 2] = f[2];
                return t1;
            });
            return b.forEach = d, b;
        }
        var w, M, A = {};
        function S() {
            if (w) return A;
            function t1(e) {
                return t1 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(t1) {
                    return typeof t1;
                } : function(t1) {
                    return t1 && "function" == typeof Symbol && t1.constructor === Symbol && t1 !== Symbol.prototype ? "symbol" : typeof t1;
                }, t1(e);
            }
            w = 1, Object.defineProperty(A, "__esModule", {
                value: !0
            }), A.create = n, A.clone = function(t1) {
                var r = new e.ARRAY_TYPE(4);
                return r[0] = t1[0], r[1] = t1[1], r[2] = t1[2], r[3] = t1[3], r;
            }, A.fromValues = function(t1, r, n, i) {
                var a = new e.ARRAY_TYPE(4);
                return a[0] = t1, a[1] = r, a[2] = n, a[3] = i, a;
            }, A.copy = function(t1, e) {
                return t1[0] = e[0], t1[1] = e[1], t1[2] = e[2], t1[3] = e[3], t1;
            }, A.set = function(t1, e, r, n, i) {
                return t1[0] = e, t1[1] = r, t1[2] = n, t1[3] = i, t1;
            }, A.add = function(t1, e, r) {
                return t1[0] = e[0] + r[0], t1[1] = e[1] + r[1], t1[2] = e[2] + r[2], t1[3] = e[3] + r[3], t1;
            }, A.subtract = i, A.multiply = s, A.divide = o, A.ceil = function(t1, e) {
                return t1[0] = Math.ceil(e[0]), t1[1] = Math.ceil(e[1]), t1[2] = Math.ceil(e[2]), t1[3] = Math.ceil(e[3]), t1;
            }, A.floor = function(t1, e) {
                return t1[0] = Math.floor(e[0]), t1[1] = Math.floor(e[1]), t1[2] = Math.floor(e[2]), t1[3] = Math.floor(e[3]), t1;
            }, A.min = function(t1, e, r) {
                return t1[0] = Math.min(e[0], r[0]), t1[1] = Math.min(e[1], r[1]), t1[2] = Math.min(e[2], r[2]), t1[3] = Math.min(e[3], r[3]), t1;
            }, A.max = function(t1, e, r) {
                return t1[0] = Math.max(e[0], r[0]), t1[1] = Math.max(e[1], r[1]), t1[2] = Math.max(e[2], r[2]), t1[3] = Math.max(e[3], r[3]), t1;
            }, A.round = function(t1, e) {
                return t1[0] = Math.round(e[0]), t1[1] = Math.round(e[1]), t1[2] = Math.round(e[2]), t1[3] = Math.round(e[3]), t1;
            }, A.scale = function(t1, e, r) {
                return t1[0] = e[0] * r, t1[1] = e[1] * r, t1[2] = e[2] * r, t1[3] = e[3] * r, t1;
            }, A.scaleAndAdd = function(t1, e, r, n) {
                return t1[0] = e[0] + r[0] * n, t1[1] = e[1] + r[1] * n, t1[2] = e[2] + r[2] * n, t1[3] = e[3] + r[3] * n, t1;
            }, A.distance = l, A.squaredDistance = u, A.length = c, A.squaredLength = h, A.negate = function(t1, e) {
                return t1[0] = -e[0], t1[1] = -e[1], t1[2] = -e[2], t1[3] = -e[3], t1;
            }, A.inverse = function(t1, e) {
                return t1[0] = 1 / e[0], t1[1] = 1 / e[1], t1[2] = 1 / e[2], t1[3] = 1 / e[3], t1;
            }, A.normalize = function(t1, e) {
                var r = e[0], n = e[1], i = e[2], a = e[3], s = r * r + n * n + i * i + a * a;
                return s > 0 && (s = 1 / Math.sqrt(s)), t1[0] = r * s, t1[1] = n * s, t1[2] = i * s, t1[3] = a * s, t1;
            }, A.dot = function(t1, e) {
                return t1[0] * e[0] + t1[1] * e[1] + t1[2] * e[2] + t1[3] * e[3];
            }, A.cross = function(t1, e, r, n) {
                var i = r[0] * n[1] - r[1] * n[0], a = r[0] * n[2] - r[2] * n[0], s = r[0] * n[3] - r[3] * n[0], o = r[1] * n[2] - r[2] * n[1], l = r[1] * n[3] - r[3] * n[1], u = r[2] * n[3] - r[3] * n[2], c = e[0], h = e[1], p = e[2], f = e[3];
                return t1[0] = h * u - p * l + f * o, t1[1] = -c * u + p * s - f * a, t1[2] = c * l - h * s + f * i, t1[3] = -c * o + h * a - p * i, t1;
            }, A.lerp = function(t1, e, r, n) {
                var i = e[0], a = e[1], s = e[2], o = e[3];
                return t1[0] = i + n * (r[0] - i), t1[1] = a + n * (r[1] - a), t1[2] = s + n * (r[2] - s), t1[3] = o + n * (r[3] - o), t1;
            }, A.random = function(t1, r) {
                var n, i, a, s, o, l;
                r = r || 1;
                do o = (n = 2 * e.RANDOM() - 1) * n + (i = 2 * e.RANDOM() - 1) * i;
                while (o >= 1);
                do l = (a = 2 * e.RANDOM() - 1) * a + (s = 2 * e.RANDOM() - 1) * s;
                while (l >= 1);
                var u = Math.sqrt((1 - o) / l);
                return t1[0] = r * n, t1[1] = r * i, t1[2] = r * a * u, t1[3] = r * s * u, t1;
            }, A.transformMat4 = function(t1, e, r) {
                var n = e[0], i = e[1], a = e[2], s = e[3];
                return t1[0] = r[0] * n + r[4] * i + r[8] * a + r[12] * s, t1[1] = r[1] * n + r[5] * i + r[9] * a + r[13] * s, t1[2] = r[2] * n + r[6] * i + r[10] * a + r[14] * s, t1[3] = r[3] * n + r[7] * i + r[11] * a + r[15] * s, t1;
            }, A.transformQuat = function(t1, e, r) {
                var n = e[0], i = e[1], a = e[2], s = r[0], o = r[1], l = r[2], u = r[3], c = u * n + o * a - l * i, h = u * i + l * n - s * a, p = u * a + s * i - o * n, f = -s * n - o * i - l * a;
                return t1[0] = c * u + f * -s + h * -l - p * -o, t1[1] = h * u + f * -o + p * -s - c * -l, t1[2] = p * u + f * -l + c * -o - h * -s, t1[3] = e[3], t1;
            }, A.zero = function(t1) {
                return t1[0] = 0, t1[1] = 0, t1[2] = 0, t1[3] = 0, t1;
            }, A.str = function(t1) {
                return "vec4(" + t1[0] + ", " + t1[1] + ", " + t1[2] + ", " + t1[3] + ")";
            }, A.exactEquals = function(t1, e) {
                return t1[0] === e[0] && t1[1] === e[1] && t1[2] === e[2] && t1[3] === e[3];
            }, A.equals = function(t1, r) {
                var n = t1[0], i = t1[1], a = t1[2], s = t1[3], o = r[0], l = r[1], u = r[2], c = r[3];
                return Math.abs(n - o) <= e.EPSILON * Math.max(1, Math.abs(n), Math.abs(o)) && Math.abs(i - l) <= e.EPSILON * Math.max(1, Math.abs(i), Math.abs(l)) && Math.abs(a - u) <= e.EPSILON * Math.max(1, Math.abs(a), Math.abs(u)) && Math.abs(s - c) <= e.EPSILON * Math.max(1, Math.abs(s), Math.abs(c));
            }, A.forEach = A.sqrLen = A.len = A.sqrDist = A.dist = A.div = A.mul = A.sub = void 0;
            var e = function(e, n) {
                if (e && e.__esModule) return e;
                if (null === e || "object" !== t1(e) && "function" != typeof e) return {
                    default: e
                };
                var i = r(void 0);
                if (i && i.has(e)) return i.get(e);
                var a = {}, s = Object.defineProperty && Object.getOwnPropertyDescriptor;
                for(var o in e)if ("default" !== o && Object.prototype.hasOwnProperty.call(e, o)) {
                    var l = s ? Object.getOwnPropertyDescriptor(e, o) : null;
                    l && (l.get || l.set) ? Object.defineProperty(a, o, l) : a[o] = e[o];
                }
                return a.default = e, i && i.set(e, a), a;
            }(a());
            function r(t1) {
                if ("function" != typeof WeakMap) return null;
                var e = new WeakMap, n = new WeakMap;
                return (r = function(t1) {
                    return t1 ? n : e;
                })(t1);
            }
            function n() {
                var t1 = new e.ARRAY_TYPE(4);
                return e.ARRAY_TYPE != Float32Array && (t1[0] = 0, t1[1] = 0, t1[2] = 0, t1[3] = 0), t1;
            }
            function i(t1, e, r) {
                return t1[0] = e[0] - r[0], t1[1] = e[1] - r[1], t1[2] = e[2] - r[2], t1[3] = e[3] - r[3], t1;
            }
            function s(t1, e, r) {
                return t1[0] = e[0] * r[0], t1[1] = e[1] * r[1], t1[2] = e[2] * r[2], t1[3] = e[3] * r[3], t1;
            }
            function o(t1, e, r) {
                return t1[0] = e[0] / r[0], t1[1] = e[1] / r[1], t1[2] = e[2] / r[2], t1[3] = e[3] / r[3], t1;
            }
            function l(t1, e) {
                return Math.hypot(e[0] - t1[0], e[1] - t1[1], e[2] - t1[2], e[3] - t1[3]);
            }
            function u(t1, e) {
                var r = e[0] - t1[0], n = e[1] - t1[1], i = e[2] - t1[2], a = e[3] - t1[3];
                return r * r + n * n + i * i + a * a;
            }
            function c(t1) {
                return Math.hypot(t1[0], t1[1], t1[2], t1[3]);
            }
            function h(t1) {
                var e = t1[0], r = t1[1], n = t1[2], i = t1[3];
                return e * e + r * r + n * n + i * i;
            }
            A.sub = i, A.mul = s, A.div = o, A.dist = l, A.sqrDist = u, A.len = c, A.sqrLen = h;
            var p, f = (p = n(), function(t1, e, r, n, i, a) {
                var s, o;
                for(e || (e = 4), r || (r = 0), o = n ? Math.min(n * e + r, t1.length) : t1.length, s = r; s < o; s += e)p[0] = t1[s], p[1] = t1[s + 1], p[2] = t1[s + 2], p[3] = t1[s + 3], i(p, p, a), t1[s] = p[0], t1[s + 1] = p[1], t1[s + 2] = p[2], t1[s + 3] = p[3];
                return t1;
            });
            return A.forEach = f, A;
        }
        function I() {
            if (M) return v;
            function t1(e) {
                return t1 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(t1) {
                    return typeof t1;
                } : function(t1) {
                    return t1 && "function" == typeof Symbol && t1.constructor === Symbol && t1 !== Symbol.prototype ? "symbol" : typeof t1;
                }, t1(e);
            }
            M = 1, Object.defineProperty(v, "__esModule", {
                value: !0
            }), v.create = l, v.identity = function(t1) {
                return t1[0] = 0, t1[1] = 0, t1[2] = 0, t1[3] = 1, t1;
            }, v.setAxisAngle = u, v.getAxisAngle = function(t1, r) {
                var n = 2 * Math.acos(r[3]), i = Math.sin(n / 2);
                return i > e.EPSILON ? (t1[0] = r[0] / i, t1[1] = r[1] / i, t1[2] = r[2] / i) : (t1[0] = 1, t1[1] = 0, t1[2] = 0), n;
            }, v.getAngle = function(t1, e) {
                var r = g(t1, e);
                return Math.acos(2 * r * r - 1);
            }, v.multiply = c, v.rotateX = function(t1, e, r) {
                r *= .5;
                var n = e[0], i = e[1], a = e[2], s = e[3], o = Math.sin(r), l = Math.cos(r);
                return t1[0] = n * l + s * o, t1[1] = i * l + a * o, t1[2] = a * l - i * o, t1[3] = s * l - n * o, t1;
            }, v.rotateY = function(t1, e, r) {
                r *= .5;
                var n = e[0], i = e[1], a = e[2], s = e[3], o = Math.sin(r), l = Math.cos(r);
                return t1[0] = n * l - a * o, t1[1] = i * l + s * o, t1[2] = a * l + n * o, t1[3] = s * l - i * o, t1;
            }, v.rotateZ = function(t1, e, r) {
                r *= .5;
                var n = e[0], i = e[1], a = e[2], s = e[3], o = Math.sin(r), l = Math.cos(r);
                return t1[0] = n * l + i * o, t1[1] = i * l - n * o, t1[2] = a * l + s * o, t1[3] = s * l - a * o, t1;
            }, v.calculateW = function(t1, e) {
                var r = e[0], n = e[1], i = e[2];
                return t1[0] = r, t1[1] = n, t1[2] = i, t1[3] = Math.sqrt(Math.abs(1 - r * r - n * n - i * i)), t1;
            }, v.exp = h, v.ln = p, v.pow = function(t1, e, r) {
                return p(t1, e), y(t1, t1, r), h(t1, t1), t1;
            }, v.slerp = f, v.random = function(t1) {
                var r = e.RANDOM(), n = e.RANDOM(), i = e.RANDOM(), a = Math.sqrt(1 - r), s = Math.sqrt(r);
                return t1[0] = a * Math.sin(2 * Math.PI * n), t1[1] = a * Math.cos(2 * Math.PI * n), t1[2] = s * Math.sin(2 * Math.PI * i), t1[3] = s * Math.cos(2 * Math.PI * i), t1;
            }, v.invert = function(t1, e) {
                var r = e[0], n = e[1], i = e[2], a = e[3], s = r * r + n * n + i * i + a * a, o = s ? 1 / s : 0;
                return t1[0] = -r * o, t1[1] = -n * o, t1[2] = -i * o, t1[3] = a * o, t1;
            }, v.conjugate = function(t1, e) {
                return t1[0] = -e[0], t1[1] = -e[1], t1[2] = -e[2], t1[3] = e[3], t1;
            }, v.fromMat3 = m, v.fromEuler = function(t1, e, r, n) {
                var i = .5 * Math.PI / 180;
                e *= i, r *= i, n *= i;
                var a = Math.sin(e), s = Math.cos(e), o = Math.sin(r), l = Math.cos(r), u = Math.sin(n), c = Math.cos(n);
                return t1[0] = a * l * c - s * o * u, t1[1] = s * o * c + a * l * u, t1[2] = s * l * u - a * o * c, t1[3] = s * l * c + a * o * u, t1;
            }, v.str = function(t1) {
                return "quat(" + t1[0] + ", " + t1[1] + ", " + t1[2] + ", " + t1[3] + ")";
            }, v.setAxes = v.sqlerp = v.rotationTo = v.equals = v.exactEquals = v.normalize = v.sqrLen = v.squaredLength = v.len = v.length = v.lerp = v.dot = v.scale = v.mul = v.add = v.set = v.copy = v.fromValues = v.clone = void 0;
            var e = o(a()), r = o(d()), n = o(_()), i = o(S());
            function s(t1) {
                if ("function" != typeof WeakMap) return null;
                var e = new WeakMap, r = new WeakMap;
                return (s = function(t1) {
                    return t1 ? r : e;
                })(t1);
            }
            function o(e, r) {
                if (e && e.__esModule) return e;
                if (null === e || "object" !== t1(e) && "function" != typeof e) return {
                    default: e
                };
                var n = s(r);
                if (n && n.has(e)) return n.get(e);
                var i = {}, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
                for(var o in e)if ("default" !== o && Object.prototype.hasOwnProperty.call(e, o)) {
                    var l = a ? Object.getOwnPropertyDescriptor(e, o) : null;
                    l && (l.get || l.set) ? Object.defineProperty(i, o, l) : i[o] = e[o];
                }
                return i.default = e, n && n.set(e, i), i;
            }
            function l() {
                var t1 = new e.ARRAY_TYPE(4);
                return e.ARRAY_TYPE != Float32Array && (t1[0] = 0, t1[1] = 0, t1[2] = 0), t1[3] = 1, t1;
            }
            function u(t1, e, r) {
                r *= .5;
                var n = Math.sin(r);
                return t1[0] = n * e[0], t1[1] = n * e[1], t1[2] = n * e[2], t1[3] = Math.cos(r), t1;
            }
            function c(t1, e, r) {
                var n = e[0], i = e[1], a = e[2], s = e[3], o = r[0], l = r[1], u = r[2], c = r[3];
                return t1[0] = n * c + s * o + i * u - a * l, t1[1] = i * c + s * l + a * o - n * u, t1[2] = a * c + s * u + n * l - i * o, t1[3] = s * c - n * o - i * l - a * u, t1;
            }
            function h(t1, e) {
                var r = e[0], n = e[1], i = e[2], a = e[3], s = Math.sqrt(r * r + n * n + i * i), o = Math.exp(a), l = s > 0 ? o * Math.sin(s) / s : 0;
                return t1[0] = r * l, t1[1] = n * l, t1[2] = i * l, t1[3] = o * Math.cos(s), t1;
            }
            function p(t1, e) {
                var r = e[0], n = e[1], i = e[2], a = e[3], s = Math.sqrt(r * r + n * n + i * i), o = s > 0 ? Math.atan2(s, a) / s : 0;
                return t1[0] = r * o, t1[1] = n * o, t1[2] = i * o, t1[3] = .5 * Math.log(r * r + n * n + i * i + a * a), t1;
            }
            function f(t1, r, n, i) {
                var a, s, o, l, u, c = r[0], h = r[1], p = r[2], f = r[3], d = n[0], m = n[1], y = n[2], g = n[3];
                return (s = c * d + h * m + p * y + f * g) < 0 && (s = -s, d = -d, m = -m, y = -y, g = -g), 1 - s > e.EPSILON ? (a = Math.acos(s), o = Math.sin(a), l = Math.sin((1 - i) * a) / o, u = Math.sin(i * a) / o) : (l = 1 - i, u = i), t1[0] = l * c + u * d, t1[1] = l * h + u * m, t1[2] = l * p + u * y, t1[3] = l * f + u * g, t1;
            }
            function m(t1, e) {
                var r, n = e[0] + e[4] + e[8];
                if (n > 0) r = Math.sqrt(n + 1), t1[3] = .5 * r, t1[0] = (e[5] - e[7]) * (r = .5 / r), t1[1] = (e[6] - e[2]) * r, t1[2] = (e[1] - e[3]) * r;
                else {
                    var i = 0;
                    e[4] > e[0] && (i = 1), e[8] > e[3 * i + i] && (i = 2);
                    var a = (i + 1) % 3, s = (i + 2) % 3;
                    r = Math.sqrt(e[3 * i + i] - e[3 * a + a] - e[3 * s + s] + 1), t1[i] = .5 * r, t1[3] = (e[3 * a + s] - e[3 * s + a]) * (r = .5 / r), t1[a] = (e[3 * a + i] + e[3 * i + a]) * r, t1[s] = (e[3 * s + i] + e[3 * i + s]) * r;
                }
                return t1;
            }
            v.clone = i.clone, v.fromValues = i.fromValues, v.copy = i.copy, v.set = i.set, v.add = i.add, v.mul = c;
            var y = i.scale;
            v.scale = y;
            var g = i.dot;
            v.dot = g, v.lerp = i.lerp;
            var x = i.length;
            v.length = x, v.len = x;
            var b = i.squaredLength;
            v.squaredLength = b, v.sqrLen = b;
            var w = i.normalize;
            v.normalize = w, v.exactEquals = i.exactEquals, v.equals = i.equals;
            var A, I, P, z = (A = n.create(), I = n.fromValues(1, 0, 0), P = n.fromValues(0, 1, 0), function(t1, e, r) {
                var i = n.dot(e, r);
                return i < -0.999999 ? (n.cross(A, I, e), n.len(A) < 1e-6 && n.cross(A, P, e), n.normalize(A, A), u(t1, A, Math.PI), t1) : i > .999999 ? (t1[0] = 0, t1[1] = 0, t1[2] = 0, t1[3] = 1, t1) : (n.cross(A, e, r), t1[0] = A[0], t1[1] = A[1], t1[2] = A[2], t1[3] = 1 + i, w(t1, t1));
            });
            v.rotationTo = z;
            var E, k, T = (E = l(), k = l(), function(t1, e, r, n, i, a) {
                return f(E, e, i, a), f(k, r, n, a), f(t1, E, k, 2 * a * (1 - a)), t1;
            });
            v.sqlerp = T;
            var B, C = (B = r.create(), function(t1, e, r, n) {
                return B[0] = r[0], B[3] = r[1], B[6] = r[2], B[1] = n[0], B[4] = n[1], B[7] = n[2], B[2] = -e[0], B[5] = -e[1], B[8] = -e[2], w(t1, m(t1, B));
            });
            return v.setAxes = C, v;
        }
        var P, z = {};
        function E() {
            if (P) return z;
            function t1(e) {
                return t1 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(t1) {
                    return typeof t1;
                } : function(t1) {
                    return t1 && "function" == typeof Symbol && t1.constructor === Symbol && t1 !== Symbol.prototype ? "symbol" : typeof t1;
                }, t1(e);
            }
            P = 1, Object.defineProperty(z, "__esModule", {
                value: !0
            }), z.create = function() {
                var t1 = new e.ARRAY_TYPE(8);
                return e.ARRAY_TYPE != Float32Array && (t1[0] = 0, t1[1] = 0, t1[2] = 0, t1[4] = 0, t1[5] = 0, t1[6] = 0, t1[7] = 0), t1[3] = 1, t1;
            }, z.clone = function(t1) {
                var r = new e.ARRAY_TYPE(8);
                return r[0] = t1[0], r[1] = t1[1], r[2] = t1[2], r[3] = t1[3], r[4] = t1[4], r[5] = t1[5], r[6] = t1[6], r[7] = t1[7], r;
            }, z.fromValues = function(t1, r, n, i, a, s, o, l) {
                var u = new e.ARRAY_TYPE(8);
                return u[0] = t1, u[1] = r, u[2] = n, u[3] = i, u[4] = a, u[5] = s, u[6] = o, u[7] = l, u;
            }, z.fromRotationTranslationValues = function(t1, r, n, i, a, s, o) {
                var l = new e.ARRAY_TYPE(8);
                l[0] = t1, l[1] = r, l[2] = n, l[3] = i;
                var u = .5 * a, c = .5 * s, h = .5 * o;
                return l[4] = u * i + c * n - h * r, l[5] = c * i + h * t1 - u * n, l[6] = h * i + u * r - c * t1, l[7] = -u * t1 - c * r - h * n, l;
            }, z.fromRotationTranslation = o, z.fromTranslation = function(t1, e) {
                return t1[0] = 0, t1[1] = 0, t1[2] = 0, t1[3] = 1, t1[4] = .5 * e[0], t1[5] = .5 * e[1], t1[6] = .5 * e[2], t1[7] = 0, t1;
            }, z.fromRotation = function(t1, e) {
                return t1[0] = e[0], t1[1] = e[1], t1[2] = e[2], t1[3] = e[3], t1[4] = 0, t1[5] = 0, t1[6] = 0, t1[7] = 0, t1;
            }, z.fromMat4 = function(t1, i) {
                var a = r.create();
                n.getRotation(a, i);
                var s = new e.ARRAY_TYPE(3);
                return n.getTranslation(s, i), o(t1, a, s), t1;
            }, z.copy = l, z.identity = function(t1) {
                return t1[0] = 0, t1[1] = 0, t1[2] = 0, t1[3] = 1, t1[4] = 0, t1[5] = 0, t1[6] = 0, t1[7] = 0, t1;
            }, z.set = function(t1, e, r, n, i, a, s, o, l) {
                return t1[0] = e, t1[1] = r, t1[2] = n, t1[3] = i, t1[4] = a, t1[5] = s, t1[6] = o, t1[7] = l, t1;
            }, z.getDual = function(t1, e) {
                return t1[0] = e[4], t1[1] = e[5], t1[2] = e[6], t1[3] = e[7], t1;
            }, z.setDual = function(t1, e) {
                return t1[4] = e[0], t1[5] = e[1], t1[6] = e[2], t1[7] = e[3], t1;
            }, z.getTranslation = function(t1, e) {
                var r = e[4], n = e[5], i = e[6], a = e[7], s = -e[0], o = -e[1], l = -e[2], u = e[3];
                return t1[0] = 2 * (r * u + a * s + n * l - i * o), t1[1] = 2 * (n * u + a * o + i * s - r * l), t1[2] = 2 * (i * u + a * l + r * o - n * s), t1;
            }, z.translate = function(t1, e, r) {
                var n = e[0], i = e[1], a = e[2], s = e[3], o = .5 * r[0], l = .5 * r[1], u = .5 * r[2], c = e[4], h = e[5], p = e[6], f = e[7];
                return t1[0] = n, t1[1] = i, t1[2] = a, t1[3] = s, t1[4] = s * o + i * u - a * l + c, t1[5] = s * l + a * o - n * u + h, t1[6] = s * u + n * l - i * o + p, t1[7] = -n * o - i * l - a * u + f, t1;
            }, z.rotateX = function(t1, e, n) {
                var i = -e[0], a = -e[1], s = -e[2], o = e[3], l = e[4], u = e[5], c = e[6], h = e[7], p = l * o + h * i + u * s - c * a, f = u * o + h * a + c * i - l * s, d = c * o + h * s + l * a - u * i, m = h * o - l * i - u * a - c * s;
                return r.rotateX(t1, e, n), t1[4] = p * (o = t1[3]) + m * (i = t1[0]) + f * (s = t1[2]) - d * (a = t1[1]), t1[5] = f * o + m * a + d * i - p * s, t1[6] = d * o + m * s + p * a - f * i, t1[7] = m * o - p * i - f * a - d * s, t1;
            }, z.rotateY = function(t1, e, n) {
                var i = -e[0], a = -e[1], s = -e[2], o = e[3], l = e[4], u = e[5], c = e[6], h = e[7], p = l * o + h * i + u * s - c * a, f = u * o + h * a + c * i - l * s, d = c * o + h * s + l * a - u * i, m = h * o - l * i - u * a - c * s;
                return r.rotateY(t1, e, n), t1[4] = p * (o = t1[3]) + m * (i = t1[0]) + f * (s = t1[2]) - d * (a = t1[1]), t1[5] = f * o + m * a + d * i - p * s, t1[6] = d * o + m * s + p * a - f * i, t1[7] = m * o - p * i - f * a - d * s, t1;
            }, z.rotateZ = function(t1, e, n) {
                var i = -e[0], a = -e[1], s = -e[2], o = e[3], l = e[4], u = e[5], c = e[6], h = e[7], p = l * o + h * i + u * s - c * a, f = u * o + h * a + c * i - l * s, d = c * o + h * s + l * a - u * i, m = h * o - l * i - u * a - c * s;
                return r.rotateZ(t1, e, n), t1[4] = p * (o = t1[3]) + m * (i = t1[0]) + f * (s = t1[2]) - d * (a = t1[1]), t1[5] = f * o + m * a + d * i - p * s, t1[6] = d * o + m * s + p * a - f * i, t1[7] = m * o - p * i - f * a - d * s, t1;
            }, z.rotateByQuatAppend = function(t1, e, r) {
                var n = r[0], i = r[1], a = r[2], s = r[3], o = e[0], l = e[1], u = e[2], c = e[3];
                return t1[0] = o * s + c * n + l * a - u * i, t1[1] = l * s + c * i + u * n - o * a, t1[2] = u * s + c * a + o * i - l * n, t1[3] = c * s - o * n - l * i - u * a, t1[4] = (o = e[4]) * s + (c = e[7]) * n + (l = e[5]) * a - (u = e[6]) * i, t1[5] = l * s + c * i + u * n - o * a, t1[6] = u * s + c * a + o * i - l * n, t1[7] = c * s - o * n - l * i - u * a, t1;
            }, z.rotateByQuatPrepend = function(t1, e, r) {
                var n = e[0], i = e[1], a = e[2], s = e[3], o = r[0], l = r[1], u = r[2], c = r[3];
                return t1[0] = n * c + s * o + i * u - a * l, t1[1] = i * c + s * l + a * o - n * u, t1[2] = a * c + s * u + n * l - i * o, t1[3] = s * c - n * o - i * l - a * u, t1[4] = n * (c = r[7]) + s * (o = r[4]) + i * (u = r[6]) - a * (l = r[5]), t1[5] = i * c + s * l + a * o - n * u, t1[6] = a * c + s * u + n * l - i * o, t1[7] = s * c - n * o - i * l - a * u, t1;
            }, z.rotateAroundAxis = function(t1, r, n, i) {
                if (Math.abs(i) < e.EPSILON) return l(t1, r);
                var a = Math.hypot(n[0], n[1], n[2]);
                i *= .5;
                var s = Math.sin(i), o = s * n[0] / a, u = s * n[1] / a, c = s * n[2] / a, h = Math.cos(i), p = r[0], f = r[1], d = r[2], m = r[3];
                t1[0] = p * h + m * o + f * c - d * u, t1[1] = f * h + m * u + d * o - p * c, t1[2] = d * h + m * c + p * u - f * o, t1[3] = m * h - p * o - f * u - d * c;
                var y = r[4], g = r[5], x = r[6], v = r[7];
                return t1[4] = y * h + v * o + g * c - x * u, t1[5] = g * h + v * u + x * o - y * c, t1[6] = x * h + v * c + y * u - g * o, t1[7] = v * h - y * o - g * u - x * c, t1;
            }, z.add = function(t1, e, r) {
                return t1[0] = e[0] + r[0], t1[1] = e[1] + r[1], t1[2] = e[2] + r[2], t1[3] = e[3] + r[3], t1[4] = e[4] + r[4], t1[5] = e[5] + r[5], t1[6] = e[6] + r[6], t1[7] = e[7] + r[7], t1;
            }, z.multiply = u, z.scale = function(t1, e, r) {
                return t1[0] = e[0] * r, t1[1] = e[1] * r, t1[2] = e[2] * r, t1[3] = e[3] * r, t1[4] = e[4] * r, t1[5] = e[5] * r, t1[6] = e[6] * r, t1[7] = e[7] * r, t1;
            }, z.lerp = function(t1, e, r, n) {
                var i = 1 - n;
                return c(e, r) < 0 && (n = -n), t1[0] = e[0] * i + r[0] * n, t1[1] = e[1] * i + r[1] * n, t1[2] = e[2] * i + r[2] * n, t1[3] = e[3] * i + r[3] * n, t1[4] = e[4] * i + r[4] * n, t1[5] = e[5] * i + r[5] * n, t1[6] = e[6] * i + r[6] * n, t1[7] = e[7] * i + r[7] * n, t1;
            }, z.invert = function(t1, e) {
                var r = p(e);
                return t1[0] = -e[0] / r, t1[1] = -e[1] / r, t1[2] = -e[2] / r, t1[3] = e[3] / r, t1[4] = -e[4] / r, t1[5] = -e[5] / r, t1[6] = -e[6] / r, t1[7] = e[7] / r, t1;
            }, z.conjugate = function(t1, e) {
                return t1[0] = -e[0], t1[1] = -e[1], t1[2] = -e[2], t1[3] = e[3], t1[4] = -e[4], t1[5] = -e[5], t1[6] = -e[6], t1[7] = e[7], t1;
            }, z.normalize = function(t1, e) {
                var r = p(e);
                if (r > 0) {
                    r = Math.sqrt(r);
                    var n = e[0] / r, i = e[1] / r, a = e[2] / r, s = e[3] / r, o = e[4], l = e[5], u = e[6], c = e[7], h = n * o + i * l + a * u + s * c;
                    t1[0] = n, t1[1] = i, t1[2] = a, t1[3] = s, t1[4] = (o - n * h) / r, t1[5] = (l - i * h) / r, t1[6] = (u - a * h) / r, t1[7] = (c - s * h) / r;
                }
                return t1;
            }, z.str = function(t1) {
                return "quat2(" + t1[0] + ", " + t1[1] + ", " + t1[2] + ", " + t1[3] + ", " + t1[4] + ", " + t1[5] + ", " + t1[6] + ", " + t1[7] + ")";
            }, z.exactEquals = function(t1, e) {
                return t1[0] === e[0] && t1[1] === e[1] && t1[2] === e[2] && t1[3] === e[3] && t1[4] === e[4] && t1[5] === e[5] && t1[6] === e[6] && t1[7] === e[7];
            }, z.equals = function(t1, r) {
                var n = t1[0], i = t1[1], a = t1[2], s = t1[3], o = t1[4], l = t1[5], u = t1[6], c = t1[7], h = r[0], p = r[1], f = r[2], d = r[3], m = r[4], y = r[5], g = r[6], x = r[7];
                return Math.abs(n - h) <= e.EPSILON * Math.max(1, Math.abs(n), Math.abs(h)) && Math.abs(i - p) <= e.EPSILON * Math.max(1, Math.abs(i), Math.abs(p)) && Math.abs(a - f) <= e.EPSILON * Math.max(1, Math.abs(a), Math.abs(f)) && Math.abs(s - d) <= e.EPSILON * Math.max(1, Math.abs(s), Math.abs(d)) && Math.abs(o - m) <= e.EPSILON * Math.max(1, Math.abs(o), Math.abs(m)) && Math.abs(l - y) <= e.EPSILON * Math.max(1, Math.abs(l), Math.abs(y)) && Math.abs(u - g) <= e.EPSILON * Math.max(1, Math.abs(u), Math.abs(g)) && Math.abs(c - x) <= e.EPSILON * Math.max(1, Math.abs(c), Math.abs(x));
            }, z.sqrLen = z.squaredLength = z.len = z.length = z.dot = z.mul = z.setReal = z.getReal = void 0;
            var e = s(a()), r = s(I()), n = s(g());
            function i(t1) {
                if ("function" != typeof WeakMap) return null;
                var e = new WeakMap, r = new WeakMap;
                return (i = function(t1) {
                    return t1 ? r : e;
                })(t1);
            }
            function s(e, r) {
                if (e && e.__esModule) return e;
                if (null === e || "object" !== t1(e) && "function" != typeof e) return {
                    default: e
                };
                var n = i(r);
                if (n && n.has(e)) return n.get(e);
                var a = {}, s = Object.defineProperty && Object.getOwnPropertyDescriptor;
                for(var o in e)if ("default" !== o && Object.prototype.hasOwnProperty.call(e, o)) {
                    var l = s ? Object.getOwnPropertyDescriptor(e, o) : null;
                    l && (l.get || l.set) ? Object.defineProperty(a, o, l) : a[o] = e[o];
                }
                return a.default = e, n && n.set(e, a), a;
            }
            function o(t1, e, r) {
                var n = .5 * r[0], i = .5 * r[1], a = .5 * r[2], s = e[0], o = e[1], l = e[2], u = e[3];
                return t1[0] = s, t1[1] = o, t1[2] = l, t1[3] = u, t1[4] = n * u + i * l - a * o, t1[5] = i * u + a * s - n * l, t1[6] = a * u + n * o - i * s, t1[7] = -n * s - i * o - a * l, t1;
            }
            function l(t1, e) {
                return t1[0] = e[0], t1[1] = e[1], t1[2] = e[2], t1[3] = e[3], t1[4] = e[4], t1[5] = e[5], t1[6] = e[6], t1[7] = e[7], t1;
            }
            function u(t1, e, r) {
                var n = e[0], i = e[1], a = e[2], s = e[3], o = r[4], l = r[5], u = r[6], c = r[7], h = e[4], p = e[5], f = e[6], d = e[7], m = r[0], y = r[1], g = r[2], x = r[3];
                return t1[0] = n * x + s * m + i * g - a * y, t1[1] = i * x + s * y + a * m - n * g, t1[2] = a * x + s * g + n * y - i * m, t1[3] = s * x - n * m - i * y - a * g, t1[4] = n * c + s * o + i * u - a * l + h * x + d * m + p * g - f * y, t1[5] = i * c + s * l + a * o - n * u + p * x + d * y + f * m - h * g, t1[6] = a * c + s * u + n * l - i * o + f * x + d * g + h * y - p * m, t1[7] = s * c - n * o - i * l - a * u + d * x - h * m - p * y - f * g, t1;
            }
            z.getReal = r.copy, z.setReal = r.copy, z.mul = u;
            var c = r.dot;
            z.dot = c;
            var h = r.length;
            z.length = h, z.len = h;
            var p = r.squaredLength;
            return z.squaredLength = p, z.sqrLen = p, z;
        }
        var k, T, B = {};
        function C() {
            if (k) return B;
            function t1(e) {
                return t1 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(t1) {
                    return typeof t1;
                } : function(t1) {
                    return t1 && "function" == typeof Symbol && t1.constructor === Symbol && t1 !== Symbol.prototype ? "symbol" : typeof t1;
                }, t1(e);
            }
            k = 1, Object.defineProperty(B, "__esModule", {
                value: !0
            }), B.create = n, B.clone = function(t1) {
                var r = new e.ARRAY_TYPE(2);
                return r[0] = t1[0], r[1] = t1[1], r;
            }, B.fromValues = function(t1, r) {
                var n = new e.ARRAY_TYPE(2);
                return n[0] = t1, n[1] = r, n;
            }, B.copy = function(t1, e) {
                return t1[0] = e[0], t1[1] = e[1], t1;
            }, B.set = function(t1, e, r) {
                return t1[0] = e, t1[1] = r, t1;
            }, B.add = function(t1, e, r) {
                return t1[0] = e[0] + r[0], t1[1] = e[1] + r[1], t1;
            }, B.subtract = i, B.multiply = s, B.divide = o, B.ceil = function(t1, e) {
                return t1[0] = Math.ceil(e[0]), t1[1] = Math.ceil(e[1]), t1;
            }, B.floor = function(t1, e) {
                return t1[0] = Math.floor(e[0]), t1[1] = Math.floor(e[1]), t1;
            }, B.min = function(t1, e, r) {
                return t1[0] = Math.min(e[0], r[0]), t1[1] = Math.min(e[1], r[1]), t1;
            }, B.max = function(t1, e, r) {
                return t1[0] = Math.max(e[0], r[0]), t1[1] = Math.max(e[1], r[1]), t1;
            }, B.round = function(t1, e) {
                return t1[0] = Math.round(e[0]), t1[1] = Math.round(e[1]), t1;
            }, B.scale = function(t1, e, r) {
                return t1[0] = e[0] * r, t1[1] = e[1] * r, t1;
            }, B.scaleAndAdd = function(t1, e, r, n) {
                return t1[0] = e[0] + r[0] * n, t1[1] = e[1] + r[1] * n, t1;
            }, B.distance = l, B.squaredDistance = u, B.length = c, B.squaredLength = h, B.negate = function(t1, e) {
                return t1[0] = -e[0], t1[1] = -e[1], t1;
            }, B.inverse = function(t1, e) {
                return t1[0] = 1 / e[0], t1[1] = 1 / e[1], t1;
            }, B.normalize = function(t1, e) {
                var r = e[0], n = e[1], i = r * r + n * n;
                return i > 0 && (i = 1 / Math.sqrt(i)), t1[0] = e[0] * i, t1[1] = e[1] * i, t1;
            }, B.dot = function(t1, e) {
                return t1[0] * e[0] + t1[1] * e[1];
            }, B.cross = function(t1, e, r) {
                var n = e[0] * r[1] - e[1] * r[0];
                return t1[0] = t1[1] = 0, t1[2] = n, t1;
            }, B.lerp = function(t1, e, r, n) {
                var i = e[0], a = e[1];
                return t1[0] = i + n * (r[0] - i), t1[1] = a + n * (r[1] - a), t1;
            }, B.random = function(t1, r) {
                r = r || 1;
                var n = 2 * e.RANDOM() * Math.PI;
                return t1[0] = Math.cos(n) * r, t1[1] = Math.sin(n) * r, t1;
            }, B.transformMat2 = function(t1, e, r) {
                var n = e[0], i = e[1];
                return t1[0] = r[0] * n + r[2] * i, t1[1] = r[1] * n + r[3] * i, t1;
            }, B.transformMat2d = function(t1, e, r) {
                var n = e[0], i = e[1];
                return t1[0] = r[0] * n + r[2] * i + r[4], t1[1] = r[1] * n + r[3] * i + r[5], t1;
            }, B.transformMat3 = function(t1, e, r) {
                var n = e[0], i = e[1];
                return t1[0] = r[0] * n + r[3] * i + r[6], t1[1] = r[1] * n + r[4] * i + r[7], t1;
            }, B.transformMat4 = function(t1, e, r) {
                var n = e[0], i = e[1];
                return t1[0] = r[0] * n + r[4] * i + r[12], t1[1] = r[1] * n + r[5] * i + r[13], t1;
            }, B.rotate = function(t1, e, r, n) {
                var i = e[0] - r[0], a = e[1] - r[1], s = Math.sin(n), o = Math.cos(n);
                return t1[0] = i * o - a * s + r[0], t1[1] = i * s + a * o + r[1], t1;
            }, B.angle = function(t1, e) {
                var r = t1[0], n = t1[1], i = e[0], a = e[1], s = Math.sqrt(r * r + n * n) * Math.sqrt(i * i + a * a);
                return Math.acos(Math.min(Math.max(s && (r * i + n * a) / s, -1), 1));
            }, B.zero = function(t1) {
                return t1[0] = 0, t1[1] = 0, t1;
            }, B.str = function(t1) {
                return "vec2(" + t1[0] + ", " + t1[1] + ")";
            }, B.exactEquals = function(t1, e) {
                return t1[0] === e[0] && t1[1] === e[1];
            }, B.equals = function(t1, r) {
                var n = t1[0], i = t1[1], a = r[0], s = r[1];
                return Math.abs(n - a) <= e.EPSILON * Math.max(1, Math.abs(n), Math.abs(a)) && Math.abs(i - s) <= e.EPSILON * Math.max(1, Math.abs(i), Math.abs(s));
            }, B.forEach = B.sqrLen = B.sqrDist = B.dist = B.div = B.mul = B.sub = B.len = void 0;
            var e = function(e, n) {
                if (e && e.__esModule) return e;
                if (null === e || "object" !== t1(e) && "function" != typeof e) return {
                    default: e
                };
                var i = r(void 0);
                if (i && i.has(e)) return i.get(e);
                var a = {}, s = Object.defineProperty && Object.getOwnPropertyDescriptor;
                for(var o in e)if ("default" !== o && Object.prototype.hasOwnProperty.call(e, o)) {
                    var l = s ? Object.getOwnPropertyDescriptor(e, o) : null;
                    l && (l.get || l.set) ? Object.defineProperty(a, o, l) : a[o] = e[o];
                }
                return a.default = e, i && i.set(e, a), a;
            }(a());
            function r(t1) {
                if ("function" != typeof WeakMap) return null;
                var e = new WeakMap, n = new WeakMap;
                return (r = function(t1) {
                    return t1 ? n : e;
                })(t1);
            }
            function n() {
                var t1 = new e.ARRAY_TYPE(2);
                return e.ARRAY_TYPE != Float32Array && (t1[0] = 0, t1[1] = 0), t1;
            }
            function i(t1, e, r) {
                return t1[0] = e[0] - r[0], t1[1] = e[1] - r[1], t1;
            }
            function s(t1, e, r) {
                return t1[0] = e[0] * r[0], t1[1] = e[1] * r[1], t1;
            }
            function o(t1, e, r) {
                return t1[0] = e[0] / r[0], t1[1] = e[1] / r[1], t1;
            }
            function l(t1, e) {
                return Math.hypot(e[0] - t1[0], e[1] - t1[1]);
            }
            function u(t1, e) {
                var r = e[0] - t1[0], n = e[1] - t1[1];
                return r * r + n * n;
            }
            function c(t1) {
                return Math.hypot(t1[0], t1[1]);
            }
            function h(t1) {
                var e = t1[0], r = t1[1];
                return e * e + r * r;
            }
            B.len = c, B.sub = i, B.mul = s, B.div = o, B.dist = l, B.sqrDist = u, B.sqrLen = h;
            var p, f = (p = n(), function(t1, e, r, n, i, a) {
                var s, o;
                for(e || (e = 2), r || (r = 0), o = n ? Math.min(n * e + r, t1.length) : t1.length, s = r; s < o; s += e)p[0] = t1[s], p[1] = t1[s + 1], i(p, p, a), t1[s] = p[0], t1[s + 1] = p[1];
                return t1;
            });
            return B.forEach = f, B;
        }
        function V() {
            if (T) return n;
            function t1(e) {
                return t1 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(t1) {
                    return typeof t1;
                } : function(t1) {
                    return t1 && "function" == typeof Symbol && t1.constructor === Symbol && t1 !== Symbol.prototype ? "symbol" : typeof t1;
                }, t1(e);
            }
            T = 1, Object.defineProperty(n, "__esModule", {
                value: !0
            }), n.vec4 = n.vec3 = n.vec2 = n.quat2 = n.quat = n.mat4 = n.mat3 = n.mat2d = n.mat2 = n.glMatrix = void 0;
            var e = x(a());
            n.glMatrix = e;
            var r = x(l());
            n.mat2 = r;
            var i = x(h());
            n.mat2d = i;
            var s = x(d());
            n.mat3 = s;
            var o = x(g());
            n.mat4 = o;
            var u = x(I());
            n.quat = u;
            var c = x(E());
            n.quat2 = c;
            var p = x(C());
            n.vec2 = p;
            var f = x(_());
            n.vec3 = f;
            var m = x(S());
            function y(t1) {
                if ("function" != typeof WeakMap) return null;
                var e = new WeakMap, r = new WeakMap;
                return (y = function(t1) {
                    return t1 ? r : e;
                })(t1);
            }
            function x(e, r) {
                if (e && e.__esModule) return e;
                if (null === e || "object" !== t1(e) && "function" != typeof e) return {
                    default: e
                };
                var n = y(r);
                if (n && n.has(e)) return n.get(e);
                var i = {}, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
                for(var s in e)if ("default" !== s && Object.prototype.hasOwnProperty.call(e, s)) {
                    var o = a ? Object.getOwnPropertyDescriptor(e, s) : null;
                    o && (o.get || o.set) ? Object.defineProperty(i, s, o) : i[s] = e[s];
                }
                return i.default = e, n && n.set(e, i), i;
            }
            return n.vec4 = m, n;
        }
        var D, L, R, F, O = V(), N = function() {
            if (L) return D;
            function t1(t1, e, r, n) {
                this.cx = 3 * t1, this.bx = 3 * (r - t1) - this.cx, this.ax = 1 - this.cx - this.bx, this.cy = 3 * e, this.by = 3 * (n - e) - this.cy, this.ay = 1 - this.cy - this.by, this.p1x = t1, this.p1y = e, this.p2x = r, this.p2y = n;
            }
            return L = 1, D = t1, t1.prototype = {
                sampleCurveX: function(t1) {
                    return ((this.ax * t1 + this.bx) * t1 + this.cx) * t1;
                },
                sampleCurveY: function(t1) {
                    return ((this.ay * t1 + this.by) * t1 + this.cy) * t1;
                },
                sampleCurveDerivativeX: function(t1) {
                    return (3 * this.ax * t1 + 2 * this.bx) * t1 + this.cx;
                },
                solveCurveX: function(t1, e) {
                    if (void 0 === e && (e = 1e-6), t1 < 0) return 0;
                    if (t1 > 1) return 1;
                    for(var r = t1, n = 0; n < 8; n++){
                        var i = this.sampleCurveX(r) - t1;
                        if (Math.abs(i) < e) return r;
                        var a = this.sampleCurveDerivativeX(r);
                        if (Math.abs(a) < 1e-6) break;
                        r -= i / a;
                    }
                    var s = 0, o = 1;
                    for(r = t1, n = 0; n < 20 && (i = this.sampleCurveX(r), !(Math.abs(i - t1) < e)); n++)t1 > i ? s = r : o = r, r = .5 * (o - s) + s;
                    return r;
                },
                solve: function(t1, e) {
                    return this.sampleCurveY(this.solveCurveX(t1, e));
                }
            }, D;
        }(), U = e(N);
        function j() {
            if (F) return R;
            function t1(t1, e) {
                this.x = t1, this.y = e;
            }
            return F = 1, R = t1, t1.prototype = {
                clone: function() {
                    return new t1(this.x, this.y);
                },
                add: function(t1) {
                    return this.clone()._add(t1);
                },
                sub: function(t1) {
                    return this.clone()._sub(t1);
                },
                multByPoint: function(t1) {
                    return this.clone()._multByPoint(t1);
                },
                divByPoint: function(t1) {
                    return this.clone()._divByPoint(t1);
                },
                mult: function(t1) {
                    return this.clone()._mult(t1);
                },
                div: function(t1) {
                    return this.clone()._div(t1);
                },
                rotate: function(t1) {
                    return this.clone()._rotate(t1);
                },
                rotateAround: function(t1, e) {
                    return this.clone()._rotateAround(t1, e);
                },
                matMult: function(t1) {
                    return this.clone()._matMult(t1);
                },
                unit: function() {
                    return this.clone()._unit();
                },
                perp: function() {
                    return this.clone()._perp();
                },
                round: function() {
                    return this.clone()._round();
                },
                mag: function() {
                    return Math.sqrt(this.x * this.x + this.y * this.y);
                },
                equals: function(t1) {
                    return this.x === t1.x && this.y === t1.y;
                },
                dist: function(t1) {
                    return Math.sqrt(this.distSqr(t1));
                },
                distSqr: function(t1) {
                    var e = t1.x - this.x, r = t1.y - this.y;
                    return e * e + r * r;
                },
                angle: function() {
                    return Math.atan2(this.y, this.x);
                },
                angleTo: function(t1) {
                    return Math.atan2(this.y - t1.y, this.x - t1.x);
                },
                angleWith: function(t1) {
                    return this.angleWithSep(t1.x, t1.y);
                },
                angleWithSep: function(t1, e) {
                    return Math.atan2(this.x * e - this.y * t1, this.x * t1 + this.y * e);
                },
                _matMult: function(t1) {
                    var e = t1[2] * this.x + t1[3] * this.y;
                    return this.x = t1[0] * this.x + t1[1] * this.y, this.y = e, this;
                },
                _add: function(t1) {
                    return this.x += t1.x, this.y += t1.y, this;
                },
                _sub: function(t1) {
                    return this.x -= t1.x, this.y -= t1.y, this;
                },
                _mult: function(t1) {
                    return this.x *= t1, this.y *= t1, this;
                },
                _div: function(t1) {
                    return this.x /= t1, this.y /= t1, this;
                },
                _multByPoint: function(t1) {
                    return this.x *= t1.x, this.y *= t1.y, this;
                },
                _divByPoint: function(t1) {
                    return this.x /= t1.x, this.y /= t1.y, this;
                },
                _unit: function() {
                    return this._div(this.mag()), this;
                },
                _perp: function() {
                    var t1 = this.y;
                    return this.y = this.x, this.x = -t1, this;
                },
                _rotate: function(t1) {
                    var e = Math.cos(t1), r = Math.sin(t1), n = r * this.x + e * this.y;
                    return this.x = e * this.x - r * this.y, this.y = n, this;
                },
                _rotateAround: function(t1, e) {
                    var r = Math.cos(t1), n = Math.sin(t1), i = e.y + n * (this.x - e.x) + r * (this.y - e.y);
                    return this.x = e.x + r * (this.x - e.x) - n * (this.y - e.y), this.y = i, this;
                },
                _round: function() {
                    return this.x = Math.round(this.x), this.y = Math.round(this.y), this;
                }
            }, t1.convert = function(e) {
                return e instanceof t1 ? e : Array.isArray(e) ? new t1(e[0], e[1]) : e;
            }, R;
        }
        var q = e(j());
        function $(t1, e) {
            if (Array.isArray(t1)) {
                if (!Array.isArray(e) || t1.length !== e.length) return !1;
                for(let r = 0; r < t1.length; r++)if (!$(t1[r], e[r])) return !1;
                return !0;
            }
            if ("object" == typeof t1 && null !== t1 && null !== e) {
                if ("object" != typeof e) return !1;
                if (Object.keys(t1).length !== Object.keys(e).length) return !1;
                for(const r in t1)if (!$(t1[r], e[r])) return !1;
                return !0;
            }
            return t1 === e;
        }
        const G = Math.PI / 180, Y = 180 / Math.PI;
        function X(t1) {
            return t1 * G;
        }
        function Z(t1) {
            return t1 * Y;
        }
        const H = [
            [
                0,
                0
            ],
            [
                1,
                0
            ],
            [
                1,
                1
            ],
            [
                0,
                1
            ]
        ];
        function W(t1) {
            if (t1 <= 0) return 0;
            if (t1 >= 1) return 1;
            const e = t1 * t1, r = e * t1;
            return 4 * (t1 < .5 ? r : 3 * (t1 - e) + r - .75);
        }
        function K(t1, e, r, n) {
            const i = new U(t1, e, r, n);
            return function(t1) {
                return i.solve(t1);
            };
        }
        const J = K(.25, .1, .25, 1);
        function Q(t1, e, r) {
            return Math.min(r, Math.max(e, t1));
        }
        function tt(t1, e, r) {
            return (r = Q((r - t1) / (e - t1), 0, 1)) * r * (3 - 2 * r);
        }
        function et(t1, e, r) {
            const n = r - e, i = ((t1 - e) % n + n) % n + e;
            return i === e ? r : i;
        }
        function rt(t1, e, r) {
            if (!t1.length) return r(null, []);
            let n = t1.length;
            const i = new Array(t1.length);
            let a = null;
            t1.forEach((t1, s)=>{
                e(t1, (t1, e)=>{
                    t1 && (a = t1), i[s] = e, 0 == --n && r(a, i);
                });
            });
        }
        function nt(t1, ...e) {
            for (const r of e)for(const e in r)t1[e] = r[e];
            return t1;
        }
        let it = 1;
        function at() {
            return it++;
        }
        function st(t1) {
            return t1 <= 1 ? 1 : Math.pow(2, Math.ceil(Math.log(t1) / Math.LN2));
        }
        function ot(t1, e) {
            t1.forEach((t1)=>{
                e[t1] && (e[t1] = e[t1].bind(e));
            });
        }
        function lt(t1, e) {
            return -1 !== t1.indexOf(e, t1.length - e.length);
        }
        function ut(t1, e, r) {
            const n = {};
            for(const r in t1)n[r] = e.call(this, t1[r], r, t1);
            return n;
        }
        function ct(t1, e, r) {
            const n = {};
            for(const r in t1)e.call(this, t1[r], r, t1) && (n[r] = t1[r]);
            return n;
        }
        function ht(t1) {
            return Array.isArray(t1) ? t1.map(ht) : "object" == typeof t1 && t1 ? ut(t1, ht) : t1;
        }
        const pt = {};
        function ft(t1) {
            pt[t1] || ("undefined" != typeof console && console.warn(t1), pt[t1] = !0);
        }
        function dt(t1, e, r) {
            return (r.y - t1.y) * (e.x - t1.x) > (e.y - t1.y) * (r.x - t1.x);
        }
        function mt(t1) {
            let e = 0;
            for(let r, n, i = 0, a = t1.length, s = a - 1; i < a; s = i++)r = t1[i], n = t1[s], e += (n.x - r.x) * (r.y + n.y);
            return e;
        }
        function yt([t1, e, r]) {
            const n = X(e + 90), i = X(r);
            return {
                x: t1 * Math.cos(n) * Math.sin(i),
                y: t1 * Math.sin(n) * Math.sin(i),
                z: t1 * Math.cos(i),
                azimuthal: e,
                polar: r
            };
        }
        function gt() {
            return "undefined" != typeof WorkerGlobalScope && "undefined" != typeof self && self instanceof WorkerGlobalScope;
        }
        function xt(t1) {
            const e = {};
            if (t1.replace(/(?:^|(?:\s*\,\s*))([^\x00-\x20\(\)<>@\,;\:\\"\/\[\]\?\=\{\}\x7F]+)(?:\=(?:([^\x00-\x20\(\)<>@\,;\:\\"\/\[\]\?\=\{\}\x7F]+)|(?:\"((?:[^"\\]|\\.)*)\")))?/g, (t1, r, n, i)=>{
                const a = n || i;
                return e[r] = !a || a.toLowerCase(), "";
            }), e["max-age"]) {
                const t1 = parseInt(e["max-age"], 10);
                isNaN(t1) ? delete e["max-age"] : e["max-age"] = t1;
            }
            return e;
        }
        let vt = null;
        function bt(t1, e) {
            return [
                t1[4 * e],
                t1[4 * e + 1],
                t1[4 * e + 2],
                t1[4 * e + 3]
            ];
        }
        function _t(t1, e, r, n) {
            for(; e < r;){
                const i = e + r >> 1;
                t1[i] < n ? e = i + 1 : r = i;
            }
            return e;
        }
        function wt(t1, e, r, n) {
            for(; e < r;){
                const i = e + r >> 1;
                t1[i] <= n ? e = i + 1 : r = i;
            }
            return e;
        }
        function Mt(t1) {
            return t1 > 0 ? 1 / (1.001 - t1) : 1 + t1;
        }
        function At(t1) {
            return t1 > 0 ? 1 - 1 / (1.001 - t1) : -t1;
        }
        const St = {
            API_URL: "https://api.mapbox.com",
            get API_URL_REGEX () {
                return /^((https?:)?\/\/)?([^\/]+\.)?mapbox\.c(n|om)(\/|\?|$)/i;
            },
            get API_TILEJSON_REGEX () {
                return /^((https?:)?\/\/)?([^\/]+\.)?mapbox\.c(n|om)(\/v[0-9]*\/.*\.json.*$)/i;
            },
            get API_SPRITE_REGEX () {
                return /^((https?:)?\/\/)?([^\/]+\.)?mapbox\.c(n|om)(\/styles\/v[0-9]*\/)(.*\/sprite.*\..*$)/i;
            },
            get API_FONTS_REGEX () {
                return /^((https?:)?\/\/)?([^\/]+\.)?mapbox\.c(n|om)(\/fonts\/v[0-9]*\/)(.*\.pbf.*$)/i;
            },
            get API_STYLE_REGEX () {
                return /^((https?:)?\/\/)?([^\/]+\.)?mapbox\.c(n|om)(\/styles\/v[0-9]*\/)(.*$)/i;
            },
            get API_CDN_URL_REGEX () {
                return /^((https?:)?\/\/)?api\.mapbox\.c(n|om)(\/mapbox-gl-js\/)(.*$)/i;
            },
            get EVENTS_URL () {
                if (!St.API_URL) return null;
                try {
                    const t1 = new URL(St.API_URL);
                    return "api.mapbox.cn" === t1.hostname ? "https://events.mapbox.cn/events/v2" : "api.mapbox.com" === t1.hostname ? "https://events.mapbox.com/events/v2" : null;
                } catch (t1) {
                    return null;
                }
            },
            SESSION_PATH: "/map-sessions/v1",
            FEEDBACK_URL: "https://apps.mapbox.com/feedback",
            TILE_URL_VERSION: "v4",
            RASTER_URL_PREFIX: "raster/v1",
            RASTERARRAYS_URL_PREFIX: "rasterarrays/v1",
            REQUIRE_ACCESS_TOKEN: !0,
            ACCESS_TOKEN: null,
            DEFAULT_STYLE: "mapbox://styles/mapbox/standard",
            MAX_PARALLEL_IMAGE_REQUESTS: 16,
            DRACO_URL: "https://api.mapbox.com/mapbox-gl-js/draco_decoder_gltf_v1.5.6.wasm",
            MESHOPT_URL: "https://api.mapbox.com/mapbox-gl-js/meshopt_base_v0.20.wasm",
            MESHOPT_SIMD_URL: "https://api.mapbox.com/mapbox-gl-js/meshopt_simd_v0.20.wasm",
            GLYPHS_URL: "mapbox://fonts/mapbox/{fontstack}/{range}.pbf",
            TILES3D_URL_PREFIX: "3dtiles/v1"
        };
        function It(t1) {
            return St.API_URL_REGEX.test(t1);
        }
        function Pt(t1) {
            return St.API_SPRITE_REGEX.test(t1);
        }
        let zt, Et, kt, Tt, Bt, Ct;
        function Vt() {
            return null == zt && (zt = self.OffscreenCanvas && new OffscreenCanvas(1, 1).getContext("2d") && "function" == typeof self.createImageBitmap), zt;
        }
        const Dt = {
            now: ()=>void 0 !== Tt ? Tt : performance.now(),
            setNow (t1) {
                Tt = t1;
            },
            restoreNow () {
                Tt = void 0;
            },
            frame (t1) {
                const e = requestAnimationFrame(t1);
                return {
                    cancel: ()=>cancelAnimationFrame(e)
                };
            },
            getImageData (t1, e = 0) {
                const { width: r, height: n } = t1;
                Bt || (Bt = document.createElement("canvas"));
                const i = Bt.getContext("2d", {
                    willReadFrequently: !0
                });
                if (!i) throw new Error("failed to create canvas 2d context");
                return (r > Bt.width || n > Bt.height) && (Bt.width = r, Bt.height = n), i.clearRect(-e, -e, r + 2 * e, n + 2 * e), i.drawImage(t1, 0, 0, r, n), i.getImageData(-e, -e, r + 2 * e, n + 2 * e);
            },
            resolveURL: (t1)=>(Et || (Et = document.createElement("a")), Et.href = t1, Et.href),
            get devicePixelRatio () {
                return window.devicePixelRatio;
            },
            get prefersReducedMotion () {
                return !!window.matchMedia && (null == kt && (kt = window.matchMedia("(prefers-reduced-motion: reduce)")), kt.matches);
            },
            hasCanvasFingerprintNoise () {
                if (void 0 !== Ct) return Ct;
                if (!Vt()) return Ct = !1, !1;
                const t1 = new OffscreenCanvas(85, 1), e = t1.getContext("2d", {
                    willReadFrequently: !0
                });
                let r = 0;
                for(let n = 0; n < t1.width; ++n)e.fillStyle = `rgba(${r++},${r++},${r++}, 255)`, e.fillRect(n, 0, 1, 1);
                const n = e.getImageData(0, 0, t1.width, t1.height);
                r = 0;
                for(let t1 = 0; t1 < n.data.length; ++t1)if (t1 % 4 != 3 && r++ !== n.data[t1]) return Ct = !0, !0;
                return Ct = !1, !1;
            }
        };
        function Lt(t1, e) {
            const r = t1.indexOf("?");
            if (r < 0) return `${t1}?${new URLSearchParams(e).toString()}`;
            const n = new URLSearchParams(t1.slice(r));
            for(const t1 in e)n.set(t1, e[t1]);
            return `${t1.slice(0, r)}?${n.toString()}`;
        }
        function Rt(t1, e = {
            persistentParams: []
        }) {
            const r = t1.indexOf("?");
            if (r < 0) return t1;
            const n = new URLSearchParams, i = new URLSearchParams(t1.slice(r));
            for (const t1 of e.persistentParams){
                const e = i.get(t1);
                e && n.set(t1, e);
            }
            const a = n.toString();
            return `${t1.slice(0, r)}${a.length > 0 ? `?${a}` : ""}`;
        }
        const Ft = "mapbox-tiles";
        let Ot = 500, Nt = 50;
        const Ut = [
            "language",
            "worldview",
            "jobid"
        ];
        let jt, qt;
        function $t() {
            try {
                return caches;
            } catch (t1) {}
        }
        function Gt() {
            const t1 = $t();
            t1 && null == jt && (jt = t1.open(Ft));
        }
        let Yt = 1 / 0;
        const Xt = {
            supported: !1,
            testSupport: function(t1) {
                !Wt && Ht && (Kt ? Qt(t1) : Zt = t1);
            }
        };
        let Zt, Ht, Wt = !1, Kt = !1;
        const Jt = "undefined" != typeof self ? self : {};
        function Qt(t1) {
            const e = t1.createTexture();
            t1.bindTexture(t1.TEXTURE_2D, e);
            try {
                if (t1.texImage2D(t1.TEXTURE_2D, 0, t1.RGBA, t1.RGBA, t1.UNSIGNED_BYTE, Ht), t1.isContextLost()) return;
                Xt.supported = !0;
            } catch (t1) {}
            t1.deleteTexture(e), Wt = !0;
        }
        Jt.document && (Ht = Jt.document.createElement("img"), Ht.onload = function() {
            Zt && Qt(Zt), Zt = null, Kt = !0;
        }, Ht.onerror = function() {
            Wt = !0, Zt = null;
        }, Ht.src = "data:image/webp;base64,UklGRh4AAABXRUJQVlA4TBEAAAAvAQAAAAfQ//73v/+BiOh/AAA=");
        const te = {
            Unknown: "Unknown",
            Style: "Style",
            Source: "Source",
            Tile: "Tile",
            Glyphs: "Glyphs",
            SpriteImage: "SpriteImage",
            SpriteJSON: "SpriteJSON",
            Iconset: "Iconset",
            Image: "Image",
            Model: "Model"
        };
        "function" == typeof Object.freeze && Object.freeze(te);
        class ee extends Error {
            toString() {
                return `${this.name}: ${this.message} (${this.status}): ${this.url}`;
            }
            constructor(t1, e, r){
                401 === e && It(r) && (t1 += ": you may have provided an invalid Mapbox access token. See https://docs.mapbox.com/api/overview/#access-tokens-and-token-scopes"), super(t1), this.status = e, this.url = r;
            }
        }
        const re = gt() ? ()=>self.worker && self.worker.referrer : ()=>("blob:" === location.protocol ? parent : self).location.href;
        const ne = function(t1, e) {
            if (!(/^file:/.test(r = t1.url) || /^file:/.test(re()) && !/^\w+:/.test(r))) {
                if (self.fetch && self.Request && self.AbortController && Request.prototype.hasOwnProperty("signal")) return function(t1, e) {
                    const r = new AbortController, n = new Request(t1.url, {
                        method: t1.method || "GET",
                        body: t1.body,
                        credentials: t1.credentials,
                        headers: t1.headers,
                        referrer: re(),
                        referrerPolicy: t1.referrerPolicy,
                        signal: r.signal
                    });
                    let i = !1, a = !1;
                    const s = (o = n.url).indexOf("sku=") > 0 && It(o);
                    var o;
                    "json" === t1.type && n.headers.set("Accept", "application/json");
                    const l = (r, i, o)=>{
                        if (a) return;
                        if (r && "SecurityError" !== r.message && ft(r.toString()), i && o) return u(i);
                        const l = Date.now();
                        fetch(n).then((r)=>{
                            if (r.ok) {
                                const t1 = s ? r.clone() : null;
                                return u(r, t1, l);
                            }
                            return e(new ee(r.statusText, r.status, t1.url));
                        }).catch((r)=>{
                            "AbortError" !== r.name && e(new Error(`${r.message} ${t1.url}`));
                        });
                    }, u = (r, s, o)=>{
                        ("arrayBuffer" === t1.type ? r.arrayBuffer() : "json" === t1.type ? r.json() : r.text()).then((t1)=>{
                            a || (s && o && function(t1, e, r) {
                                if (Gt(), null == jt) return;
                                const n = xt(e.headers.get("Cache-Control") || "");
                                if (n["no-store"]) return;
                                const i = {
                                    status: e.status,
                                    statusText: e.statusText,
                                    headers: new Headers
                                };
                                e.headers.forEach((t1, e)=>i.headers.set(e, t1)), n["max-age"] && i.headers.set("Expires", new Date(r + 1e3 * n["max-age"]).toUTCString());
                                const a = i.headers.get("Expires");
                                if (!a) return;
                                if (new Date(a).getTime() - r < 42e4) return;
                                let s = Rt(t1.url, {
                                    persistentParams: Ut
                                });
                                if (206 === e.status) {
                                    const e = t1.headers.get("Range");
                                    if (!e) return;
                                    i.status = 200, s = Lt(s, {
                                        range: e
                                    });
                                }
                                !function(t1, e) {
                                    if (void 0 === qt) try {
                                        new Response(new ReadableStream), qt = !0;
                                    } catch (t1) {
                                        qt = !1;
                                    }
                                    qt ? e(t1.body) : t1.blob().then(e);
                                }(e, (t1)=>{
                                    const r = new Response(200 !== (n = e.status) && 404 !== n && [
                                        101,
                                        103,
                                        204,
                                        205,
                                        304
                                    ].includes(n) ? null : t1, i);
                                    var n;
                                    Gt(), null != jt && jt.then((t1)=>t1.put(s, r)).catch((t1)=>ft(t1.message));
                                });
                            }(n, s, o), i = !0, e(null, t1, r.headers.get("Cache-Control"), r.headers.get("Expires")));
                        }).catch((t1)=>{
                            a || e(new Error(t1.message));
                        });
                    };
                    return s ? function(t1, e) {
                        if (Gt(), null == jt) return e(null);
                        jt.then((r)=>{
                            let n = Rt(t1.url, {
                                persistentParams: Ut
                            });
                            const i = t1.headers.get("Range");
                            i && (n = Lt(n, {
                                range: i
                            })), r.match(n).then((t1)=>{
                                const i = function(t1) {
                                    if (!t1) return !1;
                                    const e = new Date(t1.headers.get("Expires") || 0), r = xt(t1.headers.get("Cache-Control") || "");
                                    return e > Date.now() && !r["no-cache"];
                                }(t1);
                                r.delete(n), i && r.put(n, t1.clone()), e(null, t1, i);
                            }).catch(e);
                        }).catch(e);
                    }(n, l) : l(null, null), {
                        cancel: ()=>{
                            a = !0, i || r.abort();
                        }
                    };
                }(t1, e);
                if (gt() && self.worker && self.worker.actor) return self.worker.actor.send("getResource", t1, e, void 0, !0);
            }
            var r;
            return function(t1, e) {
                const r = new XMLHttpRequest;
                r.open(t1.method || "GET", t1.url, !0), "arrayBuffer" === t1.type && (r.responseType = "arraybuffer");
                for(const e in t1.headers)r.setRequestHeader(e, t1.headers[e]);
                return "json" === t1.type && (r.responseType = "text", r.setRequestHeader("Accept", "application/json")), r.withCredentials = "include" === t1.credentials, r.onerror = ()=>{
                    e(new Error(r.statusText));
                }, r.onload = ()=>{
                    if ((r.status >= 200 && r.status < 300 || 0 === r.status) && null !== r.response) {
                        let n = r.response;
                        if ("json" === t1.type) try {
                            n = JSON.parse(r.response);
                        } catch (t1) {
                            return e(t1);
                        }
                        e(null, n, r.getResponseHeader("Cache-Control"), r.getResponseHeader("Expires"));
                    } else e(new ee(r.statusText, r.status, t1.url));
                }, r.send(t1.body), {
                    cancel: ()=>r.abort()
                };
            }(t1, e);
        }, ie = function(t1, e) {
            return ne(nt(t1, {
                type: "arrayBuffer"
            }), e);
        };
        function ae(t1) {
            const e = document.createElement("a");
            return e.href = t1, e.protocol === location.protocol && e.host === location.host;
        }
        const se = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAAC0lEQVQYV2NgAAIAAAUAAarVyFEAAAAASUVORK5CYII=";
        let oe, le;
        oe = [], le = 0;
        const ue = function(t1, e) {
            if (Xt.supported && (t1.headers || (t1.headers = {}), t1.headers.accept = "image/webp,*/*"), le >= St.MAX_PARALLEL_IMAGE_REQUESTS) {
                const r = {
                    requestParameters: t1,
                    callback: e,
                    cancelled: !1,
                    cancel () {
                        this.cancelled = !0;
                    }
                };
                return oe.push(r), r;
            }
            le++;
            let r = !1;
            const n = ()=>{
                if (!r) for(r = !0, le--; oe.length && le < St.MAX_PARALLEL_IMAGE_REQUESTS;){
                    const t1 = oe.shift(), { requestParameters: e, callback: r, cancelled: n } = t1;
                    n || (t1.cancel = ue(e, r).cancel);
                }
            }, i = ie(t1, (t1, r, i, a)=>{
                n(), t1 ? e(t1) : r && (self.createImageBitmap ? function(t1, e) {
                    const r = new Blob([
                        new Uint8Array(t1)
                    ], {
                        type: "image/png"
                    });
                    createImageBitmap(r).then((t1)=>{
                        e(null, t1);
                    }).catch((t1)=>{
                        e(new Error(`Could not load image because of ${t1.message}. Please make sure to use a supported image type such as PNG or JPEG. Note that SVGs are not supported.`));
                    });
                }(r, (t1, r)=>e(t1, r, i, a)) : function(t1, e) {
                    const r = new Image;
                    r.onload = ()=>{
                        e(null, r), URL.revokeObjectURL(r.src), r.onload = null, requestAnimationFrame(()=>{
                            r.src = se;
                        });
                    }, r.onerror = ()=>e(new Error("Could not load image. Please make sure to use a supported image type such as PNG or JPEG. Note that SVGs are not supported."));
                    const n = new Blob([
                        new Uint8Array(t1)
                    ], {
                        type: "image/png"
                    });
                    r.src = t1.byteLength ? URL.createObjectURL(n) : se;
                }(r, (t1, r)=>e(t1, r, i, a)));
            });
            return {
                cancel: ()=>{
                    i.cancel(), n();
                }
            };
        };
        var ce, he, pe, fe = {
            exports: {}
        }, de = {
            exports: {}
        }, me = {
            exports: {}
        }, ye = function() {
            if (pe) return fe.exports;
            pe = 1;
            var t1 = (ce || (ce = 1, de.exports = function(t1, e) {
                var r, n, i, a, s, o, l, u;
                for(n = t1.length - (r = 3 & t1.length), i = e, s = 3432918353, o = 461845907, u = 0; u < n;)l = 255 & t1.charCodeAt(u) | (255 & t1.charCodeAt(++u)) << 8 | (255 & t1.charCodeAt(++u)) << 16 | (255 & t1.charCodeAt(++u)) << 24, ++u, i = 27492 + (65535 & (a = 5 * (65535 & (i = (i ^= l = (65535 & (l = (l = (65535 & l) * s + (((l >>> 16) * s & 65535) << 16) & 4294967295) << 15 | l >>> 17)) * o + (((l >>> 16) * o & 65535) << 16) & 4294967295) << 13 | i >>> 19)) + ((5 * (i >>> 16) & 65535) << 16) & 4294967295)) + ((58964 + (a >>> 16) & 65535) << 16);
                switch(l = 0, r){
                    case 3:
                        l ^= (255 & t1.charCodeAt(u + 2)) << 16;
                    case 2:
                        l ^= (255 & t1.charCodeAt(u + 1)) << 8;
                    case 1:
                        i ^= l = (65535 & (l = (l = (65535 & (l ^= 255 & t1.charCodeAt(u))) * s + (((l >>> 16) * s & 65535) << 16) & 4294967295) << 15 | l >>> 17)) * o + (((l >>> 16) * o & 65535) << 16) & 4294967295;
                }
                return i ^= t1.length, i = 2246822507 * (65535 & (i ^= i >>> 16)) + ((2246822507 * (i >>> 16) & 65535) << 16) & 4294967295, i = 3266489909 * (65535 & (i ^= i >>> 13)) + ((3266489909 * (i >>> 16) & 65535) << 16) & 4294967295, (i ^= i >>> 16) >>> 0;
            }), de.exports), e = (he || (he = 1, me.exports = function(t1, e) {
                for(var r, n = t1.length, i = e ^ n, a = 0; n >= 4;)r = 1540483477 * (65535 & (r = 255 & t1.charCodeAt(a) | (255 & t1.charCodeAt(++a)) << 8 | (255 & t1.charCodeAt(++a)) << 16 | (255 & t1.charCodeAt(++a)) << 24)) + ((1540483477 * (r >>> 16) & 65535) << 16), i = 1540483477 * (65535 & i) + ((1540483477 * (i >>> 16) & 65535) << 16) ^ (r = 1540483477 * (65535 & (r ^= r >>> 24)) + ((1540483477 * (r >>> 16) & 65535) << 16)), n -= 4, ++a;
                switch(n){
                    case 3:
                        i ^= (255 & t1.charCodeAt(a + 2)) << 16;
                    case 2:
                        i ^= (255 & t1.charCodeAt(a + 1)) << 8;
                    case 1:
                        i = 1540483477 * (65535 & (i ^= 255 & t1.charCodeAt(a))) + ((1540483477 * (i >>> 16) & 65535) << 16);
                }
                return i = 1540483477 * (65535 & (i ^= i >>> 13)) + ((1540483477 * (i >>> 16) & 65535) << 16), (i ^= i >>> 15) >>> 0;
            }), me.exports);
            return fe.exports = t1, fe.exports.murmur3 = t1, fe.exports.murmur2 = e, fe.exports;
        }(), ge = e(ye);
        class xe {
            constructor(t1, ...e){
                nt(this, e[0] || {}), this.type = t1;
            }
        }
        class ve extends xe {
            constructor(t1, e = {}){
                super("error", nt({
                    error: t1
                }, e));
            }
        }
        function be(t1, e, r) {
            r[t1] && -1 !== r[t1].indexOf(e) || (r[t1] = r[t1] || [], r[t1].push(e));
        }
        function _e(t1, e, r) {
            if (r && r[t1]) {
                const n = r[t1].indexOf(e);
                -1 !== n && r[t1].splice(n, 1);
            }
        }
        class we {
            on(t1, e) {
                return this._listeners = this._listeners || {}, be(t1, e, this._listeners), this;
            }
            off(t1, e) {
                return _e(t1, e, this._listeners), _e(t1, e, this._oneTimeListeners), this;
            }
            once(t1, e) {
                return e ? (this._oneTimeListeners = this._oneTimeListeners || {}, be(t1, e, this._oneTimeListeners), this) : new Promise((e)=>this.once(t1, e));
            }
            fire(t1, e) {
                const r = "string" == typeof t1 ? new xe(t1, e) : t1, n = r.type;
                if (this.listens(n)) {
                    r.target = this;
                    const t1 = this._listeners && this._listeners[n] ? this._listeners[n].slice() : [];
                    for (const e of t1)e.call(this, r);
                    const e = this._oneTimeListeners && this._oneTimeListeners[n] ? this._oneTimeListeners[n].slice() : [];
                    for (const t1 of e)_e(n, t1, this._oneTimeListeners), t1.call(this, r);
                    const i = this._eventedParent;
                    i && (nt(r, "function" == typeof this._eventedParentData ? this._eventedParentData() : this._eventedParentData), i.fire(r));
                } else r instanceof ve && console.error(r.error);
                return this;
            }
            listens(t1) {
                return !!(this._listeners && this._listeners[t1] && this._listeners[t1].length > 0 || this._oneTimeListeners && this._oneTimeListeners[t1] && this._oneTimeListeners[t1].length > 0 || this._eventedParent && this._eventedParent.listens(t1));
            }
            setEventedParent(t1, e) {
                return this._eventedParent = t1, this._eventedParentData = e, this;
            }
        }
        var Me, Ae = {}, Se = function() {
            if (Me) return Ae;
            Me = 1;
            var t1 = {
                transparent: [
                    0,
                    0,
                    0,
                    0
                ],
                aliceblue: [
                    240,
                    248,
                    255,
                    1
                ],
                antiquewhite: [
                    250,
                    235,
                    215,
                    1
                ],
                aqua: [
                    0,
                    255,
                    255,
                    1
                ],
                aquamarine: [
                    127,
                    255,
                    212,
                    1
                ],
                azure: [
                    240,
                    255,
                    255,
                    1
                ],
                beige: [
                    245,
                    245,
                    220,
                    1
                ],
                bisque: [
                    255,
                    228,
                    196,
                    1
                ],
                black: [
                    0,
                    0,
                    0,
                    1
                ],
                blanchedalmond: [
                    255,
                    235,
                    205,
                    1
                ],
                blue: [
                    0,
                    0,
                    255,
                    1
                ],
                blueviolet: [
                    138,
                    43,
                    226,
                    1
                ],
                brown: [
                    165,
                    42,
                    42,
                    1
                ],
                burlywood: [
                    222,
                    184,
                    135,
                    1
                ],
                cadetblue: [
                    95,
                    158,
                    160,
                    1
                ],
                chartreuse: [
                    127,
                    255,
                    0,
                    1
                ],
                chocolate: [
                    210,
                    105,
                    30,
                    1
                ],
                coral: [
                    255,
                    127,
                    80,
                    1
                ],
                cornflowerblue: [
                    100,
                    149,
                    237,
                    1
                ],
                cornsilk: [
                    255,
                    248,
                    220,
                    1
                ],
                crimson: [
                    220,
                    20,
                    60,
                    1
                ],
                cyan: [
                    0,
                    255,
                    255,
                    1
                ],
                darkblue: [
                    0,
                    0,
                    139,
                    1
                ],
                darkcyan: [
                    0,
                    139,
                    139,
                    1
                ],
                darkgoldenrod: [
                    184,
                    134,
                    11,
                    1
                ],
                darkgray: [
                    169,
                    169,
                    169,
                    1
                ],
                darkgreen: [
                    0,
                    100,
                    0,
                    1
                ],
                darkgrey: [
                    169,
                    169,
                    169,
                    1
                ],
                darkkhaki: [
                    189,
                    183,
                    107,
                    1
                ],
                darkmagenta: [
                    139,
                    0,
                    139,
                    1
                ],
                darkolivegreen: [
                    85,
                    107,
                    47,
                    1
                ],
                darkorange: [
                    255,
                    140,
                    0,
                    1
                ],
                darkorchid: [
                    153,
                    50,
                    204,
                    1
                ],
                darkred: [
                    139,
                    0,
                    0,
                    1
                ],
                darksalmon: [
                    233,
                    150,
                    122,
                    1
                ],
                darkseagreen: [
                    143,
                    188,
                    143,
                    1
                ],
                darkslateblue: [
                    72,
                    61,
                    139,
                    1
                ],
                darkslategray: [
                    47,
                    79,
                    79,
                    1
                ],
                darkslategrey: [
                    47,
                    79,
                    79,
                    1
                ],
                darkturquoise: [
                    0,
                    206,
                    209,
                    1
                ],
                darkviolet: [
                    148,
                    0,
                    211,
                    1
                ],
                deeppink: [
                    255,
                    20,
                    147,
                    1
                ],
                deepskyblue: [
                    0,
                    191,
                    255,
                    1
                ],
                dimgray: [
                    105,
                    105,
                    105,
                    1
                ],
                dimgrey: [
                    105,
                    105,
                    105,
                    1
                ],
                dodgerblue: [
                    30,
                    144,
                    255,
                    1
                ],
                firebrick: [
                    178,
                    34,
                    34,
                    1
                ],
                floralwhite: [
                    255,
                    250,
                    240,
                    1
                ],
                forestgreen: [
                    34,
                    139,
                    34,
                    1
                ],
                fuchsia: [
                    255,
                    0,
                    255,
                    1
                ],
                gainsboro: [
                    220,
                    220,
                    220,
                    1
                ],
                ghostwhite: [
                    248,
                    248,
                    255,
                    1
                ],
                gold: [
                    255,
                    215,
                    0,
                    1
                ],
                goldenrod: [
                    218,
                    165,
                    32,
                    1
                ],
                gray: [
                    128,
                    128,
                    128,
                    1
                ],
                green: [
                    0,
                    128,
                    0,
                    1
                ],
                greenyellow: [
                    173,
                    255,
                    47,
                    1
                ],
                grey: [
                    128,
                    128,
                    128,
                    1
                ],
                honeydew: [
                    240,
                    255,
                    240,
                    1
                ],
                hotpink: [
                    255,
                    105,
                    180,
                    1
                ],
                indianred: [
                    205,
                    92,
                    92,
                    1
                ],
                indigo: [
                    75,
                    0,
                    130,
                    1
                ],
                ivory: [
                    255,
                    255,
                    240,
                    1
                ],
                khaki: [
                    240,
                    230,
                    140,
                    1
                ],
                lavender: [
                    230,
                    230,
                    250,
                    1
                ],
                lavenderblush: [
                    255,
                    240,
                    245,
                    1
                ],
                lawngreen: [
                    124,
                    252,
                    0,
                    1
                ],
                lemonchiffon: [
                    255,
                    250,
                    205,
                    1
                ],
                lightblue: [
                    173,
                    216,
                    230,
                    1
                ],
                lightcoral: [
                    240,
                    128,
                    128,
                    1
                ],
                lightcyan: [
                    224,
                    255,
                    255,
                    1
                ],
                lightgoldenrodyellow: [
                    250,
                    250,
                    210,
                    1
                ],
                lightgray: [
                    211,
                    211,
                    211,
                    1
                ],
                lightgreen: [
                    144,
                    238,
                    144,
                    1
                ],
                lightgrey: [
                    211,
                    211,
                    211,
                    1
                ],
                lightpink: [
                    255,
                    182,
                    193,
                    1
                ],
                lightsalmon: [
                    255,
                    160,
                    122,
                    1
                ],
                lightseagreen: [
                    32,
                    178,
                    170,
                    1
                ],
                lightskyblue: [
                    135,
                    206,
                    250,
                    1
                ],
                lightslategray: [
                    119,
                    136,
                    153,
                    1
                ],
                lightslategrey: [
                    119,
                    136,
                    153,
                    1
                ],
                lightsteelblue: [
                    176,
                    196,
                    222,
                    1
                ],
                lightyellow: [
                    255,
                    255,
                    224,
                    1
                ],
                lime: [
                    0,
                    255,
                    0,
                    1
                ],
                limegreen: [
                    50,
                    205,
                    50,
                    1
                ],
                linen: [
                    250,
                    240,
                    230,
                    1
                ],
                magenta: [
                    255,
                    0,
                    255,
                    1
                ],
                maroon: [
                    128,
                    0,
                    0,
                    1
                ],
                mediumaquamarine: [
                    102,
                    205,
                    170,
                    1
                ],
                mediumblue: [
                    0,
                    0,
                    205,
                    1
                ],
                mediumorchid: [
                    186,
                    85,
                    211,
                    1
                ],
                mediumpurple: [
                    147,
                    112,
                    219,
                    1
                ],
                mediumseagreen: [
                    60,
                    179,
                    113,
                    1
                ],
                mediumslateblue: [
                    123,
                    104,
                    238,
                    1
                ],
                mediumspringgreen: [
                    0,
                    250,
                    154,
                    1
                ],
                mediumturquoise: [
                    72,
                    209,
                    204,
                    1
                ],
                mediumvioletred: [
                    199,
                    21,
                    133,
                    1
                ],
                midnightblue: [
                    25,
                    25,
                    112,
                    1
                ],
                mintcream: [
                    245,
                    255,
                    250,
                    1
                ],
                mistyrose: [
                    255,
                    228,
                    225,
                    1
                ],
                moccasin: [
                    255,
                    228,
                    181,
                    1
                ],
                navajowhite: [
                    255,
                    222,
                    173,
                    1
                ],
                navy: [
                    0,
                    0,
                    128,
                    1
                ],
                oldlace: [
                    253,
                    245,
                    230,
                    1
                ],
                olive: [
                    128,
                    128,
                    0,
                    1
                ],
                olivedrab: [
                    107,
                    142,
                    35,
                    1
                ],
                orange: [
                    255,
                    165,
                    0,
                    1
                ],
                orangered: [
                    255,
                    69,
                    0,
                    1
                ],
                orchid: [
                    218,
                    112,
                    214,
                    1
                ],
                palegoldenrod: [
                    238,
                    232,
                    170,
                    1
                ],
                palegreen: [
                    152,
                    251,
                    152,
                    1
                ],
                paleturquoise: [
                    175,
                    238,
                    238,
                    1
                ],
                palevioletred: [
                    219,
                    112,
                    147,
                    1
                ],
                papayawhip: [
                    255,
                    239,
                    213,
                    1
                ],
                peachpuff: [
                    255,
                    218,
                    185,
                    1
                ],
                peru: [
                    205,
                    133,
                    63,
                    1
                ],
                pink: [
                    255,
                    192,
                    203,
                    1
                ],
                plum: [
                    221,
                    160,
                    221,
                    1
                ],
                powderblue: [
                    176,
                    224,
                    230,
                    1
                ],
                purple: [
                    128,
                    0,
                    128,
                    1
                ],
                rebeccapurple: [
                    102,
                    51,
                    153,
                    1
                ],
                red: [
                    255,
                    0,
                    0,
                    1
                ],
                rosybrown: [
                    188,
                    143,
                    143,
                    1
                ],
                royalblue: [
                    65,
                    105,
                    225,
                    1
                ],
                saddlebrown: [
                    139,
                    69,
                    19,
                    1
                ],
                salmon: [
                    250,
                    128,
                    114,
                    1
                ],
                sandybrown: [
                    244,
                    164,
                    96,
                    1
                ],
                seagreen: [
                    46,
                    139,
                    87,
                    1
                ],
                seashell: [
                    255,
                    245,
                    238,
                    1
                ],
                sienna: [
                    160,
                    82,
                    45,
                    1
                ],
                silver: [
                    192,
                    192,
                    192,
                    1
                ],
                skyblue: [
                    135,
                    206,
                    235,
                    1
                ],
                slateblue: [
                    106,
                    90,
                    205,
                    1
                ],
                slategray: [
                    112,
                    128,
                    144,
                    1
                ],
                slategrey: [
                    112,
                    128,
                    144,
                    1
                ],
                snow: [
                    255,
                    250,
                    250,
                    1
                ],
                springgreen: [
                    0,
                    255,
                    127,
                    1
                ],
                steelblue: [
                    70,
                    130,
                    180,
                    1
                ],
                tan: [
                    210,
                    180,
                    140,
                    1
                ],
                teal: [
                    0,
                    128,
                    128,
                    1
                ],
                thistle: [
                    216,
                    191,
                    216,
                    1
                ],
                tomato: [
                    255,
                    99,
                    71,
                    1
                ],
                turquoise: [
                    64,
                    224,
                    208,
                    1
                ],
                violet: [
                    238,
                    130,
                    238,
                    1
                ],
                wheat: [
                    245,
                    222,
                    179,
                    1
                ],
                white: [
                    255,
                    255,
                    255,
                    1
                ],
                whitesmoke: [
                    245,
                    245,
                    245,
                    1
                ],
                yellow: [
                    255,
                    255,
                    0,
                    1
                ],
                yellowgreen: [
                    154,
                    205,
                    50,
                    1
                ]
            };
            function e(t1) {
                return (t1 = Math.round(t1)) < 0 ? 0 : t1 > 255 ? 255 : t1;
            }
            function r(t1) {
                return e("%" === t1[t1.length - 1] ? parseFloat(t1) / 100 * 255 : parseInt(t1));
            }
            function n(t1) {
                var e;
                return (e = "%" === t1[t1.length - 1] ? parseFloat(t1) / 100 : parseFloat(t1)) < 0 ? 0 : e > 1 ? 1 : e;
            }
            function i(t1, e, r) {
                return r < 0 ? r += 1 : r > 1 && (r -= 1), 6 * r < 1 ? t1 + (e - t1) * r * 6 : 2 * r < 1 ? e : 3 * r < 2 ? t1 + (e - t1) * (2 / 3 - r) * 6 : t1;
            }
            try {
                Ae.parseCSSColor = function(a) {
                    var s, o = a.replace(/ /g, "").toLowerCase();
                    if (o in t1) return t1[o].slice();
                    if ("#" === o[0]) return 4 === o.length ? (s = parseInt(o.substr(1), 16)) >= 0 && s <= 4095 ? [
                        (3840 & s) >> 4 | (3840 & s) >> 8,
                        240 & s | (240 & s) >> 4,
                        15 & s | (15 & s) << 4,
                        1
                    ] : null : 7 === o.length && (s = parseInt(o.substr(1), 16)) >= 0 && s <= 16777215 ? [
                        (16711680 & s) >> 16,
                        (65280 & s) >> 8,
                        255 & s,
                        1
                    ] : null;
                    var l = o.indexOf("("), u = o.indexOf(")");
                    if (-1 !== l && u + 1 === o.length) {
                        var c = o.substr(0, l), h = o.substr(l + 1, u - (l + 1)).split(","), p = 1;
                        switch(c){
                            case "rgba":
                                if (4 !== h.length) return null;
                                p = n(h.pop());
                            case "rgb":
                                return 3 !== h.length ? null : [
                                    r(h[0]),
                                    r(h[1]),
                                    r(h[2]),
                                    p
                                ];
                            case "hsla":
                                if (4 !== h.length) return null;
                                p = n(h.pop());
                            case "hsl":
                                if (3 !== h.length) return null;
                                var f = (parseFloat(h[0]) % 360 + 360) % 360 / 360, d = n(h[1]), m = n(h[2]), y = m <= .5 ? m * (d + 1) : m + d - m * d, g = 2 * m - y;
                                return [
                                    e(255 * i(g, y, f + 1 / 3)),
                                    e(255 * i(g, y, f)),
                                    e(255 * i(g, y, f - 1 / 3)),
                                    p
                                ];
                            default:
                                return null;
                        }
                    }
                    return null;
                };
            } catch (t1) {}
            return Ae;
        }();
        class Ie {
            static parse(t1) {
                if (!t1) return;
                if (t1 instanceof Ie) return t1;
                if ("string" != typeof t1) return;
                const e = Se.parseCSSColor(t1);
                return e ? new Ie(e[0] / 255 * e[3], e[1] / 255 * e[3], e[2] / 255 * e[3], e[3]) : void 0;
            }
            toStringPremultipliedAlpha() {
                const [t1, e, r, n] = 0 === this.a ? [
                    0,
                    0,
                    0,
                    0
                ] : [
                    255 * this.r / this.a,
                    255 * this.g / this.a,
                    255 * this.b / this.a,
                    this.a
                ];
                return `rgba(${Math.round(t1)},${Math.round(e)},${Math.round(r)},${n})`;
            }
            toString() {
                const [t1, e, r, n] = [
                    this.r,
                    this.g,
                    this.b,
                    this.a
                ];
                return `rgba(${Math.round(255 * t1)},${Math.round(255 * e)},${Math.round(255 * r)},${n})`;
            }
            toRenderColor(t1) {
                const { r: e, g: r, b: n, a: i } = this;
                return new Pe(t1, e, r, n, i);
            }
            clone() {
                return new Ie(this.r, this.g, this.b, this.a);
            }
            constructor(t1, e, r, n = 1){
                this.r = t1, this.g = e, this.b = r, this.a = n;
            }
        }
        class Pe {
            toArray() {
                const { r: t1, g: e, b: r, a: n } = this;
                return 0 === n ? [
                    0,
                    0,
                    0,
                    0
                ] : [
                    255 * t1 / n,
                    255 * e / n,
                    255 * r / n,
                    n
                ];
            }
            toHslaArray() {
                if (0 === this.a) return [
                    0,
                    0,
                    0,
                    0
                ];
                const { r: t1, g: e, b: r, a: n } = this, i = Math.min(Math.max(t1 / n, 0), 1), a = Math.min(Math.max(e / n, 0), 1), s = Math.min(Math.max(r / n, 0), 1), o = Math.min(i, a, s), l = Math.max(i, a, s), u = (o + l) / 2;
                if (o === l) return [
                    0,
                    0,
                    100 * u,
                    n
                ];
                const c = l - o, h = u > .5 ? c / (2 - l - o) : c / (l + o);
                let p = 0;
                return l === i ? p = (a - s) / c + (a < s ? 6 : 0) : l === a ? p = (s - i) / c + 2 : l === s && (p = (i - a) / c + 4), p *= 60, [
                    Math.min(Math.max(p, 0), 360),
                    Math.min(Math.max(100 * h, 0), 100),
                    Math.min(Math.max(100 * u, 0), 100),
                    n
                ];
            }
            toArray01() {
                const { r: t1, g: e, b: r, a: n } = this;
                return 0 === n ? [
                    0,
                    0,
                    0,
                    0
                ] : [
                    t1 / n,
                    e / n,
                    r / n,
                    n
                ];
            }
            toArray01Scaled(t1) {
                const { r: e, g: r, b: n, a: i } = this;
                return 0 === i ? [
                    0,
                    0,
                    0
                ] : [
                    e / i * t1,
                    r / i * t1,
                    n / i * t1
                ];
            }
            toArray01PremultipliedAlpha() {
                const { r: t1, g: e, b: r, a: n } = this;
                return [
                    t1,
                    e,
                    r,
                    n
                ];
            }
            toArray01Linear() {
                const { r: t1, g: e, b: r, a: n } = this;
                return 0 === n ? [
                    0,
                    0,
                    0,
                    0
                ] : [
                    Math.pow(t1 / n, 2.2),
                    Math.pow(e / n, 2.2),
                    Math.pow(r / n, 2.2),
                    n
                ];
            }
            constructor(t1, e, r, n, i){
                if (t1) {
                    const a = t1.image.height, s = a * a;
                    e = 0 === i ? 0 : e / i * (a - 1), r = 0 === i ? 0 : r / i * (a - 1), n = 0 === i ? 0 : n / i * (a - 1);
                    const o = Math.floor(e), l = Math.floor(r), u = Math.floor(n), c = Math.ceil(e), h = Math.ceil(r), p = Math.ceil(n), f = e - o, d = r - l, m = n - u, y = t1.image.data, g = 4 * (o + l * s + u * a), x = 4 * (o + l * s + p * a), v = 4 * (o + h * s + u * a), b = 4 * (o + h * s + p * a), _ = 4 * (c + l * s + u * a), w = 4 * (c + l * s + p * a), M = 4 * (c + h * s + u * a), A = 4 * (c + h * s + p * a);
                    if (g < 0 || A >= y.length) throw new Error("out of range");
                    this.r = ze(ze(ze(y[g], y[x], m), ze(y[v], y[b], m), d), ze(ze(y[_], y[w], m), ze(y[M], y[A], m), d), f) / 255 * i, this.g = ze(ze(ze(y[g + 1], y[x + 1], m), ze(y[v + 1], y[b + 1], m), d), ze(ze(y[_ + 1], y[w + 1], m), ze(y[M + 1], y[A + 1], m), d), f) / 255 * i, this.b = ze(ze(ze(y[g + 2], y[x + 2], m), ze(y[v + 2], y[b + 2], m), d), ze(ze(y[_ + 2], y[w + 2], m), ze(y[M + 2], y[A + 2], m), d), f) / 255 * i, this.a = i;
                } else this.r = e, this.g = r, this.b = n, this.a = i;
            }
        }
        function ze(t1, e, r) {
            return t1 * (1 - r) + e * r;
        }
        function Ee(t1, e, r) {
            return t1.map((t1, n)=>ze(t1, e[n], r));
        }
        Ie.black = new Ie(0, 0, 0, 1), Ie.white = new Ie(1, 1, 1, 1), Ie.transparent = new Ie(0, 0, 0, 0), Ie.red = new Ie(1, 0, 0, 1), Ie.blue = new Ie(0, 0, 1, 1);
        var ke = Object.freeze({
            __proto__: null,
            array: Ee,
            color: function(t1, e, r) {
                return new Ie(ze(t1.r, e.r, r), ze(t1.g, e.g, r), ze(t1.b, e.b, r), ze(t1.a, e.a, r));
            },
            number: ze
        });
        function Te(t1, ...e) {
            for (const r of e)for(const e in r)t1[e] = r[e];
            return t1;
        }
        class Be extends Error {
            constructor(t1, e){
                super(e), this.message = e, this.key = t1;
            }
        }
        class Ce {
            concat(t1) {
                return new Ce(this, t1);
            }
            get(t1) {
                if (this.bindings[t1]) return this.bindings[t1];
                if (this.parent) return this.parent.get(t1);
                throw new Error(`${t1} not found in scope.`);
            }
            has(t1) {
                return !!this.bindings[t1] || !!this.parent && this.parent.has(t1);
            }
            constructor(t1, e = []){
                this.parent = t1, this.bindings = {};
                for (const [t1, r] of e)this.bindings[t1] = r;
            }
        }
        const Ve = {
            kind: "null"
        }, De = {
            kind: "number"
        }, Le = {
            kind: "string"
        }, Re = {
            kind: "boolean"
        }, Fe = {
            kind: "color"
        }, Oe = {
            kind: "object"
        }, Ne = {
            kind: "value"
        }, Ue = {
            kind: "collator"
        }, je = {
            kind: "formatted"
        }, qe = {
            kind: "resolvedImage"
        };
        function $e(t1, e) {
            return {
                kind: "array",
                itemType: t1,
                N: e
            };
        }
        function Ge(t1) {
            if ("array" === t1.kind) {
                const e = Ge(t1.itemType);
                return "number" == typeof t1.N ? `array<${e}, ${t1.N}>` : "value" === t1.itemType.kind ? "array" : `array<${e}>`;
            }
            return t1.kind;
        }
        const Ye = [
            Ve,
            De,
            Le,
            Re,
            Fe,
            je,
            Oe,
            $e(Ne),
            qe
        ];
        function Xe(t1, e) {
            if ("error" === e.kind) return null;
            if ("array" === t1.kind) {
                if ("array" === e.kind && (0 === e.N && "value" === e.itemType.kind || !Xe(t1.itemType, e.itemType)) && ("number" != typeof t1.N || t1.N === e.N)) return null;
            } else {
                if (t1.kind === e.kind) return null;
                if ("value" === t1.kind) {
                    for (const t1 of Ye)if (!Xe(t1, e)) return null;
                }
            }
            return `Expected ${Ge(t1)} but found ${Ge(e)} instead.`;
        }
        function Ze(t1, e) {
            return e.some((e)=>e.kind === t1.kind);
        }
        function He(t1, e) {
            return e.some((e)=>"null" === e ? null === t1 : "array" === e ? Array.isArray(t1) : "object" === e ? t1 && !Array.isArray(t1) && "object" == typeof t1 : e === typeof t1);
        }
        class We {
            compare(t1, e) {
                return this.collator.compare(t1, e);
            }
            resolvedLocale() {
                return new Intl.Collator(this.locale ? this.locale : []).resolvedOptions().locale;
            }
            constructor(t1, e, r){
                this.sensitivity = t1 ? e ? "variant" : "case" : e ? "accent" : "base", this.locale = r, this.collator = new Intl.Collator(this.locale ? this.locale : [], {
                    sensitivity: this.sensitivity,
                    usage: "search"
                });
            }
        }
        class Ke {
            constructor(t1, e, r, n, i){
                this.text = t1.normalize ? t1.normalize() : t1, this.image = e, this.scale = r, this.fontStack = n, this.textColor = i;
            }
        }
        class Je {
            static fromString(t1) {
                return new Je([
                    new Ke(t1, null, null, null, null)
                ]);
            }
            isEmpty() {
                return 0 === this.sections.length || !this.sections.some((t1)=>0 !== t1.text.length || t1.image && t1.image.namePrimary);
            }
            static factory(t1) {
                return t1 instanceof Je ? t1 : Je.fromString(t1);
            }
            toString() {
                return 0 === this.sections.length ? "" : this.sections.map((t1)=>t1.text).join("");
            }
            serialize() {
                const t1 = [
                    "format"
                ];
                for (const e of this.sections){
                    if (e.image) {
                        t1.push([
                            "image",
                            e.image.namePrimary
                        ]);
                        continue;
                    }
                    t1.push(e.text);
                    const r = {};
                    e.fontStack && (r["text-font"] = [
                        "literal",
                        e.fontStack.split(",")
                    ]), e.scale && (r["font-scale"] = e.scale), e.textColor && (r["text-color"] = [
                        "rgba"
                    ].concat(e.textColor.toRenderColor(null).toArray())), t1.push(r);
                }
                return t1;
            }
            constructor(t1){
                this.sections = t1;
            }
        }
        class Qe {
            static deserializeId(t1) {
                return JSON.parse(t1).id;
            }
            static deserializeFromString(t1) {
                const e = JSON.parse(t1), { a: r, b: n, c: i, d: a, e: s, f: o } = e.options.transform;
                return new DOMMatrix([
                    r,
                    n,
                    i,
                    a,
                    s,
                    o
                ]), new Qe(e.id, e.options);
            }
            scaleSelf(t1) {
                return this.options.transform = this.options.transform.scale(t1), this;
            }
            serialize() {
                const t1 = {
                    id: this.id
                };
                this.options && (t1.options = this.options);
                const { a: e, b: r, c: n, d: i, e: a, f: s } = this.options.transform;
                return t1.options.transform = {
                    a: e,
                    b: r,
                    c: n,
                    d: i,
                    e: a,
                    f: s
                }, JSON.stringify(t1);
            }
            constructor(t1, e){
                if (this.id = t1, this.options = e || {
                    params: {}
                }, this.options.transform) {
                    const { a: t1, b: e, c: r, d: n, e: i, f: a } = this.options.transform;
                    this.options.transform = new DOMMatrix([
                        t1,
                        e,
                        r,
                        n,
                        i,
                        a
                    ]);
                } else this.options.transform = new DOMMatrix([
                    1,
                    0,
                    0,
                    1,
                    0,
                    0
                ]);
            }
        }
        class tr {
            toString() {
                return this.namePrimary && this.nameSecondary ? `[${this.namePrimary},${this.nameSecondary}]` : this.namePrimary;
            }
            getPrimary() {
                return new Qe(this.namePrimary, {
                    params: this.optionsPrimary && this.optionsPrimary.params || {}
                });
            }
            getSerializedPrimary() {
                return this.getPrimary().serialize();
            }
            getSecondary() {
                return this.nameSecondary ? new Qe(this.nameSecondary, {
                    params: this.optionsSecondary && this.optionsSecondary.params || {}
                }) : null;
            }
            static from(t1) {
                return "string" == typeof t1 ? tr.build(t1) : t1;
            }
            static build(t1, e, r, n) {
                return t1 ? new tr({
                    namePrimary: t1,
                    nameSecondary: e,
                    optionsPrimary: r,
                    optionsSecondary: n,
                    available: !1
                }) : null;
            }
            constructor(t1){
                this.namePrimary = t1.namePrimary, t1.nameSecondary && (this.nameSecondary = t1.nameSecondary), t1.optionsPrimary && (this.optionsPrimary = t1.optionsPrimary), t1.optionsSecondary && (this.optionsSecondary = t1.optionsSecondary), this.available = t1.available;
            }
        }
        function er(t1, e, r, n) {
            return "number" == typeof t1 && t1 >= 0 && t1 <= 255 && "number" == typeof e && e >= 0 && e <= 255 && "number" == typeof r && r >= 0 && r <= 255 ? void 0 === n || "number" == typeof n && n >= 0 && n <= 1 ? null : `Invalid rgba value [${[
                t1,
                e,
                r,
                n
            ].join(", ")}]: 'a' must be between 0 and 1.` : `Invalid rgba value [${("number" == typeof n ? [
                t1,
                e,
                r,
                n
            ] : [
                t1,
                e,
                r
            ]).join(", ")}]: 'r', 'g', and 'b' must be between 0 and 255.`;
        }
        function rr(t1) {
            if (null === t1) return !0;
            if ("string" == typeof t1) return !0;
            if ("boolean" == typeof t1) return !0;
            if ("number" == typeof t1) return !0;
            if (t1 instanceof Ie) return !0;
            if (t1 instanceof We) return !0;
            if (t1 instanceof Je) return !0;
            if (t1 instanceof tr) return !0;
            if (Array.isArray(t1)) {
                for (const e of t1)if (!rr(e)) return !1;
                return !0;
            }
            if ("object" == typeof t1) {
                for(const e in t1)if (!rr(t1[e])) return !1;
                return !0;
            }
            return !1;
        }
        function nr(t1) {
            if (null === t1) return Ve;
            if ("string" == typeof t1) return Le;
            if ("boolean" == typeof t1) return Re;
            if ("number" == typeof t1) return De;
            if (t1 instanceof Ie) return Fe;
            if (t1 instanceof We) return Ue;
            if (t1 instanceof Je) return je;
            if (t1 instanceof tr) return qe;
            if (Array.isArray(t1)) {
                const e = t1.length;
                let r;
                for (const e of t1){
                    const t1 = nr(e);
                    if (r) {
                        if (r === t1) continue;
                        r = Ne;
                        break;
                    }
                    r = t1;
                }
                return $e(r || Ne, e);
            }
            return Oe;
        }
        function ir(t1) {
            const e = typeof t1;
            return null === t1 ? "" : "string" === e || "number" === e || "boolean" === e ? String(t1) : t1 instanceof Ie ? t1.toStringPremultipliedAlpha() : t1 instanceof Je || t1 instanceof tr ? t1.toString() : JSON.stringify(t1);
        }
        class ar {
            static parse(t1, e) {
                if (2 !== t1.length) return e.error(`'literal' expression requires exactly one argument, but found ${t1.length - 1} instead.`);
                if (!rr(t1[1])) return e.error("invalid value");
                const r = t1[1];
                let n = nr(r);
                const i = e.expectedType;
                return "array" !== n.kind || 0 !== n.N || !i || "array" !== i.kind || "number" == typeof i.N && 0 !== i.N || (n = i), new ar(n, r);
            }
            evaluate() {
                return this.value;
            }
            eachChild() {}
            outputDefined() {
                return !0;
            }
            serialize() {
                return "array" === this.type.kind || "object" === this.type.kind ? [
                    "literal",
                    this.value
                ] : this.value instanceof Ie ? [
                    "rgba"
                ].concat(this.value.toRenderColor(null).toArray()) : this.value instanceof Je ? this.value.serialize() : this.value;
            }
            constructor(t1, e){
                this.type = t1, this.value = e;
            }
        }
        class sr {
            toJSON() {
                return this.message;
            }
            constructor(t1){
                this.name = "ExpressionEvaluationError", this.message = t1;
            }
        }
        const or = {
            string: Le,
            number: De,
            boolean: Re,
            object: Oe
        };
        class lr {
            static parse(t1, e) {
                if (t1.length < 2) return e.error("Expected at least one argument.");
                let r, n = 1;
                const i = t1[0];
                if ("array" === i) {
                    let i, a;
                    if (t1.length > 2) {
                        const r = t1[1];
                        if ("string" != typeof r || !(r in or) || "object" === r) return e.error('The item type argument of "array" must be one of string, number, boolean', 1);
                        i = or[r], n++;
                    } else i = Ne;
                    if (t1.length > 3) {
                        if (null !== t1[2] && ("number" != typeof t1[2] || t1[2] < 0 || t1[2] !== Math.floor(t1[2]))) return e.error('The length argument to "array" must be a positive integer literal', 2);
                        a = t1[2], n++;
                    }
                    r = $e(i, a);
                } else r = or[i];
                const a = [];
                for(; n < t1.length; n++){
                    const r = e.parse(t1[n], n, Ne);
                    if (!r) return null;
                    a.push(r);
                }
                return new lr(r, a);
            }
            evaluate(t1) {
                for(let e = 0; e < this.args.length; e++){
                    const r = this.args[e].evaluate(t1);
                    if (!Xe(this.type, nr(r))) return r;
                    if (e === this.args.length - 1) throw new sr(`The expression ${JSON.stringify(this.args[e].serialize())} evaluated to ${Ge(nr(r))} but was expected to be of type ${Ge(this.type)}.`);
                }
                return null;
            }
            eachChild(t1) {
                this.args.forEach(t1);
            }
            outputDefined() {
                return this.args.every((t1)=>t1.outputDefined());
            }
            serialize() {
                const t1 = this.type, e = [
                    t1.kind
                ];
                if ("array" === t1.kind) {
                    const r = t1.itemType;
                    if ("string" === r.kind || "number" === r.kind || "boolean" === r.kind) {
                        e.push(r.kind);
                        const n = t1.N;
                        ("number" == typeof n || this.args.length > 1) && e.push(n);
                    }
                }
                return e.concat(this.args.map((t1)=>t1.serialize()));
            }
            constructor(t1, e){
                this.type = t1, this.args = e;
            }
        }
        class ur {
            static parse(t1, e) {
                if (t1.length < 2) return e.error("Expected at least one argument.");
                const r = t1[1];
                if (!Array.isArray(r) && "object" == typeof r) return e.error("First argument must be an image or text section.");
                const n = [];
                let i = !1;
                for(let r = 1; r <= t1.length - 1; ++r){
                    const a = t1[r];
                    if (i && "object" == typeof a && !Array.isArray(a)) {
                        i = !1;
                        let t1 = null;
                        if (a["font-scale"] && (t1 = e.parseObjectValue(a["font-scale"], r, "font-scale", De), !t1)) return null;
                        let s = null;
                        if (a["text-font"] && (s = e.parseObjectValue(a["text-font"], r, "text-font", $e(Le)), !s)) return null;
                        let o = null;
                        if (a["text-color"] && (o = e.parseObjectValue(a["text-color"], r, "text-color", Fe), !o)) return null;
                        const l = n[n.length - 1];
                        l.scale = t1, l.font = s, l.textColor = o;
                    } else {
                        const a = e.parse(t1[r], r, Ne);
                        if (!a) return null;
                        const s = a.type.kind;
                        if ("string" !== s && "value" !== s && "null" !== s && "resolvedImage" !== s) return e.error("Formatted text type must be 'string', 'value', 'image' or 'null'.");
                        i = !0, n.push({
                            content: a,
                            scale: null,
                            font: null,
                            textColor: null
                        });
                    }
                }
                return new ur(n);
            }
            evaluate(t1) {
                return new Je(this.sections.map((e)=>{
                    const r = e.content.evaluate(t1);
                    return nr(r) === qe ? new Ke("", r, null, null, null) : new Ke(ir(r), null, e.scale ? e.scale.evaluate(t1) : null, e.font ? e.font.evaluate(t1).join(",") : null, e.textColor ? e.textColor.evaluate(t1) : null);
                }));
            }
            eachChild(t1) {
                for (const e of this.sections)t1(e.content), e.scale && t1(e.scale), e.font && t1(e.font), e.textColor && t1(e.textColor);
            }
            outputDefined() {
                return !1;
            }
            serialize() {
                const t1 = [
                    "format"
                ];
                for (const e of this.sections){
                    t1.push(e.content.serialize());
                    const r = {};
                    e.scale && (r["font-scale"] = e.scale.serialize()), e.font && (r["text-font"] = e.font.serialize()), e.textColor && (r["text-color"] = e.textColor.serialize()), t1.push(r);
                }
                return t1;
            }
            constructor(t1){
                this.type = je, this.sections = t1;
            }
        }
        class cr {
            static parse(t1, e) {
                if (t1.length < 2) return e.error("Expected two or more arguments.");
                let r = 1;
                const n = [];
                function i() {
                    if (r < t1.length) {
                        const i = e.parse(t1[r], r++, Le);
                        return i ? (n.push({
                            image: i,
                            options: void 0
                        }), !0) : (e.error(n.length ? "Secondary image variant is not a string." : "No image name provided."), !1);
                    }
                    return !0;
                }
                function a() {
                    if (r < t1.length) {
                        if (null === (i = t1[r]) || "object" != typeof i || Array.isArray(i)) return !0;
                        const a = t1[r].params, s = e.concat(r);
                        if (!a) return r++, !0;
                        if ("object" != typeof a || a.constructor !== Object) return s.error('Image options "params" should be an object'), !1;
                        const o = {}, l = s.concat(void 0, "params");
                        for(const t1 in a){
                            if (!t1) return l.error("Image parameter name should be non-empty"), !1;
                            const e = l.concat(void 0, t1).parse(a[t1], void 0, Fe, void 0, {
                                typeAnnotation: "coerce"
                            });
                            if (!e) return !1;
                            o[t1] = e;
                        }
                        return n[n.length - 1].options = o, r++, !0;
                    }
                    var i;
                    return !0;
                }
                for(let t1 = 0; t1 < 2; t1++)if (!i() || !a()) return;
                return new cr(n[0].image, n[1] ? n[1].image : void 0, n[0].options, n[1] ? n[1].options : void 0);
            }
            evaluateParams(t1, e) {
                const r = {};
                if (e) {
                    for(const n in e)if (e[n]) try {
                        const i = e[n].evaluate(t1), a = `Ignoring image parameter "${n}" with semi-transparent color ${i.toString()}`;
                        if (1 !== i.a) {
                            this._imageWarnHistory[a] || (console.warn(a), this._imageWarnHistory[a] = !0);
                            continue;
                        }
                        r[n] = i;
                    } catch (t1) {
                        continue;
                    }
                    if (0 !== Object.keys(r).length) return {
                        params: r
                    };
                }
            }
            evaluate(t1) {
                const e = tr.build(this.inputPrimary.evaluate(t1), this.inputSecondary ? this.inputSecondary.evaluate(t1) : void 0, this.inputPrimaryParams ? this.evaluateParams(t1, this.inputPrimaryParams) : void 0, this.inputSecondaryParams ? this.evaluateParams(t1, this.inputSecondaryParams) : void 0);
                return e && t1.availableImages && (e.available = t1.availableImages.indexOf(e.namePrimary) > -1, e.nameSecondary && e.available && t1.availableImages && (e.available = t1.availableImages.indexOf(e.nameSecondary) > -1)), e;
            }
            eachChild(t1) {
                if (t1(this.inputPrimary), this.inputPrimaryParams) for(const e in this.inputPrimaryParams)this.inputPrimaryParams[e] && t1(this.inputPrimaryParams[e]);
                if (this.inputSecondary && (t1(this.inputSecondary), this.inputSecondaryParams)) for(const e in this.inputSecondaryParams)this.inputSecondaryParams[e] && t1(this.inputSecondaryParams[e]);
            }
            outputDefined() {
                return !1;
            }
            serializeParams(t1) {
                const e = {};
                if (t1) {
                    for(const r in t1)t1[r] && (e[r] = t1[r].serialize());
                    return {
                        params: e
                    };
                }
            }
            serialize() {
                const t1 = [
                    "image",
                    this.inputPrimary.serialize()
                ];
                return this.inputPrimaryParams && t1.push(this.serializeParams(this.inputPrimaryParams)), this.inputSecondary && (t1.push(this.inputSecondary.serialize()), this.inputSecondaryParams && t1.push(this.serializeParams(this.inputSecondaryParams))), t1;
            }
            constructor(t1, e, r, n){
                this._imageWarnHistory = {}, this.type = qe, this.inputPrimary = t1, this.inputSecondary = e, this.inputPrimaryParams = r, this.inputSecondaryParams = n;
            }
        }
        function hr(t1) {
            return t1 instanceof Number ? "number" : t1 instanceof String ? "string" : t1 instanceof Boolean ? "boolean" : Array.isArray(t1) ? "array" : null === t1 ? "null" : typeof t1;
        }
        const pr = {
            "to-boolean": Re,
            "to-color": Fe,
            "to-number": De,
            "to-string": Le
        };
        class fr {
            static parse(t1, e) {
                if (t1.length < 2) return e.error("Expected at least one argument.");
                const r = t1[0], n = [];
                let i = Ve;
                if ("to-array" === r) {
                    if (!Array.isArray(t1[1])) return null;
                    const r = t1[1].length;
                    if (e.expectedType) {
                        if ("array" !== e.expectedType.kind) return e.error(`Expected ${e.expectedType.kind} but found array.`);
                        i = $e(e.expectedType.itemType, r);
                    } else {
                        if (!(r > 0 && rr(t1[1][0]))) return null;
                        i = $e(nr(t1[1][0]), r);
                    }
                    for(let a = 0; a < r; a++){
                        const r = t1[1][a];
                        let s;
                        if ("array" === hr(r)) s = e.parse(r, void 0, i.itemType);
                        else {
                            const t1 = hr(r);
                            if (t1 !== i.itemType.kind) return e.error(`Expected ${i.itemType.kind} but found ${t1}.`);
                            s = e.registry.literal.parse([
                                "literal",
                                void 0 === r ? null : r
                            ], e);
                        }
                        if (!s) return null;
                        n.push(s);
                    }
                } else {
                    if (("to-boolean" === r || "to-string" === r) && 2 !== t1.length) return e.error("Expected one argument.");
                    i = pr[r];
                    for(let r = 1; r < t1.length; r++){
                        const i = e.parse(t1[r], r, Ne);
                        if (!i) return null;
                        n.push(i);
                    }
                }
                return new fr(i, n);
            }
            evaluate(t1) {
                if ("boolean" === this.type.kind) return Boolean(this.args[0].evaluate(t1));
                if ("color" === this.type.kind) {
                    let e, r;
                    for (const n of this.args){
                        if (e = n.evaluate(t1), r = null, e instanceof Ie) return e;
                        if ("string" == typeof e) {
                            const r = t1.parseColor(e);
                            if (r) return r;
                        } else if (Array.isArray(e) && (r = e.length < 3 || e.length > 4 ? `Invalid rbga value ${JSON.stringify(e)}: expected an array containing either three or four numeric values.` : er(e[0], e[1], e[2], e[3]), !r)) return new Ie(e[0] / 255, e[1] / 255, e[2] / 255, e[3]);
                    }
                    throw new sr(r || `Could not parse color from value '${"string" == typeof e ? e : String(JSON.stringify(e))}'`);
                }
                if ("number" === this.type.kind) {
                    let e = null;
                    for (const r of this.args){
                        if (e = r.evaluate(t1), null === e) return 0;
                        const n = Number(e);
                        if (!isNaN(n)) return n;
                    }
                    throw new sr(`Could not convert ${JSON.stringify(e)} to number.`);
                }
                return "formatted" === this.type.kind ? Je.fromString(ir(this.args[0].evaluate(t1))) : "resolvedImage" === this.type.kind ? tr.build(ir(this.args[0].evaluate(t1))) : "array" === this.type.kind ? this.args.map((e)=>e.evaluate(t1)) : ir(this.args[0].evaluate(t1));
            }
            eachChild(t1) {
                this.args.forEach(t1);
            }
            outputDefined() {
                return this.args.every((t1)=>t1.outputDefined());
            }
            serialize() {
                if ("formatted" === this.type.kind) return new ur([
                    {
                        content: this.args[0],
                        scale: null,
                        font: null,
                        textColor: null
                    }
                ]).serialize();
                if ("resolvedImage" === this.type.kind) return new cr(this.args[0]).serialize();
                const t1 = "array" === this.type.kind ? [] : [
                    `to-${this.type.kind}`
                ];
                return this.eachChild((e)=>{
                    t1.push(e.serialize());
                }), t1;
            }
            constructor(t1, e){
                this.type = t1, this.args = e;
            }
        }
        const dr = [
            "Unknown",
            "Point",
            "LineString",
            "Polygon"
        ];
        class mr {
            id() {
                return this.feature && void 0 !== this.feature.id ? this.feature.id : null;
            }
            geometryType() {
                return this.feature ? "number" == typeof this.feature.type ? dr[this.feature.type] : this.feature.type : null;
            }
            geometry() {
                return this.feature && "geometry" in this.feature ? this.feature.geometry : null;
            }
            canonicalID() {
                return this.canonical;
            }
            properties() {
                return this.feature && this.feature.properties || {};
            }
            measureLight(t1) {
                return this.globals.brightness || 0;
            }
            distanceFromCenter() {
                if (this.featureTileCoord && this.featureDistanceData) {
                    const t1 = this.featureDistanceData.center, e = this.featureDistanceData.scale, { x: r, y: n } = this.featureTileCoord;
                    return this.featureDistanceData.bearing[0] * (r * e - t1[0]) + this.featureDistanceData.bearing[1] * (n * e - t1[1]);
                }
                return 0;
            }
            parseColor(t1) {
                let e = this._parseColorCache[t1];
                return e || (e = this._parseColorCache[t1] = Ie.parse(t1)), e;
            }
            getConfig(t1) {
                return this.options ? this.options.get(t1) : null;
            }
            constructor(t1, e){
                this.globals = null, this.feature = null, this.featureState = null, this.formattedSection = null, this._parseColorCache = {}, this.availableImages = null, this.canonical = null, this.featureTileCoord = null, this.featureDistanceData = null, this.scope = t1, this.options = e;
            }
        }
        class yr {
            evaluate(t1) {
                if (!this._evaluate) {
                    const t1 = yr.definitions[this.name];
                    this._evaluate = Array.isArray(t1) ? t1[2] : t1.overloads[this._overloadIndex][1];
                }
                return this._evaluate(t1, this.args);
            }
            eachChild(t1) {
                this.args.forEach(t1);
            }
            outputDefined() {
                return !1;
            }
            serialize() {
                return [
                    this.name
                ].concat(this.args.map((t1)=>t1.serialize()));
            }
            static parse(t1, e) {
                const r = t1[0], n = yr.definitions[r];
                if (!n) return e.error(`Unknown expression "${r}". If you wanted a literal array, use ["literal", [...]].`, 0);
                const i = Array.isArray(n) ? n[0] : n.type, a = Array.isArray(n) ? [
                    [
                        n[1],
                        n[2]
                    ]
                ] : n.overloads, s = [];
                let o = null, l = -1;
                for (const [n, u] of a){
                    if (Array.isArray(n) && n.length !== t1.length - 1) continue;
                    s.push(n), l++, o = new Rn(e.registry, e.path, null, e.scope, void 0, e._scope, e.options);
                    const a = [];
                    let c = !1;
                    for(let e = 1; e < t1.length; e++){
                        const r = t1[e], i = Array.isArray(n) ? n[e - 1] : n.type, s = o.parse(r, 1 + a.length, i);
                        if (!s) {
                            c = !0;
                            break;
                        }
                        a.push(s);
                    }
                    if (!c) {
                        if (Array.isArray(n) && n.length !== a.length) o.error(`Expected ${n.length} arguments, but found ${a.length} instead.`);
                        else {
                            for(let t1 = 0; t1 < a.length; t1++){
                                const e = Array.isArray(n) ? n[t1] : n.type, r = a[t1];
                                o.concat(t1 + 1).checkSubtype(e, r.type);
                            }
                            if (0 === o.errors.length) return new yr(r, i, u, a, l);
                        }
                    }
                }
                if (1 === s.length) e.errors.push(...o.errors);
                else {
                    const r = (s.length ? s : a.map(([t1])=>t1)).map(gr).join(" | "), n = [];
                    for(let r = 1; r < t1.length; r++){
                        const i = e.parse(t1[r], 1 + n.length);
                        if (!i) return null;
                        n.push(Ge(i.type));
                    }
                    e.error(`Expected arguments of type ${r}, but found (${n.join(", ")}) instead.`);
                }
                return null;
            }
            static register(t1, e) {
                yr.definitions = e;
                for(const r in e)t1[r] = yr;
            }
            constructor(t1, e, r, n, i){
                this.name = t1, this.type = e, this._evaluate = r, this.args = n, this._overloadIndex = i;
            }
        }
        function gr(t1) {
            return Array.isArray(t1) ? `(${t1.map(Ge).join(", ")})` : `(${Ge(t1.type)}...)`;
        }
        class xr {
            static parse(t1, e) {
                if (2 !== t1.length) return e.error("Expected one argument.");
                const r = t1[1];
                if ("object" != typeof r || Array.isArray(r)) return e.error("Collator options argument must be an object.");
                const n = void 0 === r["case-sensitive"] ? e.parse(!1, 1, Re) : e.parseObjectValue(r["case-sensitive"], 1, "case-sensitive", Re);
                if (!n) return null;
                const i = void 0 === r["diacritic-sensitive"] ? e.parse(!1, 1, Re) : e.parseObjectValue(r["diacritic-sensitive"], 1, "diacritic-sensitive", Re);
                if (!i) return null;
                let a = null;
                return r.locale && (a = e.parseObjectValue(r.locale, 1, "locale", Le), !a) ? null : new xr(n, i, a);
            }
            evaluate(t1) {
                return new We(this.caseSensitive.evaluate(t1), this.diacriticSensitive.evaluate(t1), this.locale ? this.locale.evaluate(t1) : null);
            }
            eachChild(t1) {
                t1(this.caseSensitive), t1(this.diacriticSensitive), this.locale && t1(this.locale);
            }
            outputDefined() {
                return !1;
            }
            serialize() {
                const t1 = {};
                return t1["case-sensitive"] = this.caseSensitive.serialize(), t1["diacritic-sensitive"] = this.diacriticSensitive.serialize(), this.locale && (t1.locale = this.locale.serialize()), [
                    "collator",
                    t1
                ];
            }
            constructor(t1, e, r){
                this.type = Ue, this.locale = r, this.caseSensitive = t1, this.diacriticSensitive = e;
            }
        }
        function vr(t1, e, r = 0, n = t1.length - 1, i = _r) {
            for(; n > r;){
                if (n - r > 600) {
                    const a = n - r + 1, s = e - r + 1, o = Math.log(a), l = .5 * Math.exp(2 * o / 3), u = .5 * Math.sqrt(o * l * (a - l) / a) * (s - a / 2 < 0 ? -1 : 1);
                    vr(t1, e, Math.max(r, Math.floor(e - s * l / a + u)), Math.min(n, Math.floor(e + (a - s) * l / a + u)), i);
                }
                const a = t1[e];
                let s = r, o = n;
                for(br(t1, r, e), i(t1[n], a) > 0 && br(t1, r, n); s < o;){
                    for(br(t1, s, o), s++, o--; i(t1[s], a) < 0;)s++;
                    for(; i(t1[o], a) > 0;)o--;
                }
                0 === i(t1[r], a) ? br(t1, r, o) : (o++, br(t1, o, n)), o <= e && (r = o + 1), e <= o && (n = o - 1);
            }
        }
        function br(t1, e, r) {
            const n = t1[e];
            t1[e] = t1[r], t1[r] = n;
        }
        function _r(t1, e) {
            return t1 < e ? -1 : t1 > e ? 1 : 0;
        }
        function wr(t1) {
            let e = 0;
            for(let r, n, i = 0, a = t1.length, s = a - 1; i < a; s = i++)r = t1[i], n = t1[s], e += (n.x - r.x) * (r.y + n.y);
            return e;
        }
        function Mr(t1, e) {
            t1[0] = Math.min(t1[0], e[0]), t1[1] = Math.min(t1[1], e[1]), t1[2] = Math.max(t1[2], e[0]), t1[3] = Math.max(t1[3], e[1]);
        }
        function Ar(t1, e) {
            return !(t1[0] <= e[0] || t1[2] >= e[2] || t1[1] <= e[1] || t1[3] >= e[3]);
        }
        function Sr(t1, e, r) {
            const n = t1[0] - e[0], i = t1[1] - e[1], a = t1[0] - r[0], s = t1[1] - r[1];
            return n * s - a * i == 0 && n * a <= 0 && i * s <= 0;
        }
        function Ir(t1, e, r = !1) {
            let n = !1;
            for(let o = 0, l = e.length; o < l; o++){
                const l = e[o];
                for(let e = 0, o = l.length, u = o - 1; e < o; u = e++){
                    const o = l[u], c = l[e];
                    if (Sr(t1, o, c)) return r;
                    (a = o)[1] > (i = t1)[1] != (s = c)[1] > i[1] && i[0] < (s[0] - a[0]) * (i[1] - a[1]) / (s[1] - a[1]) + a[0] && (n = !n);
                }
            }
            var i, a, s;
            return n;
        }
        function Pr(t1, e, r, n) {
            const i = n[0] - r[0], a = n[1] - r[1], s = (t1[0] - r[0]) * a - i * (t1[1] - r[1]), o = (e[0] - r[0]) * a - i * (e[1] - r[1]);
            return s > 0 && o < 0 || s < 0 && o > 0;
        }
        function zr(t1, e, r, n) {
            var i, a;
            return 0 != (i = [
                n[0] - r[0],
                n[1] - r[1]
            ])[0] * (a = [
                e[0] - t1[0],
                e[1] - t1[1]
            ])[1] - i[1] * a[0] && !(!Pr(t1, e, r, n) || !Pr(r, n, t1, e));
        }
        const Er = 8192;
        function kr(t1, e) {
            const r = (180 + t1[0]) / 360, n = (180 - 180 / Math.PI * Math.log(Math.tan(Math.PI / 4 + t1[1] * Math.PI / 360))) / 360, i = Math.pow(2, e.z);
            return [
                Math.round(r * i * Er),
                Math.round(n * i * Er)
            ];
        }
        function Tr(t1, e) {
            for(let r = 0; r < e.length; r++)if (Ir(t1, e[r])) return !0;
            return !1;
        }
        function Br(t1, e, r) {
            for (const n of r)for(let r = 0, i = n.length, a = i - 1; r < i; a = r++)if (zr(t1, e, n[a], n[r])) return !0;
            return !1;
        }
        function Cr(t1, e) {
            for(let r = 0; r < t1.length; ++r)if (!Ir(t1[r], e)) return !1;
            for(let r = 0; r < t1.length - 1; ++r)if (Br(t1[r], t1[r + 1], e)) return !1;
            return !0;
        }
        function Vr(t1, e) {
            for(let r = 0; r < e.length; r++)if (Cr(t1, e[r])) return !0;
            return !1;
        }
        function Dr(t1, e, r) {
            const n = [];
            for(let i = 0; i < t1.length; i++){
                const a = [];
                for(let n = 0; n < t1[i].length; n++){
                    const s = kr(t1[i][n], r);
                    Mr(e, s), a.push(s);
                }
                n.push(a);
            }
            return n;
        }
        function Lr(t1, e, r) {
            const n = [];
            for(let i = 0; i < t1.length; i++){
                const a = Dr(t1[i], e, r);
                n.push(a);
            }
            return n;
        }
        function Rr(t1, e, r, n) {
            if (t1[0] < r[0] || t1[0] > r[2]) {
                const e = .5 * n;
                let i = t1[0] - r[0] > e ? -n : r[0] - t1[0] > e ? n : 0;
                0 === i && (i = t1[0] - r[2] > e ? -n : r[2] - t1[0] > e ? n : 0), t1[0] += i;
            }
            Mr(e, t1);
        }
        function Fr(t1, e, r, n) {
            const i = Math.pow(2, n.z) * Er, a = [
                n.x * Er,
                n.y * Er
            ], s = [];
            if (!t1) return s;
            for (const n of t1)for (const t1 of n){
                const n = [
                    t1.x + a[0],
                    t1.y + a[1]
                ];
                Rr(n, e, r, i), s.push(n);
            }
            return s;
        }
        function Or(t1, e, r, n) {
            const i = Math.pow(2, n.z) * Er, a = [
                n.x * Er,
                n.y * Er
            ], s = [];
            if (!t1) return s;
            for (const r of t1){
                const t1 = [];
                for (const n of r){
                    const r = [
                        n.x + a[0],
                        n.y + a[1]
                    ];
                    Mr(e, r), t1.push(r);
                }
                s.push(t1);
            }
            if (e[2] - e[0] <= i / 2) {
                (o = e)[0] = o[1] = 1 / 0, o[2] = o[3] = -1 / 0;
                for (const t1 of s)for (const n of t1)Rr(n, e, r, i);
            }
            var o;
            return s;
        }
        class Nr {
            static parse(t1, e) {
                if (2 !== t1.length) return e.error(`'within' expression requires exactly one argument, but found ${t1.length - 1} instead.`);
                if (rr(t1[1])) {
                    const e = t1[1];
                    if ("FeatureCollection" === e.type) for(let t1 = 0; t1 < e.features.length; ++t1){
                        const r = e.features[t1].geometry.type;
                        if ("Polygon" === r || "MultiPolygon" === r) return new Nr(e, e.features[t1].geometry);
                    }
                    else if ("Feature" === e.type) {
                        const t1 = e.geometry.type;
                        if ("Polygon" === t1 || "MultiPolygon" === t1) return new Nr(e, e.geometry);
                    } else if ("Polygon" === e.type || "MultiPolygon" === e.type) return new Nr(e, e);
                }
                return e.error("'within' expression requires valid geojson object that contains polygon geometry type.");
            }
            evaluate(t1) {
                if (null != t1.geometry() && null != t1.canonicalID()) {
                    if ("Point" === t1.geometryType()) return function(t1, e) {
                        const r = [
                            1 / 0,
                            1 / 0,
                            -1 / 0,
                            -1 / 0
                        ], n = [
                            1 / 0,
                            1 / 0,
                            -1 / 0,
                            -1 / 0
                        ], i = t1.canonicalID();
                        if (!i) return !1;
                        if ("Polygon" === e.type) {
                            const a = Dr(e.coordinates, n, i), s = Fr(t1.geometry(), r, n, i);
                            if (!Ar(r, n)) return !1;
                            for (const t1 of s)if (!Ir(t1, a)) return !1;
                        }
                        if ("MultiPolygon" === e.type) {
                            const a = Lr(e.coordinates, n, i), s = Fr(t1.geometry(), r, n, i);
                            if (!Ar(r, n)) return !1;
                            for (const t1 of s)if (!Tr(t1, a)) return !1;
                        }
                        return !0;
                    }(t1, this.geometries);
                    if ("LineString" === t1.geometryType()) return function(t1, e) {
                        const r = [
                            1 / 0,
                            1 / 0,
                            -1 / 0,
                            -1 / 0
                        ], n = [
                            1 / 0,
                            1 / 0,
                            -1 / 0,
                            -1 / 0
                        ], i = t1.canonicalID();
                        if (!i) return !1;
                        if ("Polygon" === e.type) {
                            const a = Dr(e.coordinates, n, i), s = Or(t1.geometry(), r, n, i);
                            if (!Ar(r, n)) return !1;
                            for (const t1 of s)if (!Cr(t1, a)) return !1;
                        }
                        if ("MultiPolygon" === e.type) {
                            const a = Lr(e.coordinates, n, i), s = Or(t1.geometry(), r, n, i);
                            if (!Ar(r, n)) return !1;
                            for (const t1 of s)if (!Vr(t1, a)) return !1;
                        }
                        return !0;
                    }(t1, this.geometries);
                }
                return !1;
            }
            eachChild() {}
            outputDefined() {
                return !0;
            }
            serialize() {
                return [
                    "within",
                    this.geojson
                ];
            }
            constructor(t1, e){
                this.type = Re, this.geojson = t1, this.geometries = e;
            }
        }
        const Ur = {
            kilometers: 1,
            miles: 1e3 / 1609.344,
            nauticalmiles: 1e3 / 1852,
            meters: 1e3,
            metres: 1e3,
            yards: 1e3 / .9144,
            feet: 1e3 / .3048,
            inches: 1e3 / .0254
        }, jr = 1 / 298.257223563, qr = jr * (2 - jr), $r = Math.PI / 180;
        class Gr {
            static fromTile(t1, e, r) {
                const n = Math.PI * (1 - 2 * (t1 + .5) / Math.pow(2, e)), i = Math.atan(.5 * (Math.exp(n) - Math.exp(-n))) / $r;
                return new Gr(i, r);
            }
            static get units() {
                return Ur;
            }
            distance(t1, e) {
                const r = Zr(t1[0] - e[0]) * this.kx, n = (t1[1] - e[1]) * this.ky;
                return Math.sqrt(r * r + n * n);
            }
            bearing(t1, e) {
                const r = Zr(e[0] - t1[0]) * this.kx;
                return Math.atan2(r, (e[1] - t1[1]) * this.ky) / $r;
            }
            destination(t1, e, r) {
                const n = r * $r;
                return this.offset(t1, Math.sin(n) * e, Math.cos(n) * e);
            }
            offset(t1, e, r) {
                return [
                    t1[0] + e / this.kx,
                    t1[1] + r / this.ky
                ];
            }
            lineDistance(t1) {
                let e = 0;
                for(let r = 0; r < t1.length - 1; r++)e += this.distance(t1[r], t1[r + 1]);
                return e;
            }
            area(t1) {
                let e = 0;
                for(let r = 0; r < t1.length; r++){
                    const n = t1[r];
                    for(let t1 = 0, i = n.length, a = i - 1; t1 < i; a = t1++)e += Zr(n[t1][0] - n[a][0]) * (n[t1][1] + n[a][1]) * (r ? -1 : 1);
                }
                return Math.abs(e) / 2 * this.kx * this.ky;
            }
            along(t1, e) {
                let r = 0;
                if (e <= 0) return t1[0];
                for(let n = 0; n < t1.length - 1; n++){
                    const i = t1[n], a = t1[n + 1], s = this.distance(i, a);
                    if (r += s, r > e) return Xr(i, a, (e - (r - s)) / s);
                }
                return t1[t1.length - 1];
            }
            pointToSegmentDistance(t1, e, r) {
                let [n, i] = e, a = Zr(r[0] - n) * this.kx, s = (r[1] - i) * this.ky;
                if (0 !== a || 0 !== s) {
                    const e = (Zr(t1[0] - n) * this.kx * a + (t1[1] - i) * this.ky * s) / (a * a + s * s);
                    e > 1 ? (n = r[0], i = r[1]) : e > 0 && (n += a / this.kx * e, i += s / this.ky * e);
                }
                return a = Zr(t1[0] - n) * this.kx, s = (t1[1] - i) * this.ky, Math.sqrt(a * a + s * s);
            }
            pointOnLine(t1, e) {
                let r = 1 / 0, n = t1[0][0], i = t1[0][1], a = 0, s = 0;
                for(let o = 0; o < t1.length - 1; o++){
                    let l = t1[o][0], u = t1[o][1], c = Zr(t1[o + 1][0] - l) * this.kx, h = (t1[o + 1][1] - u) * this.ky, p = 0;
                    0 === c && 0 === h || (p = (Zr(e[0] - l) * this.kx * c + (e[1] - u) * this.ky * h) / (c * c + h * h), p > 1 ? (l = t1[o + 1][0], u = t1[o + 1][1]) : p > 0 && (l += c / this.kx * p, u += h / this.ky * p)), c = Zr(e[0] - l) * this.kx, h = (e[1] - u) * this.ky;
                    const f = c * c + h * h;
                    f < r && (r = f, n = l, i = u, a = o, s = p);
                }
                return {
                    point: [
                        n,
                        i
                    ],
                    index: a,
                    t: Math.max(0, Math.min(1, s))
                };
            }
            lineSlice(t1, e, r) {
                let n = this.pointOnLine(r, t1), i = this.pointOnLine(r, e);
                if (n.index > i.index || n.index === i.index && n.t > i.t) {
                    const t1 = n;
                    n = i, i = t1;
                }
                const a = [
                    n.point
                ], s = n.index + 1, o = i.index;
                !Yr(r[s], a[0]) && s <= o && a.push(r[s]);
                for(let t1 = s + 1; t1 <= o; t1++)a.push(r[t1]);
                return Yr(r[o], i.point) || a.push(i.point), a;
            }
            lineSliceAlong(t1, e, r) {
                let n = 0;
                const i = [];
                for(let a = 0; a < r.length - 1; a++){
                    const s = r[a], o = r[a + 1], l = this.distance(s, o);
                    if (n += l, n > t1 && 0 === i.length && i.push(Xr(s, o, (t1 - (n - l)) / l)), n >= e) return i.push(Xr(s, o, (e - (n - l)) / l)), i;
                    n > t1 && i.push(o);
                }
                return i;
            }
            bufferPoint(t1, e) {
                const r = e / this.ky, n = e / this.kx;
                return [
                    t1[0] - n,
                    t1[1] - r,
                    t1[0] + n,
                    t1[1] + r
                ];
            }
            bufferBBox(t1, e) {
                const r = e / this.ky, n = e / this.kx;
                return [
                    t1[0] - n,
                    t1[1] - r,
                    t1[2] + n,
                    t1[3] + r
                ];
            }
            insideBBox(t1, e) {
                return Zr(t1[0] - e[0]) >= 0 && Zr(t1[0] - e[2]) <= 0 && t1[1] >= e[1] && t1[1] <= e[3];
            }
            constructor(t1, e){
                if (void 0 === t1) throw new Error("No latitude given.");
                if (e && !Ur[e]) throw new Error(`Unknown unit ${e}. Use one of: ${Object.keys(Ur).join(", ")}`);
                const r = 6378.137 * $r * (e ? Ur[e] : 1), n = Math.cos(t1 * $r), i = 1 / (1 - qr * (1 - n * n)), a = Math.sqrt(i);
                this.kx = r * a * n, this.ky = r * a * i * (1 - qr);
            }
        }
        function Yr(t1, e) {
            return t1[0] === e[0] && t1[1] === e[1];
        }
        function Xr(t1, e, r) {
            const n = Zr(e[0] - t1[0]);
            return [
                t1[0] + n * r,
                t1[1] + (e[1] - t1[1]) * r
            ];
        }
        function Zr(t1) {
            for(; t1 < -180;)t1 += 360;
            for(; t1 > 180;)t1 -= 360;
            return t1;
        }
        class Hr {
            push(t1) {
                this.data.push(t1), this._up(this.length++);
            }
            pop() {
                if (0 === this.length) return;
                const t1 = this.data[0], e = this.data.pop();
                return --this.length > 0 && (this.data[0] = e, this._down(0)), t1;
            }
            peek() {
                return this.data[0];
            }
            _up(t1) {
                const { data: e, compare: r } = this, n = e[t1];
                for(; t1 > 0;){
                    const i = t1 - 1 >> 1, a = e[i];
                    if (r(n, a) >= 0) break;
                    e[t1] = a, t1 = i;
                }
                e[t1] = n;
            }
            _down(t1) {
                const { data: e, compare: r } = this, n = this.length >> 1, i = e[t1];
                for(; t1 < n;){
                    let n = 1 + (t1 << 1);
                    const a = n + 1;
                    if (a < this.length && r(e[a], e[n]) < 0 && (n = a), r(e[n], i) >= 0) break;
                    e[t1] = e[n], t1 = n;
                }
                e[t1] = i;
            }
            constructor(t1 = [], e = (t1, e)=>t1 < e ? -1 : t1 > e ? 1 : 0){
                if (this.data = t1, this.length = this.data.length, this.compare = e, this.length > 0) for(let t1 = (this.length >> 1) - 1; t1 >= 0; t1--)this._down(t1);
            }
        }
        var Wr = 8192;
        function Kr(t1, e) {
            return e.dist - t1.dist;
        }
        const Jr = 100, Qr = 50;
        function tn(t1) {
            const e = [
                1 / 0,
                1 / 0,
                -1 / 0,
                -1 / 0
            ];
            if (e.length !== t1.length) return !1;
            for(let r = 0; r < e.length; r++)if (e[r] !== t1[r]) return !1;
            return !0;
        }
        function en(t1) {
            return t1[1] - t1[0] + 1;
        }
        function rn(t1, e) {
            const r = t1[1] >= t1[0] && t1[1] < e;
            return r || console.warn("Distance Expression: Index is out of range"), r;
        }
        function nn(t1, e) {
            if (t1[0] > t1[1]) return [
                null,
                null
            ];
            const r = en(t1);
            if (e) {
                if (2 === r) return [
                    t1,
                    null
                ];
                const e = Math.floor(r / 2);
                return [
                    [
                        t1[0],
                        t1[0] + e
                    ],
                    [
                        t1[0] + e,
                        t1[1]
                    ]
                ];
            }
            {
                if (1 === r) return [
                    t1,
                    null
                ];
                const e = Math.floor(r / 2) - 1;
                return [
                    [
                        t1[0],
                        t1[0] + e
                    ],
                    [
                        t1[0] + e + 1,
                        t1[1]
                    ]
                ];
            }
        }
        function an(t1, e) {
            const r = [
                1 / 0,
                1 / 0,
                -1 / 0,
                -1 / 0
            ];
            if (!rn(e, t1.length)) return r;
            for(let n = e[0]; n <= e[1]; ++n)Mr(r, t1[n]);
            return r;
        }
        function sn(t1) {
            const e = [
                1 / 0,
                1 / 0,
                -1 / 0,
                -1 / 0
            ];
            for(let r = 0; r < t1.length; ++r)for(let n = 0; n < t1[r].length; ++n)Mr(e, t1[r][n]);
            return e;
        }
        function on(t1, e, r) {
            if (tn(t1) || tn(e)) return NaN;
            let n = 0, i = 0;
            return t1[2] < e[0] && (n = e[0] - t1[2]), t1[0] > e[2] && (n = t1[0] - e[2]), t1[1] > e[3] && (i = t1[1] - e[3]), t1[3] < e[1] && (i = e[1] - t1[3]), r.distance([
                0,
                0
            ], [
                n,
                i
            ]);
        }
        function ln(t1) {
            return 360 * t1 - 180;
        }
        function un(t1) {
            return 360 / Math.PI * Math.atan(Math.exp((180 - 360 * t1) * Math.PI / 180)) - 90;
        }
        function cn(t1, e) {
            const r = Math.pow(2, e.z), n = (t1.y / Wr + e.y) / r;
            return [
                ln((t1.x / Wr + e.x) / r),
                un(n)
            ];
        }
        function hn(t1, e) {
            const r = [];
            for(let n = 0; n < t1.length; ++n)r.push(cn(t1[n], e));
            return r;
        }
        function pn(t1, e, r) {
            const n = r.pointOnLine(e, t1).point;
            return r.distance(t1, n);
        }
        function fn(t1, e, r, n, i) {
            const a = r.slice(n[0], n[1] + 1);
            let s = 1 / 0;
            for(let r = e[0]; r <= e[1]; ++r)if (0 === (s = Math.min(s, pn(t1[r], a, i)))) return 0;
            return s;
        }
        function dn(t1, e, r, n, i) {
            const a = Math.min(i.pointToSegmentDistance(t1, r, n), i.pointToSegmentDistance(e, r, n)), s = Math.min(i.pointToSegmentDistance(r, t1, e), i.pointToSegmentDistance(n, t1, e));
            return Math.min(a, s);
        }
        function mn(t1, e, r, n, i) {
            if (!rn(e, t1.length) || !rn(n, r.length)) return NaN;
            let a = 1 / 0;
            for(let s = e[0]; s < e[1]; ++s)for(let e = n[0]; e < n[1]; ++e){
                if (zr(t1[s], t1[s + 1], r[e], r[e + 1])) return 0;
                a = Math.min(a, dn(t1[s], t1[s + 1], r[e], r[e + 1], i));
            }
            return a;
        }
        function yn(t1, e, r, n, i) {
            if (!rn(e, t1.length) || !rn(n, r.length)) return NaN;
            let a = 1 / 0;
            for(let s = e[0]; s <= e[1]; ++s)for(let e = n[0]; e <= n[1]; ++e)if (0 === (a = Math.min(a, i.distance(t1[s], r[e])))) return a;
            return a;
        }
        function gn(t1, e, r) {
            if (Ir(t1, e, !0)) return 0;
            let n = 1 / 0;
            for (const i of e){
                const e = i.length;
                if (e < 2) return console.warn("Distance Expression: Invalid polygon!"), NaN;
                if (i[0] !== i[e - 1] && 0 === (n = Math.min(n, r.pointToSegmentDistance(t1, i[e - 1], i[0])))) return n;
                if (0 === (n = Math.min(n, pn(t1, i, r)))) return n;
            }
            return n;
        }
        function xn(t1, e, r, n) {
            if (!rn(e, t1.length)) return NaN;
            for(let n = e[0]; n <= e[1]; ++n)if (Ir(t1[n], r, !0)) return 0;
            let i = 1 / 0;
            for(let a = e[0]; a < e[1]; ++a)for (const e of r)for(let r = 0, s = e.length, o = s - 1; r < s; o = r++){
                if (zr(t1[a], t1[a + 1], e[o], e[r])) return 0;
                i = Math.min(i, dn(t1[a], t1[a + 1], e[o], e[r], n));
            }
            return i;
        }
        function vn(t1, e) {
            for (const r of t1)for(let t1 = 0; t1 <= r.length - 1; ++t1)if (Ir(r[t1], e, !0)) return !0;
            return !1;
        }
        function bn(t1, e, r, n = 1 / 0) {
            const i = sn(t1), a = sn(e);
            if (n !== 1 / 0 && on(i, a, r) >= n) return n;
            if (Ar(i, a)) {
                if (vn(t1, e)) return 0;
            } else if (vn(e, t1)) return 0;
            let s = n;
            for (const n of t1)for(let t1 = 0, i = n.length, a = i - 1; t1 < i; a = t1++)for (const i of e)for(let e = 0, o = i.length, l = o - 1; e < o; l = e++){
                if (zr(n[a], n[t1], i[l], i[e])) return 0;
                s = Math.min(s, dn(n[a], n[t1], i[l], i[e], r));
            }
            return s;
        }
        function _n(t1, e, r, n, i, a, s) {
            if (null === a || null === s) return;
            const o = on(an(n, a), an(i, s), r);
            o < e && t1.push({
                dist: o,
                range1: a,
                range2: s
            });
        }
        function wn(t1, e, r, n, i = 1 / 0) {
            let a = Math.min(n.distance(t1[0], r[0][0]), i);
            if (0 === a) return a;
            const s = new Hr([
                {
                    dist: 0,
                    range1: [
                        0,
                        t1.length - 1
                    ],
                    range2: [
                        0,
                        0
                    ]
                }
            ], Kr), o = e ? Qr : Jr, l = sn(r);
            for(; s.length;){
                const i = s.pop();
                if (i.dist >= a) continue;
                const u = i.range1;
                if (en(u) <= o) {
                    if (!rn(u, t1.length)) return NaN;
                    if (e) {
                        const e = xn(t1, u, r, n);
                        if (0 === (a = Math.min(a, e))) return a;
                    } else for(let e = u[0]; e <= u[1]; ++e){
                        const i = gn(t1[e], r, n);
                        if (0 === (a = Math.min(a, i))) return a;
                    }
                } else {
                    const r = nn(u, e);
                    if (null !== r[0]) {
                        const e = on(an(t1, r[0]), l, n);
                        e < a && s.push({
                            dist: e,
                            range1: r[0],
                            range2: [
                                0,
                                0
                            ]
                        });
                    }
                    if (null !== r[1]) {
                        const e = on(an(t1, r[1]), l, n);
                        e < a && s.push({
                            dist: e,
                            range1: r[1],
                            range2: [
                                0,
                                0
                            ]
                        });
                    }
                }
            }
            return a;
        }
        function Mn(t1, e, r, n, i, a = 1 / 0) {
            let s = Math.min(a, i.distance(t1[0], r[0]));
            if (0 === s) return s;
            const o = new Hr([
                {
                    dist: 0,
                    range1: [
                        0,
                        t1.length - 1
                    ],
                    range2: [
                        0,
                        r.length - 1
                    ]
                }
            ], Kr), l = e ? Qr : Jr, u = n ? Qr : Jr;
            for(; o.length;){
                const a = o.pop();
                if (a.dist >= s) continue;
                const c = a.range1, h = a.range2;
                if (en(c) <= l && en(h) <= u) {
                    if (!rn(c, t1.length) || !rn(h, r.length)) return NaN;
                    if (e && n ? s = Math.min(s, mn(t1, c, r, h, i)) : e || n ? e && !n ? s = Math.min(s, fn(r, h, t1, c, i)) : !e && n && (s = Math.min(s, fn(t1, c, r, h, i))) : s = Math.min(s, yn(t1, c, r, h, i)), 0 === s) return s;
                } else {
                    const a = nn(c, e), l = nn(h, n);
                    _n(o, s, i, t1, r, a[0], l[0]), _n(o, s, i, t1, r, a[0], l[1]), _n(o, s, i, t1, r, a[1], l[0]), _n(o, s, i, t1, r, a[1], l[1]);
                }
            }
            return s;
        }
        function An(t1, e, r, n, i = 1 / 0) {
            let a = i;
            const s = an(t1, [
                0,
                t1.length - 1
            ]);
            for (const i of r)if (!(a !== 1 / 0 && on(s, an(i, [
                0,
                i.length - 1
            ]), n) >= a) && (a = Math.min(a, Mn(t1, e, i, !0, n, a)), 0 === a)) return a;
            return a;
        }
        function Sn(t1, e, r, n, i = 1 / 0) {
            let a = i;
            const s = an(t1, [
                0,
                t1.length - 1
            ]);
            for (const i of r){
                if (a !== 1 / 0 && on(s, sn(i), n) >= a) continue;
                const r = wn(t1, e, i, n, a);
                if (isNaN(r)) return r;
                if (0 === (a = Math.min(a, r))) return a;
            }
            return a;
        }
        function In(t1) {
            return "Point" === t1 || "MultiPoint" === t1 || "LineString" === t1 || "MultiLineString" === t1 || "Polygon" === t1 || "MultiPolygon" === t1;
        }
        class Pn {
            static parse(t1, e) {
                if (2 !== t1.length) return e.error(`'distance' expression requires either one argument, but found ' ${t1.length - 1} instead.`);
                if (rr(t1[1])) {
                    const e = t1[1];
                    if ("FeatureCollection" === e.type) {
                        for(let t1 = 0; t1 < e.features.length; ++t1)if (In(e.features[t1].geometry.type)) return new Pn(e, e.features[t1].geometry);
                    } else if ("Feature" === e.type) {
                        if (In(e.geometry.type)) return new Pn(e, e.geometry);
                    } else if (In(e.type)) return new Pn(e, e);
                }
                return e.error("'distance' expression needs to be an array with format ['Distance', GeoJSONObj].");
            }
            evaluate(t1) {
                const e = t1.geometry(), r = t1.canonicalID();
                if (null != e && null != r) {
                    if ("Point" === t1.geometryType()) return function(t1, e, r) {
                        const n = [];
                        for (const r of t1)for (const t1 of r)n.push(cn(t1, e));
                        const i = new Gr(n[0][1], "meters");
                        return "Point" === r.type || "MultiPoint" === r.type || "LineString" === r.type ? Mn(n, !1, "Point" === r.type ? [
                            r.coordinates
                        ] : r.coordinates, "LineString" === r.type, i) : "MultiLineString" === r.type ? An(n, !1, r.coordinates, i) : "Polygon" === r.type || "MultiPolygon" === r.type ? Sn(n, !1, "Polygon" === r.type ? [
                            r.coordinates
                        ] : r.coordinates, i) : null;
                    }(e, r, this.geometries);
                    if ("LineString" === t1.geometryType()) return function(t1, e, r) {
                        const n = [];
                        for (const r of t1){
                            const t1 = [];
                            for (const n of r)t1.push(cn(n, e));
                            n.push(t1);
                        }
                        const i = new Gr(n[0][0][1], "meters");
                        if ("Point" === r.type || "MultiPoint" === r.type || "LineString" === r.type) return An("Point" === r.type ? [
                            r.coordinates
                        ] : r.coordinates, "LineString" === r.type, n, i);
                        if ("MultiLineString" === r.type) {
                            let t1 = 1 / 0;
                            for(let e = 0; e < r.coordinates.length; e++){
                                const a = An(r.coordinates[e], !0, n, i, t1);
                                if (isNaN(a)) return a;
                                if (0 === (t1 = Math.min(t1, a))) return t1;
                            }
                            return t1;
                        }
                        if ("Polygon" === r.type || "MultiPolygon" === r.type) {
                            let t1 = 1 / 0;
                            for(let e = 0; e < n.length; e++){
                                const a = Sn(n[e], !0, "Polygon" === r.type ? [
                                    r.coordinates
                                ] : r.coordinates, i, t1);
                                if (isNaN(a)) return a;
                                if (0 === (t1 = Math.min(t1, a))) return t1;
                            }
                            return t1;
                        }
                        return null;
                    }(e, r, this.geometries);
                    if ("Polygon" === t1.geometryType()) return function(t1, e, r) {
                        const n = [];
                        for (const r of function(t1, e) {
                            const r = t1.length;
                            if (r <= 1) return [
                                t1
                            ];
                            const n = [];
                            let i, a;
                            for(let e = 0; e < r; e++){
                                const r = wr(t1[e]);
                                0 !== r && (t1[e].area = Math.abs(r), void 0 === a && (a = r < 0), a === r < 0 ? (i && n.push(i), i = [
                                    t1[e]
                                ]) : i.push(t1[e]));
                            }
                            return i && n.push(i), n;
                        }(t1)){
                            const t1 = [];
                            for(let n = 0; n < r.length; ++n)t1.push(hn(r[n], e));
                            n.push(t1);
                        }
                        const i = new Gr(n[0][0][0][1], "meters");
                        if ("Point" === r.type || "MultiPoint" === r.type || "LineString" === r.type) return Sn("Point" === r.type ? [
                            r.coordinates
                        ] : r.coordinates, "LineString" === r.type, n, i);
                        if ("MultiLineString" === r.type) {
                            let t1 = 1 / 0;
                            for(let e = 0; e < r.coordinates.length; e++){
                                const a = Sn(r.coordinates[e], !0, n, i, t1);
                                if (isNaN(a)) return a;
                                if (0 === (t1 = Math.min(t1, a))) return t1;
                            }
                            return t1;
                        }
                        return "Polygon" === r.type || "MultiPolygon" === r.type ? function(t1, e, r) {
                            let n = 1 / 0;
                            for (const i of t1)for (const t1 of e){
                                const e = bn(i, t1, r, n);
                                if (isNaN(e)) return e;
                                if (0 === (n = Math.min(n, e))) return n;
                            }
                            return n;
                        }("Polygon" === r.type ? [
                            r.coordinates
                        ] : r.coordinates, n, i) : null;
                    }(e, r, this.geometries);
                    console.warn("Distance Expression: currently only evaluates valid Point/LineString/Polygon geometries.");
                } else console.warn("Distance Expression: requirs valid feature and canonical information.");
                return null;
            }
            eachChild() {}
            outputDefined() {
                return !0;
            }
            serialize() {
                return [
                    "distance",
                    this.geojson
                ];
            }
            constructor(t1, e){
                this.type = De, this.geojson = t1, this.geometries = e;
            }
        }
        function zn(t1, e) {
            switch(t1){
                case "string":
                    return ir(e);
                case "number":
                    return +e;
                case "boolean":
                    return !!e;
                case "color":
                    return Ie.parse(e);
                case "formatted":
                    return Je.fromString(ir(e));
                case "resolvedImage":
                    return tr.build(ir(e));
            }
            return e;
        }
        function En(t1, e, r, n) {
            return void 0 !== n && (t1 = n * Math.round(t1 / n)), void 0 !== e && t1 < e && (t1 = e), void 0 !== r && t1 > r && (t1 = r), t1;
        }
        class kn {
            static parse(t1, e) {
                let r = e.expectedType;
                if (null == r && (r = Ne), t1.length < 2 || t1.length > 3) return e.error("Invalid number of arguments for 'config' expression.");
                const n = e.parse(t1[1], 1);
                if (!(n instanceof ar)) return e.error("Key name of 'config' expression must be a string literal.");
                if (t1.length >= 3) {
                    const i = e.parse(t1[2], 2);
                    return i instanceof ar ? new kn(r, ir(n.value), ir(i.value)) : e.error("Scope of 'config' expression must be a string literal.");
                }
                return new kn(r, ir(n.value));
            }
            evaluate(t1) {
                const e = [
                    this.key,
                    this.scope,
                    t1.scope
                ].filter(Boolean).join(""), r = t1.getConfig(e);
                if (!r) return null;
                const { type: n, value: i, values: a, minValue: s, maxValue: o, stepValue: l } = r, u = r.default.evaluate(t1);
                let c = u;
                if (i) {
                    const e = t1.scope;
                    t1.scope = (e || "").split("").slice(1).join(""), c = i.evaluate(t1), t1.scope = e;
                }
                return n && (c = zn(n, c)), void 0 === c || void 0 === s && void 0 === o && void 0 === l || ("number" == typeof c ? c = En(c, s, o, l) : Array.isArray(c) && (c = c.map((t1)=>"number" == typeof t1 ? En(t1, s, o, l) : t1))), void 0 !== i && void 0 !== c && a && !a.includes(c) && (c = u, n && (c = zn(n, c))), (n && n !== this.type || void 0 !== c && nr(c) !== this.type) && (c = zn(this.type.kind, c)), c;
            }
            eachChild() {}
            outputDefined() {
                return !1;
            }
            serialize() {
                const t1 = [
                    "config",
                    this.key
                ];
                return this.scope && t1.concat(this.key), t1;
            }
            constructor(t1, e, r){
                this.type = t1, this.key = e, this.scope = r;
            }
        }
        function Tn(t1) {
            if (t1 instanceof yr) {
                if ("get" === t1.name && 1 === t1.args.length) return !1;
                if ("feature-state" === t1.name) return !1;
                if ("has" === t1.name && 1 === t1.args.length) return !1;
                if ("properties" === t1.name || "geometry-type" === t1.name || "id" === t1.name) return !1;
                if (/^filter-/.test(t1.name)) return !1;
            }
            if (t1 instanceof Nr) return !1;
            if (t1 instanceof Pn) return !1;
            let e = !0;
            return t1.eachChild((t1)=>{
                e && !Tn(t1) && (e = !1);
            }), e;
        }
        function Bn(t1) {
            if (t1 instanceof yr && "feature-state" === t1.name) return !1;
            let e = !0;
            return t1.eachChild((t1)=>{
                e && !Bn(t1) && (e = !1);
            }), e;
        }
        function Cn(t1) {
            if (t1 instanceof kn) return new Set([
                t1.key
            ]);
            let e = new Set;
            return t1.eachChild((t1)=>{
                e = new Set([
                    ...e,
                    ...Cn(t1)
                ]);
            }), e;
        }
        function Vn(t1, e) {
            if (t1 instanceof yr && e.indexOf(t1.name) >= 0) return !1;
            let r = !0;
            return t1.eachChild((t1)=>{
                r && !Vn(t1, e) && (r = !1);
            }), r;
        }
        class Dn {
            static parse(t1, e) {
                if (2 !== t1.length || "string" != typeof t1[1]) return e.error("'var' expression requires exactly one string literal argument.");
                const r = t1[1];
                return e.scope.has(r) ? new Dn(r, e.scope.get(r)) : e.error(`Unknown variable "${r}". Make sure "${r}" has been bound in an enclosing "let" expression before using it.`, 1);
            }
            evaluate(t1) {
                return this.boundExpression.evaluate(t1);
            }
            eachChild() {}
            outputDefined() {
                return !1;
            }
            serialize() {
                return [
                    "var",
                    this.name
                ];
            }
            constructor(t1, e){
                this.type = e.type, this.name = t1, this.boundExpression = e;
            }
        }
        class Ln {
            parse(t1, e, r, n, i = {}) {
                return e || r ? this.concat(e, null, r, n)._parse(t1, i) : this._parse(t1, i);
            }
            parseObjectValue(t1, e, r, n, i, a = {}) {
                return this.concat(e, r, n, i)._parse(t1, a);
            }
            _parse(t1, e) {
                function r(t1, e, r) {
                    return "assert" === r ? new lr(e, [
                        t1
                    ]) : "coerce" === r ? new fr(e, [
                        t1
                    ]) : t1;
                }
                if (null !== t1 && "string" != typeof t1 && "boolean" != typeof t1 && "number" != typeof t1 || (t1 = [
                    "literal",
                    t1
                ]), Array.isArray(t1)) {
                    if (0 === t1.length) return this.error('Expected an array with at least one element. If you wanted a literal array, use ["literal", []].');
                    const n = "string" == typeof t1[0] ? this.registry[t1[0]] : void 0;
                    if (n) {
                        let i = n.parse(t1, this);
                        if (!i) return null;
                        if (this.expectedType) {
                            const t1 = this.expectedType, n = i.type;
                            if ("string" !== t1.kind && "number" !== t1.kind && "boolean" !== t1.kind && "object" !== t1.kind && "array" !== t1.kind || "value" !== n.kind) {
                                if ("color" !== t1.kind && "formatted" !== t1.kind && "resolvedImage" !== t1.kind || "value" !== n.kind && "string" !== n.kind) {
                                    if (this.checkSubtype(t1, n)) return null;
                                } else i = r(i, t1, e.typeAnnotation || "coerce");
                            } else i = r(i, t1, e.typeAnnotation || "assert");
                        }
                        if (!(i instanceof ar) && "resolvedImage" !== i.type.kind && Fn(i)) {
                            const t1 = new mr(this._scope, this.options);
                            try {
                                i = new ar(i.type, i.evaluate(t1));
                            } catch (t1) {
                                return this.error(t1.message), null;
                            }
                        }
                        return i;
                    }
                    return fr.parse([
                        "to-array",
                        t1
                    ], this);
                }
                return this.error(void 0 === t1 ? "'undefined' value invalid. Use null instead." : "object" == typeof t1 ? 'Bare objects invalid. Use ["literal", {...}] instead.' : `Expected an array, but found ${typeof t1} instead.`);
            }
            concat(t1, e, r, n) {
                let i = "number" == typeof t1 ? this.path.concat(t1) : this.path;
                i = "string" == typeof e ? i.concat(e) : i;
                const a = n ? this.scope.concat(n) : this.scope;
                return new Ln(this.registry, i, r || null, a, this.errors, this._scope, this.options);
            }
            error(t1, ...e) {
                const r = `${this.key}${e.map((t1)=>`[${t1}]`).join("")}`;
                this.errors.push(new Be(r, t1));
            }
            checkSubtype(t1, e) {
                const r = Xe(t1, e);
                return r && this.error(r), r;
            }
            constructor(t1, e = [], r, n = new Ce, i = [], a, s){
                this.registry = t1, this.path = e, this.key = e.map((t1)=>"string" == typeof t1 ? `['${t1}']` : `[${t1}]`).join(""), this.scope = n, this.errors = i, this.expectedType = r, this._scope = a, this.options = s;
            }
        }
        var Rn = Ln;
        function Fn(t1) {
            if (t1 instanceof Dn) return Fn(t1.boundExpression);
            if (t1 instanceof yr && "error" === t1.name) return !1;
            if (t1 instanceof xr) return !1;
            if (t1 instanceof Nr) return !1;
            if (t1 instanceof Pn) return !1;
            if (t1 instanceof kn) return !1;
            const e = t1 instanceof fr || t1 instanceof lr;
            let r = !0;
            return t1.eachChild((t1)=>{
                r = e ? r && Fn(t1) : r && t1 instanceof ar;
            }), !!r && Tn(t1) && Vn(t1, [
                "zoom",
                "heatmap-density",
                "line-progress",
                "raster-value",
                "sky-radial-progress",
                "accumulated",
                "is-supported-script",
                "pitch",
                "distance-from-center",
                "measure-light",
                "raster-particle-speed"
            ]);
        }
        function On(t1, e) {
            const r = t1.length - 1;
            let n, i, a = 0, s = r, o = 0;
            for(; a <= s;)if (o = Math.floor((a + s) / 2), n = t1[o], i = t1[o + 1], n <= e) {
                if (o === r || e < i) return o;
                a = o + 1;
            } else {
                if (!(n > e)) throw new sr("Input is not a number.");
                s = o - 1;
            }
            return 0;
        }
        class Nn {
            static parse(t1, e) {
                if (t1.length - 1 < 4) return e.error(`Expected at least 4 arguments, but found only ${t1.length - 1}.`);
                if ((t1.length - 1) % 2 != 0) return e.error("Expected an even number of arguments.");
                const r = e.parse(t1[1], 1, De);
                if (!r) return null;
                const n = [];
                let i = null;
                e.expectedType && "value" !== e.expectedType.kind && (i = e.expectedType);
                for(let r = 1; r < t1.length; r += 2){
                    const a = 1 === r ? -1 / 0 : t1[r], s = t1[r + 1], o = r, l = r + 1;
                    if ("number" != typeof a) return e.error('Input/output pairs for "step" expressions must be defined using literal numeric values (not computed expressions) for the input values.', o);
                    if (n.length && n[n.length - 1][0] >= a) return e.error('Input/output pairs for "step" expressions must be arranged with input values in strictly ascending order.', o);
                    const u = e.parse(s, l, i);
                    if (!u) return null;
                    i = i || u.type, n.push([
                        a,
                        u
                    ]);
                }
                return new Nn(i, r, n);
            }
            evaluate(t1) {
                const e = this.labels, r = this.outputs;
                if (1 === e.length) return r[0].evaluate(t1);
                const n = this.input.evaluate(t1);
                if (n <= e[0]) return r[0].evaluate(t1);
                const i = e.length;
                return n >= e[i - 1] ? r[i - 1].evaluate(t1) : r[On(e, n)].evaluate(t1);
            }
            eachChild(t1) {
                t1(this.input);
                for (const e of this.outputs)t1(e);
            }
            outputDefined() {
                return this.outputs.every((t1)=>t1.outputDefined());
            }
            serialize() {
                const t1 = [
                    "step",
                    this.input.serialize()
                ];
                for(let e = 0; e < this.labels.length; e++)e > 0 && t1.push(this.labels[e]), t1.push(this.outputs[e].serialize());
                return t1;
            }
            constructor(t1, e, r){
                this.type = t1, this.input = e, this.labels = [], this.outputs = [];
                for (const [t1, e] of r)this.labels.push(t1), this.outputs.push(e);
            }
        }
        const Un = .95047, jn = 1.08883, qn = 4 / 29, $n = 6 / 29, Gn = 3 * $n * $n, Yn = $n * $n * $n, Xn = Math.PI / 180, Zn = 180 / Math.PI;
        function Hn(t1) {
            return t1 > Yn ? Math.pow(t1, 1 / 3) : t1 / Gn + qn;
        }
        function Wn(t1) {
            return t1 > $n ? t1 * t1 * t1 : Gn * (t1 - qn);
        }
        function Kn(t1) {
            return 255 * (t1 <= .0031308 ? 12.92 * t1 : 1.055 * Math.pow(t1, 1 / 2.4) - .055);
        }
        function Jn(t1) {
            return (t1 /= 255) <= .04045 ? t1 / 12.92 : Math.pow((t1 + .055) / 1.055, 2.4);
        }
        function Qn(t1) {
            const e = Jn(t1.r), r = Jn(t1.g), n = Jn(t1.b), i = Hn((.4124564 * e + .3575761 * r + .1804375 * n) / Un), a = Hn((.2126729 * e + .7151522 * r + .072175 * n) / 1);
            return {
                l: 116 * a - 16,
                a: 500 * (i - a),
                b: 200 * (a - Hn((.0193339 * e + .119192 * r + .9503041 * n) / jn)),
                alpha: t1.a
            };
        }
        function ti(t1) {
            let e = (t1.l + 16) / 116, r = isNaN(t1.a) ? e : e + t1.a / 500, n = isNaN(t1.b) ? e : e - t1.b / 200;
            return e = 1 * Wn(e), r = Un * Wn(r), n = jn * Wn(n), new Ie(Kn(3.2404542 * r - 1.5371385 * e - .4985314 * n), Kn(-0.969266 * r + 1.8760108 * e + .041556 * n), Kn(.0556434 * r - .2040259 * e + 1.0572252 * n), t1.alpha);
        }
        function ei(t1, e, r) {
            const n = e - t1;
            return t1 + r * (n > 180 || n < -180 ? n - 360 * Math.round(n / 360) : n);
        }
        const ri = {
            forward: Qn,
            reverse: ti,
            interpolate: function(t1, e, r) {
                return {
                    l: ze(t1.l, e.l, r),
                    a: ze(t1.a, e.a, r),
                    b: ze(t1.b, e.b, r),
                    alpha: ze(t1.alpha, e.alpha, r)
                };
            }
        }, ni = {
            forward: function(t1) {
                const { l: e, a: r, b: n } = Qn(t1), i = Math.atan2(n, r) * Zn;
                return {
                    h: i < 0 ? i + 360 : i,
                    c: Math.sqrt(r * r + n * n),
                    l: e,
                    alpha: t1.a
                };
            },
            reverse: function(t1) {
                const e = t1.h * Xn, r = t1.c;
                return ti({
                    l: t1.l,
                    a: Math.cos(e) * r,
                    b: Math.sin(e) * r,
                    alpha: t1.alpha
                });
            },
            interpolate: function(t1, e, r) {
                return {
                    h: ei(t1.h, e.h, r),
                    c: ze(t1.c, e.c, r),
                    l: ze(t1.l, e.l, r),
                    alpha: ze(t1.alpha, e.alpha, r)
                };
            }
        };
        var ii = Object.freeze({
            __proto__: null,
            hcl: ni,
            lab: ri
        });
        class ai {
            static interpolationFactor(t1, e, r, n) {
                let i = 0;
                if ("exponential" === t1.name) i = si(e, t1.base, r, n);
                else if ("linear" === t1.name) i = si(e, 1, r, n);
                else if ("cubic-bezier" === t1.name) {
                    const a = t1.controlPoints;
                    i = new U(a[0], a[1], a[2], a[3]).solve(si(e, 1, r, n));
                }
                return i;
            }
            static parse(t1, e) {
                let [r, n, i, ...a] = t1;
                if (!Array.isArray(n) || 0 === n.length) return e.error("Expected an interpolation type expression.", 1);
                if ("linear" === n[0]) n = {
                    name: "linear"
                };
                else if ("exponential" === n[0]) {
                    const t1 = n[1];
                    if ("number" != typeof t1) return e.error("Exponential interpolation requires a numeric base.", 1, 1);
                    n = {
                        name: "exponential",
                        base: t1
                    };
                } else {
                    if ("cubic-bezier" !== n[0]) return e.error(`Unknown interpolation type ${String(n[0])}`, 1, 0);
                    {
                        const t1 = n.slice(1);
                        if (4 !== t1.length || t1.some((t1)=>"number" != typeof t1 || t1 < 0 || t1 > 1)) return e.error("Cubic bezier interpolation requires four numeric arguments with values between 0 and 1.", 1);
                        n = {
                            name: "cubic-bezier",
                            controlPoints: t1
                        };
                    }
                }
                if (t1.length - 1 < 3) return e.error(`Expected at least 3 arguments, but found only ${t1.length - 1}.`);
                if (t1.length - 1 > 3 && (t1.length - 1) % 2 != 0) return e.error("Expected an even number of arguments.");
                if (i = e.parse(i, 2, De), !i) return null;
                const s = [];
                let o = null;
                if ("interpolate-hcl" === r || "interpolate-lab" === r ? o = Fe : e.expectedType && "value" !== e.expectedType.kind && (o = e.expectedType), t1.length - 1 == 3) {
                    const t1 = e.parse(a[0], 3, Ne);
                    return t1 ? new ai(o, r, n, i, t1, s) : null;
                }
                for(let t1 = 0; t1 < a.length; t1 += 2){
                    const r = a[t1], n = a[t1 + 1], i = t1 + 3, l = t1 + 4;
                    if ("number" != typeof r) return e.error('Input/output pairs for "interpolate" expressions must be defined using literal numeric values (not computed expressions) for the input values.', i);
                    if (s.length && s[s.length - 1][0] >= r) return e.error('Input/output pairs for "interpolate" expressions must be arranged with input values in strictly ascending order.', i);
                    const u = e.parse(n, l, o);
                    if (!u) return null;
                    o = o || u.type, s.push([
                        r,
                        u
                    ]);
                }
                return "number" === o.kind || "color" === o.kind || "array" === o.kind && "number" === o.itemType.kind && "number" == typeof o.N ? new ai(o, r, n, i, null, s) : e.error(`Type ${Ge(o)} is not interpolatable.`);
            }
            evaluate(t1) {
                let e = this.labels, r = this.outputs;
                if (this.dynamicStops) {
                    const n = this.dynamicStops.evaluate(t1);
                    if (n.length % 2 != 0) throw new sr("Expected an even number of arguments.");
                    e = [], r = [];
                    for(let t1 = 0; t1 < n.length; t1 += 2){
                        const i = n[t1], a = new ar(De, n[t1 + 1]);
                        if ("number" != typeof i) throw new sr('Input/output pairs for "interpolate" expressions must be defined using literal numeric values (not computed expressions) for the input values.');
                        if (e.length && e[e.length - 1] >= i) throw new sr('Input/output pairs for "interpolate" expressions must be arranged with input values in strictly ascending order.');
                        e.push(i), r.push(a);
                    }
                    if (0 === e.length) throw new sr("Expected at least one input/output pair.");
                }
                if (1 === e.length) return r[0].evaluate(t1);
                const n = this.input.evaluate(t1);
                if (n <= e[0]) return r[0].evaluate(t1);
                const i = e.length;
                if (n >= e[i - 1]) return r[i - 1].evaluate(t1);
                const a = On(e, n), s = ai.interpolationFactor(this.interpolation, n, e[a], e[a + 1]), o = r[a].evaluate(t1), l = r[a + 1].evaluate(t1);
                return "interpolate" === this.operator ? ke[this.type.kind.toLowerCase()](o, l, s) : "interpolate-hcl" === this.operator ? ni.reverse(ni.interpolate(ni.forward(o), ni.forward(l), s)) : ri.reverse(ri.interpolate(ri.forward(o), ri.forward(l), s));
            }
            eachChild(t1) {
                t1(this.input);
                for (const e of this.outputs)t1(e);
            }
            outputDefined() {
                return this.outputs.every((t1)=>t1.outputDefined());
            }
            serialize() {
                let t1;
                t1 = "linear" === this.interpolation.name ? [
                    "linear"
                ] : "exponential" === this.interpolation.name ? 1 === this.interpolation.base ? [
                    "linear"
                ] : [
                    "exponential",
                    this.interpolation.base
                ] : [
                    "cubic-bezier"
                ].concat(this.interpolation.controlPoints);
                const e = [
                    this.operator,
                    t1,
                    this.input.serialize()
                ];
                if (this.dynamicStops) e.push(this.dynamicStops.serialize());
                else for(let t1 = 0; t1 < this.labels.length; t1++)e.push(this.labels[t1], this.outputs[t1].serialize());
                return e;
            }
            constructor(t1, e, r, n, i, a){
                this.type = t1, this.operator = e, this.interpolation = r, this.input = n, this.dynamicStops = i, this.labels = [], this.outputs = [];
                for (const [t1, e] of a)this.labels.push(t1), this.outputs.push(e);
            }
        }
        function si(t1, e, r, n) {
            const i = n - r, a = t1 - r;
            return 0 === i ? 0 : 1 === e ? a / i : (Math.pow(e, a) - 1) / (Math.pow(e, i) - 1);
        }
        class oi {
            static parse(t1, e) {
                if (t1.length < 2) return e.error("Expectected at least one argument.");
                let r = null;
                const n = e.expectedType;
                n && "value" !== n.kind && (r = n);
                const i = [];
                for (const n of t1.slice(1)){
                    const t1 = e.parse(n, 1 + i.length, r, void 0, {
                        typeAnnotation: "omit"
                    });
                    if (!t1) return null;
                    r = r || t1.type, i.push(t1);
                }
                const a = n && i.some((t1)=>Xe(n, t1.type));
                return new oi(a ? Ne : r, i);
            }
            evaluate(t1) {
                let e, r = null, n = 0;
                for (const i of this.args){
                    if (n++, r = i.evaluate(t1), r && r instanceof tr && !r.available && (e || (e = r), r = null, n === this.args.length)) return e;
                    if (null !== r) break;
                }
                return r;
            }
            eachChild(t1) {
                this.args.forEach(t1);
            }
            outputDefined() {
                return this.args.every((t1)=>t1.outputDefined());
            }
            serialize() {
                const t1 = [
                    "coalesce"
                ];
                return this.eachChild((e)=>{
                    t1.push(e.serialize());
                }), t1;
            }
            constructor(t1, e){
                this.type = t1, this.args = e;
            }
        }
        class li {
            evaluate(t1) {
                return this.result.evaluate(t1);
            }
            eachChild(t1) {
                for (const e of this.bindings)t1(e[1]);
                t1(this.result);
            }
            static parse(t1, e) {
                if (t1.length < 4) return e.error(`Expected at least 3 arguments, but found ${t1.length - 1} instead.`);
                const r = [];
                for(let n = 1; n < t1.length - 1; n += 2){
                    const i = t1[n];
                    if ("string" != typeof i) return e.error(`Expected string, but found ${typeof i} instead.`, n);
                    if (/[^a-zA-Z0-9_]/.test(i)) return e.error("Variable names must contain only alphanumeric characters or '_'.", n);
                    const a = e.parse(t1[n + 1], n + 1);
                    if (!a) return null;
                    r.push([
                        i,
                        a
                    ]);
                }
                const n = e.parse(t1[t1.length - 1], t1.length - 1, e.expectedType, r);
                return n ? new li(r, n) : null;
            }
            outputDefined() {
                return this.result.outputDefined();
            }
            serialize() {
                const t1 = [
                    "let"
                ];
                for (const [e, r] of this.bindings)t1.push(e, r.serialize());
                return t1.push(this.result.serialize()), t1;
            }
            constructor(t1, e){
                this.type = e.type, this.bindings = [].concat(t1), this.result = e;
            }
        }
        class ui {
            static parse(t1, e) {
                if (3 !== t1.length) return e.error(`Expected 2 arguments, but found ${t1.length - 1} instead.`);
                const r = e.parse(t1[1], 1, De), n = e.parse(t1[2], 2, $e(e.expectedType || Ne));
                return r && n ? new ui(n.type.itemType, r, n) : null;
            }
            evaluate(t1) {
                const e = this.index.evaluate(t1), r = this.input.evaluate(t1);
                if (e < 0) throw new sr(`Array index out of bounds: ${e} < 0.`);
                if (e > r.length - 1) throw new sr(`Array index out of bounds: ${e} > ${r.length - 1}.`);
                if (e === Math.floor(e)) return r[e];
                const n = Math.floor(e), i = Math.ceil(e), a = r[n], s = r[i];
                if ("number" != typeof a || "number" != typeof s) throw new sr(`Cannot interpolate between non-number values at index ${e}.`);
                const o = e - n;
                return a * (1 - o) + s * o;
            }
            eachChild(t1) {
                t1(this.index), t1(this.input);
            }
            outputDefined() {
                return !1;
            }
            serialize() {
                return [
                    "at",
                    this.index.serialize(),
                    this.input.serialize()
                ];
            }
            constructor(t1, e, r){
                this.type = t1, this.index = e, this.input = r;
            }
        }
        class ci {
            static parse(t1, e) {
                if (3 !== t1.length) return e.error(`Expected 2 arguments, but found ${t1.length - 1} instead.`);
                const r = e.parse(t1[1], 1, Ne), n = e.parse(t1[2], 2, Ne);
                return r && n ? Ze(r.type, [
                    Re,
                    Le,
                    De,
                    Ve,
                    Ne
                ]) ? new ci(r, n) : e.error(`Expected first argument to be of type boolean, string, number or null, but found ${Ge(r.type)} instead`) : null;
            }
            evaluate(t1) {
                const e = this.needle.evaluate(t1), r = this.haystack.evaluate(t1);
                if (null == r) return !1;
                if (!He(e, [
                    "boolean",
                    "string",
                    "number",
                    "null"
                ])) throw new sr(`Expected first argument to be of type boolean, string, number or null, but found ${Ge(nr(e))} instead.`);
                if (!He(r, [
                    "string",
                    "array"
                ])) throw new sr(`Expected second argument to be of type array or string, but found ${Ge(nr(r))} instead.`);
                return r.indexOf(e) >= 0;
            }
            eachChild(t1) {
                t1(this.needle), t1(this.haystack);
            }
            outputDefined() {
                return !0;
            }
            serialize() {
                return [
                    "in",
                    this.needle.serialize(),
                    this.haystack.serialize()
                ];
            }
            constructor(t1, e){
                this.type = Re, this.needle = t1, this.haystack = e;
            }
        }
        class hi {
            static parse(t1, e) {
                if (t1.length <= 2 || t1.length >= 5) return e.error(`Expected 3 or 4 arguments, but found ${t1.length - 1} instead.`);
                const r = e.parse(t1[1], 1, Ne), n = e.parse(t1[2], 2, Ne);
                if (!r || !n) return null;
                if (!Ze(r.type, [
                    Re,
                    Le,
                    De,
                    Ve,
                    Ne
                ])) return e.error(`Expected first argument to be of type boolean, string, number or null, but found ${Ge(r.type)} instead`);
                if (4 === t1.length) {
                    const i = e.parse(t1[3], 3, De);
                    return i ? new hi(r, n, i) : null;
                }
                return new hi(r, n);
            }
            evaluate(t1) {
                const e = this.needle.evaluate(t1), r = this.haystack.evaluate(t1);
                if (!He(e, [
                    "boolean",
                    "string",
                    "number",
                    "null"
                ])) throw new sr(`Expected first argument to be of type boolean, string, number or null, but found ${Ge(nr(e))} instead.`);
                if (!He(r, [
                    "string",
                    "array"
                ])) throw new sr(`Expected second argument to be of type array or string, but found ${Ge(nr(r))} instead.`);
                if (this.fromIndex) {
                    const n = this.fromIndex.evaluate(t1);
                    return r.indexOf(e, n);
                }
                return r.indexOf(e);
            }
            eachChild(t1) {
                t1(this.needle), t1(this.haystack), this.fromIndex && t1(this.fromIndex);
            }
            outputDefined() {
                return !1;
            }
            serialize() {
                if (null != this.fromIndex && void 0 !== this.fromIndex) {
                    const t1 = this.fromIndex.serialize();
                    return [
                        "index-of",
                        this.needle.serialize(),
                        this.haystack.serialize(),
                        t1
                    ];
                }
                return [
                    "index-of",
                    this.needle.serialize(),
                    this.haystack.serialize()
                ];
            }
            constructor(t1, e, r){
                this.type = De, this.needle = t1, this.haystack = e, this.fromIndex = r;
            }
        }
        class pi {
            static parse(t1, e) {
                if (t1.length < 5) return e.error(`Expected at least 4 arguments, but found only ${t1.length - 1}.`);
                if (t1.length % 2 != 1) return e.error("Expected an even number of arguments.");
                let r, n;
                e.expectedType && "value" !== e.expectedType.kind && (n = e.expectedType);
                const i = {}, a = [];
                for(let s = 2; s < t1.length - 1; s += 2){
                    let o = t1[s];
                    const l = t1[s + 1];
                    Array.isArray(o) || (o = [
                        o
                    ]);
                    const u = e.concat(s);
                    if (0 === o.length) return u.error("Expected at least one branch label.");
                    for (const t1 of o){
                        if ("number" != typeof t1 && "string" != typeof t1) return u.error("Branch labels must be numbers or strings.");
                        if ("number" == typeof t1 && Math.abs(t1) > Number.MAX_SAFE_INTEGER) return u.error(`Branch labels must be integers no larger than ${Number.MAX_SAFE_INTEGER}.`);
                        if ("number" == typeof t1 && Math.floor(t1) !== t1) return u.error("Numeric branch labels must be integer values.");
                        if (r) {
                            if (u.checkSubtype(r, nr(t1))) return null;
                        } else r = nr(t1);
                        if (void 0 !== i[String(t1)]) return u.error("Branch labels must be unique.");
                        i[String(t1)] = a.length;
                    }
                    const c = e.parse(l, s, n);
                    if (!c) return null;
                    n = n || c.type, a.push(c);
                }
                const s = e.parse(t1[1], 1, Ne);
                if (!s) return null;
                const o = e.parse(t1[t1.length - 1], t1.length - 1, n);
                return o ? "value" !== s.type.kind && e.concat(1).checkSubtype(r, s.type) ? null : new pi(r, n, s, i, a, o) : null;
            }
            evaluate(t1) {
                const e = this.input.evaluate(t1);
                return (nr(e) === this.inputType && this.outputs[this.cases[e]] || this.otherwise).evaluate(t1);
            }
            eachChild(t1) {
                t1(this.input), this.outputs.forEach(t1), t1(this.otherwise);
            }
            outputDefined() {
                return this.outputs.every((t1)=>t1.outputDefined()) && this.otherwise.outputDefined();
            }
            serialize() {
                const t1 = [
                    "match",
                    this.input.serialize()
                ], e = Object.keys(this.cases).sort(), r = [], n = {};
                for (const t1 of e){
                    const e = n[this.cases[t1]];
                    void 0 === e ? (n[this.cases[t1]] = r.length, r.push([
                        this.cases[t1],
                        [
                            t1
                        ]
                    ])) : r[e][1].push(t1);
                }
                const i = (t1)=>"number" === this.inputType.kind ? Number(t1) : t1;
                for (const [e, n] of r)t1.push(1 === n.length ? i(n[0]) : n.map(i)), t1.push(this.outputs[e].serialize());
                return t1.push(this.otherwise.serialize()), t1;
            }
            constructor(t1, e, r, n, i, a){
                this.inputType = t1, this.type = e, this.input = r, this.cases = n, this.outputs = i, this.otherwise = a;
            }
        }
        class fi {
            static parse(t1, e) {
                if (t1.length < 4) return e.error(`Expected at least 3 arguments, but found only ${t1.length - 1}.`);
                if (t1.length % 2 != 0) return e.error("Expected an odd number of arguments.");
                let r;
                e.expectedType && "value" !== e.expectedType.kind && (r = e.expectedType);
                const n = [];
                for(let i = 1; i < t1.length - 1; i += 2){
                    const a = e.parse(t1[i], i, Re);
                    if (!a) return null;
                    const s = e.parse(t1[i + 1], i + 1, r);
                    if (!s) return null;
                    n.push([
                        a,
                        s
                    ]), r = r || s.type;
                }
                const i = e.parse(t1[t1.length - 1], t1.length - 1, r);
                return i ? new fi(r, n, i) : null;
            }
            evaluate(t1) {
                for (const [e, r] of this.branches)if (e.evaluate(t1)) return r.evaluate(t1);
                return this.otherwise.evaluate(t1);
            }
            eachChild(t1) {
                for (const [e, r] of this.branches)t1(e), t1(r);
                t1(this.otherwise);
            }
            outputDefined() {
                return this.branches.every(([t1, e])=>e.outputDefined()) && this.otherwise.outputDefined();
            }
            serialize() {
                const t1 = [
                    "case"
                ];
                return this.eachChild((e)=>{
                    t1.push(e.serialize());
                }), t1;
            }
            constructor(t1, e, r){
                this.type = t1, this.branches = e, this.otherwise = r;
            }
        }
        class di {
            static parse(t1, e) {
                if (t1.length <= 2 || t1.length >= 5) return e.error(`Expected 3 or 4 arguments, but found ${t1.length - 1} instead.`);
                const r = e.parse(t1[1], 1, Ne), n = e.parse(t1[2], 2, De);
                if (!r || !n) return null;
                if (!Ze(r.type, [
                    $e(Ne),
                    Le,
                    Ne
                ])) return e.error(`Expected first argument to be of type array or string, but found ${Ge(r.type)} instead`);
                if (4 === t1.length) {
                    const i = e.parse(t1[3], 3, De);
                    return i ? new di(r.type, r, n, i) : null;
                }
                return new di(r.type, r, n);
            }
            evaluate(t1) {
                const e = this.input.evaluate(t1), r = this.beginIndex.evaluate(t1);
                if (!He(e, [
                    "string",
                    "array"
                ])) throw new sr(`Expected first argument to be of type array or string, but found ${Ge(nr(e))} instead.`);
                if (this.endIndex) {
                    const n = this.endIndex.evaluate(t1);
                    return e.slice(r, n);
                }
                return e.slice(r);
            }
            eachChild(t1) {
                t1(this.input), t1(this.beginIndex), this.endIndex && t1(this.endIndex);
            }
            outputDefined() {
                return !1;
            }
            serialize() {
                if (null != this.endIndex && void 0 !== this.endIndex) {
                    const t1 = this.endIndex.serialize();
                    return [
                        "slice",
                        this.input.serialize(),
                        this.beginIndex.serialize(),
                        t1
                    ];
                }
                return [
                    "slice",
                    this.input.serialize(),
                    this.beginIndex.serialize()
                ];
            }
            constructor(t1, e, r, n){
                this.type = t1, this.input = e, this.beginIndex = r, this.endIndex = n;
            }
        }
        function mi(t1, e) {
            return "==" === t1 || "!=" === t1 ? "boolean" === e.kind || "string" === e.kind || "number" === e.kind || "null" === e.kind || "value" === e.kind : "string" === e.kind || "number" === e.kind || "value" === e.kind;
        }
        function yi(t1, e, r, n) {
            return 0 === n.compare(e, r);
        }
        function gi(t1, e, r) {
            const n = "==" !== t1 && "!=" !== t1;
            return class i {
                static parse(t1, e) {
                    if (3 !== t1.length && 4 !== t1.length) return e.error("Expected two or three arguments.");
                    const r = t1[0];
                    let a = e.parse(t1[1], 1, Ne);
                    if (!a) return null;
                    if (!mi(r, a.type)) return e.concat(1).error(`"${r}" comparisons are not supported for type '${Ge(a.type)}'.`);
                    let s = e.parse(t1[2], 2, Ne);
                    if (!s) return null;
                    if (!mi(r, s.type)) return e.concat(2).error(`"${r}" comparisons are not supported for type '${Ge(s.type)}'.`);
                    if (a.type.kind !== s.type.kind && "value" !== a.type.kind && "value" !== s.type.kind) return e.error(`Cannot compare types '${Ge(a.type)}' and '${Ge(s.type)}'.`);
                    n && ("value" === a.type.kind && "value" !== s.type.kind ? a = new lr(s.type, [
                        a
                    ]) : "value" !== a.type.kind && "value" === s.type.kind && (s = new lr(a.type, [
                        s
                    ])));
                    let o = null;
                    if (4 === t1.length) {
                        if ("string" !== a.type.kind && "string" !== s.type.kind && "value" !== a.type.kind && "value" !== s.type.kind) return e.error("Cannot use collator to compare non-string types.");
                        if (o = e.parse(t1[3], 3, Ue), !o) return null;
                    }
                    return new i(a, s, o);
                }
                evaluate(i) {
                    const a = this.lhs.evaluate(i), s = this.rhs.evaluate(i);
                    if (n && this.hasUntypedArgument) {
                        const e = nr(a), r = nr(s);
                        if (e.kind !== r.kind || "string" !== e.kind && "number" !== e.kind) throw new sr(`Expected arguments for "${t1}" to be (string, string) or (number, number), but found (${e.kind}, ${r.kind}) instead.`);
                    }
                    if (this.collator && !n && this.hasUntypedArgument) {
                        const t1 = nr(a), r = nr(s);
                        if ("string" !== t1.kind || "string" !== r.kind) return e(i, a, s);
                    }
                    return this.collator ? r(i, a, s, this.collator.evaluate(i)) : e(i, a, s);
                }
                eachChild(t1) {
                    t1(this.lhs), t1(this.rhs), this.collator && t1(this.collator);
                }
                outputDefined() {
                    return !0;
                }
                serialize() {
                    const e = [
                        t1
                    ];
                    return this.eachChild((t1)=>{
                        e.push(t1.serialize());
                    }), e;
                }
                constructor(t1, e, r){
                    this.type = Re, this.lhs = t1, this.rhs = e, this.collator = r, this.hasUntypedArgument = "value" === t1.type.kind || "value" === e.type.kind;
                }
            };
        }
        const xi = gi("==", function(t1, e, r) {
            return e === r;
        }, yi), vi = gi("!=", function(t1, e, r) {
            return e !== r;
        }, function(t1, e, r, n) {
            return !yi(0, e, r, n);
        }), bi = gi("<", function(t1, e, r) {
            return e < r;
        }, function(t1, e, r, n) {
            return n.compare(e, r) < 0;
        }), _i = gi(">", function(t1, e, r) {
            return e > r;
        }, function(t1, e, r, n) {
            return n.compare(e, r) > 0;
        }), wi = gi("<=", function(t1, e, r) {
            return e <= r;
        }, function(t1, e, r, n) {
            return n.compare(e, r) <= 0;
        }), Mi = gi(">=", function(t1, e, r) {
            return e >= r;
        }, function(t1, e, r, n) {
            return n.compare(e, r) >= 0;
        });
        class Ai {
            static parse(t1, e) {
                if (3 !== t1.length) return e.error("Expected two arguments.");
                const r = e.parse(t1[1], 1, De);
                if (!r) return null;
                const n = t1[2];
                if ("object" != typeof n || Array.isArray(n)) return e.error("NumberFormat options argument must be an object.");
                let i = null;
                if (n.locale && (i = e.parseObjectValue(n.locale, 2, "locale", Le), !i)) return null;
                let a = null;
                if (n.currency && (a = e.parseObjectValue(n.currency, 2, "currency", Le), !a)) return null;
                let s = null;
                if (n.unit && (s = e.parseObjectValue(n.unit, 2, "unit", Le), !s)) return null;
                let o = null;
                if (n["min-fraction-digits"] && (o = e.parseObjectValue(n["min-fraction-digits"], 2, "min-fraction-digits", De), !o)) return null;
                let l = null;
                return n["max-fraction-digits"] && (l = e.parseObjectValue(n["max-fraction-digits"], 2, "max-fraction-digits", De), !l) ? null : new Ai(r, i, a, s, o, l);
            }
            evaluate(t1) {
                return new Intl.NumberFormat(this.locale ? this.locale.evaluate(t1) : [], {
                    style: (this.currency ? "currency" : this.unit && "unit") || "decimal",
                    currency: this.currency ? this.currency.evaluate(t1) : void 0,
                    unit: this.unit ? this.unit.evaluate(t1) : void 0,
                    minimumFractionDigits: this.minFractionDigits ? this.minFractionDigits.evaluate(t1) : void 0,
                    maximumFractionDigits: this.maxFractionDigits ? this.maxFractionDigits.evaluate(t1) : void 0
                }).format(this.number.evaluate(t1));
            }
            eachChild(t1) {
                t1(this.number), this.locale && t1(this.locale), this.currency && t1(this.currency), this.unit && t1(this.unit), this.minFractionDigits && t1(this.minFractionDigits), this.maxFractionDigits && t1(this.maxFractionDigits);
            }
            outputDefined() {
                return !1;
            }
            serialize() {
                const t1 = {};
                return this.locale && (t1.locale = this.locale.serialize()), this.currency && (t1.currency = this.currency.serialize()), this.unit && (t1.unit = this.unit.serialize()), this.minFractionDigits && (t1["min-fraction-digits"] = this.minFractionDigits.serialize()), this.maxFractionDigits && (t1["max-fraction-digits"] = this.maxFractionDigits.serialize()), [
                    "number-format",
                    this.number.serialize(),
                    t1
                ];
            }
            constructor(t1, e, r, n, i, a){
                this.type = Le, this.number = t1, this.locale = e, this.currency = r, this.unit = n, this.minFractionDigits = i, this.maxFractionDigits = a;
            }
        }
        class Si {
            static parse(t1, e) {
                if (2 !== t1.length) return e.error(`Expected 1 argument, but found ${t1.length - 1} instead.`);
                const r = e.parse(t1[1], 1);
                return r ? "array" !== r.type.kind && "string" !== r.type.kind && "value" !== r.type.kind ? e.error(`Expected argument of type string or array, but found ${Ge(r.type)} instead.`) : new Si(r) : null;
            }
            evaluate(t1) {
                const e = this.input.evaluate(t1);
                if ("string" == typeof e) return e.length;
                if (Array.isArray(e)) return e.length;
                throw new sr(`Expected value to be of type string or array, but found ${Ge(nr(e))} instead.`);
            }
            eachChild(t1) {
                t1(this.input);
            }
            outputDefined() {
                return !1;
            }
            serialize() {
                const t1 = [
                    "length"
                ];
                return this.eachChild((e)=>{
                    t1.push(e.serialize());
                }), t1;
            }
            constructor(t1){
                this.type = De, this.input = t1;
            }
        }
        function Ii(t1) {
            return function() {
                t1 = 1831565813 + (t1 |= 0) | 0;
                let e = Math.imul(t1 ^ t1 >>> 15, 1 | t1);
                return e = e + Math.imul(e ^ e >>> 7, 61 | e) ^ e, ((e ^ e >>> 14) >>> 0) / 4294967296;
            };
        }
        const Pi = {
            "==": xi,
            "!=": vi,
            ">": _i,
            "<": bi,
            ">=": Mi,
            "<=": wi,
            array: lr,
            at: ui,
            boolean: lr,
            case: fi,
            coalesce: oi,
            collator: xr,
            format: ur,
            image: cr,
            in: ci,
            "index-of": hi,
            interpolate: ai,
            "interpolate-hcl": ai,
            "interpolate-lab": ai,
            length: Si,
            let: li,
            literal: ar,
            match: pi,
            number: lr,
            "number-format": Ai,
            object: lr,
            slice: di,
            step: Nn,
            string: lr,
            "to-boolean": fr,
            "to-color": fr,
            "to-number": fr,
            "to-string": fr,
            var: Dn,
            within: Nr,
            distance: Pn,
            config: kn
        };
        function zi(t1, [e, r, n, i]) {
            e = e.evaluate(t1), r = r.evaluate(t1), n = n.evaluate(t1);
            const a = i ? i.evaluate(t1) : 1, s = er(e, r, n, a);
            if (s) throw new sr(s);
            return new Ie(e / 255 * a, r / 255 * a, n / 255 * a, a);
        }
        function Ei(t1, [e, r, n, i]) {
            e = e.evaluate(t1), r = r.evaluate(t1), n = n.evaluate(t1);
            const a = i ? i.evaluate(t1) : 1, s = function(t1, e, r, n) {
                return "number" == typeof t1 && t1 >= 0 && t1 <= 360 ? "number" == typeof e && e >= 0 && e <= 100 && "number" == typeof r && r >= 0 && r <= 100 ? void 0 === n || "number" == typeof n && n >= 0 && n <= 1 ? null : `Invalid hsla value [${[
                    t1,
                    e,
                    r,
                    n
                ].join(", ")}]: 'a' must be between 0 and 1.` : `Invalid hsla value [${("number" == typeof n ? [
                    t1,
                    e,
                    r,
                    n
                ] : [
                    t1,
                    e,
                    r
                ]).join(", ")}]: 's', and 'l' must be between 0 and 100.` : `Invalid hsla value [${("number" == typeof n ? [
                    t1,
                    e,
                    r,
                    n
                ] : [
                    t1,
                    e,
                    r
                ]).join(", ")}]: 'h' must be between 0 and 360.`;
            }(e, r, n, a);
            if (s) throw new sr(s);
            const o = `hsla(${e}, ${r}%, ${n}%, ${a})`, l = Ie.parse(o);
            if (!l) throw new sr(`Failed to parse HSLA color: ${o}`);
            return l;
        }
        function ki(t1, e) {
            return t1 in e;
        }
        function Ti(t1, e) {
            const r = e[t1];
            return void 0 === r ? null : r;
        }
        function Bi(t1) {
            return {
                type: t1
            };
        }
        function Ci(t1) {
            return {
                result: "success",
                value: t1
            };
        }
        function Vi(t1) {
            return {
                result: "error",
                value: t1
            };
        }
        function Di(t1, e) {
            return !!t1 && !!t1.parameters && t1.parameters.indexOf(e) > -1;
        }
        function Li(t1) {
            return "data-driven" === t1["property-type"];
        }
        function Ri(t1) {
            return Di(t1.expression, "measure-light");
        }
        function Fi(t1) {
            return Di(t1.expression, "zoom");
        }
        function Oi(t1) {
            return !!t1.expression && t1.expression.interpolated;
        }
        function Ni(t1) {
            return "object" == typeof t1 && null !== t1 && !Array.isArray(t1);
        }
        function Ui(t1) {
            return t1;
        }
        function ji(t1, e) {
            const r = "color" === e.type, n = t1.stops && "object" == typeof t1.stops[0][0], i = n || !(n || void 0 !== t1.property), a = t1.type || (Oi(e) ? "exponential" : "interval");
            if (r && ((t1 = Te({}, t1)).stops && (t1.stops = t1.stops.map((t1)=>[
                    t1[0],
                    Ie.parse(t1[1])
                ])), t1.default = Ie.parse(t1.default ? t1.default : e.default)), t1.colorSpace && "rgb" !== t1.colorSpace && !ii[t1.colorSpace]) throw new Error(`Unknown color space: ${t1.colorSpace}`);
            let s, o, l;
            if ("exponential" === a) s = Yi;
            else if ("interval" === a) s = Gi;
            else if ("categorical" === a) {
                s = $i, o = Object.create(null);
                for (const e of t1.stops)o[e[0]] = e[1];
                l = typeof t1.stops[0][0];
            } else {
                if ("identity" !== a) throw new Error(`Unknown function type "${a}"`);
                s = Xi;
            }
            if (n) {
                const r = {}, n = [];
                for(let e = 0; e < t1.stops.length; e++){
                    const i = t1.stops[e], a = i[0].zoom;
                    void 0 === r[a] && (r[a] = {
                        zoom: a,
                        type: t1.type,
                        property: t1.property,
                        default: t1.default,
                        stops: []
                    }, n.push(a)), r[a].stops.push([
                        i[0].value,
                        i[1]
                    ]);
                }
                const i = [];
                for (const t1 of n)i.push([
                    r[t1].zoom,
                    ji(r[t1], e)
                ]);
                const a = {
                    name: "linear"
                };
                return {
                    kind: "composite",
                    interpolationType: a,
                    interpolationFactor: ai.interpolationFactor.bind(void 0, a),
                    zoomStops: i.map((t1)=>t1[0]),
                    evaluate: ({ zoom: r }, n)=>Yi({
                            stops: i,
                            base: t1.base
                        }, e, r).evaluate(r, n)
                };
            }
            if (i) {
                const r = "exponential" === a ? {
                    name: "exponential",
                    base: void 0 !== t1.base ? t1.base : 1
                } : null;
                return {
                    kind: "camera",
                    interpolationType: r,
                    interpolationFactor: ai.interpolationFactor.bind(void 0, r),
                    zoomStops: t1.stops.map((t1)=>t1[0]),
                    evaluate: ({ zoom: r })=>s(t1, e, r, o, l)
                };
            }
            return {
                kind: "source",
                evaluate (r, n) {
                    const i = n && n.properties ? n.properties[t1.property] : void 0;
                    return void 0 === i ? qi(t1.default, e.default) : s(t1, e, i, o, l);
                }
            };
        }
        function qi(t1, e, r) {
            return void 0 !== t1 ? t1 : void 0 !== e ? e : void 0 !== r ? r : void 0;
        }
        function $i(t1, e, r, n, i) {
            return qi(typeof r === i ? n[r] : void 0, t1.default, e.default);
        }
        function Gi(t1, e, r) {
            if ("number" !== hr(r)) return qi(t1.default, e.default);
            const n = t1.stops.length;
            if (1 === n) return t1.stops[0][1];
            if (r <= t1.stops[0][0]) return t1.stops[0][1];
            if (r >= t1.stops[n - 1][0]) return t1.stops[n - 1][1];
            const i = On(t1.stops.map((t1)=>t1[0]), r);
            return t1.stops[i][1];
        }
        function Yi(t1, e, r) {
            const n = void 0 !== t1.base ? t1.base : 1;
            if ("number" !== hr(r)) return qi(t1.default, e.default);
            const i = t1.stops.length;
            if (1 === i) return t1.stops[0][1];
            if (r <= t1.stops[0][0]) return t1.stops[0][1];
            if (r >= t1.stops[i - 1][0]) return t1.stops[i - 1][1];
            const a = On(t1.stops.map((t1)=>t1[0]), r), s = function(t1, e, r, n) {
                const i = n - r, a = t1 - r;
                return 0 === i ? 0 : 1 === e ? a / i : (Math.pow(e, a) - 1) / (Math.pow(e, i) - 1);
            }(r, n, t1.stops[a][0], t1.stops[a + 1][0]), o = t1.stops[a][1], l = t1.stops[a + 1][1];
            let u = ke[e.type] || Ui;
            if (t1.colorSpace && "rgb" !== t1.colorSpace) {
                const e = ii[t1.colorSpace];
                u = (t1, r)=>e.reverse(e.interpolate(e.forward(t1), e.forward(r), s));
            }
            return "function" == typeof o.evaluate ? {
                evaluate (...t1) {
                    const e = o.evaluate.apply(void 0, t1), r = l.evaluate.apply(void 0, t1);
                    if (void 0 !== e && void 0 !== r) return u(e, r, s);
                }
            } : u(o, l, s);
        }
        function Xi(t1, e, r) {
            return "color" === e.type ? r = Ie.parse(r) : "formatted" === e.type ? r = Je.fromString(r.toString()) : "resolvedImage" === e.type ? r = tr.build(r.toString()) : hr(r) === e.type || "enum" === e.type && e.values[r] || (r = void 0), qi(r, t1.default, e.default);
        }
        yr.register(Pi, {
            error: [
                {
                    kind: "error"
                },
                [
                    Le
                ],
                (t1, [e])=>{
                    throw new sr(e.evaluate(t1));
                }
            ],
            typeof: [
                Le,
                [
                    Ne
                ],
                (t1, [e])=>Ge(nr(e.evaluate(t1)))
            ],
            "to-rgba": [
                $e(De, 4),
                [
                    Fe
                ],
                (t1, [e])=>e.evaluate(t1).toRenderColor(null).toArray()
            ],
            "to-hsla": [
                $e(De, 4),
                [
                    Fe
                ],
                (t1, [e])=>e.evaluate(t1).toRenderColor(null).toHslaArray()
            ],
            rgb: [
                Fe,
                [
                    De,
                    De,
                    De
                ],
                zi
            ],
            rgba: [
                Fe,
                [
                    De,
                    De,
                    De,
                    De
                ],
                zi
            ],
            hsl: [
                Fe,
                [
                    De,
                    De,
                    De
                ],
                Ei
            ],
            hsla: [
                Fe,
                [
                    De,
                    De,
                    De,
                    De
                ],
                Ei
            ],
            has: {
                type: Re,
                overloads: [
                    [
                        [
                            Le
                        ],
                        (t1, [e])=>ki(e.evaluate(t1), t1.properties())
                    ],
                    [
                        [
                            Le,
                            Oe
                        ],
                        (t1, [e, r])=>ki(e.evaluate(t1), r.evaluate(t1))
                    ]
                ]
            },
            get: {
                type: Ne,
                overloads: [
                    [
                        [
                            Le
                        ],
                        (t1, [e])=>Ti(e.evaluate(t1), t1.properties())
                    ],
                    [
                        [
                            Le,
                            Oe
                        ],
                        (t1, [e, r])=>Ti(e.evaluate(t1), r.evaluate(t1))
                    ]
                ]
            },
            "feature-state": [
                Ne,
                [
                    Le
                ],
                (t1, [e])=>Ti(e.evaluate(t1), t1.featureState || {})
            ],
            properties: [
                Oe,
                [],
                (t1)=>t1.properties()
            ],
            "geometry-type": [
                Le,
                [],
                (t1)=>t1.geometryType()
            ],
            id: [
                Ne,
                [],
                (t1)=>t1.id()
            ],
            zoom: [
                De,
                [],
                (t1)=>t1.globals.zoom
            ],
            pitch: [
                De,
                [],
                (t1)=>t1.globals.pitch || 0
            ],
            "distance-from-center": [
                De,
                [],
                (t1)=>t1.distanceFromCenter()
            ],
            "measure-light": [
                De,
                [
                    Le
                ],
                (t1, [e])=>t1.measureLight(e.evaluate(t1))
            ],
            "heatmap-density": [
                De,
                [],
                (t1)=>t1.globals.heatmapDensity || 0
            ],
            "line-progress": [
                De,
                [],
                (t1)=>t1.globals.lineProgress || 0
            ],
            "raster-value": [
                De,
                [],
                (t1)=>t1.globals.rasterValue || 0
            ],
            "raster-particle-speed": [
                De,
                [],
                (t1)=>t1.globals.rasterParticleSpeed || 0
            ],
            "sky-radial-progress": [
                De,
                [],
                (t1)=>t1.globals.skyRadialProgress || 0
            ],
            accumulated: [
                Ne,
                [],
                (t1)=>void 0 === t1.globals.accumulated ? null : t1.globals.accumulated
            ],
            "+": [
                De,
                Bi(De),
                (t1, e)=>{
                    let r = 0;
                    for (const n of e)r += n.evaluate(t1);
                    return r;
                }
            ],
            "*": [
                De,
                Bi(De),
                (t1, e)=>{
                    let r = 1;
                    for (const n of e)r *= n.evaluate(t1);
                    return r;
                }
            ],
            "-": {
                type: De,
                overloads: [
                    [
                        [
                            De,
                            De
                        ],
                        (t1, [e, r])=>e.evaluate(t1) - r.evaluate(t1)
                    ],
                    [
                        [
                            De
                        ],
                        (t1, [e])=>-e.evaluate(t1)
                    ]
                ]
            },
            "/": [
                De,
                [
                    De,
                    De
                ],
                (t1, [e, r])=>e.evaluate(t1) / r.evaluate(t1)
            ],
            "%": [
                De,
                [
                    De,
                    De
                ],
                (t1, [e, r])=>e.evaluate(t1) % r.evaluate(t1)
            ],
            ln2: [
                De,
                [],
                ()=>Math.LN2
            ],
            pi: [
                De,
                [],
                ()=>Math.PI
            ],
            e: [
                De,
                [],
                ()=>Math.E
            ],
            "^": [
                De,
                [
                    De,
                    De
                ],
                (t1, [e, r])=>Math.pow(e.evaluate(t1), r.evaluate(t1))
            ],
            sqrt: [
                De,
                [
                    De
                ],
                (t1, [e])=>Math.sqrt(e.evaluate(t1))
            ],
            log10: [
                De,
                [
                    De
                ],
                (t1, [e])=>Math.log(e.evaluate(t1)) / Math.LN10
            ],
            ln: [
                De,
                [
                    De
                ],
                (t1, [e])=>Math.log(e.evaluate(t1))
            ],
            log2: [
                De,
                [
                    De
                ],
                (t1, [e])=>Math.log(e.evaluate(t1)) / Math.LN2
            ],
            sin: [
                De,
                [
                    De
                ],
                (t1, [e])=>Math.sin(e.evaluate(t1))
            ],
            cos: [
                De,
                [
                    De
                ],
                (t1, [e])=>Math.cos(e.evaluate(t1))
            ],
            tan: [
                De,
                [
                    De
                ],
                (t1, [e])=>Math.tan(e.evaluate(t1))
            ],
            asin: [
                De,
                [
                    De
                ],
                (t1, [e])=>Math.asin(e.evaluate(t1))
            ],
            acos: [
                De,
                [
                    De
                ],
                (t1, [e])=>Math.acos(e.evaluate(t1))
            ],
            atan: [
                De,
                [
                    De
                ],
                (t1, [e])=>Math.atan(e.evaluate(t1))
            ],
            min: [
                De,
                Bi(De),
                (t1, e)=>Math.min(...e.map((e)=>e.evaluate(t1)))
            ],
            max: [
                De,
                Bi(De),
                (t1, e)=>Math.max(...e.map((e)=>e.evaluate(t1)))
            ],
            abs: [
                De,
                [
                    De
                ],
                (t1, [e])=>Math.abs(e.evaluate(t1))
            ],
            round: [
                De,
                [
                    De
                ],
                (t1, [e])=>{
                    const r = e.evaluate(t1);
                    return r < 0 ? -Math.round(-r) : Math.round(r);
                }
            ],
            floor: [
                De,
                [
                    De
                ],
                (t1, [e])=>Math.floor(e.evaluate(t1))
            ],
            ceil: [
                De,
                [
                    De
                ],
                (t1, [e])=>Math.ceil(e.evaluate(t1))
            ],
            "filter-==": [
                Re,
                [
                    Le,
                    Ne
                ],
                (t1, [e, r])=>t1.properties()[e.value] === r.value
            ],
            "filter-id-==": [
                Re,
                [
                    Ne
                ],
                (t1, [e])=>t1.id() === e.value
            ],
            "filter-type-==": [
                Re,
                [
                    Le
                ],
                (t1, [e])=>t1.geometryType() === e.value
            ],
            "filter-<": [
                Re,
                [
                    Le,
                    Ne
                ],
                (t1, [e, r])=>{
                    const n = t1.properties()[e.value], i = r.value;
                    return typeof n == typeof i && n < i;
                }
            ],
            "filter-id-<": [
                Re,
                [
                    Ne
                ],
                (t1, [e])=>{
                    const r = t1.id(), n = e.value;
                    return typeof r == typeof n && r < n;
                }
            ],
            "filter->": [
                Re,
                [
                    Le,
                    Ne
                ],
                (t1, [e, r])=>{
                    const n = t1.properties()[e.value], i = r.value;
                    return typeof n == typeof i && n > i;
                }
            ],
            "filter-id->": [
                Re,
                [
                    Ne
                ],
                (t1, [e])=>{
                    const r = t1.id(), n = e.value;
                    return typeof r == typeof n && r > n;
                }
            ],
            "filter-<=": [
                Re,
                [
                    Le,
                    Ne
                ],
                (t1, [e, r])=>{
                    const n = t1.properties()[e.value], i = r.value;
                    return typeof n == typeof i && n <= i;
                }
            ],
            "filter-id-<=": [
                Re,
                [
                    Ne
                ],
                (t1, [e])=>{
                    const r = t1.id(), n = e.value;
                    return typeof r == typeof n && r <= n;
                }
            ],
            "filter->=": [
                Re,
                [
                    Le,
                    Ne
                ],
                (t1, [e, r])=>{
                    const n = t1.properties()[e.value], i = r.value;
                    return typeof n == typeof i && n >= i;
                }
            ],
            "filter-id->=": [
                Re,
                [
                    Ne
                ],
                (t1, [e])=>{
                    const r = t1.id(), n = e.value;
                    return typeof r == typeof n && r >= n;
                }
            ],
            "filter-has": [
                Re,
                [
                    Ne
                ],
                (t1, [e])=>e.value in t1.properties()
            ],
            "filter-has-id": [
                Re,
                [],
                (t1)=>null !== t1.id() && void 0 !== t1.id()
            ],
            "filter-type-in": [
                Re,
                [
                    $e(Le)
                ],
                (t1, [e])=>e.value.indexOf(t1.geometryType()) >= 0
            ],
            "filter-id-in": [
                Re,
                [
                    $e(Ne)
                ],
                (t1, [e])=>e.value.indexOf(t1.id()) >= 0
            ],
            "filter-in-small": [
                Re,
                [
                    Le,
                    $e(Ne)
                ],
                (t1, [e, r])=>r.value.indexOf(t1.properties()[e.value]) >= 0
            ],
            "filter-in-large": [
                Re,
                [
                    Le,
                    $e(Ne)
                ],
                (t1, [e, r])=>(function(t1, e, r, n) {
                        for(; r <= n;){
                            const i = r + n >> 1;
                            if (e[i] === t1) return !0;
                            e[i] > t1 ? n = i - 1 : r = i + 1;
                        }
                        return !1;
                    })(t1.properties()[e.value], r.value, 0, r.value.length - 1)
            ],
            all: {
                type: Re,
                overloads: [
                    [
                        [
                            Re,
                            Re
                        ],
                        (t1, [e, r])=>e.evaluate(t1) && r.evaluate(t1)
                    ],
                    [
                        Bi(Re),
                        (t1, e)=>{
                            for (const r of e)if (!r.evaluate(t1)) return !1;
                            return !0;
                        }
                    ]
                ]
            },
            any: {
                type: Re,
                overloads: [
                    [
                        [
                            Re,
                            Re
                        ],
                        (t1, [e, r])=>e.evaluate(t1) || r.evaluate(t1)
                    ],
                    [
                        Bi(Re),
                        (t1, e)=>{
                            for (const r of e)if (r.evaluate(t1)) return !0;
                            return !1;
                        }
                    ]
                ]
            },
            "!": [
                Re,
                [
                    Re
                ],
                (t1, [e])=>!e.evaluate(t1)
            ],
            "is-supported-script": [
                Re,
                [
                    Le
                ],
                (t1, [e])=>{
                    const r = t1.globals && t1.globals.isSupportedScript;
                    return !r || r(e.evaluate(t1));
                }
            ],
            upcase: [
                Le,
                [
                    Le
                ],
                (t1, [e])=>e.evaluate(t1).toUpperCase()
            ],
            downcase: [
                Le,
                [
                    Le
                ],
                (t1, [e])=>e.evaluate(t1).toLowerCase()
            ],
            concat: [
                Le,
                Bi(Ne),
                (t1, e)=>e.map((e)=>ir(e.evaluate(t1))).join("")
            ],
            "resolved-locale": [
                Le,
                [
                    Ue
                ],
                (t1, [e])=>e.evaluate(t1).resolvedLocale()
            ],
            random: [
                De,
                [
                    De,
                    De,
                    Ne
                ],
                (t1, e)=>{
                    const [r, n, i] = e.map((e)=>e.evaluate(t1));
                    if (r > n) return r;
                    if (r === n) return r;
                    let a;
                    if ("string" == typeof i) a = function(t1) {
                        let e = 0;
                        if (0 === t1.length) return e;
                        for(let r = 0; r < t1.length; r++)e = (e << 5) - e + t1.charCodeAt(r), e |= 0;
                        return e;
                    }(i);
                    else {
                        if ("number" != typeof i) throw new sr(`Invalid seed input: ${i}`);
                        a = i;
                    }
                    return r + Ii(a)() * (n - r);
                }
            ]
        });
        class Zi {
            evaluateWithoutErrorHandling(t1, e, r, n, i, a, s, o) {
                return this._evaluator.globals = t1, this._evaluator.feature = e, this._evaluator.featureState = r, this._evaluator.canonical = n || null, this._evaluator.availableImages = i || null, this._evaluator.formattedSection = a, this._evaluator.featureTileCoord = s || null, this._evaluator.featureDistanceData = o || null, this.expression.evaluate(this._evaluator);
            }
            evaluate(t1, e, r, n, i, a, s, o) {
                this._evaluator.globals = t1, this._evaluator.feature = e || null, this._evaluator.featureState = r || null, this._evaluator.canonical = n || null, this._evaluator.availableImages = i || null, this._evaluator.formattedSection = a || null, this._evaluator.featureTileCoord = s || null, this._evaluator.featureDistanceData = o || null;
                try {
                    const t1 = this.expression.evaluate(this._evaluator);
                    if (null == t1 || "number" == typeof t1 && t1 != t1) return this._defaultValue;
                    if (this._enumValues && !(t1 in this._enumValues)) throw new sr(`Expected value to be one of ${Object.keys(this._enumValues).map((t1)=>JSON.stringify(t1)).join(", ")}, but found ${JSON.stringify(t1)} instead.`);
                    return t1;
                } catch (t1) {
                    return this._warningHistory[t1.message] || (this._warningHistory[t1.message] = !0, "undefined" != typeof console && console.warn(`Failed to evaluate expression "${JSON.stringify(this.expression.serialize())}". ${t1.message}`)), this._defaultValue;
                }
            }
            constructor(t1, e, r, n){
                this.expression = t1, this._warningHistory = {}, this._evaluator = new mr(r, n), this._defaultValue = e ? function(t1) {
                    return "color" === t1.type && (Ni(t1.default) || Array.isArray(t1.default)) ? new Ie(0, 0, 0, 0) : "color" === t1.type ? Ie.parse(t1.default) || null : void 0 === t1.default ? null : t1.default;
                }(e) : null, this._enumValues = e && "enum" === e.type ? e.values : null, this.configDependencies = Cn(t1);
            }
        }
        function Hi(t1) {
            return Array.isArray(t1) && t1.length > 0 && "string" == typeof t1[0] && t1[0] in Pi;
        }
        function Wi(t1, e, r, n) {
            const i = new Rn(Pi, [], e ? function(t1) {
                const e = {
                    color: Fe,
                    string: Le,
                    number: De,
                    enum: Le,
                    boolean: Re,
                    formatted: je,
                    resolvedImage: qe
                };
                return "array" === t1.type ? $e(e[t1.value] || Ne, t1.length) : e[t1.type];
            }(e) : void 0, void 0, void 0, r, n), a = i.parse(t1, void 0, void 0, void 0, e && "string" === e.type ? {
                typeAnnotation: "coerce"
            } : void 0);
            return a ? Ci(new Zi(a, e, r, n)) : Vi(i.errors);
        }
        class Ki {
            evaluateWithoutErrorHandling(t1, e, r, n, i, a) {
                return this._styleExpression.evaluateWithoutErrorHandling(t1, e, r, n, i, a);
            }
            evaluate(t1, e, r, n, i, a) {
                return this._styleExpression.evaluate(t1, e, r, n, i, a);
            }
            constructor(t1, e, r, n){
                this.kind = t1, this._styleExpression = e, this.isLightConstant = r, this.isLineProgressConstant = n, this.isStateDependent = "constant" !== t1 && !Bn(e.expression), this.configDependencies = Cn(e.expression);
            }
        }
        class Ji {
            evaluateWithoutErrorHandling(t1, e, r, n, i, a) {
                return this._styleExpression.evaluateWithoutErrorHandling(t1, e, r, n, i, a);
            }
            evaluate(t1, e, r, n, i, a) {
                return this._styleExpression.evaluate(t1, e, r, n, i, a);
            }
            interpolationFactor(t1, e, r) {
                return this.interpolationType ? ai.interpolationFactor(this.interpolationType, t1, e, r) : 0;
            }
            constructor(t1, e, r, n, i, a){
                this.kind = t1, this.zoomStops = r, this._styleExpression = e, this.isStateDependent = "camera" !== t1 && !Bn(e.expression), this.isLightConstant = i, this.isLineProgressConstant = a, this.configDependencies = Cn(e.expression), this.interpolationType = n;
            }
        }
        function Qi(t1, e, r, n) {
            if ("error" === (t1 = Wi(t1, e, r, n)).result) return t1;
            const i = t1.value.expression, a = Tn(i);
            if (!a && !Li(e)) return Vi([
                new Be("", "data expressions not supported")
            ]);
            const s = Vn(i, [
                "zoom",
                "pitch",
                "distance-from-center"
            ]);
            if (!s && !Fi(e)) return Vi([
                new Be("", "zoom expressions not supported")
            ]);
            const o = Vn(i, [
                "measure-light"
            ]);
            if (!o && !Ri(e)) return Vi([
                new Be("", "measure-light expression not supported")
            ]);
            const l = Vn(i, [
                "line-progress"
            ]);
            if (!l && !function(t1) {
                return Di(t1.expression, "line-progress");
            }(e)) return Vi([
                new Be("", "line-progress expression not supported")
            ]);
            const u = e.expression && e.expression.relaxZoomRestriction, c = ea(i);
            return c || s || u ? c instanceof Be ? Vi([
                c
            ]) : c instanceof ai && !Oi(e) ? Vi([
                new Be("", '"interpolate" expressions cannot be used with this property')
            ]) : Ci(c ? new Ji(a && l ? "camera" : "composite", t1.value, c.labels, c instanceof ai ? c.interpolation : void 0, o, l) : new Ki(a && l ? "constant" : "source", t1.value, o, l)) : Vi([
                new Be("", '"zoom" expression may only be used as input to a top-level "step" or "interpolate" expression, or in the properties of atmosphere.')
            ]);
        }
        class ta {
            static deserialize(t1) {
                return new ta(t1._parameters, t1._specification);
            }
            static serialize(t1) {
                return {
                    _parameters: t1._parameters,
                    _specification: t1._specification
                };
            }
            constructor(t1, e){
                this._parameters = t1, this._specification = e, Te(this, ji(this._parameters, this._specification));
            }
        }
        function ea(t1) {
            let e = null;
            if (t1 instanceof li) e = ea(t1.result);
            else if (t1 instanceof oi) {
                for (const r of t1.args)if (e = ea(r), e) break;
            } else (t1 instanceof Nn || t1 instanceof ai) && t1.input instanceof yr && "zoom" === t1.input.name && (e = t1);
            return e instanceof Be || t1.eachChild((t1)=>{
                const r = ea(t1);
                r instanceof Be ? e = r : e && r && e !== r && (e = new Be("", 'Only one zoom-based "step" or "interpolate" subexpression may be used in an expression.'));
            }), e;
        }
        var ra, na, ia = function() {
            if (na) return ra;
            na = 1, ra = e;
            var t1 = 3;
            function e(e, r, n) {
                var i = this.cells = [];
                if (e instanceof ArrayBuffer) {
                    this.arrayBuffer = e;
                    var a = new Int32Array(this.arrayBuffer);
                    e = a[0], this.d = (r = a[1]) + 2 * (n = a[2]);
                    for(var s = 0; s < this.d * this.d; s++){
                        var o = a[t1 + s], l = a[t1 + s + 1];
                        i.push(o === l ? null : a.subarray(o, l));
                    }
                    var u = a[t1 + i.length + 1];
                    this.keys = a.subarray(a[t1 + i.length], u), this.bboxes = a.subarray(u), this.insert = this._insertReadonly;
                } else {
                    this.d = r + 2 * n;
                    for(var c = 0; c < this.d * this.d; c++)i.push([]);
                    this.keys = [], this.bboxes = [];
                }
                this.n = r, this.extent = e, this.padding = n, this.scale = r / e, this.uid = 0;
                var h = n / r * e;
                this.min = -h, this.max = e + h;
            }
            return e.prototype.insert = function(t1, e, r, n, i) {
                this._forEachCell(e, r, n, i, this._insertCell, this.uid++), this.keys.push(t1), this.bboxes.push(e), this.bboxes.push(r), this.bboxes.push(n), this.bboxes.push(i);
            }, e.prototype._insertReadonly = function() {
                throw "Cannot insert into a GridIndex created from an ArrayBuffer.";
            }, e.prototype._insertCell = function(t1, e, r, n, i, a) {
                this.cells[i].push(a);
            }, e.prototype.query = function(t1, e, r, n, i) {
                var a = this.min, s = this.max;
                if (t1 <= a && e <= a && s <= r && s <= n && !i) return Array.prototype.slice.call(this.keys);
                var o = [];
                return this._forEachCell(t1, e, r, n, this._queryCell, o, {}, i), o;
            }, e.prototype._queryCell = function(t1, e, r, n, i, a, s, o) {
                var l = this.cells[i];
                if (null !== l) for(var u = this.keys, c = this.bboxes, h = 0; h < l.length; h++){
                    var p = l[h];
                    if (void 0 === s[p]) {
                        var f = 4 * p;
                        (o ? o(c[f + 0], c[f + 1], c[f + 2], c[f + 3]) : t1 <= c[f + 2] && e <= c[f + 3] && r >= c[f + 0] && n >= c[f + 1]) ? (s[p] = !0, a.push(u[p])) : s[p] = !1;
                    }
                }
            }, e.prototype._forEachCell = function(t1, e, r, n, i, a, s, o) {
                for(var l = this._convertToCellCoord(t1), u = this._convertToCellCoord(e), c = this._convertToCellCoord(r), h = this._convertToCellCoord(n), p = l; p <= c; p++)for(var f = u; f <= h; f++){
                    var d = this.d * f + p;
                    if ((!o || o(this._convertFromCellCoord(p), this._convertFromCellCoord(f), this._convertFromCellCoord(p + 1), this._convertFromCellCoord(f + 1))) && i.call(this, t1, e, r, n, d, a, s, o)) return;
                }
            }, e.prototype._convertFromCellCoord = function(t1) {
                return (t1 - this.padding) / this.scale;
            }, e.prototype._convertToCellCoord = function(t1) {
                return Math.max(0, Math.min(this.d - 1, Math.floor(t1 * this.scale) + this.padding));
            }, e.prototype.toArrayBuffer = function() {
                if (this.arrayBuffer) return this.arrayBuffer;
                for(var e = this.cells, r = t1 + this.cells.length + 1 + 1, n = 0, i = 0; i < this.cells.length; i++)n += this.cells[i].length;
                var a = new Int32Array(r + n + this.keys.length + this.bboxes.length);
                a[0] = this.extent, a[1] = this.n, a[2] = this.padding;
                for(var s = r, o = 0; o < e.length; o++){
                    var l = e[o];
                    a[t1 + o] = s, a.set(l, s), s += l.length;
                }
                return a[t1 + e.length] = s, a.set(this.keys, s), a[t1 + e.length + 1] = s += this.keys.length, a.set(this.bboxes, s), s += this.bboxes.length, a.buffer;
            }, ra;
        }(), aa = e(ia);
        const sa = {};
        function oa(t1, e, r = {}) {
            Object.defineProperty(t1, "_classRegistryKey", {
                value: e,
                writable: !1
            }), sa[e] = {
                klass: t1,
                omit: r.omit || []
            };
        }
        oa(Object, "Object"), aa.serialize = function(t1, e) {
            const r = t1.toArrayBuffer();
            return e && e.add(r), {
                buffer: r
            };
        }, aa.deserialize = function(t1) {
            return new aa(t1.buffer);
        }, Object.defineProperty(aa, "name", {
            value: "Grid"
        }), oa(aa, "Grid"), "undefined" != typeof DOMMatrix && oa(DOMMatrix, "DOMMatrix"), oa(Ie, "Color"), oa(Error, "Error"), oa(Je, "Formatted"), oa(Ke, "FormattedSection"), oa(ee, "AJAXError"), oa(tr, "ResolvedImage"), oa(ta, "StylePropertyFunction"), oa(Zi, "StyleExpression", {
            omit: [
                "_evaluator"
            ]
        }), oa(Qe, "ImageIdWithOptions"), oa(Ji, "ZoomDependentExpression"), oa(Ki, "ZoomConstantExpression"), oa(yr, "CompoundExpression", {
            omit: [
                "_evaluate"
            ]
        });
        for(const t1 in Pi)sa[Pi[t1]._classRegistryKey] || oa(Pi[t1], `Expression${t1}`);
        function la(t1) {
            return t1 && "undefined" != typeof ArrayBuffer && (t1 instanceof ArrayBuffer || t1.constructor && "ArrayBuffer" === t1.constructor.name);
        }
        function ua(t1) {
            return self.ImageBitmap && t1 instanceof ImageBitmap;
        }
        function ca(t1, e) {
            if (null == t1 || "boolean" == typeof t1 || "number" == typeof t1 || "string" == typeof t1 || t1 instanceof Boolean || t1 instanceof Number || t1 instanceof String || t1 instanceof Date || t1 instanceof RegExp) return t1;
            if (la(t1) || ua(t1)) return e && e.add(t1), t1;
            if (ArrayBuffer.isView(t1)) return e && e.add(t1.buffer), t1;
            if (t1 instanceof ImageData) return e && e.add(t1.data.buffer), t1;
            if (Array.isArray(t1)) {
                const r = [];
                for (const n of t1)r.push(ca(n, e));
                return r;
            }
            if (t1 instanceof Map) {
                const e = {
                    $name: "Map"
                };
                for (const [r, n] of t1.entries())e[r] = ca(n);
                return e;
            }
            if (t1 instanceof Set) {
                const e = {
                    $name: "Set"
                };
                let r = 0;
                for (const n of t1.values())e[++r] = ca(n);
                return e;
            }
            if ("object" == typeof t1) {
                const r = t1.constructor, n = r._classRegistryKey;
                if (!n) throw new Error(`Can't serialize object of unregistered class "${n}".`);
                const i = r.serialize ? r.serialize(t1, e) : {};
                if (!r.serialize) {
                    for(const r in t1)t1.hasOwnProperty(r) && (sa[n].omit.indexOf(r) >= 0 || (i[r] = ca(t1[r], e)));
                    t1 instanceof Error && (i.message = t1.message);
                }
                if (i.$name) throw new Error("$name property is reserved for worker serialization logic.");
                return "Object" !== n && (i.$name = n), i;
            }
            throw new Error("can't serialize object of type " + typeof t1);
        }
        function ha(t1) {
            if (null == t1 || "boolean" == typeof t1 || "number" == typeof t1 || "string" == typeof t1 || t1 instanceof Boolean || t1 instanceof Number || t1 instanceof String || t1 instanceof Date || t1 instanceof RegExp || la(t1) || ua(t1) || ArrayBuffer.isView(t1) || t1 instanceof ImageData) return t1;
            if (Array.isArray(t1)) return t1.map(ha);
            if ("object" == typeof t1) {
                const e = t1.$name || "Object";
                if ("Map" === e) {
                    const e = new Map;
                    for (const r of Object.keys(t1))"$name" !== r && e.set(r, ha(t1[r]));
                    return e;
                }
                if ("Set" === e) {
                    const e = new Set;
                    for (const r of Object.keys(t1))"$name" !== r && e.add(ha(t1[r]));
                    return e;
                }
                const { klass: r } = sa[e];
                if (!r) throw new Error(`Can't deserialize unregistered class "${e}".`);
                if (r.deserialize) return r.deserialize(t1);
                const n = Object.create(r.prototype);
                for (const e of Object.keys(t1))"$name" !== e && (n[e] = ha(t1[e]));
                return n;
            }
            throw new Error("can't deserialize object of type " + typeof t1);
        }
        const pa = {
            "Latin-1 Supplement": (t1)=>t1 >= 128 && t1 <= 255,
            Arabic: (t1)=>t1 >= 1536 && t1 <= 1791,
            "Arabic Supplement": (t1)=>t1 >= 1872 && t1 <= 1919,
            "Arabic Extended-A": (t1)=>t1 >= 2208 && t1 <= 2303,
            "Hangul Jamo": (t1)=>t1 >= 4352 && t1 <= 4607,
            "Unified Canadian Aboriginal Syllabics": (t1)=>t1 >= 5120 && t1 <= 5759,
            Khmer: (t1)=>t1 >= 6016 && t1 <= 6143,
            "Unified Canadian Aboriginal Syllabics Extended": (t1)=>t1 >= 6320 && t1 <= 6399,
            "General Punctuation": (t1)=>t1 >= 8192 && t1 <= 8303,
            "Letterlike Symbols": (t1)=>t1 >= 8448 && t1 <= 8527,
            "Number Forms": (t1)=>t1 >= 8528 && t1 <= 8591,
            "Miscellaneous Technical": (t1)=>t1 >= 8960 && t1 <= 9215,
            "Control Pictures": (t1)=>t1 >= 9216 && t1 <= 9279,
            "Optical Character Recognition": (t1)=>t1 >= 9280 && t1 <= 9311,
            "Enclosed Alphanumerics": (t1)=>t1 >= 9312 && t1 <= 9471,
            "Geometric Shapes": (t1)=>t1 >= 9632 && t1 <= 9727,
            "Miscellaneous Symbols": (t1)=>t1 >= 9728 && t1 <= 9983,
            "Miscellaneous Symbols and Arrows": (t1)=>t1 >= 11008 && t1 <= 11263,
            "CJK Radicals Supplement": (t1)=>t1 >= 11904 && t1 <= 12031,
            "Kangxi Radicals": (t1)=>t1 >= 12032 && t1 <= 12255,
            "Ideographic Description Characters": (t1)=>t1 >= 12272 && t1 <= 12287,
            "CJK Symbols and Punctuation": (t1)=>t1 >= 12288 && t1 <= 12351,
            Hiragana: (t1)=>t1 >= 12352 && t1 <= 12447,
            Katakana: (t1)=>t1 >= 12448 && t1 <= 12543,
            Bopomofo: (t1)=>t1 >= 12544 && t1 <= 12591,
            "Hangul Compatibility Jamo": (t1)=>t1 >= 12592 && t1 <= 12687,
            Kanbun: (t1)=>t1 >= 12688 && t1 <= 12703,
            "Bopomofo Extended": (t1)=>t1 >= 12704 && t1 <= 12735,
            "CJK Strokes": (t1)=>t1 >= 12736 && t1 <= 12783,
            "Katakana Phonetic Extensions": (t1)=>t1 >= 12784 && t1 <= 12799,
            "Enclosed CJK Letters and Months": (t1)=>t1 >= 12800 && t1 <= 13055,
            "CJK Compatibility": (t1)=>t1 >= 13056 && t1 <= 13311,
            "CJK Unified Ideographs Extension A": (t1)=>t1 >= 13312 && t1 <= 19903,
            "Yijing Hexagram Symbols": (t1)=>t1 >= 19904 && t1 <= 19967,
            "CJK Unified Ideographs": (t1)=>t1 >= 19968 && t1 <= 40959,
            "Yi Syllables": (t1)=>t1 >= 40960 && t1 <= 42127,
            "Yi Radicals": (t1)=>t1 >= 42128 && t1 <= 42191,
            "Hangul Jamo Extended-A": (t1)=>t1 >= 43360 && t1 <= 43391,
            "Hangul Syllables": (t1)=>t1 >= 44032 && t1 <= 55215,
            "Hangul Jamo Extended-B": (t1)=>t1 >= 55216 && t1 <= 55295,
            "Private Use Area": (t1)=>t1 >= 57344 && t1 <= 63743,
            "CJK Compatibility Ideographs": (t1)=>t1 >= 63744 && t1 <= 64255,
            "Arabic Presentation Forms-A": (t1)=>t1 >= 64336 && t1 <= 65023,
            "Vertical Forms": (t1)=>t1 >= 65040 && t1 <= 65055,
            "CJK Compatibility Forms": (t1)=>t1 >= 65072 && t1 <= 65103,
            "Small Form Variants": (t1)=>t1 >= 65104 && t1 <= 65135,
            "Arabic Presentation Forms-B": (t1)=>t1 >= 65136 && t1 <= 65279,
            "Halfwidth and Fullwidth Forms": (t1)=>t1 >= 65280 && t1 <= 65519,
            Osage: (t1)=>t1 >= 66736 && t1 <= 66815,
            "CJK Unified Ideographs Extension B": (t1)=>t1 >= 131072 && t1 <= 173791
        };
        function fa(t1) {
            for (const e of t1)if (ya(e.charCodeAt(0))) return !0;
            return !1;
        }
        function da(t1) {
            for (const e of t1)if (!ma(e.charCodeAt(0))) return !1;
            return !0;
        }
        function ma(t1) {
            return !(pa.Arabic(t1) || pa["Arabic Supplement"](t1) || pa["Arabic Extended-A"](t1) || pa["Arabic Presentation Forms-A"](t1) || pa["Arabic Presentation Forms-B"](t1));
        }
        function ya(t1) {
            return !(746 !== t1 && 747 !== t1 && (t1 < 4352 || !(pa["Bopomofo Extended"](t1) || pa.Bopomofo(t1) || pa["CJK Compatibility Forms"](t1) && !(t1 >= 65097 && t1 <= 65103) || pa["CJK Compatibility Ideographs"](t1) || pa["CJK Compatibility"](t1) || pa["CJK Radicals Supplement"](t1) || pa["CJK Strokes"](t1) || !(!pa["CJK Symbols and Punctuation"](t1) || t1 >= 12296 && t1 <= 12305 || t1 >= 12308 && t1 <= 12319 || 12336 === t1) || pa["CJK Unified Ideographs Extension A"](t1) || pa["CJK Unified Ideographs"](t1) || pa["Enclosed CJK Letters and Months"](t1) || pa["Hangul Compatibility Jamo"](t1) || pa["Hangul Jamo Extended-A"](t1) || pa["Hangul Jamo Extended-B"](t1) || pa["Hangul Jamo"](t1) || pa["Hangul Syllables"](t1) || pa.Hiragana(t1) || pa["Ideographic Description Characters"](t1) || pa.Kanbun(t1) || pa["Kangxi Radicals"](t1) || pa["Katakana Phonetic Extensions"](t1) || pa.Katakana(t1) && 12540 !== t1 || !(!pa["Halfwidth and Fullwidth Forms"](t1) || 65288 === t1 || 65289 === t1 || 65293 === t1 || t1 >= 65306 && t1 <= 65310 || 65339 === t1 || 65341 === t1 || 65343 === t1 || t1 >= 65371 && t1 <= 65503 || 65507 === t1 || t1 >= 65512 && t1 <= 65519) || !(!pa["Small Form Variants"](t1) || t1 >= 65112 && t1 <= 65118 || t1 >= 65123 && t1 <= 65126) || pa["Unified Canadian Aboriginal Syllabics"](t1) || pa["Unified Canadian Aboriginal Syllabics Extended"](t1) || pa["Vertical Forms"](t1) || pa["Yijing Hexagram Symbols"](t1) || pa["Yi Syllables"](t1) || pa["Yi Radicals"](t1))));
        }
        function ga(t1) {
            return !(ya(t1) || function(t1) {
                return !!(pa["Latin-1 Supplement"](t1) && (167 === t1 || 169 === t1 || 174 === t1 || 177 === t1 || 188 === t1 || 189 === t1 || 190 === t1 || 215 === t1 || 247 === t1) || pa["General Punctuation"](t1) && (8214 === t1 || 8224 === t1 || 8225 === t1 || 8240 === t1 || 8241 === t1 || 8251 === t1 || 8252 === t1 || 8258 === t1 || 8263 === t1 || 8264 === t1 || 8265 === t1 || 8273 === t1) || pa["Letterlike Symbols"](t1) || pa["Number Forms"](t1) || pa["Miscellaneous Technical"](t1) && (t1 >= 8960 && t1 <= 8967 || t1 >= 8972 && t1 <= 8991 || t1 >= 8996 && t1 <= 9e3 || 9003 === t1 || t1 >= 9085 && t1 <= 9114 || t1 >= 9150 && t1 <= 9165 || 9167 === t1 || t1 >= 9169 && t1 <= 9179 || t1 >= 9186 && t1 <= 9215) || pa["Control Pictures"](t1) && 9251 !== t1 || pa["Optical Character Recognition"](t1) || pa["Enclosed Alphanumerics"](t1) || pa["Geometric Shapes"](t1) || pa["Miscellaneous Symbols"](t1) && !(t1 >= 9754 && t1 <= 9759) || pa["Miscellaneous Symbols and Arrows"](t1) && (t1 >= 11026 && t1 <= 11055 || t1 >= 11088 && t1 <= 11097 || t1 >= 11192 && t1 <= 11243) || pa["CJK Symbols and Punctuation"](t1) || pa.Katakana(t1) || pa["Private Use Area"](t1) || pa["CJK Compatibility Forms"](t1) || pa["Small Form Variants"](t1) || pa["Halfwidth and Fullwidth Forms"](t1) || 8734 === t1 || 8756 === t1 || 8757 === t1 || t1 >= 9984 && t1 <= 10087 || t1 >= 10102 && t1 <= 10131 || 65532 === t1 || 65533 === t1);
            }(t1));
        }
        function xa(t1) {
            return t1 >= 1424 && t1 <= 2303 || pa["Arabic Presentation Forms-A"](t1) || pa["Arabic Presentation Forms-B"](t1);
        }
        function va(t1, e) {
            return !(!e && xa(t1) || t1 >= 2304 && t1 <= 3583 || t1 >= 3840 && t1 <= 4255 || pa.Khmer(t1));
        }
        function ba(t1) {
            for (const e of t1)if (xa(e.charCodeAt(0))) return !0;
            return !1;
        }
        const _a = "deferred", wa = "loading", Ma = "loaded";
        let Aa = null, Sa = "unavailable", Ia = null;
        const Pa = function(t1) {
            t1 && "string" == typeof t1 && t1.indexOf("NetworkError") > -1 && (Sa = "error"), Aa && Aa(t1);
        };
        function za() {
            Ea.fire(new xe("pluginStateChange", {
                pluginStatus: Sa,
                pluginURL: Ia
            }));
        }
        const Ea = new we, ka = function() {
            return Sa;
        }, Ta = function() {
            if (Sa !== _a || !Ia) throw new Error("rtl-text-plugin cannot be downloaded unless a pluginURL is specified");
            Sa = wa, za(), Ia && ie({
                url: Ia
            }, (t1)=>{
                t1 ? Pa(t1) : (Sa = Ma, za());
            });
        }, Ba = {
            applyArabicShaping: null,
            processBidirectionalText: null,
            processStyledBidirectionalText: null,
            isLoaded: ()=>Sa === Ma || null != Ba.applyArabicShaping,
            isLoading: ()=>Sa === wa,
            setState (t1) {
                Sa = t1.pluginStatus, Ia = t1.pluginURL;
            },
            isParsed: ()=>null != Ba.applyArabicShaping && null != Ba.processBidirectionalText && null != Ba.processStyledBidirectionalText,
            getPluginURL: ()=>Ia
        };
        class Ca {
            isSupportedScript(t1) {
                return function(t1, e) {
                    for (const r of t1)if (!va(r.charCodeAt(0), e)) return !1;
                    return !0;
                }(t1, Ba.isLoaded());
            }
            constructor(t1, e){
                this.zoom = t1, e ? (this.now = e.now, this.fadeDuration = e.fadeDuration, this.transition = e.transition, this.pitch = e.pitch, this.brightness = e.brightness) : (this.now = 0, this.fadeDuration = 0, this.transition = {}, this.pitch = 0, this.brightness = 0);
            }
        }
        class Va {
            isDataDriven() {
                return "source" === this.expression.kind || "composite" === this.expression.kind;
            }
            possiblyEvaluate(t1, e, r) {
                return this.property.possiblyEvaluate(this, t1, e, r);
            }
            constructor(t1, e, r, n){
                this.property = t1, this.value = e, this.expression = function(t1, e, r, n) {
                    if (Ni(t1)) return new ta(t1, e);
                    if (Hi(t1) || Array.isArray(t1) && t1.length > 0) {
                        const i = Qi(t1, e, r, n);
                        if ("error" === i.result) throw new Error(i.value.map((t1)=>`${t1.key}: ${t1.message}`).join(", "));
                        return i.value;
                    }
                    {
                        let r = t1;
                        return "string" == typeof t1 && "color" === e.type && (r = Ie.parse(t1)), {
                            kind: "constant",
                            configDependencies: new Set,
                            evaluate: ()=>r
                        };
                    }
                }(void 0 === e ? t1.specification.default : e, t1.specification, r, n);
            }
        }
        class Da {
            transitioned(t1, e) {
                return new Ra(this.property, this.value, e, nt({}, t1.transition, this.transition), t1.now);
            }
            untransitioned() {
                return new Ra(this.property, this.value, null, {}, 0);
            }
            constructor(t1, e, r){
                this.property = t1, this.value = new Va(t1, void 0, e, r);
            }
        }
        class La {
            getValue(t1) {
                return ht(this._values[t1].value.value);
            }
            setValue(t1, e) {
                this._values.hasOwnProperty(t1) || (this._values[t1] = new Da(this._values[t1].property, this._scope, this._options)), this._values[t1].value = new Va(this._values[t1].property, null === e ? void 0 : ht(e), this._scope, this._options), this._values[t1].value.expression.configDependencies && (this.configDependencies = new Set([
                    ...this.configDependencies,
                    ...this._values[t1].value.expression.configDependencies
                ]));
            }
            setTransitionOrValue(t1, e) {
                e && (this._options = e);
                const r = this._properties.properties;
                if (t1) for(const e in t1){
                    const n = t1[e];
                    if (lt(e, "-transition")) {
                        const t1 = e.slice(0, -11);
                        r[t1] && this.setTransition(t1, n);
                    } else r.hasOwnProperty(e) && this.setValue(e, n);
                }
            }
            getTransition(t1) {
                return ht(this._values[t1].transition);
            }
            setTransition(t1, e) {
                this._values.hasOwnProperty(t1) || (this._values[t1] = new Da(this._values[t1].property)), this._values[t1].transition = ht(e) || void 0;
            }
            serialize() {
                const t1 = {};
                for (const e of Object.keys(this._values)){
                    const r = this.getValue(e);
                    void 0 !== r && (t1[e] = r);
                    const n = this.getTransition(e);
                    void 0 !== n && (t1[`${e}-transition`] = n);
                }
                return t1;
            }
            transitioned(t1, e) {
                const r = new Fa(this._properties);
                for (const n of Object.keys(this._values))r._values[n] = this._values[n].transitioned(t1, e._values[n]);
                return r;
            }
            untransitioned() {
                const t1 = new Fa(this._properties);
                for (const e of Object.keys(this._values))t1._values[e] = this._values[e].untransitioned();
                return t1;
            }
            constructor(t1, e, r){
                this._properties = t1, this._values = Object.create(t1.defaultTransitionablePropertyValues), this._scope = e, this._options = r, this.configDependencies = new Set;
            }
        }
        class Ra {
            possiblyEvaluate(t1, e, r) {
                const n = t1.now || 0, i = this.value.possiblyEvaluate(t1, e, r), a = this.prior;
                if (a) {
                    if (n > this.end) return this.prior = null, i;
                    if (this.value.isDataDriven()) return this.prior = null, i;
                    if (n < this.begin) return a.possiblyEvaluate(t1, e, r);
                    {
                        const s = (n - this.begin) / (this.end - this.begin);
                        return this.property.interpolate(a.possiblyEvaluate(t1, e, r), i, W(s));
                    }
                }
                return i;
            }
            constructor(t1, e, r, n, i){
                const a = n.delay || 0, s = n.duration || 0;
                i = i || 0, this.property = t1, this.value = e, this.begin = i + a, this.end = this.begin + s, t1.specification.transition && (n.delay || n.duration) && (this.prior = r);
            }
        }
        class Fa {
            possiblyEvaluate(t1, e, r) {
                const n = new Ua(this._properties);
                for (const i of Object.keys(this._values))n._values[i] = this._values[i].possiblyEvaluate(t1, e, r);
                return n;
            }
            hasTransition() {
                for (const t1 of Object.keys(this._values))if (this._values[t1].prior) return !0;
                return !1;
            }
            constructor(t1){
                this._properties = t1, this._values = Object.create(t1.defaultTransitioningPropertyValues);
            }
        }
        class Oa {
            getValue(t1) {
                return ht(this._values[t1].value);
            }
            setValue(t1, e) {
                this._values[t1] = new Va(this._values[t1].property, null === e ? void 0 : ht(e), this._scope, this._options), this._values[t1].expression.configDependencies && (this.configDependencies = new Set([
                    ...this.configDependencies,
                    ...this._values[t1].expression.configDependencies
                ]));
            }
            serialize() {
                const t1 = {};
                for (const e of Object.keys(this._values)){
                    const r = this.getValue(e);
                    void 0 !== r && (t1[e] = r);
                }
                return t1;
            }
            possiblyEvaluate(t1, e, r) {
                const n = new Ua(this._properties);
                for (const i of Object.keys(this._values))n._values[i] = this._values[i].possiblyEvaluate(t1, e, r);
                return n;
            }
            constructor(t1, e, r){
                this._properties = t1, this._values = Object.create(t1.defaultPropertyValues), this._scope = e, this._options = r, this.configDependencies = new Set;
            }
        }
        class Na {
            isConstant() {
                return "constant" === this.value.kind;
            }
            constantOr(t1) {
                return "constant" === this.value.kind ? this.value.value : t1;
            }
            evaluate(t1, e, r, n) {
                return this.property.evaluate(this.value, this.parameters, t1, e, r, n);
            }
            constructor(t1, e, r){
                this.property = t1, this.value = e, this.parameters = r;
            }
        }
        class Ua {
            get(t1) {
                return this._values[t1];
            }
            constructor(t1){
                this._properties = t1, this._values = Object.create(t1.defaultPossiblyEvaluatedValues);
            }
        }
        class ja {
            possiblyEvaluate(t1, e) {
                return t1.expression.evaluate(e);
            }
            interpolate(t1, e, r) {
                const n = ke[this.specification.type];
                return n ? n(t1, e, r) : t1;
            }
            constructor(t1){
                this.specification = t1;
            }
        }
        class qa {
            possiblyEvaluate(t1, e, r, n) {
                return new Na(this, "constant" === t1.expression.kind || "camera" === t1.expression.kind ? {
                    kind: "constant",
                    value: t1.expression.evaluate(e, null, {}, r, n)
                } : t1.expression, e);
            }
            interpolate(t1, e, r) {
                if ("constant" !== t1.value.kind || "constant" !== e.value.kind) return t1;
                if (void 0 === t1.value.value || void 0 === e.value.value) return new Na(this, {
                    kind: "constant",
                    value: void 0
                }, t1.parameters);
                const n = ke[this.specification.type];
                return n ? new Na(this, {
                    kind: "constant",
                    value: n(t1.value.value, e.value.value, r)
                }, t1.parameters) : t1;
            }
            evaluate(t1, e, r, n, i, a) {
                return "constant" === t1.kind ? t1.value : t1.evaluate(e, r, n, i, a);
            }
            constructor(t1, e){
                this.specification = t1, this.overrides = e;
            }
        }
        class $a {
            possiblyEvaluate(t1, e, r, n) {
                return !!t1.expression.evaluate(e, null, {}, r, n);
            }
            interpolate() {
                return !1;
            }
            constructor(t1){
                this.specification = t1;
            }
        }
        class Ga {
            constructor(t1){
                this.properties = t1, this.defaultPropertyValues = {}, this.defaultTransitionablePropertyValues = {}, this.defaultTransitioningPropertyValues = {}, this.defaultPossiblyEvaluatedValues = {}, this.overridableProperties = [];
                const e = new Ca(0, {});
                for(const r in t1){
                    const n = t1[r];
                    n.specification.overridable && this.overridableProperties.push(r);
                    const i = this.defaultPropertyValues[r] = new Va(n, void 0), a = this.defaultTransitionablePropertyValues[r] = new Da(n);
                    this.defaultTransitioningPropertyValues[r] = a.untransitioned(), this.defaultPossiblyEvaluatedValues[r] = i.possiblyEvaluate(e);
                }
            }
        }
        oa(qa, "DataDrivenProperty"), oa(ja, "DataConstantProperty"), oa($a, "ColorRampProperty");
        var Ya = JSON.parse('{"$version":8,"$root":{"version":{"required":true,"type":"enum","values":[8]},"fragment":{"type":"boolean"},"name":{"type":"string"},"metadata":{"type":"*"},"center":{"type":"array","value":"number"},"zoom":{"type":"number"},"bearing":{"type":"number","default":0,"period":360},"pitch":{"type":"number","default":0},"light":{"type":"light"},"lights":{"required":false,"type":"array","value":"light-3d"},"terrain":{"type":"terrain","optional":true},"fog":{"type":"fog"},"snow":{"type":"snow","experimental":true},"rain":{"type":"rain","experimental":true},"camera":{"type":"camera"},"color-theme":{"type":"colorTheme"},"indoor":{"type":"indoor","experimental":true},"imports":{"type":"array","value":"import"},"schema":{"type":"schema"},"sources":{"required":true,"type":"sources"},"sprite":{"type":"string"},"glyphs":{"type":"string","default":"mapbox://fonts/mapbox/{fontstack}/{range}.pbf"},"transition":{"type":"transition"},"projection":{"type":"projection"},"layers":{"required":true,"type":"array","value":"layer"},"models":{"type":"models"},"featuresets":{"experimental":true,"type":"featuresets"}},"featuresets":{"experimental":true,"*":{"type":"featureset"}},"featureset":{"experimental":true,"metadata":{"experimental":true,"type":"*"},"selectors":{"experimental":true,"type":"array","value":"selector"}},"selector":{"experimental":true,"layer":{"experimental":true,"type":"string","required":true},"properties":{"experimental":true,"type":"selectorProperty","required":false},"featureNamespace":{"experimental":true,"type":"string","required":false},"_uniqueFeatureID":{"experimental":true,"type":"boolean","private":true,"required":false}},"selectorProperty":{"experimental":true,"*":{"experimental":true,"type":"*"}},"model":{"type":"string","required":true},"import":{"id":{"type":"string","required":true},"url":{"type":"string","required":true},"config":{"type":"config"},"data":{"type":"$root"},"color-theme":{"type":"colorTheme","optional":true}},"config":{"*":{"type":"*"}},"schema":{"*":{"type":"option"}},"option":{"default":{"type":"*","property-type":"data-constant","expression":{},"required":true},"type":{"type":"enum","values":{"string":1,"number":1,"boolean":1,"color":1}},"array":{"type":"boolean"},"minValue":{"type":"number"},"maxValue":{"type":"number"},"stepValue":{"type":"number"},"values":{"type":"array","value":"*"},"metadata":{"type":"*"}},"models":{"*":{"type":"model"}},"light-3d":{"id":{"type":"string","required":true},"properties":{"type":"properties"},"type":{"type":"enum","values":{"ambient":{},"directional":{},"flat":{}}}},"properties":["properties_light_directional","properties_light_ambient","properties_light_flat"],"properties_light_directional":{"direction":{"type":"array","default":[210,30],"minimum":[0,0],"maximum":[360,90],"length":2,"value":"number","property-type":"data-constant","transition":true,"expression":{"interpolated":true,"parameters":["zoom"]}},"color":{"type":"color","property-type":"data-constant","default":"#ffffff","expression":{"interpolated":true,"parameters":["zoom"]},"transition":true},"intensity":{"type":"number","property-type":"data-constant","default":0.5,"minimum":0,"maximum":1,"expression":{"interpolated":true,"parameters":["zoom"]},"transition":true},"cast-shadows":{"type":"boolean","default":false,"property-type":"data-constant"},"shadow-quality":{"type":"number","property-type":"data-constant","default":1,"minimum":0,"maximum":1,"expression":{"parameters":["zoom"]},"experimental":true},"shadow-intensity":{"type":"number","property-type":"data-constant","default":1,"minimum":0,"maximum":1,"expression":{"interpolated":true,"parameters":["zoom"]},"transition":true}},"properties_light_ambient":{"color":{"type":"color","property-type":"data-constant","default":"#ffffff","expression":{"interpolated":true,"parameters":["zoom"]},"transition":true},"intensity":{"type":"number","property-type":"data-constant","default":0.5,"minimum":0,"maximum":1,"expression":{"interpolated":true,"parameters":["zoom"]},"transition":true}},"properties_light_flat":{"anchor":{"type":"enum","default":"viewport","values":{"map":1,"viewport":1},"property-type":"data-constant","expression":{"parameters":["zoom"]}},"position":{"type":"array","default":[1.15,210,30],"length":3,"value":"number","property-type":"data-constant","transition":true,"expression":{"interpolated":true,"parameters":["zoom"]}},"color":{"type":"color","property-type":"data-constant","default":"#ffffff","expression":{"interpolated":true,"parameters":["zoom"]},"transition":true},"intensity":{"type":"number","property-type":"data-constant","default":0.5,"minimum":0,"maximum":1,"expression":{"interpolated":true,"parameters":["zoom"]},"transition":true}},"sources":{"*":{"type":"source"}},"source":["source_vector","source_raster","source_raster_dem","source_raster_array","source_geojson","source_video","source_image","source_model"],"source_vector":{"type":{"required":true,"type":"enum","values":{"vector":1}},"url":{"type":"string"},"tiles":{"type":"array","value":"string"},"bounds":{"type":"array","value":"number","length":4,"default":[-180,-85.051129,180,85.051129]},"scheme":{"type":"enum","values":{"xyz":1,"tms":1},"default":"xyz"},"minzoom":{"type":"number","default":0},"maxzoom":{"type":"number","default":22},"attribution":{"type":"string"},"promoteId":{"type":"promoteId"},"volatile":{"type":"boolean","default":false},"*":{"type":"*"}},"source_raster":{"type":{"required":true,"type":"enum","values":{"raster":1}},"url":{"type":"string"},"tiles":{"type":"array","value":"string"},"bounds":{"type":"array","value":"number","length":4,"default":[-180,-85.051129,180,85.051129]},"minzoom":{"type":"number","default":0},"maxzoom":{"type":"number","default":22},"tileSize":{"type":"number","default":512},"scheme":{"type":"enum","values":{"xyz":1,"tms":1},"default":"xyz"},"attribution":{"type":"string"},"volatile":{"type":"boolean","default":false},"*":{"type":"*"}},"source_raster_dem":{"type":{"required":true,"type":"enum","values":{"raster-dem":1}},"url":{"type":"string"},"tiles":{"type":"array","value":"string"},"bounds":{"type":"array","value":"number","length":4,"default":[-180,-85.051129,180,85.051129]},"minzoom":{"type":"number","default":0},"maxzoom":{"type":"number","default":22},"tileSize":{"type":"number","default":512},"attribution":{"type":"string"},"encoding":{"type":"enum","values":{"terrarium":1,"mapbox":1},"default":"mapbox"},"volatile":{"type":"boolean","default":false},"*":{"type":"*"}},"source_raster_array":{"experimental":true,"type":{"required":true,"type":"enum","values":{"raster-array":1}},"url":{"type":"string"},"tiles":{"type":"array","value":"string"},"bounds":{"type":"array","value":"number","length":4,"default":[-180,-85.051129,180,85.051129]},"minzoom":{"type":"number","default":0},"maxzoom":{"type":"number","default":22},"tileSize":{"type":"number","default":512},"attribution":{"type":"string"},"rasterLayers":{"type":"*"},"volatile":{"type":"boolean","default":false},"*":{"type":"*"}},"source_geojson":{"type":{"required":true,"type":"enum","values":{"geojson":1}},"data":{"type":"*"},"maxzoom":{"type":"number","default":18},"minzoom":{"type":"number","default":0},"attribution":{"type":"string"},"buffer":{"type":"number","default":128,"maximum":512,"minimum":0},"filter":{"type":"*"},"tolerance":{"type":"number","default":0.375},"cluster":{"type":"boolean","default":false},"clusterRadius":{"type":"number","default":50,"minimum":0},"clusterMaxZoom":{"type":"number"},"clusterMinPoints":{"type":"number"},"clusterProperties":{"type":"*"},"lineMetrics":{"type":"boolean","default":false},"generateId":{"type":"boolean","default":false},"promoteId":{"type":"promoteId"},"dynamic":{"type":"boolean","default":false}},"source_video":{"type":{"required":true,"type":"enum","values":{"video":1}},"urls":{"required":true,"type":"array","value":"string"},"coordinates":{"required":true,"type":"array","length":4,"value":{"type":"array","length":2,"value":"number"}}},"source_image":{"type":{"required":true,"type":"enum","values":{"image":1}},"url":{"required":false,"type":"string"},"coordinates":{"required":true,"type":"array","length":4,"value":{"type":"array","length":2,"value":"number"}}},"source_model":{"type":{"required":true,"type":"enum","values":{"model":1,"batched-model":1}},"maxzoom":{"type":"number","default":18},"minzoom":{"type":"number","default":0},"tiles":{"type":"array","value":"string"}},"layer":{"id":{"type":"string","required":true},"type":{"type":"enum","values":{"fill":{},"line":{},"symbol":{},"circle":{},"heatmap":{},"fill-extrusion":{},"raster":{},"raster-particle":{"experimental":true},"hillshade":{},"model":{"experimental":true},"background":{},"sky":{},"slot":{},"clip":{}},"required":true},"metadata":{"type":"*"},"source":{"type":"string"},"source-layer":{"type":"string"},"slot":{"type":"string"},"minzoom":{"type":"number","minimum":0,"maximum":24},"maxzoom":{"type":"number","minimum":0,"maximum":24},"filter":{"type":"filter"},"layout":{"type":"layout"},"paint":{"type":"paint"}},"layout":["layout_clip","layout_fill","layout_line","layout_circle","layout_heatmap","layout_fill-extrusion","layout_symbol","layout_raster","layout_raster-particle","layout_hillshade","layout_background","layout_sky","layout_model"],"layout_background":{"visibility":{"type":"enum","values":{"visible":1,"none":1},"default":"visible","expression":{},"property-type":"constant"}},"layout_sky":{"visibility":{"type":"enum","values":{"visible":1,"none":1},"default":"visible","expression":{},"property-type":"constant"}},"layout_model":{"visibility":{"type":"enum","values":{"visible":1,"none":1},"default":"visible","expression":{},"property-type":"constant"},"model-id":{"type":"string","default":"","property-type":"data-driven","expression":{"parameters":["zoom","feature"]}}},"layout_clip":{"clip-layer-types":{"type":"array","value":"enum","values":{"model":1,"symbol":1},"default":[],"expression":{},"property-type":"data-constant"},"clip-layer-scope":{"type":"array","value":"string","default":[],"expression":{},"property-type":"data-constant"}},"layout_fill":{"fill-sort-key":{"type":"number","expression":{"parameters":["zoom","feature"]},"property-type":"data-driven"},"visibility":{"type":"enum","values":{"visible":1,"none":1},"default":"visible","expression":{},"property-type":"constant"},"fill-elevation-reference":{"type":"enum","values":{"none":1,"hd-road-base":1,"hd-road-markup":1},"default":"none","experimental":true,"private":true,"expression":{},"property-type":"data-constant"}},"layout_circle":{"circle-sort-key":{"type":"number","expression":{"parameters":["zoom","feature"]},"property-type":"data-driven"},"circle-elevation-reference":{"type":"enum","values":{"none":1,"hd-road-markup":1},"default":"none","experimental":true,"expression":{},"property-type":"data-constant"},"visibility":{"type":"enum","values":{"visible":1,"none":1},"default":"visible","expression":{},"property-type":"constant"}},"layout_heatmap":{"visibility":{"type":"enum","values":{"visible":1,"none":1},"default":"visible","expression":{},"property-type":"constant"}},"layout_fill-extrusion":{"visibility":{"type":"enum","values":{"visible":1,"none":1},"default":"visible","expression":{},"property-type":"constant"},"fill-extrusion-edge-radius":{"type":"number","experimental":true,"default":0,"minimum":0,"maximum":1,"expression":{},"property-type":"constant"}},"layout_line":{"line-cap":{"type":"enum","values":{"butt":1,"round":1,"square":1},"default":"butt","expression":{"parameters":["zoom","feature"]},"property-type":"data-driven"},"line-join":{"type":"enum","values":{"bevel":1,"round":1,"miter":1,"none":1},"default":"miter","expression":{"parameters":["zoom","feature"]},"property-type":"data-driven"},"line-miter-limit":{"type":"number","default":2,"expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"},"line-round-limit":{"type":"number","default":1.05,"expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"},"line-sort-key":{"type":"number","expression":{"parameters":["zoom","feature"]},"property-type":"data-driven"},"line-z-offset":{"type":"number","experimental":true,"default":0,"expression":{"parameters":["zoom","feature","line-progress"]},"property-type":"data-driven"},"line-elevation-reference":{"type":"enum","values":{"none":1,"sea":1,"ground":1,"hd-road-markup":1},"default":"none","experimental":true,"expression":{},"property-type":"data-constant"},"line-cross-slope":{"type":"number","experimental":true,"expression":{},"property-type":"constant"},"visibility":{"type":"enum","values":{"visible":1,"none":1},"default":"visible","expression":{},"property-type":"constant"},"line-width-unit":{"type":"enum","values":{"pixels":1,"meters":1},"default":"pixels","experimental":true,"private":true,"expression":{"parameters":["zoom"]},"property-type":"data-constant"}},"layout_symbol":{"symbol-placement":{"type":"enum","values":{"point":1,"line":1,"line-center":1},"default":"point","expression":{"parameters":["zoom"]},"property-type":"data-constant"},"symbol-spacing":{"type":"number","default":250,"minimum":1,"expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"},"symbol-avoid-edges":{"type":"boolean","default":false,"expression":{"parameters":["zoom"]},"property-type":"data-constant"},"symbol-sort-key":{"type":"number","expression":{"parameters":["zoom","feature"]},"property-type":"data-driven"},"symbol-z-order":{"type":"enum","values":{"auto":1,"viewport-y":1,"source":1},"default":"auto","expression":{"parameters":["zoom"]},"property-type":"data-constant"},"symbol-z-elevate":{"type":"boolean","default":false,"expression":{"parameters":["zoom"]},"property-type":"data-constant"},"symbol-elevation-reference":{"type":"enum","values":{"sea":1,"ground":1,"hd-road-markup":1},"default":"ground","experimental":true,"expression":{"parameters":["zoom"]},"property-type":"data-constant"},"icon-allow-overlap":{"type":"boolean","default":false,"expression":{"parameters":["zoom"]},"property-type":"data-constant"},"icon-ignore-placement":{"type":"boolean","default":false,"expression":{"parameters":["zoom"]},"property-type":"data-constant"},"icon-optional":{"type":"boolean","default":false,"expression":{"parameters":["zoom"]},"property-type":"data-constant"},"icon-rotation-alignment":{"type":"enum","values":{"map":1,"viewport":1,"auto":1},"default":"auto","expression":{"parameters":["zoom"]},"property-type":"data-constant"},"icon-size":{"type":"number","default":1,"minimum":0,"expression":{"interpolated":true,"parameters":["zoom","feature"]},"property-type":"data-driven"},"icon-size-scale-range":{"type":"array","value":"number","length":2,"default":[0.8,2],"minimum":0.1,"maximum":10,"experimental":true,"private":true,"expression":{},"property-type":"data-constant"},"icon-text-fit":{"type":"enum","values":{"none":1,"width":1,"height":1,"both":1},"default":"none","expression":{"parameters":["zoom","feature"]},"property-type":"data-driven"},"icon-text-fit-padding":{"type":"array","value":"number","length":4,"default":[0,0,0,0],"expression":{"interpolated":true,"parameters":["zoom","feature"]},"property-type":"data-driven"},"icon-image":{"type":"resolvedImage","tokens":true,"expression":{"parameters":["zoom","feature"]},"property-type":"data-driven"},"icon-rotate":{"type":"number","default":0,"period":360,"expression":{"interpolated":true,"parameters":["zoom","feature"]},"property-type":"data-driven"},"icon-padding":{"type":"number","default":2,"minimum":0,"expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"},"icon-keep-upright":{"type":"boolean","default":false,"expression":{"parameters":["zoom"]},"property-type":"data-constant"},"icon-offset":{"type":"array","value":"number","length":2,"default":[0,0],"expression":{"interpolated":true,"parameters":["zoom","feature"]},"property-type":"data-driven"},"icon-anchor":{"type":"enum","values":{"center":1,"left":1,"right":1,"top":1,"bottom":1,"top-left":1,"top-right":1,"bottom-left":1,"bottom-right":1},"default":"center","expression":{"parameters":["zoom","feature"]},"property-type":"data-driven"},"icon-pitch-alignment":{"type":"enum","values":{"map":1,"viewport":1,"auto":1},"default":"auto","expression":{"parameters":["zoom"]},"property-type":"data-constant"},"text-pitch-alignment":{"type":"enum","values":{"map":1,"viewport":1,"auto":1},"default":"auto","expression":{"parameters":["zoom"]},"property-type":"data-constant"},"text-rotation-alignment":{"type":"enum","values":{"map":1,"viewport":1,"auto":1},"default":"auto","expression":{"parameters":["zoom"]},"property-type":"data-constant"},"text-field":{"type":"formatted","default":"","tokens":true,"expression":{"parameters":["zoom","feature"]},"property-type":"data-driven"},"text-font":{"type":"array","value":"string","default":["Open Sans Regular","Arial Unicode MS Regular"],"expression":{"parameters":["zoom","feature"]},"property-type":"data-driven"},"text-size":{"type":"number","default":16,"minimum":0,"expression":{"interpolated":true,"parameters":["zoom","feature"]},"property-type":"data-driven"},"text-size-scale-range":{"type":"array","value":"number","length":2,"default":[0.8,2],"minimum":0.1,"maximum":10,"experimental":true,"private":true,"expression":{},"property-type":"data-constant"},"text-max-width":{"type":"number","default":10,"minimum":0,"expression":{"interpolated":true,"parameters":["zoom","feature"]},"property-type":"data-driven"},"text-line-height":{"type":"number","default":1.2,"expression":{"interpolated":true,"parameters":["zoom","feature"]},"property-type":"data-driven"},"text-letter-spacing":{"type":"number","default":0,"expression":{"interpolated":true,"parameters":["zoom","feature"]},"property-type":"data-driven"},"text-justify":{"type":"enum","values":{"auto":1,"left":1,"center":1,"right":1},"default":"center","expression":{"parameters":["zoom","feature"]},"property-type":"data-driven"},"text-radial-offset":{"type":"number","default":0,"property-type":"data-driven","expression":{"interpolated":true,"parameters":["zoom","feature"]}},"text-variable-anchor":{"type":"array","value":"enum","values":{"center":1,"left":1,"right":1,"top":1,"bottom":1,"top-left":1,"top-right":1,"bottom-left":1,"bottom-right":1},"expression":{"parameters":["zoom"]},"property-type":"data-constant"},"text-anchor":{"type":"enum","values":{"center":1,"left":1,"right":1,"top":1,"bottom":1,"top-left":1,"top-right":1,"bottom-left":1,"bottom-right":1},"default":"center","expression":{"parameters":["zoom","feature"]},"property-type":"data-driven"},"text-max-angle":{"type":"number","default":45,"expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"},"text-writing-mode":{"type":"array","value":"enum","values":{"horizontal":1,"vertical":1},"expression":{"parameters":["zoom"]},"property-type":"data-constant"},"text-rotate":{"type":"number","default":0,"period":360,"expression":{"interpolated":true,"parameters":["zoom","feature"]},"property-type":"data-driven"},"text-padding":{"type":"number","default":2,"minimum":0,"expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"},"text-keep-upright":{"type":"boolean","default":true,"expression":{"parameters":["zoom"]},"property-type":"data-constant"},"text-transform":{"type":"enum","values":{"none":1,"uppercase":1,"lowercase":1},"default":"none","expression":{"parameters":["zoom","feature"]},"property-type":"data-driven"},"text-offset":{"type":"array","value":"number","length":2,"default":[0,0],"expression":{"interpolated":true,"parameters":["zoom","feature"]},"property-type":"data-driven"},"text-allow-overlap":{"type":"boolean","default":false,"expression":{"parameters":["zoom"]},"property-type":"data-constant"},"text-ignore-placement":{"type":"boolean","default":false,"expression":{"parameters":["zoom"]},"property-type":"data-constant"},"text-optional":{"type":"boolean","default":false,"expression":{"parameters":["zoom"]},"property-type":"data-constant"},"visibility":{"type":"enum","values":{"visible":1,"none":1},"default":"visible","expression":{},"property-type":"constant"}},"layout_raster":{"visibility":{"type":"enum","values":{"visible":1,"none":1},"default":"visible","expression":{},"property-type":"constant"}},"layout_raster-particle":{"visibility":{"type":"enum","values":{"visible":1,"none":1},"default":"visible","expression":{},"property-type":"constant"}},"layout_hillshade":{"visibility":{"type":"enum","values":{"visible":1,"none":1},"default":"visible","expression":{},"property-type":"constant"}},"filter":{"type":"array","value":"*"},"filter_symbol":{"type":"boolean","default":false,"property-type":"data-driven","expression":{"parameters":["zoom","feature","pitch","distance-from-center"]}},"filter_fill":{"type":"boolean","default":false,"property-type":"data-driven","expression":{"parameters":["zoom","feature"]}},"filter_hillshade":{"type":"boolean","default":false,"property-type":"data-driven","expression":{"parameters":["zoom","feature"]}},"filter_raster":{"type":"boolean","default":false,"property-type":"data-driven","expression":{"parameters":["zoom","feature"]}},"filter_raster-particle":{"type":"boolean","default":false,"property-type":"data-driven","expression":{"parameters":["zoom","feature"]}},"filter_clip":{"type":"boolean","default":false,"property-type":"data-driven","expression":{"parameters":["zoom","feature"]}},"filter_model":{"type":"boolean","default":false,"property-type":"data-driven","expression":{"parameters":["zoom","feature"]}},"filter_line":{"type":"boolean","default":false,"property-type":"data-driven","expression":{"parameters":["zoom","feature"]}},"filter_circle":{"type":"boolean","default":false,"property-type":"data-driven","expression":{"parameters":["zoom","feature"]}},"filter_fill-extrusion":{"type":"boolean","default":false,"property-type":"data-driven","expression":{"parameters":["zoom","feature"]}},"filter_heatmap":{"type":"boolean","default":false,"property-type":"data-driven","expression":{"parameters":["zoom","feature"]}},"filter_operator":{"type":"enum","values":{"==":1,"!=":1,">":1,">=":1,"<":1,"<=":1,"in":1,"!in":1,"all":1,"any":1,"none":1,"has":1,"!has":1}},"geometry_type":{"type":"enum","values":{"Point":1,"LineString":1,"Polygon":1}},"function":{"expression":{"type":"expression"},"stops":{"type":"array","value":"function_stop"},"base":{"type":"number","default":1,"minimum":0},"property":{"type":"string","default":"$zoom"},"type":{"type":"enum","values":{"identity":1,"exponential":1,"interval":1,"categorical":1},"default":"exponential"},"colorSpace":{"type":"enum","values":{"rgb":1,"lab":1,"hcl":1},"default":"rgb"},"default":{"type":"*","required":false}},"function_stop":{"type":"array","minimum":0,"maximum":24,"value":["number","color"],"length":2},"expression":{"type":"array","value":"*","minimum":1},"fog":{"range":{"type":"array","default":[0.5,10],"minimum":-20,"maximum":20,"length":2,"value":"number","property-type":"data-constant","transition":true,"expression":{"interpolated":true,"parameters":["zoom","measure-light"],"relaxZoomRestriction":true}},"color":{"type":"color","property-type":"data-constant","default":"#ffffff","expression":{"interpolated":true,"parameters":["zoom","measure-light"],"relaxZoomRestriction":true},"transition":true},"high-color":{"type":"color","property-type":"data-constant","default":"#245cdf","expression":{"interpolated":true,"parameters":["zoom","measure-light"],"relaxZoomRestriction":true},"transition":true},"space-color":{"type":"color","property-type":"data-constant","default":["interpolate",["linear"],["zoom"],4,"#010b19",7,"#367ab9"],"expression":{"interpolated":true,"parameters":["zoom","measure-light"],"relaxZoomRestriction":true},"transition":true},"horizon-blend":{"type":"number","property-type":"data-constant","default":["interpolate",["linear"],["zoom"],4,0.2,7,0.1],"minimum":0,"maximum":1,"expression":{"interpolated":true,"parameters":["zoom","measure-light"],"relaxZoomRestriction":true},"transition":true},"star-intensity":{"type":"number","property-type":"data-constant","default":["interpolate",["linear"],["zoom"],5,0.35,6,0],"minimum":0,"maximum":1,"expression":{"interpolated":true,"parameters":["zoom","measure-light"],"relaxZoomRestriction":true},"transition":true},"vertical-range":{"type":"array","default":[0,0],"minimum":0,"length":2,"value":"number","property-type":"data-constant","transition":true,"expression":{"interpolated":true,"parameters":["zoom","measure-light"],"relaxZoomRestriction":true}}},"snow":{"density":{"type":"number","property-type":"data-constant","default":["interpolate",["linear"],["zoom"],11,0,13,0.85],"minimum":0,"maximum":1,"experimental":true,"expression":{"interpolated":true,"parameters":["zoom","measure-light"],"relaxZoomRestriction":true},"transition":true},"intensity":{"type":"number","property-type":"data-constant","default":1,"minimum":0,"maximum":1,"experimental":true,"expression":{"interpolated":true,"parameters":["zoom","measure-light"],"relaxZoomRestriction":true},"transition":true},"color":{"type":"color","property-type":"data-constant","default":"#ffffff","experimental":true,"expression":{"interpolated":true,"parameters":["zoom","measure-light"],"relaxZoomRestriction":true},"transition":true},"opacity":{"type":"number","property-type":"data-constant","default":1,"minimum":0,"maximum":1,"experimental":true,"expression":{"interpolated":true,"parameters":["zoom","measure-light"],"relaxZoomRestriction":true},"transition":true},"vignette":{"type":"number","property-type":"data-constant","default":["interpolate",["linear"],["zoom"],11,0,13,0.3],"minimum":0,"maximum":1,"experimental":true,"expression":{"interpolated":true,"parameters":["zoom","measure-light"],"relaxZoomRestriction":true},"transition":true},"vignette-color":{"type":"color","property-type":"data-constant","default":"#ffffff","experimental":true,"expression":{"interpolated":true,"parameters":["zoom","measure-light"],"relaxZoomRestriction":true},"transition":true},"center-thinning":{"type":"number","property-type":"data-constant","default":0.4,"minimum":0,"maximum":1,"experimental":true,"expression":{"interpolated":true,"parameters":["zoom","measure-light"],"relaxZoomRestriction":true},"transition":true},"direction":{"type":"array","default":[0,50],"minimum":0,"maximum":360,"length":2,"value":"number","property-type":"data-constant","transition":true,"experimental":true,"expression":{"interpolated":true,"parameters":["zoom","measure-light"],"relaxZoomRestriction":true}},"flake-size":{"type":"number","property-type":"data-constant","default":0.71,"minimum":0,"maximum":5,"experimental":true,"expression":{"interpolated":true,"parameters":["zoom","measure-light"],"relaxZoomRestriction":true},"transition":true}},"rain":{"density":{"type":"number","property-type":"data-constant","default":["interpolate",["linear"],["zoom"],11,0,13,0.5],"minimum":0,"maximum":1,"experimental":true,"expression":{"interpolated":true,"parameters":["zoom","measure-light"],"relaxZoomRestriction":true},"transition":true},"intensity":{"type":"number","property-type":"data-constant","default":1,"minimum":0,"maximum":1,"experimental":true,"expression":{"interpolated":true,"parameters":["zoom","measure-light"],"relaxZoomRestriction":true},"transition":true},"color":{"type":"color","property-type":"data-constant","default":["interpolate",["linear"],["measure-light","brightness"],0,"#03113d",0.3,"#a8adbc"],"experimental":true,"expression":{"interpolated":true,"parameters":["zoom","measure-light"],"relaxZoomRestriction":true},"transition":true},"opacity":{"type":"number","property-type":"data-constant","default":["interpolate",["linear"],["measure-light","brightness"],0,0.88,1,0.7],"minimum":0,"maximum":1,"experimental":true,"expression":{"interpolated":true,"parameters":["zoom","measure-light"],"relaxZoomRestriction":true},"transition":true},"vignette":{"type":"number","property-type":"data-constant","default":["interpolate",["linear"],["zoom"],11,0,13,1],"minimum":0,"maximum":1,"experimental":true,"expression":{"interpolated":true,"parameters":["zoom","measure-light"],"relaxZoomRestriction":true},"transition":true},"vignette-color":{"type":"color","property-type":"data-constant","default":["interpolate",["linear"],["measure-light","brightness"],0,"#001736",0.3,"#464646"],"experimental":true,"expression":{"interpolated":true,"parameters":["zoom","measure-light"],"relaxZoomRestriction":true},"transition":true},"center-thinning":{"type":"number","property-type":"data-constant","default":0.57,"minimum":0,"maximum":1,"experimental":true,"expression":{"interpolated":true,"parameters":["zoom","measure-light"],"relaxZoomRestriction":true},"transition":true},"direction":{"type":"array","default":[0,80],"minimum":0,"maximum":360,"length":2,"value":"number","property-type":"data-constant","transition":true,"experimental":true,"expression":{"interpolated":true,"parameters":["zoom","measure-light"],"relaxZoomRestriction":true}},"droplet-size":{"type":"array","default":[2.6,18.2],"minimum":0,"maximum":50,"length":2,"value":"number","property-type":"data-constant","transition":true,"experimental":true,"expression":{"interpolated":true,"parameters":["zoom","measure-light"],"relaxZoomRestriction":true}},"distortion-strength":{"type":"number","property-type":"data-constant","default":0.7,"minimum":0,"maximum":1,"experimental":true,"expression":{"interpolated":true,"parameters":["zoom","measure-light"],"relaxZoomRestriction":true},"transition":true}},"camera":{"camera-projection":{"type":"enum","values":{"perspective":1,"orthographic":1},"transition":true,"expression":{"interpolated":true,"parameters":["zoom"]},"default":"perspective","property-type":"data-constant"}},"colorTheme":{"data":{"type":"string","property-type":"data-constant","expression":{}}},"indoor":{"floorplanFeaturesetId":{"type":"string","experimental":true,"property-type":"data-constant","expression":{}},"buildingFeaturesetId":{"type":"string","experimental":true,"property-type":"data-constant","expression":{}}},"light":{"anchor":{"type":"enum","default":"viewport","values":{"map":1,"viewport":1},"property-type":"data-constant","expression":{"parameters":["zoom"]}},"position":{"type":"array","default":[1.15,210,30],"length":3,"value":"number","property-type":"data-constant","transition":true,"expression":{"interpolated":true,"parameters":["zoom"]}},"color":{"type":"color","property-type":"data-constant","default":"#ffffff","expression":{"interpolated":true,"parameters":["zoom"]},"transition":true},"intensity":{"type":"number","property-type":"data-constant","default":0.5,"minimum":0,"maximum":1,"expression":{"interpolated":true,"parameters":["zoom"]},"transition":true}},"projection":{"name":{"type":"enum","values":{"albers":1,"equalEarth":1,"equirectangular":1,"lambertConformalConic":1,"mercator":1,"naturalEarth":1,"winkelTripel":1,"globe":1},"default":"mercator","required":true},"center":{"type":"array","length":2,"value":"number","property-type":"data-constant","minimum":[-180,-90],"maximum":[180,90]},"parallels":{"type":"array","length":2,"value":"number","property-type":"data-constant","minimum":[-90,-90],"maximum":[90,90]}},"terrain":{"source":{"type":"string","required":true},"exaggeration":{"type":"number","property-type":"data-constant","default":1,"minimum":0,"maximum":1000,"expression":{"interpolated":true,"parameters":["zoom"]},"transition":true}},"paint":["paint_fill","paint_line","paint_circle","paint_heatmap","paint_fill-extrusion","paint_symbol","paint_raster","paint_raster-particle","paint_hillshade","paint_background","paint_sky","paint_model"],"paint_fill":{"fill-antialias":{"type":"boolean","default":true,"expression":{"parameters":["zoom"]},"property-type":"data-constant"},"fill-opacity":{"type":"number","default":1,"minimum":0,"maximum":1,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state","measure-light"]},"property-type":"data-driven"},"fill-color":{"type":"color","default":"#000000","transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state","measure-light"]},"property-type":"data-driven"},"fill-outline-color":{"type":"color","transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state","measure-light"]},"property-type":"data-driven"},"fill-translate":{"type":"array","value":"number","length":2,"default":[0,0],"transition":true,"expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"},"fill-translate-anchor":{"type":"enum","values":{"map":1,"viewport":1},"default":"map","expression":{"parameters":["zoom"]},"property-type":"data-constant"},"fill-pattern":{"type":"resolvedImage","expression":{"parameters":["zoom","feature"]},"property-type":"data-driven"},"fill-emissive-strength":{"type":"number","default":0,"minimum":0,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","measure-light"]},"property-type":"data-constant"},"fill-z-offset":{"type":"number","default":0,"minimum":0,"transition":true,"experimental":true,"expression":{"interpolated":true,"parameters":["zoom","feature"]},"property-type":"data-driven"}},"paint_fill-extrusion":{"fill-extrusion-opacity":{"type":"number","default":1,"minimum":0,"maximum":1,"transition":true,"expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"},"fill-extrusion-color":{"type":"color","default":"#000000","transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state","measure-light"]},"property-type":"data-driven"},"fill-extrusion-translate":{"type":"array","value":"number","length":2,"default":[0,0],"transition":true,"expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"},"fill-extrusion-translate-anchor":{"type":"enum","values":{"map":1,"viewport":1},"default":"map","expression":{"parameters":["zoom"]},"property-type":"data-constant"},"fill-extrusion-pattern":{"type":"resolvedImage","expression":{"parameters":["zoom","feature"]},"property-type":"data-driven"},"fill-extrusion-height":{"type":"number","default":0,"minimum":0,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state"]},"property-type":"data-driven"},"fill-extrusion-base":{"type":"number","default":0,"minimum":0,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state"]},"property-type":"data-driven"},"fill-extrusion-height-alignment":{"type":"enum","experimental":true,"values":{"terrain":1,"flat":1},"default":"flat","property-type":"data-constant"},"fill-extrusion-base-alignment":{"type":"enum","experimental":true,"values":{"terrain":1,"flat":1},"default":"terrain","property-type":"data-constant"},"fill-extrusion-vertical-gradient":{"type":"boolean","default":true,"expression":{"parameters":["zoom"]},"property-type":"data-constant"},"fill-extrusion-ambient-occlusion-intensity":{"property-type":"data-constant","type":"number","default":0,"minimum":0,"maximum":1,"expression":{"interpolated":true,"parameters":["zoom"]},"transition":true},"fill-extrusion-ambient-occlusion-radius":{"property-type":"data-constant","type":"number","default":3,"minimum":0,"expression":{"interpolated":true,"parameters":["zoom"]},"transition":true},"fill-extrusion-ambient-occlusion-wall-radius":{"property-type":"data-constant","type":"number","experimental":true,"default":3,"minimum":0,"expression":{"interpolated":true,"parameters":["zoom"]},"transition":true},"fill-extrusion-ambient-occlusion-ground-radius":{"property-type":"data-constant","type":"number","experimental":true,"default":3,"minimum":0,"expression":{"interpolated":true,"parameters":["zoom"]},"transition":true},"fill-extrusion-ambient-occlusion-ground-attenuation":{"property-type":"data-constant","type":"number","experimental":true,"default":0.69,"minimum":0,"maximum":1,"transition":true,"expression":{"interpolated":true,"parameters":["zoom"]}},"fill-extrusion-flood-light-color":{"property-type":"data-constant","type":"color","experimental":true,"default":"#ffffff","transition":true,"expression":{"interpolated":true,"parameters":["zoom","measure-light"]}},"fill-extrusion-flood-light-intensity":{"property-type":"data-constant","type":"number","experimental":true,"default":0,"minimum":0,"maximum":1,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","measure-light"]}},"fill-extrusion-flood-light-wall-radius":{"property-type":"data-driven","type":"number","experimental":true,"default":0,"minimum":0,"transition":true,"expression":{"interpolated":true,"parameters":["feature","feature-state"]}},"fill-extrusion-flood-light-ground-radius":{"property-type":"data-driven","type":"number","experimental":true,"default":0,"transition":true,"expression":{"interpolated":true,"parameters":["feature","feature-state"]}},"fill-extrusion-flood-light-ground-attenuation":{"property-type":"data-constant","type":"number","experimental":true,"default":0.69,"minimum":0,"maximum":1,"transition":true,"expression":{"interpolated":true,"parameters":["zoom"]}},"fill-extrusion-vertical-scale":{"property-type":"data-constant","type":"number","experimental":true,"default":1,"minimum":0,"transition":true,"expression":{"interpolated":true,"parameters":["zoom"]}},"fill-extrusion-rounded-roof":{"property-type":"data-constant","type":"boolean","default":true,"experimental":true,"expression":{"parameters":["zoom"]}},"fill-extrusion-cutoff-fade-range":{"type":"number","default":0,"minimum":0,"maximum":1,"expression":{},"property-type":"data-constant"},"fill-extrusion-emissive-strength":{"type":"number","default":0,"minimum":0,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","measure-light","feature-state"]},"property-type":"data-driven"},"fill-extrusion-line-width":{"type":"number","default":0,"minimum":0,"transition":true,"experimental":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state","measure-light"]},"property-type":"data-driven"},"fill-extrusion-cast-shadows":{"type":"boolean","default":true,"property-type":"data-constant"}},"paint_line":{"line-opacity":{"type":"number","default":1,"minimum":0,"maximum":1,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state","measure-light"]},"property-type":"data-driven"},"line-color":{"type":"color","default":"#000000","transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state","measure-light"]},"property-type":"data-driven"},"line-translate":{"type":"array","value":"number","length":2,"default":[0,0],"transition":true,"expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"},"line-translate-anchor":{"type":"enum","values":{"map":1,"viewport":1},"default":"map","expression":{"parameters":["zoom"]},"property-type":"data-constant"},"line-width":{"type":"number","default":1,"minimum":0,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state","measure-light","line-progress"]},"property-type":"data-driven"},"line-gap-width":{"type":"number","default":0,"minimum":0,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state","measure-light"]},"property-type":"data-driven"},"line-offset":{"type":"number","default":0,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state","measure-light"]},"property-type":"data-driven"},"line-blur":{"type":"number","default":0,"minimum":0,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state","measure-light"]},"property-type":"data-driven"},"line-dasharray":{"type":"array","value":"number","minimum":0,"expression":{"parameters":["zoom","feature"]},"property-type":"data-driven"},"line-pattern":{"type":"resolvedImage","expression":{"parameters":["zoom","feature"]},"property-type":"data-driven"},"line-gradient":{"type":"color","expression":{"interpolated":true,"parameters":["line-progress"]},"property-type":"color-ramp"},"line-trim-offset":{"type":"array","value":"number","length":2,"default":[0,0],"minimum":[0,0],"maximum":[1,1],"property-type":"constant"},"line-trim-fade-range":{"type":"array","value":"number","experimental":true,"length":2,"default":[0,0],"minimum":[0,0],"maximum":[1,1],"expression":{"interpolated":true,"parameters":["zoom","measure-light"]},"property-type":"data-constant"},"line-trim-color":{"type":"color","experimental":true,"default":"transparent","transition":true,"expression":{"interpolated":true,"parameters":["zoom","measure-light"]},"property-type":"data-constant"},"line-emissive-strength":{"type":"number","default":0,"minimum":0,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","measure-light"]},"property-type":"data-constant"},"line-border-width":{"type":"number","private":true,"default":0,"minimum":0,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state"]},"property-type":"data-driven"},"line-border-color":{"type":"color","private":true,"default":"rgba(0, 0, 0, 0)","transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state"]},"property-type":"data-driven"},"line-occlusion-opacity":{"type":"number","default":0,"minimum":0,"maximum":1,"expression":{"interpolated":true,"parameters":["zoom"]},"transition":true,"property-type":"data-constant"}},"paint_circle":{"circle-radius":{"type":"number","default":5,"minimum":0,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state","measure-light"]},"property-type":"data-driven"},"circle-color":{"type":"color","default":"#000000","transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state","measure-light"]},"property-type":"data-driven"},"circle-blur":{"type":"number","default":0,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state","measure-light"]},"property-type":"data-driven"},"circle-opacity":{"type":"number","default":1,"minimum":0,"maximum":1,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state","measure-light"]},"property-type":"data-driven"},"circle-translate":{"type":"array","value":"number","length":2,"default":[0,0],"transition":true,"expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"},"circle-translate-anchor":{"type":"enum","values":{"map":1,"viewport":1},"default":"map","expression":{"parameters":["zoom"]},"property-type":"data-constant"},"circle-pitch-scale":{"type":"enum","values":{"map":1,"viewport":1},"default":"map","expression":{"parameters":["zoom"]},"property-type":"data-constant"},"circle-pitch-alignment":{"type":"enum","values":{"map":1,"viewport":1},"default":"viewport","expression":{"parameters":["zoom"]},"property-type":"data-constant"},"circle-stroke-width":{"type":"number","default":0,"minimum":0,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state","measure-light"]},"property-type":"data-driven"},"circle-stroke-color":{"type":"color","default":"#000000","transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state","measure-light"]},"property-type":"data-driven"},"circle-stroke-opacity":{"type":"number","default":1,"minimum":0,"maximum":1,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state","measure-light"]},"property-type":"data-driven"},"circle-emissive-strength":{"type":"number","default":0,"minimum":0,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","measure-light"]},"property-type":"data-constant"}},"paint_heatmap":{"heatmap-radius":{"type":"number","default":30,"minimum":1,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state","measure-light"]},"property-type":"data-driven"},"heatmap-weight":{"type":"number","default":1,"minimum":0,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state","measure-light"]},"property-type":"data-driven"},"heatmap-intensity":{"type":"number","default":1,"minimum":0,"transition":true,"expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"},"heatmap-color":{"type":"color","default":["interpolate",["linear"],["heatmap-density"],0,"rgba(0, 0, 255, 0)",0.1,"royalblue",0.3,"cyan",0.5,"lime",0.7,"yellow",1,"red"],"expression":{"interpolated":true,"parameters":["heatmap-density"]},"property-type":"color-ramp"},"heatmap-opacity":{"type":"number","default":1,"minimum":0,"maximum":1,"transition":true,"expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"}},"paint_symbol":{"icon-opacity":{"type":"number","default":1,"minimum":0,"maximum":1,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state","measure-light"]},"property-type":"data-driven"},"icon-occlusion-opacity":{"type":"number","minimum":0,"maximum":1,"default":0,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state","measure-light"]},"property-type":"data-driven"},"icon-emissive-strength":{"type":"number","default":1,"minimum":0,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","measure-light","feature-state"]},"property-type":"data-driven"},"text-emissive-strength":{"type":"number","default":1,"minimum":0,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","measure-light","feature-state"]},"property-type":"data-driven"},"icon-color":{"type":"color","default":"#000000","transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state","measure-light"]},"property-type":"data-driven"},"icon-halo-color":{"type":"color","default":"rgba(0, 0, 0, 0)","transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state","measure-light"]},"property-type":"data-driven"},"icon-halo-width":{"type":"number","default":0,"minimum":0,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state","measure-light"]},"property-type":"data-driven"},"icon-halo-blur":{"type":"number","default":0,"minimum":0,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state","measure-light"]},"property-type":"data-driven"},"icon-translate":{"type":"array","value":"number","length":2,"default":[0,0],"transition":true,"expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"},"icon-translate-anchor":{"type":"enum","values":{"map":1,"viewport":1},"default":"map","expression":{"parameters":["zoom"]},"property-type":"data-constant"},"icon-image-cross-fade":{"type":"number","property-type":"data-driven","default":0,"minimum":0,"maximum":1,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state","measure-light"]},"transition":true},"text-opacity":{"type":"number","default":1,"minimum":0,"maximum":1,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state","measure-light"]},"property-type":"data-driven"},"text-occlusion-opacity":{"type":"number","minimum":0,"maximum":1,"default":0,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state","measure-light"]},"property-type":"data-driven"},"text-color":{"type":"color","default":"#000000","transition":true,"overridable":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state","measure-light"]},"property-type":"data-driven"},"text-halo-color":{"type":"color","default":"rgba(0, 0, 0, 0)","transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state","measure-light"]},"property-type":"data-driven"},"text-halo-width":{"type":"number","default":0,"minimum":0,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state","measure-light"]},"property-type":"data-driven"},"text-halo-blur":{"type":"number","default":0,"minimum":0,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state","measure-light"]},"property-type":"data-driven"},"text-translate":{"type":"array","value":"number","length":2,"default":[0,0],"transition":true,"expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"},"text-translate-anchor":{"type":"enum","values":{"map":1,"viewport":1},"default":"map","expression":{"parameters":["zoom"]},"property-type":"data-constant"},"icon-color-saturation":{"type":"number","default":0,"minimum":-1,"maximum":1,"expression":{},"property-type":"data-constant"},"icon-color-contrast":{"type":"number","default":0,"minimum":-1,"maximum":1,"expression":{},"property-type":"data-constant"},"icon-color-brightness-min":{"type":"number","default":0,"minimum":0,"maximum":1,"expression":{},"property-type":"data-constant"},"icon-color-brightness-max":{"type":"number","default":1,"minimum":0,"maximum":1,"expression":{},"property-type":"data-constant"},"symbol-z-offset":{"type":"number","default":0,"minimum":0,"transition":true,"experimental":true,"expression":{"interpolated":true,"parameters":["zoom","feature"]},"property-type":"data-driven"}},"paint_raster":{"raster-opacity":{"type":"number","default":1,"minimum":0,"maximum":1,"transition":true,"expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"},"raster-color":{"type":"color","expression":{"interpolated":true,"parameters":["raster-value"]},"property-type":"color-ramp"},"raster-color-mix":{"type":"array","default":[0.2126,0.7152,0.0722,0],"length":4,"value":"number","property-type":"data-constant","transition":true,"expression":{"interpolated":true,"parameters":["zoom"]}},"raster-color-range":{"type":"array","length":2,"value":"number","property-type":"data-constant","transition":true,"expression":{"interpolated":true,"parameters":["zoom"]}},"raster-hue-rotate":{"type":"number","default":0,"period":360,"transition":true,"expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"},"raster-brightness-min":{"type":"number","default":0,"minimum":0,"maximum":1,"transition":true,"expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"},"raster-brightness-max":{"type":"number","default":1,"minimum":0,"maximum":1,"transition":true,"expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"},"raster-saturation":{"type":"number","default":0,"minimum":-1,"maximum":1,"transition":true,"expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"},"raster-contrast":{"type":"number","default":0,"minimum":-1,"maximum":1,"transition":true,"expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"},"raster-resampling":{"type":"enum","values":{"linear":1,"nearest":1},"default":"linear","expression":{"parameters":["zoom"]},"property-type":"data-constant"},"raster-fade-duration":{"type":"number","default":300,"minimum":0,"expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"},"raster-emissive-strength":{"type":"number","default":0,"minimum":0,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","measure-light"]},"property-type":"data-constant"},"raster-array-band":{"type":"string","required":false,"experimental":true,"property-type":"data-constant"},"raster-elevation":{"type":"number","default":0,"minimum":0,"transition":true,"experimental":true,"expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"}},"paint_raster-particle":{"raster-particle-array-band":{"type":"string","required":false,"property-type":"data-constant"},"raster-particle-count":{"type":"number","default":512,"minimum":1,"property-type":"data-constant"},"raster-particle-color":{"type":"color","expression":{"interpolated":true,"parameters":["raster-particle-speed"]},"property-type":"color-ramp"},"raster-particle-max-speed":{"type":"number","default":1,"minimum":1,"property-type":"data-constant"},"raster-particle-speed-factor":{"type":"number","default":0.2,"minimum":0,"maximum":1,"transition":true,"expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"},"raster-particle-fade-opacity-factor":{"type":"number","default":0.98,"minimum":0,"maximum":1,"transition":true,"expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"},"raster-particle-reset-rate-factor":{"type":"number","default":0.8,"minimum":0,"maximum":1,"property-type":"data-constant"},"raster-particle-elevation":{"type":"number","default":0,"minimum":0,"transition":true,"expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"}},"paint_hillshade":{"hillshade-illumination-direction":{"type":"number","default":335,"minimum":0,"maximum":359,"expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"},"hillshade-illumination-anchor":{"type":"enum","values":{"map":1,"viewport":1},"default":"viewport","expression":{"parameters":["zoom"]},"property-type":"data-constant"},"hillshade-exaggeration":{"type":"number","default":0.5,"minimum":0,"maximum":1,"transition":true,"expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"},"hillshade-shadow-color":{"type":"color","default":"#000000","transition":true,"expression":{"interpolated":true,"parameters":["zoom","measure-light"]},"property-type":"data-constant"},"hillshade-highlight-color":{"type":"color","default":"#FFFFFF","transition":true,"expression":{"interpolated":true,"parameters":["zoom","measure-light"]},"property-type":"data-constant"},"hillshade-accent-color":{"type":"color","default":"#000000","transition":true,"expression":{"interpolated":true,"parameters":["zoom","measure-light"]},"property-type":"data-constant"},"hillshade-emissive-strength":{"type":"number","default":0,"minimum":0,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","measure-light"]},"property-type":"data-constant"}},"paint_background":{"background-pitch-alignment":{"type":"enum","values":{"map":1,"viewport":1},"default":"map","expression":{"parameters":[]},"experimental":true,"property-type":"data-constant"},"background-color":{"type":"color","default":"#000000","transition":true,"expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"},"background-pattern":{"type":"resolvedImage","expression":{"parameters":["zoom"]},"property-type":"data-constant"},"background-opacity":{"type":"number","default":1,"minimum":0,"maximum":1,"transition":true,"expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"},"background-emissive-strength":{"type":"number","default":0,"minimum":0,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","measure-light"]},"property-type":"data-constant"}},"paint_sky":{"sky-type":{"type":"enum","values":{"gradient":1,"atmosphere":1},"default":"atmosphere","expression":{"parameters":["zoom"]},"property-type":"data-constant"},"sky-atmosphere-sun":{"type":"array","value":"number","length":2,"minimum":[0,0],"maximum":[360,180],"expression":{"parameters":["zoom"]},"property-type":"data-constant"},"sky-atmosphere-sun-intensity":{"type":"number","default":10,"minimum":0,"maximum":100,"property-type":"data-constant"},"sky-gradient-center":{"type":"array","value":"number","default":[0,0],"length":2,"minimum":[0,0],"maximum":[360,180],"expression":{"parameters":["zoom"]},"property-type":"data-constant"},"sky-gradient-radius":{"type":"number","default":90,"minimum":0,"maximum":180,"expression":{"parameters":["zoom"]},"property-type":"data-constant"},"sky-gradient":{"type":"color","default":["interpolate",["linear"],["sky-radial-progress"],0.8,"#87ceeb",1,"white"],"expression":{"interpolated":true,"parameters":["sky-radial-progress"]},"property-type":"color-ramp"},"sky-atmosphere-halo-color":{"type":"color","default":"white","property-type":"data-constant"},"sky-atmosphere-color":{"type":"color","default":"white","property-type":"data-constant"},"sky-opacity":{"type":"number","default":1,"minimum":0,"maximum":1,"transition":true,"expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"}},"paint_model":{"model-opacity":{"type":"number","default":1,"minimum":0,"maximum":1,"transition":true,"expression":{"interpolated":true,"parameters":["feature","feature-state","zoom"]},"property-type":"data-driven"},"model-rotation":{"type":"array","value":"number","length":3,"default":[0,0,0],"period":360,"property-type":"data-driven","expression":{"interpolated":true,"parameters":["feature","feature-state","zoom"]},"transition":true},"model-scale":{"type":"array","value":"number","length":3,"default":[1,1,1],"property-type":"data-driven","expression":{"interpolated":true,"parameters":["feature","feature-state","zoom"]},"transition":true},"model-translation":{"type":"array","value":"number","length":3,"default":[0,0,0],"property-type":"data-driven","expression":{"interpolated":true,"parameters":["feature","feature-state","zoom"]},"transition":true},"model-color":{"type":"color","default":"#ffffff","property-type":"data-driven","expression":{"interpolated":true,"parameters":["feature","feature-state","measure-light","zoom"]},"transition":true},"model-color-mix-intensity":{"type":"number","property-type":"data-driven","default":0,"minimum":0,"maximum":1,"expression":{"interpolated":true,"parameters":["feature","feature-state","measure-light"]},"transition":true},"model-type":{"type":"enum","values":{"common-3d":1,"location-indicator":1},"default":"common-3d","property-type":"data-constant"},"model-cast-shadows":{"type":"boolean","default":true,"property-type":"data-constant"},"model-receive-shadows":{"type":"boolean","default":true,"property-type":"data-constant"},"model-ambient-occlusion-intensity":{"type":"number","default":1,"minimum":0,"maximum":1,"expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant","transition":true},"model-emissive-strength":{"type":"number","property-type":"data-driven","default":0,"minimum":0,"maximum":5,"expression":{"interpolated":true,"parameters":["feature","feature-state","measure-light"]},"transition":true},"model-roughness":{"type":"number","default":1,"minimum":0,"maximum":1,"property-type":"data-driven","expression":{"interpolated":true,"parameters":["feature","feature-state"]},"transition":true},"model-height-based-emissive-strength-multiplier":{"type":"array","default":[1,1,1,1,0],"length":5,"value":"number","property-type":"data-driven","expression":{"interpolated":true,"parameters":["feature","feature-state","measure-light"]},"transition":true},"model-cutoff-fade-range":{"type":"number","default":0,"minimum":0,"maximum":1,"expression":{},"property-type":"data-constant"},"model-front-cutoff":{"type":"array","private":true,"value":"number","property-type":"data-constant","expression":{"interpolated":true,"parameters":["zoom"]},"length":3,"default":[0,0,1],"minimum":[0,0,0],"maximum":[1,1,1]}},"transition":{"duration":{"type":"number","default":300,"minimum":0},"delay":{"type":"number","default":0,"minimum":0}},"property-type":{"data-driven":{"type":"property-type"},"color-ramp":{"type":"property-type"},"data-constant":{"type":"property-type"},"constant":{"type":"property-type"}},"promoteId":{"*":{"type":"*"}}}');
        function Xa(t1) {
            return t1 instanceof Number || t1 instanceof String || t1 instanceof Boolean ? t1.valueOf() : t1;
        }
        function Za(t1) {
            if (Array.isArray(t1)) return t1.map(Za);
            if (t1 instanceof Object && !(t1 instanceof Number || t1 instanceof String || t1 instanceof Boolean)) {
                const e = {};
                for(const r in t1)e[r] = Za(t1[r]);
                return e;
            }
            return Xa(t1);
        }
        function Ha(t1) {
            if (!0 === t1 || !1 === t1) return !0;
            if (!Array.isArray(t1) || 0 === t1.length) return !1;
            switch(t1[0]){
                case "has":
                    return t1.length >= 2 && "$id" !== t1[1] && "$type" !== t1[1];
                case "in":
                    return t1.length >= 3 && ("string" != typeof t1[1] || Array.isArray(t1[2]));
                case "!in":
                case "!has":
                case "none":
                    return !1;
                case "==":
                case "!=":
                case ">":
                case ">=":
                case "<":
                case "<=":
                    return 3 !== t1.length || Array.isArray(t1[1]) || Array.isArray(t1[2]);
                case "any":
                case "all":
                    for (const e of t1.slice(1))if (!Ha(e) && "boolean" != typeof e) return !1;
                    return !0;
                default:
                    return !0;
            }
        }
        function Wa(t1, e = "", r = null, n = "fill") {
            if (null == t1) return {
                filter: ()=>!0,
                needGeometry: !1,
                needFeature: !1
            };
            Ha(t1) || (t1 = ns(t1));
            const i = t1;
            let a = !0;
            try {
                a = function(t1) {
                    if (!Qa(t1)) return t1;
                    let e = Za(t1);
                    return Ja(e), e = Ka(e), e;
                }(i);
            } catch (t1) {
                console.warn(`Failed to extract static filter. Filter will continue working, but at higher memory usage and slower framerate.\nThis is most likely a bug, please report this via https://github.com/mapbox/mapbox-gl-js/issues/new?assignees=&labels=&template=Bug_report.md\nand paste the contents of this message in the report.\nThank you!\nFilter Expression:\n${JSON.stringify(i, null, 2)}\n        `);
            }
            let s = null, o = null;
            if ("background" !== n && "sky" !== n && "slot" !== n) {
                o = Ya[`filter_${n}`];
                const t1 = Wi(a, o, e, r);
                if ("error" === t1.result) throw new Error(t1.value.map((t1)=>`${t1.key}: ${t1.message}`).join(", "));
                s = (e, r, n)=>t1.value.evaluate(e, r, {}, n);
            }
            let l = null, u = null;
            if (a !== i) {
                const t1 = Wi(i, o, e, r);
                if ("error" === t1.result) throw new Error(t1.value.map((t1)=>`${t1.key}: ${t1.message}`).join(", "));
                l = (e, r, n, i, a)=>t1.value.evaluate(e, r, {}, n, void 0, void 0, i, a), u = !Tn(t1.value.expression);
            }
            return {
                filter: s,
                dynamicFilter: l || void 0,
                needGeometry: rs(a),
                needFeature: !!u
            };
        }
        function Ka(t1) {
            if (!Array.isArray(t1)) return t1;
            const e = function(t1) {
                if (ts.has(t1[0])) {
                    for(let e = 1; e < t1.length; e++)if (Qa(t1[e])) return !0;
                }
                return t1;
            }(t1);
            return !0 === e ? e : e.map((t1)=>Ka(t1));
        }
        function Ja(t1) {
            let e = !1;
            const r = [];
            if ("case" === t1[0]) {
                for(let n = 1; n < t1.length - 1; n += 2)e = e || Qa(t1[n]), r.push(t1[n + 1]);
                r.push(t1[t1.length - 1]);
            } else if ("match" === t1[0]) {
                e = e || Qa(t1[1]);
                for(let e = 2; e < t1.length - 1; e += 2)r.push(t1[e + 1]);
                r.push(t1[t1.length - 1]);
            } else if ("step" === t1[0]) {
                e = e || Qa(t1[1]);
                for(let e = 1; e < t1.length - 1; e += 2)r.push(t1[e + 1]);
            }
            e && (t1.length = 0, t1.push("any", ...r));
            for(let e = 1; e < t1.length; e++)Ja(t1[e]);
        }
        function Qa(t1) {
            if (!Array.isArray(t1)) return !1;
            if ("pitch" === (e = t1[0]) || "distance-from-center" === e) return !0;
            var e;
            for(let e = 1; e < t1.length; e++)if (Qa(t1[e])) return !0;
            return !1;
        }
        const ts = new Set([
            "in",
            "==",
            "!=",
            ">",
            ">=",
            "<",
            "<=",
            "to-boolean"
        ]);
        function es(t1, e) {
            return t1 < e ? -1 : t1 > e ? 1 : 0;
        }
        function rs(t1) {
            if (!Array.isArray(t1)) return !1;
            if ("within" === t1[0] || "distance" === t1[0]) return !0;
            for(let e = 1; e < t1.length; e++)if (rs(t1[e])) return !0;
            return !1;
        }
        function ns(t1) {
            if (!t1) return !0;
            const e = t1[0];
            var r;
            return t1.length <= 1 ? "any" !== e : "==" === e ? is(t1[1], t1[2], "==") : "!=" === e ? os(is(t1[1], t1[2], "==")) : "<" === e || ">" === e || "<=" === e || ">=" === e ? is(t1[1], t1[2], e) : "any" === e ? (r = t1.slice(1), [
                "any"
            ].concat(r.map(ns))) : "all" === e ? [
                "all"
            ].concat(t1.slice(1).map(ns)) : "none" === e ? [
                "all"
            ].concat(t1.slice(1).map(ns).map(os)) : "in" === e ? as(t1[1], t1.slice(2)) : "!in" === e ? os(as(t1[1], t1.slice(2))) : "has" === e ? ss(t1[1]) : "!has" !== e || os(ss(t1[1]));
        }
        function is(t1, e, r) {
            switch(t1){
                case "$type":
                    return [
                        `filter-type-${r}`,
                        e
                    ];
                case "$id":
                    return [
                        `filter-id-${r}`,
                        e
                    ];
                default:
                    return [
                        `filter-${r}`,
                        t1,
                        e
                    ];
            }
        }
        function as(t1, e) {
            if (0 === e.length) return !1;
            switch(t1){
                case "$type":
                    return [
                        "filter-type-in",
                        [
                            "literal",
                            e
                        ]
                    ];
                case "$id":
                    return [
                        "filter-id-in",
                        [
                            "literal",
                            e
                        ]
                    ];
                default:
                    return e.length > 200 && !e.some((t1)=>typeof t1 != typeof e[0]) ? [
                        "filter-in-large",
                        t1,
                        [
                            "literal",
                            e.sort(es)
                        ]
                    ] : [
                        "filter-in-small",
                        t1,
                        [
                            "literal",
                            e
                        ]
                    ];
            }
        }
        function ss(t1) {
            switch(t1){
                case "$type":
                    return !0;
                case "$id":
                    return [
                        "filter-has-id"
                    ];
                default:
                    return [
                        "filter-has",
                        t1
                    ];
            }
        }
        function os(t1) {
            return [
                "!",
                t1
            ];
        }
        const ls = "";
        function us(t1, e) {
            return e ? `${t1}${ls}${e}` : t1;
        }
        const cs = "-transition", hs = new Set([
            "fill",
            "line",
            "background",
            "hillshade",
            "raster"
        ]);
        class ps extends we {
            onAdd(t1) {}
            onRemove(t1) {}
            isDraped(t1) {
                return !this.is3D() && hs.has(this.type);
            }
            getLayoutProperty(t1) {
                return "visibility" === t1 ? this.visibility : this._unevaluatedLayout.getValue(t1);
            }
            setLayoutProperty(t1, e) {
                if ("custom" === this.type && "visibility" === t1) return void (this.visibility = e);
                const r = this._unevaluatedLayout;
                r._properties.properties[t1] && (r.setValue(t1, e), this.configDependencies = new Set([
                    ...this.configDependencies,
                    ...r.configDependencies
                ]), "visibility" === t1 && this.possiblyEvaluateVisibility());
            }
            possiblyEvaluateVisibility() {
                this._unevaluatedLayout._values.visibility && (this.visibility = this._unevaluatedLayout._values.visibility.possiblyEvaluate({
                    zoom: 0
                }));
            }
            getPaintProperty(t1) {
                return lt(t1, cs) ? this._transitionablePaint.getTransition(t1.slice(0, -11)) : this._transitionablePaint.getValue(t1);
            }
            setPaintProperty(t1, e) {
                const r = this._transitionablePaint, n = r._properties.properties;
                if (lt(t1, cs)) {
                    const i = t1.slice(0, -11);
                    return n[i] && r.setTransition(i, e || void 0), !1;
                }
                if (!n[t1]) return !1;
                const i = r._values[t1], a = i.value.isDataDriven(), s = i.value;
                r.setValue(t1, e), this.configDependencies = new Set([
                    ...this.configDependencies,
                    ...r.configDependencies
                ]), this._handleSpecialPaintPropertyUpdate(t1);
                const o = r._values[t1].value, l = o.isDataDriven(), u = lt(t1, "pattern") || "line-dasharray" === t1;
                return l || a || u || this._handleOverridablePaintPropertyUpdate(t1, s, o);
            }
            _handleSpecialPaintPropertyUpdate(t1) {}
            getProgramIds() {
                return null;
            }
            getDefaultProgramParams(t1, e, r) {
                return null;
            }
            _handleOverridablePaintPropertyUpdate(t1, e, r) {
                return !1;
            }
            isHidden(t1) {
                return !!(this.minzoom && t1 < this.minzoom) || !!(this.maxzoom && t1 >= this.maxzoom) || "none" === this.visibility;
            }
            updateTransitions(t1) {
                this._transitioningPaint = this._transitionablePaint.transitioned(t1, this._transitioningPaint);
            }
            hasTransition() {
                return this._transitioningPaint.hasTransition();
            }
            recalculate(t1, e) {
                this._unevaluatedLayout && (this.layout = this._unevaluatedLayout.possiblyEvaluate(t1, void 0, e)), this.paint = this._transitioningPaint.possiblyEvaluate(t1, void 0, e);
            }
            serialize() {
                return ct({
                    id: this.id,
                    type: this.type,
                    slot: this.slot,
                    source: this.source,
                    "source-layer": this.sourceLayer,
                    metadata: this.metadata,
                    minzoom: this.minzoom,
                    maxzoom: this.maxzoom,
                    filter: this.filter,
                    layout: this._unevaluatedLayout && this._unevaluatedLayout.serialize(),
                    paint: this._transitionablePaint && this._transitionablePaint.serialize()
                }, (t1, e)=>!(void 0 === t1 || "layout" === e && !Object.keys(t1).length || "paint" === e && !Object.keys(t1).length));
            }
            is3D() {
                return !1;
            }
            isSky() {
                return !1;
            }
            isTileClipped() {
                return !1;
            }
            hasOffscreenPass() {
                return !1;
            }
            hasShadowPass() {
                return !1;
            }
            canCastShadows() {
                return !1;
            }
            hasLightBeamPass() {
                return !1;
            }
            cutoffRange() {
                return 0;
            }
            tileCoverLift() {
                return 0;
            }
            resize() {}
            isStateDependent() {
                for(const t1 in this.paint._values){
                    const e = this.paint.get(t1);
                    if (e instanceof Na && Li(e.property.specification) && ("source" === e.value.kind || "composite" === e.value.kind) && e.value.isStateDependent) return !0;
                }
                return !1;
            }
            compileFilter(t1) {
                this._filterCompiled || (this._featureFilter = Wa(this.filter, this.scope, t1), this._filterCompiled = !0);
            }
            invalidateCompiledFilter() {
                this._filterCompiled = !1;
            }
            dynamicFilter() {
                return this._featureFilter.dynamicFilter;
            }
            dynamicFilterNeedsFeature() {
                return this._featureFilter.needFeature;
            }
            getLayerRenderingStats() {
                return this._stats;
            }
            resetLayerRenderingStats(t1) {
                this._stats && ("shadow" === t1.renderPass ? this._stats.numRenderedVerticesInShadowPass = 0 : this._stats.numRenderedVerticesInTransparentPass = 0);
            }
            queryRadius(t1) {}
            queryIntersectsFeature(t1, e, r, n, i, a, s, o, l) {}
            constructor(t1, e, r, n, i){
                if (super(), this.id = t1.id, this.fqid = us(this.id, r), this.type = t1.type, this.scope = r, this.lut = n, this.options = i, this._featureFilter = {
                    filter: ()=>!0,
                    needGeometry: !1,
                    needFeature: !1
                }, this._filterCompiled = !1, this.configDependencies = new Set, "custom" !== t1.type) {
                    if (this.metadata = t1.metadata, this.minzoom = t1.minzoom, this.maxzoom = t1.maxzoom, t1.type && "background" !== t1.type && "sky" !== t1.type && "slot" !== t1.type) {
                        this.source = t1.source, this.sourceLayer = t1["source-layer"], this.filter = t1.filter;
                        const e = Wi(this.filter, Ya[`filter_${t1.type}`]);
                        "error" !== e.result && (this.configDependencies = new Set([
                            ...this.configDependencies,
                            ...e.value.configDependencies
                        ]));
                    }
                    if (t1.slot && (this.slot = t1.slot), e.layout && (this._unevaluatedLayout = new Oa(e.layout, this.scope, i), this.configDependencies = new Set([
                        ...this.configDependencies,
                        ...this._unevaluatedLayout.configDependencies
                    ])), e.paint) {
                        this._transitionablePaint = new La(e.paint, this.scope, i);
                        for(const e in t1.paint)this.setPaintProperty(e, t1.paint[e]);
                        for(const e in t1.layout)this.setLayoutProperty(e, t1.layout[e]);
                        this.configDependencies = new Set([
                            ...this.configDependencies,
                            ...this._transitionablePaint.configDependencies
                        ]), this._transitioningPaint = this._transitionablePaint.untransitioned(), this.paint = new Ua(e.paint);
                    }
                }
            }
        }
        const fs = {
            Int8: Int8Array,
            Uint8: Uint8Array,
            Int16: Int16Array,
            Uint16: Uint16Array,
            Int32: Int32Array,
            Uint32: Uint32Array,
            Float32: Float32Array
        };
        class ds {
            constructor(t1, e){
                this._structArray = t1, this._pos1 = e * this.size, this._pos2 = this._pos1 / 2, this._pos4 = this._pos1 / 4, this._pos8 = this._pos1 / 8;
            }
        }
        class ms {
            static serialize(t1, e) {
                return t1._trim(), e && (t1.isTransferred = !0, e.add(t1.arrayBuffer)), {
                    length: t1.length,
                    arrayBuffer: t1.arrayBuffer
                };
            }
            static deserialize(t1) {
                const e = Object.create(this.prototype);
                return e.arrayBuffer = t1.arrayBuffer, e.length = t1.length, e.capacity = t1.arrayBuffer.byteLength / e.bytesPerElement, e._refreshViews(), e;
            }
            _trim() {
                this.length !== this.capacity && (this.capacity = this.length, this.arrayBuffer = this.arrayBuffer.slice(0, this.length * this.bytesPerElement), this._refreshViews());
            }
            clear() {
                this.length = 0;
            }
            resize(t1) {
                this.reserve(t1), this.length = t1;
            }
            reserve(t1) {
                if (t1 > this.capacity) {
                    this.capacity = Math.max(t1, Math.floor(5 * this.capacity), 128), this.arrayBuffer = new ArrayBuffer(this.capacity * this.bytesPerElement);
                    const e = this.uint8;
                    this._refreshViews(), e && this.uint8.set(e);
                }
            }
            _refreshViews() {
                throw new Error("StructArray#_refreshViews() must be implemented by each concrete StructArray layout");
            }
            emplace(...t1) {
                throw new Error("StructArray#emplace() must be implemented by each concrete StructArray layout");
            }
            emplaceBack(...t1) {
                throw new Error("StructArray#emplaceBack() must be implemented by each concrete StructArray layout");
            }
            destroy() {
                this.int8 = this.uint8 = this.int16 = this.uint16 = this.int32 = this.uint32 = this.float32 = null, this.arrayBuffer = null;
            }
            constructor(){
                this.isTransferred = !1, this.capacity = -1, this.resize(0);
            }
        }
        function ys(t1, e = 1) {
            let r = 0, n = 0;
            return {
                members: t1.map((t1)=>{
                    const i = fs[t1.type].BYTES_PER_ELEMENT, a = r = gs(r, Math.max(e, i)), s = t1.components || 1;
                    return n = Math.max(n, i), r += i * s, {
                        name: t1.name,
                        type: t1.type,
                        components: s,
                        offset: a
                    };
                }),
                size: gs(r, Math.max(n, e)),
                alignment: e
            };
        }
        function gs(t1, e) {
            return Math.ceil(t1 / e) * e;
        }
        class xs extends ms {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer);
            }
            emplaceBack(t1, e) {
                const r = this.length;
                return this.resize(r + 1), this.emplace(r, t1, e);
            }
            emplace(t1, e, r) {
                const n = 2 * t1;
                return this.int16[n + 0] = e, this.int16[n + 1] = r, t1;
            }
        }
        xs.prototype.bytesPerElement = 4, oa(xs, "StructArrayLayout2i4");
        class vs extends ms {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer);
            }
            emplaceBack(t1, e, r) {
                const n = this.length;
                return this.resize(n + 1), this.emplace(n, t1, e, r);
            }
            emplace(t1, e, r, n) {
                const i = 3 * t1;
                return this.int16[i + 0] = e, this.int16[i + 1] = r, this.int16[i + 2] = n, t1;
            }
        }
        vs.prototype.bytesPerElement = 6, oa(vs, "StructArrayLayout3i6");
        class bs extends ms {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer);
            }
            emplaceBack(t1, e, r, n) {
                const i = this.length;
                return this.resize(i + 1), this.emplace(i, t1, e, r, n);
            }
            emplace(t1, e, r, n, i) {
                const a = 4 * t1;
                return this.int16[a + 0] = e, this.int16[a + 1] = r, this.int16[a + 2] = n, this.int16[a + 3] = i, t1;
            }
        }
        bs.prototype.bytesPerElement = 8, oa(bs, "StructArrayLayout4i8");
        class _s extends ms {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer);
            }
            emplaceBack(t1, e, r, n, i) {
                const a = this.length;
                return this.resize(a + 1), this.emplace(a, t1, e, r, n, i);
            }
            emplace(t1, e, r, n, i, a) {
                const s = 5 * t1;
                return this.int16[s + 0] = e, this.int16[s + 1] = r, this.int16[s + 2] = n, this.int16[s + 3] = i, this.int16[s + 4] = a, t1;
            }
        }
        _s.prototype.bytesPerElement = 10, oa(_s, "StructArrayLayout5i10");
        class ws extends ms {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
            }
            emplaceBack(t1, e, r, n, i, a, s) {
                const o = this.length;
                return this.resize(o + 1), this.emplace(o, t1, e, r, n, i, a, s);
            }
            emplace(t1, e, r, n, i, a, s, o) {
                const l = 6 * t1, u = 12 * t1, c = 3 * t1;
                return this.int16[l + 0] = e, this.int16[l + 1] = r, this.uint8[u + 4] = n, this.uint8[u + 5] = i, this.uint8[u + 6] = a, this.uint8[u + 7] = s, this.float32[c + 2] = o, t1;
            }
        }
        ws.prototype.bytesPerElement = 12, oa(ws, "StructArrayLayout2i4ub1f12");
        class Ms extends ms {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
            }
            emplaceBack(t1, e, r) {
                const n = this.length;
                return this.resize(n + 1), this.emplace(n, t1, e, r);
            }
            emplace(t1, e, r, n) {
                const i = 3 * t1;
                return this.float32[i + 0] = e, this.float32[i + 1] = r, this.float32[i + 2] = n, t1;
            }
        }
        Ms.prototype.bytesPerElement = 12, oa(Ms, "StructArrayLayout3f12");
        class As extends ms {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
            }
            emplaceBack(t1, e, r, n, i) {
                const a = this.length;
                return this.resize(a + 1), this.emplace(a, t1, e, r, n, i);
            }
            emplace(t1, e, r, n, i, a) {
                const s = 6 * t1, o = 3 * t1;
                return this.uint16[s + 0] = e, this.uint16[s + 1] = r, this.uint16[s + 2] = n, this.uint16[s + 3] = i, this.float32[o + 2] = a, t1;
            }
        }
        As.prototype.bytesPerElement = 12, oa(As, "StructArrayLayout4ui1f12");
        class Ss extends ms {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer);
            }
            emplaceBack(t1, e, r, n) {
                const i = this.length;
                return this.resize(i + 1), this.emplace(i, t1, e, r, n);
            }
            emplace(t1, e, r, n, i) {
                const a = 4 * t1;
                return this.uint16[a + 0] = e, this.uint16[a + 1] = r, this.uint16[a + 2] = n, this.uint16[a + 3] = i, t1;
            }
        }
        Ss.prototype.bytesPerElement = 8, oa(Ss, "StructArrayLayout4ui8");
        class Is extends ms {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer);
            }
            emplaceBack(t1, e, r, n, i, a) {
                const s = this.length;
                return this.resize(s + 1), this.emplace(s, t1, e, r, n, i, a);
            }
            emplace(t1, e, r, n, i, a, s) {
                const o = 6 * t1;
                return this.int16[o + 0] = e, this.int16[o + 1] = r, this.int16[o + 2] = n, this.int16[o + 3] = i, this.int16[o + 4] = a, this.int16[o + 5] = s, t1;
            }
        }
        Is.prototype.bytesPerElement = 12, oa(Is, "StructArrayLayout6i12");
        class Ps extends ms {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer);
            }
            emplaceBack(t1, e, r, n, i, a, s, o, l, u, c, h) {
                const p = this.length;
                return this.resize(p + 1), this.emplace(p, t1, e, r, n, i, a, s, o, l, u, c, h);
            }
            emplace(t1, e, r, n, i, a, s, o, l, u, c, h, p) {
                const f = 12 * t1;
                return this.int16[f + 0] = e, this.int16[f + 1] = r, this.int16[f + 2] = n, this.int16[f + 3] = i, this.uint16[f + 4] = a, this.uint16[f + 5] = s, this.uint16[f + 6] = o, this.uint16[f + 7] = l, this.int16[f + 8] = u, this.int16[f + 9] = c, this.int16[f + 10] = h, this.int16[f + 11] = p, t1;
            }
        }
        Ps.prototype.bytesPerElement = 24, oa(Ps, "StructArrayLayout4i4ui4i24");
        class zs extends ms {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
            }
            emplaceBack(t1, e, r, n, i, a) {
                const s = this.length;
                return this.resize(s + 1), this.emplace(s, t1, e, r, n, i, a);
            }
            emplace(t1, e, r, n, i, a, s) {
                const o = 10 * t1, l = 5 * t1;
                return this.int16[o + 0] = e, this.int16[o + 1] = r, this.int16[o + 2] = n, this.float32[l + 2] = i, this.float32[l + 3] = a, this.float32[l + 4] = s, t1;
            }
        }
        zs.prototype.bytesPerElement = 20, oa(zs, "StructArrayLayout3i3f20");
        class Es extends ms {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
            }
            emplaceBack(t1, e, r, n) {
                const i = this.length;
                return this.resize(i + 1), this.emplace(i, t1, e, r, n);
            }
            emplace(t1, e, r, n, i) {
                const a = 4 * t1;
                return this.float32[a + 0] = e, this.float32[a + 1] = r, this.float32[a + 2] = n, this.float32[a + 3] = i, t1;
            }
        }
        Es.prototype.bytesPerElement = 16, oa(Es, "StructArrayLayout4f16");
        class ks extends ms {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.uint32 = new Uint32Array(this.arrayBuffer);
            }
            emplaceBack(t1) {
                const e = this.length;
                return this.resize(e + 1), this.emplace(e, t1);
            }
            emplace(t1, e) {
                return this.uint32[1 * t1 + 0] = e, t1;
            }
        }
        ks.prototype.bytesPerElement = 4, oa(ks, "StructArrayLayout1ul4");
        class Ts extends ms {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer);
            }
            emplaceBack(t1, e) {
                const r = this.length;
                return this.resize(r + 1), this.emplace(r, t1, e);
            }
            emplace(t1, e, r) {
                const n = 2 * t1;
                return this.uint16[n + 0] = e, this.uint16[n + 1] = r, t1;
            }
        }
        Ts.prototype.bytesPerElement = 4, oa(Ts, "StructArrayLayout2ui4");
        class Bs extends ms {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer), this.uint32 = new Uint32Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer);
            }
            emplaceBack(t1, e, r, n, i, a, s, o, l, u, c, h, p) {
                const f = this.length;
                return this.resize(f + 1), this.emplace(f, t1, e, r, n, i, a, s, o, l, u, c, h, p);
            }
            emplace(t1, e, r, n, i, a, s, o, l, u, c, h, p, f) {
                const d = 20 * t1, m = 10 * t1;
                return this.int16[d + 0] = e, this.int16[d + 1] = r, this.int16[d + 2] = n, this.int16[d + 3] = i, this.int16[d + 4] = a, this.float32[m + 3] = s, this.float32[m + 4] = o, this.float32[m + 5] = l, this.float32[m + 6] = u, this.int16[d + 14] = c, this.uint32[m + 8] = h, this.uint16[d + 18] = p, this.uint16[d + 19] = f, t1;
            }
        }
        Bs.prototype.bytesPerElement = 40, oa(Bs, "StructArrayLayout5i4f1i1ul2ui40");
        class Cs extends ms {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer);
            }
            emplaceBack(t1, e, r, n, i, a, s) {
                const o = this.length;
                return this.resize(o + 1), this.emplace(o, t1, e, r, n, i, a, s);
            }
            emplace(t1, e, r, n, i, a, s, o) {
                const l = 8 * t1;
                return this.int16[l + 0] = e, this.int16[l + 1] = r, this.int16[l + 2] = n, this.int16[l + 4] = i, this.int16[l + 5] = a, this.int16[l + 6] = s, this.int16[l + 7] = o, t1;
            }
        }
        Cs.prototype.bytesPerElement = 16, oa(Cs, "StructArrayLayout3i2i2i16");
        class Vs extends ms {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer);
            }
            emplaceBack(t1, e, r, n, i) {
                const a = this.length;
                return this.resize(a + 1), this.emplace(a, t1, e, r, n, i);
            }
            emplace(t1, e, r, n, i, a) {
                const s = 4 * t1, o = 8 * t1;
                return this.float32[s + 0] = e, this.float32[s + 1] = r, this.float32[s + 2] = n, this.int16[o + 6] = i, this.int16[o + 7] = a, t1;
            }
        }
        Vs.prototype.bytesPerElement = 16, oa(Vs, "StructArrayLayout2f1f2i16");
        class Ds extends ms {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
            }
            emplaceBack(t1, e, r, n, i, a) {
                const s = this.length;
                return this.resize(s + 1), this.emplace(s, t1, e, r, n, i, a);
            }
            emplace(t1, e, r, n, i, a, s) {
                const o = 20 * t1, l = 5 * t1;
                return this.uint8[o + 0] = e, this.uint8[o + 1] = r, this.float32[l + 1] = n, this.float32[l + 2] = i, this.float32[l + 3] = a, this.float32[l + 4] = s, t1;
            }
        }
        Ds.prototype.bytesPerElement = 20, oa(Ds, "StructArrayLayout2ub4f20");
        class Ls extends ms {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer);
            }
            emplaceBack(t1, e, r) {
                const n = this.length;
                return this.resize(n + 1), this.emplace(n, t1, e, r);
            }
            emplace(t1, e, r, n) {
                const i = 3 * t1;
                return this.uint16[i + 0] = e, this.uint16[i + 1] = r, this.uint16[i + 2] = n, t1;
            }
        }
        Ls.prototype.bytesPerElement = 6, oa(Ls, "StructArrayLayout3ui6");
        class Rs extends ms {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer), this.uint32 = new Uint32Array(this.arrayBuffer);
            }
            emplaceBack(t1, e, r, n, i, a, s, o, l, u, c, h, p, f, d, m, y, g, x, v, b) {
                const _ = this.length;
                return this.resize(_ + 1), this.emplace(_, t1, e, r, n, i, a, s, o, l, u, c, h, p, f, d, m, y, g, x, v, b);
            }
            emplace(t1, e, r, n, i, a, s, o, l, u, c, h, p, f, d, m, y, g, x, v, b, _) {
                const w = 30 * t1, M = 15 * t1, A = 60 * t1;
                return this.int16[w + 0] = e, this.int16[w + 1] = r, this.int16[w + 2] = n, this.float32[M + 2] = i, this.float32[M + 3] = a, this.uint16[w + 8] = s, this.uint16[w + 9] = o, this.uint32[M + 5] = l, this.uint32[M + 6] = u, this.uint32[M + 7] = c, this.uint16[w + 16] = h, this.uint16[w + 17] = p, this.uint16[w + 18] = f, this.float32[M + 10] = d, this.float32[M + 11] = m, this.uint8[A + 48] = y, this.uint8[A + 49] = g, this.uint8[A + 50] = x, this.uint32[M + 13] = v, this.int16[w + 28] = b, this.uint8[A + 58] = _, t1;
            }
        }
        Rs.prototype.bytesPerElement = 60, oa(Rs, "StructArrayLayout3i2f2ui3ul3ui2f3ub1ul1i1ub60");
        class Fs extends ms {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer), this.uint32 = new Uint32Array(this.arrayBuffer);
            }
            emplaceBack(t1, e, r, n, i, a, s, o, l, u, c, h, p, f, d, m, y, g, x, v, b, _, w, M, A, S, I, P, z, E, k, T) {
                const B = this.length;
                return this.resize(B + 1), this.emplace(B, t1, e, r, n, i, a, s, o, l, u, c, h, p, f, d, m, y, g, x, v, b, _, w, M, A, S, I, P, z, E, k, T);
            }
            emplace(t1, e, r, n, i, a, s, o, l, u, c, h, p, f, d, m, y, g, x, v, b, _, w, M, A, S, I, P, z, E, k, T, B) {
                const C = 20 * t1, V = 40 * t1, D = 80 * t1;
                return this.float32[C + 0] = e, this.float32[C + 1] = r, this.int16[V + 4] = n, this.int16[V + 5] = i, this.int16[V + 6] = a, this.int16[V + 7] = s, this.int16[V + 8] = o, this.int16[V + 9] = l, this.int16[V + 10] = u, this.int16[V + 11] = c, this.int16[V + 12] = h, this.uint16[V + 13] = p, this.uint16[V + 14] = f, this.uint16[V + 15] = d, this.uint16[V + 16] = m, this.uint16[V + 17] = y, this.uint16[V + 18] = g, this.uint16[V + 19] = x, this.uint16[V + 20] = v, this.uint16[V + 21] = b, this.uint16[V + 22] = _, this.uint16[V + 23] = w, this.uint16[V + 24] = M, this.uint16[V + 25] = A, this.uint16[V + 26] = S, this.uint16[V + 27] = I, this.uint32[C + 14] = P, this.float32[C + 15] = z, this.float32[C + 16] = E, this.float32[C + 17] = k, this.float32[C + 18] = T, this.uint8[D + 76] = B, t1;
            }
        }
        Fs.prototype.bytesPerElement = 80, oa(Fs, "StructArrayLayout2f9i15ui1ul4f1ub80");
        class Os extends ms {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
            }
            emplaceBack(t1) {
                const e = this.length;
                return this.resize(e + 1), this.emplace(e, t1);
            }
            emplace(t1, e) {
                return this.float32[1 * t1 + 0] = e, t1;
            }
        }
        Os.prototype.bytesPerElement = 4, oa(Os, "StructArrayLayout1f4");
        class Ns extends ms {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
            }
            emplaceBack(t1, e, r, n, i) {
                const a = this.length;
                return this.resize(a + 1), this.emplace(a, t1, e, r, n, i);
            }
            emplace(t1, e, r, n, i, a) {
                const s = 5 * t1;
                return this.float32[s + 0] = e, this.float32[s + 1] = r, this.float32[s + 2] = n, this.float32[s + 3] = i, this.float32[s + 4] = a, t1;
            }
        }
        Ns.prototype.bytesPerElement = 20, oa(Ns, "StructArrayLayout5f20");
        class Us extends ms {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
            }
            emplaceBack(t1, e, r, n, i, a, s) {
                const o = this.length;
                return this.resize(o + 1), this.emplace(o, t1, e, r, n, i, a, s);
            }
            emplace(t1, e, r, n, i, a, s, o) {
                const l = 7 * t1;
                return this.float32[l + 0] = e, this.float32[l + 1] = r, this.float32[l + 2] = n, this.float32[l + 3] = i, this.float32[l + 4] = a, this.float32[l + 5] = s, this.float32[l + 6] = o, t1;
            }
        }
        Us.prototype.bytesPerElement = 28, oa(Us, "StructArrayLayout7f28");
        class js extends ms {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
            }
            emplaceBack(t1, e, r, n, i, a, s, o, l, u, c) {
                const h = this.length;
                return this.resize(h + 1), this.emplace(h, t1, e, r, n, i, a, s, o, l, u, c);
            }
            emplace(t1, e, r, n, i, a, s, o, l, u, c, h) {
                const p = 11 * t1;
                return this.float32[p + 0] = e, this.float32[p + 1] = r, this.float32[p + 2] = n, this.float32[p + 3] = i, this.float32[p + 4] = a, this.float32[p + 5] = s, this.float32[p + 6] = o, this.float32[p + 7] = l, this.float32[p + 8] = u, this.float32[p + 9] = c, this.float32[p + 10] = h, t1;
            }
        }
        js.prototype.bytesPerElement = 44, oa(js, "StructArrayLayout11f44");
        class qs extends ms {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
            }
            emplaceBack(t1, e, r, n, i, a, s, o, l) {
                const u = this.length;
                return this.resize(u + 1), this.emplace(u, t1, e, r, n, i, a, s, o, l);
            }
            emplace(t1, e, r, n, i, a, s, o, l, u) {
                const c = 9 * t1;
                return this.float32[c + 0] = e, this.float32[c + 1] = r, this.float32[c + 2] = n, this.float32[c + 3] = i, this.float32[c + 4] = a, this.float32[c + 5] = s, this.float32[c + 6] = o, this.float32[c + 7] = l, this.float32[c + 8] = u, t1;
            }
        }
        qs.prototype.bytesPerElement = 36, oa(qs, "StructArrayLayout9f36");
        class $s extends ms {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
            }
            emplaceBack(t1, e) {
                const r = this.length;
                return this.resize(r + 1), this.emplace(r, t1, e);
            }
            emplace(t1, e, r) {
                const n = 2 * t1;
                return this.float32[n + 0] = e, this.float32[n + 1] = r, t1;
            }
        }
        $s.prototype.bytesPerElement = 8, oa($s, "StructArrayLayout2f8");
        class Gs extends ms {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.uint32 = new Uint32Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer);
            }
            emplaceBack(t1, e, r, n) {
                const i = this.length;
                return this.resize(i + 1), this.emplace(i, t1, e, r, n);
            }
            emplace(t1, e, r, n, i) {
                const a = 6 * t1;
                return this.uint32[3 * t1 + 0] = e, this.uint16[a + 2] = r, this.uint16[a + 3] = n, this.uint16[a + 4] = i, t1;
            }
        }
        Gs.prototype.bytesPerElement = 12, oa(Gs, "StructArrayLayout1ul3ui12");
        class Ys extends ms {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer);
            }
            emplaceBack(t1) {
                const e = this.length;
                return this.resize(e + 1), this.emplace(e, t1);
            }
            emplace(t1, e) {
                return this.uint16[1 * t1 + 0] = e, t1;
            }
        }
        Ys.prototype.bytesPerElement = 2, oa(Ys, "StructArrayLayout1ui2");
        class Xs extends ms {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
            }
            emplaceBack(t1, e, r, n, i, a, s, o, l, u, c, h, p, f, d, m) {
                const y = this.length;
                return this.resize(y + 1), this.emplace(y, t1, e, r, n, i, a, s, o, l, u, c, h, p, f, d, m);
            }
            emplace(t1, e, r, n, i, a, s, o, l, u, c, h, p, f, d, m, y) {
                const g = 16 * t1;
                return this.float32[g + 0] = e, this.float32[g + 1] = r, this.float32[g + 2] = n, this.float32[g + 3] = i, this.float32[g + 4] = a, this.float32[g + 5] = s, this.float32[g + 6] = o, this.float32[g + 7] = l, this.float32[g + 8] = u, this.float32[g + 9] = c, this.float32[g + 10] = h, this.float32[g + 11] = p, this.float32[g + 12] = f, this.float32[g + 13] = d, this.float32[g + 14] = m, this.float32[g + 15] = y, t1;
            }
        }
        Xs.prototype.bytesPerElement = 64, oa(Xs, "StructArrayLayout16f64");
        class Zs extends ms {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
            }
            emplaceBack(t1, e, r, n, i, a, s) {
                const o = this.length;
                return this.resize(o + 1), this.emplace(o, t1, e, r, n, i, a, s);
            }
            emplace(t1, e, r, n, i, a, s, o) {
                const l = 10 * t1, u = 5 * t1;
                return this.uint16[l + 0] = e, this.uint16[l + 1] = r, this.uint16[l + 2] = n, this.uint16[l + 3] = i, this.float32[u + 2] = a, this.float32[u + 3] = s, this.float32[u + 4] = o, t1;
            }
        }
        Zs.prototype.bytesPerElement = 20, oa(Zs, "StructArrayLayout4ui3f20");
        class Hs extends ms {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer);
            }
            emplaceBack(t1) {
                const e = this.length;
                return this.resize(e + 1), this.emplace(e, t1);
            }
            emplace(t1, e) {
                return this.int16[1 * t1 + 0] = e, t1;
            }
        }
        Hs.prototype.bytesPerElement = 2, oa(Hs, "StructArrayLayout1i2");
        class Ws extends ms {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer);
            }
            emplaceBack(t1) {
                const e = this.length;
                return this.resize(e + 1), this.emplace(e, t1);
            }
            emplace(t1, e) {
                return this.uint8[1 * t1 + 0] = e, t1;
            }
        }
        Ws.prototype.bytesPerElement = 1, oa(Ws, "StructArrayLayout1ub1");
        class Ks extends ds {
            get projectedAnchorX() {
                return this._structArray.int16[this._pos2 + 0];
            }
            get projectedAnchorY() {
                return this._structArray.int16[this._pos2 + 1];
            }
            get projectedAnchorZ() {
                return this._structArray.int16[this._pos2 + 2];
            }
            get tileAnchorX() {
                return this._structArray.int16[this._pos2 + 3];
            }
            get tileAnchorY() {
                return this._structArray.int16[this._pos2 + 4];
            }
            get x1() {
                return this._structArray.float32[this._pos4 + 3];
            }
            get y1() {
                return this._structArray.float32[this._pos4 + 4];
            }
            get x2() {
                return this._structArray.float32[this._pos4 + 5];
            }
            get y2() {
                return this._structArray.float32[this._pos4 + 6];
            }
            get padding() {
                return this._structArray.int16[this._pos2 + 14];
            }
            get featureIndex() {
                return this._structArray.uint32[this._pos4 + 8];
            }
            get sourceLayerIndex() {
                return this._structArray.uint16[this._pos2 + 18];
            }
            get bucketIndex() {
                return this._structArray.uint16[this._pos2 + 19];
            }
        }
        Ks.prototype.size = 40;
        class Js extends Bs {
            get(t1) {
                return new Ks(this, t1);
            }
        }
        oa(Js, "CollisionBoxArray");
        class Qs extends ds {
            get projectedAnchorX() {
                return this._structArray.int16[this._pos2 + 0];
            }
            get projectedAnchorY() {
                return this._structArray.int16[this._pos2 + 1];
            }
            get projectedAnchorZ() {
                return this._structArray.int16[this._pos2 + 2];
            }
            get tileAnchorX() {
                return this._structArray.float32[this._pos4 + 2];
            }
            get tileAnchorY() {
                return this._structArray.float32[this._pos4 + 3];
            }
            get glyphStartIndex() {
                return this._structArray.uint16[this._pos2 + 8];
            }
            get numGlyphs() {
                return this._structArray.uint16[this._pos2 + 9];
            }
            get vertexStartIndex() {
                return this._structArray.uint32[this._pos4 + 5];
            }
            get lineStartIndex() {
                return this._structArray.uint32[this._pos4 + 6];
            }
            get lineLength() {
                return this._structArray.uint32[this._pos4 + 7];
            }
            get segment() {
                return this._structArray.uint16[this._pos2 + 16];
            }
            get lowerSize() {
                return this._structArray.uint16[this._pos2 + 17];
            }
            get upperSize() {
                return this._structArray.uint16[this._pos2 + 18];
            }
            get lineOffsetX() {
                return this._structArray.float32[this._pos4 + 10];
            }
            get lineOffsetY() {
                return this._structArray.float32[this._pos4 + 11];
            }
            get writingMode() {
                return this._structArray.uint8[this._pos1 + 48];
            }
            get placedOrientation() {
                return this._structArray.uint8[this._pos1 + 49];
            }
            set placedOrientation(t1) {
                this._structArray.uint8[this._pos1 + 49] = t1;
            }
            get hidden() {
                return this._structArray.uint8[this._pos1 + 50];
            }
            set hidden(t1) {
                this._structArray.uint8[this._pos1 + 50] = t1;
            }
            get crossTileID() {
                return this._structArray.uint32[this._pos4 + 13];
            }
            set crossTileID(t1) {
                this._structArray.uint32[this._pos4 + 13] = t1;
            }
            get associatedIconIndex() {
                return this._structArray.int16[this._pos2 + 28];
            }
            get flipState() {
                return this._structArray.uint8[this._pos1 + 58];
            }
            set flipState(t1) {
                this._structArray.uint8[this._pos1 + 58] = t1;
            }
        }
        Qs.prototype.size = 60;
        class to extends Rs {
            get(t1) {
                return new Qs(this, t1);
            }
        }
        oa(to, "PlacedSymbolArray");
        class eo extends ds {
            get tileAnchorX() {
                return this._structArray.float32[this._pos4 + 0];
            }
            get tileAnchorY() {
                return this._structArray.float32[this._pos4 + 1];
            }
            get projectedAnchorX() {
                return this._structArray.int16[this._pos2 + 4];
            }
            get projectedAnchorY() {
                return this._structArray.int16[this._pos2 + 5];
            }
            get projectedAnchorZ() {
                return this._structArray.int16[this._pos2 + 6];
            }
            get rightJustifiedTextSymbolIndex() {
                return this._structArray.int16[this._pos2 + 7];
            }
            get centerJustifiedTextSymbolIndex() {
                return this._structArray.int16[this._pos2 + 8];
            }
            get leftJustifiedTextSymbolIndex() {
                return this._structArray.int16[this._pos2 + 9];
            }
            get verticalPlacedTextSymbolIndex() {
                return this._structArray.int16[this._pos2 + 10];
            }
            get placedIconSymbolIndex() {
                return this._structArray.int16[this._pos2 + 11];
            }
            get verticalPlacedIconSymbolIndex() {
                return this._structArray.int16[this._pos2 + 12];
            }
            get key() {
                return this._structArray.uint16[this._pos2 + 13];
            }
            get textBoxStartIndex() {
                return this._structArray.uint16[this._pos2 + 14];
            }
            get textBoxEndIndex() {
                return this._structArray.uint16[this._pos2 + 15];
            }
            get verticalTextBoxStartIndex() {
                return this._structArray.uint16[this._pos2 + 16];
            }
            get verticalTextBoxEndIndex() {
                return this._structArray.uint16[this._pos2 + 17];
            }
            get iconBoxStartIndex() {
                return this._structArray.uint16[this._pos2 + 18];
            }
            get iconBoxEndIndex() {
                return this._structArray.uint16[this._pos2 + 19];
            }
            get verticalIconBoxStartIndex() {
                return this._structArray.uint16[this._pos2 + 20];
            }
            get verticalIconBoxEndIndex() {
                return this._structArray.uint16[this._pos2 + 21];
            }
            get featureIndex() {
                return this._structArray.uint16[this._pos2 + 22];
            }
            get numHorizontalGlyphVertices() {
                return this._structArray.uint16[this._pos2 + 23];
            }
            get numVerticalGlyphVertices() {
                return this._structArray.uint16[this._pos2 + 24];
            }
            get numIconVertices() {
                return this._structArray.uint16[this._pos2 + 25];
            }
            get numVerticalIconVertices() {
                return this._structArray.uint16[this._pos2 + 26];
            }
            get useRuntimeCollisionCircles() {
                return this._structArray.uint16[this._pos2 + 27];
            }
            get crossTileID() {
                return this._structArray.uint32[this._pos4 + 14];
            }
            set crossTileID(t1) {
                this._structArray.uint32[this._pos4 + 14] = t1;
            }
            get textOffset0() {
                return this._structArray.float32[this._pos4 + 15];
            }
            get textOffset1() {
                return this._structArray.float32[this._pos4 + 16];
            }
            get collisionCircleDiameter() {
                return this._structArray.float32[this._pos4 + 17];
            }
            get zOffset() {
                return this._structArray.float32[this._pos4 + 18];
            }
            set zOffset(t1) {
                this._structArray.float32[this._pos4 + 18] = t1;
            }
            get hasIconTextFit() {
                return this._structArray.uint8[this._pos1 + 76];
            }
        }
        eo.prototype.size = 80;
        class ro extends Fs {
            get(t1) {
                return new eo(this, t1);
            }
        }
        oa(ro, "SymbolInstanceArray");
        class no extends Os {
            getoffsetX(t1) {
                return this.float32[1 * t1 + 0];
            }
        }
        oa(no, "GlyphOffsetArray");
        class io extends xs {
            getx(t1) {
                return this.int16[2 * t1 + 0];
            }
            gety(t1) {
                return this.int16[2 * t1 + 1];
            }
        }
        oa(io, "SymbolLineVertexArray");
        class ao extends ds {
            get featureIndex() {
                return this._structArray.uint32[this._pos4 + 0];
            }
            get sourceLayerIndex() {
                return this._structArray.uint16[this._pos2 + 2];
            }
            get bucketIndex() {
                return this._structArray.uint16[this._pos2 + 3];
            }
            get layoutVertexArrayOffset() {
                return this._structArray.uint16[this._pos2 + 4];
            }
        }
        ao.prototype.size = 12;
        class so extends Gs {
            get(t1) {
                return new ao(this, t1);
            }
        }
        oa(so, "FeatureIndexArray");
        class oo extends Ts {
            geta_centroid_pos0(t1) {
                return this.uint16[2 * t1 + 0];
            }
            geta_centroid_pos1(t1) {
                return this.uint16[2 * t1 + 1];
            }
        }
        oa(oo, "FillExtrusionCentroidArray");
        class lo extends ds {
            get a_join_normal_inside0() {
                return this._structArray.int16[this._pos2 + 0];
            }
            get a_join_normal_inside1() {
                return this._structArray.int16[this._pos2 + 1];
            }
            get a_join_normal_inside2() {
                return this._structArray.int16[this._pos2 + 2];
            }
        }
        lo.prototype.size = 6;
        class uo extends vs {
            get(t1) {
                return new lo(this, t1);
            }
        }
        oa(uo, "FillExtrusionWallArray");
        const co = ys([
            {
                name: "a_pos",
                components: 2,
                type: "Int16"
            }
        ], 4), ho = ys([
            {
                name: "a_pos_3",
                components: 3,
                type: "Int16"
            },
            {
                name: "a_pos_normal_3",
                components: 3,
                type: "Int16"
            }
        ]);
        class po {
            _prepareSegment(t1, e, r, n) {
                let i = this.segments[this.segments.length - 1];
                return t1 > po.MAX_VERTEX_ARRAY_LENGTH && ft(`Max vertices per segment is ${po.MAX_VERTEX_ARRAY_LENGTH}: bucket requested ${t1}`), (!i || i.vertexLength + t1 > po.MAX_VERTEX_ARRAY_LENGTH || i.sortKey !== n) && (i = {
                    vertexOffset: e,
                    primitiveOffset: r,
                    vertexLength: 0,
                    primitiveLength: 0
                }, void 0 !== n && (i.sortKey = n), this.segments.push(i)), i;
            }
            prepareSegment(t1, e, r, n) {
                return this._prepareSegment(t1, e.length, r.length, n);
            }
            get() {
                return this.segments;
            }
            destroy() {
                for (const t1 of this.segments)for(const e in t1.vaos)t1.vaos[e].destroy();
            }
            static simpleSegment(t1, e, r, n) {
                return new po([
                    {
                        vertexOffset: t1,
                        primitiveOffset: e,
                        vertexLength: r,
                        primitiveLength: n,
                        vaos: {},
                        sortKey: 0
                    }
                ]);
            }
            constructor(t1 = []){
                this.segments = t1;
            }
        }
        function fo(t1, e) {
            return 256 * (t1 = Q(Math.floor(t1), 0, 255)) + Q(Math.floor(e), 0, 255);
        }
        po.MAX_VERTEX_ARRAY_LENGTH = Math.pow(2, 16) - 1, oa(po, "SegmentVector");
        const mo = ys([
            {
                name: "a_pattern",
                components: 4,
                type: "Uint16"
            },
            {
                name: "a_pixel_ratio",
                components: 1,
                type: "Float32"
            }
        ]), yo = ys([
            {
                name: "a_dash",
                components: 4,
                type: "Uint16"
            }
        ]);
        class go {
            add(t1, e, r, n) {
                this.ids.push(xo(t1)), this.positions.push(e, r, n);
            }
            eachPosition(t1, e) {
                const r = xo(t1);
                let n = 0, i = this.ids.length - 1;
                for(; n < i;){
                    const t1 = n + i >> 1;
                    this.ids[t1] >= r ? i = t1 : n = t1 + 1;
                }
                for(; this.ids[n] === r;)e(this.positions[3 * n], this.positions[3 * n + 1], this.positions[3 * n + 2]), n++;
            }
            static serialize(t1, e) {
                const r = new Float64Array(t1.ids), n = new Uint32Array(t1.positions);
                return vo(r, n, 0, r.length - 1), e && (e.add(r.buffer), e.add(n.buffer)), {
                    ids: r,
                    positions: n
                };
            }
            static deserialize(t1) {
                const e = new go;
                let r;
                e.ids = t1.ids, e.positions = t1.positions;
                for (const t1 of e.ids)t1 !== r && e.uniqueIds.push(t1), r = t1;
                return e.indexed = !0, e;
            }
            constructor(){
                this.ids = [], this.uniqueIds = [], this.positions = [], this.indexed = !1;
            }
        }
        function xo(t1) {
            const e = +t1;
            return !isNaN(e) && Number.MIN_SAFE_INTEGER <= e && e <= Number.MAX_SAFE_INTEGER ? e : ge(String(t1));
        }
        function vo(t1, e, r, n) {
            for(; r < n;){
                const i = t1[r + n >> 1];
                let a = r - 1, s = n + 1;
                for(;;){
                    do a++;
                    while (t1[a] < i);
                    do s--;
                    while (t1[s] > i);
                    if (a >= s) break;
                    bo(t1, a, s), bo(e, 3 * a, 3 * s), bo(e, 3 * a + 1, 3 * s + 1), bo(e, 3 * a + 2, 3 * s + 2);
                }
                s - r < n - s ? (vo(t1, e, r, s), r = s + 1) : (vo(t1, e, s + 1, n), n = s);
            }
        }
        function bo(t1, e, r) {
            const n = t1[e];
            t1[e] = t1[r], t1[r] = n;
        }
        oa(go, "FeaturePositionMap");
        class _o {
            fetchUniformLocation(t1, e) {
                return this.location || this.initialized || (this.location = this.gl.getUniformLocation(t1, e), this.initialized = !0), !!this.location;
            }
            set(t1, e, r) {
                throw new Error("Uniform#set() must be implemented by each concrete Uniform");
            }
            constructor(t1){
                this.gl = t1.gl, this.initialized = !1;
            }
        }
        class wo extends _o {
            set(t1, e, r) {
                this.fetchUniformLocation(t1, e) && this.current !== r && (this.current = r, this.gl.uniform1i(this.location, r));
            }
            constructor(t1){
                super(t1), this.current = 0;
            }
        }
        class Mo extends _o {
            set(t1, e, r) {
                this.fetchUniformLocation(t1, e) && this.current !== r && (this.current = r, this.gl.uniform1f(this.location, r));
            }
            constructor(t1){
                super(t1), this.current = 0;
            }
        }
        class Ao extends _o {
            set(t1, e, r) {
                this.fetchUniformLocation(t1, e) && (r[0] === this.current[0] && r[1] === this.current[1] || (this.current = r, this.gl.uniform2f(this.location, r[0], r[1])));
            }
            constructor(t1){
                super(t1), this.current = [
                    0,
                    0
                ];
            }
        }
        class So extends _o {
            set(t1, e, r) {
                this.fetchUniformLocation(t1, e) && (r[0] === this.current[0] && r[1] === this.current[1] && r[2] === this.current[2] || (this.current = r, this.gl.uniform3f(this.location, r[0], r[1], r[2])));
            }
            constructor(t1){
                super(t1), this.current = [
                    0,
                    0,
                    0
                ];
            }
        }
        class Io extends _o {
            set(t1, e, r) {
                this.fetchUniformLocation(t1, e) && (r[0] === this.current[0] && r[1] === this.current[1] && r[2] === this.current[2] && r[3] === this.current[3] || (this.current = r, this.gl.uniform4f(this.location, r[0], r[1], r[2], r[3])));
            }
            constructor(t1){
                super(t1), this.current = [
                    0,
                    0,
                    0,
                    0
                ];
            }
        }
        class Po extends _o {
            set(t1, e, r) {
                this.fetchUniformLocation(t1, e) && (r.r === this.current.r && r.g === this.current.g && r.b === this.current.b && r.a === this.current.a || (this.current = r, this.gl.uniform4f(this.location, r.r, r.g, r.b, r.a)));
            }
            constructor(t1){
                super(t1), this.current = Ie.transparent.toRenderColor(null);
            }
        }
        const zo = new Float32Array(16);
        class Eo extends _o {
            set(t1, e, r) {
                if (this.fetchUniformLocation(t1, e)) {
                    if (r[12] !== this.current[12] || r[0] !== this.current[0]) return this.current = r, void this.gl.uniformMatrix4fv(this.location, !1, r);
                    for(let t1 = 1; t1 < 16; t1++)if (r[t1] !== this.current[t1]) {
                        this.current = r, this.gl.uniformMatrix4fv(this.location, !1, r);
                        break;
                    }
                }
            }
            constructor(t1){
                super(t1), this.current = zo;
            }
        }
        const ko = new Float32Array(9), To = new Float32Array(4);
        class Bo extends _o {
            set(t1, e, r) {
                if (this.fetchUniformLocation(t1, e)) {
                    for(let t1 = 0; t1 < 4; t1++)if (r[t1] !== this.current[t1]) {
                        this.current = r, this.gl.uniformMatrix2fv(this.location, !1, r);
                        break;
                    }
                }
            }
            constructor(t1){
                super(t1), this.current = To;
            }
        }
        function Co(t1) {
            return [
                fo(255 * t1.r, 255 * t1.g),
                fo(255 * t1.b, 255 * t1.a)
            ];
        }
        class Vo {
            setUniform(t1, e, r, n, i) {
                const a = n.constantOr(this.value);
                e.set(t1, i, a instanceof Ie ? a.toRenderColor(this.ignoreLut ? null : this.context.lut) : a);
            }
            getBinding(t1, e) {
                return "color" === this.type ? new Po(t1) : new Mo(t1);
            }
            constructor(t1, e, r, n){
                this.value = t1, this.uniformNames = e.map((t1)=>`u_${t1}`), this.type = r, this.context = n;
            }
        }
        class Do {
            setConstantPatternPositions(t1) {
                this.pixelRatio = t1.pixelRatio || 1, this.pattern = t1.tl.concat(t1.br);
            }
            setUniform(t1, e, r, n, i) {
                const a = "u_pattern" === i || "u_dash" === i ? this.pattern : "u_pixel_ratio" === i ? this.pixelRatio : null;
                a && e.set(t1, i, a);
            }
            getBinding(t1, e) {
                return "u_pattern" === e || "u_dash" === e ? new Io(t1) : new Mo(t1);
            }
            constructor(t1, e){
                this.uniformNames = e.map((t1)=>`u_${t1}`), this.pattern = null, this.pixelRatio = 1;
            }
        }
        class Lo {
            populatePaintArray(t1, e, r, n, i, a, s) {
                const o = this.paintVertexArray.length, l = "composite" === this.expression.kind || "source" === this.expression.kind ? this.expression.evaluate(new Ca(0, {
                    brightness: a
                }), e, {}, i, n, s) : "constant" === this.expression.kind && this.expression.value;
                !this.lutExpression || "composite" !== this.lutExpression.kind && "source" !== this.lutExpression.kind || (this.ignoreLut = "none" === this.lutExpression.evaluate(new Ca(0, {
                    brightness: a
                }), e, {}, i, n, s)), this.paintVertexArray.resize(t1), this._setPaintValue(o, t1, l, this.context);
            }
            updatePaintArray(t1, e, r, n, i, a, s) {
                const o = "composite" === this.expression.kind || "source" === this.expression.kind ? this.expression.evaluate({
                    zoom: 0,
                    brightness: s
                }, r, n, void 0, i) : "constant" === this.expression.kind && this.expression.value;
                !this.lutExpression || "composite" !== this.lutExpression.kind && "source" !== this.lutExpression.kind || (this.ignoreLut = "none" === this.lutExpression.evaluate({
                    zoom: 0,
                    brightness: s
                }, r, n, void 0, i)), this._setPaintValue(t1, e, o, this.context);
            }
            _setPaintValue(t1, e, r, n) {
                if ("color" === this.type) {
                    const i = Co(r.toRenderColor(this.ignoreLut ? null : n.lut));
                    for(let r = t1; r < e; r++)this.paintVertexArray.emplace(r, i[0], i[1]);
                } else {
                    for(let n = t1; n < e; n++)this.paintVertexArray.emplace(n, r);
                    this.maxValue = Math.max(this.maxValue, Math.abs(r));
                }
            }
            upload(t1) {
                this.paintVertexArray && this.paintVertexArray.arrayBuffer && (this.paintVertexBuffer && this.paintVertexBuffer.buffer ? this.paintVertexBuffer.updateData(this.paintVertexArray) : this.paintVertexBuffer = t1.createVertexBuffer(this.paintVertexArray, this.paintVertexAttributes, this.lutExpression && "constant" !== this.lutExpression.kind && (this.lutExpression.isStateDependent || !this.lutExpression.isLightConstant) || "constant" !== this.expression.kind && (this.expression.isStateDependent || !this.expression.isLightConstant)));
            }
            destroy() {
                this.paintVertexBuffer && this.paintVertexBuffer.destroy();
            }
            constructor(t1, e, r, n){
                this.expression = t1, this.type = r, this.maxValue = 0, this.paintVertexAttributes = e.map((t1)=>({
                        name: `a_${t1}`,
                        type: "Float32",
                        components: "color" === r ? 2 : 1,
                        offset: 0
                    })), this.paintVertexArray = new n;
            }
        }
        class Ro {
            populatePaintArray(t1, e, r, n, i, a, s) {
                const o = this.expression.evaluate(new Ca(this.context.zoom, {
                    brightness: a
                }), e, {}, i, n, s), l = this.expression.evaluate(new Ca(this.context.zoom + 1, {
                    brightness: a
                }), e, {}, i, n, s);
                !this.lutExpression || "composite" !== this.lutExpression.kind && "source" !== this.lutExpression.kind || (this.ignoreLut = "none" === this.lutExpression.evaluate(new Ca(this.context.zoom, {
                    brightness: a
                }), e, {}, i, n, s));
                const u = this.paintVertexArray.length;
                this.paintVertexArray.resize(t1), this._setPaintValue(u, t1, o, l, this.context);
            }
            updatePaintArray(t1, e, r, n, i, a, s) {
                const o = this.expression.evaluate({
                    zoom: this.context.zoom,
                    brightness: s
                }, r, n, void 0, i), l = this.expression.evaluate({
                    zoom: this.context.zoom + 1,
                    brightness: s
                }, r, n, void 0, i);
                !this.lutExpression || "composite" !== this.lutExpression.kind && "source" !== this.lutExpression.kind || (this.ignoreLut = "none" === this.lutExpression.evaluate({
                    zoom: this.context.zoom,
                    brightness: s
                }, r, n, void 0, i)), this._setPaintValue(t1, e, o, l, this.context);
            }
            _setPaintValue(t1, e, r, n, i) {
                if ("color" === this.type) {
                    const n = Co(r.toRenderColor(this.ignoreLut ? null : i.lut)), a = Co(r.toRenderColor(this.ignoreLut ? null : i.lut));
                    for(let r = t1; r < e; r++)this.paintVertexArray.emplace(r, n[0], n[1], a[0], a[1]);
                } else {
                    for(let i = t1; i < e; i++)this.paintVertexArray.emplace(i, r, n);
                    this.maxValue = Math.max(this.maxValue, Math.abs(r), Math.abs(n));
                }
            }
            upload(t1) {
                this.paintVertexArray && this.paintVertexArray.arrayBuffer && (this.paintVertexBuffer && this.paintVertexBuffer.buffer ? this.paintVertexBuffer.updateData(this.paintVertexArray) : this.paintVertexBuffer = t1.createVertexBuffer(this.paintVertexArray, this.paintVertexAttributes, this.expression.isStateDependent || !this.expression.isLightConstant));
            }
            destroy() {
                this.paintVertexBuffer && this.paintVertexBuffer.destroy();
            }
            setUniform(t1, e, r, n, i) {
                const a = this.useIntegerZoom ? Math.floor(r.zoom) : r.zoom, s = Q(this.expression.interpolationFactor(a, this.context.zoom, this.context.zoom + 1), 0, 1);
                e.set(t1, i, s);
            }
            getBinding(t1, e) {
                return new Mo(t1);
            }
            constructor(t1, e, r, n, i, a){
                this.expression = t1, this.uniformNames = e.map((t1)=>`u_${t1}_t`), this.type = r, this.useIntegerZoom = n, this.context = i, this.maxValue = 0, this.paintVertexAttributes = e.map((t1)=>({
                        name: `a_${t1}`,
                        type: "Float32",
                        components: "color" === r ? 4 : 2,
                        offset: 0
                    })), this.paintVertexArray = new a;
            }
        }
        class Fo {
            populatePaintArray(t1, e, r, n) {
                const i = this.paintVertexArray.length;
                this.paintVertexArray.resize(t1), this._setPaintValues(i, t1, e.patterns && e.patterns[this.layerId], r);
            }
            updatePaintArray(t1, e, r, n, i, a, s) {
                this._setPaintValues(t1, e, r.patterns && r.patterns[this.layerId], a);
            }
            _setPaintValues(t1, e, r, n) {
                if (!n || !r) return;
                const i = n[r];
                if (!i) return;
                const { tl: a, br: s, pixelRatio: o } = i;
                for(let r = t1; r < e; r++)this.paintVertexArray.emplace(r, a[0], a[1], s[0], s[1], o);
            }
            upload(t1) {
                this.paintVertexArray && this.paintVertexArray.arrayBuffer && (this.paintVertexBuffer = t1.createVertexBuffer(this.paintVertexArray, this.paintVertexAttributes, this.expression.isStateDependent || !this.expression.isLightConstant));
            }
            destroy() {
                this.paintVertexBuffer && this.paintVertexBuffer.destroy();
            }
            constructor(t1, e, r, n, i){
                this.expression = t1, this.layerId = i, this.paintVertexAttributes = ("array" === r ? yo : mo).members;
                for(let t1 = 0; t1 < e.length; ++t1);
                this.paintVertexArray = new n;
            }
        }
        class Oo {
            getMaxValue(t1) {
                const e = this.binders[t1];
                return e instanceof Lo || e instanceof Ro ? e.maxValue : 0;
            }
            populatePaintArrays(t1, e, r, n, i, a, s) {
                for(const o in this.binders){
                    const l = this.binders[o];
                    l.context = this.context, l instanceof Lo || l instanceof Ro || l instanceof Fo ? l.populatePaintArray(t1, e, r, n, i, a, s) : l.lutExpression && l instanceof Vo && l.lutExpression && ("composite" === l.lutExpression.kind || "source" === l.lutExpression.kind) && (l.ignoreLut = "none" === l.lutExpression.evaluate(new Ca(0, {
                        brightness: a
                    }), e, {}, i, n, s));
                }
            }
            setConstantPatternPositions(t1) {
                for(const e in this.binders){
                    const r = this.binders[e];
                    r instanceof Do && r.setConstantPatternPositions(t1);
                }
            }
            updatePaintArrays(t1, e, r, n, i, a, s, o, l) {
                let u = !1;
                const c = Object.keys(t1), h = 0 !== c.length && !o, p = h ? c : e.uniqueIds;
                this.context.lut = i.lut;
                for(const o in this.binders){
                    const c = this.binders[o];
                    if (c.context = this.context, (c instanceof Lo || c instanceof Ro || c instanceof Fo) && c.expression && c.expression.kind && "constant" !== c.expression.kind && (!0 === c.expression.isStateDependent || !1 === c.expression.isLightConstant)) {
                        const f = i.paint.get(o);
                        c.expression = f.value;
                        for (const r of p){
                            const i = t1[r.toString()];
                            e.eachPosition(r, (t1, e, r)=>{
                                const o = n.feature(t1);
                                c.updatePaintArray(e, r, o, i, a, s, l);
                            });
                        }
                        if (!h) for (const e of r.uniqueIds){
                            const i = t1[e.toString()];
                            r.eachPosition(e, (t1, e, r)=>{
                                const o = n.feature(t1);
                                c.updatePaintArray(e, r, o, i, a, s, l);
                            });
                        }
                        u = !0;
                    }
                }
                return u;
            }
            defines() {
                const t1 = [];
                for(const e in this.binders){
                    const r = this.binders[e];
                    (r instanceof Vo || r instanceof Do) && t1.push(...r.uniformNames.map((t1)=>`#define HAS_UNIFORM_${t1}`));
                }
                return t1;
            }
            getBinderAttributes() {
                const t1 = [];
                for(const e in this.binders){
                    const r = this.binders[e];
                    if (r instanceof Lo || r instanceof Ro || r instanceof Fo) for(let e = 0; e < r.paintVertexAttributes.length; e++)t1.push(r.paintVertexAttributes[e].name);
                }
                return t1;
            }
            getBinderUniforms() {
                const t1 = [];
                for(const e in this.binders){
                    const r = this.binders[e];
                    if (r instanceof Vo || r instanceof Do || r instanceof Ro) for (const e of r.uniformNames)t1.push(e);
                }
                return t1;
            }
            getPaintVertexBuffers() {
                return this._buffers;
            }
            getUniforms(t1) {
                const e = [];
                for(const r in this.binders){
                    const n = this.binders[r];
                    if (n instanceof Vo || n instanceof Do || n instanceof Ro) for (const i of n.uniformNames)e.push({
                        name: i,
                        property: r,
                        binding: n.getBinding(t1, i)
                    });
                }
                return e;
            }
            setUniforms(t1, e, r, n, i) {
                for (const { name: e, property: a, binding: s } of r){
                    if (this.binders[a].checkUseTheme && this.binders[a] instanceof Vo) {
                        const t1 = n.get(`${a}-use-theme`);
                        t1.isConstant() && (this.binders[a].ignoreLut = "none" === t1.constantOr("default"));
                    }
                    this.binders[a].setUniform(t1, s, i, n.get(a), e);
                }
            }
            updatePaintBuffers() {
                this._buffers = [];
                for(const t1 in this.binders){
                    const e = this.binders[t1];
                    (e instanceof Lo || e instanceof Ro || e instanceof Fo) && e.paintVertexBuffer && this._buffers.push(e.paintVertexBuffer);
                }
            }
            upload(t1) {
                for(const e in this.binders){
                    const r = this.binders[e];
                    (r instanceof Lo || r instanceof Ro || r instanceof Fo) && r.upload(t1);
                }
                this.updatePaintBuffers();
            }
            destroy() {
                for(const t1 in this.binders){
                    const e = this.binders[t1];
                    (e instanceof Lo || e instanceof Ro || e instanceof Fo) && e.destroy();
                }
            }
            constructor(t1, e, r = ()=>!0){
                this.binders = {}, this._buffers = [], this.context = e;
                const n = [];
                for(const i in t1.paint._values){
                    const a = t1.paint.get(i), s = t1.paint.get(`${i}-use-theme`);
                    if (i.endsWith("-use-theme")) continue;
                    if (!r(i)) continue;
                    if (!(a instanceof Na && Li(a.property.specification))) continue;
                    const o = jo(i, t1.type), l = a.value, u = a.property.specification.type, c = !!a.property.useIntegerZoom, h = "line-dasharray" === i || i.endsWith("pattern"), p = "line-dasharray" === i && "constant" !== t1.layout.get("line-cap").value.kind || s && "constant" !== s.value.kind;
                    if ("constant" !== l.kind || p) {
                        if ("source" === l.kind || p || h) {
                            const e = Go(i, u, "source");
                            this.binders[i] = h ? new Fo(l, o, u, e, t1.id) : new Lo(l, o, u, e), n.push(`/a_${i}`);
                        } else {
                            const t1 = Go(i, u, "composite");
                            this.binders[i] = new Ro(l, o, u, c, e, t1), n.push(`/z_${i}`);
                        }
                    } else this.binders[i] = h ? new Do(l.value, o) : new Vo(l.value, o, u, e), n.push(`/u_${i}`);
                    s && (this.binders[i].ignoreLut = "none" === s.constantOr("default"), this.binders[i].lutExpression = s.value, this.binders[i].checkUseTheme = !0);
                }
                this.cacheKey = n.sort().join("");
            }
        }
        class No {
            populatePaintArrays(t1, e, r, n, i, a, s, o) {
                for(const r in this.programConfigurations)this.programConfigurations[r].populatePaintArrays(t1, e, n, i, a, s, o);
                void 0 !== e.id ? this._featureMap.add(e.id, r, this._bufferOffset, t1) : (this._featureMapWithoutIds.add(this._idlessCounter, r, this._bufferOffset, t1), this._idlessCounter += 1), this._bufferOffset = t1, this.needsUpload = !0;
            }
            updatePaintArrays(t1, e, r, n, i, a, s) {
                for (const o of r)this.needsUpload = this.programConfigurations[o.id].updatePaintArrays(t1, this._featureMap, this._featureMapWithoutIds, e, o, n, i, a, s || 0) || this.needsUpload;
            }
            get(t1) {
                return this.programConfigurations[t1];
            }
            upload(t1) {
                if (this.needsUpload) {
                    for(const e in this.programConfigurations)this.programConfigurations[e].upload(t1);
                    this.needsUpload = !1;
                }
            }
            destroy() {
                for(const t1 in this.programConfigurations)this.programConfigurations[t1].destroy();
            }
            constructor(t1, e, r = ()=>!0){
                this.programConfigurations = {};
                for (const n of t1)this.programConfigurations[n.id] = new Oo(n, e, r);
                this.needsUpload = !1, this._featureMap = new go, this._featureMapWithoutIds = new go, this._bufferOffset = 0, this._idlessCounter = 0;
            }
        }
        const Uo = {
            "text-opacity": [
                "opacity"
            ],
            "icon-opacity": [
                "opacity"
            ],
            "text-occlusion-opacity": [
                "occlusion_opacity"
            ],
            "icon-occlusion-opacity": [
                "occlusion_opacity"
            ],
            "text-color": [
                "fill_color"
            ],
            "icon-color": [
                "fill_color"
            ],
            "text-emissive-strength": [
                "emissive_strength"
            ],
            "icon-emissive-strength": [
                "emissive_strength"
            ],
            "text-halo-color": [
                "halo_color"
            ],
            "icon-halo-color": [
                "halo_color"
            ],
            "text-halo-blur": [
                "halo_blur"
            ],
            "icon-halo-blur": [
                "halo_blur"
            ],
            "text-halo-width": [
                "halo_width"
            ],
            "icon-halo-width": [
                "halo_width"
            ],
            "symbol-z-offset": [
                "z_offset"
            ],
            "line-gap-width": [
                "gapwidth"
            ],
            "line-pattern": [
                "pattern",
                "pixel_ratio"
            ],
            "fill-pattern": [
                "pattern",
                "pixel_ratio"
            ],
            "fill-extrusion-pattern": [
                "pattern",
                "pixel_ratio"
            ],
            "line-dasharray": [
                "dash"
            ]
        };
        function jo(t1, e) {
            return Uo[t1] || [
                t1.replace(`${e}-`, "").replace(/-/g, "_")
            ];
        }
        const qo = {
            "line-pattern": {
                source: As,
                composite: As
            },
            "fill-pattern": {
                source: As,
                composite: As
            },
            "fill-extrusion-pattern": {
                source: As,
                composite: As
            },
            "line-dasharray": {
                source: Ss,
                composite: Ss
            }
        }, $o = {
            color: {
                source: $s,
                composite: Es
            },
            number: {
                source: Os,
                composite: $s
            }
        };
        function Go(t1, e, r) {
            const n = qo[t1];
            return n && n[r] || $o[e][r];
        }
        oa(Vo, "ConstantBinder"), oa(Do, "PatternConstantBinder"), oa(Lo, "SourceExpressionBinder"), oa(Fo, "PatternCompositeBinder"), oa(Ro, "CompositeExpressionBinder"), oa(Oo, "ProgramConfiguration", {
            omit: [
                "_buffers"
            ]
        }), oa(No, "ProgramConfigurationSet");
        const Yo = Wr / Math.PI / 2, Xo = 5, Zo = 6, Ho = 16383, Wo = 64, Ko = [
            Wo,
            32,
            16
        ], Jo = -Yo, Qo = Yo;
        function tl(t1, e, r, n = Yo) {
            return r = X(r), [
                t1 * Math.sin(r) * n,
                -e * n,
                t1 * Math.cos(r) * n
            ];
        }
        function el(t1, e, r) {
            return tl(Math.cos(X(t1)), Math.sin(X(t1)), e, r);
        }
        const rl = 6371008.8, nl = 2 * Math.PI * rl;
        class il {
            wrap() {
                return new il(et(this.lng, -180, 180), this.lat);
            }
            toArray() {
                return [
                    this.lng,
                    this.lat
                ];
            }
            toString() {
                return `LngLat(${this.lng}, ${this.lat})`;
            }
            distanceTo(t1) {
                const e = Math.PI / 180, r = this.lat * e, n = t1.lat * e, i = Math.sin(r) * Math.sin(n) + Math.cos(r) * Math.cos(n) * Math.cos((t1.lng - this.lng) * e);
                return rl * Math.acos(Math.min(i, 1));
            }
            toBounds(t1 = 0) {
                const e = 360 * t1 / 40075017, r = e / Math.cos(Math.PI / 180 * this.lat);
                return new al({
                    lng: this.lng - r,
                    lat: this.lat - e
                }, {
                    lng: this.lng + r,
                    lat: this.lat + e
                });
            }
            toEcef(t1) {
                return el(this.lat, this.lng, Yo + t1 * Yo / rl);
            }
            static convert(t1) {
                if (t1 instanceof il) return t1;
                if (Array.isArray(t1) && (2 === t1.length || 3 === t1.length)) return new il(Number(t1[0]), Number(t1[1]));
                if (!Array.isArray(t1) && "object" == typeof t1 && null !== t1) return new il(Number("lng" in t1 ? t1.lng : t1.lon), Number(t1.lat));
                throw new Error("`LngLatLike` argument must be specified as a LngLat instance, an object {lng: <lng>, lat: <lat>}, an object {lon: <lng>, lat: <lat>}, or an array of [<lng>, <lat>]");
            }
            constructor(t1, e){
                if (isNaN(t1) || isNaN(e)) throw new Error(`Invalid LngLat object: (${t1}, ${e})`);
                if (this.lng = +t1, this.lat = +e, this.lat > 90 || this.lat < -90) throw new Error("Invalid LngLat latitude value: must be between -90 and 90");
            }
        }
        class al {
            setNorthEast(t1) {
                return this._ne = t1 instanceof il ? new il(t1.lng, t1.lat) : il.convert(t1), this;
            }
            setSouthWest(t1) {
                return this._sw = t1 instanceof il ? new il(t1.lng, t1.lat) : il.convert(t1), this;
            }
            extend(t1) {
                const e = this._sw, r = this._ne;
                let n, i;
                if (t1 instanceof il) n = t1, i = t1;
                else {
                    if (!(t1 instanceof al)) return Array.isArray(t1) ? 4 === t1.length || t1.every(Array.isArray) ? this.extend(al.convert(t1)) : this.extend(il.convert(t1)) : "object" == typeof t1 && null !== t1 && t1.hasOwnProperty("lat") && (t1.hasOwnProperty("lon") || t1.hasOwnProperty("lng")) ? this.extend(il.convert(t1)) : this;
                    if (n = t1._sw, i = t1._ne, !n || !i) return this;
                }
                return e || r ? (e.lng = Math.min(n.lng, e.lng), e.lat = Math.min(n.lat, e.lat), r.lng = Math.max(i.lng, r.lng), r.lat = Math.max(i.lat, r.lat)) : (this._sw = new il(n.lng, n.lat), this._ne = new il(i.lng, i.lat)), this;
            }
            getCenter() {
                return new il((this._sw.lng + this._ne.lng) / 2, (this._sw.lat + this._ne.lat) / 2);
            }
            getSouthWest() {
                return this._sw;
            }
            getNorthEast() {
                return this._ne;
            }
            getNorthWest() {
                return new il(this.getWest(), this.getNorth());
            }
            getSouthEast() {
                return new il(this.getEast(), this.getSouth());
            }
            getWest() {
                return this._sw.lng;
            }
            getSouth() {
                return this._sw.lat;
            }
            getEast() {
                return this._ne.lng;
            }
            getNorth() {
                return this._ne.lat;
            }
            toArray() {
                return [
                    this._sw.toArray(),
                    this._ne.toArray()
                ];
            }
            toString() {
                return `LngLatBounds(${this._sw.toString()}, ${this._ne.toString()})`;
            }
            isEmpty() {
                return !(this._sw && this._ne);
            }
            contains(t1) {
                const { lng: e, lat: r } = il.convert(t1);
                let n = this._sw.lng <= e && e <= this._ne.lng;
                return this._sw.lng > this._ne.lng && (n = this._sw.lng >= e && e >= this._ne.lng), this._sw.lat <= r && r <= this._ne.lat && n;
            }
            static convert(t1) {
                if (t1) return t1 instanceof al ? t1 : new al(t1);
            }
            constructor(t1, e){
                if (t1) {
                    if (e) this.setSouthWest(t1).setNorthEast(e);
                    else if (4 === t1.length) {
                        const e = t1;
                        this.setSouthWest([
                            e[0],
                            e[1]
                        ]).setNorthEast([
                            e[2],
                            e[3]
                        ]);
                    } else {
                        const e = t1;
                        this.setSouthWest(e[0]).setNorthEast(e[1]);
                    }
                }
            }
        }
        const sl = 0, ol = 25.5;
        function ll(t1) {
            return nl * Math.cos(t1 * Math.PI / 180);
        }
        function ul(t1) {
            return (180 + t1) / 360;
        }
        function cl(t1) {
            return (180 - 180 / Math.PI * Math.log(Math.tan(Math.PI / 4 + t1 * Math.PI / 360))) / 360;
        }
        function hl(t1, e) {
            return t1 / ll(e);
        }
        function pl(t1) {
            return 360 * t1 - 180;
        }
        function fl(t1) {
            return 360 / Math.PI * Math.atan(Math.exp((180 - 360 * t1) * Math.PI / 180)) - 90;
        }
        function dl(t1, e) {
            return t1 * ll(fl(e));
        }
        const ml = 85.051129;
        function yl(t1) {
            return Math.cos(X(Q(t1, -ml, ml)));
        }
        function gl(t1, e) {
            const r = Q(e, sl, ol), n = Math.pow(2, r);
            return yl(t1) * nl / (512 * n);
        }
        function xl(t1) {
            return 1 / Math.cos(t1 * Math.PI / 180);
        }
        function vl(t1, e = 0) {
            const r = Math.exp(Math.PI * (1 - (t1.y + e / Wr) / (1 << t1.z) * 2));
            return 80150034 * r / (r * r + 1) / Wr / (1 << t1.z);
        }
        class bl {
            static fromLngLat(t1, e = 0) {
                const r = il.convert(t1);
                return new bl(ul(r.lng), cl(r.lat), hl(e, r.lat));
            }
            toLngLat() {
                return new il(pl(this.x), fl(this.y));
            }
            toAltitude() {
                return dl(this.z, this.y);
            }
            meterInMercatorCoordinateUnits() {
                return 1 / nl * xl(fl(this.y));
            }
            constructor(t1, e, r = 0){
                this.x = +t1, this.y = +e, this.z = +r;
            }
        }
        function _l(t1, e, r, n, i, a, s, o, l) {
            const u = (e + n) / 2, c = (r + i) / 2, h = new q(u, c);
            o(h), function(t1, e, r, n, i, a) {
                const s = r - i, o = n - a;
                return Math.abs((n - e) * s - (r - t1) * o) / Math.hypot(s, o);
            }(h.x, h.y, a.x, a.y, s.x, s.y) >= l ? (_l(t1, e, r, u, c, a, h, o, l), _l(t1, u, c, n, i, h, s, o, l)) : t1.push(s);
        }
        function wl(t1, e, r) {
            let n = t1[0], i = n.x, a = n.y;
            e(n);
            const s = [
                n
            ];
            for(let o = 1; o < t1.length; o++){
                const l = t1[o], { x: u, y: c } = l;
                e(l), _l(s, i, a, u, c, n, l, e, r), i = u, a = c, n = l;
            }
            return s;
        }
        function Ml(t1, e, r, n) {
            if (n(e, r)) {
                const i = e.add(r)._mult(.5);
                Ml(t1, e, i, n), Ml(t1, i, r, n);
            } else t1.push(r);
        }
        function Al(t1, e) {
            let r = t1[0];
            const n = [
                r
            ];
            for(let i = 1; i < t1.length; i++){
                const a = t1[i];
                Ml(n, r, a, e), r = a;
            }
            return n;
        }
        const Sl = Math.pow(2, 14) - 1, Il = -Sl - 1;
        function Pl(t1, e) {
            const r = Math.round(t1.x * e), n = Math.round(t1.y * e);
            return t1.x = Q(r, Il, Sl), t1.y = Q(n, Il, Sl), (r < t1.x || r > t1.x + 1 || n < t1.y || n > t1.y + 1) && ft("Geometry exceeds allowed extent, reduce your vector tile buffer size"), t1;
        }
        function zl(t1, e, r) {
            const n = t1.loadGeometry(), i = t1.extent, a = Wr / i;
            if (e && r && r.projection.isReprojectedInTileSpace) {
                const a = 1 << e.z, { scale: s, x: o, y: l, projection: u } = r, c = (t1)=>{
                    const r = pl((e.x + t1.x / i) / a), n = fl((e.y + t1.y / i) / a), c = u.project(r, n);
                    t1.x = (c.x * s - o) * i, t1.y = (c.y * s - l) * i;
                };
                for(let e = 0; e < n.length; e++)if (1 !== t1.type) n[e] = wl(n[e], c, 1);
                else {
                    const t1 = [];
                    for (const r of n[e])r.x < 0 || r.x >= i || r.y < 0 || r.y >= i || (c(r), t1.push(r));
                    n[e] = t1;
                }
            }
            for (const t1 of n)for (const e of t1)Pl(e, a);
            return n;
        }
        function El(t1, e) {
            return {
                type: t1.type,
                id: t1.id,
                properties: t1.properties,
                geometry: e ? zl(t1) : []
            };
        }
        function kl(t1, e, r, n, i) {
            t1.emplaceBack(2 * e + (n + 1) / 2, 2 * r + (i + 1) / 2);
        }
        function Tl(t1, e, r) {
            const n = 16384;
            t1.emplaceBack(e.x, e.y, e.z, r[0] * n, r[1] * n, r[2] * n);
        }
        class Bl {
            updateFootprints(t1, e) {}
            populate(t1, e, r, n) {
                const i = this.layers[0], a = [];
                let s = null;
                "circle" === i.type && (s = i.layout.get("circle-sort-key"));
                for (const { feature: e, id: i, index: o, sourceLayerIndex: l } of t1){
                    const t1 = this.layers[0]._featureFilter.needGeometry, u = El(e, t1);
                    if (!this.layers[0]._featureFilter.filter(new Ca(this.zoom), u, r)) continue;
                    const c = s ? s.evaluate(u, {}, r) : void 0, h = {
                        id: i,
                        properties: e.properties,
                        type: e.type,
                        sourceLayerIndex: l,
                        index: o,
                        geometry: t1 ? u.geometry : zl(e, r, n),
                        patterns: {},
                        sortKey: c
                    };
                    a.push(h);
                }
                s && a.sort((t1, e)=>t1.sortKey - e.sortKey);
                let o = null;
                "globe" === n.projection.name && (this.globeExtVertexArray = new Is, o = n.projection);
                for (const n of a){
                    const { geometry: i, index: a, sourceLayerIndex: s } = n, l = t1[a].feature;
                    this.addFeature(n, i, a, e.availableImages, r, o, e.brightness), e.featureIndex.insert(l, i, a, s, this.index);
                }
            }
            update(t1, e, r, n, i, a, s) {
                this.programConfigurations.updatePaintArrays(t1, e, i, r, n, a, s);
            }
            isEmpty() {
                return 0 === this.layoutVertexArray.length;
            }
            uploadPending() {
                return !this.uploaded || this.programConfigurations.needsUpload;
            }
            upload(t1) {
                this.uploaded || (this.layoutVertexBuffer = t1.createVertexBuffer(this.layoutVertexArray, co.members), this.indexBuffer = t1.createIndexBuffer(this.indexArray), this.globeExtVertexArray && (this.globeExtVertexBuffer = t1.createVertexBuffer(this.globeExtVertexArray, ho.members))), this.programConfigurations.upload(t1), this.uploaded = !0;
            }
            destroy() {
                this.layoutVertexBuffer && (this.layoutVertexBuffer.destroy(), this.indexBuffer.destroy(), this.programConfigurations.destroy(), this.segments.destroy(), this.globeExtVertexBuffer && this.globeExtVertexBuffer.destroy());
            }
            addFeature(t1, e, r, n, i, a, s) {
                for (const r of e)for (const e of r){
                    const r = e.x, n = e.y;
                    if (r < 0 || r >= Wr || n < 0 || n >= Wr) continue;
                    if (a) {
                        const t1 = a.projectTilePoint(r, n, i), e = a.upVector(i, r, n), s = this.globeExtVertexArray;
                        Tl(s, t1, e), Tl(s, t1, e), Tl(s, t1, e), Tl(s, t1, e);
                    }
                    const s = this.segments.prepareSegment(4, this.layoutVertexArray, this.indexArray, t1.sortKey), o = s.vertexLength;
                    kl(this.layoutVertexArray, r, n, -1, -1), kl(this.layoutVertexArray, r, n, 1, -1), kl(this.layoutVertexArray, r, n, 1, 1), kl(this.layoutVertexArray, r, n, -1, 1), this.indexArray.emplaceBack(o, o + 1, o + 2), this.indexArray.emplaceBack(o, o + 2, o + 3), s.vertexLength += 4, s.primitiveLength += 2;
                }
                this.programConfigurations.populatePaintArrays(this.layoutVertexArray.length, t1, r, {}, n, i, s);
            }
            constructor(t1){
                this.zoom = t1.zoom, this.overscaling = t1.overscaling, this.layers = t1.layers, this.layerIds = this.layers.map((t1)=>t1.fqid), this.index = t1.index, this.hasPattern = !1, this.projection = t1.projection, this.layoutVertexArray = new xs, this.indexArray = new Ls, this.segments = new po, this.programConfigurations = new No(t1.layers, {
                    zoom: t1.zoom,
                    lut: t1.lut
                }), this.stateDependentLayerIds = this.layers.filter((t1)=>t1.isStateDependent()).map((t1)=>t1.id);
            }
        }
        function Cl(t1, e) {
            for(let r = 0; r < t1.length; r++)if (jl(e, t1[r])) return !0;
            for(let r = 0; r < e.length; r++)if (jl(t1, e[r])) return !0;
            return !!Rl(t1, e);
        }
        function Vl(t1, e, r) {
            return !!jl(t1, e) || !!Ol(e, t1, r);
        }
        function Dl(t1, e) {
            if (1 === t1.length) return Ul(e, t1[0]);
            for(let r = 0; r < e.length; r++){
                const n = e[r];
                for(let e = 0; e < n.length; e++)if (jl(t1, n[e])) return !0;
            }
            for(let r = 0; r < t1.length; r++)if (Ul(e, t1[r])) return !0;
            for(let r = 0; r < e.length; r++)if (Rl(t1, e[r])) return !0;
            return !1;
        }
        function Ll(t1, e, r) {
            if (t1.length > 1) {
                if (Rl(t1, e)) return !0;
                for(let n = 0; n < e.length; n++)if (Ol(e[n], t1, r)) return !0;
            }
            for(let n = 0; n < t1.length; n++)if (Ol(t1[n], e, r)) return !0;
            return !1;
        }
        function Rl(t1, e) {
            if (0 === t1.length || 0 === e.length) return !1;
            for(let r = 0; r < t1.length - 1; r++){
                const n = t1[r], i = t1[r + 1];
                for(let t1 = 0; t1 < e.length - 1; t1++)if (Fl(n, i, e[t1], e[t1 + 1])) return !0;
            }
            return !1;
        }
        function Fl(t1, e, r, n) {
            return dt(t1, r, n) !== dt(e, r, n) && dt(t1, e, r) !== dt(t1, e, n);
        }
        function Ol(t1, e, r) {
            const n = r * r;
            if (1 === e.length) return t1.distSqr(e[0]) < n;
            for(let r = 1; r < e.length; r++)if (Nl(t1, e[r - 1], e[r]) < n) return !0;
            return !1;
        }
        function Nl(t1, e, r) {
            const n = e.distSqr(r);
            if (0 === n) return t1.distSqr(e);
            const i = ((t1.x - e.x) * (r.x - e.x) + (t1.y - e.y) * (r.y - e.y)) / n;
            return t1.distSqr(i < 0 ? e : i > 1 ? r : r.sub(e)._mult(i)._add(e));
        }
        function Ul(t1, e) {
            let r, n, i, a = !1;
            for(let s = 0; s < t1.length; s++){
                r = t1[s];
                for(let t1 = 0, s = r.length - 1; t1 < r.length; s = t1++)n = r[t1], i = r[s], n.y > e.y != i.y > e.y && e.x < (i.x - n.x) * (e.y - n.y) / (i.y - n.y) + n.x && (a = !a);
            }
            return a;
        }
        function jl(t1, e) {
            let r = !1;
            for(let n = 0, i = t1.length - 1; n < t1.length; i = n++){
                const a = t1[n], s = t1[i];
                a.y > e.y != s.y > e.y && e.x < (s.x - a.x) * (e.y - a.y) / (s.y - a.y) + a.x && (r = !r);
            }
            return r;
        }
        function ql(t1, e, r, n, i) {
            for (const a of t1)if (e <= a.x && r <= a.y && n >= a.x && i >= a.y) return !0;
            const a = [
                new q(e, r),
                new q(e, i),
                new q(n, i),
                new q(n, r)
            ];
            if (t1.length > 2) {
                for (const e of a)if (jl(t1, e)) return !0;
            }
            for(let e = 0; e < t1.length - 1; e++)if ($l(t1[e], t1[e + 1], a)) return !0;
            return !1;
        }
        function $l(t1, e, r) {
            const n = r[0], i = r[2];
            if (t1.x < n.x && e.x < n.x || t1.x > i.x && e.x > i.x || t1.y < n.y && e.y < n.y || t1.y > i.y && e.y > i.y) return !1;
            const a = dt(t1, e, r[0]);
            return a !== dt(t1, e, r[1]) || a !== dt(t1, e, r[2]) || a !== dt(t1, e, r[3]);
        }
        function Gl(t1, e, r, n, i, a) {
            let s = e.y - t1.y, o = t1.x - e.x;
            if (a = a || 0) {
                const t1 = s * s + o * o;
                if (0 === t1) return !0;
                const e = Math.sqrt(t1);
                s /= e, o /= e;
            }
            return !((r.x - t1.x) * s + (r.y - t1.y) * o - a < 0 || (n.x - t1.x) * s + (n.y - t1.y) * o - a < 0 || (i.x - t1.x) * s + (i.y - t1.y) * o - a < 0);
        }
        function Yl(t1, e, r, n, i, a, s) {
            return !(Gl(t1, e, n, i, a, s) || Gl(e, r, n, i, a, s) || Gl(r, t1, n, i, a, s) || Gl(n, i, t1, e, r, s) || Gl(i, a, t1, e, r, s) || Gl(a, n, t1, e, r, s));
        }
        function Xl(t1, e, r) {
            const n = e.paint.get(t1).value;
            return "constant" === n.kind ? n.value : r.programConfigurations.get(e.id).getMaxValue(t1);
        }
        function Zl(t1) {
            return Math.sqrt(t1[0] * t1[0] + t1[1] * t1[1]);
        }
        function Hl(t1, e, r, n, i) {
            if (!e[0] && !e[1]) return t1;
            const a = q.convert(e)._mult(i);
            "viewport" === r && a._rotate(-n);
            const s = [];
            for(let e = 0; e < t1.length; e++)s.push(t1[e].sub(a));
            return s;
        }
        function Wl(t1, e, r, n) {
            const i = q.convert(t1)._mult(n);
            return "viewport" === e && i._rotate(-r), i;
        }
        let Kl, Jl;
        oa(Bl, "CircleBucket", {
            omit: [
                "layers"
            ]
        });
        var Ql, tu = {
            exports: {}
        }, eu = (Ql || (Ql = 1, function(t1, e) {
            !function(t1) {
                function e(t1, e, n) {
                    var i = r(256 * t1, 256 * (e = Math.pow(2, n) - e - 1), n), a = r(256 * (t1 + 1), 256 * (e + 1), n);
                    return i[0] + "," + i[1] + "," + a[0] + "," + a[1];
                }
                function r(t1, e, r) {
                    var n = 2 * Math.PI * 6378137 / 256 / Math.pow(2, r);
                    return [
                        t1 * n - 2 * Math.PI * 6378137 / 2,
                        e * n - 2 * Math.PI * 6378137 / 2
                    ];
                }
                t1.getURL = function(t1, r, n, i, a, s) {
                    return s = s || {}, t1 + "?" + [
                        "bbox=" + e(n, i, a),
                        "format=" + (s.format || "image/png"),
                        "service=" + (s.service || "WMS"),
                        "version=" + (s.version || "1.1.1"),
                        "request=" + (s.request || "GetMap"),
                        "srs=" + (s.srs || "EPSG:3857"),
                        "width=" + (s.width || 256),
                        "height=" + (s.height || 256),
                        "layers=" + r
                    ].join("&");
                }, t1.getTileBBox = e, t1.getMercCoords = r, Object.defineProperty(t1, "__esModule", {
                    value: !0
                });
            }(e);
        }(0, tu.exports)), tu.exports);
        class ru {
            equals(t1) {
                return this.z === t1.z && this.x === t1.x && this.y === t1.y;
            }
            url(t1, e) {
                const r = eu.getTileBBox(this.x, this.y, this.z), n = function(t1, e, r) {
                    let n, i = "";
                    for(let a = t1; a > 0; a--)n = 1 << a - 1, i += (e & n ? 1 : 0) + (r & n ? 2 : 0);
                    return i;
                }(this.z, this.x, this.y);
                return t1[(this.x + this.y) % t1.length].replace("{prefix}", (this.x % 16).toString(16) + (this.y % 16).toString(16)).replace(/{z}/g, String(this.z)).replace(/{x}/g, String(this.x)).replace(/{y}/g, String("tms" === e ? Math.pow(2, this.z) - this.y - 1 : this.y)).replace("{quadkey}", n).replace("{bbox-epsg-3857}", r);
            }
            toString() {
                return `${this.z}/${this.x}/${this.y}`;
            }
            constructor(t1, e, r){
                this.z = t1, this.x = e, this.y = r, this.key = au(0, t1, t1, e, r);
            }
        }
        class nu {
            constructor(t1, e){
                this.wrap = t1, this.canonical = e, this.key = au(t1, e.z, e.z, e.x, e.y);
            }
        }
        class iu {
            equals(t1) {
                return this.overscaledZ === t1.overscaledZ && this.wrap === t1.wrap && this.canonical.equals(t1.canonical);
            }
            scaledTo(t1) {
                const e = this.canonical.z - t1;
                return t1 > this.canonical.z ? new iu(t1, this.wrap, this.canonical.z, this.canonical.x, this.canonical.y) : new iu(t1, this.wrap, t1, this.canonical.x >> e, this.canonical.y >> e);
            }
            calculateScaledKey(t1, e = !0) {
                if (this.overscaledZ === t1 && e) return this.key;
                if (t1 > this.canonical.z) return au(this.wrap * +e, t1, this.canonical.z, this.canonical.x, this.canonical.y);
                {
                    const r = this.canonical.z - t1;
                    return au(this.wrap * +e, t1, t1, this.canonical.x >> r, this.canonical.y >> r);
                }
            }
            isChildOf(t1) {
                if (t1.wrap !== this.wrap) return !1;
                const e = this.canonical.z - t1.canonical.z;
                return 0 === t1.overscaledZ || t1.overscaledZ < this.overscaledZ && t1.canonical.z < this.canonical.z && t1.canonical.x === this.canonical.x >> e && t1.canonical.y === this.canonical.y >> e;
            }
            children(t1) {
                if (this.overscaledZ >= t1) return [
                    new iu(this.overscaledZ + 1, this.wrap, this.canonical.z, this.canonical.x, this.canonical.y)
                ];
                const e = this.canonical.z + 1, r = 2 * this.canonical.x, n = 2 * this.canonical.y;
                return [
                    new iu(e, this.wrap, e, r, n),
                    new iu(e, this.wrap, e, r + 1, n),
                    new iu(e, this.wrap, e, r, n + 1),
                    new iu(e, this.wrap, e, r + 1, n + 1)
                ];
            }
            isLessThan(t1) {
                return this.wrap < t1.wrap || !(this.wrap > t1.wrap) && (this.overscaledZ < t1.overscaledZ || !(this.overscaledZ > t1.overscaledZ) && (this.canonical.x < t1.canonical.x || !(this.canonical.x > t1.canonical.x) && this.canonical.y < t1.canonical.y));
            }
            wrapped() {
                return new iu(this.overscaledZ, 0, this.canonical.z, this.canonical.x, this.canonical.y);
            }
            unwrapTo(t1) {
                return new iu(this.overscaledZ, t1, this.canonical.z, this.canonical.x, this.canonical.y);
            }
            overscaleFactor() {
                return Math.pow(2, this.overscaledZ - this.canonical.z);
            }
            toUnwrapped() {
                return new nu(this.wrap, this.canonical);
            }
            toString() {
                return `${this.overscaledZ}/${this.canonical.x}/${this.canonical.y}`;
            }
            constructor(t1, e, r, n, i){
                this.overscaledZ = t1, this.wrap = e, this.canonical = new ru(r, +n, +i), this.key = 0 === e && t1 === r ? this.canonical.key : au(e, t1, r, n, i);
            }
        }
        function au(t1, e, r, n, i) {
            const a = 1 << Math.min(r, 22);
            let s = a * (i % a) + n % a;
            return t1 && r < 22 && (s += a * a * ((t1 < 0 ? -2 * t1 - 1 : 2 * t1) % (1 << 2 * (22 - r)))), 16 * (32 * s + r) + (e - r);
        }
        const su = [
            (t1)=>{
                let e = t1.canonical.x - 1, r = t1.wrap;
                return e < 0 && (e = (1 << t1.canonical.z) - 1, r--), new iu(t1.overscaledZ, r, t1.canonical.z, e, t1.canonical.y);
            },
            (t1)=>{
                let e = t1.canonical.x + 1, r = t1.wrap;
                return e === 1 << t1.canonical.z && (e = 0, r++), new iu(t1.overscaledZ, r, t1.canonical.z, e, t1.canonical.y);
            },
            (t1)=>new iu(t1.overscaledZ, t1.wrap, t1.canonical.z, t1.canonical.x, (0 === t1.canonical.y ? 1 << t1.canonical.z : t1.canonical.y) - 1),
            (t1)=>new iu(t1.overscaledZ, t1.wrap, t1.canonical.z, t1.canonical.x, t1.canonical.y === (1 << t1.canonical.z) - 1 ? 0 : t1.canonical.y + 1)
        ];
        oa(ru, "CanonicalTileID"), oa(iu, "OverscaledTileID", {
            omit: [
                "projMatrix",
                "expandedProjMatrix"
            ]
        });
        const ou = ys([
            {
                type: "Float32",
                name: "a_globe_pos",
                components: 3
            },
            {
                type: "Float32",
                name: "a_uv",
                components: 2
            }
        ]), { members: lu } = ou, uu = ys([
            {
                name: "a_pos_3",
                components: 3,
                type: "Int16"
            }
        ]);
        var cu = ys([
            {
                name: "a_pos",
                type: "Int16",
                components: 2
            }
        ]);
        class hu {
            intersectsPlane(t1, e, r) {
                const n = O.vec3.dot(e, this.dir);
                if (Math.abs(n) < 1e-6) return !1;
                const i = ((t1[0] - this.pos[0]) * e[0] + (t1[1] - this.pos[1]) * e[1] + (t1[2] - this.pos[2]) * e[2]) / n;
                return r[0] = this.pos[0] + this.dir[0] * i, r[1] = this.pos[1] + this.dir[1] * i, r[2] = this.pos[2] + this.dir[2] * i, !0;
            }
            closestPointOnSphere(t1, e, r) {
                if (O.vec3.equals(this.pos, t1) || 0 === e) return r[0] = r[1] = r[2] = 0, !1;
                const [n, i, a] = this.dir, s = this.pos[0] - t1[0], o = this.pos[1] - t1[1], l = this.pos[2] - t1[2], u = n * n + i * i + a * a, c = 2 * (s * n + o * i + l * a), h = c * c - 4 * u * (s * s + o * o + l * l - e * e);
                if (h < 0) {
                    const t1 = Math.max(-c / 2, 0), u = s + n * t1, h = o + i * t1, p = l + a * t1, f = Math.hypot(u, h, p);
                    return r[0] = u * e / f, r[1] = h * e / f, r[2] = p * e / f, !1;
                }
                {
                    const t1 = (-c - Math.sqrt(h)) / (2 * u);
                    if (t1 < 0) {
                        const t1 = Math.hypot(s, o, l);
                        return r[0] = s * e / t1, r[1] = o * e / t1, r[2] = l * e / t1, !1;
                    }
                    return r[0] = s + n * t1, r[1] = o + i * t1, r[2] = l + a * t1, !0;
                }
            }
            constructor(t1, e){
                this.pos = t1, this.dir = e;
            }
        }
        class pu {
            static fromInvProjectionMatrix(t1, e, r) {
                const n = [
                    -1,
                    1,
                    1
                ], i = [
                    1,
                    1,
                    1
                ], a = [
                    1,
                    -1,
                    1
                ], s = [
                    -1,
                    -1,
                    1
                ], o = O.vec3.transformMat4(n, n, t1), l = O.vec3.transformMat4(i, i, t1), u = O.vec3.transformMat4(a, a, t1), c = O.vec3.transformMat4(s, s, t1);
                return new pu(o, l, u, c, e / r);
            }
            constructor(t1, e, r, n, i){
                this.TL = t1, this.TR = e, this.BR = r, this.BL = n, this.horizon = i;
            }
        }
        function fu(t1, e, r) {
            let n = 1 / 0, i = -1 / 0;
            const a = [];
            for (const s of t1){
                O.vec3.sub(a, s, e);
                const t1 = O.vec3.dot(a, r);
                n = Math.min(n, t1), i = Math.max(i, t1);
            }
            return [
                n,
                i
            ];
        }
        function du(t1, e) {
            let r = !0;
            for(let n = 0; n < t1.planes.length; n++){
                const i = t1.planes[n];
                let a = 0;
                for(let t1 = 0; t1 < e.length; t1++)a += O.vec3.dot(i, e[t1]) + i[3] >= 0;
                if (0 === a) return 0;
                a !== e.length && (r = !1);
            }
            return r ? 2 : 1;
        }
        function mu(t1, e) {
            for (const r of t1.projections){
                const n = fu(e, t1.points[0], r.axis);
                if (r.projection[1] < n[0] || r.projection[0] > n[1]) return 0;
            }
            return 1;
        }
        function yu(t1, e) {
            let r = 0;
            const n = [
                0,
                0,
                0,
                0
            ];
            for(let i = 0; i < t1.length; i++)n[0] = t1[i][0], n[1] = t1[i][1], n[2] = t1[i][2], n[3] = 1, O.vec4.dot(n, e) >= 0 && r++;
            return r;
        }
        class gu {
            static fromInvProjectionMatrix(t1, e, r, n) {
                const i = Math.pow(2, r), a = [
                    [
                        -1,
                        1,
                        -1,
                        1
                    ],
                    [
                        1,
                        1,
                        -1,
                        1
                    ],
                    [
                        1,
                        -1,
                        -1,
                        1
                    ],
                    [
                        -1,
                        -1,
                        -1,
                        1
                    ],
                    [
                        -1,
                        1,
                        1,
                        1
                    ],
                    [
                        1,
                        1,
                        1,
                        1
                    ],
                    [
                        1,
                        -1,
                        1,
                        1
                    ],
                    [
                        -1,
                        -1,
                        1,
                        1
                    ]
                ].map((r)=>{
                    const a = O.vec4.transformMat4([], r, t1), s = 1 / a[3] / e * i;
                    return O.vec4.mul(a, a, [
                        s,
                        s,
                        n ? 1 / a[3] : s,
                        s
                    ]);
                }), s = [
                    [
                        0,
                        1,
                        2
                    ],
                    [
                        6,
                        5,
                        4
                    ],
                    [
                        0,
                        3,
                        7
                    ],
                    [
                        2,
                        1,
                        5
                    ],
                    [
                        3,
                        2,
                        6
                    ],
                    [
                        0,
                        4,
                        5
                    ]
                ].map((t1)=>{
                    const e = O.vec3.sub([], a[t1[0]], a[t1[1]]), r = O.vec3.sub([], a[t1[2]], a[t1[1]]), n = O.vec3.normalize([], O.vec3.cross([], e, r)), i = -O.vec3.dot(n, a[t1[1]]);
                    return n.concat(i);
                }), o = [];
                for(let t1 = 0; t1 < a.length; t1++)o.push([
                    a[t1][0],
                    a[t1][1],
                    a[t1][2]
                ]);
                return new gu(o, s);
            }
            intersectsPrecise(t1, e, r) {
                for(let r = 0; r < e.length; r++)if (!yu(t1, e[r])) return 0;
                for(let e = 0; e < this.planes.length; e++)if (!yu(t1, this.planes[e])) return 0;
                for (const e of r)for (const r of this.frustumEdges){
                    const n = O.vec3.cross([], e, r), i = O.vec3.length(n);
                    if (0 === i) continue;
                    O.vec3.scale(n, n, 1 / i);
                    const a = fu(this.points, this.points[0], n), s = fu(t1, this.points[0], n);
                    if (a[0] > s[1] || s[0] > a[1]) return 0;
                }
                return 1;
            }
            containsPoint(t1) {
                for (const e of this.planes){
                    const r = e[3];
                    if (O.vec3.dot([
                        e[0],
                        e[1],
                        e[2]
                    ], t1) + r < 0) return !1;
                }
                return !0;
            }
            constructor(t1, e){
                this.points = t1 || new Array(8).fill([
                    0,
                    0,
                    0
                ]), this.planes = e || new Array(6).fill([
                    0,
                    0,
                    0,
                    0
                ]), this.bounds = xu.fromPoints(this.points), this.projections = [], this.frustumEdges = [
                    O.vec3.sub([], this.points[2], this.points[3]),
                    O.vec3.sub([], this.points[0], this.points[3]),
                    O.vec3.sub([], this.points[4], this.points[0]),
                    O.vec3.sub([], this.points[5], this.points[1]),
                    O.vec3.sub([], this.points[6], this.points[2]),
                    O.vec3.sub([], this.points[7], this.points[3])
                ];
                for (const t1 of this.frustumEdges){
                    const e = [
                        0,
                        -t1[2],
                        t1[1]
                    ], r = [
                        t1[2],
                        0,
                        -t1[0]
                    ];
                    this.projections.push({
                        axis: e,
                        projection: fu(this.points, this.points[0], e)
                    }), this.projections.push({
                        axis: r,
                        projection: fu(this.points, this.points[0], r)
                    });
                }
            }
        }
        class xu {
            static fromPoints(t1) {
                const e = [
                    1 / 0,
                    1 / 0,
                    1 / 0
                ], r = [
                    -1 / 0,
                    -1 / 0,
                    -1 / 0
                ];
                for (const n of t1)O.vec3.min(e, e, n), O.vec3.max(r, r, n);
                return new xu(e, r);
            }
            static fromTileIdAndHeight(t1, e, r) {
                const n = 1 << t1.canonical.z, i = t1.canonical.x, a = t1.canonical.y;
                return new xu([
                    i / n,
                    a / n,
                    e
                ], [
                    (i + 1) / n,
                    (a + 1) / n,
                    r
                ]);
            }
            static applyTransform(t1, e) {
                const r = t1.getCorners();
                for(let t1 = 0; t1 < r.length; ++t1)O.vec3.transformMat4(r[t1], r[t1], e);
                return xu.fromPoints(r);
            }
            static applyTransformFast(t1, e) {
                const r = [
                    e[12],
                    e[13],
                    e[14]
                ], n = [
                    ...r
                ];
                for(let i = 0; i < 3; i++)for(let a = 0; a < 3; a++){
                    const s = e[4 * a + i], o = s * t1.min[a], l = s * t1.max[a];
                    r[i] += Math.min(o, l), n[i] += Math.max(o, l);
                }
                return new xu(r, n);
            }
            static projectAabbCorners(t1, e) {
                const r = t1.getCorners();
                for(let t1 = 0; t1 < r.length; ++t1)O.vec3.transformMat4(r[t1], r[t1], e);
                return r;
            }
            quadrant(t1) {
                const e = [
                    t1 % 2 == 0,
                    t1 < 2
                ], r = O.vec3.clone(this.min), n = O.vec3.clone(this.max);
                for(let t1 = 0; t1 < e.length; t1++)r[t1] = e[t1] ? this.min[t1] : this.center[t1], n[t1] = e[t1] ? this.center[t1] : this.max[t1];
                return n[2] = this.max[2], new xu(r, n);
            }
            distanceX(t1) {
                return Math.max(Math.min(this.max[0], t1[0]), this.min[0]) - t1[0];
            }
            distanceY(t1) {
                return Math.max(Math.min(this.max[1], t1[1]), this.min[1]) - t1[1];
            }
            distanceZ(t1) {
                return Math.max(Math.min(this.max[2], t1[2]), this.min[2]) - t1[2];
            }
            getCorners() {
                const t1 = this.min, e = this.max;
                return [
                    [
                        t1[0],
                        t1[1],
                        t1[2]
                    ],
                    [
                        e[0],
                        t1[1],
                        t1[2]
                    ],
                    [
                        e[0],
                        e[1],
                        t1[2]
                    ],
                    [
                        t1[0],
                        e[1],
                        t1[2]
                    ],
                    [
                        t1[0],
                        t1[1],
                        e[2]
                    ],
                    [
                        e[0],
                        t1[1],
                        e[2]
                    ],
                    [
                        e[0],
                        e[1],
                        e[2]
                    ],
                    [
                        t1[0],
                        e[1],
                        e[2]
                    ]
                ];
            }
            intersects(t1) {
                return this.intersectsAabb(t1.bounds) ? du(t1, this.getCorners()) : 0;
            }
            intersectsFlat(t1) {
                return this.intersectsAabb(t1.bounds) ? du(t1, [
                    [
                        this.min[0],
                        this.min[1],
                        0
                    ],
                    [
                        this.max[0],
                        this.min[1],
                        0
                    ],
                    [
                        this.max[0],
                        this.max[1],
                        0
                    ],
                    [
                        this.min[0],
                        this.max[1],
                        0
                    ]
                ]) : 0;
            }
            intersectsPrecise(t1, e) {
                return e || this.intersects(t1) ? mu(t1, this.getCorners()) : 0;
            }
            intersectsPreciseFlat(t1, e) {
                return e || this.intersectsFlat(t1) ? mu(t1, [
                    [
                        this.min[0],
                        this.min[1],
                        0
                    ],
                    [
                        this.max[0],
                        this.min[1],
                        0
                    ],
                    [
                        this.max[0],
                        this.max[1],
                        0
                    ],
                    [
                        this.min[0],
                        this.max[1],
                        0
                    ]
                ]) : 0;
            }
            intersectsAabb(t1) {
                for(let e = 0; e < 3; ++e)if (this.min[e] > t1.max[e] || t1.min[e] > this.max[e]) return !1;
                return !0;
            }
            intersectsAabbXY(t1) {
                return !(this.min[0] > t1.max[0] || t1.min[0] > this.max[0] || this.min[1] > t1.max[1] || t1.min[1] > this.max[1]);
            }
            encapsulate(t1) {
                for(let e = 0; e < 3; e++)this.min[e] = Math.min(this.min[e], t1.min[e]), this.max[e] = Math.max(this.max[e], t1.max[e]);
            }
            encapsulatePoint(t1) {
                for(let e = 0; e < 3; e++)this.min[e] = Math.min(this.min[e], t1[e]), this.max[e] = Math.max(this.max[e], t1[e]);
            }
            closestPoint(t1) {
                return [
                    Math.max(Math.min(this.max[0], t1[0]), this.min[0]),
                    Math.max(Math.min(this.max[1], t1[1]), this.min[1]),
                    Math.max(Math.min(this.max[2], t1[2]), this.min[2])
                ];
            }
            constructor(t1, e){
                this.min = t1, this.max = e, this.center = O.vec3.scale([], O.vec3.add([], this.min, this.max), .5);
            }
        }
        function vu(t1) {
            return t1 * Yo / rl;
        }
        oa(xu, "Aabb");
        const bu = [
            new xu([
                Jo,
                Jo,
                Jo
            ], [
                Qo,
                Qo,
                Qo
            ]),
            new xu([
                Jo,
                Jo,
                Jo
            ], [
                0,
                0,
                Qo
            ]),
            new xu([
                0,
                Jo,
                Jo
            ], [
                Qo,
                0,
                Qo
            ]),
            new xu([
                Jo,
                0,
                Jo
            ], [
                0,
                Qo,
                Qo
            ]),
            new xu([
                0,
                0,
                Jo
            ], [
                Qo,
                Qo,
                Qo
            ])
        ];
        function _u(t1, e, r, n = !0) {
            const i = O.vec3.scale([], t1._camera.position, t1.worldSize), a = [
                e,
                r,
                1,
                1
            ];
            O.vec4.transformMat4(a, a, t1.pixelMatrixInverse), O.vec4.scale(a, a, 1 / a[3]);
            const s = O.vec3.sub([], a, i), o = O.vec3.normalize([], s), l = t1.globeMatrix, u = [
                l[12],
                l[13],
                l[14]
            ], c = O.vec3.sub([], u, i), h = O.vec3.length(c), p = O.vec3.normalize([], c), f = t1.worldSize / (2 * Math.PI), d = O.vec3.dot(p, o), m = Math.asin(f / h);
            if (m < Math.acos(d)) {
                if (!n) return null;
                const t1 = [], e = [];
                O.vec3.scale(t1, o, h / d), O.vec3.normalize(e, O.vec3.sub(e, t1, c)), O.vec3.normalize(o, O.vec3.add(o, c, O.vec3.scale(o, e, Math.tan(m) * h)));
            }
            const y = [];
            new hu(i, o).closestPointOnSphere(u, f, y);
            const g = O.vec3.normalize([], bt(l, 0)), x = O.vec3.normalize([], bt(l, 1)), v = O.vec3.normalize([], bt(l, 2)), b = O.vec3.dot(g, y), _ = O.vec3.dot(x, y), w = O.vec3.dot(v, y), M = Z(Math.asin(-_ / f));
            let A = Z(Math.atan2(b, w));
            A = t1.center.lng + function(t1, e) {
                const r = (e - t1 + 180) % 360 - 180;
                return r < -180 ? r + 360 : r;
            }(t1.center.lng, A);
            const S = ul(A), I = Q(cl(M), 0, 1);
            return new bl(S, I);
        }
        class wu {
            constructor(t1, e, r){
                this.a = O.vec3.sub([], t1, r), this.b = O.vec3.sub([], e, r), this.center = r;
                const n = O.vec3.normalize([], this.a), i = O.vec3.normalize([], this.b);
                this.angle = Math.acos(O.vec3.dot(n, i));
            }
        }
        function Mu(t1, e) {
            if (0 === t1.angle) return null;
            let r;
            return r = 0 === t1.a[e] ? 1 / t1.angle * .5 * Math.PI : 1 / t1.angle * Math.atan(t1.b[e] / t1.a[e] / Math.sin(t1.angle) - 1 / Math.tan(t1.angle)), r < 0 || r > 1 ? null : function(t1, e, r, n) {
                const i = Math.sin(r);
                return t1 * (Math.sin((1 - n) * r) / i) + e * (Math.sin(n * r) / i);
            }(t1.a[e], t1.b[e], t1.angle, Q(r, 0, 1)) + t1.center[e];
        }
        function Au(t1) {
            if (t1.z <= 1) return bu[t1.z + 2 * t1.y + t1.x];
            const e = Eu(zu(t1));
            return xu.fromPoints(e);
        }
        function Su(t1, e, r) {
            return O.vec3.scale(t1, t1, 1 - r), O.vec3.scaleAndAdd(t1, t1, e, r);
        }
        function Iu(t1, e, r) {
            for (const n of t1)O.vec3.transformMat4(n, n, e), O.vec3.scale(n, n, r);
        }
        function Pu(t1, e, r, n) {
            const i = e / t1.worldSize, a = t1.globeMatrix;
            if (r.z <= 1) {
                const t1 = Au(r).getCorners();
                return Iu(t1, a, i), xu.fromPoints(t1);
            }
            const s = zu(r, n), o = Eu(s, Yo + vu(t1._tileCoverLift));
            Iu(o, a, i);
            const l = Number.MAX_VALUE, u = [
                -l,
                -l,
                -l
            ], c = [
                l,
                l,
                l
            ];
            if (s.contains(t1.center)) {
                for (const t1 of o)O.vec3.min(c, c, t1), O.vec3.max(u, u, t1);
                u[2] = 0;
                const e = t1.point, r = [
                    e.x * i,
                    e.y * i,
                    0
                ];
                return O.vec3.min(c, c, r), O.vec3.max(u, u, r), new xu(c, u);
            }
            if (t1._tileCoverLift > 0) {
                for (const t1 of o)O.vec3.min(c, c, t1), O.vec3.max(u, u, t1);
                return new xu(c, u);
            }
            const h = [
                a[12] * i,
                a[13] * i,
                a[14] * i
            ], p = s.getCenter(), f = Q(t1.center.lat, -ml, ml), d = Q(p.lat, -ml, ml), m = ul(t1.center.lng), y = cl(f);
            let g = m - ul(p.lng);
            const x = y - cl(d);
            g > .5 ? g -= 1 : g < -0.5 && (g += 1);
            let v = 0;
            if (Math.abs(g) > Math.abs(x)) v = g >= 0 ? 1 : 3;
            else {
                v = x >= 0 ? 0 : 2;
                const t1 = [
                    a[4] * i,
                    a[5] * i,
                    a[6] * i
                ], e = -Math.sin(X(x >= 0 ? s.getSouth() : s.getNorth())) * Yo;
                O.vec3.scaleAndAdd(h, h, t1, e);
            }
            const b = o[v], _ = o[(v + 1) % 4], w = new wu(b, _, h), M = [
                Mu(w, 0) || b[0],
                Mu(w, 1) || b[1],
                Mu(w, 2) || b[2]
            ], A = Fu(t1.zoom);
            if (A > 0) {
                const n = function({ x: t1, y: e, z: r }, n, i, a, s) {
                    const o = 1 / (1 << r);
                    let l = t1 * o, u = l + o, c = e * o, h = c + o, p = 0;
                    const f = (l + u) / 2 - a;
                    return f > .5 ? p = -1 : f < -0.5 && (p = 1), l = ((l + p) * n - (a *= n)) * i + a, u = ((u + p) * n - a) * i + a, c = (c * n - (s *= n)) * i + s, h = (h * n - s) * i + s, [
                        [
                            l,
                            h,
                            0
                        ],
                        [
                            u,
                            h,
                            0
                        ],
                        [
                            u,
                            c,
                            0
                        ],
                        [
                            l,
                            c,
                            0
                        ]
                    ];
                }(r, e, t1._pixelsPerMercatorPixel, m, y);
                for(let t1 = 0; t1 < o.length; t1++)Su(o[t1], n[t1], A);
                const i = O.vec3.add([], n[v], n[(v + 1) % 4]);
                O.vec3.scale(i, i, .5), Su(M, i, A);
            }
            for (const t1 of o)O.vec3.min(c, c, t1), O.vec3.max(u, u, t1);
            return c[2] = Math.min(b[2], _[2]), O.vec3.min(c, c, M), O.vec3.max(u, u, M), new xu(c, u);
        }
        function zu({ x: t1, y: e, z: r }, n = !1) {
            const i = 1 / (1 << r), a = new il(pl(t1 * i), e === (1 << r) - 1 && n ? -90 : fl((e + 1) * i)), s = new il(pl((t1 + 1) * i), 0 === e && n ? 90 : fl(e * i));
            return new al(a, s);
        }
        function Eu(t1, e = Yo) {
            const r = X(t1.getNorth()), n = X(t1.getSouth()), i = Math.cos(r), a = Math.cos(n), s = Math.sin(r), o = Math.sin(n), l = t1.getWest(), u = t1.getEast();
            return [
                tl(a, o, l, e),
                tl(a, o, u, e),
                tl(i, s, u, e),
                tl(i, s, l, e)
            ];
        }
        function ku(t1, e, r, n) {
            const i = 1 << r.z, a = (t1 / Wr + r.x) / i;
            return el(fl((e / Wr + r.y) / i), pl(a), n);
        }
        function Tu({ min: t1, max: e }) {
            return Ho / Math.max(e[0] - t1[0], e[1] - t1[1], e[2] - t1[2]);
        }
        const Bu = new Float64Array(16);
        function Cu(t1) {
            const e = Tu(t1), r = O.mat4.fromScaling(Bu, [
                e,
                e,
                e
            ]);
            return O.mat4.translate(r, r, O.vec3.negate([], t1.min));
        }
        function Vu(t1) {
            const e = O.mat4.fromTranslation(Bu, t1.min), r = 1 / Tu(t1);
            return O.mat4.scale(e, e, [
                r,
                r,
                r
            ]);
        }
        function Du(t1) {
            const e = Wr / (2 * Math.PI);
            return t1 / (2 * Math.PI) / e;
        }
        function Lu(t1, e) {
            return Wr / (512 * Math.pow(2, t1)) * Tu(Au(e));
        }
        function Ru(t1, e, r, n, i) {
            const a = Du(r), s = [
                t1,
                e,
                -r / (2 * Math.PI)
            ], o = O.mat4.identity(new Float64Array(16));
            return O.mat4.translate(o, o, s), O.mat4.scale(o, o, [
                a,
                a,
                a
            ]), O.mat4.rotateX(o, o, X(-i)), O.mat4.rotateY(o, o, X(-n)), o;
        }
        function Fu(t1) {
            return tt(Xo, Zo, t1);
        }
        function Ou(t1, e) {
            const r = el(e.lat, e.lng), n = function(t1) {
                const e = el(t1._center.lat, t1._center.lng), r = O.vec3.fromValues(0, 1, 0);
                let n = O.vec3.cross([], r, e);
                const i = O.mat4.fromRotation([], -t1.angle, e);
                n = O.vec3.transformMat4(n, n, i), O.mat4.fromRotation(i, -t1._pitch, n);
                const a = O.vec3.normalize([], e);
                return O.vec3.scale(a, a, vu(t1.cameraToCenterDistance / t1.pixelsPerMeter)), O.vec3.transformMat4(a, a, i), O.vec3.add([], e, a);
            }(t1), i = O.vec3.subtract([], n, r);
            return O.vec3.angle(i, r);
        }
        function Nu(t1, e) {
            return Ou(t1, e) > Math.PI / 2 * 1.01;
        }
        const Uu = X(85), ju = Math.cos(Uu), qu = Math.sin(Uu), $u = O.mat4.create(), Gu = (t1)=>{
            const e = [];
            return "map" === t1.paint.get("circle-pitch-alignment") && e.push("PITCH_WITH_MAP"), "map" === t1.paint.get("circle-pitch-scale") && e.push("SCALE_WITH_MAP"), e;
        };
        function Yu(t1, e, r, n, i, a, s, o, l) {
            if (a && t1.queryGeometry.isAboveHorizon) return !1;
            a && (l *= t1.pixelToTileUnitsFactor);
            const u = t1.tileID.canonical, c = r.projection.upVectorScale(u, r.center.lat, r.worldSize).metersToTile;
            for (const h of e)for (const e of h){
                const h = e.add(o), p = i && r.elevation ? r.elevation.exaggeration() * i.getElevationAt(h.x, h.y, !0) : 0, f = r.projection.projectTilePoint(h.x, h.y, u);
                if (p > 0) {
                    const t1 = r.projection.upVector(u, h.x, h.y);
                    f.x += t1[0] * c * p, f.y += t1[1] * c * p, f.z += t1[2] * c * p;
                }
                const d = a ? h : Xu(f.x, f.y, f.z, n), m = a ? t1.tilespaceRays.map((t1)=>Wu(t1, p)) : t1.queryGeometry.screenGeometry, y = O.vec4.transformMat4([], [
                    f.x,
                    f.y,
                    f.z,
                    1
                ], n);
                if (!s && a ? l *= y[3] / r.cameraToCenterDistance : s && !a && (l *= r.cameraToCenterDistance / y[3]), a) {
                    const t1 = fl((e.y / Wr + u.y) / (1 << u.z));
                    l /= r.projection.pixelsPerMeter(t1, 1) / hl(1, t1);
                }
                if (Vl(m, d, l)) return !0;
            }
            return !1;
        }
        function Xu(t1, e, r, n) {
            const i = O.vec4.transformMat4([], [
                t1,
                e,
                r,
                1
            ], n);
            return new q(i[0] / i[3], i[1] / i[3]);
        }
        const Zu = O.vec3.fromValues(0, 0, 0), Hu = O.vec3.fromValues(0, 0, 1);
        function Wu(t1, e) {
            const r = O.vec3.create();
            return Zu[2] = e, t1.intersectsPlane(Zu, Hu, r), new q(r[0], r[1]);
        }
        class Ku extends Bl {
        }
        let Ju, Qu, tc, ec;
        function rc(t1, { width: e, height: r }, n, i) {
            if (i) {
                if (i instanceof Uint8ClampedArray) i = new Uint8Array(i.buffer);
                else if (i.length !== e * r * n) throw new RangeError("mismatched image size");
            } else i = new Uint8Array(e * r * n);
            return t1.width = e, t1.height = r, t1.data = i, t1;
        }
        function nc(t1, e, r) {
            const { width: n, height: i } = e;
            n === t1.width && i === t1.height || (ic(t1, e, {
                x: 0,
                y: 0
            }, {
                x: 0,
                y: 0
            }, {
                width: Math.min(t1.width, n),
                height: Math.min(t1.height, i)
            }, r, null), t1.width = n, t1.height = i, t1.data = e.data);
        }
        function ic(t1, e, r, n, i, a, s, o) {
            if (0 === i.width || 0 === i.height) return e;
            if (i.width > t1.width || i.height > t1.height || r.x > t1.width - i.width || r.y > t1.height - i.height) throw new RangeError("out of range source coordinates for image copy");
            if (i.width > e.width || i.height > e.height || n.x > e.width - i.width || n.y > e.height - i.height) throw new RangeError("out of range destination coordinates for image copy");
            const l = t1.data, u = e.data, c = 4 === a && o;
            for(let o = 0; o < i.height; o++){
                const h = ((r.y + o) * t1.width + r.x) * a, p = ((n.y + o) * e.width + n.x) * a;
                if (c) for(let t1 = 0; t1 < i.width; t1++){
                    const e = h + t1 * a + 3, r = p + t1 * a;
                    u[r + 0] = 255, u[r + 1] = 255, u[r + 2] = 255, u[r + 3] = l[e];
                }
                else if (s) for(let t1 = 0; t1 < i.width; t1++){
                    const e = h + t1 * a, r = p + t1 * a, n = l[e + 3], i = new Ie(l[e + 0] / 255 * n, l[e + 1] / 255 * n, l[e + 2] / 255 * n, n).toRenderColor(s).toArray();
                    u[r + 0] = i[0], u[r + 1] = i[1], u[r + 2] = i[2], u[r + 3] = i[3];
                }
                else for(let t1 = 0; t1 < i.width * a; t1++)u[p + t1] = l[h + t1];
            }
            return e;
        }
        oa(Ku, "HeatmapBucket", {
            omit: [
                "layers"
            ]
        });
        class ac {
            resize(t1) {
                nc(this, new ac(t1), 1);
            }
            clone() {
                return new ac({
                    width: this.width,
                    height: this.height
                }, new Uint8Array(this.data));
            }
            static copy(t1, e, r, n, i) {
                ic(t1, e, r, n, i, 1, null);
            }
            constructor(t1, e){
                rc(this, t1, 1, e);
            }
        }
        class sc {
            resize(t1) {
                nc(this, new sc(t1), 4);
            }
            replace(t1, e) {
                e ? this.data.set(t1) : this.data = t1 instanceof Uint8ClampedArray ? new Uint8Array(t1.buffer) : t1;
            }
            clone() {
                return new sc({
                    width: this.width,
                    height: this.height
                }, new Uint8Array(this.data));
            }
            static copy(t1, e, r, n, i, a, s) {
                ic(t1, e, r, n, i, 4, a, s);
            }
            constructor(t1, e){
                rc(this, t1, 4, e);
            }
        }
        class oc {
            constructor(t1, e){
                this.width = t1.width, this.height = t1.height, this.data = e instanceof Uint8Array ? new Float32Array(e.buffer) : e;
            }
        }
        function lc(t1) {
            const e = {}, r = t1.resolution || 256, n = t1.clips ? t1.clips.length : 1, i = t1.image || new sc({
                width: r,
                height: n
            }), a = (r, n, a)=>{
                e[t1.evaluationKey] = a;
                const s = t1.expression.evaluate(e);
                s && (i.data[r + n + 0] = Math.floor(255 * s.r / s.a), i.data[r + n + 1] = Math.floor(255 * s.g / s.a), i.data[r + n + 2] = Math.floor(255 * s.b / s.a), i.data[r + n + 3] = Math.floor(255 * s.a));
            };
            if (t1.clips) for(let e = 0, i = 0; e < n; ++e, i += 4 * r)for(let n = 0, s = 0; n < r; n++, s += 4){
                const o = n / (r - 1), { start: l, end: u } = t1.clips[e];
                a(i, s, l * (1 - o) + u * o);
            }
            else for(let t1 = 0, e = 0; t1 < r; t1++, e += 4)a(0, e, t1 / (r - 1));
            return i;
        }
        oa(ac, "AlphaImage"), oa(sc, "RGBAImage");
        const uc = ys([
            {
                name: "a_pos",
                components: 2,
                type: "Int16"
            }
        ], 4), { members: cc } = uc;
        function hc(t1, e, r = 2) {
            const n = e && e.length, i = n ? e[0] * r : t1.length;
            let a = pc(t1, 0, i, r, !0);
            const s = [];
            if (!a || a.next === a.prev) return s;
            let o, l, u;
            if (n && (a = function(t1, e, r, n) {
                const i = [];
                for(let r = 0, a = e.length; r < a; r++){
                    const s = pc(t1, e[r] * n, r < a - 1 ? e[r + 1] * n : t1.length, n, !1);
                    s === s.next && (s.steiner = !0), i.push(Mc(s));
                }
                i.sort(vc);
                for(let t1 = 0; t1 < i.length; t1++)r = bc(i[t1], r);
                return r;
            }(t1, e, a, r)), t1.length > 80 * r) {
                o = 1 / 0, l = 1 / 0;
                let e = -1 / 0, n = -1 / 0;
                for(let a = r; a < i; a += r){
                    const r = t1[a], i = t1[a + 1];
                    r < o && (o = r), i < l && (l = i), r > e && (e = r), i > n && (n = i);
                }
                u = Math.max(e - o, n - l), u = 0 !== u ? 32767 / u : 0;
            }
            return dc(a, s, r, o, l, u, 0), s;
        }
        function pc(t1, e, r, n, i) {
            let a;
            if (i === function(t1, e, r, n) {
                let i = 0;
                for(let a = e, s = r - n; a < r; a += n)i += (t1[s] - t1[a]) * (t1[a + 1] + t1[s + 1]), s = a;
                return i;
            }(t1, e, r, n) > 0) for(let i = e; i < r; i += n)a = Cc(i / n | 0, t1[i], t1[i + 1], a);
            else for(let i = r - n; i >= e; i -= n)a = Cc(i / n | 0, t1[i], t1[i + 1], a);
            return a && Pc(a, a.next) && (Vc(a), a = a.next), a;
        }
        function fc(t1, e) {
            if (!t1) return t1;
            e || (e = t1);
            let r, n = t1;
            do if (r = !1, n.steiner || !Pc(n, n.next) && 0 !== Ic(n.prev, n, n.next)) n = n.next;
            else {
                if (Vc(n), n = e = n.prev, n === n.next) break;
                r = !0;
            }
            while (r || n !== e);
            return e;
        }
        function dc(t1, e, r, n, i, a, s) {
            if (!t1) return;
            !s && a && function(t1, e, r, n) {
                let i = t1;
                do 0 === i.z && (i.z = wc(i.x, i.y, e, r, n)), i.prevZ = i.prev, i.nextZ = i.next, i = i.next;
                while (i !== t1);
                i.prevZ.nextZ = null, i.prevZ = null, function(t1) {
                    let e, r = 1;
                    do {
                        let n, i = t1;
                        t1 = null;
                        let a = null;
                        for(e = 0; i;){
                            e++;
                            let s = i, o = 0;
                            for(let t1 = 0; t1 < r && (o++, s = s.nextZ, s); t1++);
                            let l = r;
                            for(; o > 0 || l > 0 && s;)0 !== o && (0 === l || !s || i.z <= s.z) ? (n = i, i = i.nextZ, o--) : (n = s, s = s.nextZ, l--), a ? a.nextZ = n : t1 = n, n.prevZ = a, a = n;
                            i = s;
                        }
                        a.nextZ = null, r *= 2;
                    }while (e > 1);
                }(i);
            }(t1, n, i, a);
            let o = t1;
            for(; t1.prev !== t1.next;){
                const l = t1.prev, u = t1.next;
                if (a ? yc(t1, n, i, a) : mc(t1)) e.push(l.i, t1.i, u.i), Vc(t1), t1 = u.next, o = u.next;
                else if ((t1 = u) === o) {
                    s ? 1 === s ? dc(t1 = gc(fc(t1), e), e, r, n, i, a, 2) : 2 === s && xc(t1, e, r, n, i, a) : dc(fc(t1), e, r, n, i, a, 1);
                    break;
                }
            }
        }
        function mc(t1) {
            const e = t1.prev, r = t1, n = t1.next;
            if (Ic(e, r, n) >= 0) return !1;
            const i = e.x, a = r.x, s = n.x, o = e.y, l = r.y, u = n.y, c = i < a ? i < s ? i : s : a < s ? a : s, h = o < l ? o < u ? o : u : l < u ? l : u, p = i > a ? i > s ? i : s : a > s ? a : s, f = o > l ? o > u ? o : u : l > u ? l : u;
            let d = n.next;
            for(; d !== e;){
                if (d.x >= c && d.x <= p && d.y >= h && d.y <= f && Ac(i, o, a, l, s, u, d.x, d.y) && Ic(d.prev, d, d.next) >= 0) return !1;
                d = d.next;
            }
            return !0;
        }
        function yc(t1, e, r, n) {
            const i = t1.prev, a = t1, s = t1.next;
            if (Ic(i, a, s) >= 0) return !1;
            const o = i.x, l = a.x, u = s.x, c = i.y, h = a.y, p = s.y, f = o < l ? o < u ? o : u : l < u ? l : u, d = c < h ? c < p ? c : p : h < p ? h : p, m = o > l ? o > u ? o : u : l > u ? l : u, y = c > h ? c > p ? c : p : h > p ? h : p, g = wc(f, d, e, r, n), x = wc(m, y, e, r, n);
            let v = t1.prevZ, b = t1.nextZ;
            for(; v && v.z >= g && b && b.z <= x;){
                if (v.x >= f && v.x <= m && v.y >= d && v.y <= y && v !== i && v !== s && Ac(o, c, l, h, u, p, v.x, v.y) && Ic(v.prev, v, v.next) >= 0) return !1;
                if (v = v.prevZ, b.x >= f && b.x <= m && b.y >= d && b.y <= y && b !== i && b !== s && Ac(o, c, l, h, u, p, b.x, b.y) && Ic(b.prev, b, b.next) >= 0) return !1;
                b = b.nextZ;
            }
            for(; v && v.z >= g;){
                if (v.x >= f && v.x <= m && v.y >= d && v.y <= y && v !== i && v !== s && Ac(o, c, l, h, u, p, v.x, v.y) && Ic(v.prev, v, v.next) >= 0) return !1;
                v = v.prevZ;
            }
            for(; b && b.z <= x;){
                if (b.x >= f && b.x <= m && b.y >= d && b.y <= y && b !== i && b !== s && Ac(o, c, l, h, u, p, b.x, b.y) && Ic(b.prev, b, b.next) >= 0) return !1;
                b = b.nextZ;
            }
            return !0;
        }
        function gc(t1, e) {
            let r = t1;
            do {
                const n = r.prev, i = r.next.next;
                !Pc(n, i) && zc(n, r, r.next, i) && Tc(n, i) && Tc(i, n) && (e.push(n.i, r.i, i.i), Vc(r), Vc(r.next), r = t1 = i), r = r.next;
            }while (r !== t1);
            return fc(r);
        }
        function xc(t1, e, r, n, i, a) {
            let s = t1;
            do {
                let t1 = s.next.next;
                for(; t1 !== s.prev;){
                    if (s.i !== t1.i && Sc(s, t1)) {
                        let o = Bc(s, t1);
                        return s = fc(s, s.next), o = fc(o, o.next), dc(s, e, r, n, i, a, 0), void dc(o, e, r, n, i, a, 0);
                    }
                    t1 = t1.next;
                }
                s = s.next;
            }while (s !== t1);
        }
        function vc(t1, e) {
            return t1.x - e.x;
        }
        function bc(t1, e) {
            const r = function(t1, e) {
                let r = e;
                const n = t1.x, i = t1.y;
                let a, s = -1 / 0;
                do {
                    if (i <= r.y && i >= r.next.y && r.next.y !== r.y) {
                        const t1 = r.x + (i - r.y) * (r.next.x - r.x) / (r.next.y - r.y);
                        if (t1 <= n && t1 > s && (s = t1, a = r.x < r.next.x ? r : r.next, t1 === n)) return a;
                    }
                    r = r.next;
                }while (r !== e);
                if (!a) return null;
                const o = a, l = a.x, u = a.y;
                let c = 1 / 0;
                r = a;
                do {
                    if (n >= r.x && r.x >= l && n !== r.x && Ac(i < u ? n : s, i, l, u, i < u ? s : n, i, r.x, r.y)) {
                        const e = Math.abs(i - r.y) / (n - r.x);
                        Tc(r, t1) && (e < c || e === c && (r.x > a.x || r.x === a.x && _c(a, r))) && (a = r, c = e);
                    }
                    r = r.next;
                }while (r !== o);
                return a;
            }(t1, e);
            if (!r) return e;
            const n = Bc(r, t1);
            return fc(n, n.next), fc(r, r.next);
        }
        function _c(t1, e) {
            return Ic(t1.prev, t1, e.prev) < 0 && Ic(e.next, t1, t1.next) < 0;
        }
        function wc(t1, e, r, n, i) {
            return (t1 = 1431655765 & ((t1 = 858993459 & ((t1 = 252645135 & ((t1 = 16711935 & ((t1 = (t1 - r) * i | 0) | t1 << 8)) | t1 << 4)) | t1 << 2)) | t1 << 1)) | (e = 1431655765 & ((e = 858993459 & ((e = 252645135 & ((e = 16711935 & ((e = (e - n) * i | 0) | e << 8)) | e << 4)) | e << 2)) | e << 1)) << 1;
        }
        function Mc(t1) {
            let e = t1, r = t1;
            do (e.x < r.x || e.x === r.x && e.y < r.y) && (r = e), e = e.next;
            while (e !== t1);
            return r;
        }
        function Ac(t1, e, r, n, i, a, s, o) {
            return (i - s) * (e - o) >= (t1 - s) * (a - o) && (t1 - s) * (n - o) >= (r - s) * (e - o) && (r - s) * (a - o) >= (i - s) * (n - o);
        }
        function Sc(t1, e) {
            return t1.next.i !== e.i && t1.prev.i !== e.i && !function(t1, e) {
                let r = t1;
                do {
                    if (r.i !== t1.i && r.next.i !== t1.i && r.i !== e.i && r.next.i !== e.i && zc(r, r.next, t1, e)) return !0;
                    r = r.next;
                }while (r !== t1);
                return !1;
            }(t1, e) && (Tc(t1, e) && Tc(e, t1) && function(t1, e) {
                let r = t1, n = !1;
                const i = (t1.x + e.x) / 2, a = (t1.y + e.y) / 2;
                do r.y > a != r.next.y > a && r.next.y !== r.y && i < (r.next.x - r.x) * (a - r.y) / (r.next.y - r.y) + r.x && (n = !n), r = r.next;
                while (r !== t1);
                return n;
            }(t1, e) && (Ic(t1.prev, t1, e.prev) || Ic(t1, e.prev, e)) || Pc(t1, e) && Ic(t1.prev, t1, t1.next) > 0 && Ic(e.prev, e, e.next) > 0);
        }
        function Ic(t1, e, r) {
            return (e.y - t1.y) * (r.x - e.x) - (e.x - t1.x) * (r.y - e.y);
        }
        function Pc(t1, e) {
            return t1.x === e.x && t1.y === e.y;
        }
        function zc(t1, e, r, n) {
            const i = kc(Ic(t1, e, r)), a = kc(Ic(t1, e, n)), s = kc(Ic(r, n, t1)), o = kc(Ic(r, n, e));
            return i !== a && s !== o || !(0 !== i || !Ec(t1, r, e)) || !(0 !== a || !Ec(t1, n, e)) || !(0 !== s || !Ec(r, t1, n)) || !(0 !== o || !Ec(r, e, n));
        }
        function Ec(t1, e, r) {
            return e.x <= Math.max(t1.x, r.x) && e.x >= Math.min(t1.x, r.x) && e.y <= Math.max(t1.y, r.y) && e.y >= Math.min(t1.y, r.y);
        }
        function kc(t1) {
            return t1 > 0 ? 1 : t1 < 0 ? -1 : 0;
        }
        function Tc(t1, e) {
            return Ic(t1.prev, t1, t1.next) < 0 ? Ic(t1, e, t1.next) >= 0 && Ic(t1, t1.prev, e) >= 0 : Ic(t1, e, t1.prev) < 0 || Ic(t1, t1.next, e) < 0;
        }
        function Bc(t1, e) {
            const r = Dc(t1.i, t1.x, t1.y), n = Dc(e.i, e.x, e.y), i = t1.next, a = e.prev;
            return t1.next = e, e.prev = t1, r.next = i, i.prev = r, n.next = r, r.prev = n, a.next = n, n.prev = a, n;
        }
        function Cc(t1, e, r, n) {
            const i = Dc(t1, e, r);
            return n ? (i.next = n.next, i.prev = n, n.next.prev = i, n.next = i) : (i.prev = i, i.next = i), i;
        }
        function Vc(t1) {
            t1.next.prev = t1.prev, t1.prev.next = t1.next, t1.prevZ && (t1.prevZ.nextZ = t1.nextZ), t1.nextZ && (t1.nextZ.prevZ = t1.prevZ);
        }
        function Dc(t1, e, r) {
            return {
                i: t1,
                x: e,
                y: r,
                prev: null,
                next: null,
                z: 0,
                prevZ: null,
                nextZ: null,
                steiner: !1
            };
        }
        function Lc(t1, e) {
            const r = t1.length;
            if (r <= 1) return [
                t1
            ];
            const n = [];
            let i, a;
            for(let e = 0; e < r; e++){
                const r = mt(t1[e]);
                0 !== r && (t1[e].area = Math.abs(r), void 0 === a && (a = r < 0), a === r < 0 ? (i && n.push(i), i = [
                    t1[e]
                ]) : i.push(t1[e]));
            }
            if (i && n.push(i), e > 1) for(let t1 = 0; t1 < n.length; t1++)n[t1].length <= e || (vr(n[t1], e, 1, n[t1].length - 1, Rc), n[t1] = n[t1].slice(0, e));
            return n;
        }
        function Rc(t1, e) {
            return e.area - t1.area;
        }
        function Fc(t1, e, r = 1) {
            if (!t1) return null;
            const n = "string" == typeof t1 ? t1 : t1.getPrimary().id;
            e[n] || (e[n] = []);
            const i = tr.from(n).getPrimary().scaleSelf(r);
            return e[n].push(i), i.serialize();
        }
        function Oc(t1, e, r, n) {
            const i = n.patternDependencies;
            let a = !1;
            for (const n of e){
                const e = n.paint.get(`${t1}-pattern`);
                e.isConstant() || (a = !0), Fc(e.constantOr(null), i, r) && (a = !0);
            }
            return a;
        }
        function Nc(t1, e, r, n, i, a) {
            const s = a.patternDependencies;
            for (const o of e){
                const e = o.paint.get(`${t1}-pattern`).value;
                if ("constant" !== e.kind) {
                    let t1 = e.evaluate({
                        zoom: n
                    }, r, {}, a.availableImages);
                    t1 = t1 && t1.name ? t1.name : t1;
                    const l = Fc(t1, s, i);
                    l && (r.patterns[o.id] = l);
                }
            }
            return r;
        }
        class Uc {
            updateFootprints(t1, e) {}
            populate(t1, e, r, n) {
                this.hasPattern = Oc("fill", this.layers, this.pixelRatio, e);
                const i = this.layers[0].layout.get("fill-sort-key"), a = [];
                for (const { feature: s, id: o, index: l, sourceLayerIndex: u } of t1){
                    const t1 = this.layers[0]._featureFilter.needGeometry, c = El(s, t1);
                    if (!this.layers[0]._featureFilter.filter(new Ca(this.zoom), c, r)) continue;
                    const h = i ? i.evaluate(c, {}, r, e.availableImages) : void 0, p = {
                        id: o,
                        properties: s.properties,
                        type: s.type,
                        sourceLayerIndex: u,
                        index: l,
                        geometry: t1 ? c.geometry : zl(s, r, n),
                        patterns: {},
                        sortKey: h
                    };
                    a.push(p);
                }
                i && a.sort((t1, e)=>t1.sortKey - e.sortKey);
                for (const n of a){
                    const { geometry: i, index: a, sourceLayerIndex: s } = n;
                    if (this.hasPattern) {
                        const t1 = Nc("fill", this.layers, n, this.zoom, this.pixelRatio, e);
                        this.patternFeatures.push(t1);
                    } else this.addFeature(n, i, a, r, {}, e.availableImages, e.brightness, e.elevationFeatures);
                    e.featureIndex.insert(t1[a].feature, i, a, s, this.index);
                }
            }
            update(t1, e, r, n, i, a, s) {
                this.programConfigurations.updatePaintArrays(t1, e, i, r, n, a, s);
            }
            addFeatures(t1, e, r, n, i, a) {
                for (const i of this.patternFeatures)this.addFeature(i, i.geometry, i.index, e, r, n, a, t1.elevationFeatures);
            }
            isEmpty() {
                return 0 === this.layoutVertexArray.length;
            }
            uploadPending() {
                return !this.uploaded || this.programConfigurations.needsUpload;
            }
            upload(t1) {
                this.uploaded || (this.layoutVertexBuffer = t1.createVertexBuffer(this.layoutVertexArray, cc), this.indexBuffer = t1.createIndexBuffer(this.indexArray), this.indexBuffer2 = t1.createIndexBuffer(this.indexArray2)), this.programConfigurations.upload(t1), this.uploaded = !0;
            }
            destroy() {
                this.layoutVertexBuffer && (this.layoutVertexBuffer.destroy(), this.indexBuffer.destroy(), this.indexBuffer2.destroy(), this.programConfigurations.destroy(), this.segments.destroy(), this.segments2.destroy());
            }
            addFeature(t1, e, r, n, i, a = [], s, o) {
                for (const t1 of Lc(e, 500)){
                    let e = 0;
                    for (const r of t1)e += r.length;
                    const r = this.segments.prepareSegment(e, this.layoutVertexArray, this.indexArray), n = r.vertexLength, i = [], a = [];
                    for (const e of t1){
                        if (0 === e.length) continue;
                        e !== t1[0] && a.push(i.length / 2);
                        const r = this.segments2.prepareSegment(e.length, this.layoutVertexArray, this.indexArray2), n = r.vertexLength;
                        this.layoutVertexArray.emplaceBack(e[0].x, e[0].y), this.indexArray2.emplaceBack(n + e.length - 1, n), i.push(e[0].x), i.push(e[0].y);
                        for(let t1 = 1; t1 < e.length; t1++)this.layoutVertexArray.emplaceBack(e[t1].x, e[t1].y), this.indexArray2.emplaceBack(n + t1 - 1, n + t1), i.push(e[t1].x), i.push(e[t1].y);
                        r.vertexLength += e.length, r.primitiveLength += e.length;
                    }
                    const s = hc(i, a);
                    for(let t1 = 0; t1 < s.length; t1 += 3)this.indexArray.emplaceBack(n + s[t1], n + s[t1 + 1], n + s[t1 + 2]);
                    r.vertexLength += e, r.primitiveLength += s.length / 3;
                }
                this.programConfigurations.populatePaintArrays(this.layoutVertexArray.length, t1, r, i, a, n, s);
            }
            constructor(t1){
                this.zoom = t1.zoom, this.pixelRatio = t1.pixelRatio, this.overscaling = t1.overscaling, this.layers = t1.layers, this.layerIds = this.layers.map((t1)=>t1.fqid), this.index = t1.index, this.hasPattern = !1, this.patternFeatures = [], this.layoutVertexArray = new xs, this.indexArray = new Ls, this.indexArray2 = new Ts, this.programConfigurations = new No(t1.layers, {
                    zoom: t1.zoom,
                    lut: t1.lut
                }), this.segments = new po, this.segments2 = new po, this.stateDependentLayerIds = this.layers.filter((t1)=>t1.isStateDependent()).map((t1)=>t1.id), this.projection = t1.projection;
            }
        }
        let jc, qc, $c, Gc;
        oa(Uc, "FillBucket", {
            omit: [
                "layers",
                "patternFeatures"
            ]
        });
        class Yc {
            _lazyInitLookup() {
                this.lookup || (this.lookup = new Uint8Array(Math.ceil(this.triangleCount / 8))), this.lookup.fill(0);
            }
            queryPoint(t1, e) {
                if (0 === this.triangleCount || 0 === this.cells.length) return;
                if (t1.x > this.max.x || this.min.x > t1.x || t1.y > this.max.y || this.min.y > t1.y) return;
                const r = Xc(t1.x - this.min.x, this.xScale, this.cellsX), n = Xc(t1.y - this.min.y, this.yScale, this.cellsY), i = this.cells[n * this.cellsX + r];
                if (i) {
                    this._lazyInitLookup();
                    for(let t1 = 0; t1 < i.len; t1++){
                        const r = this.payload[i.start + t1], n = Math.floor(r / 8), a = 1 << r % 8;
                        if (!(this.lookup[n] & a) && (this.lookup[n] |= a, e.push(r), e.length === this.triangleCount)) return;
                    }
                }
            }
            query(t1, e, r) {
                if (0 === this.triangleCount || 0 === this.cells.length) return;
                if (t1.x > this.max.x || this.min.x > e.x) return;
                if (t1.y > this.max.y || this.min.y > e.y) return;
                this._lazyInitLookup();
                const n = Xc(t1.x - this.min.x, this.xScale, this.cellsX), i = Xc(e.x - this.min.x, this.xScale, this.cellsX), a = Xc(t1.y - this.min.y, this.yScale, this.cellsY), s = Xc(e.y - this.min.y, this.yScale, this.cellsY);
                for(let t1 = a; t1 <= s; t1++)for(let e = n; e <= i; e++){
                    const n = this.cells[t1 * this.cellsX + e];
                    if (n) for(let t1 = 0; t1 < n.len; t1++){
                        const e = this.payload[n.start + t1], i = Math.floor(e / 8), a = 1 << e % 8;
                        if (!(this.lookup[i] & a) && (this.lookup[i] |= a, r.push(e), r.length === this.triangleCount)) return;
                    }
                }
            }
            constructor(t1, e, r, n){
                if (this.triangleCount = e.length / 3, this.min = new q(0, 0), this.max = new q(0, 0), this.xScale = 0, this.yScale = 0, this.cellsX = 0, this.cellsY = 0, this.cells = [], this.payload = [], 0 === this.triangleCount || 0 === t1.length) return;
                const [i, a] = [
                    t1[0].clone(),
                    t1[0].clone()
                ];
                for(let e = 1; e < t1.length; ++e){
                    const r = t1[e];
                    i.x = Math.min(i.x, r.x), i.y = Math.min(i.y, r.y), a.x = Math.max(a.x, r.x), a.y = Math.max(a.y, r.y);
                }
                if (n) {
                    const t1 = Math.ceil(Math.max(a.x - i.x, a.y - i.y) / n);
                    r = Math.max(r, t1);
                }
                if (0 === r) return;
                this.min = i, this.max = a;
                const s = this.max.sub(this.min);
                s.x = Math.max(s.x, 1), s.y = Math.max(s.y, 1);
                const o = Math.max(s.x, s.y) / r;
                this.cellsX = Math.max(1, Math.ceil(s.x / o)), this.cellsY = Math.max(1, Math.ceil(s.y / o)), this.xScale = 1 / o, this.yScale = 1 / o;
                const l = [];
                for(let r = 0; r < this.triangleCount; r++){
                    const n = t1[e[3 * r + 0]].sub(this.min), i = t1[e[3 * r + 1]].sub(this.min), a = t1[e[3 * r + 2]].sub(this.min), s = Xc(Math.floor(Math.min(n.x, i.x, a.x)), this.xScale, this.cellsX), u = Xc(Math.floor(Math.max(n.x, i.x, a.x)), this.xScale, this.cellsX), c = Xc(Math.floor(Math.min(n.y, i.y, a.y)), this.yScale, this.cellsY), h = Xc(Math.floor(Math.max(n.y, i.y, a.y)), this.yScale, this.cellsY), p = new q(0, 0), f = new q(0, 0), d = new q(0, 0), m = new q(0, 0);
                    for(let t1 = c; t1 <= h; ++t1){
                        p.y = f.y = t1 * o, d.y = m.y = (t1 + 1) * o;
                        for(let e = s; e <= u; ++e)p.x = d.x = e * o, f.x = m.x = (e + 1) * o, (Yl(n, i, a, p, f, m) || Yl(n, i, a, p, m, d)) && l.push({
                            cellIdx: t1 * this.cellsX + e,
                            triIdx: r
                        });
                    }
                }
                if (0 === l.length) return;
                l.sort((t1, e)=>t1.cellIdx - e.cellIdx || t1.triIdx - e.triIdx);
                let u = 0;
                for(; u < l.length;){
                    const t1 = l[u].cellIdx, e = {
                        start: this.payload.length,
                        len: 0
                    };
                    for(; u < l.length && l[u].cellIdx === t1;)++e.len, this.payload.push(l[u++].triIdx);
                    this.cells[t1] = e;
                }
            }
        }
        function Xc(t1, e, r) {
            return Math.max(0, Math.min(r - 1, Math.floor(t1 * e)));
        }
        oa(Yc, "TriangleGridIndex");
        class Zc {
            updateFootprints(t1, e) {
                for (const r of this.footprints)e.push({
                    footprint: r,
                    id: t1
                });
            }
            populate(t1, e, r, n) {
                const i = [];
                for (const { feature: e, id: a, index: s, sourceLayerIndex: o } of t1){
                    const t1 = this.layers[0]._featureFilter.needGeometry, l = El(e, t1);
                    if (!this.layers[0]._featureFilter.filter(new Ca(this.zoom), l, r)) continue;
                    const u = {
                        id: a,
                        properties: e.properties,
                        type: e.type,
                        sourceLayerIndex: o,
                        index: s,
                        geometry: t1 ? l.geometry : zl(e, r, n),
                        patterns: {}
                    };
                    i.push(u);
                }
                for (const n of i){
                    const { geometry: i, index: a, sourceLayerIndex: s } = n;
                    this.addFeature(n, i, a, r, {}, e.availableImages, e.brightness), e.featureIndex.insert(t1[a].feature, i, a, s, this.index);
                }
            }
            isEmpty() {
                return 0 === this.footprints.length;
            }
            uploadPending() {
                return !1;
            }
            upload(t1) {}
            update(t1, e, r, n, i, a, s) {}
            destroy() {}
            addFeature(t1, e, r, n, i, a = [], s) {
                for (const t1 of Lc(e, 2)){
                    const e = [], r = [], n = [], i = new q(1 / 0, 1 / 0), a = new q(-1 / 0, -1 / 0);
                    for (const s of t1)if (0 !== s.length) {
                        s !== t1[0] && n.push(r.length / 2);
                        for(let t1 = 0; t1 < s.length; t1++)r.push(s[t1].x), r.push(s[t1].y), e.push(s[t1]), i.x = Math.min(i.x, s[t1].x), i.y = Math.min(i.y, s[t1].y), a.x = Math.max(a.x, s[t1].x), a.y = Math.max(a.y, s[t1].y);
                    }
                    const s = hc(r, n), o = new Yc(e, s, 8, 256);
                    this.footprints.push({
                        vertices: e,
                        indices: s,
                        grid: o,
                        min: i,
                        max: a
                    });
                }
            }
            constructor(t1){
                this.zoom = t1.zoom, this.layers = t1.layers, this.layerIds = this.layers.map((t1)=>t1.fqid), this.index = t1.index, this.hasPattern = !1, this.stateDependentLayerIds = this.layers.filter((t1)=>t1.isStateDependent()).map((t1)=>t1.id), this.footprints = [];
            }
        }
        oa(Zc, "ClipBucket", {
            omit: [
                "layers"
            ]
        });
        const Hc = ys([
            {
                name: "a_pos_normal_ed",
                components: 4,
                type: "Int16"
            }
        ]), Wc = ys([
            {
                name: "a_pos_end",
                components: 4,
                type: "Int16"
            },
            {
                name: "a_angular_offset_factor",
                components: 1,
                type: "Int16"
            }
        ]), Kc = ys([
            {
                name: "a_centroid_pos",
                components: 2,
                type: "Uint16"
            }
        ]), Jc = ys([
            {
                name: "a_join_normal_inside",
                components: 3,
                type: "Int16"
            }
        ]), Qc = ys([
            {
                name: "a_hidden_by_landmark",
                components: 1,
                type: "Uint8"
            }
        ]), th = ys([
            {
                name: "a_pos_3",
                components: 3,
                type: "Int16"
            },
            {
                name: "a_pos_normal_3",
                components: 3,
                type: "Int16"
            }
        ]), { members: eh } = Hc;
        var rh, nh, ih, ah, sh, oh, lh, uh = {};
        function ch() {
            if (nh) return rh;
            nh = 1;
            var t1 = j();
            function e(t1, e, n, i, a) {
                this.properties = {}, this.extent = n, this.type = 0, this._pbf = t1, this._geometry = -1, this._keys = i, this._values = a, t1.readFields(r, this, e);
            }
            function r(t1, e, r) {
                1 == t1 ? e.id = r.readVarint() : 2 == t1 ? function(t1, e) {
                    for(var r = t1.readVarint() + t1.pos; t1.pos < r;){
                        var n = e._keys[t1.readVarint()], i = e._values[t1.readVarint()];
                        e.properties[n] = i;
                    }
                }(r, e) : 3 == t1 ? e.type = r.readVarint() : 4 == t1 && (e._geometry = r.pos);
            }
            function n(t1) {
                for(var e, r, n = 0, i = 0, a = t1.length, s = a - 1; i < a; s = i++)n += ((r = t1[s]).x - (e = t1[i]).x) * (e.y + r.y);
                return n;
            }
            return rh = e, e.types = [
                "Unknown",
                "Point",
                "LineString",
                "Polygon"
            ], e.prototype.loadGeometry = function() {
                var e = this._pbf;
                e.pos = this._geometry;
                for(var r, n = e.readVarint() + e.pos, i = 1, a = 0, s = 0, o = 0, l = []; e.pos < n;){
                    if (a <= 0) {
                        var u = e.readVarint();
                        i = 7 & u, a = u >> 3;
                    }
                    if (a--, 1 === i || 2 === i) s += e.readSVarint(), o += e.readSVarint(), 1 === i && (r && l.push(r), r = []), r.push(new t1(s, o));
                    else {
                        if (7 !== i) throw new Error("unknown command " + i);
                        r && r.push(r[0].clone());
                    }
                }
                return r && l.push(r), l;
            }, e.prototype.bbox = function() {
                var t1 = this._pbf;
                t1.pos = this._geometry;
                for(var e = t1.readVarint() + t1.pos, r = 1, n = 0, i = 0, a = 0, s = 1 / 0, o = -1 / 0, l = 1 / 0, u = -1 / 0; t1.pos < e;){
                    if (n <= 0) {
                        var c = t1.readVarint();
                        r = 7 & c, n = c >> 3;
                    }
                    if (n--, 1 === r || 2 === r) (i += t1.readSVarint()) < s && (s = i), i > o && (o = i), (a += t1.readSVarint()) < l && (l = a), a > u && (u = a);
                    else if (7 !== r) throw new Error("unknown command " + r);
                }
                return [
                    s,
                    l,
                    o,
                    u
                ];
            }, e.prototype.toGeoJSON = function(t1, r, i) {
                var a, s, o = this.extent * Math.pow(2, i), l = this.extent * t1, u = this.extent * r, c = this.loadGeometry(), h = e.types[this.type];
                function p(t1) {
                    for(var e = 0; e < t1.length; e++){
                        var r = t1[e];
                        t1[e] = [
                            360 * (r.x + l) / o - 180,
                            360 / Math.PI * Math.atan(Math.exp((180 - 360 * (r.y + u) / o) * Math.PI / 180)) - 90
                        ];
                    }
                }
                switch(this.type){
                    case 1:
                        var f = [];
                        for(a = 0; a < c.length; a++)f[a] = c[a][0];
                        p(c = f);
                        break;
                    case 2:
                        for(a = 0; a < c.length; a++)p(c[a]);
                        break;
                    case 3:
                        for(c = function(t1) {
                            var e = t1.length;
                            if (e <= 1) return [
                                t1
                            ];
                            for(var r, i, a = [], s = 0; s < e; s++){
                                var o = n(t1[s]);
                                0 !== o && (void 0 === i && (i = o < 0), i === o < 0 ? (r && a.push(r), r = [
                                    t1[s]
                                ]) : r.push(t1[s]));
                            }
                            return r && a.push(r), a;
                        }(c), a = 0; a < c.length; a++)for(s = 0; s < c[a].length; s++)p(c[a][s]);
                }
                1 === c.length ? c = c[0] : h = "Multi" + h;
                var d = {
                    type: "Feature",
                    geometry: {
                        type: h,
                        coordinates: c
                    },
                    properties: this.properties
                };
                return "id" in this && (d.id = this.id), d;
            }, rh;
        }
        function hh() {
            if (ah) return ih;
            ah = 1;
            var t1 = ch();
            function e(t1, e) {
                this.version = 1, this.name = null, this.extent = 4096, this.length = 0, this._pbf = t1, this._keys = [], this._values = [], this._features = [], t1.readFields(r, this, e), this.length = this._features.length;
            }
            function r(t1, e, r) {
                15 === t1 ? e.version = r.readVarint() : 1 === t1 ? e.name = r.readString() : 5 === t1 ? e.extent = r.readVarint() : 2 === t1 ? e._features.push(r.pos) : 3 === t1 ? e._keys.push(r.readString()) : 4 === t1 && e._values.push(function(t1) {
                    for(var e = null, r = t1.readVarint() + t1.pos; t1.pos < r;){
                        var n = t1.readVarint() >> 3;
                        e = 1 === n ? t1.readString() : 2 === n ? t1.readFloat() : 3 === n ? t1.readDouble() : 4 === n ? t1.readVarint64() : 5 === n ? t1.readVarint() : 6 === n ? t1.readSVarint() : 7 === n ? t1.readBoolean() : null;
                    }
                    return e;
                }(r));
            }
            return ih = e, e.prototype.feature = function(e) {
                if (e < 0 || e >= this._features.length) throw new Error("feature index out of bounds");
                this._pbf.pos = this._features[e];
                var r = this._pbf.readVarint() + this._pbf.pos;
                return new t1(this._pbf, r, this.extent, this._keys, this._values);
            }, ih;
        }
        function ph() {
            return lh || (lh = 1, uh.VectorTile = function() {
                if (oh) return sh;
                oh = 1;
                var t1 = hh();
                function e(e, r, n) {
                    if (3 === e) {
                        var i = new t1(n, n.readVarint() + n.pos);
                        i.length && (r[i.name] = i);
                    }
                }
                return sh = function(t1, r) {
                    this.layers = t1.readFields(e, {}, r);
                }, sh;
            }(), uh.VectorTileFeature = ch(), uh.VectorTileLayer = hh()), uh;
        }
        var fh = ph();
        class dh extends q {
            constructor(t1, e, r){
                super(t1, e), this.z = r;
            }
        }
        class mh extends dh {
            constructor(t1, e, r, n){
                super(t1, e, r), this.w = n;
            }
        }
        function yh(t1, e, r, n) {
            const i = [], a = 0 === n ? (t1, e, r, n, i, a)=>{
                t1.push(new q(a, r + (a - e) / (n - e) * (i - r)));
            } : (t1, e, r, n, i, a)=>{
                t1.push(new q(e + (a - r) / (i - r) * (n - e), a));
            };
            for (const s of t1){
                const t1 = [];
                for (const i of s){
                    if (i.length <= 2) continue;
                    const s = [];
                    for(let t1 = 0; t1 < i.length - 1; t1++){
                        const o = i[t1].x, l = i[t1].y, u = i[t1 + 1].x, c = i[t1 + 1].y, h = 0 === n ? o : l, p = 0 === n ? u : c;
                        h < e ? p > e && a(s, o, l, u, c, e) : h > r ? p < r && a(s, o, l, u, c, r) : s.push(i[t1]), p < e && h >= e && a(s, o, l, u, c, e), p > r && h <= r && a(s, o, l, u, c, r);
                    }
                    let o = i[i.length - 1];
                    const l = 0 === n ? o.x : o.y;
                    l >= e && l <= r && s.push(o), s.length && (o = s[s.length - 1], s[0].x === o.x && s[0].y === o.y || s.push(s[0]), t1.push(s));
                }
                t1.length && i.push(t1);
            }
            return i;
        }
        function gh(t1, e, r, n) {
            const i = "x" === r ? "y" : "x", a = (n - t1[r]) / (e[r] - t1[r]);
            t1[i] = t1[i] + (e[i] - t1[i]) * a, t1[r] = n, t1.hasOwnProperty("z") && (t1.z = ze(t1.z, e.z, a)), t1.hasOwnProperty("w") && (t1.w = ze(t1.w, e.w, a));
        }
        function xh(t1, e, r, n) {
            const i = r, a = n;
            for (const r of [
                "x",
                "y"
            ]){
                let n = t1, s = e;
                n[r] >= s[r] && (n = e, s = t1), n[r] < i && s[r] > i && gh(n, s, r, i), n[r] < a && s[r] > a && gh(s, n, r, a);
            }
        }
        const vh = Number.MAX_SAFE_INTEGER;
        function bh(t1, e, r, n) {
            return t1.order < e || t1.order === vh || !(t1.clipMask & r) || function(t1, e) {
                return 0 !== e.length && void 0 === e.find((e)=>e === t1);
            }(n, t1.clipScope);
        }
        function _h(t1, e) {
            return t1.x - e.x || t1.y - e.y;
        }
        function wh(t1, e) {
            return 0 === _h(t1.min, e.min) && 0 === _h(t1.max, e.max);
        }
        function Mh(t1, e) {
            return !(t1.min.x > e.max.x || t1.max.x < e.min.x || t1.min.y > e.max.y || t1.max.y < e.min.y);
        }
        function Ah(t1, e) {
            if (t1.length !== e.length) return !1;
            for(let r = 0; r < t1.length; r++)if (t1[r].sourceId !== e[r].sourceId || !wh(t1[r], e[r]) || t1[r].order !== e[r].order || t1[r].clipMask !== e[r].clipMask || !$(t1[r].clipScope, e[r].clipScope)) return !1;
            return !0;
        }
        function Sh(t1, e, r) {
            const n = 1 / Wr, i = 1 / (1 << r.canonical.z), a = (e.x * n + r.canonical.x) * i + r.wrap, s = (e.y * n + r.canonical.y) * i;
            return {
                min: new q((t1.x * n + r.canonical.x) * i + r.wrap, (t1.y * n + r.canonical.y) * i),
                max: new q(a, s)
            };
        }
        function Ih(t1, e, r) {
            const n = 1 << r.canonical.z, i = ((e.x - r.wrap) * n - r.canonical.x) * Wr, a = (e.y * n - r.canonical.y) * Wr;
            return {
                min: new q(((t1.x - r.wrap) * n - r.canonical.x) * Wr, (t1.y * n - r.canonical.y) * Wr),
                max: new q(i, a)
            };
        }
        function Ph(t1, e, r, n, i, a, s) {
            const o = t1.indices, l = t1.vertices, u = [];
            for(let c = n; c < n + i; c += 3){
                const n = e[r[c + 0] + a], i = e[r[c + 1] + a], h = e[r[c + 2] + a], p = Math.min(n.x, i.x, h.x), f = Math.max(n.x, i.x, h.x), d = Math.min(n.y, i.y, h.y), m = Math.max(n.y, i.y, h.y);
                u.length = 0, t1.grid.query(new q(p, d), new q(f, m), u);
                for(let t1 = 0; t1 < u.length; t1++){
                    const e = u[t1];
                    if (Yl(l[o[3 * e + 0]], l[o[3 * e + 1]], l[o[3 * e + 2]], n, i, h, s)) return !0;
                }
            }
            return !1;
        }
        function zh(t1, e, r, n) {
            if (!t1 || !r) return !1;
            let i = t1.vertices;
            if (!e.canonical.equals(n.canonical) || e.wrap !== n.wrap) {
                if (r.vertices.length < t1.vertices.length) return zh(r, n, t1, e);
                const a = e.canonical, s = n.canonical, o = Math.pow(2, s.z - a.z);
                i = t1.vertices.map((t1)=>new q((t1.x + a.x * Wr) * o - s.x * Wr, (t1.y + a.y * Wr) * o - s.y * Wr));
            }
            return Ph(r, i, t1.indices, 0, t1.indices.length, 0, 0);
        }
        function Eh(t1, e, r, n) {
            const i = Math.pow(2, n.z - r.z);
            return new q((t1 + r.x * Wr) * i - n.x * Wr, (e + r.y * Wr) * i - n.y * Wr);
        }
        function kh(t1, e) {
            const r = [];
            e.grid.queryPoint(t1, r);
            const n = e.indices, i = e.vertices;
            for(let e = 0; e < r.length; e++){
                const a = r[e];
                if (jl([
                    i[n[3 * a + 0]],
                    i[n[3 * a + 1]],
                    i[n[3 * a + 2]]
                ], t1)) return !0;
            }
            return !1;
        }
        const Th = [
            new q(0, 0),
            new q(Wr, 0),
            new q(Wr, Wr),
            new q(0, Wr)
        ];
        function Bh(t1, e) {
            const r = [];
            let n = [];
            if (!e || t1.length < 2) return [
                t1
            ];
            if (2 === t1.length) return $l(t1[0], t1[1], Th) ? [
                t1
            ] : [];
            for(let e = 0; e < t1.length + 2; e++){
                const i = t1[e % t1.length], a = t1[(e + 1) % t1.length], s = $l(0 === e ? t1[t1.length - 1] : t1[(e - 1) % t1.length], i, Th), o = $l(i, a, Th), l = s || o;
                l && n.push(i), l && o || n.length > 0 && (n.length > 1 && r.push(n), n = []);
            }
            return n.length > 1 && r.push(n), r;
        }
        const Ch = fh.VectorTileFeature.types, Vh = [
            "fill-extrusion-base",
            "fill-extrusion-height",
            "fill-extrusion-color",
            "fill-extrusion-pattern",
            "fill-extrusion-flood-light-wall-radius",
            "fill-extrusion-line-width",
            "fill-extrusion-emissive-strength"
        ], Dh = [
            "fill-extrusion-flood-light-ground-radius"
        ], Lh = Math.pow(2, 13), Rh = Math.pow(2, 15) - 1, Fh = new q(0, 1), Oh = 2147483648;
        function Nh(t1, e, r, n, i, a, s, o) {
            t1.emplaceBack((e << 1) + s, (r << 1) + a, (Math.floor(n * Lh) << 1) + i, Math.round(o));
        }
        function Uh(t1, e, r) {
            t1.emplaceBack(e.x * Wr, e.y * Wr, r ? 1 : 0);
        }
        function jh(t1, e, r, n, i, a) {
            t1.emplaceBack(e.x, e.y, (r.x << 1) + n, (r.y << 1) + i, a);
        }
        function qh(t1, e, r) {
            const n = 16384;
            t1.emplaceBack(e.x, e.y, e.z, r[0] * n, r[1] * n, r[2] * n);
        }
        class $h {
            constructor(){
                this.vertexOffset = 0, this.vertexCount = 0, this.indexOffset = 0, this.indexCount = 0;
            }
        }
        class Gh {
            span() {
                return new q(this.max.x - this.min.x, this.max.y - this.min.y);
            }
            constructor(){
                this.centroidXY = new q(0, 0), this.vertexArrayOffset = 0, this.vertexCount = 0, this.groundVertexArrayOffset = 0, this.groundVertexCount = 0, this.flags = 0, this.footprintSegIdx = -1, this.footprintSegLen = 0, this.polygonSegIdx = -1, this.polygonSegLen = 0, this.min = new q(Number.MAX_VALUE, Number.MAX_VALUE), this.max = new q(-Number.MAX_VALUE, -Number.MAX_VALUE), this.height = 0;
            }
        }
        class Yh {
            startRing(t1, e) {
                t1.min.x === Number.MAX_VALUE && (t1.min.x = t1.max.x = e.x, t1.min.y = t1.max.y = e.y);
            }
            appendEdge(t1, e, r) {
                this.accCount++, this.acc._add(e);
                let n = !!this.borders;
                e.x < t1.min.x ? (t1.min.x = e.x, n = !0) : e.x > t1.max.x && (t1.max.x = e.x, n = !0), e.y < t1.min.y ? (t1.min.y = e.y, n = !0) : e.y > t1.max.y && (t1.max.y = e.y, n = !0), ((0 === e.x || e.x === Wr) && e.x === r.x) != ((0 === e.y || e.y === Wr) && e.y === r.y) && this.processBorderOverlap(e, r), n && this.checkBorderIntersection(e, r);
            }
            checkBorderIntersection(t1, e) {
                e.x < 0 != t1.x < 0 && this.addBorderIntersection(0, ze(e.y, t1.y, (0 - e.x) / (t1.x - e.x))), e.x > Wr != t1.x > Wr && this.addBorderIntersection(1, ze(e.y, t1.y, (Wr - e.x) / (t1.x - e.x))), e.y < 0 != t1.y < 0 && this.addBorderIntersection(2, ze(e.x, t1.x, (0 - e.y) / (t1.y - e.y))), e.y > Wr != t1.y > Wr && this.addBorderIntersection(3, ze(e.x, t1.x, (Wr - e.y) / (t1.y - e.y)));
            }
            addBorderIntersection(t1, e) {
                this.borders || (this.borders = [
                    [
                        Number.MAX_VALUE,
                        -Number.MAX_VALUE
                    ],
                    [
                        Number.MAX_VALUE,
                        -Number.MAX_VALUE
                    ],
                    [
                        Number.MAX_VALUE,
                        -Number.MAX_VALUE
                    ],
                    [
                        Number.MAX_VALUE,
                        -Number.MAX_VALUE
                    ]
                ]);
                const r = this.borders[t1];
                e < r[0] && (r[0] = e), e > r[1] && (r[1] = e);
            }
            processBorderOverlap(t1, e) {
                if (t1.x === e.x) {
                    if (t1.y === e.y) return;
                    const r = 0 === t1.x ? 0 : 1;
                    this.addBorderIntersection(r, e.y), this.addBorderIntersection(r, t1.y);
                } else {
                    const r = 0 === t1.y ? 2 : 3;
                    this.addBorderIntersection(r, e.x), this.addBorderIntersection(r, t1.x);
                }
            }
            centroid() {
                return 0 === this.accCount ? new q(0, 0) : new q(Math.floor(Math.max(0, this.acc.x) / this.accCount), Math.floor(Math.max(0, this.acc.y) / this.accCount));
            }
            intersectsCount() {
                return this.borders ? this.borders.reduce((t1, e)=>t1 + +(e[0] !== Number.MAX_VALUE), 0) : 0;
            }
            constructor(){
                this.acc = new q(0, 0), this.accCount = 0, this.centroidDataIndex = 0;
            }
        }
        function Xh(t1, e) {
            const r = t1.add(e)._unit(), n = Q(t1.x * r.x + t1.y * r.y, -1, 1);
            var i, a, s;
            return s = Math.acos(n), Math.min(4, Math.max(-4, Math.tan(s))) / 4 * Rh * ((i = t1).x * (a = e).y - i.y * a.x < 0 ? -1 : 1);
        }
        const Zh = [
            (t1)=>t1.x < 0,
            (t1)=>t1.x > Wr,
            (t1)=>t1.y < 0,
            (t1)=>t1.y > Wr
        ];
        function Hh(t1, e, r, n) {
            const i = [
                4
            ];
            if (0 === n) return i;
            r._mult(n);
            const a = t1.sub(r), s = e.sub(r), o = [
                t1,
                e,
                a,
                s
            ];
            for(let t1 = 0; t1 < 4; t1++)for (const e of o)if (Zh[t1](e)) {
                i.push(t1);
                break;
            }
            return i;
        }
        class Wh {
            getDefaultSegment() {
                return this.regionSegments[4];
            }
            hasData() {
                return 0 !== this.vertexArray.length;
            }
            addData(t1, e, r, n = !1) {
                const i = t1.length;
                if (i > 2) {
                    let a = Math.max(0, this._segments.get().length - 1);
                    const s = this._segments._prepareSegment(4 * i, this.vertexArray.length, 2 * this._segmentToGroundQuads[a].length);
                    let o;
                    a !== this._segments.get().length - 1 && (a++, this._segmentToGroundQuads[a] = [], this._segmentToRegionTriCounts[a] = [
                        0,
                        0,
                        0,
                        0,
                        0
                    ]);
                    {
                        const e = t1[0], r = t1[1];
                        o = Xh(e.sub(t1[i - 1])._perp()._unit(), r.sub(e)._perp()._unit());
                    }
                    for(let l = 0; l < i; l++){
                        const u = l === i - 1 ? 0 : l + 1, c = t1[l], h = t1[u], p = t1[u === i - 1 ? 0 : u + 1], f = h.sub(c)._perp()._unit(), d = Xh(f, p.sub(h)._perp()._unit()), m = o, y = d;
                        if (ep(c, h, e) || n && rp(c, e) && rp(h, e)) {
                            o = d;
                            continue;
                        }
                        const g = s.vertexLength;
                        jh(this.vertexArray, c, h, 1, 1, m), jh(this.vertexArray, c, h, 1, 0, m), jh(this.vertexArray, c, h, 0, 1, y), jh(this.vertexArray, c, h, 0, 0, y), s.vertexLength += 4;
                        const x = Hh(c, h, f, r);
                        for (const t1 of x)this._segmentToGroundQuads[a].push({
                            id: g,
                            region: t1
                        }), this._segmentToRegionTriCounts[a][t1] += 2, s.primitiveLength += 2;
                        o = d;
                    }
                }
            }
            prepareBorderSegments() {
                if (!this.hasData()) return;
                const t1 = this._segments.get(), e = t1.length;
                for(let t1 = 0; t1 < e; t1++)this._segmentToGroundQuads[t1].sort((t1, e)=>t1.region - e.region);
                for(let r = 0; r < e; r++){
                    const e = this._segmentToGroundQuads[r], n = t1[r], i = this._segmentToRegionTriCounts[r];
                    i.reduce((t1, e)=>t1 + e, 0);
                    let a = 0;
                    for(let t1 = 0; t1 <= 4; t1++){
                        const e = i[t1];
                        if (0 !== e) {
                            let r = this.regionSegments[t1];
                            r || (r = this.regionSegments[t1] = new po);
                            const i = {
                                vertexOffset: n.vertexOffset,
                                primitiveOffset: n.primitiveOffset + a,
                                vertexLength: n.vertexLength,
                                primitiveLength: e
                            };
                            r.get().push(i);
                        }
                        a += e;
                    }
                    for(let t1 = 0; t1 < e.length; t1++){
                        const r = e[t1].id;
                        this.indexArray.emplaceBack(r, r + 1, r + 3), this.indexArray.emplaceBack(r, r + 3, r + 2);
                    }
                }
                this._segmentToGroundQuads = null, this._segmentToRegionTriCounts = null, this._segments.destroy(), this._segments = null;
            }
            addPaintPropertiesData(t1, e, r, n, i, a) {
                this.hasData() && this.programConfigurations.populatePaintArrays(this.vertexArray.length, t1, e, r, n, i, a);
            }
            upload(t1) {
                this.hasData() && (this.vertexBuffer = t1.createVertexBuffer(this.vertexArray, Wc.members), this.indexBuffer = t1.createIndexBuffer(this.indexArray));
            }
            uploadPaintProperties(t1) {
                this.hasData() && this.programConfigurations.upload(t1);
            }
            update(t1, e, r, n, i, a, s) {
                this.hasData() && this.programConfigurations.updatePaintArrays(t1, e, r, n, i, a, s);
            }
            updateHiddenByLandmark(t1) {
                if (!this.hasData()) return;
                const e = t1.groundVertexCount + t1.groundVertexArrayOffset;
                if (0 === t1.groundVertexCount) return;
                const r = t1.flags & Oh ? 1 : 0;
                for(let n = t1.groundVertexArrayOffset; n < e; ++n)this.hiddenByLandmarkVertexArray.emplace(n, r);
                this._needsHiddenByLandmarkUpdate = !0;
            }
            uploadHiddenByLandmark(t1) {
                this.hasData() && this._needsHiddenByLandmarkUpdate && (!this.hiddenByLandmarkVertexBuffer && this.hiddenByLandmarkVertexArray.length > 0 ? this.hiddenByLandmarkVertexBuffer = t1.createVertexBuffer(this.hiddenByLandmarkVertexArray, Qc.members, !0) : this.hiddenByLandmarkVertexBuffer && this.hiddenByLandmarkVertexBuffer.updateData(this.hiddenByLandmarkVertexArray), this._needsHiddenByLandmarkUpdate = !1);
            }
            destroy() {
                if (this.vertexBuffer) {
                    this.vertexBuffer.destroy(), this.indexBuffer.destroy(), this.hiddenByLandmarkVertexBuffer && this.hiddenByLandmarkVertexBuffer.destroy(), this._segments && this._segments.destroy(), this.programConfigurations.destroy();
                    for(let t1 = 0; t1 <= 4; t1++){
                        const e = this.regionSegments[t1];
                        e && e.destroy();
                    }
                }
            }
            constructor(t1){
                this.vertexArray = new _s, this.indexArray = new Ls, this.programConfigurations = new No(t1.layers, {
                    zoom: t1.zoom,
                    lut: t1.lut
                }, (t1)=>Dh.includes(t1)), this._segments = new po, this.hiddenByLandmarkVertexArray = new Ws, this._segmentToGroundQuads = {}, this._segmentToGroundQuads[0] = [], this._segmentToRegionTriCounts = {}, this._segmentToRegionTriCounts[0] = [
                    0,
                    0,
                    0,
                    0,
                    0
                ], this.regionSegments = {}, this.regionSegments[4] = new po;
            }
        }
        class Kh {
            updateFootprints(t1, e) {}
            populate(t1, e, r, n) {
                this.features = [], this.hasPattern = Oc("fill-extrusion", this.layers, this.pixelRatio, e), this.featuresOnBorder = [], this.borderFeatureIndices = [
                    [],
                    [],
                    [],
                    []
                ], this.borderDoneWithNeighborZ = [
                    -1,
                    -1,
                    -1,
                    -1
                ], this.selfDEMTileTimestamp = Number.MAX_VALUE, this.borderDEMTileTimestamp = [
                    Number.MAX_VALUE,
                    Number.MAX_VALUE,
                    Number.MAX_VALUE,
                    Number.MAX_VALUE
                ], this.tileToMeter = vl(r), this.edgeRadius = this.layers[0].layout.get("fill-extrusion-edge-radius") / this.tileToMeter, this.wallMode = 0 !== this.layers[0].paint.get("fill-extrusion-line-width").constantOr(1);
                for (const { feature: i, id: a, index: s, sourceLayerIndex: o } of t1){
                    const t1 = this.layers[0]._featureFilter.needGeometry, l = El(i, t1);
                    if (!this.layers[0]._featureFilter.filter(new Ca(this.zoom), l, r)) continue;
                    const u = {
                        id: a,
                        sourceLayerIndex: o,
                        index: s,
                        geometry: t1 ? l.geometry : zl(i, r, n),
                        properties: i.properties,
                        type: i.type,
                        patterns: {}
                    }, c = this.layoutVertexArray.length, h = "Polygon" === Ch[u.type];
                    if (this.hasPattern) this.features.push(Nc("fill-extrusion", this.layers, u, this.zoom, this.pixelRatio, e));
                    else if (this.wallMode) for (const t1 of u.geometry)for (const i of Bh(t1, h))this.addFeature(u, [
                        i
                    ], s, r, {}, e.availableImages, n, e.brightness);
                    else this.addFeature(u, u.geometry, s, r, {}, e.availableImages, n, e.brightness);
                    e.featureIndex.insert(i, u.geometry, s, o, this.index, c);
                }
                this.sortBorders(), "mercator" === this.projection.name && this.splitToSubtiles(), this.groundEffect.prepareBorderSegments(), this.polygonSegments.length = 0;
            }
            addFeatures(t1, e, r, n, i, a) {
                for (const t1 of this.features){
                    const s = "Polygon" === Ch[t1.type], { geometry: o } = t1;
                    if (this.wallMode) for (const l of o)for (const o of Bh(l, s))this.addFeature(t1, [
                        o
                    ], t1.index, e, r, n, i, a);
                    else this.addFeature(t1, o, t1.index, e, r, n, i, a);
                }
                this.sortBorders(), "mercator" === this.projection.name && this.splitToSubtiles();
            }
            update(t1, e, r, n, i, a, s) {
                this.programConfigurations.updatePaintArrays(t1, e, i, r, n, a, s), this.groundEffect.update(t1, e, i, r, n, a, s);
            }
            isEmpty() {
                return 0 === this.layoutVertexArray.length;
            }
            uploadPending() {
                return !this.uploaded || this.programConfigurations.needsUpload || this.groundEffect.programConfigurations.needsUpload;
            }
            upload(t1) {
                this.uploaded || (this.layoutVertexBuffer = t1.createVertexBuffer(this.layoutVertexArray, eh), this.indexBuffer = t1.createIndexBuffer(this.indexArray), this.wallVertexBuffer = t1.createVertexBuffer(this.wallVertexArray, Jc.members), this.layoutVertexExtArray && (this.layoutVertexExtBuffer = t1.createVertexBuffer(this.layoutVertexExtArray, th.members, !0)), this.groundEffect.upload(t1)), this.groundEffect.uploadPaintProperties(t1), this.programConfigurations.upload(t1), this.uploaded = !0;
            }
            uploadCentroid(t1) {
                this.groundEffect.uploadHiddenByLandmark(t1), this.needsCentroidUpdate && (!this.centroidVertexBuffer && this.centroidVertexArray.length > 0 ? this.centroidVertexBuffer = t1.createVertexBuffer(this.centroidVertexArray, Kc.members, !0) : this.centroidVertexBuffer && this.centroidVertexBuffer.updateData(this.centroidVertexArray), this.needsCentroidUpdate = !1);
            }
            destroy() {
                this.layoutVertexBuffer && (this.layoutVertexBuffer.destroy(), this.centroidVertexBuffer && this.centroidVertexBuffer.destroy(), this.layoutVertexExtBuffer && this.layoutVertexExtBuffer.destroy(), this.groundEffect.destroy(), this.indexBuffer.destroy(), this.programConfigurations.destroy(), this.segments.destroy());
            }
            addFeature(t1, e, r, n, i, a, s, o) {
                const l = this.layers[0].paint.get("fill-extrusion-flood-light-ground-radius").evaluate(t1, {}) / this.tileToMeter, u = [
                    new q(0, 0),
                    new q(Wr, Wr)
                ], c = s.projection, h = "globe" === c.name, p = this.wallMode || "Polygon" === Ch[t1.type], f = new Yh;
                f.centroidDataIndex = this.centroidData.length;
                const d = new Gh, m = this.layers[0].paint.get("fill-extrusion-base").evaluate(t1, {}, n) <= 0, y = this.layers[0].paint.get("fill-extrusion-height").evaluate(t1, {}, n);
                let g;
                if (d.height = y, d.vertexArrayOffset = this.layoutVertexArray.length, d.groundVertexArrayOffset = this.groundEffect.vertexArray.length, h && !this.layoutVertexExtArray && (this.layoutVertexExtArray = new Is), this.wallMode) {
                    if (h) return void ft("Non zero fill-extrusion-line-width is not yet supported on globe.");
                    if (1 !== e.length) return;
                    g = function(t1) {
                        const e = t1[0].x === t1[t1.length - 1].x && t1[0].y === t1[t1.length - 1].y, r = function(t1) {
                            let e = 0;
                            const r = t1.length;
                            for(let n = 0; n < r; n++)e += (t1[(n + 1) % r].x - t1[n].x) * (t1[(n + 1) % r].y + t1[n].y);
                            return e >= 0;
                        }(t1);
                        r || (t1 = t1.reverse());
                        const n = {
                            geometry: [],
                            joinNormals: [],
                            indices: []
                        }, i = [], a = [], s = [];
                        let o = t1.length;
                        for(; o >= 2 && t1[o - 1].equals(t1[o - 2]);)o--;
                        if (o < (e ? 3 : 2)) return n;
                        let l, u, c, h, p, f = 0;
                        for(; f < o - 1 && t1[f].equals(t1[f + 1]);)f++;
                        e && (l = t1[o - 2], p = t1[f].sub(l)._unit()._perp());
                        for(let r = f; r < o; r++){
                            if (c = r === o - 1 ? e ? t1[f + 1] : void 0 : t1[r + 1], c && t1[r].equals(c)) continue;
                            p && (h = p), l && (u = l), l = t1[r], p = c ? c.sub(l)._unit()._perp() : h, h = h || p;
                            let n = h.add(p);
                            0 === n.x && 0 === n.y || n._unit();
                            const d = n.x * p.x + n.y * p.y, m = 0 !== d ? 1 / d : 1 / 0, y = h.x * p.y - h.y * p.x > 0;
                            let g = "miter";
                            const x = 2;
                            "miter" === g && m > x && (g = "bevel"), "bevel" === g && (m > 100 && (g = "flipbevel"), m < x && (g = "miter"));
                            const v = (t1, e, r, n)=>{
                                const o = new q(t1.x, t1.y), l = new q(t1.x, t1.y);
                                o.x += e.x * n, o.y += e.y * n, l.x -= e.x * Math.max(r, 1), l.y -= e.y * Math.max(r, 1), s.push(e), i.push(o), a.push(l);
                            };
                            if ("miter" === g) n._mult(m), v(l, n, 0, 0);
                            else if ("flipbevel" === g) n = p.mult(-1), v(l, n, 0, 0), v(l, n.mult(-1), 0, 0);
                            else {
                                const t1 = -Math.sqrt(m * m - 1), e = y ? t1 : 0, r = y ? 0 : t1;
                                u && v(l, h, e, r), c && v(l, p, e, r);
                            }
                        }
                        n.geometry = [
                            ...i,
                            ...a.reverse(),
                            i[0]
                        ], n.joinNormals = [
                            ...s,
                            ...s.reverse(),
                            s[s.length - 1]
                        ];
                        const d = n.geometry.length - 1;
                        for(let t1 = 0; t1 < d / 2; t1++)if (t1 + 1 < d / 2) {
                            let e = t1, r = t1 + 1, i = d - 1 - t1, a = d - 2 - t1;
                            e = 0 === e ? d - 1 : e - 1, r = 0 === r ? d - 1 : r - 1, i = 0 === i ? d - 1 : i - 1, a = 0 === a ? d - 1 : a - 1, n.indices.push(i), n.indices.push(r), n.indices.push(e), n.indices.push(i), n.indices.push(a), n.indices.push(r);
                        }
                        return n;
                    }(e[0]), e = [
                        g.geometry
                    ];
                }
                const x = (t1, e)=>t1 < (e.length - 1) / 2 || t1 === e.length - 1, v = this.wallMode ? [
                    e
                ] : Lc(e, 500);
                for(let t1 = v.length - 1; t1 >= 0; t1--){
                    const e = v[t1];
                    (0 === e.length || (b = e[0]).every((t1)=>t1.x <= 0) || b.every((t1)=>t1.x >= Wr) || b.every((t1)=>t1.y <= 0) || b.every((t1)=>t1.y >= Wr)) && v.splice(t1, 1);
                }
                var b;
                let _;
                if (h) _ = sp(v, u, n);
                else {
                    _ = [];
                    for (const t1 of v)_.push({
                        polygon: t1,
                        bounds: u
                    });
                }
                const w = p ? this.edgeRadius : 0, M = w > 0 && this.zoom < 17, A = (t1, e)=>{
                    if (0 === t1.length) return !1;
                    const r = t1[t1.length - 1];
                    return e.x === r.x && e.y === r.y;
                };
                for (const { polygon: t1, bounds: e } of _){
                    let r = 0, i = 0;
                    for (const e of t1)p && !e[0].equals(e[e.length - 1]) && e.push(e[0]), i += p ? e.length - 1 : e.length;
                    const a = this.segments.prepareSegment((p ? 5 : 4) * i, this.layoutVertexArray, this.indexArray);
                    d.footprintSegIdx < 0 && (d.footprintSegIdx = this.footprintSegments.length), d.polygonSegIdx < 0 && (d.polygonSegIdx = this.polygonSegments.length);
                    const s = {
                        triangleArrayOffset: this.indexArray.length,
                        triangleCount: 0,
                        triangleSegIdx: this.segments.segments.length - 1
                    }, o = new $h;
                    if (o.vertexOffset = this.footprintVertices.length, o.indexOffset = 3 * this.footprintIndices.length, o.ringIndices = [], p) {
                        const i = [], s = [];
                        r = a.vertexLength;
                        for(let r = 0; r < t1.length; r++){
                            const u = t1[r];
                            u.length && 0 !== r && s.push(i.length / 2);
                            const p = [];
                            let f, d;
                            f = u[1].sub(u[0])._perp()._unit(), o.ringIndices.push(u.length - 1);
                            for(let t1 = 1; t1 < u.length; t1++){
                                const e = u[t1], r = u[t1 === u.length - 1 ? 1 : t1 + 1], s = e.clone();
                                if (w) {
                                    d = r.sub(e)._perp()._unit();
                                    const t1 = f.add(d)._unit(), n = w * Math.min(4, 1 / (f.x * t1.x + f.y * t1.y));
                                    s.x += n * t1.x, s.y += n * t1.y, s.x = Math.round(s.x), s.y = Math.round(s.y), f = d;
                                }
                                if (!m || 0 !== w && !M || A(p, s) || p.push(s), Nh(this.layoutVertexArray, s.x, s.y, 0, 0, 1, 1, 0), this.wallMode) {
                                    const e = x(t1, u);
                                    Uh(this.wallVertexArray, g.joinNormals[t1], !e);
                                }
                                a.vertexLength++, this.footprintVertices.emplaceBack(e.x, e.y), i.push(e.x, e.y), h && qh(this.layoutVertexExtArray, c.projectTilePoint(s.x, s.y, n), c.upVector(n, s.x, s.y));
                            }
                            m && (0 === w || M) && (0 !== p.length && A(p, p[0]) && p.pop(), this.groundEffect.addData(p, e, l));
                        }
                        const u = this.wallMode ? g.indices : hc(i, s);
                        for(let t1 = 0; t1 < u.length; t1 += 3)this.footprintIndices.emplaceBack(o.vertexOffset + u[t1 + 0], o.vertexOffset + u[t1 + 1], o.vertexOffset + u[t1 + 2]), this.indexArray.emplaceBack(r + u[t1], r + u[t1 + 2], r + u[t1 + 1]), a.primitiveLength++;
                        o.indexCount += u.length, o.vertexCount += this.footprintVertices.length - o.vertexOffset;
                    }
                    for(let i = 0; i < t1.length; i++){
                        const s = t1[i];
                        f.startRing(d, s[0]);
                        let o = s.length > 4 && np(s[s.length - 2], s[0], s[1]), u = w ? Qh(s[s.length - 2], s[0], s[1], w) : 0;
                        const y = [];
                        let v, b, _;
                        b = s[1].sub(s[0])._perp()._unit();
                        let M = !0;
                        for(let t1 = 1, i = 0; t1 < s.length; t1++){
                            let l = s[t1 - 1], p = s[t1];
                            const S = s[t1 === s.length - 1 ? 1 : t1 + 1];
                            if (f.appendEdge(d, p, l), ep(p, l, e)) {
                                w && (b = S.sub(p)._perp()._unit(), M = !M);
                                continue;
                            }
                            const I = p.sub(l)._perp(), P = I.x / (Math.abs(I.x) + Math.abs(I.y)), z = I.y > 0 ? 1 : 0, E = l.dist(p);
                            if (i + E > 32768 && (i = 0), w) {
                                _ = S.sub(p)._perp()._unit();
                                let t1 = tp(l, p, S, Jh(b, _), w);
                                isNaN(t1) && (t1 = 0);
                                const e = p.sub(l)._unit();
                                l = l.add(e.mult(u))._round(), p = p.add(e.mult(-t1))._round(), u = t1, b = _, m && this.zoom >= 17 && (A(y, l) || y.push(l), A(y, p) || y.push(p));
                            }
                            const k = a.vertexLength, T = s.length > 4 && np(l, p, S);
                            let B = ip(i, o, M);
                            if (Nh(this.layoutVertexArray, l.x, l.y, P, z, 0, 0, B), Nh(this.layoutVertexArray, l.x, l.y, P, z, 0, 1, B), this.wallMode) {
                                const e = x(t1 - 1, s), r = g.joinNormals[t1 - 1];
                                Uh(this.wallVertexArray, r, e), Uh(this.wallVertexArray, r, e);
                            }
                            if (i += E, B = ip(i, T, !M), o = T, Nh(this.layoutVertexArray, p.x, p.y, P, z, 0, 0, B), Nh(this.layoutVertexArray, p.x, p.y, P, z, 0, 1, B), this.wallMode) {
                                const e = x(t1, s), r = g.joinNormals[t1];
                                Uh(this.wallVertexArray, r, e), Uh(this.wallVertexArray, r, e);
                            }
                            if (a.vertexLength += 4, this.indexArray.emplaceBack(k + 0, k + 1, k + 2), this.indexArray.emplaceBack(k + 1, k + 3, k + 2), a.primitiveLength += 2, w) {
                                const n = r + (1 === t1 ? s.length - 2 : t1 - 2), i = 1 === t1 ? r : n + 1;
                                if (this.indexArray.emplaceBack(k + 1, n, k + 3), this.indexArray.emplaceBack(n, i, k + 3), a.primitiveLength += 2, void 0 === v && (v = k), !ep(S, s[t1], e)) {
                                    const e = t1 === s.length - 1 ? v : a.vertexLength;
                                    this.indexArray.emplaceBack(k + 2, k + 3, e), this.indexArray.emplaceBack(k + 3, e + 1, e), this.indexArray.emplaceBack(k + 3, i, e + 1), a.primitiveLength += 3;
                                }
                                M = !M;
                            }
                            if (h) {
                                const t1 = this.layoutVertexExtArray, e = c.projectTilePoint(l.x, l.y, n), r = c.projectTilePoint(p.x, p.y, n), i = c.upVector(n, l.x, l.y), a = c.upVector(n, p.x, p.y);
                                qh(t1, e, i), qh(t1, e, i), qh(t1, r, a), qh(t1, r, a);
                            }
                        }
                        p && (r += s.length - 1), m && w && this.zoom >= 17 && (0 !== y.length && A(y, y[0]) && y.pop(), this.groundEffect.addData(y, e, l, w > 0));
                    }
                    this.footprintSegments.push(o), s.triangleCount = this.indexArray.length - s.triangleArrayOffset, this.polygonSegments.push(s), ++d.footprintSegLen, ++d.polygonSegLen;
                }
                if (d.vertexCount = this.layoutVertexArray.length - d.vertexArrayOffset, d.groundVertexCount = this.groundEffect.vertexArray.length - d.groundVertexArrayOffset, 0 !== d.vertexCount) {
                    if (d.centroidXY = f.borders ? Fh : this.encodeCentroid(f, d), this.centroidData.push(d), f.borders) {
                        this.featuresOnBorder.push(f);
                        const t1 = this.featuresOnBorder.length - 1;
                        for(let e = 0; e < f.borders.length; e++)f.borders[e][0] !== Number.MAX_VALUE && this.borderFeatureIndices[e].push(t1);
                    }
                    this.programConfigurations.populatePaintArrays(this.layoutVertexArray.length, t1, r, i, a, n, o), this.groundEffect.addPaintPropertiesData(t1, r, i, a, n, o), this.maxHeight = Math.max(this.maxHeight, y);
                }
            }
            sortBorders() {
                for(let t1 = 0; t1 < this.borderFeatureIndices.length; t1++)this.borderFeatureIndices[t1].sort((e, r)=>this.featuresOnBorder[e].borders[t1][0] - this.featuresOnBorder[r].borders[t1][0]);
            }
            splitToSubtiles() {
                const t1 = [];
                for(let e = 0; e < this.centroidData.length; e++){
                    const r = this.centroidData[e], n = +(r.min.y + r.max.y > Wr), i = 2 * n + (+(r.min.x + r.max.x > Wr) ^ n);
                    for(let n = 0; n < r.polygonSegLen; n++){
                        const a = r.polygonSegIdx + n;
                        t1.push({
                            centroidIdx: e,
                            subtile: i,
                            polygonSegmentIdx: a,
                            triangleSegmentIdx: this.polygonSegments[a].triangleSegIdx
                        });
                    }
                }
                const e = new Ls;
                t1.sort((t1, e)=>t1.triangleSegmentIdx === e.triangleSegmentIdx ? t1.subtile - e.subtile : t1.triangleSegmentIdx - e.triangleSegmentIdx);
                let r = 0, n = 0, i = 0;
                for (const e of t1){
                    if (e.triangleSegmentIdx !== r) break;
                    i++;
                }
                const a = t1.length;
                for(; n !== t1.length;){
                    r = t1[n].triangleSegmentIdx;
                    let s = 0, o = n, l = n;
                    for(let e = o; e < i && t1[e].subtile === s; e++)l++;
                    for(; o !== i;){
                        const n = t1[o];
                        s = n.subtile;
                        const a = this.centroidData[n.centroidIdx].min.clone(), u = this.centroidData[n.centroidIdx].max.clone(), c = {
                            vertexOffset: this.segments.segments[r].vertexOffset,
                            primitiveOffset: e.length,
                            vertexLength: this.segments.segments[r].vertexLength,
                            primitiveLength: 0,
                            sortKey: void 0,
                            vaos: {}
                        };
                        for(let r = o; r < l; r++){
                            const n = t1[r], i = this.polygonSegments[n.polygonSegmentIdx], s = this.centroidData[n.centroidIdx].min, o = this.centroidData[n.centroidIdx].max, l = this.indexArray.uint16;
                            for(let t1 = i.triangleArrayOffset; t1 < i.triangleArrayOffset + i.triangleCount; t1++)e.emplaceBack(l[3 * t1], l[3 * t1 + 1], l[3 * t1 + 2]);
                            c.primitiveLength += i.triangleCount, a.x = Math.min(a.x, s.x), a.y = Math.min(a.y, s.y), u.x = Math.max(u.x, o.x), u.y = Math.max(u.y, o.y);
                        }
                        c.primitiveLength > 0 && this.triangleSubSegments.push({
                            segment: c,
                            min: a,
                            max: u
                        }), o = l;
                        for(let e = o; e < i && t1[e].subtile === t1[o].subtile; e++)l++;
                    }
                    n = i;
                    for(let e = n; e < a && t1[e].triangleSegmentIdx === t1[n].triangleSegmentIdx; e++)i++;
                }
                e._trim(), this.indexArray = e;
            }
            getVisibleSegments(t1, e, r) {
                const n = new po;
                if (this.wallMode) {
                    for (const t1 of this.triangleSubSegments)n.segments.push(t1.segment);
                    return n;
                }
                let i = 0, a = 0;
                const s = 1 << t1.canonical.z;
                if (e) {
                    const r = e.getMinMaxForTile(t1);
                    r && (i = r.min, a = r.max);
                }
                a += this.maxHeight;
                const o = t1.toUnwrapped();
                let l;
                const u = [
                    o.canonical.x / s + o.wrap,
                    o.canonical.y / s
                ], c = [
                    (o.canonical.x + 1) / s + o.wrap,
                    (o.canonical.y + 1) / s
                ], h = (t1, e, r)=>[
                        t1[0] * (1 - r[0]) + e[0] * r[0],
                        t1[1] * (1 - r[1]) + e[1] * r[1]
                    ], p = [], f = [];
                for (const t1 of this.triangleSubSegments){
                    p[0] = t1.min.x / Wr, p[1] = t1.min.y / Wr, f[0] = t1.max.x / Wr, f[1] = t1.max.y / Wr;
                    const e = h(u, c, p), s = h(u, c, f);
                    if (0 === new xu([
                        e[0],
                        e[1],
                        i
                    ], [
                        s[0],
                        s[1],
                        a
                    ]).intersectsPrecise(r)) {
                        l && (n.segments.push(l), l = void 0);
                        continue;
                    }
                    const o = t1.segment;
                    l && l.vertexOffset !== o.vertexOffset && (n.segments.push(l), l = void 0), l ? (l.vertexLength += o.vertexLength, l.primitiveLength += o.primitiveLength) : l = {
                        vertexOffset: o.vertexOffset,
                        primitiveLength: o.primitiveLength,
                        vertexLength: o.vertexLength,
                        primitiveOffset: o.primitiveOffset,
                        sortKey: void 0,
                        vaos: {}
                    };
                }
                return l && n.segments.push(l), n;
            }
            encodeCentroid(t1, e) {
                const r = t1.centroid(), n = e.span(), i = Math.min(7, Math.round(n.x * this.tileToMeter / 10)), a = Math.min(7, Math.round(n.y * this.tileToMeter / 10));
                return new q(Q(r.x, 1, Wr - 1) << 3 | i, Q(r.y, 1, Wr - 1) << 3 | a);
            }
            encodeBorderCentroid(t1) {
                if (!t1.borders) return new q(0, 0);
                const e = t1.borders, r = Number.MAX_VALUE;
                if (e[0][0] !== r || e[1][0] !== r) {
                    const t1 = e[0][0] !== r ? 0 : 1;
                    return new q(6 | (e[0][0] !== r ? 0 : 65528), (e[t1][0] + e[t1][1]) / 2 << 3 | 6);
                }
                {
                    const t1 = e[2][0] !== r ? 2 : 3;
                    return new q((e[t1][0] + e[t1][1]) / 2 << 3 | 6, 6 | (e[2][0] !== r ? 0 : 65528));
                }
            }
            showCentroid(t1) {
                const e = this.centroidData[t1.centroidDataIndex];
                e.flags &= Oh, e.centroidXY.x = 0, e.centroidXY.y = 0, this.writeCentroidToBuffer(e);
            }
            writeCentroidToBuffer(t1) {
                this.groundEffect.updateHiddenByLandmark(t1);
                const e = t1.vertexArrayOffset, r = t1.vertexCount + t1.vertexArrayOffset, n = t1.flags & Oh ? Fh : t1.centroidXY, i = this.centroidVertexArray.geta_centroid_pos0(e);
                if (this.centroidVertexArray.geta_centroid_pos1(e) !== n.y || i !== n.x) {
                    for(let t1 = e; t1 < r; ++t1)this.centroidVertexArray.emplace(t1, n.x, n.y);
                    this.needsCentroidUpdate = !0;
                }
            }
            createCentroidsBuffer() {
                this.centroidVertexArray.resize(this.layoutVertexArray.length), this.groundEffect.hiddenByLandmarkVertexArray.resize(this.groundEffect.vertexArray.length);
                for (const t1 of this.centroidData)this.writeCentroidToBuffer(t1);
            }
            updateReplacement(t1, e, r) {
                if (e.updateTime === this.replacementUpdateTime) return;
                this.replacementUpdateTime = e.updateTime;
                const n = e.getReplacementRegionsForTile(t1.toUnwrapped());
                if (Ah(this.activeReplacements, n)) return;
                if (this.activeReplacements = n, 0 === this.centroidVertexArray.length) this.createCentroidsBuffer();
                else for (const t1 of this.centroidData)t1.flags &= 2147483647;
                const i = [];
                for (const e of this.activeReplacements){
                    if (e.order < r) continue;
                    const n = Math.max(1, Math.pow(2, e.footprintTileId.canonical.z - t1.canonical.z));
                    for (const r of this.centroidData)if (!(r.flags & Oh || e.min.x > r.max.x || r.min.x > e.max.x || e.min.y > r.max.y || r.min.y > e.max.y)) for(let a = 0; a < r.footprintSegLen; a++){
                        const s = this.footprintSegments[r.footprintSegIdx + a];
                        if (i.length = 0, op(this.footprintVertices, s.vertexOffset, s.vertexCount, e.footprintTileId.canonical, t1.canonical, i), Ph(e.footprint, i, this.footprintIndices.uint16, s.indexOffset, s.indexCount, -s.vertexOffset, -n)) {
                            r.flags |= Oh;
                            break;
                        }
                    }
                }
                for (const t1 of this.centroidData)this.writeCentroidToBuffer(t1);
                this.borderDoneWithNeighborZ = [
                    -1,
                    -1,
                    -1,
                    -1
                ];
            }
            footprintContainsPoint(t1, e, r) {
                let n = !1;
                for(let i = 0; i < r.footprintSegLen; i++){
                    const a = this.footprintSegments[r.footprintSegIdx + i];
                    let s = 0;
                    for (const r of a.ringIndices){
                        for(let i = s, o = r + s - 1; i < r + s; o = i++){
                            const r = this.footprintVertices.int16[2 * (i + a.vertexOffset) + 0], s = this.footprintVertices.int16[2 * (i + a.vertexOffset) + 1], l = this.footprintVertices.int16[2 * (o + a.vertexOffset) + 1];
                            s > e != l > e && t1 < (this.footprintVertices.int16[2 * (o + a.vertexOffset) + 0] - r) * (e - s) / (l - s) + r && (n = !n);
                        }
                        s = r;
                    }
                }
                return n;
            }
            getHeightAtTileCoord(t1, e) {
                let r = Number.NEGATIVE_INFINITY, n = !0;
                const i = 4 * (t1 + Wr) * Wr + (e + Wr);
                if (this.partLookup.hasOwnProperty(i)) {
                    const t1 = this.partLookup[i];
                    return t1 ? {
                        height: t1.height,
                        hidden: !!(t1.flags & Oh)
                    } : void 0;
                }
                for (const a of this.centroidData)t1 > a.max.x || a.min.x > t1 || e > a.max.y || a.min.y > e || this.footprintContainsPoint(t1, e, a) && a && a.height > r && (r = a.height, this.partLookup[i] = a, n = !!(a.flags & Oh));
                if (r !== Number.NEGATIVE_INFINITY) return {
                    height: r,
                    hidden: n
                };
                this.partLookup[i] = void 0;
            }
            constructor(t1){
                this.zoom = t1.zoom, this.canonical = t1.canonical, this.overscaling = t1.overscaling, this.layers = t1.layers, this.pixelRatio = t1.pixelRatio, this.layerIds = this.layers.map((t1)=>t1.fqid), this.index = t1.index, this.hasPattern = !1, this.edgeRadius = 0, this.projection = t1.projection, this.activeReplacements = [], this.replacementUpdateTime = 0, this.centroidData = [], this.footprintIndices = new Ls, this.footprintVertices = new xs, this.footprintSegments = [], this.layoutVertexArray = new bs, this.centroidVertexArray = new oo, this.wallVertexArray = new uo, this.indexArray = new Ls, this.programConfigurations = new No(t1.layers, {
                    zoom: t1.zoom,
                    lut: t1.lut
                }, (t1)=>Vh.includes(t1)), this.segments = new po, this.stateDependentLayerIds = this.layers.filter((t1)=>t1.isStateDependent()).map((t1)=>t1.id), this.groundEffect = new Wh(t1), this.maxHeight = 0, this.partLookup = {}, this.triangleSubSegments = [], this.polygonSegments = [];
            }
        }
        function Jh(t1, e) {
            const r = t1.add(e)._unit();
            return t1.x * r.x + t1.y * r.y;
        }
        function Qh(t1, e, r, n) {
            const i = e.sub(t1)._perp()._unit(), a = r.sub(e)._perp()._unit();
            return tp(t1, e, r, Jh(i, a), n);
        }
        function tp(t1, e, r, n, i) {
            const a = Math.sqrt(1 - n * n);
            return Math.min(t1.dist(e) / 3, e.dist(r) / 3, i * a / n);
        }
        function ep(t1, e, r) {
            return t1.x < r[0].x && e.x < r[0].x || t1.x > r[1].x && e.x > r[1].x || t1.y < r[0].y && e.y < r[0].y || t1.y > r[1].y && e.y > r[1].y;
        }
        function rp(t1, e) {
            return t1.x < e[0].x || t1.x > e[1].x || t1.y < e[0].y || t1.y > e[1].y;
        }
        function np(t1, e, r) {
            if (t1.x < 0 || t1.x >= Wr || e.x < 0 || e.x >= Wr || r.x < 0 || r.x >= Wr) return !1;
            const n = r.sub(e), i = n.perp(), a = t1.sub(e);
            return (n.x * a.x + n.y * a.y) / Math.sqrt((n.x * n.x + n.y * n.y) * (a.x * a.x + a.y * a.y)) > -0.866 && i.x * a.x + i.y * a.y < 0;
        }
        function ip(t1, e, r) {
            const n = e ? 2 | t1 : -3 & t1;
            return r ? 1 | n : -2 & n;
        }
        function ap() {
            const t1 = Math.PI / 32, e = Math.tan(t1), r = rl;
            return r * Math.sqrt(1 + 2 * e * e) - r;
        }
        function sp(t1, e, r) {
            const n = 1 << r.z, i = pl(r.x / n), a = pl((r.x + 1) / n), s = fl(r.y / n), o = fl((r.y + 1) / n);
            return function(t1, e, r, n, i = 0, a) {
                const s = [];
                if (!t1.length || !r || !n) return s;
                const o = (t1, e)=>{
                    for (const r of t1)s.push({
                        polygon: r,
                        bounds: e
                    });
                }, l = Math.ceil(Math.log2(r)), u = Math.ceil(Math.log2(n)), c = l - u, h = [];
                for(let t1 = 0; t1 < Math.abs(c); t1++)h.push(c > 0 ? 0 : 1);
                for(let t1 = 0; t1 < Math.min(l, u); t1++)h.push(0), h.push(1);
                let p = t1;
                if (p = yh(p, e[0].y - i, e[1].y + i, 1), p = yh(p, e[0].x - i, e[1].x + i, 0), !p.length) return s;
                const f = [];
                for(h.length ? f.push({
                    polygons: p,
                    bounds: e,
                    depth: 0
                }) : o(p, e); f.length;){
                    const t1 = f.pop(), e = t1.depth, r = h[e], n = t1.bounds[0], s = t1.bounds[1], l = 0 === r ? n.x : n.y, u = 0 === r ? s.x : s.y, c = a ? a(r, l, u) : .5 * (l + u), p = yh(t1.polygons, l - i, c + i, r), d = yh(t1.polygons, c - i, u + i, r);
                    if (p.length) {
                        const t1 = [
                            n,
                            new q(0 === r ? c : s.x, 1 === r ? c : s.y)
                        ];
                        h.length > e + 1 ? f.push({
                            polygons: p,
                            bounds: t1,
                            depth: e + 1
                        }) : o(p, t1);
                    }
                    if (d.length) {
                        const t1 = [
                            new q(0 === r ? c : n.x, 1 === r ? c : n.y),
                            s
                        ];
                        h.length > e + 1 ? f.push({
                            polygons: d,
                            bounds: t1,
                            depth: e + 1
                        }) : o(d, t1);
                    }
                }
                return s;
            }(t1, e, Math.ceil((a - i) / 11.25), Math.ceil((s - o) / 11.25), 1, (t1, e, i)=>{
                if (0 === t1) return .5 * (e + i);
                {
                    const t1 = fl((r.y + e / Wr) / n);
                    return (cl(.5 * (fl((r.y + i / Wr) / n) + t1)) * n - r.y) * Wr;
                }
            });
        }
        function op(t1, e, r, n, i, a) {
            const s = Math.pow(2, n.z - i.z);
            for(let o = 0; o < r; o++){
                let r = t1.int16[2 * (o + e) + 0], l = t1.int16[2 * (o + e) + 1];
                r = (r + i.x * Wr) * s - n.x * Wr, l = (l + i.y * Wr) * s - n.y * Wr, a.push(new q(r, l));
            }
        }
        let lp, up;
        function cp(t1, e) {
            return t1.x * e.x + t1.y * e.y;
        }
        function hp(t1, e) {
            if (1 === t1.length) {
                let r = 0;
                const n = e[r++];
                let i;
                for(; !i || n.equals(i);)if (i = e[r++], !i) return 1 / 0;
                for(; r < e.length; r++){
                    const a = e[r], s = t1[0], o = i.sub(n), l = a.sub(n), u = s.sub(n), c = cp(o, o), h = cp(o, l), p = cp(l, l), f = cp(u, o), d = cp(u, l), m = c * p - h * h, y = (p * f - h * d) / m, g = (c * d - h * f) / m, x = n.z * (1 - y - g) + i.z * y + a.z * g;
                    if (isFinite(x)) return x;
                }
                return 1 / 0;
            }
            {
                let t1 = 1 / 0;
                for (const r of e)t1 = Math.min(t1, r.z);
                return t1;
            }
        }
        function pp(t1, e, r, n, i, a, s, o) {
            const l = s * i.getElevationAt(t1, e, !0, !0), u = 0 !== a[0], c = u ? 0 === a[1] ? s * (a[0] / 7 - 450) : s * function(t1, e, r) {
                const n = Math.floor(e[0] / 8), i = Math.floor(e[1] / 8), a = 10 * (e[0] - 8 * n), s = 10 * (e[1] - 8 * i), o = t1.getElevationAt(n, i, !0, !0), l = t1.getMeterToDEM(r), u = Math.floor(.5 * (a * l - 1)), c = Math.floor(.5 * (s * l - 1)), h = t1.tileCoordToPixel(n, i), p = 2 * u + 1, f = 2 * c + 1, d = function(t1, e, r, n, i) {
                    return [
                        t1.getElevationAtPixel(e, r, !0),
                        t1.getElevationAtPixel(e + i, r, !0),
                        t1.getElevationAtPixel(e, r + i, !0),
                        t1.getElevationAtPixel(e + n, r + i, !0)
                    ];
                }(t1, h.x - u, h.y - c, p, f), m = Math.abs(d[0] - d[1]), y = Math.abs(d[2] - d[3]), g = Math.abs(d[0] - d[2]) + Math.abs(d[1] - d[3]), x = Math.min(.25, .5 * l * (m + y) / p), v = Math.min(.25, .5 * l * g / f);
                return o + Math.max(x * a, v * s);
            }(i, a, o) : l;
            return {
                base: l + (0 === r ? -1 : r),
                top: u ? Math.max(c + n, l + r + 2) : l + n
            };
        }
        oa(Kh, "FillExtrusionBucket", {
            omit: [
                "layers",
                "features"
            ]
        }), oa(Gh, "PartData"), oa($h, "FootprintSegment"), oa(Yh, "BorderCentroidData"), oa(Wh, "GroundEffect");
        const fp = ys([
            {
                name: "a_pos_normal",
                components: 2,
                type: "Int16"
            },
            {
                name: "a_data",
                components: 4,
                type: "Uint8"
            },
            {
                name: "a_linesofar",
                components: 1,
                type: "Float32"
            }
        ], 4), dp = ys([
            {
                name: "a_z_offset_width",
                components: 3,
                type: "Float32"
            }
        ], 4), { members: mp } = fp, yp = ys([
            {
                name: "a_packed",
                components: 3,
                type: "Float32"
            }
        ]), { members: gp } = yp, xp = ys([
            {
                name: "a_pattern_data",
                components: 3,
                type: "Float32"
            }
        ]), { members: vp } = xp;
        class bp {
            getDash(t1, e) {
                const r = this.getKey(t1, e);
                return this.positions[r];
            }
            trim() {
                const t1 = this.width, e = this.height = st(this.nextRow);
                this.image.resize({
                    width: t1,
                    height: e
                });
            }
            getKey(t1, e) {
                return t1.join(",") + e;
            }
            getDashRanges(t1, e, r) {
                const n = [];
                let i = t1.length % 2 == 1 ? -t1[t1.length - 1] * r : 0, a = t1[0] * r, s = !0;
                n.push({
                    left: i,
                    right: a,
                    isDash: s,
                    zeroLength: 0 === t1[0]
                });
                let o = t1[0];
                for(let e = 1; e < t1.length; e++){
                    s = !s;
                    const l = t1[e];
                    i = o * r, o += l, a = o * r, n.push({
                        left: i,
                        right: a,
                        isDash: s,
                        zeroLength: 0 === l
                    });
                }
                return n;
            }
            addRoundDash(t1, e, r) {
                const n = e / 2;
                for(let e = -r; e <= r; e++){
                    const i = this.width * (this.nextRow + r + e);
                    let a = 0, s = t1[a];
                    for(let o = 0; o < this.width; o++){
                        o / s.right > 1 && (s = t1[++a]);
                        const l = Math.abs(o - s.left), u = Math.abs(o - s.right), c = Math.min(l, u);
                        let h;
                        const p = e / r * (n + 1);
                        if (s.isDash) {
                            const t1 = n - Math.abs(p);
                            h = Math.sqrt(c * c + t1 * t1);
                        } else h = n - Math.sqrt(c * c + p * p);
                        this.image.data[i + o] = Math.max(0, Math.min(255, h + 128));
                    }
                }
            }
            addRegularDash(t1, e) {
                for(let e = t1.length - 1; e >= 0; --e){
                    const r = t1[e], n = t1[e + 1];
                    r.zeroLength ? t1.splice(e, 1) : n && n.isDash === r.isDash && (n.left = r.left, t1.splice(e, 1));
                }
                const r = t1[0], n = t1[t1.length - 1];
                r.isDash === n.isDash && (r.left = n.left - this.width, n.right = r.right + this.width);
                const i = this.width * this.nextRow;
                let a = 0, s = t1[a];
                for(let r = 0; r < this.width; r++){
                    r / s.right > 1 && (s = t1[++a]);
                    const n = Math.abs(r - s.left), o = Math.abs(r - s.right), l = Math.min(n, o);
                    this.image.data[i + r] = Math.max(0, Math.min(255, (s.isDash ? l : -l) + e + 128));
                }
            }
            addDash(t1, e) {
                const r = this.getKey(t1, e);
                if (this.positions[r]) return this.positions[r];
                const n = "round" === e, i = n ? 7 : 0, a = 2 * i + 1;
                if (this.nextRow + a > this.height) return ft("LineAtlas out of space"), null;
                0 === t1.length && t1.push(1);
                let s = 0;
                for(let e = 0; e < t1.length; e++)t1[e] < 0 && (ft("Negative value is found in line dasharray, replacing values with 0"), t1[e] = 0), s += t1[e];
                if (0 !== s) {
                    const r = this.width / s, a = this.getDashRanges(t1, this.width, r);
                    n ? this.addRoundDash(a, r, i) : this.addRegularDash(a, "square" === e ? .5 * r : 0);
                }
                const o = this.nextRow + i;
                this.nextRow += a;
                const l = {
                    tl: [
                        o,
                        i
                    ],
                    br: [
                        s,
                        0
                    ]
                };
                return this.positions[r] = l, l;
            }
            constructor(t1, e){
                this.width = t1, this.height = e, this.nextRow = 0, this.image = new ac({
                    width: t1,
                    height: e
                }), this.positions = {}, this.uploaded = !1;
            }
        }
        oa(bp, "LineAtlas");
        const _p = fh.VectorTileFeature.types, wp = Math.cos(Math.PI / 180 * 37.5), Mp = Math.cos(Math.PI / 180 * 5);
        class Ap {
            updateFootprints(t1, e) {}
            populate(t1, e, r, n) {
                this.hasPattern = Oc("line", this.layers, this.pixelRatio, e);
                const i = this.layers[0].layout.get("line-sort-key");
                this.tileToMeter = vl(r);
                const a = this.layers[0].layout.get("line-z-offset"), s = a.isConstant() && !a.constantOr(0), o = this.layers[0].layout.get("line-elevation-reference");
                this.hasZOffset = "sea" === o || "ground" === o || !s && "none" === o, this.hasZOffset && "none" === o && ft(`line-elevation-reference: ground is used for the layer ${this.layerIds[0]} because non-zero line-z-offset value was found.`);
                const l = this.layers[0].layout.get("line-cross-slope");
                this.hasCrossSlope = this.hasZOffset && void 0 !== l;
                const u = [];
                for (const { feature: e, id: a, index: s, sourceLayerIndex: o } of t1){
                    const t1 = this.layers[0]._featureFilter.needGeometry, l = El(e, t1);
                    if (!this.layers[0]._featureFilter.filter(new Ca(this.zoom), l, r)) continue;
                    const c = i ? i.evaluate(l, {}, r) : void 0, h = {
                        id: a,
                        properties: e.properties,
                        type: e.type,
                        sourceLayerIndex: o,
                        index: s,
                        geometry: t1 ? l.geometry : zl(e, r, n),
                        patterns: {},
                        sortKey: c
                    };
                    u.push(h);
                }
                i && u.sort((t1, e)=>t1.sortKey - e.sortKey);
                const { lineAtlas: c, featureIndex: h } = e, p = this.addConstantDashes(c);
                for (const n of u){
                    const { geometry: i, index: a, sourceLayerIndex: s } = n;
                    if (p && this.addFeatureDashes(n, c), this.hasPattern) {
                        const t1 = Nc("line", this.layers, n, this.zoom, this.pixelRatio, e);
                        this.patternFeatures.push(t1);
                    } else this.addFeature(n, i, a, r, c.positions, e.availableImages, e.brightness);
                    h.insert(t1[a].feature, i, a, s, this.index);
                }
            }
            addConstantDashes(t1) {
                let e = !1;
                for (const r of this.layers){
                    const n = r.paint.get("line-dasharray").value, i = r.layout.get("line-cap").value;
                    if ("constant" !== n.kind || "constant" !== i.kind) e = !0;
                    else {
                        const e = i.value, r = n.value;
                        if (!r) continue;
                        t1.addDash(r, e);
                    }
                }
                return e;
            }
            addFeatureDashes(t1, e) {
                const r = this.zoom;
                for (const n of this.layers){
                    const i = n.paint.get("line-dasharray").value, a = n.layout.get("line-cap").value;
                    if ("constant" === i.kind && "constant" === a.kind) continue;
                    let s, o;
                    if ("constant" === i.kind) {
                        if (s = i.value, !s) continue;
                    } else s = i.evaluate({
                        zoom: r
                    }, t1);
                    o = "constant" === a.kind ? a.value : a.evaluate({
                        zoom: r
                    }, t1), e.addDash(s, o), t1.patterns[n.id] = e.getKey(s, o);
                }
            }
            update(t1, e, r, n, i, a, s) {
                this.programConfigurations.updatePaintArrays(t1, e, i, r, n, a, s);
            }
            addFeatures(t1, e, r, n, i, a) {
                for (const t1 of this.patternFeatures)this.addFeature(t1, t1.geometry, t1.index, e, r, n, a);
            }
            isEmpty() {
                return 0 === this.layoutVertexArray.length;
            }
            uploadPending() {
                return !this.uploaded || this.programConfigurations.needsUpload;
            }
            upload(t1) {
                this.uploaded || (0 !== this.layoutVertexArray2.length && (this.layoutVertexBuffer2 = t1.createVertexBuffer(this.layoutVertexArray2, gp)), 0 !== this.patternVertexArray.length && (this.patternVertexBuffer = t1.createVertexBuffer(this.patternVertexArray, vp)), !this.zOffsetVertexBuffer && this.zOffsetVertexArray.length > 0 && (this.zOffsetVertexBuffer = t1.createVertexBuffer(this.zOffsetVertexArray, dp.members, !0)), this.layoutVertexBuffer = t1.createVertexBuffer(this.layoutVertexArray, mp), this.indexBuffer = t1.createIndexBuffer(this.indexArray)), this.programConfigurations.upload(t1), this.uploaded = !0;
            }
            destroy() {
                this.layoutVertexBuffer && (this.zOffsetVertexBuffer && this.zOffsetVertexBuffer.destroy(), this.layoutVertexBuffer.destroy(), this.indexBuffer.destroy(), this.programConfigurations.destroy(), this.segments.destroy());
            }
            lineFeatureClips(t1) {
                if (t1.properties && t1.properties.hasOwnProperty("mapbox_clip_start") && t1.properties.hasOwnProperty("mapbox_clip_end")) return {
                    start: +t1.properties.mapbox_clip_start,
                    end: +t1.properties.mapbox_clip_end
                };
            }
            addFeature(t1, e, r, n, i, a, s) {
                const o = this.layers[0].layout, l = o.get("line-join").evaluate(t1, {}), u = o.get("line-cap").evaluate(t1, {}), c = o.get("line-miter-limit"), h = o.get("line-round-limit");
                this.lineClips = this.lineFeatureClips(t1), this.lineFeature = t1, this.zOffsetValue = o.get("line-z-offset").value;
                const p = this.layers[0].paint.get("line-width").value;
                "constant" !== p.kind && !1 === p.isLineProgressConstant && (this.variableWidthValue = p);
                for (const r of e)this.addLine(r, t1, n, l, u, c, h);
                this.programConfigurations.populatePaintArrays(this.layoutVertexArray.length, t1, r, i, a, n, s);
            }
            addLine(t1, e, r, n, i, a, s) {
                this.distance = 0, this.prevDistance = 0, this.scaledDistance = 0, this.totalDistance = 0, this.totalFeatureLength = 0, this.lineSoFar = 0, this.currentVertex = void 0;
                const o = "none" === n;
                if (this.patternJoinNone = this.hasPattern && o, this.segmentStart = 0, this.segmentStartf32 = 0, this.segmentPoints = [], this.lineClips) {
                    this.lineClipsArray.push(this.lineClips);
                    for(let e = 0; e < t1.length - 1; e++)this.totalDistance += t1[e].dist(t1[e + 1]);
                    this.totalFeatureLength = this.totalDistance / (this.lineClips.end - this.lineClips.start), this.updateScaledDistance(), this.maxLineLength = Math.max(this.maxLineLength, this.totalDistance);
                }
                const l = "Polygon" === _p[e.type];
                let u = t1.length;
                for(; u >= 2 && t1[u - 1].equals(t1[u - 2]);)u--;
                let c = 0;
                for(; c < u - 1 && t1[c].equals(t1[c + 1]);)c++;
                if (u < (l ? 3 : 2)) return;
                "bevel" === n && (a = 1.05);
                const h = this.segments.prepareSegment(10 * u, this.layoutVertexArray, this.indexArray);
                let p, f, d, m, y, g;
                this.e1 = this.e2 = -1, l && (p = t1[u - 2], y = t1[c].sub(p)._unit()._perp());
                for(let e = c; e < u; e++){
                    if (d = e === u - 1 ? l ? t1[c + 1] : void 0 : t1[e + 1], d && t1[e].equals(d)) continue;
                    y && (m = y), p && (f = p), p = t1[e], g = this.evaluateLineProgressFeatures(f ? f.dist(p) : 0), y = d ? d.sub(p)._unit()._perp() : m, m = m || y;
                    const r = f && d;
                    let x = r ? n : l || o ? "butt" : i;
                    const v = m.x * y.x + m.y * y.y;
                    if (o) {
                        const t1 = function(t1) {
                            if (t1.patternJoinNone) {
                                const e = t1.segmentPoints.length / 2, r = t1.lineSoFar - t1.segmentStart;
                                for(let n = 0; n < e; ++n){
                                    const e = t1.segmentPoints[2 * n + 1], i = Math.round(t1.segmentPoints[2 * n]) + .5 + .25 * e;
                                    t1.patternVertexArray.emplaceBack(i, r, t1.segmentStart), t1.patternVertexArray.emplaceBack(i, r, t1.segmentStart);
                                }
                                t1.segmentPoints.length = 0;
                            }
                            t1.e1 = t1.e2 = -1;
                        };
                        if (r && v < Mp) {
                            this.updateDistance(f, p), this.addCurrentVertex(p, m, 1, 1, h, g), t1(this), this.addCurrentVertex(p, y, -1, -1, h, g);
                            continue;
                        }
                        if (f) {
                            if (!d) {
                                this.updateDistance(f, p), this.addCurrentVertex(p, m, 1, 1, h, g), t1(this);
                                continue;
                            }
                            x = "miter";
                        }
                    }
                    let b = m.add(y);
                    0 === b.x && 0 === b.y || b._unit();
                    const _ = b.x * y.x + b.y * y.y, w = 0 !== _ ? 1 / _ : 1 / 0, M = 2 * Math.sqrt(2 - 2 * _), A = _ < wp && f && d, S = m.x * y.y - m.y * y.x > 0, I = this.overscaling <= 16 ? 15 * Wr / (512 * this.overscaling) : 0;
                    if (r && "round" === x) {
                        if (w < s) x = "miter";
                        else if (w <= 2) {
                            const t1 = Sp(p, -10, Wr + 10);
                            x = this.hasZOffset && (t1 || this.hasCrossSlope) ? "miter" : "fakeround";
                        }
                    }
                    if ("miter" === x && w > a && (x = "bevel"), "bevel" === x && (w > 2 && (x = "flipbevel"), w < a && (x = "miter")), f && !("miter" === x && A) && this.updateDistance(f, p), "miter" === x) {
                        if (A) {
                            const t1 = p.dist(f);
                            if (t1 > 2 * I) {
                                const e = p.sub(p.sub(f)._mult(I / t1)._round());
                                this.updateDistance(f, e), this.addCurrentVertex(e, m, 0, 0, h, g), f = e;
                            }
                            this.updateDistance(f, p), b._mult(w), this.addCurrentVertex(p, b, 0, 0, h, g);
                            const e = p.dist(d);
                            if (e > 2 * I) {
                                const t1 = p.add(d.sub(p)._mult(I / e)._round());
                                this.updateDistance(p, t1), this.addCurrentVertex(t1, y, 0, 0, h, g), p = t1;
                            }
                        } else b._mult(w), this.addCurrentVertex(p, b, 0, 0, h, g);
                    } else if ("flipbevel" === x) {
                        if (w > 100) b = y.mult(-1);
                        else {
                            const t1 = w * m.add(y).mag() / m.sub(y).mag();
                            b._perp()._mult(t1 * (S ? -1 : 1));
                        }
                        this.addCurrentVertex(p, b, 0, 0, h, g), this.addCurrentVertex(p, b.mult(-1), 0, 0, h, g);
                    } else if ("bevel" === x || "fakeround" === x) {
                        null != g && f && this.addCurrentVertex(p, m, -1, -1, h, g);
                        const t1 = p.dist(f) <= 2 * I && "bevel" !== x, e = b.mult(S ? 1 : -1);
                        e._mult(w);
                        const r = y.mult(S ? -1 : 1), n = m.mult(S ? -1 : 1), i = this.evaluateLineProgressFeatures(this.distance);
                        if (null == g && (this.addHalfVertex(p, e.x, e.y, !1, !S, 0, h, i), t1 || this.addHalfVertex(p, e.x + 2 * n.x, e.y + 2 * n.y, !1, S, 0, h, i)), "fakeround" === x) {
                            const t1 = Math.round(180 * M / Math.PI / 20);
                            this.addHalfVertex(p, n.x, n.y, !1, S, 0, h, i);
                            for(let e = 0; e < t1; e++){
                                let a = e / t1;
                                if (.5 !== a) {
                                    const t1 = a - .5;
                                    a += a * t1 * (a - 1) * ((1.0904 + v * (v * (3.55645 - 1.43519 * v) - 3.2452)) * t1 * t1 + (.848013 + v * (.215638 * v - 1.06021)));
                                }
                                const s = r.sub(n)._mult(a)._add(n)._unit();
                                this.addHalfVertex(p, s.x, s.y, !1, S, 0, h, i);
                            }
                            this.addHalfVertex(p, r.x, r.y, !1, S, 0, h, i);
                        }
                        t1 || null != g || this.addHalfVertex(p, e.x + 2 * r.x, e.y + 2 * r.y, !1, S, 0, h, i), null != g && d && this.addCurrentVertex(p, y, 1, 1, h, g);
                    } else "butt" === x ? this.addCurrentVertex(p, b, 0, 0, h, g) : "square" === x ? (f || this.addCurrentVertex(p, b, -1, -1, h, g), this.addCurrentVertex(p, b, 0, 0, h, g), f && this.addCurrentVertex(p, b, 1, 1, h, g)) : "round" === x && (f && (this.addCurrentVertex(p, m, 0, 0, h, g), this.addCurrentVertex(p, m, 1, 1, h, g, !0)), d && (this.addCurrentVertex(p, y, -1, -1, h, g, !0), this.addCurrentVertex(p, y, 0, 0, h, g)));
                }
            }
            addVerticesTo(t1, e, r, n, i, a, s, o, l, u) {
                const c = (e.w - t1.w) / this.tessellationStep | 0;
                let h = 0;
                const p = this.scaledDistance;
                if (c > 1) {
                    this.lineSoFar = t1.w;
                    const p = (e.x - t1.x) / c, f = (e.y - t1.y) / c, d = (e.z - t1.z) / c, m = (e.w - t1.w) / c;
                    for(let e = 1; e < c; ++e){
                        t1.x += p, t1.y += f, t1.z += d, this.lineSoFar += m, h += m;
                        const e = this.evaluateLineProgressFeatures(this.prevDistance + h);
                        this.scaledDistance = (this.prevDistance + h) / this.totalDistance, this.addHalfVertex(t1, r, n, u, !1, s, l, e), this.addHalfVertex(t1, i, a, u, !0, -o, l, e);
                    }
                }
                this.lineSoFar = e.w, this.scaledDistance = p;
                const f = this.evaluateLineProgressFeatures(this.distance);
                this.addHalfVertex(e, r, n, u, !1, s, l, f), this.addHalfVertex(e, i, a, u, !0, -o, l, f);
            }
            evaluateLineProgressFeatures(t1) {
                if (!this.variableWidthValue && !this.hasZOffset) return null;
                this.evaluationGlobals.lineProgress = 0, this.lineClips ? this.evaluationGlobals.lineProgress = Math.min(1, (this.totalFeatureLength * this.lineClips.start + t1) / this.totalFeatureLength) : ft(`line-progress evaluation for ${this.layerIds[0]} requires enabling 'lineMetrics' for the source.`);
                let e = 0;
                return this.variableWidthValue && "constant" !== this.variableWidthValue.kind && (e = this.variableWidthValue.evaluate(this.evaluationGlobals, this.lineFeature) || 0), this.hasZOffset ? "constant" === this.zOffsetValue.kind ? {
                    zOffset: this.zOffsetValue.value,
                    variableWidth: e
                } : {
                    zOffset: this.zOffsetValue.evaluate(this.evaluationGlobals, this.lineFeature) || 0,
                    variableWidth: e
                } : {
                    zOffset: 0,
                    variableWidth: e
                };
            }
            addCurrentVertex(t1, e, r, n, i, a, s = !1) {
                const o = e.x + e.y * r, l = e.y - e.x * r, u = e.y * n - e.x, c = -e.y - e.x * n;
                if (null != a) {
                    const e = this.hasZOffset, h = -10, p = Wr + 10, f = a.zOffset, d = new mh(t1.x, t1.y, f, this.lineSoFar), m = !!e && Sp(t1, h, p), y = this.lineSoFar, g = this.distance;
                    if (this.currentVertex) {
                        if (m) {
                            const e = this.currentVertexIsOutside, a = this.currentVertex, m = new mh(t1.x, t1.y, f, this.lineSoFar);
                            if (xh(a, m, h, p), !Sp(m, h, p)) {
                                if (e) {
                                    this.e1 = this.e2 = -1, this.distance -= a.dist(d), this.lineSoFar = a.w;
                                    const t1 = this.evaluateLineProgressFeatures(a.w - this.totalFeatureLength * (this.lineClips ? this.lineClips.start : 0));
                                    this.addHalfVertex(a, o, l, s, !1, r, i, t1), this.addHalfVertex(a, u, c, s, !0, -n, i, t1), this.prevDistance = this.distance;
                                }
                                this.distance = this.prevDistance + a.dist(m), this.scaledDistance = this.distance / this.totalDistance, this.addVerticesTo(a, m, o, l, u, c, r, n, i, s), this.distance = g, this.scaledDistance = this.distance / this.totalDistance;
                            }
                        } else {
                            const t1 = this.currentVertex;
                            if (this.currentVertexIsOutside) {
                                xh(t1, d, h, p), this.e1 = this.e2 = -1, this.distance -= t1.dist(d), this.scaledDistance = this.distance / this.totalDistance, this.lineSoFar = t1.w;
                                const e = this.evaluateLineProgressFeatures(t1.w - this.totalFeatureLength * (this.lineClips ? this.lineClips.start : 0));
                                this.addHalfVertex(t1, o, l, s, !1, r, i, e), this.addHalfVertex(t1, u, c, s, !0, -n, i, e), this.prevDistance = this.distance, this.distance = g, this.scaledDistance = this.distance / this.totalDistance;
                            }
                            this.addVerticesTo(t1, d, o, l, u, c, r, n, i, s);
                        }
                    } else m || (this.addHalfVertex(t1, o, l, s, !1, r, i, a), this.addHalfVertex(t1, u, c, s, !0, -n, i, a));
                    this.currentVertex = d, this.currentVertexIsOutside = m, this.lineSoFar = y;
                } else this.addHalfVertex(t1, o, l, s, !1, r, i, a), this.addHalfVertex(t1, u, c, s, !0, -n, i, a);
            }
            addHalfVertex({ x: t1, y: e }, r, n, i, a, s, o, l) {
                if (this.patternJoinNone && (0 === this.segmentPoints.length && (this.segmentStart = this.lineSoFar, this.segmentStartf32 = Math.fround(this.lineSoFar)), a || this.segmentPoints.push(this.lineSoFar - this.segmentStart, s)), this.layoutVertexArray.emplaceBack((t1 << 1) + (i ? 1 : 0), (e << 1) + (a ? 1 : 0), Math.round(63 * r) + 128, Math.round(63 * n) + 128, 1 + (0 === s ? 0 : s < 0 ? -1 : 1), 0, this.lineSoFar - this.segmentStartf32), this.lineClips) {
                    const t1 = ze(this.lineClips.start, this.lineClips.end, this.scaledDistance);
                    this.layoutVertexArray2.emplaceBack(this.scaledDistance, this.lineClipsArray.length, t1);
                }
                const u = o.vertexLength++;
                this.e1 >= 0 && this.e2 >= 0 && (this.indexArray.emplaceBack(this.e1, this.e2, u), o.primitiveLength++), a ? this.e2 = u : this.e1 = u, null != l && this.zOffsetVertexArray.emplaceBack(l.zOffset, l.variableWidth, l.variableWidth);
            }
            updateScaledDistance() {
                this.lineClips ? (this.scaledDistance = this.distance / this.totalDistance, this.lineSoFar = this.totalFeatureLength * this.lineClips.start + this.distance) : this.lineSoFar = this.distance;
            }
            updateDistance(t1, e) {
                this.prevDistance = this.distance, this.distance += t1.dist(e), this.updateScaledDistance();
            }
            constructor(t1){
                this.evaluationGlobals = {
                    zoom: 0,
                    lineProgress: void 0
                }, this.zoom = t1.zoom, this.evaluationGlobals.zoom = this.zoom, this.overscaling = t1.overscaling, this.pixelRatio = t1.pixelRatio, this.layers = t1.layers, this.layerIds = this.layers.map((t1)=>t1.fqid), this.index = t1.index, this.projection = t1.projection, this.hasPattern = !1, this.hasZOffset = !1, this.hasCrossSlope = !1, this.patternFeatures = [], this.lineClipsArray = [], this.gradients = {}, this.layers.forEach((t1)=>{
                    this.gradients[t1.id] = {};
                }), this.layoutVertexArray = new ws, this.layoutVertexArray2 = new Ms, this.patternVertexArray = new Ms, this.indexArray = new Ls, this.programConfigurations = new No(t1.layers, {
                    zoom: t1.zoom,
                    lut: t1.lut
                }), this.segments = new po, this.maxLineLength = 0, this.zOffsetVertexArray = new Ms, this.stateDependentLayerIds = this.layers.filter((t1)=>t1.isStateDependent()).map((t1)=>t1.id), this.tessellationStep = t1.tessellationStep ? t1.tessellationStep : Wr / 64;
            }
        }
        function Sp(t1, e, r) {
            return t1.x < e || t1.x > r || t1.y < e || t1.y > r;
        }
        let Ip, Pp;
        function zp(t1, e, r) {
            return e * (Wr / (t1.tileSize * Math.pow(2, r - t1.tileID.overscaledZ)));
        }
        oa(Ap, "LineBucket", {
            omit: [
                "layers",
                "patternFeatures",
                "currentVertex",
                "currentVertexIsOutside"
            ]
        });
        const Ep = (t1, e, r)=>(1 - r) * t1 + r * e;
        function kp(t1, e) {
            return 1 / zp(t1, 1, e.tileZoom);
        }
        function Tp(t1, e, r, n) {
            return t1.translatePosMatrix(n || e.tileID.projMatrix, e, r.paint.get("line-translate"), r.paint.get("line-translate-anchor"));
        }
        const Bp = (t1)=>{
            const e = [];
            Cp(t1) && e.push("RENDER_LINE_DASH"), t1.paint.get("line-gradient") && e.push("RENDER_LINE_GRADIENT");
            const r = t1.paint.get("line-trim-offset");
            0 === r[0] && 0 === r[1] || e.push("RENDER_LINE_TRIM_OFFSET"), 0 !== t1.paint.get("line-border-width").constantOr(1) && e.push("RENDER_LINE_BORDER");
            const n = "none" === t1.layout.get("line-join").constantOr("miter"), i = !!t1.paint.get("line-pattern").constantOr(1);
            return n && i && e.push("LINE_JOIN_NONE"), e;
        };
        function Cp(t1) {
            const e = t1.paint.get("line-dasharray").value;
            return e.value || "constant" !== e.kind;
        }
        let Vp;
        const Dp = ()=>Vp || (Vp = {
                layout: Ip || (Ip = new Ga({
                    "line-cap": new qa(Ya.layout_line["line-cap"]),
                    "line-join": new qa(Ya.layout_line["line-join"]),
                    "line-miter-limit": new ja(Ya.layout_line["line-miter-limit"]),
                    "line-round-limit": new ja(Ya.layout_line["line-round-limit"]),
                    "line-sort-key": new qa(Ya.layout_line["line-sort-key"]),
                    "line-z-offset": new qa(Ya.layout_line["line-z-offset"]),
                    "line-elevation-reference": new ja(Ya.layout_line["line-elevation-reference"]),
                    "line-cross-slope": new ja(Ya.layout_line["line-cross-slope"]),
                    visibility: new ja(Ya.layout_line.visibility),
                    "line-width-unit": new ja(Ya.layout_line["line-width-unit"])
                })),
                paint: Pp || (Pp = new Ga({
                    "line-opacity": new qa(Ya.paint_line["line-opacity"]),
                    "line-color": new qa(Ya.paint_line["line-color"]),
                    "line-translate": new ja(Ya.paint_line["line-translate"]),
                    "line-translate-anchor": new ja(Ya.paint_line["line-translate-anchor"]),
                    "line-width": new qa(Ya.paint_line["line-width"]),
                    "line-gap-width": new qa(Ya.paint_line["line-gap-width"]),
                    "line-offset": new qa(Ya.paint_line["line-offset"]),
                    "line-blur": new qa(Ya.paint_line["line-blur"]),
                    "line-dasharray": new qa(Ya.paint_line["line-dasharray"]),
                    "line-pattern": new qa(Ya.paint_line["line-pattern"]),
                    "line-gradient": new $a(Ya.paint_line["line-gradient"]),
                    "line-trim-offset": new ja(Ya.paint_line["line-trim-offset"]),
                    "line-trim-fade-range": new ja(Ya.paint_line["line-trim-fade-range"]),
                    "line-trim-color": new ja(Ya.paint_line["line-trim-color"]),
                    "line-emissive-strength": new ja(Ya.paint_line["line-emissive-strength"]),
                    "line-border-width": new qa(Ya.paint_line["line-border-width"]),
                    "line-border-color": new qa(Ya.paint_line["line-border-color"]),
                    "line-occlusion-opacity": new ja(Ya.paint_line["line-occlusion-opacity"]),
                    "line-color-use-theme": new qa({
                        type: "string",
                        default: "default",
                        "property-type": "data-driven"
                    }),
                    "line-gradient-use-theme": new qa({
                        type: "string",
                        default: "default",
                        "property-type": "data-driven"
                    }),
                    "line-trim-color-use-theme": new qa({
                        type: "string",
                        default: "default",
                        "property-type": "data-driven"
                    }),
                    "line-border-color-use-theme": new qa({
                        type: "string",
                        default: "default",
                        "property-type": "data-driven"
                    })
                }))
            }, Vp);
        class Lp extends qa {
            possiblyEvaluate(t1, e) {
                return e = new Ca(Math.floor(e.zoom), {
                    now: e.now,
                    fadeDuration: e.fadeDuration,
                    transition: e.transition
                }), super.possiblyEvaluate(t1, e);
            }
            evaluate(t1, e, r, n) {
                return e = nt({}, e, {
                    zoom: Math.floor(e.zoom)
                }), super.evaluate(t1, e, r, n);
            }
        }
        let Rp;
        function Fp(t1, e) {
            return e > 0 ? e + 2 * t1 : t1;
        }
        const Op = ys([
            {
                name: "a_pos_offset",
                components: 4,
                type: "Int16"
            },
            {
                name: "a_tex_size",
                components: 4,
                type: "Uint16"
            },
            {
                name: "a_pixeloffset",
                components: 4,
                type: "Int16"
            }
        ], 4), Np = ys([
            {
                name: "a_globe_anchor",
                components: 3,
                type: "Int16"
            },
            {
                name: "a_globe_normal",
                components: 3,
                type: "Float32"
            }
        ], 4), Up = ys([
            {
                name: "a_projected_pos",
                components: 4,
                type: "Float32"
            }
        ], 4);
        ys([
            {
                name: "a_fade_opacity",
                components: 1,
                type: "Uint32"
            }
        ], 4);
        const jp = ys([
            {
                name: "a_auto_z_offset",
                components: 1,
                type: "Float32"
            }
        ], 4), qp = ys([
            {
                name: "a_texb",
                components: 2,
                type: "Uint16"
            }
        ]), $p = ys([
            {
                name: "a_placed",
                components: 2,
                type: "Uint8"
            },
            {
                name: "a_shift",
                components: 2,
                type: "Float32"
            },
            {
                name: "a_elevation_from_sea",
                components: 2,
                type: "Float32"
            }
        ]), Gp = ys([
            {
                name: "a_size_scale",
                components: 1,
                type: "Float32"
            },
            {
                name: "a_padding",
                components: 2,
                type: "Float32"
            },
            {
                name: "a_auto_z_offset",
                components: 1,
                type: "Float32"
            }
        ]);
        ys([
            {
                type: "Int16",
                name: "projectedAnchorX"
            },
            {
                type: "Int16",
                name: "projectedAnchorY"
            },
            {
                type: "Int16",
                name: "projectedAnchorZ"
            },
            {
                type: "Int16",
                name: "tileAnchorX"
            },
            {
                type: "Int16",
                name: "tileAnchorY"
            },
            {
                type: "Float32",
                name: "x1"
            },
            {
                type: "Float32",
                name: "y1"
            },
            {
                type: "Float32",
                name: "x2"
            },
            {
                type: "Float32",
                name: "y2"
            },
            {
                type: "Int16",
                name: "padding"
            },
            {
                type: "Uint32",
                name: "featureIndex"
            },
            {
                type: "Uint16",
                name: "sourceLayerIndex"
            },
            {
                type: "Uint16",
                name: "bucketIndex"
            }
        ]);
        const Yp = ys([
            {
                name: "a_pos",
                components: 3,
                type: "Int16"
            },
            {
                name: "a_anchor_pos",
                components: 2,
                type: "Int16"
            },
            {
                name: "a_extrude",
                components: 2,
                type: "Int16"
            }
        ], 4), Xp = ys([
            {
                name: "a_pos_2f",
                components: 2,
                type: "Float32"
            },
            {
                name: "a_radius",
                components: 1,
                type: "Float32"
            },
            {
                name: "a_flags",
                components: 2,
                type: "Int16"
            }
        ], 4);
        ys([
            {
                name: "triangle",
                components: 3,
                type: "Uint16"
            }
        ]), ys([
            {
                type: "Int16",
                name: "projectedAnchorX"
            },
            {
                type: "Int16",
                name: "projectedAnchorY"
            },
            {
                type: "Int16",
                name: "projectedAnchorZ"
            },
            {
                type: "Float32",
                name: "tileAnchorX"
            },
            {
                type: "Float32",
                name: "tileAnchorY"
            },
            {
                type: "Uint16",
                name: "glyphStartIndex"
            },
            {
                type: "Uint16",
                name: "numGlyphs"
            },
            {
                type: "Uint32",
                name: "vertexStartIndex"
            },
            {
                type: "Uint32",
                name: "lineStartIndex"
            },
            {
                type: "Uint32",
                name: "lineLength"
            },
            {
                type: "Uint16",
                name: "segment"
            },
            {
                type: "Uint16",
                name: "lowerSize"
            },
            {
                type: "Uint16",
                name: "upperSize"
            },
            {
                type: "Float32",
                name: "lineOffsetX"
            },
            {
                type: "Float32",
                name: "lineOffsetY"
            },
            {
                type: "Uint8",
                name: "writingMode"
            },
            {
                type: "Uint8",
                name: "placedOrientation"
            },
            {
                type: "Uint8",
                name: "hidden"
            },
            {
                type: "Uint32",
                name: "crossTileID"
            },
            {
                type: "Int16",
                name: "associatedIconIndex"
            },
            {
                type: "Uint8",
                name: "flipState"
            }
        ]), ys([
            {
                type: "Float32",
                name: "tileAnchorX"
            },
            {
                type: "Float32",
                name: "tileAnchorY"
            },
            {
                type: "Int16",
                name: "projectedAnchorX"
            },
            {
                type: "Int16",
                name: "projectedAnchorY"
            },
            {
                type: "Int16",
                name: "projectedAnchorZ"
            },
            {
                type: "Int16",
                name: "rightJustifiedTextSymbolIndex"
            },
            {
                type: "Int16",
                name: "centerJustifiedTextSymbolIndex"
            },
            {
                type: "Int16",
                name: "leftJustifiedTextSymbolIndex"
            },
            {
                type: "Int16",
                name: "verticalPlacedTextSymbolIndex"
            },
            {
                type: "Int16",
                name: "placedIconSymbolIndex"
            },
            {
                type: "Int16",
                name: "verticalPlacedIconSymbolIndex"
            },
            {
                type: "Uint16",
                name: "key"
            },
            {
                type: "Uint16",
                name: "textBoxStartIndex"
            },
            {
                type: "Uint16",
                name: "textBoxEndIndex"
            },
            {
                type: "Uint16",
                name: "verticalTextBoxStartIndex"
            },
            {
                type: "Uint16",
                name: "verticalTextBoxEndIndex"
            },
            {
                type: "Uint16",
                name: "iconBoxStartIndex"
            },
            {
                type: "Uint16",
                name: "iconBoxEndIndex"
            },
            {
                type: "Uint16",
                name: "verticalIconBoxStartIndex"
            },
            {
                type: "Uint16",
                name: "verticalIconBoxEndIndex"
            },
            {
                type: "Uint16",
                name: "featureIndex"
            },
            {
                type: "Uint16",
                name: "numHorizontalGlyphVertices"
            },
            {
                type: "Uint16",
                name: "numVerticalGlyphVertices"
            },
            {
                type: "Uint16",
                name: "numIconVertices"
            },
            {
                type: "Uint16",
                name: "numVerticalIconVertices"
            },
            {
                type: "Uint16",
                name: "useRuntimeCollisionCircles"
            },
            {
                type: "Uint32",
                name: "crossTileID"
            },
            {
                type: "Float32",
                components: 2,
                name: "textOffset"
            },
            {
                type: "Float32",
                name: "collisionCircleDiameter"
            },
            {
                type: "Float32",
                name: "zOffset"
            },
            {
                type: "Uint8",
                name: "hasIconTextFit"
            }
        ]), ys([
            {
                type: "Float32",
                name: "offsetX"
            }
        ]), ys([
            {
                type: "Int16",
                name: "x"
            },
            {
                type: "Int16",
                name: "y"
            }
        ]);
        var Zp = 24;
        const Hp = 128;
        function Wp(t1, e, r, n, i) {
            if ("camera" === t1.kind) return t1.maxSize;
            if ("composite" === t1.kind) {
                const n = e.possiblyEvaluate(new Ca(t1.maxZoom), r).evaluate(i, {}, r), a = e.possiblyEvaluate(new Ca(t1.minZoom), r).evaluate(i, {}, r);
                return Math.max(n, a);
            }
            return e.possiblyEvaluate(new Ca(n)).evaluate(i, {}, r);
        }
        function Kp(t1, e) {
            const { expression: r } = e;
            if ("constant" === r.kind) return {
                kind: "constant",
                layoutSize: r.evaluate(new Ca(t1 + 1))
            };
            if ("source" === r.kind) return {
                kind: "source"
            };
            {
                const { zoomStops: e, interpolationType: n } = r;
                let i = 0;
                for(; i < e.length && e[i] <= t1;)i++;
                i = Math.max(0, i - 1);
                let a = i;
                for(; a < e.length && e[a] < t1 + 1;)a++;
                a = Math.min(e.length - 1, a);
                const s = e[i], o = e[a];
                return "composite" === r.kind ? {
                    kind: "composite",
                    minZoom: s,
                    maxZoom: o,
                    interpolationType: n
                } : {
                    kind: "camera",
                    minZoom: s,
                    maxZoom: o,
                    minSize: r.evaluate(new Ca(s)),
                    maxSize: r.evaluate(new Ca(o)),
                    interpolationType: n
                };
            }
        }
        function Jp(t1, { uSize: e, uSizeT: r }, { lowerSize: n, upperSize: i }) {
            return "source" === t1.kind ? n / Hp : "composite" === t1.kind ? ze(n / Hp, i / Hp, r) : e;
        }
        function Qp(t1, e, r = 1) {
            let n = 0, i = 0;
            if ("constant" === t1.kind) i = t1.layoutSize * r;
            else if ("source" !== t1.kind) {
                const { interpolationType: a, minZoom: s, maxZoom: o } = t1, l = a ? Q(ai.interpolationFactor(a, e, s, o), 0, 1) : 0;
                "camera" === t1.kind ? i = ze(t1.minSize, t1.maxSize, l) * r : n = l * r;
            }
            return {
                uSizeT: n,
                uSize: i
            };
        }
        var tf = Object.freeze({
            __proto__: null,
            SIZE_PACK_FACTOR: Hp,
            evaluateSizeForFeature: Jp,
            evaluateSizeForZoom: Qp,
            getRasterizedIconSize: Wp,
            getSizeData: Kp
        });
        function ef(t1, e, r) {
            return t1.sections.forEach((t1)=>{
                t1.text = function(t1, e, r) {
                    const n = e.layout.get("text-transform").evaluate(r, {});
                    return "uppercase" === n ? t1 = t1.toLocaleUpperCase() : "lowercase" === n && (t1 = t1.toLocaleLowerCase()), Ba.applyArabicShaping && (t1 = Ba.applyArabicShaping(t1)), t1;
                }(t1.text, e, r);
            }), t1;
        }
        const rf = {
            "!": "\uFE15",
            "#": "\uFF03",
            $: "\uFF04",
            "%": "\uFF05",
            "&": "\uFF06",
            "(": "\uFE35",
            ")": "\uFE36",
            "*": "\uFF0A",
            "+": "\uFF0B",
            ",": "\uFE10",
            "-": "\uFE32",
            ".": "\u30FB",
            "/": "\uFF0F",
            ":": "\uFE13",
            ";": "\uFE14",
            "<": "\uFE3F",
            "=": "\uFF1D",
            ">": "\uFE40",
            "?": "\uFE16",
            "@": "\uFF20",
            "[": "\uFE47",
            "\\": "\uFF3C",
            "]": "\uFE48",
            "^": "\uFF3E",
            _: "\uFE33",
            "`": "\uFF40",
            "{": "\uFE37",
            "|": "\u2015",
            "}": "\uFE38",
            "~": "\uFF5E",
            "\xa2": "\uFFE0",
            "\xa3": "\uFFE1",
            "\xa5": "\uFFE5",
            "\xa6": "\uFFE4",
            "\xac": "\uFFE2",
            "\xaf": "\uFFE3",
            "\u2013": "\uFE32",
            "\u2014": "\uFE31",
            "\u2018": "\uFE43",
            "\u2019": "\uFE44",
            "\u201C": "\uFE41",
            "\u201D": "\uFE42",
            "\u2026": "\uFE19",
            "\u2027": "\u30FB",
            "\u20A9": "\uFFE6",
            "\u3001": "\uFE11",
            "\u3002": "\uFE12",
            "\u3008": "\uFE3F",
            "\u3009": "\uFE40",
            "\u300A": "\uFE3D",
            "\u300B": "\uFE3E",
            "\u300C": "\uFE41",
            "\u300D": "\uFE42",
            "\u300E": "\uFE43",
            "\u300F": "\uFE44",
            "\u3010": "\uFE3B",
            "\u3011": "\uFE3C",
            "\u3014": "\uFE39",
            "\u3015": "\uFE3A",
            "\u3016": "\uFE17",
            "\u3017": "\uFE18",
            "\uFF01": "\uFE15",
            "\uFF08": "\uFE35",
            "\uFF09": "\uFE36",
            "\uFF0C": "\uFE10",
            "\uFF0D": "\uFE32",
            "\uFF0E": "\u30FB",
            "\uFF1A": "\uFE13",
            "\uFF1B": "\uFE14",
            "\uFF1C": "\uFE3F",
            "\uFF1E": "\uFE40",
            "\uFF1F": "\uFE16",
            "\uFF3B": "\uFE47",
            "\uFF3D": "\uFE48",
            "\uFF3F": "\uFE33",
            "\uFF5B": "\uFE37",
            "\uFF5C": "\u2015",
            "\uFF5D": "\uFE38",
            "\uFF5F": "\uFE35",
            "\uFF60": "\uFE36",
            "\uFF61": "\uFE12",
            "\uFF62": "\uFE41",
            "\uFF63": "\uFE42",
            "\u2190": "\u2191",
            "\u2192": "\u2193"
        };
        function nf(t1) {
            return "\uFE36" === t1 || "\uFE48" === t1 || "\uFE38" === t1 || "\uFE44" === t1 || "\uFE42" === t1 || "\uFE3E" === t1 || "\uFE3C" === t1 || "\uFE3A" === t1 || "\uFE18" === t1 || "\uFE40" === t1 || "\uFE10" === t1 || "\uFE13" === t1 || "\uFE14" === t1 || "\uFF40" === t1 || "\uFFE3" === t1 || "\uFE11" === t1 || "\uFE12" === t1;
        }
        function af(t1) {
            return "\uFE35" === t1 || "\uFE47" === t1 || "\uFE37" === t1 || "\uFE43" === t1 || "\uFE41" === t1 || "\uFE3D" === t1 || "\uFE3B" === t1 || "\uFE39" === t1 || "\uFE17" === t1 || "\uFE3F" === t1;
        }
        var sf, of, lf, uf = {};
        /*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ function cf() {
            return sf || (sf = 1, uf.read = function(t1, e, r, n, i) {
                var a, s, o = 8 * i - n - 1, l = (1 << o) - 1, u = l >> 1, c = -7, h = r ? i - 1 : 0, p = r ? -1 : 1, f = t1[e + h];
                for(h += p, a = f & (1 << -c) - 1, f >>= -c, c += o; c > 0; a = 256 * a + t1[e + h], h += p, c -= 8);
                for(s = a & (1 << -c) - 1, a >>= -c, c += n; c > 0; s = 256 * s + t1[e + h], h += p, c -= 8);
                if (0 === a) a = 1 - u;
                else {
                    if (a === l) return s ? NaN : 1 / 0 * (f ? -1 : 1);
                    s += Math.pow(2, n), a -= u;
                }
                return (f ? -1 : 1) * s * Math.pow(2, a - n);
            }, uf.write = function(t1, e, r, n, i, a) {
                var s, o, l, u = 8 * a - i - 1, c = (1 << u) - 1, h = c >> 1, p = 23 === i ? Math.pow(2, -24) - Math.pow(2, -77) : 0, f = n ? 0 : a - 1, d = n ? 1 : -1, m = e < 0 || 0 === e && 1 / e < 0 ? 1 : 0;
                for(e = Math.abs(e), isNaN(e) || e === 1 / 0 ? (o = isNaN(e) ? 1 : 0, s = c) : (s = Math.floor(Math.log(e) / Math.LN2), e * (l = Math.pow(2, -s)) < 1 && (s--, l *= 2), (e += s + h >= 1 ? p / l : p * Math.pow(2, 1 - h)) * l >= 2 && (s++, l /= 2), s + h >= c ? (o = 0, s = c) : s + h >= 1 ? (o = (e * l - 1) * Math.pow(2, i), s += h) : (o = e * Math.pow(2, h - 1) * Math.pow(2, i), s = 0)); i >= 8; t1[r + f] = 255 & o, f += d, o /= 256, i -= 8);
                for(s = s << i | o, u += i; u > 0; t1[r + f] = 255 & s, f += d, s /= 256, u -= 8);
                t1[r + f - d] |= 128 * m;
            }), uf;
        }
        function hf() {
            if (lf) return of;
            lf = 1, of = e;
            var t1 = cf();
            function e(t1) {
                this.buf = ArrayBuffer.isView && ArrayBuffer.isView(t1) ? t1 : new Uint8Array(t1 || 0), this.pos = 0, this.type = 0, this.length = this.buf.length;
            }
            e.Varint = 0, e.Fixed64 = 1, e.Bytes = 2, e.Fixed32 = 5;
            var r = 4294967296, n = 1 / r, i = "undefined" == typeof TextDecoder ? null : new TextDecoder("utf8");
            function a(t1) {
                return t1.type === e.Bytes ? t1.readVarint() + t1.pos : t1.pos + 1;
            }
            function s(t1, e, r) {
                return r ? 4294967296 * e + (t1 >>> 0) : 4294967296 * (e >>> 0) + (t1 >>> 0);
            }
            function o(t1, e, r) {
                var n = e <= 16383 ? 1 : e <= 2097151 ? 2 : e <= 268435455 ? 3 : Math.floor(Math.log(e) / (7 * Math.LN2));
                r.realloc(n);
                for(var i = r.pos - 1; i >= t1; i--)r.buf[i + n] = r.buf[i];
            }
            function l(t1, e) {
                for(var r = 0; r < t1.length; r++)e.writeVarint(t1[r]);
            }
            function u(t1, e) {
                for(var r = 0; r < t1.length; r++)e.writeSVarint(t1[r]);
            }
            function c(t1, e) {
                for(var r = 0; r < t1.length; r++)e.writeFloat(t1[r]);
            }
            function h(t1, e) {
                for(var r = 0; r < t1.length; r++)e.writeDouble(t1[r]);
            }
            function p(t1, e) {
                for(var r = 0; r < t1.length; r++)e.writeBoolean(t1[r]);
            }
            function f(t1, e) {
                for(var r = 0; r < t1.length; r++)e.writeFixed32(t1[r]);
            }
            function d(t1, e) {
                for(var r = 0; r < t1.length; r++)e.writeSFixed32(t1[r]);
            }
            function m(t1, e) {
                for(var r = 0; r < t1.length; r++)e.writeFixed64(t1[r]);
            }
            function y(t1, e) {
                for(var r = 0; r < t1.length; r++)e.writeSFixed64(t1[r]);
            }
            function g(t1, e) {
                return (t1[e] | t1[e + 1] << 8 | t1[e + 2] << 16) + 16777216 * t1[e + 3];
            }
            function x(t1, e, r) {
                t1[r] = e, t1[r + 1] = e >>> 8, t1[r + 2] = e >>> 16, t1[r + 3] = e >>> 24;
            }
            function v(t1, e) {
                return (t1[e] | t1[e + 1] << 8 | t1[e + 2] << 16) + (t1[e + 3] << 24);
            }
            return e.prototype = {
                destroy: function() {
                    this.buf = null;
                },
                readFields: function(t1, e, r) {
                    for(r = r || this.length; this.pos < r;){
                        var n = this.readVarint(), i = n >> 3, a = this.pos;
                        this.type = 7 & n, t1(i, e, this), this.pos === a && this.skip(n);
                    }
                    return e;
                },
                readMessage: function(t1, e) {
                    return this.readFields(t1, e, this.readVarint() + this.pos);
                },
                readFixed32: function() {
                    var t1 = g(this.buf, this.pos);
                    return this.pos += 4, t1;
                },
                readSFixed32: function() {
                    var t1 = v(this.buf, this.pos);
                    return this.pos += 4, t1;
                },
                readFixed64: function() {
                    var t1 = g(this.buf, this.pos) + g(this.buf, this.pos + 4) * r;
                    return this.pos += 8, t1;
                },
                readSFixed64: function() {
                    var t1 = g(this.buf, this.pos) + v(this.buf, this.pos + 4) * r;
                    return this.pos += 8, t1;
                },
                readFloat: function() {
                    var e = t1.read(this.buf, this.pos, !0, 23, 4);
                    return this.pos += 4, e;
                },
                readDouble: function() {
                    var e = t1.read(this.buf, this.pos, !0, 52, 8);
                    return this.pos += 8, e;
                },
                readVarint: function(t1) {
                    var e, r, n = this.buf;
                    return e = 127 & (r = n[this.pos++]), r < 128 ? e : (e |= (127 & (r = n[this.pos++])) << 7, r < 128 ? e : (e |= (127 & (r = n[this.pos++])) << 14, r < 128 ? e : (e |= (127 & (r = n[this.pos++])) << 21, r < 128 ? e : function(t1, e, r) {
                        var n, i, a = r.buf;
                        if (n = (112 & (i = a[r.pos++])) >> 4, i < 128) return s(t1, n, e);
                        if (n |= (127 & (i = a[r.pos++])) << 3, i < 128) return s(t1, n, e);
                        if (n |= (127 & (i = a[r.pos++])) << 10, i < 128) return s(t1, n, e);
                        if (n |= (127 & (i = a[r.pos++])) << 17, i < 128) return s(t1, n, e);
                        if (n |= (127 & (i = a[r.pos++])) << 24, i < 128) return s(t1, n, e);
                        if (n |= (1 & (i = a[r.pos++])) << 31, i < 128) return s(t1, n, e);
                        throw new Error("Expected varint not more than 10 bytes");
                    }(e |= (15 & (r = n[this.pos])) << 28, t1, this))));
                },
                readVarint64: function() {
                    return this.readVarint(!0);
                },
                readSVarint: function() {
                    var t1 = this.readVarint();
                    return t1 % 2 == 1 ? (t1 + 1) / -2 : t1 / 2;
                },
                readBoolean: function() {
                    return Boolean(this.readVarint());
                },
                readString: function() {
                    var t1 = this.readVarint() + this.pos, e = this.pos;
                    return this.pos = t1, t1 - e >= 12 && i ? function(t1, e, r) {
                        return i.decode(t1.subarray(e, r));
                    }(this.buf, e, t1) : function(t1, e, r) {
                        for(var n = "", i = e; i < r;){
                            var a, s, o, l = t1[i], u = null, c = l > 239 ? 4 : l > 223 ? 3 : l > 191 ? 2 : 1;
                            if (i + c > r) break;
                            1 === c ? l < 128 && (u = l) : 2 === c ? 128 == (192 & (a = t1[i + 1])) && (u = (31 & l) << 6 | 63 & a) <= 127 && (u = null) : 3 === c ? (s = t1[i + 2], 128 == (192 & (a = t1[i + 1])) && 128 == (192 & s) && ((u = (15 & l) << 12 | (63 & a) << 6 | 63 & s) <= 2047 || u >= 55296 && u <= 57343) && (u = null)) : 4 === c && (s = t1[i + 2], o = t1[i + 3], 128 == (192 & (a = t1[i + 1])) && 128 == (192 & s) && 128 == (192 & o) && ((u = (15 & l) << 18 | (63 & a) << 12 | (63 & s) << 6 | 63 & o) <= 65535 || u >= 1114112) && (u = null)), null === u ? (u = 65533, c = 1) : u > 65535 && (u -= 65536, n += String.fromCharCode(u >>> 10 & 1023 | 55296), u = 56320 | 1023 & u), n += String.fromCharCode(u), i += c;
                        }
                        return n;
                    }(this.buf, e, t1);
                },
                readBytes: function() {
                    var t1 = this.readVarint() + this.pos, e = this.buf.subarray(this.pos, t1);
                    return this.pos = t1, e;
                },
                readPackedVarint: function(t1, r) {
                    if (this.type !== e.Bytes) return t1.push(this.readVarint(r));
                    var n = a(this);
                    for(t1 = t1 || []; this.pos < n;)t1.push(this.readVarint(r));
                    return t1;
                },
                readPackedSVarint: function(t1) {
                    if (this.type !== e.Bytes) return t1.push(this.readSVarint());
                    var r = a(this);
                    for(t1 = t1 || []; this.pos < r;)t1.push(this.readSVarint());
                    return t1;
                },
                readPackedBoolean: function(t1) {
                    if (this.type !== e.Bytes) return t1.push(this.readBoolean());
                    var r = a(this);
                    for(t1 = t1 || []; this.pos < r;)t1.push(this.readBoolean());
                    return t1;
                },
                readPackedFloat: function(t1) {
                    if (this.type !== e.Bytes) return t1.push(this.readFloat());
                    var r = a(this);
                    for(t1 = t1 || []; this.pos < r;)t1.push(this.readFloat());
                    return t1;
                },
                readPackedDouble: function(t1) {
                    if (this.type !== e.Bytes) return t1.push(this.readDouble());
                    var r = a(this);
                    for(t1 = t1 || []; this.pos < r;)t1.push(this.readDouble());
                    return t1;
                },
                readPackedFixed32: function(t1) {
                    if (this.type !== e.Bytes) return t1.push(this.readFixed32());
                    var r = a(this);
                    for(t1 = t1 || []; this.pos < r;)t1.push(this.readFixed32());
                    return t1;
                },
                readPackedSFixed32: function(t1) {
                    if (this.type !== e.Bytes) return t1.push(this.readSFixed32());
                    var r = a(this);
                    for(t1 = t1 || []; this.pos < r;)t1.push(this.readSFixed32());
                    return t1;
                },
                readPackedFixed64: function(t1) {
                    if (this.type !== e.Bytes) return t1.push(this.readFixed64());
                    var r = a(this);
                    for(t1 = t1 || []; this.pos < r;)t1.push(this.readFixed64());
                    return t1;
                },
                readPackedSFixed64: function(t1) {
                    if (this.type !== e.Bytes) return t1.push(this.readSFixed64());
                    var r = a(this);
                    for(t1 = t1 || []; this.pos < r;)t1.push(this.readSFixed64());
                    return t1;
                },
                skip: function(t1) {
                    var r = 7 & t1;
                    if (r === e.Varint) for(; this.buf[this.pos++] > 127;);
                    else if (r === e.Bytes) this.pos = this.readVarint() + this.pos;
                    else if (r === e.Fixed32) this.pos += 4;
                    else {
                        if (r !== e.Fixed64) throw new Error("Unimplemented type: " + r);
                        this.pos += 8;
                    }
                },
                writeTag: function(t1, e) {
                    this.writeVarint(t1 << 3 | e);
                },
                realloc: function(t1) {
                    for(var e = this.length || 16; e < this.pos + t1;)e *= 2;
                    if (e !== this.length) {
                        var r = new Uint8Array(e);
                        r.set(this.buf), this.buf = r, this.length = e;
                    }
                },
                finish: function() {
                    return this.length = this.pos, this.pos = 0, this.buf.subarray(0, this.length);
                },
                writeFixed32: function(t1) {
                    this.realloc(4), x(this.buf, t1, this.pos), this.pos += 4;
                },
                writeSFixed32: function(t1) {
                    this.realloc(4), x(this.buf, t1, this.pos), this.pos += 4;
                },
                writeFixed64: function(t1) {
                    this.realloc(8), x(this.buf, -1 & t1, this.pos), x(this.buf, Math.floor(t1 * n), this.pos + 4), this.pos += 8;
                },
                writeSFixed64: function(t1) {
                    this.realloc(8), x(this.buf, -1 & t1, this.pos), x(this.buf, Math.floor(t1 * n), this.pos + 4), this.pos += 8;
                },
                writeVarint: function(t1) {
                    (t1 = +t1 || 0) > 268435455 || t1 < 0 ? function(t1, e) {
                        var r, n;
                        if (t1 >= 0 ? (r = t1 % 4294967296 | 0, n = t1 / 4294967296 | 0) : (n = ~(-t1 / 4294967296), 4294967295 ^ (r = ~(-t1 % 4294967296)) ? r = r + 1 | 0 : (r = 0, n = n + 1 | 0)), t1 >= 0x10000000000000000 || t1 < -18446744073709552000) throw new Error("Given varint doesn't fit into 10 bytes");
                        e.realloc(10), function(t1, e, r) {
                            r.buf[r.pos++] = 127 & t1 | 128, t1 >>>= 7, r.buf[r.pos++] = 127 & t1 | 128, t1 >>>= 7, r.buf[r.pos++] = 127 & t1 | 128, t1 >>>= 7, r.buf[r.pos++] = 127 & t1 | 128, r.buf[r.pos] = 127 & (t1 >>>= 7);
                        }(r, 0, e), function(t1, e) {
                            var r = (7 & t1) << 4;
                            e.buf[e.pos++] |= r | ((t1 >>>= 3) ? 128 : 0), t1 && (e.buf[e.pos++] = 127 & t1 | ((t1 >>>= 7) ? 128 : 0), t1 && (e.buf[e.pos++] = 127 & t1 | ((t1 >>>= 7) ? 128 : 0), t1 && (e.buf[e.pos++] = 127 & t1 | ((t1 >>>= 7) ? 128 : 0), t1 && (e.buf[e.pos++] = 127 & t1 | ((t1 >>>= 7) ? 128 : 0), t1 && (e.buf[e.pos++] = 127 & t1)))));
                        }(n, e);
                    }(t1, this) : (this.realloc(4), this.buf[this.pos++] = 127 & t1 | (t1 > 127 ? 128 : 0), t1 <= 127 || (this.buf[this.pos++] = 127 & (t1 >>>= 7) | (t1 > 127 ? 128 : 0), t1 <= 127 || (this.buf[this.pos++] = 127 & (t1 >>>= 7) | (t1 > 127 ? 128 : 0), t1 <= 127 || (this.buf[this.pos++] = t1 >>> 7 & 127))));
                },
                writeSVarint: function(t1) {
                    this.writeVarint(t1 < 0 ? 2 * -t1 - 1 : 2 * t1);
                },
                writeBoolean: function(t1) {
                    this.writeVarint(Boolean(t1));
                },
                writeString: function(t1) {
                    t1 = String(t1), this.realloc(4 * t1.length), this.pos++;
                    var e = this.pos;
                    this.pos = function(t1, e, r) {
                        for(var n, i, a = 0; a < e.length; a++){
                            if ((n = e.charCodeAt(a)) > 55295 && n < 57344) {
                                if (!i) {
                                    n > 56319 || a + 1 === e.length ? (t1[r++] = 239, t1[r++] = 191, t1[r++] = 189) : i = n;
                                    continue;
                                }
                                if (n < 56320) {
                                    t1[r++] = 239, t1[r++] = 191, t1[r++] = 189, i = n;
                                    continue;
                                }
                                n = i - 55296 << 10 | n - 56320 | 65536, i = null;
                            } else i && (t1[r++] = 239, t1[r++] = 191, t1[r++] = 189, i = null);
                            n < 128 ? t1[r++] = n : (n < 2048 ? t1[r++] = n >> 6 | 192 : (n < 65536 ? t1[r++] = n >> 12 | 224 : (t1[r++] = n >> 18 | 240, t1[r++] = n >> 12 & 63 | 128), t1[r++] = n >> 6 & 63 | 128), t1[r++] = 63 & n | 128);
                        }
                        return r;
                    }(this.buf, t1, this.pos);
                    var r = this.pos - e;
                    r >= 128 && o(e, r, this), this.pos = e - 1, this.writeVarint(r), this.pos += r;
                },
                writeFloat: function(e) {
                    this.realloc(4), t1.write(this.buf, e, this.pos, !0, 23, 4), this.pos += 4;
                },
                writeDouble: function(e) {
                    this.realloc(8), t1.write(this.buf, e, this.pos, !0, 52, 8), this.pos += 8;
                },
                writeBytes: function(t1) {
                    var e = t1.length;
                    this.writeVarint(e), this.realloc(e);
                    for(var r = 0; r < e; r++)this.buf[this.pos++] = t1[r];
                },
                writeRawMessage: function(t1, e) {
                    this.pos++;
                    var r = this.pos;
                    t1(e, this);
                    var n = this.pos - r;
                    n >= 128 && o(r, n, this), this.pos = r - 1, this.writeVarint(n), this.pos += n;
                },
                writeMessage: function(t1, r, n) {
                    this.writeTag(t1, e.Bytes), this.writeRawMessage(r, n);
                },
                writePackedVarint: function(t1, e) {
                    e.length && this.writeMessage(t1, l, e);
                },
                writePackedSVarint: function(t1, e) {
                    e.length && this.writeMessage(t1, u, e);
                },
                writePackedBoolean: function(t1, e) {
                    e.length && this.writeMessage(t1, p, e);
                },
                writePackedFloat: function(t1, e) {
                    e.length && this.writeMessage(t1, c, e);
                },
                writePackedDouble: function(t1, e) {
                    e.length && this.writeMessage(t1, h, e);
                },
                writePackedFixed32: function(t1, e) {
                    e.length && this.writeMessage(t1, f, e);
                },
                writePackedSFixed32: function(t1, e) {
                    e.length && this.writeMessage(t1, d, e);
                },
                writePackedFixed64: function(t1, e) {
                    e.length && this.writeMessage(t1, m, e);
                },
                writePackedSFixed64: function(t1, e) {
                    e.length && this.writeMessage(t1, y, e);
                },
                writeBytesField: function(t1, r) {
                    this.writeTag(t1, e.Bytes), this.writeBytes(r);
                },
                writeFixed32Field: function(t1, r) {
                    this.writeTag(t1, e.Fixed32), this.writeFixed32(r);
                },
                writeSFixed32Field: function(t1, r) {
                    this.writeTag(t1, e.Fixed32), this.writeSFixed32(r);
                },
                writeFixed64Field: function(t1, r) {
                    this.writeTag(t1, e.Fixed64), this.writeFixed64(r);
                },
                writeSFixed64Field: function(t1, r) {
                    this.writeTag(t1, e.Fixed64), this.writeSFixed64(r);
                },
                writeVarintField: function(t1, r) {
                    this.writeTag(t1, e.Varint), this.writeVarint(r);
                },
                writeSVarintField: function(t1, r) {
                    this.writeTag(t1, e.Varint), this.writeSVarint(r);
                },
                writeStringField: function(t1, r) {
                    this.writeTag(t1, e.Bytes), this.writeString(r);
                },
                writeFloatField: function(t1, r) {
                    this.writeTag(t1, e.Fixed32), this.writeFloat(r);
                },
                writeDoubleField: function(t1, r) {
                    this.writeTag(t1, e.Fixed64), this.writeDouble(r);
                },
                writeBooleanField: function(t1, e) {
                    this.writeVarintField(t1, Boolean(e));
                }
            }, of;
        }
        var pf = e(hf());
        const ff = 3;
        function df(t1, e, r) {
            e.glyphs = [], 1 === t1 && r.readMessage(mf, e);
        }
        function mf(t1, e, r) {
            if (3 === t1) {
                const { id: t1, bitmap: n, width: i, height: a, left: s, top: o, advance: l } = r.readMessage(yf, {});
                e.glyphs.push({
                    id: t1,
                    bitmap: new ac({
                        width: i + 2 * ff,
                        height: a + 2 * ff
                    }, n),
                    metrics: {
                        width: i,
                        height: a,
                        left: s,
                        top: o,
                        advance: l
                    }
                });
            } else 4 === t1 ? e.ascender = r.readSVarint() : 5 === t1 && (e.descender = r.readSVarint());
        }
        function yf(t1, e, r) {
            1 === t1 ? e.id = r.readVarint() : 2 === t1 ? e.bitmap = r.readBytes() : 3 === t1 ? e.width = r.readVarint() : 4 === t1 ? e.height = r.readVarint() : 5 === t1 ? e.left = r.readSVarint() : 6 === t1 ? e.top = r.readSVarint() : 7 === t1 && (e.advance = r.readVarint());
        }
        const gf = ff, xf = {
            horizontal: 1,
            vertical: 2,
            horizontalOnly: 3
        };
        class vf {
            static forText(t1, e) {
                const r = new vf;
                return r.scale = t1 || 1, r.fontStack = e, r;
            }
            static forImage(t1) {
                const e = new vf;
                return e.image = t1, e;
            }
            constructor(){
                this.scale = 1, this.fontStack = "", this.image = null;
            }
        }
        class bf {
            static fromFeature(t1, e) {
                const r = new bf;
                for(let n = 0; n < t1.sections.length; n++){
                    const i = t1.sections[n];
                    i.image ? r.addImageSection(i) : r.addTextSection(i, e);
                }
                return r;
            }
            length() {
                return this.text.length;
            }
            getSection(t1) {
                return this.sections[this.sectionIndex[t1]];
            }
            getSections() {
                return this.sections;
            }
            getSectionIndex(t1) {
                return this.sectionIndex[t1];
            }
            getCodePoint(t1) {
                return this.text.codePointAt(t1);
            }
            verticalizePunctuation(t1) {
                this.text = function(t1, e) {
                    let r = "";
                    for(let n = 0; n < t1.length; n++){
                        const i = t1.charCodeAt(n + 1) || null, a = t1.charCodeAt(n - 1) || null;
                        r += !e && (i && ga(i) && !rf[t1[n + 1]] || a && ga(a) && !rf[t1[n - 1]]) || !rf[t1[n]] ? t1[n] : rf[t1[n]];
                    }
                    return r;
                }(this.text, t1);
            }
            trim() {
                let t1 = 0;
                for(let e = 0; e < this.text.length && wf[this.text.charCodeAt(e)]; e++)t1++;
                let e = this.text.length;
                for(let r = this.text.length - 1; r >= 0 && r >= t1 && wf[this.text.charCodeAt(r)]; r--)e--;
                this.text = this.text.substring(t1, e), this.sectionIndex = this.sectionIndex.slice(t1, e);
            }
            substring(t1, e) {
                const r = new bf;
                return r.text = this.text.substring(t1, e), r.sectionIndex = this.sectionIndex.slice(t1, e), r.sections = this.sections, r;
            }
            toString() {
                return this.text;
            }
            getMaxScale() {
                return this.sectionIndex.reduce((t1, e)=>Math.max(t1, this.sections[e].scale), 0);
            }
            addTextSection(t1, e) {
                this.text += t1.text, this.sections.push(vf.forText(t1.scale, t1.fontStack || e));
                const r = this.sections.length - 1;
                for(let e = 0; e < t1.text.length; ++e)this.sectionIndex.push(r);
            }
            addImageSection(t1) {
                const e = t1.image && t1.image.namePrimary ? t1.image.getPrimary() : null;
                if (!e) return void ft("Can't add FormattedSection with an empty image.");
                const r = this.getNextImageSectionCharCode();
                r ? (this.text += String.fromCodePoint(r), this.sections.push(vf.forImage(e)), this.sectionIndex.push(this.sections.length - 1)) : ft("Reached maximum number of images 6401");
            }
            getNextImageSectionCharCode() {
                return this.imageSectionID ? this.imageSectionID >= 63743 ? null : ++this.imageSectionID : (this.imageSectionID = 57344, this.imageSectionID);
            }
            constructor(){
                this.text = "", this.sectionIndex = [], this.sections = [], this.imageSectionID = null;
            }
        }
        function _f(t1, e, r, n, i, a, s, o, l, u, c, h, p, f, d) {
            const m = bf.fromFeature(t1, i);
            h === xf.vertical && m.verticalizePunctuation(p);
            let y = [];
            const g = function(t1, e, r, n, i, a) {
                if (!t1) return [];
                const s = [], o = function(t1, e, r, n, i, a) {
                    let s = 0;
                    for(let r = 0; r < t1.length(); r++){
                        const o = t1.getSection(r);
                        s += Af(t1.getCodePoint(r), o, n, i, e, a);
                    }
                    return s / Math.max(1, Math.ceil(s / r));
                }(t1, e, r, n, i, a), l = t1.text.indexOf("\u200B") >= 0;
                let u = 0;
                for(let r = 0; r < t1.length(); r++){
                    const h = t1.getSection(r), p = t1.getCodePoint(r);
                    if (wf[p] || (u += Af(p, h, n, i, e, a)), r < t1.length() - 1) {
                        const e = !((c = p) < 11904 || !(pa["Bopomofo Extended"](c) || pa.Bopomofo(c) || pa["CJK Compatibility Forms"](c) || pa["CJK Compatibility Ideographs"](c) || pa["CJK Compatibility"](c) || pa["CJK Radicals Supplement"](c) || pa["CJK Strokes"](c) || pa["CJK Symbols and Punctuation"](c) || pa["CJK Unified Ideographs Extension A"](c) || pa["CJK Unified Ideographs"](c) || pa["Enclosed CJK Letters and Months"](c) || pa["Halfwidth and Fullwidth Forms"](c) || pa.Hiragana(c) || pa["Ideographic Description Characters"](c) || pa["Kangxi Radicals"](c) || pa["Katakana Phonetic Extensions"](c) || pa.Katakana(c) || pa["Vertical Forms"](c) || pa["Yi Radicals"](c) || pa["Yi Syllables"](c)));
                        (Mf[p] || e || h.image) && s.push(Pf(r + 1, u, o, s, If(p, t1.getCodePoint(r + 1), e && l), !1));
                    }
                }
                var c;
                return zf(Pf(t1.length(), u, o, s, 0, !0));
            }(m, u, a, e, n, f), { processBidirectionalText: x, processStyledBidirectionalText: v } = Ba;
            if (x && 1 === m.sections.length) {
                const t1 = x(m.toString(), g);
                for (const e of t1){
                    const t1 = new bf;
                    t1.text = e, t1.sections = m.sections;
                    for(let r = 0; r < e.length; r++)t1.sectionIndex.push(0);
                    y.push(t1);
                }
            } else if (v) {
                const t1 = v(m.text, m.sectionIndex, g);
                for (const e of t1){
                    const t1 = new bf;
                    t1.text = e[0], t1.sectionIndex = e[1], t1.sections = m.sections, y.push(t1);
                }
            } else y = function(t1, e) {
                const r = [], n = t1.text;
                let i = 0;
                for (const n of e)r.push(t1.substring(i, n)), i = n;
                return i < n.length && r.push(t1.substring(i, n.length)), r;
            }(m, g);
            const b = [], _ = {
                positionedLines: b,
                text: m.toString(),
                top: c[1],
                bottom: c[1],
                left: c[0],
                right: c[0],
                writingMode: h,
                iconsInText: !1,
                verticalizable: !1,
                hasBaseline: !1
            };
            return function(t1, e, r, n, i, a, s, o, l, u, c, h) {
                let p = 0, f = 0, d = 0;
                const m = "right" === o ? 1 : "left" === o ? 0 : .5;
                let y = !1;
                for (const t1 of i){
                    const r = t1.getSections();
                    for (const t1 of r){
                        if (t1.image) continue;
                        const r = e[t1.fontStack];
                        if (r && (y = void 0 !== r.ascender && void 0 !== r.descender, !y)) break;
                    }
                    if (!y) break;
                }
                let g = 0;
                for (const s of i){
                    s.trim();
                    const i = s.getMaxScale(), o = (i - 1) * Zp, v = {
                        positionedGlyphs: [],
                        lineOffset: 0
                    };
                    t1.positionedLines[g] = v;
                    const b = v.positionedGlyphs;
                    let _ = 0;
                    if (!s.length()) {
                        f += a, ++g;
                        continue;
                    }
                    let w = 0, M = 0;
                    for(let a = 0; a < s.length(); a++){
                        const o = s.getSection(a), d = s.getSectionIndex(a), m = s.getCodePoint(a);
                        let g = o.scale, v = null, A = null, S = null, I = Zp, P = 0;
                        const z = !(l === xf.horizontal || !c && !ya(m) || c && (wf[m] || (x = m, pa.Arabic(x) || pa["Arabic Supplement"](x) || pa["Arabic Extended-A"](x) || pa["Arabic Presentation Forms-A"](x) || pa["Arabic Presentation Forms-B"](x))));
                        if (o.image) {
                            const e = n[o.image.serialize()];
                            if (!e) continue;
                            S = o.image.id, t1.iconsInText = t1.iconsInText || !0, A = e.paddedRect;
                            const r = e.displaySize;
                            g = g * Zp / h, v = {
                                width: r[0],
                                height: r[1],
                                left: 0,
                                top: -gf,
                                advance: z ? r[1] : r[0],
                                localGlyph: !1
                            }, P = y ? -v.height * g : i * Zp - 17 - r[1] * g, I = v.advance;
                            const a = (z ? r[0] : r[1]) * g - Zp * i;
                            a > 0 && a > _ && (_ = a);
                        } else {
                            const t1 = r[o.fontStack];
                            if (!t1) continue;
                            t1[m] && (A = t1[m]);
                            const n = e[o.fontStack];
                            if (!n) continue;
                            const a = n.glyphs[m];
                            if (!a) continue;
                            if (v = a.metrics, I = 8203 !== m ? Zp : 0, y) {
                                const t1 = void 0 !== n.ascender ? Math.abs(n.ascender) : 0, e = void 0 !== n.descender ? Math.abs(n.descender) : 0, r = (t1 + e) * g;
                                w < r && (w = r, M = (t1 - e) / 2 * g), P = -t1 * g;
                            } else P = (i - g) * Zp - 17;
                        }
                        z ? (t1.verticalizable = !0, b.push({
                            glyph: m,
                            imageName: S,
                            x: p,
                            y: f + P,
                            vertical: z,
                            scale: g,
                            localGlyph: v.localGlyph,
                            fontStack: o.fontStack,
                            sectionIndex: d,
                            metrics: v,
                            rect: A
                        }), p += I * g + u) : (b.push({
                            glyph: m,
                            imageName: S,
                            x: p,
                            y: f + P,
                            vertical: z,
                            scale: g,
                            localGlyph: v.localGlyph,
                            fontStack: o.fontStack,
                            sectionIndex: d,
                            metrics: v,
                            rect: A
                        }), p += v.advance * g + u);
                    }
                    0 !== b.length && (d = Math.max(p - u, d), y ? kf(b, m, _, M, a * i / 2) : kf(b, m, _, 0, a / 2)), p = 0;
                    const A = a * i + _;
                    v.lineOffset = Math.max(_, o), f += A, ++g;
                }
                var x;
                const v = f, { horizontalAlign: b, verticalAlign: _ } = Ef(s);
                (function(t1, e, r, n, i, a) {
                    const s = (e - r) * i, o = -a * n;
                    for (const e of t1)for (const t1 of e.positionedGlyphs)t1.x += s, t1.y += o;
                })(t1.positionedLines, m, b, _, d, v), t1.top += -_ * v, t1.bottom = t1.top + v, t1.left += -b * d, t1.right = t1.left + d, t1.hasBaseline = y;
            }(_, e, r, n, y, s, o, l, h, u, p, d), !function(t1) {
                for (const e of t1)if (0 !== e.positionedGlyphs.length) return !1;
                return !0;
            }(b) && _;
        }
        const wf = {
            9: !0,
            10: !0,
            11: !0,
            12: !0,
            13: !0,
            32: !0
        }, Mf = {
            10: !0,
            32: !0,
            38: !0,
            40: !0,
            41: !0,
            43: !0,
            45: !0,
            47: !0,
            173: !0,
            183: !0,
            8203: !0,
            8208: !0,
            8211: !0,
            8231: !0
        };
        function Af(t1, e, r, n, i, a) {
            if (e.image) {
                const t1 = n[e.image.serialize()];
                return t1 ? t1.displaySize[0] * e.scale * Zp / a + i : 0;
            }
            {
                const n = r[e.fontStack], a = n && n.glyphs[t1];
                return a ? a.metrics.advance * e.scale + i : 0;
            }
        }
        function Sf(t1, e, r, n) {
            const i = Math.pow(t1 - e, 2);
            return n ? t1 < e ? i / 2 : 2 * i : i + Math.abs(r) * r;
        }
        function If(t1, e, r) {
            let n = 0;
            return 10 === t1 && (n -= 1e4), r && (n += 150), 40 !== t1 && 65288 !== t1 || (n += 50), 41 !== e && 65289 !== e || (n += 50), n;
        }
        function Pf(t1, e, r, n, i, a) {
            let s = null, o = Sf(e, r, i, a);
            for (const t1 of n){
                const n = Sf(e - t1.x, r, i, a) + t1.badness;
                n <= o && (s = t1, o = n);
            }
            return {
                index: t1,
                x: e,
                priorBreak: s,
                badness: o
            };
        }
        function zf(t1) {
            return t1 ? zf(t1.priorBreak).concat(t1.index) : [];
        }
        function Ef(t1) {
            let e = .5, r = .5;
            switch(t1){
                case "right":
                case "top-right":
                case "bottom-right":
                    e = 1;
                    break;
                case "left":
                case "top-left":
                case "bottom-left":
                    e = 0;
            }
            switch(t1){
                case "bottom":
                case "bottom-right":
                case "bottom-left":
                    r = 1;
                    break;
                case "top":
                case "top-right":
                case "top-left":
                    r = 0;
            }
            return {
                horizontalAlign: e,
                verticalAlign: r
            };
        }
        function kf(t1, e, r, n, i) {
            if (!(e || r || n || i)) return;
            const a = t1.length - 1, s = t1[a], o = (s.x + s.metrics.advance * s.scale) * e;
            for(let e = 0; e <= a; e++)t1[e].x -= o, t1[e].y += r + n + i;
        }
        function Tf(t1, e, r, n) {
            const { horizontalAlign: i, verticalAlign: a } = Ef(n), s = r[0] - t1.displaySize[0] * i, o = r[1] - t1.displaySize[1] * a;
            return {
                imagePrimary: t1,
                imageSecondary: e,
                top: o,
                bottom: o + t1.displaySize[1],
                left: s,
                right: s + t1.displaySize[0]
            };
        }
        function Bf(t1, e, r, n, i, a) {
            const s = t1.imagePrimary;
            let o;
            if (s.content) {
                const t1 = s.content, e = s.pixelRatio || 1;
                o = [
                    t1[0] / e,
                    t1[1] / e,
                    s.displaySize[0] - t1[2] / e,
                    s.displaySize[1] - t1[3] / e
                ];
            }
            const l = e.left * a, u = e.right * a;
            let c, h, p, f;
            "width" === r || "both" === r ? (f = i[0] + l - n[3], h = i[0] + u + n[1]) : (f = i[0] + (l + u - s.displaySize[0]) / 2, h = f + s.displaySize[0]);
            const d = e.top * a, m = e.bottom * a;
            return "height" === r || "both" === r ? (c = i[1] + d - n[0], p = i[1] + m + n[2]) : (c = i[1] + (d + m - s.displaySize[1]) / 2, p = c + s.displaySize[1]), {
                imagePrimary: s,
                imageSecondary: void 0,
                top: c,
                right: h,
                bottom: p,
                left: f,
                collisionPadding: o
            };
        }
        class Cf extends q {
            clone() {
                return new Cf(this.x, this.y, this.z, this.angle, this.segment);
            }
            constructor(t1, e, r, n, i){
                super(t1, e), this.angle = n, this.z = r, void 0 !== i && (this.segment = i);
            }
        }
        function Vf(t1, e, r, n, i) {
            if (void 0 === e.segment) return !0;
            let a = e, s = e.segment + 1, o = 0;
            for(; o > -r / 2;){
                if (s--, s < 0) return !1;
                o -= t1[s].dist(a), a = t1[s];
            }
            o += t1[s].dist(t1[s + 1]), s++;
            const l = [];
            let u = 0;
            for(; o < r / 2;){
                const e = t1[s], r = t1[s + 1];
                if (!r) return !1;
                let a = t1[s - 1].angleTo(e) - e.angleTo(r);
                for(a = Math.abs((a + 3 * Math.PI) % (2 * Math.PI) - Math.PI), l.push({
                    distance: o,
                    angleDelta: a
                }), u += a; o - l[0].distance > n;)u -= l.shift().angleDelta;
                if (u > i) return !1;
                s++, o += e.dist(r);
            }
            return !0;
        }
        function Df(t1) {
            let e = 0;
            for(let r = 0; r < t1.length - 1; r++)e += t1[r].dist(t1[r + 1]);
            return e;
        }
        function Lf(t1, e, r) {
            return t1 ? .6 * e * r : 0;
        }
        function Rf(t1, e) {
            return Math.max(t1 ? t1.right - t1.left : 0, e ? e.right - e.left : 0);
        }
        function Ff(t1, e, r, n, i, a) {
            const s = Lf(r, i, a), o = Rf(r, n) * a;
            let l = 0;
            const u = Df(t1) / 2;
            for(let r = 0; r < t1.length - 1; r++){
                const n = t1[r], i = t1[r + 1], a = n.dist(i);
                if (l + a > u) {
                    const c = (u - l) / a, h = ze(n.x, i.x, c), p = ze(n.y, i.y, c), f = new Cf(h, p, 0, i.angleTo(n), r);
                    return !s || Vf(t1, f, o, s, e) ? f : void 0;
                }
                l += a;
            }
        }
        function Of(t1, e, r, n, i, a, s, o, l) {
            const u = Lf(n, a, s), c = Rf(n, i), h = c * s, p = 0 === t1[0].x || t1[0].x === l || 0 === t1[0].y || t1[0].y === l;
            return e - h < e / 4 && (e = h + e / 4), Nf(t1, p ? e / 2 * o % e : (c / 2 + 2 * a) * s * o % e, e, u, r, h, p, !1, l);
        }
        function Nf(t1, e, r, n, i, a, s, o, l) {
            const u = a / 2, c = Df(t1);
            let h = 0, p = e - r, f = [];
            for(let e = 0; e < t1.length - 1; e++){
                const s = t1[e], o = t1[e + 1], d = s.dist(o), m = o.angleTo(s);
                for(; p + r < h + d;){
                    p += r;
                    const y = (p - h) / d, g = ze(s.x, o.x, y), x = ze(s.y, o.y, y);
                    if (g >= 0 && g < l && x >= 0 && x < l && p - u >= 0 && p + u <= c) {
                        const r = new Cf(g, x, 0, m, e);
                        n && !Vf(t1, r, a, n, i) || f.push(r);
                    }
                }
                h += d;
            }
            return o || f.length || s || (f = Nf(t1, h / 2, r, n, i, a, s, !0, l)), f;
        }
        function Uf(t1, e, r, n, i) {
            const a = [];
            for(let s = 0; s < t1.length; s++){
                const o = t1[s];
                let l;
                for(let t1 = 0; t1 < o.length - 1; t1++){
                    let s = o[t1], u = o[t1 + 1];
                    s.x < e && u.x < e || (s.x < e ? s = new q(e, s.y + (e - s.x) / (u.x - s.x) * (u.y - s.y))._round() : u.x < e && (u = new q(e, s.y + (e - s.x) / (u.x - s.x) * (u.y - s.y))._round()), s.y < r && u.y < r || (s.y < r ? s = new q(s.x + (r - s.y) / (u.y - s.y) * (u.x - s.x), r)._round() : u.y < r && (u = new q(s.x + (r - s.y) / (u.y - s.y) * (u.x - s.x), r)._round()), s.x >= n && u.x >= n || (s.x >= n ? s = new q(n, s.y + (n - s.x) / (u.x - s.x) * (u.y - s.y))._round() : u.x >= n && (u = new q(n, s.y + (n - s.x) / (u.x - s.x) * (u.y - s.y))._round()), s.y >= i && u.y >= i || (s.y >= i ? s = new q(s.x + (i - s.y) / (u.y - s.y) * (u.x - s.x), i)._round() : u.y >= i && (u = new q(s.x + (i - s.y) / (u.y - s.y) * (u.x - s.x), i)._round()), l && s.equals(l[l.length - 1]) || (l = [
                        s
                    ], a.push(l)), l.push(u)))));
                }
            }
            return a;
        }
        function jf(t1) {
            let e = 0, r = 0;
            for (const n of t1)e += n.w * n.h, r = Math.max(r, n.w);
            t1.sort((t1, e)=>e.h - t1.h);
            const n = [
                {
                    x: 0,
                    y: 0,
                    w: Math.max(Math.ceil(Math.sqrt(e / .95)), r),
                    h: 1 / 0
                }
            ];
            let i = 0, a = 0;
            for (const e of t1)for(let t1 = n.length - 1; t1 >= 0; t1--){
                const r = n[t1];
                if (!(e.w > r.w || e.h > r.h)) {
                    if (e.x = r.x, e.y = r.y, a = Math.max(a, e.y + e.h), i = Math.max(i, e.x + e.w), e.w === r.w && e.h === r.h) {
                        const e = n.pop();
                        t1 < n.length && (n[t1] = e);
                    } else e.h === r.h ? (r.x += e.w, r.w -= e.w) : e.w === r.w ? (r.y += e.h, r.h -= e.h) : (n.push({
                        x: r.x + e.w,
                        y: r.y,
                        w: r.w - e.w,
                        h: e.h
                    }), r.y += e.h, r.h -= e.h);
                    break;
                }
            }
            return {
                w: i,
                h: a,
                fill: e / (i * a) || 0
            };
        }
        oa(Cf, "Anchor");
        const qf = 1;
        class $f {
            static getImagePositionScale(t1, e, r) {
                return e && t1 && t1.options && t1.options.transform ? {
                    x: t1.options.transform.a,
                    y: t1.options.transform.d
                } : {
                    x: r,
                    y: r
                };
            }
            get tl() {
                return [
                    this.paddedRect.x + this.padding,
                    this.paddedRect.y + this.padding
                ];
            }
            get br() {
                return [
                    this.paddedRect.x + this.paddedRect.w - this.padding,
                    this.paddedRect.y + this.paddedRect.h - this.padding
                ];
            }
            get displaySize() {
                return [
                    (this.paddedRect.w - 2 * this.padding) / this.scale.x,
                    (this.paddedRect.h - 2 * this.padding) / this.scale.y
                ];
            }
            constructor(t1, { pixelRatio: e, version: r, stretchX: n, stretchY: i, content: a, sdf: s, usvg: o }, l, u){
                this.paddedRect = t1, this.pixelRatio = e, this.stretchX = n, this.stretchY = i, this.content = a, this.version = r, this.padding = l, this.sdf = s, this.scale = $f.getImagePositionScale(u, o, e);
            }
        }
        class Gf {
            addImages(t1, e, r, n) {
                for(const i in t1){
                    const a = t1[i], s = {
                        x: 0,
                        y: 0,
                        w: a.data.width + 2 * r,
                        h: a.data.height + 2 * r
                    };
                    n.push(s);
                    const o = Qe.deserializeFromString(i);
                    e[i] = new $f(s, a, r, o), a.hasRenderCallback && this.haveRenderCallbacks.push(o.id);
                }
            }
            patchUpdatedImages(t1, e, r) {
                this.haveRenderCallbacks = this.haveRenderCallbacks.filter((e)=>t1.hasImage(e, r)), t1.dispatchRenderCallbacks(this.haveRenderCallbacks, r);
                for(const n in t1.getUpdatedImages(r)){
                    for (const i of Object.keys(this.iconPositions))Qe.deserializeId(i) === n && this.patchUpdatedImage(this.iconPositions[i], t1.getImage(n, r), e);
                    for (const i of Object.keys(this.patternPositions))Qe.deserializeId(i) === n && this.patchUpdatedImage(this.patternPositions[i], t1.getImage(n, r), e);
                }
            }
            patchUpdatedImage(t1, e, r) {
                if (!t1 || !e) return;
                if (t1.version === e.version) return;
                t1.version = e.version;
                const [n, i] = t1.tl, a = t1.sdf;
                if (this.lut || a) {
                    const t1 = {
                        width: e.data.width,
                        height: e.data.height
                    }, s = new sc(t1);
                    sc.copy(e.data, s, {
                        x: 0,
                        y: 0
                    }, {
                        x: 0,
                        y: 0
                    }, t1, this.lut, a), r.update(s, {
                        position: {
                            x: n,
                            y: i
                        }
                    });
                } else r.update(e.data, {
                    position: {
                        x: n,
                        y: i
                    }
                });
            }
            constructor(t1, e, r){
                const n = {}, i = {};
                this.haveRenderCallbacks = [];
                const a = [];
                this.addImages(t1, n, qf, a), this.addImages(e, i, 2, a);
                const { w: s, h: o } = jf(a), l = new sc({
                    width: s || 1,
                    height: o || 1
                });
                for(const e in t1){
                    const i = t1[e], a = n[e].paddedRect;
                    sc.copy(i.data, l, {
                        x: 0,
                        y: 0
                    }, {
                        x: a.x + qf,
                        y: a.y + qf
                    }, i.data, r, i.sdf);
                }
                for(const t1 in e){
                    const n = e[t1], a = i[t1].paddedRect;
                    let s = i[t1].padding;
                    const o = a.x + s, u = a.y + s, c = n.data.width, h = n.data.height;
                    s = s > 1 ? s - 1 : s, sc.copy(n.data, l, {
                        x: 0,
                        y: 0
                    }, {
                        x: o,
                        y: u
                    }, n.data, r), sc.copy(n.data, l, {
                        x: 0,
                        y: h - s
                    }, {
                        x: o,
                        y: u - s
                    }, {
                        width: c,
                        height: s
                    }, r), sc.copy(n.data, l, {
                        x: 0,
                        y: 0
                    }, {
                        x: o,
                        y: u + h
                    }, {
                        width: c,
                        height: s
                    }, r), sc.copy(n.data, l, {
                        x: c - s,
                        y: 0
                    }, {
                        x: o - s,
                        y: u
                    }, {
                        width: s,
                        height: h
                    }, r), sc.copy(n.data, l, {
                        x: 0,
                        y: 0
                    }, {
                        x: o + c,
                        y: u
                    }, {
                        width: s,
                        height: h
                    }, r), sc.copy(n.data, l, {
                        x: c - s,
                        y: h - s
                    }, {
                        x: o - s,
                        y: u - s
                    }, {
                        width: s,
                        height: s
                    }, r), sc.copy(n.data, l, {
                        x: 0,
                        y: h - s
                    }, {
                        x: o + c,
                        y: u - s
                    }, {
                        width: s,
                        height: s
                    }, r), sc.copy(n.data, l, {
                        x: 0,
                        y: 0
                    }, {
                        x: o + c,
                        y: u + h
                    }, {
                        width: s,
                        height: s
                    }, r), sc.copy(n.data, l, {
                        x: c - s,
                        y: 0
                    }, {
                        x: o - s,
                        y: u + h
                    }, {
                        width: s,
                        height: s
                    }, r);
                }
                this.lut = r, this.image = l, this.iconPositions = n, this.patternPositions = i;
            }
        }
        oa($f, "ImagePosition"), oa(Gf, "ImageAtlas");
        const Yf = 1e20;
        function Xf(t1, e, r, n, i, a, s, o, l) {
            for(let u = e; u < e + n; u++)Zf(t1, r * a + u, a, i, s, o, l);
            for(let u = r; u < r + i; u++)Zf(t1, u * a + e, 1, n, s, o, l);
        }
        function Zf(t1, e, r, n, i, a, s) {
            a[0] = 0, s[0] = -Yf, s[1] = Yf, i[0] = t1[e];
            for(let o = 1, l = 0, u = 0; o < n; o++){
                i[o] = t1[e + o * r];
                const n = o * o;
                do {
                    const t1 = a[l];
                    u = (i[o] - i[t1] + n - t1 * t1) / (o - t1) / 2;
                }while (u <= s[l] && --l > -1);
                l++, a[l] = o, s[l] = u, s[l + 1] = Yf;
            }
            for(let o = 0, l = 0; o < n; o++){
                for(; s[l + 1] < o;)l++;
                const n = a[l], u = o - n;
                t1[e + o * r] = i[n] + u * u;
            }
        }
        const Hf = 2, Wf = {
            none: 0,
            ideographs: 1,
            all: 2
        };
        class Kf {
            setURL(t1, e) {
                this.urls[e] = t1;
            }
            getGlyphs(t1, e, r) {
                const n = [], i = this.urls[e] || St.GLYPHS_URL;
                for(const e in t1)for (const r of t1[e])n.push({
                    stack: e,
                    id: r
                });
                rt(n, ({ stack: t1, id: e }, r)=>{
                    let n = this.entries[t1];
                    n || (n = this.entries[t1] = {
                        glyphs: {},
                        requests: {},
                        ranges: {},
                        ascender: void 0,
                        descender: void 0
                    });
                    let a = n.glyphs[e];
                    if (void 0 !== a) return void r(null, {
                        stack: t1,
                        id: e,
                        glyph: a
                    });
                    if (a = this._tinySDF(n, t1, e), a) return n.glyphs[e] = a, void r(null, {
                        stack: t1,
                        id: e,
                        glyph: a
                    });
                    const s = Math.floor(e / 256);
                    if (256 * s > 65535) return ft("glyphs > 65535 not supported"), void r(null, {
                        stack: t1,
                        id: e,
                        glyph: a
                    });
                    if (n.ranges[s]) return void r(null, {
                        stack: t1,
                        id: e,
                        glyph: a
                    });
                    let o = n.requests[s];
                    o || (o = n.requests[s] = [], Kf.loadGlyphRange(t1, s, i, this.requestManager, (t1, e)=>{
                        if (e) {
                            n.ascender = e.ascender, n.descender = e.descender;
                            for(const t1 in e.glyphs)this._doesCharSupportLocalGlyph(+t1) || (n.glyphs[+t1] = e.glyphs[+t1]);
                            n.ranges[s] = !0;
                        }
                        for (const r of o)r(t1, e);
                        delete n.requests[s];
                    })), o.push((n, i)=>{
                        n ? r(n) : i && r(null, {
                            stack: t1,
                            id: e,
                            glyph: i.glyphs[e] || null
                        });
                    });
                }, (t1, e)=>{
                    if (t1) r(t1);
                    else if (e) {
                        const t1 = {};
                        for (const { stack: r, id: n, glyph: i } of e)void 0 === t1[r] && (t1[r] = {}), void 0 === t1[r].glyphs && (t1[r].glyphs = {}), t1[r].glyphs[n] = i && {
                            id: i.id,
                            bitmap: i.bitmap.clone(),
                            metrics: i.metrics
                        }, t1[r].ascender = this.entries[r].ascender, t1[r].descender = this.entries[r].descender;
                        r(null, t1);
                    }
                });
            }
            _doesCharSupportLocalGlyph(t1) {
                return this.localGlyphMode !== Wf.none && (this.localGlyphMode === Wf.all ? !!this.localFontFamily : !!this.localFontFamily && (pa["CJK Unified Ideographs"](t1) || pa["Hangul Syllables"](t1) || pa.Hiragana(t1) || pa.Katakana(t1) || pa["CJK Symbols and Punctuation"](t1) || pa["CJK Unified Ideographs Extension A"](t1) || pa["CJK Unified Ideographs Extension B"](t1) || pa.Osage(t1)));
            }
            _tinySDF(t1, e, r) {
                const n = this.localFontFamily;
                if (!n || !this._doesCharSupportLocalGlyph(r)) return;
                let i = t1.tinySDF;
                if (!i) {
                    let r = "400";
                    /bold/i.test(e) ? r = "900" : /medium/i.test(e) ? r = "500" : /light/i.test(e) && (r = "200"), i = t1.tinySDF = new Kf.TinySDF({
                        fontFamily: n,
                        fontWeight: r,
                        fontSize: 24 * Hf,
                        buffer: 3 * Hf,
                        radius: 8 * Hf
                    }), i.fontWeight = r;
                }
                if (this.localGlyphs[i.fontWeight][r]) return this.localGlyphs[i.fontWeight][r];
                const a = String.fromCodePoint(r), { data: s, width: o, height: l, glyphWidth: u, glyphHeight: c, glyphLeft: h, glyphTop: p, glyphAdvance: f } = i.draw(a);
                return this.localGlyphs[i.fontWeight][r] = {
                    id: r,
                    bitmap: new ac({
                        width: o,
                        height: l
                    }, s),
                    metrics: {
                        width: u / Hf,
                        height: c / Hf,
                        left: h / Hf,
                        top: p / Hf - 27,
                        advance: f / Hf,
                        localGlyph: !0
                    }
                };
            }
            constructor(t1, e, r){
                this.requestManager = t1, this.localGlyphMode = e, this.localFontFamily = r, this.urls = {}, this.entries = {}, this.localGlyphs = {
                    200: {},
                    400: {},
                    500: {},
                    900: {}
                };
            }
        }
        Kf.loadGlyphRange = function(t1, e, r, n, i) {
            const a = 256 * e, s = a + 255, o = n.transformRequest(n.normalizeGlyphsURL(r).replace("{fontstack}", t1).replace("{range}", `${a}-${s}`), te.Glyphs);
            ie(o, (t1, e)=>{
                if (t1) i(t1);
                else if (e) {
                    const t1 = {}, r = function(t1) {
                        return new pf(t1).readFields(df, {});
                    }(e);
                    for (const e of r.glyphs)t1[e.id] = e;
                    i(null, {
                        glyphs: t1,
                        ascender: r.ascender,
                        descender: r.descender
                    });
                }
            });
        }, Kf.TinySDF = class {
            _createCanvas(t1) {
                const e = document.createElement("canvas");
                return e.width = e.height = t1, e;
            }
            draw(t1) {
                const { width: e, actualBoundingBoxAscent: r, actualBoundingBoxDescent: n, actualBoundingBoxLeft: i, actualBoundingBoxRight: a } = this.ctx.measureText(t1), s = Math.ceil(r), o = Math.max(0, Math.min(this.size - this.buffer, Math.ceil(a - i))), l = Math.min(this.size - this.buffer, s + Math.ceil(n)), u = o + 2 * this.buffer, c = l + 2 * this.buffer, h = Math.max(u * c, 0), p = new Uint8ClampedArray(h), f = {
                    data: p,
                    width: u,
                    height: c,
                    glyphWidth: o,
                    glyphHeight: l,
                    glyphTop: s,
                    glyphLeft: 0,
                    glyphAdvance: e
                };
                if (0 === o || 0 === l) return f;
                const { ctx: d, buffer: m, gridInner: y, gridOuter: g } = this;
                d.clearRect(m, m, o, l), d.fillText(t1, m, m + s);
                const x = d.getImageData(m, m, o, l);
                g.fill(Yf, 0, h), y.fill(0, 0, h);
                for(let t1 = 0; t1 < l; t1++)for(let e = 0; e < o; e++){
                    const r = x.data[4 * (t1 * o + e) + 3] / 255;
                    if (0 === r) continue;
                    const n = (t1 + m) * u + e + m;
                    if (1 === r) g[n] = 0, y[n] = Yf;
                    else {
                        const t1 = .5 - r;
                        g[n] = t1 > 0 ? t1 * t1 : 0, y[n] = t1 < 0 ? t1 * t1 : 0;
                    }
                }
                Xf(g, 0, 0, u, c, u, this.f, this.v, this.z), Xf(y, m, m, o, l, u, this.f, this.v, this.z);
                for(let t1 = 0; t1 < h; t1++){
                    const e = Math.sqrt(g[t1]) - Math.sqrt(y[t1]);
                    p[t1] = Math.round(255 - 255 * (e / this.radius + this.cutoff));
                }
                return f;
            }
            constructor({ fontSize: t1 = 24, buffer: e = 3, radius: r = 8, cutoff: n = .25, fontFamily: i = "sans-serif", fontWeight: a = "normal", fontStyle: s = "normal" } = {}){
                this.buffer = e, this.cutoff = n, this.radius = r;
                const o = this.size = t1 + 4 * e, l = this._createCanvas(o), u = this.ctx = l.getContext("2d", {
                    willReadFrequently: !0
                });
                u.font = `${s} ${a} ${t1}px ${i}`, u.textBaseline = "alphabetic", u.textAlign = "left", u.fillStyle = "black", this.gridOuter = new Float64Array(o * o), this.gridInner = new Float64Array(o * o), this.f = new Float64Array(o), this.z = new Float64Array(o + 1), this.v = new Uint16Array(o);
            }
        };
        const Jf = qf;
        function Qf(t1, e) {
            return t1 + e[1] - e[0];
        }
        function td(t1, e, r, n, i = 1) {
            const a = [], s = t1.imagePrimary, o = s.pixelRatio, l = s.paddedRect.w - 2 * Jf, u = s.paddedRect.h - 2 * Jf, c = (t1.right - t1.left) * i, h = (t1.bottom - t1.top) * i, p = s.stretchX || [
                [
                    0,
                    l
                ]
            ], f = s.stretchY || [
                [
                    0,
                    u
                ]
            ], d = p.reduce(Qf, 0), m = f.reduce(Qf, 0), y = l - d, g = u - m;
            let x = 0, v = d, b = 0, _ = m, w = 0, M = y, A = 0, S = g;
            if (s.content && n) {
                const t1 = s.content;
                x = ed(p, 0, t1[0]), b = ed(f, 0, t1[1]), v = ed(p, t1[0], t1[2]), _ = ed(f, t1[1], t1[3]), w = t1[0] - x, A = t1[1] - b, M = t1[2] - t1[0] - v, S = t1[3] - t1[1] - _;
            }
            const I = (n, a, l, u)=>{
                const p = nd(n.stretch - x, v, c, t1.left * i), f = id(n.fixed - w, M, n.stretch, d), y = nd(a.stretch - b, _, h, t1.top * i), g = id(a.fixed - A, S, a.stretch, m), I = nd(l.stretch - x, v, c, t1.left * i), P = id(l.fixed - w, M, l.stretch, d), z = nd(u.stretch - b, _, h, t1.top * i), E = id(u.fixed - A, S, u.stretch, m), k = new q(p, y), T = new q(I, y), B = new q(I, z), C = new q(p, z), V = new q(f / o, g / o), D = new q(P / o, E / o), L = e * Math.PI / 180;
                if (L) {
                    const t1 = Math.sin(L), e = Math.cos(L), r = [
                        e,
                        -t1,
                        t1,
                        e
                    ];
                    k._matMult(r), T._matMult(r), C._matMult(r), B._matMult(r);
                }
                const R = n.stretch + n.fixed, F = l.stretch + l.fixed, O = a.stretch + a.fixed, N = u.stretch + u.fixed, U = t1.imageSecondary;
                return {
                    tl: k,
                    tr: T,
                    bl: C,
                    br: B,
                    texPrimary: {
                        x: s.paddedRect.x + Jf + R,
                        y: s.paddedRect.y + Jf + O,
                        w: F - R,
                        h: N - O
                    },
                    texSecondary: U ? {
                        x: U.paddedRect.x + Jf + R,
                        y: U.paddedRect.y + Jf + O,
                        w: F - R,
                        h: N - O
                    } : void 0,
                    writingMode: void 0,
                    glyphOffset: [
                        0,
                        0
                    ],
                    sectionIndex: 0,
                    pixelOffsetTL: V,
                    pixelOffsetBR: D,
                    minFontScaleX: M / o / c,
                    minFontScaleY: S / o / h,
                    isSDF: r
                };
            };
            if (n && (s.stretchX || s.stretchY)) {
                const t1 = rd(p, y, d), e = rd(f, g, m);
                for(let r = 0; r < t1.length - 1; r++){
                    const n = t1[r], i = t1[r + 1];
                    for(let t1 = 0; t1 < e.length - 1; t1++)a.push(I(n, e[t1], i, e[t1 + 1]));
                }
            } else a.push(I({
                fixed: 0,
                stretch: -1
            }, {
                fixed: 0,
                stretch: -1
            }, {
                fixed: 0,
                stretch: l + 1
            }, {
                fixed: 0,
                stretch: u + 1
            }));
            return a;
        }
        function ed(t1, e, r) {
            let n = 0;
            for (const i of t1)n += Math.max(e, Math.min(r, i[1])) - Math.max(e, Math.min(r, i[0]));
            return n;
        }
        function rd(t1, e, r) {
            const n = [
                {
                    fixed: -Jf,
                    stretch: 0
                }
            ];
            for (const [e, r] of t1){
                const t1 = n[n.length - 1];
                n.push({
                    fixed: e - t1.stretch,
                    stretch: t1.stretch
                }), n.push({
                    fixed: e - t1.stretch,
                    stretch: t1.stretch + (r - e)
                });
            }
            return n.push({
                fixed: e + Jf,
                stretch: r
            }), n;
        }
        function nd(t1, e, r, n) {
            return t1 / e * r + n;
        }
        function id(t1, e, r, n) {
            return t1 - e * r / n;
        }
        function ad(t1, e, r, n) {
            const i = e + t1.positionedLines[n].lineOffset;
            return 0 === n ? r + i / 2 : r + (i + (e + t1.positionedLines[n - 1].lineOffset)) / 2;
        }
        function sd(t1, e = 1, r = !1) {
            let n = 1 / 0, i = 1 / 0, a = -1 / 0, s = -1 / 0;
            const o = t1[0];
            for(let t1 = 0; t1 < o.length; t1++){
                const e = o[t1];
                (!t1 || e.x < n) && (n = e.x), (!t1 || e.y < i) && (i = e.y), (!t1 || e.x > a) && (a = e.x), (!t1 || e.y > s) && (s = e.y);
            }
            const l = Math.min(a - n, s - i);
            let u = l / 2;
            const c = new Hr([], od);
            if (0 === l) return new q(n, i);
            for(let e = n; e < a; e += l)for(let r = i; r < s; r += l)c.push(new ld(e + u, r + u, u, t1));
            let h = function(t1) {
                let e = 0, r = 0, n = 0;
                const i = t1[0];
                for(let t1 = 0, a = i.length, s = a - 1; t1 < a; s = t1++){
                    const a = i[t1], o = i[s], l = a.x * o.y - o.x * a.y;
                    r += (a.x + o.x) * l, n += (a.y + o.y) * l, e += 3 * l;
                }
                return new ld(r / e, n / e, 0, t1);
            }(t1), p = c.length;
            for(; c.length;){
                const n = c.pop();
                (n.d > h.d || !h.d) && (h = n, r && console.log("found best %d after %d probes", Math.round(1e4 * n.d) / 1e4, p)), n.max - h.d <= e || (u = n.h / 2, c.push(new ld(n.p.x - u, n.p.y - u, u, t1)), c.push(new ld(n.p.x + u, n.p.y - u, u, t1)), c.push(new ld(n.p.x - u, n.p.y + u, u, t1)), c.push(new ld(n.p.x + u, n.p.y + u, u, t1)), p += 4);
            }
            return r && (console.log(`num probes: ${p}`), console.log(`best distance: ${h.d}`)), h.p;
        }
        function od(t1, e) {
            return e.max - t1.max;
        }
        class ld {
            constructor(t1, e, r, n){
                this.p = new q(t1, e), this.h = r, this.d = function(t1, e) {
                    let r = !1, n = 1 / 0;
                    for(let i = 0; i < e.length; i++){
                        const a = e[i];
                        for(let e = 0, i = a.length, s = i - 1; e < i; s = e++){
                            const i = a[e], o = a[s];
                            i.y > t1.y != o.y > t1.y && t1.x < (o.x - i.x) * (t1.y - i.y) / (o.y - i.y) + i.x && (r = !r), n = Math.min(n, Nl(t1, i, o));
                        }
                    }
                    return (r ? 1 : -1) * Math.sqrt(n);
                }(this.p, n), this.max = this.d + this.h * Math.SQRT2;
            }
        }
        const ud = Number.POSITIVE_INFINITY, cd = Math.sqrt(2);
        function hd(t1, [e, r]) {
            let n = 0, i = 0;
            if (r === ud) {
                e < 0 && (e = 0);
                const r = e / cd;
                switch(t1){
                    case "top-right":
                    case "top-left":
                        i = r - 7;
                        break;
                    case "bottom-right":
                    case "bottom-left":
                        i = 7 - r;
                        break;
                    case "bottom":
                        i = 7 - e;
                        break;
                    case "top":
                        i = e - 7;
                }
                switch(t1){
                    case "top-right":
                    case "bottom-right":
                        n = -r;
                        break;
                    case "top-left":
                    case "bottom-left":
                        n = r;
                        break;
                    case "left":
                        n = e;
                        break;
                    case "right":
                        n = -e;
                }
            } else {
                switch(e = Math.abs(e), r = Math.abs(r), t1){
                    case "top-right":
                    case "top-left":
                    case "top":
                        i = r - 7;
                        break;
                    case "bottom-right":
                    case "bottom-left":
                    case "bottom":
                        i = 7 - r;
                }
                switch(t1){
                    case "top-right":
                    case "bottom-right":
                    case "right":
                        n = -e;
                        break;
                    case "top-left":
                    case "bottom-left":
                    case "left":
                        n = e;
                }
            }
            return [
                n,
                i
            ];
        }
        function pd(t1) {
            switch(t1){
                case "right":
                case "top-right":
                case "bottom-right":
                    return "right";
                case "left":
                case "top-left":
                case "bottom-left":
                    return "left";
            }
            return "center";
        }
        function fd(t1, e, r, n, i, a, s, o, l, u, c, h, p, f, d) {
            let m = a.textMaxSize.evaluate(e, {}, h);
            void 0 === m ? m = s * a.textScaleFactor : m *= a.textScaleFactor;
            const y = t1.layers[0].layout, g = y.get("icon-offset").evaluate(e, {}, h), x = gd(r.horizontal) || r.vertical, v = "globe" === p.name, b = Zp, _ = s * a.textScaleFactor / b, w = t1.tilePixelRatio * m / b, M = (T = t1.overscaling, t1.zoom > 18 && T > 2 && (T >>= 1), Math.max(Wr / (512 * T), 1) * y.get("symbol-spacing")), A = y.get("text-padding") * t1.tilePixelRatio, S = y.get("icon-padding") * t1.tilePixelRatio, I = X(y.get("text-max-angle")), P = "map" === y.get("text-rotation-alignment") && "point" !== y.get("symbol-placement"), z = "map" === y.get("icon-rotation-alignment") && "point" !== y.get("symbol-placement"), E = y.get("symbol-placement"), k = M / 2;
            var T;
            const B = y.get("icon-text-fit").evaluate(e, {}, h), C = y.get("icon-text-fit-padding").evaluate(e, {}, h), V = "none" !== B;
            let D;
            !1 === t1.hasAnyIconTextFit && V && (t1.hasAnyIconTextFit = !0), n && V && (t1.allowVerticalPlacement && r.vertical && (D = Bf(n, r.vertical, B, C, g, _)), x && (n = Bf(n, x, B, C, g, _)));
            const L = (s, o, m)=>{
                if (o.x < 0 || o.x >= Wr || o.y < 0 || o.y >= Wr) return;
                let y = null;
                if (v) {
                    const { x: t1, y: e, z: r } = p.projectTilePoint(o.x, o.y, m);
                    y = {
                        anchor: new Cf(t1, e, r, 0, void 0),
                        up: p.upVector(m, o.x, o.y)
                    };
                }
                !function(t1, e, r, n, i, a, s, o, l, u, c, h, p, f, d, m, y, g, x, v, b, _, w, M, A, S, I) {
                    const P = t1.addToLineVertexArray(e, n);
                    let z, E, k, T, B, C, V, D = 0, L = 0, R = 0, F = 0, O = -1, N = -1;
                    const U = {};
                    let j = ge("");
                    const q = r ? r.anchor : e, $ = "none" !== l.layout.get("icon-text-fit").evaluate(b, {}, A);
                    let G = 0, Y = 0;
                    if (void 0 === l._unevaluatedLayout.getValue("text-radial-offset") ? [G, Y] = l.layout.get("text-offset").evaluate(b, {}, A).map((t1)=>t1 * Zp) : (G = l.layout.get("text-radial-offset").evaluate(b, {}, A) * Zp, Y = ud), t1.allowVerticalPlacement && i.vertical) {
                        const t1 = i.vertical;
                        if (d) C = vd(t1), o && (V = vd(o));
                        else {
                            const r = l.layout.get("text-rotate").evaluate(b, {}, A) + 90;
                            k = xd(u, q, e, c, h, p, t1, f, r, m), o && (T = xd(u, q, e, c, h, p, o, g, r));
                        }
                    }
                    if (a) {
                        const n = t1.iconSizeData, i = l.layout.get("icon-rotate").evaluate(b, {}, A), s = td(a, i, w, $, _.iconScaleFactor), f = o ? td(o, i, w, $, _.iconScaleFactor) : void 0;
                        E = xd(u, q, e, c, h, p, a, g, i, null), D = 4 * s.length;
                        let d = null;
                        "source" === n.kind ? (d = [
                            Hp * l.layout.get("icon-size").evaluate(b, {}, A) * _.iconScaleFactor
                        ], d[0] > md && ft(`${t1.layerIds[0]}: Value for "icon-size" is >= ${dd}. Reduce your "icon-size".`)) : "composite" === n.kind && (d = [
                            Hp * _.compositeIconSizes[0].evaluate(b, {}, A) * _.iconScaleFactor,
                            Hp * _.compositeIconSizes[1].evaluate(b, {}, A) * _.iconScaleFactor
                        ], (d[0] > md || d[1] > md) && ft(`${t1.layerIds[0]}: Value for "icon-size" is >= ${dd}. Reduce your "icon-size".`)), t1.addSymbols(t1.icon, s, d, v, x, b, !1, r, e, P.lineStartIndex, P.lineLength, -1, M, A, S, I), O = t1.icon.placedSymbolArray.length - 1, f && (L = 4 * f.length, t1.addSymbols(t1.icon, f, d, v, x, b, xf.vertical, r, e, P.lineStartIndex, P.lineLength, -1, M, A, S, I), N = t1.icon.placedSymbolArray.length - 1);
                    }
                    for(const n in i.horizontal){
                        const a = i.horizontal[n];
                        z || (j = ge(a.text), d ? B = vd(a) : z = xd(u, q, e, c, h, p, a, f, l.layout.get("text-rotate").evaluate(b, {}, A), m));
                        const o = 1 === a.positionedLines.length;
                        if (R += yd(t1, r, e, a, s, l, d, b, m, P, i.vertical ? xf.horizontal : xf.horizontalOnly, o ? Object.keys(i.horizontal) : [
                            n
                        ], U, O, _, M, A, S), o) break;
                    }
                    i.vertical && (F += yd(t1, r, e, i.vertical, s, l, d, b, m, P, xf.vertical, [
                        "vertical"
                    ], U, N, _, M, A, S));
                    let X = -1;
                    const Z = (t1, e)=>t1 ? Math.max(t1, e) : e;
                    X = Z(B, X), X = Z(C, X), X = Z(V, X);
                    const H = X > -1 ? 1 : 0;
                    t1.glyphOffsetArray.length >= 65535 && ft("Too many glyphs being rendered in a tile. See https://github.com/mapbox/mapbox-gl-js/issues/2907"), void 0 !== b.sortKey && t1.addToSortKeyRanges(t1.symbolInstances.length, b.sortKey), t1.symbolInstances.emplaceBack(e.x, e.y, q.x, q.y, q.z, U.right >= 0 ? U.right : -1, U.center >= 0 ? U.center : -1, U.left >= 0 ? U.left : -1, U.vertical >= 0 ? U.vertical : -1, O, N, j, void 0 !== z ? z : t1.collisionBoxArray.length, void 0 !== z ? z + 1 : t1.collisionBoxArray.length, void 0 !== k ? k : t1.collisionBoxArray.length, void 0 !== k ? k + 1 : t1.collisionBoxArray.length, void 0 !== E ? E : t1.collisionBoxArray.length, void 0 !== E ? E + 1 : t1.collisionBoxArray.length, T || t1.collisionBoxArray.length, T ? T + 1 : t1.collisionBoxArray.length, c, R, F, D, L, H, 0, G, Y, X, 0, $ ? 1 : 0);
                }(t1, o, y, s, r, n, i, D, t1.layers[0], t1.collisionBoxArray, e.index, e.sourceLayerIndex, t1.index, A, P, l, 0, S, z, g, e, a, u, c, h, f, d);
            };
            if ("line" === E) for (const i of Uf(e.geometry, 0, 0, Wr, Wr)){
                const e = Of(i, M, I, r.vertical || x, n, b, w, t1.overscaling, Wr);
                for (const r of e)x && bd(t1, x.text, k, r) || L(i, r, h);
            }
            else if ("line-center" === E) {
                for (const t1 of e.geometry)if (t1.length > 1) {
                    const e = Ff(t1, I, r.vertical || x, n, b, w);
                    e && L(t1, e, h);
                }
            } else if ("Polygon" === e.type) for (const t1 of Lc(e.geometry, 0)){
                const e = sd(t1, 16);
                L(t1[0], new Cf(e.x, e.y, 0, 0, void 0), h);
            }
            else if ("LineString" === e.type) for (const t1 of e.geometry)L(t1, new Cf(t1[0].x, t1[0].y, 0, 0, void 0), h);
            else if ("Point" === e.type) for (const t1 of e.geometry)for (const e of t1)L([
                e
            ], new Cf(e.x, e.y, 0, 0, void 0), h);
        }
        const dd = 255, md = dd * Hp;
        function yd(t1, e, r, n, i, a, s, o, l, u, c, h, p, f, d, m, y, g) {
            const x = function(t1, e, r, n, i, a, s, o) {
                const l = [];
                if (0 === e.positionedLines.length) return l;
                const u = n.layout.get("text-rotate").evaluate(a, {}) * Math.PI / 180, c = function(t1) {
                    const e = t1[0], r = t1[1], n = e * r;
                    return n > 0 ? [
                        e,
                        -r
                    ] : n < 0 ? [
                        -e,
                        r
                    ] : 0 === e ? [
                        r,
                        e
                    ] : [
                        r,
                        -e
                    ];
                }(r);
                let h = Math.abs(e.top - e.bottom);
                for (const t1 of e.positionedLines)h -= t1.lineOffset;
                const p = e.positionedLines.length, f = h / p;
                let d = e.top - r[1];
                for(let t1 = 0; t1 < p; ++t1){
                    const n = e.positionedLines[t1];
                    d = ad(e, f, d, t1);
                    for (const t1 of n.positionedGlyphs){
                        if (!t1.rect) continue;
                        const n = t1.rect || {};
                        let a = gf + 1, h = !0, p = 1, f = 0;
                        if (t1.imageName) {
                            const e = s[tr.build(t1.imageName).getSerializedPrimary()];
                            if (!e) continue;
                            if (e.sdf) {
                                ft("SDF images are not supported in formatted text and will be ignored.");
                                continue;
                            }
                            h = !1, p = e.pixelRatio, a = qf / p;
                        }
                        const m = (i || o) && t1.vertical, y = t1.metrics.advance * t1.scale / 2, g = t1.metrics, x = t1.rect;
                        if (null === x) continue;
                        o && e.verticalizable && (f = t1.imageName ? y - t1.metrics.width * t1.scale / 2 : 0);
                        const v = i ? [
                            t1.x + y,
                            t1.y
                        ] : [
                            0,
                            0
                        ];
                        let b = [
                            0,
                            0
                        ], _ = [
                            0,
                            0
                        ], w = !1;
                        i || (m ? (_ = [
                            t1.x + y + c[0],
                            t1.y + c[1] - f
                        ], w = !0) : b = [
                            t1.x + y + r[0],
                            t1.y + r[1] - f
                        ]);
                        const M = x.w * t1.scale / (p * (t1.localGlyph ? Hf : 1)), A = x.h * t1.scale / (p * (t1.localGlyph ? Hf : 1));
                        let S, I, P, z;
                        if (m) {
                            const e = t1.y - d, r = new q(-y, y - e), n = -Math.PI / 2, i = new q(..._);
                            S = new q(-y + b[0], b[1]), S._rotateAround(n, r)._add(i), S.x += -e + y, S.y -= (g.left - a) * t1.scale;
                            const s = t1.imageName ? g.advance * t1.scale : Zp * t1.scale, o = String.fromCodePoint(t1.glyph);
                            nf(o) ? S.x += (1 - a) * t1.scale : af(o) ? S.x += s - g.height * t1.scale + (-a - 1) * t1.scale : S.x += t1.imageName || g.width + 2 * a === x.w && g.height + 2 * a === x.h ? (s - A) / 2 : (s - (g.height + 2 * a) * t1.scale) / 2, I = new q(S.x, S.y - M), P = new q(S.x + A, S.y), z = new q(S.x + A, S.y - M);
                        } else {
                            const e = (g.left - a) * t1.scale - y + b[0], r = (-g.top - a) * t1.scale + b[1], n = e + M, i = r + A;
                            S = new q(e, r), I = new q(n, r), P = new q(e, i), z = new q(n, i);
                        }
                        if (u) {
                            let t1;
                            t1 = i ? new q(0, 0) : w ? new q(c[0], c[1]) : new q(r[0], r[1]), S._rotateAround(u, t1), I._rotateAround(u, t1), P._rotateAround(u, t1), z._rotateAround(u, t1);
                        }
                        const E = new q(0, 0), k = new q(0, 0);
                        l.push({
                            tl: S,
                            tr: I,
                            bl: P,
                            br: z,
                            texPrimary: n,
                            texSecondary: void 0,
                            writingMode: e.writingMode,
                            glyphOffset: v,
                            sectionIndex: t1.sectionIndex,
                            isSDF: h,
                            pixelOffsetTL: E,
                            pixelOffsetBR: k,
                            minFontScaleX: 0,
                            minFontScaleY: 0
                        });
                    }
                }
                return l;
            }(0, n, l, a, s, o, i, t1.allowVerticalPlacement), v = t1.textSizeData;
            let b = null;
            "source" === v.kind ? (b = [
                Hp * a.layout.get("text-size").evaluate(o, {}, y) * d.textScaleFactor
            ], b[0] > md && ft(`${t1.layerIds[0]}: Value for "text-size" is >= ${dd}. Reduce your "text-size".`)) : "composite" === v.kind && (b = [
                Hp * d.compositeTextSizes[0].evaluate(o, {}, y) * d.textScaleFactor,
                Hp * d.compositeTextSizes[1].evaluate(o, {}, y) * d.textScaleFactor
            ], (b[0] > md || b[1] > md) && ft(`${t1.layerIds[0]}: Value for "text-size" is >= ${dd}. Reduce your "text-size".`)), t1.addSymbols(t1.text, x, b, l, s, o, c, e, r, u.lineStartIndex, u.lineLength, f, m, y, g, !1);
            for (const e of h)p[e] = t1.text.placedSymbolArray.length - 1;
            return 4 * x.length;
        }
        function gd(t1) {
            for(const e in t1)return t1[e];
            return null;
        }
        function xd(t1, e, r, n, i, a, s, o, l, u) {
            let c = s.top, h = s.bottom, p = s.left, f = s.right;
            const d = s.collisionPadding;
            if (d && (p -= d[0], c -= d[1], f += d[2], h += d[3]), l) {
                const t1 = new q(p, c), e = new q(f, c), r = new q(p, h), n = new q(f, h), i = X(l);
                let a = new q(0, 0);
                u && (a = new q(u[0], u[1])), t1._rotateAround(i, a), e._rotateAround(i, a), r._rotateAround(i, a), n._rotateAround(i, a), p = Math.min(t1.x, e.x, r.x, n.x), f = Math.max(t1.x, e.x, r.x, n.x), c = Math.min(t1.y, e.y, r.y, n.y), h = Math.max(t1.y, e.y, r.y, n.y);
            }
            return t1.emplaceBack(e.x, e.y, e.z, r.x, r.y, p, c, f, h, o, n, i, a), t1.length - 1;
        }
        function vd(t1) {
            t1.collisionPadding && (t1.top -= t1.collisionPadding[1], t1.bottom += t1.collisionPadding[3]);
            const e = t1.bottom - t1.top;
            return e > 0 ? Math.max(10, e) : null;
        }
        function bd(t1, e, r, n) {
            const i = t1.compareText;
            if (e in i) {
                const t1 = i[e];
                for(let e = t1.length - 1; e >= 0; e--)if (n.dist(t1[e]) < r) return !0;
            } else i[e] = [];
            return i[e].push(n), !1;
        }
        function _d(t1, e) {
            const r = t1.fovAboveCenter, n = t1.elevation ? t1.elevation.getMinElevationBelowMSL() * e : 0, i = (t1._camera.position[2] * t1.worldSize - n) / Math.cos(t1._pitch), a = Math.sin(r) * i / Math.sin(Math.max(Math.PI / 2 - t1._pitch - r, .01));
            let s = Math.sin(t1._pitch) * a + i;
            const o = i * (1 / t1._horizonShift);
            if (!t1.elevation || 0 === t1.elevation.exaggeration()) {
                let e = Math.max(t1.zoom - 17, 0);
                t1.isOrthographic && (e /= 10), s *= 1 + e;
            }
            return Math.min(1.01 * s, o);
        }
        function wd(t1, e) {
            if (!e.isReprojectedInTileSpace) return {
                scale: 1 << t1.z,
                x: t1.x,
                y: t1.y,
                x2: t1.x + 1,
                y2: t1.y + 1,
                projection: e
            };
            const r = Math.pow(2, -t1.z), n = t1.x * r, i = (t1.x + 1) * r, a = t1.y * r, s = (t1.y + 1) * r, o = pl(n), l = pl(i), u = fl(a), c = fl(s), h = e.project(o, u), p = e.project(l, u), f = e.project(l, c), d = e.project(o, c);
            let m = Math.min(h.x, p.x, f.x, d.x), y = Math.min(h.y, p.y, f.y, d.y), g = Math.max(h.x, p.x, f.x, d.x), x = Math.max(h.y, p.y, f.y, d.y);
            const v = r / 16;
            function b(t1, r, n, i, a, s) {
                const o = (n + a) / 2, l = (i + s) / 2, u = e.project(pl(o), fl(l)), c = Math.max(0, m - u.x, y - u.y, u.x - g, u.y - x);
                m = Math.min(m, u.x), g = Math.max(g, u.x), y = Math.min(y, u.y), x = Math.max(x, u.y), c > v && (b(t1, u, n, i, o, l), b(u, r, o, l, a, s));
            }
            b(h, p, n, a, i, a), b(p, f, i, a, i, s), b(f, d, i, s, n, s), b(d, h, n, s, n, a), m -= v, y -= v, g += v, x += v;
            const _ = 1 / Math.max(g - m, x - y);
            return {
                scale: _,
                x: m * _,
                y: y * _,
                x2: g * _,
                y2: x * _,
                projection: e
            };
        }
        function Md(t1, { x: e, y: r }, n = 0) {
            return new q(((e - n) * t1.scale - t1.x) * Wr, (r * t1.scale - t1.y) * Wr);
        }
        const Ad = O.mat4.identity(new Float32Array(16));
        class Sd {
            project(t1, e) {
                return {
                    x: 0,
                    y: 0,
                    z: 0
                };
            }
            unproject(t1, e) {
                return new il(0, 0);
            }
            projectTilePoint(t1, e, r) {
                return {
                    x: t1,
                    y: e,
                    z: 0
                };
            }
            locationPoint(t1, e, r = !0) {
                return t1._coordinatePoint(t1.locationCoordinate(e), r);
            }
            pixelsPerMeter(t1, e) {
                return hl(1, t1) * e;
            }
            pixelSpaceConversion(t1, e, r) {
                return 1;
            }
            farthestPixelDistance(t1) {
                return _d(t1, t1.pixelsPerMeter);
            }
            pointCoordinate(t1, e, r, n) {
                const i = t1.horizonLineFromTop(!1), a = new q(e, Math.max(i, r));
                return t1.rayIntersectionCoordinate(t1.pointRayIntersection(a, n));
            }
            pointCoordinate3D(t1, e, r) {
                const n = new q(e, r);
                if (t1.elevation) return t1.elevation.pointCoordinate(n);
                {
                    const e = this.pointCoordinate(t1, n.x, n.y, 0);
                    return [
                        e.x,
                        e.y,
                        e.z
                    ];
                }
            }
            isPointAboveHorizon(t1, e) {
                if (t1.elevation && t1.elevation.visibleDemTiles.length) return !this.pointCoordinate3D(t1, e.x, e.y);
                const r = t1.horizonLineFromTop();
                return e.y < r;
            }
            createInversionMatrix(t1, e) {
                return Ad;
            }
            createTileMatrix(t1, e, r) {
                let n, i, a;
                const s = r.canonical, o = O.mat4.identity(new Float64Array(16));
                if (this.isReprojectedInTileSpace) {
                    const l = wd(s, this);
                    n = 1, i = l.x + r.wrap * l.scale, a = l.y, O.mat4.scale(o, o, [
                        n / l.scale,
                        n / l.scale,
                        t1.pixelsPerMeter / e
                    ]);
                } else n = e / t1.zoomScale(s.z), i = (s.x + Math.pow(2, s.z) * r.wrap) * n, a = s.y * n;
                return O.mat4.translate(o, o, [
                    i,
                    a,
                    0
                ]), O.mat4.scale(o, o, [
                    n / Wr,
                    n / Wr,
                    1
                ]), o;
            }
            upVector(t1, e, r) {
                return [
                    0,
                    0,
                    1
                ];
            }
            upVectorScale(t1, e, r) {
                return {
                    metersToTile: 1
                };
            }
            constructor(t1){
                this.spec = t1, this.name = t1.name, this.wrap = !1, this.requiresDraping = !1, this.supportsWorldCopies = !1, this.supportsTerrain = !1, this.supportsFog = !1, this.supportsFreeCamera = !1, this.zAxisUnit = "meters", this.isReprojectedInTileSpace = !0, this.unsupportedLayers = [
                    "custom"
                ], this.center = [
                    0,
                    0
                ], this.range = [
                    3.5,
                    7
                ];
            }
        }
        class Id extends Sd {
            project(t1, e) {
                const { n: r, c: n, r0: i } = this, a = X(t1 - this.center[0]), s = X(e), o = Math.sqrt(n - 2 * r * Math.sin(s)) / r;
                return {
                    x: o * Math.sin(a * r),
                    y: o * Math.cos(a * r) - i,
                    z: 0
                };
            }
            unproject(t1, e) {
                const { n: r, c: n, r0: i } = this, a = i + e;
                let s = Math.atan2(t1, Math.abs(a)) * Math.sign(a);
                a * r < 0 && (s -= Math.PI * Math.sign(t1) * Math.sign(a));
                const o = X(this.center[0]) * r;
                s = et(s, -Math.PI - o, Math.PI - o);
                const l = Q(Z(s / r) + this.center[0], -180, 180), u = Math.asin(Q((n - (t1 * t1 + a * a) * r * r) / (2 * r), -1, 1)), c = Q(Z(u), -ml, ml);
                return new il(l, c);
            }
            constructor(t1){
                super(t1), this.range = [
                    4,
                    7
                ], this.center = t1.center || [
                    -96,
                    37.5
                ];
                const [e, r] = this.parallels = t1.parallels || [
                    29.5,
                    45.5
                ], n = Math.sin(X(e));
                this.n = (n + Math.sin(X(r))) / 2, this.c = 1 + n * (2 * this.n - n), this.r0 = Math.sqrt(this.c) / this.n;
            }
        }
        const Pd = 1.340264, zd = -0.081106, Ed = 893e-6, kd = .003796, Td = Math.sqrt(3) / 2;
        class Bd extends Sd {
            project(t1, e) {
                e = e / 180 * Math.PI, t1 = t1 / 180 * Math.PI;
                const r = Math.asin(Td * Math.sin(e)), n = r * r, i = n * n * n;
                return {
                    x: .5 * (t1 * Math.cos(r) / (Td * (Pd + 3 * zd * n + i * (7 * Ed + 9 * kd * n))) / Math.PI + .5),
                    y: 1 - .5 * (r * (Pd + zd * n + i * (Ed + kd * n)) / Math.PI + 1),
                    z: 0
                };
            }
            unproject(t1, e) {
                t1 = (2 * t1 - .5) * Math.PI;
                let r = e = (2 * (1 - e) - 1) * Math.PI, n = r * r, i = n * n * n;
                for(let t1, a, s, o = 0; o < 12 && (a = r * (Pd + zd * n + i * (Ed + kd * n)) - e, s = Pd + 3 * zd * n + i * (7 * Ed + 9 * kd * n), t1 = a / s, r = Q(r - t1, -Math.PI / 3, Math.PI / 3), n = r * r, i = n * n * n, !(Math.abs(t1) < 1e-12)); ++o);
                const a = Td * t1 * (Pd + 3 * zd * n + i * (7 * Ed + 9 * kd * n)) / Math.cos(r), s = Math.asin(Math.sin(r) / Td), o = Q(180 * a / Math.PI, -180, 180), l = Q(180 * s / Math.PI, -ml, ml);
                return new il(o, l);
            }
        }
        class Cd extends Sd {
            project(t1, e) {
                return {
                    x: .5 + t1 / 360,
                    y: .5 - e / 360,
                    z: 0
                };
            }
            unproject(t1, e) {
                const r = 360 * (t1 - .5), n = Q(360 * (.5 - e), -ml, ml);
                return new il(r, n);
            }
            constructor(t1){
                super(t1), this.wrap = !0, this.supportsWorldCopies = !0;
            }
        }
        const Vd = Math.PI / 2;
        function Dd(t1) {
            return Math.tan((Vd + t1) / 2);
        }
        class Ld extends Sd {
            project(t1, e) {
                e = X(e), this.southernCenter && (e = -e), t1 = X(t1 - this.center[0]);
                const r = 1e-6, { n: n, f: i } = this;
                i > 0 ? e < -Vd + r && (e = -Vd + r) : e > Vd - r && (e = Vd - r);
                const a = i / Math.pow(Dd(e), n);
                let s = a * Math.sin(n * t1), o = i - a * Math.cos(n * t1);
                return s = .5 * (s / Math.PI + .5), o = .5 * (o / Math.PI + .5), {
                    x: s,
                    y: this.southernCenter ? o : 1 - o,
                    z: 0
                };
            }
            unproject(t1, e) {
                t1 = (2 * t1 - .5) * Math.PI, this.southernCenter && (e = 1 - e), e = (2 * (1 - e) - .5) * Math.PI;
                const { n: r, f: n } = this, i = n - e, a = Math.sign(i), s = Math.sign(r) * Math.sqrt(t1 * t1 + i * i);
                let o = Math.atan2(t1, Math.abs(i)) * a;
                i * r < 0 && (o -= Math.PI * Math.sign(t1) * a);
                const l = Q(Z(o / r) + this.center[0], -180, 180), u = Q(Z(2 * Math.atan(Math.pow(n / s, 1 / r)) - Vd), -ml, ml);
                return new il(l, this.southernCenter ? -u : u);
            }
            constructor(t1){
                super(t1), this.center = t1.center || [
                    0,
                    30
                ];
                const [e, r] = this.parallels = t1.parallels || [
                    30,
                    30
                ];
                let n = X(e), i = X(r);
                this.southernCenter = n + i < 0, this.southernCenter && (n = -n, i = -i);
                const a = Math.cos(n), s = Dd(n);
                this.n = n === i ? Math.sin(n) : Math.log(a / Math.cos(i)) / Math.log(Dd(i) / s), this.f = a * Math.pow(Dd(n), this.n) / this.n;
            }
        }
        class Rd extends Sd {
            project(t1, e) {
                return {
                    x: ul(t1),
                    y: cl(e),
                    z: 0
                };
            }
            unproject(t1, e) {
                const r = pl(t1), n = fl(e);
                return new il(r, n);
            }
            constructor(t1){
                super(t1), this.wrap = !0, this.supportsWorldCopies = !0, this.supportsTerrain = !0, this.supportsFog = !0, this.supportsFreeCamera = !0, this.isReprojectedInTileSpace = !1, this.unsupportedLayers = [], this.range = null;
            }
        }
        const Fd = X(ml);
        class Od extends Sd {
            project(t1, e) {
                const r = (e = X(e)) * e, n = r * r;
                return {
                    x: .5 * ((t1 = X(t1)) * (.8707 - .131979 * r + n * (n * (.003971 * r - .001529 * n) - .013791)) / Math.PI + .5),
                    y: 1 - .5 * (e * (1.007226 + r * (.015085 + n * (.028874 * r - .044475 - .005916 * n))) / Math.PI + 1),
                    z: 0
                };
            }
            unproject(t1, e) {
                t1 = (2 * t1 - .5) * Math.PI;
                let r = e = (2 * (1 - e) - 1) * Math.PI, n = 25, i = 0, a = r * r;
                do {
                    a = r * r;
                    const t1 = a * a;
                    i = (r * (1.007226 + a * (.015085 + t1 * (.028874 * a - .044475 - .005916 * t1))) - e) / (1.007226 + a * (.045255 + t1 * (.259866 * a - .311325 - .005916 * 11 * t1))), r = Q(r - i, -Fd, Fd);
                }while (Math.abs(i) > 1e-6 && --n > 0);
                a = r * r;
                const s = Q(Z(t1 / (.8707 + a * (a * (a * a * a * (.003971 - .001529 * a) - .013791) - .131979))), -180, 180), o = Z(r);
                return new il(s, o);
            }
        }
        const Nd = X(ml);
        class Ud extends Sd {
            project(t1, e) {
                e = X(e), t1 = X(t1);
                const r = Math.cos(e), n = 2 / Math.PI, i = Math.acos(r * Math.cos(t1 / 2)), a = Math.sin(i) / i, s = .5 * (t1 * n + 2 * r * Math.sin(t1 / 2) / a) || 0, o = .5 * (e + Math.sin(e) / a) || 0;
                return {
                    x: .5 * (s / Math.PI + .5),
                    y: 1 - .5 * (o / Math.PI + 1),
                    z: 0
                };
            }
            unproject(t1, e) {
                let r = t1 = (2 * t1 - .5) * Math.PI, n = e = (2 * (1 - e) - 1) * Math.PI, i = 25;
                const a = 1e-6;
                let s = 0, o = 0;
                do {
                    const i = Math.cos(n), a = Math.sin(n), l = 2 * a * i, u = a * a, c = i * i, h = Math.cos(r / 2), p = Math.sin(r / 2), f = 2 * h * p, d = p * p, m = 1 - c * h * h, y = m ? 1 / m : 0, g = m ? Math.acos(i * h) * Math.sqrt(1 / m) : 0, x = .5 * (2 * g * i * p + 2 * r / Math.PI) - t1, v = .5 * (g * a + n) - e, b = .5 * y * (c * d + g * i * h * u) + 1 / Math.PI, _ = y * (f * l / 4 - g * a * p), w = .125 * y * (l * p - g * a * c * f), M = .5 * y * (u * h + g * d * i) + .5, A = _ * w - M * b;
                    s = (v * _ - x * M) / A, o = (x * w - v * b) / A, r = Q(r - s, -Math.PI, Math.PI), n = Q(n - o, -Nd, Nd);
                }while ((Math.abs(s) > a || Math.abs(o) > a) && --i > 0);
                return new il(Z(r), Z(n));
            }
        }
        class jd extends Sd {
            project(t1, e) {
                const { scale: r, cosPhi: n } = this;
                return {
                    x: X(t1) * n * r + .5,
                    y: -Math.sin(X(e)) / n * r + .5,
                    z: 0
                };
            }
            unproject(t1, e) {
                const { scale: r, cosPhi: n } = this, i = -(e - .5) / r, a = Q(Z((t1 - .5) / r) / n, -180, 180), s = Math.asin(Q(i * n, -1, 1)), o = Q(Z(s), -ml, ml);
                return new il(a, o);
            }
            constructor(t1){
                super(t1), this.center = t1.center || [
                    0,
                    0
                ], this.parallels = t1.parallels || [
                    0,
                    0
                ], this.cosPhi = Math.max(.01, Math.cos(X(this.parallels[0]))), this.scale = 1 / (2 * Math.max(Math.PI * this.cosPhi, 1 / this.cosPhi)), this.wrap = !0, this.supportsWorldCopies = !0;
            }
        }
        class qd extends Rd {
            projectTilePoint(t1, e, r) {
                const n = ku(t1, e, r), i = Cu(Au(r));
                return O.vec3.transformMat4(n, n, i), {
                    x: n[0],
                    y: n[1],
                    z: n[2]
                };
            }
            locationPoint(t1, e) {
                const r = el(e.lat, e.lng), n = O.vec3.normalize([], r), i = t1.elevation ? t1.elevation.getAtPointOrZero(t1.locationCoordinate(e), t1._centerAltitude) : t1._centerAltitude, a = hl(1, 0) * Wr * i;
                O.vec3.scaleAndAdd(r, r, n, a);
                const s = O.mat4.identity(new Float64Array(16));
                return O.mat4.multiply(s, t1.pixelMatrix, t1.globeMatrix), O.vec3.transformMat4(r, r, s), new q(r[0], r[1]);
            }
            pixelsPerMeter(t1, e) {
                return hl(1, 0) * e;
            }
            pixelSpaceConversion(t1, e, r) {
                const n = hl(1, t1) * e, i = ze(hl(1, 45) * e, n, r);
                return this.pixelsPerMeter(t1, e) / i;
            }
            createTileMatrix(t1, e, r) {
                const n = Vu(Au(r.canonical));
                return O.mat4.multiply(new Float64Array(16), t1.globeMatrix, n);
            }
            createInversionMatrix(t1, e) {
                const { center: r } = t1, n = Cu(Au(e));
                return O.mat4.rotateY(n, n, X(r.lng)), O.mat4.rotateX(n, n, X(r.lat)), O.mat4.scale(n, n, [
                    t1._pixelsPerMercatorPixel,
                    t1._pixelsPerMercatorPixel,
                    1
                ]), Float32Array.from(n);
            }
            pointCoordinate(t1, e, r, n) {
                return _u(t1, e, r, !0) || new bl(0, 0);
            }
            pointCoordinate3D(t1, e, r) {
                const n = this.pointCoordinate(t1, e, r, 0);
                return [
                    n.x,
                    n.y,
                    n.z
                ];
            }
            isPointAboveHorizon(t1, e) {
                return !_u(t1, e.x, e.y, !1);
            }
            farthestPixelDistance(t1) {
                const e = function(t1, e) {
                    const r = t1.cameraToCenterDistance, n = t1._centerAltitude * e, i = t1._camera, a = t1._camera.forward(), s = O.vec3.add([], O.vec3.scale([], a, -r), [
                        0,
                        0,
                        n
                    ]), o = t1.worldSize / (2 * Math.PI), l = [
                        0,
                        0,
                        -o
                    ], u = t1.width / t1.height, c = Math.tan(t1.fovAboveCenter), h = O.vec3.scale([], i.up(), c), p = O.vec3.scale([], i.right(), c * u), f = O.vec3.normalize([], O.vec3.add([], O.vec3.add([], a, h), p)), d = [];
                    let m;
                    if (new hu(s, f).closestPointOnSphere(l, o, d)) {
                        const e = O.vec3.add([], d, l), r = O.vec3.sub([], e, s);
                        m = Math.cos(t1.fovAboveCenter) * O.vec3.length(r);
                    } else {
                        const t1 = O.vec3.sub([], s, l), e = O.vec3.sub([], l, s);
                        O.vec3.normalize(e, e);
                        const r = O.vec3.length(t1) - o;
                        m = Math.sqrt(r * (r + 2 * o));
                        const n = Math.acos(m / (o + r)) - Math.acos(O.vec3.dot(a, e));
                        m *= Math.cos(n);
                    }
                    return 1.01 * m;
                }(t1, this.pixelsPerMeter(t1.center.lat, t1.worldSize)), r = Fu(t1.zoom);
                if (r > 0) {
                    const n = _d(t1, hl(1, t1.center.lat) * t1.worldSize), i = t1.worldSize / (2 * Math.PI), a = Math.max(t1.width, t1.height) / t1.worldSize * Math.PI;
                    return ze(e, n + i * (1 - Math.cos(a)), Math.pow(r, 10));
                }
                return e;
            }
            upVector(t1, e, r) {
                return ku(e, r, t1, 1);
            }
            upVectorScale(t1) {
                return {
                    metersToTile: vu(Tu(Au(t1)))
                };
            }
            constructor(t1){
                super(t1), this.requiresDraping = !0, this.supportsWorldCopies = !1, this.supportsFog = !0, this.zAxisUnit = "pixels", this.unsupportedLayers = [
                    "debug"
                ], this.range = [
                    3,
                    5
                ];
            }
        }
        function $d(t1) {
            const e = t1.parallels, r = !!e && Math.abs(e[0] + e[1]) < .01;
            switch(t1.name){
                case "mercator":
                    return new Rd(t1);
                case "equirectangular":
                    return new Cd(t1);
                case "naturalEarth":
                    return new Od(t1);
                case "equalEarth":
                    return new Bd(t1);
                case "winkelTripel":
                    return new Ud(t1);
                case "albers":
                    return r ? new jd(t1) : new Id(t1);
                case "lambertConformalConic":
                    return r ? new jd(t1) : new Ld(t1);
                case "globe":
                    return new qd(t1);
            }
            throw new Error(`Invalid projection name: ${t1.name}`);
        }
        const Gd = fh.VectorTileFeature.types, Yd = [
            {
                name: "a_fade_opacity",
                components: 1,
                type: "Uint8",
                offset: 0
            }
        ];
        function Xd(t1, e, r, n, i, a, s, o, l, u, c, h, p) {
            const f = o ? Math.min(md, Math.round(o[0])) : 0, d = o ? Math.min(md, Math.round(o[1])) : 0;
            t1.emplaceBack(e, r, Math.round(32 * n), Math.round(32 * i), a, s, (f << 1) + (l ? 1 : 0), d, 16 * u, 16 * c, 256 * h, 256 * p);
        }
        function Zd(t1, e, r) {
            t1.emplaceBack(e, r);
        }
        function Hd(t1, e, r, n, i, a, s) {
            t1.emplaceBack(e, r, n, i, a, s);
        }
        function Wd(t1, e, r, n, i) {
            t1.emplaceBack(e, r, n, i), t1.emplaceBack(e, r, n, i), t1.emplaceBack(e, r, n, i), t1.emplaceBack(e, r, n, i);
        }
        function Kd(t1) {
            for (const e of t1.sections)if (ba(e.text)) return !0;
            return !1;
        }
        class Jd {
            isEmpty() {
                return 0 === this.layoutVertexArray.length && 0 === this.indexArray.length && 0 === this.dynamicLayoutVertexArray.length && 0 === this.opacityVertexArray.length && 0 === this.iconTransitioningVertexArray.length;
            }
            upload(t1, e, r, n, i) {
                this.isEmpty() || (r && (this.layoutVertexBuffer = t1.createVertexBuffer(this.layoutVertexArray, Op.members), this.indexBuffer = t1.createIndexBuffer(this.indexArray, e), this.dynamicLayoutVertexBuffer = t1.createVertexBuffer(this.dynamicLayoutVertexArray, Up.members, !0), this.opacityVertexBuffer = t1.createVertexBuffer(this.opacityVertexArray, Yd, !0), this.iconTransitioningVertexArray.length > 0 && (this.iconTransitioningVertexBuffer = t1.createVertexBuffer(this.iconTransitioningVertexArray, qp.members, !0)), this.globeExtVertexArray.length > 0 && (this.globeExtVertexBuffer = t1.createVertexBuffer(this.globeExtVertexArray, Np.members, !0)), !this.zOffsetVertexBuffer && (this.zOffsetVertexArray.length > 0 || i) && (this.zOffsetVertexBuffer = t1.createVertexBuffer(this.zOffsetVertexArray, jp.members, !0)), this.opacityVertexBuffer.itemSize = 1), (r || n) && this.programConfigurations.upload(t1));
            }
            destroy() {
                this.layoutVertexBuffer && (this.layoutVertexBuffer.destroy(), this.indexBuffer.destroy(), this.programConfigurations.destroy(), this.segments.destroy(), this.dynamicLayoutVertexBuffer.destroy(), this.opacityVertexBuffer.destroy(), this.iconTransitioningVertexBuffer && this.iconTransitioningVertexBuffer.destroy(), this.globeExtVertexBuffer && this.globeExtVertexBuffer.destroy(), this.zOffsetVertexBuffer && this.zOffsetVertexBuffer.destroy());
            }
            constructor(t1){
                this.layoutVertexArray = new Ps, this.indexArray = new Ls, this.programConfigurations = t1, this.segments = new po, this.dynamicLayoutVertexArray = new Es, this.opacityVertexArray = new ks, this.placedSymbolArray = new to, this.iconTransitioningVertexArray = new Ts, this.globeExtVertexArray = new zs, this.zOffsetVertexArray = new Os;
            }
        }
        oa(Jd, "SymbolBuffers");
        class Qd {
            upload(t1) {
                this.layoutVertexBuffer = t1.createVertexBuffer(this.layoutVertexArray, this.layoutAttributes), this.indexBuffer = t1.createIndexBuffer(this.indexArray), this.collisionVertexBuffer = t1.createVertexBuffer(this.collisionVertexArray, $p.members, !0), this.collisionVertexBufferExt = t1.createVertexBuffer(this.collisionVertexArrayExt, Gp.members, !0);
            }
            destroy() {
                this.layoutVertexBuffer && (this.layoutVertexBuffer.destroy(), this.indexBuffer.destroy(), this.segments.destroy(), this.collisionVertexBuffer.destroy(), this.collisionVertexBufferExt.destroy());
            }
            constructor(t1, e, r){
                this.layoutVertexArray = new t1, this.layoutAttributes = e, this.indexArray = new r, this.segments = new po, this.collisionVertexArray = new Ds, this.collisionVertexArrayExt = new Es;
            }
        }
        oa(Qd, "CollisionBuffers");
        class tm {
            createArrays() {
                this.text = new Jd(new No(this.layers, {
                    zoom: this.zoom,
                    lut: this.lut
                }, (t1)=>t1.startsWith("text") || t1.startsWith("symbol"))), this.icon = new Jd(new No(this.layers, {
                    zoom: this.zoom,
                    lut: this.lut
                }, (t1)=>t1.startsWith("icon") || t1.startsWith("symbol"))), this.glyphOffsetArray = new no, this.lineVertexArray = new io, this.symbolInstances = new ro;
            }
            calculateGlyphDependencies(t1, e, r, n, i) {
                for (const r of t1){
                    const t1 = r.codePointAt(0);
                    if (void 0 === t1) break;
                    if (e[t1] = !0, n && i && t1 <= 65535) {
                        const t1 = rf[r];
                        t1 && (e[t1.charCodeAt(0)] = !0);
                    }
                }
            }
            updateFootprints(t1, e) {}
            updateReplacement(t1, e) {
                if (e.updateTime === this.replacementUpdateTime) return !1;
                this.replacementUpdateTime = e.updateTime;
                const r = e.getReplacementRegionsForTile(t1.toUnwrapped(), !0);
                return !Ah(this.activeReplacements, r) && (this.activeReplacements = r, !0);
            }
            populate(t1, e, r, n) {
                const i = this.layers[0], a = i.layout, s = "globe" === this.projection.name, o = a.get("text-font"), l = a.get("text-field"), u = a.get("icon-image"), [c, h] = a.get("icon-size-scale-range"), p = Q(e.scaleFactor || 1, c, h), f = ("constant" !== l.value.kind || l.value.value instanceof Je && !l.value.value.isEmpty() || l.value.value.toString().length > 0) && ("constant" !== o.value.kind || o.value.value.length > 0), d = "constant" !== u.value.kind || !!u.value.value || Object.keys(u.parameters).length > 0, m = a.get("symbol-sort-key");
                if (this.features = [], !f && !d) return;
                const y = e.iconDependencies, g = e.glyphDependencies, x = e.availableImages, v = new Ca(this.zoom);
                for (const { feature: e, id: l, index: u, sourceLayerIndex: c } of t1){
                    const t1 = i._featureFilter.needGeometry, h = El(e, t1);
                    if (!i._featureFilter.filter(v, h, r)) continue;
                    if (t1 || (h.geometry = zl(e, r, n)), s && 1 !== e.type && r.z <= 5) {
                        const t1 = h.geometry, e = .98078528056, n = (t1, n)=>{
                            const i = ku(t1.x, t1.y, r, 1), a = ku(n.x, n.y, r, 1);
                            return O.vec3.dot(i, a) < e;
                        };
                        for(let e = 0; e < t1.length; e++)t1[e] = Al(t1[e], n);
                    }
                    let b, _;
                    if (f) {
                        const t1 = i.getValueAndResolveTokens("text-field", h, r, x), e = Je.factory(t1);
                        Kd(e) && (this.hasRTLText = !0), (!this.hasRTLText || "unavailable" === ka() || this.hasRTLText && Ba.isParsed()) && (b = ef(e, i, h));
                    }
                    if (d) {
                        const t1 = i.getValueAndResolveTokens("icon-image", h, r, x);
                        _ = t1 instanceof tr ? t1 : tr.build(t1);
                    }
                    if (!b && !_) continue;
                    const w = this.sortFeaturesByKey ? m.evaluate(h, {}, r) : void 0, M = {
                        id: l,
                        text: b,
                        icon: _,
                        index: u,
                        sourceLayerIndex: c,
                        geometry: h.geometry,
                        properties: e.properties,
                        type: Gd[e.type],
                        sortKey: w
                    };
                    if (this.features.push(M), _) {
                        const t1 = Wp(this.iconSizeData, this.layers[0]._unevaluatedLayout._values["icon-size"], r, this.zoom, M) * p * this.pixelRatio, e = _.getPrimary().scaleSelf(t1);
                        if (y[e.id] = y[e.id] || [], y[e.id].push(e), _.nameSecondary) {
                            const e = _.getSecondary().scaleSelf(t1);
                            y[e.id] = y[e.id] || [], y[e.id].push(e);
                        }
                    }
                    if (b) {
                        const t1 = o.evaluate(h, {}, r).join(","), e = "map" === a.get("text-rotation-alignment") && "point" !== a.get("symbol-placement");
                        this.allowVerticalPlacement = this.writingModes && this.writingModes.indexOf(xf.vertical) >= 0;
                        for (const r of b.sections)if (r.image) {
                            const t1 = r.image.getPrimary().scaleSelf(this.pixelRatio);
                            y[t1.id] = y[t1.id] || [], y[t1.id].push(t1);
                        } else {
                            const n = fa(b.toString()), i = r.fontStack || t1, a = g[i] = g[i] || {};
                            this.calculateGlyphDependencies(r.text, a, e, this.allowVerticalPlacement, n);
                        }
                    }
                }
                "line" === a.get("symbol-placement") && (this.features = function(t1) {
                    const e = {}, r = {}, n = [];
                    let i = 0;
                    function a(e) {
                        n.push(t1[e]), i++;
                    }
                    function s(t1, e, i) {
                        const a = r[t1];
                        return delete r[t1], r[e] = a, n[a].geometry[0].pop(), n[a].geometry[0] = n[a].geometry[0].concat(i[0]), a;
                    }
                    function o(t1, r, i) {
                        const a = e[r];
                        return delete e[r], e[t1] = a, n[a].geometry[0].shift(), n[a].geometry[0] = i[0].concat(n[a].geometry[0]), a;
                    }
                    function l(t1, e, r) {
                        const n = r ? e[0][e[0].length - 1] : e[0][0];
                        return `${t1}:${n.x}:${n.y}`;
                    }
                    for(let u = 0; u < t1.length; u++){
                        const c = t1[u], h = c.geometry, p = c.text ? c.text.toString() : null;
                        if (!p) {
                            a(u);
                            continue;
                        }
                        const f = l(p, h), d = l(p, h, !0);
                        if (f in r && d in e && r[f] !== e[d]) {
                            const t1 = o(f, d, h), i = s(f, d, n[t1].geometry);
                            delete e[f], delete r[d], r[l(p, n[i].geometry, !0)] = i, n[t1].geometry = null;
                        } else f in r ? s(f, d, h) : d in e ? o(f, d, h) : (a(u), e[f] = i - 1, r[d] = i - 1);
                    }
                    return n.filter((t1)=>t1.geometry);
                }(this.features)), this.sortFeaturesByKey && this.features.sort((t1, e)=>t1.sortKey - e.sortKey);
            }
            update(t1, e, r, n, i, a, s) {
                this.text.programConfigurations.updatePaintArrays(t1, e, i, r, n, a, s), this.icon.programConfigurations.updatePaintArrays(t1, e, i, r, n, a, s);
            }
            updateZOffset() {
                const t1 = (t1, e, n)=>{
                    r += e, r > t1.length && t1.resize(r);
                    for(let i = -e; i < 0; i++)t1.emplace(i + r, n);
                }, e = (t1, e, r)=>{
                    n += e, n > t1.length && t1.resize(n);
                    for(let i = -e; i < 0; i++)t1.emplace(i + n, r);
                };
                if (!this.zOffsetBuffersNeedUpload) return;
                this.zOffsetBuffersNeedUpload = !1;
                let r = 0, n = 0;
                for(let r = 0; r < this.symbolInstances.length; r++){
                    const n = this.symbolInstances.get(r), { numHorizontalGlyphVertices: i, numVerticalGlyphVertices: a, numIconVertices: s } = n, o = n.zOffset, l = s > 0;
                    if ((i > 0 || a > 0) && (t1(this.text.zOffsetVertexArray, i, o), t1(this.text.zOffsetVertexArray, a, o)), l) {
                        const { placedIconSymbolIndex: t1, verticalPlacedIconSymbolIndex: r } = n;
                        t1 >= 0 && e(this.icon.zOffsetVertexArray, s, o), r >= 0 && e(this.icon.zOffsetVertexArray, n.numVerticalIconVertices, o);
                    }
                }
                this.text.zOffsetVertexBuffer && this.text.zOffsetVertexBuffer.updateData(this.text.zOffsetVertexArray), this.icon.zOffsetVertexBuffer && this.icon.zOffsetVertexBuffer.updateData(this.icon.zOffsetVertexArray);
            }
            isEmpty() {
                return 0 === this.symbolInstances.length && !this.hasRTLText;
            }
            uploadPending() {
                return !this.uploaded || this.text.programConfigurations.needsUpload || this.icon.programConfigurations.needsUpload;
            }
            upload(t1) {
                !this.uploaded && this.hasDebugData() && (this.textCollisionBox.upload(t1), this.iconCollisionBox.upload(t1)), this.text.upload(t1, this.sortFeaturesByY, !this.uploaded, this.text.programConfigurations.needsUpload, this.zOffsetBuffersNeedUpload), this.icon.upload(t1, this.sortFeaturesByY, !this.uploaded, this.icon.programConfigurations.needsUpload, this.zOffsetBuffersNeedUpload), this.uploaded = !0;
            }
            destroyDebugData() {
                this.textCollisionBox.destroy(), this.iconCollisionBox.destroy();
            }
            getProjection() {
                return this.projectionInstance || (this.projectionInstance = $d(this.projection)), this.projectionInstance;
            }
            destroy() {
                this.text.destroy(), this.icon.destroy(), this.hasDebugData() && this.destroyDebugData();
            }
            addToLineVertexArray(t1, e) {
                const r = this.lineVertexArray.length;
                if (void 0 !== t1.segment) for (const { x: t1, y: r } of e)this.lineVertexArray.emplaceBack(t1, r);
                return {
                    lineStartIndex: r,
                    lineLength: this.lineVertexArray.length - r
                };
            }
            addSymbols(t1, e, r, n, i, a, s, o, l, u, c, h, p, f, d, m) {
                const y = t1.indexArray, g = t1.layoutVertexArray, x = t1.globeExtVertexArray, v = t1.segments.prepareSegment(4 * e.length, g, y, this.canOverlap ? a.sortKey : void 0), b = this.glyphOffsetArray.length, _ = v.vertexLength, w = this.allowVerticalPlacement && s === xf.vertical ? Math.PI / 2 : 0, M = a.text && a.text.sections;
                for(let n = 0; n < e.length; n++){
                    const { tl: i, tr: s, bl: u, br: c, texPrimary: h, texSecondary: b, pixelOffsetTL: _, pixelOffsetBR: A, minFontScaleX: S, minFontScaleY: I, glyphOffset: P, isSDF: z, sectionIndex: E } = e[n], k = v.vertexLength, T = P[1];
                    if (Xd(g, l.x, l.y, i.x, T + i.y, h.x, h.y, r, z, _.x, _.y, S, I), Xd(g, l.x, l.y, s.x, T + s.y, h.x + h.w, h.y, r, z, A.x, _.y, S, I), Xd(g, l.x, l.y, u.x, T + u.y, h.x, h.y + h.h, r, z, _.x, A.y, S, I), Xd(g, l.x, l.y, c.x, T + c.y, h.x + h.w, h.y + h.h, r, z, A.x, A.y, S, I), o) {
                        const { x: e, y: r, z: n } = o.anchor, [i, a, s] = o.up;
                        Hd(x, e, r, n, i, a, s), Hd(x, e, r, n, i, a, s), Hd(x, e, r, n, i, a, s), Hd(x, e, r, n, i, a, s), Wd(t1.dynamicLayoutVertexArray, e, r, n, w);
                    } else Wd(t1.dynamicLayoutVertexArray, l.x, l.y, l.z, w);
                    if (m) {
                        const e = b || h;
                        Zd(t1.iconTransitioningVertexArray, e.x, e.y), Zd(t1.iconTransitioningVertexArray, e.x + e.w, e.y), Zd(t1.iconTransitioningVertexArray, e.x, e.y + e.h), Zd(t1.iconTransitioningVertexArray, e.x + e.w, e.y + e.h);
                    }
                    y.emplaceBack(k, k + 1, k + 2), y.emplaceBack(k + 1, k + 2, k + 3), v.vertexLength += 4, v.primitiveLength += 2, this.glyphOffsetArray.emplaceBack(P[0]), n !== e.length - 1 && E === e[n + 1].sectionIndex || t1.programConfigurations.populatePaintArrays(g.length, a, a.index, {}, p, f, d, M && M[E]);
                }
                const A = o ? o.anchor : l;
                t1.placedSymbolArray.emplaceBack(A.x, A.y, A.z, l.x, l.y, b, this.glyphOffsetArray.length - b, _, u, c, l.segment, r ? r[0] : 0, r ? r[1] : 0, n[0], n[1], s, 0, !1, 0, h, 0);
            }
            _commitLayoutVertex(t1, e, r, n, i, a, s) {
                t1.emplaceBack(e, r, n, i, a, Math.round(s.x), Math.round(s.y));
            }
            _addCollisionDebugVertices(t1, e, r, n, i, a, s) {
                const o = r.segments.prepareSegment(4, r.layoutVertexArray, r.indexArray), l = o.vertexLength, u = s.tileAnchorX, c = s.tileAnchorY;
                for(let t1 = 0; t1 < 4; t1++)r.collisionVertexArray.emplaceBack(0, 0, 0, 0, 0, 0);
                this._commitDebugCollisionVertexUpdate(r.collisionVertexArrayExt, e, t1.padding, s.zOffset), this._commitLayoutVertex(r.layoutVertexArray, n, i, a, u, c, new q(t1.x1, t1.y1)), this._commitLayoutVertex(r.layoutVertexArray, n, i, a, u, c, new q(t1.x2, t1.y1)), this._commitLayoutVertex(r.layoutVertexArray, n, i, a, u, c, new q(t1.x2, t1.y2)), this._commitLayoutVertex(r.layoutVertexArray, n, i, a, u, c, new q(t1.x1, t1.y2)), o.vertexLength += 4;
                const h = r.indexArray;
                h.emplaceBack(l, l + 1), h.emplaceBack(l + 1, l + 2), h.emplaceBack(l + 2, l + 3), h.emplaceBack(l + 3, l), o.primitiveLength += 4;
            }
            _addTextDebugCollisionBoxes(t1, e, r, n, i, a) {
                for(let s = n; s < i; s++){
                    const n = r.get(s), i = this.getSymbolInstanceTextSize(t1, a, e, s);
                    this._addCollisionDebugVertices(n, i, this.textCollisionBox, n.projectedAnchorX, n.projectedAnchorY, n.projectedAnchorZ, a);
                }
            }
            _addIconDebugCollisionBoxes(t1, e, r, n, i, a) {
                for(let s = n; s < i; s++){
                    const n = r.get(s), i = this.getSymbolInstanceIconSize(t1, e, a.placedIconSymbolIndex);
                    this._addCollisionDebugVertices(n, i, this.iconCollisionBox, n.projectedAnchorX, n.projectedAnchorY, n.projectedAnchorZ, a);
                }
            }
            generateCollisionDebugBuffers(t1, e, r) {
                this.hasDebugData() && this.destroyDebugData(), this.textCollisionBox = new Qd(Cs, Yp.members, Ts), this.iconCollisionBox = new Qd(Cs, Yp.members, Ts);
                const n = Qp(this.iconSizeData, t1), i = Qp(this.textSizeData, t1, r);
                for(let r = 0; r < this.symbolInstances.length; r++){
                    const a = this.symbolInstances.get(r);
                    this._addTextDebugCollisionBoxes(i, t1, e, a.textBoxStartIndex, a.textBoxEndIndex, a), this._addTextDebugCollisionBoxes(i, t1, e, a.verticalTextBoxStartIndex, a.verticalTextBoxEndIndex, a), this._addIconDebugCollisionBoxes(n, t1, e, a.iconBoxStartIndex, a.iconBoxEndIndex, a), this._addIconDebugCollisionBoxes(n, t1, e, a.verticalIconBoxStartIndex, a.verticalIconBoxEndIndex, a);
                }
            }
            getSymbolInstanceTextSize(t1, e, r, n) {
                const i = this.text.placedSymbolArray.get(e.rightJustifiedTextSymbolIndex >= 0 ? e.rightJustifiedTextSymbolIndex : e.centerJustifiedTextSymbolIndex >= 0 ? e.centerJustifiedTextSymbolIndex : e.leftJustifiedTextSymbolIndex >= 0 ? e.leftJustifiedTextSymbolIndex : e.verticalPlacedTextSymbolIndex >= 0 ? e.verticalPlacedTextSymbolIndex : n), a = Jp(this.textSizeData, t1, i) / Zp;
                return this.tilePixelRatio * a;
            }
            getSymbolInstanceIconSize(t1, e, r) {
                const n = this.icon.placedSymbolArray.get(r), i = Jp(this.iconSizeData, t1, n);
                return this.tilePixelRatio * i;
            }
            _commitDebugCollisionVertexUpdate(t1, e, r, n) {
                t1.emplaceBack(e, -r, -r, n), t1.emplaceBack(e, r, -r, n), t1.emplaceBack(e, r, r, n), t1.emplaceBack(e, -r, r, n);
            }
            _updateTextDebugCollisionBoxes(t1, e, r, n, i, a, s) {
                for(let s = n; s < i; s++){
                    const n = r.get(s), i = this.getSymbolInstanceTextSize(t1, a, e, s);
                    this._commitDebugCollisionVertexUpdate(this.textCollisionBox.collisionVertexArrayExt, i, n.padding, a.zOffset);
                }
            }
            _updateIconDebugCollisionBoxes(t1, e, r, n, i, a, s) {
                for(let s = n; s < i; s++){
                    const n = r.get(s), i = this.getSymbolInstanceIconSize(t1, e, a.placedIconSymbolIndex);
                    this._commitDebugCollisionVertexUpdate(this.iconCollisionBox.collisionVertexArrayExt, i, n.padding, a.zOffset);
                }
            }
            updateCollisionDebugBuffers(t1, e, r, n) {
                if (!this.hasDebugData()) return;
                this.hasTextCollisionBoxData() && this.textCollisionBox.collisionVertexArrayExt.clear(), this.hasIconCollisionBoxData() && this.iconCollisionBox.collisionVertexArrayExt.clear();
                const i = Qp(this.iconSizeData, t1, n), a = Qp(this.textSizeData, t1, r);
                for(let s = 0; s < this.symbolInstances.length; s++){
                    const o = this.symbolInstances.get(s);
                    this._updateTextDebugCollisionBoxes(a, t1, e, o.textBoxStartIndex, o.textBoxEndIndex, o, r), this._updateTextDebugCollisionBoxes(a, t1, e, o.verticalTextBoxStartIndex, o.verticalTextBoxEndIndex, o, r), this._updateIconDebugCollisionBoxes(i, t1, e, o.iconBoxStartIndex, o.iconBoxEndIndex, o, n), this._updateIconDebugCollisionBoxes(i, t1, e, o.verticalIconBoxStartIndex, o.verticalIconBoxEndIndex, o, n);
                }
                this.hasTextCollisionBoxData() && this.textCollisionBox.collisionVertexBufferExt && this.textCollisionBox.collisionVertexBufferExt.updateData(this.textCollisionBox.collisionVertexArrayExt), this.hasIconCollisionBoxData() && this.iconCollisionBox.collisionVertexBufferExt && this.iconCollisionBox.collisionVertexBufferExt.updateData(this.iconCollisionBox.collisionVertexArrayExt);
            }
            _deserializeCollisionBoxesForSymbol(t1, e, r, n, i, a, s, o, l) {
                const u = {};
                if (e < r) {
                    const { x1: r, y1: n, x2: i, y2: a, padding: s, projectedAnchorX: o, projectedAnchorY: l, projectedAnchorZ: c, tileAnchorX: h, tileAnchorY: p, featureIndex: f } = t1.get(e);
                    u.textBox = {
                        x1: r,
                        y1: n,
                        x2: i,
                        y2: a,
                        padding: s,
                        projectedAnchorX: o,
                        projectedAnchorY: l,
                        projectedAnchorZ: c,
                        tileAnchorX: h,
                        tileAnchorY: p
                    }, u.textFeatureIndex = f;
                }
                if (n < i) {
                    const { x1: e, y1: r, x2: i, y2: a, padding: s, projectedAnchorX: o, projectedAnchorY: l, projectedAnchorZ: c, tileAnchorX: h, tileAnchorY: p, featureIndex: f } = t1.get(n);
                    u.verticalTextBox = {
                        x1: e,
                        y1: r,
                        x2: i,
                        y2: a,
                        padding: s,
                        projectedAnchorX: o,
                        projectedAnchorY: l,
                        projectedAnchorZ: c,
                        tileAnchorX: h,
                        tileAnchorY: p
                    }, u.verticalTextFeatureIndex = f;
                }
                if (a < s) {
                    const { x1: e, y1: r, x2: n, y2: i, padding: s, projectedAnchorX: o, projectedAnchorY: l, projectedAnchorZ: c, tileAnchorX: h, tileAnchorY: p, featureIndex: f } = t1.get(a);
                    u.iconBox = {
                        x1: e,
                        y1: r,
                        x2: n,
                        y2: i,
                        padding: s,
                        projectedAnchorX: o,
                        projectedAnchorY: l,
                        projectedAnchorZ: c,
                        tileAnchorX: h,
                        tileAnchorY: p
                    }, u.iconFeatureIndex = f;
                }
                if (o < l) {
                    const { x1: e, y1: r, x2: n, y2: i, padding: a, projectedAnchorX: s, projectedAnchorY: l, projectedAnchorZ: c, tileAnchorX: h, tileAnchorY: p, featureIndex: f } = t1.get(o);
                    u.verticalIconBox = {
                        x1: e,
                        y1: r,
                        x2: n,
                        y2: i,
                        padding: a,
                        projectedAnchorX: s,
                        projectedAnchorY: l,
                        projectedAnchorZ: c,
                        tileAnchorX: h,
                        tileAnchorY: p
                    }, u.verticalIconFeatureIndex = f;
                }
                return u;
            }
            deserializeCollisionBoxes(t1) {
                this.collisionArrays = [];
                for(let e = 0; e < this.symbolInstances.length; e++){
                    const r = this.symbolInstances.get(e);
                    this.collisionArrays.push(this._deserializeCollisionBoxesForSymbol(t1, r.textBoxStartIndex, r.textBoxEndIndex, r.verticalTextBoxStartIndex, r.verticalTextBoxEndIndex, r.iconBoxStartIndex, r.iconBoxEndIndex, r.verticalIconBoxStartIndex, r.verticalIconBoxEndIndex));
                }
            }
            hasTextData() {
                return this.text.segments.get().length > 0;
            }
            hasIconData() {
                return this.icon.segments.get().length > 0;
            }
            hasDebugData() {
                return this.textCollisionBox && this.iconCollisionBox;
            }
            hasTextCollisionBoxData() {
                return this.hasDebugData() && this.textCollisionBox.segments.get().length > 0;
            }
            hasIconCollisionBoxData() {
                return this.hasDebugData() && this.iconCollisionBox.segments.get().length > 0;
            }
            hasIconTextFit() {
                return this.hasAnyIconTextFit;
            }
            addIndicesForPlacedSymbol(t1, e) {
                const r = t1.placedSymbolArray.get(e), n = r.vertexStartIndex + 4 * r.numGlyphs;
                for(let e = r.vertexStartIndex; e < n; e += 4)t1.indexArray.emplaceBack(e, e + 1, e + 2), t1.indexArray.emplaceBack(e + 1, e + 2, e + 3);
            }
            getSortedSymbolIndexes(t1) {
                if (this.sortedAngle === t1 && void 0 !== this.symbolInstanceIndexes) return this.symbolInstanceIndexes;
                const e = Math.sin(t1), r = Math.cos(t1), n = [], i = [], a = [];
                for(let t1 = 0; t1 < this.symbolInstances.length; ++t1){
                    a.push(t1);
                    const s = this.symbolInstances.get(t1);
                    n.push(0 | Math.round(e * s.tileAnchorX + r * s.tileAnchorY)), i.push(s.featureIndex);
                }
                return a.sort((t1, e)=>n[t1] - n[e] || i[e] - i[t1]), a;
            }
            getSortedIndexesByZOffset() {
                if (!this.zOffsetSortDirty) return this.symbolInstanceIndexesSortedZOffset;
                if (!this.symbolInstanceIndexesSortedZOffset) {
                    this.symbolInstanceIndexesSortedZOffset = [];
                    for(let t1 = 0; t1 < this.symbolInstances.length; ++t1)this.symbolInstanceIndexesSortedZOffset.push(t1);
                }
                return this.zOffsetSortDirty = !1, this.symbolInstanceIndexesSortedZOffset.sort((t1, e)=>this.symbolInstances.get(e).zOffset - this.symbolInstances.get(t1).zOffset);
            }
            addToSortKeyRanges(t1, e) {
                const r = this.sortKeyRanges[this.sortKeyRanges.length - 1];
                r && r.sortKey === e ? r.symbolInstanceEnd = t1 + 1 : this.sortKeyRanges.push({
                    sortKey: e,
                    symbolInstanceStart: t1,
                    symbolInstanceEnd: t1 + 1
                });
            }
            sortFeatures(t1) {
                if (this.sortFeaturesByY && this.sortedAngle !== t1 && !(this.text.segments.get().length > 1 || this.icon.segments.get().length > 1)) {
                    this.symbolInstanceIndexes = this.getSortedSymbolIndexes(t1), this.sortedAngle = t1, this.text.indexArray.clear(), this.icon.indexArray.clear(), this.featureSortOrder = [];
                    for (const t1 of this.symbolInstanceIndexes){
                        const e = this.symbolInstances.get(t1);
                        this.featureSortOrder.push(e.featureIndex);
                        const { rightJustifiedTextSymbolIndex: r, centerJustifiedTextSymbolIndex: n, leftJustifiedTextSymbolIndex: i, verticalPlacedTextSymbolIndex: a, placedIconSymbolIndex: s, verticalPlacedIconSymbolIndex: o } = e;
                        r >= 0 && this.addIndicesForPlacedSymbol(this.text, r), n >= 0 && n !== r && this.addIndicesForPlacedSymbol(this.text, n), i >= 0 && i !== n && i !== r && this.addIndicesForPlacedSymbol(this.text, i), a >= 0 && this.addIndicesForPlacedSymbol(this.text, a), s >= 0 && this.addIndicesForPlacedSymbol(this.icon, s), o >= 0 && this.addIndicesForPlacedSymbol(this.icon, o);
                    }
                    this.text.indexBuffer && this.text.indexBuffer.updateData(this.text.indexArray), this.icon.indexBuffer && this.icon.indexBuffer.updateData(this.icon.indexArray);
                }
            }
            constructor(t1){
                this.collisionBoxArray = t1.collisionBoxArray, this.zoom = t1.zoom, this.lut = t1.lut, this.overscaling = t1.overscaling, this.layers = t1.layers, this.layerIds = this.layers.map((t1)=>t1.fqid), this.index = t1.index, this.pixelRatio = t1.pixelRatio, this.sourceLayerIndex = t1.sourceLayerIndex, this.hasPattern = !1, this.hasRTLText = !1, this.fullyClipped = !1, this.hasAnyIconTextFit = !1, this.sortKeyRanges = [], this.collisionCircleArray = [], this.placementInvProjMatrix = O.mat4.identity([]), this.placementViewportMatrix = O.mat4.identity([]);
                const e = this.layers[0]._unevaluatedLayout._values;
                this.textSizeData = Kp(this.zoom, e["text-size"]), this.iconSizeData = Kp(this.zoom, e["icon-size"]);
                const r = this.layers[0].layout, n = r.get("symbol-sort-key"), i = r.get("symbol-z-order");
                this.canOverlap = r.get("text-allow-overlap") || r.get("icon-allow-overlap") || r.get("text-ignore-placement") || r.get("icon-ignore-placement"), this.sortFeaturesByKey = "viewport-y" !== i && void 0 !== n.constantOr(1), this.sortFeaturesByY = ("viewport-y" === i || "auto" === i && !this.sortFeaturesByKey) && this.canOverlap, this.writingModes = r.get("text-writing-mode").map((t1)=>xf[t1]), this.stateDependentLayerIds = this.layers.filter((t1)=>t1.isStateDependent()).map((t1)=>t1.id), this.sourceID = t1.sourceID, this.projection = t1.projection, this.hasAnyZOffset = !1, this.zOffsetSortDirty = !1, this.zOffsetBuffersNeedUpload = r.get("symbol-z-elevate"), this.activeReplacements = [], this.replacementUpdateTime = 0;
            }
        }
        let em, rm, nm;
        oa(tm, "SymbolBucket", {
            omit: [
                "layers",
                "collisionBoxArray",
                "features",
                "compareText"
            ]
        }), tm.addDynamicAttributes = Wd;
        class im {
            evaluate(t1) {
                if (t1.formattedSection) {
                    const e = this.defaultValue.property.overrides;
                    if (e && e.hasOverride(t1.formattedSection)) return e.getOverride(t1.formattedSection);
                }
                return t1.feature && t1.featureState ? this.defaultValue.evaluate(t1.feature, t1.featureState) : this.defaultValue.property.specification.default;
            }
            eachChild(t1) {
                this.defaultValue.isConstant() || t1(this.defaultValue.value._styleExpression.expression);
            }
            outputDefined() {
                return !1;
            }
            serialize() {
                return null;
            }
            constructor(t1){
                this.type = t1.property.overrides ? t1.property.overrides.runtimeType : Ve, this.defaultValue = t1;
            }
        }
        oa(im, "FormatSectionOverride", {
            omit: [
                "defaultValue"
            ]
        });
        const am = ()=>nm || (nm = {
                layout: em || (em = new Ga({
                    "symbol-placement": new ja(Ya.layout_symbol["symbol-placement"]),
                    "symbol-spacing": new ja(Ya.layout_symbol["symbol-spacing"]),
                    "symbol-avoid-edges": new ja(Ya.layout_symbol["symbol-avoid-edges"]),
                    "symbol-sort-key": new qa(Ya.layout_symbol["symbol-sort-key"]),
                    "symbol-z-order": new ja(Ya.layout_symbol["symbol-z-order"]),
                    "symbol-z-elevate": new ja(Ya.layout_symbol["symbol-z-elevate"]),
                    "symbol-elevation-reference": new ja(Ya.layout_symbol["symbol-elevation-reference"]),
                    "icon-allow-overlap": new ja(Ya.layout_symbol["icon-allow-overlap"]),
                    "icon-ignore-placement": new ja(Ya.layout_symbol["icon-ignore-placement"]),
                    "icon-optional": new ja(Ya.layout_symbol["icon-optional"]),
                    "icon-rotation-alignment": new ja(Ya.layout_symbol["icon-rotation-alignment"]),
                    "icon-size": new qa(Ya.layout_symbol["icon-size"]),
                    "icon-size-scale-range": new ja(Ya.layout_symbol["icon-size-scale-range"]),
                    "icon-text-fit": new qa(Ya.layout_symbol["icon-text-fit"]),
                    "icon-text-fit-padding": new qa(Ya.layout_symbol["icon-text-fit-padding"]),
                    "icon-image": new qa(Ya.layout_symbol["icon-image"]),
                    "icon-rotate": new qa(Ya.layout_symbol["icon-rotate"]),
                    "icon-padding": new ja(Ya.layout_symbol["icon-padding"]),
                    "icon-keep-upright": new ja(Ya.layout_symbol["icon-keep-upright"]),
                    "icon-offset": new qa(Ya.layout_symbol["icon-offset"]),
                    "icon-anchor": new qa(Ya.layout_symbol["icon-anchor"]),
                    "icon-pitch-alignment": new ja(Ya.layout_symbol["icon-pitch-alignment"]),
                    "text-pitch-alignment": new ja(Ya.layout_symbol["text-pitch-alignment"]),
                    "text-rotation-alignment": new ja(Ya.layout_symbol["text-rotation-alignment"]),
                    "text-field": new qa(Ya.layout_symbol["text-field"]),
                    "text-font": new qa(Ya.layout_symbol["text-font"]),
                    "text-size": new qa(Ya.layout_symbol["text-size"]),
                    "text-size-scale-range": new ja(Ya.layout_symbol["text-size-scale-range"]),
                    "text-max-width": new qa(Ya.layout_symbol["text-max-width"]),
                    "text-line-height": new qa(Ya.layout_symbol["text-line-height"]),
                    "text-letter-spacing": new qa(Ya.layout_symbol["text-letter-spacing"]),
                    "text-justify": new qa(Ya.layout_symbol["text-justify"]),
                    "text-radial-offset": new qa(Ya.layout_symbol["text-radial-offset"]),
                    "text-variable-anchor": new ja(Ya.layout_symbol["text-variable-anchor"]),
                    "text-anchor": new qa(Ya.layout_symbol["text-anchor"]),
                    "text-max-angle": new ja(Ya.layout_symbol["text-max-angle"]),
                    "text-writing-mode": new ja(Ya.layout_symbol["text-writing-mode"]),
                    "text-rotate": new qa(Ya.layout_symbol["text-rotate"]),
                    "text-padding": new ja(Ya.layout_symbol["text-padding"]),
                    "text-keep-upright": new ja(Ya.layout_symbol["text-keep-upright"]),
                    "text-transform": new qa(Ya.layout_symbol["text-transform"]),
                    "text-offset": new qa(Ya.layout_symbol["text-offset"]),
                    "text-allow-overlap": new ja(Ya.layout_symbol["text-allow-overlap"]),
                    "text-ignore-placement": new ja(Ya.layout_symbol["text-ignore-placement"]),
                    "text-optional": new ja(Ya.layout_symbol["text-optional"]),
                    visibility: new ja(Ya.layout_symbol.visibility)
                })),
                paint: rm || (rm = new Ga({
                    "icon-opacity": new qa(Ya.paint_symbol["icon-opacity"]),
                    "icon-occlusion-opacity": new qa(Ya.paint_symbol["icon-occlusion-opacity"]),
                    "icon-emissive-strength": new qa(Ya.paint_symbol["icon-emissive-strength"]),
                    "text-emissive-strength": new qa(Ya.paint_symbol["text-emissive-strength"]),
                    "icon-color": new qa(Ya.paint_symbol["icon-color"]),
                    "icon-halo-color": new qa(Ya.paint_symbol["icon-halo-color"]),
                    "icon-halo-width": new qa(Ya.paint_symbol["icon-halo-width"]),
                    "icon-halo-blur": new qa(Ya.paint_symbol["icon-halo-blur"]),
                    "icon-translate": new ja(Ya.paint_symbol["icon-translate"]),
                    "icon-translate-anchor": new ja(Ya.paint_symbol["icon-translate-anchor"]),
                    "icon-image-cross-fade": new qa(Ya.paint_symbol["icon-image-cross-fade"]),
                    "text-opacity": new qa(Ya.paint_symbol["text-opacity"]),
                    "text-occlusion-opacity": new qa(Ya.paint_symbol["text-occlusion-opacity"]),
                    "text-color": new qa(Ya.paint_symbol["text-color"], {
                        runtimeType: Fe,
                        getOverride: (t1)=>t1.textColor,
                        hasOverride: (t1)=>!!t1.textColor
                    }),
                    "text-halo-color": new qa(Ya.paint_symbol["text-halo-color"]),
                    "text-halo-width": new qa(Ya.paint_symbol["text-halo-width"]),
                    "text-halo-blur": new qa(Ya.paint_symbol["text-halo-blur"]),
                    "text-translate": new ja(Ya.paint_symbol["text-translate"]),
                    "text-translate-anchor": new ja(Ya.paint_symbol["text-translate-anchor"]),
                    "icon-color-saturation": new ja(Ya.paint_symbol["icon-color-saturation"]),
                    "icon-color-contrast": new ja(Ya.paint_symbol["icon-color-contrast"]),
                    "icon-color-brightness-min": new ja(Ya.paint_symbol["icon-color-brightness-min"]),
                    "icon-color-brightness-max": new ja(Ya.paint_symbol["icon-color-brightness-max"]),
                    "symbol-z-offset": new qa(Ya.paint_symbol["symbol-z-offset"]),
                    "icon-color-use-theme": new qa({
                        type: "string",
                        default: "default",
                        "property-type": "data-driven"
                    }),
                    "icon-halo-color-use-theme": new qa({
                        type: "string",
                        default: "default",
                        "property-type": "data-driven"
                    }),
                    "text-color-use-theme": new qa({
                        type: "string",
                        default: "default",
                        "property-type": "data-driven"
                    }),
                    "text-halo-color-use-theme": new qa({
                        type: "string",
                        default: "default",
                        "property-type": "data-driven"
                    })
                }))
            }, nm);
        class sm extends ps {
            recalculate(t1, e) {
                super.recalculate(t1, e), "auto" === this.layout.get("icon-rotation-alignment") && (this.layout._values["icon-rotation-alignment"] = "point" !== this.layout.get("symbol-placement") ? "map" : "viewport"), "auto" === this.layout.get("text-rotation-alignment") && (this.layout._values["text-rotation-alignment"] = "point" !== this.layout.get("symbol-placement") ? "map" : "viewport"), "auto" === this.layout.get("text-pitch-alignment") && (this.layout._values["text-pitch-alignment"] = this.layout.get("text-rotation-alignment")), "auto" === this.layout.get("icon-pitch-alignment") && (this.layout._values["icon-pitch-alignment"] = this.layout.get("icon-rotation-alignment"));
                const r = this.layout.get("text-writing-mode");
                if (r) {
                    const t1 = [];
                    for (const e of r)t1.indexOf(e) < 0 && t1.push(e);
                    this.layout._values["text-writing-mode"] = t1;
                } else this.layout._values["text-writing-mode"] = "point" === this.layout.get("symbol-placement") ? [
                    "horizontal"
                ] : [
                    "horizontal",
                    "vertical"
                ];
                this._setPaintOverrides();
            }
            getColorAdjustmentMatrix(t1, e, r, n) {
                return this._saturation === t1 && this._contrast === e && this._brightnessMin === r && this._brightnessMax === n || (this._colorAdjustmentMatrix = function(t1, e, r, n) {
                    t1 = At(t1), e = Mt(e);
                    const i = O.mat4.create(), a = t1 / 3, s = 1 - 2 * a, o = [
                        s,
                        a,
                        a,
                        0,
                        a,
                        s,
                        a,
                        0,
                        a,
                        a,
                        s,
                        0,
                        0,
                        0,
                        0,
                        1
                    ], l = .5 - .5 * e, u = n - r;
                    return O.mat4.multiply(i, [
                        u,
                        0,
                        0,
                        0,
                        0,
                        u,
                        0,
                        0,
                        0,
                        0,
                        u,
                        0,
                        r,
                        r,
                        r,
                        1
                    ], [
                        e,
                        0,
                        0,
                        0,
                        0,
                        e,
                        0,
                        0,
                        0,
                        0,
                        e,
                        0,
                        l,
                        l,
                        l,
                        1
                    ]), O.mat4.multiply(i, i, o), i;
                }(t1, e, r, n), this._saturation = t1, this._contrast = e, this._brightnessMin = r, this._brightnessMax = n), this._colorAdjustmentMatrix;
            }
            getValueAndResolveTokens(t1, e, r, n) {
                const i = this.layout.get(t1).evaluate(e, {}, r, n), a = this._unevaluatedLayout._values[t1];
                return a.isDataDriven() || Hi(a.value) || !i ? i : function(t1, e) {
                    return e.replace(/{([^{}]+)}/g, (e, r)=>r in t1 ? String(t1[r]) : "");
                }(e.properties, i);
            }
            createBucket(t1) {
                return new tm(t1);
            }
            queryRadius() {
                return 0;
            }
            queryIntersectsFeature() {
                return !1;
            }
            _setPaintOverrides() {
                for (const t1 of am().paint.overridableProperties){
                    if (!sm.hasPaintOverride(this.layout, t1)) continue;
                    const e = this.paint.get(t1), r = new im(e), n = new Zi(r, e.property.specification, this.scope, this.options);
                    let i = null;
                    i = "constant" === e.value.kind || "source" === e.value.kind ? new Ki("source", n) : new Ji("composite", n, e.value.zoomStops, e.value._interpolationType), this.paint._values[t1] = new Na(e.property, i, e.parameters);
                }
            }
            _handleOverridablePaintPropertyUpdate(t1, e, r) {
                return !(!this.layout || e.isDataDriven() || r.isDataDriven()) && sm.hasPaintOverride(this.layout, t1);
            }
            static hasPaintOverride(t1, e) {
                const r = t1.get("text-field"), n = am().paint.properties[e];
                let i = !1;
                const a = (t1)=>{
                    for (const e of t1)if (n.overrides && n.overrides.hasOverride(e)) return void (i = !0);
                };
                if ("constant" === r.value.kind && r.value.value instanceof Je) a(r.value.value.sections);
                else if ("source" === r.value.kind) {
                    const t1 = (e)=>{
                        i || (e instanceof ar && nr(e.value) === je ? a(e.value.sections) : e instanceof ur ? a(e.sections) : e.eachChild(t1));
                    }, e = r.value;
                    e._styleExpression && t1(e._styleExpression.expression);
                }
                return i;
            }
            getProgramIds() {
                return [
                    "symbol"
                ];
            }
            getDefaultProgramParams(t1, e, r) {
                return {
                    config: new Oo(this, {
                        zoom: e,
                        lut: r
                    }),
                    overrideFog: !1
                };
            }
            constructor(t1, e, r, n){
                super(t1, am(), e, r, n), this._colorAdjustmentMatrix = O.mat4.identity([]), this.hasInitialOcclusionOpacityProperties = void 0 !== t1.paint && ("icon-occlusion-opacity" in t1.paint || "text-occlusion-opacity" in t1.paint);
            }
        }
        let om, lm, um, cm;
        var hm = ys([
            {
                name: "a_pos",
                type: "Int16",
                components: 2
            },
            {
                name: "a_texture_pos",
                type: "Int16",
                components: 2
            }
        ]);
        function pm(t1) {
            switch(t1){
                case WebGL2RenderingContext.RGBA8:
                    return WebGL2RenderingContext.RGBA;
                case WebGL2RenderingContext.DEPTH_COMPONENT16:
                    return WebGL2RenderingContext.DEPTH_COMPONENT;
                case WebGL2RenderingContext.DEPTH24_STENCIL8:
                    return WebGL2RenderingContext.DEPTH_STENCIL;
                case WebGL2RenderingContext.R8:
                case WebGL2RenderingContext.R32F:
                    return WebGL2RenderingContext.RED;
            }
        }
        function fm(t1) {
            switch(t1){
                case WebGL2RenderingContext.RGBA8:
                    return WebGL2RenderingContext.UNSIGNED_BYTE;
                case WebGL2RenderingContext.DEPTH_COMPONENT16:
                    return WebGL2RenderingContext.UNSIGNED_SHORT;
                case WebGL2RenderingContext.DEPTH24_STENCIL8:
                    return WebGL2RenderingContext.UNSIGNED_INT_24_8;
                case WebGL2RenderingContext.R8:
                    return WebGL2RenderingContext.UNSIGNED_BYTE;
                case WebGL2RenderingContext.R32F:
                    return WebGL2RenderingContext.FLOAT;
            }
        }
        class dm {
            update(t1, e) {
                const r = t1 && t1 instanceof HTMLVideoElement && 0 === t1.width ? t1.videoWidth : t1.width, n = t1 && t1 instanceof HTMLVideoElement && 0 === t1.height ? t1.videoHeight : t1.height, { context: i } = this, { gl: a } = i, { x: s, y: o } = e && e.position ? e.position : {
                    x: 0,
                    y: 0
                }, l = s + r, u = o + n;
                !this.size || this.size[0] === l && this.size[1] === u || (a.bindTexture(a.TEXTURE_2D, null), a.deleteTexture(this.texture), this.texture = a.createTexture(), this.size = null), a.bindTexture(a.TEXTURE_2D, this.texture), i.pixelStoreUnpackFlipY.set(!1), i.pixelStoreUnpack.set(1), i.pixelStoreUnpackPremultiplyAlpha.set(this.format === a.RGBA8 && (!e || !1 !== e.premultiply));
                const c = t1 instanceof HTMLImageElement || t1 instanceof HTMLCanvasElement || t1 instanceof HTMLVideoElement || t1 instanceof ImageData || ImageBitmap && t1 instanceof ImageBitmap;
                if (!this.size && l > 0 && u > 0) {
                    const t1 = this.useMipmap ? Math.floor(Math.log2(Math.max(l, u))) + 1 : 1;
                    a.texStorage2D(a.TEXTURE_2D, t1, this.format, l, u), this.size = [
                        l,
                        u
                    ];
                }
                if (this.size) {
                    if (c) a.texSubImage2D(a.TEXTURE_2D, 0, s, o, pm(this.format), fm(this.format), t1);
                    else {
                        const e = t1.data;
                        e && a.texSubImage2D(a.TEXTURE_2D, 0, s, o, r, n, pm(this.format), fm(this.format), e);
                    }
                }
                this.useMipmap && a.generateMipmap(a.TEXTURE_2D);
            }
            bind(t1, e, r = !1) {
                const { context: n } = this, { gl: i } = n;
                i.bindTexture(i.TEXTURE_2D, this.texture), t1 !== this.minFilter && (i.texParameteri(i.TEXTURE_2D, i.TEXTURE_MAG_FILTER, t1), i.texParameteri(i.TEXTURE_2D, i.TEXTURE_MIN_FILTER, this.useMipmap && !r ? t1 === i.NEAREST ? i.NEAREST_MIPMAP_NEAREST : i.LINEAR_MIPMAP_LINEAR : t1), this.minFilter = t1), e !== this.wrapS && (i.texParameteri(i.TEXTURE_2D, i.TEXTURE_WRAP_S, e), i.texParameteri(i.TEXTURE_2D, i.TEXTURE_WRAP_T, e), this.wrapS = e);
            }
            bindExtraParam(t1, e, r, n) {
                const { context: i } = this, { gl: a } = i;
                a.bindTexture(a.TEXTURE_2D, this.texture), e !== this.magFilter && (a.texParameteri(a.TEXTURE_2D, a.TEXTURE_MAG_FILTER, e), this.magFilter = e), t1 !== this.minFilter && (a.texParameteri(a.TEXTURE_2D, a.TEXTURE_MIN_FILTER, this.useMipmap ? t1 === a.NEAREST ? a.NEAREST_MIPMAP_NEAREST : a.LINEAR_MIPMAP_LINEAR : t1), this.minFilter = t1), r !== this.wrapS && (a.texParameteri(a.TEXTURE_2D, a.TEXTURE_WRAP_S, r), this.wrapS = r), n !== this.wrapT && (a.texParameteri(a.TEXTURE_2D, a.TEXTURE_WRAP_T, n), this.wrapT = n);
            }
            destroy() {
                const { gl: t1 } = this.context;
                t1.deleteTexture(this.texture), this.texture = null;
            }
            constructor(t1, e, r, n){
                this.context = t1, this.format = r, this.useMipmap = n && n.useMipmap, this.texture = t1.gl.createTexture(), this.update(e, {
                    premultiply: n && n.premultiply
                });
            }
        }
        class mm {
            bind(t1, e) {
                const { context: r } = this, { gl: n } = r;
                n.bindTexture(n.TEXTURE_2D, this.texture), t1 !== this.minFilter && (n.texParameteri(n.TEXTURE_2D, n.TEXTURE_MAG_FILTER, t1), n.texParameteri(n.TEXTURE_2D, n.TEXTURE_MIN_FILTER, t1), this.minFilter = t1), e !== this.wrapS && (n.texParameteri(n.TEXTURE_2D, n.TEXTURE_WRAP_S, e), n.texParameteri(n.TEXTURE_2D, n.TEXTURE_WRAP_T, e), this.wrapS = e);
            }
            constructor(t1, e){
                this.context = t1, this.texture = e;
            }
        }
        function ym(t1, e, r, n, i, a, s, o) {
            const l = [
                t1,
                e,
                1,
                r,
                n,
                1,
                i,
                a,
                1
            ], u = [
                s,
                o,
                1
            ], c = O.mat3.adjoint([], l), [h, p, f] = O.vec3.transformMat3(u, u, c);
            return O.mat3.multiply(l, l, [
                h,
                0,
                0,
                0,
                p,
                0,
                0,
                0,
                f
            ]);
        }
        function gm(t1, e, r, n, i, a, s, o) {
            const l = function(t1, e, r, n, i, a, s, o) {
                const l = ym(0, 0, 1, 0, 1, 1, 0, 1), u = ym(t1, e, r, n, i, a, s, o), c = O.mat3.adjoint([], l);
                return O.mat3.multiply(u, u, c);
            }(t1, e, r, n, i, a, s, o);
            return [
                l[2] / l[8] / Wr,
                l[5] / l[8] / Wr
            ];
        }
        function xm(t1) {
            return [
                t1[0],
                Math.min(Math.max(t1[1], -ml), ml)
            ];
        }
        class vm extends we {
            load(t1, e) {
                if (this._loaded = e || !1, this.fire(new xe("dataloading", {
                    dataType: "source"
                })), this.url = this.options.url, !this.url) return t1 && (this.coordinates = t1), this._loaded = !0, void this._finishLoading();
                this._imageRequest = ue(this.map._requestManager.transformRequest(this.url, te.Image), (e, r)=>{
                    this._imageRequest = null, this._loaded = !0, e ? this.fire(new ve(e)) : r && (this.image = r instanceof HTMLImageElement ? Dt.getImageData(r) : r, this._dirty = !0, this.width = this.image.width, this.height = this.image.height, t1 && (this.coordinates = t1), this._finishLoading());
                });
            }
            loaded() {
                return this._loaded;
            }
            updateImage(t1) {
                return t1.url ? (this._imageRequest && t1.url !== this.options.url && (this._imageRequest.cancel(), this._imageRequest = null), this.options.url = t1.url, this.load(t1.coordinates, this._loaded), this) : this;
            }
            setTexture(t1) {
                if (!(t1.handle instanceof WebGLTexture)) throw new Error("The provided handle is not a WebGLTexture instance");
                return this.texture = new mm(this.map.painter.context, t1.handle), this.width = t1.dimensions[0], this.height = t1.dimensions[1], this._dirty = !1, this._loaded = !0, this._finishLoading(), this;
            }
            _finishLoading() {
                this.map && (this.setCoordinates(this.coordinates), this.fire(new xe("data", {
                    dataType: "source",
                    sourceDataType: "metadata"
                })));
            }
            onAdd(t1) {
                this.map = t1, this.load();
            }
            onRemove(t1) {
                this._imageRequest && (this._imageRequest.cancel(), this._imageRequest = null), !this.texture || this.texture instanceof mm || this.texture.destroy(), this.boundsBuffer && (this.boundsBuffer.destroy(), this.elevatedGlobeVertexBuffer && this.elevatedGlobeVertexBuffer.destroy(), this.elevatedGlobeIndexBuffer && this.elevatedGlobeIndexBuffer.destroy());
            }
            setCoordinates(t1) {
                if (this.coordinates = t1, this._boundsArray = void 0, this._unsupportedCoords = !1, !t1.length) return this;
                this.onNorthPole = !1, this.onSouthPole = !1;
                let e = t1[0][1], r = t1[0][1];
                for (const n of t1)n[1] > r && (r = n[1]), n[1] < e && (e = n[1]);
                const n = (r + e) / 2;
                if (n > ml ? this.onNorthPole = !0 : n < -ml && (this.onSouthPole = !0), !this.onNorthPole && !this.onSouthPole) {
                    const e = t1.map(bl.fromLngLat);
                    this.tileID = function(t1) {
                        let e = 1 / 0, r = 1 / 0, n = -1 / 0, i = -1 / 0;
                        for (const a of t1)e = Math.min(e, a.x), r = Math.min(r, a.y), n = Math.max(n, a.x), i = Math.max(i, a.y);
                        const a = Math.max(n - e, i - r), s = Math.max(0, Math.floor(-Math.log(a) / Math.LN2)), o = Math.pow(2, s);
                        let l = Math.floor((e + n) / 2 * o);
                        return l > 1 && (l -= 1), new ru(s, l, Math.floor((r + i) / 2 * o));
                    }(e), this.minzoom = this.maxzoom = this.tileID.z;
                }
                return this.fire(new xe("data", {
                    dataType: "source",
                    sourceDataType: "content"
                })), this;
            }
            _clear() {
                this._boundsArray = void 0, this._unsupportedCoords = !1;
            }
            _prepareData(t1) {
                for(const t1 in this.tiles){
                    const e = this.tiles[t1];
                    "loaded" !== e.state && (e.state = "loaded", e.texture = this.texture);
                }
                if (this._boundsArray || this.onNorthPole || this.onSouthPole || this._unsupportedCoords) return;
                const e = wd(new ru(0, 0, 0), this.map.transform.projection), r = [
                    e.projection.project(this.coordinates[0][0], this.coordinates[0][1]),
                    e.projection.project(this.coordinates[1][0], this.coordinates[1][1]),
                    e.projection.project(this.coordinates[2][0], this.coordinates[2][1]),
                    e.projection.project(this.coordinates[3][0], this.coordinates[3][1])
                ];
                if (!function(t1) {
                    const e = t1[1].x - t1[0].x, r = t1[1].y - t1[0].y, n = t1[2].x - t1[1].x, i = t1[2].y - t1[1].y, a = t1[3].x - t1[2].x, s = t1[3].y - t1[2].y, o = t1[0].x - t1[3].x, l = t1[0].y - t1[3].y, u = e * i - n * r, c = n * s - a * i, h = a * l - o * s, p = o * r - e * l;
                    return u > 0 && c > 0 && h > 0 && p > 0 || u < 0 && c < 0 && h < 0 && p < 0;
                }(r)) return console.warn("Image source coordinates are defining non-convex area in the Mercator projection"), void (this._unsupportedCoords = !0);
                const n = wd(this.tileID, this.map.transform.projection), [i, a, s, o] = this.coordinates.map((t1)=>{
                    const e = n.projection.project(t1[0], t1[1]);
                    return Md(n, e)._round();
                });
                this.perspectiveTransform = gm(i.x, i.y, a.x, a.y, s.x, s.y, o.x, o.y);
                const l = this._boundsArray = new bs;
                l.emplaceBack(i.x, i.y, 0, 0), l.emplaceBack(a.x, a.y, Wr, 0), l.emplaceBack(o.x, o.y, 0, Wr), l.emplaceBack(s.x, s.y, Wr, Wr), this.boundsBuffer && (this.boundsBuffer.destroy(), this.elevatedGlobeVertexBuffer && this.elevatedGlobeVertexBuffer.destroy(), this.elevatedGlobeIndexBuffer && this.elevatedGlobeIndexBuffer.destroy()), this.boundsBuffer = t1.createVertexBuffer(l, hm.members), this.boundsSegments = po.simpleSegment(0, 0, 4, 2);
                const u = [], c = [
                    xm((h = this.coordinates)[0]),
                    xm(h[1]),
                    xm(h[2]),
                    xm(h[3])
                ];
                var h;
                const [p, f, d, m] = function(t1) {
                    let e = t1[0][0], r = e, n = t1[0][1], i = n;
                    for(let a = 1; a < t1.length; a++)t1[a][0] < e ? e = t1[a][0] : t1[a][0] > r && (r = t1[a][0]), t1[a][1] < n ? n = t1[a][1] : t1[a][1] > i && (i = t1[a][1]);
                    return [
                        e,
                        n,
                        r - e,
                        i - n
                    ];
                }(c);
                {
                    const n = new bs, [i, a, s, o] = function(t1) {
                        let e = t1[0].x, r = e, n = t1[0].y, i = n;
                        for(let a = 1; a < t1.length; a++)t1[a].x < e ? e = t1[a].x : t1[a].x > r && (r = t1[a].x), t1[a].y < n ? n = t1[a].y : t1[a].y > i && (i = t1[a].y);
                        return [
                            e,
                            n,
                            r - e,
                            i - n
                        ];
                    }(r), l = (t1)=>[
                            (t1.x - i) / s,
                            (t1.y - a) / o
                        ], [c, h, y, g] = r.map(l), x = function(t1, e, r, n, i, a, s, o) {
                        const l = ym(0, 0, 1, 0, 1, 1, 0, 1), u = ym(t1, e, r, n, i, a, s, o), c = O.mat3.adjoint([], u);
                        return O.mat3.multiply(l, l, c);
                    }(c[0], c[1], h[0], h[1], y[0], y[1], g[0], g[1]);
                    this.elevatedGlobePerspectiveTransform = gm(c[0], c[1], h[0], h[1], y[0], y[1], g[0], g[1]);
                    const v = (t1, e)=>{
                        u.push(t1.lng);
                        const r = Math.round((t1.lng - p) / d * Wr), i = Math.round((t1.lat - f) / m * Wr), a = l(e), s = O.vec3.transformMat3([], [
                            a[0],
                            a[1],
                            1
                        ], x), o = Math.round(s[0] / s[2] * Wr), c = Math.round(s[1] / s[2] * Wr);
                        n.emplaceBack(r, i, o, c);
                    }, b = r[3].x - r[0].x, _ = r[3].y - r[0].y, w = r[2].x - r[1].x, M = r[2].y - r[1].y;
                    for(let t1 = 0; t1 < 65; t1++){
                        const n = t1 / 64, i = [
                            r[0].x + n * b,
                            r[0].y + n * _
                        ], a = [
                            r[1].x + n * w,
                            r[1].y + n * M
                        ], s = a[0] - i[0], o = a[1] - i[1];
                        for(let t1 = 0; t1 < 65; t1++){
                            const r = t1 / 64, n = {
                                x: i[0] + s * r,
                                y: i[1] + o * r,
                                z: 0
                            };
                            v(e.projection.unproject(n.x, n.y), n);
                        }
                    }
                    this.elevatedGlobeVertexBuffer = t1.createVertexBuffer(n, hm.members);
                }
                {
                    this.maxLongitudeTriangleSize = 0;
                    let e = [], r = new Ls;
                    const n = (t1, n, i)=>{
                        r.emplaceBack(t1, n, i);
                        const a = u[t1], s = u[n], o = u[i], l = Math.min(Math.min(a, s), o), c = Math.max(Math.max(a, s), o) - l;
                        c > this.maxLongitudeTriangleSize && (this.maxLongitudeTriangleSize = c), e.push(l + c / 2);
                    };
                    for(let t1 = 0; t1 < 64; t1++)for(let e = 0; e < 64; e++){
                        const r = 65 * t1 + e, i = r + 1, a = r + 65, s = a + 1;
                        n(r, a, i), n(i, a, s);
                    }
                    [e, r] = function(t1, e) {
                        const r = Array.from({
                            length: t1.length
                        }, (t1, e)=>e);
                        r.sort((e, r)=>t1[e] - t1[r]);
                        const n = [], i = new Ls;
                        for(let a = 0; a < r.length; a++){
                            const s = r[a];
                            n.push(t1[s]);
                            const o = 3 * s, l = o + 1;
                            i.emplaceBack(e.uint16[o], e.uint16[l], e.uint16[l + 1]);
                        }
                        return [
                            n,
                            i
                        ];
                    }(e, r), this.elevatedGlobeTrianglesCenterLongitudes = e, this.elevatedGlobeIndexBuffer = t1.createIndexBuffer(r);
                }
                this.elevatedGlobeSegments = po.simpleSegment(0, 0, 4225, 8192), this.elevatedGlobeGridMatrix = new Float32Array([
                    0,
                    d / Wr,
                    0,
                    m / Wr,
                    0,
                    0,
                    f,
                    p,
                    0
                ]);
            }
            prepare() {
                const t1 = 0 !== Object.keys(this.tiles).length;
                if (this.tileID && !t1) return;
                const e = this.map.painter.context, r = e.gl;
                !this._dirty || this.texture instanceof mm || (this.texture ? this.texture.update(this.image) : (this.texture = new dm(e, this.image, r.RGBA8), this.texture.bind(r.LINEAR, r.CLAMP_TO_EDGE)), this._dirty = !1), t1 && this._prepareData(e);
            }
            loadTile(t1, e) {
                this.tileID && this.tileID.equals(t1.tileID.canonical) ? (this.tiles[String(t1.tileID.wrap)] = t1, t1.buckets = {}, e(null)) : (t1.state = "errored", e(null));
            }
            serialize() {
                return {
                    type: "image",
                    url: this.options.url,
                    coordinates: this.coordinates
                };
            }
            hasTransition() {
                return !1;
            }
            getSegmentsForLongitude(t1) {
                const e = this.elevatedGlobeSegments;
                if (!this.elevatedGlobeTrianglesCenterLongitudes || !e) return null;
                const r = this.elevatedGlobeTrianglesCenterLongitudes;
                let n = (i = t1 + 180) + 360 * Math.round((r[0] - i) / 360);
                var i;
                const a = new po, s = (t1, r)=>{
                    a.segments.push({
                        vertexOffset: 0,
                        primitiveOffset: t1,
                        vertexLength: e.segments[0].vertexLength,
                        primitiveLength: r,
                        sortKey: void 0,
                        vaos: {}
                    });
                }, o = .51 * this.maxLongitudeTriangleSize;
                if (Math.abs(r[0] - n) <= o) {
                    const t1 = wt(r, 0, r.length, n + o);
                    return t1 === r.length || s(t1, _t(r, t1 + 1, r.length, n + 360 - o) - t1), a;
                }
                n < r[0] && (n += 360);
                const l = _t(r, 0, r.length, n - o);
                if (l === r.length) return s(0, r.length), a;
                s(0, l - 0);
                const u = wt(r, l + 1, r.length, n + o);
                return u !== r.length && s(u, r.length - u), a;
            }
            constructor(t1, e, r, n){
                super(), this.id = t1, this.dispatcher = r, this.coordinates = e.coordinates, this.type = "image", this.minzoom = 0, this.maxzoom = 22, this.tileSize = 512, this.tiles = {}, this._loaded = !1, this.onNorthPole = !1, this.onSouthPole = !1, this.setEventedParent(n), this.options = e, this._dirty = !1;
            }
        }
        const bm = (Math.pow(256, 2) - 1) / 16907520;
        class _m extends ps {
            getProgramIds() {
                return [
                    "raster"
                ];
            }
            hasColorMap() {
                return !!this._transitionablePaint._values["raster-color"].value.value;
            }
            tileCoverLift() {
                return this.paint.get("raster-elevation");
            }
            isDraped(t1) {
                return !(t1 && t1._source instanceof vm && (t1._source.onNorthPole || t1._source.onSouthPole)) && 0 === this.paint.get("raster-elevation");
            }
            _handleSpecialPaintPropertyUpdate(t1) {
                "raster-color" !== t1 && "raster-color-range" !== t1 || (this._curRampRange = [
                    NaN,
                    NaN
                ], this.updateColorRamp());
            }
            updateColorRamp(t1) {
                if (!this.hasColorMap()) return;
                if (!this._curRampRange) return;
                const e = this._transitionablePaint._values["raster-color"].value.expression, [r, n] = t1 || this._transitionablePaint._values["raster-color-range"].value.expression.evaluate({
                    zoom: 0
                }) || [
                    NaN,
                    NaN
                ];
                isNaN(r) && isNaN(n) || r === this._curRampRange[0] && n === this._curRampRange[1] || (this.colorRamp = lc({
                    expression: e,
                    evaluationKey: "rasterValue",
                    image: this.colorRamp,
                    clips: [
                        {
                            start: r,
                            end: n
                        }
                    ],
                    resolution: 256
                }), this.colorRampTexture = null, this._curRampRange = [
                    r,
                    n
                ]);
            }
            constructor(t1, e, r, n){
                super(t1, {
                    layout: um || (um = new Ga({
                        visibility: new ja(Ya.layout_raster.visibility)
                    })),
                    paint: cm || (cm = new Ga({
                        "raster-opacity": new ja(Ya.paint_raster["raster-opacity"]),
                        "raster-color": new $a(Ya.paint_raster["raster-color"]),
                        "raster-color-mix": new ja(Ya.paint_raster["raster-color-mix"]),
                        "raster-color-range": new ja(Ya.paint_raster["raster-color-range"]),
                        "raster-hue-rotate": new ja(Ya.paint_raster["raster-hue-rotate"]),
                        "raster-brightness-min": new ja(Ya.paint_raster["raster-brightness-min"]),
                        "raster-brightness-max": new ja(Ya.paint_raster["raster-brightness-max"]),
                        "raster-saturation": new ja(Ya.paint_raster["raster-saturation"]),
                        "raster-contrast": new ja(Ya.paint_raster["raster-contrast"]),
                        "raster-resampling": new ja(Ya.paint_raster["raster-resampling"]),
                        "raster-fade-duration": new ja(Ya.paint_raster["raster-fade-duration"]),
                        "raster-emissive-strength": new ja(Ya.paint_raster["raster-emissive-strength"]),
                        "raster-array-band": new ja(Ya.paint_raster["raster-array-band"]),
                        "raster-elevation": new ja(Ya.paint_raster["raster-elevation"]),
                        "raster-color-use-theme": new qa({
                            type: "string",
                            default: "default",
                            "property-type": "data-driven"
                        })
                    }))
                }, e, r, n), this.updateColorRamp(), this._curRampRange = [
                    NaN,
                    NaN
                ];
            }
        }
        let wm, Mm, Am, Sm, Im;
        class Pm extends ps {
            onRemove(t1) {
                this.colorRampTexture && this.colorRampTexture.destroy(), this.tileFramebuffer && this.tileFramebuffer.destroy(), this.particleFramebuffer && this.particleFramebuffer.destroy();
            }
            hasColorMap() {
                return !!this._transitionablePaint._values["raster-particle-color"].value.value;
            }
            getProgramIds() {
                return [
                    "rasterParticle"
                ];
            }
            hasOffscreenPass() {
                return "none" !== this.visibility;
            }
            isDraped(t1) {
                return !1;
            }
            _handleSpecialPaintPropertyUpdate(t1) {
                "raster-particle-color" !== t1 && "raster-particle-max-speed" !== t1 || (this._updateColorRamp(), this._invalidateAnimationState()), "raster-particle-count" === t1 && this._invalidateAnimationState();
            }
            _updateColorRamp() {
                if (!this.hasColorMap()) return;
                const t1 = this._transitionablePaint._values["raster-particle-color"].value.expression, e = this._transitionablePaint._values["raster-particle-max-speed"].value.expression.evaluate({
                    zoom: 0
                });
                this.colorRamp = lc({
                    expression: t1,
                    evaluationKey: "rasterParticleSpeed",
                    image: this.colorRamp,
                    clips: [
                        {
                            start: 0,
                            end: e
                        }
                    ],
                    resolution: 256
                }), this.colorRampTexture = null;
            }
            _invalidateAnimationState() {
                this.lastInvalidatedAt = Dt.now();
            }
            tileCoverLift() {
                return this.paint.get("raster-particle-elevation");
            }
            constructor(t1, e, r, n){
                super(t1, {
                    layout: wm || (wm = new Ga({
                        visibility: new ja(Ya["layout_raster-particle"].visibility)
                    })),
                    paint: Mm || (Mm = new Ga({
                        "raster-particle-array-band": new ja(Ya["paint_raster-particle"]["raster-particle-array-band"]),
                        "raster-particle-count": new ja(Ya["paint_raster-particle"]["raster-particle-count"]),
                        "raster-particle-color": new $a(Ya["paint_raster-particle"]["raster-particle-color"]),
                        "raster-particle-max-speed": new ja(Ya["paint_raster-particle"]["raster-particle-max-speed"]),
                        "raster-particle-speed-factor": new ja(Ya["paint_raster-particle"]["raster-particle-speed-factor"]),
                        "raster-particle-fade-opacity-factor": new ja(Ya["paint_raster-particle"]["raster-particle-fade-opacity-factor"]),
                        "raster-particle-reset-rate-factor": new ja(Ya["paint_raster-particle"]["raster-particle-reset-rate-factor"]),
                        "raster-particle-elevation": new ja(Ya["paint_raster-particle"]["raster-particle-elevation"]),
                        "raster-particle-color-use-theme": new qa({
                            type: "string",
                            default: "default",
                            "property-type": "data-driven"
                        })
                    }))
                }, e, r, n), this._updateColorRamp(), this.lastInvalidatedAt = Dt.now();
            }
        }
        class zm extends ps {
            is3D() {
                return "3d" === this.implementation.renderingMode;
            }
            hasOffscreenPass() {
                return void 0 !== this.implementation.prerender;
            }
            isDraped(t1) {
                return void 0 !== this.implementation.renderToTile;
            }
            shouldRedrape() {
                return !!this.implementation.shouldRerenderTiles && this.implementation.shouldRerenderTiles();
            }
            recalculate() {}
            updateTransitions() {}
            hasTransition() {
                return !1;
            }
            serialize() {}
            onAdd(t1) {
                this.implementation.onAdd && this.implementation.onAdd(t1, t1.painter.context.gl);
            }
            onRemove(t1) {
                this.implementation.onRemove && this.implementation.onRemove(t1, t1.painter.context.gl);
            }
            constructor(t1, e){
                super(t1, {}, e, null), this.implementation = t1, t1.slot && (this.slot = t1.slot);
            }
        }
        function Em(t1, e, r) {
            const n = [
                0,
                0,
                1
            ], i = O.quat.identity([]);
            return O.quat.rotateY(i, i, r ? -X(t1) + Math.PI : X(t1)), O.quat.rotateX(i, i, -X(e)), O.vec3.transformQuat(n, n, i), O.vec3.normalize(n, n);
        }
        function km(t1, e) {
            const r = Bm(t1.projection, t1.zoom, t1.width, t1.height), n = function(t1, e, r, n, i) {
                const a = new il(r.lng - 180 * Cm, r.lat), s = new il(r.lng + 180 * Cm, r.lat), o = t1.project(a.lng, a.lat), l = t1.project(s.lng, s.lat), u = -Math.atan2(l.y - o.y, l.x - o.x), c = bl.fromLngLat(r);
                c.y = Q(c.y, -1 + Cm, 1 - Cm);
                const h = c.toLngLat(), p = t1.project(h.lng, h.lat), f = bl.fromLngLat(h);
                f.x += Cm;
                const d = f.toLngLat(), m = t1.project(d.lng, d.lat), y = Dm(m.x - p.x, m.y - p.y, u), g = bl.fromLngLat(h);
                g.y += Cm;
                const x = g.toLngLat(), v = t1.project(x.lng, x.lat), b = Dm(v.x - p.x, v.y - p.y, u), _ = Math.abs(y.x) / Math.abs(b.y), w = O.mat4.identity([]);
                O.mat4.rotateZ(w, w, -u * (1 - (i ? 0 : n)));
                const M = O.mat4.identity([]);
                return O.mat4.scale(M, M, [
                    1,
                    1 - (1 - _) * n,
                    1
                ]), M[4] = -b.x / b.y * n, O.mat4.rotateZ(M, M, u), O.mat4.multiply(M, w, M), M;
            }(t1.projection, 0, t1.center, r, e), i = Tm(t1);
            return O.mat4.scale(n, n, [
                i,
                i,
                1
            ]), n;
        }
        function Tm(t1) {
            const e = t1.projection, r = Bm(t1.projection, t1.zoom, t1.width, t1.height), n = Vm(e, t1.center), i = Vm(e, il.convert(e.center));
            return Math.pow(2, n * r + (1 - r) * i);
        }
        function Bm(t1, e, r, n, i = 1 / 0) {
            const a = t1.range;
            if (!a) return 0;
            const s = Math.min(i, Math.max(r, n)), o = Math.log(s / 1024) / Math.LN2;
            return tt(a[0] + o, a[1] + o, e);
        }
        const Cm = 1 / 4e4;
        function Vm(t1, e) {
            const r = Q(e.lat, -ml, ml), n = new il(e.lng - 180 * Cm, r), i = new il(e.lng + 180 * Cm, r), a = t1.project(n.lng, r), s = t1.project(i.lng, r), o = bl.fromLngLat(n), l = bl.fromLngLat(i), u = s.x - a.x, c = s.y - a.y, h = l.x - o.x, p = l.y - o.y, f = Math.sqrt((h * h + p * p) / (u * u + c * c));
            return Math.log(f) / Math.LN2;
        }
        function Dm(t1, e, r) {
            const n = Math.cos(r), i = Math.sin(r);
            return {
                x: t1 * n - e * i,
                y: t1 * i + e * n
            };
        }
        function Lm(t1, e, r) {
            O.mat4.identity(t1), O.mat4.rotateZ(t1, t1, X(e[2])), O.mat4.rotateX(t1, t1, X(e[0])), O.mat4.rotateY(t1, t1, X(e[1])), O.mat4.scale(t1, t1, r), O.mat4.multiply(t1, t1, [
                1,
                0,
                0,
                0,
                0,
                0,
                1,
                0,
                0,
                1,
                0,
                0,
                0,
                0,
                0,
                1
            ]);
        }
        function Rm(t1, e, r, n, i, a, s, o) {
            const l = [
                r[0] - e[0],
                r[1] - e[1],
                0
            ], u = [
                n[0] - e[0],
                n[1] - e[1],
                0
            ];
            if (O.vec3.length(l) < 1e-12 || O.vec3.length(u) < 1e-12) return O.quat.identity(t1);
            const c = O.vec3.cross([], l, u);
            O.vec3.normalize(c, c), O.vec3.subtract(u, n, e), l[2] = (a - i) * o, u[2] = (s - i) * o;
            const h = l;
            return O.vec3.cross(h, l, u), O.vec3.normalize(h, h), O.quat.rotationTo(t1, c, h);
        }
        function Fm(t1, e, r = !1) {
            const n = Fu(e.zoom), i = function(t1, e, r) {
                const n = e.worldSize, i = [
                    t1[12],
                    t1[13],
                    t1[14]
                ], a = fl(i[1] / n), s = pl(i[0] / n), o = O.mat4.identity([]), l = hl(1, a) * n, u = hl(1, 0) * n * gl(a, e.zoom), c = 1 / Du(n);
                let h = u * c;
                if (r) {
                    const t1 = Bm(e.projection, e.zoom, e.width, e.height, 1024);
                    h = c * e.projection.pixelSpaceConversion(e.center.lat, n, t1);
                }
                const p = el(a, s);
                O.vec3.add(p, p, O.vec3.scale([], O.vec3.normalize([], p), l * h * i[2]));
                const f = function(t1) {
                    const e = [
                        t1[0],
                        t1[1],
                        t1[2]
                    ];
                    let r = [
                        0,
                        1,
                        0
                    ];
                    const n = O.vec3.cross([], r, e);
                    return O.vec3.cross(r, e, n), 0 === O.vec3.squaredLength(r) && (r = [
                        0,
                        1,
                        0
                    ], O.vec3.cross(n, e, r)), O.vec3.normalize(n, n), O.vec3.normalize(r, r), O.vec3.normalize(e, e), [
                        n[0],
                        n[1],
                        n[2],
                        0,
                        r[0],
                        r[1],
                        r[2],
                        0,
                        e[0],
                        e[1],
                        e[2],
                        0,
                        t1[0],
                        t1[1],
                        t1[2],
                        1
                    ];
                }(p);
                O.mat4.scale(o, o, [
                    h,
                    h,
                    h * l
                ]), O.mat4.translate(o, o, [
                    -i[0],
                    -i[1],
                    -i[2]
                ]);
                const d = O.mat4.multiply([], e.globeMatrix, f);
                return O.mat4.multiply(d, d, o), O.mat4.multiply(d, d, t1), d;
            }(t1, e, r);
            if (n > 0) {
                const r = function(t1, e) {
                    const r = e.worldSize, n = hl(1, 0) * r * gl(e.center.lat, e.zoom) / Du(r), i = hl(1, e.center.lat) * r, a = O.mat4.identity([]);
                    return O.mat4.rotateY(a, a, X(e.center.lng)), O.mat4.rotateX(a, a, X(e.center.lat)), O.mat4.translate(a, a, [
                        0,
                        0,
                        Yo
                    ]), O.mat4.scale(a, a, [
                        n,
                        n,
                        n * i
                    ]), O.mat4.translate(a, a, [
                        e.point.x - .5 * r,
                        e.point.y - .5 * r,
                        0
                    ]), O.mat4.multiply(a, a, t1), O.mat4.multiply(a, e.globeMatrix, a);
                }(t1, e);
                return function(t1, e, r) {
                    const n = (t1, e, r)=>{
                        const n = O.vec3.length(t1), i = O.vec3.length(e), a = Su(t1, e, r);
                        return O.vec3.scale(a, a, 1 / O.vec3.length(a) * ze(n, i, r));
                    }, i = n([
                        t1[0],
                        t1[1],
                        t1[2]
                    ], [
                        e[0],
                        e[1],
                        e[2]
                    ], r), a = n([
                        t1[4],
                        t1[5],
                        t1[6]
                    ], [
                        e[4],
                        e[5],
                        e[6]
                    ], r), s = n([
                        t1[8],
                        t1[9],
                        t1[10]
                    ], [
                        e[8],
                        e[9],
                        e[10]
                    ], r), o = Su([
                        t1[12],
                        t1[13],
                        t1[14]
                    ], [
                        e[12],
                        e[13],
                        e[14]
                    ], r);
                    return [
                        i[0],
                        i[1],
                        i[2],
                        0,
                        a[0],
                        a[1],
                        a[2],
                        0,
                        s[0],
                        s[1],
                        s[2],
                        0,
                        o[0],
                        o[1],
                        o[2],
                        1
                    ];
                }(i, r, n);
            }
            return i;
        }
        function Om(t1, e, r, n) {
            const i = xu.projectAabbCorners(n, r);
            let a = Number.MAX_VALUE, s = -1;
            for(let t1 = 0; t1 < i.length; ++t1){
                const r = i[t1];
                r[0] = (.5 * r[0] + .5) * e.width, r[1] = (.5 - .5 * r[1]) * e.height, r[2] < a && (s = t1, a = r[2]);
            }
            const o = (t1)=>new q(i[t1][0], i[t1][1]);
            let l;
            switch(s){
                case 0:
                case 6:
                    l = [
                        o(1),
                        o(5),
                        o(4),
                        o(7),
                        o(3),
                        o(2),
                        o(1)
                    ];
                    break;
                case 1:
                case 7:
                    l = [
                        o(0),
                        o(4),
                        o(5),
                        o(6),
                        o(2),
                        o(3),
                        o(0)
                    ];
                    break;
                case 3:
                case 5:
                    l = [
                        o(1),
                        o(0),
                        o(4),
                        o(7),
                        o(6),
                        o(2),
                        o(1)
                    ];
                    break;
                default:
                    l = [
                        o(1),
                        o(5),
                        o(6),
                        o(7),
                        o(3),
                        o(0),
                        o(1)
                    ];
            }
            if (Cl(t1, l)) return a;
        }
        const Nm = ys([
            {
                name: "a_pos_3f",
                components: 3,
                type: "Float32"
            }
        ]), Um = ys([
            {
                name: "a_color_3f",
                components: 3,
                type: "Float32"
            }
        ]), jm = ys([
            {
                name: "a_color_4f",
                components: 4,
                type: "Float32"
            }
        ]), qm = ys([
            {
                name: "a_uv_2f",
                components: 2,
                type: "Float32"
            }
        ]), $m = ys([
            {
                name: "a_normal_3f",
                components: 3,
                type: "Float32"
            }
        ]), Gm = ys([
            {
                name: "a_normal_matrix0",
                components: 4,
                type: "Float32"
            },
            {
                name: "a_normal_matrix1",
                components: 4,
                type: "Float32"
            },
            {
                name: "a_normal_matrix2",
                components: 4,
                type: "Float32"
            },
            {
                name: "a_normal_matrix3",
                components: 4,
                type: "Float32"
            }
        ]), Ym = ys([
            {
                name: "a_pbr",
                components: 4,
                type: "Uint16"
            },
            {
                name: "a_heightBasedEmissiveStrength",
                components: 3,
                type: "Float32"
            }
        ]), Xm = {
            None: 0,
            Model: 1,
            Symbol: 2,
            FillExtrusion: 4,
            All: 7
        };
        class Zm {
            constructor(t1, e, r, n){
                this.message = (t1 ? `${t1}: ` : "") + r, n && (this.identifier = n), null != e && e.__line__ && (this.line = e.__line__);
            }
        }
        function Hm(t1, e) {
            const r = -1 === t1.indexOf("://");
            try {
                return new URL(t1, r && e ? "http://example.com" : void 0), !0;
            } catch (t1) {
                return !1;
            }
        }
        class Wm {
            constructor(t1, e){
                this.feature = t1, this.instancedDataOffset = e, this.instancedDataCount = 0, this.rotation = [
                    0,
                    0,
                    0
                ], this.scale = [
                    1,
                    1,
                    1
                ], this.translation = [
                    0,
                    0,
                    0
                ];
            }
        }
        class Km {
            constructor(){
                this.instancedDataArray = new Xs, this.instancesEvaluatedElevation = [], this.features = [], this.idToFeaturesIndex = {};
            }
        }
        class Jm {
            updateFootprints(t1, e) {}
            populate(t1, e, r, n) {
                this.tileToMeter = vl(r);
                const i = this.layers[0]._featureFilter.needGeometry;
                this.lookup = new Uint8Array(this.lookupDim * this.lookupDim);
                for (const { feature: a, id: s, index: o, sourceLayerIndex: l } of t1){
                    const t1 = null != s ? s : a.properties && a.properties.hasOwnProperty("id") ? a.properties.id : void 0, u = El(a, i);
                    if (!this.layers[0]._featureFilter.filter(new Ca(this.zoom), u, r)) continue;
                    const c = {
                        id: t1,
                        sourceLayerIndex: l,
                        index: o,
                        geometry: i ? u.geometry : zl(a, r, n),
                        properties: a.properties,
                        type: a.type,
                        patterns: {}
                    }, h = this.addFeature(c, c.geometry, u);
                    h && e.featureIndex.insert(a, c.geometry, o, l, this.index, this.instancesPerModel[h].instancedDataArray.length, Wr / 32);
                }
                this.lookup = null;
            }
            update(t1, e, r, n) {
                for(const e in this.instancesPerModel){
                    const r = this.instancesPerModel[e];
                    for(const e in t1)r.idToFeaturesIndex.hasOwnProperty(e) && (this.evaluate(r.features[r.idToFeaturesIndex[e]], t1[e], r, !0), this.uploaded = !1);
                }
                this.maxHeight = 0;
            }
            updateZoomBasedPaintProperties() {
                if (!this.hasZoomDependentProperties) return !1;
                let t1 = !1;
                for(const e in this.instancesPerModel){
                    const r = this.instancesPerModel[e];
                    for (const e of r.features){
                        const n = this.layers[0], i = e.feature, a = this.canonical, s = n.paint.get("model-rotation").evaluate(i, {}, a), o = n.paint.get("model-scale").evaluate(i, {}, a), l = n.paint.get("model-translation").evaluate(i, {}, a);
                        O.vec3.exactEquals(e.rotation, s) && O.vec3.exactEquals(e.scale, o) && O.vec3.exactEquals(e.translation, l) || (this.evaluate(e, e.featureStates, r, !0), t1 = !0);
                    }
                }
                return t1;
            }
            updateReplacement(t1, e, r, n) {
                if (e.updateTime === this.replacementUpdateTime) return !1;
                this.replacementUpdateTime = e.updateTime;
                const i = e.getReplacementRegionsForTile(t1.toUnwrapped(), !0);
                if (Ah(this.activeReplacements, i)) return !1;
                this.activeReplacements = i;
                let a = !1;
                for(const e in this.instancesPerModel){
                    const i = this.instancesPerModel[e], s = i.instancedDataArray;
                    for (const e of i.features){
                        const i = e.instancedDataOffset, o = e.instancedDataCount;
                        for(let e = 0; e < o; e++){
                            const o = 16 * (e + i);
                            let l = s.float32[o + 0];
                            const u = l > Wr;
                            l = u ? l - Wr : l;
                            const c = Math.floor(l), h = s.float32[o + 1];
                            let p = !1;
                            for (const e of this.activeReplacements)if (!bh(e, r, Xm.Model, n) && !(e.min.x > c || c > e.max.x || e.min.y > h || h > e.max.y) && (p = kh(Eh(c, h, t1.canonical, e.footprintTileId.canonical), e.footprint), p)) break;
                            s.float32[o] = p ? l + Wr : l, a = a || p !== u;
                        }
                    }
                }
                return a;
            }
            isEmpty() {
                for(const t1 in this.instancesPerModel)if (0 !== this.instancesPerModel[t1].instancedDataArray.length) return !1;
                return !0;
            }
            uploadPending() {
                return !this.uploaded;
            }
            upload(t1) {
                if (!this.uploaded) for(const e in this.instancesPerModel){
                    const r = this.instancesPerModel[e];
                    r.instancedDataArray.length < 0 || 0 === r.instancedDataArray.length || (r.instancedDataBuffer ? r.instancedDataBuffer.updateData(r.instancedDataArray) : r.instancedDataBuffer = t1.createVertexBuffer(r.instancedDataArray, Gm.members, !0, void 0, this.instanceCount));
                }
                this.uploaded = !0;
            }
            destroy() {
                for(const t1 in this.instancesPerModel){
                    const e = this.instancesPerModel[t1];
                    0 !== e.instancedDataArray.length && e.instancedDataBuffer && e.instancedDataBuffer.destroy();
                }
                const t1 = this.layers[0].modelManager;
                if (t1 && this.modelUris) for (const e of this.modelUris)t1.removeModel(e, "");
            }
            addFeature(t1, e, r) {
                const n = this.layers[0], i = n.layout.get("model-id").evaluate(r, {}, this.canonical);
                if (!i) return ft(`modelId is not evaluated for layer ${n.id} and it is not going to get rendered.`), i;
                Hm(i, !1) && (this.modelUris.includes(i) || this.modelUris.push(i)), this.instancesPerModel[i] || (this.instancesPerModel[i] = new Km);
                const a = this.instancesPerModel[i], s = a.instancedDataArray, o = new Wm(r, s.length);
                for (const t1 of e)for (const e of t1){
                    if (e.x < 0 || e.x >= Wr || e.y < 0 || e.y >= Wr) continue;
                    const t1 = (this.lookupDim - 1) / Wr, r = this.lookupDim * (e.y * t1 | 0) + e.x * t1 | 0;
                    if (this.lookup) {
                        if (0 !== this.lookup[r]) continue;
                        this.lookup[r] = 1;
                    }
                    this.instanceCount++;
                    const n = s.length;
                    s.resize(n + 1), a.instancesEvaluatedElevation.push(0), s.float32[16 * n] = e.x, s.float32[16 * n + 1] = e.y;
                }
                return o.instancedDataCount = a.instancedDataArray.length - o.instancedDataOffset, o.instancedDataCount > 0 && (t1.id && (a.idToFeaturesIndex[t1.id] = a.features.length), a.features.push(o), this.evaluate(o, {}, a, !1)), i;
            }
            getModelUris() {
                return this.modelUris;
            }
            evaluate(t1, e, r, n) {
                const i = this.layers[0], a = t1.feature, s = this.canonical, o = t1.rotation = i.paint.get("model-rotation").evaluate(a, e, s), l = t1.scale = i.paint.get("model-scale").evaluate(a, e, s), u = t1.translation = i.paint.get("model-translation").evaluate(a, e, s), c = i.paint.get("model-color").evaluate(a, e, s);
                c.a = i.paint.get("model-color-mix-intensity").evaluate(a, e, s);
                const h = [];
                this.maxVerticalOffset < u[2] && (this.maxVerticalOffset = u[2]), this.maxScale = Math.max(Math.max(this.maxScale, l[0]), Math.max(l[1], l[2])), Lm(h, o, l);
                const p = Math.round(100 * c.a) + c.b / 1.05;
                for(let e = 0; e < t1.instancedDataCount; ++e){
                    const i = t1.instancedDataOffset + e, a = 16 * i, o = r.instancedDataArray.float32;
                    let l = 0;
                    n && (l = o[a + 6] - r.instancesEvaluatedElevation[i]);
                    const f = 0 | o[a + 1];
                    o[a] = (0 | o[a]) + c.r / 1.05, o[a + 1] = f + c.g / 1.05, o[a + 2] = p, o[a + 3] = 1 / (s.z > 10 ? this.tileToMeter : vl(s, f)), o[a + 4] = u[0], o[a + 5] = u[1], o[a + 6] = u[2] + l, o[a + 7] = h[0], o[a + 8] = h[1], o[a + 9] = h[2], o[a + 10] = h[4], o[a + 11] = h[5], o[a + 12] = h[6], o[a + 13] = h[8], o[a + 14] = h[9], o[a + 15] = h[10], r.instancesEvaluatedElevation[i] = u[2];
                }
            }
            constructor(t1){
                this.zoom = t1.zoom, this.canonical = t1.canonical, this.layers = t1.layers, this.layerIds = this.layers.map((t1)=>t1.fqid), this.projection = t1.projection, this.index = t1.index, this.hasZoomDependentProperties = this.layers[0].isZoomDependent(), this.stateDependentLayerIds = this.layers.filter((t1)=>t1.isStateDependent()).map((t1)=>t1.id), this.hasPattern = !1, this.instancesPerModel = {}, this.validForExaggeration = 0, this.maxVerticalOffset = 0, this.maxScale = 0, this.maxHeight = 0, this.lookupDim = this.zoom > this.canonical.z ? 256 : this.zoom > 15 ? 75 : 100, this.instanceCount = 0, this.terrainElevationMin = 0, this.terrainElevationMax = 0, this.validForDEMTile = {
                    id: null,
                    timestamp: 0
                }, this.modelUris = [], this.modelsRequested = !1, this.activeReplacements = [], this.replacementUpdateTime = 0;
            }
        }
        let Qm, ty;
        oa(Jm, "ModelBucket", {
            omit: [
                "layers"
            ]
        }), oa(Km, "PerModelAttributes"), oa(Wm, "ModelFeature");
        const ey = 64, ry = {
            CoordinateSpaceTile: 1,
            CoordinateSpaceYUp: 2,
            HasMapboxMeshFeatures: 4,
            HasMeshoptCompression: 8
        };
        function ny(t1, e, r, n, i, a, s, o, l, u = !1) {
            const c = r.zoom, h = r.project(n), p = gl(n.lat, c), f = 1 / p;
            O.mat4.identity(t1), O.mat4.translate(t1, t1, [
                h.x + s[0] * f,
                h.y + s[1] * f,
                s[2]
            ]);
            let d = 1, m = 1;
            const y = r.worldSize;
            if (u) {
                if ("mercator" === r.projection.name) {
                    let t1 = 0;
                    r.elevation && (t1 = r.elevation.getAtPointOrZero(new bl(h.x / y, h.y / y), 0));
                    const e = O.vec4.transformMat4([], [
                        h.x,
                        h.y,
                        t1,
                        1
                    ], r.projMatrix)[3] / r.cameraToCenterDistance;
                    d = e, m = e * gl(r.center.lat, c);
                } else if ("globe" === r.projection.name) {
                    const e = Fm(t1, r), i = O.mat4.multiply([], r.projMatrix, e), a = [
                        0,
                        0,
                        0,
                        1
                    ];
                    O.vec4.transformMat4(a, a, i);
                    const s = a[3] / r.cameraToCenterDistance, o = Fu(c), l = r.projection.pixelsPerMeter(n.lat, y) * gl(n.lat, c), u = r.projection.pixelsPerMeter(r.center.lat, y) * gl(r.center.lat, c);
                    d = s / ze(l, yl(r.center.lat), o), m = s * p / l, d *= u, m *= u;
                }
            } else d = f;
            O.mat4.scale(t1, t1, [
                d,
                d,
                m
            ]);
            const g = [
                ...t1
            ], x = e.orientation, v = [];
            if (Lm(v, [
                x[0] + i[0],
                x[1] + i[1],
                x[2] + i[2]
            ], a), O.mat4.multiply(t1, g, v), o && r.elevation) {
                let i = 0;
                const a = [];
                if (l && r.elevation) {
                    i = function(t1, e, r, n, i) {
                        const a = e.elevation;
                        if (!a) return 0;
                        const s = xu.projectAabbCorners(r, n), o = hl(1, i.lat) * e.worldSize, l = function(t1, e) {
                            const r = [
                                0,
                                0,
                                1
                            ], n = [
                                {
                                    corners: [
                                        0,
                                        1,
                                        3,
                                        2
                                    ],
                                    dotProductWithUp: 0
                                },
                                {
                                    corners: [
                                        1,
                                        5,
                                        2,
                                        6
                                    ],
                                    dotProductWithUp: 0
                                },
                                {
                                    corners: [
                                        0,
                                        4,
                                        1,
                                        5
                                    ],
                                    dotProductWithUp: 0
                                },
                                {
                                    corners: [
                                        2,
                                        6,
                                        3,
                                        7
                                    ],
                                    dotProductWithUp: 0
                                },
                                {
                                    corners: [
                                        4,
                                        7,
                                        5,
                                        6
                                    ],
                                    dotProductWithUp: 0
                                },
                                {
                                    corners: [
                                        0,
                                        3,
                                        4,
                                        7
                                    ],
                                    dotProductWithUp: 0
                                }
                            ];
                            for (const i of n){
                                const n = t1[i.corners[0]], a = t1[i.corners[1]], s = t1[i.corners[2]], o = [
                                    a[0] - n[0],
                                    a[1] - n[1],
                                    e * (a[2] - n[2])
                                ], l = O.vec3.cross(o, o, [
                                    s[0] - n[0],
                                    s[1] - n[1],
                                    e * (s[2] - n[2])
                                ]);
                                O.vec3.normalize(l, l), i.dotProductWithUp = O.vec3.dot(l, r);
                            }
                            return n.sort((t1, e)=>t1.dotProductWithUp - e.dotProductWithUp), n[0].corners;
                        }(s, o), u = s[l[0]], c = s[l[1]], h = s[l[2]], p = s[l[3]], f = a.getAtPointOrZero(new bl(u[0] / e.worldSize, u[1] / e.worldSize), 0), d = a.getAtPointOrZero(new bl(c[0] / e.worldSize, c[1] / e.worldSize), 0), m = a.getAtPointOrZero(new bl(h[0] / e.worldSize, h[1] / e.worldSize), 0), y = a.getAtPointOrZero(new bl(p[0] / e.worldSize, p[1] / e.worldSize), 0), g = (f + y) / 2, x = (d + m) / 2;
                        return g > x ? d < m ? Rm(t1, c, p, u, d, y, f, o) : Rm(t1, h, u, p, m, f, y, o) : f < y ? Rm(t1, u, c, h, f, d, m, o) : Rm(t1, p, h, c, y, m, d, o), Math.max(g, x);
                    }(a, r, e.aabb, t1, n);
                    const s = O.mat4.fromQuat([], a), o = O.mat4.multiply([], s, v);
                    O.mat4.multiply(t1, g, o);
                } else i = r.elevation.getAtPointOrZero(new bl(h.x / y, h.y / y), 0);
                0 !== i && (t1[14] += i);
            }
        }
        function iy(t1, e, r = !1) {
            t1.uploaded || (t1.gfxTexture = new dm(e, t1.image, r ? e.gl.R8 : e.gl.RGBA8, {
                useMipmap: t1.sampler.minFilter >= e.gl.NEAREST_MIPMAP_NEAREST
            }), t1.uploaded = !0, t1.image = null);
        }
        function ay(t1, e, r) {
            t1.indexBuffer = e.createIndexBuffer(t1.indexArray, !1, !0), t1.vertexBuffer = e.createVertexBuffer(t1.vertexArray, Nm.members, !1, !0), t1.normalArray && (t1.normalBuffer = e.createVertexBuffer(t1.normalArray, $m.members, !1, !0)), t1.texcoordArray && (t1.texcoordBuffer = e.createVertexBuffer(t1.texcoordArray, qm.members, !1, !0)), t1.colorArray && (t1.colorBuffer = e.createVertexBuffer(t1.colorArray, (12 === t1.colorArray.bytesPerElement ? Um : jm).members, !1, !0)), t1.featureArray && (t1.pbrBuffer = e.createVertexBuffer(t1.featureArray, Ym.members, !0)), t1.segments = po.simpleSegment(0, 0, t1.vertexArray.length, t1.indexArray.length);
            const n = t1.material;
            n.pbrMetallicRoughness.baseColorTexture && iy(n.pbrMetallicRoughness.baseColorTexture, e), n.pbrMetallicRoughness.metallicRoughnessTexture && iy(n.pbrMetallicRoughness.metallicRoughnessTexture, e), n.normalTexture && iy(n.normalTexture, e), n.occlusionTexture && iy(n.occlusionTexture, e, r), n.emissionTexture && iy(n.emissionTexture, e);
        }
        function sy(t1, e, r) {
            if (t1.meshes) for (const n of t1.meshes)ay(n, e, r);
            if (t1.children) for (const n of t1.children)sy(n, e, r);
        }
        function oy(t1) {
            if (t1.meshes) for (const e of t1.meshes)e.indexArray.destroy(), e.vertexArray.destroy(), e.colorArray && e.colorArray.destroy(), e.normalArray && e.normalArray.destroy(), e.texcoordArray && e.texcoordArray.destroy(), e.featureArray && e.featureArray.destroy();
            if (t1.children) for (const e of t1.children)oy(e);
        }
        function ly(t1) {
            if (t1.meshes) for (const r of t1.meshes)r.vertexBuffer && (r.vertexBuffer.destroy(), r.indexBuffer.destroy(), r.normalBuffer && r.normalBuffer.destroy(), r.texcoordBuffer && r.texcoordBuffer.destroy(), r.colorBuffer && r.colorBuffer.destroy(), r.pbrBuffer && r.pbrBuffer.destroy(), r.segments.destroy(), r.material && ((e = r.material).pbrMetallicRoughness.baseColorTexture && e.pbrMetallicRoughness.baseColorTexture.gfxTexture && e.pbrMetallicRoughness.baseColorTexture.gfxTexture.destroy(), e.pbrMetallicRoughness.metallicRoughnessTexture && e.pbrMetallicRoughness.metallicRoughnessTexture.gfxTexture && e.pbrMetallicRoughness.metallicRoughnessTexture.gfxTexture.destroy(), e.normalTexture && e.normalTexture.gfxTexture && e.normalTexture.gfxTexture.destroy(), e.emissionTexture && e.emissionTexture.gfxTexture && e.emissionTexture.gfxTexture.destroy(), e.occlusionTexture && e.occlusionTexture.gfxTexture && e.occlusionTexture.gfxTexture.destroy()));
            var e;
            if (t1.children) for (const e of t1.children)ly(e);
        }
        class uy {
            static create(t1, e, r) {
                const n = r || t1.findDEMTileFor(e);
                if (!n || !n.dem) return;
                const i = n.dem, a = n.tileID, s = 1 << e.canonical.z - a.canonical.z;
                return new uy(n, i.dim / Wr / s, [
                    (e.canonical.x / s - a.canonical.x) * i.dim,
                    (e.canonical.y / s - a.canonical.y) * i.dim
                ]);
            }
            tileCoordToPixel(t1, e) {
                const r = e * this._scale + this._offset[1], n = Math.floor(t1 * this._scale + this._offset[0]), i = Math.floor(r);
                return new q(n, i);
            }
            getElevationAt(t1, e, r, n) {
                const i = t1 * this._scale + this._offset[0], a = e * this._scale + this._offset[1], s = Math.floor(i), o = Math.floor(a), l = this._dem;
                return n = !!n, r ? ze(ze(l.get(s, o, n), l.get(s, o + 1, n), a - o), ze(l.get(s + 1, o, n), l.get(s + 1, o + 1, n), a - o), i - s) : l.get(s, o, n);
            }
            getElevationAtPixel(t1, e, r) {
                return this._dem.get(t1, e, !!r);
            }
            getMeterToDEM(t1) {
                return (1 << this._demTile.tileID.canonical.z) * hl(1, t1) * this._dem.stride;
            }
            constructor(t1, e, r){
                this._demTile = t1, this._dem = this._demTile.dem, this._scale = e, this._offset = r;
            }
        }
        const cy = new Float32Array(262144), hy = new Uint8Array(262144);
        function py(t1) {
            let e = 0;
            if (t1.meshes) for (const r of t1.meshes)e = Math.max(e, r.aabb.max[2]);
            if (t1.children) for (const r of t1.children)e = Math.max(e, py(r));
            return e;
        }
        function fy(t1, e, r) {
            if (t1.meshes) for (const n of t1.meshes){
                if (n.aabb.min[0] === 1 / 0) continue;
                const i = xu.applyTransform(n.aabb, t1.matrix);
                r.insert(e, i.min[0], i.min[1], i.max[0], i.max[1]);
            }
            if (t1.children) for (const n of t1.children)fy(n, e, r);
        }
        const dy = [
            "",
            "wall",
            "door",
            "roof",
            "window",
            "lamp",
            "logo"
        ];
        class my {
            _getLocalBounds() {
                if (!this.node.meshes) return new xu([
                    1 / 0,
                    1 / 0,
                    1 / 0
                ], [
                    -1 / 0,
                    -1 / 0,
                    -1 / 0
                ]);
                if (!this.aabb) {
                    let t1 = 0;
                    const e = new xu([
                        1 / 0,
                        1 / 0,
                        1 / 0
                    ], [
                        -1 / 0,
                        -1 / 0,
                        -1 / 0
                    ]);
                    for (const r of this.node.meshes)this.node.lightMeshIndex !== t1 && (r.transformedAabb = xu.applyTransformFast(r.aabb, this.node.matrix), e.encapsulate(r.transformedAabb)), t1++;
                    this.aabb = e;
                }
                return this.aabb;
            }
            constructor(t1){
                this.node = t1, this.evaluatedRMEA = [
                    [
                        1,
                        0,
                        0,
                        1
                    ],
                    [
                        1,
                        0,
                        0,
                        1
                    ],
                    [
                        1,
                        0,
                        0,
                        1
                    ],
                    [
                        1,
                        0,
                        0,
                        1
                    ],
                    [
                        .4,
                        1,
                        0,
                        1
                    ],
                    [
                        1,
                        0,
                        0,
                        1
                    ],
                    [
                        1,
                        0,
                        0,
                        1
                    ]
                ], this.hiddenByReplacement = !1, this.evaluatedScale = [
                    1,
                    1,
                    1
                ], this.evaluatedColor = [], this.emissionHeightBasedParams = [], this.cameraCollisionOpacity = 1, this.feature = {
                    type: "Point",
                    id: t1.id,
                    geometry: [],
                    properties: {
                        height: py(t1)
                    }
                }, this.aabb = this._getLocalBounds(), this.state = null;
            }
        }
        class yy {
            updateFootprints(t1, e) {
                for (const r of this.getNodesInfo()){
                    const n = r.node;
                    n.footprint && e.push({
                        footprint: n.footprint,
                        id: t1
                    });
                }
            }
            update(t1) {
                const e = 0 !== Object.keys(t1).length;
                if (e && !this.stateDependentLayers.length) return;
                const r = e ? this.stateDependentLayers : this.layers;
                if (!$(t1, this.states)) for (const e of r)this.evaluate(e, t1);
                this.states = structuredClone(t1);
            }
            populate() {
                console.log("populate 3D model bucket");
            }
            uploadPending() {
                return !this.uploaded || this.needsUpload;
            }
            upload(t1) {
                if (!this.needsUpload) return;
                const e = this.getNodesInfo();
                for (const r of e){
                    const e = r.node;
                    this.uploaded ? this.updatePbrBuffer(e) : sy(e, t1, !0);
                }
                for (const t1 of e)oy(t1.node);
                this.uploaded = !0, this.needsUpload = !1;
            }
            updatePbrBuffer(t1) {
                let e = !1;
                if (!t1.meshes) return e;
                for (const r of t1.meshes)r.pbrBuffer && (r.pbrBuffer.updateData(r.featureArray), e = !0);
                return e;
            }
            needsReEvaluation(t1, e, r) {
                const n = t1.transform.projectionOptions, i = t1.style.getBrightness(), a = this.brightness !== i;
                if (!this.uploaded || this.dirty || n.name !== this.projection.name || gy(r.paint.get("model-color").value, a) || gy(r.paint.get("model-color-mix-intensity").value, a) || gy(r.paint.get("model-roughness").value, a) || gy(r.paint.get("model-emissive-strength").value, a) || gy(r.paint.get("model-height-based-emissive-strength-multiplier").value, a)) {
                    this.projection = n, this.brightness = i;
                    const t1 = this.getNodesInfo();
                    for (const e of t1)e.state = null;
                    return !0;
                }
                return !1;
            }
            evaluateScale(t1, e) {
                if (t1.transform.zoom === this.zoom) return;
                this.zoom = t1.transform.zoom;
                const r = this.getNodesInfo(), n = this.id.canonical;
                for (const t1 of r){
                    const r = t1.feature;
                    t1.evaluatedScale = e.paint.get("model-scale").evaluate(r, {}, n);
                }
            }
            evaluate(t1, e) {
                const r = this.getNodesInfo();
                for (const n of r){
                    if (!n.node.meshes) continue;
                    const r = n.feature, i = e && e[r.id];
                    if ($(i, n.state)) continue;
                    n.state = structuredClone(i);
                    const a = n.node.meshes && n.node.meshes[0].featureData, s = n.evaluatedColor[2], o = n.evaluatedRMEA[2], l = this.id.canonical;
                    if (n.hasTranslucentParts = !1, a) {
                        for(let e = 0; e < dy.length; e++){
                            const a = dy[e];
                            a.length && (r.properties.part = a);
                            const s = t1.paint.get("model-color").evaluate(r, i, l).toRenderColor(null), o = t1.paint.get("model-color-mix-intensity").evaluate(r, i, l);
                            n.evaluatedColor[e] = [
                                s.r,
                                s.g,
                                s.b,
                                o
                            ], n.evaluatedRMEA[e][0] = t1.paint.get("model-roughness").evaluate(r, i, l), n.evaluatedRMEA[e][2] = t1.paint.get("model-emissive-strength").evaluate(r, i, l), n.evaluatedRMEA[e][3] = s.a, n.emissionHeightBasedParams[e] = t1.paint.get("model-height-based-emissive-strength-multiplier").evaluate(r, i, l), !n.hasTranslucentParts && s.a < 1 && (n.hasTranslucentParts = !0);
                        }
                        delete r.properties.part, vy(n, s !== n.evaluatedColor[2] || o !== n.evaluatedRMEA[2], this.modelTraits);
                    } else n.evaluatedRMEA[0][2] = t1.paint.get("model-emissive-strength").evaluate(r, i, l);
                    n.evaluatedScale = t1.paint.get("model-scale").evaluate(r, i, l), this.updatePbrBuffer(n.node) || (this.needsUpload = !0);
                }
                this.dirty = !1;
            }
            elevationUpdate(t1, e, r, n) {
                const i = t1.findDEMTileFor(r);
                if (i && (i.tileID.canonical !== this.terrainTile || e !== this.terrainExaggeration)) {
                    if (i.dem && i.tileID.overscaledZ !== this.elevationReadFromZ) {
                        this.elevationReadFromZ = i.tileID.overscaledZ;
                        const e = uy.create(t1, r, i);
                        if (!e) return;
                        this.modelTraits & ry.HasMapboxMeshFeatures && this.updateDEM(t1, e, r, n);
                        for (const t1 of this.getNodesInfo()){
                            const r = t1.node;
                            if (!r.footprint || !r.footprint.vertices || !r.footprint.vertices.length) continue;
                            const n = r.footprint.vertices;
                            let i = e.getElevationAt(n[0].x, n[0].y, !0, !0);
                            for(let t1 = 1; t1 < n.length; t1++)i = Math.min(i, e.getElevationAt(n[t1].x, n[t1].y, !0, !0));
                            r.elevation = i;
                        }
                    }
                    this.terrainTile = i.tileID.canonical, this.terrainExaggeration = e;
                }
            }
            updateDEM(t1, e, r, n) {
                let i = e._dem._modifiedForSources[n];
                if (void 0 === i && (e._dem._modifiedForSources[n] = [], i = e._dem._modifiedForSources[n]), i.includes(r.canonical)) return;
                const a = e._dem.dim;
                i.push(r.canonical);
                let s = !1;
                for (const t1 of this.getNodesInfo()){
                    const r = t1.node;
                    if (!r.footprint || !r.footprint.grid) continue;
                    const n = r.footprint.grid, i = e.tileCoordToPixel(n.min.x, n.min.y), o = e.tileCoordToPixel(n.max.x, n.max.y), l = Math.min(Math.min(a - o.y, i.x), Math.min(i.y, a - o.x));
                    if (l < 0) continue;
                    const u = Q(l, 2, 5);
                    let c = Math.max(0, i.x - u), h = Math.max(0, i.y - u), p = Math.min(o.x + u, a - 1), f = Math.min(o.y + u, a - 1);
                    for(let t1 = h; t1 <= f; ++t1)for(let e = c; e <= p; ++e)hy[t1 * a + e] = 255;
                    let d = 0, m = 0;
                    for(let t1 = 0; t1 < n.cellsY; ++t1)for(let r = 0; r < n.cellsX; ++r){
                        if (!n.cells[t1 * n.cellsX + r]) continue;
                        const i = e.tileCoordToPixel(n.min.x + r / n.xScale, n.min.y + t1 / n.yScale), s = e.tileCoordToPixel(n.min.x + (r + 1) / n.xScale, n.min.y + (t1 + 1) / n.yScale);
                        for(let t1 = i.y; t1 <= Math.min(s.y + 1, a - 1); ++t1)for(let r = i.x; r <= Math.min(s.x + 1, a - 1); ++r)255 === hy[t1 * a + r] && (hy[t1 * a + r] = 0, d += e.getElevationAtPixel(r, t1), m++);
                    }
                    const y = d / m;
                    c = Math.max(1, i.x - u), h = Math.max(1, i.y - u), p = Math.min(o.x + u, a - 2), f = Math.min(o.y + u, a - 2), s = !0;
                    for(let t1 = h; t1 <= f; ++t1)for(let r = c; r <= p; ++r)0 === hy[t1 * a + r] && (cy[t1 * a + r] = e._dem.set(r, t1, y));
                    for(let t1 = 1; t1 < u; ++t1){
                        c = Math.max(1, i.x - t1), h = Math.max(1, i.y - t1), p = Math.min(o.x + t1, a - 2), f = Math.min(o.y + t1, a - 2);
                        for(let r = h; r <= f; ++r)for(let n = c; n <= p; ++n){
                            const i = r * a + n;
                            if (255 === hy[i]) {
                                let s = 0, o = 0, l = -1, c = -1;
                                for(let e = -1; e <= 1; ++e)for(let i = -1; i <= 1; ++i){
                                    const u = (r + e) * a + n + i;
                                    if (hy[u] >= t1) continue;
                                    const h = cy[u], p = Math.abs(h);
                                    p > o && (s = h, o = p, l = i, c = e);
                                }
                                if (o > .1) {
                                    const a = 1 - (t1 + .5 * Math.abs(l * c)) / u;
                                    let o = e._dem.get(n, r) + s * a;
                                    const h = e._dem.get(n + l, r + c), p = e._dem.get(n - l, r - c, !0);
                                    (o - h) * (o - p) > 0 && (o = (h + p) / 2), cy[i] = e._dem.set(n, r, o), hy[i] = t1;
                                }
                            }
                        }
                    }
                }
                s && (e._demTile.needsDEMTextureUpload = !0, e._dem._timestamp = Dt.now());
            }
            getNodesInfo() {
                return this.nodesInfo;
            }
            destroy() {
                const t1 = this.getNodesInfo();
                for (const e of t1)oy(e.node), ly(e.node);
            }
            isEmpty() {
                return !this.nodesInfo.length;
            }
            updateReplacement(t1, e) {
                if (e.updateTime === this.replacementUpdateTime) return;
                this.replacementUpdateTime = e.updateTime;
                const r = e.getReplacementRegionsForTile(t1.toUnwrapped()), n = this.getNodesInfo();
                for(let t1 = 0; t1 < this.nodesInfo.length; t1++){
                    const e = n[t1].node;
                    n[t1].hiddenByReplacement = !!e.footprint && !r.find((t1)=>t1.footprint === e.footprint);
                }
            }
            getHeightAtTileCoord(t1, e) {
                const r = this.getNodesInfo(), n = [], i = [
                    0,
                    0,
                    0
                ], a = O.mat4.identity([]);
                for(let s = 0; s < this.nodesInfo.length; s++){
                    const o = r[s], l = o.node.meshes[0], u = l.transformedAabb;
                    if (t1 < u.min[0] || e < u.min[1] || t1 > u.max[0] || e > u.max[1]) continue;
                    if (!0 === o.node.hidden) return {
                        height: 1 / 0,
                        maxHeight: o.feature.properties.height,
                        hidden: !1,
                        verticalScale: o.evaluatedScale[2]
                    };
                    O.mat4.invert(a, o.node.matrix), i[0] = t1, i[1] = e, O.vec3.transformMat4(i, i, a);
                    const c = (i[0] - l.aabb.min[0]) / (l.aabb.max[0] - l.aabb.min[0]) * ey | 0, h = Math.min(63, (i[1] - l.aabb.min[1]) / (l.aabb.max[1] - l.aabb.min[1]) * ey | 0) * ey + Math.min(63, c), p = l.heightmap[h];
                    if (!(p < 0 && o.node.footprint)) {
                        if (o.hiddenByReplacement) return;
                        return {
                            height: p,
                            maxHeight: o.feature.properties.height,
                            hidden: !1,
                            verticalScale: o.evaluatedScale[2]
                        };
                    }
                    if (o.node.footprint.grid.query(new q(t1, e), new q(t1, e), n), n.length > 0) return {
                        height: void 0,
                        maxHeight: o.feature.properties.height,
                        hidden: o.hiddenByReplacement,
                        verticalScale: o.evaluatedScale[2]
                    };
                }
            }
            constructor(t1, e, r, n, i, a, s){
                this.id = r, this.layers = t1, this.layerIds = this.layers.map((t1)=>t1.fqid), this.stateDependentLayerIds = this.layers.filter((t1)=>t1.isStateDependent()).map((t1)=>t1.id), this.modelTraits |= ry.CoordinateSpaceTile, this.uploaded = !1, this.hasPattern = !1, n && (this.modelTraits |= ry.HasMapboxMeshFeatures), i && (this.modelTraits |= ry.HasMeshoptCompression), this.zoom = -1, this.terrainExaggeration = 1, this.projection = {
                    name: "mercator"
                }, this.replacementUpdateTime = 0, this.elevationReadFromZ = 255, this.brightness = a, this.dirty = !0, this.needsUpload = !1, this.nodesInfo = [];
                for (const t1 of e)this.nodesInfo.push(new my(t1)), fy(t1, s.featureIndexArray.length, s.grid), s.featureIndexArray.emplaceBack(this.nodesInfo.length - 1, 0, s.bucketLayerIDs.length - 1, 0);
                this.states = {};
            }
        }
        function gy(t1, e) {
            return !t1.isLightConstant && e;
        }
        function xy(t1, e, r, n, i, a, s, o) {
            let l = (61440 & e | (61440 & e) >> 4) >> 8, u = (3840 & e | (3840 & e) >> 4) >> 4, c = 240 & e | (240 & e) >> 4;
            r[3] > 0 && (l = ze(l, 255 * r[0], r[3]), u = ze(u, 255 * r[1], r[3]), c = ze(c, 255 * r[2], r[3]));
            const h = l << 8 | u, p = c << 8 | Math.floor(255 * n[3]), f = function(t1) {
                const e = Q(t1, 0, 2);
                return Math.min(Math.round(.5 * e * 255), 255);
            }(n[2]) << 8 | 15 * n[0] << 4 | 15 * n[1], d = Q(i[0], 0, 1), m = Q(i[1], 0, 1), y = Q(i[2], 0, 1), g = Q(i[3], 0, 1);
            let x, v, b, _;
            if (d !== m && s !== a && m !== d) {
                const t1 = s - a;
                v = 1 / (t1 * (m - d)), b = -(a + t1 * d) / (t1 * (m - d));
                const e = Q(i[4], -1, 1);
                _ = Math.pow(10, e), x = 255 * y << 8 | 255 * g;
            } else x = 65535, v = 0, b = 1, _ = 1;
            if (t1.emplaceBack(h, p, f, x, v, b, _), o) {
                const t1 = o.length;
                o.clear();
                for(let e = 0; e < t1; e++)o.emplaceBack(h, p, f, x, v, b, _);
            }
        }
        function vy(t1, e, r) {
            const n = t1.node;
            let i = 0;
            const a = r & ry.HasMeshoptCompression;
            for (const r of n.meshes){
                if (n.lights && n.lightMeshIndex === i) continue;
                if (!r.featureData) continue;
                r.featureArray = new Zs, r.featureArray.reserve(r.featureData.length);
                let s = e;
                for (const e of r.featureData){
                    const i = a ? 65535 & e : e >> 16 & 65535, o = a ? e >> 16 & 65535 : 65535 & e, l = (15 & o) < 8 ? 15 & o : 0, u = t1.evaluatedRMEA[l], c = t1.evaluatedColor[l], h = t1.emissionHeightBasedParams[l];
                    let p;
                    if (s && 2 === l && n.lights && (p = new Zs, p.resize(10 * n.lights.length)), xy(r.featureArray, i, c, u, h, r.aabb.min[2], r.aabb.max[2], p), p && s) {
                        s = !1;
                        const t1 = n.meshes[n.lightMeshIndex];
                        t1.featureArray = p, t1.featureArray._trim();
                    }
                }
                r.featureArray._trim(), i++;
            }
        }
        function by(t1, e, r, n) {
            const i = 1 << t1.z;
            e.lat = fl((n / Wr + t1.y) / i), e.lng = pl((r / Wr + t1.x) / i);
        }
        oa(yy, "Tiled3dModelBucket", {
            omit: [
                "layers"
            ]
        }), oa(my, "Tiled3dModelFeature");
        const _y = {
            circle: class extends ps {
                createBucket(t1) {
                    return new Bl(t1);
                }
                queryRadius(t1) {
                    const e = t1;
                    return Xl("circle-radius", this, e) + Xl("circle-stroke-width", this, e) + Zl(this.paint.get("circle-translate"));
                }
                queryIntersectsFeature(t1, e, r, n, i, a, s, o) {
                    const l = Wl(this.paint.get("circle-translate"), this.paint.get("circle-translate-anchor"), a.angle, t1.pixelToTileUnitsFactor), u = this.paint.get("circle-radius").evaluate(e, r) + this.paint.get("circle-stroke-width").evaluate(e, r);
                    return Yu(t1, n, a, s, o, "map" === this.paint.get("circle-pitch-alignment"), "map" === this.paint.get("circle-pitch-scale"), l, u);
                }
                getProgramIds() {
                    return [
                        "circle"
                    ];
                }
                getDefaultProgramParams(t1, e, r) {
                    const n = Gu(this);
                    return {
                        config: new Oo(this, {
                            zoom: e,
                            lut: r
                        }),
                        defines: n,
                        overrideFog: !1
                    };
                }
                constructor(t1, e, r, n){
                    super(t1, {
                        layout: Kl || (Kl = new Ga({
                            "circle-sort-key": new qa(Ya.layout_circle["circle-sort-key"]),
                            "circle-elevation-reference": new ja(Ya.layout_circle["circle-elevation-reference"]),
                            visibility: new ja(Ya.layout_circle.visibility)
                        })),
                        paint: Jl || (Jl = new Ga({
                            "circle-radius": new qa(Ya.paint_circle["circle-radius"]),
                            "circle-color": new qa(Ya.paint_circle["circle-color"]),
                            "circle-blur": new qa(Ya.paint_circle["circle-blur"]),
                            "circle-opacity": new qa(Ya.paint_circle["circle-opacity"]),
                            "circle-translate": new ja(Ya.paint_circle["circle-translate"]),
                            "circle-translate-anchor": new ja(Ya.paint_circle["circle-translate-anchor"]),
                            "circle-pitch-scale": new ja(Ya.paint_circle["circle-pitch-scale"]),
                            "circle-pitch-alignment": new ja(Ya.paint_circle["circle-pitch-alignment"]),
                            "circle-stroke-width": new qa(Ya.paint_circle["circle-stroke-width"]),
                            "circle-stroke-color": new qa(Ya.paint_circle["circle-stroke-color"]),
                            "circle-stroke-opacity": new qa(Ya.paint_circle["circle-stroke-opacity"]),
                            "circle-emissive-strength": new ja(Ya.paint_circle["circle-emissive-strength"]),
                            "circle-color-use-theme": new qa({
                                type: "string",
                                default: "default",
                                "property-type": "data-driven"
                            }),
                            "circle-stroke-color-use-theme": new qa({
                                type: "string",
                                default: "default",
                                "property-type": "data-driven"
                            })
                        }))
                    }, e, r, n);
                }
            },
            heatmap: class extends ps {
                createBucket(t1) {
                    return new Ku(t1);
                }
                _handleSpecialPaintPropertyUpdate(t1) {
                    "heatmap-color" === t1 && this._updateColorRamp();
                }
                _updateColorRamp() {
                    this.colorRamp = lc({
                        expression: this._transitionablePaint._values["heatmap-color"].value.expression,
                        evaluationKey: "heatmapDensity",
                        image: this.colorRamp
                    }), this.colorRampTexture = null;
                }
                resize() {
                    this.heatmapFbo && (this.heatmapFbo.destroy(), this.heatmapFbo = null);
                }
                queryRadius(t1) {
                    return Xl("heatmap-radius", this, t1);
                }
                queryIntersectsFeature(t1, e, r, n, i, a, s, o) {
                    const l = this.paint.get("heatmap-radius").evaluate(e, r);
                    return Yu(t1, n, a, s, o, !0, !0, new q(0, 0), l);
                }
                hasOffscreenPass() {
                    return 0 !== this.paint.get("heatmap-opacity") && "none" !== this.visibility;
                }
                getProgramIds() {
                    return [
                        "heatmap",
                        "heatmapTexture"
                    ];
                }
                getDefaultProgramParams(t1, e, r) {
                    return "heatmap" === t1 ? {
                        config: new Oo(this, {
                            zoom: e,
                            lut: r
                        }),
                        overrideFog: !1
                    } : {};
                }
                constructor(t1, e, r, n){
                    super(t1, {
                        layout: Ju || (Ju = new Ga({
                            visibility: new ja(Ya.layout_heatmap.visibility)
                        })),
                        paint: Qu || (Qu = new Ga({
                            "heatmap-radius": new qa(Ya.paint_heatmap["heatmap-radius"]),
                            "heatmap-weight": new qa(Ya.paint_heatmap["heatmap-weight"]),
                            "heatmap-intensity": new ja(Ya.paint_heatmap["heatmap-intensity"]),
                            "heatmap-color": new $a(Ya.paint_heatmap["heatmap-color"]),
                            "heatmap-opacity": new ja(Ya.paint_heatmap["heatmap-opacity"]),
                            "heatmap-color-use-theme": new qa({
                                type: "string",
                                default: "default",
                                "property-type": "data-driven"
                            })
                        }))
                    }, e, r, n), this._updateColorRamp();
                }
            },
            hillshade: class extends ps {
                shouldRedrape() {
                    return this.hasOffscreenPass() && "viewport" === this.paint.get("hillshade-illumination-anchor");
                }
                hasOffscreenPass() {
                    return 0 !== this.paint.get("hillshade-exaggeration") && "none" !== this.visibility;
                }
                getProgramIds() {
                    return [
                        "hillshade",
                        "hillshadePrepare"
                    ];
                }
                getDefaultProgramParams(t1, e, r) {
                    return {
                        overrideFog: !1
                    };
                }
                constructor(t1, e, r, n){
                    super(t1, {
                        layout: tc || (tc = new Ga({
                            visibility: new ja(Ya.layout_hillshade.visibility)
                        })),
                        paint: ec || (ec = new Ga({
                            "hillshade-illumination-direction": new ja(Ya.paint_hillshade["hillshade-illumination-direction"]),
                            "hillshade-illumination-anchor": new ja(Ya.paint_hillshade["hillshade-illumination-anchor"]),
                            "hillshade-exaggeration": new ja(Ya.paint_hillshade["hillshade-exaggeration"]),
                            "hillshade-shadow-color": new ja(Ya.paint_hillshade["hillshade-shadow-color"]),
                            "hillshade-highlight-color": new ja(Ya.paint_hillshade["hillshade-highlight-color"]),
                            "hillshade-accent-color": new ja(Ya.paint_hillshade["hillshade-accent-color"]),
                            "hillshade-emissive-strength": new ja(Ya.paint_hillshade["hillshade-emissive-strength"]),
                            "hillshade-shadow-color-use-theme": new qa({
                                type: "string",
                                default: "default",
                                "property-type": "data-driven"
                            }),
                            "hillshade-highlight-color-use-theme": new qa({
                                type: "string",
                                default: "default",
                                "property-type": "data-driven"
                            }),
                            "hillshade-accent-color-use-theme": new qa({
                                type: "string",
                                default: "default",
                                "property-type": "data-driven"
                            })
                        }))
                    }, e, r, n);
                }
            },
            fill: class extends ps {
                getProgramIds() {
                    const t1 = this.paint.get("fill-pattern"), e = t1 && t1.constantOr(1), r = [
                        e ? "fillPattern" : "fill"
                    ];
                    return this.paint.get("fill-antialias") && r.push(e && !this.getPaintProperty("fill-outline-color") ? "fillOutlinePattern" : "fillOutline"), r;
                }
                getDefaultProgramParams(t1, e, r) {
                    return {
                        config: new Oo(this, {
                            zoom: e,
                            lut: r
                        }),
                        overrideFog: !1
                    };
                }
                recalculate(t1, e) {
                    super.recalculate(t1, e);
                    const r = this.paint._values["fill-outline-color"];
                    "constant" === r.value.kind && void 0 === r.value.value && (this.paint._values["fill-outline-color"] = this.paint._values["fill-color"]);
                }
                createBucket(t1) {
                    return new Uc(t1);
                }
                queryRadius() {
                    return Zl(this.paint.get("fill-translate"));
                }
                queryIntersectsFeature(t1, e, r, n, i, a) {
                    return !t1.queryGeometry.isAboveHorizon && Dl(Hl(t1.tilespaceGeometry, this.paint.get("fill-translate"), this.paint.get("fill-translate-anchor"), a.angle, t1.pixelToTileUnitsFactor), n);
                }
                isTileClipped() {
                    return !0;
                }
                is3D() {
                    return 0 !== this.paint.get("fill-z-offset").constantOr(1);
                }
                constructor(t1, e, r, n){
                    super(t1, {
                        layout: jc || (jc = new Ga({
                            "fill-sort-key": new qa(Ya.layout_fill["fill-sort-key"]),
                            visibility: new ja(Ya.layout_fill.visibility),
                            "fill-elevation-reference": new ja(Ya.layout_fill["fill-elevation-reference"])
                        })),
                        paint: qc || (qc = new Ga({
                            "fill-antialias": new ja(Ya.paint_fill["fill-antialias"]),
                            "fill-opacity": new qa(Ya.paint_fill["fill-opacity"]),
                            "fill-color": new qa(Ya.paint_fill["fill-color"]),
                            "fill-outline-color": new qa(Ya.paint_fill["fill-outline-color"]),
                            "fill-translate": new ja(Ya.paint_fill["fill-translate"]),
                            "fill-translate-anchor": new ja(Ya.paint_fill["fill-translate-anchor"]),
                            "fill-pattern": new qa(Ya.paint_fill["fill-pattern"]),
                            "fill-emissive-strength": new ja(Ya.paint_fill["fill-emissive-strength"]),
                            "fill-z-offset": new qa(Ya.paint_fill["fill-z-offset"]),
                            "fill-color-use-theme": new qa({
                                type: "string",
                                default: "default",
                                "property-type": "data-driven"
                            }),
                            "fill-outline-color-use-theme": new qa({
                                type: "string",
                                default: "default",
                                "property-type": "data-driven"
                            })
                        }))
                    }, e, r, n);
                }
            },
            "fill-extrusion": class extends ps {
                createBucket(t1) {
                    return new Kh(t1);
                }
                queryRadius() {
                    return Zl(this.paint.get("fill-extrusion-translate"));
                }
                is3D() {
                    return !0;
                }
                hasShadowPass() {
                    return this.paint.get("fill-extrusion-cast-shadows");
                }
                cutoffRange() {
                    return this.paint.get("fill-extrusion-cutoff-fade-range");
                }
                canCastShadows() {
                    return !0;
                }
                getProgramIds() {
                    return [
                        this.paint.get("fill-extrusion-pattern").constantOr(1) ? "fillExtrusionPattern" : "fillExtrusion"
                    ];
                }
                queryIntersectsFeature(t1, e, r, n, i, a, s, o, l) {
                    const u = Wl(this.paint.get("fill-extrusion-translate"), this.paint.get("fill-extrusion-translate-anchor"), a.angle, t1.pixelToTileUnitsFactor), c = this.paint.get("fill-extrusion-height").evaluate(e, r), h = this.paint.get("fill-extrusion-base").evaluate(e, r), p = [
                        0,
                        0
                    ], f = o && a.elevation, d = a.elevation ? a.elevation.exaggeration() : 1, m = t1.tile.getBucket(this);
                    if (f && m instanceof Kh) {
                        const t1 = m.centroidVertexArray, e = l + 1;
                        e < t1.length && (p[0] = t1.geta_centroid_pos0(e), p[1] = t1.geta_centroid_pos1(e));
                    }
                    if (0 === p[0] && 1 === p[1]) return !1;
                    "globe" === a.projection.name && (n = sp([
                        n
                    ], [
                        new q(0, 0),
                        new q(Wr, Wr)
                    ], t1.tileID.canonical).map((t1)=>t1.polygon).flat());
                    const y = f ? o : null, [g, x] = function(t1, e, r, n, i, a, s, o, l, u, c) {
                        return "globe" === t1.projection.name ? function(t1, e, r, n, i, a, s, o, l, u, c) {
                            const h = [], p = [], f = t1.projection.upVectorScale(c, t1.center.lat, t1.worldSize).metersToTile, d = [
                                0,
                                0,
                                0,
                                1
                            ], m = [
                                0,
                                0,
                                0,
                                1
                            ], y = (t1, e, r, n)=>{
                                t1[0] = e, t1[1] = r, t1[2] = n, t1[3] = 1;
                            }, g = ap();
                            r > 0 && (r += g), n += g;
                            for (const g of e){
                                const e = [], x = [];
                                for (const h of g){
                                    const p = h.x + i.x, g = h.y + i.y, v = t1.projection.projectTilePoint(p, g, c), b = t1.projection.upVector(c, h.x, h.y);
                                    let _ = r, w = n;
                                    if (s) {
                                        const t1 = pp(p, g, r, n, s, o, l, u);
                                        _ += t1.base, w += t1.top;
                                    }
                                    0 !== r ? y(d, v.x + b[0] * f * _, v.y + b[1] * f * _, v.z + b[2] * f * _) : y(d, v.x, v.y, v.z), y(m, v.x + b[0] * f * w, v.y + b[1] * f * w, v.z + b[2] * f * w), O.vec3.transformMat4(d, d, a), O.vec3.transformMat4(m, m, a), e.push(new dh(d[0], d[1], d[2])), x.push(new dh(m[0], m[1], m[2]));
                                }
                                h.push(e), p.push(x);
                            }
                            return [
                                h,
                                p
                            ];
                        }(t1, e, r, n, i, a, s, o, l, u, c) : s ? function(t1, e, r, n, i, a, s, o, l) {
                            const u = [], c = [], h = [
                                0,
                                0,
                                0,
                                1
                            ];
                            for (const p of t1){
                                const t1 = [], f = [];
                                for (const u of p){
                                    const c = u.x + n.x, p = u.y + n.y, d = pp(c, p, e, r, a, s, o, l);
                                    h[0] = c, h[1] = p, h[2] = d.base, h[3] = 1, O.vec4.transformMat4(h, h, i), h[3] = Math.max(h[3], 1e-5);
                                    const m = new dh(h[0] / h[3], h[1] / h[3], h[2] / h[3]);
                                    h[0] = c, h[1] = p, h[2] = d.top, h[3] = 1, O.vec4.transformMat4(h, h, i), h[3] = Math.max(h[3], 1e-5);
                                    const y = new dh(h[0] / h[3], h[1] / h[3], h[2] / h[3]);
                                    t1.push(m), f.push(y);
                                }
                                u.push(t1), c.push(f);
                            }
                            return [
                                u,
                                c
                            ];
                        }(e, r, n, i, a, s, o, l, u) : function(t1, e, r, n, i) {
                            const a = [], s = [], o = i[8] * e, l = i[9] * e, u = i[10] * e, c = i[11] * e, h = i[8] * r, p = i[9] * r, f = i[10] * r, d = i[11] * r;
                            for (const e of t1){
                                const t1 = [], r = [];
                                for (const a of e){
                                    const e = a.x + n.x, s = a.y + n.y, m = i[0] * e + i[4] * s + i[12], y = i[1] * e + i[5] * s + i[13], g = i[2] * e + i[6] * s + i[14], x = i[3] * e + i[7] * s + i[15], v = m + o, b = y + l, _ = g + u, w = Math.max(x + c, 1e-5), M = m + h, A = y + p, S = g + f, I = Math.max(x + d, 1e-5);
                                    t1.push(new dh(v / w, b / w, _ / w)), r.push(new dh(M / I, A / I, S / I));
                                }
                                a.push(t1), s.push(r);
                            }
                            return [
                                a,
                                s
                            ];
                        }(e, r, n, i, a);
                    }(a, n, h, c, u, s, y, p, d, a.center.lat, t1.tileID.canonical), v = t1.queryGeometry;
                    return function(t1, e, r) {
                        let n = 1 / 0;
                        Dl(r, e) && (n = hp(r, e[0]));
                        for(let i = 0; i < e.length; i++){
                            const a = e[i], s = t1[i];
                            for(let t1 = 0; t1 < a.length - 1; t1++){
                                const e = a[t1], i = [
                                    e,
                                    a[t1 + 1],
                                    s[t1 + 1],
                                    s[t1],
                                    e
                                ];
                                Cl(r, i) && (n = Math.min(n, hp(r, i)));
                            }
                        }
                        return n !== 1 / 0 && n;
                    }(g, x, v.isPointQuery() ? v.screenBounds : v.screenGeometry);
                }
                constructor(t1, e, r, n){
                    super(t1, {
                        layout: lp || (lp = new Ga({
                            visibility: new ja(Ya["layout_fill-extrusion"].visibility),
                            "fill-extrusion-edge-radius": new ja(Ya["layout_fill-extrusion"]["fill-extrusion-edge-radius"])
                        })),
                        paint: up || (up = new Ga({
                            "fill-extrusion-opacity": new ja(Ya["paint_fill-extrusion"]["fill-extrusion-opacity"]),
                            "fill-extrusion-color": new qa(Ya["paint_fill-extrusion"]["fill-extrusion-color"]),
                            "fill-extrusion-translate": new ja(Ya["paint_fill-extrusion"]["fill-extrusion-translate"]),
                            "fill-extrusion-translate-anchor": new ja(Ya["paint_fill-extrusion"]["fill-extrusion-translate-anchor"]),
                            "fill-extrusion-pattern": new qa(Ya["paint_fill-extrusion"]["fill-extrusion-pattern"]),
                            "fill-extrusion-height": new qa(Ya["paint_fill-extrusion"]["fill-extrusion-height"]),
                            "fill-extrusion-base": new qa(Ya["paint_fill-extrusion"]["fill-extrusion-base"]),
                            "fill-extrusion-height-alignment": new ja(Ya["paint_fill-extrusion"]["fill-extrusion-height-alignment"]),
                            "fill-extrusion-base-alignment": new ja(Ya["paint_fill-extrusion"]["fill-extrusion-base-alignment"]),
                            "fill-extrusion-vertical-gradient": new ja(Ya["paint_fill-extrusion"]["fill-extrusion-vertical-gradient"]),
                            "fill-extrusion-ambient-occlusion-intensity": new ja(Ya["paint_fill-extrusion"]["fill-extrusion-ambient-occlusion-intensity"]),
                            "fill-extrusion-ambient-occlusion-radius": new ja(Ya["paint_fill-extrusion"]["fill-extrusion-ambient-occlusion-radius"]),
                            "fill-extrusion-ambient-occlusion-wall-radius": new ja(Ya["paint_fill-extrusion"]["fill-extrusion-ambient-occlusion-wall-radius"]),
                            "fill-extrusion-ambient-occlusion-ground-radius": new ja(Ya["paint_fill-extrusion"]["fill-extrusion-ambient-occlusion-ground-radius"]),
                            "fill-extrusion-ambient-occlusion-ground-attenuation": new ja(Ya["paint_fill-extrusion"]["fill-extrusion-ambient-occlusion-ground-attenuation"]),
                            "fill-extrusion-flood-light-color": new ja(Ya["paint_fill-extrusion"]["fill-extrusion-flood-light-color"]),
                            "fill-extrusion-flood-light-intensity": new ja(Ya["paint_fill-extrusion"]["fill-extrusion-flood-light-intensity"]),
                            "fill-extrusion-flood-light-wall-radius": new qa(Ya["paint_fill-extrusion"]["fill-extrusion-flood-light-wall-radius"]),
                            "fill-extrusion-flood-light-ground-radius": new qa(Ya["paint_fill-extrusion"]["fill-extrusion-flood-light-ground-radius"]),
                            "fill-extrusion-flood-light-ground-attenuation": new ja(Ya["paint_fill-extrusion"]["fill-extrusion-flood-light-ground-attenuation"]),
                            "fill-extrusion-vertical-scale": new ja(Ya["paint_fill-extrusion"]["fill-extrusion-vertical-scale"]),
                            "fill-extrusion-rounded-roof": new ja(Ya["paint_fill-extrusion"]["fill-extrusion-rounded-roof"]),
                            "fill-extrusion-cutoff-fade-range": new ja(Ya["paint_fill-extrusion"]["fill-extrusion-cutoff-fade-range"]),
                            "fill-extrusion-emissive-strength": new qa(Ya["paint_fill-extrusion"]["fill-extrusion-emissive-strength"]),
                            "fill-extrusion-line-width": new qa(Ya["paint_fill-extrusion"]["fill-extrusion-line-width"]),
                            "fill-extrusion-cast-shadows": new ja(Ya["paint_fill-extrusion"]["fill-extrusion-cast-shadows"]),
                            "fill-extrusion-color-use-theme": new qa({
                                type: "string",
                                default: "default",
                                "property-type": "data-driven"
                            }),
                            "fill-extrusion-flood-light-color-use-theme": new qa({
                                type: "string",
                                default: "default",
                                "property-type": "data-driven"
                            })
                        }))
                    }, e, r, n), this._stats = {
                        numRenderedVerticesInShadowPass: 0,
                        numRenderedVerticesInTransparentPass: 0
                    };
                }
            },
            line: class extends ps {
                _handleSpecialPaintPropertyUpdate(t1) {
                    if ("line-gradient" === t1) {
                        const t1 = this._transitionablePaint._values["line-gradient"].value.expression;
                        this.stepInterpolant = t1._styleExpression && t1._styleExpression.expression instanceof Nn, this.gradientVersion = (this.gradientVersion + 1) % Number.MAX_SAFE_INTEGER;
                    }
                }
                gradientExpression() {
                    return this._transitionablePaint._values["line-gradient"].value.expression;
                }
                widthExpression() {
                    return this._transitionablePaint._values["line-width"].value.expression;
                }
                recalculate(t1, e) {
                    super.recalculate(t1, e), this.paint._values["line-floorwidth"] = (()=>{
                        if (Rp) return Rp;
                        const t1 = Dp();
                        return Rp = new Lp(t1.paint.properties["line-width"].specification), Rp.useIntegerZoom = !0, Rp;
                    })().possiblyEvaluate(this._transitioningPaint._values["line-width"].value, t1);
                }
                createBucket(t1) {
                    return new Ap(t1);
                }
                getProgramIds() {
                    return [
                        this.paint.get("line-pattern").constantOr(1) ? "linePattern" : "line"
                    ];
                }
                getDefaultProgramParams(t1, e, r) {
                    const n = Bp(this);
                    return {
                        config: new Oo(this, {
                            zoom: e,
                            lut: r
                        }),
                        defines: n,
                        overrideFog: !1
                    };
                }
                queryRadius(t1) {
                    const e = t1, r = Fp(Xl("line-width", this, e), Xl("line-gap-width", this, e)), n = Xl("line-offset", this, e);
                    return r / 2 + Math.abs(n) + Zl(this.paint.get("line-translate"));
                }
                queryIntersectsFeature(t1, e, r, n, i, a) {
                    if (t1.queryGeometry.isAboveHorizon) return !1;
                    const s = Hl(t1.tilespaceGeometry, this.paint.get("line-translate"), this.paint.get("line-translate-anchor"), a.angle, t1.pixelToTileUnitsFactor), o = t1.pixelToTileUnitsFactor / 2 * Fp(this.paint.get("line-width").evaluate(e, r), this.paint.get("line-gap-width").evaluate(e, r)), l = this.paint.get("line-offset").evaluate(e, r);
                    return l && (n = function(t1, e) {
                        const r = [], n = new q(0, 0);
                        for(let i = 0; i < t1.length; i++){
                            const a = t1[i], s = [];
                            for(let t1 = 0; t1 < a.length; t1++){
                                const r = a[t1], i = a[t1 + 1], o = 0 === t1 ? n : r.sub(a[t1 - 1])._unit()._perp(), l = t1 === a.length - 1 ? n : i.sub(r)._unit()._perp(), u = o._add(l)._unit();
                                u._mult(1 / (u.x * l.x + u.y * l.y)), s.push(u._mult(e)._add(r));
                            }
                            r.push(s);
                        }
                        return r;
                    }(n, l * t1.pixelToTileUnitsFactor)), function(t1, e, r) {
                        for(let n = 0; n < e.length; n++){
                            const i = e[n];
                            if (t1.length >= 3) {
                                for(let e = 0; e < i.length; e++)if (jl(t1, i[e])) return !0;
                            }
                            if (Ll(t1, i, r)) return !0;
                        }
                        return !1;
                    }(s, n, o);
                }
                isTileClipped() {
                    return !0;
                }
                isDraped(t1) {
                    return !this.hasElevatedBuckets;
                }
                constructor(t1, e, r, n){
                    const i = Dp();
                    super(t1, i, e, r, n), i.layout && (this.layout = new Ua(i.layout)), this.gradientVersion = 0, this.hasElevatedBuckets = !1, this.hasNonElevatedBuckets = !1;
                }
            },
            symbol: sm,
            background: class extends ps {
                getProgramIds() {
                    return [
                        this.paint.get("background-pattern") ? "backgroundPattern" : "background"
                    ];
                }
                getDefaultProgramParams(t1, e, r) {
                    return {
                        overrideFog: !1
                    };
                }
                is3D() {
                    return "viewport" === this.paint.get("background-pitch-alignment");
                }
                constructor(t1, e, r, n){
                    super(t1, {
                        layout: om || (om = new Ga({
                            visibility: new ja(Ya.layout_background.visibility)
                        })),
                        paint: lm || (lm = new Ga({
                            "background-pitch-alignment": new ja(Ya.paint_background["background-pitch-alignment"]),
                            "background-color": new ja(Ya.paint_background["background-color"]),
                            "background-pattern": new ja(Ya.paint_background["background-pattern"]),
                            "background-opacity": new ja(Ya.paint_background["background-opacity"]),
                            "background-emissive-strength": new ja(Ya.paint_background["background-emissive-strength"]),
                            "background-color-use-theme": new qa({
                                type: "string",
                                default: "default",
                                "property-type": "data-driven"
                            })
                        }))
                    }, e, r, n);
                }
            },
            raster: _m,
            "raster-particle": Pm,
            sky: class extends ps {
                _handleSpecialPaintPropertyUpdate(t1) {
                    "sky-gradient" === t1 ? this._updateColorRamp() : "sky-atmosphere-sun" !== t1 && "sky-atmosphere-halo-color" !== t1 && "sky-atmosphere-color" !== t1 && "sky-atmosphere-sun-intensity" !== t1 || (this._skyboxInvalidated = !0);
                }
                _updateColorRamp() {
                    this.colorRamp = lc({
                        expression: this._transitionablePaint._values["sky-gradient"].value.expression,
                        evaluationKey: "skyRadialProgress"
                    }), this.colorRampTexture && (this.colorRampTexture.destroy(), this.colorRampTexture = null);
                }
                needsSkyboxCapture(t1) {
                    if (this._skyboxInvalidated || !this.skyboxTexture || !this.skyboxGeometry) return !0;
                    if (!this.paint.get("sky-atmosphere-sun")) {
                        const e = t1.style.light.properties.get("position");
                        return this._lightPosition.azimuthal !== e.azimuthal || this._lightPosition.polar !== e.polar;
                    }
                    return !1;
                }
                getCenter(t1, e) {
                    if ("atmosphere" === this.paint.get("sky-type")) {
                        const r = this.paint.get("sky-atmosphere-sun"), n = !r, i = t1.style.light, a = i.properties.get("position");
                        return n && "viewport" === i.properties.get("anchor") && ft("The sun direction is attached to a light with viewport anchor, lighting may behave unexpectedly."), n ? Em(a.azimuthal, 90 - a.polar, e) : Em(r[0], 90 - r[1], e);
                    }
                    const r = this.paint.get("sky-gradient-center");
                    return Em(r[0], 90 - r[1], e);
                }
                isSky() {
                    return !0;
                }
                markSkyboxValid(t1) {
                    this._skyboxInvalidated = !1, this._lightPosition = t1.style.light.properties.get("position");
                }
                hasOffscreenPass() {
                    return !0;
                }
                getProgramIds() {
                    const t1 = this.paint.get("sky-type");
                    return "atmosphere" === t1 ? [
                        "skyboxCapture",
                        "skybox"
                    ] : "gradient" === t1 ? [
                        "skyboxGradient"
                    ] : null;
                }
                constructor(t1, e, r, n){
                    super(t1, {
                        layout: Am || (Am = new Ga({
                            visibility: new ja(Ya.layout_sky.visibility)
                        })),
                        paint: Sm || (Sm = new Ga({
                            "sky-type": new ja(Ya.paint_sky["sky-type"]),
                            "sky-atmosphere-sun": new ja(Ya.paint_sky["sky-atmosphere-sun"]),
                            "sky-atmosphere-sun-intensity": new ja(Ya.paint_sky["sky-atmosphere-sun-intensity"]),
                            "sky-gradient-center": new ja(Ya.paint_sky["sky-gradient-center"]),
                            "sky-gradient-radius": new ja(Ya.paint_sky["sky-gradient-radius"]),
                            "sky-gradient": new $a(Ya.paint_sky["sky-gradient"]),
                            "sky-atmosphere-halo-color": new ja(Ya.paint_sky["sky-atmosphere-halo-color"]),
                            "sky-atmosphere-color": new ja(Ya.paint_sky["sky-atmosphere-color"]),
                            "sky-opacity": new ja(Ya.paint_sky["sky-opacity"]),
                            "sky-gradient-use-theme": new qa({
                                type: "string",
                                default: "default",
                                "property-type": "data-driven"
                            }),
                            "sky-atmosphere-halo-color-use-theme": new qa({
                                type: "string",
                                default: "default",
                                "property-type": "data-driven"
                            }),
                            "sky-atmosphere-color-use-theme": new qa({
                                type: "string",
                                default: "default",
                                "property-type": "data-driven"
                            })
                        }))
                    }, e, r, n), this._updateColorRamp();
                }
            },
            slot: class extends ps {
                constructor(t1, e, r, n){
                    super(t1, {
                        paint: Im || (Im = new Ga({}))
                    }, e, null);
                }
            },
            model: class extends ps {
                createBucket(t1) {
                    return new Jm(t1);
                }
                getProgramIds() {
                    return [
                        "model"
                    ];
                }
                is3D() {
                    return !0;
                }
                hasShadowPass() {
                    return !0;
                }
                canCastShadows() {
                    return !0;
                }
                hasLightBeamPass() {
                    return !0;
                }
                cutoffRange() {
                    return this.paint.get("model-cutoff-fade-range");
                }
                queryRadius(t1) {
                    return t1 instanceof yy ? Wr - 1 : 0;
                }
                queryIntersectsFeature(t1, e, r, n, i, a) {
                    if (!this.modelManager) return !1;
                    const s = this.modelManager, o = t1.tile.getBucket(this);
                    if (!(o && o instanceof Jm)) return !1;
                    for(const r in o.instancesPerModel){
                        const n = o.instancesPerModel[r], i = void 0 !== e.id ? e.id : e.properties && e.properties.hasOwnProperty("id") ? e.properties.id : void 0;
                        if (n.idToFeaturesIndex.hasOwnProperty(i)) {
                            const e = n.features[n.idToFeaturesIndex[i]], l = s.getModel(r, this.scope);
                            if (!l) return !1;
                            let u = O.mat4.create();
                            const c = new il(0, 0), h = o.canonical;
                            let p = Number.MAX_VALUE;
                            for(let r = 0; r < e.instancedDataCount; ++r){
                                const i = 16 * (e.instancedDataOffset + r), s = n.instancedDataArray.float32, o = [
                                    s[i + 4],
                                    s[i + 5],
                                    s[i + 6]
                                ];
                                by(h, c, s[i], 0 | s[i + 1]), ny(u, l, a, c, e.rotation, e.scale, o, !1, !1, !1), "globe" === a.projection.name && (u = Fm(u, a));
                                const f = O.mat4.multiply([], a.projMatrix, u), d = t1.queryGeometry, m = Om(d.isPointQuery() ? d.screenBounds : d.screenGeometry, a, f, l.aabb);
                                null != m && (p = Math.min(m, p));
                            }
                            return p !== Number.MAX_VALUE && p;
                        }
                    }
                    return !1;
                }
                _handleOverridablePaintPropertyUpdate(t1, e, r) {
                    return !(!this.layout || e.isDataDriven() || r.isDataDriven() || "model-color" !== t1 && "model-color-mix-intensity" !== t1 && "model-rotation" !== t1 && "model-scale" !== t1 && "model-translation" !== t1 && "model-emissive-strength" !== t1);
                }
                _isPropertyZoomDependent(t1) {
                    const e = this._transitionablePaint._values[t1];
                    return null != e && null != e.value && null != e.value.expression && e.value.expression instanceof Ji;
                }
                isZoomDependent() {
                    return this._isPropertyZoomDependent("model-scale") || this._isPropertyZoomDependent("model-rotation") || this._isPropertyZoomDependent("model-translation");
                }
                constructor(t1, e, r, n){
                    super(t1, {
                        layout: Qm || (Qm = new Ga({
                            visibility: new ja(Ya.layout_model.visibility),
                            "model-id": new qa(Ya.layout_model["model-id"])
                        })),
                        paint: ty || (ty = new Ga({
                            "model-opacity": new qa(Ya.paint_model["model-opacity"]),
                            "model-rotation": new qa(Ya.paint_model["model-rotation"]),
                            "model-scale": new qa(Ya.paint_model["model-scale"]),
                            "model-translation": new qa(Ya.paint_model["model-translation"]),
                            "model-color": new qa(Ya.paint_model["model-color"]),
                            "model-color-mix-intensity": new qa(Ya.paint_model["model-color-mix-intensity"]),
                            "model-type": new ja(Ya.paint_model["model-type"]),
                            "model-cast-shadows": new ja(Ya.paint_model["model-cast-shadows"]),
                            "model-receive-shadows": new ja(Ya.paint_model["model-receive-shadows"]),
                            "model-ambient-occlusion-intensity": new ja(Ya.paint_model["model-ambient-occlusion-intensity"]),
                            "model-emissive-strength": new qa(Ya.paint_model["model-emissive-strength"]),
                            "model-roughness": new qa(Ya.paint_model["model-roughness"]),
                            "model-height-based-emissive-strength-multiplier": new qa(Ya.paint_model["model-height-based-emissive-strength-multiplier"]),
                            "model-cutoff-fade-range": new ja(Ya.paint_model["model-cutoff-fade-range"]),
                            "model-front-cutoff": new ja(Ya.paint_model["model-front-cutoff"]),
                            "model-color-use-theme": new qa({
                                type: "string",
                                default: "default",
                                "property-type": "data-driven"
                            })
                        }))
                    }, e, r, n), this._stats = {
                        numRenderedVerticesInShadowPass: 0,
                        numRenderedVerticesInTransparentPass: 0
                    };
                }
            },
            clip: class extends ps {
                recalculate(t1, e) {
                    super.recalculate(t1, e);
                }
                createBucket(t1) {
                    return new Zc(t1);
                }
                isTileClipped() {
                    return !0;
                }
                is3D() {
                    return !0;
                }
                constructor(t1, e, r, n){
                    super(t1, {
                        layout: $c || ($c = new Ga({
                            "clip-layer-types": new ja(Ya.layout_clip["clip-layer-types"]),
                            "clip-layer-scope": new ja(Ya.layout_clip["clip-layer-scope"])
                        })),
                        paint: Gc || (Gc = new Ga({}))
                    }, e, r, n);
                }
            }
        };
        class wy {
            trigger() {
                this._triggered || (this._triggered = !0, this._channel ? this._channel.port1.postMessage(!0) : setTimeout(()=>{
                    this._triggered = !1, this._callback();
                }, 0));
            }
            remove() {
                this._channel = void 0, this._callback = ()=>{};
            }
            constructor(t1){
                this._callback = t1, this._triggered = !1, "undefined" != typeof MessageChannel && (this._channel = new MessageChannel, this._channel.port2.onmessage = ()=>{
                    this._triggered = !1, this._callback();
                });
            }
        }
        class My {
            add(t1, e) {
                const r = this.nextId++, n = function({ type: t1, isSymbolTile: e, zoom: r }) {
                    return r = r || 0, "message" === t1 ? 0 : "maybePrepare" !== t1 || e ? "parseTile" !== t1 || e ? "parseTile" === t1 && e ? 300 - r : "maybePrepare" === t1 && e ? 400 - r : 500 : 200 - r : 100 - r;
                }(e);
                if (0 === n) {
                    t1();
                    return null;
                }
                return this.tasks[r] = {
                    fn: t1,
                    metadata: e,
                    priority: n,
                    id: r
                }, this.taskQueue.push(r), this.invoker.trigger(), {
                    cancel: ()=>{
                        delete this.tasks[r];
                    }
                };
            }
            process() {
                {
                    if (this.taskQueue = this.taskQueue.filter((t1)=>!!this.tasks[t1]), !this.taskQueue.length) return;
                    const t1 = this.pick();
                    if (null === t1) return;
                    const e = this.tasks[t1];
                    if (delete this.tasks[t1], this.taskQueue.length && this.invoker.trigger(), !e) return;
                    e.fn();
                }
            }
            pick() {
                let t1 = null, e = 1 / 0;
                for(let r = 0; r < this.taskQueue.length; r++){
                    const n = this.tasks[this.taskQueue[r]];
                    n.priority < e && (e = n.priority, t1 = r);
                }
                if (null === t1) return null;
                const r = this.taskQueue[t1];
                return this.taskQueue.splice(t1, 1), r;
            }
            remove() {
                this.invoker.remove();
            }
            constructor(){
                this.tasks = {}, this.taskQueue = [], ot([
                    "process"
                ], this), this.invoker = new wy(this.process), this.nextId = 0;
            }
        }
        class Ay {
            send(t1, e, r, n, i = !1, a) {
                const s = Math.round(1e18 * Math.random()).toString(36).substring(0, 10);
                r && (r.metadata = a, this.callbacks[s] = r);
                const o = new Set;
                return this.target.postMessage({
                    id: s,
                    type: t1,
                    hasCallback: !!r,
                    targetMapId: n,
                    mustQueue: i,
                    sourceMapId: this.mapId,
                    data: ca(e, o)
                }, o), {
                    cancel: ()=>{
                        r && delete this.callbacks[s], this.target.postMessage({
                            id: s,
                            type: "<cancel>",
                            targetMapId: n,
                            sourceMapId: this.mapId
                        });
                    }
                };
            }
            receive(t1) {
                const e = t1.data, r = e.id;
                if (r && (!e.targetMapId || this.mapId === e.targetMapId)) {
                    if ("<cancel>" === e.type) {
                        const t1 = this.cancelCallbacks[r];
                        delete this.cancelCallbacks[r], t1 && t1.cancel();
                    } else if (e.mustQueue || gt()) {
                        const t1 = this.callbacks[r], n = this.scheduler.add(()=>this.processTask(r, e), t1 && t1.metadata || {
                            type: "message"
                        });
                        n && (this.cancelCallbacks[r] = n);
                    } else this.processTask(r, e);
                }
            }
            processTask(t1, e) {
                if (delete this.cancelCallbacks[t1], "<response>" === e.type) {
                    const r = this.callbacks[t1];
                    delete this.callbacks[t1], r && (e.error ? r(ha(e.error)) : r(null, ha(e.data)));
                } else {
                    const r = new Set, n = e.hasCallback ? (e, n)=>{
                        this.target.postMessage({
                            id: t1,
                            type: "<response>",
                            sourceMapId: this.mapId,
                            error: e ? ca(e) : null,
                            data: ca(n, r)
                        }, r);
                    } : ()=>{}, i = ha(e.data);
                    if (this.parent[e.type]) this.parent[e.type](e.sourceMapId, i, n);
                    else if (this.parent.getWorkerSource) {
                        const t1 = e.type.split(".");
                        this.parent.getWorkerSource(e.sourceMapId, t1[0], i.source, i.scope)[t1[1]](i, n);
                    } else n(new Error(`Could not find function ${e.type}`));
                }
            }
            remove() {
                this.scheduler.remove(), this.target.removeEventListener("message", this.receive, !1);
            }
            constructor(t1, e, r){
                this.target = t1, this.parent = e, this.mapId = r, this.callbacks = {}, this.cancelCallbacks = {}, ot([
                    "receive"
                ], this), this.target.addEventListener("message", this.receive, !1), this.scheduler = new My;
            }
        }
        var Sy = {
            workerUrl: "",
            workerClass: null,
            workerParams: void 0
        };
        const Iy = "mapboxgl_preloaded_worker_pool";
        class Py {
            acquire(t1, e = Py.workerCount) {
                if (!this.workers) for(this.workers = []; this.workers.length < e;)this.workers.push(null != Sy.workerClass ? new Sy.workerClass : new self.Worker(Sy.workerUrl, Sy.workerParams));
                return this.active[t1] = !0, this.workers.slice();
            }
            release(t1) {
                delete this.active[t1], this.workers && 0 === this.numActive() && (this.workers.forEach((t1)=>{
                    t1.terminate();
                }), this.workers = null);
            }
            isPreloaded() {
                return !!this.active[Iy];
            }
            numActive() {
                return Object.keys(this.active).length;
            }
            constructor(){
                this.active = {};
            }
        }
        Py.workerCount = 2;
        class zy {
            broadcast(t1, e, r) {
                rt(this.actors, (r, n)=>{
                    r.send(t1, e, n);
                }, r = r || function() {});
            }
            getActor() {
                return this.currentActor = (this.currentActor + 1) % this.actors.length, this.actors[this.currentActor];
            }
            remove() {
                this.actors.forEach((t1)=>{
                    t1.remove();
                }), this.actors = [], this.workerPool.release(this.id);
            }
            constructor(t1, e, r = "Worker", n = Py.workerCount){
                this.workerPool = t1, this.actors = [], this.currentActor = 0, this.id = at();
                const i = this.workerPool.acquire(this.id, n);
                for(let t1 = 0; t1 < i.length; t1++){
                    const n = new zy.Actor(i[t1], e, this.id);
                    n.name = `${r} ${t1}`, this.actors.push(n);
                }
                this.ready = !1, this.broadcast("checkIfReady", null, ()=>{
                    this.ready = !0;
                });
            }
        }
        let Ey, ky;
        function Ty() {
            return Ey || (Ey = new Py), Ey;
        }
        zy.Actor = Ay;
        const By = new Ie(0, 0, 0);
        var Cy = ((t1)=>(t1[t1.PATH_RULE_UNSPECIFIED = 0] = "PATH_RULE_UNSPECIFIED", t1[t1.PATH_RULE_NON_ZERO = 1] = "PATH_RULE_NON_ZERO", t1[t1.PATH_RULE_EVEN_ODD = 2] = "PATH_RULE_EVEN_ODD", t1))(Cy || {}), Vy = ((t1)=>(t1[t1.LINE_CAP_UNSPECIFIED = 0] = "LINE_CAP_UNSPECIFIED", t1[t1.LINE_CAP_BUTT = 1] = "LINE_CAP_BUTT", t1[t1.LINE_CAP_ROUND = 2] = "LINE_CAP_ROUND", t1[t1.LINE_CAP_SQUARE = 3] = "LINE_CAP_SQUARE", t1))(Vy || {}), Dy = ((t1)=>(t1[t1.LINE_JOIN_UNSPECIFIED = 0] = "LINE_JOIN_UNSPECIFIED", t1[t1.LINE_JOIN_MITER = 1] = "LINE_JOIN_MITER", t1[t1.LINE_JOIN_MITER_CLIP = 2] = "LINE_JOIN_MITER_CLIP", t1[t1.LINE_JOIN_ROUND = 3] = "LINE_JOIN_ROUND", t1[t1.LINE_JOIN_BEVEL = 4] = "LINE_JOIN_BEVEL", t1))(Dy || {}), Ly = ((t1)=>(t1[t1.PAINT_ORDER_UNSPECIFIED = 0] = "PAINT_ORDER_UNSPECIFIED", t1[t1.PAINT_ORDER_FILL_AND_STROKE = 1] = "PAINT_ORDER_FILL_AND_STROKE", t1[t1.PAINT_ORDER_STROKE_AND_FILL = 2] = "PAINT_ORDER_STROKE_AND_FILL", t1))(Ly || {}), Ry = ((t1)=>(t1[t1.PATH_COMMAND_UNSPECIFIED = 0] = "PATH_COMMAND_UNSPECIFIED", t1[t1.PATH_COMMAND_MOVE = 1] = "PATH_COMMAND_MOVE", t1[t1.PATH_COMMAND_LINE = 2] = "PATH_COMMAND_LINE", t1[t1.PATH_COMMAND_QUAD = 3] = "PATH_COMMAND_QUAD", t1[t1.PATH_COMMAND_CUBIC = 4] = "PATH_COMMAND_CUBIC", t1[t1.PATH_COMMAND_CLOSE = 5] = "PATH_COMMAND_CLOSE", t1))(Ry || {}), Fy = ((t1)=>(t1[t1.MASK_TYPE_UNSPECIFIED = 0] = "MASK_TYPE_UNSPECIFIED", t1[t1.MASK_TYPE_LUMINANCE = 1] = "MASK_TYPE_LUMINANCE", t1[t1.MASK_TYPE_ALPHA = 2] = "MASK_TYPE_ALPHA", t1))(Fy || {});
        function Oy(t1, e, r) {
            1 === t1 && e.icons.push(function(t1, e) {
                return function(t1) {
                    if (t1.usvg_tree.height || (t1.usvg_tree.height = t1.usvg_tree.width), !t1.metadata) return t1;
                    const { metadata: e } = t1;
                    if (e.content_area) {
                        const { content_area: r } = e;
                        null == r.top && (r.top = r.left), null == r.width && (r.width = t1.usvg_tree.width), null == r.height && (r.height = r.width);
                    }
                    return e.stretch_x && e.stretch_x.length && Ny(e, "x"), e.stretch_y && e.stretch_y.length && Ny(e, "y"), t1;
                }(t1.readFields(Uy, {
                    name: void 0
                }, e));
            }(r, r.readVarint() + r.pos));
        }
        function Ny(t1, e) {
            const r = [], n = t1[`stretch_${e}`];
            let i = null;
            for(let t1 = 0; t1 < n.length; t1++)null === i ? i = 0 === r.length ? n[0] : r[r.length - 1][1] + n[t1] : (r.push([
                i,
                i + n[t1]
            ]), i = null);
            t1[`stretch_${e}_areas`] = r;
        }
        function Uy(t1, e, r) {
            1 === t1 ? e.name = r.readString() : 2 === t1 ? e.metadata = function(t1, e) {
                return t1.readFields(jy, {
                    stretch_x: null,
                    stretch_y: null,
                    stretch_x_areas: null,
                    stretch_y_areas: null,
                    variables: []
                }, e);
            }(r, r.readVarint() + r.pos) : 3 === t1 && (e.usvg_tree = function(t1, e) {
                return t1.readFields(Gy, {
                    width: 20,
                    children: [],
                    linear_gradients: [],
                    radial_gradients: [],
                    clip_paths: [],
                    masks: []
                }, e);
            }(r, r.readVarint() + r.pos), e.data = "usvg_tree");
        }
        function jy(t1, e, r) {
            1 === t1 ? e.stretch_x = r.readPackedVarint() : 2 === t1 ? e.stretch_y = r.readPackedVarint() : 3 === t1 ? e.content_area = function(t1, e) {
                return t1.readFields(qy, {
                    left: 0
                }, e);
            }(r, r.readVarint() + r.pos) : 4 === t1 && e.variables.push(function(t1, e) {
                return t1.readFields($y, {
                    name: void 0
                }, e);
            }(r, r.readVarint() + r.pos));
        }
        function qy(t1, e, r) {
            1 === t1 ? e.left = r.readVarint() : 2 === t1 ? e.width = r.readVarint() : 3 === t1 ? e.top = r.readVarint() : 4 === t1 && (e.height = r.readVarint());
        }
        function $y(t1, e, r) {
            1 === t1 ? e.name = r.readString() : 2 === t1 && (e.rgb_color = Qy(r.readVarint()), e.value = "rgb_color");
        }
        function Gy(t1, e, r) {
            1 === t1 ? e.width = e.height = r.readVarint() : 2 === t1 ? e.height = r.readVarint() : 3 === t1 ? e.children.push(Yy(r, r.readVarint() + r.pos)) : 4 === t1 ? e.linear_gradients.push(function(t1, e) {
                return t1.readFields(eg, {
                    spread_method: 1,
                    stops: [],
                    x1: 0,
                    y1: 0,
                    x2: 1,
                    y2: 0
                }, e);
            }(r, r.readVarint() + r.pos)) : 5 === t1 ? e.radial_gradients.push(function(t1, e) {
                return t1.readFields(ig, {
                    spread_method: 1,
                    stops: [],
                    cx: .5,
                    cy: .5,
                    r: .5,
                    fx: .5,
                    fy: .5,
                    fr: 0
                }, e);
            }(r, r.readVarint() + r.pos)) : 7 === t1 ? e.clip_paths.push(function(t1, e) {
                return t1.readFields(ag, {
                    children: []
                }, e);
            }(r, r.readVarint() + r.pos)) : 8 === t1 && e.masks.push(function(t1, e) {
                const r = t1.readFields(sg, {
                    left: 0,
                    width: 20,
                    mask_type: 1,
                    children: []
                }, e);
                return null == r.height && (r.height = r.width), null == r.top && (r.top = r.left), r;
            }(r, r.readVarint() + r.pos));
        }
        function Yy(t1, e) {
            return t1.readFields(Xy, {}, e);
        }
        function Xy(t1, e, r) {
            1 === t1 ? (e.group = function(t1, e) {
                return t1.readFields(Zy, {
                    opacity: 255,
                    children: []
                }, e);
            }(r, r.readVarint() + r.pos), e.node = "group") : 2 === t1 && (e.path = function(t1, e) {
                return t1.readFields(Ky, {
                    paint_order: 1,
                    commands: [],
                    step: 1,
                    diffs: [],
                    rule: 1
                }, e);
            }(r, r.readVarint() + r.pos), e.node = "path");
        }
        function Zy(t1, e, r) {
            1 === t1 ? e.transform = Hy(r, r.readVarint() + r.pos) : 2 === t1 ? e.opacity = r.readVarint() : 5 === t1 ? e.clip_path_idx = r.readVarint() : 6 === t1 ? e.mask_idx = r.readVarint() : 7 === t1 && e.children.push(Yy(r, r.readVarint() + r.pos));
        }
        function Hy(t1, e) {
            return t1.readFields(Wy, {
                sx: 1,
                ky: 0,
                kx: 0,
                sy: 1,
                tx: 0,
                ty: 0
            }, e);
        }
        function Wy(t1, e, r) {
            1 === t1 ? e.sx = r.readFloat() : 2 === t1 ? e.ky = r.readFloat() : 3 === t1 ? e.kx = r.readFloat() : 4 === t1 ? e.sy = r.readFloat() : 5 === t1 ? e.tx = r.readFloat() : 6 === t1 && (e.ty = r.readFloat());
        }
        function Ky(t1, e, r) {
            1 === t1 ? e.fill = function(t1, e) {
                return t1.readFields(Jy, {
                    rgb_color: By,
                    paint: "rgb_color",
                    opacity: 255
                }, e);
            }(r, r.readVarint() + r.pos) : 2 === t1 ? e.stroke = function(t1, e) {
                return t1.readFields(tg, {
                    rgb_color: By,
                    paint: "rgb_color",
                    dasharray: [],
                    dashoffset: 0,
                    miterlimit: 4,
                    opacity: 255,
                    width: 1,
                    linecap: 1,
                    linejoin: 1
                }, e);
            }(r, r.readVarint() + r.pos) : 3 === t1 ? e.paint_order = r.readVarint() : 5 === t1 ? r.readPackedVarint(e.commands) : 6 === t1 ? e.step = r.readFloat() : 7 === t1 ? r.readPackedSVarint(e.diffs) : 8 === t1 && (e.rule = r.readVarint());
        }
        function Jy(t1, e, r) {
            1 === t1 ? (e.rgb_color = Qy(r.readVarint()), e.paint = "rgb_color") : 2 === t1 ? (e.linear_gradient_idx = r.readVarint(), e.paint = "linear_gradient_idx") : 3 === t1 ? (e.radial_gradient_idx = r.readVarint(), e.paint = "radial_gradient_idx") : 5 === t1 && (e.opacity = r.readVarint());
        }
        function Qy(t1) {
            return new Ie((t1 >> 16 & 255) / 255, (t1 >> 8 & 255) / 255, (255 & t1) / 255, 1);
        }
        function tg(t1, e, r) {
            1 === t1 ? (e.rgb_color = Qy(r.readVarint()), e.paint = "rgb_color") : 2 === t1 ? (e.linear_gradient_idx = r.readVarint(), e.paint = "linear_gradient_idx") : 3 === t1 ? (e.radial_gradient_idx = r.readVarint(), e.paint = "radial_gradient_idx") : 5 === t1 ? r.readPackedFloat(e.dasharray) : 6 === t1 ? e.dashoffset = r.readFloat() : 7 === t1 ? e.miterlimit = r.readFloat() : 8 === t1 ? e.opacity = r.readVarint() : 9 === t1 ? e.width = r.readFloat() : 10 === t1 ? e.linecap = r.readVarint() : 11 === t1 && (e.linejoin = r.readVarint());
        }
        function eg(t1, e, r) {
            1 === t1 ? e.transform = Hy(r, r.readVarint() + r.pos) : 2 === t1 ? e.spread_method = r.readVarint() : 3 === t1 ? e.stops.push(rg(r, r.readVarint() + r.pos)) : 4 === t1 ? e.x1 = r.readFloat() : 5 === t1 ? e.y1 = r.readFloat() : 6 === t1 ? e.x2 = r.readFloat() : 7 === t1 && (e.y2 = r.readFloat());
        }
        function rg(t1, e) {
            return t1.readFields(ng, {
                offset: 0,
                opacity: 255,
                rgb_color: By
            }, e);
        }
        function ng(t1, e, r) {
            1 === t1 ? e.offset = r.readFloat() : 2 === t1 ? e.opacity = r.readVarint() : 3 === t1 && (e.rgb_color = Qy(r.readVarint()));
        }
        function ig(t1, e, r) {
            1 === t1 ? e.transform = Hy(r, r.readVarint() + r.pos) : 2 === t1 ? e.spread_method = r.readVarint() : 3 === t1 ? e.stops.push(rg(r, r.readVarint() + r.pos)) : 4 === t1 ? e.cx = r.readFloat() : 5 === t1 ? e.cy = r.readFloat() : 6 === t1 ? e.r = r.readFloat() : 7 === t1 ? e.fx = r.readFloat() : 8 === t1 ? e.fy = r.readFloat() : 9 === t1 && (e.fr = r.readFloat());
        }
        function ag(t1, e, r) {
            1 === t1 ? e.transform = Hy(r, r.readVarint() + r.pos) : 2 === t1 ? e.clip_path_idx = r.readVarint() : 3 === t1 && e.children.push(Yy(r, r.readVarint() + r.pos));
        }
        function sg(t1, e, r) {
            1 === t1 ? e.left = e.top = r.readFloat() : 2 === t1 ? e.width = e.height = r.readFloat() : 3 === t1 ? e.top = r.readFloat() : 4 === t1 ? e.height = r.readFloat() : 5 === t1 ? e.mask_type = r.readVarint() : 6 === t1 ? e.mask_idx = r.readVarint() : 7 === t1 && e.children.push(Yy(r, r.readVarint() + r.pos));
        }
        class og {
            static calculate(t1, e) {
                const r = new Map, n = new Map;
                if (0 === Object.keys(t1).length) return r;
                e.forEach((t1)=>{
                    n.set(t1.name, t1.rgb_color || new Ie(0, 0, 0));
                });
                for (const [e, i] of Object.entries(t1))n.has(e) ? r.set(n.get(e).toStringPremultipliedAlpha(), i) : console.warn(`Ignoring unknown image variable "${e}"`);
                return r;
            }
        }
        function lg(t1, e = 255, r) {
            const n = e / 255, i = t1.toStringPremultipliedAlpha(), a = r.has(i) ? r.get(i).clone() : t1.clone();
            return a.a = n, a.toString();
        }
        function ug(t1, e) {
            if (!Vt()) {
                const r = document.createElement("canvas");
                return r.width = t1, r.height = e, r;
            }
            return new OffscreenCanvas(t1, e);
        }
        function cg(t1, e) {
            const r = og.calculate(e.params, t1.metadata ? t1.metadata.variables : []), n = t1.usvg_tree, i = n.width, a = n.height, s = e.transform ? e.transform : new DOMMatrix, o = Math.max(1, Math.round(i * s.a)), l = Math.max(1, Math.round(a * s.d)), u = new DOMMatrix([
                o / i,
                0,
                0,
                l / a,
                0,
                0
            ]), c = ug(o, l).getContext("2d");
            return hg(c, u, n, n, r), c.getImageData(0, 0, o, l);
        }
        function hg(t1, e, r, n, i) {
            for (const a of n.children)pg(t1, e, r, a, i);
        }
        function pg(t1, e, r, n, i) {
            n.group ? (t1.save(), function(t1, e, r, n, i) {
                const a = null != n.mask_idx ? r.masks[n.mask_idx] : null, s = null != n.clip_path_idx ? r.clip_paths[n.clip_path_idx] : null;
                if (n.transform && (e = _g(n.transform).preMultiplySelf(e)), !function(t1, e, r) {
                    return 255 !== t1.opacity || e || r;
                }(n, null != s, null != a)) return void hg(t1, e, r, n, i);
                const o = ug(t1.canvas.width, t1.canvas.height), l = o.getContext("2d");
                hg(l, e, r, n, i), s && vg(l, e, r, s), a && bg(l, e, r, a, i), t1.globalAlpha = n.opacity / 255, t1.drawImage(o, 0, 0);
            }(t1, e, r, n.group, i), t1.restore()) : n.path && (t1.save(), function(t1, e, r, n, i) {
                const a = wg(n);
                t1.setTransform(e), n.paint_order === Ly.PAINT_ORDER_FILL_AND_STROKE ? (fg(t1, r, n, a, i), mg(t1, r, n, a, i)) : (mg(t1, r, n, a, i), fg(t1, r, n, a, i));
            }(t1, e, r, n.path, i), t1.restore());
        }
        function fg(t1, e, r, n, i) {
            const a = r.fill;
            if (!a) return;
            const s = a.opacity / 255;
            switch(a.paint){
                case "rgb_color":
                    t1.fillStyle = lg(a.rgb_color, a.opacity, i);
                    break;
                case "linear_gradient_idx":
                    t1.fillStyle = yg(t1, e.linear_gradients[a.linear_gradient_idx], s, i);
                    break;
                case "radial_gradient_idx":
                    t1.fillStyle = gg(t1, e.radial_gradients[a.radial_gradient_idx], s, i);
            }
            t1.fill(n, dg(r));
        }
        function dg(t1) {
            return t1.rule === Cy.PATH_RULE_NON_ZERO ? "nonzero" : t1.rule === Cy.PATH_RULE_EVEN_ODD ? "evenodd" : void 0;
        }
        function mg(t1, e, r, n, i) {
            const a = r.stroke;
            if (!a) return;
            t1.lineWidth = a.width, t1.miterLimit = a.miterlimit, t1.setLineDash(a.dasharray), t1.lineDashOffset = a.dashoffset;
            const s = a.opacity / 255;
            switch(a.paint){
                case "rgb_color":
                    t1.strokeStyle = lg(a.rgb_color, a.opacity, i);
                    break;
                case "linear_gradient_idx":
                    t1.strokeStyle = yg(t1, e.linear_gradients[a.linear_gradient_idx], s, i);
                    break;
                case "radial_gradient_idx":
                    t1.strokeStyle = gg(t1, e.radial_gradients[a.radial_gradient_idx], s, i);
            }
            switch(a.linejoin){
                case Dy.LINE_JOIN_MITER_CLIP:
                case Dy.LINE_JOIN_MITER:
                    t1.lineJoin = "miter";
                    break;
                case Dy.LINE_JOIN_ROUND:
                    t1.lineJoin = "round";
                    break;
                case Dy.LINE_JOIN_BEVEL:
                    t1.lineJoin = "bevel";
            }
            switch(a.linecap){
                case Vy.LINE_CAP_BUTT:
                    t1.lineCap = "butt";
                    break;
                case Vy.LINE_CAP_ROUND:
                    t1.lineCap = "round";
                    break;
                case Vy.LINE_CAP_SQUARE:
                    t1.lineCap = "square";
            }
            t1.stroke(n);
        }
        function yg(t1, e, r, n) {
            if (1 === e.stops.length) {
                const t1 = e.stops[0];
                return lg(t1.rgb_color, t1.opacity * r, n);
            }
            const i = _g(e.transform), { x1: a, y1: s, x2: o, y2: l } = e, u = i.transformPoint(new DOMPoint(a, s)), c = i.transformPoint(new DOMPoint(o, l)), h = t1.createLinearGradient(u.x, u.y, c.x, c.y);
            for (const t1 of e.stops)h.addColorStop(t1.offset, lg(t1.rgb_color, t1.opacity * r, n));
            return h;
        }
        function gg(t1, e, r, n) {
            if (1 === e.stops.length) {
                const t1 = e.stops[0];
                return lg(t1.rgb_color, t1.opacity * r, n);
            }
            const i = _g(e.transform), { fx: a, fy: s, cx: o, cy: l } = e, u = i.transformPoint(new DOMPoint(a, s)), c = i.transformPoint(new DOMPoint(o, l)), h = t1.createRadialGradient(u.x, u.y, 0, c.x, c.y, e.r * ((i.a + i.d) / 2));
            for (const t1 of e.stops)h.addColorStop(t1.offset, lg(t1.rgb_color, t1.opacity * r, n));
            return h;
        }
        function xg(t1, e, r, n) {
            const i = n.transform ? _g(n.transform).preMultiplySelf(e) : e, a = ug(t1.canvas.width, t1.canvas.height), s = a.getContext("2d");
            for (const t1 of n.children)if (t1.group) xg(s, i, r, t1.group);
            else if (t1.path) {
                const e = t1.path, r = new Path2D;
                r.addPath(wg(e), i), s.fill(r, dg(e));
            }
            const o = null != n.clip_path_idx ? r.clip_paths[n.clip_path_idx] : null;
            o && vg(s, i, r, o), t1.globalCompositeOperation = "source-over", t1.drawImage(a, 0, 0);
        }
        function vg(t1, e, r, n) {
            const i = ug(t1.canvas.width, t1.canvas.height);
            xg(i.getContext("2d"), e, r, n), t1.globalCompositeOperation = "destination-in", t1.drawImage(i, 0, 0);
        }
        function bg(t1, e, r, n, i) {
            if (0 === n.children.length) return;
            const a = null != n.mask_idx ? r.masks[n.mask_idx] : null;
            a && bg(t1, e, r, a, i);
            const s = t1.canvas.width, o = t1.canvas.height, l = ug(s, o), u = l.getContext("2d"), c = n.width, h = n.height, p = n.left, f = n.top, d = new Path2D, m = new Path2D;
            m.rect(p, f, c, h), d.addPath(m, e), u.clip(d);
            for (const t1 of n.children)pg(u, e, r, t1, i);
            const y = u.getImageData(0, 0, s, o), g = y.data;
            if (n.mask_type === Fy.MASK_TYPE_LUMINANCE) for(let t1 = 0; t1 < g.length; t1 += 4)g[t1 + 3] = g[t1 + 3] / 255 * (.2126 * g[t1] + .7152 * g[t1 + 1] + .0722 * g[t1 + 2]);
            u.putImageData(y, 0, 0), t1.globalCompositeOperation = "destination-in", t1.drawImage(l, 0, 0);
        }
        function _g(t1) {
            return t1 ? new DOMMatrix([
                t1.sx,
                t1.ky,
                t1.kx,
                t1.sy,
                t1.tx,
                t1.ty
            ]) : new DOMMatrix;
        }
        function wg(t1) {
            const e = new Path2D, r = t1.step;
            let n = t1.diffs[0] * r, i = t1.diffs[1] * r;
            e.moveTo(n, i);
            for(let a = 0, s = 2; a < t1.commands.length; a++)switch(t1.commands[a]){
                case Ry.PATH_COMMAND_MOVE:
                    n += t1.diffs[s++] * r, i += t1.diffs[s++] * r, e.moveTo(n, i);
                    break;
                case Ry.PATH_COMMAND_LINE:
                    n += t1.diffs[s++] * r, i += t1.diffs[s++] * r, e.lineTo(n, i);
                    break;
                case Ry.PATH_COMMAND_QUAD:
                    {
                        const a = n + t1.diffs[s++] * r, o = i + t1.diffs[s++] * r;
                        n = a + t1.diffs[s++] * r, i = o + t1.diffs[s++] * r, e.quadraticCurveTo(a, o, n, i);
                        break;
                    }
                case Ry.PATH_COMMAND_CUBIC:
                    {
                        const a = n + t1.diffs[s++] * r, o = i + t1.diffs[s++] * r, l = a + t1.diffs[s++] * r, u = o + t1.diffs[s++] * r;
                        n = l + t1.diffs[s++] * r, i = u + t1.diffs[s++] * r, e.bezierCurveTo(a, o, l, u, n, i);
                        break;
                    }
                case Ry.PATH_COMMAND_CLOSE:
                    e.closePath();
            }
            return e;
        }
        class Mg {
            get(t1) {
                if (!this.cache.has(t1)) return;
                const e = this.cache.get(t1);
                return this.cache.delete(t1), this.cache.set(t1, e), e;
            }
            put(t1, e) {
                this.cache.has(t1) ? this.cache.delete(t1) : this.cache.size === this.capacity && this.cache.delete(this.cache.keys().next().value), this.cache.set(t1, e);
            }
            delete(t1) {
                this.cache.delete(t1);
            }
            constructor(t1){
                this.capacity = t1, this.cache = new Map;
            }
        }
        class Ag {
            static _getImage(t1) {
                return new sc(t1, t1.data);
            }
            getFromCache(t1, e, r) {
                return this.cacheMap.has(r) || this.cacheMap.set(r, new Mg(150)), this.cacheMap.get(r).get(us(t1.serialize(), e));
            }
            setInCache(t1, e, r, n) {
                this.cacheDependenciesMap.has(n) || this.cacheDependenciesMap.set(n, new Map), this.cacheMap.has(n) || this.cacheMap.set(n, new Mg(150));
                const i = this.cacheDependenciesMap.get(n);
                i.get(us(t1.id, r)) || i.set(us(t1.id, r), new Set);
                const a = this.cacheMap.get(n), s = t1.serialize();
                i.get(us(t1.id, r)).add(s), a.put(us(t1.serialize(), r), e);
            }
            removeImagesFromCacheByIds(t1, e, r = "") {
                if (!this.cacheMap.has(r) || !this.cacheDependenciesMap.has(r)) return;
                const n = this.cacheMap.get(r), i = this.cacheDependenciesMap.get(r);
                for (const r of t1)if (i.has(us(r, e))) {
                    for (const t1 of i.get(us(r, e)))n.delete(t1);
                    i.delete(us(r, e));
                }
            }
            rasterize(t1, e, r, n, i = cg) {
                const a = this.getFromCache(t1, r, n);
                if (a) return a.clone();
                const s = i(e.icon, t1.options), o = Ag._getImage(s);
                return this.setInCache(t1, o, r, n), o.clone();
            }
            constructor(){
                this.cacheMap = new Map, this.cacheDependenciesMap = new Map;
            }
        }
        class Sg {
            getElevation(t1, e) {
                const r = this.toIdx(t1, e);
                return {
                    min: this.minimums[r],
                    max: this.maximums[r]
                };
            }
            isLeaf(t1, e) {
                return this.leaves[this.toIdx(t1, e)];
            }
            toIdx(t1, e) {
                return e * this.size + t1;
            }
            constructor(t1){
                this.size = t1, this.minimums = [], this.maximums = [], this.leaves = [];
            }
        }
        function Ig(t1, e, r, n) {
            let i = 0, a = Number.MAX_VALUE;
            for(let s = 0; s < 3; s++)if (Math.abs(n[s]) < 1e-15) {
                if (r[s] < t1[s] || r[s] > e[s]) return null;
            } else {
                const o = 1 / n[s];
                let l = (t1[s] - r[s]) * o, u = (e[s] - r[s]) * o;
                if (l > u) {
                    const t1 = l;
                    l = u, u = t1;
                }
                if (l > i && (i = l), u < a && (a = u), i > a) return null;
            }
            return i;
        }
        function Pg(t1, e, r, n, i, a, s, o, l, u, c) {
            const h = n - t1, p = i - e, f = a - r, d = s - t1, m = o - e, y = l - r, g = c[1] * y - c[2] * m, x = c[2] * d - c[0] * y, v = c[0] * m - c[1] * d, b = h * g + p * x + f * v;
            if (Math.abs(b) < 1e-15) return null;
            const _ = 1 / b, w = u[0] - t1, M = u[1] - e, A = u[2] - r, S = (w * g + M * x + A * v) * _;
            if (S < 0 || S > 1) return null;
            const I = M * f - A * p, P = A * h - w * f, z = w * p - M * h, E = (c[0] * I + c[1] * P + c[2] * z) * _;
            return E < 0 || S + E > 1 ? null : (d * I + m * P + y * z) * _;
        }
        function zg(t1, e, r) {
            return (t1 - e) / (r - e);
        }
        function Eg(t1, e, r, n, i, a, s, o, l) {
            const u = 1 << r, c = a - n, h = s - i, p = (t1 + 1) / u * c + n, f = (e + 0) / u * h + i, d = (e + 1) / u * h + i;
            o[0] = (t1 + 0) / u * c + n, o[1] = f, l[0] = p, l[1] = d;
        }
        class kg {
            raycastRoot(t1, e, r, n, i, a, s = 1) {
                return Ig([
                    t1,
                    e,
                    -100
                ], [
                    r,
                    n,
                    this.maximums[0] * s
                ], i, a);
            }
            raycast(t1, e, r, n, i, a, s = 1) {
                if (!this.nodeCount) return null;
                const o = this.raycastRoot(t1, e, r, n, i, a, s);
                if (null == o) return null;
                const l = [], u = [], c = [], h = [], p = [
                    {
                        idx: 0,
                        t: o,
                        nodex: 0,
                        nodey: 0,
                        depth: 0
                    }
                ];
                for(; p.length > 0;){
                    const { idx: o, t: f, nodex: d, nodey: m, depth: y } = p.pop();
                    if (this.leaves[o]) {
                        Eg(d, m, y, t1, e, r, n, c, h);
                        const o = 1 << y, l = (d + 0) / o, u = (d + 1) / o, p = (m + 0) / o, g = (m + 1) / o, x = Bg(l, p, this.dem) * s, v = Bg(u, p, this.dem) * s, b = Bg(u, g, this.dem) * s, _ = Bg(l, g, this.dem) * s, w = Pg(c[0], c[1], x, h[0], c[1], v, h[0], h[1], b, i, a), M = Pg(h[0], h[1], b, c[0], h[1], _, c[0], c[1], x, i, a), A = Math.min(null !== w ? w : Number.MAX_VALUE, null !== M ? M : Number.MAX_VALUE);
                        if (A !== Number.MAX_VALUE) return A;
                        {
                            const t1 = O.vec3.scaleAndAdd([], i, a, f);
                            if (Tg(x, v, _, b, zg(t1[0], c[0], h[0]), zg(t1[1], c[1], h[1])) >= t1[2]) return f;
                        }
                        continue;
                    }
                    let g = 0;
                    for(let p = 0; p < this._siblingOffset.length; p++){
                        Eg((d << 1) + this._siblingOffset[p][0], (m << 1) + this._siblingOffset[p][1], y + 1, t1, e, r, n, c, h), c[2] = -100, h[2] = this.maximums[this.childOffsets[o] + p] * s;
                        const f = Ig(c, h, i, a);
                        if (null != f) {
                            const t1 = f;
                            l[p] = t1;
                            let e = !1;
                            for(let r = 0; r < g && !e; r++)t1 >= l[u[r]] && (u.splice(r, 0, p), e = !0);
                            e || (u[g] = p), g++;
                        }
                    }
                    for(let t1 = 0; t1 < g; t1++){
                        const e = u[t1];
                        p.push({
                            idx: this.childOffsets[o] + e,
                            t: l[e],
                            nodex: (d << 1) + this._siblingOffset[e][0],
                            nodey: (m << 1) + this._siblingOffset[e][1],
                            depth: y + 1
                        });
                    }
                }
                return null;
            }
            _addNode(t1, e, r) {
                return this.minimums.push(t1), this.maximums.push(e), this.leaves.push(r), this.childOffsets.push(0), this.nodeCount++;
            }
            _construct(t1, e, r, n, i) {
                if (1 === t1[n].isLeaf(e, r)) return;
                this.childOffsets[i] || (this.childOffsets[i] = this.nodeCount);
                const a = n - 1, s = t1[a];
                let o = 0, l = 0;
                for(let t1 = 0; t1 < this._siblingOffset.length; t1++){
                    const n = 2 * e + this._siblingOffset[t1][0], i = 2 * r + this._siblingOffset[t1][1], a = s.getElevation(n, i), u = s.isLeaf(n, i), c = this._addNode(a.min, a.max, u);
                    u && (o |= 1 << t1), l || (l = c);
                }
                for(let n = 0; n < this._siblingOffset.length; n++)o & 1 << n || this._construct(t1, 2 * e + this._siblingOffset[n][0], 2 * r + this._siblingOffset[n][1], a, l + n);
            }
            constructor(t1){
                if (this.maximums = [], this.minimums = [], this.leaves = [], this.childOffsets = [], this.nodeCount = 0, this.dem = t1, this._siblingOffset = [
                    [
                        0,
                        0
                    ],
                    [
                        1,
                        0
                    ],
                    [
                        0,
                        1
                    ],
                    [
                        1,
                        1
                    ]
                ], !this.dem) return;
                const e = function(t1) {
                    const e = Math.ceil(Math.log2(t1.dim / 8)), r = [];
                    let n = Math.ceil(Math.pow(2, e));
                    const i = 1 / n, a = (t1, e, r, n, i)=>{
                        const a = n ? 1 : 0, s = (t1 + 1) * r - a, o = e * r, l = (e + 1) * r - a;
                        i[0] = t1 * r, i[1] = o, i[2] = s, i[3] = l;
                    };
                    let s = new Sg(n);
                    const o = [];
                    for(let e = 0; e < n * n; e++){
                        a(e % n, Math.floor(e / n), i, !1, o);
                        const r = Bg(o[0], o[1], t1), l = Bg(o[2], o[1], t1), u = Bg(o[2], o[3], t1), c = Bg(o[0], o[3], t1);
                        s.minimums.push(Math.min(r, l, u, c)), s.maximums.push(Math.max(r, l, u, c)), s.leaves.push(1);
                    }
                    for(r.push(s), n /= 2; n >= 1; n /= 2){
                        const t1 = r[r.length - 1];
                        s = new Sg(n);
                        for(let e = 0; e < n * n; e++){
                            a(e % n, Math.floor(e / n), 2, !0, o);
                            const r = t1.getElevation(o[0], o[1]), i = t1.getElevation(o[2], o[1]), l = t1.getElevation(o[2], o[3]), u = t1.getElevation(o[0], o[3]), c = t1.isLeaf(o[0], o[1]), h = t1.isLeaf(o[2], o[1]), p = t1.isLeaf(o[2], o[3]), f = t1.isLeaf(o[0], o[3]), d = Math.min(r.min, i.min, l.min, u.min), m = Math.max(r.max, i.max, l.max, u.max), y = c && h && p && f;
                            s.maximums.push(m), s.minimums.push(d), s.leaves.push(m - d <= 5 && y ? 1 : 0);
                        }
                        r.push(s);
                    }
                    return r;
                }(this.dem), r = e.length - 1, n = e[r];
                this._addNode(n.minimums[0], n.maximums[0], n.leaves[0]), this._construct(e, 0, 0, r, 0);
            }
        }
        function Tg(t1, e, r, n, i, a) {
            return ze(ze(t1, r, a), ze(e, n, a), i);
        }
        function Bg(t1, e, r) {
            const n = r.dim, i = Q(t1 * n - .5, 0, n - 1), a = Q(e * n - .5, 0, n - 1), s = Math.floor(i), o = Math.floor(a), l = Math.min(s + 1, n - 1), u = Math.min(o + 1, n - 1);
            return Tg(r.get(s, o), r.get(l, o), r.get(s, u), r.get(l, u), i - s, a - o);
        }
        const Cg = {
            mapbox: [
                6553.6,
                25.6,
                .1,
                1e4
            ],
            terrarium: [
                256,
                1,
                1 / 256,
                32768
            ]
        };
        function Vg(t1, e, r) {
            return (256 * t1 * 256 + 256 * e + r) / 10 - 1e4;
        }
        function Dg(t1, e, r) {
            return 256 * t1 + e + r / 256 - 32768;
        }
        class Lg {
            get tree() {
                return this._tree || this._buildQuadTree(), this._tree;
            }
            _buildQuadTree() {
                this._tree = new kg(this);
            }
            get(t1, e, r = !1) {
                r && (t1 = Q(t1, -1, this.dim), e = Q(e, -1, this.dim));
                const n = this._idx(t1, e);
                return this.floatView[n];
            }
            set(t1, e, r) {
                const n = this._idx(t1, e), i = this.floatView[n];
                return this.floatView[n] = r, r - i;
            }
            static getUnpackVector(t1) {
                return Cg[t1];
            }
            _idx(t1, e) {
                if (t1 < -1 || t1 >= this.dim + 1 || e < -1 || e >= this.dim + 1) throw new RangeError("out of range source coordinates for DEM data");
                return (e + 1) * this.stride + (t1 + 1);
            }
            static pack(t1, e) {
                const r = [
                    0,
                    0,
                    0,
                    0
                ], n = Lg.getUnpackVector(e);
                let i = Math.floor((t1 + n[3]) / n[2]);
                return r[2] = i % 256, i = Math.floor(i / 256), r[1] = i % 256, i = Math.floor(i / 256), r[0] = i, r;
            }
            getPixels() {
                return new oc({
                    width: this.stride,
                    height: this.stride
                }, this.pixels);
            }
            backfillBorder(t1, e, r) {
                if (this.dim !== t1.dim) throw new Error("dem dimension mismatch");
                let n = e * this.dim, i = e * this.dim + this.dim, a = r * this.dim, s = r * this.dim + this.dim;
                switch(e){
                    case -1:
                        n = i - 1;
                        break;
                    case 1:
                        i = n + 1;
                }
                switch(r){
                    case -1:
                        a = s - 1;
                        break;
                    case 1:
                        s = a + 1;
                }
                const o = -e * this.dim, l = -r * this.dim;
                for(let e = a; e < s; e++)for(let r = n; r < i; r++){
                    const n = 4 * this._idx(r, e), i = 4 * this._idx(r + o, e + l);
                    this.pixels[n + 0] = t1.pixels[i + 0], this.pixels[n + 1] = t1.pixels[i + 1], this.pixels[n + 2] = t1.pixels[i + 2], this.pixels[n + 3] = t1.pixels[i + 3];
                }
            }
            onDeserialize() {
                this._tree && (this._tree.dem = this);
            }
            constructor(t1, e, r, n = !1){
                if (this.uid = t1, e.height !== e.width) throw new RangeError("DEM tiles must be square");
                if (r && "mapbox" !== r && "terrarium" !== r) return void ft(`"${r}" is not a valid encoding type. Valid types include "mapbox" and "terrarium".`);
                this.stride = e.height;
                const i = this.dim = e.height - 2, a = new Uint32Array(e.data.buffer);
                if (this.pixels = new Uint8Array(e.data.buffer), this.floatView = new Float32Array(e.data.buffer), this.borderReady = n, this._modifiedForSources = {}, !n) {
                    for(let t1 = 0; t1 < i; t1++)a[this._idx(-1, t1)] = a[this._idx(0, t1)], a[this._idx(i, t1)] = a[this._idx(i - 1, t1)], a[this._idx(t1, -1)] = a[this._idx(t1, 0)], a[this._idx(t1, i)] = a[this._idx(t1, i - 1)];
                    a[this._idx(-1, -1)] = a[this._idx(0, 0)], a[this._idx(i, -1)] = a[this._idx(i - 1, 0)], a[this._idx(-1, i)] = a[this._idx(0, i - 1)], a[this._idx(i, i)] = a[this._idx(i - 1, i - 1)];
                }
                const s = "terrarium" === r ? Dg : Vg;
                for(let t1 = 0; t1 < a.length; ++t1){
                    const e = 4 * t1;
                    this.floatView[t1] = s(this.pixels[e], this.pixels[e + 1], this.pixels[e + 2]);
                }
                this._timestamp = Dt.now();
            }
        }
        function Rg(t1, e, r) {
            1 === t1 ? e.headerLength = r.readFixed32() : 2 === t1 ? e.x = r.readVarint() : 3 === t1 ? e.y = r.readVarint() : 4 === t1 ? e.z = r.readVarint() : 5 === t1 && e.layers.push(function(t1, e) {
                return t1.readFields(jg, {
                    version: 0,
                    name: "",
                    units: "",
                    tileSize: 0,
                    buffer: 0,
                    pixelFormat: 0,
                    dataIndex: []
                }, e);
            }(r, r.readVarint() + r.pos));
        }
        function Fg(t1, e, r) {
            1 === t1 ? (e.delta_filter = function(t1, e) {
                return t1.readFields(Og, {
                    blockSize: 0
                }, e);
            }(r, r.readVarint() + r.pos), e.filter = "delta_filter") : 2 === t1 ? (r.readVarint(), e.filter = "zigzag_filter") : 3 === t1 ? (r.readVarint(), e.filter = "bitshuffle_filter") : 4 === t1 && (r.readVarint(), e.filter = "byteshuffle_filter");
        }
        function Og(t1, e, r) {
            1 === t1 && (e.blockSize = r.readVarint());
        }
        function Ng(t1, e, r) {
            1 === t1 ? (r.readVarint(), e.codec = "gzip_data") : 2 === t1 ? (r.readVarint(), e.codec = "jpeg_image") : 3 === t1 ? (r.readVarint(), e.codec = "webp_image") : 4 === t1 && (r.readVarint(), e.codec = "png_image");
        }
        function Ug(t1, e, r) {
            let n = 0, i = 0;
            1 === t1 ? e.firstByte = r.readFixed64() : 2 === t1 ? e.lastByte = r.readFixed64() : 3 === t1 ? e.filters.push(function(t1, e) {
                return t1.readFields(Fg, {}, e);
            }(r, r.readVarint() + r.pos)) : 4 === t1 ? e.codec = function(t1, e) {
                return t1.readFields(Ng, {}, e);
            }(r, r.readVarint() + r.pos) : 5 === t1 ? i = r.readFloat() : 6 === t1 ? n = r.readFloat() : 7 === t1 ? e.bands.push(r.readString()) : 8 === t1 ? e.offset = r.readDouble() : 9 === t1 && (e.scale = r.readDouble()), 0 === e.offset && (e.offset = i), 0 === e.scale && (e.scale = n);
        }
        function jg(t1, e, r) {
            1 === t1 ? e.version = r.readVarint() : 2 === t1 ? e.name = r.readString() : 3 === t1 ? e.units = r.readString() : 4 === t1 ? e.tileSize = r.readVarint() : 5 === t1 ? e.buffer = r.readVarint() : 6 === t1 ? e.pixelFormat = r.readVarint() : 7 === t1 && e.dataIndex.push(function(t1, e) {
                return t1.readFields(Ug, {
                    firstByte: 0,
                    lastByte: 0,
                    filters: [],
                    codec: null,
                    offset: 0,
                    scale: 0,
                    bands: []
                }, e);
            }(r, r.readVarint() + r.pos));
        }
        function qg(t1, e, r) {
            if (2 === t1) !function(t1, e, r) {
                t1.readFields($g, r, e);
            }(r, r.readVarint() + r.pos, e);
            else if (3 === t1) throw new Error("Not implemented");
        }
        function $g(t1, e, r) {
            if (1 === t1) {
                let t1 = 0;
                const n = r.readVarint() + r.pos;
                for(; r.pos < n;)e[t1++] = r.readVarint();
            }
        }
        function Gg(t1, e) {
            if (4 !== e.length) throw new Error(`Expected data of dimension 4 but got ${e.length}.`);
            let r = e[3];
            for(let n = 2; n >= 1; n--){
                const i = 1 === n ? 1 : 0, a = 2 === n ? 1 : 0;
                for(let n = 0; n < e[0]; n++){
                    const s = e[1] * n;
                    for(let n = i; n < e[1]; n++){
                        const i = e[2] * (n + s);
                        for(let n = a; n < e[2]; n++){
                            const a = e[3] * (n + i);
                            for(let n = 0; n < e[3]; n++){
                                const e = a + n;
                                t1[e] += t1[e - r];
                            }
                        }
                    }
                }
                r *= e[n];
            }
            return t1;
        }
        function Yg(t1) {
            for(let e = 0, r = t1.length; e < r; e++)t1[e] = t1[e] >>> 1 ^ -(1 & t1[e]);
            return t1;
        }
        function Xg(t1, e) {
            switch(e){
                case "uint32":
                    return t1;
                case "uint16":
                    for(let e = 0; e < t1.length; e += 2){
                        const r = t1[e], n = t1[e + 1];
                        t1[e] = (240 & r) >> 4 | (61440 & r) >> 8 | (240 & n) << 4 | 61440 & n, t1[e + 1] = 15 & r | (3840 & r) >> 4 | (15 & n) << 8 | (3840 & n) << 4;
                    }
                    return t1;
                case "uint8":
                    for(let e = 0; e < t1.length; e += 4){
                        const r = t1[e], n = t1[e + 1], i = t1[e + 2], a = t1[e + 3];
                        t1[e + 0] = (192 & r) >> 6 | (192 & n) >> 4 | (192 & i) >> 2 | 192 & a, t1[e + 1] = (48 & r) >> 4 | (48 & n) >> 2 | 48 & i | (48 & a) << 2, t1[e + 2] = (12 & r) >> 2 | 12 & n | (12 & i) << 2 | (12 & a) << 4, t1[e + 3] = 3 & r | (3 & n) << 2 | (3 & i) << 4 | (3 & a) << 6;
                    }
                    return t1;
                default:
                    throw new Error(`Invalid pixel format, "${e}"`);
            }
        }
        oa(Lg, "DEMData"), oa(kg, "DemMinMaxQuadTree", {
            omit: [
                "dem"
            ]
        });
        var Zg = Uint8Array, Hg = Uint16Array, Wg = Int32Array, Kg = new Zg([
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            1,
            1,
            1,
            1,
            2,
            2,
            2,
            2,
            3,
            3,
            3,
            3,
            4,
            4,
            4,
            4,
            5,
            5,
            5,
            5,
            0,
            0,
            0,
            0
        ]), Jg = new Zg([
            0,
            0,
            0,
            0,
            1,
            1,
            2,
            2,
            3,
            3,
            4,
            4,
            5,
            5,
            6,
            6,
            7,
            7,
            8,
            8,
            9,
            9,
            10,
            10,
            11,
            11,
            12,
            12,
            13,
            13,
            0,
            0
        ]), Qg = new Zg([
            16,
            17,
            18,
            0,
            8,
            7,
            9,
            6,
            10,
            5,
            11,
            4,
            12,
            3,
            13,
            2,
            14,
            1,
            15
        ]), tx = function(t1, e) {
            for(var r = new Hg(31), n = 0; n < 31; ++n)r[n] = e += 1 << t1[n - 1];
            var i = new Wg(r[30]);
            for(n = 1; n < 30; ++n)for(var a = r[n]; a < r[n + 1]; ++a)i[a] = a - r[n] << 5 | n;
            return {
                b: r,
                r: i
            };
        }, ex = tx(Kg, 2), rx = ex.b, nx = ex.r;
        rx[28] = 258, nx[258] = 28;
        for(var ix = tx(Jg, 0).b, ax = new Hg(32768), sx = 0; sx < 32768; ++sx){
            var ox = (43690 & sx) >> 1 | (21845 & sx) << 1;
            ax[sx] = ((65280 & (ox = (61680 & (ox = (52428 & ox) >> 2 | (13107 & ox) << 2)) >> 4 | (3855 & ox) << 4)) >> 8 | (255 & ox) << 8) >> 1;
        }
        var lx = function(t1, e, r) {
            for(var n = t1.length, i = 0, a = new Hg(e); i < n; ++i)t1[i] && ++a[t1[i] - 1];
            var s, o = new Hg(e);
            for(i = 1; i < e; ++i)o[i] = o[i - 1] + a[i - 1] << 1;
            s = new Hg(1 << e);
            var l = 15 - e;
            for(i = 0; i < n; ++i)if (t1[i]) for(var u = i << 4 | t1[i], c = e - t1[i], h = o[t1[i] - 1]++ << c, p = h | (1 << c) - 1; h <= p; ++h)s[ax[h] >> l] = u;
            return s;
        }, ux = new Zg(288);
        for(sx = 0; sx < 144; ++sx)ux[sx] = 8;
        for(sx = 144; sx < 256; ++sx)ux[sx] = 9;
        for(sx = 256; sx < 280; ++sx)ux[sx] = 7;
        for(sx = 280; sx < 288; ++sx)ux[sx] = 8;
        var cx = new Zg(32);
        for(sx = 0; sx < 32; ++sx)cx[sx] = 5;
        var hx = lx(ux, 9), px = lx(cx, 5), fx = function(t1) {
            for(var e = t1[0], r = 1; r < t1.length; ++r)t1[r] > e && (e = t1[r]);
            return e;
        }, dx = function(t1, e, r) {
            var n = e / 8 | 0;
            return (t1[n] | t1[n + 1] << 8) >> (7 & e) & r;
        }, mx = function(t1, e) {
            var r = e / 8 | 0;
            return (t1[r] | t1[r + 1] << 8 | t1[r + 2] << 16) >> (7 & e);
        }, yx = [
            "unexpected EOF",
            "invalid block type",
            "invalid length/literal",
            "invalid distance",
            "stream finished",
            "no stream handler",
            ,
            "no callback",
            "invalid UTF-8 data",
            "extra field too long",
            "date not in range 1980-2099",
            "filename too long",
            "stream finishing",
            "invalid zip data"
        ], gx = function(t1, e, r) {
            var n = new Error(e || yx[t1]);
            if (n.code = t1, Error.captureStackTrace && Error.captureStackTrace(n, gx), !r) throw n;
            return n;
        }, xx = new Zg(0), vx = "undefined" != typeof TextDecoder && new TextDecoder;
        try {
            vx.decode(xx, {
                stream: !0
            });
        } catch (t1) {}
        const bx = {
            gzip_data: "gzip"
        };
        class _x extends Error {
            constructor(t1){
                super(t1), this.name = "MRTError";
            }
        }
        const wx = {
            0: "uint32",
            1: "uint32",
            2: "uint16",
            3: "uint8"
        }, Mx = {
            uint32: 1,
            uint16: 2,
            uint8: 4
        }, Ax = {
            uint32: Uint32Array,
            uint16: Uint16Array,
            uint8: Uint8Array
        };
        let Sx;
        class Ix {
            getLayer(t1) {
                const e = this.layers[t1];
                if (!e) throw new _x(`Layer '${t1}' not found`);
                return e;
            }
            getHeaderLength(t1) {
                const e = new Uint8Array(t1), r = new DataView(t1);
                if (13 !== e[0]) throw new _x("File is not a valid MRT.");
                return r.getUint32(1, !0);
            }
            parseHeader(t1) {
                const e = new Uint8Array(t1), r = this.getHeaderLength(t1);
                if (e.length < r) throw new _x(`Expected header with length >= ${r} but got buffer of length ${e.length}`);
                const n = function(t1, e) {
                    return t1.readFields(Rg, {
                        headerLength: 0,
                        x: 0,
                        y: 0,
                        z: 0,
                        layers: []
                    }, void 0);
                }(new Sx(e.subarray(0, r)));
                if (!isNaN(this.x) && (this.x !== n.x || this.y !== n.y || this.z !== n.z)) throw new _x(`Invalid attempt to parse header ${n.z}/${n.x}/${n.y} for tile ${this.z}/${this.x}/${this.y}`);
                this.x = n.x, this.y = n.y, this.z = n.z;
                for (const t1 of n.layers)this.layers[t1.name] = new Px(t1, {
                    cacheSize: this._cacheSize
                });
                return this;
            }
            createDecodingTask(t1) {
                const e = [], r = this.getLayer(t1.layerName);
                for (let n of t1.blockIndices){
                    const i = r.dataIndex[n], a = i.firstByte - t1.firstByte, s = i.lastByte - t1.firstByte;
                    if (r._blocksInProgress.has(n)) continue;
                    const o = {
                        layerName: r.name,
                        firstByte: a,
                        lastByte: s,
                        pixelFormat: r.pixelFormat,
                        blockIndex: n,
                        blockShape: [
                            i.bands.length
                        ].concat(r.bandShape),
                        buffer: r.buffer,
                        codec: i.codec.codec,
                        filters: i.filters.map((t1)=>t1.filter)
                    };
                    r._blocksInProgress.add(n), e.push(o);
                }
                return new zx(e, ()=>{
                    e.forEach((t1)=>r._blocksInProgress.delete(t1.blockIndex));
                }, (t1, n)=>{
                    if (e.forEach((t1)=>r._blocksInProgress.delete(t1.blockIndex)), t1) throw t1;
                    n.forEach((t1)=>{
                        this.getLayer(t1.layerName).processDecodedData(t1);
                    });
                });
            }
            constructor(t1 = 5){
                this.x = NaN, this.y = NaN, this.z = NaN, this.layers = {}, this._cacheSize = t1;
            }
        }
        class Px {
            get dimension() {
                return Mx[this.pixelFormat];
            }
            get cacheSize() {
                return this._decodedBlocks.capacity;
            }
            getBandList() {
                return this.dataIndex.map(({ bands: t1 })=>t1).flat();
            }
            processDecodedData(t1) {
                const e = t1.blockIndex.toString();
                this._decodedBlocks.get(e) || this._decodedBlocks.put(e, t1.data);
            }
            getBlockForBand(t1) {
                let e = 0;
                switch(typeof t1){
                    case "string":
                        for (const [r, n] of this.dataIndex.entries()){
                            for (const [i, a] of n.bands.entries())if (a === t1) return {
                                bandIndex: e + i,
                                blockIndex: r,
                                blockBandIndex: i
                            };
                            e += n.bands.length;
                        }
                        break;
                    case "number":
                        for (const [r, n] of this.dataIndex.entries()){
                            if (t1 >= e && t1 < e + n.bands.length) return {
                                bandIndex: t1,
                                blockIndex: r,
                                blockBandIndex: t1 - e
                            };
                            e += n.bands.length;
                        }
                        break;
                    default:
                        throw new _x(`Invalid band \`${JSON.stringify(t1)}\`. Expected string or integer.`);
                }
                throw new _x(`Band not found: ${JSON.stringify(t1)}`);
            }
            getDataRange(t1) {
                let e = 1 / 0, r = -1 / 0;
                const n = [], i = new Set;
                for (const a of t1){
                    const { blockIndex: t1 } = this.getBlockForBand(a);
                    if (t1 < 0) throw new _x(`Invalid band: ${JSON.stringify(a)}`);
                    const s = this.dataIndex[t1];
                    n.includes(t1) || n.push(t1), i.add(t1), e = Math.min(e, s.firstByte), r = Math.max(r, s.lastByte);
                }
                if (i.size > this.cacheSize) throw new _x(`Number of blocks to decode (${i.size}) exceeds cache size (${this.cacheSize}).`);
                return {
                    layerName: this.name,
                    firstByte: e,
                    lastByte: r,
                    blockIndices: n
                };
            }
            hasBand(t1) {
                const { blockIndex: e } = this.getBlockForBand(t1);
                return e >= 0;
            }
            hasDataForBand(t1) {
                const { blockIndex: e } = this.getBlockForBand(t1);
                return e >= 0 && !!this._decodedBlocks.get(e.toString());
            }
            getBandView(t1) {
                const { blockIndex: e, blockBandIndex: r } = this.getBlockForBand(t1), n = this._decodedBlocks.get(e.toString());
                if (!n) throw new _x(`Data for band ${JSON.stringify(t1)} of layer "${this.name}" not decoded.`);
                const i = this.dataIndex[e], a = this.bandShape.reduce((t1, e)=>t1 * e, 1), s = r * a, o = n.subarray(s, s + a);
                return {
                    data: o,
                    bytes: new Uint8Array(o.buffer).subarray(o.byteOffset, o.byteOffset + o.byteLength),
                    tileSize: this.tileSize,
                    buffer: this.buffer,
                    pixelFormat: this.pixelFormat,
                    dimension: this.dimension,
                    offset: i.offset,
                    scale: i.scale
                };
            }
            constructor({ version: t1, name: e, units: r, tileSize: n, pixelFormat: i, buffer: a, dataIndex: s }, o){
                if (this.version = t1, 1 !== this.version) throw new _x(`Cannot parse raster layer encoded with MRT version ${t1}`);
                this.name = e, this.units = r, this.tileSize = n, this.buffer = a, this.pixelFormat = wx[i], this.dataIndex = s, this.bandShape = [
                    n + 2 * a,
                    n + 2 * a,
                    Mx[this.pixelFormat]
                ], this._decodedBlocks = new Mg(o ? o.cacheSize : 5), this._blocksInProgress = new Set;
            }
        }
        Ix.setPbf = function(t1) {
            Sx = t1;
        };
        class zx {
            cancel() {
                this._finalized || (this._onCancel(), this._finalized = !0);
            }
            complete(t1, e) {
                this._finalized || (this._onComplete(t1, e), this._finalized = !0);
            }
            constructor(t1, e, r){
                this.tasks = t1, this._onCancel = e, this._onComplete = r, this._finalized = !1;
            }
        }
        Ix.performDecoding = function(t1, e) {
            const r = new Uint8Array(t1);
            return Promise.all(e.tasks.map((t1)=>{
                const { layerName: e, firstByte: n, lastByte: i, pixelFormat: a, blockShape: s, blockIndex: o, filters: l, codec: u } = t1, c = r.subarray(n, i + 1), h = new Uint32Array(s[0] * s[1] * s[2]);
                let p;
                if ("gzip_data" !== u) throw new _x(`Unhandled codec: ${u}`);
                return p = (function(t1, e) {
                    if (!globalThis.DecompressionStream && "gzip_data" === e) return Promise.resolve(((a = function(t1) {
                        31 == t1[0] && 139 == t1[1] && 8 == t1[2] || gx(6, "invalid gzip data");
                        var e = t1[3], r = 10;
                        4 & e && (r += 2 + (t1[10] | t1[11] << 8));
                        for(var n = (e >> 3 & 1) + (e >> 4 & 1); n > 0; n -= !t1[r++]);
                        return r + (2 & e);
                    }(i = t1)) + 8 > i.length && gx(6, "invalid gzip data"), function(t1, e, r, n) {
                        var i = t1.length;
                        if (!i || e.f && !e.l) return r || new Zg(0);
                        var a = !r, s = a || 2 != e.i, o = e.i;
                        a && (r = new Zg(3 * i));
                        var l, u, c = function(t1) {
                            var e = r.length;
                            if (t1 > e) {
                                var n = new Zg(Math.max(2 * e, t1));
                                n.set(r), r = n;
                            }
                        }, h = e.f || 0, p = e.p || 0, f = e.b || 0, d = e.l, m = e.d, y = e.m, g = e.n, x = 8 * i;
                        do {
                            if (!d) {
                                h = dx(t1, p, 1);
                                var v = dx(t1, p + 1, 3);
                                if (p += 3, !v) {
                                    var b = t1[(T = 4 + ((p + 7) / 8 | 0)) - 4] | t1[T - 3] << 8, _ = T + b;
                                    if (_ > i) {
                                        o && gx(0);
                                        break;
                                    }
                                    s && c(f + b), r.set(t1.subarray(T, _), f), e.b = f += b, e.p = p = 8 * _, e.f = h;
                                    continue;
                                }
                                if (1 == v) d = hx, m = px, y = 9, g = 5;
                                else if (2 == v) {
                                    var w = dx(t1, p, 31) + 257, M = dx(t1, p + 10, 15) + 4, A = w + dx(t1, p + 5, 31) + 1;
                                    p += 14;
                                    for(var S = new Zg(A), I = new Zg(19), P = 0; P < M; ++P)I[Qg[P]] = dx(t1, p + 3 * P, 7);
                                    p += 3 * M;
                                    var z = fx(I), E = (1 << z) - 1, k = lx(I, z);
                                    for(P = 0; P < A;){
                                        var T, B = k[dx(t1, p, E)];
                                        if (p += 15 & B, (T = B >> 4) < 16) S[P++] = T;
                                        else {
                                            var C = 0, V = 0;
                                            for(16 == T ? (V = 3 + dx(t1, p, 3), p += 2, C = S[P - 1]) : 17 == T ? (V = 3 + dx(t1, p, 7), p += 3) : 18 == T && (V = 11 + dx(t1, p, 127), p += 7); V--;)S[P++] = C;
                                        }
                                    }
                                    var D = S.subarray(0, w), L = S.subarray(w);
                                    y = fx(D), g = fx(L), d = lx(D, y), m = lx(L, g);
                                } else gx(1);
                                if (p > x) {
                                    o && gx(0);
                                    break;
                                }
                            }
                            s && c(f + 131072);
                            for(var R = (1 << y) - 1, F = (1 << g) - 1, O = p;; O = p){
                                var N = (C = d[mx(t1, p) & R]) >> 4;
                                if ((p += 15 & C) > x) {
                                    o && gx(0);
                                    break;
                                }
                                if (C || gx(2), N < 256) r[f++] = N;
                                else {
                                    if (256 == N) {
                                        O = p, d = null;
                                        break;
                                    }
                                    var U = N - 254;
                                    N > 264 && (U = dx(t1, p, (1 << ($ = Kg[P = N - 257])) - 1) + rx[P], p += $);
                                    var j = m[mx(t1, p) & F], q = j >> 4;
                                    if (j || gx(3), p += 15 & j, L = ix[q], q > 3) {
                                        var $ = Jg[q];
                                        L += mx(t1, p) & (1 << $) - 1, p += $;
                                    }
                                    if (p > x) {
                                        o && gx(0);
                                        break;
                                    }
                                    s && c(f + 131072);
                                    var G = f + U;
                                    if (f < L) {
                                        var Y = 0 - L, X = Math.min(L, G);
                                        for(Y + f < 0 && gx(3); f < X; ++f)r[f] = (void 0)[Y + f];
                                    }
                                    for(; f < G; ++f)r[f] = r[f - L];
                                }
                            }
                            e.l = d, e.p = O, e.b = f, e.f = h, d && (h = 1, e.m = y, e.d = m, e.n = g);
                        }while (!h);
                        return f != r.length && a ? (l = r, (null == (u = f) || u > l.length) && (u = l.length), new Zg(l.subarray(0, u))) : r.subarray(0, f);
                    }(i.subarray(a, -8), {
                        i: 2
                    }, new Zg(((r = i)[(n = r.length) - 4] | r[n - 3] << 8 | r[n - 2] << 16 | r[n - 1] << 24) >>> 0))));
                    var r, n, i, a;
                    const s = bx[e];
                    if (!s) throw new Error(`Unhandled codec: ${e}`);
                    const o = new globalThis.DecompressionStream(s);
                    return new Response(new Blob([
                        t1
                    ]).stream().pipeThrough(o)).arrayBuffer().then((t1)=>new Uint8Array(t1));
                })(c, u).then((t1)=>((function(t1, e) {
                        t1.readFields(qg, e);
                    })(new Sx(t1), h), new Ax[a](h.buffer))), p.then((t1)=>{
                    for(let e = l.length - 1; e >= 0; e--)switch(l[e]){
                        case "delta_filter":
                            Gg(t1, s);
                            break;
                        case "zigzag_filter":
                            Yg(t1);
                            break;
                        case "bitshuffle_filter":
                            Xg(t1, a);
                            break;
                        default:
                            throw new _x(`Unhandled filter "${l[e]}"`);
                    }
                    return {
                        layerName: e,
                        blockIndex: o,
                        data: t1
                    };
                }).catch((t1)=>{
                    throw t1;
                });
            }));
        }, oa(zx, "MRTDecodingBatch", {
            omit: [
                "_onCancel",
                "_onComplete"
            ]
        });
        let Ex, kx, Tx, Bx, Cx, Vx = null;
        function Dx() {
            return gt() && self.worker && self.worker.dracoUrl ? self.worker.dracoUrl : kx || St.DRACO_URL;
        }
        function Lx() {
            if (gt() && self.worker && self.worker.meshoptUrl) return self.worker.meshoptUrl;
            if (Bx) return Bx;
            const t1 = new Uint8Array([
                0,
                97,
                115,
                109,
                1,
                0,
                0,
                0,
                1,
                4,
                1,
                96,
                0,
                0,
                3,
                3,
                2,
                0,
                0,
                5,
                3,
                1,
                0,
                1,
                12,
                1,
                0,
                10,
                22,
                2,
                12,
                0,
                65,
                0,
                65,
                0,
                65,
                0,
                252,
                10,
                0,
                0,
                11,
                7,
                0,
                65,
                0,
                253,
                15,
                26,
                11
            ]);
            if ("object" != typeof WebAssembly) throw new Error("WebAssembly not supported, cannot instantiate meshoptimizer");
            return Bx = WebAssembly.validate(t1) ? St.MESHOPT_SIMD_URL : St.MESHOPT_URL, Bx;
        }
        const Rx = {
            5120: Int8Array,
            5121: Uint8Array,
            5122: Int16Array,
            5123: Uint16Array,
            5125: Uint32Array,
            5126: Float32Array
        }, Fx = {
            5120: "DT_INT8",
            5121: "DT_UINT8",
            5122: "DT_INT16",
            5123: "DT_UINT16",
            5125: "DT_UINT32",
            5126: "DT_FLOAT32"
        }, Ox = {
            SCALAR: 1,
            VEC2: 2,
            VEC3: 3,
            VEC4: 4,
            MAT2: 4,
            MAT3: 9,
            MAT4: 16
        };
        function Nx(t1, e, r) {
            const n = r.json.bufferViews.length, i = r.buffers.length;
            e.bufferView = n, r.json.bufferViews[n] = {
                buffer: i,
                byteLength: t1.byteLength
            }, r.buffers[i] = t1;
        }
        const Ux = "KHR_draco_mesh_compression";
        function jx(t1, e) {
            const r = t1.extensions && t1.extensions[Ux];
            if (!r) return;
            const n = new Tx.Decoder, i = Hx(e, r.bufferView), a = new Tx.Mesh;
            if (!n.DecodeArrayToMesh(i, i.byteLength, a)) throw new Error("Failed to decode Draco mesh");
            const s = e.json.accessors[t1.indices], o = Rx[s.componentType], l = s.count * o.BYTES_PER_ELEMENT, u = Tx._malloc(l);
            o === Uint16Array ? n.GetTrianglesUInt16Array(a, l, u) : n.GetTrianglesUInt32Array(a, l, u), Nx(Tx.memory.buffer.slice(u, u + l), s, e), Tx._free(u);
            for (const i of Object.keys(r.attributes)){
                const s = n.GetAttributeByUniqueId(a, r.attributes[i]), o = e.json.accessors[t1.attributes[i]], l = Fx[o.componentType], u = o.count * Ox[o.type] * Rx[o.componentType].BYTES_PER_ELEMENT, c = Tx._malloc(u);
                n.GetAttributeDataArrayForAllPoints(a, s, Tx[l], u, c), Nx(Tx.memory.buffer.slice(c, c + u), o, e), Tx._free(c);
            }
            n.destroy(), a.destroy(), delete t1.extensions[Ux];
        }
        const qx = "EXT_meshopt_compression";
        function $x(t1, e) {
            if (!t1.extensions || !t1.extensions[qx]) return;
            const r = t1.extensions[qx], n = new Uint8Array(e.buffers[r.buffer], r.byteOffset || 0, r.byteLength || 0), i = new Uint8Array(r.count * r.byteStride);
            Cx.decodeGltfBuffer(i, r.count, r.byteStride, n, r.mode, r.filter), t1.buffer = e.buffers.length, t1.byteOffset = 0, e.buffers[t1.buffer] = i.buffer, delete t1.extensions[qx];
        }
        const Gx = 1179937895, Yx = new TextDecoder("utf8");
        function Xx(t1, e) {
            return new URL(t1, e).href;
        }
        function Zx(t1, e, r, n) {
            return fetch(Xx(t1.uri, n)).then((t1)=>t1.arrayBuffer()).then((t1)=>{
                e.buffers[r] = t1;
            });
        }
        function Hx(t1, e) {
            const r = t1.json.bufferViews[e];
            return new Uint8Array(t1.buffers[r.buffer], r.byteOffset || 0, r.byteLength);
        }
        function Wx(t1, e, r, n) {
            if (t1.uri) {
                const i = Xx(t1.uri, n);
                return fetch(i).then((t1)=>t1.blob()).then((t1)=>createImageBitmap(t1)).then((t1)=>{
                    e.images[r] = t1;
                });
            }
            if (void 0 !== t1.bufferView) {
                const n = Hx(e, t1.bufferView), i = new Blob([
                    n
                ], {
                    type: t1.mimeType
                });
                return createImageBitmap(i).then((t1)=>{
                    e.images[r] = t1;
                });
            }
        }
        function Kx(t1, e = 0, r) {
            const n = {
                json: null,
                images: [],
                buffers: []
            };
            if (new Uint32Array(t1, e, 1)[0] === Gx) {
                const r = new Uint32Array(t1, e);
                let i = 2;
                const a = (r[i++] >> 2) - 3, s = r[i++] >> 2;
                if (i++, n.json = JSON.parse(Yx.decode(r.subarray(i, i + s))), i += s, i < a) {
                    const a = r[i++];
                    i++;
                    const s = e + (i << 2);
                    n.buffers[0] = t1.slice(s, s + a);
                }
            } else n.json = JSON.parse(Yx.decode(new Uint8Array(t1, e)));
            const { buffers: i, images: a, meshes: s, extensionsUsed: o, bufferViews: l } = n.json;
            let u = Promise.resolve();
            if (i) {
                const t1 = [];
                for(let e = 0; e < i.length; e++){
                    const a = i[e];
                    a.uri ? t1.push(Zx(a, n, e, r)) : n.buffers[e] || (n.buffers[e] = null);
                }
                u = Promise.all(t1);
            }
            return u.then(()=>{
                const t1 = [], e = o && o.includes(Ux), i = o && o.includes(qx);
                if (e && t1.push(function() {
                    if (!Tx) return null != Ex ? Ex : (Ex = function(t1) {
                        let e, r = null;
                        function n() {
                            e = new Uint8Array(r.buffer);
                        }
                        function i() {
                            throw new Error("Unexpected Draco error.");
                        }
                        const a = {
                            a: {
                                a: i,
                                d: function(t1, r, n) {
                                    return e.copyWithin(t1, r, r + n);
                                },
                                c: function(t1) {
                                    const i = e.length, a = Math.max(t1 >>> 0, Math.ceil(1.2 * i)), s = Math.ceil((a - i) / 65536);
                                    try {
                                        return r.grow(s), n(), !0;
                                    } catch (t1) {
                                        return !1;
                                    }
                                },
                                b: i
                            }
                        };
                        return (WebAssembly.instantiateStreaming ? WebAssembly.instantiateStreaming(t1, a) : t1.then((t1)=>t1.arrayBuffer()).then((t1)=>WebAssembly.instantiate(t1, a))).then((t1)=>{
                            const { Rb: i, Qb: a, P: s, T: o, X: l, Ja: u, La: c, Qa: h, Va: p, Wa: f, eb: d, jb: m, f: y, e: g, yb: x, zb: v, Ab: b, Bb: _, Db: w, Gb: M } = t1.instance.exports;
                            r = g;
                            const A = (()=>{
                                let t1 = 0, r = 0, n = 0, s = 0;
                                return (o)=>{
                                    n && (i(s), i(t1), r += n, n = t1 = 0), t1 || (r += 128, t1 = a(r));
                                    const l = o.length + 7 & -8;
                                    let u = t1;
                                    l >= r && (n = l, u = s = a(l));
                                    for(let t1 = 0; t1 < o.length; t1++)e[u + t1] = o[t1];
                                    return u;
                                };
                            })();
                            return n(), y(), {
                                memory: g,
                                _free: i,
                                _malloc: a,
                                Mesh: class {
                                    destroy() {
                                        o(this.ptr);
                                    }
                                    constructor(){
                                        this.ptr = s();
                                    }
                                },
                                Decoder: class {
                                    destroy() {
                                        m(this.ptr);
                                    }
                                    DecodeArrayToMesh(t1, e, r) {
                                        const n = A(t1), i = c(this.ptr, n, e, r.ptr);
                                        return !!l(i);
                                    }
                                    GetAttributeByUniqueId(t1, e) {
                                        return {
                                            ptr: h(this.ptr, t1.ptr, e)
                                        };
                                    }
                                    GetTrianglesUInt16Array(t1, e, r) {
                                        p(this.ptr, t1.ptr, e, r);
                                    }
                                    GetTrianglesUInt32Array(t1, e, r) {
                                        f(this.ptr, t1.ptr, e, r);
                                    }
                                    GetAttributeDataArrayForAllPoints(t1, e, r, n, i) {
                                        d(this.ptr, t1.ptr, e.ptr, r, n, i);
                                    }
                                    constructor(){
                                        this.ptr = u();
                                    }
                                },
                                DT_INT8: x(),
                                DT_UINT8: v(),
                                DT_INT16: b(),
                                DT_UINT16: _(),
                                DT_UINT32: w(),
                                DT_FLOAT32: M()
                            };
                        });
                    }(fetch(Dx())), Ex.then((t1)=>{
                        Tx = t1, Ex = void 0;
                    }));
                }()), i && t1.push(function() {
                    if (Cx) return;
                    const t1 = function(t1) {
                        let e;
                        const r = WebAssembly.instantiateStreaming(t1, {}).then((t1)=>{
                            e = t1.instance, e.exports.__wasm_call_ctors();
                        }), n = {
                            NONE: "",
                            OCTAHEDRAL: "meshopt_decodeFilterOct",
                            QUATERNION: "meshopt_decodeFilterQuat",
                            EXPONENTIAL: "meshopt_decodeFilterExp"
                        }, i = {
                            ATTRIBUTES: "meshopt_decodeVertexBuffer",
                            TRIANGLES: "meshopt_decodeIndexBuffer",
                            INDICES: "meshopt_decodeIndexSequence"
                        };
                        return {
                            ready: r,
                            supported: !0,
                            decodeGltfBuffer (t1, r, a, s, o, l) {
                                !function(t1, e, r, n, i, a, s) {
                                    const o = t1.exports.sbrk, l = n + 3 & -4, u = o(l * i), c = o(a.length), h = new Uint8Array(t1.exports.memory.buffer);
                                    h.set(a, c);
                                    const p = e(u, n, i, c, a.length);
                                    if (0 === p && s && s(u, l, i), r.set(h.subarray(u, u + n * i)), o(u - o(0)), 0 !== p) throw new Error(`Malformed buffer data: ${p}`);
                                }(e, e.exports[i[o]], t1, r, a, s, e.exports[n[l]]);
                            }
                        };
                    }(fetch(Lx()));
                    return t1.ready.then(()=>{
                        Cx = t1;
                    });
                }()), a) for(let e = 0; e < a.length; e++)t1.push(Wx(a[e], n, e, r));
                return (t1.length ? Promise.all(t1) : Promise.resolve()).then(()=>{
                    if (e && s) for (const { primitives: t1 } of s)for (const e of t1)jx(e, n);
                    if (i && s && l) for (const t1 of l)$x(t1, n);
                    return n;
                });
            });
        }
        function Jx(t1, e) {
            const r = t1.json.bufferViews[e.bufferView], n = Rx[e.componentType];
            return new n(t1.buffers[r.buffer], (e.byteOffset || 0) + (r.byteOffset || 0), e.count * (r.byteStride && r.byteStride !== Ox[e.type] * n.BYTES_PER_ELEMENT ? r.byteStride / n.BYTES_PER_ELEMENT : Ox[e.type]));
        }
        function Qx(t1, e, r, n) {
            const i = Rx[e.componentType], a = function(t1) {
                switch(t1){
                    case Int8Array:
                        return 1 / 127;
                    case Uint8Array:
                        return 1 / 255;
                    case Int16Array:
                        return 1 / 32767;
                    case Uint16Array:
                        return 1 / 65535;
                    default:
                        return 1;
                }
            }(i), s = t1.json.bufferViews[e.bufferView], o = s.byteStride ? s.byteStride / i.BYTES_PER_ELEMENT : Ox[e.type], l = r.float32, u = l.length / r.capacity;
            for(let t1 = 0, r = 0; t1 < e.count * o; t1 += o, r += u)for(let e = 0; e < u; e++)l[r + e] = n[t1 + e] * a;
            r._trim();
        }
        function tv(t1, e, r) {
            const n = t1.indices, i = t1.attributes, a = {};
            a.indexArray = new Ls;
            const s = e.json.accessors[n], o = s.count / 3;
            a.indexArray.reserve(o);
            const l = Jx(e, s);
            for(let t1 = 0; t1 < o; t1++)a.indexArray.emplaceBack(l[3 * t1], l[3 * t1 + 1], l[3 * t1 + 2]);
            a.indexArray._trim(), a.vertexArray = new Ms;
            const u = e.json.accessors[i.POSITION];
            a.vertexArray.reserve(u.count);
            const c = Jx(e, u);
            for(let t1 = 0; t1 < u.count; t1++)a.vertexArray.emplaceBack(c[3 * t1], c[3 * t1 + 1], c[3 * t1 + 2]);
            if (a.vertexArray._trim(), a.aabb = new xu(u.min, u.max), a.centroid = function(t1, e) {
                const r = [
                    0,
                    0,
                    0
                ], n = t1.length;
                if (n > 0) {
                    for(let i = 0; i < n; i++){
                        const n = 3 * t1[i];
                        r[0] += e[n], r[1] += e[n + 1], r[2] += e[n + 2];
                    }
                    r[0] /= n, r[1] /= n, r[2] /= n;
                }
                return r;
            }(l, c), void 0 !== i.COLOR_0) {
                const t1 = e.json.accessors[i.COLOR_0], r = Ox[t1.type], n = Jx(e, t1);
                a.colorArray = 3 === r ? new Ms : new Es, a.colorArray.resize(t1.count), Qx(e, t1, a.colorArray, n);
            }
            if (void 0 !== i.NORMAL) {
                a.normalArray = new Ms;
                const t1 = e.json.accessors[i.NORMAL];
                a.normalArray.resize(t1.count);
                const r = Jx(e, t1);
                Qx(e, t1, a.normalArray, r);
            }
            if (void 0 !== i.TEXCOORD_0 && r.length > 0) {
                a.texcoordArray = new $s;
                const t1 = e.json.accessors[i.TEXCOORD_0];
                a.texcoordArray.resize(t1.count);
                const r = Jx(e, t1);
                Qx(e, t1, a.texcoordArray, r);
            }
            if (void 0 !== i._FEATURE_ID_RGBA4444) {
                const t1 = e.json.accessors[i._FEATURE_ID_RGBA4444];
                e.json.extensionsUsed && e.json.extensionsUsed.includes("EXT_meshopt_compression") && (a.featureData = Jx(e, t1));
            }
            void 0 !== i._FEATURE_RGBA4444 && (a.featureData = new Uint32Array(Jx(e, e.json.accessors[i._FEATURE_RGBA4444]).buffer));
            const h = t1.material;
            return a.material = function(t1, e) {
                const { emissiveFactor: r = [
                    0,
                    0,
                    0
                ], alphaMode: n = "OPAQUE", alphaCutoff: i = .5, normalTexture: a, occlusionTexture: s, emissiveTexture: o, doubleSided: l } = t1, { baseColorFactor: u = [
                    1,
                    1,
                    1,
                    1
                ], metallicFactor: c = 1, roughnessFactor: h = 1, baseColorTexture: p, metallicRoughnessTexture: f } = t1.pbrMetallicRoughness || {}, d = s ? e[s.index] : void 0;
                if (s && s.extensions && s.extensions.KHR_texture_transform && d) {
                    const t1 = s.extensions.KHR_texture_transform;
                    d.offsetScale = [
                        t1.offset[0],
                        t1.offset[1],
                        t1.scale[0],
                        t1.scale[1]
                    ];
                }
                return {
                    pbrMetallicRoughness: {
                        baseColorFactor: new Ie(...u),
                        metallicFactor: c,
                        roughnessFactor: h,
                        baseColorTexture: p ? e[p.index] : void 0,
                        metallicRoughnessTexture: f ? e[f.index] : void 0
                    },
                    doubleSided: l,
                    emissiveFactor: r,
                    alphaMode: n,
                    alphaCutoff: i,
                    normalTexture: a ? e[a.index] : void 0,
                    occlusionTexture: d,
                    emissionTexture: o ? e[o.index] : void 0,
                    defined: void 0 === t1.defined
                };
            }(void 0 !== h ? e.json.materials[h] : {
                defined: !1
            }, r), a;
        }
        function ev(t1, e, r) {
            const { matrix: n, rotation: i, translation: a, scale: s, mesh: o, extras: l, children: u } = t1, c = {};
            if (c.matrix = n || O.mat4.fromRotationTranslationScale([], i || [
                0,
                0,
                0,
                1
            ], a || [
                0,
                0,
                0
            ], s || [
                1,
                1,
                1
            ]), void 0 !== o) {
                c.meshes = r[o];
                const t1 = c.anchor = [
                    0,
                    0
                ];
                for (const e of c.meshes){
                    const { min: r, max: n } = e.aabb;
                    t1[0] += r[0] + n[0], t1[1] += r[1] + n[1];
                }
                t1[0] = Math.floor(t1[0] / c.meshes.length / 2), t1[1] = Math.floor(t1[1] / c.meshes.length / 2);
            }
            if (l && (l.id && (c.id = l.id), l.lights && (c.lights = function(t1) {
                if (!t1.length) return [];
                const e = function(t1) {
                    const e = atob(t1), r = new Uint8Array(e.length);
                    for(let t1 = 0; t1 < e.length; t1++)r[t1] = e.codePointAt(t1);
                    return r;
                }(t1), r = [], n = e.length / 24, i = new Uint16Array(e.buffer), a = new Float32Array(e.buffer);
                for(let t1 = 0; t1 < n; t1++){
                    const e = i[2 * t1 * 6] / 30, n = i[2 * t1 * 6 + 1] / 30, s = i[2 * t1 * 6 + 10] / 100, o = a[6 * t1 + 1], l = a[6 * t1 + 2], u = a[6 * t1 + 3], c = a[6 * t1 + 4], h = u - o, p = c - l, f = Math.hypot(h, p);
                    r.push({
                        pos: [
                            o + .5 * h,
                            l + .5 * p,
                            n
                        ],
                        normal: [
                            p / f,
                            -h / f,
                            0
                        ],
                        width: f,
                        height: e,
                        depth: s,
                        points: [
                            o,
                            l,
                            u,
                            c
                        ]
                    });
                }
                return r;
            }(l.lights))), u) {
                const t1 = [];
                for (const n of u)t1.push(ev(e.json.nodes[n], e, r));
                c.children = t1;
            }
            return c;
        }
        function rv(t1) {
            if (0 === t1.vertices.length || 0 === t1.indices.length) return null;
            const e = new Yc(t1.vertices, t1.indices, 8, 256), [r, n] = [
                e.min.clone(),
                e.max.clone()
            ];
            return {
                vertices: t1.vertices,
                indices: t1.indices,
                grid: e,
                min: r,
                max: n
            };
        }
        function nv(t1) {
            if (!t1.extras || !t1.extras.ground) return null;
            const e = t1.extras.ground;
            if (!e || !Array.isArray(e) || 0 === e.length) return null;
            const r = e[0];
            if (!r || !Array.isArray(r) || 0 === r.length) return null;
            const n = [];
            for (const t1 of r){
                if (!Array.isArray(t1) || 2 !== t1.length) continue;
                const e = t1[0], r = t1[1];
                "number" == typeof e && "number" == typeof r && n.push(new q(e, r));
            }
            if (n.length < 3) return null;
            n.length > 1 && n[n.length - 1].equals(n[0]) && n.pop();
            let i = 0;
            for(let t1 = 0; t1 < n.length; t1++){
                const e = n[t1], r = n[(t1 + 1) % n.length], a = n[(t1 + 2) % n.length];
                i += (e.x - r.x) * (a.y - r.y) - (a.x - r.x) * (e.y - r.y);
            }
            i > 0 && n.reverse();
            const a = hc(n.flatMap((t1)=>[
                    t1.x,
                    t1.y
                ]), []);
            return 0 === a.length ? null : {
                vertices: n,
                indices: a
            };
        }
        function iv(t1, e) {
            const r = [], n = [];
            let i = 0;
            const a = [];
            for (const s of t1){
                i = r.length;
                const t1 = s.vertexArray.float32, o = s.indexArray.uint16;
                for(let n = 0; n < s.vertexArray.length; n++)a[0] = t1[3 * n + 0], a[1] = t1[3 * n + 1], a[2] = t1[3 * n + 2], O.vec3.transformMat4(a, a, e), r.push(new q(a[0], a[1]));
                for(let t1 = 0; t1 < 3 * s.indexArray.length; t1++)n.push(o[t1] + i);
            }
            if (n.length % 3 != 0) return null;
            for(let t1 = 0; t1 < n.length; t1 += 3){
                const e = r[n[t1 + 0]], i = r[n[t1 + 1]], a = r[n[t1 + 2]];
                (e.x - i.x) * (a.y - i.y) - (a.x - i.x) * (e.y - i.y) > 0 && ([n[t1 + 1], n[t1 + 2]] = [
                    n[t1 + 2],
                    n[t1 + 1]
                ]);
            }
            return {
                vertices: r,
                indices: n
            };
        }
        function av(t1) {
            const e = function(t1, e) {
                const r = [], n = WebGL2RenderingContext;
                if (t1.json.textures) for (const i of t1.json.textures){
                    const a = {
                        magFilter: n.LINEAR,
                        minFilter: n.NEAREST,
                        wrapS: n.REPEAT,
                        wrapT: n.REPEAT
                    };
                    void 0 !== i.sampler && Object.assign(a, t1.json.samplers[i.sampler]), r.push({
                        image: e[i.source],
                        sampler: a,
                        uploaded: !1
                    });
                }
                return r;
            }(t1, t1.images), r = function(t1, e) {
                const r = [];
                for (const n of t1.json.meshes){
                    const i = [];
                    for (const r of n.primitives)i.push(tv(r, t1, e));
                    r.push(i);
                }
                return r;
            }(t1, e), { scenes: n, scene: i, nodes: a } = t1.json, s = n ? n[i || 0].nodes : a, o = [];
            for (const e of s)o.push(ev(a[e], t1, r));
            return function(t1, e, r) {
                const n = {}, i = new Set;
                for(let a = 0; a < t1.length; a++){
                    const t1 = r[e[a]];
                    if (!t1.extras) continue;
                    const s = t1.extras["mapbox:footprint:version"], o = t1.extras["mapbox:footprint:id"];
                    (s || o) && i.add(a), "1.0.0" === s && o && (n[o] = a);
                }
                for(let a = 0; a < t1.length; a++){
                    if (i.has(a)) continue;
                    const s = t1[a], o = r[e[a]];
                    if (!o.extras) continue;
                    let l = null;
                    s.id in n && (l = iv(t1[n[s.id]].meshes, s.matrix)), l || (l = nv(o)), l && (s.footprint = rv(l));
                }
                if (i.size > 0) {
                    const e = Array.from(i.values()).sort((t1, e)=>t1 - e);
                    for(let r = e.length - 1; r >= 0; r--)t1.splice(e[r], 1);
                }
            }(o, s, t1.json.nodes), o;
        }
        function sv(t1) {
            t1.heightmap = new Float32Array(4096), t1.heightmap.fill(-1);
            const e = t1.vertexArray.float32, r = t1.aabb.min[0] - 1, n = t1.aabb.min[1] - 1, i = ey / (t1.aabb.max[0] - r + 2), a = ey / (t1.aabb.max[1] - n + 2);
            for(let s = 0; s < e.length; s += 3){
                const o = e[s + 2], l = (e[s + 0] - r) * i | 0, u = (e[s + 1] - n) * a | 0;
                o > t1.heightmap[u * ey + l] && (t1.heightmap[u * ey + l] = o);
            }
        }
        function ov(t1, e) {
            const r = {};
            r.indexArray = new Ls, r.indexArray.reserve(4 * t1.length), r.vertexArray = new Ms, r.vertexArray.reserve(10 * t1.length), r.colorArray = new Es, r.vertexArray.reserve(10 * t1.length);
            let n = 0;
            for (const i of t1){
                const t1 = Math.min(10, Math.max(4, 1.3 * i.height)) * e, a = [
                    -i.normal[1],
                    i.normal[0],
                    0
                ], s = Math.min(.29, .1 * i.width / i.depth), o = i.width - 2 * i.depth * e * (s + .01), l = O.vec3.scaleAndAdd([], i.pos, a, o / 2), u = O.vec3.scaleAndAdd([], i.pos, a, -o / 2), c = [
                    l[0],
                    l[1],
                    l[2] + i.height
                ], h = [
                    u[0],
                    u[1],
                    u[2] + i.height
                ], p = O.vec3.scaleAndAdd([], i.normal, a, s);
                O.vec3.scale(p, p, t1);
                const f = O.vec3.scaleAndAdd([], i.normal, a, -s);
                O.vec3.scale(f, f, t1), O.vec3.add(p, l, p), O.vec3.add(f, u, f), l[2] += .1, u[2] += .1, r.vertexArray.emplaceBack(p[0], p[1], p[2]), r.vertexArray.emplaceBack(f[0], f[1], f[2]), r.vertexArray.emplaceBack(l[0], l[1], l[2]), r.vertexArray.emplaceBack(u[0], u[1], u[2]), r.vertexArray.emplaceBack(c[0], c[1], c[2]), r.vertexArray.emplaceBack(h[0], h[1], h[2]), r.vertexArray.emplaceBack(l[0], l[1], l[2]), r.vertexArray.emplaceBack(u[0], u[1], u[2]), r.vertexArray.emplaceBack(p[0], p[1], p[2]), r.vertexArray.emplaceBack(f[0], f[1], f[2]);
                const d = o / t1 / 2;
                r.colorArray.emplaceBack(-d - s, -1, d, .8), r.colorArray.emplaceBack(d + s, -1, d, .8), r.colorArray.emplaceBack(-d, 0, d, 1.3), r.colorArray.emplaceBack(d, 0, d, 1.3), r.colorArray.emplaceBack(d + s, -0.8, d, .7), r.colorArray.emplaceBack(d + s, -0.8, d, .7), r.colorArray.emplaceBack(0, 0, d, 1.3), r.colorArray.emplaceBack(0, 0, d, 1.3), r.colorArray.emplaceBack(d + s, -1.2, d, .8), r.colorArray.emplaceBack(d + s, -1.2, d, .8), r.indexArray.emplaceBack(6 + n, 4 + n, 8 + n), r.indexArray.emplaceBack(7 + n, 9 + n, 5 + n), r.indexArray.emplaceBack(0 + n, 1 + n, 2 + n), r.indexArray.emplaceBack(1 + n, 3 + n, 2 + n), n += 10;
            }
            const i = {
                defined: !0,
                emissiveFactor: [
                    0,
                    0,
                    0
                ]
            }, a = {};
            return a.baseColorFactor = Ie.white, i.pbrMetallicRoughness = a, r.material = i, r.aabb = new xu([
                1 / 0,
                1 / 0,
                1 / 0
            ], [
                -1 / 0,
                -1 / 0,
                -1 / 0
            ]), r;
        }
        class lv {
            encode(t1) {
                return this._stringToNumber[t1];
            }
            decode(t1) {
                return this._numberToString[t1];
            }
            constructor(t1){
                this._stringToNumber = {}, this._numberToString = [];
                for(let e = 0; e < t1.length; e++){
                    const r = t1[e];
                    this._stringToNumber[r] = e, this._numberToString[e] = r;
                }
            }
        }
        const uv = [
            "id",
            "tile",
            "layer",
            "source",
            "sourceLayer",
            "state"
        ];
        class cv {
            clone() {
                const t1 = new cv(this._vectorTileFeature, this._z, this._x, this._y, this.id);
                return this.state && (t1.state = Object.assign({}, this.state)), this.layer && (t1.layer = Object.assign({}, this.layer)), this.source && (t1.source = this.source), this.sourceLayer && (t1.sourceLayer = this.sourceLayer), t1;
            }
            get geometry() {
                return void 0 === this._geometry && (this._geometry = this._vectorTileFeature.toGeoJSON(this._x, this._y, this._z).geometry), this._geometry;
            }
            set geometry(t1) {
                this._geometry = t1;
            }
            toJSON() {
                const t1 = {
                    type: "Feature",
                    state: void 0,
                    geometry: this.geometry,
                    properties: this.properties
                };
                for (const e of uv)void 0 !== this[e] && (t1[e] = this[e]);
                return t1;
            }
            constructor(t1, e, r, n, i){
                this.type = "Feature", this._vectorTileFeature = t1, this._z = e, this._x = r, this._y = n, this.properties = t1.properties, this.id = i;
            }
        }
        class hv {
            insert(t1, e, r, n, i, a = 0, s = 0) {
                const o = this.featureIndexArray.length;
                this.featureIndexArray.emplaceBack(r, n, i, a);
                const l = this.grid;
                for(let t1 = 0; t1 < e.length; t1++){
                    const r = e[t1], n = [
                        1 / 0,
                        1 / 0,
                        -1 / 0,
                        -1 / 0
                    ];
                    for(let t1 = 0; t1 < r.length; t1++){
                        const e = r[t1];
                        n[0] = Math.min(n[0], e.x), n[1] = Math.min(n[1], e.y), n[2] = Math.max(n[2], e.x), n[3] = Math.max(n[3], e.y);
                    }
                    0 !== s && (n[0] -= s, n[1] -= s, n[2] += s, n[3] += s), n[0] < Wr && n[1] < Wr && n[2] >= 0 && n[3] >= 0 && l.insert(o, n[0], n[1], n[2], n[3]);
                }
            }
            loadVTLayers() {
                if (!this.vtLayers) {
                    this.vtLayers = new fh.VectorTile(new pf(this.rawTileData)).layers, this.sourceLayerCoder = new lv(this.vtLayers ? Object.keys(this.vtLayers).sort() : [
                        "_geojsonTileLayer"
                    ]), this.vtFeatures = {};
                    for(const t1 in this.vtLayers)this.vtFeatures[t1] = [];
                }
                return this.vtLayers;
            }
            query(t1, e) {
                const { tilespaceGeometry: r, transform: n, tileTransform: i, pixelPosMatrix: a, availableImages: s } = e;
                this.loadVTLayers(), this.serializedLayersCache.clear();
                const o = r.bufferedTilespaceBounds, l = this.grid.query(o.min.x, o.min.y, o.max.x, o.max.y, (t1, e, n, i)=>ql(r.bufferedTilespaceGeometry, t1, e, n, i));
                l.sort(fv);
                let u = null;
                n.elevation && l.length > 0 && (u = uy.create(n.elevation, this.tileID));
                const c = {};
                let h;
                for(let e = 0; e < l.length; e++){
                    const o = l[e];
                    if (o === h) continue;
                    h = o;
                    const p = this.featureIndexArray.get(o);
                    let f = null;
                    this.is3DTile ? this.loadMatchingModelFeature(c, p, t1, r, n) : this.loadMatchingFeature(c, p, t1, s, (t1, e, s, o = 0)=>(f || (f = zl(t1, this.tileID.canonical, i)), e.queryIntersectsFeature(r, t1, s, f, this.z, n, a, u, o)));
                }
                return c;
            }
            loadMatchingFeature(t1, e, r, n, i) {
                const { featureIndex: a, bucketIndex: s, sourceLayerIndex: o, layoutVertexArrayOffset: l } = e, u = this.bucketLayerIDs[s], c = r.layers, h = Object.keys(c);
                if (h.length && !function(t1, e) {
                    for(let r = 0; r < t1.length; r++)if (e.indexOf(t1[r]) >= 0) return !0;
                    return !1;
                }(h, u)) return;
                const p = r.sourceCache, f = this.sourceLayerCoder.decode(o), d = this.vtLayers[f].feature(a), m = this.getId(d, f);
                for(let e = 0; e < u.length; e++){
                    const r = u[e];
                    if (!c[r]) continue;
                    const { styleLayer: s, targets: o } = c[r];
                    let h = {};
                    void 0 !== m && (h = p.getFeatureState(s.sourceLayer, m));
                    const f = !i || i(d, s, h, l);
                    if (!f) continue;
                    const y = new cv(d, this.z, this.x, this.y, m);
                    y.tile = this.tileID.canonical, y.state = h;
                    let g = this.serializedLayersCache.get(r);
                    g || (g = s.serialize(), g.id = r, this.serializedLayersCache.set(r, g)), y.source = g.source, y.sourceLayer = g["source-layer"], y.layer = nt({}, g), y.layer.paint = pv(g.paint, s.paint, d, h, n), y.layer.layout = pv(g.layout, s.layout, d, h, n);
                    let x = !1;
                    for (const t1 of o){
                        this.updateFeatureProperties(y, t1);
                        const { filter: e } = t1;
                        if (e) {
                            if (d.properties = y.properties, e.needGeometry) {
                                const t1 = El(d, !0);
                                if (!e.filter(new Ca(this.tileID.overscaledZ), t1, this.tileID.canonical)) continue;
                            } else if (!e.filter(new Ca(this.tileID.overscaledZ), d)) continue;
                        }
                        x = !0, t1.targetId && this.addFeatureVariant(y, t1);
                    }
                    x && this.appendToResult(t1, r, a, y, f);
                }
            }
            loadMatchingModelFeature(t1, e, r, n, i) {
                const a = this.bucketLayerIDs[0][0], s = r.layers;
                if (!s[a]) return;
                const { styleLayer: o, targets: l } = s[a];
                if ("model" !== o.type) return;
                const u = n.tile, c = e.featureIndex, h = u.getBucket(o);
                if (!(h && h instanceof yy)) return;
                const p = function(t1, e, r, n) {
                    const i = t1.getNodesInfo()[e];
                    if (i.hiddenByReplacement || !i.node.meshes) return;
                    let a = Number.MAX_VALUE;
                    const s = i.node, o = r.tile, l = n.calculatePosMatrix(o.tileID.toUnwrapped(), n.worldSize), u = i.evaluatedScale;
                    let c = 0;
                    n.elevation && s.elevation && (c = s.elevation * n.elevation.exaggeration()), O.mat4.translate(l, l, [
                        (s.anchor ? s.anchor[0] : 0) * (u[0] - 1),
                        (s.anchor ? s.anchor[1] : 0) * (u[1] - 1),
                        c
                    ]), O.mat4.scale(l, l, u);
                    const h = r.queryGeometry, p = h.isPointQuery() ? h.screenBounds : h.screenGeometry, f = function(t1) {
                        const e = O.mat4.multiply([], l, t1.matrix);
                        O.mat4.multiply(e, n.expandedFarZProjMatrix, e);
                        for(let r = 0; r < t1.meshes.length; ++r){
                            const i = t1.meshes[r];
                            if (r === t1.lightMeshIndex) continue;
                            const s = Om(p, n, e, i.aabb);
                            null != s && (a = Math.min(s, a));
                        }
                        if (t1.children) for (const e of t1.children)f(e);
                    };
                    if (f(s), a === Number.MAX_VALUE) return;
                    const d = new il(0, 0);
                    return by(o.tileID.canonical, d, i.node.anchor[0], i.node.anchor[1]), {
                        intersectionZ: a,
                        position: d,
                        feature: i.feature
                    };
                }(h, c, n, i);
                if (!p) return;
                const { z: f, x: d, y: m } = u.tileID.canonical, { feature: y, intersectionZ: g, position: x } = p;
                let v = {};
                void 0 !== y.id && (v = r.sourceCache.getFeatureState(o.sourceLayer, y.id));
                const b = new cv({}, f, d, m, y.id);
                b.tile = this.tileID.canonical, b.state = v, b.properties = y.properties, b.geometry = {
                    type: "Point",
                    coordinates: [
                        x.lng,
                        x.lat
                    ]
                };
                let _ = this.serializedLayersCache.get(a);
                _ || (_ = o.serialize(), _.id = a, this.serializedLayersCache.set(a, _)), b.source = _.source, b.sourceLayer = _["source-layer"], b.layer = nt({}, _);
                let w = !1;
                for (const t1 of l){
                    this.updateFeatureProperties(b, t1);
                    const { filter: e } = t1;
                    if (e) {
                        if (y.properties = b.properties, e.needGeometry) {
                            if (!e.filter(new Ca(this.tileID.overscaledZ), y, this.tileID.canonical)) continue;
                        } else if (!e.filter(new Ca(this.tileID.overscaledZ), y)) continue;
                    }
                    w = !0, t1.targetId && this.addFeatureVariant(b, t1);
                }
                w && this.appendToResult(t1, a, c, b, g);
            }
            updateFeatureProperties(t1, e, r) {
                if (e.properties) {
                    const n = {};
                    for(const i in e.properties){
                        const a = e.properties[i].evaluate({
                            zoom: this.z
                        }, t1._vectorTileFeature, t1.state, t1.tile, r);
                        null != a && (n[i] = a);
                    }
                    t1.properties = n;
                }
            }
            addFeatureVariant(t1, e, r) {
                const n = {
                    target: e.target,
                    namespace: e.namespace,
                    uniqueFeatureID: e.uniqueFeatureID
                };
                e.properties && (n.properties = t1.properties), t1.variants = t1.variants || {}, t1.variants[e.targetId] = t1.variants[e.targetId] || [], t1.variants[e.targetId].push(n);
            }
            appendToResult(t1, e, r, n, i) {
                let a = t1[e];
                void 0 === a && (a = t1[e] = []), a.push({
                    featureIndex: r,
                    feature: n,
                    intersectionZ: i
                });
            }
            lookupSymbolFeatures(t1, e, r, n, i) {
                const a = {};
                this.loadVTLayers();
                for (const s of t1)this.loadMatchingFeature(a, {
                    bucketIndex: e,
                    sourceLayerIndex: r,
                    featureIndex: s,
                    layoutVertexArrayOffset: 0
                }, n, i);
                return a;
            }
            loadFeature(t1) {
                const { featureIndex: e, sourceLayerIndex: r } = t1;
                this.loadVTLayers();
                const n = this.sourceLayerCoder.decode(r), i = this.vtFeatures[n];
                if (i[e]) return i[e];
                const a = this.vtLayers[n].feature(e);
                return i[e] = a, a;
            }
            hasLayer(t1) {
                for (const e of this.bucketLayerIDs)for (const r of e)if (t1 === r) return !0;
                return !1;
            }
            getId(t1, e) {
                let r = t1.id;
                if (this.promoteId) {
                    const n = Array.isArray(this.promoteId) || "object" != typeof this.promoteId ? this.promoteId : this.promoteId[e];
                    if (null != n) {
                        if (Array.isArray(n)) {
                            if (!this.promoteIdExpression) {
                                const t1 = Wi(n);
                                if ("success" !== t1.result) {
                                    const e = t1.value.map((t1)=>`${t1.key}: ${t1.message}`).join(", ");
                                    return void ft(`Failed to create expression for promoteId: ${e}`);
                                }
                                this.promoteIdExpression = t1.value;
                            }
                            this.promoteIdExpression._evaluator || (this.promoteIdExpression._evaluator = new mr), r = this.promoteIdExpression.evaluate({
                                zoom: 0
                            }, t1);
                        } else r = t1.properties[n];
                    }
                    "boolean" == typeof r && (r = Number(r));
                }
                return r;
            }
            constructor(t1, e){
                this.tileID = t1, this.x = t1.canonical.x, this.y = t1.canonical.y, this.z = t1.canonical.z, this.grid = new aa(Wr, 16, 0), this.featureIndexArray = new so, this.promoteId = e, this.is3DTile = !1, this.serializedLayersCache = new Map;
            }
        }
        function pv(t1, e, r, n, i) {
            return ut(t1, (t1, a)=>{
                const s = e instanceof Ua ? e.get(a) : null;
                return s && s.evaluate ? s.evaluate(r, n, i) : s;
            });
        }
        function fv(t1, e) {
            return e - t1;
        }
        oa(hv, "FeatureIndex", {
            omit: [
                "rawTileData",
                "sourceLayerCoder"
            ]
        });
        const dv = [
            Int8Array,
            Uint8Array,
            Uint8ClampedArray,
            Int16Array,
            Uint16Array,
            Int32Array,
            Uint32Array,
            Float32Array,
            Float64Array
        ];
        class mv {
            static from(t1) {
                if (!(t1 instanceof ArrayBuffer)) throw new Error("Data must be an instance of ArrayBuffer.");
                const [e, r] = new Uint8Array(t1, 0, 2);
                if (219 !== e) throw new Error("Data does not appear to be in a KDBush format.");
                const n = r >> 4;
                if (1 !== n) throw new Error(`Got v${n} data when expected v1.`);
                const i = dv[15 & r];
                if (!i) throw new Error("Unrecognized array type.");
                const [a] = new Uint16Array(t1, 2, 1), [s] = new Uint32Array(t1, 4, 1);
                return new mv(s, a, i, t1);
            }
            add(t1, e) {
                const r = this._pos >> 1;
                return this.ids[r] = r, this.coords[this._pos++] = t1, this.coords[this._pos++] = e, r;
            }
            finish() {
                const t1 = this._pos >> 1;
                if (t1 !== this.numItems) throw new Error(`Added ${t1} items when expected ${this.numItems}.`);
                return yv(this.ids, this.coords, this.nodeSize, 0, this.numItems - 1, 0), this._finished = !0, this;
            }
            range(t1, e, r, n) {
                if (!this._finished) throw new Error("Data not yet indexed - call index.finish().");
                const { ids: i, coords: a, nodeSize: s } = this, o = [
                    0,
                    i.length - 1,
                    0
                ], l = [];
                for(; o.length;){
                    const u = o.pop() || 0, c = o.pop() || 0, h = o.pop() || 0;
                    if (c - h <= s) {
                        for(let s = h; s <= c; s++){
                            const o = a[2 * s], u = a[2 * s + 1];
                            o >= t1 && o <= r && u >= e && u <= n && l.push(i[s]);
                        }
                        continue;
                    }
                    const p = h + c >> 1, f = a[2 * p], d = a[2 * p + 1];
                    f >= t1 && f <= r && d >= e && d <= n && l.push(i[p]), (0 === u ? t1 <= f : e <= d) && (o.push(h), o.push(p - 1), o.push(1 - u)), (0 === u ? r >= f : n >= d) && (o.push(p + 1), o.push(c), o.push(1 - u));
                }
                return l;
            }
            within(t1, e, r) {
                if (!this._finished) throw new Error("Data not yet indexed - call index.finish().");
                const { ids: n, coords: i, nodeSize: a } = this, s = [
                    0,
                    n.length - 1,
                    0
                ], o = [], l = r * r;
                for(; s.length;){
                    const u = s.pop() || 0, c = s.pop() || 0, h = s.pop() || 0;
                    if (c - h <= a) {
                        for(let r = h; r <= c; r++)bv(i[2 * r], i[2 * r + 1], t1, e) <= l && o.push(n[r]);
                        continue;
                    }
                    const p = h + c >> 1, f = i[2 * p], d = i[2 * p + 1];
                    bv(f, d, t1, e) <= l && o.push(n[p]), (0 === u ? t1 - r <= f : e - r <= d) && (s.push(h), s.push(p - 1), s.push(1 - u)), (0 === u ? t1 + r >= f : e + r >= d) && (s.push(p + 1), s.push(c), s.push(1 - u));
                }
                return o;
            }
            constructor(t1, e = 64, r = Float64Array, n){
                if (isNaN(t1) || t1 < 0) throw new Error(`Unpexpected numItems value: ${t1}.`);
                this.numItems = +t1, this.nodeSize = Math.min(Math.max(+e, 2), 65535), this.ArrayType = r, this.IndexArrayType = t1 < 65536 ? Uint16Array : Uint32Array;
                const i = dv.indexOf(this.ArrayType), a = 2 * t1 * this.ArrayType.BYTES_PER_ELEMENT, s = t1 * this.IndexArrayType.BYTES_PER_ELEMENT, o = (8 - s % 8) % 8;
                if (i < 0) throw new Error(`Unexpected typed array class: ${r}.`);
                n && n instanceof ArrayBuffer ? (this.data = n, this.ids = new this.IndexArrayType(this.data, 8, t1), this.coords = new this.ArrayType(this.data, 8 + s + o, 2 * t1), this._pos = 2 * t1, this._finished = !0) : (this.data = new ArrayBuffer(8 + a + s + o), this.ids = new this.IndexArrayType(this.data, 8, t1), this.coords = new this.ArrayType(this.data, 8 + s + o, 2 * t1), this._pos = 0, this._finished = !1, new Uint8Array(this.data, 0, 2).set([
                    219,
                    16 + i
                ]), new Uint16Array(this.data, 2, 1)[0] = e, new Uint32Array(this.data, 4, 1)[0] = t1);
            }
        }
        function yv(t1, e, r, n, i, a) {
            if (i - n <= r) return;
            const s = n + i >> 1;
            gv(t1, e, s, n, i, a), yv(t1, e, r, n, s - 1, 1 - a), yv(t1, e, r, s + 1, i, 1 - a);
        }
        function gv(t1, e, r, n, i, a) {
            for(; i > n;){
                if (i - n > 600) {
                    const s = i - n + 1, o = r - n + 1, l = Math.log(s), u = .5 * Math.exp(2 * l / 3), c = .5 * Math.sqrt(l * u * (s - u) / s) * (o - s / 2 < 0 ? -1 : 1);
                    gv(t1, e, r, Math.max(n, Math.floor(r - o * u / s + c)), Math.min(i, Math.floor(r + (s - o) * u / s + c)), a);
                }
                const s = e[2 * r + a];
                let o = n, l = i;
                for(xv(t1, e, n, r), e[2 * i + a] > s && xv(t1, e, n, i); o < l;){
                    for(xv(t1, e, o, l), o++, l--; e[2 * o + a] < s;)o++;
                    for(; e[2 * l + a] > s;)l--;
                }
                e[2 * n + a] === s ? xv(t1, e, n, l) : (l++, xv(t1, e, l, i)), l <= r && (n = l + 1), r <= l && (i = l - 1);
            }
        }
        function xv(t1, e, r, n) {
            vv(t1, r, n), vv(e, 2 * r, 2 * n), vv(e, 2 * r + 1, 2 * n + 1);
        }
        function vv(t1, e, r) {
            const n = t1[e];
            t1[e] = t1[r], t1[r] = n;
        }
        function bv(t1, e, r, n) {
            const i = t1 - r, a = e - n;
            return i * i + a * a;
        }
        t1.$ = Ha, t1.A = tr, t1.B = 2, t1.C = $f, t1.D = zy, t1.E = we, t1.F = jf, t1.G = class extends Zm {
        }, t1.H = hr, t1.I = Ag, t1.J = Te, t1.K = Xa, t1.L = Oi, t1.M = Li, t1.N = Fi, t1.O = Hi, t1.P = q, t1.Q = Za, t1.R = te, t1.S = Qi, t1.T = dm, t1.U = Wi, t1.V = Zm, t1.W = Bn, t1.X = Vn, t1.Y = Tn, t1.Z = yr, t1._ = Se, t1.a = function(t1) {
            return St.API_CDN_URL_REGEX.test(t1);
        }, t1.a$ = cv, t1.a0 = Ni, t1.a1 = Ri, t1.a2 = function(t1) {
            const e = t1.value;
            let r = [];
            if (!e) return r;
            const n = hr(e);
            return "string" !== n ? (r = r.concat([
                new Zm(t1.key, e, `string expected, "${n}" found`)
            ]), r) : (Hm(e, !0) || (r = r.concat([
                new Zm(t1.key, e, `invalid url "${e}"`)
            ])), r);
        }, t1.a3 = Ya, t1.a4 = La, t1.a5 = Ga, t1.a6 = ja, t1.a7 = class {
            possiblyEvaluate(t1, e) {
                return yt(t1.expression.evaluate(e));
            }
            interpolate(t1, e, r) {
                return {
                    x: ze(t1.x, e.x, r),
                    y: ze(t1.y, e.y, r),
                    z: ze(t1.z, e.z, r),
                    azimuthal: ze(t1.azimuthal, e.azimuthal, r),
                    polar: ze(t1.polar, e.polar, r)
                };
            }
            constructor(t1){
                this.specification = t1;
            }
        }, t1.a8 = Ca, t1.a9 = Ji, t1.aA = cl, t1.aB = class {
            request(t1, e, r, n) {
                const i = this.entries[t1] = this.entries[t1] || {
                    callbacks: []
                };
                if (i.result) {
                    const [t1, r] = i.result;
                    return this.scheduler ? this.scheduler.add(()=>{
                        n(t1, r);
                    }, e) : n(t1, r), ()=>{};
                }
                return i.callbacks.push(n), i.cancel || (i.cancel = r((r, n)=>{
                    i.result = [
                        r,
                        n
                    ];
                    for (const t1 of i.callbacks)this.scheduler ? this.scheduler.add(()=>{
                        t1(r, n);
                    }, e) : t1(r, n);
                    setTimeout(()=>delete this.entries[t1], 3e3);
                })), ()=>{
                    i.result || (i.callbacks = i.callbacks.filter((t1)=>t1 !== n), i.callbacks.length || (i.cancel(), delete this.entries[t1]));
                };
            }
            constructor(t1){
                this.entries = {}, this.scheduler = t1;
            }
        }, t1.aC = us, t1.aD = function(t1, e, r) {
            const n = JSON.stringify(t1.request);
            return t1.data && (this.deduped.entries[n] = {
                result: [
                    null,
                    t1.data
                ]
            }), this.deduped.request(n, {
                type: "parseTile",
                isSymbolTile: t1.isSymbolTile,
                zoom: t1.tileZoom
            }, (e)=>{
                const n = ie(t1.request, (t1, n, i, a)=>{
                    t1 ? e(t1) : n && e(null, {
                        vectorTile: r ? void 0 : new fh.VectorTile(new pf(n)),
                        rawData: n,
                        cacheControl: i,
                        expires: a
                    });
                });
                return ()=>{
                    n.cancel(), e();
                };
            }, e);
        }, t1.aE = function(t1) {
            Yt++, Yt > Nt && (t1.getActor().send("enforceCacheSizeLimit", Ot), Yt = 0);
        }, t1.aF = function(t1) {
            return t1 <= 1 ? 1 : Math.pow(2, Math.floor(Math.log(t1) / Math.LN2));
        }, t1.aG = iu, t1.aH = _m, t1.aI = Pm, t1.aJ = vm, t1.aK = function(t1, e) {
            const r = document.createElement("video");
            r.muted = !0, r.onloadstart = function() {
                e(null, r);
            };
            for(let e = 0; e < t1.length; e++){
                const n = document.createElement("source");
                ae(t1[e]) || (r.crossOrigin = "Anonymous"), n.src = t1[e], r.appendChild(n);
            }
            return {
                cancel: ()=>{}
            };
        }, t1.aL = mm, t1.aM = function(t1) {
            return fetch(t1).then((t1)=>t1.arrayBuffer()).then((e)=>Kx(e, 0, t1));
        }, t1.aN = av, t1.aO = class {
            _applyTransformations(t1, e) {
                if (O.mat4.multiply(t1.matrix, e, t1.matrix), t1.meshes) for (const e of t1.meshes){
                    const r = xu.applyTransformFast(e.aabb, t1.matrix);
                    this.aabb.encapsulate(r);
                }
                if (t1.children) for (const e of t1.children)this._applyTransformations(e, t1.matrix);
            }
            computeBoundsAndApplyParent() {
                const t1 = O.mat4.identity([]);
                for (const e of this.nodes)this._applyTransformations(e, t1);
            }
            computeModelMatrix(t1, e, r, n, i, a, s = !1) {
                ny(this.matrix, this, t1.transform, this.position, e, r, n, i, a, s);
            }
            upload(t1) {
                if (!this.uploaded) {
                    for (const e of this.nodes)sy(e, t1);
                    for (const t1 of this.nodes)oy(t1);
                    this.uploaded = !0;
                }
            }
            destroy() {
                for (const t1 of this.nodes)ly(t1);
            }
            constructor(t1, e, r, n){
                this.id = t1, this.position = null != e ? new il(e[0], e[1]) : new il(0, 0), this.orientation = null != r ? r : [
                    0,
                    0,
                    0
                ], this.nodes = n, this.uploaded = !1, this.aabb = new xu([
                    1 / 0,
                    1 / 0,
                    1 / 0
                ], [
                    -1 / 0,
                    -1 / 0,
                    -1 / 0
                ]), this.matrix = [];
            }
        }, t1.aP = ot, t1.aQ = wd, t1.aR = pl, t1.aS = fl, t1.aT = bs, t1.aU = Ls, t1.aV = at, t1.aW = Js, t1.aX = tm, t1.aY = function() {
            Ba.isLoading() || Ba.isLoaded() || "deferred" !== ka() || Ta();
        }, t1.aZ = Wa, t1.a_ = El, t1.aa = bl, t1.ab = O, t1.ac = tt, t1.ad = Ua, t1.ae = Fu, t1.af = ze, t1.ag = Wr, t1.ah = Ee, t1.ai = X, t1.aj = Ie, t1.ak = class {
            possiblyEvaluate(t1, e) {
                return function([t1, e]) {
                    const r = yt([
                        1,
                        t1,
                        e
                    ]);
                    return {
                        x: r.x,
                        y: r.y,
                        z: r.z
                    };
                }(t1.expression.evaluate(e));
            }
            interpolate(t1, e, r) {
                return {
                    x: ze(t1.x, e.x, r),
                    y: ze(t1.y, e.y, r),
                    z: ze(t1.z, e.z, r)
                };
            }
            constructor(t1){
                this.specification = t1;
            }
        }, t1.al = function(t1, e, r = 0, n = !0) {
            const i = new q(r, r), a = t1.sub(i), s = e.add(i), o = [
                a,
                new q(s.x, a.y),
                s,
                new q(a.x, s.y)
            ];
            return n && o.push(a.clone()), o;
        }, t1.am = function(t1, e) {
            const r = [];
            for(let n = 0; n < t1.length; n++){
                const i = et(n - 1, -1, t1.length - 1), a = et(n + 1, -1, t1.length - 1), s = t1[n], o = t1[a], l = t1[i].sub(s).unit(), u = o.sub(s).unit(), c = u.angleWithSep(l.x, l.y), h = l.add(u).unit().mult(-1 * e / Math.sin(c / 2));
                r.push(s.add(h));
            }
            return r;
        }, t1.an = Md, t1.ao = ql, t1.ap = function(t1, e, r = 0) {
            return O.vec3.fromValues(((e.x - r) * t1.scale - t1.x) * Wr, (e.y * t1.scale - t1.y) * Wr, dl(e.z, e.y));
        }, t1.aq = hu, t1.ar = zp, t1.as = function(t1) {
            let e = 1 / 0, r = 1 / 0, n = -1 / 0, i = -1 / 0;
            for (const a of t1)e = Math.min(e, a.x), r = Math.min(r, a.y), n = Math.max(n, a.x), i = Math.max(i, a.y);
            return {
                min: new q(e, r),
                max: new q(n, i)
            };
        }, t1.at = ul, t1.au = jl, t1.av = wl, t1.aw = Q, t1.ax = Yo, t1.ay = function(t1, e) {
            const r = {};
            for(let n = 0; n < e.length; n++){
                const i = e[n];
                i in t1 && (r[i] = t1[i]);
            }
            return r;
        }, t1.az = al, t1.b = function(t1) {
            return St.API_FONTS_REGEX.test(t1);
        }, t1.b$ = Bm, t1.b0 = xt, t1.b1 = Ap, t1.b2 = Uc, t1.b3 = zl, t1.b4 = xs, t1.b5 = Ys, t1.b6 = cu, t1.b7 = po, t1.b8 = hc, t1.b9 = hm, t1.bA = kh, t1.bB = pd, t1.bC = hd, t1.bD = Ef, t1.bE = mv, t1.bF = et, t1.bG = bt, t1.bH = hl, t1.bI = function(t1, e, r) {
            t1[4 * e + 0] = r[0], t1[4 * e + 1] = r[1], t1[4 * e + 2] = r[2], t1[4 * e + 3] = r[3];
        }, t1.bJ = Eo, t1.bK = Ao, t1.bL = So, t1.bM = Mo, t1.bN = wo, t1.bO = il, t1.bP = $d, t1.bQ = nu, t1.bR = gu, t1.bS = Tm, t1.bT = ru, t1.bU = Pu, t1.bV = function(t1, e, r, n, i, a, s, o, l) {
            if ("globe" === l.name) return Pu(t1, e, new ru(r, n, i), !1);
            const u = wd({
                z: r,
                x: n,
                y: i
            }, l);
            return new xu([
                (a + u.x / u.scale) * e,
                e * (u.y / u.scale),
                s
            ], [
                (a + u.x2 / u.scale) * e,
                e * (u.y2 / u.scale),
                o
            ]);
        }, t1.bW = function(t1, e, r) {
            let n = 0;
            for(let r = 0; r < 2; ++r){
                const i = 0;
                t1[r] > i && (n += (t1[r] - i) * (t1[r] - i)), e[r] < i && (n += (i - e[r]) * (i - e[r]));
            }
            return n;
        }, t1.bX = ml, t1.bY = Zo, t1.bZ = function(t1) {
            const e = O.mat4.identity(new Float64Array(16));
            O.mat4.multiply(e, t1.pixelMatrix, t1.globeMatrix);
            const r = [
                0,
                Jo,
                0
            ], n = [
                0,
                Qo,
                0
            ];
            return O.vec3.transformMat4(r, r, e), O.vec3.transformMat4(n, n, e), [
                r[0] > 0 && r[0] <= t1.width && r[1] > 0 && r[1] <= t1.height && !Nu(t1, new il(t1.center.lat, 90)),
                n[0] > 0 && n[0] <= t1.width && n[1] > 0 && n[1] <= t1.height && !Nu(t1, new il(t1.center.lat, -90))
            ];
        }, t1.b_ = function(t1, e) {
            const { scale: r } = t1.tileTransform, n = r * Wr / (t1.tileSize * Math.pow(2, e.zoom - t1.tileID.overscaledZ + t1.tileID.canonical.z));
            return O.mat2.scale(new Float32Array(4), e.inverseAdjustmentMatrix, [
                n,
                n
            ]);
        }, t1.ba = function(t1, e) {
            const r = Fu(e.zoom);
            if (0 === r) return Au(t1);
            const n = zu(t1), i = Eu(n), a = ul(n.getWest()) * e.worldSize, s = ul(n.getEast()) * e.worldSize, o = cl(n.getNorth()) * e.worldSize, l = cl(n.getSouth()) * e.worldSize, u = [
                a,
                o,
                0
            ], c = [
                s,
                o,
                0
            ], h = [
                a,
                l,
                0
            ], p = [
                s,
                l,
                0
            ], f = O.mat4.invert([], e.globeMatrix);
            return O.vec3.transformMat4(u, u, f), O.vec3.transformMat4(c, c, f), O.vec3.transformMat4(h, h, f), O.vec3.transformMat4(p, p, f), i[0] = Su(i[0], h, r), i[1] = Su(i[1], p, r), i[2] = Su(i[2], c, r), i[3] = Su(i[3], u, r), xu.fromPoints(i);
        }, t1.bb = Cu, t1.bc = ku, t1.bd = Su, t1.be = vs, t1.bf = uu, t1.bg = Ix, t1.bh = pf, t1.bi = ie, t1.bj = function(t1) {
            const e = [];
            for(const r in t1)e.push(t1[r]);
            return e;
        }, t1.bk = function(t1, e) {
            const r = [];
            for(const n in t1)n in e || r.push(n);
            return r;
        }, t1.bl = rt, t1.bm = [
            "type",
            "source",
            "source-layer",
            "minzoom",
            "maxzoom",
            "filter",
            "layout"
        ], t1.bn = $, t1.bo = function(t1, e) {
            const { x: r, y: n } = t1.point, i = Ru(r, n, t1.worldSize / t1._pixelsPerMercatorPixel, 0, 0);
            return O.mat4.multiply(i, i, Vu(Au(e)));
        }, t1.bp = Qp, t1.bq = xf, t1.br = Jp, t1.bs = function(t1, e, r, n, i) {
            const a = 5 * e + 2;
            t1.float32[a + 0] = r, t1.float32[a + 1] = n, t1.float32[a + 2] = i;
        }, t1.bt = Wd, t1.bu = Uf, t1.bv = Cl, t1.bw = Zp, t1.bx = bh, t1.by = Xm, t1.bz = Eh, t1.c = Pt, t1.c$ = (t1, e, r, n, i, a, s, o)=>{
            const l = t1.transform, u = l.pitch < 15 ? Ep(.07, .7, Q((14 - l.zoom) / 5, 0, 1)) : .07, c = "none" === r.paint.get("line-trim-color-use-theme").constantOr("default");
            return {
                u_matrix: Tp(t1, e, r, n),
                u_texsize: e.imageAtlasTexture ? e.imageAtlasTexture.size : [
                    0,
                    0
                ],
                u_pixels_to_tile_units: l.calculatePixelsToTileUnitsMatrix(e),
                u_device_pixel_ratio: i,
                u_width_scale: a,
                u_floor_width_scale: s,
                u_image: 0,
                u_tile_units_to_pixels: kp(e, l),
                u_units_to_pixels: [
                    1 / l.pixelsToGLUnits[0],
                    1 / l.pixelsToGLUnits[1]
                ],
                u_alpha_discard_threshold: 0,
                u_trim_offset: o,
                u_trim_fade_range: r.paint.get("line-trim-fade-range"),
                u_trim_color: r.paint.get("line-trim-color").toRenderColor(c ? null : r.lut).toArray01(),
                u_emissive_strength: r.paint.get("line-emissive-strength"),
                u_zbias_factor: u,
                u_tile_to_meter: vl(e.tileID.canonical, 0)
            };
        }, t1.c0 = km, t1.c1 = function(t1) {
            const e = km(t1, !0);
            return O.mat2.invert([], [
                e[0],
                e[1],
                e[4],
                e[5]
            ]);
        }, t1.c2 = pu, t1.c3 = function(t1) {
            const { x: e, y: r } = t1.point, { lng: n, lat: i } = t1._center;
            return Ru(e, r, t1.worldSize, n, i);
        }, t1.c4 = Z, t1.c5 = au, t1.c6 = Xo, t1.c7 = function(t1) {
            const e = Math.round((t1 + 45 + 360) % 360 / 90) % 4;
            return H[e];
        }, t1.c8 = 45, t1.c9 = ll, t1.cA = class extends _o {
            set(t1, e, r) {
                if (this.fetchUniformLocation(t1, e)) {
                    for(let t1 = 0; t1 < 9; t1++)if (r[t1] !== this.current[t1]) {
                        this.current = r, this.gl.uniformMatrix3fv(this.location, !1, r);
                        break;
                    }
                }
            }
            constructor(t1){
                super(t1), this.current = ko;
            }
        }, t1.cB = W, t1.cC = function(t1, e, r) {
            const n = Fu(r.zoom), i = t1.style.map._antialias, a = t1.terrain && t1.terrain.exaggeration() > 0;
            return 0 === n && !i && !a;
        }, t1.cD = function(t1) {
            const e = t1.pixelsPerMeter, r = e / hl(1, t1.center.lat), n = O.mat4.identity(new Float64Array(16));
            return O.mat4.translate(n, n, [
                t1.point.x,
                t1.point.y,
                0
            ]), O.mat4.scale(n, n, [
                r,
                r,
                e
            ]), Float32Array.from(n);
        }, t1.cE = zu, t1.cF = function(t1) {
            const e = ml - 5;
            t1 = Q(t1, -e, e) / e * 90;
            const r = Math.pow(Math.abs(Math.sin(X(t1))), 3);
            return Math.round(r * (Ko.length - 1));
        }, t1.cG = function(t1, e, r, n) {
            const i = e.getNorth(), a = e.getSouth(), s = e.getWest(), o = e.getEast(), l = 1 << t1.z, u = o - s, c = i - a, h = u / Wo, p = -c / Ko[r], f = [
                0,
                h,
                0,
                p,
                0,
                0,
                i,
                s,
                0
            ];
            if (t1.z > 0) {
                const t1 = 180 / n;
                O.mat3.multiply(f, f, [
                    t1 / u + 1,
                    0,
                    0,
                    0,
                    t1 / c + 1,
                    0,
                    -0.5 * t1 / h,
                    .5 * t1 / p,
                    1
                ]);
            }
            return f[2] = l, f[5] = t1.x, f[8] = t1.y, f;
        }, t1.cH = Au, t1.cI = function(t1, e, r) {
            const n = O.mat4.identity(new Float64Array(16)), i = (e / (1 << t1) - .5) * Math.PI * 2;
            return O.mat4.rotateY(n, r.globeMatrix, i), Float32Array.from(n);
        }, t1.cJ = class {
            isDataAvailableAtPoint(t1) {
                const e = this._source();
                if (this.isUsingMockSource() || !e || t1.y < 0 || t1.y > 1) return !1;
                const r = e.getSource().maxzoom, n = 1 << r, i = Math.floor(t1.x), a = Math.floor((t1.x - i) * n), s = Math.floor(t1.y * n), o = this.findDEMTileFor(new iu(r, i, r, a, s));
                return !(!o || !o.dem);
            }
            getAtPointOrZero(t1, e = 0) {
                return this.getAtPoint(t1, e) || 0;
            }
            getAtPoint(t1, e, r = !0) {
                if (this.isUsingMockSource()) return null;
                null == e && (e = null);
                const n = this._source();
                if (!n) return e;
                if (t1.y < 0 || t1.y > 1) return e;
                const i = n.getSource().maxzoom, a = 1 << i, s = Math.floor(t1.x), o = t1.x - s, l = new iu(i, s, i, Math.floor(o * a), Math.floor(t1.y * a)), u = this.findDEMTileFor(l);
                if (!u || !u.dem) return e;
                const c = u.dem, h = 1 << u.tileID.canonical.z, p = (o * h - u.tileID.canonical.x) * c.dim, f = (t1.y * h - u.tileID.canonical.y) * c.dim, d = Math.floor(p), m = Math.floor(f);
                return (r ? this.exaggeration() : 1) * ze(ze(c.get(d, m), c.get(d, m + 1), f - m), ze(c.get(d + 1, m), c.get(d + 1, m + 1), f - m), p - d);
            }
            getAtTileOffset(t1, e, r) {
                const n = 1 << t1.canonical.z;
                return this.getAtPointOrZero(new bl(t1.wrap + (t1.canonical.x + e / Wr) / n, (t1.canonical.y + r / Wr) / n));
            }
            getAtTileOffsetFunc(t1, e, r, n) {
                return (i)=>{
                    const a = this.getAtTileOffset(t1, i.x, i.y), s = n.upVector(t1.canonical, i.x, i.y), o = n.upVectorScale(t1.canonical, e, r).metersToTile;
                    return O.vec3.scale(s, s, a * o), s;
                };
            }
            getForTilePoints(t1, e, r, n) {
                if (this.isUsingMockSource()) return !1;
                const i = uy.create(this, t1, n);
                return !!i && (e.forEach((t1)=>{
                    t1[2] = this.exaggeration() * i.getElevationAt(t1[0], t1[1], r);
                }), !0);
            }
            getMinMaxForTile(t1) {
                if (this.isUsingMockSource()) return null;
                const e = this.findDEMTileFor(t1);
                if (!e || !e.dem) return null;
                const r = e.dem.tree, n = e.tileID, i = 1 << t1.canonical.z - n.canonical.z;
                let a = t1.canonical.x / i - n.canonical.x, s = t1.canonical.y / i - n.canonical.y, o = 0;
                for(let e = 0; e < t1.canonical.z - n.canonical.z && !r.leaves[o]; e++){
                    a *= 2, s *= 2;
                    const t1 = 2 * Math.floor(s) + Math.floor(a);
                    o = r.childOffsets[o] + t1, a %= 1, s %= 1;
                }
                return {
                    min: this.exaggeration() * r.minimums[o],
                    max: this.exaggeration() * r.maximums[o]
                };
            }
            getMinElevationBelowMSL() {
                throw new Error("Pure virtual method called.");
            }
            raycast(t1, e, r) {
                throw new Error("Pure virtual method called.");
            }
            pointCoordinate(t1) {
                throw new Error("Pure virtual method called.");
            }
            _source() {
                throw new Error("Pure virtual method called.");
            }
            isUsingMockSource() {
                throw new Error("Pure virtual method called.");
            }
            exaggeration() {
                throw new Error("Pure virtual method called.");
            }
            findDEMTileFor(t1) {
                throw new Error("Pure virtual method called.");
            }
            get visibleDemTiles() {
                throw new Error("Getter must be implemented in subclass.");
            }
            getMinMaxForVisibleTiles() {
                const t1 = this.visibleDemTiles;
                if (0 === t1.length) return null;
                let e = !1, r = Number.MAX_VALUE, n = Number.MIN_VALUE;
                for (const i of t1){
                    const t1 = this.getMinMaxForTile(i.tileID);
                    t1 && (r = Math.min(r, t1.min), n = Math.max(n, t1.max), e = !0);
                }
                return e ? {
                    min: r,
                    max: n
                } : null;
            }
        }, t1.cK = oc, t1.cL = vu, t1.cM = function(t1, e) {
            return [
                Math.pow(t1[0], 2.2) * e,
                Math.pow(t1[1], 2.2) * e,
                Math.pow(t1[2], 2.2) * e
            ];
        }, t1.cN = Lu, t1.cO = At, t1.cP = Mt, t1.cQ = 256, t1.cR = function(t1, e) {
            const r = [
                0,
                0,
                0
            ], n = Cu(Au(e.canonical));
            return O.vec3.transformMat4(r, r, n), O.vec3.transformMat4(r, r, t1), r;
        }, t1.cS = (t1)=>({
                u_camera_to_center_distance: new Mo(t1),
                u_extrude_scale: new Bo(t1),
                u_device_pixel_ratio: new Mo(t1),
                u_matrix: new Eo(t1),
                u_inv_rot_matrix: new Eo(t1),
                u_merc_center: new Ao(t1),
                u_tile_id: new So(t1),
                u_zoom_transition: new Mo(t1),
                u_up_dir: new So(t1),
                u_emissive_strength: new Mo(t1)
            }), t1.cT = (t1)=>({
                u_matrix: new Eo(t1),
                u_pixels_to_tile_units: new Bo(t1),
                u_device_pixel_ratio: new Mo(t1),
                u_width_scale: new Mo(t1),
                u_floor_width_scale: new Mo(t1),
                u_units_to_pixels: new Ao(t1),
                u_dash_image: new wo(t1),
                u_gradient_image: new wo(t1),
                u_image_height: new Mo(t1),
                u_texsize: new Ao(t1),
                u_tile_units_to_pixels: new Mo(t1),
                u_alpha_discard_threshold: new Mo(t1),
                u_trim_offset: new Ao(t1),
                u_trim_fade_range: new Ao(t1),
                u_trim_color: new Io(t1),
                u_emissive_strength: new Mo(t1),
                u_zbias_factor: new Mo(t1),
                u_tile_to_meter: new Mo(t1)
            }), t1.cU = (t1)=>({
                u_matrix: new Eo(t1),
                u_texsize: new Ao(t1),
                u_pixels_to_tile_units: new Bo(t1),
                u_device_pixel_ratio: new Mo(t1),
                u_width_scale: new Mo(t1),
                u_floor_width_scale: new Mo(t1),
                u_image: new wo(t1),
                u_units_to_pixels: new Ao(t1),
                u_tile_units_to_pixels: new Mo(t1),
                u_alpha_discard_threshold: new Mo(t1),
                u_trim_offset: new Ao(t1),
                u_trim_fade_range: new Ao(t1),
                u_trim_color: new Io(t1),
                u_emissive_strength: new Mo(t1),
                u_zbias_factor: new Mo(t1),
                u_tile_to_meter: new Mo(t1)
            }), t1.cV = Vs, t1.cW = Xp, t1.cX = tf, t1.cY = Gu, t1.cZ = (t1, e, r, n, i, a)=>{
            const s = t1.transform, o = "globe" === s.projection.name;
            let l;
            if ("map" === a.paint.get("circle-pitch-alignment")) {
                if (o) {
                    const t1 = Lu(s.zoom, e.canonical) * s._pixelsPerMercatorPixel;
                    l = Float32Array.from([
                        t1,
                        0,
                        0,
                        t1
                    ]);
                } else l = s.calculatePixelsToTileUnitsMatrix(r);
            } else l = new Float32Array([
                s.pixelsToGLUnits[0],
                0,
                0,
                s.pixelsToGLUnits[1]
            ]);
            const u = {
                u_camera_to_center_distance: t1.transform.getCameraToCenterDistance(s.projection),
                u_matrix: t1.translatePosMatrix(e.projMatrix, r, a.paint.get("circle-translate"), a.paint.get("circle-translate-anchor")),
                u_device_pixel_ratio: Dt.devicePixelRatio,
                u_extrude_scale: l,
                u_inv_rot_matrix: $u,
                u_merc_center: [
                    0,
                    0
                ],
                u_tile_id: [
                    0,
                    0,
                    0
                ],
                u_zoom_transition: 0,
                u_up_dir: [
                    0,
                    0,
                    0
                ],
                u_emissive_strength: a.paint.get("circle-emissive-strength")
            };
            if (o) {
                u.u_inv_rot_matrix = n, u.u_merc_center = i, u.u_tile_id = [
                    e.canonical.x,
                    e.canonical.y,
                    1 << e.canonical.z
                ], u.u_zoom_transition = Fu(s.zoom);
                const t1 = i[0] * Wr, r = i[1] * Wr;
                u.u_up_dir = s.projection.upVector(new ru(0, 0, 0), t1, r);
            }
            return u;
        }, t1.c_ = Bp, t1.ca = Io, t1.cb = function(t1, e, r) {
            const n = Math.sqrt(t1 * t1 + e * e + r * r), i = n > 0 ? Math.acos(r / n) * Y : 0;
            let a = 0 !== t1 || 0 !== e ? Math.atan2(-e, -t1) * Y + 90 : 0;
            return a < 0 && (a += 360), [
                n,
                a,
                i
            ];
        }, t1.cc = vl, t1.cd = xu, t1.ce = yt, t1.cf = function(t1) {
            return [
                Math.pow(t1[0], 1 / 2.2),
                Math.pow(t1[1], 1 / 2.2),
                Math.pow(t1[2], 1 / 2.2)
            ];
        }, t1.cg = function(t1, e) {
            return t1.readFields(Oy, {
                icons: []
            }, e);
        }, t1.ch = function(t1) {
            return t1({
                pluginStatus: Sa,
                pluginURL: Ia
            }), Ea.on("pluginStateChange", t1), t1;
        }, t1.ci = Ty, t1.cj = Kf, t1.ck = Wf, t1.cl = re, t1.cm = Pa, t1.cn = Rt, t1.co = ge, t1.cp = ht, t1.cq = function(t1) {
            const e = t1.indexOf(ls);
            return e >= 0 ? t1.slice(0, e) : t1;
        }, t1.cr = function(t1) {
            return t1.indexOf(ls) >= 0;
        }, t1.cs = function(t1) {
            const e = t1.indexOf(ls);
            return e >= 0 ? t1.slice(e + 1) : "";
        }, t1.ct = function(t1) {
            const e = [], r = t1.id;
            return void 0 === r && e.push({
                message: `layers.${r}: missing required property "id"`
            }), void 0 === t1.render && e.push({
                message: `layers.${r}: missing required method "render"`
            }), t1.renderingMode && "2d" !== t1.renderingMode && "3d" !== t1.renderingMode && e.push({
                message: `layers.${r}: property "renderingMode" must be either "2d" or "3d"`
            }), e;
        }, t1.cu = function(t1, e, r, n) {
            return "custom" === t1.type ? new zm(t1, e) : new _y[t1.type](t1, e, r, n);
        }, t1.cv = ct, t1.cw = class extends cv {
            toJSON() {
                const t1 = super.toJSON();
                return t1.target = this.target, t1.namespace = this.namespace, t1;
            }
            constructor(t1, e){
                super(t1._vectorTileFeature, t1._z, t1._x, t1._y, t1.id), t1.state && (this.state = Object.assign({}, t1.state)), this.target = e.target, this.namespace = e.namespace, e.properties && (this.properties = e.properties), this.target && ("featuresetId" in this.target && !this.target.importId || "layerId" in this.target) && (this.source = t1.source, this.sourceLayer = t1.sourceLayer, this.layer = t1.layer);
            }
        }, t1.cx = Ea, t1.cy = ne, t1.cz = Po, t1.d = function(t1) {
            return St.API_TILEJSON_REGEX.test(t1);
        }, t1.d$ = hv, t1.d0 = (t1, e, r, n, i, a, s, o, l)=>{
            const u = t1.transform, c = u.calculatePixelsToTileUnitsMatrix(e), h = "none" === r.paint.get("line-trim-color-use-theme").constantOr("default"), p = u.pitch < 15 ? Ep(.07, .7, Q((14 - u.zoom) / 5, 0, 1)) : .07;
            return {
                u_matrix: Tp(t1, e, r, n),
                u_pixels_to_tile_units: c,
                u_device_pixel_ratio: a,
                u_width_scale: s,
                u_floor_width_scale: o,
                u_units_to_pixels: [
                    1 / u.pixelsToGLUnits[0],
                    1 / u.pixelsToGLUnits[1]
                ],
                u_dash_image: 0,
                u_gradient_image: 1,
                u_image_height: i,
                u_texsize: Cp(r) && e.lineAtlasTexture ? e.lineAtlasTexture.size : [
                    0,
                    0
                ],
                u_tile_units_to_pixels: kp(e, t1.transform),
                u_alpha_discard_threshold: 0,
                u_trim_offset: l,
                u_trim_fade_range: r.paint.get("line-trim-fade-range"),
                u_trim_color: r.paint.get("line-trim-color").toRenderColor(h ? null : r.lut).toArray01(),
                u_emissive_strength: r.paint.get("line-emissive-strength"),
                u_zbias_factor: p,
                u_tile_to_meter: vl(e.tileID.canonical, 0)
            };
        }, t1.d1 = st, t1.d2 = lc, t1.d3 = ap, t1.d4 = su, t1.d5 = Kh, t1.d6 = Oh, t1.d7 = 450, t1.d8 = 7, t1.d9 = bm, t1.dA = J, t1.dB = xl, t1.dC = el, t1.dD = function([t1, e, r]) {
            const n = Math.hypot(t1, e, r), i = Math.atan2(t1, r), a = .5 * Math.PI - Math.acos(-e / n);
            return new il(Z(i), Z(a));
        }, t1.dE = Vm, t1.dF = function(t1) {
            const e = t1.navigator ? t1.navigator.userAgent : null;
            return !!function(t1) {
                if (null == vt) {
                    const e = t1.navigator ? t1.navigator.userAgent : null;
                    vt = !!t1.safari || !(!e || !(/\b(iPad|iPhone|iPod)\b/.test(e) || e.match("Safari") && !e.match("Chrome")));
                }
                return vt;
            }(t1) && e && (e.match("Version/15.4") || e.match("Version/15.5") || e.match(/CPU (OS|iPhone OS) (15_4|15_5) like Mac OS X/));
        }, t1.dG = function(t1, e) {
            Ot = t1, Nt = e;
        }, t1.dH = Nu, t1.dI = Ou, t1.dJ = function(t1) {
            const e = [
                0,
                0,
                0
            ], r = O.mat4.identity(new Float64Array(16));
            return O.mat4.multiply(r, t1.pixelMatrix, t1.globeMatrix), O.vec3.transformMat4(e, e, r), new q(e[0], e[1]);
        }, t1.dK = function(t1, e, r = !1) {
            if (Sa === _a || Sa === wa || Sa === Ma) throw new Error("setRTLTextPlugin cannot be called multiple times.");
            Ia = Dt.resolveURL(t1), Sa = _a, Aa = e, za(), r || Ta();
        }, t1.dL = ka, t1.dM = function() {
            Ty().acquire(Iy);
        }, t1.dN = function() {
            const t1 = Ey;
            t1 && (t1.isPreloaded() && 1 === t1.numActive() ? (t1.release(Iy), Ey = null) : console.warn("Could not clear WebWorkers since there are active Map instances that still reference it. The pre-warmed WebWorker pool can only be cleared when all map instances have been removed with map.remove()"));
        }, t1.dO = Py, t1.dP = function(t1) {
            const e = $t();
            if (!e) return;
            const r = e.delete(Ft);
            t1 && r.catch(t1).then(()=>t1());
        }, t1.dQ = Sy, t1.dR = Dx, t1.dS = function(t1) {
            kx = Dt.resolveURL(t1), Vx || (Vx = new zy(Ty(), new we)), Vx.broadcast("setDracoUrl", kx);
        }, t1.dT = Lx, t1.dU = function(t1) {
            Bx = Dt.resolveURL(t1), Vx || (Vx = new zy(Ty(), new we)), Vx.broadcast("setMeshoptUrl", Bx);
        }, t1.dV = oa, t1.dW = ac, t1.dX = Hf, t1.dY = fh, t1.dZ = class {
            intersectsPlane(t1, e, r) {
                const n = O.vec2.dot(e, this.dir);
                if (Math.abs(n) < 1e-6) return !1;
                const i = ((t1[0] - this.pos[0]) * e[0] + (t1[1] - this.pos[1]) * e[1]) / n;
                return r[0] = this.pos[0] + this.dir[0] * i, r[1] = this.pos[1] + this.dir[1] * i, !0;
            }
            constructor(t1, e){
                this.pos = t1, this.dir = e;
            }
        }, t1.d_ = lv, t1.da = ys, t1.db = Hs, t1.dc = 256, t1.dd = Vu, t1.de = Ms, t1.df = Ns, t1.dg = Us, t1.dh = function(t1, e, r, n, i) {
            return Q((t1 - e) / (r - e) * (i - n) + n, n, i);
        }, t1.di = Ii, t1.dj = gl, t1.dk = class {
            bind(t1, e) {
                const { context: r } = this, { gl: n } = r;
                n.bindTexture(n.TEXTURE_3D, this.texture), t1 !== this.minFilter && (n.texParameteri(n.TEXTURE_3D, n.TEXTURE_MAG_FILTER, t1), n.texParameteri(n.TEXTURE_3D, n.TEXTURE_MIN_FILTER, t1), this.minFilter = t1), e !== this.wrapS && (n.texParameteri(n.TEXTURE_3D, n.TEXTURE_WRAP_S, e), n.texParameteri(n.TEXTURE_3D, n.TEXTURE_WRAP_T, e), this.wrapS = e);
            }
            destroy() {
                const { gl: t1 } = this.context;
                t1.deleteTexture(this.texture), this.texture = null;
            }
            constructor(t1, e, r, n){
                this.context = t1, this.format = n, this.size = r, this.texture = t1.gl.createTexture();
                const [i, a, s] = this.size, { gl: o } = t1;
                o.bindTexture(o.TEXTURE_3D, this.texture), t1.pixelStoreUnpackFlipY.set(!1), t1.pixelStoreUnpack.set(1), t1.pixelStoreUnpackPremultiplyAlpha.set(!1), o.texImage3D(o.TEXTURE_3D, 0, this.format, i, a, s, 0, pm(this.format), fm(this.format), e.data);
            }
        }, t1.dl = Fm, t1.dm = [
            1,
            1,
            1
        ], t1.dn = uy, t1.dp = ry, t1.dq = Ts, t1.dr = $s, t1.ds = rl, t1.dt = qs, t1.du = js, t1.dv = class {
            clear() {
                this._activeRegions.length > 0 && ++this._updateTime, this._activeRegions = [], this._prevRegions = [];
            }
            get updateTime() {
                return this._updateTime;
            }
            getReplacementRegionsForTile(t1, e = !1) {
                const r = Sh(new q(0, 0), new q(Wr, Wr), t1), n = [];
                if (e && !Mh(r, this._globalClipBounds)) return n;
                for (const e of this._activeRegions){
                    if (e.hiddenByOverlap) continue;
                    if (!Mh(r, e)) continue;
                    const i = Ih(e.min, e.max, t1);
                    n.push({
                        min: i.min,
                        max: i.max,
                        sourceId: this._sourceIds[e.priority],
                        footprint: e.footprint,
                        footprintTileId: e.tileId,
                        order: e.order,
                        clipMask: e.clipMask,
                        clipScope: e.clipScope
                    });
                }
                return n;
            }
            setSources(t1) {
                this._setSources(t1.map((t1)=>({
                        getSourceId: ()=>t1.cache.id,
                        getFootprints: ()=>{
                            const e = [];
                            for (const r of t1.cache.getVisibleCoordinates()){
                                const n = t1.cache.getTile(r).buckets[t1.layer];
                                n && n.updateFootprints(r.toUnwrapped(), e);
                            }
                            return e;
                        },
                        getOrder: ()=>t1.order,
                        getClipMask: ()=>t1.clipMask,
                        getClipScope: ()=>t1.clipScope
                    })));
            }
            _addSource(t1) {
                const e = t1.getFootprints();
                if (0 === e.length) return;
                const r = t1.getOrder(), n = t1.getClipMask(), i = t1.getClipScope();
                for (const t1 of e){
                    if (!t1.footprint) continue;
                    const e = Sh(t1.footprint.min, t1.footprint.max, t1.id);
                    this._activeRegions.push({
                        min: e.min,
                        max: e.max,
                        hiddenByOverlap: !1,
                        priority: this._sourceIds.length,
                        tileId: t1.id,
                        footprint: t1.footprint,
                        order: r,
                        clipMask: n,
                        clipScope: i
                    });
                }
                this._sourceIds.push(t1.getSourceId());
            }
            _computeReplacement() {
                this._activeRegions.sort((t1, e)=>t1.priority - e.priority || _h(t1.min, e.min) || _h(t1.max, e.max) || t1.order - e.order || t1.clipMask - e.clipMask || function(t1, e) {
                        const r = (t1, e)=>t1 + e;
                        return t1.length - e.length || t1.reduce(r, "").localeCompare(e.reduce(r, ""));
                    }(t1.clipScope, e.clipScope));
                let t1 = this._activeRegions.length !== this._prevRegions.length;
                if (!t1) {
                    let e = 0;
                    for(; !t1 && e !== this._activeRegions.length;){
                        const r = this._activeRegions[e], n = this._prevRegions[e];
                        t1 = r.priority !== n.priority || !wh(r, n) || r.order !== n.order || r.clipMask !== n.clipMask || !$(r.clipScope, n.clipScope), ++e;
                    }
                }
                if (t1) {
                    ++this._updateTime;
                    for (const t1 of this._activeRegions)t1.order !== vh && (this._globalClipBounds.min.x = Math.min(this._globalClipBounds.min.x, t1.min.x), this._globalClipBounds.min.y = Math.min(this._globalClipBounds.min.y, t1.min.y), this._globalClipBounds.max.x = Math.max(this._globalClipBounds.max.x, t1.max.x), this._globalClipBounds.max.y = Math.max(this._globalClipBounds.max.y, t1.max.y));
                    const t1 = (t1)=>{
                        const e = this._activeRegions;
                        if (t1 >= e.length) return t1;
                        const r = e[t1].priority;
                        for(; t1 < e.length && e[t1].priority === r;)++t1;
                        return t1;
                    };
                    if (this._sourceIds.length > 1) {
                        let e = 0, r = t1(e);
                        for(; e !== r;){
                            let n = e;
                            const i = e;
                            for(; n !== r;){
                                const t1 = this._activeRegions[n];
                                t1.hiddenByOverlap = !1;
                                for(let e = 0; e < i; e++){
                                    const r = this._activeRegions[e];
                                    if (!r.hiddenByOverlap && t1.order === vh && Mh(t1, r) && (t1.hiddenByOverlap = zh(t1.footprint, t1.tileId, r.footprint, r.tileId), t1.hiddenByOverlap)) break;
                                }
                                ++n;
                            }
                            e = r, r = t1(e);
                        }
                    }
                }
            }
            _setSources(t1) {
                [this._prevRegions, this._activeRegions] = [
                    this._activeRegions,
                    []
                ], this._sourceIds = [];
                for(let e = t1.length - 1; e >= 0; e--)this._addSource(t1[e]);
                this._computeReplacement();
            }
            constructor(){
                this._updateTime = 0, this._sourceIds = [], this._activeRegions = [], this._prevRegions = [], this._globalClipBounds = {
                    min: new q(1 / 0, 1 / 0),
                    max: new q(-1 / 0, -1 / 0)
                };
            }
        }, t1.dw = class {
            destroy() {
                this._poleIndexBuffer.destroy(), this._gridBuffer.destroy(), this._gridIndexBuffer.destroy(), this._poleNorthVertexBuffer.destroy(), this._poleSouthVertexBuffer.destroy();
                for (const t1 of this._poleSegments)t1.destroy();
                for (const t1 of this._gridSegments)t1.withSkirts.destroy(), t1.withoutSkirts.destroy();
            }
            _fillGridMeshWithLods(t1, e) {
                const r = new xs, n = new Ls, i = [], a = t1 + 1 + 2, s = e[0] + 1, o = e[0] + 1 + (1 + e.length), l = (t1, e, r)=>{
                    let n = t1 === a - 1 ? t1 - 2 : 0 === t1 ? t1 : t1 - 1;
                    return n += r ? 24575 : 0, [
                        n,
                        e
                    ];
                };
                for(let t1 = 0; t1 < a; ++t1)r.emplaceBack(...l(t1, 0, !0));
                for(let t1 = 0; t1 < s; ++t1)for(let e = 0; e < a; ++e)r.emplaceBack(...l(e, t1, (0 === e || e === a - 1) && !0));
                for(let t1 = 0; t1 < e.length; ++t1){
                    const n = e[t1];
                    for(let t1 = 0; t1 < a; ++t1)r.emplaceBack(...l(t1, n, !0));
                }
                for(let t1 = 0; t1 < e.length; ++t1){
                    const s = n.length, l = e[t1] + 1 + 2, u = new Ls;
                    for(let r = 0; r < l - 1; r++){
                        const i = r === l - 2, s = i ? a * (o - e.length + t1 - r) : a;
                        for(let t1 = 0; t1 < a - 1; t1++){
                            const e = r * a + t1;
                            0 === r || i || 0 === t1 || t1 === a - 2 ? (u.emplaceBack(e + 1, e, e + s), u.emplaceBack(e + s, e + s + 1, e + 1)) : (n.emplaceBack(e + 1, e, e + s), n.emplaceBack(e + s, e + s + 1, e + 1));
                        }
                    }
                    const c = po.simpleSegment(0, s, r.length, n.length - s);
                    for(let t1 = 0; t1 < u.uint16.length; t1 += 3)n.emplaceBack(u.uint16[t1], u.uint16[t1 + 1], u.uint16[t1 + 2]);
                    const h = po.simpleSegment(0, s, r.length, n.length - s);
                    i.push({
                        withoutSkirts: c,
                        withSkirts: h
                    });
                }
                return {
                    vertices: r,
                    indices: n,
                    segments: i
                };
            }
            _createGrid(t1) {
                const e = this._fillGridMeshWithLods(Wo, Ko);
                this._gridSegments = e.segments, this._gridBuffer = t1.createVertexBuffer(e.vertices, cu.members), this._gridIndexBuffer = t1.createIndexBuffer(e.indices, !0);
            }
            _createPoles(t1) {
                const e = new Ls;
                for(let t1 = 0; t1 <= Wo; t1++)e.emplaceBack(0, t1 + 1, t1 + 2);
                this._poleIndexBuffer = t1.createIndexBuffer(e, !0);
                const r = new Ns, n = new Ns, i = new Ns, a = new Ns;
                this._poleSegments = [];
                for(let t1 = 0, e = 0; t1 < Xo; t1++){
                    const s = 360 / (1 << t1);
                    r.emplaceBack(0, -Yo, 0, .5, 0), n.emplaceBack(0, -Yo, 0, .5, 1), i.emplaceBack(0, -Yo, 0, .5, .5), a.emplaceBack(0, -Yo, 0, .5, .5);
                    for(let t1 = 0; t1 <= Wo; t1++){
                        let e = t1 / Wo, o = 0;
                        const l = ze(0, s, e), [u, c, h] = tl(ju, qu, l, Yo);
                        r.emplaceBack(u, c, h, e, o), n.emplaceBack(u, c, h, e, 1 - o);
                        const p = X(l);
                        e = .5 + .5 * Math.sin(p), o = .5 + .5 * Math.cos(p), i.emplaceBack(u, c, h, e, o), a.emplaceBack(u, c, h, e, 1 - o);
                    }
                    this._poleSegments.push(po.simpleSegment(e, 0, 66, 64)), e += 66;
                }
                this._poleNorthVertexBuffer = t1.createVertexBuffer(r, lu, !1), this._poleSouthVertexBuffer = t1.createVertexBuffer(n, lu, !1), this._texturedPoleNorthVertexBuffer = t1.createVertexBuffer(i, lu, !1), this._texturedPoleSouthVertexBuffer = t1.createVertexBuffer(a, lu, !1);
            }
            getGridBuffers(t1, e) {
                return [
                    this._gridBuffer,
                    this._gridIndexBuffer,
                    e ? this._gridSegments[t1].withSkirts : this._gridSegments[t1].withoutSkirts
                ];
            }
            getPoleBuffers(t1, e) {
                return [
                    e ? this._texturedPoleNorthVertexBuffer : this._poleNorthVertexBuffer,
                    e ? this._texturedPoleSouthVertexBuffer : this._poleSouthVertexBuffer,
                    this._poleIndexBuffer,
                    this._poleSegments[t1]
                ];
            }
            constructor(t1){
                this._createGrid(t1), this._createPoles(t1);
            }
        }, t1.dx = vh, t1.dy = K, t1.dz = function() {
            return !!document.fullscreenElement || !!document.webkitFullscreenElement;
        }, t1.e = St, t1.e0 = bp, t1.e1 = ut, t1.e2 = Qe, t1.e3 = Gf, t1.e4 = function(t1, e, r, n, i, a, s, o, l, u, c = 1, h, p) {
            t1.createArrays(), t1.tilePixelRatio = Wr / (512 * t1.overscaling), t1.compareText = {}, t1.iconsNeedLinear = !1;
            const f = t1.layers[0].layout, d = t1.layers[0]._unevaluatedLayout._values, m = {};
            m.scaleFactor = c, m.textSizeScaleRange = f.get("text-size-scale-range"), m.iconSizeScaleRange = f.get("icon-size-scale-range");
            const [y, g] = m.textSizeScaleRange, [x, v] = m.iconSizeScaleRange;
            if (m.textScaleFactor = Q(m.scaleFactor, y, g), m.iconScaleFactor = Q(m.scaleFactor, x, v), "composite" === t1.textSizeData.kind) {
                const { minZoom: e, maxZoom: r } = t1.textSizeData;
                m.compositeTextSizes = [
                    d["text-size"].possiblyEvaluate(new Ca(e), o),
                    d["text-size"].possiblyEvaluate(new Ca(r), o)
                ];
            }
            if ("composite" === t1.iconSizeData.kind) {
                const { minZoom: e, maxZoom: r } = t1.iconSizeData;
                m.compositeIconSizes = [
                    d["icon-size"].possiblyEvaluate(new Ca(e), o),
                    d["icon-size"].possiblyEvaluate(new Ca(r), o)
                ];
            }
            m.layoutTextSize = d["text-size"].possiblyEvaluate(new Ca(l + 1), o), m.layoutIconSize = d["icon-size"].possiblyEvaluate(new Ca(l + 1), o), m.textMaxSize = d["text-size"].possiblyEvaluate(new Ca(18), o);
            const b = "map" === f.get("text-rotation-alignment") && "point" !== f.get("symbol-placement"), _ = f.get("text-size");
            let w = !1;
            for (const e of t1.features)if (e.icon && e.icon.nameSecondary) {
                w = !0;
                break;
            }
            for (const a of t1.features){
                const l = f.get("text-font").evaluate(a, {}, o).join(","), c = _.evaluate(a, {}, o) * m.textScaleFactor, y = m.layoutTextSize.evaluate(a, {}, o) * m.textScaleFactor, g = (m.layoutIconSize.evaluate(a, {}, o), {
                    horizontal: {},
                    vertical: void 0
                }), x = a.text;
                let v, M = [
                    0,
                    0
                ];
                if (x) {
                    const n = x.toString(), s = f.get("text-letter-spacing").evaluate(a, {}, o) * Zp, u = f.get("text-line-height").evaluate(a, {}, o) * Zp, h = da(n) ? s : 0, p = f.get("text-anchor").evaluate(a, {}, o), d = f.get("text-variable-anchor");
                    if (!d) {
                        const t1 = f.get("text-radial-offset").evaluate(a, {}, o);
                        M = t1 ? hd(p, [
                            t1 * Zp,
                            ud
                        ]) : f.get("text-offset").evaluate(a, {}, o).map((t1)=>t1 * Zp);
                    }
                    let m = b ? "center" : f.get("text-justify").evaluate(a, {}, o);
                    const v = "point" === f.get("symbol-placement"), _ = v ? f.get("text-max-width").evaluate(a, {}, o) * Zp : 1 / 0, w = (a)=>{
                        t1.allowVerticalPlacement && fa(n) && (g.vertical = _f(x, e, r, i, l, _, u, p, a, h, M, xf.vertical, !0, y, c));
                    };
                    if (!b && d) {
                        const t1 = "auto" === m ? d.map((t1)=>pd(t1)) : [
                            m
                        ];
                        let n = !1;
                        for(let a = 0; a < t1.length; a++){
                            const s = t1[a];
                            if (!g.horizontal[s]) {
                                if (n) g.horizontal[s] = g.horizontal[0];
                                else {
                                    const t1 = _f(x, e, r, i, l, _, u, "center", s, h, M, xf.horizontal, !1, y, c);
                                    t1 && (g.horizontal[s] = t1, n = 1 === t1.positionedLines.length);
                                }
                            }
                        }
                        w("left");
                    } else {
                        if ("auto" === m && (m = pd(p)), v || f.get("text-writing-mode").indexOf("horizontal") >= 0 || !fa(n)) {
                            const t1 = _f(x, e, r, i, l, _, u, p, m, h, M, xf.horizontal, !1, y, c);
                            t1 && (g.horizontal[m] = t1);
                        }
                        w(v ? "left" : m);
                    }
                }
                let A = !1;
                if (a.icon && a.icon.namePrimary) {
                    const e = Wp(t1.iconSizeData, d["icon-size"], o, t1.zoom, a) * m.iconScaleFactor * h, r = a.icon.getPrimary().scaleSelf(e).serialize(), s = n[r];
                    s && (v = Tf(i[r], a.icon.nameSecondary ? i[a.icon.getSecondary().scaleSelf(e).serialize()] : void 0, f.get("icon-offset").evaluate(a, {}, o), f.get("icon-anchor").evaluate(a, {}, o)), A = s.sdf, void 0 === t1.sdfIcons ? t1.sdfIcons = s.sdf : t1.sdfIcons !== s.sdf && ft("Style sheet warning: Cannot mix SDF and non-SDF icons in one buffer"), (s.pixelRatio !== t1.pixelRatio || 0 !== f.get("icon-rotate").constantOr(1)) && (t1.iconsNeedLinear = !0));
                }
                const S = gd(g.horizontal) || g.vertical;
                t1.iconsInText || (t1.iconsInText = !!S && S.iconsInText), (S || v) && fd(t1, a, g, v, n, m, y, 0, M, A, s, o, u, p, w);
            }
            a && t1.generateCollisionDebugBuffers(l, t1.collisionBoxArray, m.textScaleFactor);
        }, t1.e5 = Lg, t1.e6 = j, t1.e7 = ph, t1.e8 = hf, t1.e9 = e, t1.ea = function(t1) {
            let e = 0;
            if (new Uint32Array(t1, 0, 1)[0] !== Gx) {
                const r = new Uint32Array(t1, 0, 7), [, , n, i, a, s] = r;
                e = r.byteLength + i + a + s + a, (n !== t1.byteLength || e >= t1.byteLength) && ft("Invalid b3dm header information.");
            }
            return Kx(t1, e);
        }, t1.eb = function(t1, e) {
            const r = av(t1);
            for (const t1 of r){
                for (const e of t1.meshes)sv(e);
                t1.lights && (t1.lightMeshIndex = t1.meshes.length, t1.meshes.push(ov(t1.lights, e)));
            }
            return r;
        }, t1.ec = yy, t1.ed = Ay, t1.ee = Ba, t1.ef = function(t1) {
            Gt(), null != jt && jt.then((e)=>{
                e.keys().then((r)=>{
                    for(let n = 0; n < r.length - t1; n++)e.delete(r[n]);
                });
            });
        }, t1.f = function(t1) {
            return 0 === t1.indexOf("mapbox:");
        }, t1.g = function(t1, e) {
            return ne(nt(t1, {
                method: "GET"
            }), e);
        }, t1.h = It, t1.i = function(t1) {
            return St.API_STYLE_REGEX.test(t1) && !Pt(t1);
        }, t1.j = function(t1) {
            return decodeURIComponent(atob(t1).split("").map((t1)=>"%" + ("00" + t1.charCodeAt(0).toString(16)).slice(-2)).join(""));
        }, t1.k = function(t1) {
            return btoa(encodeURIComponent(t1).replace(/%([0-9A-F]{2})/g, (t1, e)=>String.fromCharCode(Number("0x" + e))));
        }, t1.l = nt, t1.m = Xt, t1.n = function(t1, e) {
            return ne(nt(t1, {
                type: "json"
            }), e);
        }, t1.o = ue, t1.p = function(t1, e) {
            return ne(nt(t1, {
                method: "POST"
            }), e);
        }, t1.q = Dt, t1.r = sc, t1.s = function(t1) {
            try {
                const e = self[t1];
                return e.setItem("_mapbox_test_", 1), e.removeItem("_mapbox_test_"), !0;
            } catch (t1) {
                return !1;
            }
        }, t1.t = Vt, t1.u = function() {
            return function t1(e) {
                return e ? (e ^ Math.random() * (16 >> e / 4)).toString(16) : ([
                    1e7
                ] + -[
                    1e3
                ] + -4000 + -8000 + -100000000000).replace(/[018]/g, t1);
            }();
        }, t1.v = function(t1) {
            return !!t1 && /^[0-9a-f]{8}-[0-9a-f]{4}-[4][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i.test(t1);
        }, t1.w = ft, t1.x = function() {
            return ky || (ky = new Py), ky;
        }, t1.y = ve, t1.z = xe;
    });
    define([
        "./shared"
    ], function(e) {
        function t1(e) {
            const t1 = e ? e.url.toString() : void 0;
            return t1 ? performance.getEntriesByName(t1) : [];
        }
        function s(e) {
            if ("number" == typeof e || "boolean" == typeof e || "string" == typeof e || null == e) return JSON.stringify(e);
            if (Array.isArray(e)) {
                let t1 = "[";
                for (const i of e)t1 += `${s(i)},`;
                return `${t1}]`;
            }
            let t1 = "{";
            for (const i of Object.keys(e).sort())t1 += `${i}:${s(e[i])},`;
            return `${t1}}`;
        }
        function i(t1) {
            let i = "";
            for (const o of e.bm)("model" !== t1.type || "minzoom" !== o && "maxzoom" !== o) && (i += `/${s(t1[o])}`);
            return i;
        }
        class o {
            replace(e, t1) {
                this._layerConfigs = {}, this._layers = {}, this.update(e, [], t1);
            }
            update(t1, o, r) {
                this._options = r;
                for (const s of t1)this._layerConfigs[s.id] = s, (this._layers[s.id] = e.cu(s, this.scope, null, this._options)).compileFilter(r), this.keyCache[s.id] && delete this.keyCache[s.id];
                for (const e of o)delete this.keyCache[e], delete this._layerConfigs[e], delete this._layers[e];
                this.familiesBySource = {};
                const n = function(e, t1) {
                    const o = {};
                    for(let r = 0; r < e.length; r++){
                        const n = e[r];
                        let a = t1 && t1[n.id];
                        !a && (a = i(n), "line" === n.type && n.paint) && function e(t1) {
                            return "string" == typeof t1 && "line-progress" === t1 || (Array.isArray(t1) ? t1.some(e) : !(!t1 || "object" != typeof t1) && Object.values(t1).some(e));
                        }(n.paint["line-width"]) && (a += `/${s(n.paint["line-width"])}`), t1 && (t1[n.id] = a);
                        let l = o[a];
                        l || (l = o[a] = []), l.push(n);
                    }
                    const r = [];
                    for(const e in o)r.push(o[e]);
                    return r;
                }(e.bj(this._layerConfigs), this.keyCache);
                for (const e of n){
                    const t1 = e.map((e)=>this._layers[e.id]), s = t1[0];
                    if ("none" === s.visibility) continue;
                    const i = s.source || "";
                    let o = this.familiesBySource[i];
                    o || (o = this.familiesBySource[i] = {});
                    const r = s.sourceLayer || "_geojsonTileLayer";
                    let n = o[r];
                    n || (n = o[r] = []), n.push(t1);
                }
            }
            constructor(e){
                this.keyCache = {}, this._layers = {}, this._layerConfigs = {}, e && this.replace(e);
            }
        }
        const r = 1 * e.dX;
        class n {
            constructor(t1){
                const s = {}, i = [];
                for(const e in t1){
                    const o = t1[e], n = s[e] = {};
                    for(const e in o.glyphs){
                        const t1 = o.glyphs[+e];
                        if (!t1 || 0 === t1.bitmap.width || 0 === t1.bitmap.height) continue;
                        const s = t1.metrics.localGlyph ? r : 1, a = {
                            x: 0,
                            y: 0,
                            w: t1.bitmap.width + 2 * s,
                            h: t1.bitmap.height + 2 * s
                        };
                        i.push(a), n[e] = a;
                    }
                }
                const { w: o, h: n } = e.F(i), a = new e.dW({
                    width: o || 1,
                    height: n || 1
                });
                for(const i in t1){
                    const o = t1[i];
                    for(const t1 in o.glyphs){
                        const n = o.glyphs[+t1];
                        if (!n || 0 === n.bitmap.width || 0 === n.bitmap.height) continue;
                        const l = s[i][t1], c = n.metrics.localGlyph ? r : 1;
                        e.dW.copy(n.bitmap, a, {
                            x: 0,
                            y: 0
                        }, {
                            x: l.x + c,
                            y: l.y + c
                        }, n.bitmap);
                    }
                }
                this.image = a, this.positions = s;
            }
        }
        e.dV(n, "GlyphAtlas");
        const a = "3d_elevation_id", l = "hd_road_elevation";
        class c {
            reset(e) {
                return this.feature = e, this._valid = !0, this._geometry = e.loadGeometry(), 0 !== this._geometry.length && 0 !== this._geometry[0].length || (this._valid = !1), this;
            }
            geometry(e, t1) {
                return this._valid && e(t1(this._geometry)), this;
            }
            require(e, t1, s) {
                return this.get(e, !0, t1, s);
            }
            optional(e, t1, s) {
                return this.get(e, !1, t1, s);
            }
            success() {
                return this._valid;
            }
            get(e, t1, s, i) {
                const o = this.feature.properties.hasOwnProperty(e) ? +this.feature.properties[e] : void 0;
                return this._valid && void 0 !== o ? s(i ? i(o) : o) : t1 && (this._valid = !1), this;
            }
            constructor(){
                this._valid = !1;
            }
        }
        class h {
            parseFeature(e, t1, s) {
                return this.featureFunc(e, t1, s);
            }
            parseVertex(e, t1, s) {
                return this.vertexFunc(e, t1, s);
            }
            constructor(e, t1){
                this.featureFunc = e, this.vertexFunc = t1;
            }
        }
        const u = new h((e, t1, s)=>e.reset(t1).require(a, (e)=>{
                s.id = e;
            }).optional("fixed_height_relative", (e)=>{
                s.constantHeight = e;
            }, p.decodeRelativeHeight).geometry((e)=>{
                s.bounds = e;
            }, p.computeBounds).success(), (e, t1, s)=>e.reset(t1).require(a, (e)=>{
                s.id = e;
            }).require("elevation_idx", (e)=>{
                s.idx = e;
            }).require("extent", (e)=>{
                s.extent = e;
            }).require("height_relative", (e)=>{
                s.height = e;
            }, p.decodeRelativeHeight).geometry((e)=>{
                s.position = e;
            }, p.getPoint).success()), d = new h((e, t1, s)=>e.reset(t1).require(a, (e)=>{
                s.id = e;
            }).optional("fixed_height", (e)=>{
                s.constantHeight = e;
            }, p.decodeMetricHeight).geometry((e)=>{
                s.bounds = e;
            }, p.computeBounds).success(), (e, t1, s)=>e.reset(t1).require(a, (e)=>{
                s.id = e;
            }).require("elevation_idx", (e)=>{
                s.idx = e;
            }).require("extent", (e)=>{
                s.extent = e;
            }).require("height", (e)=>{
                s.height = e;
            }, p.decodeMetricHeight).geometry((e)=>{
                s.position = e;
            }, p.getPoint).success());
        class p {
            static computeBounds(t1) {
                const s = new e.P(Number.POSITIVE_INFINITY, Number.POSITIVE_INFINITY), i = new e.P(Number.NEGATIVE_INFINITY, Number.NEGATIVE_INFINITY);
                for (const e of t1[0])s.x > e.x && (s.x = e.x), s.y > e.y && (s.y = e.y), i.x < e.x && (i.x = e.x), i.y < e.y && (i.y = e.y);
                return {
                    min: s,
                    max: i
                };
            }
            static getPoint(t1) {
                return e.ab.vec2.fromValues(t1[0][0].x, t1[0][0].y);
            }
            static decodeRelativeHeight(e) {
                return 1e-4 * e * 5;
            }
            static decodeMetricHeight(e) {
                return 1e-4 * e;
            }
            static parse(t1) {
                const s = [], i = [], o = t1.length, r = new c;
                for(let a = 0; a < o; a++){
                    const o = t1.feature(a), l = o.properties.hasOwnProperty("version") ? String(o.properties.version) : void 0, c = (n = l) ? "1.0.1" === n ? d : void 0 : u;
                    if (void 0 === c) {
                        e.w(`Unknown elevation feature version number ${l || "(unknown)"}`);
                        continue;
                    }
                    const h = o.properties.hasOwnProperty("type") ? o.properties.type : void 0;
                    if (h) {
                        if ("Point" === e.dY.VectorTileFeature.types[o.type] && "curve_point" === h) {
                            const e = {};
                            c.parseVertex(r, o, e) && s.push(e);
                        } else if ("Polygon" === e.dY.VectorTileFeature.types[o.type] && "curve_meta" === h) {
                            const e = {};
                            c.parseFeature(r, o, e) && i.push(e);
                        }
                    }
                }
                var n;
                return {
                    vertices: s,
                    features: i
                };
            }
        }
        class f {
            pointElevation(e) {
                if (null != this.constantHeight) return this.constantHeight;
                const t1 = this.getClosestEdge(e);
                if (null == t1) return 0;
                const [s, i] = t1;
                var o;
                return (1 - (o = i)) * this.vertices[this.edges[s].a].height + o * this.vertices[this.edges[s].b].height;
            }
            getClosestEdge(t1) {
                if (0 === this.edges.length) return;
                let s = 0, i = Number.POSITIVE_INFINITY, o = 0;
                const r = e.ab.vec2.fromValues(t1.x, t1.y);
                for(let t1 = 0; t1 < this.edges.length; t1++){
                    const n = this.edges[t1], a = this.edgeProps[t1].dir, l = new e.dZ(r, this.edgeProps[t1].dir), c = this.vertices[n.a].position, h = this.vertices[n.b].position, u = e.ab.vec2.create(), d = e.ab.vec2.create(), p = l.intersectsPlane(c, this.vertexProps[n.a].dir, u), f = l.intersectsPlane(h, this.vertexProps[n.b].dir, d);
                    if (!p || !f) continue;
                    const g = e.ab.vec2.subtract(e.ab.vec2.create(), d, u), m = e.ab.vec2.subtract(e.ab.vec2.create(), r, u), y = e.ab.vec2.dot(g, g), v = y > 0 ? e.ab.vec2.dot(m, g) / y : 0, b = e.aw(v, 0, 1), x = Math.abs((v - b) * this.edgeProps[t1].len), w = e.ab.vec2.subtract(e.ab.vec2.create(), r, c), I = x + Math.abs(e.ab.vec2.dot(w, e.ab.vec2.fromValues(a[1], -a[0])));
                    I < i && (s = t1, i = I, o = b);
                }
                return [
                    s,
                    o
                ];
            }
            tessellate(t1) {
                for(let s = this.edges.length - 1; s >= 0; --s){
                    const i = this.edges[s].a, o = this.edges[s].b, { position: r, height: n, extent: a } = this.vertices[i], { position: l, height: c, extent: h } = this.vertices[o], u = this.vertexProps[i].dir, d = this.vertexProps[o].dir, p = e.ab.vec3.fromValues(r[0] / t1, r[1] / t1, n), f = e.ab.vec3.fromValues(l[0] / t1, l[1] / t1, c), g = e.ab.vec3.fromValues(u[1], -u[0], 0);
                    e.ab.vec3.scale(g, g, a);
                    const m = e.ab.vec3.fromValues(d[1], -d[0], 0);
                    if (e.ab.vec3.scale(m, m, h), this.distSqLines(e.ab.vec3.fromValues(p[0] + .5 * g[0], p[1] + .5 * g[1], p[2] + .5 * g[2]), e.ab.vec3.fromValues(f[0] - .5 * m[0], f[1] - .5 * m[1], f[2] - .5 * m[2]), e.ab.vec3.fromValues(p[0] - .5 * g[0], p[1] - .5 * g[1], p[2] - .5 * g[2]), e.ab.vec3.fromValues(f[0] + .5 * m[0], f[1] + .5 * m[1], f[2] + .5 * m[2])) <= .05 * .05) continue;
                    const y = this.vertices.length, v = e.ab.vec2.add(e.ab.vec2.create(), r, l);
                    this.vertices.push({
                        position: e.ab.vec2.scale(v, v, .5),
                        height: .5 * (n + c),
                        extent: .5 * (a + h)
                    });
                    const b = e.ab.vec2.add(e.ab.vec2.create(), u, d);
                    this.vertexProps.push({
                        dir: e.ab.vec2.normalize(b, b)
                    }), this.edges.splice(s, 1), this.edgeProps.splice(s, 1), this.edges.push({
                        a: i,
                        b: y
                    }), this.edges.push({
                        a: y,
                        b: o
                    });
                    const x = e.ab.vec2.subtract(e.ab.vec2.create(), this.vertices[y].position, r), w = e.ab.vec2.length(x), I = {
                        vec: x,
                        dir: e.ab.vec2.scale(e.ab.vec2.create(), x, 1 / w),
                        len: w
                    };
                    this.edgeProps.push(I), this.edgeProps.push(I);
                }
            }
            distSqLines(t1, s, i, o) {
                const r = e.ab.vec3.subtract(e.ab.vec3.create(), s, t1), n = e.ab.vec3.subtract(e.ab.vec3.create(), o, i), a = e.ab.vec3.subtract(e.ab.vec3.create(), t1, i), l = e.ab.vec3.dot(r, r), c = e.ab.vec3.dot(r, n), h = e.ab.vec3.dot(r, a), u = e.ab.vec3.dot(n, n), d = e.ab.vec3.dot(n, a), p = l * u - c * c;
                if (0 === p) {
                    const s = e.ab.vec3.dot(a, n) / e.ab.vec3.dot(n, n), r = e.ab.vec3.lerp(e.ab.vec3.create(), i, o, s);
                    return e.ab.vec3.squaredDistance(r, t1);
                }
                const f = (c * d - h * u) / p, g = (l * d - c * h) / p, m = e.ab.vec3.lerp(e.ab.vec3.create(), t1, s, f), y = e.ab.vec3.lerp(e.ab.vec3.create(), i, o, g);
                return e.ab.vec3.squaredDistance(m, y);
            }
            constructor(t1, s, i, o, r, n){
                if (this.vertices = new Array, this.vertexProps = new Array, this.edges = new Array, this.edgeProps = new Array, this.id = t1, this.heightRange = {
                    min: i,
                    max: i
                }, this.safeArea = s, this.constantHeight = i, null == this.constantHeight && (null != this.constantHeight || 0 !== o.length)) {
                    this.vertices = o, this.edges = r, this.edges = this.edges.filter((t1)=>t1.a < this.vertices.length && t1.b < this.vertices.length && !e.ab.vec2.exactEquals(this.vertices[t1.a].position, this.vertices[t1.b].position)), this.heightRange = {
                        min: Number.POSITIVE_INFINITY,
                        max: Number.NEGATIVE_INFINITY
                    };
                    for (const t1 of this.vertices)this.vertexProps.push({
                        dir: e.ab.vec2.fromValues(0, 0)
                    }), this.heightRange.min = Math.min(this.heightRange.min, t1.height), this.heightRange.max = Math.max(this.heightRange.max, t1.height);
                    for (const t1 of this.edges){
                        const s = this.vertices[t1.a].position, i = this.vertices[t1.b].position, o = e.ab.vec2.subtract(e.ab.vec2.create(), i, s), r = e.ab.vec2.length(o), n = e.ab.vec2.scale(e.ab.vec2.create(), o, 1 / r);
                        this.edgeProps.push({
                            vec: o,
                            dir: n,
                            len: r
                        });
                        const a = this.vertexProps[t1.a].dir, l = this.vertexProps[t1.b].dir;
                        e.ab.vec2.add(a, a, n), e.ab.vec2.add(l, l, n);
                    }
                    for (const t1 of this.vertexProps)0 === t1.dir[0] && 0 === t1.dir[1] || e.ab.vec2.normalize(t1.dir, t1.dir);
                    this.tessellate(n);
                }
            }
        }
        class g {
            static parseFrom(t1, s) {
                const i = p.parse(t1);
                if (!i) return [];
                let { vertices: o, features: r } = i;
                const n = 1 / e.cc(s);
                r.sort((e, t1)=>e.id - t1.id), o.sort((e, t1)=>e.id - t1.id || e.idx - t1.idx), o = o.filter((e, t1, s)=>t1 === s.findIndex((t1)=>t1.id === e.id && t1.idx === e.idx));
                const a = new Array;
                let l = 0;
                const c = o.length;
                for (const e of r){
                    if (e.constantHeight) {
                        a.push(new f(e.id, e.bounds, e.constantHeight));
                        continue;
                    }
                    for(; l !== c && o[l].id < e.id;)l++;
                    if (l === c || o[l].id !== e.id) continue;
                    const t1 = new Array, s = new Array, i = l;
                    for(; l !== c && o[l].id === e.id;){
                        const e = o[l];
                        if (t1.push({
                            position: e.position,
                            height: e.height,
                            extent: e.extent
                        }), l !== i && o[l - 1].idx === e.idx - 1) {
                            const e = l - i;
                            s.push({
                                a: e - 1,
                                b: e
                            });
                        }
                        l++;
                    }
                    a.push(new f(e.id, e.bounds, void 0, t1, s, n));
                }
                return a;
            }
        }
        e.dV(f, "ElevationFeature");
        class m {
            parse(t1, s, i, o, r) {
                this.status = "parsing", this.data = t1, this.collisionBoxArray = new e.aW;
                const c = new e.d_(Object.keys(t1.layers).sort()), h = new e.d$(this.tileID, this.promoteId);
                h.bucketLayerIDs = [];
                const u = {}, d = new e.e0(256, 256), p = {
                    featureIndex: h,
                    iconDependencies: {},
                    patternDependencies: {},
                    glyphDependencies: {},
                    lineAtlas: d,
                    availableImages: i,
                    brightness: this.brightness,
                    scaleFactor: this.scaleFactor,
                    elevationFeatures: void 0
                }, f = s.familiesBySource[this.source];
                for(const s in f){
                    const o = t1.layers[s];
                    if (!o) continue;
                    let r = !1, n = !1, d = !1;
                    for (const e of f[s])"symbol" === e[0].type ? r = !0 : n = !0, e[0].is3D() && "model" !== e[0].type && (d = !0);
                    if (this.extraShadowCaster && !d) continue;
                    if (!0 === this.isSymbolTile && !r) continue;
                    if (!1 === this.isSymbolTile && !n) continue;
                    1 === o.version && e.w(`Vector tile source "${this.source}" layer "${s}" does not use vector tile spec v2 and therefore may have some rendering errors.`);
                    const m = c.encode(s), v = [];
                    let b = !1;
                    for(let e = 0, t1 = 0; e < o.length; e++){
                        const i = o.feature(e), r = h.getId(i, s);
                        if (this.localizableLayerIds && this.localizableLayerIds.has(s)) {
                            const e = i.properties ? i.properties.worldview : null;
                            if (this.worldview && "string" == typeof e) {
                                if ("all" === e) i.properties.$localized = !0;
                                else {
                                    if (!e.split(",").includes(this.worldview)) continue;
                                    i.properties.$localized = !0, i.properties.worldview = this.worldview;
                                }
                            }
                        }
                        !b && i.properties && i.properties.hasOwnProperty(a) && (b = !0), v.push({
                            feature: i,
                            id: r,
                            index: t1,
                            sourceLayerIndex: m
                        }), t1++;
                    }
                    b && t1.layers.hasOwnProperty(l) && (p.elevationFeatures = g.parseFrom(t1.layers[l], this.canonical));
                    for (const t1 of f[s]){
                        const s = t1[0];
                        (!this.extraShadowCaster || s.is3D() && "model" !== s.type) && (void 0 !== this.isSymbolTile && "symbol" === s.type !== this.isSymbolTile || s.minzoom && this.zoom < Math.floor(s.minzoom) || s.maxzoom && this.zoom >= s.maxzoom || "none" !== s.visibility && (y(t1, this.zoom, p.brightness, i), (u[s.id] = s.createBucket({
                            index: h.bucketLayerIDs.length,
                            layers: t1,
                            zoom: this.zoom,
                            lut: this.lut,
                            canonical: this.canonical,
                            pixelRatio: this.pixelRatio,
                            overscaling: this.overscaling,
                            collisionBoxArray: this.collisionBoxArray,
                            sourceLayerIndex: m,
                            sourceID: this.source,
                            projection: this.projection.spec,
                            tessellationStep: this.tessellationStep
                        })).populate(v, p, this.tileID.canonical, this.tileTransform), h.bucketLayerIDs.push(t1.map((t1)=>e.aC(t1.id, t1.scope)))));
                    }
                }
                let m, v, b, x;
                d.trim();
                const w = {
                    type: "maybePrepare",
                    isSymbolTile: this.isSymbolTile,
                    zoom: this.zoom
                }, I = ()=>{
                    if (m) return this.status = "done", r(m);
                    if (this.extraShadowCaster) this.status = "done", r(null, {
                        buckets: e.bj(u).filter((e)=>!e.isEmpty()),
                        featureIndex: h,
                        collisionBoxArray: null,
                        glyphAtlasImage: null,
                        lineAtlas: null,
                        imageAtlas: null,
                        brightness: p.brightness,
                        glyphMap: null,
                        iconMap: null,
                        glyphPositions: null
                    });
                    else if (v && b && x) {
                        const t1 = new n(v), s = new e.e3(b, x, this.lut);
                        for(const o in u){
                            const r = u[o];
                            r instanceof e.aX ? (y(r.layers, this.zoom, p.brightness, i), e.e4(r, v, t1.positions, b, s.iconPositions, this.showCollisionBoxes, i, this.tileID.canonical, this.tileZoom, this.projection, this.scaleFactor, this.pixelRatio, this.brightness)) : r.hasPattern && (r instanceof e.b1 || r instanceof e.b2 || r instanceof e.d5) && (y(r.layers, this.zoom, p.brightness, i), r.addFeatures(p, this.tileID.canonical, s.patternPositions, i, this.tileTransform, this.brightness));
                        }
                        this.status = "done", r(null, {
                            buckets: e.bj(u).filter((e)=>!e.isEmpty()),
                            featureIndex: h,
                            collisionBoxArray: this.collisionBoxArray,
                            glyphAtlasImage: t1.image,
                            lineAtlas: d,
                            imageAtlas: s,
                            brightness: p.brightness
                        });
                    }
                };
                if (!this.extraShadowCaster) {
                    const t1 = e.e1(p.glyphDependencies, (e)=>Object.keys(e).map(Number));
                    Object.keys(t1).length ? o.send("getGlyphs", {
                        uid: this.uid,
                        stacks: t1,
                        scope: this.scope
                    }, (e, t1)=>{
                        m || (m = e, v = t1, I());
                    }, void 0, !1, w) : v = {};
                    const s = Object.keys(p.iconDependencies);
                    s.length ? o.send("getImages", {
                        icons: s,
                        source: this.source,
                        scope: this.scope,
                        tileID: this.tileID,
                        type: "icons"
                    }, (e, t1)=>{
                        if (m) return;
                        m = e;
                        const s = {};
                        Object.values(t1).some((e)=>e.usvg) ? this.rasterize(o, s, t1, p.iconDependencies, ()=>{
                            b = s, I();
                        }) : (this.fillImageMap(s, p.iconDependencies, t1), b = s, I());
                    }, void 0, !1, w) : b = {};
                    const i = Object.keys(p.patternDependencies);
                    i.length ? o.send("getImages", {
                        icons: i,
                        source: this.source,
                        scope: this.scope,
                        tileID: this.tileID,
                        type: "patterns"
                    }, (e, t1)=>{
                        if (!m) {
                            m = e;
                            const s = {};
                            Object.values(t1).some((e)=>e.usvg) ? this.rasterize(o, s, t1, p.patternDependencies, ()=>{
                                x = s, I();
                            }) : (this.fillImageMap(s, p.patternDependencies, t1), x = s, I());
                        }
                    }, void 0, !1, w) : x = {};
                }
                I();
            }
            fillImageMap(e, t1, s) {
                for(const i in s){
                    const o = t1[i] || [];
                    for (const t1 of o)s[t1.id].usvg || (e[t1.serialize()] = s[t1.id]);
                }
            }
            getImageTaskQueue(e, t1, s) {
                const i = {};
                for(const o in t1){
                    const r = s[o] || [];
                    for (const s of r){
                        const o = s.serialize();
                        t1[s.id].usvg ? i[o] || (i[o] = s) : e[o] = t1[s.id];
                    }
                }
                return i;
            }
            rasterize(t1, s, i, o, r) {
                const n = this.getImageTaskQueue(s, i, o);
                this.rasterizeTask = t1.send("rasterizeImages", {
                    scope: this.scope,
                    imageTasks: n
                }, (t1, o)=>{
                    if (!t1) for(const t1 in o){
                        const { id: r } = e.e2.deserializeFromString(t1);
                        s[t1] = Object.assign({}, i[r], {
                            data: o[t1]
                        });
                    }
                    r();
                });
            }
            cancelRasterize() {
                this.rasterizeTask && this.rasterizeTask.cancel();
            }
            constructor(t1){
                this.tileID = new e.aG(t1.tileID.overscaledZ, t1.tileID.wrap, t1.tileID.canonical.z, t1.tileID.canonical.x, t1.tileID.canonical.y), this.tileZoom = t1.tileZoom, this.uid = t1.uid, this.zoom = t1.zoom, this.lut = t1.lut, this.canonical = t1.tileID.canonical, this.pixelRatio = t1.pixelRatio, this.tileSize = t1.tileSize, this.source = t1.source, this.scope = t1.scope, this.overscaling = this.tileID.overscaleFactor(), this.showCollisionBoxes = t1.showCollisionBoxes, this.collectResourceTiming = !!t1.request && t1.request.collectResourceTiming, this.promoteId = t1.promoteId, this.isSymbolTile = t1.isSymbolTile, this.tileTransform = e.aQ(t1.tileID.canonical, t1.projection), this.projection = t1.projection, this.worldview = t1.worldview, this.localizableLayerIds = t1.localizableLayerIds, this.brightness = t1.brightness, this.extraShadowCaster = !!t1.extraShadowCaster, this.tessellationStep = t1.tessellationStep, this.scaleFactor = t1.scaleFactor;
            }
        }
        function y(t1, s, i, o) {
            const r = new e.a8(s, {
                brightness: i
            });
            for (const e of t1)e.recalculate(r, o);
        }
        class v extends e.E {
            loadTile(s, i) {
                const o = s.uid, r = s && s.request, n = r && r.collectResourceTiming, a = this.loading[o] = new m(s);
                a.abort = this.loadVectorData(s, (l, c)=>{
                    const h = !this.loading[o];
                    if (delete this.loading[o], a.cancelRasterize(), h || l || !c) return a.status = "done", h || (this.loaded[o] = a), i(l);
                    const u = c.rawData, d = {};
                    c.expires && (d.expires = c.expires), c.cacheControl && (d.cacheControl = c.cacheControl), a.vectorTile = c.vectorTile || new e.dY.VectorTile(new e.bh(u));
                    const p = ()=>{
                        a.parse(a.vectorTile, this.layerIndex, this.availableImages, this.actor, (s, o)=>{
                            if (s || !o) return i(s);
                            const a = {};
                            if (n) {
                                const e = t1(r);
                                e.length > 0 && (a.resourceTiming = JSON.parse(JSON.stringify(e)));
                            }
                            i(null, e.l({
                                rawTileData: u.slice(0)
                            }, o, d, a));
                        });
                    };
                    this.isSpriteLoaded ? p() : this.once("isSpriteLoaded", ()=>{
                        this.scheduler ? this.scheduler.add(p, {
                            type: "parseTile",
                            isSymbolTile: s.isSymbolTile,
                            zoom: s.tileZoom
                        }) : p();
                    }), this.loaded = this.loaded || {}, this.loaded[o] = a;
                });
            }
            reloadTile(t1, s) {
                const i = this.loaded, o = t1.uid;
                if (i && i[o]) {
                    const r = i[o];
                    r.scaleFactor = t1.scaleFactor, r.showCollisionBoxes = t1.showCollisionBoxes, r.projection = t1.projection, r.brightness = t1.brightness, r.tileTransform = e.aQ(t1.tileID.canonical, t1.projection), r.extraShadowCaster = t1.extraShadowCaster, r.lut = t1.lut;
                    const n = (e, t1)=>{
                        const i = r.reloadCallback;
                        i && (delete r.reloadCallback, r.parse(r.vectorTile, this.layerIndex, this.availableImages, this.actor, i)), s(e, t1);
                    };
                    "parsing" === r.status ? r.reloadCallback = n : "done" === r.status && (r.vectorTile ? r.parse(r.vectorTile, this.layerIndex, this.availableImages, this.actor, n) : n());
                } else s(null, void 0);
            }
            abortTile(e, t1) {
                const s = e.uid, i = this.loading[s];
                i && (i.abort && i.abort(), delete this.loading[s]), t1();
            }
            removeTile(e, t1) {
                const s = this.loaded, i = e.uid;
                s && s[i] && delete s[i], t1();
            }
            constructor(t1, s, i, o, r, n){
                super(), this.actor = t1, this.layerIndex = s, this.availableImages = i, this.loadVectorData = r || e.aD, this.loading = {}, this.loaded = {}, this.deduped = new e.aB(t1.scheduler), this.isSpriteLoaded = o, this.scheduler = t1.scheduler, this.brightness = n;
            }
        }
        class b {
            loadTile(t1, s) {
                const { uid: i, encoding: o, rawImageData: r, padding: n } = t1, a = ImageBitmap && r instanceof ImageBitmap ? this.getImageData(r, n) : r;
                s(null, new e.e5(i, a, o, n < 1));
            }
            getImageData(e, t1) {
                this.offscreenCanvas && this.offscreenCanvasContext || (this.offscreenCanvas = new OffscreenCanvas(e.width, e.height), this.offscreenCanvasContext = this.offscreenCanvas.getContext("2d", {
                    willReadFrequently: !0
                })), this.offscreenCanvas.width = e.width, this.offscreenCanvas.height = e.height, this.offscreenCanvasContext.drawImage(e, 0, 0, e.width, e.height);
                const s = this.offscreenCanvasContext.getImageData(-t1, -t1, e.width + 2 * t1, e.height + 2 * t1);
                return this.offscreenCanvasContext.clearRect(0, 0, this.offscreenCanvas.width, this.offscreenCanvas.height), s;
            }
        }
        e.bg.setPbf(e.bh);
        class x {
            decodeRasterArray({ task: t1, buffer: s }, i) {
                e.bg.performDecoding(s, t1).then((e)=>{
                    i(null, e);
                }, (e)=>{
                    i(e);
                });
            }
        }
        const w = e.dY.VectorTileFeature.prototype.toGeoJSON;
        class I {
            loadGeometry() {
                if (1 === this._feature.type) {
                    const t1 = [];
                    for (const s of this._feature.geometry)t1.push([
                        new e.P(s[0], s[1])
                    ]);
                    return t1;
                }
                {
                    const t1 = [];
                    for (const s of this._feature.geometry){
                        const i = [];
                        for (const t1 of s)i.push(new e.P(t1[0], t1[1]));
                        t1.push(i);
                    }
                    return t1;
                }
            }
            toGeoJSON(e, t1, s) {
                return w.call(this, e, t1, s);
            }
            constructor(t1){
                this._feature = t1, this.extent = e.ag, this.type = t1.type, this.properties = t1.tags, "id" in t1 && !isNaN(t1.id) && (this.id = parseInt(t1.id, 10));
            }
        }
        class S {
            feature(e) {
                return new I(this._features[e]);
            }
            constructor(t1){
                this.layers = {
                    _geojsonTileLayer: this
                }, this.name = "_geojsonTileLayer", this.extent = e.ag, this.length = t1.length, this._features = t1;
            }
        }
        const M = 64 / 4096, P = 128;
        class T {
            clear() {
                this.features.clear();
            }
            load(e = [], t1) {
                for (const s of e){
                    const e = s.id;
                    if (null == e) continue;
                    let i = this.features.get(e);
                    i && this.updateCache(i, t1), s.geometry ? (i = _(s), this.updateCache(i, t1), this.features.set(e, i)) : this.features.delete(e), this.updateCache(i, t1);
                }
            }
            updateCache(e, t1) {
                for (const { canonical: s, uid: i } of Object.values(t1)){
                    const { z: o, x: r, y: n } = s;
                    k(e, Math.pow(2, o), r, n) && delete t1[i];
                }
            }
            getTile(e, t1, s) {
                const i = Math.pow(2, e), o = [];
                for (const e of this.features.values())k(e, i, t1, s) && o.push(D(e, i, t1, s));
                return {
                    features: o
                };
            }
            getFeatures() {
                return [
                    ...this.features.values()
                ];
            }
            constructor(){
                this.features = new Map;
            }
        }
        function k({ minX: e, minY: t1, maxX: s, maxY: i }, o, r, n) {
            return e < (r + 1 + M) / o && t1 < (n + 1 + M) / o && s > (r - M) / o && i > (n - M) / o;
        }
        function _(e) {
            const { id: t1, geometry: s, properties: i } = e;
            if (!s) return;
            if ("GeometryCollection" === s.type) throw new Error("GeometryCollection not supported in dynamic mode.");
            const { type: o, coordinates: r } = s, n = {
                id: t1,
                type: 1,
                geometry: [],
                tags: i,
                minX: 1 / 0,
                minY: 1 / 0,
                maxX: -1 / 0,
                maxY: -1 / 0
            }, a = n.geometry;
            if ("Point" === o) C(r, a, n);
            else if ("MultiPoint" === o) for (const e of r)C(e, a, n);
            else if ("LineString" === o) n.type = 2, z(r, a, n);
            else if ("MultiLineString" === o) n.type = 2, L(r, a, n);
            else if ("Polygon" === o) n.type = 3, L(r, a, n, !0);
            else {
                if ("MultiPolygon" !== o) throw new Error("Input data is not a valid GeoJSON object.");
                n.type = 3;
                for (const e of r)L(e, a, n, !0);
            }
            return n;
        }
        function C([t1, s], i, o) {
            const r = e.at(t1);
            let n = e.aA(s);
            n = n < 0 ? 0 : n > 1 ? 1 : n, i.push(r, n), o.minX = Math.min(o.minX, r), o.minY = Math.min(o.minY, n), o.maxX = Math.max(o.maxX, r), o.maxY = Math.max(o.maxY, n);
        }
        function z(e, t1, s, i = !1, o = !1) {
            const r = [];
            for (const t1 of e)C(t1, r, s);
            t1.push(r), i && function(e, t1) {
                let s = 0;
                for(let t1 = 0, i = e.length, o = i - 2; t1 < i; o = t1, t1 += 2)s += (e[t1] - e[o]) * (e[t1 + 1] + e[o + 1]);
                if (s > 0 === t1) for(let t1 = 0, s = e.length; t1 < s / 2; t1 += 2){
                    const i = e[t1], o = e[t1 + 1];
                    e[t1] = e[s - 2 - t1], e[t1 + 1] = e[s - 1 - t1], e[s - 2 - t1] = i, e[s - 1 - t1] = o;
                }
            }(r, o);
        }
        function L(e, t1, s, i = !1) {
            for(let o = 0; o < e.length; o++)z(e[o], t1, s, i, 0 === o);
        }
        function D(t1, s, i, o) {
            const { id: r, type: n, geometry: a, tags: l } = t1, c = [];
            if (1 === n) !function(t1, s, i, o, r) {
                for(let n = 0; n < t1.length; n += 2){
                    const a = Math.round(e.ag * (t1[n + 0] * s - i)), l = Math.round(e.ag * (t1[n + 1] * s - o));
                    r.push([
                        a,
                        l
                    ]);
                }
            }(a, s, i, o, c);
            else for (const e of a)O(e, s, i, o, c);
            return {
                id: r,
                type: n,
                geometry: c,
                tags: l
            };
        }
        function O(t1, s, i, o, r) {
            const n = -P, a = e.ag + P;
            let l;
            for(let c = 0; c < t1.length - 2; c += 2){
                let h = Math.round(e.ag * (t1[c + 0] * s - i)), u = Math.round(e.ag * (t1[c + 1] * s - o)), d = Math.round(e.ag * (t1[c + 2] * s - i)), p = Math.round(e.ag * (t1[c + 3] * s - o));
                const f = d - h, g = p - u;
                h < n && d < n || (h < n ? (u += Math.round(g * ((n - h) / f)), h = n) : d < n && (p = u + Math.round(g * ((n - h) / f)), d = n), u < n && p < n || (u < n ? (h += Math.round(f * ((n - u) / g)), u = n) : p < n && (d = h + Math.round(f * ((n - u) / g)), p = n), h >= a && d >= a || (h >= a ? (u += Math.round(g * ((a - h) / f)), h = a) : d >= a && (p = u + Math.round(g * ((a - h) / f)), d = a), u >= a && p >= a || (u >= a ? (h += Math.round(f * ((a - u) / g)), u = a) : p >= a && (d = h + Math.round(f * ((a - u) / g)), p = a), l && h === l[l.length - 1][0] && u === l[l.length - 1][1] || (l = [
                    [
                        h,
                        u
                    ]
                ], r.push(l)), l.push([
                    d,
                    p
                ])))));
            }
        }
        var j, F, N, A = {
            exports: {}
        }, E = function() {
            if (N) return A.exports;
            N = 1;
            var t1 = e.e8(), s = function() {
                if (F) return j;
                F = 1;
                var t1 = e.e6(), s = e.e7().VectorTileFeature;
                function i(e, t1) {
                    this.options = t1 || {}, this.features = e, this.length = e.length;
                }
                function o(e, t1) {
                    this.id = "number" == typeof e.id ? e.id : void 0, this.type = e.type, this.rawGeometry = 1 === e.type ? [
                        e.geometry
                    ] : e.geometry, this.properties = e.tags, this.extent = t1 || 4096;
                }
                return j = i, i.prototype.feature = function(e) {
                    return new o(this.features[e], this.options.extent);
                }, o.prototype.loadGeometry = function() {
                    var e = this.rawGeometry;
                    this.geometry = [];
                    for(var s = 0; s < e.length; s++){
                        for(var i = e[s], o = [], r = 0; r < i.length; r++)o.push(new t1(i[r][0], i[r][1]));
                        this.geometry.push(o);
                    }
                    return this.geometry;
                }, o.prototype.bbox = function() {
                    this.geometry || this.loadGeometry();
                    for(var e = this.geometry, t1 = 1 / 0, s = -1 / 0, i = 1 / 0, o = -1 / 0, r = 0; r < e.length; r++)for(var n = e[r], a = 0; a < n.length; a++){
                        var l = n[a];
                        t1 = Math.min(t1, l.x), s = Math.max(s, l.x), i = Math.min(i, l.y), o = Math.max(o, l.y);
                    }
                    return [
                        t1,
                        i,
                        s,
                        o
                    ];
                }, o.prototype.toGeoJSON = s.prototype.toGeoJSON, j;
            }();
            function i(e) {
                var s = new t1;
                return function(e, t1) {
                    for(var s in e.layers)t1.writeMessage(3, o, e.layers[s]);
                }(e, s), s.finish();
            }
            function o(e, t1) {
                var s;
                t1.writeVarintField(15, e.version || 1), t1.writeStringField(1, e.name || ""), t1.writeVarintField(5, e.extent || 4096);
                var i = {
                    keys: [],
                    values: [],
                    keycache: {},
                    valuecache: {}
                };
                for(s = 0; s < e.length; s++)i.feature = e.feature(s), t1.writeMessage(2, r, i);
                var o = i.keys;
                for(s = 0; s < o.length; s++)t1.writeStringField(3, o[s]);
                var n = i.values;
                for(s = 0; s < n.length; s++)t1.writeMessage(4, h, n[s]);
            }
            function r(e, t1) {
                var s = e.feature;
                void 0 !== s.id && t1.writeVarintField(1, s.id), t1.writeMessage(2, n, e), t1.writeVarintField(3, s.type), t1.writeMessage(4, c, s);
            }
            function n(e, t1) {
                var s = e.feature, i = e.keys, o = e.values, r = e.keycache, n = e.valuecache;
                for(var a in s.properties){
                    var l = s.properties[a], c = r[a];
                    if (null !== l) {
                        void 0 === c && (i.push(a), r[a] = c = i.length - 1), t1.writeVarint(c);
                        var h = typeof l;
                        "string" !== h && "boolean" !== h && "number" !== h && (l = JSON.stringify(l));
                        var u = h + ":" + l, d = n[u];
                        void 0 === d && (o.push(l), n[u] = d = o.length - 1), t1.writeVarint(d);
                    }
                }
            }
            function a(e, t1) {
                return (t1 << 3) + (7 & e);
            }
            function l(e) {
                return e << 1 ^ e >> 31;
            }
            function c(e, t1) {
                for(var s = e.loadGeometry(), i = e.type, o = 0, r = 0, n = s.length, c = 0; c < n; c++){
                    var h = s[c], u = 1;
                    1 === i && (u = h.length), t1.writeVarint(a(1, u));
                    for(var d = 3 === i ? h.length - 1 : h.length, p = 0; p < d; p++){
                        1 === p && 1 !== i && t1.writeVarint(a(2, d - 1));
                        var f = h[p].x - o, g = h[p].y - r;
                        t1.writeVarint(l(f)), t1.writeVarint(l(g)), o += f, r += g;
                    }
                    3 === i && t1.writeVarint(a(7, 1));
                }
            }
            function h(e, t1) {
                var s = typeof e;
                "string" === s ? t1.writeStringField(1, e) : "boolean" === s ? t1.writeBooleanField(7, e) : "number" === s && (e % 1 != 0 ? t1.writeDoubleField(3, e) : e < 0 ? t1.writeSVarintField(6, e) : t1.writeVarintField(5, e));
            }
            return A.exports = i, A.exports.fromVectorTileJs = i, A.exports.fromGeojsonVt = function(e, t1) {
                t1 = t1 || {};
                var o = {};
                for(var r in e)o[r] = new s(e[r].features, t1), o[r].name = r, o[r].version = t1.version, o[r].extent = t1.extent;
                return i({
                    layers: o
                });
            }, A.exports.GeoJSONWrapper = s, A.exports;
        }(), V = e.e9(E);
        const Y = {
            minZoom: 0,
            maxZoom: 16,
            minPoints: 2,
            radius: 40,
            extent: 512,
            nodeSize: 64,
            log: !1,
            generateId: !1,
            reduce: null,
            map: (e)=>e
        }, R = Math.fround || (Z = new Float32Array(1), (e)=>(Z[0] = +e, Z[0]));
        var Z;
        const G = 3, B = 5, W = 6;
        class X {
            load(e) {
                const { log: t1, minZoom: s, maxZoom: i } = this.options;
                t1 && console.time("total time");
                const o = `prepare ${e.length} points`;
                t1 && console.time(o), this.points = e;
                const r = [];
                for(let t1 = 0; t1 < e.length; t1++){
                    const s = e[t1];
                    if (!s.geometry) continue;
                    const [i, o] = s.geometry.coordinates, n = R($(i)), a = R(H(o));
                    r.push(n, a, 1 / 0, t1, -1, 1), this.options.reduce && r.push(0);
                }
                let n = this.trees[i + 1] = this._createTree(r);
                t1 && console.timeEnd(o);
                for(let e = i; e >= s; e--){
                    const s = +Date.now();
                    n = this.trees[e] = this._createTree(this._cluster(n, e)), t1 && console.log("z%d: %d clusters in %dms", e, n.numItems, +Date.now() - s);
                }
                return t1 && console.timeEnd("total time"), this;
            }
            getClusters(e, t1) {
                let s = ((e[0] + 180) % 360 + 360) % 360 - 180;
                const i = Math.max(-90, Math.min(90, e[1]));
                let o = 180 === e[2] ? 180 : ((e[2] + 180) % 360 + 360) % 360 - 180;
                const r = Math.max(-90, Math.min(90, e[3]));
                if (e[2] - e[0] >= 360) s = -180, o = 180;
                else if (s > o) {
                    const e = this.getClusters([
                        s,
                        i,
                        180,
                        r
                    ], t1), n = this.getClusters([
                        -180,
                        i,
                        o,
                        r
                    ], t1);
                    return e.concat(n);
                }
                const n = this.trees[this._limitZoom(t1)], a = n.range($(s), H(r), $(o), H(i)), l = n.data, c = [];
                for (const e of a){
                    const t1 = this.stride * e;
                    c.push(l[t1 + B] > 1 ? J(l, t1, this.clusterProps) : this.points[l[t1 + G]]);
                }
                return c;
            }
            getChildren(e) {
                const t1 = this._getOriginId(e), s = this._getOriginZoom(e), i = "No cluster with the specified id.", o = this.trees[s];
                if (!o) throw new Error(i);
                const r = o.data;
                if (t1 * this.stride >= r.length) throw new Error(i);
                const n = this.options.radius / (this.options.extent * Math.pow(2, s - 1)), a = o.within(r[t1 * this.stride], r[t1 * this.stride + 1], n), l = [];
                for (const t1 of a){
                    const s = t1 * this.stride;
                    r[s + 4] === e && l.push(r[s + B] > 1 ? J(r, s, this.clusterProps) : this.points[r[s + G]]);
                }
                if (0 === l.length) throw new Error(i);
                return l;
            }
            getLeaves(e, t1, s) {
                const i = [];
                return this._appendLeaves(i, e, t1 = t1 || 10, s = s || 0, 0), i;
            }
            getTile(e, t1, s) {
                const i = this.trees[this._limitZoom(e)], o = Math.pow(2, e), { extent: r, radius: n } = this.options, a = n / r, l = (s - a) / o, c = (s + 1 + a) / o, h = {
                    features: []
                };
                return this._addTileFeatures(i.range((t1 - a) / o, l, (t1 + 1 + a) / o, c), i.data, t1, s, o, h), 0 === t1 && this._addTileFeatures(i.range(1 - a / o, l, 1, c), i.data, o, s, o, h), t1 === o - 1 && this._addTileFeatures(i.range(0, l, a / o, c), i.data, -1, s, o, h), h.features.length ? h : null;
            }
            getClusterExpansionZoom(e) {
                let t1 = this._getOriginZoom(e) - 1;
                for(; t1 <= this.options.maxZoom;){
                    const s = this.getChildren(e);
                    if (t1++, 1 !== s.length) break;
                    e = s[0].properties.cluster_id;
                }
                return t1;
            }
            _appendLeaves(e, t1, s, i, o) {
                const r = this.getChildren(t1);
                for (const t1 of r){
                    const r = t1.properties;
                    if (r && r.cluster ? o + r.point_count <= i ? o += r.point_count : o = this._appendLeaves(e, r.cluster_id, s, i, o) : o < i ? o++ : e.push(t1), e.length === s) break;
                }
                return o;
            }
            _createTree(t1) {
                const s = new e.bE(t1.length / this.stride | 0, this.options.nodeSize, Float32Array);
                for(let e = 0; e < t1.length; e += this.stride)s.add(t1[e], t1[e + 1]);
                return s.finish(), s.data = t1, s;
            }
            _addTileFeatures(e, t1, s, i, o, r) {
                for (const n of e){
                    const e = n * this.stride, a = t1[e + B] > 1;
                    let l, c, h;
                    if (a) l = q(t1, e, this.clusterProps), c = t1[e], h = t1[e + 1];
                    else {
                        const s = this.points[t1[e + G]];
                        l = s.properties;
                        const [i, o] = s.geometry.coordinates;
                        c = $(i), h = H(o);
                    }
                    const u = {
                        type: 1,
                        geometry: [
                            [
                                Math.round(this.options.extent * (c * o - s)),
                                Math.round(this.options.extent * (h * o - i))
                            ]
                        ],
                        tags: l
                    };
                    let d;
                    d = a || this.options.generateId ? t1[e + G] : this.points[t1[e + G]].id, void 0 !== d && (u.id = d), r.features.push(u);
                }
            }
            _limitZoom(e) {
                return Math.max(this.options.minZoom, Math.min(Math.floor(+e), this.options.maxZoom + 1));
            }
            _cluster(e, t1) {
                const { radius: s, extent: i, reduce: o, minPoints: r } = this.options, n = s / (i * Math.pow(2, t1)), a = e.data, l = [], c = this.stride;
                for(let s = 0; s < a.length; s += c){
                    if (a[s + 2] <= t1) continue;
                    a[s + 2] = t1;
                    const i = a[s], h = a[s + 1], u = e.within(a[s], a[s + 1], n), d = a[s + B];
                    let p = d;
                    for (const e of u){
                        const s = e * c;
                        a[s + 2] > t1 && (p += a[s + B]);
                    }
                    if (p > d && p >= r) {
                        let e, r = i * d, n = h * d, f = -1;
                        const g = (s / c << 5) + (t1 + 1) + this.points.length;
                        for (const i of u){
                            const l = i * c;
                            if (a[l + 2] <= t1) continue;
                            a[l + 2] = t1;
                            const h = a[l + B];
                            r += a[l] * h, n += a[l + 1] * h, a[l + 4] = g, o && (e || (e = this._map(a, s, !0), f = this.clusterProps.length, this.clusterProps.push(e)), o(e, this._map(a, l)));
                        }
                        a[s + 4] = g, l.push(r / p, n / p, 1 / 0, g, -1, p), o && l.push(f);
                    } else {
                        for(let e = 0; e < c; e++)l.push(a[s + e]);
                        if (p > 1) for (const e of u){
                            const s = e * c;
                            if (!(a[s + 2] <= t1)) {
                                a[s + 2] = t1;
                                for(let e = 0; e < c; e++)l.push(a[s + e]);
                            }
                        }
                    }
                }
                return l;
            }
            _getOriginId(e) {
                return e - this.points.length >> 5;
            }
            _getOriginZoom(e) {
                return (e - this.points.length) % 32;
            }
            _map(e, t1, s) {
                if (e[t1 + B] > 1) {
                    const i = this.clusterProps[e[t1 + W]];
                    return s ? Object.assign({}, i) : i;
                }
                const i = this.points[e[t1 + G]].properties, o = this.options.map(i);
                return s && o === i ? Object.assign({}, o) : o;
            }
            constructor(e){
                this.options = Object.assign(Object.create(Y), e), this.trees = new Array(this.options.maxZoom + 1), this.stride = this.options.reduce ? 7 : 6, this.clusterProps = [];
            }
        }
        function J(e, t1, s) {
            var i;
            return {
                type: "Feature",
                id: e[t1 + G],
                properties: q(e, t1, s),
                geometry: {
                    type: "Point",
                    coordinates: [
                        (i = e[t1], 360 * (i - .5)),
                        U(e[t1 + 1])
                    ]
                }
            };
        }
        function q(e, t1, s) {
            const i = e[t1 + B], o = i >= 1e4 ? `${Math.round(i / 1e3)}k` : i >= 1e3 ? Math.round(i / 100) / 10 + "k" : i, r = e[t1 + W], n = -1 === r ? {} : Object.assign({}, s[r]);
            return Object.assign(n, {
                cluster: !0,
                cluster_id: e[t1 + G],
                point_count: i,
                point_count_abbreviated: o
            });
        }
        function $(e) {
            return e / 360 + .5;
        }
        function H(e) {
            const t1 = Math.sin(e * Math.PI / 180), s = .5 - .25 * Math.log((1 + t1) / (1 - t1)) / Math.PI;
            return s < 0 ? 0 : s > 1 ? 1 : s;
        }
        function U(e) {
            const t1 = (180 - 360 * e) * Math.PI / 180;
            return 360 * Math.atan(Math.exp(t1)) / Math.PI - 90;
        }
        function Q(e, t1, s, i) {
            let o = i;
            const r = t1 + (s - t1 >> 1);
            let n, a = s - t1;
            const l = e[t1], c = e[t1 + 1], h = e[s], u = e[s + 1];
            for(let i = t1 + 3; i < s; i += 3){
                const t1 = K(e[i], e[i + 1], l, c, h, u);
                if (t1 > o) n = i, o = t1;
                else if (t1 === o) {
                    const e = Math.abs(i - r);
                    e < a && (n = i, a = e);
                }
            }
            o > i && (n - t1 > 3 && Q(e, t1, n, i), e[n + 2] = o, s - n > 3 && Q(e, n, s, i));
        }
        function K(e, t1, s, i, o, r) {
            let n = o - s, a = r - i;
            if (0 !== n || 0 !== a) {
                const l = ((e - s) * n + (t1 - i) * a) / (n * n + a * a);
                l > 1 ? (s = o, i = r) : l > 0 && (s += n * l, i += a * l);
            }
            return n = e - s, a = t1 - i, n * n + a * a;
        }
        function ee(e, t1, s, i) {
            const o = {
                id: e ?? null,
                type: t1,
                geometry: s,
                tags: i,
                minX: 1 / 0,
                minY: 1 / 0,
                maxX: -1 / 0,
                maxY: -1 / 0
            };
            if ("Point" === t1 || "MultiPoint" === t1 || "LineString" === t1) te(o, s);
            else if ("Polygon" === t1) te(o, s[0]);
            else if ("MultiLineString" === t1) for (const e of s)te(o, e);
            else if ("MultiPolygon" === t1) for (const e of s)te(o, e[0]);
            return o;
        }
        function te(e, t1) {
            for(let s = 0; s < t1.length; s += 3)e.minX = Math.min(e.minX, t1[s]), e.minY = Math.min(e.minY, t1[s + 1]), e.maxX = Math.max(e.maxX, t1[s]), e.maxY = Math.max(e.maxY, t1[s + 1]);
        }
        function se(e, t1, s, i) {
            if (!t1.geometry) return;
            const o = t1.geometry.coordinates;
            if (o && 0 === o.length) return;
            const r = t1.geometry.type, n = Math.pow(s.tolerance / ((1 << s.maxZoom) * s.extent), 2);
            let a = [], l = t1.id;
            if (s.promoteId ? l = t1.properties[s.promoteId] : s.generateId && (l = i || 0), "Point" === r) ie(o, a);
            else if ("MultiPoint" === r) for (const e of o)ie(e, a);
            else if ("LineString" === r) oe(o, a, n, !1);
            else if ("MultiLineString" === r) {
                if (s.lineMetrics) {
                    for (const s of o)a = [], oe(s, a, n, !1), e.push(ee(l, "LineString", a, t1.properties));
                    return;
                }
                re(o, a, n, !1);
            } else if ("Polygon" === r) re(o, a, n, !0);
            else {
                if ("MultiPolygon" !== r) {
                    if ("GeometryCollection" === r) {
                        for (const o of t1.geometry.geometries)se(e, {
                            id: l,
                            geometry: o,
                            properties: t1.properties
                        }, s, i);
                        return;
                    }
                    throw new Error("Input data is not a valid GeoJSON object.");
                }
                for (const e of o){
                    const t1 = [];
                    re(e, t1, n, !0), a.push(t1);
                }
            }
            e.push(ee(l, r, a, t1.properties));
        }
        function ie(e, t1) {
            t1.push(ne(e[0]), ae(e[1]), 0);
        }
        function oe(e, t1, s, i) {
            let o, r, n = 0;
            for(let s = 0; s < e.length; s++){
                const a = ne(e[s][0]), l = ae(e[s][1]);
                t1.push(a, l, 0), s > 0 && (n += i ? (o * l - a * r) / 2 : Math.sqrt(Math.pow(a - o, 2) + Math.pow(l - r, 2))), o = a, r = l;
            }
            const a = t1.length - 3;
            t1[2] = 1, Q(t1, 0, a, s), t1[a + 2] = 1, t1.size = Math.abs(n), t1.start = 0, t1.end = t1.size;
        }
        function re(e, t1, s, i) {
            for(let o = 0; o < e.length; o++){
                const r = [];
                oe(e[o], r, s, i), t1.push(r);
            }
        }
        function ne(e) {
            return e / 360 + .5;
        }
        function ae(e) {
            const t1 = Math.sin(e * Math.PI / 180), s = .5 - .25 * Math.log((1 + t1) / (1 - t1)) / Math.PI;
            return s < 0 ? 0 : s > 1 ? 1 : s;
        }
        function le(e, t1, s, i, o, r, n, a) {
            if (i /= t1, r >= (s /= t1) && n < i) return e;
            if (n < s || r >= i) return null;
            const l = [];
            for (const t1 of e){
                const e = t1.geometry;
                let r = t1.type;
                const n = 0 === o ? t1.minX : t1.minY, c = 0 === o ? t1.maxX : t1.maxY;
                if (n >= s && c < i) {
                    l.push(t1);
                    continue;
                }
                if (c < s || n >= i) continue;
                let h = [];
                if ("Point" === r || "MultiPoint" === r) ce(e, h, s, i, o);
                else if ("LineString" === r) he(e, h, s, i, o, !1, a.lineMetrics);
                else if ("MultiLineString" === r) de(e, h, s, i, o, !1);
                else if ("Polygon" === r) de(e, h, s, i, o, !0);
                else if ("MultiPolygon" === r) for (const t1 of e){
                    const e = [];
                    de(t1, e, s, i, o, !0), e.length && h.push(e);
                }
                if (h.length) {
                    if (a.lineMetrics && "LineString" === r) {
                        for (const e of h)l.push(ee(t1.id, r, e, t1.tags));
                        continue;
                    }
                    "LineString" !== r && "MultiLineString" !== r || (1 === h.length ? (r = "LineString", h = h[0]) : r = "MultiLineString"), "Point" !== r && "MultiPoint" !== r || (r = 3 === h.length ? "Point" : "MultiPoint"), l.push(ee(t1.id, r, h, t1.tags));
                }
            }
            return l.length ? l : null;
        }
        function ce(e, t1, s, i, o) {
            for(let r = 0; r < e.length; r += 3){
                const n = e[r + o];
                n >= s && n <= i && pe(t1, e[r], e[r + 1], e[r + 2]);
            }
        }
        function he(e, t1, s, i, o, r, n) {
            let a = ue(e);
            const l = 0 === o ? fe : ge;
            let c, h, u = e.start;
            for(let d = 0; d < e.length - 3; d += 3){
                const p = e[d], f = e[d + 1], g = e[d + 2], m = e[d + 3], y = e[d + 4], v = 0 === o ? p : f, b = 0 === o ? m : y;
                let x = !1;
                n && (c = Math.sqrt(Math.pow(p - m, 2) + Math.pow(f - y, 2))), v < s ? b > s && (h = l(a, p, f, m, y, s), n && (a.start = u + c * h)) : v > i ? b < i && (h = l(a, p, f, m, y, i), n && (a.start = u + c * h)) : pe(a, p, f, g), b < s && v >= s && (h = l(a, p, f, m, y, s), x = !0), b > i && v <= i && (h = l(a, p, f, m, y, i), x = !0), !r && x && (n && (a.end = u + c * h), t1.push(a), a = ue(e)), n && (u += c);
            }
            let d = e.length - 3;
            const p = e[d], f = e[d + 1], g = 0 === o ? p : f;
            g >= s && g <= i && pe(a, p, f, e[d + 2]), d = a.length - 3, r && d >= 3 && (a[d] !== a[0] || a[d + 1] !== a[1]) && pe(a, a[0], a[1], a[2]), a.length && t1.push(a);
        }
        function ue(e) {
            const t1 = [];
            return t1.size = e.size, t1.start = e.start, t1.end = e.end, t1;
        }
        function de(e, t1, s, i, o, r) {
            for (const n of e)he(n, t1, s, i, o, r, !1);
        }
        function pe(e, t1, s, i) {
            e.push(t1, s, i);
        }
        function fe(e, t1, s, i, o, r) {
            const n = (r - t1) / (i - t1);
            return pe(e, r, s + (o - s) * n, 1), n;
        }
        function ge(e, t1, s, i, o, r) {
            const n = (r - s) / (o - s);
            return pe(e, t1 + (i - t1) * n, r, 1), n;
        }
        function me(e, t1) {
            const s = [];
            for(let i = 0; i < e.length; i++){
                const o = e[i], r = o.type;
                let n;
                if ("Point" === r || "MultiPoint" === r || "LineString" === r) n = ye(o.geometry, t1);
                else if ("MultiLineString" === r || "Polygon" === r) {
                    n = [];
                    for (const e of o.geometry)n.push(ye(e, t1));
                } else if ("MultiPolygon" === r) {
                    n = [];
                    for (const e of o.geometry){
                        const s = [];
                        for (const i of e)s.push(ye(i, t1));
                        n.push(s);
                    }
                }
                s.push(ee(o.id, r, n, o.tags));
            }
            return s;
        }
        function ye(e, t1) {
            const s = [];
            s.size = e.size, void 0 !== e.start && (s.start = e.start, s.end = e.end);
            for(let i = 0; i < e.length; i += 3)s.push(e[i] + t1, e[i + 1], e[i + 2]);
            return s;
        }
        function ve(e, t1) {
            if (e.transformed) return e;
            const s = 1 << e.z, i = e.x, o = e.y;
            for (const r of e.features){
                const e = r.geometry, n = r.type;
                if (r.geometry = [], 1 === n) for(let n = 0; n < e.length; n += 2)r.geometry.push(be(e[n], e[n + 1], t1, s, i, o));
                else for(let n = 0; n < e.length; n++){
                    const a = [];
                    for(let r = 0; r < e[n].length; r += 2)a.push(be(e[n][r], e[n][r + 1], t1, s, i, o));
                    r.geometry.push(a);
                }
            }
            return e.transformed = !0, e;
        }
        function be(e, t1, s, i, o, r) {
            return [
                Math.round(s * (e * i - o)),
                Math.round(s * (t1 * i - r))
            ];
        }
        function xe(e, t1, s, i, o) {
            const r = t1 === o.maxZoom ? 0 : o.tolerance / ((1 << t1) * o.extent), n = {
                features: [],
                numPoints: 0,
                numSimplified: 0,
                numFeatures: e.length,
                source: null,
                x: s,
                y: i,
                z: t1,
                transformed: !1,
                minX: 2,
                minY: 1,
                maxX: -1,
                maxY: 0
            };
            for (const t1 of e)we(n, t1, r, o);
            return n;
        }
        function we(e, t1, s, i) {
            const o = t1.geometry, r = t1.type, n = [];
            if (e.minX = Math.min(e.minX, t1.minX), e.minY = Math.min(e.minY, t1.minY), e.maxX = Math.max(e.maxX, t1.maxX), e.maxY = Math.max(e.maxY, t1.maxY), "Point" === r || "MultiPoint" === r) for(let t1 = 0; t1 < o.length; t1 += 3)n.push(o[t1], o[t1 + 1]), e.numPoints++, e.numSimplified++;
            else if ("LineString" === r) Ie(n, o, e, s, !1, !1);
            else if ("MultiLineString" === r || "Polygon" === r) for(let t1 = 0; t1 < o.length; t1++)Ie(n, o[t1], e, s, "Polygon" === r, 0 === t1);
            else if ("MultiPolygon" === r) for(let t1 = 0; t1 < o.length; t1++){
                const i = o[t1];
                for(let t1 = 0; t1 < i.length; t1++)Ie(n, i[t1], e, s, !0, 0 === t1);
            }
            if (n.length) {
                let s = t1.tags || null;
                if ("LineString" === r && i.lineMetrics) {
                    s = {};
                    for(const e in t1.tags)s[e] = t1.tags[e];
                    s.mapbox_clip_start = o.start / o.size, s.mapbox_clip_end = o.end / o.size;
                }
                const a = {
                    geometry: n,
                    type: "Polygon" === r || "MultiPolygon" === r ? 3 : "LineString" === r || "MultiLineString" === r ? 2 : 1,
                    tags: s
                };
                null !== t1.id && (a.id = t1.id), e.features.push(a);
            }
        }
        function Ie(e, t1, s, i, o, r) {
            const n = i * i;
            if (i > 0 && t1.size < (o ? n : i)) return void (s.numPoints += t1.length / 3);
            const a = [];
            for(let e = 0; e < t1.length; e += 3)(0 === i || t1[e + 2] > n) && (s.numSimplified++, a.push(t1[e], t1[e + 1])), s.numPoints++;
            o && function(e, t1) {
                let s = 0;
                for(let t1 = 0, i = e.length, o = i - 2; t1 < i; o = t1, t1 += 2)s += (e[t1] - e[o]) * (e[t1 + 1] + e[o + 1]);
                if (s > 0 === t1) for(let t1 = 0, s = e.length; t1 < s / 2; t1 += 2){
                    const i = e[t1], o = e[t1 + 1];
                    e[t1] = e[s - 2 - t1], e[t1 + 1] = e[s - 1 - t1], e[s - 2 - t1] = i, e[s - 1 - t1] = o;
                }
            }(a, r), e.push(a);
        }
        const Se = {
            maxZoom: 14,
            indexMaxZoom: 5,
            indexMaxPoints: 1e5,
            tolerance: 3,
            extent: 4096,
            buffer: 64,
            lineMetrics: !1,
            promoteId: null,
            generateId: !1,
            debug: 0
        };
        class Me {
            splitTile(e, t1, s, i, o, r, n) {
                const a = [
                    e,
                    t1,
                    s,
                    i
                ], l = this.options, c = l.debug;
                for(; a.length;){
                    i = a.pop(), s = a.pop(), t1 = a.pop(), e = a.pop();
                    const h = 1 << t1, u = Pe(t1, s, i);
                    let d = this.tiles[u];
                    if (!d && (c > 1 && console.time("creation"), d = this.tiles[u] = xe(e, t1, s, i, l), this.tileCoords.push({
                        z: t1,
                        x: s,
                        y: i
                    }), c)) {
                        c > 1 && (console.log("tile z%d-%d-%d (features: %d, points: %d, simplified: %d)", t1, s, i, d.numFeatures, d.numPoints, d.numSimplified), console.timeEnd("creation"));
                        const e = `z${t1}`;
                        this.stats[e] = (this.stats[e] || 0) + 1, this.total++;
                    }
                    if (d.source = e, null == o) {
                        if (t1 === l.indexMaxZoom || d.numPoints <= l.indexMaxPoints) continue;
                    } else {
                        if (t1 === l.maxZoom || t1 === o) continue;
                        if (null != o) {
                            const e = o - t1;
                            if (s !== r >> e || i !== n >> e) continue;
                        }
                    }
                    if (d.source = null, 0 === e.length) continue;
                    c > 1 && console.time("clipping");
                    const p = .5 * l.buffer / l.extent, f = .5 - p, g = .5 + p, m = 1 + p;
                    let y = null, v = null, b = null, x = null, w = le(e, h, s - p, s + g, 0, d.minX, d.maxX, l), I = le(e, h, s + f, s + m, 0, d.minX, d.maxX, l);
                    e = null, w && (y = le(w, h, i - p, i + g, 1, d.minY, d.maxY, l), v = le(w, h, i + f, i + m, 1, d.minY, d.maxY, l), w = null), I && (b = le(I, h, i - p, i + g, 1, d.minY, d.maxY, l), x = le(I, h, i + f, i + m, 1, d.minY, d.maxY, l), I = null), c > 1 && console.timeEnd("clipping"), a.push(y || [], t1 + 1, 2 * s, 2 * i), a.push(v || [], t1 + 1, 2 * s, 2 * i + 1), a.push(b || [], t1 + 1, 2 * s + 1, 2 * i), a.push(x || [], t1 + 1, 2 * s + 1, 2 * i + 1);
                }
            }
            getTile(e, t1, s) {
                e = +e, t1 = +t1, s = +s;
                const i = this.options, { extent: o, debug: r } = i;
                if (e < 0 || e > 24) return null;
                const n = 1 << e, a = Pe(e, t1 = t1 + n & n - 1, s);
                if (this.tiles[a]) return ve(this.tiles[a], o);
                r > 1 && console.log("drilling down to z%d-%d-%d", e, t1, s);
                let l, c = e, h = t1, u = s;
                for(; !l && c > 0;)c--, h >>= 1, u >>= 1, l = this.tiles[Pe(c, h, u)];
                return l && l.source ? (r > 1 && (console.log("found parent tile z%d-%d-%d", c, h, u), console.time("drilling down")), this.splitTile(l.source, c, h, u, e, t1, s), r > 1 && console.timeEnd("drilling down"), this.tiles[a] ? ve(this.tiles[a], o) : null) : null;
            }
            constructor(e, t1){
                const s = (t1 = this.options = function(e, t1) {
                    for(const s in t1)e[s] = t1[s];
                    return e;
                }(Object.create(Se), t1)).debug;
                if (s && console.time("preprocess data"), t1.maxZoom < 0 || t1.maxZoom > 24) throw new Error("maxZoom should be in the 0-24 range");
                if (t1.promoteId && t1.generateId) throw new Error("promoteId and generateId cannot be used together.");
                let i = function(e, t1) {
                    const s = [];
                    if ("FeatureCollection" === e.type) for(let i = 0; i < e.features.length; i++)se(s, e.features[i], t1, i);
                    else se(s, "Feature" === e.type ? e : {
                        geometry: e
                    }, t1);
                    return s;
                }(e, t1);
                this.tiles = {}, this.tileCoords = [], s && (console.timeEnd("preprocess data"), console.log("index: maxZoom: %d, maxPoints: %d", t1.indexMaxZoom, t1.indexMaxPoints), console.time("generate tiles"), this.stats = {}, this.total = 0), i = function(e, t1) {
                    const s = t1.buffer / t1.extent;
                    let i = e;
                    const o = le(e, 1, -1 - s, s, 0, -1, 2, t1), r = le(e, 1, 1 - s, 2 + s, 0, -1, 2, t1);
                    return (o || r) && (i = le(e, 1, -s, 1 + s, 0, -1, 2, t1) || [], o && (i = me(o, 1).concat(i)), r && (i = i.concat(me(r, -1)))), i;
                }(i, t1), i.length && this.splitTile(i, 0, 0, 0), s && (i.length && console.log("features: %d, points: %d", this.tiles[0].numFeatures, this.tiles[0].numPoints), console.timeEnd("generate tiles"), console.log("tiles generated:", this.total, JSON.stringify(this.stats)));
            }
        }
        function Pe(e, t1, s) {
            return 32 * ((1 << e) * s + t1) + e;
        }
        function Te(e, t1) {
            const s = e.tileID.canonical;
            if (!this._geoJSONIndex) return void t1(null, null);
            const i = this._geoJSONIndex.getTile(s.z, s.x, s.y);
            if (!i) return void t1(null, null);
            const o = new S(i.features);
            let r = V(o);
            0 === r.byteOffset && r.byteLength === r.buffer.byteLength || (r = new Uint8Array(r)), t1(null, {
                vectorTile: o,
                rawData: r.buffer
            });
        }
        class ke extends v {
            loadData(s, i) {
                const o = s && s.request, r = o && o.collectResourceTiming;
                this.loadGeoJSON(s, (n, a)=>{
                    if (n || !a) return i(n);
                    if ("object" != typeof a) return i(new Error(`Input data given to '${s.source}' is not a valid GeoJSON object.`));
                    {
                        try {
                            if (s.filter) {
                                const t1 = e.U(s.filter, {
                                    type: "boolean",
                                    "property-type": "data-driven",
                                    overridable: !1,
                                    transition: !1
                                });
                                if ("error" === t1.result) throw new Error(t1.value.map((e)=>`${e.key}: ${e.message}`).join(", "));
                                a.features = a.features.filter((e)=>t1.value.evaluate({
                                        zoom: 0
                                    }, e));
                            }
                            s.dynamic ? ("Feature" === a.type && (a = {
                                type: "FeatureCollection",
                                features: [
                                    a
                                ]
                            }), s.append || (this._dynamicIndex.clear(), this.loaded = {}), this._dynamicIndex.load(a.features, this.loaded), s.cluster && (a.features = this._dynamicIndex.getFeatures())) : this.loaded = {}, this._geoJSONIndex = s.cluster ? new X(function({ superclusterOptions: t1, clusterProperties: s }) {
                                if (!s || !t1) return t1;
                                const i = {}, o = {}, r = {
                                    accumulated: null,
                                    zoom: 0
                                }, n = {
                                    properties: null
                                }, a = Object.keys(s);
                                for (const t1 of a){
                                    const [r, n] = s[t1], a = e.U(n), l = e.U("string" == typeof r ? [
                                        r,
                                        [
                                            "accumulated"
                                        ],
                                        [
                                            "get",
                                            t1
                                        ]
                                    ] : r);
                                    i[t1] = a.value, o[t1] = l.value;
                                }
                                return t1.map = (e)=>{
                                    n.properties = e;
                                    const t1 = {};
                                    for (const e of a)t1[e] = i[e].evaluate(r, n);
                                    return t1;
                                }, t1.reduce = (e, t1)=>{
                                    n.properties = t1;
                                    for (const t1 of a)r.accumulated = e[t1], e[t1] = o[t1].evaluate(r, n);
                                }, t1;
                            }(s)).load(a.features) : s.dynamic ? this._dynamicIndex : function(e, t1) {
                                return new Me(e, t1);
                            }(a, s.geojsonVtOptions);
                        } catch (e) {
                            return i(e);
                        }
                        const n = {};
                        if (r) {
                            const e = t1(o);
                            e && (n.resourceTiming = {}, n.resourceTiming[s.source] = JSON.parse(JSON.stringify(e)));
                        }
                        i(null, n);
                    }
                });
            }
            reloadTile(e, t1) {
                const s = this.loaded;
                return s && s[e.uid] ? e.partial ? t1(null, void 0) : super.reloadTile(e, t1) : this.loadTile(e, t1);
            }
            loadGeoJSON(t1, s) {
                if (t1.request) e.n(t1.request, s);
                else {
                    if ("string" != typeof t1.data) return s(new Error(`Input data given to '${t1.source}' is not a valid GeoJSON object.`));
                    try {
                        return s(null, JSON.parse(t1.data));
                    } catch (e) {
                        return s(new Error(`Input data given to '${t1.source}' is not a valid GeoJSON object.`));
                    }
                }
            }
            getClusterExpansionZoom(e, t1) {
                try {
                    t1(null, this._geoJSONIndex.getClusterExpansionZoom(e.clusterId));
                } catch (e) {
                    t1(e);
                }
            }
            getClusterChildren(e, t1) {
                try {
                    t1(null, this._geoJSONIndex.getChildren(e.clusterId));
                } catch (e) {
                    t1(e);
                }
            }
            getClusterLeaves(e, t1) {
                try {
                    t1(null, this._geoJSONIndex.getLeaves(e.clusterId, e.limit, e.offset));
                } catch (e) {
                    t1(e);
                }
            }
            constructor(e, t1, s, i, o, r){
                super(e, t1, s, i, Te, r), o && (this.loadGeoJSON = o), this._dynamicIndex = new T;
            }
        }
        class _e {
            parse(t1, s, i, o) {
                this.status = "parsing";
                const r = new e.aG(i.tileID.overscaledZ, i.tileID.wrap, i.tileID.canonical.z, i.tileID.canonical.x, i.tileID.canonical.y), n = [], a = s.familiesBySource[i.source], l = new e.d$(r, i.promoteId);
                return l.bucketLayerIDs = [], l.is3DTile = !0, e.ea(t1).then((t1)=>{
                    if (!t1) return o(new Error("Could not parse tile"));
                    const s = e.eb(t1, 1 / e.cc(i.tileID.canonical)), c = t1.json.extensionsUsed && t1.json.extensionsUsed.includes("MAPBOX_mesh_features") || t1.json.asset.extras && t1.json.asset.extras.MAPBOX_mesh_features, h = t1.json.extensionsUsed && t1.json.extensionsUsed.includes("EXT_meshopt_compression"), u = new e.a8(this.zoom, {
                        brightness: this.brightness
                    });
                    for(const t1 in a)for (const i of a[t1]){
                        const t1 = i[0];
                        l.bucketLayerIDs.push(i.map((t1)=>e.aC(t1.id, t1.scope))), t1.recalculate(u, []);
                        const o = new e.ec(i, s, r, c, h, this.brightness, l);
                        c || (o.needsUpload = !0), n.push(o), o.evaluate(t1);
                    }
                    this.status = "done", o(null, {
                        buckets: n,
                        featureIndex: l,
                        collisionBoxArray: null,
                        glyphAtlasImage: null,
                        lineAtlas: null,
                        imageAtlas: null,
                        brightness: null
                    });
                }).catch((e)=>o(new Error(e.message)));
            }
            constructor(t1, s){
                this.tileID = new e.aG(t1.tileID.overscaledZ, t1.tileID.wrap, t1.tileID.canonical.z, t1.tileID.canonical.x, t1.tileID.canonical.y), this.tileZoom = t1.tileZoom, this.uid = t1.uid, this.zoom = t1.zoom, this.canonical = t1.tileID.canonical, this.pixelRatio = t1.pixelRatio, this.tileSize = t1.tileSize, this.source = t1.source, this.overscaling = this.tileID.overscaleFactor(), this.projection = t1.projection, this.brightness = s;
            }
        }
        class Ce {
            loadTile(t1, s) {
                const i = t1.uid, o = this.loading[i] = new _e(t1, this.brightness);
                e.bi(t1.request, (e, r)=>{
                    const n = !this.loading[i];
                    return delete this.loading[i], n || e ? (o.status = "done", n || (this.loaded[i] = o), s(e)) : r && 0 !== r.byteLength ? void o.parse(r, this.layerIndex, t1, (e, t1)=>{
                        o.status = "done", this.loaded = this.loaded || {}, this.loaded[i] = o, e || !t1 ? s(e) : s(null, t1);
                    }) : (o.status = "done", this.loaded[i] = o, s());
                });
            }
            reloadTile(e, t1) {
                const s = this.loaded, i = e.uid;
                if (s && s[i]) {
                    const o = s[i];
                    o.projection = e.projection, o.brightness = e.brightness;
                    const r = (s, i)=>{
                        o.reloadCallback && (delete o.reloadCallback, this.loadTile(e, t1)), t1(s, i);
                    };
                    "parsing" === o.status ? o.reloadCallback = r : "done" === o.status && this.loadTile(e, t1);
                }
            }
            abortTile(e, t1) {
                const s = e.uid;
                this.loading[s] && delete this.loading[s], t1();
            }
            removeTile(e, t1) {
                const s = this.loaded, i = e.uid;
                s && s[i] && delete s[i], t1();
            }
            constructor(e, t1, s, i, o, r){
                this.actor = e, this.layerIndex = t1, this.availableImages = s, this.brightness = r, this.loading = {}, this.loaded = {};
            }
        }
        class ze {
            clearCaches(e, t1, s) {
                delete this.layerIndexes[e], delete this.availableImages[e], delete this.workerSources[e], delete this.demWorkerSources[e], delete this.rasterArrayWorkerSource, s();
            }
            checkIfReady(e, t1, s) {
                s();
            }
            setReferrer(e, t1) {
                this.referrer = t1;
            }
            spriteLoaded(t1, { scope: s, isLoaded: i }) {
                if (this.isSpriteLoaded[t1] || (this.isSpriteLoaded[t1] = {}), this.isSpriteLoaded[t1][s] = i, this.workerSources[t1] && this.workerSources[t1][s]) for(const o in this.workerSources[t1][s]){
                    const r = this.workerSources[t1][s][o];
                    for(const t1 in r){
                        const s = r[t1];
                        s instanceof v && (s.isSpriteLoaded = i, s.fire(new e.z("isSpriteLoaded")));
                    }
                }
            }
            setImages(e, { scope: t1, images: s }, i) {
                if (this.availableImages[e] || (this.availableImages[e] = {}), this.availableImages[e][t1] = s, this.workerSources[e] && this.workerSources[e][t1]) {
                    for(const i in this.workerSources[e][t1]){
                        const o = this.workerSources[e][t1][i];
                        for(const e in o)o[e].availableImages = s;
                    }
                    i();
                } else i();
            }
            setProjection(t1, s) {
                this.projections[t1] = e.bP(s);
            }
            setBrightness(e, t1, s) {
                this.brightness = t1, s();
            }
            setLayers(e, t1, s) {
                this.getLayerIndex(e, t1.scope).replace(t1.layers, t1.options), s();
            }
            updateLayers(e, t1, s) {
                this.getLayerIndex(e, t1.scope).update(t1.layers, t1.removedIds, t1.options), s();
            }
            loadTile(e, t1, s) {
                t1.projection = this.projections[e] || this.defaultProjection, this.getWorkerSource(e, t1.type, t1.source, t1.scope).loadTile(t1, s);
            }
            loadDEMTile(e, t1, s) {
                this.getDEMWorkerSource(e, t1.source, t1.scope).loadTile(t1, s);
            }
            decodeRasterArray(e, t1, s) {
                this.getRasterArrayWorkerSource().decodeRasterArray(t1, s);
            }
            reloadTile(e, t1, s) {
                t1.projection = this.projections[e] || this.defaultProjection, this.getWorkerSource(e, t1.type, t1.source, t1.scope).reloadTile(t1, s);
            }
            abortTile(e, t1, s) {
                this.getWorkerSource(e, t1.type, t1.source, t1.scope).abortTile(t1, s);
            }
            removeTile(e, t1, s) {
                this.getWorkerSource(e, t1.type, t1.source, t1.scope).removeTile(t1, s);
            }
            removeSource(e, t1, s) {
                if (!(this.workerSources[e] && this.workerSources[e][t1.scope] && this.workerSources[e][t1.scope][t1.type] && this.workerSources[e][t1.scope][t1.type][t1.source])) return;
                const i = this.workerSources[e][t1.scope][t1.type][t1.source];
                delete this.workerSources[e][t1.scope][t1.type][t1.source], void 0 !== i.removeSource ? i.removeSource(t1, s) : s();
            }
            loadWorkerSource(e, t1, s) {
                try {
                    this.self.importScripts(t1.url), s();
                } catch (e) {
                    s(e.toString());
                }
            }
            syncRTLPluginState(t1, s, i) {
                try {
                    e.ee.setState(s);
                    const t1 = e.ee.getPluginURL();
                    if (e.ee.isLoaded() && !e.ee.isParsed() && null != t1) {
                        this.self.importScripts(t1);
                        const s = e.ee.isParsed();
                        i(s ? void 0 : new Error(`RTL Text Plugin failed to import scripts from ${t1}`), s);
                    }
                } catch (e) {
                    i(e.toString());
                }
            }
            setDracoUrl(e, t1) {
                this.dracoUrl = t1;
            }
            getAvailableImages(e, t1) {
                this.availableImages[e] || (this.availableImages[e] = {});
                let s = this.availableImages[e][t1];
                return s || (s = []), s;
            }
            getLayerIndex(e, t1) {
                this.layerIndexes[e] || (this.layerIndexes[e] = {});
                let s = this.layerIndexes[e][t1];
                return s || (s = this.layerIndexes[e][t1] = new o, s.scope = t1), s;
            }
            getWorkerSource(e, t1, s, i) {
                return this.workerSources[e] || (this.workerSources[e] = {}), this.workerSources[e][i] || (this.workerSources[e][i] = {}), this.workerSources[e][i][t1] || (this.workerSources[e][i][t1] = {}), this.isSpriteLoaded[e] || (this.isSpriteLoaded[e] = {}), this.workerSources[e][i][t1][s] || (this.workerSources[e][i][t1][s] = new this.workerSourceTypes[t1]({
                    send: (t1, s, i, o, r, n)=>{
                        this.actor.send(t1, s, i, e, r, n);
                    },
                    scheduler: this.actor.scheduler
                }, this.getLayerIndex(e, i), this.getAvailableImages(e, i), this.isSpriteLoaded[e][i], void 0, this.brightness)), this.workerSources[e][i][t1][s];
            }
            rasterizeImages(e, t1, s) {
                const { imageTasks: i, scope: o } = t1, r = {};
                for(const t1 in i){
                    const { image: s, imageIdWithOptions: n } = i[t1];
                    r[t1] = this.imageRasterizer.rasterize(n, s, o, e);
                }
                s(void 0, r);
            }
            removeRasterizedImages(e, t1, s) {
                const { imageIds: i, scope: o } = t1;
                this.imageRasterizer.removeImagesFromCacheByIds(i, o, e), s();
            }
            getDEMWorkerSource(e, t1, s) {
                return this.demWorkerSources[e] || (this.demWorkerSources[e] = {}), this.demWorkerSources[e][s] || (this.demWorkerSources[e][s] = {}), this.demWorkerSources[e][s][t1] || (this.demWorkerSources[e][s][t1] = new b), this.demWorkerSources[e][s][t1];
            }
            getRasterArrayWorkerSource() {
                return this.rasterArrayWorkerSource || (this.rasterArrayWorkerSource = new x), this.rasterArrayWorkerSource;
            }
            enforceCacheSizeLimit(t1, s) {
                e.ef(s);
            }
            getWorkerPerformanceMetrics(e, t1, s) {
                s(void 0, void 0);
            }
            constructor(t1){
                this.self = t1, this.actor = new e.ed(t1, this), this.layerIndexes = {}, this.availableImages = {}, this.isSpriteLoaded = {}, this.imageRasterizer = new e.I, this.projections = {}, this.defaultProjection = e.bP({
                    name: "mercator"
                }), this.workerSourceTypes = {
                    vector: v,
                    geojson: ke,
                    "batched-model": Ce
                }, this.workerSources = {}, this.demWorkerSources = {}, this.self.registerWorkerSource = (e, t1)=>{
                    if (this.workerSourceTypes[e]) throw new Error(`Worker source with name "${e}" already registered.`);
                    this.workerSourceTypes[e] = t1;
                }, this.self.registerRTLTextPlugin = (t1)=>{
                    if (e.ee.isParsed()) throw new Error("RTL text plugin already registered.");
                    e.ee.applyArabicShaping = t1.applyArabicShaping, e.ee.processBidirectionalText = t1.processBidirectionalText, e.ee.processStyledBidirectionalText = t1.processStyledBidirectionalText;
                };
            }
        }
        return "undefined" != typeof WorkerGlobalScope && "undefined" != typeof self && self instanceof WorkerGlobalScope && (self.worker = new ze(self)), ze;
    });
    define([
        "./shared"
    ], function(e) {
        var t1 = "3.10.0";
        const i = {
            create: "create",
            load: "load",
            fullLoad: "fullLoad"
        }, o = {
            mark (e) {
                performance.mark(e);
            },
            measure (e, t1, i) {
                performance.measure(e, t1, i);
            }
        };
        function s(t1) {
            const i = t1.name.split("?")[0];
            return e.a(i) && i.includes("mapbox-gl.js") ? "javascript" : e.a(i) && i.includes("mapbox-gl.css") ? "css" : e.b(i) ? "fontRange" : e.c(i) ? "sprite" : e.i(i) ? "style" : e.d(i) ? "tilejson" : "other";
        }
        var r, a = {}, n = function() {
            if (r) return a;
            function e(e) {
                return !t1(e);
            }
            function t1(t1) {
                var o;
                return "undefined" == typeof window || "undefined" == typeof document ? "not a browser" : function() {
                    if (!("Worker" in window && "Blob" in window && "URL" in window)) return !1;
                    var e, t1, i = new Blob([
                        ""
                    ], {
                        type: "text/javascript"
                    }), o = URL.createObjectURL(i);
                    try {
                        t1 = new Worker(o), e = !0;
                    } catch (t1) {
                        e = !1;
                    }
                    return t1 && t1.terminate(), URL.revokeObjectURL(o), e;
                }() ? function() {
                    var e = document.createElement("canvas");
                    e.width = e.height = 1;
                    var t1 = e.getContext("2d");
                    if (!t1) return !1;
                    var i = t1.getImageData(0, 0, 1, 1);
                    return i && i.width === e.width;
                }() ? (void 0 === i[o = t1 && t1.failIfMajorPerformanceCaveat] && (i[o] = function(t1) {
                    var i, o = function(t1) {
                        var i = document.createElement("canvas"), o = Object.create(e.webGLContextAttributes);
                        return o.failIfMajorPerformanceCaveat = t1, i.getContext("webgl2", o);
                    }(t1);
                    if (!o) return !1;
                    try {
                        i = o.createShader(o.VERTEX_SHADER);
                    } catch (e) {
                        return !1;
                    }
                    return !(!i || o.isContextLost()) && (o.shaderSource(i, "void main() {}"), o.compileShader(i), !0 === o.getShaderParameter(i, o.COMPILE_STATUS));
                }(o)), i[o] ? document.documentMode ? "insufficient ECMAScript 6 support" : void 0 : "insufficient WebGL2 support") : "insufficient Canvas/getImageData support" : "insufficient worker support";
            }
            r = 1, a.supported = e, a.notSupportedReason = t1;
            var i = {};
            return e.webGLContextAttributes = {
                antialias: !1,
                alpha: !0,
                stencil: !0,
                depth: !0
            }, a;
        }();
        function l(e, t1, i) {
            const o = document.createElement(e);
            return null != t1 && (o.className = t1), i && i.appendChild(o), o;
        }
        function c(e, t1, i) {
            const o = document.createElementNS("http://www.w3.org/2000/svg", e);
            for (const e of Object.keys(t1))o.setAttributeNS(null, e, String(t1[e]));
            return i && i.appendChild(o), o;
        }
        const h = "undefined" != typeof document ? document.documentElement && document.documentElement.style : null, u = h && void 0 !== h.userSelect ? "userSelect" : "WebkitUserSelect";
        let d;
        function _() {
            h && u && (d = h[u], h[u] = "none");
        }
        function p() {
            h && u && (h[u] = d);
        }
        function f(e) {
            e.preventDefault(), e.stopPropagation(), window.removeEventListener("click", f, !0);
        }
        function m() {
            window.addEventListener("click", f, !0), window.setTimeout(()=>{
                window.removeEventListener("click", f, !0);
            }, 0);
        }
        function g(e, t1) {
            const i = e.getBoundingClientRect();
            return x(e, i, t1);
        }
        function v(e, t1) {
            const i = e.getBoundingClientRect(), o = [];
            for(let s = 0; s < t1.length; s++)o.push(x(e, i, t1[s]));
            return o;
        }
        function y(e) {
            return /firefox/i.test(navigator.userAgent) && /macintosh/i.test(navigator.userAgent) && 2 === e.button && e.ctrlKey ? 0 : e.button;
        }
        function x(t1, i, o) {
            const s = t1.offsetWidth === i.width ? 1 : t1.offsetWidth / i.width;
            return new e.P((o.clientX - i.left) * s, (o.clientY - i.top) * s);
        }
        const b = "01", w = "NO_ACCESS_TOKEN";
        class T {
            _createSkuToken() {
                const e = function() {
                    let e = "";
                    for(let t1 = 0; t1 < 10; t1++)e += "0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ"[Math.floor(62 * Math.random())];
                    return {
                        token: [
                            "1",
                            b,
                            e
                        ].join(""),
                        tokenExpiresAt: Date.now() + 432e5
                    };
                }();
                this._skuToken = e.token, this._skuTokenExpiresAt = e.tokenExpiresAt;
            }
            _isSkuTokenExpired() {
                return Date.now() > this._skuTokenExpiresAt;
            }
            transformRequest(e, t1) {
                return this._transformRequestFn && this._transformRequestFn(e, t1) || {
                    url: e
                };
            }
            normalizeStyleURL(i, o) {
                if (!e.f(i)) return i;
                const s = S(i);
                return s.params.push(`sdk=js-${t1}`), s.path = `/styles/v1${s.path}`, this._makeAPIURL(s, this._customAccessToken || o);
            }
            normalizeGlyphsURL(t1, i) {
                if (!e.f(t1)) return t1;
                const o = S(t1);
                return o.path = `/fonts/v1${o.path}`, this._makeAPIURL(o, this._customAccessToken || i);
            }
            normalizeModelURL(t1, i) {
                if (!e.f(t1)) return t1;
                const o = S(t1);
                return o.path = `/models/v1${o.path}`, this._makeAPIURL(o, this._customAccessToken || i);
            }
            normalizeSourceURL(t1, i, o, s) {
                if (!e.f(t1)) return t1;
                const r = S(t1);
                return r.path = `/v4/${r.authority}.json`, r.params.push("secure"), o && r.params.push(`language=${o}`), s && r.params.push(`worldview=${s}`), this._makeAPIURL(r, this._customAccessToken || i);
            }
            normalizeIconsetURL(t1, i) {
                const o = S(t1);
                return e.f(t1) ? (o.path = `/styles/v1${o.path}/iconset.pbf`, this._makeAPIURL(o, this._customAccessToken || i)) : C(o);
            }
            normalizeSpriteURL(t1, i, o, s) {
                const r = S(t1);
                return e.f(t1) ? (r.path = `/styles/v1${r.path}/sprite${i}${o}`, this._makeAPIURL(r, this._customAccessToken || s)) : (r.path += `${i}${o}`, C(r));
            }
            normalizeTileURL(t1, i, o) {
                if (this._isSkuTokenExpired() && this._createSkuToken(), t1 && !e.f(t1)) return t1;
                const s = S(t1);
                s.path = s.path.replace(/(\.(png|jpg)\d*)(?=$)/, `${i || o && "raster" !== s.authority && 512 === o ? "@2x" : ""}${e.m.supported ? ".webp" : "$1"}`), "raster" === s.authority ? s.path = `/${e.e.RASTER_URL_PREFIX}${s.path}` : "rasterarrays" === s.authority ? s.path = `/${e.e.RASTERARRAYS_URL_PREFIX}${s.path}` : "3dtiles" === s.authority ? s.path = `/${e.e.TILES3D_URL_PREFIX}${s.path}` : (s.path = s.path.replace(/^.+\/v4\//, "/"), s.path = `/${e.e.TILE_URL_VERSION}${s.path}`);
                const r = this._customAccessToken || function(e) {
                    for (const t1 of e){
                        const e = t1.match(/^access_token=(.*)$/);
                        if (e) return e[1];
                    }
                    return null;
                }(s.params) || e.e.ACCESS_TOKEN;
                return e.e.REQUIRE_ACCESS_TOKEN && r && this._skuToken && s.params.push(`sku=${this._skuToken}`), this._makeAPIURL(s, r);
            }
            canonicalizeTileURL(t1, i) {
                const o = S(t1);
                if (!o.path.match(/^(\/v4\/|\/(raster|rasterarrays)\/v1\/)/) || !o.path.match(/\.[\w]+$/)) return t1;
                let s = "mapbox://";
                o.path.match(/^\/raster\/v1\//) ? s += `raster/${o.path.replace(`/${e.e.RASTER_URL_PREFIX}/`, "")}` : o.path.match(/^\/rasterarrays\/v1\//) ? s += `rasterarrays/${o.path.replace(`/${e.e.RASTERARRAYS_URL_PREFIX}/`, "")}` : s += `tiles/${o.path.replace(`/${e.e.TILE_URL_VERSION}/`, "")}`;
                let r = o.params;
                return i && (r = r.filter((e)=>!e.match(/^access_token=/))), r.length && (s += `?${r.join("&")}`), s;
            }
            canonicalizeTileset(t1, i) {
                const o = !!i && e.f(i), s = [];
                for (const i of t1.tiles || [])e.h(i) ? s.push(this.canonicalizeTileURL(i, o)) : s.push(i);
                return s;
            }
            _makeAPIURL(t1, i) {
                const o = "See https://docs.mapbox.com/api/overview/#access-tokens-and-token-scopes", s = S(e.e.API_URL);
                if (t1.protocol = s.protocol, t1.authority = s.authority, "http" === t1.protocol) {
                    const e = t1.params.indexOf("secure");
                    e >= 0 && t1.params.splice(e, 1);
                }
                if ("/" !== s.path && (t1.path = `${s.path}${t1.path}`), !e.e.REQUIRE_ACCESS_TOKEN) return C(t1);
                if (i = i || e.e.ACCESS_TOKEN, !this._silenceAuthErrors) {
                    if (!i) throw new Error(`An API access token is required to use Mapbox GL. ${o}`);
                    if ("s" === i[0]) throw new Error(`Use a public access token (pk.*) with Mapbox GL, not a secret access token (sk.*). ${o}`);
                }
                return t1.params = t1.params.filter((e)=>-1 === e.indexOf("access_token")), t1.params.push(`access_token=${i || ""}`), C(t1);
            }
            constructor(e, t1, i){
                this._transformRequestFn = e, this._customAccessToken = t1, this._silenceAuthErrors = !!i, this._createSkuToken();
            }
        }
        const E = /^(\w+):\/\/([^/?]*)(\/[^?]+)?\??(.+)?/;
        function S(e) {
            const t1 = e.match(E);
            if (!t1) throw new Error("Unable to parse URL object");
            return {
                protocol: t1[1],
                authority: t1[2],
                path: t1[3] || "/",
                params: t1[4] ? t1[4].split("&") : []
            };
        }
        function C(e) {
            const t1 = e.params.length ? `?${e.params.join("&")}` : "";
            return `${e.protocol}://${e.authority}${e.path}${t1}`;
        }
        const I = "mapbox.eventData";
        function R(t1) {
            if (!t1) return null;
            const i = t1.split(".");
            if (!i || 3 !== i.length) return null;
            try {
                return JSON.parse(e.j(i[1]));
            } catch (e) {
                return null;
            }
        }
        class D {
            getStorageKey(t1) {
                const i = R(e.e.ACCESS_TOKEN);
                let o = "";
                return o = i && i.u ? e.k(i.u) : e.e.ACCESS_TOKEN || "", t1 ? `${I}.${t1}:${o}` : `${I}:${o}`;
            }
            fetchEventData() {
                const t1 = e.s("localStorage"), i = this.getStorageKey(), o = this.getStorageKey("uuid");
                if (t1) try {
                    const e = localStorage.getItem(i);
                    e && (this.eventData = JSON.parse(e));
                    const t1 = localStorage.getItem(o);
                    t1 && (this.anonId = t1);
                } catch (t1) {
                    e.w("Unable to read from LocalStorage");
                }
            }
            saveEventData() {
                const t1 = e.s("localStorage"), i = this.getStorageKey(), o = this.getStorageKey("uuid"), s = this.anonId;
                if (t1 && s) try {
                    localStorage.setItem(o, s), Object.keys(this.eventData).length >= 1 && localStorage.setItem(i, JSON.stringify(this.eventData));
                } catch (t1) {
                    e.w("Unable to write to LocalStorage");
                }
            }
            processRequests(e) {}
            postEvent(t1, i, o, s) {
                if (!e.e.EVENTS_URL) return;
                const r = S(e.e.EVENTS_URL);
                r.params.push(`access_token=${s || e.e.ACCESS_TOKEN || ""}`);
                const a = {
                    event: this.type,
                    created: new Date(t1).toISOString()
                }, n = i ? e.l(a, i) : a, l = {
                    url: C(r),
                    headers: {
                        "Content-Type": "text/plain"
                    },
                    body: JSON.stringify([
                        n
                    ])
                };
                this.pendingRequest = e.p(l, (e)=>{
                    this.pendingRequest = null, o(e), this.saveEventData(), this.processRequests(s);
                });
            }
            queueRequest(e, t1) {
                this.queue.push(e), this.processRequests(t1);
            }
            constructor(e){
                this.type = e, this.anonId = null, this.eventData = {}, this.queue = [], this.pendingRequest = null;
            }
        }
        const L = new class extends D {
            postTurnstileEvent(t1, i) {
                e.e.EVENTS_URL && e.e.ACCESS_TOKEN && Array.isArray(t1) && t1.some((t1)=>e.f(t1) || e.h(t1)) && this.queueRequest(Date.now(), i);
            }
            processRequests(i) {
                if (this.pendingRequest || 0 === this.queue.length) return;
                this.anonId && this.eventData.lastSuccess && this.eventData.tokenU || this.fetchEventData();
                const o = R(e.e.ACCESS_TOKEN), s = o ? o.u : e.e.ACCESS_TOKEN;
                let r = s !== this.eventData.tokenU;
                e.v(this.anonId) || (this.anonId = e.u(), r = !0);
                const a = this.queue.shift();
                if (this.eventData.lastSuccess) {
                    const e = new Date(this.eventData.lastSuccess), t1 = new Date(a), i = (a - this.eventData.lastSuccess) / 864e5;
                    r = r || i >= 1 || i < -1 || e.getDate() !== t1.getDate();
                } else r = !0;
                r ? this.postEvent(a, {
                    sdkIdentifier: "mapbox-gl-js",
                    sdkVersion: t1,
                    skuId: b,
                    "enabled.telemetry": !1,
                    userId: this.anonId
                }, (e)=>{
                    e || (this.eventData.lastSuccess = a, this.eventData.tokenU = s);
                }, i) : this.processRequests();
            }
            constructor(e){
                super("appUserTurnstile"), this._customAccessToken = e;
            }
        }, A = L.postTurnstileEvent.bind(L), z = new class extends D {
            postMapLoadEvent(t1, i, o, s) {
                this.skuToken = i, this.errorCb = s, e.e.EVENTS_URL && (o || e.e.ACCESS_TOKEN ? this.queueRequest({
                    id: t1,
                    timestamp: Date.now()
                }, o) : this.errorCb(new Error(w)));
            }
            processRequests(i) {
                if (this.pendingRequest || 0 === this.queue.length) return;
                const { id: o, timestamp: s } = this.queue.shift();
                o && this.success[o] || (this.anonId || this.fetchEventData(), e.v(this.anonId) || (this.anonId = e.u()), this.postEvent(s, {
                    sdkIdentifier: "mapbox-gl-js",
                    sdkVersion: t1,
                    skuId: b,
                    skuToken: this.skuToken,
                    userId: this.anonId
                }, (e)=>{
                    e ? this.errorCb(e) : o && (this.success[o] = !0);
                }, i));
            }
            remove() {
                this.errorCb = null;
            }
            constructor(){
                super("map.load"), this.success = {}, this.skuToken = "";
            }
        }, P = z.postMapLoadEvent.bind(z), M = new class extends D {
            getMapInstanceId(t1) {
                let i = this.mapInstanceIdMap.get(t1);
                return i || (i = e.u(), this.mapInstanceIdMap.set(t1, i)), i;
            }
            getEventId(e) {
                const t1 = this.eventIdPerMapInstanceMap.get(e) || 0;
                return this.eventIdPerMapInstanceMap.set(e, t1 + 1), t1;
            }
            postStyleLoadEvent(t1, i) {
                const { map: o, style: s, importedStyles: r } = i;
                if (!e.e.EVENTS_URL || !t1 && !e.e.ACCESS_TOKEN) return;
                const a = this.getMapInstanceId(o), n = {
                    mapInstanceId: a,
                    eventId: this.getEventId(a),
                    style: s
                };
                r.length && (n.importedStyles = r), this.queueRequest({
                    timestamp: Date.now(),
                    payload: n
                }, t1);
            }
            processRequests(e) {
                if (this.pendingRequest || 0 === this.queue.length) return;
                const { timestamp: t1, payload: i } = this.queue.shift();
                this.postEvent(t1, i, ()=>{}, e);
            }
            constructor(){
                super("style.load"), this.eventIdPerMapInstanceMap = new Map, this.mapInstanceIdMap = new WeakMap;
            }
        }, O = M.postStyleLoadEvent.bind(M), F = new class extends D {
            postPerformanceEvent(t1, i) {
                e.e.EVENTS_URL && (t1 || e.e.ACCESS_TOKEN) && this.queueRequest({
                    timestamp: Date.now(),
                    performanceData: i
                }, t1);
            }
            processRequests(o) {
                if (this.pendingRequest || 0 === this.queue.length) return;
                const { timestamp: r, performanceData: a } = this.queue.shift(), n = function(o) {
                    const r = performance.getEntriesByType("resource"), a = performance.getEntriesByType("mark"), n = function(e) {
                        const t1 = {};
                        if (e) {
                            for(const i in e)if ("other" !== i) for (const o of e[i]){
                                const e = `${i}ResolveRangeMin`, s = `${i}ResolveRangeMax`, r = `${i}RequestCount`, a = `${i}RequestCachedCount`;
                                t1[e] = Math.min(t1[e] || 1 / 0, o.startTime), t1[s] = Math.max(t1[s] || -1 / 0, o.responseEnd);
                                const n = (e)=>{
                                    void 0 === t1[e] && (t1[e] = 0), ++t1[e];
                                };
                                void 0 !== o.transferSize && 0 === o.transferSize && n(a), n(r);
                            }
                        }
                        return t1;
                    }(function(e, t1) {
                        const i = {};
                        if (e) for (const o of e){
                            const e = t1(o);
                            void 0 === i[e] && (i[e] = []), i[e].push(o);
                        }
                        return i;
                    }(r, s)), l = window.devicePixelRatio, c = navigator.connection || navigator.mozConnection || navigator.webkitConnection, h = c ? c.effectiveType : void 0, u = {
                        counters: [],
                        metadata: [],
                        attributes: []
                    }, d = (e, t1, i)=>{
                        null != i && e.push({
                            name: t1,
                            value: i.toString()
                        });
                    };
                    for(const e in n)d(u.counters, e, n[e]);
                    if (o.interactionRange[0] !== 1 / 0 && o.interactionRange[1] !== -1 / 0 && (d(u.counters, "interactionRangeMin", o.interactionRange[0]), d(u.counters, "interactionRangeMax", o.interactionRange[1])), a) for (const e of Object.keys(i)){
                        const t1 = i[e], o = a.find((e)=>e.name === t1);
                        o && d(u.counters, t1, o.startTime);
                    }
                    return d(u.counters, "visibilityHidden", o.visibilityHidden), d(u.attributes, "style", function(t1) {
                        if (t1) for (const i of t1){
                            const t1 = i.name.split("?")[0];
                            if (e.i(t1)) {
                                const e = t1.split("/").slice(-2);
                                if (2 === e.length) return `mapbox://styles/${e[0]}/${e[1]}`;
                            }
                        }
                    }(r)), d(u.attributes, "terrainEnabled", o.terrainEnabled ? "true" : "false"), d(u.attributes, "fogEnabled", o.fogEnabled ? "true" : "false"), d(u.attributes, "projection", o.projection), d(u.attributes, "zoom", o.zoom), d(u.metadata, "devicePixelRatio", l), d(u.metadata, "connectionEffectiveType", h), d(u.metadata, "navigatorUserAgent", navigator.userAgent), d(u.metadata, "screenWidth", window.screen.width), d(u.metadata, "screenHeight", window.screen.height), d(u.metadata, "windowWidth", window.innerWidth), d(u.metadata, "windowHeight", window.innerHeight), d(u.metadata, "mapWidth", o.width / l), d(u.metadata, "mapHeight", o.height / l), d(u.metadata, "webglRenderer", o.renderer), d(u.metadata, "webglVendor", o.vendor), d(u.metadata, "sdkVersion", t1), d(u.metadata, "sdkIdentifier", "mapbox-gl-js"), u;
                }(a);
                for (const e of n.metadata);
                for (const e of n.counters);
                for (const e of n.attributes);
                this.postEvent(r, n, ()=>{}, o);
            }
            constructor(){
                super("gljs.performance");
            }
        }, k = F.postPerformanceEvent.bind(F), B = new class extends D {
            getSession(t1, i, o, s) {
                if (!e.e.API_URL || !e.e.SESSION_PATH) return;
                const r = S(e.e.API_URL + e.e.SESSION_PATH);
                r.params.push(`sku=${i || ""}`), r.params.push(`access_token=${s || e.e.ACCESS_TOKEN || ""}`);
                const a = {
                    url: C(r),
                    headers: {
                        "Content-Type": "text/plain"
                    }
                };
                this.pendingRequest = e.g(a, (e)=>{
                    this.pendingRequest = null, o(e), this.saveEventData(), this.processRequests(s);
                });
            }
            getSessionAPI(t1, i, o, s) {
                this.skuToken = i, this.errorCb = s, e.e.SESSION_PATH && e.e.API_URL && (o || e.e.ACCESS_TOKEN ? this.queueRequest({
                    id: t1,
                    timestamp: Date.now()
                }, o) : this.errorCb(new Error(w)));
            }
            processRequests(e) {
                if (this.pendingRequest || 0 === this.queue.length) return;
                const { id: t1, timestamp: i } = this.queue.shift();
                t1 && this.success[t1] || this.getSession(i, this.skuToken, (e)=>{
                    e ? this.errorCb(e) : t1 && (this.success[t1] = !0);
                }, e);
            }
            remove() {
                this.errorCb = null;
            }
            constructor(){
                super("map.auth"), this.success = {}, this.skuToken = "";
            }
        }, N = B.getSessionAPI.bind(B), U = new Set;
        function j(e, t1) {
            t1 ? U.add(e) : U.delete(e);
        }
        class G {
            isDirty() {
                return this._changed;
            }
            setDirty() {
                this._changed = !0;
            }
            getUpdatedSourceCaches() {
                return this._updatedSourceCaches;
            }
            updateSourceCache(e, t1) {
                this._updatedSourceCaches[e] = t1, this.setDirty();
            }
            discardSourceCacheUpdate(e) {
                delete this._updatedSourceCaches[e];
            }
            updateLayer(e) {
                const t1 = e.scope;
                this._updatedLayers[t1] = this._updatedLayers[t1] || new Set, this._updatedLayers[t1].add(e.id), this.setDirty();
            }
            removeLayer(e) {
                const t1 = e.scope;
                this._removedLayers[t1] = this._removedLayers[t1] || {}, this._updatedLayers[t1] = this._updatedLayers[t1] || new Set, this._removedLayers[t1][e.id] = e, this._updatedLayers[t1].delete(e.id), this._updatedPaintProps.delete(e.fqid), this.setDirty();
            }
            getRemovedLayer(e) {
                return this._removedLayers[e.scope] ? this._removedLayers[e.scope][e.id] : null;
            }
            discardLayerRemoval(e) {
                this._removedLayers[e.scope] && delete this._removedLayers[e.scope][e.id];
            }
            getLayerUpdatesByScope() {
                const e = {};
                for(const t1 in this._updatedLayers)e[t1] = e[t1] || {}, e[t1].updatedIds = Array.from(this._updatedLayers[t1].values());
                for(const t1 in this._removedLayers)e[t1] = e[t1] || {}, e[t1].removedIds = Object.keys(this._removedLayers[t1]);
                return e;
            }
            getUpdatedPaintProperties() {
                return this._updatedPaintProps;
            }
            updatePaintProperties(e) {
                this._updatedPaintProps.add(e.fqid), this.setDirty();
            }
            getUpdatedImages() {
                return Array.from(this._updatedImages.values());
            }
            updateImage(e) {
                this._updatedImages.add(e), this.setDirty();
            }
            resetUpdatedImages() {
                this._updatedImages.clear();
            }
            reset() {
                this._changed = !1, this._updatedLayers = {}, this._removedLayers = {}, this._updatedSourceCaches = {}, this._updatedPaintProps.clear(), this._updatedImages.clear();
            }
            constructor(){
                this._changed = !1, this._updatedLayers = {}, this._removedLayers = {}, this._updatedSourceCaches = {}, this._updatedPaintProps = new Set, this._updatedImages = new Set;
            }
        }
        function V(e) {
            const { userImage: t1 } = e;
            return !!(t1 && t1.render && t1.render()) && (e.data.replace(new Uint8Array(t1.data.buffer)), !0);
        }
        class q extends e.E {
            get imageRasterizer() {
                return this._imageRasterizer || (this._imageRasterizer = new e.I), this._imageRasterizer;
            }
            createScope(t1) {
                this.images[t1] = {}, this.loaded[t1] = !1, this.updatedImages[t1] = {}, this.patterns[t1] = {}, this.callbackDispatchedThisFrame[t1] = {}, this.atlasImage[t1] = new e.r({
                    width: 1,
                    height: 1
                });
            }
            isLoaded() {
                for(const e in this.loaded)if (!this.loaded[e]) return !1;
                return !0;
            }
            setLoaded(e, t1) {
                if (this.loaded[t1] !== e && (this.loaded[t1] = e, e)) {
                    for (const { ids: e, callback: i } of this.requestors)this._notify(e, t1, i);
                    this.requestors = [];
                }
            }
            hasImage(e, t1) {
                return !!this.getImage(e, t1);
            }
            getImage(e, t1) {
                return this.images[t1][e];
            }
            addImage(e, t1, i) {
                this._validate(e, i) && (this.images[t1][e] = i);
            }
            _validate(t1, i) {
                let o = !0;
                return this._validateStretch(i.stretchX, i.data && i.data.width) || (this.fire(new e.y(new Error(`Image "${t1}" has invalid "stretchX" value`))), o = !1), this._validateStretch(i.stretchY, i.data && i.data.height) || (this.fire(new e.y(new Error(`Image "${t1}" has invalid "stretchY" value`))), o = !1), this._validateContent(i.content, i) || (this.fire(new e.y(new Error(`Image "${t1}" has invalid "content" value`))), o = !1), o;
            }
            _validateStretch(e, t1) {
                if (!e) return !0;
                let i = 0;
                for (const o of e){
                    if (o[0] < i || o[1] < o[0] || t1 < o[1]) return !1;
                    i = o[1];
                }
                return !0;
            }
            _validateContent(e, t1) {
                if (!e) return !0;
                if (4 !== e.length) return !1;
                if (!t1.usvg) {
                    if (e[0] < 0 || t1.data.width < e[0]) return !1;
                    if (e[1] < 0 || t1.data.height < e[1]) return !1;
                    if (e[2] < 0 || t1.data.width < e[2]) return !1;
                    if (e[3] < 0 || t1.data.height < e[3]) return !1;
                }
                return !(e[2] < e[0] || e[3] < e[1]);
            }
            updateImage(e, t1, i) {
                i.version = this.images[t1][e].version + 1, this.images[t1][e] = i, this.updatedImages[t1][e] = !0, this.removeFromImageRasterizerCache(e, t1);
            }
            removeFromImageRasterizerCache(t1, i) {
                "raster" !== this.spriteFormat && (e.t() ? this.imageRasterizerDispatcher.getActor().send("removeRasterizedImages", {
                    imageIds: [
                        t1
                    ],
                    scope: i
                }) : this.imageRasterizer.removeImagesFromCacheByIds([
                    t1
                ], i));
            }
            removeImage(e, t1) {
                const i = this.images[t1][e];
                delete this.images[t1][e], delete this.patterns[t1][e], this.removeFromImageRasterizerCache(e, t1), i.userImage && i.userImage.onRemove && i.userImage.onRemove();
            }
            listImages(e) {
                return Object.keys(this.images[e]);
            }
            getImages(e, t1, i) {
                let o = !0;
                const s = !!this.loaded[t1];
                if (!s) for (const i of e)this.images[t1][i] || (o = !1);
                s || o ? this._notify(e, t1, i) : this.requestors.push({
                    ids: e,
                    scope: t1,
                    callback: i
                });
            }
            rasterizeImages({ scope: t1, imageTasks: i }, o) {
                const s = {};
                for(const e in i){
                    const o = i[e], r = this.getImage(o.id, t1);
                    r && (s[e] = {
                        image: r,
                        imageIdWithOptions: o
                    });
                }
                e.t() ? this.imageRasterizerDispatcher.getActor().send("rasterizeImages", {
                    imageTasks: s,
                    scope: t1
                }, o) : this.rasterizeImagesInMainThread({
                    imageTasks: s,
                    scope: t1
                }, o);
            }
            rasterizeImagesInMainThread(e, t1) {
                const { imageTasks: i, scope: o } = e, s = {};
                for(const e in i){
                    const { image: t1, imageIdWithOptions: r } = i[e];
                    s[e] = this.imageRasterizer.rasterize(r, t1, o, "");
                }
                t1(void 0, s);
            }
            getUpdatedImages(e) {
                return this.updatedImages[e];
            }
            _notify(t1, i, o) {
                const s = {};
                for (const o of t1){
                    this.images[i][o] || this.fire(new e.z("styleimagemissing", {
                        id: o
                    }));
                    const t1 = this.images[i][o];
                    t1 ? s[o] = {
                        data: t1.usvg ? null : t1.data.clone(),
                        pixelRatio: t1.pixelRatio,
                        sdf: t1.sdf,
                        usvg: t1.usvg,
                        version: t1.version,
                        stretchX: t1.stretchX,
                        stretchY: t1.stretchY,
                        content: t1.content,
                        hasRenderCallback: Boolean(t1.userImage && t1.userImage.render)
                    } : e.w(`Image "${o}" could not be loaded. Please make sure you have added the image with map.addImage() or a "sprite" property in your style. You can provide missing images by listening for the "styleimagemissing" map event.`);
                }
                o(null, s);
            }
            getPixelSize(e) {
                const { width: t1, height: i } = this.atlasImage[e];
                return {
                    width: t1,
                    height: i
                };
            }
            getPattern(t1, i, o) {
                const s = this.patterns[i][t1], r = this.getImage(t1, i);
                if (!r) return null;
                if (s && s.position.version === r.version) return s.position;
                if (s) s.position.version = r.version;
                else {
                    r.usvg && !r.data && (r.data = this.imageRasterizer.rasterize(e.A.from(t1).getPrimary(), r, i, ""));
                    const o = {
                        w: r.data.width + 2 * e.B,
                        h: r.data.height + 2 * e.B,
                        x: 0,
                        y: 0
                    }, s = new e.C(o, r, e.B);
                    this.patterns[i][t1] = {
                        bin: o,
                        position: s
                    };
                }
                return this._updatePatternAtlas(i, o), this.patterns[i][t1].position;
            }
            bind(t1, i) {
                const o = t1.gl;
                let s = this.atlasTexture[i];
                s ? this.dirty && (s.update(this.atlasImage[i]), this.dirty = !1) : (s = new e.T(t1, this.atlasImage[i], o.RGBA8), this.atlasTexture[i] = s), s.bind(o.LINEAR, o.CLAMP_TO_EDGE);
            }
            _updatePatternAtlas(t1, i) {
                const o = [];
                for(const e in this.patterns[t1])o.push(this.patterns[t1][e].bin);
                const { w: s, h: r } = e.F(o), a = this.atlasImage[t1];
                a.resize({
                    width: s || 1,
                    height: r || 1
                });
                for(const o in this.patterns[t1]){
                    const { bin: s, position: r } = this.patterns[t1][o];
                    let n = r.padding;
                    const l = s.x + n, c = s.y + n, h = this.images[t1][o].data, u = h.width, d = h.height;
                    n = n > 1 ? n - 1 : n, e.r.copy(h, a, {
                        x: 0,
                        y: 0
                    }, {
                        x: l,
                        y: c
                    }, {
                        width: u,
                        height: d
                    }, i), e.r.copy(h, a, {
                        x: 0,
                        y: d - n
                    }, {
                        x: l,
                        y: c - n
                    }, {
                        width: u,
                        height: n
                    }, i), e.r.copy(h, a, {
                        x: 0,
                        y: 0
                    }, {
                        x: l,
                        y: c + d
                    }, {
                        width: u,
                        height: n
                    }, i), e.r.copy(h, a, {
                        x: u - n,
                        y: 0
                    }, {
                        x: l - n,
                        y: c
                    }, {
                        width: n,
                        height: d
                    }, i), e.r.copy(h, a, {
                        x: 0,
                        y: 0
                    }, {
                        x: l + u,
                        y: c
                    }, {
                        width: n,
                        height: d
                    }, i), e.r.copy(h, a, {
                        x: u - n,
                        y: d - n
                    }, {
                        x: l - n,
                        y: c - n
                    }, {
                        width: n,
                        height: n
                    }, i), e.r.copy(h, a, {
                        x: 0,
                        y: d - n
                    }, {
                        x: l + u,
                        y: c - n
                    }, {
                        width: n,
                        height: n
                    }, i), e.r.copy(h, a, {
                        x: 0,
                        y: 0
                    }, {
                        x: l + u,
                        y: c + d
                    }, {
                        width: n,
                        height: n
                    }, i), e.r.copy(h, a, {
                        x: u - n,
                        y: 0
                    }, {
                        x: l - n,
                        y: c + d
                    }, {
                        width: n,
                        height: n
                    }, i);
                }
                this.dirty = !0;
            }
            beginFrame() {
                for(const e in this.images)this.callbackDispatchedThisFrame[e] = {};
            }
            dispatchRenderCallbacks(e, t1) {
                for (const i of e){
                    if (this.callbackDispatchedThisFrame[t1][i]) continue;
                    this.callbackDispatchedThisFrame[t1][i] = !0;
                    const e = this.images[t1][i];
                    V(e) && this.updateImage(i, t1, e);
                }
            }
            constructor(t1){
                super(), this.images = {}, this.updatedImages = {}, this.callbackDispatchedThisFrame = {}, this.loaded = {}, this.requestors = [], this.patterns = {}, this.atlasImage = {}, this.atlasTexture = {}, this.dirty = !0, this.spriteFormat = t1, "raster" !== t1 && e.t() && (this.imageRasterizerDispatcher = new e.D(e.x(), this, "Image Rasterizer Worker", 1));
            }
        }
        function H(t1) {
            const i = t1.key, o = t1.value, s = t1.valueSpec || {}, r = t1.objectElementValidators || {}, a = t1.style, n = t1.styleSpec;
            let l = [];
            const c = e.H(o);
            if ("object" !== c) return [
                new e.V(i, o, `object expected, ${c} found`)
            ];
            for(const t1 in o){
                const c = t1.split(".")[0];
                let h;
                r[c] ? h = r[c] : s[c] ? h = _e : r["*"] ? h = r["*"] : s["*"] && (h = _e), h ? l = l.concat(h({
                    key: (i ? `${i}.` : i) + t1,
                    value: o[t1],
                    valueSpec: s[c] || s["*"],
                    style: a,
                    styleSpec: n,
                    object: o,
                    objectKey: t1
                }, o)) : l.push(new e.G(i, o[t1], `unknown property "${t1}"`));
            }
            for(const t1 in s)r[t1] || s[t1].required && void 0 === s[t1].default && void 0 === o[t1] && l.push(new e.V(i, o, `missing required property "${t1}"`));
            return l;
        }
        function Z(t1) {
            const i = t1.value, o = t1.valueSpec, s = t1.style, r = t1.styleSpec, a = t1.key, n = t1.arrayElementValidator || _e;
            if ("array" !== e.H(i)) return [
                new e.V(a, i, `array expected, ${e.H(i)} found`)
            ];
            if (o.length && i.length !== o.length) return [
                new e.V(a, i, `array length ${o.length} expected, length ${i.length} found`)
            ];
            if (o["min-length"] && i.length < o["min-length"]) return [
                new e.V(a, i, `array length at least ${o["min-length"]} expected, length ${i.length} found`)
            ];
            let l = {
                type: o.value,
                values: o.values,
                minimum: o.minimum,
                maximum: o.maximum,
                function: void 0
            };
            r.$version < 7 && (l.function = o.function), "object" === e.H(o.value) && (l = o.value);
            let c = [];
            for(let e = 0; e < i.length; e++)c = c.concat(n({
                array: i,
                arrayIndex: e,
                value: i[e],
                valueSpec: l,
                style: s,
                styleSpec: r,
                key: `${a}[${e}]`
            }, !0));
            return c;
        }
        function W(t1) {
            const i = t1.key, o = t1.value, s = t1.valueSpec;
            let r = e.H(o);
            if ("number" === r && o != o && (r = "NaN"), "number" !== r) return [
                new e.V(i, o, `number expected, ${r} found`)
            ];
            if ("minimum" in s) {
                let r = s.minimum;
                if ("array" === e.H(s.minimum) && (r = s.minimum[t1.arrayIndex]), o < r) return [
                    new e.V(i, o, `${o} is less than the minimum value ${r}`)
                ];
            }
            if ("maximum" in s) {
                let r = s.maximum;
                if ("array" === e.H(s.maximum) && (r = s.maximum[t1.arrayIndex]), o > r) return [
                    new e.V(i, o, `${o} is greater than the maximum value ${r}`)
                ];
            }
            return [];
        }
        function $(t1) {
            const i = t1.valueSpec, o = e.K(t1.value.type);
            let s, r, a, n = {};
            const l = "categorical" !== o && void 0 === t1.value.property, c = !l, h = "array" === e.H(t1.value.stops) && "array" === e.H(t1.value.stops[0]) && "object" === e.H(t1.value.stops[0][0]), u = H({
                key: t1.key,
                value: t1.value,
                valueSpec: t1.styleSpec.function,
                style: t1.style,
                styleSpec: t1.styleSpec,
                objectElementValidators: {
                    stops: function(t1) {
                        if ("identity" === o) return [
                            new e.V(t1.key, t1.value, 'identity function may not have a "stops" property')
                        ];
                        let i = [];
                        const s = t1.value;
                        return i = i.concat(Z({
                            key: t1.key,
                            value: s,
                            valueSpec: t1.valueSpec,
                            style: t1.style,
                            styleSpec: t1.styleSpec,
                            arrayElementValidator: d
                        })), "array" === e.H(s) && 0 === s.length && i.push(new e.V(t1.key, s, "array must have at least one stop")), i;
                    },
                    default: function(e) {
                        return _e({
                            key: e.key,
                            value: e.value,
                            valueSpec: i,
                            style: e.style,
                            styleSpec: e.styleSpec
                        });
                    }
                }
            });
            return "identity" === o && l && u.push(new e.V(t1.key, t1.value, 'missing required property "property"')), "identity" === o || t1.value.stops || u.push(new e.V(t1.key, t1.value, 'missing required property "stops"')), "exponential" === o && t1.valueSpec.expression && !e.L(t1.valueSpec) && u.push(new e.V(t1.key, t1.value, "exponential functions not supported")), t1.styleSpec.$version >= 8 && (c && !e.M(t1.valueSpec) ? u.push(new e.V(t1.key, t1.value, "property functions not supported")) : l && !e.N(t1.valueSpec) && u.push(new e.V(t1.key, t1.value, "zoom functions not supported"))), "categorical" !== o && !h || void 0 !== t1.value.property || u.push(new e.V(t1.key, t1.value, '"property" property is required')), u;
            function d(t1) {
                let o = [];
                const s = t1.value, l = t1.key;
                if ("array" !== e.H(s)) return [
                    new e.V(l, s, `array expected, ${e.H(s)} found`)
                ];
                if (2 !== s.length) return [
                    new e.V(l, s, `array length 2 expected, length ${s.length} found`)
                ];
                if (h) {
                    if ("object" !== e.H(s[0])) return [
                        new e.V(l, s, `object expected, ${e.H(s[0])} found`)
                    ];
                    if (void 0 === s[0].zoom) return [
                        new e.V(l, s, "object stop key must have zoom")
                    ];
                    if (void 0 === s[0].value) return [
                        new e.V(l, s, "object stop key must have value")
                    ];
                    const i = e.K(s[0].zoom);
                    if ("number" != typeof i) return [
                        new e.V(l, s[0].zoom, "stop zoom values must be numbers")
                    ];
                    if (a && a > i) return [
                        new e.V(l, s[0].zoom, "stop zoom values must appear in ascending order")
                    ];
                    i !== a && (a = i, r = void 0, n = {}), o = o.concat(H({
                        key: `${l}[0]`,
                        value: s[0],
                        valueSpec: {
                            zoom: {}
                        },
                        style: t1.style,
                        styleSpec: t1.styleSpec,
                        objectElementValidators: {
                            zoom: W,
                            value: _
                        }
                    }));
                } else o = o.concat(_({
                    key: `${l}[0]`,
                    value: s[0],
                    valueSpec: {},
                    style: t1.style,
                    styleSpec: t1.styleSpec
                }, s));
                return e.O(e.Q(s[1])) ? o.concat([
                    new e.V(`${l}[1]`, s[1], "expressions are not allowed in function stops.")
                ]) : o.concat(_e({
                    key: `${l}[1]`,
                    value: s[1],
                    valueSpec: i,
                    style: t1.style,
                    styleSpec: t1.styleSpec
                }));
            }
            function _(t1, a) {
                const l = e.H(t1.value), c = e.K(t1.value), h = null !== t1.value ? t1.value : a;
                if (s) {
                    if (l !== s) return [
                        new e.V(t1.key, h, `${l} stop domain type must match previous stop domain type ${s}`)
                    ];
                } else s = l;
                if ("number" !== l && "string" !== l && "boolean" !== l && "number" != typeof c && "string" != typeof c && "boolean" != typeof c) return [
                    new e.V(t1.key, h, "stop domain value must be a number, string, or boolean")
                ];
                if ("number" !== l && "categorical" !== o) {
                    let s = `number expected, ${l} found`;
                    return e.M(i) && void 0 === o && (s += '\nIf you intended to use a categorical function, specify `"type": "categorical"`.'), [
                        new e.V(t1.key, h, s)
                    ];
                }
                return "categorical" !== o || "number" !== l || "number" == typeof c && isFinite(c) && Math.floor(c) === c ? "categorical" !== o && "number" === l && "number" == typeof c && "number" == typeof r && void 0 !== r && c < r ? [
                    new e.V(t1.key, h, "stop domain values must appear in ascending order")
                ] : (r = c, "categorical" === o && c in n ? [
                    new e.V(t1.key, h, "stop domain values must be unique")
                ] : (n[c] = !0, [])) : [
                    new e.V(t1.key, h, `integer expected, found ${String(c)}`)
                ];
            }
        }
        function X(t1) {
            const i = ("property" === t1.expressionContext ? e.S : e.U)(e.Q(t1.value), t1.valueSpec);
            if ("error" === i.result) return i.value.map((i)=>new e.V(`${t1.key}${i.key}`, t1.value, i.message));
            const o = i.value.expression || i.value._styleExpression.expression;
            if ("property" === t1.expressionContext && "text-font" === t1.propertyKey && !o.outputDefined()) return [
                new e.V(t1.key, t1.value, `Invalid data expression for "${t1.propertyKey}". Output values must be contained as literals within the expression.`)
            ];
            if ("property" === t1.expressionContext && "layout" === t1.propertyType && !e.W(o)) return [
                new e.V(t1.key, t1.value, '"feature-state" data expressions are not supported with layout properties.')
            ];
            if ("filter" === t1.expressionContext) return K(o, t1);
            if (t1.expressionContext && 0 === t1.expressionContext.indexOf("cluster")) {
                if (!e.X(o, [
                    "zoom",
                    "feature-state"
                ])) return [
                    new e.V(t1.key, t1.value, '"zoom" and "feature-state" expressions are not supported with cluster properties.')
                ];
                if ("cluster-initial" === t1.expressionContext && !e.Y(o)) return [
                    new e.V(t1.key, t1.value, "Feature data expressions are not supported with initial expression part of cluster properties.")
                ];
            }
            return [];
        }
        function K(t1, i) {
            const o = new Set([
                "zoom",
                "feature-state",
                "pitch",
                "distance-from-center"
            ]);
            if (i.valueSpec && i.valueSpec.expression) for (const e of i.valueSpec.expression.parameters)o.delete(e);
            if (0 === o.size) return [];
            const s = [];
            return t1 instanceof e.Z && o.has(t1.name) ? [
                new e.V(i.key, i.value, `["${t1.name}"] expression is not supported in a filter for a ${i.object.type} layer with id: ${i.object.id}`)
            ] : (t1.eachChild((e)=>{
                s.push(...K(e, i));
            }), s);
        }
        function Y(t1) {
            const i = t1.key, o = t1.value, s = t1.valueSpec, r = [];
            return Array.isArray(s.values) ? -1 === s.values.indexOf(e.K(o)) && r.push(new e.V(i, o, `expected one of [${s.values.join(", ")}], ${JSON.stringify(o)} found`)) : -1 === Object.keys(s.values).indexOf(e.K(o)) && r.push(new e.V(i, o, `expected one of [${Object.keys(s.values).join(", ")}], ${JSON.stringify(o)} found`)), r;
        }
        function J(t1) {
            return e.$(e.Q(t1.value)) ? X(e.J({}, t1, {
                expressionContext: "filter",
                valueSpec: t1.styleSpec[`filter_${t1.layerType || "fill"}`]
            })) : Q(t1);
        }
        function Q(t1) {
            const i = t1.value, o = t1.key;
            if ("array" !== e.H(i)) return [
                new e.V(o, i, `array expected, ${e.H(i)} found`)
            ];
            const s = t1.styleSpec;
            let r, a = [];
            if (i.length < 1) return [
                new e.V(o, i, "filter array must have at least 1 element")
            ];
            switch(a = a.concat(Y({
                key: `${o}[0]`,
                value: i[0],
                valueSpec: s.filter_operator,
                style: t1.style,
                styleSpec: t1.styleSpec
            })), e.K(i[0])){
                case "<":
                case "<=":
                case ">":
                case ">=":
                    i.length >= 2 && "$type" === e.K(i[1]) && a.push(new e.V(o, i, `"$type" cannot be use with operator "${i[0]}"`));
                case "==":
                case "!=":
                    3 !== i.length && a.push(new e.V(o, i, `filter array for operator "${i[0]}" must have 3 elements`));
                case "in":
                case "!in":
                    i.length >= 2 && (r = e.H(i[1]), "string" !== r && a.push(new e.V(`${o}[1]`, i[1], `string expected, ${r} found`)));
                    for(let n = 2; n < i.length; n++)r = e.H(i[n]), "$type" === e.K(i[1]) ? a = a.concat(Y({
                        key: `${o}[${n}]`,
                        value: i[n],
                        valueSpec: s.geometry_type,
                        style: t1.style,
                        styleSpec: t1.styleSpec
                    })) : "string" !== r && "number" !== r && "boolean" !== r && a.push(new e.V(`${o}[${n}]`, i[n], `string, number, or boolean expected, ${r} found`));
                    break;
                case "any":
                case "all":
                case "none":
                    for(let e = 1; e < i.length; e++)a = a.concat(Q({
                        key: `${o}[${e}]`,
                        value: i[e],
                        style: t1.style,
                        styleSpec: t1.styleSpec
                    }));
                    break;
                case "has":
                case "!has":
                    r = e.H(i[1]), 2 !== i.length ? a.push(new e.V(o, i, `filter array for "${i[0]}" operator must have 2 elements`)) : "string" !== r && a.push(new e.V(`${o}[1]`, i[1], `string expected, ${r} found`));
            }
            return a;
        }
        function ee(t1, i) {
            const o = t1.key, s = t1.style, r = t1.layer, a = t1.styleSpec, n = t1.value, l = t1.objectKey, c = a[`${i}_${t1.layerType}`];
            if (!c) return [];
            const h = l.match(/^(.*)-use-theme$/);
            if ("paint" === i && h && c[h[1]]) return e.O(n) ? [].concat(_e({
                key: t1.key,
                value: n,
                valueSpec: {
                    type: "string",
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom",
                            "feature"
                        ]
                    },
                    "property-type": "data-driven"
                },
                style: s,
                styleSpec: a,
                expressionContext: "property",
                propertyType: i,
                propertyKey: l
            })) : _e({
                key: o,
                value: n,
                valueSpec: {
                    type: "string"
                },
                style: s,
                styleSpec: a
            });
            const u = l.match(/^(.*)-transition$/);
            if ("paint" === i && u && c[u[1]] && c[u[1]].transition) return _e({
                key: o,
                value: n,
                valueSpec: a.transition,
                style: s,
                styleSpec: a
            });
            const d = t1.valueSpec || c[l];
            if (!d) return [
                new e.G(o, n, `unknown property "${l}"`)
            ];
            let _;
            if ("string" === e.H(n) && e.M(d) && !d.tokens && (_ = /^{([^}]+)}$/.exec(n))) {
                const t1 = `\`{ "type": "identity", "property": ${_ ? JSON.stringify(_[1]) : '"_"'} }\``;
                return [
                    new e.V(o, n, `"${l}" does not support interpolation syntax\nUse an identity property function instead: ${t1}.`)
                ];
            }
            const p = [];
            if ("symbol" === t1.layerType) "text-field" !== l || !s || s.glyphs || s.imports || p.push(new e.V(o, n, 'use of "text-field" requires a style "glyphs" property')), "text-font" === l && e.a0(e.Q(n)) && "identity" === e.K(n.type) && p.push(new e.V(o, n, '"text-font" does not support identity functions'));
            else if ("model" === t1.layerType && "paint" === i && r && r.layout && r.layout.hasOwnProperty("model-id") && e.M(d) && (e.a1(d) || e.N(d))) {
                const t1 = e.S(e.Q(n), d), i = t1.value.expression || t1.value._styleExpression.expression;
                i && !e.X(i, [
                    "measure-light"
                ]) && ("model-emissive-strength" === l && e.Y(i) && e.W(i) || p.push(new e.V(o, n, `${l} does not support measure-light expressions when the model layer source is vector tile or GeoJSON.`)));
            }
            return p.concat(_e({
                key: t1.key,
                value: n,
                valueSpec: d,
                style: s,
                styleSpec: a,
                expressionContext: "property",
                propertyType: i,
                propertyKey: l
            }));
        }
        function te(e) {
            return ee(e, "paint");
        }
        function ie(e) {
            return ee(e, "layout");
        }
        function oe(t1) {
            let i = [];
            const o = t1.value, s = t1.key, r = t1.style, a = t1.styleSpec;
            o.type || o.ref || i.push(new e.V(s, o, 'either "type" or "ref" is required'));
            let n = e.K(o.type);
            const l = e.K(o.ref);
            if (o.id) {
                const a = e.K(o.id);
                for(let n = 0; n < t1.arrayIndex; n++){
                    const t1 = r.layers[n];
                    e.K(t1.id) === a && i.push(new e.V(s, o.id, `duplicate layer id "${o.id}", previously used at line ${t1.id.__line__}`));
                }
            }
            if ("ref" in o) {
                let t1;
                [
                    "type",
                    "source",
                    "source-layer",
                    "filter",
                    "layout"
                ].forEach((t1)=>{
                    t1 in o && i.push(new e.V(s, o[t1], `"${t1}" is prohibited for ref layers`));
                }), r.layers.forEach((i)=>{
                    e.K(i.id) === l && (t1 = i);
                }), t1 ? t1.ref ? i.push(new e.V(s, o.ref, "ref cannot reference another ref layer")) : n = e.K(t1.type) : "string" == typeof l && i.push(new e.V(s, o.ref, `ref layer "${l}" not found`));
            } else if ("background" !== n && "sky" !== n && "slot" !== n) {
                if (o.source) {
                    const t1 = r.sources && r.sources[o.source], a = t1 && e.K(t1.type);
                    t1 ? "vector" === a && "raster" === n ? i.push(new e.V(s, o.source, `layer "${o.id}" requires a raster source`)) : "raster" === a && "raster" !== n ? i.push(new e.V(s, o.source, `layer "${o.id}" requires a vector source`)) : "vector" !== a || o["source-layer"] ? "raster-dem" === a && "hillshade" !== n ? i.push(new e.V(s, o.source, "raster-dem source can only be used with layer type 'hillshade'.")) : "raster-array" !== a || [
                        "raster",
                        "raster-particle"
                    ].includes(n) ? "line" !== n || !o.paint || !o.paint["line-gradient"] && !o.paint["line-trim-offset"] || "geojson" === a && t1.lineMetrics ? "raster-particle" === n && "raster-array" !== a && i.push(new e.V(s, o.source, `layer "${o.id}" requires a 'raster-array' source.`)) : i.push(new e.V(s, o, `layer "${o.id}" specifies a line-gradient, which requires a GeoJSON source with \`lineMetrics\` enabled.`)) : i.push(new e.V(s, o.source, "raster-array source can only be used with layer type 'raster'.")) : i.push(new e.V(s, o, `layer "${o.id}" must specify a "source-layer"`)) : i.push(new e.V(s, o.source, `source "${o.source}" not found`));
                } else i.push(new e.V(s, o, 'missing required property "source"'));
            }
            return i = i.concat(H({
                key: s,
                value: o,
                valueSpec: a.layer,
                style: t1.style,
                styleSpec: t1.styleSpec,
                objectElementValidators: {
                    "*": ()=>[],
                    type: ()=>_e({
                            key: `${s}.type`,
                            value: o.type,
                            valueSpec: a.layer.type,
                            style: t1.style,
                            styleSpec: t1.styleSpec,
                            object: o,
                            objectKey: "type"
                        }),
                    filter: (t1)=>J(e.J({
                            layerType: n
                        }, t1)),
                    layout: (t1)=>H({
                            layer: o,
                            key: t1.key,
                            value: t1.value,
                            valueSpec: {},
                            style: t1.style,
                            styleSpec: t1.styleSpec,
                            objectElementValidators: {
                                "*": (t1)=>ie(e.J({
                                        layerType: n
                                    }, t1))
                            }
                        }),
                    paint: (t1)=>H({
                            layer: o,
                            key: t1.key,
                            value: t1.value,
                            valueSpec: {},
                            style: t1.style,
                            styleSpec: t1.styleSpec,
                            objectElementValidators: {
                                "*": (t1)=>te(e.J({
                                        layerType: n,
                                        layer: o
                                    }, t1))
                            }
                        })
                }
            })), i;
        }
        function se(t1) {
            const i = t1.value, o = t1.key, s = e.H(i);
            return "string" !== s ? [
                new e.V(o, i, `string expected, ${s} found`)
            ] : [];
        }
        const re = {
            promoteId: function t1({ key: i, value: o }) {
                if ("string" === e.H(o)) return se({
                    key: i,
                    value: o
                });
                if (Array.isArray(o)) {
                    const t1 = [], s = e.Q(o), r = e.U(s);
                    return "error" === r.result && r.value.forEach((o)=>{
                        t1.push(new e.V(`${i}${o.key}`, null, `${o.message}`));
                    }), e.X(r.value.expression, [
                        "zoom",
                        "heatmap-density",
                        "line-progress",
                        "raster-value",
                        "sky-radial-progress",
                        "accumulated",
                        "is-supported-script",
                        "pitch",
                        "distance-from-center",
                        "measure-light",
                        "raster-particle-speed"
                    ]) || t1.push(new e.V(`${i}`, null, "promoteId expression should be only feature dependent")), t1;
                }
                {
                    const e = [];
                    for(const s in o)e.push(...t1({
                        key: `${i}.${s}`,
                        value: o[s]
                    }));
                    return e;
                }
            }
        };
        function ae(t1) {
            const i = t1.value, o = t1.key, s = t1.styleSpec, r = t1.style;
            if (!i.type) return [
                new e.V(o, i, '"type" is required')
            ];
            const a = e.K(i.type);
            let n = [];
            switch([
                "vector",
                "raster",
                "raster-dem",
                "raster-array"
            ].includes(a) && (i.url || i.tiles || n.push(new e.G(o, i, 'Either "url" or "tiles" is required.'))), a){
                case "vector":
                case "raster":
                case "raster-dem":
                case "raster-array":
                    return n = n.concat(H({
                        key: o,
                        value: i,
                        valueSpec: s[`source_${a.replace("-", "_")}`],
                        style: t1.style,
                        styleSpec: s,
                        objectElementValidators: re
                    })), n;
                case "geojson":
                    if (n = H({
                        key: o,
                        value: i,
                        valueSpec: s.source_geojson,
                        style: r,
                        styleSpec: s,
                        objectElementValidators: re
                    }), i.cluster) for(const e in i.clusterProperties){
                        const [t1, s] = i.clusterProperties[e], r = "string" == typeof t1 ? [
                            t1,
                            [
                                "accumulated"
                            ],
                            [
                                "get",
                                e
                            ]
                        ] : t1;
                        n.push(...X({
                            key: `${o}.${e}.map`,
                            value: s,
                            expressionContext: "cluster-map"
                        })), n.push(...X({
                            key: `${o}.${e}.reduce`,
                            value: r,
                            expressionContext: "cluster-reduce"
                        }));
                    }
                    return n;
                case "video":
                    return H({
                        key: o,
                        value: i,
                        valueSpec: s.source_video,
                        style: r,
                        styleSpec: s
                    });
                case "image":
                    return H({
                        key: o,
                        value: i,
                        valueSpec: s.source_image,
                        style: r,
                        styleSpec: s
                    });
                case "canvas":
                    return [
                        new e.V(o, null, "Please use runtime APIs to add canvas sources, rather than including them in stylesheets.", "source.canvas")
                    ];
                default:
                    return Y({
                        key: `${o}.type`,
                        value: i.type,
                        valueSpec: {
                            values: ne(s)
                        },
                        style: r,
                        styleSpec: s
                    });
            }
        }
        function ne(e) {
            return e.source.reduce((t1, i)=>{
                const o = e[i];
                return "enum" === o.type.type && (t1 = t1.concat(Object.keys(o.type.values))), t1;
            }, []);
        }
        function le(t1) {
            const i = t1.value, o = t1.styleSpec, s = o.light, r = t1.style;
            let a = [];
            const n = e.H(i);
            if (void 0 === i) return a;
            if ("object" !== n) return a = a.concat([
                new e.V("light", i, `object expected, ${n} found`)
            ]), a;
            for(const t1 in i){
                const n = t1.match(/^(.*)-transition$/), l = t1.match(/^(.*)-use-theme$/);
                a = a.concat(l && s[l[1]] ? _e({
                    key: t1,
                    value: i[t1],
                    valueSpec: {
                        type: "string"
                    },
                    style: r,
                    styleSpec: o
                }) : n && s[n[1]] && s[n[1]].transition ? _e({
                    key: t1,
                    value: i[t1],
                    valueSpec: o.transition,
                    style: r,
                    styleSpec: o
                }) : s[t1] ? _e({
                    key: t1,
                    value: i[t1],
                    valueSpec: s[t1],
                    style: r,
                    styleSpec: o
                }) : [
                    new e.V(t1, i[t1], `unknown property "${t1}"`)
                ]);
            }
            return a;
        }
        function ce(t1) {
            const i = t1.value;
            let o = [];
            if (!i) return o;
            const s = e.H(i);
            if ("object" !== s) return o = o.concat([
                new e.V("light-3d", i, `object expected, ${s} found`)
            ]), o;
            const r = t1.styleSpec, a = r["light-3d"], n = t1.key, l = t1.style, c = t1.style.lights;
            for (const t1 of [
                "type",
                "id"
            ])if (!(t1 in i)) return o = o.concat([
                new e.V("light-3d", i, `missing property ${t1} on light`)
            ]), o;
            if (i.type && c) for(let s = 0; s < t1.arrayIndex; s++){
                const t1 = e.K(i.type), r = c[s];
                e.K(r.type) === t1 && o.push(new e.V(n, i.id, `duplicate light type "${i.type}", previously defined at line ${r.id.__line__}`));
            }
            const h = `properties_light_${i.type}`;
            if (!(h in r)) return o = o.concat([
                new e.V("light-3d", i, `Invalid light type ${i.type}`)
            ]), o;
            const u = r[h];
            for(const s in i)if ("properties" === s) {
                const a = i[s], n = e.H(a);
                if ("object" !== n) return o = o.concat([
                    new e.V("properties", a, `object expected, ${n} found`)
                ]), o;
                for(const i in a)o = o.concat(u[i] ? _e({
                    key: i,
                    value: a[i],
                    valueSpec: u[i],
                    style: l,
                    styleSpec: r
                }) : [
                    new e.G(t1.key, a[i], `unknown property "${i}"`)
                ]);
            } else {
                const t1 = s.match(/^(.*)-transition$/), n = s.match(/^(.*)-use-theme$/);
                o = o.concat(n && a[n[1]] ? _e({
                    key: s,
                    value: i[s],
                    valueSpec: {
                        type: "string"
                    },
                    style: l,
                    styleSpec: r
                }) : t1 && a[t1[1]] && a[t1[1]].transition ? _e({
                    key: s,
                    value: i[s],
                    valueSpec: r.transition,
                    style: l,
                    styleSpec: r
                }) : a[s] ? _e({
                    key: s,
                    value: i[s],
                    valueSpec: a[s],
                    style: l,
                    styleSpec: r
                }) : [
                    new e.G(s, i[s], `unknown property "${s}"`)
                ]);
            }
            return o;
        }
        function he(t1) {
            const i = t1.value, o = t1.key, s = t1.style, r = t1.styleSpec, a = r.terrain;
            let n = [];
            const l = e.H(i);
            if (void 0 === i) return n;
            if ("null" === l) return n;
            if ("object" !== l) return n = n.concat([
                new e.V("terrain", i, `object expected, ${l} found`)
            ]), n;
            for(const t1 in i){
                const o = t1.match(/^(.*)-transition$/), l = t1.match(/^(.*)-use-theme$/);
                n = n.concat(l && a[l[1]] ? _e({
                    key: t1,
                    value: i[t1],
                    valueSpec: {
                        type: "string"
                    },
                    style: s,
                    styleSpec: r
                }) : o && a[o[1]] && a[o[1]].transition ? _e({
                    key: t1,
                    value: i[t1],
                    valueSpec: r.transition,
                    style: s,
                    styleSpec: r
                }) : a[t1] ? _e({
                    key: t1,
                    value: i[t1],
                    valueSpec: a[t1],
                    style: s,
                    styleSpec: r
                }) : [
                    new e.G(t1, i[t1], `unknown property "${t1}"`)
                ]);
            }
            if (i.source) {
                const t1 = s.sources && s.sources[i.source], r = t1 && e.K(t1.type);
                t1 ? "raster-dem" !== r && n.push(new e.V(o, i.source, `terrain cannot be used with a source of type ${String(r)}, it only be used with a "raster-dem" source type`)) : n.push(new e.V(o, i.source, `source "${i.source}" not found`));
            } else n.push(new e.V(o, i, 'terrain is missing required property "source"'));
            return n;
        }
        function ue(t1) {
            const i = t1.value, o = t1.style, s = t1.styleSpec, r = s.fog;
            let a = [];
            const n = e.H(i);
            if (void 0 === i) return a;
            if ("object" !== n) return a = a.concat([
                new e.V("fog", i, `object expected, ${n} found`)
            ]), a;
            for(const t1 in i){
                const n = t1.match(/^(.*)-transition$/), l = t1.match(/^(.*)-use-theme$/);
                a = a.concat(l && r[l[1]] ? _e({
                    key: t1,
                    value: i[t1],
                    valueSpec: {
                        type: "string"
                    },
                    style: o,
                    styleSpec: s
                }) : n && r[n[1]] && r[n[1]].transition ? _e({
                    key: t1,
                    value: i[t1],
                    valueSpec: s.transition,
                    style: o,
                    styleSpec: s
                }) : r[t1] ? _e({
                    key: t1,
                    value: i[t1],
                    valueSpec: r[t1],
                    style: o,
                    styleSpec: s
                }) : [
                    new e.G(t1, i[t1], `unknown property "${t1}"`)
                ]);
            }
            return a;
        }
        const de = {
            "*": ()=>[],
            array: Z,
            boolean: function(t1) {
                const i = t1.value, o = t1.key, s = e.H(i);
                return "boolean" !== s ? [
                    new e.V(o, i, `boolean expected, ${s} found`)
                ] : [];
            },
            number: W,
            color: function(t1) {
                const i = t1.key, o = t1.value, s = e.H(o);
                return "string" !== s ? [
                    new e.V(i, o, `color expected, ${s} found`)
                ] : null === e._.parseCSSColor(o) ? [
                    new e.V(i, o, `color expected, "${o}" found`)
                ] : [];
            },
            enum: Y,
            filter: J,
            function: $,
            layer: oe,
            object: H,
            source: ae,
            model: e.a2,
            light: le,
            "light-3d": ce,
            terrain: he,
            fog: ue,
            string: se,
            formatted: function(e) {
                return 0 === se(e).length ? [] : X(e);
            },
            resolvedImage: function(e) {
                return 0 === se(e).length ? [] : X(e);
            },
            projection: function(t1) {
                const i = t1.value, o = t1.styleSpec, s = o.projection, r = t1.style;
                let a = [];
                const n = e.H(i);
                if ("object" === n) for(const e in i)a = a.concat(_e({
                    key: e,
                    value: i[e],
                    valueSpec: s[e],
                    style: r,
                    styleSpec: o
                }));
                else "string" !== n && (a = a.concat([
                    new e.V("projection", i, `object or string expected, ${n} found`)
                ]));
                return a;
            },
            import: function(t1) {
                const { value: i, styleSpec: o } = t1, { data: s, ...r } = i;
                Object.defineProperty(r, "__line__", {
                    value: i.__line__,
                    enumerable: !1
                });
                let a = H(e.J({}, t1, {
                    value: r,
                    valueSpec: o.import
                }));
                return "" === e.K(r.id) && a.push(new e.V(`${t1.key}.id`, r, "import id can't be an empty string")), s && (a = a.concat(fe(s, o, {
                    key: `${t1.key}.data`
                }))), a;
            }
        };
        function _e(t1, i = !1) {
            const o = t1.value, s = t1.valueSpec, r = t1.styleSpec;
            if (s.expression && e.a0(e.K(o))) return $(t1);
            if (s.expression && e.O(e.Q(o))) return X(t1);
            if (s.type && de[s.type]) {
                const o = de[s.type](t1);
                return !0 === i && o.length > 0 && "array" === e.H(t1.value) ? X(t1) : o;
            }
            return H(e.J({}, t1, {
                valueSpec: s.type ? r[s.type] : s
            }));
        }
        function pe(t1) {
            const i = t1.value, o = t1.key, s = se(t1);
            return s.length || (-1 === i.indexOf("{fontstack}") && s.push(new e.V(o, i, '"glyphs" url must include a "{fontstack}" token')), -1 === i.indexOf("{range}") && s.push(new e.V(o, i, '"glyphs" url must include a "{range}" token'))), s;
        }
        function fe(t1, i = e.a3, o = {}) {
            return _e({
                key: o.key || "",
                value: t1,
                valueSpec: i.$root,
                styleSpec: i,
                style: t1,
                objectElementValidators: {
                    glyphs: pe,
                    "*": ()=>[]
                }
            });
        }
        function me(t1, i = e.a3) {
            return De(fe(t1, i));
        }
        const ge = (e)=>De(ae(e)), ve = (e)=>De(le(e)), ye = (e)=>De(ce(e)), xe = (e)=>De(he(e)), be = (e)=>De(ue(e)), we = (t1)=>De(function(t1) {
                const i = t1.value, o = t1.style, s = t1.styleSpec, r = s.snow;
                let a = [];
                const n = e.H(i);
                if (void 0 === i) return a;
                if ("object" !== n) return a = a.concat([
                    new e.V("snow", i, `object expected, ${n} found`)
                ]), a;
                for(const t1 in i){
                    const n = t1.match(/^(.*)-transition$/);
                    a = a.concat(n && r[n[1]] && r[n[1]].transition ? _e({
                        key: t1,
                        value: i[t1],
                        valueSpec: s.transition,
                        style: o,
                        styleSpec: s
                    }) : r[t1] ? _e({
                        key: t1,
                        value: i[t1],
                        valueSpec: r[t1],
                        style: o,
                        styleSpec: s
                    }) : [
                        new e.G(t1, i[t1], `unknown property "${t1}"`)
                    ]);
                }
                return a;
            }(t1)), Te = (t1)=>De(function(t1) {
                const i = t1.value, o = t1.style, s = t1.styleSpec, r = s.rain;
                let a = [];
                const n = e.H(i);
                if (void 0 === i) return a;
                if ("object" !== n) return a = a.concat([
                    new e.V("rain", i, `object expected, ${n} found`)
                ]), a;
                for(const t1 in i){
                    const n = t1.match(/^(.*)-transition$/);
                    a = a.concat(n && r[n[1]] && r[n[1]].transition ? _e({
                        key: t1,
                        value: i[t1],
                        valueSpec: s.transition,
                        style: o,
                        styleSpec: s
                    }) : r[t1] ? _e({
                        key: t1,
                        value: i[t1],
                        valueSpec: r[t1],
                        style: o,
                        styleSpec: s
                    }) : [
                        new e.G(t1, i[t1], `unknown property "${t1}"`)
                    ]);
                }
                return a;
            }(t1)), Ee = (e)=>De(oe(e)), Se = (e)=>De(J(e)), Ce = (e)=>De(te(e)), Ie = (e)=>De(ie(e)), Re = (t1)=>De(e.a2(t1));
        function De(e) {
            return e.slice().sort((e, t1)=>e.line && t1.line ? e.line - t1.line : 0);
        }
        function Le(t1, i) {
            let o = !1;
            if (i && i.length) for (const s of i)s instanceof e.G ? e.w(s.message) : (t1.fire(new e.y(new Error(s.message))), o = !0);
            return o;
        }
        let Ae;
        class ze extends e.E {
            getLight() {
                return this._transitionable.serialize();
            }
            setLight(e, t1, i = {}) {
                this._validate(ve, e, i) || (this._transitionable.setTransitionOrValue(e), this.id = t1);
            }
            updateTransitions(e) {
                this._transitioning = this._transitionable.transitioned(e, this._transitioning);
            }
            hasTransition() {
                return this._transitioning.hasTransition();
            }
            recalculate(e) {
                this.properties = this._transitioning.possiblyEvaluate(e);
            }
            _validate(t1, i, o) {
                return (!o || !1 !== o.validate) && Le(this, t1.call(me, e.l({
                    value: i,
                    style: {
                        glyphs: !0,
                        sprite: !0
                    },
                    styleSpec: e.a3
                })));
            }
            constructor(t1, i = "flat"){
                super(), this._transitionable = new e.a4(Ae || (Ae = new e.a5({
                    anchor: new e.a6(e.a3.light.anchor),
                    position: new e.a7(e.a3.light.position),
                    color: new e.a6(e.a3.light.color),
                    intensity: new e.a6(e.a3.light.intensity)
                }))), this.setLight(t1, i), this._transitioning = this._transitionable.untransitioned();
            }
        }
        let Pe = class extends e.E {
            get() {
                return this._transitionable.serialize();
            }
            set(e, t1) {
                this._transitionable.setTransitionOrValue(e, t1);
            }
            updateTransitions(e) {
                this._transitioning = this._transitionable.transitioned(e, this._transitioning);
            }
            hasTransition() {
                return this._transitioning.hasTransition();
            }
            recalculate(e) {
                this.properties = this._transitioning.possiblyEvaluate(e);
            }
            getExaggeration(t1) {
                return this._transitioning.possiblyEvaluate(new e.a8(t1)).get("exaggeration");
            }
            getAttenuationRange() {
                if (!this.isZoomDependent()) return null;
                const t1 = this._transitionable._values.exaggeration;
                if (!t1) return null;
                const i = t1.value.expression;
                if (!i) return null;
                let o = -1, s = -1, r = 1;
                for (const t1 of i.zoomStops)r = i.evaluate(new e.a8(t1)), r > .01 ? (o = t1, s = -1) : s = t1;
                return r < .01 && o > 0 && s > o ? [
                    o,
                    s
                ] : null;
            }
            isZoomDependent() {
                const t1 = this._transitionable._values.exaggeration;
                return null != t1 && null != t1.value && null != t1.value.expression && t1.value.expression instanceof e.a9;
            }
            constructor(t1, i, o, s){
                super(), this.scope = o, this._transitionable = new e.a4(new e.a5({
                    source: new e.a6(e.a3.terrain.source),
                    exaggeration: new e.a6(e.a3.terrain.exaggeration)
                }), o, s), this._transitionable.setTransitionOrValue(t1, s), this._transitioning = this._transitionable.untransitioned(), this.drapeRenderMode = i;
            }
        };
        const Me = 45, Oe = 65, Fe = .05;
        function ke(t1, i, o, s) {
            const r = e.ac(Me, Oe, o), [a, n] = Be(t1, s);
            let l = 1 - Math.min(1, Math.exp((i - a) / (n - a) * -6));
            return l *= l * l, l = Math.min(1, 1.00747 * l), l * r * t1.alpha;
        }
        function Be(e, t1) {
            const i = .5 / Math.tan(.5 * t1);
            return [
                e.range[0] + i,
                e.range[1] + i
            ];
        }
        function Ne(t1, i, o, s, r) {
            const a = e.ab.vec3.transformMat4([], [
                i,
                o,
                s
            ], r.mercatorFogMatrix);
            return ke(t1, e.ab.vec3.length(a), r.pitch, r._fov);
        }
        function Ue(t1, i, o, s, r, a, n) {
            const l = [
                [
                    o,
                    s,
                    0
                ],
                [
                    r,
                    s,
                    0
                ],
                [
                    r,
                    a,
                    0
                ],
                [
                    o,
                    a,
                    0
                ]
            ];
            let c = Number.MAX_VALUE, h = -Number.MAX_VALUE;
            for (const t1 of l){
                const o = e.ab.vec3.transformMat4([], t1, i), s = e.ab.vec3.length(o);
                c = Math.min(c, s), h = Math.max(h, s);
            }
            return [
                ke(t1, c, n.pitch, n._fov),
                ke(t1, h, n.pitch, n._fov)
            ];
        }
        class je extends e.E {
            get state() {
                const t1 = this._transform, i = "globe" === t1.projection.name, o = e.ae(t1.zoom), s = this.properties.get("range"), r = [
                    .5,
                    3
                ];
                return {
                    range: i ? [
                        e.af(r[0], s[0], o),
                        e.af(r[1], s[1], o)
                    ] : s,
                    horizonBlend: this.properties.get("horizon-blend"),
                    alpha: this.properties.get("color").a
                };
            }
            get() {
                return this._transitionable.serialize();
            }
            set(t1, i, o = {}) {
                if (this._validate(be, t1, o)) return;
                const s = e.l({}, t1);
                for (const t1 of Object.keys(e.a3.fog))void 0 === s[t1] && (s[t1] = e.a3.fog[t1].default);
                this._options = s, this._transitionable.setTransitionOrValue(this._options, i);
            }
            getOpacity(t1) {
                if (!this._transform.projection.supportsFog) return 0;
                const i = this.properties && this.properties.get("color") || 1;
                return ("globe" === this._transform.projection.name ? 1 : e.ac(Me, Oe, t1)) * i.a;
            }
            getOpacityAtLatLng(t1, i) {
                return this._transform.projection.supportsFog ? function(t1, i, o) {
                    const s = e.aa.fromLngLat(i), r = o.elevation ? o.elevation.getAtPointOrZero(s) : 0;
                    return Ne(t1, s.x, s.y, r, o);
                }(this.state, t1, i) : 0;
            }
            getOpacityForTile(t1) {
                if (!this._transform.projection.supportsFog) return [
                    1,
                    1
                ];
                const i = this._transform.calculateFogTileMatrix(t1.toUnwrapped());
                return Ue(this.state, i, 0, 0, e.ag, e.ag, this._transform);
            }
            getOpacityForBounds(e, t1, i, o, s) {
                return this._transform.projection.supportsFog ? Ue(this.state, e, t1, i, o, s, this._transform) : [
                    1,
                    1
                ];
            }
            getFovAdjustedRange(e) {
                return this._transform.projection.supportsFog ? Be(this.state, e) : [
                    0,
                    1
                ];
            }
            isVisibleOnFrustum(t1) {
                if (!this._transform.projection.supportsFog) return !1;
                const i = [
                    4,
                    5,
                    6,
                    7
                ];
                for (const o of i){
                    const i = t1.points[o];
                    let s;
                    if (i[2] >= 0) s = i;
                    else {
                        const r = t1.points[o - 4];
                        s = e.ah(r, i, r[2] / (r[2] - i[2]));
                    }
                    if (Ne(this.state, s[0], s[1], 0, this._transform) >= Fe) return !0;
                }
                return !1;
            }
            updateConfig(e) {
                this._transitionable.setTransitionOrValue(this._options, new Map(e));
            }
            updateTransitions(e) {
                this._transitioning = this._transitionable.transitioned(e, this._transitioning);
            }
            hasTransition() {
                return this._transitioning.hasTransition();
            }
            recalculate(e) {
                this.properties = this._transitioning.possiblyEvaluate(e);
            }
            _validate(t1, i, o) {
                return (!o || !1 !== o.validate) && Le(this, t1.call(me, e.l({
                    value: i,
                    style: {
                        glyphs: !0,
                        sprite: !0
                    },
                    styleSpec: e.a3
                })));
            }
            constructor(t1, i, o, s){
                super();
                const r = new e.a5({
                    range: new e.a6(e.a3.fog.range),
                    color: new e.a6(e.a3.fog.color),
                    "color-use-theme": new e.a6({
                        type: "string",
                        "property-type": "data-constant",
                        default: "default"
                    }),
                    "high-color": new e.a6(e.a3.fog["high-color"]),
                    "high-color-use-theme": new e.a6({
                        type: "string",
                        "property-type": "data-constant",
                        default: "default"
                    }),
                    "space-color": new e.a6(e.a3.fog["space-color"]),
                    "space-color-use-theme": new e.a6({
                        type: "string",
                        "property-type": "data-constant",
                        default: "default"
                    }),
                    "horizon-blend": new e.a6(e.a3.fog["horizon-blend"]),
                    "star-intensity": new e.a6(e.a3.fog["star-intensity"]),
                    "vertical-range": new e.a6(e.a3.fog["vertical-range"])
                });
                this._transitionable = new e.a4(r, o, new Map(s)), this.set(t1, s), this._transitioning = this._transitionable.untransitioned(), this._transform = i, this.properties = new e.ad(r), this.scope = o;
            }
        }
        let Ge, Ve, qe, He, Ze = class extends e.E {
            get state() {
                const t1 = this.properties.get("opacity"), i = this.properties.get("color"), o = this.properties.get("direction"), s = e.ai(o[0]), r = -Math.max(e.ai(o[1]), .01), a = [
                    Math.cos(s) * Math.cos(r),
                    Math.sin(s) * Math.cos(r),
                    Math.sin(r)
                ], n = this.properties.get("vignette"), l = this.properties.get("vignette-color");
                return l.a = n, {
                    density: this.properties.get("density"),
                    intensity: this.properties.get("intensity"),
                    color: new e.aj(i.r, i.g, i.b, i.a * t1),
                    direction: a,
                    centerThinning: this.properties.get("center-thinning"),
                    flakeSize: this.properties.get("flake-size"),
                    vignetteColor: l
                };
            }
            get() {
                return this._transitionable.serialize();
            }
            set(t1, i, o = {}) {
                if (this._validate(we, t1, o)) return;
                const s = e.l({}, t1);
                for (const t1 of Object.keys(e.a3.snow))void 0 === s[t1] && (s[t1] = e.a3.snow[t1].default);
                this._options = s, this._transitionable.setTransitionOrValue(this._options, i);
            }
            updateConfig(e) {
                this._transitionable.setTransitionOrValue(this._options, new Map(e));
            }
            updateTransitions(e) {
                this._transitioning = this._transitionable.transitioned(e, this._transitioning);
            }
            hasTransition() {
                return this._transitioning.hasTransition();
            }
            recalculate(e) {
                this.properties = this._transitioning.possiblyEvaluate(e);
            }
            _validate(t1, i, o) {
                return (!o || !1 !== o.validate) && Le(this, t1.call(me, e.l({
                    value: i,
                    style: {
                        glyphs: !0,
                        sprite: !0
                    },
                    styleSpec: e.a3
                })));
            }
            constructor(t1, i, o, s){
                super();
                const r = Ge || (Ge = new e.a5({
                    density: new e.a6(e.a3.snow.density),
                    intensity: new e.a6(e.a3.snow.intensity),
                    color: new e.a6(e.a3.snow.color),
                    opacity: new e.a6(e.a3.snow.opacity),
                    vignette: new e.a6(e.a3.snow.vignette),
                    "vignette-color": new e.a6(e.a3.snow["vignette-color"]),
                    "center-thinning": new e.a6(e.a3.snow["center-thinning"]),
                    direction: new e.a6(e.a3.snow.direction),
                    "flake-size": new e.a6(e.a3.snow["flake-size"])
                }));
                this._transitionable = new e.a4(r, o, new Map(s)), this.set(t1, s), this._transitioning = this._transitionable.untransitioned(), this.properties = new e.ad(r), this.scope = o;
            }
        }, We = class extends e.E {
            get state() {
                const t1 = this.properties.get("opacity"), i = this.properties.get("color"), o = this.properties.get("direction"), s = e.ai(o[0]), r = -Math.max(e.ai(o[1]), .01), a = [
                    Math.cos(s) * Math.cos(r),
                    Math.sin(s) * Math.cos(r),
                    Math.sin(r)
                ], n = this.properties.get("vignette-color");
                return n.a = this.properties.get("vignette"), {
                    density: this.properties.get("density"),
                    intensity: this.properties.get("intensity"),
                    color: new e.aj(i.r, i.g, i.b, i.a * t1),
                    direction: a,
                    centerThinning: this.properties.get("center-thinning"),
                    dropletSize: this.properties.get("droplet-size"),
                    distortionStrength: this.properties.get("distortion-strength"),
                    vignetteColor: n
                };
            }
            get() {
                return this._transitionable.serialize();
            }
            set(t1, i, o = {}) {
                if (this._validate(Te, t1, o)) return;
                const s = e.l({}, t1);
                for (const t1 of Object.keys(e.a3.rain))void 0 === s[t1] && (s[t1] = e.a3.rain[t1].default);
                this._options = s, this._transitionable.setTransitionOrValue(this._options, i);
            }
            updateConfig(e) {
                this._transitionable.setTransitionOrValue(this._options, new Map(e));
            }
            updateTransitions(e) {
                this._transitioning = this._transitionable.transitioned(e, this._transitioning);
            }
            hasTransition() {
                return this._transitioning.hasTransition();
            }
            recalculate(e) {
                this.properties = this._transitioning.possiblyEvaluate(e);
            }
            _validate(t1, i, o) {
                return (!o || !1 !== o.validate) && Le(this, t1.call(me, e.l({
                    value: i,
                    style: {
                        glyphs: !0,
                        sprite: !0
                    },
                    styleSpec: e.a3
                })));
            }
            constructor(t1, i, o, s){
                super();
                const r = Ve || (Ve = new e.a5({
                    density: new e.a6(e.a3.rain.density),
                    intensity: new e.a6(e.a3.rain.intensity),
                    color: new e.a6(e.a3.rain.color),
                    opacity: new e.a6(e.a3.rain.opacity),
                    vignette: new e.a6(e.a3.rain.vignette),
                    "vignette-color": new e.a6(e.a3.rain["vignette-color"]),
                    "center-thinning": new e.a6(e.a3.rain["center-thinning"]),
                    direction: new e.a6(e.a3.rain.direction),
                    "droplet-size": new e.a6(e.a3.rain["droplet-size"]),
                    "distortion-strength": new e.a6(e.a3.rain["distortion-strength"])
                }));
                this._transitionable = new e.a4(r, o, new Map(s)), this.set(t1, s), this._transitioning = this._transitionable.untransitioned(), this.properties = new e.ad(r), this.scope = o;
            }
        };
        class $e extends e.E {
            updateConfig(e) {
                this._transitionable.setTransitionOrValue(this._options.properties, new Map(e));
            }
            updateTransitions(e) {
                this._transitioning = this._transitionable.transitioned(e, this._transitioning);
            }
            hasTransition() {
                return this._transitioning.hasTransition();
            }
            recalculate(e) {
                this.properties = this._transitioning.possiblyEvaluate(e);
            }
            get() {
                return this._options.properties = this._transitionable.serialize(), this._options;
            }
            set(e, t1) {
                this._options = e, this._transitionable.setTransitionOrValue(e.properties, t1);
            }
            shadowsEnabled() {
                return !!this.properties && !0 === this.properties.get("cast-shadows");
            }
            constructor(t1, i, o, s){
                super(), this.scope = o, this._options = t1, this.properties = new e.ad(i), this._transitionable = new e.a4(i, o, new Map(s)), this._transitionable.setTransitionOrValue(t1.properties), this._transitioning = this._transitionable.untransitioned();
            }
        }
        class Xe {
            static createFromScreenPoints(t1, i) {
                let o, s;
                if (t1 instanceof e.P || "number" == typeof t1[0]) {
                    const r = e.P.convert(t1);
                    o = [
                        r
                    ], s = i.isPointAboveHorizon(r);
                } else {
                    const r = e.P.convert(t1[0]), a = e.P.convert(t1[1]);
                    o = [
                        r,
                        a
                    ], s = e.al(r, a).every((e)=>i.isPointAboveHorizon(e));
                }
                return new Xe(o, i.getCameraPoint(), s, i);
            }
            isPointQuery() {
                return 1 === this.screenBounds.length;
            }
            bufferedScreenGeometry(t1) {
                return e.al(this.screenBounds[0], 1 === this.screenBounds.length ? this.screenBounds[0] : this.screenBounds[1], t1);
            }
            bufferedCameraGeometry(t1) {
                const i = this.screenBounds[0], o = 1 === this.screenBounds.length ? this.screenBounds[0].add(new e.P(1, 1)) : this.screenBounds[1], s = e.al(i, o, 0, !1);
                return this.cameraPoint.y > o.y && (this.cameraPoint.x > i.x && this.cameraPoint.x < o.x ? s.splice(3, 0, this.cameraPoint) : this.cameraPoint.x >= o.x ? s[2] = this.cameraPoint : this.cameraPoint.x <= i.x && (s[3] = this.cameraPoint)), e.am(s, t1);
            }
            bufferedCameraGeometryGlobe(t1) {
                const i = this.screenBounds[0], o = 1 === this.screenBounds.length ? this.screenBounds[0].add(new e.P(1, 1)) : this.screenBounds[1], s = e.al(i, o, t1), r = this.cameraPoint.clone();
                switch(3 * ((r.y > i.y) + (r.y > o.y)) + ((r.x > i.x) + (r.x > o.x))){
                    case 0:
                        s[0] = r, s[4] = r.clone();
                        break;
                    case 1:
                        s.splice(1, 0, r);
                        break;
                    case 2:
                        s[1] = r;
                        break;
                    case 3:
                        s.splice(4, 0, r);
                        break;
                    case 5:
                        s.splice(2, 0, r);
                        break;
                    case 6:
                        s[3] = r;
                        break;
                    case 7:
                        s.splice(3, 0, r);
                        break;
                    case 8:
                        s[2] = r;
                }
                return s;
            }
            containsTile(t1, i, o, s = 0) {
                const r = t1.queryPadding / i._pixelsPerMercatorPixel + 1, a = o ? this._bufferedCameraMercator(r, i) : this._bufferedScreenMercator(r, i);
                let n = t1.tileID.wrap + (a.unwrapped ? s : 0);
                const l = a.polygon.map((i)=>e.an(t1.tileTransform, i, n));
                if (!e.ao(l, 0, 0, e.ag, e.ag)) return;
                n = t1.tileID.wrap + (this.screenGeometryMercator.unwrapped ? s : 0);
                const c = this.screenGeometryMercator.polygon.map((i)=>e.ap(t1.tileTransform, i, n)), h = c.map((t1)=>new e.P(t1[0], t1[1])), u = i.getFreeCameraOptions().position || new e.aa(0, 0, 0), d = e.ap(t1.tileTransform, u, n), _ = c.map((t1)=>{
                    const i = e.ab.vec3.sub(t1, t1, d);
                    return e.ab.vec3.normalize(i, i), new e.aq(d, i);
                }), p = e.ar(t1, 1, i.zoom) * i._pixelsPerMercatorPixel;
                var f;
                return {
                    queryGeometry: this,
                    tilespaceGeometry: h,
                    tilespaceRays: _,
                    bufferedTilespaceGeometry: l,
                    bufferedTilespaceBounds: (f = e.as(l), f.min.x = e.aw(f.min.x, 0, e.ag), f.min.y = e.aw(f.min.y, 0, e.ag), f.max.x = e.aw(f.max.x, 0, e.ag), f.max.y = e.aw(f.max.y, 0, e.ag), f),
                    tile: t1,
                    tileID: t1.tileID,
                    pixelToTileUnitsFactor: p
                };
            }
            _bufferedScreenMercator(e, t1) {
                const i = Je(e);
                if (this._screenRaycastCache[i]) return this._screenRaycastCache[i];
                {
                    let o;
                    return o = "globe" === t1.projection.name ? this._projectAndResample(this.bufferedScreenGeometry(e), t1) : {
                        polygon: this.bufferedScreenGeometry(e).map((e)=>t1.pointCoordinate3D(e)),
                        unwrapped: !0
                    }, this._screenRaycastCache[i] = o, o;
                }
            }
            _bufferedCameraMercator(e, t1) {
                const i = Je(e);
                if (this._cameraRaycastCache[i]) return this._cameraRaycastCache[i];
                {
                    let o;
                    return o = "globe" === t1.projection.name ? this._projectAndResample(this.bufferedCameraGeometryGlobe(e), t1) : {
                        polygon: this.bufferedCameraGeometry(e).map((e)=>t1.pointCoordinate3D(e)),
                        unwrapped: !0
                    }, this._cameraRaycastCache[i] = o, o;
                }
            }
            _projectAndResample(t1, i) {
                const o = function(t1, i) {
                    const o = e.ab.mat4.multiply([], i.pixelMatrix, i.globeMatrix), s = [
                        0,
                        -e.ax,
                        0,
                        1
                    ], r = [
                        0,
                        e.ax,
                        0,
                        1
                    ], a = [
                        0,
                        0,
                        0,
                        1
                    ];
                    e.ab.vec4.transformMat4(s, s, o), e.ab.vec4.transformMat4(r, r, o), e.ab.vec4.transformMat4(a, a, o);
                    const n = new e.P(s[0] / s[3], s[1] / s[3]), l = new e.P(r[0] / r[3], r[1] / r[3]), c = e.au(t1, n) && s[3] < a[3], h = e.au(t1, l) && r[3] < a[3];
                    if (!c && !h) return null;
                    const u = function(e, t1, i) {
                        for(let o = 1; o < e.length; o++){
                            const s = Ye(t1.pointCoordinate3D(e[o - 1]).x), r = Ye(t1.pointCoordinate3D(e[o]).x);
                            if (i < 0) {
                                if (s < r) return {
                                    idx: o,
                                    t: -s / (r - 1 - s)
                                };
                            } else if (r < s) return {
                                idx: o,
                                t: (1 - s) / (r + 1 - s)
                            };
                        }
                        return null;
                    }(t1, i, c ? -1 : 1);
                    if (!u) return null;
                    const { idx: d, t: _ } = u;
                    let p = d > 1 ? Ke(t1.slice(0, d), i) : [], f = d < t1.length ? Ke(t1.slice(d), i) : [];
                    p = p.map((t1)=>new e.P(Ye(t1.x), t1.y)), f = f.map((t1)=>new e.P(Ye(t1.x), t1.y));
                    const m = [
                        ...p
                    ];
                    0 === m.length && m.push(f[f.length - 1]);
                    const g = e.af(m[m.length - 1].y, (0 === f.length ? p[0] : f[0]).y, _);
                    let v;
                    return v = c ? [
                        new e.P(0, g),
                        new e.P(0, 0),
                        new e.P(1, 0),
                        new e.P(1, g)
                    ] : [
                        new e.P(1, g),
                        new e.P(1, 1),
                        new e.P(0, 1),
                        new e.P(0, g)
                    ], m.push(...v), 0 === f.length ? m.push(p[0]) : m.push(...f), {
                        polygon: m.map((t1)=>new e.aa(t1.x, t1.y)),
                        unwrapped: !1
                    };
                }(t1, i);
                if (o) return o;
                const s = function(t1, i) {
                    let o = !1, s = -1 / 0, r = 0;
                    for(let e = 0; e < t1.length - 1; e++)t1[e].x > s && (s = t1[e].x, r = e);
                    for(let e = 0; e < t1.length - 1; e++){
                        const i = (r + e) % (t1.length - 1), s = t1[i], a = t1[i + 1];
                        Math.abs(s.x - a.x) > .5 && (s.x < a.x ? (s.x += 1, 0 === i && (t1[t1.length - 1].x += 1)) : (a.x += 1, i + 1 === t1.length - 1 && (t1[0].x += 1)), o = !0);
                    }
                    const a = e.at(i.center.lng);
                    return o && a < Math.abs(a - 1) && t1.forEach((e)=>{
                        e.x -= 1;
                    }), {
                        polygon: t1,
                        unwrapped: o
                    };
                }(Ke(t1, i).map((t1)=>new e.P(Ye(t1.x), t1.y)), i);
                return {
                    polygon: s.polygon.map((t1)=>new e.aa(t1.x, t1.y)),
                    unwrapped: s.unwrapped
                };
            }
            constructor(e, t1, i, o){
                this.screenBounds = e, this.cameraPoint = t1, this._screenRaycastCache = {}, this._cameraRaycastCache = {}, this.isAboveHorizon = i, this.screenGeometry = this.bufferedScreenGeometry(0), this.screenGeometryMercator = this._bufferedScreenMercator(0, o);
            }
        }
        function Ke(t1, i) {
            return e.av(t1, (e)=>{
                const t1 = i.pointCoordinate3D(e);
                e.x = t1.x, e.y = t1.y;
            }, 1 / 256);
        }
        function Ye(e) {
            return e < 0 ? 1 + e % 1 : e % 1;
        }
        function Je(e) {
            return 100 * e | 0;
        }
        function Qe(t1, i, o, s, r) {
            const a = function(o, s) {
                if (o) return r(o);
                if (s) {
                    if (t1.url && s.tiles && t1.tiles && delete t1.tiles, s.variants) {
                        if (!Array.isArray(s.variants)) return r(new Error("variants must be an array"));
                        for (const t1 of s.variants){
                            if (null == t1 || "object" != typeof t1 || t1.constructor !== Object) return r(new Error("variant must be an object"));
                            if (!Array.isArray(t1.capabilities)) return r(new Error("capabilities must be an array"));
                            if (1 === t1.capabilities.length && "meshopt" === t1.capabilities[0]) {
                                s = e.l(s, t1);
                                break;
                            }
                        }
                    }
                    const o = e.ay(e.l({}, s, t1), [
                        "tilejson",
                        "tiles",
                        "minzoom",
                        "maxzoom",
                        "attribution",
                        "mapbox_logo",
                        "bounds",
                        "scheme",
                        "tileSize",
                        "encoding",
                        "vector_layers",
                        "raster_layers",
                        "worldview_options",
                        "worldview_default",
                        "worldview"
                    ]);
                    o.tiles = i.canonicalizeTileset(o, t1.url), r(null, o);
                }
            }, n = function(e, t1, i) {
                if (!e) return null;
                if (!t1 && !i) return e;
                i = i || e.worldview_default;
                const o = Object.values(e.language || {});
                if (0 === o.length) return null;
                const s = Object.values(e.worldview || {});
                if (0 === s.length) return null;
                const r = o.every((e)=>e === t1), a = s.every((e)=>e === i);
                return r && a ? e : t1 in (e.language_options || {}) || i in (e.worldview_options || {}) ? null : e.language_options && e.worldview_options ? e : null;
            }(t1.data, o, s);
            return n ? e.q.frame(()=>a(null, n)) : t1.url ? e.n(i.transformRequest(i.normalizeSourceURL(t1.url, null, o, s), e.R.Source), a) : e.q.frame(()=>{
                const { data: e, ...i } = t1;
                a(null, i);
            });
        }
        class et {
            validateBounds(e) {
                return Array.isArray(e) && 4 === e.length ? [
                    Math.max(-180, e[0]),
                    Math.max(-90, e[1]),
                    Math.min(180, e[2]),
                    Math.min(90, e[3])
                ] : [
                    -180,
                    -90,
                    180,
                    90
                ];
            }
            contains(t1) {
                const i = Math.pow(2, t1.z), o = Math.floor(e.at(this.bounds.getWest()) * i), s = Math.floor(e.aA(this.bounds.getNorth()) * i), r = Math.ceil(e.at(this.bounds.getEast()) * i), a = Math.ceil(e.aA(this.bounds.getSouth()) * i);
                return t1.x >= o && t1.x < r && t1.y >= s && t1.y < a;
            }
            constructor(t1, i, o){
                this.bounds = e.az.convert(this.validateBounds(t1)), this.minzoom = i || 0, this.maxzoom = o || 24;
            }
        }
        class tt extends e.E {
            load(t1) {
                this._loaded = !1, this.fire(new e.z("dataloading", {
                    dataType: "source"
                }));
                const i = Array.isArray(this.map._language) ? this.map._language.join() : this.map._language, o = this.map.getWorldview();
                this._tileJSONRequest = Qe(this._options, this.map._requestManager, i, o, (s, r)=>{
                    if (this._tileJSONRequest = null, this._loaded = !0, s) i && console.warn(`Ensure that your requested language string is a valid BCP-47 code or list of codes. Found: ${i}`), o && console.warn(`Requested worldview strings must be a valid ISO alpha-2 code. Found: ${o}`), this.fire(new e.y(s));
                    else if (r) {
                        if (e.l(this, r), this.hasWorldviews = !!r.worldview_options, r.worldview_default && (this.worldviewDefault = r.worldview_default), r.vector_layers) {
                            this.vectorLayers = r.vector_layers, this.vectorLayerIds = [], this.localizableLayerIds = new Set;
                            for (const e of r.vector_layers)this.vectorLayerIds.push(e.id), r.worldview && r.worldview[e.source] && this.localizableLayerIds.add(e.id);
                        }
                        r.bounds && (this.tileBounds = new et(r.bounds, this.minzoom, this.maxzoom)), A(r.tiles, this.map._requestManager._customAccessToken), this.fire(new e.z("data", {
                            dataType: "source",
                            sourceDataType: "metadata"
                        })), this.fire(new e.z("data", {
                            dataType: "source",
                            sourceDataType: "content"
                        }));
                    }
                    t1 && t1(s);
                });
            }
            loaded() {
                return this._loaded;
            }
            hasTile(e) {
                return !this.tileBounds || this.tileBounds.contains(e.canonical);
            }
            onAdd(e) {
                this.map = e, this.load();
            }
            reload() {
                this.cancelTileJSONRequest();
                const t1 = e.aC(this.id, this.scope);
                this.load(()=>this.map.style.clearSource(t1));
            }
            setTiles(e) {
                return this._options.tiles = e, this.reload(), this;
            }
            setUrl(e) {
                return this.url = e, this._options.url = e, this.reload(), this;
            }
            onRemove(e) {
                this.cancelTileJSONRequest();
            }
            serialize() {
                return e.l({}, this._options);
            }
            loadTile(t1, i) {
                const o = t1.tileID.canonical.url(this.tiles, this.scheme), s = this.map._requestManager.normalizeTileURL(o), r = this.map._requestManager.transformRequest(s, e.R.Tile), a = this.map.style ? this.map.style.getLut(this.scope) : null, n = a ? {
                    image: a.image.clone()
                } : null, l = {
                    request: r,
                    data: void 0,
                    uid: t1.uid,
                    tileID: t1.tileID,
                    tileZoom: t1.tileZoom,
                    zoom: t1.tileID.overscaledZ,
                    maxZoom: this.maxzoom,
                    lut: n,
                    tileSize: this.tileSize * t1.tileID.overscaleFactor(),
                    type: this.type,
                    source: this.id,
                    scope: this.scope,
                    pixelRatio: e.q.devicePixelRatio,
                    showCollisionBoxes: this.map.showCollisionBoxes,
                    promoteId: this.promoteId,
                    isSymbolTile: t1.isSymbolTile,
                    brightness: this.map.style && this.map.style.getBrightness() || 0,
                    extraShadowCaster: t1.isExtraShadowCaster,
                    tessellationStep: this.map._tessellationStep,
                    scaleFactor: this.map.getScaleFactor()
                };
                if (this.hasWorldviews && e.f(o) && (l.worldview = this.map.getWorldview() || this.worldviewDefault, l.localizableLayerIds = this.localizableLayerIds), l.request.collectResourceTiming = this._collectResourceTiming, t1.actor && "expired" !== t1.state) "loading" === t1.state ? t1.reloadCallback = i : t1.request = t1.actor.send("reloadTile", l, c.bind(this));
                else if (t1.actor = this._tileWorkers[s] = this._tileWorkers[s] || this.dispatcher.getActor(), this.dispatcher.ready) t1.request = t1.actor.send("loadTile", l, c.bind(this), void 0, !0);
                else {
                    const i = e.aD.call({
                        deduped: this._deduped
                    }, l, (e, i)=>{
                        e || !i ? c.call(this, e) : (l.data = {
                            cacheControl: i.cacheControl,
                            expires: i.expires,
                            rawData: i.rawData.slice(0)
                        }, t1.actor && t1.actor.send("loadTile", l, c.bind(this), void 0, !0));
                    }, !0);
                    t1.request = {
                        cancel: i
                    };
                }
                function c(o, s) {
                    return delete t1.request, t1.aborted ? i(null) : o && 404 !== o.status ? i(o) : (s && s.resourceTiming && (t1.resourceTiming = s.resourceTiming), this.map._refreshExpiredTiles && s && t1.setExpiryData(s), t1.loadVectorData(s, this.map.painter), e.aE(this.dispatcher), i(null), void (t1.reloadCallback && (this.loadTile(t1, t1.reloadCallback), t1.reloadCallback = null)));
                }
            }
            abortTile(e) {
                e.request && (e.request.cancel(), delete e.request), e.actor && e.actor.send("abortTile", {
                    uid: e.uid,
                    type: this.type,
                    source: this.id,
                    scope: this.scope
                });
            }
            unloadTile(e, t1) {
                e.actor && e.actor.send("removeTile", {
                    uid: e.uid,
                    type: this.type,
                    source: this.id,
                    scope: this.scope
                }), e.destroy();
            }
            hasTransition() {
                return !1;
            }
            afterUpdate() {
                this._tileWorkers = {};
            }
            cancelTileJSONRequest() {
                this._tileJSONRequest && (this._tileJSONRequest.cancel(), this._tileJSONRequest = null);
            }
            constructor(t1, i, o, s){
                if (super(), this.id = t1, this.dispatcher = o, this.type = "vector", this.minzoom = 0, this.maxzoom = 22, this.scheme = "xyz", this.tileSize = 512, this.reparseOverscaled = !0, this.isTileClipped = !0, this._loaded = !1, e.l(this, e.ay(i, [
                    "url",
                    "scheme",
                    "tileSize",
                    "promoteId"
                ])), this._options = e.l({
                    type: "vector"
                }, i), this._collectResourceTiming = !!i.collectResourceTiming, 512 !== this.tileSize) throw new Error("vector tile sources must have a tileSize of 512");
                this.setEventedParent(s), this._tileWorkers = {}, this._deduped = new e.aB;
            }
        }
        class it extends e.E {
            load(t1) {
                this._loaded = !1, this.fire(new e.z("dataloading", {
                    dataType: "source"
                })), this._tileJSONRequest = Qe(this._options, this.map._requestManager, null, null, (i, o)=>{
                    this._tileJSONRequest = null, this._loaded = !0, i ? this.fire(new e.y(i)) : o && (e.l(this, o), o.raster_layers && (this.rasterLayers = o.raster_layers, this.rasterLayerIds = this.rasterLayers.map((e)=>e.id)), o.bounds && (this.tileBounds = new et(o.bounds, this.minzoom, this.maxzoom)), A(o.tiles), this.fire(new e.z("data", {
                        dataType: "source",
                        sourceDataType: "metadata"
                    })), this.fire(new e.z("data", {
                        dataType: "source",
                        sourceDataType: "content"
                    }))), t1 && t1(i);
                });
            }
            loaded() {
                return this._loaded;
            }
            onAdd(e) {
                this.map = e, this.load();
            }
            reload() {
                this.cancelTileJSONRequest();
                const t1 = e.aC(this.id, this.scope);
                this.load(()=>this.map.style.clearSource(t1));
            }
            setTiles(e) {
                return this._options.tiles = e, this.reload(), this;
            }
            setUrl(e) {
                return this.url = e, this._options.url = e, this.reload(), this;
            }
            onRemove(e) {
                this.cancelTileJSONRequest();
            }
            serialize() {
                return e.l({}, this._options);
            }
            hasTile(e) {
                return !this.tileBounds || this.tileBounds.contains(e.canonical);
            }
            loadTile(t1, i) {
                const o = e.q.devicePixelRatio >= 2, s = this.map._requestManager.normalizeTileURL(t1.tileID.canonical.url(this.tiles, this.scheme), o, this.tileSize);
                t1.request = e.o(this.map._requestManager.transformRequest(s, e.R.Tile), (o, s, r, a)=>(delete t1.request, t1.aborted ? (t1.state = "unloaded", i(null)) : o ? (t1.state = "errored", i(o)) : s ? (this.map._refreshExpiredTiles && t1.setExpiryData({
                        cacheControl: r,
                        expires: a
                    }), t1.setTexture(s, this.map.painter), t1.state = "loaded", e.aE(this.dispatcher), void i(null)) : i(null)));
            }
            abortTile(e, t1) {
                e.request && (e.request.cancel(), delete e.request), t1 && t1();
            }
            unloadTile(t1, i) {
                t1.texture && t1.texture instanceof e.T ? (t1.destroy(!0), t1.texture && t1.texture instanceof e.T && this.map.painter.saveTileTexture(t1.texture)) : t1.destroy(), i && i();
            }
            hasTransition() {
                return !1;
            }
            cancelTileJSONRequest() {
                this._tileJSONRequest && (this._tileJSONRequest.cancel(), this._tileJSONRequest = null);
            }
            constructor(t1, i, o, s){
                super(), this.id = t1, this.dispatcher = o, this.setEventedParent(s), this.type = "raster", this.minzoom = 0, this.maxzoom = 22, this.roundZoom = !0, this.scheme = "xyz", this.tileSize = 512, this._loaded = !1, this._options = e.l({
                    type: "raster"
                }, i), e.l(this, e.ay(i, [
                    "url",
                    "scheme",
                    "tileSize"
                ]));
            }
        }
        class ot extends it {
            triggerRepaint(e) {
                const t1 = this.map.painter._terrain, i = this.map.style.getSourceCache(this.id);
                t1 && t1.enabled && i && t1._clearRenderCacheForTile(i.id, e.tileID), this.map.triggerRepaint();
            }
            loadTile(t1, i) {
                const o = this.map._requestManager.normalizeTileURL(t1.tileID.canonical.url(this.tiles, this.scheme), !1, this.tileSize), s = this.map._requestManager.transformRequest(o, e.R.Tile);
                t1.requestParams = s, t1.actor || (t1.actor = this.dispatcher.getActor()), t1.request = t1.fetchHeader(void 0, (e, o, s, r)=>{
                    if (delete t1.request, t1.aborted) return t1.state = "unloaded", i(null);
                    if (e) {
                        if (20 === e.code) return;
                        return t1.state = "errored", i(e);
                    }
                    this.map._refreshExpiredTiles && t1.setExpiryData({
                        cacheControl: s,
                        expires: r
                    }), t1.state = "empty", i(null);
                });
            }
            unloadTile(t1, i) {
                const o = t1.texture;
                o && o instanceof e.T ? (t1.destroy(!0), this.map.painter.saveTileTexture(o)) : (t1.destroy(), t1.flushQueues(), t1._isHeaderLoaded = !1, delete t1._mrt, delete t1.textureDescriptor), t1.fbo && (t1.fbo.destroy(), delete t1.fbo), delete t1.request, delete t1.requestParams, delete t1.neighboringTiles, t1.state = "unloaded";
            }
            prepareTile(t1, i, o) {
                t1._isHeaderLoaded && ("empty" !== t1.state && (t1.state = "reloading"), t1.fetchBand(i, o, (i, o)=>{
                    if (i) return t1.state = "errored", this.fire(new e.y(i)), void this.triggerRepaint(t1);
                    o && (t1.setTexture(o, this.map.painter), t1.state = "loaded", this.triggerRepaint(t1));
                }));
            }
            getInitialBand(e) {
                if (!this.rasterLayers) return 0;
                const t1 = this.rasterLayers.find(({ id: t1 })=>t1 === e), i = t1 && t1.fields, o = i && i.bands && i.bands;
                return o ? o[0] : 0;
            }
            getTextureDescriptor(t1, i, o) {
                if (!t1) return;
                const s = i.sourceLayer || this.rasterLayerIds && this.rasterLayerIds[0];
                if (!s) return;
                let r = null;
                i instanceof e.aH ? r = i.paint.get("raster-array-band") : i instanceof e.aI && (r = i.paint.get("raster-particle-array-band"));
                const a = r || this.getInitialBand(s);
                if (null != a) {
                    if (t1.textureDescriptor) {
                        if (!t1.updateNeeded(s, a) || o) return Object.assign({}, t1.textureDescriptor, {
                            texture: t1.texture
                        });
                    } else this.prepareTile(t1, s, a);
                }
            }
            constructor(t1, i, o, s){
                super(t1, i, o, s), this.type = "raster-array", this.maxzoom = 22, this._options = e.l({
                    type: "raster-array"
                }, i);
            }
        }
        const st = {
            vector: tt,
            raster: it,
            "raster-dem": class extends it {
                loadTile(t1, i) {
                    const o = this.map._requestManager.normalizeTileURL(t1.tileID.canonical.url(this.tiles, this.scheme), !1, this.tileSize);
                    function s(e, o) {
                        e && (t1.state = "errored", i(e)), o && (t1.dem = o, t1.dem.onDeserialize(), t1.needsHillshadePrepare = !0, t1.needsDEMTextureUpload = !0, t1.state = "loaded", i(null));
                    }
                    t1.request = e.o(this.map._requestManager.transformRequest(o, e.R.Tile), (function(o, r, a, n) {
                        if (delete t1.request, t1.aborted) t1.state = "unloaded", i(null);
                        else if (o) t1.state = "errored", i(o);
                        else if (r) {
                            this.map._refreshExpiredTiles && t1.setExpiryData({
                                cacheControl: a,
                                expires: n
                            });
                            const i = ImageBitmap && r instanceof ImageBitmap && e.t(), o = 1 - (r.width - e.aF(r.width)) / 2;
                            o < 1 || t1.neighboringTiles || (t1.neighboringTiles = this._getNeighboringTiles(t1.tileID));
                            const l = i ? r : e.q.getImageData(r, o), c = {
                                uid: t1.uid,
                                coord: t1.tileID,
                                source: this.id,
                                scope: this.scope,
                                rawImageData: l,
                                encoding: this.encoding,
                                padding: o
                            };
                            t1.actor && "expired" !== t1.state || (t1.actor = this.dispatcher.getActor(), t1.actor.send("loadDEMTile", c, s.bind(this), void 0, !0));
                        }
                    }).bind(this));
                }
                _getNeighboringTiles(t1) {
                    const i = t1.canonical, o = Math.pow(2, i.z), s = (i.x - 1 + o) % o, r = 0 === i.x ? t1.wrap - 1 : t1.wrap, a = (i.x + 1 + o) % o, n = i.x + 1 === o ? t1.wrap + 1 : t1.wrap, l = {};
                    return l[new e.aG(t1.overscaledZ, r, i.z, s, i.y).key] = {
                        backfilled: !1
                    }, l[new e.aG(t1.overscaledZ, n, i.z, a, i.y).key] = {
                        backfilled: !1
                    }, i.y > 0 && (l[new e.aG(t1.overscaledZ, r, i.z, s, i.y - 1).key] = {
                        backfilled: !1
                    }, l[new e.aG(t1.overscaledZ, t1.wrap, i.z, i.x, i.y - 1).key] = {
                        backfilled: !1
                    }, l[new e.aG(t1.overscaledZ, n, i.z, a, i.y - 1).key] = {
                        backfilled: !1
                    }), i.y + 1 < o && (l[new e.aG(t1.overscaledZ, r, i.z, s, i.y + 1).key] = {
                        backfilled: !1
                    }, l[new e.aG(t1.overscaledZ, t1.wrap, i.z, i.x, i.y + 1).key] = {
                        backfilled: !1
                    }, l[new e.aG(t1.overscaledZ, n, i.z, a, i.y + 1).key] = {
                        backfilled: !1
                    }), l;
                }
                constructor(t1, i, o, s){
                    super(t1, i, o, s), this.type = "raster-dem", this.maxzoom = 22, this._options = e.l({
                        type: "raster-dem"
                    }, i), this.encoding = i.encoding || "mapbox";
                }
            },
            "raster-array": ot,
            geojson: class extends e.E {
                onAdd(e) {
                    this.map = e, this.setData(this._data);
                }
                setData(e) {
                    return this._data = e, this._updateWorkerData(), this;
                }
                updateData(t1) {
                    if (!this._options.dynamic) return this.fire(new e.y(new Error("Can't call updateData on a GeoJSON source with dynamic set to false.")));
                    if ("string" != typeof t1 && ("Feature" === t1.type && (t1 = {
                        type: "FeatureCollection",
                        features: [
                            t1
                        ]
                    }), "FeatureCollection" !== t1.type)) return this.fire(new e.y(new Error("Data to update should be a feature or a feature collection.")));
                    if (this._coalesce && "string" != typeof t1 && "string" != typeof this._data && "FeatureCollection" === this._data.type) {
                        const e = new Map;
                        for (const t1 of this._data.features)e.set(t1.id, t1);
                        for (const i of t1.features)e.set(i.id, i);
                        this._data.features = [
                            ...e.values()
                        ];
                    } else this._data = t1;
                    return this._updateWorkerData(!0), this;
                }
                getClusterExpansionZoom(e, t1) {
                    return this.actor.send("geojson.getClusterExpansionZoom", {
                        clusterId: e,
                        source: this.id,
                        scope: this.scope
                    }, t1), this;
                }
                getClusterChildren(e, t1) {
                    return this.actor.send("geojson.getClusterChildren", {
                        clusterId: e,
                        source: this.id,
                        scope: this.scope
                    }, t1), this;
                }
                getClusterLeaves(e, t1, i, o) {
                    return this.actor.send("geojson.getClusterLeaves", {
                        source: this.id,
                        scope: this.scope,
                        clusterId: e,
                        limit: t1,
                        offset: i
                    }, o), this;
                }
                _updateWorkerData(t1 = !1) {
                    if (this._pendingLoad) return void (this._coalesce = !0);
                    this.fire(new e.z("dataloading", {
                        dataType: "source"
                    })), this._loaded = !1;
                    const i = e.l({
                        append: t1
                    }, this.workerOptions);
                    i.scope = this.scope;
                    const o = this._data;
                    "string" == typeof o ? (i.request = this.map._requestManager.transformRequest(e.q.resolveURL(o), e.R.Source), i.request.collectResourceTiming = this._collectResourceTiming) : i.data = JSON.stringify(o), this._pendingLoad = this.actor.send(`${this.type}.loadData`, i, (i, o)=>{
                        if (this._loaded = !0, this._pendingLoad = null, i) this.fire(new e.y(i));
                        else {
                            const i = {
                                dataType: "source",
                                sourceDataType: this._metadataFired ? "content" : "metadata"
                            };
                            this._collectResourceTiming && o && o.resourceTiming && o.resourceTiming[this.id] && (i.resourceTiming = o.resourceTiming[this.id]), t1 && (this._partialReload = !0), this.fire(new e.z("data", i)), this._partialReload = !1, this._metadataFired = !0;
                        }
                        this._coalesce && (this._updateWorkerData(t1), this._coalesce = !1);
                    });
                }
                loaded() {
                    return this._loaded;
                }
                reload() {
                    const t1 = e.aC(this.id, this.scope);
                    this.map.style.clearSource(t1), this._updateWorkerData();
                }
                loadTile(t1, i) {
                    const o = t1.actor ? "reloadTile" : "loadTile";
                    t1.actor = this.actor;
                    const s = this.map.style ? this.map.style.getLut(this.scope) : null, r = s ? {
                        image: s.image.clone()
                    } : null, a = this._partialReload, n = {
                        type: this.type,
                        uid: t1.uid,
                        tileID: t1.tileID,
                        tileZoom: t1.tileZoom,
                        zoom: t1.tileID.overscaledZ,
                        maxZoom: this.maxzoom,
                        tileSize: this.tileSize,
                        source: this.id,
                        lut: r,
                        scope: this.scope,
                        pixelRatio: e.q.devicePixelRatio,
                        showCollisionBoxes: this.map.showCollisionBoxes,
                        promoteId: this.promoteId,
                        brightness: this.map.style && this.map.style.getBrightness() || 0,
                        scaleFactor: this.map.getScaleFactor(),
                        partial: a
                    };
                    t1.request = this.actor.send(o, n, (e, s)=>a && !s ? (t1.state = "loaded", i(null)) : (delete t1.request, t1.destroy(), t1.aborted ? i(null) : e ? i(e) : (t1.loadVectorData(s, this.map.painter, "reloadTile" === o), i(null))), void 0, "loadTile" === o);
                }
                abortTile(e) {
                    e.request && (e.request.cancel(), delete e.request), e.aborted = !0;
                }
                unloadTile(e, t1) {
                    this.actor.send("removeTile", {
                        uid: e.uid,
                        type: this.type,
                        source: this.id,
                        scope: this.scope
                    }), e.destroy();
                }
                onRemove(e) {
                    this._pendingLoad && this._pendingLoad.cancel();
                }
                serialize() {
                    return e.l({}, this._options, {
                        type: this.type,
                        data: this._data
                    });
                }
                hasTransition() {
                    return !1;
                }
                constructor(t1, i, o, s){
                    super(), this.id = t1, this.type = "geojson", this.minzoom = 0, this.maxzoom = 18, this.tileSize = 512, this.isTileClipped = !0, this.reparseOverscaled = !0, this._loaded = !1, this.actor = o.getActor(), this.setEventedParent(s), this._data = i.data, this._options = e.l({}, i), this._collectResourceTiming = i.collectResourceTiming, void 0 !== i.maxzoom && (this.maxzoom = i.maxzoom), void 0 !== i.minzoom && (this.minzoom = i.minzoom), i.type && (this.type = i.type), i.attribution && (this.attribution = i.attribution), this.promoteId = i.promoteId;
                    const r = e.ag / this.tileSize;
                    this.workerOptions = e.l({
                        source: this.id,
                        scope: this.scope,
                        cluster: i.cluster || !1,
                        geojsonVtOptions: {
                            buffer: (void 0 !== i.buffer ? i.buffer : 128) * r,
                            tolerance: (void 0 !== i.tolerance ? i.tolerance : .375) * r,
                            extent: e.ag,
                            maxZoom: this.maxzoom,
                            lineMetrics: i.lineMetrics || !1,
                            generateId: i.generateId || !1
                        },
                        superclusterOptions: {
                            maxZoom: void 0 !== i.clusterMaxZoom ? i.clusterMaxZoom : this.maxzoom - 1,
                            minPoints: Math.max(2, i.clusterMinPoints || 2),
                            extent: e.ag,
                            radius: (void 0 !== i.clusterRadius ? i.clusterRadius : 50) * r,
                            log: !1,
                            generateId: i.generateId || !1
                        },
                        clusterProperties: i.clusterProperties,
                        filter: i.filter,
                        dynamic: i.dynamic
                    }, i.workerOptions);
                }
            },
            video: class extends e.aJ {
                load() {
                    this._loaded = !1;
                    const t1 = this.options;
                    this.urls = [];
                    for (const i of t1.urls)this.urls.push(this.map._requestManager.transformRequest(i, e.R.Source).url);
                    e.aK(this.urls, (t1, i)=>{
                        this._loaded = !0, t1 ? this.fire(new e.y(t1)) : i && (this.video = i, this.video.loop = !0, this.video.setAttribute("playsinline", ""), this.video.addEventListener("playing", ()=>{
                            this.map.triggerRepaint();
                        }), this.map && this.video.play(), this._finishLoading());
                    });
                }
                pause() {
                    this.video && this.video.pause();
                }
                play() {
                    this.video && this.video.play();
                }
                seek(t1) {
                    if (this.video) {
                        const i = this.video.seekable;
                        t1 < i.start(0) || t1 > i.end(0) ? this.fire(new e.y(new e.V(`sources.${this.id}`, null, `Playback for this video can be set only between the ${i.start(0)} and ${i.end(0)}-second mark.`))) : this.video.currentTime = t1;
                    }
                }
                getVideo() {
                    return this.video;
                }
                onAdd(e) {
                    this.map || (this.map = e, this.load(), this.video && (this.video.play(), this.setCoordinates(this.coordinates)));
                }
                prepare() {
                    if (0 === Object.keys(this.tiles).length || this.video.readyState < 2) return;
                    const t1 = this.map.painter.context, i = t1.gl;
                    this.texture ? this.video.paused || (this.texture.bind(i.LINEAR, i.CLAMP_TO_EDGE), i.texSubImage2D(i.TEXTURE_2D, 0, 0, 0, i.RGBA, i.UNSIGNED_BYTE, this.video)) : (this.texture = new e.T(t1, this.video, i.RGBA8), this.texture.bind(i.LINEAR, i.CLAMP_TO_EDGE), this.width = this.video.videoWidth, this.height = this.video.videoHeight), this._prepareData(t1);
                }
                serialize() {
                    return {
                        type: "video",
                        urls: this.urls,
                        coordinates: this.coordinates
                    };
                }
                hasTransition() {
                    return this.video && !this.video.paused;
                }
                constructor(e, t1, i, o){
                    super(e, t1, i, o), this.roundZoom = !0, this.type = "video", this.options = t1;
                }
            },
            image: e.aJ,
            model: class extends e.E {
                load() {
                    const t1 = [];
                    for(const i in this._options.models){
                        const o = this._options.models[i], s = e.aM(this.map._requestManager.transformRequest(o.uri, e.R.Model).url).then((t1)=>{
                            if (!t1) return;
                            const s = e.aN(t1), r = new e.aO(i, o.position, o.orientation, s);
                            r.computeBoundsAndApplyParent(), this.models.push(r);
                        }).catch((t1)=>{
                            this.fire(new e.y(new Error(`Could not load model ${i} from ${o.uri}: ${t1.message}`)));
                        });
                        t1.push(s);
                    }
                    return Promise.allSettled(t1).then(()=>{
                        this._loaded = !0, this.fire(new e.z("data", {
                            dataType: "source",
                            sourceDataType: "metadata"
                        }));
                    }).catch((t1)=>{
                        this.fire(new e.y(new Error(`Could not load models: ${t1.message}`)));
                    });
                }
                onAdd(e) {
                    this.map = e, this.load();
                }
                hasTransition() {
                    return !1;
                }
                loaded() {
                    return this._loaded;
                }
                getModels() {
                    return this.models;
                }
                loadTile(e, t1) {}
                serialize() {
                    return {
                        type: "model"
                    };
                }
                constructor(e, t1, i, o){
                    super(), this.id = e, this.type = "model", this.models = [], this._loaded = !1, this._options = t1;
                }
            },
            "batched-model": class extends e.E {
                onAdd(e) {
                    this.map = e, this.load();
                }
                reload() {
                    this.cancelTileJSONRequest();
                    const t1 = e.aC(this.id, this.scope);
                    this.load(()=>this.map.style.clearSource(t1));
                }
                cancelTileJSONRequest() {
                    this._tileJSONRequest && (this._tileJSONRequest.cancel(), this._tileJSONRequest = null);
                }
                load(t1) {
                    this._loaded = !1, this.fire(new e.z("dataloading", {
                        dataType: "source"
                    }));
                    const i = Array.isArray(this.map._language) ? this.map._language.join() : this.map._language, o = this.map.getWorldview();
                    this._tileJSONRequest = Qe(this._options, this.map._requestManager, i, o, (s, r)=>{
                        this._tileJSONRequest = null, this._loaded = !0, s ? (i && console.warn(`Ensure that your requested language string is a valid BCP-47 code or list of codes. Found: ${i}`), o && 2 !== o.length && console.warn(`Requested worldview strings must be a valid ISO alpha-2 code. Found: ${o}`), this.fire(new e.y(s))) : r && (e.l(this, r), r.bounds && (this.tileBounds = new et(r.bounds, this.minzoom, this.maxzoom)), A(r.tiles, this.map._requestManager._customAccessToken), this.fire(new e.z("data", {
                            dataType: "source",
                            sourceDataType: "metadata"
                        })), this.fire(new e.z("data", {
                            dataType: "source",
                            sourceDataType: "content"
                        }))), t1 && t1(s);
                    });
                }
                hasTransition() {
                    return !1;
                }
                hasTile(e) {
                    return !this.tileBounds || this.tileBounds.contains(e.canonical);
                }
                loaded() {
                    return this._loaded;
                }
                loadTile(t1, i) {
                    const o = this.map._requestManager.normalizeTileURL(t1.tileID.canonical.url(this.tiles, this.scheme)), s = {
                        request: this.map._requestManager.transformRequest(o, e.R.Tile),
                        data: void 0,
                        uid: t1.uid,
                        tileID: t1.tileID,
                        tileZoom: t1.tileZoom,
                        zoom: t1.tileID.overscaledZ,
                        tileSize: this.tileSize * t1.tileID.overscaleFactor(),
                        type: this.type,
                        source: this.id,
                        scope: this.scope,
                        showCollisionBoxes: this.map.showCollisionBoxes,
                        isSymbolTile: t1.isSymbolTile,
                        brightness: this.map.style && this.map.style.getBrightness() || 0,
                        lut: null,
                        maxZoom: null,
                        promoteId: null,
                        pixelRatio: null,
                        scaleFactor: null
                    };
                    if (t1.actor && "expired" !== t1.state) {
                        if ("loading" === t1.state) t1.reloadCallback = i;
                        else {
                            if (t1.buckets) {
                                const e = Object.values(t1.buckets);
                                for (const t1 of e)t1.dirty = !0;
                                return void (t1.state = "loaded");
                            }
                            t1.request = t1.actor.send("reloadTile", s, r.bind(this));
                        }
                    } else t1.actor = this.dispatcher.getActor(), t1.request = t1.actor.send("loadTile", s, r.bind(this), void 0, !0);
                    function r(e, o) {
                        return t1.aborted ? i(null) : e && 404 !== e.status ? i(e) : (this.map._refreshExpiredTiles && o && t1.setExpiryData(o), t1.loadModelData(o, this.map.painter), t1.state = "loaded", void i(null));
                    }
                }
                serialize() {
                    return e.l({}, this._options);
                }
                constructor(e, t1, i, o){
                    super(), this.type = "batched-model", this.id = e, this.tileSize = 512, this._options = t1, this.tiles = this._options.tiles, this.maxzoom = t1.maxzoom || 19, this.minzoom = t1.minzoom || 0, this.roundZoom = !0, this.usedInConflation = !0, this.dispatcher = i, this.reparseOverscaled = !1, this.scheme = "xyz", this._loaded = !1, this.setEventedParent(o);
                }
            },
            canvas: class extends e.aJ {
                load() {
                    this._loaded = !0, this.canvas || (this.canvas = this.options.canvas instanceof HTMLCanvasElement ? this.options.canvas : document.getElementById(this.options.canvas)), this.width = this.canvas.width, this.height = this.canvas.height, this._hasInvalidDimensions() ? this.fire(new e.y(new Error("Canvas dimensions cannot be less than or equal to zero."))) : (this.play = function() {
                        this._playing = !0, this.map.triggerRepaint();
                    }, this.pause = function() {
                        this._playing && (this.prepare(), this._playing = !1);
                    }, this._finishLoading());
                }
                getCanvas() {
                    return this.canvas;
                }
                onAdd(e) {
                    this.map = e, this.load(), this.canvas && this.animate && this.play();
                }
                onRemove(e) {
                    this.pause();
                }
                prepare() {
                    let t1 = !1;
                    if (this.canvas.width !== this.width && (this.width = this.canvas.width, t1 = !0), this.canvas.height !== this.height && (this.height = this.canvas.height, t1 = !0), this._hasInvalidDimensions()) return;
                    if (0 === Object.keys(this.tiles).length) return;
                    const i = this.map.painter.context;
                    this.texture ? !t1 && !this._playing || this.texture instanceof e.aL || this.texture.update(this.canvas, {
                        premultiply: !0
                    }) : this.texture = new e.T(i, this.canvas, i.gl.RGBA8, {
                        premultiply: !0
                    }), this._prepareData(i);
                }
                serialize() {
                    return {
                        type: "canvas",
                        coordinates: this.coordinates
                    };
                }
                hasTransition() {
                    return this._playing;
                }
                _hasInvalidDimensions() {
                    for (const e of [
                        this.canvas.width,
                        this.canvas.height
                    ])if (isNaN(e) || e <= 0) return !0;
                    return !1;
                }
                constructor(t1, i, o, s){
                    super(t1, i, o, s), i.coordinates ? Array.isArray(i.coordinates) && 4 === i.coordinates.length && !i.coordinates.some((e)=>!Array.isArray(e) || 2 !== e.length || e.some((e)=>"number" != typeof e)) || this.fire(new e.y(new e.V(`sources.${t1}`, null, '"coordinates" property must be an array of 4 longitude/latitude array pairs'))) : this.fire(new e.y(new e.V(`sources.${t1}`, null, 'missing required property "coordinates"'))), i.animate && "boolean" != typeof i.animate && this.fire(new e.y(new e.V(`sources.${t1}`, null, 'optional "animate" property must be a boolean value'))), i.canvas ? "string" == typeof i.canvas || i.canvas instanceof HTMLCanvasElement || this.fire(new e.y(new e.V(`sources.${t1}`, null, '"canvas" must be either a string representing the ID of the canvas element from which to read, or an HTMLCanvasElement instance'))) : this.fire(new e.y(new e.V(`sources.${t1}`, null, 'missing required property "canvas"'))), this.options = i, this.animate = void 0 === i.animate || i.animate;
                }
            },
            custom: class extends e.E {
                serialize() {
                    return e.ay(this, [
                        "type",
                        "scheme",
                        "minzoom",
                        "maxzoom",
                        "tileSize",
                        "attribution"
                    ]);
                }
                load() {
                    this._loaded = !0, this.fire(new e.z("data", {
                        dataType: "source",
                        sourceDataType: "metadata"
                    })), this.fire(new e.z("data", {
                        dataType: "source",
                        sourceDataType: "content"
                    }));
                }
                loaded() {
                    return this._loaded;
                }
                onAdd(t1) {
                    this.map = t1, this._loaded = !1, this.fire(new e.z("dataloading", {
                        dataType: "source"
                    })), this._implementation.onAdd && this._implementation.onAdd(t1), this.load();
                }
                onRemove(e) {
                    this._implementation.onRemove && this._implementation.onRemove(e);
                }
                hasTile(e) {
                    if (this._implementation.hasTile) {
                        const { x: t1, y: i, z: o } = e.canonical;
                        return this._implementation.hasTile({
                            x: t1,
                            y: i,
                            z: o
                        });
                    }
                    return !this.tileBounds || this.tileBounds.contains(e.canonical);
                }
                loadTile(e, t1) {
                    const { x: i, y: o, z: s } = e.tileID.canonical, r = new AbortController;
                    e.request = Promise.resolve(this._implementation.loadTile({
                        x: i,
                        y: o,
                        z: s
                    }, {
                        signal: r.signal
                    })).then((function(i) {
                        return delete e.request, e.aborted ? (e.state = "unloaded", t1(null)) : void 0 === i ? (e.state = "errored", t1(null)) : null === i ? (this.loadTileData(e, {
                            width: this.tileSize,
                            height: this.tileSize,
                            data: null
                        }), e.state = "loaded", t1(null)) : function(e) {
                            return e instanceof ImageData || e instanceof HTMLCanvasElement || e instanceof ImageBitmap || e instanceof HTMLImageElement;
                        }(i) ? (this.loadTileData(e, i), e.state = "loaded", void t1(null)) : (e.state = "errored", t1(new Error(`Can't infer data type for ${this.id}, only raster data supported at the moment`)));
                    }).bind(this)).catch((i)=>{
                        20 !== i.code && (e.state = "errored", t1(i));
                    }), e.request.cancel = ()=>r.abort();
                }
                loadTileData(e, t1) {
                    e.setTexture(t1, this.map.painter);
                }
                unloadTile(t1, i) {
                    if (t1.texture && t1.texture instanceof e.T ? (t1.destroy(!0), t1.texture && t1.texture instanceof e.T && this.map.painter.saveTileTexture(t1.texture)) : t1.destroy(), this._implementation.unloadTile) {
                        const { x: e, y: i, z: o } = t1.tileID.canonical;
                        this._implementation.unloadTile({
                            x: e,
                            y: i,
                            z: o
                        });
                    }
                    i && i();
                }
                abortTile(e, t1) {
                    e.request && e.request.cancel && (e.request.cancel(), delete e.request), t1 && t1();
                }
                hasTransition() {
                    return !1;
                }
                _coveringTiles() {
                    return this.map.transform.coveringTiles({
                        tileSize: this.tileSize,
                        minzoom: this.minzoom,
                        maxzoom: this.maxzoom,
                        roundZoom: this.roundZoom
                    }).map((e)=>({
                            x: e.canonical.x,
                            y: e.canonical.y,
                            z: e.canonical.z
                        }));
                }
                _clearTiles() {
                    const t1 = e.aC(this.id, this.scope);
                    this.map.style.clearSource(t1);
                }
                _update() {
                    this.fire(new e.z("data", {
                        dataType: "source",
                        sourceDataType: "content"
                    }));
                }
                constructor(t1, i, o, s){
                    super(), this.id = t1, this.type = "custom", this._dataType = "raster", this._dispatcher = o, this._implementation = i, this.setEventedParent(s), this.scheme = "xyz", this.minzoom = 0, this.maxzoom = 22, this.tileSize = 512, this._loaded = !1, this.roundZoom = !0, this._implementation || this.fire(new e.y(new Error(`Missing implementation for ${this.id} custom source`))), this._implementation.loadTile || this.fire(new e.y(new Error(`Missing loadTile implementation for ${this.id} custom source`))), this._implementation.bounds && (this.tileBounds = new et(this._implementation.bounds, this.minzoom, this.maxzoom)), i.update = this._update.bind(this), i.clearTiles = this._clearTiles.bind(this), i.coveringTiles = this._coveringTiles.bind(this), e.l(this, e.ay(i, [
                        "dataType",
                        "scheme",
                        "minzoom",
                        "maxzoom",
                        "tileSize",
                        "attribution",
                        "minTileCacheSize",
                        "maxTileCacheSize"
                    ]));
                }
            }
        }, rt = function(t1, i, o, s) {
            const r = new st[i.type](t1, i, o, s);
            if (r.id !== t1) throw new Error(`Expected Source id to be ${t1} instead of ${r.id}`);
            return e.aP([
                "load",
                "abort",
                "unload",
                "serialize",
                "prepare"
            ], r), r;
        };
        function at(e, t1, i = "") {
            return `${i}:${t1.id || ""}:${t1.layer.id}:${function(e) {
                if ("layerId" in e) return `layer:${e.layerId}`;
                {
                    const { featuresetId: t1, importId: i } = e;
                    return `featureset:${t1}${i ? `:import:${i}` : ""}`;
                }
            }(e.target)}`;
        }
        function nt(e, t1, i, o = "") {
            if (e.uniqueFeatureID) {
                const s = at(e, t1, o);
                if (i.has(s)) return !0;
                i.add(s);
            }
            return !1;
        }
        function lt(e, t1, i, o, s = !1) {
            const r = t1.sourceCache.transform, a = t1.sourceCache.tilesIn(e, t1.has3DLayers, s);
            a.sort(ut);
            const n = [];
            for (const e of a){
                const a = e.tile.queryRenderedFeatures(t1, e, i, o, r, s);
                Object.keys(a).length && n.push({
                    wrappedTileID: e.tile.tileID.wrapped().key,
                    queryResults: a
                });
            }
            return 0 === n.length ? {} : function(e) {
                const t1 = {}, i = {};
                for (const o of e){
                    const e = o.queryResults, s = o.wrappedTileID, r = i[s] = i[s] || {};
                    for(const i in e){
                        const o = e[i], s = r[i] = r[i] || {}, a = t1[i] = t1[i] || [];
                        for (const e of o)s[e.featureIndex] || (s[e.featureIndex] = !0, a.push(e));
                    }
                }
                return t1;
            }(n);
        }
        function ct(e, t1, i, o, s) {
            const r = {}, a = o.queryRenderedSymbols(e), n = [];
            for (const e of Object.keys(a).map(Number))n.push(s[e]);
            n.sort(ut);
            for (const e of n){
                const o = e.featureIndex.lookupSymbolFeatures(a[e.bucketInstanceId], e.bucketIndex, e.sourceLayerIndex, t1, i);
                for(const t1 in o){
                    const i = r[t1] = r[t1] || [], s = o[t1];
                    s.sort((t1, i)=>{
                        const o = e.featureSortOrder;
                        if (o) {
                            const e = o.indexOf(t1.featureIndex);
                            return o.indexOf(i.featureIndex) - e;
                        }
                        return i.featureIndex - t1.featureIndex;
                    });
                    for (const e of s)i.push(e);
                }
            }
            return r;
        }
        function ht(e, t1) {
            const i = e.getRenderableIds().map((t1)=>e.getTileByID(t1)), o = [], s = {};
            for(let e = 0; e < i.length; e++){
                const r = i[e], a = r.tileID.canonical.key;
                s[a] || (s[a] = !0, r.querySourceFeatures(o, t1));
            }
            return o;
        }
        function ut(e, t1) {
            const i = e.tileID, o = t1.tileID;
            return i.overscaledZ - o.overscaledZ || i.canonical.y - o.canonical.y || i.wrap - o.wrap || i.canonical.x - o.canonical.x;
        }
        function dt(e, t1) {
            const i = {};
            if (!t1) return i;
            for (const o of e){
                const e = o.layerIds.map((e)=>t1.getLayer(e)).filter(Boolean);
                if (0 !== e.length) {
                    o.layers = e, o.stateDependentLayerIds && (o.stateDependentLayers = o.stateDependentLayerIds.map((t1)=>e.filter((e)=>e.id === t1)[0]));
                    for (const t1 of e)i[t1.fqid] = o;
                }
            }
            return i;
        }
        const _t = 32, pt = 33, ft = new Uint16Array(8184);
        for(let e = 0; e < 2046; e++){
            let t1 = e + 2, i = 0, o = 0, s = 0, r = 0, a = 0, n = 0;
            for(1 & t1 ? s = r = a = _t : i = o = n = _t; (t1 >>= 1) > 1;){
                const e = i + s >> 1, l = o + r >> 1;
                1 & t1 ? (s = i, r = o, i = a, o = n) : (i = s, o = r, s = a, r = n), a = e, n = l;
            }
            const l = 4 * e;
            ft[l + 0] = i, ft[l + 1] = o, ft[l + 2] = s, ft[l + 3] = r;
        }
        const mt = new Uint16Array(2178), gt = new Uint8Array(1089), vt = new Uint16Array(1089);
        function yt(e) {
            return 0 === e ? -0.03125 : 32 === e ? .03125 : 0;
        }
        const xt = (()=>({
                type: 2,
                extent: e.ag,
                loadGeometry: ()=>[
                        [
                            new e.P(0, 0),
                            new e.P(e.ag + 1, 0),
                            new e.P(e.ag + 1, e.ag + 1),
                            new e.P(0, e.ag + 1),
                            new e.P(0, 0)
                        ]
                    ]
            }))();
        class bt {
            registerFadeDuration(t1) {
                const i = t1 + this.timeAdded;
                i < e.q.now() || this.fadeEndTime && i < this.fadeEndTime || (this.fadeEndTime = i);
            }
            wasRequested() {
                return "errored" === this.state || "loaded" === this.state || "reloading" === this.state;
            }
            get tileTransform() {
                return this._tileTransform || (this._tileTransform = e.aQ(this.tileID.canonical, this.projection)), this._tileTransform;
            }
            loadVectorData(t1, i, o) {
                if (this.unloadVectorData(), this.state = "loaded", t1) {
                    t1.featureIndex && (this.latestFeatureIndex = t1.featureIndex, t1.rawTileData ? (this.latestRawTileData = t1.rawTileData, this.latestFeatureIndex.rawTileData = t1.rawTileData) : this.latestRawTileData && (this.latestFeatureIndex.rawTileData = this.latestRawTileData)), this.collisionBoxArray = t1.collisionBoxArray, this.buckets = dt(t1.buckets, i.style), this.hasSymbolBuckets = !1;
                    for(const t1 in this.buckets){
                        const i = this.buckets[t1];
                        if (i instanceof e.aX) {
                            if (this.hasSymbolBuckets = !0, !o) break;
                            i.justReloaded = !0;
                        }
                    }
                    if (this.hasRTLText = !1, this.hasSymbolBuckets) for(const t1 in this.buckets){
                        const i = this.buckets[t1];
                        if (i instanceof e.aX && i.hasRTLText) {
                            this.hasRTLText = !0, e.aY();
                            break;
                        }
                    }
                    this.queryPadding = 0;
                    for(const e in this.buckets){
                        const t1 = this.buckets[e], o = i.style.getOwnLayer(e);
                        if (!o) continue;
                        const s = o.queryRadius(t1);
                        this.queryPadding = Math.max(this.queryPadding, s);
                    }
                    t1.imageAtlas && (this.imageAtlas = t1.imageAtlas), t1.glyphAtlasImage && (this.glyphAtlasImage = t1.glyphAtlasImage), t1.lineAtlas && (this.lineAtlas = t1.lineAtlas), this._lastUpdatedBrightness = t1.brightness;
                } else this.collisionBoxArray = new e.aW;
            }
            unloadVectorData() {
                if (this.hasData()) {
                    for(const e in this.buckets)this.buckets[e].destroy();
                    this.buckets = {}, this.imageAtlas && (this.imageAtlas = null), this.lineAtlas && (this.lineAtlas = null), this.imageAtlasTexture && this.imageAtlasTexture.destroy(), this.glyphAtlasTexture && this.glyphAtlasTexture.destroy(), this.lineAtlasTexture && this.lineAtlasTexture.destroy(), this._tileBoundsBuffer && (this._tileBoundsBuffer.destroy(), this._tileBoundsIndexBuffer.destroy(), this._tileBoundsSegments.destroy(), this._tileBoundsBuffer = null), this._tileDebugBuffer && (this._tileDebugBuffer.destroy(), this._tileDebugSegments.destroy(), this._tileDebugBuffer = null), this._tileDebugIndexBuffer && (this._tileDebugIndexBuffer.destroy(), this._tileDebugIndexBuffer = null), this._globeTileDebugBorderBuffer && (this._globeTileDebugBorderBuffer.destroy(), this._globeTileDebugBorderBuffer = null), this._tileDebugTextBuffer && (this._tileDebugTextBuffer.destroy(), this._tileDebugTextSegments.destroy(), this._tileDebugTextIndexBuffer.destroy(), this._tileDebugTextBuffer = null), this._globeTileDebugTextBuffer && (this._globeTileDebugTextBuffer.destroy(), this._globeTileDebugTextBuffer = null), this.latestFeatureIndex = null, this.state = "unloaded";
                }
            }
            loadModelData(e, t1, i) {
                e && (e.resourceTiming && (this.resourceTiming = e.resourceTiming), this.buckets = Object.assign({}, this.buckets, dt(e.buckets, t1.style)), e.featureIndex && (this.latestFeatureIndex = e.featureIndex));
            }
            getBucket(e) {
                return this.buckets[e.fqid];
            }
            upload(t1) {
                for(const e in this.buckets){
                    const i = this.buckets[e];
                    i.uploadPending() && i.upload(t1);
                }
                const i = t1.gl, o = this.imageAtlas;
                if (o && !o.uploaded) {
                    const s = !!Object.keys(o.patternPositions).length;
                    this.imageAtlasTexture = new e.T(t1, o.image, i.RGBA8, {
                        useMipmap: s
                    }), this.imageAtlas.uploaded = !0;
                }
                this.glyphAtlasImage && (this.glyphAtlasTexture = new e.T(t1, this.glyphAtlasImage, i.R8), this.glyphAtlasImage = null), this.lineAtlas && !this.lineAtlas.uploaded && (this.lineAtlasTexture = new e.T(t1, this.lineAtlas.image, i.R8), this.lineAtlas.uploaded = !0);
            }
            prepare(e, t1, i) {
                if (this.imageAtlas && this.imageAtlasTexture && this.imageAtlas.patchUpdatedImages(e, this.imageAtlasTexture, i), !t1 || !this.latestFeatureIndex || !this.latestFeatureIndex.rawTileData) return;
                const o = t1.style.getBrightness();
                (this._lastUpdatedBrightness || o) && (this._lastUpdatedBrightness && o && Math.abs(this._lastUpdatedBrightness - o) < .001 || (this.updateBuckets(t1, this._lastUpdatedBrightness !== o), this._lastUpdatedBrightness = o));
            }
            queryRenderedFeatures(t1, i, o, s, r, a) {
                if (!this.latestFeatureIndex || !this.latestFeatureIndex.rawTileData && !this.latestFeatureIndex.is3DTile) return {};
                const n = function(t1, i) {
                    const o = e.ab.mat4.fromScaling([], [
                        .5 * t1.width,
                        .5 * -t1.height,
                        1
                    ]);
                    return e.ab.mat4.translate(o, o, [
                        1,
                        -1,
                        0
                    ]), e.ab.mat4.multiply(o, o, t1.calculateProjMatrix(i.toUnwrapped())), Float32Array.from(o);
                }(r, this.tileID);
                return this.latestFeatureIndex.query(t1, {
                    tilespaceGeometry: i,
                    pixelPosMatrix: n,
                    transform: s,
                    availableImages: o,
                    tileTransform: this.tileTransform
                });
            }
            querySourceFeatures(t1, i) {
                const o = this.latestFeatureIndex;
                if (!o || !o.rawTileData) return;
                const s = o.loadVTLayers(), r = i ? i.sourceLayer : "", a = s._geojsonTileLayer || s[r];
                if (!a) return;
                const n = e.aZ(i && i.filter), { z: l, x: c, y: h } = this.tileID.canonical, u = {
                    z: l,
                    x: c,
                    y: h
                };
                for(let i = 0; i < a.length; i++){
                    const s = a.feature(i);
                    if (n.needGeometry) {
                        const t1 = e.a_(s, !0);
                        if (!n.filter(new e.a8(this.tileID.overscaledZ), t1, this.tileID.canonical)) continue;
                    } else if (!n.filter(new e.a8(this.tileID.overscaledZ), s)) continue;
                    const d = o.getId(s, r), _ = new e.a$(s, l, c, h, d);
                    _.tile = u, t1.push(_);
                }
            }
            hasData() {
                return "loaded" === this.state || "reloading" === this.state || "expired" === this.state;
            }
            patternsLoaded() {
                return !!this.imageAtlas && !!Object.keys(this.imageAtlas.patternPositions).length;
            }
            setExpiryData(t1) {
                const i = this.expirationTime;
                if (t1.cacheControl) {
                    const i = e.b0(t1.cacheControl);
                    i["max-age"] && (this.expirationTime = Date.now() + 1e3 * i["max-age"]);
                } else t1.expires && (this.expirationTime = new Date(t1.expires).getTime());
                if (this.expirationTime) {
                    const e = Date.now();
                    let t1 = !1;
                    if (this.expirationTime > e) t1 = !1;
                    else if (i) {
                        if (this.expirationTime < i) t1 = !0;
                        else {
                            const o = this.expirationTime - i;
                            o ? this.expirationTime = e + Math.max(o, 3e4) : t1 = !0;
                        }
                    } else t1 = !0;
                    t1 ? (this.expiredRequestCount++, this.state = "expired") : this.expiredRequestCount = 0;
                }
            }
            getExpiryTimeout() {
                if (this.expirationTime) return this.expiredRequestCount ? 1e3 * (1 << Math.min(this.expiredRequestCount - 1, 31)) : Math.min(this.expirationTime - (new Date).getTime(), Math.pow(2, 31) - 1);
            }
            refreshFeatureState(e) {
                this.latestFeatureIndex && (this.latestFeatureIndex.rawTileData || this.latestFeatureIndex.is3DTile) && e && this.updateBuckets(e);
            }
            updateBuckets(t1, i) {
                if (!this.latestFeatureIndex) return;
                if (!t1.style) return;
                const o = this.latestFeatureIndex.loadVTLayers(), s = t1.style.listImages(), r = t1.style.getBrightness();
                for(const a in this.buckets){
                    if (!t1.style.hasLayer(a)) continue;
                    const n = this.buckets[a], l = n.layers[0], c = l.sourceLayer || "_geojsonTileLayer", h = o[c], u = t1.style.getLayerSourceCache(l);
                    let d = {};
                    u && (d = u._state.getState(c, void 0));
                    const _ = this.imageAtlas && this.imageAtlas.patternPositions || {}, p = Object.keys(d).length > 0 && !i;
                    p && !n.stateDependentLayers.length && !i || n.update(d, h, s, _, p ? n.stateDependentLayers : n.layers, i, r), (n instanceof e.b1 || n instanceof e.b2) && t1._terrain && t1._terrain.enabled && u && n.programConfigurations.needsUpload && t1._terrain._clearRenderCacheForTile(u.id, this.tileID);
                    const f = t1 && t1.style && t1.style.getOwnLayer(a);
                    f && (this.queryPadding = Math.max(this.queryPadding, f.queryRadius(n)));
                }
            }
            holdingForFade() {
                return void 0 !== this.symbolFadeHoldUntil;
            }
            symbolFadeFinished() {
                return !this.symbolFadeHoldUntil || this.symbolFadeHoldUntil < e.q.now();
            }
            clearFadeHold() {
                this.symbolFadeHoldUntil = void 0;
            }
            setHoldDuration(t1) {
                this.symbolFadeHoldUntil = e.q.now() + t1;
            }
            setTexture(t1, i) {
                const o = i.context, s = o.gl;
                this.texture = this.texture || i.getTileTexture(t1.width), this.texture && this.texture instanceof e.T ? this.texture.update(t1) : (this.texture = new e.T(o, t1, s.RGBA8, {
                    useMipmap: !0
                }), this.texture.bind(s.LINEAR, s.CLAMP_TO_EDGE));
            }
            setDependencies(e, t1) {
                const i = {};
                for (const e of t1)i[e] = !0;
                this.dependencies[e] = i;
            }
            hasDependency(e, t1) {
                for (const i of e){
                    const e = this.dependencies[i];
                    if (e) {
                        for (const i of t1)if (e[i]) return !0;
                    }
                }
                return !1;
            }
            clearQueryDebugViz() {}
            _makeDebugTileBoundsBuffers(t1, i) {
                if (!i || "mercator" === i.name || this._tileDebugBuffer) return;
                const o = e.b3(xt, this.tileID.canonical, this.tileTransform)[0], s = new e.b4, r = new e.b5;
                for(let e = 0; e < o.length; e++){
                    const { x: t1, y: i } = o[e];
                    s.emplaceBack(t1, i), r.emplaceBack(e);
                }
                r.emplaceBack(0), this._tileDebugIndexBuffer = t1.createIndexBuffer(r), this._tileDebugBuffer = t1.createVertexBuffer(s, e.b6.members), this._tileDebugSegments = e.b7.simpleSegment(0, 0, s.length, r.length);
            }
            _makeTileBoundsBuffers(t1, i) {
                if (this._tileBoundsBuffer || !i || "mercator" === i.name) return;
                const o = e.b3(xt, this.tileID.canonical, this.tileTransform)[0];
                let s, r;
                if (this.isRaster) {
                    const t1 = function(t1, i) {
                        const o = e.aQ(t1, i), s = Math.pow(2, t1.z);
                        for(let r = 0; r < pt; r++)for(let a = 0; a < pt; a++){
                            const n = e.aR((t1.x + (a + yt(a)) / _t) / s), l = e.aS((t1.y + (r + yt(r)) / _t) / s), c = i.project(n, l), h = r * pt + a;
                            mt[2 * h + 0] = Math.round((c.x * o.scale - o.x) * e.ag), mt[2 * h + 1] = Math.round((c.y * o.scale - o.y) * e.ag);
                        }
                        gt.fill(0), vt.fill(0);
                        for(let e = 2045; e >= 0; e--){
                            const t1 = 4 * e, i = ft[t1 + 0], o = ft[t1 + 1], s = ft[t1 + 2], r = ft[t1 + 3], a = i + s >> 1, n = o + r >> 1, l = a + n - o, c = n + i - a, h = o * pt + i, u = r * pt + s, d = n * pt + a, _ = Math.hypot((mt[2 * h + 0] + mt[2 * u + 0]) / 2 - mt[2 * d + 0], (mt[2 * h + 1] + mt[2 * u + 1]) / 2 - mt[2 * d + 1]) >= 16;
                            gt[d] = gt[d] || (_ ? 1 : 0), e < 1022 && (gt[d] = gt[d] || gt[(o + c >> 1) * pt + (i + l >> 1)] || gt[(r + c >> 1) * pt + (s + l >> 1)]);
                        }
                        const r = new e.aT, a = new e.aU;
                        let n = 0;
                        function l(t1, i) {
                            const o = i * pt + t1;
                            return 0 === vt[o] && (r.emplaceBack(mt[2 * o + 0], mt[2 * o + 1], t1 * e.ag / _t, i * e.ag / _t), vt[o] = ++n), vt[o] - 1;
                        }
                        function c(e, t1, i, o, s, r) {
                            const n = e + i >> 1, h = t1 + o >> 1;
                            if (Math.abs(e - s) + Math.abs(t1 - r) > 1 && gt[h * pt + n]) c(s, r, e, t1, n, h), c(i, o, s, r, n, h);
                            else {
                                const n = l(e, t1), c = l(i, o), h = l(s, r);
                                a.emplaceBack(n, c, h);
                            }
                        }
                        return c(0, 0, _t, _t, _t, 0), c(_t, _t, 0, 0, 0, _t), {
                            vertices: r,
                            indices: a
                        };
                    }(this.tileID.canonical, i);
                    s = t1.vertices, r = t1.indices;
                } else {
                    s = new e.aT, r = new e.aU;
                    for (const { x: e, y: t1 } of o)s.emplaceBack(e, t1, 0, 0);
                    const t1 = e.b8(s.int16, void 0, 4);
                    for(let e = 0; e < t1.length; e += 3)r.emplaceBack(t1[e], t1[e + 1], t1[e + 2]);
                }
                this._tileBoundsBuffer = t1.createVertexBuffer(s, e.b9.members), this._tileBoundsIndexBuffer = t1.createIndexBuffer(r), this._tileBoundsSegments = e.b7.simpleSegment(0, 0, s.length, r.length);
            }
            _makeGlobeTileDebugBuffers(t1, i) {
                const o = i.projection;
                if (!o || "globe" !== o.name || i.freezeTileCoverage) return;
                const s = this.tileID.canonical, r = e.ba(s, i), a = e.bb(r), n = e.ae(i.zoom);
                let l;
                n > 0 && (l = e.ab.mat4.invert(new Float64Array(16), i.globeMatrix)), this._makeGlobeTileDebugBorderBuffer(t1, s, i, a, l, n), this._makeGlobeTileDebugTextBuffer(t1, s, i, a, l, n);
            }
            _globePoint(t1, i, o, s, r, a, n) {
                let l = e.bc(t1, i, o);
                if (a) {
                    const r = 1 << o.z, c = e.at(s.center.lng), h = e.aA(s.center.lat), u = (o.x + .5) / r - c;
                    let d = 0;
                    u > .5 ? d = -1 : u < -0.5 && (d = 1);
                    let _ = (t1 / e.ag + o.x) / r + d, p = (i / e.ag + o.y) / r;
                    _ = (_ - c) * s._pixelsPerMercatorPixel + c, p = (p - h) * s._pixelsPerMercatorPixel + h;
                    const f = [
                        _ * s.worldSize,
                        p * s.worldSize,
                        0
                    ];
                    e.ab.vec3.transformMat4(f, f, a), l = e.bd(l, f, n);
                }
                return e.ab.vec3.transformMat4(l, l, r);
            }
            _makeGlobeTileDebugBorderBuffer(t1, i, o, s, r, a) {
                const n = new e.b4, l = new e.b5, c = new e.be, h = (e, t1, h, u, d)=>{
                    const _ = (h - e) / (d - 1), p = (u - t1) / (d - 1), f = n.length;
                    for(let h = 0; h < d; h++){
                        const u = e + h * _, d = t1 + h * p;
                        n.emplaceBack(u, d);
                        const m = this._globePoint(u, d, i, o, s, r, a);
                        c.emplaceBack(m[0], m[1], m[2]), l.emplaceBack(f + h);
                    }
                }, u = e.ag;
                h(0, 0, u, 0, 16), h(u, 0, u, u, 16), h(u, u, 0, u, 16), h(0, u, 0, 0, 16), this._tileDebugIndexBuffer = t1.createIndexBuffer(l), this._tileDebugBuffer = t1.createVertexBuffer(n, e.b6.members), this._globeTileDebugBorderBuffer = t1.createVertexBuffer(c, e.bf.members), this._tileDebugSegments = e.b7.simpleSegment(0, 0, n.length, l.length);
            }
            _makeGlobeTileDebugTextBuffer(t1, i, o, s, r, a) {
                const n = e.ag / 4, l = new e.b4, c = new e.aU, h = new e.be, u = 25;
                c.reserve(32), l.reserve(u), h.reserve(u);
                const d = (e, t1)=>u * e + t1;
                for(let e = 0; e < u; e++){
                    const t1 = e * n;
                    for(let e = 0; e < u; e++){
                        const c = e * n;
                        l.emplaceBack(c, t1);
                        const u = this._globePoint(c, t1, i, o, s, r, a);
                        h.emplaceBack(u[0], u[1], u[2]);
                    }
                }
                for(let e = 0; e < 4; e++)for(let t1 = 0; t1 < 4; t1++){
                    const i = d(e, t1), o = d(e, t1 + 1), s = d(e + 1, t1), r = d(e + 1, t1 + 1);
                    c.emplaceBack(i, o, s), c.emplaceBack(s, o, r);
                }
                this._tileDebugTextIndexBuffer = t1.createIndexBuffer(c), this._tileDebugTextBuffer = t1.createVertexBuffer(l, e.b6.members), this._globeTileDebugTextBuffer = t1.createVertexBuffer(h, e.bf.members), this._tileDebugTextSegments = e.b7.simpleSegment(0, 0, u, 32);
            }
            destroy(t1 = !1) {
                for(const e in this.buckets)this.buckets[e].destroy();
                this.buckets = {}, this.imageAtlas && (this.imageAtlas = null), this.lineAtlas && (this.lineAtlas = null), this.imageAtlasTexture && (this.imageAtlasTexture.destroy(), delete this.imageAtlasTexture), this.glyphAtlasTexture && (this.glyphAtlasTexture.destroy(), delete this.glyphAtlasTexture), this.lineAtlasTexture && (this.lineAtlasTexture.destroy(), delete this.lineAtlasTexture), this._tileBoundsBuffer && (this._tileBoundsBuffer.destroy(), this._tileBoundsIndexBuffer.destroy(), this._tileBoundsSegments.destroy(), this._tileBoundsBuffer = null), this._tileDebugBuffer && (this._tileDebugBuffer.destroy(), this._tileDebugSegments.destroy(), this._tileDebugBuffer = null), this._tileDebugIndexBuffer && (this._tileDebugIndexBuffer.destroy(), this._tileDebugIndexBuffer = null), this._globeTileDebugBorderBuffer && (this._globeTileDebugBorderBuffer.destroy(), this._globeTileDebugBorderBuffer = null), this._tileDebugTextBuffer && (this._tileDebugTextBuffer.destroy(), this._tileDebugTextSegments.destroy(), this._tileDebugTextIndexBuffer.destroy(), this._tileDebugTextBuffer = null), this._globeTileDebugTextBuffer && (this._globeTileDebugTextBuffer.destroy(), this._globeTileDebugTextBuffer = null), !t1 && this.texture && this.texture instanceof e.T && (this.texture.destroy(), delete this.texture), this.hillshadeFBO && (this.hillshadeFBO.destroy(), delete this.hillshadeFBO), this.dem && delete this.dem, this.neighboringTiles && delete this.neighboringTiles, this.demTexture && (this.demTexture.destroy(), delete this.demTexture), this.rasterParticleState && (this.rasterParticleState.destroy(), delete this.rasterParticleState), this.latestFeatureIndex = null, this.state = "unloaded";
            }
            constructor(t1, i, o, s, r){
                this.tileID = t1, this.uid = e.aV(), this.uses = 0, this.tileSize = i, this.tileZoom = o, this.buckets = {}, this.expirationTime = null, this.queryPadding = 0, this.hasSymbolBuckets = !1, this.hasRTLText = !1, this.dependencies = {}, this.isRaster = r, s && s.style && (this._lastUpdatedBrightness = s.style.getBrightness()), this.expiredRequestCount = 0, this.state = "loading", s && s.transform && (this.projection = s.transform.projection);
            }
        }
        e.bg.setPbf(e.bh);
        class wt extends bt {
            setTexture(t1, i) {
                const o = i.context, s = o.gl;
                this.texture = this.texture || i.getTileTexture(t1.width), this.texture && this.texture instanceof e.T ? this.texture.update(t1, {
                    premultiply: !1
                }) : this.texture = new e.T(o, t1, s.RGBA8, {
                    premultiply: !1
                });
            }
            flushQueues() {
                for(; this._workQueue.length;)this._workQueue.pop()();
                for(; this._fetchQueue.length;)this._fetchQueue.pop()();
            }
            fetchHeader(t1 = 16384, i) {
                const o = this._mrt = new e.bg(30), s = Object.assign({}, this.requestParams, {
                    headers: {
                        Range: "bytes=0-" + (t1 - 1)
                    }
                });
                return this.entireBuffer = null, this.request = e.bi(s, (e, s, r, a)=>{
                    if (e) i(e);
                    else try {
                        const e = o.getHeaderLength(s);
                        if (e > t1) return void (this.request = this.fetchHeader(e, i));
                        o.parseHeader(s), this._isHeaderLoaded = !0;
                        let n = 0;
                        for (const e of Object.values(o.layers))n = Math.max(n, e.dataIndex[e.dataIndex.length - 1].last_byte);
                        s.byteLength >= n && (this.entireBuffer = s), i(null, this.entireBuffer || s, r, a);
                    } catch (e) {
                        i(e);
                    }
                }), this.request;
            }
            fetchBand(t1, i, o) {
                const s = this._mrt;
                if (!this._isHeaderLoaded || !s) return void o(new Error("Tile header is not ready"));
                const r = this.actor;
                if (!r) return void o(new Error("Can't fetch tile band without an actor"));
                let a;
                const n = (e, s)=>{
                    a.complete(e, s), e ? o(e) : (this.updateTextureDescriptor(t1, i), o(null, this.textureDescriptor && this.textureDescriptor.img));
                }, l = (e, t1)=>{
                    if (e) return o(e);
                    const i = r.send("decodeRasterArray", {
                        buffer: t1,
                        task: a
                    }, n, void 0, !0);
                    this._workQueue.push(()=>{
                        i && i.cancel(), a.cancel();
                    });
                }, c = s.getLayer(t1);
                if (!c) return void o(new Error(`Unknown sourceLayer "${t1}"`));
                if (c.hasDataForBand(i)) return this.updateTextureDescriptor(t1, i), void o(null, this.textureDescriptor ? this.textureDescriptor.img : null);
                const h = c.getDataRange([
                    i
                ]);
                if (a = s.createDecodingTask(h), !a || a.tasks.length) {
                    if (this.flushQueues(), this.entireBuffer) l(null, this.entireBuffer.slice(h.firstByte, h.lastByte + 1));
                    else {
                        const t1 = Object.assign({}, this.requestParams, {
                            headers: {
                                Range: `bytes=${h.firstByte}-${h.lastByte}`
                            }
                        }), i = e.bi(t1, l);
                        this._fetchQueue.push(()=>{
                            i.cancel(), a.cancel();
                        });
                    }
                } else o(null);
            }
            updateNeeded(e, t1) {
                return (!this.textureDescriptor || this.textureDescriptor.band !== t1 || this.textureDescriptor.layer !== e) && "errored" !== this.state;
            }
            updateTextureDescriptor(t1, i) {
                if (!this._mrt) return;
                const o = this._mrt.getLayer(t1);
                if (!o || !o.hasBand(i) || !o.hasDataForBand(i)) return;
                const { bytes: s, tileSize: r, buffer: a, offset: n, scale: l } = o.getBandView(i), c = r + 2 * a, h = {
                    data: s,
                    width: c,
                    height: c
                }, u = this.texture;
                u && u instanceof e.T && u.update(h, {
                    premultiply: !1
                }), this.textureDescriptor = {
                    layer: t1,
                    band: i,
                    img: h,
                    buffer: a,
                    offset: n,
                    tileSize: r,
                    format: o.pixelFormat,
                    mix: [
                        l,
                        256 * l,
                        65536 * l,
                        16777216 * l
                    ]
                };
            }
            constructor(e, t1, i, o, s){
                super(e, t1, i, o, s), this._workQueue = [], this._fetchQueue = [], this._isHeaderLoaded = !1;
            }
        }
        class Tt {
            reset() {
                for(const e in this.data)for (const t1 of this.data[e])t1.timeout && clearTimeout(t1.timeout), this.onRemove(t1.value);
                return this.data = {}, this.order = [], this;
            }
            add(e, t1, i) {
                const o = e.wrapped().key;
                void 0 === this.data[o] && (this.data[o] = []);
                const s = {
                    value: t1,
                    timeout: void 0
                };
                if (void 0 !== i && (s.timeout = setTimeout(()=>{
                    this.remove(e, s);
                }, i)), this.data[o].push(s), this.order.push(o), this.order.length > this.max) {
                    const e = this._getAndRemoveByKey(this.order[0]);
                    e && this.onRemove(e);
                }
                return this;
            }
            has(e) {
                return e.wrapped().key in this.data;
            }
            getAndRemove(e) {
                return this.has(e) ? this._getAndRemoveByKey(e.wrapped().key) : null;
            }
            _getAndRemoveByKey(e) {
                const t1 = this.data[e].shift();
                return t1.timeout && clearTimeout(t1.timeout), 0 === this.data[e].length && delete this.data[e], this.order.splice(this.order.indexOf(e), 1), t1.value;
            }
            getByKey(e) {
                const t1 = this.data[e];
                return t1 ? t1[0].value : null;
            }
            get(e) {
                return this.has(e) ? this.data[e.wrapped().key][0].value : null;
            }
            remove(e, t1) {
                if (!this.has(e)) return this;
                const i = e.wrapped().key, o = void 0 === t1 ? 0 : this.data[i].indexOf(t1), s = this.data[i][o];
                return this.data[i].splice(o, 1), s.timeout && clearTimeout(s.timeout), 0 === this.data[i].length && delete this.data[i], this.onRemove(s.value), this.order.splice(this.order.indexOf(i), 1), this;
            }
            setMaxSize(e) {
                for(this.max = e; this.order.length > this.max;){
                    const e = this._getAndRemoveByKey(this.order[0]);
                    e && this.onRemove(e);
                }
                return this;
            }
            filter(e) {
                const t1 = [];
                for(const i in this.data)for (const o of this.data[i])e(o.value) || t1.push(o);
                for (const e of t1)this.remove(e.value.tileID, e);
            }
            constructor(e, t1){
                this.max = e, this.onRemove = t1, this.reset();
            }
        }
        class Et {
            updateState(t1, i, o) {
                const s = String(i);
                if (this.stateChanges[t1] = this.stateChanges[t1] || {}, this.stateChanges[t1][s] = this.stateChanges[t1][s] || {}, e.l(this.stateChanges[t1][s], o), null === this.deletedStates[t1]) {
                    this.deletedStates[t1] = {};
                    for(const e in this.state[t1])e !== s && (this.deletedStates[t1][e] = null);
                } else if (this.deletedStates[t1] && null === this.deletedStates[t1][s]) {
                    this.deletedStates[t1][s] = {};
                    for(const e in this.state[t1][s])o[e] || (this.deletedStates[t1][s][e] = null);
                } else for(const e in o)this.deletedStates[t1] && this.deletedStates[t1][s] && null === this.deletedStates[t1][s][e] && delete this.deletedStates[t1][s][e];
            }
            removeFeatureState(e, t1, i) {
                if (null === this.deletedStates[e]) return;
                const o = String(t1);
                if (this.deletedStates[e] = this.deletedStates[e] || {}, i && void 0 !== t1) null !== this.deletedStates[e][o] && (this.deletedStates[e][o] = this.deletedStates[e][o] || {}, this.deletedStates[e][o][i] = null);
                else if (void 0 !== t1) {
                    if (this.stateChanges[e] && this.stateChanges[e][o]) for(i in this.deletedStates[e][o] = {}, this.stateChanges[e][o])this.deletedStates[e][o][i] = null;
                    else this.deletedStates[e][o] = null;
                } else this.deletedStates[e] = null;
            }
            getState(t1, i) {
                const o = this.state[t1] || {}, s = this.stateChanges[t1] || {}, r = this.deletedStates[t1];
                if (null === r) return {};
                if (void 0 !== i) {
                    const t1 = String(i), a = e.l({}, o[t1], s[t1]);
                    if (r) {
                        const e = r[i];
                        if (null === e) return {};
                        for(const t1 in e)delete a[t1];
                    }
                    return a;
                }
                const a = e.l({}, o, s);
                if (r) for(const e in r)delete a[e];
                return a;
            }
            initializeTileState(e, t1) {
                e.refreshFeatureState(t1);
            }
            coalesceChanges(t1, i) {
                const o = {};
                for(const t1 in this.stateChanges){
                    this.state[t1] = this.state[t1] || {};
                    const i = {};
                    for(const o in this.stateChanges[t1])this.state[t1][o] || (this.state[t1][o] = {}), e.l(this.state[t1][o], this.stateChanges[t1][o]), i[o] = this.state[t1][o];
                    o[t1] = i;
                }
                for(const t1 in this.deletedStates){
                    this.state[t1] = this.state[t1] || {};
                    const i = {};
                    if (null === this.deletedStates[t1]) for(const e in this.state[t1])i[e] = {}, this.state[t1][e] = {};
                    else for(const e in this.deletedStates[t1]){
                        if (null === this.deletedStates[t1][e]) this.state[t1][e] = {};
                        else if (this.state[t1][e]) for (const i of Object.keys(this.deletedStates[t1][e]))delete this.state[t1][e][i];
                        i[e] = this.state[t1][e];
                    }
                    o[t1] = o[t1] || {}, e.l(o[t1], i);
                }
                if (this.stateChanges = {}, this.deletedStates = {}, 0 !== Object.keys(o).length) for(const e in t1)t1[e].refreshFeatureState(i);
            }
            constructor(){
                this.state = {}, this.stateChanges = {}, this.deletedStates = {};
            }
        }
        class St extends e.E {
            onAdd(e) {
                this.map = e, this._minTileCacheSize = void 0 === this._minTileCacheSize && e ? e._minTileCacheSize : this._minTileCacheSize, this._maxTileCacheSize = void 0 === this._maxTileCacheSize && e ? e._maxTileCacheSize : this._maxTileCacheSize;
            }
            loaded() {
                if (this._sourceErrored) return !0;
                if (!this._sourceLoaded) return !1;
                if (!this._source.loaded()) return !1;
                for(const e in this._tiles){
                    const t1 = this._tiles[e];
                    if ("loaded" !== t1.state && "errored" !== t1.state) return !1;
                }
                return !0;
            }
            getSource() {
                return this._source;
            }
            pause() {
                this._paused = !0;
            }
            resume() {
                if (!this._paused) return;
                const e = this._shouldReloadOnResume;
                this._paused = !1, this._shouldReloadOnResume = !1, e && this.reload(), this.transform && this.update(this.transform);
            }
            _loadTile(e, t1) {
                return e.isSymbolTile = this._onlySymbols, e.isExtraShadowCaster = this._shadowCasterTiles[e.tileID.key], this._source.loadTile(e, t1);
            }
            _unloadTile(e) {
                if (this._source.unloadTile) return this._source.unloadTile(e);
            }
            _abortTile(e) {
                if (this._source.abortTile) return this._source.abortTile(e);
            }
            serialize() {
                return this._source.serialize();
            }
            prepare(e) {
                this._source.prepare && this._source.prepare(), this._state.coalesceChanges(this._tiles, this.map ? this.map.painter : null);
                for(const t1 in this._tiles){
                    const i = this._tiles[t1];
                    i.upload(e), i.prepare(this.map.style.imageManager, this.map ? this.map.painter : null, this._source.scope);
                }
            }
            getIds() {
                return e.bj(this._tiles).map((e)=>e.tileID).sort(Ct).map((e)=>e.key);
            }
            getRenderableIds(t1, i) {
                const o = [];
                for(const e in this._tiles)this._isIdRenderable(+e, t1, i) && o.push(this._tiles[e]);
                return t1 ? o.sort((t1, i)=>{
                    const o = t1.tileID, s = i.tileID, r = new e.P(o.canonical.x, o.canonical.y)._rotate(this.transform.angle), a = new e.P(s.canonical.x, s.canonical.y)._rotate(this.transform.angle);
                    return o.overscaledZ - s.overscaledZ || a.y - r.y || a.x - r.x;
                }).map((e)=>e.tileID.key) : o.map((e)=>e.tileID).sort(Ct).map((e)=>e.key);
            }
            hasRenderableParent(e) {
                const t1 = this.findLoadedParent(e, 0);
                return !!t1 && this._isIdRenderable(t1.tileID.key);
            }
            _isIdRenderable(e, t1, i) {
                return this._tiles[e] && this._tiles[e].hasData() && !this._coveredTiles[e] && (t1 || !this._tiles[e].holdingForFade()) && (i || !this._shadowCasterTiles[e]);
            }
            reload() {
                if (this._paused) this._shouldReloadOnResume = !0;
                else {
                    this._cache.reset();
                    for(const e in this._tiles)"errored" !== this._tiles[e].state && this._reloadTile(+e, "reloading");
                }
            }
            _reloadTile(e, t1) {
                const i = this._tiles[e];
                i && ("loading" !== i.state && (i.state = t1), this._loadTile(i, this._tileLoaded.bind(this, i, e, t1)));
            }
            _tileLoaded(t1, i, o, s) {
                if (s) {
                    if (t1.state = "errored", 404 !== s.status) this._source.fire(new e.y(s, {
                        tile: t1
                    }));
                    else {
                        if (this._source.fire(new e.z("data", {
                            dataType: "source",
                            sourceDataType: "error",
                            sourceId: this._source.id,
                            tile: t1
                        })), !(t1.tileID.key in this._loadedParentTiles)) return;
                        if ("raster-dem" === this._source.type && this.usedForTerrain && this.map.painter.terrain) {
                            const e = this.map.painter.terrain;
                            this.update(this.transform, e.getScaledDemTileSize(), !0), e.resetTileLookupCache(this.id);
                        } else this.update(this.transform);
                    }
                } else t1.timeAdded = e.q.now(), "expired" === o && (t1.refreshedUponExpiration = !0), this._setTileReloadTimer(i, t1), "raster-dem" === this._source.type && t1.dem && this._backfillDEM(t1), this._state.initializeTileState(t1, this.map ? this.map.painter : null), this._source.fire(new e.z("data", {
                    dataType: "source",
                    tile: t1,
                    coord: t1.tileID,
                    sourceCacheId: this.id
                }));
            }
            _backfillDEM(e) {
                const t1 = this.getRenderableIds();
                for(let o = 0; o < t1.length; o++){
                    const s = t1[o];
                    if (e.neighboringTiles && e.neighboringTiles[s]) {
                        const t1 = this.getTileByID(s);
                        i(e, t1), i(t1, e);
                    }
                }
                function i(e, t1) {
                    if (!e.dem || e.dem.borderReady) return;
                    e.needsHillshadePrepare = !0, e.needsDEMTextureUpload = !0;
                    let i = t1.tileID.canonical.x - e.tileID.canonical.x;
                    const o = t1.tileID.canonical.y - e.tileID.canonical.y, s = Math.pow(2, e.tileID.canonical.z), r = t1.tileID.key;
                    0 === i && 0 === o || Math.abs(o) > 1 || (Math.abs(i) > 1 && (1 === Math.abs(i + s) ? i += s : 1 === Math.abs(i - s) && (i -= s)), t1.dem && e.dem && (e.dem.backfillBorder(t1.dem, i, o), e.neighboringTiles && e.neighboringTiles[r] && (e.neighboringTiles[r].backfilled = !0)));
                }
            }
            getTile(e) {
                return this.getTileByID(e.key);
            }
            getTileByID(e) {
                return this._tiles[e];
            }
            _retainLoadedChildren(e, t1, i, o) {
                for(const s in this._tiles){
                    let r = this._tiles[s];
                    if (o[s] || !r.hasData() || r.tileID.overscaledZ <= t1 || r.tileID.overscaledZ > i) continue;
                    let a = r.tileID;
                    for(; r && r.tileID.overscaledZ > t1 + 1;){
                        const e = r.tileID.scaledTo(r.tileID.overscaledZ - 1);
                        r = this._tiles[e.key], r && r.hasData() && (a = e);
                    }
                    let n = a;
                    for(; n.overscaledZ > t1;)if (n = n.scaledTo(n.overscaledZ - 1), e[n.key]) {
                        o[a.key] = a;
                        break;
                    }
                }
            }
            findLoadedParent(e, t1) {
                if (e.key in this._loadedParentTiles) {
                    const i = this._loadedParentTiles[e.key];
                    return i && i.tileID.overscaledZ >= t1 ? i : null;
                }
                for(let i = e.overscaledZ - 1; i >= t1; i--){
                    const t1 = e.scaledTo(i), o = this._getLoadedTile(t1);
                    if (o) return o;
                }
            }
            _getLoadedTile(e) {
                const t1 = this._tiles[e.key];
                return t1 && t1.hasData() ? t1 : this._cache.getByKey(this._source.reparseOverscaled ? e.wrapped().key : e.canonical.key);
            }
            updateCacheSize(e, t1) {
                t1 = t1 || this._source.tileSize;
                const i = Math.ceil(e.width / t1) + 1, o = Math.ceil(e.height / t1) + 1, s = Math.floor(i * o * 5), r = "number" == typeof this._minTileCacheSize ? Math.max(this._minTileCacheSize, s) : s, a = "number" == typeof this._maxTileCacheSize ? Math.min(this._maxTileCacheSize, r) : r;
                this._cache.setMaxSize(a);
            }
            handleWrapJump(e) {
                const t1 = Math.round((e - (void 0 === this._prevLng ? e : this._prevLng)) / 360);
                if (this._prevLng = e, t1) {
                    const e = {};
                    for(const i in this._tiles){
                        const o = this._tiles[i];
                        o.tileID = o.tileID.unwrapTo(o.tileID.wrap + t1), e[o.tileID.key] = o;
                    }
                    this._tiles = e;
                    for(const e in this._timers)clearTimeout(this._timers[e]), delete this._timers[e];
                    for(const e in this._tiles)this._setTileReloadTimer(+e, this._tiles[e]);
                }
            }
            update(t1, i, o, s) {
                if (this.transform = t1, !this._sourceLoaded || this._paused || this.transform.freezeTileCoverage) return;
                if (this.usedForTerrain && !o) return;
                this.updateCacheSize(t1, i), "globe" !== this.transform.projection.name && this.handleWrapJump(this.transform.center.lng), this._shadowCasterTiles = {}, this._coveredTiles = {};
                const r = "batched-model" === this._source.type;
                let a, n = this._source.maxzoom;
                const l = this.map && this.map.painter ? this.map.painter._terrain : null;
                if (l && l.sourceCache === this && l.attenuationRange()) {
                    const e = l.attenuationRange()[0], t1 = Math.floor(e) - Math.log2(l.getDemUpscale());
                    n > t1 && (n = t1);
                }
                if (this.used || this.usedForTerrain) {
                    if (this._source.tileID) a = t1.getVisibleUnwrappedCoordinates(this._source.tileID).map((t1)=>new e.aG(t1.canonical.z, t1.wrap, t1.canonical.z, t1.canonical.x, t1.canonical.y));
                    else if (0 !== this.tileCoverLift) {
                        const s = t1.clone();
                        s.tileCoverLift = this.tileCoverLift, a = s.coveringTiles({
                            tileSize: i || this._source.tileSize,
                            minzoom: this._source.minzoom,
                            maxzoom: n,
                            roundZoom: this._source.roundZoom && !o,
                            reparseOverscaled: this._source.reparseOverscaled,
                            isTerrainDEM: this.usedForTerrain,
                            calculateQuadrantVisibility: r
                        }), this._source.minzoom <= 1 && "globe" === t1.projection.name && (a.push(new e.aG(1, 0, 1, 0, 0)), a.push(new e.aG(1, 0, 1, 1, 0)), a.push(new e.aG(1, 0, 1, 0, 1)), a.push(new e.aG(1, 0, 1, 1, 1)));
                    } else if (a = t1.coveringTiles({
                        tileSize: i || this._source.tileSize,
                        minzoom: this._source.minzoom,
                        maxzoom: n,
                        roundZoom: this._source.roundZoom && !o,
                        reparseOverscaled: this._source.reparseOverscaled,
                        isTerrainDEM: this.usedForTerrain,
                        calculateQuadrantVisibility: r
                    }), this._source.hasTile) {
                        const e = this._source.hasTile.bind(this._source);
                        a = a.filter((t1)=>e(t1));
                    }
                } else a = [];
                if (a.length > 0 && this.castsShadows && s && "globe" !== this.transform.projection.name && !this.usedForTerrain && !It(this._source.type)) {
                    const e = t1.coveringZoomLevel({
                        tileSize: i || this._source.tileSize,
                        roundZoom: this._source.roundZoom && !o
                    }), n = Math.min(e, this._source.maxzoom);
                    if (r) {
                        const e = t1.extendTileCover(a, n);
                        for (const t1 of e)a.push(t1);
                    } else {
                        const e = t1.extendTileCover(a, n, s);
                        for (const t1 of e)this._shadowCasterTiles[t1.key] = !0, a.push(t1);
                    }
                }
                const c = this._updateRetainedTiles(a);
                if (It(this._source.type) && 0 !== a.length) {
                    const t1 = {}, i = {}, o = Object.keys(c);
                    for (const s of o){
                        const o = c[s], r = this._tiles[s];
                        if (!r || r.fadeEndTime && r.fadeEndTime <= e.q.now()) continue;
                        const a = this.findLoadedParent(o, Math.max(o.overscaledZ - St.maxOverzooming, this._source.minzoom));
                        a && (this._addTile(a.tileID), t1[a.tileID.key] = a.tileID), i[s] = o;
                    }
                    const s = a[a.length - 1].overscaledZ;
                    for(const e in this._tiles){
                        const t1 = this._tiles[e];
                        if (c[e] || !t1.hasData()) continue;
                        let o = t1.tileID;
                        for(; o.overscaledZ > s;){
                            o = o.scaledTo(o.overscaledZ - 1);
                            const s = this._tiles[o.key];
                            if (s && s.hasData() && i[o.key]) {
                                c[e] = t1.tileID;
                                break;
                            }
                        }
                    }
                    for(const e in t1)c[e] || (this._coveredTiles[e] = !0, c[e] = t1[e]);
                }
                for(const e in c)this._tiles[e].clearFadeHold();
                const h = e.bk(this._tiles, c);
                for (const e of h){
                    const t1 = this._tiles[e];
                    t1.hasSymbolBuckets && !t1.holdingForFade() ? t1.setHoldDuration(this.map._fadeDuration) : t1.hasSymbolBuckets && !t1.symbolFadeFinished() || this._removeTile(+e);
                }
                this._updateLoadedParentTileCache(), this._onlySymbols && this._source.afterUpdate && this._source.afterUpdate();
            }
            releaseSymbolFadeTiles() {
                for(const e in this._tiles)this._tiles[e].holdingForFade() && this._removeTile(+e);
            }
            _updateRetainedTiles(e) {
                const t1 = {};
                if (0 === e.length) return t1;
                const i = {}, o = e.reduce((e, t1)=>Math.min(e, t1.overscaledZ), 1 / 0), s = e[0].overscaledZ, r = Math.max(s - St.maxOverzooming, this._source.minzoom), a = Math.max(s + St.maxUnderzooming, this._source.minzoom), n = {};
                for (const i of e){
                    const e = this._addTile(i);
                    t1[i.key] = i, e.hasData() || o < this._source.maxzoom && (n[i.key] = i);
                }
                this._retainLoadedChildren(n, o, a, t1);
                for (const o of e){
                    let e = this._tiles[o.key];
                    if (e.hasData()) continue;
                    if (o.canonical.z >= this._source.maxzoom) {
                        const e = o.children(this._source.maxzoom)[0], i = this.getTile(e);
                        if (i && i.hasData()) {
                            t1[e.key] = e;
                            continue;
                        }
                    } else {
                        const e = o.children(this._source.maxzoom);
                        if (t1[e[0].key] && t1[e[1].key] && t1[e[2].key] && t1[e[3].key]) continue;
                    }
                    let s = e.wasRequested();
                    for(let a = o.overscaledZ - 1; a >= r; --a){
                        const r = o.scaledTo(a);
                        if (i[r.key]) break;
                        if (i[r.key] = !0, e = this.getTile(r), !e && s && (e = this._addTile(r)), e && (t1[r.key] = r, s = e.wasRequested(), e.hasData())) break;
                    }
                }
                return t1;
            }
            _updateLoadedParentTileCache() {
                this._loadedParentTiles = {};
                for(const e in this._tiles){
                    const t1 = [];
                    let i, o = this._tiles[e].tileID;
                    for(; o.overscaledZ > 0;){
                        if (o.key in this._loadedParentTiles) {
                            i = this._loadedParentTiles[o.key];
                            break;
                        }
                        t1.push(o.key);
                        const e = o.scaledTo(o.overscaledZ - 1);
                        if (i = this._getLoadedTile(e), i) break;
                        o = e;
                    }
                    for (const e of t1)this._loadedParentTiles[e] = i;
                }
            }
            _addTile(t1) {
                let i = this._tiles[t1.key];
                if (i) return !0 !== i.isExtraShadowCaster || !!this._shadowCasterTiles[t1.key] || this._reloadTile(t1.key, "reloading"), i;
                i = this._cache.getAndRemove(t1), i && (this._setTileReloadTimer(t1.key, i), i.tileID = t1, this._state.initializeTileState(i, this.map ? this.map.painter : null), this._cacheTimers[t1.key] && (clearTimeout(this._cacheTimers[t1.key]), delete this._cacheTimers[t1.key], this._setTileReloadTimer(t1.key, i)));
                const o = Boolean(i);
                if (!o) {
                    const e = this.map ? this.map.painter : null, o = this._source.tileSize * t1.overscaleFactor();
                    i = "raster-array" === this._source.type ? new wt(t1, o, this.transform.tileZoom, e, this._isRaster) : new bt(t1, o, this.transform.tileZoom, e, this._isRaster), this._loadTile(i, this._tileLoaded.bind(this, i, t1.key, i.state));
                }
                return i ? (i.uses++, this._tiles[t1.key] = i, o || this._source.fire(new e.z("dataloading", {
                    tile: i,
                    coord: i.tileID,
                    dataType: "source"
                })), i) : null;
            }
            _setTileReloadTimer(e, t1) {
                e in this._timers && (clearTimeout(this._timers[e]), delete this._timers[e]);
                const i = t1.getExpiryTimeout();
                i && (this._timers[e] = setTimeout(()=>{
                    this._reloadTile(e, "expired"), delete this._timers[e];
                }, i));
            }
            _removeTile(e) {
                const t1 = this._tiles[e];
                t1 && (t1.uses--, delete this._tiles[e], this._timers[e] && (clearTimeout(this._timers[e]), delete this._timers[e]), t1.uses > 0 || (t1.hasData() && "reloading" !== t1.state || "empty" === t1.state ? this._cache.add(t1.tileID, t1, t1.getExpiryTimeout()) : (t1.aborted = !0, this._abortTile(t1), this._unloadTile(t1))));
            }
            clearTiles() {
                this._shouldReloadOnResume = !1, this._paused = !1;
                for(const e in this._tiles)this._removeTile(+e);
                this._source._clear && this._source._clear(), this._cache.reset(), this.map && this.usedForTerrain && this.map.painter.terrain && this.map.painter.terrain.resetTileLookupCache(this.id);
            }
            tilesIn(t1, i, o) {
                const s = [], r = this.transform;
                if (!r) return s;
                const a = "globe" === r.projection.name, n = e.at(r.center.lng);
                for(const l in this._tiles){
                    const c = this._tiles[l];
                    if (o && c.clearQueryDebugViz(), c.holdingForFade()) continue;
                    let h;
                    if (a) {
                        const t1 = c.tileID.canonical;
                        if (0 === t1.z) {
                            const i = [
                                Math.abs(e.aw(n, ...Rt(t1, -1)) - n),
                                Math.abs(e.aw(n, ...Rt(t1, 1)) - n)
                            ];
                            h = [
                                0,
                                2 * i.indexOf(Math.min(...i)) - 1
                            ];
                        } else {
                            const i = [
                                Math.abs(e.aw(n, ...Rt(t1, -1)) - n),
                                Math.abs(e.aw(n, ...Rt(t1, 0)) - n),
                                Math.abs(e.aw(n, ...Rt(t1, 1)) - n)
                            ];
                            h = [
                                i.indexOf(Math.min(...i)) - 1
                            ];
                        }
                    } else h = [
                        0
                    ];
                    for (const e of h){
                        const o = t1.containsTile(c, r, i, e);
                        o && s.push(o);
                    }
                }
                return s;
            }
            getShadowCasterCoordinates() {
                return this._getRenderableCoordinates(!1, !0);
            }
            getVisibleCoordinates(e) {
                return this._getRenderableCoordinates(e);
            }
            _getRenderableCoordinates(e, t1) {
                const i = this.getRenderableIds(e, t1).map((e)=>this._tiles[e].tileID), o = "globe" === this.transform.projection.name;
                for (const e of i)e.projMatrix = this.transform.calculateProjMatrix(e.toUnwrapped()), e.expandedProjMatrix = o ? this.transform.calculateProjMatrix(e.toUnwrapped(), !1, !0) : e.projMatrix;
                return i;
            }
            sortCoordinatesByDistance(e) {
                const t1 = e.slice(), i = this.transform._camera.position, o = this.transform._camera.forward(), s = {};
                for (const e of t1){
                    const t1 = 1 / (1 << e.canonical.z);
                    s[e.key] = ((e.canonical.x + .5) * t1 + e.wrap - i[0]) * o[0] + ((e.canonical.y + .5) * t1 - i[1]) * o[1] - i[2] * o[2];
                }
                return t1.sort((e, t1)=>s[e.key] - s[t1.key]), t1;
            }
            hasTransition() {
                if (this._source.hasTransition()) return !0;
                if (It(this._source.type)) for(const t1 in this._tiles){
                    const i = this._tiles[t1];
                    if (void 0 !== i.fadeEndTime && i.fadeEndTime >= e.q.now()) return !0;
                }
                return !1;
            }
            setFeatureState(e, t1, i) {
                this._state.updateState(e = e || "_geojsonTileLayer", t1, i);
            }
            removeFeatureState(e, t1, i) {
                this._state.removeFeatureState(e = e || "_geojsonTileLayer", t1, i);
            }
            getFeatureState(e, t1) {
                return this._state.getState(e = e || "_geojsonTileLayer", t1);
            }
            setDependencies(e, t1, i) {
                const o = this._tiles[e];
                o && o.setDependencies(t1, i);
            }
            reloadTilesForDependencies(e, t1) {
                for(const i in this._tiles)this._tiles[i].hasDependency(e, t1) && this._reloadTile(+i, "reloading");
                this._cache.filter((i)=>!i.hasDependency(e, t1));
            }
            _preloadTiles(t1, i) {
                if (!this._sourceLoaded) {
                    const e = ()=>{
                        this._sourceLoaded && (this._source.off("data", e), this._preloadTiles(t1, i));
                    };
                    return void this._source.on("data", e);
                }
                const o = new Map, s = Array.isArray(t1) ? t1 : [
                    t1
                ], r = this.map.painter.terrain, a = this.usedForTerrain && r ? r.getScaledDemTileSize() : this._source.tileSize;
                for (const e of s){
                    const t1 = e.coveringTiles({
                        tileSize: a,
                        minzoom: this._source.minzoom,
                        maxzoom: this._source.maxzoom,
                        roundZoom: this._source.roundZoom && !this.usedForTerrain,
                        reparseOverscaled: this._source.reparseOverscaled,
                        isTerrainDEM: this.usedForTerrain
                    });
                    for (const e of t1)o.set(e.key, e);
                    this.usedForTerrain && e.updateElevation(!1);
                }
                const n = Array.from(o.values());
                e.bl(n, (e, t1)=>{
                    const i = new bt(e, this._source.tileSize * e.overscaleFactor(), this.transform.tileZoom, this.map.painter, this._isRaster);
                    this._loadTile(i, (e)=>{
                        "raster-dem" === this._source.type && i.dem && this._backfillDEM(i), t1(e, i);
                    });
                }, i);
            }
            constructor(e, t1, i){
                super(), this.id = e, this._onlySymbols = i, t1.on("data", (e)=>{
                    "source" === e.dataType && "metadata" === e.sourceDataType && (this._sourceLoaded = !0), this._sourceLoaded && !this._paused && "source" === e.dataType && "content" === e.sourceDataType && (this.reload(), this.transform && this.update(this.transform));
                }), t1.on("error", ()=>{
                    this._sourceErrored = !0;
                }), this._source = t1, this._tiles = {}, this._cache = new Tt(0, this._unloadTile.bind(this)), this._timers = {}, this._cacheTimers = {}, this._minTileCacheSize = t1.minTileCacheSize, this._maxTileCacheSize = t1.maxTileCacheSize, this._loadedParentTiles = {}, this.castsShadows = !1, this.tileCoverLift = 0, this._coveredTiles = {}, this._shadowCasterTiles = {}, this._state = new Et, this._isRaster = "raster" === this._source.type || "raster-dem" === this._source.type || "raster-array" === this._source.type || "custom" === this._source.type && "raster" === this._source._dataType;
            }
        }
        function Ct(e, t1) {
            const i = Math.abs(2 * e.wrap) - +(e.wrap < 0), o = Math.abs(2 * t1.wrap) - +(t1.wrap < 0);
            return e.overscaledZ - t1.overscaledZ || o - i || t1.canonical.y - e.canonical.y || t1.canonical.x - e.canonical.x;
        }
        function It(e) {
            return "raster" === e || "image" === e || "video" === e || "custom" === e;
        }
        function Rt(e, t1) {
            const i = 1 << e.z;
            return [
                e.x / i + t1,
                (e.x + 1) / i + t1
            ];
        }
        St.maxOverzooming = 10, St.maxUnderzooming = 3;
        class Dt {
            processLayersChanged() {
                this.layers = [];
                const e = !1, t1 = !1;
                for(const i in this.style._mergedLayers){
                    const o = this.style._mergedLayers[i];
                    if ("fill-extrusion" === o.type) this.layers.push({
                        layer: o,
                        visible: e,
                        visibilityChanged: t1
                    });
                    else if ("model" === o.type) {
                        const i = this.style.getLayerSource(o);
                        i && "batched-model" === i.type && this.layers.push({
                            layer: o,
                            visible: e,
                            visibilityChanged: t1
                        });
                    }
                }
            }
            onNewFrame(e) {
                this.layersGotHidden = !1;
                for (const t1 of this.layers){
                    const i = t1.layer;
                    let o = !1;
                    "fill-extrusion" === i.type ? o = !i.isHidden(e) && i.paint.get("fill-extrusion-opacity") > 0 : "model" === i.type && (o = !i.isHidden(e) && i.paint.get("model-opacity").constantOr(1) > 0), this.layersGotHidden = this.layersGotHidden || !o && t1.visible, t1.visible = o;
                }
            }
            updateZOffset(e, t1) {
                this.currentBuildingBuckets = [];
                for (const e of this.layers){
                    const i = e.layer, o = this.style.getLayerSourceCache(i);
                    let s = 1;
                    "fill-extrusion" === i.type && (s = e.visible ? i.paint.get("fill-extrusion-vertical-scale") : 0);
                    let r = o ? o.getTile(t1) : null;
                    if (!r && o && t1.canonical.z > o.getSource().minzoom) {
                        let e = t1.scaledTo(Math.min(o.getSource().maxzoom, t1.overscaledZ - 1));
                        for(; e.overscaledZ >= o.getSource().minzoom && (r = o.getTile(e), !r && 0 !== e.overscaledZ);)e = e.scaledTo(e.overscaledZ - 1);
                    }
                    this.currentBuildingBuckets.push({
                        bucket: r ? r.getBucket(i) : null,
                        tileID: r ? r.tileID : t1,
                        verticalScale: s
                    });
                }
                e.hasAnyZOffset = !1;
                let i = !1;
                for(let o = 0; o < e.symbolInstances.length; o++){
                    const s = e.symbolInstances.get(o), r = s.zOffset, a = this._getHeightAtTileOffset(t1, s.tileAnchorX, s.tileAnchorY);
                    s.zOffset = a !== Number.NEGATIVE_INFINITY ? a : r, i || r === s.zOffset || (i = !0), e.hasAnyZOffset || 0 === s.zOffset || (e.hasAnyZOffset = !0);
                }
                i && (e.zOffsetBuffersNeedUpload = !0, e.zOffsetSortDirty = !0);
            }
            _mapCoordToOverlappingTile(t1, i, o, s) {
                let r = i, a = o;
                if (t1.canonical.z !== s.canonical.z) {
                    const n = s.canonical, l = 1 / (1 << t1.canonical.z - n.z);
                    r = (i + t1.canonical.x * e.ag) * l - n.x * e.ag | 0, a = (o + t1.canonical.y * e.ag) * l - n.y * e.ag | 0;
                }
                return {
                    tileX: r,
                    tileY: a
                };
            }
            _getHeightAtTileOffset(e, t1, i) {
                let o, s;
                for(let r = 0; r < this.layers.length; ++r){
                    if ("fill-extrusion" !== this.layers[r].layer.type) continue;
                    const { bucket: a, tileID: n, verticalScale: l } = this.currentBuildingBuckets[r];
                    if (!a) continue;
                    const { tileX: c, tileY: h } = this._mapCoordToOverlappingTile(e, t1, i, n), u = a.getHeightAtTileCoord(c, h);
                    u && void 0 !== u.height && (u.hidden ? o = u.height : s = Math.max(u.height * l, s || 0));
                }
                if (void 0 !== s) return s;
                for(let s = 0; s < this.layers.length; ++s){
                    const r = this.layers[s];
                    if ("model" !== r.layer.type || !r.visible) continue;
                    const { bucket: a, tileID: n } = this.currentBuildingBuckets[s];
                    if (!a) continue;
                    const { tileX: l, tileY: c } = this._mapCoordToOverlappingTile(e, t1, i, n), h = a.getHeightAtTileCoord(l, c);
                    if (h && !h.hidden) return void 0 === h.height && void 0 !== o ? Math.min(h.maxHeight, o) * h.verticalScale : h.height ? h.height * h.verticalScale : Number.NEGATIVE_INFINITY;
                }
                return this.layersGotHidden ? 0 : Number.NEGATIVE_INFINITY;
            }
            constructor(e){
                this.style = e, this.layersGotHidden = !1, this.layers = [];
            }
        }
        function Lt(t1, i) {
            const o = {};
            for(const e in t1)"ref" !== e && (o[e] = t1[e]);
            return e.bm.forEach((e)=>{
                e in i && (o[e] = i[e]);
            }), o;
        }
        function At(e) {
            e = e.slice();
            const t1 = Object.create(null);
            for(let i = 0; i < e.length; i++)t1[e[i].id] = e[i];
            for(let i = 0; i < e.length; i++)"ref" in e[i] && (e[i] = Lt(e[i], t1[e[i].ref]));
            return e;
        }
        const zt = {
            setStyle: "setStyle",
            addLayer: "addLayer",
            removeLayer: "removeLayer",
            setPaintProperty: "setPaintProperty",
            setLayoutProperty: "setLayoutProperty",
            setSlot: "setSlot",
            setFilter: "setFilter",
            addSource: "addSource",
            removeSource: "removeSource",
            setGeoJSONSourceData: "setGeoJSONSourceData",
            setLayerZoomRange: "setLayerZoomRange",
            setLayerProperty: "setLayerProperty",
            setCenter: "setCenter",
            setZoom: "setZoom",
            setBearing: "setBearing",
            setPitch: "setPitch",
            setSprite: "setSprite",
            setGlyphs: "setGlyphs",
            setTransition: "setTransition",
            setLight: "setLight",
            setTerrain: "setTerrain",
            setFog: "setFog",
            setSnow: "setSnow",
            setRain: "setRain",
            setCamera: "setCamera",
            setLights: "setLights",
            setProjection: "setProjection",
            addImport: "addImport",
            removeImport: "removeImport",
            updateImport: "updateImport"
        };
        function Pt(e, t1, i) {
            i.push({
                command: zt.addSource,
                args: [
                    e,
                    t1[e]
                ]
            });
        }
        function Mt(e, t1, i) {
            t1.push({
                command: zt.removeSource,
                args: [
                    e
                ]
            }), i[e] = !0;
        }
        function Ot(e, t1, i, o) {
            Mt(e, i, o), Pt(e, t1, i);
        }
        function Ft(t1, i, o) {
            let s;
            for(s in t1[o])if (t1[o].hasOwnProperty(s) && "data" !== s && !e.bn(t1[o][s], i[o][s])) return !1;
            for(s in i[o])if (i[o].hasOwnProperty(s) && "data" !== s && !e.bn(t1[o][s], i[o][s])) return !1;
            return !0;
        }
        function kt(t1, i, o, s, r, a) {
            let n;
            for(n in i = i || {}, t1 = t1 || {})t1.hasOwnProperty(n) && (e.bn(t1[n], i[n]) || o.push({
                command: a,
                args: [
                    s,
                    n,
                    i[n],
                    r
                ]
            }));
            for(n in i)i.hasOwnProperty(n) && !t1.hasOwnProperty(n) && (e.bn(t1[n], i[n]) || o.push({
                command: a,
                args: [
                    s,
                    n,
                    i[n],
                    r
                ]
            }));
        }
        function Bt(e) {
            return e.id;
        }
        function Nt(e, t1) {
            return e[t1.id] = t1, e;
        }
        class Ut {
            reset(e, t1) {
                this.points = e || [], this._distances = [
                    0
                ];
                for(let e = 1; e < this.points.length; e++)this._distances[e] = this._distances[e - 1] + this.points[e].dist(this.points[e - 1]);
                this.length = this._distances[this._distances.length - 1], this.padding = Math.min(t1 || 0, .5 * this.length), this.paddedLength = this.length - 2 * this.padding;
            }
            lerp(t1) {
                if (1 === this.points.length) return this.points[0];
                t1 = e.aw(t1, 0, 1);
                let i = 1, o = this._distances[i];
                const s = t1 * this.paddedLength + this.padding;
                for(; o < s && i < this._distances.length;)o = this._distances[++i];
                const r = i - 1, a = this._distances[r], n = o - a, l = n > 0 ? (s - a) / n : 0;
                return this.points[r].mult(1 - l).add(this.points[i].mult(l));
            }
            constructor(e, t1){
                this.reset(e, t1);
            }
        }
        class jt {
            keysLength() {
                return this.boxKeys.length + this.circleKeys.length;
            }
            insert(e, t1, i, o, s) {
                this._forEachCell(t1, i, o, s, this._insertBoxCell, this.boxUid++), this.boxKeys.push(e), this.bboxes.push(t1), this.bboxes.push(i), this.bboxes.push(o), this.bboxes.push(s);
            }
            insertCircle(e, t1, i, o) {
                this._forEachCell(t1 - o, i - o, t1 + o, i + o, this._insertCircleCell, this.circleUid++), this.circleKeys.push(e), this.circles.push(t1), this.circles.push(i), this.circles.push(o);
            }
            _insertBoxCell(e, t1, i, o, s, r) {
                this.boxCells[s].push(r);
            }
            _insertCircleCell(e, t1, i, o, s, r) {
                this.circleCells[s].push(r);
            }
            _query(e, t1, i, o, s, r) {
                if (i < 0 || e > this.width || o < 0 || t1 > this.height) return !s && [];
                const a = [];
                if (e <= 0 && t1 <= 0 && this.width <= i && this.height <= o) {
                    if (s) return !0;
                    for(let e = 0; e < this.boxKeys.length; e++)a.push({
                        key: this.boxKeys[e],
                        x1: this.bboxes[4 * e],
                        y1: this.bboxes[4 * e + 1],
                        x2: this.bboxes[4 * e + 2],
                        y2: this.bboxes[4 * e + 3]
                    });
                    for(let e = 0; e < this.circleKeys.length; e++){
                        const t1 = this.circles[3 * e], i = this.circles[3 * e + 1], o = this.circles[3 * e + 2];
                        a.push({
                            key: this.circleKeys[e],
                            x1: t1 - o,
                            y1: i - o,
                            x2: t1 + o,
                            y2: i + o
                        });
                    }
                    return r ? a.filter(r) : a;
                }
                return this._forEachCell(e, t1, i, o, this._queryCell, a, {
                    hitTest: s,
                    seenUids: {
                        box: {},
                        circle: {}
                    }
                }, r), s ? a.length > 0 : a;
            }
            _queryCircle(e, t1, i, o, s) {
                const r = e - i, a = e + i, n = t1 - i, l = t1 + i;
                if (a < 0 || r > this.width || l < 0 || n > this.height) return !o && [];
                const c = [];
                return this._forEachCell(r, n, a, l, this._queryCellCircle, c, {
                    hitTest: o,
                    circle: {
                        x: e,
                        y: t1,
                        radius: i
                    },
                    seenUids: {
                        box: {},
                        circle: {}
                    }
                }, s), o ? c.length > 0 : c;
            }
            query(e, t1, i, o, s) {
                return this._query(e, t1, i, o, !1, s);
            }
            hitTest(e, t1, i, o, s) {
                return this._query(e, t1, i, o, !0, s);
            }
            hitTestCircle(e, t1, i, o) {
                return this._queryCircle(e, t1, i, !0, o);
            }
            _queryCell(e, t1, i, o, s, r, a, n) {
                const l = a.seenUids, c = this.boxCells[s];
                if (null !== c) {
                    const s = this.bboxes;
                    for (const h of c)if (!l.box[h]) {
                        l.box[h] = !0;
                        const c = 4 * h;
                        if (e <= s[c + 2] && t1 <= s[c + 3] && i >= s[c + 0] && o >= s[c + 1] && (!n || n(this.boxKeys[h]))) {
                            if (a.hitTest) return r.push(!0), !0;
                            r.push({
                                key: this.boxKeys[h],
                                x1: s[c],
                                y1: s[c + 1],
                                x2: s[c + 2],
                                y2: s[c + 3]
                            });
                        }
                    }
                }
                const h = this.circleCells[s];
                if (null !== h) {
                    const s = this.circles;
                    for (const c of h)if (!l.circle[c]) {
                        l.circle[c] = !0;
                        const h = 3 * c;
                        if (this._circleAndRectCollide(s[h], s[h + 1], s[h + 2], e, t1, i, o) && (!n || n(this.circleKeys[c]))) {
                            if (a.hitTest) return r.push(!0), !0;
                            {
                                const e = s[h], t1 = s[h + 1], i = s[h + 2];
                                r.push({
                                    key: this.circleKeys[c],
                                    x1: e - i,
                                    y1: t1 - i,
                                    x2: e + i,
                                    y2: t1 + i
                                });
                            }
                        }
                    }
                }
            }
            _queryCellCircle(e, t1, i, o, s, r, a, n) {
                const l = a.circle, c = a.seenUids, h = this.boxCells[s];
                if (null !== h) {
                    const e = this.bboxes;
                    for (const t1 of h)if (!c.box[t1]) {
                        c.box[t1] = !0;
                        const i = 4 * t1;
                        if (this._circleAndRectCollide(l.x, l.y, l.radius, e[i + 0], e[i + 1], e[i + 2], e[i + 3]) && (!n || n(this.boxKeys[t1]))) return r.push(!0), !0;
                    }
                }
                const u = this.circleCells[s];
                if (null !== u) {
                    const e = this.circles;
                    for (const t1 of u)if (!c.circle[t1]) {
                        c.circle[t1] = !0;
                        const i = 3 * t1;
                        if (this._circlesCollide(e[i], e[i + 1], e[i + 2], l.x, l.y, l.radius) && (!n || n(this.circleKeys[t1]))) return r.push(!0), !0;
                    }
                }
            }
            _forEachCell(e, t1, i, o, s, r, a, n) {
                const l = this._convertToXCellCoord(e), c = this._convertToYCellCoord(t1), h = this._convertToXCellCoord(i), u = this._convertToYCellCoord(o);
                for(let d = l; d <= h; d++)for(let l = c; l <= u; l++)if (s.call(this, e, t1, i, o, this.xCellCount * l + d, r, a, n)) return;
            }
            _convertToXCellCoord(e) {
                return Math.max(0, Math.min(this.xCellCount - 1, Math.floor(e * this.xScale)));
            }
            _convertToYCellCoord(e) {
                return Math.max(0, Math.min(this.yCellCount - 1, Math.floor(e * this.yScale)));
            }
            _circlesCollide(e, t1, i, o, s, r) {
                const a = o - e, n = s - t1, l = i + r;
                return l * l > a * a + n * n;
            }
            _circleAndRectCollide(e, t1, i, o, s, r, a) {
                const n = (r - o) / 2, l = Math.abs(e - (o + n));
                if (l > n + i) return !1;
                const c = (a - s) / 2, h = Math.abs(t1 - (s + c));
                if (h > c + i) return !1;
                if (l <= n || h <= c) return !0;
                const u = l - n, d = h - c;
                return u * u + d * d <= i * i;
            }
            constructor(e, t1, i){
                const o = this.boxCells = [], s = this.circleCells = [];
                this.xCellCount = Math.ceil(e / i), this.yCellCount = Math.ceil(t1 / i);
                for(let e = 0; e < this.xCellCount * this.yCellCount; e++)o.push([]), s.push([]);
                this.circleKeys = [], this.boxKeys = [], this.bboxes = [], this.circles = [], this.width = e, this.height = t1, this.xScale = this.xCellCount / e, this.yScale = this.yCellCount / t1, this.boxUid = 0, this.circleUid = 0;
            }
        }
        const Gt = {
            unknown: 0,
            flipRequired: 1,
            flipNotRequired: 2
        }, Vt = Math.tan(85 * Math.PI / 180);
        function qt(t1, i, o, s, r, a, n) {
            const l = e.ab.mat4.create();
            if (o) {
                if ("globe" === a.name) {
                    const t1 = e.bo(r, i);
                    e.ab.mat4.multiply(l, l, t1);
                } else {
                    const t1 = e.ab.mat2.invert([], n);
                    l[0] = t1[0], l[1] = t1[1], l[4] = t1[2], l[5] = t1[3], s || e.ab.mat4.rotateZ(l, l, r.angle);
                }
            } else e.ab.mat4.multiply(l, r.labelPlaneMatrix, t1);
            return l;
        }
        function Ht(e, t1, i, o, s, r, a) {
            const n = qt(e, t1, i, o, s, r, a);
            return "globe" === r.name && i || (n[2] = n[6] = n[10] = n[14] = 0), n;
        }
        function Zt(t1, i, o, s, r, a, n) {
            if (o) {
                if ("globe" === a.name) {
                    const l = qt(t1, i, o, s, r, a, n);
                    return e.ab.mat4.invert(l, l), e.ab.mat4.multiply(l, t1, l), l;
                }
                {
                    const i = e.ab.mat4.clone(t1), o = e.ab.mat4.identity([]);
                    return o[0] = n[0], o[1] = n[1], o[4] = n[2], o[5] = n[3], e.ab.mat4.multiply(i, i, o), s || e.ab.mat4.rotateZ(i, i, -r.angle), i;
                }
            }
            return r.glCoordMatrix;
        }
        function Wt(t1, i, o, s) {
            const r = [
                t1,
                i,
                o,
                1
            ];
            o ? e.ab.vec4.transformMat4(r, r, s) : si(r, r, s);
            const a = r[3];
            return r[0] /= a, r[1] /= a, r[2] /= a, r;
        }
        function $t(e, t1) {
            return Math.min(.5 + e / t1 * .5, 1.5);
        }
        function Xt(e, t1) {
            const i = e[0] / e[3], o = e[1] / e[3];
            return i >= -t1[0] && i <= t1[0] && o >= -t1[1] && o <= t1[1];
        }
        function Kt(t1, i, o, s, r, a, n, l, c, h) {
            const u = o.transform, d = s ? t1.textSizeData : t1.iconSizeData, _ = e.bp(d, o.transform.zoom), p = "globe" === u.projection.name, f = [
                256 / o.width * 2 + 1,
                256 / o.height * 2 + 1
            ], m = s ? t1.text.dynamicLayoutVertexArray : t1.icon.dynamicLayoutVertexArray;
            m.clear();
            let g = null;
            p && (g = s ? t1.text.globeExtVertexArray : t1.icon.globeExtVertexArray);
            const v = t1.lineVertexArray, y = s ? t1.text.placedSymbolArray : t1.icon.placedSymbolArray, x = o.transform.width / o.transform.height;
            let b, w = !1;
            for(let s = 0; s < y.length; s++){
                const p = y.get(s), { numGlyphs: T, writingMode: E } = p;
                if (E !== e.bq.vertical || w || b === e.bq.horizontal || (w = !0), b = E, (p.hidden || E === e.bq.vertical) && !w) {
                    oi(T, m);
                    continue;
                }
                w = !1;
                const S = new e.P(p.tileAnchorX, p.tileAnchorY);
                let { x: C, y: I, z: R } = u.projection.projectTilePoint(S.x, S.y, h.canonical);
                if (c) {
                    const [e, t1, i] = c(S);
                    C += e, I += t1, R += i;
                }
                const D = [
                    C,
                    I,
                    R,
                    1
                ];
                if (e.ab.vec4.transformMat4(D, D, i), !Xt(D, f)) {
                    oi(T, m);
                    continue;
                }
                const L = D[3], A = $t(o.transform.getCameraToCenterDistance(u.projection), L), z = e.br(d, _, p), P = n ? z / A : z * A, M = Wt(C, I, R, r);
                if (M[3] <= 0) {
                    oi(T, m);
                    continue;
                }
                let O = {};
                const F = n ? null : c, k = Qt(p, P, !1, l, i, r, a, t1.glyphOffsetArray, v, m, g, M, S, O, x, F, u.projection, h, n);
                w = k.useVertical, F && k.needsFlipping && (O = {}), (k.notEnoughRoom || w || k.needsFlipping && Qt(p, P, !0, l, i, r, a, t1.glyphOffsetArray, v, m, g, M, S, O, x, F, u.projection, h, n).notEnoughRoom) && oi(T, m);
            }
            s ? (t1.text.dynamicLayoutVertexBuffer.updateData(m), g && t1.text.globeExtVertexBuffer && t1.text.globeExtVertexBuffer.updateData(g)) : (t1.icon.dynamicLayoutVertexBuffer.updateData(m), g && t1.icon.globeExtVertexBuffer && t1.icon.globeExtVertexBuffer.updateData(g));
        }
        function Yt(e, t1, i, o, s, r, a, n, l, c, h, u, d, _, p, f) {
            const { lineStartIndex: m, glyphStartIndex: g, segment: v } = n, y = g + n.numGlyphs, x = m + n.lineLength, b = t1.getoffsetX(g), w = t1.getoffsetX(y - 1), T = ii(e * b, i, o, s, r, a, v, m, x, l, c, h, u, d, !0, _, p, f);
            if (!T) return null;
            const E = ii(e * w, i, o, s, r, a, v, m, x, l, c, h, u, d, !0, _, p, f);
            return E ? {
                first: T,
                last: E
            } : null;
        }
        function Jt(t1, i, o, s) {
            return t1 === e.bq.horizontal && Math.abs(s) > Math.abs(o) ? {
                useVertical: !0
            } : t1 === e.bq.vertical ? s > 0 ? {
                needsFlipping: !0
            } : null : i !== Gt.unknown && function(e, t1) {
                return 0 === e || Math.abs(t1 / e) > Vt;
            }(o, s) ? i === Gt.flipRequired ? {
                needsFlipping: !0
            } : null : o < 0 ? {
                needsFlipping: !0
            } : null;
        }
        function Qt(t1, i, o, s, r, a, n, l, c, h, u, d, _, p, f, m, g, v, y) {
            const x = i / 24, b = t1.lineOffsetX * x, w = t1.lineOffsetY * x, { lineStartIndex: T, glyphStartIndex: E, numGlyphs: S, segment: C, writingMode: I, flipState: R } = t1, D = T + t1.lineLength, L = (t1)=>{
                if (u) {
                    const [i, o, s] = t1.up, r = h.length;
                    e.bs(u, r + 0, i, o, s), e.bs(u, r + 1, i, o, s), e.bs(u, r + 2, i, o, s), e.bs(u, r + 3, i, o, s);
                }
                const [i, o, s] = t1.point;
                e.bt(h, i, o, s, t1.angle);
            };
            if (S > 1) {
                const e = Yt(x, l, b, w, o, d, _, t1, c, a, p, m, !1, g, v, y);
                if (!e) return {
                    notEnoughRoom: !0
                };
                if (s && !o) {
                    let [i, o, s] = e.first.point, [r, a, l] = e.last.point;
                    [i, o] = Wt(i, o, s, n), [r, a] = Wt(r, a, l, n);
                    const c = Jt(I, R, (r - i) * f, a - o);
                    if (t1.flipState = c && c.needsFlipping ? Gt.flipRequired : Gt.flipNotRequired, c) return c;
                }
                L(e.first);
                for(let e = E + 1; e < E + S - 1; e++){
                    const t1 = ii(x * l.getoffsetX(e), b, w, o, d, _, C, T, D, c, a, p, m, !1, !1, g, v, y);
                    if (!t1) return h.length -= 4 * (e - E), {
                        notEnoughRoom: !0
                    };
                    L(t1);
                }
                L(e.last);
            } else {
                if (s && !o) {
                    const i = Wt(_.x, _.y, 0, r), o = T + C + 1, s = new e.P(c.getx(o), c.gety(o)), a = Wt(s.x, s.y, 0, r), n = a[3] > 0 ? a : ti(_, s, i, 1, r, void 0, g, v.canonical), l = Jt(I, R, (n[0] - i[0]) * f, n[1] - i[1]);
                    if (t1.flipState = l && l.needsFlipping ? Gt.flipRequired : Gt.flipNotRequired, l) return l;
                }
                const i = ii(x * l.getoffsetX(E), b, w, o, d, _, C, T, D, c, a, p, m, !1, !1, g, v, y);
                if (!i) return {
                    notEnoughRoom: !0
                };
                L(i);
            }
            return {};
        }
        function ei(e, t1, i, o, s) {
            const { x: r, y: a, z: n } = o.projectTilePoint(e.x, e.y, t1);
            if (!s) return Wt(r, a, n, i);
            const [l, c, h] = s(e);
            return Wt(r + l, a + c, n + h, i);
        }
        function ti(t1, i, o, s, r, a, n, l) {
            const c = ei(t1.sub(i)._unit()._add(t1), l, r, n, a);
            return e.ab.vec3.sub(c, o, c), e.ab.vec3.normalize(c, c), e.ab.vec3.scaleAndAdd(c, o, c, s);
        }
        function ii(t1, i, o, s, r, a, n, l, c, h, u, d, _, p, f, m, g, v) {
            const y = s ? t1 - i : t1 + i;
            let x = y > 0 ? 1 : -1, b = 0;
            s && (x *= -1, b = Math.PI), x < 0 && (b += Math.PI);
            let w = l + n + (x > 0 ? 0 : 1) | 0, T = r, E = r, S = 0, C = 0;
            const I = Math.abs(y), R = [], D = [];
            let L = a, A = L;
            const z = ()=>ti(A, L, E, I - S + 1, u, _, m, g.canonical);
            for(; S + C <= I;){
                if (w += x, w < l || w >= c) return null;
                if (E = T, A = L, R.push(E), p && D.push(A), L = new e.P(h.getx(w), h.gety(w)), T = d[w], !T) {
                    const e = ei(L, g.canonical, u, m, _);
                    T = e[3] > 0 ? d[w] = e : z();
                }
                S += C, C = e.ab.vec3.distance(E, T);
            }
            f && _ && (d[w] && (T = z(), C = e.ab.vec3.distance(E, T)), d[w] = T);
            const P = (I - S) / C, M = L.sub(A)._mult(P)._add(A), O = e.ab.vec3.sub([], T, E), F = e.ab.vec3.scaleAndAdd([], E, O, P);
            let k = [
                0,
                0,
                1
            ], B = O[0], N = O[1];
            if (v && (k = m.upVector(g.canonical, M.x, M.y), 0 !== k[0] || 0 !== k[1] || 1 !== k[2])) {
                const t1 = [
                    k[2],
                    0,
                    -k[0]
                ], i = e.ab.vec3.cross([], k, t1);
                e.ab.vec3.normalize(t1, t1), e.ab.vec3.normalize(i, i), B = e.ab.vec3.dot(O, t1), N = e.ab.vec3.dot(O, i);
            }
            if (o) {
                const t1 = e.ab.vec3.cross([], k, O);
                e.ab.vec3.normalize(t1, t1), e.ab.vec3.scaleAndAdd(F, F, t1, o * x);
            }
            const U = b + Math.atan2(N, B);
            return R.push(F), p && D.push(M), {
                point: F,
                angle: U,
                path: R,
                tilePath: D,
                up: k
            };
        }
        function oi(e, t1) {
            const i = t1.length, o = i + 4 * e;
            t1.resize(o), t1.float32.fill(-1 / 0, 4 * i, 4 * o);
        }
        function si(e, t1, i) {
            const o = t1[0], s = t1[1];
            return e[0] = i[0] * o + i[4] * s + i[12], e[1] = i[1] * o + i[5] * s + i[13], e[3] = i[3] * o + i[7] * s + i[15], e;
        }
        const ri = 100;
        class ai {
            placeCollisionBox(e, t1, i, o, s, r, a, n) {
                let l = i.projectedAnchorX, c = i.projectedAnchorY, h = i.projectedAnchorZ;
                const u = i.elevation, d = i.tileID, _ = e.getProjection();
                if (u && d) {
                    const [e, t1, o] = _.upVector(d.canonical, i.tileAnchorX, i.tileAnchorY), s = _.upVectorScale(d.canonical, this.transform.center.lat, this.transform.worldSize).metersToTile;
                    l += e * u * s, c += t1 * u * s, h += o * u * s;
                }
                const p = this.projectAndGetPerspectiveRatio(a, l, c, h, i.tileID, "globe" === _.name || !!u || this.transform.pitch > 0, _), f = r * p.perspectiveRatio, m = (i.x1 * t1 + o.x - i.padding) * f + p.point.x, g = (i.y1 * t1 + o.y - i.padding) * f + p.point.y, v = (i.x2 * t1 + o.x + i.padding) * f + p.point.x, y = (i.y2 * t1 + o.y + i.padding) * f + p.point.y, x = p.perspectiveRatio <= .55 || p.occluded;
                return !this.isInsideGrid(m, g, v, y) || !s && this.grid.hitTest(m, g, v, y, n) || x ? {
                    box: [],
                    offscreen: !1,
                    occluded: p.occluded
                } : {
                    box: [
                        m,
                        g,
                        v,
                        y
                    ],
                    offscreen: this.isOffscreen(m, g, v, y),
                    occluded: !1
                };
            }
            placeCollisionCircles(t1, i, o, s, r, a, n, l, c, h, u, d, _, p, f) {
                const m = [], g = this.transform.elevation, v = t1.getProjection(), y = g ? g.getAtTileOffsetFunc(f, this.transform.center.lat, this.transform.worldSize, v) : null, x = new e.P(o.tileAnchorX, o.tileAnchorY);
                let { x: b, y: w, z: T } = v.projectTilePoint(x.x, x.y, f.canonical);
                if (y) {
                    const [e, t1, i] = y(x);
                    b += e, w += t1, T += i;
                }
                const E = "globe" === v.name, S = this.projectAndGetPerspectiveRatio(n, b, w, T, f, E || !!g || this.transform.pitch > 0, v), { perspectiveRatio: C } = S, I = (u ? a / C : a * C) / e.bw, R = Wt(b, w, T, l), D = S.signedDistanceFromCamera > 0 ? Yt(I, r, o.lineOffsetX * I, o.lineOffsetY * I, !1, R, x, o, s, l, {}, g && !u ? y : null, u && !!g, v, f, u) : null;
                let L = !1, A = !1, z = !0;
                if (D && !S.occluded) {
                    const t1 = .5 * _ * C + p, o = new e.P(-100, -100), s = new e.P(this.screenRightBoundary, this.screenBottomBoundary), r = new Ut, { first: a, last: n } = D, l = a.path.length;
                    let u = [];
                    for(let e = l - 1; e >= 1; e--)u.push(a.path[e]);
                    for(let e = 1; e < n.path.length; e++)u.push(n.path[e]);
                    const f = 2.5 * t1;
                    c && (u = u.map(([e, t1, i], o)=>(y && !E && (i = y(o < l - 1 ? a.tilePath[l - 1 - o] : n.tilePath[o - l + 2])[2]), Wt(e, t1, i, c))), u.some((e)=>e[3] <= 0) && (u = []));
                    let g = [];
                    if (u.length > 0) {
                        let t1 = 1 / 0, i = -1 / 0, r = 1 / 0, a = -1 / 0;
                        for (const e of u)t1 = Math.min(t1, e[0]), r = Math.min(r, e[1]), i = Math.max(i, e[0]), a = Math.max(a, e[1]);
                        i >= o.x && t1 <= s.x && a >= o.y && r <= s.y && (g = [
                            u.map((t1)=>new e.P(t1[0], t1[1]))
                        ], (t1 < o.x || i > s.x || r < o.y || a > s.y) && (g = e.bu(g, o.x, o.y, s.x, s.y)));
                    }
                    for (const e of g){
                        r.reset(e, .25 * t1);
                        let o = 0;
                        o = r.length <= .5 * t1 ? 1 : Math.ceil(r.paddedLength / f) + 1;
                        for(let e = 0; e < o; e++){
                            const s = e / Math.max(o - 1, 1), a = r.lerp(s), n = a.x + ri, l = a.y + ri;
                            m.push(n, l, t1, 0);
                            const c = n - t1, u = l - t1, _ = n + t1, p = l + t1;
                            if (z = z && this.isOffscreen(c, u, _, p), A = A || this.isInsideGrid(c, u, _, p), !i && this.grid.hitTestCircle(n, l, t1, d) && (L = !0, !h)) return {
                                circles: [],
                                offscreen: !1,
                                collisionDetected: L,
                                occluded: !1
                            };
                        }
                    }
                }
                return {
                    circles: !h && L || !A ? [] : m,
                    offscreen: z,
                    collisionDetected: L,
                    occluded: S.occluded
                };
            }
            queryRenderedSymbols(t1) {
                if (0 === t1.length || 0 === this.grid.keysLength() && 0 === this.ignoredGrid.keysLength()) return {};
                const i = [];
                let o = 1 / 0, s = 1 / 0, r = -1 / 0, a = -1 / 0;
                for (const n of t1){
                    const t1 = new e.P(n.x + ri, n.y + ri);
                    o = Math.min(o, t1.x), s = Math.min(s, t1.y), r = Math.max(r, t1.x), a = Math.max(a, t1.y), i.push(t1);
                }
                const n = this.grid.query(o, s, r, a).concat(this.ignoredGrid.query(o, s, r, a)), l = {}, c = {};
                for (const t1 of n){
                    const o = t1.key;
                    if (void 0 === l[o.bucketInstanceId] && (l[o.bucketInstanceId] = {}), l[o.bucketInstanceId][o.featureIndex]) continue;
                    const s = [
                        new e.P(t1.x1, t1.y1),
                        new e.P(t1.x2, t1.y1),
                        new e.P(t1.x2, t1.y2),
                        new e.P(t1.x1, t1.y2)
                    ];
                    e.bv(i, s) && (l[o.bucketInstanceId][o.featureIndex] = !0, void 0 === c[o.bucketInstanceId] && (c[o.bucketInstanceId] = []), c[o.bucketInstanceId].push(o.featureIndex));
                }
                return c;
            }
            insertCollisionBox(e, t1, i, o, s) {
                (t1 ? this.ignoredGrid : this.grid).insert({
                    bucketInstanceId: i,
                    featureIndex: o,
                    collisionGroupID: s
                }, e[0], e[1], e[2], e[3]);
            }
            insertCollisionCircles(e, t1, i, o, s) {
                const r = t1 ? this.ignoredGrid : this.grid, a = {
                    bucketInstanceId: i,
                    featureIndex: o,
                    collisionGroupID: s
                };
                for(let t1 = 0; t1 < e.length; t1 += 4)r.insertCircle(a, e[t1], e[t1 + 1], e[t1 + 2]);
            }
            projectAndGetPerspectiveRatio(t1, i, o, s, r, a, n) {
                const l = [
                    i,
                    o,
                    s,
                    1
                ];
                let c = !1;
                if (s || this.transform.pitch > 0) {
                    if (e.ab.vec4.transformMat4(l, l, t1), this.fogState && r && "globe" !== n.name) {
                        const t1 = function(t1, i, o, s, r, a) {
                            const n = a.calculateFogTileMatrix(r), l = [
                                i,
                                o,
                                s
                            ];
                            return e.ab.vec3.transformMat4(l, l, n), ke(t1, e.ab.vec3.length(l), a.pitch, a._fov);
                        }(this.fogState, i, o, s, r.toUnwrapped(), this.transform);
                        c = t1 > .9;
                    }
                } else si(l, l, t1);
                const h = l[3];
                return {
                    point: new e.P((l[0] / h + 1) / 2 * this.transform.width + ri, (-l[1] / h + 1) / 2 * this.transform.height + ri),
                    perspectiveRatio: Math.min(.5 + this.transform.getCameraToCenterDistance(n) / h * .5, 1.5),
                    signedDistanceFromCamera: h,
                    occluded: a && l[2] > h || c
                };
            }
            isOffscreen(e, t1, i, o) {
                return i < ri || e >= this.screenRightBoundary || o < ri || t1 > this.screenBottomBoundary;
            }
            isInsideGrid(e, t1, i, o) {
                return i >= 0 && e < this.gridRightBoundary && o >= 0 && t1 < this.gridBottomBoundary;
            }
            getViewportMatrix() {
                const t1 = e.ab.mat4.identity([]);
                return e.ab.mat4.translate(t1, t1, [
                    -100,
                    -100,
                    0
                ]), t1;
            }
            constructor(e, t1, i = new jt(e.width + 200, e.height + 200, 25), o = new jt(e.width + 200, e.height + 200, 25)){
                this.transform = e, this.grid = i, this.ignoredGrid = o, this.pitchfactor = Math.cos(e._pitch) * e.cameraToCenterDistance, this.screenRightBoundary = e.width + ri, this.screenBottomBoundary = e.height + ri, this.gridRightBoundary = e.width + 200, this.gridBottomBoundary = e.height + 200, this.fogState = t1;
            }
        }
        function ni(t1, i, o) {
            const s = i.createTileMatrix(t1, t1.worldSize, o.toUnwrapped());
            return e.ab.mat4.multiply(new Float32Array(16), t1.projMatrix, s);
        }
        function li(e, t1, i) {
            if (t1.projection.name === i.projection.name) return e.projMatrix;
            const o = i.clone();
            return o.setProjection(t1.projection), ni(o, t1.getProjection(), e);
        }
        function ci(e, t1, i) {
            return t1.name === i.projection.name ? e.projMatrix : ni(i, t1, e);
        }
        class hi {
            isHidden() {
                return 0 === this.opacity && !this.placed;
            }
            constructor(e, t1, i, o){
                this.opacity = e ? Math.max(0, Math.min(1, e.opacity + (e.placed ? t1 : -t1))) : o && i ? 1 : 0, this.placed = i;
            }
        }
        class ui {
            isHidden() {
                return this.text.isHidden() && this.icon.isHidden();
            }
            constructor(e, t1, i, o, s, r = !1){
                this.text = new hi(e ? e.text : null, t1, i, s), this.icon = new hi(e ? e.icon : null, t1, o, s), this.clipped = r;
            }
        }
        class di {
            constructor(e, t1, i, o = !1){
                this.text = e, this.icon = t1, this.skipFade = i, this.clipped = o;
            }
        }
        class _i {
            constructor(){
                this.invProjMatrix = e.ab.mat4.create(), this.viewportMatrix = e.ab.mat4.create(), this.circles = [];
            }
        }
        class pi {
            constructor(e, t1, i, o, s){
                this.bucketInstanceId = e, this.featureIndex = t1, this.sourceLayerIndex = i, this.bucketIndex = o, this.tileID = s;
            }
        }
        class fi {
            get(e) {
                if (this.crossSourceCollisions) return {
                    ID: 0,
                    predicate: null
                };
                if (!this.collisionGroups[e]) {
                    const t1 = ++this.maxGroupID;
                    this.collisionGroups[e] = {
                        ID: t1,
                        predicate: (e)=>e.collisionGroupID === t1
                    };
                }
                return this.collisionGroups[e];
            }
            constructor(e){
                this.crossSourceCollisions = e, this.maxGroupID = 0, this.collisionGroups = {};
            }
        }
        function mi(t1, i, o, s, r) {
            const { horizontalAlign: a, verticalAlign: n } = e.bD(t1), l = -(a - .5) * i, c = -(n - .5) * o, h = e.bC(t1, s);
            return new e.P(l + h[0] * r, c + h[1] * r);
        }
        function gi(t1, i, o, s, r) {
            const a = new e.P(t1, i);
            return o && a._rotate(s ? r : -r), a;
        }
        class vi {
            getBucketParts(t1, i, o, s, r = 1) {
                const a = o.getBucket(i), n = o.latestFeatureIndex;
                if (!a || !n || i.fqid !== a.layerIds[0]) return;
                const l = a.layers[0].layout, c = a.layers[0].paint, h = o.collisionBoxArray, u = Math.pow(2, this.transform.zoom - o.tileID.overscaledZ), d = o.tileSize / e.ag, _ = o.tileID.toUnwrapped();
                this.transform.setProjection(a.projection);
                const p = (f = o.tileID, m = a.getProjection(), g = this.transform, m.name === this.projection ? g.calculateProjMatrix(f.toUnwrapped()) : ni(g, m, f));
                var f, m, g;
                const v = "map" === l.get("text-pitch-alignment"), y = "map" === l.get("text-rotation-alignment");
                i.compileFilter(i.options);
                const x = i.dynamicFilter(), b = i.dynamicFilterNeedsFeature(), w = this.transform.calculatePixelsToTileUnitsMatrix(o), T = Ht(p, o.tileID.canonical, v, y, this.transform, a.getProjection(), w);
                let E = null;
                if (v) {
                    const t1 = Zt(p, o.tileID.canonical, v, y, this.transform, a.getProjection(), w);
                    E = e.ab.mat4.multiply([], this.transform.labelPlaneMatrix, t1);
                }
                let S = null;
                x && o.latestFeatureIndex && (S = {
                    unwrappedTileID: _,
                    dynamicFilter: x,
                    dynamicFilterNeedsFeature: b
                }), this.retainedQueryData[a.bucketInstanceId] = new pi(a.bucketInstanceId, n, a.sourceLayerIndex, a.index, o.tileID);
                const [C, I] = a.layers[0].layout.get("text-size-scale-range"), R = e.aw(r, C, I), [D, L] = l.get("icon-size-scale-range"), A = e.aw(r, D, L), z = {
                    bucket: a,
                    layout: l,
                    paint: c,
                    posMatrix: p,
                    textLabelPlaneMatrix: T,
                    labelToScreenMatrix: E,
                    clippingData: S,
                    scale: u,
                    textPixelRatio: d,
                    holdingForFade: o.holdingForFade(),
                    collisionBoxArray: h,
                    partiallyEvaluatedTextSize: e.bp(a.textSizeData, this.transform.zoom, R),
                    partiallyEvaluatedIconSize: e.bp(a.iconSizeData, this.transform.zoom, A),
                    collisionGroup: this.collisionGroups.get(a.sourceID),
                    latestFeatureIndex: o.latestFeatureIndex
                };
                if (s) for (const e of a.sortKeyRanges){
                    const { sortKey: i, symbolInstanceStart: o, symbolInstanceEnd: s } = e;
                    t1.push({
                        sortKey: i,
                        symbolInstanceStart: o,
                        symbolInstanceEnd: s,
                        parameters: z
                    });
                }
                else t1.push({
                    symbolInstanceStart: 0,
                    symbolInstanceEnd: a.symbolInstances.length,
                    parameters: z
                });
            }
            attemptAnchorPlacement(e, t1, i, o, s, r, a, n, l, c, h, u, d, _, p, f, m, g) {
                const { textOffset0: v, textOffset1: y, crossTileID: x } = u, b = [
                    v,
                    y
                ], w = mi(e, i, o, b, s), T = this.collisionIndex.placeCollisionBox(_, s, t1, gi(w.x, w.y, r, a, this.transform.angle), h, n, l, c.predicate);
                if (f) {
                    const e = _.getSymbolInstanceIconSize(g, this.transform.zoom, u.placedIconSymbolIndex);
                    if (0 === this.collisionIndex.placeCollisionBox(_, e, f, gi(w.x, w.y, r, a, this.transform.angle), h, n, l, c.predicate).box.length) return;
                }
                if (T.box.length > 0) {
                    let t1;
                    return this.prevPlacement && this.prevPlacement.variableOffsets[x] && this.prevPlacement.placements[x] && this.prevPlacement.placements[x].text && (t1 = this.prevPlacement.variableOffsets[x].anchor), this.variableOffsets[x] = {
                        textOffset: b,
                        width: i,
                        height: o,
                        anchor: e,
                        textScale: s,
                        prevAnchor: t1
                    }, this.markUsedJustification(_, e, u, p), _.allowVerticalPlacement && (this.markUsedOrientation(_, p, u), this.placedOrientations[x] = p), {
                        shift: w,
                        placedGlyphBoxes: T
                    };
                }
            }
            placeLayerBucketPart(t1, i, o, s, r = 1) {
                const { bucket: a, layout: n, paint: l, posMatrix: c, textLabelPlaneMatrix: h, labelToScreenMatrix: u, clippingData: d, textPixelRatio: _, holdingForFade: p, collisionBoxArray: f, partiallyEvaluatedTextSize: m, partiallyEvaluatedIconSize: g, collisionGroup: v, latestFeatureIndex: y } = t1.parameters, x = n.get("text-optional"), b = n.get("icon-optional"), w = n.get("text-allow-overlap"), T = n.get("icon-allow-overlap"), E = "map" === n.get("text-rotation-alignment"), S = "map" === n.get("text-pitch-alignment"), C = n.get("symbol-z-elevate"), I = l.get("symbol-z-offset"), R = "sea" === n.get("symbol-elevation-reference"), [D, L] = n.get("text-size-scale-range"), [A, z] = n.get("icon-size-scale-range"), P = e.aw(r, D, L), M = e.aw(r, A, z);
                this.transform.setProjection(a.projection);
                let O = w && (T || !a.hasIconData() || b), F = T && (w || !a.hasTextData() || x);
                const k = !I.isConstant();
                !a.collisionArrays && f && a.deserializeCollisionBoxes(f), o && s && a.updateCollisionDebugBuffers(this.transform.zoom, f, P, M);
                const B = (t1, s, l)=>{
                    const { crossTileID: f, numVerticalGlyphVertices: C } = t1;
                    let D = null;
                    if (d && d.dynamicFilterNeedsFeature || k) {
                        const e = this.retainedQueryData[a.bucketInstanceId];
                        D = y.loadFeature({
                            featureIndex: t1.featureIndex,
                            bucketIndex: e.bucketIndex,
                            sourceLayerIndex: e.sourceLayerIndex,
                            layoutVertexArrayOffset: 0
                        });
                    }
                    if (d && !(0, d.dynamicFilter)({
                        zoom: this.transform.zoom,
                        pitch: this.transform.pitch
                    }, D, this.retainedQueryData[a.bucketInstanceId].tileID.canonical, new e.P(t1.tileAnchorX, t1.tileAnchorY), this.transform.calculateDistanceTileData(d.unwrappedTileID))) return this.placements[f] = new di(!1, !1, !1, !0), void i.add(f);
                    const L = I.evaluate(D, {});
                    if (i.has(f)) return;
                    if (p) return void (this.placements[f] = new di(!1, !1, !1));
                    let A = !1, z = !1, P = !0, M = !1, B = !1, N = null, U = {
                        box: null,
                        offscreen: null,
                        occluded: null
                    }, j = {
                        box: null,
                        offscreen: null,
                        occluded: null
                    }, G = null, V = null, q = null, H = 0, Z = 0, W = 0;
                    l.textFeatureIndex ? H = l.textFeatureIndex : t1.useRuntimeCollisionCircles && (H = t1.featureIndex), l.verticalTextFeatureIndex && (Z = l.verticalTextFeatureIndex);
                    const $ = (e)=>{
                        e.tileID = this.retainedQueryData[a.bucketInstanceId].tileID;
                        const i = this.transform.elevation;
                        e.elevation = R ? L : L + (i ? i.getAtTileOffset(e.tileID, e.tileAnchorX, e.tileAnchorY) : 0), e.elevation += t1.zOffset;
                    }, X = l.textBox;
                    if (X) {
                        $(X);
                        const i = (i)=>{
                            let o = e.bq.horizontal;
                            if (a.allowVerticalPlacement && !i && this.prevPlacement) {
                                const e = this.prevPlacement.placedOrientations[f];
                                e && (this.placedOrientations[f] = e, o = e, this.markUsedOrientation(a, o, t1));
                            }
                            return o;
                        }, o = (t1, i)=>{
                            if (a.allowVerticalPlacement && C > 0 && l.verticalTextBox) {
                                for (const o of a.writingModes)if (o === e.bq.vertical ? (U = i(), j = U) : U = t1(), U && U.box && U.box.length) break;
                            } else U = t1();
                        };
                        if (n.get("text-variable-anchor")) {
                            let r = n.get("text-variable-anchor");
                            if (this.prevPlacement && this.prevPlacement.variableOffsets[f]) {
                                const e = this.prevPlacement.variableOffsets[f];
                                r.indexOf(e.anchor) > 0 && (r = r.filter((t1)=>t1 !== e.anchor), r.unshift(e.anchor));
                            }
                            const h = (e, i, o)=>{
                                const n = a.getSymbolInstanceTextSize(m, t1, this.transform.zoom, s), l = (e.x2 - e.x1) * n + 2 * e.padding, h = (e.y2 - e.y1) * n + 2 * e.padding, u = t1.hasIconTextFit && !T ? i : null;
                                u && $(u);
                                let d = {
                                    box: [],
                                    offscreen: !1,
                                    occluded: !1
                                };
                                const p = w ? 2 * r.length : r.length;
                                for(let i = 0; i < p; ++i){
                                    const p = this.attemptAnchorPlacement(r[i % r.length], e, l, h, n, E, S, _, c, v, i >= r.length, t1, s, a, o, u, m, g);
                                    if (p && (d = p.placedGlyphBoxes, d && d.box && d.box.length)) {
                                        A = !0, N = p.shift;
                                        break;
                                    }
                                }
                                return d;
                            };
                            o(()=>h(X, l.iconBox, e.bq.horizontal), ()=>{
                                const t1 = l.verticalTextBox;
                                return t1 && $(t1), a.allowVerticalPlacement && !(U && U.box && U.box.length) && C > 0 && t1 ? h(t1, l.verticalIconBox, e.bq.vertical) : {
                                    box: null,
                                    offscreen: null,
                                    occluded: null
                                };
                            }), U && (A = U.box, P = U.offscreen, M = U.occluded);
                            const u = i(!(!U || !U.box));
                            if (!A && this.prevPlacement) {
                                const e = this.prevPlacement.variableOffsets[f];
                                e && (this.variableOffsets[f] = e, this.markUsedJustification(a, e.anchor, t1, u));
                            }
                        } else {
                            const n = (i, o)=>{
                                const n = a.getSymbolInstanceTextSize(m, t1, this.transform.zoom, s, r), l = this.collisionIndex.placeCollisionBox(a, n, i, new e.P(0, 0), w, _, c, v.predicate);
                                return l && l.box && l.box.length && (this.markUsedOrientation(a, o, t1), this.placedOrientations[f] = o), l;
                            };
                            o(()=>n(X, e.bq.horizontal), ()=>{
                                const t1 = l.verticalTextBox;
                                return a.allowVerticalPlacement && C > 0 && t1 ? ($(t1), n(t1, e.bq.vertical)) : {
                                    box: null,
                                    offscreen: null,
                                    occluded: null
                                };
                            }), i(!!(U && U.box && U.box.length));
                        }
                    }
                    if (G = U, A = G && G.box && G.box.length > 0, P = G && G.offscreen, M = G && G.occluded, t1.useRuntimeCollisionCircles) {
                        const i = a.text.placedSymbolArray.get(t1.centerJustifiedTextSymbolIndex >= 0 ? t1.centerJustifiedTextSymbolIndex : t1.verticalPlacedTextSymbolIndex), s = e.br(a.textSizeData, m, i), r = n.get("text-padding");
                        V = this.collisionIndex.placeCollisionCircles(a, w, i, a.lineVertexArray, a.glyphOffsetArray, s, c, h, u, o, S, v.predicate, t1.collisionCircleDiameter * s / e.bw, r, this.retainedQueryData[a.bucketInstanceId].tileID), A = w || V.circles.length > 0 && !V.collisionDetected, P = P && V.offscreen, M = V.occluded;
                    }
                    if (l.iconFeatureIndex && (W = l.iconFeatureIndex), l.iconBox) {
                        const i = (i)=>{
                            $(i);
                            const o = t1.hasIconTextFit && N ? gi(N.x, N.y, E, S, this.transform.angle) : new e.P(0, 0), s = a.getSymbolInstanceIconSize(g, this.transform.zoom, t1.placedIconSymbolIndex);
                            return this.collisionIndex.placeCollisionBox(a, s, i, o, T, _, c, v.predicate);
                        };
                        j && j.box && j.box.length && l.verticalIconBox ? (q = i(l.verticalIconBox), z = q.box.length > 0) : (q = i(l.iconBox), z = q.box.length > 0), P = P && q.offscreen, B = q.occluded;
                    }
                    const K = x || 0 === t1.numHorizontalGlyphVertices && 0 === C, Y = b || 0 === t1.numIconVertices;
                    if (K || Y ? Y ? K || (z = z && A) : A = z && A : z = A = z && A, A && G && G.box && this.collisionIndex.insertCollisionBox(G.box, n.get("text-ignore-placement"), a.bucketInstanceId, j && j.box && Z ? Z : H, v.ID), z && q && this.collisionIndex.insertCollisionBox(q.box, n.get("icon-ignore-placement"), a.bucketInstanceId, W, v.ID), V && (A && this.collisionIndex.insertCollisionCircles(V.circles, n.get("text-ignore-placement"), a.bucketInstanceId, H, v.ID), o)) {
                        const e = a.bucketInstanceId;
                        let t1 = this.collisionCircleArrays[e];
                        void 0 === t1 && (t1 = this.collisionCircleArrays[e] = new _i);
                        for(let e = 0; e < V.circles.length; e += 4)t1.circles.push(V.circles[e + 0]), t1.circles.push(V.circles[e + 1]), t1.circles.push(V.circles[e + 2]), t1.circles.push(V.collisionDetected ? 1 : 0);
                    }
                    const J = "globe" !== a.projection.name;
                    O = O && (J || !M), F = F && (J || !B), this.placements[f] = new di(A || O, z || F, P || a.justReloaded), i.add(f);
                };
                if (C && this.buildingIndex && (this.buildingIndex.updateZOffset(a, this.retainedQueryData[a.bucketInstanceId].tileID), a.updateZOffset()), a.sortFeaturesByY) {
                    const t1 = a.getSortedSymbolIndexes(this.transform.angle);
                    for(let e = t1.length - 1; e >= 0; --e){
                        const i = t1[e];
                        B(a.symbolInstances.get(i), i, a.collisionArrays[i]);
                    }
                    a.hasAnyZOffset && e.w(`${a.layerIds[0]} layer symbol-z-elevate: symbols are not sorted by elevation if symbol-z-order is evaluated to viewport-y`);
                } else if (a.hasAnyZOffset) {
                    const e = a.getSortedIndexesByZOffset();
                    for(let t1 = 0; t1 < e.length; ++t1){
                        const i = e[t1];
                        B(a.symbolInstances.get(i), i, a.collisionArrays[i]);
                    }
                } else for(let e = t1.symbolInstanceStart; e < t1.symbolInstanceEnd; e++)B(a.symbolInstances.get(e), e, a.collisionArrays[e]);
                if (o && a.bucketInstanceId in this.collisionCircleArrays) {
                    const t1 = this.collisionCircleArrays[a.bucketInstanceId];
                    e.ab.mat4.invert(t1.invProjMatrix, c), t1.viewportMatrix = this.collisionIndex.getViewportMatrix();
                }
                a.justReloaded = !1;
            }
            markUsedJustification(t1, i, o, s) {
                const { leftJustifiedTextSymbolIndex: r, centerJustifiedTextSymbolIndex: a, rightJustifiedTextSymbolIndex: n, verticalPlacedTextSymbolIndex: l, crossTileID: c } = o, h = e.bB(i), u = s === e.bq.vertical ? l : "left" === h ? r : "center" === h ? a : "right" === h ? n : -1;
                r >= 0 && (t1.text.placedSymbolArray.get(r).crossTileID = u >= 0 && r !== u ? 0 : c), a >= 0 && (t1.text.placedSymbolArray.get(a).crossTileID = u >= 0 && a !== u ? 0 : c), n >= 0 && (t1.text.placedSymbolArray.get(n).crossTileID = u >= 0 && n !== u ? 0 : c), l >= 0 && (t1.text.placedSymbolArray.get(l).crossTileID = u >= 0 && l !== u ? 0 : c);
            }
            markUsedOrientation(t1, i, o) {
                const s = i === e.bq.horizontal || i === e.bq.horizontalOnly ? i : 0, r = i === e.bq.vertical ? i : 0, { leftJustifiedTextSymbolIndex: a, centerJustifiedTextSymbolIndex: n, rightJustifiedTextSymbolIndex: l, verticalPlacedTextSymbolIndex: c } = o, h = t1.text.placedSymbolArray;
                a >= 0 && (h.get(a).placedOrientation = s), n >= 0 && (h.get(n).placedOrientation = s), l >= 0 && (h.get(l).placedOrientation = s), c >= 0 && (h.get(c).placedOrientation = r);
            }
            commit(e) {
                this.commitTime = e, this.zoomAtLastRecencyCheck = this.transform.zoom;
                const t1 = this.prevPlacement;
                let i = !1;
                this.prevZoomAdjustment = t1 ? t1.zoomAdjustment(this.transform.zoom) : 0;
                const o = t1 ? t1.symbolFadeChange(e) : 1, s = t1 ? t1.opacities : {}, r = t1 ? t1.variableOffsets : {}, a = t1 ? t1.placedOrientations : {};
                for(const e in this.placements){
                    const t1 = this.placements[e], r = s[e];
                    r ? (this.opacities[e] = new ui(r, o, t1.text, t1.icon, null, t1.clipped), i = i || t1.text !== r.text.placed || t1.icon !== r.icon.placed) : (this.opacities[e] = new ui(null, o, t1.text, t1.icon, t1.skipFade, t1.clipped), i = i || t1.text || t1.icon);
                }
                for(const e in s){
                    const t1 = s[e];
                    if (!this.opacities[e]) {
                        const s = new ui(t1, o, !1, !1);
                        s.isHidden() || (this.opacities[e] = s, i = i || t1.text.placed || t1.icon.placed);
                    }
                }
                for(const e in r)this.variableOffsets[e] || !this.opacities[e] || this.opacities[e].isHidden() || (this.variableOffsets[e] = r[e]);
                for(const e in a)this.placedOrientations[e] || !this.opacities[e] || this.opacities[e].isHidden() || (this.placedOrientations[e] = a[e]);
                i ? this.lastPlacementChangeTime = e : "number" != typeof this.lastPlacementChangeTime && (this.lastPlacementChangeTime = t1 ? t1.lastPlacementChangeTime : e);
            }
            updateLayerOpacities(e, t1, i, o) {
                const s = new Set;
                for (const r of t1){
                    const t1 = r.getBucket(e);
                    t1 && r.latestFeatureIndex && e.fqid === t1.layerIds[0] && (this.updateBucketOpacities(t1, s, r, r.collisionBoxArray, i, o, r.tileID, e.scope), t1.layers[0].layout.get("symbol-z-elevate") && this.buildingIndex && (this.buildingIndex.updateZOffset(t1, r.tileID), t1.updateZOffset()));
                }
            }
            updateBucketOpacities(t1, i, o, s, r, a, n, l) {
                t1.hasTextData() && t1.text.opacityVertexArray.clear(), t1.hasIconData() && t1.icon.opacityVertexArray.clear(), t1.hasIconCollisionBoxData() && t1.iconCollisionBox.collisionVertexArray.clear(), t1.hasTextCollisionBoxData() && t1.textCollisionBox.collisionVertexArray.clear();
                const c = t1.layers[0].layout, h = t1.layers[0].paint, u = !!t1.layers[0].dynamicFilter(), d = new ui(null, 0, !1, !1, !0), _ = c.get("text-allow-overlap"), p = c.get("icon-allow-overlap"), f = c.get("text-variable-anchor"), m = "map" === c.get("text-rotation-alignment"), g = "map" === c.get("text-pitch-alignment"), v = h.get("symbol-z-offset"), y = "sea" === c.get("symbol-elevation-reference"), x = !v.isConstant(), b = new ui(null, 0, _ && (p || !t1.hasIconData() || c.get("icon-optional")), p && (_ || !t1.hasTextData() || c.get("text-optional")), !0);
                !t1.collisionArrays && s && (t1.hasIconCollisionBoxData() || t1.hasTextCollisionBoxData()) && t1.deserializeCollisionBoxes(s);
                const w = (e, t1, i)=>{
                    for(let o = 0; o < t1 / 4; o++)e.opacityVertexArray.emplaceBack(i);
                };
                let T = 0;
                a && t1.updateReplacement(n, a);
                for(let s = 0; s < t1.symbolInstances.length; s++){
                    const c = t1.symbolInstances.get(s), { numHorizontalGlyphVertices: h, numVerticalGlyphVertices: _, crossTileID: p, numIconVertices: E, tileAnchorX: S, tileAnchorY: C } = c;
                    let I = null;
                    const R = this.retainedQueryData[t1.bucketInstanceId];
                    x && c && R && (I = o.latestFeatureIndex.loadFeature({
                        featureIndex: c.featureIndex,
                        bucketIndex: R.bucketIndex,
                        sourceLayerIndex: R.sourceLayerIndex,
                        layoutVertexArrayOffset: 0
                    }));
                    const D = v.evaluate(I, {}), L = i.has(p);
                    let A = this.opacities[p];
                    L ? A = d : A || (A = b, this.opacities[p] = A), i.add(p);
                    const z = h > 0 || _ > 0, P = E > 0, M = this.placedOrientations[p], O = M === e.bq.vertical, F = M === e.bq.horizontal || M === e.bq.horizontalOnly;
                    !z && !P || A.isHidden() || T++;
                    let k = !1;
                    if ((z || P) && a) for (const i of t1.activeReplacements){
                        if (e.bx(i, r, e.by.Symbol, l)) continue;
                        if (i.min.x > S || S > i.max.x || i.min.y > C || C > i.max.y) continue;
                        const t1 = e.bz(S, C, n.canonical, i.footprintTileId.canonical);
                        if (k = e.bA(t1, i.footprint), k) break;
                    }
                    if (z) {
                        const e = k ? Ri : Ii(A.text);
                        w(t1.text, h, O ? Ri : e), w(t1.text, _, F ? Ri : e);
                        const i = A.text.isHidden(), { leftJustifiedTextSymbolIndex: o, centerJustifiedTextSymbolIndex: s, rightJustifiedTextSymbolIndex: r, verticalPlacedTextSymbolIndex: a } = c, n = t1.text.placedSymbolArray, l = i || O ? 1 : 0;
                        o >= 0 && (n.get(o).hidden = l), s >= 0 && (n.get(s).hidden = l), r >= 0 && (n.get(r).hidden = l), a >= 0 && (n.get(a).hidden = i || F ? 1 : 0);
                        const u = this.variableOffsets[p];
                        u && this.markUsedJustification(t1, u.anchor, c, M);
                        const d = this.placedOrientations[p];
                        d && (this.markUsedJustification(t1, "left", c, d), this.markUsedOrientation(t1, d, c));
                    }
                    if (P) {
                        const e = k ? Ri : Ii(A.icon), { placedIconSymbolIndex: i, verticalPlacedIconSymbolIndex: o } = c, s = t1.icon.placedSymbolArray, r = A.icon.isHidden() ? 1 : 0;
                        i >= 0 && (w(t1.icon, E, O ? Ri : e), s.get(i).hidden = r), o >= 0 && (w(t1.icon, c.numVerticalIconVertices, F ? Ri : e), s.get(o).hidden = r);
                    }
                    if (t1.hasIconCollisionBoxData() || t1.hasTextCollisionBoxData()) {
                        const i = t1.collisionArrays[s];
                        if (i) {
                            let o = new e.P(0, 0), s = !0;
                            if (i.textBox || i.verticalTextBox) {
                                if (f) {
                                    const e = this.variableOffsets[p];
                                    e ? (o = mi(e.anchor, e.width, e.height, e.textOffset, e.textScale), m && o._rotate(g ? this.transform.angle : -this.transform.angle)) : s = !1;
                                }
                                u && (s = !A.clipped), i.textBox && yi(t1.textCollisionBox.collisionVertexArray, A.text.placed, !s || O, D, y, o.x, o.y), i.verticalTextBox && yi(t1.textCollisionBox.collisionVertexArray, A.text.placed, !s || F, D, y, o.x, o.y);
                            }
                            const r = s && Boolean(!F && i.verticalIconBox);
                            i.iconBox && yi(t1.iconCollisionBox.collisionVertexArray, A.icon.placed, r, D, y, c.hasIconTextFit ? o.x : 0, c.hasIconTextFit ? o.y : 0), i.verticalIconBox && yi(t1.iconCollisionBox.collisionVertexArray, A.icon.placed, !r, D, y, c.hasIconTextFit ? o.x : 0, c.hasIconTextFit ? o.y : 0);
                        }
                    }
                }
                if (t1.fullyClipped = 0 === T, t1.sortFeatures(this.transform.angle), this.retainedQueryData[t1.bucketInstanceId] && (this.retainedQueryData[t1.bucketInstanceId].featureSortOrder = t1.featureSortOrder), t1.hasTextData() && t1.text.opacityVertexBuffer && t1.text.opacityVertexBuffer.updateData(t1.text.opacityVertexArray), t1.hasIconData() && t1.icon.opacityVertexBuffer && t1.icon.opacityVertexBuffer.updateData(t1.icon.opacityVertexArray), t1.hasIconCollisionBoxData() && t1.iconCollisionBox.collisionVertexBuffer && t1.iconCollisionBox.collisionVertexBuffer.updateData(t1.iconCollisionBox.collisionVertexArray), t1.hasTextCollisionBoxData() && t1.textCollisionBox.collisionVertexBuffer && t1.textCollisionBox.collisionVertexBuffer.updateData(t1.textCollisionBox.collisionVertexArray), t1.bucketInstanceId in this.collisionCircleArrays) {
                    const e = this.collisionCircleArrays[t1.bucketInstanceId];
                    t1.placementInvProjMatrix = e.invProjMatrix, t1.placementViewportMatrix = e.viewportMatrix, t1.collisionCircleArray = e.circles, delete this.collisionCircleArrays[t1.bucketInstanceId];
                }
            }
            symbolFadeChange(e) {
                return 0 === this.fadeDuration ? 1 : (e - this.commitTime) / this.fadeDuration + this.prevZoomAdjustment;
            }
            zoomAdjustment(e) {
                return Math.max(0, (this.transform.zoom - e) / 1.5);
            }
            hasTransitions(e) {
                return this.stale || e - this.lastPlacementChangeTime < this.fadeDuration;
            }
            stillRecent(e, t1) {
                const i = this.zoomAtLastRecencyCheck === t1 ? 1 - this.zoomAdjustment(t1) : 1;
                return this.zoomAtLastRecencyCheck = t1, this.commitTime + this.fadeDuration * i > e;
            }
            setStale() {
                this.stale = !0;
            }
            constructor(e, t1, i, o, s, r){
                this.transform = e.clone(), this.projection = e.projection.name, this.collisionIndex = new ai(this.transform, s), this.buildingIndex = r, this.placements = {}, this.opacities = {}, this.variableOffsets = {}, this.stale = !1, this.commitTime = 0, this.fadeDuration = t1, this.retainedQueryData = {}, this.collisionGroups = new fi(i), this.collisionCircleArrays = {}, this.prevPlacement = o, o && (o.prevPlacement = void 0), this.placedOrientations = {};
            }
        }
        function yi(e, t1, i, o, s, r, a) {
            e.emplaceBack(t1 ? 1 : 0, i ? 1 : 0, r || 0, a || 0, o, s ? 1 : 0), e.emplaceBack(t1 ? 1 : 0, i ? 1 : 0, r || 0, a || 0, o, s ? 1 : 0), e.emplaceBack(t1 ? 1 : 0, i ? 1 : 0, r || 0, a || 0, o, s ? 1 : 0), e.emplaceBack(t1 ? 1 : 0, i ? 1 : 0, r || 0, a || 0, o, s ? 1 : 0);
        }
        const xi = Math.pow(2, 25), bi = Math.pow(2, 24), wi = Math.pow(2, 17), Ti = Math.pow(2, 16), Ei = Math.pow(2, 9), Si = Math.pow(2, 8), Ci = Math.pow(2, 1);
        function Ii(e) {
            if (0 === e.opacity && !e.placed) return 0;
            if (1 === e.opacity && e.placed) return 4294967295;
            const t1 = e.placed ? 1 : 0, i = Math.floor(127 * e.opacity);
            return i * xi + t1 * bi + i * wi + t1 * Ti + i * Ei + t1 * Si + i * Ci + t1;
        }
        const Ri = 0;
        class Di {
            continuePlacement(e, t1, i, o, s, r) {
                const a = this._bucketParts;
                for(; this._currentTileIndex < e.length;)if (t1.getBucketParts(a, o, e[this._currentTileIndex], this._sortAcrossTiles, r), this._currentTileIndex++, s()) return !0;
                for(this._sortAcrossTiles && (this._sortAcrossTiles = !1, a.sort((e, t1)=>e.sortKey - t1.sortKey)); this._currentPartIndex < a.length;){
                    const e = a[this._currentPartIndex];
                    if (t1.placeLayerBucketPart(e, this._seenCrossTileIDs, i, 0 === e.symbolInstanceStart, r), this._currentPartIndex++, s()) return !0;
                }
                return !1;
            }
            constructor(e){
                this._sortAcrossTiles = "viewport-y" !== e.layout.get("symbol-z-order") && void 0 !== e.layout.get("symbol-sort-key").constantOr(1), this._currentTileIndex = 0, this._currentPartIndex = 0, this._seenCrossTileIDs = new Set, this._bucketParts = [];
            }
        }
        class Li {
            isDone() {
                return this._done;
            }
            continuePlacement(t1, i, o, s, r) {
                const a = e.q.now(), n = ()=>{
                    const t1 = e.q.now() - a;
                    return !this._forceFullPlacement && t1 > 2;
                };
                for(; this._currentPlacementIndex >= 0;){
                    const a = i[t1[this._currentPlacementIndex]], l = this.placement.collisionIndex.transform.zoom;
                    if ("symbol" === a.type && (!a.minzoom || a.minzoom <= l) && (!a.maxzoom || a.maxzoom > l)) {
                        const t1 = a, i = t1.layout.get("symbol-z-elevate"), l = void 0 !== t1.layout.get("symbol-sort-key").constantOr(1), c = t1.layout.get("symbol-z-order"), h = "viewport-y" === c || "auto" === c && !("viewport-y" !== c && l), u = t1.layout.get("text-allow-overlap") || t1.layout.get("icon-allow-overlap") || t1.layout.get("text-ignore-placement") || t1.layout.get("icon-ignore-placement"), d = h && u, _ = this._inProgressLayer = this._inProgressLayer || new Di(t1), p = e.aC(a.source, a.scope);
                        if (_.continuePlacement(i || d ? s[p] : o[p], this.placement, this._showCollisionBoxes, a, n, r)) return;
                        delete this._inProgressLayer;
                    }
                    this._currentPlacementIndex--;
                }
                this._done = !0;
            }
            commit(e) {
                return this.placement.commit(e), this.placement;
            }
            constructor(e, t1, i, o, s, r, a, n, l){
                this.placement = new vi(e, s, r, a, n, l), this._currentPlacementIndex = t1.length - 1, this._forceFullPlacement = i, this._showCollisionBoxes = o, this._done = !1;
            }
        }
        const Ai = 512 / e.ag / 2;
        class zi {
            findMatches(t1, i, o) {
                const s = this.tileID.canonical.z < i.canonical.z ? 1 : Math.pow(2, this.tileID.canonical.z - i.canonical.z), r = Ai / Math.pow(2, i.canonical.z - this.tileID.canonical.z), a = i.canonical.x * e.ag, n = i.canonical.y * e.ag;
                for(let e = 0; e < t1.length; e++){
                    const i = t1.get(e);
                    if (i.crossTileID) continue;
                    const { key: l, tileAnchorX: c, tileAnchorY: h } = i, u = Math.floor((a + c) * r), d = Math.floor((n + h) * r), _ = this.index.range(u - s, d - s, u + s, d + s);
                    for (const e of _){
                        const t1 = this.crossTileIDs[e];
                        if (this.keys[e] === l && !o.has(t1)) {
                            o.add(t1), i.crossTileID = t1;
                            break;
                        }
                    }
                }
            }
            constructor(t1, i, o){
                this.tileID = t1, this.bucketInstanceId = o, this.index = new e.bE(i.length, 16, Int32Array), this.keys = [], this.crossTileIDs = [];
                const s = t1.canonical.x * e.ag, r = t1.canonical.y * e.ag;
                for(let e = 0; e < i.length; e++){
                    const { key: t1, crossTileID: o, tileAnchorX: a, tileAnchorY: n } = i.get(e), l = Math.floor((s + a) * Ai), c = Math.floor((r + n) * Ai);
                    this.index.add(l, c), this.keys.push(t1), this.crossTileIDs.push(o);
                }
                this.index.finish();
            }
        }
        class Pi {
            generate() {
                return ++this.maxCrossTileID;
            }
            constructor(){
                this.maxCrossTileID = 0;
            }
        }
        class Mi {
            handleWrapJump(e) {
                const t1 = Math.round((e - this.lng) / 360);
                if (0 !== t1) for(const e in this.indexes){
                    const i = this.indexes[e], o = {};
                    for(const e in i){
                        const s = i[e];
                        s.tileID = s.tileID.unwrapTo(s.tileID.wrap + t1), o[s.tileID.key] = s;
                    }
                    this.indexes[e] = o;
                }
                this.lng = e;
            }
            addBucket(e, t1, i) {
                if (this.indexes[e.overscaledZ] && this.indexes[e.overscaledZ][e.key]) {
                    if (this.indexes[e.overscaledZ][e.key].bucketInstanceId === t1.bucketInstanceId) return !1;
                    this.removeBucketCrossTileIDs(e.overscaledZ, this.indexes[e.overscaledZ][e.key]);
                }
                for(let e = 0; e < t1.symbolInstances.length; e++)t1.symbolInstances.get(e).crossTileID = 0;
                this.usedCrossTileIDs[e.overscaledZ] || (this.usedCrossTileIDs[e.overscaledZ] = new Set);
                const o = this.usedCrossTileIDs[e.overscaledZ];
                for(const i in this.indexes){
                    const s = this.indexes[i];
                    if (Number(i) > e.overscaledZ) for(const i in s){
                        const r = s[i];
                        r.tileID.isChildOf(e) && r.findMatches(t1.symbolInstances, e, o);
                    }
                    else {
                        const r = s[e.scaledTo(Number(i)).key];
                        r && r.findMatches(t1.symbolInstances, e, o);
                    }
                }
                for(let e = 0; e < t1.symbolInstances.length; e++){
                    const s = t1.symbolInstances.get(e);
                    s.crossTileID || (s.crossTileID = i.generate(), o.add(s.crossTileID));
                }
                return void 0 === this.indexes[e.overscaledZ] && (this.indexes[e.overscaledZ] = {}), this.indexes[e.overscaledZ][e.key] = new zi(e, t1.symbolInstances, t1.bucketInstanceId), !0;
            }
            removeBucketCrossTileIDs(e, t1) {
                for (const i of t1.crossTileIDs)this.usedCrossTileIDs[e].delete(i);
            }
            removeStaleBuckets(e) {
                let t1 = !1;
                for(const i in this.indexes){
                    const o = this.indexes[i];
                    for(const s in o)e[o[s].bucketInstanceId] || (this.removeBucketCrossTileIDs(i, o[s]), delete o[s], t1 = !0);
                }
                return t1;
            }
            constructor(){
                this.indexes = {}, this.usedCrossTileIDs = {}, this.lng = 0;
            }
        }
        class Oi {
            addLayer(e, t1, i, o) {
                let s = this.layerIndexes[e.fqid];
                void 0 === s && (s = this.layerIndexes[e.fqid] = new Mi);
                let r = !1;
                const a = {};
                "globe" !== o.name && s.handleWrapJump(i);
                for (const i of t1){
                    const t1 = i.getBucket(e);
                    t1 && e.fqid === t1.layerIds[0] && (t1.bucketInstanceId || (t1.bucketInstanceId = ++this.maxBucketInstanceId), s.addBucket(i.tileID, t1, this.crossTileIDs) && (r = !0), a[t1.bucketInstanceId] = !0);
                }
                return s.removeStaleBuckets(a) && (r = !0), r;
            }
            pruneUnusedLayers(e) {
                const t1 = {};
                e.forEach((e)=>{
                    t1[e] = !0;
                });
                for(const e in this.layerIndexes)t1[e] || delete this.layerIndexes[e];
            }
            constructor(){
                this.layerIndexes = {}, this.crossTileIDs = new Pi, this.maxBucketInstanceId = 0, this.bucketsInCurrentPlacement = {};
            }
        }
        const Fi = 771;
        class ki {
            constructor(e, t1, i, o){
                this.blendFunction = e, this.blendColor = t1, this.mask = i, this.blendEquation = o;
            }
        }
        ki.Replace = [
            1,
            0,
            1,
            0
        ], ki.disabled = new ki(ki.Replace, e.aj.transparent, [
            !1,
            !1,
            !1,
            !1
        ]), ki.unblended = new ki(ki.Replace, e.aj.transparent, [
            !0,
            !0,
            !0,
            !0
        ]), ki.alphaBlended = new ki([
            1,
            Fi,
            1,
            Fi
        ], e.aj.transparent, [
            !0,
            !0,
            !0,
            !0
        ]), ki.alphaBlendedNonPremultiplied = new ki([
            770,
            Fi,
            770,
            Fi
        ], e.aj.transparent, [
            !0,
            !0,
            !0,
            !0
        ]), ki.multiply = new ki([
            774,
            0,
            774,
            0
        ], e.aj.transparent, [
            !0,
            !0,
            !0,
            !0
        ]);
        class Bi {
            constructor(e, t1, i){
                this.func = e, this.mask = t1, this.range = i;
            }
        }
        Bi.ReadOnly = !1, Bi.ReadWrite = !0, Bi.disabled = new Bi(519, Bi.ReadOnly, [
            0,
            1
        ]);
        const Ni = 7680;
        class Ui {
            constructor(e, t1, i, o, s, r){
                this.test = e, this.ref = t1, this.mask = i, this.fail = o, this.depthFail = s, this.pass = r;
            }
        }
        Ui.disabled = new Ui({
            func: 519,
            mask: 0
        }, 0, 0, Ni, Ni, Ni);
        const ji = 1029, Gi = 2305;
        class Vi {
            constructor(e, t1, i){
                this.enable = e, this.mode = t1, this.frontFace = i;
            }
        }
        function qi(t1, i) {
            const o = e.bG(t1, 3);
            e.ab.mat4.fromQuat(t1, i), e.bI(t1, 3, o);
        }
        function Hi(t1, i) {
            const o = e.ab.quat.identity([]);
            return e.ab.quat.rotateZ(o, o, -i), e.ab.quat.rotateX(o, o, -t1), o;
        }
        function Zi(t1, i) {
            const o = [
                t1[0],
                t1[1],
                0
            ], s = [
                i[0],
                i[1],
                0
            ];
            if (e.ab.vec3.length(o) >= 1e-15) {
                const t1 = e.ab.vec3.normalize([], o);
                e.ab.vec3.scale(s, t1, e.ab.vec3.dot(s, t1)), i[0] = s[0], i[1] = s[1];
            }
            const r = e.ab.vec3.cross([], i, t1);
            if (e.ab.vec3.len(r) < 1e-15) return null;
            const a = Math.atan2(-r[1], r[0]);
            return Hi(Math.atan2(Math.sqrt(t1[0] * t1[0] + t1[1] * t1[1]), -t1[2]), a);
        }
        Vi.disabled = new Vi(!1, ji, Gi), Vi.backCCW = new Vi(!0, ji, Gi), Vi.backCW = new Vi(!0, ji, 2304), Vi.frontCW = new Vi(!0, 1028, 2304), Vi.frontCCW = new Vi(!0, 1028, Gi);
        class Wi {
            get position() {
                return this._position;
            }
            set position(t1) {
                if (t1) {
                    const i = t1 instanceof e.aa ? t1 : new e.aa(t1[0], t1[1], t1[2]);
                    this._renderWorldCopies && (i.x = e.bF(i.x, 0, 1)), this._position = i;
                } else this._position = null;
            }
            lookAtPoint(t1, i) {
                if (this.orientation = null, !this.position) return;
                const o = this.position, s = this._elevation ? this._elevation.getAtPointOrZero(e.aa.fromLngLat(t1)) : 0, r = e.aa.fromLngLat(t1, s), a = [
                    r.x - o.x,
                    r.y - o.y,
                    r.z - o.z
                ];
                i || (i = [
                    0,
                    0,
                    1
                ]), i[2] = Math.abs(i[2]), this.orientation = Zi(a, i);
            }
            setPitchBearing(t1, i) {
                this.orientation = Hi(e.ai(t1), e.ai(-i));
            }
            constructor(e, t1){
                this.position = e, this.orientation = t1;
            }
        }
        class $i {
            get mercatorPosition() {
                const t1 = this.position;
                return new e.aa(t1[0], t1[1], t1[2]);
            }
            get position() {
                const t1 = e.bG(this._transform, 3);
                return [
                    t1[0],
                    t1[1],
                    t1[2]
                ];
            }
            set position(t1) {
                var i;
                t1 && e.bI(this._transform, 3, [
                    (i = t1)[0],
                    i[1],
                    i[2],
                    1
                ]);
            }
            get orientation() {
                return this._orientation;
            }
            set orientation(t1) {
                this._orientation = t1 || e.ab.quat.identity([]), t1 && qi(this._transform, this._orientation);
            }
            getPitchBearing() {
                const e = this.forward(), t1 = this.right();
                return {
                    bearing: Math.atan2(-t1[1], t1[0]),
                    pitch: Math.atan2(Math.sqrt(e[0] * e[0] + e[1] * e[1]), -e[2])
                };
            }
            setPitchBearing(e, t1) {
                this._orientation = Hi(e, t1), qi(this._transform, this._orientation);
            }
            forward() {
                const t1 = e.bG(this._transform, 2);
                return [
                    -t1[0],
                    -t1[1],
                    -t1[2]
                ];
            }
            up() {
                const t1 = e.bG(this._transform, 1);
                return [
                    -t1[0],
                    -t1[1],
                    -t1[2]
                ];
            }
            right() {
                const t1 = e.bG(this._transform, 0);
                return [
                    t1[0],
                    t1[1],
                    t1[2]
                ];
            }
            getCameraToWorld(t1, i) {
                const o = new Float64Array(16);
                return e.ab.mat4.invert(o, this.getWorldToCamera(t1, i)), o;
            }
            getCameraToWorldMercator() {
                return this._transform;
            }
            getWorldToCameraPosition(t1, i, o) {
                const s = this.position;
                e.ab.vec3.scale(s, s, -t1);
                const r = new Float64Array(16);
                return e.ab.mat4.fromScaling(r, [
                    o,
                    o,
                    o
                ]), e.ab.mat4.translate(r, r, s), r[10] *= i, r;
            }
            getWorldToCamera(t1, i) {
                const o = new Float64Array(16), s = new Float64Array(4), r = this.position;
                return e.ab.quat.conjugate(s, this._orientation), e.ab.vec3.scale(r, r, -t1), e.ab.mat4.fromQuat(o, s), e.ab.mat4.translate(o, o, r), o[1] *= -1, o[5] *= -1, o[9] *= -1, o[13] *= -1, o[8] *= i, o[9] *= i, o[10] *= i, o[11] *= i, o;
            }
            getCameraToClipPerspective(t1, i, o, s) {
                const r = new Float64Array(16);
                return e.ab.mat4.perspective(r, t1, i, o, s), r;
            }
            getCameraToClipOrthographic(t1, i, o, s, r, a) {
                const n = new Float64Array(16);
                return e.ab.mat4.ortho(n, t1, i, o, s, r, a), n;
            }
            getDistanceToElevation(t1, i = !1) {
                const o = 0 === t1 ? 0 : e.bH(t1, i ? e.aS(this.position[1]) : this.position[1]), s = this.forward();
                return (o - this.position[2]) / s[2];
            }
            clone() {
                return new $i([
                    ...this.position
                ], [
                    ...this.orientation
                ]);
            }
            constructor(t1, i){
                this._transform = e.ab.mat4.identity([]), this.orientation = i, this.position = t1;
            }
        }
        const Xi = {
            BaseColor: 5,
            MetallicRoughness: 6,
            Normal: 7,
            Occlusion: 8,
            Emission: 9,
            LUT: 10,
            ShadowMap0: 11
        };
        class Ki {
            interpolate(t1, i, o) {
                return null != i.top && null != t1.top && (this.top = e.af(t1.top, i.top, o)), null != i.bottom && null != t1.bottom && (this.bottom = e.af(t1.bottom, i.bottom, o)), null != i.left && null != t1.left && (this.left = e.af(t1.left, i.left, o)), null != i.right && null != t1.right && (this.right = e.af(t1.right, i.right, o)), this;
            }
            getCenter(t1, i) {
                const o = e.aw((this.left + t1 - this.right) / 2, 0, t1), s = e.aw((this.top + i - this.bottom) / 2, 0, i);
                return new e.P(o, s);
            }
            equals(e) {
                return this.top === e.top && this.bottom === e.bottom && this.left === e.left && this.right === e.right;
            }
            clone() {
                return new Ki(this.top, this.bottom, this.left, this.right);
            }
            toJSON() {
                return {
                    top: this.top,
                    bottom: this.bottom,
                    left: this.left,
                    right: this.right
                };
            }
            constructor(e = 0, t1 = 0, i = 0, o = 0){
                if (isNaN(e) || e < 0 || isNaN(t1) || t1 < 0 || isNaN(i) || i < 0 || isNaN(o) || o < 0) throw new Error("Invalid value for edge-insets, top, bottom, left and right must all be numbers");
                this.top = e, this.bottom = t1, this.left = i, this.right = o;
            }
        }
        const Yi = (e, t1, i)=>(1 - i) * e + i * t1, Ji = (e)=>e * e * e * e * e;
        class Qi {
            clone() {
                const e = new Qi(this._minZoom, this._maxZoom, this._minPitch, this.maxPitch, this._renderWorldCopies, this.getProjection());
                return e._elevation = this._elevation, e._centerAltitude = this._centerAltitude, e._centerAltitudeValidForExaggeration = this._centerAltitudeValidForExaggeration, e.tileSize = this.tileSize, e.mercatorFromTransition = this.mercatorFromTransition, e.width = this.width, e.height = this.height, e.cameraElevationReference = this.cameraElevationReference, e._center = this._center, e._setZoom(this.zoom), e._seaLevelZoom = this._seaLevelZoom, e.angle = this.angle, e._fov = this._fov, e._pitch = this._pitch, e._nearZ = this._nearZ, e._farZ = this._farZ, e._averageElevation = this._averageElevation, e._orthographicProjectionAtLowPitch = this._orthographicProjectionAtLowPitch, e._unmodified = this._unmodified, e._edgeInsets = this._edgeInsets.clone(), e._camera = this._camera.clone(), e._calcMatrices(), e.freezeTileCoverage = this.freezeTileCoverage, e.frustumCorners = this.frustumCorners, e;
            }
            get isOrthographic() {
                return "globe" !== this.projection.name && this._orthographicProjectionAtLowPitch && this.pitch < 15;
            }
            get elevation() {
                return this._elevation;
            }
            set elevation(e) {
                this._elevation !== e && (this._elevation = e, this._updateCameraOnTerrain(), this._calcMatrices());
            }
            get depthOcclusionForSymbolsAndCircles() {
                return "globe" !== this.projection.name && !this.isOrthographic;
            }
            updateElevation(e, t1 = !1) {
                const i = this._elevation && this._elevation.exaggeration() !== this._centerAltitudeValidForExaggeration;
                (null == this._seaLevelZoom || i) && this._updateCameraOnTerrain(), (e || i) && this._constrainCamera(t1), this._calcMatrices();
            }
            getProjection() {
                return e.ay(this.projection, [
                    "name",
                    "center",
                    "parallels"
                ]);
            }
            setProjection(t1) {
                this.projectionOptions = t1 || {
                    name: "mercator"
                };
                const i = this.projection ? this.getProjection() : void 0;
                this.projection = e.bP(this.projectionOptions);
                const o = this.getProjection(), s = !e.bn(i, o);
                return s && this._calcMatrices(), this.mercatorFromTransition = !1, s;
            }
            setOrthographicProjectionAtLowPitch(e) {
                return this._orthographicProjectionAtLowPitch !== e && (this._orthographicProjectionAtLowPitch = e, this._calcMatrices(), !0);
            }
            setMercatorFromTransition() {
                const t1 = this.projection.name;
                this.mercatorFromTransition = !0, this.projectionOptions = {
                    name: "mercator"
                }, this.projection = e.bP({
                    name: "mercator"
                });
                const i = t1 !== this.projection.name;
                return i && this._calcMatrices(), i;
            }
            get minZoom() {
                return this._minZoom;
            }
            set minZoom(e) {
                this._minZoom !== e && (this._minZoom = e, this.zoom = Math.max(this.zoom, e));
            }
            get maxZoom() {
                return this._maxZoom;
            }
            set maxZoom(e) {
                this._maxZoom !== e && (this._maxZoom = e, this.zoom = Math.min(this.zoom, e));
            }
            get minPitch() {
                return this._minPitch;
            }
            set minPitch(e) {
                this._minPitch !== e && (this._minPitch = e, this.pitch = Math.max(this.pitch, e));
            }
            get maxPitch() {
                return this._maxPitch;
            }
            set maxPitch(e) {
                this._maxPitch !== e && (this._maxPitch = e, this.pitch = Math.min(this.pitch, e));
            }
            get renderWorldCopies() {
                return this._renderWorldCopies && !0 === this.projection.supportsWorldCopies;
            }
            set renderWorldCopies(e) {
                void 0 === e ? e = !0 : null === e && (e = !1), this._renderWorldCopies = e;
            }
            get worldSize() {
                return this.tileSize * this.scale;
            }
            get cameraWorldSizeForFog() {
                const e = Math.max(this._camera.getDistanceToElevation(this._averageElevation), Number.EPSILON);
                return this._worldSizeFromZoom(this._zoomFromMercatorZ(e));
            }
            get cameraWorldSize() {
                const e = Math.max(this._camera.getDistanceToElevation(this._averageElevation, !0), Number.EPSILON);
                return this._worldSizeFromZoom(this._zoomFromMercatorZ(e));
            }
            get pixelsPerMeter() {
                return this.projection.pixelsPerMeter(this.center.lat, this.worldSize);
            }
            get cameraPixelsPerMeter() {
                return e.bH(1, this.center.lat) * this.cameraWorldSizeForFog;
            }
            get centerOffset() {
                return this.centerPoint._sub(this.size._div(2));
            }
            get size() {
                return new e.P(this.width, this.height);
            }
            get bearing() {
                return e.bF(this.rotation, -180, 180);
            }
            set bearing(e) {
                this.rotation = e;
            }
            get rotation() {
                return -this.angle / Math.PI * 180;
            }
            set rotation(t1) {
                const i = -t1 * Math.PI / 180;
                this.angle !== i && (this._unmodified = !1, this.angle = i, this._calcMatrices(), this.rotationMatrix = e.ab.mat2.create(), e.ab.mat2.rotate(this.rotationMatrix, this.rotationMatrix, this.angle));
            }
            get pitch() {
                return this._pitch / Math.PI * 180;
            }
            set pitch(t1) {
                const i = e.aw(t1, this.minPitch, this.maxPitch) / 180 * Math.PI;
                this._pitch !== i && (this._unmodified = !1, this._pitch = i, this._calcMatrices());
            }
            get aspect() {
                return this.width / this.height;
            }
            get fov() {
                return this._fov / Math.PI * 180;
            }
            get fovX() {
                return this._fov;
            }
            get fovY() {
                const e = 1 / Math.tan(.5 * this.fovX);
                return 2 * Math.atan(1 / this.aspect / e);
            }
            set fov(t1) {
                t1 = Math.max(.01, Math.min(60, t1)), this._fov !== t1 && (this._unmodified = !1, this._fov = e.ai(t1), this._calcMatrices());
            }
            get averageElevation() {
                return this._averageElevation;
            }
            set averageElevation(e) {
                this._averageElevation = e, this._calcFogMatrices(), this._distanceTileDataCache = {};
            }
            get zoom() {
                return this._zoom;
            }
            set zoom(e) {
                const t1 = Math.min(Math.max(e, this.minZoom), this.maxZoom);
                this._zoom !== t1 && (this._unmodified = !1, this._setZoom(t1), this._updateSeaLevelZoom(), this._constrain(), this._calcMatrices());
            }
            _setZoom(e) {
                this._zoom = e, this.scale = this.zoomScale(e), this.tileZoom = Math.floor(e), this.zoomFraction = e - this.tileZoom;
            }
            get tileCoverLift() {
                return this._tileCoverLift;
            }
            set tileCoverLift(e) {
                this._tileCoverLift !== e && (this._tileCoverLift = e);
            }
            _updateCameraOnTerrain() {
                const e = this.elevation ? this.elevation.getAtPoint(this.locationCoordinate(this.center), Number.NEGATIVE_INFINITY) : Number.NEGATIVE_INFINITY, t1 = this.elevation && e === Number.NEGATIVE_INFINITY && this.elevation.visibleDemTiles.length > 0 && this.elevation.exaggeration() > 0 && this._centerAltitudeValidForExaggeration;
                if (!this._elevation || e === Number.NEGATIVE_INFINITY && (!t1 || !this._centerAltitude)) return this._centerAltitude = 0, this._seaLevelZoom = null, void (this._centerAltitudeValidForExaggeration = void 0);
                const i = this._elevation;
                t1 || this._centerAltitude && this._centerAltitudeValidForExaggeration && i.exaggeration() && this._centerAltitudeValidForExaggeration !== i.exaggeration() ? (this._centerAltitude = this._centerAltitude / this._centerAltitudeValidForExaggeration * i.exaggeration(), this._centerAltitudeValidForExaggeration = i.exaggeration()) : (this._centerAltitude = e || 0, this._centerAltitudeValidForExaggeration = i.exaggeration()), this._updateSeaLevelZoom();
            }
            _updateSeaLevelZoom() {
                void 0 !== this._centerAltitudeValidForExaggeration && (this._seaLevelZoom = this._zoomFromMercatorZ((this.pixelsPerMeter * this._centerAltitude + this.cameraToCenterDistance) / this.worldSize));
            }
            sampleAverageElevation() {
                if (!this._elevation) return 0;
                const t1 = this._elevation, i = [
                    [
                        .5,
                        .2
                    ],
                    [
                        .3,
                        .5
                    ],
                    [
                        .5,
                        .5
                    ],
                    [
                        .7,
                        .5
                    ],
                    [
                        .5,
                        .8
                    ]
                ], o = this.horizonLineFromTop();
                let s = 0, r = 0;
                for(let a = 0; a < i.length; a++){
                    const n = new e.P(i[a][0] * this.width, o + i[a][1] * (this.height - o)), l = t1.pointCoordinate(n);
                    if (!l) continue;
                    const c = 1 / Math.hypot(l[0] - this._camera.position[0], l[1] - this._camera.position[1]);
                    s += l[3] * c, r += c;
                }
                return 0 === r ? NaN : s / r;
            }
            get center() {
                return this._center;
            }
            set center(e) {
                e.lat === this._center.lat && e.lng === this._center.lng || (this._unmodified = !1, this._center = e, this._terrainEnabled() && ("ground" === this.cameraElevationReference ? this._updateCameraOnTerrain() : this._updateZoomFromElevation()), this._constrain(), this._calcMatrices());
            }
            _updateZoomFromElevation() {
                if (null == this._seaLevelZoom || !this._elevation) return;
                const e = this._seaLevelZoom, t1 = this._elevation.getAtPointOrZero(this.locationCoordinate(this.center)), i = this.pixelsPerMeter / this.worldSize * t1, o = this._mercatorZfromZoom(e), s = this._mercatorZfromZoom(this._maxZoom), r = Math.max(o - i, s);
                this._setZoom(this._zoomFromMercatorZ(r));
            }
            get padding() {
                return this._edgeInsets.toJSON();
            }
            set padding(e) {
                this._edgeInsets.equals(e) || (this._unmodified = !1, this._edgeInsets.interpolate(this._edgeInsets, e, 1), this._calcMatrices());
            }
            computeZoomRelativeTo(t1) {
                const i = this.rayIntersectionCoordinate(this.pointRayIntersection(this.centerPoint, t1.toAltitude()));
                let o;
                o = t1.z < this._camera.position[2] ? [
                    i.x,
                    i.y,
                    i.z
                ] : [
                    t1.x,
                    t1.y,
                    t1.z
                ];
                const s = e.ab.vec3.length(e.ab.vec3.sub([], this._camera.position, o));
                return e.aw(this._zoomFromMercatorZ(s), this._minZoom, this._maxZoom);
            }
            setFreeCameraOptions(t1) {
                if (!this.height) return;
                if (!t1.position && !t1.orientation) return;
                this._updateCameraState();
                let i = !1;
                if (t1.orientation && !e.ab.quat.exactEquals(t1.orientation, this._camera.orientation) && (i = this._setCameraOrientation(t1.orientation)), t1.position) {
                    const o = [
                        t1.position.x,
                        t1.position.y,
                        t1.position.z
                    ];
                    e.ab.vec3.exactEquals(o, this._camera.position) || (this._setCameraPosition(o), i = !0);
                }
                i && (this._updateStateFromCamera(), this.recenterOnTerrain());
            }
            getFreeCameraOptions() {
                this._updateCameraState();
                const t1 = this._camera.position, i = new Wi;
                return i.position = new e.aa(t1[0], t1[1], t1[2]), i.orientation = this._camera.orientation, i._elevation = this.elevation, i._renderWorldCopies = this.renderWorldCopies, i;
            }
            _setCameraOrientation(t1) {
                if (!e.ab.quat.length(t1)) return !1;
                e.ab.quat.normalize(t1, t1);
                const i = e.ab.vec3.transformQuat([], [
                    0,
                    0,
                    -1
                ], t1), o = e.ab.vec3.transformQuat([], [
                    0,
                    -1,
                    0
                ], t1);
                if (o[2] < 0) return !1;
                const s = Zi(i, o);
                return !!s && (this._camera.orientation = s, !0);
            }
            _setCameraPosition(t1) {
                const i = this.zoomScale(this.minZoom) * this.tileSize, o = this.zoomScale(this.maxZoom) * this.tileSize, s = this.cameraToCenterDistance;
                t1[2] = e.aw(t1[2], s / o, s / i), this._camera.position = t1;
            }
            get centerPoint() {
                return this._edgeInsets.getCenter(this.width, this.height);
            }
            get fovAboveCenter() {
                return this._fov * (.5 + this.centerOffset.y / this.height);
            }
            isPaddingEqual(e) {
                return this._edgeInsets.equals(e);
            }
            interpolatePadding(e, t1, i) {
                this._unmodified = !1, this._edgeInsets.interpolate(e, t1, i), this._constrain(), this._calcMatrices();
            }
            coveringZoomLevel(e) {
                const t1 = (e.roundZoom ? Math.round : Math.floor)(this.zoom + this.scaleZoom(this.tileSize / e.tileSize));
                return Math.max(0, t1);
            }
            getVisibleUnwrappedCoordinates(t1) {
                const i = [
                    new e.bQ(0, t1)
                ];
                if (this.renderWorldCopies) {
                    const o = this.pointCoordinate(new e.P(0, 0)), s = this.pointCoordinate(new e.P(this.width, 0)), r = this.pointCoordinate(new e.P(this.width, this.height)), a = this.pointCoordinate(new e.P(0, this.height)), n = Math.floor(Math.min(o.x, s.x, r.x, a.x)), l = Math.floor(Math.max(o.x, s.x, r.x, a.x)), c = 1;
                    for(let o = n - c; o <= l + c; o++)0 !== o && i.push(new e.bQ(o, t1));
                }
                return i;
            }
            isLODDisabled(e) {
                return (!e || this.pitch <= 60) && this._edgeInsets.top <= this._edgeInsets.bottom && !this._elevation && !this.projection.isReprojectedInTileSpace;
            }
            extendTileCover(t1, i, o) {
                let s = [];
                const r = void 0 !== o, a = !r;
                if (a && this.zoom < i) return s;
                if (r && 0 === o[0] && 0 === o[1]) return s;
                const n = new Set, l = (t1, i, o, r, a)=>{
                    const l = e.c5(i, t1, o, r, a);
                    n.has(l) || (s.push(new e.aG(t1, i, o, r, a)), n.add(l));
                };
                for(let e = 0; e < t1.length; e++){
                    const s = t1[e];
                    if (a && s.canonical.z !== i) continue;
                    const n = s.canonical, c = s.overscaledZ, h = s.wrap, u = 1 << n.z, d = n.x + 1 < u, _ = n.x > 0, p = n.y + 1 < u, f = n.y > 0, m = s.wrap - (_ ? 0 : 1), g = s.wrap + (d ? 0 : 1), v = _ ? n.x - 1 : u - 1, y = d ? n.x + 1 : 0;
                    if (r) o[0] < 0 ? (l(c, g, n.z, y, n.y), o[1] < 0 && p && (l(c, h, n.z, n.x, n.y + 1), l(c, g, n.z, y, n.y + 1)), o[1] > 0 && f && (l(c, h, n.z, n.x, n.y - 1), l(c, g, n.z, y, n.y - 1))) : o[0] > 0 ? (l(c, m, n.z, v, n.y), o[1] < 0 && p && (l(c, h, n.z, n.x, n.y + 1), l(c, m, n.z, v, n.y + 1)), o[1] > 0 && f && (l(c, h, n.z, n.x, n.y - 1), l(c, m, n.z, v, n.y - 1))) : o[1] < 0 && p ? l(c, h, n.z, n.x, n.y + 1) : f && l(c, h, n.z, n.x, n.y - 1);
                    else {
                        const e = s.visibleQuadrants;
                        1 & e && (l(c, m, n.z, v, n.y), f && (l(c, h, n.z, n.x, n.y - 1), l(c, m, n.z, v, n.y - 1))), 2 & e && (l(c, g, n.z, y, n.y), f && (l(c, h, n.z, n.x, n.y - 1), l(c, g, n.z, y, n.y - 1))), 4 & e && (l(c, m, n.z, v, n.y), p && (l(c, h, n.z, n.x, n.y + 1), l(c, m, n.z, v, n.y + 1))), 8 & e && (l(c, g, n.z, y, n.y), p && (l(c, h, n.z, n.x, n.y + 1), l(c, g, n.z, y, n.y + 1)));
                    }
                }
                const c = [];
                for (const e of s)s.some((t1)=>e.isChildOf(t1)) || c.push(e);
                if (s = c.filter((e)=>!t1.some((t1)=>!!(e.overscaledZ < i && t1.isChildOf(e)) || e.equals(t1) || e.isChildOf(t1))), a) {
                    const e = 1 << i, t1 = "globe" === this.projection.name ? this._camera.mercatorPosition : this.pointCoordinate(this.getCameraPoint()), o = [
                        e * t1.x,
                        e * t1.y
                    ], r = 4, a = r * r;
                    s = s.filter((e)=>{
                        const t1 = e.canonical.x + .5 - o[0], i = e.canonical.y + .5 - o[1];
                        return t1 * t1 + i * i < a;
                    });
                }
                return s;
            }
            coveringTiles(t1) {
                let i = this.coveringZoomLevel(t1);
                const o = i, s = this.elevation && this.elevation.exaggeration(), r = s && !t1.isTerrainDEM, a = "mercator" === this.projection.name;
                if (void 0 !== t1.minzoom && i < t1.minzoom) return [];
                void 0 !== t1.maxzoom && i > t1.maxzoom && (i = t1.maxzoom);
                const n = this.locationCoordinate(this.center), l = this.center.lat, c = 1 << i, h = [
                    c * n.x,
                    c * n.y,
                    0
                ], u = "globe" === this.projection.name, d = !u, _ = e.bR.fromInvProjectionMatrix(this.invProjMatrix, this.worldSize, i, d), p = u ? this._camera.mercatorPosition : this.pointCoordinate(this.getCameraPoint()), f = c * e.bH(1, this.center.lat), m = this._camera.position[2] / e.bH(1, this.center.lat), g = [
                    c * p.x,
                    c * p.y,
                    m * (d ? 1 : f)
                ], v = u || s, y = this.cameraToCenterDistance / t1.tileSize * (t1.roundZoom ? 1 : .502), x = this.isLODDisabled(!0) ? i : 0;
                let b;
                if (this._elevation && t1.isTerrainDEM) b = 1e4 * this._elevation.exaggeration();
                else if (this._elevation) {
                    const e = this._elevation.getMinMaxForVisibleTiles();
                    b = e ? e.max : this._centerAltitude;
                } else b = this._centerAltitude;
                const w = t1.isTerrainDEM ? -b : this._elevation ? this._elevation.getMinElevationBelowMSL() : 0, T = this.projection.isReprojectedInTileSpace ? e.bS(this) : 1, E = (t1)=>{
                    const i = 1 / 4e4, o = new e.aa(t1.x + i, t1.y, t1.z), s = new e.aa(t1.x, t1.y + i, t1.z), r = t1.toLngLat(), a = o.toLngLat(), n = s.toLngLat(), l = this.locationCoordinate(r), c = this.locationCoordinate(a), h = this.locationCoordinate(n), u = Math.hypot(c.x - l.x, c.y - l.y), d = Math.hypot(h.x - l.x, h.y - l.y);
                    return Math.sqrt(u * d) * T / i;
                }, S = (t1)=>{
                    const i = b, o = w;
                    return {
                        aabb: e.bV(this, c, 0, 0, 0, t1, o, i, this.projection),
                        zoom: 0,
                        x: 0,
                        y: 0,
                        minZ: o,
                        maxZ: i,
                        wrap: t1,
                        fullyVisible: !1
                    };
                }, C = [];
                let I = [];
                const R = i, D = t1.reparseOverscaled ? o : i, L = (m - this._centerAltitude) * f, A = (e)=>{
                    if (!this._elevation || !e.tileID || !a) return;
                    const t1 = this._elevation.getMinMaxForTile(e.tileID), i = e.aabb;
                    t1 ? (i.min[2] = t1.min, i.max[2] = t1.max, i.center[2] = (i.min[2] + i.max[2]) / 2) : (e.shouldSplit = P(e), e.shouldSplit || (i.min[2] = i.max[2] = i.center[2] = this._centerAltitude));
                }, z = (e, t1)=>{
                    if (.707 * t1 < e) return 1;
                    const i = t1 / e;
                    return i / (1.4144271570014144 + (Math.pow(1.1, i - 1.4144271570014144 + 1) - 1) / (1.1 - 1) - 1);
                }, P = (t1)=>{
                    if (t1.zoom < x) return !0;
                    if (t1.zoom === R) return !1;
                    if (null != t1.shouldSplit) return t1.shouldSplit;
                    const i = t1.aabb.distanceX(g), s = t1.aabb.distanceY(g);
                    let n = L, c = 1;
                    if (u) {
                        n = t1.aabb.distanceZ(g);
                        const i = Math.pow(2, t1.zoom), o = e.aS((t1.y + 1) / i), s = e.aS(t1.y / i), r = Math.min(Math.max(l, o), s), a = e.c9(r) / e.c9(l);
                        if (c = r === l ? 1 / Math.max(1, this._mercatorScaleRatio - .3) : Math.min(1, a / this._mercatorScaleRatio), this.zoom <= e.c6 && t1.zoom === R - 1 && a >= .9) return !0;
                    } else if (r && (n = t1.aabb.distanceZ(g) * f), this.projection.isReprojectedInTileSpace && o <= 5) {
                        const i = Math.pow(2, t1.zoom), o = E(new e.aa((t1.x + .5) / i, (t1.y + .5) / i));
                        c = o > .85 ? 1 : o;
                    }
                    if (!a) {
                        const e = Math.sqrt(i * i + s * s + n * n);
                        let o = (1 << R - t1.zoom) * y * c;
                        return o *= z(Math.max(n, L), e), e < o;
                    }
                    let d = Number.MAX_VALUE, _ = 0;
                    const p = t1.aabb.getCorners(), m = [];
                    for (const t1 of p){
                        e.ab.vec3.sub(m, t1, g), u || (r ? m[2] *= f : m[2] = L);
                        const i = e.ab.vec3.dot(m, this._camera.forward());
                        i < d && (d = i, _ = Math.abs(m[2]));
                    }
                    let v = (1 << R - t1.zoom) * y * c;
                    if (v *= z(Math.max(_, L), d), d < v) return !0;
                    const b = t1.aabb.closestPoint(h);
                    return b[0] === h[0] && b[1] === h[1];
                };
                if (this.renderWorldCopies) for(let e = 1; e <= 3; e++)C.push(S(-e)), C.push(S(e));
                for(C.push(S(0)); C.length > 0;){
                    const o = C.pop(), s = o.x, n = o.y;
                    let l = o.fullyVisible;
                    const d = ()=>"globe" === this.projection.name && (0 === o.y || o.y === (1 << o.zoom) - 1);
                    if (!l) {
                        let t1 = v ? o.aabb.intersects(_) : o.aabb.intersectsFlat(_);
                        if (0 === t1 && d()) {
                            const i = new e.bT(o.zoom, s, n);
                            t1 = e.bU(this, c, i, !0).intersects(_);
                        }
                        if (0 === t1) continue;
                        l = 2 === t1;
                    }
                    if (o.zoom !== R && P(o)) for(let t1 = 0; t1 < 4; t1++){
                        const i = (s << 1) + t1 % 2, h = (n << 1) + (t1 >> 1), d = {
                            aabb: a ? o.aabb.quadrant(t1) : e.bV(this, c, o.zoom + 1, i, h, o.wrap, o.minZ, o.maxZ, this.projection),
                            zoom: o.zoom + 1,
                            x: i,
                            y: h,
                            wrap: o.wrap,
                            fullyVisible: l,
                            tileID: void 0,
                            shouldSplit: void 0,
                            minZ: o.minZ,
                            maxZ: o.maxZ
                        };
                        r && !u && (d.tileID = new e.aG(o.zoom + 1 === R ? D : o.zoom + 1, o.wrap, o.zoom + 1, i, h), A(d)), C.push(d);
                    }
                    else {
                        const r = o.zoom === R ? D : o.zoom;
                        if (t1.minzoom && t1.minzoom > r) continue;
                        let a = 0;
                        if (!l) {
                            let i = v ? o.aabb.intersectsPrecise(_) : o.aabb.intersectsPreciseFlat(_);
                            if (0 === i && d()) {
                                const t1 = new e.bT(o.zoom, s, n);
                                i = e.bU(this, c, t1, !0).intersectsPrecise(_);
                            }
                            if (0 === i) continue;
                            if (t1.calculateQuadrantVisibility) {
                                if (_.containsPoint(o.aabb.center)) a = 15;
                                else for(let e = 0; e < 4; e++)0 !== o.aabb.quadrant(e).intersects(_) && (a |= 1 << e);
                            }
                        }
                        const u = h[0] - (.5 + s + (o.wrap << o.zoom)) * (1 << i - o.zoom), p = h[1] - .5 - n, f = o.tileID ? o.tileID : new e.aG(r, o.wrap, o.zoom, s, n);
                        t1.calculateQuadrantVisibility && (f.visibleQuadrants = a), I.push({
                            tileID: f,
                            distanceSq: u * u + p * p
                        });
                    }
                }
                if (this.fogCullDistSq) {
                    const i = this.fogCullDistSq, o = this.horizonLineFromTop();
                    I = I.filter((s)=>{
                        const r = [
                            0,
                            0,
                            0,
                            1
                        ], a = [
                            e.ag,
                            e.ag,
                            0,
                            1
                        ], n = this.calculateFogTileMatrix(s.tileID.toUnwrapped());
                        e.ab.vec4.transformMat4(r, r, n), e.ab.vec4.transformMat4(a, a, n);
                        const l = e.ab.vec4.min([], r, a), c = e.ab.vec4.max([], r, a), h = e.bW(l, c);
                        if (0 === h) return !0;
                        let u = !1;
                        const d = this._elevation;
                        if (d && h > i && 0 !== o) {
                            const i = this.calculateProjMatrix(s.tileID.toUnwrapped());
                            let r;
                            t1.isTerrainDEM || (r = d.getMinMaxForTile(s.tileID)), r || (r = {
                                min: w,
                                max: b
                            });
                            const a = e.c7(this.rotation), n = [
                                a[0] * e.ag,
                                a[1] * e.ag,
                                r.max
                            ];
                            e.ab.vec3.transformMat4(n, n, i), u = (1 - n[1]) * this.height * .5 < o;
                        }
                        return h < i || u;
                    });
                }
                return I.sort((e, t1)=>e.distanceSq - t1.distanceSq).map((e)=>e.tileID);
            }
            resize(e, t1) {
                this.width = e, this.height = t1, this.pixelsToGLUnits = [
                    2 / e,
                    -2 / t1
                ], this._constrain(), this._calcMatrices();
            }
            get unmodified() {
                return this._unmodified;
            }
            zoomScale(e) {
                return Math.pow(2, e);
            }
            scaleZoom(e) {
                return Math.log(e) / Math.LN2;
            }
            project(t1) {
                const i = e.aw(t1.lat, -e.bX, e.bX), o = this.projection.project(t1.lng, i);
                return new e.P(o.x * this.worldSize, o.y * this.worldSize);
            }
            unproject(e) {
                return this.projection.unproject(e.x / this.worldSize, e.y / this.worldSize);
            }
            get point() {
                return this.project(this.center);
            }
            get pointMerc() {
                return this.point._div(this.worldSize);
            }
            get pixelsPerMeterRatio() {
                return this.pixelsPerMeter / e.bH(1, this.center.lat) / this.worldSize;
            }
            setLocationAtPoint(t1, i) {
                let o, s;
                const r = this.centerPoint;
                if ("globe" === this.projection.name) {
                    const e = this.worldSize;
                    o = (i.x - r.x) / e, s = (i.y - r.y) / e;
                } else {
                    const e = this.pointCoordinate(i), t1 = this.pointCoordinate(r);
                    o = e.x - t1.x, s = e.y - t1.y;
                }
                const a = this.locationCoordinate(t1);
                this.setLocation(new e.aa(a.x - o, a.y - s));
            }
            setLocation(e) {
                this.center = this.coordinateLocation(e), this.projection.wrap && (this.center = this.center.wrap());
            }
            locationPoint(e) {
                return this.projection.locationPoint(this, e);
            }
            locationPoint3D(e) {
                return this.projection.locationPoint(this, e, !0);
            }
            pointLocation(e) {
                return this.coordinateLocation(this.pointCoordinate(e));
            }
            pointLocation3D(e) {
                return this.coordinateLocation(this.pointCoordinate3D(e));
            }
            locationCoordinate(t1, i) {
                const o = i ? e.bH(i, t1.lat) : void 0, s = this.projection.project(t1.lng, t1.lat);
                return new e.aa(s.x, s.y, o);
            }
            coordinateLocation(e) {
                return this.projection.unproject(e.x, e.y);
            }
            pointRayIntersection(t1, i) {
                const o = null != i ? i : this._centerAltitude, s = [
                    t1.x,
                    t1.y,
                    0,
                    1
                ], r = [
                    t1.x,
                    t1.y,
                    1,
                    1
                ];
                e.ab.vec4.transformMat4(s, s, this.pixelMatrixInverse), e.ab.vec4.transformMat4(r, r, this.pixelMatrixInverse);
                const a = r[3];
                e.ab.vec4.scale(s, s, 1 / s[3]), e.ab.vec4.scale(r, r, 1 / a);
                const n = s[2], l = r[2];
                return {
                    p0: s,
                    p1: r,
                    t: n === l ? 0 : (o - n) / (l - n)
                };
            }
            screenPointToMercatorRay(t1) {
                const i = [
                    t1.x,
                    t1.y,
                    0,
                    1
                ], o = [
                    t1.x,
                    t1.y,
                    1,
                    1
                ];
                return e.ab.vec4.transformMat4(i, i, this.pixelMatrixInverse), e.ab.vec4.transformMat4(o, o, this.pixelMatrixInverse), e.ab.vec4.scale(i, i, 1 / i[3]), e.ab.vec4.scale(o, o, 1 / o[3]), i[2] = e.bH(i[2], this._center.lat) * this.worldSize, o[2] = e.bH(o[2], this._center.lat) * this.worldSize, e.ab.vec4.scale(i, i, 1 / this.worldSize), e.ab.vec4.scale(o, o, 1 / this.worldSize), new e.aq([
                    i[0],
                    i[1],
                    i[2]
                ], e.ab.vec3.normalize([], e.ab.vec3.sub([], o, i)));
            }
            rayIntersectionCoordinate(t1) {
                const { p0: i, p1: o, t: s } = t1, r = e.bH(i[2], this._center.lat), a = e.bH(o[2], this._center.lat);
                return new e.aa(e.af(i[0], o[0], s) / this.worldSize, e.af(i[1], o[1], s) / this.worldSize, e.af(r, a, s));
            }
            pointCoordinate(e, t1 = this._centerAltitude) {
                return this.projection.pointCoordinate(this, e.x, e.y, t1);
            }
            pointCoordinate3D(t1) {
                if (!this.elevation) return this.pointCoordinate(t1);
                let i = this.projection.pointCoordinate3D(this, t1.x, t1.y);
                if (i) return new e.aa(i[0], i[1], i[2]);
                let o = 0, s = this.horizonLineFromTop();
                if (t1.y > s) return this.pointCoordinate(t1);
                const r = .02 * s, a = t1.clone();
                for(let t1 = 0; t1 < 10 && s - o > r; t1++){
                    a.y = e.af(o, s, .66);
                    const t1 = this.projection.pointCoordinate3D(this, a.x, a.y);
                    t1 ? (s = a.y, i = t1) : o = a.y;
                }
                return i ? new e.aa(i[0], i[1], i[2]) : this.pointCoordinate(t1);
            }
            isPointAboveHorizon(e) {
                return this.projection.isPointAboveHorizon(this, e);
            }
            isPointOnSurface(t1) {
                if (t1.y < 0 || t1.y > this.height || t1.x < 0 || t1.x > this.width) return !1;
                if (this.elevation || this.zoom >= e.bY) return !this.isPointAboveHorizon(t1);
                const i = this.pointCoordinate(t1);
                return i.y >= 0 && i.y <= 1;
            }
            _coordinatePoint(t1, i) {
                const o = i && this.elevation ? this.elevation.getAtPointOrZero(t1, this._centerAltitude) : this._centerAltitude, s = [
                    t1.x * this.worldSize,
                    t1.y * this.worldSize,
                    o + t1.toAltitude(),
                    1
                ];
                return e.ab.vec4.transformMat4(s, s, this.pixelMatrix), s[3] > 0 ? new e.P(s[0] / s[3], s[1] / s[3]) : new e.P(Number.MAX_VALUE, Number.MAX_VALUE);
            }
            _getBoundsNonRectangular() {
                const { top: t1, left: i } = this._edgeInsets, o = this.height - this._edgeInsets.bottom, s = this.width - this._edgeInsets.right, r = this.pointLocation3D(new e.P(i, t1)), a = this.pointLocation3D(new e.P(s, t1)), n = this.pointLocation3D(new e.P(s, o)), l = this.pointLocation3D(new e.P(i, o));
                let c = Math.min(r.lng, a.lng, n.lng, l.lng), h = Math.max(r.lng, a.lng, n.lng, l.lng), u = Math.min(r.lat, a.lat, n.lat, l.lat), d = Math.max(r.lat, a.lat, n.lat, l.lat);
                const _ = Math.pow(2, -this.zoom) / 16 * 270, p = "globe" === this.projection.name ? 1 : 4, f = (t1, i, o, s, r)=>{
                    const a = (t1 + o) / 2, n = (i + s) / 2, l = new e.P(a, n), { lng: m, lat: g } = this.pointLocation3D(l), v = Math.max(0, c - m, u - g, m - h, g - d);
                    c = Math.min(c, m), h = Math.max(h, m), u = Math.min(u, g), d = Math.max(d, g), (r < p || v > _) && (f(t1, i, a, n, r + 1), f(a, n, o, s, r + 1));
                };
                if (f(i, t1, s, t1, 1), f(s, t1, s, o, 1), f(s, o, i, o, 1), f(i, o, i, t1, 1), "globe" === this.projection.name) {
                    const [t1, i] = e.bZ(this);
                    t1 ? (d = 90, h = 180, c = -180) : i && (u = -90, h = 180, c = -180);
                }
                return new e.az(new e.bO(c, u), new e.bO(h, d));
            }
            _getBoundsRectangular(t1, i) {
                const { top: o, left: s } = this._edgeInsets, r = this.height - this._edgeInsets.bottom, a = this.width - this._edgeInsets.right, n = new e.P(s, o), l = new e.P(a, o), c = new e.P(a, r), h = new e.P(s, r);
                let u = this.pointCoordinate(n, t1), d = this.pointCoordinate(l, t1);
                const _ = this.pointCoordinate(c, i), p = this.pointCoordinate(h, i), f = (e, t1)=>(t1.y - e.y) / (t1.x - e.x);
                return u.y > 1 && d.y >= 0 ? u = new e.aa((1 - p.y) / f(p, u) + p.x, 1) : u.y < 0 && d.y <= 1 && (u = new e.aa(-p.y / f(p, u) + p.x, 0)), d.y > 1 && u.y >= 0 ? d = new e.aa((1 - _.y) / f(_, d) + _.x, 1) : d.y < 0 && u.y <= 1 && (d = new e.aa(-_.y / f(_, d) + _.x, 0)), (new e.az).extend(this.coordinateLocation(u)).extend(this.coordinateLocation(d)).extend(this.coordinateLocation(p)).extend(this.coordinateLocation(_));
            }
            _getBoundsRectangularTerrain() {
                const e = this.elevation;
                if (!e.visibleDemTiles.length || e.isUsingMockSource()) return this._getBoundsRectangular(0, 0);
                const t1 = e.visibleDemTiles.reduce((e, t1)=>{
                    if (t1.dem) {
                        const i = t1.dem.tree;
                        e.min = Math.min(e.min, i.minimums[0]), e.max = Math.max(e.max, i.maximums[0]);
                    }
                    return e;
                }, {
                    min: Number.MAX_VALUE,
                    max: 0
                });
                return this._getBoundsRectangular(t1.min * e.exaggeration(), t1.max * e.exaggeration());
            }
            getBounds() {
                return "mercator" === this.projection.name || "equirectangular" === this.projection.name ? this._terrainEnabled() ? this._getBoundsRectangularTerrain() : this._getBoundsRectangular(0, 0) : this._getBoundsNonRectangular();
            }
            horizonLineFromTop(e = !0) {
                const t1 = this.height / 2 / Math.tan(this._fov / 2) / Math.tan(Math.max(this._pitch, .1)) - this.centerOffset.y, i = this.height / 2 - t1 * (1 - this._horizonShift);
                return e ? Math.max(0, i) : i;
            }
            getMaxBounds() {
                return this.maxBounds;
            }
            setMaxBounds(t1) {
                this.maxBounds = t1, this.minLat = -e.bX, this.maxLat = e.bX, this.minLng = -180, this.maxLng = 180, t1 && (this.minLat = t1.getSouth(), this.maxLat = t1.getNorth(), this.minLng = t1.getWest(), this.maxLng = t1.getEast(), this.maxLng < this.minLng && (this.maxLng += 360)), this.worldMinX = e.at(this.minLng) * this.tileSize, this.worldMaxX = e.at(this.maxLng) * this.tileSize, this.worldMinY = e.aA(this.maxLat) * this.tileSize, this.worldMaxY = e.aA(this.minLat) * this.tileSize, this._constrain();
            }
            calculatePosMatrix(e, t1) {
                return this.projection.createTileMatrix(this, t1, e);
            }
            calculateDistanceTileData(t1) {
                const i = t1.key, o = this._distanceTileDataCache;
                if (o[i]) return o[i];
                const s = t1.canonical, r = 1 / this.height, a = this.cameraWorldSize, n = a / this.zoomScale(s.z), l = (s.x + Math.pow(2, s.z) * t1.wrap) * n, c = s.y * n, h = this.point;
                h.x *= a / this.worldSize, h.y *= a / this.worldSize;
                const u = this.angle, d = Math.sin(-u), _ = -Math.cos(-u);
                return o[i] = {
                    bearing: [
                        d,
                        _
                    ],
                    center: [
                        (h.x - l) * r,
                        (h.y - c) * r
                    ],
                    scale: n / e.ag * r
                }, o[i];
            }
            calculateFogTileMatrix(t1) {
                const i = t1.key, o = this._fogTileMatrixCache;
                if (o[i]) return o[i];
                const s = this.projection.createTileMatrix(this, this.cameraWorldSizeForFog, t1);
                return e.ab.mat4.multiply(s, this.worldToFogMatrix, s), o[i] = new Float32Array(s), o[i];
            }
            calculateProjMatrix(t1, i = !1, o = !1) {
                const s = t1.key;
                let r;
                if (r = o ? this._expandedProjMatrixCache : i ? this._alignedProjMatrixCache : this._projMatrixCache, r[s]) return r[s];
                const a = this.calculatePosMatrix(t1, this.worldSize);
                let n;
                return n = this.projection.isReprojectedInTileSpace ? this.mercatorMatrix : o ? this.expandedFarZProjMatrix : i ? this.alignedProjMatrix : this.projMatrix, e.ab.mat4.multiply(a, n, a), r[s] = new Float32Array(a), r[s];
            }
            calculatePixelsToTileUnitsMatrix(t1) {
                const i = t1.tileID.key, o = this._pixelsToTileUnitsCache;
                if (o[i]) return o[i];
                const s = e.b_(t1, this);
                return o[i] = s, o[i];
            }
            customLayerMatrix() {
                return this.mercatorMatrix.slice();
            }
            globeToMercatorMatrix() {
                if ("globe" === this.projection.name) {
                    const t1 = 1 / this.worldSize, i = e.ab.mat4.fromScaling([], [
                        t1,
                        t1,
                        t1
                    ]);
                    return e.ab.mat4.multiply(i, i, this.globeMatrix), i;
                }
            }
            recenterOnTerrain() {
                if (!this._elevation || "globe" === this.projection.name) return;
                const t1 = this._elevation;
                this._updateCameraState();
                const i = e.bH(1, this._center.lat) * this.worldSize, o = this._computeCameraPosition(i), s = this._camera.forward(), r = e.bH(1, this._center.lat);
                o[2] /= r, s[2] /= r, e.ab.vec3.normalize(s, s);
                const a = t1.raycast(o, s, t1.exaggeration());
                if (a) {
                    const t1 = e.ab.vec3.scaleAndAdd([], o, s, a), i = new e.aa(t1[0], t1[1], e.bH(t1[2], e.aS(t1[1]))), n = (i.z + e.ab.vec3.length([
                        i.x - o[0],
                        i.y - o[1],
                        i.z - o[2] * r
                    ])) * this._pixelsPerMercatorPixel;
                    this._seaLevelZoom = this._zoomFromMercatorZ(n), this._centerAltitude = i.toAltitude(), this._center = this.coordinateLocation(i), this._updateZoomFromElevation(), this._constrain(), this._calcMatrices();
                }
            }
            _constrainCamera(t1 = !1) {
                if (!this._elevation) return;
                const i = this._elevation, o = e.bH(1, this._center.lat) * this.worldSize, s = this._computeCameraPosition(o), r = i.getAtPointOrZero(new e.aa(...s)), a = this.pixelsPerMeter / this.worldSize * r, n = this._minimumHeightOverTerrain(), l = s[2] - a;
                if (l <= n) {
                    if (l < 0 || t1) {
                        const t1 = this.locationCoordinate(this._center, this._centerAltitude), i = [
                            s[0],
                            s[1],
                            t1.z - s[2]
                        ], o = e.ab.vec3.length(i);
                        i[2] -= (n - l) / this._pixelsPerMercatorPixel;
                        const r = e.ab.vec3.length(i);
                        if (0 === r) return;
                        e.ab.vec3.scale(i, i, o / r * this._pixelsPerMercatorPixel), this._camera.position = [
                            s[0],
                            s[1],
                            t1.z * this._pixelsPerMercatorPixel - i[2]
                        ], this._updateStateFromCamera();
                    } else this._isCameraConstrained = !0;
                }
            }
            _constrain() {
                if (!this.center || !this.width || !this.height || this._constraining) return;
                this._constraining = !0;
                const t1 = "globe" === this.projection.name || this.mercatorFromTransition;
                if (this.projection.isReprojectedInTileSpace || t1) {
                    const i = this.center;
                    return i.lat = e.aw(i.lat, this.minLat, this.maxLat), (this.maxBounds || !this.renderWorldCopies && !t1) && (i.lng = e.aw(i.lng, this.minLng, this.maxLng)), this.center = i, void (this._constraining = !1);
                }
                const i = this._unmodified, { x: o, y: s } = this.point;
                let r = 0, a = o, n = s;
                const l = this.width / 2, c = this.height / 2, h = this.worldMinY * this.scale, u = this.worldMaxY * this.scale;
                if (s - c < h && (n = h + c), s + c > u && (n = u - c), u - h < this.height && (r = Math.max(r, this.height / (u - h)), n = (u + h) / 2), this.maxBounds || !this._renderWorldCopies || !this.projection.wrap) {
                    const e = this.worldMinX * this.scale, t1 = this.worldMaxX * this.scale, i = this.worldSize / 2 - (e + t1) / 2;
                    a = (o + i + this.worldSize) % this.worldSize - i, a - l < e && (a = e + l), a + l > t1 && (a = t1 - l), t1 - e < this.width && (r = Math.max(r, this.width / (t1 - e)), a = (t1 + e) / 2);
                }
                a === o && n === s || (this.center = this.unproject(new e.P(a, n))), r && (this.zoom += this.scaleZoom(r)), this._constrainCamera(), this._unmodified = i, this._constraining = !1;
            }
            _minZoomForBounds() {
                let e = Math.max(0, this.scaleZoom(this.height / (this.worldMaxY - this.worldMinY)));
                return this.maxBounds && (e = Math.max(e, this.scaleZoom(this.width / (this.worldMaxX - this.worldMinX)))), e;
            }
            _maxCameraBoundsDistance() {
                return this._mercatorZfromZoom(this._minZoomForBounds());
            }
            _calcMatrices() {
                if (!this.height) return;
                const t1 = this.centerOffset, i = "globe" === this.projection.name, o = this.pixelsPerMeter;
                "globe" === this.projection.name && (this._mercatorScaleRatio = e.bH(1, this.center.lat) / e.bH(1, e.c8));
                const s = e.b$(this.projection, this.zoom, this.width, this.height, 1024);
                this._pixelsPerMercatorPixel = this.projection.pixelSpaceConversion(this.center.lat, this.worldSize, s), this.cameraToCenterDistance = .5 / Math.tan(.5 * this._fov) * this.height * this._pixelsPerMercatorPixel, this._updateCameraState(), this._farZ = this.projection.farthestPixelDistance(this), this._nearZ = this.height / 50;
                const r = "meters" === this.projection.zAxisUnit ? o : 1, a = this._camera.getWorldToCamera(this.worldSize, r);
                let n;
                const l = this._camera.getCameraToClipPerspective(this._fov, this.width / this.height, this._nearZ, this._farZ);
                if (l[8] = 2 * -t1.x / this.width, l[9] = 2 * t1.y / this.height, this.isOrthographic) {
                    let e = .5 * this.height / Math.tan(this._fov / 2) * 1 * Math.tan(.5 * this._fov), i = e * this.aspect, o = -i, s = -e;
                    i -= t1.x, o -= t1.x, e += t1.y, s += t1.y, n = this._camera.getCameraToClipOrthographic(o, i, s, e, this._nearZ, this._farZ), ((e, t1, i, o)=>{
                        for(let s = 0; s < 16; s++)e[s] = Yi(t1[s], i[s], o);
                    })(n, n, l, Ji(this.pitch >= 15 ? 1 : this.pitch / 15));
                } else n = l;
                const c = e.ab.mat4.mul([], l, a);
                let h = e.ab.mat4.mul([], n, a);
                if (this.projection.isReprojectedInTileSpace) {
                    const t1 = this.locationCoordinate(this.center), i = e.ab.mat4.identity([]);
                    e.ab.mat4.translate(i, i, [
                        t1.x * this.worldSize,
                        t1.y * this.worldSize,
                        0
                    ]), e.ab.mat4.multiply(i, i, e.c0(this)), e.ab.mat4.translate(i, i, [
                        -t1.x * this.worldSize,
                        -t1.y * this.worldSize,
                        0
                    ]), e.ab.mat4.multiply(h, h, i), e.ab.mat4.multiply(c, c, i), this.inverseAdjustmentMatrix = e.c1(this);
                } else this.inverseAdjustmentMatrix = [
                    1,
                    0,
                    0,
                    1
                ];
                if (this.mercatorMatrix = e.ab.mat4.scale([], h, [
                    this.worldSize,
                    this.worldSize,
                    this.worldSize / r,
                    1
                ]), this.projMatrix = h, this.invProjMatrix = e.ab.mat4.invert(new Float64Array(16), this.projMatrix), i) {
                    const i = this._camera.getCameraToClipPerspective(this._fov, this.width / this.height, this._nearZ, 1 / 0);
                    i[8] = 2 * -t1.x / this.width, i[9] = 2 * t1.y / this.height, this.expandedFarZProjMatrix = e.ab.mat4.mul([], i, a);
                } else this.expandedFarZProjMatrix = this.projMatrix;
                const u = e.ab.mat4.invert([], n);
                this.frustumCorners = e.c2.fromInvProjectionMatrix(u, this.horizonLineFromTop(), this.height), this.cameraFrustum = e.bR.fromInvProjectionMatrix(this.invProjMatrix, this.worldSize, 0, !i);
                const d = new Float32Array(16);
                e.ab.mat4.identity(d), e.ab.mat4.scale(d, d, [
                    1,
                    -1,
                    1
                ]), e.ab.mat4.rotateX(d, d, this._pitch), e.ab.mat4.rotateZ(d, d, this.angle);
                const _ = e.ab.mat4.perspective(new Float32Array(16), this._fov, this.width / this.height, this._nearZ, this._farZ);
                this.starsProjMatrix = e.ab.mat4.clone(_);
                const p = (Math.PI / 2 - this._pitch) * (this.height / this._fov) * this._horizonShift;
                _[8] = 2 * -t1.x / this.width, _[9] = 2 * (t1.y + p) / this.height, this.skyboxMatrix = e.ab.mat4.multiply(d, _, d);
                const f = this.point, m = f.x, g = f.y, v = this.width % 2 / 2, y = this.height % 2 / 2, x = Math.cos(this.angle), b = Math.sin(this.angle), w = m - Math.round(m) + x * v + b * y, T = g - Math.round(g) + x * y + b * v, E = new Float64Array(h);
                if (e.ab.mat4.translate(E, E, [
                    w > .5 ? w - 1 : w,
                    T > .5 ? T - 1 : T,
                    0
                ]), this.alignedProjMatrix = E, h = e.ab.mat4.create(), e.ab.mat4.scale(h, h, [
                    this.width / 2,
                    -this.height / 2,
                    1
                ]), e.ab.mat4.translate(h, h, [
                    1,
                    -1,
                    0
                ]), this.labelPlaneMatrix = h, h = e.ab.mat4.create(), e.ab.mat4.scale(h, h, [
                    1,
                    -1,
                    1
                ]), e.ab.mat4.translate(h, h, [
                    -1,
                    -1,
                    0
                ]), e.ab.mat4.scale(h, h, [
                    2 / this.width,
                    2 / this.height,
                    1
                ]), this.glCoordMatrix = h, this.pixelMatrix = e.ab.mat4.multiply(new Float64Array(16), this.labelPlaneMatrix, c), this._calcFogMatrices(), this._distanceTileDataCache = {}, h = e.ab.mat4.invert(new Float64Array(16), this.pixelMatrix), !h) throw new Error("failed to invert matrix");
                if (this.pixelMatrixInverse = h, "globe" === this.projection.name || this.mercatorFromTransition) {
                    this.globeMatrix = e.c3(this);
                    const t1 = [
                        this.globeMatrix[12],
                        this.globeMatrix[13],
                        this.globeMatrix[14]
                    ];
                    this.globeCenterInViewSpace = e.ab.vec3.transformMat4(t1, t1, a), this.globeRadius = this.worldSize / 2 / Math.PI - 1;
                } else this.globeMatrix = h;
                this._projMatrixCache = {}, this._alignedProjMatrixCache = {}, this._pixelsToTileUnitsCache = {}, this._expandedProjMatrixCache = {};
            }
            _calcFogMatrices() {
                this._fogTileMatrixCache = {};
                const t1 = this.cameraWorldSizeForFog, i = this.cameraPixelsPerMeter, o = this._camera.position, s = 1 / this.height / this._pixelsPerMercatorPixel, r = [
                    t1,
                    t1,
                    i
                ];
                e.ab.vec3.scale(r, r, s), e.ab.vec3.scale(o, o, -1), e.ab.vec3.multiply(o, o, r);
                const a = e.ab.mat4.create();
                e.ab.mat4.translate(a, a, o), e.ab.mat4.scale(a, a, r), this.mercatorFogMatrix = a, this.worldToFogMatrix = this._camera.getWorldToCameraPosition(t1, i, s);
            }
            _computeCameraPosition(e) {
                const t1 = (e = e || this.pixelsPerMeter) / this.pixelsPerMeter, i = this._camera.forward(), o = this.point, s = this._mercatorZfromZoom(this._seaLevelZoom ? this._seaLevelZoom : this._zoom) * t1 - e / this.worldSize * this._centerAltitude;
                return [
                    o.x / this.worldSize - i[0] * s,
                    o.y / this.worldSize - i[1] * s,
                    e / this.worldSize * this._centerAltitude - i[2] * s
                ];
            }
            _updateCameraState() {
                this.height && (this._camera.setPitchBearing(this._pitch, this.angle), this._camera.position = this._computeCameraPosition());
            }
            _translateCameraConstrained(t1) {
                const i = this._maxCameraBoundsDistance() * Math.cos(this._pitch), o = this._camera.position[2], s = t1[2];
                let r = 1;
                this.projection.wrap && (this.center = this.center.wrap()), s > 0 && (r = Math.min((i - o) / s, 1)), this._camera.position = e.ab.vec3.scaleAndAdd([], this._camera.position, t1, r), this._updateStateFromCamera();
            }
            _updateStateFromCamera() {
                const t1 = this._camera.position, i = this._camera.forward(), { pitch: o, bearing: s } = this._camera.getPitchBearing(), r = e.bH(this._centerAltitude, this.center.lat) * this._pixelsPerMercatorPixel, a = this._mercatorZfromZoom(this._maxZoom) * Math.cos(e.ai(this._maxPitch)), n = Math.max((t1[2] - r) / Math.cos(o), a), l = this._zoomFromMercatorZ(n);
                e.ab.vec3.scaleAndAdd(t1, t1, i, n), this._pitch = e.aw(o, e.ai(this.minPitch), e.ai(this.maxPitch)), this.angle = e.bF(s, -Math.PI, Math.PI), this._setZoom(e.aw(l, this._minZoom, this._maxZoom)), this._updateSeaLevelZoom(), this._center = this.coordinateLocation(new e.aa(t1[0], t1[1], t1[2])), this._unmodified = !1, this._constrain(), this._calcMatrices();
            }
            _worldSizeFromZoom(e) {
                return Math.pow(2, e) * this.tileSize;
            }
            _mercatorZfromZoom(e) {
                return this.cameraToCenterDistance / this._worldSizeFromZoom(e);
            }
            _minimumHeightOverTerrain() {
                const e = Math.min(null != this._seaLevelZoom ? this._seaLevelZoom : this._zoom, this._maxZoom) + 4;
                return this._mercatorZfromZoom(e);
            }
            _zoomFromMercatorZ(e) {
                return this.scaleZoom(this.cameraToCenterDistance / (e * this.tileSize));
            }
            zoomFromMercatorZAdjusted(t1) {
                let i = 0, o = e.bY, s = 0, r = 1 / 0;
                for(; o - i > 1e-6 && o > i;){
                    const e = i + .5 * (o - i), a = this.tileSize * Math.pow(2, e), n = this.getCameraToCenterDistance(this.projection, e, a), l = this.scaleZoom(n / (t1 * this.tileSize)), c = Math.abs(e - l);
                    c < r && (r = c, s = e), e < l ? i = e : o = e;
                }
                return s;
            }
            _terrainEnabled() {
                return !(!this._elevation || !this.projection.supportsTerrain && (e.w("Terrain is not yet supported with alternate projections. Use mercator or globe to enable terrain."), 1));
            }
            anyCornerOffEdge(t1, i) {
                const o = Math.min(t1.x, i.x), s = Math.max(t1.x, i.x), r = Math.min(t1.y, i.y), a = Math.max(t1.y, i.y);
                if (r < this.horizonLineFromTop(!1)) return !0;
                if ("mercator" !== this.projection.name) return !1;
                const n = [
                    new e.P(o, r),
                    new e.P(s, a),
                    new e.P(o, a),
                    new e.P(s, r)
                ], l = this.renderWorldCopies ? -3 : 0, c = this.renderWorldCopies ? 4 : 1;
                for (const e of n){
                    const t1 = this.pointRayIntersection(e);
                    if (t1.t < 0) return !0;
                    const i = this.rayIntersectionCoordinate(t1);
                    if (i.x < l || i.y < 0 || i.x > c || i.y > 1) return !0;
                }
                return !1;
            }
            isHorizonVisible() {
                return this.pitch + e.c4(this.fovAboveCenter) > 88 || this.anyCornerOffEdge(new e.P(0, 0), new e.P(this.width, this.height));
            }
            zoomDeltaToMovement(t1, i) {
                const o = e.ab.vec3.length(e.ab.vec3.sub([], this._camera.position, t1)), s = this._zoomFromMercatorZ(o) + i;
                return o - this._mercatorZfromZoom(s);
            }
            getCameraPoint() {
                if ("globe" === this.projection.name) {
                    const t1 = function([t1, i, o], s) {
                        const r = [
                            t1,
                            i,
                            o,
                            1
                        ];
                        e.ab.vec4.transformMat4(r, r, s);
                        const a = r[3] = Math.max(r[3], 1e-6);
                        return r[0] /= a, r[1] /= a, r[2] /= a, r;
                    }([
                        this.globeMatrix[12],
                        this.globeMatrix[13],
                        this.globeMatrix[14]
                    ], this.pixelMatrix);
                    return new e.P(t1[0], t1[1]);
                }
                {
                    const t1 = Math.tan(this._pitch) * (this.cameraToCenterDistance || 1);
                    return this.centerPoint.add(new e.P(0, t1));
                }
            }
            getCameraToCenterDistance(t1, i = this.zoom, o = this.worldSize) {
                const s = e.b$(t1, i, this.width, this.height, 1024), r = t1.pixelSpaceConversion(this.center.lat, o, s);
                let a = .5 / Math.tan(.5 * this._fov) * this.height * r;
                return this.isOrthographic && (a = Yi(1, a, Ji(this.pitch >= 15 ? 1 : this.pitch / 15))), a;
            }
            getWorldToCameraMatrix() {
                const t1 = this._camera.getWorldToCamera(this.worldSize, "meters" === this.projection.zAxisUnit ? this.pixelsPerMeter : 1);
                return "globe" === this.projection.name && e.ab.mat4.multiply(t1, t1, this.globeMatrix), t1;
            }
            getFrustum(t1) {
                return e.bR.fromInvProjectionMatrix(this.invProjMatrix, this.worldSize, t1, "meters" === this.projection.zAxisUnit);
            }
            constructor(t1, i, o, s, r, a, n){
                this.tileSize = 512, this._renderWorldCopies = void 0 === r || r, this._minZoom = t1 || 0, this._maxZoom = i || 22, this._minPitch = o ?? 0, this._maxPitch = s ?? 60, this.setProjection(a), this.setMaxBounds(n), this.width = 0, this.height = 0, this._center = new e.bO(0, 0), this.zoom = 0, this.angle = 0, this._fov = .6435011087932844, this._pitch = 0, this._nearZ = 0, this._farZ = 0, this._unmodified = !0, this._edgeInsets = new Ki, this._projMatrixCache = {}, this._alignedProjMatrixCache = {}, this._fogTileMatrixCache = {}, this._expandedProjMatrixCache = {}, this._distanceTileDataCache = {}, this._camera = new $i, this._centerAltitude = 0, this._averageElevation = 0, this.cameraElevationReference = "ground", this._pixelsPerMercatorPixel = 1, this.globeRadius = 0, this.globeCenterInViewSpace = [
                    0,
                    0,
                    0
                ], this._tileCoverLift = 0, this.freezeTileCoverage = !1, this._horizonShift = .1, this._orthographicProjectionAtLowPitch = !1;
            }
        }
        const eo = (t1, i)=>{
            if (i > 0 && t1.terrain && e.w("Cutoff is currently disabled on terrain"), i <= 0 || t1.terrain) return {
                shouldRenderCutoff: !1,
                uniformValues: {
                    u_cutoff_params: [
                        0,
                        0,
                        0,
                        1
                    ]
                }
            };
            const o = t1.transform, s = Math.max(Math.abs(o._zoom - (t1.minCutoffZoom - 1)), 1), r = o.isLODDisabled(!1) ? e.ac(60, 45, o.pitch) : e.ac(30, 15, o.pitch), a = o._farZ - o._nearZ, n = i * o.height, l = ((1 - (c = r)) * o.cameraToCenterDistance + c * (o._farZ + n)) * s;
            var c;
            return {
                shouldRenderCutoff: r < 1,
                uniformValues: {
                    u_cutoff_params: [
                        o._nearZ,
                        o._farZ,
                        (l - o._nearZ) / a,
                        (l - n - o._nearZ) / a
                    ]
                }
            };
        }, to = {
            cascadeCount: 2,
            normalOffset: 3,
            shadowMapResolution: 2048
        };
        class io {
            constructor(e, t1){
                this.aabb = e, this.lastCascade = t1;
            }
        }
        class oo {
            add(e, t1) {
                const i = this.receivers[e.key];
                void 0 !== i ? (i.aabb.min[0] = Math.min(i.aabb.min[0], t1.min[0]), i.aabb.min[1] = Math.min(i.aabb.min[1], t1.min[1]), i.aabb.min[2] = Math.min(i.aabb.min[2], t1.min[2]), i.aabb.max[0] = Math.max(i.aabb.max[0], t1.max[0]), i.aabb.max[1] = Math.max(i.aabb.max[1], t1.max[1]), i.aabb.max[2] = Math.max(i.aabb.max[2], t1.max[2])) : this.receivers[e.key] = new io(t1, null);
            }
            clear() {
                this.receivers = {};
            }
            get(e) {
                return this.receivers[e.key];
            }
            computeRequiredCascades(t1, i, o) {
                const s = e.cd.fromPoints(t1.points);
                let r = 0;
                for(const t1 in this.receivers){
                    const a = this.receivers[t1];
                    if (!a) continue;
                    if (!s.intersectsAabb(a.aabb)) continue;
                    a.aabb.min = s.closestPoint(a.aabb.min), a.aabb.max = s.closestPoint(a.aabb.max);
                    const n = a.aabb.getCorners();
                    for(let t1 = 0; t1 < o.length; t1++){
                        let s = !0;
                        for (const r of n){
                            const a = [
                                r[0] * i,
                                r[1] * i,
                                r[2]
                            ];
                            if (e.ab.vec3.transformMat4(a, a, o[t1].matrix), a[0] < -1 || a[0] > 1 || a[1] < -1 || a[1] > 1) {
                                s = !1;
                                break;
                            }
                        }
                        if (a.lastCascade = t1, r = Math.max(r, t1), s) break;
                    }
                }
                return r + 1;
            }
        }
        class so {
            destroy() {
                for (const e of this._cascades)e.texture.destroy(), e.framebuffer.destroy();
                this._cascades = [];
            }
            updateShadowParameters(t1, i) {
                const o = this.painter;
                if (this._enabled = !1, this._shadowLayerCount = 0, this._receivers.clear(), !i || !i.properties) return;
                const s = i.properties.get("shadow-intensity");
                if (!i.shadowsEnabled() || s <= 0) return;
                if (this._shadowLayerCount = o.style.order.reduce((e, i)=>{
                    const s = o.style._mergedLayers[i];
                    return e + (s.hasShadowPass() && !s.isHidden(t1.zoom) ? 1 : 0);
                }, 0), this._enabled = this._shadowLayerCount > 0, !this.enabled) return;
                const r = o.context, a = to.shadowMapResolution, n = to.shadowMapResolution;
                if (0 === this._cascades.length || to.shadowMapResolution !== this._cascades[0].texture.size[0]) {
                    this._cascades = [];
                    for(let t1 = 0; t1 < to.cascadeCount; ++t1){
                        const t1 = o._shadowMapDebug, i = r.gl, s = r.createFramebuffer(a, n, t1, "texture"), l = new e.T(r, {
                            width: a,
                            height: n,
                            data: null
                        }, i.DEPTH_COMPONENT16);
                        if (s.depthAttachment.set(l.texture), t1) {
                            const t1 = new e.T(r, {
                                width: a,
                                height: n,
                                data: null
                            }, i.RGBA8);
                            s.colorAttachment.set(t1.texture);
                        }
                        this._cascades.push({
                            framebuffer: s,
                            texture: l,
                            matrix: [],
                            far: 0,
                            boundingSphereRadius: 0,
                            frustum: new e.bR,
                            scale: 0
                        });
                    }
                }
                this.shadowDirection = ao(i);
                let l = 0;
                if (t1.elevation) {
                    const e = t1.elevation, i = [
                        1e4,
                        -10000
                    ];
                    e.visibleDemTiles.filter((e)=>e.dem).forEach((e)=>{
                        const t1 = e.dem.tree;
                        i[0] = Math.min(i[0], t1.minimums[0]), i[1] = Math.max(i[1], t1.maximums[0]);
                    }), 1e4 !== i[0] && (l = (i[1] - i[0]) * e.exaggeration());
                }
                const c = 1.5 * t1.cameraToCenterDistance, h = 3 * c, u = new Float64Array(16);
                for(let i = 0; i < this._cascades.length; ++i){
                    const o = this._cascades[i];
                    let s = t1.height / 50, r = 1;
                    1 === to.cascadeCount ? r = h : 0 === i ? r = c : (s = c, r = h);
                    const [a, n] = lo(t1, this.shadowDirection, s, r, to.shadowMapResolution, l);
                    o.scale = t1.scale, o.matrix = a, o.boundingSphereRadius = n, e.ab.mat4.invert(u, o.matrix), o.frustum = e.bR.fromInvProjectionMatrix(u, 1, 0, !0), o.far = r;
                }
                const d = this._cascades.length - 1;
                this._uniformValues.u_fade_range = [
                    .75 * this._cascades[d].far,
                    this._cascades[d].far
                ], this._uniformValues.u_shadow_intensity = s, this._uniformValues.u_shadow_direction = [
                    this.shadowDirection[0],
                    this.shadowDirection[1],
                    this.shadowDirection[2]
                ], this._uniformValues.u_shadow_texel_size = 1 / to.shadowMapResolution, this._uniformValues.u_shadow_map_resolution = to.shadowMapResolution, this._uniformValues.u_shadowmap_0 = Xi.ShadowMap0, this._uniformValues.u_shadowmap_1 = Xi.ShadowMap0 + 1, this._groundShadowTiles = o.transform.coveringTiles({
                    tileSize: 512,
                    renderWorldCopies: !0
                });
                const _ = o.transform.elevation;
                for (const e of this._groundShadowTiles){
                    let t1 = {
                        min: 0,
                        max: 0
                    };
                    if (_) {
                        const i = _.getMinMaxForTile(e);
                        i && (t1 = i);
                    }
                    this.addShadowReceiver(e.toUnwrapped(), t1.min, t1.max);
                }
            }
            get enabled() {
                return this._enabled && !this._forceDisable;
            }
            set enabled(e) {
                this._enabled = e;
            }
            drawShadowPass(t1, i) {
                if (!this.enabled) return;
                const o = this.painter, s = o.context;
                this._numCascadesToRender = this._receivers.computeRequiredCascades(o.transform.getFrustum(0), o.transform.worldSize, this._cascades), s.viewport.set([
                    0,
                    0,
                    to.shadowMapResolution,
                    to.shadowMapResolution
                ]);
                for(let r = 0; r < this._numCascadesToRender; ++r){
                    o.currentShadowCascade = r, s.bindFramebuffer.set(this._cascades[r].framebuffer.framebuffer), s.clear({
                        color: e.aj.white,
                        depth: 1
                    });
                    for (const e of t1.order){
                        const s = t1._mergedLayers[e];
                        if (!s.hasShadowPass() || s.isHidden(o.transform.zoom)) continue;
                        const r = t1.getLayerSourceCache(s), a = r ? i[r.id] : void 0;
                        ("model" === s.type || a && a.length) && o.renderLayer(o, r, s, a);
                    }
                }
                o.currentShadowCascade = 0;
            }
            drawGroundShadows() {
                if (!this.enabled) return;
                const e = this.painter, t1 = e.style, i = e.context, o = t1.directionalLight, s = t1.ambientLight;
                if (!o || !s) return;
                const r = [], a = eo(e, e.longestCutoffRange);
                a.shouldRenderCutoff && r.push("RENDER_CUTOFF"), r.push("RENDER_SHADOWS", "DEPTH_TEXTURE"), this.useNormalOffset && r.push("NORMAL_OFFSET");
                const n = no(t1, o, s), l = new Bi(i.gl.LEQUAL, Bi.ReadOnly, e.depthRangeFor3D);
                for (const t1 of this._groundShadowTiles){
                    const o = t1.toUnwrapped(), s = e.isTileAffectedByFog(t1), c = e.getOrCreateProgram("groundShadow", {
                        defines: r,
                        overrideFog: s
                    });
                    this.setupShadows(o, c), e.uploadCommonUniforms(i, c, o, null, a);
                    const h = {
                        u_matrix: e.transform.calculateProjMatrix(o),
                        u_ground_shadow_factor: n
                    };
                    c.draw(e, i.gl.TRIANGLES, l, Ui.disabled, ki.multiply, Vi.disabled, h, "ground_shadow", e.tileExtentBuffer, e.quadTriangleIndexBuffer, e.tileExtentSegments, {}, e.transform.zoom, null, null);
                }
            }
            getShadowPassColorMode() {
                return this.painter._shadowMapDebug ? ki.unblended : ki.disabled;
            }
            getShadowPassDepthMode() {
                return this._depthMode;
            }
            getShadowCastingLayerCount() {
                return this._shadowLayerCount;
            }
            calculateShadowPassMatrixFromTile(t1) {
                const i = this.painter.transform, o = i.calculatePosMatrix(t1, i.worldSize);
                return e.ab.mat4.multiply(o, this._cascades[this.painter.currentShadowCascade].matrix, o), Float32Array.from(o);
            }
            calculateShadowPassMatrixFromMatrix(t1) {
                return e.ab.mat4.multiply(t1, this._cascades[this.painter.currentShadowCascade].matrix, t1), Float32Array.from(t1);
            }
            setupShadows(t1, i, o, s = 0) {
                if (!this.enabled) return;
                const r = this.painter.transform, a = this.painter.context, n = a.gl, l = this._uniformValues, c = new Float64Array(16), h = r.calculatePosMatrix(t1, r.worldSize);
                for(let t1 = 0; t1 < this._cascades.length; t1++)e.ab.mat4.multiply(c, this._cascades[t1].matrix, h), l[0 === t1 ? "u_light_matrix_0" : "u_light_matrix_1"] = Float32Array.from(c), a.activeTexture.set(n.TEXTURE0 + Xi.ShadowMap0 + t1), this._cascades[t1].texture.bind(n.NEAREST, n.CLAMP_TO_EDGE);
                if (this.useNormalOffset = !!o, this.useNormalOffset) {
                    const i = e.cc(t1.canonical), a = 2 / r.tileSize * e.ag / to.shadowMapResolution, n = a * this._cascades[0].boundingSphereRadius, c = a * this._cascades[this._cascades.length - 1].boundingSphereRadius, h = ("vector-tile" === o ? 1 : 3) / Math.pow(2, s - t1.canonical.z - (1 - r.zoom + Math.floor(r.zoom)));
                    l.u_shadow_normal_offset = [
                        i,
                        n * h,
                        c * h
                    ], l.u_shadow_bias = [
                        6e-5,
                        .0012,
                        .012
                    ];
                } else l.u_shadow_bias = [
                    36e-5,
                    .0012,
                    .012
                ];
                i.setShadowUniformValues(a, l);
            }
            setupShadowsFromMatrix(t1, i, o = !1) {
                if (!this.enabled) return;
                const s = this.painter.context, r = s.gl, a = this._uniformValues, n = new Float64Array(16);
                for(let i = 0; i < to.cascadeCount; i++)e.ab.mat4.multiply(n, this._cascades[i].matrix, t1), a[0 === i ? "u_light_matrix_0" : "u_light_matrix_1"] = Float32Array.from(n), s.activeTexture.set(r.TEXTURE0 + Xi.ShadowMap0 + i), this._cascades[i].texture.bind(r.NEAREST, r.CLAMP_TO_EDGE);
                if (this.useNormalOffset = o, o) {
                    const e = to.normalOffset;
                    a.u_shadow_normal_offset = [
                        1,
                        e,
                        e
                    ], a.u_shadow_bias = [
                        6e-5,
                        .0012,
                        .012
                    ];
                } else a.u_shadow_bias = [
                    36e-5,
                    .0012,
                    .012
                ];
                i.setShadowUniformValues(s, a);
            }
            getShadowUniformValues() {
                return this._uniformValues;
            }
            getCurrentCascadeFrustum() {
                return this._cascades[this.painter.currentShadowCascade].frustum;
            }
            computeSimplifiedTileShadowVolume(t1, i, o, s) {
                if (s[2] >= 0) return {};
                const r = (function(t1, i, o) {
                    const s = o / (1 << t1.canonical.z);
                    return new e.cd([
                        t1.canonical.x * s + t1.wrap * o,
                        t1.canonical.y * s + t1.wrap * o,
                        0
                    ], [
                        (t1.canonical.x + 1) * s + t1.wrap * o,
                        (t1.canonical.y + 1) * s + t1.wrap * o,
                        i
                    ]);
                })(t1, i, o).getCorners(), a = i / -s[2];
                s[0] < 0 ? (e.ab.vec3.add(r[0], r[0], [
                    s[0] * a,
                    0,
                    0
                ]), e.ab.vec3.add(r[3], r[3], [
                    s[0] * a,
                    0,
                    0
                ])) : s[0] > 0 && (e.ab.vec3.add(r[1], r[1], [
                    s[0] * a,
                    0,
                    0
                ]), e.ab.vec3.add(r[2], r[2], [
                    s[0] * a,
                    0,
                    0
                ])), s[1] < 0 ? (e.ab.vec3.add(r[0], r[0], [
                    0,
                    s[1] * a,
                    0
                ]), e.ab.vec3.add(r[1], r[1], [
                    0,
                    s[1] * a,
                    0
                ])) : s[1] > 0 && (e.ab.vec3.add(r[2], r[2], [
                    0,
                    s[1] * a,
                    0
                ]), e.ab.vec3.add(r[3], r[3], [
                    0,
                    s[1] * a,
                    0
                ]));
                const n = {};
                return n.vertices = r, n.planes = [
                    ro(r[1], r[0], r[4]),
                    ro(r[2], r[1], r[5]),
                    ro(r[3], r[2], r[6]),
                    ro(r[0], r[3], r[7])
                ], n;
            }
            addShadowReceiver(t1, i, o) {
                this._receivers.add(t1, e.cd.fromTileIdAndHeight(t1, i, o));
            }
            getMaxCascadeForTile(e) {
                const t1 = this._receivers.get(e);
                return t1 && t1.lastCascade ? t1.lastCascade : 0;
            }
            constructor(e){
                this.painter = e, this._enabled = !1, this._shadowLayerCount = 0, this._numCascadesToRender = 0, this._cascades = [], this._groundShadowTiles = [], this._receivers = new oo, this._depthMode = new Bi(e.context.gl.LEQUAL, Bi.ReadWrite, [
                    0,
                    1
                ]), this._uniformValues = {
                    u_light_matrix_0: new Float32Array(16),
                    u_light_matrix_1: new Float32Array(16),
                    u_shadow_intensity: 0,
                    u_fade_range: [
                        0,
                        0
                    ],
                    u_shadow_normal_offset: [
                        1,
                        1,
                        1
                    ],
                    u_shadow_texel_size: 1,
                    u_shadow_map_resolution: 1,
                    u_shadow_direction: [
                        0,
                        0,
                        1
                    ],
                    u_shadow_bias: [
                        36e-5,
                        .0012,
                        .012
                    ],
                    u_shadowmap_0: 0,
                    u_shadowmap_1: 0
                }, this._forceDisable = !1, this.useNormalOffset = !1, e.tp.registerParameter(this, [
                    "Shadows"
                ], "_forceDisable", {
                    label: "forceDisable"
                }, ()=>{
                    this.painter.style.map.triggerRepaint();
                }), e.tp.registerParameter(to, [
                    "Shadows"
                ], "cascadeCount", {
                    min: 1,
                    max: 2,
                    step: 1
                }), e.tp.registerParameter(to, [
                    "Shadows"
                ], "normalOffset", {
                    min: 0,
                    max: 10,
                    step: .05
                }), e.tp.registerParameter(to, [
                    "Shadows"
                ], "shadowMapResolution", {
                    min: 32,
                    max: 2048,
                    step: 32
                }), e.tp.registerBinding(this, [
                    "Shadows"
                ], "_numCascadesToRender", {
                    readonly: !0,
                    label: "numCascadesToRender"
                });
            }
        }
        function ro(t1, i, o) {
            const s = e.ab.vec3.sub([], o, i), r = e.ab.vec3.sub([], t1, i), a = e.ab.vec3.cross([], s, r), n = e.ab.vec3.length(a);
            return 0 === n ? [
                0,
                0,
                1,
                0
            ] : (e.ab.vec3.scale(a, a, 1 / n), [
                a[0],
                a[1],
                a[2],
                -e.ab.vec3.dot(a, i)
            ]);
        }
        function ao(t1) {
            const i = t1.properties.get("direction"), o = e.cb(i.x, i.y, i.z);
            o[2] = e.aw(o[2], 0, 75);
            const s = e.ce([
                o[0],
                o[1],
                o[2]
            ]);
            return e.ab.vec3.fromValues(s.x, s.y, s.z);
        }
        function no(t1, i, o) {
            const s = "none" === i.properties.get("color-use-theme"), r = i.properties.get("color"), a = i.properties.get("intensity"), n = i.properties.get("direction"), l = [
                n.x,
                n.y,
                n.z
            ], c = "none" === o.properties.get("color-use-theme"), h = o.properties.get("color"), u = o.properties.get("intensity"), d = Math.max(e.ab.vec3.dot([
                0,
                0,
                1
            ], l), 0), _ = [
                0,
                0,
                0
            ];
            e.ab.vec3.scale(_, h.toRenderColor(c ? null : t1.getLut(i.scope)).toArray01Linear().slice(0, 3), u);
            const p = [
                0,
                0,
                0
            ];
            return e.ab.vec3.scale(p, r.toRenderColor(s ? null : t1.getLut(o.scope)).toArray01Linear().slice(0, 3), d * a), e.cf([
                _[0] > 0 ? _[0] / (_[0] + p[0]) : 0,
                _[1] > 0 ? _[1] / (_[1] + p[1]) : 0,
                _[2] > 0 ? _[2] / (_[2] + p[2]) : 0
            ]);
        }
        function lo(t1, i, o, s, r, a) {
            const n = t1.zoom, l = t1.scale, c = t1.worldSize, h = 1 / c, u = t1.aspect, d = Math.sqrt(1 + u * u) * Math.tan(.5 * t1.fovX), _ = d * d, p = s - o, f = s + o;
            let m, g;
            _ > p / f ? (m = s, g = s * d) : (m = .5 * f * (1 + _), g = .5 * Math.sqrt(p * p + 2 * (s * s + o * o) * _ + f * f * _ * _));
            const v = t1.projection.pixelsPerMeter(t1.center.lat, c), y = t1._camera.getCameraToWorldMercator(), x = [
                0,
                0,
                -m * h
            ];
            e.ab.vec3.transformMat4(x, x, y);
            let b = g * h;
            const w = t1._edgeInsets;
            if (!(0 === w.left && 0 === w.top && 0 === w.right && 0 === w.bottom || w.left === w.right && w.top === w.bottom)) {
                const i = t1._camera.getWorldToCamera(t1.worldSize, "meters" === t1.projection.zAxisUnit ? v : 1), r = t1._camera.getCameraToClipPerspective(t1._fov, t1.width / t1.height, o, s);
                r[8] = 2 * -t1.centerOffset.x / t1.width, r[9] = 2 * t1.centerOffset.y / t1.height;
                const a = new Float64Array(16);
                e.ab.mat4.mul(a, r, i);
                const h = new Float64Array(16);
                e.ab.mat4.invert(h, a);
                const u = e.bR.fromInvProjectionMatrix(h, c, n, !0);
                for (const i of u.points){
                    const o = ((T = i)[0] /= l, T[1] /= l, T[2] = e.bH(T[2], t1._center.lat), T);
                    b = Math.max(b, e.ab.vec3.len(e.ab.vec3.subtract([], x, o)));
                }
            }
            var T;
            b *= r / (r - 1);
            const E = Math.acos(i[2]), S = Math.atan2(-i[0], -i[1]), C = new $i;
            C.position = x, C.setPitchBearing(E, S);
            const I = C.getWorldToCamera(c, v), R = b * c, D = Math.min(t1._mercatorZfromZoom(17) * c * -2, -2 * R), L = C.getCameraToClipOrthographic(-R, R, -R, R, D, (R + a * v) / i[2]), A = new Float64Array(16);
            e.ab.mat4.multiply(A, L, I);
            const z = e.ab.vec3.fromValues(Math.floor(1e6 * x[0]) / 1e6 * c, Math.floor(1e6 * x[1]) / 1e6 * c, 0), P = .5 * r, M = [
                0,
                0,
                0
            ];
            e.ab.vec3.transformMat4(M, z, A), e.ab.vec3.scale(M, M, P);
            const O = [
                Math.floor(M[0]),
                Math.floor(M[1]),
                Math.floor(M[2])
            ], F = [
                0,
                0,
                0
            ];
            e.ab.vec3.sub(F, M, O), e.ab.vec3.scale(F, F, -1 / P);
            const k = new Float64Array(16);
            return e.ab.mat4.identity(k), e.ab.mat4.translate(k, k, F), e.ab.mat4.multiply(A, k, A), [
                A,
                R
            ];
        }
        class co extends e.E {
            loadModel(t1, i) {
                return e.aM(this.requestManager.transformRequest(i, e.R.Model).url).then((i)=>{
                    if (!i) return;
                    const o = e.aN(i), s = new e.aO(t1, void 0, void 0, o);
                    return s.computeBoundsAndApplyParent(), s;
                }).catch((o)=>{
                    if (o && 404 === o.status) return null;
                    this.fire(new e.y(new Error(`Could not load model ${t1} from ${i}: ${o.message}`)));
                });
            }
            load(t1, i, o = {
                keepNumReferences: !1
            }) {
                this.models[i] || (this.models[i] = {});
                const s = Object.keys(t1);
                this.numModelsLoading[i] = (this.numModelsLoading[i] || 0) + s.length;
                const r = [];
                for (const e of s)r.push(this.loadModel(e, t1[e]));
                Promise.allSettled(r).then((t1)=>{
                    for(let e = 0; e < t1.length; e++){
                        const { status: r, value: a } = t1[e];
                        if ("fulfilled" === r && a) {
                            const t1 = this.models[i][s[e]];
                            this.models[i][s[e]] = {
                                model: a,
                                numReferences: o.keepNumReferences && t1 ? t1.numReferences : 1
                            };
                        }
                    }
                    this.numModelsLoading[i] -= s.length, this.fire(new e.z("data", {
                        dataType: "style"
                    }));
                }).catch((t1)=>{
                    this.fire(new e.y(new Error(`Could not load models: ${t1.message}`)));
                });
            }
            isLoaded() {
                for(const e in this.numModelsLoading)if (this.numModelsLoading[e] > 0) return !1;
                return !0;
            }
            hasModel(e, t1) {
                return !!this.getModel(e, t1);
            }
            getModel(e, t1) {
                return this.models[t1] || (this.models[t1] = {}), this.models[t1][e] ? this.models[t1][e].model : void 0;
            }
            addModel(e, t1, i) {
                this.models[i] || (this.models[i] = {}), this.modelUris[i] || (this.modelUris[i] = {}), this.hasModel(e, i) && this.models[i][e].numReferences++, this.modelUris[i][e] = this.requestManager.normalizeModelURL(t1), this.load({
                    [e]: this.modelUris[i][e]
                }, i);
            }
            addModels(e, t1) {
                this.models[t1] || (this.models[t1] = {}), this.modelUris[t1] || (this.modelUris[t1] = {});
                const i = this.modelUris[t1];
                for(const o in e)this.models[t1][o] = {}, i[o] = this.requestManager.normalizeModelURL(e[o]);
                this.load(i, t1, {
                    keepNumReferences: !0
                });
            }
            reloadModels(e) {
                this.load(this.modelUris[e], e);
            }
            addModelsFromBucket(e, t1) {
                this.models[t1] || (this.models[t1] = {}), this.modelUris[t1] || (this.modelUris[t1] = {});
                const i = {};
                for (const o of e)this.hasModel(o, t1) ? this.models[t1][o].numReferences++ : (this.modelUris[t1][o] = this.requestManager.normalizeModelURL(o), i[o] = this.modelUris[t1][o]);
                this.load(i, t1);
            }
            removeModel(e, t1) {
                if (this.models[t1] && this.models[t1][e] && (this.models[t1][e].numReferences--, 0 === this.models[t1][e].numReferences)) {
                    const i = this.models[t1][e].model;
                    delete this.models[t1][e], delete this.modelUris[t1][e], i.destroy();
                }
            }
            listModels(e) {
                return this.models[e] || (this.models[e] = {}), Object.keys(this.models[e]);
            }
            upload(e, t1) {
                this.models[t1] || (this.models[t1] = {});
                for(const i in this.models[t1])this.models[t1][i].model && this.models[t1][i].model.upload(e.context);
            }
            constructor(e){
                super(), this.requestManager = e, this.models = {
                    "": {}
                }, this.modelUris = {
                    "": {}
                }, this.numModelsLoading = {};
            }
        }
        const ho = new e.a5({
            data: new e.a6(e.a3.colorTheme.data)
        }), uo = {
            "mbx-indoor-active-floorplans": {
                default: [
                    "literal",
                    []
                ]
            },
            "mbx-indoor-underground": {
                default: [
                    "literal",
                    !1
                ]
            },
            "mbx-indoor-loaded-levels": {
                default: [
                    "literal",
                    []
                ]
            },
            "mbx-indoor-level-height": {
                default: [
                    "literal",
                    {}
                ]
            },
            "mbx-indoor-level-base": {
                default: [
                    "literal",
                    {}
                ]
            },
            "mbx-indoor-level-selected": {
                default: [
                    "literal",
                    {}
                ]
            },
            "mbx-indoor-level-overlapped": {
                default: [
                    "literal",
                    {}
                ]
            }
        };
        function _o(e) {
            return e = e || {}, Object.assign(e, uo);
        }
        class po extends e.E {
            destroy() {
                this._map.indoor.off("load", this._onLoad), this._map.indoor.off("move", this._onMove), this._map = void 0;
            }
            _onLoad() {
                this._map.style.forEachFragmentStyle((t1)=>{
                    t1.stylesheet.indoor && (this._queryFeatureSetId ? this.fire(new e.y(new Error("Multiple indoor map styles detected, simultaneous usage is not allowed currently."))) : (this._queryFeatureSetId = t1.stylesheet.indoor.floorplanFeaturesetId, this._buildingEntryFeatureSetId = t1.stylesheet.indoor.buildingFeaturesetId, this._scope = t1.scope));
                }), this._queryFeatureSetId && this._buildingEntryFeatureSetId && this._map.addInteraction("mbx-indoor-buildingclick", {
                    type: "click",
                    target: {
                        featuresetId: this._buildingEntryFeatureSetId,
                        importId: this._scope
                    },
                    handler: (e)=>(e.feature && e.feature.properties.floorplan && this.selectFloorplan(e.feature.properties.floorplan), !0)
                }), this._checkFloorplanVisible(!0);
            }
            _onMove() {
                this._checkFloorplanVisible(!1);
            }
            _checkFloorplanVisible(t1) {
                if (!this._queryFeatureSetId) return;
                if (!this._map.isStyleLoaded()) return;
                if (this._map.transform.zoom < 13) return;
                this._indoorData && !function(e, t1) {
                    const [i, o] = e, { center: s, radius: r } = t1, [a, n] = s, l = Math.abs(i - a);
                    return Math.sqrt((l > 180 ? 360 - l : l) ** 2 + (o - n) ** 2) <= r;
                }([
                    this._map.getCenter().lng,
                    this._map.getCenter().lat
                ], this._indoorData.circumCircle) && (this._indoorData = void 0, this._selectedFloorplan = void 0, this._map.setConfigProperty(this._scope, "mbx-indoor-underground", !1), this._map.setConfigProperty(this._scope, "mbx-indoor-active-floorplans", [
                    "literal",
                    []
                ]), this.fire(new e.z("floorplangone")));
                const i = {
                    target: {
                        featuresetId: this._queryFeatureSetId,
                        importId: this._scope
                    }
                }, o = new e.P(this._map.transform.width / 2, this._map.transform.height / 2), s = [
                    new e.P(0, 0),
                    new e.P(this._map.transform.width, this._map.transform.height)
                ], r = this._map.queryRenderedFeatures(t1 ? s : o, i);
                r.length > 0 && (this._selectedFloorplan && r[0].properties.id === this._selectedFloorplan.properties.id || (this._selectedFloorplan = r[0], this._floorplanSelected(!1)));
            }
            _floorplanSelected(t1) {
                this._indoorData = JSON.parse(this._selectedFloorplan.properties["indoor-data"]), this._indoorData.id = this._selectedFloorplan.properties.id, this._indoorData.circumCircle = function(e) {
                    const [[t1, i], [o, s]] = e, r = (o - t1 + 360) % 360, a = r > 180 ? 360 - r : r;
                    return {
                        center: [
                            (t1 + a / 2 + 360) % 360,
                            (i + s) / 2
                        ],
                        radius: Math.sqrt(a ** 2 + (s - i) ** 2) / 2
                    };
                }(this._indoorData.extent), this._floorplanStates[this._indoorData.id] || (this._floorplanStates[this._indoorData.id] = {});
                const i = this._floorplanStates[this._indoorData.id].selectedBuilding, o = this._floorplanStates[this._indoorData.id].selectedLevel;
                let s;
                if (this._map.setConfigProperty(this._scope, "mbx-indoor-active-floorplans", this._indoorData.floorplanIDs), this._selectedLevel) for (const e of this._indoorData.levels)e.id === this._selectedLevel.id && (s = e.id);
                if (this.fire(new e.z("floorplanselected", {
                    buildings: this._indoorData.buildings,
                    levels: this._indoorData.levels,
                    selectedLevelId: s
                })), i) {
                    const e = this._indoorData.buildings.find((e)=>e.id === i);
                    this._buildingSelected(e, !1);
                } else this._indoorData.buildings.length > 0 && this._buildingSelected(this._indoorData.buildings[0], !1);
                if (o) {
                    const e = this._indoorData.levels.find((e)=>e.id === o);
                    this._updateLevels(e, t1);
                } else t1 && this._indoorData["default-levels"].length > 0 && this.selectLevel(this._indoorData["default-levels"][0]);
            }
            _buildingSelected(t1, i) {
                i && t1 && t1.extent && this._map.fitBounds(t1.extent, {
                    pitch: this._map.getPitch(),
                    bearing: this._map.getBearing()
                }), this._floorplanStates[this._indoorData.id].selectedBuilding = t1 ? t1.id : void 0;
                const o = this._indoorData.levels.filter((e)=>t1.levels.includes(e.id));
                this.fire(new e.z("buildingselected", {
                    buildingId: t1.id,
                    levels: o
                }));
            }
            _levelSelected(t1) {
                if ("overview" === t1) this._updateLevels(void 0, !0);
                else {
                    const e = this._indoorData.levels.find((e)=>e.id === t1);
                    this._updateLevels(e, !0);
                }
                this.fire(new e.z("levelselected", {
                    levelId: "overview" === t1 ? void 0 : t1
                }));
            }
            _updateLevels(e, t1) {
                if (!e) return this._map.setConfigProperty(this._scope, "mbx-indoor-loaded-levels", [
                    "literal",
                    []
                ]), this._map.setConfigProperty(this._scope, "mbx-indoor-underground", !1), this._floorplanStates[this._indoorData.id].selectedLevel = void 0, void (t1 && this._indoorData.extent && this._map.fitBounds(this._indoorData.extent, {
                    pitch: this._map.getPitch(),
                    bearing: this._map.getBearing()
                }));
                function i(e) {
                    const t1 = e.indexOf("/floor/");
                    if (-1 === t1) return e;
                    const i = t1 + 7, o = e.indexOf("/", i);
                    return -1 === o ? e.slice(i) : e.slice(i, o);
                }
                this._selectedLevel = e, this._floorplanStates[this._indoorData.id].selectedLevel = e ? e.id : void 0;
                const o = [], s = {}, r = {}, a = {}, n = {};
                for (const t1 of this._indoorData.levels)if (o.push(t1.id), s[t1.id] = t1.height, r[t1.id] = t1.base, e) {
                    if (this.mergeFloors) {
                        const o = i(e.id), s = i(t1.id);
                        a[t1.id] = s === o ? "true" : "false";
                    } else a[t1.id] = t1.id === e.id ? "true" : "false";
                    n[t1.id] = t1.base < e.base ? "true" : "false";
                } else n[t1.id] = !0;
                if (this._map.setConfigProperty(this._scope, "mbx-indoor-loaded-levels", [
                    "literal",
                    o
                ]), this._map.setConfigProperty(this._scope, "mbx-indoor-level-height", [
                    "literal",
                    s
                ]), this._map.setConfigProperty(this._scope, "mbx-indoor-level-base", [
                    "literal",
                    r
                ]), this._map.setConfigProperty(this._scope, "mbx-indoor-level-selected", [
                    "literal",
                    a
                ]), this._map.setConfigProperty(this._scope, "mbx-indoor-level-overlapped", [
                    "literal",
                    n
                ]), e && (this._map.setConfigProperty(this._scope, "mbx-indoor-underground", !!e.isUnderground), t1 && e.extent)) {
                    const t1 = this._map.cameraForBounds(e.extent, {
                        pitch: this._map.getPitch(),
                        bearing: this._map.getBearing()
                    }), i = this._map.getZoom(), o = t1.zoom ? Math.abs(i - t1.zoom) : 0;
                    this._map.fitBounds(e.extent, o >= 1 ? {
                        pitch: this._map.getPitch(),
                        bearing: this._map.getBearing()
                    } : {
                        pitch: this._map.getPitch(),
                        bearing: this._map.getBearing(),
                        zoom: i
                    });
                }
            }
            selectFloorplan(t1) {
                const i = {
                    target: {
                        featuresetId: this._queryFeatureSetId,
                        importId: this._scope
                    }
                }, o = [
                    new e.P(0, 0),
                    new e.P(this._map.transform.width, this._map.transform.height)
                ], s = this._map.queryRenderedFeatures(o, i);
                if (s.length > 0) {
                    for (const e of s)if (JSON.parse(e.properties["indoor-data"]).floorplanIDs.includes(t1)) {
                        this._selectedFloorplan = e, this._floorplanSelected(!0);
                        break;
                    }
                }
            }
            selectBuilding(e) {
                const t1 = this._indoorData.buildings.find((t1)=>t1.id === e);
                this._buildingSelected(t1, !0);
            }
            selectLevel(e) {
                this._levelSelected(e);
            }
            constructor(t1){
                super(), this.mergeFloors = !0, this._scope = void 0, this._queryFeatureSetId = void 0, this._buildingEntryFeatureSetId = void 0, this._selectedFloorplan = void 0, this._indoorData = void 0, this._selectedLevel = void 0, this._floorplanStates = {}, e.aP([
                    "_onLoad",
                    "_onMove",
                    "_checkFloorplanVisible"
                ], this), this._map = t1, this._checkFloorplanVisible(!0), this._map.on("load", this._onLoad), this._map.on("move", this._onMove);
            }
        }
        function fo(t1) {
            if (!t1.metadata || !t1.metadata.content_area) return;
            const i = e.q.devicePixelRatio, { left: o, top: s, width: r, height: a } = t1.metadata.content_area, n = o * i, l = s * i;
            return [
                n,
                l,
                n + r * i,
                l + a * i
            ];
        }
        function mo(t1) {
            if (t1) return t1.map(([t1, i])=>[
                    t1 * e.q.devicePixelRatio,
                    i * e.q.devicePixelRatio
                ]);
        }
        const go = (e, t1)=>Le(e, t1 && t1.filter((e)=>"source.canvas" !== e.identifier)), vo = e.ay(zt, [
            "addLayer",
            "removeLayer",
            "setLights",
            "setPaintProperty",
            "setLayoutProperty",
            "setSlot",
            "setFilter",
            "addSource",
            "removeSource",
            "setLayerZoomRange",
            "setLight",
            "setTransition",
            "setGeoJSONSourceData",
            "setTerrain",
            "setFog",
            "setSnow",
            "setRain",
            "setProjection",
            "setCamera",
            "addImport",
            "removeImport",
            "updateImport"
        ]), yo = e.ay(zt, [
            "setCenter",
            "setZoom",
            "setBearing",
            "setPitch"
        ]), xo = new Set([
            "background",
            "sky",
            "slot",
            "custom"
        ]), bo = {
            version: 8,
            layers: [],
            sources: {}
        }, wo = {
            duration: 300,
            delay: 0
        };
        class To extends e.E {
            load(e) {
                return e ? ("string" == typeof e ? this.loadURL(e) : this.loadJSON(e), this) : this;
            }
            _getGlobalId(t1) {
                if (!t1) return null;
                if ("string" == typeof t1) {
                    if (e.f(t1)) return t1;
                    const i = e.cn(t1);
                    if (!i.startsWith("http")) try {
                        return new URL(i, location.href).toString();
                    } catch (e) {
                        return i;
                    }
                    return i;
                }
                return `json://${e.co(JSON.stringify(t1))}`;
            }
            _diffStyle(t1, i, o) {
                this.globalId = this._getGlobalId(t1);
                const s = (e, t1)=>{
                    try {
                        t1(null, this.setState(e, o));
                    } catch (e) {
                        t1(e, !1);
                    }
                };
                if ("string" == typeof t1) {
                    const o = this.map._requestManager.normalizeStyleURL(t1), r = this.map._requestManager.transformRequest(o, e.R.Style);
                    e.n(r, (t1, o)=>{
                        t1 ? this.fire(new e.y(t1)) : o && s(o, i);
                    });
                } else "object" == typeof t1 && s(t1, i);
            }
            loadURL(t1, i = {}) {
                this.fire(new e.z("dataloading", {
                    dataType: "style"
                }));
                const o = "boolean" == typeof i.validate ? i.validate : !e.f(t1);
                this.globalId = this._getGlobalId(t1), t1 = this.map._requestManager.normalizeStyleURL(t1, i.accessToken), this.resolvedImports.add(t1);
                const s = this.importsCache.get(t1);
                if (s) return this._load(s, o);
                const r = this.map._requestManager.transformRequest(t1, e.R.Style);
                this._request = e.n(r, (i, s)=>{
                    if (this._request = null, i) this.fire(new e.y(i));
                    else if (s) return this.importsCache.set(t1, s), this._load(s, o);
                });
            }
            loadJSON(t1, i = {}) {
                this.fire(new e.z("dataloading", {
                    dataType: "style"
                })), this.globalId = this._getGlobalId(t1), this._request = e.q.frame(()=>{
                    this._request = null, this._load(t1, !1 !== i.validate);
                });
            }
            loadEmpty() {
                this.fire(new e.z("dataloading", {
                    dataType: "style"
                })), this._load(bo, !1);
            }
            _loadImports(t1, i, o) {
                if (this.importDepth >= 4) return e.w("Style doesn't support nesting deeper than 5"), Promise.resolve();
                const s = [];
                for (const e of t1){
                    const t1 = this._createFragmentStyle(e), r = new Promise((e)=>{
                        t1.once("style.import.load", e), t1.once("error", e);
                    }).then(()=>this.mergeAll());
                    if (s.push(r), this.resolvedImports.has(e.url)) {
                        t1.loadEmpty();
                        continue;
                    }
                    const a = e.data || this.importsCache.get(e.url);
                    a ? (t1.loadJSON(a, {
                        validate: i
                    }), this._isInternalStyle(a) && (t1.globalId = null)) : e.url ? t1.loadURL(e.url, {
                        validate: i
                    }) : t1.loadEmpty();
                    const n = {
                        style: t1,
                        id: e.id,
                        config: e.config
                    };
                    if (o) {
                        const e = this.fragments.findIndex(({ id: e })=>e === o);
                        this.fragments = this.fragments.slice(0, e).concat(n).concat(this.fragments.slice(e));
                    } else this.fragments.push(n);
                }
                return Promise.allSettled(s);
            }
            getImportGlobalIds(e = this, t1 = new Set) {
                for (const i of e.fragments)i.style.globalId && t1.add(i.style.globalId), this.getImportGlobalIds(i.style, t1);
                return [
                    ...t1.values()
                ];
            }
            _createFragmentStyle(t1) {
                const i = this.scope ? e.aC(t1.id, this.scope) : t1.id;
                let o;
                const s = this._initialConfig && this._initialConfig[i];
                (t1.config || s) && (o = e.l({}, t1.config, s));
                const r = new To(this.map, {
                    scope: i,
                    styleChanges: this._changes,
                    importDepth: this.importDepth + 1,
                    importsCache: this.importsCache,
                    resolvedImports: new Set(this.resolvedImports),
                    dispatcher: this.dispatcher,
                    imageManager: this.imageManager,
                    glyphManager: this.glyphManager,
                    modelManager: this.modelManager,
                    config: o,
                    configOptions: this.options,
                    colorThemeOverride: t1["color-theme"],
                    configDependentLayers: this._configDependentLayers
                });
                return r.setEventedParent(this.map, {
                    style: r
                }), r;
            }
            _reloadImports() {
                this.mergeAll(), this._updateMapProjection(), this.updateConfigDependencies(), this.map._triggerCameraUpdate(this.camera), this.dispatcher.broadcast("setLayers", {
                    layers: this._serializeLayers(this._order),
                    scope: this.scope,
                    options: this.options
                }), this._shouldPrecompile = this.map._precompilePrograms && this.isRootStyle();
            }
            _isInternalStyle(e) {
                return this.isRootStyle() && (e.fragment || !!e.schema && !1 !== e.fragment);
            }
            _load(t1, i) {
                const o = t1.indoor ? _o(t1.schema) : t1.schema;
                if (this._isInternalStyle(t1)) {
                    const o = e.l({}, bo, {
                        imports: [
                            {
                                id: "basemap",
                                data: t1,
                                url: ""
                            }
                        ]
                    });
                    return void this._load(o, i);
                }
                if (this.updateConfig(this._config, o), i && go(this, me(t1))) return;
                this._loaded = !0, this.stylesheet = e.cp(t1);
                const s = ()=>{
                    for(const e in t1.sources)this.addSource(e, t1.sources[e], {
                        validate: !1,
                        isInitialLoad: !0
                    });
                    t1.sprite ? this._loadIconset(t1.sprite) : (this.imageManager.setLoaded(!0, this.scope), this.dispatcher.broadcast("spriteLoaded", {
                        scope: this.scope,
                        isLoaded: !0
                    })), this.glyphManager.setURL(t1.glyphs, this.scope);
                    const o = At(this.stylesheet.layers);
                    if (this._order = o.map((e)=>e.id), this.stylesheet.light && e.w("The `light` root property is deprecated, prefer using `lights` with `flat` light type instead."), this.stylesheet.lights) {
                        if (1 === this.stylesheet.lights.length && "flat" === this.stylesheet.lights[0].type) {
                            const e = this.stylesheet.lights[0];
                            this.light = new ze(e.properties, e.id);
                        } else this.setLights(this.stylesheet.lights);
                    }
                    this.light || (this.light = new ze(this.stylesheet.light)), this._layers = {};
                    for (const t1 of o){
                        const i = e.cu(t1, this.scope, this._styleColorTheme.lut, this.options);
                        0 !== i.configDependencies.size && this._configDependentLayers.add(i.fqid), i.setEventedParent(this, {
                            layer: {
                                id: i.id
                            }
                        }), this._layers[i.id] = i;
                        const o = this.getOwnLayerSourceCache(i), s = !!this.directionalLight && this.directionalLight.shadowsEnabled();
                        o && i.canCastShadows() && s && (o.castsShadows = !0);
                    }
                    this.stylesheet.featuresets && this.setFeaturesetSelectors(this.stylesheet.featuresets), this.stylesheet.models && this.modelManager.addModels(this.stylesheet.models, this.scope);
                    const s = this.stylesheet.terrain;
                    s && (this.checkCanvasFingerprintNoise(), this.disableElevatedTerrain || this.terrainSetForDrapingOnly() || this._createTerrain(s, 1)), this.stylesheet.fog && this._createFog(this.stylesheet.fog), this.stylesheet.snow && this._createSnow(this.stylesheet.snow), this.stylesheet.rain && this._createRain(this.stylesheet.rain), this.stylesheet.transition && this.setTransition(this.stylesheet.transition), this.fire(new e.z("data", {
                        dataType: "style"
                    }));
                    const r = this.isRootStyle();
                    t1.imports ? this._loadImports(t1.imports, i).then(()=>{
                        this._reloadImports(), this.fire(new e.z(r ? "style.load" : "style.import.load"));
                    }) : (this._reloadImports(), this.fire(new e.z(r ? "style.load" : "style.import.load")));
                };
                this._styleColorTheme.colorTheme = this.stylesheet["color-theme"];
                const r = this._styleColorTheme.colorThemeOverride ? this._styleColorTheme.colorThemeOverride : this._styleColorTheme.colorTheme;
                if (r) {
                    const t1 = this._evaluateColorThemeData(r);
                    this._loadColorTheme(t1).then(()=>{
                        s();
                    }).catch((t1)=>{
                        e.w(`Couldn't load color theme from the stylesheet: ${t1}`), s();
                    });
                } else this._styleColorTheme.lut = null, s();
            }
            isRootStyle() {
                return 0 === this.importDepth;
            }
            mergeAll() {
                let t1, i, o, s, r, a, n, l, c, h;
                const u = {};
                this.terrain && this.terrain.scope !== this.scope && delete this.terrain, this.forEachFragmentStyle((e)=>{
                    if (e.stylesheet) {
                        if (null != e.light && (t1 = e.light), e.stylesheet.lights) for (const t1 of e.stylesheet.lights)"ambient" === t1.type && null != e.ambientLight && (i = e.ambientLight), "directional" === t1.type && null != e.directionalLight && (o = e.directionalLight);
                        s = this._prioritizeTerrain(s, e.terrain, e.stylesheet.terrain), e.stylesheet.fog && null != e.fog && (r = e.fog), e.stylesheet.snow && null != e.snow && (a = e.snow), e.stylesheet.rain && null != e.rain && (n = e.rain), null != e.stylesheet.camera && (h = e.stylesheet.camera), null != e.stylesheet.projection && (l = e.stylesheet.projection), null != e.stylesheet.transition && (c = e.stylesheet.transition), u[e.scope] = e._styleColorTheme;
                    }
                }), this.light = t1, this.ambientLight = i, this.directionalLight = o, this.fog = r, this.snow = a, this.rain = n, this._styleColorThemeForScope = u, null === s ? delete this.terrain : this.terrain = s, this.camera = h || {
                    "camera-projection": "perspective"
                }, this.projection = l || {
                    name: "mercator"
                }, this.transition = e.l({}, wo, c), this.mergeSources(), this.mergeLayers();
            }
            forEachFragmentStyle(e) {
                const t1 = (i)=>{
                    for (const e of i.fragments)t1(e.style);
                    e(i);
                };
                t1(this);
            }
            _prioritizeTerrain(e, t1, i) {
                const o = e && 0 === e.drapeRenderMode;
                return null === i ? t1 && 0 === t1.drapeRenderMode ? t1 : o ? e : null : null != t1 && (!e || o || t1 && 1 === t1.drapeRenderMode) ? t1 : e;
            }
            mergeTerrain() {
                let e;
                this.terrain && this.terrain.scope !== this.scope && delete this.terrain, this.forEachFragmentStyle((t1)=>{
                    e = this._prioritizeTerrain(e, t1.terrain, t1.stylesheet.terrain);
                }), null === e ? delete this.terrain : this.terrain = e;
            }
            mergeProjection() {
                let e;
                this.forEachFragmentStyle((t1)=>{
                    null != t1.stylesheet.projection && (e = t1.stylesheet.projection);
                }), this.projection = e || {
                    name: "mercator"
                };
            }
            mergeSources() {
                const t1 = {}, i = {}, o = {};
                this.forEachFragmentStyle((s)=>{
                    for(const i in s._sourceCaches){
                        const o = e.aC(i, s.scope);
                        t1[o] = s._sourceCaches[i];
                    }
                    for(const t1 in s._otherSourceCaches){
                        const o = e.aC(t1, s.scope);
                        i[o] = s._otherSourceCaches[t1];
                    }
                    for(const t1 in s._symbolSourceCaches){
                        const i = e.aC(t1, s.scope);
                        o[i] = s._symbolSourceCaches[t1];
                    }
                }), this._mergedSourceCaches = t1, this._mergedOtherSourceCaches = i, this._mergedSymbolSourceCaches = o;
            }
            mergeLayers() {
                const t1 = {}, i = [], o = {};
                this._mergedSlots = [], this._has3DLayers = !1, this._hasCircleLayers = !1, this._hasSymbolLayers = !1, this.forEachFragmentStyle((o)=>{
                    for (const s of o._order){
                        const r = o._layers[s];
                        if ("slot" === r.type) {
                            const i = e.cq(s);
                            if (t1[i]) continue;
                            t1[i] = [];
                        }
                        r.slot && t1[r.slot] ? t1[r.slot].push(r) : i.push(r);
                    }
                }), this._mergedOrder = [];
                const s = (i = [])=>{
                    for (const r of i)if ("slot" === r.type) {
                        const i = e.cq(r.id);
                        t1[i] && s(t1[i]), this._mergedSlots.push(i);
                    } else {
                        const t1 = e.aC(r.id, r.scope);
                        this._mergedOrder.push(t1), o[t1] = r, r.is3D() && (this._has3DLayers = !0), "circle" === r.type && (this._hasCircleLayers = !0), "symbol" === r.type && (this._hasSymbolLayers = !0), "clip" === r.type && (this._clipLayerPresent = !0);
                    }
                };
                s(i), this._mergedOrder.sort((e, t1)=>{
                    const i = o[e], s = o[t1];
                    return i.hasInitialOcclusionOpacityProperties ? s.is3D() ? 1 : 0 : i.is3D() && s.hasInitialOcclusionOpacityProperties ? -1 : 0;
                }), this._mergedLayers = o, this.updateDrapeFirstLayers(), this._buildingIndex.processLayersChanged();
            }
            terrainSetForDrapingOnly() {
                return !!this.terrain && 0 === this.terrain.drapeRenderMode;
            }
            getCamera() {
                return this.stylesheet.camera;
            }
            setCamera(t1) {
                return this.stylesheet.camera = e.l({}, this.stylesheet.camera, t1), this.camera = this.stylesheet.camera, this;
            }
            _evaluateColorThemeData(t1) {
                return t1.data ? (function(t1, i, o) {
                    const s = e.l({}, i);
                    for (const t1 of Object.keys(e.a3.colorTheme))void 0 === s[t1] && (s[t1] = e.a3.colorTheme[t1].default);
                    const r = new e.a4(ho, t1, new Map(o));
                    return r.setTransitionOrValue(s, o), r.untransitioned().possiblyEvaluate(new e.a8(0));
                })(this.scope, t1, this.options).get("data") : null;
            }
            _loadColorTheme(t1) {
                this._styleColorTheme.lutLoading = !0, this._styleColorTheme.lutLoadingCorrelationID += 1;
                const i = this._styleColorTheme.lutLoadingCorrelationID;
                return new Promise((o, s)=>{
                    const r = "data:image/png;base64,";
                    if (!t1 || 0 === t1.length) return this._styleColorTheme.lut = null, this._styleColorTheme.lutLoading = !1, void o();
                    let a = t1;
                    a.startsWith(r) || (a = r + a);
                    const n = "mapbox-reserved-lut", l = new Image;
                    l.src = a, l.onerror = ()=>{
                        this._styleColorTheme.lutLoading = !1, s(new Error("Failed to load image data"));
                    }, l.onload = ()=>{
                        if (this._styleColorTheme.lutLoadingCorrelationID !== i) return void o();
                        this._styleColorTheme.lutLoading = !1;
                        const { width: r, height: a, data: c } = e.q.getImageData(l);
                        if (a > 32) return void s(new Error("The height of the image must be less than or equal to 32 pixels."));
                        if (r !== a * a) return void s(new Error("The width of the image must be equal to the height squared."));
                        this.getImage(n) && this.removeImage(n), this.addImage(n, {
                            data: new e.r({
                                width: r,
                                height: a
                            }, c),
                            pixelRatio: 1,
                            sdf: !1,
                            usvg: !1,
                            version: 0
                        });
                        const h = this.imageManager.getImage(n, this.scope);
                        h ? (this._styleColorTheme.lut = {
                            image: h.data,
                            data: t1
                        }, o()) : s(new Error("Missing LUT image."));
                    };
                });
            }
            getLut(e) {
                const t1 = this._styleColorThemeForScope[e];
                return t1 ? t1.lut : null;
            }
            setProjection(e) {
                e ? this.stylesheet.projection = e : delete this.stylesheet.projection, this.mergeProjection(), this._updateMapProjection();
            }
            applyProjectionUpdate() {
                this._loaded && (this.dispatcher.broadcast("setProjection", this.map.transform.projectionOptions), this.map.transform.projection.requiresDraping ? (this.getTerrain() || this.stylesheet.terrain) && !this.disableElevatedTerrain || this.setTerrainForDraping() : this.terrainSetForDrapingOnly() && this.setTerrain(null, 0));
            }
            _updateMapProjection() {
                this.isRootStyle() && (this.map._useExplicitProjection ? this.applyProjectionUpdate() : this.map._prioritizeAndUpdateProjection(null, this.projection));
            }
            _loadSprite(t1) {
                this._spriteRequest = function(t1, i, o) {
                    let s, r, a;
                    const n = e.q.devicePixelRatio > 1 ? "@2x" : "";
                    let l = e.n(i.transformRequest(i.normalizeSpriteURL(t1, n, ".json"), e.R.SpriteJSON), (e, t1)=>{
                        l = null, a || (a = e, s = t1, h());
                    }), c = e.o(i.transformRequest(i.normalizeSpriteURL(t1, n, ".png"), e.R.SpriteImage), (e, t1)=>{
                        c = null, a || (a = e, r = t1, h());
                    });
                    function h() {
                        if (a) o(a);
                        else if (s && r) {
                            const t1 = e.q.getImageData(r), i = {};
                            for(const o in s){
                                const { width: r, height: a, x: n, y: l, sdf: c, pixelRatio: h, stretchX: u, stretchY: d, content: _ } = s[o], p = new e.r({
                                    width: r,
                                    height: a
                                });
                                e.r.copy(t1, p, {
                                    x: n,
                                    y: l
                                }, {
                                    x: 0,
                                    y: 0
                                }, {
                                    width: r,
                                    height: a
                                }, null), i[o] = {
                                    data: p,
                                    pixelRatio: h,
                                    sdf: c,
                                    stretchX: u,
                                    stretchY: d,
                                    content: _,
                                    usvg: !1
                                };
                            }
                            o(null, i);
                        }
                    }
                    return {
                        cancel () {
                            l && (l.cancel(), l = null), c && (c.cancel(), c = null);
                        }
                    };
                }(t1, this.map._requestManager, (t1, i)=>{
                    if (this._spriteRequest = null, t1) this.fire(new e.y(t1));
                    else if (i) for(const e in i)this.imageManager.addImage(e, this.scope, i[e]);
                    this.imageManager.setLoaded(!0, this.scope), this._availableImages = this.imageManager.listImages(this.scope), this.dispatcher.broadcast("setImages", {
                        scope: this.scope,
                        images: this._availableImages
                    }), this.dispatcher.broadcast("spriteLoaded", {
                        scope: this.scope,
                        isLoaded: !0
                    }), this.fire(new e.z("data", {
                        dataType: "style"
                    }));
                });
            }
            _loadIconset(t1) {
                if (!e.f(t1) && "icon_set" !== this.map._spriteFormat || "raster" === this.map._spriteFormat) return void this._loadSprite(t1);
                const i = "auto" === this.map._spriteFormat;
                var o, s;
                this._spriteRequest = (s = (o, s)=>{
                    if (this._spriteRequest = null, o) i ? this._loadSprite(t1) : this.fire(new e.y(o));
                    else if (s) for(const e in s)this.imageManager.addImage(e, this.scope, s[e]);
                    this.imageManager.setLoaded(!0, this.scope), this._availableImages = this.imageManager.listImages(this.scope), this.dispatcher.broadcast("setImages", {
                        scope: this.scope,
                        images: this._availableImages
                    }), this.dispatcher.broadcast("spriteLoaded", {
                        scope: this.scope,
                        isLoaded: !0
                    }), this.fire(new e.z("data", {
                        dataType: "style"
                    }));
                }, e.bi((o = this.map._requestManager).transformRequest(o.normalizeIconsetURL(t1), e.R.Iconset), (t1, i)=>{
                    if (t1) return void s(t1);
                    const o = {}, r = e.cg(new e.bh(i));
                    for (const t1 of r.icons){
                        const i = {
                            version: 1,
                            pixelRatio: e.q.devicePixelRatio,
                            content: fo(t1),
                            stretchX: t1.metadata ? mo(t1.metadata.stretch_x_areas) : void 0,
                            stretchY: t1.metadata ? mo(t1.metadata.stretch_y_areas) : void 0,
                            sdf: !1,
                            usvg: !0,
                            icon: t1
                        };
                        o[t1.name] = i;
                    }
                    s(null, o);
                }));
            }
            _validateLayer(t1) {
                const i = this.getOwnSource(t1.source);
                if (!i) return;
                const o = t1.sourceLayer;
                o && ("geojson" === i.type || i.vectorLayerIds && -1 === i.vectorLayerIds.indexOf(o)) && this.fire(new e.y(new Error(`Source layer "${o}" does not exist on source "${i.id}" as specified by style layer "${t1.id}"`)));
            }
            loaded() {
                if (!this._loaded) return !1;
                if (Object.keys(this._changes.getUpdatedSourceCaches()).length) return !1;
                for(const e in this._sourceCaches)if (!this._sourceCaches[e].loaded()) return !1;
                if (!this.imageManager.isLoaded()) return !1;
                if (!this.modelManager.isLoaded()) return !1;
                if (this._styleColorTheme.lutLoading) return !1;
                for (const { style: e } of this.fragments)if (!e.loaded()) return !1;
                return !0;
            }
            _serializeImports() {
                if (this.stylesheet.imports) return this.stylesheet.imports.map((e, t1)=>{
                    const i = this.fragments[t1];
                    return i && i.style && (e.data = i.style.serialize()), e;
                });
            }
            _serializeSources() {
                const e = {};
                for(const t1 in this._sourceCaches){
                    const i = this._sourceCaches[t1].getSource();
                    e[i.id] || (e[i.id] = i.serialize());
                }
                return e;
            }
            _serializeLayers(e) {
                const t1 = [];
                for (const i of e){
                    const e = this._layers[i];
                    e && "custom" !== e.type && t1.push(e.serialize());
                }
                return t1;
            }
            hasLightTransitions() {
                return !(!this.light || !this.light.hasTransition()) || !(!this.ambientLight || !this.ambientLight.hasTransition()) || !(!this.directionalLight || !this.directionalLight.hasTransition());
            }
            hasFogTransition() {
                return !!this.fog && this.fog.hasTransition();
            }
            hasSnowTransition() {
                return !!this.snow && this.snow.hasTransition();
            }
            hasRainTransition() {
                return !!this.rain && this.rain.hasTransition();
            }
            hasTransitions() {
                if (this.hasLightTransitions()) return !0;
                if (this.hasFogTransition()) return !0;
                if (this.hasSnowTransition()) return !0;
                if (this.hasRainTransition()) return !0;
                for(const e in this._sourceCaches)if (this._sourceCaches[e].hasTransition()) return !0;
                for(const e in this._layers)if (this._layers[e].hasTransition()) return !0;
                return !1;
            }
            get order() {
                return this.terrain ? this._drapedFirstOrder : this._mergedOrder;
            }
            _getOrder(e) {
                return e ? this.order : this._mergedOrder;
            }
            isLayerDraped(e) {
                return !!this.terrain && e.isDraped(this.getLayerSourceCache(e));
            }
            _checkLoaded() {
                if (!this._loaded) throw new Error("Style is not done loading");
            }
            _checkLayer(t1) {
                const i = this.getOwnLayer(t1);
                if (i) return i;
                this.fire(new e.y(new Error(`The layer '${t1}' does not exist in the map's style.`)));
            }
            _checkSource(t1) {
                const i = this.getOwnSource(t1);
                if (i) return i;
                this.fire(new e.y(new Error(`The source '${t1}' does not exist in the map's style.`)));
            }
            precompilePrograms(e, t1) {
                const i = this.map.painter;
                if (i) for(let o = e.minzoom || 0; o < (e.maxzoom || 25.5); o++){
                    const o = e.getProgramIds();
                    if (o) for (const s of o){
                        const o = e.getDefaultProgramParams(s, t1.zoom, this._styleColorTheme.lut);
                        o && (i.style = this, this.fog && (i._fogVisible = !0, o.overrideFog = !0, i.getOrCreateProgram(s, o)), i._fogVisible = !1, o.overrideFog = !1, i.getOrCreateProgram(s, o), (this.stylesheet.terrain || this.stylesheet.projection && "globe" === this.stylesheet.projection.name) && (o.overrideRtt = !0, i.getOrCreateProgram(s, o)));
                    }
                }
            }
            update(t1) {
                if (!this._loaded) return;
                this.ambientLight && this.ambientLight.recalculate(t1), this.directionalLight && this.directionalLight.recalculate(t1);
                const i = this.calculateLightsBrightness();
                t1.brightness = i || 0, i !== this._brightness && (this._brightness = i, this.dispatcher.broadcast("setBrightness", i));
                const o = this._changes.isDirty();
                let s = !1;
                if (this._changes.isDirty()) {
                    const e = this._changes.getLayerUpdatesByScope();
                    for(const t1 in e){
                        const { updatedIds: i, removedIds: o } = e[t1];
                        (i || o) && (this._updateWorkerLayers(t1, i, o), s = !0);
                    }
                    this.updateSourceCaches(), this._updateTilesForChangedImages(), this.updateLayers(t1), this.light && this.light.updateTransitions(t1), this.ambientLight && this.ambientLight.updateTransitions(t1), this.directionalLight && this.directionalLight.updateTransitions(t1), this.fog && this.fog.updateTransitions(t1), this.snow && this.snow.updateTransitions(t1), this.rain && this.rain.updateTransitions(t1), this._changes.reset();
                }
                const r = {};
                for(const e in this._mergedSourceCaches){
                    const t1 = this._mergedSourceCaches[e];
                    r[e] = t1.used, t1.used = !1, t1.tileCoverLift = 0;
                }
                for (const e of this._mergedOrder){
                    const i = this._mergedLayers[e];
                    if (i.recalculate(t1, this._availableImages), !i.isHidden(t1.zoom)) {
                        const e = this.getLayerSourceCache(i);
                        e && (e.used = !0, e.tileCoverLift = Math.max(e.tileCoverLift, i.tileCoverLift()));
                    }
                    !this._precompileDone && this._shouldPrecompile && ("requestIdleCallback" in window ? requestIdleCallback(()=>{
                        this.precompilePrograms(i, t1);
                    }) : this.precompilePrograms(i, t1));
                }
                this._shouldPrecompile && (this._precompileDone = !0), this.terrain && s && this.mergeLayers();
                for(const t1 in r){
                    const i = this._mergedSourceCaches[t1];
                    r[t1] !== i.used && i.getSource().fire(new e.z("data", {
                        sourceDataType: "visibility",
                        dataType: "source",
                        sourceId: i.getSource().id
                    }));
                }
                this.light && this.light.recalculate(t1), this.terrain && this.terrain.recalculate(t1), this.fog && this.fog.recalculate(t1), this.snow && this.snow.recalculate(t1), this.rain && this.rain.recalculate(t1), this.z = t1.zoom, this._markersNeedUpdate && (this._updateMarkersOpacity(), this._markersNeedUpdate = !1), o && this.fire(new e.z("data", {
                    dataType: "style"
                }));
            }
            _updateTilesForChangedImages() {
                const e = this._changes.getUpdatedImages();
                if (e.length) {
                    for(const t1 in this._sourceCaches)this._sourceCaches[t1].reloadTilesForDependencies([
                        "icons",
                        "patterns"
                    ], e);
                    this._changes.resetUpdatedImages();
                }
            }
            _updateWorkerLayers(e, t1, i) {
                const o = this.getFragmentStyle(e);
                o && this.dispatcher.broadcast("updateLayers", {
                    layers: t1 ? o._serializeLayers(t1) : [],
                    scope: e,
                    removedIds: i || [],
                    options: o.options
                });
            }
            setState(t1, i) {
                if (this._checkLoaded(), go(this, me(t1))) return !1;
                (t1 = e.cp(t1)).layers = At(t1.layers);
                const o = (function(t1, i) {
                    if (!t1) return [
                        {
                            command: zt.setStyle,
                            args: [
                                i
                            ]
                        }
                    ];
                    let o = [];
                    try {
                        if (!e.bn(t1.version, i.version)) return [
                            {
                                command: zt.setStyle,
                                args: [
                                    i
                                ]
                            }
                        ];
                        if (e.bn(t1.center, i.center) || o.push({
                            command: zt.setCenter,
                            args: [
                                i.center
                            ]
                        }), e.bn(t1.zoom, i.zoom) || o.push({
                            command: zt.setZoom,
                            args: [
                                i.zoom
                            ]
                        }), e.bn(t1.bearing, i.bearing) || o.push({
                            command: zt.setBearing,
                            args: [
                                i.bearing
                            ]
                        }), e.bn(t1.pitch, i.pitch) || o.push({
                            command: zt.setPitch,
                            args: [
                                i.pitch
                            ]
                        }), e.bn(t1.sprite, i.sprite) || o.push({
                            command: zt.setSprite,
                            args: [
                                i.sprite
                            ]
                        }), e.bn(t1.glyphs, i.glyphs) || o.push({
                            command: zt.setGlyphs,
                            args: [
                                i.glyphs
                            ]
                        }), e.bn(t1.imports, i.imports) || function(t1 = [], i = [], o) {
                            i = i || [];
                            const s = (t1 = t1 || []).map(Bt), r = i.map(Bt), a = t1.reduce(Nt, {}), n = i.reduce(Nt, {}), l = s.slice();
                            let c, h, u, d;
                            for(c = 0, h = 0; c < s.length; c++)u = s[c], n.hasOwnProperty(u) ? h++ : (o.push({
                                command: zt.removeImport,
                                args: [
                                    u
                                ]
                            }), l.splice(l.indexOf(u, h), 1));
                            for(c = 0, h = 0; c < r.length; c++)u = r[r.length - 1 - c], l[l.length - 1 - c] !== u && (a.hasOwnProperty(u) ? (o.push({
                                command: zt.removeImport,
                                args: [
                                    u
                                ]
                            }), l.splice(l.lastIndexOf(u, l.length - h), 1)) : h++, d = l[l.length - c], o.push({
                                command: zt.addImport,
                                args: [
                                    n[u],
                                    d
                                ]
                            }), l.splice(l.length - c, 0, u));
                            for (const t1 of i){
                                const i = a[t1.id];
                                i && !e.bn(i, t1) && o.push({
                                    command: zt.updateImport,
                                    args: [
                                        t1.id,
                                        t1
                                    ]
                                });
                            }
                        }(t1.imports, i.imports, o), e.bn(t1.transition, i.transition) || o.push({
                            command: zt.setTransition,
                            args: [
                                i.transition
                            ]
                        }), e.bn(t1.light, i.light) || o.push({
                            command: zt.setLight,
                            args: [
                                i.light
                            ]
                        }), e.bn(t1.fog, i.fog) || o.push({
                            command: zt.setFog,
                            args: [
                                i.fog
                            ]
                        }), e.bn(t1.snow, i.snow) || o.push({
                            command: zt.setSnow,
                            args: [
                                i.snow
                            ]
                        }), e.bn(t1.rain, i.rain) || o.push({
                            command: zt.setRain,
                            args: [
                                i.rain
                            ]
                        }), e.bn(t1.projection, i.projection) || o.push({
                            command: zt.setProjection,
                            args: [
                                i.projection
                            ]
                        }), e.bn(t1.lights, i.lights) || o.push({
                            command: zt.setLights,
                            args: [
                                i.lights
                            ]
                        }), e.bn(t1.camera, i.camera) || o.push({
                            command: zt.setCamera,
                            args: [
                                i.camera
                            ]
                        }), !e.bn(t1["color-theme"], i["color-theme"])) return [
                            {
                                command: zt.setStyle,
                                args: [
                                    i
                                ]
                            }
                        ];
                        const s = {}, r = [];
                        !function(t1, i, o, s) {
                            let r;
                            for(r in i = i || {}, t1 = t1 || {})t1.hasOwnProperty(r) && (i.hasOwnProperty(r) || Mt(r, o, s));
                            for(r in i){
                                if (!i.hasOwnProperty(r)) continue;
                                const a = i[r];
                                t1.hasOwnProperty(r) ? e.bn(t1[r], a) || ("geojson" === t1[r].type && "geojson" === a.type && Ft(t1, i, r) ? o.push({
                                    command: zt.setGeoJSONSourceData,
                                    args: [
                                        r,
                                        a.data
                                    ]
                                }) : Ot(r, i, o, s)) : Pt(r, i, o);
                            }
                        }(t1.sources, i.sources, r, s);
                        const a = [];
                        t1.layers && t1.layers.forEach((e)=>{
                            e.source && s[e.source] ? o.push({
                                command: zt.removeLayer,
                                args: [
                                    e.id
                                ]
                            }) : a.push(e);
                        });
                        let n = t1.terrain;
                        n && s[n.source] && (o.push({
                            command: zt.setTerrain,
                            args: [
                                void 0
                            ]
                        }), n = void 0), o = o.concat(r), e.bn(n, i.terrain) || o.push({
                            command: zt.setTerrain,
                            args: [
                                i.terrain
                            ]
                        }), function(t1, i, o) {
                            i = i || [];
                            const s = (t1 = t1 || []).map(Bt), r = i.map(Bt), a = t1.reduce(Nt, {}), n = i.reduce(Nt, {}), l = s.slice(), c = Object.create(null);
                            let h, u, d, _, p, f, m;
                            for(h = 0, u = 0; h < s.length; h++)d = s[h], n.hasOwnProperty(d) ? u++ : (o.push({
                                command: zt.removeLayer,
                                args: [
                                    d
                                ]
                            }), l.splice(l.indexOf(d, u), 1));
                            for(h = 0, u = 0; h < r.length; h++)d = r[r.length - 1 - h], l[l.length - 1 - h] !== d && (a.hasOwnProperty(d) ? (o.push({
                                command: zt.removeLayer,
                                args: [
                                    d
                                ]
                            }), l.splice(l.lastIndexOf(d, l.length - u), 1)) : u++, f = l[l.length - h], o.push({
                                command: zt.addLayer,
                                args: [
                                    n[d],
                                    f
                                ]
                            }), l.splice(l.length - h, 0, d), c[d] = !0);
                            for(h = 0; h < r.length; h++)if (d = r[h], _ = a[d], p = n[d], !c[d] && !e.bn(_, p)) {
                                if (e.bn(_.source, p.source) && e.bn(_["source-layer"], p["source-layer"]) && e.bn(_.type, p.type)) {
                                    for(m in kt(_.layout, p.layout, o, d, null, zt.setLayoutProperty), kt(_.paint, p.paint, o, d, null, zt.setPaintProperty), e.bn(_.slot, p.slot) || o.push({
                                        command: zt.setSlot,
                                        args: [
                                            d,
                                            p.slot
                                        ]
                                    }), e.bn(_.filter, p.filter) || o.push({
                                        command: zt.setFilter,
                                        args: [
                                            d,
                                            p.filter
                                        ]
                                    }), e.bn(_.minzoom, p.minzoom) && e.bn(_.maxzoom, p.maxzoom) || o.push({
                                        command: zt.setLayerZoomRange,
                                        args: [
                                            d,
                                            p.minzoom,
                                            p.maxzoom
                                        ]
                                    }), _)_.hasOwnProperty(m) && "layout" !== m && "paint" !== m && "filter" !== m && "metadata" !== m && "minzoom" !== m && "maxzoom" !== m && "slot" !== m && (0 === m.indexOf("paint.") ? kt(_[m], p[m], o, d, m.slice(6), zt.setPaintProperty) : e.bn(_[m], p[m]) || o.push({
                                        command: zt.setLayerProperty,
                                        args: [
                                            d,
                                            m,
                                            p[m]
                                        ]
                                    }));
                                    for(m in p)p.hasOwnProperty(m) && !_.hasOwnProperty(m) && "layout" !== m && "paint" !== m && "filter" !== m && "metadata" !== m && "minzoom" !== m && "maxzoom" !== m && "slot" !== m && (0 === m.indexOf("paint.") ? kt(_[m], p[m], o, d, m.slice(6), zt.setPaintProperty) : e.bn(_[m], p[m]) || o.push({
                                        command: zt.setLayerProperty,
                                        args: [
                                            d,
                                            m,
                                            p[m]
                                        ]
                                    }));
                                } else o.push({
                                    command: zt.removeLayer,
                                    args: [
                                        d
                                    ]
                                }), f = l[l.lastIndexOf(d) + 1], o.push({
                                    command: zt.addLayer,
                                    args: [
                                        p,
                                        f
                                    ]
                                });
                            }
                        }(a, i.layers, o);
                    } catch (e) {
                        console.warn("Unable to compute style diff:", e), o = [
                            {
                                command: zt.setStyle,
                                args: [
                                    i
                                ]
                            }
                        ];
                    }
                    return o;
                })(this.serialize(), t1).filter((e)=>!(e.command in yo));
                if (0 === o.length) return !1;
                const s = o.filter((e)=>!(e.command in vo));
                if (s.length > 0) throw new Error(`Unimplemented: ${s.map((e)=>e.command).join(", ")}.`);
                const r = [];
                return o.forEach((e)=>{
                    r.push(this[e.command].apply(this, e.args));
                }), i && Promise.all(r).then(i), this.stylesheet = t1, this.mergeAll(), this.dispatcher.broadcast("setLayers", {
                    layers: this._serializeLayers(this._order),
                    scope: this.scope,
                    options: this.options
                }), !0;
            }
            addImage(t1, i) {
                return this.getImage(t1) ? this.fire(new e.y(new Error("An image with this name already exists."))) : (this.imageManager.addImage(t1, this.scope, i), this._afterImageUpdated(t1), this);
            }
            updateImage(e, t1, i = !1) {
                this.imageManager.updateImage(e, this.scope, t1), i && this._afterImageUpdated(e);
            }
            getImage(e) {
                return this.imageManager.getImage(e, this.scope);
            }
            removeImage(t1) {
                return this.getImage(t1) ? (this.imageManager.removeImage(t1, this.scope), this._afterImageUpdated(t1), this) : this.fire(new e.y(new Error("No image with this name exists.")));
            }
            _afterImageUpdated(t1) {
                this._availableImages = this.imageManager.listImages(this.scope), this._changes.updateImage(t1), this.dispatcher.broadcast("setImages", {
                    scope: this.scope,
                    images: this._availableImages
                }), this.fire(new e.z("data", {
                    dataType: "style"
                }));
            }
            listImages() {
                return this._checkLoaded(), this._availableImages.slice();
            }
            addModel(e, t1, i = {}) {
                return this._checkLoaded(), this._validate(Re, `models.${e}`, t1, null, i) || (this.modelManager.addModel(e, t1, this.scope), this._changes.setDirty()), this;
            }
            hasModel(e) {
                return this.modelManager.hasModel(e, this.scope);
            }
            removeModel(t1) {
                return this.hasModel(t1) ? (this.modelManager.removeModel(t1, this.scope), this) : this.fire(new e.y(new Error("No model with this ID exists.")));
            }
            listModels() {
                return this._checkLoaded(), this.modelManager.listModels(this.scope);
            }
            addSource(t1, i, o = {}) {
                if (this._checkLoaded(), void 0 !== this.getOwnSource(t1)) throw new Error(`There is already a source with ID "${t1}".`);
                if (!i.type) throw new Error(`The type property must be defined, but only the following properties were given: ${Object.keys(i).join(", ")}.`);
                if ([
                    "vector",
                    "raster",
                    "geojson",
                    "video",
                    "image"
                ].indexOf(i.type) >= 0 && this._validate(ge, `sources.${t1}`, i, null, o)) return;
                this.map && this.map._collectResourceTiming && (i.collectResourceTiming = !0);
                const s = rt(t1, i, this.dispatcher, this);
                s.scope = this.scope, s.setEventedParent(this, ()=>({
                        isSourceLoaded: this._isSourceCacheLoaded(s.id),
                        source: s.serialize(),
                        sourceId: s.id
                    }));
                const r = (t1)=>{
                    const i = (t1 ? "symbol:" : "other:") + s.id, o = e.aC(i, this.scope), r = this._sourceCaches[i] = new St(o, s, t1);
                    (t1 ? this._symbolSourceCaches : this._otherSourceCaches)[s.id] = r, r.onAdd(this.map);
                };
                r(!1), "vector" !== i.type && "geojson" !== i.type || r(!0), s.onAdd && s.onAdd(this.map), o.isInitialLoad || (this.mergeSources(), this._changes.setDirty());
            }
            removeSource(t1) {
                this._checkLoaded();
                const i = this.getOwnSource(t1);
                if (!i) throw new Error("There is no source with this ID");
                for(const i in this._layers)if (this._layers[i].source === t1) return this.fire(new e.y(new Error(`Source "${t1}" cannot be removed while layer "${i}" is using it.`)));
                if (this.terrain && this.terrain.scope === this.scope && this.terrain.get().source === t1) return this.fire(new e.y(new Error(`Source "${t1}" cannot be removed while terrain is using it.`)));
                const o = this.getOwnSourceCaches(t1);
                for (const t1 of o){
                    const i = e.cq(t1.id);
                    delete this._sourceCaches[i], this._changes.discardSourceCacheUpdate(t1.id), t1.fire(new e.z("data", {
                        sourceDataType: "metadata",
                        dataType: "source",
                        sourceId: t1.getSource().id
                    })), t1.setEventedParent(null), t1.clearTiles();
                }
                return delete this._otherSourceCaches[t1], delete this._symbolSourceCaches[t1], this.mergeSources(), i.setEventedParent(null), i.onRemove && i.onRemove(this.map), this._changes.setDirty(), this;
            }
            setGeoJSONSourceData(e, t1) {
                this._checkLoaded(), this.getOwnSource(e).setData(t1), this._changes.setDirty();
            }
            getOwnSource(e) {
                const t1 = this.getOwnSourceCache(e);
                return t1 && t1.getSource();
            }
            getOwnSources() {
                const e = [];
                for(const t1 in this._otherSourceCaches){
                    const i = this.getOwnSourceCache(t1);
                    i && e.push(i.getSource());
                }
                return e;
            }
            areTilesLoaded() {
                const e = this._mergedSourceCaches;
                for(const t1 in e){
                    const i = e[t1]._tiles;
                    for(const e in i){
                        const t1 = i[e];
                        if ("loaded" !== t1.state && "errored" !== t1.state) return !1;
                    }
                }
                return !0;
            }
            setLights(t1) {
                if (this._checkLoaded(), !t1) return delete this.ambientLight, void delete this.directionalLight;
                const i = this._getTransitionParameters();
                for (const o of t1){
                    if (this._validate(ye, "lights", o)) return;
                    switch(o.type){
                        case "ambient":
                            if (this.ambientLight) {
                                const e = this.ambientLight;
                                e.set(o), e.updateTransitions(i);
                            } else this.ambientLight = new $e(o, qe || (qe = new e.a5({
                                color: new e.a6(e.a3.properties_light_ambient.color),
                                "color-use-theme": new e.a6({
                                    type: "string",
                                    default: "default",
                                    "property-type": "data-constant"
                                }),
                                intensity: new e.a6(e.a3.properties_light_ambient.intensity)
                            })), this.scope, this.options);
                            break;
                        case "directional":
                            if (this.directionalLight) {
                                const e = this.directionalLight;
                                e.set(o), e.updateTransitions(i);
                            } else this.directionalLight = new $e(o, He || (He = new e.a5({
                                direction: new e.ak(e.a3.properties_light_directional.direction),
                                color: new e.a6(e.a3.properties_light_directional.color),
                                "color-use-theme": new e.a6({
                                    type: "string",
                                    default: "default",
                                    "property-type": "data-constant"
                                }),
                                intensity: new e.a6(e.a3.properties_light_directional.intensity),
                                "cast-shadows": new e.a6(e.a3.properties_light_directional["cast-shadows"]),
                                "shadow-quality": new e.a6(e.a3.properties_light_directional["shadow-quality"]),
                                "shadow-intensity": new e.a6(e.a3.properties_light_directional["shadow-intensity"])
                            })), this.scope, this.options);
                    }
                }
                const o = new e.a8(this.z || 0, i);
                this.ambientLight && this.ambientLight.recalculate(o), this.directionalLight && this.directionalLight.recalculate(o), this._brightness = this.calculateLightsBrightness(), this.dispatcher.broadcast("setBrightness", this._brightness);
            }
            calculateLightsBrightness() {
                const t1 = this.directionalLight, i = this.ambientLight;
                if (!t1 || !i) return;
                const o = (e)=>.2126 * (e[0] <= .03928 ? e[0] / 12.92 : Math.pow((e[0] + .055) / 1.055, 2.4)) + .7152 * (e[1] <= .03928 ? e[1] / 12.92 : Math.pow((e[1] + .055) / 1.055, 2.4)) + .0722 * (e[2] <= .03928 ? e[2] / 12.92 : Math.pow((e[2] + .055) / 1.055, 2.4)), s = t1.properties.get("color").toRenderColor(null).toArray01(), r = t1.properties.get("intensity"), a = t1.properties.get("direction"), n = 1 - e.cb(a.x, a.y, a.z)[2] / 90, l = o(s) * r * n, c = i.properties.get("color").toRenderColor(null).toArray01(), h = i.properties.get("intensity"), u = o(c) * h;
                return Number(((l + u) / 2).toFixed(6));
            }
            getBrightness() {
                return this._brightness;
            }
            getLights() {
                if (!this.enable3dLights()) return null;
                const e = [];
                return this.directionalLight && e.push(this.directionalLight.get()), this.ambientLight && e.push(this.ambientLight.get()), e;
            }
            enable3dLights() {
                return !!this.ambientLight && !!this.directionalLight;
            }
            getFragmentStyle(t1) {
                if (!t1) return this;
                if (e.cr(t1)) {
                    const i = e.cs(t1), o = this.fragments.find(({ id: e })=>e === i);
                    if (!o) throw new Error(`Style import '${t1}' not found`);
                    const s = e.cq(t1);
                    return o.style.getFragmentStyle(s);
                }
                {
                    const e = this.fragments.find(({ id: e })=>e === t1);
                    return e ? e.style : void 0;
                }
            }
            setFeaturesetSelectors(t1) {
                if (!t1) return;
                const i = {}, o = (e, t1 = "")=>`${e}::${t1}`;
                this._featuresetSelectors = {};
                for(const s in t1){
                    const r = this._featuresetSelectors[s] = [];
                    for (const a of t1[s].selectors){
                        if (a.featureNamespace) {
                            const t1 = this.getOwnLayer(a.layer);
                            if (!t1) {
                                e.w(`Layer is undefined for selector: ${a.layer}`);
                                continue;
                            }
                            const r = o(t1.source, t1.sourceLayer);
                            if (r in i && i[r] !== a.featureNamespace) {
                                e.w(`"featureNamespace ${a.featureNamespace} of featureset ${s}'s selector is not associated to the same source, skip this selector`);
                                continue;
                            }
                            i[r] = a.featureNamespace;
                        }
                        let t1;
                        if (a.properties) for(const i in a.properties){
                            const o = e.U(a.properties[i]);
                            "success" === o.result && (t1 = t1 || {}, t1[i] = o.value);
                        }
                        r.push({
                            layerId: a.layer,
                            namespace: a.featureNamespace,
                            properties: t1,
                            uniqueFeatureID: a._uniqueFeatureID
                        });
                    }
                }
            }
            getFeaturesetDescriptors(e) {
                const t1 = this.getFragmentStyle(e);
                if (!t1 || !t1.stylesheet.featuresets) return [];
                const i = [];
                for(const e in t1.stylesheet.featuresets)i.push({
                    featuresetId: e,
                    importId: t1.scope ? t1.scope : void 0
                });
                return i;
            }
            getFeaturesetLayers(t1, i) {
                const o = this.getFragmentStyle(i), s = o.stylesheet.featuresets;
                if (!s || !s[t1]) return this.fire(new e.y(new Error(`The featureset '${t1}' does not exist in the map's style and cannot be queried.`))), [];
                const r = [];
                for (const e of s[t1].selectors){
                    const t1 = o.getOwnLayer(e.layer);
                    t1 && r.push(t1);
                }
                return r;
            }
            getConfigProperty(t1, i) {
                const o = this.getFragmentStyle(t1);
                if (!o) return null;
                const s = e.aC(i, o.scope), r = o.options.get(s), a = r ? r.value || r.default : null;
                return a ? a.serialize() : null;
            }
            setConfigProperty(t1, i, o) {
                const s = this.getFragmentStyle(t1);
                if (!s) return;
                const r = s.stylesheet.indoor ? _o(s.stylesheet.schema) : s.stylesheet.schema;
                if (!r || !r[i]) return;
                const a = e.U(o);
                if ("success" !== a.result) return void go(this, a.value);
                const n = a.value.expression, l = e.aC(i, s.scope), c = s.options.get(l);
                if (!c) return;
                let h;
                const { minValue: u, maxValue: d, stepValue: _, type: p, values: f } = r[i], m = e.U(r[i].default);
                "success" === m.result && (h = m.value.expression), h ? (this.options.set(l, Object.assign({}, c, {
                    value: n,
                    default: h,
                    minValue: u,
                    maxValue: d,
                    stepValue: _,
                    type: p,
                    values: f
                })), this.updateConfigDependencies(i)) : this.fire(new e.y(new Error(`No schema defined for the config option "${i}" in the "${t1}" fragment.`)));
            }
            getConfig(t1) {
                const i = this.getFragmentStyle(t1);
                if (!i) return null;
                const o = i.stylesheet.schema;
                if (!o) return null;
                const s = {};
                for(const t1 in o){
                    const o = e.aC(t1, i.scope), r = i.options.get(o), a = r ? r.value || r.default : null;
                    s[t1] = a ? a.serialize() : null;
                }
                return s;
            }
            setConfig(e, t1) {
                const i = this.getFragmentStyle(e);
                i && (i.updateConfig(t1, i.stylesheet.schema), this.updateConfigDependencies());
            }
            getSchema(e) {
                const t1 = this.getFragmentStyle(e);
                return t1 ? t1.stylesheet.schema : null;
            }
            setSchema(e, t1) {
                const i = this.getFragmentStyle(e);
                i && (i.stylesheet.schema = t1, i.updateConfig(i._config, t1), this.updateConfigDependencies());
            }
            updateConfig(t1, i) {
                if (this._config = t1, t1 || i) {
                    if (i) for(const o in i){
                        let s, r;
                        const a = e.U(i[o].default);
                        if ("success" === a.result && (s = a.value.expression), t1 && void 0 !== t1[o]) {
                            const i = e.U(t1[o]);
                            "success" === i.result && (r = i.value.expression);
                        }
                        const { minValue: n, maxValue: l, stepValue: c, type: h, values: u } = i[o];
                        if (s) {
                            const t1 = e.aC(o, this.scope);
                            this.options.set(t1, {
                                default: s,
                                value: r,
                                minValue: n,
                                maxValue: l,
                                stepValue: c,
                                type: h,
                                values: u
                            });
                        } else this.fire(new e.y(new Error(`No schema defined for config option "${o}".`)));
                    }
                    else this.fire(new e.y(new Error("Attempting to set config for a style without schema.")));
                }
            }
            updateConfigDependencies(e) {
                for (const t1 of this._configDependentLayers){
                    const i = this.getLayer(t1);
                    if (i) {
                        if (e && !i.configDependencies.has(e)) continue;
                        i.possiblyEvaluateVisibility(), this._updateLayer(i);
                    }
                }
                this.ambientLight && this.ambientLight.updateConfig(this.options), this.directionalLight && this.directionalLight.updateConfig(this.options), this.fog && this.fog.updateConfig(this.options), this.snow && this.snow.updateConfig(this.options), this.rain && this.rain.updateConfig(this.options), this.forEachFragmentStyle((e)=>{
                    const t1 = e._styleColorTheme.colorThemeOverride ? e._styleColorTheme.colorThemeOverride : e._styleColorTheme.colorTheme;
                    if (t1) {
                        const i = e._evaluateColorThemeData(t1);
                        (!e._styleColorTheme.lut && "" !== i || e._styleColorTheme.lut && i !== e._styleColorTheme.lut.data) && e.setColorTheme(t1);
                    }
                }), this._changes.setDirty();
            }
            addLayer(t1, i, o = {}) {
                this._checkLoaded();
                const s = t1.id;
                if (this._layers[s]) return void this.fire(new e.y(new Error(`Layer with id "${s}" already exists on this map`)));
                let r;
                if ("custom" === t1.type) {
                    if (go(this, e.ct(t1))) return;
                    r = e.cu(t1, this.scope, this._styleColorTheme.lut, this.options);
                } else {
                    if ("object" == typeof t1.source && (this.addSource(s, t1.source), t1 = e.cp(t1), t1 = e.l(t1, {
                        source: s
                    })), this._validate(Ee, `layers.${s}`, t1, {
                        arrayIndex: -1
                    }, o)) return;
                    r = e.cu(t1, this.scope, this._styleColorTheme.lut, this.options), this._validateLayer(r), r.setEventedParent(this, {
                        layer: {
                            id: s
                        }
                    });
                }
                0 !== r.configDependencies.size && this._configDependentLayers.add(r.fqid);
                let a = this._order.length;
                if (i) {
                    const t1 = this._order.indexOf(i);
                    if (-1 === t1) return void this.fire(new e.y(new Error(`Layer with id "${i}" does not exist on this map.`)));
                    r.slot === this._layers[i].slot ? a = t1 : e.w(`Layer with id "${i}" has a different slot. Layers can only be rearranged within the same slot.`);
                }
                this._order.splice(a, 0, s), this._layerOrderChanged = !0, this._layers[s] = r;
                const n = this.getOwnLayerSourceCache(r), l = !!this.directionalLight && this.directionalLight.shadowsEnabled();
                n && r.canCastShadows() && l && (n.castsShadows = !0);
                const c = this._changes.getRemovedLayer(r);
                if (c && r.source && n && "custom" !== r.type) {
                    this._changes.discardLayerRemoval(r);
                    const t1 = e.aC(r.source, r.scope);
                    c.type !== r.type ? this._changes.updateSourceCache(t1, "clear") : (this._changes.updateSourceCache(t1, "reload"), n.pause());
                }
                this._updateLayer(r), r.onAdd && r.onAdd(this.map), r.scope = this.scope, this.mergeLayers();
            }
            moveLayer(t1, i) {
                this._checkLoaded();
                const o = this._checkLayer(t1);
                if (!o) return;
                if (t1 === i) return;
                const s = this._order.indexOf(t1);
                this._order.splice(s, 1);
                let r = this._order.length;
                if (i) {
                    const t1 = this._order.indexOf(i);
                    if (-1 === t1) return void this.fire(new e.y(new Error(`Layer with id "${i}" does not exist on this map.`)));
                    o.slot === this._layers[i].slot ? r = t1 : e.w(`Layer with id "${i}" has a different slot. Layers can only be rearranged within the same slot.`);
                }
                this._order.splice(r, 0, t1), this._changes.setDirty(), this._layerOrderChanged = !0, this.mergeLayers();
            }
            removeLayer(e) {
                this._checkLoaded();
                const t1 = this._checkLayer(e);
                if (!t1) return;
                t1.setEventedParent(null);
                const i = this._order.indexOf(e);
                this._order.splice(i, 1), delete this._layers[e], this._changes.setDirty(), this._layerOrderChanged = !0, this._configDependentLayers.delete(t1.fqid), this._changes.removeLayer(t1);
                const o = this.getOwnLayerSourceCache(t1);
                if (o && o.castsShadows) {
                    let e = !1;
                    for(const i in this._layers)if (this._layers[i].source === t1.source && this._layers[i].canCastShadows()) {
                        e = !0;
                        break;
                    }
                    o.castsShadows = e;
                }
                t1.onRemove && t1.onRemove(this.map), this.mergeLayers();
            }
            getOwnLayer(e) {
                return this._layers[e];
            }
            hasLayer(e) {
                return e in this._mergedLayers;
            }
            hasLayerType(e) {
                for(const t1 in this._layers)if (this._layers[t1].type === e) return !0;
                return !1;
            }
            setLayerZoomRange(e, t1, i) {
                this._checkLoaded();
                const o = this._checkLayer(e);
                o && (o.minzoom === t1 && o.maxzoom === i || (null != t1 && (o.minzoom = t1), null != i && (o.maxzoom = i), this._updateLayer(o)));
            }
            getSlots() {
                return this._checkLoaded(), this._mergedSlots;
            }
            setSlot(e, t1) {
                this._checkLoaded();
                const i = this._checkLayer(e);
                i && i.slot !== t1 && (i.slot = t1, this._updateLayer(i));
            }
            setFilter(t1, i, o = {}) {
                this._checkLoaded();
                const s = this._checkLayer(t1);
                if (s && !e.bn(s.filter, i)) return null == i ? (s.filter = void 0, void this._updateLayer(s)) : void (this._validate(Se, `layers.${s.id}.filter`, i, {
                    layerType: s.type
                }, o) || (s.filter = e.cp(i), this._updateLayer(s)));
            }
            getFilter(t1) {
                const i = this._checkLayer(t1);
                if (i) return e.cp(i.filter);
            }
            setLayoutProperty(t1, i, o, s = {}) {
                this._checkLoaded();
                const r = this._checkLayer(t1);
                if (r && !e.bn(r.getLayoutProperty(i), o)) {
                    if (null != o && (!s || !1 !== s.validate) && go(r, Ie.call(me, {
                        key: `layers.${t1}.layout.${i}`,
                        layerType: r.type,
                        objectKey: i,
                        value: o,
                        styleSpec: e.a3,
                        style: {
                            glyphs: !0,
                            sprite: !0
                        }
                    }))) return;
                    r.setLayoutProperty(i, o), 0 !== r.configDependencies.size && this._configDependentLayers.add(r.fqid), this._updateLayer(r);
                }
            }
            getLayoutProperty(e, t1) {
                const i = this._checkLayer(e);
                if (i) return i.getLayoutProperty(t1);
            }
            setPaintProperty(t1, i, o, s = {}) {
                this._checkLoaded();
                const r = this._checkLayer(t1);
                if (!r) return;
                if (e.bn(r.getPaintProperty(i), o)) return;
                if (null != o && (!s || !1 !== s.validate) && go(r, Ce.call(me, {
                    key: `layers.${t1}.paint.${i}`,
                    layerType: r.type,
                    objectKey: i,
                    value: o,
                    styleSpec: e.a3
                }))) return;
                const a = r.setPaintProperty(i, o);
                0 !== r.configDependencies.size && this._configDependentLayers.add(r.fqid), a && this._updateLayer(r), this._changes.updatePaintProperties(r);
            }
            getPaintProperty(e, t1) {
                const i = this._checkLayer(e);
                if (i) return i.getPaintProperty(t1);
            }
            setFeatureState(t1, i) {
                if (this._checkLoaded(), "target" in t1) {
                    if ("featuresetId" in t1.target) {
                        const { featuresetId: e, importId: o } = t1.target, s = this.getFragmentStyle(o), r = s.getFeaturesetLayers(e);
                        for (const { source: e, sourceLayer: o } of r)s.setFeatureState({
                            id: t1.id,
                            source: e,
                            sourceLayer: o
                        }, i);
                    } else if ("layerId" in t1.target) {
                        const { layerId: e } = t1.target, o = this.getLayer(e);
                        this.setFeatureState({
                            id: t1.id,
                            source: o.source,
                            sourceLayer: o.sourceLayer
                        }, i);
                    }
                    return;
                }
                const o = t1.source, s = t1.sourceLayer, r = this._checkSource(o);
                if (!r) return;
                const a = r.type;
                if ("geojson" === a && s) return void this.fire(new e.y(new Error("GeoJSON sources cannot have a sourceLayer parameter.")));
                if ("vector" === a && !s) return void this.fire(new e.y(new Error("The sourceLayer parameter must be provided for vector source types.")));
                void 0 === t1.id && this.fire(new e.y(new Error("The feature id parameter must be provided.")));
                const n = this.getOwnSourceCaches(o);
                for (const e of n)e.setFeatureState(s, t1.id, i);
            }
            removeFeatureState(t1, i) {
                if (this._checkLoaded(), "target" in t1) {
                    if ("featuresetId" in t1.target) {
                        const { featuresetId: e, importId: o } = t1.target, s = this.getFragmentStyle(o), r = s.getFeaturesetLayers(e);
                        for (const { source: e, sourceLayer: o } of r)s.removeFeatureState({
                            id: t1.id,
                            source: e,
                            sourceLayer: o
                        }, i);
                    } else if ("layerId" in t1.target) {
                        const { layerId: e } = t1.target, o = this.getLayer(e);
                        this.removeFeatureState({
                            id: t1.id,
                            source: o.source,
                            sourceLayer: o.sourceLayer
                        }, i);
                    }
                    return;
                }
                const o = t1.source, s = this._checkSource(o);
                if (!s) return;
                const r = s.type, a = "vector" === r ? t1.sourceLayer : void 0;
                if ("vector" === r && !a) return void this.fire(new e.y(new Error("The sourceLayer parameter must be provided for vector source types.")));
                if (i && "string" != typeof t1.id && "number" != typeof t1.id) return void this.fire(new e.y(new Error("A feature id is required to remove its specific state property.")));
                const n = this.getOwnSourceCaches(o);
                for (const e of n)e.removeFeatureState(a, t1.id, i);
            }
            getFeatureState(t1) {
                if (this._checkLoaded(), "target" in t1) {
                    let i;
                    if ("featuresetId" in t1.target) {
                        const { featuresetId: o, importId: s } = t1.target, r = this.getFragmentStyle(s), a = r.getFeaturesetLayers(o);
                        for (const { source: o, sourceLayer: s } of a){
                            const a = r.getFeatureState({
                                id: t1.id,
                                source: o,
                                sourceLayer: s
                            });
                            if (a && !i) i = a;
                            else if (!e.bn(i, a)) return void this.fire(new e.y(new Error("The same feature id exists in multiple sources in the featureset, but their feature states are not consistent through the sources.")));
                        }
                    } else if ("layerId" in t1.target) {
                        const { layerId: e } = t1.target, o = this.getLayer(e);
                        i = this.getFeatureState({
                            id: t1.id,
                            source: o.source,
                            sourceLayer: o.sourceLayer
                        });
                    }
                    return i;
                }
                const i = t1.source, o = t1.sourceLayer, s = this._checkSource(i);
                if (s) {
                    if ("vector" !== s.type || o) return void 0 === t1.id && this.fire(new e.y(new Error("The feature id parameter must be provided."))), this.getOwnSourceCaches(i)[0].getFeatureState(o, t1.id);
                    this.fire(new e.y(new Error("The sourceLayer parameter must be provided for vector source types.")));
                }
            }
            setTransition(t1) {
                return this.stylesheet.transition = e.l({}, this.stylesheet.transition, t1), this.transition = this.stylesheet.transition, this;
            }
            getTransition() {
                return e.l({}, this.stylesheet.transition);
            }
            serialize() {
                this._checkLoaded();
                const t1 = this.getTerrain(), i = t1 && this.terrain && this.terrain.scope === this.scope ? t1 : this.stylesheet.terrain;
                return e.cv({
                    version: this.stylesheet.version,
                    name: this.stylesheet.name,
                    metadata: this.stylesheet.metadata,
                    fragment: this.stylesheet.fragment,
                    imports: this._serializeImports(),
                    schema: this.stylesheet.schema,
                    camera: this.stylesheet.camera,
                    light: this.stylesheet.light,
                    lights: this.stylesheet.lights,
                    terrain: i,
                    fog: this.stylesheet.fog,
                    snow: this.stylesheet.snow,
                    rain: this.stylesheet.rain,
                    center: this.stylesheet.center,
                    "color-theme": this.stylesheet["color-theme"],
                    zoom: this.stylesheet.zoom,
                    bearing: this.stylesheet.bearing,
                    pitch: this.stylesheet.pitch,
                    sprite: this.stylesheet.sprite,
                    glyphs: this.stylesheet.glyphs,
                    transition: this.stylesheet.transition,
                    projection: this.stylesheet.projection,
                    sources: this._serializeSources(),
                    layers: this._serializeLayers(this._order)
                }, (e)=>void 0 !== e);
            }
            _updateFilteredLayers(e) {
                for (const t1 of Object.values(this._mergedLayers))e(t1) && this._updateLayer(t1);
            }
            _updateLayer(t1) {
                this._changes.updateLayer(t1);
                const i = this.getLayerSourceCache(t1), o = e.aC(t1.source, t1.scope), s = this._changes.getUpdatedSourceCaches();
                t1.source && !s[o] && i && "raster" !== i.getSource().type && (this._changes.updateSourceCache(o, "reload"), i.pause()), t1.invalidateCompiledFilter();
            }
            _flattenAndSortRenderedFeatures(e) {
                const t1 = (e)=>this._mergedLayers[e].is3D(), i = this.order, o = {}, s = [];
                for(let r = i.length - 1; r >= 0; r--){
                    const a = i[r];
                    if (t1(a)) {
                        o[a] = r;
                        for (const t1 of e){
                            const e = t1[a];
                            if (e) for (const t1 of e)s.push(t1);
                        }
                    }
                }
                s.sort((e, t1)=>t1.intersectionZ - e.intersectionZ);
                const r = [];
                for(let a = i.length - 1; a >= 0; a--){
                    const n = i[a];
                    if (t1(n)) for(let e = s.length - 1; e >= 0; e--){
                        const t1 = s[e].feature;
                        if (t1.layer && o[t1.layer.id] < a) break;
                        r.push(t1), s.pop();
                    }
                    else for (const t1 of e){
                        const e = t1[n];
                        if (e) for (const t1 of e)r.push(t1.feature);
                    }
                }
                return r;
            }
            queryRenderedFeatures(t1, i, o) {
                let s;
                i && !Array.isArray(i) && i.filter && (this._validate(Se, "queryRenderedFeatures.filter", i.filter, null, i), s = e.aZ(i.filter));
                const r = {}, a = (e)=>{
                    if (xo.has(e.type)) return;
                    const t1 = this.getOwnLayerSourceCache(e), i = r[t1.id] = r[t1.id] || {
                        sourceCache: t1,
                        layers: {},
                        has3DLayers: !1
                    };
                    e.is3D() && (i.has3DLayers = !0), i.layers[e.fqid] = i.layers[e.fqid] || {
                        styleLayer: e,
                        targets: []
                    }, i.layers[e.fqid].targets.push({
                        filter: s
                    });
                };
                if (i && i.layers) {
                    if (!Array.isArray(i.layers)) return this.fire(new e.y(new Error("parameters.layers must be an Array."))), [];
                    for (const t1 of i.layers){
                        const i = this._layers[t1];
                        if (!i) return this.fire(new e.y(new Error(`The layer '${t1}' does not exist in the map's style and cannot be queried for features.`))), [];
                        a(i);
                    }
                } else for(const e in this._layers)a(this._layers[e]);
                const n = this._queryRenderedFeatures(t1, r, o), l = this._flattenAndSortRenderedFeatures(n), c = [];
                for (const t1 of l)e.cs(t1.layer.id) === this.scope && c.push(t1);
                return c;
            }
            queryRenderedFeatureset(t1, i, o) {
                let s;
                i && !Array.isArray(i) && i.filter && (this._validate(Se, "queryRenderedFeatures.filter", i.filter, null, i), s = e.aZ(i.filter));
                const r = "mock", a = [];
                if (i && i.target) a.push(Object.assign({}, i, {
                    targetId: r,
                    filter: s
                }));
                else {
                    const e = this.getFeaturesetDescriptors();
                    for (const t1 of e)a.push({
                        targetId: r,
                        filter: s,
                        target: t1
                    });
                    for (const { style: e } of this.fragments){
                        const t1 = e.getFeaturesetDescriptors();
                        for (const e of t1)a.push({
                            targetId: r,
                            filter: s,
                            target: e
                        });
                    }
                }
                const n = this.queryRenderedTargets(t1, a, o), l = [], c = new Set;
                for (const t1 of n)for (const i of t1.variants[r])nt(i, t1, c) || l.push(new e.cw(t1, i));
                return l;
            }
            queryRenderedTargets(t1, i, o) {
                const s = {}, r = (e, t1, i, o)=>{
                    const r = s[t1.id] = s[t1.id] || {
                        sourceCache: t1,
                        layers: {},
                        has3DLayers: !1
                    };
                    if (r.layers[e.fqid] = r.layers[e.fqid] || {
                        styleLayer: e,
                        targets: []
                    }, e.is3D() && (r.has3DLayers = !0), !o) return i.uniqueFeatureID = !1, void r.layers[e.fqid].targets.push(i);
                    r.layers[e.fqid].targets.push(Object.assign({}, i, {
                        namespace: o.namespace,
                        properties: o.properties,
                        uniqueFeatureID: o.uniqueFeatureID
                    }));
                };
                for (const t1 of i)if ("featuresetId" in t1.target) {
                    const { featuresetId: i, importId: o } = t1.target, s = this.getFragmentStyle(o);
                    if (!s || !s._featuresetSelectors) continue;
                    const a = s._featuresetSelectors[i];
                    if (!a) {
                        this.fire(new e.y(new Error(`The featureset '${i}' does not exist in the map's style and cannot be queried for features.`)));
                        continue;
                    }
                    for (const e of a){
                        const i = s.getOwnLayer(e.layerId);
                        i && !xo.has(i.type) && r(i, s.getOwnLayerSourceCache(i), t1, e);
                    }
                } else if ("layerId" in t1.target) {
                    const { layerId: e } = t1.target, i = this.getLayer(e);
                    if (!i || xo.has(i.type)) continue;
                    r(i, this.getLayerSourceCache(i), t1);
                }
                const a = this._queryRenderedFeatures(t1, s, o);
                return this._flattenAndSortRenderedFeatures(a);
            }
            _queryRenderedFeatures(e, t1, i) {
                const o = [], s = !!this.map._showQueryGeometry, r = Xe.createFromScreenPoints(e, i);
                for(const e in t1){
                    const a = lt(r, t1[e], this._availableImages, i, s);
                    Object.keys(a).length && o.push(a);
                }
                if (this.placement) for(const e in t1){
                    if (!t1[e].sourceCache._onlySymbols) continue;
                    const i = ct(r.screenGeometry, t1[e], this._availableImages, this.placement.collisionIndex, this.placement.retainedQueryData);
                    Object.keys(i).length && o.push(i);
                }
                return o;
            }
            querySourceFeatures(e, t1) {
                const i = t1 && t1.filter;
                i && this._validate(Se, "querySourceFeatures.filter", i, null, t1);
                let o = [];
                const s = this.getOwnSourceCaches(e);
                for (const e of s)o = o.concat(ht(e, t1));
                return o;
            }
            addSourceType(e, t1, i) {
                return To.getSourceType(e) ? i(new Error(`A source type called "${e}" already exists.`)) : (To.setSourceType(e, t1), t1.workerSourceURL ? void this.dispatcher.broadcast("loadWorkerSource", {
                    name: e,
                    url: t1.workerSourceURL
                }, i) : i(null, null));
            }
            getFlatLight() {
                return this.light.getLight();
            }
            setFlatLight(t1, i, o = {}) {
                this._checkLoaded();
                const s = this.light.getLight();
                let r = !1;
                for(const i in t1)if (!e.bn(t1[i], s[i])) {
                    r = !0;
                    break;
                }
                if (!r) return;
                const a = this._getTransitionParameters();
                this.light.setLight(t1, i, o), this.light.updateTransitions(a);
            }
            getTerrain() {
                return this.terrain && 1 === this.terrain.drapeRenderMode ? this.terrain.get() : null;
            }
            setTerrainForDraping() {
                this.setTerrain({
                    source: "",
                    exaggeration: 0
                }, 0);
            }
            checkCanvasFingerprintNoise() {
                void 0 === this.disableElevatedTerrain && (this.disableElevatedTerrain = e.q.hasCanvasFingerprintNoise(), this.disableElevatedTerrain && e.w("Terrain and hillshade are disabled because of Canvas2D limitations when fingerprinting protection is enabled (e.g. in private browsing mode)."));
            }
            setTerrain(t1, i = 1) {
                if (this._checkLoaded(), !t1) return this.terrainSetForDrapingOnly() || (delete this.terrain, this.map.transform.projection.requiresDraping && this.setTerrainForDraping()), 0 === i && delete this.terrain, null === t1 ? this.stylesheet.terrain = null : delete this.stylesheet.terrain, this._force3DLayerUpdate(), void (this._markersNeedUpdate = !0);
                this.checkCanvasFingerprintNoise();
                let o = t1;
                const s = null == t1.source;
                if (1 === i) {
                    if (this.disableElevatedTerrain) return;
                    if ("object" == typeof o.source) {
                        const t1 = "terrain-dem-src";
                        this.addSource(t1, o.source), o = e.cp(o), o = e.l(o, {
                            source: t1
                        });
                    }
                    const t1 = e.l({}, o), i = {};
                    if (this.terrain && s) {
                        t1.source = this.terrain.get().source;
                        const e = this.terrain ? this.getFragmentStyle(this.terrain.scope) : null;
                        e && (i.style = e.serialize());
                    }
                    if (this._validate(xe, "terrain", t1, i)) return;
                }
                if (!this.terrain || this.terrain.scope !== this.scope && !s || this.terrain && i !== this.terrain.drapeRenderMode) {
                    if (!o) return;
                    this._createTerrain(o, i), this.fire(new e.z("data", {
                        dataType: "style"
                    }));
                } else {
                    const i = this.terrain, s = i.get();
                    for (const t1 of Object.keys(e.a3.terrain))!o.hasOwnProperty(t1) && e.a3.terrain[t1].default && (o[t1] = e.a3.terrain[t1].default);
                    for(const o in t1)if (!e.bn(t1[o], s[o])) {
                        i.set(t1, this.options), this.stylesheet.terrain = t1;
                        const o = this._getTransitionParameters({
                            duration: 0
                        });
                        i.updateTransitions(o), this.fire(new e.z("data", {
                            dataType: "style"
                        }));
                        break;
                    }
                }
                this.mergeTerrain(), this.updateDrapeFirstLayers(), this._markersNeedUpdate = !0;
            }
            _createFog(e) {
                const t1 = this.fog = new je(e, this.map.transform, this.scope, this.options);
                this.stylesheet.fog = t1.get();
                const i = this._getTransitionParameters({
                    duration: 0
                });
                t1.updateTransitions(i);
            }
            _createSnow(e) {
                const t1 = this.snow = new Ze(e, this.map.transform, this.scope, this.options);
                this.stylesheet.snow = t1.get();
                const i = this._getTransitionParameters({
                    duration: 0
                });
                t1.updateTransitions(i);
            }
            _createRain(e) {
                const t1 = this.rain = new We(e, this.map.transform, this.scope, this.options);
                this.stylesheet.rain = t1.get();
                const i = this._getTransitionParameters({
                    duration: 0
                });
                t1.updateTransitions(i);
            }
            _updateMarkersOpacity() {
                0 !== this.map._markers.length && this.map._requestDomTask(()=>{
                    for (const e of this.map._markers)e._evaluateOpacity();
                });
            }
            getFog() {
                return this.fog ? this.fog.get() : null;
            }
            setFog(t1) {
                if (this._checkLoaded(), !t1) return delete this.fog, delete this.stylesheet.fog, void (this._markersNeedUpdate = !0);
                if (this.fog) {
                    const i = this.fog;
                    if (!e.bn(i.get(), t1)) {
                        i.set(t1, this.options), this.stylesheet.fog = i.get();
                        const e = this._getTransitionParameters({
                            duration: 0
                        });
                        i.updateTransitions(e);
                    }
                } else this._createFog(t1);
                this._markersNeedUpdate = !0;
            }
            getSnow() {
                return this.snow ? this.snow.get() : null;
            }
            setSnow(t1) {
                if (this._checkLoaded(), !t1) return delete this.snow, void delete this.stylesheet.snow;
                if (this.snow) {
                    const i = this.snow;
                    if (!e.bn(i.get(), t1)) {
                        i.set(t1, this.options), this.stylesheet.snow = i.get();
                        const e = this._getTransitionParameters({
                            duration: 0
                        });
                        i.updateTransitions(e);
                    }
                } else this._createSnow(t1);
                this._markersNeedUpdate = !0;
            }
            getRain() {
                return this.rain ? this.rain.get() : null;
            }
            setRain(t1) {
                if (this._checkLoaded(), !t1) return delete this.rain, void delete this.stylesheet.rain;
                if (this.rain) {
                    const i = this.rain;
                    if (!e.bn(i.get(), t1)) {
                        i.set(t1, this.options), this.stylesheet.rain = i.get();
                        const e = this._getTransitionParameters({
                            duration: 0
                        });
                        i.updateTransitions(e);
                    }
                } else this._createRain(t1);
                this._markersNeedUpdate = !0;
            }
            _reloadColorTheme() {
                const t1 = ()=>{
                    for(const e in this._layers)this._layers[e].lut = this._styleColorTheme.lut;
                    for(const e in this._sourceCaches)this._sourceCaches[e].clearTiles();
                }, i = this._styleColorTheme.colorThemeOverride ? this._styleColorTheme.colorThemeOverride : this._styleColorTheme.colorTheme;
                if (!i) return this._styleColorTheme.lut = null, void t1();
                const o = this._evaluateColorThemeData(i);
                this._loadColorTheme(o).then(()=>{
                    this.fire(new e.z("colorthemeset")), t1();
                }).catch((t1)=>{
                    e.w(`Couldn't set color theme: ${t1}`);
                });
            }
            setColorTheme(t1) {
                this._checkLoaded(), this._styleColorTheme.colorThemeOverride && e.w("Note: setColorTheme is called on a style with a color-theme override, the passed color-theme won't be visible."), this._styleColorTheme.colorTheme = t1, this._reloadColorTheme();
            }
            setImportColorTheme(e, t1) {
                const i = this.getFragmentStyle(e);
                i && (i._styleColorTheme.colorThemeOverride = t1, i._reloadColorTheme());
            }
            _getTransitionParameters(t1) {
                return {
                    now: e.q.now(),
                    transition: e.l(this.transition, t1)
                };
            }
            updateDrapeFirstLayers() {
                if (!this.terrain) return;
                const e = [], t1 = [];
                for (const i of this._mergedOrder)this.isLayerDraped(this._mergedLayers[i]) ? e.push(i) : t1.push(i);
                this._drapedFirstOrder = [], this._drapedFirstOrder.push(...e), this._drapedFirstOrder.push(...t1);
            }
            _createTerrain(e, t1) {
                const i = this.terrain = new Pe(e, t1, this.scope, this.options);
                1 === t1 && (this.stylesheet.terrain = e), this.mergeTerrain(), this.updateDrapeFirstLayers(), this._force3DLayerUpdate();
                const o = this._getTransitionParameters({
                    duration: 0
                });
                i.updateTransitions(o);
            }
            _force3DLayerUpdate() {
                for(const e in this._layers){
                    const t1 = this._layers[e];
                    "fill-extrusion" === t1.type && this._updateLayer(t1);
                }
            }
            _forceSymbolLayerUpdate() {
                for(const e in this._layers){
                    const t1 = this._layers[e];
                    "symbol" === t1.type && this._updateLayer(t1);
                }
            }
            _validate(t1, i, o, s, r = {}) {
                if (r && !1 === r.validate) return !1;
                const a = e.l({}, this.serialize());
                return go(this, t1.call(me, e.l({
                    key: i,
                    style: a,
                    value: o,
                    styleSpec: e.a3
                }, s)));
            }
            _remove() {
                this._request && (this._request.cancel(), this._request = null), this._spriteRequest && (this._spriteRequest.cancel(), this._spriteRequest = null), e.cx.off("pluginStateChange", this._rtlTextPluginCallback);
                for(const e in this._mergedLayers)this._mergedLayers[e].setEventedParent(null);
                for(const e in this._mergedSourceCaches)this._mergedSourceCaches[e].clearTiles(), this._mergedSourceCaches[e].setEventedParent(null);
                this.setEventedParent(null), delete this.fog, delete this.snow, delete this.rain, delete this.terrain, delete this.ambientLight, delete this.directionalLight, this.isRootStyle() && (this.imageManager.setEventedParent(null), this.modelManager.setEventedParent(null), this.dispatcher.remove());
            }
            clearSource(e) {
                const t1 = this.getSourceCaches(e);
                for (const e of t1)e.clearTiles();
            }
            clearSources() {
                for(const e in this._mergedSourceCaches)this._mergedSourceCaches[e].clearTiles();
            }
            reloadSource(e) {
                const t1 = this.getSourceCaches(e);
                for (const e of t1)e.resume(), e.reload();
            }
            reloadSources() {
                for (const e of this.getSources())e.reload && e.reload();
            }
            reloadModels() {
                this.modelManager.reloadModels(""), this.forEachFragmentStyle((e)=>{
                    e.modelManager.reloadModels(e.scope);
                });
            }
            updateSources(e) {
                let t1;
                this.directionalLight && (t1 = ao(this.directionalLight));
                for(const i in this._mergedSourceCaches)this._mergedSourceCaches[i].update(e, void 0, void 0, t1);
            }
            _generateCollisionBoxes() {
                for(const e in this._sourceCaches){
                    const t1 = this._sourceCaches[e];
                    t1.resume(), t1.reload();
                }
            }
            _updatePlacement(t1, i, o, s, r, a, n = !1) {
                let l = !1, c = !1;
                const h = {}, u = {};
                for (const t1 of this._mergedOrder){
                    const o = this._mergedLayers[t1];
                    if ("symbol" !== o.type) continue;
                    const s = e.aC(o.source, o.scope);
                    let r = h[s];
                    if (!r) {
                        const e = this.getLayerSourceCache(o);
                        if (!e) continue;
                        const t1 = e.getRenderableIds(!0).map((t1)=>e.getTileByID(t1));
                        u[s] = t1.slice(), r = h[s] = t1.sort((e, t1)=>t1.tileID.overscaledZ - e.tileID.overscaledZ || (e.tileID.isLessThan(t1.tileID) ? -1 : 1));
                    }
                    const a = this.crossTileSymbolIndex.addLayer(o, r, i.center.lng, i.projection);
                    l = l || a;
                }
                if (this.crossTileSymbolIndex.pruneUnusedLayers(this._mergedOrder), n = n || this._layerOrderChanged || 0 === s, this._layerOrderChanged && this.fire(new e.z("neworder")), (n || !this.pauseablePlacement || this.pauseablePlacement.isDone() && !this.placement.stillRecent(e.q.now(), i.zoom)) && (this.pauseablePlacement = new Li(i, this._mergedOrder, n, o, s, r, this.placement, this.fog && i.projection.supportsFog ? this.fog.state : null, this._buildingIndex), this._layerOrderChanged = !1), this.pauseablePlacement.isDone() ? this.placement.setStale() : (this.pauseablePlacement.continuePlacement(this._mergedOrder, this._mergedLayers, h, u, this.map.painter.scaleFactor), this.pauseablePlacement.isDone() && (this.placement = this.pauseablePlacement.commit(e.q.now()), c = !0), l && this.pauseablePlacement.placement.setStale()), c || l) {
                    this._buildingIndex.onNewFrame(i.zoom);
                    for(let t1 = 0; t1 < this._mergedOrder.length; t1++){
                        const i = this._mergedLayers[this._mergedOrder[t1]];
                        if ("symbol" !== i.type) continue;
                        const o = this.isLayerClipped(i);
                        this.placement.updateLayerOpacities(i, h[e.aC(i.source, i.scope)], t1, o ? a : null);
                    }
                }
                return {
                    needsRerender: !this.pauseablePlacement.isDone() || this.placement.hasTransitions(e.q.now())
                };
            }
            _releaseSymbolFadeTiles() {
                for(const e in this._sourceCaches)this._sourceCaches[e].releaseSymbolFadeTiles();
            }
            addImport(t1, i) {
                this._checkLoaded();
                const o = this.stylesheet.imports = this.stylesheet.imports || [];
                if (-1 !== o.findIndex(({ id: e })=>e === t1.id)) return void this.fire(new e.y(new Error(`Import with id '${t1.id}' already exists in the map's style.`)));
                if (!i) return o.push(t1), this._loadImports([
                    t1
                ], !0);
                const s = o.findIndex(({ id: e })=>e === i);
                return -1 === s && this.fire(new e.y(new Error(`Import with id "${i}" does not exist on this map.`))), this.stylesheet.imports = o.slice(0, s).concat(t1).concat(o.slice(s)), this._loadImports([
                    t1
                ], !0, i);
            }
            updateImport(t1, i) {
                this._checkLoaded();
                const o = this.stylesheet.imports || [], s = this.getImportIndex(t1);
                return -1 === s ? this : "string" == typeof i ? (this.setImportUrl(t1, i), this) : (i.url && i.url !== o[s].url && this.setImportUrl(t1, i.url), e.bn(i.config, o[s].config) || this.setImportConfig(t1, i.config, i.data.schema), e.bn(i.data, o[s].data) || this.setImportData(t1, i.data), this);
            }
            moveImport(e, t1) {
                this._checkLoaded();
                let i = this.stylesheet.imports || [];
                const o = this.getImportIndex(e);
                if (-1 === o) return this;
                const s = this.getImportIndex(t1);
                if (-1 === s) return this;
                const r = i[o], a = this.fragments[o];
                return i = i.filter(({ id: t1 })=>t1 !== e), this.fragments = this.fragments.filter(({ id: t1 })=>t1 !== e), this.stylesheet.imports = i.slice(0, s).concat(r).concat(i.slice(s)), this.fragments = this.fragments.slice(0, s).concat(a).concat(this.fragments.slice(s)), this.mergeLayers(), this;
            }
            setImportUrl(e, t1) {
                this._checkLoaded();
                const i = this.stylesheet.imports || [], o = this.getImportIndex(e);
                if (-1 === o) return this;
                i[o].url = t1;
                const s = this.fragments[o];
                return s.style = this._createFragmentStyle(i[o]), s.style.on("style.import.load", ()=>this.mergeAll()), s.style.loadURL(t1), this;
            }
            setImportData(e, t1) {
                this._checkLoaded();
                const i = this.getImportIndex(e), o = this.stylesheet.imports || [];
                return -1 === i ? this : t1 ? (this.fragments[i].style.setState(t1), this._reloadImports(), this) : (delete o[i].data, this.setImportUrl(e, o[i].url));
            }
            setImportConfig(e, t1, i) {
                this._checkLoaded();
                const o = this.getImportIndex(e), s = this.stylesheet.imports || [];
                if (-1 === o) return this;
                t1 ? s[o].config = t1 : delete s[o].config;
                const r = this.fragments[o];
                i && r.style.stylesheet && (r.style.stylesheet.schema = i);
                const a = r.style.stylesheet && r.style.stylesheet.schema;
                return r.config = t1, r.style.updateConfig(t1, a), this.updateConfigDependencies(), this;
            }
            removeImport(e) {
                this._checkLoaded();
                const t1 = this.stylesheet.imports || [], i = this.getImportIndex(e);
                -1 !== i && (t1.splice(i, 1), this.fragments[i].style._remove(), this.fragments.splice(i, 1), this._reloadImports());
            }
            getImportIndex(t1) {
                const i = (this.stylesheet.imports || []).findIndex((e)=>e.id === t1);
                return -1 === i && this.fire(new e.y(new Error(`Import '${t1}' does not exist in the map's style and cannot be updated.`))), i;
            }
            getLayer(e) {
                return this._mergedLayers[e];
            }
            getSources() {
                const e = [];
                for(const t1 in this._mergedOtherSourceCaches){
                    const i = this._mergedOtherSourceCaches[t1];
                    i && e.push(i.getSource());
                }
                return e;
            }
            getSource(e, t1) {
                const i = this.getSourceCache(e, t1);
                return i && i.getSource();
            }
            getLayerSource(e) {
                const t1 = this.getLayerSourceCache(e);
                return t1 && t1.getSource();
            }
            getSourceCache(t1, i) {
                const o = e.aC(t1, i);
                return this._mergedOtherSourceCaches[o];
            }
            getLayerSourceCache(t1) {
                const i = e.aC(t1.source, t1.scope);
                return "symbol" === t1.type ? this._mergedSymbolSourceCaches[i] : this._mergedOtherSourceCaches[i];
            }
            getSourceCaches(e) {
                if (null == e) return Object.values(this._mergedSourceCaches);
                const t1 = [];
                return this._mergedOtherSourceCaches[e] && t1.push(this._mergedOtherSourceCaches[e]), this._mergedSymbolSourceCaches[e] && t1.push(this._mergedSymbolSourceCaches[e]), t1;
            }
            updateSourceCaches() {
                const e = this._changes.getUpdatedSourceCaches();
                for(const t1 in e){
                    const i = e[t1];
                    "reload" === i ? this.reloadSource(t1) : "clear" === i && this.clearSource(t1);
                }
            }
            updateLayers(e) {
                const t1 = this._changes.getUpdatedPaintProperties();
                for (const i of t1){
                    const t1 = this.getLayer(i);
                    t1 && t1.updateTransitions(e);
                }
            }
            getImages(e, t1, i) {
                this.imageManager.getImages(t1.icons, t1.scope, i), this._updateTilesForChangedImages();
                const o = (e)=>{
                    e && e.setDependencies(t1.tileID.key, t1.type, t1.icons);
                };
                o(this._otherSourceCaches[t1.source]), o(this._symbolSourceCaches[t1.source]);
            }
            rasterizeImages(e, t1, i) {
                this.imageManager.rasterizeImages(t1, i);
            }
            getGlyphs(e, t1, i) {
                this.glyphManager.getGlyphs(t1.stacks, t1.scope, i);
            }
            getResource(t1, i, o) {
                return e.cy(i, o);
            }
            getOwnSourceCache(e) {
                return this._otherSourceCaches[e];
            }
            getOwnLayerSourceCache(e) {
                return "symbol" === e.type ? this._symbolSourceCaches[e.source] : this._otherSourceCaches[e.source];
            }
            getOwnSourceCaches(e) {
                const t1 = [];
                return this._otherSourceCaches[e] && t1.push(this._otherSourceCaches[e]), this._symbolSourceCaches[e] && t1.push(this._symbolSourceCaches[e]), t1;
            }
            _isSourceCacheLoaded(t1) {
                const i = this.getOwnSourceCaches(t1);
                return 0 === i.length ? (this.fire(new e.y(new Error(`There is no source with ID '${t1}'`))), !1) : i.every((e)=>e.loaded());
            }
            has3DLayers() {
                return this._has3DLayers;
            }
            hasSymbolLayers() {
                return this._hasSymbolLayers;
            }
            hasCircleLayers() {
                return this._hasCircleLayers;
            }
            isLayerClipped(e, t1) {
                if (!this._clipLayerPresent && "fill-extrusion" !== e.type) return !1;
                const i = "fill-extrusion" === e.type && "building" === e.sourceLayer;
                if (e.is3D()) {
                    if (i || t1 && "batched-model" === t1.type) return !0;
                    if ("model" === e.type) return !0;
                } else if ("symbol" === e.type) return !0;
                return !1;
            }
            _clearWorkerCaches() {
                this.dispatcher.broadcast("clearCaches");
            }
            destroy() {
                this._clearWorkerCaches(), this.fragments.forEach((e)=>{
                    e.style._remove();
                }), this.terrainSetForDrapingOnly() && (delete this.terrain, delete this.stylesheet.terrain);
            }
            constructor(t1, i = {}){
                super(), this.map = t1, this.scope = i.scope || "", this.globalId = null, this.fragments = [], this.importDepth = i.importDepth || 0, this.importsCache = i.importsCache || new Map, this.resolvedImports = i.resolvedImports || new Set, this.transition = e.l({}, wo), this._buildingIndex = new Dt(this), this.crossTileSymbolIndex = new Oi, this._mergedOrder = [], this._drapedFirstOrder = [], this._mergedLayers = {}, this._mergedSourceCaches = {}, this._mergedOtherSourceCaches = {}, this._mergedSymbolSourceCaches = {}, this._clipLayerPresent = !1, this._has3DLayers = !1, this._hasCircleLayers = !1, this._hasSymbolLayers = !1, this._changes = i.styleChanges || new G, this.dispatcher = i.dispatcher ? i.dispatcher : new e.D(e.ci(), this), i.imageManager ? this.imageManager = i.imageManager : (this.imageManager = new q(this.map._spriteFormat), this.imageManager.setEventedParent(this)), this.imageManager.createScope(this.scope), this.glyphManager = i.glyphManager ? i.glyphManager : new e.cj(t1._requestManager, i.localFontFamily ? e.ck.all : i.localIdeographFontFamily ? e.ck.ideographs : e.ck.none, i.localFontFamily || i.localIdeographFontFamily), i.modelManager ? this.modelManager = i.modelManager : (this.modelManager = new co(t1._requestManager), this.modelManager.setEventedParent(this)), this._layers = {}, this._sourceCaches = {}, this._otherSourceCaches = {}, this._symbolSourceCaches = {}, this._loaded = !1, this._precompileDone = !1, this._shouldPrecompile = !1, this._availableImages = [], this._order = [], this._markersNeedUpdate = !1, this.options = i.configOptions ? i.configOptions : new Map, this._configDependentLayers = i.configDependentLayers ? i.configDependentLayers : new Set, this._config = i.config, this._styleColorTheme = {
                    lut: null,
                    lutLoading: !1,
                    lutLoadingCorrelationID: 0,
                    colorTheme: null,
                    colorThemeOverride: i.colorThemeOverride
                }, this._styleColorThemeForScope = {}, this._initialConfig = i.initialConfig, this.dispatcher.broadcast("setReferrer", e.cl());
                const o = this;
                this._rtlTextPluginCallback = To.registerForPluginStateChange((t1)=>{
                    o.dispatcher.broadcast("syncRTLPluginState", {
                        pluginStatus: t1.pluginStatus,
                        pluginURL: t1.pluginURL
                    }, (t1, i)=>{
                        if (e.cm(t1), i && i.every((e)=>e)) for(const e in o._sourceCaches){
                            const t1 = o._sourceCaches[e], i = t1.getSource().type;
                            "vector" !== i && "geojson" !== i || t1.reload();
                        }
                    });
                }), this.on("data", (e)=>{
                    if ("source" !== e.dataType || "metadata" !== e.sourceDataType) return;
                    const t1 = this.getOwnSource(e.sourceId);
                    if (t1 && t1.vectorLayerIds) for(const e in this._layers){
                        const i = this._layers[e];
                        i.source === t1.id && this._validateLayer(i);
                    }
                });
            }
        }
        To.getSourceType = function(e) {
            return st[e];
        }, To.setSourceType = function(e, t1) {
            st[e] = t1;
        }, To.registerForPluginStateChange = e.ch;
        var Eo = "\n#define EPSILON 0.0000001\n#define PI 3.141592653589793\n#ifdef RENDER_CUTOFF\nfloat cutoff_opacity(vec4 cutoff_params,float depth) {float near=cutoff_params.x;float far=cutoff_params.y;float cutoffStart=cutoff_params.z;float cutoffEnd=cutoff_params.w;float linearDepth=(depth-near)/(far-near);return clamp((linearDepth-cutoffStart)/(cutoffEnd-cutoffStart),0.0,1.0);}\n#endif", So = "\nout vec4 glFragColor;highp float unpack_depth(highp vec4 rgba_depth)\n{const highp vec4 bit_shift=vec4(1.0/(255.0*255.0*255.0),1.0/(255.0*255.0),1.0/255.0,1.0);return dot(rgba_depth,bit_shift)*2.0-1.0;}highp vec4 pack_depth(highp float ndc_z) {highp float depth=ndc_z*0.5+0.5;const highp vec4 bit_shift=vec4(255.0*255.0*255.0,255.0*255.0,255.0,1.0);const highp vec4 bit_mask =vec4(0.0,1.0/255.0,1.0/255.0,1.0/255.0);highp vec4 res=fract(depth*bit_shift);res-=res.xxyz*bit_mask;return res;}\n#ifdef INDICATOR_CUTOUT\nuniform vec3 u_indicator_cutout_centers;uniform vec4 u_indicator_cutout_params;\n#endif\nvec4 applyCutout(vec4 color,float height) {\n#ifdef INDICATOR_CUTOUT\nfloat verticalFadeRange=u_indicator_cutout_centers.z*0.25;float holeMinOpacity=mix(1.0,u_indicator_cutout_params.x,smoothstep(u_indicator_cutout_centers.z,u_indicator_cutout_centers.z+verticalFadeRange,height));float holeRadius=max(u_indicator_cutout_params.y,0.0);float holeAspectRatio=u_indicator_cutout_params.z;float fadeStart=u_indicator_cutout_params.w;float distA=distance(vec2(gl_FragCoord.x,gl_FragCoord.y*holeAspectRatio),vec2(u_indicator_cutout_centers[0],u_indicator_cutout_centers[1]*holeAspectRatio));return color*min(smoothstep(fadeStart,holeRadius,distA)+holeMinOpacity,1.0);\n#else\nreturn color;\n#endif\n}\n#ifdef DEBUG_WIREFRAME\n#define HANDLE_WIREFRAME_DEBUG \\\nglFragColor=vec4(0.7,0.0,0.0,0.7); \\\ngl_FragDepth=gl_FragCoord.z-0.0001;\n#else\n#define HANDLE_WIREFRAME_DEBUG\n#endif\n#ifdef RENDER_CUTOFF\nuniform highp vec4 u_cutoff_params;in float v_cutoff_opacity;\n#endif\nvec4 textureLodCustom(sampler2D image,highp vec2 pos,highp vec2 lod_coord) {highp vec2 size=vec2(textureSize(image,0));highp vec2 dx=dFdx(lod_coord.xy*size);highp vec2 dy=dFdy(lod_coord.xy*size);highp float delta_max_sqr=max(dot(dx,dx),dot(dy,dy));highp float lod=0.5*log2(delta_max_sqr);return textureLod(image,pos,lod);}vec4 applyLUT(highp sampler3D lut,vec4 col) {vec3 size=vec3(textureSize(lut,0));vec3 uvw=(col.rbg*float(size-1.0)+0.5)/size;return vec4(texture(lut,uvw).rgb,col.a);}vec3 applyLUT(highp sampler3D lut,vec3 col) {return applyLUT(lut,vec4(col,1.0)).rgb;}", Co = "\n#define EXTENT 8192.0\n#define RAD_TO_DEG 180.0/PI\n#define DEG_TO_RAD PI/180.0\n#define GLOBE_RADIUS EXTENT/PI/2.0\nfloat wrap(float n,float min,float max) {float d=max-min;float w=mod(mod(n-min,d)+d,d)+min;return (w==min) ? max : w;}\n#ifdef PROJECTION_GLOBE_VIEW\nvec3 mercator_tile_position(mat4 matrix,vec2 tile_anchor,vec3 tile_id,vec2 mercator_center) {\n#ifndef PROJECTED_POS_ON_VIEWPORT\nfloat tiles=tile_id.z;vec2 mercator=(tile_anchor/EXTENT+tile_id.xy)/tiles;mercator-=mercator_center;mercator.x=wrap(mercator.x,-0.5,0.5);vec4 mercator_tile=vec4(mercator.xy*EXTENT,EXTENT/(2.0*PI),1.0);mercator_tile=matrix*mercator_tile;return mercator_tile.xyz;\n#else\nreturn vec3(0.0);\n#endif\n}vec3 mix_globe_mercator(vec3 globe,vec3 mercator,float t) {return mix(globe,mercator,t);}mat3 globe_mercator_surface_vectors(vec3 pos_normal,vec3 up_dir,float zoom_transition) {vec3 normal=zoom_transition==0.0 ? pos_normal : normalize(mix(pos_normal,up_dir,zoom_transition));vec3 xAxis=normalize(vec3(normal.z,0.0,-normal.x));vec3 yAxis=normalize(cross(normal,xAxis));return mat3(xAxis,yAxis,normal);}\n#endif\nvec2 unpack_float(const float packedValue) {int packedIntValue=int(packedValue);int v0=packedIntValue/256;return vec2(v0,packedIntValue-v0*256);}vec2 unpack_opacity(const float packedOpacity) {int intOpacity=int(packedOpacity)/2;return vec2(float(intOpacity)/127.0,mod(packedOpacity,2.0));}vec4 decode_color(const vec2 encodedColor) {return vec4(\nunpack_float(encodedColor[0])/255.0,unpack_float(encodedColor[1])/255.0\n);}float unpack_mix_vec2(const vec2 packedValue,const float t) {return mix(packedValue[0],packedValue[1],t);}vec4 unpack_mix_color(const vec4 packedColors,const float t) {vec4 minColor=decode_color(vec2(packedColors[0],packedColors[1]));vec4 maxColor=decode_color(vec2(packedColors[2],packedColors[3]));return mix(minColor,maxColor,t);}vec2 get_pattern_pos(const vec2 pixel_coord_upper,const vec2 pixel_coord_lower,const vec2 pattern_size,const vec2 units_to_pixels,const vec2 pos) {vec2 offset=mod(mod(mod(pixel_coord_upper,pattern_size)*256.0,pattern_size)*256.0+pixel_coord_lower,pattern_size);return (units_to_pixels*pos+offset)/pattern_size;}vec2 get_pattern_pos(const vec2 pixel_coord_upper,const vec2 pixel_coord_lower,const vec2 pattern_size,const float tile_units_to_pixels,const vec2 pos) {return get_pattern_pos(pixel_coord_upper,pixel_coord_lower,pattern_size,vec2(tile_units_to_pixels),pos);}float mercatorXfromLng(float lng) {return (180.0+lng)/360.0;}float mercatorYfromLat(float lat) {return (180.0-(RAD_TO_DEG*log(tan(PI/4.0+lat/2.0*DEG_TO_RAD))))/360.0;}vec3 latLngToECEF(vec2 latLng) {latLng=DEG_TO_RAD*latLng;float cosLat=cos(latLng[0]);float sinLat=sin(latLng[0]);float cosLng=cos(latLng[1]);float sinLng=sin(latLng[1]);float sx=cosLat*sinLng*GLOBE_RADIUS;float sy=-sinLat*GLOBE_RADIUS;float sz=cosLat*cosLng*GLOBE_RADIUS;return vec3(sx,sy,sz);}\n#ifdef RENDER_CUTOFF\nuniform vec4 u_cutoff_params;out float v_cutoff_opacity;\n#endif\nconst vec4 AWAY=vec4(-1000.0,-1000.0,-1000.0,1);const float skirtOffset=24575.0;vec3 decomposeToPosAndSkirt(vec2 posWithComposedSkirt)\n{float skirt=float(posWithComposedSkirt.x >=skirtOffset);vec2 pos=posWithComposedSkirt-vec2(skirt*skirtOffset,0.0);return vec3(pos,skirt);}", Io = "in highp vec3 a_pos_3f;uniform lowp mat4 u_matrix;out highp vec3 v_uv;void main() {const mat3 half_neg_pi_around_x=mat3(1.0,0.0, 0.0,0.0,0.0,-1.0,0.0,1.0, 0.0);v_uv=half_neg_pi_around_x*a_pos_3f;vec4 pos=u_matrix*vec4(a_pos_3f,1.0);gl_Position=pos.xyww;}", Ro = "\n#define ELEVATION_SCALE 7.0\n#define ELEVATION_OFFSET 450.0\n#ifdef PROJECTION_GLOBE_VIEW\nuniform vec3 u_tile_tl_up;uniform vec3 u_tile_tr_up;uniform vec3 u_tile_br_up;uniform vec3 u_tile_bl_up;uniform float u_tile_up_scale;vec3 elevationVector(vec2 pos) {vec2 uv=pos/EXTENT;vec3 up=normalize(mix(\nmix(u_tile_tl_up,u_tile_tr_up,uv.xxx),mix(u_tile_bl_up,u_tile_br_up,uv.xxx),uv.yyy));return up*u_tile_up_scale;}\n#else\nvec3 elevationVector(vec2 pos) { return vec3(0,0,1); }\n#endif\n#ifdef TERRAIN\nuniform highp sampler2D u_dem;uniform highp sampler2D u_dem_prev;uniform vec2 u_dem_tl;uniform vec2 u_dem_tl_prev;uniform float u_dem_scale;uniform float u_dem_scale_prev;uniform float u_dem_size;uniform float u_dem_lerp;uniform float u_exaggeration;uniform float u_meter_to_dem;uniform mat4 u_label_plane_matrix_inv;vec4 tileUvToDemSample(vec2 uv,float dem_size,float dem_scale,vec2 dem_tl) {vec2 pos=dem_size*(uv*dem_scale+dem_tl)+1.0;vec2 f=fract(pos);return vec4((pos-f+0.5)/(dem_size+2.0),f);}float currentElevation(vec2 apos) {\n#ifdef TERRAIN_DEM_FLOAT_FORMAT\nvec2 pos=(u_dem_size*(apos/8192.0*u_dem_scale+u_dem_tl)+1.5)/(u_dem_size+2.0);return u_exaggeration*texture(u_dem,pos).r;\n#else\nfloat dd=1.0/(u_dem_size+2.0);vec4 r=tileUvToDemSample(apos/8192.0,u_dem_size,u_dem_scale,u_dem_tl);vec2 pos=r.xy;vec2 f=r.zw;float tl=texture(u_dem,pos).r;float tr=texture(u_dem,pos+vec2(dd,0)).r;float bl=texture(u_dem,pos+vec2(0,dd)).r;float br=texture(u_dem,pos+vec2(dd,dd)).r;return u_exaggeration*mix(mix(tl,tr,f.x),mix(bl,br,f.x),f.y);\n#endif\n}float prevElevation(vec2 apos) {\n#ifdef TERRAIN_DEM_FLOAT_FORMAT\nvec2 pos=(u_dem_size*(apos/8192.0*u_dem_scale_prev+u_dem_tl_prev)+1.5)/(u_dem_size+2.0);return u_exaggeration*texture(u_dem_prev,pos).r;\n#else\nfloat dd=1.0/(u_dem_size+2.0);vec4 r=tileUvToDemSample(apos/8192.0,u_dem_size,u_dem_scale_prev,u_dem_tl_prev);vec2 pos=r.xy;vec2 f=r.zw;float tl=texture(u_dem_prev,pos).r;float tr=texture(u_dem_prev,pos+vec2(dd,0)).r;float bl=texture(u_dem_prev,pos+vec2(0,dd)).r;float br=texture(u_dem_prev,pos+vec2(dd,dd)).r;return u_exaggeration*mix(mix(tl,tr,f.x),mix(bl,br,f.x),f.y);\n#endif\n}\n#ifdef TERRAIN_VERTEX_MORPHING\nfloat elevation(vec2 apos) {\n#ifdef ZERO_EXAGGERATION\nreturn 0.0;\n#endif\nfloat nextElevation=currentElevation(apos);float prevElevation=prevElevation(apos);return mix(prevElevation,nextElevation,u_dem_lerp);}\n#else\nfloat elevation(vec2 apos) {\n#ifdef ZERO_EXAGGERATION\nreturn 0.0;\n#endif\nreturn currentElevation(apos);}\n#endif\nvec4 fourSample(vec2 pos,vec2 off) {float tl=texture(u_dem,pos).r;float tr=texture(u_dem,pos+vec2(off.x,0.0)).r;float bl=texture(u_dem,pos+vec2(0.0,off.y)).r;float br=texture(u_dem,pos+off).r;return vec4(tl,tr,bl,br);}float flatElevation(vec2 pack) {vec2 apos=floor(pack/8.0);vec2 span=10.0*(pack-apos*8.0);vec2 uvTex=(apos-vec2(1.0,1.0))/8190.0;float size=u_dem_size+2.0;float dd=1.0/size;vec2 pos=u_dem_size*(uvTex*u_dem_scale+u_dem_tl)+1.0;vec2 f=fract(pos);pos=(pos-f+0.5)*dd;vec4 h=fourSample(pos,vec2(dd));float z=mix(mix(h.x,h.y,f.x),mix(h.z,h.w,f.x),f.y);vec2 w=floor(0.5*(span*u_meter_to_dem-1.0));vec2 d=dd*w;h=fourSample(pos-d,2.0*d+vec2(dd));vec4 diff=abs(h.xzxy-h.ywzw);vec2 slope=min(vec2(0.25),u_meter_to_dem*0.5*(diff.xz+diff.yw)/(2.0*w+vec2(1.0)));vec2 fix=slope*span;float base=z+max(fix.x,fix.y);return u_exaggeration*base;}float elevationFromUint16(float word) {return u_exaggeration*(word/ELEVATION_SCALE-ELEVATION_OFFSET);}\n#else\nfloat elevation(vec2 pos) { return 0.0; }\n#endif\n#ifdef DEPTH_OCCLUSION\nuniform highp sampler2D u_depth;uniform highp vec2 u_depth_size_inv;uniform highp vec2 u_depth_range_unpack;uniform highp float u_occluder_half_size;uniform highp float u_occlusion_depth_offset;\n#ifdef DEPTH_D24\nfloat unpack_depth(float depth) {return depth*u_depth_range_unpack.x+u_depth_range_unpack.y;}vec4 unpack_depth4(vec4 depth) {return depth*u_depth_range_unpack.x+vec4(u_depth_range_unpack.y);}\n#else\nhighp float unpack_depth_rgba(vec4 rgba_depth)\n{const highp vec4 bit_shift=vec4(1.0/(255.0*255.0*255.0),1.0/(255.0*255.0),1.0/255.0,1.0);return dot(rgba_depth,bit_shift)*2.0-1.0;}\n#endif\nbool isOccluded(vec4 frag) {vec3 coord=frag.xyz/frag.w;\n#ifdef DEPTH_D24\nfloat depth=unpack_depth(texture(u_depth,(coord.xy+1.0)*0.5).r);\n#else\nfloat depth=unpack_depth_rgba(texture(u_depth,(coord.xy+1.0)*0.5));\n#endif\nreturn coord.z+u_occlusion_depth_offset > depth;}highp vec4 getCornerDepths(vec2 coord) {highp vec3 df=vec3(u_occluder_half_size*u_depth_size_inv,0.0);highp vec2 uv=0.5*coord.xy+0.5;\n#ifdef DEPTH_D24\nhighp vec4 depth=vec4(\ntexture(u_depth,uv-df.xz).r,texture(u_depth,uv+df.xz).r,texture(u_depth,uv-df.zy).r,texture(u_depth,uv+df.zy).r\n);depth=unpack_depth4(depth);\n#else\nhighp vec4 depth=vec4(\nunpack_depth_rgba(texture(u_depth,uv-df.xz)),unpack_depth_rgba(texture(u_depth,uv+df.xz)),unpack_depth_rgba(texture(u_depth,uv-df.zy)),unpack_depth_rgba(texture(u_depth,uv+df.zy))\n);\n#endif\nreturn depth;}highp float occlusionFadeMultiSample(vec4 frag) {highp vec3 coord=frag.xyz/frag.w;highp vec2 uv=0.5*coord.xy+0.5;int NX=3;int NY=4;highp vec2 df=u_occluder_half_size*u_depth_size_inv;highp vec2 oneStep=2.0*u_occluder_half_size*u_depth_size_inv/vec2(NX-1,NY-1);highp float res=0.0;for (int y=0; y < NY;++y) {for (int x=0; x < NX;++x) {\n#ifdef DEPTH_D24\nhighp float depth=unpack_depth(texture(u_depth,uv-df+vec2(float(x)*oneStep.x,float(y)*oneStep.y)).r);\n#else\nhighp float depth=unpack_depth_rgba(texture(u_depth,uv-df+vec2(float(x)*oneStep.x,float(y)*oneStep.y)));\n#endif\nres+=1.0-clamp(300.0*(coord.z+u_occlusion_depth_offset-depth),0.0,1.0);}}res=clamp(2.0*res/float(NX*NY)-0.5,0.0,1.0);return res;}highp float occlusionFade(vec4 frag) {highp vec3 coord=frag.xyz/frag.w;highp vec4 depth=getCornerDepths(coord.xy);return dot(vec4(0.25),vec4(1.0)-clamp(300.0*(vec4(coord.z+u_occlusion_depth_offset)-depth),0.0,1.0));}\n#else\nbool isOccluded(vec4 frag) { return false; }highp float occlusionFade(vec4 frag) { return 1.0; }highp float occlusionFadeMultiSample(vec4 frag) { return 1.0; }\n#endif//DEPTH_OCCLUSION", Do = "#ifdef FOG\nuniform mediump vec4 u_fog_color;uniform mediump vec2 u_fog_range;uniform mediump float u_fog_horizon_blend;uniform mediump mat4 u_fog_matrix;out vec3 v_fog_pos;float fog_range(float depth) {return (depth-u_fog_range[0])/(u_fog_range[1]-u_fog_range[0]);}float fog_horizon_blending(vec3 camera_dir) {float t=max(0.0,camera_dir.z/u_fog_horizon_blend);return u_fog_color.a*exp(-3.0*t*t);}float fog_opacity(float t) {const float decay=6.0;float falloff=1.0-min(1.0,exp(-decay*t));falloff*=falloff*falloff;return u_fog_color.a*min(1.0,1.00747*falloff);}vec3 fog_position(vec3 pos) {return (u_fog_matrix*vec4(pos,1.0)).xyz;}vec3 fog_position(vec2 pos) {return fog_position(vec3(pos,0.0));}float fog(vec3 pos) {float depth=length(pos);float opacity=fog_opacity(fog_range(depth));return opacity*fog_horizon_blending(pos/depth);}\n#endif", Lo = "#ifdef FOG\nuniform mediump vec4 u_fog_color;uniform mediump vec2 u_fog_range;uniform mediump float u_fog_horizon_blend;uniform mediump vec2 u_fog_vertical_limit;uniform mediump float u_fog_temporal_offset;in vec3 v_fog_pos;uniform highp vec3 u_frustum_tl;uniform highp vec3 u_frustum_tr;uniform highp vec3 u_frustum_br;uniform highp vec3 u_frustum_bl;uniform highp vec3 u_globe_pos;uniform highp float u_globe_radius;uniform highp vec2 u_viewport;uniform float u_globe_transition;uniform int u_is_globe;float fog_range(float depth) {return (depth-u_fog_range[0])/(u_fog_range[1]-u_fog_range[0]);}float fog_horizon_blending(vec3 camera_dir) {float t=max(0.0,camera_dir.z/u_fog_horizon_blend);return u_fog_color.a*exp(-3.0*t*t);}float fog_opacity(float t) {const float decay=6.0;float falloff=1.0-min(1.0,exp(-decay*t));falloff*=falloff*falloff;return u_fog_color.a*min(1.0,1.00747*falloff);}float globe_glow_progress() {highp vec2 uv=gl_FragCoord.xy/u_viewport;highp vec3 ray_dir=mix(\nmix(u_frustum_tl,u_frustum_tr,uv.x),mix(u_frustum_bl,u_frustum_br,uv.x),1.0-uv.y);highp vec3 dir=normalize(ray_dir);highp vec3 closest_point=dot(u_globe_pos,dir)*dir;highp float sdf=length(closest_point-u_globe_pos)/u_globe_radius;return sdf+PI*0.5;}float fog_opacity(vec3 pos) {float depth=length(pos);return fog_opacity(fog_range(depth));}vec3 fog_apply(vec3 color,vec3 pos,float opacity_limit) {float depth=length(pos);float opacity;if (u_is_globe==1) {float glow_progress=globe_glow_progress();float t=mix(glow_progress,depth,u_globe_transition);opacity=fog_opacity(fog_range(t));} else {opacity=fog_opacity(fog_range(depth));opacity*=fog_horizon_blending(pos/depth);}return mix(color,u_fog_color.rgb,min(opacity,opacity_limit));}vec3 fog_apply(vec3 color,vec3 pos) {return fog_apply(color,pos,1.0);}vec4 fog_apply_from_vert(vec4 color,float fog_opac) {float alpha=EPSILON+color.a;color.rgb=mix(color.rgb/alpha,u_fog_color.rgb,fog_opac)*alpha;return color;}vec3 fog_apply_sky_gradient(vec3 camera_ray,vec3 sky_color) {float horizon_blend=fog_horizon_blending(normalize(camera_ray));return mix(sky_color,u_fog_color.rgb,horizon_blend);}vec4 fog_apply_premultiplied(vec4 color,vec3 pos) {float alpha=EPSILON+color.a;color.rgb=fog_apply(color.rgb/alpha,pos)*alpha;return color;}vec4 fog_apply_premultiplied(vec4 color,vec3 pos,float heightMeters) {float verticalProgress=(u_fog_vertical_limit.x > 0.0 || u_fog_vertical_limit.y > 0.0) ? smoothstep(u_fog_vertical_limit.x,u_fog_vertical_limit.y,heightMeters) : 0.0;float opacityLimit=1.0-smoothstep(0.9,1.0,fog_opacity(pos));return mix(fog_apply_premultiplied(color,pos),color,min(verticalProgress,opacityLimit));}vec3 fog_dither(vec3 color) {return color;}vec4 fog_dither(vec4 color) {return vec4(fog_dither(color.rgb),color.a);}\n#endif", Ao = "#ifdef RASTER_ARRAY\nuniform highp sampler2D u_image0;uniform sampler2D u_image1;const vec4 NODATA=vec4(1);ivec4 _raTexLinearCoord(highp vec2 texCoord,highp vec2 texResolution,out highp vec2 fxy) {texCoord=texCoord*texResolution-0.5;fxy=fract(texCoord);texCoord-=fxy;return ivec4(texCoord.xxyy+vec2(1.5,0.5).xyxy);}vec2 _raTexLinearMix(highp vec2 fxy,highp vec4 colorMix,highp float colorOffset,highp vec4 t00,highp vec4 t10,highp vec4 t01,highp vec4 t11) {vec2 c00=t00==NODATA ? vec2(0) : vec2(colorOffset+dot(t00,colorMix),1);vec2 c10=t10==NODATA ? vec2(0) : vec2(colorOffset+dot(t10,colorMix),1);vec2 c01=t01==NODATA ? vec2(0) : vec2(colorOffset+dot(t01,colorMix),1);vec2 c11=t11==NODATA ? vec2(0) : vec2(colorOffset+dot(t11,colorMix),1);return mix(mix(c01,c11,fxy.x),mix(c00,c10,fxy.x),fxy.y);}vec2 raTexture2D_image0_linear(highp vec2 texCoord,highp vec2 texResolution,highp vec4 colorMix,highp float colorOffset) {vec2 fxy;ivec4 c=_raTexLinearCoord(texCoord,texResolution,fxy);return _raTexLinearMix(fxy,colorMix,colorOffset,texelFetch(u_image0,c.yz,0),texelFetch(u_image0,c.xz,0),texelFetch(u_image0,c.yw,0),texelFetch(u_image0,c.xw,0)\n);}vec2 raTexture2D_image1_linear(highp vec2 texCoord,highp vec2 texResolution,highp vec4 colorMix,highp float colorOffset) {vec2 fxy;ivec4 c=_raTexLinearCoord(texCoord,texResolution,fxy);return _raTexLinearMix(fxy,colorMix,colorOffset,texelFetch(u_image1,c.yz,0),texelFetch(u_image1,c.xz,0),texelFetch(u_image1,c.yw,0),texelFetch(u_image1,c.xw,0)\n);}vec2 raTexture2D_image0_nearest(highp vec2 texCoord,highp vec2 texResolution,highp vec4 colorMix,highp float colorOffset) {vec4 t=texelFetch(u_image0,ivec2(texCoord*texResolution),0);return t==NODATA ? vec2(0) : vec2(colorOffset+dot(t,colorMix),1);}vec2 raTexture2D_image1_nearest(highp vec2 texCoord,highp vec2 texResolution,highp vec4 colorMix,highp float colorOffset) {vec4 t=texelFetch(u_image1,ivec2(texCoord*texResolution),0);return t==NODATA ? vec2(0) : vec2(colorOffset+dot(t,colorMix),1);}\n#endif", zo = "#ifdef RASTER_ARRAY\nuniform sampler2D u_velocity;uniform mediump vec2 u_velocity_res;uniform mediump float u_max_speed;const vec4 NO_DATA=vec4(1);const vec2 INVALID_VELOCITY=vec2(-1);uniform highp vec2 u_uv_offset;uniform highp float u_data_offset;uniform highp vec2 u_data_scale;ivec4 rasterArrayLinearCoord(highp vec2 texCoord,highp vec2 texResolution,out highp vec2 fxy) {texCoord=texCoord*texResolution-0.5;fxy=fract(texCoord);texCoord-=fxy;return ivec4(texCoord.xxyy+vec2(1.5,0.5).xyxy);}highp vec2 lookup_velocity(highp vec2 uv) {uv=u_uv_offset.x+u_uv_offset.y*uv;highp vec2 fxy;ivec4 c=rasterArrayLinearCoord(uv,u_velocity_res,fxy);highp vec4 tl=texelFetch(u_velocity,c.yz,0);highp vec4 tr=texelFetch(u_velocity,c.xz,0);highp vec4 bl=texelFetch(u_velocity,c.yw,0);highp vec4 br=texelFetch(u_velocity,c.xw,0);if (tl==NO_DATA) {return INVALID_VELOCITY;}if (tr==NO_DATA) {return INVALID_VELOCITY;}if (bl==NO_DATA) {return INVALID_VELOCITY;}if (br==NO_DATA) {return INVALID_VELOCITY;}highp vec4 t=mix(mix(bl,br,fxy.x),mix(tl,tr,fxy.x),fxy.y);highp vec2 velocity=u_data_offset+vec2(dot(t.rg,u_data_scale),dot(t.ba,u_data_scale));velocity.y=-velocity.y;velocity/=max(u_max_speed,length(velocity));return velocity;}\n#endif\nuniform highp float u_particle_pos_scale;uniform highp vec2 u_particle_pos_offset;highp vec4 pack_pos_to_rgba(highp vec2 p) {highp vec2 v=(p+u_particle_pos_offset)/u_particle_pos_scale;highp vec4 r=vec4(v.x,fract(v.x*255.0),v.y,fract(v.y*255.0));return vec4(r.x-r.y/255.0,r.y,r.z-r.w/255.0,r.w);}highp vec2 unpack_pos_from_rgba(highp vec4 v) {v=floor(v*255.0+0.5)/255.0;highp vec2 p=vec2(v.x+(v.y/255.0),v.z+(v.w/255.0));return u_particle_pos_scale*p-u_particle_pos_offset;}", Po = "#ifdef RENDER_SHADOWS\nuniform mediump vec3 u_shadow_direction;uniform highp vec3 u_shadow_normal_offset;vec3 shadow_normal_offset(vec3 normal) {float tileInMeters=u_shadow_normal_offset[0];vec3 n=vec3(-normal.xy,tileInMeters*normal.z);float dotScale=min(1.0-dot(normal,u_shadow_direction),1.0)*0.5+0.5;return n*dotScale;}vec3 shadow_normal_offset_model(vec3 normal) {vec3 transformed_normal=vec3(-normal.xy,normal.z);float NDotL=dot(normalize(transformed_normal),u_shadow_direction);float dotScale=min(1.0-NDotL,1.0)*0.5+0.5;return normal*dotScale;}float shadow_normal_offset_multiplier0() {return u_shadow_normal_offset[1];}float shadow_normal_offset_multiplier1() {return u_shadow_normal_offset[2];}\n#endif//RENDER_SHADOWS", Mo = "#ifdef RENDER_SHADOWS\n#ifdef DEPTH_TEXTURE\nuniform highp sampler2D u_shadowmap_0;uniform highp sampler2D u_shadowmap_1;\n#else\nuniform sampler2D u_shadowmap_0;uniform sampler2D u_shadowmap_1;\n#endif\nuniform float u_shadow_intensity;uniform float u_shadow_map_resolution;uniform float u_shadow_texel_size;uniform highp vec3 u_shadow_normal_offset;uniform vec2 u_fade_range;uniform mediump vec3 u_shadow_direction;uniform highp vec3 u_shadow_bias;highp float shadow_sample_1(highp vec2 uv,highp float compare) {highp float shadow_depth;\n#ifdef DEPTH_TEXTURE\nshadow_depth=texture(u_shadowmap_1,uv).r;\n#else\nshadow_depth=unpack_depth(texture(u_shadowmap_1,uv))*0.5+0.5;\n#endif\nreturn step(shadow_depth,compare);}highp float shadow_sample_0(highp vec2 uv,highp float compare) {highp float shadow_depth;\n#ifdef DEPTH_TEXTURE\nshadow_depth=texture(u_shadowmap_0,uv).r;\n#else\nshadow_depth=unpack_depth(texture(u_shadowmap_0,uv))*0.5+0.5;\n#endif\nreturn step(shadow_depth,compare);}float shadow_occlusion_1(highp vec4 pos,highp float bias) {highp vec2 uv=pos.xy;return shadow_sample_1(uv,pos.z-bias);}float shadow_occlusion_0(highp vec4 pos,highp float bias) {highp float compare0=pos.z-bias;\n#ifdef TEXTURE_GATHER\nhighp vec2 uv=pos.xy;highp vec4 samples=textureGather(u_shadowmap_0,uv,0);lowp vec4 stepSamples=step(samples,vec4(compare0));\n#else\nhighp vec2 uv00=pos.xy-vec2(0.5*u_shadow_texel_size);highp vec2 uv10=uv00+vec2(u_shadow_texel_size,0.0);highp vec2 uv01=uv00+vec2(0.0,u_shadow_texel_size);highp vec2 uv11=uv01+vec2(u_shadow_texel_size,0.0);lowp vec4 stepSamples=vec4(\nshadow_sample_0(uv01,compare0),shadow_sample_0(uv11,compare0),shadow_sample_0(uv10,compare0),shadow_sample_0(uv00,compare0)\n);\n#endif\nvec2 f=fract(pos.xy*u_shadow_map_resolution-vec2(0.5));lowp vec2 lerpx=mix(stepSamples.wx,stepSamples.zy,f.xx);return mix(lerpx.x,lerpx.y,f.y);}float shadow_occlusion(highp vec4 light_view_pos0,highp vec4 light_view_pos1,float view_depth,highp float bias) {\n#ifdef SHADOWS_SINGLE_CASCADE\nlight_view_pos0.xyz/=light_view_pos0.w;vec2 abs_bounds=abs(light_view_pos0.xy);if (abs_bounds.x >=1.0 || abs_bounds.y >=1.0) {return 0.0;}light_view_pos0.xyz=light_view_pos0.xyz*0.5+0.5;return shadow_occlusion_0(light_view_pos0,bias);\n#else\nlight_view_pos0.xyz/=light_view_pos0.w;light_view_pos1.xyz/=light_view_pos1.w;vec4 uv=vec4(light_view_pos0.xy,light_view_pos1.xy);vec4 abs_bounds=abs(uv);if (abs_bounds.x < 1.0 && abs_bounds.y < 1.0) {light_view_pos0.xyz=light_view_pos0.xyz*0.5+0.5;return shadow_occlusion_0(light_view_pos0,bias);}if (abs_bounds.z >=1.0 || abs_bounds.w >=1.0) {return 0.0;}light_view_pos1.xyz=light_view_pos1.xyz*0.5+0.5;float occlusion1=shadow_occlusion_1(light_view_pos1,bias);return mix(occlusion1,0.0,smoothstep(u_fade_range.x,u_fade_range.y,view_depth));\n#endif\n}highp float calculate_shadow_bias(float NDotL) {\n#ifdef NORMAL_OFFSET\nreturn 0.5*u_shadow_bias.x;\n#else\nreturn 0.5*(u_shadow_bias.x+clamp(u_shadow_bias.y*tan(acos(NDotL)),0.0,u_shadow_bias.z));\n#endif\n}float shadowed_light_factor_normal(vec3 N,highp vec4 light_view_pos0,highp vec4 light_view_pos1,float view_depth) {float NDotL=dot(N,u_shadow_direction);float bias=calculate_shadow_bias(NDotL);float occlusion=shadow_occlusion(light_view_pos0,light_view_pos1,view_depth,bias);return mix(0.0,(1.0-(u_shadow_intensity*occlusion))*NDotL,step(0.0,NDotL));}float shadowed_light_factor_normal_opacity(vec3 N,highp vec4 light_view_pos0,highp vec4 light_view_pos1,float view_depth,float shadow_opacity) {float NDotL=dot(N,u_shadow_direction);float bias=calculate_shadow_bias(NDotL);float occlusion=shadow_occlusion(light_view_pos0,light_view_pos1,view_depth,bias)*shadow_opacity;return mix(0.0,(1.0-(u_shadow_intensity*occlusion))*NDotL,step(0.0,NDotL));}float shadowed_light_factor_normal_unbiased(vec3 N,highp vec4 light_view_pos0,highp vec4 light_view_pos1,float view_depth) {float NDotL=dot(N,u_shadow_direction);float bias=0.0;float occlusion=shadow_occlusion(light_view_pos0,light_view_pos1,view_depth,bias);return mix(0.0,(1.0-(u_shadow_intensity*occlusion))*NDotL,step(0.0,NDotL));}highp vec2 compute_receiver_plane_depth_bias(highp vec3 pos_dx,highp vec3 pos_dy)\n{highp vec2 biasUV=vec2(\npos_dy.y*pos_dx.z-pos_dx.y*pos_dy.z,pos_dx.x*pos_dy.z-pos_dy.x*pos_dx.z);biasUV*=1.0/((pos_dx.x*pos_dy.y)-(pos_dx.y*pos_dy.x));return biasUV;}float shadowed_light_factor_plane_bias(highp vec4 light_view_pos0,highp vec4 light_view_pos1,float view_depth) {highp vec3 light_view_pos0_xyz=light_view_pos0.xyz/light_view_pos0.w*0.5+0.5;highp vec3 light_view_pos0_ddx=dFdx(light_view_pos0_xyz);highp vec3 light_view_pos0_ddy=dFdy(light_view_pos0_xyz);highp vec2 plane_depth_bias=compute_receiver_plane_depth_bias(light_view_pos0_ddx,light_view_pos0_ddy);highp float bias=dot(vec2(u_shadow_texel_size,u_shadow_texel_size),plane_depth_bias)+0.0001;float occlusion=shadow_occlusion(light_view_pos0,light_view_pos1,view_depth,bias);return 1.0-(u_shadow_intensity*occlusion);}float shadowed_light_factor(highp vec4 light_view_pos0,highp vec4 light_view_pos1,float view_depth) {float bias=0.0;float occlusion=shadow_occlusion(light_view_pos0,light_view_pos1,view_depth,bias);return 1.0-(u_shadow_intensity*occlusion);}float shadow_occlusion(float ndotl,highp vec4 light_view_pos0,highp vec4 light_view_pos1,float view_depth) {float bias=calculate_shadow_bias(ndotl);return shadow_occlusion(light_view_pos0,light_view_pos1,view_depth,bias);}\n#endif";
        const Oo = [];
        jo(Eo, Oo), jo(Co, Oo), jo(So, Oo);
        const Fo = {
            "_prelude_fog.vertex.glsl": Do,
            "_prelude_terrain.vertex.glsl": Ro,
            "_prelude_shadow.vertex.glsl": Po,
            "_prelude_fog.fragment.glsl": Lo,
            "_prelude_shadow.fragment.glsl": Mo,
            "_prelude_lighting.glsl": "\n#ifdef LIGHTING_3D_MODE\nuniform mediump vec3 u_lighting_ambient_color;uniform mediump vec3 u_lighting_directional_dir;uniform mediump vec3 u_lighting_directional_color;uniform mediump vec3 u_ground_radiance;float calculate_ambient_directional_factor(vec3 normal) {float NdotL=dot(normal,u_lighting_directional_dir);const float factor_reduction_max=0.3;float dir_luminance=dot(u_lighting_directional_color,vec3(0.2126,0.7152,0.0722));float directional_factor_min=1.0-factor_reduction_max*min(dir_luminance,1.0);float ambient_directional_factor=mix(directional_factor_min,1.0,min((NdotL+1.0),1.0));const float vertical_factor_min=0.92;float vertical_factor=mix(vertical_factor_min,1.0,normal.z*0.5+0.5);return vertical_factor*ambient_directional_factor;}vec3 linearProduct(vec3 srgbIn,vec3 k) {return srgbIn*pow(k,vec3(1./2.2));}vec3 apply_lighting(vec3 color,vec3 normal,float dir_factor) {float ambient_directional_factor=calculate_ambient_directional_factor(normal);vec3 ambient_contrib=ambient_directional_factor*u_lighting_ambient_color;vec3 directional_contrib=u_lighting_directional_color*dir_factor;return linearProduct(color,ambient_contrib+directional_contrib);}vec4 apply_lighting(vec4 color,vec3 normal,float dir_factor) {return vec4(apply_lighting(color.rgb,normal,dir_factor),color.a);}vec3 apply_lighting(vec3 color,vec3 normal) {float dir_factor=max(dot(normal,u_lighting_directional_dir),0.0);return apply_lighting(color.rgb,normal,dir_factor);}vec4 apply_lighting(vec4 color,vec3 normal) {float dir_factor=max(dot(normal,u_lighting_directional_dir),0.0);return vec4(apply_lighting(color.rgb,normal,dir_factor),color.a);}vec3 apply_lighting_ground(vec3 color) {return color*u_ground_radiance;}vec4 apply_lighting_ground(vec4 color) {return vec4(apply_lighting_ground(color.rgb),color.a);}float calculate_NdotL(vec3 normal) {const float ext=0.70710678118;return (clamp(dot(normal,u_lighting_directional_dir),-ext,1.0)+ext)/(1.0+ext);}vec4 apply_lighting_with_emission_ground(vec4 color,float emissive_strength) {return mix(apply_lighting_ground(color),color,emissive_strength);}vec3 compute_flood_lighting(vec3 flood_light_color,float fully_occluded_factor,float occlusion,vec3 ground_shadow_factor) {vec3 fully_occluded_color=flood_light_color*mix(ground_shadow_factor,vec3(1.0),fully_occluded_factor);float occlusion_ramp=smoothstep(0.0,0.2,1.0-occlusion);return mix(fully_occluded_color,flood_light_color,occlusion_ramp);}vec3 compute_emissive_draped(vec3 unlit_color,float fully_occluded_factor,float occlusion,vec3 ground_shadow_factor) {vec3 fully_occluded_color=unlit_color*mix(ground_shadow_factor,vec3(1.0),fully_occluded_factor);return mix(fully_occluded_color,unlit_color,1.0-occlusion);}\n#endif//LIGHTING_3D_MODE",
            "_prelude_raster_array.glsl": Ao,
            "_prelude_raster_particle.glsl": zo
        }, ko = {};
        Go("", Ro), Go(Lo, Do), Go(Mo, Po), Go(Ao, ""), Go(zo, "");
        const Bo = Go(So, Co), No = Eo;
        var Uo = {
            background: Go('#include "_prelude_fog.fragment.glsl"\n#include "_prelude_lighting.glsl"\nuniform vec4 u_color;uniform float u_opacity;\n#ifdef LIGHTING_3D_MODE\nin vec4 v_color;\n#endif\nvoid main() {vec4 out_color;\n#ifdef LIGHTING_3D_MODE\nout_color=v_color;\n#else\nout_color=u_color;\n#endif\n#ifdef FOG\nout_color=fog_dither(fog_apply_premultiplied(out_color,v_fog_pos));\n#endif\nglFragColor=out_color*u_opacity;\n#ifdef OVERDRAW_INSPECTOR\nglFragColor=vec4(1.0);\n#endif\nHANDLE_WIREFRAME_DEBUG;}', '#include "_prelude_fog.vertex.glsl"\n#include "_prelude_lighting.glsl"\nin vec2 a_pos;uniform mat4 u_matrix;\n#ifdef LIGHTING_3D_MODE\nuniform mediump vec4 u_color;out vec4 v_color;uniform float u_emissive_strength;\n#endif\nvoid main() {gl_Position=u_matrix*vec4(a_pos,0,1);\n#ifdef LIGHTING_3D_MODE\nv_color=apply_lighting_with_emission_ground(u_color,u_emissive_strength);\n#endif\n#ifdef FOG\nv_fog_pos=fog_position(a_pos);\n#endif\n}'),
            backgroundPattern: Go('#include "_prelude_fog.fragment.glsl"\n#include "_prelude_lighting.glsl"\nuniform vec2 u_pattern_tl;uniform vec2 u_pattern_br;uniform vec2 u_texsize;uniform float u_opacity;uniform float u_emissive_strength;uniform sampler2D u_image;in highp vec2 v_pos;void main() {highp vec2 imagecoord=mod(v_pos,1.0);highp vec2 pos=mix(u_pattern_tl/u_texsize,u_pattern_br/u_texsize,imagecoord);vec4 out_color=textureLodCustom(u_image,pos,v_pos);\n#ifdef LIGHTING_3D_MODE\nout_color=apply_lighting_with_emission_ground(out_color,u_emissive_strength);\n#endif\n#ifdef FOG\nout_color=fog_dither(fog_apply_premultiplied(out_color,v_fog_pos));\n#endif\nglFragColor=out_color*u_opacity;\n#ifdef OVERDRAW_INSPECTOR\nglFragColor=vec4(1.0);\n#endif\nHANDLE_WIREFRAME_DEBUG;}', '#include "_prelude_fog.vertex.glsl"\nuniform mat4 u_matrix;uniform vec2 u_pattern_size;uniform vec2 u_pixel_coord_upper;uniform vec2 u_pixel_coord_lower;uniform vec2 u_pattern_units_to_pixels;in vec2 a_pos;out highp vec2 v_pos;void main() {gl_Position=u_matrix*vec4(a_pos,0,1);v_pos=get_pattern_pos(u_pixel_coord_upper,u_pixel_coord_lower,u_pattern_size,u_pattern_units_to_pixels,a_pos);\n#ifdef FOG\nv_fog_pos=fog_position(a_pos);\n#endif\n}'),
            circle: Go('#include "_prelude_fog.fragment.glsl"\n#include "_prelude_lighting.glsl"\nin vec3 v_data;in float v_visibility;\n#pragma mapbox: define highp vec4 color\n#pragma mapbox: define mediump float radius\n#pragma mapbox: define lowp float blur\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define highp vec4 stroke_color\n#pragma mapbox: define mediump float stroke_width\n#pragma mapbox: define lowp float stroke_opacity\nuniform float u_emissive_strength;void main() {\n#pragma mapbox: initialize highp vec4 color\n#pragma mapbox: initialize mediump float radius\n#pragma mapbox: initialize lowp float blur\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize highp vec4 stroke_color\n#pragma mapbox: initialize mediump float stroke_width\n#pragma mapbox: initialize lowp float stroke_opacity\nvec2 extrude=v_data.xy;float blur_positive=blur < 0.0 ? 0.0 : 1.0;lowp float antialiasblur=v_data.z;float extrude_length=length(extrude)+antialiasblur*(1.0-blur_positive);float antialiased_blur=-max(abs(blur),antialiasblur);float antialiase_blur_opacity=smoothstep(0.0,antialiasblur,extrude_length-1.0);float opacity_t=blur_positive==1.0 ? \nsmoothstep(0.0,-antialiased_blur,1.0-extrude_length) : \nsmoothstep(antialiased_blur,0.0,extrude_length-1.0)-antialiase_blur_opacity;float color_t=stroke_width < 0.01 ? 0.0 : smoothstep(\nantialiased_blur,0.0,extrude_length-radius/(radius+stroke_width)\n);vec4 out_color=mix(color*opacity,stroke_color*stroke_opacity,color_t);\n#ifdef LIGHTING_3D_MODE\nout_color=apply_lighting_with_emission_ground(out_color,u_emissive_strength);\n#endif\n#ifdef FOG\nout_color=fog_apply_premultiplied(out_color,v_fog_pos);\n#endif\nglFragColor=out_color*(v_visibility*opacity_t);\n#ifdef OVERDRAW_INSPECTOR\nglFragColor=vec4(1.0);\n#endif\n}', '#include "_prelude_fog.vertex.glsl"\n#include "_prelude_terrain.vertex.glsl"\n#define NUM_VISIBILITY_RINGS 2\n#define INV_SQRT2 0.70710678\n#define ELEVATION_BIAS 0.0001\n#define NUM_SAMPLES_PER_RING 16\nuniform mat4 u_matrix;uniform mat2 u_extrude_scale;uniform lowp float u_device_pixel_ratio;uniform highp float u_camera_to_center_distance;in vec2 a_pos;\n#ifdef PROJECTION_GLOBE_VIEW\nin vec3 a_pos_3;in vec3 a_pos_normal_3;uniform mat4 u_inv_rot_matrix;uniform vec2 u_merc_center;uniform vec3 u_tile_id;uniform float u_zoom_transition;uniform vec3 u_up_dir;\n#endif\n#ifdef ELEVATED_ROADS\nin float a_circle_z_offset;\n#endif\nout vec3 v_data;out float v_visibility;\n#pragma mapbox: define highp vec4 color\n#pragma mapbox: define mediump float radius\n#pragma mapbox: define lowp float blur\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define highp vec4 stroke_color\n#pragma mapbox: define mediump float stroke_width\n#pragma mapbox: define lowp float stroke_opacity\nvec2 calc_offset(vec2 extrusion,float radius,float stroke_width, float view_scale) {return extrusion*(radius+stroke_width)*u_extrude_scale*view_scale;}float cantilevered_elevation(vec2 pos,float radius,float stroke_width,float view_scale) {vec2 c1=pos+calc_offset(vec2(-1,-1),radius,stroke_width,view_scale);vec2 c2=pos+calc_offset(vec2(1,-1),radius,stroke_width,view_scale);vec2 c3=pos+calc_offset(vec2(1,1),radius,stroke_width,view_scale);vec2 c4=pos+calc_offset(vec2(-1,1),radius,stroke_width,view_scale);float h1=elevation(c1)+ELEVATION_BIAS;float h2=elevation(c2)+ELEVATION_BIAS;float h3=elevation(c3)+ELEVATION_BIAS;float h4=elevation(c4)+ELEVATION_BIAS;return max(h4,max(h3,max(h1,h2)));}float circle_elevation(vec2 pos) {\n#if defined(TERRAIN)\nreturn elevation(pos)+ELEVATION_BIAS;\n#else\nreturn 0.0;\n#endif\n}vec4 project_vertex(vec2 extrusion,vec4 world_center,vec4 projected_center,float radius,float stroke_width, float view_scale,mat3 surface_vectors) {vec2 sample_offset=calc_offset(extrusion,radius,stroke_width,view_scale);\n#ifdef PITCH_WITH_MAP\n#ifdef PROJECTION_GLOBE_VIEW\nreturn u_matrix*( world_center+vec4(sample_offset.x*surface_vectors[0]+sample_offset.y*surface_vectors[1],0) );\n#else\nreturn u_matrix*( world_center+vec4(sample_offset,0,0) );\n#endif\n#else\nreturn projected_center+vec4(sample_offset,0,0);\n#endif\n}float get_sample_step() {\n#ifdef PITCH_WITH_MAP\nreturn 2.0*PI/float(NUM_SAMPLES_PER_RING);\n#else\nreturn PI/float(NUM_SAMPLES_PER_RING);\n#endif\n}void main(void) {\n#pragma mapbox: initialize highp vec4 color\n#pragma mapbox: initialize mediump float radius\n#pragma mapbox: initialize lowp float blur\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize highp vec4 stroke_color\n#pragma mapbox: initialize mediump float stroke_width\n#pragma mapbox: initialize lowp float stroke_opacity\nvec2 extrude=vec2(mod(a_pos,2.0)*2.0-1.0);vec2 circle_center=floor(a_pos*0.5);vec4 world_center;mat3 surface_vectors;\n#ifdef PROJECTION_GLOBE_VIEW\nvec3 pos_normal_3=a_pos_normal_3/16384.0;surface_vectors=globe_mercator_surface_vectors(pos_normal_3,u_up_dir,u_zoom_transition);vec3 surface_extrusion=extrude.x*surface_vectors[0]+extrude.y*surface_vectors[1];vec3 globe_elevation=elevationVector(circle_center)*circle_elevation(circle_center);vec3 globe_pos=a_pos_3+surface_extrusion+globe_elevation;vec3 mercator_elevation=u_up_dir*u_tile_up_scale*circle_elevation(circle_center);vec3 merc_pos=mercator_tile_position(u_inv_rot_matrix,circle_center,u_tile_id,u_merc_center)+surface_extrusion+mercator_elevation;vec3 pos=mix_globe_mercator(globe_pos,merc_pos,u_zoom_transition);world_center=vec4(pos,1);\n#else \nsurface_vectors=mat3(1.0);float height=circle_elevation(circle_center);world_center=vec4(circle_center,height,1);\n#endif\n#ifdef ELEVATED_ROADS\nworld_center.z+=a_circle_z_offset+ELEVATION_BIAS;\n#endif\nvec4 projected_center=u_matrix*world_center;float view_scale=0.0;\n#ifdef PITCH_WITH_MAP\n#ifdef SCALE_WITH_MAP\nview_scale=1.0;\n#else\nview_scale=projected_center.w/u_camera_to_center_distance;\n#endif\n#else\n#ifdef SCALE_WITH_MAP\nview_scale=u_camera_to_center_distance;\n#else\nview_scale=projected_center.w;\n#endif\n#endif\ngl_Position=project_vertex(extrude,world_center,projected_center,radius,stroke_width,view_scale,surface_vectors);float visibility=0.0;\n#ifdef TERRAIN\nfloat step=get_sample_step();vec4 occlusion_world_center;vec4 occlusion_projected_center;\n#ifdef PITCH_WITH_MAP\nfloat cantilevered_height=cantilevered_elevation(circle_center,radius,stroke_width,view_scale);occlusion_world_center=vec4(circle_center,cantilevered_height,1);occlusion_projected_center=u_matrix*occlusion_world_center;\n#else\nocclusion_world_center=world_center;occlusion_projected_center=projected_center;\n#endif\nfor(int ring=0; ring < NUM_VISIBILITY_RINGS; ring++) {float scale=(float(ring)+1.0)/float(NUM_VISIBILITY_RINGS);for(int i=0; i < NUM_SAMPLES_PER_RING; i++) {vec2 extrusion=vec2(cos(step*float(i)),-sin(step*float(i)))*scale;vec4 frag_pos=project_vertex(extrusion,occlusion_world_center,occlusion_projected_center,radius,stroke_width,view_scale,surface_vectors);visibility+=float(!isOccluded(frag_pos));}}visibility/=float(NUM_VISIBILITY_RINGS)*float(NUM_SAMPLES_PER_RING);\n#else\nvisibility=1.0;\n#endif\n#ifdef PROJECTION_GLOBE_VIEW\nvisibility=1.0;\n#endif\nv_visibility=visibility;lowp float antialiasblur=1.0/u_device_pixel_ratio/(radius+stroke_width);v_data=vec3(extrude.x,extrude.y,antialiasblur);\n#ifdef FOG\nv_fog_pos=fog_position(world_center.xyz);\n#endif\n}'),
            clippingMask: Go("void main() {glFragColor=vec4(1.0);}", "in vec2 a_pos;uniform mat4 u_matrix;void main() {gl_Position=u_matrix*vec4(a_pos,0,1);}"),
            heatmap: Go('#include "_prelude_fog.fragment.glsl"\nuniform highp float u_intensity;in vec2 v_extrude;\n#pragma mapbox: define highp float weight\n#define GAUSS_COEF 0.3989422804014327\nvoid main() {\n#pragma mapbox: initialize highp float weight\nfloat d=-0.5*3.0*3.0*dot(v_extrude,v_extrude);float val=weight*u_intensity*GAUSS_COEF*exp(d);glFragColor=vec4(val,1.0,1.0,1.0);\n#ifdef FOG\nif (u_is_globe==0) {glFragColor.r*=pow(1.0-fog_opacity(v_fog_pos),2.0);}\n#endif\n#ifdef OVERDRAW_INSPECTOR\nglFragColor=vec4(1.0);\n#endif\nHANDLE_WIREFRAME_DEBUG;}', '#include "_prelude_terrain.vertex.glsl"\n#include "_prelude_fog.vertex.glsl"\nuniform mat4 u_matrix;uniform float u_extrude_scale;uniform float u_opacity;uniform float u_intensity;in vec2 a_pos;\n#ifdef PROJECTION_GLOBE_VIEW\nin vec3 a_pos_3;in vec3 a_pos_normal_3;uniform mat4 u_inv_rot_matrix;uniform vec2 u_merc_center;uniform vec3 u_tile_id;uniform float u_zoom_transition;uniform vec3 u_up_dir;\n#endif\nout vec2 v_extrude;\n#pragma mapbox: define highp float weight\n#pragma mapbox: define mediump float radius\nconst highp float ZERO=1.0/255.0/16.0;\n#define GAUSS_COEF 0.3989422804014327\nvoid main(void) {\n#pragma mapbox: initialize highp float weight\n#pragma mapbox: initialize mediump float radius\nvec2 unscaled_extrude=vec2(mod(a_pos,2.0)*2.0-1.0);float S=sqrt(-2.0*log(ZERO/weight/u_intensity/GAUSS_COEF))/3.0;v_extrude=S*unscaled_extrude;vec2 extrude=v_extrude*radius*u_extrude_scale;vec2 tilePos=floor(a_pos*0.5);vec3 pos;\n#ifdef PROJECTION_GLOBE_VIEW\nvec3 pos_normal_3=a_pos_normal_3/16384.0;mat3 surface_vectors=globe_mercator_surface_vectors(pos_normal_3,u_up_dir,u_zoom_transition);vec3 surface_extrusion=extrude.x*surface_vectors[0]+extrude.y*surface_vectors[1];vec3 globe_elevation=elevationVector(tilePos)*elevation(tilePos);vec3 globe_pos=a_pos_3+surface_extrusion+globe_elevation;vec3 mercator_elevation=u_up_dir*u_tile_up_scale*elevation(tilePos);vec3 merc_pos=mercator_tile_position(u_inv_rot_matrix,tilePos,u_tile_id,u_merc_center)+surface_extrusion+mercator_elevation;pos=mix_globe_mercator(globe_pos,merc_pos,u_zoom_transition);\n#else\npos=vec3(tilePos+extrude,elevation(tilePos));\n#endif\ngl_Position=u_matrix*vec4(pos,1);\n#ifdef FOG\nv_fog_pos=fog_position(pos);\n#endif\n}'),
            heatmapTexture: Go("uniform sampler2D u_image;uniform sampler2D u_color_ramp;uniform float u_opacity;in vec2 v_pos;void main() {float t=texture(u_image,v_pos).r;vec4 color=texture(u_color_ramp,vec2(t,0.5));glFragColor=color*u_opacity;\n#ifdef OVERDRAW_INSPECTOR\nglFragColor=vec4(0.0);\n#endif\nHANDLE_WIREFRAME_DEBUG;}", "in vec2 a_pos;out vec2 v_pos;void main() {gl_Position=vec4(a_pos,0,1);v_pos=a_pos*0.5+0.5;}"),
            collisionBox: Go("in float v_placed;in float v_notUsed;void main() {vec4 red =vec4(1.0,0.0,0.0,1.0);vec4 blue=vec4(0.0,0.0,1.0,0.5);glFragColor =mix(red,blue,step(0.5,v_placed))*0.5;glFragColor*=mix(1.0,0.1,step(0.5,v_notUsed));}", '#include "_prelude_terrain.vertex.glsl"\nin vec3 a_pos;in vec2 a_anchor_pos;in vec2 a_extrude;in vec2 a_placed;in vec2 a_shift;in vec2 a_elevation_from_sea;in float a_size_scale;in vec2 a_padding;in float a_auto_z_offset;uniform mat4 u_matrix;uniform vec2 u_extrude_scale;uniform float u_camera_to_center_distance;out float v_placed;out float v_notUsed;void main() {float feature_elevation=a_elevation_from_sea.x+a_auto_z_offset;float terrain_elevation=(a_elevation_from_sea.y==1.0 ? 0.0 : elevation(a_anchor_pos));vec4 projectedPoint=u_matrix*vec4(a_pos+elevationVector(a_anchor_pos)*(feature_elevation+terrain_elevation),1);highp float camera_to_anchor_distance=projectedPoint.w;highp float collision_perspective_ratio=clamp(\n0.5+0.5*(u_camera_to_center_distance/camera_to_anchor_distance),0.0,1.5);gl_Position=projectedPoint;gl_Position.xy+=(a_extrude*a_size_scale+a_shift+a_padding)*u_extrude_scale*gl_Position.w*collision_perspective_ratio;v_placed=a_placed.x;v_notUsed=a_placed.y;}'),
            collisionCircle: Go("in float v_radius;in vec2 v_extrude;in float v_perspective_ratio;in float v_collision;void main() {float alpha=0.5*min(v_perspective_ratio,1.0);float stroke_radius=0.9*max(v_perspective_ratio,1.0);float distance_to_center=length(v_extrude);float distance_to_edge=abs(distance_to_center-v_radius);float opacity_t=smoothstep(-stroke_radius,0.0,-distance_to_edge);vec4 color=mix(vec4(0.0,0.0,1.0,0.5),vec4(1.0,0.0,0.0,1.0),v_collision);glFragColor=color*alpha*opacity_t;}", "in vec2 a_pos_2f;in float a_radius;in vec2 a_flags;uniform mat4 u_matrix;uniform mat4 u_inv_matrix;uniform vec2 u_viewport_size;uniform float u_camera_to_center_distance;out float v_radius;out vec2 v_extrude;out float v_perspective_ratio;out float v_collision;vec3 toTilePosition(vec2 screenPos) {vec4 rayStart=u_inv_matrix*vec4(screenPos,-1.0,1.0);vec4 rayEnd  =u_inv_matrix*vec4(screenPos, 1.0,1.0);rayStart.xyz/=rayStart.w;rayEnd.xyz  /=rayEnd.w;highp float t=(0.0-rayStart.z)/(rayEnd.z-rayStart.z);return mix(rayStart.xyz,rayEnd.xyz,t);}void main() {vec2 quadCenterPos=a_pos_2f;float radius=a_radius;float collision=a_flags.x;float vertexIdx=a_flags.y;vec2 quadVertexOffset=vec2(\nmix(-1.0,1.0,float(vertexIdx >=2.0)),mix(-1.0,1.0,float(vertexIdx >=1.0 && vertexIdx <=2.0)));vec2 quadVertexExtent=quadVertexOffset*radius;vec3 tilePos=toTilePosition(quadCenterPos);vec4 clipPos=u_matrix*vec4(tilePos,1.0);highp float camera_to_anchor_distance=clipPos.w;highp float collision_perspective_ratio=clamp(\n0.5+0.5*(u_camera_to_center_distance/camera_to_anchor_distance),0.0,4.0);float padding_factor=1.2;v_radius=radius;v_extrude=quadVertexExtent*padding_factor;v_perspective_ratio=collision_perspective_ratio;v_collision=collision;gl_Position=vec4(clipPos.xyz/clipPos.w,1.0)+vec4(quadVertexExtent*padding_factor/u_viewport_size*2.0,0.0,0.0);}"),
            debug: Go("uniform highp vec4 u_color;uniform sampler2D u_overlay;in vec2 v_uv;void main() {vec4 overlay_color=texture(u_overlay,v_uv);glFragColor=mix(u_color,overlay_color,overlay_color.a);}", '#include "_prelude_terrain.vertex.glsl"\nin vec2 a_pos;\n#ifdef PROJECTION_GLOBE_VIEW\nin vec3 a_pos_3;\n#endif\nout vec2 v_uv;uniform mat4 u_matrix;uniform float u_overlay_scale;void main() {float h=elevation(a_pos);v_uv=a_pos/8192.0;\n#ifdef PROJECTION_GLOBE_VIEW\ngl_Position=u_matrix*vec4(a_pos_3+elevationVector(a_pos)*h,1);\n#else\ngl_Position=u_matrix*vec4(a_pos*u_overlay_scale,h,1);\n#endif\n}'),
            fill: Go('#include "_prelude_fog.fragment.glsl"\n#include "_prelude_lighting.glsl"\n#include "_prelude_shadow.fragment.glsl"\n#pragma mapbox: define highp vec4 color\n#pragma mapbox: define lowp float opacity\nuniform float u_emissive_strength;\n#ifdef RENDER_SHADOWS\nuniform vec3 u_ground_shadow_factor;in highp vec4 v_pos_light_view_0;in highp vec4 v_pos_light_view_1;in highp float v_depth;\n#endif\n#ifdef INDICATOR_CUTOUT\nin highp float v_z_offset;\n#endif\nvoid main() {\n#pragma mapbox: initialize highp vec4 color\n#pragma mapbox: initialize lowp float opacity\nvec4 out_color=color;\n#ifdef LIGHTING_3D_MODE\nout_color=apply_lighting_with_emission_ground(out_color,u_emissive_strength);\n#ifdef RENDER_SHADOWS\nfloat light=shadowed_light_factor(v_pos_light_view_0,v_pos_light_view_1,v_depth);out_color.rgb*=mix(u_ground_shadow_factor,vec3(1.0),light);\n#endif\n#endif\n#ifdef FOG\nout_color=fog_dither(fog_apply_premultiplied(out_color,v_fog_pos));\n#endif\nout_color*=opacity;\n#ifdef INDICATOR_CUTOUT\nif (v_z_offset >=0.0) {out_color=applyCutout(out_color,v_z_offset);}\n#endif\nglFragColor=out_color;\n#ifdef OVERDRAW_INSPECTOR\nglFragColor=vec4(1.0);\n#endif\nHANDLE_WIREFRAME_DEBUG;}', '#include "_prelude_fog.vertex.glsl"\n#include "_prelude_shadow.vertex.glsl"\nin vec2 a_pos;\n#ifdef ELEVATED_ROADS\nin float a_road_z_offset;\n#endif\n#ifdef RENDER_SHADOWS\nuniform mat4 u_light_matrix_0;uniform mat4 u_light_matrix_1;out highp vec4 v_pos_light_view_0;out highp vec4 v_pos_light_view_1;out highp float v_depth;\n#endif\n#ifdef INDICATOR_CUTOUT\nout highp float v_z_offset;\n#endif\nuniform mat4 u_matrix;\n#pragma mapbox: define highp vec4 color\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define highp float z_offset\nvoid main() {\n#pragma mapbox: initialize highp vec4 color\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize highp float z_offset\n#ifdef ELEVATED_ROADS\nz_offset+=a_road_z_offset;\n#endif\nfloat hidden=float(opacity==0.0);gl_Position=mix(u_matrix*vec4(a_pos,z_offset,1),AWAY,hidden);\n#ifdef RENDER_SHADOWS\nvec3 shd_pos0=vec3(a_pos,z_offset);vec3 shd_pos1=vec3(a_pos,z_offset);\n#ifdef NORMAL_OFFSET\nvec3 offset=shadow_normal_offset(vec3(0.0,0.0,1.0));shd_pos0+=offset*shadow_normal_offset_multiplier0();shd_pos1+=offset*shadow_normal_offset_multiplier1();\n#endif\nv_pos_light_view_0=u_light_matrix_0*vec4(shd_pos0,1);v_pos_light_view_1=u_light_matrix_1*vec4(shd_pos1,1);v_depth=gl_Position.w;\n#endif\n#ifdef FOG\nv_fog_pos=fog_position(a_pos);\n#endif\n#ifdef INDICATOR_CUTOUT\nv_z_offset=z_offset;\n#endif\n}'),
            fillOutline: Go('#include "_prelude_fog.fragment.glsl"\n#include "_prelude_lighting.glsl"\n#include "_prelude_shadow.fragment.glsl"\nin highp vec2 v_pos;uniform float u_emissive_strength;\n#ifdef RENDER_SHADOWS\nuniform vec3 u_ground_shadow_factor;in highp vec4 v_pos_light_view_0;in highp vec4 v_pos_light_view_1;in highp float v_depth;\n#endif\n#pragma mapbox: define highp vec4 outline_color\n#pragma mapbox: define lowp float opacity\nvoid main() {\n#pragma mapbox: initialize highp vec4 outline_color\n#pragma mapbox: initialize lowp float opacity\nfloat dist=length(v_pos-gl_FragCoord.xy);float alpha=1.0-smoothstep(0.0,1.0,dist);vec4 out_color=outline_color;\n#ifdef LIGHTING_3D_MODE\nout_color=apply_lighting_with_emission_ground(out_color,u_emissive_strength);\n#ifdef RENDER_SHADOWS\nfloat light=shadowed_light_factor(v_pos_light_view_0,v_pos_light_view_1,v_depth);out_color.rgb*=mix(u_ground_shadow_factor,vec3(1.0),light);\n#endif\n#endif\n#ifdef FOG\nout_color=fog_dither(fog_apply_premultiplied(out_color,v_fog_pos));\n#endif\nglFragColor=out_color*(alpha*opacity);\n#ifdef OVERDRAW_INSPECTOR\nglFragColor=vec4(1.0);\n#endif\nHANDLE_WIREFRAME_DEBUG;}', '#include "_prelude_fog.vertex.glsl"\n#include "_prelude_shadow.vertex.glsl"\nin vec2 a_pos;\n#ifdef ELEVATED_ROADS\nin float a_road_z_offset;\n#endif\n#ifdef RENDER_SHADOWS\nuniform mat4 u_light_matrix_0;uniform mat4 u_light_matrix_1;out highp vec4 v_pos_light_view_0;out highp vec4 v_pos_light_view_1;out highp float v_depth;\n#endif\nuniform mat4 u_matrix;uniform vec2 u_world;out highp vec2 v_pos;\n#pragma mapbox: define highp vec4 outline_color\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define highp float z_offset\nvoid main() {\n#pragma mapbox: initialize highp vec4 outline_color\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize highp float z_offset\n#ifdef ELEVATED_ROADS\nz_offset+=a_road_z_offset;\n#endif\nfloat hidden=float(opacity==0.0);gl_Position=mix(u_matrix*vec4(a_pos,z_offset,1),AWAY,hidden);v_pos=(gl_Position.xy/gl_Position.w+1.0)/2.0*u_world;\n#ifdef RENDER_SHADOWS\nvec3 shd_pos0=vec3(a_pos,z_offset);vec3 shd_pos1=vec3(a_pos,z_offset);\n#ifdef NORMAL_OFFSET\nvec3 offset=shadow_normal_offset(vec3(0.0,0.0,1.0));shd_pos0+=offset*shadow_normal_offset_multiplier0();shd_pos1+=offset*shadow_normal_offset_multiplier1();\n#endif\nv_pos_light_view_0=u_light_matrix_0*vec4(shd_pos0,1);v_pos_light_view_1=u_light_matrix_1*vec4(shd_pos1,1);v_depth=gl_Position.w;\n#endif\n#ifdef FOG\nv_fog_pos=fog_position(a_pos);\n#endif\n}'),
            fillOutlinePattern: Go('#include "_prelude_fog.fragment.glsl"\n#include "_prelude_lighting.glsl"\n#include "_prelude_shadow.fragment.glsl"\nuniform vec2 u_texsize;uniform sampler2D u_image;uniform float u_emissive_strength;\n#ifdef RENDER_SHADOWS\nuniform vec3 u_ground_shadow_factor;in highp vec4 v_pos_light_view_0;in highp vec4 v_pos_light_view_1;in highp float v_depth;\n#endif\nin highp vec2 v_pos;in highp vec2 v_pos_world;\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define lowp vec4 pattern\nvoid main() {\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize mediump vec4 pattern\nvec2 pattern_tl=pattern.xy;vec2 pattern_br=pattern.zw;highp vec2 imagecoord=mod(v_pos,1.0);highp vec2 pos=mix(pattern_tl/u_texsize,pattern_br/u_texsize,imagecoord);highp vec2 lod_pos=mix(pattern_tl/u_texsize,pattern_br/u_texsize,v_pos);float dist=length(v_pos_world-gl_FragCoord.xy);float alpha=1.0-smoothstep(0.0,1.0,dist);vec4 out_color=textureLodCustom(u_image,pos,lod_pos);\n#ifdef LIGHTING_3D_MODE\nout_color=apply_lighting_with_emission_ground(out_color,u_emissive_strength);\n#ifdef RENDER_SHADOWS\nfloat light=shadowed_light_factor(v_pos_light_view_0,v_pos_light_view_1,v_depth);out_color.rgb*=mix(u_ground_shadow_factor,vec3(1.0),light);\n#endif\n#endif\n#ifdef FOG\nout_color=fog_dither(fog_apply_premultiplied(out_color,v_fog_pos));\n#endif\nglFragColor=out_color*(alpha*opacity);\n#ifdef OVERDRAW_INSPECTOR\nglFragColor=vec4(1.0);\n#endif\nHANDLE_WIREFRAME_DEBUG;}', '#include "_prelude_fog.vertex.glsl"\n#include "_prelude_shadow.vertex.glsl"\nuniform mat4 u_matrix;uniform vec2 u_world;uniform vec2 u_pixel_coord_upper;uniform vec2 u_pixel_coord_lower;uniform float u_tile_units_to_pixels;in vec2 a_pos;\n#ifdef ELEVATED_ROADS\nin float a_road_z_offset;\n#endif\n#ifdef RENDER_SHADOWS\nuniform mat4 u_light_matrix_0;uniform mat4 u_light_matrix_1;out highp vec4 v_pos_light_view_0;out highp vec4 v_pos_light_view_1;out highp float v_depth;\n#endif\nout highp vec2 v_pos;out highp vec2 v_pos_world;\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define lowp vec4 pattern\n#pragma mapbox: define lowp float pixel_ratio\n#pragma mapbox: define highp float z_offset\nvoid main() {\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize mediump vec4 pattern\n#pragma mapbox: initialize lowp float pixel_ratio\n#pragma mapbox: initialize highp float z_offset\nvec2 pattern_tl=pattern.xy;vec2 pattern_br=pattern.zw;\n#ifdef ELEVATED_ROADS\nz_offset+=a_road_z_offset;\n#endif\nfloat hidden=float(opacity==0.0);gl_Position=mix(u_matrix*vec4(a_pos,z_offset,1),AWAY,hidden);vec2 display_size=(pattern_br-pattern_tl)/pixel_ratio;v_pos=get_pattern_pos(u_pixel_coord_upper,u_pixel_coord_lower,display_size,u_tile_units_to_pixels,a_pos);v_pos_world=(gl_Position.xy/gl_Position.w+1.0)/2.0*u_world;\n#ifdef RENDER_SHADOWS\nvec3 shd_pos0=vec3(a_pos,z_offset);vec3 shd_pos1=vec3(a_pos,z_offset);\n#ifdef NORMAL_OFFSET\nvec3 offset=shadow_normal_offset(vec3(0.0,0.0,1.0));shd_pos0+=offset*shadow_normal_offset_multiplier0();shd_pos1+=offset*shadow_normal_offset_multiplier1();\n#endif\nv_pos_light_view_0=u_light_matrix_0*vec4(shd_pos0,1);v_pos_light_view_1=u_light_matrix_1*vec4(shd_pos1,1);v_depth=gl_Position.w;\n#endif\n#ifdef FOG\nv_fog_pos=fog_position(a_pos);\n#endif\n}'),
            fillPattern: Go('#include "_prelude_fog.fragment.glsl"\n#include "_prelude_lighting.glsl"\n#include "_prelude_shadow.fragment.glsl"\nuniform vec2 u_texsize;uniform sampler2D u_image;in highp vec2 v_pos;uniform float u_emissive_strength;\n#ifdef RENDER_SHADOWS\nuniform vec3 u_ground_shadow_factor;in highp vec4 v_pos_light_view_0;in highp vec4 v_pos_light_view_1;in highp float v_depth;\n#endif\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define lowp vec4 pattern\nvoid main() {\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize mediump vec4 pattern\nvec2 pattern_tl=pattern.xy;vec2 pattern_br=pattern.zw;highp vec2 imagecoord=mod(v_pos,1.0);highp vec2 pos=mix(pattern_tl/u_texsize,pattern_br/u_texsize,imagecoord);highp vec2 lod_pos=mix(pattern_tl/u_texsize,pattern_br/u_texsize,v_pos);vec4 out_color=textureLodCustom(u_image,pos,lod_pos);\n#ifdef LIGHTING_3D_MODE\nout_color=apply_lighting_with_emission_ground(out_color,u_emissive_strength);\n#ifdef RENDER_SHADOWS\nfloat light=shadowed_light_factor(v_pos_light_view_0,v_pos_light_view_1,v_depth);out_color.rgb*=mix(u_ground_shadow_factor,vec3(1.0),light);\n#endif\n#endif\n#ifdef FOG\nout_color=fog_dither(fog_apply_premultiplied(out_color,v_fog_pos));\n#endif\nglFragColor=out_color*opacity;\n#ifdef OVERDRAW_INSPECTOR\nglFragColor=vec4(1.0);\n#endif\nHANDLE_WIREFRAME_DEBUG;}', '#include "_prelude_fog.vertex.glsl"\n#include "_prelude_shadow.vertex.glsl"\nuniform mat4 u_matrix;uniform vec2 u_pixel_coord_upper;uniform vec2 u_pixel_coord_lower;uniform float u_tile_units_to_pixels;in vec2 a_pos;\n#ifdef ELEVATED_ROADS\nin float a_road_z_offset;\n#endif\n#ifdef RENDER_SHADOWS\nuniform mat4 u_light_matrix_0;uniform mat4 u_light_matrix_1;out highp vec4 v_pos_light_view_0;out highp vec4 v_pos_light_view_1;out highp float v_depth;\n#endif\nout highp vec2 v_pos;\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define lowp vec4 pattern\n#pragma mapbox: define lowp float pixel_ratio\n#pragma mapbox: define highp float z_offset\nvoid main() {\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize mediump vec4 pattern\n#pragma mapbox: initialize lowp float pixel_ratio\n#pragma mapbox: initialize highp float z_offset\nvec2 pattern_tl=pattern.xy;vec2 pattern_br=pattern.zw;vec2 display_size=(pattern_br-pattern_tl)/pixel_ratio;\n#ifdef ELEVATED_ROADS\nz_offset+=a_road_z_offset;\n#endif\nfloat hidden=float(opacity==0.0);gl_Position=mix(u_matrix*vec4(a_pos,z_offset,1),AWAY,hidden);v_pos=get_pattern_pos(u_pixel_coord_upper,u_pixel_coord_lower,display_size,u_tile_units_to_pixels,a_pos);\n#ifdef RENDER_SHADOWS\nvec3 shd_pos0=vec3(a_pos,z_offset);vec3 shd_pos1=vec3(a_pos,z_offset);\n#ifdef NORMAL_OFFSET\nvec3 offset=shadow_normal_offset(vec3(0.0,0.0,1.0));shd_pos0+=offset*shadow_normal_offset_multiplier0();shd_pos1+=offset*shadow_normal_offset_multiplier1();\n#endif\nv_pos_light_view_0=u_light_matrix_0*vec4(shd_pos0,1);v_pos_light_view_1=u_light_matrix_1*vec4(shd_pos1,1);v_depth=gl_Position.w;\n#endif\n#ifdef FOG\nv_fog_pos=fog_position(a_pos);\n#endif\n}'),
            fillExtrusion: Go('#include "_prelude_fog.fragment.glsl"\n#include "_prelude_shadow.fragment.glsl"\n#include "_prelude_lighting.glsl"\nin vec4 v_color;in vec4 v_flat;\n#ifdef RENDER_SHADOWS\nin highp vec4 v_pos_light_view_0;in highp vec4 v_pos_light_view_1;\n#endif\nuniform lowp float u_opacity;\n#ifdef FAUX_AO\nuniform lowp vec2 u_ao;in vec2 v_ao;\n#endif\n#if defined(ZERO_ROOF_RADIUS) && !defined(LIGHTING_3D_MODE)\nin vec4 v_roof_color;\n#endif\n#if defined(ZERO_ROOF_RADIUS) || defined(RENDER_SHADOWS) || defined(LIGHTING_3D_MODE)\nin highp vec3 v_normal;\n#endif\nuniform vec3 u_flood_light_color;uniform highp float u_vertical_scale;uniform float u_flood_light_intensity;uniform vec3 u_ground_shadow_factor;\n#if defined(LIGHTING_3D_MODE) && defined(FLOOD_LIGHT)\nin float v_flood_radius;in float v_has_floodlight;\n#endif\nin float v_height;\n#pragma mapbox: define highp float emissive_strength\nvoid main() {\n#pragma mapbox: initialize highp float emissive_strength\n#if defined(ZERO_ROOF_RADIUS) || defined(RENDER_SHADOWS) || defined(LIGHTING_3D_MODE)\nvec3 normal=normalize(v_normal);\n#endif\nfloat z;vec4 color=v_color;\n#ifdef ZERO_ROOF_RADIUS\nz=float(normal.z > 0.00001);\n#ifdef LIGHTING_3D_MODE\nnormal=mix(normal,vec3(0.0,0.0,1.0),z);\n#else\ncolor=mix(v_color,v_roof_color,z);\n#endif\n#endif\nfloat h=max(0.0,v_height);float ao_shade=1.0;\n#ifdef FAUX_AO\nfloat intensity=u_ao[0];float h_floors=h/(u_ao[1]*u_vertical_scale);float y_shade=1.0-0.9*intensity*min(v_ao.y,1.0);ao_shade=(1.0-0.08*intensity)*(y_shade+(1.0-y_shade)*(1.0-pow(1.0-min(h_floors/16.0,1.0),16.0)))+0.08*intensity*min(h_floors/160.0,1.0);float concave=v_ao.x*v_ao.x;\n#ifdef ZERO_ROOF_RADIUS\nconcave*=(1.0-z);\n#endif\nfloat x_shade=mix(1.0,mix(0.6,0.75,min(h_floors/30.0,1.0)),intensity)+0.1*intensity*min(h,1.0);ao_shade*=mix(1.0,x_shade*x_shade*x_shade,concave);\n#ifdef LIGHTING_3D_MODE\n#ifdef FLOOD_LIGHT\ncolor.rgb*=mix(ao_shade,1.0,v_has_floodlight);\n#else\ncolor.rgb*=ao_shade;\n#endif\n#else\ncolor.rgb*=ao_shade;\n#endif\n#endif\n#ifdef LIGHTING_3D_MODE\nfloat flood_radiance=0.0;\n#ifdef FLOOD_LIGHT\nflood_radiance=(1.0-min(h/v_flood_radius,1.0))*u_flood_light_intensity*v_has_floodlight;\n#endif\n#ifdef RENDER_SHADOWS\n#ifdef FLOOD_LIGHT\nfloat ndotl_unclamped=dot(normal,u_shadow_direction);float ndotl=max(0.0,ndotl_unclamped);float occlusion=ndotl_unclamped < 0.0 ? 1.0 : shadow_occlusion(ndotl,v_pos_light_view_0,v_pos_light_view_1,1.0/gl_FragCoord.w);vec3 litColor=apply_lighting(color.rgb,normal,(1.0-u_shadow_intensity*occlusion)*ndotl);vec3 floodLitColor=compute_flood_lighting(u_flood_light_color*u_opacity,1.0-u_shadow_intensity,occlusion,u_ground_shadow_factor);color.rgb=mix(litColor,floodLitColor,flood_radiance);\n#else\nfloat shadowed_lighting_factor;\n#ifdef RENDER_CUTOFF\nshadowed_lighting_factor=shadowed_light_factor_normal_opacity(normal,v_pos_light_view_0,v_pos_light_view_1,1.0/gl_FragCoord.w,v_cutoff_opacity);if (v_cutoff_opacity==0.0) {discard;}\n#else\nshadowed_lighting_factor=shadowed_light_factor_normal(normal,v_pos_light_view_0,v_pos_light_view_1,1.0/gl_FragCoord.w);\n#endif\ncolor.rgb=apply_lighting(color.rgb,normal,shadowed_lighting_factor);\n#endif\n#else\ncolor.rgb=apply_lighting(color.rgb,normal);\n#ifdef FLOOD_LIGHT\ncolor.rgb=mix(color.rgb,u_flood_light_color*u_opacity,flood_radiance);\n#endif\n#endif\ncolor.rgb=mix(color.rgb,v_flat.rgb,emissive_strength);color*=u_opacity;\n#endif\n#ifdef FOG\ncolor=fog_dither(fog_apply_premultiplied(color,v_fog_pos,h));\n#endif\n#ifdef INDICATOR_CUTOUT\ncolor=applyCutout(color,h);\n#endif\nglFragColor=color;\n#ifdef OVERDRAW_INSPECTOR\nglFragColor=vec4(1.0);\n#endif\nHANDLE_WIREFRAME_DEBUG;}', '#include "_prelude_fog.vertex.glsl"\n#include "_prelude_terrain.vertex.glsl"\n#include "_prelude_shadow.vertex.glsl"\n#include "_prelude_lighting.glsl"\nuniform mat4 u_matrix;uniform vec3 u_lightcolor;uniform lowp vec3 u_lightpos;uniform lowp float u_lightintensity;uniform float u_vertical_gradient;uniform lowp float u_opacity;uniform float u_edge_radius;uniform float u_width_scale;in vec4 a_pos_normal_ed;in vec2 a_centroid_pos;\n#ifdef RENDER_WALL_MODE\nin vec3 a_join_normal_inside;\n#endif\n#ifdef PROJECTION_GLOBE_VIEW\nin vec3 a_pos_3;in vec3 a_pos_normal_3;uniform mat4 u_inv_rot_matrix;uniform vec2 u_merc_center;uniform vec3 u_tile_id;uniform float u_zoom_transition;uniform vec3 u_up_dir;uniform float u_height_lift;\n#endif\n#ifdef TERRAIN\nuniform int u_height_type;uniform int u_base_type;\n#endif\nuniform highp float u_vertical_scale;out vec4 v_color;out vec4 v_flat;\n#ifdef RENDER_SHADOWS\nuniform mat4 u_light_matrix_0;uniform mat4 u_light_matrix_1;out highp vec4 v_pos_light_view_0;out highp vec4 v_pos_light_view_1;\n#endif\n#if defined(ZERO_ROOF_RADIUS) && !defined(LIGHTING_3D_MODE)\nout vec4 v_roof_color;\n#endif\n#if defined(ZERO_ROOF_RADIUS) || defined(RENDER_SHADOWS) || defined(LIGHTING_3D_MODE)\nout highp vec3 v_normal;\n#endif\n#ifdef FAUX_AO\nuniform lowp vec2 u_ao;out vec2 v_ao;\n#endif\n#if defined(LIGHTING_3D_MODE) && defined(FLOOD_LIGHT)\nout float v_flood_radius;out float v_has_floodlight;\n#endif\nout float v_height;vec3 linearTosRGB(vec3 color) {return pow(color,vec3(1./2.2));}vec3 sRGBToLinear(vec3 srgbIn) {return pow(srgbIn,vec3(2.2));}\n#pragma mapbox: define highp float base\n#pragma mapbox: define highp float height\n#pragma mapbox: define highp vec4 color\n#pragma mapbox: define highp float flood_light_wall_radius\n#pragma mapbox: define highp float line_width\n#pragma mapbox: define highp float emissive_strength\nvoid main() {\n#pragma mapbox: initialize highp float base\n#pragma mapbox: initialize highp float height\n#pragma mapbox: initialize highp vec4 color\n#pragma mapbox: initialize highp float flood_light_wall_radius\n#pragma mapbox: initialize highp float line_width\n#pragma mapbox: initialize highp float emissive_strength\nbase*=u_vertical_scale;height*=u_vertical_scale;vec4 pos_nx=floor(a_pos_normal_ed*0.5);vec4 top_up_ny_start=a_pos_normal_ed-2.0*pos_nx;vec3 top_up_ny=top_up_ny_start.xyz;float x_normal=pos_nx.z/8192.0;vec3 normal=top_up_ny.y==1.0 ? vec3(0.0,0.0,1.0) : normalize(vec3(x_normal,(2.0*top_up_ny.z-1.0)*(1.0-abs(x_normal)),0.0));\n#if defined(ZERO_ROOF_RADIUS) || defined(RENDER_SHADOWS) || defined(LIGHTING_3D_MODE)\nv_normal=normal;\n#endif\nbase=max(0.0,base);float attr_height=height;height=max(0.0,top_up_ny.y==0.0 && top_up_ny.x==1.0 ? height-u_edge_radius : height);float t=top_up_ny.x;vec2 centroid_pos=vec2(0.0);\n#if defined(HAS_CENTROID) || defined(TERRAIN)\ncentroid_pos=a_centroid_pos;\n#endif\nfloat ele=0.0;float h=0.0;float c_ele=0.0;vec3 pos;\n#ifdef TERRAIN\nbool is_flat_height=centroid_pos.x !=0.0 && u_height_type==1;bool is_flat_base=centroid_pos.x !=0.0 && u_base_type==1;ele=elevation(pos_nx.xy);c_ele=is_flat_height || is_flat_base ? (centroid_pos.y==0.0 ? elevationFromUint16(centroid_pos.x) : flatElevation(centroid_pos)) : ele;float h_height=is_flat_height ? max(c_ele+height,ele+base+2.0) : ele+height;float h_base=is_flat_base ? max(c_ele+base,ele+base) : ele+(base==0.0 ?-5.0 : base);h=t > 0.0 ? max(h_base,h_height) : h_base;pos=vec3(pos_nx.xy,h);\n#else\nh=t > 0.0 ? height : base;pos=vec3(pos_nx.xy,h);\n#endif\n#ifdef PROJECTION_GLOBE_VIEW\nfloat lift=float((t+base) > 0.0)*u_height_lift;h+=lift;vec3 globe_normal=normalize(mix(a_pos_normal_3/16384.0,u_up_dir,u_zoom_transition));vec3 globe_pos=a_pos_3+globe_normal*(u_tile_up_scale*h);vec3 merc_pos=mercator_tile_position(u_inv_rot_matrix,pos.xy,u_tile_id,u_merc_center)+u_up_dir*u_tile_up_scale*pos.z;pos=mix_globe_mercator(globe_pos,merc_pos,u_zoom_transition);\n#endif\nfloat cutoff=1.0;vec3 scaled_pos=pos;\n#ifdef RENDER_CUTOFF\nvec3 centroid_random=vec3(centroid_pos.xy,centroid_pos.x+centroid_pos.y+1.0);vec3 ground_pos=centroid_pos.x==0.0 ? pos.xyz : (centroid_random/8.0);vec4 ground=u_matrix*vec4(ground_pos.xy,ele,1.0);cutoff=cutoff_opacity(u_cutoff_params,ground.z);if (centroid_pos.y !=0.0 && centroid_pos.x !=0.0) {vec3 g=floor(ground_pos);vec3 mod_=centroid_random-g*8.0;float seed=min(1.0,0.1*(min(3.5,max(mod_.x+mod_.y,0.2*attr_height))*0.35+mod_.z));if (cutoff < 0.8-seed) {cutoff=0.0;}}float cutoff_scale=cutoff;v_cutoff_opacity=cutoff;scaled_pos.z=mix(c_ele,h,cutoff_scale);\n#endif\nfloat hidden=float((centroid_pos.x==0.0 && centroid_pos.y==1.0) || (cutoff==0.0 && centroid_pos.x !=0.0) || (color.a==0.0));\n#ifdef RENDER_WALL_MODE\nvec2 wall_offset=u_width_scale*line_width*(a_join_normal_inside.xy/EXTENT);scaled_pos.xy+=(1.0-a_join_normal_inside.z)*wall_offset*0.5;scaled_pos.xy-=a_join_normal_inside.z*wall_offset*0.5;\n#endif\ngl_Position=mix(u_matrix*vec4(scaled_pos,1),AWAY,hidden);h=h-ele;v_height=h;\n#ifdef RENDER_SHADOWS\nvec3 shd_pos0=pos;vec3 shd_pos1=pos;\n#ifdef NORMAL_OFFSET\nvec3 offset=shadow_normal_offset(normal);shd_pos0+=offset*shadow_normal_offset_multiplier0();shd_pos1+=offset*shadow_normal_offset_multiplier1();\n#endif\nv_pos_light_view_0=u_light_matrix_0*vec4(shd_pos0,1);v_pos_light_view_1=u_light_matrix_1*vec4(shd_pos1,1);\n#endif\nfloat NdotL=0.0;float colorvalue=0.0;\n#ifndef LIGHTING_3D_MODE\ncolorvalue=color.r*0.2126+color.g*0.7152+color.b*0.0722;vec4 ambientlight=vec4(0.03,0.03,0.03,1.0);color+=ambientlight;NdotL=clamp(dot(normal,u_lightpos),0.0,1.0);NdotL=mix((1.0-u_lightintensity),max((1.0-colorvalue+u_lightintensity),1.0),NdotL);if (normal.y !=0.0) {float r=0.84;r=mix(0.7,0.98,1.0-u_lightintensity);NdotL*=(\n(1.0-u_vertical_gradient)+(u_vertical_gradient*clamp((t+base)*pow(height/150.0,0.5),r,1.0)));}\n#endif\n#ifdef FAUX_AO\nfloat concave=pos_nx.w-floor(pos_nx.w*0.5)*2.0;float start=top_up_ny_start.w;float y_ground=1.0-clamp(t+base,0.0,1.0);float top_height=height;\n#ifdef TERRAIN\ntop_height=mix(max(c_ele+height,ele+base+2.0),ele+height,float(centroid_pos.x==0.0))-ele;y_ground+=y_ground*5.0/max(3.0,top_height);\n#endif\nv_ao=vec2(mix(concave,-concave,start),y_ground);NdotL*=(1.0+0.05*(1.0-top_up_ny.y)*u_ao[0]);\n#ifdef PROJECTION_GLOBE_VIEW\ntop_height+=u_height_lift;\n#endif\ngl_Position.z-=(0.0000006*(min(top_height,500.)+2.0*min(base,500.0)+60.0*concave+3.0*start))*gl_Position.w;\n#endif\n#ifdef LIGHTING_3D_MODE\n#ifdef FLOOD_LIGHT\nfloat is_wall=1.0-float(t > 0.0 && top_up_ny.y > 0.0);v_has_floodlight=float(flood_light_wall_radius > 0.0 && is_wall > 0.0);v_flood_radius=flood_light_wall_radius*u_vertical_scale;\n#endif\nv_color=vec4(color.rgb,1.0);float ndotl=calculate_NdotL(normal);v_flat.rgb=sRGBToLinear(color.rgb);v_flat.rgb=v_flat.rgb*(ndotl+(1.0-min(ndotl*57.29,1.0))*emissive_strength);v_flat=vec4(linearTosRGB(v_flat.rgb),1.0);\n#else\nv_color=vec4(0.0,0.0,0.0,1.0);v_color.rgb+=clamp(color.rgb*NdotL*u_lightcolor,mix(vec3(0.0),vec3(0.3),1.0-u_lightcolor),vec3(1.0));v_color*=u_opacity;\n#endif\n#if defined(ZERO_ROOF_RADIUS) && !defined(LIGHTING_3D_MODE)\nfloat roofNdotL=clamp(u_lightpos.z,0.0,1.0);roofNdotL=mix((1.0-u_lightintensity),max((1.0-colorvalue+u_lightintensity),1.0),roofNdotL);v_roof_color=vec4(0.0,0.0,0.0,1.0);v_roof_color.rgb+=clamp(color.rgb*roofNdotL*u_lightcolor,mix(vec3(0.0),vec3(0.3),1.0-u_lightcolor),vec3(1.0));v_roof_color*=u_opacity;\n#endif\n#ifdef FOG\nv_fog_pos=fog_position(pos);\n#endif\n}'),
            fillExtrusionDepth: Go("in highp float v_depth;void main() {\n#ifndef DEPTH_TEXTURE\nglFragColor=pack_depth(v_depth);\n#endif\n}", '#include "_prelude_terrain.vertex.glsl"\nuniform mat4 u_matrix;uniform float u_edge_radius;uniform float u_width_scale;uniform float u_vertical_scale;\n#ifdef TERRAIN\nuniform int u_height_type;uniform int u_base_type;\n#endif\nin vec4 a_pos_normal_ed;in vec2 a_centroid_pos;\n#ifdef RENDER_WALL_MODE\nin vec3 a_join_normal_inside;\n#endif\n#pragma mapbox: define highp float base\n#pragma mapbox: define highp float height\n#pragma mapbox: define highp float line_width\n#pragma mapbox: define highp vec4 color\nout highp float v_depth;void main() {\n#pragma mapbox: initialize highp float base\n#pragma mapbox: initialize highp float height\n#pragma mapbox: initialize highp float line_width\n#pragma mapbox: initialize highp vec4 color\nbase*=u_vertical_scale;height*=u_vertical_scale;vec3 pos_nx=floor(a_pos_normal_ed.xyz*0.5);mediump vec3 top_up_ny=a_pos_normal_ed.xyz-2.0*pos_nx;base=max(0.0,base);height=max(0.0,top_up_ny.y==0.0 && top_up_ny.x==1.0 ? height-u_edge_radius : height);float t=top_up_ny.x;vec2 centroid_pos=vec2(0.0);\n#if defined(HAS_CENTROID) || defined(TERRAIN)\ncentroid_pos=a_centroid_pos;\n#endif\nvec3 pos;\n#ifdef TERRAIN\nbool is_flat_height=centroid_pos.x !=0.0 && u_height_type==1;bool is_flat_base=centroid_pos.x !=0.0 && u_base_type==1;float ele=elevation(pos_nx.xy);float c_ele=is_flat_height || is_flat_base ? (centroid_pos.y==0.0 ? elevationFromUint16(centroid_pos.x) : flatElevation(centroid_pos)) : ele;float h_height=is_flat_height ? max(c_ele+height,ele+base+2.0) : ele+height;float h_base=is_flat_base ? max(c_ele+base,ele+base) : ele+(base==0.0 ?-5.0 : base);float h=t > 0.0 ? max(h_base,h_height) : h_base;pos=vec3(pos_nx.xy,h);\n#else\npos=vec3(pos_nx.xy,t > 0.0 ? height : base);\n#endif\n#ifdef RENDER_WALL_MODE\nvec2 wall_offset=u_width_scale*line_width*(a_join_normal_inside.xy/EXTENT);pos.xy+=(1.0-a_join_normal_inside.z)*wall_offset*0.5;pos.xy-=a_join_normal_inside.z*wall_offset*0.5;\n#endif\nfloat hidden=float((centroid_pos.x==0.0 && centroid_pos.y==1.0) || (color.a==0.0));gl_Position=mix(u_matrix*vec4(pos,1),AWAY,hidden);v_depth=gl_Position.z/gl_Position.w;}'),
            fillExtrusionPattern: Go('#include "_prelude_fog.fragment.glsl"\n#include "_prelude_lighting.glsl"\nuniform vec2 u_texsize;uniform sampler2D u_image;\n#ifdef FAUX_AO\nuniform lowp vec2 u_ao;in vec3 v_ao;\n#endif\n#ifdef LIGHTING_3D_MODE\nin vec3 v_normal;\n#endif\nin highp vec2 v_pos;in vec4 v_lighting;uniform lowp float u_opacity;\n#pragma mapbox: define highp float base\n#pragma mapbox: define highp float height\n#pragma mapbox: define mediump vec4 pattern\n#pragma mapbox: define highp float pixel_ratio\nvoid main() {\n#pragma mapbox: initialize highp float base\n#pragma mapbox: initialize highp float height\n#pragma mapbox: initialize mediump vec4 pattern\n#pragma mapbox: initialize highp float pixel_ratio\nvec2 pattern_tl=pattern.xy;vec2 pattern_br=pattern.zw;highp vec2 imagecoord=mod(v_pos,1.0);highp vec2 pos=mix(pattern_tl/u_texsize,pattern_br/u_texsize,imagecoord);highp vec2 lod_pos=mix(pattern_tl/u_texsize,pattern_br/u_texsize,v_pos);vec4 out_color=textureLodCustom(u_image,pos,lod_pos);\n#ifdef LIGHTING_3D_MODE\nout_color=apply_lighting(out_color,normalize(v_normal))*u_opacity;\n#else\nout_color=out_color*v_lighting;\n#endif\n#ifdef FAUX_AO\nfloat intensity=u_ao[0];float h=max(0.0,v_ao.z);float h_floors=h/u_ao[1];float y_shade=1.0-0.9*intensity*min(v_ao.y,1.0);float shade=(1.0-0.08*intensity)*(y_shade+(1.0-y_shade)*(1.0-pow(1.0-min(h_floors/16.0,1.0),16.0)))+0.08*intensity*min(h_floors/160.0,1.0);float concave=v_ao.x*v_ao.x;float x_shade=mix(1.0,mix(0.6,0.75,min(h_floors/30.0,1.0)),intensity)+0.1*intensity*min(h,1.0);shade*=mix(1.0,x_shade*x_shade*x_shade,concave);out_color.rgb=out_color.rgb*shade;\n#endif\n#ifdef FOG\nout_color=fog_dither(fog_apply_premultiplied(out_color,v_fog_pos));\n#endif\n#ifdef INDICATOR_CUTOUT\nout_color=applyCutout(out_color,height);\n#endif\nglFragColor=out_color;\n#ifdef OVERDRAW_INSPECTOR\nglFragColor=vec4(1.0);\n#endif\nHANDLE_WIREFRAME_DEBUG;}', '#include "_prelude_fog.vertex.glsl"\n#include "_prelude_terrain.vertex.glsl"\n#include "_prelude_lighting.glsl"\nuniform mat4 u_matrix;uniform vec2 u_pixel_coord_upper;uniform vec2 u_pixel_coord_lower;uniform float u_height_factor;uniform float u_tile_units_to_pixels;uniform float u_vertical_gradient;uniform lowp float u_opacity;uniform float u_width_scale;uniform vec3 u_lightcolor;uniform lowp vec3 u_lightpos;uniform lowp float u_lightintensity;in vec4 a_pos_normal_ed;in vec2 a_centroid_pos;\n#ifdef RENDER_WALL_MODE\nin vec3 a_join_normal_inside;\n#endif\n#ifdef PROJECTION_GLOBE_VIEW\nin vec3 a_pos_3;in vec3 a_pos_normal_3;uniform mat4 u_inv_rot_matrix;uniform vec2 u_merc_center;uniform vec3 u_tile_id;uniform float u_zoom_transition;uniform vec3 u_up_dir;uniform float u_height_lift;\n#endif\n#ifdef TERRAIN\nuniform int u_height_type;uniform int u_base_type;\n#endif\nout highp vec2 v_pos;out vec4 v_lighting;\n#ifdef FAUX_AO\nuniform lowp vec2 u_ao;out vec3 v_ao;\n#endif\n#ifdef LIGHTING_3D_MODE\nout vec3 v_normal;\n#endif\n#pragma mapbox: define highp float base\n#pragma mapbox: define highp float height\n#pragma mapbox: define highp vec4 color\n#pragma mapbox: define mediump vec4 pattern\n#pragma mapbox: define highp float pixel_ratio\n#pragma mapbox: define highp float line_width\nvoid main() {\n#pragma mapbox: initialize highp float base\n#pragma mapbox: initialize highp float height\n#pragma mapbox: initialize highp vec4 color\n#pragma mapbox: initialize mediump vec4 pattern\n#pragma mapbox: initialize highp float pixel_ratio\n#pragma mapbox: initialize highp float line_width\nvec2 pattern_tl=pattern.xy;vec2 pattern_br=pattern.zw;vec4 pos_nx=floor(a_pos_normal_ed*0.5);mediump vec4 top_up_ny_start=a_pos_normal_ed-2.0*pos_nx;mediump vec3 top_up_ny=top_up_ny_start.xyz;float x_normal=pos_nx.z/8192.0;vec3 normal=top_up_ny.y==1.0 ? vec3(0.0,0.0,1.0) : normalize(vec3(x_normal,(2.0*top_up_ny.z-1.0)*(1.0-abs(x_normal)),0.0));float edgedistance=a_pos_normal_ed.w;vec2 display_size=(pattern_br-pattern_tl)/pixel_ratio;base=max(0.0,base);height=max(0.0,height);float t=top_up_ny.x;float z=t > 0.0 ? height : base;vec2 centroid_pos=vec2(0.0);\n#if defined(HAS_CENTROID) || defined(TERRAIN)\ncentroid_pos=a_centroid_pos;\n#endif\nfloat ele=0.0;float h=z;vec3 p;float c_ele;\n#ifdef TERRAIN\nbool is_flat_height=centroid_pos.x !=0.0 && u_height_type==1;bool is_flat_base=centroid_pos.x !=0.0 && u_base_type==1;ele=elevation(pos_nx.xy);c_ele=is_flat_height || is_flat_base ? (centroid_pos.y==0.0 ? elevationFromUint16(centroid_pos.x) : flatElevation(centroid_pos)) : ele;float h_height=is_flat_height ? max(c_ele+height,ele+base+2.0) : ele+height;float h_base=is_flat_base ? max(c_ele+base,ele+base) : ele+(base==0.0 ?-5.0 : base);h=t > 0.0 ? max(h_base,h_height) : h_base;p=vec3(pos_nx.xy,h);\n#else\np=vec3(pos_nx.xy,z);\n#endif\n#ifdef PROJECTION_GLOBE_VIEW\nfloat lift=float((t+base) > 0.0)*u_height_lift;h+=lift;vec3 globe_normal=normalize(mix(a_pos_normal_3/16384.0,u_up_dir,u_zoom_transition));vec3 globe_pos=a_pos_3+globe_normal*(u_tile_up_scale*(p.z+lift));vec3 merc_pos=mercator_tile_position(u_inv_rot_matrix,p.xy,u_tile_id,u_merc_center)+u_up_dir*u_tile_up_scale*p.z;p=mix_globe_mercator(globe_pos,merc_pos,u_zoom_transition);\n#endif\n#ifdef RENDER_WALL_MODE\nvec2 wall_offset=u_width_scale*line_width*(a_join_normal_inside.xy/EXTENT);p.xy+=(1.0-a_join_normal_inside.z)*wall_offset*0.5;p.xy-=a_join_normal_inside.z*wall_offset*0.5;\n#endif\nfloat hidden=float((centroid_pos.x==0.0 && centroid_pos.y==1.0) || (color.a==0.0));gl_Position=mix(u_matrix*vec4(p,1),AWAY,hidden);vec2 pos=normal.z==1.0\n? pos_nx.xy\n: vec2(edgedistance,z*u_height_factor);v_pos=get_pattern_pos(u_pixel_coord_upper,u_pixel_coord_lower,display_size,u_tile_units_to_pixels,pos);v_lighting=vec4(0.0,0.0,0.0,1.0);float NdotL=0.0;\n#ifdef LIGHTING_3D_MODE\nNdotL=calculate_NdotL(normal);\n#else\nNdotL=clamp(dot(normal,u_lightpos),0.0,1.0);NdotL=mix((1.0-u_lightintensity),max((0.5+u_lightintensity),1.0),NdotL);\n#endif\nif (normal.y !=0.0) {float r=0.84;\n#ifndef LIGHTING_3D_MODE\nr=mix(0.7,0.98,1.0-u_lightintensity);\n#endif\nNdotL*=(\n(1.0-u_vertical_gradient)+(u_vertical_gradient*clamp((t+base)*pow(height/150.0,0.5),r,1.0)));}\n#ifdef FAUX_AO\nfloat concave=pos_nx.w-floor(pos_nx.w*0.5)*2.0;float start=top_up_ny_start.w;float y_ground=1.0-clamp(t+base,0.0,1.0);float top_height=height;\n#ifdef TERRAIN\ntop_height=mix(max(c_ele+height,ele+base+2.0),ele+height,float(centroid_pos.x==0.0))-ele;y_ground+=y_ground*5.0/max(3.0,top_height);\n#endif\nv_ao=vec3(mix(concave,-concave,start),y_ground,h-ele);NdotL*=(1.0+0.05*(1.0-top_up_ny.y)*u_ao[0]);\n#ifdef PROJECTION_GLOBE_VIEW\ntop_height+=u_height_lift;\n#endif\ngl_Position.z-=(0.0000006*(min(top_height,500.)+2.0*min(base,500.0)+60.0*concave+3.0*start))*gl_Position.w;\n#endif\n#ifdef LIGHTING_3D_MODE\nv_normal=normal;\n#else\nv_lighting.rgb+=clamp(NdotL*u_lightcolor,mix(vec3(0.0),vec3(0.3),1.0-u_lightcolor),vec3(1.0));v_lighting*=u_opacity;\n#endif \n#ifdef FOG\nv_fog_pos=fog_position(p);\n#endif\n}'),
            groundShadow: Go('#include "_prelude_shadow.fragment.glsl"\nprecision highp float;uniform vec3 u_ground_shadow_factor;in vec4 v_pos_light_view_0;in vec4 v_pos_light_view_1;\n#ifdef FOG\nin float v_fog_opacity;\n#endif\nvoid main() {float light=shadowed_light_factor_plane_bias(v_pos_light_view_0,v_pos_light_view_1,1.0/gl_FragCoord.w);vec3 shadow=mix(u_ground_shadow_factor,vec3(1.0),light);\n#ifdef RENDER_CUTOFF\nshadow=mix(vec3(1.0),shadow,cutoff_opacity(u_cutoff_params,1.0/gl_FragCoord.w));\n#endif\n#ifdef FOG\nshadow=mix(shadow,vec3(1.0),v_fog_opacity);\n#endif\n#ifdef INDICATOR_CUTOUT\nshadow=mix(shadow,vec3(1.0),1.0-applyCutout(vec4(1.0),0.0).r);\n#endif\nglFragColor=vec4(shadow,1.0);}', '#include "_prelude_fog.vertex.glsl"\nuniform mat4 u_matrix;uniform mat4 u_light_matrix_0;uniform mat4 u_light_matrix_1;in vec2 a_pos;out vec4 v_pos_light_view_0;out vec4 v_pos_light_view_1;\n#ifdef FOG\nout float v_fog_opacity;\n#endif\nvoid main() {gl_Position=u_matrix*vec4(a_pos,0.0,1.0);v_pos_light_view_0=u_light_matrix_0*vec4(a_pos,0.0,1.0);v_pos_light_view_1=u_light_matrix_1*vec4(a_pos,0.0,1.0);\n#ifdef FOG\nv_fog_pos=fog_position(a_pos);v_fog_opacity=fog(v_fog_pos);\n#endif\n}'),
            fillExtrusionGroundEffect: Go("uniform highp float u_ao_pass;uniform highp float u_opacity;uniform highp float u_flood_light_intensity;uniform highp vec3 u_flood_light_color;uniform highp float u_attenuation;uniform sampler2D u_fb;uniform float u_fb_size;\n#ifdef SDF_SUBPASS\nin highp vec2 v_pos;in highp vec4 v_line_segment;in highp float v_flood_light_radius_tile;in highp vec2 v_ao;float line_df(highp vec2 a,highp vec2 b,highp vec2 p) {highp vec2 ba=b-a;highp vec2 pa=p-a;highp float r=clamp(dot(pa,ba)/dot(ba,ba),0.0,1.0);return length(pa-r*ba);}\n#ifdef FOG\nin highp float v_fog;\n#endif\n#endif\nvoid main() {\n#ifdef CLEAR_SUBPASS\nvec4 color=vec4(1.0);\n#ifdef CLEAR_FROM_TEXTURE\ncolor=texture(u_fb,gl_FragCoord.xy/vec2(u_fb_size));\n#endif\nglFragColor=color;\n#else\n#ifdef SDF_SUBPASS\nhighp float d=line_df(v_line_segment.xy,v_line_segment.zw,v_pos);highp float effect_radius=mix(v_flood_light_radius_tile,v_ao.y,u_ao_pass);d/=effect_radius;d=min(d,1.0);d=1.0-pow(1.0-d,u_attenuation);highp float effect_intensity=mix(u_flood_light_intensity,v_ao.x,u_ao_pass);highp float fog=1.0;\n#ifdef FOG\nfog=v_fog;\n#endif\n#ifdef RENDER_CUTOFF\nfog*=v_cutoff_opacity;\n#endif\nglFragColor=vec4(vec3(0.0),mix(1.0,d,effect_intensity*u_opacity*fog));\n#else\nvec4 color=mix(vec4(u_flood_light_color,1.0),vec4(vec3(0.0),1.0),u_ao_pass);\n#ifdef OVERDRAW_INSPECTOR\ncolor=vec4(1.0);\n#endif\nglFragColor=color;\n#endif\nHANDLE_WIREFRAME_DEBUG;\n#endif\n}", '#include "_prelude_fog.vertex.glsl"\nin highp vec4 a_pos_end;in highp float a_angular_offset_factor;in highp float a_hidden_by_landmark;\n#ifdef SDF_SUBPASS\nout highp vec2 v_pos;out highp vec4 v_line_segment;out highp float v_flood_light_radius_tile;out highp vec2 v_ao;\n#ifdef FOG\nout highp float v_fog;\n#endif\n#endif\nuniform highp float u_flood_light_intensity;uniform highp mat4 u_matrix;uniform highp float u_ao_pass;uniform highp float u_meter_to_tile;uniform highp float u_edge_radius;uniform highp float u_dynamic_offset;uniform highp vec2 u_ao;\n#pragma mapbox: define highp float flood_light_ground_radius\nconst float TANGENT_CUTOFF=4.0;const float NORM=32767.0;void main() {\n#pragma mapbox: initialize highp float flood_light_ground_radius\nvec2 p=a_pos_end.xy;vec2 q=floor(a_pos_end.zw*0.5);vec2 start_bottom=a_pos_end.zw-q*2.0;float fl_ground_radius=flood_light_ground_radius;fl_ground_radius=abs(flood_light_ground_radius);float direction=flood_light_ground_radius < 0.0 ?-1.0 : 1.0;float flood_radius_tile=fl_ground_radius*u_meter_to_tile;vec2 v=normalize(q-p);float ao_radius=u_ao.y/3.5;float effect_radius=mix(flood_radius_tile,ao_radius,u_ao_pass)+u_edge_radius;float angular_offset_factor=a_angular_offset_factor/NORM*TANGENT_CUTOFF;float angular_offset=direction*angular_offset_factor*effect_radius;float top=1.0-start_bottom.y;float side=(0.5-start_bottom.x)*2.0;vec2 extrusion_parallel=v*side*mix(u_dynamic_offset,angular_offset,top);vec2 perp=vec2(v.y,-v.x);vec2 extrusion_perp=direction*perp*effect_radius*top;vec3 pos=vec3(mix(q,p,start_bottom.x),0.0);pos.xy+=extrusion_parallel+extrusion_perp;\n#ifdef SDF_SUBPASS\nv_pos=pos.xy;v_line_segment=vec4(p,q)+perp.xyxy*u_edge_radius;v_flood_light_radius_tile=flood_radius_tile;v_ao=vec2(u_ao.x,ao_radius);\n#ifdef FOG\nv_fog_pos=fog_position(pos);v_fog=1.0-fog(v_fog_pos);\n#endif\n#endif\nfloat hidden_by_landmark=0.0;\n#ifdef HAS_CENTROID\nhidden_by_landmark=a_hidden_by_landmark;\n#endif\nfloat isFloodlit=float(fl_ground_radius > 0.0 && u_flood_light_intensity > 0.0);float hidden=mix(1.0-isFloodlit,isFloodlit,u_ao_pass);hidden+=hidden_by_landmark;gl_Position=mix(u_matrix*vec4(pos,1.0),AWAY,float(hidden > 0.0));\n#ifdef RENDER_CUTOFF\nv_cutoff_opacity=cutoff_opacity(u_cutoff_params,gl_Position.z);\n#endif\n}'),
            hillshadePrepare: Go("precision highp float;uniform sampler2D u_image;in vec2 v_pos;uniform vec2 u_dimension;uniform float u_zoom;float getElevation(vec2 coord) {return texture(u_image,coord).r/4.0;}void main() {vec2 epsilon=1.0/u_dimension;float a=getElevation(v_pos+vec2(-epsilon.x,-epsilon.y));float b=getElevation(v_pos+vec2(0,-epsilon.y));float c=getElevation(v_pos+vec2(epsilon.x,-epsilon.y));float d=getElevation(v_pos+vec2(-epsilon.x,0));float e=getElevation(v_pos+vec2(epsilon.x,0));float f=getElevation(v_pos+vec2(-epsilon.x,epsilon.y));float g=getElevation(v_pos+vec2(0,epsilon.y));float h=getElevation(v_pos+vec2(epsilon.x,epsilon.y));float exaggerationFactor=u_zoom < 2.0 ? 0.4 : u_zoom < 4.5 ? 0.35 : 0.3;float exaggeration=u_zoom < 15.0 ? (u_zoom-15.0)*exaggerationFactor : 0.0;vec2 deriv=vec2(\n(c+e+e+h)-(a+d+d+f),(f+g+g+h)-(a+b+b+c)\n)/pow(2.0,exaggeration+(19.2562-u_zoom));glFragColor=clamp(vec4(\nderiv.x/2.0+0.5,deriv.y/2.0+0.5,1.0,1.0),0.0,1.0);}", "uniform mat4 u_matrix;uniform vec2 u_dimension;in vec2 a_pos;in vec2 a_texture_pos;out vec2 v_pos;void main() {gl_Position=u_matrix*vec4(a_pos,0,1);highp vec2 epsilon=1.0/u_dimension;float scale=(u_dimension.x-2.0)/u_dimension.x;v_pos=(a_texture_pos/8192.0)*scale+epsilon;}"),
            hillshade: Go('#include "_prelude_fog.fragment.glsl"\n#include "_prelude_lighting.glsl"\nuniform sampler2D u_image;in vec2 v_pos;uniform vec2 u_latrange;uniform vec2 u_light;uniform vec4 u_shadow;uniform vec4 u_highlight;uniform vec4 u_accent;uniform float u_emissive_strength;void main() {vec4 pixel=texture(u_image,v_pos);vec2 deriv=((pixel.rg*2.0)-1.0);float scaleFactor=cos(radians((u_latrange[0]-u_latrange[1])*(1.0-v_pos.y)+u_latrange[1]));float slope=atan(1.25*length(deriv)/scaleFactor);float aspect=deriv.x !=0.0 ? atan(deriv.y,-deriv.x) : PI/2.0*(deriv.y > 0.0 ? 1.0 :-1.0);float intensity=u_light.x;float azimuth=u_light.y+PI;float base=1.875-intensity*1.75;float maxValue=0.5*PI;float scaledSlope=intensity !=0.5 ? ((pow(base,slope)-1.0)/(pow(base,maxValue)-1.0))*maxValue : slope;float accent=cos(scaledSlope);vec4 accent_color=(1.0-accent)*u_accent*clamp(intensity*2.0,0.0,1.0);float shade=abs(mod((aspect+azimuth)/PI+0.5,2.0)-1.0);vec4 shade_color=mix(u_shadow,u_highlight,shade)*sin(scaledSlope)*clamp(intensity*2.0,0.0,1.0);glFragColor=accent_color*(1.0-shade_color.a)+shade_color;\n#ifdef LIGHTING_3D_MODE\nglFragColor=apply_lighting_with_emission_ground(glFragColor,u_emissive_strength);\n#endif\n#ifdef FOG\nglFragColor=fog_dither(fog_apply_premultiplied(glFragColor,v_fog_pos));\n#endif\n#ifdef OVERDRAW_INSPECTOR\nglFragColor=vec4(1.0);\n#endif\nHANDLE_WIREFRAME_DEBUG;}', '#include "_prelude_fog.vertex.glsl"\nuniform mat4 u_matrix;in vec2 a_pos;in vec2 a_texture_pos;out vec2 v_pos;void main() {gl_Position=u_matrix*vec4(a_pos,0,1);v_pos=a_texture_pos/8192.0;\n#ifdef FOG\nv_fog_pos=fog_position(a_pos);\n#endif\n}'),
            line: Go('#include "_prelude_fog.fragment.glsl"\n#include "_prelude_lighting.glsl"\n#include "_prelude_shadow.fragment.glsl"\nuniform lowp float u_device_pixel_ratio;uniform highp float u_width_scale;uniform highp float u_floor_width_scale;uniform float u_alpha_discard_threshold;uniform highp vec2 u_trim_offset;uniform highp vec2 u_trim_fade_range;uniform lowp vec4 u_trim_color;in vec2 v_width2;in vec2 v_normal;in float v_gamma_scale;in highp vec3 v_uv;\n#ifdef ELEVATED_ROADS\nin highp float v_road_z_offset;\n#endif\n#ifdef RENDER_LINE_DASH\nuniform sampler2D u_dash_image;in vec2 v_tex;\n#endif\n#ifdef RENDER_LINE_GRADIENT\nuniform sampler2D u_gradient_image;\n#endif\n#ifdef INDICATOR_CUTOUT\nin highp float v_z_offset;\n#endif\n#ifdef RENDER_SHADOWS\nuniform vec3 u_ground_shadow_factor;in highp vec4 v_pos_light_view_0;in highp vec4 v_pos_light_view_1;in highp float v_depth;\n#endif\nfloat luminance(vec3 c) {return (c.r+c.r+c.b+c.g+c.g+c.g)*0.1667;}uniform float u_emissive_strength;\n#pragma mapbox: define highp vec4 color\n#pragma mapbox: define lowp float floorwidth\n#pragma mapbox: define lowp vec4 dash\n#pragma mapbox: define lowp float blur\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define lowp float border_width\n#pragma mapbox: define lowp vec4 border_color\nfloat linearstep(float edge0,float edge1,float x) {return  clamp((x-edge0)/(edge1-edge0),0.0,1.0);}void main() {\n#pragma mapbox: initialize highp vec4 color\n#pragma mapbox: initialize lowp float floorwidth\n#pragma mapbox: initialize lowp vec4 dash\n#pragma mapbox: initialize lowp float blur\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize lowp float border_width\n#pragma mapbox: initialize lowp vec4 border_color\nfloat dist=length(v_normal)*v_width2.s;float blur2=(u_width_scale*blur+1.0/u_device_pixel_ratio)*v_gamma_scale;float alpha=clamp(min(dist-(v_width2.t-blur2),v_width2.s-dist)/blur2,0.0,1.0);\n#ifdef RENDER_LINE_DASH\nfloat sdfdist=texture(u_dash_image,v_tex).r;float sdfgamma=1.0/(2.0*u_device_pixel_ratio)/dash.z;float scaled_floorwidth=(floorwidth*u_floor_width_scale);alpha*=linearstep(0.5-sdfgamma/scaled_floorwidth,0.5+sdfgamma/scaled_floorwidth,sdfdist);\n#endif\nhighp vec4 out_color;\n#ifdef RENDER_LINE_GRADIENT\nout_color=texture(u_gradient_image,v_uv.xy);\n#else\nout_color=color;\n#endif\nfloat trim_alpha=1.0;\n#ifdef RENDER_LINE_TRIM_OFFSET\nhighp float trim_start=u_trim_offset[0];highp float trim_end=u_trim_offset[1];highp float line_progress=v_uv[2];if (trim_end > trim_start) {highp float start_transition=max(0.0,min(1.0,(line_progress-trim_start)/max(u_trim_fade_range[0],1.0e-9)));highp float end_transition=max(0.0,min(1.0,(trim_end-line_progress)/max(u_trim_fade_range[1],1.0e-9)));highp float transition_factor=min(start_transition,end_transition);out_color=mix(out_color,u_trim_color,transition_factor);trim_alpha=1.0-transition_factor;}\n#endif\nif (u_alpha_discard_threshold !=0.0) {if (alpha < u_alpha_discard_threshold) {discard;}}\n#ifdef RENDER_LINE_BORDER\nfloat edgeBlur=((border_width*u_width_scale)+1.0/u_device_pixel_ratio);float alpha2=clamp(min(dist-(v_width2.t-edgeBlur),v_width2.s-dist)/edgeBlur,0.0,1.0);if (alpha2 < 1.) {float smoothAlpha=smoothstep(0.6,1.0,alpha2);if (border_color.a==0.0) {float Y=(out_color.a > 0.01) ? luminance(out_color.rgb/out_color.a) : 1.;float adjustment=(Y > 0.) ? 0.5/Y : 0.45;if (out_color.a > 0.25 && Y < 0.25) {vec3 borderColor=(Y > 0.) ? out_color.rgb : vec3(1,1,1)*out_color.a;out_color.rgb=out_color.rgb+borderColor*(adjustment*(1.0-smoothAlpha));} else {out_color.rgb*=(0.6 +0.4*smoothAlpha);}} else {out_color=mix(border_color*trim_alpha,out_color,smoothAlpha);}}\n#endif\n#ifdef LIGHTING_3D_MODE\nout_color=apply_lighting_with_emission_ground(out_color,u_emissive_strength);\n#ifdef RENDER_SHADOWS\nfloat light=shadowed_light_factor(v_pos_light_view_0,v_pos_light_view_1,v_depth);\n#ifdef ELEVATED_ROADS\nout_color.rgb*=mix(v_road_z_offset > 0.0 ? u_ground_shadow_factor : vec3(1.0),vec3(1.0),light);\n#else\nout_color.rgb*=mix(u_ground_shadow_factor,vec3(1.0),light);\n#endif\n#endif\n#endif\n#ifdef FOG\nout_color=fog_dither(fog_apply_premultiplied(out_color,v_fog_pos));\n#endif\nout_color*=(alpha*opacity);\n#ifdef INDICATOR_CUTOUT\nout_color=applyCutout(out_color,v_z_offset);\n#endif\nglFragColor=out_color;\n#ifdef OVERDRAW_INSPECTOR\nglFragColor=vec4(1.0);\n#endif\nHANDLE_WIREFRAME_DEBUG;}', '#include "_prelude_fog.vertex.glsl"\n#include "_prelude_shadow.vertex.glsl"\n#include "_prelude_terrain.vertex.glsl"\n#define EXTRUDE_SCALE 0.015873016\nin vec2 a_pos_normal;in vec4 a_data;\n#if defined(ELEVATED) || defined(ELEVATED_ROADS) || defined(VARIABLE_LINE_WIDTH)\nin vec3 a_z_offset_width;\n#endif\n#if defined(RENDER_LINE_GRADIENT) || defined(RENDER_LINE_TRIM_OFFSET)\nin highp vec3 a_packed;\n#endif\n#ifdef RENDER_LINE_DASH\nin float a_linesofar;\n#endif\nuniform mat4 u_matrix;uniform mat2 u_pixels_to_tile_units;uniform vec2 u_units_to_pixels;uniform lowp float u_device_pixel_ratio;uniform float u_width_scale;uniform highp float u_floor_width_scale;\n#ifdef ELEVATED\nuniform lowp float u_zbias_factor;uniform lowp float u_tile_to_meter;float sample_elevation(vec2 apos) {\n#ifdef ELEVATION_REFERENCE_SEA\nreturn 0.0;\n#else\nreturn elevation(apos);\n#endif\n}\n#endif\nout vec2 v_normal;out vec2 v_width2;out float v_gamma_scale;out highp vec3 v_uv;\n#ifdef ELEVATED_ROADS\nout highp float v_road_z_offset;\n#endif\n#ifdef RENDER_LINE_DASH\nuniform vec2 u_texsize;uniform float u_tile_units_to_pixels;out vec2 v_tex;\n#endif\n#ifdef RENDER_LINE_GRADIENT\nuniform float u_image_height;\n#endif\n#ifdef INDICATOR_CUTOUT\nout highp float v_z_offset;\n#endif\n#ifdef RENDER_SHADOWS\nuniform mat4 u_light_matrix_0;uniform mat4 u_light_matrix_1;out highp vec4 v_pos_light_view_0;out highp vec4 v_pos_light_view_1;out highp float v_depth;\n#endif\n#pragma mapbox: define highp vec4 color\n#pragma mapbox: define lowp float floorwidth\n#pragma mapbox: define lowp vec4 dash\n#pragma mapbox: define lowp float blur\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define mediump float gapwidth\n#pragma mapbox: define lowp float offset\n#pragma mapbox: define mediump float width\n#pragma mapbox: define lowp float border_width\n#pragma mapbox: define lowp vec4 border_color\nvoid main() {\n#pragma mapbox: initialize highp vec4 color\n#pragma mapbox: initialize lowp float floorwidth\n#pragma mapbox: initialize lowp vec4 dash\n#pragma mapbox: initialize lowp float blur\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize mediump float gapwidth\n#pragma mapbox: initialize lowp float offset\n#pragma mapbox: initialize mediump float width\n#pragma mapbox: initialize lowp float border_width\n#pragma mapbox: initialize lowp vec4 border_color\nfloat a_z_offset;\n#if defined(ELEVATED) || defined(ELEVATED_ROADS)\na_z_offset=a_z_offset_width.x;\n#endif\nfloat ANTIALIASING=1.0/u_device_pixel_ratio/2.0;vec2 a_extrude=a_data.xy-128.0;float a_direction=mod(a_data.z,4.0)-1.0;vec2 pos=floor(a_pos_normal*0.5);mediump vec2 normal=a_pos_normal-2.0*pos;normal.y=normal.y*2.0-1.0;v_normal=normal;gapwidth=gapwidth/2.0;float halfwidth;\n#ifdef VARIABLE_LINE_WIDTH\nfloat left=a_pos_normal.y-2.0*floor(a_pos_normal.y*0.5);halfwidth=(u_width_scale*(left==1.0 ? a_z_offset_width.y : a_z_offset_width.z))/2.0;\n#else\nhalfwidth=(u_width_scale*width)/2.0;\n#endif\noffset=-1.0*offset*u_width_scale;float inset=gapwidth+(gapwidth > 0.0 ? ANTIALIASING : 0.0);float outset=gapwidth+halfwidth*(gapwidth > 0.0 ? 2.0 : 1.0)+(halfwidth==0.0 ? 0.0 : ANTIALIASING);mediump vec2 dist=outset*a_extrude*EXTRUDE_SCALE;mediump float u=0.5*a_direction;mediump float t=1.0-abs(u);mediump vec2 offset2=offset*a_extrude*EXTRUDE_SCALE*normal.y*mat2(t,-u,u,t);float hidden=float(opacity==0.0);vec2 extrude=dist*u_pixels_to_tile_units;vec4 projected_extrude=u_matrix*vec4(extrude,0.0,0.0);vec2 projected_extrude_xy=projected_extrude.xy;\n#ifdef ELEVATED_ROADS\nv_road_z_offset=a_z_offset;gl_Position=u_matrix*vec4(pos+offset2*u_pixels_to_tile_units,a_z_offset,1.0)+projected_extrude;\n#else\n#ifdef ELEVATED\nvec2 offsetTile=offset2*u_pixels_to_tile_units;vec2 offset_pos=pos+offsetTile;float ele=0.0;\n#ifdef CROSS_SLOPE_VERTICAL\nfloat top=a_pos_normal.y-2.0*floor(a_pos_normal.y*0.5);float line_height=2.0*u_tile_to_meter*outset*top*u_pixels_to_tile_units[1][1]+a_z_offset;ele=sample_elevation(offset_pos)+line_height;projected_extrude=vec4(0);\n#else\n#ifdef CROSS_SLOPE_HORIZONTAL\nfloat ele0=sample_elevation(offset_pos);float ele1=max(sample_elevation(offset_pos+extrude),sample_elevation(offset_pos+extrude/2.0));float ele2=max(sample_elevation(offset_pos-extrude),sample_elevation(offset_pos-extrude/2.0));float ele_max=max(ele0,max(ele1,ele2));ele=ele_max+a_z_offset;\n#else\nfloat ele0=sample_elevation(offset_pos);float ele1=max(sample_elevation(offset_pos+extrude),sample_elevation(offset_pos+extrude/2.0));float ele2=max(sample_elevation(offset_pos-extrude),sample_elevation(offset_pos-extrude/2.0));float ele_max=max(ele0,0.5*(ele1+ele2));ele=ele_max-ele0+ele1+a_z_offset;\n#endif\n#endif\ngl_Position=u_matrix*vec4(offset_pos,ele,1.0)+projected_extrude;float z=clamp(gl_Position.z/gl_Position.w,0.5,1.0);float zbias=max(0.00005,(pow(z,0.8)-z)*u_zbias_factor*u_exaggeration);gl_Position.z-=(gl_Position.w*zbias);gl_Position=mix(gl_Position,AWAY,hidden);\n#else\ngl_Position=mix(u_matrix*vec4(pos+offset2*u_pixels_to_tile_units,0.0,1.0)+projected_extrude,AWAY,hidden);\n#endif\n#endif\n#ifdef ELEVATED_ROADS\n#ifdef RENDER_SHADOWS\nvec3 shd_pos=vec3(pos+(offset2+dist)*u_pixels_to_tile_units,a_z_offset);vec3 shd_pos0=shd_pos;vec3 shd_pos1=shd_pos;\n#ifdef NORMAL_OFFSET\nvec3 shd_pos_offset=shadow_normal_offset(vec3(0.0,0.0,1.0));shd_pos0+=shd_pos_offset*shadow_normal_offset_multiplier0();shd_pos1+=shd_pos_offset*shadow_normal_offset_multiplier1();\n#endif\nv_pos_light_view_0=u_light_matrix_0*vec4(shd_pos0,1);v_pos_light_view_1=u_light_matrix_1*vec4(shd_pos1,1);v_depth=gl_Position.w;\n#endif\n#endif\n#ifndef RENDER_TO_TEXTURE\nfloat extrude_length_without_perspective=length(dist);float extrude_length_with_perspective=length(projected_extrude_xy/gl_Position.w*u_units_to_pixels);v_gamma_scale=mix(extrude_length_without_perspective/extrude_length_with_perspective,1.0,step(0.01,blur));\n#else\nv_gamma_scale=1.0;\n#endif\n#if defined(RENDER_LINE_GRADIENT) || defined(RENDER_LINE_TRIM_OFFSET)\nhighp float a_uv_x=a_packed[0];float a_split_index=a_packed[1];highp float line_progress=a_packed[2];\n#ifdef RENDER_LINE_GRADIENT\nhighp float texel_height=1.0/u_image_height;highp float half_texel_height=0.5*texel_height;v_uv=vec3(a_uv_x,a_split_index*texel_height-half_texel_height,line_progress);\n#else\nv_uv=vec3(a_uv_x,0.0,line_progress);\n#endif\n#endif\n#ifdef RENDER_LINE_DASH\nfloat scale=dash.z==0.0 ? 0.0 : u_tile_units_to_pixels/dash.z;float height=dash.y;v_tex=vec2(a_linesofar*scale/(floorwidth*u_floor_width_scale),(-normal.y*height+dash.x+0.5)/u_texsize.y);\n#endif\nv_width2=vec2(outset,inset);\n#ifdef FOG\nv_fog_pos=fog_position(pos);\n#endif\n#ifdef INDICATOR_CUTOUT\nv_z_offset=a_z_offset;\n#endif\n}'),
            linePattern: Go('#include "_prelude_fog.fragment.glsl"\n#include "_prelude_lighting.glsl"\n#include "_prelude_shadow.fragment.glsl"\nuniform highp float u_device_pixel_ratio;uniform highp float u_width_scale;uniform highp float u_alpha_discard_threshold;uniform highp vec2 u_texsize;uniform highp float u_tile_units_to_pixels;uniform highp vec2 u_trim_offset;uniform highp vec2 u_trim_fade_range;uniform lowp vec4 u_trim_color;uniform sampler2D u_image;in vec2 v_normal;in vec2 v_width2;in highp float v_linesofar;in float v_gamma_scale;in float v_width;\n#ifdef RENDER_LINE_TRIM_OFFSET\nin highp vec3 v_uv;\n#endif\n#ifdef ELEVATED_ROADS\nin highp float v_road_z_offset;\n#endif\n#ifdef LINE_JOIN_NONE\nin vec2 v_pattern_data;\n#endif\n#ifdef INDICATOR_CUTOUT\nin highp float v_z_offset;\n#endif\n#ifdef RENDER_SHADOWS\nuniform vec3 u_ground_shadow_factor;in highp vec4 v_pos_light_view_0;in highp vec4 v_pos_light_view_1;in highp float v_depth;\n#endif\nuniform float u_emissive_strength;\n#pragma mapbox: define mediump vec4 pattern\n#pragma mapbox: define mediump float pixel_ratio\n#pragma mapbox: define mediump float blur\n#pragma mapbox: define mediump float opacity\nvoid main() {\n#pragma mapbox: initialize mediump vec4 pattern\n#pragma mapbox: initialize mediump float pixel_ratio\n#pragma mapbox: initialize mediump float blur\n#pragma mapbox: initialize mediump float opacity\nvec2 pattern_tl=pattern.xy;vec2 pattern_br=pattern.zw;vec2 display_size=(pattern_br-pattern_tl)/pixel_ratio;highp float pattern_size=display_size.x/u_tile_units_to_pixels;float aspect=display_size.y/v_width;float dist=length(v_normal)*v_width2.s;float blur2=(u_width_scale*blur+1.0/u_device_pixel_ratio)*v_gamma_scale;float alpha=clamp(min(dist-(v_width2.t-blur2),v_width2.s-dist)/blur2,0.0,1.0);highp float pattern_x=v_linesofar/pattern_size*aspect;highp float x=mod(pattern_x,1.0);highp float y=0.5*v_normal.y+0.5;vec2 texel_size=1.0/u_texsize;highp vec2 pos=mix(pattern_tl*texel_size-texel_size,pattern_br*texel_size+texel_size,vec2(x,y));highp vec2 lod_pos=mix(pattern_tl*texel_size-texel_size,pattern_br*texel_size+texel_size,vec2(pattern_x,y));vec4 color=textureLodCustom(u_image,pos,lod_pos);\n#ifdef RENDER_LINE_TRIM_OFFSET\nhighp float trim_start=u_trim_offset[0];highp float trim_end=u_trim_offset[1];highp float line_progress=v_uv[2];if (trim_end > trim_start) {highp float start_transition=max(0.0,min(1.0,(line_progress-trim_start)/max(u_trim_fade_range[0],1.0e-9)));highp float end_transition=max(0.0,min(1.0,(trim_end-line_progress)/max(u_trim_fade_range[1],1.0e-9)));highp float transition_factor=min(start_transition,end_transition);color=mix(color,color.a*u_trim_color,transition_factor);}\n#endif\n#ifdef LINE_JOIN_NONE\nhighp float pattern_len=pattern_size/aspect;highp float segment_phase=pattern_len-mod(v_linesofar-v_pattern_data.x+pattern_len,pattern_len);highp float visible_start=segment_phase-step(pattern_len*0.5,segment_phase)*pattern_len;highp float visible_end=floor((v_pattern_data.y-segment_phase)/pattern_len)*pattern_len+segment_phase;visible_end+=step(pattern_len*0.5,v_pattern_data.y-visible_end)*pattern_len;if (v_pattern_data.x < visible_start || v_pattern_data.x >=visible_end) {color=vec4(0.0);}\n#endif\n#ifdef LIGHTING_3D_MODE\ncolor=apply_lighting_with_emission_ground(color,u_emissive_strength);\n#ifdef RENDER_SHADOWS\nfloat light=shadowed_light_factor(v_pos_light_view_0,v_pos_light_view_1,v_depth);\n#ifdef ELEVATED_ROADS\ncolor.rgb*=mix(v_road_z_offset > 0.0 ? u_ground_shadow_factor : vec3(1.0),vec3(1.0),light);\n#else\ncolor.rgb*=mix(u_ground_shadow_factor,vec3(1.0),light);\n#endif\n#endif\n#endif\n#ifdef FOG\ncolor=fog_dither(fog_apply_premultiplied(color,v_fog_pos));\n#endif\ncolor*=(alpha*opacity);if (u_alpha_discard_threshold !=0.0) {if (color.a < u_alpha_discard_threshold) {discard;}}\n#ifdef INDICATOR_CUTOUT\ncolor=applyCutout(color,v_z_offset);\n#endif\nglFragColor=color;\n#ifdef OVERDRAW_INSPECTOR\nglFragColor=vec4(1.0);\n#endif\nHANDLE_WIREFRAME_DEBUG;}', '#include "_prelude_fog.vertex.glsl"\n#include "_prelude_shadow.vertex.glsl"\n#include "_prelude_terrain.vertex.glsl"\n#define scale 0.015873016\nin vec2 a_pos_normal;in vec4 a_data;\n#if defined(ELEVATED) || defined(ELEVATED_ROADS)\nin vec3 a_z_offset_width;\n#endif\n#ifdef RENDER_LINE_TRIM_OFFSET\nin highp vec3 a_packed;\n#endif\nin highp float a_linesofar;\n#ifdef LINE_JOIN_NONE\nin highp vec3 a_pattern_data;out vec2 v_pattern_data;\n#endif\n#ifdef INDICATOR_CUTOUT\nout highp float v_z_offset;\n#endif\nuniform mat4 u_matrix;uniform float u_tile_units_to_pixels;uniform vec2 u_units_to_pixels;uniform mat2 u_pixels_to_tile_units;uniform float u_device_pixel_ratio;uniform float u_width_scale;uniform float u_floor_width_scale;\n#ifdef ELEVATED\nuniform lowp float u_zbias_factor;uniform lowp float u_tile_to_meter;float sample_elevation(vec2 apos) {\n#ifdef ELEVATION_REFERENCE_SEA\nreturn 0.0;\n#else\nreturn elevation(apos);\n#endif\n}\n#endif\nout vec2 v_normal;out vec2 v_width2;out highp float v_linesofar;out float v_gamma_scale;out float v_width;\n#ifdef RENDER_LINE_TRIM_OFFSET\nout highp vec3 v_uv;\n#endif\n#ifdef ELEVATED_ROADS\nout highp float v_road_z_offset;\n#endif\n#ifdef RENDER_SHADOWS\nuniform mat4 u_light_matrix_0;uniform mat4 u_light_matrix_1;out highp vec4 v_pos_light_view_0;out highp vec4 v_pos_light_view_1;out highp float v_depth;\n#endif\n#pragma mapbox: define mediump float blur\n#pragma mapbox: define mediump float opacity\n#pragma mapbox: define mediump float offset\n#pragma mapbox: define mediump float gapwidth\n#pragma mapbox: define mediump float width\n#pragma mapbox: define mediump float floorwidth\n#pragma mapbox: define mediump vec4 pattern\n#pragma mapbox: define mediump float pixel_ratio\nvoid main() {\n#pragma mapbox: initialize mediump float blur\n#pragma mapbox: initialize mediump float opacity\n#pragma mapbox: initialize mediump float offset\n#pragma mapbox: initialize mediump float gapwidth\n#pragma mapbox: initialize mediump float width\n#pragma mapbox: initialize mediump float floorwidth\n#pragma mapbox: initialize mediump vec4 pattern\n#pragma mapbox: initialize mediump float pixel_ratio\nfloat a_z_offset;\n#if defined(ELEVATED) || defined(ELEVATED_ROADS)\na_z_offset=a_z_offset_width.x;\n#endif\nfloat ANTIALIASING=1.0/u_device_pixel_ratio/2.0;vec2 a_extrude=a_data.xy-128.0;float a_direction=mod(a_data.z,4.0)-1.0;vec2 pos=floor(a_pos_normal*0.5);vec2 normal=a_pos_normal-2.0*pos;normal.y=normal.y*2.0-1.0;v_normal=normal;gapwidth=gapwidth/2.0;float halfwidth=(u_width_scale*width)/2.0;offset=-1.0*offset*u_width_scale;float inset=gapwidth+(gapwidth > 0.0 ? ANTIALIASING : 0.0);float outset=gapwidth+halfwidth*(gapwidth > 0.0 ? 2.0 : 1.0)+(halfwidth==0.0 ? 0.0 : ANTIALIASING);vec2 dist=outset*a_extrude*scale;float u=0.5*a_direction;float t=1.0-abs(u);vec2 offset2=offset*a_extrude*scale*normal.y*mat2(t,-u,u,t);float hidden=float(opacity==0.0);vec2 extrude=dist*u_pixels_to_tile_units;vec4 projected_extrude=u_matrix*vec4(extrude,0.0,0.0);vec2 projected_extrude_xy=projected_extrude.xy;\n#ifdef ELEVATED_ROADS\nv_road_z_offset=a_z_offset;gl_Position=u_matrix*vec4(pos+offset2*u_pixels_to_tile_units,a_z_offset,1.0)+projected_extrude;\n#else\n#ifdef ELEVATED\nvec2 offsetTile=offset2*u_pixels_to_tile_units;vec2 offset_pos=pos+offsetTile;float ele=0.0;\n#ifdef CROSS_SLOPE_VERTICAL\nfloat top=a_pos_normal.y-2.0*floor(a_pos_normal.y*0.5);float line_height=2.0*u_tile_to_meter*outset*top*u_pixels_to_tile_units[1][1]+a_z_offset;ele=sample_elevation(offset_pos)+line_height;projected_extrude=vec4(0);\n#else\n#ifdef CROSS_SLOPE_HORIZONTAL\nfloat ele0=sample_elevation(offset_pos);float ele1=max(sample_elevation(offset_pos+extrude),sample_elevation(offset_pos+extrude/2.0));float ele2=max(sample_elevation(offset_pos-extrude),sample_elevation(offset_pos-extrude/2.0));float ele_max=max(ele0,max(ele1,ele2));ele=ele_max+a_z_offset;\n#else\nfloat ele0=sample_elevation(offset_pos);float ele1=max(sample_elevation(offset_pos+extrude),sample_elevation(offset_pos+extrude/2.0));float ele2=max(sample_elevation(offset_pos-extrude),sample_elevation(offset_pos-extrude/2.0));float ele_max=max(ele0,0.5*(ele1+ele2));ele=ele_max-ele0+ele1+a_z_offset;\n#endif\n#endif\ngl_Position=u_matrix*vec4(offset_pos,ele,1.0)+projected_extrude;float z=clamp(gl_Position.z/gl_Position.w,0.5,1.0);float zbias=max(0.00005,(pow(z,0.8)-z)*u_zbias_factor*u_exaggeration);gl_Position.z-=(gl_Position.w*zbias);gl_Position=mix(gl_Position,AWAY,hidden);\n#else\ngl_Position=mix(u_matrix*vec4(pos+offset2*u_pixels_to_tile_units,0.0,1.0)+projected_extrude,AWAY,hidden);\n#endif\n#endif\n#ifdef ELEVATED_ROADS\n#ifdef RENDER_SHADOWS\nvec3 shd_pos=vec3(pos+(offset2+dist)*u_pixels_to_tile_units,a_z_offset);vec3 shd_pos0=shd_pos;vec3 shd_pos1=shd_pos;\n#ifdef NORMAL_OFFSET\nvec3 shd_pos_offset=shadow_normal_offset(vec3(0.0,0.0,1.0));shd_pos0+=shd_pos_offset*shadow_normal_offset_multiplier0();shd_pos1+=shd_pos_offset*shadow_normal_offset_multiplier1();\n#endif\nv_pos_light_view_0=u_light_matrix_0*vec4(shd_pos0,1);v_pos_light_view_1=u_light_matrix_1*vec4(shd_pos1,1);v_depth=gl_Position.w;\n#endif\n#endif\n#ifndef RENDER_TO_TEXTURE\nfloat extrude_length_without_perspective=length(dist);float extrude_length_with_perspective=length(projected_extrude_xy/gl_Position.w*u_units_to_pixels);v_gamma_scale=mix(extrude_length_without_perspective/extrude_length_with_perspective,1.0,step(0.01,blur));\n#else\nv_gamma_scale=1.0;\n#endif\n#ifdef RENDER_LINE_TRIM_OFFSET\nhighp float a_uv_x=a_packed[0];highp float line_progress=a_packed[2];v_uv=vec3(a_uv_x,0.0,line_progress);\n#endif\nv_linesofar=a_linesofar;v_width2=vec2(outset,inset);v_width=(floorwidth*u_floor_width_scale);\n#ifdef LINE_JOIN_NONE\nv_width=(floorwidth*u_floor_width_scale)+ANTIALIASING;mediump float pixels_to_tile_units=1.0/u_tile_units_to_pixels;mediump float pixel_ratio_inverse=1.0/pixel_ratio;mediump float aspect=v_width/((pattern.w-pattern.y)*pixel_ratio_inverse);highp float subt_multiple=(pattern.z-pattern.x)*pixel_ratio_inverse*pixels_to_tile_units*aspect*32.0;highp float subt=floor(a_pattern_data.z/subt_multiple)*subt_multiple;float offset_sign=(fract(a_pattern_data.x)-0.5)*4.0;float line_progress_offset=offset_sign*v_width*0.5*pixels_to_tile_units;v_linesofar=(a_pattern_data.z-subt)+a_linesofar+line_progress_offset;v_pattern_data=vec2(a_pattern_data.x+line_progress_offset,a_pattern_data.y);\n#endif\n#ifdef FOG\nv_fog_pos=fog_position(pos);\n#endif\n#ifdef INDICATOR_CUTOUT\nv_z_offset=a_z_offset;\n#endif\n}'),
            raster: Go('#include "_prelude_fog.fragment.glsl"\n#include "_prelude_lighting.glsl"\n#include "_prelude_raster_array.glsl"\nuniform float u_fade_t;uniform float u_opacity;uniform highp float u_raster_elevation;uniform highp float u_zoom_transition;in vec2 v_pos0;in vec2 v_pos1;in float v_depth;\n#ifdef PROJECTION_GLOBE_VIEW\nin float v_split_fade;\n#endif\nuniform float u_brightness_low;uniform float u_brightness_high;uniform float u_saturation_factor;uniform float u_contrast_factor;uniform vec3 u_spin_weights;uniform float u_emissive_strength;\n#ifndef RASTER_ARRAY\nuniform highp sampler2D u_image0;uniform sampler2D u_image1;\n#endif\n#ifdef RASTER_COLOR\nuniform sampler2D u_color_ramp;uniform highp vec4 u_colorization_mix;uniform highp float u_colorization_offset;uniform vec2 u_texture_res;\n#endif\nvoid main() {vec4 color0,color1,color;vec2 value;\n#ifdef RASTER_COLOR\n#ifdef RASTER_ARRAY\n#ifdef RASTER_ARRAY_LINEAR\nvalue=mix(\nraTexture2D_image0_linear(v_pos0,u_texture_res,u_colorization_mix,u_colorization_offset),raTexture2D_image1_linear(v_pos1,u_texture_res,u_colorization_mix,u_colorization_offset),u_fade_t\n);\n#else\nvalue=mix(\nraTexture2D_image0_nearest(v_pos0,u_texture_res,u_colorization_mix,u_colorization_offset),raTexture2D_image1_nearest(v_pos1,u_texture_res,u_colorization_mix,u_colorization_offset),u_fade_t\n);\n#endif\nif (value.y > 0.0) value.x/=value.y;\n#else\ncolor=mix(texture(u_image0,v_pos0),texture(u_image1,v_pos1),u_fade_t);value=vec2(u_colorization_offset+dot(color.rgb,u_colorization_mix.rgb),color.a);\n#endif\ncolor=texture(u_color_ramp,vec2(value.x,0.5));if (color.a > 0.0) color.rgb/=color.a;color.a*=value.y;\n#else\ncolor0=texture(u_image0,v_pos0);color1=texture(u_image1,v_pos1);if (color0.a > 0.0) color0.rgb/=color0.a;if (color1.a > 0.0) color1.rgb/=color1.a;color=mix(color0,color1,u_fade_t);\n#endif\ncolor.a*=u_opacity;\n#ifdef GLOBE_POLES\ncolor.a*=1.0-smoothstep(0.0,0.05,u_zoom_transition);\n#endif\nvec3 rgb=color.rgb;rgb=vec3(\ndot(rgb,u_spin_weights.xyz),dot(rgb,u_spin_weights.zxy),dot(rgb,u_spin_weights.yzx));float average=(color.r+color.g+color.b)/3.0;rgb+=(average-rgb)*u_saturation_factor;rgb=(rgb-0.5)*u_contrast_factor+0.5;vec3 u_high_vec=vec3(u_brightness_low,u_brightness_low,u_brightness_low);vec3 u_low_vec=vec3(u_brightness_high,u_brightness_high,u_brightness_high);vec3 out_color=mix(u_high_vec,u_low_vec,rgb);\n#ifdef LIGHTING_3D_MODE\nout_color=apply_lighting_with_emission_ground(vec4(out_color,1.0),u_emissive_strength).rgb;\n#endif\n#ifdef FOG\nhighp float fog_limit_high_meters=1000000.0;highp float fog_limit_low_meters=600000.0;float fog_limit=1.0-smoothstep(fog_limit_low_meters,fog_limit_high_meters,u_raster_elevation);out_color=fog_dither(fog_apply(out_color,v_fog_pos,fog_limit));\n#endif\nglFragColor=vec4(out_color*color.a,color.a);\n#ifdef PROJECTION_GLOBE_VIEW\nglFragColor*=mix(1.0,1.0-smoothstep(0.0,0.05,u_zoom_transition),smoothstep(0.8,0.9,v_split_fade));\n#endif\n#ifdef RENDER_CUTOFF\nglFragColor=glFragColor*cutoff_opacity(u_cutoff_params,v_depth);\n#endif\n#ifdef OVERDRAW_INSPECTOR\nglFragColor=vec4(1.0);\n#endif\nHANDLE_WIREFRAME_DEBUG;}', '#include "_prelude_fog.vertex.glsl"\nuniform mat4 u_matrix;uniform mat4 u_normalize_matrix;uniform mat4 u_globe_matrix;uniform mat4 u_merc_matrix;uniform mat3 u_grid_matrix;uniform vec2 u_tl_parent;uniform float u_scale_parent;uniform vec2 u_perspective_transform;uniform vec2 u_texture_offset;uniform float u_raster_elevation;uniform float u_zoom_transition;uniform vec2 u_merc_center;\n#define GLOBE_UPSCALE GLOBE_RADIUS/6371008.8\n#ifdef GLOBE_POLES\nin vec3 a_globe_pos;in vec2 a_uv;\n#else\nin vec2 a_pos;in vec2 a_texture_pos;\n#endif\nout vec2 v_pos0;out vec2 v_pos1;out float v_depth;\n#ifdef PROJECTION_GLOBE_VIEW\nout float v_split_fade;\n#endif\nvoid main() {vec2 uv;\n#ifdef GLOBE_POLES\nvec3 globe_pos=a_globe_pos;globe_pos+=normalize(globe_pos)*u_raster_elevation*GLOBE_UPSCALE;gl_Position=u_matrix*u_globe_matrix*vec4(globe_pos   ,1.0);uv=a_uv;\n#ifdef FOG\nv_fog_pos=fog_position((u_normalize_matrix*vec4(a_globe_pos,1.0)).xyz);\n#endif\n#else\nfloat w=1.0+dot(a_texture_pos,u_perspective_transform);uv=a_texture_pos/8192.0;\n#ifdef PROJECTION_GLOBE_VIEW\nvec3 decomposed_pos_and_skirt=decomposeToPosAndSkirt(a_pos);vec3 latLng=u_grid_matrix*vec3(decomposed_pos_and_skirt.xy,1.0);vec3 globe_pos=latLngToECEF(latLng.xy);globe_pos+=normalize(globe_pos)*u_raster_elevation*GLOBE_UPSCALE;vec4 globe_world_pos=u_globe_matrix*vec4(globe_pos,1.0);vec4 merc_world_pos=vec4(0.0);float mercatorY=mercatorYfromLat(latLng[0]);float mercatorX=mercatorXfromLng(latLng[1]);    \nv_split_fade=0.0;if (u_zoom_transition > 0.0) {vec2 merc_pos=vec2(mercatorX,mercatorY);merc_world_pos=vec4(merc_pos,u_raster_elevation,1.0);merc_world_pos.xy-=u_merc_center;merc_world_pos.x=wrap(merc_world_pos.x,-0.5,0.5);merc_world_pos=u_merc_matrix*merc_world_pos;float opposite_merc_center=mod(u_merc_center.x+0.5,1.0);float dist_from_poles=(abs(mercatorY-0.5)*2.0);float range=0.1;v_split_fade=abs(opposite_merc_center-mercatorX);v_split_fade=clamp(1.0-v_split_fade,0.0,1.0);v_split_fade=max(smoothstep(1.0-range,1.0,dist_from_poles),max(smoothstep(1.0-range,1.0,v_split_fade),smoothstep(1.0-range,1.0,1.0-v_split_fade)));}float tiles=u_grid_matrix[0][2];if (tiles > 0.0) {float idx=u_grid_matrix[1][2];float idy=u_grid_matrix[2][2];float uvY=mercatorY*tiles-idy;float uvX=mercatorX*tiles-idx;uv=vec2(uvX,uvY);}vec4 interpolated_pos=vec4(mix(globe_world_pos.xyz,merc_world_pos.xyz,u_zoom_transition)*w,w);gl_Position=u_matrix*interpolated_pos;\n#ifdef FOG\nv_fog_pos=fog_position((u_normalize_matrix*vec4(globe_pos,1.0)).xyz);\n#endif\n#else\ngl_Position=u_matrix*vec4(a_pos*w,u_raster_elevation*w,w);\n#ifdef FOG\nv_fog_pos=fog_position(a_pos);\n#endif\n#endif\n#endif\nv_pos0=uv;v_pos1=(v_pos0*u_scale_parent)+u_tl_parent;v_pos0=u_texture_offset.x+u_texture_offset.y*v_pos0;v_pos1=u_texture_offset.x+u_texture_offset.y*v_pos1;\n#ifdef RENDER_CUTOFF\nv_depth=gl_Position.z;\n#endif\n}'),
            rasterParticle: Go('#include "_prelude_fog.fragment.glsl"\n#include "_prelude_lighting.glsl"\nuniform float u_fade_t;uniform float u_opacity;uniform highp float u_raster_elevation;in vec2 v_pos0;in vec2 v_pos1;uniform sampler2D u_image0;uniform sampler2D u_image1;void main() {vec4 color0,color1,color;color0=texture(u_image0,v_pos0);color1=texture(u_image1,v_pos1);if (color0.a > 0.0) color0.rgb/=color0.a;if (color1.a > 0.0) color1.rgb/=color1.a;color=mix(color0,color1,u_fade_t);color.a*=u_opacity;vec3 out_color=color.rgb;\n#ifdef LIGHTING_3D_MODE\nout_color=apply_lighting_with_emission_ground(vec4(out_color,1.0),0.0).rgb;\n#endif\n#ifdef FOG\nhighp float fog_limit_high_meters=1000000.0;highp float fog_limit_low_meters=600000.0;float fog_limit=1.0-smoothstep(fog_limit_low_meters,fog_limit_high_meters,u_raster_elevation);out_color=fog_dither(fog_apply(out_color,v_fog_pos,fog_limit));\n#endif\nglFragColor=vec4(out_color*color.a,color.a);\n#ifdef OVERDRAW_INSPECTOR\nglFragColor=vec4(1.0);\n#endif\nHANDLE_WIREFRAME_DEBUG;}', '#include "_prelude_fog.vertex.glsl"\nuniform mat4 u_matrix;uniform mat4 u_normalize_matrix;uniform mat4 u_globe_matrix;uniform mat4 u_merc_matrix;uniform mat3 u_grid_matrix;uniform vec2 u_tl_parent;uniform float u_scale_parent;uniform float u_raster_elevation;uniform float u_zoom_transition;uniform vec2 u_merc_center;\n#define GLOBE_UPSCALE GLOBE_RADIUS/6371008.8\nin vec2 a_pos;in vec2 a_texture_pos;out vec2 v_pos0;out vec2 v_pos1;void main() {float w=1.0;vec2 uv;\n#ifdef PROJECTION_GLOBE_VIEW\nvec3 decomposed_pos_and_skirt=decomposeToPosAndSkirt(a_pos);vec3 latLng=u_grid_matrix*vec3(decomposed_pos_and_skirt.xy,1.0);float mercatorY=mercatorYfromLat(latLng[0]);float mercatorX=mercatorXfromLng(latLng[1]);float tiles=u_grid_matrix[0][2];float idx=u_grid_matrix[1][2];float idy=u_grid_matrix[2][2];float uvX=mercatorX*tiles-idx;float uvY=mercatorY*tiles-idy;uv=vec2(uvX,uvY);vec3 globe_pos=latLngToECEF(latLng.xy);globe_pos+=normalize(globe_pos)*u_raster_elevation*GLOBE_UPSCALE;vec4 globe_world_pos=u_globe_matrix*vec4(globe_pos,1.0);vec4 merc_world_pos=vec4(0.0);if (u_zoom_transition > 0.0) {vec2 merc_pos=vec2(mercatorX,mercatorY);merc_world_pos=vec4(merc_pos,u_raster_elevation,1.0);merc_world_pos.xy-=u_merc_center;merc_world_pos.x=wrap(merc_world_pos.x,-0.5,0.5);merc_world_pos=u_merc_matrix*merc_world_pos;}vec4 interpolated_pos=vec4(mix(globe_world_pos.xyz,merc_world_pos.xyz,u_zoom_transition)*w,w);gl_Position=u_matrix*interpolated_pos;\n#ifdef FOG\nv_fog_pos=fog_position((u_normalize_matrix*vec4(globe_pos,1.0)).xyz);\n#endif\n#else\nuv=a_texture_pos/8192.0;gl_Position=u_matrix*vec4(a_pos*w,u_raster_elevation*w,w);\n#ifdef FOG\nv_fog_pos=fog_position(a_pos);\n#endif\n#endif\nv_pos0=uv;v_pos1=(v_pos0*u_scale_parent)+u_tl_parent;}'),
            rasterParticleDraw: Go("uniform sampler2D u_color_ramp;in float v_particle_speed;void main() {glFragColor=texture(u_color_ramp,vec2(v_particle_speed,0.5));}", '#include "_prelude_raster_particle.glsl"\nin float a_index;uniform sampler2D u_particle_texture;uniform float u_particle_texture_side_len;uniform vec2 u_tile_offset;out float v_particle_speed;void main() {ivec2 pixel_coord=ivec2(\nmod(a_index,u_particle_texture_side_len),a_index/u_particle_texture_side_len);vec4 pixel=texelFetch(u_particle_texture,pixel_coord,0);vec2 pos=unpack_pos_from_rgba(pixel)+u_tile_offset;vec2 tex_coord=fract(pos);vec2 velocity=lookup_velocity(tex_coord);if (velocity==INVALID_VELOCITY) {gl_Position=AWAY;v_particle_speed=0.0;} else {gl_Position=vec4(2.0*pos-1.0,0,1);v_particle_speed=length(velocity);}gl_PointSize=1.0;}'),
            rasterParticleTexture: Go("uniform sampler2D u_texture;uniform float u_opacity;in vec2 v_tex_pos;void main() {vec4 color=texture(u_texture,v_tex_pos);glFragColor=vec4(floor(255.0*color*u_opacity)/255.0);}", "in vec2 a_pos;out vec2 v_tex_pos;void main() {vec2 uv=0.5*a_pos+vec2(0.5);v_tex_pos=uv;gl_Position=vec4(a_pos,0.0,1.0);}"),
            rasterParticleUpdate: Go('#include "_prelude_raster_particle.glsl"\nuniform sampler2D u_particle_texture;uniform mediump float u_particle_texture_side_len;uniform mediump float u_speed_factor;uniform highp float u_reset_rate;uniform highp float u_rand_seed;in highp vec2 v_tex_coord;vec2 linearstep(vec2 edge0,vec2 edge1,vec2 x) {return  clamp((x-edge0)/(edge1-edge0),vec2(0),vec2(1));}const highp vec3 rand_constants=vec3(12.9898,78.233,4375.85453);highp float rand(const highp vec2 co) {highp float t=dot(rand_constants.xy,co);return fract(sin(t)*(rand_constants.z+t));}void main() {ivec2 pixel_coord=ivec2(v_tex_coord*u_particle_texture_side_len);highp vec4 pixel=texelFetch(u_particle_texture,pixel_coord,0);highp vec2 pos=unpack_pos_from_rgba(pixel);highp vec2 velocity=lookup_velocity(clamp(pos,0.0,1.0));highp vec2 dp=velocity==INVALID_VELOCITY ? vec2(0) : velocity*u_speed_factor;pos=pos+dp;highp vec2 seed=(pos+v_tex_coord)*u_rand_seed;highp vec2 random_pos=vec2(rand(seed+1.3),rand(seed+2.1));highp vec2 persist_rate=pow(\nlinearstep(vec2(-u_particle_pos_offset),vec2(0),pos)*linearstep(vec2(1.0+u_particle_pos_offset),vec2(1),pos),vec2(4)\n);highp vec2 per_frame_persist=pow(persist_rate,abs(dp)/u_particle_pos_offset);highp float drop_rate=1.0-per_frame_persist.x*per_frame_persist.y;drop_rate=any(greaterThanEqual(abs(pos-0.5),vec2(0.5+u_particle_pos_offset))) ? 1.0 : drop_rate;highp float drop=step(1.0-drop_rate-u_reset_rate,rand(seed));highp vec2 next_pos=mix(pos,random_pos,drop);glFragColor=pack_pos_to_rgba(next_pos);}', "in vec2 a_pos;out vec2 v_tex_coord;void main() {v_tex_coord=0.5*(a_pos+vec2(1.0));gl_Position=vec4(a_pos,0.0,1.0);}"),
            symbol: Go('#include "_prelude_lighting.glsl"\n#define SDF_PX 8.0\n#define SDF 1.0\n#define ICON 0.0\nuniform sampler2D u_texture;uniform sampler2D u_texture_icon;uniform highp float u_gamma_scale;uniform lowp float u_device_pixel_ratio;uniform bool u_is_text;uniform bool u_is_halo;uniform lowp float u_scale_factor;\n#ifdef ICON_TRANSITION\nuniform float u_icon_transition;\n#endif\n#ifdef COLOR_ADJUSTMENT\nuniform mat4 u_color_adj_mat;\n#endif\n#ifdef INDICATOR_CUTOUT\nin highp float v_z_offset;\n#endif\nin vec2 v_tex_a;\n#ifdef ICON_TRANSITION\nin vec2 v_tex_b;\n#endif\nin float v_draw_halo;in vec3 v_gamma_scale_size_fade_opacity;\n#ifdef RENDER_TEXT_AND_SYMBOL\nin float is_sdf;in vec2 v_tex_a_icon;\n#endif\n#pragma mapbox: define highp vec4 fill_color\n#pragma mapbox: define highp vec4 halo_color\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define lowp float halo_width\n#pragma mapbox: define lowp float halo_blur\n#pragma mapbox: define lowp float emissive_strength\nvoid main() {\n#pragma mapbox: initialize highp vec4 fill_color\n#pragma mapbox: initialize highp vec4 halo_color\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize lowp float halo_width\n#pragma mapbox: initialize lowp float halo_blur\n#pragma mapbox: initialize lowp float emissive_strength\nvec4 out_color;float fade_opacity=v_gamma_scale_size_fade_opacity[2];\n#ifdef RENDER_TEXT_AND_SYMBOL\nif (is_sdf==ICON) {vec2 tex_icon=v_tex_a_icon;lowp float alpha=opacity*fade_opacity;glFragColor=texture(u_texture_icon,tex_icon)*alpha;\n#ifdef OVERDRAW_INSPECTOR\nglFragColor=vec4(1.0);\n#endif\nreturn;}\n#endif\n#ifdef RENDER_SDF\nfloat EDGE_GAMMA=0.105/u_device_pixel_ratio;float gamma_scale=v_gamma_scale_size_fade_opacity.x;float size=v_gamma_scale_size_fade_opacity.y;float fontScale=u_is_text ? size/24.0 : size;out_color=fill_color;highp float gamma=EDGE_GAMMA/(fontScale*u_gamma_scale);lowp float buff=(256.0-64.0)/256.0;bool draw_halo=v_draw_halo > 0.0;if (draw_halo) {out_color=halo_color;gamma=(halo_blur*u_scale_factor*1.19/SDF_PX+EDGE_GAMMA)/(fontScale*u_gamma_scale);buff=(6.0-halo_width*u_scale_factor/fontScale)/SDF_PX;}lowp float dist=texture(u_texture,v_tex_a).r;highp float gamma_scaled=gamma*gamma_scale;highp float alpha=smoothstep(buff-gamma_scaled,buff+gamma_scaled,dist);out_color*=alpha;\n#else\n#ifdef ICON_TRANSITION\nvec4 a=texture(u_texture,v_tex_a)*(1.0-u_icon_transition);vec4 b=texture(u_texture,v_tex_b)*u_icon_transition;out_color=(a+b);\n#else\nout_color=texture(u_texture,v_tex_a);\n#endif\n#ifdef COLOR_ADJUSTMENT\nout_color=u_color_adj_mat*out_color;\n#endif\n#endif\nout_color*=opacity*fade_opacity;\n#ifdef LIGHTING_3D_MODE\nout_color=apply_lighting_with_emission_ground(out_color,emissive_strength);\n#endif\n#ifdef INDICATOR_CUTOUT\nout_color=applyCutout(out_color,v_z_offset);\n#endif\nglFragColor=out_color;\n#ifdef OVERDRAW_INSPECTOR\nglFragColor=vec4(1.0);\n#endif\nHANDLE_WIREFRAME_DEBUG;}', '#include "_prelude_terrain.vertex.glsl"\nin vec4 a_pos_offset;in vec4 a_tex_size;in vec4 a_pixeloffset;in vec4 a_projected_pos;in float a_fade_opacity;\n#ifdef Z_OFFSET\nin float a_auto_z_offset;\n#endif\n#ifdef PROJECTION_GLOBE_VIEW\nin vec3 a_globe_anchor;in vec3 a_globe_normal;\n#endif\n#ifdef ICON_TRANSITION\nin vec2 a_texb;\n#endif\n#ifdef OCCLUSION_QUERIES\nin float a_occlusion_query_opacity;\n#endif\n#ifdef INDICATOR_CUTOUT\nout highp float v_z_offset;\n#endif\nuniform bool u_is_size_zoom_constant;uniform bool u_is_size_feature_constant;uniform highp float u_size_t;uniform highp float u_size;uniform mat4 u_matrix;uniform mat4 u_label_plane_matrix;uniform mat4 u_coord_matrix;uniform bool u_is_text;uniform bool u_elevation_from_sea;uniform bool u_pitch_with_map;uniform bool u_rotate_symbol;uniform highp float u_aspect_ratio;uniform highp float u_camera_to_center_distance;uniform float u_fade_change;uniform vec2 u_texsize;uniform vec3 u_up_vector;uniform vec2 u_texsize_icon;uniform bool u_is_halo;\n#ifdef PROJECTION_GLOBE_VIEW\nuniform vec3 u_tile_id;uniform mat4 u_inv_rot_matrix;uniform vec2 u_merc_center;uniform vec3 u_camera_forward;uniform float u_zoom_transition;uniform vec3 u_ecef_origin;uniform mat4 u_tile_matrix;\n#endif\nout vec2 v_tex_a;\n#ifdef ICON_TRANSITION\nout vec2 v_tex_b;\n#endif\nout float v_draw_halo;out vec3 v_gamma_scale_size_fade_opacity;\n#ifdef RENDER_TEXT_AND_SYMBOL\nout float is_sdf;out vec2 v_tex_a_icon;\n#endif\n#pragma mapbox: define highp vec4 fill_color\n#pragma mapbox: define highp vec4 halo_color\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define lowp float halo_width\n#pragma mapbox: define lowp float halo_blur\n#pragma mapbox: define lowp float emissive_strength\n#pragma mapbox: define lowp float occlusion_opacity\n#pragma mapbox: define lowp float z_offset\nvoid main() {\n#pragma mapbox: initialize highp vec4 fill_color\n#pragma mapbox: initialize highp vec4 halo_color\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize lowp float halo_width\n#pragma mapbox: initialize lowp float halo_blur\n#pragma mapbox: initialize lowp float emissive_strength\n#pragma mapbox: initialize lowp float occlusion_opacity\n#pragma mapbox: initialize lowp float z_offset\nvec2 a_pos=a_pos_offset.xy;vec2 a_offset=a_pos_offset.zw;vec2 a_tex=a_tex_size.xy;vec2 a_size=a_tex_size.zw;float a_size_min=floor(a_size[0]*0.5);vec2 a_pxoffset=a_pixeloffset.xy;vec2 a_min_font_scale=a_pixeloffset.zw/256.0;highp float segment_angle=-a_projected_pos[3];float size;if (!u_is_size_zoom_constant && !u_is_size_feature_constant) {size=mix(a_size_min,a_size[1],u_size_t)/128.0;} else if (u_is_size_zoom_constant && !u_is_size_feature_constant) {size=a_size_min/128.0;} else {size=u_size;}vec2 tile_anchor=a_pos;float e=u_elevation_from_sea ? z_offset : z_offset+elevation(tile_anchor);\n#ifdef Z_OFFSET\ne+=a_auto_z_offset;\n#endif\nvec3 h=elevationVector(tile_anchor)*e;float globe_occlusion_fade;vec3 world_pos;vec3 mercator_pos;vec3 world_pos_globe;\n#ifdef PROJECTION_GLOBE_VIEW\nmercator_pos=mercator_tile_position(u_inv_rot_matrix,tile_anchor,u_tile_id,u_merc_center);world_pos_globe=a_globe_anchor+h;world_pos=mix_globe_mercator(world_pos_globe,mercator_pos,u_zoom_transition);vec4 ecef_point=u_tile_matrix*vec4(world_pos,1.0);vec3 origin_to_point=ecef_point.xyz-u_ecef_origin;globe_occlusion_fade=dot(origin_to_point,u_camera_forward) >=0.0 ? 0.0 : 1.0;\n#else\nworld_pos=vec3(tile_anchor,0)+h;globe_occlusion_fade=1.0;\n#endif\nvec4 projected_point=u_matrix*vec4(world_pos,1);highp float camera_to_anchor_distance=projected_point.w;highp float distance_ratio=u_pitch_with_map ?\ncamera_to_anchor_distance/u_camera_to_center_distance :\nu_camera_to_center_distance/camera_to_anchor_distance;highp float perspective_ratio=clamp(\n0.5+0.5*distance_ratio,0.0,1.5);size*=perspective_ratio;float font_scale=u_is_text ? size/24.0 : size;highp float symbol_rotation=0.0;if (u_rotate_symbol) {vec4 offsetprojected_point;vec2 a;\n#ifdef PROJECTION_GLOBE_VIEW\nvec3 displacement=vec3(a_globe_normal.z,0,-a_globe_normal.x);offsetprojected_point=u_matrix*vec4(a_globe_anchor+displacement,1);vec4 projected_point_globe=u_matrix*vec4(world_pos_globe,1);a=projected_point_globe.xy/projected_point_globe.w;\n#else\noffsetprojected_point=u_matrix*vec4(tile_anchor+vec2(1,0),0,1);a=projected_point.xy/projected_point.w;\n#endif\nvec2 b=offsetprojected_point.xy/offsetprojected_point.w;symbol_rotation=atan((b.y-a.y)/u_aspect_ratio,b.x-a.x);}vec4 projected_pos;\n#ifdef PROJECTION_GLOBE_VIEW\n#ifdef PROJECTED_POS_ON_VIEWPORT\nprojected_pos=u_label_plane_matrix*vec4(a_projected_pos.xyz+h,1.0);\n#else\nvec3 proj_pos=mix_globe_mercator(a_projected_pos.xyz,mercator_pos,u_zoom_transition)+h;projected_pos=u_label_plane_matrix*vec4(proj_pos,1.0);    \n#endif\n#else\nprojected_pos=u_label_plane_matrix*vec4(a_projected_pos.xy,h.z,1.0);\n#endif\nhighp float angle_sin=sin(segment_angle+symbol_rotation);highp float angle_cos=cos(segment_angle+symbol_rotation);mat2 rotation_matrix=mat2(angle_cos,-1.0*angle_sin,angle_sin,angle_cos);float z=0.0;vec2 offset=rotation_matrix*(a_offset/32.0*max(a_min_font_scale,font_scale)+a_pxoffset/16.0);\n#ifdef TERRAIN\n#ifdef PITCH_WITH_MAP_TERRAIN\nvec4 tile_pos=u_label_plane_matrix_inv*vec4(a_projected_pos.xy+offset,0.0,1.0);z=elevation(tile_pos.xy);\n#endif\n#endif\n#ifdef Z_OFFSET\nz+=u_pitch_with_map ? a_auto_z_offset+(u_elevation_from_sea ? z_offset : z_offset) : 0.0;\n#else\nz+=u_pitch_with_map ? (u_elevation_from_sea ? z_offset : z_offset) : 0.0;\n#endif\nfloat occlusion_fade=globe_occlusion_fade;vec2 fade_opacity=unpack_opacity(a_fade_opacity);float fade_change=fade_opacity[1] > 0.5 ? u_fade_change :-u_fade_change;float out_fade_opacity=max(0.0,min(occlusion_fade,fade_opacity[0]+fade_change));\n#ifdef DEPTH_OCCLUSION\nfloat depth_occlusion=occlusionFadeMultiSample(projected_point);float depth_occlusion_multplier=mix(occlusion_opacity,1.0,depth_occlusion);out_fade_opacity*=depth_occlusion_multplier;\n#endif\n#ifdef OCCLUSION_QUERIES\nfloat occludedFadeMultiplier=mix(occlusion_opacity,1.0,a_occlusion_query_opacity);out_fade_opacity*=occludedFadeMultiplier;\n#endif\nfloat alpha=opacity*out_fade_opacity;float hidden=float(alpha==0.0 || projected_point.w <=0.0 || occlusion_fade==0.0);\n#ifdef PROJECTION_GLOBE_VIEW\nvec3 xAxis=u_pitch_with_map ? normalize(cross(a_globe_normal,u_up_vector)) : vec3(1,0,0);vec3 yAxis=u_pitch_with_map ? normalize(cross(a_globe_normal,xAxis)) : vec3(0,1,0);gl_Position=mix(u_coord_matrix*vec4(projected_pos.xyz/projected_pos.w+xAxis*offset.x+yAxis*offset.y,1.0),AWAY,hidden);\n#else\ngl_Position=mix(u_coord_matrix*vec4(projected_pos.xy/projected_pos.w+offset,z,1.0),AWAY,hidden);\n#endif\nfloat gamma_scale=gl_Position.w;v_draw_halo=(u_is_halo && float(gl_InstanceID)==0.0) ? 1.0 : 0.0;v_gamma_scale_size_fade_opacity=vec3(gamma_scale,size,out_fade_opacity);v_tex_a=a_tex/u_texsize;\n#ifdef RENDER_TEXT_AND_SYMBOL\nis_sdf=a_size[0]-2.0*a_size_min;v_tex_a_icon=a_tex/u_texsize_icon;\n#endif\n#ifdef ICON_TRANSITION\nv_tex_b=a_texb/u_texsize;\n#endif\n#ifdef INDICATOR_CUTOUT\nv_z_offset=e;\n#endif\n}'),
            terrainRaster: Go('#include "_prelude_fog.fragment.glsl"\n#include "_prelude_shadow.fragment.glsl"\n#include "_prelude_lighting.glsl"\nuniform sampler2D u_image0;in vec2 v_pos0;\n#ifdef FOG\nin float v_fog_opacity;\n#endif\n#ifdef RENDER_SHADOWS\nin vec4 v_pos_light_view_0;in vec4 v_pos_light_view_1;\n#endif\nuniform vec3 u_ground_shadow_factor;void main() {vec4 image_color=texture(u_image0,v_pos0);vec4 color;\n#ifdef LIGHTING_3D_MODE\nconst vec3 normal=vec3(0.0,0.0,1.0);\n#ifdef RENDER_SHADOWS\nfloat cutoffOpacity=1.0;\n#ifdef RENDER_CUTOFF\ncutoffOpacity=cutoff_opacity(u_cutoff_params,1.0/gl_FragCoord.w);\n#endif\n#ifdef LIGHTING_3D_ALPHA_EMISSIVENESS\nvec3 unlit_base=image_color.rgb*(1.0-image_color.a);vec3 emissive_base=image_color.rgb*image_color.a;float ndotl=u_shadow_direction.z;float occlusion=ndotl < 0.0 ? 1.0 : shadow_occlusion(v_pos_light_view_0,v_pos_light_view_1,1.0/gl_FragCoord.w,0.0);ndotl=max(0.0,ndotl);vec3 lit=apply_lighting(unlit_base,normal,mix(1.0,(1.0-(u_shadow_intensity*occlusion))*ndotl,cutoffOpacity));vec3 emissive=compute_emissive_draped(emissive_base,1.0-u_shadow_intensity,occlusion,u_ground_shadow_factor);color.rgb=lit+emissive;color.a=1.0;\n#else\nfloat lighting_factor=shadowed_light_factor_normal_unbiased(normal,v_pos_light_view_0,v_pos_light_view_1,1.0/gl_FragCoord.w);color=apply_lighting(image_color,normal,mix(1.0,lighting_factor,cutoffOpacity));\n#endif\n#else\nfloat lighting_factor=u_lighting_directional_dir.z;color=apply_lighting(image_color,normal,lighting_factor);\n#ifdef LIGHTING_3D_ALPHA_EMISSIVENESS\ncolor.rgb=mix(color.rgb,image_color.rgb,image_color.a);color.a=1.0;\n#endif\n#endif\n#else\ncolor=image_color;\n#endif\n#ifdef FOG\n#ifdef ZERO_EXAGGERATION\ncolor=fog_dither(fog_apply_premultiplied(color,v_fog_pos));\n#else\ncolor=fog_dither(fog_apply_from_vert(color,v_fog_opacity));\n#endif\n#endif\nglFragColor=color;\n#ifdef OVERDRAW_INSPECTOR\nglFragColor=vec4(1.0);\n#endif\nHANDLE_WIREFRAME_DEBUG;}', '#include "_prelude_fog.vertex.glsl"\n#include "_prelude_terrain.vertex.glsl"\nuniform mat4 u_matrix;uniform float u_skirt_height;in vec2 a_pos;out vec2 v_pos0;\n#ifdef FOG\nout float v_fog_opacity;\n#endif\n#ifdef RENDER_SHADOWS\nuniform mat4 u_light_matrix_0;uniform mat4 u_light_matrix_1;out vec4 v_pos_light_view_0;out vec4 v_pos_light_view_1;out float v_depth;\n#endif\nvoid main() {vec3 decomposedPosAndSkirt=decomposeToPosAndSkirt(a_pos);float skirt=decomposedPosAndSkirt.z;vec2 decodedPos=decomposedPosAndSkirt.xy;float elevation=elevation(decodedPos)-skirt*u_skirt_height;v_pos0=decodedPos/8192.0;gl_Position=u_matrix*vec4(decodedPos,elevation,1.0);\n#ifdef FOG\n#ifdef ZERO_EXAGGERATION\nv_fog_pos=fog_position(decodedPos);\n#else\nv_fog_opacity=fog(fog_position(vec3(decodedPos,elevation)));\n#endif\n#endif\n#ifdef RENDER_SHADOWS\nvec3 pos=vec3(decodedPos,elevation);v_pos_light_view_0=u_light_matrix_0*vec4(pos,1.);v_pos_light_view_1=u_light_matrix_1*vec4(pos,1.);\n#endif\n}'),
            terrainDepth: Go("precision highp float;in float v_depth;void main() {glFragColor=pack_depth(v_depth);}", '#include "_prelude_terrain.vertex.glsl"\nuniform mat4 u_matrix;in vec2 a_pos;out float v_depth;void main() {float elevation=elevation(a_pos);gl_Position=u_matrix*vec4(a_pos,elevation,1.0);v_depth=gl_Position.z/gl_Position.w;}'),
            skybox: Go('#include "_prelude_fog.fragment.glsl"\nin lowp vec3 v_uv;uniform lowp samplerCube u_cubemap;uniform lowp float u_opacity;uniform highp float u_temporal_offset;uniform highp vec3 u_sun_direction;float sun_disk(highp vec3 ray_direction,highp vec3 sun_direction) {highp float cos_angle=dot(normalize(ray_direction),sun_direction);const highp float cos_sun_angular_diameter=0.99996192306;const highp float smoothstep_delta=1e-5;return smoothstep(\ncos_sun_angular_diameter-smoothstep_delta,cos_sun_angular_diameter+smoothstep_delta,cos_angle);}float map(float value,float start,float end,float new_start,float new_end) {return ((value-start)*(new_end-new_start))/(end-start)+new_start;}void main() {vec3 uv=v_uv;const float y_bias=0.015;uv.y+=y_bias;uv.y=pow(abs(uv.y),1.0/5.0);uv.y=map(uv.y,0.0,1.0,-1.0,1.0);vec3 sky_color=texture(u_cubemap,uv).rgb;\n#ifdef FOG\nsky_color=fog_apply_sky_gradient(v_uv.xzy,sky_color);\n#endif\nsky_color+=0.1*sun_disk(v_uv,u_sun_direction);glFragColor=vec4(sky_color*u_opacity,u_opacity);\n#ifdef OVERDRAW_INSPECTOR\nglFragColor=vec4(1.0);\n#endif\n}', Io),
            skyboxGradient: Go('#include "_prelude_fog.fragment.glsl"\nin highp vec3 v_uv;uniform lowp sampler2D u_color_ramp;uniform highp vec3 u_center_direction;uniform lowp float u_radius;uniform lowp float u_opacity;uniform highp float u_temporal_offset;void main() {float progress=acos(dot(normalize(v_uv),u_center_direction))/u_radius;vec4 color=texture(u_color_ramp,vec2(progress,0.5));\n#ifdef FOG\ncolor.rgb=fog_apply_sky_gradient(v_uv.xzy,color.rgb/color.a)*color.a;\n#endif\ncolor*=u_opacity;glFragColor=color;\n#ifdef OVERDRAW_INSPECTOR\nglFragColor=vec4(1.0);\n#endif\n}', Io),
            skyboxCapture: Go("\nin highp vec3 v_position;uniform highp float u_sun_intensity;uniform highp float u_luminance;uniform lowp vec3 u_sun_direction;uniform highp vec4 u_color_tint_r;uniform highp vec4 u_color_tint_m;precision highp float;\n#define BETA_R                  vec3(5.5e-6,13.0e-6,22.4e-6)\n#define BETA_M                  vec3(21e-6,21e-6,21e-6)\n#define MIE_G                   0.76\n#define DENSITY_HEIGHT_SCALE_R  8000.0\n#define DENSITY_HEIGHT_SCALE_M  1200.0\n#define PLANET_RADIUS           6360e3\n#define ATMOSPHERE_RADIUS       6420e3\n#define SAMPLE_STEPS            10\n#define DENSITY_STEPS           4\nfloat ray_sphere_exit(vec3 orig,vec3 dir,float radius) {float a=dot(dir,dir);float b=2.0*dot(dir,orig);float c=dot(orig,orig)-radius*radius;float d=sqrt(b*b-4.0*a*c);return (-b+d)/(2.0*a);}vec3 extinction(vec2 density) {return exp(-vec3(BETA_R*u_color_tint_r.a*density.x+BETA_M*u_color_tint_m.a*density.y));}vec2 local_density(vec3 point) {float height=max(length(point)-PLANET_RADIUS,0.0);float exp_r=exp(-height/DENSITY_HEIGHT_SCALE_R);float exp_m=exp(-height/DENSITY_HEIGHT_SCALE_M);return vec2(exp_r,exp_m);}float phase_ray(float cos_angle) {return (3.0/(16.0*PI))*(1.0+cos_angle*cos_angle);}float phase_mie(float cos_angle) {return (3.0/(8.0*PI))*((1.0-MIE_G*MIE_G)*(1.0+cos_angle*cos_angle))/((2.0+MIE_G*MIE_G)*pow(1.0+MIE_G*MIE_G-2.0*MIE_G*cos_angle,1.5));}vec2 density_to_atmosphere(vec3 point,vec3 light_dir) {float ray_len=ray_sphere_exit(point,light_dir,ATMOSPHERE_RADIUS);float step_len=ray_len/float(DENSITY_STEPS);vec2 density_point_to_atmosphere=vec2(0.0);for (int i=0; i < DENSITY_STEPS;++i) {vec3 point_on_ray=point+light_dir*((float(i)+0.5)*step_len);density_point_to_atmosphere+=local_density(point_on_ray)*step_len;;}return density_point_to_atmosphere;}vec3 atmosphere(vec3 ray_dir,vec3 sun_direction,float sun_intensity) {vec2 density_orig_to_point=vec2(0.0);vec3 scatter_r=vec3(0.0);vec3 scatter_m=vec3(0.0);vec3 origin=vec3(0.0,PLANET_RADIUS,0.0);float ray_len=ray_sphere_exit(origin,ray_dir,ATMOSPHERE_RADIUS);float step_len=ray_len/float(SAMPLE_STEPS);for (int i=0; i < SAMPLE_STEPS;++i) {vec3 point_on_ray=origin+ray_dir*((float(i)+0.5)*step_len);vec2 density=local_density(point_on_ray)*step_len;density_orig_to_point+=density;vec2 density_point_to_atmosphere=density_to_atmosphere(point_on_ray,sun_direction);vec2 density_orig_to_atmosphere=density_orig_to_point+density_point_to_atmosphere;vec3 extinction=extinction(density_orig_to_atmosphere);scatter_r+=density.x*extinction;scatter_m+=density.y*extinction;}float cos_angle=dot(ray_dir,sun_direction);float phase_r=phase_ray(cos_angle);float phase_m=phase_mie(cos_angle);vec3 beta_r=BETA_R*u_color_tint_r.rgb*u_color_tint_r.a;vec3 beta_m=BETA_M*u_color_tint_m.rgb*u_color_tint_m.a;return (scatter_r*phase_r*beta_r+scatter_m*phase_m*beta_m)*sun_intensity;}const float A=0.15;const float B=0.50;const float C=0.10;const float D=0.20;const float E=0.02;const float F=0.30;vec3 uncharted2_tonemap(vec3 x) {return ((x*(A*x+C*B)+D*E)/(x*(A*x+B)+D*F))-E/F;}void main() {vec3 ray_direction=v_position;ray_direction.y=pow(ray_direction.y,5.0);const float y_bias=0.015;ray_direction.y+=y_bias;vec3 color=atmosphere(normalize(ray_direction),u_sun_direction,u_sun_intensity);float white_scale=1.0748724675633854;color=uncharted2_tonemap((log2(2.0/pow(u_luminance,4.0)))*color)*white_scale;glFragColor=vec4(color,1.0);}", "in highp vec3 a_pos_3f;uniform mat3 u_matrix_3f;out highp vec3 v_position;float map(float value,float start,float end,float new_start,float new_end) {return ((value-start)*(new_end-new_start))/(end-start)+new_start;}void main() {vec4 pos=vec4(u_matrix_3f*a_pos_3f,1.0);v_position=pos.xyz;v_position.y*=-1.0;v_position.y=map(v_position.y,-1.0,1.0,0.0,1.0);gl_Position=vec4(a_pos_3f.xy,0.0,1.0);}"),
            globeRaster: Go('#include "_prelude_fog.fragment.glsl"\n#include "_prelude_lighting.glsl"\nuniform sampler2D u_image0;uniform float u_far_z_cutoff;in vec2 v_pos0;\n#ifndef FOG\nuniform highp vec3 u_frustum_tl;uniform highp vec3 u_frustum_tr;uniform highp vec3 u_frustum_br;uniform highp vec3 u_frustum_bl;uniform highp vec3 u_globe_pos;uniform highp float u_globe_radius;uniform vec2 u_viewport;\n#endif\nvoid main() {vec4 color;\n#ifdef CUSTOM_ANTIALIASING\nhighp vec2 uv=gl_FragCoord.xy/u_viewport;highp vec3 ray_dir=mix(\nmix(u_frustum_tl,u_frustum_tr,uv.x),mix(u_frustum_bl,u_frustum_br,uv.x),1.0-uv.y);highp vec3 dir=normalize(ray_dir);highp vec3 closest_point=dot(u_globe_pos,dir)*dir;highp float norm_dist_from_center=1.0-length(closest_point-u_globe_pos)/u_globe_radius;const float antialias_pixel=2.0;highp float antialias_factor=antialias_pixel*fwidth(norm_dist_from_center);highp float antialias=smoothstep(0.0,antialias_factor,norm_dist_from_center);vec4 raster=texture(u_image0,v_pos0);\n#ifdef LIGHTING_3D_MODE\n#ifdef LIGHTING_3D_ALPHA_EMISSIVENESS\nraster=apply_lighting_with_emission_ground(raster,raster.a);color=vec4(clamp(raster.rgb,vec3(0),vec3(1))*antialias,antialias);\n#else\nraster=apply_lighting_ground(raster);color=vec4(raster.rgb*antialias,raster.a*antialias);\n#endif\n#else\ncolor=vec4(raster.rgb*antialias,raster.a*antialias);\n#endif\n#else\ncolor=texture(u_image0,v_pos0);\n#ifdef LIGHTING_3D_MODE\n#ifdef LIGHTING_3D_ALPHA_EMISSIVENESS\ncolor=apply_lighting_with_emission_ground(color,color.a);color.a=1.0;\n#else\ncolor=apply_lighting_ground(color);\n#endif\n#endif\n#endif\n#ifdef FOG\ncolor=fog_dither(fog_apply_premultiplied(color,v_fog_pos));\n#endif\ncolor*=1.0-step(u_far_z_cutoff,1.0/gl_FragCoord.w);glFragColor=color;\n#ifdef OVERDRAW_INSPECTOR\nglFragColor=vec4(1.0);\n#endif\nHANDLE_WIREFRAME_DEBUG;}', '#include "_prelude_fog.vertex.glsl"\n#include "_prelude_terrain.vertex.glsl"\nuniform mat4 u_proj_matrix;uniform mat4 u_normalize_matrix;uniform mat4 u_globe_matrix;uniform mat4 u_merc_matrix;uniform float u_zoom_transition;uniform vec2 u_merc_center;uniform mat3 u_grid_matrix;uniform float u_skirt_height;\n#ifdef GLOBE_POLES\nin vec3 a_globe_pos;in vec2 a_uv;\n#else\nin vec2 a_pos;\n#endif\nout vec2 v_pos0;void main() {\n#ifdef GLOBE_POLES\nvec3 globe_pos=a_globe_pos;vec2 uv=a_uv;\n#else\nfloat tiles=u_grid_matrix[0][2];float idx=u_grid_matrix[1][2];float idy=u_grid_matrix[2][2];vec3 decomposed_pos_and_skirt=decomposeToPosAndSkirt(a_pos);vec3 latLng=u_grid_matrix*vec3(decomposed_pos_and_skirt.xy,1.0);float mercatorY=mercatorYfromLat(latLng[0]);float uvY=mercatorY*tiles-idy;float mercatorX=mercatorXfromLng(latLng[1]);float uvX=mercatorX*tiles-idx;vec3 globe_pos=latLngToECEF(latLng.xy);vec2 merc_pos=vec2(mercatorX,mercatorY);vec2 uv=vec2(uvX,uvY);\n#endif\nv_pos0=uv;vec2 tile_pos=uv*EXTENT;vec3 globe_derived_up_vector=normalize(globe_pos)*u_tile_up_scale;\n#ifdef GLOBE_POLES\nvec3 up_vector=globe_derived_up_vector;\n#else\nvec3 up_vector=elevationVector(tile_pos);\n#endif\nfloat height=elevation(tile_pos);globe_pos+=up_vector*height;\n#ifndef GLOBE_POLES\nglobe_pos-=globe_derived_up_vector*u_skirt_height*decomposed_pos_and_skirt.z;\n#endif\n#ifdef GLOBE_POLES\nvec4 interpolated_pos=u_globe_matrix*vec4(globe_pos,1.0);\n#else\nvec4 globe_world_pos=u_globe_matrix*vec4(globe_pos,1.0);vec4 merc_world_pos=vec4(0.0);if (u_zoom_transition > 0.0) {merc_world_pos=vec4(merc_pos,height-u_skirt_height*decomposed_pos_and_skirt.z,1.0);merc_world_pos.xy-=u_merc_center;merc_world_pos.x=wrap(merc_world_pos.x,-0.5,0.5);merc_world_pos=u_merc_matrix*merc_world_pos;}vec4 interpolated_pos=vec4(mix(globe_world_pos.xyz,merc_world_pos.xyz,u_zoom_transition),1.0);\n#endif\ngl_Position=u_proj_matrix*interpolated_pos;\n#ifdef FOG\nv_fog_pos=fog_position((u_normalize_matrix*vec4(globe_pos,1.0)).xyz);\n#endif\n}'),
            globeAtmosphere: Go('#include "_prelude_fog.fragment.glsl"\nuniform float u_transition;uniform highp float u_fadeout_range;uniform highp float u_temporal_offset;uniform vec4 u_color;uniform vec4 u_high_color;uniform vec4 u_space_color;uniform float u_horizon_angle;in highp vec3 v_ray_dir;in highp vec3 v_horizon_dir;void main() {highp vec3 dir=normalize(v_ray_dir);float globe_pos_dot_dir;\n#ifdef PROJECTION_GLOBE_VIEW\nglobe_pos_dot_dir=dot(u_globe_pos,dir);highp vec3 closest_point_forward=abs(globe_pos_dot_dir)*dir;float norm_dist_from_center=length(closest_point_forward-u_globe_pos)/u_globe_radius;if (norm_dist_from_center < 0.98) {\n#ifdef ALPHA_PASS\nglFragColor=vec4(0,0,0,0);return;\n#else\n#ifdef NATIVE\nglFragColor=vec4(1,1,1,1);\n#else\nglFragColor=vec4(0,0,0,1);\n#endif\nreturn;\n#endif\n}\n#endif\nhighp vec3 horizon_dir=normalize(v_horizon_dir);float horizon_angle_mercator=dir.y < horizon_dir.y ?\n0.0 : max(acos(clamp(dot(dir,horizon_dir),-1.0,1.0)),0.0);float horizon_angle;\n#ifdef PROJECTION_GLOBE_VIEW\nhighp vec3 closest_point=globe_pos_dot_dir*dir;highp float closest_point_to_center=length(closest_point-u_globe_pos);highp float theta=asin(clamp(closest_point_to_center/length(u_globe_pos),-1.0,1.0));horizon_angle=globe_pos_dot_dir < 0.0 ?\nPI-theta-u_horizon_angle : theta-u_horizon_angle;float angle_t=pow(u_transition,10.0);horizon_angle=mix(horizon_angle,horizon_angle_mercator,angle_t);\n#else\nhorizon_angle=horizon_angle_mercator;\n#endif\nhorizon_angle/=PI;float t=exp(-horizon_angle/u_fadeout_range);float alpha_0=u_color.a;float alpha_1=u_high_color.a;float alpha_2=u_space_color.a;vec3 color_stop_0=u_color.rgb;vec3 color_stop_1=u_high_color.rgb;vec3 color_stop_2=u_space_color.rgb;\n#ifdef ALPHA_PASS\nfloat a0=mix(alpha_2,1.0,alpha_1);float a1=mix(a0,1.0,alpha_0);float a2=mix(a0,a1,t);float a =mix(alpha_2,a2,t);glFragColor=vec4(1.0,1.0,1.0,a);\n#else\nvec3 c0=mix(color_stop_2,color_stop_1,alpha_1);vec3 c1=mix(c0,color_stop_0,alpha_0);vec3 c2=mix(c0,c1,t);vec3 c=c2;glFragColor=vec4(c*t,t);\n#endif\n}', "in vec3 a_pos;in vec2 a_uv;uniform vec3 u_frustum_tl;uniform vec3 u_frustum_tr;uniform vec3 u_frustum_br;uniform vec3 u_frustum_bl;uniform float u_horizon;out highp vec3 v_ray_dir;out highp vec3 v_horizon_dir;void main() {v_ray_dir=mix(\nmix(u_frustum_tl,u_frustum_tr,a_uv.x),mix(u_frustum_bl,u_frustum_br,a_uv.x),a_uv.y);v_horizon_dir=mix(\nmix(u_frustum_tl,u_frustum_bl,u_horizon),mix(u_frustum_tr,u_frustum_br,u_horizon),a_uv.x);gl_Position=vec4(a_pos,1.0);}"),
            model: Go('#include "_prelude_fog.fragment.glsl"\n#include "_prelude_shadow.fragment.glsl"\n#include "_prelude_lighting.glsl"\nuniform float u_opacity;uniform vec3 u_lightcolor;uniform vec3 u_lightpos;uniform float u_lightintensity;uniform vec4 u_baseColorFactor;uniform vec4 u_emissiveFactor;uniform float u_metallicFactor;uniform float u_roughnessFactor;uniform float u_emissive_strength;in highp vec4 v_position_height;in lowp vec4 v_color_mix;\n#ifdef RENDER_SHADOWS\nin highp vec4 v_pos_light_view_0;in highp vec4 v_pos_light_view_1;in float v_depth_shadows;\n#endif\n#ifdef OCCLUSION_TEXTURE_TRANSFORM\nuniform vec4 u_occlusionTextureTransform;\n#endif\n#pragma mapbox: define-attribute highp vec3 normal_3f\n#pragma mapbox: define-attribute highp vec3 color_3f\n#pragma mapbox: define-attribute highp vec4 color_4f\n#pragma mapbox: define-attribute highp vec2 uv_2f\n#pragma mapbox: initialize-attribute highp vec3 normal_3f\n#pragma mapbox: initialize-attribute highp vec3 color_3f\n#pragma mapbox: initialize-attribute highp vec4 color_4f\n#pragma mapbox: initialize-attribute highp vec2 uv_2f\n#ifdef HAS_ATTRIBUTE_a_pbr\nin lowp vec4 v_roughness_metallic_emissive_alpha;in mediump vec4 v_height_based_emission_params;\n#endif\n#ifdef HAS_TEXTURE_u_baseColorTexture\nuniform sampler2D u_baseColorTexture;uniform bool u_baseTextureIsAlpha;uniform bool u_alphaMask;uniform float u_alphaCutoff;\n#endif\n#ifdef HAS_TEXTURE_u_metallicRoughnessTexture\nuniform sampler2D u_metallicRoughnessTexture;\n#endif\n#ifdef HAS_TEXTURE_u_occlusionTexture\nuniform sampler2D u_occlusionTexture;uniform float u_aoIntensity;\n#endif\n#ifdef HAS_TEXTURE_u_normalTexture\nuniform sampler2D u_normalTexture;\n#endif\n#ifdef HAS_TEXTURE_u_emissionTexture\nuniform sampler2D u_emissionTexture;\n#endif\n#ifdef APPLY_LUT_ON_GPU\nuniform highp sampler3D u_lutTexture;\n#endif\n#ifdef TERRAIN_FRAGMENT_OCCLUSION\nin highp float v_depth;uniform highp sampler2D u_depthTexture;uniform highp vec2 u_inv_depth_size;uniform highp vec2 u_depth_range_unpack;\n#ifdef DEPTH_D24\nhighp float unpack_depth(highp float depth) {return  depth*u_depth_range_unpack.x+u_depth_range_unpack.y;}\n#else\nhighp float unpack_depth_rgba(highp vec4 rgba_depth)\n{const highp vec4 bit_shift=vec4(1.0/(255.0*255.0*255.0),1.0/(255.0*255.0),1.0/255.0,1.0);return dot(rgba_depth,bit_shift)*2.0-1.0;}\n#endif\nbool isOccluded() {highp vec2 coord=gl_FragCoord.xy*u_inv_depth_size;\n#ifdef DEPTH_D24\nhighp float depth=unpack_depth(texture(u_depthTexture,coord).r);\n#else\nhighp float depth=unpack_depth_rgba(texture(u_depthTexture,coord));\n#endif\nreturn v_depth > depth+0.0005;}\n#endif\n#define saturate(_x) clamp(_x,0.,1.)\nvec3 linearTosRGB(vec3 color) {return pow(color,vec3(1./2.2));}vec3 sRGBToLinear(vec3 srgbIn) {return pow(srgbIn,vec3(2.2));}float calculate_NdotL(vec3 normal,vec3 lightDir) {const float ext=0.70710678118;return (clamp(dot(normal,lightDir),-ext,1.0)+ext)/(1.0+ext);}vec3 getDiffuseShadedColor(vec3 albedo,vec3 normal,vec3 lightDir,vec3 lightColor)\n{\n#ifdef LIGHTING_3D_MODE\nvec3 transformed_normal=vec3(-normal.xy,normal.z);float lighting_factor;\n#ifdef RENDER_SHADOWS\nlighting_factor=shadowed_light_factor_normal(transformed_normal,v_pos_light_view_0,v_pos_light_view_1,v_depth_shadows);\n#else\nlighting_factor=saturate(dot(transformed_normal,u_lighting_directional_dir));\n#endif\nreturn apply_lighting(albedo,transformed_normal,lighting_factor);\n#else\nvec3 n=normal;float colorvalue=((albedo.x*0.2126)+(albedo.y*0.7152))+(albedo.z*0.0722);vec3 c=vec3(0.03,0.03,0.03);float directional=clamp(dot(n,vec3(lightDir)),0.0,1.0);directional=mix(1.0-u_lightintensity,max((1.0-colorvalue)+u_lightintensity,1.0),directional);vec3 c3=c+clamp((albedo*directional)*lightColor,mix(vec3(0.0),vec3(0.3),vec3(1.0)-lightColor),vec3(1.0));return c3;\n#endif\n}vec4 getBaseColor() {vec4 albedo=u_baseColorFactor;\n#ifdef HAS_ATTRIBUTE_a_color_3f\nalbedo*=vec4(color_3f,1.0);\n#endif\n#ifdef HAS_ATTRIBUTE_a_pbr\n#else\n#ifdef HAS_ATTRIBUTE_a_color_4f\nalbedo*=color_4f;\n#endif\n#endif\n#if defined (HAS_TEXTURE_u_baseColorTexture) && defined (HAS_ATTRIBUTE_a_uv_2f)\nvec4 texColor=texture(u_baseColorTexture,uv_2f);if(u_alphaMask) {if (texColor.w < u_alphaCutoff) {discard;}}\n#ifdef UNPREMULT_TEXTURE_IN_SHADER\nif(texColor.w > 0.0) {texColor.rgb/=texColor.w;}texColor.w=1.0;\n#endif\nif(u_baseTextureIsAlpha) {if (texColor.r < 0.5) {discard;}} else {texColor.rgb=sRGBToLinear(texColor.rgb);albedo*=texColor;}\n#endif\nvec4 color=vec4(mix(albedo.rgb,v_color_mix.rgb,v_color_mix.a),albedo.a);\n#ifdef APPLY_LUT_ON_GPU\ncolor=applyLUT(u_lutTexture,color);\n#endif\nreturn color;}highp mat3 cotangentFrame(highp vec3 N,highp vec3 p,highp vec2 uv ) {\n#ifdef HAS_TEXTURE_u_normalTexture\nhighp vec3 dp1=vec3(dFdx(p.x),dFdx(p.y),dFdx(p.z));highp vec3 dp2=vec3(dFdy(p.x),dFdy(p.y),dFdy(p.z));highp vec2 duv1=vec2(dFdx(uv.x),dFdx(uv.y));highp vec2 duv2=vec2(dFdy(uv.x),dFdy(uv.y));highp vec3 dp2perp=cross( dp2,N );highp vec3 dp1perp=cross( N,dp1 );highp vec3 T=dp2perp*duv1.x+dp1perp*duv2.x;highp vec3 B=dp2perp*duv1.y+dp1perp*duv2.y;highp float lengthT=dot(T,T);highp float lengthB=dot(B,B);highp float maxLength=max(lengthT,lengthB);highp float invmax=inversesqrt( maxLength );highp mat3 res=mat3( T*invmax,B*invmax,N );return res;\n#else\nreturn mat3(1.0);\n#endif\n}highp vec3 getNormal(){highp vec3 n;\n#ifdef HAS_ATTRIBUTE_a_normal_3f\nn=normalize(normal_3f);\n#else\nhighp vec3 fdx=vec3(dFdx(v_position_height.x),dFdx(v_position_height.y),dFdx(v_position_height.z));highp vec3 fdy=vec3(dFdy(v_position_height.x),dFdy(v_position_height.y),dFdy(v_position_height.z));n=normalize(cross(fdx,fdy))*-1.0;\n#endif\n#if defined(HAS_TEXTURE_u_normalTexture) && defined(HAS_ATTRIBUTE_a_uv_2f)\nvec3 nMap=texture( u_normalTexture,uv_2f).xyz;nMap=normalize(2.0*nMap-vec3(1.0));highp vec3 v=normalize(-v_position_height.xyz);highp mat3 TBN=cotangentFrame(n,v,uv_2f);n=normalize(TBN*nMap);\n#endif\nreturn n;}struct Material {float perceptualRoughness;float alphaRoughness;float metallic;vec3 f90;vec4 baseColor;vec3 diffuseColor;vec3 specularColor;highp vec3 normal;};Material getPBRMaterial() {Material mat;mat.baseColor=getBaseColor();mat.perceptualRoughness=u_roughnessFactor;mat.metallic=u_metallicFactor;\n#ifdef HAS_ATTRIBUTE_a_pbr\nmat.perceptualRoughness=v_roughness_metallic_emissive_alpha.x;mat.metallic=v_roughness_metallic_emissive_alpha.y;mat.baseColor.w*=v_roughness_metallic_emissive_alpha.w;\n#endif\n#if defined(HAS_TEXTURE_u_metallicRoughnessTexture) && defined(HAS_ATTRIBUTE_a_uv_2f) \nvec4 mrSample=texture(u_metallicRoughnessTexture,uv_2f);mat.perceptualRoughness*=mrSample.g;mat.metallic*=mrSample.b;\n#endif\nconst float c_minRoughness=0.04;mat.perceptualRoughness=clamp(mat.perceptualRoughness,c_minRoughness,1.0);mat.metallic=saturate(mat.metallic);mat.alphaRoughness=mat.perceptualRoughness*mat.perceptualRoughness;const vec3 f0=vec3(0.04);mat.diffuseColor=mat.baseColor.rgb*(vec3(1.0)-f0);mat.diffuseColor*=1.0-mat.metallic;mat.specularColor=mix(f0,mat.baseColor.rgb,mat.metallic);highp float reflectance=max(max(mat.specularColor.r,mat.specularColor.g),mat.specularColor.b);highp float reflectance90=saturate(reflectance*25.0);mat.f90=vec3(reflectance90);mat.normal=getNormal();return mat;}float V_GGX(float NdotL,float NdotV,float roughness)\n{float a2=roughness*roughness;float GGXV=NdotL*sqrt(NdotV*NdotV*(1.0-a2)+a2);float GGXL=NdotV*sqrt(NdotL*NdotL*(1.0-a2)+a2);return 0.5/(GGXV+GGXL);}float V_GGXFast(float NdotL,float NdotV,float roughness) {float a=roughness;float GGXV=NdotL*(NdotV*(1.0-a)+a);float GGXL=NdotV*(NdotL*(1.0-a)+a);return 0.5/(GGXV+GGXL);}vec3 F_Schlick(vec3 specularColor,vec3 f90,float VdotH)\n{return specularColor+(f90-specularColor)*pow(clamp(1.0-VdotH,0.0,1.0),5.0);}vec3 F_SchlickFast(vec3 specularColor,float VdotH)\n{float x=1.0-VdotH;float x4=x*x*x*x;return specularColor+(1.0-specularColor)*x4*x;}float D_GGX(highp float NdotH,float alphaRoughness)\n{highp float a4=alphaRoughness*alphaRoughness;highp float f=(NdotH*a4-NdotH)*NdotH+1.0;return a4/(PI*f*f);}vec3 diffuseBurley(Material mat,float LdotH,float NdotL,float NdotV)\n{float f90=2.0*LdotH*LdotH*mat.alphaRoughness-0.5;return (mat.diffuseColor/PI)*(1.0+f90*pow((1.0-NdotL),5.0))*(1.0+f90*pow((1.0-NdotV),5.0));}vec3 diffuseLambertian(Material mat)\n{\n#ifdef LIGHTING_3D_MODE\nreturn mat.diffuseColor;\n#else\nreturn mat.diffuseColor/PI;\n#endif\n}vec3 EnvBRDFApprox(vec3 specularColor,float roughness,highp float NdotV)\n{vec4 c0=vec4(-1,-0.0275,-0.572,0.022);vec4 c1=vec4(1,0.0425,1.04,-0.04);highp vec4 r=roughness*c0+c1;highp float a004=min(r.x*r.x,exp2(-9.28*NdotV))*r.x+r.y;vec2 AB=vec2(-1.04,1.04)*a004+r.zw;return specularColor*AB.x+AB.y;}vec3 computeIndirectLightContribution(Material mat,float NdotV,vec3 normal)\n{vec3 env_light=vec3(0.65,0.65,0.65);\n#ifdef LIGHTING_3D_MODE\nfloat ambient_factor=calculate_ambient_directional_factor(normal);env_light=u_lighting_ambient_color*ambient_factor;\n#endif\nvec3 envBRDF=EnvBRDFApprox(mat.specularColor,mat.perceptualRoughness,NdotV);vec3 indirectSpecular= envBRDF*env_light;vec3 indirectDiffuse=mat.diffuseColor*env_light;return indirectSpecular+indirectDiffuse;}vec3 computeLightContribution(Material mat,vec3 lightPosition,vec3 lightColor)\n{highp vec3 n=mat.normal;highp vec3 v=normalize(-v_position_height.xyz);highp vec3 l=normalize(lightPosition);highp vec3 h=normalize(v+l);float NdotV=clamp(abs(dot(n,v)),0.001,1.0);float NdotL=saturate(dot(n,l));highp float NdotH=saturate(dot(n,h));float VdotH=saturate(dot(v,h));vec3 f=F_SchlickFast(mat.specularColor,VdotH);float g=V_GGXFast(NdotL,NdotV,mat.alphaRoughness);float d=D_GGX(NdotH,mat.alphaRoughness);vec3 diffuseTerm=(1.0-f)*diffuseLambertian(mat);vec3 specularTerm=f*g*d;vec3 transformed_normal=vec3(-n.xy,n.z);float lighting_factor;\n#ifdef RENDER_SHADOWS\nlighting_factor=shadowed_light_factor_normal(transformed_normal,v_pos_light_view_0,v_pos_light_view_1,v_depth_shadows);\n#else\nlighting_factor=NdotL;\n#endif\nvec3 directLightColor=(specularTerm+diffuseTerm)*lighting_factor*lightColor;vec3 indirectLightColor=computeIndirectLightContribution(mat,NdotV,transformed_normal);vec3 color=(saturate(directLightColor)+indirectLightColor);float intensityFactor=1.0;\n#if !defined(LIGHTING_3D_MODE)\nconst vec3 luminosityFactor=vec3(0.2126,0.7152,0.0722);float luminance=dot(diffuseTerm,luminosityFactor);intensityFactor=mix((1.0-u_lightintensity),max((1.0-luminance+u_lightintensity),1.0),NdotL);\n#endif\ncolor*=intensityFactor;return color;}void main() {\n#ifdef TERRAIN_FRAGMENT_OCCLUSION\nif (isOccluded()) {discard;}\n#endif\nvec3 lightDir=u_lightpos;vec3 lightColor=u_lightcolor;\n#ifdef LIGHTING_3D_MODE\nlightDir=u_lighting_directional_dir;lightDir.xy=-lightDir.xy;lightColor=u_lighting_directional_color;\n#endif\nvec4 finalColor;\n#ifdef DIFFUSE_SHADED\nvec3 N=getNormal();vec3 baseColor=getBaseColor().rgb;vec3 diffuse=getDiffuseShadedColor(baseColor,N,lightDir,lightColor);\n#ifdef HAS_TEXTURE_u_occlusionTexture\nfloat ao=(texture(u_occlusionTexture,uv_2f).r-1.0)*u_aoIntensity+1.0;diffuse*=ao;\n#endif\nfinalColor=vec4(mix(diffuse,baseColor,u_emissive_strength),1.0)*u_opacity;\n#else\nMaterial mat=getPBRMaterial();vec3 color=computeLightContribution(mat,lightDir,lightColor);float ao=1.0;\n#if defined (HAS_TEXTURE_u_occlusionTexture) && defined(HAS_ATTRIBUTE_a_uv_2f)\n#ifdef OCCLUSION_TEXTURE_TRANSFORM\nvec2 uv=uv_2f.xy*u_occlusionTextureTransform.zw+u_occlusionTextureTransform.xy;\n#else\nvec2 uv=uv_2f;\n#endif\nao=(texture(u_occlusionTexture,uv).x-1.0)*u_aoIntensity+1.0;color*=ao;\n#endif\nvec4 emissive=u_emissiveFactor;\n#if defined(HAS_TEXTURE_u_emissionTexture) && defined(HAS_ATTRIBUTE_a_uv_2f)\nemissive.rgb*=sRGBToLinear(texture(u_emissionTexture,uv_2f).rgb);\n#endif\n#ifdef APPLY_LUT_ON_GPU\nfloat emissiveFactorLength=max(length(u_emissiveFactor.rgb),0.001);emissive.rgb=sRGBToLinear(applyLUT(u_lutTexture,linearTosRGB(emissive.rgb/emissiveFactorLength).rbg))*emissiveFactorLength;\n#endif\ncolor+=emissive.rgb;float opacity=mat.baseColor.w*u_opacity;\n#ifdef HAS_ATTRIBUTE_a_pbr\nfloat resEmission=v_roughness_metallic_emissive_alpha.z;resEmission*=v_height_based_emission_params.z+v_height_based_emission_params.w*pow(clamp(v_height_based_emission_params.x,0.0,1.0),v_height_based_emission_params.y);vec3 color_mix=v_color_mix.rgb;\n#ifdef APPLY_LUT_ON_GPU\ncolor_mix=applyLUT(u_lutTexture,color_mix);\n#endif\ncolor=mix(color,color_mix,min(1.0,resEmission));\n#ifdef HAS_ATTRIBUTE_a_color_4f\nfloat distance=length(vec2(1.3*max(0.0,abs(color_4f.x)-color_4f.z),color_4f.y));distance+= mix(0.5,0.0,clamp(resEmission-1.0,0.0,1.0));opacity*=v_roughness_metallic_emissive_alpha.w*saturate(1.0-distance*distance);\n#endif\n#endif\nvec3 unlitColor=mat.baseColor.rgb*ao+emissive.rgb;color=mix(color,unlitColor,u_emissive_strength);color=linearTosRGB(color);color*=opacity;finalColor=vec4(color,opacity);\n#endif\n#ifdef FOG\nfinalColor=fog_dither(fog_apply_premultiplied(finalColor,v_fog_pos,v_position_height.w));\n#endif\n#ifdef RENDER_CUTOFF\nfinalColor*=v_cutoff_opacity;\n#endif\n#ifdef INDICATOR_CUTOUT\nfinalColor=applyCutout(finalColor,v_position_height.w);\n#endif\nglFragColor=finalColor;\n#ifdef OVERDRAW_INSPECTOR\nglFragColor=vec4(1.0);\n#endif\nHANDLE_WIREFRAME_DEBUG;}', '#include "_prelude_fog.vertex.glsl"\n#include "_prelude_shadow.vertex.glsl"\nin vec3 a_pos_3f;\n#pragma mapbox: define-attribute highp vec3 normal_3f\n#pragma mapbox: define-attribute highp vec2 uv_2f\n#pragma mapbox: define-attribute highp vec3 color_3f\n#pragma mapbox: define-attribute highp vec4 color_4f\n#pragma mapbox: define-attribute-vertex-shader-only highp vec4 pbr\n#pragma mapbox: define-attribute-vertex-shader-only highp vec3 heightBasedEmissiveStrength\nuniform mat4 u_matrix;uniform mat4 u_node_matrix;uniform mat4 u_lighting_matrix;uniform vec3 u_camera_pos;uniform vec4 u_color_mix;\n#ifdef INSTANCED_ARRAYS\nin vec4 a_normal_matrix0;in vec4 a_normal_matrix1;in vec4 a_normal_matrix2;in vec4 a_normal_matrix3;\n#else\nuniform highp mat4 u_normal_matrix;\n#endif\n#ifdef RENDER_SHADOWS\nuniform mat4 u_light_matrix_0;uniform mat4 u_light_matrix_1;out highp vec4 v_pos_light_view_0;out highp vec4 v_pos_light_view_1;out float v_depth_shadows;\n#endif\nout vec4 v_position_height;out lowp vec4 v_color_mix;\n#ifdef TERRAIN_FRAGMENT_OCCLUSION\nout highp float v_depth;\n#endif\n#ifdef HAS_ATTRIBUTE_a_pbr\nout lowp vec4 v_roughness_metallic_emissive_alpha;out mediump vec4 v_height_based_emission_params;\n#endif\nvec3 sRGBToLinear(vec3 srgbIn) {return pow(srgbIn,vec3(2.2));}void main() {\n#pragma mapbox: initialize-attribute highp vec3 normal_3f\n#pragma mapbox: initialize-attribute highp vec2 uv_2f\n#pragma mapbox: initialize-attribute highp vec3 color_3f\n#pragma mapbox: initialize-attribute highp vec4 color_4f\n#pragma mapbox: initialize-attribute-custom highp vec4 pbr\n#pragma mapbox: initialize-attribute-custom highp vec3 heightBasedEmissiveStrength\nhighp mat4 normal_matrix;\n#ifdef INSTANCED_ARRAYS\nnormal_matrix=mat4(a_normal_matrix0,a_normal_matrix1,a_normal_matrix2,a_normal_matrix3);\n#else\nnormal_matrix=u_normal_matrix;\n#endif\nvec3 local_pos;mat3 rs;\n#ifdef MODEL_POSITION_ON_GPU\nvec3 pos_color=normal_matrix[0].xyz;vec4 translate=normal_matrix[1];vec3 pos_a=floor(pos_color);vec3 rgb=1.05*(pos_color-pos_a);float hidden=float(pos_a.x > EXTENT);float color_mix=pos_a.z/100.0;v_color_mix=vec4(sRGBToLinear(rgb),color_mix);float meter_to_tile=normal_matrix[0].w;vec4 pos=vec4(pos_a.xy,translate.z,1.0);rs[0].x=normal_matrix[1].w;rs[0].yz=normal_matrix[2].xy;rs[1].xy=normal_matrix[2].zw;rs[1].z=normal_matrix[3].x;rs[2].xyz=normal_matrix[3].yzw;vec4 pos_node=u_lighting_matrix*vec4(a_pos_3f,1.0);vec3 rotated_pos_node=rs*pos_node.xyz;vec3 pos_model_tile=(rotated_pos_node+vec3(translate.xy,0.0))*vec3(meter_to_tile,meter_to_tile,1.0);pos.xyz+=pos_model_tile;local_pos=pos.xyz;gl_Position=mix(u_matrix*pos,AWAY,hidden);pos.z*=meter_to_tile;v_position_height.xyz=pos.xyz-u_camera_pos;\n#else\nlocal_pos=a_pos_3f;gl_Position=u_matrix*vec4(a_pos_3f,1);v_position_height.xyz=vec3(u_lighting_matrix*vec4(a_pos_3f,1));v_color_mix=vec4(sRGBToLinear(u_color_mix.rgb),u_color_mix.a);\n#endif\nv_position_height.w=a_pos_3f.z;\n#ifdef HAS_ATTRIBUTE_a_pbr\nvec4 albedo_c=decode_color(pbr.xy);vec2 e_r_m=unpack_float(pbr.z);vec2 r_m= unpack_float(e_r_m.y*16.0);r_m.r=r_m.r*16.0;v_color_mix=vec4(albedo_c.rgb,1.0);v_roughness_metallic_emissive_alpha=vec4(vec3(r_m,e_r_m.x)/255.0,albedo_c.a);v_roughness_metallic_emissive_alpha.z*=2.0;float heightBasedRelativeIntepolation=a_pos_3f.z*heightBasedEmissiveStrength.x+heightBasedEmissiveStrength.y;v_height_based_emission_params.x=heightBasedRelativeIntepolation;v_height_based_emission_params.y=heightBasedEmissiveStrength.z;vec2 emissionMultiplierValues=unpack_float(pbr.w)/256.0;v_height_based_emission_params.z=emissionMultiplierValues.x;v_height_based_emission_params.w=emissionMultiplierValues.y-emissionMultiplierValues.x;\n#endif\n#ifdef FOG\nv_fog_pos=fog_position(local_pos);\n#endif\n#ifdef RENDER_CUTOFF\nv_cutoff_opacity=cutoff_opacity(u_cutoff_params,gl_Position.z);\n#endif\n#ifdef TERRAIN_FRAGMENT_OCCLUSION\nv_depth=gl_Position.z/gl_Position.w;\n#endif\n#ifdef HAS_ATTRIBUTE_a_normal_3f\n#ifdef MODEL_POSITION_ON_GPU\nfloat x_squared_scale=dot(rs[0],rs[0]);float y_squared_scale=dot(rs[1],rs[1]);float z_squared_scale=dot(rs[2],rs[2]);vec3 squared_scale=vec3(x_squared_scale,y_squared_scale,z_squared_scale);normal_3f=rs*((u_lighting_matrix*vec4(normal_3f,0.0)).xyz/squared_scale);normal_3f=normalize(normal_3f);\n#else\nnormal_3f=vec3(normal_matrix*vec4(normal_3f,0));\n#endif\n#endif\n#ifdef HAS_ATTRIBUTE_a_pbr\n#ifdef HAS_ATTRIBUTE_a_color_4f\nv_roughness_metallic_emissive_alpha.w=clamp(color_4f.a*v_roughness_metallic_emissive_alpha.w*(v_roughness_metallic_emissive_alpha.z-1.0),0.0,1.0);\n#endif\n#endif\n#ifdef RENDER_SHADOWS\nvec4 shadow_pos=u_node_matrix*vec4(local_pos,1.0);\n#ifdef NORMAL_OFFSET\n#ifdef HAS_ATTRIBUTE_a_normal_3f\n#ifdef MODEL_POSITION_ON_GPU\nvec3 offset=shadow_normal_offset(vec3(-normal_3f.xy,normal_3f.z));shadow_pos.xyz+=offset*shadow_normal_offset_multiplier0();\n#else\nvec3 offset=shadow_normal_offset_model(normal_3f);shadow_pos.xyz+=offset*shadow_normal_offset_multiplier0();\n#endif\n#endif\n#endif\nv_pos_light_view_0=u_light_matrix_0*shadow_pos;v_pos_light_view_1=u_light_matrix_1*shadow_pos;v_depth_shadows=gl_Position.w;\n#endif\n}'),
            modelDepth: Go("in highp float v_depth;void main() {\n#ifndef DEPTH_TEXTURE\nglFragColor=pack_depth(v_depth);\n#endif\n}", "in vec3 a_pos_3f;uniform mat4 u_matrix;out highp float v_depth;\n#ifdef MODEL_POSITION_ON_GPU\n#ifdef INSTANCED_ARRAYS\nin vec4 a_normal_matrix0;in vec4 a_normal_matrix1;in vec4 a_normal_matrix2;in vec4 a_normal_matrix3;\n#else\nuniform highp mat4 u_instance;\n#endif\nuniform highp mat4 u_node_matrix;\n#endif\nvoid main() {\n#ifdef MODEL_POSITION_ON_GPU\nhighp mat4 instance;\n#ifdef INSTANCED_ARRAYS\ninstance=mat4(a_normal_matrix0,a_normal_matrix1,a_normal_matrix2,a_normal_matrix3);\n#else\ninstance=u_instance;\n#endif\nvec3 pos_color=instance[0].xyz;vec4 translate=instance[1];vec3 pos_a=floor(pos_color);float hidden=float(pos_a.x > EXTENT);float meter_to_tile=instance[0].w;vec4 pos=vec4(pos_a.xy,translate.z,1.0);mat3 rs;rs[0].x=instance[1].w;rs[0].yz=instance[2].xy;rs[1].xy=instance[2].zw;rs[1].z=instance[3].x;rs[2].xyz=instance[3].yzw;vec4 pos_node=u_node_matrix*vec4(a_pos_3f,1.0);vec3 rotated_pos_node=rs*pos_node.xyz;vec3 pos_model_tile=(rotated_pos_node+vec3(translate.xy,0.0))*vec3(meter_to_tile,meter_to_tile,1.0);pos.xyz+=pos_model_tile;gl_Position=mix(u_matrix*pos,AWAY,hidden);\n#else\ngl_Position=u_matrix*vec4(a_pos_3f,1);\n#endif\nv_depth=gl_Position.z/gl_Position.w;}"),
            stars: Go("in highp vec2 v_uv;in mediump float v_intensity;float shapeCircle(in vec2 uv)\n{float beginFade=0.6;float lengthFromCenter=length(v_uv);return 1.0-clamp((lengthFromCenter-beginFade)/(1.0-beginFade),0.0,1.0);}void main() {float alpha=shapeCircle(v_uv);vec3 color=vec3(1.0,1.0,1.0);alpha*=v_intensity;glFragColor=vec4(color*alpha,alpha);HANDLE_WIREFRAME_DEBUG;}", "\nin vec3 a_pos_3f;in vec2 a_uv;in float a_size_scale;in float a_fade_opacity;uniform mat4 u_matrix;uniform vec3 u_up;uniform vec3 u_right;uniform float u_intensity_multiplier;out highp vec2 v_uv;out mediump float v_intensity;void main() {v_uv=a_uv;v_intensity=a_fade_opacity*u_intensity_multiplier;vec3 pos=a_pos_3f;pos+=a_uv.x*u_right*a_size_scale;pos+=a_uv.y*u_up*a_size_scale;gl_Position=u_matrix*vec4(pos,1.0);}"),
            snowParticle: Go("in highp vec2 uv;in highp float alphaMultiplier;uniform vec4 u_particleColor;uniform vec2 u_simpleShapeParameters;void main() {float t=clamp((length(uv)-u_simpleShapeParameters.x)/(1.0-u_simpleShapeParameters.x),0.0,1.0);float alpha=1.0-pow(t,pow(10.0,u_simpleShapeParameters.y));alpha*=alphaMultiplier;alpha*=u_particleColor.a;vec3 color=u_particleColor.rgb*alpha;glFragColor=vec4(color,alpha) ;HANDLE_WIREFRAME_DEBUG;}", "\nin highp vec3 a_pos_3f;in highp vec2 a_uv;in highp vec4 a_snowParticleData;in highp vec4 a_snowParticleDataHorizontalOscillation;uniform mat4 u_modelview;uniform mat4 u_projection;uniform vec3 u_cam_pos;uniform vec2 u_screenSize;uniform float u_time;uniform float u_boxSize;uniform float u_velocityConeAperture; \nuniform float u_velocity;uniform vec3 u_direction;uniform float u_horizontalOscillationRadius; \nuniform float u_horizontalOscillationRate; \nuniform float u_billboardSize;uniform vec2 u_thinningCenterPos;uniform vec3 u_thinningShape;uniform float u_thinningAffectedRatio;uniform float u_thinningParticleOffset;out highp vec2 uv;out highp float alphaMultiplier;void main() {vec3 pos=a_pos_3f;float halfBoxSize=0.5*u_boxSize;pos.xyz*=halfBoxSize;pos+=u_cam_pos;float velocityConeApertureRad=radians(u_velocityConeAperture*0.5);float coneAnglePichRad=velocityConeApertureRad*a_snowParticleData.z;float coneAngleHeadingRad=a_snowParticleData.w*radians(360.0);vec3 localZ=normalize(u_direction);vec3 localX=normalize(cross(localZ,vec3(1,0,0)));vec3 localY=normalize(cross(localZ,localX));vec3 direction;direction.x=cos(coneAngleHeadingRad)*sin(coneAnglePichRad);direction.y=sin(coneAngleHeadingRad)*sin(coneAnglePichRad);direction.z=cos(coneAnglePichRad);direction=normalize(direction);vec3 simPosLocal=vec3(0,0,0);float velocityScale=(1.0+3.0*a_snowParticleData.y)*u_velocity;simPosLocal+=direction*velocityScale*u_time;float horizontalOscillationRadius=u_horizontalOscillationRadius*a_snowParticleDataHorizontalOscillation.x;float horizontalOscillationAngle=u_horizontalOscillationRate*u_time*(-1.0+2.0*a_snowParticleDataHorizontalOscillation.y);simPosLocal.xy+=horizontalOscillationRadius*vec2(cos(horizontalOscillationAngle),sin(horizontalOscillationAngle));vec3 simPos=localX*simPosLocal.x+\nlocalY*simPosLocal.y+localZ*simPosLocal.z;pos+=simPos;pos=fract((pos+vec3(halfBoxSize))/vec3(u_boxSize))*u_boxSize-vec3(halfBoxSize);float clipZ=-u_cam_pos.z+pos.z;vec4 posView=u_modelview*vec4(pos,1.0);float size=u_billboardSize;alphaMultiplier=1.0;vec4 posScreen=u_projection*posView;posScreen/=posScreen.w;posScreen.xy=vec2(0.5)+posScreen.xy*0.5;posScreen.xy*=u_screenSize;vec2 thinningCenterPos=u_thinningCenterPos.xy;thinningCenterPos.y=u_screenSize.y-thinningCenterPos.y;float screenDist=length((thinningCenterPos-posScreen.xy)/(0.5*u_screenSize));screenDist+=a_snowParticleData.x*u_thinningParticleOffset;float scaleFactorMode=0.0;float thinningShapeDist=u_thinningShape.x+u_thinningShape.y;if (screenDist < thinningShapeDist) {float thinningFadeRatio=clamp((screenDist-u_thinningShape.x)/u_thinningShape.y,0.0,1.0);thinningFadeRatio=pow(thinningFadeRatio,u_thinningShape.z);if (a_snowParticleData.x < u_thinningAffectedRatio) {scaleFactorMode=1.0-thinningFadeRatio;alphaMultiplier=thinningFadeRatio;}}vec4 posScreen1=u_projection*vec4(posView.x-size,posView.yzw);posScreen1/=posScreen1.w;vec4 posScreen2=u_projection*vec4(posView.x+size,posView.yzw);posScreen2/=posScreen2.w;posScreen1.xy=vec2(0.5)+posScreen1.xy*0.5;posScreen1.xy*=u_screenSize;posScreen2.xy=vec2(0.5)+posScreen2.xy*0.5;posScreen2.xy*=u_screenSize;float screenLength=length(posScreen1.xy-posScreen2.xy);float screenEpsilon=3.0;float scaleFactor=1.0;if (screenLength < screenEpsilon) {scaleFactor=screenEpsilon/max(screenLength,0.01);scaleFactor=mix(scaleFactor,1.0,scaleFactorMode);}float screenEpsilon2=15.0;if (screenLength > screenEpsilon2) {scaleFactor=screenEpsilon2/max(screenLength,0.01);}size*=scaleFactor;vec2 right=size*vec2(1,0);vec2 up=size*vec2(0,1);posView.xy+=right*a_uv.x;posView.xy+=up*a_uv.y;uv=a_uv;gl_Position=u_projection*posView;}"),
            rainParticle: Go("in highp vec2 uv;in highp float particleRandomValue;uniform sampler2D u_texScreen;uniform float u_distortionStrength;uniform vec4 u_color;uniform vec2 u_thinningCenterPos;uniform vec3 u_thinningShape;uniform float u_thinningAffectedRatio;uniform float u_thinningParticleOffset;uniform float u_shapeDirectionalPower;uniform float u_mode;void main() {vec2 st=uv*0.5+vec2(0.5);vec2 uvm=uv;uvm.y=-1.0+2.0*pow(st.y,u_shapeDirectionalPower);float shape=clamp(1.0-length(uvm),0.0,1.0);float alpha=abs(shape)*u_color.a;vec2 screenSize=vec2(textureSize(u_texScreen,0));vec2 thinningCenterPos=u_thinningCenterPos.xy;thinningCenterPos.y=screenSize.y-thinningCenterPos.y;float screenDist=length((thinningCenterPos-gl_FragCoord.xy)/(0.5*screenSize));screenDist+=(0.5+0.5*particleRandomValue)*u_thinningParticleOffset;float thinningShapeDist=u_thinningShape.x+u_thinningShape.y;float thinningAlpha=1.0;if (screenDist < thinningShapeDist) {float thinningFadeRatio=clamp((screenDist-u_thinningShape.x)/u_thinningShape.y,0.0,1.0);thinningFadeRatio=pow(thinningFadeRatio,u_thinningShape.z);thinningAlpha*=thinningFadeRatio;}vec2 offsetXY=normalize(uvm)*abs(shape);vec2 stScreen=(gl_FragCoord.xy+offsetXY*u_distortionStrength*thinningAlpha)/screenSize;vec3 colorScreen=texture(u_texScreen,stScreen).rgb;alpha*=thinningAlpha;glFragColor=mix(vec4(colorScreen,1.0),vec4(u_color.rgb*alpha,alpha),u_mode);HANDLE_WIREFRAME_DEBUG;}", "\nin highp vec3 a_pos_3f;in highp vec2 a_uv;in highp vec4 a_rainParticleData;uniform mat4 u_modelview;uniform mat4 u_projection;uniform vec3 u_cam_pos;uniform float u_time;uniform float u_boxSize;uniform float u_velocityConeAperture; \nuniform float u_velocity; \nuniform vec2 u_rainDropletSize;uniform vec3 u_rainDirection;out highp vec2 uv;out highp float particleRandomValue;void main() {vec3 pos=a_pos_3f;float halfBoxSize=0.5*u_boxSize;pos*=halfBoxSize; \npos+=u_cam_pos;float velocityConeApertureRad=radians(u_velocityConeAperture*0.5);float coneAnglePichRad=velocityConeApertureRad*a_rainParticleData.z;float coneAngleHeadingRad=a_rainParticleData.w*radians(360.0);vec3 localZ=normalize(u_rainDirection);vec3 localX=normalize(cross(localZ,vec3(1,0,0)));vec3 localY=normalize(cross(localZ,localX));vec3 directionLocal;directionLocal.x=cos(coneAngleHeadingRad)*sin(coneAnglePichRad);directionLocal.y=sin(coneAngleHeadingRad)*sin(coneAnglePichRad);directionLocal.z=cos(coneAnglePichRad);directionLocal=normalize(directionLocal);vec3 directionWorld=localX*directionLocal.x+localY*directionLocal.y+localZ*directionLocal.z;float velocityScale=(1.0+3.0*a_rainParticleData.y)*u_velocity;vec3 simPosLocal=vec3(0,0,0);simPosLocal+=directionLocal*velocityScale*u_time;vec3 simPos=localX*simPosLocal.x+\nlocalY*simPosLocal.y+localZ*simPosLocal.z;pos+=simPos;pos=fract((pos+vec3(halfBoxSize))/vec3(u_boxSize))*u_boxSize-vec3(halfBoxSize);vec4 posView=u_modelview*vec4(pos,1.0);vec3 directionView=normalize((u_modelview*vec4(directionWorld,0.0)).xyz);vec3 side=cross(directionView,normalize(posView.xyz));posView.xyz+=side*a_uv.x*u_rainDropletSize.x;posView.xyz+=directionView*a_uv.y*u_rainDropletSize.y;uv=a_uv;particleRandomValue=a_rainParticleData.x;gl_Position=u_projection*posView;}"),
            vignette: Go("uniform vec3 u_vignetteShape;uniform vec4 u_vignetteColor;in vec2 st;void main() {float screenDist=length(st);float alpha=clamp((screenDist-u_vignetteShape.x)/u_vignetteShape.y,0.0,1.0);alpha=pow(alpha,u_vignetteShape.z)*u_vignetteColor.a;vec3 color=u_vignetteColor.rgb;glFragColor=vec4(color*alpha,alpha) ;}", "in vec2 a_pos_2f;out vec2 st;void main() {st=a_pos_2f;gl_Position=vec4(a_pos_2f,0,1);}"),
            occlusion: Go("uniform vec4 u_color;void main() {glFragColor=u_color;}", '#include "_prelude_terrain.vertex.glsl"\nin highp vec2 a_offset_xy;uniform highp vec3 u_anchorPos;uniform mat4 u_matrix;uniform vec2 u_screenSizePx;uniform vec2 u_occluderSizePx;void main() {vec3 world_pos=u_anchorPos;\n#ifdef TERRAIN\nfloat e=elevation(world_pos.xy);world_pos.z+=e;\n#endif\nvec4 projected_point=u_matrix*vec4(world_pos,1.0);projected_point.xy+=projected_point.w*a_offset_xy*0.5*u_occluderSizePx/u_screenSizePx;gl_Position=projected_point;}')
        };
        function jo(e, t1) {
            const i = e.replace(/\s*\/\/[^\n]*\n/g, "\n").split("\n");
            for (let e of i)if (e = e.trim(), "#" === e[0] && e.includes("if") && !e.includes("endif")) {
                e = e.replace("#", "").replace(/ifdef|ifndef|elif|if/g, "").replace(/!|defined|\(|\)|\|\||&&/g, "").replace(/\s+/g, " ").trim();
                const i = e.split(" ");
                for (const e of i)t1.includes(e) || t1.push(e);
            }
        }
        function Go(e, t1) {
            const i = /#include\s+"([^"]+)"/g, o = /#pragma mapbox: ([\w\-]+) ([\w]+) ([\w]+) ([\w]+)/g;
            let s = t1.match(/(attribute(\S*)|(^\s*|;)in) (highp |mediump |lowp )?([\w]+) ([\w]+)/gm);
            s && (s = s.map((e)=>{
                const t1 = e.split(" ");
                return t1[t1.length - 1];
            }), s = [
                ...new Set(s)
            ]);
            const r = {}, a = [], n = [];
            if (e = e.replace(i, (e, t1)=>(n.push(t1), "")), (t1 = t1.replace(i, (e, t1)=>(a.push(t1), ""))).includes("flat out")) return void console.error('The usage of "flat" qualifier is disallowed, see: https://bugs.webkit.org/show_bug.cgi?id=268071');
            let l = [
                ...Oo
            ];
            jo(e, l), jo(t1, l);
            for (const e of [
                ...a,
                ...n
            ])Fo[e] || console.error(`Undefined include: ${e}`), ko[e] || (ko[e] = [], jo(Fo[e], ko[e])), l = [
                ...l,
                ...ko[e]
            ];
            return {
                fragmentSource: e = e.replace(o, (e, t1, i, o, s)=>(r[s] = !0, "define" === t1 ? `\n#ifndef HAS_UNIFORM_u_${s}\nin ${i} ${o} ${s};\n#else\nuniform ${i} ${o} u_${s};\n#endif\n` : "initialize" === t1 ? `\n#ifdef HAS_UNIFORM_u_${s}\n    ${i} ${o} ${s} = u_${s};\n#endif\n` : "define-attribute" === t1 ? `\n#ifdef HAS_ATTRIBUTE_a_${s}\n    in ${i} ${o} ${s};\n#endif\n` : "initialize-attribute" === t1 ? "" : void 0)),
                vertexSource: t1 = t1.replace(o, (e, t1, i, o, s)=>{
                    const a = "float" === o ? "vec2" : o, n = s.match(/color/) ? "color" : a;
                    return "define-attribute-vertex-shader-only" === t1 ? `\n#ifdef HAS_ATTRIBUTE_a_${s}\nin ${i} ${o} a_${s};\n#endif\n` : r[s] ? "define" === t1 ? `\n#ifndef HAS_UNIFORM_u_${s}\nuniform lowp float u_${s}_t;\nin ${i} ${a} a_${s};\nout ${i} ${o} ${s};\n#else\nuniform ${i} ${o} u_${s};\n#endif\n` : "initialize" === t1 ? "vec4" === n ? `\n#ifndef HAS_UNIFORM_u_${s}\n    ${s} = a_${s};\n#else\n    ${i} ${o} ${s} = u_${s};\n#endif\n` : `\n#ifndef HAS_UNIFORM_u_${s}\n    ${s} = unpack_mix_${n}(a_${s}, u_${s}_t);\n#else\n    ${i} ${o} ${s} = u_${s};\n#endif\n` : "define-attribute" === t1 ? `\n#ifdef HAS_ATTRIBUTE_a_${s}\n    in ${i} ${o} a_${s};\n    out ${i} ${o} ${s};\n#endif\n` : "initialize-attribute" === t1 ? `\n#ifdef HAS_ATTRIBUTE_a_${s}\n    ${s} = a_${s};\n#endif\n` : void 0 : "define" === t1 ? `\n#ifndef HAS_UNIFORM_u_${s}\nuniform lowp float u_${s}_t;\nin ${i} ${a} a_${s};\n#else\nuniform ${i} ${o} u_${s};\n#endif\n` : "define-instanced" === t1 ? "mat4" === n ? `\n#ifdef INSTANCED_ARRAYS\nin vec4 a_${s}0;\nin vec4 a_${s}1;\nin vec4 a_${s}2;\nin vec4 a_${s}3;\n#else\nuniform ${i} ${o} u_${s};\n#endif\n` : `\n#ifdef INSTANCED_ARRAYS\nin ${i} ${a} a_${s};\n#else\nuniform ${i} ${o} u_${s};\n#endif\n` : "initialize-attribute-custom" === t1 ? `\n#ifdef HAS_ATTRIBUTE_a_${s}\n    ${i} ${o} ${s} = a_${s};\n#endif\n` : "vec4" === n ? `\n#ifndef HAS_UNIFORM_u_${s}\n    ${i} ${o} ${s} = a_${s};\n#else\n    ${i} ${o} ${s} = u_${s};\n#endif\n` : `\n#ifndef HAS_UNIFORM_u_${s}\n    ${i} ${o} ${s} = unpack_mix_${n}(a_${s}, u_${s}_t);\n#else\n    ${i} ${o} ${s} = u_${s};\n#endif\n`;
                }),
                staticAttributes: s,
                usedDefines: l,
                vertexIncludes: a,
                fragmentIncludes: n
            };
        }
        class Vo {
            bind(e, t1, i, o, s, r, a, n) {
                this.context = e;
                let l = this.boundPaintVertexBuffers.length !== o.length;
                for(let e = 0; !l && e < o.length; e++)this.boundPaintVertexBuffers[e] !== o[e] && (l = !0);
                let c = this.boundDynamicVertexBuffers.length !== a.length;
                for(let e = 0; !c && e < a.length; e++)this.boundDynamicVertexBuffers[e] !== a[e] && (c = !0);
                if (!this.vao || this.boundProgram !== t1 || this.boundLayoutVertexBuffer !== i || l || c || this.boundIndexBuffer !== s || this.boundVertexOffset !== r) this.freshBind(t1, i, o, s, r, a, n);
                else {
                    e.bindVertexArrayOES.set(this.vao);
                    for (const i of a)i && (i.bind(), n && i.instanceCount && i.setVertexAttribDivisor(e.gl, t1, n));
                    s && s.dynamicDraw && s.bind();
                }
            }
            freshBind(e, t1, i, o, s, r, a) {
                const n = e.numAttributes, l = this.context, c = l.gl;
                this.vao && this.destroy(), this.vao = l.gl.createVertexArray(), l.bindVertexArrayOES.set(this.vao), this.boundProgram = e, this.boundLayoutVertexBuffer = t1, this.boundPaintVertexBuffers = i, this.boundIndexBuffer = o, this.boundVertexOffset = s, this.boundDynamicVertexBuffers = r, t1.enableAttributes(c, e), t1.bind(), t1.setVertexAttribPointers(c, e, s);
                for (const t1 of i)t1.enableAttributes(c, e), t1.bind(), t1.setVertexAttribPointers(c, e, s);
                for (const t1 of r)t1 && (t1.enableAttributes(c, e), t1.bind(), t1.setVertexAttribPointers(c, e, s), a && t1.instanceCount && t1.setVertexAttribDivisor(c, e, a));
                o && o.bind(), l.currentNumAttributes = n;
            }
            destroy() {
                this.vao && (this.context.gl.deleteVertexArray(this.vao), this.vao = null);
            }
            constructor(){
                this.boundProgram = null, this.boundLayoutVertexBuffer = null, this.boundPaintVertexBuffers = [], this.boundIndexBuffer = null, this.boundVertexOffset = null, this.boundDynamicVertexBuffers = [], this.vao = null;
            }
        }
        function qo(t1, i) {
            const o = Math.pow(2, i.canonical.z), s = i.canonical.y;
            return [
                new e.aa(0, s / o).toLngLat().lat,
                new e.aa(0, (s + 1) / o).toLngLat().lat
            ];
        }
        function Ho(t1, i, o, s, r, a, n) {
            const l = t1.context, c = l.gl, h = o.hillshadeFBO;
            if (!h) return;
            t1.prepareDrawTile();
            const u = t1.isTileAffectedByFog(i), d = t1.getOrCreateProgram("hillshade", {
                overrideFog: u
            });
            l.activeTexture.set(c.TEXTURE0), c.bindTexture(c.TEXTURE_2D, h.colorAttachment.get());
            const _ = ((t1, i, o, s)=>{
                const r = o.paint.get("hillshade-shadow-color"), a = "none" === o.paint.get("hillshade-shadow-color-use-theme").constantOr("default"), n = o.paint.get("hillshade-highlight-color"), l = "none" === o.paint.get("hillshade-highlight-color-use-theme").constantOr("default"), c = o.paint.get("hillshade-accent-color"), h = "none" === o.paint.get("hillshade-accent-color-use-theme").constantOr("default"), u = o.paint.get("hillshade-emissive-strength");
                let d = e.ai(o.paint.get("hillshade-illumination-direction"));
                if ("viewport" === o.paint.get("hillshade-illumination-anchor")) d -= t1.transform.angle;
                else if (t1.style && t1.style.enable3dLights() && t1.style.directionalLight) {
                    const i = t1.style.directionalLight.properties.get("direction"), o = e.cb(i.x, i.y, i.z);
                    d = e.ai(o[1]);
                }
                const _ = !t1.options.moving;
                return {
                    u_matrix: s || t1.transform.calculateProjMatrix(i.tileID.toUnwrapped(), _),
                    u_image: 0,
                    u_latrange: qo(0, i.tileID),
                    u_light: [
                        o.paint.get("hillshade-exaggeration"),
                        d
                    ],
                    u_shadow: r.toRenderColor(a ? null : o.lut),
                    u_highlight: n.toRenderColor(l ? null : o.lut),
                    u_emissive_strength: u,
                    u_accent: c.toRenderColor(h ? null : o.lut)
                };
            })(t1, o, s, t1.terrain ? i.projMatrix : null);
            t1.uploadCommonUniforms(l, d, i.toUnwrapped());
            const { tileBoundsBuffer: p, tileBoundsIndexBuffer: f, tileBoundsSegments: m } = t1.getTileBoundsBuffers(o);
            d.draw(t1, c.TRIANGLES, r, a, n, Vi.disabled, _, s.id, p, f, m);
        }
        function Zo(t1, i, o) {
            if (!i.needsDEMTextureUpload) return;
            const s = t1.context, r = s.gl;
            s.pixelStoreUnpackPremultiplyAlpha.set(!1), i.demTexture = i.demTexture || t1.getTileTexture(o.stride);
            const a = o.getPixels();
            i.demTexture ? i.demTexture.update(a, {
                premultiply: !1
            }) : i.demTexture = new e.T(s, a, r.R32F, {
                premultiply: !1
            }), i.needsDEMTextureUpload = !1;
        }
        function Wo(t1, i, o) {
            const s = t1.context, r = s.gl;
            if (!i.dem) return;
            const a = i.dem;
            if (s.activeTexture.set(r.TEXTURE1), Zo(t1, i, a), !i.demTexture) return;
            i.demTexture.bind(r.NEAREST, r.CLAMP_TO_EDGE);
            const n = a.dim;
            s.activeTexture.set(r.TEXTURE0);
            let l = i.hillshadeFBO;
            if (!l) {
                const t1 = new e.T(s, {
                    width: n,
                    height: n,
                    data: null
                }, r.RGBA8);
                t1.bind(r.LINEAR, r.CLAMP_TO_EDGE), l = i.hillshadeFBO = s.createFramebuffer(n, n, !0, "renderbuffer"), l.colorAttachment.set(t1.texture);
            }
            s.bindFramebuffer.set(l.framebuffer), s.viewport.set([
                0,
                0,
                n,
                n
            ]);
            const { tileBoundsBuffer: c, tileBoundsIndexBuffer: h, tileBoundsSegments: u } = t1.getMercatorTileBoundsBuffers(), d = [];
            t1.linearFloatFilteringSupported() && d.push("TERRAIN_DEM_FLOAT_FORMAT"), t1.getOrCreateProgram("hillshadePrepare", {
                defines: d
            }).draw(t1, r.TRIANGLES, Bi.disabled, Ui.disabled, ki.unblended, Vi.disabled, ((t1, i)=>{
                const o = i.stride, s = e.ab.mat4.create();
                return e.ab.mat4.ortho(s, 0, e.ag, -e.ag, 0, 0, 1), e.ab.mat4.translate(s, s, [
                    0,
                    -e.ag,
                    0
                ]), {
                    u_matrix: s,
                    u_image: 1,
                    u_dimension: [
                        o,
                        o
                    ],
                    u_zoom: t1.overscaledZ
                };
            })(i.tileID, a), o.id, c, h, u), i.needsHillshadePrepare = !1;
        }
        class $o {
            get() {
                return this.current;
            }
            set(e) {}
            getDefault() {
                return this.default;
            }
            setDefault() {
                this.set(this.default);
            }
            constructor(e){
                this.gl = e.gl, this.default = this.getDefault(), this.current = this.default, this.dirty = !1;
            }
        }
        class Xo extends $o {
            getDefault() {
                return e.aj.transparent;
            }
            set(e) {
                const t1 = this.current;
                (e.r !== t1.r || e.g !== t1.g || e.b !== t1.b || e.a !== t1.a || this.dirty) && (this.gl.clearColor(e.r, e.g, e.b, e.a), this.current = e, this.dirty = !1);
            }
        }
        class Ko extends $o {
            getDefault() {
                return 1;
            }
            set(e) {
                (e !== this.current || this.dirty) && (this.gl.clearDepth(e), this.current = e, this.dirty = !1);
            }
        }
        class Yo extends $o {
            getDefault() {
                return 0;
            }
            set(e) {
                (e !== this.current || this.dirty) && (this.gl.clearStencil(e), this.current = e, this.dirty = !1);
            }
        }
        class Jo extends $o {
            getDefault() {
                return [
                    !0,
                    !0,
                    !0,
                    !0
                ];
            }
            set(e) {
                const t1 = this.current;
                (e[0] !== t1[0] || e[1] !== t1[1] || e[2] !== t1[2] || e[3] !== t1[3] || this.dirty) && (this.gl.colorMask(e[0], e[1], e[2], e[3]), this.current = e, this.dirty = !1);
            }
        }
        class Qo extends $o {
            getDefault() {
                return !0;
            }
            set(e) {
                (e !== this.current || this.dirty) && (this.gl.depthMask(e), this.current = e, this.dirty = !1);
            }
        }
        class es extends $o {
            getDefault() {
                return 255;
            }
            set(e) {
                (e !== this.current || this.dirty) && (this.gl.stencilMask(e), this.current = e, this.dirty = !1);
            }
        }
        class ts extends $o {
            getDefault() {
                return {
                    func: this.gl.ALWAYS,
                    ref: 0,
                    mask: 255
                };
            }
            set(e) {
                const t1 = this.current;
                (e.func !== t1.func || e.ref !== t1.ref || e.mask !== t1.mask || this.dirty) && (this.gl.stencilFunc(e.func, e.ref, e.mask), this.current = e, this.dirty = !1);
            }
        }
        class is extends $o {
            getDefault() {
                const e = this.gl;
                return [
                    e.KEEP,
                    e.KEEP,
                    e.KEEP
                ];
            }
            set(e) {
                const t1 = this.current;
                (e[0] !== t1[0] || e[1] !== t1[1] || e[2] !== t1[2] || this.dirty) && (this.gl.stencilOp(e[0], e[1], e[2]), this.current = e, this.dirty = !1);
            }
        }
        class os extends $o {
            getDefault() {
                return !1;
            }
            set(e) {
                if (e === this.current && !this.dirty) return;
                const t1 = this.gl;
                e ? t1.enable(t1.STENCIL_TEST) : t1.disable(t1.STENCIL_TEST), this.current = e, this.dirty = !1;
            }
        }
        class ss extends $o {
            getDefault() {
                return [
                    0,
                    1
                ];
            }
            set(e) {
                const t1 = this.current;
                (e[0] !== t1[0] || e[1] !== t1[1] || this.dirty) && (this.gl.depthRange(e[0], e[1]), this.current = e, this.dirty = !1);
            }
        }
        class rs extends $o {
            getDefault() {
                return !1;
            }
            set(e) {
                if (e === this.current && !this.dirty) return;
                const t1 = this.gl;
                e ? t1.enable(t1.DEPTH_TEST) : t1.disable(t1.DEPTH_TEST), this.current = e, this.dirty = !1;
            }
        }
        class as extends $o {
            getDefault() {
                return this.gl.LESS;
            }
            set(e) {
                (e !== this.current || this.dirty) && (this.gl.depthFunc(e), this.current = e, this.dirty = !1);
            }
        }
        class ns extends $o {
            getDefault() {
                return !1;
            }
            set(e) {
                if (e === this.current && !this.dirty) return;
                const t1 = this.gl;
                e ? t1.enable(t1.BLEND) : t1.disable(t1.BLEND), this.current = e, this.dirty = !1;
            }
        }
        class ls extends $o {
            getDefault() {
                const e = this.gl;
                return [
                    e.ONE,
                    e.ZERO,
                    e.ONE,
                    e.ZERO
                ];
            }
            set(e) {
                const t1 = this.current;
                (e[0] !== t1[0] || e[1] !== t1[1] || e[2] !== t1[2] || e[3] !== t1[3] || this.dirty) && (this.gl.blendFuncSeparate(e[0], e[1], e[2], e[3]), this.current = e, this.dirty = !1);
            }
        }
        class cs extends $o {
            getDefault() {
                return e.aj.transparent;
            }
            set(e) {
                const t1 = this.current;
                (e.r !== t1.r || e.g !== t1.g || e.b !== t1.b || e.a !== t1.a || this.dirty) && (this.gl.blendColor(e.r, e.g, e.b, e.a), this.current = e, this.dirty = !1);
            }
        }
        class hs extends $o {
            getDefault() {
                return this.gl.FUNC_ADD;
            }
            set(e) {
                (e !== this.current || this.dirty) && (this.gl.blendEquationSeparate(e, e), this.current = e, this.dirty = !1);
            }
        }
        class us extends $o {
            getDefault() {
                return !1;
            }
            set(e) {
                if (e === this.current && !this.dirty) return;
                const t1 = this.gl;
                e ? t1.enable(t1.CULL_FACE) : t1.disable(t1.CULL_FACE), this.current = e, this.dirty = !1;
            }
        }
        class ds extends $o {
            getDefault() {
                return this.gl.BACK;
            }
            set(e) {
                (e !== this.current || this.dirty) && (this.gl.cullFace(e), this.current = e, this.dirty = !1);
            }
        }
        class _s extends $o {
            getDefault() {
                return this.gl.CCW;
            }
            set(e) {
                (e !== this.current || this.dirty) && (this.gl.frontFace(e), this.current = e, this.dirty = !1);
            }
        }
        let ps = class extends $o {
            getDefault() {
                return null;
            }
            set(e) {
                (e !== this.current || this.dirty) && (this.gl.useProgram(e), this.current = e, this.dirty = !1);
            }
        };
        class fs extends $o {
            getDefault() {
                return this.gl.TEXTURE0;
            }
            set(e) {
                (e !== this.current || this.dirty) && (this.gl.activeTexture(e), this.current = e, this.dirty = !1);
            }
        }
        class ms extends $o {
            getDefault() {
                const e = this.gl;
                return [
                    0,
                    0,
                    e.drawingBufferWidth,
                    e.drawingBufferHeight
                ];
            }
            set(e) {
                const t1 = this.current;
                (e[0] !== t1[0] || e[1] !== t1[1] || e[2] !== t1[2] || e[3] !== t1[3] || this.dirty) && (this.gl.viewport(e[0], e[1], e[2], e[3]), this.current = e, this.dirty = !1);
            }
        }
        class gs extends $o {
            getDefault() {
                return null;
            }
            set(e) {
                if (e === this.current && !this.dirty) return;
                const t1 = this.gl;
                t1.bindFramebuffer(t1.FRAMEBUFFER, e), this.current = e, this.dirty = !1;
            }
        }
        class vs extends $o {
            getDefault() {
                return null;
            }
            set(e) {
                if (e === this.current && !this.dirty) return;
                const t1 = this.gl;
                t1.bindRenderbuffer(t1.RENDERBUFFER, e), this.current = e, this.dirty = !1;
            }
        }
        class ys extends $o {
            getDefault() {
                return null;
            }
            set(e) {
                if (e === this.current && !this.dirty) return;
                const t1 = this.gl;
                t1.bindTexture(t1.TEXTURE_2D, e), this.current = e, this.dirty = !1;
            }
        }
        class xs extends $o {
            getDefault() {
                return null;
            }
            set(e) {
                if (e === this.current && !this.dirty) return;
                const t1 = this.gl;
                t1.bindBuffer(t1.ARRAY_BUFFER, e), this.current = e, this.dirty = !1;
            }
        }
        class bs extends $o {
            getDefault() {
                return null;
            }
            set(e) {
                const t1 = this.gl;
                t1.bindBuffer(t1.ELEMENT_ARRAY_BUFFER, e), this.current = e, this.dirty = !1;
            }
        }
        class ws extends $o {
            getDefault() {
                return null;
            }
            set(e) {
                this.gl && (e !== this.current || this.dirty) && (this.gl.bindVertexArray(e), this.current = e, this.dirty = !1);
            }
        }
        class Ts extends $o {
            getDefault() {
                return 4;
            }
            set(e) {
                if (e === this.current && !this.dirty) return;
                const t1 = this.gl;
                t1.pixelStorei(t1.UNPACK_ALIGNMENT, e), this.current = e, this.dirty = !1;
            }
        }
        class Es extends $o {
            getDefault() {
                return !1;
            }
            set(e) {
                if (e === this.current && !this.dirty) return;
                const t1 = this.gl;
                t1.pixelStorei(t1.UNPACK_PREMULTIPLY_ALPHA_WEBGL, e), this.current = e, this.dirty = !1;
            }
        }
        class Ss extends $o {
            getDefault() {
                return !1;
            }
            set(e) {
                if (e === this.current && !this.dirty) return;
                const t1 = this.gl;
                t1.pixelStorei(t1.UNPACK_FLIP_Y_WEBGL, e), this.current = e, this.dirty = !1;
            }
        }
        class Cs extends $o {
            getDefault() {
                return null;
            }
            constructor(e, t1){
                super(e), this.context = e, this.parent = t1;
            }
        }
        class Is extends Cs {
            setDirty() {
                this.dirty = !0;
            }
            set(e) {
                if (e === this.current && !this.dirty) return;
                this.context.bindFramebuffer.set(this.parent);
                const t1 = this.gl;
                t1.framebufferTexture2D(t1.FRAMEBUFFER, t1.COLOR_ATTACHMENT0, t1.TEXTURE_2D, e, 0), this.current = e, this.dirty = !1;
            }
        }
        class Rs extends Cs {
            attachment() {
                return this.gl.DEPTH_ATTACHMENT;
            }
            set(e) {
                if (e === this.current && !this.dirty) return;
                this.context.bindFramebuffer.set(this.parent);
                const t1 = this.gl;
                t1.framebufferRenderbuffer(t1.FRAMEBUFFER, this.attachment(), t1.RENDERBUFFER, e), this.current = e, this.dirty = !1;
            }
        }
        class Ds extends Cs {
            attachment() {
                return this.gl.DEPTH_ATTACHMENT;
            }
            set(e) {
                if (e === this.current && !this.dirty) return;
                this.context.bindFramebuffer.set(this.parent);
                const t1 = this.gl;
                t1.framebufferTexture2D(t1.FRAMEBUFFER, this.attachment(), t1.TEXTURE_2D, e, 0), this.current = e, this.dirty = !1;
            }
        }
        class Ls extends Rs {
            attachment() {
                return this.gl.DEPTH_STENCIL_ATTACHMENT;
            }
        }
        const As = (e, t1, i)=>({
                u_matrix: e,
                u_image0: 0,
                u_skirt_height: t1,
                u_ground_shadow_factor: i
            }), zs = (e, t1, i, o, s, r, a, n, l, c, h, u, d, _, p, f)=>({
                u_proj_matrix: Float32Array.from(e),
                u_globe_matrix: t1,
                u_normalize_matrix: Float32Array.from(o),
                u_merc_matrix: i,
                u_zoom_transition: s,
                u_merc_center: r,
                u_image0: 0,
                u_frustum_tl: a,
                u_frustum_tr: n,
                u_frustum_br: l,
                u_frustum_bl: c,
                u_globe_pos: h,
                u_globe_radius: u,
                u_viewport: d,
                u_grid_matrix: f ? Float32Array.from(f) : new Float32Array(9),
                u_skirt_height: _,
                u_far_z_cutoff: p
            });
        function Ps(e, t1) {
            return null != e && null != t1 && !(!e.hasData() || !t1.hasData()) && null != e.demTexture && null != t1.demTexture && e.tileID.key !== t1.tileID.key;
        }
        const Ms = new class {
            newMorphing(e, t1, i, o, s) {
                if (e in this.operations) {
                    const t1 = this.operations[e];
                    t1.to.tileID.key !== i.tileID.key && (t1.queued = i);
                } else this.operations[e] = {
                    startTime: o,
                    phase: 0,
                    duration: s,
                    from: t1,
                    to: i,
                    queued: null
                };
            }
            getMorphValuesForProxy(e) {
                if (!(e in this.operations)) return null;
                const t1 = this.operations[e];
                return {
                    from: t1.from,
                    to: t1.to,
                    phase: t1.phase
                };
            }
            update(e) {
                for(const t1 in this.operations){
                    const i = this.operations[t1];
                    for(i.phase = (e - i.startTime) / i.duration; i.phase >= 1 || !this._validOp(i);)if (!this._nextOp(i, e)) {
                        delete this.operations[t1];
                        break;
                    }
                }
            }
            _nextOp(e, t1) {
                return !!e.queued && (e.from = e.to, e.to = e.queued, e.queued = null, e.phase = 0, e.startTime = t1, !0);
            }
            _validOp(e) {
                return e.from.hasData() && e.to.hasData();
            }
            constructor(){
                this.operations = {};
            }
        }, Os = {
            0: null,
            1: "TERRAIN_VERTEX_MORPHING"
        };
        function Fs(e, t1, i) {
            if (0 === t1) return 0;
            const o = t1 < 1 && 514 === i ? .25 / t1 : 1;
            return 6 * Math.pow(1.5, 22 - e) * Math.max(t1, 1) * o;
        }
        function ks(e, t1) {
            const i = 1 << e.z;
            return !t1 && (0 === e.x || e.x === i - 1) || 0 === e.y || e.y === i - 1;
        }
        const Bs = (e)=>({
                u_matrix: e
            });
        function Ns(t1, i, o, s, r) {
            if (r > 0) {
                const a = e.q.now(), n = (a - t1.timeAdded) / r, l = i ? (a - i.timeAdded) / r : -1, c = o.getSource(), h = s.coveringZoomLevel({
                    tileSize: c.tileSize,
                    roundZoom: c.roundZoom
                }), u = !i || Math.abs(i.tileID.overscaledZ - h) > Math.abs(t1.tileID.overscaledZ - h), d = u && t1.refreshedUponExpiration ? 1 : e.aw(u ? n : 1 - l, 0, 1);
                return t1.refreshedUponExpiration && n >= 1 && (t1.refreshedUponExpiration = !1), i ? {
                    opacity: 1,
                    mix: 1 - d
                } : {
                    opacity: d,
                    mix: 0
                };
            }
            return {
                opacity: 1,
                mix: 0
            };
        }
        class Us extends St {
            _loadTile(e, t1) {
                e.state = "loaded", t1(null);
            }
            constructor(t1){
                const i = {
                    type: "raster-dem",
                    maxzoom: t1.transform.maxZoom
                }, o = new e.D(e.ci(), null), s = rt("mock-dem", i, o, t1.style);
                super("mock-dem", s, !1), s.setEventedParent(this), this._sourceLoaded = !0;
            }
        }
        class js extends St {
            update(e, t1, i) {
                if (e.freezeTileCoverage) return;
                this.transform = e;
                const o = e.coveringTiles({
                    tileSize: this._source.tileSize,
                    minzoom: this._source.minzoom,
                    maxzoom: this._source.maxzoom,
                    roundZoom: this._source.roundZoom,
                    reparseOverscaled: this._source.reparseOverscaled
                }).reduce((t1, i)=>{
                    if (t1[i.key] = "", !this._tiles[i.key]) {
                        const t1 = new bt(i, this._source.tileSize * i.overscaleFactor(), e.tileZoom);
                        t1.state = "loaded", this._tiles[i.key] = t1;
                    }
                    return t1;
                }, {});
                for(const e in this._tiles)e in o || (this.freeFBO(e), this._tiles[e].unloadVectorData(), delete this._tiles[e]);
            }
            freeFBO(e) {
                const t1 = this.proxyCachedFBO[e];
                if (void 0 !== t1) {
                    const i = Object.values(t1);
                    this.renderCachePool.push(...i), delete this.proxyCachedFBO[e];
                }
            }
            deallocRenderCache() {
                this.renderCache.forEach((e)=>e.fb.destroy()), this.renderCache = [], this.renderCachePool = [], this.proxyCachedFBO = {};
            }
            constructor(t1){
                const i = rt("proxy", {
                    type: "geojson",
                    maxzoom: t1.transform.maxZoom
                }, new e.D(e.ci(), null), t1.style);
                super("proxy", i, !1), i.setEventedParent(this), this.map = this.getSource().map = t1, this.used = this._sourceLoaded = !0, this.renderCache = [], this.renderCachePool = [], this.proxyCachedFBO = {};
            }
        }
        class Gs extends e.aG {
            constructor(e, t1, i){
                super(e.overscaledZ, e.wrap, e.canonical.z, e.canonical.x, e.canonical.y), this.proxyTileKey = t1, this.projMatrix = i;
            }
        }
        class Vs extends e.cJ {
            set style(e) {
                e.on("data", this._onStyleDataEvent.bind(this)), this._style = e, this._style.map.on("moveend", ()=>{
                    this._clearLineLayersFromRenderCache();
                });
            }
            update(t1, i, o) {
                if (t1 && t1.terrain) {
                    this._style !== t1 && (this.style = t1, this._evaluationZoom = void 0);
                    const s = t1.terrain.properties, r = 0 === t1.terrain.drapeRenderMode, a = t1.terrain.isZoomDependent();
                    this._previousUpdateTimestamp = this.enabled ? this._updateTimestamp : void 0, this._updateTimestamp = e.q.now();
                    const n = t1.terrain && t1.terrain.scope, l = s.get("source"), c = r ? this._mockSourceCache : t1.getSourceCache(l, n);
                    if (!c) return void e.w(`Couldn't find terrain source "${l}".`);
                    if (this.sourceCache = c, this._attenuationRange = t1.terrain.getAttenuationRange(), this._exaggeration = a ? this.calculateExaggeration(i) : s.get("exaggeration"), !i.projection.requiresDraping && a && 0 === this._exaggeration) return void this._disable();
                    this.enabled = !0;
                    const h = ()=>{
                        this.sourceCache.used && e.w(`Raster DEM source '${this.sourceCache.id}' is used both for terrain and as layer source.\nThis leads to lower resolution of hillshade. For full hillshade resolution but higher memory consumption, define another raster DEM source.`);
                        const t1 = this.getScaledDemTileSize();
                        this.sourceCache.update(i, t1, !0), this.resetTileLookupCache(this.sourceCache.id);
                    };
                    this.sourceCache.usedForTerrain || (this.resetTileLookupCache(this.sourceCache.id), this.sourceCache.usedForTerrain = !0, h(), this._initializing = !0), h(), i.updateElevation(!0, o), this.resetTileLookupCache(this.proxySourceCache.id), this.proxySourceCache.update(i), this._emptyDEMTextureDirty = !0, this._previousZoom = i.zoom;
                } else this._disable();
            }
            calculateExaggeration(t1) {
                if (this._attenuationRange && t1.zoom >= Math.ceil(this._attenuationRange[1])) return this._style.terrain.getExaggeration(t1.zoom);
                const i = this._previousCameraAltitude, o = t1.getFreeCameraOptions().position.z / t1.pixelsPerMeter * t1.worldSize;
                this._previousCameraAltitude = o;
                const s = null != i ? o - i : Number.MAX_VALUE;
                if (Math.abs(s) < 2) return this._exaggeration;
                const r = t1.zoom, a = this._style.terrain;
                if (!this._previousUpdateTimestamp) return a.getExaggeration(r);
                let n = r - this._previousZoom;
                const l = this._previousUpdateTimestamp;
                let c = r;
                null != this._evaluationZoom && (c = this._evaluationZoom, Math.abs(r - c) > .5 && (n = .5 * (r - c + n)), n * s < 0 && (c += n)), this._evaluationZoom = c;
                const h = a.getExaggeration(c), u = h === a.getExaggeration(Math.max(0, c - .1));
                if (u && Math.abs(h - this._exaggeration) < .01) return h;
                let d = Math.min(.1, .00375 * (this._updateTimestamp - l));
                return (u || h < .1 || Math.abs(n) < 1e-4) && (d = Math.min(.2, 4 * d)), e.af(this._exaggeration, h, d);
            }
            resetTileLookupCache(e) {
                this._findCoveringTileCache[e] = {};
            }
            attenuationRange() {
                return this._attenuationRange;
            }
            getDemUpscale() {
                return this.proxySourceCache.getSource().tileSize / 128;
            }
            getScaledDemTileSize() {
                return this.sourceCache.getSource().tileSize / 128 * this.proxySourceCache.getSource().tileSize;
            }
            _onStyleDataEvent(e) {
                e.coord && "source" === e.dataType ? this._clearRenderCacheForTile(e.sourceCacheId, e.coord) : "style" === e.dataType && (this.invalidateRenderCache = !0, this._evaluationZoom = void 0, this._previousUpdateTimestamp = void 0, this._previousCameraAltitude = void 0);
            }
            _disable() {
                if (this.enabled && (this.enabled = !1, this._emptyDEMTextureDirty = !0, this._sharedDepthStencil = void 0, this._evaluationZoom = void 0, this._previousUpdateTimestamp = void 0, this.proxySourceCache.deallocRenderCache(), this._style)) for(const e in this._style._mergedSourceCaches)this._style._mergedSourceCaches[e].usedForTerrain = !1;
            }
            destroy() {
                this._disable(), this._emptyDEMTexture && this._emptyDEMTexture.destroy(), this.pool.forEach((e)=>e.fb.destroy()), this.pool = [], this.framebufferCopyTexture && this.framebufferCopyTexture.destroy();
            }
            _source() {
                return this.enabled ? this.sourceCache : null;
            }
            isUsingMockSource() {
                return this.sourceCache === this._mockSourceCache;
            }
            exaggeration() {
                return this.enabled ? this._exaggeration : 0;
            }
            get visibleDemTiles() {
                return this._visibleDemTiles;
            }
            get drapeBufferSize() {
                const e = 2 * this.proxySourceCache.getSource().tileSize;
                return [
                    e,
                    e
                ];
            }
            set useVertexMorphing(e) {
                this._useVertexMorphing = e;
            }
            updateTileBinding(t1) {
                if (!this.enabled) return;
                this.prevTerrainTileForTile = this.terrainTileForTile;
                const i = this.proxySourceCache, o = this.painter.transform;
                this._initializing && (this._initializing = 0 === o._centerAltitude && -1 === this.getAtPointOrZero(e.aa.fromLngLat(o.center), -1), this._emptyDEMTextureDirty = !this._initializing);
                const s = this.proxyCoords = i.getIds().map((e)=>{
                    const t1 = i.getTileByID(e).tileID;
                    return t1.projMatrix = o.calculateProjMatrix(t1.toUnwrapped()), t1;
                });
                !function(t1, i) {
                    const o = i.transform.pointCoordinate(i.transform.getCameraPoint()), s = new e.P(o.x, o.y);
                    t1.sort((t1, i)=>{
                        if (i.overscaledZ - t1.overscaledZ) return i.overscaledZ - t1.overscaledZ;
                        const o = new e.P(t1.canonical.x + (1 << t1.canonical.z) * t1.wrap, t1.canonical.y), r = new e.P(i.canonical.x + (1 << i.canonical.z) * i.wrap, i.canonical.y), a = s.mult(1 << t1.canonical.z);
                        return a.x -= .5, a.y -= .5, a.distSqr(o) - a.distSqr(r);
                    });
                }(s, this.painter);
                const r = this.proxyToSource || {};
                this.proxyToSource = {}, s.forEach((e)=>{
                    this.proxyToSource[e.key] = {};
                }), this.terrainTileForTile = {};
                const a = this._style._mergedSourceCaches;
                for(const e in a){
                    const i = a[e];
                    if (!i.used) continue;
                    if (i !== this.sourceCache && this.resetTileLookupCache(i.id), this._setupProxiedCoordsForOrtho(i, t1[e], r), i.usedForTerrain) continue;
                    const o = t1[e];
                    i.getSource().reparseOverscaled && this._assignTerrainTiles(o);
                }
                this.proxiedCoords[i.id] = s.map((e)=>new Gs(e, e.key, this.orthoMatrix)), this._assignTerrainTiles(s), this._prepareDEMTextures(), this._setupDrapedRenderBatches(), this._initFBOPool(), this._setupRenderCache(r), this.renderingToTexture = !1;
                const n = {};
                this._visibleDemTiles = [];
                for (const e of this.proxyCoords){
                    const t1 = this.terrainTileForTile[e.key];
                    if (!t1) continue;
                    const i = t1.tileID.key;
                    i in n || (this._visibleDemTiles.push(t1), n[i] = i);
                }
            }
            _assignTerrainTiles(e) {
                this._initializing || e.forEach((e)=>{
                    if (this.terrainTileForTile[e.key]) return;
                    const t1 = this._findTileCoveringTileID(e, this.sourceCache);
                    t1 && (this.terrainTileForTile[e.key] = t1);
                });
            }
            _prepareDEMTextures() {
                const e = this.painter.context, t1 = e.gl;
                for(const i in this.terrainTileForTile){
                    const o = this.terrainTileForTile[i], s = o.dem;
                    !s || o.demTexture && !o.needsDEMTextureUpload || (e.activeTexture.set(t1.TEXTURE1), Zo(this.painter, o, s));
                }
            }
            _prepareDemTileUniforms(e, t1, i, o) {
                if (!t1 || null == t1.demTexture) return !1;
                const s = e.tileID.canonical, r = Math.pow(2, t1.tileID.canonical.z - s.z), a = o || "";
                return i[`u_dem_tl${a}`] = [
                    s.x * r % 1,
                    s.y * r % 1
                ], i[`u_dem_scale${a}`] = r, !0;
            }
            get emptyDEMTexture() {
                return !this._emptyDEMTextureDirty && this._emptyDEMTexture ? this._emptyDEMTexture : this._updateEmptyDEMTexture();
            }
            _getLoadedAreaMinimum() {
                if (!this.enabled) return 0;
                let e = 0;
                const t1 = this._visibleDemTiles.reduce((t1, i)=>{
                    if (!i.dem) return t1;
                    const o = i.dem.tree.minimums[0];
                    return o > 0 && e++, t1 + o;
                }, 0);
                return e ? t1 / e : 0;
            }
            _updateEmptyDEMTexture() {
                const t1 = this.painter.context, i = t1.gl;
                t1.activeTexture.set(i.TEXTURE2);
                const o = this._getLoadedAreaMinimum(), s = new e.cK({
                    width: 1,
                    height: 1
                }, new Float32Array([
                    o
                ]));
                this._emptyDEMTextureDirty = !1;
                let r = this._emptyDEMTexture;
                return r ? r.update(s, {
                    premultiply: !1
                }) : r = this._emptyDEMTexture = new e.T(t1, s, i.R32F, {
                    premultiply: !1
                }), r;
            }
            setupElevationDraw(t1, i, o) {
                const s = this.painter.context, r = s.gl, a = {
                    u_dem: 2,
                    u_dem_prev: 4,
                    u_dem_tl: [
                        0,
                        0
                    ],
                    u_dem_tl_prev: [
                        0,
                        0
                    ],
                    u_dem_scale: 0,
                    u_dem_scale_prev: 0,
                    u_dem_size: 0,
                    u_dem_lerp: 1,
                    u_depth: 3,
                    u_depth_size_inv: [
                        0,
                        0
                    ],
                    u_depth_range_unpack: [
                        0,
                        1
                    ],
                    u_occluder_half_size: 16,
                    u_occlusion_depth_offset: -0.0001,
                    u_exaggeration: 0
                };
                a.u_exaggeration = this.exaggeration();
                let n = null, l = null, c = 1;
                if (o && o.morphing && this._useVertexMorphing) {
                    const e = o.morphing.srcDemTile, i = o.morphing.dstDemTile;
                    c = o.morphing.phase, e && i && (this._prepareDemTileUniforms(t1, e, a, "_prev") && (l = e), this._prepareDemTileUniforms(t1, i, a) && (n = i));
                }
                const h = (e)=>e && e.demTexture && this.painter.linearFloatFilteringSupported() ? r.LINEAR : r.NEAREST;
                let u = null;
                var d;
                if (this.enabled ? l && n ? (u = n.demTexture, s.activeTexture.set(r.TEXTURE4), l.demTexture.bind(h(l), r.CLAMP_TO_EDGE), a.u_dem_lerp = c) : (n = this.terrainTileForTile[t1.tileID.key], u = this._prepareDemTileUniforms(t1, n, a) ? n.demTexture : this.emptyDEMTexture) : u = this.emptyDEMTexture, s.activeTexture.set(r.TEXTURE2), u && (a.u_dem_size = 1 === (d = u).size[0] ? 1 : d.size[0] - 2, u.bind(h(n), r.CLAMP_TO_EDGE)), this.painter.setupDepthForOcclusion(o && o.useDepthForOcclusion, i, a), o && o.useMeterToDem && n) {
                    const t1 = (1 << n.tileID.canonical.z) * e.bH(1, this.painter.transform.center.lat) * this.sourceCache.getSource().tileSize;
                    a.u_meter_to_dem = t1;
                }
                if (o && o.labelPlaneMatrixInv && (a.u_label_plane_matrix_inv = o.labelPlaneMatrixInv), i.setTerrainUniformValues(s, a), "globe" === this.painter.transform.projection.name) {
                    const e = this.globeUniformValues(this.painter.transform, t1.tileID.canonical, o && o.useDenormalizedUpVectorScale);
                    i.setGlobeUniformValues(s, e);
                }
            }
            globeUniformValues(t1, i, o) {
                const s = t1.projection;
                return {
                    u_tile_tl_up: s.upVector(i, 0, 0),
                    u_tile_tr_up: s.upVector(i, e.ag, 0),
                    u_tile_br_up: s.upVector(i, e.ag, e.ag),
                    u_tile_bl_up: s.upVector(i, 0, e.ag),
                    u_tile_up_scale: o ? e.cL(1) : s.upVectorScale(i, t1.center.lat, t1.worldSize).metersToTile
                };
            }
            renderToBackBuffer(t1) {
                const i = this.painter, o = this.painter.context;
                0 !== t1.length && (o.bindFramebuffer.set(null), o.viewport.set([
                    0,
                    0,
                    i.width,
                    i.height
                ]), i.gpuTimingDeferredRenderStart(), this.renderingToTexture = !1, function(t1, i, o, s, r) {
                    if ("globe" === t1.transform.projection.name) !function(t1, i, o, s, r) {
                        const a = t1.context, n = a.gl;
                        let l, c;
                        const h = t1.transform, u = e.cC(t1, a, h), d = (e, i)=>{
                            if (c === i) return;
                            const o = [
                                Os[i],
                                "PROJECTION_GLOBE_VIEW"
                            ];
                            u && o.push("CUSTOM_ANTIALIASING");
                            const s = t1.isTileAffectedByFog(e);
                            l = t1.getOrCreateProgram("globeRaster", {
                                defines: o,
                                overrideFog: s
                            }), c = i;
                        }, _ = t1.colorModeForRenderPass(), p = new Bi(n.LEQUAL, Bi.ReadWrite, t1.depthRangeFor3D);
                        Ms.update(r);
                        const f = e.cD(h), m = [
                            e.at(h.center.lng),
                            e.aA(h.center.lat)
                        ], g = t1.globeSharedBuffers, v = [
                            h.width * e.q.devicePixelRatio,
                            h.height * e.q.devicePixelRatio
                        ], y = Float32Array.from(h.globeMatrix), x = {
                            useDenormalizedUpVectorScale: !0
                        };
                        {
                            const h = t1.transform, u = Fs(h.zoom, i.exaggeration(), i.sourceCache._source.tileSize);
                            c = -1;
                            const b = n.TRIANGLES;
                            for (const c of s){
                                const s = o.getTile(c), w = Ui.disabled, T = i.prevTerrainTileForTile[c.key], E = i.terrainTileForTile[c.key];
                                Ps(T, E) && Ms.newMorphing(c.key, T, E, r, 250), a.activeTexture.set(n.TEXTURE0), s.texture && s.texture.bind(n.LINEAR, n.CLAMP_TO_EDGE);
                                const S = Ms.getMorphValuesForProxy(c.key), C = S ? 1 : 0;
                                S && e.J(x, {
                                    morphing: {
                                        srcDemTile: S.from,
                                        dstDemTile: S.to,
                                        phase: e.cB(S.phase)
                                    }
                                });
                                const I = e.cE(c.canonical), R = e.cF(I.getCenter().lat), D = e.cG(c.canonical, I, R, h.worldSize / h._pixelsPerMercatorPixel), L = e.bb(e.cH(c.canonical)), A = zs(h.expandedFarZProjMatrix, y, f, L, e.ae(h.zoom), m, h.frustumCorners.TL, h.frustumCorners.TR, h.frustumCorners.BR, h.frustumCorners.BL, h.globeCenterInViewSpace, h.globeRadius, v, u, h._farZ, D);
                                if (d(c, C), l && (i.setupElevationDraw(s, l, x), t1.uploadCommonUniforms(a, l, c.toUnwrapped()), g)) {
                                    const [e, i, o] = g.getGridBuffers(R, 0 !== u);
                                    l.draw(t1, b, p, w, _, Vi.backCCW, A, "globe_raster", e, i, o);
                                }
                            }
                        }
                        if (g && (t1.renderDefaultNorthPole || t1.renderDefaultSouthPole)) {
                            const r = [
                                "GLOBE_POLES",
                                "PROJECTION_GLOBE_VIEW"
                            ];
                            u && r.push("CUSTOM_ANTIALIASING"), l = t1.getOrCreateProgram("globeRaster", {
                                defines: r
                            });
                            for (const r of s){
                                const { x: s, y: c, z: u } = r.canonical, d = 0 === c, f = c === (1 << u) - 1, [y, b, w, T] = g.getPoleBuffers(u, !1);
                                if (T && (d || f)) {
                                    const c = o.getTile(r);
                                    a.activeTexture.set(n.TEXTURE0), c.texture && c.texture.bind(n.LINEAR, n.CLAMP_TO_EDGE);
                                    let g = e.cI(u, s, h);
                                    const E = e.bb(e.cH(r.canonical)), S = (e, i)=>e.draw(t1, n.TRIANGLES, p, Ui.disabled, _, Vi.disabled, zs(h.expandedFarZProjMatrix, g, g, E, 0, m, h.frustumCorners.TL, h.frustumCorners.TR, h.frustumCorners.BR, h.frustumCorners.BL, h.globeCenterInViewSpace, h.globeRadius, v, 0, h._farZ), "globe_pole_raster", i, w, T);
                                    i.setupElevationDraw(c, l, x), t1.uploadCommonUniforms(a, l, r.toUnwrapped()), d && t1.renderDefaultNorthPole && S(l, y), f && t1.renderDefaultSouthPole && (g = e.ab.mat4.scale(e.ab.mat4.create(), g, [
                                        1,
                                        -1,
                                        1
                                    ]), S(l, b));
                                }
                            }
                        }
                    }(t1, i, o, s, r);
                    else {
                        const a = t1.context, n = a.gl;
                        let l, c;
                        const h = t1.shadowRenderer, u = eo(t1, t1.longestCutoffRange), d = (e)=>{
                            if (c === e) return;
                            const i = [];
                            i.push(Os[e]), u.shouldRenderCutoff && i.push("RENDER_CUTOFF"), h && (i.push("RENDER_SHADOWS", "DEPTH_TEXTURE"), h.useNormalOffset && i.push("NORMAL_OFFSET")), l = t1.getOrCreateProgram("terrainRaster", {
                                defines: i
                            }), c = e;
                        }, _ = t1.colorModeForRenderPass(), p = new Bi(n.LEQUAL, Bi.ReadWrite, t1.depthRangeFor3D);
                        Ms.update(r);
                        const f = t1.transform, m = Fs(f.zoom, i.exaggeration(), i.sourceCache._source.tileSize);
                        let g = [
                            0,
                            0,
                            0
                        ];
                        if (h) {
                            const e = t1.style.directionalLight, i = t1.style.ambientLight;
                            e && i && (g = no(t1.style, e, i));
                        }
                        {
                            c = -1;
                            const v = n.TRIANGLES, [y, x] = [
                                i.gridIndexBuffer,
                                i.gridSegments
                            ];
                            for (const c of s){
                                const s = o.getTile(c), b = Ui.disabled, w = i.prevTerrainTileForTile[c.key], T = i.terrainTileForTile[c.key];
                                Ps(w, T) && Ms.newMorphing(c.key, w, T, r, 250), a.activeTexture.set(n.TEXTURE0), s.texture && s.texture.bind(n.LINEAR, n.CLAMP_TO_EDGE);
                                const E = Ms.getMorphValuesForProxy(c.key), S = E ? 1 : 0;
                                let C;
                                E && (C = {
                                    morphing: {
                                        srcDemTile: E.from,
                                        dstDemTile: E.to,
                                        phase: e.cB(E.phase)
                                    }
                                });
                                const I = As(c.projMatrix, ks(c.canonical, f.renderWorldCopies) ? m / 10 : m, g);
                                if (d(S), !l) continue;
                                i.setupElevationDraw(s, l, C);
                                const R = c.toUnwrapped();
                                h && h.setupShadows(R, l), t1.uploadCommonUniforms(a, l, R, null, u), l.draw(t1, v, p, b, _, Vi.backCCW, I, "terrain_raster", i.gridBuffer, y, x);
                            }
                        }
                    }
                }(i, this, this.proxySourceCache, t1, this._updateTimestamp), this.renderingToTexture = !0, i.gpuTimingDeferredRenderEnd(), t1.splice(0, t1.length));
            }
            renderBatch(t1) {
                if (0 === this._drapedRenderBatches.length) return t1 + 1;
                this.renderingToTexture = !0;
                const i = this.painter, o = this.painter.context, s = this.proxySourceCache, r = this.proxiedCoords[s.id], a = this._drapedRenderBatches.shift(), n = i.style.order, l = [];
                let c = 0;
                for (const h of r){
                    const r = s.getTileByID(h.proxyTileKey), u = s.proxyCachedFBO[h.key] ? s.proxyCachedFBO[h.key][t1] : void 0, d = void 0 !== u ? s.renderCache[u] : this.pool[c++], _ = void 0 !== u;
                    if (r.texture = d.tex, _ && !d.dirty) {
                        l.push(r.tileID);
                        continue;
                    }
                    let p;
                    o.bindFramebuffer.set(d.fb.framebuffer), this.renderedToTile = !1, d.dirty && (o.clear({
                        color: e.aj.transparent,
                        stencil: 0
                    }), d.dirty = !1);
                    for(let e = a.start; e <= a.end; ++e){
                        const t1 = i.style._mergedLayers[n[e]];
                        if (t1.isHidden(i.transform.zoom)) continue;
                        const s = i.style.getLayerSourceCache(t1), r = s ? this.proxyToSource[h.key][s.id] : [
                            h
                        ];
                        if (!r) continue;
                        const a = r;
                        o.viewport.set([
                            0,
                            0,
                            d.fb.width,
                            d.fb.height
                        ]), p !== (s ? s.id : null) && (this._setupStencil(d, r, t1, s), p = s ? s.id : null), i.renderLayer(i, s, t1, a);
                    }
                    if (0 === this._drapedRenderBatches.length) for (const e of this._pendingGroundEffectLayers){
                        const t1 = i.style._mergedLayers[n[e]];
                        if (t1.isHidden(i.transform.zoom)) continue;
                        const s = i.style.getLayerSourceCache(t1), r = s ? this.proxyToSource[h.key][s.id] : [
                            h
                        ];
                        if (!r) continue;
                        const a = r;
                        o.viewport.set([
                            0,
                            0,
                            d.fb.width,
                            d.fb.height
                        ]), p !== (s ? s.id : null) && (this._setupStencil(d, r, t1, s), p = s ? s.id : null), i.renderLayer(i, s, t1, a);
                    }
                    this.renderedToTile ? (d.dirty = !0, l.push(r.tileID)) : _ || --c, 5 === c && (c = 0, this.renderToBackBuffer(l));
                }
                return this.renderToBackBuffer(l), this.renderingToTexture = !1, o.bindFramebuffer.set(null), o.viewport.set([
                    0,
                    0,
                    i.width,
                    i.height
                ]), a.end + 1;
            }
            postRender() {}
            isLayerOrderingCorrect(e) {
                const t1 = e.order.length;
                let i = -1, o = t1;
                for(let s = 0; s < t1; ++s)this._style.isLayerDraped(e._mergedLayers[e.order[s]]) ? i = Math.max(i, s) : o = Math.min(o, s);
                return o > i;
            }
            getMinElevationBelowMSL() {
                let e = 0;
                return this._visibleDemTiles.filter((e)=>e.dem).forEach((t1)=>{
                    e = Math.min(e, t1.dem.tree.minimums[0]);
                }), 0 === e ? e : (e - 30) * this._exaggeration;
            }
            raycast(e, t1, i) {
                if (!this._visibleDemTiles) return null;
                const o = this._visibleDemTiles.filter((e)=>e.dem).map((o)=>{
                    const s = o.tileID, r = 1 << s.overscaledZ, { x: a, y: n } = s.canonical, l = a / r, c = (a + 1) / r, h = n / r, u = (n + 1) / r;
                    return {
                        minx: l,
                        miny: h,
                        maxx: c,
                        maxy: u,
                        t: o.dem.tree.raycastRoot(l, h, c, u, e, t1, i),
                        tile: o
                    };
                });
                o.sort((e, t1)=>(null !== e.t ? e.t : Number.MAX_VALUE) - (null !== t1.t ? t1.t : Number.MAX_VALUE));
                for (const s of o){
                    if (null == s.t) return null;
                    const o = s.tile.dem.tree.raycast(s.minx, s.miny, s.maxx, s.maxy, e, t1, i);
                    if (null != o) return o;
                }
                return null;
            }
            _createFBO() {
                const t1 = this.painter.context, i = t1.gl, o = this.drapeBufferSize;
                t1.activeTexture.set(i.TEXTURE0);
                const s = new e.T(t1, {
                    width: o[0],
                    height: o[1],
                    data: null
                }, i.RGBA8);
                s.bind(i.LINEAR, i.CLAMP_TO_EDGE);
                const r = t1.createFramebuffer(o[0], o[1], !0, null);
                return r.colorAttachment.set(s.texture), r.depthAttachment = new Ls(t1, r.framebuffer), void 0 === this._sharedDepthStencil ? (this._sharedDepthStencil = t1.createRenderbuffer(t1.gl.DEPTH_STENCIL, o[0], o[1]), this._stencilRef = 0, r.depthAttachment.set(this._sharedDepthStencil), t1.clear({
                    stencil: 0
                })) : r.depthAttachment.set(this._sharedDepthStencil), t1.extTextureFilterAnisotropic && i.texParameterf(i.TEXTURE_2D, t1.extTextureFilterAnisotropic.TEXTURE_MAX_ANISOTROPY_EXT, t1.extTextureFilterAnisotropicMax), {
                    fb: r,
                    tex: s,
                    dirty: !1
                };
            }
            _initFBOPool() {
                for(; this.pool.length < Math.min(5, this.proxyCoords.length);)this.pool.push(this._createFBO());
            }
            _shouldDisableRenderCache() {
                if (this._debugParams.disableRenderCache) return !0;
                if (this._style.hasLightTransitions()) return !0;
                for(const e in this._style._mergedSourceCaches)if (this._style._mergedSourceCaches[e].hasTransition()) return !0;
                return this._style.order.some((e)=>{
                    const t1 = this._style._mergedLayers[e], i = t1.isHidden(this.painter.transform.zoom);
                    return "hillshade" === t1.type || "custom" === t1.type ? !i && t1.shouldRedrape() : !i && t1.hasTransition();
                });
            }
            _clearLineLayersFromRenderCache() {
                let t1 = !1;
                for (const e of this._style.getSources())if (e instanceof tt) {
                    t1 = !0;
                    break;
                }
                if (!t1) return;
                const i = {};
                for(let t1 = 0; t1 < this._style.order.length; ++t1){
                    const o = this._style._mergedLayers[this._style.order[t1]], s = this._style.getLayerSourceCache(o);
                    if (s && !i[s.id] && !o.isHidden(this.painter.transform.zoom) && "line" === o.type && o.widthExpression() instanceof e.a9) {
                        i[s.id] = !0;
                        for (const e of this.proxyCoords){
                            const t1 = this.proxyToSource[e.key][s.id];
                            if (t1) for (const e of t1)this._clearRenderCacheForTile(s.id, e);
                        }
                    }
                }
            }
            _clearRasterLayersFromRenderCache() {
                let e = !1;
                for(const t1 in this._style._mergedSourceCaches)if (this._style._mergedSourceCaches[t1]._source instanceof it) {
                    e = !0;
                    break;
                }
                if (!e) return;
                const t1 = {};
                for(let e = 0; e < this._style.order.length; ++e){
                    const i = this._style._mergedLayers[this._style.order[e]], o = this._style.getLayerSourceCache(i);
                    if (!o || t1[o.id]) continue;
                    if (i.isHidden(this.painter.transform.zoom) || "raster" !== i.type) continue;
                    const s = i.paint.get("raster-fade-duration");
                    for (const e of this.proxyCoords){
                        const t1 = this.proxyToSource[e.key][o.id];
                        if (t1) for (const e of t1){
                            const t1 = Ns(o.getTile(e), o.findLoadedParent(e, 0), o, this.painter.transform, s);
                            (1 !== t1.opacity || 0 !== t1.mix) && this._clearRenderCacheForTile(o.id, e);
                        }
                    }
                }
            }
            _setupDrapedRenderBatches() {
                this._style.updateDrapeFirstLayers();
                const t1 = this._style.order, i = t1.length;
                if (0 === i) return;
                const o = [];
                this._pendingGroundEffectLayers = [];
                let s, r = 0, a = this._style._mergedLayers[t1[r]];
                for(; !this._style.isLayerDraped(a) && a.isHidden(this.painter.transform.zoom) && ++r < i;)a = this._style._mergedLayers[t1[r]];
                for(; r < i; ++r){
                    const e = this._style._mergedLayers[t1[r]];
                    e.isHidden(this.painter.transform.zoom) || (this._style.isLayerDraped(e) ? void 0 === s && (s = r) : ("fill-extrusion" === e.type && this._pendingGroundEffectLayers.push(r), void 0 !== s && (o.push({
                        start: s,
                        end: r - 1
                    }), s = void 0)));
                }
                if (void 0 !== s && o.push({
                    start: s,
                    end: r - 1
                }), 0 !== o.length) {
                    const t1 = o[o.length - 1];
                    this._pendingGroundEffectLayers.every((e)=>e > t1.end) || e.w("fill-extrusion with flood lighting and/or ground ambient occlusion should be moved to be on top of all draped layers.");
                }
                this._drapedRenderBatches = o;
            }
            _setupRenderCache(e) {
                const t1 = this.proxySourceCache;
                if (this._shouldDisableRenderCache() || this.invalidateRenderCache) {
                    if (this.invalidateRenderCache = !1, t1.renderCache.length > t1.renderCachePool.length) {
                        const e = Object.values(t1.proxyCachedFBO);
                        t1.proxyCachedFBO = {};
                        for(let i = 0; i < e.length; ++i){
                            const o = Object.values(e[i]);
                            t1.renderCachePool.push(...o);
                        }
                    }
                    return;
                }
                this._clearRasterLayersFromRenderCache();
                const i = this.proxyCoords, o = this._tilesDirty;
                for(let s = i.length - 1; s >= 0; s--){
                    const r = i[s];
                    if (t1.getTileByID(r.key), void 0 !== t1.proxyCachedFBO[r.key]) {
                        const i = e[r.key], s = this.proxyToSource[r.key];
                        let a = 0;
                        for(const e in s){
                            const t1 = s[e], r = i[e];
                            if (!r || r.length !== t1.length || t1.some((t1, i)=>t1 !== r[i] || o[e] && o[e].hasOwnProperty(t1.key))) {
                                a = -1;
                                break;
                            }
                            ++a;
                        }
                        for(const e in t1.proxyCachedFBO[r.key])t1.renderCache[t1.proxyCachedFBO[r.key][e]].dirty = a < 0 || a !== Object.values(i).length;
                    }
                }
                const s = [
                    ...this._drapedRenderBatches
                ];
                s.sort((e, t1)=>t1.end - t1.start - (e.end - e.start));
                for (const e of s)for (const o of i){
                    if (t1.proxyCachedFBO[o.key]) continue;
                    let i = t1.renderCachePool.pop();
                    void 0 === i && t1.renderCache.length < 50 && (i = t1.renderCache.length, t1.renderCache.push(this._createFBO())), void 0 !== i && (t1.proxyCachedFBO[o.key] = {}, t1.proxyCachedFBO[o.key][e.start] = i, t1.renderCache[i].dirty = !0);
                }
                this._tilesDirty = {};
            }
            _setupStencil(e, t1, i, o) {
                if (!o || !this._sourceTilesOverlap[o.id]) return void (this._overlapStencilType && (this._overlapStencilType = !1));
                const s = this.painter.context, r = s.gl;
                if (t1.length <= 1) return void (this._overlapStencilType = !1);
                let a;
                if (i.isTileClipped()) a = t1.length, this._overlapStencilMode.test = {
                    func: r.EQUAL,
                    mask: 255
                }, this._overlapStencilType = "Clip";
                else {
                    if (!(t1[0].overscaledZ > t1[t1.length - 1].overscaledZ)) return void (this._overlapStencilType = !1);
                    a = 1, this._overlapStencilMode.test = {
                        func: r.GREATER,
                        mask: 255
                    }, this._overlapStencilType = "Mask";
                }
                this._stencilRef + a > 255 && (s.clear({
                    stencil: 0
                }), this._stencilRef = 0), this._stencilRef += a, this._overlapStencilMode.ref = this._stencilRef, i.isTileClipped() && this._renderTileClippingMasks(t1, this._overlapStencilMode.ref);
            }
            clipOrMaskOverlapStencilType() {
                return "Clip" === this._overlapStencilType || "Mask" === this._overlapStencilType;
            }
            stencilModeForRTTOverlap(e) {
                return this.renderingToTexture && this._overlapStencilType ? ("Clip" === this._overlapStencilType && (this._overlapStencilMode.ref = this.painter._tileClippingMaskIDs[e.key]), this._overlapStencilMode) : Ui.disabled;
            }
            _renderTileClippingMasks(e, t1) {
                const i = this.painter, o = this.painter.context, s = o.gl;
                i._tileClippingMaskIDs = {}, o.setColorMode(ki.disabled), o.setDepthMode(Bi.disabled);
                const r = i.getOrCreateProgram("clippingMask");
                for (const o of e){
                    const e = i._tileClippingMaskIDs[o.key] = --t1;
                    r.draw(i, s.TRIANGLES, Bi.disabled, new Ui({
                        func: s.ALWAYS,
                        mask: 0
                    }, e, 255, s.KEEP, s.KEEP, s.REPLACE), ki.disabled, Vi.disabled, Bs(o.projMatrix), "$clipping", i.tileExtentBuffer, i.quadTriangleIndexBuffer, i.tileExtentSegments);
                }
            }
            pointCoordinate(t1) {
                const i = this.painter.transform;
                if (t1.x < 0 || t1.x > i.width || t1.y < 0 || t1.y > i.height) return null;
                const o = [
                    t1.x,
                    t1.y,
                    1,
                    1
                ];
                e.ab.vec4.transformMat4(o, o, i.pixelMatrixInverse), e.ab.vec4.scale(o, o, 1 / o[3]), o[0] /= i.worldSize, o[1] /= i.worldSize;
                const s = i._camera.position, r = e.bH(1, i.center.lat), a = [
                    s[0],
                    s[1],
                    s[2] / r,
                    0
                ], n = e.ab.vec3.subtract([], o.slice(0, 3), a);
                e.ab.vec3.normalize(n, n);
                const l = this.raycast(a, n, this._exaggeration);
                return null !== l && l ? (e.ab.vec3.scaleAndAdd(a, a, n, l), a[3] = a[2], a[2] *= r, a) : null;
            }
            _setupProxiedCoordsForOrtho(t1, i, o) {
                if (t1.getSource() instanceof e.aJ) return this._setupProxiedCoordsForImageSource(t1, i, o);
                this._findCoveringTileCache[t1.id] = this._findCoveringTileCache[t1.id] || {};
                const s = this.proxiedCoords[t1.id] = [], r = this.proxyCoords;
                for(let e = 0; e < r.length; e++){
                    const i = r[e], a = this._findTileCoveringTileID(i, t1);
                    if (a) {
                        const e = this._createProxiedId(i, a, o[i.key] && o[i.key][t1.id]);
                        s.push(e), this.proxyToSource[i.key][t1.id] = [
                            e
                        ];
                    }
                }
                let a = !1;
                const n = new Set;
                for(let e = 0; e < i.length; e++){
                    const r = t1.getTile(i[e]);
                    if (!r || !r.hasData()) continue;
                    const l = this._findTileCoveringTileID(r.tileID, this.proxySourceCache);
                    if (l && l.tileID.canonical.z !== r.tileID.canonical.z) {
                        const e = this.proxyToSource[l.tileID.key][t1.id], i = this._createProxiedId(l.tileID, r, o[l.tileID.key] && o[l.tileID.key][t1.id]);
                        e ? e.splice(e.length - 1, 0, i) : this.proxyToSource[l.tileID.key][t1.id] = [
                            i
                        ];
                        const c = this.proxyToSource[l.tileID.key][t1.id];
                        n.has(c) || n.add(c), s.push(i), a = !0;
                    }
                }
                if (this._sourceTilesOverlap[t1.id] = a, a && this._debugParams.sortTilesHiZFirst) for (const e of n)e.sort((e, t1)=>t1.overscaledZ - e.overscaledZ);
            }
            _setupProxiedCoordsForImageSource(t1, i, o) {
                if (!t1.getSource().loaded()) return;
                const s = this.proxiedCoords[t1.id] = [], r = this.proxyCoords, a = t1.getSource(), n = a.tileID;
                if (!n) return;
                const l = new e.P(n.x, n.y)._div(1 << n.z), c = a.coordinates.map(e.aa.fromLngLat).reduce((e, t1)=>(e.min.x = Math.min(e.min.x, t1.x - l.x), e.min.y = Math.min(e.min.y, t1.y - l.y), e.max.x = Math.max(e.max.x, t1.x - l.x), e.max.y = Math.max(e.max.y, t1.y - l.y), e), {
                    min: new e.P(Number.MAX_VALUE, Number.MAX_VALUE),
                    max: new e.P(-Number.MAX_VALUE, -Number.MAX_VALUE)
                }), h = (t1, i)=>{
                    const o = t1.wrap + t1.canonical.x / (1 << t1.canonical.z), s = t1.canonical.y / (1 << t1.canonical.z), r = e.ag / (1 << t1.canonical.z), a = i.wrap + i.canonical.x / (1 << i.canonical.z), n = i.canonical.y / (1 << i.canonical.z);
                    return o + r < a + c.min.x || o > a + c.max.x || s + r < n + c.min.y || s > n + c.max.y;
                };
                for(let e = 0; e < r.length; e++){
                    const a = r[e];
                    for(let e = 0; e < i.length; e++){
                        const r = t1.getTile(i[e]);
                        if (!r || !r.hasData()) continue;
                        if (h(a, r.tileID)) continue;
                        const n = this._createProxiedId(a, r, o[a.key] && o[a.key][t1.id]), l = this.proxyToSource[a.key][t1.id];
                        l ? l.push(n) : this.proxyToSource[a.key][t1.id] = [
                            n
                        ], s.push(n);
                    }
                }
            }
            _createProxiedId(t1, i, o) {
                let s = this.orthoMatrix;
                if (o) {
                    const e = o.find((e)=>e.key === i.tileID.key);
                    if (e) return e;
                }
                if (i.tileID.key !== t1.key) {
                    const o = t1.canonical.z - i.tileID.canonical.z;
                    let r, a, n;
                    s = e.ab.mat4.create();
                    const l = i.tileID.wrap - t1.wrap << t1.overscaledZ;
                    o > 0 ? (r = e.ag >> o, a = r * ((i.tileID.canonical.x << o) - t1.canonical.x + l), n = r * ((i.tileID.canonical.y << o) - t1.canonical.y)) : (r = e.ag << -o, a = e.ag * (i.tileID.canonical.x - (t1.canonical.x + l << -o)), n = e.ag * (i.tileID.canonical.y - (t1.canonical.y << -o))), e.ab.mat4.ortho(s, 0, r, 0, r, 0, 1), e.ab.mat4.translate(s, s, [
                        a,
                        n,
                        0
                    ]);
                }
                return new Gs(i.tileID, t1.key, s);
            }
            _findTileCoveringTileID(t1, i) {
                let o = i.getTile(t1);
                if (o && o.hasData()) return o;
                const s = this._findCoveringTileCache[i.id], r = s[t1.key];
                if (o = r ? i.getTileByID(r) : null, o && o.hasData() || null === r) return o;
                let a = o ? o.tileID : t1, n = a.overscaledZ;
                const l = i.getSource().minzoom, c = [];
                if (!r) {
                    const s = i.getSource().maxzoom;
                    if (t1.canonical.z >= s) {
                        const o = t1.canonical.z - s;
                        i.getSource().reparseOverscaled ? (n = Math.max(t1.canonical.z + 2, i.transform.tileZoom), a = new e.aG(n, t1.wrap, s, t1.canonical.x >> o, t1.canonical.y >> o)) : 0 !== o && (n = s, a = new e.aG(n, t1.wrap, s, t1.canonical.x >> o, t1.canonical.y >> o));
                    }
                    a.key !== t1.key && (c.push(a.key), o = i.getTile(a));
                }
                const h = (e)=>{
                    c.forEach((t1)=>{
                        s[t1] = e;
                    }), c.length = 0;
                };
                for(n -= 1; n >= l && (!o || !o.hasData()); n--){
                    o && h(o.tileID.key);
                    const e = a.calculateScaledKey(n);
                    if (o = i.getTileByID(e), o && o.hasData()) break;
                    const t1 = s[e];
                    if (null === t1) break;
                    void 0 === t1 ? c.push(e) : o = i.getTileByID(t1);
                }
                return h(o ? o.tileID.key : null), o && o.hasData() ? o : null;
            }
            findDEMTileFor(e) {
                return this.enabled ? this._findTileCoveringTileID(e, this.sourceCache) : null;
            }
            prepareDrawTile() {
                this.renderedToTile = !0;
            }
            _clearRenderCacheForTile(e, t1) {
                let i = this._tilesDirty[e];
                i || (i = this._tilesDirty[e] = {}), i[t1.key] = !0;
            }
            constructor(t1, i){
                super(), this._debugParams = {
                    sortTilesHiZFirst: !0,
                    disableRenderCache: !1
                }, t1.tp.registerParameter(this._debugParams, [
                    "Terrain"
                ], "sortTilesHiZFirst", {}, ()=>{
                    this._style.map.triggerRepaint();
                }), t1.tp.registerParameter(this._debugParams, [
                    "Terrain"
                ], "disableRenderCache", {}, ()=>{
                    this._style.map.triggerRepaint();
                }), t1.tp.registerButton([
                    "Terrain"
                ], "Invalidate Render Cache", ()=>{
                    this.invalidateRenderCache = !0, this._style.map.triggerRepaint();
                }), this.painter = t1, this.terrainTileForTile = {}, this.prevTerrainTileForTile = {};
                const [o, s, r] = function(t1) {
                    const i = new e.b4, o = new e.aU, s = 131;
                    i.reserve(17161), o.reserve(33800);
                    const r = e.ag / 128, a = e.ag + r / 2, n = a + r;
                    for(let t1 = -r; t1 < n; t1 += r)for(let o = -r; o < n; o += r){
                        const s = o < 0 || o > a || t1 < 0 || t1 > a ? 24575 : 0, r = e.aw(Math.round(o), 0, e.ag), n = e.aw(Math.round(t1), 0, e.ag);
                        i.emplaceBack(r + s, n);
                    }
                    const l = (e, t1)=>{
                        const i = t1 * s + e;
                        o.emplaceBack(i + 1, i, i + s), o.emplaceBack(i + s, i + s + 1, i + 1);
                    };
                    for(let e = 1; e < 129; e++)for(let t1 = 1; t1 < 129; t1++)l(t1, e);
                    return [
                        0,
                        129
                    ].forEach((e)=>{
                        for(let t1 = 0; t1 < 130; t1++)l(t1, e), l(e, t1);
                    }), [
                        i,
                        o,
                        32768
                    ];
                }(), a = t1.context;
                this.gridBuffer = a.createVertexBuffer(o, e.b6.members), this.gridIndexBuffer = a.createIndexBuffer(s), this.gridSegments = e.b7.simpleSegment(0, 0, o.length, s.length), this.gridNoSkirtSegments = e.b7.simpleSegment(0, 0, o.length, r), this.proxyCoords = [], this.proxiedCoords = {}, this._visibleDemTiles = [], this._drapedRenderBatches = [], this._sourceTilesOverlap = {}, this.proxySourceCache = new js(i.map), this.orthoMatrix = e.ab.mat4.create(), e.ab.mat4.ortho(this.orthoMatrix, "globe" === this.painter.transform.projection.name ? .015 : 0, e.ag, 0, e.ag, 0, 1);
                const n = a.gl;
                this._overlapStencilMode = new Ui({
                    func: n.GEQUAL,
                    mask: 255
                }, 0, 255, n.KEEP, n.KEEP, n.REPLACE), this._previousZoom = t1.transform.zoom, this.pool = [], this._findCoveringTileCache = {}, this._tilesDirty = {}, this.style = i, this._useVertexMorphing = !0, this._exaggeration = 1, this._mockSourceCache = new Us(i.map), this._pendingGroundEffectLayers = [];
            }
        }
        function qs(t1, i, o) {
            const s = function(t1, i, o) {
                const s = e.ab.vec3.dot(i, t1), r = e.ab.vec3.dot(o, [
                    .2126,
                    .7152,
                    .0722
                ]), a = (e, t1, i)=>(1 - i) * e + i * t1, n = a(1 - .3 * Math.min(r, 1), 1, Math.min(s + 1, 1));
                return a(.92, 1, Math.asin(e.aw(i[2], -1, 1)) / Math.PI + .5) * n;
            }(t1, [
                0,
                0,
                1
            ], i), r = [
                0,
                0,
                0
            ];
            e.ab.vec3.scale(r, o.slice(0, 3), s);
            const a = [
                0,
                0,
                0
            ];
            e.ab.vec3.scale(a, i.slice(0, 3), t1[2]);
            const n = [
                0,
                0,
                0
            ];
            return e.ab.vec3.add(n, r, a), e.cf(n);
        }
        const Hs = [
            "fill",
            "fillOutline",
            "fillPattern",
            "line",
            "linePattern",
            "background",
            "backgroundPattern",
            "hillshade",
            "raster"
        ], Zs = [
            "stars",
            "rainParticle",
            "snowParticle",
            "fillExtrusion",
            "fillExtrusionGroundEffect",
            "model",
            "symbol"
        ];
        class Ws {
            static cacheKey(e, t1, i, o) {
                let s = `${t1}${o ? o.cacheKey : ""}`;
                for (const t1 of i)e.usedDefines.includes(t1) && (s += `/${t1}`);
                return s;
            }
            setTerrainUniformValues(e, t1) {
                if (!this.terrainUniforms) return;
                const i = this.terrainUniforms;
                if (!this.failedToCreate) {
                    e.program.set(this.program);
                    for(const e in t1)i[e] && i[e].set(this.program, e, t1[e]);
                }
            }
            setGlobeUniformValues(e, t1) {
                if (!this.globeUniforms) return;
                const i = this.globeUniforms;
                if (!this.failedToCreate) {
                    e.program.set(this.program);
                    for(const e in t1)i[e] && i[e].set(this.program, e, t1[e]);
                }
            }
            setFogUniformValues(e, t1) {
                if (!this.fogUniforms) return;
                const i = this.fogUniforms;
                if (!this.failedToCreate) {
                    e.program.set(this.program);
                    for(const e in t1)i[e].set(this.program, e, t1[e]);
                }
            }
            setCutoffUniformValues(e, t1) {
                if (!this.cutoffUniforms) return;
                const i = this.cutoffUniforms;
                if (!this.failedToCreate) {
                    e.program.set(this.program);
                    for(const e in t1)i[e].set(this.program, e, t1[e]);
                }
            }
            setLightsUniformValues(e, t1) {
                if (!this.lightsUniforms) return;
                const i = this.lightsUniforms;
                if (!this.failedToCreate) {
                    e.program.set(this.program);
                    for(const e in t1)i[e].set(this.program, e, t1[e]);
                }
            }
            setShadowUniformValues(e, t1) {
                if (this.failedToCreate || !this.shadowUniforms) return;
                const i = this.shadowUniforms;
                e.program.set(this.program);
                for(const e in t1)i[e].set(this.program, e, t1[e]);
            }
            _drawDebugWireframe(t1, i, o, s, r, a, n, l, c, h) {
                const u = t1.options.wireframe;
                if (!1 === u.terrain && !1 === u.layers2D && !1 === u.layers3D) return;
                const d = t1.context;
                if (!(()=>!(!u.terrain || "terrainRaster" !== this.name && "globeRaster" !== this.name) || !(!u.layers2D || t1._terrain && t1._terrain.renderingToTexture || !Hs.includes(this.name)) || !(!u.layers3D || !Zs.includes(this.name)))()) return;
                const _ = d.gl, p = t1.wireframeDebugCache.getLinesFromTrianglesBuffer(t1.frameCounter, r, d);
                if (!p) return;
                const f = [
                    ...this.fixedDefines
                ];
                f.push("DEBUG_WIREFRAME");
                const m = t1.getOrCreateProgram(this.name, {
                    config: this.configuration,
                    defines: f
                });
                d.program.set(m.program);
                const g = (e, t1, i)=>{
                    if (t1[e] && i[e]) for(const o in t1[e])i[e][o] && i[e][o].set(i.program, o, t1[e][o].current);
                };
                c && c.setUniforms(m.program, d, m.binderUniforms, n, {
                    zoom: l
                }), g("fixedUniforms", this, m), g("terrainUniforms", this, m), g("globeUniforms", this, m), g("fogUniforms", this, m), g("lightsUniforms", this, m), g("shadowUniforms", this, m), p.bind(), d.setColorMode(new ki([
                    _.ONE,
                    _.ONE_MINUS_SRC_ALPHA,
                    _.ZERO,
                    _.ONE
                ], e.aj.transparent, [
                    !0,
                    !0,
                    !0,
                    !1
                ])), d.setDepthMode(new Bi(i.func === _.LESS ? _.LEQUAL : i.func, Bi.ReadOnly, i.range)), d.setStencilMode(Ui.disabled);
                const v = 3 * a.primitiveLength * 2, y = 3 * a.primitiveOffset * 4;
                if (this.forceManualRenderingForInstanceIDShaders) {
                    const e = h || 1;
                    for(let t1 = 0; t1 < e; ++t1)m.instancingUniforms.u_instanceID.set(this.program, "u_instanceID", t1), _.drawElements(_.LINES, v, _.UNSIGNED_SHORT, y);
                } else h && h > 1 ? _.drawElementsInstanced(_.LINES, v, _.UNSIGNED_SHORT, y, h) : _.drawElements(_.LINES, v, _.UNSIGNED_SHORT, y);
                r.bind(), d.program.set(this.program), d.setDepthMode(i), d.setStencilMode(o), d.setColorMode(s);
            }
            checkUniforms(e, t1, i) {
                if (this.fixedDefines.includes(t1)) {
                    for (const o of Object.keys(i))if (!i[o].initialized) throw new Error(`Program '${this.name}', from draw '${e}': uniform ${o} not set but required by ${t1} being defined`);
                }
            }
            draw(e, t1, i, o, s, r, a, n, l, c, h, u, d, _, p, f) {
                const m = e.context, g = m.gl;
                if (this.failedToCreate) return;
                m.program.set(this.program), m.setDepthMode(i), m.setStencilMode(o), m.setColorMode(s), m.setCullFace(r);
                for (const e of Object.keys(this.fixedUniforms))this.fixedUniforms[e].set(this.program, e, a[e]);
                _ && _.setUniforms(this.program, m, this.binderUniforms, u, {
                    zoom: d
                });
                const v = {
                    [g.POINTS]: 1,
                    [g.LINES]: 2,
                    [g.TRIANGLES]: 3,
                    [g.LINE_STRIP]: 1
                }[t1];
                this.checkUniforms(n, "RENDER_SHADOWS", this.shadowUniforms);
                const y = f && f > 0 ? 1 : void 0;
                for (const r of h.get()){
                    const a = r.vaos || (r.vaos = {});
                    if ((a[n] || (a[n] = new Vo)).bind(m, this, l, _ ? _.getPaintVertexBuffers() : [], c, r.vertexOffset, p || [], y), this.forceManualRenderingForInstanceIDShaders) {
                        const e = f || 1;
                        for(let i = 0; i < e; ++i)this.instancingUniforms.u_instanceID.set(this.program, "u_instanceID", i), c ? g.drawElements(t1, r.primitiveLength * v, g.UNSIGNED_SHORT, r.primitiveOffset * v * 2) : g.drawArrays(t1, r.vertexOffset, r.vertexLength);
                    } else f && f > 1 ? g.drawElementsInstanced(t1, r.primitiveLength * v, g.UNSIGNED_SHORT, r.primitiveOffset * v * 2, f) : c ? g.drawElements(t1, r.primitiveLength * v, g.UNSIGNED_SHORT, r.primitiveOffset * v * 2) : g.drawArrays(t1, r.vertexOffset, r.vertexLength);
                    t1 === g.TRIANGLES && c && this._drawDebugWireframe(e, i, o, s, c, r, u, d, _, f);
                }
            }
            constructor(t1, i, o, s, r, a){
                const n = t1.gl;
                this.program = n.createProgram(), this.configuration = s, this.name = i, this.fixedDefines = [
                    ...a
                ];
                const l = s ? s.getBinderAttributes() : [], c = (o.staticAttributes || []).concat(l);
                let h = s ? s.defines() : [];
                h = h.concat(a.map((e)=>`#define ${e}`));
                const u = "#version 300 es\n";
                let d = u + h.concat("precision mediump float;", No, Bo.fragmentSource).join("\n");
                for (const e of o.fragmentIncludes)d += `\n${Fo[e]}`;
                d += `\n${o.fragmentSource}`;
                let _ = u + h.concat("precision highp float;", No, Bo.vertexSource).join("\n");
                for (const e of o.vertexIncludes)_ += `\n${Fo[e]}`;
                this.forceManualRenderingForInstanceIDShaders = t1.forceManualRenderingForInstanceIDShaders && -1 !== o.vertexSource.indexOf("gl_InstanceID"), this.forceManualRenderingForInstanceIDShaders && (_ += "\nuniform int u_instanceID;\n"), _ += `\n${o.vertexSource}`, this.forceManualRenderingForInstanceIDShaders && (_ = _.replaceAll("gl_InstanceID", "u_instanceID"));
                const p = n.createShader(n.FRAGMENT_SHADER);
                if (n.isContextLost()) return void (this.failedToCreate = !0);
                n.shaderSource(p, d), n.compileShader(p), n.attachShader(this.program, p);
                const f = n.createShader(n.VERTEX_SHADER);
                if (n.isContextLost()) this.failedToCreate = !0;
                else {
                    n.shaderSource(f, _), n.compileShader(f), n.attachShader(this.program, f), this.attributes = {}, this.numAttributes = c.length;
                    for(let e = 0; e < this.numAttributes; e++)if (c[e]) {
                        const t1 = c[e].startsWith("a_") ? c[e] : `a_${c[e]}`;
                        n.bindAttribLocation(this.program, e, t1), this.attributes[t1] = e;
                    }
                    n.linkProgram(this.program), n.deleteShader(f), n.deleteShader(p), this.fixedUniforms = r(t1), this.binderUniforms = s ? s.getUniforms(t1) : [], this.forceManualRenderingForInstanceIDShaders && (this.instancingUniforms = ((t1)=>({
                            u_instanceID: new e.bN(t1)
                        }))(t1)), (a.includes("TERRAIN") || -1 !== i.indexOf("symbol") || -1 !== i.indexOf("circle")) && (this.terrainUniforms = ((t1)=>({
                            u_dem: new e.bN(t1),
                            u_dem_prev: new e.bN(t1),
                            u_dem_tl: new e.bK(t1),
                            u_dem_scale: new e.bM(t1),
                            u_dem_tl_prev: new e.bK(t1),
                            u_dem_scale_prev: new e.bM(t1),
                            u_dem_size: new e.bM(t1),
                            u_dem_lerp: new e.bM(t1),
                            u_exaggeration: new e.bM(t1),
                            u_depth: new e.bN(t1),
                            u_depth_size_inv: new e.bK(t1),
                            u_depth_range_unpack: new e.bK(t1),
                            u_occluder_half_size: new e.bM(t1),
                            u_occlusion_depth_offset: new e.bM(t1),
                            u_meter_to_dem: new e.bM(t1),
                            u_label_plane_matrix_inv: new e.bJ(t1)
                        }))(t1)), a.includes("GLOBE") && (this.globeUniforms = ((t1)=>({
                            u_tile_tl_up: new e.bL(t1),
                            u_tile_tr_up: new e.bL(t1),
                            u_tile_br_up: new e.bL(t1),
                            u_tile_bl_up: new e.bL(t1),
                            u_tile_up_scale: new e.bM(t1)
                        }))(t1)), a.includes("FOG") && (this.fogUniforms = ((t1)=>({
                            u_fog_matrix: new e.bJ(t1),
                            u_fog_range: new e.bK(t1),
                            u_fog_color: new e.ca(t1),
                            u_fog_horizon_blend: new e.bM(t1),
                            u_fog_vertical_limit: new e.bK(t1),
                            u_fog_temporal_offset: new e.bM(t1),
                            u_frustum_tl: new e.bL(t1),
                            u_frustum_tr: new e.bL(t1),
                            u_frustum_br: new e.bL(t1),
                            u_frustum_bl: new e.bL(t1),
                            u_globe_pos: new e.bL(t1),
                            u_globe_radius: new e.bM(t1),
                            u_globe_transition: new e.bM(t1),
                            u_is_globe: new e.bN(t1),
                            u_viewport: new e.bK(t1)
                        }))(t1)), a.includes("RENDER_CUTOFF") && (this.cutoffUniforms = ((t1)=>({
                            u_cutoff_params: new e.ca(t1)
                        }))(t1)), a.includes("LIGHTING_3D_MODE") && (this.lightsUniforms = ((t1)=>({
                            u_lighting_ambient_color: new e.bL(t1),
                            u_lighting_directional_dir: new e.bL(t1),
                            u_lighting_directional_color: new e.bL(t1),
                            u_ground_radiance: new e.bL(t1)
                        }))(t1)), a.includes("RENDER_SHADOWS") && (this.shadowUniforms = ((t1)=>({
                            u_light_matrix_0: new e.bJ(t1),
                            u_light_matrix_1: new e.bJ(t1),
                            u_fade_range: new e.bK(t1),
                            u_shadow_normal_offset: new e.bL(t1),
                            u_shadow_intensity: new e.bM(t1),
                            u_shadow_texel_size: new e.bM(t1),
                            u_shadow_map_resolution: new e.bM(t1),
                            u_shadow_direction: new e.bL(t1),
                            u_shadow_bias: new e.bL(t1),
                            u_shadowmap_0: new e.bN(t1),
                            u_shadowmap_1: new e.bN(t1)
                        }))(t1));
                }
            }
        }
        function $s(t1, i) {
            const o = Math.pow(2, i.tileID.overscaledZ), s = i.tileSize * Math.pow(2, t1.transform.tileZoom) / o, r = s * (i.tileID.canonical.x + i.tileID.wrap * o), a = s * i.tileID.canonical.y;
            return {
                u_image: 0,
                u_texsize: i.imageAtlasTexture ? i.imageAtlasTexture.size : [
                    0,
                    0
                ],
                u_tile_units_to_pixels: 1 / e.ar(i, 1, t1.transform.tileZoom),
                u_pixel_coord_upper: [
                    r >> 16,
                    a >> 16
                ],
                u_pixel_coord_lower: [
                    65535 & r,
                    65535 & a
                ]
            };
        }
        const Xs = {
            terrain: 0,
            flat: 1
        }, Ks = e.ab.mat4.create(), Ys = (t1, i, o, s, r, a, n, l, c, h, u, d, _, p, f, m, g, v)=>{
            const y = i.style.light, x = y.properties.get("position"), b = [
                x.x,
                x.y,
                x.z
            ], w = e.ab.mat3.create();
            "viewport" === y.properties.get("anchor") && (e.ab.mat3.fromRotation(w, -i.transform.angle), e.ab.vec3.transformMat3(b, b, w));
            const T = y.properties.get("color"), E = i.transform, S = {
                u_matrix: t1,
                u_lightpos: b,
                u_lightintensity: y.properties.get("intensity"),
                u_lightcolor: [
                    T.r,
                    T.g,
                    T.b
                ],
                u_vertical_gradient: +o,
                u_opacity: s,
                u_tile_id: [
                    0,
                    0,
                    0
                ],
                u_zoom_transition: 0,
                u_inv_rot_matrix: Ks,
                u_merc_center: [
                    0,
                    0
                ],
                u_up_dir: [
                    0,
                    0,
                    0
                ],
                u_height_lift: 0,
                u_height_type: Xs[h],
                u_base_type: Xs[u],
                u_ao: r,
                u_edge_radius: a,
                u_width_scale: n,
                u_flood_light_color: f,
                u_vertical_scale: m,
                u_flood_light_intensity: g,
                u_ground_shadow_factor: v
            };
            return "globe" === E.projection.name && (S.u_tile_id = [
                l.canonical.x,
                l.canonical.y,
                1 << l.canonical.z
            ], S.u_zoom_transition = d, S.u_inv_rot_matrix = p, S.u_merc_center = _, S.u_up_dir = E.projection.upVector(new e.bT(0, 0, 0), _[0] * e.ag, _[1] * e.ag), S.u_height_lift = c), S;
        }, Js = (e, t1, i, o, s, r)=>({
                u_matrix: e,
                u_edge_radius: t1,
                u_width_scale: i,
                u_vertical_scale: o,
                u_height_type: Xs[s],
                u_base_type: Xs[r]
            }), Qs = (t1, i, o, s, r, a, n, l, c, h, u, d, _, p, f, m, g)=>{
            const v = Ys(t1, i, o, s, r, a, n, l, h, u, d, _, p, f, m, g, 1, [
                0,
                0,
                0
            ]), y = {
                u_height_factor: -Math.pow(2, l.overscaledZ) / c.tileSize / 8
            };
            return e.l(v, $s(i, c), y);
        }, er = (e, t1)=>({
                u_matrix: e,
                u_emissive_strength: t1
            }), tr = (t1, i, o, s)=>e.l(er(t1, i), $s(o, s)), ir = (e, t1, i)=>({
                u_matrix: e,
                u_world: i,
                u_emissive_strength: t1
            }), or = (t1, i, o, s, r)=>e.l(tr(t1, i, o, s), {
                u_world: r
            }), sr = (t1, i, o, s)=>{
            const r = e.ag / o.tileSize;
            return {
                u_matrix: t1,
                u_camera_to_center_distance: i.getCameraToCenterDistance(s),
                u_extrude_scale: [
                    i.pixelsToGLUnits[0] / r,
                    i.pixelsToGLUnits[1] / r
                ]
            };
        }, rr = (e, t1, i = 1)=>({
                u_matrix: e,
                u_color: t1.toRenderColor(null),
                u_overlay: 0,
                u_overlay_scale: i
            }), ar = e.ab.mat4.create(), nr = (t1, i, o, s, r, a, n)=>{
            const l = t1.transform, c = "globe" === l.projection.name, h = c ? e.cN(l.zoom, i.canonical) * l._pixelsPerMercatorPixel : e.ar(o, 1, a), u = {
                u_matrix: i.projMatrix,
                u_extrude_scale: h,
                u_intensity: n,
                u_inv_rot_matrix: ar,
                u_merc_center: [
                    0,
                    0
                ],
                u_tile_id: [
                    0,
                    0,
                    0
                ],
                u_zoom_transition: 0,
                u_up_dir: [
                    0,
                    0,
                    0
                ]
            };
            if (c) {
                u.u_inv_rot_matrix = s, u.u_merc_center = r, u.u_tile_id = [
                    i.canonical.x,
                    i.canonical.y,
                    1 << i.canonical.z
                ], u.u_zoom_transition = e.ae(l.zoom);
                const t1 = r[0] * e.ag, o = r[1] * e.ag;
                u.u_up_dir = l.projection.upVector(new e.bT(0, 0, 0), t1, o);
            }
            return u;
        };
        function lr(e, [t1, i, o, s], [r, a]) {
            if (r === a) return [
                0,
                0,
                0,
                0
            ];
            const n = 255 * (e - 1) / (e * (a - r));
            return [
                t1 * n,
                i * n,
                o * n,
                s * n
            ];
        }
        function cr(e, t1, [i, o]) {
            return i === o ? 0 : .5 / e + (t1 - i) * (e - 1) / (e * (o - i));
        }
        const hr = (t1, i, o, s, r, a, n, l, c, h, u, d, _, p, f, m, g, v, y, x, b)=>({
                u_matrix: t1,
                u_normalize_matrix: i,
                u_globe_matrix: o,
                u_merc_matrix: s,
                u_grid_matrix: r,
                u_tl_parent: a,
                u_scale_parent: h,
                u_fade_t: u.mix,
                u_opacity: u.opacity * d.paint.get("raster-opacity"),
                u_image0: 0,
                u_image1: 1,
                u_brightness_low: d.paint.get("raster-brightness-min"),
                u_brightness_high: d.paint.get("raster-brightness-max"),
                u_saturation_factor: e.cO(d.paint.get("raster-saturation")),
                u_contrast_factor: e.cP(d.paint.get("raster-contrast")),
                u_spin_weights: ur(d.paint.get("raster-hue-rotate")),
                u_perspective_transform: _,
                u_raster_elevation: p,
                u_zoom_transition: n,
                u_merc_center: l,
                u_cutoff_params: c,
                u_colorization_mix: lr(e.cQ, m, v),
                u_colorization_offset: cr(e.cQ, g, v),
                u_color_ramp: f,
                u_texture_offset: [
                    x / (y + 2 * x),
                    y / (y + 2 * x)
                ],
                u_texture_res: [
                    y + 2 * x,
                    y + 2 * x
                ],
                u_emissive_strength: b
            });
        function ur(e) {
            e *= Math.PI / 180;
            const t1 = Math.sin(e), i = Math.cos(e);
            return [
                (2 * i + 1) / 3,
                (-Math.sqrt(3) * t1 - i + 1) / 3,
                (Math.sqrt(3) * t1 - i + 1) / 3
            ];
        }
        const dr = .05, _r = (e, t1, i, o, s, r, a, n, l, c, h, u)=>({
                u_matrix: e,
                u_normalize_matrix: t1,
                u_globe_matrix: i,
                u_merc_matrix: o,
                u_grid_matrix: s,
                u_tl_parent: r,
                u_scale_parent: c,
                u_fade_t: h.mix,
                u_opacity: h.opacity,
                u_image0: 0,
                u_image1: 1,
                u_raster_elevation: u,
                u_zoom_transition: a,
                u_merc_center: n,
                u_cutoff_params: l
            }), pr = (e, t1, i, o, s, r, a, n, l, c)=>({
                u_particle_texture: e,
                u_particle_texture_side_len: t1,
                u_tile_offset: i,
                u_velocity: o,
                u_color_ramp: r,
                u_velocity_res: s,
                u_max_speed: a,
                u_uv_offset: n,
                u_data_scale: [
                    255 * l[0],
                    255 * l[1]
                ],
                u_data_offset: c,
                u_particle_pos_scale: 1.1,
                u_particle_pos_offset: [
                    dr,
                    dr
                ]
            }), fr = (e, t1, i, o, s, r, a, n, l, c)=>({
                u_particle_texture: e,
                u_particle_texture_side_len: t1,
                u_velocity: i,
                u_velocity_res: o,
                u_max_speed: s,
                u_speed_factor: r,
                u_reset_rate: a,
                u_rand_seed: Math.random(),
                u_uv_offset: n,
                u_data_scale: [
                    255 * l[0],
                    255 * l[1]
                ],
                u_data_offset: c,
                u_particle_pos_scale: 1.1,
                u_particle_pos_offset: [
                    dr,
                    dr
                ]
            }), mr = e.ab.mat4.create(), gr = (t1, i, o, s, r, a, n, l, c, h, u, d, _, p, f, m, g, v, y, x, b, w)=>{
            const T = r.transform, E = {
                u_is_size_zoom_constant: +("constant" === t1 || "source" === t1),
                u_is_size_feature_constant: +("constant" === t1 || "camera" === t1),
                u_size_t: i ? i.uSizeT : 0,
                u_size: i ? i.uSize : 0,
                u_camera_to_center_distance: T.getCameraToCenterDistance(y),
                u_rotate_symbol: +o,
                u_aspect_ratio: T.width / T.height,
                u_fade_change: r.options.fadeDuration ? r.symbolFadeChange : 1,
                u_matrix: a,
                u_label_plane_matrix: n,
                u_coord_matrix: l,
                u_is_text: +h,
                u_elevation_from_sea: c ? 1 : 0,
                u_pitch_with_map: +s,
                u_texsize: u,
                u_texsize_icon: d,
                u_texture: 0,
                u_texture_icon: 1,
                u_tile_id: [
                    0,
                    0,
                    0
                ],
                u_zoom_transition: 0,
                u_inv_rot_matrix: mr,
                u_merc_center: [
                    0,
                    0
                ],
                u_camera_forward: [
                    0,
                    0,
                    0
                ],
                u_ecef_origin: [
                    0,
                    0,
                    0
                ],
                u_tile_matrix: mr,
                u_up_vector: [
                    0,
                    -1,
                    0
                ],
                u_color_adj_mat: x,
                u_icon_transition: b || 0,
                u_gamma_scale: s ? r.transform.getCameraToCenterDistance(y) * Math.cos(r.terrain ? 0 : r.transform._pitch) : 1,
                u_device_pixel_ratio: e.q.devicePixelRatio,
                u_is_halo: +_,
                u_scale_factor: w || 1
            };
            return "globe" === y.name && (E.u_tile_id = [
                p.canonical.x,
                p.canonical.y,
                1 << p.canonical.z
            ], E.u_zoom_transition = f, E.u_inv_rot_matrix = g, E.u_merc_center = m, E.u_camera_forward = T._camera.forward(), E.u_ecef_origin = e.cR(T.globeMatrix, p.toUnwrapped()), E.u_tile_matrix = Float32Array.from(T.globeMatrix), E.u_up_vector = v), E;
        }, vr = (e, t1, i, o)=>({
                u_matrix: e,
                u_emissive_strength: t1,
                u_opacity: i,
                u_color: o
            }), yr = (t1, i, o, s, r, a, n, l, c)=>e.l(function(t1, i, o, s, r, a) {
                const { width: n, height: l } = s.imageManager.getPixelSize(i), c = Math.pow(2, a.tileID.overscaledZ), h = a.tileSize * Math.pow(2, s.transform.tileZoom) / c, u = h * (a.tileID.canonical.x + a.tileID.wrap * c), d = h * a.tileID.canonical.y;
                return {
                    u_image: 0,
                    u_pattern_tl: o.tl,
                    u_pattern_br: o.br,
                    u_texsize: [
                        n,
                        l
                    ],
                    u_pattern_size: o.displaySize,
                    u_pattern_units_to_pixels: r ? [
                        s.transform.width,
                        -1 * s.transform.height
                    ] : [
                        1 / e.ar(a, 1, s.transform.tileZoom),
                        1 / e.ar(a, 1, s.transform.tileZoom)
                    ],
                    u_pixel_coord_upper: [
                        u >> 16,
                        d >> 16
                    ],
                    u_pixel_coord_lower: [
                        65535 & u,
                        65535 & d
                    ]
                };
            }(0, a, n, s, l, c), {
                u_matrix: t1,
                u_emissive_strength: i,
                u_opacity: o
            }), xr = new Float32Array(e.ab.mat4.identity([])), br = (t1, i, o, s, r, a, n, l, c, h, u, d, _, p = [
            0,
            0,
            0
        ], f)=>{
            const m = r.style.light, g = m.properties.get("position"), v = [
                -g.x,
                -g.y,
                g.z
            ], y = e.ab.mat3.create();
            "viewport" === m.properties.get("anchor") && (e.ab.mat3.fromRotation(y, -r.transform.angle), e.ab.vec3.transformMat3(v, v, y));
            const x = "MASK" === u.alphaMode, b = m.properties.get("color").toRenderColor(null), w = _.paint.get("model-ambient-occlusion-intensity"), T = _.paint.get("model-color").constantOr(e.aj.white).toRenderColor(null), E = _.paint.get("model-color-mix-intensity").constantOr(0);
            return {
                u_matrix: t1,
                u_lighting_matrix: i,
                u_normal_matrix: o,
                u_node_matrix: s || xr,
                u_lightpos: v,
                u_lightintensity: m.properties.get("intensity"),
                u_lightcolor: [
                    b.r,
                    b.g,
                    b.b
                ],
                u_camera_pos: p,
                u_opacity: a,
                u_baseTextureIsAlpha: 0,
                u_alphaMask: +x,
                u_alphaCutoff: u.alphaCutoff,
                u_baseColorFactor: [
                    n.r,
                    n.g,
                    n.b,
                    n.a
                ],
                u_emissiveFactor: [
                    l[0],
                    l[1],
                    l[2],
                    1
                ],
                u_metallicFactor: c,
                u_roughnessFactor: h,
                u_baseColorTexture: Xi.BaseColor,
                u_metallicRoughnessTexture: Xi.MetallicRoughness,
                u_normalTexture: Xi.Normal,
                u_occlusionTexture: Xi.Occlusion,
                u_emissionTexture: Xi.Emission,
                u_lutTexture: Xi.LUT,
                u_color_mix: [
                    T.r,
                    T.g,
                    T.b,
                    E
                ],
                u_aoIntensity: w,
                u_emissive_strength: d,
                u_occlusionTextureTransform: f || [
                    0,
                    0,
                    0,
                    0
                ]
            };
        }, wr = (e, t1 = xr, i = xr)=>({
                u_matrix: e,
                u_instance: t1,
                u_node_matrix: i
            }), Tr = {
            fillExtrusion: (t1)=>({
                    u_matrix: new e.bJ(t1),
                    u_lightpos: new e.bL(t1),
                    u_lightintensity: new e.bM(t1),
                    u_lightcolor: new e.bL(t1),
                    u_vertical_gradient: new e.bM(t1),
                    u_opacity: new e.bM(t1),
                    u_edge_radius: new e.bM(t1),
                    u_width_scale: new e.bM(t1),
                    u_ao: new e.bK(t1),
                    u_height_type: new e.bN(t1),
                    u_base_type: new e.bN(t1),
                    u_tile_id: new e.bL(t1),
                    u_zoom_transition: new e.bM(t1),
                    u_inv_rot_matrix: new e.bJ(t1),
                    u_merc_center: new e.bK(t1),
                    u_up_dir: new e.bL(t1),
                    u_height_lift: new e.bM(t1),
                    u_flood_light_color: new e.bL(t1),
                    u_vertical_scale: new e.bM(t1),
                    u_flood_light_intensity: new e.bM(t1),
                    u_ground_shadow_factor: new e.bL(t1)
                }),
            fillExtrusionDepth: (t1)=>({
                    u_matrix: new e.bJ(t1),
                    u_edge_radius: new e.bM(t1),
                    u_width_scale: new e.bM(t1),
                    u_vertical_scale: new e.bM(t1),
                    u_height_type: new e.bN(t1),
                    u_base_type: new e.bN(t1)
                }),
            fillExtrusionPattern: (t1)=>({
                    u_matrix: new e.bJ(t1),
                    u_lightpos: new e.bL(t1),
                    u_lightintensity: new e.bM(t1),
                    u_lightcolor: new e.bL(t1),
                    u_vertical_gradient: new e.bM(t1),
                    u_height_factor: new e.bM(t1),
                    u_edge_radius: new e.bM(t1),
                    u_width_scale: new e.bM(t1),
                    u_ao: new e.bK(t1),
                    u_height_type: new e.bN(t1),
                    u_base_type: new e.bN(t1),
                    u_tile_id: new e.bL(t1),
                    u_zoom_transition: new e.bM(t1),
                    u_inv_rot_matrix: new e.bJ(t1),
                    u_merc_center: new e.bK(t1),
                    u_up_dir: new e.bL(t1),
                    u_height_lift: new e.bM(t1),
                    u_image: new e.bN(t1),
                    u_texsize: new e.bK(t1),
                    u_pixel_coord_upper: new e.bK(t1),
                    u_pixel_coord_lower: new e.bK(t1),
                    u_tile_units_to_pixels: new e.bM(t1),
                    u_opacity: new e.bM(t1)
                }),
            fillExtrusionGroundEffect: (t1)=>({
                    u_matrix: new e.bJ(t1),
                    u_opacity: new e.bM(t1),
                    u_ao_pass: new e.bM(t1),
                    u_meter_to_tile: new e.bM(t1),
                    u_ao: new e.bK(t1),
                    u_flood_light_intensity: new e.bM(t1),
                    u_flood_light_color: new e.bL(t1),
                    u_attenuation: new e.bM(t1),
                    u_edge_radius: new e.bM(t1),
                    u_fb: new e.bN(t1),
                    u_fb_size: new e.bM(t1),
                    u_dynamic_offset: new e.bM(t1)
                }),
            fill: (t1)=>({
                    u_matrix: new e.bJ(t1),
                    u_emissive_strength: new e.bM(t1)
                }),
            fillPattern: (t1)=>({
                    u_matrix: new e.bJ(t1),
                    u_emissive_strength: new e.bM(t1),
                    u_image: new e.bN(t1),
                    u_texsize: new e.bK(t1),
                    u_pixel_coord_upper: new e.bK(t1),
                    u_pixel_coord_lower: new e.bK(t1),
                    u_tile_units_to_pixels: new e.bM(t1)
                }),
            fillOutline: (t1)=>({
                    u_matrix: new e.bJ(t1),
                    u_emissive_strength: new e.bM(t1),
                    u_world: new e.bK(t1)
                }),
            fillOutlinePattern: (t1)=>({
                    u_matrix: new e.bJ(t1),
                    u_emissive_strength: new e.bM(t1),
                    u_world: new e.bK(t1),
                    u_image: new e.bN(t1),
                    u_texsize: new e.bK(t1),
                    u_pixel_coord_upper: new e.bK(t1),
                    u_pixel_coord_lower: new e.bK(t1),
                    u_tile_units_to_pixels: new e.bM(t1)
                }),
            circle: e.cS,
            collisionBox: (t1)=>({
                    u_matrix: new e.bJ(t1),
                    u_camera_to_center_distance: new e.bM(t1),
                    u_extrude_scale: new e.bK(t1)
                }),
            collisionCircle: (t1)=>({
                    u_matrix: new e.bJ(t1),
                    u_inv_matrix: new e.bJ(t1),
                    u_camera_to_center_distance: new e.bM(t1),
                    u_viewport_size: new e.bK(t1)
                }),
            debug: (t1)=>({
                    u_color: new e.cz(t1),
                    u_matrix: new e.bJ(t1),
                    u_overlay: new e.bN(t1),
                    u_overlay_scale: new e.bM(t1)
                }),
            clippingMask: (t1)=>({
                    u_matrix: new e.bJ(t1)
                }),
            heatmap: (t1)=>({
                    u_extrude_scale: new e.bM(t1),
                    u_intensity: new e.bM(t1),
                    u_matrix: new e.bJ(t1),
                    u_inv_rot_matrix: new e.bJ(t1),
                    u_merc_center: new e.bK(t1),
                    u_tile_id: new e.bL(t1),
                    u_zoom_transition: new e.bM(t1),
                    u_up_dir: new e.bL(t1)
                }),
            heatmapTexture: (t1)=>({
                    u_image: new e.bN(t1),
                    u_color_ramp: new e.bN(t1),
                    u_opacity: new e.bM(t1)
                }),
            hillshade: (t1)=>({
                    u_matrix: new e.bJ(t1),
                    u_image: new e.bN(t1),
                    u_latrange: new e.bK(t1),
                    u_light: new e.bK(t1),
                    u_shadow: new e.cz(t1),
                    u_highlight: new e.cz(t1),
                    u_emissive_strength: new e.bM(t1),
                    u_accent: new e.cz(t1)
                }),
            hillshadePrepare: (t1)=>({
                    u_matrix: new e.bJ(t1),
                    u_image: new e.bN(t1),
                    u_dimension: new e.bK(t1),
                    u_zoom: new e.bM(t1)
                }),
            line: e.cT,
            linePattern: e.cU,
            raster: (t1)=>({
                    u_matrix: new e.bJ(t1),
                    u_normalize_matrix: new e.bJ(t1),
                    u_globe_matrix: new e.bJ(t1),
                    u_merc_matrix: new e.bJ(t1),
                    u_grid_matrix: new e.cA(t1),
                    u_tl_parent: new e.bK(t1),
                    u_scale_parent: new e.bM(t1),
                    u_fade_t: new e.bM(t1),
                    u_opacity: new e.bM(t1),
                    u_image0: new e.bN(t1),
                    u_image1: new e.bN(t1),
                    u_brightness_low: new e.bM(t1),
                    u_brightness_high: new e.bM(t1),
                    u_saturation_factor: new e.bM(t1),
                    u_contrast_factor: new e.bM(t1),
                    u_spin_weights: new e.bL(t1),
                    u_perspective_transform: new e.bK(t1),
                    u_raster_elevation: new e.bM(t1),
                    u_zoom_transition: new e.bM(t1),
                    u_merc_center: new e.bK(t1),
                    u_cutoff_params: new e.ca(t1),
                    u_colorization_mix: new e.ca(t1),
                    u_colorization_offset: new e.bM(t1),
                    u_color_ramp: new e.bN(t1),
                    u_texture_offset: new e.bK(t1),
                    u_texture_res: new e.bK(t1),
                    u_emissive_strength: new e.bM(t1)
                }),
            rasterParticle: (t1)=>({
                    u_matrix: new e.bJ(t1),
                    u_normalize_matrix: new e.bJ(t1),
                    u_globe_matrix: new e.bJ(t1),
                    u_merc_matrix: new e.bJ(t1),
                    u_grid_matrix: new e.cA(t1),
                    u_tl_parent: new e.bK(t1),
                    u_scale_parent: new e.bM(t1),
                    u_fade_t: new e.bM(t1),
                    u_opacity: new e.bM(t1),
                    u_image0: new e.bN(t1),
                    u_image1: new e.bN(t1),
                    u_raster_elevation: new e.bM(t1),
                    u_zoom_transition: new e.bM(t1),
                    u_merc_center: new e.bK(t1),
                    u_cutoff_params: new e.ca(t1)
                }),
            rasterParticleTexture: (t1)=>({
                    u_texture: new e.bN(t1),
                    u_opacity: new e.bM(t1)
                }),
            rasterParticleDraw: (t1)=>({
                    u_particle_texture: new e.bN(t1),
                    u_particle_texture_side_len: new e.bM(t1),
                    u_tile_offset: new e.bK(t1),
                    u_velocity: new e.bN(t1),
                    u_color_ramp: new e.bN(t1),
                    u_velocity_res: new e.bK(t1),
                    u_max_speed: new e.bM(t1),
                    u_uv_offset: new e.bK(t1),
                    u_data_scale: new e.bK(t1),
                    u_data_offset: new e.bM(t1),
                    u_particle_pos_scale: new e.bM(t1),
                    u_particle_pos_offset: new e.bK(t1)
                }),
            rasterParticleUpdate: (t1)=>({
                    u_particle_texture: new e.bN(t1),
                    u_particle_texture_side_len: new e.bM(t1),
                    u_velocity: new e.bN(t1),
                    u_velocity_res: new e.bK(t1),
                    u_max_speed: new e.bM(t1),
                    u_speed_factor: new e.bM(t1),
                    u_reset_rate: new e.bM(t1),
                    u_rand_seed: new e.bM(t1),
                    u_uv_offset: new e.bK(t1),
                    u_data_scale: new e.bK(t1),
                    u_data_offset: new e.bM(t1),
                    u_particle_pos_scale: new e.bM(t1),
                    u_particle_pos_offset: new e.bK(t1)
                }),
            symbol: (t1)=>({
                    u_is_size_zoom_constant: new e.bN(t1),
                    u_is_size_feature_constant: new e.bN(t1),
                    u_size_t: new e.bM(t1),
                    u_size: new e.bM(t1),
                    u_camera_to_center_distance: new e.bM(t1),
                    u_rotate_symbol: new e.bN(t1),
                    u_aspect_ratio: new e.bM(t1),
                    u_fade_change: new e.bM(t1),
                    u_matrix: new e.bJ(t1),
                    u_label_plane_matrix: new e.bJ(t1),
                    u_coord_matrix: new e.bJ(t1),
                    u_is_text: new e.bN(t1),
                    u_elevation_from_sea: new e.bN(t1),
                    u_pitch_with_map: new e.bN(t1),
                    u_texsize: new e.bK(t1),
                    u_texsize_icon: new e.bK(t1),
                    u_texture: new e.bN(t1),
                    u_texture_icon: new e.bN(t1),
                    u_gamma_scale: new e.bM(t1),
                    u_device_pixel_ratio: new e.bM(t1),
                    u_tile_id: new e.bL(t1),
                    u_zoom_transition: new e.bM(t1),
                    u_inv_rot_matrix: new e.bJ(t1),
                    u_merc_center: new e.bK(t1),
                    u_camera_forward: new e.bL(t1),
                    u_tile_matrix: new e.bJ(t1),
                    u_up_vector: new e.bL(t1),
                    u_ecef_origin: new e.bL(t1),
                    u_is_halo: new e.bN(t1),
                    u_icon_transition: new e.bM(t1),
                    u_color_adj_mat: new e.bJ(t1),
                    u_scale_factor: new e.bM(t1)
                }),
            background: (t1)=>({
                    u_matrix: new e.bJ(t1),
                    u_emissive_strength: new e.bM(t1),
                    u_opacity: new e.bM(t1),
                    u_color: new e.cz(t1)
                }),
            backgroundPattern: (t1)=>({
                    u_matrix: new e.bJ(t1),
                    u_emissive_strength: new e.bM(t1),
                    u_opacity: new e.bM(t1),
                    u_image: new e.bN(t1),
                    u_pattern_tl: new e.bK(t1),
                    u_pattern_br: new e.bK(t1),
                    u_texsize: new e.bK(t1),
                    u_pattern_size: new e.bK(t1),
                    u_pixel_coord_upper: new e.bK(t1),
                    u_pixel_coord_lower: new e.bK(t1),
                    u_pattern_units_to_pixels: new e.bK(t1)
                }),
            terrainRaster: (t1)=>({
                    u_matrix: new e.bJ(t1),
                    u_image0: new e.bN(t1),
                    u_skirt_height: new e.bM(t1),
                    u_ground_shadow_factor: new e.bL(t1)
                }),
            skybox: (t1)=>({
                    u_matrix: new e.bJ(t1),
                    u_sun_direction: new e.bL(t1),
                    u_cubemap: new e.bN(t1),
                    u_opacity: new e.bM(t1),
                    u_temporal_offset: new e.bM(t1)
                }),
            skyboxGradient: (t1)=>({
                    u_matrix: new e.bJ(t1),
                    u_color_ramp: new e.bN(t1),
                    u_center_direction: new e.bL(t1),
                    u_radius: new e.bM(t1),
                    u_opacity: new e.bM(t1),
                    u_temporal_offset: new e.bM(t1)
                }),
            skyboxCapture: (t1)=>({
                    u_matrix_3f: new e.cA(t1),
                    u_sun_direction: new e.bL(t1),
                    u_sun_intensity: new e.bM(t1),
                    u_color_tint_r: new e.ca(t1),
                    u_color_tint_m: new e.ca(t1),
                    u_luminance: new e.bM(t1)
                }),
            globeRaster: (t1)=>({
                    u_proj_matrix: new e.bJ(t1),
                    u_globe_matrix: new e.bJ(t1),
                    u_normalize_matrix: new e.bJ(t1),
                    u_merc_matrix: new e.bJ(t1),
                    u_zoom_transition: new e.bM(t1),
                    u_merc_center: new e.bK(t1),
                    u_image0: new e.bN(t1),
                    u_grid_matrix: new e.cA(t1),
                    u_skirt_height: new e.bM(t1),
                    u_far_z_cutoff: new e.bM(t1),
                    u_frustum_tl: new e.bL(t1),
                    u_frustum_tr: new e.bL(t1),
                    u_frustum_br: new e.bL(t1),
                    u_frustum_bl: new e.bL(t1),
                    u_globe_pos: new e.bL(t1),
                    u_globe_radius: new e.bM(t1),
                    u_viewport: new e.bK(t1)
                }),
            globeAtmosphere: (t1)=>({
                    u_frustum_tl: new e.bL(t1),
                    u_frustum_tr: new e.bL(t1),
                    u_frustum_br: new e.bL(t1),
                    u_frustum_bl: new e.bL(t1),
                    u_horizon: new e.bM(t1),
                    u_transition: new e.bM(t1),
                    u_fadeout_range: new e.bM(t1),
                    u_color: new e.ca(t1),
                    u_high_color: new e.ca(t1),
                    u_space_color: new e.ca(t1),
                    u_temporal_offset: new e.bM(t1),
                    u_horizon_angle: new e.bM(t1)
                }),
            model: (t1)=>({
                    u_matrix: new e.bJ(t1),
                    u_lighting_matrix: new e.bJ(t1),
                    u_normal_matrix: new e.bJ(t1),
                    u_node_matrix: new e.bJ(t1),
                    u_lightpos: new e.bL(t1),
                    u_lightintensity: new e.bM(t1),
                    u_lightcolor: new e.bL(t1),
                    u_camera_pos: new e.bL(t1),
                    u_opacity: new e.bM(t1),
                    u_baseColorFactor: new e.ca(t1),
                    u_emissiveFactor: new e.ca(t1),
                    u_metallicFactor: new e.bM(t1),
                    u_roughnessFactor: new e.bM(t1),
                    u_baseTextureIsAlpha: new e.bN(t1),
                    u_alphaMask: new e.bN(t1),
                    u_alphaCutoff: new e.bM(t1),
                    u_baseColorTexture: new e.bN(t1),
                    u_metallicRoughnessTexture: new e.bN(t1),
                    u_normalTexture: new e.bN(t1),
                    u_occlusionTexture: new e.bN(t1),
                    u_emissionTexture: new e.bN(t1),
                    u_lutTexture: new e.bN(t1),
                    u_color_mix: new e.ca(t1),
                    u_aoIntensity: new e.bM(t1),
                    u_emissive_strength: new e.bM(t1),
                    u_occlusionTextureTransform: new e.ca(t1)
                }),
            modelDepth: (t1)=>({
                    u_matrix: new e.bJ(t1),
                    u_instance: new e.bJ(t1),
                    u_node_matrix: new e.bJ(t1)
                }),
            groundShadow: (t1)=>({
                    u_matrix: new e.bJ(t1),
                    u_ground_shadow_factor: new e.bL(t1)
                }),
            stars: (t1)=>({
                    u_matrix: new e.bJ(t1),
                    u_up: new e.bL(t1),
                    u_right: new e.bL(t1),
                    u_intensity_multiplier: new e.bM(t1)
                }),
            snowParticle: (t1)=>({
                    u_modelview: new e.bJ(t1),
                    u_projection: new e.bJ(t1),
                    u_time: new e.bM(t1),
                    u_cam_pos: new e.bL(t1),
                    u_velocityConeAperture: new e.bM(t1),
                    u_velocity: new e.bM(t1),
                    u_horizontalOscillationRadius: new e.bM(t1),
                    u_horizontalOscillationRate: new e.bM(t1),
                    u_boxSize: new e.bM(t1),
                    u_billboardSize: new e.bM(t1),
                    u_simpleShapeParameters: new e.bK(t1),
                    u_screenSize: new e.bK(t1),
                    u_thinningCenterPos: new e.bK(t1),
                    u_thinningShape: new e.bL(t1),
                    u_thinningAffectedRatio: new e.bM(t1),
                    u_thinningParticleOffset: new e.bM(t1),
                    u_particleColor: new e.ca(t1),
                    u_direction: new e.bL(t1)
                }),
            rainParticle: (t1)=>({
                    u_modelview: new e.bJ(t1),
                    u_projection: new e.bJ(t1),
                    u_time: new e.bM(t1),
                    u_cam_pos: new e.bL(t1),
                    u_texScreen: new e.bN(t1),
                    u_velocityConeAperture: new e.bM(t1),
                    u_velocity: new e.bM(t1),
                    u_boxSize: new e.bM(t1),
                    u_rainDropletSize: new e.bK(t1),
                    u_distortionStrength: new e.bM(t1),
                    u_rainDirection: new e.bL(t1),
                    u_color: new e.ca(t1),
                    u_screenSize: new e.bK(t1),
                    u_thinningCenterPos: new e.bK(t1),
                    u_thinningShape: new e.bL(t1),
                    u_thinningAffectedRatio: new e.bM(t1),
                    u_thinningParticleOffset: new e.bM(t1),
                    u_shapeDirectionalPower: new e.bM(t1),
                    u_shapeNormalPower: new e.bM(t1),
                    u_mode: new e.bM(t1)
                }),
            vignette: (t1)=>({
                    u_vignetteShape: new e.bL(t1),
                    u_vignetteColor: new e.ca(t1)
                }),
            occlusion: (t1)=>({
                    u_matrix: new e.bJ(t1),
                    u_anchorPos: new e.bL(t1),
                    u_screenSizePx: new e.bK(t1),
                    u_occluderSizePx: new e.bK(t1),
                    u_color: new e.ca(t1)
                })
        };
        class Er {
            bind() {
                this.context.bindElementBuffer.set(this.buffer);
            }
            updateData(e) {
                this.id = Er.uniqueIdxCounter, Er.uniqueIdxCounter++;
                const t1 = this.context.gl;
                this.context.unbindVAO(), this.bind(), t1.bufferSubData(t1.ELEMENT_ARRAY_BUFFER, 0, e.arrayBuffer);
            }
            destroy() {
                this.buffer && (this.context.gl.deleteBuffer(this.buffer), delete this.buffer);
            }
            constructor(e, t1, i, o){
                this.id = Er.uniqueIdxCounter, Er.uniqueIdxCounter++, this.context = e;
                const s = e.gl;
                this.buffer = s.createBuffer(), this.dynamicDraw = Boolean(i), this.context.unbindVAO(), e.bindElementBuffer.set(this.buffer), s.bufferData(s.ELEMENT_ARRAY_BUFFER, t1.arrayBuffer, this.dynamicDraw ? s.DYNAMIC_DRAW : s.STATIC_DRAW), this.dynamicDraw || o || t1.destroy();
            }
        }
        Er.uniqueIdxCounter = 0;
        const Sr = {
            Int8: "BYTE",
            Uint8: "UNSIGNED_BYTE",
            Int16: "SHORT",
            Uint16: "UNSIGNED_SHORT",
            Int32: "INT",
            Uint32: "UNSIGNED_INT",
            Float32: "FLOAT"
        };
        class Cr {
            bind() {
                this.context.bindVertexBuffer.set(this.buffer);
            }
            updateData(e) {
                const t1 = this.context.gl;
                this.bind(), t1.bufferSubData(t1.ARRAY_BUFFER, 0, e.arrayBuffer);
            }
            enableAttributes(e, t1) {
                for(let i = 0; i < this.attributes.length; i++){
                    const o = t1.attributes[this.attributes[i].name];
                    void 0 !== o && e.enableVertexAttribArray(o);
                }
            }
            setVertexAttribPointers(e, t1, i) {
                for(let o = 0; o < this.attributes.length; o++){
                    const s = this.attributes[o], r = t1.attributes[s.name];
                    void 0 !== r && e.vertexAttribPointer(r, s.components, e[Sr[s.type]], !1, this.itemSize, s.offset + this.itemSize * (i || 0));
                }
            }
            setVertexAttribDivisor(e, t1, i) {
                for(let o = 0; o < this.attributes.length; o++){
                    const s = t1.attributes[this.attributes[o].name];
                    void 0 !== s && this.instanceCount && this.instanceCount > 0 && e.vertexAttribDivisor(s, i);
                }
            }
            destroy() {
                this.buffer && (this.context.gl.deleteBuffer(this.buffer), delete this.buffer);
            }
            constructor(e, t1, i, o, s, r){
                this.length = t1.length, this.attributes = i, this.itemSize = t1.bytesPerElement, this.dynamicDraw = o, this.instanceCount = r, this.context = e;
                const a = e.gl;
                this.buffer = a.createBuffer(), e.bindVertexBuffer.set(this.buffer), a.bufferData(a.ARRAY_BUFFER, t1.arrayBuffer, this.dynamicDraw ? a.DYNAMIC_DRAW : a.STATIC_DRAW), this.dynamicDraw || s || t1.destroy();
            }
        }
        class Ir {
            destroy() {
                const e = this.context.gl;
                if (this.colorAttachment) {
                    const t1 = this.colorAttachment.get();
                    t1 && e.deleteTexture(t1);
                }
                if (this.depthAttachment && this.depthAttachmentType) {
                    if ("renderbuffer" === this.depthAttachmentType) {
                        const t1 = this.depthAttachment.get();
                        t1 && e.deleteRenderbuffer(t1);
                    } else {
                        const t1 = this.depthAttachment.get();
                        t1 && e.deleteTexture(t1);
                    }
                }
                e.deleteFramebuffer(this.framebuffer);
            }
            constructor(e, t1, i, o, s){
                this.context = e, this.width = t1, this.height = i;
                const r = this.framebuffer = e.gl.createFramebuffer();
                o && (this.colorAttachment = new Is(e, r)), s && (this.depthAttachmentType = s, this.depthAttachment = "renderbuffer" === s ? new Rs(e, r) : new Ds(e, r));
            }
        }
        class Rr {
            setDefault() {
                this.unbindVAO(), this.clearColor.setDefault(), this.clearDepth.setDefault(), this.clearStencil.setDefault(), this.colorMask.setDefault(), this.depthMask.setDefault(), this.stencilMask.setDefault(), this.stencilFunc.setDefault(), this.stencilOp.setDefault(), this.stencilTest.setDefault(), this.depthRange.setDefault(), this.depthTest.setDefault(), this.depthFunc.setDefault(), this.blend.setDefault(), this.blendFunc.setDefault(), this.blendColor.setDefault(), this.blendEquation.setDefault(), this.cullFace.setDefault(), this.cullFaceSide.setDefault(), this.frontFace.setDefault(), this.program.setDefault(), this.activeTexture.setDefault(), this.bindFramebuffer.setDefault(), this.pixelStoreUnpack.setDefault(), this.pixelStoreUnpackPremultiplyAlpha.setDefault(), this.pixelStoreUnpackFlipY.setDefault();
            }
            setDirty() {
                this.clearColor.dirty = !0, this.clearDepth.dirty = !0, this.clearStencil.dirty = !0, this.colorMask.dirty = !0, this.depthMask.dirty = !0, this.stencilMask.dirty = !0, this.stencilFunc.dirty = !0, this.stencilOp.dirty = !0, this.stencilTest.dirty = !0, this.depthRange.dirty = !0, this.depthTest.dirty = !0, this.depthFunc.dirty = !0, this.blend.dirty = !0, this.blendFunc.dirty = !0, this.blendColor.dirty = !0, this.blendEquation.dirty = !0, this.cullFace.dirty = !0, this.cullFaceSide.dirty = !0, this.frontFace.dirty = !0, this.program.dirty = !0, this.activeTexture.dirty = !0, this.viewport.dirty = !0, this.bindFramebuffer.dirty = !0, this.bindRenderbuffer.dirty = !0, this.bindTexture.dirty = !0, this.bindVertexBuffer.dirty = !0, this.bindElementBuffer.dirty = !0, this.bindVertexArrayOES.dirty = !0, this.pixelStoreUnpack.dirty = !0, this.pixelStoreUnpackPremultiplyAlpha.dirty = !0, this.pixelStoreUnpackFlipY.dirty = !0;
            }
            createIndexBuffer(e, t1, i) {
                return new Er(this, e, t1, i);
            }
            createVertexBuffer(e, t1, i, o, s) {
                return new Cr(this, e, t1, i, o, s);
            }
            createRenderbuffer(e, t1, i) {
                const o = this.gl, s = o.createRenderbuffer();
                return this.bindRenderbuffer.set(s), o.renderbufferStorage(o.RENDERBUFFER, e, t1, i), this.bindRenderbuffer.set(null), s;
            }
            createFramebuffer(e, t1, i, o) {
                return new Ir(this, e, t1, i, o);
            }
            clear({ color: e, depth: t1, stencil: i, colorMask: o }) {
                const s = this.gl;
                let r = 0;
                e && (r |= s.COLOR_BUFFER_BIT, this.clearColor.set(e), this.colorMask.set(o || [
                    !0,
                    !0,
                    !0,
                    !0
                ])), void 0 !== t1 && (r |= s.DEPTH_BUFFER_BIT, this.depthRange.set([
                    0,
                    1
                ]), this.clearDepth.set(t1), this.depthMask.set(!0)), void 0 !== i && (r |= s.STENCIL_BUFFER_BIT, this.clearStencil.set(i), this.stencilMask.set(255)), s.clear(r);
            }
            setCullFace(e) {
                !1 === e.enable ? this.cullFace.set(!1) : (this.cullFace.set(!0), this.cullFaceSide.set(e.mode), this.frontFace.set(e.frontFace));
            }
            setDepthMode(e) {
                e.func !== this.gl.ALWAYS || e.mask ? (this.depthTest.set(!0), this.depthFunc.set(e.func), this.depthMask.set(e.mask), this.depthRange.set(e.range)) : this.depthTest.set(!1);
            }
            setStencilMode(e) {
                e.test.func !== this.gl.ALWAYS || e.mask ? (this.stencilTest.set(!0), this.stencilMask.set(e.mask), this.stencilOp.set([
                    e.fail,
                    e.depthFail,
                    e.pass
                ]), this.stencilFunc.set({
                    func: e.test.func,
                    ref: e.ref,
                    mask: e.test.mask
                })) : this.stencilTest.set(!1);
            }
            setColorMode(t1) {
                e.bn(t1.blendFunction, ki.Replace) ? this.blend.set(!1) : (this.blend.set(!0), this.blendFunc.set(t1.blendFunction), this.blendColor.set(t1.blendColor), t1.blendEquation ? this.blendEquation.set(t1.blendEquation) : this.blendEquation.setDefault()), this.colorMask.set(t1.mask);
            }
            unbindVAO() {
                this.bindVertexArrayOES.set(null);
            }
            constructor(e, t1){
                this.gl = e, this.clearColor = new Xo(this), this.clearDepth = new Ko(this), this.clearStencil = new Yo(this), this.colorMask = new Jo(this), this.depthMask = new Qo(this), this.stencilMask = new es(this), this.stencilFunc = new ts(this), this.stencilOp = new is(this), this.stencilTest = new os(this), this.depthRange = new ss(this), this.depthTest = new rs(this), this.depthFunc = new as(this), this.blend = new ns(this), this.blendFunc = new ls(this), this.blendColor = new cs(this), this.blendEquation = new hs(this), this.cullFace = new us(this), this.cullFaceSide = new ds(this), this.frontFace = new _s(this), this.program = new ps(this), this.activeTexture = new fs(this), this.viewport = new ms(this), this.bindFramebuffer = new gs(this), this.bindRenderbuffer = new vs(this), this.bindTexture = new ys(this), this.bindVertexBuffer = new xs(this), this.bindElementBuffer = new bs(this), this.bindVertexArrayOES = new ws(this), this.pixelStoreUnpack = new Ts(this), this.pixelStoreUnpackPremultiplyAlpha = new Es(this), this.pixelStoreUnpackFlipY = new Ss(this), this.options = t1 ? Object.assign({}, t1) : {}, this.options.extTextureFilterAnisotropicForceOff || (this.extTextureFilterAnisotropic = e.getExtension("EXT_texture_filter_anisotropic") || e.getExtension("MOZ_EXT_texture_filter_anisotropic") || e.getExtension("WEBKIT_EXT_texture_filter_anisotropic"), this.extTextureFilterAnisotropic && (this.extTextureFilterAnisotropicMax = e.getParameter(this.extTextureFilterAnisotropic.MAX_TEXTURE_MAX_ANISOTROPY_EXT))), this.extDebugRendererInfo = e.getExtension("WEBGL_debug_renderer_info"), this.extDebugRendererInfo && (this.renderer = e.getParameter(this.extDebugRendererInfo.UNMASKED_RENDERER_WEBGL), this.vendor = e.getParameter(this.extDebugRendererInfo.UNMASKED_VENDOR_WEBGL)), this.forceManualRenderingForInstanceIDShaders = t1 && !!t1.forceManualRenderingForInstanceIDShaders || this.renderer && -1 !== this.renderer.indexOf("PowerVR"), this.options.extTextureFloatLinearForceOff || (this.extTextureFloatLinear = e.getExtension("OES_texture_float_linear")), this.extRenderToTextureHalfFloat = e.getExtension("EXT_color_buffer_half_float"), this.extTimerQuery = e.getExtension("EXT_disjoint_timer_query_webgl2"), this.maxTextureSize = e.getParameter(e.MAX_TEXTURE_SIZE), this.maxPointSize = e.getParameter(e.ALIASED_POINT_SIZE_RANGE)[1];
            }
        }
        let Dr;
        function Lr(t1, i, o, s, r, a, n) {
            const l = t1.context, c = l.gl, h = t1.transform, u = t1.getOrCreateProgram("collisionBox"), d = [];
            let _ = 0, p = 0;
            for(let l = 0; l < s.length; l++){
                const f = s[l], m = i.getTile(f), g = m.getBucket(o);
                if (!g) continue;
                const v = li(f, g, h);
                let y = v;
                0 === r[0] && 0 === r[1] || (y = t1.translatePosMatrix(v, m, r, a));
                const x = n ? g.textCollisionBox : g.iconCollisionBox, b = g.collisionCircleArray;
                if (b.length > 0) {
                    const t1 = e.ab.mat4.create(), i = y;
                    e.ab.mat4.mul(t1, g.placementInvProjMatrix, h.glCoordMatrix), e.ab.mat4.mul(t1, t1, g.placementViewportMatrix), d.push({
                        circleArray: b,
                        circleOffset: p,
                        transform: i,
                        invTransform: t1,
                        projection: g.getProjection()
                    }), _ += b.length / 4, p = _;
                }
                x && (t1.terrain && t1.terrain.setupElevationDraw(m, u), u.draw(t1, c.LINES, Bi.disabled, Ui.disabled, t1.colorModeForRenderPass(), Vi.disabled, sr(y, h, m, g.getProjection()), o.id, x.layoutVertexBuffer, x.indexBuffer, x.segments, null, h.zoom, null, [
                    x.collisionVertexBuffer,
                    x.collisionVertexBufferExt
                ]));
            }
            if (!n || !d.length) return;
            const f = t1.getOrCreateProgram("collisionCircle"), m = new e.cV;
            m.resize(4 * _), m._trim();
            let g = 0;
            for (const e of d)for(let t1 = 0; t1 < e.circleArray.length / 4; t1++){
                const i = 4 * t1, o = e.circleArray[i + 0], s = e.circleArray[i + 1], r = e.circleArray[i + 2], a = e.circleArray[i + 3];
                m.emplace(g++, o, s, r, a, 0), m.emplace(g++, o, s, r, a, 1), m.emplace(g++, o, s, r, a, 2), m.emplace(g++, o, s, r, a, 3);
            }
            (!Dr || Dr.length < 2 * _) && (Dr = function(t1) {
                const i = 2 * t1, o = new e.aU;
                o.resize(i), o._trim();
                for(let e = 0; e < i; e++){
                    const t1 = 6 * e;
                    o.uint16[t1 + 0] = 4 * e + 0, o.uint16[t1 + 1] = 4 * e + 1, o.uint16[t1 + 2] = 4 * e + 2, o.uint16[t1 + 3] = 4 * e + 2, o.uint16[t1 + 4] = 4 * e + 3, o.uint16[t1 + 5] = 4 * e + 0;
                }
                return o;
            }(_));
            const v = l.createIndexBuffer(Dr, !0), y = l.createVertexBuffer(m, e.cW.members, !0);
            for (const i of d){
                const s = {
                    u_matrix: i.transform,
                    u_inv_matrix: i.invTransform,
                    u_camera_to_center_distance: (x = h).getCameraToCenterDistance(i.projection),
                    u_viewport_size: [
                        x.width,
                        x.height
                    ]
                };
                f.draw(t1, c.TRIANGLES, Bi.disabled, Ui.disabled, t1.colorModeForRenderPass(), Vi.disabled, s, o.id, y, v, e.b7.simpleSegment(0, 2 * i.circleOffset, i.circleArray.length, i.circleArray.length / 2), null, h.zoom);
            }
            var x;
            y.destroy(), v.destroy();
        }
        const Ar = e.ab.mat4.create();
        function zr(t1) {
            const i = t1._camera.getWorldToCamera(t1.worldSize, 1), o = e.ab.mat4.multiply([], i, t1.globeMatrix);
            e.ab.mat4.invert(o, o);
            const s = [
                0,
                0,
                0
            ], r = [
                0,
                1,
                0,
                0
            ];
            return e.ab.vec4.transformMat4(r, r, o), s[0] = r[0], s[1] = r[1], s[2] = r[2], e.ab.vec3.normalize(s, s), s;
        }
        function Pr({ width: t1, height: i, anchor: o, textOffset: s, textScale: r }, a) {
            const { horizontalAlign: n, verticalAlign: l } = e.bD(o), c = -(n - .5) * t1, h = -(l - .5) * i, u = e.bC(o, s);
            return new e.P((c / r + u[0]) * a, (h / r + u[1]) * a);
        }
        function Mr(t1, i, o, s, r, a, n, l, c, h, u) {
            const d = t1.text.placedSymbolArray, _ = t1.text.dynamicLayoutVertexArray, p = t1.icon.dynamicLayoutVertexArray, f = {}, m = t1.getProjection(), g = ci(l, m, a), v = a.elevation, y = m.upVectorScale(l.canonical, a.center.lat, a.worldSize).metersToTile;
            _.clear();
            for(let p = 0; p < d.length; p++){
                const x = d.get(p), { tileAnchorX: b, tileAnchorY: w, numGlyphs: T } = x, E = x.hidden || !x.crossTileID || t1.allowVerticalPlacement && !x.placedOrientation ? null : s[x.crossTileID];
                if (E) {
                    let s = 0, d = 0, p = 0;
                    if (v) {
                        const e = v ? v.getAtTileOffset(l, b, w) : 0, [t1, i, o] = m.upVector(l.canonical, b, w);
                        s = e * t1 * y, d = e * i * y, p = e * o * y;
                    }
                    let [S, C, I, R] = Wt(x.projectedAnchorX + s, x.projectedAnchorY + d, x.projectedAnchorZ + p, o ? g : n);
                    const D = $t(a.getCameraToCenterDistance(m), R);
                    let L = r.evaluateSizeForFeature(t1.textSizeData, h, x) * D / e.bw;
                    o && (L *= t1.tilePixelRatio / c);
                    const A = Pr(E, L);
                    o ? ({ x: S, y: C, z: I } = m.projectTilePoint(b + A.x, w + A.y, l.canonical), [S, C, I] = Wt(S + s, C + d, I + p, n)) : (i && A._rotate(-a.angle), S += A.x, C += A.y, I = 0);
                    const z = t1.allowVerticalPlacement && x.placedOrientation === e.bq.vertical ? Math.PI / 2 : 0;
                    for(let t1 = 0; t1 < T; t1++)e.bt(_, S, C, I, z);
                    u && x.associatedIconIndex >= 0 && (f[x.associatedIconIndex] = {
                        x: S,
                        y: C,
                        z: I,
                        angle: z
                    });
                } else oi(T, _);
            }
            if (u) {
                p.clear();
                const i = t1.icon.placedSymbolArray;
                for(let t1 = 0; t1 < i.length; t1++){
                    const o = i.get(t1), { numGlyphs: s } = o, r = f[t1];
                    if (o.hidden || !r) oi(s, p);
                    else {
                        const { x: t1, y: i, z: o, angle: a } = r;
                        for(let r = 0; r < s; r++)e.bt(p, t1, i, o, a);
                    }
                }
                t1.icon.dynamicLayoutVertexBuffer.updateData(p);
            }
            t1.text.dynamicLayoutVertexBuffer.updateData(_);
        }
        function Or(t1, i, o, s, r, a, n = {}) {
            const l = o.paint.get("icon-translate"), c = o.paint.get("text-translate"), h = o.paint.get("icon-translate-anchor"), u = o.paint.get("text-translate-anchor"), d = o.layout.get("icon-rotation-alignment"), _ = o.layout.get("text-rotation-alignment"), p = o.layout.get("icon-pitch-alignment"), f = o.layout.get("text-pitch-alignment"), m = o.layout.get("icon-keep-upright"), g = o.layout.get("text-keep-upright"), v = o.paint.get("icon-color-saturation"), y = o.paint.get("icon-color-contrast"), x = o.paint.get("icon-color-brightness-min"), b = o.paint.get("icon-color-brightness-max"), w = "sea" === o.layout.get("symbol-elevation-reference"), T = t1.context, E = T.gl, S = t1.transform, C = "map" === d, I = "map" === _, R = "map" === p, D = "map" === f, L = void 0 !== o.layout.get("symbol-sort-key").constantOr(1);
            let A = !1;
            const z = t1.depthModeForSublayer(0, Bi.ReadOnly), P = [
                e.at(S.center.lng),
                e.aA(S.center.lat)
            ], M = o.layout.get("text-variable-anchor"), O = "globe" === S.projection.name, F = [], k = [
                0,
                -1,
                0
            ];
            for (const r of s){
                const s = i.getTile(r), a = s.getBucket(o);
                if (!a) continue;
                if ("mercator" === a.projection.name && O) continue;
                if (a.fullyClipped) continue;
                const d = "globe" === a.projection.name, _ = d ? e.ae(S.zoom) : 0, p = ci(r, a.getProjection(), S), f = S.calculatePixelsToTileUnitsMatrix(s), T = M && a.hasTextData(), z = a.hasIconTextFit() && T && a.hasIconData(), B = a.getProjection().createInversionMatrix(S, r.canonical), N = (e)=>{
                    S.depthOcclusionForSymbolsAndCircles && (o.hasInitialOcclusionOpacityProperties || t1.terrain) && (e.push("DEPTH_D24"), e.push("DEPTH_OCCLUSION"));
                }, U = ()=>{
                    const i = C && "point" !== o.layout.get("symbol-placement"), n = [];
                    N(n);
                    const c = i || z, u = o.paint.get("icon-image-cross-fade").constantOr(0);
                    t1.terrainRenderModeElevated() && R && n.push("PITCH_WITH_MAP_TERRAIN"), d && (n.push("PROJECTION_GLOBE_VIEW"), c && n.push("PROJECTED_POS_ON_VIEWPORT")), u > 0 && n.push("ICON_TRANSITION"), a.icon.zOffsetVertexBuffer && n.push("Z_OFFSET"), 0 === v && 0 === y && 0 === x && 1 === b || n.push("COLOR_ADJUSTMENT"), a.sdfIcons && n.push("RENDER_SDF");
                    const g = a.icon.programConfigurations.get(o.id), T = t1.getOrCreateProgram("symbol", {
                        config: g,
                        defines: n
                    }), I = s.imageAtlasTexture ? s.imageAtlasTexture.size : [
                        0,
                        0
                    ], D = a.iconSizeData, L = e.bp(D, S.zoom), A = R || 0 !== S.pitch, M = qt(p, s.tileID.canonical, R, C, S, a.getProjection(), f), F = Zt(p, s.tileID.canonical, R, C, S, a.getProjection(), f), U = t1.translatePosMatrix(F, s, l, h, !0), j = t1.translatePosMatrix(p, s, l, h), G = c ? Ar : M, V = C && !R && !i;
                    let q = k;
                    !O && !S.mercatorFromTransition || C || (q = zr(S));
                    const H = d ? q : k, Z = o.getColorAdjustmentMatrix(v, y, x, b), W = gr(D.kind, L, V, R, t1, j, G, U, w, !1, I, [
                        0,
                        0
                    ], !0, r, _, P, B, H, a.getProjection(), Z, u), $ = s.imageAtlasTexture ? s.imageAtlasTexture : null, X = 1 !== o.layout.get("icon-size").constantOr(0) || a.iconsNeedLinear, K = a.sdfIcons || t1.options.rotating || t1.options.zooming || X || A ? E.LINEAR : E.NEAREST, Y = a.sdfIcons && 0 !== o.paint.get("icon-halo-width").constantOr(1), J = t1.terrain && R && i ? e.ab.mat4.invert(e.ab.mat4.create(), M) : Ar;
                    if (i && a.icon) {
                        const e = S.elevation, i = e ? e.getAtTileOffsetFunc(r, S.center.lat, S.worldSize, a.getProjection()) : null, o = Ht(p, s.tileID.canonical, R, C, S, a.getProjection(), f);
                        Kt(a, p, t1, !1, o, F, R, m, i, r);
                    }
                    return {
                        program: T,
                        buffers: a.icon,
                        uniformValues: W,
                        atlasTexture: $,
                        atlasTextureIcon: null,
                        atlasInterpolation: K,
                        atlasInterpolationIcon: null,
                        isSDF: a.sdfIcons,
                        hasHalo: Y,
                        tile: s,
                        labelPlaneMatrixInv: J
                    };
                }, j = ()=>{
                    const i = I && "point" !== o.layout.get("symbol-placement"), n = [], l = i || M || z;
                    t1.terrainRenderModeElevated() && D && n.push("PITCH_WITH_MAP_TERRAIN"), d && (n.push("PROJECTION_GLOBE_VIEW"), l && n.push("PROJECTED_POS_ON_VIEWPORT")), a.text.zOffsetVertexBuffer && n.push("Z_OFFSET"), a.iconsInText && n.push("RENDER_TEXT_AND_SYMBOL"), n.push("RENDER_SDF"), N(n);
                    const h = a.text.programConfigurations.get(o.id), m = t1.getOrCreateProgram("symbol", {
                        config: h,
                        defines: n
                    });
                    let v, y = [
                        0,
                        0
                    ], x = null;
                    const b = a.textSizeData;
                    a.iconsInText && (y = s.imageAtlasTexture ? s.imageAtlasTexture.size : [
                        0,
                        0
                    ], x = s.imageAtlasTexture ? s.imageAtlasTexture : null, v = D || 0 !== S.pitch || t1.options.rotating || t1.options.zooming || "composite" === b.kind || "camera" === b.kind ? E.LINEAR : E.NEAREST);
                    const T = s.glyphAtlasTexture ? s.glyphAtlasTexture.size : [
                        0,
                        0
                    ], C = o.layout.get("text-size-scale-range"), R = e.aw(t1.scaleFactor, C[0], C[1]), L = e.bp(b, S.zoom, R), A = qt(p, s.tileID.canonical, D, I, S, a.getProjection(), f), F = Zt(p, s.tileID.canonical, D, I, S, a.getProjection(), f), U = t1.translatePosMatrix(F, s, c, u, !0), j = t1.translatePosMatrix(p, s, c, u), G = l ? Ar : A, V = I && !D && !i;
                    let q = k;
                    !O && !S.mercatorFromTransition || I || (q = zr(S));
                    const H = gr(b.kind, L, V, D, t1, j, G, U, w, !0, T, y, !0, r, _, P, B, d ? q : k, a.getProjection(), null, null, R), Z = s.glyphAtlasTexture ? s.glyphAtlasTexture : null, W = E.LINEAR, $ = 0 !== o.paint.get("text-halo-width").constantOr(1), X = t1.terrain && D && i ? e.ab.mat4.invert(e.ab.mat4.create(), A) : Ar;
                    if (i && a.text) {
                        const e = S.elevation, i = e ? e.getAtTileOffsetFunc(r, S.center.lat, S.worldSize, a.getProjection()) : null, o = Ht(p, s.tileID.canonical, D, I, S, a.getProjection(), f);
                        Kt(a, p, t1, !0, o, F, D, g, i, r);
                    }
                    return {
                        program: m,
                        buffers: a.text,
                        uniformValues: H,
                        atlasTexture: Z,
                        atlasTextureIcon: x,
                        atlasInterpolation: W,
                        atlasInterpolationIcon: v,
                        isSDF: !0,
                        hasHalo: $,
                        tile: s,
                        labelPlaneMatrixInv: X
                    };
                }, G = a.icon.segments.get().length, V = a.text.segments.get().length, q = G && !n.onlyText ? U() : null, H = V && !n.onlyIcons ? j() : null, Z = o.paint.get("icon-opacity").constantOr(1), W = o.paint.get("text-opacity").constantOr(1);
                if (L && a.canOverlap) {
                    A = !0;
                    const t1 = Z && !n.onlyText ? a.icon.segments.get() : [], i = W && !n.onlyIcons ? a.text.segments.get() : [];
                    for (const i of t1)F.push({
                        segments: new e.b7([
                            i
                        ]),
                        sortKey: i.sortKey,
                        state: q
                    });
                    for (const t1 of i)F.push({
                        segments: new e.b7([
                            t1
                        ]),
                        sortKey: t1.sortKey,
                        state: H
                    });
                } else n.onlyText || F.push({
                    segments: Z ? a.icon.segments : new e.b7([]),
                    sortKey: 0,
                    state: q
                }), n.onlyIcons || F.push({
                    segments: W ? a.text.segments : new e.b7([]),
                    sortKey: 0,
                    state: H
                });
            }
            A && F.sort((e, t1)=>e.sortKey - t1.sortKey);
            for (const e of F){
                const i = e.state;
                if (i) {
                    if (t1.terrain ? t1.terrain.setupElevationDraw(i.tile, i.program, {
                        useDepthForOcclusion: S.depthOcclusionForSymbolsAndCircles,
                        labelPlaneMatrixInv: i.labelPlaneMatrixInv
                    }) : t1.setupDepthForOcclusion(S.depthOcclusionForSymbolsAndCircles, i.program), T.activeTexture.set(E.TEXTURE0), i.atlasTexture && i.atlasTexture.bind(i.atlasInterpolation, E.CLAMP_TO_EDGE, !0), i.atlasTextureIcon && (T.activeTexture.set(E.TEXTURE1), i.atlasTextureIcon && i.atlasTextureIcon.bind(i.atlasInterpolationIcon, E.CLAMP_TO_EDGE, !0)), t1.uploadCommonLightUniforms(t1.context, i.program), i.hasHalo) {
                        const s = i.uniformValues;
                        s.u_is_halo = 1, Fr(i.buffers, e.segments, o, t1, i.program, z, r, a, s, 2), s.u_is_halo = 0;
                    } else {
                        if (i.isSDF) {
                            const s = i.uniformValues;
                            i.hasHalo && (s.u_is_halo = 1, Fr(i.buffers, e.segments, o, t1, i.program, z, r, a, s, 1)), s.u_is_halo = 0;
                        }
                        Fr(i.buffers, e.segments, o, t1, i.program, z, r, a, i.uniformValues, 1);
                    }
                }
            }
        }
        function Fr(e, t1, i, o, s, r, a, n, l, c) {
            const h = [
                e.dynamicLayoutVertexBuffer,
                e.opacityVertexBuffer,
                e.iconTransitioningVertexBuffer,
                e.globeExtVertexBuffer,
                e.zOffsetVertexBuffer
            ];
            s.draw(o, o.context.gl.TRIANGLES, r, a, n, Vi.disabled, l, i.id, e.layoutVertexBuffer, e.indexBuffer, t1, i.paint, o.transform.zoom, e.programConfigurations.get(i.id), h, c);
        }
        function kr(t1, i, o, s, r, a, n) {
            const l = t1.context.gl, c = o.paint.get("fill-pattern"), h = o.is3D(), u = h ? t1.stencilModeFor3D() : Ui.disabled, d = c && c.constantOr(1);
            let _, p, f, m, g;
            n ? (p = d && !o.getPaintProperty("fill-outline-color") ? "fillOutlinePattern" : "fillOutline", _ = l.LINES) : (p = d ? "fillPattern" : "fill", _ = l.TRIANGLES);
            for (const v of s){
                const s = i.getTile(v);
                if (d && !s.patternsLoaded()) continue;
                const y = s.getBucket(o);
                if (!y) continue;
                t1.prepareDrawTile();
                const x = y.programConfigurations.get(o.id), b = t1.isTileAffectedByFog(v), w = t1.getOrCreateProgram(p, {
                    config: x,
                    overrideFog: b
                });
                d && (t1.context.activeTexture.set(l.TEXTURE0), s.imageAtlasTexture && s.imageAtlasTexture.bind(l.LINEAR, l.CLAMP_TO_EDGE), x.updatePaintBuffers());
                const T = c.constantOr(null);
                if (T && s.imageAtlas) {
                    const t1 = s.imageAtlas, i = e.A.from(T).getPrimary().scaleSelf(e.q.devicePixelRatio).serialize(), o = t1.patternPositions[i];
                    o && x.setConstantPatternPositions(o);
                }
                const E = t1.translatePosMatrix(v.projMatrix, s, o.paint.get("fill-translate"), o.paint.get("fill-translate-anchor")), S = o.paint.get("fill-emissive-strength");
                if (n) {
                    m = y.indexBuffer2, g = y.segments2;
                    const e = t1.terrain && t1.terrain.renderingToTexture ? t1.terrain.drapeBufferSize : [
                        l.drawingBufferWidth,
                        l.drawingBufferHeight
                    ];
                    f = "fillOutlinePattern" === p && d ? or(E, S, t1, s, e) : ir(E, S, e);
                } else m = y.indexBuffer, g = y.segments, f = d ? tr(E, S, t1, s) : er(E, S);
                t1.uploadCommonUniforms(t1.context, w, v.toUnwrapped()), w.draw(t1, _, r, h ? u : t1.stencilModeForClipping(v), a, Vi.disabled, f, o.id, y.layoutVertexBuffer, m, g, o.paint, t1.transform.zoom, x, void 0);
            }
        }
        function Br(t1, i, o, s, r, a, n, l) {
            o.resetLayerRenderingStats(t1);
            const c = t1.context, h = c.gl, u = t1.transform, d = o.paint.get("fill-extrusion-pattern"), _ = d.constantOr(1), p = o.paint.get("fill-extrusion-opacity"), f = t1.style.enable3dLights(), m = o.paint.get(f && !_ ? "fill-extrusion-ambient-occlusion-wall-radius" : "fill-extrusion-ambient-occlusion-radius"), g = [
                o.paint.get("fill-extrusion-ambient-occlusion-intensity"),
                m
            ], v = o.layout.get("fill-extrusion-edge-radius"), y = v > 0 && !o.paint.get("fill-extrusion-rounded-roof"), x = y ? 0 : v, b = "globe" === u.projection.name ? e.d3() : 0, w = "globe" === u.projection.name, T = w ? e.ae(u.zoom) : 0, E = [
                e.at(u.center.lng),
                e.aA(u.center.lat)
            ], S = "none" === o.paint.get("fill-extrusion-flood-light-color-use-theme").constantOr("default"), C = o.paint.get("fill-extrusion-flood-light-color").toRenderColor(S ? null : o.lut).toArray01().slice(0, 3), I = o.paint.get("fill-extrusion-flood-light-intensity"), R = o.paint.get("fill-extrusion-vertical-scale"), D = 0 !== o.paint.get("fill-extrusion-line-width").constantOr(1), L = o.paint.get("fill-extrusion-height-alignment"), A = o.paint.get("fill-extrusion-base-alignment"), z = eo(t1, o.paint.get("fill-extrusion-cutoff-fade-range")), P = [];
            let M;
            w && P.push("PROJECTION_GLOBE_VIEW"), g[0] > 0 && P.push("FAUX_AO"), y && P.push("ZERO_ROOF_RADIUS"), l && P.push("HAS_CENTROID"), I > 0 && P.push("FLOOD_LIGHT"), z.shouldRenderCutoff && P.push("RENDER_CUTOFF"), D && P.push("RENDER_WALL_MODE");
            const O = "shadow" === t1.renderPass, F = t1.shadowRenderer, k = O && !!F;
            t1.shadowRenderer && (t1.shadowRenderer.useNormalOffset = !0);
            let B = [
                0,
                0,
                0
            ];
            if (F) {
                const e = t1.style.directionalLight, i = t1.style.ambientLight;
                e && i && (B = no(t1.style, e, i)), O || (P.push("RENDER_SHADOWS", "DEPTH_TEXTURE"), F.useNormalOffset && P.push("NORMAL_OFFSET")), M = P.concat([
                    "SHADOWS_SINGLE_CASCADE"
                ]);
            }
            const N = k ? "fillExtrusionDepth" : _ ? "fillExtrusionPattern" : "fillExtrusion", U = o.getLayerRenderingStats();
            for (const f of s){
                const s = i.getTile(f), m = s.getBucket(o);
                if (!m || m.projection.name !== u.projection.name) continue;
                let v = !1;
                F && (v = 0 === F.getMaxCascadeForTile(f.toUnwrapped()));
                const y = t1.isTileAffectedByFog(f), S = m.programConfigurations.get(o.id), k = t1.getOrCreateProgram(N, {
                    config: S,
                    defines: v ? M : P,
                    overrideFog: y
                });
                if (t1.terrain && t1.terrain.setupElevationDraw(s, k, {
                    useMeterToDem: !0
                }), !m.centroidVertexBuffer) {
                    const e = k.attributes.a_centroid_pos;
                    void 0 !== e && h.vertexAttrib2f(e, 0, 0);
                }
                !O && F && F.setupShadows(s.tileID.toUnwrapped(), k, "vector-tile", s.tileID.overscaledZ), _ && (t1.context.activeTexture.set(h.TEXTURE0), s.imageAtlasTexture && s.imageAtlasTexture.bind(h.LINEAR, h.CLAMP_TO_EDGE), S.updatePaintBuffers());
                const j = d.constantOr(null);
                if (j && s.imageAtlas) {
                    const t1 = s.imageAtlas, i = e.A.from(j).getPrimary().scaleSelf(e.q.devicePixelRatio), o = t1.patternPositions[i.serialize()];
                    o && S.setConstantPatternPositions(o);
                }
                const G = o.paint.get("fill-extrusion-vertical-gradient"), V = 1 / m.tileToMeter;
                let q;
                if (O && F) {
                    if (qr(s.tileID, m, t1)) continue;
                    const e = F.calculateShadowPassMatrixFromTile(s.tileID.toUnwrapped());
                    q = Js(e, x, V, R, L, A);
                } else {
                    const e = t1.translatePosMatrix(f.expandedProjMatrix, s, o.paint.get("fill-extrusion-translate"), o.paint.get("fill-extrusion-translate-anchor")), i = u.projection.createInversionMatrix(u, f.canonical);
                    q = _ ? Qs(e, t1, G, p, g, x, V, f, s, b, L, A, T, E, i, C, R) : Ys(e, t1, G, p, g, x, V, f, b, L, A, T, E, i, C, R, I, B);
                }
                t1.uploadCommonUniforms(c, k, f.toUnwrapped(), null, z);
                let H = m.segments;
                if ("mercator" === u.projection.name && !O && (H = m.getVisibleSegments(s.tileID, t1.terrain, t1.transform.getFrustum(0)), !H.get().length)) continue;
                if (U) {
                    if (O) for (const e of H.get())U.numRenderedVerticesInShadowPass += e.primitiveLength;
                    else for (const e of H.get())U.numRenderedVerticesInTransparentPass += e.primitiveLength;
                }
                const Z = [];
                (t1.terrain || l) && Z.push(m.centroidVertexBuffer), w && Z.push(m.layoutVertexExtBuffer), D && Z.push(m.wallVertexBuffer), k.draw(t1, c.gl.TRIANGLES, r, a, n, Vi.backCCW, q, o.id, m.layoutVertexBuffer, m.indexBuffer, H, o.paint, t1.transform.zoom, S, Z);
            }
            t1.shadowRenderer && (t1.shadowRenderer.useNormalOffset = !1);
        }
        function Nr(t1, i, o, s, r, a, n, l, c, h, u, d, _, p, f, m, g, v, y) {
            const x = t1.context, b = x.gl, w = t1.transform, T = t1.transform.zoom, E = [], S = eo(t1, o.paint.get("fill-extrusion-cutoff-fade-range"));
            "clear" === h ? (E.push("CLEAR_SUBPASS"), y && (E.push("CLEAR_FROM_TEXTURE"), x.activeTexture.set(b.TEXTURE0), y.bind(b.LINEAR, b.CLAMP_TO_EDGE))) : "sdf" === h && E.push("SDF_SUBPASS"), g && E.push("HAS_CENTROID"), S.shouldRenderCutoff && E.push("RENDER_CUTOFF");
            const C = o.layout.get("fill-extrusion-edge-radius"), I = (e, i, s, h, v)=>{
                const b = i.programConfigurations.get(o.id), w = t1.isTileAffectedByFog(e), I = t1.getOrCreateProgram("fillExtrusionGroundEffect", {
                    config: b,
                    defines: E,
                    overrideFog: w
                }), R = ((e, t1, i, o, s, r, a, n, l, c, h)=>({
                        u_matrix: t1,
                        u_opacity: i,
                        u_ao_pass: o ? 1 : 0,
                        u_meter_to_tile: s,
                        u_ao: r,
                        u_flood_light_intensity: a,
                        u_flood_light_color: n,
                        u_attenuation: l,
                        u_edge_radius: c,
                        u_fb: 0,
                        u_fb_size: h,
                        u_dynamic_offset: 1
                    }))(0, h, u, c, v, [
                    d,
                    _ * v
                ], p, f, m, T >= 17 ? 0 : C * v, y ? y.size[0] : 0), D = [];
                g && D.push(i.hiddenByLandmarkVertexBuffer), t1.uploadCommonUniforms(x, I, e.toUnwrapped(), null, S), I.draw(t1, x.gl.TRIANGLES, r, a, n, l, R, o.id, i.vertexBuffer, i.indexBuffer, s, o.paint, T, b, D);
            };
            for (const r of s){
                const s = i.getTile(r), a = s.getBucket(o);
                if (!a || a.projection.name !== w.projection.name || !a.groundEffect || a.groundEffect && !a.groundEffect.hasData()) continue;
                const n = a.groundEffect, l = 1 / a.tileToMeter;
                {
                    const e = t1.translatePosMatrix(r.projMatrix, s, o.paint.get("fill-extrusion-translate"), o.paint.get("fill-extrusion-translate-anchor")), i = n.getDefaultSegment();
                    I(r, n, i, e, l);
                }
                if (v) for(let a = 0; a < 4; a++){
                    const n = e.d4[a](r), c = i.getTile(n);
                    if (!c) continue;
                    const h = c.getBucket(o);
                    if (!h || h.projection.name !== w.projection.name || !h.groundEffect || h.groundEffect && !h.groundEffect.hasData()) continue;
                    const u = h.groundEffect;
                    let d, _;
                    0 === a ? (d = [
                        -e.ag,
                        0,
                        0
                    ], _ = 1) : 1 === a ? (d = [
                        e.ag,
                        0,
                        0
                    ], _ = 0) : 2 === a ? (d = [
                        0,
                        -e.ag,
                        0
                    ], _ = 3) : (d = [
                        0,
                        e.ag,
                        0
                    ], _ = 2);
                    const p = u.regionSegments[_];
                    if (!p) continue;
                    const f = new Float32Array(16);
                    e.ab.mat4.translate(f, r.projMatrix, d), I(r, u, p, t1.translatePosMatrix(f, s, o.paint.get("fill-extrusion-translate"), o.paint.get("fill-extrusion-translate-anchor")), l);
                }
            }
        }
        function Ur(t1, i, o, s, r, a, n) {
            0 === s.centroidVertexArray.length && s.createCentroidsBuffer();
            const l = a ? a.findDEMTileFor(o) : null;
            if (!(l && l.dem || n)) return;
            a && l && l.dem && s.selfDEMTileTimestamp !== l.dem._timestamp && (s.borderDoneWithNeighborZ = [
                -1,
                -1,
                -1,
                -1
            ], s.selfDEMTileTimestamp = l.dem._timestamp);
            const c = (t1)=>new e.P(Math.ceil((t1 + e.d7) * e.d8), 0), h = (e)=>{
                const t1 = i.getSource().minzoom, o = (e)=>{
                    const t1 = i.getTileByID(e);
                    if (t1 && t1.hasData()) return t1.getBucket(r);
                }, s = [
                    0,
                    -1,
                    1
                ];
                for (const i of s){
                    if (e.overscaledZ + i < t1) continue;
                    const s = o(e.calculateScaledKey(e.overscaledZ + i));
                    if (s) return s;
                }
            }, u = [
                0,
                0,
                0
            ], d = (t1, i)=>(u[0] = Math.min(t1.min.y, i.min.y), u[1] = Math.max(t1.max.y, i.max.y), u[2] = e.ag - i.min.x > t1.max.x ? i.min.x - e.ag : t1.max.x, u), _ = (t1, i)=>(u[0] = Math.min(t1.min.x, i.min.x), u[1] = Math.max(t1.max.x, i.max.x), u[2] = e.ag - i.min.y > t1.max.y ? i.min.y - e.ag : t1.max.y, u), p = [
                (e, t1)=>d(e, t1),
                (e, t1)=>d(t1, e),
                (e, t1)=>_(e, t1),
                (e, t1)=>_(t1, e)
            ], f = (t1, i, s, r, n, c, h)=>{
                if (!a) return 0;
                const u = [
                    [
                        c ? s : t1,
                        c ? t1 : s,
                        0
                    ],
                    [
                        c ? s : i,
                        c ? i : s,
                        0
                    ]
                ], d = h < 0 ? e.ag + h : h, _ = [
                    c ? d : (t1 + i) / 2,
                    c ? (t1 + i) / 2 : d,
                    0
                ];
                return 0 === s && h < 0 || 0 !== s && h > 0 ? a.getForTilePoints(n, [
                    _
                ], !0, r) : u.push(_), a.getForTilePoints(o, u, !0, l), Math.max(u[0][2], u[1][2], _[2]) / a.exaggeration();
            };
            for(let t1 = 0; t1 < 4; t1++){
                const i = s.borderFeatureIndices[t1];
                if (0 === i.length) continue;
                const r = e.d4[t1](o), l = h(r);
                if (!(l && l instanceof e.d5)) continue;
                const u = a ? a.findDEMTileFor(r) : null;
                if (!(u && u.dem || n)) continue;
                if (a && u && u.dem && s.borderDEMTileTimestamp[t1] !== u.dem._timestamp && (s.borderDoneWithNeighborZ[t1] = -1, s.borderDEMTileTimestamp[t1] = u.dem._timestamp), s.borderDoneWithNeighborZ[t1] === l.canonical.z) continue;
                0 === l.centroidVertexArray.length && l.createCentroidsBuffer();
                const d = (t1 < 2 ? 1 : 5) - t1, _ = l.borderDoneWithNeighborZ[d] !== s.canonical.z, v = l.borderFeatureIndices[d];
                let y = 0;
                if (s.canonical.z !== l.canonical.z) {
                    for (const e of i)s.showCentroid(s.featuresOnBorder[e]);
                    if (_) for (const e of v)l.showCentroid(l.featuresOnBorder[e]);
                    s.borderDoneWithNeighborZ[t1] = l.canonical.z, l.borderDoneWithNeighborZ[d] = s.canonical.z;
                }
                for (const o of i){
                    const i = s.featuresOnBorder[o], a = s.centroidData[i.centroidDataIndex], h = i.borders[t1];
                    let _;
                    for(; y < v.length;){
                        _ = l.featuresOnBorder[v[y]];
                        const e = _.borders[d];
                        if (e[1] > h[0] + 3 || e[0] > h[0] - 3) break;
                        l.showCentroid(_), y++;
                    }
                    if (_ && y < v.length) {
                        const o = y;
                        let x = 0;
                        for(; !(_.borders[d][0] > h[1] - 3) && (x++, ++y !== v.length);)_ = l.featuresOnBorder[v[y]];
                        _ = l.featuresOnBorder[v[o]];
                        let b = !1;
                        if (x >= 1) {
                            const e = _.borders[d];
                            Math.abs(h[0] - e[0]) < 3 && Math.abs(h[1] - e[1]) < 3 && (x = 1, b = !0, y = o + 1);
                        } else if (0 === x) {
                            s.showCentroid(i);
                            continue;
                        }
                        const w = l.centroidData[_.centroidDataIndex];
                        n && b && (((m = a).flags | (g = w).flags) & e.d6 ? (m.flags |= e.d6, g.flags |= e.d6) : (m.flags &= ~e.d6, g.flags &= ~e.d6));
                        const T = i.intersectsCount() > 1 || _.intersectsCount() > 1;
                        if (x > 1) y = o, a.centroidXY = w.centroidXY = new e.P(0, 0);
                        else if (u && u.dem && !T) {
                            const i = p[t1](a, w), o = t1 % 2 ? e.ag - 1 : 0, s = f(i[0], Math.min(e.ag - 1, i[1]), o, u, r, t1 < 2, i[2]);
                            a.centroidXY = w.centroidXY = c(s);
                        } else T ? a.centroidXY = w.centroidXY = new e.P(0, 0) : (a.centroidXY = s.encodeBorderCentroid(i), w.centroidXY = l.encodeBorderCentroid(_));
                        s.writeCentroidToBuffer(a), l.writeCentroidToBuffer(w);
                    } else s.showCentroid(i);
                }
                s.borderDoneWithNeighborZ[t1] = l.canonical.z, l.borderDoneWithNeighborZ[d] = s.canonical.z;
            }
            var m, g;
            (s.needsCentroidUpdate || !s.centroidVertexBuffer && 0 !== s.centroidVertexArray.length) && s.uploadCentroid(t1);
        }
        const jr = [
            1,
            0,
            0
        ], Gr = [
            0,
            1,
            0
        ], Vr = [
            0,
            0,
            1
        ];
        function qr(t1, i, o) {
            const s = o.transform, r = o.shadowRenderer;
            if (!r) return !0;
            const a = t1.toUnwrapped(), n = s.tileSize * r._cascades[o.currentShadowCascade].scale;
            let l = i.maxHeight;
            if (s.elevation) {
                const e = s.elevation.getMinMaxForTile(t1);
                e && (l += e.max);
            }
            const c = [
                ...r.shadowDirection
            ];
            c[2] = -c[2];
            const h = r.computeSimplifiedTileShadowVolume(a, l, n, c);
            if (!h) return !1;
            const u = [
                jr,
                Gr,
                Vr,
                c,
                [
                    c[0],
                    0,
                    c[2]
                ],
                [
                    0,
                    c[1],
                    c[2]
                ]
            ], d = "globe" === s.projection.name, _ = s.scaleZoom(n), p = e.bR.fromInvProjectionMatrix(s.invProjMatrix, s.worldSize, _, !d), f = r.getCurrentCascadeFrustum();
            return 0 === p.intersectsPrecise(h.vertices, h.planes, u) || 0 === f.intersectsPrecise(h.vertices, h.planes, u);
        }
        function Hr(t1) {
            return [
                t1[0] * e.d9,
                t1[1] * e.d9,
                t1[2] * e.d9,
                0
            ];
        }
        function Zr(t1, i, o, s, r, a, n, l, c) {
            const h = s.getSource(), u = o.globeSharedBuffers;
            if (!u) return;
            let d, _, p;
            if (i && (d = s.getTile(i)), h instanceof e.aJ ? (_ = h.texture, p = e.cI(0, 0, o.transform)) : d && i && (_ = d.texture, p = e.cI(i.canonical.z, i.canonical.x, o.transform)), !_ || !p) return;
            t1 || (p = e.ab.mat4.scale(e.ab.mat4.create(), p, [
                1,
                -1,
                1
            ]));
            const f = o.context, m = f.gl, g = "nearest" === r.paint.get("raster-resampling") ? m.NEAREST : m.LINEAR, v = o.colorModeForDrapableLayerRenderPass(a), y = n.defines;
            y.push("GLOBE_POLES");
            const x = new Bi(m.LEQUAL, Bi.ReadWrite, o.depthRangeFor3D), b = Float32Array.from(o.transform.expandedFarZProjMatrix), w = Float32Array.from(e.bb(e.cH(new e.bT(0, 0, 0))));
            o.terrain && o.terrain.prepareDrawTile(), f.activeTexture.set(m.TEXTURE0), _.bind(g, m.CLAMP_TO_EDGE), f.activeTexture.set(m.TEXTURE1), _.bind(g, m.CLAMP_TO_EDGE), _.useMipmap && f.extTextureFilterAnisotropic && o.transform.pitch > 20 && m.texParameterf(m.TEXTURE_2D, f.extTextureFilterAnisotropic.TEXTURE_MAX_ANISOTROPY_EXT, f.extTextureFilterAnisotropicMax);
            const [T, E, S, C] = i ? u.getPoleBuffers(i.canonical.z, !1) : u.getPoleBuffers(0, !0), I = r.paint.get("raster-elevation");
            let R;
            t1 ? (R = T, o.renderDefaultNorthPole = 0 !== I) : (R = E, o.renderDefaultSouthPole = 0 !== I);
            const D = Hr(n.mix), L = ((e, t1, i, o, s, r, a, n, l, c, h, u, d)=>hr(e, t1, i, new Float32Array(16), new Float32Array(9), [
                    0,
                    0
                ], o, [
                    0,
                    0
                ], [
                    0,
                    0,
                    0,
                    0
                ], 1, {
                    opacity: 1,
                    mix: 0
                }, r, [
                    0,
                    0
                ], n, 2, c, h, u, 1, 0, d))(b, w, p, e.ae(o.transform.zoom), 0, r, 0, I, 0, D, n.offset, n.range, a), A = o.getOrCreateProgram("raster", {
                defines: y
            });
            o.uploadCommonUniforms(f, A, null), A.draw(o, m.TRIANGLES, x, c, v, l, L, r.id, R, S, C);
        }
        function Wr(e) {
            const t1 = e._nearZ, i = e.projection.farthestPixelDistance(e), o = i - t1, s = .2 * e.height, r = t1 + s;
            return [
                t1,
                i,
                (r - s - t1) / o,
                (r - t1) / o
            ];
        }
        function $r(e, t1, i, o) {
            if (e) return t1 instanceof ot && e instanceof wt ? t1.getTextureDescriptor(e, i, !0) : {
                texture: e.texture,
                mix: Hr(o.mix),
                offset: o.offset,
                buffer: 0,
                tileSize: 1
            };
        }
        var Xr = e.da([
            {
                name: "a_index",
                type: "Int16",
                components: 1
            }
        ]);
        class Kr {
            updateParticleTexture(t1, i) {
                if (this.particleTextureDimension === i.width) return;
                (this.particleTexture0 || this.particleTexture1 || this.particleIndexBuffer || this.particleSegment) && (this.particleTexture0.destroy(), this.particleTexture1.destroy(), this.particleIndexBuffer.destroy(), this.particleSegment.destroy());
                const o = this.context.gl, s = i.width * i.height;
                this.particleTexture0 = new e.T(this.context, i, o.RGBA8, {
                    premultiply: !1,
                    useMipmap: !1
                }), this.particleTexture1 = new e.T(this.context, i, o.RGBA8, {
                    premultiply: !1,
                    useMipmap: !1
                });
                const r = new e.db;
                r.reserve(s);
                for(let e = 0; e < s; e++)r.emplaceBack(e);
                this.particleIndexBuffer = this.context.createVertexBuffer(r, Xr.members, !0), this.particleSegment = e.b7.simpleSegment(0, 0, this.particleIndexBuffer.length, 0), this.particleTextureDimension = i.width;
            }
            update(t1) {
                return !(this.lastInvalidatedAt < t1 && (this.lastInvalidatedAt = e.q.now(), 1));
            }
            destroy() {
                this.targetColorTexture.destroy(), this.backgroundColorTexture.destroy(), this.particleIndexBuffer.destroy(), this.particleTexture0.destroy(), this.particleTexture1.destroy(), this.particleSegment.destroy();
            }
            constructor(t1, i, o, s){
                const r = {
                    width: o[0],
                    height: o[1],
                    data: null
                }, a = t1.gl;
                this.targetColorTexture = new e.T(t1, r, a.RGBA8, {
                    useMipmap: !1
                }), this.backgroundColorTexture = new e.T(t1, r, a.RGBA8, {
                    useMipmap: !1
                }), this.context = t1, this.updateParticleTexture(i, s), this.lastInvalidatedAt = 0;
            }
        }
        function Yr(t1, i, o) {
            if (!t1) return null;
            const s = i.getTextureDescriptor(t1, o, !0);
            if (!s) return null;
            let { texture: r, mix: a, offset: n, tileSize: l, buffer: c, format: h } = s;
            if (!r || !h) return null;
            let u = !1;
            return "uint32" === h && (u = !0, a[3] = 0, a = lr(e.dc, a, [
                0,
                o.paint.get("raster-particle-max-speed")
            ]), n = cr(e.dc, n, [
                0,
                o.paint.get("raster-particle-max-speed")
            ])), {
                texture: r,
                textureOffset: [
                    c / (l + 2 * c),
                    l / (l + 2 * c)
                ],
                tileSize: l,
                scalarData: u,
                scale: a,
                offset: n,
                defines: [
                    "RASTER_ARRAY",
                    {
                        uint8: "DATA_FORMAT_UINT8",
                        uint16: "DATA_FORMAT_UINT16",
                        uint32: "DATA_FORMAT_UINT32"
                    }[h]
                ]
            };
        }
        function Jr(e) {
            const t1 = e._nearZ, i = e.projection.farthestPixelDistance(e), o = i - t1, s = .2 * e.height, r = t1 + s;
            return [
                t1,
                i,
                (r - s - t1) / o,
                (r - t1) / o
            ];
        }
        const Qr = new e.aj(1, 0, 0, 1), ea = new e.aj(0, 1, 0, 1), ta = new e.aj(0, 0, 1, 1), ia = new e.aj(1, 0, 1, 1), oa = new e.aj(0, 1, 1, 1);
        function sa(t1, i, o, s, r, a, n) {
            const l = t1.context, c = t1.transform, h = l.gl, u = "globe" === c.projection.name, d = u ? [
                "PROJECTION_GLOBE_VIEW"
            ] : [];
            let _ = e.ab.mat4.clone(o.projMatrix);
            if (u && e.ae(c.zoom) > 0) {
                const t1 = e.ba(o.canonical, c), i = e.dd(t1);
                _ = e.ab.mat4.multiply(new Float32Array(16), c.globeMatrix, i), e.ab.mat4.multiply(_, c.projMatrix, _);
            }
            const p = e.ab.mat4.create();
            p[12] += 2 * r / (e.q.devicePixelRatio * c.width), p[13] += 2 * a / (e.q.devicePixelRatio * c.height), e.ab.mat4.multiply(_, p, _);
            const f = t1.getOrCreateProgram("debug", {
                defines: d
            }), m = i.getTileByID(o.key);
            t1.terrain && t1.terrain.setupElevationDraw(m, f);
            const g = Bi.disabled, v = Ui.disabled, y = t1.colorModeForRenderPass(), x = "$debug";
            l.activeTexture.set(h.TEXTURE0), t1.emptyTexture.bind(h.LINEAR, h.CLAMP_TO_EDGE), u ? m._makeGlobeTileDebugBuffers(t1.context, c) : m._makeDebugTileBoundsBuffers(t1.context, c.projection);
            const b = m._tileDebugBuffer || t1.debugBuffer, w = m._tileDebugIndexBuffer || t1.debugIndexBuffer, T = m._tileDebugSegments || t1.debugSegments;
            if (f.draw(t1, h.LINE_STRIP, g, v, y, Vi.disabled, rr(_, s), x, b, w, T, null, null, null, [
                m._globeTileDebugBorderBuffer
            ]), n) {
                const e = m.latestRawTileData, i = Math.floor((e && e.byteLength || 0) / 1024);
                let s = o.canonical.toString();
                o.overscaledZ !== o.canonical.z && (s += ` => ${o.overscaledZ}`), s += ` ${m.state}`, s += ` ${i}kb`, function(e, t1) {
                    e.initDebugOverlayCanvas();
                    const i = e.debugOverlayCanvas, o = e.context.gl, s = e.debugOverlayCanvas.getContext("2d");
                    s.clearRect(0, 0, i.width, i.height), s.shadowColor = "white", s.shadowBlur = 2, s.lineWidth = 1.5, s.strokeStyle = "white", s.textBaseline = "top", s.font = "bold 36px Open Sans, sans-serif", s.fillText(t1, 5, 5), s.strokeText(t1, 5, 5), e.debugOverlayTexture.update(i), e.debugOverlayTexture.bind(o.LINEAR, o.CLAMP_TO_EDGE);
                }(t1, s);
            }
            const E = i.getTile(o).tileSize, S = 512 / Math.min(E, 512) * (o.overscaledZ / c.zoom) * .5, C = m._tileDebugTextBuffer || t1.debugBuffer, I = m._tileDebugTextIndexBuffer || t1.quadTriangleIndexBuffer, R = m._tileDebugTextSegments || t1.debugSegments;
            f.draw(t1, h.TRIANGLES, g, v, ki.alphaBlended, Vi.disabled, rr(_, e.aj.transparent, S), x, C, I, R, null, null, null, [
                m._globeTileDebugTextBuffer
            ]);
        }
        function ra(e, t1, i, o) {
            na(e, 0, t1 + i / 2, e.transform.width, i, o);
        }
        function aa(e, t1, i, o) {
            na(e, t1 - i / 2, 0, i, e.transform.height, o);
        }
        function na(t1, i, o, s, r, a) {
            const n = t1.context, l = n.gl;
            l.enable(l.SCISSOR_TEST), l.scissor(i * e.q.devicePixelRatio, o * e.q.devicePixelRatio, s * e.q.devicePixelRatio, r * e.q.devicePixelRatio), n.clear({
                color: a
            }), l.disable(l.SCISSOR_TEST);
        }
        const la = e.da([
            {
                name: "a_pos_3f",
                components: 3,
                type: "Float32"
            }
        ]), { members: ca } = la;
        function ha(e, t1, i, o) {
            e.emplaceBack(t1, i, o);
        }
        class ua {
            constructor(t1){
                this.vertexArray = new e.de, this.indices = new e.aU, ha(this.vertexArray, -1, -1, 1), ha(this.vertexArray, 1, -1, 1), ha(this.vertexArray, -1, 1, 1), ha(this.vertexArray, 1, 1, 1), ha(this.vertexArray, -1, -1, -1), ha(this.vertexArray, 1, -1, -1), ha(this.vertexArray, -1, 1, -1), ha(this.vertexArray, 1, 1, -1), this.indices.emplaceBack(5, 1, 3), this.indices.emplaceBack(3, 7, 5), this.indices.emplaceBack(6, 2, 0), this.indices.emplaceBack(0, 4, 6), this.indices.emplaceBack(2, 6, 7), this.indices.emplaceBack(7, 3, 2), this.indices.emplaceBack(5, 4, 0), this.indices.emplaceBack(0, 1, 5), this.indices.emplaceBack(0, 2, 3), this.indices.emplaceBack(3, 1, 0), this.indices.emplaceBack(7, 6, 4), this.indices.emplaceBack(4, 5, 7), this.vertexBuffer = t1.createVertexBuffer(this.vertexArray, ca), this.indexBuffer = t1.createIndexBuffer(this.indices), this.segment = e.b7.simpleSegment(0, 0, 36, 12);
            }
        }
        function da(t1, i, o, s, r, a) {
            const n = t1.context.gl, l = i.paint.get("sky-atmosphere-color"), c = i.paint.get("sky-atmosphere-halo-color"), h = i.paint.get("sky-atmosphere-sun-intensity"), u = ((e, t1, i, o, s)=>({
                    u_matrix_3f: e,
                    u_sun_direction: t1,
                    u_sun_intensity: i,
                    u_color_tint_r: [
                        o.r,
                        o.g,
                        o.b,
                        o.a
                    ],
                    u_color_tint_m: [
                        s.r,
                        s.g,
                        s.b,
                        s.a
                    ],
                    u_luminance: 5e-5
                }))(e.ab.mat3.fromMat4(e.ab.mat3.create(), s), r, h, l, c);
            n.framebufferTexture2D(n.FRAMEBUFFER, n.COLOR_ATTACHMENT0, n.TEXTURE_CUBE_MAP_POSITIVE_X + a, i.skyboxTexture, 0), o.draw(t1, n.TRIANGLES, Bi.disabled, Ui.disabled, ki.unblended, Vi.frontCW, u, "skyboxCapture", i.skyboxGeometry.vertexBuffer, i.skyboxGeometry.indexBuffer, i.skyboxGeometry.segment);
        }
        const _a = e.da([
            {
                type: "Float32",
                name: "a_pos",
                components: 3
            },
            {
                type: "Float32",
                name: "a_uv",
                components: 2
            }
        ]);
        class pa {
            destroy() {
                this.vertexBuffer.destroy(), this.indexBuffer.destroy(), this.segments.destroy();
            }
            constructor(t1){
                const i = new e.df;
                i.emplaceBack(-1, 1, 1, 0, 0), i.emplaceBack(1, 1, 1, 1, 0), i.emplaceBack(1, -1, 1, 1, 1), i.emplaceBack(-1, -1, 1, 0, 1);
                const o = new e.aU;
                o.emplaceBack(0, 1, 2), o.emplaceBack(2, 3, 0), this.vertexBuffer = t1.createVertexBuffer(i, _a.members), this.indexBuffer = t1.createIndexBuffer(o), this.segments = e.b7.simpleSegment(0, 0, 4, 2);
            }
        }
        const fa = e.da([
            {
                type: "Float32",
                name: "a_pos_3f",
                components: 3
            },
            {
                type: "Float32",
                name: "a_uv",
                components: 2
            },
            {
                type: "Float32",
                name: "a_size_scale",
                components: 1
            },
            {
                type: "Float32",
                name: "a_fade_opacity",
                components: 1
            }
        ]);
        class ma {
            constructor(){
                this.starsCount = 16e3, this.sizeMultiplier = .15, this.sizeRange = 100, this.intensityRange = 200;
            }
        }
        class ga {
            update(t1) {
                const i = t1.context;
                if (!this.atmosphereBuffer || this.updateNeeded) {
                    this.updateNeeded = !1, this.atmosphereBuffer = new pa(i);
                    const t1 = this.params.sizeRange, o = this.params.intensityRange, s = function(t1) {
                        const i = e.di(30), o = [];
                        for(let s = 0; s < t1; ++s){
                            const t1 = 2 * Math.PI * i(), s = Math.acos(1 - 2 * i()) - .5 * Math.PI;
                            o.push(e.ab.vec3.fromValues(Math.cos(s) * Math.cos(t1), Math.cos(s) * Math.sin(t1), Math.sin(s)));
                        }
                        return o;
                    }(this.params.starsCount), r = e.di(300), a = new e.dg, n = new e.aU;
                    let l = 0;
                    for(let i = 0; i < s.length; ++i){
                        const c = e.ab.vec3.scale([], s[i], 200), h = Math.max(0, 1 + .01 * t1 * (1 * r() - .5)), u = Math.max(0, 1 + .01 * o * (1 * r() - .5));
                        a.emplaceBack(c[0], c[1], c[2], -1, -1, h, u), a.emplaceBack(c[0], c[1], c[2], 1, -1, h, u), a.emplaceBack(c[0], c[1], c[2], 1, 1, h, u), a.emplaceBack(c[0], c[1], c[2], -1, 1, h, u), n.emplaceBack(l + 0, l + 1, l + 2), n.emplaceBack(l + 0, l + 2, l + 3), l += 4;
                    }
                    this.starsVx = i.createVertexBuffer(a, fa.members), this.starsIdx = i.createIndexBuffer(n), this.starsSegments = e.b7.simpleSegment(0, 0, a.length, n.length);
                }
            }
            destroy() {
                this.atmosphereBuffer && this.atmosphereBuffer.destroy(), this.starsVx && this.starsVx.destroy(), this.starsIdx && this.starsIdx.destroy();
            }
            drawAtmosphereGlow(t1, i) {
                const o = t1.context, s = o.gl, r = t1.transform, a = new Bi(s.LEQUAL, Bi.ReadOnly, [
                    0,
                    1
                ]), n = e.ae(r.zoom), l = t1.style.getLut(i.scope), c = "none" === i.properties.get("color-use-theme"), h = i.properties.get("color").toRenderColor(c ? null : l).toArray01(), u = "none" === i.properties.get("high-color-use-theme"), d = i.properties.get("high-color").toRenderColor(u ? null : l).toArray01(), _ = "none" === i.properties.get("space-color-use-theme"), p = i.properties.get("space-color").toRenderColor(_ ? null : l).toArray01PremultipliedAlpha(), f = 5e-4, m = e.dh(i.properties.get("horizon-blend"), 0, 1, f, .25), g = e.cC(t1, o, r) && m === f ? r.worldSize / (2 * Math.PI * 1.025) - 1 : r.globeRadius, v = t1.frameCounter / 1e3 % 1, y = e.ab.vec3.length(r.globeCenterInViewSpace), x = Math.sqrt(Math.pow(y, 2) - Math.pow(g, 2)), b = Math.acos(x / y), w = (e)=>{
                    const i = "globe" === r.projection.name ? [
                        "PROJECTION_GLOBE_VIEW",
                        "FOG"
                    ] : [
                        "FOG"
                    ];
                    e && i.push("ALPHA_PASS");
                    const l = t1.getOrCreateProgram("globeAtmosphere", {
                        defines: i
                    }), c = ((e, t1, i, o, s, r, a, n, l, c, h, u)=>({
                            u_frustum_tl: e,
                            u_frustum_tr: t1,
                            u_frustum_br: i,
                            u_frustum_bl: o,
                            u_horizon: s,
                            u_transition: r,
                            u_fadeout_range: a,
                            u_color: n,
                            u_high_color: l,
                            u_space_color: c,
                            u_temporal_offset: h,
                            u_horizon_angle: u
                        }))(r.frustumCorners.TL, r.frustumCorners.TR, r.frustumCorners.BR, r.frustumCorners.BL, r.frustumCorners.horizon, n, m, h, d, p, v, b);
                    t1.uploadCommonUniforms(o, l);
                    const u = this.atmosphereBuffer;
                    u && l.draw(t1, s.TRIANGLES, a, Ui.disabled, e ? this.colorModeWriteAlpha : this.colorModeAlphaBlendedWriteRGB, Vi.backCW, c, e ? "atmosphere_glow_alpha" : "atmosphere_glow", u.vertexBuffer, u.indexBuffer, u.segments);
                };
                w(!1), w(!0);
            }
            drawStars(t1, i) {
                const o = e.aw(i.properties.get("star-intensity"), 0, 1);
                if (0 === o) return;
                const s = t1.context, r = s.gl, a = t1.transform, n = t1.getOrCreateProgram("stars"), l = e.ab.quat.identity([]);
                e.ab.quat.rotateX(l, l, -a._pitch), e.ab.quat.rotateZ(l, l, -a.angle), e.ab.quat.rotateX(l, l, e.ai(a._center.lat)), e.ab.quat.rotateY(l, l, -e.ai(a._center.lng));
                const c = e.ab.mat4.fromQuat(new Float32Array(16), l), h = e.ab.mat4.multiply([], a.starsProjMatrix, c), u = e.ab.mat3.fromMat4([], c), d = e.ab.mat3.invert([], u), _ = [
                    0,
                    1,
                    0
                ];
                e.ab.vec3.transformMat3(_, _, d), e.ab.vec3.scale(_, _, this.params.sizeMultiplier);
                const p = [
                    1,
                    0,
                    0
                ];
                e.ab.vec3.transformMat3(p, p, d), e.ab.vec3.scale(p, p, this.params.sizeMultiplier);
                const f = (m = _, g = p, v = o, {
                    u_matrix: Float32Array.from(h),
                    u_up: m,
                    u_right: g,
                    u_intensity_multiplier: v
                });
                var m, g, v;
                t1.uploadCommonUniforms(s, n), this.starsVx && this.starsIdx && n.draw(t1, r.TRIANGLES, Bi.disabled, Ui.disabled, this.colorModeAlphaBlendedWriteRGB, Vi.disabled, f, "atmosphere_stars", this.starsVx, this.starsIdx, this.starsSegments);
            }
            constructor(t1){
                this.colorModeAlphaBlendedWriteRGB = new ki([
                    1,
                    Fi,
                    1,
                    Fi
                ], e.aj.transparent, [
                    !0,
                    !0,
                    !0,
                    !1
                ]), this.colorModeWriteAlpha = new ki([
                    1,
                    0,
                    1,
                    0
                ], e.aj.transparent, [
                    !1,
                    !1,
                    !1,
                    !0
                ]), this.params = new ma, this.updateNeeded = !0, t1.tp.registerParameter(this.params, [
                    "Stars"
                ], "starsCount", {
                    min: 100,
                    max: 16e3,
                    step: 1
                }, ()=>{
                    this.updateNeeded = !0;
                }), t1.tp.registerParameter(this.params, [
                    "Stars"
                ], "sizeMultiplier", {
                    min: .01,
                    max: 2,
                    step: .01
                }), t1.tp.registerParameter(this.params, [
                    "Stars"
                ], "sizeRange", {
                    min: 0,
                    max: 200,
                    step: 1
                }, ()=>{
                    this.updateNeeded = !0;
                }), t1.tp.registerParameter(this.params, [
                    "Stars"
                ], "intensityRange", {
                    min: 0,
                    max: 200,
                    step: 1
                }, ()=>{
                    this.updateNeeded = !0;
                });
            }
        }
        function va(t1, i) {
            const o = [
                ...t1
            ], s = i.cameraWorldSizeForFog / i.worldSize, r = e.ab.mat4.identity([]);
            return e.ab.mat4.scale(r, r, [
                s,
                s,
                1
            ]), e.ab.mat4.multiply(o, r, o), e.ab.mat4.multiply(o, i.worldToFogMatrix, o), o;
        }
        function ya(t1, i, o, s, r) {
            const a = o.material, n = s.context, { baseColorTexture: l, metallicRoughnessTexture: c } = a.pbrMetallicRoughness, { normalTexture: h, occlusionTexture: u, emissionTexture: d } = a;
            function _(e, i, o) {
                if (e && (t1.push(i), n.activeTexture.set(n.gl.TEXTURE0 + o), e.gfxTexture)) {
                    const { minFilter: t1, magFilter: i, wrapS: o, wrapT: s } = e.sampler;
                    e.gfxTexture.bindExtraParam(t1, i, o, s);
                }
            }
            _(l, "HAS_TEXTURE_u_baseColorTexture", Xi.BaseColor), _(c, "HAS_TEXTURE_u_metallicRoughnessTexture", Xi.MetallicRoughness), _(h, "HAS_TEXTURE_u_normalTexture", Xi.Normal), _(u, "HAS_TEXTURE_u_occlusionTexture", Xi.Occlusion), _(d, "HAS_TEXTURE_u_emissionTexture", Xi.Emission), r && (r.texture || (r.texture = new e.dk(s.context, r.image, [
                r.image.height,
                r.image.height,
                r.image.height
            ], n.gl.RGBA8)), n.activeTexture.set(n.gl.TEXTURE0 + Xi.LUT), r.texture && r.texture.bind(n.gl.LINEAR, n.gl.CLAMP_TO_EDGE), t1.push("APPLY_LUT_ON_GPU")), o.texcoordBuffer && (t1.push("HAS_ATTRIBUTE_a_uv_2f"), i.push(o.texcoordBuffer)), o.colorBuffer && (t1.push(12 === o.colorBuffer.itemSize ? "HAS_ATTRIBUTE_a_color_3f" : "HAS_ATTRIBUTE_a_color_4f"), i.push(o.colorBuffer)), o.normalBuffer && (t1.push("HAS_ATTRIBUTE_a_normal_3f"), i.push(o.normalBuffer)), o.pbrBuffer && (t1.push("HAS_ATTRIBUTE_a_pbr"), t1.push("HAS_ATTRIBUTE_a_heightBasedEmissiveStrength"), i.push(o.pbrBuffer)), "OPAQUE" !== a.alphaMode && "MASK" !== a.alphaMode || t1.push("UNPREMULT_TEXTURE_IN_SHADER"), a.defined || t1.push("DIFFUSE_SHADED");
            const p = s.shadowRenderer;
            p && (t1.push("RENDER_SHADOWS", "DEPTH_TEXTURE"), p.useNormalOffset && t1.push("NORMAL_OFFSET"));
        }
        function xa(t1, i, o, s, r, a) {
            const n = o.paint.get("model-opacity").constantOr(1), l = i.context, c = new Bi(i.context.gl.LEQUAL, Bi.ReadWrite, i.depthRangeFor3D), h = i.transform, u = t1.mesh, d = u.material, _ = d.pbrMetallicRoughness, p = i.style.fog;
            let f;
            f = "pixels" === i.transform.projection.zAxisUnit ? [
                ...t1.nodeModelMatrix
            ] : e.ab.mat4.multiply([], s.zScaleMatrix, t1.nodeModelMatrix), e.ab.mat4.multiply(f, s.negCameraPosMatrix, f);
            const m = e.ab.mat4.invert([], f);
            e.ab.mat4.transpose(m, m);
            const g = "none" === o.paint.get("model-color-use-theme").constantOr("default"), v = o.paint.get("model-emissive-strength").constantOr(0), y = br(new Float32Array(t1.worldViewProjection), new Float32Array(f), new Float32Array(m), null, i, n, _.baseColorFactor.toRenderColor(null), d.emissiveFactor, _.metallicFactor, _.roughnessFactor, d, v, o), x = {
                defines: []
            }, b = [], w = i.shadowRenderer;
            w && (w.useNormalOffset = !1), ya(x.defines, b, u, i, g ? null : o.lut);
            let T = null;
            if (p) {
                const e = va(t1.nodeModelMatrix, i.transform);
                if (T = new Float32Array(e), "globe" !== h.projection.name) {
                    const t1 = u.aabb.min, i = u.aabb.max, [o, s] = p.getOpacityForBounds(e, t1[0], t1[1], i[0], i[1]);
                    x.overrideFog = o >= Fe || s >= Fe;
                }
            }
            const E = eo(i, o.paint.get("model-cutoff-fade-range"));
            E.shouldRenderCutoff && x.defines.push("RENDER_CUTOFF");
            const S = i.getOrCreateProgram("model", x);
            i.uploadCommonUniforms(l, S, null, T, E), "shadow" !== i.renderPass && w && w.setupShadowsFromMatrix(t1.nodeModelMatrix, S), S.draw(i, l.gl.TRIANGLES, c, r, a, u.material.doubleSided ? Vi.disabled : Vi.backCCW, y, o.id, u.vertexBuffer, u.indexBuffer, u.segments, o.paint, i.transform.zoom, void 0, b);
        }
        function ba(t1, i, o, s, r, a, n) {
            let l;
            l = "globe" === t1.projection.name ? e.dl(o, t1) : [
                ...o
            ], e.ab.mat4.multiply(l, l, i.matrix);
            const c = e.ab.mat4.multiply([], s, l);
            if (i.meshes) for (const o of i.meshes){
                if ("BLEND" !== o.material.alphaMode) {
                    n.push({
                        mesh: o,
                        depth: 0,
                        modelIndex: r,
                        worldViewProjection: c,
                        nodeModelMatrix: l
                    });
                    continue;
                }
                const i = e.ab.vec3.transformMat4([], o.centroid, c);
                !t1.isOrthographic && i[2] <= 0 || a.push({
                    mesh: o,
                    depth: i[2],
                    modelIndex: r,
                    worldViewProjection: c,
                    nodeModelMatrix: l
                });
            }
            if (i.children) for (const e of i.children)ba(t1, e, o, s, r, a, n);
        }
        function wa(e, t1, i, o) {
            const s = i.shadowRenderer;
            if (!s) return;
            const r = s.getShadowPassDepthMode(), a = s.getShadowPassColorMode(), n = s.calculateShadowPassMatrixFromMatrix(t1), l = wr(n);
            i.getOrCreateProgram("modelDepth", {
                defines: i._shadowMapDebug ? [] : [
                    "DEPTH_TEXTURE"
                ]
            }).draw(i, i.context.gl.TRIANGLES, r, Ui.disabled, a, Vi.backCCW, l, o.id, e.vertexBuffer, e.indexBuffer, e.segments, o.paint, i.transform.zoom, void 0, void 0);
        }
        function Ta(t1, i, o) {
            const s = i.updateZoomBasedPaintProperties(), r = function(t1, i, o) {
                let s, r, a, n = t1.terrain ? t1.terrain.exaggeration() : 0;
                if (t1.terrain && n > 0) {
                    const i = t1.terrain, r = i.findDEMTileFor(o);
                    r && r.dem ? s = e.dn.create(i, o, r) : n = 0;
                }
                if (0 === n && (i.terrainElevationMin = 0, i.terrainElevationMax = 0), n === i.validForExaggeration && (0 === n || s && s._demTile && s._demTile.tileID === i.validForDEMTile.id && s._dem._timestamp === i.validForDEMTile.timestamp)) return !1;
                for(const e in i.instancesPerModel){
                    const t1 = i.instancesPerModel[e];
                    for(let e = 0; e < t1.instancedDataArray.length; ++e){
                        const o = (s ? n * s.getElevationAt(0 | t1.instancedDataArray.float32[16 * e], 0 | t1.instancedDataArray.float32[16 * e + 1], !0, !0) : 0) + t1.instancesEvaluatedElevation[e];
                        t1.instancedDataArray.float32[16 * e + 6] = o, r = r ? Math.min(i.terrainElevationMin, o) : o, a = a ? Math.max(i.terrainElevationMax, o) : o;
                    }
                }
                return i.terrainElevationMin = r || 0, i.terrainElevationMax = a || 0, i.validForExaggeration = n, i.validForDEMTile = s && s._demTile ? {
                    id: s._demTile.tileID,
                    timestamp: s._dem._timestamp
                } : {
                    id: void 0,
                    timestamp: 0
                }, !0;
            }(t1, i, o);
            (s || r) && (i.uploaded = !1, i.upload(t1.context));
        }
        const Ea = {
            shadowUniformsInitialized: !1,
            useSingleShadowCascade: !1,
            tileMatrix: new Float64Array(16),
            shadowTileMatrix: new Float32Array(16),
            aabb: new e.cd([
                0,
                0,
                0
            ], [
                e.ag,
                e.ag,
                0
            ])
        };
        function Sa(t1, i) {
            const o = 1 << t1.canonical.z, s = i.getFreeCameraOptions().position, r = i.elevation, a = t1.canonical.x / o, n = (t1.canonical.x + 1) / o, l = t1.canonical.y / o, c = (t1.canonical.y + 1) / o;
            let h = i._centerAltitude;
            if (r) {
                const e = r.getMinMaxForTile(t1);
                e && e.max > h && (h = e.max);
            }
            const u = e.aw(s.x, a, n) - s.x, d = e.aw(s.y, l, c) - s.y, _ = e.bH(h, i.center.lat) - s.z;
            return i._zoomFromMercatorZ(Math.sqrt(u * u + d * d + _ * _));
        }
        function Ca(e, t1, i, o, s, r, a) {
            const n = e.context, l = "shadow" === e.renderPass, c = e.shadowRenderer, h = l && c ? c.getShadowPassDepthMode() : new Bi(n.gl.LEQUAL, Bi.ReadWrite, e.depthRangeFor3D), u = e.isTileAffectedByFog(r);
            if (i.meshes) for (const d of i.meshes){
                const _ = [
                    "MODEL_POSITION_ON_GPU"
                ], p = [];
                let f, m, g;
                o.instancedDataArray.length > 20 && _.push("INSTANCED_ARRAYS");
                const v = eo(e, t1.paint.get("model-cutoff-fade-range"));
                if (v.shouldRenderCutoff && _.push("RENDER_CUTOFF"), l && c) f = e.getOrCreateProgram("modelDepth", {
                    defines: _
                }), m = wr(a.shadowTileMatrix, a.shadowTileMatrix, Float32Array.from(i.matrix)), g = c.getShadowPassColorMode();
                else {
                    ya(_, p, d, e, "none" === t1.paint.get("model-color-use-theme").constantOr("default") ? null : t1.lut), f = e.getOrCreateProgram("model", {
                        defines: _,
                        overrideFog: u
                    });
                    const o = d.material, l = o.pbrMetallicRoughness, h = t1.paint.get("model-opacity").constantOr(1), y = t1.paint.get("model-emissive-strength").constantOr(0);
                    m = br(r.expandedProjMatrix, Float32Array.from(i.matrix), new Float32Array(16), null, e, h, l.baseColorFactor.toRenderColor(null), o.emissiveFactor, l.metallicFactor, l.roughnessFactor, o, y, t1, s), c && (a.shadowUniformsInitialized ? f.setShadowUniformValues(n, c.getShadowUniformValues()) : (c.setupShadows(r.toUnwrapped(), f, "model-tile", r.overscaledZ), a.shadowUniformsInitialized = !0)), g = v.shouldRenderCutoff || h < 1 || "OPAQUE" !== o.alphaMode ? ki.alphaBlended : ki.unblended;
                }
                e.uploadCommonUniforms(n, f, r.toUnwrapped(), null, v);
                const y = d.material.doubleSided ? Vi.disabled : Vi.backCCW;
                if (o.instancedDataArray.length > 20) p.push(o.instancedDataBuffer), f.draw(e, n.gl.TRIANGLES, h, Ui.disabled, g, y, m, t1.id, d.vertexBuffer, d.indexBuffer, d.segments, t1.paint, e.transform.zoom, void 0, p, o.instancedDataArray.length);
                else {
                    const i = l ? "u_instance" : "u_normal_matrix";
                    for(let s = 0; s < o.instancedDataArray.length; ++s)m[i] = new Float32Array(o.instancedDataArray.arrayBuffer, 64 * s, 16), f.draw(e, n.gl.TRIANGLES, h, Ui.disabled, g, y, m, t1.id, d.vertexBuffer, d.indexBuffer, d.segments, t1.paint, e.transform.zoom, void 0, p);
                }
            }
            if (i.children) for (const n of i.children)Ca(e, t1, n, o, s, r, a);
        }
        const Ia = [
            1,
            -1,
            1
        ];
        function Ra(t1, i, o, s) {
            if (!o.modelManager) return !0;
            const r = o.modelManager;
            if (!o.shadowRenderer) return !0;
            const a = o.shadowRenderer, n = i.aabb;
            let l = !0, c = t1.maxHeight;
            if (0 === c) {
                let e = 0;
                for(const i in t1.instancesPerModel){
                    const t1 = r.getModel(i, s);
                    t1 ? e = Math.max(e, Math.max(Math.max(t1.aabb.max[0], t1.aabb.max[1]), t1.aabb.max[2])) : l = !1;
                }
                c = t1.maxScale * e * 1.41 + t1.maxVerticalOffset, l && (t1.maxHeight = c);
            }
            n.max[2] = c, n.min[2] += t1.terrainElevationMin, n.max[2] += t1.terrainElevationMax, e.ab.vec3.transformMat4(n.min, n.min, i.tileMatrix), e.ab.vec3.transformMat4(n.max, n.max, i.tileMatrix);
            const h = n.intersects(a.getCurrentCascadeFrustum());
            return 0 === o.currentShadowCascade && (t1.isInsideFirstShadowMapFrustum = 2 === h), 0 === h;
        }
        function Da(t1, i) {
            const o = t1.uniformValues.u_cutoff_params[0], s = t1.uniformValues.u_cutoff_params[1], r = t1.uniformValues.u_cutoff_params[2], a = t1.uniformValues.u_cutoff_params[3];
            return s === o || a === r ? 1 : e.aw(((i - o) / (s - o) - r) / (a - r), 0, 1);
        }
        function La(t1, i, o, s) {
            if (i.pitch < 20) return 1;
            const r = i.getWorldToCameraMatrix();
            e.ab.mat4.multiply(r, r, t1);
            const a = e.ab.vec4.fromValues(o.min[0], o.min[1], o.min[2], 1);
            let n = e.ab.vec4.transformMat4(e.ab.vec4.create(), a, r), l = n, c = n;
            a[1] = o.max[1], n = e.ab.vec4.transformMat4(e.ab.vec4.create(), a, r), l = n[1] < l[1] ? n : l, c = n[1] > c[1] ? n : c, a[0] = o.max[0], n = e.ab.vec4.transformMat4(e.ab.vec4.create(), a, r), l = n[1] < l[1] ? n : l, c = n[1] > c[1] ? n : c, a[1] = o.min[1], n = e.ab.vec4.transformMat4(e.ab.vec4.create(), a, r), l = n[1] < l[1] ? n : l, c = n[1] > c[1] ? n : c;
            const h = e.aw(s[0], 0, 1), u = 100 * i.pixelsPerMeter * e.aw(s[1], 0, 1), d = e.aw(s[2], 0, 1), _ = e.ab.vec4.lerp(e.ab.vec4.create(), l, c, h), p = Math.tan(.5 * i.fovX), f = -_[2] * p;
            if (0 === u) return _[1] < -Math.abs(f) ? d : 1;
            const m = (-Math.abs(f) - _[1]) / u, g = (e, t1, i)=>(1 - i) * e + i * t1, v = e.aw(g(1, d, m), d, 1);
            return g(1, v, e.aw((i.pitch - 20) / 20, 0, 1));
        }
        class Aa {
        }
        class za {
            getLinesFromTrianglesBuffer(t1, i, o) {
                {
                    const e = this._storage.get(i.id);
                    if (e) return e.lastUsedFrameIdx = t1, e.buf;
                }
                const s = o.gl, r = s.getBufferParameter(s.ELEMENT_ARRAY_BUFFER, s.BUFFER_SIZE), a = new ArrayBuffer(r), n = new Int16Array(a);
                s.getBufferSubData(s.ELEMENT_ARRAY_BUFFER, 0, new Int16Array(a));
                const l = new e.dq;
                for(let e = 0; e < r / 2; e += 3){
                    const t1 = n[e], i = n[e + 1], o = n[e + 2];
                    l.emplaceBack(t1, i), l.emplaceBack(i, o), l.emplaceBack(o, t1);
                }
                const c = o.bindVertexArrayOES.current, h = new Aa;
                return h.buf = new Er(o, l), h.lastUsedFrameIdx = t1, this._storage.set(i.id, h), o.bindVertexArrayOES.set(c), h.buf;
            }
            update(e) {
                for (const [t1, i] of this._storage)e - i.lastUsedFrameIdx > 30 && (i.buf.destroy(), this._storage.delete(t1));
            }
            destroy() {
                for (const [e, t1] of this._storage)t1.buf.destroy(), this._storage.delete(e);
            }
            constructor(){
                this._storage = new Map;
            }
        }
        class Pa {
            constructor(e){
                this.occluderSize = 30, this.depthOffset = -0.0001, e.registerParameter(this, [
                    "Occlusion"
                ], "occluderSize", {
                    min: 1,
                    max: 100,
                    step: 1
                }), e.registerParameter(this, [
                    "Occlusion"
                ], "depthOffset", {
                    min: -0.05,
                    max: 0,
                    step: 1e-5
                });
            }
        }
        const Ma = e.da([
            {
                type: "Float32",
                name: "a_pos_3f",
                components: 3
            },
            {
                type: "Float32",
                name: "a_uv",
                components: 2
            },
            {
                type: "Float32",
                name: "a_rainParticleData",
                components: 4
            }
        ]);
        class Oa {
            registerParameter() {}
            registerButton() {}
            registerBinding() {}
            refreshUI() {}
        }
        class Fa {
            constructor(e, t1){
                this.revealStart = 11, this.revealRange = 2, e.registerParameter(this, [
                    ...t1,
                    "Reveal"
                ], "revealStart", {
                    min: 0,
                    max: 17,
                    step: .05
                }), e.registerParameter(this, [
                    ...t1,
                    "Reveal"
                ], "revealRange", {
                    min: .1,
                    max: 5.1,
                    step: .05
                });
            }
        }
        const ka = e.da([
            {
                type: "Float32",
                name: "a_pos_2f",
                components: 2
            }
        ]);
        class Ba {
            destroy() {
                this.vignetteVx && this.vignetteVx.destroy(), this.vignetteIdx && this.vignetteIdx.destroy();
            }
            draw(t1, i) {
                const o = t1.getOrCreateProgram("vignette");
                if (!this.vignetteVx || !this.vignetteIdx) {
                    const i = new e.dr, o = new e.aU;
                    i.emplaceBack(-1, -1), i.emplaceBack(1, -1), i.emplaceBack(1, 1), i.emplaceBack(-1, 1), o.emplaceBack(0, 1, 2), o.emplaceBack(0, 2, 3), this.vignetteVx = t1.context.createVertexBuffer(i, ka.members), this.vignetteIdx = t1.context.createIndexBuffer(o);
                }
                const s = e.b7.simpleSegment(0, 0, 4, 6);
                if (this.vignetteVx && this.vignetteIdx) {
                    t1.uploadCommonUniforms(t1.context, o);
                    const e = {
                        u_vignetteShape: (r = {
                            vignetteShape: [
                                i.start,
                                i.range,
                                Math.pow(10, i.fadePower)
                            ],
                            vignetteColor: [
                                i.color.r,
                                i.color.g,
                                i.color.b,
                                i.color.a * i.strength
                            ]
                        }).vignetteShape,
                        u_vignetteColor: r.vignetteColor
                    };
                    o.draw(t1, t1.context.gl.TRIANGLES, Bi.disabled, Ui.disabled, ki.alphaBlended, Vi.disabled, e, "vignette", this.vignetteVx, this.vignetteIdx, s, {});
                }
                var r;
            }
        }
        class Na {
            update(t1, i) {
                const o = t1.getFreeCameraOptions().position, s = o.toAltitude(), r = o.toLngLat(), a = e.ai(r.lng), n = e.ai(r.lat), l = t1.pixelsPerMeter / i, c = a * e.ds, h = e.ds * Math.log(Math.tan(Math.PI / 4 + n / 2));
                if (void 0 === this._offsetXPrev) this._offsetXPrev = 0, this._offsetYPrev = 0, this._elevationPrev = 0, this._accumulatedOffsetX = 0, this._accumulatedOffsetY = 0, this._accumulatedElevation = 0;
                else {
                    const e = -this._offsetYPrev + h, t1 = -this._elevationPrev + s;
                    this._accumulatedOffsetX += (-this._offsetXPrev + c) * l, this._accumulatedOffsetY += e * l, this._accumulatedElevation += t1 * l, this._offsetXPrev = c, this._offsetYPrev = h, this._elevationPrev = s;
                }
            }
            getPosition() {
                return [
                    this._accumulatedOffsetX,
                    this._accumulatedOffsetY,
                    this._accumulatedElevation
                ];
            }
            constructor(){
                this._accumulatedOffsetX = 0, this._accumulatedOffsetY = 0, this._accumulatedElevation = 0;
            }
        }
        function Ua(e, t1) {
            return [
                -(e[0] - Math.floor(e[0] / t1) * t1),
                -(e[1] - Math.floor(e[1] / t1) * t1),
                -(e[2] - Math.floor(e[2] / t1) * t1)
            ];
        }
        function ja(t1) {
            const i = e.di(1323123451230), o = [];
            for(let s = 0; s < t1; ++s){
                const t1 = 2 * i() - 1, s = 2 * i() - 1, r = 2 * i() - 1;
                o.push(e.ab.vec3.fromValues(t1, s, r));
            }
            return o;
        }
        function Ga(t1, i, o, s, r) {
            const a = e.aw((r - o) / (s - o), 0, 1);
            return (1 - a) * t1 + a * i;
        }
        class Va {
            destroy() {
                this.particlesVx && this.particlesVx.destroy(), this.particlesIdx && this.particlesIdx.destroy(), this._vignette && this._vignette.destroy();
            }
            updateOnRender(t1, i) {
                const o = t1.transform;
                this._movement.update(o, this._ppmScaleFactor);
                const s = o.starsProjMatrix, r = e.ab.quat.identity([]);
                e.ab.quat.rotateX(r, r, e.ai(90) - o._pitch), e.ab.quat.rotateZ(r, r, -o.angle);
                const a = e.ab.mat4.fromQuat(new Float32Array(16), r), n = e.ab.mat4.fromValues(1, 0, 0, 0, 0, 0, 1, 0, 0, -1, 0, 0, 0, 0, 0, 1), l = e.ab.mat4.transpose([], n), c = e.ab.mat4.multiply([], l, a), h = Date.now() / 1e3;
                return this._accumulatedTimeFromStart += (h - this._prevTime) * i, this._prevTime = h, {
                    projectionMatrix: s,
                    modelviewMatrix: c
                };
            }
            constructor(e){
                this._movement = new Na, this._accumulatedTimeFromStart = 0, this._prevTime = Date.now() / 1e3, this._vignette = new Ba, this._ppmScaleFactor = e;
            }
        }
        class qa extends Va {
            update(t1) {
                const i = t1.context;
                if (!this.particlesVx) {
                    const t1 = ja(this.particlesCount), o = new e.dt, s = new e.aU;
                    let r = 0;
                    const a = e.di(1323123451230);
                    for(let e = 0; e < t1.length; ++e){
                        const i = t1[e], n = [
                            2 * a() - 1,
                            a(),
                            a(),
                            a()
                        ];
                        o.emplaceBack(i[0], i[1], i[2], -1, -1, ...n), o.emplaceBack(i[0], i[1], i[2], 1, -1, ...n), o.emplaceBack(i[0], i[1], i[2], 1, 1, ...n), o.emplaceBack(i[0], i[1], i[2], -1, 1, ...n), s.emplaceBack(r + 0, r + 1, r + 2), s.emplaceBack(r + 0, r + 2, r + 3), r += 4;
                    }
                    this.particlesVx = i.createVertexBuffer(o, Ma.members), this.particlesIdx = i.createIndexBuffer(s);
                }
            }
            draw(t1) {
                if (!this._params.overrideStyleParameters && !t1.style.rain) return;
                const i = this._params.overrideStyleParameters ? this._revealParams : {
                    revealStart: 0,
                    revealRange: .01
                }, o = t1.transform.zoom;
                if (i.revealStart > o) return;
                const s = Ga(0, 1, i.revealStart, i.revealStart + i.revealRange, o);
                if (!this.particlesVx || !this.particlesIdx) return;
                const r = structuredClone(this._params);
                let a = [
                    -r.direction.x,
                    r.direction.y,
                    -100
                ];
                e.ab.vec3.normalize(a, a);
                const n = structuredClone(this._vignetteParams);
                n.strength *= s, r.overrideStyleParameters || (r.intensity = t1.style.rain.state.density, r.timeFactor = t1.style.rain.state.intensity, r.color = structuredClone(t1.style.rain.state.color), a = structuredClone(t1.style.rain.state.direction), r.screenThinning.intensity = t1.style.rain.state.centerThinning, r.dropletSizeX = t1.style.rain.state.dropletSize[0], r.dropletSizeYScale = t1.style.rain.state.dropletSize[1] / t1.style.rain.state.dropletSize[0], r.distortionStrength = 100 * t1.style.rain.state.distortionStrength, n.strength = 1, n.color = structuredClone(t1.style.rain.state.vignetteColor));
                const l = this.updateOnRender(t1, r.timeFactor), c = t1.context, h = c.gl, u = t1.transform;
                this.screenTexture && this.screenTexture.size[0] === t1.width && this.screenTexture.size[1] === t1.height || (this.screenTexture = new e.T(c, {
                    width: t1.width,
                    height: t1.height,
                    data: null
                }, h.RGBA8)), r.distortionStrength > 0 && (c.activeTexture.set(h.TEXTURE0), this.screenTexture.bind(h.LINEAR, h.CLAMP_TO_EDGE), h.copyTexSubImage2D(h.TEXTURE_2D, 0, 0, 0, 0, 0, t1.width, t1.height));
                const d = t1.getOrCreateProgram("rainParticle");
                t1.uploadCommonUniforms(c, d), c.activeTexture.set(h.TEXTURE0), this.screenTexture.bind(h.LINEAR, h.CLAMP_TO_EDGE);
                const _ = [
                    r.color.r,
                    r.color.g,
                    r.color.b,
                    r.color.a
                ], p = (i, o)=>{
                    const s = Ua(this._movement.getPosition(), i), n = r.dropletSizeX, c = r.dropletSizeX * r.dropletSizeYScale, p = t1.width / 2, f = t1.height / 2, m = Ga(0, r.screenThinning.start, 0, 1, r.screenThinning.intensity), g = Ga(.001, r.screenThinning.range, 0, 1, r.screenThinning.intensity), v = Ga(0, r.screenThinning.particleOffset, 0, 1, r.screenThinning.intensity), y = (x = {
                        modelview: l.modelviewMatrix,
                        projection: l.projectionMatrix,
                        time: this._accumulatedTimeFromStart,
                        camPos: s,
                        velocityConeAperture: r.velocityConeAperture,
                        velocity: r.velocity,
                        boxSize: i,
                        rainDropletSize: [
                            n,
                            c
                        ],
                        distortionStrength: r.distortionStrength,
                        rainDirection: a,
                        color: _,
                        screenSize: [
                            u.width,
                            u.height
                        ],
                        thinningCenterPos: [
                            p,
                            f
                        ],
                        thinningShape: [
                            m,
                            g,
                            Math.pow(10, r.screenThinning.fadePower)
                        ],
                        thinningAffectedRatio: r.screenThinning.affectedRatio,
                        thinningParticleOffset: v,
                        shapeDirectionalPower: r.shapeDirPower,
                        shapeNormalPower: r.shapeNormalPower,
                        mode: o ? 0 : 1
                    }, {
                        u_modelview: Float32Array.from(x.modelview),
                        u_projection: Float32Array.from(x.projection),
                        u_time: x.time,
                        u_cam_pos: x.camPos,
                        u_texScreen: 0,
                        u_velocityConeAperture: x.velocityConeAperture,
                        u_velocity: x.velocity,
                        u_boxSize: x.boxSize,
                        u_rainDropletSize: x.rainDropletSize,
                        u_distortionStrength: x.distortionStrength,
                        u_rainDirection: x.rainDirection,
                        u_color: x.color,
                        u_screenSize: x.screenSize,
                        u_thinningCenterPos: x.thinningCenterPos,
                        u_thinningShape: x.thinningShape,
                        u_thinningAffectedRatio: x.thinningAffectedRatio,
                        u_thinningParticleOffset: x.thinningParticleOffset,
                        u_shapeDirectionalPower: x.shapeDirectionalPower,
                        u_shapeNormalPower: x.shapeNormalPower,
                        u_mode: x.mode
                    });
                    var x;
                    const b = Math.round(r.intensity * this.particlesCount), w = e.b7.simpleSegment(0, 0, 4 * b, 2 * b);
                    d.draw(t1, h.TRIANGLES, Bi.disabled, Ui.disabled, ki.alphaBlended, Vi.disabled, y, "rain_particles", this.particlesVx, this.particlesIdx, w, {});
                };
                r.distortionStrength > 0 && p(r.boxSize, !0), p(r.boxSize, !1), this._vignette.draw(t1, n);
            }
            constructor(e){
                super(4.25), this._params = {
                    overrideStyleParameters: !1,
                    intensity: .5,
                    timeFactor: 1,
                    velocityConeAperture: 0,
                    velocity: 300,
                    boxSize: 2500,
                    dropletSizeX: 1,
                    dropletSizeYScale: 10,
                    distortionStrength: 70,
                    screenThinning: {
                        intensity: .57,
                        start: .46,
                        range: 1.17,
                        fadePower: .17,
                        affectedRatio: 1,
                        particleOffset: -0.2
                    },
                    color: {
                        r: .66,
                        g: .68,
                        b: .74,
                        a: .7
                    },
                    direction: {
                        x: -50,
                        y: -35
                    },
                    shapeDirPower: 2,
                    shapeNormalPower: 1
                }, this._revealParams = new Fa(e.tp, [
                    "Precipitation",
                    "Rain"
                ]), this._vignetteParams = {
                    strength: 1,
                    start: .7,
                    range: 1,
                    fadePower: .4,
                    color: {
                        r: .27,
                        g: .27,
                        b: .27,
                        a: 1
                    }
                }, this.particlesCount = 16e3;
            }
        }
        const Ha = e.da([
            {
                type: "Float32",
                name: "a_pos_3f",
                components: 3
            },
            {
                type: "Float32",
                name: "a_uv",
                components: 2
            },
            {
                type: "Float32",
                name: "a_snowParticleData",
                components: 4
            },
            {
                type: "Float32",
                name: "a_snowParticleDataHorizontalOscillation",
                components: 2
            }
        ]);
        class Za extends Va {
            update(t1) {
                const i = t1.context;
                if (!this.particlesVx) {
                    const t1 = ja(this.particlesCount), o = new e.du, s = new e.aU;
                    let r = 0;
                    const a = e.di(1323123451230);
                    for(let e = 0; e < t1.length; ++e){
                        const i = t1[e], n = a(), l = a(), c = a(), h = [
                            e / t1.length,
                            n,
                            l,
                            c
                        ], u = [
                            a(),
                            a()
                        ];
                        o.emplaceBack(i[0], i[1], i[2], -1, -1, ...h, ...u), o.emplaceBack(i[0], i[1], i[2], 1, -1, ...h, ...u), o.emplaceBack(i[0], i[1], i[2], 1, 1, ...h, ...u), o.emplaceBack(i[0], i[1], i[2], -1, 1, ...h, ...u), s.emplaceBack(r + 0, r + 1, r + 2), s.emplaceBack(r + 0, r + 2, r + 3), r += 4;
                    }
                    this.particlesVx = i.createVertexBuffer(o, Ha.members), this.particlesIdx = i.createIndexBuffer(s);
                }
            }
            draw(t1) {
                if (!this._params.overrideStyleParameters && !t1.style.snow) return;
                const i = structuredClone(this._params);
                let o = [
                    -i.direction.x,
                    i.direction.y,
                    -100
                ];
                e.ab.vec3.normalize(o, o);
                const s = structuredClone(this._vignetteParams), r = i.overrideStyleParameters ? this._revealParams : {
                    revealStart: 0,
                    revealRange: .01
                }, a = t1.transform.zoom;
                if (r.revealStart > a) return;
                const n = Ga(0, 1, r.revealStart, r.revealStart + r.revealRange, a);
                s.strength *= n, i.overrideStyleParameters || (i.intensity = t1.style.snow.state.density, i.timeFactor = t1.style.snow.state.intensity, i.color = structuredClone(t1.style.snow.state.color), o = structuredClone(t1.style.snow.state.direction), i.screenThinning.intensity = t1.style.snow.state.centerThinning, i.billboardSize = 2.79 * t1.style.snow.state.flakeSize, s.strength = 1, s.color = structuredClone(t1.style.snow.state.vignetteColor));
                const l = this.updateOnRender(t1, i.timeFactor);
                if (!this.particlesVx || !this.particlesIdx) return;
                const c = t1.context, h = c.gl, u = t1.transform, d = t1.getOrCreateProgram("snowParticle");
                t1.uploadCommonUniforms(c, d), ((i, s, r)=>{
                    const a = Ua(this._movement.getPosition(), i), n = u.width / 2, c = u.height / 2, _ = Ga(0, r.screenThinning.start, 0, 1, r.screenThinning.intensity), p = Ga(.001, r.screenThinning.range, 0, 1, r.screenThinning.intensity), f = Ga(0, r.screenThinning.particleOffset, 0, 1, r.screenThinning.intensity), m = (g = {
                        modelview: l.modelviewMatrix,
                        projection: l.projectionMatrix,
                        time: this._accumulatedTimeFromStart,
                        camPos: a,
                        velocityConeAperture: r.velocityConeAperture,
                        velocity: r.velocity,
                        horizontalOscillationRadius: r.horizontalOscillationRadius,
                        horizontalOscillationRate: r.horizontalOscillationRate,
                        boxSize: i,
                        billboardSize: 1 * r.billboardSize,
                        simpleShapeParameters: [
                            r.shapeFadeStart,
                            r.shapeFadePower
                        ],
                        screenSize: [
                            u.width,
                            u.height
                        ],
                        thinningCenterPos: [
                            n,
                            c
                        ],
                        thinningShape: [
                            _,
                            p,
                            Math.pow(10, r.screenThinning.fadePower)
                        ],
                        thinningAffectedRatio: r.screenThinning.affectedRatio,
                        thinningParticleOffset: f,
                        color: [
                            r.color.r,
                            r.color.g,
                            r.color.b,
                            r.color.a
                        ],
                        direction: o
                    }, {
                        u_modelview: Float32Array.from(g.modelview),
                        u_projection: Float32Array.from(g.projection),
                        u_time: g.time,
                        u_cam_pos: g.camPos,
                        u_velocityConeAperture: g.velocityConeAperture,
                        u_velocity: g.velocity,
                        u_horizontalOscillationRadius: g.horizontalOscillationRadius,
                        u_horizontalOscillationRate: g.horizontalOscillationRate,
                        u_boxSize: g.boxSize,
                        u_billboardSize: g.billboardSize,
                        u_simpleShapeParameters: g.simpleShapeParameters,
                        u_screenSize: g.screenSize,
                        u_thinningCenterPos: g.thinningCenterPos,
                        u_thinningShape: g.thinningShape,
                        u_thinningAffectedRatio: g.thinningAffectedRatio,
                        u_thinningParticleOffset: g.thinningParticleOffset,
                        u_particleColor: g.color,
                        u_direction: g.direction
                    });
                    var g;
                    const v = Math.round(r.intensity * this.particlesCount), y = e.b7.simpleSegment(0, 0, 4 * v, 2 * v);
                    this.particlesVx && this.particlesIdx && d.draw(t1, h.TRIANGLES, Bi.disabled, Ui.disabled, ki.alphaBlended, Vi.disabled, m, "snow_particles", this.particlesVx, this.particlesIdx, y, {});
                })(i.boxSize, 0, i), this._vignette.draw(t1, s);
            }
            constructor(e){
                super(2.25), this._params = {
                    overrideStyleParameters: !1,
                    intensity: .85,
                    timeFactor: .75,
                    velocityConeAperture: 70,
                    velocity: 40,
                    horizontalOscillationRadius: 4,
                    horizontalOscillationRate: 1.5,
                    boxSize: 2e3,
                    billboardSize: 2,
                    shapeFadeStart: .27,
                    shapeFadePower: .21,
                    screenThinning: {
                        intensity: .4,
                        start: .15,
                        range: 1.4,
                        fadePower: .24,
                        affectedRatio: 1,
                        particleOffset: -0.2
                    },
                    color: {
                        r: 1,
                        g: 1,
                        b: 1,
                        a: 1
                    },
                    direction: {
                        x: -50,
                        y: -35
                    }
                }, this._revealParams = new Fa(e.tp, [
                    "Precipitation",
                    "Snow"
                ]), this._vignetteParams = {
                    strength: .3,
                    start: .78,
                    range: .46,
                    fadePower: .2,
                    color: {
                        r: 1,
                        g: 1,
                        b: 1,
                        a: 1
                    }
                }, this.particlesCount = 16e3;
            }
        }
        const Wa = {
            symbol: function(t1, i, o, s, r) {
                if ("translucent" !== t1.renderPass) return;
                const a = Ui.disabled, n = t1.colorModeForRenderPass(), l = o.layout.get("text-variable-anchor"), c = o.layout.get("text-size-scale-range"), h = e.aw(t1.scaleFactor, c[0], c[1]);
                l && function(t1, i, o, s, r, a, n, l) {
                    const c = i.transform, h = "map" === r, u = "map" === a;
                    for (const i of t1){
                        const t1 = s.getTile(i), r = t1.getBucket(o);
                        if (!r || !r.text || !r.text.segments.get().length) continue;
                        const a = e.bp(r.textSizeData, c.zoom, l), d = ci(i, r.getProjection(), c), _ = c.calculatePixelsToTileUnitsMatrix(t1), p = qt(d, t1.tileID.canonical, u, h, c, r.getProjection(), _), f = r.hasIconTextFit() && r.hasIconData();
                        if (a) {
                            const o = Math.pow(2, c.zoom - t1.tileID.overscaledZ);
                            Mr(r, h, u, n, e.cX, c, p, i, o, a, f);
                        }
                    }
                }(s, t1, o, i, o.layout.get("text-rotation-alignment"), o.layout.get("text-pitch-alignment"), r, h);
                const u = 0 !== o.paint.get("icon-opacity").constantOr(1), d = 0 !== o.paint.get("text-opacity").constantOr(1);
                void 0 !== o.layout.get("symbol-sort-key").constantOr(1) && (u || d) ? Or(t1, i, o, s, a, n) : (u && Or(t1, i, o, s, a, n, {
                    onlyIcons: !0
                }), d && Or(t1, i, o, s, a, n, {
                    onlyText: !0
                })), i.map.showCollisionBoxes && (Lr(t1, i, o, s, o.paint.get("text-translate"), o.paint.get("text-translate-anchor"), !0), Lr(t1, i, o, s, o.paint.get("icon-translate"), o.paint.get("icon-translate-anchor"), !1));
            },
            circle: function(t1, i, o, s) {
                if ("translucent" !== t1.renderPass) return;
                const r = o.paint.get("circle-opacity"), a = o.paint.get("circle-stroke-width"), n = o.paint.get("circle-stroke-opacity"), l = void 0 !== o.layout.get("circle-sort-key").constantOr(1), c = o.paint.get("circle-emissive-strength");
                if (0 === r.constantOr(1) && (0 === a.constantOr(1) || 0 === n.constantOr(1))) return;
                const h = t1.context, u = h.gl, d = t1.transform, _ = t1.depthModeForSublayer(0, Bi.ReadOnly), p = Ui.disabled, f = t1.colorModeForDrapableLayerRenderPass(c), m = "globe" === d.projection.name, g = [
                    e.at(d.center.lng),
                    e.aA(d.center.lat)
                ], v = [];
                for(let r = 0; r < s.length; r++){
                    const a = s[r], n = i.getTile(a), c = n.getBucket(o);
                    if (!c || c.projection.name !== d.projection.name) continue;
                    const h = c.programConfigurations.get(o.id), u = e.cY(o), _ = t1.isTileAffectedByFog(a);
                    m && u.push("PROJECTION_GLOBE_VIEW"), u.push("DEPTH_D24"), t1.terrain && d.depthOcclusionForSymbolsAndCircles && u.push("DEPTH_OCCLUSION");
                    const p = t1.getOrCreateProgram("circle", {
                        config: h,
                        defines: u,
                        overrideFog: _
                    }), f = c.layoutVertexBuffer, y = c.globeExtVertexBuffer, x = c.indexBuffer, b = d.projection.createInversionMatrix(d, a.canonical), w = {
                        programConfiguration: h,
                        program: p,
                        layoutVertexBuffer: f,
                        globeExtVertexBuffer: y,
                        indexBuffer: x,
                        uniformValues: e.cZ(t1, a, n, b, g, o),
                        tile: n
                    };
                    if (l) {
                        const t1 = c.segments.get();
                        for (const i of t1)v.push({
                            segments: new e.b7([
                                i
                            ]),
                            sortKey: i.sortKey,
                            state: w
                        });
                    } else v.push({
                        segments: c.segments,
                        sortKey: 0,
                        state: w
                    });
                }
                l && v.sort((e, t1)=>e.sortKey - t1.sortKey);
                const y = {
                    useDepthForOcclusion: d.depthOcclusionForSymbolsAndCircles
                };
                for (const e of v){
                    const { programConfiguration: i, program: s, layoutVertexBuffer: r, globeExtVertexBuffer: a, indexBuffer: n, uniformValues: l, tile: c } = e.state, m = e.segments;
                    t1.terrain && t1.terrain.setupElevationDraw(c, s, y), t1.uploadCommonUniforms(h, s, c.tileID.toUnwrapped()), s.draw(t1, u.TRIANGLES, _, p, f, Vi.disabled, l, o.id, r, n, m, o.paint, d.zoom, i, [
                        a
                    ]);
                }
            },
            heatmap: function(t1, i, o, s) {
                if (0 !== o.paint.get("heatmap-opacity")) {
                    if ("offscreen" === t1.renderPass) {
                        const r = t1.context, a = r.gl, n = Ui.disabled, l = new ki([
                            a.ONE,
                            a.ONE,
                            a.ONE,
                            a.ONE
                        ], e.aj.transparent, [
                            !0,
                            !0,
                            !0,
                            !0
                        ]);
                        !function(e, t1, i, o) {
                            const s = e.gl, r = t1.width * o, a = t1.height * o;
                            e.activeTexture.set(s.TEXTURE1), e.viewport.set([
                                0,
                                0,
                                r,
                                a
                            ]);
                            let n = i.heatmapFbo;
                            if (!n || n && (n.width !== r || n.height !== a)) {
                                n && n.destroy();
                                const t1 = s.createTexture();
                                s.bindTexture(s.TEXTURE_2D, t1), s.texParameteri(s.TEXTURE_2D, s.TEXTURE_WRAP_S, s.CLAMP_TO_EDGE), s.texParameteri(s.TEXTURE_2D, s.TEXTURE_WRAP_T, s.CLAMP_TO_EDGE), s.texParameteri(s.TEXTURE_2D, s.TEXTURE_MIN_FILTER, s.LINEAR), s.texParameteri(s.TEXTURE_2D, s.TEXTURE_MAG_FILTER, s.LINEAR), n = i.heatmapFbo = e.createFramebuffer(r, a, !0, null), function(e, t1, i, o, s, r) {
                                    const a = e.gl;
                                    a.texImage2D(a.TEXTURE_2D, 0, e.extRenderToTextureHalfFloat ? a.RGBA16F : a.RGBA, s, r, 0, a.RGBA, e.extRenderToTextureHalfFloat ? a.HALF_FLOAT : a.UNSIGNED_BYTE, null), o.colorAttachment.set(i);
                                }(e, 0, t1, n, r, a);
                            } else s.bindTexture(s.TEXTURE_2D, n.colorAttachment.get()), e.bindFramebuffer.set(n.framebuffer);
                        }(r, t1, o, "globe" === t1.transform.projection.name ? .5 : .25), r.clear({
                            color: e.aj.transparent
                        });
                        const c = t1.transform, h = "globe" === c.projection.name, u = h ? [
                            "PROJECTION_GLOBE_VIEW"
                        ] : [], d = h ? Vi.frontCCW : Vi.disabled, _ = [
                            e.at(c.center.lng),
                            e.aA(c.center.lat)
                        ];
                        for(let e = 0; e < s.length; e++){
                            const p = s[e];
                            if (i.hasRenderableParent(p)) continue;
                            const f = i.getTile(p), m = f.getBucket(o);
                            if (!m || m.projection.name !== c.projection.name) continue;
                            const g = t1.isTileAffectedByFog(p), v = m.programConfigurations.get(o.id), y = t1.getOrCreateProgram("heatmap", {
                                config: v,
                                defines: u,
                                overrideFog: g
                            }), { zoom: x } = t1.transform;
                            t1.terrain && t1.terrain.setupElevationDraw(f, y), t1.uploadCommonUniforms(r, y, p.toUnwrapped());
                            const b = c.projection.createInversionMatrix(c, p.canonical);
                            y.draw(t1, a.TRIANGLES, Bi.disabled, n, l, d, nr(t1, p, f, b, _, x, o.paint.get("heatmap-intensity")), o.id, m.layoutVertexBuffer, m.indexBuffer, m.segments, o.paint, t1.transform.zoom, v, h ? [
                                m.globeExtVertexBuffer
                            ] : null);
                        }
                        r.viewport.set([
                            0,
                            0,
                            t1.width,
                            t1.height
                        ]);
                    } else "translucent" === t1.renderPass && (t1.context.setColorMode(t1.colorModeForRenderPass()), function(t1, i) {
                        const o = t1.context, s = o.gl, r = i.heatmapFbo;
                        if (!r) return;
                        o.activeTexture.set(s.TEXTURE0), s.bindTexture(s.TEXTURE_2D, r.colorAttachment.get()), o.activeTexture.set(s.TEXTURE1);
                        let a = i.colorRampTexture;
                        a || (a = i.colorRampTexture = new e.T(o, i.colorRamp, s.RGBA8)), a.bind(s.LINEAR, s.CLAMP_TO_EDGE), t1.getOrCreateProgram("heatmapTexture").draw(t1, s.TRIANGLES, Bi.disabled, Ui.disabled, t1.colorModeForRenderPass(), Vi.disabled, ((e, t1, i, o)=>({
                                u_image: 0,
                                u_color_ramp: 1,
                                u_opacity: t1.paint.get("heatmap-opacity")
                            }))(0, i), i.id, t1.viewportBuffer, t1.quadTriangleIndexBuffer, t1.viewportSegments, i.paint, t1.transform.zoom);
                    }(t1, o));
                }
            },
            line: function(t1, i, o, s) {
                if ("translucent" !== t1.renderPass) return;
                const r = o.paint.get("line-opacity"), a = o.paint.get("line-width");
                if (0 === r.constantOr(1) || 0 === a.constantOr(1)) return;
                const n = o.paint.get("line-emissive-strength"), l = o.paint.get("line-occlusion-opacity"), c = o.layout.get("line-elevation-reference"), h = "meters" === o.layout.get("line-width-unit"), u = "sea" === c, d = t1.context, _ = d.gl;
                if (o.hasElevatedBuckets && "globe" === t1.transform.projection.name) return;
                const p = o.layout.get("line-cross-slope"), f = void 0 !== p, m = p < 1, g = t1.colorModeForDrapableLayerRenderPass(n), v = t1.terrain && t1.terrain.renderingToTexture, y = v ? 1 : e.q.devicePixelRatio, x = o.paint.get("line-dasharray"), b = x.constantOr(1), w = o.layout.get("line-cap"), T = x.constantOr(null), E = w.constantOr(null), S = o.paint.get("line-pattern"), C = S.constantOr(1), I = S.constantOr(null), R = o.paint.get("line-opacity").constantOr(1);
                let D = !C && 1 !== R || t1.depthOcclusion && l > 0 && l < 1;
                const L = o.paint.get("line-gradient"), A = C ? "linePattern" : "line", z = e.c_(o);
                let P;
                if (v && t1.terrain && t1.terrain.clipOrMaskOverlapStencilType() && (D = !1), 0 !== l && t1.depthOcclusion) {
                    const t1 = o.paint._values["line-opacity"];
                    t1 && t1.value && "constant" === t1.value.kind ? P = t1.value : e.w(`Occlusion opacity for layer ${o.id} is supported only when line-opacity isn't data-driven.`);
                }
                "constant" !== a.value.kind && !1 === a.value.isLineProgressConstant && z.push("VARIABLE_LINE_WIDTH");
                const M = (s, r, a, n, c)=>{
                    for (const p of s){
                        const s = i.getTile(p);
                        if (C && !s.patternsLoaded()) continue;
                        const f = s.getBucket(o);
                        if (!f) continue;
                        if (f.hasZOffset && !c || !f.hasZOffset && c) continue;
                        t1.prepareDrawTile();
                        const m = f.programConfigurations.get(o.id), x = t1.isTileAffectedByFog(p), w = t1.getOrCreateProgram(A, {
                            config: m,
                            defines: r,
                            overrideFog: x,
                            overrideRtt: !c && void 0
                        });
                        if (I && s.imageAtlas) {
                            const t1 = e.A.from(I).getPrimary().scaleSelf(y).serialize(), i = s.imageAtlas.patternPositions[t1];
                            i && m.setConstantPatternPositions(i);
                        }
                        if (!C && T && E && s.lineAtlas) {
                            const e = s.lineAtlas.getDash(T, E);
                            e && m.setConstantPatternPositions(e);
                        }
                        let [S, z] = o.paint.get("line-trim-offset");
                        if ("round" === E || "square" === E) {
                            const e = 1;
                            S !== z && (0 === S && (S -= e), 1 === z && (z += e));
                        }
                        const M = v ? p.projMatrix : null, O = h ? 1 / f.tileToMeter / e.ar(s, 1, t1.transform.zoom) : 1, F = h ? 1 / f.tileToMeter / e.ar(s, 1, Math.floor(t1.transform.zoom)) : 1, k = C ? e.c$(t1, s, o, M, y, O, F, [
                            S,
                            z
                        ]) : e.d0(t1, s, o, M, f.lineClipsArray.length, y, O, F, [
                            S,
                            z
                        ]);
                        if (L) {
                            const s = f.gradients[o.id];
                            let r = s.texture;
                            if (o.gradientVersion !== s.version) {
                                let a = 256;
                                if (o.stepInterpolant) {
                                    const o = i.getSource().maxzoom, s = p.canonical.z === o ? Math.ceil(1 << t1.transform.maxZoom - p.canonical.z) : 1;
                                    a = e.aw(e.d1(f.maxLineLength / e.ag * 1024 * s), 256, d.maxTextureSize);
                                }
                                s.gradient = e.d2({
                                    expression: o.gradientExpression(),
                                    evaluationKey: "lineProgress",
                                    resolution: a,
                                    image: s.gradient || void 0,
                                    clips: f.lineClipsArray
                                }), s.texture ? s.texture.update(s.gradient) : s.texture = new e.T(d, s.gradient, _.RGBA8), s.version = o.gradientVersion, r = s.texture;
                            }
                            d.activeTexture.set(_.TEXTURE1), r.bind(o.stepInterpolant ? _.NEAREST : _.LINEAR, _.CLAMP_TO_EDGE);
                        }
                        b && (d.activeTexture.set(_.TEXTURE0), s.lineAtlasTexture && s.lineAtlasTexture.bind(_.LINEAR, _.REPEAT), m.updatePaintBuffers()), C && (d.activeTexture.set(_.TEXTURE0), s.imageAtlasTexture && s.imageAtlasTexture.bind(_.LINEAR, _.CLAMP_TO_EDGE), m.updatePaintBuffers()), c && !u && t1.terrain.setupElevationDraw(s, w), t1.uploadCommonUniforms(d, w, p.toUnwrapped());
                        const B = (e)=>{
                            null != P && (P.value = R * l), w.draw(t1, _.TRIANGLES, a, e, g, Vi.disabled, k, o.id, f.layoutVertexBuffer, f.indexBuffer, f.segments, o.paint, t1.transform.zoom, m, [
                                f.layoutVertexBuffer2,
                                f.patternVertexBuffer,
                                f.zOffsetVertexBuffer
                            ]), null != P && (P.value = R);
                        };
                        if (D && !c) {
                            const e = t1.stencilModeForClipping(p).ref;
                            0 === e && v && d.clear({
                                stencil: 0
                            });
                            const i = {
                                func: _.EQUAL,
                                mask: 255
                            };
                            k.u_alpha_discard_threshold = .8, B(new Ui(i, e, 255, _.KEEP, _.KEEP, _.INVERT)), k.u_alpha_discard_threshold = 0, B(new Ui(i, e, 255, _.KEEP, _.KEEP, _.KEEP));
                        } else D && c && (k.u_alpha_discard_threshold = .001), B(c ? n : t1.stencilModeForClipping(p));
                    }
                };
                if (o.hasNonElevatedBuckets) {
                    const i = !v && t1.terrain;
                    0 !== l && i ? e.w(`Occlusion opacity for layer ${o.id} is supported on terrain only if the layer has line-z-offset enabled.`) : i ? e.w(`Cannot render non-elevated lines in immediate mode when terrain is enabled. Layer: ${o.id}.`) : M(s, z, t1.depthModeForSublayer(0, Bi.ReadOnly), Ui.disabled, !1);
                }
                if (o.hasElevatedBuckets) {
                    z.push("ELEVATED"), f && z.push(m ? "CROSS_SLOPE_HORIZONTAL" : "CROSS_SLOPE_VERTICAL"), u && z.push("ELEVATION_REFERENCE_SEA");
                    const e = D ? t1.stencilModeFor3D() : Ui.disabled, i = new Bi(t1.depthOcclusion ? _.GREATER : _.LEQUAL, Bi.ReadOnly, t1.depthRangeFor3D);
                    t1.forceTerrainMode = !0, M(s, z, i, e, !0), t1.forceTerrainMode = !1;
                }
                D && (t1.resetStencilClippingMasks(), v && d.clear({
                    stencil: 0
                })), 0 === l || t1.depthOcclusion || v || t1.layersWithOcclusionOpacity.push(t1.currentLayer);
            },
            fill: function(t1, i, o, s) {
                const r = o.paint.get("fill-color"), a = o.paint.get("fill-opacity"), n = o.is3D(), l = new Bi(t1.context.gl.LEQUAL, Bi.ReadWrite, t1.depthRangeFor3D);
                if (0 === a.constantOr(1)) return;
                const c = o.paint.get("fill-emissive-strength"), h = t1.colorModeForDrapableLayerRenderPass(c), u = o.paint.get("fill-pattern"), d = t1.opaquePassEnabledForLayer() && !u.constantOr(1) && 1 === r.constantOr(e.aj.transparent).a && 1 === a.constantOr(0) ? "opaque" : "translucent";
                if (t1.renderPass === d) {
                    const e = n ? l : t1.depthModeForSublayer(1, "opaque" === t1.renderPass ? Bi.ReadWrite : Bi.ReadOnly);
                    kr(t1, i, o, s, e, h, !1);
                }
                if (!n && "translucent" === t1.renderPass && o.paint.get("fill-antialias")) {
                    const e = n ? l : t1.depthModeForSublayer(o.getPaintProperty("fill-outline-color") ? 2 : 0, Bi.ReadOnly);
                    kr(t1, i, o, s, e, h, !0);
                }
            },
            "fill-extrusion": function(t1, i, o, s) {
                const r = o.paint.get("fill-extrusion-opacity"), a = t1.context, n = a.gl, l = t1.terrain, c = l && l.renderingToTexture;
                if (0 === r) return;
                const h = t1.conflationActive && t1.style.isLayerClipped(o, i.getSource()), u = t1.style.order.indexOf(o.fqid);
                if (h && function(e, t1, i, o, s) {
                    for (const r of o){
                        const o = t1.getTile(r).getBucket(i);
                        o && (o.updateReplacement(r, e.replacementSource, s), o.uploadCentroid(e.context));
                    }
                }(t1, i, o, s, u), l || h) for (const e of s){
                    const s = i.getTile(e).getBucket(o);
                    s && Ur(t1.context, i, e, s, o, l, h);
                }
                if ("shadow" === t1.renderPass && t1.shadowRenderer) {
                    const a = t1.shadowRenderer;
                    if (l && r < .65 && o._transitionablePaint._values["fill-extrusion-opacity"].value.expression instanceof e.a9) return;
                    const n = a.getShadowPassDepthMode(), c = a.getShadowPassColorMode();
                    Br(t1, i, o, s, n, Ui.disabled, c, h);
                } else if ("translucent" === t1.renderPass) {
                    const u = !o.paint.get("fill-extrusion-pattern").constantOr(1), d = o.paint.get("fill-extrusion-color").constantOr(e.aj.white);
                    if (!c && 0 !== d.a) {
                        const e = new Bi(t1.context.gl.LEQUAL, Bi.ReadWrite, t1.depthRangeFor3D);
                        1 === r && u ? Br(t1, i, o, s, e, Ui.disabled, ki.unblended, h) : (Br(t1, i, o, s, e, Ui.disabled, ki.disabled, h), Br(t1, i, o, s, e, t1.stencilModeFor3D(), t1.colorModeForRenderPass(), h), t1.resetStencilClippingMasks());
                    }
                    if (t1.style.enable3dLights() && u && (!l && "globe" !== t1.transform.projection.name || c)) {
                        const r = o.paint.get("fill-extrusion-opacity"), u = o.paint.get("fill-extrusion-ambient-occlusion-intensity"), d = o.paint.get("fill-extrusion-ambient-occlusion-ground-radius"), _ = o.paint.get("fill-extrusion-flood-light-intensity"), p = "none" === o.paint.get("fill-extrusion-flood-light-color-use-theme").constantOr("default"), f = o.paint.get("fill-extrusion-flood-light-color").toRenderColor(p ? null : o.lut).toArray01().slice(0, 3), m = u > 0 && d > 0, g = _ > 0, v = (e, t1, i)=>(1 - i) * e + i * t1, y = (a)=>{
                            const l = t1.depthModeForSublayer(1, Bi.ReadOnly, n.LEQUAL, !0), c = o.paint.get(a ? "fill-extrusion-ambient-occlusion-ground-attenuation" : "fill-extrusion-flood-light-ground-attenuation"), p = v(.1, 3, c), m = t1._showOverdrawInspector;
                            if (!m) {
                                const c = new Ui({
                                    func: n.ALWAYS,
                                    mask: 255
                                }, 255, 255, n.KEEP, n.KEEP, n.REPLACE), m = new ki([
                                    n.ONE,
                                    n.ONE,
                                    n.ONE,
                                    n.ONE
                                ], e.aj.transparent, [
                                    !1,
                                    !1,
                                    !1,
                                    !0
                                ], n.MIN);
                                Nr(t1, i, o, s, l, c, m, Vi.disabled, a, "sdf", r, u, d, _, f, p, h, !1);
                            }
                            {
                                const c = m ? Ui.disabled : new Ui({
                                    func: n.EQUAL,
                                    mask: 255
                                }, 255, 255, n.KEEP, n.DECR, n.DECR), g = m ? t1.colorModeForRenderPass() : new ki([
                                    n.ONE_MINUS_DST_ALPHA,
                                    n.DST_ALPHA,
                                    n.ONE,
                                    n.ONE
                                ], e.aj.transparent, [
                                    !0,
                                    !0,
                                    !0,
                                    !0
                                ]);
                                Nr(t1, i, o, s, l, c, g, Vi.disabled, a, "color", r, u, d, _, f, p, h, !1);
                            }
                        };
                        if (c) {
                            const c = (a, l, c)=>{
                                const p = t1.depthModeForSublayer(1, Bi.ReadOnly, n.LEQUAL, !1), m = o.paint.get(a ? "fill-extrusion-ambient-occlusion-ground-attenuation" : "fill-extrusion-flood-light-ground-attenuation"), g = v(.1, 3, m);
                                {
                                    const c = new ki([
                                        n.ONE,
                                        n.ONE,
                                        n.ONE,
                                        n.ONE
                                    ], e.aj.transparent, [
                                        !1,
                                        !1,
                                        !1,
                                        !0
                                    ]);
                                    Nr(t1, i, o, s, p, Ui.disabled, c, Vi.disabled, a, "clear", r, u, d, _, f, g, h, l);
                                }
                                {
                                    const c = new Ui({
                                        func: n.ALWAYS,
                                        mask: 255
                                    }, 255, 255, n.KEEP, n.KEEP, n.REPLACE), m = new ki([
                                        n.ONE,
                                        n.ONE,
                                        n.ONE,
                                        n.ONE
                                    ], e.aj.transparent, [
                                        !1,
                                        !1,
                                        !1,
                                        !0
                                    ], n.MIN);
                                    Nr(t1, i, o, s, p, c, m, Vi.disabled, a, "sdf", r, u, d, _, f, g, h, l);
                                }
                                {
                                    const c = a ? n.ZERO : n.ONE_MINUS_DST_ALPHA, m = new Ui({
                                        func: n.EQUAL,
                                        mask: 255
                                    }, 255, 255, n.KEEP, n.DECR, n.DECR), v = new ki([
                                        c,
                                        n.DST_ALPHA,
                                        n.ONE_MINUS_DST_ALPHA,
                                        n.ZERO
                                    ], e.aj.transparent, [
                                        !0,
                                        !0,
                                        !0,
                                        !0
                                    ]);
                                    Nr(t1, i, o, s, p, m, v, Vi.disabled, a, "color", r, u, d, _, f, g, h, l);
                                }
                                {
                                    const m = new ki([
                                        n.ONE,
                                        n.ONE,
                                        n.ONE,
                                        a ? n.ZERO : n.ONE
                                    ], e.aj.transparent, [
                                        !1,
                                        !1,
                                        !1,
                                        !0
                                    ], a ? n.FUNC_ADD : n.MAX);
                                    Nr(t1, i, o, s, p, Ui.disabled, m, Vi.disabled, a, "clear", r, u, d, _, f, g, h, l, c);
                                }
                            };
                            if (m || g) {
                                let i;
                                if (t1.prepareDrawTile(), l) {
                                    const t1 = l.drapeBufferSize[0], o = l.drapeBufferSize[1];
                                    i = l.framebufferCopyTexture, i && (!i || i.size[0] === t1 && i.size[1] === o) || (i && i.destroy(), i = l.framebufferCopyTexture = new e.T(a, new e.r({
                                        width: t1,
                                        height: o
                                    }), n.RGBA8)), i.bind(n.LINEAR, n.CLAMP_TO_EDGE), n.copyTexSubImage2D(n.TEXTURE_2D, 0, 0, 0, 0, 0, t1, o);
                                }
                                m && c(!0, !1, i), g && c(!1, !0, i);
                            }
                        } else m && y(!0), g && y(!1), (m || g) && t1.resetStencilClippingMasks();
                    }
                }
            },
            hillshade: function(e, t1, i, o) {
                if ("offscreen" !== e.renderPass && "translucent" !== e.renderPass) return;
                if (e.style.disableElevatedTerrain) return;
                const s = e.context, r = e.terrain && e.terrain.renderingToTexture, [a, n] = "translucent" !== e.renderPass || r ? [
                    {},
                    o
                ] : e.stencilConfigForOverlap(o);
                for (const o of n){
                    const s = t1.getTile(o);
                    if (s.needsHillshadePrepare && "offscreen" === e.renderPass) Wo(e, s, i);
                    else if ("translucent" === e.renderPass) {
                        const t1 = e.depthModeForSublayer(0, Bi.ReadOnly), n = i.paint.get("hillshade-emissive-strength"), l = e.colorModeForDrapableLayerRenderPass(n), c = r && e.terrain ? e.terrain.stencilModeForRTTOverlap(o) : a[o.overscaledZ];
                        Ho(e, o, s, i, t1, c, l);
                    }
                }
                s.viewport.set([
                    0,
                    0,
                    e.width,
                    e.height
                ]), e.resetStencilClippingMasks();
            },
            raster: function(t1, i, o, s, r, a) {
                if ("translucent" !== t1.renderPass) return;
                if (0 === o.paint.get("raster-opacity")) return;
                const n = "globe" === t1.transform.projection.name, l = 0 !== o.paint.get("raster-elevation"), c = l && n;
                if (t1.renderElevatedRasterBackface && !c) return;
                const h = t1.context, u = h.gl, d = i.getSource(), _ = function(t1, i, o, s) {
                    const r = i.paint.get("raster-color"), a = "raster-array" === t1.type, n = [], l = i.paint.get("raster-resampling"), c = i.paint.get("raster-color-mix");
                    let h = i.paint.get("raster-color-range");
                    const u = [
                        c[0],
                        c[1],
                        c[2],
                        0
                    ], d = c[3];
                    let _ = "nearest" === l ? s.NEAREST : s.LINEAR;
                    if (a && (n.push("RASTER_ARRAY"), r || n.push("RASTER_COLOR"), "linear" === l && n.push("RASTER_ARRAY_LINEAR"), _ = s.NEAREST, !h && t1.rasterLayers)) {
                        const e = t1.rasterLayers.find(({ id: e })=>e === i.sourceLayer);
                        e && e.fields && e.fields.range && (h = e.fields.range);
                    }
                    if (h = h || [
                        0,
                        1
                    ], r) {
                        n.push("RASTER_COLOR"), o.activeTexture.set(s.TEXTURE2), i.updateColorRamp(h);
                        let t1 = i.colorRampTexture;
                        t1 || (t1 = i.colorRampTexture = new e.T(o, i.colorRamp, s.RGBA8)), t1.bind(s.LINEAR, s.CLAMP_TO_EDGE);
                    }
                    return {
                        mix: u,
                        range: h,
                        offset: d,
                        defines: n,
                        resampling: _
                    };
                }(d, o, h, u);
                if (d instanceof e.aJ && !s.length && !n) return;
                const p = o.paint.get("raster-emissive-strength"), f = t1.colorModeForDrapableLayerRenderPass(p), m = t1.terrain && t1.terrain.renderingToTexture, g = !t1.options.moving, v = "nearest" === o.paint.get("raster-resampling") ? u.NEAREST : u.LINEAR;
                if (d instanceof e.aJ && !s.length && (d.onNorthPole || d.onSouthPole)) {
                    const e = l ? t1.stencilModeFor3D() : Ui.disabled;
                    return void Zr(!!d.onNorthPole, null, t1, i, o, p, _, Vi.disabled, e);
                }
                if (!s.length) return;
                const [y, x] = d instanceof e.aJ || m ? [
                    {},
                    s
                ] : t1.stencilConfigForOverlap(s), b = x[x.length - 1].overscaledZ;
                c && _.defines.push("PROJECTION_GLOBE_VIEW"), l && _.defines.push("RENDER_CUTOFF");
                const w = (s, r, x)=>{
                    for (const w of s){
                        const s = w.toUnwrapped(), T = i.getTile(w);
                        if (m && (!T || !T.hasData())) continue;
                        h.activeTexture.set(u.TEXTURE0);
                        const E = $r(T, d, o, _);
                        if (!E || !E.texture) continue;
                        const { texture: S, mix: C, offset: I, tileSize: R, buffer: D } = E;
                        let L, A;
                        m ? (L = Bi.disabled, A = w.projMatrix) : l ? (L = new Bi(u.LEQUAL, Bi.ReadWrite, t1.depthRangeFor3D), A = n ? Float32Array.from(t1.transform.expandedFarZProjMatrix) : t1.transform.calculateProjMatrix(s, g)) : (L = t1.depthModeForSublayer(w.overscaledZ - b, 1 === o.paint.get("raster-opacity") ? Bi.ReadWrite : Bi.ReadOnly, u.LESS), A = t1.transform.calculateProjMatrix(s, g));
                        const z = t1.terrain && m ? t1.terrain.stencilModeForRTTOverlap(w) : y[w.overscaledZ], P = a ? 0 : o.paint.get("raster-fade-duration");
                        T.registerFadeDuration(P);
                        const M = i.findLoadedParent(w, 0), O = Ns(T, M, i, t1.transform, P);
                        let F, k;
                        t1.terrain && t1.terrain.prepareDrawTile(), h.activeTexture.set(u.TEXTURE0), S.bind(v, u.CLAMP_TO_EDGE), h.activeTexture.set(u.TEXTURE1), M ? (M.texture && M.texture.bind(v, u.CLAMP_TO_EDGE), F = Math.pow(2, M.tileID.overscaledZ - T.tileID.overscaledZ), k = [
                            T.tileID.canonical.x * F % 1,
                            T.tileID.canonical.y * F % 1
                        ]) : S.bind(v, u.CLAMP_TO_EDGE), S.useMipmap && h.extTextureFilterAnisotropic && t1.transform.pitch > 20 && u.texParameterf(u.TEXTURE_2D, h.extTextureFilterAnisotropic.TEXTURE_MAX_ANISOTROPY_EXT, h.extTextureFilterAnisotropicMax);
                        const B = t1.transform;
                        let N;
                        const U = l ? Wr(B) : [
                            0,
                            0,
                            0,
                            0
                        ];
                        let j, G, V, q, H, Z = 0;
                        if (c && d instanceof e.aJ && d.coordinates.length > 3) j = Float32Array.from(e.bb(e.cH(new e.bT(0, 0, 0)))), G = Float32Array.from(B.globeMatrix), V = Float32Array.from(e.cD(B)), q = [
                            e.at(B.center.lng),
                            e.aA(B.center.lat)
                        ], N = d.elevatedGlobePerspectiveTransform, H = d.elevatedGlobeGridMatrix || new Float32Array(9);
                        else if (c) {
                            const t1 = e.cE(w.canonical);
                            Z = e.cF(t1.getCenter().lat), j = Float32Array.from(e.bb(e.cH(w.canonical))), G = Float32Array.from(B.globeMatrix), V = Float32Array.from(e.cD(B)), q = [
                                e.at(B.center.lng),
                                e.aA(B.center.lat)
                            ], N = [
                                0,
                                0
                            ], H = Float32Array.from(e.cG(w.canonical, t1, Z, B.worldSize / B._pixelsPerMercatorPixel));
                        } else N = d instanceof e.aJ ? d.perspectiveTransform : [
                            0,
                            0
                        ], j = new Float32Array(16), G = new Float32Array(9), V = new Float32Array(16), q = [
                            0,
                            0
                        ], H = new Float32Array(9);
                        const W = hr(A, j, G, V, H, k || [
                            0,
                            0
                        ], e.ae(t1.transform.zoom), q, U, F || 1, O, o, N, l ? o.paint.get("raster-elevation") : 0, 2, C, I, _.range, R, D, p), $ = t1.isTileAffectedByFog(w), X = t1.getOrCreateProgram("raster", {
                            defines: _.defines,
                            overrideFog: $
                        });
                        if (t1.uploadCommonUniforms(h, X, s), d instanceof e.aJ) {
                            const i = d.elevatedGlobeVertexBuffer, s = d.elevatedGlobeIndexBuffer;
                            if (m || !n) d.boundsBuffer && d.boundsSegments && X.draw(t1, u.TRIANGLES, L, Ui.disabled, f, Vi.disabled, W, o.id, d.boundsBuffer, t1.quadTriangleIndexBuffer, d.boundsSegments);
                            else if (i && s) {
                                const a = B.zoom <= e.c6 ? d.elevatedGlobeSegments : d.getSegmentsForLongitude(B.center.lng);
                                a && X.draw(t1, u.TRIANGLES, L, Ui.disabled, f, r, W, o.id, i, s, a);
                            }
                        } else if (c) {
                            L = new Bi(u.LEQUAL, Bi.ReadOnly, t1.depthRangeFor3D);
                            const e = t1.globeSharedBuffers;
                            if (e) {
                                const [i, s, a] = e.getGridBuffers(Z, !1);
                                X.draw(t1, u.TRIANGLES, L, x || z, t1.colorModeForRenderPass(), r, W, o.id, i, s, a);
                            }
                        } else {
                            const { tileBoundsBuffer: e, tileBoundsIndexBuffer: i, tileBoundsSegments: s } = t1.getTileBoundsBuffers(T);
                            X.draw(t1, u.TRIANGLES, L, z, f, Vi.disabled, W, o.id, e, i, s);
                        }
                    }
                    if (!(d instanceof e.aJ) && c) for (const e of s){
                        const s = e.canonical.y === (1 << e.canonical.z) - 1;
                        0 === e.canonical.y && Zr(!0, e, t1, i, o, p, _, r, x || Ui.disabled), s && Zr(!1, e, t1, i, o, p, _, r === Vi.frontCW ? Vi.backCW : Vi.frontCW, x || Ui.disabled);
                    }
                };
                c ? w(x, t1.renderElevatedRasterBackface ? Vi.backCW : Vi.frontCW, t1.stencilModeFor3D()) : w(x, Vi.disabled, void 0), t1.resetStencilClippingMasks();
            },
            "raster-particle": function(t1, i, o, s, r, a) {
                "offscreen" === t1.renderPass && function(t1, i, o, s) {
                    if (!s.length) return;
                    const r = t1.context, a = r.gl, n = i.getSource();
                    if (!(n instanceof ot)) return;
                    const l = Math.ceil(Math.sqrt(o.paint.get("raster-particle-count")));
                    let c = o.particlePositionRGBAImage;
                    if (!c || c.width !== l) {
                        const t1 = function(e) {
                            const t1 = e * e, i = new Uint8Array(4 * t1), o = function(e) {
                                return e |= 0, e = Math.imul(2747636419 ^ e, 2654435769), e = Math.imul(e ^ e >>> 16, 2654435769), ((e = Math.imul(e ^ e >>> 16, 2654435769)) >>> 0) / 4294967296;
                            }, s = 1 / 1.1;
                            for(let e = 0; e < t1; e++){
                                const t1 = s * (o(2 * e + 0) + dr), r = s * (o(2 * e + 1) + dr), a = 255 * t1 % 1, n = 255 * r % 1, l = a, c = r - n / 255, h = n;
                                i[4 * e + 0] = 255 * (t1 - a / 255), i[4 * e + 1] = 255 * l, i[4 * e + 2] = 255 * c, i[4 * e + 3] = 255 * h;
                            }
                            return i;
                        }(l);
                        c = o.particlePositionRGBAImage = new e.r({
                            width: l,
                            height: l
                        }, t1);
                    }
                    let h = o.particleFramebuffer;
                    h ? h.width !== l && (h.destroy(), h = o.particleFramebuffer = r.createFramebuffer(l, l, !0, null)) : h = o.particleFramebuffer = r.createFramebuffer(l, l, !0, null);
                    const u = [];
                    for (const e of s){
                        const t1 = i.getTile(e);
                        if (!(t1 instanceof wt)) continue;
                        const s = Yr(t1, n, o);
                        if (!s) continue;
                        const a = [
                            t1.tileSize,
                            t1.tileSize
                        ];
                        let h = o.tileFramebuffer;
                        h || (h = o.tileFramebuffer = r.createFramebuffer(a[0], a[1], !0, null));
                        let d = t1.rasterParticleState;
                        d || (d = t1.rasterParticleState = new Kr(r, e, a, c));
                        const _ = d.update(o.lastInvalidatedAt);
                        d.particleTextureDimension !== l && d.updateParticleTexture(e, c);
                        const p = d.targetColorTexture;
                        d.targetColorTexture = d.backgroundColorTexture, d.backgroundColorTexture = p;
                        const f = d.particleTexture0;
                        d.particleTexture0 = d.particleTexture1, d.particleTexture1 = f, u.push([
                            e,
                            s,
                            d,
                            _
                        ]);
                    }
                    if (0 === u.length) return;
                    const d = e.q.now(), _ = o.previousDrawTimestamp ? .001 * (d - o.previousDrawTimestamp) : .0167;
                    if (o.previousDrawTimestamp = d, o.hasColorMap()) {
                        r.activeTexture.set(a.TEXTURE0 + 2);
                        let t1 = o.colorRampTexture;
                        t1 || (t1 = o.colorRampTexture = new e.T(r, o.colorRamp, a.RGBA8)), t1.bind(a.LINEAR, a.CLAMP_TO_EDGE);
                    }
                    r.bindFramebuffer.set(o.tileFramebuffer.framebuffer), function(t1, i, o) {
                        const s = t1.context, r = s.gl, a = i.tileFramebuffer;
                        s.activeTexture.set(r.TEXTURE0);
                        const n = {
                            u_texture: 0,
                            u_opacity: 1.05 * (c = i.paint.get("raster-particle-fade-opacity-factor")) / (c + .05)
                        }, l = t1.getOrCreateProgram("rasterParticleTexture", {
                            defines: [],
                            overrideFog: !1
                        });
                        var c;
                        for (const c of o){
                            const [, , o, h] = c;
                            a.colorAttachment.set(o.targetColorTexture.texture), s.viewport.set([
                                0,
                                0,
                                a.width,
                                a.height
                            ]), s.clear({
                                color: e.aj.transparent
                            }), h && (o.backgroundColorTexture.bind(r.NEAREST, r.CLAMP_TO_EDGE), l.draw(t1, r.TRIANGLES, Bi.disabled, Ui.disabled, ki.alphaBlended, Vi.disabled, n, i.id, t1.viewportBuffer, t1.quadTriangleIndexBuffer, t1.viewportSegments));
                        }
                    }(t1, o, u), function(t1, i, o, s) {
                        const r = t1.context, a = r.gl, n = o.tileFramebuffer, l = "globe" === t1.transform.projection.name, c = o.paint.get("raster-particle-max-speed");
                        for (const h of s){
                            const [s, u, d] = h;
                            r.activeTexture.set(a.TEXTURE0 + 0), u.texture.bind(a.LINEAR, a.CLAMP_TO_EDGE), n.colorAttachment.set(d.targetColorTexture.texture);
                            const _ = t1.getOrCreateProgram("rasterParticleDraw", {
                                defines: u.defines,
                                overrideFog: !1
                            });
                            r.activeTexture.set(a.TEXTURE0 + 1);
                            const p = u.scalarData ? [] : [
                                0,
                                1,
                                2,
                                3
                            ].map((t1)=>e.d4[t1](s));
                            p.push(s);
                            const f = s.canonical.x, m = s.canonical.y;
                            for (const e of p){
                                const r = i.getTile(l ? e.wrapped() : e);
                                if (!r) continue;
                                const n = r.rasterParticleState;
                                if (!n) continue;
                                const h = e.canonical.x + (1 << e.canonical.z) * (e.wrap - s.wrap), d = e.canonical.y;
                                n.particleTexture0.bind(a.NEAREST, a.CLAMP_TO_EDGE);
                                const p = pr(1, n.particleTexture0.size[0], [
                                    h - f,
                                    d - m
                                ], 0, u.texture.size, 2, c, u.textureOffset, u.scale, u.offset);
                                _.draw(t1, a.POINTS, Bi.disabled, Ui.disabled, ki.alphaBlended, Vi.disabled, p, o.id, n.particleIndexBuffer, void 0, n.particleSegment);
                            }
                        }
                    }(t1, i, o, u), r.bindFramebuffer.set(o.particleFramebuffer.framebuffer), function(t1, i, o, s) {
                        const r = t1.context, a = r.gl, n = i.paint.get("raster-particle-max-speed"), l = s * i.paint.get("raster-particle-speed-factor") * .15, c = function(e) {
                            return Math.pow(e, 6);
                        }(.01 + 1 * i.paint.get("raster-particle-reset-rate-factor")), h = i.particleFramebuffer;
                        r.viewport.set([
                            0,
                            0,
                            h.width,
                            h.height
                        ]);
                        for (const s of o){
                            const [, o, u] = s;
                            r.activeTexture.set(a.TEXTURE0 + 0), o.texture.bind(a.LINEAR, a.CLAMP_TO_EDGE), r.activeTexture.set(a.TEXTURE0 + 1);
                            const d = u.particleTexture0;
                            d.bind(a.NEAREST, a.CLAMP_TO_EDGE);
                            const _ = fr(1, d.size[0], 0, o.texture.size, n, l, c, o.textureOffset, o.scale, o.offset);
                            h.colorAttachment.set(u.particleTexture1.texture), r.clear({
                                color: e.aj.transparent
                            }), t1.getOrCreateProgram("rasterParticleUpdate", {
                                defines: o.defines
                            }).draw(t1, a.TRIANGLES, Bi.disabled, Ui.disabled, ki.unblended, Vi.disabled, _, i.id, t1.viewportBuffer, t1.quadTriangleIndexBuffer, t1.viewportSegments);
                        }
                    }(t1, o, u, _);
                }(t1, i, o, s), "translucent" === t1.renderPass && (function(t1, i, o, s, r) {
                    const a = t1.context, n = a.gl, l = i.getSource().tileSize, c = 5 * (1 - e.ac(e.bY, e.bY + 1, t1.transform.zoom)) * l + o.paint.get("raster-particle-elevation"), h = !t1.options.moving, u = "globe" === t1.transform.projection.name;
                    if (!s.length) return;
                    const [d, _] = t1.stencilConfigForOverlap(s), p = [];
                    u && p.push("PROJECTION_GLOBE_VIEW");
                    const f = t1.stencilModeFor3D();
                    for (const s of _){
                        const r = s.toUnwrapped(), l = i.getTile(s);
                        if (!l.rasterParticleState) continue;
                        const _ = l.rasterParticleState, m = 100;
                        l.registerFadeDuration(m);
                        const g = i.findLoadedParent(s, 0), v = Ns(l, g, i, t1.transform, m);
                        let y, x;
                        t1.terrain && t1.terrain.prepareDrawTile(), a.activeTexture.set(n.TEXTURE0), _.targetColorTexture.bind(n.LINEAR, n.CLAMP_TO_EDGE), a.activeTexture.set(n.TEXTURE1), g && g.rasterParticleState ? (g.rasterParticleState.targetColorTexture.bind(n.LINEAR, n.CLAMP_TO_EDGE), y = Math.pow(2, g.tileID.overscaledZ - l.tileID.overscaledZ), x = [
                            l.tileID.canonical.x * y % 1,
                            l.tileID.canonical.y * y % 1
                        ]) : _.targetColorTexture.bind(n.LINEAR, n.CLAMP_TO_EDGE);
                        const b = u ? Float32Array.from(t1.transform.expandedFarZProjMatrix) : t1.transform.calculateProjMatrix(r, h), w = t1.transform, T = Jr(w), E = e.cE(s.canonical), S = e.cF(E.getCenter().lat);
                        let C, I, R, D, L;
                        u ? (C = Float32Array.from(e.bb(e.cH(s.canonical))), I = Float32Array.from(w.globeMatrix), R = Float32Array.from(e.cD(w)), D = [
                            e.at(w.center.lng),
                            e.aA(w.center.lat)
                        ], L = Float32Array.from(e.cG(s.canonical, E, S, w.worldSize / w._pixelsPerMercatorPixel))) : (C = new Float32Array(16), I = new Float32Array(9), R = new Float32Array(16), D = [
                            0,
                            0
                        ], L = new Float32Array(9));
                        const A = _r(b, C, I, R, L, x || [
                            0,
                            0
                        ], e.ae(t1.transform.zoom), D, T, y || 1, v, c), z = t1.isTileAffectedByFog(s), P = t1.getOrCreateProgram("rasterParticle", {
                            defines: p,
                            overrideFog: z
                        });
                        if (t1.uploadCommonUniforms(a, P, r), u) {
                            const e = new Bi(n.LEQUAL, Bi.ReadOnly, t1.depthRangeFor3D), i = 0, s = t1.globeSharedBuffers;
                            if (s) {
                                const [r, a, l] = s.getGridBuffers(S, 0 !== i);
                                P.draw(t1, n.TRIANGLES, e, f, ki.alphaBlended, t1.renderElevatedRasterBackface ? Vi.frontCCW : Vi.backCCW, A, o.id, r, a, l);
                            }
                        } else {
                            const e = t1.depthModeForSublayer(0, Bi.ReadOnly), i = d[s.overscaledZ], { tileBoundsBuffer: r, tileBoundsIndexBuffer: a, tileBoundsSegments: c } = t1.getTileBoundsBuffers(l);
                            P.draw(t1, n.TRIANGLES, e, i, ki.alphaBlended, Vi.disabled, A, o.id, r, a, c);
                        }
                    }
                    t1.resetStencilClippingMasks();
                }(t1, i, o, s), t1.style.map.triggerRepaint());
            },
            background: function(t1, i, o, s) {
                const r = o.paint.get("background-color"), a = "none" === o.paint.get("background-color-use-theme").constantOr("default"), n = o.paint.get("background-opacity"), l = o.paint.get("background-emissive-strength"), c = "viewport" === o.paint.get("background-pitch-alignment");
                if (0 === n) return;
                const h = t1.context, u = h.gl, d = t1.transform, _ = d.tileSize, p = o.paint.get("background-pattern");
                let f;
                if (void 0 !== p) {
                    if (null === p) return;
                    if (f = t1.imageManager.getPattern(p.toString(), o.scope, t1.style.getLut(o.scope)), !f) return;
                }
                const m = !p && 1 === r.a && 1 === n && t1.opaquePassEnabledForLayer() ? "opaque" : "translucent";
                if (t1.renderPass !== m) return;
                const g = Ui.disabled, v = t1.depthModeForSublayer(0, "opaque" === m ? Bi.ReadWrite : Bi.ReadOnly), y = t1.colorModeForDrapableLayerRenderPass(l), x = p ? "backgroundPattern" : "background";
                let b, w = s;
                if (w || (b = t1.getBackgroundTiles(), w = Object.values(b).map((e)=>e.tileID)), p && (h.activeTexture.set(u.TEXTURE0), t1.imageManager.bind(t1.context, o.scope)), c) {
                    const i = t1.getOrCreateProgram(x, {
                        overrideFog: !1,
                        overrideRtt: !0
                    }), s = new Float32Array(e.ab.mat4.identity([])), h = new e.aG(0, 0, 0, 0, 0), d = p ? yr(s, l, n, t1, 0, o.scope, f, c, {
                        tileID: h,
                        tileSize: _
                    }) : vr(s, l, n, r.toRenderColor(a ? null : o.lut));
                    i.draw(t1, u.TRIANGLES, v, g, y, Vi.disabled, d, o.id, t1.viewportBuffer, t1.quadTriangleIndexBuffer, t1.viewportSegments);
                } else for (const e of w){
                    const m = t1.isTileAffectedByFog(e), w = t1.getOrCreateProgram(x, {
                        overrideFog: m
                    }), T = e.toUnwrapped(), E = s ? e.projMatrix : t1.transform.calculateProjMatrix(T);
                    t1.prepareDrawTile();
                    const S = i ? i.getTile(e) : b ? b[e.key] : new bt(e, _, d.zoom, t1), C = p ? yr(E, l, n, t1, 0, o.scope, f, c, {
                        tileID: e,
                        tileSize: _
                    }) : vr(E, l, n, r.toRenderColor(a ? null : o.lut));
                    t1.uploadCommonUniforms(h, w, T);
                    const { tileBoundsBuffer: I, tileBoundsIndexBuffer: R, tileBoundsSegments: D } = t1.getTileBoundsBuffers(S);
                    w.draw(t1, u.TRIANGLES, v, g, y, Vi.disabled, C, o.id, I, R, D);
                }
            },
            sky: function(t1, i, o) {
                const s = t1._atmosphere ? e.ae(t1.transform.zoom) : 1, r = o.paint.get("sky-opacity") * s;
                if (0 === r) return;
                const a = t1.context, n = o.paint.get("sky-type"), l = new Bi(a.gl.LEQUAL, Bi.ReadOnly, [
                    0,
                    1
                ]), c = t1.frameCounter / 1e3 % 1;
                "atmosphere" === n ? "offscreen" === t1.renderPass ? o.needsSkyboxCapture(t1) && (function(t1, i, o, s) {
                    const r = t1.context, a = r.gl;
                    let n = i.skyboxFbo;
                    if (!n) {
                        n = i.skyboxFbo = r.createFramebuffer(32, 32, !0, null), i.skyboxGeometry = new ua(r), i.skyboxTexture = r.gl.createTexture(), a.bindTexture(a.TEXTURE_CUBE_MAP, i.skyboxTexture), a.texParameteri(a.TEXTURE_CUBE_MAP, a.TEXTURE_WRAP_S, a.CLAMP_TO_EDGE), a.texParameteri(a.TEXTURE_CUBE_MAP, a.TEXTURE_WRAP_T, a.CLAMP_TO_EDGE), a.texParameteri(a.TEXTURE_CUBE_MAP, a.TEXTURE_MIN_FILTER, a.LINEAR), a.texParameteri(a.TEXTURE_CUBE_MAP, a.TEXTURE_MAG_FILTER, a.LINEAR);
                        for(let e = 0; e < 6; ++e)a.texImage2D(a.TEXTURE_CUBE_MAP_POSITIVE_X + e, 0, a.RGBA, 32, 32, 0, a.RGBA, a.UNSIGNED_BYTE, null);
                    }
                    r.bindFramebuffer.set(n.framebuffer), r.viewport.set([
                        0,
                        0,
                        32,
                        32
                    ]);
                    const l = i.getCenter(t1, !0), c = t1.getOrCreateProgram("skyboxCapture"), h = new Float64Array(16);
                    e.ab.mat4.identity(h), e.ab.mat4.rotateY(h, h, .5 * -Math.PI), da(t1, i, c, h, l, 0), e.ab.mat4.identity(h), e.ab.mat4.rotateY(h, h, .5 * Math.PI), da(t1, i, c, h, l, 1), e.ab.mat4.identity(h), e.ab.mat4.rotateX(h, h, .5 * -Math.PI), da(t1, i, c, h, l, 2), e.ab.mat4.identity(h), e.ab.mat4.rotateX(h, h, .5 * Math.PI), da(t1, i, c, h, l, 3), e.ab.mat4.identity(h), da(t1, i, c, h, l, 4), e.ab.mat4.identity(h), e.ab.mat4.rotateY(h, h, Math.PI), da(t1, i, c, h, l, 5), r.viewport.set([
                        0,
                        0,
                        t1.width,
                        t1.height
                    ]);
                }(t1, o), o.markSkyboxValid(t1)) : "sky" === t1.renderPass && function(e, t1, i, o, s) {
                    const r = e.context, a = r.gl, n = e.transform, l = e.getOrCreateProgram("skybox");
                    r.activeTexture.set(a.TEXTURE0), a.bindTexture(a.TEXTURE_CUBE_MAP, t1.skyboxTexture);
                    const c = ((e, t1, i, o, s)=>({
                            u_matrix: e,
                            u_sun_direction: t1,
                            u_cubemap: 0,
                            u_opacity: o,
                            u_temporal_offset: s
                        }))(n.skyboxMatrix, t1.getCenter(e, !1), 0, o, s);
                    e.uploadCommonUniforms(r, l), l.draw(e, a.TRIANGLES, i, Ui.disabled, e.colorModeForRenderPass(), Vi.backCW, c, "skybox", t1.skyboxGeometry.vertexBuffer, t1.skyboxGeometry.indexBuffer, t1.skyboxGeometry.segment);
                }(t1, o, l, r, c) : "gradient" === n && "sky" === t1.renderPass && function(t1, i, o, s, r) {
                    const a = t1.context, n = a.gl, l = t1.transform, c = t1.getOrCreateProgram("skyboxGradient");
                    i.skyboxGeometry || (i.skyboxGeometry = new ua(a)), a.activeTexture.set(n.TEXTURE0);
                    let h = i.colorRampTexture;
                    h || (h = i.colorRampTexture = new e.T(a, i.colorRamp, n.RGBA8)), h.bind(n.LINEAR, n.CLAMP_TO_EDGE);
                    const u = ((t1, i, o, s, r)=>({
                            u_matrix: t1,
                            u_color_ramp: 0,
                            u_center_direction: i,
                            u_radius: e.ai(o),
                            u_opacity: s,
                            u_temporal_offset: r
                        }))(l.skyboxMatrix, i.getCenter(t1, !1), i.paint.get("sky-gradient-radius"), s, r);
                    t1.uploadCommonUniforms(a, c), c.draw(t1, n.TRIANGLES, o, Ui.disabled, t1.colorModeForRenderPass(), Vi.backCW, u, "skyboxGradient", i.skyboxGeometry.vertexBuffer, i.skyboxGeometry.indexBuffer, i.skyboxGeometry.segment);
                }(t1, o, l, r, c);
            },
            debug: function(t1, i, o, s, r, a) {
                for(let n = 0; n < o.length; n++)if (r) {
                    const r = 1, l = .8, c = new e.aj(s.r * l, s.g * l, s.b * l, 1);
                    sa(t1, i, o[n], s, -r, -r, a), sa(t1, i, o[n], s, -r, r, a), sa(t1, i, o[n], s, r, r, a), sa(t1, i, o[n], s, r, -r, a), sa(t1, i, o[n], c, 0, 0, a);
                } else sa(t1, i, o[n], s, 0, 0, a);
            },
            custom: function(t1, i, o, s) {
                const r = t1.context, a = o.implementation;
                if (!t1.transform.projection.unsupportedLayers || !t1.transform.projection.unsupportedLayers.includes("custom") || t1.terrain && (t1.terrain.renderingToTexture || "offscreen" === t1.renderPass) && o.isDraped(i)) {
                    if ("offscreen" === t1.renderPass) {
                        const i = a.prerender;
                        if (i) {
                            if (t1.setCustomLayerDefaults(), r.setColorMode(t1.colorModeForRenderPass()), "globe" === t1.transform.projection.name) {
                                const o = t1.transform.pointMerc;
                                i.call(a, r.gl, t1.transform.customLayerMatrix(), t1.transform.getProjection(), t1.transform.globeToMercatorMatrix(), e.ae(t1.transform.zoom), [
                                    o.x,
                                    o.y
                                ], t1.transform.pixelsPerMeterRatio);
                            } else i.call(a, r.gl, t1.transform.customLayerMatrix());
                            r.setDirty(), t1.setBaseState();
                        }
                    } else if ("translucent" === t1.renderPass) {
                        if (t1.terrain && t1.terrain.renderingToTexture) {
                            const i = a.renderToTile;
                            if (i) {
                                const o = s[0].canonical, n = new e.aa(o.x + s[0].wrap * (1 << o.z), o.y, o.z);
                                r.setDepthMode(Bi.disabled), r.setStencilMode(Ui.disabled), r.setColorMode(t1.colorModeForRenderPass()), t1.setCustomLayerDefaults(), i.call(a, r.gl, n), r.setDirty(), t1.setBaseState();
                            }
                            return;
                        }
                        t1.setCustomLayerDefaults(), r.setColorMode(t1.colorModeForRenderPass()), r.setStencilMode(Ui.disabled);
                        const i = "3d" === a.renderingMode ? new Bi(t1.context.gl.LEQUAL, Bi.ReadWrite, t1.depthRangeFor3D) : t1.depthModeForSublayer(0, Bi.ReadOnly);
                        if (r.setDepthMode(i), "globe" === t1.transform.projection.name) {
                            const i = t1.transform.pointMerc;
                            a.render(r.gl, t1.transform.customLayerMatrix(), t1.transform.getProjection(), t1.transform.globeToMercatorMatrix(), e.ae(t1.transform.zoom), [
                                i.x,
                                i.y
                            ], t1.transform.pixelsPerMeterRatio);
                        } else a.render(r.gl, t1.transform.customLayerMatrix());
                        r.setDirty(), t1.setBaseState(), r.bindFramebuffer.set(null);
                    }
                } else e.w("Custom layers are not yet supported with this projection. Use mercator or globe to enable usage of custom layers.");
            },
            model: function(t1, i, o, s) {
                if ("opaque" === t1.renderPass) return;
                const r = o.paint.get("model-opacity").constantOr(1);
                if (0 === r) return;
                const a = o.paint.get("model-cast-shadows");
                if ("shadow" === t1.renderPass) {
                    if (!a) return;
                    if (t1.terrain && r < .65 && o._transitionablePaint._values["model-opacity"].value.expression instanceof e.a9) return;
                }
                const n = t1.shadowRenderer, l = o.paint.get("model-receive-shadows");
                n && (n.useNormalOffset = !0, l || (n.enabled = !1));
                const c = ()=>{
                    n && (n.useNormalOffset = !0, l || (n.enabled = !0));
                }, h = i.getSource();
                if ("light-beam" === t1.renderPass && "batched-model" !== h.type) return;
                if ("vector" === h.type || "geojson" === h.type) return function(t1, i, o, s, r) {
                    const a = t1.transform;
                    if ("mercator" !== a.projection.name) return void e.w(`Drawing 3D models for ${a.projection.name} projection is not yet implemented`);
                    const n = a.getFreeCameraOptions().position;
                    if (!t1.modelManager) return;
                    const l = t1.modelManager;
                    o.modelManager = l;
                    const c = t1.shadowRenderer;
                    if (!o._unevaluatedLayout._values.hasOwnProperty("model-id")) return;
                    const h = o._unevaluatedLayout._values["model-id"], u = Object.assign({}, o.layout.get("model-id").parameters), d = t1.style.order.indexOf(o.fqid);
                    for (const _ of s){
                        const s = i.getTile(_).getBucket(o);
                        if (!s || s.projection.name !== a.projection.name) continue;
                        const p = s.getModelUris();
                        p && !s.modelsRequested && (l.addModelsFromBucket(p, r), s.modelsRequested = !0);
                        const f = Sa(_, a);
                        u.zoom = f;
                        const m = h.possiblyEvaluate(u);
                        if (Ta(t1, s, _), Ea.shadowUniformsInitialized = !1, Ea.useSingleShadowCascade = !!c && 0 === c.getMaxCascadeForTile(_.toUnwrapped()), "shadow" === t1.renderPass && c) {
                            if (1 === t1.currentShadowCascade && s.isInsideFirstShadowMapFrustum) continue;
                            const i = a.calculatePosMatrix(_.toUnwrapped(), a.worldSize);
                            if (Ea.tileMatrix.set(i), Ea.shadowTileMatrix = Float32Array.from(c.calculateShadowPassMatrixFromMatrix(i)), Ea.aabb.min.fill(0), Ea.aabb.max[0] = Ea.aabb.max[1] = e.ag, Ea.aabb.max[2] = 0, Ra(s, Ea, t1, o.scope)) continue;
                        }
                        const g = 1 << _.canonical.z, v = [
                            ((n.x - _.wrap) * g - _.canonical.x) * e.ag,
                            (n.y * g - _.canonical.y) * e.ag,
                            n.z * g * e.ag
                        ];
                        t1.conflationActive && Object.keys(s.instancesPerModel).length > 0 && t1.style.isLayerClipped(o, i.getSource()) && s.updateReplacement(_, t1.replacementSource, d, r) && (s.uploaded = !1, s.upload(t1.context));
                        for(let e in s.instancesPerModel){
                            const i = s.instancesPerModel[e];
                            i.features.length > 0 && (e = m.evaluate(i.features[0].feature, {}));
                            const a = l.getModel(e, r);
                            if (a && a.uploaded) for (const e of a.nodes)Ca(t1, o, e, i, v, _, Ea);
                        }
                    }
                }(t1, i, o, s, "vector" === h.type ? o.scope : ""), void c();
                if (!h.loaded()) return;
                if ("batched-model" === h.type) return function(t1, i, o, s) {
                    o.resetLayerRenderingStats(t1);
                    const r = t1.context, a = t1.transform, n = t1.style.fog, l = t1.shadowRenderer;
                    if ("mercator" !== a.projection.name) return void e.w(`Drawing 3D landmark models for ${a.projection.name} projection is not yet implemented`);
                    const c = t1.transform.getFreeCameraOptions().position, h = e.ab.vec3.scale([], [
                        c.x,
                        c.y,
                        c.z
                    ], t1.transform.worldSize), u = e.ab.vec3.negate([], h), d = e.ab.mat4.identity([]), _ = e.dj(a.center.lat, a.zoom), p = e.ab.mat4.fromScaling([], [
                        1,
                        1,
                        1 / _
                    ]);
                    e.ab.mat4.translate(d, d, u);
                    const f = o.paint.get("model-opacity").constantOr(1), m = new Bi(r.gl.LEQUAL, Bi.ReadWrite, t1.depthRangeFor3D), g = new Bi(r.gl.LEQUAL, Bi.ReadOnly, t1.depthRangeFor3D), v = new e.cd([
                        1 / 0,
                        1 / 0,
                        1 / 0
                    ], [
                        -1 / 0,
                        -1 / 0,
                        -1 / 0
                    ]), y = "shadow" === t1.renderPass, x = y && l ? l.getCurrentCascadeFrustum() : a.getFrustum(a.scaleZoom(a.worldSize)), b = o.paint.get("model-front-cutoff"), w = b[2] < 1, T = eo(t1, o.paint.get("model-cutoff-fade-range")), E = o.getLayerRenderingStats();
                    (function(e, t1, i, o) {
                        const s = e.terrain ? e.terrain.exaggeration() : 0, r = e.transform.zoom;
                        for (const a of o){
                            const o = t1.getTile(a).getBucket(i);
                            o && (e.conflationActive && o.updateReplacement(a, e.replacementSource), o.evaluateScale(e, i), e.terrain && s > 0 && o.elevationUpdate(e.terrain, s, a, i.source), o.needsReEvaluation(e, r, i) && o.evaluate(i));
                        }
                    })(t1, i, o, s), function() {
                        let c, u, S;
                        w ? (c = s.length - 1, u = -1, S = -1) : (c = 0, u = s.length, S = 1);
                        const C = new Float64Array(16), I = e.ab.vec3.create(), R = new e.P(0, 0);
                        for(let D = c; D !== u; D += S){
                            const c = s[D], u = i.getTile(c).getBucket(o);
                            if (!u || !u.uploaded) continue;
                            let S = !1;
                            l && (S = 0 === l.getMaxCascadeForTile(c.toUnwrapped()));
                            const L = a.calculatePosMatrix(c.toUnwrapped(), a.worldSize), A = u.modelTraits;
                            !y && w && (e.ab.mat4.invert(C, L), e.ab.vec3.transformMat4(I, h, C), R.x = I[0], R.y = I[1]);
                            const z = [];
                            for (const i of u.getNodesInfo()){
                                if (i.hiddenByReplacement) continue;
                                if (!i.node.meshes) continue;
                                const o = i.node;
                                let s = 0;
                                t1.terrain && o.elevation && (s = o.elevation * t1.terrain.exaggeration());
                                const r = (()=>{
                                    const t1 = i.aabb;
                                    return v.min = [
                                        ...t1.min
                                    ], v.max = [
                                        ...t1.max
                                    ], v.min[2] += s, v.max[2] += s, e.ab.vec3.transformMat4(v.min, v.min, L), e.ab.vec3.transformMat4(v.max, v.max, L), v;
                                })(), n = i.evaluatedScale;
                                if (n[0] <= 1 && n[1] <= 1 && n[2] <= 1 && 0 === r.intersects(x)) continue;
                                if (!y && w) {
                                    const t1 = 1 / 6;
                                    i.cameraCollisionOpacity = h[0] > r.min[0] && h[0] < r.max[0] && h[1] > r.min[1] && h[1] < r.max[1] && h[2] * _ < r.max[2] && o.footprint && e.bA(R, o.footprint) ? Math.max(i.cameraCollisionOpacity - t1, 0) : Math.min(1, i.cameraCollisionOpacity + t1);
                                }
                                const l = [
                                    ...L
                                ], c = o.anchor ? o.anchor[0] : 0, u = o.anchor ? o.anchor[1] : 0;
                                e.ab.mat4.translate(l, l, [
                                    c * (n[0] - 1),
                                    u * (n[1] - 1),
                                    s
                                ]), e.ab.vec3.exactEquals(n, e.dm) || e.ab.mat4.scale(l, l, n);
                                const d = e.ab.mat4.multiply([], l, o.matrix), p = e.ab.mat4.multiply([], a.expandedFarZProjMatrix, d), m = e.ab.mat4.multiply([], a.expandedFarZProjMatrix, l), g = e.ab.vec4.transformMat4([], [
                                    c,
                                    u,
                                    s,
                                    1
                                ], p)[2];
                                o.hidden = !1;
                                let E = f;
                                y || (w && (E *= i.cameraCollisionOpacity, E *= La(l, a, i.aabb, b)), E *= Da(T, g)), 0 !== E ? z.push({
                                    nodeInfo: i,
                                    depth: g,
                                    opacity: E,
                                    wvpForNode: p,
                                    wvpForTile: m,
                                    nodeModelMatrix: d,
                                    tileModelMatrix: l
                                }) : o.hidden = !0;
                            }
                            y || z.sort((e, t1)=>!w || 1 === e.opacity && 1 === t1.opacity ? e.depth < t1.depth ? -1 : 1 : 1 === e.opacity ? -1 : 1 === t1.opacity ? 1 : e.depth > t1.depth ? -1 : 1);
                            for (const i of z){
                                const s = i.nodeInfo, c = s.node;
                                let h = e.ab.mat4.multiply([], p, i.tileModelMatrix);
                                e.ab.mat4.multiply(h, d, h);
                                const u = e.ab.mat4.invert([], h);
                                e.ab.mat4.transpose(u, u), e.ab.mat4.scale(u, u, Ia), h = e.ab.mat4.multiply(h, h, c.matrix);
                                const _ = "light-beam" === t1.renderPass, f = "none" === o.paint.get("model-color-use-theme").constantOr("default"), v = A & e.dp.HasMapboxMeshFeatures, x = v ? 0 : s.evaluatedRMEA[0][2];
                                for(let e = 0; e < c.meshes.length; ++e){
                                    const d = c.meshes[e], p = e === c.lightMeshIndex;
                                    let b = i.wvpForNode;
                                    if (p) {
                                        if (!_ && !t1.terrain && t1.shadowRenderer) {
                                            t1.currentLayer < t1.firstLightBeamLayer && (t1.firstLightBeamLayer = t1.currentLayer);
                                            continue;
                                        }
                                        b = i.wvpForTile;
                                    } else if (_) continue;
                                    const w = {
                                        defines: []
                                    }, T = [];
                                    if (!y && l && (l.useNormalOffset = !!d.normalBuffer), ya(w.defines, T, d, t1, f ? null : o.lut), v || w.defines.push("DIFFUSE_SHADED"), S && w.defines.push("SHADOWS_SINGLE_CASCADE"), E && (y ? E.numRenderedVerticesInShadowPass += d.vertexArray.length : E.numRenderedVerticesInTransparentPass += d.vertexArray.length), y) {
                                        wa(d, i.nodeModelMatrix, t1, o);
                                        continue;
                                    }
                                    let C = null;
                                    if (n) {
                                        const e = va(i.nodeModelMatrix, t1.transform);
                                        if (C = new Float32Array(e), "globe" !== a.projection.name) {
                                            const t1 = d.aabb.min, i = d.aabb.max, [o, s] = n.getOpacityForBounds(e, t1[0], t1[1], i[0], i[1]);
                                            w.overrideFog = o >= Fe || s >= Fe;
                                        }
                                    }
                                    const I = d.material;
                                    let R;
                                    I.occlusionTexture && I.occlusionTexture.offsetScale && (R = I.occlusionTexture.offsetScale, w.defines.push("OCCLUSION_TEXTURE_TRANSFORM"));
                                    const D = t1.getOrCreateProgram("model", w);
                                    !y && l && l.setupShadowsFromMatrix(i.tileModelMatrix, D, l.useNormalOffset), t1.uploadCommonUniforms(r, D, null, C);
                                    const L = I.pbrMetallicRoughness;
                                    L.metallicFactor = .9, L.roughnessFactor = .5;
                                    const A = br(new Float32Array(b), new Float32Array(h), new Float32Array(u), new Float32Array(c.matrix), t1, i.opacity, L.baseColorFactor.toRenderColor(null), I.emissiveFactor, L.metallicFactor, L.roughnessFactor, I, x, o, [
                                        0,
                                        0,
                                        0
                                    ], R);
                                    !p && (s.hasTranslucentParts || i.opacity < 1) && D.draw(t1, r.gl.TRIANGLES, m, Ui.disabled, ki.disabled, Vi.backCCW, A, o.id, d.vertexBuffer, d.indexBuffer, d.segments, o.paint, t1.transform.zoom, void 0, T), D.draw(t1, r.gl.TRIANGLES, p ? g : m, Ui.disabled, p || i.opacity < 1 || s.hasTranslucentParts ? ki.alphaBlended : ki.unblended, Vi.backCCW, A, o.id, d.vertexBuffer, d.indexBuffer, d.segments, o.paint, t1.transform.zoom, void 0, T);
                                }
                            }
                        }
                    }();
                }(t1, i, o, s), void c();
                if ("model" !== h.type) return;
                const u = h.getModels(), d = [], _ = t1.transform.getFreeCameraOptions().position, p = e.ab.vec3.scale([], [
                    _.x,
                    _.y,
                    _.z
                ], t1.transform.worldSize);
                e.ab.vec3.negate(p, p);
                const f = [], m = [];
                let g = 0;
                for (const i of u){
                    const s = o.paint.get("model-rotation").constantOr(null), r = o.paint.get("model-scale").constantOr(null), a = o.paint.get("model-translation").constantOr(null);
                    i.computeModelMatrix(t1, s, r, a, !0, !0, !1);
                    const n = e.ab.mat4.identity([]), l = e.dj(i.position.lat, t1.transform.zoom), c = e.ab.mat4.fromScaling([], [
                        1,
                        1,
                        1 / l
                    ]);
                    e.ab.mat4.translate(n, n, p), d.push({
                        zScaleMatrix: c,
                        negCameraPosMatrix: n
                    });
                    for (const e of i.nodes)ba(t1.transform, e, i.matrix, t1.transform.expandedFarZProjMatrix, g, f, m);
                    g++;
                }
                if (f.sort((e, t1)=>t1.depth - e.depth), "shadow" !== t1.renderPass) {
                    if (1 === r) for (const e of m)xa(e, t1, o, d[e.modelIndex], Ui.disabled, t1.colorModeForRenderPass());
                    else {
                        for (const e of m)xa(e, t1, o, d[e.modelIndex], Ui.disabled, ki.disabled);
                        for (const e of m)xa(e, t1, o, d[e.modelIndex], t1.stencilModeFor3D(), t1.colorModeForRenderPass());
                        t1.resetStencilClippingMasks();
                    }
                    for (const e of f)xa(e, t1, o, d[e.modelIndex], Ui.disabled, t1.colorModeForRenderPass());
                    c();
                } else {
                    for (const e of m)wa(e.mesh, e.nodeModelMatrix, t1, o);
                    for (const e of f)wa(e.mesh, e.nodeModelMatrix, t1, o);
                    c();
                }
            }
        }, $a = {
            line: function(e, t1, i) {
                if (e.hasElevatedBuckets = !1, e.hasNonElevatedBuckets = !1, void 0 !== e._unevaluatedLayout.getValue("line-elevation-reference") || void 0 !== e._unevaluatedLayout.getValue("line-z-offset")) {
                    if (t1) {
                        const i = t1.getVisibleCoordinates();
                        for (const o of i){
                            const i = t1.getTile(o).getBucket(e);
                            if (i && (i.hasZOffset ? e.hasElevatedBuckets = !0 : e.hasNonElevatedBuckets = !0, e.hasElevatedBuckets && e.hasNonElevatedBuckets)) break;
                        }
                    }
                } else e.hasNonElevatedBuckets = !0;
            },
            model: function(e, t1, i) {
                const o = t1.getSource();
                if (!o.loaded()) return;
                if ("vector" === o.type || "geojson" === o.type) return void (i.modelManager && i.modelManager.upload(i, "vector" === o.type ? e.scope : ""));
                if ("batched-model" === o.type) return;
                if ("model" !== o.type) return;
                const s = o.getModels();
                for (const e of s)e.upload(i.context);
            },
            raster: function(e, t1, i) {
                const o = t1.getSource();
                if (!(o instanceof ot && o.loaded())) return;
                const s = e.sourceLayer || o.rasterLayerIds && o.rasterLayerIds[0];
                if (!s) return;
                const r = e.paint.get("raster-array-band") || o.getInitialBand(s);
                if (null == r) return;
                const a = t1.getIds().map((e)=>t1.getTileByID(e));
                for (const e of a)e.updateNeeded(s, r) && o.prepareTile(e, s, r);
            },
            "raster-particle": function(e, t1, i) {
                const o = t1.getSource();
                if (!(o instanceof ot && o.loaded())) return;
                const s = e.sourceLayer || o.rasterLayerIds && o.rasterLayerIds[0];
                if (!s) return;
                const r = e.paint.get("raster-particle-array-band") || o.getInitialBand(s);
                if (null == r) return;
                const a = t1.getIds().map((e)=>t1.getTileByID(e));
                for (const e of a)e.updateNeeded(s, r) && o.prepareTile(e, s, r);
            }
        };
        class Xa {
            updateTerrain(e, t1) {
                const i = !!e && !!e.terrain && this.transform.projection.supportsTerrain;
                if (!(i || this._terrain && this._terrain.enabled)) return;
                this._terrain || (this._terrain = new Vs(this, e));
                const o = this._terrain;
                this.transform.elevation = i ? o : null, o.update(e, this.transform, t1), this.transform.elevation && !o.enabled && (this.transform.elevation = null);
            }
            _updateFog(e) {
                const t1 = e.fog;
                if (!t1 || "globe" === this.transform.projection.name || t1.getOpacity(this.transform.pitch) < 1 || t1.properties.get("horizon-blend") < .03) return void (this.transform.fogCullDistSq = null);
                const [i, o] = t1.getFovAdjustedRange(this.transform._fov);
                if (i > o) return void (this.transform.fogCullDistSq = null);
                const s = i + .78 * (o - i);
                this.transform.fogCullDistSq = s * s;
            }
            get terrain() {
                return this.transform._terrainEnabled() && this._terrain && this._terrain.enabled || this._forceTerrainMode ? this._terrain : null;
            }
            get forceTerrainMode() {
                return this._forceTerrainMode;
            }
            set forceTerrainMode(e) {
                e && !this._terrain && (this._terrain = new Vs(this, this.style)), this._forceTerrainMode = e;
            }
            get shadowRenderer() {
                return this._shadowRenderer && this._shadowRenderer.enabled ? this._shadowRenderer : null;
            }
            get wireframeDebugCache() {
                return this._wireframeDebugCache;
            }
            resize(t1, i) {
                if (this.width = t1 * e.q.devicePixelRatio, this.height = i * e.q.devicePixelRatio, this.context.viewport.set([
                    0,
                    0,
                    this.width,
                    this.height
                ]), this.style) for (const e of this.style.order)this.style._mergedLayers[e].resize();
            }
            setup() {
                const t1 = this.context, i = new e.b4;
                i.emplaceBack(0, 0), i.emplaceBack(e.ag, 0), i.emplaceBack(0, e.ag), i.emplaceBack(e.ag, e.ag), this.tileExtentBuffer = t1.createVertexBuffer(i, e.b6.members), this.tileExtentSegments = e.b7.simpleSegment(0, 0, 4, 2);
                const o = new e.b4;
                o.emplaceBack(0, 0), o.emplaceBack(e.ag, 0), o.emplaceBack(0, e.ag), o.emplaceBack(e.ag, e.ag), this.debugBuffer = t1.createVertexBuffer(o, e.b6.members), this.debugSegments = e.b7.simpleSegment(0, 0, 4, 5);
                const s = new e.b4;
                s.emplaceBack(-1, -1), s.emplaceBack(1, -1), s.emplaceBack(-1, 1), s.emplaceBack(1, 1), this.viewportBuffer = t1.createVertexBuffer(s, e.b6.members), this.viewportSegments = e.b7.simpleSegment(0, 0, 4, 2);
                const r = new e.aT;
                r.emplaceBack(0, 0, 0, 0), r.emplaceBack(e.ag, 0, e.ag, 0), r.emplaceBack(0, e.ag, 0, e.ag), r.emplaceBack(e.ag, e.ag, e.ag, e.ag), this.mercatorBoundsBuffer = t1.createVertexBuffer(r, e.b9.members), this.mercatorBoundsSegments = e.b7.simpleSegment(0, 0, 4, 2);
                const a = new e.aU;
                a.emplaceBack(0, 1, 2), a.emplaceBack(2, 1, 3), this.quadTriangleIndexBuffer = t1.createIndexBuffer(a);
                const n = new e.b5;
                for (const e of [
                    0,
                    1,
                    3,
                    2,
                    0
                ])n.emplaceBack(e);
                this.debugIndexBuffer = t1.createIndexBuffer(n), this.emptyTexture = new e.T(t1, new e.r({
                    width: 1,
                    height: 1
                }, Uint8Array.of(0, 0, 0, 0)), t1.gl.RGBA8), this.identityMat = e.ab.mat4.create();
                const l = this.context.gl;
                this.stencilClearMode = new Ui({
                    func: l.ALWAYS,
                    mask: 0
                }, 0, 255, l.ZERO, l.ZERO, l.ZERO), this.loadTimeStamps.push(performance.now());
            }
            getMercatorTileBoundsBuffers() {
                return {
                    tileBoundsBuffer: this.mercatorBoundsBuffer,
                    tileBoundsIndexBuffer: this.quadTriangleIndexBuffer,
                    tileBoundsSegments: this.mercatorBoundsSegments
                };
            }
            getTileBoundsBuffers(e) {
                return e._makeTileBoundsBuffers(this.context, this.transform.projection), e._tileBoundsBuffer ? {
                    tileBoundsBuffer: e._tileBoundsBuffer,
                    tileBoundsIndexBuffer: e._tileBoundsIndexBuffer,
                    tileBoundsSegments: e._tileBoundsSegments
                } : this.getMercatorTileBoundsBuffers();
            }
            clearStencil() {
                const e = this.context.gl;
                this.nextStencilID = 1, this.currentStencilSource = void 0, this._tileClippingMaskIDs = {}, this.getOrCreateProgram("clippingMask").draw(this, e.TRIANGLES, Bi.disabled, this.stencilClearMode, ki.disabled, Vi.disabled, Bs(this.identityMat), "$clipping", this.viewportBuffer, this.quadTriangleIndexBuffer, this.viewportSegments);
            }
            resetStencilClippingMasks() {
                this.terrain || (this.currentStencilSource = void 0, this._tileClippingMaskIDs = {});
            }
            _renderTileClippingMasks(e, t1, i) {
                if (!t1 || this.currentStencilSource === t1.id || !e.isTileClipped() || !i || 0 === i.length) return;
                if (this._tileClippingMaskIDs && !this.terrain) {
                    let e = !1;
                    for (const t1 of i)if (void 0 === this._tileClippingMaskIDs[t1.key]) {
                        e = !0;
                        break;
                    }
                    if (!e) return;
                }
                this.currentStencilSource = t1.id;
                const o = this.context, s = o.gl;
                this.nextStencilID + i.length > 256 && this.clearStencil(), o.setColorMode(ki.disabled), o.setDepthMode(Bi.disabled);
                const r = this.getOrCreateProgram("clippingMask");
                this._tileClippingMaskIDs = {};
                for (const e of i){
                    const i = t1.getTile(e), o = this._tileClippingMaskIDs[e.key] = this.nextStencilID++, { tileBoundsBuffer: a, tileBoundsIndexBuffer: n, tileBoundsSegments: l } = this.getTileBoundsBuffers(i);
                    r.draw(this, s.TRIANGLES, Bi.disabled, new Ui({
                        func: s.ALWAYS,
                        mask: 0
                    }, o, 255, s.KEEP, s.KEEP, s.REPLACE), ki.disabled, Vi.disabled, Bs(e.projMatrix), "$clipping", a, n, l);
                }
            }
            stencilModeFor3D() {
                this.currentStencilSource = void 0, this.nextStencilID + 1 > 256 && this.clearStencil();
                const e = this.nextStencilID++, t1 = this.context.gl;
                return new Ui({
                    func: t1.NOTEQUAL,
                    mask: 255
                }, e, 255, t1.KEEP, t1.KEEP, t1.REPLACE);
            }
            stencilModeForClipping(e) {
                if (this.terrain) return this.terrain.stencilModeForRTTOverlap(e);
                const t1 = this.context.gl;
                return new Ui({
                    func: t1.EQUAL,
                    mask: 255
                }, this._tileClippingMaskIDs[e.key], 0, t1.KEEP, t1.KEEP, t1.REPLACE);
            }
            stencilConfigForOverlap(e) {
                const t1 = this.context.gl, i = e.sort((e, t1)=>t1.overscaledZ - e.overscaledZ), o = i[i.length - 1].overscaledZ, s = i[0].overscaledZ - o + 1;
                if (s > 1) {
                    this.currentStencilSource = void 0, this.nextStencilID + s > 256 && this.clearStencil();
                    const e = {};
                    for(let i = 0; i < s; i++)e[i + o] = new Ui({
                        func: t1.GEQUAL,
                        mask: 255
                    }, i + this.nextStencilID, 255, t1.KEEP, t1.KEEP, t1.REPLACE);
                    return this.nextStencilID += s, [
                        e,
                        i
                    ];
                }
                return [
                    {
                        [o]: Ui.disabled
                    },
                    i
                ];
            }
            colorModeForRenderPass() {
                const t1 = this.context.gl;
                if (this._showOverdrawInspector) {
                    const i = 1 / 8;
                    return new ki([
                        t1.CONSTANT_COLOR,
                        t1.ONE,
                        t1.CONSTANT_COLOR,
                        t1.ONE
                    ], new e.aj(i, i, i, 0), [
                        !0,
                        !0,
                        !0,
                        !0
                    ]);
                }
                return "opaque" === this.renderPass ? ki.unblended : ki.alphaBlended;
            }
            colorModeForDrapableLayerRenderPass(t1) {
                const i = this.context.gl;
                return (()=>this.style && this.style.enable3dLights() && this.terrain && this.terrain.renderingToTexture)() && "translucent" === this.renderPass ? new ki([
                    i.ONE,
                    i.ONE_MINUS_SRC_ALPHA,
                    i.CONSTANT_ALPHA,
                    i.ONE_MINUS_SRC_ALPHA
                ], new e.aj(0, 0, 0, void 0 === t1 ? 0 : t1), [
                    !0,
                    !0,
                    !0,
                    !0
                ]) : this.colorModeForRenderPass();
            }
            depthModeForSublayer(e, t1, i, o = !1) {
                if (this.depthOcclusion) return new Bi(this.context.gl.GREATER, Bi.ReadOnly, this.depthRangeFor3D);
                if (!this.opaquePassEnabledForLayer() && !o) return Bi.disabled;
                const s = 1 - ((1 + this.currentLayer) * this.numSublayers + e) * this.depthEpsilon;
                return new Bi(i || this.context.gl.LEQUAL, t1, [
                    s,
                    s
                ]);
            }
            opaquePassEnabledForLayer() {
                return this.currentLayer < this.opaquePassCutoff;
            }
            blitDepth() {
                const t1 = this.context.gl, i = Math.ceil(this.width), o = Math.ceil(this.height), s = this.context.bindFramebuffer.get(), r = t1.getParameter(t1.TEXTURE_BINDING_2D);
                this.depthFBO && this.depthFBO.width === i && this.depthFBO.height === o || (this.depthFBO && (this.depthFBO.destroy(), this.depthFBO = void 0, this.depthTexture = void 0), 0 !== i && 0 !== o && (this.depthFBO = new Ir(this.context, i, o, !1, "texture"), this.depthTexture = new e.T(this.context, {
                    width: i,
                    height: o,
                    data: null
                }, t1.DEPTH24_STENCIL8), this.depthFBO.depthAttachment.set(this.depthTexture.texture))), this.context.bindFramebuffer.set(s), t1.bindTexture(t1.TEXTURE_2D, r), this.depthFBO && (t1.bindFramebuffer(t1.READ_FRAMEBUFFER, null), t1.bindFramebuffer(t1.DRAW_FRAMEBUFFER, this.depthFBO.framebuffer), t1.blitFramebuffer(0, 0, i, o, 0, 0, i, o, t1.DEPTH_BUFFER_BIT, t1.NEAREST), t1.bindFramebuffer(t1.FRAMEBUFFER, this.context.bindFramebuffer.current));
            }
            updateAverageFPS() {
                this._fpsHistory.push(0 === this._dt ? 0 : 1e3 / this._dt), this._fpsHistory.length > this._debugParams.fpsWindow && this._fpsHistory.splice(0, this._fpsHistory.length - this._debugParams.fpsWindow), this._averageFPS = Math.round(this._fpsHistory.reduce((e, t1)=>e + t1 / this._fpsHistory.length, 0));
            }
            render(t1, i) {
                const o = e.q.now();
                this._dt = o - this._timeStamp, this._timeStamp = o, this._wireframeDebugCache.update(this.frameCounter), this._debugParams.continousRedraw = t1.map.repaint, this.style = t1, this.options = i;
                const s = this.style._mergedLayers, r = !(!this.terrain || !this.terrain.enabled), a = ()=>this.style._getOrder(r).filter((e)=>{
                        const t1 = s[e];
                        return !(t1.type in this._debugParams.enabledLayers) || this._debugParams.enabledLayers[t1.type];
                    });
                let n = a(), l = !1, c = !1;
                for (const e of n){
                    const t1 = s[e];
                    "circle" === t1.type && (l = !0), "symbol" === t1.type && (t1.hasInitialOcclusionOpacityProperties ? c = !0 : l = !0);
                }
                let h = n.map((e)=>s[e]);
                const u = this.style._mergedSourceCaches;
                this.imageManager = t1.imageManager, this.modelManager = t1.modelManager, this.symbolFadeChange = t1.placement.symbolFadeChange(e.q.now()), this.imageManager.beginFrame();
                let d = 0, _ = !1;
                for(const e in u){
                    const t1 = u[e];
                    t1.used && (t1.prepare(this.context), t1.getSource().usedInConflation && ++d);
                }
                let p = !1;
                for (const e of h)e.isHidden(this.transform.zoom) || ("clip" === e.type && (p = !0), this.prepareLayer(e));
                const f = {}, m = {}, g = {}, v = {}, y = {};
                for(const e in u){
                    const t1 = u[e];
                    f[e] = t1.getVisibleCoordinates(), m[e] = f[e].slice().reverse(), g[e] = t1.getVisibleCoordinates(!0).reverse(), v[e] = t1.getShadowCasterCoordinates(), y[e] = t1.sortCoordinatesByDistance(f[e]);
                }
                const x = (e)=>{
                    const t1 = this.style.getLayerSourceCache(e);
                    return t1 && t1.used ? t1.getSource() : null;
                };
                if (d || p || this._clippingActiveLastFrame) {
                    const t1 = [], i = [];
                    let o = 0;
                    for (const e of h)this.isSourceForClippingOrConflation(e, x(e)) && (t1.push(e), i.push(o)), o++;
                    if (t1 && (p || t1.length > 1) || this._clippingActiveLastFrame) {
                        p = !1;
                        const o = [];
                        for(let s = 0; s < t1.length; s++){
                            const r = t1[s], a = i[s], n = this.style.getLayerSourceCache(r);
                            if (!n || !n.used || !n.getSource().usedInConflation && "clip" !== r.type) continue;
                            let l = e.dx, c = e.by.None;
                            const h = [];
                            let u = !0;
                            if ("clip" === r.type) {
                                l = a;
                                for (const t1 of r.layout.get("clip-layer-types"))c |= "model" === t1 ? e.by.Model : "symbol" === t1 ? e.by.Symbol : e.by.FillExtrusion;
                                for (const e of r.layout.get("clip-layer-scope"))h.push(e);
                                r.isHidden(this.transform.zoom) ? u = !1 : p = !0;
                            }
                            u && o.push({
                                layer: r.fqid,
                                cache: n,
                                order: l,
                                clipMask: c,
                                clipScope: h
                            });
                        }
                        this.replacementSource.setSources(o), _ = !0;
                    }
                }
                this._clippingActiveLastFrame = p, _ || this.replacementSource.clear(), this.conflationActive = _, this.minCutoffZoom = 0, this.longestCutoffRange = 0, this.opaquePassCutoff = 1 / 0, this._lastOcclusionLayer = -1, this.layersWithOcclusionOpacity = [];
                for(let e = 0; e < h.length; e++){
                    const t1 = h[e], i = t1.cutoffRange();
                    if (this.longestCutoffRange = Math.max(i, this.longestCutoffRange), i > 0) {
                        const e = x(t1);
                        e && (this.minCutoffZoom = Math.max(e.minzoom, this.minCutoffZoom)), t1.minzoom && (this.minCutoffZoom = Math.max(t1.minzoom, this.minCutoffZoom));
                    }
                    t1.is3D() && (this.opaquePassCutoff === 1 / 0 && (this.opaquePassCutoff = e), this._lastOcclusionLayer = e);
                }
                const b = this.style && this.style.fog;
                b ? (this._fogVisible = 0 !== b.getOpacity(this.transform.pitch), this._fogVisible && "globe" !== this.transform.projection.name && (this._fogVisible = b.isVisibleOnFrustum(this.transform.cameraFrustum))) : this._fogVisible = !1, this._cachedTileFogOpacities = {}, this.terrain && (this.terrain.updateTileBinding(g), this.opaquePassCutoff = 0, n = a(), h = n.map((e)=>s[e]));
                const w = this._shadowRenderer;
                if (w) {
                    w.updateShadowParameters(this.transform, this.style.directionalLight);
                    for(const e in u)for (const t1 of f[e]){
                        let e = {
                            min: 0,
                            max: 0
                        };
                        this.terrain && (e = this.terrain.getMinMaxForTile(t1) || e), w.addShadowReceiver(t1.toUnwrapped(), e.min, e.max);
                    }
                }
                "globe" !== this.transform.projection.name || this.globeSharedBuffers || (this.globeSharedBuffers = new e.dw(this.context)), this.style.fog && this.transform.projection.supportsFog ? (this._atmosphere || (this._atmosphere = new ga(this)), this._atmosphere.update(this)) : this._atmosphere && (this._atmosphere.destroy(), this._atmosphere = void 0);
                const T = this._debugParams.forceEnablePrecipitation || !(!this.style || !this.style.snow), E = this._debugParams.forceEnablePrecipitation || !(!this.style || !this.style.rain);
                if (T && !this._snow && (this._snow = new Za(this)), !T && this._snow && (this._snow.destroy(), delete this._snow), E && !this._rain && (this._rain = new qa(this)), !E && this._rain && (this._rain.destroy(), delete this._rain), this._snow && this._snow.update(this), this._rain && this._rain.update(this), !U.has(this.context.gl)) return;
                this.renderPass = "offscreen";
                for (const e of h){
                    const i = t1.getLayerSourceCache(e);
                    if (!e.hasOffscreenPass() || e.isHidden(this.transform.zoom)) continue;
                    const o = i ? m[i.id] : void 0;
                    ("custom" === e.type || "raster" === e.type || "raster-particle" === e.type || e.isSky() || o && o.length) && this.renderLayer(this, i, e, o);
                }
                this.depthRangeFor3D = [
                    0,
                    1 - (h.length + 2) * this.numSublayers * this.depthEpsilon
                ], this._shadowRenderer && (this.renderPass = "shadow", this._shadowRenderer.drawShadowPass(this.style, v)), this.context.bindFramebuffer.set(null), this.context.viewport.set([
                    0,
                    0,
                    this.width,
                    this.height
                ]);
                const S = "globe" === this.transform.projection.name || this.transform.isHorizonVisible(), C = (()=>{
                    if (i.showOverdrawInspector) return e.aj.black;
                    const t1 = this.style.fog;
                    if (t1 && this.transform.projection.supportsFog) {
                        const i = this.style.getLut(t1.scope);
                        if (!S) {
                            const o = "none" === t1.properties.get("color-use-theme"), s = t1.properties.get("color").toRenderColor(o ? null : i).toArray01();
                            return new e.aj(...s);
                        }
                        if (S) {
                            const o = "none" === t1.properties.get("space-color-use-theme"), s = t1.properties.get("space-color").toRenderColor(o ? null : i).toArray01();
                            return new e.aj(...s);
                        }
                    }
                    return e.aj.transparent;
                })();
                if (this.context.clear({
                    color: C,
                    depth: 1
                }), this.clearStencil(), this._showOverdrawInspector = i.showOverdrawInspector, this.renderPass = "opaque", this.style.fog && this.transform.projection.supportsFog && this._atmosphere && !this._showOverdrawInspector && S && this._atmosphere.drawStars(this, this.style.fog), !this.terrain) for(this.currentLayer = n.length - 1; this.currentLayer >= 0; this.currentLayer--){
                    const e = h[this.currentLayer], i = t1.getLayerSourceCache(e);
                    if (e.isSky()) continue;
                    const o = i ? (e.is3D() ? y : m)[i.id] : void 0;
                    this._renderTileClippingMasks(e, i, o), this.renderLayer(this, i, e, o);
                }
                if (this.style.fog && this.transform.projection.supportsFog && this._atmosphere && !this._showOverdrawInspector && S && this._atmosphere.drawAtmosphereGlow(this, this.style.fog), this.renderPass = "sky", (!this._atmosphere || e.ae(this.transform.zoom) > 0) && ("globe" === this.transform.projection.name || this.transform.isHorizonVisible())) for(this.currentLayer = 0; this.currentLayer < n.length; this.currentLayer++){
                    const e = h[this.currentLayer], i = t1.getLayerSourceCache(e);
                    e.isSky() && this.renderLayer(this, i, e, i ? m[i.id] : void 0);
                }
                function I(e, t1) {
                    let i;
                    return t1 && (i = ("symbol" === e.type ? g : e.is3D() ? y : m)[t1.id]), i;
                }
                if (this.renderPass = "translucent", "globe" === this.transform.projection.name) {
                    for(this.renderElevatedRasterBackface = !0, this.currentLayer = 0; this.currentLayer < n.length;){
                        const e = h[this.currentLayer];
                        if ("raster" === e.type || "raster-particle" === e.type) {
                            const i = t1.getLayerSourceCache(e);
                            this.renderLayer(this, i, e, I(e, i));
                        }
                        ++this.currentLayer;
                    }
                    this.renderElevatedRasterBackface = !1;
                }
                this.currentLayer = 0, this.firstLightBeamLayer = Number.MAX_SAFE_INTEGER;
                let R = 0;
                w && (R = w.getShadowCastingLayerCount());
                let D = !1, L = -1;
                for(let e = 0; e < n.length; ++e){
                    const t1 = h[e];
                    t1.isHidden(this.transform.zoom) || t1.is3D() && (L = e);
                }
                for(c && -1 === L && (l = !0); this.currentLayer < n.length;){
                    const e = h[this.currentLayer], i = t1.getLayerSourceCache(e);
                    if (e.isSky()) ++this.currentLayer;
                    else if (this.terrain && this.style.isLayerDraped(e)) {
                        if (e.isHidden(this.transform.zoom)) {
                            ++this.currentLayer;
                            continue;
                        }
                        this.currentLayer = this.terrain.renderBatch(this.currentLayer), this._lastOcclusionLayer = Math.max(this.currentLayer, this._lastOcclusionLayer);
                    } else {
                        if (l && !D && this.terrain && !this.transform.isOrthographic && (D = !0, this.blitDepth()), c && -1 !== L && this.currentLayer === L + 1 && !this.transform.isOrthographic && this.blitDepth(), e.is3D() || this.terrain || this._renderTileClippingMasks(e, i, i ? f[i.id] : void 0), this.renderLayer(this, i, e, I(e, i)), !this.terrain && w && R > 0 && e.hasShadowPass() && 0 == --R && (w.drawGroundShadows(), this.firstLightBeamLayer <= this.currentLayer)) {
                            const e = this.currentLayer;
                            for(this.renderPass = "light-beam", this.currentLayer = this.firstLightBeamLayer; this.currentLayer <= e; this.currentLayer++){
                                const e = h[this.currentLayer];
                                if (!e.hasLightBeamPass()) continue;
                                const i = t1.getLayerSourceCache(e);
                                this.renderLayer(this, i, e, i ? m[i.id] : void 0);
                            }
                            this.currentLayer = e, this.renderPass = "translucent";
                        }
                        if (this.currentLayer >= this._lastOcclusionLayer && this.layersWithOcclusionOpacity.length > 0) {
                            const e = this.currentLayer;
                            this.depthOcclusion = !0;
                            for (const e of this.layersWithOcclusionOpacity){
                                this.currentLayer = e;
                                const i = h[this.currentLayer], o = t1.getLayerSourceCache(i), s = o ? m[o.id] : void 0;
                                i.is3D() || this.terrain || this._renderTileClippingMasks(i, o, o ? f[o.id] : void 0), this.renderLayer(this, o, i, s);
                            }
                            this.depthOcclusion = !1, this.currentLayer = e, this.renderPass = "translucent", this.layersWithOcclusionOpacity = [];
                        }
                        ++this.currentLayer;
                    }
                }
                if (this.terrain && this.terrain.postRender(), this._snow && this._snow.draw(this), this._rain && this._rain.draw(this), this.options.showTileBoundaries || this.options.showQueryGeometry || this.options.showTileAABBs) {
                    let i = null;
                    h.forEach((e)=>{
                        const o = t1.getLayerSourceCache(e);
                        o && !e.isHidden(this.transform.zoom) && o.getVisibleCoordinates().length && (!i || i.getSource().maxzoom < o.getSource().maxzoom) && (i = o);
                    }), i && this.options.showTileBoundaries && Wa.debug(this, i, i.getVisibleCoordinates(), e.aj.red, !1, this.options.showParseStatus);
                }
                this.terrain && this._debugParams.showTerrainProxyTiles && Wa.debug(this, this.terrain.proxySourceCache, this.terrain.proxyCoords, new e.aj(1, .8, .1, 1), !0, this.options.showParseStatus), this.options.showPadding && function(e) {
                    const t1 = e.transform.padding;
                    ra(e, e.transform.height - (t1.top || 0), 3, Qr), ra(e, t1.bottom || 0, 3, ea), aa(e, t1.left || 0, 3, ta), aa(e, e.transform.width - (t1.right || 0), 3, ia);
                    const i = e.transform.centerPoint;
                    !function(e, t1, i, o) {
                        na(e, t1 - 1, i - 10, 2, 20, o), na(e, t1 - 10, i - 1, 20, 2, o);
                    }(e, i.x, e.transform.height - i.y, oa);
                }(this), this.context.setDefault(), this.frameCounter = (this.frameCounter + 1) % Number.MAX_SAFE_INTEGER, this.tileLoaded && this.options.speedIndexTiming && (this.loadTimeStamps.push(performance.now()), this.saveCanvasCopy()), _ || (this.conflationActive = !1);
            }
            prepareLayer(e) {
                this.gpuTimingStart(e);
                const { unsupportedLayers: t1 } = this.transform.projection, i = !t1 || !t1.includes(e.type);
                if ($a[e.type] && (i || this.terrain && "custom" === e.type)) {
                    const t1 = this.style.getLayerSourceCache(e);
                    $a[e.type](e, t1, this);
                }
                this.gpuTimingEnd();
            }
            renderLayer(e, t1, i, o) {
                i.isHidden(this.transform.zoom) || ("background" === i.type || "sky" === i.type || "custom" === i.type || "model" === i.type || "raster" === i.type || "raster-particle" === i.type || o && o.length) && (this.id = i.id, this.gpuTimingStart(i), e.transform.projection.unsupportedLayers && e.transform.projection.unsupportedLayers.includes(i.type) && (!e.terrain || "custom" !== i.type) || "clip" === i.type || Wa[i.type](e, t1, i, o, this.style.placement.variableOffsets, this.options.isInitialLoad), this.gpuTimingEnd());
            }
            gpuTimingStart(e) {
                if (!this.options.gpuTiming) return;
                const t1 = this.context.extTimerQuery, i = this.context.gl;
                let o = this.gpuTimers[e.id];
                o || (o = this.gpuTimers[e.id] = {
                    calls: 0,
                    cpuTime: 0,
                    query: i.createQuery()
                }), o.calls++, i.beginQuery(t1.TIME_ELAPSED_EXT, o.query);
            }
            gpuTimingDeferredRenderStart() {
                if (this.options.gpuTimingDeferredRender) {
                    const e = this.context.extTimerQuery, t1 = this.context.gl, i = t1.createQuery();
                    this.deferredRenderGpuTimeQueries.push(i), t1.beginQuery(e.TIME_ELAPSED_EXT, i);
                }
            }
            gpuTimingDeferredRenderEnd() {
                this.options.gpuTimingDeferredRender && this.context.gl.endQuery(this.context.extTimerQuery.TIME_ELAPSED_EXT);
            }
            gpuTimingEnd() {
                this.options.gpuTiming && this.context.gl.endQuery(this.context.extTimerQuery.TIME_ELAPSED_EXT);
            }
            collectGpuTimers() {
                const e = this.gpuTimers;
                return this.gpuTimers = {}, e;
            }
            collectDeferredRenderGpuQueries() {
                const e = this.deferredRenderGpuTimeQueries;
                return this.deferredRenderGpuTimeQueries = [], e;
            }
            queryGpuTimers(e) {
                const t1 = {};
                for(const i in e){
                    const o = e[i], s = this.context.extTimerQuery, r = s.getQueryParameter(o.query, this.context.gl.QUERY_RESULT) / 1e6;
                    s.deleteQueryEXT(o.query), t1[i] = r;
                }
                return t1;
            }
            queryGpuTimeDeferredRender(e) {
                if (!this.options.gpuTimingDeferredRender) return 0;
                const t1 = this.context.gl;
                let i = 0;
                for (const o of e)i += t1.getQueryParameter(o, t1.QUERY_RESULT) / 1e6, t1.deleteQuery(o);
                return i;
            }
            translatePosMatrix(t1, i, o, s, r) {
                if (!o[0] && !o[1]) return t1;
                const a = r ? "map" === s ? this.transform.angle : 0 : "viewport" === s ? -this.transform.angle : 0;
                if (a) {
                    const e = Math.sin(a), t1 = Math.cos(a);
                    o = [
                        o[0] * t1 - o[1] * e,
                        o[0] * e + o[1] * t1
                    ];
                }
                const n = [
                    r ? o[0] : e.ar(i, o[0], this.transform.zoom),
                    r ? o[1] : e.ar(i, o[1], this.transform.zoom),
                    0
                ], l = new Float32Array(16);
                return e.ab.mat4.translate(l, t1, n), l;
            }
            saveTileTexture(e) {
                const t1 = e.size[0], i = this._tileTextures[t1];
                i ? i.push(e) : this._tileTextures[t1] = [
                    e
                ];
            }
            getTileTexture(e) {
                const t1 = this._tileTextures[e];
                return t1 && t1.length > 0 ? t1.pop() : null;
            }
            terrainRenderModeElevated() {
                return this.style && !!this.style.getTerrain() && !!this.terrain && !this.terrain.renderingToTexture || this.forceTerrainMode;
            }
            linearFloatFilteringSupported() {
                return null != this.context.extTextureFloatLinear;
            }
            currentGlobalDefines(e, t1, i) {
                const o = void 0 === i ? this.terrain && this.terrain.renderingToTexture : i, s = [];
                return this.style && this.style.enable3dLights() && ("globeRaster" === e || "terrainRaster" === e ? (s.push("LIGHTING_3D_MODE"), s.push("LIGHTING_3D_ALPHA_EMISSIVENESS")) : o || s.push("LIGHTING_3D_MODE")), "shadow" === this.renderPass && (this._shadowMapDebug || s.push("DEPTH_TEXTURE")), this.terrainRenderModeElevated() && (s.push("TERRAIN"), this.linearFloatFilteringSupported() && s.push("TERRAIN_DEM_FLOAT_FORMAT")), "globe" === this.transform.projection.name && s.push("GLOBE"), !this._fogVisible || o || void 0 !== t1 && !t1 || s.push("FOG", "FOG_DITHERING"), o && s.push("RENDER_TO_TEXTURE"), this._showOverdrawInspector && s.push("OVERDRAW_INSPECTOR"), s;
            }
            getOrCreateProgram(e, t1) {
                this.cache = this.cache || {};
                const i = t1 && t1.defines || [], o = t1 && t1.config, s = this.currentGlobalDefines(e, t1 && t1.overrideFog, t1 && t1.overrideRtt).concat(i), r = Ws.cacheKey(Uo[e], e, s, o);
                return this.cache[r] || (this.cache[r] = new Ws(this.context, e, Uo[e], o, Tr[e], s)), this.cache[r];
            }
            setCustomLayerDefaults() {
                this.context.unbindVAO(), this.context.cullFace.setDefault(), this.context.frontFace.setDefault(), this.context.cullFaceSide.setDefault(), this.context.activeTexture.setDefault(), this.context.pixelStoreUnpack.setDefault(), this.context.pixelStoreUnpackPremultiplyAlpha.setDefault(), this.context.pixelStoreUnpackFlipY.setDefault();
            }
            setBaseState() {
                const e = this.context.gl;
                this.context.cullFace.set(!1), this.context.viewport.set([
                    0,
                    0,
                    this.width,
                    this.height
                ]), this.context.blendEquation.set(e.FUNC_ADD);
            }
            initDebugOverlayCanvas() {
                null == this.debugOverlayCanvas && (this.debugOverlayCanvas = document.createElement("canvas"), this.debugOverlayCanvas.width = 512, this.debugOverlayCanvas.height = 512, this.debugOverlayTexture = new e.T(this.context, this.debugOverlayCanvas, this.context.gl.RGBA8));
            }
            destroy() {
                this._terrain && this._terrain.destroy(), this._atmosphere && (this._atmosphere.destroy(), this._atmosphere = void 0), this.globeSharedBuffers && this.globeSharedBuffers.destroy(), this.emptyTexture.destroy(), this.debugOverlayTexture && this.debugOverlayTexture.destroy(), this._wireframeDebugCache.destroy(), this.depthFBO && (this.depthFBO.destroy(), this.depthFBO = void 0, this.depthTexture = void 0), this.emptyDepthTexture && this.emptyDepthTexture.destroy();
            }
            prepareDrawTile() {
                this.terrain && this.terrain.prepareDrawTile();
            }
            uploadCommonLightUniforms(t1, i) {
                if (this.style.enable3dLights()) {
                    const o = this.style.directionalLight, s = this.style.ambientLight;
                    if (o && s) {
                        const r = ((t1, i, o)=>{
                            const s = t1.properties.get("direction"), r = "none" === t1.properties.get("color-use-theme"), a = t1.properties.get("color").toRenderColor(r ? null : o.getLut(t1.scope)).toArray01(), n = t1.properties.get("intensity"), l = "none" === i.properties.get("color-use-theme"), c = i.properties.get("color").toRenderColor(l ? null : o.getLut(i.scope)).toArray01(), h = i.properties.get("intensity"), u = [
                                s.x,
                                s.y,
                                s.z
                            ], d = e.cM(c, h), _ = e.cM(a, n);
                            return {
                                u_lighting_ambient_color: d,
                                u_lighting_directional_dir: u,
                                u_lighting_directional_color: _,
                                u_ground_radiance: qs(u, _, d)
                            };
                        })(o, s, this.style);
                        i.setLightsUniformValues(t1, r);
                    }
                }
            }
            uploadCommonUniforms(t1, i, o, s, r) {
                if (this.uploadCommonLightUniforms(t1, i), this.terrain && this.terrain.renderingToTexture) return;
                const a = this.style.fog;
                if (a) {
                    const r = a.getOpacity(this.transform.pitch), n = ((t1, i, o, s, r, a, n, l, c, h, u, d)=>{
                        const _ = t1.transform, p = "none" === i.properties.get("color-use-theme"), f = i.properties.get("color").toRenderColor(p ? null : t1.style.getLut(i.scope)).toArray01();
                        f[3] = s;
                        const m = t1.frameCounter / 1e3 % 1, [g, v] = i.properties.get("vertical-range");
                        return {
                            u_fog_matrix: o ? _.calculateFogTileMatrix(o) : d || t1.identityMat,
                            u_fog_range: i.getFovAdjustedRange(_._fov),
                            u_fog_color: f,
                            u_fog_horizon_blend: i.properties.get("horizon-blend"),
                            u_fog_vertical_limit: [
                                Math.min(g, v),
                                v
                            ],
                            u_fog_temporal_offset: m,
                            u_frustum_tl: r,
                            u_frustum_tr: a,
                            u_frustum_br: n,
                            u_frustum_bl: l,
                            u_globe_pos: c,
                            u_globe_radius: h,
                            u_viewport: u,
                            u_globe_transition: e.ae(_.zoom),
                            u_is_globe: +("globe" === _.projection.name)
                        };
                    })(this, a, o, r, this.transform.frustumCorners.TL, this.transform.frustumCorners.TR, this.transform.frustumCorners.BR, this.transform.frustumCorners.BL, this.transform.globeCenterInViewSpace, this.transform.globeRadius, [
                        this.transform.width * e.q.devicePixelRatio,
                        this.transform.height * e.q.devicePixelRatio
                    ], s);
                    i.setFogUniformValues(t1, n);
                }
                r && i.setCutoffUniformValues(t1, r.uniformValues);
            }
            setTileLoadedFlag(e) {
                this.tileLoaded = e;
            }
            saveCanvasCopy() {
                const e = this.canvasCopy();
                e && (this.frameCopies.push(e), this.tileLoaded = !1);
            }
            canvasCopy() {
                const e = this.context.gl, t1 = e.createTexture();
                return e.bindTexture(e.TEXTURE_2D, t1), e.copyTexImage2D(e.TEXTURE_2D, 0, e.RGBA, 0, 0, e.drawingBufferWidth, e.drawingBufferHeight, 0), t1;
            }
            getCanvasCopiesAndTimestamps() {
                return {
                    canvasCopies: this.frameCopies,
                    timeStamps: this.loadTimeStamps
                };
            }
            averageElevationNeedsEasing() {
                if (!this.transform._elevation) return !1;
                const e = this.style && this.style.fog;
                return !!e && 0 !== e.getOpacity(this.transform.pitch);
            }
            getBackgroundTiles() {
                const e = this._backgroundTiles, t1 = this._backgroundTiles = {}, i = this.transform.coveringTiles({
                    tileSize: 512
                });
                for (const o of i)t1[o.key] = e[o.key] || new bt(o, 512, this.transform.tileZoom, this);
                return t1;
            }
            clearBackgroundTiles() {
                this._backgroundTiles = {};
            }
            isSourceForClippingOrConflation(e, t1) {
                return !(!e.is3D() || "clip" !== e.type && (e.minzoom && e.minzoom > this.transform.zoom || (this.style._clipLayerPresent || "building" !== e.sourceLayer) && (!t1 || "batched-model" !== t1.type)));
            }
            isTileAffectedByFog(e) {
                if (!this.style || !this.style.fog) return !1;
                if ("globe" === this.transform.projection.name) return !0;
                let t1 = this._cachedTileFogOpacities[e.key];
                return t1 || (this._cachedTileFogOpacities[e.key] = t1 = this.style.fog.getOpacityForTile(e)), t1[0] >= Fe || t1[1] >= Fe;
            }
            setupDepthForOcclusion(e, t1, i) {
                const o = this.context, s = o.gl, r = !!i;
                var a;
                i || (i = {
                    u_dem: 2,
                    u_dem_prev: 4,
                    u_dem_tl: [
                        0,
                        0
                    ],
                    u_dem_tl_prev: [
                        0,
                        0
                    ],
                    u_dem_scale: 0,
                    u_dem_scale_prev: 0,
                    u_dem_size: 0,
                    u_dem_lerp: 1,
                    u_depth: 3,
                    u_depth_size_inv: [
                        0,
                        0
                    ],
                    u_depth_range_unpack: [
                        0,
                        1
                    ],
                    u_occluder_half_size: 16,
                    u_occlusion_depth_offset: -0.0001,
                    u_exaggeration: 0
                }), o.activeTexture.set(s.TEXTURE3), e && this.depthFBO && this.depthTexture ? (this.depthTexture.bind(s.NEAREST, s.CLAMP_TO_EDGE), i.u_depth_size_inv = [
                    1 / this.depthFBO.width,
                    1 / this.depthFBO.height
                ], i.u_depth_range_unpack = [
                    2 / ((a = this.depthRangeFor3D)[1] - a[0]),
                    -1 - 2 * a[0] / (a[1] - a[0])
                ], i.u_occluder_half_size = .5 * this.occlusionParams.occluderSize, i.u_occlusion_depth_offset = this.occlusionParams.depthOffset) : this.emptyDepthTexture.bind(s.NEAREST, s.CLAMP_TO_EDGE), o.activeTexture.set(s.TEXTURE0), r || t1.setTerrainUniformValues(o, i);
            }
            constructor(t1, i, o, s, r){
                this.context = new Rr(t1, i), this.transform = o, this._tileTextures = {}, this.frameCopies = [], this.loadTimeStamps = [], this.tp = r, this._timeStamp = e.q.now(), this._averageFPS = 0, this._fpsHistory = [], this._dt = 0, this._debugParams = {
                    forceEnablePrecipitation: !1,
                    showTerrainProxyTiles: !1,
                    fpsWindow: 30,
                    continousRedraw: !1,
                    enabledLayers: {}
                };
                const a = [
                    "fill",
                    "line",
                    "symbol",
                    "circle",
                    "heatmap",
                    "fill-extrusion",
                    "raster",
                    "raster-particle",
                    "hillshade",
                    "model",
                    "background",
                    "sky"
                ];
                for (const e of a)this._debugParams.enabledLayers[e] = !0;
                r.registerParameter(this._debugParams, [
                    "Terrain"
                ], "showTerrainProxyTiles", {}, ()=>{
                    this.style.map.triggerRepaint();
                }), r.registerParameter(this._debugParams, [
                    "Precipitation"
                ], "forceEnablePrecipitation"), r.registerParameter(this._debugParams, [
                    "FPS"
                ], "fpsWindow", {
                    min: 1,
                    max: 100,
                    step: 1
                }), r.registerBinding(this._debugParams, [
                    "FPS"
                ], "continousRedraw", {
                    readonly: !0,
                    label: "continuous redraw"
                }), r.registerBinding(this, [
                    "FPS"
                ], "_averageFPS", {
                    readonly: !0,
                    label: "value"
                }), r.registerBinding(this, [
                    "FPS"
                ], "_averageFPS", {
                    readonly: !0,
                    label: "graph",
                    view: "graph",
                    min: 0,
                    max: 200
                });
                for (const e of a)r.registerParameter(this._debugParams.enabledLayers, [
                    "Debug",
                    "Layers"
                ], e);
                this.occlusionParams = new Pa(r), this.setup(), this.numSublayers = St.maxUnderzooming + St.maxOverzooming + 1, this.depthEpsilon = 1 / Math.pow(2, 16), this.deferredRenderGpuTimeQueries = [], this.gpuTimers = {}, this.frameCounter = 0, this._backgroundTiles = {}, this.conflationActive = !1, this.replacementSource = new e.dv, this.longestCutoffRange = 0, this.minCutoffZoom = 0, this._fogVisible = !1, this._cachedTileFogOpacities = {}, this._shadowRenderer = new so(this), this._wireframeDebugCache = new za, this.renderDefaultNorthPole = !0, this.renderDefaultSouthPole = !0, this.layersWithOcclusionOpacity = [];
                const n = new e.r({
                    width: 1,
                    height: 1
                }, Uint8Array.of(0, 0, 0, 0));
                this.emptyDepthTexture = new e.T(this.context, n, t1.RGBA8), this._clippingActiveLastFrame = !1, this.scaleFactor = s;
            }
        }
        function Ka(e, t1) {
            let i = !1, o = null;
            const s = ()=>{
                o = null, i && (e(), o = setTimeout(s, t1), i = !1);
            };
            return ()=>(i = !0, o || s(), o);
        }
        class Ya {
            addTo(e) {
                return this._map = e, window.addEventListener("hashchange", this._onHashChange, !1), e.on("moveend", this._updateHash), this;
            }
            remove() {
                return this._map ? (this._map.off("moveend", this._updateHash), window.removeEventListener("hashchange", this._onHashChange, !1), clearTimeout(this._updateHash()), this._map = void 0, this) : this;
            }
            getHashString() {
                const e = this._map;
                if (!e) return "";
                const t1 = Ja(e);
                if (this._hashName) {
                    const e = this._hashName;
                    let i = !1;
                    const o = location.hash.slice(1).split("&").map((o)=>{
                        const s = o.split("=")[0];
                        return s === e ? (i = !0, `${s}=${t1}`) : o;
                    }).filter((e)=>e);
                    return i || o.push(`${e}=${t1}`), `#${o.join("&")}`;
                }
                return `#${t1}`;
            }
            _getCurrentHash() {
                const e = location.hash.replace("#", "");
                if (this._hashName) {
                    let t1;
                    return e.split("&").map((e)=>e.split("=")).forEach((e)=>{
                        e[0] === this._hashName && (t1 = e);
                    }), (t1 && t1[1] || "").split("/");
                }
                return e.split("/");
            }
            _onHashChange() {
                const e = this._map;
                if (!e) return !1;
                const t1 = this._getCurrentHash();
                if (t1.length >= 3 && !t1.some((e)=>isNaN(e))) {
                    const i = e.dragRotate.isEnabled() && e.touchZoomRotate.isEnabled() ? +(t1[3] || 0) : e.getBearing();
                    return e.jumpTo({
                        center: [
                            +t1[2],
                            +t1[1]
                        ],
                        zoom: +t1[0],
                        bearing: i,
                        pitch: +(t1[4] || 0)
                    }), !0;
                }
                return !1;
            }
            _updateHashUnthrottled() {
                history.replaceState(history.state, "", location.href.replace(/(#.+)?$/, this.getHashString()));
            }
            constructor(t1){
                this._hashName = t1 && encodeURIComponent(t1), e.aP([
                    "_getCurrentHash",
                    "_onHashChange",
                    "_updateHash"
                ], this), this._updateHash = Ka(this._updateHashUnthrottled.bind(this), 300);
            }
        }
        function Ja(e, t1) {
            const i = e.getCenter(), o = Math.round(100 * e.getZoom()) / 100, s = Math.ceil((o * Math.LN2 + Math.log(512 / 360 / .5)) / Math.LN10), r = Math.pow(10, s), a = Math.round(i.lng * r) / r, n = Math.round(i.lat * r) / r, l = e.getBearing(), c = e.getPitch();
            let h = t1 ? `/${a}/${n}/${o}` : `${o}/${n}/${a}`;
            return (l || c) && (h += "/" + Math.round(10 * l) / 10), c && (h += `/${Math.round(c)}`), h;
        }
        const Qa = {
            linearity: .3,
            easing: e.dy(0, 0, .3, 1)
        }, en = e.l({
            deceleration: 2500,
            maxSpeed: 1400
        }, Qa), tn = e.l({
            deceleration: 20,
            maxSpeed: 1400
        }, Qa), on = e.l({
            deceleration: 1e3,
            maxSpeed: 360
        }, Qa), sn = e.l({
            deceleration: 1e3,
            maxSpeed: 90
        }, Qa);
        class rn {
            clear() {
                this._inertiaBuffer = [];
            }
            record(t1) {
                this._drainInertiaBuffer(), this._inertiaBuffer.push({
                    time: e.q.now(),
                    settings: t1
                });
            }
            _drainInertiaBuffer() {
                const t1 = this._inertiaBuffer, i = e.q.now();
                for(; t1.length > 0 && i - t1[0].time > 160;)t1.shift();
            }
            _onMoveEnd(t1) {
                if (this._map._prefersReducedMotion()) return;
                if (this._drainInertiaBuffer(), this._inertiaBuffer.length < 2) return;
                const i = {
                    zoom: 0,
                    bearing: 0,
                    pitch: 0,
                    pan: new e.P(0, 0),
                    pinchAround: void 0,
                    around: void 0
                };
                for (const { settings: e } of this._inertiaBuffer)i.zoom += e.zoomDelta || 0, i.bearing += e.bearingDelta || 0, i.pitch += e.pitchDelta || 0, e.panDelta && i.pan._add(e.panDelta), e.around && (i.around = e.around), e.pinchAround && (i.pinchAround = e.pinchAround);
                const o = this._inertiaBuffer[this._inertiaBuffer.length - 1].time - this._inertiaBuffer[0].time, s = {};
                if (i.pan.mag()) {
                    const r = nn(i.pan.mag(), o, e.l({}, en, t1 || {}));
                    s.offset = i.pan.mult(r.amount / i.pan.mag()), s.center = this._map.transform.center, an(s, r);
                }
                if (i.zoom) {
                    const e = nn(i.zoom, o, tn);
                    s.zoom = this._map.transform.zoom + e.amount, an(s, e);
                }
                if (i.bearing) {
                    const t1 = nn(i.bearing, o, on);
                    s.bearing = this._map.transform.bearing + e.aw(t1.amount, -179, 179), an(s, t1);
                }
                if (i.pitch) {
                    const e = nn(i.pitch, o, sn);
                    s.pitch = this._map.transform.pitch + e.amount, an(s, e);
                }
                if (s.zoom || s.bearing) {
                    const e = void 0 === i.pinchAround ? i.around : i.pinchAround;
                    s.around = e ? this._map.unproject(e) : this._map.getCenter();
                }
                return this.clear(), s.noMoveStart = !0, s;
            }
            constructor(e){
                this._map = e, this.clear();
            }
        }
        function an(e, t1) {
            (!e.duration || e.duration < t1.duration) && (e.duration = t1.duration, e.easing = t1.easing);
        }
        function nn(t1, i, o) {
            const { maxSpeed: s, linearity: r, deceleration: a } = o, n = e.aw(t1 * r / (i / 1e3), -s, s), l = Math.abs(n) / (a * r);
            return {
                easing: o.easing,
                duration: 1e3 * l,
                amount: n * (l / 2)
            };
        }
        class ln extends e.z {
            preventDefault() {
                this._defaultPrevented = !0;
            }
            get defaultPrevented() {
                return this._defaultPrevented;
            }
            constructor(t1, i, o, s = {}){
                const r = g(i.getCanvasContainer(), o), a = i.unproject(r);
                super(t1, e.l({
                    point: r,
                    lngLat: a,
                    originalEvent: o
                }, s)), this._defaultPrevented = !1, this.target = i;
            }
        }
        class cn extends e.z {
            preventDefault() {
                this._defaultPrevented = !0;
            }
            get defaultPrevented() {
                return this._defaultPrevented;
            }
            constructor(t1, i, o){
                const s = "touchend" === t1 ? o.changedTouches : o.touches, r = v(i.getCanvasContainer(), s), a = r.map((e)=>i.unproject(e)), n = r.reduce((e, t1, i, o)=>e.add(t1.div(o.length)), new e.P(0, 0));
                super(t1, {
                    points: r,
                    point: n,
                    lngLats: a,
                    lngLat: i.unproject(n),
                    originalEvent: o
                }), this._defaultPrevented = !1;
            }
        }
        class hn extends e.z {
            preventDefault() {
                this._defaultPrevented = !0;
            }
            get defaultPrevented() {
                return this._defaultPrevented;
            }
            constructor(e, t1){
                super("wheel", {
                    originalEvent: t1
                }), this._defaultPrevented = !1;
            }
        }
        class un {
            reset() {
                this._mousedownPos = void 0;
            }
            wheel(e) {
                return this._firePreventable(new hn(this._map, e));
            }
            mousedown(e, t1) {
                return this._mousedownPos = t1, this._firePreventable(new ln(e.type, this._map, e));
            }
            mouseup(e) {
                this._map.fire(new ln(e.type, this._map, e));
            }
            preclick(t1) {
                const i = e.l({}, t1);
                i.type = "preclick", this._map.fire(new ln(i.type, this._map, i));
            }
            click(e, t1) {
                this._mousedownPos && this._mousedownPos.dist(t1) >= this._clickTolerance || (this.preclick(e), this._map.fire(new ln(e.type, this._map, e)));
            }
            dblclick(e) {
                return this._firePreventable(new ln(e.type, this._map, e));
            }
            mouseover(e) {
                this._map.fire(new ln(e.type, this._map, e));
            }
            mouseout(e) {
                this._map.fire(new ln(e.type, this._map, e));
            }
            touchstart(e) {
                return this._firePreventable(new cn(e.type, this._map, e));
            }
            touchmove(e) {
                this._map.fire(new cn(e.type, this._map, e));
            }
            touchend(e) {
                this._map.fire(new cn(e.type, this._map, e));
            }
            touchcancel(e) {
                this._map.fire(new cn(e.type, this._map, e));
            }
            _firePreventable(e) {
                if (this._map.fire(e), e.defaultPrevented) return {};
            }
            isEnabled() {
                return !0;
            }
            isActive() {
                return !1;
            }
            enable() {}
            disable() {}
            constructor(e, t1){
                this._map = e, this._clickTolerance = t1.clickTolerance;
            }
        }
        class dn {
            reset() {
                this._delayContextMenu = !1, this._contextMenuEvent = void 0;
            }
            mousemove(e) {
                this._map.fire(new ln(e.type, this._map, e));
            }
            mousedown() {
                this._delayContextMenu = !0;
            }
            mouseup() {
                this._delayContextMenu = !1, this._contextMenuEvent && (this._map.fire(new ln("contextmenu", this._map, this._contextMenuEvent)), delete this._contextMenuEvent);
            }
            contextmenu(e) {
                this._delayContextMenu ? this._contextMenuEvent = e : this._map.fire(new ln(e.type, this._map, e)), this._map.listens("contextmenu") && e.preventDefault();
            }
            isEnabled() {
                return !0;
            }
            isActive() {
                return !1;
            }
            enable() {}
            disable() {}
            constructor(e){
                this._map = e;
            }
        }
        class _n {
            isEnabled() {
                return !!this._enabled;
            }
            isActive() {
                return !!this._active;
            }
            enable() {
                this.isEnabled() || (this._enabled = !0);
            }
            disable() {
                this.isEnabled() && (this._enabled = !1);
            }
            mousedown(e, t1) {
                this.isEnabled() && e.shiftKey && 0 === e.button && (_(), this._startPos = this._lastPos = t1, this._active = !0);
            }
            mousemoveWindow(e, t1) {
                if (!this._active) return;
                const i = t1, o = this._startPos, s = this._lastPos;
                if (!o || !s || s.equals(i) || !this._box && i.dist(o) < this._clickTolerance) return;
                this._lastPos = i, this._box || (this._box = l("div", "mapboxgl-boxzoom", this._container), this._container.classList.add("mapboxgl-crosshair"), this._fireEvent("boxzoomstart", e));
                const r = Math.min(o.x, i.x), a = Math.max(o.x, i.x), n = Math.min(o.y, i.y), c = Math.max(o.y, i.y);
                this._map._requestDomTask(()=>{
                    this._box && (this._box.style.transform = `translate(${r}px,${n}px)`, this._box.style.width = a - r + "px", this._box.style.height = c - n + "px");
                });
            }
            mouseupWindow(t1, i) {
                if (!this._active) return;
                const o = this._startPos, s = i;
                if (o && 0 === t1.button) {
                    if (this.reset(), m(), o.x !== s.x || o.y !== s.y) return this._map.fire(new e.z("boxzoomend", {
                        originalEvent: t1
                    })), {
                        cameraAnimation: (e)=>e.fitScreenCoordinates(o, s, this._map.getBearing(), {
                                linear: !1
                            })
                    };
                    this._fireEvent("boxzoomcancel", t1);
                }
            }
            keydown(e) {
                this._active && 27 === e.keyCode && (this.reset(), this._fireEvent("boxzoomcancel", e));
            }
            blur() {
                this.reset();
            }
            reset() {
                this._active = !1, this._container.classList.remove("mapboxgl-crosshair"), this._box && (this._box.remove(), this._box = null), p(), delete this._startPos, delete this._lastPos;
            }
            _fireEvent(t1, i) {
                return this._map.fire(new e.z(t1, {
                    originalEvent: i
                }));
            }
            constructor(e, t1){
                this._map = e, this._el = e.getCanvasContainer(), this._container = e.getContainer(), this._clickTolerance = t1.clickTolerance || 1;
            }
        }
        function pn(e, t1) {
            const i = {};
            for(let o = 0; o < e.length; o++)i[e[o].identifier] = t1[o];
            return i;
        }
        class fn {
            reset() {
                this.centroid = void 0, this.startTime = 0, this.touches = {}, this.aborted = !1;
            }
            touchstart(t1, i, o) {
                (this.centroid || o.length > this.numTouches) && (this.aborted = !0), this.aborted || (0 === this.startTime && (this.startTime = t1.timeStamp), o.length === this.numTouches && (this.centroid = function(t1) {
                    const i = new e.P(0, 0);
                    for (const e of t1)i._add(e);
                    return i.div(t1.length);
                }(i), this.touches = pn(o, i)));
            }
            touchmove(e, t1, i) {
                if (this.aborted || !this.centroid) return;
                const o = pn(i, t1);
                for(const e in this.touches){
                    const t1 = o[e];
                    (!t1 || t1.dist(this.touches[e]) > 30) && (this.aborted = !0);
                }
            }
            touchend(e, t1, i) {
                if ((!this.centroid || e.timeStamp - this.startTime > 500) && (this.aborted = !0), 0 === i.length) {
                    const e = !this.aborted && this.centroid;
                    if (this.reset(), e) return e;
                }
            }
            constructor(e){
                this.reset(), this.numTouches = e.numTouches;
            }
        }
        class mn {
            reset() {
                this.lastTime = 1 / 0, this.lastTap = void 0, this.count = 0, this.singleTap.reset();
            }
            touchstart(e, t1, i) {
                this.singleTap.touchstart(e, t1, i);
            }
            touchmove(e, t1, i) {
                this.singleTap.touchmove(e, t1, i);
            }
            touchend(e, t1, i) {
                const o = this.singleTap.touchend(e, t1, i);
                if (o) {
                    const t1 = e.timeStamp - this.lastTime < 500, i = !this.lastTap || this.lastTap.dist(o) < 30;
                    if (t1 && i || this.reset(), this.count++, this.lastTime = e.timeStamp, this.lastTap = o, this.count === this.numTaps) return this.reset(), o;
                }
            }
            constructor(e){
                this.singleTap = new fn(e), this.numTaps = e.numTaps, this.reset();
            }
        }
        class gn {
            reset() {
                this._active = !1, this._zoomIn.reset(), this._zoomOut.reset();
            }
            touchstart(e, t1, i) {
                this._zoomIn.touchstart(e, t1, i), this._zoomOut.touchstart(e, t1, i);
            }
            touchmove(e, t1, i) {
                this._zoomIn.touchmove(e, t1, i), this._zoomOut.touchmove(e, t1, i);
            }
            touchend(e, t1, i) {
                const o = this._zoomIn.touchend(e, t1, i), s = this._zoomOut.touchend(e, t1, i);
                return o ? (this._active = !0, e.preventDefault(), setTimeout(()=>this.reset(), 0), {
                    cameraAnimation: (t1)=>t1.easeTo({
                            duration: 300,
                            zoom: t1.getZoom() + 1,
                            around: t1.unproject(o)
                        }, {
                            originalEvent: e
                        })
                }) : s ? (this._active = !0, e.preventDefault(), setTimeout(()=>this.reset(), 0), {
                    cameraAnimation: (t1)=>t1.easeTo({
                            duration: 300,
                            zoom: t1.getZoom() - 1,
                            around: t1.unproject(s)
                        }, {
                            originalEvent: e
                        })
                }) : void 0;
            }
            touchcancel() {
                this.reset();
            }
            enable() {
                this._enabled = !0;
            }
            disable() {
                this._enabled = !1, this.reset();
            }
            isEnabled() {
                return this._enabled;
            }
            isActive() {
                return this._active;
            }
            constructor(){
                this._zoomIn = new mn({
                    numTouches: 1,
                    numTaps: 2
                }), this._zoomOut = new mn({
                    numTouches: 2,
                    numTaps: 1
                }), this.reset();
            }
        }
        const vn = {
            0: 1,
            2: 2
        };
        class yn {
            blur() {
                this.reset();
            }
            reset() {
                this._active = !1, this._moved = !1, this._lastPoint = void 0, this._eventButton = void 0;
            }
            _correctButton(e, t1) {
                return !1;
            }
            _move(e, t1) {
                return {};
            }
            mousedown(e, t1) {
                if (this._lastPoint) return;
                const i = y(e);
                this._correctButton(e, i) && (this._lastPoint = t1, this._eventButton = i);
            }
            mousemoveWindow(e, t1) {
                const i = this._lastPoint;
                if (i) {
                    if (e.preventDefault(), null != this._eventButton && function(e, t1) {
                        const i = vn[t1];
                        return void 0 === e.buttons || (e.buttons & i) !== i;
                    }(e, this._eventButton)) this.reset();
                    else if (this._moved || !(t1.dist(i) < this._clickTolerance)) return this._moved = !0, this._lastPoint = t1, this._move(i, t1);
                }
            }
            mouseupWindow(e) {
                this._lastPoint && y(e) === this._eventButton && (this._moved && m(), this.reset());
            }
            enable() {
                this._enabled = !0;
            }
            disable() {
                this._enabled = !1, this.reset();
            }
            isEnabled() {
                return this._enabled;
            }
            isActive() {
                return this._active;
            }
            constructor(e){
                this.reset(), this._clickTolerance = e.clickTolerance || 1;
            }
        }
        class xn extends yn {
            mousedown(e, t1) {
                super.mousedown(e, t1), this._lastPoint && (this._active = !0);
            }
            _correctButton(e, t1) {
                return 0 === t1 && !e.ctrlKey;
            }
            _move(e, t1) {
                return {
                    around: t1,
                    panDelta: t1.sub(e)
                };
            }
        }
        class bn extends yn {
            _correctButton(e, t1) {
                return 0 === t1 && e.ctrlKey || 2 === t1;
            }
            _move(e, t1) {
                const i = .8 * (t1.x - e.x);
                if (i) return this._active = !0, {
                    bearingDelta: i
                };
            }
            contextmenu(e) {
                e.preventDefault();
            }
        }
        class wn extends yn {
            _correctButton(e, t1) {
                return 0 === t1 && e.ctrlKey || 2 === t1;
            }
            _move(e, t1) {
                const i = -0.5 * (t1.y - e.y);
                if (i) return this._active = !0, {
                    pitchDelta: i
                };
            }
            contextmenu(e) {
                e.preventDefault();
            }
        }
        class Tn {
            reset() {
                this._active = !1, this._touches = {}, this._sum = new e.P(0, 0);
            }
            touchstart(e, t1, i) {
                return this._calculateTransform(e, t1, i);
            }
            touchmove(t1, i, o) {
                if (this._active && !(o.length < this._minTouches)) {
                    if (this._map._cooperativeGestures && !this._map.isMoving()) {
                        if (1 === o.length && !e.dz()) return void this._showTouchPanBlockerAlert();
                        "hidden" !== this._alertContainer.style.visibility && (this._alertContainer.style.visibility = "hidden", clearTimeout(this._alertTimer));
                    }
                    return t1.cancelable && t1.preventDefault(), this._calculateTransform(t1, i, o);
                }
            }
            touchend(e, t1, i) {
                this._calculateTransform(e, t1, i), this._active && i.length < this._minTouches && this.reset();
            }
            touchcancel() {
                this.reset();
            }
            _calculateTransform(t1, i, o) {
                o.length > 0 && (this._active = !0);
                const s = pn(o, i), r = new e.P(0, 0), a = new e.P(0, 0);
                let n = 0;
                for(const e in s){
                    const t1 = s[e], i = this._touches[e];
                    i && (r._add(t1), a._add(t1.sub(i)), n++, s[e] = t1);
                }
                if (this._touches = s, n < this._minTouches || !a.mag()) return;
                const l = a.div(n);
                return this._sum._add(l), this._sum.mag() < this._clickTolerance ? void 0 : {
                    around: r.div(n),
                    panDelta: l
                };
            }
            enable() {
                this._enabled = !0, this._map._cooperativeGestures && (this._addTouchPanBlocker(), this._el.classList.add("mapboxgl-touch-pan-blocker-override", "mapboxgl-scrollable-page"));
            }
            disable() {
                this._enabled = !1, this._map._cooperativeGestures && (clearTimeout(this._alertTimer), this._alertContainer.remove(), this._el.classList.remove("mapboxgl-touch-pan-blocker-override", "mapboxgl-scrollable-page")), this.reset();
            }
            isEnabled() {
                return !!this._enabled;
            }
            isActive() {
                return !!this._active;
            }
            _addTouchPanBlocker() {
                this._map && !this._alertContainer && (this._alertContainer = l("div", "mapboxgl-touch-pan-blocker", this._map._container), this._alertContainer.textContent = this._map._getUIString("TouchPanBlocker.Message"), this._alertContainer.style.fontSize = `${Math.max(10, Math.min(24, Math.floor(.05 * this._el.clientWidth)))}px`);
            }
            _showTouchPanBlockerAlert() {
                this._alertContainer.style.visibility = "visible", this._alertContainer.classList.add("mapboxgl-touch-pan-blocker-show"), this._alertContainer.setAttribute("role", "alert"), clearTimeout(this._alertTimer), this._alertTimer = window.setTimeout(()=>{
                    this._alertContainer.classList.remove("mapboxgl-touch-pan-blocker-show"), this._alertContainer.removeAttribute("role");
                }, 500);
            }
            constructor(t1, i){
                this._map = t1, this._el = t1.getCanvasContainer(), this._minTouches = 1, this._clickTolerance = i.clickTolerance || 1, this.reset(), e.aP([
                    "_addTouchPanBlocker",
                    "_showTouchPanBlockerAlert"
                ], this);
            }
        }
        class En {
            reset() {
                this._active = !1, this._firstTwoTouches = void 0;
            }
            _start(e) {}
            _move(e, t1, i) {
                return {};
            }
            touchstart(e, t1, i) {
                this._firstTwoTouches || i.length < 2 || (this._firstTwoTouches = [
                    i[0].identifier,
                    i[1].identifier
                ], this._start([
                    t1[0],
                    t1[1]
                ]));
            }
            touchmove(e, t1, i) {
                const o = this._firstTwoTouches;
                if (!o) return;
                e.preventDefault();
                const [s, r] = o, a = Sn(i, t1, s), n = Sn(i, t1, r);
                if (!a || !n) return;
                const l = this._aroundCenter ? null : a.add(n).div(2);
                return this._move([
                    a,
                    n
                ], l, e);
            }
            touchend(e, t1, i) {
                if (!this._firstTwoTouches) return;
                const [o, s] = this._firstTwoTouches, r = Sn(i, t1, o), a = Sn(i, t1, s);
                r && a || (this._active && m(), this.reset());
            }
            touchcancel() {
                this.reset();
            }
            enable(e) {
                this._enabled = !0, this._aroundCenter = !!e && "center" === e.around;
            }
            disable() {
                this._enabled = !1, this.reset();
            }
            isEnabled() {
                return this._enabled;
            }
            isActive() {
                return this._active;
            }
            constructor(){
                this.reset();
            }
        }
        function Sn(e, t1, i) {
            for(let o = 0; o < e.length; o++)if (e[o].identifier === i) return t1[o];
        }
        function Cn(e, t1) {
            return Math.log(e / t1) / Math.LN2;
        }
        class In extends En {
            reset() {
                super.reset(), this._distance = 0, this._startDistance = 0;
            }
            _start(e) {
                this._startDistance = this._distance = e[0].dist(e[1]);
            }
            _move(e, t1) {
                const i = this._distance;
                if (this._distance = e[0].dist(e[1]), this._active || !(Math.abs(Cn(this._distance, this._startDistance)) < .1)) return this._active = !0, {
                    zoomDelta: Cn(this._distance, i),
                    pinchAround: t1
                };
            }
        }
        function Rn(e, t1) {
            return 180 * e.angleWith(t1) / Math.PI;
        }
        class Dn extends En {
            reset() {
                super.reset(), this._minDiameter = 0, this._startVector = void 0, this._vector = void 0;
            }
            _start(e) {
                this._startVector = this._vector = e[0].sub(e[1]), this._minDiameter = e[0].dist(e[1]);
            }
            _move(e, t1) {
                const i = this._vector;
                if (this._vector = e[0].sub(e[1]), i && (this._active || !this._isBelowThreshold(this._vector))) return this._active = !0, {
                    bearingDelta: Rn(this._vector, i),
                    pinchAround: t1
                };
            }
            _isBelowThreshold(e) {
                this._minDiameter = Math.min(this._minDiameter, e.mag());
                const t1 = 25 / (Math.PI * this._minDiameter) * 360, i = this._startVector;
                if (!i) return !1;
                const o = Rn(e, i);
                return Math.abs(o) < t1;
            }
        }
        function Ln(e) {
            return Math.abs(e.y) > Math.abs(e.x);
        }
        class An extends En {
            reset() {
                super.reset(), this._valid = void 0, this._firstMove = void 0, this._lastPoints = void 0;
            }
            _start(e) {
                this._lastPoints = e, Ln(e[0].sub(e[1])) && (this._valid = !1);
            }
            _move(t1, i, o) {
                const s = this._lastPoints;
                if (!s) return;
                const r = t1[0].sub(s[0]), a = t1[1].sub(s[1]);
                return this._map._cooperativeGestures && !e.dz() && o.touches.length < 3 || (this._valid = this.gestureBeginsVertically(r, a, o.timeStamp), !this._valid) ? void 0 : (this._lastPoints = t1, this._active = !0, {
                    pitchDelta: (r.y + a.y) / 2 * -0.5
                });
            }
            gestureBeginsVertically(e, t1, i) {
                if (void 0 !== this._valid) return this._valid;
                const o = e.mag() >= 2, s = t1.mag() >= 2;
                if (!o && !s) return;
                if (!o || !s) return null == this._firstMove && (this._firstMove = i), i - this._firstMove < 100 && void 0;
                const r = e.y > 0 == t1.y > 0;
                return Ln(e) && Ln(t1) && r;
            }
            constructor(e){
                super(), this._map = e;
            }
        }
        const zn = {
            panStep: 100,
            bearingStep: 15,
            pitchStep: 10
        };
        class Pn {
            blur() {
                this.reset();
            }
            reset() {
                this._active = !1;
            }
            keydown(e) {
                if (e.altKey || e.ctrlKey || e.metaKey) return;
                let t1 = 0, i = 0, o = 0, s = 0, r = 0;
                switch(e.keyCode){
                    case 61:
                    case 107:
                    case 171:
                    case 187:
                        t1 = 1;
                        break;
                    case 189:
                    case 109:
                    case 173:
                        t1 = -1;
                        break;
                    case 37:
                        e.shiftKey ? i = -1 : (e.preventDefault(), s = -1);
                        break;
                    case 39:
                        e.shiftKey ? i = 1 : (e.preventDefault(), s = 1);
                        break;
                    case 38:
                        e.shiftKey ? o = 1 : (e.preventDefault(), r = -1);
                        break;
                    case 40:
                        e.shiftKey ? o = -1 : (e.preventDefault(), r = 1);
                        break;
                    default:
                        return;
                }
                return this._rotationDisabled && (i = 0, o = 0), {
                    cameraAnimation: (a)=>{
                        const n = a.getZoom();
                        a.easeTo({
                            duration: 300,
                            easeId: "keyboardHandler",
                            easing: Mn,
                            zoom: t1 ? Math.round(n) + t1 * (e.shiftKey ? 2 : 1) : n,
                            bearing: a.getBearing() + i * this._bearingStep,
                            pitch: a.getPitch() + o * this._pitchStep,
                            offset: [
                                -s * this._panStep,
                                -r * this._panStep
                            ],
                            center: a.getCenter()
                        }, {
                            originalEvent: e
                        });
                    }
                };
            }
            enable() {
                this._enabled = !0;
            }
            disable() {
                this._enabled = !1, this.reset();
            }
            isEnabled() {
                return this._enabled;
            }
            isActive() {
                return this._active;
            }
            disableRotation() {
                this._rotationDisabled = !0;
            }
            enableRotation() {
                this._rotationDisabled = !1;
            }
            constructor(){
                const e = zn;
                this._panStep = e.panStep, this._bearingStep = e.bearingStep, this._pitchStep = e.pitchStep, this._rotationDisabled = !1;
            }
        }
        function Mn(e) {
            return e * (2 - e);
        }
        const On = 4.000244140625, Fn = 1 / 450;
        class kn {
            setZoomRate(e) {
                this._defaultZoomRate = e;
            }
            setWheelZoomRate(e) {
                this._wheelZoomRate = e;
            }
            isEnabled() {
                return !!this._enabled;
            }
            isActive() {
                return this._active || void 0 !== this._finishTimeout;
            }
            isZooming() {
                return !!this._zooming;
            }
            enable(e) {
                this.isEnabled() || (this._enabled = !0, this._aroundCenter = !!e && "center" === e.around, this._map._cooperativeGestures && this._addScrollZoomBlocker());
            }
            disable() {
                this.isEnabled() && (this._enabled = !1, this._map._cooperativeGestures && (clearTimeout(this._alertTimer), this._alertContainer.remove()));
            }
            wheel(t1) {
                if (!this.isEnabled()) return;
                if (this._map._cooperativeGestures) {
                    if (!(t1.ctrlKey || t1.metaKey || this.isZooming() || e.dz())) return void this._showBlockerAlert();
                    "hidden" !== this._alertContainer.style.visibility && (this._alertContainer.style.visibility = "hidden", clearTimeout(this._alertTimer));
                }
                let i = t1.deltaMode === WheelEvent.DOM_DELTA_LINE ? 40 * t1.deltaY : t1.deltaY;
                const o = e.q.now(), s = o - (this._lastWheelEventTime || 0);
                this._lastWheelEventTime = o, 0 !== i && i % On == 0 ? this._type = "wheel" : 0 !== i && Math.abs(i) < 4 ? this._type = "trackpad" : s > 400 ? (this._type = null, this._lastValue = i, this._timeout = window.setTimeout(this._onTimeout, 40, t1)) : this._type || (this._type = Math.abs(s * i) < 200 ? "trackpad" : "wheel", this._timeout && (clearTimeout(this._timeout), this._timeout = null, i += this._lastValue)), t1.shiftKey && i && (i /= 4), this._type && (this._lastWheelEvent = t1, this._delta -= i, this._active || this._start(t1)), t1.preventDefault();
            }
            _onTimeout(e) {
                this._type = "wheel", this._delta -= this._lastValue, this._active || this._start(e);
            }
            _start(e) {
                if (!this._delta) return;
                this._frameId && (this._frameId = null), this._active = !0, this.isZooming() || (this._zooming = !0), this._finishTimeout && (clearTimeout(this._finishTimeout), delete this._finishTimeout);
                const t1 = g(this._el, e);
                this._aroundPoint = this._aroundCenter ? this._map.transform.centerPoint : t1, this._aroundCoord = this._map.transform.pointCoordinate3D(this._aroundPoint), this._targetZoom = void 0, this._frameId || (this._frameId = !0, this._handler._triggerRenderFrame());
            }
            renderFrame() {
                if (!this._frameId) return;
                if (this._frameId = null, !this.isActive()) return;
                const t1 = this._map.transform;
                "wheel" === this._type && t1.projection.wrap && (t1._center.lng >= 180 || t1._center.lng <= -180) && (this._prevEase = null, this._easing = null, this._lastWheelEvent = null, this._lastWheelEventTime = 0);
                const i = ()=>t1._terrainEnabled() && this._aroundCoord ? t1.computeZoomRelativeTo(this._aroundCoord) : t1.zoom;
                if (0 !== this._delta) {
                    const e = "wheel" === this._type && Math.abs(this._delta) > On ? this._wheelZoomRate : this._defaultZoomRate;
                    let o = 2 / (1 + Math.exp(-Math.abs(this._delta * e)));
                    this._delta < 0 && 0 !== o && (o = 1 / o);
                    const s = i(), r = Math.pow(2, s), a = "number" == typeof this._targetZoom ? t1.zoomScale(this._targetZoom) : r;
                    this._targetZoom = Math.min(t1.maxZoom, Math.max(t1.minZoom, t1.scaleZoom(a * o))), "wheel" === this._type && (this._startZoom = s, this._easing = this._smoothOutEasing(200)), this._lastDelta = this._delta, this._delta = 0;
                }
                const o = "number" == typeof this._targetZoom ? this._targetZoom : i(), s = this._startZoom, r = this._easing;
                let a, n = !1;
                if ("wheel" === this._type && s && r) {
                    const t1 = Math.min((e.q.now() - this._lastWheelEventTime) / 200, 1), i = r(t1);
                    a = e.af(s, o, i), t1 < 1 ? this._frameId || (this._frameId = !0) : n = !0;
                } else a = o, n = !0;
                this._active = !0, n && (this._active = !1, this._finishTimeout = window.setTimeout(()=>{
                    this._zooming = !1, this._handler._triggerRenderFrame(), delete this._targetZoom, delete this._finishTimeout;
                }, 200));
                let l = a - i();
                return l * this._lastDelta < 0 && (l = 0), {
                    noInertia: !0,
                    needsRenderFrame: !n,
                    zoomDelta: l,
                    around: this._aroundPoint,
                    aroundCoord: this._aroundCoord,
                    originalEvent: this._lastWheelEvent
                };
            }
            _smoothOutEasing(t1) {
                let i = e.dA;
                if (this._prevEase) {
                    const t1 = this._prevEase, o = (e.q.now() - t1.start) / t1.duration, s = t1.easing(o + .01) - t1.easing(o), r = .27 / Math.sqrt(s * s + 1e-4) * .01, a = Math.sqrt(.0729 - r * r);
                    i = e.dy(r, a, .25, 1);
                }
                return this._prevEase = {
                    start: e.q.now(),
                    duration: t1,
                    easing: i
                }, i;
            }
            blur() {
                this.reset();
            }
            reset() {
                this._active = !1;
            }
            _addScrollZoomBlocker() {
                this._map && !this._alertContainer && (this._alertContainer = l("div", "mapboxgl-scroll-zoom-blocker", this._map._container), this._alertContainer.textContent = /(Mac|iPad)/i.test(navigator.userAgent) ? this._map._getUIString("ScrollZoomBlocker.CmdMessage") : this._map._getUIString("ScrollZoomBlocker.CtrlMessage"), this._alertContainer.style.fontSize = `${Math.max(10, Math.min(24, Math.floor(.05 * this._el.clientWidth)))}px`);
            }
            _showBlockerAlert() {
                this._alertContainer.style.visibility = "visible", this._alertContainer.classList.add("mapboxgl-scroll-zoom-blocker-show"), this._alertContainer.setAttribute("role", "alert"), clearTimeout(this._alertTimer), this._alertTimer = window.setTimeout(()=>{
                    this._alertContainer.classList.remove("mapboxgl-scroll-zoom-blocker-show"), this._alertContainer.removeAttribute("role");
                }, 200);
            }
            constructor(t1, i){
                this._map = t1, this._el = t1.getCanvasContainer(), this._handler = i, this._delta = 0, this._lastDelta = 0, this._defaultZoomRate = .01, this._wheelZoomRate = Fn, e.aP([
                    "_onTimeout",
                    "_addScrollZoomBlocker",
                    "_showBlockerAlert"
                ], this);
            }
        }
        class Bn {
            enable() {
                this._clickZoom.enable(), this._tapZoom.enable();
            }
            disable() {
                this._clickZoom.disable(), this._tapZoom.disable();
            }
            isEnabled() {
                return this._clickZoom.isEnabled() && this._tapZoom.isEnabled();
            }
            isActive() {
                return this._clickZoom.isActive() || this._tapZoom.isActive();
            }
            constructor(e, t1){
                this._clickZoom = e, this._tapZoom = t1;
            }
        }
        class Nn {
            reset() {
                this._active = !1;
            }
            blur() {
                this.reset();
            }
            dblclick(e, t1) {
                return e.preventDefault(), {
                    cameraAnimation: (i)=>{
                        i.easeTo({
                            duration: 300,
                            zoom: i.getZoom() + (e.shiftKey ? -1 : 1),
                            around: i.unproject(t1)
                        }, {
                            originalEvent: e
                        });
                    }
                };
            }
            enable() {
                this._enabled = !0;
            }
            disable() {
                this._enabled = !1, this.reset();
            }
            isEnabled() {
                return this._enabled;
            }
            isActive() {
                return this._active;
            }
            constructor(){
                this.reset();
            }
        }
        class Un {
            reset() {
                this._active = !1, this._swipePoint = void 0, this._swipeTouch = 0, this._tapTime = 0, this._tap.reset();
            }
            touchstart(e, t1, i) {
                this._swipePoint || (this._tapTime && e.timeStamp - this._tapTime > 500 && this.reset(), this._tapTime ? i.length > 0 && (this._swipePoint = t1[0], this._swipeTouch = i[0].identifier) : this._tap.touchstart(e, t1, i));
            }
            touchmove(e, t1, i) {
                if (this._tapTime) {
                    if (this._swipePoint) {
                        if (i[0].identifier !== this._swipeTouch) return;
                        const o = t1[0], s = o.y - this._swipePoint.y;
                        return this._swipePoint = o, e.preventDefault(), this._active = !0, {
                            zoomDelta: s / 128
                        };
                    }
                } else this._tap.touchmove(e, t1, i);
            }
            touchend(e, t1, i) {
                this._tapTime ? this._swipePoint && 0 === i.length && this.reset() : this._tap.touchend(e, t1, i) && (this._tapTime = e.timeStamp);
            }
            touchcancel() {
                this.reset();
            }
            enable() {
                this._enabled = !0;
            }
            disable() {
                this._enabled = !1, this.reset();
            }
            isEnabled() {
                return this._enabled;
            }
            isActive() {
                return this._active;
            }
            constructor(){
                this._tap = new mn({
                    numTouches: 1,
                    numTaps: 1
                }), this.reset();
            }
        }
        class jn {
            enable(e) {
                this._inertiaOptions = e || {}, this._mousePan.enable(), this._touchPan.enable(), this._el.classList.add("mapboxgl-touch-drag-pan");
            }
            disable() {
                this._mousePan.disable(), this._touchPan.disable(), this._el.classList.remove("mapboxgl-touch-drag-pan");
            }
            isEnabled() {
                return this._mousePan.isEnabled() && this._touchPan.isEnabled();
            }
            isActive() {
                return this._mousePan.isActive() || this._touchPan.isActive();
            }
            constructor(e, t1, i){
                this._el = e, this._mousePan = t1, this._touchPan = i;
            }
        }
        class Gn {
            enable() {
                this._mouseRotate.enable(), this._pitchWithRotate && this._mousePitch.enable();
            }
            disable() {
                this._mouseRotate.disable(), this._mousePitch.disable();
            }
            isEnabled() {
                return this._mouseRotate.isEnabled() && (!this._pitchWithRotate || this._mousePitch.isEnabled());
            }
            isActive() {
                return this._mouseRotate.isActive() || this._mousePitch.isActive();
            }
            constructor(e, t1, i){
                this._pitchWithRotate = e.pitchWithRotate, this._mouseRotate = t1, this._mousePitch = i;
            }
        }
        class Vn {
            enable(e) {
                this._touchZoom.enable(e), this._rotationDisabled || this._touchRotate.enable(e), this._tapDragZoom.enable(), this._el.classList.add("mapboxgl-touch-zoom-rotate");
            }
            disable() {
                this._touchZoom.disable(), this._touchRotate.disable(), this._tapDragZoom.disable(), this._el.classList.remove("mapboxgl-touch-zoom-rotate");
            }
            isEnabled() {
                return this._touchZoom.isEnabled() && (this._rotationDisabled || this._touchRotate.isEnabled()) && this._tapDragZoom.isEnabled();
            }
            isActive() {
                return this._touchZoom.isActive() || this._touchRotate.isActive() || this._tapDragZoom.isActive();
            }
            disableRotation() {
                this._rotationDisabled = !0, this._touchRotate.disable();
            }
            enableRotation() {
                this._rotationDisabled = !1, this._touchZoom.isEnabled() && this._touchRotate.enable();
            }
            constructor(e, t1, i, o){
                this._el = e, this._touchZoom = t1, this._touchRotate = i, this._tapDragZoom = o, this._rotationDisabled = !1, this._enabled = !0;
            }
        }
        const qn = (e)=>e.zoom || e.drag || e.pitch || e.rotate;
        class Hn extends e.z {
        }
        class Zn {
            setup(t1, i) {
                const o = e.ab.vec3.sub([], i, t1);
                this.radius = e.ab.vec3.length(o[2] < 0 ? e.ab.vec3.div([], o, this.constants) : [
                    o[0],
                    o[1],
                    0
                ]);
            }
            projectRay(t1) {
                e.ab.vec3.div(t1, t1, this.constants), e.ab.vec3.normalize(t1, t1), e.ab.vec3.mul(t1, t1, this.constants);
                const i = e.ab.vec3.scale([], t1, this.radius);
                if (i[2] > 0) {
                    const t1 = e.ab.vec3.scale([], [
                        0,
                        0,
                        1
                    ], e.ab.vec3.dot(i, [
                        0,
                        0,
                        1
                    ])), o = e.ab.vec3.scale([], e.ab.vec3.normalize([], [
                        i[0],
                        i[1],
                        0
                    ]), this.radius), s = e.ab.vec3.add([], i, e.ab.vec3.scale([], e.ab.vec3.sub([], e.ab.vec3.add([], o, t1), i), 2));
                    i[0] = s[0], i[1] = s[1];
                }
                return i;
            }
            constructor(){
                this.constants = [
                    1,
                    1,
                    .01
                ], this.radius = 0;
            }
        }
        function Wn(e) {
            return e.panDelta && e.panDelta.mag() || e.zoomDelta || e.bearingDelta || e.pitchDelta;
        }
        class $n {
            destroy() {
                for (const [e, t1, i] of this._listeners){
                    const o = e === document ? this.handleWindowEvent : this.handleEvent;
                    e.removeEventListener(t1, o, i);
                }
            }
            _addDefaultHandlers(e) {
                const t1 = this._map, i = t1.getCanvasContainer();
                this._add("mapEvent", new un(t1, e));
                const o = t1.boxZoom = new _n(t1, e);
                this._add("boxZoom", o);
                const s = new gn, r = new Nn;
                t1.doubleClickZoom = new Bn(r, s), this._add("tapZoom", s), this._add("clickZoom", r);
                const a = new Un;
                this._add("tapDragZoom", a);
                const n = t1.touchPitch = new An(t1);
                this._add("touchPitch", n);
                const l = new bn(e), c = new wn(e);
                t1.dragRotate = new Gn(e, l, c), this._add("mouseRotate", l, [
                    "mousePitch"
                ]), this._add("mousePitch", c, [
                    "mouseRotate"
                ]);
                const h = new xn(e), u = new Tn(t1, e);
                t1.dragPan = new jn(i, h, u), this._add("mousePan", h), this._add("touchPan", u, [
                    "touchZoom",
                    "touchRotate"
                ]);
                const d = new Dn, _ = new In;
                t1.touchZoomRotate = new Vn(i, _, d, a), this._add("touchRotate", d, [
                    "touchPan",
                    "touchZoom"
                ]), this._add("touchZoom", _, [
                    "touchPan",
                    "touchRotate"
                ]), this._add("blockableMapEvent", new dn(t1));
                const p = t1.scrollZoom = new kn(t1, this);
                this._add("scrollZoom", p, [
                    "mousePan"
                ]);
                const f = t1.keyboard = new Pn;
                this._add("keyboard", f);
                for (const i of [
                    "boxZoom",
                    "doubleClickZoom",
                    "tapDragZoom",
                    "touchPitch",
                    "dragRotate",
                    "dragPan",
                    "touchZoomRotate",
                    "scrollZoom",
                    "keyboard"
                ])e.interactive && e[i] && t1[i].enable(e[i]);
            }
            _add(e, t1, i) {
                this._handlers.push({
                    handlerName: e,
                    handler: t1,
                    allowed: i
                }), this._handlersById[e] = t1;
            }
            stop(e) {
                if (!this._updatingCamera) {
                    for (const { handler: e } of this._handlers)e.reset();
                    this._inertia.clear(), this._fireEvents({}, {}, e), this._changes = [], this._originalZoom = void 0;
                }
            }
            isActive() {
                for (const { handler: e } of this._handlers)if (e.isActive()) return !0;
                return !1;
            }
            isZooming() {
                return !!this._eventsInProgress.zoom || this._map.scrollZoom.isZooming();
            }
            isRotating() {
                return !!this._eventsInProgress.rotate;
            }
            isMoving() {
                return !!qn(this._eventsInProgress) || this.isZooming();
            }
            _isDragging() {
                return !!this._eventsInProgress.drag;
            }
            _blockedByActive(e, t1, i) {
                for(const o in e)if (o !== i && (!t1 || t1.indexOf(o) < 0)) return !0;
                return !1;
            }
            handleWindowEvent(e) {
                this.handleEvent(e, `${e.type}Window`);
            }
            _getMapTouches(e) {
                const t1 = [];
                for (const i of e)this._el.contains(i.target) && t1.push(i);
                return t1;
            }
            handleEvent(e, t1) {
                this._updatingCamera = !0;
                const i = "renderFrame" === e.type, o = i ? void 0 : e, s = {
                    needsRenderFrame: !1
                }, r = {}, a = {}, n = e.touches ? this._getMapTouches(e.touches) : void 0, l = n ? v(this._el, n) : i ? void 0 : g(this._el, e);
                for (const { handlerName: i, handler: c, allowed: h } of this._handlers){
                    if (!c.isEnabled()) continue;
                    let u;
                    this._blockedByActive(a, h, i) ? c.reset() : c[t1 || e.type] && (u = c[t1 || e.type](e, l, n), this.mergeHandlerResult(s, r, u, i, o), u && u.needsRenderFrame && this._triggerRenderFrame()), (u || c.isActive()) && (a[i] = c);
                }
                const c = {};
                for(const e in this._previousActiveHandlers)a[e] || (c[e] = o);
                this._previousActiveHandlers = a, (Object.keys(c).length || Wn(s)) && (this._changes.push([
                    s,
                    r,
                    c
                ]), this._triggerRenderFrame()), (Object.keys(a).length || Wn(s)) && this._map._stop(!0), this._updatingCamera = !1;
                const { cameraAnimation: h } = s;
                h && (this._inertia.clear(), this._fireEvents({}, {}, !0), this._changes = [], h(this._map));
            }
            mergeHandlerResult(t1, i, o, s, r) {
                if (!o) return;
                e.l(t1, o);
                const a = {
                    handlerName: s,
                    originalEvent: o.originalEvent || r
                };
                void 0 !== o.zoomDelta && (i.zoom = a), void 0 !== o.panDelta && (i.drag = a), void 0 !== o.pitchDelta && (i.pitch = a), void 0 !== o.bearingDelta && (i.rotate = a);
            }
            _applyChanges() {
                const t1 = {}, i = {}, o = {};
                for (const [s, r, a] of this._changes)s.panDelta && (t1.panDelta = (t1.panDelta || new e.P(0, 0))._add(s.panDelta)), s.zoomDelta && (t1.zoomDelta = (t1.zoomDelta || 0) + s.zoomDelta), s.bearingDelta && (t1.bearingDelta = (t1.bearingDelta || 0) + s.bearingDelta), s.pitchDelta && (t1.pitchDelta = (t1.pitchDelta || 0) + s.pitchDelta), void 0 !== s.around && (t1.around = s.around), void 0 !== s.aroundCoord && (t1.aroundCoord = s.aroundCoord), void 0 !== s.pinchAround && (t1.pinchAround = s.pinchAround), s.noInertia && (t1.noInertia = s.noInertia), e.l(i, r), e.l(o, a);
                this._updateMapTransform(t1, i, o), this._changes = [];
            }
            _updateMapTransform(t1, i, o) {
                const s = this._map, r = s.transform, a = (e)=>[
                        e.x,
                        e.y,
                        e.z
                    ];
                if (((e)=>{
                    const t1 = this._eventsInProgress.drag;
                    return t1 && !this._handlersById[t1.handlerName].isActive();
                })() && !Wn(t1)) {
                    const e = r.zoom;
                    r.cameraElevationReference = "sea", null != this._originalZoom && r._orthographicProjectionAtLowPitch && "globe" !== r.projection.name && 0 === r.pitch ? (r.cameraElevationReference = "ground", r.zoom = this._originalZoom) : (r.recenterOnTerrain(), r.cameraElevationReference = "ground"), e !== r.zoom && this._map._update(!0);
                }
                if (r._isCameraConstrained && s._stop(!0), !Wn(t1)) return void this._fireEvents(i, o, !0);
                let { panDelta: n, zoomDelta: l, bearingDelta: c, pitchDelta: h, around: u, aroundCoord: d, pinchAround: _ } = t1;
                r._isCameraConstrained && (l > 0 && (l = 0), r._isCameraConstrained = !1), void 0 !== _ && (u = _), (l || ((e)=>i[e] && !this._eventsInProgress[e])("drag")) && u && (this._dragOrigin = a(r.pointCoordinate3D(u)), this._originalZoom = r.zoom, this._trackingEllipsoid.setup(r._camera.position, this._dragOrigin)), r.cameraElevationReference = "sea", s._stop(!0), u = u || s.transform.centerPoint, c && (r.bearing += c), h && (r.pitch += h), r._updateCameraState();
                const p = [
                    0,
                    0,
                    0
                ];
                if (n) {
                    if ("mercator" === r.projection.name) {
                        const e = this._trackingEllipsoid.projectRay(r.screenPointToMercatorRay(u).dir), t1 = this._trackingEllipsoid.projectRay(r.screenPointToMercatorRay(u.sub(n)).dir);
                        p[0] = t1[0] - e[0], p[1] = t1[1] - e[1];
                    } else {
                        const t1 = r.pointCoordinate(u);
                        if ("globe" === r.projection.name) {
                            n = n.rotate(-r.angle);
                            const i = r._pixelsPerMercatorPixel / r.worldSize;
                            p[0] = -n.x * e.dB(e.aS(t1.y)) * i, p[1] = -n.y * e.dB(r.center.lat) * i;
                        } else {
                            const e = r.pointCoordinate(u.sub(n));
                            t1 && e && (p[0] = e.x - t1.x, p[1] = e.y - t1.y);
                        }
                    }
                }
                const f = r.zoom, m = [
                    0,
                    0,
                    0
                ];
                if (l) {
                    const t1 = a(d || r.pointCoordinate3D(u)), i = {
                        dir: e.ab.vec3.normalize([], e.ab.vec3.sub([], t1, r._camera.position))
                    };
                    if (i.dir[2] < 0) {
                        const o = r.zoomDeltaToMovement(t1, l);
                        e.ab.vec3.scale(m, i.dir, o);
                    }
                }
                const g = e.ab.vec3.add(p, p, m);
                r._translateCameraConstrained(g), l && Math.abs(r.zoom - f) > 1e-4 && r.recenterOnTerrain(), r.cameraElevationReference = "ground", this._map._update(), t1.noInertia || this._inertia.record(t1), this._fireEvents(i, o, !0);
            }
            _fireEvents(t1, i, o) {
                const s = qn(this._eventsInProgress), r = qn(t1), a = {};
                for(const e in t1){
                    const { originalEvent: i } = t1[e];
                    this._eventsInProgress[e] || (a[`${e}start`] = i), this._eventsInProgress[e] = t1[e];
                }
                !s && r && this._fireEvent("movestart", r.originalEvent);
                for(const e in a)this._fireEvent(e, a[e]);
                r && this._fireEvent("move", r.originalEvent);
                for(const e in t1){
                    const { originalEvent: i } = t1[e];
                    this._fireEvent(e, i);
                }
                const n = {};
                let l;
                for(const e in this._eventsInProgress){
                    const { handlerName: t1, originalEvent: o } = this._eventsInProgress[e];
                    this._handlersById[t1].isActive() || (delete this._eventsInProgress[e], l = i[t1] || o, n[`${e}end`] = l);
                }
                for(const e in n)this._fireEvent(e, n[e]);
                const c = qn(this._eventsInProgress);
                if (o && (s || r) && !c) {
                    this._updatingCamera = !0;
                    const t1 = this._inertia._onMoveEnd(this._map.dragPan._inertiaOptions), i = (e)=>0 !== e && -this._bearingSnap < e && e < this._bearingSnap;
                    t1 ? (i(t1.bearing || this._map.getBearing()) && (t1.bearing = 0), this._map.easeTo(t1, {
                        originalEvent: l
                    })) : (this._map.fire(new e.z("moveend", {
                        originalEvent: l
                    })), i(this._map.getBearing()) && this._map.resetNorth()), this._updatingCamera = !1;
                }
            }
            _fireEvent(t1, i) {
                this._map.fire(new e.z(t1, i ? {
                    originalEvent: i
                } : {}));
            }
            _requestFrame() {
                return this._map.triggerRepaint(), this._map._renderTaskQueue.add((e)=>{
                    this._frameId = void 0, this.handleEvent(new Hn("renderFrame", {
                        timeStamp: e
                    })), this._applyChanges();
                });
            }
            _triggerRenderFrame() {
                void 0 === this._frameId && (this._frameId = this._requestFrame());
            }
            constructor(t1, i){
                this._map = t1, this._el = this._map.getCanvasContainer(), this._handlers = [], this._handlersById = {}, this._changes = [], this._inertia = new rn(t1), this._bearingSnap = i.bearingSnap, this._previousActiveHandlers = {}, this._trackingEllipsoid = new Zn, this._dragOrigin = null, this._eventsInProgress = {}, this._addDefaultHandlers(i), e.aP([
                    "handleEvent",
                    "handleWindowEvent"
                ], this);
                const o = this._el;
                this._listeners = [
                    [
                        o,
                        "touchstart",
                        {
                            passive: !0
                        }
                    ],
                    [
                        o,
                        "touchmove",
                        {
                            passive: !1
                        }
                    ],
                    [
                        o,
                        "touchend",
                        void 0
                    ],
                    [
                        o,
                        "touchcancel",
                        void 0
                    ],
                    [
                        o,
                        "mousedown",
                        void 0
                    ],
                    [
                        o,
                        "mousemove",
                        void 0
                    ],
                    [
                        o,
                        "mouseup",
                        void 0
                    ],
                    [
                        document,
                        "mousemove",
                        {
                            capture: !0
                        }
                    ],
                    [
                        document,
                        "mouseup",
                        void 0
                    ],
                    [
                        o,
                        "mouseover",
                        void 0
                    ],
                    [
                        o,
                        "mouseout",
                        void 0
                    ],
                    [
                        o,
                        "dblclick",
                        void 0
                    ],
                    [
                        o,
                        "click",
                        void 0
                    ],
                    [
                        o,
                        "keydown",
                        {
                            capture: !1
                        }
                    ],
                    [
                        o,
                        "keyup",
                        void 0
                    ],
                    [
                        o,
                        "wheel",
                        {
                            passive: !1
                        }
                    ],
                    [
                        o,
                        "contextmenu",
                        void 0
                    ],
                    [
                        window,
                        "blur",
                        void 0
                    ]
                ];
                for (const [e, t1, i] of this._listeners){
                    const o = e === document ? this.handleWindowEvent : this.handleEvent;
                    e.addEventListener(t1, o, i);
                }
            }
        }
        const Xn = "map.setFreeCameraOptions(...) and map.getFreeCameraOptions() are not yet supported for non-mercator projections.";
        class Kn extends e.E {
            getCenter() {
                return new e.bO(this.transform.center.lng, this.transform.center.lat);
            }
            setCenter(e, t1) {
                return this.jumpTo({
                    center: e
                }, t1);
            }
            panBy(t1, i, o) {
                return t1 = e.P.convert(t1).mult(-1), this.panTo(this.transform.center, e.l({
                    offset: t1
                }, i), o);
            }
            panTo(t1, i, o) {
                return this.easeTo(e.l({
                    center: t1
                }, i), o);
            }
            getZoom() {
                return this.transform.zoom;
            }
            setZoom(e, t1) {
                return this.jumpTo({
                    zoom: e
                }, t1), this;
            }
            zoomTo(t1, i, o) {
                return this.easeTo(e.l({
                    zoom: t1
                }, i), o);
            }
            zoomIn(e, t1) {
                return this.zoomTo(this.getZoom() + 1, e, t1), this;
            }
            zoomOut(e, t1) {
                return this.zoomTo(this.getZoom() - 1, e, t1), this;
            }
            getBearing() {
                return this.transform.bearing;
            }
            setBearing(e, t1) {
                return this.jumpTo({
                    bearing: e
                }, t1), this;
            }
            getPadding() {
                return this.transform.padding;
            }
            setPadding(e, t1) {
                return this.jumpTo({
                    padding: e
                }, t1), this;
            }
            rotateTo(t1, i, o) {
                return this.easeTo(e.l({
                    bearing: t1
                }, i), o);
            }
            resetNorth(t1, i) {
                return this.rotateTo(0, e.l({
                    duration: 1e3
                }, t1), i), this;
            }
            resetNorthPitch(t1, i) {
                return this.easeTo(e.l({
                    bearing: 0,
                    pitch: 0,
                    duration: 1e3
                }, t1), i), this;
            }
            snapToNorth(e, t1) {
                return Math.abs(this.getBearing()) < this._bearingSnap ? this.resetNorth(e, t1) : this;
            }
            getPitch() {
                return this.transform.pitch;
            }
            setPitch(e, t1) {
                return this.jumpTo({
                    pitch: e
                }, t1), this;
            }
            cameraForBounds(t1, i) {
                t1 = e.az.convert(t1);
                const o = i && i.bearing || 0, s = i && i.pitch || 0, r = t1.getNorthWest(), a = t1.getSouthEast();
                return this._cameraForBounds(this.transform, r, a, o, s, i);
            }
            _extendPadding(t1) {
                const i = {
                    top: 0,
                    right: 0,
                    bottom: 0,
                    left: 0
                };
                return null == t1 ? e.l({}, i, this.transform.padding) : "number" == typeof t1 ? {
                    top: t1,
                    bottom: t1,
                    right: t1,
                    left: t1
                } : e.l({}, i, t1);
            }
            _extendCameraOptions(t1) {
                return (t1 = e.l({
                    offset: [
                        0,
                        0
                    ],
                    maxZoom: this.transform.maxZoom
                }, t1)).padding = this._extendPadding(t1.padding), t1;
            }
            _minimumAABBFrustumDistance(e, t1) {
                const i = t1.max[0] - t1.min[0], o = t1.max[1] - t1.min[1];
                return i / o > e.aspect ? i / (2 * Math.tan(.5 * e.fovX) * e.aspect) : o / (2 * Math.tan(.5 * e.fovY) * e.aspect);
            }
            _cameraForBoundsOnGlobe(t1, i, o, s, r, a) {
                const n = t1.clone(), l = this._extendCameraOptions(a);
                n.bearing = s, n.pitch = r;
                const c = e.bO.convert(i), h = e.bO.convert(o), u = .5 * (c.lat + h.lat), d = .5 * (c.lng + h.lng), _ = e.dC(u, d), p = e.ab.vec3.normalize([], _), f = e.ab.vec3.normalize([], e.ab.vec3.cross([], p, [
                    0,
                    1,
                    0
                ])), m = e.ab.vec3.cross([], f, p), g = [
                    f[0],
                    f[1],
                    f[2],
                    0,
                    m[0],
                    m[1],
                    m[2],
                    0,
                    p[0],
                    p[1],
                    p[2],
                    0,
                    0,
                    0,
                    0,
                    1
                ], v = [
                    _,
                    e.dC(c.lat, c.lng),
                    e.dC(h.lat, c.lng),
                    e.dC(h.lat, h.lng),
                    e.dC(c.lat, h.lng),
                    e.dC(u, c.lng),
                    e.dC(u, h.lng),
                    e.dC(c.lat, d),
                    e.dC(h.lat, d)
                ];
                let y = e.cd.fromPoints(v.map((t1)=>[
                        e.ab.vec3.dot(f, t1),
                        e.ab.vec3.dot(m, t1),
                        e.ab.vec3.dot(p, t1)
                    ]));
                const x = e.ab.vec3.transformMat4([], y.center, g);
                0 === e.ab.vec3.squaredLength(x) && e.ab.vec3.set(x, 0, 0, 1), e.ab.vec3.normalize(x, x), e.ab.vec3.scale(x, x, e.ax), n.center = e.dD(x);
                const b = n.getWorldToCameraMatrix(), w = e.ab.mat4.invert(new Float64Array(16), b);
                y = e.cd.applyTransform(y, e.ab.mat4.multiply([], b, g));
                const T = this._extendAABB(y, n, l, s);
                if (!T) return void e.w("Map cannot fit within canvas with the given bounds, padding, and/or offset.");
                y = T, e.ab.vec3.transformMat4(x, x, b);
                const E = .5 * (y.max[2] - y.min[2]), S = this._minimumAABBFrustumDistance(n, y), C = e.ab.vec3.scale([], [
                    0,
                    0,
                    1
                ], E), I = e.ab.vec3.add(C, x, C), R = S + (0 === n.pitch ? 0 : e.ab.vec3.distance(x, I)), D = n.globeCenterInViewSpace, L = e.ab.vec3.sub([], x, [
                    D[0],
                    D[1],
                    D[2]
                ]);
                e.ab.vec3.normalize(L, L), e.ab.vec3.scale(L, L, R);
                const A = e.ab.vec3.add([], x, L);
                e.ab.vec3.transformMat4(A, A, w);
                const z = e.ds / e.ax, P = e.ab.vec3.length(A), M = e.bH(Math.max(P * z - e.ds, Number.EPSILON), 0), O = Math.min(n.zoomFromMercatorZAdjusted(M), l.maxZoom);
                return O > .5 * (e.c6 + e.bY) ? (n.setProjection({
                    name: "mercator"
                }), n.zoom = O, this._cameraForBounds(n, i, o, s, r, a)) : {
                    center: n.center,
                    zoom: O,
                    bearing: s,
                    pitch: r
                };
            }
            _extendAABB(t1, i, o, s) {
                const r = .5 * ((o.padding.left || 0) + (o.padding.right || 0)), a = .5 * ((o.padding.top || 0) + (o.padding.bottom || 0)), n = a, l = r, c = r, h = a, u = i.width - (l + c), d = i.height - (n + h), _ = e.ab.vec3.sub([], t1.max, t1.min), p = Math.min(u / _[0], d / _[1]), f = Math.min(i.scaleZoom(i.scale * p), o.maxZoom);
                if (isNaN(f)) return null;
                const m = i.scale / i.zoomScale(f), g = new e.cd([
                    t1.min[0] - l * m,
                    t1.min[1] - h * m,
                    t1.min[2]
                ], [
                    t1.max[0] + c * m,
                    t1.max[1] + n * m,
                    t1.max[2]
                ]), v = ("number" == typeof o.offset.x && "number" == typeof o.offset.y ? new e.P(o.offset.x, o.offset.y) : e.P.convert(o.offset)).rotate(-e.ai(s));
                return g.center[0] -= v.x * m, g.center[1] += v.y * m, g;
            }
            queryTerrainElevation(t1, i) {
                const o = this.transform.elevation;
                return o ? (i = e.l({}, {
                    exaggerated: !0
                }, i), o.getAtPoint(e.aa.fromLngLat(t1), null, i.exaggerated)) : null;
            }
            _cameraForBounds(t1, i, o, s, r, a) {
                if ("globe" === t1.projection.name) return this._cameraForBoundsOnGlobe(t1, i, o, s, r, a);
                const n = t1.clone(), l = this._extendCameraOptions(a);
                n.bearing = s, n.pitch = r;
                const c = e.bO.convert(i), h = e.bO.convert(o), u = new e.bO(c.lng, h.lat), d = new e.bO(h.lng, c.lat), _ = n.project(c), p = n.project(h), f = this.queryTerrainElevation(c), m = this.queryTerrainElevation(h), g = this.queryTerrainElevation(u), v = this.queryTerrainElevation(d), y = [
                    [
                        _.x,
                        _.y,
                        Math.min(f || 0, m || 0, g || 0, v || 0)
                    ],
                    [
                        p.x,
                        p.y,
                        Math.max(f || 0, m || 0, g || 0, v || 0)
                    ]
                ];
                let x = e.cd.fromPoints(y);
                const b = n.getWorldToCameraMatrix(), w = e.ab.mat4.invert(new Float64Array(16), b);
                x = e.cd.applyTransform(x, b);
                const T = this._extendAABB(x, n, l, s);
                if (!T) return void e.w("Map cannot fit within canvas with the given bounds, padding, and/or offset.");
                x = T;
                const E = .5 * e.ab.vec3.sub([], x.max, x.min)[2], S = this._minimumAABBFrustumDistance(n, x), C = [
                    0,
                    0,
                    1,
                    0
                ];
                e.ab.vec4.transformMat4(C, C, b), e.ab.vec4.normalize(C, C);
                const I = e.ab.vec3.scale([], C, S + E), R = e.ab.vec3.add([], x.center, I);
                e.ab.vec3.transformMat4(x.center, x.center, w), e.ab.vec3.transformMat4(R, R, w);
                const D = n.unproject(new e.P(x.center[0], x.center[1])), L = e.dE(n.projection, D), A = Math.pow(2, L), z = Math.min(n._zoomFromMercatorZ(R[2] * n.pixelsPerMeter * A / n.worldSize), l.maxZoom);
                return n.mercatorFromTransition && z < .5 * (e.c6 + e.bY) ? (n.setProjection({
                    name: "globe"
                }), n.zoom = z, this._cameraForBounds(n, i, o, s, r, a)) : {
                    center: D,
                    zoom: z,
                    bearing: s,
                    pitch: r
                };
            }
            fitBounds(e, t1, i) {
                const o = this.cameraForBounds(e, t1);
                return this._fitInternal(o, t1, i);
            }
            fitScreenCoordinates(t1, i, o, s, r) {
                const a = e.P.convert(t1), n = e.P.convert(i), l = new e.P(Math.min(a.x, n.x), Math.min(a.y, n.y)), c = new e.P(Math.max(a.x, n.x), Math.max(a.y, n.y));
                if ("mercator" === this.transform.projection.name && this.transform.anyCornerOffEdge(a, n)) return this;
                const h = this.transform.pointLocation3D(l), u = this.transform.pointLocation3D(c), d = this.transform.pointLocation3D(new e.P(l.x, c.y)), _ = this.transform.pointLocation3D(new e.P(c.x, l.y)), p = [
                    Math.min(h.lng, u.lng, d.lng, _.lng),
                    Math.min(h.lat, u.lat, d.lat, _.lat)
                ], f = [
                    Math.max(h.lng, u.lng, d.lng, _.lng),
                    Math.max(h.lat, u.lat, d.lat, _.lat)
                ], m = s && s.pitch ? s.pitch : this.getPitch(), g = this._cameraForBounds(this.transform, p, f, o, m, s);
                return this._fitInternal(g, s, r);
            }
            _fitInternal(t1, i, o) {
                return t1 ? (i = e.l(t1, i)).linear ? this.easeTo(i, o) : this.flyTo(i, o) : this;
            }
            jumpTo(t1, i) {
                this.stop();
                const o = t1.preloadOnly ? this.transform.clone() : this.transform;
                let s = !1, r = !1, a = !1;
                "zoom" in t1 && o.zoom !== +t1.zoom && (s = !0, o.zoom = +t1.zoom), void 0 !== t1.center && (o.center = e.bO.convert(t1.center)), "bearing" in t1 && o.bearing !== +t1.bearing && (r = !0, o.bearing = +t1.bearing), "pitch" in t1 && o.pitch !== +t1.pitch && (a = !0, o.pitch = +t1.pitch);
                const n = "number" == typeof t1.padding ? this._extendPadding(t1.padding) : t1.padding;
                if (null != t1.padding && !o.isPaddingEqual(n)) {
                    if (!1 === t1.retainPadding) {
                        const e = o.clone();
                        e.padding = n, o.setLocationAtPoint(o.center, e.centerPoint);
                    } else o.padding = n;
                }
                return t1.preloadOnly ? (this._preloadTiles(o), this) : (this.fire(new e.z("movestart", i)).fire(new e.z("move", i)), s && this.fire(new e.z("zoomstart", i)).fire(new e.z("zoom", i)).fire(new e.z("zoomend", i)), r && this.fire(new e.z("rotatestart", i)).fire(new e.z("rotate", i)).fire(new e.z("rotateend", i)), a && this.fire(new e.z("pitchstart", i)).fire(new e.z("pitch", i)).fire(new e.z("pitchend", i)), this.fire(new e.z("moveend", i)));
            }
            getFreeCameraOptions() {
                return this.transform.projection.supportsFreeCamera || e.w(Xn), this.transform.getFreeCameraOptions();
            }
            setFreeCameraOptions(t1, i) {
                const o = this.transform;
                if (!o.projection.supportsFreeCamera) return e.w(Xn), this;
                this.stop();
                const s = o.zoom, r = o.pitch, a = o.bearing;
                o.setFreeCameraOptions(t1);
                const n = s !== o.zoom, l = r !== o.pitch, c = a !== o.bearing;
                return this.fire(new e.z("movestart", i)).fire(new e.z("move", i)), n && this.fire(new e.z("zoomstart", i)).fire(new e.z("zoom", i)).fire(new e.z("zoomend", i)), c && this.fire(new e.z("rotatestart", i)).fire(new e.z("rotate", i)).fire(new e.z("rotateend", i)), l && this.fire(new e.z("pitchstart", i)).fire(new e.z("pitch", i)).fire(new e.z("pitchend", i)), this.fire(new e.z("moveend", i)), this;
            }
            easeTo(t1, i) {
                this._stop(!1, t1.easeId), (!1 === (t1 = e.l({
                    offset: [
                        0,
                        0
                    ],
                    duration: 500,
                    easing: e.dA
                }, t1)).animate || this._prefersReducedMotion(t1)) && (t1.duration = 0);
                const o = this.transform, s = this.getZoom(), r = this.getBearing(), a = this.getPitch(), n = this.getPadding(), l = "zoom" in t1 ? +t1.zoom : s, c = "bearing" in t1 ? this._normalizeBearing(t1.bearing, r) : r, h = "pitch" in t1 ? +t1.pitch : a, u = this._extendPadding(t1.padding), d = e.P.convert(t1.offset);
                let _, p, f;
                if ("globe" === o.projection.name) {
                    const i = e.aa.fromLngLat(o.center), s = d.rotate(-o.angle);
                    i.x += s.x / o.worldSize, i.y += s.y / o.worldSize;
                    const r = i.toLngLat(), a = e.bO.convert(t1.center || r);
                    this._normalizeCenter(a), _ = o.centerPoint.add(s), p = new e.P(i.x, i.y).mult(o.worldSize), f = new e.P(e.at(a.lng), e.aA(a.lat)).mult(o.worldSize).sub(p);
                } else {
                    _ = o.centerPoint.add(d);
                    const i = o.pointLocation(_), s = e.bO.convert(t1.center || i);
                    this._normalizeCenter(s), p = o.project(i), f = o.project(s).sub(p);
                }
                const m = o.zoomScale(l - s);
                let g, v;
                t1.around && (g = e.bO.convert(t1.around), v = o.locationPoint(g));
                const y = this._zooming || l !== s, x = this._rotating || r !== c, b = this._pitching || h !== a, w = !o.isPaddingEqual(u), T = !1 === t1.retainPadding ? o.clone() : o, E = (o)=>(E)=>{
                        if (y && (o.zoom = e.af(s, l, E)), x && (o.bearing = e.af(r, c, E)), b && (o.pitch = e.af(a, h, E)), w && (T.interpolatePadding(n, u, E), _ = T.centerPoint.add(d)), g) o.setLocationAtPoint(g, v);
                        else {
                            const e = o.zoomScale(o.zoom - s), t1 = l > s ? Math.min(2, m) : Math.max(.5, m), i = Math.pow(t1, 1 - E), r = o.unproject(p.add(f.mult(E * i)).mult(e));
                            o.setLocationAtPoint(o.renderWorldCopies ? r.wrap() : r, _);
                        }
                        return t1.preloadOnly || this._fireMoveEvents(i), o;
                    };
                if (t1.preloadOnly) {
                    const e = this._emulate(E, t1.duration, o);
                    return this._preloadTiles(e), this;
                }
                const S = {
                    moving: this._moving,
                    zooming: this._zooming,
                    rotating: this._rotating,
                    pitching: this._pitching
                };
                return this._zooming = y, this._rotating = x, this._pitching = b, this._padding = w, this._easeId = t1.easeId, this._prepareEase(i, t1.noMoveStart, S), this._ease(E(o), (e)=>{
                    "sea" === o.cameraElevationReference && o.recenterOnTerrain(), this._afterEase(i, e);
                }, t1), this;
            }
            _prepareEase(t1, i, o = {}) {
                this._moving = !0, this.transform.cameraElevationReference = "sea", this.transform._orthographicProjectionAtLowPitch && 0 === this.transform.pitch && "globe" !== this.transform.projection.name && (this.transform.cameraElevationReference = "ground"), i || o.moving || this.fire(new e.z("movestart", t1)), this._zooming && !o.zooming && this.fire(new e.z("zoomstart", t1)), this._rotating && !o.rotating && this.fire(new e.z("rotatestart", t1)), this._pitching && !o.pitching && this.fire(new e.z("pitchstart", t1));
            }
            _fireMoveEvents(t1) {
                this.fire(new e.z("move", t1)), this._zooming && this.fire(new e.z("zoom", t1)), this._rotating && this.fire(new e.z("rotate", t1)), this._pitching && this.fire(new e.z("pitch", t1));
            }
            _afterEase(t1, i) {
                if (this._easeId && i && this._easeId === i) return;
                this._easeId = void 0, this.transform.cameraElevationReference = "ground";
                const o = this._zooming, s = this._rotating, r = this._pitching;
                this._moving = !1, this._zooming = !1, this._rotating = !1, this._pitching = !1, this._padding = !1, o && this.fire(new e.z("zoomend", t1)), s && this.fire(new e.z("rotateend", t1)), r && this.fire(new e.z("pitchend", t1)), this.fire(new e.z("moveend", t1));
            }
            flyTo(t1, i) {
                if (this._prefersReducedMotion(t1)) {
                    const o = e.ay(t1, [
                        "center",
                        "zoom",
                        "bearing",
                        "pitch",
                        "around",
                        "padding",
                        "retainPadding"
                    ]);
                    return this.jumpTo(o, i);
                }
                this.stop(), t1 = e.l({
                    offset: [
                        0,
                        0
                    ],
                    speed: 1.2,
                    curve: 1.42,
                    easing: e.dA
                }, t1);
                const o = this.transform, s = this.getZoom(), r = this.getBearing(), a = this.getPitch(), n = this.getPadding(), l = "zoom" in t1 ? e.aw(+t1.zoom, o.minZoom, o.maxZoom) : s, c = "bearing" in t1 ? this._normalizeBearing(t1.bearing, r) : r, h = "pitch" in t1 ? +t1.pitch : a, u = this._extendPadding(t1.padding), d = o.zoomScale(l - s), _ = e.P.convert(t1.offset);
                let p = o.centerPoint.add(_);
                const f = o.pointLocation(p), m = e.bO.convert(t1.center || f);
                this._normalizeCenter(m);
                const g = o.project(f), v = o.project(m).sub(g);
                let y = t1.curve;
                const x = Math.max(o.width, o.height), b = x / d, w = v.mag();
                if ("minZoom" in t1) {
                    const i = e.aw(Math.min(t1.minZoom, s, l), o.minZoom, o.maxZoom), r = x / o.zoomScale(i - s);
                    y = Math.sqrt(r / w * 2);
                }
                const T = y * y;
                function E(e) {
                    const t1 = (b * b - x * x + (e ? -1 : 1) * T * T * w * w) / (2 * (e ? b : x) * T * w);
                    return Math.log(Math.sqrt(t1 * t1 + 1) - t1);
                }
                function S(e) {
                    return (Math.exp(e) - Math.exp(-e)) / 2;
                }
                function C(e) {
                    return (Math.exp(e) + Math.exp(-e)) / 2;
                }
                const I = E(0);
                let R = function(e) {
                    return C(I) / C(I + y * e);
                }, D = function(e) {
                    var t1;
                    return x * ((C(I) * (S(t1 = I + y * e) / C(t1)) - S(I)) / T) / w;
                }, L = (E(1) - I) / y;
                if (Math.abs(w) < 1e-6 || !isFinite(L)) {
                    if (Math.abs(x - b) < 1e-6) return this.easeTo(t1, i);
                    const e = b < x ? -1 : 1;
                    L = Math.abs(Math.log(b / x)) / y, D = function() {
                        return 0;
                    }, R = function(t1) {
                        return Math.exp(e * y * t1);
                    };
                }
                t1.duration = "duration" in t1 ? +t1.duration : 1e3 * L / ("screenSpeed" in t1 ? +t1.screenSpeed / y : +t1.speed), t1.maxDuration && t1.duration > t1.maxDuration && (t1.duration = 0);
                const A = r !== c, z = h !== a, P = !o.isPaddingEqual(u), M = !1 === t1.retainPadding ? o.clone() : o, O = (o)=>(d)=>{
                        const f = d * L, y = 1 / R(f);
                        o.zoom = 1 === d ? l : s + o.scaleZoom(y), A && (o.bearing = e.af(r, c, d)), z && (o.pitch = e.af(a, h, d)), P && (M.interpolatePadding(n, u, d), p = M.centerPoint.add(_));
                        const x = 1 === d ? m : o.unproject(g.add(v.mult(D(f))).mult(y));
                        return o.setLocationAtPoint(o.renderWorldCopies ? x.wrap() : x, p), o._updateCameraOnTerrain(), t1.preloadOnly || this._fireMoveEvents(i), o;
                    };
                if (t1.preloadOnly) {
                    const e = this._emulate(O, t1.duration, o);
                    return this._preloadTiles(e), this;
                }
                return this._zooming = !0, this._rotating = A, this._pitching = z, this._padding = P, this._prepareEase(i, !1), this._ease(O(o), ()=>this._afterEase(i), t1), this;
            }
            isEasing() {
                return !!this._easeFrameId;
            }
            stop() {
                return this._stop();
            }
            _requestRenderFrame(e) {}
            _cancelRenderFrame(e) {}
            _stop(e, t1) {
                if (this._easeFrameId && (this._cancelRenderFrame(this._easeFrameId), this._easeFrameId = void 0, this._onEaseFrame = void 0), this._onEaseEnd) {
                    const e = this._onEaseEnd;
                    this._onEaseEnd = void 0, e.call(this, t1);
                }
                if (!e) {
                    const e = this.handlers;
                    e && e.stop(!1);
                }
                return this;
            }
            _ease(t1, i, o) {
                !1 === o.animate || 0 === o.duration ? (t1(1), i()) : (this._easeStart = e.q.now(), this._easeOptions = o, this._onEaseFrame = t1, this._onEaseEnd = i, this._easeFrameId = this._requestRenderFrame(this._renderFrameCallback));
            }
            _renderFrameCallback() {
                const t1 = Math.min((e.q.now() - this._easeStart) / this._easeOptions.duration, 1), i = this._onEaseFrame;
                i && i(this._easeOptions.easing(t1)), t1 < 1 ? this._easeFrameId = this._requestRenderFrame(this._renderFrameCallback) : this.stop();
            }
            _normalizeBearing(t1, i) {
                t1 = e.bF(t1, -180, 180);
                const o = Math.abs(t1 - i);
                return Math.abs(t1 - 360 - i) < o && (t1 -= 360), Math.abs(t1 + 360 - i) < o && (t1 += 360), t1;
            }
            _normalizeCenter(e) {
                const t1 = this.transform;
                if (t1.maxBounds) return;
                if ("globe" !== t1.projection.name && !t1.renderWorldCopies) return;
                const i = e.lng - t1.center.lng;
                e.lng += i > 180 ? -360 : i < -180 ? 360 : 0;
            }
            _prefersReducedMotion(t1) {
                return this._respectPrefersReducedMotion && e.q.prefersReducedMotion && !(t1 && t1.essential);
            }
            _emulate(e, t1, i) {
                const o = Math.ceil(15 * t1 / 1e3), s = [], r = e(i.clone());
                for(let e = 0; e <= o; e++){
                    const t1 = r(e / o);
                    s.push(t1.clone());
                }
                return s;
            }
            _preloadTiles(e, t1) {}
            constructor(t1, i){
                super(), this._moving = !1, this._zooming = !1, this.transform = t1, this._bearingSnap = i.bearingSnap, this._respectPrefersReducedMotion = !1 !== i.respectPrefersReducedMotion, e.aP([
                    "_renderFrameCallback"
                ], this);
            }
        }
        class Yn {
            getDefaultPosition() {
                return "bottom-right";
            }
            onAdd(e) {
                const t1 = this.options && this.options.compact, i = e._getUIString("AttributionControl.ToggleAttribution");
                this._map = e, this._container = l("div", "mapboxgl-ctrl mapboxgl-ctrl-attrib"), this._compactButton = l("button", "mapboxgl-ctrl-attrib-button", this._container), this._compactButton.type = "button", this._compactButton.addEventListener("click", this._toggleAttribution), this._compactButton.setAttribute("aria-label", i);
                const o = l("span", "mapboxgl-ctrl-icon", this._compactButton);
                return o.setAttribute("aria-hidden", "true"), o.setAttribute("title", i), this._innerContainer = l("div", "mapboxgl-ctrl-attrib-inner", this._container), t1 && this._container.classList.add("mapboxgl-compact"), this._updateAttributions(), this._updateEditLink(), this._map.on("styledata", this._updateData), this._map.on("sourcedata", this._updateData), this._map.on("moveend", this._updateEditLink), void 0 === t1 && (this._map.on("resize", this._updateCompact), this._updateCompact()), this._container;
            }
            onRemove() {
                this._container.remove(), this._map.off("styledata", this._updateData), this._map.off("sourcedata", this._updateData), this._map.off("moveend", this._updateEditLink), this._map.off("resize", this._updateCompact), this._map = void 0, this._attribHTML = void 0;
            }
            _toggleAttribution() {
                this._container.classList.contains("mapboxgl-compact-show") ? (this._container.classList.remove("mapboxgl-compact-show"), this._compactButton.setAttribute("aria-expanded", "false")) : (this._container.classList.add("mapboxgl-compact-show"), this._compactButton.setAttribute("aria-expanded", "true"));
            }
            _updateEditLink() {
                let t1 = this._editLink;
                t1 || (t1 = this._editLink = this._container.querySelector(".mapbox-improve-map"));
                const i = [
                    {
                        key: "owner",
                        value: this.styleOwner
                    },
                    {
                        key: "id",
                        value: this.styleId
                    },
                    {
                        key: "access_token",
                        value: this._map._requestManager._customAccessToken || e.e.ACCESS_TOKEN
                    }
                ];
                if (t1) {
                    const o = i.reduce((e, t1, o)=>(t1.value && (e += `${t1.key}=${t1.value}${o < i.length - 1 ? "&" : ""}`), e), "?");
                    t1.href = `${e.e.FEEDBACK_URL}/${o}#${Ja(this._map, !0)}`, t1.rel = "noopener nofollow";
                }
            }
            _updateData(e) {
                !e || "metadata" !== e.sourceDataType && "visibility" !== e.sourceDataType && "style" !== e.dataType || (this._updateAttributions(), this._updateEditLink());
            }
            _updateAttributions() {
                if (!this._map.style) return;
                let e = [];
                if (this._map.style.stylesheet) {
                    const e = this._map.style.stylesheet;
                    this.styleOwner = e.owner, this.styleId = e.id;
                }
                const t1 = this._map.style._mergedSourceCaches;
                for(const i in t1){
                    const o = t1[i];
                    if (o.used) {
                        const t1 = o.getSource();
                        t1.attribution && e.indexOf(t1.attribution) < 0 && e.push(t1.attribution);
                    }
                }
                e.sort((e, t1)=>e.length - t1.length), e = e.filter((t1, i)=>{
                    for(let o = i + 1; o < e.length; o++)if (e[o].indexOf(t1) >= 0) return !1;
                    return !0;
                }), this.options.customAttribution && (Array.isArray(this.options.customAttribution) ? e = [
                    ...this.options.customAttribution,
                    ...e
                ] : e.unshift(this.options.customAttribution));
                const i = e.join(" | ");
                i !== this._attribHTML && (this._attribHTML = i, e.length ? (this._innerContainer.innerHTML = i, this._container.classList.remove("mapboxgl-attrib-empty")) : this._container.classList.add("mapboxgl-attrib-empty"), this._editLink = null);
            }
            _updateCompact() {
                this._map.getCanvasContainer().offsetWidth <= 640 ? this._container.classList.add("mapboxgl-compact") : this._container.classList.remove("mapboxgl-compact", "mapboxgl-compact-show");
            }
            constructor(t1 = {}){
                this.options = t1, e.aP([
                    "_toggleAttribution",
                    "_updateEditLink",
                    "_updateData",
                    "_updateCompact"
                ], this);
            }
        }
        class Jn {
            onAdd(e) {
                this._map = e, this._container = l("div", "mapboxgl-ctrl");
                const t1 = l("a", "mapboxgl-ctrl-logo");
                return t1.target = "_blank", t1.rel = "noopener nofollow", t1.href = "https://www.mapbox.com/", t1.setAttribute("aria-label", this._map._getUIString("LogoControl.Title")), t1.setAttribute("rel", "noopener nofollow"), this._container.appendChild(t1), this._container.style.display = "none", this._map.on("sourcedata", this._updateLogo), this._updateLogo(), this._map.on("resize", this._updateCompact), this._updateCompact(), this._container;
            }
            onRemove() {
                this._container.remove(), this._map.off("sourcedata", this._updateLogo), this._map.off("resize", this._updateCompact);
            }
            getDefaultPosition() {
                return "bottom-left";
            }
            _updateLogo(e) {
                e && "metadata" !== e.sourceDataType || (this._container.style.display = this._logoRequired() ? "block" : "none");
            }
            _logoRequired() {
                if (!this._map.style) return !0;
                const e = this._map.style._sourceCaches;
                if (0 === Object.entries(e).length) return !0;
                for(const t1 in e){
                    const i = e[t1].getSource();
                    if (i.hasOwnProperty("mapbox_logo") && !i.mapbox_logo) return !1;
                }
                return !0;
            }
            _updateCompact() {
                const e = this._container.children;
                if (e.length) {
                    const t1 = e[0];
                    this._map.getCanvasContainer().offsetWidth < 250 ? t1.classList.add("mapboxgl-compact") : t1.classList.remove("mapboxgl-compact");
                }
            }
            constructor(){
                e.aP([
                    "_updateLogo",
                    "_updateCompact"
                ], this);
            }
        }
        class Qn {
            add(e) {
                const t1 = ++this._id;
                return this._queue.push({
                    callback: e,
                    id: t1,
                    cancelled: !1
                }), t1;
            }
            remove(e) {
                const t1 = this._currentlyRunning, i = t1 ? this._queue.concat(t1) : this._queue;
                for (const t1 of i)if (t1.id === e) return void (t1.cancelled = !0);
            }
            run(e = 0) {
                const t1 = this._currentlyRunning = this._queue;
                this._queue = [];
                for (const i of t1)if (!i.cancelled && (i.callback(e), this._cleared)) break;
                this._cleared = !1, this._currentlyRunning = !1;
            }
            clear() {
                this._currentlyRunning && (this._cleared = !0), this._queue = [];
            }
            constructor(){
                this._queue = [], this._id = 0, this._cleared = !1, this._currentlyRunning = !1;
            }
        }
        class el {
            getValue(t1) {
                if (t1 <= this._startTime) return this._start;
                if (t1 >= this._endTime) return this._end;
                const i = e.cB((t1 - this._startTime) / (this._endTime - this._startTime));
                return this._start * (1 - i) + this._end * i;
            }
            isEasing(e) {
                return e >= this._startTime && e <= this._endTime;
            }
            jumpTo(e) {
                this._startTime = -1 / 0, this._endTime = -1 / 0, this._start = e, this._end = e;
            }
            easeTo(e, t1, i) {
                this._start = this.getValue(t1), this._end = e, this._startTime = t1, this._endTime = t1 + i;
            }
            constructor(e){
                this.jumpTo(e);
            }
        }
        const tl = {
            "AttributionControl.ToggleAttribution": "Toggle attribution",
            "FullscreenControl.Enter": "Enter fullscreen",
            "FullscreenControl.Exit": "Exit fullscreen",
            "GeolocateControl.FindMyLocation": "Find my location",
            "GeolocateControl.LocationNotAvailable": "Location not available",
            "LogoControl.Title": "Mapbox homepage",
            "Map.Title": "Map",
            "NavigationControl.ResetBearing": "Reset bearing to north",
            "NavigationControl.ZoomIn": "Zoom in",
            "NavigationControl.ZoomOut": "Zoom out",
            "ScrollZoomBlocker.CtrlMessage": "Use ctrl + scroll to zoom the map",
            "ScrollZoomBlocker.CmdMessage": "Use \u2318 + scroll to zoom the map",
            "TouchPanBlocker.Message": "Use two fingers to move the map"
        };
        class il extends e.z {
            constructor(e, t1, i, o){
                const { point: s, lngLat: r, originalEvent: a, target: n } = e;
                super(e.type, {
                    point: s,
                    lngLat: r,
                    originalEvent: a,
                    target: n
                }), this.preventDefault = ()=>{
                    e.preventDefault();
                }, this.id = t1, this.interaction = i, this.feature = o;
            }
        }
        class ol {
            add(t1, i) {
                if (this.typeById.has(t1)) throw new Error(`Interaction id "${t1}" already exists.`);
                const o = i.filter;
                let s = i.type;
                o && this.filters.set(t1, e.aZ(o)), "mouseover" === s && (s = "mouseenter"), "mouseout" === s && (s = "mouseleave");
                const r = this.interactionsByType.get(s) || new Map;
                "mouseenter" === s || "mouseleave" === s ? (0 === this.delegatedInteractions.size && (this.map.on("mousemove", this.handleMove), this.map.on("mouseout", this.handleOut)), this.delegatedInteractions.set(t1, i)) : 0 === r.size && this.map.on(s, this.handleType), 0 === r.size && this.interactionsByType.set(s, r), r.set(t1, i), this.typeById.set(t1, s);
            }
            get(e) {
                const t1 = this.typeById.get(e);
                if (!t1) return;
                const i = this.interactionsByType.get(t1);
                return i ? i.get(e) : void 0;
            }
            remove(e) {
                const t1 = this.typeById.get(e);
                if (!t1) return;
                this.typeById.delete(e), this.filters.delete(e);
                const i = this.interactionsByType.get(t1);
                i && (i.delete(e), "mouseenter" === t1 || "mouseleave" === t1 ? (this.delegatedInteractions.delete(e), 0 === this.delegatedInteractions.size && (this.map.off("mousemove", this.handleMove), this.map.off("mouseout", this.handleOut))) : 0 === i.size && this.map.off(t1, this.handleType));
            }
            queryTargets(e, t1) {
                const i = [];
                for (const [e, o] of t1)o.target && i.push({
                    targetId: e,
                    target: o.target,
                    filter: this.filters.get(e)
                });
                return this.map.style.queryRenderedTargets(e, i, this.map.transform);
            }
            handleMove(e) {
                this.prevHoveredFeatures = this.hoveredFeatures, this.hoveredFeatures = new Map;
                const t1 = this.queryTargets(e.point, Array.from(this.delegatedInteractions).reverse());
                t1.length && (e.type = "mouseenter", this.handleType(e, t1));
                const i = new Map;
                for (const [e, { feature: t1 }] of this.prevHoveredFeatures)this.hoveredFeatures.has(e) || i.set(t1.id, t1);
                i.size && (e.type = "mouseleave", this.handleType(e, Array.from(i.values())));
            }
            handleOut(e) {
                const t1 = Array.from(this.hoveredFeatures.values()).map(({ feature: e })=>e);
                t1.length && (e.type = "mouseleave", this.handleType(e, t1)), this.hoveredFeatures.clear();
            }
            handleType(t1, i) {
                const o = Array.from(this.interactionsByType.get(t1.type)).reverse(), s = !!i;
                i = i || this.queryTargets(t1.point, o);
                const r = "mouseenter" === t1.type;
                let a = !1;
                const n = new Set;
                for (const l of i){
                    for (const [i, c] of o){
                        if (!c.target) continue;
                        const o = l.variants ? l.variants[i] : null;
                        if (o) {
                            for (const h of o){
                                if (nt(h, l, n, i)) continue;
                                const o = new e.cw(l, h), u = at(h, l, i);
                                s && (o.state = this.map.getFeatureState(o));
                                const d = r ? this.prevHoveredFeatures.get(u) : null, _ = new il(t1, i, c, o), p = d ? d.stop : c.handler(_);
                                if (r && this.hoveredFeatures.set(u, {
                                    feature: l,
                                    stop: p
                                }), !1 !== p) {
                                    a = !0;
                                    break;
                                }
                            }
                            if (a) break;
                        }
                    }
                    if (a) break;
                }
                if (!a) for (const [e, i] of o){
                    const { handler: o, target: s } = i;
                    if (!s && !1 !== o(new il(t1, e, i, null))) break;
                }
            }
            constructor(e){
                this.map = e, this.interactionsByType = new Map, this.delegatedInteractions = new Map, this.typeById = new Map, this.filters = new Map, this.handleType = this.handleType.bind(this), this.handleMove = this.handleMove.bind(this), this.handleOut = this.handleOut.bind(this), this.hoveredFeatures = new Map, this.prevHoveredFeatures = new Map;
            }
        }
        function sl(t1, i) {
            if (Array.isArray(t1) && Array.isArray(i)) {
                const e = new Set(t1), o = new Set(i);
                return e.size === o.size && t1.every((e)=>o.has(e));
            }
            return e.bn(t1, i);
        }
        const rl = {
            center: [
                0,
                0
            ],
            zoom: 0,
            bearing: 0,
            pitch: 0,
            minZoom: -2,
            maxZoom: 22,
            minPitch: 0,
            maxPitch: 85,
            interactive: !0,
            scrollZoom: !0,
            boxZoom: !0,
            dragRotate: !0,
            dragPan: !0,
            keyboard: !0,
            doubleClickZoom: !0,
            touchZoomRotate: !0,
            touchPitch: !0,
            cooperativeGestures: !1,
            performanceMetricsCollection: !0,
            bearingSnap: 7,
            clickTolerance: 3,
            pitchWithRotate: !0,
            hash: !1,
            attributionControl: !0,
            antialias: !1,
            failIfMajorPerformanceCaveat: !1,
            preserveDrawingBuffer: !1,
            trackResize: !0,
            renderWorldCopies: !0,
            refreshExpiredTiles: !0,
            minTileCacheSize: null,
            maxTileCacheSize: null,
            localIdeographFontFamily: "sans-serif",
            localFontFamily: null,
            transformRequest: null,
            accessToken: null,
            fadeDuration: 300,
            respectPrefersReducedMotion: !0,
            crossSourceCollisions: !0,
            collectResourceTiming: !1,
            testMode: !1,
            precompilePrograms: !0,
            scaleFactor: 1,
            spriteFormat: "auto"
        }, al = {
            showCompass: !0,
            showZoom: !0,
            visualizePitch: !1
        };
        class nl {
            down(e, t1) {
                this.mouseRotate.mousedown(e, t1), this.mousePitch && this.mousePitch.mousedown(e, t1), _();
            }
            move(e, t1) {
                const i = this.map, o = this.mouseRotate.mousemoveWindow(e, t1), s = o && o.bearingDelta;
                if (s && i.setBearing(i.getBearing() + s), this.mousePitch) {
                    const o = this.mousePitch.mousemoveWindow(e, t1), s = o && o.pitchDelta;
                    s && i.setPitch(i.getPitch() + s);
                }
            }
            off() {
                const e = this.element;
                e.removeEventListener("mousedown", this.mousedown), e.removeEventListener("touchstart", this.touchstart, {
                    passive: !1
                }), e.removeEventListener("touchmove", this.touchmove), e.removeEventListener("touchend", this.touchend), e.removeEventListener("touchcancel", this.reset), this.offTemp();
            }
            offTemp() {
                p(), window.removeEventListener("mousemove", this.mousemove), window.removeEventListener("mouseup", this.mouseup);
            }
            mousedown(t1) {
                this.down(e.l({}, t1, {
                    ctrlKey: !0,
                    preventDefault: ()=>t1.preventDefault()
                }), g(this.element, t1)), window.addEventListener("mousemove", this.mousemove), window.addEventListener("mouseup", this.mouseup);
            }
            mousemove(e) {
                this.move(e, g(this.element, e));
            }
            mouseup(e) {
                this.mouseRotate.mouseupWindow(e), this.mousePitch && this.mousePitch.mouseupWindow(e), this.offTemp();
            }
            touchstart(e) {
                1 !== e.targetTouches.length ? this.reset() : (this._startPos = this._lastPos = v(this.element, e.targetTouches)[0], this.down({
                    type: "mousedown",
                    button: 0,
                    ctrlKey: !0,
                    preventDefault: ()=>e.preventDefault()
                }, this._startPos));
            }
            touchmove(e) {
                1 !== e.targetTouches.length ? this.reset() : (this._lastPos = v(this.element, e.targetTouches)[0], this.move({
                    preventDefault: ()=>e.preventDefault()
                }, this._lastPos));
            }
            touchend(e) {
                0 === e.targetTouches.length && this._startPos && this._lastPos && this._startPos.dist(this._lastPos) < this._clickTolerance && this.element.click(), this.reset();
            }
            reset() {
                this.mouseRotate.reset(), this.mousePitch && this.mousePitch.reset(), delete this._startPos, delete this._lastPos, this.offTemp();
            }
            constructor(t1, i, o = !1){
                this._clickTolerance = 10, this.element = i, this.mouseRotate = new bn({
                    clickTolerance: t1.dragRotate._mouseRotate._clickTolerance
                }), this.map = t1, o && (this.mousePitch = new wn({
                    clickTolerance: t1.dragRotate._mousePitch._clickTolerance
                })), e.aP([
                    "mousedown",
                    "mousemove",
                    "mouseup",
                    "touchstart",
                    "touchmove",
                    "touchend",
                    "reset"
                ], this), i.addEventListener("mousedown", this.mousedown), i.addEventListener("touchstart", this.touchstart, {
                    passive: !1
                }), i.addEventListener("touchmove", this.touchmove), i.addEventListener("touchend", this.touchend), i.addEventListener("touchcancel", this.reset);
            }
        }
        function ll(t1, i, o) {
            if (t1 = new e.bO(t1.lng, t1.lat), i) {
                const s = new e.bO(t1.lng - 360, t1.lat), r = new e.bO(t1.lng + 360, t1.lat), a = 360 * Math.ceil(Math.abs(t1.lng - o.center.lng) / 360), n = o.locationPoint(t1).distSqr(i), l = i.x < 0 || i.y < 0 || i.x > o.width || i.y > o.height;
                o.locationPoint(s).distSqr(i) < n && (l || Math.abs(s.lng - o.center.lng) < a) ? t1 = s : o.locationPoint(r).distSqr(i) < n && (l || Math.abs(r.lng - o.center.lng) < a) && (t1 = r);
            }
            for(; Math.abs(t1.lng - o.center.lng) > 180;){
                const e = o.locationPoint(t1);
                if (e.x >= 0 && e.y >= 0 && e.x <= o.width && e.y <= o.height) break;
                t1.lng > o.center.lng ? t1.lng -= 360 : t1.lng += 360;
            }
            return t1;
        }
        const cl = {
            center: "translate(-50%,-50%)",
            top: "translate(-50%,0)",
            "top-left": "translate(0,0)",
            "top-right": "translate(-100%,0)",
            bottom: "translate(-50%,-100%)",
            "bottom-left": "translate(0,-100%)",
            "bottom-right": "translate(-100%,-100%)",
            left: "translate(0,-50%)",
            right: "translate(-100%,-50%)"
        };
        class hl extends e.E {
            addTo(e) {
                return e === this._map || (this.remove(), this._map = e, e.getCanvasContainer().appendChild(this._element), e.on("move", this._updateMoving), e.on("moveend", this._update), e.on("remove", this._clearFadeTimer), e._addMarker(this), this.setDraggable(this._draggable), this._update(), e.on("click", this._onMapClick)), this;
            }
            remove() {
                const e = this._map;
                return e && (e.off("click", this._onMapClick), e.off("move", this._updateMoving), e.off("moveend", this._update), e.off("mousedown", this._addDragHandler), e.off("touchstart", this._addDragHandler), e.off("mouseup", this._onUp), e.off("touchend", this._onUp), e.off("mousemove", this._onMove), e.off("touchmove", this._onMove), e.off("remove", this._clearFadeTimer), e._removeMarker(this), this._map = void 0), this._clearFadeTimer(), this._element.remove(), this._popup && this._popup.remove(), this;
            }
            getLngLat() {
                return this._lngLat;
            }
            setLngLat(t1) {
                return this._lngLat = e.bO.convert(t1), this._pos = null, this._popup && this._popup.setLngLat(this._lngLat), this._update(!0), this;
            }
            getElement() {
                return this._element;
            }
            setPopup(e) {
                if (this._popup && (this._popup.remove(), this._popup = null, this._element.removeAttribute("role"), this._element.removeEventListener("keypress", this._onKeyPress), this._originalTabIndex || this._element.removeAttribute("tabindex")), e) {
                    if (!("offset" in e.options)) {
                        const t1 = 38.1, i = 13.5, o = Math.sqrt(Math.pow(i, 2) / 2);
                        e.options.offset = this._defaultMarker ? {
                            top: [
                                0,
                                0
                            ],
                            "top-left": [
                                0,
                                0
                            ],
                            "top-right": [
                                0,
                                0
                            ],
                            bottom: [
                                0,
                                -t1
                            ],
                            "bottom-left": [
                                o,
                                -1 * (t1 - i + o)
                            ],
                            "bottom-right": [
                                -o,
                                -1 * (t1 - i + o)
                            ],
                            left: [
                                i,
                                -1 * (t1 - i)
                            ],
                            right: [
                                -i,
                                -1 * (t1 - i)
                            ]
                        } : this._offset;
                    }
                    this._popup = e, e._marker = this, this._lngLat && this._popup.setLngLat(this._lngLat), this._element.setAttribute("role", "button"), this._originalTabIndex = this._element.getAttribute("tabindex"), this._originalTabIndex || this._element.setAttribute("tabindex", "0"), this._element.addEventListener("keypress", this._onKeyPress), this._element.setAttribute("aria-expanded", "false");
                }
                return this;
            }
            _onKeyPress(e) {
                const t1 = e.code, i = e.charCode || e.keyCode;
                "Space" !== t1 && "Enter" !== t1 && 32 !== i && 13 !== i || this.togglePopup();
            }
            _onMapClick(e) {
                const t1 = e.originalEvent.target, i = this._element;
                this._popup && (t1 === i || i.contains(t1)) && this.togglePopup();
            }
            getPopup() {
                return this._popup;
            }
            togglePopup() {
                const e = this._popup;
                return e ? (e.isOpen() ? (e.remove(), this._element.setAttribute("aria-expanded", "false")) : this._map && (e.addTo(this._map), this._element.setAttribute("aria-expanded", "true")), this) : this;
            }
            _behindTerrain() {
                const e = this._map, t1 = this._pos;
                if (!e || !t1) return !1;
                const i = e.unproject(t1), o = e.getFreeCameraOptions();
                if (!o.position) return !1;
                const s = o.position.toLngLat();
                return s.distanceTo(i) < .9 * s.distanceTo(this._lngLat);
            }
            _evaluateOpacity() {
                const t1 = this._map;
                if (!t1) return;
                const i = this._pos;
                if (!i || i.x < 0 || i.x > t1.transform.width || i.y < 0 || i.y > t1.transform.height) return void this._clearFadeTimer();
                const o = t1.unproject(i);
                let s;
                t1._showingGlobe() && e.dH(t1.transform, this._lngLat) ? s = 0 : (s = 1 - t1._queryFogOpacity(o), t1.transform._terrainEnabled() && t1.getTerrain() && this._behindTerrain() && (s *= this._occludedOpacity)), this._element.style.opacity = `${s}`, this._element.style.pointerEvents = s > 0 ? "auto" : "none", this._popup && this._popup._setOpacity(s), this._fadeTimer = null;
            }
            _clearFadeTimer() {
                this._fadeTimer && (clearTimeout(this._fadeTimer), this._fadeTimer = null);
            }
            _updateDOM() {
                const e = this._pos;
                if (!e || !this._map) return;
                const t1 = this._offset.mult(this._scale);
                this._element.style.transform = `\n            translate(${e.x}px,${e.y}px)\n            ${cl[this._anchor]}\n            ${this._calculateXYTransform()} ${this._calculateZTransform()}\n            translate(${t1.x}px,${t1.y}px)\n        `;
            }
            _calculateXYTransform() {
                const t1 = this._pos, i = this._map, o = this.getPitchAlignment();
                if (!i || !t1 || "map" !== o) return "";
                if (!i._showingGlobe()) {
                    const e = i.getPitch();
                    return e ? `rotateX(${e}deg)` : "";
                }
                const s = e.c4(e.dI(i.transform, this._lngLat)), r = t1.sub(e.dJ(i.transform)), a = Math.abs(r.x) + Math.abs(r.y);
                if (0 === a) return "";
                const n = s / a;
                return `rotateX(${-r.y * n}deg) rotateY(${r.x * n}deg)`;
            }
            _calculateZTransform() {
                const t1 = this._pos, i = this._map;
                if (!i || !t1) return "";
                let o = 0;
                const s = this.getRotationAlignment();
                if ("map" === s) {
                    if (i._showingGlobe()) {
                        const t1 = i.project(new e.bO(this._lngLat.lng, this._lngLat.lat + .001)), s = i.project(new e.bO(this._lngLat.lng, this._lngLat.lat - .001)).sub(t1);
                        o = e.c4(Math.atan2(s.y, s.x)) - 90;
                    } else o = -i.getBearing();
                } else if ("horizon" === s) {
                    const s = e.ac(4, 6, i.getZoom()), r = e.dJ(i.transform);
                    r.y += s * i.transform.height;
                    const a = t1.sub(r), n = e.c4(Math.atan2(a.y, a.x));
                    o = (n > 90 ? n - 270 : n + 90) * (1 - s);
                }
                return o += this._rotation, o ? `rotateZ(${o}deg)` : "";
            }
            _update(e) {
                cancelAnimationFrame(this._updateFrameId);
                const t1 = this._map;
                t1 && (t1.transform.renderWorldCopies && (this._lngLat = ll(this._lngLat, this._pos, t1.transform)), this._pos = t1.project(this._lngLat), !0 === e ? this._updateFrameId = requestAnimationFrame(()=>{
                    this._element && this._pos && this._anchor && (this._pos = this._pos.round(), this._updateDOM());
                }) : this._pos = this._pos.round(), t1._requestDomTask(()=>{
                    this._map && (this._element && this._pos && this._anchor && this._updateDOM(), (t1._showingGlobe() || t1.getTerrain() || t1.getFog()) && !this._fadeTimer && (this._fadeTimer = window.setTimeout(this._evaluateOpacity.bind(this), 60)));
                }));
            }
            getOffset() {
                return this._offset;
            }
            setOffset(t1) {
                return this._offset = e.P.convert(t1), this._update(), this;
            }
            addClassName(e) {
                return this._element.classList.add(e), this;
            }
            removeClassName(e) {
                return this._element.classList.remove(e), this;
            }
            toggleClassName(e) {
                return this._element.classList.toggle(e);
            }
            _onMove(t1) {
                const i = this._map;
                if (!i) return;
                const o = this._pointerdownPos, s = this._positionDelta;
                if (o && s) {
                    if (!this._isDragging) {
                        const e = this._clickTolerance || i._clickTolerance;
                        if (t1.point.dist(o) < e) return;
                        this._isDragging = !0;
                    }
                    this._pos = t1.point.sub(s), this._lngLat = i.unproject(this._pos), this.setLngLat(this._lngLat), this._element.style.pointerEvents = "none", "pending" === this._state && (this._state = "active", this.fire(new e.z("dragstart"))), this.fire(new e.z("drag"));
                }
            }
            _onUp() {
                this._element.style.pointerEvents = "auto", this._positionDelta = null, this._pointerdownPos = null, this._isDragging = !1;
                const t1 = this._map;
                t1 && (t1.off("mousemove", this._onMove), t1.off("touchmove", this._onMove)), "active" === this._state && this.fire(new e.z("dragend")), this._state = "inactive";
            }
            _addDragHandler(e) {
                const t1 = this._map, i = this._pos;
                t1 && i && this._element.contains(e.originalEvent.target) && (e.preventDefault(), this._positionDelta = e.point.sub(i), this._pointerdownPos = e.point, this._state = "pending", t1.on("mousemove", this._onMove), t1.on("touchmove", this._onMove), t1.once("mouseup", this._onUp), t1.once("touchend", this._onUp));
            }
            setDraggable(e) {
                this._draggable = !!e;
                const t1 = this._map;
                return t1 && (e ? (t1.on("mousedown", this._addDragHandler), t1.on("touchstart", this._addDragHandler)) : (t1.off("mousedown", this._addDragHandler), t1.off("touchstart", this._addDragHandler))), this;
            }
            isDraggable() {
                return this._draggable;
            }
            setRotation(e) {
                return this._rotation = e || 0, this._update(), this;
            }
            getRotation() {
                return this._rotation;
            }
            setRotationAlignment(e) {
                return this._rotationAlignment = e || "auto", this._update(), this;
            }
            getRotationAlignment() {
                return "auto" === this._rotationAlignment || "horizon" === this._rotationAlignment && this._map && !this._map._showingGlobe() ? "viewport" : this._rotationAlignment;
            }
            setPitchAlignment(e) {
                return this._pitchAlignment = e || "auto", this._update(), this;
            }
            getPitchAlignment() {
                return "auto" === this._pitchAlignment ? this.getRotationAlignment() : this._pitchAlignment;
            }
            setOccludedOpacity(e) {
                return this._occludedOpacity = e || .2, this._update(), this;
            }
            getOccludedOpacity() {
                return this._occludedOpacity;
            }
            constructor(t1, i){
                if (super(), (t1 instanceof HTMLElement || i) && (t1 = e.l({
                    element: t1
                }, i)), e.aP([
                    "_update",
                    "_onMove",
                    "_onUp",
                    "_addDragHandler",
                    "_onMapClick",
                    "_onKeyPress",
                    "_clearFadeTimer"
                ], this), this._anchor = t1 && t1.anchor || "center", this._color = t1 && t1.color || "#3FB1CE", this._scale = t1 && t1.scale || 1, this._draggable = t1 && t1.draggable || !1, this._clickTolerance = t1 && t1.clickTolerance || 0, this._isDragging = !1, this._state = "inactive", this._rotation = t1 && t1.rotation || 0, this._rotationAlignment = t1 && t1.rotationAlignment || "auto", this._pitchAlignment = t1 && t1.pitchAlignment && t1.pitchAlignment || "auto", this._updateMoving = ()=>this._update(!0), this._occludedOpacity = t1 && t1.occludedOpacity || .2, t1 && t1.element) this._element = t1.element, this._offset = e.P.convert(t1 && t1.offset || [
                    0,
                    0
                ]);
                else {
                    this._defaultMarker = !0, this._element = l("div");
                    const i = 41, o = 27, s = c("svg", {
                        display: "block",
                        height: i * this._scale + "px",
                        width: o * this._scale + "px",
                        viewBox: `0 0 ${o} ${i}`
                    }, this._element), r = c("radialGradient", {
                        id: "shadowGradient"
                    }, c("defs", {}, s));
                    c("stop", {
                        offset: "10%",
                        "stop-opacity": .4
                    }, r), c("stop", {
                        offset: "100%",
                        "stop-opacity": .05
                    }, r), c("ellipse", {
                        cx: 13.5,
                        cy: 34.8,
                        rx: 10.5,
                        ry: 5.25,
                        fill: "url(#shadowGradient)"
                    }, s), c("path", {
                        fill: this._color,
                        d: "M27,13.5C27,19.07 20.25,27 14.75,34.5C14.02,35.5 12.98,35.5 12.25,34.5C6.75,27 0,19.22 0,13.5C0,6.04 6.04,0 13.5,0C20.96,0 27,6.04 27,13.5Z"
                    }, s), c("path", {
                        opacity: .25,
                        d: "M13.5,0C6.04,0 0,6.04 0,13.5C0,19.22 6.75,27 12.25,34.5C13,35.52 14.02,35.5 14.75,34.5C20.25,27 27,19.07 27,13.5C27,6.04 20.96,0 13.5,0ZM13.5,1C20.42,1 26,6.58 26,13.5C26,15.9 24.5,19.18 22.22,22.74C19.95,26.3 16.71,30.14 13.94,33.91C13.74,34.18 13.61,34.32 13.5,34.44C13.39,34.32 13.26,34.18 13.06,33.91C10.28,30.13 7.41,26.31 5.02,22.77C2.62,19.23 1,15.95 1,13.5C1,6.58 6.58,1 13.5,1Z"
                    }, s), c("circle", {
                        fill: "white",
                        cx: 13.5,
                        cy: 13.5,
                        r: 5.5
                    }, s), this._offset = e.P.convert(t1 && t1.offset || [
                        0,
                        -14
                    ]);
                }
                this._element.hasAttribute("aria-label") || this._element.setAttribute("aria-label", "Map marker"), this._element.hasAttribute("role") || this._element.setAttribute("role", "img"), this._element.classList.add("mapboxgl-marker"), this._element.addEventListener("dragstart", (e)=>{
                    e.preventDefault();
                }), this._element.addEventListener("mousedown", (e)=>{
                    e.preventDefault();
                });
                const o = this._element.classList;
                for(const e in cl)o.remove(`mapboxgl-marker-anchor-${e}`);
                o.add(`mapboxgl-marker-anchor-${this._anchor}`);
                const s = t1 && t1.className ? t1.className.trim().split(/\s+/) : [];
                o.add(...s), this._popup = null;
            }
        }
        const ul = {
            positionOptions: {
                enableHighAccuracy: !1,
                maximumAge: 0,
                timeout: 6e3
            },
            fitBoundsOptions: {
                maxZoom: 15
            },
            trackUserLocation: !1,
            showAccuracyCircle: !0,
            showUserLocation: !0,
            showUserHeading: !1
        }, dl = {
            maxWidth: 100,
            unit: "metric"
        }, _l = {
            kilometer: "km",
            meter: "m",
            mile: "mi",
            foot: "ft",
            "nautical-mile": "nm"
        }, pl = {
            closeButton: !0,
            closeOnClick: !0,
            focusAfterOpen: !0,
            className: "",
            maxWidth: "240px"
        }, fl = [
            "a[href]",
            "[tabindex]:not([tabindex='-1'])",
            "[contenteditable]:not([contenteditable='false'])",
            "button:not([disabled])",
            "input:not([disabled])",
            "select:not([disabled])",
            "textarea:not([disabled])"
        ].join(", ");
        function ml(t1 = new e.P(0, 0), i = "bottom") {
            if ("number" == typeof t1) {
                const o = Math.round(Math.sqrt(.5 * Math.pow(t1, 2)));
                switch(i){
                    case "top":
                        return new e.P(0, t1);
                    case "top-left":
                        return new e.P(o, o);
                    case "top-right":
                        return new e.P(-o, o);
                    case "bottom":
                        return new e.P(0, -t1);
                    case "bottom-left":
                        return new e.P(o, -o);
                    case "bottom-right":
                        return new e.P(-o, -o);
                    case "left":
                        return new e.P(t1, 0);
                    case "right":
                        return new e.P(-t1, 0);
                }
                return new e.P(0, 0);
            }
            return t1 instanceof e.P || Array.isArray(t1) ? e.P.convert(t1) : e.P.convert(t1[i] || [
                0,
                0
            ]);
        }
        const gl = {
            version: t1,
            supported: n.supported,
            setRTLTextPlugin: e.dK,
            getRTLTextPluginStatus: e.dL,
            Map: class extends Kn {
                _getMapId() {
                    return this._mapId;
                }
                addControl(t1, i) {
                    if (void 0 === i && (i = t1.getDefaultPosition ? t1.getDefaultPosition() : "top-right"), !t1 || !t1.onAdd) return this.fire(new e.y(new Error("Invalid argument to map.addControl(). Argument must be a control with onAdd and onRemove methods.")));
                    const o = t1.onAdd(this);
                    this._controls.push(t1);
                    const s = this._controlPositions[i];
                    return -1 !== i.indexOf("bottom") ? s.insertBefore(o, s.firstChild) : s.appendChild(o), this;
                }
                removeControl(t1) {
                    if (!t1 || !t1.onRemove) return this.fire(new e.y(new Error("Invalid argument to map.removeControl(). Argument must be a control with onAdd and onRemove methods.")));
                    const i = this._controls.indexOf(t1);
                    return i > -1 && this._controls.splice(i, 1), t1.onRemove(this), this;
                }
                hasControl(e) {
                    return this._controls.indexOf(e) > -1;
                }
                getContainer() {
                    return this._container;
                }
                getCanvasContainer() {
                    return this._canvasContainer;
                }
                getCanvas() {
                    return this._canvas;
                }
                resize(t1) {
                    if (this._updateContainerDimensions(), this._containerWidth === this.transform.width && this._containerHeight === this.transform.height) return this;
                    this._resizeCanvas(this._containerWidth, this._containerHeight), this.transform.resize(this._containerWidth, this._containerHeight), this.painter.resize(Math.ceil(this._containerWidth), Math.ceil(this._containerHeight));
                    const i = !this._moving;
                    return i && this.fire(new e.z("movestart", t1)).fire(new e.z("move", t1)), this.fire(new e.z("resize", t1)), i && this.fire(new e.z("moveend", t1)), this;
                }
                getBounds() {
                    return this.transform.getBounds();
                }
                getMaxBounds() {
                    return this.transform.getMaxBounds() || null;
                }
                setMaxBounds(t1) {
                    return this.transform.setMaxBounds(e.az.convert(t1)), this._update();
                }
                setMinZoom(t1) {
                    if ((t1 = t1 ?? -2) >= -2 && t1 <= this.transform.maxZoom) return this.transform.minZoom = t1, this._update(), this.getZoom() < t1 ? this.setZoom(t1) : this.fire(new e.z("zoomstart")).fire(new e.z("zoom")).fire(new e.z("zoomend")), this;
                    throw new Error("minZoom must be between -2 and the current maxZoom, inclusive");
                }
                getMinZoom() {
                    return this.transform.minZoom;
                }
                setMaxZoom(t1) {
                    if ((t1 = t1 ?? 22) >= this.transform.minZoom) return this.transform.maxZoom = t1, this._update(), this.getZoom() > t1 ? this.setZoom(t1) : this.fire(new e.z("zoomstart")).fire(new e.z("zoom")).fire(new e.z("zoomend")), this;
                    throw new Error("maxZoom must be greater than the current minZoom");
                }
                getMaxZoom() {
                    return this.transform.maxZoom;
                }
                setMinPitch(t1) {
                    if ((t1 = t1 ?? 0) < 0) throw new Error("minPitch must be greater than or equal to 0");
                    if (t1 >= 0 && t1 <= this.transform.maxPitch) return this.transform.minPitch = t1, this._update(), this.getPitch() < t1 ? this.setPitch(t1) : this.fire(new e.z("pitchstart")).fire(new e.z("pitch")).fire(new e.z("pitchend")), this;
                    throw new Error("minPitch must be between 0 and the current maxPitch, inclusive");
                }
                getMinPitch() {
                    return this.transform.minPitch;
                }
                setMaxPitch(t1) {
                    if ((t1 = t1 ?? 85) > 85) throw new Error("maxPitch must be less than or equal to 85");
                    if (t1 >= this.transform.minPitch) return this.transform.maxPitch = t1, this._update(), this.getPitch() > t1 ? this.setPitch(t1) : this.fire(new e.z("pitchstart")).fire(new e.z("pitch")).fire(new e.z("pitchend")), this;
                    throw new Error("maxPitch must be greater than or equal to minPitch");
                }
                getMaxPitch() {
                    return this.transform.maxPitch;
                }
                getScaleFactor() {
                    return this._scaleFactor;
                }
                setScaleFactor(e) {
                    return this._scaleFactor = e, this.painter.scaleFactor = e, this._tp.refreshUI(), this._scaleFactorChanged = !0, this.style._updateFilteredLayers((e)=>"symbol" === e.type), this._update(!0), this;
                }
                getRenderWorldCopies() {
                    return this.transform.renderWorldCopies;
                }
                setRenderWorldCopies(e) {
                    return this.transform.renderWorldCopies = e, this.transform.renderWorldCopies || this._forceMarkerAndPopupUpdate(!0), this._update();
                }
                getLanguage() {
                    return this._language;
                }
                _parseLanguage(e) {
                    return "auto" === e ? navigator.language : Array.isArray(e) ? 0 === e.length ? void 0 : e.map((e)=>"auto" === e ? navigator.language : e) : e;
                }
                setLanguage(e) {
                    const t1 = this._parseLanguage(e);
                    if (!this.style || t1 === this._language) return this;
                    this._language = t1, this.style.reloadSources();
                    for (const e of this._controls)e._setLanguage && e._setLanguage(this._language);
                    return this;
                }
                getWorldview() {
                    return this._worldview;
                }
                setWorldview(e) {
                    return this.style && e !== this._worldview ? (this._worldview = e, this.style.reloadSources(), this) : this;
                }
                getProjection() {
                    return this.transform.mercatorFromTransition ? {
                        name: "globe",
                        center: [
                            0,
                            0
                        ]
                    } : this.transform.getProjection();
                }
                _showingGlobe() {
                    return "globe" === this.transform.projection.name;
                }
                setProjection(e) {
                    return this._lazyInitEmptyStyle(), e ? "string" == typeof e && (e = {
                        name: e
                    }) : e = null, this._useExplicitProjection = !!e, this._prioritizeAndUpdateProjection(e, this.style.projection);
                }
                _updateProjectionTransition() {
                    if ("globe" !== this.getProjection().name) return;
                    const t1 = this.transform, i = t1.projection.name;
                    let o;
                    "globe" === i && t1.zoom >= e.bY ? (t1.setMercatorFromTransition(), o = !0) : "mercator" === i && t1.zoom < e.bY && (t1.setProjection({
                        name: "globe"
                    }), o = !0), o && (this.style.applyProjectionUpdate(), this.style._forceSymbolLayerUpdate());
                }
                _prioritizeAndUpdateProjection(e, t1) {
                    return this._updateProjection(e || t1 || {
                        name: "mercator"
                    });
                }
                _updateProjection(t1) {
                    let i;
                    return i = "globe" === t1.name && this.transform.zoom >= e.bY ? this.transform.setMercatorFromTransition() : this.transform.setProjection(t1), this.style.applyProjectionUpdate(), i && (this.painter.clearBackgroundTiles(), this.style.clearSources(), this._update(!0), this._forceMarkerAndPopupUpdate(!0)), this;
                }
                project(t1) {
                    return this.transform.locationPoint3D(e.bO.convert(t1));
                }
                unproject(t1) {
                    return this.transform.pointLocation3D(e.P.convert(t1));
                }
                isMoving() {
                    return this._moving || this.handlers && this.handlers.isMoving() || !1;
                }
                isZooming() {
                    return this._zooming || this.handlers && this.handlers.isZooming() || !1;
                }
                isRotating() {
                    return this._rotating || this.handlers && this.handlers.isRotating() || !1;
                }
                _isDragging() {
                    return this.handlers && this.handlers._isDragging() || !1;
                }
                _createDelegatedListener(e, t1, i) {
                    const o = (e)=>{
                        let i = [];
                        if (Array.isArray(t1)) {
                            const o = t1.filter((e)=>this.getLayer(e));
                            i = o.length ? this.queryRenderedFeatures(e, {
                                layers: o
                            }) : [];
                        } else i = this.queryRenderedFeatures(e, {
                            target: t1
                        });
                        return i;
                    };
                    if ("mouseenter" === e || "mouseover" === e) {
                        let s = !1;
                        const r = (t1)=>{
                            const r = o(t1.point);
                            r.length ? s || (s = !0, i.call(this, new ln(e, this, t1.originalEvent, {
                                features: r
                            }))) : s = !1;
                        };
                        return {
                            listener: i,
                            targets: t1,
                            delegates: {
                                mousemove: r,
                                mouseout: ()=>{
                                    s = !1;
                                }
                            }
                        };
                    }
                    if ("mouseleave" === e || "mouseout" === e) {
                        let s = !1;
                        const r = (t1)=>{
                            o(t1.point).length ? s = !0 : s && (s = !1, i.call(this, new ln(e, this, t1.originalEvent)));
                        }, a = (t1)=>{
                            s && (s = !1, i.call(this, new ln(e, this, t1.originalEvent)));
                        };
                        return {
                            listener: i,
                            targets: t1,
                            delegates: {
                                mousemove: r,
                                mouseout: a
                            }
                        };
                    }
                    {
                        const s = (e)=>{
                            const t1 = o(e.point);
                            t1.length && (e.features = t1, i.call(this, e), delete e.features);
                        };
                        return {
                            listener: i,
                            targets: t1,
                            delegates: {
                                [e]: s
                            }
                        };
                    }
                }
                on(e, t1, i) {
                    if ("function" == typeof t1 || void 0 === i) return super.on(e, t1);
                    if ("string" == typeof t1 && (t1 = [
                        t1
                    ]), !this._areTargetsValid(t1)) return this;
                    const o = this._createDelegatedListener(e, t1, i);
                    this._delegatedListeners = this._delegatedListeners || {}, this._delegatedListeners[e] = this._delegatedListeners[e] || [], this._delegatedListeners[e].push(o);
                    for(const e in o.delegates)this.on(e, o.delegates[e]);
                    return this;
                }
                once(e, t1, i) {
                    if ("function" == typeof t1 || void 0 === i) return super.once(e, t1);
                    if ("string" == typeof t1 && (t1 = [
                        t1
                    ]), !this._areTargetsValid(t1)) return this;
                    const o = this._createDelegatedListener(e, t1, i);
                    for(const e in o.delegates)this.once(e, o.delegates[e]);
                    return this;
                }
                off(e, t1, i) {
                    if ("function" == typeof t1 || void 0 === i) return super.off(e, t1);
                    if ("string" == typeof t1 && (t1 = [
                        t1
                    ]), !this._areTargetsValid(t1)) return this;
                    const o = this._delegatedListeners ? this._delegatedListeners[e] : void 0;
                    return o && ((e)=>{
                        for(let o = 0; o < e.length; o++){
                            const s = e[o];
                            if (s.listener === i && sl(s.targets, t1)) {
                                for(const e in s.delegates)this.off(e, s.delegates[e]);
                                return e.splice(o, 1), this;
                            }
                        }
                    })(o), this;
                }
                queryRenderedFeatures(t1, i) {
                    if (!this.style) return [];
                    if (void 0 === t1 || t1 instanceof e.P || Array.isArray(t1) || void 0 !== i || (i = t1, t1 = void 0), t1 = t1 || [
                        [
                            0,
                            0
                        ],
                        [
                            this.transform.width,
                            this.transform.height
                        ]
                    ], !i) {
                        const e = this.style.queryRenderedFeatures(t1, void 0, this.transform), i = this.style.queryRenderedFeatureset(t1, void 0, this.transform);
                        return e.concat(i);
                    }
                    let o = !0;
                    if (i.target && (o = this._isTargetValid(i.target), o && !i.layers)) return this.style.queryRenderedFeatureset(t1, i, this.transform);
                    let s = !0;
                    if (i.layers && Array.isArray(i.layers)) {
                        for (const e of i.layers)if (!this._isValidId(e)) {
                            s = !1;
                            break;
                        }
                        if (s && !i.target) return this.style.queryRenderedFeatures(t1, i, this.transform);
                    }
                    let r = [];
                    return s && (r = r.concat(this.style.queryRenderedFeatures(t1, i, this.transform))), o && (r = r.concat(this.style.queryRenderedFeatureset(t1, i, this.transform))), r;
                }
                querySourceFeatures(e, t1) {
                    return !e || "string" == typeof e && !this._isValidId(e) ? [] : this.style.querySourceFeatures(e, t1);
                }
                isPointOnSurface(t1) {
                    const { name: i } = this.transform.projection;
                    return "globe" !== i && "mercator" !== i && e.w(`${i} projection does not support isPointOnSurface, this API may behave unexpectedly.`), this.transform.isPointOnSurface(e.P.convert(t1));
                }
                addInteraction(e, t1) {
                    return this._interactions.add(e, t1), this;
                }
                removeInteraction(e) {
                    return this._interactions.remove(e), this;
                }
                setStyle(t1, i) {
                    return i = e.l({}, {
                        localIdeographFontFamily: this._localIdeographFontFamily,
                        localFontFamily: this._localFontFamily
                    }, i), this.style && t1 && !1 !== i.diff && i.localFontFamily === this._localFontFamily && i.localIdeographFontFamily === this._localIdeographFontFamily && !i.config ? (this.style._diffStyle(t1, (o, s)=>{
                        o ? (e.w(`Unable to perform style diff: ${String(o.message || o.error || o)}. Rebuilding the style from scratch.`), this._updateStyle(t1, i)) : s && this._update(!0);
                    }, ()=>{
                        this._postStyleLoadEvent();
                    }), this) : (this._localIdeographFontFamily = i.localIdeographFontFamily, this._localFontFamily = i.localFontFamily, this._updateStyle(t1, i));
                }
                _getUIString(e) {
                    const t1 = this._locale[e];
                    if (null == t1) throw new Error(`Missing UI string '${e}'`);
                    return t1;
                }
                _updateStyle(t1, i) {
                    if (this.style && (this.style.setEventedParent(null), this.style._remove(), this.style = void 0), t1) {
                        const o = e.l({}, i);
                        i && i.config && (o.initialConfig = i.config, delete o.config), this.style = new To(this, o).load(t1), this.style.setEventedParent(this, {
                            style: this.style
                        });
                    }
                    return this._updateTerrain(), this;
                }
                _lazyInitEmptyStyle() {
                    this.style || (this.style = new To(this, {}), this.style.setEventedParent(this, {
                        style: this.style
                    }), this.style.loadEmpty());
                }
                getStyle() {
                    if (this.style) return this.style.serialize();
                }
                isStyleLoaded() {
                    return this.style ? this.style.loaded() : (e.w("There is no style added to the map."), !1);
                }
                _isValidId(t1) {
                    return null == t1 ? (this.fire(new e.y(new Error("IDs can't be empty."))), !1) : !e.cr(t1) || (this.fire(new e.y(new Error(`IDs can't contain special symbols: "${t1}".`))), !1);
                }
                _isTargetValid(e) {
                    return "featuresetId" in e ? this._isValidId("importId" in e ? e.importId : e.featuresetId) : "layerId" in e && this._isValidId(e.layerId);
                }
                _areTargetsValid(e) {
                    if (Array.isArray(e)) {
                        for (const t1 of e)if (!this._isValidId(t1)) return !1;
                        return !0;
                    }
                    return this._isTargetValid(e);
                }
                addSource(e, t1) {
                    return this._isValidId(e) ? (this._lazyInitEmptyStyle(), this.style.addSource(e, t1), this._update(!0)) : this;
                }
                isSourceLoaded(e) {
                    return !!this._isValidId(e) && !!this.style && this.style._isSourceCacheLoaded(e);
                }
                areTilesLoaded() {
                    return this.style.areTilesLoaded();
                }
                addSourceType(e, t1, i) {
                    this._lazyInitEmptyStyle(), this.style.addSourceType(e, t1, i);
                }
                removeSource(e) {
                    return this._isValidId(e) ? (this.style.removeSource(e), this._updateTerrain(), this._update(!0)) : this;
                }
                getSource(e) {
                    return this._isValidId(e) ? this.style.getOwnSource(e) : null;
                }
                addImage(t1, i, { pixelRatio: o = 1, sdf: s = !1, stretchX: r, stretchY: a, content: n } = {}) {
                    if (this._lazyInitEmptyStyle(), i instanceof HTMLImageElement || ImageBitmap && i instanceof ImageBitmap) {
                        const { width: l, height: c, data: h } = e.q.getImageData(i);
                        this.style.addImage(t1, {
                            data: new e.r({
                                width: l,
                                height: c
                            }, h),
                            pixelRatio: o,
                            stretchX: r,
                            stretchY: a,
                            content: n,
                            sdf: s,
                            version: 0,
                            usvg: !1
                        });
                    } else if (void 0 === i.width || void 0 === i.height) this.fire(new e.y(new Error("Invalid arguments to map.addImage(). The second argument must be an `HTMLImageElement`, `ImageData`, `ImageBitmap`, or object with `width`, `height`, and `data` properties with the same format as `ImageData`")));
                    else {
                        const { width: l, height: c } = i, h = i;
                        this.style.addImage(t1, {
                            data: new e.r({
                                width: l,
                                height: c
                            }, new Uint8Array(h.data)),
                            pixelRatio: o,
                            stretchX: r,
                            stretchY: a,
                            content: n,
                            sdf: s,
                            usvg: !1,
                            version: 0,
                            userImage: h
                        }), h.onAdd && h.onAdd(this, t1);
                    }
                }
                updateImage(t1, i) {
                    this._lazyInitEmptyStyle();
                    const o = this.style.getImage(t1);
                    if (!o) return void this.fire(new e.y(new Error("The map has no image with that id. If you are adding a new image use `map.addImage(...)` instead.")));
                    const s = i instanceof HTMLImageElement || ImageBitmap && i instanceof ImageBitmap ? e.q.getImageData(i) : i, { width: r, height: a, data: n } = s;
                    if (void 0 === r || void 0 === a) return void this.fire(new e.y(new Error("Invalid arguments to map.updateImage(). The second argument must be an `HTMLImageElement`, `ImageData`, `ImageBitmap`, or object with `width`, `height`, and `data` properties with the same format as `ImageData`")));
                    if (r !== (o.usvg ? o.icon.usvg_tree.width : o.data.width) || a !== (o.usvg ? o.icon.usvg_tree.height : o.data.height)) return void this.fire(new e.y(new Error(`The width and height of the updated image (${r}, ${a})\n                must be that same as the previous version of the image\n                (${o.data.width}, ${o.data.height})`)));
                    const l = !(i instanceof HTMLImageElement || ImageBitmap && i instanceof ImageBitmap);
                    let c = !1;
                    o.usvg ? (o.data = new e.r({
                        width: r,
                        height: a
                    }, new Uint8Array(n)), o.usvg = !1, o.icon = void 0, c = !0) : o.data.replace(n, l), this.style.updateImage(t1, o, c);
                }
                hasImage(t1) {
                    return t1 ? !!this.style && !!this.style.getImage(t1) : (this.fire(new e.y(new Error("Missing required image id"))), !1);
                }
                removeImage(e) {
                    this.style.removeImage(e);
                }
                loadImage(t1, i) {
                    e.o(this._requestManager.transformRequest(t1, e.R.Image), (t1, o)=>{
                        i(t1, o instanceof HTMLImageElement ? e.q.getImageData(o) : o);
                    });
                }
                listImages() {
                    return this.style.listImages();
                }
                addModel(e, t1) {
                    this._lazyInitEmptyStyle(), this.style.addModel(e, t1);
                }
                hasModel(t1) {
                    return t1 ? this.style.hasModel(t1) : (this.fire(new e.y(new Error("Missing required model id"))), !1);
                }
                removeModel(e) {
                    this.style.removeModel(e);
                }
                listModels() {
                    return this.style.listModels();
                }
                addLayer(e, t1) {
                    return this._isValidId(e.id) ? (this._lazyInitEmptyStyle(), this.style.addLayer(e, t1), this._update(!0)) : this;
                }
                getSlot(e) {
                    const t1 = this.getLayer(e);
                    return t1 && t1.slot || null;
                }
                setSlot(e, t1) {
                    return this.style.setSlot(e, t1), this.style.mergeLayers(), this._update(!0);
                }
                addImport(e, t1) {
                    return this.style.addImport(e, t1), this;
                }
                updateImport(e, t1) {
                    return "string" != typeof t1 && t1.id !== e ? (this.removeImport(e), this.addImport(t1)) : (this.style.updateImport(e, t1), this._update(!0));
                }
                removeImport(e) {
                    return this.style.removeImport(e), this;
                }
                moveImport(e, t1) {
                    return this.style.moveImport(e, t1), this._update(!0);
                }
                moveLayer(e, t1) {
                    return this._isValidId(e) ? (this.style.moveLayer(e, t1), this._update(!0)) : this;
                }
                removeLayer(e) {
                    return this._isValidId(e) ? (this.style.removeLayer(e), this._update(!0)) : this;
                }
                getLayer(e) {
                    if (!this._isValidId(e)) return null;
                    const t1 = this.style.getOwnLayer(e);
                    return t1 ? "custom" === t1.type ? t1.implementation : t1.serialize() : void 0;
                }
                getSlots() {
                    return this.style.getSlots();
                }
                setLayerZoomRange(e, t1, i) {
                    return this._isValidId(e) ? (this.style.setLayerZoomRange(e, t1, i), this._update(!0)) : this;
                }
                setFilter(e, t1, i = {}) {
                    return this._isValidId(e) ? (this.style.setFilter(e, t1, i), this._update(!0)) : this;
                }
                getFilter(e) {
                    return this._isValidId(e) ? this.style.getFilter(e) : null;
                }
                setPaintProperty(e, t1, i, o = {}) {
                    return this._isValidId(e) ? (this.style.setPaintProperty(e, t1, i, o), this._update(!0)) : this;
                }
                getPaintProperty(e, t1) {
                    return this._isValidId(e) ? this.style.getPaintProperty(e, t1) : null;
                }
                setLayoutProperty(e, t1, i, o = {}) {
                    return this._isValidId(e) ? (this.style.setLayoutProperty(e, t1, i, o), this._update(!0)) : this;
                }
                getLayoutProperty(e, t1) {
                    return this._isValidId(e) ? this.style.getLayoutProperty(e, t1) : null;
                }
                getSchema(e) {
                    return this.style.getSchema(e);
                }
                setSchema(e, t1) {
                    return this.style.setSchema(e, t1), this._update(!0);
                }
                getConfig(e) {
                    return this.style.getConfig(e);
                }
                setConfig(e, t1) {
                    return this.style.setConfig(e, t1), this._update(!0);
                }
                getConfigProperty(e, t1) {
                    return this.style.getConfigProperty(e, t1);
                }
                setConfigProperty(e, t1, i) {
                    return this.style.setConfigProperty(e, t1, i), this._update(!0);
                }
                getFeaturesetDescriptors(e) {
                    return this.style.getFeaturesetDescriptors(e);
                }
                setLights(e) {
                    if (this._lazyInitEmptyStyle(), e && 1 === e.length && "flat" === e[0].type) {
                        const t1 = e[0];
                        t1.properties ? this.style.setFlatLight(t1.properties, t1.id, {}) : this.style.setFlatLight({}, "flat");
                    } else this.style.setLights(e), this.painter.terrain && (this.painter.terrain.invalidateRenderCache = !0);
                    return this._update(!0);
                }
                getLights() {
                    const e = this.style.getLights() || [];
                    return 0 === e.length && e.push({
                        id: this.style.light.id,
                        type: "flat",
                        properties: this.style.getFlatLight()
                    }), e;
                }
                setLight(e, t1 = {}) {
                    return console.log("The `map.setLight` function is deprecated, prefer using `map.setLights` with `flat` light type instead."), this.setLights([
                        {
                            id: "flat",
                            type: "flat",
                            properties: e
                        }
                    ]);
                }
                getLight() {
                    return console.log("The `map.getLight` function is deprecated, prefer using `map.getLights` instead."), this.style.getFlatLight();
                }
                setTerrain(e) {
                    return this._lazyInitEmptyStyle(), !e && this.transform.projection.requiresDraping ? this.style.setTerrainForDraping() : this.style.setTerrain(e), this._averageElevationLastSampledAt = -1 / 0, this._update(!0);
                }
                getTerrain() {
                    return this.style ? this.style.getTerrain() : null;
                }
                setFog(e) {
                    return this._lazyInitEmptyStyle(), this.style.setFog(e), this._update(!0);
                }
                getFog() {
                    return this.style ? this.style.getFog() : null;
                }
                setSnow(e) {
                    return this._lazyInitEmptyStyle(), this.style.setSnow(e), this._update(!0);
                }
                getSnow() {
                    return this.style ? this.style.getSnow() : null;
                }
                setRain(e) {
                    return this._lazyInitEmptyStyle(), this.style.setRain(e), this._update(!0);
                }
                getRain() {
                    return this.style ? this.style.getRain() : null;
                }
                setColorTheme(e) {
                    return this._lazyInitEmptyStyle(), this.style.setColorTheme(e), this._update(!0);
                }
                setImportColorTheme(e, t1) {
                    return this._lazyInitEmptyStyle(), this.style.setImportColorTheme(e, t1), this._update(!0);
                }
                setCamera(e) {
                    return this.style.setCamera(e), this._triggerCameraUpdate(e);
                }
                _triggerCameraUpdate(e) {
                    return this._update(this.transform.setOrthographicProjectionAtLowPitch("orthographic" === e["camera-projection"]));
                }
                getCamera() {
                    return this.style.camera;
                }
                _queryFogOpacity(t1) {
                    return this.style && this.style.fog ? this.style.fog.getOpacityAtLatLng(e.bO.convert(t1), this.transform) : 0;
                }
                setFeatureState(e, t1) {
                    return e.source && !this._isValidId(e.source) ? this : (this.style.setFeatureState(e, t1), this._update());
                }
                removeFeatureState(e, t1) {
                    return e.source && !this._isValidId(e.source) ? this : (this.style.removeFeatureState(e, t1), this._update());
                }
                getFeatureState(e) {
                    return e.source && !this._isValidId(e.source) ? null : this.style.getFeatureState(e);
                }
                _updateContainerDimensions() {
                    if (!this._container) return;
                    const e = this._container.getBoundingClientRect().width || 400, t1 = this._container.getBoundingClientRect().height || 300;
                    let i, o, s, r = this._container;
                    for(; r && (!o || !s);){
                        const e = window.getComputedStyle(r).transform;
                        e && "none" !== e && (i = e.match(/matrix.*\((.+)\)/)[1].split(", "), i[0] && "0" !== i[0] && "1" !== i[0] && (o = i[0]), i[3] && "0" !== i[3] && "1" !== i[3] && (s = i[3])), r = r.parentElement;
                    }
                    this._containerWidth = o ? Math.abs(e / o) : e, this._containerHeight = s ? Math.abs(t1 / s) : t1;
                }
                _detectMissingCSS() {
                    "rgb(250, 128, 114)" !== window.getComputedStyle(this._missingCSSCanary).getPropertyValue("background-color") && e.w("This page appears to be missing CSS declarations for Mapbox GL JS, which may cause the map to display incorrectly. Please ensure your page includes mapbox-gl.css, as described in https://www.mapbox.com/mapbox-gl-js/api/.");
                }
                _setupContainer() {
                    const e = this._container;
                    e.classList.add("mapboxgl-map"), (this._missingCSSCanary = l("div", "mapboxgl-canary", e)).style.visibility = "hidden", this._detectMissingCSS();
                    const t1 = this._canvasContainer = l("div", "mapboxgl-canvas-container", e);
                    this._canvas = l("canvas", "mapboxgl-canvas", t1), this._interactive && (t1.classList.add("mapboxgl-interactive"), this._canvas.setAttribute("tabindex", "0")), this._canvas.addEventListener("webglcontextlost", this._contextLost, !1), this._canvas.addEventListener("webglcontextrestored", this._contextRestored, !1), this._canvas.setAttribute("aria-label", this._getUIString("Map.Title")), this._canvas.setAttribute("role", "region"), this._updateContainerDimensions(), this._resizeCanvas(this._containerWidth, this._containerHeight);
                    const i = this._controlContainer = l("div", "mapboxgl-control-container", e), o = this._controlPositions = {};
                    [
                        "top-left",
                        "top",
                        "top-right",
                        "right",
                        "bottom-right",
                        "bottom",
                        "bottom-left",
                        "left"
                    ].forEach((e)=>{
                        o[e] = l("div", `mapboxgl-ctrl-${e}`, i);
                    }), this._container.addEventListener("scroll", this._onMapScroll, !1);
                }
                _resizeCanvas(t1, i) {
                    const o = e.q.devicePixelRatio || 1;
                    this._canvas.width = o * Math.ceil(t1), this._canvas.height = o * Math.ceil(i), this._canvas.style.width = `${t1}px`, this._canvas.style.height = `${i}px`;
                }
                _addMarker(e) {
                    this._markers.push(e);
                }
                _removeMarker(e) {
                    const t1 = this._markers.indexOf(e);
                    -1 !== t1 && this._markers.splice(t1, 1);
                }
                _addPopup(e) {
                    this._popups.push(e);
                }
                _removePopup(e) {
                    const t1 = this._popups.indexOf(e);
                    -1 !== t1 && this._popups.splice(t1, 1);
                }
                _setupPainter() {
                    const t1 = e.l({}, n.supported.webGLContextAttributes, {
                        failIfMajorPerformanceCaveat: this._failIfMajorPerformanceCaveat,
                        preserveDrawingBuffer: this._preserveDrawingBuffer,
                        antialias: this._antialias || !1
                    }), i = this._canvas.getContext("webgl2", t1);
                    i ? (j(i, !0), this.painter = new Xa(i, this._contextCreateOptions, this.transform, this._scaleFactor, this._tp), this.on("data", (e)=>{
                        "source" === e.dataType && this.painter.setTileLoadedFlag(!0);
                    }), e.m.testSupport(i)) : this.fire(new e.y(new Error("Failed to initialize WebGL")));
                }
                _contextLost(t1) {
                    t1.preventDefault(), this._frame && (this._frame.cancel(), this._frame = null), this.fire(new e.z("webglcontextlost", {
                        originalEvent: t1
                    }));
                }
                _contextRestored(t1) {
                    this._setupPainter(), this.painter.resize(Math.ceil(this._containerWidth), Math.ceil(this._containerHeight)), this._updateTerrain(), this.style.reloadModels(), this.style.clearSources(), this._update(), this.fire(new e.z("webglcontextrestored", {
                        originalEvent: t1
                    }));
                }
                _onMapScroll(e) {
                    if (e.target === this._container) return this._container.scrollTop = 0, this._container.scrollLeft = 0, !1;
                }
                idle() {
                    return !this.isMoving() && this.loaded();
                }
                loaded() {
                    return !this._styleDirty && !this._sourcesDirty && !!this.style && this.style.loaded();
                }
                frameReady() {
                    return this.loaded() && !this._placementDirty;
                }
                _update(e) {
                    return this.style ? (this._styleDirty = this._styleDirty || e, this._sourcesDirty = !0, this.triggerRepaint(), this) : this;
                }
                _requestRenderFrame(e) {
                    return this._update(), this._renderTaskQueue.add(e);
                }
                _cancelRenderFrame(e) {
                    this._renderTaskQueue.remove(e);
                }
                _requestDomTask(e) {
                    !this.loaded() || this.loaded() && !this.isMoving() ? e() : this._domRenderTaskQueue.add(e);
                }
                _render(t1) {
                    let s;
                    this.fire(new e.z("renderstart")), ++this._frameId;
                    const r = this.painter.context.extTimerQuery, a = e.q.now(), n = this.painter.context.gl;
                    if (this.listens("gpu-timing-frame") && (s = n.createQuery(), n.beginQuery(r.TIME_ELAPSED_EXT, s)), this.painter.context.setDirty(), this.painter.setBaseState(), (this.isMoving() || this.isRotating() || this.isZooming()) && (this._interactionRange[0] = Math.min(this._interactionRange[0], performance.now()), this._interactionRange[1] = Math.max(this._interactionRange[1], performance.now())), this._renderTaskQueue.run(t1), this._domRenderTaskQueue.run(t1), this._removed) return;
                    this._updateProjectionTransition();
                    const l = this._isInitialLoad ? 0 : this._fadeDuration;
                    if (this.style && this._styleDirty) {
                        this._styleDirty = !1;
                        const t1 = this.transform.zoom, i = this.transform.pitch, o = e.q.now(), s = new e.a8(t1, {
                            now: o,
                            fadeDuration: l,
                            pitch: i,
                            transition: this.style.transition
                        });
                        this.style.update(s);
                    }
                    this.style && this.style.hasFogTransition() && (this.style._markersNeedUpdate = !0, this._sourcesDirty = !0);
                    let c = !1;
                    this.style && this._sourcesDirty ? (this._sourcesDirty = !1, this.painter._updateFog(this.style), this._updateTerrain(), c = this._updateAverageElevation(a), this.style.updateSources(this.transform), this._forceMarkerAndPopupUpdate()) : c = this._updateAverageElevation(a);
                    const h = this.style && this.style._updatePlacement(this.painter, this.painter.transform, this.showCollisionBoxes, l, this._crossSourceCollisions, this.painter.replacementSource, this._scaleFactorChanged);
                    if (this._scaleFactorChanged && (this._scaleFactorChanged = !1), h && (this._placementDirty = h.needsRerender), this.style && this.painter.render(this.style, {
                        showTileBoundaries: this.showTileBoundaries,
                        showParseStatus: this.showParseStatus,
                        wireframe: {
                            terrain: this.showTerrainWireframe,
                            layers2D: this.showLayers2DWireframe,
                            layers3D: this.showLayers3DWireframe
                        },
                        showOverdrawInspector: this._showOverdrawInspector,
                        showQueryGeometry: !!this._showQueryGeometry,
                        showTileAABBs: this.showTileAABBs,
                        rotating: this.isRotating(),
                        zooming: this.isZooming(),
                        moving: this.isMoving(),
                        fadeDuration: l,
                        isInitialLoad: this._isInitialLoad,
                        showPadding: this.showPadding,
                        gpuTiming: !!this.listens("gpu-timing-layer"),
                        gpuTimingDeferredRender: !!this.listens("gpu-timing-deferred-render"),
                        speedIndexTiming: this.speedIndexTiming
                    }), this.fire(new e.z("render")), this.loaded() && !this._loaded && (this._loaded = !0, o.mark(i.load), this.fire(new e.z("load"))), this.style && this.style.hasTransitions() && (this._styleDirty = !0), this.style && (this.style.snow || this.style.rain) && (this._styleDirty = !0), this.style && !this._placementDirty && this.style._releaseSymbolFadeTiles(), s) {
                        const t1 = e.q.now() - a;
                        n.endQuery(r.TIME_ELAPSED_EXT), setTimeout(()=>{
                            const i = n.getQueryParameter(s, n.QUERY_RESULT) / 1e6;
                            n.deleteQuery(s), this.fire(new e.z("gpu-timing-frame", {
                                cpuTime: t1,
                                gpuTime: i
                            }));
                        }, 50);
                    }
                    if (this.listens("gpu-timing-layer")) {
                        const t1 = this.painter.collectGpuTimers();
                        setTimeout(()=>{
                            const i = this.painter.queryGpuTimers(t1);
                            this.fire(new e.z("gpu-timing-layer", {
                                layerTimes: i
                            }));
                        }, 50);
                    }
                    if (this.listens("gpu-timing-deferred-render")) {
                        const t1 = this.painter.collectDeferredRenderGpuQueries();
                        setTimeout(()=>{
                            const i = this.painter.queryGpuTimeDeferredRender(t1);
                            this.fire(new e.z("gpu-timing-deferred-render", {
                                gpuTime: i
                            }));
                        }, 50);
                    }
                    const u = this._sourcesDirty || this._styleDirty || this._placementDirty || c;
                    if (u || this._repaint) this.triggerRepaint();
                    else {
                        const t1 = this.idle();
                        if (t1 && (c = this._updateAverageElevation(a, !0)), c) this.triggerRepaint();
                        else if (this._triggerFrame(!1), t1 && (this.fire(new e.z("idle")), this._isInitialLoad = !1, this.speedIndexTiming)) {
                            const t1 = this._calculateSpeedIndex();
                            this.fire(new e.z("speedindexcompleted", {
                                speedIndex: t1
                            })), this.speedIndexTiming = !1;
                        }
                    }
                    !this._loaded || this._fullyLoaded || u || (this._fullyLoaded = !0, o.mark(i.fullLoad), this._performanceMetricsCollection && k(this._requestManager._customAccessToken, {
                        width: this.painter.width,
                        height: this.painter.height,
                        interactionRange: this._interactionRange,
                        visibilityHidden: this._visibilityHidden,
                        terrainEnabled: !!this.painter.style.getTerrain(),
                        fogEnabled: !!this.painter.style.getFog(),
                        projection: this.getProjection().name,
                        zoom: this.transform.zoom,
                        renderer: this.painter.context.renderer,
                        vendor: this.painter.context.vendor
                    }), this._authenticate());
                }
                _forceMarkerAndPopupUpdate(e) {
                    for (const t1 of this._markers)e && !this.getRenderWorldCopies() && (t1._lngLat = t1._lngLat.wrap()), t1._update();
                    for (const t1 of this._popups)!e || this.getRenderWorldCopies() || t1._trackPointer || (t1._lngLat = t1._lngLat.wrap()), t1._update();
                }
                _updateAverageElevation(e, t1 = !1) {
                    const i = (e)=>(this.transform.averageElevation = e, this._update(!1), !0);
                    if (!this.painter.averageElevationNeedsEasing()) return 0 !== this.transform.averageElevation && i(0);
                    const o = this.transform.elevation && this.transform.elevation.exaggeration() !== this._averageElevationExaggeration;
                    if (o || (t1 || e - this._averageElevationLastSampledAt > 500) && !this._averageElevation.isEasing(e)) {
                        const t1 = this.transform.averageElevation;
                        let s = this.transform.sampleAverageElevation();
                        null != this.transform.elevation && (this._averageElevationExaggeration = this.transform.elevation.exaggeration()), isNaN(s) ? s = 0 : this._averageElevationLastSampledAt = e;
                        const r = Math.abs(t1 - s);
                        if (r > 1) {
                            if (this._isInitialLoad || o) return this._averageElevation.jumpTo(s), i(s);
                            this._averageElevation.easeTo(s, e, 300);
                        } else if (r > 1e-4) return this._averageElevation.jumpTo(s), i(s);
                    }
                    return !!this._averageElevation.isEasing(e) && i(this._averageElevation.getValue(e));
                }
                _authenticate() {
                    N(this._getMapId(), this._requestManager._skuToken, this._requestManager._customAccessToken, (t1)=>{
                        if (t1 && (t1.message === w || 401 === t1.status)) {
                            const t1 = this.painter.context.gl;
                            j(t1, !1), this._logoControl instanceof Jn && this._logoControl._updateLogo(), t1 && t1.clear(t1.DEPTH_BUFFER_BIT | t1.COLOR_BUFFER_BIT | t1.STENCIL_BUFFER_BIT), this._silenceAuthErrors || this.fire(new e.y(new Error("A valid Mapbox access token is required to use Mapbox GL JS. To create an account or a new access token, visit https://account.mapbox.com/")));
                        }
                    }), P(this._getMapId(), this._requestManager._skuToken, this._requestManager._customAccessToken, ()=>{});
                }
                _postStyleLoadEvent() {
                    this.style.globalId && O(this._requestManager._customAccessToken, {
                        map: this,
                        skuToken: this._requestManager._skuToken,
                        style: this.style.globalId,
                        importedStyles: this.style.getImportGlobalIds()
                    });
                }
                _updateTerrain() {
                    const e = this._isDragging();
                    this.painter.updateTerrain(this.style, e);
                }
                _calculateSpeedIndex() {
                    const e = this.painter.canvasCopy(), t1 = this.painter.getCanvasCopiesAndTimestamps();
                    t1.timeStamps.push(performance.now());
                    const i = this.painter.context.gl, o = i.createFramebuffer();
                    function s(e) {
                        i.framebufferTexture2D(i.FRAMEBUFFER, i.COLOR_ATTACHMENT0, i.TEXTURE_2D, e, 0);
                        const t1 = new Uint8Array(i.drawingBufferWidth * i.drawingBufferHeight * 4);
                        return i.readPixels(0, 0, i.drawingBufferWidth, i.drawingBufferHeight, i.RGBA, i.UNSIGNED_BYTE, t1), t1;
                    }
                    return i.bindFramebuffer(i.FRAMEBUFFER, o), this._canvasPixelComparison(s(e), t1.canvasCopies.map(s), t1.timeStamps);
                }
                _canvasPixelComparison(e, t1, i) {
                    let o = i[1] - i[0];
                    const s = e.length / 4;
                    for(let r = 0; r < t1.length; r++){
                        const a = t1[r];
                        let n = 0;
                        for(let t1 = 0; t1 < a.length; t1 += 4)a[t1] === e[t1] && a[t1 + 1] === e[t1 + 1] && a[t1 + 2] === e[t1 + 2] && a[t1 + 3] === e[t1 + 3] && (n += 1);
                        o += (i[r + 2] - i[r + 1]) * (1 - n / s);
                    }
                    return o;
                }
                remove() {
                    this._hash && this._hash.remove();
                    for (const e of this._controls)e.onRemove(this);
                    this._controls = [], this._frame && (this._frame.cancel(), this._frame = null), this._renderTaskQueue.clear(), this._domRenderTaskQueue.clear(), this.style && this.style.destroy(), this.indoor.destroy(), this.painter.destroy(), this.handlers && this.handlers.destroy(), this.handlers = void 0, this.setStyle(null), window.removeEventListener("resize", this._onWindowResize, !1), window.removeEventListener("orientationchange", this._onWindowResize, !1), window.removeEventListener(this._fullscreenchangeEvent, this._onWindowResize, !1), window.removeEventListener("online", this._onWindowOnline, !1), window.removeEventListener("visibilitychange", this._onVisibilityChange, !1);
                    const t1 = this.painter.context.gl.getExtension("WEBGL_lose_context");
                    t1 && t1.loseContext(), this._canvas.removeEventListener("webglcontextlost", this._contextLost, !1), this._canvas.removeEventListener("webglcontextrestored", this._contextRestored, !1), this._canvasContainer.remove(), this._controlContainer.remove(), this._missingCSSCanary.remove(), this._canvas = void 0, this._canvasContainer = void 0, this._controlContainer = void 0, this._missingCSSCanary = void 0, this._container.classList.remove("mapboxgl-map"), this._container.removeEventListener("scroll", this._onMapScroll, !1), U.delete(this.painter.context.gl), B.remove(), z.remove(), this._removed = !0, this.fire(new e.z("remove"));
                }
                triggerRepaint() {
                    this._triggerFrame(!0);
                }
                _triggerFrame(t1) {
                    this._renderNextFrame = this._renderNextFrame || t1, this.style && !this._frame && (this._frame = e.q.frame((e)=>{
                        const t1 = !!this._renderNextFrame;
                        this._frame = null, this._renderNextFrame = null, t1 && this._render(e);
                    }));
                }
                _preloadTiles(t1) {
                    const i = this.style ? this.style.getSourceCaches() : [];
                    return e.bl(i, (e, i)=>e._preloadTiles(t1, i), ()=>{
                        this.triggerRepaint();
                    }), this;
                }
                _onWindowOnline() {
                    this._update();
                }
                _onWindowResize(e) {
                    this._trackResize && this.resize({
                        originalEvent: e
                    })._update();
                }
                _onVisibilityChange() {
                    "hidden" === document.visibilityState && this._visibilityHidden++;
                }
                get showTileBoundaries() {
                    return !!this._showTileBoundaries;
                }
                set showTileBoundaries(e) {
                    this._showTileBoundaries !== e && (this._showTileBoundaries = e, this._tp.refreshUI(), this._update());
                }
                get showParseStatus() {
                    return !!this._showParseStatus;
                }
                set showParseStatus(e) {
                    this._showParseStatus !== e && (this._showParseStatus = e, this._tp.refreshUI(), this._update());
                }
                get showTerrainWireframe() {
                    return !!this._showTerrainWireframe;
                }
                set showTerrainWireframe(e) {
                    this._showTerrainWireframe !== e && (this._showTerrainWireframe = e, this._tp.refreshUI(), this._update());
                }
                get showLayers2DWireframe() {
                    return !!this._showLayers2DWireframe;
                }
                set showLayers2DWireframe(e) {
                    this._showLayers2DWireframe !== e && (this._showLayers2DWireframe = e, this._tp.refreshUI(), this._update());
                }
                get showLayers3DWireframe() {
                    return !!this._showLayers3DWireframe;
                }
                set showLayers3DWireframe(e) {
                    this._showLayers3DWireframe !== e && (this._showLayers3DWireframe = e, this._tp.refreshUI(), this._update());
                }
                get speedIndexTiming() {
                    return !!this._speedIndexTiming;
                }
                set speedIndexTiming(e) {
                    this._speedIndexTiming !== e && (this._speedIndexTiming = e, this._update());
                }
                get showPadding() {
                    return !!this._showPadding;
                }
                set showPadding(e) {
                    this._showPadding !== e && (this._showPadding = e, this._tp.refreshUI(), this._update());
                }
                get showCollisionBoxes() {
                    return !!this._showCollisionBoxes;
                }
                set showCollisionBoxes(e) {
                    this._showCollisionBoxes !== e && (this._showCollisionBoxes = e, this._tp.refreshUI(), e ? this.style._generateCollisionBoxes() : this._update());
                }
                get showOverdrawInspector() {
                    return !!this._showOverdrawInspector;
                }
                set showOverdrawInspector(e) {
                    this._showOverdrawInspector !== e && (this._showOverdrawInspector = e, this._tp.refreshUI(), this._update());
                }
                get repaint() {
                    return !!this._repaint;
                }
                set repaint(e) {
                    this._repaint !== e && (this._repaint = e, this._tp.refreshUI(), this.triggerRepaint());
                }
                get vertices() {
                    return !!this._vertices;
                }
                set vertices(e) {
                    this._vertices = e, this._update();
                }
                get showTileAABBs() {
                    return !!this._showTileAABBs;
                }
                set showTileAABBs(e) {
                    this._showTileAABBs !== e && (this._showTileAABBs = e, this._tp.refreshUI(), e && this._update());
                }
                _setCacheLimits(t1, i) {
                    e.dG(t1, i);
                }
                get version() {
                    return t1;
                }
                constructor(t1){
                    o.mark(i.create);
                    const s = t1;
                    if (null != (t1 = e.l({}, rl, t1)).minZoom && null != t1.maxZoom && t1.minZoom > t1.maxZoom) throw new Error("maxZoom must be greater than or equal to minZoom");
                    if (null != t1.minPitch && null != t1.maxPitch && t1.minPitch > t1.maxPitch) throw new Error("maxPitch must be greater than or equal to minPitch");
                    if (null != t1.minPitch && t1.minPitch < 0) throw new Error("minPitch must be greater than or equal to 0");
                    if (null != t1.maxPitch && t1.maxPitch > 85) throw new Error("maxPitch must be less than or equal to 85");
                    if (t1.antialias && e.dF(window) && (t1.antialias = !1, e.w("Antialiasing is disabled for this WebGL context to avoid browser bug: https://github.com/mapbox/mapbox-gl-js/issues/11609")), super(new Qi(t1.minZoom, t1.maxZoom, t1.minPitch, t1.maxPitch, t1.renderWorldCopies), t1), this._repaint = !!t1.repaint, this._interactive = t1.interactive, this._minTileCacheSize = t1.minTileCacheSize, this._maxTileCacheSize = t1.maxTileCacheSize, this._failIfMajorPerformanceCaveat = t1.failIfMajorPerformanceCaveat, this._preserveDrawingBuffer = t1.preserveDrawingBuffer, this._antialias = t1.antialias, this._trackResize = t1.trackResize, this._bearingSnap = t1.bearingSnap, this._refreshExpiredTiles = t1.refreshExpiredTiles, this._fadeDuration = t1.fadeDuration, this._isInitialLoad = !0, this._crossSourceCollisions = t1.crossSourceCollisions, this._collectResourceTiming = t1.collectResourceTiming, this._language = this._parseLanguage(t1.language), this._worldview = t1.worldview, this._renderTaskQueue = new Qn, this._domRenderTaskQueue = new Qn, this._controls = [], this._markers = [], this._popups = [], this._mapId = e.aV(), this._locale = e.l({}, tl, t1.locale), this._clickTolerance = t1.clickTolerance, this._cooperativeGestures = t1.cooperativeGestures, this._performanceMetricsCollection = t1.performanceMetricsCollection, this._tessellationStep = t1.tessellationStep, this._containerWidth = 0, this._containerHeight = 0, this._showParseStatus = !0, this._precompilePrograms = t1.precompilePrograms, this._scaleFactorChanged = !1, this._averageElevationLastSampledAt = -1 / 0, this._averageElevationExaggeration = 0, this._averageElevation = new el(0), this._interactionRange = [
                        1 / 0,
                        -1 / 0
                    ], this._visibilityHidden = 0, this._useExplicitProjection = !1, this._frameId = 0, this._scaleFactor = t1.scaleFactor, this._requestManager = new T(t1.transformRequest, t1.accessToken, t1.testMode), this._silenceAuthErrors = !!t1.testMode, this._contextCreateOptions = t1.contextCreateOptions ? Object.assign({}, t1.contextCreateOptions) : {}, "string" == typeof t1.container) {
                        const e = document.getElementById(t1.container);
                        if (!e) throw new Error(`Container '${t1.container.toString()}' not found.`);
                        this._container = e;
                    } else {
                        if (!(t1.container instanceof HTMLElement)) throw new Error("Invalid type: 'container' must be a String or HTMLElement.");
                        this._container = t1.container;
                    }
                    if (this._container.childNodes.length > 0 && e.w("The map container element should be empty, otherwise the map's interactivity will be negatively impacted. If you want to display a message when WebGL is not supported, use the Mapbox GL Supported plugin instead."), t1.maxBounds && this.setMaxBounds(t1.maxBounds), this._spriteFormat = t1.spriteFormat, e.aP([
                        "_onWindowOnline",
                        "_onWindowResize",
                        "_onVisibilityChange",
                        "_onMapScroll",
                        "_contextLost",
                        "_contextRestored"
                    ], this), this._setupContainer(), this._tp || (this._tp = new Oa), this._tp.registerParameter(this, [
                        "Debug"
                    ], "showOverdrawInspector"), this._tp.registerParameter(this, [
                        "Debug"
                    ], "showTileBoundaries"), this._tp.registerParameter(this, [
                        "Debug"
                    ], "showParseStatus"), this._tp.registerParameter(this, [
                        "Debug"
                    ], "repaint"), this._tp.registerParameter(this, [
                        "Debug"
                    ], "showTileAABBs"), this._tp.registerParameter(this, [
                        "Debug"
                    ], "showPadding"), this._tp.registerParameter(this, [
                        "Debug"
                    ], "showCollisionBoxes", {
                        noSave: !0
                    }), this._tp.registerParameter(this.transform, [
                        "Debug"
                    ], "freezeTileCoverage", {
                        noSave: !0
                    }, ()=>{
                        this._update();
                    }), this._tp.registerParameter(this, [
                        "Debug",
                        "Wireframe"
                    ], "showTerrainWireframe"), this._tp.registerParameter(this, [
                        "Debug",
                        "Wireframe"
                    ], "showLayers2DWireframe"), this._tp.registerParameter(this, [
                        "Debug",
                        "Wireframe"
                    ], "showLayers3DWireframe"), this._tp.registerParameter(this, [
                        "Scaling"
                    ], "_scaleFactor", {
                        min: .1,
                        max: 10,
                        step: .1
                    }, ()=>{
                        this.setScaleFactor(this._scaleFactor);
                    }), this._setupPainter(), void 0 === this.painter) throw new Error("Failed to initialize WebGL.");
                    if (this.on("move", ()=>this._update(!1)), this.on("moveend", ()=>this._update(!1)), this.on("zoom", ()=>this._update(!0)), this._fullscreenchangeEvent = "onfullscreenchange" in document ? "fullscreenchange" : "webkitfullscreenchange", window.addEventListener("online", this._onWindowOnline, !1), window.addEventListener("resize", this._onWindowResize, !1), window.addEventListener("orientationchange", this._onWindowResize, !1), window.addEventListener(this._fullscreenchangeEvent, this._onWindowResize, !1), window.addEventListener("visibilitychange", this._onVisibilityChange, !1), this.handlers = new $n(this, t1), this._localFontFamily = t1.localFontFamily, this._localIdeographFontFamily = t1.localIdeographFontFamily, (t1.style || !t1.testMode) && this.setStyle(t1.style || e.e.DEFAULT_STYLE, {
                        config: t1.config,
                        localFontFamily: this._localFontFamily,
                        localIdeographFontFamily: this._localIdeographFontFamily
                    }), t1.projection && this.setProjection(t1.projection), this.indoor = new po(this), t1.hash && (this._hash = new Ya("string" == typeof t1.hash && t1.hash || void 0).addTo(this)), !this._hash || !this._hash._onHashChange()) {
                        null == s.center && null == s.zoom || (this.transform._unmodified = !1), this.jumpTo({
                            center: t1.center,
                            zoom: t1.zoom,
                            bearing: t1.bearing,
                            pitch: t1.pitch
                        });
                        const i = t1.bounds;
                        i && (this.resize(), this.fitBounds(i, e.l({}, t1.fitBoundsOptions, {
                            duration: 0
                        })));
                    }
                    this.resize(), t1.attributionControl && this.addControl(new Yn({
                        customAttribution: t1.customAttribution
                    })), this._logoControl = new Jn, this.addControl(this._logoControl, t1.logoPosition), this.on("style.load", ()=>{
                        this.transform.unmodified && this.jumpTo(this.style.stylesheet), this._postStyleLoadEvent();
                    }), this.on("data", (t1)=>{
                        this._update("style" === t1.dataType), this.fire(new e.z(`${t1.dataType}data`, t1));
                    }), this.on("dataloading", (t1)=>{
                        this.fire(new e.z(`${t1.dataType}dataloading`, t1));
                    }), this._interactions = new ol(this);
                }
            },
            NavigationControl: class {
                _updateZoomButtons() {
                    const e = this._map;
                    if (!e) return;
                    const t1 = e.getZoom(), i = t1 === e.getMaxZoom(), o = t1 === e.getMinZoom();
                    this._zoomInButton.disabled = i, this._zoomOutButton.disabled = o, this._zoomInButton.setAttribute("aria-disabled", i.toString()), this._zoomOutButton.setAttribute("aria-disabled", o.toString());
                }
                _rotateCompassArrow() {
                    const e = this._map;
                    if (!e) return;
                    const t1 = this.options.visualizePitch ? `scale(${1 / Math.pow(Math.cos(e.transform.pitch * (Math.PI / 180)), .5)}) rotateX(${e.transform.pitch}deg) rotateZ(${e.transform.angle * (180 / Math.PI)}deg)` : `rotate(${e.transform.angle * (180 / Math.PI)}deg)`;
                    e._requestDomTask(()=>{
                        this._compassIcon && (this._compassIcon.style.transform = t1);
                    });
                }
                onAdd(e) {
                    return this._map = e, this.options.showZoom && (this._setButtonTitle(this._zoomInButton, "ZoomIn"), this._setButtonTitle(this._zoomOutButton, "ZoomOut"), e.on("zoom", this._updateZoomButtons), this._updateZoomButtons()), this.options.showCompass && (this._setButtonTitle(this._compass, "ResetBearing"), this.options.visualizePitch && e.on("pitch", this._rotateCompassArrow), e.on("rotate", this._rotateCompassArrow), this._rotateCompassArrow(), this._handler = new nl(e, this._compass, this.options.visualizePitch)), this._container;
                }
                onRemove() {
                    const e = this._map;
                    e && (this._container.remove(), this.options.showZoom && e.off("zoom", this._updateZoomButtons), this.options.showCompass && (this.options.visualizePitch && e.off("pitch", this._rotateCompassArrow), e.off("rotate", this._rotateCompassArrow), this._handler && this._handler.off(), this._handler = void 0), this._map = void 0);
                }
                _createButton(e, t1) {
                    const i = l("button", e, this._container);
                    return i.type = "button", i.addEventListener("click", t1), i;
                }
                _setButtonTitle(e, t1) {
                    if (!this._map) return;
                    const i = this._map._getUIString(`NavigationControl.${t1}`);
                    e.setAttribute("aria-label", i), e.firstElementChild && e.firstElementChild.setAttribute("title", i);
                }
                constructor(t1 = {}){
                    this.options = e.l({}, al, t1), this._container = l("div", "mapboxgl-ctrl mapboxgl-ctrl-group"), this._container.addEventListener("contextmenu", (e)=>e.preventDefault()), this.options.showZoom && (e.aP([
                        "_setButtonTitle",
                        "_updateZoomButtons"
                    ], this), this._zoomInButton = this._createButton("mapboxgl-ctrl-zoom-in", (e)=>{
                        this._map && this._map.zoomIn({}, {
                            originalEvent: e
                        });
                    }), l("span", "mapboxgl-ctrl-icon", this._zoomInButton).setAttribute("aria-hidden", "true"), this._zoomOutButton = this._createButton("mapboxgl-ctrl-zoom-out", (e)=>{
                        this._map && this._map.zoomOut({}, {
                            originalEvent: e
                        });
                    }), l("span", "mapboxgl-ctrl-icon", this._zoomOutButton).setAttribute("aria-hidden", "true")), this.options.showCompass && (e.aP([
                        "_rotateCompassArrow"
                    ], this), this._compass = this._createButton("mapboxgl-ctrl-compass", (e)=>{
                        const t1 = this._map;
                        t1 && (this.options.visualizePitch ? t1.resetNorthPitch({}, {
                            originalEvent: e
                        }) : t1.resetNorth({}, {
                            originalEvent: e
                        }));
                    }), this._compassIcon = l("span", "mapboxgl-ctrl-icon", this._compass), this._compassIcon.setAttribute("aria-hidden", "true"));
                }
            },
            GeolocateControl: class extends e.E {
                onAdd(e) {
                    return this._map = e, this._container = l("div", "mapboxgl-ctrl mapboxgl-ctrl-group"), this._checkGeolocationSupport(this._setupUI), this._container;
                }
                onRemove() {
                    void 0 !== this._geolocationWatchID && (this.options.geolocation.clearWatch(this._geolocationWatchID), this._geolocationWatchID = void 0), this.options.showUserLocation && this._userLocationDotMarker && this._userLocationDotMarker.remove(), this.options.showAccuracyCircle && this._accuracyCircleMarker && this._accuracyCircleMarker.remove(), this._container.remove(), this._map.off("zoom", this._onZoom), this._map = void 0, this._numberOfWatches = 0, this._noTimeout = !1;
                }
                _checkGeolocationSupport(e) {
                    const t1 = (t1 = !!this.options.geolocation)=>{
                        this._supportsGeolocation = t1, e(t1);
                    };
                    void 0 !== this._supportsGeolocation ? e(this._supportsGeolocation) : void 0 !== navigator.permissions ? navigator.permissions.query({
                        name: "geolocation"
                    }).then((e)=>t1("denied" !== e.state)).catch(()=>t1()) : t1();
                }
                _isOutOfMapMaxBounds(e) {
                    const t1 = this._map.getMaxBounds(), i = e.coords;
                    return !!t1 && (i.longitude < t1.getWest() || i.longitude > t1.getEast() || i.latitude < t1.getSouth() || i.latitude > t1.getNorth());
                }
                _setErrorState() {
                    switch(this._watchState){
                        case "WAITING_ACTIVE":
                            this._watchState = "ACTIVE_ERROR", this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-active"), this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-active-error");
                            break;
                        case "ACTIVE_LOCK":
                            this._watchState = "ACTIVE_ERROR", this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-active"), this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-active-error"), this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-waiting");
                            break;
                        case "BACKGROUND":
                            this._watchState = "BACKGROUND_ERROR", this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-background"), this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-background-error"), this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-waiting");
                    }
                }
                _onSuccess(t1) {
                    if (this._map) {
                        if (this._isOutOfMapMaxBounds(t1)) return this._setErrorState(), this.fire(new e.z("outofmaxbounds", t1)), this._updateMarker(), void this._finish();
                        if (this.options.trackUserLocation) switch(this._lastKnownPosition = t1, this._watchState){
                            case "WAITING_ACTIVE":
                            case "ACTIVE_LOCK":
                            case "ACTIVE_ERROR":
                                this._watchState = "ACTIVE_LOCK", this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-waiting"), this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-active-error"), this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-active");
                                break;
                            case "BACKGROUND":
                            case "BACKGROUND_ERROR":
                                this._watchState = "BACKGROUND", this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-waiting"), this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-background-error"), this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-background");
                        }
                        this.options.showUserLocation && "OFF" !== this._watchState && this._updateMarker(t1), this.options.trackUserLocation && "ACTIVE_LOCK" !== this._watchState || this._updateCamera(t1), this.options.showUserLocation && this._userLocationDotMarker.removeClassName("mapboxgl-user-location-dot-stale"), this.fire(new e.z("geolocate", t1)), this._finish();
                    }
                }
                _updateCamera(t1) {
                    const i = new e.bO(t1.coords.longitude, t1.coords.latitude), o = t1.coords.accuracy, s = this._map.getBearing(), r = e.l({
                        bearing: s
                    }, this.options.fitBoundsOptions);
                    this._map.fitBounds(i.toBounds(o), r, {
                        geolocateSource: !0
                    });
                }
                _updateMarker(t1) {
                    if (t1) {
                        const i = new e.bO(t1.coords.longitude, t1.coords.latitude);
                        this._accuracyCircleMarker.setLngLat(i).addTo(this._map), this._userLocationDotMarker.setLngLat(i).addTo(this._map), this._accuracy = t1.coords.accuracy, this.options.showUserLocation && this.options.showAccuracyCircle && this._updateCircleRadius();
                    } else this._userLocationDotMarker.remove(), this._accuracyCircleMarker.remove();
                }
                _updateCircleRadius() {
                    const t1 = this._map.transform, i = e.bH(1, t1._center.lat) * t1.worldSize, o = Math.ceil(2 * this._accuracy * i);
                    this._circleElement.style.width = `${o}px`, this._circleElement.style.height = `${o}px`;
                }
                _onZoom() {
                    this.options.showUserLocation && this.options.showAccuracyCircle && this._updateCircleRadius();
                }
                _updateMarkerRotation() {
                    this._userLocationDotMarker && "number" == typeof this._heading ? (this._userLocationDotMarker.setRotation(this._heading), this._userLocationDotMarker.addClassName("mapboxgl-user-location-show-heading")) : (this._userLocationDotMarker.removeClassName("mapboxgl-user-location-show-heading"), this._userLocationDotMarker.setRotation(0));
                }
                _onError(t1) {
                    if (this._map) {
                        if (this.options.trackUserLocation) {
                            if (1 === t1.code) {
                                this._watchState = "OFF", this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-waiting"), this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-active"), this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-active-error"), this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-background"), this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-background-error"), this._geolocateButton.disabled = !0;
                                const e = this._map._getUIString("GeolocateControl.LocationNotAvailable");
                                this._geolocateButton.setAttribute("aria-label", e), this._geolocateButton.firstElementChild && this._geolocateButton.firstElementChild.setAttribute("title", e), void 0 !== this._geolocationWatchID && this._clearWatch();
                            } else {
                                if (3 === t1.code && this._noTimeout) return;
                                this._setErrorState();
                            }
                        }
                        "OFF" !== this._watchState && this.options.showUserLocation && this._userLocationDotMarker.addClassName("mapboxgl-user-location-dot-stale"), this.fire(new e.z("error", t1)), this._finish();
                    }
                }
                _finish() {
                    this._timeoutId && clearTimeout(this._timeoutId), this._timeoutId = void 0;
                }
                _setupUI(t1) {
                    if (void 0 !== this._map) {
                        if (this._container.addEventListener("contextmenu", (e)=>e.preventDefault()), this._geolocateButton = l("button", "mapboxgl-ctrl-geolocate", this._container), l("span", "mapboxgl-ctrl-icon", this._geolocateButton).setAttribute("aria-hidden", "true"), this._geolocateButton.type = "button", !1 === t1) {
                            e.w("Geolocation support is not available so the GeolocateControl will be disabled.");
                            const t1 = this._map._getUIString("GeolocateControl.LocationNotAvailable");
                            this._geolocateButton.disabled = !0, this._geolocateButton.setAttribute("aria-label", t1), this._geolocateButton.firstElementChild && this._geolocateButton.firstElementChild.setAttribute("title", t1);
                        } else {
                            const e = this._map._getUIString("GeolocateControl.FindMyLocation");
                            this._geolocateButton.setAttribute("aria-label", e), this._geolocateButton.firstElementChild && this._geolocateButton.firstElementChild.setAttribute("title", e);
                        }
                        this.options.trackUserLocation && (this._geolocateButton.setAttribute("aria-pressed", "false"), this._watchState = "OFF"), this.options.showUserLocation && (this._dotElement = l("div", "mapboxgl-user-location"), this._dotElement.appendChild(l("div", "mapboxgl-user-location-dot")), this._dotElement.appendChild(l("div", "mapboxgl-user-location-heading")), this._userLocationDotMarker = new hl({
                            element: this._dotElement,
                            rotationAlignment: "map",
                            pitchAlignment: "map"
                        }), this._circleElement = l("div", "mapboxgl-user-location-accuracy-circle"), this._accuracyCircleMarker = new hl({
                            element: this._circleElement,
                            pitchAlignment: "map"
                        }), this.options.trackUserLocation && (this._watchState = "OFF"), this._map.on("zoom", this._onZoom)), this._geolocateButton.addEventListener("click", this.trigger.bind(this)), this._setup = !0, this.options.trackUserLocation && this._map.on("movestart", (t1)=>{
                            t1.geolocateSource || "ACTIVE_LOCK" !== this._watchState || t1.originalEvent && "resize" === t1.originalEvent.type || (this._watchState = "BACKGROUND", this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-background"), this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-active"), this.fire(new e.z("trackuserlocationend")));
                        });
                    }
                }
                _onDeviceOrientation(e) {
                    this._userLocationDotMarker && (e.webkitCompassHeading ? this._heading = e.webkitCompassHeading : !0 === e.absolute && (this._heading = -1 * e.alpha), this._updateMarkerRotationThrottled());
                }
                trigger() {
                    if (!this._setup) return e.w("Geolocate control triggered before added to a map"), !1;
                    if (this.options.trackUserLocation) {
                        switch(this._watchState){
                            case "OFF":
                                this._watchState = "WAITING_ACTIVE", this.fire(new e.z("trackuserlocationstart"));
                                break;
                            case "WAITING_ACTIVE":
                            case "ACTIVE_LOCK":
                            case "ACTIVE_ERROR":
                            case "BACKGROUND_ERROR":
                                this._numberOfWatches--, this._noTimeout = !1, this._watchState = "OFF", this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-waiting"), this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-active"), this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-active-error"), this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-background"), this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-background-error"), this.fire(new e.z("trackuserlocationend"));
                                break;
                            case "BACKGROUND":
                                this._watchState = "ACTIVE_LOCK", this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-background"), this._lastKnownPosition && this._updateCamera(this._lastKnownPosition), this.fire(new e.z("trackuserlocationstart"));
                        }
                        switch(this._watchState){
                            case "WAITING_ACTIVE":
                                this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-waiting"), this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-active");
                                break;
                            case "ACTIVE_LOCK":
                                this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-active");
                                break;
                            case "ACTIVE_ERROR":
                                this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-waiting"), this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-active-error");
                                break;
                            case "BACKGROUND":
                                this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-background");
                                break;
                            case "BACKGROUND_ERROR":
                                this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-waiting"), this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-background-error");
                        }
                        if ("OFF" === this._watchState && void 0 !== this._geolocationWatchID) this._clearWatch();
                        else if (void 0 === this._geolocationWatchID) {
                            let e;
                            this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-waiting"), this._geolocateButton.setAttribute("aria-pressed", "true"), this._numberOfWatches++, this._numberOfWatches > 1 ? (e = {
                                maximumAge: 6e5,
                                timeout: 0
                            }, this._noTimeout = !0) : (e = this.options.positionOptions, this._noTimeout = !1), this._geolocationWatchID = this.options.geolocation.watchPosition(this._onSuccess, this._onError, e), this.options.showUserHeading && this._addDeviceOrientationListener();
                        }
                    } else this.options.geolocation.getCurrentPosition(this._onSuccess, this._onError, this.options.positionOptions), this._timeoutId = window.setTimeout(this._finish, 1e4);
                    return !0;
                }
                _addDeviceOrientationListener() {
                    const e = ()=>{
                        "ondeviceorientationabsolute" in window ? window.addEventListener("deviceorientationabsolute", this._onDeviceOrientation) : window.addEventListener("deviceorientation", this._onDeviceOrientation);
                    };
                    "undefined" != typeof DeviceMotionEvent && "function" == typeof DeviceMotionEvent.requestPermission ? DeviceOrientationEvent.requestPermission().then((t1)=>{
                        "granted" === t1 && e();
                    }).catch(console.error) : e();
                }
                _clearWatch() {
                    this.options.geolocation.clearWatch(this._geolocationWatchID), window.removeEventListener("deviceorientation", this._onDeviceOrientation), window.removeEventListener("deviceorientationabsolute", this._onDeviceOrientation), this._geolocationWatchID = void 0, this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-waiting"), this._geolocateButton.setAttribute("aria-pressed", "false"), this.options.showUserLocation && this._updateMarker(null);
                }
                constructor(t1 = {}){
                    super();
                    const i = navigator.geolocation;
                    this.options = e.l({
                        geolocation: i
                    }, ul, t1), e.aP([
                        "_onSuccess",
                        "_onError",
                        "_onZoom",
                        "_finish",
                        "_setupUI",
                        "_updateCamera",
                        "_updateMarker",
                        "_updateMarkerRotation",
                        "_onDeviceOrientation"
                    ], this), this._updateMarkerRotationThrottled = Ka(this._updateMarkerRotation, 20), this._numberOfWatches = 0;
                }
            },
            AttributionControl: Yn,
            ScaleControl: class {
                getDefaultPosition() {
                    return "bottom-left";
                }
                _update() {
                    const e = this.options.maxWidth || 100, t1 = this._map, i = t1._containerHeight / 2, o = t1._containerWidth / 2 - e / 2, s = t1.unproject([
                        o,
                        i
                    ]), r = t1.unproject([
                        o + e,
                        i
                    ]), a = s.distanceTo(r);
                    if ("imperial" === this.options.unit) {
                        const t1 = 3.2808 * a;
                        t1 > 5280 ? this._setScale(e, t1 / 5280, "mile") : this._setScale(e, t1, "foot");
                    } else "nautical" === this.options.unit ? this._setScale(e, a / 1852, "nautical-mile") : a >= 1e3 ? this._setScale(e, a / 1e3, "kilometer") : this._setScale(e, a, "meter");
                }
                _setScale(e, t1, i) {
                    this._map._requestDomTask(()=>{
                        const o = function(e) {
                            const t1 = Math.pow(10, `${Math.floor(e)}`.length - 1);
                            let i = e / t1;
                            return i = i >= 10 ? 10 : i >= 5 ? 5 : i >= 3 ? 3 : i >= 2 ? 2 : i >= 1 ? 1 : function(e) {
                                const t1 = Math.pow(10, Math.ceil(-Math.log(e) / Math.LN10));
                                return Math.round(e * t1) / t1;
                            }(i), t1 * i;
                        }(t1), s = o / t1;
                        this._container.innerHTML = this._isNumberFormatSupported && "nautical-mile" !== i ? new Intl.NumberFormat(this._language, {
                            style: "unit",
                            unitDisplay: "short",
                            unit: i
                        }).format(o) : `${o}&nbsp;${_l[i]}`, this._container.style.width = e * s + "px";
                    });
                }
                onAdd(e) {
                    return this._map = e, this._language = e.getLanguage(), this._container = l("div", "mapboxgl-ctrl mapboxgl-ctrl-scale", e.getContainer()), this._container.dir = "auto", this._map.on("move", this._update), this._update(), this._container;
                }
                onRemove() {
                    this._container.remove(), this._map.off("move", this._update), this._map = void 0;
                }
                _setLanguage(e) {
                    this._language = e, this._update();
                }
                setUnit(e) {
                    this.options.unit = e, this._update();
                }
                constructor(t1 = {}){
                    this.options = e.l({}, dl, t1), this._isNumberFormatSupported = function() {
                        try {
                            return new Intl.NumberFormat("en", {
                                style: "unit",
                                unitDisplay: "short",
                                unit: "meter"
                            }), !0;
                        } catch (e) {
                            return !1;
                        }
                    }(), e.aP([
                        "_update",
                        "_setScale",
                        "setUnit"
                    ], this);
                }
            },
            FullscreenControl: class {
                onAdd(t1) {
                    return this._map = t1, this._container || (this._container = this._map.getContainer()), this._controlContainer = l("div", "mapboxgl-ctrl mapboxgl-ctrl-group"), this._checkFullscreenSupport() ? this._setupUI() : (this._controlContainer.style.display = "none", e.w("This device does not support fullscreen mode.")), this._controlContainer;
                }
                onRemove() {
                    this._controlContainer.remove(), this._map = null, document.removeEventListener(this._fullscreenchange, this._changeIcon);
                }
                _checkFullscreenSupport() {
                    return !(!document.fullscreenEnabled && !document.webkitFullscreenEnabled);
                }
                _setupUI() {
                    const e = this._fullscreenButton = l("button", "mapboxgl-ctrl-fullscreen", this._controlContainer);
                    l("span", "mapboxgl-ctrl-icon", e).setAttribute("aria-hidden", "true"), e.type = "button", this._updateTitle(), this._fullscreenButton.addEventListener("click", this._onClickFullscreen), document.addEventListener(this._fullscreenchange, this._changeIcon);
                }
                _updateTitle() {
                    const e = this._getTitle();
                    this._fullscreenButton.setAttribute("aria-label", e), this._fullscreenButton.firstElementChild && this._fullscreenButton.firstElementChild.setAttribute("title", e);
                }
                _getTitle() {
                    return this._map._getUIString(this._isFullscreen() ? "FullscreenControl.Exit" : "FullscreenControl.Enter");
                }
                _isFullscreen() {
                    return this._fullscreen;
                }
                _changeIcon() {
                    (document.fullscreenElement || document.webkitFullscreenElement) === this._container !== this._fullscreen && (this._fullscreen = !this._fullscreen, this._fullscreenButton.classList.toggle("mapboxgl-ctrl-shrink"), this._fullscreenButton.classList.toggle("mapboxgl-ctrl-fullscreen"), this._updateTitle());
                }
                _onClickFullscreen() {
                    this._isFullscreen() ? document.exitFullscreen ? document.exitFullscreen() : document.webkitCancelFullScreen && document.webkitCancelFullScreen() : this._container.requestFullscreen ? this._container.requestFullscreen() : this._container.webkitRequestFullscreen && this._container.webkitRequestFullscreen();
                }
                constructor(t1 = {}){
                    this._fullscreen = !1, t1 && t1.container && (t1.container instanceof HTMLElement ? this._container = t1.container : e.w("Full screen control 'container' must be a DOM element.")), e.aP([
                        "_onClickFullscreen",
                        "_changeIcon"
                    ], this), "onfullscreenchange" in document ? this._fullscreenchange = "fullscreenchange" : "onwebkitfullscreenchange" in document && (this._fullscreenchange = "webkitfullscreenchange");
                }
            },
            Popup: class extends e.E {
                addTo(t1) {
                    return this._map && this.remove(), this._map = t1, this.options.closeOnClick && t1.on("preclick", this._onClose), this.options.closeOnMove && t1.on("move", this._onClose), t1.on("remove", this.remove), this._update(), t1._addPopup(this), this._focusFirstElement(), this._trackPointer ? (t1.on("mousemove", this._onMouseEvent), t1.on("mouseup", this._onMouseEvent), t1._canvasContainer.classList.add("mapboxgl-track-pointer")) : t1.on("move", this._update), this.fire(new e.z("open")), this;
                }
                isOpen() {
                    return !!this._map;
                }
                remove() {
                    this._content && this._content.remove(), this._container && (this._container.remove(), this._container = void 0);
                    const t1 = this._map;
                    return t1 && (t1.off("move", this._update), t1.off("move", this._onClose), t1.off("preclick", this._onClose), t1.off("click", this._onClose), t1.off("remove", this.remove), t1.off("mousemove", this._onMouseEvent), t1.off("mouseup", this._onMouseEvent), t1.off("drag", this._onMouseEvent), t1._canvasContainer && t1._canvasContainer.classList.remove("mapboxgl-track-pointer"), t1._removePopup(this), this._map = void 0), this.fire(new e.z("close")), this;
                }
                getLngLat() {
                    return this._lngLat;
                }
                setLngLat(t1) {
                    this._lngLat = e.bO.convert(t1), this._pos = null, this._trackPointer = !1, this._update();
                    const i = this._map;
                    return i && (i.on("move", this._update), i.off("mousemove", this._onMouseEvent), i._canvasContainer.classList.remove("mapboxgl-track-pointer")), this;
                }
                trackPointer() {
                    this._trackPointer = !0, this._pos = null, this._update();
                    const e = this._map;
                    return e && (e.off("move", this._update), e.on("mousemove", this._onMouseEvent), e.on("drag", this._onMouseEvent), e._canvasContainer.classList.add("mapboxgl-track-pointer")), this;
                }
                getElement() {
                    return this._container;
                }
                setText(e) {
                    return this.setDOMContent(document.createTextNode(e));
                }
                setHTML(e) {
                    const t1 = document.createDocumentFragment(), i = document.createElement("body");
                    let o;
                    for(i.innerHTML = e; o = i.firstChild, o;)t1.appendChild(o);
                    return this.setDOMContent(t1);
                }
                getMaxWidth() {
                    return this._container && this._container.style.maxWidth;
                }
                setMaxWidth(e) {
                    return this.options.maxWidth = e, this._update(), this;
                }
                setDOMContent(e) {
                    let t1 = this._content;
                    if (t1) for(; t1.hasChildNodes();)t1.firstChild && t1.removeChild(t1.firstChild);
                    else t1 = this._content = l("div", "mapboxgl-popup-content", this._container || void 0);
                    if (t1.appendChild(e), this.options.closeButton) {
                        const e = this._closeButton = l("button", "mapboxgl-popup-close-button", t1);
                        e.type = "button", e.setAttribute("aria-label", "Close popup"), e.innerHTML = '<span aria-hidden="true">&#215;</span>', e.addEventListener("click", this._onClose);
                    }
                    return this._update(), this._focusFirstElement(), this;
                }
                addClassName(e) {
                    return this._classList.add(e), this._updateClassList(), this;
                }
                removeClassName(e) {
                    return this._classList.delete(e), this._updateClassList(), this;
                }
                setOffset(e) {
                    return this.options.offset = e, this._update(), this;
                }
                toggleClassName(e) {
                    let t1;
                    return this._classList.delete(e) ? t1 = !1 : (this._classList.add(e), t1 = !0), this._updateClassList(), t1;
                }
                _onMouseEvent(e) {
                    this._update(e.point);
                }
                _getAnchor(e) {
                    if (this.options.anchor) return this.options.anchor;
                    const t1 = this._map, i = this._container, o = this._pos;
                    if (!t1 || !i || !o) return "bottom";
                    const s = i.offsetWidth, r = i.offsetHeight, a = o.x < s / 2, n = o.x > t1.transform.width - s / 2;
                    if (o.y + e < r) return a ? "top-left" : n ? "top-right" : "top";
                    if (o.y > t1.transform.height - r) {
                        if (a) return "bottom-left";
                        if (n) return "bottom-right";
                    }
                    return a ? "left" : n ? "right" : "bottom";
                }
                _updateClassList() {
                    const e = this._container;
                    if (!e) return;
                    const t1 = [
                        ...this._classList
                    ];
                    t1.push("mapboxgl-popup"), this._anchor && t1.push(`mapboxgl-popup-anchor-${this._anchor}`), this._trackPointer && t1.push("mapboxgl-popup-track-pointer"), e.className = t1.join(" ");
                }
                _update(t1) {
                    const i = this._map, o = this._content;
                    if (!i || !this._lngLat && !this._trackPointer || !o) return;
                    let s = this._container;
                    if (s || (s = this._container = l("div", "mapboxgl-popup", i.getContainer()), this._tip = l("div", "mapboxgl-popup-tip", s), s.appendChild(o)), this.options.maxWidth && s.style.maxWidth !== this.options.maxWidth && (s.style.maxWidth = this.options.maxWidth), i.transform.renderWorldCopies && !this._trackPointer && (this._lngLat = ll(this._lngLat, this._pos, i.transform)), !this._trackPointer || t1) {
                        const o = this._pos = this._trackPointer && t1 instanceof e.P ? t1 : i.project(this._lngLat), s = ml(this.options.offset), r = this._anchor = this._getAnchor(s.y), a = ml(this.options.offset, r), n = o.add(a).round();
                        i._requestDomTask(()=>{
                            this._container && r && (this._container.style.transform = `${cl[r]} translate(${n.x}px,${n.y}px)`);
                        });
                    }
                    if (!this._marker && i._showingGlobe()) {
                        const t1 = e.dH(i.transform, this._lngLat) ? 0 : 1;
                        this._setOpacity(t1);
                    }
                    this._updateClassList();
                }
                _focusFirstElement() {
                    if (!this.options.focusAfterOpen || !this._container) return;
                    const e = this._container.querySelector(fl);
                    e && e.focus();
                }
                _onClose() {
                    this.remove();
                }
                _setOpacity(e) {
                    this._container && (this._container.style.opacity = `${e}`), this._content && (this._content.style.pointerEvents = e ? "auto" : "none");
                }
                constructor(t1){
                    super(), this.options = e.l(Object.create(pl), t1), e.aP([
                        "_update",
                        "_onClose",
                        "remove",
                        "_onMouseEvent"
                    ], this), this._classList = new Set(t1 && t1.className ? t1.className.trim().split(/\s+/) : []);
                }
            },
            Marker: hl,
            Style: To,
            LngLat: e.bO,
            LngLatBounds: e.az,
            Point: e.P,
            MercatorCoordinate: e.aa,
            FreeCameraOptions: Wi,
            Evented: e.E,
            config: e.e,
            prewarm: e.dM,
            clearPrewarmedResources: e.dN,
            get accessToken () {
                return e.e.ACCESS_TOKEN;
            },
            set accessToken (t){
                e.e.ACCESS_TOKEN = t;
            },
            get baseApiUrl () {
                return e.e.API_URL;
            },
            set baseApiUrl (t){
                e.e.API_URL = t;
            },
            get workerCount () {
                return e.dO.workerCount;
            },
            set workerCount (t){
                e.dO.workerCount = t;
            },
            get maxParallelImageRequests () {
                return e.e.MAX_PARALLEL_IMAGE_REQUESTS;
            },
            set maxParallelImageRequests (t){
                e.e.MAX_PARALLEL_IMAGE_REQUESTS = t;
            },
            clearStorage (t1) {
                e.dP(t1);
            },
            get workerUrl () {
                return e.dQ.workerUrl;
            },
            set workerUrl (t){
                e.dQ.workerUrl = t;
            },
            get workerClass () {
                return e.dQ.workerClass;
            },
            set workerClass (t){
                e.dQ.workerClass = t;
            },
            get workerParams () {
                return e.dQ.workerParams;
            },
            set workerParams (t){
                e.dQ.workerParams = t;
            },
            get dracoUrl () {
                return e.dR();
            },
            set dracoUrl (t){
                e.dS(t);
            },
            get meshoptUrl () {
                return e.dT();
            },
            set meshoptUrl (t){
                e.dU(t);
            },
            setNow: e.q.setNow,
            restoreNow: e.q.restoreNow
        };
        return gl;
    });
    //
    // Our custom intro provides a specialized "define()" function, called by the
    // AMD modules below, that sets up the worker blob URL and then executes the
    // main module, storing its exported value as 'mapboxgl'
    var mapboxgl$1 = mapboxgl;
    return mapboxgl$1;
});

});

parcelRegister("3Fezy", function(module, exports) {
"use strict";
var $2ab081364be27a1e$var$__assign = module.exports && module.exports.__assign || function() {
    $2ab081364be27a1e$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $2ab081364be27a1e$var$__assign.apply(this, arguments);
};
var $2ab081364be27a1e$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, {
        enumerable: true,
        get: function() {
            return m[k];
        }
    });
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $2ab081364be27a1e$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $2ab081364be27a1e$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $2ab081364be27a1e$var$__createBinding(result, mod, k);
    }
    $2ab081364be27a1e$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Carousel = void 0;

var $7fhJd = parcelRequire("7fhJd");

var $6h9rz = parcelRequire("6h9rz");

var $gF1SE = parcelRequire("gF1SE");

var $7bLnp = parcelRequire("7bLnp");

var $2ab081364be27a1e$var$react_1 = $2ab081364be27a1e$var$__importStar((parcelRequire("gJYWc")));
var $2ab081364be27a1e$var$Carousel = function(props) {
    var _a = (0, $2ab081364be27a1e$var$react_1.useState)({
        active: 0,
        prevActive: 0,
        next: true
    }), state = _a[0], setState = _a[1];
    /** Used to set carousel's height. It is being set by the CarouselItems */ var _b = (0, $2ab081364be27a1e$var$react_1.useState)(), childrenHeight = _b[0], setChildrenHeight = _b[1];
    var _c = (0, $2ab081364be27a1e$var$react_1.useState)(false), paused = _c[0], setPaused = _c[1];
    var sanitizedProps = (0, $gF1SE.sanitizeProps)(props);
    // componentDidMount & onIndexChange
    (0, $2ab081364be27a1e$var$react_1.useEffect)(function() {
        var index = sanitizedProps.index, changeOnFirstRender = sanitizedProps.changeOnFirstRender;
        setNext(index, true, changeOnFirstRender);
    }, [
        sanitizedProps.index
    ]);
    (0, $gF1SE.useInterval)(function() {
        var autoPlay = sanitizedProps.autoPlay;
        if (autoPlay && !paused) next(undefined);
    }, sanitizedProps.interval);
    var next = function(event) {
        var children = sanitizedProps.children, cycleNavigation = sanitizedProps.cycleNavigation;
        var last = Array.isArray(children) ? children.length - 1 : 0;
        var nextActive = state.active + 1 > last ? cycleNavigation ? 0 : state.active : state.active + 1;
        setNext(nextActive, true);
        if (event) event.stopPropagation();
    };
    var prev = function(event) {
        var children = sanitizedProps.children, cycleNavigation = sanitizedProps.cycleNavigation;
        var last = Array.isArray(children) ? children.length - 1 : 0;
        var nextActive = state.active - 1 < 0 ? cycleNavigation ? last : state.active : state.active - 1;
        setNext(nextActive, false);
        if (event) event.stopPropagation();
    };
    var setNext = function(index, isNext, runCallbacks) {
        if (runCallbacks === void 0) runCallbacks = true;
        var onChange = sanitizedProps.onChange, children = sanitizedProps.children, strictIndexing = sanitizedProps.strictIndexing;
        if (Array.isArray(children)) {
            if (strictIndexing && index > children.length - 1) index = children.length - 1;
            if (strictIndexing && index < 0) index = 0;
        } else index = 0;
        if (runCallbacks) {
            if (isNext !== undefined) isNext ? sanitizedProps.next(index, state.active) : sanitizedProps.prev(index, state.active);
            onChange(index, state.active);
        }
        if (isNext === undefined) isNext = index > state.active;
        setState({
            active: index,
            prevActive: state.active,
            next: isNext
        });
    };
    var children = sanitizedProps.children, sx = sanitizedProps.sx, className = sanitizedProps.className, height = sanitizedProps.height, stopAutoPlayOnHover = sanitizedProps.stopAutoPlayOnHover, animation = sanitizedProps.animation, duration = sanitizedProps.duration, swipe = sanitizedProps.swipe, navButtonsAlwaysInvisible = sanitizedProps.navButtonsAlwaysInvisible, navButtonsAlwaysVisible = sanitizedProps.navButtonsAlwaysVisible, cycleNavigation = sanitizedProps.cycleNavigation, fullHeightHover = sanitizedProps.fullHeightHover, navButtonsProps = sanitizedProps.navButtonsProps, navButtonsWrapperProps = sanitizedProps.navButtonsWrapperProps, NavButton = sanitizedProps.NavButton, NextIcon = sanitizedProps.NextIcon, PrevIcon = sanitizedProps.PrevIcon, indicators = sanitizedProps.indicators, indicatorContainerProps = sanitizedProps.indicatorContainerProps, indicatorIconButtonProps = sanitizedProps.indicatorIconButtonProps, activeIndicatorIconButtonProps = sanitizedProps.activeIndicatorIconButtonProps, IndicatorIcon = sanitizedProps.IndicatorIcon;
    var showButton = function(next) {
        if (next === void 0) next = true;
        if (cycleNavigation) return true;
        var last = Array.isArray(children) ? children.length - 1 : 0;
        if (next && state.active === last) return false;
        if (!next && state.active === 0) return false;
        return true;
    };
    return $2ab081364be27a1e$var$react_1.default.createElement($7bLnp.StyledRoot, {
        sx: sx,
        className: className,
        onMouseOver: function() {
            stopAutoPlayOnHover && setPaused(true);
        },
        onMouseOut: function() {
            stopAutoPlayOnHover && setPaused(false);
        },
        onFocus: function() {
            stopAutoPlayOnHover && setPaused(true);
        },
        onBlur: function() {
            stopAutoPlayOnHover && setPaused(false);
        }
    }, $2ab081364be27a1e$var$react_1.default.createElement($7bLnp.StyledItemWrapper, {
        style: {
            height: height ? height : childrenHeight
        }
    }, Array.isArray(children) ? children.map(function(child, index) {
        return $2ab081364be27a1e$var$react_1.default.createElement($7fhJd.CarouselItem, {
            key: "carousel-item" + index,
            state: state,
            index: index,
            maxIndex: children.length - 1,
            child: child,
            animation: animation,
            duration: duration,
            swipe: swipe,
            next: next,
            prev: prev,
            height: height,
            setHeight: setChildrenHeight
        });
    }) : $2ab081364be27a1e$var$react_1.default.createElement($7fhJd.CarouselItem, {
        key: "carousel-item0",
        state: state,
        index: 0,
        maxIndex: 0,
        child: children,
        animation: animation,
        duration: duration,
        height: height,
        setHeight: setChildrenHeight
    })), !navButtonsAlwaysInvisible && showButton(true) && $2ab081364be27a1e$var$react_1.default.createElement($7bLnp.StyledButtonWrapper, $2ab081364be27a1e$var$__assign({
        "$next": true,
        "$prev": false,
        "$fullHeightHover": fullHeightHover
    }, navButtonsWrapperProps), NavButton !== undefined ? NavButton($2ab081364be27a1e$var$__assign({
        onClick: next,
        next: true,
        prev: false
    }, navButtonsProps)) : $2ab081364be27a1e$var$react_1.default.createElement($7bLnp.StyledIconButton, $2ab081364be27a1e$var$__assign({
        "$alwaysVisible": navButtonsAlwaysVisible,
        "$fullHeightHover": fullHeightHover,
        onClick: next,
        "aria-label": "Next"
    }, navButtonsProps), NextIcon)), !navButtonsAlwaysInvisible && showButton(false) && $2ab081364be27a1e$var$react_1.default.createElement($7bLnp.StyledButtonWrapper, $2ab081364be27a1e$var$__assign({
        "$next": false,
        "$prev": true,
        "$fullHeightHover": fullHeightHover
    }, navButtonsWrapperProps), NavButton !== undefined ? NavButton($2ab081364be27a1e$var$__assign({
        onClick: prev,
        next: false,
        prev: true
    }, navButtonsProps)) : $2ab081364be27a1e$var$react_1.default.createElement($7bLnp.StyledIconButton, $2ab081364be27a1e$var$__assign({
        "$alwaysVisible": navButtonsAlwaysVisible,
        "$fullHeightHover": fullHeightHover,
        onClick: prev,
        "aria-label": "Previous"
    }, navButtonsProps), PrevIcon)), indicators ? $2ab081364be27a1e$var$react_1.default.createElement($6h9rz.Indicators, {
        length: Array.isArray(children) ? children.length : 0,
        active: state.active,
        press: setNext,
        indicatorContainerProps: indicatorContainerProps,
        indicatorIconButtonProps: indicatorIconButtonProps,
        activeIndicatorIconButtonProps: activeIndicatorIconButtonProps,
        IndicatorIcon: IndicatorIcon
    }) : null);
};
module.exports.Carousel = $2ab081364be27a1e$var$Carousel;
module.exports.default = module.exports.Carousel;

});
parcelRegister("7fhJd", function(module, exports) {
"use strict";
var $5467af9a4762e0a9$var$__assign = module.exports && module.exports.__assign || function() {
    $5467af9a4762e0a9$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $5467af9a4762e0a9$var$__assign.apply(this, arguments);
};
var $5467af9a4762e0a9$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, {
        enumerable: true,
        get: function() {
            return m[k];
        }
    });
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $5467af9a4762e0a9$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $5467af9a4762e0a9$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $5467af9a4762e0a9$var$__createBinding(result, mod, k);
    }
    $5467af9a4762e0a9$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CarouselItem = void 0;

var $h9UJp = parcelRequire("h9UJp");
var $kBzoh = parcelRequire("kBzoh");

var $5467af9a4762e0a9$var$react_1 = $5467af9a4762e0a9$var$__importStar((parcelRequire("gJYWc")));

var $7bLnp = parcelRequire("7bLnp");
var $5467af9a4762e0a9$var$CarouselItem = function(_a) {
    var animation = _a.animation, next = _a.next, prev = _a.prev, swipe = _a.swipe, state = _a.state, index = _a.index, maxIndex = _a.maxIndex, duration = _a.duration, child = _a.child, height = _a.height, setHeight = _a.setHeight;
    var slide = animation === 'slide';
    var fade = animation === 'fade';
    var dragProps = {
        drag: 'x',
        layout: true,
        onDragEnd: function(event, info) {
            if (!swipe) return;
            if (info.offset.x > 0) prev && prev();
            else if (info.offset.x < 0) next && next();
            event.stopPropagation();
        },
        dragElastic: 0,
        dragConstraints: {
            left: 0,
            right: 0
        }
    };
    var divRef = (0, $5467af9a4762e0a9$var$react_1.useRef)(null);
    var checkAndSetHeight = (0, $5467af9a4762e0a9$var$react_1.useCallback)(function() {
        if (index !== state.active) return;
        if (!divRef.current) return;
        if (divRef.current.offsetHeight === 0) setTimeout(function() {
            return checkAndSetHeight();
        }, 100);
        else setHeight(divRef.current.offsetHeight);
    }, [
        setHeight,
        state.active,
        index,
        divRef
    ]);
    // Set height on every child change
    (0, $5467af9a4762e0a9$var$react_1.useEffect)(function() {
        checkAndSetHeight();
    }, [
        checkAndSetHeight
    ]);
    var variants = {
        leftwardExit: {
            x: slide ? '-100%' : undefined,
            opacity: fade ? 0 : undefined,
            zIndex: 0
        },
        leftOut: {
            x: slide ? '-100%' : undefined,
            opacity: fade ? 0 : undefined,
            display: 'none',
            zIndex: 0
        },
        rightwardExit: {
            x: slide ? '100%' : undefined,
            opacity: fade ? 0 : undefined,
            zIndex: 0
        },
        rightOut: {
            x: slide ? '100%' : undefined,
            opacity: fade ? 0 : undefined,
            display: 'none',
            zIndex: 0
        },
        center: {
            x: 0,
            opacity: 1,
            zIndex: 1
        }
    };
    // Handle animation directions and opacity given based on active, prevActive and this item's index
    var active = state.active, isNext = state.next, prevActive = state.prevActive;
    var animate = 'center';
    if (index === active) animate = 'center';
    else if (index === prevActive) {
        animate = isNext ? 'leftwardExit' : 'rightwardExit';
        if (active === maxIndex && index === 0) animate = 'rightwardExit';
        if (active === 0 && index === maxIndex) animate = 'leftwardExit';
    } else {
        animate = index < active ? 'leftOut' : 'rightOut';
        if (active === maxIndex && index === 0) animate = 'rightOut';
        if (active === 0 && index === maxIndex) animate = 'leftOut';
    }
    duration = duration / 1000;
    return $5467af9a4762e0a9$var$react_1.default.createElement($7bLnp.StyledItem, null, $5467af9a4762e0a9$var$react_1.default.createElement($h9UJp.AnimatePresence, {
        custom: isNext
    }, $5467af9a4762e0a9$var$react_1.default.createElement($kBzoh.motion.div, $5467af9a4762e0a9$var$__assign({}, swipe && dragProps, {
        style: {
            height: '100%'
        }
    }), $5467af9a4762e0a9$var$react_1.default.createElement($kBzoh.motion.div, {
        custom: isNext,
        variants: variants,
        animate: animate,
        transition: {
            x: {
                type: "tween",
                duration: duration,
                delay: 0
            },
            opacity: {
                duration: duration
            }
        },
        style: {
            position: 'relative',
            height: '100%'
        }
    }, $5467af9a4762e0a9$var$react_1.default.createElement("div", {
        ref: divRef,
        style: {
            height: height
        }
    }, child)))));
};
module.exports.CarouselItem = $5467af9a4762e0a9$var$CarouselItem;

});
parcelRegister("h9UJp", function(module, exports) {

$parcel$export(module.exports, "AnimatePresence", function () { return $c7df489673401037$export$3ae376d12526dd6f; });

var $66bGh = parcelRequire("66bGh");

var $gJYWc = parcelRequire("gJYWc");

var $8fQMF = parcelRequire("8fQMF");

var $gwUA6 = parcelRequire("gwUA6");

var $db9c2 = parcelRequire("db9c2");
function $c7df489673401037$var$getChildKey(child) {
    return child.key || "";
}
function $c7df489673401037$var$updateChildLookup(children, allChildren) {
    var seenChildren = null;
    children.forEach(function(child) {
        var key = $c7df489673401037$var$getChildKey(child);
        allChildren.set(key, child);
    });
}
function $c7df489673401037$var$onlyElements(children) {
    var filtered = [];
    // We use forEach here instead of map as map mutates the component key by preprending `.$`
    (0, $gJYWc.Children).forEach(children, function(child) {
        if ((0, $gJYWc.isValidElement)(child)) filtered.push(child);
    });
    return filtered;
}
/**
 * `AnimatePresence` enables the animation of components that have been removed from the tree.
 *
 * When adding/removing more than a single child, every child **must** be given a unique `key` prop.
 *
 * @library
 *
 * Any `Frame` components that have an `exit` property defined will animate out when removed from
 * the tree.
 *
 * ```jsx
 * import { Frame, AnimatePresence } from 'framer'
 *
 * // As items are added and removed from `items`
 * export function Items({ items }) {
 *   return (
 *     <AnimatePresence>
 *       {items.map(item => (
 *         <Frame
 *           key={item.id}
 *           initial={{ opacity: 0 }}
 *           animate={{ opacity: 1 }}
 *           exit={{ opacity: 0 }}
 *         />
 *       ))}
 *     </AnimatePresence>
 *   )
 * }
 * ```
 *
 * You can sequence exit animations throughout a tree using variants.
 *
 * @motion
 *
 * Any `motion` components that have an `exit` property defined will animate out when removed from
 * the tree.
 *
 * ```jsx
 * import { motion, AnimatePresence } from 'framer-motion'
 *
 * export const Items = ({ items }) => (
 *   <AnimatePresence>
 *     {items.map(item => (
 *       <motion.div
 *         key={item.id}
 *         initial={{ opacity: 0 }}
 *         animate={{ opacity: 1 }}
 *         exit={{ opacity: 0 }}
 *       />
 *     ))}
 *   </AnimatePresence>
 * )
 * ```
 *
 * You can sequence exit animations throughout a tree using variants.
 *
 * If a child contains multiple `motion` components with `exit` props, it will only unmount the child
 * once all `motion` components have finished animating out. Likewise, any components using
 * `usePresence` all need to call `safeToRemove`.
 *
 * @public
 */ var $c7df489673401037$export$3ae376d12526dd6f = function(_a) {
    var children = _a.children, custom = _a.custom, _b = _a.initial, initial = _b === void 0 ? true : _b, onExitComplete = _a.onExitComplete, exitBeforeEnter = _a.exitBeforeEnter, _c = _a.presenceAffectsLayout, presenceAffectsLayout = _c === void 0 ? true : _c;
    // We want to force a re-render once all exiting animations have finished. We
    // either use a local forceRender function, or one from a parent context if it exists.
    var forceRender = (0, $8fQMF.useForceUpdate)();
    var layoutContext = (0, $gJYWc.useContext)((0, $db9c2.SharedLayoutContext));
    if ((0, $db9c2.isSharedLayout)(layoutContext)) forceRender = layoutContext.forceUpdate;
    var isInitialRender = (0, $gJYWc.useRef)(true);
    // Filter out any children that aren't ReactElements. We can only track ReactElements with a props.key
    var filteredChildren = $c7df489673401037$var$onlyElements(children);
    // Keep a living record of the children we're actually rendering so we
    // can diff to figure out which are entering and exiting
    var presentChildren = (0, $gJYWc.useRef)(filteredChildren);
    // A lookup table to quickly reference components by key
    var allChildren = (0, $gJYWc.useRef)(new Map()).current;
    // A living record of all currently exiting components.
    var exiting = (0, $gJYWc.useRef)(new Set()).current;
    $c7df489673401037$var$updateChildLookup(filteredChildren, allChildren);
    // If this is the initial component render, just deal with logic surrounding whether
    // we play onMount animations or not.
    if (isInitialRender.current) {
        isInitialRender.current = false;
        return $gJYWc.createElement($gJYWc.Fragment, null, filteredChildren.map(function(child) {
            return $gJYWc.createElement((0, $gwUA6.PresenceChild), {
                key: $c7df489673401037$var$getChildKey(child),
                isPresent: true,
                initial: initial ? undefined : false,
                presenceAffectsLayout: presenceAffectsLayout
            }, child);
        }));
    }
    // If this is a subsequent render, deal with entering and exiting children
    var childrenToRender = (0, $66bGh.__spreadArray)([], (0, $66bGh.__read)(filteredChildren));
    // Diff the keys of the currently-present and target children to update our
    // exiting list.
    var presentKeys = presentChildren.current.map($c7df489673401037$var$getChildKey);
    var targetKeys = filteredChildren.map($c7df489673401037$var$getChildKey);
    // Diff the present children with our target children and mark those that are exiting
    var numPresent = presentKeys.length;
    for(var i = 0; i < numPresent; i++){
        var key = presentKeys[i];
        if (targetKeys.indexOf(key) === -1) exiting.add(key);
        else // In case this key has re-entered, remove from the exiting list
        exiting.delete(key);
    }
    // If we currently have exiting children, and we're deferring rendering incoming children
    // until after all current children have exiting, empty the childrenToRender array
    if (exitBeforeEnter && exiting.size) childrenToRender = [];
    // Loop through all currently exiting components and clone them to overwrite `animate`
    // with any `exit` prop they might have defined.
    exiting.forEach(function(key) {
        // If this component is actually entering again, early return
        if (targetKeys.indexOf(key) !== -1) return;
        var child = allChildren.get(key);
        if (!child) return;
        var insertionIndex = presentKeys.indexOf(key);
        var onExit = function() {
            allChildren.delete(key);
            exiting.delete(key);
            // Remove this child from the present children
            var removeIndex = presentChildren.current.findIndex(function(presentChild) {
                return presentChild.key === key;
            });
            presentChildren.current.splice(removeIndex, 1);
            // Defer re-rendering until all exiting children have indeed left
            if (!exiting.size) {
                presentChildren.current = filteredChildren;
                forceRender();
                onExitComplete && onExitComplete();
            }
        };
        childrenToRender.splice(insertionIndex, 0, $gJYWc.createElement((0, $gwUA6.PresenceChild), {
            key: $c7df489673401037$var$getChildKey(child),
            isPresent: false,
            onExitComplete: onExit,
            custom: custom,
            presenceAffectsLayout: presenceAffectsLayout
        }, child));
    });
    // Add `MotionContext` even to children that don't need it to ensure we're rendering
    // the same tree between renders
    childrenToRender = childrenToRender.map(function(child) {
        var key = child.key;
        return exiting.has(key) ? child : $gJYWc.createElement((0, $gwUA6.PresenceChild), {
            key: $c7df489673401037$var$getChildKey(child),
            isPresent: true,
            presenceAffectsLayout: presenceAffectsLayout
        }, child);
    });
    presentChildren.current = childrenToRender;
    return $gJYWc.createElement($gJYWc.Fragment, null, exiting.size ? childrenToRender : childrenToRender.map(function(child) {
        return (0, $gJYWc.cloneElement)(child);
    }));
};

});
parcelRegister("66bGh", function(module, exports) {

$parcel$export(module.exports, "__extends", function () { return $470c5d2f64787d39$export$a8ba968b8961cb8a; });
$parcel$export(module.exports, "__assign", function () { return $470c5d2f64787d39$export$18ce0697a983be9b; });
$parcel$export(module.exports, "__rest", function () { return $470c5d2f64787d39$export$3c9a16f847548506; });
$parcel$export(module.exports, "__read", function () { return $470c5d2f64787d39$export$8d051b38c9118094; });
$parcel$export(module.exports, "__spreadArray", function () { return $470c5d2f64787d39$export$1216008129fb82ed; });
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol, Iterator */ var $470c5d2f64787d39$var$extendStatics = function(d, b) {
    $470c5d2f64787d39$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $470c5d2f64787d39$var$extendStatics(d, b);
};
function $470c5d2f64787d39$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $470c5d2f64787d39$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $470c5d2f64787d39$export$18ce0697a983be9b = function() {
    $470c5d2f64787d39$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $470c5d2f64787d39$export$18ce0697a983be9b.apply(this, arguments);
};
function $470c5d2f64787d39$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $470c5d2f64787d39$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $470c5d2f64787d39$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $470c5d2f64787d39$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $470c5d2f64787d39$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $470c5d2f64787d39$export$6a2a36740a146cb8(x) {
    return typeof x === "symbol" ? x : "".concat(x);
}
function $470c5d2f64787d39$export$d1a06452d3489bc7(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $470c5d2f64787d39$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $470c5d2f64787d39$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $470c5d2f64787d39$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $470c5d2f64787d39$export$45d3717a4c69092e = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $470c5d2f64787d39$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $470c5d2f64787d39$export$45d3717a4c69092e(o, m, p);
}
function $470c5d2f64787d39$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $470c5d2f64787d39$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $470c5d2f64787d39$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($470c5d2f64787d39$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $470c5d2f64787d39$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $470c5d2f64787d39$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $470c5d2f64787d39$export$10c90e4f7922046c(v) {
    return this instanceof $470c5d2f64787d39$export$10c90e4f7922046c ? (this.v = v, this) : new $470c5d2f64787d39$export$10c90e4f7922046c(v);
}
function $470c5d2f64787d39$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = Object.create((typeof AsyncIterator === "function" ? AsyncIterator : Object).prototype), verb("next"), verb("throw"), verb("return", awaitReturn), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function awaitReturn(f) {
        return function(v) {
            return Promise.resolve(v).then(f, reject);
        };
    }
    function verb(n, f) {
        if (g[n]) {
            i[n] = function(v) {
                return new Promise(function(a, b) {
                    q.push([
                        n,
                        v,
                        a,
                        b
                    ]) > 1 || resume(n, v);
                });
            };
            if (f) i[n] = f(i[n]);
        }
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $470c5d2f64787d39$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $470c5d2f64787d39$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $470c5d2f64787d39$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $470c5d2f64787d39$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $470c5d2f64787d39$export$19a8beecd37a4c45 === "function" ? $470c5d2f64787d39$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $470c5d2f64787d39$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $470c5d2f64787d39$var$__setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
var $470c5d2f64787d39$var$ownKeys = function(o) {
    $470c5d2f64787d39$var$ownKeys = Object.getOwnPropertyNames || function(o) {
        var ar = [];
        for(var k in o)if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
        return ar;
    };
    return $470c5d2f64787d39$var$ownKeys(o);
};
function $470c5d2f64787d39$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k = $470c5d2f64787d39$var$ownKeys(mod), i = 0; i < k.length; i++)if (k[i] !== "default") $470c5d2f64787d39$export$45d3717a4c69092e(result, mod, k[i]);
    }
    $470c5d2f64787d39$var$__setModuleDefault(result, mod);
    return result;
}
function $470c5d2f64787d39$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $470c5d2f64787d39$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $470c5d2f64787d39$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $470c5d2f64787d39$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $470c5d2f64787d39$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose, inner;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
            if (async) inner = dispose;
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        if (inner) dispose = function() {
            try {
                inner.call(this);
            } catch (e) {
                return Promise.reject(e);
            }
        };
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $470c5d2f64787d39$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $470c5d2f64787d39$export$8f076105dc360e92(env) {
    function fail(e) {
        env.error = env.hasError ? new $470c5d2f64787d39$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    var r, s = 0;
    function next() {
        while(r = env.stack.pop())try {
            if (!r.async && s === 1) return s = 0, env.stack.push(r), Promise.resolve().then(next);
            if (r.dispose) {
                var result = r.dispose.call(r.value);
                if (r.async) return s |= 2, Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } else s |= 1;
        } catch (e) {
            fail(e);
        }
        if (s === 1) return env.hasError ? Promise.reject(env.error) : Promise.resolve();
        if (env.hasError) throw env.error;
    }
    return next();
}
function $470c5d2f64787d39$export$889dfb5d17574b0b(path, preserveJsx) {
    if (typeof path === "string" && /^\.\.?\//.test(path)) return path.replace(/\.(tsx)$|((?:\.d)?)((?:\.[^./]+?)?)\.([cm]?)ts$/i, function(m, tsx, d, ext, cm) {
        return tsx ? preserveJsx ? ".jsx" : ".js" : d && (!ext || !cm) ? m : d + ext + "." + cm.toLowerCase() + "js";
    });
    return path;
}
var $470c5d2f64787d39$export$2e2bcd8739ae039 = {
    __extends: $470c5d2f64787d39$export$a8ba968b8961cb8a,
    __assign: $470c5d2f64787d39$export$18ce0697a983be9b,
    __rest: $470c5d2f64787d39$export$3c9a16f847548506,
    __decorate: $470c5d2f64787d39$export$29e00dfd3077644b,
    __param: $470c5d2f64787d39$export$d5ad3fd78186038f,
    __esDecorate: $470c5d2f64787d39$export$3a84e1ae4e97e9b0,
    __runInitializers: $470c5d2f64787d39$export$d831c04e792af3d,
    __propKey: $470c5d2f64787d39$export$6a2a36740a146cb8,
    __setFunctionName: $470c5d2f64787d39$export$d1a06452d3489bc7,
    __metadata: $470c5d2f64787d39$export$f1db080c865becb9,
    __awaiter: $470c5d2f64787d39$export$1050f835b63b671e,
    __generator: $470c5d2f64787d39$export$67ebef60e6f28a6,
    __createBinding: $470c5d2f64787d39$export$45d3717a4c69092e,
    __exportStar: $470c5d2f64787d39$export$f33643c0debef087,
    __values: $470c5d2f64787d39$export$19a8beecd37a4c45,
    __read: $470c5d2f64787d39$export$8d051b38c9118094,
    __spread: $470c5d2f64787d39$export$afc72e2116322959,
    __spreadArrays: $470c5d2f64787d39$export$6388937ca91ccae8,
    __spreadArray: $470c5d2f64787d39$export$1216008129fb82ed,
    __await: $470c5d2f64787d39$export$10c90e4f7922046c,
    __asyncGenerator: $470c5d2f64787d39$export$e427f37a30a4de9b,
    __asyncDelegator: $470c5d2f64787d39$export$bbd80228419bb833,
    __asyncValues: $470c5d2f64787d39$export$e3b29a3d6162315f,
    __makeTemplateObject: $470c5d2f64787d39$export$4fb47efe1390b86f,
    __importStar: $470c5d2f64787d39$export$c21735bcef00d192,
    __importDefault: $470c5d2f64787d39$export$da59b14a69baef04,
    __classPrivateFieldGet: $470c5d2f64787d39$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $470c5d2f64787d39$export$d40a35129aaff81f,
    __classPrivateFieldIn: $470c5d2f64787d39$export$81fdc39f203e4e04,
    __addDisposableResource: $470c5d2f64787d39$export$88ac25d8e944e405,
    __disposeResources: $470c5d2f64787d39$export$8f076105dc360e92,
    __rewriteRelativeImportExtension: $470c5d2f64787d39$export$889dfb5d17574b0b
};

});

parcelRegister("8fQMF", function(module, exports) {

$parcel$export(module.exports, "useForceUpdate", function () { return $6028ab386c8aaadc$export$91db9bc4f8ac944a; });

var $66bGh = parcelRequire("66bGh");

var $gJYWc = parcelRequire("gJYWc");

var $kdjA6 = parcelRequire("kdjA6");
function $6028ab386c8aaadc$export$91db9bc4f8ac944a() {
    var unloadingRef = (0, $gJYWc.useRef)(false);
    var _a = (0, $66bGh.__read)((0, $gJYWc.useState)(0), 2), forcedRenderCount = _a[0], setForcedRenderCount = _a[1];
    (0, $kdjA6.useUnmountEffect)(function() {
        return unloadingRef.current = true;
    });
    return (0, $gJYWc.useCallback)(function() {
        !unloadingRef.current && setForcedRenderCount(forcedRenderCount + 1);
    }, [
        forcedRenderCount
    ]);
}

});
parcelRegister("kdjA6", function(module, exports) {

$parcel$export(module.exports, "useUnmountEffect", function () { return $eb743600251b92b4$export$f3a192d0cbd30b96; });

var $gJYWc = parcelRequire("gJYWc");
function $eb743600251b92b4$export$f3a192d0cbd30b96(callback) {
    return (0, $gJYWc.useEffect)(function() {
        return function() {
            return callback();
        };
    }, []);
}

});


parcelRegister("gwUA6", function(module, exports) {

$parcel$export(module.exports, "PresenceChild", function () { return $c08b8663c65130ec$export$979daf65881a382a; });

var $gJYWc = parcelRequire("gJYWc");

var $1CTTQ = parcelRequire("1CTTQ");

var $j0JMo = parcelRequire("j0JMo");
var $c08b8663c65130ec$var$presenceId = 0;
function $c08b8663c65130ec$var$getPresenceId() {
    var id = $c08b8663c65130ec$var$presenceId;
    $c08b8663c65130ec$var$presenceId++;
    return id;
}
var $c08b8663c65130ec$export$979daf65881a382a = function(_a) {
    var children = _a.children, initial = _a.initial, isPresent = _a.isPresent, onExitComplete = _a.onExitComplete, custom = _a.custom, presenceAffectsLayout = _a.presenceAffectsLayout;
    var presenceChildren = (0, $j0JMo.useConstant)($c08b8663c65130ec$var$newChildrenMap);
    var id = (0, $j0JMo.useConstant)($c08b8663c65130ec$var$getPresenceId);
    var context = (0, $gJYWc.useMemo)(function() {
        return {
            id: id,
            initial: initial,
            isPresent: isPresent,
            custom: custom,
            onExitComplete: function(childId) {
                presenceChildren.set(childId, true);
                var allComplete = true;
                presenceChildren.forEach(function(isComplete) {
                    if (!isComplete) allComplete = false;
                });
                allComplete && (onExitComplete === null || onExitComplete === void 0 || onExitComplete());
            },
            register: function(childId) {
                presenceChildren.set(childId, false);
                return function() {
                    return presenceChildren.delete(childId);
                };
            }
        };
    }, /**
     * If the presence of a child affects the layout of the components around it,
     * we want to make a new context value to ensure they get re-rendered
     * so they can detect that layout change.
     */ presenceAffectsLayout ? undefined : [
        isPresent
    ]);
    (0, $gJYWc.useMemo)(function() {
        presenceChildren.forEach(function(_, key) {
            return presenceChildren.set(key, false);
        });
    }, [
        isPresent
    ]);
    /**
     * If there's no `motion` components to fire exit animations, we want to remove this
     * component immediately.
     */ $gJYWc.useEffect(function() {
        !isPresent && !presenceChildren.size && (onExitComplete === null || onExitComplete === void 0 || onExitComplete());
    }, [
        isPresent
    ]);
    return $gJYWc.createElement((0, $1CTTQ.PresenceContext).Provider, {
        value: context
    }, children);
};
function $c08b8663c65130ec$var$newChildrenMap() {
    return new Map();
}

});
parcelRegister("1CTTQ", function(module, exports) {

$parcel$export(module.exports, "PresenceContext", function () { return $12f4b394364d9f5b$export$f224e4635b6f8ce2; });

var $gJYWc = parcelRequire("gJYWc");
/**
 * @public
 */ var $12f4b394364d9f5b$export$f224e4635b6f8ce2 = (0, $gJYWc.createContext)(null);

});

parcelRegister("j0JMo", function(module, exports) {

$parcel$export(module.exports, "useConstant", function () { return $dd7187439a423a27$export$fe4300aa8eebea86; });

var $gJYWc = parcelRequire("gJYWc");
/**
 * Creates a constant value over the lifecycle of a component.
 *
 * Even if `useMemo` is provided an empty array as its final argument, it doesn't offer
 * a guarantee that it won't re-run for performance reasons later on. By using `useConstant`
 * you can ensure that initialisers don't execute twice or more.
 */ function $dd7187439a423a27$export$fe4300aa8eebea86(init) {
    var ref = (0, $gJYWc.useRef)(null);
    if (ref.current === null) ref.current = init();
    return ref.current;
}

});


parcelRegister("db9c2", function(module, exports) {

$parcel$export(module.exports, "SharedLayoutContext", function () { return $99836f0923b6eb5e$export$a3d1a816cb91a642; });
$parcel$export(module.exports, "FramerTreeLayoutContext", function () { return $99836f0923b6eb5e$export$88d0442641a5238c; });
$parcel$export(module.exports, "isSharedLayout", function () { return $99836f0923b6eb5e$export$8475119b63356082; });

var $gJYWc = parcelRequire("gJYWc");

var $fkpzH = parcelRequire("fkpzH");
var $99836f0923b6eb5e$export$a3d1a816cb91a642 = (0, $gJYWc.createContext)((0, $fkpzH.createBatcher)());
/**
 * @internal
 */ var $99836f0923b6eb5e$export$88d0442641a5238c = (0, $gJYWc.createContext)((0, $fkpzH.createBatcher)());
function $99836f0923b6eb5e$export$8475119b63356082(context) {
    return !!context.forceUpdate;
}

});
parcelRegister("fkpzH", function(module, exports) {

$parcel$export(module.exports, "createBatcher", function () { return $b28c8fe2ca2c93ed$export$29e5fe0a0fc8f32f; });

var $66bGh = parcelRequire("66bGh");

var $fzvX8 = parcelRequire("fzvX8");

var $52vCk = parcelRequire("52vCk");

var $lxfWR = parcelRequire("lxfWR");

var $1TXqq = parcelRequire("1TXqq");

var $aRkas = parcelRequire("aRkas");
/**
 * Default handlers for batching VisualElements
 */ var $b28c8fe2ca2c93ed$var$defaultHandler = {
    layoutReady: function(child) {
        return child.notifyLayoutReady();
    }
};
/**
 * Create a batcher to process VisualElements
 */ function $b28c8fe2ca2c93ed$export$29e5fe0a0fc8f32f() {
    var queue = new Set();
    return {
        add: function(child) {
            return queue.add(child);
        },
        flush: function(_a) {
            var _b = _a === void 0 ? $b28c8fe2ca2c93ed$var$defaultHandler : _a, layoutReady = _b.layoutReady, parent = _b.parent;
            (0, $lxfWR.batchLayout)(function(read, write) {
                var order = Array.from(queue).sort((0, $1TXqq.compareByDepth));
                var ancestors = parent ? (0, $52vCk.collectProjectingAncestors)(parent) : [];
                write(function() {
                    var allElements = (0, $66bGh.__spreadArray)((0, $66bGh.__spreadArray)([], (0, $66bGh.__read)(ancestors)), (0, $66bGh.__read)(order));
                    allElements.forEach(function(element) {
                        return element.resetTransform();
                    });
                });
                read(function() {
                    order.forEach((0, $52vCk.updateLayoutMeasurement));
                });
                write(function() {
                    ancestors.forEach(function(element) {
                        return element.restoreTransform();
                    });
                    order.forEach(layoutReady);
                });
                read(function() {
                    /**
                     * After all children have started animating, ensure any Entering components are set to Present.
                     * If we add deferred animations (set up all animations and then start them in two loops) this
                     * could be moved to the start loop. But it needs to happen after all the animations configs
                     * are generated in AnimateSharedLayout as this relies on presence data
                     */ order.forEach(function(child) {
                        if (child.isPresent) child.presence = (0, $aRkas.Presence).Present;
                    });
                });
                write(function() {
                    /**
                     * Starting these animations will have queued jobs on the frame loop. In some situations,
                     * like when removing an element, these will be processed too late after the DOM is manipulated,
                     * leaving a flash of incorrectly-projected content. By manually flushing these jobs
                     * we ensure there's no flash.
                     */ (0, $fzvX8.flushSync).preRender();
                    (0, $fzvX8.flushSync).render();
                });
                read(function() {
                    /**
                     * Schedule a callback at the end of the following frame to assign the latest projection
                     * box to the prevViewportBox snapshot. Once global batching is in place this could be run
                     * synchronously. But for now it ensures that if any nested `AnimateSharedLayout` top-level
                     * child attempts to calculate its previous relative position against a prevViewportBox
                     * it will be against its latest projection box instead, as the snapshot is useless beyond this
                     * render.
                     */ (0, $fzvX8.default).postRender(function() {
                        return order.forEach($b28c8fe2ca2c93ed$var$assignProjectionToSnapshot);
                    });
                    queue.clear();
                });
            });
            // TODO: Need to find a layout-synchronous way of flushing this
            (0, $lxfWR.flushLayout)();
        }
    };
}
function $b28c8fe2ca2c93ed$var$assignProjectionToSnapshot(child) {
    child.prevViewportBox = child.projection.target;
}

});
parcelRegister("fzvX8", function(module, exports) {

$parcel$export(module.exports, "cancelSync", function () { return $b562e91103160134$export$d93e9c1fe0553512; });
$parcel$export(module.exports, "flushSync", function () { return $b562e91103160134$export$cd75ccfd720a3cd4; });
$parcel$export(module.exports, "getFrameData", function () { return $b562e91103160134$export$7244445918e670ed; });
$parcel$export(module.exports, "default", function () { return $b562e91103160134$export$2e2bcd8739ae039; });

var $dClVM = parcelRequire("dClVM");

var $W3r7J = parcelRequire("W3r7J");
var $b562e91103160134$var$maxElapsed = 40;
var $b562e91103160134$var$useDefaultElapsed = true;
var $b562e91103160134$var$runNextFrame = false;
var $b562e91103160134$var$isProcessing = false;
var $b562e91103160134$var$frame = {
    delta: 0,
    timestamp: 0
};
var $b562e91103160134$var$stepsOrder = [
    "read",
    "update",
    "preRender",
    "render",
    "postRender"
];
var $b562e91103160134$var$steps = /*#__PURE__*/ $b562e91103160134$var$stepsOrder.reduce(function(acc, key) {
    acc[key] = (0, $W3r7J.createRenderStep)(function() {
        return $b562e91103160134$var$runNextFrame = true;
    });
    return acc;
}, {});
var $b562e91103160134$var$sync = /*#__PURE__*/ $b562e91103160134$var$stepsOrder.reduce(function(acc, key) {
    var step = $b562e91103160134$var$steps[key];
    acc[key] = function(process, keepAlive, immediate) {
        if (keepAlive === void 0) keepAlive = false;
        if (immediate === void 0) immediate = false;
        if (!$b562e91103160134$var$runNextFrame) $b562e91103160134$var$startLoop();
        return step.schedule(process, keepAlive, immediate);
    };
    return acc;
}, {});
var $b562e91103160134$export$d93e9c1fe0553512 = /*#__PURE__*/ $b562e91103160134$var$stepsOrder.reduce(function(acc, key) {
    acc[key] = $b562e91103160134$var$steps[key].cancel;
    return acc;
}, {});
var $b562e91103160134$export$cd75ccfd720a3cd4 = /*#__PURE__*/ $b562e91103160134$var$stepsOrder.reduce(function(acc, key) {
    acc[key] = function() {
        return $b562e91103160134$var$steps[key].process($b562e91103160134$var$frame);
    };
    return acc;
}, {});
var $b562e91103160134$var$processStep = function(stepId) {
    return $b562e91103160134$var$steps[stepId].process($b562e91103160134$var$frame);
};
var $b562e91103160134$var$processFrame = function(timestamp) {
    $b562e91103160134$var$runNextFrame = false;
    $b562e91103160134$var$frame.delta = $b562e91103160134$var$useDefaultElapsed ? (0, $dClVM.defaultTimestep) : Math.max(Math.min(timestamp - $b562e91103160134$var$frame.timestamp, $b562e91103160134$var$maxElapsed), 1);
    $b562e91103160134$var$frame.timestamp = timestamp;
    $b562e91103160134$var$isProcessing = true;
    $b562e91103160134$var$stepsOrder.forEach($b562e91103160134$var$processStep);
    $b562e91103160134$var$isProcessing = false;
    if ($b562e91103160134$var$runNextFrame) {
        $b562e91103160134$var$useDefaultElapsed = false;
        (0, $dClVM.onNextFrame)($b562e91103160134$var$processFrame);
    }
};
var $b562e91103160134$var$startLoop = function() {
    $b562e91103160134$var$runNextFrame = true;
    $b562e91103160134$var$useDefaultElapsed = true;
    if (!$b562e91103160134$var$isProcessing) (0, $dClVM.onNextFrame)($b562e91103160134$var$processFrame);
};
var $b562e91103160134$export$7244445918e670ed = function() {
    return $b562e91103160134$var$frame;
};
var $b562e91103160134$export$2e2bcd8739ae039 = $b562e91103160134$var$sync;

});
parcelRegister("dClVM", function(module, exports) {

$parcel$export(module.exports, "defaultTimestep", function () { return $9e9fd605ee5e39bc$export$f8caf8121275292d; });
$parcel$export(module.exports, "onNextFrame", function () { return $9e9fd605ee5e39bc$export$4fdea63ab5513fd5; });
var $9e9fd605ee5e39bc$export$f8caf8121275292d = 1 / 60 * 1000;
var $9e9fd605ee5e39bc$var$getCurrentTime = typeof performance !== "undefined" ? function() {
    return performance.now();
} : function() {
    return Date.now();
};
var $9e9fd605ee5e39bc$export$4fdea63ab5513fd5 = typeof window !== "undefined" ? function(callback) {
    return window.requestAnimationFrame(callback);
} : function(callback) {
    return setTimeout(function() {
        return callback($9e9fd605ee5e39bc$var$getCurrentTime());
    }, $9e9fd605ee5e39bc$export$f8caf8121275292d);
};

});

parcelRegister("W3r7J", function(module, exports) {

$parcel$export(module.exports, "createRenderStep", function () { return $0ae8154eaebe56a5$export$b995e5e85f5c8289; });
function $0ae8154eaebe56a5$export$b995e5e85f5c8289(runNextFrame) {
    var toRun = [];
    var toRunNextFrame = [];
    var numToRun = 0;
    var isProcessing = false;
    var toKeepAlive = new WeakSet();
    var step = {
        schedule: function(callback, keepAlive, immediate) {
            if (keepAlive === void 0) keepAlive = false;
            if (immediate === void 0) immediate = false;
            var addToCurrentFrame = immediate && isProcessing;
            var buffer = addToCurrentFrame ? toRun : toRunNextFrame;
            if (keepAlive) toKeepAlive.add(callback);
            if (buffer.indexOf(callback) === -1) {
                buffer.push(callback);
                if (addToCurrentFrame && isProcessing) numToRun = toRun.length;
            }
            return callback;
        },
        cancel: function(callback) {
            var index = toRunNextFrame.indexOf(callback);
            if (index !== -1) toRunNextFrame.splice(index, 1);
            toKeepAlive.delete(callback);
        },
        process: function(frameData) {
            var _a;
            isProcessing = true;
            _a = [
                toRunNextFrame,
                toRun
            ], toRun = _a[0], toRunNextFrame = _a[1];
            toRunNextFrame.length = 0;
            numToRun = toRun.length;
            if (numToRun) for(var i = 0; i < numToRun; i++){
                var callback = toRun[i];
                callback(frameData);
                if (toKeepAlive.has(callback)) {
                    step.schedule(callback);
                    runNextFrame();
                }
            }
            isProcessing = false;
        }
    };
    return step;
}

});


parcelRegister("52vCk", function(module, exports) {

$parcel$export(module.exports, "collectProjectingAncestors", function () { return $3ab5aa2889207ea8$export$e900175ee6159829; });
$parcel$export(module.exports, "collectProjectingChildren", function () { return $3ab5aa2889207ea8$export$99d2ce63b1d58b9f; });
$parcel$export(module.exports, "updateLayoutMeasurement", function () { return $3ab5aa2889207ea8$export$ec1805441219fc83; });
$parcel$export(module.exports, "snapshotViewportBox", function () { return $3ab5aa2889207ea8$export$4f13d577f7028d57; });

var $fzvX8 = parcelRequire("fzvX8");

var $hJbCe = parcelRequire("hJbCe");

var $1TXqq = parcelRequire("1TXqq");
function $3ab5aa2889207ea8$var$isProjecting(visualElement) {
    var isEnabled = visualElement.projection.isEnabled;
    return isEnabled || visualElement.shouldResetTransform();
}
function $3ab5aa2889207ea8$export$e900175ee6159829(visualElement, ancestors) {
    if (ancestors === void 0) ancestors = [];
    var parent = visualElement.parent;
    if (parent) $3ab5aa2889207ea8$export$e900175ee6159829(parent, ancestors);
    if ($3ab5aa2889207ea8$var$isProjecting(visualElement)) ancestors.push(visualElement);
    return ancestors;
}
function $3ab5aa2889207ea8$export$99d2ce63b1d58b9f(visualElement) {
    var children = [];
    var addChild = function(child) {
        if ($3ab5aa2889207ea8$var$isProjecting(child)) children.push(child);
        child.children.forEach(addChild);
    };
    visualElement.children.forEach(addChild);
    return children.sort((0, $1TXqq.compareByDepth));
}
/**
 * Update the layoutState by measuring the DOM layout. This
 * should be called after resetting any layout-affecting transforms.
 */ function $3ab5aa2889207ea8$export$ec1805441219fc83(visualElement) {
    if (visualElement.shouldResetTransform()) return;
    var layoutState = visualElement.getLayoutState();
    visualElement.notifyBeforeLayoutMeasure(layoutState.layout);
    layoutState.isHydrated = true;
    layoutState.layout = visualElement.measureViewportBox();
    layoutState.layoutCorrected = (0, $hJbCe.copyAxisBox)(layoutState.layout);
    visualElement.notifyLayoutMeasure(layoutState.layout, visualElement.prevViewportBox || layoutState.layout);
    (0, $fzvX8.default).update(function() {
        return visualElement.rebaseProjectionTarget();
    });
}
/**
 * Record the viewport box as it was before an expected mutation/re-render
 */ function $3ab5aa2889207ea8$export$4f13d577f7028d57(visualElement) {
    if (visualElement.shouldResetTransform()) return;
    visualElement.prevViewportBox = visualElement.measureViewportBox(false);
    /**
     * Update targetBox to match the prevViewportBox. This is just to ensure
     * that targetBox is affected by scroll in the same way as the measured box
     */ visualElement.rebaseProjectionTarget(false, visualElement.prevViewportBox);
}

});
parcelRegister("hJbCe", function(module, exports) {

$parcel$export(module.exports, "convertBoundingBoxToAxisBox", function () { return $ce7fa6475a158b21$export$a6a6a93acd99480a; });
$parcel$export(module.exports, "convertAxisBoxToBoundingBox", function () { return $ce7fa6475a158b21$export$7dccf987ed3cfb10; });
$parcel$export(module.exports, "transformBoundingBox", function () { return $ce7fa6475a158b21$export$e79a6921359ce186; });
$parcel$export(module.exports, "axisBox", function () { return $ce7fa6475a158b21$export$392205f483678b20; });
$parcel$export(module.exports, "copyAxisBox", function () { return $ce7fa6475a158b21$export$cad7f7b798bfcc39; });
$parcel$export(module.exports, "delta", function () { return $ce7fa6475a158b21$export$eabbe41f409ce55b; });

var $66bGh = parcelRequire("66bGh");

var $8uPYE = parcelRequire("8uPYE");
/**
 * Bounding boxes tend to be defined as top, left, right, bottom. For various operations
 * it's easier to consider each axis individually. This function returns a bounding box
 * as a map of single-axis min/max values.
 */ function $ce7fa6475a158b21$export$a6a6a93acd99480a(_a) {
    var top = _a.top, left = _a.left, right = _a.right, bottom = _a.bottom;
    return {
        x: {
            min: left,
            max: right
        },
        y: {
            min: top,
            max: bottom
        }
    };
}
function $ce7fa6475a158b21$export$7dccf987ed3cfb10(_a) {
    var x = _a.x, y = _a.y;
    return {
        top: y.min,
        bottom: y.max,
        left: x.min,
        right: x.max
    };
}
/**
 * Applies a TransformPoint function to a bounding box. TransformPoint is usually a function
 * provided by Framer to allow measured points to be corrected for device scaling. This is used
 * when measuring DOM elements and DOM event points.
 */ function $ce7fa6475a158b21$export$e79a6921359ce186(_a, transformPoint) {
    var top = _a.top, left = _a.left, bottom = _a.bottom, right = _a.right;
    if (transformPoint === void 0) transformPoint = (0, $8uPYE.noop);
    var topLeft = transformPoint({
        x: left,
        y: top
    });
    var bottomRight = transformPoint({
        x: right,
        y: bottom
    });
    return {
        top: topLeft.y,
        left: topLeft.x,
        bottom: bottomRight.y,
        right: bottomRight.x
    };
}
/**
 * Create an empty axis box of zero size
 */ function $ce7fa6475a158b21$export$392205f483678b20() {
    return {
        x: {
            min: 0,
            max: 1
        },
        y: {
            min: 0,
            max: 1
        }
    };
}
function $ce7fa6475a158b21$export$cad7f7b798bfcc39(box) {
    return {
        x: (0, $66bGh.__assign)({}, box.x),
        y: (0, $66bGh.__assign)({}, box.y)
    };
}
/**
 * Create an empty box delta
 */ var $ce7fa6475a158b21$var$zeroDelta = {
    translate: 0,
    scale: 1,
    origin: 0,
    originPoint: 0
};
function $ce7fa6475a158b21$export$eabbe41f409ce55b() {
    return {
        x: (0, $66bGh.__assign)({}, $ce7fa6475a158b21$var$zeroDelta),
        y: (0, $66bGh.__assign)({}, $ce7fa6475a158b21$var$zeroDelta)
    };
}

});
parcelRegister("8uPYE", function(module, exports) {

$parcel$export(module.exports, "noop", function () { return $62f971ab5375544c$export$8793edee2d425525; });
function $62f971ab5375544c$export$8793edee2d425525(any) {
    return any;
}

});


parcelRegister("1TXqq", function(module, exports) {

$parcel$export(module.exports, "compareByDepth", function () { return $162906186146eca1$export$d689d9dec5ad338; });
var $162906186146eca1$export$d689d9dec5ad338 = function(a, b) {
    return a.depth - b.depth;
};

});


parcelRegister("lxfWR", function(module, exports) {

$parcel$export(module.exports, "batchLayout", function () { return $fad90d116f04c278$export$7e76af4b25f08a69; });
$parcel$export(module.exports, "flushLayout", function () { return $fad90d116f04c278$export$6445c3d91f1ae606; });
var $fad90d116f04c278$var$unresolvedJobs = new Set();
function $fad90d116f04c278$var$pushJob(stack, job, pointer) {
    if (!stack[pointer]) stack[pointer] = [];
    stack[pointer].push(job);
}
function $fad90d116f04c278$export$7e76af4b25f08a69(callback) {
    $fad90d116f04c278$var$unresolvedJobs.add(callback);
    return function() {
        return $fad90d116f04c278$var$unresolvedJobs.delete(callback);
    };
}
function $fad90d116f04c278$export$6445c3d91f1ae606() {
    if (!$fad90d116f04c278$var$unresolvedJobs.size) return;
    var pointer = 0;
    var reads = [
        []
    ];
    var writes = [];
    var setRead = function(job) {
        return $fad90d116f04c278$var$pushJob(reads, job, pointer);
    };
    var setWrite = function(job) {
        $fad90d116f04c278$var$pushJob(writes, job, pointer);
        pointer++;
    };
    /**
     * Resolve jobs into their array stacks
     */ $fad90d116f04c278$var$unresolvedJobs.forEach(function(callback) {
        callback(setRead, setWrite);
        pointer = 0;
    });
    $fad90d116f04c278$var$unresolvedJobs.clear();
    /**
     * Execute jobs
     */ var numStacks = writes.length;
    for(var i = 0; i <= numStacks; i++){
        reads[i] && reads[i].forEach($fad90d116f04c278$var$executeJob);
        writes[i] && writes[i].forEach($fad90d116f04c278$var$executeJob);
    }
}
var $fad90d116f04c278$var$executeJob = function(job) {
    return job();
};

});

parcelRegister("aRkas", function(module, exports) {

$parcel$export(module.exports, "Presence", function () { return $7e7e7f801caa1e5f$export$99c2b779aa4e8b8b; });
$parcel$export(module.exports, "VisibilityAction", function () { return $7e7e7f801caa1e5f$export$560b21f26820dbed; });
/**
 * @public
 */ var $7e7e7f801caa1e5f$export$99c2b779aa4e8b8b;
(function(Presence) {
    Presence[Presence["Entering"] = 0] = "Entering";
    Presence[Presence["Present"] = 1] = "Present";
    Presence[Presence["Exiting"] = 2] = "Exiting";
})($7e7e7f801caa1e5f$export$99c2b779aa4e8b8b || ($7e7e7f801caa1e5f$export$99c2b779aa4e8b8b = {}));
/**
 * @public
 */ var $7e7e7f801caa1e5f$export$560b21f26820dbed;
(function(VisibilityAction) {
    VisibilityAction[VisibilityAction["Hide"] = 0] = "Hide";
    VisibilityAction[VisibilityAction["Show"] = 1] = "Show";
})($7e7e7f801caa1e5f$export$560b21f26820dbed || ($7e7e7f801caa1e5f$export$560b21f26820dbed = {}));

});




parcelRegister("kBzoh", function(module, exports) {

$parcel$export(module.exports, "motion", function () { return $f002b73656a98f58$export$e25e478948902b8b; });

var $66bGh = parcelRequire("66bGh");

var $l4yeB = parcelRequire("l4yeB");

var $iLVgS = parcelRequire("iLVgS");

var $5TNuT = parcelRequire("5TNuT");

var $hEkwi = parcelRequire("hEkwi");

var $dd0Jt = parcelRequire("dd0Jt");

var $7A2EQ = parcelRequire("7A2EQ");

var $h7Noc = parcelRequire("h7Noc");

var $h9Bmg = parcelRequire("h9Bmg");
var $f002b73656a98f58$var$featureBundle = (0, $66bGh.__assign)((0, $66bGh.__assign)((0, $66bGh.__assign)((0, $66bGh.__assign)({}, (0, $dd0Jt.animations)), (0, $hEkwi.gestureAnimations)), (0, $7A2EQ.drag)), (0, $h7Noc.layoutAnimations));
/**
 * HTML & SVG components, optimised for use with gestures and animation. These can be used as
 * drop-in replacements for any HTML & SVG component, all CSS & SVG properties are supported.
 *
 * @public
 */ var $f002b73656a98f58$export$e25e478948902b8b = /*@__PURE__*/ (0, $iLVgS.createMotionProxy)(function(Component, config) {
    return (0, $5TNuT.createDomMotionConfig)(Component, config, $f002b73656a98f58$var$featureBundle, (0, $h9Bmg.createDomVisualElement));
});
/**
 * Create a DOM `motion` component with the provided string. This is primarily intended
 * as a full alternative to `motion` for consumers who have to support environments that don't
 * support `Proxy`.
 *
 * ```javascript
 * import { createDomMotionComponent } from "framer-motion"
 *
 * const motion = {
 *   div: createDomMotionComponent('div')
 * }
 * ```
 *
 * @public
 */ function $f002b73656a98f58$export$546614c4a05701f9(key) {
    return (0, $l4yeB.createMotionComponent)((0, $5TNuT.createDomMotionConfig)(key, {
        forwardMotionProps: false
    }, $f002b73656a98f58$var$featureBundle, (0, $h9Bmg.createDomVisualElement)));
}

});
parcelRegister("l4yeB", function(module, exports) {

$parcel$export(module.exports, "createMotionComponent", function () { return $f57486f39cd973e9$export$46b7e4b9dc6110c3; });

var $gJYWc = parcelRequire("gJYWc");

var $2P9jZ = parcelRequire("2P9jZ");

var $cUvlw = parcelRequire("cUvlw");

var $cq6iL = parcelRequire("cq6iL");

var $6HPvO = parcelRequire("6HPvO");

var $ZvuE2 = parcelRequire("ZvuE2");

var $7sHKP = parcelRequire("7sHKP");

var $kdkxk = parcelRequire("kdkxk");

var $4qLKY = parcelRequire("4qLKY");
/**
 * Create a `motion` component.
 *
 * This function accepts a Component argument, which can be either a string (ie "div"
 * for `motion.div`), or an actual React component.
 *
 * Alongside this is a config option which provides a way of rendering the provided
 * component "offline", or outside the React render cycle.
 *
 * @internal
 */ function $f57486f39cd973e9$export$46b7e4b9dc6110c3(_a) {
    var preloadedFeatures = _a.preloadedFeatures, createVisualElement = _a.createVisualElement, useRender = _a.useRender, useVisualState = _a.useVisualState, Component = _a.Component;
    preloadedFeatures && (0, $kdkxk.loadFeatures)(preloadedFeatures);
    function MotionComponent(props, externalRef) {
        /**
         * If we're rendering in a static environment, we only visually update the component
         * as a result of a React-rerender rather than interactions or animations. This
         * means we don't need to load additional memory structures like VisualElement,
         * or any gesture/animation features.
         */ var isStatic = (0, $gJYWc.useContext)((0, $cUvlw.MotionConfigContext)).isStatic;
        var features = null;
        /**
         * Create the tree context. This is memoized and will only trigger renders
         * when the current tree variant changes in static mode.
         */ var context = (0, $7sHKP.useCreateMotionContext)(props, isStatic);
        /**
         *
         */ var visualState = useVisualState(props, isStatic);
        if (!isStatic && (0, $4qLKY.isBrowser)) {
            /**
             * Create a VisualElement for this component. A VisualElement provides a common
             * interface to renderer-specific APIs (ie DOM/Three.js etc) as well as
             * providing a way of rendering to these APIs outside of the React render loop
             * for more performant animations and interactions
             */ context.visualElement = (0, $6HPvO.useVisualElement)(Component, visualState, props, createVisualElement);
            /**
             * Load Motion gesture and animation features. These are rendered as renderless
             * components so each feature can optionally make use of React lifecycle methods.
             *
             * TODO: The intention is to move these away from a React-centric to a
             * VisualElement-centric lifecycle scheme.
             */ features = (0, $2P9jZ.useFeatures)(props, context.visualElement, preloadedFeatures);
        }
        /**
         * The mount order and hierarchy is specific to ensure our element ref
         * is hydrated by the time features fire their effects.
         */ return $gJYWc.createElement($gJYWc.Fragment, null, $gJYWc.createElement((0, $cq6iL.MotionContext).Provider, {
            value: context
        }, useRender(Component, props, (0, $ZvuE2.useMotionRef)(visualState, context.visualElement, externalRef), visualState, isStatic)), features);
    }
    return (0, $gJYWc.forwardRef)(MotionComponent);
}

});
parcelRegister("2P9jZ", function(module, exports) {

$parcel$export(module.exports, "useFeatures", function () { return $20e7933f009eb7e5$export$4a39035bacc4ed76; });

var $66bGh = parcelRequire("66bGh");

var $gJYWc = parcelRequire("gJYWc");

var $kdkxk = parcelRequire("kdkxk");
parcelRequire("739Hg");

var $i8mvm = parcelRequire("i8mvm");
var $20e7933f009eb7e5$var$featureNames = Object.keys((0, $kdkxk.featureDefinitions));
var $20e7933f009eb7e5$var$numFeatures = $20e7933f009eb7e5$var$featureNames.length;
/**
 * Load features via renderless components based on the provided MotionProps.
 */ function $20e7933f009eb7e5$export$4a39035bacc4ed76(props, visualElement, preloadedFeatures) {
    var features = [];
    var lazyContext = (0, $gJYWc.useContext)((0, $i8mvm.LazyContext));
    if (!visualElement) return null;
    for(var i = 0; i < $20e7933f009eb7e5$var$numFeatures; i++){
        var name_1 = $20e7933f009eb7e5$var$featureNames[i];
        var _a = (0, $kdkxk.featureDefinitions)[name_1], isEnabled = _a.isEnabled, Component = _a.Component;
        /**
         * It might be possible in the future to use this moment to
         * dynamically request functionality. In initial tests this
         * was producing a lot of duplication amongst bundles.
         */ if (isEnabled(props) && Component) features.push($gJYWc.createElement(Component, (0, $66bGh.__assign)({
            key: name_1
        }, props, {
            visualElement: visualElement
        })));
    }
    return features;
}

});
parcelRegister("kdkxk", function(module, exports) {

$parcel$export(module.exports, "featureDefinitions", function () { return $eb74f3afe514b49e$export$65570e08d843624d; });
$parcel$export(module.exports, "loadFeatures", function () { return $eb74f3afe514b49e$export$449561ec5703cdc8; });
var $eb74f3afe514b49e$var$createDefinition = function(propNames) {
    return {
        isEnabled: function(props) {
            return propNames.some(function(name) {
                return !!props[name];
            });
        }
    };
};
var $eb74f3afe514b49e$export$65570e08d843624d = {
    measureLayout: $eb74f3afe514b49e$var$createDefinition([
        "layout",
        "layoutId",
        "drag",
        "_layoutResetTransform"
    ]),
    animation: $eb74f3afe514b49e$var$createDefinition([
        "animate",
        "exit",
        "variants",
        "whileHover",
        "whileTap",
        "whileFocus",
        "whileDrag"
    ]),
    exit: $eb74f3afe514b49e$var$createDefinition([
        "exit"
    ]),
    drag: $eb74f3afe514b49e$var$createDefinition([
        "drag",
        "dragControls"
    ]),
    focus: $eb74f3afe514b49e$var$createDefinition([
        "whileFocus"
    ]),
    hover: $eb74f3afe514b49e$var$createDefinition([
        "whileHover",
        "onHoverStart",
        "onHoverEnd"
    ]),
    tap: $eb74f3afe514b49e$var$createDefinition([
        "whileTap",
        "onTap",
        "onTapStart",
        "onTapCancel"
    ]),
    pan: $eb74f3afe514b49e$var$createDefinition([
        "onPan",
        "onPanStart",
        "onPanSessionStart",
        "onPanEnd"
    ]),
    layoutAnimation: $eb74f3afe514b49e$var$createDefinition([
        "layout",
        "layoutId"
    ])
};
function $eb74f3afe514b49e$export$449561ec5703cdc8(features) {
    for(var key in features){
        var Component = features[key];
        if (Component !== null) $eb74f3afe514b49e$export$65570e08d843624d[key].Component = Component;
    }
}

});

parcelRegister("739Hg", function(module, exports) {

$parcel$export(module.exports, "warning", function () { return $522055c857ff8b6f$export$491112666e282270; });
$parcel$export(module.exports, "invariant", function () { return $522055c857ff8b6f$export$f5708dca728d7177; });
var $522055c857ff8b6f$export$491112666e282270 = function() {};
var $522055c857ff8b6f$export$f5708dca728d7177 = function() {};

});

parcelRegister("i8mvm", function(module, exports) {

$parcel$export(module.exports, "LazyContext", function () { return $d33a6e5c9be9ee21$export$40f10139ecf1f171; });

var $gJYWc = parcelRequire("gJYWc");
var $d33a6e5c9be9ee21$export$40f10139ecf1f171 = (0, $gJYWc.createContext)({
    strict: false
});

});


parcelRegister("cUvlw", function(module, exports) {

$parcel$export(module.exports, "MotionConfigContext", function () { return $966307adda44c3a1$export$22a697fb29aac98d; });

var $gJYWc = parcelRequire("gJYWc");
/**
 * @public
 */ var $966307adda44c3a1$export$22a697fb29aac98d = (0, $gJYWc.createContext)({
    transformPagePoint: function(p) {
        return p;
    },
    isStatic: false
});

});

parcelRegister("cq6iL", function(module, exports) {

$parcel$export(module.exports, "MotionContext", function () { return $90accd1dc933e297$export$2285bbca2c666415; });
$parcel$export(module.exports, "useVisualElementContext", function () { return $90accd1dc933e297$export$cd995842eb2ab956; });

var $gJYWc = parcelRequire("gJYWc");
var $90accd1dc933e297$export$2285bbca2c666415 = (0, $gJYWc.createContext)({});
function $90accd1dc933e297$export$cd995842eb2ab956() {
    return (0, $gJYWc.useContext)($90accd1dc933e297$export$2285bbca2c666415).visualElement;
}

});

parcelRegister("6HPvO", function(module, exports) {

$parcel$export(module.exports, "useVisualElement", function () { return $01428f588d260bac$export$dc0335d73ab0b115; });

var $66bGh = parcelRequire("66bGh");

var $gJYWc = parcelRequire("gJYWc");

var $1CTTQ = parcelRequire("1CTTQ");

var $dUQA6 = parcelRequire("dUQA6");

var $jLcRD = parcelRequire("jLcRD");

var $cq6iL = parcelRequire("cq6iL");

var $bG9er = parcelRequire("bG9er");

var $cUvlw = parcelRequire("cUvlw");

var $i8mvm = parcelRequire("i8mvm");
function $01428f588d260bac$var$useLayoutId(_a) {
    var layoutId = _a.layoutId;
    var layoutGroupId = (0, $gJYWc.useContext)((0, $jLcRD.LayoutGroupContext));
    return layoutGroupId && layoutId !== undefined ? layoutGroupId + "-" + layoutId : layoutId;
}
function $01428f588d260bac$export$dc0335d73ab0b115(Component, visualState, props, createVisualElement) {
    var config = (0, $gJYWc.useContext)((0, $cUvlw.MotionConfigContext));
    var lazyContext = (0, $gJYWc.useContext)((0, $i8mvm.LazyContext));
    var parent = (0, $cq6iL.useVisualElementContext)();
    var presenceContext = (0, $gJYWc.useContext)((0, $1CTTQ.PresenceContext));
    var layoutId = $01428f588d260bac$var$useLayoutId(props);
    var visualElementRef = (0, $gJYWc.useRef)(undefined);
    /**
     * If we haven't preloaded a renderer, check to see if we have one lazy-loaded
     */ if (!createVisualElement) createVisualElement = lazyContext.renderer;
    if (!visualElementRef.current && createVisualElement) visualElementRef.current = createVisualElement(Component, {
        visualState: visualState,
        parent: parent,
        props: (0, $66bGh.__assign)((0, $66bGh.__assign)({}, props), {
            layoutId: layoutId
        }),
        presenceId: presenceContext === null || presenceContext === void 0 ? void 0 : presenceContext.id,
        blockInitialAnimation: (presenceContext === null || presenceContext === void 0 ? void 0 : presenceContext.initial) === false
    });
    var visualElement = visualElementRef.current;
    (0, $bG9er.useIsomorphicLayoutEffect)(function() {
        if (!visualElement) return;
        visualElement.setProps((0, $66bGh.__assign)((0, $66bGh.__assign)((0, $66bGh.__assign)({}, config), props), {
            layoutId: layoutId
        }));
        visualElement.isPresent = (0, $dUQA6.isPresent)(presenceContext);
        visualElement.isPresenceRoot = !parent || parent.presenceId !== (presenceContext === null || presenceContext === void 0 ? void 0 : presenceContext.id);
        /**
         * Fire a render to ensure the latest state is reflected on-screen.
         */ visualElement.syncRender();
    });
    (0, $gJYWc.useEffect)(function() {
        var _a;
        if (!visualElement) return;
        /**
         * In a future refactor we can replace the features-as-components and
         * have this loop through them all firing "effect" listeners
         */ (_a = visualElement.animationState) === null || _a === void 0 || _a.animateChanges();
    });
    (0, $bG9er.useIsomorphicLayoutEffect)(function() {
        return function() {
            return visualElement === null || visualElement === void 0 ? void 0 : visualElement.notifyUnmount();
        };
    }, []);
    return visualElement;
}

});
parcelRegister("dUQA6", function(module, exports) {

$parcel$export(module.exports, "usePresence", function () { return $a2194ae04d2f94fa$export$2a8c16d82a0a0e26; });
$parcel$export(module.exports, "isPresent", function () { return $a2194ae04d2f94fa$export$ee27c052bca048fb; });

var $gJYWc = parcelRequire("gJYWc");

var $1CTTQ = parcelRequire("1CTTQ");

var $j0JMo = parcelRequire("j0JMo");
/**
 * When a component is the child of `AnimatePresence`, it can use `usePresence`
 * to access information about whether it's still present in the React tree.
 *
 * ```jsx
 * import { usePresence } from "framer-motion"
 *
 * export const Component = () => {
 *   const [isPresent, safeToRemove] = usePresence()
 *
 *   useEffect(() => {
 *     !isPresent && setTimeout(safeToRemove, 1000)
 *   }, [isPresent])
 *
 *   return <div />
 * }
 * ```
 *
 * If `isPresent` is `false`, it means that a component has been removed the tree, but
 * `AnimatePresence` won't really remove it until `safeToRemove` has been called.
 *
 * @public
 */ function $a2194ae04d2f94fa$export$2a8c16d82a0a0e26() {
    var context = (0, $gJYWc.useContext)((0, $1CTTQ.PresenceContext));
    if (context === null) return [
        true,
        null
    ];
    var isPresent = context.isPresent, onExitComplete = context.onExitComplete, register = context.register;
    // It's safe to call the following hooks conditionally (after an early return) because the context will always
    // either be null or non-null for the lifespan of the component.
    // Replace with useOpaqueId when released in React
    var id = $a2194ae04d2f94fa$var$useUniqueId();
    (0, $gJYWc.useEffect)(function() {
        return register(id);
    }, []);
    var safeToRemove = function() {
        return onExitComplete === null || onExitComplete === void 0 ? void 0 : onExitComplete(id);
    };
    return !isPresent && onExitComplete ? [
        false,
        safeToRemove
    ] : [
        true
    ];
}
/**
 * Similar to `usePresence`, except `useIsPresent` simply returns whether or not the component is present.
 * There is no `safeToRemove` function.
 *
 * ```jsx
 * import { useIsPresent } from "framer-motion"
 *
 * export const Component = () => {
 *   const isPresent = useIsPresent()
 *
 *   useEffect(() => {
 *     !isPresent && console.log("I've been removed!")
 *   }, [isPresent])
 *
 *   return <div />
 * }
 * ```
 *
 * @public
 */ function $a2194ae04d2f94fa$export$8249053f690ea39a() {
    return $a2194ae04d2f94fa$export$ee27c052bca048fb((0, $gJYWc.useContext)((0, $1CTTQ.PresenceContext)));
}
function $a2194ae04d2f94fa$export$ee27c052bca048fb(context) {
    return context === null ? true : context.isPresent;
}
var $a2194ae04d2f94fa$var$counter = 0;
var $a2194ae04d2f94fa$var$incrementId = function() {
    return $a2194ae04d2f94fa$var$counter++;
};
var $a2194ae04d2f94fa$var$useUniqueId = function() {
    return (0, $j0JMo.useConstant)($a2194ae04d2f94fa$var$incrementId);
};

});

parcelRegister("jLcRD", function(module, exports) {

$parcel$export(module.exports, "LayoutGroupContext", function () { return $e62c62a3db91f0dc$export$a3579ca508007a95; });

var $gJYWc = parcelRequire("gJYWc");
/**
 * @internal
 */ var $e62c62a3db91f0dc$export$a3579ca508007a95 = (0, $gJYWc.createContext)(null);

});

parcelRegister("bG9er", function(module, exports) {

$parcel$export(module.exports, "useIsomorphicLayoutEffect", function () { return $880ac73b2f56d4dc$export$700979bc83e7db82; });

var $gJYWc = parcelRequire("gJYWc");

var $4qLKY = parcelRequire("4qLKY");
var $880ac73b2f56d4dc$export$700979bc83e7db82 = (0, $4qLKY.isBrowser) ? (0, $gJYWc.useLayoutEffect) : (0, $gJYWc.useEffect);

});
parcelRegister("4qLKY", function(module, exports) {

$parcel$export(module.exports, "isBrowser", function () { return $339ea2996e788c97$export$4e09c449d6c407f7; });
var $339ea2996e788c97$export$4e09c449d6c407f7 = typeof window !== "undefined";

});



parcelRegister("ZvuE2", function(module, exports) {

$parcel$export(module.exports, "useMotionRef", function () { return $0b8e20870bbccf1c$export$c684914703d321fd; });

var $gJYWc = parcelRequire("gJYWc");

var $ixxQP = parcelRequire("ixxQP");
/**
 * Creates a ref function that, when called, hydrates the provided
 * external ref and VisualElement.
 */ function $0b8e20870bbccf1c$export$c684914703d321fd(visualState, visualElement, externalRef) {
    return (0, $gJYWc.useCallback)(function(instance) {
        var _a;
        instance && ((_a = visualState.mount) === null || _a === void 0 || _a.call(visualState, instance));
        if (visualElement) instance ? visualElement.mount(instance) : visualElement.unmount();
        if (externalRef) {
            if (typeof externalRef === "function") externalRef(instance);
            else if ((0, $ixxQP.isRefObject)(externalRef)) externalRef.current = instance;
        }
    }, /**
     * Only pass a new ref callback to React if we've received a visual element
     * factory. Otherwise we'll be mounting/remounting every time externalRef
     * or other dependencies change.
     */ [
        visualElement
    ]);
}

});
parcelRegister("ixxQP", function(module, exports) {

$parcel$export(module.exports, "isRefObject", function () { return $d7f59131cfaa9d15$export$dedd81df7bc1307; });
function $d7f59131cfaa9d15$export$dedd81df7bc1307(ref) {
    return typeof ref === "object" && Object.prototype.hasOwnProperty.call(ref, "current");
}

});


parcelRegister("7sHKP", function(module, exports) {

$parcel$export(module.exports, "useCreateMotionContext", function () { return $56ed16a3360422b6$export$c5638d843b37a176; });

var $gJYWc = parcelRequire("gJYWc");

var $cq6iL = parcelRequire("cq6iL");

var $gMhDF = parcelRequire("gMhDF");
function $56ed16a3360422b6$export$c5638d843b37a176(props, isStatic) {
    var _a = (0, $gMhDF.getCurrentTreeVariants)(props, (0, $gJYWc.useContext)((0, $cq6iL.MotionContext))), initial = _a.initial, animate = _a.animate;
    return (0, $gJYWc.useMemo)(function() {
        return {
            initial: initial,
            animate: animate
        };
    }, /**
     * Only break memoisation in static mode
     */ isStatic ? [
        $56ed16a3360422b6$var$variantLabelsAsDependency(initial),
        $56ed16a3360422b6$var$variantLabelsAsDependency(animate)
    ] : []);
}
function $56ed16a3360422b6$var$variantLabelsAsDependency(prop) {
    return Array.isArray(prop) ? prop.join(" ") : prop;
}

});
parcelRegister("gMhDF", function(module, exports) {

$parcel$export(module.exports, "getCurrentTreeVariants", function () { return $c36ecfbc30293001$export$12fc32fc096a04a3; });

var $g4bZm = parcelRequire("g4bZm");
function $c36ecfbc30293001$export$12fc32fc096a04a3(props, context) {
    if ((0, $g4bZm.checkIfControllingVariants)(props)) {
        var initial = props.initial, animate = props.animate;
        return {
            initial: initial === false || (0, $g4bZm.isVariantLabel)(initial) ? initial : undefined,
            animate: (0, $g4bZm.isVariantLabel)(animate) ? animate : undefined
        };
    }
    return props.inherit !== false ? context : {};
}

});
parcelRegister("g4bZm", function(module, exports) {

$parcel$export(module.exports, "isVariantLabels", function () { return $bb2651c36265a57c$export$562271cd22f751d; });
$parcel$export(module.exports, "isVariantLabel", function () { return $bb2651c36265a57c$export$720b90e312cea233; });
$parcel$export(module.exports, "resolveVariantFromProps", function () { return $bb2651c36265a57c$export$d68f140c4d9b48bc; });
$parcel$export(module.exports, "resolveVariant", function () { return $bb2651c36265a57c$export$7b1b1c981f4f0558; });
$parcel$export(module.exports, "checkIfControllingVariants", function () { return $bb2651c36265a57c$export$cf3a7bd331c35bf0; });
$parcel$export(module.exports, "checkIfVariantNode", function () { return $bb2651c36265a57c$export$c0eba02279c18fea; });
/**
 * Decides if the supplied variable is an array of variant labels
 */ function $bb2651c36265a57c$export$562271cd22f751d(v) {
    return Array.isArray(v);
}
/**
 * Decides if the supplied variable is variant label
 */ function $bb2651c36265a57c$export$720b90e312cea233(v) {
    return typeof v === "string" || $bb2651c36265a57c$export$562271cd22f751d(v);
}
/**
 * Creates an object containing the latest state of every MotionValue on a VisualElement
 */ function $bb2651c36265a57c$var$getCurrent(visualElement) {
    var current = {};
    visualElement.forEachValue(function(value, key) {
        return current[key] = value.get();
    });
    return current;
}
/**
 * Creates an object containing the latest velocity of every MotionValue on a VisualElement
 */ function $bb2651c36265a57c$var$getVelocity(visualElement) {
    var velocity = {};
    visualElement.forEachValue(function(value, key) {
        return velocity[key] = value.getVelocity();
    });
    return velocity;
}
function $bb2651c36265a57c$export$d68f140c4d9b48bc(props, definition, custom, currentValues, currentVelocity) {
    var _a;
    if (currentValues === void 0) currentValues = {};
    if (currentVelocity === void 0) currentVelocity = {};
    if (typeof definition === "string") definition = (_a = props.variants) === null || _a === void 0 ? void 0 : _a[definition];
    return typeof definition === "function" ? definition(custom !== null && custom !== void 0 ? custom : props.custom, currentValues, currentVelocity) : definition;
}
function $bb2651c36265a57c$export$7b1b1c981f4f0558(visualElement, definition, custom) {
    var props = visualElement.getProps();
    return $bb2651c36265a57c$export$d68f140c4d9b48bc(props, definition, custom !== null && custom !== void 0 ? custom : props.custom, $bb2651c36265a57c$var$getCurrent(visualElement), $bb2651c36265a57c$var$getVelocity(visualElement));
}
function $bb2651c36265a57c$export$cf3a7bd331c35bf0(props) {
    var _a;
    return typeof ((_a = props.animate) === null || _a === void 0 ? void 0 : _a.start) === "function" || $bb2651c36265a57c$export$720b90e312cea233(props.initial) || $bb2651c36265a57c$export$720b90e312cea233(props.animate) || $bb2651c36265a57c$export$720b90e312cea233(props.whileHover) || $bb2651c36265a57c$export$720b90e312cea233(props.whileDrag) || $bb2651c36265a57c$export$720b90e312cea233(props.whileTap) || $bb2651c36265a57c$export$720b90e312cea233(props.whileFocus) || $bb2651c36265a57c$export$720b90e312cea233(props.exit);
}
function $bb2651c36265a57c$export$c0eba02279c18fea(props) {
    return Boolean($bb2651c36265a57c$export$cf3a7bd331c35bf0(props) || props.variants);
}

});




parcelRegister("iLVgS", function(module, exports) {

$parcel$export(module.exports, "createMotionProxy", function () { return $daa90aaabe97404b$export$a28d6df673050e18; });

var $l4yeB = parcelRequire("l4yeB");
/**
 * Convert any React component into a `motion` component. The provided component
 * **must** use `React.forwardRef` to the underlying DOM component you want to animate.
 *
 * ```jsx
 * const Component = React.forwardRef((props, ref) => {
 *   return <div ref={ref} />
 * })
 *
 * const MotionComponent = motion(Component)
 * ```
 *
 * @public
 */ function $daa90aaabe97404b$export$a28d6df673050e18(createConfig) {
    function custom(Component, customMotionComponentConfig) {
        if (customMotionComponentConfig === void 0) customMotionComponentConfig = {};
        return (0, $l4yeB.createMotionComponent)(createConfig(Component, customMotionComponentConfig));
    }
    /**
     * A cache of generated `motion` components, e.g `motion.div`, `motion.input` etc.
     * Rather than generating them anew every render.
     */ var componentCache = new Map();
    return new Proxy(custom, {
        /**
         * Called when `motion` is referenced with a prop: `motion.div`, `motion.input` etc.
         * The prop name is passed through as `key` and we can use that to generate a `motion`
         * DOM component with that name.
         */ get: function(_target, key) {
            /**
             * If this element doesn't exist in the component cache, create it and cache.
             */ if (!componentCache.has(key)) componentCache.set(key, custom(key));
            return componentCache.get(key);
        }
    });
}

});

parcelRegister("5TNuT", function(module, exports) {

$parcel$export(module.exports, "createDomMotionConfig", function () { return $44b87bea55a6f31d$export$732916c0e88175fb; });

var $66bGh = parcelRequire("66bGh");

var $htvfJ = parcelRequire("htvfJ");

var $2DXJI = parcelRequire("2DXJI");

var $8LxlJ = parcelRequire("8LxlJ");

var $3RVwR = parcelRequire("3RVwR");
function $44b87bea55a6f31d$export$732916c0e88175fb(Component, _a, preloadedFeatures, createVisualElement) {
    var _b = _a.forwardMotionProps, forwardMotionProps = _b === void 0 ? false : _b;
    var baseConfig = (0, $htvfJ.isSVGComponent)(Component) ? (0, $8LxlJ.svgMotionConfig) : (0, $3RVwR.htmlMotionConfig);
    return (0, $66bGh.__assign)((0, $66bGh.__assign)({}, baseConfig), {
        preloadedFeatures: preloadedFeatures,
        useRender: (0, $2DXJI.createUseRender)(forwardMotionProps),
        createVisualElement: createVisualElement,
        Component: Component
    });
}

});
parcelRegister("htvfJ", function(module, exports) {

$parcel$export(module.exports, "isSVGComponent", function () { return $cb8d633e0d6b65b8$export$88f3fc2fd3766989; });

var $jHvjL = parcelRequire("jHvjL");
function $cb8d633e0d6b65b8$export$88f3fc2fd3766989(Component) {
    if (/**
     * If it's not a string, it's a custom React component. Currently we only support
     * HTML custom React components.
     */ typeof Component !== "string" || /**
         * If it contains a dash, the element is a custom HTML webcomponent.
         */ Component.includes("-")) return false;
    else if (/**
     * If it's in our list of lowercase SVG tags, it's an SVG component
     */ (0, $jHvjL.lowercaseSVGElements).indexOf(Component) > -1 || /**
         * If it contains a capital letter, it's an SVG component
         */ /[A-Z]/.test(Component)) return true;
    return false;
}

});
parcelRegister("jHvjL", function(module, exports) {

$parcel$export(module.exports, "lowercaseSVGElements", function () { return $e57a538904b466b1$export$40209c4c512158e6; });
/**
 * We keep these listed seperately as we use the lowercase tag names as part
 * of the runtime bundle to detect SVG components
 */ var $e57a538904b466b1$export$40209c4c512158e6 = [
    "animate",
    "circle",
    "defs",
    "desc",
    "ellipse",
    "g",
    "image",
    "line",
    "filter",
    "marker",
    "mask",
    "metadata",
    "path",
    "pattern",
    "polygon",
    "polyline",
    "rect",
    "stop",
    "svg",
    "switch",
    "symbol",
    "text",
    "tspan",
    "use",
    "view"
];

});


parcelRegister("2DXJI", function(module, exports) {

$parcel$export(module.exports, "createUseRender", function () { return $1ecd8fa9298c8c38$export$5d29104eefd89cc8; });

var $66bGh = parcelRequire("66bGh");

var $gJYWc = parcelRequire("gJYWc");

var $d5GCf = parcelRequire("d5GCf");

var $9FGVB = parcelRequire("9FGVB");

var $htvfJ = parcelRequire("htvfJ");

var $iyIDB = parcelRequire("iyIDB");
function $1ecd8fa9298c8c38$export$5d29104eefd89cc8(forwardMotionProps) {
    if (forwardMotionProps === void 0) forwardMotionProps = false;
    var useRender = function(Component, props, ref, _a, isStatic) {
        var latestValues = _a.latestValues;
        var useVisualProps = (0, $htvfJ.isSVGComponent)(Component) ? (0, $iyIDB.useSVGProps) : (0, $d5GCf.useHTMLProps);
        var visualProps = useVisualProps(props, latestValues, isStatic);
        var filteredProps = (0, $9FGVB.filterProps)(props, typeof Component === "string", forwardMotionProps);
        var elementProps = (0, $66bGh.__assign)((0, $66bGh.__assign)((0, $66bGh.__assign)({}, filteredProps), visualProps), {
            ref: ref
        });
        return (0, $gJYWc.createElement)(Component, elementProps);
    };
    return useRender;
}

});
parcelRegister("d5GCf", function(module, exports) {

$parcel$export(module.exports, "copyRawValuesOnly", function () { return $987ccca0f04afeee$export$40dafdb8630c956b; });
$parcel$export(module.exports, "useHTMLProps", function () { return $987ccca0f04afeee$export$57be0a314572d87d; });

var $66bGh = parcelRequire("66bGh");

var $gJYWc = parcelRequire("gJYWc");

var $kGZoz = parcelRequire("kGZoz");

var $a3Km2 = parcelRequire("a3Km2");

var $68PBy = parcelRequire("68PBy");

var $bKWYX = parcelRequire("bKWYX");
function $987ccca0f04afeee$export$40dafdb8630c956b(target, source, props) {
    for(var key in source)if (!(0, $a3Km2.isMotionValue)(source[key]) && !(0, $kGZoz.isForcedMotionValue)(key, props)) target[key] = source[key];
}
function $987ccca0f04afeee$var$useInitialMotionValues(_a, visualState, isStatic) {
    var transformTemplate = _a.transformTemplate;
    return (0, $gJYWc.useMemo)(function() {
        var state = (0, $bKWYX.createHtmlRenderState)();
        (0, $68PBy.buildHTMLStyles)(state, visualState, undefined, undefined, {
            enableHardwareAcceleration: !isStatic
        }, transformTemplate);
        var vars = state.vars, style = state.style;
        return (0, $66bGh.__assign)((0, $66bGh.__assign)({}, vars), style);
    }, [
        visualState
    ]);
}
function $987ccca0f04afeee$export$72c85e333541e7f(props, visualState, isStatic) {
    var styleProp = props.style || {};
    var style = {};
    /**
     * Copy non-Motion Values straight into style
     */ $987ccca0f04afeee$export$40dafdb8630c956b(style, styleProp, props);
    Object.assign(style, $987ccca0f04afeee$var$useInitialMotionValues(props, visualState, isStatic));
    if (props.transformValues) style = props.transformValues(style);
    return style;
}
function $987ccca0f04afeee$export$57be0a314572d87d(props, visualState, isStatic) {
    // The `any` isn't ideal but it is the type of createElement props argument
    var htmlProps = {};
    var style = $987ccca0f04afeee$export$72c85e333541e7f(props, visualState, isStatic);
    if (Boolean(props.drag)) {
        // Disable the ghost element when a user drags
        htmlProps.draggable = false;
        // Disable text selection
        style.userSelect = style.WebkitUserSelect = style.WebkitTouchCallout = "none";
        // Disable scrolling on the draggable direction
        style.touchAction = props.drag === true ? "none" : "pan-" + (props.drag === "x" ? "y" : "x");
    }
    htmlProps.style = style;
    return htmlProps;
}

});
parcelRegister("kGZoz", function(module, exports) {

$parcel$export(module.exports, "isForcedMotionValue", function () { return $f1075ab67951482b$export$6d27ce8e3de1c3cf; });

var $c9NBR = parcelRequire("c9NBR");

var $wmU9r = parcelRequire("wmU9r");
function $f1075ab67951482b$export$6d27ce8e3de1c3cf(key, _a) {
    var layout = _a.layout, layoutId = _a.layoutId;
    return (0, $wmU9r.isTransformProp)(key) || (0, $wmU9r.isTransformOriginProp)(key) || (layout || layoutId !== undefined) && (!!(0, $c9NBR.valueScaleCorrection)[key] || key === "opacity");
}

});
parcelRegister("c9NBR", function(module, exports) {

$parcel$export(module.exports, "valueScaleCorrection", function () { return $8d9ccec07e2dff91$export$d57fad728466ad75; });
$parcel$export(module.exports, "addScaleCorrection", function () { return $8d9ccec07e2dff91$export$2cba7fcde4b7b2d5; });
var $8d9ccec07e2dff91$export$d57fad728466ad75 = {};
/**
 * @internal
 */ function $8d9ccec07e2dff91$export$2cba7fcde4b7b2d5(correctors) {
    for(var key in correctors)$8d9ccec07e2dff91$export$d57fad728466ad75[key] = correctors[key];
}

});

parcelRegister("wmU9r", function(module, exports) {

$parcel$export(module.exports, "transformProps", function () { return $0614c1a9d0a8787c$export$7b42a0094fb00b6e; });
$parcel$export(module.exports, "sortTransformProps", function () { return $0614c1a9d0a8787c$export$61f68472e7973485; });
$parcel$export(module.exports, "isTransformProp", function () { return $0614c1a9d0a8787c$export$15240a8a4379d8de; });
$parcel$export(module.exports, "isTransformOriginProp", function () { return $0614c1a9d0a8787c$export$91fe49ee9d172523; });
/**
 * A list of all transformable axes. We'll use this list to generated a version
 * of each axes for each transform.
 */ var $0614c1a9d0a8787c$export$67cd428da31419e1 = [
    "",
    "X",
    "Y",
    "Z"
];
/**
 * An ordered array of each transformable value. By default, transform values
 * will be sorted to this order.
 */ var $0614c1a9d0a8787c$var$order = [
    "translate",
    "scale",
    "rotate",
    "skew"
];
/**
 * Generate a list of every possible transform key.
 */ var $0614c1a9d0a8787c$export$7b42a0094fb00b6e = [
    "transformPerspective",
    "x",
    "y",
    "z"
];
$0614c1a9d0a8787c$var$order.forEach(function(operationKey) {
    return $0614c1a9d0a8787c$export$67cd428da31419e1.forEach(function(axesKey) {
        return $0614c1a9d0a8787c$export$7b42a0094fb00b6e.push(operationKey + axesKey);
    });
});
/**
 * A function to use with Array.sort to sort transform keys by their default order.
 */ function $0614c1a9d0a8787c$export$61f68472e7973485(a, b) {
    return $0614c1a9d0a8787c$export$7b42a0094fb00b6e.indexOf(a) - $0614c1a9d0a8787c$export$7b42a0094fb00b6e.indexOf(b);
}
/**
 * A quick lookup for transform props.
 */ var $0614c1a9d0a8787c$var$transformPropSet = new Set($0614c1a9d0a8787c$export$7b42a0094fb00b6e);
function $0614c1a9d0a8787c$export$15240a8a4379d8de(key) {
    return $0614c1a9d0a8787c$var$transformPropSet.has(key);
}
/**
 * A quick lookup for transform origin props
 */ var $0614c1a9d0a8787c$var$transformOriginProps = new Set([
    "originX",
    "originY",
    "originZ"
]);
function $0614c1a9d0a8787c$export$91fe49ee9d172523(key) {
    return $0614c1a9d0a8787c$var$transformOriginProps.has(key);
}

});


parcelRegister("a3Km2", function(module, exports) {

$parcel$export(module.exports, "isMotionValue", function () { return $752e243fb2e09829$export$605d60a2578142d3; });
var $752e243fb2e09829$export$605d60a2578142d3 = function(value) {
    return value !== null && typeof value === "object" && value.getVelocity;
};

});

parcelRegister("68PBy", function(module, exports) {

$parcel$export(module.exports, "buildHTMLStyles", function () { return $478b850f7e8eb72e$export$bb517f8b40f8e99d; });

var $c9NBR = parcelRequire("c9NBR");

var $fpg54 = parcelRequire("fpg54");

var $cHiBe = parcelRequire("cHiBe");

var $wmU9r = parcelRequire("wmU9r");

var $8LGZw = parcelRequire("8LGZw");

var $5qVHO = parcelRequire("5qVHO");
function $478b850f7e8eb72e$export$bb517f8b40f8e99d(state, latestValues, projection, layoutState, options, transformTemplate, buildProjectionTransform, buildProjectionTransformOrigin) {
    var _a;
    var style = state.style, vars = state.vars, transform = state.transform, transformKeys = state.transformKeys, transformOrigin = state.transformOrigin;
    // Empty the transformKeys array. As we're throwing out refs to its items
    // this might not be as cheap as suspected. Maybe using the array as a buffer
    // with a manual incrementation would be better.
    transformKeys.length = 0;
    // Track whether we encounter any transform or transformOrigin values.
    var hasTransform = false;
    var hasTransformOrigin = false;
    // Does the calculated transform essentially equal "none"?
    var transformIsNone = true;
    /**
     * Loop over all our latest animated values and decide whether to handle them
     * as a style or CSS variable.
     *
     * Transforms and transform origins are kept seperately for further processing.
     */ for(var key in latestValues){
        var value = latestValues[key];
        /**
         * If this is a CSS variable we don't do any further processing.
         */ if ((0, $cHiBe.isCSSVariable)(key)) {
            vars[key] = value;
            continue;
        }
        // Convert the value to its default value type, ie 0 -> "0px"
        var valueType = (0, $5qVHO.numberValueTypes)[key];
        var valueAsType = (0, $8LGZw.getValueAsType)(value, valueType);
        if ((0, $wmU9r.isTransformProp)(key)) {
            // If this is a transform, flag to enable further transform processing
            hasTransform = true;
            transform[key] = valueAsType;
            transformKeys.push(key);
            // If we already know we have a non-default transform, early return
            if (!transformIsNone) continue;
            // Otherwise check to see if this is a default transform
            if (value !== ((_a = valueType.default) !== null && _a !== void 0 ? _a : 0)) transformIsNone = false;
        } else if ((0, $wmU9r.isTransformOriginProp)(key)) {
            transformOrigin[key] = valueAsType;
            // If this is a transform origin, flag and enable further transform-origin processing
            hasTransformOrigin = true;
        } else /**
             * If layout projection is on, and we need to perform scale correction for this
             * value type, perform it.
             */ if ((projection === null || projection === void 0 ? void 0 : projection.isHydrated) && (layoutState === null || layoutState === void 0 ? void 0 : layoutState.isHydrated) && (0, $c9NBR.valueScaleCorrection)[key]) {
            var correctedValue = (0, $c9NBR.valueScaleCorrection)[key].process(value, layoutState, projection);
            /**
                 * Scale-correctable values can define a number of other values to break
                 * down into. For instance borderRadius needs applying to borderBottomLeftRadius etc
                 */ var applyTo = (0, $c9NBR.valueScaleCorrection)[key].applyTo;
            if (applyTo) {
                var num = applyTo.length;
                for(var i = 0; i < num; i++)style[applyTo[i]] = correctedValue;
            } else style[key] = correctedValue;
        } else style[key] = valueAsType;
    }
    if (layoutState && projection && buildProjectionTransform && buildProjectionTransformOrigin) {
        style.transform = buildProjectionTransform(layoutState.deltaFinal, layoutState.treeScale, hasTransform ? transform : undefined);
        if (transformTemplate) style.transform = transformTemplate(transform, style.transform);
        style.transformOrigin = buildProjectionTransformOrigin(layoutState);
    } else {
        if (hasTransform) style.transform = (0, $fpg54.buildTransform)(state, options, transformIsNone, transformTemplate);
        if (hasTransformOrigin) style.transformOrigin = (0, $fpg54.buildTransformOrigin)(transformOrigin);
    }
}

});
parcelRegister("fpg54", function(module, exports) {

$parcel$export(module.exports, "buildTransform", function () { return $b375aa259d043c9d$export$bdc96e0d5c8f914; });
$parcel$export(module.exports, "buildTransformOrigin", function () { return $b375aa259d043c9d$export$22d2fbf39767d07a; });

var $wmU9r = parcelRequire("wmU9r");
var $b375aa259d043c9d$var$translateAlias = {
    x: "translateX",
    y: "translateY",
    z: "translateZ",
    transformPerspective: "perspective"
};
/**
 * Build a CSS transform style from individual x/y/scale etc properties.
 *
 * This outputs with a default order of transforms/scales/rotations, this can be customised by
 * providing a transformTemplate function.
 */ function $b375aa259d043c9d$export$bdc96e0d5c8f914(_a, _b, transformIsDefault, transformTemplate) {
    var transform = _a.transform, transformKeys = _a.transformKeys;
    var _c = _b.enableHardwareAcceleration, enableHardwareAcceleration = _c === void 0 ? true : _c, _d = _b.allowTransformNone, allowTransformNone = _d === void 0 ? true : _d;
    // The transform string we're going to build into.
    var transformString = "";
    // Transform keys into their default order - this will determine the output order.
    transformKeys.sort((0, $wmU9r.sortTransformProps));
    // Track whether the defined transform has a defined z so we don't add a
    // second to enable hardware acceleration
    var transformHasZ = false;
    // Loop over each transform and build them into transformString
    var numTransformKeys = transformKeys.length;
    for(var i = 0; i < numTransformKeys; i++){
        var key = transformKeys[i];
        transformString += ($b375aa259d043c9d$var$translateAlias[key] || key) + "(" + transform[key] + ") ";
        if (key === "z") transformHasZ = true;
    }
    if (!transformHasZ && enableHardwareAcceleration) transformString += "translateZ(0)";
    else transformString = transformString.trim();
    // If we have a custom `transform` template, pass our transform values and
    // generated transformString to that before returning
    if (transformTemplate) transformString = transformTemplate(transform, transformIsDefault ? "" : transformString);
    else if (allowTransformNone && transformIsDefault) transformString = "none";
    return transformString;
}
/**
 * Build a transformOrigin style. Uses the same defaults as the browser for
 * undefined origins.
 */ function $b375aa259d043c9d$export$22d2fbf39767d07a(_a) {
    var _b = _a.originX, originX = _b === void 0 ? "50%" : _b, _c = _a.originY, originY = _c === void 0 ? "50%" : _c, _d = _a.originZ, originZ = _d === void 0 ? 0 : _d;
    return originX + " " + originY + " " + originZ;
}

});

parcelRegister("cHiBe", function(module, exports) {

$parcel$export(module.exports, "isCSSVariable", function () { return $93e7edabd7638a65$export$451bc42768436155; });
/**
 * Returns true if the provided key is a CSS variable
 */ function $93e7edabd7638a65$export$451bc42768436155(key) {
    return key.startsWith("--");
}

});

parcelRegister("8LGZw", function(module, exports) {

$parcel$export(module.exports, "getValueAsType", function () { return $66240fb45c728525$export$453ef540a9a1bd6b; });
/**
 * Provided a value and a ValueType, returns the value as that value type.
 */ var $66240fb45c728525$export$453ef540a9a1bd6b = function(value, type) {
    return type && typeof value === "number" ? type.transform(value) : value;
};

});

parcelRegister("5qVHO", function(module, exports) {

$parcel$export(module.exports, "numberValueTypes", function () { return $3f4c2499852becc5$export$eec14432cd1cb67b; });

var $5M3DJ = parcelRequire("5M3DJ");
var $4B3zo = parcelRequire("4B3zo");

var $fUn0O = parcelRequire("fUn0O");
var $3f4c2499852becc5$export$eec14432cd1cb67b = {
    // Border props
    borderWidth: (0, $4B3zo.px),
    borderTopWidth: (0, $4B3zo.px),
    borderRightWidth: (0, $4B3zo.px),
    borderBottomWidth: (0, $4B3zo.px),
    borderLeftWidth: (0, $4B3zo.px),
    borderRadius: (0, $4B3zo.px),
    radius: (0, $4B3zo.px),
    borderTopLeftRadius: (0, $4B3zo.px),
    borderTopRightRadius: (0, $4B3zo.px),
    borderBottomRightRadius: (0, $4B3zo.px),
    borderBottomLeftRadius: (0, $4B3zo.px),
    // Positioning props
    width: (0, $4B3zo.px),
    maxWidth: (0, $4B3zo.px),
    height: (0, $4B3zo.px),
    maxHeight: (0, $4B3zo.px),
    size: (0, $4B3zo.px),
    top: (0, $4B3zo.px),
    right: (0, $4B3zo.px),
    bottom: (0, $4B3zo.px),
    left: (0, $4B3zo.px),
    // Spacing props
    padding: (0, $4B3zo.px),
    paddingTop: (0, $4B3zo.px),
    paddingRight: (0, $4B3zo.px),
    paddingBottom: (0, $4B3zo.px),
    paddingLeft: (0, $4B3zo.px),
    margin: (0, $4B3zo.px),
    marginTop: (0, $4B3zo.px),
    marginRight: (0, $4B3zo.px),
    marginBottom: (0, $4B3zo.px),
    marginLeft: (0, $4B3zo.px),
    // Transform props
    rotate: (0, $4B3zo.degrees),
    rotateX: (0, $4B3zo.degrees),
    rotateY: (0, $4B3zo.degrees),
    rotateZ: (0, $4B3zo.degrees),
    scale: (0, $5M3DJ.scale),
    scaleX: (0, $5M3DJ.scale),
    scaleY: (0, $5M3DJ.scale),
    scaleZ: (0, $5M3DJ.scale),
    skew: (0, $4B3zo.degrees),
    skewX: (0, $4B3zo.degrees),
    skewY: (0, $4B3zo.degrees),
    distance: (0, $4B3zo.px),
    translateX: (0, $4B3zo.px),
    translateY: (0, $4B3zo.px),
    translateZ: (0, $4B3zo.px),
    x: (0, $4B3zo.px),
    y: (0, $4B3zo.px),
    z: (0, $4B3zo.px),
    perspective: (0, $4B3zo.px),
    transformPerspective: (0, $4B3zo.px),
    opacity: (0, $5M3DJ.alpha),
    originX: (0, $4B3zo.progressPercentage),
    originY: (0, $4B3zo.progressPercentage),
    originZ: (0, $4B3zo.px),
    // Misc
    zIndex: (0, $fUn0O.int),
    // SVG
    fillOpacity: (0, $5M3DJ.alpha),
    strokeOpacity: (0, $5M3DJ.alpha),
    numOctaves: (0, $fUn0O.int)
};

});
parcelRegister("5M3DJ", function(module, exports) {

$parcel$export(module.exports, "number", function () { return $4344423e5da28c99$export$98e628dec113755e; });
$parcel$export(module.exports, "alpha", function () { return $4344423e5da28c99$export$58f0f39f63f3cf42; });
$parcel$export(module.exports, "scale", function () { return $4344423e5da28c99$export$dcdf75081b88279d; });

var $66bGh = parcelRequire("66bGh");

var $6YHRg = parcelRequire("6YHRg");
var $4344423e5da28c99$export$98e628dec113755e = {
    test: function(v) {
        return typeof v === 'number';
    },
    parse: parseFloat,
    transform: function(v) {
        return v;
    }
};
var $4344423e5da28c99$export$58f0f39f63f3cf42 = (0, $66bGh.__assign)((0, $66bGh.__assign)({}, $4344423e5da28c99$export$98e628dec113755e), {
    transform: (0, $6YHRg.clamp)(0, 1)
});
var $4344423e5da28c99$export$dcdf75081b88279d = (0, $66bGh.__assign)((0, $66bGh.__assign)({}, $4344423e5da28c99$export$98e628dec113755e), {
    default: 1
});

});
parcelRegister("6YHRg", function(module, exports) {

$parcel$export(module.exports, "clamp", function () { return $514a5dfccfbe6d27$export$7d15b64cf5a3a4c4; });
$parcel$export(module.exports, "sanitize", function () { return $514a5dfccfbe6d27$export$83d2e9e3e4ee39ed; });
$parcel$export(module.exports, "floatRegex", function () { return $514a5dfccfbe6d27$export$2444ca58c08448e4; });
$parcel$export(module.exports, "colorRegex", function () { return $514a5dfccfbe6d27$export$740b69c5fad25dba; });
$parcel$export(module.exports, "singleColorRegex", function () { return $514a5dfccfbe6d27$export$ed808ff6ecd39e8d; });
$parcel$export(module.exports, "isString", function () { return $514a5dfccfbe6d27$export$844ec244b1367d54; });
var $514a5dfccfbe6d27$export$7d15b64cf5a3a4c4 = function(min, max) {
    return function(v) {
        return Math.max(Math.min(v, max), min);
    };
};
var $514a5dfccfbe6d27$export$83d2e9e3e4ee39ed = function(v) {
    return v % 1 ? Number(v.toFixed(5)) : v;
};
var $514a5dfccfbe6d27$export$2444ca58c08448e4 = /(-)?([\d]*\.?[\d])+/g;
var $514a5dfccfbe6d27$export$740b69c5fad25dba = /(#[0-9a-f]{6}|#[0-9a-f]{3}|#(?:[0-9a-f]{2}){2,4}|(rgb|hsl)a?\((-?[\d\.]+%?[,\s]+){2,3}\s*\/*\s*[\d\.]+%?\))/gi;
var $514a5dfccfbe6d27$export$ed808ff6ecd39e8d = /^(#[0-9a-f]{3}|#(?:[0-9a-f]{2}){2,4}|(rgb|hsl)a?\((-?[\d\.]+%?[,\s]+){2,3}\s*\/*\s*[\d\.]+%?\))$/i;
function $514a5dfccfbe6d27$export$844ec244b1367d54(v) {
    return typeof v === 'string';
}

});


parcelRegister("4B3zo", function(module, exports) {

$parcel$export(module.exports, "degrees", function () { return $358d630657a2eb2b$export$41fc368e1a942b97; });
$parcel$export(module.exports, "percent", function () { return $358d630657a2eb2b$export$626336c2cd4b14de; });
$parcel$export(module.exports, "px", function () { return $358d630657a2eb2b$export$91c0eda1d06bf008; });
$parcel$export(module.exports, "vh", function () { return $358d630657a2eb2b$export$f91e8c45a95a32f2; });
$parcel$export(module.exports, "vw", function () { return $358d630657a2eb2b$export$aed3d7b7d206c196; });
$parcel$export(module.exports, "progressPercentage", function () { return $358d630657a2eb2b$export$44e2e1705876d7ed; });

var $66bGh = parcelRequire("66bGh");

var $6YHRg = parcelRequire("6YHRg");
var $358d630657a2eb2b$var$createUnitType = function(unit) {
    return {
        test: function(v) {
            return (0, $6YHRg.isString)(v) && v.endsWith(unit) && v.split(' ').length === 1;
        },
        parse: parseFloat,
        transform: function(v) {
            return "" + v + unit;
        }
    };
};
var $358d630657a2eb2b$export$41fc368e1a942b97 = $358d630657a2eb2b$var$createUnitType('deg');
var $358d630657a2eb2b$export$626336c2cd4b14de = $358d630657a2eb2b$var$createUnitType('%');
var $358d630657a2eb2b$export$91c0eda1d06bf008 = $358d630657a2eb2b$var$createUnitType('px');
var $358d630657a2eb2b$export$f91e8c45a95a32f2 = $358d630657a2eb2b$var$createUnitType('vh');
var $358d630657a2eb2b$export$aed3d7b7d206c196 = $358d630657a2eb2b$var$createUnitType('vw');
var $358d630657a2eb2b$export$44e2e1705876d7ed = (0, $66bGh.__assign)((0, $66bGh.__assign)({}, $358d630657a2eb2b$export$626336c2cd4b14de), {
    parse: function(v) {
        return $358d630657a2eb2b$export$626336c2cd4b14de.parse(v) / 100;
    },
    transform: function(v) {
        return $358d630657a2eb2b$export$626336c2cd4b14de.transform(v * 100);
    }
});

});

parcelRegister("fUn0O", function(module, exports) {

$parcel$export(module.exports, "int", function () { return $b94defb8bb601bd4$export$7d260a2a5f8bc19e; });

var $66bGh = parcelRequire("66bGh");

var $5M3DJ = parcelRequire("5M3DJ");
var $b94defb8bb601bd4$export$7d260a2a5f8bc19e = (0, $66bGh.__assign)((0, $66bGh.__assign)({}, (0, $5M3DJ.number)), {
    transform: Math.round
});

});



parcelRegister("bKWYX", function(module, exports) {

$parcel$export(module.exports, "createHtmlRenderState", function () { return $88f1be39a3ae3de3$export$8940b483cf52eeda; });
var $88f1be39a3ae3de3$export$8940b483cf52eeda = function() {
    return {
        style: {},
        transform: {},
        transformKeys: [],
        transformOrigin: {},
        vars: {}
    };
};

});


parcelRegister("9FGVB", function(module, exports) {

$parcel$export(module.exports, "filterProps", function () { return $70a93e022ee7d8c6$export$d697c39a2985a4c; });

var $8SU90 = parcelRequire("8SU90");
var $70a93e022ee7d8c6$var$shouldForward = function(key) {
    return !(0, $8SU90.isValidMotionProp)(key);
};

/**
 * Emotion and Styled Components both allow users to pass through arbitrary props to their components
 * to dynamically generate CSS. They both use the `@emotion/is-prop-valid` package to determine which
 * of these should be passed to the underlying DOM node.
 *
 * However, when styling a Motion component `styled(motion.div)`, both packages pass through *all* props
 * as it's seen as an arbitrary component rather than a DOM node. Motion only allows arbitrary props
 * passed through the `custom` prop so it doesn't *need* the payload or computational overhead of
 * `@emotion/is-prop-valid`, however to fix this problem we need to use it.
 *
 * By making it an optionalDependency we can offer this functionality only in the situations where it's
 * actually required.
 */ try {
    var $70a93e022ee7d8c6$var$emotionIsPropValid_1 = (parcelRequire("8cItv")).default;
    $70a93e022ee7d8c6$var$shouldForward = function(key) {
        // Handle events explicitly as Emotion validates them all as true
        if (key.startsWith("on")) return !(0, $8SU90.isValidMotionProp)(key);
        else return $70a93e022ee7d8c6$var$emotionIsPropValid_1(key);
    };
} catch (_a) {
// We don't need to actually do anything here - the fallback is the existing `isPropValid`.
}
function $70a93e022ee7d8c6$export$d697c39a2985a4c(props, isDom, forwardMotionProps) {
    var filteredProps = {};
    for(var key in props)if ($70a93e022ee7d8c6$var$shouldForward(key) || forwardMotionProps === true && (0, $8SU90.isValidMotionProp)(key) || !isDom && !(0, $8SU90.isValidMotionProp)(key)) filteredProps[key] = props[key];
    return filteredProps;
}

});
parcelRegister("8SU90", function(module, exports) {

$parcel$export(module.exports, "isValidMotionProp", function () { return $677eeaf9e0fb9167$export$2f9c46555243bf04; });
/**
 * A list of all valid MotionProps.
 *
 * @internalremarks
 * This doesn't throw if a `MotionProp` name is missing - it should.
 */ var $677eeaf9e0fb9167$var$validMotionProps = new Set([
    "initial",
    "animate",
    "exit",
    "style",
    "variants",
    "transition",
    "transformTemplate",
    "transformValues",
    "custom",
    "inherit",
    "layout",
    "layoutId",
    "_layoutResetTransform",
    "onLayoutAnimationComplete",
    "onViewportBoxUpdate",
    "onLayoutMeasure",
    "onBeforeLayoutMeasure",
    "onAnimationStart",
    "onAnimationComplete",
    "onUpdate",
    "onDragStart",
    "onDrag",
    "onDragEnd",
    "onMeasureDragConstraints",
    "onDirectionLock",
    "onDragTransitionEnd",
    "drag",
    "dragControls",
    "dragListener",
    "dragConstraints",
    "dragDirectionLock",
    "_dragX",
    "_dragY",
    "dragElastic",
    "dragMomentum",
    "dragPropagation",
    "dragTransition",
    "whileDrag",
    "onPan",
    "onPanStart",
    "onPanEnd",
    "onPanSessionStart",
    "onTap",
    "onTapStart",
    "onTapCancel",
    "onHoverStart",
    "onHoverEnd",
    "whileFocus",
    "whileTap",
    "whileHover"
]);
/**
 * Check whether a prop name is a valid `MotionProp` key.
 *
 * @param key - Name of the property to check
 * @returns `true` is key is a valid `MotionProp`.
 *
 * @public
 */ function $677eeaf9e0fb9167$export$2f9c46555243bf04(key) {
    return $677eeaf9e0fb9167$var$validMotionProps.has(key);
}

});

parcelRegister("8cItv", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5f91f17bf9366c89$export$2e2bcd8739ae039; });

var $k6uUP = parcelRequire("k6uUP");
var $5f91f17bf9366c89$var$reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|download|draggable|encType|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|inert|itemProp|itemScope|itemType|itemID|itemRef|on|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/; // https://esbench.com/bench/5bfee68a4cd7e6009ef61d23
var $5f91f17bf9366c89$var$index = (0, $k6uUP.default)(function(prop) {
    return $5f91f17bf9366c89$var$reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111 && prop.charCodeAt(1) === 110 && prop.charCodeAt(2) < 91;
});
var $5f91f17bf9366c89$export$2e2bcd8739ae039 = $5f91f17bf9366c89$var$index;

});
parcelRegister("k6uUP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ea2c5962f6f06a9a$export$2e2bcd8739ae039; });
function $ea2c5962f6f06a9a$var$memoize(fn) {
    var cache = {};
    return function(arg) {
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}
var $ea2c5962f6f06a9a$export$2e2bcd8739ae039 = $ea2c5962f6f06a9a$var$memoize;

});



parcelRegister("iyIDB", function(module, exports) {

$parcel$export(module.exports, "useSVGProps", function () { return $d82e0712f8526fb5$export$84309c4f53cb1bd5; });

var $66bGh = parcelRequire("66bGh");

var $gJYWc = parcelRequire("gJYWc");

var $d5GCf = parcelRequire("d5GCf");

var $cFfTK = parcelRequire("cFfTK");

var $b5Qm0 = parcelRequire("b5Qm0");
function $d82e0712f8526fb5$export$84309c4f53cb1bd5(props, visualState) {
    var visualProps = (0, $gJYWc.useMemo)(function() {
        var state = (0, $b5Qm0.createSvgRenderState)();
        (0, $cFfTK.buildSVGAttrs)(state, visualState, undefined, undefined, {
            enableHardwareAcceleration: false
        }, props.transformTemplate);
        return (0, $66bGh.__assign)((0, $66bGh.__assign)({}, state.attrs), {
            style: (0, $66bGh.__assign)({}, state.style)
        });
    }, [
        visualState
    ]);
    if (props.style) {
        var rawStyles = {};
        (0, $d5GCf.copyRawValuesOnly)(rawStyles, props.style, props);
        visualProps.style = (0, $66bGh.__assign)((0, $66bGh.__assign)({}, rawStyles), visualProps.style);
    }
    return visualProps;
}

});
parcelRegister("cFfTK", function(module, exports) {

$parcel$export(module.exports, "buildSVGAttrs", function () { return $9385a5706c057be3$export$5475d24f125d7053; });

var $66bGh = parcelRequire("66bGh");

var $68PBy = parcelRequire("68PBy");

var $ix8Nz = parcelRequire("ix8Nz");

var $eiKd8 = parcelRequire("eiKd8");
/**
 * Build SVG visual attrbutes, like cx and style.transform
 */ function $9385a5706c057be3$export$5475d24f125d7053(state, _a, projection, layoutState, options, transformTemplate, buildProjectionTransform, buildProjectionTransformOrigin) {
    var attrX = _a.attrX, attrY = _a.attrY, originX = _a.originX, originY = _a.originY, pathLength = _a.pathLength, _b = _a.pathSpacing, pathSpacing = _b === void 0 ? 1 : _b, _c = _a.pathOffset, pathOffset = _c === void 0 ? 0 : _c, // This is object creation, which we try to avoid per-frame.
    latest = (0, $66bGh.__rest)(_a, [
        "attrX",
        "attrY",
        "originX",
        "originY",
        "pathLength",
        "pathSpacing",
        "pathOffset"
    ]);
    (0, $68PBy.buildHTMLStyles)(state, latest, projection, layoutState, options, transformTemplate, buildProjectionTransform, buildProjectionTransformOrigin);
    state.attrs = state.style;
    state.style = {};
    var attrs = state.attrs, style = state.style, dimensions = state.dimensions, totalPathLength = state.totalPathLength;
    /**
     * However, we apply transforms as CSS transforms. So if we detect a transform we take it from attrs
     * and copy it into style.
     */ if (attrs.transform) {
        if (dimensions) style.transform = attrs.transform;
        delete attrs.transform;
    }
    // Parse transformOrigin
    if (dimensions && (originX !== undefined || originY !== undefined || style.transform)) style.transformOrigin = (0, $ix8Nz.calcSVGTransformOrigin)(dimensions, originX !== undefined ? originX : 0.5, originY !== undefined ? originY : 0.5);
    // Treat x/y not as shortcuts but as actual attributes
    if (attrX !== undefined) attrs.x = attrX;
    if (attrY !== undefined) attrs.y = attrY;
    // Build SVG path if one has been measured
    if (totalPathLength !== undefined && pathLength !== undefined) (0, $eiKd8.buildSVGPath)(attrs, totalPathLength, pathLength, pathSpacing, pathOffset, false);
}

});
parcelRegister("ix8Nz", function(module, exports) {

$parcel$export(module.exports, "calcSVGTransformOrigin", function () { return $d7e22242719944cc$export$d4fbcfc8e5472155; });

var $4B3zo = parcelRequire("4B3zo");
function $d7e22242719944cc$var$calcOrigin(origin, offset, size) {
    return typeof origin === "string" ? origin : (0, $4B3zo.px).transform(offset + size * origin);
}
/**
 * The SVG transform origin defaults are different to CSS and is less intuitive,
 * so we use the measured dimensions of the SVG to reconcile these.
 */ function $d7e22242719944cc$export$d4fbcfc8e5472155(dimensions, originX, originY) {
    var pxOriginX = $d7e22242719944cc$var$calcOrigin(originX, dimensions.x, dimensions.width);
    var pxOriginY = $d7e22242719944cc$var$calcOrigin(originY, dimensions.y, dimensions.height);
    return pxOriginX + " " + pxOriginY;
}

});

parcelRegister("eiKd8", function(module, exports) {

$parcel$export(module.exports, "buildSVGPath", function () { return $a69697a949b27ebf$export$311b43f666da1d82; });

var $4B3zo = parcelRequire("4B3zo");
// Convert a progress 0-1 to a pixels value based on the provided length
var $a69697a949b27ebf$var$progressToPixels = function(progress, length) {
    return (0, $4B3zo.px).transform(progress * length);
};
var $a69697a949b27ebf$var$dashKeys = {
    offset: "stroke-dashoffset",
    array: "stroke-dasharray"
};
var $a69697a949b27ebf$var$camelKeys = {
    offset: "strokeDashoffset",
    array: "strokeDasharray"
};
/**
 * Build SVG path properties. Uses the path's measured length to convert
 * our custom pathLength, pathSpacing and pathOffset into stroke-dashoffset
 * and stroke-dasharray attributes.
 *
 * This function is mutative to reduce per-frame GC.
 */ function $a69697a949b27ebf$export$311b43f666da1d82(attrs, totalLength, length, spacing, offset, useDashCase) {
    if (spacing === void 0) spacing = 1;
    if (offset === void 0) offset = 0;
    if (useDashCase === void 0) useDashCase = true;
    // We use dash case when setting attributes directly to the DOM node and camel case
    // when defining props on a React component.
    var keys = useDashCase ? $a69697a949b27ebf$var$dashKeys : $a69697a949b27ebf$var$camelKeys;
    // Build the dash offset
    attrs[keys.offset] = $a69697a949b27ebf$var$progressToPixels(-offset, totalLength);
    // Build the dash array
    var pathLength = $a69697a949b27ebf$var$progressToPixels(length, totalLength);
    var pathSpacing = $a69697a949b27ebf$var$progressToPixels(spacing, totalLength);
    attrs[keys.array] = pathLength + " " + pathSpacing;
}

});


parcelRegister("b5Qm0", function(module, exports) {

$parcel$export(module.exports, "createSvgRenderState", function () { return $8138c5bfc9477ae1$export$41be8b43e1c4d4f9; });

var $66bGh = parcelRequire("66bGh");

var $bKWYX = parcelRequire("bKWYX");
var $8138c5bfc9477ae1$export$41be8b43e1c4d4f9 = function() {
    return (0, $66bGh.__assign)((0, $66bGh.__assign)({}, (0, $bKWYX.createHtmlRenderState)()), {
        attrs: {}
    });
};

});



parcelRegister("8LxlJ", function(module, exports) {

$parcel$export(module.exports, "svgMotionConfig", function () { return $661c9506e6e91286$export$44dabd3fae512e85; });

var $2XBJX = parcelRequire("2XBJX");

var $fuGiI = parcelRequire("fuGiI");

var $akWDz = parcelRequire("akWDz");

var $b5Qm0 = parcelRequire("b5Qm0");

var $cFfTK = parcelRequire("cFfTK");
var $661c9506e6e91286$export$44dabd3fae512e85 = {
    useVisualState: (0, $akWDz.makeUseVisualState)({
        scrapeMotionValuesFromProps: (0, $fuGiI.scrapeMotionValuesFromProps),
        createRenderState: (0, $b5Qm0.createSvgRenderState),
        onMount: function(props, instance, _a) {
            var renderState = _a.renderState, latestValues = _a.latestValues;
            try {
                renderState.dimensions = typeof instance.getBBox === "function" ? instance.getBBox() : instance.getBoundingClientRect();
            } catch (e) {
                // Most likely trying to measure an unrendered element under Firefox
                renderState.dimensions = {
                    x: 0,
                    y: 0,
                    width: 0,
                    height: 0
                };
            }
            if ($661c9506e6e91286$var$isPath(instance)) renderState.totalPathLength = instance.getTotalLength();
            (0, $cFfTK.buildSVGAttrs)(renderState, latestValues, undefined, undefined, {
                enableHardwareAcceleration: false
            }, props.transformTemplate);
            // TODO: Replace with direct assignment
            (0, $2XBJX.renderSVG)(instance, renderState);
        }
    })
};
function $661c9506e6e91286$var$isPath(element) {
    return element.tagName === "path";
}

});
parcelRegister("2XBJX", function(module, exports) {

$parcel$export(module.exports, "renderSVG", function () { return $227e5de49edb3ab9$export$c5f8399d19a7394b; });

var $9Heev = parcelRequire("9Heev");

var $ggG97 = parcelRequire("ggG97");

var $jt6P8 = parcelRequire("jt6P8");
function $227e5de49edb3ab9$export$c5f8399d19a7394b(element, renderState) {
    (0, $ggG97.renderHTML)(element, renderState);
    for(var key in renderState.attrs)element.setAttribute(!(0, $jt6P8.camelCaseAttributes).has(key) ? (0, $9Heev.camelToDash)(key) : key, renderState.attrs[key]);
}

});
parcelRegister("9Heev", function(module, exports) {

$parcel$export(module.exports, "camelToDash", function () { return $70f32b9904befa86$export$9fd24a634729c672; });
var $70f32b9904befa86$var$CAMEL_CASE_PATTERN = /([a-z])([A-Z])/g;
var $70f32b9904befa86$var$REPLACE_TEMPLATE = "$1-$2";
/**
 * Convert camelCase to dash-case properties.
 */ var $70f32b9904befa86$export$9fd24a634729c672 = function(str) {
    return str.replace($70f32b9904befa86$var$CAMEL_CASE_PATTERN, $70f32b9904befa86$var$REPLACE_TEMPLATE).toLowerCase();
};

});

parcelRegister("ggG97", function(module, exports) {

$parcel$export(module.exports, "renderHTML", function () { return $bd7ed547551b8a65$export$1a32bf6229c258c0; });
function $bd7ed547551b8a65$export$1a32bf6229c258c0(element, _a) {
    var style = _a.style, vars = _a.vars;
    // Directly assign style into the Element's style prop. In tests Object.assign is the
    // fastest way to assign styles.
    Object.assign(element.style, style);
    // Loop over any CSS variables and assign those.
    for(var key in vars)element.style.setProperty(key, vars[key]);
}

});

parcelRegister("jt6P8", function(module, exports) {

$parcel$export(module.exports, "camelCaseAttributes", function () { return $e2c604cba6e77142$export$28931db5d57958e5; });
/**
 * A set of attribute names that are always read/written as camel case.
 */ var $e2c604cba6e77142$export$28931db5d57958e5 = new Set([
    "baseFrequency",
    "diffuseConstant",
    "kernelMatrix",
    "kernelUnitLength",
    "keySplines",
    "keyTimes",
    "limitingConeAngle",
    "markerHeight",
    "markerWidth",
    "numOctaves",
    "targetX",
    "targetY",
    "surfaceScale",
    "specularConstant",
    "specularExponent",
    "stdDeviation",
    "tableValues",
    "viewBox",
    "gradientTransform"
]);

});


parcelRegister("fuGiI", function(module, exports) {

$parcel$export(module.exports, "scrapeMotionValuesFromProps", function () { return $b47a7873b5a20ed1$export$16da615486abaa45; });

var $a3Km2 = parcelRequire("a3Km2");

var $23199 = parcelRequire("23199");
function $b47a7873b5a20ed1$export$16da615486abaa45(props) {
    var newValues = (0, $23199.scrapeMotionValuesFromProps)(props);
    for(var key in props)if ((0, $a3Km2.isMotionValue)(props[key])) {
        var targetKey = key === "x" || key === "y" ? "attr" + key.toUpperCase() : key;
        newValues[targetKey] = props[key];
    }
    return newValues;
}

});
parcelRegister("23199", function(module, exports) {

$parcel$export(module.exports, "scrapeMotionValuesFromProps", function () { return $17dcc046f9d536e8$export$16da615486abaa45; });

var $kGZoz = parcelRequire("kGZoz");

var $a3Km2 = parcelRequire("a3Km2");
function $17dcc046f9d536e8$export$16da615486abaa45(props) {
    var style = props.style;
    var newValues = {};
    for(var key in style)if ((0, $a3Km2.isMotionValue)(style[key]) || (0, $kGZoz.isForcedMotionValue)(key, props)) newValues[key] = style[key];
    return newValues;
}

});


parcelRegister("akWDz", function(module, exports) {

$parcel$export(module.exports, "makeUseVisualState", function () { return $786941cbc9b6e03c$export$e91e107bc6d03a8e; });

var $66bGh = parcelRequire("66bGh");

var $gJYWc = parcelRequire("gJYWc");

var $4TucY = parcelRequire("4TucY");

var $1CTTQ = parcelRequire("1CTTQ");

var $g4bZm = parcelRequire("g4bZm");

var $j0JMo = parcelRequire("j0JMo");

var $4mjOv = parcelRequire("4mjOv");

var $cq6iL = parcelRequire("cq6iL");
function $786941cbc9b6e03c$var$makeState(_a, props, context, presenceContext) {
    var scrapeMotionValuesFromProps = _a.scrapeMotionValuesFromProps, createRenderState = _a.createRenderState, onMount = _a.onMount;
    var state = {
        latestValues: $786941cbc9b6e03c$var$makeLatestValues(props, context, presenceContext, scrapeMotionValuesFromProps),
        renderState: createRenderState()
    };
    if (onMount) state.mount = function(instance) {
        return onMount(props, instance, state);
    };
    return state;
}
var $786941cbc9b6e03c$export$e91e107bc6d03a8e = function(config) {
    return function(props, isStatic) {
        var context = (0, $gJYWc.useContext)((0, $cq6iL.MotionContext));
        var presenceContext = (0, $gJYWc.useContext)((0, $1CTTQ.PresenceContext));
        return isStatic ? $786941cbc9b6e03c$var$makeState(config, props, context, presenceContext) : (0, $j0JMo.useConstant)(function() {
            return $786941cbc9b6e03c$var$makeState(config, props, context, presenceContext);
        });
    };
};
function $786941cbc9b6e03c$var$makeLatestValues(props, context, presenceContext, scrapeMotionValues) {
    var values = {};
    var blockInitialAnimation = (presenceContext === null || presenceContext === void 0 ? void 0 : presenceContext.initial) === false;
    var motionValues = scrapeMotionValues(props);
    for(var key in motionValues)values[key] = (0, $4mjOv.resolveMotionValue)(motionValues[key]);
    var initial = props.initial, animate = props.animate;
    var isControllingVariants = (0, $g4bZm.checkIfControllingVariants)(props);
    var isVariantNode = (0, $g4bZm.checkIfVariantNode)(props);
    if (context && isVariantNode && !isControllingVariants && props.inherit !== false) {
        initial !== null && initial !== void 0 ? initial : initial = context.initial;
        animate !== null && animate !== void 0 ? animate : animate = context.animate;
    }
    var variantToSet = blockInitialAnimation || initial === false ? animate : initial;
    if (variantToSet && typeof variantToSet !== "boolean" && !(0, $4TucY.isAnimationControls)(variantToSet)) {
        var list = Array.isArray(variantToSet) ? variantToSet : [
            variantToSet
        ];
        list.forEach(function(definition) {
            var resolved = (0, $g4bZm.resolveVariantFromProps)(props, definition);
            if (!resolved) return;
            var transitionEnd = resolved.transitionEnd;
            resolved.transition;
            var target = (0, $66bGh.__rest)(resolved, [
                "transitionEnd",
                "transition"
            ]);
            for(var key in target)values[key] = target[key];
            for(var key in transitionEnd)values[key] = transitionEnd[key];
        });
    }
    return values;
}

});
parcelRegister("4TucY", function(module, exports) {

$parcel$export(module.exports, "isAnimationControls", function () { return $3903bb3b85da3fb6$export$aa71198ceeaf53ce; });
function $3903bb3b85da3fb6$export$aa71198ceeaf53ce(v) {
    return typeof v === "object" && typeof v.start === "function";
}

});

parcelRegister("4mjOv", function(module, exports) {

$parcel$export(module.exports, "resolveMotionValue", function () { return $32c8960e337bfdfc$export$fcc2206ecb6d74b; });

var $5q7SE = parcelRequire("5q7SE");

var $a3Km2 = parcelRequire("a3Km2");
/**
 * If the provided value is a MotionValue, this returns the actual value, otherwise just the value itself
 *
 * TODO: Remove and move to library
 *
 * @internal
 */ function $32c8960e337bfdfc$export$fcc2206ecb6d74b(value) {
    var unwrappedValue = (0, $a3Km2.isMotionValue)(value) ? value.get() : value;
    return (0, $5q7SE.isCustomValue)(unwrappedValue) ? unwrappedValue.toValue() : unwrappedValue;
}

});
parcelRegister("5q7SE", function(module, exports) {

$parcel$export(module.exports, "isCustomValue", function () { return $3f257e59abbe18ba$export$2f308ad9864b3ac9; });
$parcel$export(module.exports, "resolveFinalValueInKeyframes", function () { return $3f257e59abbe18ba$export$5485128c47bd48bb; });

var $3UqcD = parcelRequire("3UqcD");
var $3f257e59abbe18ba$export$2f308ad9864b3ac9 = function(v) {
    return Boolean(v && typeof v === "object" && v.mix && v.toValue);
};
var $3f257e59abbe18ba$export$5485128c47bd48bb = function(v) {
    // TODO maybe throw if v.length - 1 is placeholder token?
    return (0, $3UqcD.isKeyframesTarget)(v) ? v[v.length - 1] || 0 : v;
};

});
parcelRegister("3UqcD", function(module, exports) {

$parcel$export(module.exports, "isKeyframesTarget", function () { return $2d8aed62f6fa97e8$export$9153ad4c4999f4a0; });
var $2d8aed62f6fa97e8$export$9153ad4c4999f4a0 = function(v) {
    return Array.isArray(v);
};

});





parcelRegister("3RVwR", function(module, exports) {

$parcel$export(module.exports, "htmlMotionConfig", function () { return $2d12f2600ae2366e$export$e13ea21d87ea57c8; });

var $akWDz = parcelRequire("akWDz");

var $23199 = parcelRequire("23199");

var $bKWYX = parcelRequire("bKWYX");
var $2d12f2600ae2366e$export$e13ea21d87ea57c8 = {
    useVisualState: (0, $akWDz.makeUseVisualState)({
        scrapeMotionValuesFromProps: (0, $23199.scrapeMotionValuesFromProps),
        createRenderState: (0, $bKWYX.createHtmlRenderState)
    })
};

});


parcelRegister("hEkwi", function(module, exports) {

$parcel$export(module.exports, "gestureAnimations", function () { return $cd9616eb78962eef$export$e5b72898e5a201f1; });

var $ktc6f = parcelRequire("ktc6f");

var $3KL1r = parcelRequire("3KL1r");

var $1vkck = parcelRequire("1vkck");

var $eBj6o = parcelRequire("eBj6o");
var $cd9616eb78962eef$export$e5b72898e5a201f1 = {
    tap: (0, $eBj6o.makeRenderlessComponent)((0, $1vkck.useTapGesture)),
    focus: (0, $eBj6o.makeRenderlessComponent)((0, $ktc6f.useFocusGesture)),
    hover: (0, $eBj6o.makeRenderlessComponent)((0, $3KL1r.useHoverGesture))
};

});
parcelRegister("ktc6f", function(module, exports) {

$parcel$export(module.exports, "useFocusGesture", function () { return $ee6fe6d46280e5d4$export$cac52d7cca250a66; });

var $9Ujt6 = parcelRequire("9Ujt6");

var $eCb0d = parcelRequire("eCb0d");
/**
 *
 * @param props
 * @param ref
 * @internal
 */ function $ee6fe6d46280e5d4$export$cac52d7cca250a66(_a) {
    var whileFocus = _a.whileFocus, visualElement = _a.visualElement;
    var onFocus = function() {
        var _a;
        (_a = visualElement.animationState) === null || _a === void 0 || _a.setActive((0, $9Ujt6.AnimationType).Focus, true);
    };
    var onBlur = function() {
        var _a;
        (_a = visualElement.animationState) === null || _a === void 0 || _a.setActive((0, $9Ujt6.AnimationType).Focus, false);
    };
    (0, $eCb0d.useDomEvent)(visualElement, "focus", whileFocus ? onFocus : undefined);
    (0, $eCb0d.useDomEvent)(visualElement, "blur", whileFocus ? onBlur : undefined);
}

});
parcelRegister("9Ujt6", function(module, exports) {

$parcel$export(module.exports, "AnimationType", function () { return $7368720bcca11ea7$export$2deb71ebd3734d23; });
var $7368720bcca11ea7$export$2deb71ebd3734d23;
(function(AnimationType) {
    AnimationType["Animate"] = "animate";
    AnimationType["Hover"] = "whileHover";
    AnimationType["Tap"] = "whileTap";
    AnimationType["Drag"] = "whileDrag";
    AnimationType["Focus"] = "whileFocus";
    AnimationType["Exit"] = "exit";
})($7368720bcca11ea7$export$2deb71ebd3734d23 || ($7368720bcca11ea7$export$2deb71ebd3734d23 = {}));

});

parcelRegister("eCb0d", function(module, exports) {

$parcel$export(module.exports, "addDomEvent", function () { return $aa3d2625faa3557d$export$b1d829ddf82884aa; });
$parcel$export(module.exports, "useDomEvent", function () { return $aa3d2625faa3557d$export$c1052189363cb2e0; });

var $gJYWc = parcelRequire("gJYWc");
function $aa3d2625faa3557d$export$b1d829ddf82884aa(target, eventName, handler, options) {
    target.addEventListener(eventName, handler, options);
    return function() {
        return target.removeEventListener(eventName, handler, options);
    };
}
/**
 * Attaches an event listener directly to the provided DOM element.
 *
 * Bypassing React's event system can be desirable, for instance when attaching non-passive
 * event handlers.
 *
 * ```jsx
 * const ref = useRef(null)
 *
 * useDomEvent(ref, 'wheel', onWheel, { passive: false })
 *
 * return <div ref={ref} />
 * ```
 *
 * @param ref - React.RefObject that's been provided to the element you want to bind the listener to.
 * @param eventName - Name of the event you want listen for.
 * @param handler - Function to fire when receiving the event.
 * @param options - Options to pass to `Event.addEventListener`.
 *
 * @public
 */ function $aa3d2625faa3557d$export$c1052189363cb2e0(ref, eventName, handler, options) {
    (0, $gJYWc.useEffect)(function() {
        var element = ref.current;
        if (handler && element) return $aa3d2625faa3557d$export$b1d829ddf82884aa(element, eventName, handler, options);
    }, [
        ref,
        eventName,
        handler,
        options
    ]);
}

});


parcelRegister("3KL1r", function(module, exports) {

$parcel$export(module.exports, "useHoverGesture", function () { return $2bba249741d80685$export$dea06860711b7ebc; });

var $7FACY = parcelRequire("7FACY");

var $9Ujt6 = parcelRequire("9Ujt6");

var $bN9Oo = parcelRequire("bN9Oo");

var $inZZ1 = parcelRequire("inZZ1");
function $2bba249741d80685$var$createHoverEvent(visualElement, isActive, callback) {
    return function(event, info) {
        var _a;
        if (!(0, $7FACY.isMouseEvent)(event) || (0, $inZZ1.isDragActive)()) return;
        callback === null || callback === void 0 || callback(event, info);
        (_a = visualElement.animationState) === null || _a === void 0 || _a.setActive((0, $9Ujt6.AnimationType).Hover, isActive);
    };
}
function $2bba249741d80685$export$dea06860711b7ebc(_a) {
    var onHoverStart = _a.onHoverStart, onHoverEnd = _a.onHoverEnd, whileHover = _a.whileHover, visualElement = _a.visualElement;
    (0, $bN9Oo.usePointerEvent)(visualElement, "pointerenter", onHoverStart || whileHover ? $2bba249741d80685$var$createHoverEvent(visualElement, true, onHoverStart) : undefined);
    (0, $bN9Oo.usePointerEvent)(visualElement, "pointerleave", onHoverEnd || whileHover ? $2bba249741d80685$var$createHoverEvent(visualElement, false, onHoverEnd) : undefined);
}

});
parcelRegister("7FACY", function(module, exports) {

$parcel$export(module.exports, "isMouseEvent", function () { return $5958c63c1112da5e$export$764db16956f554f8; });
$parcel$export(module.exports, "isTouchEvent", function () { return $5958c63c1112da5e$export$c4dfce035d43d1e0; });
function $5958c63c1112da5e$export$764db16956f554f8(event) {
    // PointerEvent inherits from MouseEvent so we can't use a straight instanceof check.
    if (typeof PointerEvent !== "undefined" && event instanceof PointerEvent) return !!(event.pointerType === "mouse");
    return event instanceof MouseEvent;
}
function $5958c63c1112da5e$export$c4dfce035d43d1e0(event) {
    var hasTouches = !!event.touches;
    return hasTouches;
}

});

parcelRegister("bN9Oo", function(module, exports) {

$parcel$export(module.exports, "addPointerEvent", function () { return $895be1b668601ed0$export$fcff2e64e6676b81; });
$parcel$export(module.exports, "usePointerEvent", function () { return $895be1b668601ed0$export$734d04395f5243cd; });

var $eCb0d = parcelRequire("eCb0d");

var $13MxN = parcelRequire("13MxN");

var $jINAH = parcelRequire("jINAH");
var $895be1b668601ed0$var$mouseEventNames = {
    pointerdown: "mousedown",
    pointermove: "mousemove",
    pointerup: "mouseup",
    pointercancel: "mousecancel",
    pointerover: "mouseover",
    pointerout: "mouseout",
    pointerenter: "mouseenter",
    pointerleave: "mouseleave"
};
var $895be1b668601ed0$var$touchEventNames = {
    pointerdown: "touchstart",
    pointermove: "touchmove",
    pointerup: "touchend",
    pointercancel: "touchcancel"
};
function $895be1b668601ed0$var$getPointerEventName(name) {
    if ((0, $jINAH.supportsPointerEvents)()) return name;
    else if ((0, $jINAH.supportsTouchEvents)()) return $895be1b668601ed0$var$touchEventNames[name];
    else if ((0, $jINAH.supportsMouseEvents)()) return $895be1b668601ed0$var$mouseEventNames[name];
    return name;
}
function $895be1b668601ed0$export$fcff2e64e6676b81(target, eventName, handler, options) {
    return (0, $eCb0d.addDomEvent)(target, $895be1b668601ed0$var$getPointerEventName(eventName), (0, $13MxN.wrapHandler)(handler, eventName === "pointerdown"), options);
}
function $895be1b668601ed0$export$734d04395f5243cd(ref, eventName, handler, options) {
    return (0, $eCb0d.useDomEvent)(ref, $895be1b668601ed0$var$getPointerEventName(eventName), handler && (0, $13MxN.wrapHandler)(handler, eventName === "pointerdown"), options);
}

});
parcelRegister("13MxN", function(module, exports) {

$parcel$export(module.exports, "extractEventInfo", function () { return $0c5bba187e6a07c3$export$12f84bb882d06e1a; });
$parcel$export(module.exports, "getViewportPointFromEvent", function () { return $0c5bba187e6a07c3$export$750e59ed656e0503; });
$parcel$export(module.exports, "wrapHandler", function () { return $0c5bba187e6a07c3$export$f4437ba81469b709; });

var $7FACY = parcelRequire("7FACY");
/**
 * Filters out events not attached to the primary pointer (currently left mouse button)
 * @param eventHandler
 */ function $0c5bba187e6a07c3$var$filterPrimaryPointer(eventHandler) {
    return function(event) {
        var isMouseEvent = event instanceof MouseEvent;
        var isPrimaryPointer = !isMouseEvent || isMouseEvent && event.button === 0;
        if (isPrimaryPointer) eventHandler(event);
    };
}
var $0c5bba187e6a07c3$var$defaultPagePoint = {
    pageX: 0,
    pageY: 0
};
function $0c5bba187e6a07c3$var$pointFromTouch(e, pointType) {
    if (pointType === void 0) pointType = "page";
    var primaryTouch = e.touches[0] || e.changedTouches[0];
    var point = primaryTouch || $0c5bba187e6a07c3$var$defaultPagePoint;
    return {
        x: point[pointType + "X"],
        y: point[pointType + "Y"]
    };
}
function $0c5bba187e6a07c3$var$pointFromMouse(point, pointType) {
    if (pointType === void 0) pointType = "page";
    return {
        x: point[pointType + "X"],
        y: point[pointType + "Y"]
    };
}
function $0c5bba187e6a07c3$export$12f84bb882d06e1a(event, pointType) {
    if (pointType === void 0) pointType = "page";
    return {
        point: (0, $7FACY.isTouchEvent)(event) ? $0c5bba187e6a07c3$var$pointFromTouch(event, pointType) : $0c5bba187e6a07c3$var$pointFromMouse(event, pointType)
    };
}
function $0c5bba187e6a07c3$export$750e59ed656e0503(event) {
    return $0c5bba187e6a07c3$export$12f84bb882d06e1a(event, "client");
}
var $0c5bba187e6a07c3$export$f4437ba81469b709 = function(handler, shouldFilterPrimaryPointer) {
    if (shouldFilterPrimaryPointer === void 0) shouldFilterPrimaryPointer = false;
    var listener = function(event) {
        return handler(event, $0c5bba187e6a07c3$export$12f84bb882d06e1a(event));
    };
    return shouldFilterPrimaryPointer ? $0c5bba187e6a07c3$var$filterPrimaryPointer(listener) : listener;
};

});

parcelRegister("jINAH", function(module, exports) {

$parcel$export(module.exports, "supportsPointerEvents", function () { return $e5b8981b72686360$export$ed662207763ba653; });
$parcel$export(module.exports, "supportsTouchEvents", function () { return $e5b8981b72686360$export$58e9cbc5718eb8c2; });
$parcel$export(module.exports, "supportsMouseEvents", function () { return $e5b8981b72686360$export$1a3879af679d3ede; });

var $4qLKY = parcelRequire("4qLKY");
// We check for event support via functions in case they've been mocked by a testing suite.
var $e5b8981b72686360$export$ed662207763ba653 = function() {
    return (0, $4qLKY.isBrowser) && window.onpointerdown === null;
};
var $e5b8981b72686360$export$58e9cbc5718eb8c2 = function() {
    return (0, $4qLKY.isBrowser) && window.ontouchstart === null;
};
var $e5b8981b72686360$export$1a3879af679d3ede = function() {
    return (0, $4qLKY.isBrowser) && window.onmousedown === null;
};

});


parcelRegister("inZZ1", function(module, exports) {

$parcel$export(module.exports, "getGlobalLock", function () { return $d62a748ee7732091$export$2b7959ed03c1a3fe; });
$parcel$export(module.exports, "isDragActive", function () { return $d62a748ee7732091$export$1b3dd616664938e4; });
function $d62a748ee7732091$export$518c5fc2dcb7974b(name) {
    var lock = null;
    return function() {
        var openLock = function() {
            lock = null;
        };
        if (lock === null) {
            lock = name;
            return openLock;
        }
        return false;
    };
}
var $d62a748ee7732091$var$globalHorizontalLock = $d62a748ee7732091$export$518c5fc2dcb7974b("dragHorizontal");
var $d62a748ee7732091$var$globalVerticalLock = $d62a748ee7732091$export$518c5fc2dcb7974b("dragVertical");
function $d62a748ee7732091$export$2b7959ed03c1a3fe(drag) {
    var lock = false;
    if (drag === "y") lock = $d62a748ee7732091$var$globalVerticalLock();
    else if (drag === "x") lock = $d62a748ee7732091$var$globalHorizontalLock();
    else {
        var openHorizontal_1 = $d62a748ee7732091$var$globalHorizontalLock();
        var openVertical_1 = $d62a748ee7732091$var$globalVerticalLock();
        if (openHorizontal_1 && openVertical_1) lock = function() {
            openHorizontal_1();
            openVertical_1();
        };
        else {
            // Release the locks because we don't use them
            if (openHorizontal_1) openHorizontal_1();
            if (openVertical_1) openVertical_1();
        }
    }
    return lock;
}
function $d62a748ee7732091$export$1b3dd616664938e4() {
    // Check the gesture lock - if we get it, it means no drag gesture is active
    // and we can safely fire the tap gesture.
    var openGestureLock = $d62a748ee7732091$export$2b7959ed03c1a3fe(true);
    if (!openGestureLock) return true;
    openGestureLock();
    return false;
}

});


parcelRegister("1vkck", function(module, exports) {

$parcel$export(module.exports, "useTapGesture", function () { return $11885a8ea2c9a40d$export$16dee6ef8c34532; });

var $gJYWc = parcelRequire("gJYWc");

var $i6Bir = parcelRequire("i6Bir");

var $bN9Oo = parcelRequire("bN9Oo");

var $kdjA6 = parcelRequire("kdjA6");

var $6Zyiw = parcelRequire("6Zyiw");

var $9Ujt6 = parcelRequire("9Ujt6");

var $inZZ1 = parcelRequire("inZZ1");
/**
 * @param handlers -
 * @internal
 */ function $11885a8ea2c9a40d$export$16dee6ef8c34532(_a) {
    var onTap = _a.onTap, onTapStart = _a.onTapStart, onTapCancel = _a.onTapCancel, whileTap = _a.whileTap, visualElement = _a.visualElement;
    var hasPressListeners = onTap || onTapStart || onTapCancel || whileTap;
    var isPressing = (0, $gJYWc.useRef)(false);
    var cancelPointerEndListeners = (0, $gJYWc.useRef)(null);
    function removePointerEndListener() {
        var _a;
        (_a = cancelPointerEndListeners.current) === null || _a === void 0 || _a.call(cancelPointerEndListeners);
        cancelPointerEndListeners.current = null;
    }
    function checkPointerEnd() {
        var _a;
        removePointerEndListener();
        isPressing.current = false;
        (_a = visualElement.animationState) === null || _a === void 0 || _a.setActive((0, $9Ujt6.AnimationType).Tap, false);
        return !(0, $inZZ1.isDragActive)();
    }
    function onPointerUp(event, info) {
        if (!checkPointerEnd()) return;
        /**
         * We only count this as a tap gesture if the event.target is the same
         * as, or a child of, this component's element
         */ !(0, $i6Bir.isNodeOrChild)(visualElement.getInstance(), event.target) ? onTapCancel === null || onTapCancel === void 0 || onTapCancel(event, info) : onTap === null || onTap === void 0 || onTap(event, info);
    }
    function onPointerCancel(event, info) {
        if (!checkPointerEnd()) return;
        onTapCancel === null || onTapCancel === void 0 || onTapCancel(event, info);
    }
    function onPointerDown(event, info) {
        var _a;
        removePointerEndListener();
        if (isPressing.current) return;
        isPressing.current = true;
        cancelPointerEndListeners.current = (0, $6Zyiw.pipe)((0, $bN9Oo.addPointerEvent)(window, "pointerup", onPointerUp), (0, $bN9Oo.addPointerEvent)(window, "pointercancel", onPointerCancel));
        onTapStart === null || onTapStart === void 0 || onTapStart(event, info);
        (_a = visualElement.animationState) === null || _a === void 0 || _a.setActive((0, $9Ujt6.AnimationType).Tap, true);
    }
    (0, $bN9Oo.usePointerEvent)(visualElement, "pointerdown", hasPressListeners ? onPointerDown : undefined);
    (0, $kdjA6.useUnmountEffect)(removePointerEndListener);
}

});
parcelRegister("i6Bir", function(module, exports) {

$parcel$export(module.exports, "isNodeOrChild", function () { return $d2e5b7d9266ea826$export$e841ada32ff745b; });
/**
 * Recursively traverse up the tree to check whether the provided child node
 * is the parent or a descendant of it.
 *
 * @param parent - Element to find
 * @param child - Element to test against parent
 */ var $d2e5b7d9266ea826$export$e841ada32ff745b = function(parent, child) {
    if (!child) return false;
    else if (parent === child) return true;
    else return $d2e5b7d9266ea826$export$e841ada32ff745b(parent, child.parentElement);
};

});

parcelRegister("6Zyiw", function(module, exports) {

$parcel$export(module.exports, "pipe", function () { return $51730b627b162632$export$a4627e546088548d; });
var $51730b627b162632$var$combineFunctions = function(a, b) {
    return function(v) {
        return b(a(v));
    };
};
var $51730b627b162632$export$a4627e546088548d = function() {
    var transformers = [];
    for(var _i = 0; _i < arguments.length; _i++)transformers[_i] = arguments[_i];
    return transformers.reduce($51730b627b162632$var$combineFunctions);
};

});


parcelRegister("eBj6o", function(module, exports) {

$parcel$export(module.exports, "makeRenderlessComponent", function () { return $aa1356a7a02512a9$export$46d1d6d046f826e4; });
var $aa1356a7a02512a9$export$46d1d6d046f826e4 = function(hook) {
    return function(props) {
        hook(props);
        return null;
    };
};

});


parcelRegister("dd0Jt", function(module, exports) {

$parcel$export(module.exports, "animations", function () { return $99dd0eb8ac93c366$export$7f9953c70dacfd7f; });

var $66bGh = parcelRequire("66bGh");

var $gJYWc = parcelRequire("gJYWc");

var $4TucY = parcelRequire("4TucY");

var $dUQA6 = parcelRequire("dUQA6");

var $1CTTQ = parcelRequire("1CTTQ");

var $f5zA9 = parcelRequire("f5zA9");

var $9Ujt6 = parcelRequire("9Ujt6");

var $eBj6o = parcelRequire("eBj6o");
var $99dd0eb8ac93c366$export$7f9953c70dacfd7f = {
    animation: (0, $eBj6o.makeRenderlessComponent)(function(_a) {
        var visualElement = _a.visualElement, animate = _a.animate;
        /**
         * We dynamically generate the AnimationState manager as it contains a reference
         * to the underlying animation library. We only want to load that if we load this,
         * so people can optionally code split it out using the `m` component.
         */ visualElement.animationState || (visualElement.animationState = (0, $f5zA9.createAnimationState)(visualElement));
        /**
         * Subscribe any provided AnimationControls to the component's VisualElement
         */ if ((0, $4TucY.isAnimationControls)(animate)) (0, $gJYWc.useEffect)(function() {
            return animate.subscribe(visualElement);
        }, [
            animate
        ]);
    }),
    exit: (0, $eBj6o.makeRenderlessComponent)(function(props) {
        var custom = props.custom, visualElement = props.visualElement;
        var _a = (0, $66bGh.__read)((0, $dUQA6.usePresence)(), 2), isPresent = _a[0], onExitComplete = _a[1];
        var presenceContext = (0, $gJYWc.useContext)((0, $1CTTQ.PresenceContext));
        (0, $gJYWc.useEffect)(function() {
            var _a, _b;
            var animation = (_a = visualElement.animationState) === null || _a === void 0 ? void 0 : _a.setActive((0, $9Ujt6.AnimationType).Exit, !isPresent, {
                custom: (_b = presenceContext === null || presenceContext === void 0 ? void 0 : presenceContext.custom) !== null && _b !== void 0 ? _b : custom
            });
            !isPresent && (animation === null || animation === void 0 || animation.then(onExitComplete));
        }, [
            isPresent
        ]);
    })
};

});
parcelRegister("f5zA9", function(module, exports) {

$parcel$export(module.exports, "variantPriorityOrder", function () { return $afc2ec83ae5bd06f$export$16e45afcc206d3a8; });
$parcel$export(module.exports, "createAnimationState", function () { return $afc2ec83ae5bd06f$export$bb53502b7a672aa8; });

var $66bGh = parcelRequire("66bGh");

var $4TucY = parcelRequire("4TucY");

var $3UqcD = parcelRequire("3UqcD");

var $gSjbf = parcelRequire("gSjbf");

var $awMh4 = parcelRequire("awMh4");

var $9Ujt6 = parcelRequire("9Ujt6");

var $g4bZm = parcelRequire("g4bZm");
var $afc2ec83ae5bd06f$export$16e45afcc206d3a8 = [
    (0, $9Ujt6.AnimationType).Animate,
    (0, $9Ujt6.AnimationType).Hover,
    (0, $9Ujt6.AnimationType).Tap,
    (0, $9Ujt6.AnimationType).Drag,
    (0, $9Ujt6.AnimationType).Focus,
    (0, $9Ujt6.AnimationType).Exit
];
var $afc2ec83ae5bd06f$var$reversePriorityOrder = (0, $66bGh.__spreadArray)([], (0, $66bGh.__read)($afc2ec83ae5bd06f$export$16e45afcc206d3a8)).reverse();
var $afc2ec83ae5bd06f$var$numAnimationTypes = $afc2ec83ae5bd06f$export$16e45afcc206d3a8.length;
function $afc2ec83ae5bd06f$var$animateList(visualElement) {
    return function(animations) {
        return Promise.all(animations.map(function(_a) {
            var animation = _a.animation, options = _a.options;
            return (0, $awMh4.animateVisualElement)(visualElement, animation, options);
        }));
    };
}
function $afc2ec83ae5bd06f$export$bb53502b7a672aa8(visualElement) {
    var animate = $afc2ec83ae5bd06f$var$animateList(visualElement);
    var state = $afc2ec83ae5bd06f$var$createState();
    var allAnimatedKeys = {};
    var isInitialRender = true;
    /**
     * This function will be used to reduce the animation definitions for
     * each active animation type into an object of resolved values for it.
     */ var buildResolvedTypeValues = function(acc, definition) {
        var resolved = (0, $g4bZm.resolveVariant)(visualElement, definition);
        if (resolved) {
            resolved.transition;
            var transitionEnd = resolved.transitionEnd, target = (0, $66bGh.__rest)(resolved, [
                "transition",
                "transitionEnd"
            ]);
            acc = (0, $66bGh.__assign)((0, $66bGh.__assign)((0, $66bGh.__assign)({}, acc), target), transitionEnd);
        }
        return acc;
    };
    function isAnimated(key) {
        return allAnimatedKeys[key] !== undefined;
    }
    /**
     * This just allows us to inject mocked animation functions
     * @internal
     */ function setAnimateFunction(makeAnimator) {
        animate = makeAnimator(visualElement);
    }
    /**
     * When we receive new props, we need to:
     * 1. Create a list of protected keys for each type. This is a directory of
     *    value keys that are currently being "handled" by types of a higher priority
     *    so that whenever an animation is played of a given type, these values are
     *    protected from being animated.
     * 2. Determine if an animation type needs animating.
     * 3. Determine if any values have been removed from a type and figure out
     *    what to animate those to.
     */ function animateChanges(options, changedActiveType) {
        var _a;
        var props = visualElement.getProps();
        var context = visualElement.getVariantContext(true) || {};
        /**
         * A list of animations that we'll build into as we iterate through the animation
         * types. This will get executed at the end of the function.
         */ var animations = [];
        /**
         * Keep track of which values have been removed. Then, as we hit lower priority
         * animation types, we can check if they contain removed values and animate to that.
         */ var removedKeys = new Set();
        /**
         * A dictionary of all encountered keys. This is an object to let us build into and
         * copy it without iteration. Each time we hit an animation type we set its protected
         * keys - the keys its not allowed to animate - to the latest version of this object.
         */ var encounteredKeys = {};
        /**
         * If a variant has been removed at a given index, and this component is controlling
         * variant animations, we want to ensure lower-priority variants are forced to animate.
         */ var removedVariantIndex = Infinity;
        var _loop_1 = function(i) {
            var type = $afc2ec83ae5bd06f$var$reversePriorityOrder[i];
            var typeState = state[type];
            var prop = (_a = props[type]) !== null && _a !== void 0 ? _a : context[type];
            var propIsVariant = (0, $g4bZm.isVariantLabel)(prop);
            /**
             * If this type has *just* changed isActive status, set activeDelta
             * to that status. Otherwise set to null.
             */ var activeDelta = type === changedActiveType ? typeState.isActive : null;
            if (activeDelta === false) removedVariantIndex = i;
            /**
             * If this prop is an inherited variant, rather than been set directly on the
             * component itself, we want to make sure we allow the parent to trigger animations.
             *
             * TODO: Can probably change this to a !isControllingVariants check
             */ var isInherited = prop === context[type] && prop !== props[type] && propIsVariant;
            /**
             *
             */ if (isInherited && isInitialRender && visualElement.manuallyAnimateOnMount) isInherited = false;
            /**
             * Set all encountered keys so far as the protected keys for this type. This will
             * be any key that has been animated or otherwise handled by active, higher-priortiy types.
             */ typeState.protectedKeys = (0, $66bGh.__assign)({}, encounteredKeys);
            // Check if we can skip analysing this prop early
            if (// If it isn't active and hasn't *just* been set as inactive
            !typeState.isActive && activeDelta === null || // If we didn't and don't have any defined prop for this animation type
            !prop && !typeState.prevProp || // Or if the prop doesn't define an animation
            (0, $4TucY.isAnimationControls)(prop) || typeof prop === "boolean") return "continue";
            /**
             * As we go look through the values defined on this type, if we detect
             * a changed value or a value that was removed in a higher priority, we set
             * this to true and add this prop to the animation list.
             */ var shouldAnimateType = $afc2ec83ae5bd06f$export$b9d9a225005a5327(typeState.prevProp, prop) || // If we're making this variant active, we want to always make it active
            type === changedActiveType && typeState.isActive && !isInherited && propIsVariant || // If we removed a higher-priority variant (i is in reverse order)
            i > removedVariantIndex && propIsVariant;
            /**
             * As animations can be set as variant lists, variants or target objects, we
             * coerce everything to an array if it isn't one already
             */ var definitionList = Array.isArray(prop) ? prop : [
                prop
            ];
            /**
             * Build an object of all the resolved values. We'll use this in the subsequent
             * animateChanges calls to determine whether a value has changed.
             */ var resolvedValues = definitionList.reduce(buildResolvedTypeValues, {});
            if (activeDelta === false) resolvedValues = {};
            /**
             * Now we need to loop through all the keys in the prev prop and this prop,
             * and decide:
             * 1. If the value has changed, and needs animating
             * 2. If it has been removed, and needs adding to the removedKeys set
             * 3. If it has been removed in a higher priority type and needs animating
             * 4. If it hasn't been removed in a higher priority but hasn't changed, and
             *    needs adding to the type's protectedKeys list.
             */ var _b = typeState.prevResolvedValues, prevResolvedValues = _b === void 0 ? {} : _b;
            var allKeys = (0, $66bGh.__assign)((0, $66bGh.__assign)({}, prevResolvedValues), resolvedValues);
            var markToAnimate = function(key) {
                shouldAnimateType = true;
                removedKeys.delete(key);
                typeState.needsAnimating[key] = true;
            };
            for(var key in allKeys){
                var next = resolvedValues[key];
                var prev = prevResolvedValues[key];
                // If we've already handled this we can just skip ahead
                if (encounteredKeys.hasOwnProperty(key)) continue;
                /**
                 * If the value has changed, we probably want to animate it.
                 */ if (next !== prev) {
                    /**
                     * If both values are keyframes, we need to shallow compare them to
                     * detect whether any value has changed. If it has, we animate it.
                     */ if ((0, $3UqcD.isKeyframesTarget)(next) && (0, $3UqcD.isKeyframesTarget)(prev)) {
                        if (!(0, $gSjbf.shallowCompare)(next, prev)) markToAnimate(key);
                        else /**
                             * If it hasn't changed, we want to ensure it doesn't animate by
                             * adding it to the list of protected keys.
                             */ typeState.protectedKeys[key] = true;
                    } else if (next !== undefined) // If next is defined and doesn't equal prev, it needs animating
                    markToAnimate(key);
                    else // If it's undefined, it's been removed.
                    removedKeys.add(key);
                } else if (next !== undefined && removedKeys.has(key)) /**
                     * If next hasn't changed and it isn't undefined, we want to check if it's
                     * been removed by a higher priority
                     */ markToAnimate(key);
                else /**
                     * If it hasn't changed, we add it to the list of protected values
                     * to ensure it doesn't get animated.
                     */ typeState.protectedKeys[key] = true;
            }
            /**
             * Update the typeState so next time animateChanges is called we can compare the
             * latest prop and resolvedValues to these.
             */ typeState.prevProp = prop;
            typeState.prevResolvedValues = resolvedValues;
            /**
             *
             */ if (typeState.isActive) encounteredKeys = (0, $66bGh.__assign)((0, $66bGh.__assign)({}, encounteredKeys), resolvedValues);
            if (isInitialRender && visualElement.blockInitialAnimation) shouldAnimateType = false;
            /**
             * If this is an inherited prop we want to hard-block animations
             * TODO: Test as this should probably still handle animations triggered
             * by removed values?
             */ if (shouldAnimateType && !isInherited) animations.push.apply(animations, (0, $66bGh.__spreadArray)([], (0, $66bGh.__read)(definitionList.map(function(animation) {
                return {
                    animation: animation,
                    options: (0, $66bGh.__assign)({
                        type: type
                    }, options)
                };
            }))));
        };
        /**
         * Iterate through all animation types in reverse priority order. For each, we want to
         * detect which values it's handling and whether or not they've changed (and therefore
         * need to be animated). If any values have been removed, we want to detect those in
         * lower priority props and flag for animation.
         */ for(var i = 0; i < $afc2ec83ae5bd06f$var$numAnimationTypes; i++)_loop_1(i);
        allAnimatedKeys = (0, $66bGh.__assign)({}, encounteredKeys);
        /**
         * If there are some removed value that haven't been dealt with,
         * we need to create a new animation that falls back either to the value
         * defined in the style prop, or the last read value.
         */ if (removedKeys.size) {
            var fallbackAnimation_1 = {};
            removedKeys.forEach(function(key) {
                var fallbackTarget = visualElement.getBaseTarget(key);
                if (fallbackTarget !== undefined) fallbackAnimation_1[key] = fallbackTarget;
            });
            animations.push({
                animation: fallbackAnimation_1
            });
        }
        var shouldAnimate = Boolean(animations.length);
        if (isInitialRender && props.initial === false && !visualElement.manuallyAnimateOnMount) shouldAnimate = false;
        isInitialRender = false;
        return shouldAnimate ? animate(animations) : Promise.resolve();
    }
    /**
     * Change whether a certain animation type is active.
     */ function setActive(type, isActive, options) {
        var _a;
        // If the active state hasn't changed, we can safely do nothing here
        if (state[type].isActive === isActive) return Promise.resolve();
        // Propagate active change to children
        (_a = visualElement.variantChildren) === null || _a === void 0 || _a.forEach(function(child) {
            var _a;
            return (_a = child.animationState) === null || _a === void 0 ? void 0 : _a.setActive(type, isActive);
        });
        state[type].isActive = isActive;
        return animateChanges(options, type);
    }
    return {
        isAnimated: isAnimated,
        animateChanges: animateChanges,
        setActive: setActive,
        setAnimateFunction: setAnimateFunction,
        getState: function() {
            return state;
        }
    };
}
function $afc2ec83ae5bd06f$export$b9d9a225005a5327(prev, next) {
    if (typeof next === "string") return next !== prev;
    else if ((0, $g4bZm.isVariantLabels)(next)) return !(0, $gSjbf.shallowCompare)(next, prev);
    return false;
}
function $afc2ec83ae5bd06f$var$createTypeState(isActive) {
    if (isActive === void 0) isActive = false;
    return {
        isActive: isActive,
        protectedKeys: {},
        needsAnimating: {},
        prevResolvedValues: {}
    };
}
function $afc2ec83ae5bd06f$var$createState() {
    var _a;
    return _a = {}, _a[(0, $9Ujt6.AnimationType).Animate] = $afc2ec83ae5bd06f$var$createTypeState(true), _a[(0, $9Ujt6.AnimationType).Hover] = $afc2ec83ae5bd06f$var$createTypeState(), _a[(0, $9Ujt6.AnimationType).Tap] = $afc2ec83ae5bd06f$var$createTypeState(), _a[(0, $9Ujt6.AnimationType).Drag] = $afc2ec83ae5bd06f$var$createTypeState(), _a[(0, $9Ujt6.AnimationType).Focus] = $afc2ec83ae5bd06f$var$createTypeState(), _a[(0, $9Ujt6.AnimationType).Exit] = $afc2ec83ae5bd06f$var$createTypeState(), _a;
}

});
parcelRegister("gSjbf", function(module, exports) {

$parcel$export(module.exports, "shallowCompare", function () { return $c490914ed9a7ec64$export$90e866afbd6b9f1a; });
function $c490914ed9a7ec64$export$90e866afbd6b9f1a(next, prev) {
    if (!Array.isArray(prev)) return false;
    var prevLength = prev.length;
    if (prevLength !== next.length) return false;
    for(var i = 0; i < prevLength; i++){
        if (prev[i] !== next[i]) return false;
    }
    return true;
}

});

parcelRegister("awMh4", function(module, exports) {

$parcel$export(module.exports, "animateVisualElement", function () { return $7aa256ce3bbc0d63$export$ff62cf473653f109; });

var $66bGh = parcelRequire("66bGh");

var $6CYZP = parcelRequire("6CYZP");

var $cA2Zn = parcelRequire("cA2Zn");

var $g4bZm = parcelRequire("g4bZm");
/**
 * @internal
 */ function $7aa256ce3bbc0d63$export$ff62cf473653f109(visualElement, definition, options) {
    if (options === void 0) options = {};
    visualElement.notifyAnimationStart();
    var animation;
    if (Array.isArray(definition)) {
        var animations = definition.map(function(variant) {
            return $7aa256ce3bbc0d63$var$animateVariant(visualElement, variant, options);
        });
        animation = Promise.all(animations);
    } else if (typeof definition === "string") animation = $7aa256ce3bbc0d63$var$animateVariant(visualElement, definition, options);
    else {
        var resolvedDefinition = typeof definition === "function" ? (0, $g4bZm.resolveVariant)(visualElement, definition, options.custom) : definition;
        animation = $7aa256ce3bbc0d63$var$animateTarget(visualElement, resolvedDefinition, options);
    }
    return animation.then(function() {
        return visualElement.notifyAnimationComplete(definition);
    });
}
function $7aa256ce3bbc0d63$var$animateVariant(visualElement, variant, options) {
    var _a;
    if (options === void 0) options = {};
    var resolved = (0, $g4bZm.resolveVariant)(visualElement, variant, options.custom);
    var _b = (resolved || {}).transition, transition = _b === void 0 ? visualElement.getDefaultTransition() || {} : _b;
    if (options.transitionOverride) transition = options.transitionOverride;
    /**
     * If we have a variant, create a callback that runs it as an animation.
     * Otherwise, we resolve a Promise immediately for a composable no-op.
     */ var getAnimation = resolved ? function() {
        return $7aa256ce3bbc0d63$var$animateTarget(visualElement, resolved, options);
    } : function() {
        return Promise.resolve();
    };
    /**
     * If we have children, create a callback that runs all their animations.
     * Otherwise, we resolve a Promise immediately for a composable no-op.
     */ var getChildAnimations = ((_a = visualElement.variantChildren) === null || _a === void 0 ? void 0 : _a.size) ? function(forwardDelay) {
        if (forwardDelay === void 0) forwardDelay = 0;
        var _a = transition.delayChildren, delayChildren = _a === void 0 ? 0 : _a, staggerChildren = transition.staggerChildren, staggerDirection = transition.staggerDirection;
        return $7aa256ce3bbc0d63$var$animateChildren(visualElement, variant, delayChildren + forwardDelay, staggerChildren, staggerDirection, options);
    } : function() {
        return Promise.resolve();
    };
    /**
     * If the transition explicitly defines a "when" option, we need to resolve either
     * this animation or all children animations before playing the other.
     */ var when = transition.when;
    if (when) {
        var _c = (0, $66bGh.__read)(when === "beforeChildren" ? [
            getAnimation,
            getChildAnimations
        ] : [
            getChildAnimations,
            getAnimation
        ], 2), first = _c[0], last = _c[1];
        return first().then(last);
    } else return Promise.all([
        getAnimation(),
        getChildAnimations(options.delay)
    ]);
}
/**
 * @internal
 */ function $7aa256ce3bbc0d63$var$animateTarget(visualElement, definition, _a) {
    var _b;
    var _c = _a === void 0 ? {} : _a, _d = _c.delay, delay = _d === void 0 ? 0 : _d, transitionOverride = _c.transitionOverride, type = _c.type;
    var _e = visualElement.makeTargetAnimatable(definition), _f = _e.transition, transition = _f === void 0 ? visualElement.getDefaultTransition() : _f, transitionEnd = _e.transitionEnd, target = (0, $66bGh.__rest)(_e, [
        "transition",
        "transitionEnd"
    ]);
    if (transitionOverride) transition = transitionOverride;
    var animations = [];
    var animationTypeState = type && ((_b = visualElement.animationState) === null || _b === void 0 ? void 0 : _b.getState()[type]);
    for(var key in target){
        var value = visualElement.getValue(key);
        var valueTarget = target[key];
        if (!value || valueTarget === undefined || animationTypeState && $7aa256ce3bbc0d63$var$shouldBlockAnimation(animationTypeState, key)) continue;
        var animation = (0, $6CYZP.startAnimation)(key, value, valueTarget, (0, $66bGh.__assign)({
            delay: delay
        }, transition));
        animations.push(animation);
    }
    return Promise.all(animations).then(function() {
        transitionEnd && (0, $cA2Zn.setTarget)(visualElement, transitionEnd);
    });
}
function $7aa256ce3bbc0d63$var$animateChildren(visualElement, variant, delayChildren, staggerChildren, staggerDirection, options) {
    if (delayChildren === void 0) delayChildren = 0;
    if (staggerChildren === void 0) staggerChildren = 0;
    if (staggerDirection === void 0) staggerDirection = 1;
    var animations = [];
    var maxStaggerDuration = (visualElement.variantChildren.size - 1) * staggerChildren;
    var generateStaggerDuration = staggerDirection === 1 ? function(i) {
        if (i === void 0) i = 0;
        return i * staggerChildren;
    } : function(i) {
        if (i === void 0) i = 0;
        return maxStaggerDuration - i * staggerChildren;
    };
    Array.from(visualElement.variantChildren).sort($7aa256ce3bbc0d63$export$523a0bedf33ad781).forEach(function(child, i) {
        animations.push($7aa256ce3bbc0d63$var$animateVariant(child, variant, (0, $66bGh.__assign)((0, $66bGh.__assign)({}, options), {
            delay: delayChildren + generateStaggerDuration(i)
        })).then(function() {
            return child.notifyAnimationComplete(variant);
        }));
    });
    return Promise.all(animations);
}
function $7aa256ce3bbc0d63$export$3cc6f911ef1fd837(visualElement) {
    visualElement.forEachValue(function(value) {
        return value.stop();
    });
}
function $7aa256ce3bbc0d63$export$523a0bedf33ad781(a, b) {
    return a.sortNodePosition(b);
}
/**
 * Decide whether we should block this animation. Previously, we achieved this
 * just by checking whether the key was listed in protectedKeys, but this
 * posed problems if an animation was triggered by afterChildren and protectedKeys
 * had been set to true in the meantime.
 */ function $7aa256ce3bbc0d63$var$shouldBlockAnimation(_a, key) {
    var protectedKeys = _a.protectedKeys, needsAnimating = _a.needsAnimating;
    var shouldBlock = protectedKeys.hasOwnProperty(key) && needsAnimating[key] !== true;
    needsAnimating[key] = false;
    return shouldBlock;
}

});
parcelRegister("6CYZP", function(module, exports) {

$parcel$export(module.exports, "getValueTransition", function () { return $4d359b40e755201a$export$7c1391340308742e; });
$parcel$export(module.exports, "startAnimation", function () { return $4d359b40e755201a$export$592dbd515a49cf1b; });

var $66bGh = parcelRequire("66bGh");

var $95mwY = parcelRequire("95mwY");
var $i5erf = parcelRequire("i5erf");

var $j5T2L = parcelRequire("j5T2L");

var $bCkvz = parcelRequire("bCkvz");

var $logPu = parcelRequire("logPu");

var $jwNdj = parcelRequire("jwNdj");

var $739Hg = parcelRequire("739Hg");

var $jqo75 = parcelRequire("jqo75");
/**
 * Decide whether a transition is defined on a given Transition.
 * This filters out orchestration options and returns true
 * if any options are left.
 */ function $4d359b40e755201a$export$ca8e47dc8ed5a9d7(_a) {
    _a.when;
    _a.delay;
    _a.delayChildren;
    _a.staggerChildren;
    _a.staggerDirection;
    _a.repeat;
    _a.repeatType;
    _a.repeatDelay;
    _a.from;
    var transition = (0, $66bGh.__rest)(_a, [
        "when",
        "delay",
        "delayChildren",
        "staggerChildren",
        "staggerDirection",
        "repeat",
        "repeatType",
        "repeatDelay",
        "from"
    ]);
    return !!Object.keys(transition).length;
}
var $4d359b40e755201a$var$legacyRepeatWarning = false;
/**
 * Convert Framer Motion's Transition type into Popmotion-compatible options.
 */ function $4d359b40e755201a$export$998eb6d72a6574db(_a) {
    var ease = _a.ease, times = _a.times, yoyo = _a.yoyo, flip = _a.flip, loop = _a.loop, transition = (0, $66bGh.__rest)(_a, [
        "ease",
        "times",
        "yoyo",
        "flip",
        "loop"
    ]);
    var options = (0, $66bGh.__assign)({}, transition);
    if (times) options["offset"] = times;
    /**
     * Convert any existing durations from seconds to milliseconds
     */ if (transition.duration) options["duration"] = (0, $j5T2L.secondsToMilliseconds)(transition.duration);
    if (transition.repeatDelay) options.repeatDelay = (0, $j5T2L.secondsToMilliseconds)(transition.repeatDelay);
    /**
     * Map easing names to Popmotion's easing functions
     */ if (ease) options["ease"] = (0, $bCkvz.isEasingArray)(ease) ? ease.map((0, $bCkvz.easingDefinitionToFunction)) : (0, $bCkvz.easingDefinitionToFunction)(ease);
    /**
     * Support legacy transition API
     */ if (transition.type === "tween") options.type = "keyframes";
    /**
     * TODO: These options are officially removed from the API.
     */ if (yoyo || loop || flip) {
        (0, $739Hg.warning)(!$4d359b40e755201a$var$legacyRepeatWarning, "yoyo, loop and flip have been removed from the API. Replace with repeat and repeatType options.");
        $4d359b40e755201a$var$legacyRepeatWarning = true;
        if (yoyo) options.repeatType = "reverse";
        else if (loop) options.repeatType = "loop";
        else if (flip) options.repeatType = "mirror";
        options.repeat = loop || yoyo || flip || transition.repeat;
    }
    /**
     * TODO: Popmotion 9 has the ability to automatically detect whether to use
     * a keyframes or spring animation, but does so by detecting velocity and other spring options.
     * It'd be good to introduce a similar thing here.
     */ if (transition.type !== "spring") options.type = "keyframes";
    return options;
}
/**
 * Get the delay for a value by checking Transition with decreasing specificity.
 */ function $4d359b40e755201a$export$b55a0e77aebddb70(transition, key) {
    var _a;
    var valueTransition = $4d359b40e755201a$export$7c1391340308742e(transition, key) || {};
    return (_a = valueTransition.delay) !== null && _a !== void 0 ? _a : 0;
}
function $4d359b40e755201a$export$3d2f5b3e7004e0cf(options) {
    if (Array.isArray(options.to) && options.to[0] === null) {
        options.to = (0, $66bGh.__spreadArray)([], (0, $66bGh.__read)(options.to));
        options.to[0] = options.from;
    }
    return options;
}
function $4d359b40e755201a$export$9019a69adbea191(transition, options, key) {
    var _a;
    if (Array.isArray(options.to)) (_a = transition.duration) !== null && _a !== void 0 ? _a : transition.duration = 0.8;
    $4d359b40e755201a$export$3d2f5b3e7004e0cf(options);
    /**
     * Get a default transition if none is determined to be defined.
     */ if (!$4d359b40e755201a$export$ca8e47dc8ed5a9d7(transition)) transition = (0, $66bGh.__assign)((0, $66bGh.__assign)({}, transition), (0, $jwNdj.getDefaultTransition)(key, options.to));
    return (0, $66bGh.__assign)((0, $66bGh.__assign)({}, options), $4d359b40e755201a$export$998eb6d72a6574db(transition));
}
/**
 *
 */ function $4d359b40e755201a$var$getAnimation(key, value, target, transition, onComplete) {
    var _a;
    var valueTransition = $4d359b40e755201a$export$7c1391340308742e(transition, key);
    var origin = (_a = valueTransition.from) !== null && _a !== void 0 ? _a : value.get();
    var isTargetAnimatable = (0, $logPu.isAnimatable)(key, target);
    if (origin === "none" && isTargetAnimatable && typeof target === "string") /**
         * If we're trying to animate from "none", try and get an animatable version
         * of the target. This could be improved to work both ways.
         */ origin = (0, $jqo75.getAnimatableNone)(key, target);
    else if ($4d359b40e755201a$export$c46ec7d82fb1f602(origin) && typeof target === "string") origin = $4d359b40e755201a$export$36cd6032f9de8a48(target);
    else if (!Array.isArray(target) && $4d359b40e755201a$export$c46ec7d82fb1f602(target) && typeof origin === "string") target = $4d359b40e755201a$export$36cd6032f9de8a48(origin);
    var isOriginAnimatable = (0, $logPu.isAnimatable)(key, origin);
    (0, $739Hg.warning)(isOriginAnimatable === isTargetAnimatable, "You are trying to animate " + key + " from \"" + origin + "\" to \"" + target + "\". " + origin + " is not an animatable value - to enable this animation set " + origin + " to a value animatable to " + target + " via the `style` property.");
    function start() {
        var options = {
            from: origin,
            to: target,
            velocity: value.getVelocity(),
            onComplete: onComplete,
            onUpdate: function(v) {
                return value.set(v);
            }
        };
        return valueTransition.type === "inertia" || valueTransition.type === "decay" ? (0, $i5erf.inertia)((0, $66bGh.__assign)((0, $66bGh.__assign)({}, options), valueTransition)) : (0, $95mwY.animate)((0, $66bGh.__assign)((0, $66bGh.__assign)({}, $4d359b40e755201a$export$9019a69adbea191(valueTransition, options, key)), {
            onUpdate: function(v) {
                var _a;
                options.onUpdate(v);
                (_a = valueTransition.onUpdate) === null || _a === void 0 || _a.call(valueTransition, v);
            },
            onComplete: function() {
                var _a;
                options.onComplete();
                (_a = valueTransition.onComplete) === null || _a === void 0 || _a.call(valueTransition);
            }
        }));
    }
    function set() {
        var _a;
        value.set(target);
        onComplete();
        (_a = valueTransition === null || valueTransition === void 0 ? void 0 : valueTransition.onComplete) === null || _a === void 0 || _a.call(valueTransition);
        return {
            stop: function() {}
        };
    }
    return !isOriginAnimatable || !isTargetAnimatable || valueTransition.type === false ? set : start;
}
function $4d359b40e755201a$export$c46ec7d82fb1f602(value) {
    return value === 0 || typeof value === "string" && parseFloat(value) === 0 && value.indexOf(" ") === -1;
}
function $4d359b40e755201a$export$36cd6032f9de8a48(potentialUnitType) {
    return typeof potentialUnitType === "number" ? 0 : (0, $jqo75.getAnimatableNone)("", potentialUnitType);
}
function $4d359b40e755201a$export$7c1391340308742e(transition, key) {
    return transition[key] || transition["default"] || transition;
}
/**
 * Start animation on a MotionValue. This function is an interface between
 * Framer Motion and Popmotion
 *
 * @internal
 */ function $4d359b40e755201a$export$592dbd515a49cf1b(key, value, target, transition) {
    if (transition === void 0) transition = {};
    return value.start(function(onComplete) {
        var delayTimer;
        var controls;
        var animation = $4d359b40e755201a$var$getAnimation(key, value, target, transition, onComplete);
        var delay = $4d359b40e755201a$export$b55a0e77aebddb70(transition, key);
        var start = function() {
            return controls = animation();
        };
        if (delay) delayTimer = setTimeout(start, (0, $j5T2L.secondsToMilliseconds)(delay));
        else start();
        return function() {
            clearTimeout(delayTimer);
            controls === null || controls === void 0 || controls.stop();
        };
    });
}

});
parcelRegister("95mwY", function(module, exports) {

$parcel$export(module.exports, "animate", function () { return $69d60ed6788ae84c$export$e3607ec2d7a891c4; });

var $66bGh = parcelRequire("66bGh");

var $hLRdx = parcelRequire("hLRdx");

var $fzvX8 = parcelRequire("fzvX8");

var $5D2gm = parcelRequire("5D2gm");

var $izbdP = parcelRequire("izbdP");
var $69d60ed6788ae84c$var$framesync = function(update) {
    var passTimestamp = function(_a) {
        var delta = _a.delta;
        return update(delta);
    };
    return {
        start: function() {
            return (0, $fzvX8.default).update(passTimestamp, true);
        },
        stop: function() {
            return (0, $fzvX8.cancelSync).update(passTimestamp);
        }
    };
};
function $69d60ed6788ae84c$export$e3607ec2d7a891c4(_a) {
    var _b, _c;
    var from = _a.from, _d = _a.autoplay, autoplay = _d === void 0 ? true : _d, _e = _a.driver, driver = _e === void 0 ? $69d60ed6788ae84c$var$framesync : _e, _f = _a.elapsed, elapsed = _f === void 0 ? 0 : _f, _g = _a.repeat, repeatMax = _g === void 0 ? 0 : _g, _h = _a.repeatType, repeatType = _h === void 0 ? "loop" : _h, _j = _a.repeatDelay, repeatDelay = _j === void 0 ? 0 : _j, onPlay = _a.onPlay, onStop = _a.onStop, onComplete = _a.onComplete, onRepeat = _a.onRepeat, onUpdate = _a.onUpdate, options = (0, $66bGh.__rest)(_a, [
        "from",
        "autoplay",
        "driver",
        "elapsed",
        "repeat",
        "repeatType",
        "repeatDelay",
        "onPlay",
        "onStop",
        "onComplete",
        "onRepeat",
        "onUpdate"
    ]);
    var to = options.to;
    var driverControls;
    var repeatCount = 0;
    var computedDuration = options.duration;
    var latest;
    var isComplete = false;
    var isForwardPlayback = true;
    var interpolateFromNumber;
    var animator = (0, $hLRdx.detectAnimationFromOptions)(options);
    if ((_c = (_b = animator).needsInterpolation) === null || _c === void 0 ? void 0 : _c.call(_b, from, to)) {
        interpolateFromNumber = (0, $5D2gm.interpolate)([
            0,
            100
        ], [
            from,
            to
        ], {
            clamp: false
        });
        from = 0;
        to = 100;
    }
    var animation = animator((0, $66bGh.__assign)((0, $66bGh.__assign)({}, options), {
        from: from,
        to: to
    }));
    function repeat() {
        repeatCount++;
        if (repeatType === "reverse") {
            isForwardPlayback = repeatCount % 2 === 0;
            elapsed = (0, $izbdP.reverseElapsed)(elapsed, computedDuration, repeatDelay, isForwardPlayback);
        } else {
            elapsed = (0, $izbdP.loopElapsed)(elapsed, computedDuration, repeatDelay);
            if (repeatType === "mirror") animation.flipTarget();
        }
        isComplete = false;
        onRepeat && onRepeat();
    }
    function complete() {
        driverControls.stop();
        onComplete && onComplete();
    }
    function update(delta) {
        if (!isForwardPlayback) delta = -delta;
        elapsed += delta;
        if (!isComplete) {
            var state = animation.next(Math.max(0, elapsed));
            latest = state.value;
            if (interpolateFromNumber) latest = interpolateFromNumber(latest);
            isComplete = isForwardPlayback ? state.done : elapsed <= 0;
        }
        onUpdate === null || onUpdate === void 0 || onUpdate(latest);
        if (isComplete) {
            if (repeatCount === 0) computedDuration !== null && computedDuration !== void 0 ? computedDuration : computedDuration = elapsed;
            if (repeatCount < repeatMax) (0, $izbdP.hasRepeatDelayElapsed)(elapsed, computedDuration, repeatDelay, isForwardPlayback) && repeat();
            else complete();
        }
    }
    function play() {
        onPlay === null || onPlay === void 0 || onPlay();
        driverControls = driver(update);
        driverControls.start();
    }
    autoplay && play();
    return {
        stop: function() {
            onStop === null || onStop === void 0 || onStop();
            driverControls.stop();
        }
    };
}

});
parcelRegister("hLRdx", function(module, exports) {

$parcel$export(module.exports, "detectAnimationFromOptions", function () { return $cf001b5071d48511$export$74df49bbebf8cb2c; });

var $RsQjT = parcelRequire("RsQjT");

var $3Zk64 = parcelRequire("3Zk64");

var $9y7So = parcelRequire("9y7So");
var $cf001b5071d48511$var$types = {
    keyframes: (0, $3Zk64.keyframes),
    spring: (0, $RsQjT.spring),
    decay: (0, $9y7So.decay)
};
function $cf001b5071d48511$export$74df49bbebf8cb2c(config) {
    if (Array.isArray(config.to)) return 0, $3Zk64.keyframes;
    else if ($cf001b5071d48511$var$types[config.type]) return $cf001b5071d48511$var$types[config.type];
    var keys = new Set(Object.keys(config));
    if (keys.has("ease") || keys.has("duration") && !keys.has("dampingRatio")) return 0, $3Zk64.keyframes;
    else if (keys.has("dampingRatio") || keys.has("stiffness") || keys.has("mass") || keys.has("damping") || keys.has("restSpeed") || keys.has("restDelta")) return 0, $RsQjT.spring;
    return 0, $3Zk64.keyframes;
}

});
parcelRegister("RsQjT", function(module, exports) {

$parcel$export(module.exports, "spring", function () { return $0a0b52f1d2712f74$export$b36281d89752ae66; });

var $66bGh = parcelRequire("66bGh");

var $fzfIh = parcelRequire("fzfIh");
var $0a0b52f1d2712f74$var$durationKeys = [
    "duration",
    "bounce"
];
var $0a0b52f1d2712f74$var$physicsKeys = [
    "stiffness",
    "damping",
    "mass"
];
function $0a0b52f1d2712f74$var$isSpringType(options, keys) {
    return keys.some(function(key) {
        return options[key] !== undefined;
    });
}
function $0a0b52f1d2712f74$var$getSpringOptions(options) {
    var springOptions = (0, $66bGh.__assign)({
        velocity: 0.0,
        stiffness: 100,
        damping: 10,
        mass: 1.0,
        isResolvedFromDuration: false
    }, options);
    if (!$0a0b52f1d2712f74$var$isSpringType(options, $0a0b52f1d2712f74$var$physicsKeys) && $0a0b52f1d2712f74$var$isSpringType(options, $0a0b52f1d2712f74$var$durationKeys)) {
        var derived = (0, $fzfIh.findSpring)(options);
        springOptions = (0, $66bGh.__assign)((0, $66bGh.__assign)((0, $66bGh.__assign)({}, springOptions), derived), {
            velocity: 0.0,
            mass: 1.0
        });
        springOptions.isResolvedFromDuration = true;
    }
    return springOptions;
}
function $0a0b52f1d2712f74$export$b36281d89752ae66(_a) {
    var _b = _a.from, from = _b === void 0 ? 0.0 : _b, _c = _a.to, to = _c === void 0 ? 1.0 : _c, _d = _a.restSpeed, restSpeed = _d === void 0 ? 2 : _d, restDelta = _a.restDelta, options = (0, $66bGh.__rest)(_a, [
        "from",
        "to",
        "restSpeed",
        "restDelta"
    ]);
    var state = {
        done: false,
        value: from
    };
    var _e = $0a0b52f1d2712f74$var$getSpringOptions(options), stiffness = _e.stiffness, damping = _e.damping, mass = _e.mass, velocity = _e.velocity, duration = _e.duration, isResolvedFromDuration = _e.isResolvedFromDuration;
    var resolveSpring = $0a0b52f1d2712f74$var$zero;
    var resolveVelocity = $0a0b52f1d2712f74$var$zero;
    function createSpring() {
        var initialVelocity = velocity ? -(velocity / 1000) : 0.0;
        var initialDelta = to - from;
        var dampingRatio = damping / (2 * Math.sqrt(stiffness * mass));
        var undampedAngularFreq = Math.sqrt(stiffness / mass) / 1000;
        restDelta !== null && restDelta !== void 0 ? restDelta : restDelta = Math.abs(to - from) <= 1 ? 0.01 : 0.4;
        if (dampingRatio < 1) {
            var angularFreq_1 = (0, $fzfIh.calcAngularFreq)(undampedAngularFreq, dampingRatio);
            resolveSpring = function(t) {
                var envelope = Math.exp(-dampingRatio * undampedAngularFreq * t);
                return to - envelope * ((initialVelocity + dampingRatio * undampedAngularFreq * initialDelta) / angularFreq_1 * Math.sin(angularFreq_1 * t) + initialDelta * Math.cos(angularFreq_1 * t));
            };
            resolveVelocity = function(t) {
                var envelope = Math.exp(-dampingRatio * undampedAngularFreq * t);
                return dampingRatio * undampedAngularFreq * envelope * (Math.sin(angularFreq_1 * t) * (initialVelocity + dampingRatio * undampedAngularFreq * initialDelta) / angularFreq_1 + initialDelta * Math.cos(angularFreq_1 * t)) - envelope * (Math.cos(angularFreq_1 * t) * (initialVelocity + dampingRatio * undampedAngularFreq * initialDelta) - angularFreq_1 * initialDelta * Math.sin(angularFreq_1 * t));
            };
        } else if (dampingRatio === 1) resolveSpring = function(t) {
            return to - Math.exp(-undampedAngularFreq * t) * (initialDelta + (initialVelocity + undampedAngularFreq * initialDelta) * t);
        };
        else {
            var dampedAngularFreq_1 = undampedAngularFreq * Math.sqrt(dampingRatio * dampingRatio - 1);
            resolveSpring = function(t) {
                var envelope = Math.exp(-dampingRatio * undampedAngularFreq * t);
                var freqForT = Math.min(dampedAngularFreq_1 * t, 300);
                return to - envelope * ((initialVelocity + dampingRatio * undampedAngularFreq * initialDelta) * Math.sinh(freqForT) + dampedAngularFreq_1 * initialDelta * Math.cosh(freqForT)) / dampedAngularFreq_1;
            };
        }
    }
    createSpring();
    return {
        next: function(t) {
            var current = resolveSpring(t);
            if (!isResolvedFromDuration) {
                var currentVelocity = resolveVelocity(t) * 1000;
                var isBelowVelocityThreshold = Math.abs(currentVelocity) <= restSpeed;
                var isBelowDisplacementThreshold = Math.abs(to - current) <= restDelta;
                state.done = isBelowVelocityThreshold && isBelowDisplacementThreshold;
            } else state.done = t >= duration;
            state.value = state.done ? to : current;
            return state;
        },
        flipTarget: function() {
            var _a;
            velocity = -velocity;
            _a = [
                to,
                from
            ], from = _a[0], to = _a[1];
            createSpring();
        }
    };
}
$0a0b52f1d2712f74$export$b36281d89752ae66.needsInterpolation = function(a, b) {
    return typeof a === "string" || typeof b === "string";
};
var $0a0b52f1d2712f74$var$zero = function(_t) {
    return 0;
};

});
parcelRegister("fzfIh", function(module, exports) {

$parcel$export(module.exports, "findSpring", function () { return $b55650307eba1f4a$export$b15f158dc6d6f458; });
$parcel$export(module.exports, "calcAngularFreq", function () { return $b55650307eba1f4a$export$5f679887c3a78b15; });

var $739Hg = parcelRequire("739Hg");

var $7ier8 = parcelRequire("7ier8");
var $b55650307eba1f4a$var$safeMin = 0.001;
var $b55650307eba1f4a$export$a3cdb76e84ee608e = 0.01;
var $b55650307eba1f4a$export$1824b851fad8862b = 10.0;
var $b55650307eba1f4a$export$ff08f2d53484465 = 0.05;
var $b55650307eba1f4a$export$201ca48e54038115 = 1;
function $b55650307eba1f4a$export$b15f158dc6d6f458(_a) {
    var _b = _a.duration, duration = _b === void 0 ? 800 : _b, _c = _a.bounce, bounce = _c === void 0 ? 0.25 : _c, _d = _a.velocity, velocity = _d === void 0 ? 0 : _d, _e = _a.mass, mass = _e === void 0 ? 1 : _e;
    var envelope;
    var derivative;
    (0, $739Hg.warning)(duration <= $b55650307eba1f4a$export$1824b851fad8862b * 1000, "Spring duration must be 10 seconds or less");
    var dampingRatio = 1 - bounce;
    dampingRatio = (0, $7ier8.clamp)($b55650307eba1f4a$export$ff08f2d53484465, $b55650307eba1f4a$export$201ca48e54038115, dampingRatio);
    duration = (0, $7ier8.clamp)($b55650307eba1f4a$export$a3cdb76e84ee608e, $b55650307eba1f4a$export$1824b851fad8862b, duration / 1000);
    if (dampingRatio < 1) {
        envelope = function(undampedFreq) {
            var exponentialDecay = undampedFreq * dampingRatio;
            var delta = exponentialDecay * duration;
            var a = exponentialDecay - velocity;
            var b = $b55650307eba1f4a$export$5f679887c3a78b15(undampedFreq, dampingRatio);
            var c = Math.exp(-delta);
            return $b55650307eba1f4a$var$safeMin - a / b * c;
        };
        derivative = function(undampedFreq) {
            var exponentialDecay = undampedFreq * dampingRatio;
            var delta = exponentialDecay * duration;
            var d = delta * velocity + velocity;
            var e = Math.pow(dampingRatio, 2) * Math.pow(undampedFreq, 2) * duration;
            var f = Math.exp(-delta);
            var g = $b55650307eba1f4a$export$5f679887c3a78b15(Math.pow(undampedFreq, 2), dampingRatio);
            var factor = -envelope(undampedFreq) + $b55650307eba1f4a$var$safeMin > 0 ? -1 : 1;
            return factor * ((d - e) * f) / g;
        };
    } else {
        envelope = function(undampedFreq) {
            var a = Math.exp(-undampedFreq * duration);
            var b = (undampedFreq - velocity) * duration + 1;
            return -$b55650307eba1f4a$var$safeMin + a * b;
        };
        derivative = function(undampedFreq) {
            var a = Math.exp(-undampedFreq * duration);
            var b = (velocity - undampedFreq) * (duration * duration);
            return a * b;
        };
    }
    var initialGuess = 5 / duration;
    var undampedFreq = $b55650307eba1f4a$var$approximateRoot(envelope, derivative, initialGuess);
    duration = duration * 1000;
    if (isNaN(undampedFreq)) return {
        stiffness: 100,
        damping: 10,
        duration: duration
    };
    else {
        var stiffness = Math.pow(undampedFreq, 2) * mass;
        return {
            stiffness: stiffness,
            damping: dampingRatio * 2 * Math.sqrt(mass * stiffness),
            duration: duration
        };
    }
}
var $b55650307eba1f4a$var$rootIterations = 12;
function $b55650307eba1f4a$var$approximateRoot(envelope, derivative, initialGuess) {
    var result = initialGuess;
    for(var i = 1; i < $b55650307eba1f4a$var$rootIterations; i++)result = result - envelope(result) / derivative(result);
    return result;
}
function $b55650307eba1f4a$export$5f679887c3a78b15(undampedFreq, dampingRatio) {
    return undampedFreq * Math.sqrt(1 - dampingRatio * dampingRatio);
}

});
parcelRegister("7ier8", function(module, exports) {

$parcel$export(module.exports, "clamp", function () { return $54f569abfaf9eb98$export$7d15b64cf5a3a4c4; });
var $54f569abfaf9eb98$export$7d15b64cf5a3a4c4 = function(min, max, v) {
    return Math.min(Math.max(v, min), max);
};

});



parcelRegister("3Zk64", function(module, exports) {

$parcel$export(module.exports, "keyframes", function () { return $2e76a86eeaffb387$export$d25ddfdf17c3ad3e; });

var $5D2gm = parcelRequire("5D2gm");

var $6viqV = parcelRequire("6viqV");
function $2e76a86eeaffb387$export$6b60b58e4ea7d715(values, easing) {
    return values.map(function() {
        return easing || (0, $6viqV.easeInOut);
    }).splice(0, values.length - 1);
}
function $2e76a86eeaffb387$export$24dbcec0b26e6d9d(values) {
    var numValues = values.length;
    return values.map(function(_value, i) {
        return i !== 0 ? i / (numValues - 1) : 0;
    });
}
function $2e76a86eeaffb387$export$2a91b4e3a4539316(offset, duration) {
    return offset.map(function(o) {
        return o * duration;
    });
}
function $2e76a86eeaffb387$export$d25ddfdf17c3ad3e(_a) {
    var _b = _a.from, from = _b === void 0 ? 0 : _b, _c = _a.to, to = _c === void 0 ? 1 : _c, ease = _a.ease, offset = _a.offset, _d = _a.duration, duration = _d === void 0 ? 300 : _d;
    var state = {
        done: false,
        value: from
    };
    var values = Array.isArray(to) ? to : [
        from,
        to
    ];
    var times = $2e76a86eeaffb387$export$2a91b4e3a4539316(offset && offset.length === values.length ? offset : $2e76a86eeaffb387$export$24dbcec0b26e6d9d(values), duration);
    function createInterpolator() {
        return (0, $5D2gm.interpolate)(times, values, {
            ease: Array.isArray(ease) ? ease : $2e76a86eeaffb387$export$6b60b58e4ea7d715(values, ease)
        });
    }
    var interpolator = createInterpolator();
    return {
        next: function(t) {
            state.value = interpolator(t);
            state.done = t >= duration;
            return state;
        },
        flipTarget: function() {
            values.reverse();
            interpolator = createInterpolator();
        }
    };
}

});
parcelRegister("5D2gm", function(module, exports) {

$parcel$export(module.exports, "interpolate", function () { return $419259a53b898d53$export$89e29e4ab65e70a9; });

var $iz4xc = parcelRequire("iz4xc");

var $203mS = parcelRequire("203mS");

var $j26Ak = parcelRequire("j26Ak");

var $6sZia = parcelRequire("6sZia");

var $d2IoU = parcelRequire("d2IoU");

var $7ier8 = parcelRequire("7ier8");

var $6Zyiw = parcelRequire("6Zyiw");

var $739Hg = parcelRequire("739Hg");
var $419259a53b898d53$var$mixNumber = function(from, to) {
    return function(p) {
        return (0, $203mS.mix)(from, to, p);
    };
};
function $419259a53b898d53$var$detectMixerFactory(v) {
    if (typeof v === 'number') return $419259a53b898d53$var$mixNumber;
    else if (typeof v === 'string') {
        if ((0, $d2IoU.color).test(v)) return 0, $j26Ak.mixColor;
        else return 0, $6sZia.mixComplex;
    } else if (Array.isArray(v)) return 0, $6sZia.mixArray;
    else if (typeof v === 'object') return 0, $6sZia.mixObject;
}
function $419259a53b898d53$var$createMixers(output, ease, customMixer) {
    var mixers = [];
    var mixerFactory = customMixer || $419259a53b898d53$var$detectMixerFactory(output[0]);
    var numMixers = output.length - 1;
    for(var i = 0; i < numMixers; i++){
        var mixer = mixerFactory(output[i], output[i + 1]);
        if (ease) {
            var easingFunction = Array.isArray(ease) ? ease[i] : ease;
            mixer = (0, $6Zyiw.pipe)(easingFunction, mixer);
        }
        mixers.push(mixer);
    }
    return mixers;
}
function $419259a53b898d53$var$fastInterpolate(_a, _b) {
    var from = _a[0], to = _a[1];
    var mixer = _b[0];
    return function(v) {
        return mixer((0, $iz4xc.progress)(from, to, v));
    };
}
function $419259a53b898d53$var$slowInterpolate(input, mixers) {
    var inputLength = input.length;
    var lastInputIndex = inputLength - 1;
    return function(v) {
        var mixerIndex = 0;
        var foundMixerIndex = false;
        if (v <= input[0]) foundMixerIndex = true;
        else if (v >= input[lastInputIndex]) {
            mixerIndex = lastInputIndex - 1;
            foundMixerIndex = true;
        }
        if (!foundMixerIndex) {
            var i = 1;
            for(; i < inputLength; i++){
                if (input[i] > v || i === lastInputIndex) break;
            }
            mixerIndex = i - 1;
        }
        var progressInRange = (0, $iz4xc.progress)(input[mixerIndex], input[mixerIndex + 1], v);
        return mixers[mixerIndex](progressInRange);
    };
}
function $419259a53b898d53$export$89e29e4ab65e70a9(input, output, _a) {
    var _b = _a === void 0 ? {} : _a, _c = _b.clamp, isClamp = _c === void 0 ? true : _c, ease = _b.ease, mixer = _b.mixer;
    var inputLength = input.length;
    (0, $739Hg.invariant)(inputLength === output.length, 'Both input and output ranges must be the same length');
    (0, $739Hg.invariant)(!ease || !Array.isArray(ease) || ease.length === inputLength - 1, 'Array of easing functions must be of length `input.length - 1`, as it applies to the transitions **between** the defined values.');
    if (input[0] > input[inputLength - 1]) {
        input = [].concat(input);
        output = [].concat(output);
        input.reverse();
        output.reverse();
    }
    var mixers = $419259a53b898d53$var$createMixers(output, ease, mixer);
    var interpolator = inputLength === 2 ? $419259a53b898d53$var$fastInterpolate(input, mixers) : $419259a53b898d53$var$slowInterpolate(input, mixers);
    return isClamp ? function(v) {
        return interpolator((0, $7ier8.clamp)(input[0], input[inputLength - 1], v));
    } : interpolator;
}

});
parcelRegister("iz4xc", function(module, exports) {

$parcel$export(module.exports, "progress", function () { return $d83f03500f7ad4bf$export$504d7abb21fa8c9; });
var $d83f03500f7ad4bf$export$504d7abb21fa8c9 = function(from, to, value) {
    var toFromDifference = to - from;
    return toFromDifference === 0 ? 1 : (value - from) / toFromDifference;
};

});

parcelRegister("203mS", function(module, exports) {

$parcel$export(module.exports, "mix", function () { return $174e31acc71e41b8$export$2c9e8a9632a706b2; });
var $174e31acc71e41b8$export$2c9e8a9632a706b2 = function(from, to, progress) {
    return -progress * from + progress * to + from;
};

});

parcelRegister("j26Ak", function(module, exports) {

$parcel$export(module.exports, "mixColor", function () { return $ddb34fd909bae734$export$51e568cf5c039bac; });

var $66bGh = parcelRequire("66bGh");

var $203mS = parcelRequire("203mS");

var $98rsj = parcelRequire("98rsj");
var $9CYrG = parcelRequire("9CYrG");
var $eMYvQ = parcelRequire("eMYvQ");

var $739Hg = parcelRequire("739Hg");
var $ddb34fd909bae734$export$d4ecea248cce73c = function(from, to, v) {
    var fromExpo = from * from;
    var toExpo = to * to;
    return Math.sqrt(Math.max(0, v * (toExpo - fromExpo) + fromExpo));
};
var $ddb34fd909bae734$var$colorTypes = [
    (0, $98rsj.hex),
    (0, $eMYvQ.rgba),
    (0, $9CYrG.hsla)
];
var $ddb34fd909bae734$var$getColorType = function(v) {
    return $ddb34fd909bae734$var$colorTypes.find(function(type) {
        return type.test(v);
    });
};
var $ddb34fd909bae734$var$notAnimatable = function(color) {
    return "'" + color + "' is not an animatable color. Use the equivalent color code instead.";
};
var $ddb34fd909bae734$export$51e568cf5c039bac = function(from, to) {
    var fromColorType = $ddb34fd909bae734$var$getColorType(from);
    var toColorType = $ddb34fd909bae734$var$getColorType(to);
    (0, $739Hg.invariant)(!!fromColorType, $ddb34fd909bae734$var$notAnimatable(from));
    (0, $739Hg.invariant)(!!toColorType, $ddb34fd909bae734$var$notAnimatable(to));
    (0, $739Hg.invariant)(fromColorType.transform === toColorType.transform, "Both colors must be hex/RGBA, OR both must be HSLA.");
    var fromColor = fromColorType.parse(from);
    var toColor = toColorType.parse(to);
    var blended = (0, $66bGh.__assign)({}, fromColor);
    var mixFunc = fromColorType === (0, $9CYrG.hsla) ? (0, $203mS.mix) : $ddb34fd909bae734$export$d4ecea248cce73c;
    return function(v) {
        for(var key in blended)if (key !== "alpha") blended[key] = mixFunc(fromColor[key], toColor[key], v);
        blended.alpha = (0, $203mS.mix)(fromColor.alpha, toColor.alpha, v);
        return fromColorType.transform(blended);
    };
};

});
parcelRegister("98rsj", function(module, exports) {

$parcel$export(module.exports, "hex", function () { return $6a6a2886e33a552a$export$834dfc94dde4b3d8; });

var $eMYvQ = parcelRequire("eMYvQ");

var $ig3sQ = parcelRequire("ig3sQ");
function $6a6a2886e33a552a$var$parseHex(v) {
    var r = '';
    var g = '';
    var b = '';
    var a = '';
    if (v.length > 5) {
        r = v.substr(1, 2);
        g = v.substr(3, 2);
        b = v.substr(5, 2);
        a = v.substr(7, 2);
    } else {
        r = v.substr(1, 1);
        g = v.substr(2, 1);
        b = v.substr(3, 1);
        a = v.substr(4, 1);
        r += r;
        g += g;
        b += b;
        a += a;
    }
    return {
        red: parseInt(r, 16),
        green: parseInt(g, 16),
        blue: parseInt(b, 16),
        alpha: a ? parseInt(a, 16) / 255 : 1
    };
}
var $6a6a2886e33a552a$export$834dfc94dde4b3d8 = {
    test: (0, $ig3sQ.isColorString)('#'),
    parse: $6a6a2886e33a552a$var$parseHex,
    transform: (0, $eMYvQ.rgba).transform
};

});
parcelRegister("eMYvQ", function(module, exports) {

$parcel$export(module.exports, "rgba", function () { return $ac447cf2a0fc4c4e$export$4e46ac54fc82cf3b; });

var $66bGh = parcelRequire("66bGh");

var $5M3DJ = parcelRequire("5M3DJ");

var $6YHRg = parcelRequire("6YHRg");

var $ig3sQ = parcelRequire("ig3sQ");
var $ac447cf2a0fc4c4e$var$clampRgbUnit = (0, $6YHRg.clamp)(0, 255);
var $ac447cf2a0fc4c4e$export$7a99c86b5b1f4c9e = (0, $66bGh.__assign)((0, $66bGh.__assign)({}, (0, $5M3DJ.number)), {
    transform: function(v) {
        return Math.round($ac447cf2a0fc4c4e$var$clampRgbUnit(v));
    }
});
var $ac447cf2a0fc4c4e$export$4e46ac54fc82cf3b = {
    test: (0, $ig3sQ.isColorString)('rgb', 'red'),
    parse: (0, $ig3sQ.splitColor)('red', 'green', 'blue'),
    transform: function(_a) {
        var red = _a.red, green = _a.green, blue = _a.blue, _b = _a.alpha, alpha$1 = _b === void 0 ? 1 : _b;
        return 'rgba(' + $ac447cf2a0fc4c4e$export$7a99c86b5b1f4c9e.transform(red) + ', ' + $ac447cf2a0fc4c4e$export$7a99c86b5b1f4c9e.transform(green) + ', ' + $ac447cf2a0fc4c4e$export$7a99c86b5b1f4c9e.transform(blue) + ', ' + (0, $6YHRg.sanitize)((0, $5M3DJ.alpha).transform(alpha$1)) + ')';
    }
};

});
parcelRegister("ig3sQ", function(module, exports) {

$parcel$export(module.exports, "isColorString", function () { return $d4ac688b6b4bfcdf$export$2c8400d58aca05e; });
$parcel$export(module.exports, "splitColor", function () { return $d4ac688b6b4bfcdf$export$73d6f35be992df24; });

var $6YHRg = parcelRequire("6YHRg");
var $d4ac688b6b4bfcdf$export$2c8400d58aca05e = function(type, testProp) {
    return function(v) {
        return Boolean((0, $6YHRg.isString)(v) && (0, $6YHRg.singleColorRegex).test(v) && v.startsWith(type) || testProp && Object.prototype.hasOwnProperty.call(v, testProp));
    };
};
var $d4ac688b6b4bfcdf$export$73d6f35be992df24 = function(aName, bName, cName) {
    return function(v) {
        var _a;
        if (!(0, $6YHRg.isString)(v)) return v;
        var _b = v.match((0, $6YHRg.floatRegex)), a = _b[0], b = _b[1], c = _b[2], alpha = _b[3];
        return _a = {}, _a[aName] = parseFloat(a), _a[bName] = parseFloat(b), _a[cName] = parseFloat(c), _a.alpha = alpha !== undefined ? parseFloat(alpha) : 1, _a;
    };
};

});



parcelRegister("9CYrG", function(module, exports) {

$parcel$export(module.exports, "hsla", function () { return $70268ce4b13a3bef$export$810b04175080204c; });

var $5M3DJ = parcelRequire("5M3DJ");

var $4B3zo = parcelRequire("4B3zo");

var $6YHRg = parcelRequire("6YHRg");

var $ig3sQ = parcelRequire("ig3sQ");
var $70268ce4b13a3bef$export$810b04175080204c = {
    test: (0, $ig3sQ.isColorString)('hsl', 'hue'),
    parse: (0, $ig3sQ.splitColor)('hue', 'saturation', 'lightness'),
    transform: function(_a) {
        var hue = _a.hue, saturation = _a.saturation, lightness = _a.lightness, _b = _a.alpha, alpha$1 = _b === void 0 ? 1 : _b;
        return 'hsla(' + Math.round(hue) + ', ' + (0, $4B3zo.percent).transform((0, $6YHRg.sanitize)(saturation)) + ', ' + (0, $4B3zo.percent).transform((0, $6YHRg.sanitize)(lightness)) + ', ' + (0, $6YHRg.sanitize)((0, $5M3DJ.alpha).transform(alpha$1)) + ')';
    }
};

});


parcelRegister("6sZia", function(module, exports) {

$parcel$export(module.exports, "mixComplex", function () { return $4b54e6ec95da7545$export$65516310a87d8205; });
$parcel$export(module.exports, "mixArray", function () { return $4b54e6ec95da7545$export$3bbefa2f402845c4; });
$parcel$export(module.exports, "mixObject", function () { return $4b54e6ec95da7545$export$ebc23b6840c51ba1; });

var $66bGh = parcelRequire("66bGh");

var $d2IoU = parcelRequire("d2IoU");
var $iNhZm = parcelRequire("iNhZm");

var $203mS = parcelRequire("203mS");

var $j26Ak = parcelRequire("j26Ak");

var $ipA6L = parcelRequire("ipA6L");

var $6Zyiw = parcelRequire("6Zyiw");

var $739Hg = parcelRequire("739Hg");
function $4b54e6ec95da7545$var$getMixer(origin, target) {
    if ((0, $ipA6L.isNum)(origin)) return function(v) {
        return (0, $203mS.mix)(origin, target, v);
    };
    else if ((0, $d2IoU.color).test(origin)) return (0, $j26Ak.mixColor)(origin, target);
    else return $4b54e6ec95da7545$export$65516310a87d8205(origin, target);
}
var $4b54e6ec95da7545$export$3bbefa2f402845c4 = function(from, to) {
    var output = (0, $66bGh.__spreadArray)([], from);
    var numValues = output.length;
    var blendValue = from.map(function(fromThis, i) {
        return $4b54e6ec95da7545$var$getMixer(fromThis, to[i]);
    });
    return function(v) {
        for(var i = 0; i < numValues; i++)output[i] = blendValue[i](v);
        return output;
    };
};
var $4b54e6ec95da7545$export$ebc23b6840c51ba1 = function(origin, target) {
    var output = (0, $66bGh.__assign)((0, $66bGh.__assign)({}, origin), target);
    var blendValue = {};
    for(var key in output)if (origin[key] !== undefined && target[key] !== undefined) blendValue[key] = $4b54e6ec95da7545$var$getMixer(origin[key], target[key]);
    return function(v) {
        for(var key in blendValue)output[key] = blendValue[key](v);
        return output;
    };
};
function $4b54e6ec95da7545$var$analyse(value) {
    var parsed = (0, $iNhZm.complex).parse(value);
    var numValues = parsed.length;
    var numNumbers = 0;
    var numRGB = 0;
    var numHSL = 0;
    for(var i = 0; i < numValues; i++){
        if (numNumbers || typeof parsed[i] === "number") numNumbers++;
        else if (parsed[i].hue !== undefined) numHSL++;
        else numRGB++;
    }
    return {
        parsed: parsed,
        numNumbers: numNumbers,
        numRGB: numRGB,
        numHSL: numHSL
    };
}
var $4b54e6ec95da7545$export$65516310a87d8205 = function(origin, target) {
    var template = (0, $iNhZm.complex).createTransformer(target);
    var originStats = $4b54e6ec95da7545$var$analyse(origin);
    var targetStats = $4b54e6ec95da7545$var$analyse(target);
    (0, $739Hg.invariant)(originStats.numHSL === targetStats.numHSL && originStats.numRGB === targetStats.numRGB && originStats.numNumbers >= targetStats.numNumbers, "Complex values '" + origin + "' and '" + target + "' too different to mix. Ensure all colors are of the same type.");
    return (0, $6Zyiw.pipe)($4b54e6ec95da7545$export$3bbefa2f402845c4(originStats.parsed, targetStats.parsed), template);
};

});
parcelRegister("d2IoU", function(module, exports) {

$parcel$export(module.exports, "color", function () { return $97ede7522451d4ee$export$35e9368ef982300f; });

var $6YHRg = parcelRequire("6YHRg");

var $98rsj = parcelRequire("98rsj");

var $9CYrG = parcelRequire("9CYrG");

var $eMYvQ = parcelRequire("eMYvQ");
var $97ede7522451d4ee$export$35e9368ef982300f = {
    test: function(v) {
        return (0, $eMYvQ.rgba).test(v) || (0, $98rsj.hex).test(v) || (0, $9CYrG.hsla).test(v);
    },
    parse: function(v) {
        if ((0, $eMYvQ.rgba).test(v)) return (0, $eMYvQ.rgba).parse(v);
        else if ((0, $9CYrG.hsla).test(v)) return (0, $9CYrG.hsla).parse(v);
        else return (0, $98rsj.hex).parse(v);
    },
    transform: function(v) {
        return (0, $6YHRg.isString)(v) ? v : v.hasOwnProperty('red') ? (0, $eMYvQ.rgba).transform(v) : (0, $9CYrG.hsla).transform(v);
    }
};

});

parcelRegister("iNhZm", function(module, exports) {

$parcel$export(module.exports, "complex", function () { return $daeac1c856e3678e$export$83a0e34f1302825b; });

var $d2IoU = parcelRequire("d2IoU");

var $5M3DJ = parcelRequire("5M3DJ");

var $6YHRg = parcelRequire("6YHRg");
var $daeac1c856e3678e$var$colorToken = '${c}';
var $daeac1c856e3678e$var$numberToken = '${n}';
function $daeac1c856e3678e$var$test(v) {
    var _a, _b, _c, _d;
    return isNaN(v) && (0, $6YHRg.isString)(v) && ((_b = (_a = v.match((0, $6YHRg.floatRegex))) === null || _a === void 0 ? void 0 : _a.length) !== null && _b !== void 0 ? _b : 0) + ((_d = (_c = v.match((0, $6YHRg.colorRegex))) === null || _c === void 0 ? void 0 : _c.length) !== null && _d !== void 0 ? _d : 0) > 0;
}
function $daeac1c856e3678e$var$analyse(v) {
    var values = [];
    var numColors = 0;
    var colors = v.match((0, $6YHRg.colorRegex));
    if (colors) {
        numColors = colors.length;
        v = v.replace((0, $6YHRg.colorRegex), $daeac1c856e3678e$var$colorToken);
        values.push.apply(values, colors.map((0, $d2IoU.color).parse));
    }
    var numbers = v.match((0, $6YHRg.floatRegex));
    if (numbers) {
        v = v.replace((0, $6YHRg.floatRegex), $daeac1c856e3678e$var$numberToken);
        values.push.apply(values, numbers.map((0, $5M3DJ.number).parse));
    }
    return {
        values: values,
        numColors: numColors,
        tokenised: v
    };
}
function $daeac1c856e3678e$var$parse(v) {
    return $daeac1c856e3678e$var$analyse(v).values;
}
function $daeac1c856e3678e$var$createTransformer(v) {
    var _a = $daeac1c856e3678e$var$analyse(v), values = _a.values, numColors = _a.numColors, tokenised = _a.tokenised;
    var numValues = values.length;
    return function(v) {
        var output = tokenised;
        for(var i = 0; i < numValues; i++)output = output.replace(i < numColors ? $daeac1c856e3678e$var$colorToken : $daeac1c856e3678e$var$numberToken, i < numColors ? (0, $d2IoU.color).transform(v[i]) : (0, $6YHRg.sanitize)(v[i]));
        return output;
    };
}
var $daeac1c856e3678e$var$convertNumbersToZero = function(v) {
    return typeof v === 'number' ? 0 : v;
};
function $daeac1c856e3678e$var$getAnimatableNone(v) {
    var parsed = $daeac1c856e3678e$var$parse(v);
    var transformer = $daeac1c856e3678e$var$createTransformer(v);
    return transformer(parsed.map($daeac1c856e3678e$var$convertNumbersToZero));
}
var $daeac1c856e3678e$export$83a0e34f1302825b = {
    test: $daeac1c856e3678e$var$test,
    parse: $daeac1c856e3678e$var$parse,
    createTransformer: $daeac1c856e3678e$var$createTransformer,
    getAnimatableNone: $daeac1c856e3678e$var$getAnimatableNone
};

});

parcelRegister("ipA6L", function(module, exports) {

$parcel$export(module.exports, "isNum", function () { return $d6769219bdc46881$export$4e960b977ccfec97; });
var $d6769219bdc46881$export$c0c148ccc4f34a76 = {
    x: 0,
    y: 0,
    z: 0
};
var $d6769219bdc46881$export$4e960b977ccfec97 = function(v) {
    return typeof v === 'number';
};

});



parcelRegister("6viqV", function(module, exports) {

$parcel$export(module.exports, "linear", function () { return $4bc3efca5563f4c9$export$45db2fc2f15997e7; });
$parcel$export(module.exports, "easeIn", function () { return $4bc3efca5563f4c9$export$929e5a82286172a6; });
$parcel$export(module.exports, "easeOut", function () { return $4bc3efca5563f4c9$export$57636bb43b1ccbb0; });
$parcel$export(module.exports, "easeInOut", function () { return $4bc3efca5563f4c9$export$c07234257a03d5e9; });
$parcel$export(module.exports, "circIn", function () { return $4bc3efca5563f4c9$export$e444123e42d03385; });
$parcel$export(module.exports, "circOut", function () { return $4bc3efca5563f4c9$export$c8d67a19199d1a50; });
$parcel$export(module.exports, "circInOut", function () { return $4bc3efca5563f4c9$export$30d3455eee55bed5; });
$parcel$export(module.exports, "backIn", function () { return $4bc3efca5563f4c9$export$b01116c84cdfe1a2; });
$parcel$export(module.exports, "backOut", function () { return $4bc3efca5563f4c9$export$77edfce482316a60; });
$parcel$export(module.exports, "backInOut", function () { return $4bc3efca5563f4c9$export$ddc5fd596f6c71b2; });
$parcel$export(module.exports, "anticipate", function () { return $4bc3efca5563f4c9$export$6b0af63b873d419e; });
$parcel$export(module.exports, "bounceOut", function () { return $4bc3efca5563f4c9$export$cccc9e04465dce11; });
$parcel$export(module.exports, "bounceIn", function () { return $4bc3efca5563f4c9$export$fccebd7948554554; });
$parcel$export(module.exports, "bounceInOut", function () { return $4bc3efca5563f4c9$export$41ad9e9849a703ce; });

var $j0zTj = parcelRequire("j0zTj");
var $4bc3efca5563f4c9$var$DEFAULT_OVERSHOOT_STRENGTH = 1.525;
var $4bc3efca5563f4c9$var$BOUNCE_FIRST_THRESHOLD = 4.0 / 11.0;
var $4bc3efca5563f4c9$var$BOUNCE_SECOND_THRESHOLD = 8.0 / 11.0;
var $4bc3efca5563f4c9$var$BOUNCE_THIRD_THRESHOLD = 0.9;
var $4bc3efca5563f4c9$export$45db2fc2f15997e7 = function(p) {
    return p;
};
var $4bc3efca5563f4c9$export$929e5a82286172a6 = (0, $j0zTj.createExpoIn)(2);
var $4bc3efca5563f4c9$export$57636bb43b1ccbb0 = (0, $j0zTj.reverseEasing)($4bc3efca5563f4c9$export$929e5a82286172a6);
var $4bc3efca5563f4c9$export$c07234257a03d5e9 = (0, $j0zTj.mirrorEasing)($4bc3efca5563f4c9$export$929e5a82286172a6);
var $4bc3efca5563f4c9$export$e444123e42d03385 = function(p) {
    return 1 - Math.sin(Math.acos(p));
};
var $4bc3efca5563f4c9$export$c8d67a19199d1a50 = (0, $j0zTj.reverseEasing)($4bc3efca5563f4c9$export$e444123e42d03385);
var $4bc3efca5563f4c9$export$30d3455eee55bed5 = (0, $j0zTj.mirrorEasing)($4bc3efca5563f4c9$export$c8d67a19199d1a50);
var $4bc3efca5563f4c9$export$b01116c84cdfe1a2 = (0, $j0zTj.createBackIn)($4bc3efca5563f4c9$var$DEFAULT_OVERSHOOT_STRENGTH);
var $4bc3efca5563f4c9$export$77edfce482316a60 = (0, $j0zTj.reverseEasing)($4bc3efca5563f4c9$export$b01116c84cdfe1a2);
var $4bc3efca5563f4c9$export$ddc5fd596f6c71b2 = (0, $j0zTj.mirrorEasing)($4bc3efca5563f4c9$export$b01116c84cdfe1a2);
var $4bc3efca5563f4c9$export$6b0af63b873d419e = (0, $j0zTj.createAnticipate)($4bc3efca5563f4c9$var$DEFAULT_OVERSHOOT_STRENGTH);
var $4bc3efca5563f4c9$var$ca = 4356.0 / 361.0;
var $4bc3efca5563f4c9$var$cb = 35442.0 / 1805.0;
var $4bc3efca5563f4c9$var$cc = 16061.0 / 1805.0;
var $4bc3efca5563f4c9$export$cccc9e04465dce11 = function(p) {
    if (p === 1 || p === 0) return p;
    var p2 = p * p;
    return p < $4bc3efca5563f4c9$var$BOUNCE_FIRST_THRESHOLD ? 7.5625 * p2 : p < $4bc3efca5563f4c9$var$BOUNCE_SECOND_THRESHOLD ? 9.075 * p2 - 9.9 * p + 3.4 : p < $4bc3efca5563f4c9$var$BOUNCE_THIRD_THRESHOLD ? $4bc3efca5563f4c9$var$ca * p2 - $4bc3efca5563f4c9$var$cb * p + $4bc3efca5563f4c9$var$cc : 10.8 * p * p - 20.52 * p + 10.72;
};
var $4bc3efca5563f4c9$export$fccebd7948554554 = (0, $j0zTj.reverseEasing)($4bc3efca5563f4c9$export$cccc9e04465dce11);
var $4bc3efca5563f4c9$export$41ad9e9849a703ce = function(p) {
    return p < 0.5 ? 0.5 * (1.0 - $4bc3efca5563f4c9$export$cccc9e04465dce11(1.0 - p * 2.0)) : 0.5 * $4bc3efca5563f4c9$export$cccc9e04465dce11(p * 2.0 - 1.0) + 0.5;
};

});
parcelRegister("j0zTj", function(module, exports) {

$parcel$export(module.exports, "reverseEasing", function () { return $dd69dba508de2622$export$2c07eeff45156d4d; });
$parcel$export(module.exports, "mirrorEasing", function () { return $dd69dba508de2622$export$f946554fb8aeaf0d; });
$parcel$export(module.exports, "createExpoIn", function () { return $dd69dba508de2622$export$c90c8c5a3c7a5e80; });
$parcel$export(module.exports, "createBackIn", function () { return $dd69dba508de2622$export$2a739ba6da1d1495; });
$parcel$export(module.exports, "createAnticipate", function () { return $dd69dba508de2622$export$222fa0be41d8b537; });
var $dd69dba508de2622$export$2c07eeff45156d4d = function(easing) {
    return function(p) {
        return 1 - easing(1 - p);
    };
};
var $dd69dba508de2622$export$f946554fb8aeaf0d = function(easing) {
    return function(p) {
        return p <= 0.5 ? easing(2 * p) / 2 : (2 - easing(2 * (1 - p))) / 2;
    };
};
var $dd69dba508de2622$export$c90c8c5a3c7a5e80 = function(power) {
    return function(p) {
        return Math.pow(p, power);
    };
};
var $dd69dba508de2622$export$2a739ba6da1d1495 = function(power) {
    return function(p) {
        return p * p * ((power + 1) * p - power);
    };
};
var $dd69dba508de2622$export$222fa0be41d8b537 = function(power) {
    var backEasing = $dd69dba508de2622$export$2a739ba6da1d1495(power);
    return function(p) {
        return (p *= 2) < 1 ? 0.5 * backEasing(p) : 0.5 * (2 - Math.pow(2, -10 * (p - 1)));
    };
};

});



parcelRegister("9y7So", function(module, exports) {

$parcel$export(module.exports, "decay", function () { return $6f3d661738eec610$export$e9341ba102272ab9; });
function $6f3d661738eec610$export$e9341ba102272ab9(_a) {
    var _b = _a.velocity, velocity = _b === void 0 ? 0 : _b, _c = _a.from, from = _c === void 0 ? 0 : _c, _d = _a.power, power = _d === void 0 ? 0.8 : _d, _e = _a.timeConstant, timeConstant = _e === void 0 ? 350 : _e, _f = _a.restDelta, restDelta = _f === void 0 ? 0.5 : _f, modifyTarget = _a.modifyTarget;
    var state = {
        done: false,
        value: from
    };
    var amplitude = power * velocity;
    var ideal = from + amplitude;
    var target = modifyTarget === undefined ? ideal : modifyTarget(ideal);
    if (target !== ideal) amplitude = target - from;
    return {
        next: function(t) {
            var delta = -amplitude * Math.exp(-t / timeConstant);
            state.done = !(delta > restDelta || delta < -restDelta);
            state.value = state.done ? target : target + delta;
            return state;
        },
        flipTarget: function() {}
    };
}

});


parcelRegister("izbdP", function(module, exports) {

$parcel$export(module.exports, "loopElapsed", function () { return $d844335709c729e6$export$7d0784e050d8e25f; });
$parcel$export(module.exports, "reverseElapsed", function () { return $d844335709c729e6$export$ab9042754680126b; });
$parcel$export(module.exports, "hasRepeatDelayElapsed", function () { return $d844335709c729e6$export$c9c9437f9b8733b5; });
function $d844335709c729e6$export$7d0784e050d8e25f(elapsed, duration, delay) {
    if (delay === void 0) delay = 0;
    return elapsed - duration - delay;
}
function $d844335709c729e6$export$ab9042754680126b(elapsed, duration, delay, isForwardPlayback) {
    if (delay === void 0) delay = 0;
    if (isForwardPlayback === void 0) isForwardPlayback = true;
    return isForwardPlayback ? $d844335709c729e6$export$7d0784e050d8e25f(duration + -elapsed, duration, delay) : duration - (elapsed - duration) + delay;
}
function $d844335709c729e6$export$c9c9437f9b8733b5(elapsed, duration, delay, isForwardPlayback) {
    return isForwardPlayback ? elapsed >= duration + delay : elapsed <= -delay;
}

});


parcelRegister("i5erf", function(module, exports) {

$parcel$export(module.exports, "inertia", function () { return $0365bd7f434911ae$export$ee3ff3a17106998; });

var $66bGh = parcelRequire("66bGh");

var $95mwY = parcelRequire("95mwY");

var $i42T8 = parcelRequire("i42T8");

var $fzvX8 = parcelRequire("fzvX8");
function $0365bd7f434911ae$export$ee3ff3a17106998(_a) {
    var _b = _a.from, from = _b === void 0 ? 0 : _b, _c = _a.velocity, velocity = _c === void 0 ? 0 : _c, min = _a.min, max = _a.max, _d = _a.power, power = _d === void 0 ? 0.8 : _d, _e = _a.timeConstant, timeConstant = _e === void 0 ? 750 : _e, _f = _a.bounceStiffness, bounceStiffness = _f === void 0 ? 500 : _f, _g = _a.bounceDamping, bounceDamping = _g === void 0 ? 10 : _g, _h = _a.restDelta, restDelta = _h === void 0 ? 1 : _h, modifyTarget = _a.modifyTarget, driver = _a.driver, onUpdate = _a.onUpdate, onComplete = _a.onComplete;
    var currentAnimation;
    function isOutOfBounds(v) {
        return min !== undefined && v < min || max !== undefined && v > max;
    }
    function boundaryNearest(v) {
        if (min === undefined) return max;
        if (max === undefined) return min;
        return Math.abs(min - v) < Math.abs(max - v) ? min : max;
    }
    function startAnimation(options) {
        currentAnimation === null || currentAnimation === void 0 || currentAnimation.stop();
        currentAnimation = (0, $95mwY.animate)((0, $66bGh.__assign)((0, $66bGh.__assign)({}, options), {
            driver: driver,
            onUpdate: function(v) {
                var _a;
                onUpdate === null || onUpdate === void 0 || onUpdate(v);
                (_a = options.onUpdate) === null || _a === void 0 || _a.call(options, v);
            },
            onComplete: onComplete
        }));
    }
    function startSpring(options) {
        startAnimation((0, $66bGh.__assign)({
            type: "spring",
            stiffness: bounceStiffness,
            damping: bounceDamping,
            restDelta: restDelta
        }, options));
    }
    if (isOutOfBounds(from)) startSpring({
        from: from,
        velocity: velocity,
        to: boundaryNearest(from)
    });
    else {
        var target = power * velocity + from;
        if (typeof modifyTarget !== "undefined") target = modifyTarget(target);
        var boundary_1 = boundaryNearest(target);
        var heading_1 = boundary_1 === min ? -1 : 1;
        var prev_1;
        var current_1;
        var checkBoundary = function(v) {
            prev_1 = current_1;
            current_1 = v;
            velocity = (0, $i42T8.velocityPerSecond)(v - prev_1, (0, $fzvX8.getFrameData)().delta);
            if (heading_1 === 1 && v > boundary_1 || heading_1 === -1 && v < boundary_1) startSpring({
                from: v,
                to: boundary_1,
                velocity: velocity
            });
        };
        startAnimation({
            type: "decay",
            from: from,
            velocity: velocity,
            timeConstant: timeConstant,
            power: power,
            restDelta: restDelta,
            modifyTarget: modifyTarget,
            onUpdate: isOutOfBounds(target) ? checkBoundary : undefined
        });
    }
    return {
        stop: function() {
            return currentAnimation === null || currentAnimation === void 0 ? void 0 : currentAnimation.stop();
        }
    };
}

});
parcelRegister("i42T8", function(module, exports) {

$parcel$export(module.exports, "velocityPerSecond", function () { return $d26ad74928234e62$export$eab0632f7ad4f9d7; });
function $d26ad74928234e62$export$eab0632f7ad4f9d7(velocity, frameDuration) {
    return frameDuration ? velocity * (1000 / frameDuration) : 0;
}

});


parcelRegister("j5T2L", function(module, exports) {

$parcel$export(module.exports, "secondsToMilliseconds", function () { return $de692e749cf0ccd0$export$fc3e7e8557f8c8c7; });
/**
 * Converts seconds to milliseconds
 *
 * @param seconds - Time in seconds.
 * @return milliseconds - Converted time in milliseconds.
 */ var $de692e749cf0ccd0$export$fc3e7e8557f8c8c7 = function(seconds) {
    return seconds * 1000;
};

});

parcelRegister("bCkvz", function(module, exports) {

$parcel$export(module.exports, "easingDefinitionToFunction", function () { return $875326cdad02353e$export$ef97fe084f156ca4; });
$parcel$export(module.exports, "isEasingArray", function () { return $875326cdad02353e$export$216948827bbdc797; });

var $66bGh = parcelRequire("66bGh");

var $739Hg = parcelRequire("739Hg");

var $6viqV = parcelRequire("6viqV");
var $5fcWT = parcelRequire("5fcWT");
var $875326cdad02353e$var$easingLookup = {
    linear: (0, $6viqV.linear),
    easeIn: (0, $6viqV.easeIn),
    easeInOut: (0, $6viqV.easeInOut),
    easeOut: (0, $6viqV.easeOut),
    circIn: (0, $6viqV.circIn),
    circInOut: (0, $6viqV.circInOut),
    circOut: (0, $6viqV.circOut),
    backIn: (0, $6viqV.backIn),
    backInOut: (0, $6viqV.backInOut),
    backOut: (0, $6viqV.backOut),
    anticipate: (0, $6viqV.anticipate),
    bounceIn: (0, $6viqV.bounceIn),
    bounceInOut: (0, $6viqV.bounceInOut),
    bounceOut: (0, $6viqV.bounceOut)
};
var $875326cdad02353e$export$ef97fe084f156ca4 = function(definition) {
    if (Array.isArray(definition)) {
        // If cubic bezier definition, create bezier curve
        (0, $739Hg.invariant)(definition.length === 4, "Cubic bezier arrays must contain four numerical values.");
        var _a = (0, $66bGh.__read)(definition, 4), x1 = _a[0], y1 = _a[1], x2 = _a[2], y2 = _a[3];
        return (0, $5fcWT.cubicBezier)(x1, y1, x2, y2);
    } else if (typeof definition === "string") {
        // Else lookup from table
        (0, $739Hg.invariant)($875326cdad02353e$var$easingLookup[definition] !== undefined, "Invalid easing type '" + definition + "'");
        return $875326cdad02353e$var$easingLookup[definition];
    }
    return definition;
};
var $875326cdad02353e$export$216948827bbdc797 = function(ease) {
    return Array.isArray(ease) && typeof ease[0] !== "number";
};

});
parcelRegister("5fcWT", function(module, exports) {

$parcel$export(module.exports, "cubicBezier", function () { return $3d1865d68ef92dc3$export$2c575fa1d20488bd; });

var $6viqV = parcelRequire("6viqV");
var $3d1865d68ef92dc3$var$a = function(a1, a2) {
    return 1.0 - 3.0 * a2 + 3.0 * a1;
};
var $3d1865d68ef92dc3$var$b = function(a1, a2) {
    return 3.0 * a2 - 6.0 * a1;
};
var $3d1865d68ef92dc3$var$c = function(a1) {
    return 3.0 * a1;
};
var $3d1865d68ef92dc3$var$calcBezier = function(t, a1, a2) {
    return (($3d1865d68ef92dc3$var$a(a1, a2) * t + $3d1865d68ef92dc3$var$b(a1, a2)) * t + $3d1865d68ef92dc3$var$c(a1)) * t;
};
var $3d1865d68ef92dc3$var$getSlope = function(t, a1, a2) {
    return 3.0 * $3d1865d68ef92dc3$var$a(a1, a2) * t * t + 2.0 * $3d1865d68ef92dc3$var$b(a1, a2) * t + $3d1865d68ef92dc3$var$c(a1);
};
var $3d1865d68ef92dc3$var$subdivisionPrecision = 0.0000001;
var $3d1865d68ef92dc3$var$subdivisionMaxIterations = 10;
function $3d1865d68ef92dc3$var$binarySubdivide(aX, aA, aB, mX1, mX2) {
    var currentX;
    var currentT;
    var i = 0;
    do {
        currentT = aA + (aB - aA) / 2.0;
        currentX = $3d1865d68ef92dc3$var$calcBezier(currentT, mX1, mX2) - aX;
        if (currentX > 0.0) aB = currentT;
        else aA = currentT;
    }while (Math.abs(currentX) > $3d1865d68ef92dc3$var$subdivisionPrecision && ++i < $3d1865d68ef92dc3$var$subdivisionMaxIterations);
    return currentT;
}
var $3d1865d68ef92dc3$var$newtonIterations = 8;
var $3d1865d68ef92dc3$var$newtonMinSlope = 0.001;
function $3d1865d68ef92dc3$var$newtonRaphsonIterate(aX, aGuessT, mX1, mX2) {
    for(var i = 0; i < $3d1865d68ef92dc3$var$newtonIterations; ++i){
        var currentSlope = $3d1865d68ef92dc3$var$getSlope(aGuessT, mX1, mX2);
        if (currentSlope === 0.0) return aGuessT;
        var currentX = $3d1865d68ef92dc3$var$calcBezier(aGuessT, mX1, mX2) - aX;
        aGuessT -= currentX / currentSlope;
    }
    return aGuessT;
}
var $3d1865d68ef92dc3$var$kSplineTableSize = 11;
var $3d1865d68ef92dc3$var$kSampleStepSize = 1.0 / ($3d1865d68ef92dc3$var$kSplineTableSize - 1.0);
function $3d1865d68ef92dc3$export$2c575fa1d20488bd(mX1, mY1, mX2, mY2) {
    if (mX1 === mY1 && mX2 === mY2) return 0, $6viqV.linear;
    var sampleValues = new Float32Array($3d1865d68ef92dc3$var$kSplineTableSize);
    for(var i = 0; i < $3d1865d68ef92dc3$var$kSplineTableSize; ++i)sampleValues[i] = $3d1865d68ef92dc3$var$calcBezier(i * $3d1865d68ef92dc3$var$kSampleStepSize, mX1, mX2);
    function getTForX(aX) {
        var intervalStart = 0.0;
        var currentSample = 1;
        var lastSample = $3d1865d68ef92dc3$var$kSplineTableSize - 1;
        for(; currentSample !== lastSample && sampleValues[currentSample] <= aX; ++currentSample)intervalStart += $3d1865d68ef92dc3$var$kSampleStepSize;
        --currentSample;
        var dist = (aX - sampleValues[currentSample]) / (sampleValues[currentSample + 1] - sampleValues[currentSample]);
        var guessForT = intervalStart + dist * $3d1865d68ef92dc3$var$kSampleStepSize;
        var initialSlope = $3d1865d68ef92dc3$var$getSlope(guessForT, mX1, mX2);
        if (initialSlope >= $3d1865d68ef92dc3$var$newtonMinSlope) return $3d1865d68ef92dc3$var$newtonRaphsonIterate(aX, guessForT, mX1, mX2);
        else if (initialSlope === 0.0) return guessForT;
        else return $3d1865d68ef92dc3$var$binarySubdivide(aX, intervalStart, intervalStart + $3d1865d68ef92dc3$var$kSampleStepSize, mX1, mX2);
    }
    return function(t) {
        return t === 0 || t === 1 ? t : $3d1865d68ef92dc3$var$calcBezier(getTForX(t), mY1, mY2);
    };
}

});


parcelRegister("logPu", function(module, exports) {

$parcel$export(module.exports, "isAnimatable", function () { return $f928e4d81978d702$export$65676b58b122bc38; });

var $iNhZm = parcelRequire("iNhZm");
/**
 * Check if a value is animatable. Examples:
 *
 * ✅: 100, "100px", "#fff"
 * ❌: "block", "url(2.jpg)"
 * @param value
 *
 * @internal
 */ var $f928e4d81978d702$export$65676b58b122bc38 = function(key, value) {
    // If the list of keys tat might be non-animatable grows, replace with Set
    if (key === "zIndex") return false;
    // If it's a number or a keyframes array, we can animate it. We might at some point
    // need to do a deep isAnimatable check of keyframes, or let Popmotion handle this,
    // but for now lets leave it like this for performance reasons
    if (typeof value === "number" || Array.isArray(value)) return true;
    if (typeof value === "string" && // It's animatable if we have a string
    (0, $iNhZm.complex).test(value) && // And it contains numbers and/or colors
    !value.startsWith("url(") // Unless it starts with "url("
    ) return true;
    return false;
};

});

parcelRegister("jwNdj", function(module, exports) {

$parcel$export(module.exports, "getDefaultTransition", function () { return $e3772e466dfa6610$export$262124b154b9f1c0; });

var $66bGh = parcelRequire("66bGh");

var $3UqcD = parcelRequire("3UqcD");
var $e3772e466dfa6610$export$2577c2184b2254d3 = function() {
    return {
        type: "spring",
        stiffness: 500,
        damping: 25,
        restDelta: 0.5,
        restSpeed: 10
    };
};
var $e3772e466dfa6610$export$a743142a31c132c = function(to) {
    return {
        type: "spring",
        stiffness: 550,
        damping: to === 0 ? 2 * Math.sqrt(550) : 30,
        restDelta: 0.01,
        restSpeed: 10
    };
};
var $e3772e466dfa6610$export$c2d663fbb86d66d6 = function() {
    return {
        type: "keyframes",
        ease: "linear",
        duration: 0.3
    };
};
var $e3772e466dfa6610$var$keyframes = function(values) {
    return {
        type: "keyframes",
        duration: 0.8,
        values: values
    };
};
var $e3772e466dfa6610$var$defaultTransitions = {
    x: $e3772e466dfa6610$export$2577c2184b2254d3,
    y: $e3772e466dfa6610$export$2577c2184b2254d3,
    z: $e3772e466dfa6610$export$2577c2184b2254d3,
    rotate: $e3772e466dfa6610$export$2577c2184b2254d3,
    rotateX: $e3772e466dfa6610$export$2577c2184b2254d3,
    rotateY: $e3772e466dfa6610$export$2577c2184b2254d3,
    rotateZ: $e3772e466dfa6610$export$2577c2184b2254d3,
    scaleX: $e3772e466dfa6610$export$a743142a31c132c,
    scaleY: $e3772e466dfa6610$export$a743142a31c132c,
    scale: $e3772e466dfa6610$export$a743142a31c132c,
    opacity: $e3772e466dfa6610$export$c2d663fbb86d66d6,
    backgroundColor: $e3772e466dfa6610$export$c2d663fbb86d66d6,
    color: $e3772e466dfa6610$export$c2d663fbb86d66d6,
    default: $e3772e466dfa6610$export$a743142a31c132c
};
var $e3772e466dfa6610$export$262124b154b9f1c0 = function(valueKey, to) {
    var transitionFactory;
    if ((0, $3UqcD.isKeyframesTarget)(to)) transitionFactory = $e3772e466dfa6610$var$keyframes;
    else transitionFactory = $e3772e466dfa6610$var$defaultTransitions[valueKey] || $e3772e466dfa6610$var$defaultTransitions.default;
    return (0, $66bGh.__assign)({
        to: to
    }, transitionFactory(to));
};

});

parcelRegister("jqo75", function(module, exports) {

$parcel$export(module.exports, "getAnimatableNone", function () { return $e2432671b29867df$export$cea0cedcb94873b5; });

var $iNhZm = parcelRequire("iNhZm");
var $iMdsM = parcelRequire("iMdsM");

var $2fWSs = parcelRequire("2fWSs");
function $e2432671b29867df$export$cea0cedcb94873b5(key, value) {
    var _a;
    var defaultValueType = (0, $2fWSs.getDefaultValueType)(key);
    if (defaultValueType !== (0, $iMdsM.filter)) defaultValueType = (0, $iNhZm.complex);
    // If value is not recognised as animatable, ie "none", create an animatable version origin based on the target
    return (_a = defaultValueType.getAnimatableNone) === null || _a === void 0 ? void 0 : _a.call(defaultValueType, value);
}

});
parcelRegister("iMdsM", function(module, exports) {

$parcel$export(module.exports, "filter", function () { return $dab7272ec6698df0$export$3dea766d36a8935f; });

var $66bGh = parcelRequire("66bGh");

var $iNhZm = parcelRequire("iNhZm");

var $6YHRg = parcelRequire("6YHRg");
var $dab7272ec6698df0$var$maxDefaults = new Set([
    'brightness',
    'contrast',
    'saturate',
    'opacity'
]);
function $dab7272ec6698df0$var$applyDefaultFilter(v) {
    var _a = v.slice(0, -1).split('('), name = _a[0], value = _a[1];
    if (name === 'drop-shadow') return v;
    var number = (value.match((0, $6YHRg.floatRegex)) || [])[0];
    if (!number) return v;
    var unit = value.replace(number, '');
    var defaultValue = $dab7272ec6698df0$var$maxDefaults.has(name) ? 1 : 0;
    if (number !== value) defaultValue *= 100;
    return name + '(' + defaultValue + unit + ')';
}
var $dab7272ec6698df0$var$functionRegex = /([a-z-]*)\(.*?\)/g;
var $dab7272ec6698df0$export$3dea766d36a8935f = (0, $66bGh.__assign)((0, $66bGh.__assign)({}, (0, $iNhZm.complex)), {
    getAnimatableNone: function(v) {
        var functions = v.match($dab7272ec6698df0$var$functionRegex);
        return functions ? functions.map($dab7272ec6698df0$var$applyDefaultFilter).join(' ') : v;
    }
});

});

parcelRegister("2fWSs", function(module, exports) {

$parcel$export(module.exports, "getDefaultValueType", function () { return $1a4aa752c2000d98$export$67d1babe0338d23b; });

var $66bGh = parcelRequire("66bGh");

var $d2IoU = parcelRequire("d2IoU");
var $iMdsM = parcelRequire("iMdsM");

var $5qVHO = parcelRequire("5qVHO");
/**
 * A map of default value types for common values
 */ var $1a4aa752c2000d98$export$98cd7c72c5a731fb = (0, $66bGh.__assign)((0, $66bGh.__assign)({}, (0, $5qVHO.numberValueTypes)), {
    // Color props
    color: (0, $d2IoU.color),
    backgroundColor: (0, $d2IoU.color),
    outlineColor: (0, $d2IoU.color),
    fill: (0, $d2IoU.color),
    stroke: (0, $d2IoU.color),
    // Border props
    borderColor: (0, $d2IoU.color),
    borderTopColor: (0, $d2IoU.color),
    borderRightColor: (0, $d2IoU.color),
    borderBottomColor: (0, $d2IoU.color),
    borderLeftColor: (0, $d2IoU.color),
    filter: (0, $iMdsM.filter),
    WebkitFilter: (0, $iMdsM.filter)
});
/**
 * Gets the default ValueType for the provided value key
 */ var $1a4aa752c2000d98$export$67d1babe0338d23b = function(key) {
    return $1a4aa752c2000d98$export$98cd7c72c5a731fb[key];
};

});



parcelRegister("cA2Zn", function(module, exports) {

$parcel$export(module.exports, "setTarget", function () { return $928b2a5898bb1809$export$1f61c53461aff4a5; });
$parcel$export(module.exports, "checkTargetForNewValues", function () { return $928b2a5898bb1809$export$6afbed164019a54c; });
$parcel$export(module.exports, "getOrigin", function () { return $928b2a5898bb1809$export$5a759dc7a1cfb72a; });

var $66bGh = parcelRequire("66bGh");

var $iNhZm = parcelRequire("iNhZm");

var $dxeVa = parcelRequire("dxeVa");

var $5q7SE = parcelRequire("5q7SE");

var $1XUdZ = parcelRequire("1XUdZ");

var $jqo75 = parcelRequire("jqo75");

var $7UN6w = parcelRequire("7UN6w");

var $g4bZm = parcelRequire("g4bZm");
/**
 * Set VisualElement's MotionValue, creating a new MotionValue for it if
 * it doesn't exist.
 */ function $928b2a5898bb1809$var$setMotionValue(visualElement, key, value) {
    if (visualElement.hasValue(key)) visualElement.getValue(key).set(value);
    else visualElement.addValue(key, (0, $1XUdZ.motionValue)(value));
}
function $928b2a5898bb1809$export$1f61c53461aff4a5(visualElement, definition) {
    var resolved = (0, $g4bZm.resolveVariant)(visualElement, definition);
    var _a = resolved ? visualElement.makeTargetAnimatable(resolved, false) : {}, _b = _a.transitionEnd, transitionEnd = _b === void 0 ? {} : _b;
    _a.transition;
    var target = (0, $66bGh.__rest)(_a, [
        "transitionEnd",
        "transition"
    ]);
    target = (0, $66bGh.__assign)((0, $66bGh.__assign)({}, target), transitionEnd);
    for(var key in target){
        var value = (0, $5q7SE.resolveFinalValueInKeyframes)(target[key]);
        $928b2a5898bb1809$var$setMotionValue(visualElement, key, value);
    }
}
function $928b2a5898bb1809$var$setVariants(visualElement, variantLabels) {
    var reversedLabels = (0, $66bGh.__spreadArray)([], (0, $66bGh.__read)(variantLabels)).reverse();
    reversedLabels.forEach(function(key) {
        var _a;
        var variant = visualElement.getVariant(key);
        variant && $928b2a5898bb1809$export$1f61c53461aff4a5(visualElement, variant);
        (_a = visualElement.variantChildren) === null || _a === void 0 || _a.forEach(function(child) {
            $928b2a5898bb1809$var$setVariants(child, variantLabels);
        });
    });
}
function $928b2a5898bb1809$export$b7771d60d308862f(visualElement, definition) {
    if (Array.isArray(definition)) return $928b2a5898bb1809$var$setVariants(visualElement, definition);
    else if (typeof definition === "string") return $928b2a5898bb1809$var$setVariants(visualElement, [
        definition
    ]);
    else $928b2a5898bb1809$export$1f61c53461aff4a5(visualElement, definition);
}
function $928b2a5898bb1809$export$6afbed164019a54c(visualElement, target, origin) {
    var _a, _b, _c;
    var _d;
    var newValueKeys = Object.keys(target).filter(function(key) {
        return !visualElement.hasValue(key);
    });
    var numNewValues = newValueKeys.length;
    if (!numNewValues) return;
    for(var i = 0; i < numNewValues; i++){
        var key = newValueKeys[i];
        var targetValue = target[key];
        var value = null;
        /**
         * If the target is a series of keyframes, we can use the first value
         * in the array. If this first value is null, we'll still need to read from the DOM.
         */ if (Array.isArray(targetValue)) value = targetValue[0];
        /**
         * If the target isn't keyframes, or the first keyframe was null, we need to
         * first check if an origin value was explicitly defined in the transition as "from",
         * if not read the value from the DOM. As an absolute fallback, take the defined target value.
         */ if (value === null) value = (_b = (_a = origin[key]) !== null && _a !== void 0 ? _a : visualElement.readValue(key)) !== null && _b !== void 0 ? _b : target[key];
        /**
         * If value is still undefined or null, ignore it. Preferably this would throw,
         * but this was causing issues in Framer.
         */ if (value === undefined || value === null) continue;
        if (typeof value === "string" && (0, $dxeVa.isNumericalString)(value)) // If this is a number read as a string, ie "0" or "200", convert it to a number
        value = parseFloat(value);
        else if (!(0, $7UN6w.findValueType)(value) && (0, $iNhZm.complex).test(targetValue)) value = (0, $jqo75.getAnimatableNone)(key, targetValue);
        visualElement.addValue(key, (0, $1XUdZ.motionValue)(value));
        (_c = (_d = origin)[key]) !== null && _c !== void 0 ? _c : _d[key] = value;
        visualElement.setBaseTarget(key, value);
    }
}
function $928b2a5898bb1809$export$c3befe8e18686628(key, transition) {
    if (!transition) return;
    var valueTransition = transition[key] || transition["default"] || transition;
    return valueTransition.from;
}
function $928b2a5898bb1809$export$5a759dc7a1cfb72a(target, transition, visualElement) {
    var _a, _b;
    var origin = {};
    for(var key in target)origin[key] = (_a = $928b2a5898bb1809$export$c3befe8e18686628(key, transition)) !== null && _a !== void 0 ? _a : (_b = visualElement.getValue(key)) === null || _b === void 0 ? void 0 : _b.get();
    return origin;
}

});
parcelRegister("dxeVa", function(module, exports) {

$parcel$export(module.exports, "isNumericalString", function () { return $9da9ee73f5de1b5d$export$65583ed5a868f2d9; });
/**
 * Check if value is a numerical string, ie a string that is purely a number eg "100" or "-100.1"
 */ var $9da9ee73f5de1b5d$export$65583ed5a868f2d9 = function(v) {
    return /^\-?\d*\.?\d+$/.test(v);
};

});

parcelRegister("1XUdZ", function(module, exports) {

$parcel$export(module.exports, "motionValue", function () { return $16e6ea2d628d409a$export$ce8bdc721e76545f; });

var $fzvX8 = parcelRequire("fzvX8");

var $i42T8 = parcelRequire("i42T8");

var $Q8xMG = parcelRequire("Q8xMG");
var $16e6ea2d628d409a$var$isFloat = function(value) {
    return !isNaN(parseFloat(value));
};
/**
 * `MotionValue` is used to track the state and velocity of motion values.
 *
 * @public
 */ var $16e6ea2d628d409a$export$8cea36d14ee64562 = /** @class */ function() {
    /**
     * @param init - The initiating value
     * @param config - Optional configuration options
     *
     * -  `transformer`: A function to transform incoming values with.
     *
     * @internal
     */ function MotionValue(init) {
        var _this = this;
        /**
         * Duration, in milliseconds, since last updating frame.
         *
         * @internal
         */ this.timeDelta = 0;
        /**
         * Timestamp of the last time this `MotionValue` was updated.
         *
         * @internal
         */ this.lastUpdated = 0;
        /**
         * Functions to notify when the `MotionValue` updates.
         *
         * @internal
         */ this.updateSubscribers = new (0, $Q8xMG.SubscriptionManager)();
        /**
         * Functions to notify when the velocity updates.
         *
         * @internal
         */ this.velocityUpdateSubscribers = new (0, $Q8xMG.SubscriptionManager)();
        /**
         * Functions to notify when the `MotionValue` updates and `render` is set to `true`.
         *
         * @internal
         */ this.renderSubscribers = new (0, $Q8xMG.SubscriptionManager)();
        /**
         * Tracks whether this value can output a velocity. Currently this is only true
         * if the value is numerical, but we might be able to widen the scope here and support
         * other value types.
         *
         * @internal
         */ this.canTrackVelocity = false;
        this.updateAndNotify = function(v, render) {
            if (render === void 0) render = true;
            _this.prev = _this.current;
            _this.current = v;
            // Update timestamp
            var _a = (0, $fzvX8.getFrameData)(), delta = _a.delta, timestamp = _a.timestamp;
            if (_this.lastUpdated !== timestamp) {
                _this.timeDelta = delta;
                _this.lastUpdated = timestamp;
                (0, $fzvX8.default).postRender(_this.scheduleVelocityCheck);
            }
            // Update update subscribers
            if (_this.prev !== _this.current) _this.updateSubscribers.notify(_this.current);
            // Update velocity subscribers
            if (_this.velocityUpdateSubscribers.getSize()) _this.velocityUpdateSubscribers.notify(_this.getVelocity());
            // Update render subscribers
            if (render) _this.renderSubscribers.notify(_this.current);
        };
        /**
         * Schedule a velocity check for the next frame.
         *
         * This is an instanced and bound function to prevent generating a new
         * function once per frame.
         *
         * @internal
         */ this.scheduleVelocityCheck = function() {
            return (0, $fzvX8.default).postRender(_this.velocityCheck);
        };
        /**
         * Updates `prev` with `current` if the value hasn't been updated this frame.
         * This ensures velocity calculations return `0`.
         *
         * This is an instanced and bound function to prevent generating a new
         * function once per frame.
         *
         * @internal
         */ this.velocityCheck = function(_a) {
            var timestamp = _a.timestamp;
            if (timestamp !== _this.lastUpdated) {
                _this.prev = _this.current;
                _this.velocityUpdateSubscribers.notify(_this.getVelocity());
            }
        };
        this.hasAnimated = false;
        this.prev = this.current = init;
        this.canTrackVelocity = $16e6ea2d628d409a$var$isFloat(this.current);
    }
    /**
     * Adds a function that will be notified when the `MotionValue` is updated.
     *
     * It returns a function that, when called, will cancel the subscription.
     *
     * When calling `onChange` inside a React component, it should be wrapped with the
     * `useEffect` hook. As it returns an unsubscribe function, this should be returned
     * from the `useEffect` function to ensure you don't add duplicate subscribers..
     *
     * @library
     *
     * ```jsx
     * function MyComponent() {
     *   const x = useMotionValue(0)
     *   const y = useMotionValue(0)
     *   const opacity = useMotionValue(1)
     *
     *   useEffect(() => {
     *     function updateOpacity() {
     *       const maxXY = Math.max(x.get(), y.get())
     *       const newOpacity = transform(maxXY, [0, 100], [1, 0])
     *       opacity.set(newOpacity)
     *     }
     *
     *     const unsubscribeX = x.onChange(updateOpacity)
     *     const unsubscribeY = y.onChange(updateOpacity)
     *
     *     return () => {
     *       unsubscribeX()
     *       unsubscribeY()
     *     }
     *   }, [])
     *
     *   return <Frame x={x} />
     * }
     * ```
     *
     * @motion
     *
     * ```jsx
     * export const MyComponent = () => {
     *   const x = useMotionValue(0)
     *   const y = useMotionValue(0)
     *   const opacity = useMotionValue(1)
     *
     *   useEffect(() => {
     *     function updateOpacity() {
     *       const maxXY = Math.max(x.get(), y.get())
     *       const newOpacity = transform(maxXY, [0, 100], [1, 0])
     *       opacity.set(newOpacity)
     *     }
     *
     *     const unsubscribeX = x.onChange(updateOpacity)
     *     const unsubscribeY = y.onChange(updateOpacity)
     *
     *     return () => {
     *       unsubscribeX()
     *       unsubscribeY()
     *     }
     *   }, [])
     *
     *   return <motion.div style={{ x }} />
     * }
     * ```
     *
     * @internalremarks
     *
     * We could look into a `useOnChange` hook if the above lifecycle management proves confusing.
     *
     * ```jsx
     * useOnChange(x, () => {})
     * ```
     *
     * @param subscriber - A function that receives the latest value.
     * @returns A function that, when called, will cancel this subscription.
     *
     * @public
     */ MotionValue.prototype.onChange = function(subscription) {
        return this.updateSubscribers.add(subscription);
    };
    MotionValue.prototype.clearListeners = function() {
        this.updateSubscribers.clear();
    };
    /**
     * Adds a function that will be notified when the `MotionValue` requests a render.
     *
     * @param subscriber - A function that's provided the latest value.
     * @returns A function that, when called, will cancel this subscription.
     *
     * @internal
     */ MotionValue.prototype.onRenderRequest = function(subscription) {
        // Render immediately
        subscription(this.get());
        return this.renderSubscribers.add(subscription);
    };
    /**
     * Attaches a passive effect to the `MotionValue`.
     *
     * @internal
     */ MotionValue.prototype.attach = function(passiveEffect) {
        this.passiveEffect = passiveEffect;
    };
    /**
     * Sets the state of the `MotionValue`.
     *
     * @remarks
     *
     * ```jsx
     * const x = useMotionValue(0)
     * x.set(10)
     * ```
     *
     * @param latest - Latest value to set.
     * @param render - Whether to notify render subscribers. Defaults to `true`
     *
     * @public
     */ MotionValue.prototype.set = function(v, render) {
        if (render === void 0) render = true;
        if (!render || !this.passiveEffect) this.updateAndNotify(v, render);
        else this.passiveEffect(v, this.updateAndNotify);
    };
    /**
     * Returns the latest state of `MotionValue`
     *
     * @returns - The latest state of `MotionValue`
     *
     * @public
     */ MotionValue.prototype.get = function() {
        return this.current;
    };
    /**
     * @public
     */ MotionValue.prototype.getPrevious = function() {
        return this.prev;
    };
    /**
     * Returns the latest velocity of `MotionValue`
     *
     * @returns - The latest velocity of `MotionValue`. Returns `0` if the state is non-numerical.
     *
     * @public
     */ MotionValue.prototype.getVelocity = function() {
        // This could be isFloat(this.prev) && isFloat(this.current), but that would be wasteful
        return this.canTrackVelocity ? (0, $i42T8.velocityPerSecond)(parseFloat(this.current) - parseFloat(this.prev), this.timeDelta) : 0;
    };
    /**
     * Registers a new animation to control this `MotionValue`. Only one
     * animation can drive a `MotionValue` at one time.
     *
     * ```jsx
     * value.start()
     * ```
     *
     * @param animation - A function that starts the provided animation
     *
     * @internal
     */ MotionValue.prototype.start = function(animation) {
        var _this = this;
        this.stop();
        return new Promise(function(resolve) {
            _this.hasAnimated = true;
            _this.stopAnimation = animation(resolve);
        }).then(function() {
            return _this.clearAnimation();
        });
    };
    /**
     * Stop the currently active animation.
     *
     * @public
     */ MotionValue.prototype.stop = function() {
        if (this.stopAnimation) this.stopAnimation();
        this.clearAnimation();
    };
    /**
     * Returns `true` if this value is currently animating.
     *
     * @public
     */ MotionValue.prototype.isAnimating = function() {
        return !!this.stopAnimation;
    };
    MotionValue.prototype.clearAnimation = function() {
        this.stopAnimation = null;
    };
    /**
     * Destroy and clean up subscribers to this `MotionValue`.
     *
     * The `MotionValue` hooks like `useMotionValue` and `useTransform` automatically
     * handle the lifecycle of the returned `MotionValue`, so this method is only necessary if you've manually
     * created a `MotionValue` via the `motionValue` function.
     *
     * @public
     */ MotionValue.prototype.destroy = function() {
        this.updateSubscribers.clear();
        this.renderSubscribers.clear();
        this.stop();
    };
    return MotionValue;
}();
/**
 * @internal
 */ function $16e6ea2d628d409a$export$ce8bdc721e76545f(init) {
    return new $16e6ea2d628d409a$export$8cea36d14ee64562(init);
}

});
parcelRegister("Q8xMG", function(module, exports) {

$parcel$export(module.exports, "SubscriptionManager", function () { return $09cb7c15eee11bb3$export$e7dff9482a5fd23c; });

var $chivA = parcelRequire("chivA");
var $09cb7c15eee11bb3$export$e7dff9482a5fd23c = /** @class */ function() {
    function SubscriptionManager() {
        this.subscriptions = [];
    }
    SubscriptionManager.prototype.add = function(handler) {
        var _this = this;
        (0, $chivA.addUniqueItem)(this.subscriptions, handler);
        return function() {
            return (0, $chivA.removeItem)(_this.subscriptions, handler);
        };
    };
    SubscriptionManager.prototype.notify = function(a, b, c) {
        var numSubscriptions = this.subscriptions.length;
        if (!numSubscriptions) return;
        if (numSubscriptions === 1) /**
             * If there's only a single handler we can just call it without invoking a loop.
             */ this.subscriptions[0](a, b, c);
        else for(var i = 0; i < numSubscriptions; i++){
            /**
                 * Check whether the handler exists before firing as it's possible
                 * the subscriptions were modified during this loop running.
                 */ var handler = this.subscriptions[i];
            handler && handler(a, b, c);
        }
    };
    SubscriptionManager.prototype.getSize = function() {
        return this.subscriptions.length;
    };
    SubscriptionManager.prototype.clear = function() {
        this.subscriptions.length = 0;
    };
    return SubscriptionManager;
}();

});
parcelRegister("chivA", function(module, exports) {

$parcel$export(module.exports, "addUniqueItem", function () { return $8f056df14035621e$export$20e507e47fae79fd; });
$parcel$export(module.exports, "removeItem", function () { return $8f056df14035621e$export$fe2d9b4e03920b4c; });
function $8f056df14035621e$export$20e507e47fae79fd(arr, item) {
    arr.indexOf(item) === -1 && arr.push(item);
}
function $8f056df14035621e$export$fe2d9b4e03920b4c(arr, item) {
    var index = arr.indexOf(item);
    index > -1 && arr.splice(index, 1);
}

});



parcelRegister("7UN6w", function(module, exports) {

$parcel$export(module.exports, "findValueType", function () { return $5c33da6dc606356b$export$950e7e59ea1ffed7; });

var $66bGh = parcelRequire("66bGh");

var $d2IoU = parcelRequire("d2IoU");
var $iNhZm = parcelRequire("iNhZm");

var $kjEle = parcelRequire("kjEle");

var $7iRSr = parcelRequire("7iRSr");
/**
 * A list of all ValueTypes
 */ var $5c33da6dc606356b$var$valueTypes = (0, $66bGh.__spreadArray)((0, $66bGh.__spreadArray)([], (0, $66bGh.__read)((0, $kjEle.dimensionValueTypes))), [
    (0, $d2IoU.color),
    (0, $iNhZm.complex)
]);
/**
 * Tests a value against the list of ValueTypes
 */ var $5c33da6dc606356b$export$950e7e59ea1ffed7 = function(v) {
    return $5c33da6dc606356b$var$valueTypes.find((0, $7iRSr.testValueType)(v));
};

});
parcelRegister("kjEle", function(module, exports) {

$parcel$export(module.exports, "dimensionValueTypes", function () { return $eca4dff47475ca27$export$d176691c1998a1f5; });
$parcel$export(module.exports, "findDimensionValueType", function () { return $eca4dff47475ca27$export$eefdd52e3ccae428; });

var $4B3zo = parcelRequire("4B3zo");
var $5M3DJ = parcelRequire("5M3DJ");

var $7iRSr = parcelRequire("7iRSr");

var $ipkz3 = parcelRequire("ipkz3");
/**
 * A list of value types commonly used for dimensions
 */ var $eca4dff47475ca27$export$d176691c1998a1f5 = [
    (0, $5M3DJ.number),
    (0, $4B3zo.px),
    (0, $4B3zo.percent),
    (0, $4B3zo.degrees),
    (0, $4B3zo.vw),
    (0, $4B3zo.vh),
    (0, $ipkz3.auto)
];
/**
 * Tests a dimensional value against the list of dimension ValueTypes
 */ var $eca4dff47475ca27$export$eefdd52e3ccae428 = function(v) {
    return $eca4dff47475ca27$export$d176691c1998a1f5.find((0, $7iRSr.testValueType)(v));
};

});
parcelRegister("7iRSr", function(module, exports) {

$parcel$export(module.exports, "testValueType", function () { return $551401b9b709c627$export$6eae4d0a6a7ca7cd; });
/**
 * Tests a provided value against a ValueType
 */ var $551401b9b709c627$export$6eae4d0a6a7ca7cd = function(v) {
    return function(type) {
        return type.test(v);
    };
};

});

parcelRegister("ipkz3", function(module, exports) {

$parcel$export(module.exports, "auto", function () { return $d66a837909645307$export$dfb5619354ba860; });
/**
 * ValueType for "auto"
 */ var $d66a837909645307$export$dfb5619354ba860 = {
    test: function(v) {
        return v === "auto";
    },
    parse: function(v) {
        return v;
    }
};

});







parcelRegister("7A2EQ", function(module, exports) {

$parcel$export(module.exports, "drag", function () { return $584df4fe2f805b3b$export$d7d5d435647ed5a0; });

var $jAA1Z = parcelRequire("jAA1Z");

var $b2d4x = parcelRequire("b2d4x");

var $eBj6o = parcelRequire("eBj6o");
var $584df4fe2f805b3b$export$d7d5d435647ed5a0 = {
    pan: (0, $eBj6o.makeRenderlessComponent)((0, $b2d4x.usePanGesture)),
    drag: (0, $eBj6o.makeRenderlessComponent)((0, $jAA1Z.useDrag))
};

});
parcelRegister("jAA1Z", function(module, exports) {

$parcel$export(module.exports, "useDrag", function () { return $e42d541e1ffe84e4$export$7941f8aafa4b6021; });

var $66bGh = parcelRequire("66bGh");

var $gJYWc = parcelRequire("gJYWc");

var $cUvlw = parcelRequire("cUvlw");

var $7JDUU = parcelRequire("7JDUU");

var $j0JMo = parcelRequire("j0JMo");
/**
 * A hook that allows an element to be dragged.
 *
 * @internal
 */ function $e42d541e1ffe84e4$export$7941f8aafa4b6021(props) {
    var groupDragControls = props.dragControls, visualElement = props.visualElement;
    var transformPagePoint = (0, $gJYWc.useContext)((0, $cUvlw.MotionConfigContext)).transformPagePoint;
    var dragControls = (0, $j0JMo.useConstant)(function() {
        return new (0, $7JDUU.VisualElementDragControls)({
            visualElement: visualElement
        });
    });
    dragControls.setProps((0, $66bGh.__assign)((0, $66bGh.__assign)({}, props), {
        transformPagePoint: transformPagePoint
    }));
    // If we've been provided a DragControls for manual control over the drag gesture,
    // subscribe this component to it on mount.
    (0, $gJYWc.useEffect)(function() {
        return groupDragControls && groupDragControls.subscribe(dragControls);
    }, [
        dragControls
    ]);
    // Mount the drag controls with the visualElement
    (0, $gJYWc.useEffect)(function() {
        return dragControls.mount(visualElement);
    }, []);
}

});
parcelRegister("7JDUU", function(module, exports) {

$parcel$export(module.exports, "VisualElementDragControls", function () { return $5a1bb30bf03821e5$export$86bff71f18910307; });

var $66bGh = parcelRequire("66bGh");

var $739Hg = parcelRequire("739Hg");

var $hfXOZ = parcelRequire("hfXOZ");

var $inZZ1 = parcelRequire("inZZ1");

var $ixxQP = parcelRequire("ixxQP");

var $bN9Oo = parcelRequire("bN9Oo");

var $eCb0d = parcelRequire("eCb0d");

var $13MxN = parcelRequire("13MxN");

var $hJbCe = parcelRequire("hJbCe");

var $bbVsu = parcelRequire("bbVsu");

var $gdjM3 = parcelRequire("gdjM3");

var $lphzD = parcelRequire("lphzD");

var $hDYE8 = parcelRequire("hDYE8");

var $6CYZP = parcelRequire("6CYZP");

var $9Ujt6 = parcelRequire("9Ujt6");

var $52vCk = parcelRequire("52vCk");

var $iz4xc = parcelRequire("iz4xc");

var $avXQG = parcelRequire("avXQG");

var $a789I = parcelRequire("a789I");

var $lxfWR = parcelRequire("lxfWR");

var $fzvX8 = parcelRequire("fzvX8");
var $5a1bb30bf03821e5$export$f0a15892c27dc07c = new WeakMap();
/**
 *
 */ var $5a1bb30bf03821e5$var$lastPointerEvent;
var $5a1bb30bf03821e5$export$86bff71f18910307 = /** @class */ function() {
    function VisualElementDragControls(_a) {
        var visualElement = _a.visualElement;
        /**
         * Track whether we're currently dragging.
         *
         * @internal
         */ this.isDragging = false;
        /**
         * The current direction of drag, or `null` if both.
         *
         * @internal
         */ this.currentDirection = null;
        /**
         * The permitted boundaries of travel, in pixels.
         *
         * @internal
         */ this.constraints = false;
        /**
         * The per-axis resolved elastic values.
         *
         * @internal
         */ this.elastic = (0, $hJbCe.axisBox)();
        /**
         * A reference to the host component's latest props.
         *
         * @internal
         */ this.props = {};
        /**
         * @internal
         */ this.hasMutatedConstraints = false;
        /**
         * Track the initial position of the cursor relative to the dragging element
         * when dragging starts as a value of 0-1 on each axis. We then use this to calculate
         * an ideal bounding box for the VisualElement renderer to project into every frame.
         *
         * @internal
         */ this.cursorProgress = {
            x: 0.5,
            y: 0.5
        };
        // When updating _dragX, or _dragY instead of the VisualElement,
        // persist their values between drag gestures.
        this.originPoint = {};
        // This is a reference to the global drag gesture lock, ensuring only one component
        // can "capture" the drag of one or both axes.
        // TODO: Look into moving this into pansession?
        this.openGlobalLock = null;
        /**
         * @internal
         */ this.panSession = null;
        this.visualElement = visualElement;
        this.visualElement.enableLayoutProjection();
        $5a1bb30bf03821e5$export$f0a15892c27dc07c.set(visualElement, this);
    }
    /**
     * Instantiate a PanSession for the drag gesture
     *
     * @public
     */ VisualElementDragControls.prototype.start = function(originEvent, _a) {
        var _this = this;
        var _b = _a === void 0 ? {} : _a, _c = _b.snapToCursor, snapToCursor = _c === void 0 ? false : _c, cursorProgress = _b.cursorProgress;
        var onSessionStart = function(event) {
            var _a;
            // Stop any animations on both axis values immediately. This allows the user to throw and catch
            // the component.
            _this.stopMotion();
            /**
             * Save the initial point. We'll use this to calculate the pointer's position rather
             * than the one we receive when the gesture actually starts. By then, the pointer will
             * have already moved, and the perception will be of the pointer "slipping" across the element
             */ var initialPoint = (0, $13MxN.getViewportPointFromEvent)(event).point;
            (_a = _this.cancelLayout) === null || _a === void 0 || _a.call(_this);
            _this.cancelLayout = (0, $lxfWR.batchLayout)(function(read, write) {
                var ancestors = (0, $52vCk.collectProjectingAncestors)(_this.visualElement);
                var children = (0, $52vCk.collectProjectingChildren)(_this.visualElement);
                var tree = (0, $66bGh.__spreadArray)((0, $66bGh.__spreadArray)([], (0, $66bGh.__read)(ancestors)), (0, $66bGh.__read)(children));
                var hasManuallySetCursorOrigin = false;
                /**
                 * Apply a simple lock to the projection target. This ensures no animations
                 * can run on the projection box while this lock is active.
                 */ _this.isLayoutDrag() && _this.visualElement.lockProjectionTarget();
                write(function() {
                    tree.forEach(function(element) {
                        return element.resetTransform();
                    });
                });
                read(function() {
                    (0, $52vCk.updateLayoutMeasurement)(_this.visualElement);
                    children.forEach((0, $52vCk.updateLayoutMeasurement));
                });
                write(function() {
                    tree.forEach(function(element) {
                        return element.restoreTransform();
                    });
                    if (snapToCursor) hasManuallySetCursorOrigin = _this.snapToCursor(initialPoint);
                });
                read(function() {
                    var isRelativeDrag = Boolean(_this.getAxisMotionValue("x") && !_this.isExternalDrag());
                    if (!isRelativeDrag) _this.visualElement.rebaseProjectionTarget(true, _this.visualElement.measureViewportBox(false));
                    _this.visualElement.scheduleUpdateLayoutProjection();
                    /**
                     * When dragging starts, we want to find where the cursor is relative to the bounding box
                     * of the element. Every frame, we calculate a new bounding box using this relative position
                     * and let the visualElement renderer figure out how to reproject the element into this bounding
                     * box.
                     *
                     * By doing it this way, rather than applying an x/y transform directly to the element,
                     * we can ensure the component always visually sticks to the cursor as we'd expect, even
                     * if the DOM element itself changes layout as a result of React updates the user might
                     * make based on the drag position.
                     */ var projection = _this.visualElement.projection;
                    (0, $bbVsu.eachAxis)(function(axis) {
                        if (!hasManuallySetCursorOrigin) {
                            var _a = projection.target[axis], min = _a.min, max = _a.max;
                            _this.cursorProgress[axis] = cursorProgress ? cursorProgress[axis] : (0, $iz4xc.progress)(min, max, initialPoint[axis]);
                        }
                        /**
                         * If we have external drag MotionValues, record their origin point. On pointermove
                         * we'll apply the pan gesture offset directly to this value.
                         */ var axisValue = _this.getAxisMotionValue(axis);
                        if (axisValue) _this.originPoint[axis] = axisValue.get();
                    });
                });
                write(function() {
                    (0, $fzvX8.flushSync).update();
                    (0, $fzvX8.flushSync).preRender();
                    (0, $fzvX8.flushSync).render();
                    (0, $fzvX8.flushSync).postRender();
                });
                read(function() {
                    return _this.resolveDragConstraints();
                });
            });
        };
        var onStart = function(event, info) {
            var _a, _b, _c;
            // Attempt to grab the global drag gesture lock - maybe make this part of PanSession
            var _d = _this.props, drag = _d.drag, dragPropagation = _d.dragPropagation;
            if (drag && !dragPropagation) {
                if (_this.openGlobalLock) _this.openGlobalLock();
                _this.openGlobalLock = (0, $inZZ1.getGlobalLock)(drag);
                // If we don 't have the lock, don't start dragging
                if (!_this.openGlobalLock) return;
            }
            (0, $lxfWR.flushLayout)();
            // Set current drag status
            _this.isDragging = true;
            _this.currentDirection = null;
            // Fire onDragStart event
            (_b = (_a = _this.props).onDragStart) === null || _b === void 0 || _b.call(_a, event, info);
            (_c = _this.visualElement.animationState) === null || _c === void 0 || _c.setActive((0, $9Ujt6.AnimationType).Drag, true);
        };
        var onMove = function(event, info) {
            var _a, _b, _c, _d;
            var _e = _this.props, dragPropagation = _e.dragPropagation, dragDirectionLock = _e.dragDirectionLock;
            // If we didn't successfully receive the gesture lock, early return.
            if (!dragPropagation && !_this.openGlobalLock) return;
            var offset = info.offset;
            // Attempt to detect drag direction if directionLock is true
            if (dragDirectionLock && _this.currentDirection === null) {
                _this.currentDirection = $5a1bb30bf03821e5$var$getCurrentDirection(offset);
                // If we've successfully set a direction, notify listener
                if (_this.currentDirection !== null) (_b = (_a = _this.props).onDirectionLock) === null || _b === void 0 || _b.call(_a, _this.currentDirection);
                return;
            }
            // Update each point with the latest position
            _this.updateAxis("x", info.point, offset);
            _this.updateAxis("y", info.point, offset);
            // Fire onDrag event
            (_d = (_c = _this.props).onDrag) === null || _d === void 0 || _d.call(_c, event, info);
            // Update the last pointer event
            $5a1bb30bf03821e5$var$lastPointerEvent = event;
        };
        var onSessionEnd = function(event, info) {
            return _this.stop(event, info);
        };
        var transformPagePoint = this.props.transformPagePoint;
        this.panSession = new (0, $hfXOZ.PanSession)(originEvent, {
            onSessionStart: onSessionStart,
            onStart: onStart,
            onMove: onMove,
            onSessionEnd: onSessionEnd
        }, {
            transformPagePoint: transformPagePoint
        });
    };
    VisualElementDragControls.prototype.resolveDragConstraints = function() {
        var _this = this;
        var _a = this.props, dragConstraints = _a.dragConstraints, dragElastic = _a.dragElastic;
        var layout = this.visualElement.getLayoutState().layoutCorrected;
        if (dragConstraints) this.constraints = (0, $ixxQP.isRefObject)(dragConstraints) ? this.resolveRefConstraints(layout, dragConstraints) : (0, $gdjM3.calcRelativeConstraints)(layout, dragConstraints);
        else this.constraints = false;
        this.elastic = (0, $gdjM3.resolveDragElastic)(dragElastic);
        /**
         * If we're outputting to external MotionValues, we want to rebase the measured constraints
         * from viewport-relative to component-relative.
         */ if (this.constraints && !this.hasMutatedConstraints) (0, $bbVsu.eachAxis)(function(axis) {
            if (_this.getAxisMotionValue(axis)) _this.constraints[axis] = (0, $gdjM3.rebaseAxisConstraints)(layout[axis], _this.constraints[axis]);
        });
    };
    VisualElementDragControls.prototype.resolveRefConstraints = function(layoutBox, constraints) {
        var _a = this.props, onMeasureDragConstraints = _a.onMeasureDragConstraints, transformPagePoint = _a.transformPagePoint;
        var constraintsElement = constraints.current;
        (0, $739Hg.invariant)(constraintsElement !== null, "If `dragConstraints` is set as a React ref, that ref must be passed to another component's `ref` prop.");
        this.constraintsBox = (0, $lphzD.getBoundingBox)(constraintsElement, transformPagePoint);
        var measuredConstraints = (0, $gdjM3.calcViewportConstraints)(layoutBox, this.constraintsBox);
        /**
         * If there's an onMeasureDragConstraints listener we call it and
         * if different constraints are returned, set constraints to that
         */ if (onMeasureDragConstraints) {
            var userConstraints = onMeasureDragConstraints((0, $hJbCe.convertAxisBoxToBoundingBox)(measuredConstraints));
            this.hasMutatedConstraints = !!userConstraints;
            if (userConstraints) measuredConstraints = (0, $hJbCe.convertBoundingBoxToAxisBox)(userConstraints);
        }
        return measuredConstraints;
    };
    VisualElementDragControls.prototype.cancelDrag = function() {
        var _a, _b;
        this.visualElement.unlockProjectionTarget();
        (_a = this.cancelLayout) === null || _a === void 0 || _a.call(this);
        this.isDragging = false;
        this.panSession && this.panSession.end();
        this.panSession = null;
        if (!this.props.dragPropagation && this.openGlobalLock) {
            this.openGlobalLock();
            this.openGlobalLock = null;
        }
        (_b = this.visualElement.animationState) === null || _b === void 0 || _b.setActive((0, $9Ujt6.AnimationType).Drag, false);
    };
    VisualElementDragControls.prototype.stop = function(event, info) {
        var _a, _b, _c;
        (_a = this.panSession) === null || _a === void 0 || _a.end();
        this.panSession = null;
        var isDragging = this.isDragging;
        this.cancelDrag();
        if (!isDragging) return;
        var velocity = info.velocity;
        this.animateDragEnd(velocity);
        (_c = (_b = this.props).onDragEnd) === null || _c === void 0 || _c.call(_b, event, info);
    };
    VisualElementDragControls.prototype.snapToCursor = function(point) {
        var _this = this;
        return (0, $bbVsu.eachAxis)(function(axis) {
            var drag = _this.props.drag;
            // If we're not dragging this axis, do an early return.
            if (!$5a1bb30bf03821e5$var$shouldDrag(axis, drag, _this.currentDirection)) return;
            var axisValue = _this.getAxisMotionValue(axis);
            if (axisValue) {
                var box = _this.visualElement.getLayoutState().layout;
                var length_1 = box[axis].max - box[axis].min;
                var center = box[axis].min + length_1 / 2;
                var offset = point[axis] - center;
                _this.originPoint[axis] = point[axis];
                axisValue.set(offset);
            } else {
                _this.cursorProgress[axis] = 0.5;
                return true;
            }
        }).includes(true);
    };
    /**
     * Update the specified axis with the latest pointer information.
     */ VisualElementDragControls.prototype.updateAxis = function(axis, point, offset) {
        var drag = this.props.drag;
        // If we're not dragging this axis, do an early return.
        if (!$5a1bb30bf03821e5$var$shouldDrag(axis, drag, this.currentDirection)) return;
        return this.getAxisMotionValue(axis) ? this.updateAxisMotionValue(axis, offset) : this.updateVisualElementAxis(axis, point);
    };
    VisualElementDragControls.prototype.updateAxisMotionValue = function(axis, offset) {
        var axisValue = this.getAxisMotionValue(axis);
        if (!offset || !axisValue) return;
        var nextValue = this.originPoint[axis] + offset[axis];
        var update = this.constraints ? (0, $gdjM3.applyConstraints)(nextValue, this.constraints[axis], this.elastic[axis]) : nextValue;
        axisValue.set(update);
    };
    VisualElementDragControls.prototype.updateVisualElementAxis = function(axis, point) {
        var _a;
        // Get the actual layout bounding box of the element
        var axisLayout = this.visualElement.getLayoutState().layout[axis];
        // Calculate its current length. In the future we might want to lerp this to animate
        // between lengths if the layout changes as we change the DOM
        var axisLength = axisLayout.max - axisLayout.min;
        // Get the initial progress that the pointer sat on this axis on gesture start.
        var axisProgress = this.cursorProgress[axis];
        // Calculate a new min point based on the latest pointer position, constraints and elastic
        var min = (0, $gdjM3.calcConstrainedMinPoint)(point[axis], axisLength, axisProgress, (_a = this.constraints) === null || _a === void 0 ? void 0 : _a[axis], this.elastic[axis]);
        // Update the axis viewport target with this new min and the length
        this.visualElement.setProjectionTargetAxis(axis, min, min + axisLength);
    };
    VisualElementDragControls.prototype.setProps = function(_a) {
        var _b = _a.drag, drag = _b === void 0 ? false : _b, _c = _a.dragDirectionLock, dragDirectionLock = _c === void 0 ? false : _c, _d = _a.dragPropagation, dragPropagation = _d === void 0 ? false : _d, _e = _a.dragConstraints, dragConstraints = _e === void 0 ? false : _e, _f = _a.dragElastic, dragElastic = _f === void 0 ? (0, $gdjM3.defaultElastic) : _f, _g = _a.dragMomentum, dragMomentum = _g === void 0 ? true : _g, remainingProps = (0, $66bGh.__rest)(_a, [
            "drag",
            "dragDirectionLock",
            "dragPropagation",
            "dragConstraints",
            "dragElastic",
            "dragMomentum"
        ]);
        this.props = (0, $66bGh.__assign)({
            drag: drag,
            dragDirectionLock: dragDirectionLock,
            dragPropagation: dragPropagation,
            dragConstraints: dragConstraints,
            dragElastic: dragElastic,
            dragMomentum: dragMomentum
        }, remainingProps);
    };
    /**
     * Drag works differently depending on which props are provided.
     *
     * - If _dragX and _dragY are provided, we output the gesture delta directly to those motion values.
     * - If the component will perform layout animations, we output the gesture to the component's
     *      visual bounding box
     * - Otherwise, we apply the delta to the x/y motion values.
     */ VisualElementDragControls.prototype.getAxisMotionValue = function(axis) {
        var _a = this.props, layout = _a.layout, layoutId = _a.layoutId;
        var dragKey = "_drag" + axis.toUpperCase();
        if (this.props[dragKey]) return this.props[dragKey];
        else if (!layout && layoutId === undefined) return this.visualElement.getValue(axis, 0);
    };
    VisualElementDragControls.prototype.isLayoutDrag = function() {
        return !this.getAxisMotionValue("x");
    };
    VisualElementDragControls.prototype.isExternalDrag = function() {
        var _a = this.props, _dragX = _a._dragX, _dragY = _a._dragY;
        return _dragX || _dragY;
    };
    VisualElementDragControls.prototype.animateDragEnd = function(velocity) {
        var _this = this;
        var _a = this.props, drag = _a.drag, dragMomentum = _a.dragMomentum, dragElastic = _a.dragElastic, dragTransition = _a.dragTransition;
        /**
         * Everything beyond the drag gesture should be performed with
         * relative projection so children stay in sync with their parent element.
         */ var isRelative = (0, $avXQG.convertToRelativeProjection)(this.visualElement, this.isLayoutDrag() && !this.isExternalDrag());
        /**
         * If we had previously resolved constraints relative to the viewport,
         * we need to also convert those to a relative coordinate space for the animation
         */ var constraints = this.constraints || {};
        if (isRelative && Object.keys(constraints).length && this.isLayoutDrag()) {
            var projectionParent = this.visualElement.getProjectionParent();
            if (projectionParent) {
                var relativeConstraints_1 = (0, $a789I.calcRelativeOffset)(projectionParent.projection.targetFinal, constraints);
                (0, $bbVsu.eachAxis)(function(axis) {
                    var _a = relativeConstraints_1[axis], min = _a.min, max = _a.max;
                    constraints[axis] = {
                        min: isNaN(min) ? undefined : min,
                        max: isNaN(max) ? undefined : max
                    };
                });
            }
        }
        var momentumAnimations = (0, $bbVsu.eachAxis)(function(axis) {
            var _a;
            if (!$5a1bb30bf03821e5$var$shouldDrag(axis, drag, _this.currentDirection)) return;
            var transition = (_a = constraints === null || constraints === void 0 ? void 0 : constraints[axis]) !== null && _a !== void 0 ? _a : {};
            /**
             * Overdamp the boundary spring if `dragElastic` is disabled. There's still a frame
             * of spring animations so we should look into adding a disable spring option to `inertia`.
             * We could do something here where we affect the `bounceStiffness` and `bounceDamping`
             * using the value of `dragElastic`.
             */ var bounceStiffness = dragElastic ? 200 : 1000000;
            var bounceDamping = dragElastic ? 40 : 10000000;
            var inertia = (0, $66bGh.__assign)((0, $66bGh.__assign)({
                type: "inertia",
                velocity: dragMomentum ? velocity[axis] : 0,
                bounceStiffness: bounceStiffness,
                bounceDamping: bounceDamping,
                timeConstant: 750,
                restDelta: 1,
                restSpeed: 10
            }, dragTransition), transition);
            // If we're not animating on an externally-provided `MotionValue` we can use the
            // component's animation controls which will handle interactions with whileHover (etc),
            // otherwise we just have to animate the `MotionValue` itself.
            return _this.getAxisMotionValue(axis) ? _this.startAxisValueAnimation(axis, inertia) : _this.visualElement.startLayoutAnimation(axis, inertia, isRelative);
        });
        // Run all animations and then resolve the new drag constraints.
        return Promise.all(momentumAnimations).then(function() {
            var _a, _b;
            (_b = (_a = _this.props).onDragTransitionEnd) === null || _b === void 0 || _b.call(_a);
        });
    };
    VisualElementDragControls.prototype.stopMotion = function() {
        var _this = this;
        (0, $bbVsu.eachAxis)(function(axis) {
            var axisValue = _this.getAxisMotionValue(axis);
            axisValue ? axisValue.stop() : _this.visualElement.stopLayoutAnimation();
        });
    };
    VisualElementDragControls.prototype.startAxisValueAnimation = function(axis, transition) {
        var axisValue = this.getAxisMotionValue(axis);
        if (!axisValue) return;
        var currentValue = axisValue.get();
        axisValue.set(currentValue);
        axisValue.set(currentValue); // Set twice to hard-reset velocity
        return (0, $6CYZP.startAnimation)(axis, axisValue, 0, transition);
    };
    VisualElementDragControls.prototype.scalePoint = function() {
        var _this = this;
        var _a = this.props, drag = _a.drag, dragConstraints = _a.dragConstraints;
        if (!(0, $ixxQP.isRefObject)(dragConstraints) || !this.constraintsBox) return;
        // Stop any current animations as there can be some visual glitching if we resize mid animation
        this.stopMotion();
        // Record the relative progress of the targetBox relative to the constraintsBox
        var boxProgress = {
            x: 0,
            y: 0
        };
        (0, $bbVsu.eachAxis)(function(axis) {
            boxProgress[axis] = (0, $hDYE8.calcOrigin)(_this.visualElement.projection.target[axis], _this.constraintsBox[axis]);
        });
        /**
         * For each axis, calculate the current progress of the layout axis within the constraints.
         * Then, using the latest layout and constraints measurements, reposition the new layout axis
         * proportionally within the constraints.
         */ this.updateConstraints(function() {
            (0, $bbVsu.eachAxis)(function(axis) {
                if (!$5a1bb30bf03821e5$var$shouldDrag(axis, drag, null)) return;
                // Calculate the position of the targetBox relative to the constraintsBox using the
                // previously calculated progress
                var _a = (0, $gdjM3.calcPositionFromProgress)(_this.visualElement.projection.target[axis], _this.constraintsBox[axis], boxProgress[axis]), min = _a.min, max = _a.max;
                _this.visualElement.setProjectionTargetAxis(axis, min, max);
            });
        });
        /**
         * If any other draggable components are queuing the same tasks synchronously
         * this will wait until they've all been scheduled before flushing.
         */ setTimeout((0, $lxfWR.flushLayout), 1);
    };
    VisualElementDragControls.prototype.updateConstraints = function(onReady) {
        var _this = this;
        this.cancelLayout = (0, $lxfWR.batchLayout)(function(read, write) {
            var ancestors = (0, $52vCk.collectProjectingAncestors)(_this.visualElement);
            write(function() {
                return ancestors.forEach(function(element) {
                    return element.resetTransform();
                });
            });
            read(function() {
                return (0, $52vCk.updateLayoutMeasurement)(_this.visualElement);
            });
            write(function() {
                return ancestors.forEach(function(element) {
                    return element.restoreTransform();
                });
            });
            read(function() {
                _this.resolveDragConstraints();
            });
            if (onReady) write(onReady);
        });
    };
    VisualElementDragControls.prototype.mount = function(visualElement) {
        var _this = this;
        var element = visualElement.getInstance();
        /**
         * Attach a pointerdown event listener on this DOM element to initiate drag tracking.
         */ var stopPointerListener = (0, $bN9Oo.addPointerEvent)(element, "pointerdown", function(event) {
            var _a = _this.props, drag = _a.drag, _b = _a.dragListener, dragListener = _b === void 0 ? true : _b;
            drag && dragListener && _this.start(event);
        });
        /**
         * Attach a window resize listener to scale the draggable target within its defined
         * constraints as the window resizes.
         */ var stopResizeListener = (0, $eCb0d.addDomEvent)(window, "resize", function() {
            _this.scalePoint();
        });
        /**
         * Ensure drag constraints are resolved correctly relative to the dragging element
         * whenever its layout changes.
         */ var stopLayoutUpdateListener = visualElement.onLayoutUpdate(function() {
            if (_this.isDragging) _this.resolveDragConstraints();
        });
        /**
         * If the previous component with this same layoutId was dragging at the time
         * it was unmounted, we want to continue the same gesture on this component.
         */ var prevDragCursor = visualElement.prevDragCursor;
        if (prevDragCursor) this.start($5a1bb30bf03821e5$var$lastPointerEvent, {
            cursorProgress: prevDragCursor
        });
        /**
         * Return a function that will teardown the drag gesture
         */ return function() {
            stopPointerListener === null || stopPointerListener === void 0 || stopPointerListener();
            stopResizeListener === null || stopResizeListener === void 0 || stopResizeListener();
            stopLayoutUpdateListener === null || stopLayoutUpdateListener === void 0 || stopLayoutUpdateListener();
            _this.cancelDrag();
        };
    };
    return VisualElementDragControls;
}();
function $5a1bb30bf03821e5$var$shouldDrag(direction, drag, currentDirection) {
    return (drag === true || drag === direction) && (currentDirection === null || currentDirection === direction);
}
/**
 * Based on an x/y offset determine the current drag direction. If both axis' offsets are lower
 * than the provided threshold, return `null`.
 *
 * @param offset - The x/y offset from origin.
 * @param lockThreshold - (Optional) - the minimum absolute offset before we can determine a drag direction.
 */ function $5a1bb30bf03821e5$var$getCurrentDirection(offset, lockThreshold) {
    if (lockThreshold === void 0) lockThreshold = 10;
    var direction = null;
    if (Math.abs(offset.y) > lockThreshold) direction = "y";
    else if (Math.abs(offset.x) > lockThreshold) direction = "x";
    return direction;
}

});
parcelRegister("hfXOZ", function(module, exports) {

$parcel$export(module.exports, "PanSession", function () { return $c9023dab6ad5550d$export$d9c66232c9c4689c; });

var $66bGh = parcelRequire("66bGh");

var $7FACY = parcelRequire("7FACY");

var $13MxN = parcelRequire("13MxN");

var $fzvX8 = parcelRequire("fzvX8");

var $j5T2L = parcelRequire("j5T2L");

var $bN9Oo = parcelRequire("bN9Oo");

var $iTwql = parcelRequire("iTwql");
var $6Zyiw = parcelRequire("6Zyiw");
/**
 * @internal
 */ var $c9023dab6ad5550d$export$d9c66232c9c4689c = /** @class */ function() {
    function PanSession(event, handlers, _a) {
        var _this = this;
        var _b = _a === void 0 ? {} : _a, transformPagePoint = _b.transformPagePoint;
        /**
         * @internal
         */ this.startEvent = null;
        /**
         * @internal
         */ this.lastMoveEvent = null;
        /**
         * @internal
         */ this.lastMoveEventInfo = null;
        /**
         * @internal
         */ this.handlers = {};
        this.updatePoint = function() {
            if (!(_this.lastMoveEvent && _this.lastMoveEventInfo)) return;
            var info = $c9023dab6ad5550d$var$getPanInfo(_this.lastMoveEventInfo, _this.history);
            var isPanStarted = _this.startEvent !== null;
            // Only start panning if the offset is larger than 3 pixels. If we make it
            // any larger than this we'll want to reset the pointer history
            // on the first update to avoid visual snapping to the cursoe.
            var isDistancePastThreshold = (0, $iTwql.distance)(info.offset, {
                x: 0,
                y: 0
            }) >= 3;
            if (!isPanStarted && !isDistancePastThreshold) return;
            var point = info.point;
            var timestamp = (0, $fzvX8.getFrameData)().timestamp;
            _this.history.push((0, $66bGh.__assign)((0, $66bGh.__assign)({}, point), {
                timestamp: timestamp
            }));
            var _a = _this.handlers, onStart = _a.onStart, onMove = _a.onMove;
            if (!isPanStarted) {
                onStart && onStart(_this.lastMoveEvent, info);
                _this.startEvent = _this.lastMoveEvent;
            }
            onMove && onMove(_this.lastMoveEvent, info);
        };
        this.handlePointerMove = function(event, info) {
            _this.lastMoveEvent = event;
            _this.lastMoveEventInfo = $c9023dab6ad5550d$var$transformPoint(info, _this.transformPagePoint);
            // Because Safari doesn't trigger mouseup events when it's above a `<select>`
            if ((0, $7FACY.isMouseEvent)(event) && event.buttons === 0) {
                _this.handlePointerUp(event, info);
                return;
            }
            // Throttle mouse move event to once per frame
            (0, $fzvX8.default).update(_this.updatePoint, true);
        };
        this.handlePointerUp = function(event, info) {
            _this.end();
            var _a = _this.handlers, onEnd = _a.onEnd, onSessionEnd = _a.onSessionEnd;
            var panInfo = $c9023dab6ad5550d$var$getPanInfo($c9023dab6ad5550d$var$transformPoint(info, _this.transformPagePoint), _this.history);
            if (_this.startEvent && onEnd) onEnd(event, panInfo);
            onSessionEnd && onSessionEnd(event, panInfo);
        };
        // If we have more than one touch, don't start detecting this gesture
        if ((0, $7FACY.isTouchEvent)(event) && event.touches.length > 1) return;
        this.handlers = handlers;
        this.transformPagePoint = transformPagePoint;
        var info = (0, $13MxN.extractEventInfo)(event);
        var initialInfo = $c9023dab6ad5550d$var$transformPoint(info, this.transformPagePoint);
        var point = initialInfo.point;
        var timestamp = (0, $fzvX8.getFrameData)().timestamp;
        this.history = [
            (0, $66bGh.__assign)((0, $66bGh.__assign)({}, point), {
                timestamp: timestamp
            })
        ];
        var onSessionStart = handlers.onSessionStart;
        onSessionStart && onSessionStart(event, $c9023dab6ad5550d$var$getPanInfo(initialInfo, this.history));
        this.removeListeners = (0, $6Zyiw.pipe)((0, $bN9Oo.addPointerEvent)(window, "pointermove", this.handlePointerMove), (0, $bN9Oo.addPointerEvent)(window, "pointerup", this.handlePointerUp), (0, $bN9Oo.addPointerEvent)(window, "pointercancel", this.handlePointerUp));
    }
    PanSession.prototype.updateHandlers = function(handlers) {
        this.handlers = handlers;
    };
    PanSession.prototype.end = function() {
        this.removeListeners && this.removeListeners();
        (0, $fzvX8.cancelSync).update(this.updatePoint);
    };
    return PanSession;
}();
function $c9023dab6ad5550d$var$transformPoint(info, transformPagePoint) {
    return transformPagePoint ? {
        point: transformPagePoint(info.point)
    } : info;
}
function $c9023dab6ad5550d$var$subtractPoint(a, b) {
    return {
        x: a.x - b.x,
        y: a.y - b.y
    };
}
function $c9023dab6ad5550d$var$getPanInfo(_a, history) {
    var point = _a.point;
    return {
        point: point,
        delta: $c9023dab6ad5550d$var$subtractPoint(point, $c9023dab6ad5550d$var$lastDevicePoint(history)),
        offset: $c9023dab6ad5550d$var$subtractPoint(point, $c9023dab6ad5550d$var$startDevicePoint(history)),
        velocity: $c9023dab6ad5550d$var$getVelocity(history, 0.1)
    };
}
function $c9023dab6ad5550d$var$startDevicePoint(history) {
    return history[0];
}
function $c9023dab6ad5550d$var$lastDevicePoint(history) {
    return history[history.length - 1];
}
function $c9023dab6ad5550d$var$getVelocity(history, timeDelta) {
    if (history.length < 2) return {
        x: 0,
        y: 0
    };
    var i = history.length - 1;
    var timestampedPoint = null;
    var lastPoint = $c9023dab6ad5550d$var$lastDevicePoint(history);
    while(i >= 0){
        timestampedPoint = history[i];
        if (lastPoint.timestamp - timestampedPoint.timestamp > (0, $j5T2L.secondsToMilliseconds)(timeDelta)) break;
        i--;
    }
    if (!timestampedPoint) return {
        x: 0,
        y: 0
    };
    var time = (lastPoint.timestamp - timestampedPoint.timestamp) / 1000;
    if (time === 0) return {
        x: 0,
        y: 0
    };
    var currentVelocity = {
        x: (lastPoint.x - timestampedPoint.x) / time,
        y: (lastPoint.y - timestampedPoint.y) / time
    };
    if (currentVelocity.x === Infinity) currentVelocity.x = 0;
    if (currentVelocity.y === Infinity) currentVelocity.y = 0;
    return currentVelocity;
}

});
parcelRegister("iTwql", function(module, exports) {

$parcel$export(module.exports, "distance", function () { return $dc1683bf22033969$export$9f17032d917177de; });

var $eVZPI = parcelRequire("eVZPI");

var $lwX2k = parcelRequire("lwX2k");

var $ipA6L = parcelRequire("ipA6L");
var $dc1683bf22033969$var$distance1D = function(a, b) {
    return Math.abs(a - b);
};
function $dc1683bf22033969$export$9f17032d917177de(a, b) {
    if ((0, $ipA6L.isNum)(a) && (0, $ipA6L.isNum)(b)) return $dc1683bf22033969$var$distance1D(a, b);
    else if ((0, $eVZPI.isPoint)(a) && (0, $eVZPI.isPoint)(b)) {
        var xDelta = $dc1683bf22033969$var$distance1D(a.x, b.x);
        var yDelta = $dc1683bf22033969$var$distance1D(a.y, b.y);
        var zDelta = (0, $lwX2k.isPoint3D)(a) && (0, $lwX2k.isPoint3D)(b) ? $dc1683bf22033969$var$distance1D(a.z, b.z) : 0;
        return Math.sqrt(Math.pow(xDelta, 2) + Math.pow(yDelta, 2) + Math.pow(zDelta, 2));
    }
}

});
parcelRegister("eVZPI", function(module, exports) {

$parcel$export(module.exports, "isPoint", function () { return $adf65a5ad66a8adc$export$aff838a5553f2a92; });
var $adf65a5ad66a8adc$export$aff838a5553f2a92 = function(point) {
    return point.hasOwnProperty('x') && point.hasOwnProperty('y');
};

});

parcelRegister("lwX2k", function(module, exports) {

$parcel$export(module.exports, "isPoint3D", function () { return $faca61947743c199$export$319d74662aaa2966; });

var $eVZPI = parcelRequire("eVZPI");
var $faca61947743c199$export$319d74662aaa2966 = function(point) {
    return (0, $eVZPI.isPoint)(point) && point.hasOwnProperty('z');
};

});



parcelRegister("bbVsu", function(module, exports) {

$parcel$export(module.exports, "eachAxis", function () { return $825d4adbe62f0b84$export$b789de563eb43b1; });
// Call a handler once for each axis
function $825d4adbe62f0b84$export$b789de563eb43b1(handler) {
    return [
        handler("x"),
        handler("y")
    ];
}

});

parcelRegister("gdjM3", function(module, exports) {

$parcel$export(module.exports, "applyConstraints", function () { return $bcdd32f11e65a1bf$export$b3c764d3fca3ffe3; });
$parcel$export(module.exports, "calcConstrainedMinPoint", function () { return $bcdd32f11e65a1bf$export$365d4f5bee5334d2; });
$parcel$export(module.exports, "calcRelativeConstraints", function () { return $bcdd32f11e65a1bf$export$4e9195bf7793bc78; });
$parcel$export(module.exports, "calcViewportConstraints", function () { return $bcdd32f11e65a1bf$export$4228500f19d4cdf7; });
$parcel$export(module.exports, "calcPositionFromProgress", function () { return $bcdd32f11e65a1bf$export$c24202d5faacd1d9; });
$parcel$export(module.exports, "rebaseAxisConstraints", function () { return $bcdd32f11e65a1bf$export$e9672cc4c36a8b87; });
$parcel$export(module.exports, "defaultElastic", function () { return $bcdd32f11e65a1bf$export$a3366d3bac43a742; });
$parcel$export(module.exports, "resolveDragElastic", function () { return $bcdd32f11e65a1bf$export$7c5eaef8f4723d22; });

var $66bGh = parcelRequire("66bGh");

var $203mS = parcelRequire("203mS");
/**
 * Apply constraints to a point. These constraints are both physical along an
 * axis, and an elastic factor that determines how much to constrain the point
 * by if it does lie outside the defined parameters.
 */ function $bcdd32f11e65a1bf$export$b3c764d3fca3ffe3(point, _a, elastic) {
    var min = _a.min, max = _a.max;
    if (min !== undefined && point < min) // If we have a min point defined, and this is outside of that, constrain
    point = elastic ? (0, $203mS.mix)(min, point, elastic.min) : Math.max(point, min);
    else if (max !== undefined && point > max) // If we have a max point defined, and this is outside of that, constrain
    point = elastic ? (0, $203mS.mix)(max, point, elastic.max) : Math.min(point, max);
    return point;
}
/**
 * Calculates a min projection point based on a pointer, pointer progress
 * within the drag target, and constraints.
 *
 * For instance if an element was 100px width, we were dragging from 0.25
 * along this axis, the pointer is at 200px, and there were no constraints,
 * we would calculate a min projection point of 175px.
 */ function $bcdd32f11e65a1bf$export$365d4f5bee5334d2(point, length, progress, constraints, elastic) {
    // Calculate a min point for this axis and apply it to the current pointer
    var min = point - length * progress;
    return constraints ? $bcdd32f11e65a1bf$export$b3c764d3fca3ffe3(min, constraints, elastic) : min;
}
/**
 * Calculate constraints in terms of the viewport when defined relatively to the
 * measured axis. This is measured from the nearest edge, so a max constraint of 200
 * on an axis with a max value of 300 would return a constraint of 500 - axis length
 */ function $bcdd32f11e65a1bf$export$690c180aa5775042(axis, min, max) {
    return {
        min: min !== undefined ? axis.min + min : undefined,
        max: max !== undefined ? axis.max + max - (axis.max - axis.min) : undefined
    };
}
/**
 * Calculate constraints in terms of the viewport when
 * defined relatively to the measured bounding box.
 */ function $bcdd32f11e65a1bf$export$4e9195bf7793bc78(layoutBox, _a) {
    var top = _a.top, left = _a.left, bottom = _a.bottom, right = _a.right;
    return {
        x: $bcdd32f11e65a1bf$export$690c180aa5775042(layoutBox.x, left, right),
        y: $bcdd32f11e65a1bf$export$690c180aa5775042(layoutBox.y, top, bottom)
    };
}
/**
 * Calculate viewport constraints when defined as another viewport-relative axis
 */ function $bcdd32f11e65a1bf$export$87abc398c3c7ce27(layoutAxis, constraintsAxis) {
    var _a;
    var min = constraintsAxis.min - layoutAxis.min;
    var max = constraintsAxis.max - layoutAxis.max;
    // If the constraints axis is actually smaller than the layout axis then we can
    // flip the constraints
    if (constraintsAxis.max - constraintsAxis.min < layoutAxis.max - layoutAxis.min) _a = (0, $66bGh.__read)([
        max,
        min
    ], 2), min = _a[0], max = _a[1];
    return {
        min: layoutAxis.min + min,
        max: layoutAxis.min + max
    };
}
/**
 * Calculate viewport constraints when defined as another viewport-relative box
 */ function $bcdd32f11e65a1bf$export$4228500f19d4cdf7(layoutBox, constraintsBox) {
    return {
        x: $bcdd32f11e65a1bf$export$87abc398c3c7ce27(layoutBox.x, constraintsBox.x),
        y: $bcdd32f11e65a1bf$export$87abc398c3c7ce27(layoutBox.y, constraintsBox.y)
    };
}
/**
 * Calculate the an axis position based on two axes and a progress value.
 */ function $bcdd32f11e65a1bf$export$c24202d5faacd1d9(axis, constraints, progress) {
    var axisLength = axis.max - axis.min;
    var min = (0, $203mS.mix)(constraints.min, constraints.max - axisLength, progress);
    return {
        min: min,
        max: min + axisLength
    };
}
/**
 * Rebase the calculated viewport constraints relative to the layout.min point.
 */ function $bcdd32f11e65a1bf$export$e9672cc4c36a8b87(layout, constraints) {
    var relativeConstraints = {};
    if (constraints.min !== undefined) relativeConstraints.min = constraints.min - layout.min;
    if (constraints.max !== undefined) relativeConstraints.max = constraints.max - layout.min;
    return relativeConstraints;
}
var $bcdd32f11e65a1bf$export$a3366d3bac43a742 = 0.35;
/**
 * Accepts a dragElastic prop and returns resolved elastic values for each axis.
 */ function $bcdd32f11e65a1bf$export$7c5eaef8f4723d22(dragElastic) {
    if (dragElastic === false) dragElastic = 0;
    else if (dragElastic === true) dragElastic = $bcdd32f11e65a1bf$export$a3366d3bac43a742;
    return {
        x: $bcdd32f11e65a1bf$export$589076940abb04b5(dragElastic, "left", "right"),
        y: $bcdd32f11e65a1bf$export$589076940abb04b5(dragElastic, "top", "bottom")
    };
}
function $bcdd32f11e65a1bf$export$589076940abb04b5(dragElastic, minLabel, maxLabel) {
    return {
        min: $bcdd32f11e65a1bf$export$bbbc10b82e6c0afb(dragElastic, minLabel),
        max: $bcdd32f11e65a1bf$export$bbbc10b82e6c0afb(dragElastic, maxLabel)
    };
}
function $bcdd32f11e65a1bf$export$bbbc10b82e6c0afb(dragElastic, label) {
    var _a;
    return typeof dragElastic === "number" ? dragElastic : (_a = dragElastic[label]) !== null && _a !== void 0 ? _a : 0;
}

});

parcelRegister("lphzD", function(module, exports) {

$parcel$export(module.exports, "getBoundingBox", function () { return $f9599092f7706c67$export$895c5e634403eaa7; });

var $hJbCe = parcelRequire("hJbCe");
/**
 * Measure and return the element bounding box.
 *
 * We convert the box into an AxisBox2D to make it easier to work with each axis
 * individually and programmatically.
 *
 * This function optionally accepts a transformPagePoint function which allows us to compensate
 * for, for instance, measuring the element within a scaled plane like a Framer devivce preview component.
 */ function $f9599092f7706c67$export$895c5e634403eaa7(element, transformPagePoint) {
    var box = element.getBoundingClientRect();
    return (0, $hJbCe.convertBoundingBoxToAxisBox)((0, $hJbCe.transformBoundingBox)(box, transformPagePoint));
}

});

parcelRegister("hDYE8", function(module, exports) {

$parcel$export(module.exports, "calcOrigin", function () { return $cd851f4fb44a69a8$export$13abbfca044ca46d; });
$parcel$export(module.exports, "updateBoxDelta", function () { return $cd851f4fb44a69a8$export$1435a2beec546d2e; });
$parcel$export(module.exports, "calcRelativeBox", function () { return $cd851f4fb44a69a8$export$426154f9d100f99; });

var $7ier8 = parcelRequire("7ier8");
var $iTwql = parcelRequire("iTwql");
var $203mS = parcelRequire("203mS");
var $iz4xc = parcelRequire("iz4xc");
var $cd851f4fb44a69a8$var$clampProgress = function(v) {
    return (0, $7ier8.clamp)(0, 1, v);
};
/**
 * Returns true if the provided value is within maxDistance of the provided target
 */ function $cd851f4fb44a69a8$export$28d0384c4b79bde2(value, target, maxDistance) {
    if (target === void 0) target = 0;
    if (maxDistance === void 0) maxDistance = 0.01;
    return (0, $iTwql.distance)(value, target) < maxDistance;
}
function $cd851f4fb44a69a8$var$calcLength(axis) {
    return axis.max - axis.min;
}
/**
 * Calculate a transform origin relative to the source axis, between 0-1, that results
 * in an asthetically pleasing scale/transform needed to project from source to target.
 */ function $cd851f4fb44a69a8$export$13abbfca044ca46d(source, target) {
    var origin = 0.5;
    var sourceLength = $cd851f4fb44a69a8$var$calcLength(source);
    var targetLength = $cd851f4fb44a69a8$var$calcLength(target);
    if (targetLength > sourceLength) origin = (0, $iz4xc.progress)(target.min, target.max - sourceLength, source.min);
    else if (sourceLength > targetLength) origin = (0, $iz4xc.progress)(source.min, source.max - targetLength, target.min);
    return $cd851f4fb44a69a8$var$clampProgress(origin);
}
/**
 * Update the AxisDelta with a transform that projects source into target.
 *
 * The transform `origin` is optional. If not provided, it'll be automatically
 * calculated based on the relative positions of the two bounding boxes.
 */ function $cd851f4fb44a69a8$export$acf2fd1e22884f56(delta, source, target, origin) {
    if (origin === void 0) origin = 0.5;
    delta.origin = origin;
    delta.originPoint = (0, $203mS.mix)(source.min, source.max, delta.origin);
    delta.scale = $cd851f4fb44a69a8$var$calcLength(target) / $cd851f4fb44a69a8$var$calcLength(source);
    if ($cd851f4fb44a69a8$export$28d0384c4b79bde2(delta.scale, 1, 0.0001)) delta.scale = 1;
    delta.translate = (0, $203mS.mix)(target.min, target.max, delta.origin) - delta.originPoint;
    if ($cd851f4fb44a69a8$export$28d0384c4b79bde2(delta.translate)) delta.translate = 0;
}
/**
 * Update the BoxDelta with a transform that projects the source into the target.
 *
 * The transform `origin` is optional. If not provided, it'll be automatically
 * calculated based on the relative positions of the two bounding boxes.
 */ function $cd851f4fb44a69a8$export$1435a2beec546d2e(delta, source, target, origin) {
    $cd851f4fb44a69a8$export$acf2fd1e22884f56(delta.x, source.x, target.x, $cd851f4fb44a69a8$var$defaultOrigin(origin.originX));
    $cd851f4fb44a69a8$export$acf2fd1e22884f56(delta.y, source.y, target.y, $cd851f4fb44a69a8$var$defaultOrigin(origin.originY));
}
/**
 * Currently this only accepts numerical origins, measured as 0-1, but could
 * accept pixel values by comparing to the target axis.
 */ function $cd851f4fb44a69a8$var$defaultOrigin(origin) {
    return typeof origin === "number" ? origin : 0.5;
}
function $cd851f4fb44a69a8$export$cabef5b392704b41(target, relative, parent) {
    target.min = parent.min + relative.min;
    target.max = target.min + $cd851f4fb44a69a8$var$calcLength(relative);
}
function $cd851f4fb44a69a8$export$426154f9d100f99(projection, parentProjection) {
    $cd851f4fb44a69a8$export$cabef5b392704b41(projection.target.x, projection.relativeTarget.x, parentProjection.target.x);
    $cd851f4fb44a69a8$export$cabef5b392704b41(projection.target.y, projection.relativeTarget.y, parentProjection.target.y);
}

});

parcelRegister("avXQG", function(module, exports) {

$parcel$export(module.exports, "convertToRelativeProjection", function () { return $01f9babb3cc860a1$export$69bccedc5101c4d1; });

var $a789I = parcelRequire("a789I");

var $bbVsu = parcelRequire("bbVsu");

var $7eAOS = parcelRequire("7eAOS");
/**
 * Returns a boolean stating whether or not we converted the projection
 * to relative projection.
 */ function $01f9babb3cc860a1$export$69bccedc5101c4d1(visualElement, isLayoutDrag) {
    if (isLayoutDrag === void 0) isLayoutDrag = true;
    var projectionParent = visualElement.getProjectionParent();
    if (!projectionParent) return false;
    var offset;
    if (isLayoutDrag) {
        offset = (0, $a789I.calcRelativeOffset)(projectionParent.projection.target, visualElement.projection.target);
        (0, $7eAOS.removeBoxTransforms)(offset, projectionParent.getLatestValues());
    } else offset = (0, $a789I.calcRelativeOffset)(projectionParent.getLayoutState().layout, visualElement.getLayoutState().layout);
    (0, $bbVsu.eachAxis)(function(axis) {
        return visualElement.setProjectionTargetAxis(axis, offset[axis].min, offset[axis].max, true);
    });
    return true;
}

});
parcelRegister("a789I", function(module, exports) {

$parcel$export(module.exports, "tweenAxis", function () { return $75d0e25d6c450e0d$export$21d180ad0c0013cb; });
$parcel$export(module.exports, "calcRelativeOffset", function () { return $75d0e25d6c450e0d$export$5d8b2d12fde0857a; });
$parcel$export(module.exports, "checkIfParentHasChanged", function () { return $75d0e25d6c450e0d$export$d1cc994fa3b9d457; });

var $203mS = parcelRequire("203mS");
function $75d0e25d6c450e0d$export$21d180ad0c0013cb(target, prev, next, p) {
    target.min = (0, $203mS.mix)(prev.min, next.min, p);
    target.max = (0, $203mS.mix)(prev.max, next.max, p);
}
function $75d0e25d6c450e0d$export$58fa21d412109d6b(parent, child) {
    return {
        min: child.min - parent.min,
        max: child.max - parent.min
    };
}
function $75d0e25d6c450e0d$export$5d8b2d12fde0857a(parent, child) {
    return {
        x: $75d0e25d6c450e0d$export$58fa21d412109d6b(parent.x, child.x),
        y: $75d0e25d6c450e0d$export$58fa21d412109d6b(parent.y, child.y)
    };
}
function $75d0e25d6c450e0d$export$d1cc994fa3b9d457(prev, next) {
    var prevId = prev.getLayoutId();
    var nextId = next.getLayoutId();
    return prevId !== nextId || nextId === undefined && prev !== next;
}

});

parcelRegister("7eAOS", function(module, exports) {

$parcel$export(module.exports, "resetBox", function () { return $015bf9665e4186d6$export$d7ad1d43f7ab13a6; });
$parcel$export(module.exports, "applyBoxTransforms", function () { return $015bf9665e4186d6$export$c8fdd2c80d7384dd; });
$parcel$export(module.exports, "removeBoxTransforms", function () { return $015bf9665e4186d6$export$73e1ad0a9694e25c; });
$parcel$export(module.exports, "applyTreeDeltas", function () { return $015bf9665e4186d6$export$e2a980535c55eabb; });

var $66bGh = parcelRequire("66bGh");

var $203mS = parcelRequire("203mS");

var $TYiew = parcelRequire("TYiew");
/**
 * Reset an axis to the provided origin box.
 *
 * This is a mutative operation.
 */ function $015bf9665e4186d6$export$ab0da4c5058aa6e9(axis, originAxis) {
    axis.min = originAxis.min;
    axis.max = originAxis.max;
}
/**
 * Reset a box to the provided origin box.
 *
 * This is a mutative operation.
 */ function $015bf9665e4186d6$export$d7ad1d43f7ab13a6(box, originBox) {
    $015bf9665e4186d6$export$ab0da4c5058aa6e9(box.x, originBox.x);
    $015bf9665e4186d6$export$ab0da4c5058aa6e9(box.y, originBox.y);
}
/**
 * Scales a point based on a factor and an originPoint
 */ function $015bf9665e4186d6$export$2290ec7febe36dd6(point, scale, originPoint) {
    var distanceFromOrigin = point - originPoint;
    var scaled = scale * distanceFromOrigin;
    return originPoint + scaled;
}
/**
 * Applies a translate/scale delta to a point
 */ function $015bf9665e4186d6$export$4e122ddcc0c61a2e(point, translate, scale, originPoint, boxScale) {
    if (boxScale !== undefined) point = $015bf9665e4186d6$export$2290ec7febe36dd6(point, boxScale, originPoint);
    return $015bf9665e4186d6$export$2290ec7febe36dd6(point, scale, originPoint) + translate;
}
/**
 * Applies a translate/scale delta to an axis
 */ function $015bf9665e4186d6$export$e8e3a712e9ebf422(axis, translate, scale, originPoint, boxScale) {
    if (translate === void 0) translate = 0;
    if (scale === void 0) scale = 1;
    axis.min = $015bf9665e4186d6$export$4e122ddcc0c61a2e(axis.min, translate, scale, originPoint, boxScale);
    axis.max = $015bf9665e4186d6$export$4e122ddcc0c61a2e(axis.max, translate, scale, originPoint, boxScale);
}
/**
 * Applies a translate/scale delta to a box
 */ function $015bf9665e4186d6$export$d80074982803af5c(box, _a) {
    var x = _a.x, y = _a.y;
    $015bf9665e4186d6$export$e8e3a712e9ebf422(box.x, x.translate, x.scale, x.originPoint);
    $015bf9665e4186d6$export$e8e3a712e9ebf422(box.y, y.translate, y.scale, y.originPoint);
}
/**
 * Apply a transform to an axis from the latest resolved motion values.
 * This function basically acts as a bridge between a flat motion value map
 * and applyAxisDelta
 */ function $015bf9665e4186d6$export$fe9134d4e4502d7e(final, axis, transforms, _a) {
    var _b = (0, $66bGh.__read)(_a, 3), key = _b[0], scaleKey = _b[1], originKey = _b[2];
    // Copy the current axis to the final axis before mutation
    final.min = axis.min;
    final.max = axis.max;
    var axisOrigin = transforms[originKey] !== undefined ? transforms[originKey] : 0.5;
    var originPoint = (0, $203mS.mix)(axis.min, axis.max, axisOrigin);
    // Apply the axis delta to the final axis
    $015bf9665e4186d6$export$e8e3a712e9ebf422(final, transforms[key], transforms[scaleKey], originPoint, transforms.scale);
}
/**
 * The names of the motion values we want to apply as translation, scale and origin.
 */ var $015bf9665e4186d6$var$xKeys = [
    "x",
    "scaleX",
    "originX"
];
var $015bf9665e4186d6$var$yKeys = [
    "y",
    "scaleY",
    "originY"
];
/**
 * Apply a transform to a box from the latest resolved motion values.
 */ function $015bf9665e4186d6$export$c8fdd2c80d7384dd(finalBox, box, transforms) {
    $015bf9665e4186d6$export$fe9134d4e4502d7e(finalBox.x, box.x, transforms, $015bf9665e4186d6$var$xKeys);
    $015bf9665e4186d6$export$fe9134d4e4502d7e(finalBox.y, box.y, transforms, $015bf9665e4186d6$var$yKeys);
}
/**
 * Remove a delta from a point. This is essentially the steps of applyPointDelta in reverse
 */ function $015bf9665e4186d6$export$691f07066b3be7c5(point, translate, scale, originPoint, boxScale) {
    point -= translate;
    point = $015bf9665e4186d6$export$2290ec7febe36dd6(point, 1 / scale, originPoint);
    if (boxScale !== undefined) point = $015bf9665e4186d6$export$2290ec7febe36dd6(point, 1 / boxScale, originPoint);
    return point;
}
/**
 * Remove a delta from an axis. This is essentially the steps of applyAxisDelta in reverse
 */ function $015bf9665e4186d6$export$cc12a0672fae5b4a(axis, translate, scale, origin, boxScale) {
    if (translate === void 0) translate = 0;
    if (scale === void 0) scale = 1;
    if (origin === void 0) origin = 0.5;
    var originPoint = (0, $203mS.mix)(axis.min, axis.max, origin) - translate;
    axis.min = $015bf9665e4186d6$export$691f07066b3be7c5(axis.min, translate, scale, originPoint, boxScale);
    axis.max = $015bf9665e4186d6$export$691f07066b3be7c5(axis.max, translate, scale, originPoint, boxScale);
}
/**
 * Remove a transforms from an axis. This is essentially the steps of applyAxisTransforms in reverse
 * and acts as a bridge between motion values and removeAxisDelta
 */ function $015bf9665e4186d6$export$42b76f1d0d16d5b(axis, transforms, _a) {
    var _b = (0, $66bGh.__read)(_a, 3), key = _b[0], scaleKey = _b[1], originKey = _b[2];
    $015bf9665e4186d6$export$cc12a0672fae5b4a(axis, transforms[key], transforms[scaleKey], transforms[originKey], transforms.scale);
}
/**
 * Remove a transforms from an box. This is essentially the steps of applyAxisBox in reverse
 * and acts as a bridge between motion values and removeAxisDelta
 */ function $015bf9665e4186d6$export$73e1ad0a9694e25c(box, transforms) {
    $015bf9665e4186d6$export$42b76f1d0d16d5b(box.x, transforms, $015bf9665e4186d6$var$xKeys);
    $015bf9665e4186d6$export$42b76f1d0d16d5b(box.y, transforms, $015bf9665e4186d6$var$yKeys);
}
/**
 * Apply a tree of deltas to a box. We do this to calculate the effect of all the transforms
 * in a tree upon our box before then calculating how to project it into our desired viewport-relative box
 *
 * This is the final nested loop within updateLayoutDelta for future refactoring
 */ function $015bf9665e4186d6$export$e2a980535c55eabb(box, treeScale, treePath) {
    var treeLength = treePath.length;
    if (!treeLength) return;
    // Reset the treeScale
    treeScale.x = treeScale.y = 1;
    var node;
    var delta;
    for(var i = 0; i < treeLength; i++){
        node = treePath[i];
        delta = node.getLayoutState().delta;
        // Incoporate each ancestor's scale into a culmulative treeScale for this component
        treeScale.x *= delta.x.scale;
        treeScale.y *= delta.y.scale;
        // Apply each ancestor's calculated delta into this component's recorded layout box
        $015bf9665e4186d6$export$d80074982803af5c(box, delta);
        // If this is a draggable ancestor, also incorporate the node's transform to the layout box
        if ((0, $TYiew.isDraggable)(node)) $015bf9665e4186d6$export$c8fdd2c80d7384dd(box, box, node.getLatestValues());
    }
}

});
parcelRegister("TYiew", function(module, exports) {

$parcel$export(module.exports, "isDraggable", function () { return $0a83e81e87c72ce2$export$fe8f97248bbe2d04; });
function $0a83e81e87c72ce2$export$fe8f97248bbe2d04(visualElement) {
    var _a = visualElement.getProps(), drag = _a.drag, _dragX = _a._dragX;
    return drag && !_dragX;
}

});





parcelRegister("b2d4x", function(module, exports) {

$parcel$export(module.exports, "usePanGesture", function () { return $808a0578fa71cac5$export$eb0f62174cac1aec; });

var $gJYWc = parcelRequire("gJYWc");

var $cUvlw = parcelRequire("cUvlw");

var $kdjA6 = parcelRequire("kdjA6");

var $bN9Oo = parcelRequire("bN9Oo");

var $hfXOZ = parcelRequire("hfXOZ");
/**
 *
 * @param handlers -
 * @param ref -
 *
 * @internalremarks
 * Currently this sets new pan gesture functions every render. The memo route has been explored
 * in the past but ultimately we're still creating new functions every render. An optimisation
 * to explore is creating the pan gestures and loading them into a `ref`.
 *
 * @internal
 */ function $808a0578fa71cac5$export$eb0f62174cac1aec(_a) {
    var onPan = _a.onPan, onPanStart = _a.onPanStart, onPanEnd = _a.onPanEnd, onPanSessionStart = _a.onPanSessionStart, visualElement = _a.visualElement;
    var hasPanEvents = onPan || onPanStart || onPanEnd || onPanSessionStart;
    var panSession = (0, $gJYWc.useRef)(null);
    var transformPagePoint = (0, $gJYWc.useContext)((0, $cUvlw.MotionConfigContext)).transformPagePoint;
    var handlers = {
        onSessionStart: onPanSessionStart,
        onStart: onPanStart,
        onMove: onPan,
        onEnd: function(event, info) {
            panSession.current = null;
            onPanEnd && onPanEnd(event, info);
        }
    };
    (0, $gJYWc.useEffect)(function() {
        if (panSession.current !== null) panSession.current.updateHandlers(handlers);
    });
    function onPointerDown(event) {
        panSession.current = new (0, $hfXOZ.PanSession)(event, handlers, {
            transformPagePoint: transformPagePoint
        });
    }
    (0, $bN9Oo.usePointerEvent)(visualElement, "pointerdown", hasPanEvents && onPointerDown);
    (0, $kdjA6.useUnmountEffect)(function() {
        return panSession.current && panSession.current.end();
    });
}

});


parcelRegister("h7Noc", function(module, exports) {

$parcel$export(module.exports, "layoutAnimations", function () { return $c77966ce35ba8878$export$eb704cf7366aa18a; });

var $gas15 = parcelRequire("gas15");

var $jtBLI = parcelRequire("jtBLI");
var $c77966ce35ba8878$export$eb704cf7366aa18a = {
    measureLayout: (0, $jtBLI.MeasureContextProvider),
    layoutAnimation: (0, $gas15.AnimateLayoutContextProvider)
};

});
parcelRegister("gas15", function(module, exports) {

$parcel$export(module.exports, "AnimateLayoutContextProvider", function () { return $bc5350002ea73f00$export$bd44d4206e0b4eca; });

var $66bGh = parcelRequire("66bGh");

var $gJYWc = parcelRequire("gJYWc");

var $bbVsu = parcelRequire("bbVsu");

var $6CYZP = parcelRequire("6CYZP");

var $a789I = parcelRequire("a789I");

var $aRkas = parcelRequire("aRkas");

var $dUQA6 = parcelRequire("dUQA6");

var $hJbCe = parcelRequire("hJbCe");

var $c9NBR = parcelRequire("c9NBR");

var $ke1iK = parcelRequire("ke1iK");
var $bc5350002ea73f00$var$progressTarget = 1000;
var $bc5350002ea73f00$var$Animate = /** @class */ function(_super) {
    (0, $66bGh.__extends)(Animate, _super);
    function Animate() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        /**
         * A mutable object that tracks the target viewport box
         * for the current animation frame.
         */ _this.frameTarget = (0, $hJbCe.axisBox)();
        /**
         * The current animation target, we use this to check whether to start
         * a new animation or continue the existing one.
         */ _this.currentAnimationTarget = (0, $hJbCe.axisBox)();
        /**
         * Track whether we're animating this axis.
         */ _this.isAnimating = {
            x: false,
            y: false
        };
        _this.stopAxisAnimation = {
            x: undefined,
            y: undefined
        };
        _this.isAnimatingTree = false;
        _this.animate = function(target, origin, _a) {
            if (_a === void 0) _a = {};
            var originBox = _a.originBox, targetBox = _a.targetBox, visibilityAction = _a.visibilityAction, shouldStackAnimate = _a.shouldStackAnimate, onComplete = _a.onComplete, prevParent = _a.prevParent, config = (0, $66bGh.__rest)(_a, [
                "originBox",
                "targetBox",
                "visibilityAction",
                "shouldStackAnimate",
                "onComplete",
                "prevParent"
            ]);
            var _b = _this.props, visualElement = _b.visualElement, layout = _b.layout;
            /**
             * Early return if we've been instructed not to animate this render.
             */ if (shouldStackAnimate === false) {
                _this.isAnimatingTree = false;
                return _this.safeToRemove();
            }
            /**
             * Prioritise tree animations
             */ if (_this.isAnimatingTree && shouldStackAnimate !== true) return;
            else if (shouldStackAnimate) _this.isAnimatingTree = true;
            /**
             * Allow the measured origin (prev bounding box) and target (actual layout) to be
             * overridden by the provided config.
             */ origin = originBox || origin;
            target = targetBox || target;
            /**
             * If this element has a projecting parent, there's an opportunity to animate
             * it relatively to that parent rather than relatively to the viewport. This
             * allows us to add orchestrated animations.
             */ var isRelative = false;
            var projectionParent = visualElement.getProjectionParent();
            if (projectionParent) {
                var prevParentViewportBox = projectionParent.prevViewportBox;
                var parentLayout = projectionParent.getLayoutState().layout;
                /**
                 * If we're being provided a previous parent VisualElement by AnimateSharedLayout
                 */ if (prevParent) {
                    /**
                     * If we've been provided an explicit target box it means we're animating back
                     * to this previous parent. So we can make a relative box by comparing to the previous
                     * parent's layout
                     */ if (targetBox) parentLayout = prevParent.getLayoutState().layout;
                    /**
                     * Likewise if we've been provided an explicit origin box it means we're
                     * animating out from a different element. So we should figure out where that was
                     * on screen relative to the new parent element.
                     */ if (originBox && !(0, $a789I.checkIfParentHasChanged)(prevParent, projectionParent) && prevParent.prevViewportBox) prevParentViewportBox = prevParent.prevViewportBox;
                }
                if (prevParentViewportBox && $bc5350002ea73f00$var$isProvidedCorrectDataForRelativeSharedLayout(prevParent, originBox, targetBox)) {
                    isRelative = true;
                    origin = (0, $a789I.calcRelativeOffset)(prevParentViewportBox, origin);
                    target = (0, $a789I.calcRelativeOffset)(parentLayout, target);
                }
            }
            var boxHasMoved = $bc5350002ea73f00$var$hasMoved(origin, target);
            var animations = (0, $bbVsu.eachAxis)(function(axis) {
                var _a, _b;
                /**
                 * If layout is set to "position", we can resize the origin box based on the target
                 * box and only animate its position.
                 */ if (layout === "position") {
                    var targetLength = target[axis].max - target[axis].min;
                    origin[axis].max = origin[axis].min + targetLength;
                }
                if (visualElement.projection.isTargetLocked) return;
                else if (visibilityAction !== undefined) visualElement.setVisibility(visibilityAction === (0, $aRkas.VisibilityAction).Show);
                else if (boxHasMoved) // If the box has moved, animate between it's current visual state and its
                // final state
                return _this.animateAxis(axis, target[axis], origin[axis], (0, $66bGh.__assign)((0, $66bGh.__assign)({}, config), {
                    isRelative: isRelative
                }));
                else {
                    (_b = (_a = _this.stopAxisAnimation)[axis]) === null || _b === void 0 || _b.call(_a);
                    // If the box has remained in the same place, immediately set the axis target
                    // to the final desired state
                    return visualElement.setProjectionTargetAxis(axis, target[axis].min, target[axis].max, isRelative);
                }
            });
            // Force a render to ensure there's no flash of uncorrected bounding box.
            visualElement.syncRender();
            /**
             * If this visualElement isn't present (ie it's been removed from the tree by the user but
             * kept in by the tree by AnimatePresence) then call safeToRemove when all axis animations
             * have successfully finished.
             */ return Promise.all(animations).then(function() {
                _this.isAnimatingTree = false;
                onComplete && onComplete();
                visualElement.notifyLayoutAnimationComplete();
            });
        };
        return _this;
    }
    Animate.prototype.componentDidMount = function() {
        var _this = this;
        var visualElement = this.props.visualElement;
        visualElement.animateMotionValue = (0, $6CYZP.startAnimation);
        visualElement.enableLayoutProjection();
        this.unsubLayoutReady = visualElement.onLayoutUpdate(this.animate);
        visualElement.layoutSafeToRemove = function() {
            return _this.safeToRemove();
        };
        (0, $c9NBR.addScaleCorrection)((0, $ke1iK.defaultScaleCorrectors));
    };
    Animate.prototype.componentWillUnmount = function() {
        var _this = this;
        this.unsubLayoutReady();
        (0, $bbVsu.eachAxis)(function(axis) {
            var _a, _b;
            return (_b = (_a = _this.stopAxisAnimation)[axis]) === null || _b === void 0 ? void 0 : _b.call(_a);
        });
    };
    /**
     * TODO: This manually performs animations on the visualElement's layout progress
     * values. It'd be preferable to amend the startLayoutAxisAnimation
     * API to accept more custom animations like this.
     */ Animate.prototype.animateAxis = function(axis, target, origin, _a) {
        var _this = this;
        var _b, _c;
        var _d = _a === void 0 ? {} : _a, transition = _d.transition, isRelative = _d.isRelative;
        /**
         * If we're not animating to a new target, don't run this animation
         */ if (this.isAnimating[axis] && $bc5350002ea73f00$var$axisIsEqual(target, this.currentAnimationTarget[axis])) return;
        (_c = (_b = this.stopAxisAnimation)[axis]) === null || _c === void 0 || _c.call(_b);
        this.isAnimating[axis] = true;
        var visualElement = this.props.visualElement;
        var frameTarget = this.frameTarget[axis];
        var layoutProgress = visualElement.getProjectionAnimationProgress()[axis];
        /**
         * Set layout progress back to 0. We set it twice to hard-reset any velocity that might
         * be re-incoporated into a subsequent spring animation.
         */ layoutProgress.clearListeners();
        layoutProgress.set(0);
        layoutProgress.set(0);
        /**
         * Create an animation function to run once per frame. This will tween the visual bounding box from
         * origin to target using the latest progress value.
         */ var frame = function() {
            // Convert the latest layoutProgress, which is a value from 0-1000, into a 0-1 progress
            var p = layoutProgress.get() / $bc5350002ea73f00$var$progressTarget;
            // Tween the axis and update the visualElement with the latest values
            (0, $a789I.tweenAxis)(frameTarget, origin, target, p);
            visualElement.setProjectionTargetAxis(axis, frameTarget.min, frameTarget.max, isRelative);
        };
        // Synchronously run a frame to ensure there's no flash of the uncorrected bounding box.
        frame();
        // Create a function to stop animation on this specific axis
        var unsubscribeProgress = layoutProgress.onChange(frame);
        this.stopAxisAnimation[axis] = function() {
            _this.isAnimating[axis] = false;
            layoutProgress.stop();
            unsubscribeProgress();
        };
        this.currentAnimationTarget[axis] = target;
        var layoutTransition = transition || visualElement.getDefaultTransition() || $bc5350002ea73f00$var$defaultLayoutTransition;
        // Start the animation on this axis
        var animation = (0, $6CYZP.startAnimation)(axis === "x" ? "layoutX" : "layoutY", layoutProgress, $bc5350002ea73f00$var$progressTarget, layoutTransition && (0, $6CYZP.getValueTransition)(layoutTransition, "layout")).then(this.stopAxisAnimation[axis]);
        return animation;
    };
    Animate.prototype.safeToRemove = function() {
        var _a, _b;
        (_b = (_a = this.props).safeToRemove) === null || _b === void 0 || _b.call(_a);
    };
    Animate.prototype.render = function() {
        return null;
    };
    return Animate;
}($gJYWc.Component);
function $bc5350002ea73f00$export$bd44d4206e0b4eca(props) {
    var _a = (0, $66bGh.__read)((0, $dUQA6.usePresence)(), 2), safeToRemove = _a[1];
    return $gJYWc.createElement($bc5350002ea73f00$var$Animate, (0, $66bGh.__assign)({}, props, {
        safeToRemove: safeToRemove
    }));
}
function $bc5350002ea73f00$var$hasMoved(a, b) {
    return !$bc5350002ea73f00$var$isZeroBox(a) && !$bc5350002ea73f00$var$isZeroBox(b) && (!$bc5350002ea73f00$var$axisIsEqual(a.x, b.x) || !$bc5350002ea73f00$var$axisIsEqual(a.y, b.y));
}
var $bc5350002ea73f00$var$zeroAxis = {
    min: 0,
    max: 0
};
function $bc5350002ea73f00$var$isZeroBox(a) {
    return $bc5350002ea73f00$var$axisIsEqual(a.x, $bc5350002ea73f00$var$zeroAxis) && $bc5350002ea73f00$var$axisIsEqual(a.y, $bc5350002ea73f00$var$zeroAxis);
}
function $bc5350002ea73f00$var$axisIsEqual(a, b) {
    return a.min === b.min && a.max === b.max;
}
var $bc5350002ea73f00$var$defaultLayoutTransition = {
    duration: 0.45,
    ease: [
        0.4,
        0,
        0.1,
        1
    ]
};
function $bc5350002ea73f00$var$isProvidedCorrectDataForRelativeSharedLayout(prevParent, originBox, targetBox) {
    return prevParent || !prevParent && !(originBox || targetBox);
}

});
parcelRegister("ke1iK", function(module, exports) {

$parcel$export(module.exports, "defaultScaleCorrectors", function () { return $eb961fe2e6371045$export$f5121daded6e3d5d; });

var $66bGh = parcelRequire("66bGh");

var $iNhZm = parcelRequire("iNhZm");
var $4B3zo = parcelRequire("4B3zo");

var $203mS = parcelRequire("203mS");

var $dGRG5 = parcelRequire("dGRG5");
function $eb961fe2e6371045$export$fafff692be55225d(pixels, axis) {
    return pixels / (axis.max - axis.min) * 100;
}
/**
 * We always correct borderRadius as a percentage rather than pixels to reduce paints.
 * For example, if you are projecting a box that is 100px wide with a 10px borderRadius
 * into a box that is 200px wide with a 20px borderRadius, that is actually a 10%
 * borderRadius in both states. If we animate between the two in pixels that will trigger
 * a paint each time. If we animate between the two in percentage we'll avoid a paint.
 */ function $eb961fe2e6371045$export$5eafb6257a5844c(latest, _layoutState, _a) {
    var target = _a.target;
    /**
     * If latest is a string, if it's a percentage we can return immediately as it's
     * going to be stretched appropriately. Otherwise, if it's a pixel, convert it to a number.
     */ if (typeof latest === "string") {
        if ((0, $4B3zo.px).test(latest)) latest = parseFloat(latest);
        else return latest;
    }
    /**
     * If latest is a number, it's a pixel value. We use the current viewportBox to calculate that
     * pixel value as a percentage of each axis
     */ var x = $eb961fe2e6371045$export$fafff692be55225d(latest, target.x);
    var y = $eb961fe2e6371045$export$fafff692be55225d(latest, target.y);
    return x + "% " + y + "%";
}
var $eb961fe2e6371045$var$varToken = "_$css";
function $eb961fe2e6371045$export$eb0bc629e74dcf8(latest, _a) {
    var delta = _a.delta, treeScale = _a.treeScale;
    var original = latest;
    /**
     * We need to first strip and store CSS variables from the string.
     */ var containsCSSVariables = latest.includes("var(");
    var cssVariables = [];
    if (containsCSSVariables) latest = latest.replace((0, $dGRG5.cssVariableRegex), function(match) {
        cssVariables.push(match);
        return $eb961fe2e6371045$var$varToken;
    });
    var shadow = (0, $iNhZm.complex).parse(latest);
    // TODO: Doesn't support multiple shadows
    if (shadow.length > 5) return original;
    var template = (0, $iNhZm.complex).createTransformer(latest);
    var offset = typeof shadow[0] !== "number" ? 1 : 0;
    // Calculate the overall context scale
    var xScale = delta.x.scale * treeScale.x;
    var yScale = delta.y.scale * treeScale.y;
    shadow[0 + offset] /= xScale;
    shadow[1 + offset] /= yScale;
    /**
     * Ideally we'd correct x and y scales individually, but because blur and
     * spread apply to both we have to take a scale average and apply that instead.
     * We could potentially improve the outcome of this by incorporating the ratio between
     * the two scales.
     */ var averageScale = (0, $203mS.mix)(xScale, yScale, 0.5);
    // Blur
    if (typeof shadow[2 + offset] === "number") shadow[2 + offset] /= averageScale;
    // Spread
    if (typeof shadow[3 + offset] === "number") shadow[3 + offset] /= averageScale;
    var output = template(shadow);
    if (containsCSSVariables) {
        var i_1 = 0;
        output = output.replace($eb961fe2e6371045$var$varToken, function() {
            var cssVariable = cssVariables[i_1];
            i_1++;
            return cssVariable;
        });
    }
    return output;
}
var $eb961fe2e6371045$var$borderCorrectionDefinition = {
    process: $eb961fe2e6371045$export$5eafb6257a5844c
};
var $eb961fe2e6371045$export$f5121daded6e3d5d = {
    borderRadius: (0, $66bGh.__assign)((0, $66bGh.__assign)({}, $eb961fe2e6371045$var$borderCorrectionDefinition), {
        applyTo: [
            "borderTopLeftRadius",
            "borderTopRightRadius",
            "borderBottomLeftRadius",
            "borderBottomRightRadius"
        ]
    }),
    borderTopLeftRadius: $eb961fe2e6371045$var$borderCorrectionDefinition,
    borderTopRightRadius: $eb961fe2e6371045$var$borderCorrectionDefinition,
    borderBottomLeftRadius: $eb961fe2e6371045$var$borderCorrectionDefinition,
    borderBottomRightRadius: $eb961fe2e6371045$var$borderCorrectionDefinition,
    boxShadow: {
        process: $eb961fe2e6371045$export$eb0bc629e74dcf8
    }
};

});
parcelRegister("dGRG5", function(module, exports) {

$parcel$export(module.exports, "cssVariableRegex", function () { return $9f78d5e499f1fa3a$export$f7c0a352d8ef6313; });
$parcel$export(module.exports, "resolveCSSVariables", function () { return $9f78d5e499f1fa3a$export$669319b042b57350; });

var $66bGh = parcelRequire("66bGh");

var $739Hg = parcelRequire("739Hg");
function $9f78d5e499f1fa3a$var$isCSSVariable(value) {
    return typeof value === "string" && value.startsWith("var(--");
}
/**
 * Parse Framer's special CSS variable format into a CSS token and a fallback.
 *
 * ```
 * `var(--foo, #fff)` => [`--foo`, '#fff']
 * ```
 *
 * @param current
 */ var $9f78d5e499f1fa3a$export$f7c0a352d8ef6313 = /var\((--[a-zA-Z0-9-_]+),? ?([a-zA-Z0-9 ()%#.,-]+)?\)/;
function $9f78d5e499f1fa3a$export$b9f0c1f373aee2b0(current) {
    var match = $9f78d5e499f1fa3a$export$f7c0a352d8ef6313.exec(current);
    if (!match) return [
        , 
    ];
    var _a = (0, $66bGh.__read)(match, 3), token = _a[1], fallback = _a[2];
    return [
        token,
        fallback
    ];
}
var $9f78d5e499f1fa3a$var$maxDepth = 4;
function $9f78d5e499f1fa3a$var$getVariableValue(current, element, depth) {
    if (depth === void 0) depth = 1;
    (0, $739Hg.invariant)(depth <= $9f78d5e499f1fa3a$var$maxDepth, "Max CSS variable fallback depth detected in property \"" + current + "\". This may indicate a circular fallback dependency.");
    var _a = (0, $66bGh.__read)($9f78d5e499f1fa3a$export$b9f0c1f373aee2b0(current), 2), token = _a[0], fallback = _a[1];
    // No CSS variable detected
    if (!token) return;
    // Attempt to read this CSS variable off the element
    var resolved = window.getComputedStyle(element).getPropertyValue(token);
    if (resolved) return resolved.trim();
    else if ($9f78d5e499f1fa3a$var$isCSSVariable(fallback)) // The fallback might itself be a CSS variable, in which case we attempt to resolve it too.
    return $9f78d5e499f1fa3a$var$getVariableValue(fallback, element, depth + 1);
    else return fallback;
}
/**
 * Resolve CSS variables from
 *
 * @internal
 */ function $9f78d5e499f1fa3a$export$669319b042b57350(visualElement, _a, transitionEnd) {
    var _b;
    var target = (0, $66bGh.__rest)(_a, []);
    var element = visualElement.getInstance();
    if (!(element instanceof HTMLElement)) return {
        target: target,
        transitionEnd: transitionEnd
    };
    // If `transitionEnd` isn't `undefined`, clone it. We could clone `target` and `transitionEnd`
    // only if they change but I think this reads clearer and this isn't a performance-critical path.
    if (transitionEnd) transitionEnd = (0, $66bGh.__assign)({}, transitionEnd);
    // Go through existing `MotionValue`s and ensure any existing CSS variables are resolved
    visualElement.forEachValue(function(value) {
        var current = value.get();
        if (!$9f78d5e499f1fa3a$var$isCSSVariable(current)) return;
        var resolved = $9f78d5e499f1fa3a$var$getVariableValue(current, element);
        if (resolved) value.set(resolved);
    });
    // Cycle through every target property and resolve CSS variables. Currently
    // we only read single-var properties like `var(--foo)`, not `calc(var(--foo) + 20px)`
    for(var key in target){
        var current = target[key];
        if (!$9f78d5e499f1fa3a$var$isCSSVariable(current)) continue;
        var resolved = $9f78d5e499f1fa3a$var$getVariableValue(current, element);
        if (!resolved) continue;
        // Clone target if it hasn't already been
        target[key] = resolved;
        // If the user hasn't already set this key on `transitionEnd`, set it to the unresolved
        // CSS variable. This will ensure that after the animation the component will reflect
        // changes in the value of the CSS variable.
        if (transitionEnd) (_b = transitionEnd[key]) !== null && _b !== void 0 ? _b : transitionEnd[key] = current;
    }
    return {
        target: target,
        transitionEnd: transitionEnd
    };
}

});



parcelRegister("jtBLI", function(module, exports) {

$parcel$export(module.exports, "MeasureContextProvider", function () { return $e2de05cbedee6071$export$47ef792ac0e676f6; });

var $66bGh = parcelRequire("66bGh");

var $gJYWc = parcelRequire("gJYWc");

var $db9c2 = parcelRequire("db9c2");

var $52vCk = parcelRequire("52vCk");
/**
 * This component is responsible for scheduling the measuring of the motion component
 */ var $e2de05cbedee6071$var$Measure = /** @class */ function(_super) {
    (0, $66bGh.__extends)(Measure, _super);
    function Measure() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * If this is a child of a SyncContext, register the VisualElement with it on mount.
     */ Measure.prototype.componentDidMount = function() {
        var _a = this.props, syncLayout = _a.syncLayout, framerSyncLayout = _a.framerSyncLayout, visualElement = _a.visualElement;
        (0, $db9c2.isSharedLayout)(syncLayout) && syncLayout.register(visualElement);
        (0, $db9c2.isSharedLayout)(framerSyncLayout) && framerSyncLayout.register(visualElement);
        visualElement.onUnmount(function() {
            if ((0, $db9c2.isSharedLayout)(syncLayout)) syncLayout.remove(visualElement);
            if ((0, $db9c2.isSharedLayout)(framerSyncLayout)) framerSyncLayout.remove(visualElement);
        });
    };
    /**
     * If this is a child of a SyncContext, notify it that it needs to re-render. It will then
     * handle the snapshotting.
     *
     * If it is stand-alone component, add it to the batcher.
     */ Measure.prototype.getSnapshotBeforeUpdate = function() {
        var _a = this.props, syncLayout = _a.syncLayout, visualElement = _a.visualElement;
        if ((0, $db9c2.isSharedLayout)(syncLayout)) syncLayout.syncUpdate();
        else {
            (0, $52vCk.snapshotViewportBox)(visualElement);
            syncLayout.add(visualElement);
        }
        return null;
    };
    Measure.prototype.componentDidUpdate = function() {
        var syncLayout = this.props.syncLayout;
        if (!(0, $db9c2.isSharedLayout)(syncLayout)) syncLayout.flush();
    };
    Measure.prototype.render = function() {
        return null;
    };
    return Measure;
}((0, (/*@__PURE__*/$parcel$interopDefault($gJYWc))).Component);
function $e2de05cbedee6071$export$47ef792ac0e676f6(props) {
    var syncLayout = (0, $gJYWc.useContext)((0, $db9c2.SharedLayoutContext));
    var framerSyncLayout = (0, $gJYWc.useContext)((0, $db9c2.FramerTreeLayoutContext));
    return (0, (/*@__PURE__*/$parcel$interopDefault($gJYWc))).createElement($e2de05cbedee6071$var$Measure, (0, $66bGh.__assign)({}, props, {
        syncLayout: syncLayout,
        framerSyncLayout: framerSyncLayout
    }));
}

});


parcelRegister("h9Bmg", function(module, exports) {

$parcel$export(module.exports, "createDomVisualElement", function () { return $c7d04178528c2af1$export$56ba0183203348f5; });

var $dvVt2 = parcelRequire("dvVt2");

var $b5EBL = parcelRequire("b5EBL");

var $htvfJ = parcelRequire("htvfJ");
var $c7d04178528c2af1$export$56ba0183203348f5 = function(Component, options) {
    return (0, $htvfJ.isSVGComponent)(Component) ? (0, $b5EBL.svgVisualElement)(options, {
        enableHardwareAcceleration: false
    }) : (0, $dvVt2.htmlVisualElement)(options, {
        enableHardwareAcceleration: true
    });
};

});
parcelRegister("dvVt2", function(module, exports) {

$parcel$export(module.exports, "htmlConfig", function () { return $9d6abf68bb2a20ee$export$985b1494d4aeee90; });
$parcel$export(module.exports, "htmlVisualElement", function () { return $9d6abf68bb2a20ee$export$9509f7c142585e92; });

var $66bGh = parcelRequire("66bGh");

var $6GMTc = parcelRequire("6GMTc");

var $cA2Zn = parcelRequire("cA2Zn");

var $lphzD = parcelRequire("lphzD");

var $68PBy = parcelRequire("68PBy");

var $cHiBe = parcelRequire("cHiBe");

var $3YgUz = parcelRequire("3YgUz");

var $wmU9r = parcelRequire("wmU9r");

var $23199 = parcelRequire("23199");

var $ggG97 = parcelRequire("ggG97");

var $2fWSs = parcelRequire("2fWSs");

var $lkz4B = parcelRequire("lkz4B");
function $9d6abf68bb2a20ee$export$3735103072e4a80(element) {
    return window.getComputedStyle(element);
}
var $9d6abf68bb2a20ee$export$985b1494d4aeee90 = {
    treeType: "dom",
    readValueFromInstance: function(domElement, key) {
        if ((0, $wmU9r.isTransformProp)(key)) {
            var defaultType = (0, $2fWSs.getDefaultValueType)(key);
            return defaultType ? defaultType.default || 0 : 0;
        } else {
            var computedStyle = $9d6abf68bb2a20ee$export$3735103072e4a80(domElement);
            return ((0, $cHiBe.isCSSVariable)(key) ? computedStyle.getPropertyValue(key) : computedStyle[key]) || 0;
        }
    },
    sortNodePosition: function(a, b) {
        /**
         * compareDocumentPosition returns a bitmask, by using the bitwise &
         * we're returning true if 2 in that bitmask is set to true. 2 is set
         * to true if b preceeds a.
         */ return a.compareDocumentPosition(b) & 2 ? 1 : -1;
    },
    getBaseTarget: function(props, key) {
        var _a;
        return (_a = props.style) === null || _a === void 0 ? void 0 : _a[key];
    },
    measureViewportBox: function(element, _a) {
        var transformPagePoint = _a.transformPagePoint;
        return (0, $lphzD.getBoundingBox)(element, transformPagePoint);
    },
    /**
     * Reset the transform on the current Element. This is called as part
     * of a batched process across the entire layout tree. To remove this write
     * cycle it'd be interesting to see if it's possible to "undo" all the current
     * layout transforms up the tree in the same way this.getBoundingBoxWithoutTransforms
     * works
     */ resetTransform: function(element, domElement, props) {
        var transformTemplate = props.transformTemplate;
        domElement.style.transform = transformTemplate ? transformTemplate({}, "") : "none";
        // Ensure that whatever happens next, we restore our transform on the next frame
        element.scheduleRender();
    },
    restoreTransform: function(instance, mutableState) {
        instance.style.transform = mutableState.style.transform;
    },
    removeValueFromRenderState: function(key, _a) {
        var vars = _a.vars, style = _a.style;
        delete vars[key];
        delete style[key];
    },
    /**
     * Ensure that HTML and Framer-specific value types like `px`->`%` and `Color`
     * can be animated by Motion.
     */ makeTargetAnimatable: function(element, _a, _b, isMounted) {
        var transformValues = _b.transformValues;
        if (isMounted === void 0) isMounted = true;
        var transition = _a.transition, transitionEnd = _a.transitionEnd, target = (0, $66bGh.__rest)(_a, [
            "transition",
            "transitionEnd"
        ]);
        var origin = (0, $cA2Zn.getOrigin)(target, transition || {}, element);
        /**
         * If Framer has provided a function to convert `Color` etc value types, convert them
         */ if (transformValues) {
            if (transitionEnd) transitionEnd = transformValues(transitionEnd);
            if (target) target = transformValues(target);
            if (origin) origin = transformValues(origin);
        }
        if (isMounted) {
            (0, $cA2Zn.checkTargetForNewValues)(element, target, origin);
            var parsed = (0, $3YgUz.parseDomVariant)(element, target, origin, transitionEnd);
            transitionEnd = parsed.transitionEnd;
            target = parsed.target;
        }
        return (0, $66bGh.__assign)({
            transition: transition,
            transitionEnd: transitionEnd
        }, target);
    },
    scrapeMotionValuesFromProps: (0, $23199.scrapeMotionValuesFromProps),
    build: function(element, renderState, latestValues, projection, layoutState, options, props) {
        if (element.isVisible !== undefined) renderState.style.visibility = element.isVisible ? "visible" : "hidden";
        var isProjectionTranform = projection.isEnabled && layoutState.isHydrated;
        (0, $68PBy.buildHTMLStyles)(renderState, latestValues, projection, layoutState, options, props.transformTemplate, isProjectionTranform ? (0, $lkz4B.buildLayoutProjectionTransform) : undefined, isProjectionTranform ? (0, $lkz4B.buildLayoutProjectionTransformOrigin) : undefined);
    },
    render: (0, $ggG97.renderHTML)
};
var $9d6abf68bb2a20ee$export$9509f7c142585e92 = (0, $6GMTc.visualElement)($9d6abf68bb2a20ee$export$985b1494d4aeee90);

});
parcelRegister("6GMTc", function(module, exports) {

$parcel$export(module.exports, "visualElement", function () { return $4dec96baa9134630$export$5ad594e944c33d76; });

var $66bGh = parcelRequire("66bGh");

var $fzvX8 = parcelRequire("fzvX8");

var $6Zyiw = parcelRequire("6Zyiw");

var $aRkas = parcelRequire("aRkas");

var $bbVsu = parcelRequire("bbVsu");

var $hJbCe = parcelRequire("hJbCe");

var $7eAOS = parcelRequire("7eAOS");

var $hDYE8 = parcelRequire("hDYE8");

var $1XUdZ = parcelRequire("1XUdZ");

var $a3Km2 = parcelRequire("a3Km2");

var $lkz4B = parcelRequire("lkz4B");

var $f5zA9 = parcelRequire("f5zA9");

var $1b19L = parcelRequire("1b19L");

var $2PaTK = parcelRequire("2PaTK");

var $3Ct4H = parcelRequire("3Ct4H");

var $jJzLq = parcelRequire("jJzLq");

var $ip93O = parcelRequire("ip93O");

var $g4bZm = parcelRequire("g4bZm");

var $gYzOH = parcelRequire("gYzOH");

var $TYiew = parcelRequire("TYiew");
var $4dec96baa9134630$export$5ad594e944c33d76 = function(_a) {
    var _b = _a.treeType, treeType = _b === void 0 ? "" : _b, build = _a.build, getBaseTarget = _a.getBaseTarget, makeTargetAnimatable = _a.makeTargetAnimatable, measureViewportBox = _a.measureViewportBox, renderInstance = _a.render, readValueFromInstance = _a.readValueFromInstance, resetTransform = _a.resetTransform, restoreTransform = _a.restoreTransform, removeValueFromRenderState = _a.removeValueFromRenderState, sortNodePosition = _a.sortNodePosition, scrapeMotionValuesFromProps = _a.scrapeMotionValuesFromProps;
    return function(_a, options) {
        var parent = _a.parent, props = _a.props, presenceId = _a.presenceId, blockInitialAnimation = _a.blockInitialAnimation, visualState = _a.visualState;
        if (options === void 0) options = {};
        var latestValues = visualState.latestValues, renderState = visualState.renderState;
        /**
         * The instance of the render-specific node that will be hydrated by the
         * exposed React ref. So for example, this visual element can host a
         * HTMLElement, plain object, or Three.js object. The functions provided
         * in VisualElementConfig allow us to interface with this instance.
         */ var instance;
        /**
         * Manages the subscriptions for a visual element's lifecycle, for instance
         * onRender and onViewportBoxUpdate.
         */ var lifecycles = (0, $1b19L.createLifecycles)();
        /**
         *
         */ var projection = (0, $jJzLq.createProjectionState)();
        /**
         * A reference to the nearest projecting parent. This is either
         * undefined if we haven't looked for the nearest projecting parent,
         * false if there is no parent performing layout projection, or a reference
         * to the projecting parent.
         */ var projectionParent;
        /**
         * This is a reference to the visual state of the "lead" visual element.
         * Usually, this will be this visual element. But if it shares a layoutId
         * with other visual elements, only one of them will be designated lead by
         * AnimateSharedLayout. All the other visual elements will take on the visual
         * appearance of the lead while they crossfade to it.
         */ var leadProjection = projection;
        var leadLatestValues = latestValues;
        var unsubscribeFromLeadVisualElement;
        /**
         * The latest layout measurements and calculated projections. This
         * is seperate from the target projection data in visualState as
         * many visual elements might point to the same piece of visualState as
         * a target, whereas they might each have different layouts and thus
         * projection calculations needed to project into the same viewport box.
         */ var layoutState = (0, $jJzLq.createLayoutState)();
        /**
         *
         */ var crossfader;
        /**
         * Keep track of whether the viewport box has been updated since the
         * last time the layout projection was re-calculated.
         */ var hasViewportBoxUpdated = false;
        /**
         * A map of all motion values attached to this visual element. Motion
         * values are source of truth for any given animated value. A motion
         * value might be provided externally by the component via props.
         */ var values = new Map();
        /**
         * A map of every subscription that binds the provided or generated
         * motion values onChange listeners to this visual element.
         */ var valueSubscriptions = new Map();
        /**
         * A reference to the previously-provided motion values as returned
         * from scrapeMotionValuesFromProps. We use the keys in here to determine
         * if any motion values need to be removed after props are updated.
         */ var prevMotionValues = {};
        /**
         * x/y motion values that track the progress of initiated layout
         * animations.
         *
         * TODO: Target for removal
         */ var projectionTargetProgress;
        /**
         * When values are removed from all animation props we need to search
         * for a fallback value to animate to. These values are tracked in baseTarget.
         */ var baseTarget = (0, $66bGh.__assign)({}, latestValues);
        // Internal methods ========================
        /**
         * On mount, this will be hydrated with a callback to disconnect
         * this visual element from its parent on unmount.
         */ var removeFromVariantTree;
        /**
         *
         */ function render() {
            if (!instance) return;
            if (element.isProjectionReady()) {
                /**
                 * Apply the latest user-set transforms to the targetBox to produce the targetBoxFinal.
                 * This is the final box that we will then project into by calculating a transform delta and
                 * applying it to the corrected box.
                 */ (0, $7eAOS.applyBoxTransforms)(leadProjection.targetFinal, leadProjection.target, leadLatestValues);
                /**
                 * Update the delta between the corrected box and the final target box, after
                 * user-set transforms are applied to it. This will be used by the renderer to
                 * create a transform style that will reproject the element from its actual layout
                 * into the desired bounding box.
                 */ (0, $hDYE8.updateBoxDelta)(layoutState.deltaFinal, layoutState.layoutCorrected, leadProjection.targetFinal, latestValues);
            }
            triggerBuild();
            renderInstance(instance, renderState);
        }
        function triggerBuild() {
            var valuesToRender = latestValues;
            if (crossfader && crossfader.isActive()) {
                var crossfadedValues = crossfader.getCrossfadeState(element);
                if (crossfadedValues) valuesToRender = crossfadedValues;
            }
            build(element, renderState, valuesToRender, leadProjection, layoutState, options, props);
        }
        function update() {
            lifecycles.notifyUpdate(latestValues);
        }
        function updateLayoutProjection() {
            if (!element.isProjectionReady()) return;
            var delta = layoutState.delta, treeScale = layoutState.treeScale;
            var prevTreeScaleX = treeScale.x;
            var prevTreeScaleY = treeScale.y;
            var prevDeltaTransform = layoutState.deltaTransform;
            (0, $3Ct4H.updateLayoutDeltas)(layoutState, leadProjection, element.path, latestValues);
            hasViewportBoxUpdated && element.notifyViewportBoxUpdate(leadProjection.target, delta);
            hasViewportBoxUpdated = false;
            var deltaTransform = (0, $lkz4B.buildLayoutProjectionTransform)(delta, treeScale);
            if (deltaTransform !== prevDeltaTransform || // Also compare calculated treeScale, for values that rely on this only for scale correction
            prevTreeScaleX !== treeScale.x || prevTreeScaleY !== treeScale.y) element.scheduleRender();
            layoutState.deltaTransform = deltaTransform;
        }
        function updateTreeLayoutProjection() {
            element.layoutTree.forEach($4dec96baa9134630$var$fireUpdateLayoutProjection);
        }
        /**
         *
         */ function bindToMotionValue(key, value) {
            var removeOnChange = value.onChange(function(latestValue) {
                latestValues[key] = latestValue;
                props.onUpdate && (0, $fzvX8.default).update(update, false, true);
            });
            var removeOnRenderRequest = value.onRenderRequest(element.scheduleRender);
            valueSubscriptions.set(key, function() {
                removeOnChange();
                removeOnRenderRequest();
            });
        }
        /**
         * Any motion values that are provided to the element when created
         * aren't yet bound to the element, as this would technically be impure.
         * However, we iterate through the motion values and set them to the
         * initial values for this component.
         *
         * TODO: This is impure and we should look at changing this to run on mount.
         * Doing so will break some tests but this isn't neccessarily a breaking change,
         * more a reflection of the test.
         */ var initialMotionValues = scrapeMotionValuesFromProps(props);
        for(var key in initialMotionValues){
            var value = initialMotionValues[key];
            if (latestValues[key] !== undefined && (0, $a3Km2.isMotionValue)(value)) value.set(latestValues[key], false);
        }
        /**
         * Determine what role this visual element should take in the variant tree.
         */ var isControllingVariants = (0, $g4bZm.checkIfControllingVariants)(props);
        var isVariantNode = (0, $g4bZm.checkIfVariantNode)(props);
        var element = (0, $66bGh.__assign)((0, $66bGh.__assign)({
            treeType: treeType,
            /**
             * This is a mirror of the internal instance prop, which keeps
             * VisualElement type-compatible with React's RefObject.
             */ current: null,
            /**
             * The depth of this visual element within the visual element tree.
             */ depth: parent ? parent.depth + 1 : 0,
            parent: parent,
            children: new Set(),
            /**
             * An ancestor path back to the root visual element. This is used
             * by layout projection to quickly recurse back up the tree.
             */ path: parent ? (0, $66bGh.__spreadArray)((0, $66bGh.__spreadArray)([], (0, $66bGh.__read)(parent.path)), [
                parent
            ]) : [],
            layoutTree: parent ? parent.layoutTree : new (0, $ip93O.FlatTree)(),
            /**
             *
             */ presenceId: presenceId,
            projection: projection,
            /**
             * If this component is part of the variant tree, it should track
             * any children that are also part of the tree. This is essentially
             * a shadow tree to simplify logic around how to stagger over children.
             */ variantChildren: isVariantNode ? new Set() : undefined,
            /**
             * Whether this instance is visible. This can be changed imperatively
             * by AnimateSharedLayout, is analogous to CSS's visibility in that
             * hidden elements should take up layout, and needs enacting by the configured
             * render function.
             */ isVisible: undefined,
            /**
             * Normally, if a component is controlled by a parent's variants, it can
             * rely on that ancestor to trigger animations further down the tree.
             * However, if a component is created after its parent is mounted, the parent
             * won't trigger that mount animation so the child needs to.
             *
             * TODO: This might be better replaced with a method isParentMounted
             */ manuallyAnimateOnMount: Boolean(parent === null || parent === void 0 ? void 0 : parent.isMounted()),
            /**
             * This can be set by AnimatePresence to force components that mount
             * at the same time as it to mount as if they have initial={false} set.
             */ blockInitialAnimation: blockInitialAnimation,
            /**
             * Determine whether this component has mounted yet. This is mostly used
             * by variant children to determine whether they need to trigger their
             * own animations on mount.
             */ isMounted: function() {
                return Boolean(instance);
            },
            mount: function(newInstance) {
                instance = element.current = newInstance;
                element.pointTo(element);
                if (isVariantNode && parent && !isControllingVariants) removeFromVariantTree = parent === null || parent === void 0 ? void 0 : parent.addVariantChild(element);
                parent === null || parent === void 0 || parent.children.add(element);
            },
            /**
             *
             */ unmount: function() {
                (0, $fzvX8.cancelSync).update(update);
                (0, $fzvX8.cancelSync).render(render);
                (0, $fzvX8.cancelSync).preRender(element.updateLayoutProjection);
                valueSubscriptions.forEach(function(remove) {
                    return remove();
                });
                element.stopLayoutAnimation();
                element.layoutTree.remove(element);
                removeFromVariantTree === null || removeFromVariantTree === void 0 || removeFromVariantTree();
                parent === null || parent === void 0 || parent.children.delete(element);
                unsubscribeFromLeadVisualElement === null || unsubscribeFromLeadVisualElement === void 0 || unsubscribeFromLeadVisualElement();
                lifecycles.clearAllListeners();
            },
            /**
             * Add a child visual element to our set of children.
             */ addVariantChild: function(child) {
                var _a;
                var closestVariantNode = element.getClosestVariantNode();
                if (closestVariantNode) {
                    (_a = closestVariantNode.variantChildren) === null || _a === void 0 || _a.add(child);
                    return function() {
                        return closestVariantNode.variantChildren.delete(child);
                    };
                }
            },
            sortNodePosition: function(other) {
                /**
                 * If these nodes aren't even of the same type we can't compare their depth.
                 */ if (!sortNodePosition || treeType !== other.treeType) return 0;
                return sortNodePosition(element.getInstance(), other.getInstance());
            },
            /**
             * Returns the closest variant node in the tree starting from
             * this visual element.
             */ getClosestVariantNode: function() {
                return isVariantNode ? element : parent === null || parent === void 0 ? void 0 : parent.getClosestVariantNode();
            },
            /**
             * A method that schedules an update to layout projections throughout
             * the tree. We inherit from the parent so there's only ever one
             * job scheduled on the next frame - that of the root visual element.
             */ scheduleUpdateLayoutProjection: parent ? parent.scheduleUpdateLayoutProjection : function() {
                return (0, $fzvX8.default).preRender(element.updateTreeLayoutProjection, false, true);
            },
            /**
             * Expose the latest layoutId prop.
             */ getLayoutId: function() {
                return props.layoutId;
            },
            /**
             * Returns the current instance.
             */ getInstance: function() {
                return instance;
            },
            /**
             * Get/set the latest static values.
             */ getStaticValue: function(key) {
                return latestValues[key];
            },
            setStaticValue: function(key, value) {
                return latestValues[key] = value;
            },
            /**
             * Returns the latest motion value state. Currently only used to take
             * a snapshot of the visual element - perhaps this can return the whole
             * visual state
             */ getLatestValues: function() {
                return latestValues;
            },
            /**
             * Set the visiblity of the visual element. If it's changed, schedule
             * a render to reflect these changes.
             */ setVisibility: function(visibility) {
                if (element.isVisible === visibility) return;
                element.isVisible = visibility;
                element.scheduleRender();
            },
            /**
             * Make a target animatable by Popmotion. For instance, if we're
             * trying to animate width from 100px to 100vw we need to measure 100vw
             * in pixels to determine what we really need to animate to. This is also
             * pluggable to support Framer's custom value types like Color,
             * and CSS variables.
             */ makeTargetAnimatable: function(target, canMutate) {
                if (canMutate === void 0) canMutate = true;
                return makeTargetAnimatable(element, target, props, canMutate);
            },
            // Motion values ========================
            /**
             * Add a motion value and bind it to this visual element.
             */ addValue: function(key, value) {
                // Remove existing value if it exists
                if (element.hasValue(key)) element.removeValue(key);
                values.set(key, value);
                latestValues[key] = value.get();
                bindToMotionValue(key, value);
            },
            /**
             * Remove a motion value and unbind any active subscriptions.
             */ removeValue: function(key) {
                var _a;
                values.delete(key);
                (_a = valueSubscriptions.get(key)) === null || _a === void 0 || _a();
                valueSubscriptions.delete(key);
                delete latestValues[key];
                removeValueFromRenderState(key, renderState);
            },
            /**
             * Check whether we have a motion value for this key
             */ hasValue: function(key) {
                return values.has(key);
            },
            /**
             * Get a motion value for this key. If called with a default
             * value, we'll create one if none exists.
             */ getValue: function(key, defaultValue) {
                var value = values.get(key);
                if (value === undefined && defaultValue !== undefined) {
                    value = (0, $1XUdZ.motionValue)(defaultValue);
                    element.addValue(key, value);
                }
                return value;
            },
            /**
             * Iterate over our motion values.
             */ forEachValue: function(callback) {
                return values.forEach(callback);
            },
            /**
             * If we're trying to animate to a previously unencountered value,
             * we need to check for it in our state and as a last resort read it
             * directly from the instance (which might have performance implications).
             */ readValue: function(key) {
                var _a;
                return (_a = latestValues[key]) !== null && _a !== void 0 ? _a : readValueFromInstance(instance, key, options);
            },
            /**
             * Set the base target to later animate back to. This is currently
             * only hydrated on creation and when we first read a value.
             */ setBaseTarget: function(key, value) {
                baseTarget[key] = value;
            },
            /**
             * Find the base target for a value thats been removed from all animation
             * props.
             */ getBaseTarget: function(key) {
                if (getBaseTarget) {
                    var target = getBaseTarget(props, key);
                    if (target !== undefined && !(0, $a3Km2.isMotionValue)(target)) return target;
                }
                return baseTarget[key];
            }
        }, lifecycles), {
            /**
             * Build the renderer state based on the latest visual state.
             */ build: function() {
                triggerBuild();
                return renderState;
            },
            /**
             * Schedule a render on the next animation frame.
             */ scheduleRender: function() {
                (0, $fzvX8.default).render(render, false, true);
            },
            /**
             * Synchronously fire render. It's prefered that we batch renders but
             * in many circumstances, like layout measurement, we need to run this
             * synchronously. However in those instances other measures should be taken
             * to batch reads/writes.
             */ syncRender: render,
            /**
             * Update the provided props. Ensure any newly-added motion values are
             * added to our map, old ones removed, and listeners updated.
             */ setProps: function(newProps) {
                props = newProps;
                lifecycles.updatePropListeners(newProps);
                prevMotionValues = (0, $2PaTK.updateMotionValuesFromProps)(element, scrapeMotionValuesFromProps(props), prevMotionValues);
            },
            getProps: function() {
                return props;
            },
            // Variants ==============================
            /**
             * Returns the variant definition with a given name.
             */ getVariant: function(name) {
                var _a;
                return (_a = props.variants) === null || _a === void 0 ? void 0 : _a[name];
            },
            /**
             * Returns the defined default transition on this component.
             */ getDefaultTransition: function() {
                return props.transition;
            },
            /**
             * Used by child variant nodes to get the closest ancestor variant props.
             */ getVariantContext: function(startAtParent) {
                if (startAtParent === void 0) startAtParent = false;
                if (startAtParent) return parent === null || parent === void 0 ? void 0 : parent.getVariantContext();
                if (!isControllingVariants) {
                    var context_1 = (parent === null || parent === void 0 ? void 0 : parent.getVariantContext()) || {};
                    if (props.initial !== undefined) context_1.initial = props.initial;
                    return context_1;
                }
                var context = {};
                for(var i = 0; i < $4dec96baa9134630$var$numVariantProps; i++){
                    var name_1 = $4dec96baa9134630$var$variantProps[i];
                    var prop = props[name_1];
                    if ((0, $g4bZm.isVariantLabel)(prop) || prop === false) context[name_1] = prop;
                }
                return context;
            },
            // Layout projection ==============================
            /**
             * Enable layout projection for this visual element. Won't actually
             * occur until we also have hydrated layout measurements.
             */ enableLayoutProjection: function() {
                projection.isEnabled = true;
                element.layoutTree.add(element);
            },
            /**
             * Lock the projection target, for instance when dragging, so
             * nothing else can try and animate it.
             */ lockProjectionTarget: function() {
                projection.isTargetLocked = true;
            },
            unlockProjectionTarget: function() {
                element.stopLayoutAnimation();
                projection.isTargetLocked = false;
            },
            getLayoutState: function() {
                return layoutState;
            },
            setCrossfader: function(newCrossfader) {
                crossfader = newCrossfader;
            },
            isProjectionReady: function() {
                return projection.isEnabled && projection.isHydrated && layoutState.isHydrated;
            },
            /**
             * Start a layout animation on a given axis.
             */ startLayoutAnimation: function(axis, transition, isRelative) {
                if (isRelative === void 0) isRelative = false;
                var progress = element.getProjectionAnimationProgress()[axis];
                var _a = isRelative ? projection.relativeTarget[axis] : projection.target[axis], min = _a.min, max = _a.max;
                var length = max - min;
                progress.clearListeners();
                progress.set(min);
                progress.set(min); // Set twice to hard-reset velocity
                progress.onChange(function(v) {
                    element.setProjectionTargetAxis(axis, v, v + length, isRelative);
                });
                return element.animateMotionValue(axis, progress, 0, transition);
            },
            /**
             * Stop layout animations.
             */ stopLayoutAnimation: function() {
                (0, $bbVsu.eachAxis)(function(axis) {
                    return element.getProjectionAnimationProgress()[axis].stop();
                });
            },
            /**
             * Measure the current viewport box with or without transforms.
             * Only measures axis-aligned boxes, rotate and skew must be manually
             * removed with a re-render to work.
             */ measureViewportBox: function(withTransform) {
                if (withTransform === void 0) withTransform = true;
                var viewportBox = measureViewportBox(instance, options);
                if (!withTransform) (0, $7eAOS.removeBoxTransforms)(viewportBox, latestValues);
                return viewportBox;
            },
            /**
             * Get the motion values tracking the layout animations on each
             * axis. Lazy init if not already created.
             */ getProjectionAnimationProgress: function() {
                projectionTargetProgress || (projectionTargetProgress = {
                    x: (0, $1XUdZ.motionValue)(0),
                    y: (0, $1XUdZ.motionValue)(0)
                });
                return projectionTargetProgress;
            },
            /**
             * Update the projection of a single axis. Schedule an update to
             * the tree layout projection.
             */ setProjectionTargetAxis: function(axis, min, max, isRelative) {
                if (isRelative === void 0) isRelative = false;
                var target;
                if (isRelative) {
                    if (!projection.relativeTarget) projection.relativeTarget = (0, $hJbCe.axisBox)();
                    target = projection.relativeTarget[axis];
                } else {
                    projection.relativeTarget = undefined;
                    target = projection.target[axis];
                }
                projection.isHydrated = true;
                target.min = min;
                target.max = max;
                // Flag that we want to fire the onViewportBoxUpdate event handler
                hasViewportBoxUpdated = true;
                lifecycles.notifySetAxisTarget();
            },
            /**
             * Rebase the projection target on top of the provided viewport box
             * or the measured layout. This ensures that non-animating elements
             * don't fall out of sync differences in measurements vs projections
             * after a page scroll or other relayout.
             */ rebaseProjectionTarget: function(force, box) {
                if (box === void 0) box = layoutState.layout;
                var _a = element.getProjectionAnimationProgress(), x = _a.x, y = _a.y;
                var shouldRebase = !projection.relativeTarget && !projection.isTargetLocked && !x.isAnimating() && !y.isAnimating();
                if (force || shouldRebase) (0, $bbVsu.eachAxis)(function(axis) {
                    var _a = box[axis], min = _a.min, max = _a.max;
                    element.setProjectionTargetAxis(axis, min, max);
                });
            },
            /**
             * Notify the visual element that its layout is up-to-date.
             * Currently Animate.tsx uses this to check whether a layout animation
             * needs to be performed.
             */ notifyLayoutReady: function(config) {
                (0, $gYzOH.setCurrentViewportBox)(element);
                element.notifyLayoutUpdate(layoutState.layout, element.prevViewportBox || layoutState.layout, config);
            },
            /**
             * Temporarily reset the transform of the instance.
             */ resetTransform: function() {
                return resetTransform(element, instance, props);
            },
            restoreTransform: function() {
                return restoreTransform(instance, renderState);
            },
            updateLayoutProjection: updateLayoutProjection,
            updateTreeLayoutProjection: function() {
                element.layoutTree.forEach($4dec96baa9134630$var$fireResolveRelativeTargetBox);
                /**
                 * Schedule the projection updates at the end of the current preRender
                 * step. This will ensure that all layout trees will first resolve
                 * relative projection boxes into viewport boxes, and *then*
                 * update projections.
                 */ (0, $fzvX8.default).preRender(updateTreeLayoutProjection, false, true);
            // sync.postRender(() => element.scheduleUpdateLayoutProjection())
            },
            getProjectionParent: function() {
                if (projectionParent === undefined) {
                    var foundParent = false;
                    // Search backwards through the tree path
                    for(var i = element.path.length - 1; i >= 0; i--){
                        var ancestor = element.path[i];
                        if (ancestor.projection.isEnabled) {
                            foundParent = ancestor;
                            break;
                        }
                    }
                    projectionParent = foundParent;
                }
                return projectionParent;
            },
            resolveRelativeTargetBox: function() {
                var relativeParent = element.getProjectionParent();
                if (!projection.relativeTarget || !relativeParent) return;
                (0, $hDYE8.calcRelativeBox)(projection, relativeParent.projection);
                if ((0, $TYiew.isDraggable)(relativeParent)) {
                    var target = projection.target;
                    (0, $7eAOS.applyBoxTransforms)(target, target, relativeParent.getLatestValues());
                }
            },
            shouldResetTransform: function() {
                return Boolean(props._layoutResetTransform);
            },
            /**
             *
             */ pointTo: function(newLead) {
                leadProjection = newLead.projection;
                leadLatestValues = newLead.getLatestValues();
                /**
                 * Subscribe to lead component's layout animations
                 */ unsubscribeFromLeadVisualElement === null || unsubscribeFromLeadVisualElement === void 0 || unsubscribeFromLeadVisualElement();
                unsubscribeFromLeadVisualElement = (0, $6Zyiw.pipe)(newLead.onSetAxisTarget(element.scheduleUpdateLayoutProjection), newLead.onLayoutAnimationComplete(function() {
                    var _a;
                    if (element.isPresent) element.presence = (0, $aRkas.Presence).Present;
                    else (_a = element.layoutSafeToRemove) === null || _a === void 0 || _a.call(element);
                }));
            },
            // TODO: Clean this up
            isPresent: true,
            presence: (0, $aRkas.Presence).Entering
        });
        return element;
    };
};
function $4dec96baa9134630$var$fireResolveRelativeTargetBox(child) {
    child.resolveRelativeTargetBox();
}
function $4dec96baa9134630$var$fireUpdateLayoutProjection(child) {
    child.updateLayoutProjection();
}
var $4dec96baa9134630$var$variantProps = (0, $66bGh.__spreadArray)([
    "initial"
], (0, $66bGh.__read)((0, $f5zA9.variantPriorityOrder)));
var $4dec96baa9134630$var$numVariantProps = $4dec96baa9134630$var$variantProps.length;

});
parcelRegister("lkz4B", function(module, exports) {

$parcel$export(module.exports, "buildLayoutProjectionTransform", function () { return $f876ac096edb3395$export$d842ebfa32edc648; });
$parcel$export(module.exports, "buildLayoutProjectionTransformOrigin", function () { return $f876ac096edb3395$export$9df601cd9cfcf364; });

var $jJzLq = parcelRequire("jJzLq");
/**
 * Build a transform style that takes a calculated delta between the element's current
 * space on screen and projects it into the desired space.
 */ function $f876ac096edb3395$export$d842ebfa32edc648(_a, treeScale, latestTransform) {
    var x = _a.x, y = _a.y;
    /**
     * The translations we use to calculate are always relative to the viewport coordinate space.
     * But when we apply scales, we also scale the coordinate space of an element and its children.
     * For instance if we have a treeScale (the culmination of all parent scales) of 0.5 and we need
     * to move an element 100 pixels, we actually need to move it 200 in within that scaled space.
     */ var xTranslate = x.translate / treeScale.x;
    var yTranslate = y.translate / treeScale.y;
    var transform = "translate3d(" + xTranslate + "px, " + yTranslate + "px, 0) ";
    if (latestTransform) {
        var rotate = latestTransform.rotate, rotateX = latestTransform.rotateX, rotateY = latestTransform.rotateY;
        if (rotate) transform += "rotate(" + rotate + ") ";
        if (rotateX) transform += "rotateX(" + rotateX + ") ";
        if (rotateY) transform += "rotateY(" + rotateY + ") ";
    }
    transform += "scale(" + x.scale + ", " + y.scale + ")";
    return !latestTransform && transform === $f876ac096edb3395$export$f6730f82d2dcfda3 ? "" : transform;
}
/**
 * Take the calculated delta origin and apply it as a transform string.
 */ function $f876ac096edb3395$export$9df601cd9cfcf364(_a) {
    var deltaFinal = _a.deltaFinal;
    return deltaFinal.x.origin * 100 + "% " + deltaFinal.y.origin * 100 + "% 0";
}
var $f876ac096edb3395$export$f6730f82d2dcfda3 = $f876ac096edb3395$export$d842ebfa32edc648((0, $jJzLq.zeroLayout).delta, (0, $jJzLq.zeroLayout).treeScale, {
    x: 1,
    y: 1
});

});
parcelRegister("jJzLq", function(module, exports) {

$parcel$export(module.exports, "createProjectionState", function () { return $e5ddf643b4ce2767$export$3cdcde773d12ad30; });
$parcel$export(module.exports, "createLayoutState", function () { return $e5ddf643b4ce2767$export$e7071b3cce6bc4ce; });
$parcel$export(module.exports, "zeroLayout", function () { return $e5ddf643b4ce2767$export$6ce978c1a0625804; });

var $hJbCe = parcelRequire("hJbCe");
var $e5ddf643b4ce2767$export$3cdcde773d12ad30 = function() {
    return {
        isEnabled: false,
        isHydrated: false,
        isTargetLocked: false,
        target: (0, $hJbCe.axisBox)(),
        targetFinal: (0, $hJbCe.axisBox)()
    };
};
function $e5ddf643b4ce2767$export$e7071b3cce6bc4ce() {
    return {
        isHydrated: false,
        layout: (0, $hJbCe.axisBox)(),
        layoutCorrected: (0, $hJbCe.axisBox)(),
        treeScale: {
            x: 1,
            y: 1
        },
        delta: (0, $hJbCe.delta)(),
        deltaFinal: (0, $hJbCe.delta)(),
        deltaTransform: ""
    };
}
var $e5ddf643b4ce2767$export$6ce978c1a0625804 = $e5ddf643b4ce2767$export$e7071b3cce6bc4ce();

});


parcelRegister("1b19L", function(module, exports) {

$parcel$export(module.exports, "createLifecycles", function () { return $0db7b7331cdd565a$export$f6841af6ea5003ab; });

var $66bGh = parcelRequire("66bGh");

var $Q8xMG = parcelRequire("Q8xMG");
var $0db7b7331cdd565a$var$names = [
    "LayoutMeasure",
    "BeforeLayoutMeasure",
    "LayoutUpdate",
    "ViewportBoxUpdate",
    "Update",
    "Render",
    "AnimationComplete",
    "LayoutAnimationComplete",
    "AnimationStart",
    "SetAxisTarget",
    "Unmount"
];
function $0db7b7331cdd565a$export$f6841af6ea5003ab() {
    var managers = $0db7b7331cdd565a$var$names.map(function() {
        return new (0, $Q8xMG.SubscriptionManager)();
    });
    var propSubscriptions = {};
    var lifecycles = {
        clearAllListeners: function() {
            return managers.forEach(function(manager) {
                return manager.clear();
            });
        },
        updatePropListeners: function(props) {
            return $0db7b7331cdd565a$var$names.forEach(function(name) {
                var _a;
                (_a = propSubscriptions[name]) === null || _a === void 0 || _a.call(propSubscriptions);
                var on = "on" + name;
                var propListener = props[on];
                if (propListener) propSubscriptions[name] = lifecycles[on](propListener);
            });
        }
    };
    managers.forEach(function(manager, i) {
        lifecycles["on" + $0db7b7331cdd565a$var$names[i]] = function(handler) {
            return manager.add(handler);
        };
        lifecycles["notify" + $0db7b7331cdd565a$var$names[i]] = function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return manager.notify.apply(manager, (0, $66bGh.__spreadArray)([], (0, $66bGh.__read)(args)));
        };
    });
    return lifecycles;
}

});

parcelRegister("2PaTK", function(module, exports) {

$parcel$export(module.exports, "updateMotionValuesFromProps", function () { return $20e8cc51e7323d17$export$9a552858d5197f6e; });

var $1XUdZ = parcelRequire("1XUdZ");

var $a3Km2 = parcelRequire("a3Km2");
function $20e8cc51e7323d17$export$9a552858d5197f6e(element, next, prev) {
    var _a;
    for(var key in next){
        var nextValue = next[key];
        var prevValue = prev[key];
        if ((0, $a3Km2.isMotionValue)(nextValue)) /**
             * If this is a motion value found in props or style, we want to add it
             * to our visual element's motion value map.
             */ element.addValue(key, nextValue);
        else if ((0, $a3Km2.isMotionValue)(prevValue)) /**
             * If we're swapping to a new motion value, create a new motion value
             * from that
             */ element.addValue(key, (0, $1XUdZ.motionValue)(nextValue));
        else if (prevValue !== nextValue) {
            /**
             * If this is a flat value that has changed, update the motion value
             * or create one if it doesn't exist. We only want to do this if we're
             * not handling the value with our animation state.
             */ if (element.hasValue(key)) {
                var existingValue = element.getValue(key);
                // TODO: Only update values that aren't being animated or even looked at
                !existingValue.hasAnimated && existingValue.set(nextValue);
            } else element.addValue(key, (0, $1XUdZ.motionValue)((_a = element.getStaticValue(key)) !== null && _a !== void 0 ? _a : nextValue));
        }
    }
    // Handle removed values
    for(var key in prev)if (next[key] === undefined) element.removeValue(key);
    return next;
}

});

parcelRegister("3Ct4H", function(module, exports) {

$parcel$export(module.exports, "updateLayoutDeltas", function () { return $2a2b795c4c69d325$export$1b3a41764b83e037; });

var $7eAOS = parcelRequire("7eAOS");

var $hDYE8 = parcelRequire("hDYE8");
function $2a2b795c4c69d325$export$1b3a41764b83e037(_a, _b, treePath, transformOrigin) {
    var delta = _a.delta, layout = _a.layout, layoutCorrected = _a.layoutCorrected, treeScale = _a.treeScale;
    var target = _b.target;
    /**
     * Reset the corrected box with the latest values from box, as we're then going
     * to perform mutative operations on it.
     */ (0, $7eAOS.resetBox)(layoutCorrected, layout);
    /**
     * Apply all the parent deltas to this box to produce the corrected box. This
     * is the layout box, as it will appear on screen as a result of the transforms of its parents.
     */ (0, $7eAOS.applyTreeDeltas)(layoutCorrected, treeScale, treePath);
    /**
     * Update the delta between the corrected box and the target box before user-set transforms were applied.
     * This will allow us to calculate the corrected borderRadius and boxShadow to compensate
     * for our layout reprojection, but still allow them to be scaled correctly by the user.
     * It might be that to simplify this we may want to accept that user-set scale is also corrected
     * and we wouldn't have to keep and calc both deltas, OR we could support a user setting
     * to allow people to choose whether these styles are corrected based on just the
     * layout reprojection or the final bounding box.
     */ (0, $hDYE8.updateBoxDelta)(delta, layoutCorrected, target, transformOrigin);
}

});

parcelRegister("ip93O", function(module, exports) {

$parcel$export(module.exports, "FlatTree", function () { return $d66196ffdea684f6$export$1465d17e3de78a96; });

var $chivA = parcelRequire("chivA");

var $1TXqq = parcelRequire("1TXqq");
var $d66196ffdea684f6$export$1465d17e3de78a96 = /** @class */ function() {
    function FlatTree() {
        this.children = [];
        this.isDirty = false;
    }
    FlatTree.prototype.add = function(child) {
        (0, $chivA.addUniqueItem)(this.children, child);
        this.isDirty = true;
    };
    FlatTree.prototype.remove = function(child) {
        (0, $chivA.removeItem)(this.children, child);
        this.isDirty = true;
    };
    FlatTree.prototype.forEach = function(callback) {
        this.isDirty && this.children.sort((0, $1TXqq.compareByDepth));
        this.isDirty = false;
        this.children.forEach(callback);
    };
    return FlatTree;
}();

});

parcelRegister("gYzOH", function(module, exports) {

$parcel$export(module.exports, "setCurrentViewportBox", function () { return $c5be086a89388334$export$8a57a029e604f408; });

var $a789I = parcelRequire("a789I");

var $bbVsu = parcelRequire("bbVsu");
function $c5be086a89388334$export$8a57a029e604f408(visualElement) {
    var projectionParent = visualElement.getProjectionParent();
    if (!projectionParent) {
        visualElement.rebaseProjectionTarget();
        return;
    }
    var relativeOffset = (0, $a789I.calcRelativeOffset)(projectionParent.getLayoutState().layout, visualElement.getLayoutState().layout);
    (0, $bbVsu.eachAxis)(function(axis) {
        visualElement.setProjectionTargetAxis(axis, relativeOffset[axis].min, relativeOffset[axis].max, true);
    });
}

});


parcelRegister("3YgUz", function(module, exports) {

$parcel$export(module.exports, "parseDomVariant", function () { return $2e4417f6254b5f97$export$5849e743e29831d6; });

var $dGRG5 = parcelRequire("dGRG5");

var $4TQat = parcelRequire("4TQat");
/**
 * Parse a DOM variant to make it animatable. This involves resolving CSS variables
 * and ensuring animations like "20%" => "calc(50vw)" are performed in pixels.
 */ var $2e4417f6254b5f97$export$5849e743e29831d6 = function(visualElement, target, origin, transitionEnd) {
    var resolved = (0, $dGRG5.resolveCSSVariables)(visualElement, target, transitionEnd);
    target = resolved.target;
    transitionEnd = resolved.transitionEnd;
    return (0, $4TQat.unitConversion)(visualElement, target, origin, transitionEnd);
};

});
parcelRegister("4TQat", function(module, exports) {

$parcel$export(module.exports, "unitConversion", function () { return $3914c3f6525f633f$export$9e04b0cab841a28; });

var $66bGh = parcelRequire("66bGh");

var $5M3DJ = parcelRequire("5M3DJ");
var $4B3zo = parcelRequire("4B3zo");

var $3UqcD = parcelRequire("3UqcD");

var $739Hg = parcelRequire("739Hg");

var $wmU9r = parcelRequire("wmU9r");

var $kjEle = parcelRequire("kjEle");
var $3914c3f6525f633f$var$positionalKeys = new Set([
    "width",
    "height",
    "top",
    "left",
    "right",
    "bottom",
    "x",
    "y"
]);
var $3914c3f6525f633f$var$isPositionalKey = function(key) {
    return $3914c3f6525f633f$var$positionalKeys.has(key);
};
var $3914c3f6525f633f$var$hasPositionalKey = function(target) {
    return Object.keys(target).some($3914c3f6525f633f$var$isPositionalKey);
};
var $3914c3f6525f633f$var$setAndResetVelocity = function(value, to) {
    // Looks odd but setting it twice doesn't render, it'll just
    // set both prev and current to the latest value
    value.set(to, false);
    value.set(to);
};
var $3914c3f6525f633f$var$isNumOrPxType = function(v) {
    return v === (0, $5M3DJ.number) || v === (0, $4B3zo.px);
};
var $3914c3f6525f633f$export$d0c75e4fa9e69db8;
(function(BoundingBoxDimension) {
    BoundingBoxDimension["width"] = "width";
    BoundingBoxDimension["height"] = "height";
    BoundingBoxDimension["left"] = "left";
    BoundingBoxDimension["right"] = "right";
    BoundingBoxDimension["top"] = "top";
    BoundingBoxDimension["bottom"] = "bottom";
})($3914c3f6525f633f$export$d0c75e4fa9e69db8 || ($3914c3f6525f633f$export$d0c75e4fa9e69db8 = {}));
var $3914c3f6525f633f$var$getPosFromMatrix = function(matrix, pos) {
    return parseFloat(matrix.split(", ")[pos]);
};
var $3914c3f6525f633f$var$getTranslateFromMatrix = function(pos2, pos3) {
    return function(_bbox, _a) {
        var transform = _a.transform;
        if (transform === "none" || !transform) return 0;
        var matrix3d = transform.match(/^matrix3d\((.+)\)$/);
        if (matrix3d) return $3914c3f6525f633f$var$getPosFromMatrix(matrix3d[1], pos3);
        else {
            var matrix = transform.match(/^matrix\((.+)\)$/);
            if (matrix) return $3914c3f6525f633f$var$getPosFromMatrix(matrix[1], pos2);
            else return 0;
        }
    };
};
var $3914c3f6525f633f$var$transformKeys = new Set([
    "x",
    "y",
    "z"
]);
var $3914c3f6525f633f$var$nonTranslationalTransformKeys = (0, $wmU9r.transformProps).filter(function(key) {
    return !$3914c3f6525f633f$var$transformKeys.has(key);
});
function $3914c3f6525f633f$var$removeNonTranslationalTransform(visualElement) {
    var removedTransforms = [];
    $3914c3f6525f633f$var$nonTranslationalTransformKeys.forEach(function(key) {
        var value = visualElement.getValue(key);
        if (value !== undefined) {
            removedTransforms.push([
                key,
                value.get()
            ]);
            value.set(key.startsWith("scale") ? 1 : 0);
        }
    });
    // Apply changes to element before measurement
    if (removedTransforms.length) visualElement.syncRender();
    return removedTransforms;
}
var $3914c3f6525f633f$var$positionalValues = {
    // Dimensions
    width: function(_a) {
        var x = _a.x;
        return x.max - x.min;
    },
    height: function(_a) {
        var y = _a.y;
        return y.max - y.min;
    },
    top: function(_bbox, _a) {
        var top = _a.top;
        return parseFloat(top);
    },
    left: function(_bbox, _a) {
        var left = _a.left;
        return parseFloat(left);
    },
    bottom: function(_a, _b) {
        var y = _a.y;
        var top = _b.top;
        return parseFloat(top) + (y.max - y.min);
    },
    right: function(_a, _b) {
        var x = _a.x;
        var left = _b.left;
        return parseFloat(left) + (x.max - x.min);
    },
    // Transform
    x: $3914c3f6525f633f$var$getTranslateFromMatrix(4, 13),
    y: $3914c3f6525f633f$var$getTranslateFromMatrix(5, 14)
};
var $3914c3f6525f633f$var$convertChangedValueTypes = function(target, visualElement, changedKeys) {
    var originBbox = visualElement.measureViewportBox();
    var element = visualElement.getInstance();
    var elementComputedStyle = getComputedStyle(element);
    var display = elementComputedStyle.display, top = elementComputedStyle.top, left = elementComputedStyle.left, bottom = elementComputedStyle.bottom, right = elementComputedStyle.right, transform = elementComputedStyle.transform;
    var originComputedStyle = {
        top: top,
        left: left,
        bottom: bottom,
        right: right,
        transform: transform
    };
    // If the element is currently set to display: "none", make it visible before
    // measuring the target bounding box
    if (display === "none") visualElement.setStaticValue("display", target.display || "block");
    // Apply the latest values (as set in checkAndConvertChangedValueTypes)
    visualElement.syncRender();
    var targetBbox = visualElement.measureViewportBox();
    changedKeys.forEach(function(key) {
        // Restore styles to their **calculated computed style**, not their actual
        // originally set style. This allows us to animate between equivalent pixel units.
        var value = visualElement.getValue(key);
        $3914c3f6525f633f$var$setAndResetVelocity(value, $3914c3f6525f633f$var$positionalValues[key](originBbox, originComputedStyle));
        target[key] = $3914c3f6525f633f$var$positionalValues[key](targetBbox, elementComputedStyle);
    });
    return target;
};
var $3914c3f6525f633f$var$checkAndConvertChangedValueTypes = function(visualElement, target, origin, transitionEnd) {
    if (origin === void 0) origin = {};
    if (transitionEnd === void 0) transitionEnd = {};
    target = (0, $66bGh.__assign)({}, target);
    transitionEnd = (0, $66bGh.__assign)({}, transitionEnd);
    var targetPositionalKeys = Object.keys(target).filter($3914c3f6525f633f$var$isPositionalKey);
    // We want to remove any transform values that could affect the element's bounding box before
    // it's measured. We'll reapply these later.
    var removedTransformValues = [];
    var hasAttemptedToRemoveTransformValues = false;
    var changedValueTypeKeys = [];
    targetPositionalKeys.forEach(function(key) {
        var value = visualElement.getValue(key);
        if (!visualElement.hasValue(key)) return;
        var from = origin[key];
        var to = target[key];
        var fromType = (0, $kjEle.findDimensionValueType)(from);
        var toType;
        // TODO: The current implementation of this basically throws an error
        // if you try and do value conversion via keyframes. There's probably
        // a way of doing this but the performance implications would need greater scrutiny,
        // as it'd be doing multiple resize-remeasure operations.
        if ((0, $3UqcD.isKeyframesTarget)(to)) {
            var numKeyframes = to.length;
            for(var i = to[0] === null ? 1 : 0; i < numKeyframes; i++)if (!toType) {
                toType = (0, $kjEle.findDimensionValueType)(to[i]);
                (0, $739Hg.invariant)(toType === fromType || $3914c3f6525f633f$var$isNumOrPxType(fromType) && $3914c3f6525f633f$var$isNumOrPxType(toType), "Keyframes must be of the same dimension as the current value");
            } else (0, $739Hg.invariant)((0, $kjEle.findDimensionValueType)(to[i]) === toType, "All keyframes must be of the same type");
        } else toType = (0, $kjEle.findDimensionValueType)(to);
        if (fromType !== toType) {
            // If they're both just number or px, convert them both to numbers rather than
            // relying on resize/remeasure to convert (which is wasteful in this situation)
            if ($3914c3f6525f633f$var$isNumOrPxType(fromType) && $3914c3f6525f633f$var$isNumOrPxType(toType)) {
                var current = value.get();
                if (typeof current === "string") value.set(parseFloat(current));
                if (typeof to === "string") target[key] = parseFloat(to);
                else if (Array.isArray(to) && toType === (0, $4B3zo.px)) target[key] = to.map(parseFloat);
            } else if ((fromType === null || fromType === void 0 ? void 0 : fromType.transform) && (toType === null || toType === void 0 ? void 0 : toType.transform) && (from === 0 || to === 0)) {
                // If one or the other value is 0, it's safe to coerce it to the
                // type of the other without measurement
                if (from === 0) value.set(toType.transform(from));
                else target[key] = fromType.transform(to);
            } else {
                // If we're going to do value conversion via DOM measurements, we first
                // need to remove non-positional transform values that could affect the bbox measurements.
                if (!hasAttemptedToRemoveTransformValues) {
                    removedTransformValues = $3914c3f6525f633f$var$removeNonTranslationalTransform(visualElement);
                    hasAttemptedToRemoveTransformValues = true;
                }
                changedValueTypeKeys.push(key);
                transitionEnd[key] = transitionEnd[key] !== undefined ? transitionEnd[key] : target[key];
                $3914c3f6525f633f$var$setAndResetVelocity(value, to);
            }
        }
    });
    if (changedValueTypeKeys.length) {
        var convertedTarget = $3914c3f6525f633f$var$convertChangedValueTypes(target, visualElement, changedValueTypeKeys);
        // If we removed transform values, reapply them before the next render
        if (removedTransformValues.length) removedTransformValues.forEach(function(_a) {
            var _b = (0, $66bGh.__read)(_a, 2), key = _b[0], value = _b[1];
            visualElement.getValue(key).set(value);
        });
        // Reapply original values
        visualElement.syncRender();
        return {
            target: convertedTarget,
            transitionEnd: transitionEnd
        };
    } else return {
        target: target,
        transitionEnd: transitionEnd
    };
};
/**
 * Convert value types for x/y/width/height/top/left/bottom/right
 *
 * Allows animation between `'auto'` -> `'100%'` or `0` -> `'calc(50% - 10vw)'`
 *
 * @internal
 */ function $3914c3f6525f633f$export$9e04b0cab841a28(visualElement, target, origin, transitionEnd) {
    return $3914c3f6525f633f$var$hasPositionalKey(target) ? $3914c3f6525f633f$var$checkAndConvertChangedValueTypes(visualElement, target, origin, transitionEnd) : {
        target: target,
        transitionEnd: transitionEnd
    };
}

});



parcelRegister("b5EBL", function(module, exports) {

$parcel$export(module.exports, "svgVisualElement", function () { return $812fa9458a793eed$export$3ba8992de7b705bc; });

var $66bGh = parcelRequire("66bGh");

var $6GMTc = parcelRequire("6GMTc");

var $fuGiI = parcelRequire("fuGiI");

var $dvVt2 = parcelRequire("dvVt2");

var $cFfTK = parcelRequire("cFfTK");

var $9Heev = parcelRequire("9Heev");

var $jt6P8 = parcelRequire("jt6P8");

var $wmU9r = parcelRequire("wmU9r");

var $2XBJX = parcelRequire("2XBJX");

var $2fWSs = parcelRequire("2fWSs");

var $lkz4B = parcelRequire("lkz4B");
var $812fa9458a793eed$export$3ba8992de7b705bc = (0, $6GMTc.visualElement)((0, $66bGh.__assign)((0, $66bGh.__assign)({}, (0, $dvVt2.htmlConfig)), {
    getBaseTarget: function(props, key) {
        return props[key];
    },
    readValueFromInstance: function(domElement, key) {
        var _a;
        if ((0, $wmU9r.isTransformProp)(key)) return ((_a = (0, $2fWSs.getDefaultValueType)(key)) === null || _a === void 0 ? void 0 : _a.default) || 0;
        key = !(0, $jt6P8.camelCaseAttributes).has(key) ? (0, $9Heev.camelToDash)(key) : key;
        return domElement.getAttribute(key);
    },
    scrapeMotionValuesFromProps: (0, $fuGiI.scrapeMotionValuesFromProps),
    build: function(_element, renderState, latestValues, projection, layoutState, options, props) {
        var isProjectionTranform = projection.isEnabled && layoutState.isHydrated;
        (0, $cFfTK.buildSVGAttrs)(renderState, latestValues, projection, layoutState, options, props.transformTemplate, isProjectionTranform ? (0, $lkz4B.buildLayoutProjectionTransform) : undefined, isProjectionTranform ? (0, $lkz4B.buildLayoutProjectionTransformOrigin) : undefined);
    },
    render: (0, $2XBJX.renderSVG)
}));

});



parcelRegister("7bLnp", function(module, exports) {
"use strict";
var $53be4f7dc30b35f8$var$__assign = module.exports && module.exports.__assign || function() {
    $53be4f7dc30b35f8$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $53be4f7dc30b35f8$var$__assign.apply(this, arguments);
};
var $53be4f7dc30b35f8$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.StyledButtonWrapper = module.exports.StyledIconButton = module.exports.StyledIndicatorIconButton = module.exports.StyledFiberManualRecordIcon = module.exports.StyledIndicators = module.exports.StyledItemWrapper = module.exports.StyledItem = module.exports.StyledRoot = void 0;

var $53be4f7dc30b35f8$var$FiberManualRecord_1 = $53be4f7dc30b35f8$var$__importDefault((parcelRequire("7x57I")));

var $17CRd = parcelRequire("17CRd");
var $HGmne = parcelRequire("HGmne");
module.exports.StyledRoot = (0, $HGmne.default)("div")({
    position: "relative",
    overflow: "hidden"
});
module.exports.StyledItem = (0, $HGmne.default)("div")({
    position: "absolute",
    height: "100%",
    width: '100%'
});
module.exports.StyledItemWrapper = (0, $HGmne.default)("div")({
    position: 'relative',
    width: '100%',
    height: '100%'
});
module.exports.StyledIndicators = (0, $HGmne.default)("div")({
    width: "100%",
    marginTop: "10px",
    textAlign: "center"
});
module.exports.StyledFiberManualRecordIcon = (0, $HGmne.default)($53be4f7dc30b35f8$var$FiberManualRecord_1.default)({
    fontSize: "15px"
});
module.exports.StyledIndicatorIconButton = (0, $HGmne.default)($17CRd.default, {
    shouldForwardProp: function(propName) {
        return !propName.startsWith('$');
    }
})(function(_a) {
    var $active = _a.$active;
    return {
        cursor: "pointer",
        transition: "200ms",
        padding: 0,
        color: $active ? "#494949" : "#afafaf",
        '&:hover': {
            color: $active ? "#494949" : "#1f1f1f"
        },
        '&:active': {
            color: $active ? "#494949" : "#1f1f1f"
        }
    };
});
module.exports.StyledIconButton = (0, $HGmne.default)($17CRd.default, {
    shouldForwardProp: function(propName) {
        return !propName.startsWith('$');
    }
})(function(_a) {
    var $alwaysVisible = _a.$alwaysVisible;
    return {
        margin: "0 10px",
        position: "relative",
        backgroundColor: "#494949",
        top: "calc(50% - 20px) !important",
        color: "white",
        fontSize: "30px",
        transition: "200ms",
        cursor: "pointer",
        opacity: $alwaysVisible ? '1' : '0',
        '&:hover': {
            opacity: "0.6 !important"
        }
    };
});
module.exports.StyledButtonWrapper = (0, $HGmne.default)("div", {
    shouldForwardProp: function(propName) {
        return !propName.startsWith('$');
    }
})(function(_a) {
    var $next = _a.$next, $prev = _a.$prev, $fullHeightHover = _a.$fullHeightHover;
    return $53be4f7dc30b35f8$var$__assign($53be4f7dc30b35f8$var$__assign($53be4f7dc30b35f8$var$__assign({
        position: "absolute",
        height: "100px",
        backgroundColor: "transparent",
        zIndex: 1,
        top: "calc(50% - 70px)",
        '&:hover': {
            '& button': {
                backgroundColor: "black",
                filter: "brightness(120%)",
                opacity: "0.4"
            }
        }
    }, $fullHeightHover ? {
        height: "100%",
        top: "0"
    } : undefined), $next ? {
        right: 0
    } : undefined), $prev ? {
        left: 0
    } : undefined);
});

});
parcelRegister("7x57I", function(module, exports) {
"use strict";
"use client";

var $hrFuR = parcelRequire("hrFuR");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $57bf96e7a32c4a10$var$_createSvgIcon = $hrFuR((parcelRequire("lXMfO")));

var $9wx12 = parcelRequire("9wx12");
var $57bf96e7a32c4a10$var$_default = module.exports.default = (0, $57bf96e7a32c4a10$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $9wx12.jsx)("circle", {
    cx: "12",
    cy: "12",
    r: "8"
}), 'FiberManualRecord');

});

parcelRegister("17CRd", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0d1496289fc9e0e6$export$2e2bcd8739ae039; });

var $cTAWX = parcelRequire("cTAWX");

var $3VnFq = parcelRequire("3VnFq");

var $gJYWc = parcelRequire("gJYWc");


var $2w6IV = parcelRequire("2w6IV");


var $3e4LV = parcelRequire("3e4LV");

var $fwsmC = parcelRequire("fwsmC");

var $HGmne = parcelRequire("HGmne");

var $8pLcn = parcelRequire("8pLcn");

var $fNSZE = parcelRequire("fNSZE");

var $cVrVk = parcelRequire("cVrVk");

var $1uF8F = parcelRequire("1uF8F");

var $9wx12 = parcelRequire("9wx12");
'use client';
const $0d1496289fc9e0e6$var$_excluded = [
    "edge",
    "children",
    "className",
    "color",
    "disabled",
    "disableFocusRipple",
    "size"
];
const $0d1496289fc9e0e6$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disabled: disabled, color: color, edge: edge, size: size } = ownerState;
    const slots = {
        root: [
            'root',
            disabled && 'disabled',
            color !== 'default' && `color${(0, $cVrVk.default)(color)}`,
            edge && `edge${(0, $cVrVk.default)(edge)}`,
            `size${(0, $cVrVk.default)(size)}`
        ]
    };
    return (0, $3e4LV.default)(slots, (0, $1uF8F.getIconButtonUtilityClass), classes);
};
const $0d1496289fc9e0e6$var$IconButtonRoot = (0, $HGmne.default)((0, $fNSZE.default), {
    name: 'MuiIconButton',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.color !== 'default' && styles[`color${(0, $cVrVk.default)(ownerState.color)}`],
            ownerState.edge && styles[`edge${(0, $cVrVk.default)(ownerState.edge)}`],
            styles[`size${(0, $cVrVk.default)(ownerState.size)}`]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $3VnFq.default)({
        textAlign: 'center',
        flex: '0 0 auto',
        fontSize: theme.typography.pxToRem(24),
        padding: 8,
        borderRadius: '50%',
        overflow: 'visible',
        // Explicitly set the default value to solve a bug on IE11.
        color: (theme.vars || theme).palette.action.active,
        transition: theme.transitions.create('background-color', {
            duration: theme.transitions.duration.shortest
        })
    }, !ownerState.disableRipple && {
        '&:hover': {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.action.activeChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $fwsmC.alpha)(theme.palette.action.active, theme.palette.action.hoverOpacity),
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                backgroundColor: 'transparent'
            }
        }
    }, ownerState.edge === 'start' && {
        marginLeft: ownerState.size === 'small' ? -3 : -12
    }, ownerState.edge === 'end' && {
        marginRight: ownerState.size === 'small' ? -3 : -12
    }), ({ theme: theme, ownerState: ownerState })=>{
    var _palette;
    const palette = (_palette = (theme.vars || theme).palette) == null ? void 0 : _palette[ownerState.color];
    return (0, $3VnFq.default)({}, ownerState.color === 'inherit' && {
        color: 'inherit'
    }, ownerState.color !== 'inherit' && ownerState.color !== 'default' && (0, $3VnFq.default)({
        color: palette == null ? void 0 : palette.main
    }, !ownerState.disableRipple && {
        '&:hover': (0, $3VnFq.default)({}, palette && {
            backgroundColor: theme.vars ? `rgba(${palette.mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $fwsmC.alpha)(palette.main, theme.palette.action.hoverOpacity)
        }, {
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                backgroundColor: 'transparent'
            }
        })
    }), ownerState.size === 'small' && {
        padding: 5,
        fontSize: theme.typography.pxToRem(18)
    }, ownerState.size === 'large' && {
        padding: 12,
        fontSize: theme.typography.pxToRem(28)
    }, {
        [`&.${(0, $1uF8F.default).disabled}`]: {
            backgroundColor: 'transparent',
            color: (theme.vars || theme).palette.action.disabled
        }
    });
});
/**
 * Refer to the [Icons](/material-ui/icons/) section of the documentation
 * regarding the available icon options.
 */ const $0d1496289fc9e0e6$var$IconButton = /*#__PURE__*/ $gJYWc.forwardRef(function IconButton(inProps, ref) {
    const props = (0, $8pLcn.useDefaultProps)({
        props: inProps,
        name: 'MuiIconButton'
    });
    const { edge: edge = false, children: children, className: className, color: color = 'default', disabled: disabled = false, disableFocusRipple: disableFocusRipple = false, size: size = 'medium' } = props, other = (0, $cTAWX.default)(props, $0d1496289fc9e0e6$var$_excluded);
    const ownerState = (0, $3VnFq.default)({}, props, {
        edge: edge,
        color: color,
        disabled: disabled,
        disableFocusRipple: disableFocusRipple,
        size: size
    });
    const classes = $0d1496289fc9e0e6$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $9wx12.jsx)($0d1496289fc9e0e6$var$IconButtonRoot, (0, $3VnFq.default)({
        className: (0, $2w6IV.default)(classes.root, className),
        centerRipple: true,
        focusRipple: !disableFocusRipple,
        disabled: disabled,
        ref: ref
    }, other, {
        ownerState: ownerState,
        children: children
    }));
});
var $0d1496289fc9e0e6$export$2e2bcd8739ae039 = $0d1496289fc9e0e6$var$IconButton;

});
parcelRegister("fNSZE", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b816172d31107ee5$export$2e2bcd8739ae039; });

var $3VnFq = parcelRequire("3VnFq");

var $cTAWX = parcelRequire("cTAWX");

var $gJYWc = parcelRequire("gJYWc");


var $2w6IV = parcelRequire("2w6IV");



var $3e4LV = parcelRequire("3e4LV");

var $HGmne = parcelRequire("HGmne");

var $8pLcn = parcelRequire("8pLcn");

var $il32z = parcelRequire("il32z");

var $3r59w = parcelRequire("3r59w");

var $gbQLW = parcelRequire("gbQLW");

var $f89qk = parcelRequire("f89qk");

var $jZED7 = parcelRequire("jZED7");

var $9wx12 = parcelRequire("9wx12");
'use client';
const $b816172d31107ee5$var$_excluded = [
    "action",
    "centerRipple",
    "children",
    "className",
    "component",
    "disabled",
    "disableRipple",
    "disableTouchRipple",
    "focusRipple",
    "focusVisibleClassName",
    "LinkComponent",
    "onBlur",
    "onClick",
    "onContextMenu",
    "onDragLeave",
    "onFocus",
    "onFocusVisible",
    "onKeyDown",
    "onKeyUp",
    "onMouseDown",
    "onMouseLeave",
    "onMouseUp",
    "onTouchEnd",
    "onTouchMove",
    "onTouchStart",
    "tabIndex",
    "TouchRippleProps",
    "touchRippleRef",
    "type"
];
const $b816172d31107ee5$var$useUtilityClasses = (ownerState)=>{
    const { disabled: disabled, focusVisible: focusVisible, focusVisibleClassName: focusVisibleClassName, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            disabled && 'disabled',
            focusVisible && 'focusVisible'
        ]
    };
    const composedClasses = (0, $3e4LV.default)(slots, (0, $jZED7.getButtonBaseUtilityClass), classes);
    if (focusVisible && focusVisibleClassName) composedClasses.root += ` ${focusVisibleClassName}`;
    return composedClasses;
};
const $b816172d31107ee5$export$7ec0dcc5e3cdcd36 = (0, $HGmne.default)('button', {
    name: 'MuiButtonBase',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})({
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'relative',
    boxSizing: 'border-box',
    WebkitTapHighlightColor: 'transparent',
    backgroundColor: 'transparent',
    // Reset default value
    // We disable the focus ring for mouse, touch and keyboard users.
    outline: 0,
    border: 0,
    margin: 0,
    // Remove the margin in Safari
    borderRadius: 0,
    padding: 0,
    // Remove the padding in Firefox
    cursor: 'pointer',
    userSelect: 'none',
    verticalAlign: 'middle',
    MozAppearance: 'none',
    // Reset
    WebkitAppearance: 'none',
    // Reset
    textDecoration: 'none',
    // So we take precedent over the style of a native <a /> element.
    color: 'inherit',
    '&::-moz-focus-inner': {
        borderStyle: 'none' // Remove Firefox dotted outline.
    },
    [`&.${(0, $jZED7.default).disabled}`]: {
        pointerEvents: 'none',
        // Disable link interactions
        cursor: 'default'
    },
    '@media print': {
        colorAdjust: 'exact'
    }
});
/**
 * `ButtonBase` contains as few styles as possible.
 * It aims to be a simple building block for creating a button.
 * It contains a load of style reset and some focus/ripple logic.
 */ const $b816172d31107ee5$var$ButtonBase = /*#__PURE__*/ $gJYWc.forwardRef(function ButtonBase(inProps, ref) {
    const props = (0, $8pLcn.useDefaultProps)({
        props: inProps,
        name: 'MuiButtonBase'
    });
    const { action: action, centerRipple: centerRipple = false, children: children, className: className, component: component = 'button', disabled: disabled = false, disableRipple: disableRipple = false, disableTouchRipple: disableTouchRipple = false, focusRipple: focusRipple = false, LinkComponent: LinkComponent = 'a', onBlur: onBlur, onClick: onClick, onContextMenu: onContextMenu, onDragLeave: onDragLeave, onFocus: onFocus, onFocusVisible: onFocusVisible, onKeyDown: onKeyDown, onKeyUp: onKeyUp, onMouseDown: onMouseDown, onMouseLeave: onMouseLeave, onMouseUp: onMouseUp, onTouchEnd: onTouchEnd, onTouchMove: onTouchMove, onTouchStart: onTouchStart, tabIndex: tabIndex = 0, TouchRippleProps: TouchRippleProps, touchRippleRef: touchRippleRef, type: type } = props, other = (0, $cTAWX.default)(props, $b816172d31107ee5$var$_excluded);
    const buttonRef = $gJYWc.useRef(null);
    const rippleRef = $gJYWc.useRef(null);
    const handleRippleRef = (0, $il32z.default)(rippleRef, touchRippleRef);
    const { isFocusVisibleRef: isFocusVisibleRef, onFocus: handleFocusVisible, onBlur: handleBlurVisible, ref: focusVisibleRef } = (0, $gbQLW.default)();
    const [focusVisible, setFocusVisible] = $gJYWc.useState(false);
    if (disabled && focusVisible) setFocusVisible(false);
    $gJYWc.useImperativeHandle(action, ()=>({
            focusVisible: ()=>{
                setFocusVisible(true);
                buttonRef.current.focus();
            }
        }), []);
    const [mountedState, setMountedState] = $gJYWc.useState(false);
    $gJYWc.useEffect(()=>{
        setMountedState(true);
    }, []);
    const enableTouchRipple = mountedState && !disableRipple && !disabled;
    $gJYWc.useEffect(()=>{
        if (focusVisible && focusRipple && !disableRipple && mountedState) rippleRef.current.pulsate();
    }, [
        disableRipple,
        focusRipple,
        focusVisible,
        mountedState
    ]);
    function useRippleHandler(rippleAction, eventCallback, skipRippleAction = disableTouchRipple) {
        return (0, $3r59w.default)((event)=>{
            if (eventCallback) eventCallback(event);
            const ignore = skipRippleAction;
            if (!ignore && rippleRef.current) rippleRef.current[rippleAction](event);
            return true;
        });
    }
    const handleMouseDown = useRippleHandler('start', onMouseDown);
    const handleContextMenu = useRippleHandler('stop', onContextMenu);
    const handleDragLeave = useRippleHandler('stop', onDragLeave);
    const handleMouseUp = useRippleHandler('stop', onMouseUp);
    const handleMouseLeave = useRippleHandler('stop', (event)=>{
        if (focusVisible) event.preventDefault();
        if (onMouseLeave) onMouseLeave(event);
    });
    const handleTouchStart = useRippleHandler('start', onTouchStart);
    const handleTouchEnd = useRippleHandler('stop', onTouchEnd);
    const handleTouchMove = useRippleHandler('stop', onTouchMove);
    const handleBlur = useRippleHandler('stop', (event)=>{
        handleBlurVisible(event);
        if (isFocusVisibleRef.current === false) setFocusVisible(false);
        if (onBlur) onBlur(event);
    }, false);
    const handleFocus = (0, $3r59w.default)((event)=>{
        // Fix for https://github.com/facebook/react/issues/7769
        if (!buttonRef.current) buttonRef.current = event.currentTarget;
        handleFocusVisible(event);
        if (isFocusVisibleRef.current === true) {
            setFocusVisible(true);
            if (onFocusVisible) onFocusVisible(event);
        }
        if (onFocus) onFocus(event);
    });
    const isNonNativeButton = ()=>{
        const button = buttonRef.current;
        return component && component !== 'button' && !(button.tagName === 'A' && button.href);
    };
    /**
   * IE11 shim for https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/repeat
   */ const keydownRef = $gJYWc.useRef(false);
    const handleKeyDown = (0, $3r59w.default)((event)=>{
        // Check if key is already down to avoid repeats being counted as multiple activations
        if (focusRipple && !keydownRef.current && focusVisible && rippleRef.current && event.key === ' ') {
            keydownRef.current = true;
            rippleRef.current.stop(event, ()=>{
                rippleRef.current.start(event);
            });
        }
        if (event.target === event.currentTarget && isNonNativeButton() && event.key === ' ') event.preventDefault();
        if (onKeyDown) onKeyDown(event);
        // Keyboard accessibility for non interactive elements
        if (event.target === event.currentTarget && isNonNativeButton() && event.key === 'Enter' && !disabled) {
            event.preventDefault();
            if (onClick) onClick(event);
        }
    });
    const handleKeyUp = (0, $3r59w.default)((event)=>{
        // calling preventDefault in keyUp on a <button> will not dispatch a click event if Space is pressed
        // https://codesandbox.io/p/sandbox/button-keyup-preventdefault-dn7f0
        if (focusRipple && event.key === ' ' && rippleRef.current && focusVisible && !event.defaultPrevented) {
            keydownRef.current = false;
            rippleRef.current.stop(event, ()=>{
                rippleRef.current.pulsate(event);
            });
        }
        if (onKeyUp) onKeyUp(event);
        // Keyboard accessibility for non interactive elements
        if (onClick && event.target === event.currentTarget && isNonNativeButton() && event.key === ' ' && !event.defaultPrevented) onClick(event);
    });
    let ComponentProp = component;
    if (ComponentProp === 'button' && (other.href || other.to)) ComponentProp = LinkComponent;
    const buttonProps = {};
    if (ComponentProp === 'button') {
        buttonProps.type = type === undefined ? 'button' : type;
        buttonProps.disabled = disabled;
    } else {
        if (!other.href && !other.to) buttonProps.role = 'button';
        if (disabled) buttonProps['aria-disabled'] = disabled;
    }
    const handleRef = (0, $il32z.default)(ref, focusVisibleRef, buttonRef);
    const ownerState = (0, $3VnFq.default)({}, props, {
        centerRipple: centerRipple,
        component: component,
        disabled: disabled,
        disableRipple: disableRipple,
        disableTouchRipple: disableTouchRipple,
        focusRipple: focusRipple,
        tabIndex: tabIndex,
        focusVisible: focusVisible
    });
    const classes = $b816172d31107ee5$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $9wx12.jsxs)($b816172d31107ee5$export$7ec0dcc5e3cdcd36, (0, $3VnFq.default)({
        as: ComponentProp,
        className: (0, $2w6IV.default)(classes.root, className),
        ownerState: ownerState,
        onBlur: handleBlur,
        onClick: onClick,
        onContextMenu: handleContextMenu,
        onFocus: handleFocus,
        onKeyDown: handleKeyDown,
        onKeyUp: handleKeyUp,
        onMouseDown: handleMouseDown,
        onMouseLeave: handleMouseLeave,
        onMouseUp: handleMouseUp,
        onDragLeave: handleDragLeave,
        onTouchEnd: handleTouchEnd,
        onTouchMove: handleTouchMove,
        onTouchStart: handleTouchStart,
        ref: handleRef,
        tabIndex: disabled ? -1 : tabIndex,
        type: type
    }, buttonProps, other, {
        children: [
            children,
            enableTouchRipple ? /*#__PURE__*/ /* TouchRipple is only needed client-side, x2 boost on the server. */ (0, $9wx12.jsx)((0, $f89qk.default), (0, $3VnFq.default)({
                ref: handleRippleRef,
                center: centerRipple
            }, TouchRippleProps)) : null
        ]
    }));
});
var $b816172d31107ee5$export$2e2bcd8739ae039 = $b816172d31107ee5$var$ButtonBase;

});
parcelRegister("il32z", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d59c8bf27b532874$export$2e2bcd8739ae039; });

var $4gWBK = parcelRequire("4gWBK");
'use client';
var $d59c8bf27b532874$export$2e2bcd8739ae039 = (0, $4gWBK.default);

});
parcelRegister("4gWBK", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $31c61e5706889529$export$2e2bcd8739ae039; });

var $gJYWc = parcelRequire("gJYWc");

var $anPBZ = parcelRequire("anPBZ");
'use client';
function $31c61e5706889529$export$2e2bcd8739ae039(...refs) {
    /**
   * This will create a new function if the refs passed to this hook change and are all defined.
   * This means react will call the old forkRef with `null` and the new forkRef
   * with the ref. Cleanup naturally emerges from this behavior.
   */ return $gJYWc.useMemo(()=>{
        if (refs.every((ref)=>ref == null)) return null;
        return (instance)=>{
            refs.forEach((ref)=>{
                (0, $anPBZ.default)(ref, instance);
            });
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, refs);
}

});
parcelRegister("anPBZ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $78f41662fb086edb$export$2e2bcd8739ae039; });
/**
 * TODO v5: consider making it private
 *
 * passes {value} to {ref}
 *
 * WARNING: Be sure to only call this inside a callback that is passed as a ref.
 * Otherwise, make sure to cleanup the previous {ref} if it changes. See
 * https://github.com/mui/material-ui/issues/13539
 *
 * Useful if you want to expose the ref of an inner component to the public API
 * while still using it inside the component.
 * @param ref A ref callback or ref object. If anything falsy, this is a no-op.
 */ function $78f41662fb086edb$export$2e2bcd8739ae039(ref, value) {
    if (typeof ref === 'function') ref(value);
    else if (ref) ref.current = value;
}

});



parcelRegister("3r59w", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2807e3e60cf7d3d6$export$2e2bcd8739ae039; });

var $92UcI = parcelRequire("92UcI");
'use client';
var $2807e3e60cf7d3d6$export$2e2bcd8739ae039 = (0, $92UcI.default);

});
parcelRegister("92UcI", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $695fe5ed7bd2e748$export$2e2bcd8739ae039; });

var $gJYWc = parcelRequire("gJYWc");

var $4z2O6 = parcelRequire("4z2O6");
'use client';
/**
 * Inspired by https://github.com/facebook/react/issues/14099#issuecomment-440013892
 * See RFC in https://github.com/reactjs/rfcs/pull/220
 */ function $695fe5ed7bd2e748$var$useEventCallback(fn) {
    const ref = $gJYWc.useRef(fn);
    (0, $4z2O6.default)(()=>{
        ref.current = fn;
    });
    return $gJYWc.useRef((...args)=>// @ts-expect-error hide `this`
        (0, ref.current)(...args)).current;
}
var $695fe5ed7bd2e748$export$2e2bcd8739ae039 = $695fe5ed7bd2e748$var$useEventCallback;

});
parcelRegister("4z2O6", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $352c9bbd89ef8d24$export$2e2bcd8739ae039; });

var $gJYWc = parcelRequire("gJYWc");
'use client';
/**
 * A version of `React.useLayoutEffect` that does not show a warning when server-side rendering.
 * This is useful for effects that are only needed for client-side rendering but not for SSR.
 *
 * Before you use this hook, make sure to read https://gist.github.com/gaearon/e7d97cdf38a2907924ea12e4ebdf3c85
 * and confirm it doesn't apply to your use-case.
 */ const $352c9bbd89ef8d24$var$useEnhancedEffect = typeof window !== 'undefined' ? $gJYWc.useLayoutEffect : $gJYWc.useEffect;
var $352c9bbd89ef8d24$export$2e2bcd8739ae039 = $352c9bbd89ef8d24$var$useEnhancedEffect;

});



parcelRegister("gbQLW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bc969bea2e93c2b1$export$2e2bcd8739ae039; });

var $4mujG = parcelRequire("4mujG");
'use client';
var $bc969bea2e93c2b1$export$2e2bcd8739ae039 = (0, $4mujG.default);

});
parcelRegister("4mujG", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $32d0bbb37645f3a6$export$2e2bcd8739ae039; });

var $gJYWc = parcelRequire("gJYWc");

var $4LiUz = parcelRequire("4LiUz");
'use client';
let $32d0bbb37645f3a6$var$hadKeyboardEvent = true;
let $32d0bbb37645f3a6$var$hadFocusVisibleRecently = false;
const $32d0bbb37645f3a6$var$hadFocusVisibleRecentlyTimeout = new (0, $4LiUz.Timeout)();
const $32d0bbb37645f3a6$var$inputTypesWhitelist = {
    text: true,
    search: true,
    url: true,
    tel: true,
    email: true,
    password: true,
    number: true,
    date: true,
    month: true,
    week: true,
    time: true,
    datetime: true,
    'datetime-local': true
};
/**
 * Computes whether the given element should automatically trigger the
 * `focus-visible` class being added, i.e. whether it should always match
 * `:focus-visible` when focused.
 * @param {Element} node
 * @returns {boolean}
 */ function $32d0bbb37645f3a6$var$focusTriggersKeyboardModality(node) {
    const { type: type, tagName: tagName } = node;
    if (tagName === 'INPUT' && $32d0bbb37645f3a6$var$inputTypesWhitelist[type] && !node.readOnly) return true;
    if (tagName === 'TEXTAREA' && !node.readOnly) return true;
    if (node.isContentEditable) return true;
    return false;
}
/**
 * Keep track of our keyboard modality state with `hadKeyboardEvent`.
 * If the most recent user interaction was via the keyboard;
 * and the key press did not include a meta, alt/option, or control key;
 * then the modality is keyboard. Otherwise, the modality is not keyboard.
 * @param {KeyboardEvent} event
 */ function $32d0bbb37645f3a6$var$handleKeyDown(event) {
    if (event.metaKey || event.altKey || event.ctrlKey) return;
    $32d0bbb37645f3a6$var$hadKeyboardEvent = true;
}
/**
 * If at any point a user clicks with a pointing device, ensure that we change
 * the modality away from keyboard.
 * This avoids the situation where a user presses a key on an already focused
 * element, and then clicks on a different element, focusing it with a
 * pointing device, while we still think we're in keyboard modality.
 */ function $32d0bbb37645f3a6$var$handlePointerDown() {
    $32d0bbb37645f3a6$var$hadKeyboardEvent = false;
}
function $32d0bbb37645f3a6$var$handleVisibilityChange() {
    if (this.visibilityState === 'hidden') // If the tab becomes active again, the browser will handle calling focus
    // on the element (Safari actually calls it twice).
    // If this tab change caused a blur on an element with focus-visible,
    // re-apply the class when the user switches back to the tab.
    {
        if ($32d0bbb37645f3a6$var$hadFocusVisibleRecently) $32d0bbb37645f3a6$var$hadKeyboardEvent = true;
    }
}
function $32d0bbb37645f3a6$var$prepare(doc) {
    doc.addEventListener('keydown', $32d0bbb37645f3a6$var$handleKeyDown, true);
    doc.addEventListener('mousedown', $32d0bbb37645f3a6$var$handlePointerDown, true);
    doc.addEventListener('pointerdown', $32d0bbb37645f3a6$var$handlePointerDown, true);
    doc.addEventListener('touchstart', $32d0bbb37645f3a6$var$handlePointerDown, true);
    doc.addEventListener('visibilitychange', $32d0bbb37645f3a6$var$handleVisibilityChange, true);
}
function $32d0bbb37645f3a6$export$4794d9b1949031cf(doc) {
    doc.removeEventListener('keydown', $32d0bbb37645f3a6$var$handleKeyDown, true);
    doc.removeEventListener('mousedown', $32d0bbb37645f3a6$var$handlePointerDown, true);
    doc.removeEventListener('pointerdown', $32d0bbb37645f3a6$var$handlePointerDown, true);
    doc.removeEventListener('touchstart', $32d0bbb37645f3a6$var$handlePointerDown, true);
    doc.removeEventListener('visibilitychange', $32d0bbb37645f3a6$var$handleVisibilityChange, true);
}
function $32d0bbb37645f3a6$var$isFocusVisible(event) {
    const { target: target } = event;
    try {
        return target.matches(':focus-visible');
    } catch (error) {
    // Browsers not implementing :focus-visible will throw a SyntaxError.
    // We use our own heuristic for those browsers.
    // Rethrow might be better if it's not the expected error but do we really
    // want to crash if focus-visible malfunctioned?
    }
    // No need for validFocusTarget check. The user does that by attaching it to
    // focusable events only.
    return $32d0bbb37645f3a6$var$hadKeyboardEvent || $32d0bbb37645f3a6$var$focusTriggersKeyboardModality(target);
}
function $32d0bbb37645f3a6$export$2e2bcd8739ae039() {
    const ref = $gJYWc.useCallback((node)=>{
        if (node != null) $32d0bbb37645f3a6$var$prepare(node.ownerDocument);
    }, []);
    const isFocusVisibleRef = $gJYWc.useRef(false);
    /**
   * Should be called if a blur event is fired
   */ function handleBlurVisible() {
        // checking against potential state variable does not suffice if we focus and blur synchronously.
        // React wouldn't have time to trigger a re-render so `focusVisible` would be stale.
        // Ideally we would adjust `isFocusVisible(event)` to look at `relatedTarget` for blur events.
        // This doesn't work in IE11 due to https://github.com/facebook/react/issues/3751
        // TODO: check again if React releases their internal changes to focus event handling (https://github.com/facebook/react/pull/19186).
        if (isFocusVisibleRef.current) {
            // To detect a tab/window switch, we look for a blur event followed
            // rapidly by a visibility change.
            // If we don't see a visibility change within 100ms, it's probably a
            // regular focus change.
            $32d0bbb37645f3a6$var$hadFocusVisibleRecently = true;
            $32d0bbb37645f3a6$var$hadFocusVisibleRecentlyTimeout.start(100, ()=>{
                $32d0bbb37645f3a6$var$hadFocusVisibleRecently = false;
            });
            isFocusVisibleRef.current = false;
            return true;
        }
        return false;
    }
    /**
   * Should be called if a blur event is fired
   */ function handleFocusVisible(event) {
        if ($32d0bbb37645f3a6$var$isFocusVisible(event)) {
            isFocusVisibleRef.current = true;
            return true;
        }
        return false;
    }
    return {
        isFocusVisibleRef: isFocusVisibleRef,
        onFocus: handleFocusVisible,
        onBlur: handleBlurVisible,
        ref: ref
    };
}

});
parcelRegister("4LiUz", function(module, exports) {

$parcel$export(module.exports, "Timeout", function () { return $377a389a7ea6d167$export$786b4da70f00938b; });
$parcel$export(module.exports, "default", function () { return $377a389a7ea6d167$export$2e2bcd8739ae039; });

var $kA63M = parcelRequire("kA63M");

var $LeFRC = parcelRequire("LeFRC");
'use client';
class $377a389a7ea6d167$export$786b4da70f00938b {
    static create() {
        return new $377a389a7ea6d167$export$786b4da70f00938b();
    }
    /**
   * Executes `fn` after `delay`, clearing any previously scheduled call.
   */ start(delay, fn) {
        this.clear();
        this.currentId = setTimeout(()=>{
            this.currentId = null;
            fn();
        }, delay);
    }
    constructor(){
        this.currentId = null;
        this.clear = ()=>{
            if (this.currentId !== null) {
                clearTimeout(this.currentId);
                this.currentId = null;
            }
        };
        this.disposeEffect = ()=>{
            return this.clear;
        };
    }
}
function $377a389a7ea6d167$export$2e2bcd8739ae039() {
    const timeout = (0, $kA63M.default)($377a389a7ea6d167$export$786b4da70f00938b.create).current;
    (0, $LeFRC.default)(timeout.disposeEffect);
    return timeout;
}

});
parcelRegister("kA63M", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $efbbded05e5b67de$export$2e2bcd8739ae039; });

var $gJYWc = parcelRequire("gJYWc");
'use client';
const $efbbded05e5b67de$var$UNINITIALIZED = {};
function $efbbded05e5b67de$export$2e2bcd8739ae039(init, initArg) {
    const ref = $gJYWc.useRef($efbbded05e5b67de$var$UNINITIALIZED);
    if (ref.current === $efbbded05e5b67de$var$UNINITIALIZED) ref.current = init(initArg);
    return ref;
}

});

parcelRegister("LeFRC", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $08dfc5e56e2406e1$export$2e2bcd8739ae039; });

var $gJYWc = parcelRequire("gJYWc");
'use client';
const $08dfc5e56e2406e1$var$EMPTY = [];
function $08dfc5e56e2406e1$export$2e2bcd8739ae039(fn) {
    /* eslint-disable react-hooks/exhaustive-deps */ $gJYWc.useEffect(fn, $08dfc5e56e2406e1$var$EMPTY);
/* eslint-enable react-hooks/exhaustive-deps */ }

});




parcelRegister("f89qk", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b03ee9bb4ed8c084$export$2e2bcd8739ae039; });

var $3VnFq = parcelRequire("3VnFq");

var $cTAWX = parcelRequire("cTAWX");

var $gJYWc = parcelRequire("gJYWc");


var $wvXl9 = parcelRequire("wvXl9");

var $2w6IV = parcelRequire("2w6IV");

var $d0nrV = parcelRequire("d0nrV");

var $4LiUz = parcelRequire("4LiUz");

var $HGmne = parcelRequire("HGmne");

var $8pLcn = parcelRequire("8pLcn");

var $aJ8j2 = parcelRequire("aJ8j2");

var $igKOC = parcelRequire("igKOC");

var $9wx12 = parcelRequire("9wx12");
'use client';
const $b03ee9bb4ed8c084$var$_excluded = [
    "center",
    "classes",
    "className"
];
let $b03ee9bb4ed8c084$var$_ = (t)=>t, $b03ee9bb4ed8c084$var$_t, $b03ee9bb4ed8c084$var$_t2, $b03ee9bb4ed8c084$var$_t3, $b03ee9bb4ed8c084$var$_t4;
const $b03ee9bb4ed8c084$var$DURATION = 550;
const $b03ee9bb4ed8c084$export$95d0c9356b2231a3 = 80;
const $b03ee9bb4ed8c084$var$enterKeyframe = (0, $d0nrV.keyframes)($b03ee9bb4ed8c084$var$_t || ($b03ee9bb4ed8c084$var$_t = $b03ee9bb4ed8c084$var$_`
  0% {
    transform: scale(0);
    opacity: 0.1;
  }

  100% {
    transform: scale(1);
    opacity: 0.3;
  }
`));
const $b03ee9bb4ed8c084$var$exitKeyframe = (0, $d0nrV.keyframes)($b03ee9bb4ed8c084$var$_t2 || ($b03ee9bb4ed8c084$var$_t2 = $b03ee9bb4ed8c084$var$_`
  0% {
    opacity: 1;
  }

  100% {
    opacity: 0;
  }
`));
const $b03ee9bb4ed8c084$var$pulsateKeyframe = (0, $d0nrV.keyframes)($b03ee9bb4ed8c084$var$_t3 || ($b03ee9bb4ed8c084$var$_t3 = $b03ee9bb4ed8c084$var$_`
  0% {
    transform: scale(1);
  }

  50% {
    transform: scale(0.92);
  }

  100% {
    transform: scale(1);
  }
`));
const $b03ee9bb4ed8c084$export$f6b7418508c72c25 = (0, $HGmne.default)('span', {
    name: 'MuiTouchRipple',
    slot: 'Root'
})({
    overflow: 'hidden',
    pointerEvents: 'none',
    position: 'absolute',
    zIndex: 0,
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    borderRadius: 'inherit'
});
const $b03ee9bb4ed8c084$export$676cfe7b12693c4b = (0, $HGmne.default)((0, $aJ8j2.default), {
    name: 'MuiTouchRipple',
    slot: 'Ripple'
})($b03ee9bb4ed8c084$var$_t4 || ($b03ee9bb4ed8c084$var$_t4 = $b03ee9bb4ed8c084$var$_`
  opacity: 0;
  position: absolute;

  &.${0} {
    opacity: 0.3;
    transform: scale(1);
    animation-name: ${0};
    animation-duration: ${0}ms;
    animation-timing-function: ${0};
  }

  &.${0} {
    animation-duration: ${0}ms;
  }

  & .${0} {
    opacity: 1;
    display: block;
    width: 100%;
    height: 100%;
    border-radius: 50%;
    background-color: currentColor;
  }

  & .${0} {
    opacity: 0;
    animation-name: ${0};
    animation-duration: ${0}ms;
    animation-timing-function: ${0};
  }

  & .${0} {
    position: absolute;
    /* @noflip */
    left: 0px;
    top: 0;
    animation-name: ${0};
    animation-duration: 2500ms;
    animation-timing-function: ${0};
    animation-iteration-count: infinite;
    animation-delay: 200ms;
  }
`), (0, $igKOC.default).rippleVisible, $b03ee9bb4ed8c084$var$enterKeyframe, $b03ee9bb4ed8c084$var$DURATION, ({ theme: theme })=>theme.transitions.easing.easeInOut, (0, $igKOC.default).ripplePulsate, ({ theme: theme })=>theme.transitions.duration.shorter, (0, $igKOC.default).child, (0, $igKOC.default).childLeaving, $b03ee9bb4ed8c084$var$exitKeyframe, $b03ee9bb4ed8c084$var$DURATION, ({ theme: theme })=>theme.transitions.easing.easeInOut, (0, $igKOC.default).childPulsate, $b03ee9bb4ed8c084$var$pulsateKeyframe, ({ theme: theme })=>theme.transitions.easing.easeInOut);
/**
 * @ignore - internal component.
 *
 * TODO v5: Make private
 */ const $b03ee9bb4ed8c084$var$TouchRipple = /*#__PURE__*/ $gJYWc.forwardRef(function TouchRipple(inProps, ref) {
    const props = (0, $8pLcn.useDefaultProps)({
        props: inProps,
        name: 'MuiTouchRipple'
    });
    const { center: centerProp = false, classes: classes = {}, className: className } = props, other = (0, $cTAWX.default)(props, $b03ee9bb4ed8c084$var$_excluded);
    const [ripples, setRipples] = $gJYWc.useState([]);
    const nextKey = $gJYWc.useRef(0);
    const rippleCallback = $gJYWc.useRef(null);
    $gJYWc.useEffect(()=>{
        if (rippleCallback.current) {
            rippleCallback.current();
            rippleCallback.current = null;
        }
    }, [
        ripples
    ]);
    // Used to filter out mouse emulated events on mobile.
    const ignoringMouseDown = $gJYWc.useRef(false);
    // We use a timer in order to only show the ripples for touch "click" like events.
    // We don't want to display the ripple for touch scroll events.
    const startTimer = (0, $4LiUz.default)();
    // This is the hook called once the previous timeout is ready.
    const startTimerCommit = $gJYWc.useRef(null);
    const container = $gJYWc.useRef(null);
    const startCommit = $gJYWc.useCallback((params)=>{
        const { pulsate: pulsate, rippleX: rippleX, rippleY: rippleY, rippleSize: rippleSize, cb: cb } = params;
        setRipples((oldRipples)=>[
                ...oldRipples,
                /*#__PURE__*/ (0, $9wx12.jsx)($b03ee9bb4ed8c084$export$676cfe7b12693c4b, {
                    classes: {
                        ripple: (0, $2w6IV.default)(classes.ripple, (0, $igKOC.default).ripple),
                        rippleVisible: (0, $2w6IV.default)(classes.rippleVisible, (0, $igKOC.default).rippleVisible),
                        ripplePulsate: (0, $2w6IV.default)(classes.ripplePulsate, (0, $igKOC.default).ripplePulsate),
                        child: (0, $2w6IV.default)(classes.child, (0, $igKOC.default).child),
                        childLeaving: (0, $2w6IV.default)(classes.childLeaving, (0, $igKOC.default).childLeaving),
                        childPulsate: (0, $2w6IV.default)(classes.childPulsate, (0, $igKOC.default).childPulsate)
                    },
                    timeout: $b03ee9bb4ed8c084$var$DURATION,
                    pulsate: pulsate,
                    rippleX: rippleX,
                    rippleY: rippleY,
                    rippleSize: rippleSize
                }, nextKey.current)
            ]);
        nextKey.current += 1;
        rippleCallback.current = cb;
    }, [
        classes
    ]);
    const start = $gJYWc.useCallback((event = {}, options = {}, cb = ()=>{})=>{
        const { pulsate: pulsate = false, center: center = centerProp || options.pulsate, fakeElement: fakeElement = false // For test purposes
         } = options;
        if ((event == null ? void 0 : event.type) === 'mousedown' && ignoringMouseDown.current) {
            ignoringMouseDown.current = false;
            return;
        }
        if ((event == null ? void 0 : event.type) === 'touchstart') ignoringMouseDown.current = true;
        const element = fakeElement ? null : container.current;
        const rect = element ? element.getBoundingClientRect() : {
            width: 0,
            height: 0,
            left: 0,
            top: 0
        };
        // Get the size of the ripple
        let rippleX;
        let rippleY;
        let rippleSize;
        if (center || event === undefined || event.clientX === 0 && event.clientY === 0 || !event.clientX && !event.touches) {
            rippleX = Math.round(rect.width / 2);
            rippleY = Math.round(rect.height / 2);
        } else {
            const { clientX: clientX, clientY: clientY } = event.touches && event.touches.length > 0 ? event.touches[0] : event;
            rippleX = Math.round(clientX - rect.left);
            rippleY = Math.round(clientY - rect.top);
        }
        if (center) {
            rippleSize = Math.sqrt((2 * rect.width ** 2 + rect.height ** 2) / 3);
            // For some reason the animation is broken on Mobile Chrome if the size is even.
            if (rippleSize % 2 === 0) rippleSize += 1;
        } else {
            const sizeX = Math.max(Math.abs((element ? element.clientWidth : 0) - rippleX), rippleX) * 2 + 2;
            const sizeY = Math.max(Math.abs((element ? element.clientHeight : 0) - rippleY), rippleY) * 2 + 2;
            rippleSize = Math.sqrt(sizeX ** 2 + sizeY ** 2);
        }
        // Touche devices
        if (event != null && event.touches) // check that this isn't another touchstart due to multitouch
        // otherwise we will only clear a single timer when unmounting while two
        // are running
        {
            if (startTimerCommit.current === null) {
                // Prepare the ripple effect.
                startTimerCommit.current = ()=>{
                    startCommit({
                        pulsate: pulsate,
                        rippleX: rippleX,
                        rippleY: rippleY,
                        rippleSize: rippleSize,
                        cb: cb
                    });
                };
                // Delay the execution of the ripple effect.
                // We have to make a tradeoff with this delay value.
                startTimer.start($b03ee9bb4ed8c084$export$95d0c9356b2231a3, ()=>{
                    if (startTimerCommit.current) {
                        startTimerCommit.current();
                        startTimerCommit.current = null;
                    }
                });
            }
        } else startCommit({
            pulsate: pulsate,
            rippleX: rippleX,
            rippleY: rippleY,
            rippleSize: rippleSize,
            cb: cb
        });
    }, [
        centerProp,
        startCommit,
        startTimer
    ]);
    const pulsate = $gJYWc.useCallback(()=>{
        start({}, {
            pulsate: true
        });
    }, [
        start
    ]);
    const stop = $gJYWc.useCallback((event, cb)=>{
        startTimer.clear();
        // The touch interaction occurs too quickly.
        // We still want to show ripple effect.
        if ((event == null ? void 0 : event.type) === 'touchend' && startTimerCommit.current) {
            startTimerCommit.current();
            startTimerCommit.current = null;
            startTimer.start(0, ()=>{
                stop(event, cb);
            });
            return;
        }
        startTimerCommit.current = null;
        setRipples((oldRipples)=>{
            if (oldRipples.length > 0) return oldRipples.slice(1);
            return oldRipples;
        });
        rippleCallback.current = cb;
    }, [
        startTimer
    ]);
    $gJYWc.useImperativeHandle(ref, ()=>({
            pulsate: pulsate,
            start: start,
            stop: stop
        }), [
        pulsate,
        start,
        stop
    ]);
    return /*#__PURE__*/ (0, $9wx12.jsx)($b03ee9bb4ed8c084$export$f6b7418508c72c25, (0, $3VnFq.default)({
        className: (0, $2w6IV.default)((0, $igKOC.default).root, classes.root, className),
        ref: container
    }, other, {
        children: /*#__PURE__*/ (0, $9wx12.jsx)((0, $wvXl9.default), {
            component: null,
            exit: true,
            children: ripples
        })
    }));
});
var $b03ee9bb4ed8c084$export$2e2bcd8739ae039 = $b03ee9bb4ed8c084$var$TouchRipple;

});
parcelRegister("wvXl9", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $061bc716c4e2775d$export$2e2bcd8739ae039; });

var $cTAWX = parcelRequire("cTAWX");

var $3VnFq = parcelRequire("3VnFq");

var $bn1jD = parcelRequire("bn1jD");

var $4yJFC = parcelRequire("4yJFC");


var $gJYWc = parcelRequire("gJYWc");

var $l6PtU = parcelRequire("l6PtU");

var $gW7W8 = parcelRequire("gW7W8");
var $061bc716c4e2775d$var$values = Object.values || function(obj) {
    return Object.keys(obj).map(function(k) {
        return obj[k];
    });
};
var $061bc716c4e2775d$var$defaultProps = {
    component: 'div',
    childFactory: function childFactory(child) {
        return child;
    }
};
/**
 * The `<TransitionGroup>` component manages a set of transition components
 * (`<Transition>` and `<CSSTransition>`) in a list. Like with the transition
 * components, `<TransitionGroup>` is a state machine for managing the mounting
 * and unmounting of components over time.
 *
 * Consider the example below. As items are removed or added to the TodoList the
 * `in` prop is toggled automatically by the `<TransitionGroup>`.
 *
 * Note that `<TransitionGroup>`  does not define any animation behavior!
 * Exactly _how_ a list item animates is up to the individual transition
 * component. This means you can mix and match animations across different list
 * items.
 */ var $061bc716c4e2775d$var$TransitionGroup = /*#__PURE__*/ function(_React$Component) {
    (0, $4yJFC.default)(TransitionGroup, _React$Component);
    function TransitionGroup(props, context) {
        var _this;
        _this = _React$Component.call(this, props, context) || this;
        var handleExited = _this.handleExited.bind((0, $bn1jD.default)(_this)); // Initial children should all be entering, dependent on appear
        _this.state = {
            contextValue: {
                isMounting: true
            },
            handleExited: handleExited,
            firstRender: true
        };
        return _this;
    }
    var _proto = TransitionGroup.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this.mounted = true;
        this.setState({
            contextValue: {
                isMounting: false
            }
        });
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.mounted = false;
    };
    TransitionGroup.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, _ref) {
        var prevChildMapping = _ref.children, handleExited = _ref.handleExited, firstRender = _ref.firstRender;
        return {
            children: firstRender ? (0, $gW7W8.getInitialChildMapping)(nextProps, handleExited) : (0, $gW7W8.getNextChildMapping)(nextProps, prevChildMapping, handleExited),
            firstRender: false
        };
    } // node is `undefined` when user provided `nodeRef` prop
    ;
    _proto.handleExited = function handleExited(child, node) {
        var currentChildMapping = (0, $gW7W8.getChildMapping)(this.props.children);
        if (child.key in currentChildMapping) return;
        if (child.props.onExited) child.props.onExited(node);
        if (this.mounted) this.setState(function(state) {
            var children = (0, $3VnFq.default)({}, state.children);
            delete children[child.key];
            return {
                children: children
            };
        });
    };
    _proto.render = function render() {
        var _this$props = this.props, Component = _this$props.component, childFactory = _this$props.childFactory, props = (0, $cTAWX.default)(_this$props, [
            "component",
            "childFactory"
        ]);
        var contextValue = this.state.contextValue;
        var children = $061bc716c4e2775d$var$values(this.state.children).map(childFactory);
        delete props.appear;
        delete props.enter;
        delete props.exit;
        if (Component === null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gJYWc))).createElement((0, $l6PtU.default).Provider, {
            value: contextValue
        }, children);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gJYWc))).createElement((0, $l6PtU.default).Provider, {
            value: contextValue
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gJYWc))).createElement(Component, props, children));
    };
    return TransitionGroup;
}((0, (/*@__PURE__*/$parcel$interopDefault($gJYWc))).Component);
$061bc716c4e2775d$var$TransitionGroup.propTypes = {};
$061bc716c4e2775d$var$TransitionGroup.defaultProps = $061bc716c4e2775d$var$defaultProps;
var $061bc716c4e2775d$export$2e2bcd8739ae039 = $061bc716c4e2775d$var$TransitionGroup;

});
parcelRegister("bn1jD", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8472dcf213f3f86f$export$2e2bcd8739ae039; });
function $8472dcf213f3f86f$export$2e2bcd8739ae039(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
}

});

parcelRegister("4yJFC", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $351dc38da8b3ffa6$export$2e2bcd8739ae039; });

var $mAbGg = parcelRequire("mAbGg");
function $351dc38da8b3ffa6$export$2e2bcd8739ae039(t, o) {
    t.prototype = Object.create(o.prototype), t.prototype.constructor = t, (0, $mAbGg.default)(t, o);
}

});
parcelRegister("mAbGg", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $043e204071c15d67$export$2e2bcd8739ae039; });
function $043e204071c15d67$export$2e2bcd8739ae039(t, e) {
    return $043e204071c15d67$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, $043e204071c15d67$export$2e2bcd8739ae039(t, e);
}

});


parcelRegister("l6PtU", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f5e217a323b8318c$export$2e2bcd8739ae039; });

var $gJYWc = parcelRequire("gJYWc");
var $f5e217a323b8318c$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($gJYWc))).createContext(null);

});

parcelRegister("gW7W8", function(module, exports) {

$parcel$export(module.exports, "getChildMapping", function () { return $c5483829750cbdd3$export$bbc8a025727ea824; });
$parcel$export(module.exports, "getInitialChildMapping", function () { return $c5483829750cbdd3$export$fa71e2345c31d7a2; });
$parcel$export(module.exports, "getNextChildMapping", function () { return $c5483829750cbdd3$export$36fd1af28d383ec0; });

var $gJYWc = parcelRequire("gJYWc");
function $c5483829750cbdd3$export$bbc8a025727ea824(children, mapFn) {
    var mapper = function mapper(child) {
        return mapFn && (0, $gJYWc.isValidElement)(child) ? mapFn(child) : child;
    };
    var result = Object.create(null);
    if (children) (0, $gJYWc.Children).map(children, function(c) {
        return c;
    }).forEach(function(child) {
        // run the map function here instead so that the key is the computed one
        result[child.key] = mapper(child);
    });
    return result;
}
function $c5483829750cbdd3$export$7a874f95ccf533dd(prev, next) {
    prev = prev || {};
    next = next || {};
    function getValueForKey(key) {
        return key in next ? next[key] : prev[key];
    } // For each key of `next`, the list of keys to insert before that key in
    // the combined list
    var nextKeysPending = Object.create(null);
    var pendingKeys = [];
    for(var prevKey in prev){
        if (prevKey in next) {
            if (pendingKeys.length) {
                nextKeysPending[prevKey] = pendingKeys;
                pendingKeys = [];
            }
        } else pendingKeys.push(prevKey);
    }
    var i;
    var childMapping = {};
    for(var nextKey in next){
        if (nextKeysPending[nextKey]) for(i = 0; i < nextKeysPending[nextKey].length; i++){
            var pendingNextKey = nextKeysPending[nextKey][i];
            childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
        }
        childMapping[nextKey] = getValueForKey(nextKey);
    } // Finally, add the keys which didn't appear before any key in `next`
    for(i = 0; i < pendingKeys.length; i++)childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
    return childMapping;
}
function $c5483829750cbdd3$var$getProp(child, prop, props) {
    return props[prop] != null ? props[prop] : child.props[prop];
}
function $c5483829750cbdd3$export$fa71e2345c31d7a2(props, onExited) {
    return $c5483829750cbdd3$export$bbc8a025727ea824(props.children, function(child) {
        return (0, $gJYWc.cloneElement)(child, {
            onExited: onExited.bind(null, child),
            in: true,
            appear: $c5483829750cbdd3$var$getProp(child, 'appear', props),
            enter: $c5483829750cbdd3$var$getProp(child, 'enter', props),
            exit: $c5483829750cbdd3$var$getProp(child, 'exit', props)
        });
    });
}
function $c5483829750cbdd3$export$36fd1af28d383ec0(nextProps, prevChildMapping, onExited) {
    var nextChildMapping = $c5483829750cbdd3$export$bbc8a025727ea824(nextProps.children);
    var children = $c5483829750cbdd3$export$7a874f95ccf533dd(prevChildMapping, nextChildMapping);
    Object.keys(children).forEach(function(key) {
        var child = children[key];
        if (!(0, $gJYWc.isValidElement)(child)) return;
        var hasPrev = key in prevChildMapping;
        var hasNext = key in nextChildMapping;
        var prevChild = prevChildMapping[key];
        var isLeaving = (0, $gJYWc.isValidElement)(prevChild) && !prevChild.props.in; // item is new (entering)
        if (hasNext && (!hasPrev || isLeaving)) // console.log('entering', key)
        children[key] = (0, $gJYWc.cloneElement)(child, {
            onExited: onExited.bind(null, child),
            in: true,
            exit: $c5483829750cbdd3$var$getProp(child, 'exit', nextProps),
            enter: $c5483829750cbdd3$var$getProp(child, 'enter', nextProps)
        });
        else if (!hasNext && hasPrev && !isLeaving) // item is old (exiting)
        // console.log('leaving', key)
        children[key] = (0, $gJYWc.cloneElement)(child, {
            in: false
        });
        else if (hasNext && hasPrev && (0, $gJYWc.isValidElement)(prevChild)) // item hasn't changed transition states
        // copy over the last transition props;
        // console.log('unchanged', key)
        children[key] = (0, $gJYWc.cloneElement)(child, {
            onExited: onExited.bind(null, child),
            in: prevChild.props.in,
            exit: $c5483829750cbdd3$var$getProp(child, 'exit', nextProps),
            enter: $c5483829750cbdd3$var$getProp(child, 'enter', nextProps)
        });
    });
    return children;
}

});


parcelRegister("aJ8j2", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7cf48cc66a1157c3$export$2e2bcd8739ae039; });

var $gJYWc = parcelRequire("gJYWc");


var $2w6IV = parcelRequire("2w6IV");

var $9wx12 = parcelRequire("9wx12");
'use client';
function $7cf48cc66a1157c3$var$Ripple(props) {
    const { className: className, classes: classes, pulsate: pulsate = false, rippleX: rippleX, rippleY: rippleY, rippleSize: rippleSize, in: inProp, onExited: onExited, timeout: timeout } = props;
    const [leaving, setLeaving] = $gJYWc.useState(false);
    const rippleClassName = (0, $2w6IV.default)(className, classes.ripple, classes.rippleVisible, pulsate && classes.ripplePulsate);
    const rippleStyles = {
        width: rippleSize,
        height: rippleSize,
        top: -(rippleSize / 2) + rippleY,
        left: -(rippleSize / 2) + rippleX
    };
    const childClassName = (0, $2w6IV.default)(classes.child, leaving && classes.childLeaving, pulsate && classes.childPulsate);
    if (!inProp && !leaving) setLeaving(true);
    $gJYWc.useEffect(()=>{
        if (!inProp && onExited != null) {
            // react-transition-group#onExited
            const timeoutId = setTimeout(onExited, timeout);
            return ()=>{
                clearTimeout(timeoutId);
            };
        }
        return undefined;
    }, [
        onExited,
        inProp,
        timeout
    ]);
    return /*#__PURE__*/ (0, $9wx12.jsx)("span", {
        className: rippleClassName,
        style: rippleStyles,
        children: /*#__PURE__*/ (0, $9wx12.jsx)("span", {
            className: childClassName
        })
    });
}
var $7cf48cc66a1157c3$export$2e2bcd8739ae039 = $7cf48cc66a1157c3$var$Ripple;

});

parcelRegister("igKOC", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d4ce092c61c01b00$export$2e2bcd8739ae039; });

var $i8nzj = parcelRequire("i8nzj");

var $1kRHf = parcelRequire("1kRHf");
function $d4ce092c61c01b00$export$b464606f735ab902(slot) {
    return (0, $1kRHf.default)('MuiTouchRipple', slot);
}
const $d4ce092c61c01b00$var$touchRippleClasses = (0, $i8nzj.default)('MuiTouchRipple', [
    'root',
    'ripple',
    'rippleVisible',
    'ripplePulsate',
    'child',
    'childLeaving',
    'childPulsate'
]);
var $d4ce092c61c01b00$export$2e2bcd8739ae039 = $d4ce092c61c01b00$var$touchRippleClasses;

});


parcelRegister("jZED7", function(module, exports) {

$parcel$export(module.exports, "getButtonBaseUtilityClass", function () { return $e8e33b13774a40f8$export$fccb0498dcd99783; });
$parcel$export(module.exports, "default", function () { return $e8e33b13774a40f8$export$2e2bcd8739ae039; });

var $i8nzj = parcelRequire("i8nzj");

var $1kRHf = parcelRequire("1kRHf");
function $e8e33b13774a40f8$export$fccb0498dcd99783(slot) {
    return (0, $1kRHf.default)('MuiButtonBase', slot);
}
const $e8e33b13774a40f8$var$buttonBaseClasses = (0, $i8nzj.default)('MuiButtonBase', [
    'root',
    'disabled',
    'focusVisible'
]);
var $e8e33b13774a40f8$export$2e2bcd8739ae039 = $e8e33b13774a40f8$var$buttonBaseClasses;

});


parcelRegister("1uF8F", function(module, exports) {

$parcel$export(module.exports, "getIconButtonUtilityClass", function () { return $1168811dc6d652c8$export$5e8702d71474f093; });
$parcel$export(module.exports, "default", function () { return $1168811dc6d652c8$export$2e2bcd8739ae039; });

var $i8nzj = parcelRequire("i8nzj");

var $1kRHf = parcelRequire("1kRHf");
function $1168811dc6d652c8$export$5e8702d71474f093(slot) {
    return (0, $1kRHf.default)('MuiIconButton', slot);
}
const $1168811dc6d652c8$var$iconButtonClasses = (0, $i8nzj.default)('MuiIconButton', [
    'root',
    'disabled',
    'colorInherit',
    'colorPrimary',
    'colorSecondary',
    'colorError',
    'colorInfo',
    'colorSuccess',
    'colorWarning',
    'edgeStart',
    'edgeEnd',
    'sizeSmall',
    'sizeMedium',
    'sizeLarge'
]);
var $1168811dc6d652c8$export$2e2bcd8739ae039 = $1168811dc6d652c8$var$iconButtonClasses;

});




parcelRegister("6h9rz", function(module, exports) {
"use strict";
var $491ba7eaabde7494$var$__assign = module.exports && module.exports.__assign || function() {
    $491ba7eaabde7494$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $491ba7eaabde7494$var$__assign.apply(this, arguments);
};
var $491ba7eaabde7494$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, {
        enumerable: true,
        get: function() {
            return m[k];
        }
    });
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $491ba7eaabde7494$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $491ba7eaabde7494$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $491ba7eaabde7494$var$__createBinding(result, mod, k);
    }
    $491ba7eaabde7494$var$__setModuleDefault(result, mod);
    return result;
};
var $491ba7eaabde7494$var$__rest = module.exports && module.exports.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Indicators = void 0;

var $491ba7eaabde7494$var$react_1 = $491ba7eaabde7494$var$__importStar((parcelRequire("gJYWc")));

var $7bLnp = parcelRequire("7bLnp");
var $491ba7eaabde7494$var$Indicators = function(props) {
    var IndicatorIcon = (0, $491ba7eaabde7494$var$react_1.useMemo)(function() {
        return props.IndicatorIcon !== undefined ? props.IndicatorIcon : $491ba7eaabde7494$var$react_1.default.createElement($7bLnp.StyledFiberManualRecordIcon, null);
    }, [
        props.IndicatorIcon
    ]);
    var completeListIfRequired = (0, $491ba7eaabde7494$var$react_1.useCallback)(function(arrayOfIcons) {
        while(arrayOfIcons.length < props.length){
            var index = 0;
            arrayOfIcons.push(arrayOfIcons[index]);
            index += 1;
        }
    }, [
        props.length
    ]);
    var _a = props.indicatorIconButtonProps, indicatorIconButtonClass = _a.className, indicatorIconButtonStyle = _a.style, indicatorIconButtonProps = $491ba7eaabde7494$var$__rest(_a, [
        "className",
        "style"
    ]);
    var _b = props.activeIndicatorIconButtonProps, activeIndicatorIconButtonClass = _b.className, activeIndicatorIconButtonStyle = _b.style, activeIndicatorIconButtonProps = $491ba7eaabde7494$var$__rest(_b, [
        "className",
        "style"
    ]);
    var indicators = [];
    var _loop_1 = function(i) {
        var className = i === props.active ? indicatorIconButtonClass + " " + activeIndicatorIconButtonClass : "" + indicatorIconButtonClass;
        var style = i === props.active ? Object.assign({}, indicatorIconButtonStyle, activeIndicatorIconButtonStyle) : indicatorIconButtonStyle;
        var restProps = i === props.active ? Object.assign({}, indicatorIconButtonProps, activeIndicatorIconButtonProps) : indicatorIconButtonProps;
        if (restProps['aria-label'] === undefined) restProps['aria-label'] = 'carousel indicator';
        var createIndicator = function(IndicatorIcon) {
            return $491ba7eaabde7494$var$react_1.default.createElement($7bLnp.StyledIndicatorIconButton, $491ba7eaabde7494$var$__assign({
                "$active": i === props.active,
                key: i,
                className: className,
                style: style,
                onClick: function() {
                    props.press(i);
                }
            }, restProps, {
                "aria-label": restProps['aria-label'] + " " + (i + 1)
            }), IndicatorIcon);
        };
        Array.isArray(IndicatorIcon) ? indicators.push(createIndicator(IndicatorIcon[i])) && completeListIfRequired(IndicatorIcon) : indicators.push(createIndicator(IndicatorIcon));
    };
    for(var i = 0; i < props.length; i++)_loop_1(i);
    var _c = props.indicatorContainerProps, indicatorContainerClass = _c.className, indicatorContainerStyle = _c.style, indicatorContainerProps = $491ba7eaabde7494$var$__rest(_c, [
        "className",
        "style"
    ]);
    return $491ba7eaabde7494$var$react_1.default.createElement($7bLnp.StyledIndicators, $491ba7eaabde7494$var$__assign({
        className: indicatorContainerClass,
        style: indicatorContainerStyle
    }, indicatorContainerProps), indicators);
};
module.exports.Indicators = $491ba7eaabde7494$var$Indicators;

});

parcelRegister("gF1SE", function(module, exports) {
"use strict";
var $c211ef160983c1b0$var$__assign = module.exports && module.exports.__assign || function() {
    $c211ef160983c1b0$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $c211ef160983c1b0$var$__assign.apply(this, arguments);
};
var $c211ef160983c1b0$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, {
        enumerable: true,
        get: function() {
            return m[k];
        }
    });
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $c211ef160983c1b0$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $c211ef160983c1b0$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $c211ef160983c1b0$var$__createBinding(result, mod, k);
    }
    $c211ef160983c1b0$var$__setModuleDefault(result, mod);
    return result;
};
var $c211ef160983c1b0$var$__rest = module.exports && module.exports.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $c211ef160983c1b0$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.useInterval = module.exports.sanitizeProps = module.exports.sanitizeNavProps = void 0;

var $c211ef160983c1b0$var$NavigateBefore_1 = $c211ef160983c1b0$var$__importDefault((parcelRequire("5H8zW")));

var $c211ef160983c1b0$var$NavigateNext_1 = $c211ef160983c1b0$var$__importDefault((parcelRequire("26wLu")));

var $c211ef160983c1b0$var$react_1 = $c211ef160983c1b0$var$__importStar((parcelRequire("gJYWc")));
var $c211ef160983c1b0$var$sanitizeNavProps = function(props) {
    var _a = props || {}, className = _a.className, style = _a.style, rest = $c211ef160983c1b0$var$__rest(_a, [
        "className",
        "style"
    ]);
    return props !== undefined ? $c211ef160983c1b0$var$__assign({
        style: props.style !== undefined ? props.style : {},
        className: props.className !== undefined ? props.className : ""
    }, rest) : $c211ef160983c1b0$var$__assign({
        style: {},
        className: ""
    }, rest);
};
module.exports.sanitizeNavProps = $c211ef160983c1b0$var$sanitizeNavProps;
var $c211ef160983c1b0$var$sanitizeProps = function(props) {
    var animation = props.animation !== undefined ? props.animation : "fade";
    var duration = props.duration !== undefined ? props.duration : animation === "fade" ? 500 : 200;
    return {
        sx: props.sx !== undefined ? props.sx : {},
        className: props.className !== undefined ? props.className : "",
        children: props.children ? props.children : [],
        height: props.height,
        index: props.index !== undefined ? props.index : 0,
        strictIndexing: props.strictIndexing !== undefined ? props.strictIndexing : true,
        autoPlay: props.autoPlay !== undefined ? props.autoPlay : true,
        stopAutoPlayOnHover: props.stopAutoPlayOnHover !== undefined ? props.stopAutoPlayOnHover : true,
        interval: props.interval !== undefined ? props.interval : 4000,
        animation: animation,
        duration: duration,
        swipe: props.swipe !== undefined ? props.swipe : true,
        navButtonsAlwaysInvisible: props.navButtonsAlwaysInvisible !== undefined ? props.navButtonsAlwaysInvisible : false,
        navButtonsAlwaysVisible: props.navButtonsAlwaysVisible !== undefined ? props.navButtonsAlwaysVisible : false,
        cycleNavigation: props.cycleNavigation !== undefined ? props.cycleNavigation : true,
        fullHeightHover: props.fullHeightHover !== undefined ? props.fullHeightHover : true,
        navButtonsWrapperProps: (0, module.exports.sanitizeNavProps)(props.navButtonsWrapperProps),
        navButtonsProps: (0, module.exports.sanitizeNavProps)(props.navButtonsProps),
        NavButton: props.NavButton,
        NextIcon: props.NextIcon !== undefined ? props.NextIcon : $c211ef160983c1b0$var$react_1.default.createElement($c211ef160983c1b0$var$NavigateNext_1.default, null),
        PrevIcon: props.PrevIcon !== undefined ? props.PrevIcon : $c211ef160983c1b0$var$react_1.default.createElement($c211ef160983c1b0$var$NavigateBefore_1.default, null),
        indicators: props.indicators !== undefined ? props.indicators : true,
        indicatorContainerProps: (0, module.exports.sanitizeNavProps)(props.indicatorContainerProps),
        indicatorIconButtonProps: (0, module.exports.sanitizeNavProps)(props.indicatorIconButtonProps),
        activeIndicatorIconButtonProps: (0, module.exports.sanitizeNavProps)(props.activeIndicatorIconButtonProps),
        IndicatorIcon: props.IndicatorIcon,
        onChange: props.onChange !== undefined ? props.onChange : function() {},
        changeOnFirstRender: props.changeOnFirstRender !== undefined ? props.changeOnFirstRender : false,
        next: props.next !== undefined ? props.next : function() {},
        prev: props.prev !== undefined ? props.prev : function() {}
    };
};
module.exports.sanitizeProps = $c211ef160983c1b0$var$sanitizeProps;
var $c211ef160983c1b0$var$useInterval = function(callback, delay) {
    var savedCallback = (0, $c211ef160983c1b0$var$react_1.useRef)(function() {});
    // Remember the latest callback.
    (0, $c211ef160983c1b0$var$react_1.useEffect)(function() {
        savedCallback.current = callback;
    }, [
        callback
    ]);
    // Set up the interval.
    (0, $c211ef160983c1b0$var$react_1.useEffect)(function() {
        function tick() {
            savedCallback.current();
        }
        if (delay !== null) {
            var id_1 = setInterval(tick, delay);
            return function() {
                return clearInterval(id_1);
            };
        }
        return function() {};
    }, [
        delay
    ]);
};
module.exports.useInterval = $c211ef160983c1b0$var$useInterval;

});
parcelRegister("5H8zW", function(module, exports) {
"use strict";
"use client";

var $hrFuR = parcelRequire("hrFuR");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $42579f703f30e04f$var$_createSvgIcon = $hrFuR((parcelRequire("lXMfO")));

var $9wx12 = parcelRequire("9wx12");
var $42579f703f30e04f$var$_default = module.exports.default = (0, $42579f703f30e04f$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $9wx12.jsx)("path", {
    d: "M15.41 7.41 14 6l-6 6 6 6 1.41-1.41L10.83 12z"
}), 'NavigateBefore');

});

parcelRegister("26wLu", function(module, exports) {
"use strict";
"use client";

var $hrFuR = parcelRequire("hrFuR");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $18858ebc65c407ea$var$_createSvgIcon = $hrFuR((parcelRequire("lXMfO")));

var $9wx12 = parcelRequire("9wx12");
var $18858ebc65c407ea$var$_default = module.exports.default = (0, $18858ebc65c407ea$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $9wx12.jsx)("path", {
    d: "M10 6 8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z"
}), 'NavigateNext');

});



parcelRegister("3Zour", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $2e7a10cb7b17fb24$var$ReactIs, $2e7a10cb7b17fb24$var$throwOnDirectAccess;

// By explicitly using `prop-types` you are opting into new production behavior.
// http://fb.me/prop-types-in-prod
module.exports = (parcelRequire("6vfKF"))();

});

var $bf8bfea269a50fbb$exports = {};
$parcel$extendImportMap({
    "i89wO": "browser.e9e71b17.js"
});


var $9wx12 = parcelRequire("9wx12");
parcelRequire("gJYWc");
var $2eecfe30d0392fb8$export$882461b6382ed46c;
var $2eecfe30d0392fb8$export$757ceba2d55c277e;
'use strict';
var $b5d6c7fd13e04efb$exports = {};
'use strict';
function $b5d6c7fd13e04efb$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($b5d6c7fd13e04efb$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$b5d6c7fd13e04efb$var$checkDCE();

$b5d6c7fd13e04efb$exports = (parcelRequire("56Lv3"));


var $2eecfe30d0392fb8$var$i;
$2eecfe30d0392fb8$export$882461b6382ed46c = $b5d6c7fd13e04efb$exports.createRoot;
$2eecfe30d0392fb8$export$757ceba2d55c277e = $b5d6c7fd13e04efb$exports.hydrateRoot;








var $gJYWc = parcelRequire("gJYWc");

var $gJYWc = parcelRequire("gJYWc");
var $5c26b6cd2850c10e$exports = {};
/**
 * This file automatically generated from `pre-publish.js`.
 * Do not manually edit.
 */ $5c26b6cd2850c10e$exports = {
    "area": true,
    "base": true,
    "br": true,
    "col": true,
    "embed": true,
    "hr": true,
    "img": true,
    "input": true,
    "link": true,
    "meta": true,
    "param": true,
    "source": true,
    "track": true,
    "wbr": true
};


var $dec7b2a08dd59c4b$var$t = /\s([^'"/\s><]+?)[\s/>]|([^\s=]+)=\s?(".*?"|'.*?')/g;
function $dec7b2a08dd59c4b$var$n(n) {
    var r = {
        type: "tag",
        name: "",
        voidElement: !1,
        attrs: {},
        children: []
    }, i = n.match(/<\/?([^\s]+?)[/\s>]/);
    if (i && (r.name = i[1], ((0, (/*@__PURE__*/$parcel$interopDefault($5c26b6cd2850c10e$exports)))[i[1]] || "/" === n.charAt(n.length - 2)) && (r.voidElement = !0), r.name.startsWith("!--"))) {
        var s = n.indexOf("--\x3e");
        return {
            type: "comment",
            comment: -1 !== s ? n.slice(4, s) : ""
        };
    }
    for(var a = new RegExp($dec7b2a08dd59c4b$var$t), c = null; null !== (c = a.exec(n));)if (c[0].trim()) {
        if (c[1]) {
            var o = c[1].trim(), l = [
                o,
                ""
            ];
            o.indexOf("=") > -1 && (l = o.split("=")), r.attrs[l[0]] = l[1], a.lastIndex--;
        } else c[2] && (r.attrs[c[2]] = c[3].trim().substring(1, c[3].length - 1));
    }
    return r;
}
var $dec7b2a08dd59c4b$var$r = /<[a-zA-Z0-9\-\!\/](?:"[^"]*"|'[^']*'|[^'">])*>/g, $dec7b2a08dd59c4b$var$i = /^\s*$/, $dec7b2a08dd59c4b$var$s = Object.create(null);
function $dec7b2a08dd59c4b$var$a(e, t) {
    switch(t.type){
        case "text":
            return e + t.content;
        case "tag":
            return e += "<" + t.name + (t.attrs ? function(e) {
                var t = [];
                for(var n in e)t.push(n + '="' + e[n] + '"');
                return t.length ? " " + t.join(" ") : "";
            }(t.attrs) : "") + (t.voidElement ? "/>" : ">"), t.voidElement ? e : e + t.children.reduce($dec7b2a08dd59c4b$var$a, "") + "</" + t.name + ">";
        case "comment":
            return e + "\x3c!--" + t.comment + "--\x3e";
    }
}
var $dec7b2a08dd59c4b$var$c = {
    parse: function(e, t) {
        t || (t = {}), t.components || (t.components = $dec7b2a08dd59c4b$var$s);
        var a, c = [], o = [], l = -1, m = !1;
        if (0 !== e.indexOf("<")) {
            var u = e.indexOf("<");
            c.push({
                type: "text",
                content: -1 === u ? e : e.substring(0, u)
            });
        }
        return e.replace($dec7b2a08dd59c4b$var$r, function(r, s) {
            if (m) {
                if (r !== "</" + a.name + ">") return;
                m = !1;
            }
            var u, f = "/" !== r.charAt(1), h = r.startsWith("\x3c!--"), p = s + r.length, d = e.charAt(p);
            if (h) {
                var v = $dec7b2a08dd59c4b$var$n(r);
                return l < 0 ? (c.push(v), c) : ((u = o[l]).children.push(v), c);
            }
            if (f && (l++, "tag" === (a = $dec7b2a08dd59c4b$var$n(r)).type && t.components[a.name] && (a.type = "component", m = !0), a.voidElement || m || !d || "<" === d || a.children.push({
                type: "text",
                content: e.slice(p, e.indexOf("<", p))
            }), 0 === l && c.push(a), (u = o[l - 1]) && u.children.push(a), o[l] = a), (!f || a.voidElement) && (l > -1 && (a.voidElement || a.name === r.slice(2, -1)) && (l--, a = -1 === l ? c : o[l]), !m && "<" !== d && d)) {
                u = -1 === l ? c : o[l].children;
                var x = e.indexOf("<", p), g = e.slice(p, -1 === x ? void 0 : x);
                $dec7b2a08dd59c4b$var$i.test(g) && (g = " "), (x > -1 && l + u.length >= 0 || " " !== g) && u.push({
                    type: "text",
                    content: g
                });
            }
        }), c;
    },
    stringify: function(e) {
        return e.reduce(function(e, t) {
            return e + $dec7b2a08dd59c4b$var$a("", t);
        }, "");
    }
};
var $dec7b2a08dd59c4b$export$2e2bcd8739ae039 = $dec7b2a08dd59c4b$var$c;


function $a0ed9a691e4afde0$export$c106dd0671a0fc2d() {
    if (console && console.warn) {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        if ($a0ed9a691e4afde0$export$844ec244b1367d54(args[0])) args[0] = `react-i18next:: ${args[0]}`;
        console.warn(...args);
    }
}
const $a0ed9a691e4afde0$var$alreadyWarned = {};
function $a0ed9a691e4afde0$export$5b28268982f175ba() {
    for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
    if ($a0ed9a691e4afde0$export$844ec244b1367d54(args[0]) && $a0ed9a691e4afde0$var$alreadyWarned[args[0]]) return;
    if ($a0ed9a691e4afde0$export$844ec244b1367d54(args[0])) $a0ed9a691e4afde0$var$alreadyWarned[args[0]] = new Date();
    $a0ed9a691e4afde0$export$c106dd0671a0fc2d(...args);
}
const $a0ed9a691e4afde0$var$loadedClb = (i18n, cb)=>()=>{
        if (i18n.isInitialized) cb();
        else {
            const initialized = ()=>{
                setTimeout(()=>{
                    i18n.off('initialized', initialized);
                }, 0);
                cb();
            };
            i18n.on('initialized', initialized);
        }
    };
const $a0ed9a691e4afde0$export$83be934b53fff43b = (i18n, ns, cb)=>{
    i18n.loadNamespaces(ns, $a0ed9a691e4afde0$var$loadedClb(i18n, cb));
};
const $a0ed9a691e4afde0$export$8cd7e7a54fa865bc = (i18n, lng, ns, cb)=>{
    if ($a0ed9a691e4afde0$export$844ec244b1367d54(ns)) ns = [
        ns
    ];
    ns.forEach((n)=>{
        if (i18n.options.ns.indexOf(n) < 0) i18n.options.ns.push(n);
    });
    i18n.loadLanguages(lng, $a0ed9a691e4afde0$var$loadedClb(i18n, cb));
};
const $a0ed9a691e4afde0$var$oldI18nextHasLoadedNamespace = function(ns, i18n) {
    let options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    const lng = i18n.languages[0];
    const fallbackLng = i18n.options ? i18n.options.fallbackLng : false;
    const lastLng = i18n.languages[i18n.languages.length - 1];
    if (lng.toLowerCase() === 'cimode') return true;
    const loadNotPending = (l, n)=>{
        const loadState = i18n.services.backendConnector.state[`${l}|${n}`];
        return loadState === -1 || loadState === 2;
    };
    if (options.bindI18n && options.bindI18n.indexOf('languageChanging') > -1 && i18n.services.backendConnector.backend && i18n.isLanguageChangingTo && !loadNotPending(i18n.isLanguageChangingTo, ns)) return false;
    if (i18n.hasResourceBundle(lng, ns)) return true;
    if (!i18n.services.backendConnector.backend || i18n.options.resources && !i18n.options.partialBundledLanguages) return true;
    if (loadNotPending(lng, ns) && (!fallbackLng || loadNotPending(lastLng, ns))) return true;
    return false;
};
const $a0ed9a691e4afde0$export$93d9ee97c1ad3f31 = function(ns, i18n) {
    let options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    if (!i18n.languages || !i18n.languages.length) {
        $a0ed9a691e4afde0$export$5b28268982f175ba('i18n.languages were undefined or empty', i18n.languages);
        return true;
    }
    const isNewerI18next = i18n.options.ignoreJSONStructure !== undefined;
    if (!isNewerI18next) return $a0ed9a691e4afde0$var$oldI18nextHasLoadedNamespace(ns, i18n, options);
    return i18n.hasLoadedNamespace(ns, {
        lng: options.lng,
        precheck: (i18nInstance, loadNotPending)=>{
            if (options.bindI18n && options.bindI18n.indexOf('languageChanging') > -1 && i18nInstance.services.backendConnector.backend && i18nInstance.isLanguageChangingTo && !loadNotPending(i18nInstance.isLanguageChangingTo, ns)) return false;
        }
    });
};
const $a0ed9a691e4afde0$export$be63e0664592e141 = (Component)=>Component.displayName || Component.name || ($a0ed9a691e4afde0$export$844ec244b1367d54(Component) && Component.length > 0 ? Component : 'Unknown');
const $a0ed9a691e4afde0$export$844ec244b1367d54 = (obj)=>typeof obj === 'string';
const $a0ed9a691e4afde0$export$a6cdc56e425d0d0a = (obj)=>typeof obj === 'object' && obj !== null;


const $96842ec49b8e5697$var$matchHtmlEntity = /&(?:amp|#38|lt|#60|gt|#62|apos|#39|quot|#34|nbsp|#160|copy|#169|reg|#174|hellip|#8230|#x2F|#47);/g;
const $96842ec49b8e5697$var$htmlEntities = {
    '&amp;': '&',
    '&#38;': '&',
    '&lt;': '<',
    '&#60;': '<',
    '&gt;': '>',
    '&#62;': '>',
    '&apos;': "'",
    '&#39;': "'",
    '&quot;': '"',
    '&#34;': '"',
    '&nbsp;': ' ',
    '&#160;': ' ',
    '&copy;': "\xa9",
    '&#169;': "\xa9",
    '&reg;': "\xae",
    '&#174;': "\xae",
    '&hellip;': "\u2026",
    '&#8230;': "\u2026",
    '&#x2F;': '/',
    '&#47;': '/'
};
const $96842ec49b8e5697$var$unescapeHtmlEntity = (m)=>$96842ec49b8e5697$var$htmlEntities[m];
const $96842ec49b8e5697$export$e8bacd2802a88316 = (text)=>text.replace($96842ec49b8e5697$var$matchHtmlEntity, $96842ec49b8e5697$var$unescapeHtmlEntity);


let $7e2406c3268cb554$var$defaultOptions = {
    bindI18n: 'languageChanged',
    bindI18nStore: '',
    transEmptyNodeValue: '',
    transSupportBasicHtmlNodes: true,
    transWrapTextNodes: '',
    transKeepBasicHtmlNodesFor: [
        'br',
        'strong',
        'i',
        'p'
    ],
    useSuspense: true,
    unescape: $96842ec49b8e5697$export$e8bacd2802a88316
};
const $7e2406c3268cb554$export$2e2366488d12e20d = function() {
    let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    $7e2406c3268cb554$var$defaultOptions = {
        ...$7e2406c3268cb554$var$defaultOptions,
        ...options
    };
};
const $7e2406c3268cb554$export$212bb2fc580a90a8 = ()=>$7e2406c3268cb554$var$defaultOptions;


let $558998b4ddc9b2a1$var$i18nInstance;
const $558998b4ddc9b2a1$export$a039134f2fc7e0 = (instance)=>{
    $558998b4ddc9b2a1$var$i18nInstance = instance;
};
const $558998b4ddc9b2a1$export$64af334f494c2f47 = ()=>$558998b4ddc9b2a1$var$i18nInstance;


const $452f7dd325f5bb78$var$hasChildren = (node, checkLength)=>{
    if (!node) return false;
    const base = node.props ? node.props.children : node.children;
    if (checkLength) return base.length > 0;
    return !!base;
};
const $452f7dd325f5bb78$var$getChildren = (node)=>{
    if (!node) return [];
    const children = node.props ? node.props.children : node.children;
    return node.props && node.props.i18nIsDynamicList ? $452f7dd325f5bb78$var$getAsArray(children) : children;
};
const $452f7dd325f5bb78$var$hasValidReactChildren = (children)=>Array.isArray(children) && children.every((0, $gJYWc.isValidElement));
const $452f7dd325f5bb78$var$getAsArray = (data)=>Array.isArray(data) ? data : [
        data
    ];
const $452f7dd325f5bb78$var$mergeProps = (source, target)=>{
    const newTarget = {
        ...target
    };
    newTarget.props = Object.assign(source.props, target.props);
    return newTarget;
};
const $452f7dd325f5bb78$export$4f7a36dd898f1267 = (children, i18nOptions)=>{
    if (!children) return '';
    let stringNode = '';
    const childrenArray = $452f7dd325f5bb78$var$getAsArray(children);
    const keepArray = i18nOptions.transSupportBasicHtmlNodes && i18nOptions.transKeepBasicHtmlNodesFor ? i18nOptions.transKeepBasicHtmlNodesFor : [];
    childrenArray.forEach((child, childIndex)=>{
        if ((0, $a0ed9a691e4afde0$export$844ec244b1367d54)(child)) stringNode += `${child}`;
        else if ((0, $gJYWc.isValidElement)(child)) {
            const { props: props, type: type } = child;
            const childPropsCount = Object.keys(props).length;
            const shouldKeepChild = keepArray.indexOf(type) > -1;
            const childChildren = props.children;
            if (!childChildren && shouldKeepChild && !childPropsCount) stringNode += `<${type}/>`;
            else if (!childChildren && (!shouldKeepChild || childPropsCount) || props.i18nIsDynamicList) stringNode += `<${childIndex}></${childIndex}>`;
            else if (shouldKeepChild && childPropsCount === 1 && (0, $a0ed9a691e4afde0$export$844ec244b1367d54)(childChildren)) stringNode += `<${type}>${childChildren}</${type}>`;
            else {
                const content = $452f7dd325f5bb78$export$4f7a36dd898f1267(childChildren, i18nOptions);
                stringNode += `<${childIndex}>${content}</${childIndex}>`;
            }
        } else if (child === null) (0, $a0ed9a691e4afde0$export$c106dd0671a0fc2d)(`Trans: the passed in value is invalid - seems you passed in a null child.`);
        else if ((0, $a0ed9a691e4afde0$export$a6cdc56e425d0d0a)(child)) {
            const { format: format, ...clone } = child;
            const keys = Object.keys(clone);
            if (keys.length === 1) {
                const value = format ? `${keys[0]}, ${format}` : keys[0];
                stringNode += `{{${value}}}`;
            } else (0, $a0ed9a691e4afde0$export$c106dd0671a0fc2d)(`react-i18next: the passed in object contained more than one variable - the object should look like {{ value, format }} where format is optional.`, child);
        } else (0, $a0ed9a691e4afde0$export$c106dd0671a0fc2d)(`Trans: the passed in value is invalid - seems you passed in a variable like {number} - please pass in variables for interpolation as full objects like {{number}}.`, child);
    });
    return stringNode;
};
const $452f7dd325f5bb78$var$renderNodes = (children, targetString, i18n, i18nOptions, combinedTOpts, shouldUnescape)=>{
    if (targetString === '') return [];
    const keepArray = i18nOptions.transKeepBasicHtmlNodesFor || [];
    const emptyChildrenButNeedsHandling = targetString && new RegExp(keepArray.map((keep)=>`<${keep}`).join('|')).test(targetString);
    if (!children && !emptyChildrenButNeedsHandling && !shouldUnescape) return [
        targetString
    ];
    const data = {};
    const getData = (childs)=>{
        const childrenArray = $452f7dd325f5bb78$var$getAsArray(childs);
        childrenArray.forEach((child)=>{
            if ((0, $a0ed9a691e4afde0$export$844ec244b1367d54)(child)) return;
            if ($452f7dd325f5bb78$var$hasChildren(child)) getData($452f7dd325f5bb78$var$getChildren(child));
            else if ((0, $a0ed9a691e4afde0$export$a6cdc56e425d0d0a)(child) && !(0, $gJYWc.isValidElement)(child)) Object.assign(data, child);
        });
    };
    getData(children);
    const ast = (0, $dec7b2a08dd59c4b$export$2e2bcd8739ae039).parse(`<0>${targetString}</0>`);
    const opts = {
        ...data,
        ...combinedTOpts
    };
    const renderInner = (child, node, rootReactNode)=>{
        const childs = $452f7dd325f5bb78$var$getChildren(child);
        const mappedChildren = mapAST(childs, node.children, rootReactNode);
        return $452f7dd325f5bb78$var$hasValidReactChildren(childs) && mappedChildren.length === 0 || child.props && child.props.i18nIsDynamicList ? childs : mappedChildren;
    };
    const pushTranslatedJSX = (child, inner, mem, i, isVoid)=>{
        if (child.dummy) {
            child.children = inner;
            mem.push((0, $gJYWc.cloneElement)(child, {
                key: i
            }, isVoid ? undefined : inner));
        } else mem.push(...(0, $gJYWc.Children).map([
            child
        ], (c)=>{
            const props = {
                ...c.props
            };
            delete props.i18nIsDynamicList;
            return (0, $gJYWc.createElement)(c.type, {
                ...props,
                key: i,
                ref: c.ref
            }, isVoid ? null : inner);
        }));
    };
    const mapAST = (reactNode, astNode, rootReactNode)=>{
        const reactNodes = $452f7dd325f5bb78$var$getAsArray(reactNode);
        const astNodes = $452f7dd325f5bb78$var$getAsArray(astNode);
        return astNodes.reduce((mem, node, i)=>{
            const translationContent = node.children && node.children[0] && node.children[0].content && i18n.services.interpolator.interpolate(node.children[0].content, opts, i18n.language);
            if (node.type === 'tag') {
                let tmp = reactNodes[parseInt(node.name, 10)];
                if (rootReactNode.length === 1 && !tmp) tmp = rootReactNode[0][node.name];
                if (!tmp) tmp = {};
                const child = Object.keys(node.attrs).length !== 0 ? $452f7dd325f5bb78$var$mergeProps({
                    props: node.attrs
                }, tmp) : tmp;
                const isElement = (0, $gJYWc.isValidElement)(child);
                const isValidTranslationWithChildren = isElement && $452f7dd325f5bb78$var$hasChildren(node, true) && !node.voidElement;
                const isEmptyTransWithHTML = emptyChildrenButNeedsHandling && (0, $a0ed9a691e4afde0$export$a6cdc56e425d0d0a)(child) && child.dummy && !isElement;
                const isKnownComponent = (0, $a0ed9a691e4afde0$export$a6cdc56e425d0d0a)(children) && Object.hasOwnProperty.call(children, node.name);
                if ((0, $a0ed9a691e4afde0$export$844ec244b1367d54)(child)) {
                    const value = i18n.services.interpolator.interpolate(child, opts, i18n.language);
                    mem.push(value);
                } else if ($452f7dd325f5bb78$var$hasChildren(child) || isValidTranslationWithChildren) {
                    const inner = renderInner(child, node, rootReactNode);
                    pushTranslatedJSX(child, inner, mem, i);
                } else if (isEmptyTransWithHTML) {
                    const inner = mapAST(reactNodes, node.children, rootReactNode);
                    pushTranslatedJSX(child, inner, mem, i);
                } else if (Number.isNaN(parseFloat(node.name))) {
                    if (isKnownComponent) {
                        const inner = renderInner(child, node, rootReactNode);
                        pushTranslatedJSX(child, inner, mem, i, node.voidElement);
                    } else if (i18nOptions.transSupportBasicHtmlNodes && keepArray.indexOf(node.name) > -1) {
                        if (node.voidElement) mem.push((0, $gJYWc.createElement)(node.name, {
                            key: `${node.name}-${i}`
                        }));
                        else {
                            const inner = mapAST(reactNodes, node.children, rootReactNode);
                            mem.push((0, $gJYWc.createElement)(node.name, {
                                key: `${node.name}-${i}`
                            }, inner));
                        }
                    } else if (node.voidElement) mem.push(`<${node.name} />`);
                    else {
                        const inner = mapAST(reactNodes, node.children, rootReactNode);
                        mem.push(`<${node.name}>${inner}</${node.name}>`);
                    }
                } else if ((0, $a0ed9a691e4afde0$export$a6cdc56e425d0d0a)(child) && !isElement) {
                    const content = node.children[0] ? translationContent : null;
                    if (content) mem.push(content);
                } else pushTranslatedJSX(child, translationContent, mem, i, node.children.length !== 1 || !translationContent);
            } else if (node.type === 'text') {
                const wrapTextNodes = i18nOptions.transWrapTextNodes;
                const content = shouldUnescape ? i18nOptions.unescape(i18n.services.interpolator.interpolate(node.content, opts, i18n.language)) : i18n.services.interpolator.interpolate(node.content, opts, i18n.language);
                if (wrapTextNodes) mem.push((0, $gJYWc.createElement)(wrapTextNodes, {
                    key: `${node.name}-${i}`
                }, content));
                else mem.push(content);
            }
            return mem;
        }, []);
    };
    const result = mapAST([
        {
            dummy: true,
            children: children || []
        }
    ], ast, $452f7dd325f5bb78$var$getAsArray(children || []));
    return $452f7dd325f5bb78$var$getChildren(result[0]);
};
function $452f7dd325f5bb78$export$8d6a9236f2e3f2ce(_ref) {
    let { children: children, count: count, parent: parent, i18nKey: i18nKey, context: context, tOptions: tOptions = {}, values: values, defaults: defaults, components: components, ns: ns, i18n: i18nFromProps, t: tFromProps, shouldUnescape: shouldUnescape, ...additionalProps } = _ref;
    const i18n = i18nFromProps || (0, $558998b4ddc9b2a1$export$64af334f494c2f47)();
    if (!i18n) {
        (0, $a0ed9a691e4afde0$export$5b28268982f175ba)('You will need to pass in an i18next instance by using i18nextReactModule');
        return children;
    }
    const t = tFromProps || i18n.t.bind(i18n) || ((k)=>k);
    const reactI18nextOptions = {
        ...(0, $7e2406c3268cb554$export$212bb2fc580a90a8)(),
        ...i18n.options && i18n.options.react
    };
    let namespaces = ns || t.ns || i18n.options && i18n.options.defaultNS;
    namespaces = (0, $a0ed9a691e4afde0$export$844ec244b1367d54)(namespaces) ? [
        namespaces
    ] : namespaces || [
        'translation'
    ];
    const nodeAsString = $452f7dd325f5bb78$export$4f7a36dd898f1267(children, reactI18nextOptions);
    const defaultValue = defaults || nodeAsString || reactI18nextOptions.transEmptyNodeValue || i18nKey;
    const { hashTransKey: hashTransKey } = reactI18nextOptions;
    const key = i18nKey || (hashTransKey ? hashTransKey(nodeAsString || defaultValue) : nodeAsString || defaultValue);
    if (i18n.options && i18n.options.interpolation && i18n.options.interpolation.defaultVariables) values = values && Object.keys(values).length > 0 ? {
        ...values,
        ...i18n.options.interpolation.defaultVariables
    } : {
        ...i18n.options.interpolation.defaultVariables
    };
    const interpolationOverride = values || count !== undefined || !children ? tOptions.interpolation : {
        interpolation: {
            ...tOptions.interpolation,
            prefix: '#$?',
            suffix: '?$#'
        }
    };
    const combinedTOpts = {
        ...tOptions,
        context: context || tOptions.context,
        count: count,
        ...values,
        ...interpolationOverride,
        defaultValue: defaultValue,
        ns: namespaces
    };
    const translation = key ? t(key, combinedTOpts) : defaultValue;
    if (components) Object.keys(components).forEach((c)=>{
        const comp = components[c];
        if (typeof comp.type === 'function' || !comp.props || !comp.props.children || translation.indexOf(`${c}/>`) < 0 && translation.indexOf(`${c} />`) < 0) return;
        function Componentized() {
            return (0, $gJYWc.createElement)((0, $gJYWc.Fragment), null, comp);
        }
        components[c] = (0, $gJYWc.createElement)(Componentized);
    });
    const content = $452f7dd325f5bb78$var$renderNodes(components || children, translation, i18n, reactI18nextOptions, combinedTOpts, shouldUnescape);
    const useAsParent = parent !== undefined ? parent : reactI18nextOptions.defaultTransParent;
    return useAsParent ? (0, $gJYWc.createElement)(useAsParent, additionalProps, content) : content;
}


function $9ba0ae6a89e01306$export$71511d61b312f219(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}



var $gJYWc = parcelRequire("gJYWc");




const $1f9e801d6ace9094$export$ae7e14d40d89f296 = {
    type: '3rdParty',
    init (instance) {
        (0, $7e2406c3268cb554$export$2e2366488d12e20d)(instance.options.react);
        (0, $558998b4ddc9b2a1$export$a039134f2fc7e0)(instance);
    }
};


const $1c25a8262645e529$export$5603ab5ced17ce64 = (0, $gJYWc.createContext)();
class $1c25a8262645e529$export$ea171b67e3820290 {
    addUsedNamespaces(namespaces) {
        namespaces.forEach((ns)=>{
            if (!this.usedNamespaces[ns]) this.usedNamespaces[ns] = true;
        });
    }
    constructor(){
        (0, $9ba0ae6a89e01306$export$71511d61b312f219)(this, "getUsedNamespaces", ()=>Object.keys(this.usedNamespaces));
        this.usedNamespaces = {};
    }
}
const $1c25a8262645e529$export$30ff0342ccf735a = (ForComponent)=>async (ctx)=>{
        const componentsInitialProps = ForComponent.getInitialProps ? await ForComponent.getInitialProps(ctx) : {};
        const i18nInitialProps = $1c25a8262645e529$export$704200e5d0b9e8f();
        return {
            ...componentsInitialProps,
            ...i18nInitialProps
        };
    };
const $1c25a8262645e529$export$704200e5d0b9e8f = ()=>{
    const i18n = (0, $558998b4ddc9b2a1$export$64af334f494c2f47)();
    const namespaces = i18n.reportNamespaces ? i18n.reportNamespaces.getUsedNamespaces() : [];
    const ret = {};
    const initialI18nStore = {};
    i18n.languages.forEach((l)=>{
        initialI18nStore[l] = {};
        namespaces.forEach((ns)=>{
            initialI18nStore[l][ns] = i18n.getResourceBundle(l, ns) || {};
        });
    });
    ret.initialI18nStore = initialI18nStore;
    ret.initialLanguage = i18n.language;
    return ret;
};


function $b7ad2166008b296a$export$8d6a9236f2e3f2ce(_ref) {
    let { children: children, count: count, parent: parent, i18nKey: i18nKey, context: context, tOptions: tOptions = {}, values: values, defaults: defaults, components: components, ns: ns, i18n: i18nFromProps, t: tFromProps, shouldUnescape: shouldUnescape, ...additionalProps } = _ref;
    const { i18n: i18nFromContext, defaultNS: defaultNSFromContext } = (0, $gJYWc.useContext)((0, $1c25a8262645e529$export$5603ab5ced17ce64)) || {};
    const i18n = i18nFromProps || i18nFromContext || (0, $558998b4ddc9b2a1$export$64af334f494c2f47)();
    const t = tFromProps || i18n && i18n.t.bind(i18n);
    return (0, $452f7dd325f5bb78$export$8d6a9236f2e3f2ce)({
        children: children,
        count: count,
        parent: parent,
        i18nKey: i18nKey,
        context: context,
        tOptions: tOptions,
        values: values,
        defaults: defaults,
        components: components,
        ns: ns || t && t.ns || defaultNSFromContext || i18n && i18n.options && i18n.options.defaultNS,
        i18n: i18n,
        t: tFromProps,
        shouldUnescape: shouldUnescape,
        ...additionalProps
    });
}




var $gJYWc = parcelRequire("gJYWc");


const $980e4b3a97f1ad67$var$usePrevious = (value, ignore)=>{
    const ref = (0, $gJYWc.useRef)();
    (0, $gJYWc.useEffect)(()=>{
        ref.current = ignore ? ref.current : value;
    }, [
        value,
        ignore
    ]);
    return ref.current;
};
const $980e4b3a97f1ad67$var$alwaysNewT = (i18n, language, namespace, keyPrefix)=>i18n.getFixedT(language, namespace, keyPrefix);
const $980e4b3a97f1ad67$var$useMemoizedT = (i18n, language, namespace, keyPrefix)=>(0, $gJYWc.useCallback)($980e4b3a97f1ad67$var$alwaysNewT(i18n, language, namespace, keyPrefix), [
        i18n,
        language,
        namespace,
        keyPrefix
    ]);
const $980e4b3a97f1ad67$export$9fc83ad70ead8663 = function(ns) {
    let props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    const { i18n: i18nFromProps } = props;
    const { i18n: i18nFromContext, defaultNS: defaultNSFromContext } = (0, $gJYWc.useContext)((0, $1c25a8262645e529$export$5603ab5ced17ce64)) || {};
    const i18n = i18nFromProps || i18nFromContext || (0, $558998b4ddc9b2a1$export$64af334f494c2f47)();
    if (i18n && !i18n.reportNamespaces) i18n.reportNamespaces = new (0, $1c25a8262645e529$export$ea171b67e3820290)();
    if (!i18n) {
        (0, $a0ed9a691e4afde0$export$5b28268982f175ba)('You will need to pass in an i18next instance by using initReactI18next');
        const notReadyT = (k, optsOrDefaultValue)=>{
            if ((0, $a0ed9a691e4afde0$export$844ec244b1367d54)(optsOrDefaultValue)) return optsOrDefaultValue;
            if ((0, $a0ed9a691e4afde0$export$a6cdc56e425d0d0a)(optsOrDefaultValue) && (0, $a0ed9a691e4afde0$export$844ec244b1367d54)(optsOrDefaultValue.defaultValue)) return optsOrDefaultValue.defaultValue;
            return Array.isArray(k) ? k[k.length - 1] : k;
        };
        const retNotReady = [
            notReadyT,
            {},
            false
        ];
        retNotReady.t = notReadyT;
        retNotReady.i18n = {};
        retNotReady.ready = false;
        return retNotReady;
    }
    if (i18n.options.react && i18n.options.react.wait !== undefined) (0, $a0ed9a691e4afde0$export$5b28268982f175ba)('It seems you are still using the old wait option, you may migrate to the new useSuspense behaviour.');
    const i18nOptions = {
        ...(0, $7e2406c3268cb554$export$212bb2fc580a90a8)(),
        ...i18n.options.react,
        ...props
    };
    const { useSuspense: useSuspense, keyPrefix: keyPrefix } = i18nOptions;
    let namespaces = ns || defaultNSFromContext || i18n.options && i18n.options.defaultNS;
    namespaces = (0, $a0ed9a691e4afde0$export$844ec244b1367d54)(namespaces) ? [
        namespaces
    ] : namespaces || [
        'translation'
    ];
    if (i18n.reportNamespaces.addUsedNamespaces) i18n.reportNamespaces.addUsedNamespaces(namespaces);
    const ready = (i18n.isInitialized || i18n.initializedStoreOnce) && namespaces.every((n)=>(0, $a0ed9a691e4afde0$export$93d9ee97c1ad3f31)(n, i18n, i18nOptions));
    const memoGetT = $980e4b3a97f1ad67$var$useMemoizedT(i18n, props.lng || null, i18nOptions.nsMode === 'fallback' ? namespaces : namespaces[0], keyPrefix);
    const getT = ()=>memoGetT;
    const getNewT = ()=>$980e4b3a97f1ad67$var$alwaysNewT(i18n, props.lng || null, i18nOptions.nsMode === 'fallback' ? namespaces : namespaces[0], keyPrefix);
    const [t, setT] = (0, $gJYWc.useState)(getT);
    let joinedNS = namespaces.join();
    if (props.lng) joinedNS = `${props.lng}${joinedNS}`;
    const previousJoinedNS = $980e4b3a97f1ad67$var$usePrevious(joinedNS);
    const isMounted = (0, $gJYWc.useRef)(true);
    (0, $gJYWc.useEffect)(()=>{
        const { bindI18n: bindI18n, bindI18nStore: bindI18nStore } = i18nOptions;
        isMounted.current = true;
        if (!ready && !useSuspense) {
            if (props.lng) (0, $a0ed9a691e4afde0$export$8cd7e7a54fa865bc)(i18n, props.lng, namespaces, ()=>{
                if (isMounted.current) setT(getNewT);
            });
            else (0, $a0ed9a691e4afde0$export$83be934b53fff43b)(i18n, namespaces, ()=>{
                if (isMounted.current) setT(getNewT);
            });
        }
        if (ready && previousJoinedNS && previousJoinedNS !== joinedNS && isMounted.current) setT(getNewT);
        const boundReset = ()=>{
            if (isMounted.current) setT(getNewT);
        };
        if (bindI18n && i18n) i18n.on(bindI18n, boundReset);
        if (bindI18nStore && i18n) i18n.store.on(bindI18nStore, boundReset);
        return ()=>{
            isMounted.current = false;
            if (bindI18n && i18n) bindI18n.split(' ').forEach((e)=>i18n.off(e, boundReset));
            if (bindI18nStore && i18n) bindI18nStore.split(' ').forEach((e)=>i18n.store.off(e, boundReset));
        };
    }, [
        i18n,
        joinedNS
    ]);
    (0, $gJYWc.useEffect)(()=>{
        if (isMounted.current && ready) setT(getT);
    }, [
        i18n,
        keyPrefix,
        ready
    ]);
    const ret = [
        t,
        i18n,
        ready
    ];
    ret.t = t;
    ret.i18n = i18n;
    ret.ready = ready;
    if (ready) return ret;
    if (!ready && !useSuspense) return ret;
    throw new Promise((resolve)=>{
        if (props.lng) (0, $a0ed9a691e4afde0$export$8cd7e7a54fa865bc)(i18n, props.lng, namespaces, ()=>resolve());
        else (0, $a0ed9a691e4afde0$export$83be934b53fff43b)(i18n, namespaces, ()=>resolve());
    });
};



var $gJYWc = parcelRequire("gJYWc");


const $fdd19889f9b3ac5d$export$2dcb0053efd21124 = function(ns) {
    let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return function Extend(WrappedComponent) {
        function I18nextWithTranslation(_ref) {
            let { forwardedRef: forwardedRef, ...rest } = _ref;
            const [t, i18n, ready] = (0, $980e4b3a97f1ad67$export$9fc83ad70ead8663)(ns, {
                ...rest,
                keyPrefix: options.keyPrefix
            });
            const passDownProps = {
                ...rest,
                t: t,
                i18n: i18n,
                tReady: ready
            };
            if (options.withRef && forwardedRef) passDownProps.ref = forwardedRef;
            else if (!options.withRef && forwardedRef) passDownProps.forwardedRef = forwardedRef;
            return (0, $gJYWc.createElement)(WrappedComponent, passDownProps);
        }
        I18nextWithTranslation.displayName = `withI18nextTranslation(${(0, $a0ed9a691e4afde0$export$be63e0664592e141)(WrappedComponent)})`;
        I18nextWithTranslation.WrappedComponent = WrappedComponent;
        const forwardRef = (props, ref)=>(0, $gJYWc.createElement)(I18nextWithTranslation, Object.assign({}, props, {
                forwardedRef: ref
            }));
        return options.withRef ? (0, $gJYWc.forwardRef)(forwardRef) : I18nextWithTranslation;
    };
};



function $556640a9261e5ebc$export$b63289fbda65eed1(props) {
    const { ns: ns, children: children, ...options } = props;
    const [t, i18n, ready] = (0, $980e4b3a97f1ad67$export$9fc83ad70ead8663)(ns, options);
    return children(t, {
        i18n: i18n,
        lng: i18n.language
    }, ready);
}



var $gJYWc = parcelRequire("gJYWc");

function $1b095e731abebe61$export$1325e8699caa160f(_ref) {
    let { i18n: i18n, defaultNS: defaultNS, children: children } = _ref;
    const value = (0, $gJYWc.useMemo)(()=>({
            i18n: i18n,
            defaultNS: defaultNS
        }), [
        i18n,
        defaultNS
    ]);
    return (0, $gJYWc.createElement)((0, $1c25a8262645e529$export$5603ab5ced17ce64).Provider, {
        value: value
    }, children);
}



var $gJYWc = parcelRequire("gJYWc");

var $gJYWc = parcelRequire("gJYWc");

const $08955dc04dc246af$export$3526fb65ade8d8b7 = function(initialI18nStore, initialLanguage) {
    let props = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    const { i18n: i18nFromProps } = props;
    const { i18n: i18nFromContext } = (0, $gJYWc.useContext)((0, $1c25a8262645e529$export$5603ab5ced17ce64)) || {};
    const i18n = i18nFromProps || i18nFromContext || (0, $558998b4ddc9b2a1$export$64af334f494c2f47)();
    if (i18n.options && i18n.options.isClone) return;
    if (initialI18nStore && !i18n.initializedStoreOnce) {
        i18n.services.resourceStore.data = initialI18nStore;
        i18n.options.ns = Object.values(initialI18nStore).reduce((mem, lngResources)=>{
            Object.keys(lngResources).forEach((ns)=>{
                if (mem.indexOf(ns) < 0) mem.push(ns);
            });
            return mem;
        }, i18n.options.ns);
        i18n.initializedStoreOnce = true;
        i18n.isInitialized = true;
    }
    if (initialLanguage && !i18n.initializedLanguageOnce) {
        i18n.changeLanguage(initialLanguage);
        i18n.initializedLanguageOnce = true;
    }
};




const $1e815eede1baee39$export$80dfa519af1c8605 = ()=>function Extend(WrappedComponent) {
        function I18nextWithSSR(_ref) {
            let { initialI18nStore: initialI18nStore, initialLanguage: initialLanguage, ...rest } = _ref;
            (0, $08955dc04dc246af$export$3526fb65ade8d8b7)(initialI18nStore, initialLanguage);
            return (0, $gJYWc.createElement)(WrappedComponent, {
                ...rest
            });
        }
        I18nextWithSSR.getInitialProps = (0, $1c25a8262645e529$export$30ff0342ccf735a)(WrappedComponent);
        I18nextWithSSR.displayName = `withI18nextSSR(${(0, $a0ed9a691e4afde0$export$be63e0664592e141)(WrappedComponent)})`;
        I18nextWithSSR.WrappedComponent = WrappedComponent;
        return I18nextWithSSR;
    };







const $911d74d50e2f7249$export$324d90190a8b822a = ()=>'';
const $911d74d50e2f7249$export$2da9be4cfdb689b1 = ()=>'';
const $911d74d50e2f7249$export$98e628dec113755e = ()=>'';
const $911d74d50e2f7249$export$2e6c959c16ff56b8 = ()=>'';
const $911d74d50e2f7249$export$4e35d5c922a95490 = ()=>'';
const $911d74d50e2f7249$export$720a3b9db04b7a0f = ()=>'';


const $5367a5ae783d4618$var$isString = (obj)=>typeof obj === 'string';
const $5367a5ae783d4618$var$defer = ()=>{
    let res;
    let rej;
    const promise = new Promise((resolve, reject)=>{
        res = resolve;
        rej = reject;
    });
    promise.resolve = res;
    promise.reject = rej;
    return promise;
};
const $5367a5ae783d4618$var$makeString = (object)=>{
    if (object == null) return '';
    return '' + object;
};
const $5367a5ae783d4618$var$copy = (a, s, t)=>{
    a.forEach((m)=>{
        if (s[m]) t[m] = s[m];
    });
};
const $5367a5ae783d4618$var$lastOfPathSeparatorRegExp = /###/g;
const $5367a5ae783d4618$var$cleanKey = (key)=>key && key.indexOf('###') > -1 ? key.replace($5367a5ae783d4618$var$lastOfPathSeparatorRegExp, '.') : key;
const $5367a5ae783d4618$var$canNotTraverseDeeper = (object)=>!object || $5367a5ae783d4618$var$isString(object);
const $5367a5ae783d4618$var$getLastOfPath = (object, path, Empty)=>{
    const stack = !$5367a5ae783d4618$var$isString(path) ? path : path.split('.');
    let stackIndex = 0;
    while(stackIndex < stack.length - 1){
        if ($5367a5ae783d4618$var$canNotTraverseDeeper(object)) return {};
        const key = $5367a5ae783d4618$var$cleanKey(stack[stackIndex]);
        if (!object[key] && Empty) object[key] = new Empty();
        if (Object.prototype.hasOwnProperty.call(object, key)) object = object[key];
        else object = {};
        ++stackIndex;
    }
    if ($5367a5ae783d4618$var$canNotTraverseDeeper(object)) return {};
    return {
        obj: object,
        k: $5367a5ae783d4618$var$cleanKey(stack[stackIndex])
    };
};
const $5367a5ae783d4618$var$setPath = (object, path, newValue)=>{
    const { obj: obj, k: k } = $5367a5ae783d4618$var$getLastOfPath(object, path, Object);
    if (obj !== undefined || path.length === 1) {
        obj[k] = newValue;
        return;
    }
    let e = path[path.length - 1];
    let p = path.slice(0, path.length - 1);
    let last = $5367a5ae783d4618$var$getLastOfPath(object, p, Object);
    while(last.obj === undefined && p.length){
        e = `${p[p.length - 1]}.${e}`;
        p = p.slice(0, p.length - 1);
        last = $5367a5ae783d4618$var$getLastOfPath(object, p, Object);
        if (last && last.obj && typeof last.obj[`${last.k}.${e}`] !== 'undefined') last.obj = undefined;
    }
    last.obj[`${last.k}.${e}`] = newValue;
};
const $5367a5ae783d4618$var$pushPath = (object, path, newValue, concat)=>{
    const { obj: obj, k: k } = $5367a5ae783d4618$var$getLastOfPath(object, path, Object);
    obj[k] = obj[k] || [];
    obj[k].push(newValue);
};
const $5367a5ae783d4618$var$getPath = (object, path)=>{
    const { obj: obj, k: k } = $5367a5ae783d4618$var$getLastOfPath(object, path);
    if (!obj) return undefined;
    return obj[k];
};
const $5367a5ae783d4618$var$getPathWithDefaults = (data, defaultData, key)=>{
    const value = $5367a5ae783d4618$var$getPath(data, key);
    if (value !== undefined) return value;
    return $5367a5ae783d4618$var$getPath(defaultData, key);
};
const $5367a5ae783d4618$var$deepExtend = (target, source, overwrite)=>{
    for(const prop in source)if (prop !== '__proto__' && prop !== 'constructor') {
        if (prop in target) {
            if ($5367a5ae783d4618$var$isString(target[prop]) || target[prop] instanceof String || $5367a5ae783d4618$var$isString(source[prop]) || source[prop] instanceof String) {
                if (overwrite) target[prop] = source[prop];
            } else $5367a5ae783d4618$var$deepExtend(target[prop], source[prop], overwrite);
        } else target[prop] = source[prop];
    }
    return target;
};
const $5367a5ae783d4618$var$regexEscape = (str)=>str.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, '\\$&');
var $5367a5ae783d4618$var$_entityMap = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#39;',
    '/': '&#x2F;'
};
const $5367a5ae783d4618$var$escape = (data)=>{
    if ($5367a5ae783d4618$var$isString(data)) return data.replace(/[&<>"'\/]/g, (s)=>$5367a5ae783d4618$var$_entityMap[s]);
    return data;
};
class $5367a5ae783d4618$var$RegExpCache {
    getRegExp(pattern) {
        const regExpFromCache = this.regExpMap.get(pattern);
        if (regExpFromCache !== undefined) return regExpFromCache;
        const regExpNew = new RegExp(pattern);
        if (this.regExpQueue.length === this.capacity) this.regExpMap.delete(this.regExpQueue.shift());
        this.regExpMap.set(pattern, regExpNew);
        this.regExpQueue.push(pattern);
        return regExpNew;
    }
    constructor(capacity){
        this.capacity = capacity;
        this.regExpMap = new Map();
        this.regExpQueue = [];
    }
}
const $5367a5ae783d4618$var$chars = [
    ' ',
    ',',
    '?',
    '!',
    ';'
];
const $5367a5ae783d4618$var$looksLikeObjectPathRegExpCache = new $5367a5ae783d4618$var$RegExpCache(20);
const $5367a5ae783d4618$var$looksLikeObjectPath = (key, nsSeparator, keySeparator)=>{
    nsSeparator = nsSeparator || '';
    keySeparator = keySeparator || '';
    const possibleChars = $5367a5ae783d4618$var$chars.filter((c)=>nsSeparator.indexOf(c) < 0 && keySeparator.indexOf(c) < 0);
    if (possibleChars.length === 0) return true;
    const r = $5367a5ae783d4618$var$looksLikeObjectPathRegExpCache.getRegExp(`(${possibleChars.map((c)=>c === '?' ? '\\?' : c).join('|')})`);
    let matched = !r.test(key);
    if (!matched) {
        const ki = key.indexOf(keySeparator);
        if (ki > 0 && !r.test(key.substring(0, ki))) matched = true;
    }
    return matched;
};
const $5367a5ae783d4618$var$deepFind = function(obj, path) {
    let keySeparator = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '.';
    if (!obj) return undefined;
    if (obj[path]) return obj[path];
    const tokens = path.split(keySeparator);
    let current = obj;
    for(let i = 0; i < tokens.length;){
        if (!current || typeof current !== 'object') return undefined;
        let next;
        let nextPath = '';
        for(let j = i; j < tokens.length; ++j){
            if (j !== i) nextPath += keySeparator;
            nextPath += tokens[j];
            next = current[nextPath];
            if (next !== undefined) {
                if ([
                    'string',
                    'number',
                    'boolean'
                ].indexOf(typeof next) > -1 && j < tokens.length - 1) continue;
                i += j - i + 1;
                break;
            }
        }
        current = next;
    }
    return current;
};
const $5367a5ae783d4618$var$getCleanedCode = (code)=>code && code.replace('_', '-');
const $5367a5ae783d4618$var$consoleLogger = {
    type: 'logger',
    log (args) {
        this.output('log', args);
    },
    warn (args) {
        this.output('warn', args);
    },
    error (args) {
        this.output('error', args);
    },
    output (type, args) {
        if (console && console[type]) console[type].apply(console, args);
    }
};
class $5367a5ae783d4618$var$Logger {
    init(concreteLogger) {
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        this.prefix = options.prefix || 'i18next:';
        this.logger = concreteLogger || $5367a5ae783d4618$var$consoleLogger;
        this.options = options;
        this.debug = options.debug;
    }
    log() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return this.forward(args, 'log', '', true);
    }
    warn() {
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        return this.forward(args, 'warn', '', true);
    }
    error() {
        for(var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++)args[_key3] = arguments[_key3];
        return this.forward(args, 'error', '');
    }
    deprecate() {
        for(var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++)args[_key4] = arguments[_key4];
        return this.forward(args, 'warn', 'WARNING DEPRECATED: ', true);
    }
    forward(args, lvl, prefix, debugOnly) {
        if (debugOnly && !this.debug) return null;
        if ($5367a5ae783d4618$var$isString(args[0])) args[0] = `${prefix}${this.prefix} ${args[0]}`;
        return this.logger[lvl](args);
    }
    create(moduleName) {
        return new $5367a5ae783d4618$var$Logger(this.logger, {
            prefix: `${this.prefix}:${moduleName}:`,
            ...this.options
        });
    }
    clone(options) {
        options = options || this.options;
        options.prefix = options.prefix || this.prefix;
        return new $5367a5ae783d4618$var$Logger(this.logger, options);
    }
    constructor(concreteLogger){
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        this.init(concreteLogger, options);
    }
}
var $5367a5ae783d4618$var$baseLogger = new $5367a5ae783d4618$var$Logger();
class $5367a5ae783d4618$var$EventEmitter {
    on(events, listener) {
        events.split(' ').forEach((event)=>{
            if (!this.observers[event]) this.observers[event] = new Map();
            const numListeners = this.observers[event].get(listener) || 0;
            this.observers[event].set(listener, numListeners + 1);
        });
        return this;
    }
    off(event, listener) {
        if (!this.observers[event]) return;
        if (!listener) {
            delete this.observers[event];
            return;
        }
        this.observers[event].delete(listener);
    }
    emit(event) {
        for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
        if (this.observers[event]) {
            const cloned = Array.from(this.observers[event].entries());
            cloned.forEach((_ref)=>{
                let [observer, numTimesAdded] = _ref;
                for(let i = 0; i < numTimesAdded; i++)observer(...args);
            });
        }
        if (this.observers['*']) {
            const cloned = Array.from(this.observers['*'].entries());
            cloned.forEach((_ref2)=>{
                let [observer, numTimesAdded] = _ref2;
                for(let i = 0; i < numTimesAdded; i++)observer.apply(observer, [
                    event,
                    ...args
                ]);
            });
        }
    }
    constructor(){
        this.observers = {};
    }
}
class $5367a5ae783d4618$var$ResourceStore extends $5367a5ae783d4618$var$EventEmitter {
    addNamespaces(ns) {
        if (this.options.ns.indexOf(ns) < 0) this.options.ns.push(ns);
    }
    removeNamespaces(ns) {
        const index = this.options.ns.indexOf(ns);
        if (index > -1) this.options.ns.splice(index, 1);
    }
    getResource(lng, ns, key) {
        let options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
        const keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;
        const ignoreJSONStructure = options.ignoreJSONStructure !== undefined ? options.ignoreJSONStructure : this.options.ignoreJSONStructure;
        let path;
        if (lng.indexOf('.') > -1) path = lng.split('.');
        else {
            path = [
                lng,
                ns
            ];
            if (key) {
                if (Array.isArray(key)) path.push(...key);
                else if ($5367a5ae783d4618$var$isString(key) && keySeparator) path.push(...key.split(keySeparator));
                else path.push(key);
            }
        }
        const result = $5367a5ae783d4618$var$getPath(this.data, path);
        if (!result && !ns && !key && lng.indexOf('.') > -1) {
            lng = path[0];
            ns = path[1];
            key = path.slice(2).join('.');
        }
        if (result || !ignoreJSONStructure || !$5367a5ae783d4618$var$isString(key)) return result;
        return $5367a5ae783d4618$var$deepFind(this.data && this.data[lng] && this.data[lng][ns], key, keySeparator);
    }
    addResource(lng, ns, key, value) {
        let options = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {
            silent: false
        };
        const keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;
        let path = [
            lng,
            ns
        ];
        if (key) path = path.concat(keySeparator ? key.split(keySeparator) : key);
        if (lng.indexOf('.') > -1) {
            path = lng.split('.');
            value = ns;
            ns = path[1];
        }
        this.addNamespaces(ns);
        $5367a5ae783d4618$var$setPath(this.data, path, value);
        if (!options.silent) this.emit('added', lng, ns, key, value);
    }
    addResources(lng, ns, resources) {
        let options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {
            silent: false
        };
        for(const m in resources)if ($5367a5ae783d4618$var$isString(resources[m]) || Array.isArray(resources[m])) this.addResource(lng, ns, m, resources[m], {
            silent: true
        });
        if (!options.silent) this.emit('added', lng, ns, resources);
    }
    addResourceBundle(lng, ns, resources, deep, overwrite) {
        let options = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {
            silent: false,
            skipCopy: false
        };
        let path = [
            lng,
            ns
        ];
        if (lng.indexOf('.') > -1) {
            path = lng.split('.');
            deep = resources;
            resources = ns;
            ns = path[1];
        }
        this.addNamespaces(ns);
        let pack = $5367a5ae783d4618$var$getPath(this.data, path) || {};
        if (!options.skipCopy) resources = JSON.parse(JSON.stringify(resources));
        if (deep) $5367a5ae783d4618$var$deepExtend(pack, resources, overwrite);
        else pack = {
            ...pack,
            ...resources
        };
        $5367a5ae783d4618$var$setPath(this.data, path, pack);
        if (!options.silent) this.emit('added', lng, ns, resources);
    }
    removeResourceBundle(lng, ns) {
        if (this.hasResourceBundle(lng, ns)) delete this.data[lng][ns];
        this.removeNamespaces(ns);
        this.emit('removed', lng, ns);
    }
    hasResourceBundle(lng, ns) {
        return this.getResource(lng, ns) !== undefined;
    }
    getResourceBundle(lng, ns) {
        if (!ns) ns = this.options.defaultNS;
        if (this.options.compatibilityAPI === 'v1') return {
            ...this.getResource(lng, ns)
        };
        return this.getResource(lng, ns);
    }
    getDataByLanguage(lng) {
        return this.data[lng];
    }
    hasLanguageSomeTranslations(lng) {
        const data = this.getDataByLanguage(lng);
        const n = data && Object.keys(data) || [];
        return !!n.find((v)=>data[v] && Object.keys(data[v]).length > 0);
    }
    toJSON() {
        return this.data;
    }
    constructor(data){
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
            ns: [
                'translation'
            ],
            defaultNS: 'translation'
        };
        super();
        this.data = data || {};
        this.options = options;
        if (this.options.keySeparator === undefined) this.options.keySeparator = '.';
        if (this.options.ignoreJSONStructure === undefined) this.options.ignoreJSONStructure = true;
    }
}
var $5367a5ae783d4618$var$postProcessor = {
    processors: {},
    addPostProcessor (module) {
        this.processors[module.name] = module;
    },
    handle (processors, value, key, options, translator) {
        processors.forEach((processor)=>{
            if (this.processors[processor]) value = this.processors[processor].process(value, key, options, translator);
        });
        return value;
    }
};
const $5367a5ae783d4618$var$checkedLoadedFor = {};
class $5367a5ae783d4618$var$Translator extends $5367a5ae783d4618$var$EventEmitter {
    changeLanguage(lng) {
        if (lng) this.language = lng;
    }
    exists(key) {
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
            interpolation: {}
        };
        if (key === undefined || key === null) return false;
        const resolved = this.resolve(key, options);
        return resolved && resolved.res !== undefined;
    }
    extractFromKey(key, options) {
        let nsSeparator = options.nsSeparator !== undefined ? options.nsSeparator : this.options.nsSeparator;
        if (nsSeparator === undefined) nsSeparator = ':';
        const keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;
        let namespaces = options.ns || this.options.defaultNS || [];
        const wouldCheckForNsInKey = nsSeparator && key.indexOf(nsSeparator) > -1;
        const seemsNaturalLanguage = !this.options.userDefinedKeySeparator && !options.keySeparator && !this.options.userDefinedNsSeparator && !options.nsSeparator && !$5367a5ae783d4618$var$looksLikeObjectPath(key, nsSeparator, keySeparator);
        if (wouldCheckForNsInKey && !seemsNaturalLanguage) {
            const m = key.match(this.interpolator.nestingRegexp);
            if (m && m.length > 0) return {
                key: key,
                namespaces: $5367a5ae783d4618$var$isString(namespaces) ? [
                    namespaces
                ] : namespaces
            };
            const parts = key.split(nsSeparator);
            if (nsSeparator !== keySeparator || nsSeparator === keySeparator && this.options.ns.indexOf(parts[0]) > -1) namespaces = parts.shift();
            key = parts.join(keySeparator);
        }
        return {
            key: key,
            namespaces: $5367a5ae783d4618$var$isString(namespaces) ? [
                namespaces
            ] : namespaces
        };
    }
    translate(keys, options, lastKey) {
        if (typeof options !== 'object' && this.options.overloadTranslationOptionHandler) options = this.options.overloadTranslationOptionHandler(arguments);
        if (typeof options === 'object') options = {
            ...options
        };
        if (!options) options = {};
        if (keys === undefined || keys === null) return '';
        if (!Array.isArray(keys)) keys = [
            String(keys)
        ];
        const returnDetails = options.returnDetails !== undefined ? options.returnDetails : this.options.returnDetails;
        const keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;
        const { key: key, namespaces: namespaces } = this.extractFromKey(keys[keys.length - 1], options);
        const namespace = namespaces[namespaces.length - 1];
        const lng = options.lng || this.language;
        const appendNamespaceToCIMode = options.appendNamespaceToCIMode || this.options.appendNamespaceToCIMode;
        if (lng && lng.toLowerCase() === 'cimode') {
            if (appendNamespaceToCIMode) {
                const nsSeparator = options.nsSeparator || this.options.nsSeparator;
                if (returnDetails) return {
                    res: `${namespace}${nsSeparator}${key}`,
                    usedKey: key,
                    exactUsedKey: key,
                    usedLng: lng,
                    usedNS: namespace,
                    usedParams: this.getUsedParamsDetails(options)
                };
                return `${namespace}${nsSeparator}${key}`;
            }
            if (returnDetails) return {
                res: key,
                usedKey: key,
                exactUsedKey: key,
                usedLng: lng,
                usedNS: namespace,
                usedParams: this.getUsedParamsDetails(options)
            };
            return key;
        }
        const resolved = this.resolve(keys, options);
        let res = resolved && resolved.res;
        const resUsedKey = resolved && resolved.usedKey || key;
        const resExactUsedKey = resolved && resolved.exactUsedKey || key;
        const resType = Object.prototype.toString.apply(res);
        const noObject = [
            '[object Number]',
            '[object Function]',
            '[object RegExp]'
        ];
        const joinArrays = options.joinArrays !== undefined ? options.joinArrays : this.options.joinArrays;
        const handleAsObjectInI18nFormat = !this.i18nFormat || this.i18nFormat.handleAsObject;
        const handleAsObject = !$5367a5ae783d4618$var$isString(res) && typeof res !== 'boolean' && typeof res !== 'number';
        if (handleAsObjectInI18nFormat && res && handleAsObject && noObject.indexOf(resType) < 0 && !($5367a5ae783d4618$var$isString(joinArrays) && Array.isArray(res))) {
            if (!options.returnObjects && !this.options.returnObjects) {
                if (!this.options.returnedObjectHandler) this.logger.warn('accessing an object - but returnObjects options is not enabled!');
                const r = this.options.returnedObjectHandler ? this.options.returnedObjectHandler(resUsedKey, res, {
                    ...options,
                    ns: namespaces
                }) : `key '${key} (${this.language})' returned an object instead of string.`;
                if (returnDetails) {
                    resolved.res = r;
                    resolved.usedParams = this.getUsedParamsDetails(options);
                    return resolved;
                }
                return r;
            }
            if (keySeparator) {
                const resTypeIsArray = Array.isArray(res);
                const copy = resTypeIsArray ? [] : {};
                const newKeyToUse = resTypeIsArray ? resExactUsedKey : resUsedKey;
                for(const m in res)if (Object.prototype.hasOwnProperty.call(res, m)) {
                    const deepKey = `${newKeyToUse}${keySeparator}${m}`;
                    copy[m] = this.translate(deepKey, {
                        ...options,
                        joinArrays: false,
                        ns: namespaces
                    });
                    if (copy[m] === deepKey) copy[m] = res[m];
                }
                res = copy;
            }
        } else if (handleAsObjectInI18nFormat && $5367a5ae783d4618$var$isString(joinArrays) && Array.isArray(res)) {
            res = res.join(joinArrays);
            if (res) res = this.extendTranslation(res, keys, options, lastKey);
        } else {
            let usedDefault = false;
            let usedKey = false;
            const needsPluralHandling = options.count !== undefined && !$5367a5ae783d4618$var$isString(options.count);
            const hasDefaultValue = $5367a5ae783d4618$var$Translator.hasDefaultValue(options);
            const defaultValueSuffix = needsPluralHandling ? this.pluralResolver.getSuffix(lng, options.count, options) : '';
            const defaultValueSuffixOrdinalFallback = options.ordinal && needsPluralHandling ? this.pluralResolver.getSuffix(lng, options.count, {
                ordinal: false
            }) : '';
            const needsZeroSuffixLookup = needsPluralHandling && !options.ordinal && options.count === 0 && this.pluralResolver.shouldUseIntlApi();
            const defaultValue = needsZeroSuffixLookup && options[`defaultValue${this.options.pluralSeparator}zero`] || options[`defaultValue${defaultValueSuffix}`] || options[`defaultValue${defaultValueSuffixOrdinalFallback}`] || options.defaultValue;
            if (!this.isValidLookup(res) && hasDefaultValue) {
                usedDefault = true;
                res = defaultValue;
            }
            if (!this.isValidLookup(res)) {
                usedKey = true;
                res = key;
            }
            const missingKeyNoValueFallbackToKey = options.missingKeyNoValueFallbackToKey || this.options.missingKeyNoValueFallbackToKey;
            const resForMissing = missingKeyNoValueFallbackToKey && usedKey ? undefined : res;
            const updateMissing = hasDefaultValue && defaultValue !== res && this.options.updateMissing;
            if (usedKey || usedDefault || updateMissing) {
                this.logger.log(updateMissing ? 'updateKey' : 'missingKey', lng, namespace, key, updateMissing ? defaultValue : res);
                if (keySeparator) {
                    const fk = this.resolve(key, {
                        ...options,
                        keySeparator: false
                    });
                    if (fk && fk.res) this.logger.warn('Seems the loaded translations were in flat JSON format instead of nested. Either set keySeparator: false on init or make sure your translations are published in nested format.');
                }
                let lngs = [];
                const fallbackLngs = this.languageUtils.getFallbackCodes(this.options.fallbackLng, options.lng || this.language);
                if (this.options.saveMissingTo === 'fallback' && fallbackLngs && fallbackLngs[0]) for(let i = 0; i < fallbackLngs.length; i++)lngs.push(fallbackLngs[i]);
                else if (this.options.saveMissingTo === 'all') lngs = this.languageUtils.toResolveHierarchy(options.lng || this.language);
                else lngs.push(options.lng || this.language);
                const send = (l, k, specificDefaultValue)=>{
                    const defaultForMissing = hasDefaultValue && specificDefaultValue !== res ? specificDefaultValue : resForMissing;
                    if (this.options.missingKeyHandler) this.options.missingKeyHandler(l, namespace, k, defaultForMissing, updateMissing, options);
                    else if (this.backendConnector && this.backendConnector.saveMissing) this.backendConnector.saveMissing(l, namespace, k, defaultForMissing, updateMissing, options);
                    this.emit('missingKey', l, namespace, k, res);
                };
                if (this.options.saveMissing) {
                    if (this.options.saveMissingPlurals && needsPluralHandling) lngs.forEach((language)=>{
                        const suffixes = this.pluralResolver.getSuffixes(language, options);
                        if (needsZeroSuffixLookup && options[`defaultValue${this.options.pluralSeparator}zero`] && suffixes.indexOf(`${this.options.pluralSeparator}zero`) < 0) suffixes.push(`${this.options.pluralSeparator}zero`);
                        suffixes.forEach((suffix)=>{
                            send([
                                language
                            ], key + suffix, options[`defaultValue${suffix}`] || defaultValue);
                        });
                    });
                    else send(lngs, key, defaultValue);
                }
            }
            res = this.extendTranslation(res, keys, options, resolved, lastKey);
            if (usedKey && res === key && this.options.appendNamespaceToMissingKey) res = `${namespace}:${key}`;
            if ((usedKey || usedDefault) && this.options.parseMissingKeyHandler) {
                if (this.options.compatibilityAPI !== 'v1') res = this.options.parseMissingKeyHandler(this.options.appendNamespaceToMissingKey ? `${namespace}:${key}` : key, usedDefault ? res : undefined);
                else res = this.options.parseMissingKeyHandler(res);
            }
        }
        if (returnDetails) {
            resolved.res = res;
            resolved.usedParams = this.getUsedParamsDetails(options);
            return resolved;
        }
        return res;
    }
    extendTranslation(res, key, options, resolved, lastKey) {
        var _this = this;
        if (this.i18nFormat && this.i18nFormat.parse) res = this.i18nFormat.parse(res, {
            ...this.options.interpolation.defaultVariables,
            ...options
        }, options.lng || this.language || resolved.usedLng, resolved.usedNS, resolved.usedKey, {
            resolved: resolved
        });
        else if (!options.skipInterpolation) {
            if (options.interpolation) this.interpolator.init({
                ...options,
                interpolation: {
                    ...this.options.interpolation,
                    ...options.interpolation
                }
            });
            const skipOnVariables = $5367a5ae783d4618$var$isString(res) && (options && options.interpolation && options.interpolation.skipOnVariables !== undefined ? options.interpolation.skipOnVariables : this.options.interpolation.skipOnVariables);
            let nestBef;
            if (skipOnVariables) {
                const nb = res.match(this.interpolator.nestingRegexp);
                nestBef = nb && nb.length;
            }
            let data = options.replace && !$5367a5ae783d4618$var$isString(options.replace) ? options.replace : options;
            if (this.options.interpolation.defaultVariables) data = {
                ...this.options.interpolation.defaultVariables,
                ...data
            };
            res = this.interpolator.interpolate(res, data, options.lng || this.language || resolved.usedLng, options);
            if (skipOnVariables) {
                const na = res.match(this.interpolator.nestingRegexp);
                const nestAft = na && na.length;
                if (nestBef < nestAft) options.nest = false;
            }
            if (!options.lng && this.options.compatibilityAPI !== 'v1' && resolved && resolved.res) options.lng = this.language || resolved.usedLng;
            if (options.nest !== false) res = this.interpolator.nest(res, function() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                if (lastKey && lastKey[0] === args[0] && !options.context) {
                    _this.logger.warn(`It seems you are nesting recursively key: ${args[0]} in key: ${key[0]}`);
                    return null;
                }
                return _this.translate(...args, key);
            }, options);
            if (options.interpolation) this.interpolator.reset();
        }
        const postProcess = options.postProcess || this.options.postProcess;
        const postProcessorNames = $5367a5ae783d4618$var$isString(postProcess) ? [
            postProcess
        ] : postProcess;
        if (res !== undefined && res !== null && postProcessorNames && postProcessorNames.length && options.applyPostProcessor !== false) res = $5367a5ae783d4618$var$postProcessor.handle(postProcessorNames, res, key, this.options && this.options.postProcessPassResolved ? {
            i18nResolved: {
                ...resolved,
                usedParams: this.getUsedParamsDetails(options)
            },
            ...options
        } : options, this);
        return res;
    }
    resolve(keys) {
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        let found;
        let usedKey;
        let exactUsedKey;
        let usedLng;
        let usedNS;
        if ($5367a5ae783d4618$var$isString(keys)) keys = [
            keys
        ];
        keys.forEach((k)=>{
            if (this.isValidLookup(found)) return;
            const extracted = this.extractFromKey(k, options);
            const key = extracted.key;
            usedKey = key;
            let namespaces = extracted.namespaces;
            if (this.options.fallbackNS) namespaces = namespaces.concat(this.options.fallbackNS);
            const needsPluralHandling = options.count !== undefined && !$5367a5ae783d4618$var$isString(options.count);
            const needsZeroSuffixLookup = needsPluralHandling && !options.ordinal && options.count === 0 && this.pluralResolver.shouldUseIntlApi();
            const needsContextHandling = options.context !== undefined && ($5367a5ae783d4618$var$isString(options.context) || typeof options.context === 'number') && options.context !== '';
            const codes = options.lngs ? options.lngs : this.languageUtils.toResolveHierarchy(options.lng || this.language, options.fallbackLng);
            namespaces.forEach((ns)=>{
                if (this.isValidLookup(found)) return;
                usedNS = ns;
                if (!$5367a5ae783d4618$var$checkedLoadedFor[`${codes[0]}-${ns}`] && this.utils && this.utils.hasLoadedNamespace && !this.utils.hasLoadedNamespace(usedNS)) {
                    $5367a5ae783d4618$var$checkedLoadedFor[`${codes[0]}-${ns}`] = true;
                    this.logger.warn(`key "${usedKey}" for languages "${codes.join(', ')}" won't get resolved as namespace "${usedNS}" was not yet loaded`, 'This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!');
                }
                codes.forEach((code)=>{
                    if (this.isValidLookup(found)) return;
                    usedLng = code;
                    const finalKeys = [
                        key
                    ];
                    if (this.i18nFormat && this.i18nFormat.addLookupKeys) this.i18nFormat.addLookupKeys(finalKeys, key, code, ns, options);
                    else {
                        let pluralSuffix;
                        if (needsPluralHandling) pluralSuffix = this.pluralResolver.getSuffix(code, options.count, options);
                        const zeroSuffix = `${this.options.pluralSeparator}zero`;
                        const ordinalPrefix = `${this.options.pluralSeparator}ordinal${this.options.pluralSeparator}`;
                        if (needsPluralHandling) {
                            finalKeys.push(key + pluralSuffix);
                            if (options.ordinal && pluralSuffix.indexOf(ordinalPrefix) === 0) finalKeys.push(key + pluralSuffix.replace(ordinalPrefix, this.options.pluralSeparator));
                            if (needsZeroSuffixLookup) finalKeys.push(key + zeroSuffix);
                        }
                        if (needsContextHandling) {
                            const contextKey = `${key}${this.options.contextSeparator}${options.context}`;
                            finalKeys.push(contextKey);
                            if (needsPluralHandling) {
                                finalKeys.push(contextKey + pluralSuffix);
                                if (options.ordinal && pluralSuffix.indexOf(ordinalPrefix) === 0) finalKeys.push(contextKey + pluralSuffix.replace(ordinalPrefix, this.options.pluralSeparator));
                                if (needsZeroSuffixLookup) finalKeys.push(contextKey + zeroSuffix);
                            }
                        }
                    }
                    let possibleKey;
                    while(possibleKey = finalKeys.pop())if (!this.isValidLookup(found)) {
                        exactUsedKey = possibleKey;
                        found = this.getResource(code, ns, possibleKey, options);
                    }
                });
            });
        });
        return {
            res: found,
            usedKey: usedKey,
            exactUsedKey: exactUsedKey,
            usedLng: usedLng,
            usedNS: usedNS
        };
    }
    isValidLookup(res) {
        return res !== undefined && !(!this.options.returnNull && res === null) && !(!this.options.returnEmptyString && res === '');
    }
    getResource(code, ns, key) {
        let options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
        if (this.i18nFormat && this.i18nFormat.getResource) return this.i18nFormat.getResource(code, ns, key, options);
        return this.resourceStore.getResource(code, ns, key, options);
    }
    getUsedParamsDetails() {
        let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        const optionsKeys = [
            'defaultValue',
            'ordinal',
            'context',
            'replace',
            'lng',
            'lngs',
            'fallbackLng',
            'ns',
            'keySeparator',
            'nsSeparator',
            'returnObjects',
            'returnDetails',
            'joinArrays',
            'postProcess',
            'interpolation'
        ];
        const useOptionsReplaceForData = options.replace && !$5367a5ae783d4618$var$isString(options.replace);
        let data = useOptionsReplaceForData ? options.replace : options;
        if (useOptionsReplaceForData && typeof options.count !== 'undefined') data.count = options.count;
        if (this.options.interpolation.defaultVariables) data = {
            ...this.options.interpolation.defaultVariables,
            ...data
        };
        if (!useOptionsReplaceForData) {
            data = {
                ...data
            };
            for (const key of optionsKeys)delete data[key];
        }
        return data;
    }
    static hasDefaultValue(options) {
        const prefix = 'defaultValue';
        for(const option in options){
            if (Object.prototype.hasOwnProperty.call(options, option) && prefix === option.substring(0, prefix.length) && undefined !== options[option]) return true;
        }
        return false;
    }
    constructor(services){
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        super();
        $5367a5ae783d4618$var$copy([
            'resourceStore',
            'languageUtils',
            'pluralResolver',
            'interpolator',
            'backendConnector',
            'i18nFormat',
            'utils'
        ], services, this);
        this.options = options;
        if (this.options.keySeparator === undefined) this.options.keySeparator = '.';
        this.logger = $5367a5ae783d4618$var$baseLogger.create('translator');
    }
}
const $5367a5ae783d4618$var$capitalize = (string)=>string.charAt(0).toUpperCase() + string.slice(1);
class $5367a5ae783d4618$var$LanguageUtil {
    getScriptPartFromCode(code) {
        code = $5367a5ae783d4618$var$getCleanedCode(code);
        if (!code || code.indexOf('-') < 0) return null;
        const p = code.split('-');
        if (p.length === 2) return null;
        p.pop();
        if (p[p.length - 1].toLowerCase() === 'x') return null;
        return this.formatLanguageCode(p.join('-'));
    }
    getLanguagePartFromCode(code) {
        code = $5367a5ae783d4618$var$getCleanedCode(code);
        if (!code || code.indexOf('-') < 0) return code;
        const p = code.split('-');
        return this.formatLanguageCode(p[0]);
    }
    formatLanguageCode(code) {
        if ($5367a5ae783d4618$var$isString(code) && code.indexOf('-') > -1) {
            if (typeof Intl !== 'undefined' && typeof Intl.getCanonicalLocales !== 'undefined') try {
                let formattedCode = Intl.getCanonicalLocales(code)[0];
                if (formattedCode && this.options.lowerCaseLng) formattedCode = formattedCode.toLowerCase();
                if (formattedCode) return formattedCode;
            } catch (e) {}
            const specialCases = [
                'hans',
                'hant',
                'latn',
                'cyrl',
                'cans',
                'mong',
                'arab'
            ];
            let p = code.split('-');
            if (this.options.lowerCaseLng) p = p.map((part)=>part.toLowerCase());
            else if (p.length === 2) {
                p[0] = p[0].toLowerCase();
                p[1] = p[1].toUpperCase();
                if (specialCases.indexOf(p[1].toLowerCase()) > -1) p[1] = $5367a5ae783d4618$var$capitalize(p[1].toLowerCase());
            } else if (p.length === 3) {
                p[0] = p[0].toLowerCase();
                if (p[1].length === 2) p[1] = p[1].toUpperCase();
                if (p[0] !== 'sgn' && p[2].length === 2) p[2] = p[2].toUpperCase();
                if (specialCases.indexOf(p[1].toLowerCase()) > -1) p[1] = $5367a5ae783d4618$var$capitalize(p[1].toLowerCase());
                if (specialCases.indexOf(p[2].toLowerCase()) > -1) p[2] = $5367a5ae783d4618$var$capitalize(p[2].toLowerCase());
            }
            return p.join('-');
        }
        return this.options.cleanCode || this.options.lowerCaseLng ? code.toLowerCase() : code;
    }
    isSupportedCode(code) {
        if (this.options.load === 'languageOnly' || this.options.nonExplicitSupportedLngs) code = this.getLanguagePartFromCode(code);
        return !this.supportedLngs || !this.supportedLngs.length || this.supportedLngs.indexOf(code) > -1;
    }
    getBestMatchFromCodes(codes) {
        if (!codes) return null;
        let found;
        codes.forEach((code)=>{
            if (found) return;
            const cleanedLng = this.formatLanguageCode(code);
            if (!this.options.supportedLngs || this.isSupportedCode(cleanedLng)) found = cleanedLng;
        });
        if (!found && this.options.supportedLngs) codes.forEach((code)=>{
            if (found) return;
            const lngOnly = this.getLanguagePartFromCode(code);
            if (this.isSupportedCode(lngOnly)) return found = lngOnly;
            found = this.options.supportedLngs.find((supportedLng)=>{
                if (supportedLng === lngOnly) return supportedLng;
                if (supportedLng.indexOf('-') < 0 && lngOnly.indexOf('-') < 0) return;
                if (supportedLng.indexOf('-') > 0 && lngOnly.indexOf('-') < 0 && supportedLng.substring(0, supportedLng.indexOf('-')) === lngOnly) return supportedLng;
                if (supportedLng.indexOf(lngOnly) === 0 && lngOnly.length > 1) return supportedLng;
            });
        });
        if (!found) found = this.getFallbackCodes(this.options.fallbackLng)[0];
        return found;
    }
    getFallbackCodes(fallbacks, code) {
        if (!fallbacks) return [];
        if (typeof fallbacks === 'function') fallbacks = fallbacks(code);
        if ($5367a5ae783d4618$var$isString(fallbacks)) fallbacks = [
            fallbacks
        ];
        if (Array.isArray(fallbacks)) return fallbacks;
        if (!code) return fallbacks.default || [];
        let found = fallbacks[code];
        if (!found) found = fallbacks[this.getScriptPartFromCode(code)];
        if (!found) found = fallbacks[this.formatLanguageCode(code)];
        if (!found) found = fallbacks[this.getLanguagePartFromCode(code)];
        if (!found) found = fallbacks.default;
        return found || [];
    }
    toResolveHierarchy(code, fallbackCode) {
        const fallbackCodes = this.getFallbackCodes(fallbackCode || this.options.fallbackLng || [], code);
        const codes = [];
        const addCode = (c)=>{
            if (!c) return;
            if (this.isSupportedCode(c)) codes.push(c);
            else this.logger.warn(`rejecting language code not found in supportedLngs: ${c}`);
        };
        if ($5367a5ae783d4618$var$isString(code) && (code.indexOf('-') > -1 || code.indexOf('_') > -1)) {
            if (this.options.load !== 'languageOnly') addCode(this.formatLanguageCode(code));
            if (this.options.load !== 'languageOnly' && this.options.load !== 'currentOnly') addCode(this.getScriptPartFromCode(code));
            if (this.options.load !== 'currentOnly') addCode(this.getLanguagePartFromCode(code));
        } else if ($5367a5ae783d4618$var$isString(code)) addCode(this.formatLanguageCode(code));
        fallbackCodes.forEach((fc)=>{
            if (codes.indexOf(fc) < 0) addCode(this.formatLanguageCode(fc));
        });
        return codes;
    }
    constructor(options){
        this.options = options;
        this.supportedLngs = this.options.supportedLngs || false;
        this.logger = $5367a5ae783d4618$var$baseLogger.create('languageUtils');
    }
}
let $5367a5ae783d4618$var$sets = [
    {
        lngs: [
            'ach',
            'ak',
            'am',
            'arn',
            'br',
            'fil',
            'gun',
            'ln',
            'mfe',
            'mg',
            'mi',
            'oc',
            'pt',
            'pt-BR',
            'tg',
            'tl',
            'ti',
            'tr',
            'uz',
            'wa'
        ],
        nr: [
            1,
            2
        ],
        fc: 1
    },
    {
        lngs: [
            'af',
            'an',
            'ast',
            'az',
            'bg',
            'bn',
            'ca',
            'da',
            'de',
            'dev',
            'el',
            'en',
            'eo',
            'es',
            'et',
            'eu',
            'fi',
            'fo',
            'fur',
            'fy',
            'gl',
            'gu',
            'ha',
            'hi',
            'hu',
            'hy',
            'ia',
            'it',
            'kk',
            'kn',
            'ku',
            'lb',
            'mai',
            'ml',
            'mn',
            'mr',
            'nah',
            'nap',
            'nb',
            'ne',
            'nl',
            'nn',
            'no',
            'nso',
            'pa',
            'pap',
            'pms',
            'ps',
            'pt-PT',
            'rm',
            'sco',
            'se',
            'si',
            'so',
            'son',
            'sq',
            'sv',
            'sw',
            'ta',
            'te',
            'tk',
            'ur',
            'yo'
        ],
        nr: [
            1,
            2
        ],
        fc: 2
    },
    {
        lngs: [
            'ay',
            'bo',
            'cgg',
            'fa',
            'ht',
            'id',
            'ja',
            'jbo',
            'ka',
            'km',
            'ko',
            'ky',
            'lo',
            'ms',
            'sah',
            'su',
            'th',
            'tt',
            'ug',
            'vi',
            'wo',
            'zh'
        ],
        nr: [
            1
        ],
        fc: 3
    },
    {
        lngs: [
            'be',
            'bs',
            'cnr',
            'dz',
            'hr',
            'ru',
            'sr',
            'uk'
        ],
        nr: [
            1,
            2,
            5
        ],
        fc: 4
    },
    {
        lngs: [
            'ar'
        ],
        nr: [
            0,
            1,
            2,
            3,
            11,
            100
        ],
        fc: 5
    },
    {
        lngs: [
            'cs',
            'sk'
        ],
        nr: [
            1,
            2,
            5
        ],
        fc: 6
    },
    {
        lngs: [
            'csb',
            'pl'
        ],
        nr: [
            1,
            2,
            5
        ],
        fc: 7
    },
    {
        lngs: [
            'cy'
        ],
        nr: [
            1,
            2,
            3,
            8
        ],
        fc: 8
    },
    {
        lngs: [
            'fr'
        ],
        nr: [
            1,
            2
        ],
        fc: 9
    },
    {
        lngs: [
            'ga'
        ],
        nr: [
            1,
            2,
            3,
            7,
            11
        ],
        fc: 10
    },
    {
        lngs: [
            'gd'
        ],
        nr: [
            1,
            2,
            3,
            20
        ],
        fc: 11
    },
    {
        lngs: [
            'is'
        ],
        nr: [
            1,
            2
        ],
        fc: 12
    },
    {
        lngs: [
            'jv'
        ],
        nr: [
            0,
            1
        ],
        fc: 13
    },
    {
        lngs: [
            'kw'
        ],
        nr: [
            1,
            2,
            3,
            4
        ],
        fc: 14
    },
    {
        lngs: [
            'lt'
        ],
        nr: [
            1,
            2,
            10
        ],
        fc: 15
    },
    {
        lngs: [
            'lv'
        ],
        nr: [
            1,
            2,
            0
        ],
        fc: 16
    },
    {
        lngs: [
            'mk'
        ],
        nr: [
            1,
            2
        ],
        fc: 17
    },
    {
        lngs: [
            'mnk'
        ],
        nr: [
            0,
            1,
            2
        ],
        fc: 18
    },
    {
        lngs: [
            'mt'
        ],
        nr: [
            1,
            2,
            11,
            20
        ],
        fc: 19
    },
    {
        lngs: [
            'or'
        ],
        nr: [
            2,
            1
        ],
        fc: 2
    },
    {
        lngs: [
            'ro'
        ],
        nr: [
            1,
            2,
            20
        ],
        fc: 20
    },
    {
        lngs: [
            'sl'
        ],
        nr: [
            5,
            1,
            2,
            3
        ],
        fc: 21
    },
    {
        lngs: [
            'he',
            'iw'
        ],
        nr: [
            1,
            2,
            20,
            21
        ],
        fc: 22
    }
];
let $5367a5ae783d4618$var$_rulesPluralsTypes = {
    1: (n)=>Number(n > 1),
    2: (n)=>Number(n != 1),
    3: (n)=>0,
    4: (n)=>Number(n % 10 == 1 && n % 100 != 11 ? 0 : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2),
    5: (n)=>Number(n == 0 ? 0 : n == 1 ? 1 : n == 2 ? 2 : n % 100 >= 3 && n % 100 <= 10 ? 3 : n % 100 >= 11 ? 4 : 5),
    6: (n)=>Number(n == 1 ? 0 : n >= 2 && n <= 4 ? 1 : 2),
    7: (n)=>Number(n == 1 ? 0 : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2),
    8: (n)=>Number(n == 1 ? 0 : n == 2 ? 1 : n != 8 && n != 11 ? 2 : 3),
    9: (n)=>Number(n >= 2),
    10: (n)=>Number(n == 1 ? 0 : n == 2 ? 1 : n < 7 ? 2 : n < 11 ? 3 : 4),
    11: (n)=>Number(n == 1 || n == 11 ? 0 : n == 2 || n == 12 ? 1 : n > 2 && n < 20 ? 2 : 3),
    12: (n)=>Number(n % 10 != 1 || n % 100 == 11),
    13: (n)=>Number(n !== 0),
    14: (n)=>Number(n == 1 ? 0 : n == 2 ? 1 : n == 3 ? 2 : 3),
    15: (n)=>Number(n % 10 == 1 && n % 100 != 11 ? 0 : n % 10 >= 2 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2),
    16: (n)=>Number(n % 10 == 1 && n % 100 != 11 ? 0 : n !== 0 ? 1 : 2),
    17: (n)=>Number(n == 1 || n % 10 == 1 && n % 100 != 11 ? 0 : 1),
    18: (n)=>Number(n == 0 ? 0 : n == 1 ? 1 : 2),
    19: (n)=>Number(n == 1 ? 0 : n == 0 || n % 100 > 1 && n % 100 < 11 ? 1 : n % 100 > 10 && n % 100 < 20 ? 2 : 3),
    20: (n)=>Number(n == 1 ? 0 : n == 0 || n % 100 > 0 && n % 100 < 20 ? 1 : 2),
    21: (n)=>Number(n % 100 == 1 ? 1 : n % 100 == 2 ? 2 : n % 100 == 3 || n % 100 == 4 ? 3 : 0),
    22: (n)=>Number(n == 1 ? 0 : n == 2 ? 1 : (n < 0 || n > 10) && n % 10 == 0 ? 2 : 3)
};
const $5367a5ae783d4618$var$nonIntlVersions = [
    'v1',
    'v2',
    'v3'
];
const $5367a5ae783d4618$var$intlVersions = [
    'v4'
];
const $5367a5ae783d4618$var$suffixesOrder = {
    zero: 0,
    one: 1,
    two: 2,
    few: 3,
    many: 4,
    other: 5
};
const $5367a5ae783d4618$var$createRules = ()=>{
    const rules = {};
    $5367a5ae783d4618$var$sets.forEach((set)=>{
        set.lngs.forEach((l)=>{
            rules[l] = {
                numbers: set.nr,
                plurals: $5367a5ae783d4618$var$_rulesPluralsTypes[set.fc]
            };
        });
    });
    return rules;
};
class $5367a5ae783d4618$var$PluralResolver {
    addRule(lng, obj) {
        this.rules[lng] = obj;
    }
    clearCache() {
        this.pluralRulesCache = {};
    }
    getRule(code) {
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        if (this.shouldUseIntlApi()) {
            const cleanedCode = $5367a5ae783d4618$var$getCleanedCode(code === 'dev' ? 'en' : code);
            const type = options.ordinal ? 'ordinal' : 'cardinal';
            const cacheKey = JSON.stringify({
                cleanedCode: cleanedCode,
                type: type
            });
            if (cacheKey in this.pluralRulesCache) return this.pluralRulesCache[cacheKey];
            let rule;
            try {
                rule = new Intl.PluralRules(cleanedCode, {
                    type: type
                });
            } catch (err) {
                if (!code.match(/-|_/)) return;
                const lngPart = this.languageUtils.getLanguagePartFromCode(code);
                rule = this.getRule(lngPart, options);
            }
            this.pluralRulesCache[cacheKey] = rule;
            return rule;
        }
        return this.rules[code] || this.rules[this.languageUtils.getLanguagePartFromCode(code)];
    }
    needsPlural(code) {
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        const rule = this.getRule(code, options);
        if (this.shouldUseIntlApi()) return rule && rule.resolvedOptions().pluralCategories.length > 1;
        return rule && rule.numbers.length > 1;
    }
    getPluralFormsOfKey(code, key) {
        let options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        return this.getSuffixes(code, options).map((suffix)=>`${key}${suffix}`);
    }
    getSuffixes(code) {
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        const rule = this.getRule(code, options);
        if (!rule) return [];
        if (this.shouldUseIntlApi()) return rule.resolvedOptions().pluralCategories.sort((pluralCategory1, pluralCategory2)=>$5367a5ae783d4618$var$suffixesOrder[pluralCategory1] - $5367a5ae783d4618$var$suffixesOrder[pluralCategory2]).map((pluralCategory)=>`${this.options.prepend}${options.ordinal ? `ordinal${this.options.prepend}` : ''}${pluralCategory}`);
        return rule.numbers.map((number)=>this.getSuffix(code, number, options));
    }
    getSuffix(code, count) {
        let options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        const rule = this.getRule(code, options);
        if (rule) {
            if (this.shouldUseIntlApi()) return `${this.options.prepend}${options.ordinal ? `ordinal${this.options.prepend}` : ''}${rule.select(count)}`;
            return this.getSuffixRetroCompatible(rule, count);
        }
        this.logger.warn(`no plural rule found for: ${code}`);
        return '';
    }
    getSuffixRetroCompatible(rule, count) {
        const idx = rule.noAbs ? rule.plurals(count) : rule.plurals(Math.abs(count));
        let suffix = rule.numbers[idx];
        if (this.options.simplifyPluralSuffix && rule.numbers.length === 2 && rule.numbers[0] === 1) {
            if (suffix === 2) suffix = 'plural';
            else if (suffix === 1) suffix = '';
        }
        const returnSuffix = ()=>this.options.prepend && suffix.toString() ? this.options.prepend + suffix.toString() : suffix.toString();
        if (this.options.compatibilityJSON === 'v1') {
            if (suffix === 1) return '';
            if (typeof suffix === 'number') return `_plural_${suffix.toString()}`;
            return returnSuffix();
        } else if (this.options.compatibilityJSON === 'v2') return returnSuffix();
        else if (this.options.simplifyPluralSuffix && rule.numbers.length === 2 && rule.numbers[0] === 1) return returnSuffix();
        return this.options.prepend && idx.toString() ? this.options.prepend + idx.toString() : idx.toString();
    }
    shouldUseIntlApi() {
        return !$5367a5ae783d4618$var$nonIntlVersions.includes(this.options.compatibilityJSON);
    }
    constructor(languageUtils){
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        this.languageUtils = languageUtils;
        this.options = options;
        this.logger = $5367a5ae783d4618$var$baseLogger.create('pluralResolver');
        if ((!this.options.compatibilityJSON || $5367a5ae783d4618$var$intlVersions.includes(this.options.compatibilityJSON)) && (typeof Intl === 'undefined' || !Intl.PluralRules)) {
            this.options.compatibilityJSON = 'v3';
            this.logger.error('Your environment seems not to be Intl API compatible, use an Intl.PluralRules polyfill. Will fallback to the compatibilityJSON v3 format handling.');
        }
        this.rules = $5367a5ae783d4618$var$createRules();
        this.pluralRulesCache = {};
    }
}
const $5367a5ae783d4618$var$deepFindWithDefaults = function(data, defaultData, key) {
    let keySeparator = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '.';
    let ignoreJSONStructure = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : true;
    let path = $5367a5ae783d4618$var$getPathWithDefaults(data, defaultData, key);
    if (!path && ignoreJSONStructure && $5367a5ae783d4618$var$isString(key)) {
        path = $5367a5ae783d4618$var$deepFind(data, key, keySeparator);
        if (path === undefined) path = $5367a5ae783d4618$var$deepFind(defaultData, key, keySeparator);
    }
    return path;
};
const $5367a5ae783d4618$var$regexSafe = (val)=>val.replace(/\$/g, '$$$$');
class $5367a5ae783d4618$var$Interpolator {
    init() {
        let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        if (!options.interpolation) options.interpolation = {
            escapeValue: true
        };
        const { escape: escape$1, escapeValue: escapeValue, useRawValueToEscape: useRawValueToEscape, prefix: prefix, prefixEscaped: prefixEscaped, suffix: suffix, suffixEscaped: suffixEscaped, formatSeparator: formatSeparator, unescapeSuffix: unescapeSuffix, unescapePrefix: unescapePrefix, nestingPrefix: nestingPrefix, nestingPrefixEscaped: nestingPrefixEscaped, nestingSuffix: nestingSuffix, nestingSuffixEscaped: nestingSuffixEscaped, nestingOptionsSeparator: nestingOptionsSeparator, maxReplaces: maxReplaces, alwaysFormat: alwaysFormat } = options.interpolation;
        this.escape = escape$1 !== undefined ? escape$1 : $5367a5ae783d4618$var$escape;
        this.escapeValue = escapeValue !== undefined ? escapeValue : true;
        this.useRawValueToEscape = useRawValueToEscape !== undefined ? useRawValueToEscape : false;
        this.prefix = prefix ? $5367a5ae783d4618$var$regexEscape(prefix) : prefixEscaped || '{{';
        this.suffix = suffix ? $5367a5ae783d4618$var$regexEscape(suffix) : suffixEscaped || '}}';
        this.formatSeparator = formatSeparator || ',';
        this.unescapePrefix = unescapeSuffix ? '' : unescapePrefix || '-';
        this.unescapeSuffix = this.unescapePrefix ? '' : unescapeSuffix || '';
        this.nestingPrefix = nestingPrefix ? $5367a5ae783d4618$var$regexEscape(nestingPrefix) : nestingPrefixEscaped || $5367a5ae783d4618$var$regexEscape('$t(');
        this.nestingSuffix = nestingSuffix ? $5367a5ae783d4618$var$regexEscape(nestingSuffix) : nestingSuffixEscaped || $5367a5ae783d4618$var$regexEscape(')');
        this.nestingOptionsSeparator = nestingOptionsSeparator || ',';
        this.maxReplaces = maxReplaces || 1000;
        this.alwaysFormat = alwaysFormat !== undefined ? alwaysFormat : false;
        this.resetRegExp();
    }
    reset() {
        if (this.options) this.init(this.options);
    }
    resetRegExp() {
        const getOrResetRegExp = (existingRegExp, pattern)=>{
            if (existingRegExp && existingRegExp.source === pattern) {
                existingRegExp.lastIndex = 0;
                return existingRegExp;
            }
            return new RegExp(pattern, 'g');
        };
        this.regexp = getOrResetRegExp(this.regexp, `${this.prefix}(.+?)${this.suffix}`);
        this.regexpUnescape = getOrResetRegExp(this.regexpUnescape, `${this.prefix}${this.unescapePrefix}(.+?)${this.unescapeSuffix}${this.suffix}`);
        this.nestingRegexp = getOrResetRegExp(this.nestingRegexp, `${this.nestingPrefix}(.+?)${this.nestingSuffix}`);
    }
    interpolate(str, data, lng, options) {
        let match;
        let value;
        let replaces;
        const defaultData = this.options && this.options.interpolation && this.options.interpolation.defaultVariables || {};
        const handleFormat = (key)=>{
            if (key.indexOf(this.formatSeparator) < 0) {
                const path = $5367a5ae783d4618$var$deepFindWithDefaults(data, defaultData, key, this.options.keySeparator, this.options.ignoreJSONStructure);
                return this.alwaysFormat ? this.format(path, undefined, lng, {
                    ...options,
                    ...data,
                    interpolationkey: key
                }) : path;
            }
            const p = key.split(this.formatSeparator);
            const k = p.shift().trim();
            const f = p.join(this.formatSeparator).trim();
            return this.format($5367a5ae783d4618$var$deepFindWithDefaults(data, defaultData, k, this.options.keySeparator, this.options.ignoreJSONStructure), f, lng, {
                ...options,
                ...data,
                interpolationkey: k
            });
        };
        this.resetRegExp();
        const missingInterpolationHandler = options && options.missingInterpolationHandler || this.options.missingInterpolationHandler;
        const skipOnVariables = options && options.interpolation && options.interpolation.skipOnVariables !== undefined ? options.interpolation.skipOnVariables : this.options.interpolation.skipOnVariables;
        const todos = [
            {
                regex: this.regexpUnescape,
                safeValue: (val)=>$5367a5ae783d4618$var$regexSafe(val)
            },
            {
                regex: this.regexp,
                safeValue: (val)=>this.escapeValue ? $5367a5ae783d4618$var$regexSafe(this.escape(val)) : $5367a5ae783d4618$var$regexSafe(val)
            }
        ];
        todos.forEach((todo)=>{
            replaces = 0;
            while(match = todo.regex.exec(str)){
                const matchedVar = match[1].trim();
                value = handleFormat(matchedVar);
                if (value === undefined) {
                    if (typeof missingInterpolationHandler === 'function') {
                        const temp = missingInterpolationHandler(str, match, options);
                        value = $5367a5ae783d4618$var$isString(temp) ? temp : '';
                    } else if (options && Object.prototype.hasOwnProperty.call(options, matchedVar)) value = '';
                    else if (skipOnVariables) {
                        value = match[0];
                        continue;
                    } else {
                        this.logger.warn(`missed to pass in variable ${matchedVar} for interpolating ${str}`);
                        value = '';
                    }
                } else if (!$5367a5ae783d4618$var$isString(value) && !this.useRawValueToEscape) value = $5367a5ae783d4618$var$makeString(value);
                const safeValue = todo.safeValue(value);
                str = str.replace(match[0], safeValue);
                if (skipOnVariables) {
                    todo.regex.lastIndex += value.length;
                    todo.regex.lastIndex -= match[0].length;
                } else todo.regex.lastIndex = 0;
                replaces++;
                if (replaces >= this.maxReplaces) break;
            }
        });
        return str;
    }
    nest(str, fc) {
        let options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        let match;
        let value;
        let clonedOptions;
        const handleHasOptions = (key, inheritedOptions)=>{
            const sep = this.nestingOptionsSeparator;
            if (key.indexOf(sep) < 0) return key;
            const c = key.split(new RegExp(`${sep}[ ]*{`));
            let optionsString = `{${c[1]}`;
            key = c[0];
            optionsString = this.interpolate(optionsString, clonedOptions);
            const matchedSingleQuotes = optionsString.match(/'/g);
            const matchedDoubleQuotes = optionsString.match(/"/g);
            if (matchedSingleQuotes && matchedSingleQuotes.length % 2 === 0 && !matchedDoubleQuotes || matchedDoubleQuotes.length % 2 !== 0) optionsString = optionsString.replace(/'/g, '"');
            try {
                clonedOptions = JSON.parse(optionsString);
                if (inheritedOptions) clonedOptions = {
                    ...inheritedOptions,
                    ...clonedOptions
                };
            } catch (e) {
                this.logger.warn(`failed parsing options string in nesting for key ${key}`, e);
                return `${key}${sep}${optionsString}`;
            }
            if (clonedOptions.defaultValue && clonedOptions.defaultValue.indexOf(this.prefix) > -1) delete clonedOptions.defaultValue;
            return key;
        };
        while(match = this.nestingRegexp.exec(str)){
            let formatters = [];
            clonedOptions = {
                ...options
            };
            clonedOptions = clonedOptions.replace && !$5367a5ae783d4618$var$isString(clonedOptions.replace) ? clonedOptions.replace : clonedOptions;
            clonedOptions.applyPostProcessor = false;
            delete clonedOptions.defaultValue;
            let doReduce = false;
            if (match[0].indexOf(this.formatSeparator) !== -1 && !/{.*}/.test(match[1])) {
                const r = match[1].split(this.formatSeparator).map((elem)=>elem.trim());
                match[1] = r.shift();
                formatters = r;
                doReduce = true;
            }
            value = fc(handleHasOptions.call(this, match[1].trim(), clonedOptions), clonedOptions);
            if (value && match[0] === str && !$5367a5ae783d4618$var$isString(value)) return value;
            if (!$5367a5ae783d4618$var$isString(value)) value = $5367a5ae783d4618$var$makeString(value);
            if (!value) {
                this.logger.warn(`missed to resolve ${match[1]} for nesting ${str}`);
                value = '';
            }
            if (doReduce) value = formatters.reduce((v, f)=>this.format(v, f, options.lng, {
                    ...options,
                    interpolationkey: match[1].trim()
                }), value.trim());
            str = str.replace(match[0], value);
            this.regexp.lastIndex = 0;
        }
        return str;
    }
    constructor(){
        let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        this.logger = $5367a5ae783d4618$var$baseLogger.create('interpolator');
        this.options = options;
        this.format = options.interpolation && options.interpolation.format || ((value)=>value);
        this.init(options);
    }
}
const $5367a5ae783d4618$var$parseFormatStr = (formatStr)=>{
    let formatName = formatStr.toLowerCase().trim();
    const formatOptions = {};
    if (formatStr.indexOf('(') > -1) {
        const p = formatStr.split('(');
        formatName = p[0].toLowerCase().trim();
        const optStr = p[1].substring(0, p[1].length - 1);
        if (formatName === 'currency' && optStr.indexOf(':') < 0) {
            if (!formatOptions.currency) formatOptions.currency = optStr.trim();
        } else if (formatName === 'relativetime' && optStr.indexOf(':') < 0) {
            if (!formatOptions.range) formatOptions.range = optStr.trim();
        } else {
            const opts = optStr.split(';');
            opts.forEach((opt)=>{
                if (opt) {
                    const [key, ...rest] = opt.split(':');
                    const val = rest.join(':').trim().replace(/^'+|'+$/g, '');
                    const trimmedKey = key.trim();
                    if (!formatOptions[trimmedKey]) formatOptions[trimmedKey] = val;
                    if (val === 'false') formatOptions[trimmedKey] = false;
                    if (val === 'true') formatOptions[trimmedKey] = true;
                    if (!isNaN(val)) formatOptions[trimmedKey] = parseInt(val, 10);
                }
            });
        }
    }
    return {
        formatName: formatName,
        formatOptions: formatOptions
    };
};
const $5367a5ae783d4618$var$createCachedFormatter = (fn)=>{
    const cache = {};
    return (val, lng, options)=>{
        let optForCache = options;
        if (options && options.interpolationkey && options.formatParams && options.formatParams[options.interpolationkey] && options[options.interpolationkey]) optForCache = {
            ...optForCache,
            [options.interpolationkey]: undefined
        };
        const key = lng + JSON.stringify(optForCache);
        let formatter = cache[key];
        if (!formatter) {
            formatter = fn($5367a5ae783d4618$var$getCleanedCode(lng), options);
            cache[key] = formatter;
        }
        return formatter(val);
    };
};
class $5367a5ae783d4618$var$Formatter {
    init(services) {
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
            interpolation: {}
        };
        this.formatSeparator = options.interpolation.formatSeparator || ',';
    }
    add(name, fc) {
        this.formats[name.toLowerCase().trim()] = fc;
    }
    addCached(name, fc) {
        this.formats[name.toLowerCase().trim()] = $5367a5ae783d4618$var$createCachedFormatter(fc);
    }
    format(value, format, lng) {
        let options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
        const formats = format.split(this.formatSeparator);
        if (formats.length > 1 && formats[0].indexOf('(') > 1 && formats[0].indexOf(')') < 0 && formats.find((f)=>f.indexOf(')') > -1)) {
            const lastIndex = formats.findIndex((f)=>f.indexOf(')') > -1);
            formats[0] = [
                formats[0],
                ...formats.splice(1, lastIndex)
            ].join(this.formatSeparator);
        }
        const result = formats.reduce((mem, f)=>{
            const { formatName: formatName, formatOptions: formatOptions } = $5367a5ae783d4618$var$parseFormatStr(f);
            if (this.formats[formatName]) {
                let formatted = mem;
                try {
                    const valOptions = options && options.formatParams && options.formatParams[options.interpolationkey] || {};
                    const l = valOptions.locale || valOptions.lng || options.locale || options.lng || lng;
                    formatted = this.formats[formatName](mem, l, {
                        ...formatOptions,
                        ...options,
                        ...valOptions
                    });
                } catch (error) {
                    this.logger.warn(error);
                }
                return formatted;
            } else this.logger.warn(`there was no format function for ${formatName}`);
            return mem;
        }, value);
        return result;
    }
    constructor(){
        let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        this.logger = $5367a5ae783d4618$var$baseLogger.create('formatter');
        this.options = options;
        this.formats = {
            number: $5367a5ae783d4618$var$createCachedFormatter((lng, opt)=>{
                const formatter = new Intl.NumberFormat(lng, {
                    ...opt
                });
                return (val)=>formatter.format(val);
            }),
            currency: $5367a5ae783d4618$var$createCachedFormatter((lng, opt)=>{
                const formatter = new Intl.NumberFormat(lng, {
                    ...opt,
                    style: 'currency'
                });
                return (val)=>formatter.format(val);
            }),
            datetime: $5367a5ae783d4618$var$createCachedFormatter((lng, opt)=>{
                const formatter = new Intl.DateTimeFormat(lng, {
                    ...opt
                });
                return (val)=>formatter.format(val);
            }),
            relativetime: $5367a5ae783d4618$var$createCachedFormatter((lng, opt)=>{
                const formatter = new Intl.RelativeTimeFormat(lng, {
                    ...opt
                });
                return (val)=>formatter.format(val, opt.range || 'day');
            }),
            list: $5367a5ae783d4618$var$createCachedFormatter((lng, opt)=>{
                const formatter = new Intl.ListFormat(lng, {
                    ...opt
                });
                return (val)=>formatter.format(val);
            })
        };
        this.init(options);
    }
}
const $5367a5ae783d4618$var$removePending = (q, name)=>{
    if (q.pending[name] !== undefined) {
        delete q.pending[name];
        q.pendingCount--;
    }
};
class $5367a5ae783d4618$var$Connector extends $5367a5ae783d4618$var$EventEmitter {
    queueLoad(languages, namespaces, options, callback) {
        const toLoad = {};
        const pending = {};
        const toLoadLanguages = {};
        const toLoadNamespaces = {};
        languages.forEach((lng)=>{
            let hasAllNamespaces = true;
            namespaces.forEach((ns)=>{
                const name = `${lng}|${ns}`;
                if (!options.reload && this.store.hasResourceBundle(lng, ns)) this.state[name] = 2;
                else if (this.state[name] < 0) ;
                else if (this.state[name] === 1) {
                    if (pending[name] === undefined) pending[name] = true;
                } else {
                    this.state[name] = 1;
                    hasAllNamespaces = false;
                    if (pending[name] === undefined) pending[name] = true;
                    if (toLoad[name] === undefined) toLoad[name] = true;
                    if (toLoadNamespaces[ns] === undefined) toLoadNamespaces[ns] = true;
                }
            });
            if (!hasAllNamespaces) toLoadLanguages[lng] = true;
        });
        if (Object.keys(toLoad).length || Object.keys(pending).length) this.queue.push({
            pending: pending,
            pendingCount: Object.keys(pending).length,
            loaded: {},
            errors: [],
            callback: callback
        });
        return {
            toLoad: Object.keys(toLoad),
            pending: Object.keys(pending),
            toLoadLanguages: Object.keys(toLoadLanguages),
            toLoadNamespaces: Object.keys(toLoadNamespaces)
        };
    }
    loaded(name, err, data) {
        const s = name.split('|');
        const lng = s[0];
        const ns = s[1];
        if (err) this.emit('failedLoading', lng, ns, err);
        if (!err && data) this.store.addResourceBundle(lng, ns, data, undefined, undefined, {
            skipCopy: true
        });
        this.state[name] = err ? -1 : 2;
        if (err && data) this.state[name] = 0;
        const loaded = {};
        this.queue.forEach((q)=>{
            $5367a5ae783d4618$var$pushPath(q.loaded, [
                lng
            ], ns);
            $5367a5ae783d4618$var$removePending(q, name);
            if (err) q.errors.push(err);
            if (q.pendingCount === 0 && !q.done) {
                Object.keys(q.loaded).forEach((l)=>{
                    if (!loaded[l]) loaded[l] = {};
                    const loadedKeys = q.loaded[l];
                    if (loadedKeys.length) loadedKeys.forEach((n)=>{
                        if (loaded[l][n] === undefined) loaded[l][n] = true;
                    });
                });
                q.done = true;
                if (q.errors.length) q.callback(q.errors);
                else q.callback();
            }
        });
        this.emit('loaded', loaded);
        this.queue = this.queue.filter((q)=>!q.done);
    }
    read(lng, ns, fcName) {
        let tried = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
        let wait = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : this.retryTimeout;
        let callback = arguments.length > 5 ? arguments[5] : undefined;
        if (!lng.length) return callback(null, {});
        if (this.readingCalls >= this.maxParallelReads) {
            this.waitingReads.push({
                lng: lng,
                ns: ns,
                fcName: fcName,
                tried: tried,
                wait: wait,
                callback: callback
            });
            return;
        }
        this.readingCalls++;
        const resolver = (err, data)=>{
            this.readingCalls--;
            if (this.waitingReads.length > 0) {
                const next = this.waitingReads.shift();
                this.read(next.lng, next.ns, next.fcName, next.tried, next.wait, next.callback);
            }
            if (err && data && tried < this.maxRetries) {
                setTimeout(()=>{
                    this.read.call(this, lng, ns, fcName, tried + 1, wait * 2, callback);
                }, wait);
                return;
            }
            callback(err, data);
        };
        const fc = this.backend[fcName].bind(this.backend);
        if (fc.length === 2) {
            try {
                const r = fc(lng, ns);
                if (r && typeof r.then === 'function') r.then((data)=>resolver(null, data)).catch(resolver);
                else resolver(null, r);
            } catch (err) {
                resolver(err);
            }
            return;
        }
        return fc(lng, ns, resolver);
    }
    prepareLoading(languages, namespaces) {
        let options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        let callback = arguments.length > 3 ? arguments[3] : undefined;
        if (!this.backend) {
            this.logger.warn('No backend was added via i18next.use. Will not load resources.');
            return callback && callback();
        }
        if ($5367a5ae783d4618$var$isString(languages)) languages = this.languageUtils.toResolveHierarchy(languages);
        if ($5367a5ae783d4618$var$isString(namespaces)) namespaces = [
            namespaces
        ];
        const toLoad = this.queueLoad(languages, namespaces, options, callback);
        if (!toLoad.toLoad.length) {
            if (!toLoad.pending.length) callback();
            return null;
        }
        toLoad.toLoad.forEach((name)=>{
            this.loadOne(name);
        });
    }
    load(languages, namespaces, callback) {
        this.prepareLoading(languages, namespaces, {}, callback);
    }
    reload(languages, namespaces, callback) {
        this.prepareLoading(languages, namespaces, {
            reload: true
        }, callback);
    }
    loadOne(name) {
        let prefix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
        const s = name.split('|');
        const lng = s[0];
        const ns = s[1];
        this.read(lng, ns, 'read', undefined, undefined, (err, data)=>{
            if (err) this.logger.warn(`${prefix}loading namespace ${ns} for language ${lng} failed`, err);
            if (!err && data) this.logger.log(`${prefix}loaded namespace ${ns} for language ${lng}`, data);
            this.loaded(name, err, data);
        });
    }
    saveMissing(languages, namespace, key, fallbackValue, isUpdate) {
        let options = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};
        let clb = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : ()=>{};
        if (this.services.utils && this.services.utils.hasLoadedNamespace && !this.services.utils.hasLoadedNamespace(namespace)) {
            this.logger.warn(`did not save key "${key}" as the namespace "${namespace}" was not yet loaded`, 'This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!');
            return;
        }
        if (key === undefined || key === null || key === '') return;
        if (this.backend && this.backend.create) {
            const opts = {
                ...options,
                isUpdate: isUpdate
            };
            const fc = this.backend.create.bind(this.backend);
            if (fc.length < 6) try {
                let r;
                if (fc.length === 5) r = fc(languages, namespace, key, fallbackValue, opts);
                else r = fc(languages, namespace, key, fallbackValue);
                if (r && typeof r.then === 'function') r.then((data)=>clb(null, data)).catch(clb);
                else clb(null, r);
            } catch (err) {
                clb(err);
            }
            else fc(languages, namespace, key, fallbackValue, clb, opts);
        }
        if (!languages || !languages[0]) return;
        this.store.addResource(languages[0], namespace, key, fallbackValue);
    }
    constructor(backend, store, services){
        let options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
        super();
        this.backend = backend;
        this.store = store;
        this.services = services;
        this.languageUtils = services.languageUtils;
        this.options = options;
        this.logger = $5367a5ae783d4618$var$baseLogger.create('backendConnector');
        this.waitingReads = [];
        this.maxParallelReads = options.maxParallelReads || 10;
        this.readingCalls = 0;
        this.maxRetries = options.maxRetries >= 0 ? options.maxRetries : 5;
        this.retryTimeout = options.retryTimeout >= 1 ? options.retryTimeout : 350;
        this.state = {};
        this.queue = [];
        if (this.backend && this.backend.init) this.backend.init(services, options.backend, options);
    }
}
const $5367a5ae783d4618$var$get = ()=>({
        debug: false,
        initImmediate: true,
        ns: [
            'translation'
        ],
        defaultNS: [
            'translation'
        ],
        fallbackLng: [
            'dev'
        ],
        fallbackNS: false,
        supportedLngs: false,
        nonExplicitSupportedLngs: false,
        load: 'all',
        preload: false,
        simplifyPluralSuffix: true,
        keySeparator: '.',
        nsSeparator: ':',
        pluralSeparator: '_',
        contextSeparator: '_',
        partialBundledLanguages: false,
        saveMissing: false,
        updateMissing: false,
        saveMissingTo: 'fallback',
        saveMissingPlurals: true,
        missingKeyHandler: false,
        missingInterpolationHandler: false,
        postProcess: false,
        postProcessPassResolved: false,
        returnNull: false,
        returnEmptyString: true,
        returnObjects: false,
        joinArrays: false,
        returnedObjectHandler: false,
        parseMissingKeyHandler: false,
        appendNamespaceToMissingKey: false,
        appendNamespaceToCIMode: false,
        overloadTranslationOptionHandler: (args)=>{
            let ret = {};
            if (typeof args[1] === 'object') ret = args[1];
            if ($5367a5ae783d4618$var$isString(args[1])) ret.defaultValue = args[1];
            if ($5367a5ae783d4618$var$isString(args[2])) ret.tDescription = args[2];
            if (typeof args[2] === 'object' || typeof args[3] === 'object') {
                const options = args[3] || args[2];
                Object.keys(options).forEach((key)=>{
                    ret[key] = options[key];
                });
            }
            return ret;
        },
        interpolation: {
            escapeValue: true,
            format: (value)=>value,
            prefix: '{{',
            suffix: '}}',
            formatSeparator: ',',
            unescapePrefix: '-',
            nestingPrefix: '$t(',
            nestingSuffix: ')',
            nestingOptionsSeparator: ',',
            maxReplaces: 1000,
            skipOnVariables: true
        }
    });
const $5367a5ae783d4618$var$transformOptions = (options)=>{
    if ($5367a5ae783d4618$var$isString(options.ns)) options.ns = [
        options.ns
    ];
    if ($5367a5ae783d4618$var$isString(options.fallbackLng)) options.fallbackLng = [
        options.fallbackLng
    ];
    if ($5367a5ae783d4618$var$isString(options.fallbackNS)) options.fallbackNS = [
        options.fallbackNS
    ];
    if (options.supportedLngs && options.supportedLngs.indexOf('cimode') < 0) options.supportedLngs = options.supportedLngs.concat([
        'cimode'
    ]);
    return options;
};
const $5367a5ae783d4618$var$noop = ()=>{};
const $5367a5ae783d4618$var$bindMemberFunctions = (inst)=>{
    const mems = Object.getOwnPropertyNames(Object.getPrototypeOf(inst));
    mems.forEach((mem)=>{
        if (typeof inst[mem] === 'function') inst[mem] = inst[mem].bind(inst);
    });
};
class $5367a5ae783d4618$var$I18n extends $5367a5ae783d4618$var$EventEmitter {
    init() {
        var _this = this;
        let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        let callback = arguments.length > 1 ? arguments[1] : undefined;
        this.isInitializing = true;
        if (typeof options === 'function') {
            callback = options;
            options = {};
        }
        if (!options.defaultNS && options.defaultNS !== false && options.ns) {
            if ($5367a5ae783d4618$var$isString(options.ns)) options.defaultNS = options.ns;
            else if (options.ns.indexOf('translation') < 0) options.defaultNS = options.ns[0];
        }
        const defOpts = $5367a5ae783d4618$var$get();
        this.options = {
            ...defOpts,
            ...this.options,
            ...$5367a5ae783d4618$var$transformOptions(options)
        };
        if (this.options.compatibilityAPI !== 'v1') this.options.interpolation = {
            ...defOpts.interpolation,
            ...this.options.interpolation
        };
        if (options.keySeparator !== undefined) this.options.userDefinedKeySeparator = options.keySeparator;
        if (options.nsSeparator !== undefined) this.options.userDefinedNsSeparator = options.nsSeparator;
        const createClassOnDemand = (ClassOrObject)=>{
            if (!ClassOrObject) return null;
            if (typeof ClassOrObject === 'function') return new ClassOrObject();
            return ClassOrObject;
        };
        if (!this.options.isClone) {
            if (this.modules.logger) $5367a5ae783d4618$var$baseLogger.init(createClassOnDemand(this.modules.logger), this.options);
            else $5367a5ae783d4618$var$baseLogger.init(null, this.options);
            let formatter;
            if (this.modules.formatter) formatter = this.modules.formatter;
            else if (typeof Intl !== 'undefined') formatter = $5367a5ae783d4618$var$Formatter;
            const lu = new $5367a5ae783d4618$var$LanguageUtil(this.options);
            this.store = new $5367a5ae783d4618$var$ResourceStore(this.options.resources, this.options);
            const s = this.services;
            s.logger = $5367a5ae783d4618$var$baseLogger;
            s.resourceStore = this.store;
            s.languageUtils = lu;
            s.pluralResolver = new $5367a5ae783d4618$var$PluralResolver(lu, {
                prepend: this.options.pluralSeparator,
                compatibilityJSON: this.options.compatibilityJSON,
                simplifyPluralSuffix: this.options.simplifyPluralSuffix
            });
            if (formatter && (!this.options.interpolation.format || this.options.interpolation.format === defOpts.interpolation.format)) {
                s.formatter = createClassOnDemand(formatter);
                s.formatter.init(s, this.options);
                this.options.interpolation.format = s.formatter.format.bind(s.formatter);
            }
            s.interpolator = new $5367a5ae783d4618$var$Interpolator(this.options);
            s.utils = {
                hasLoadedNamespace: this.hasLoadedNamespace.bind(this)
            };
            s.backendConnector = new $5367a5ae783d4618$var$Connector(createClassOnDemand(this.modules.backend), s.resourceStore, s, this.options);
            s.backendConnector.on('*', function(event) {
                for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
                _this.emit(event, ...args);
            });
            if (this.modules.languageDetector) {
                s.languageDetector = createClassOnDemand(this.modules.languageDetector);
                if (s.languageDetector.init) s.languageDetector.init(s, this.options.detection, this.options);
            }
            if (this.modules.i18nFormat) {
                s.i18nFormat = createClassOnDemand(this.modules.i18nFormat);
                if (s.i18nFormat.init) s.i18nFormat.init(this);
            }
            this.translator = new $5367a5ae783d4618$var$Translator(this.services, this.options);
            this.translator.on('*', function(event) {
                for(var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)args[_key2 - 1] = arguments[_key2];
                _this.emit(event, ...args);
            });
            this.modules.external.forEach((m)=>{
                if (m.init) m.init(this);
            });
        }
        this.format = this.options.interpolation.format;
        if (!callback) callback = $5367a5ae783d4618$var$noop;
        if (this.options.fallbackLng && !this.services.languageDetector && !this.options.lng) {
            const codes = this.services.languageUtils.getFallbackCodes(this.options.fallbackLng);
            if (codes.length > 0 && codes[0] !== 'dev') this.options.lng = codes[0];
        }
        if (!this.services.languageDetector && !this.options.lng) this.logger.warn('init: no languageDetector is used and no lng is defined');
        const storeApi = [
            'getResource',
            'hasResourceBundle',
            'getResourceBundle',
            'getDataByLanguage'
        ];
        storeApi.forEach((fcName)=>{
            this[fcName] = function() {
                return _this.store[fcName](...arguments);
            };
        });
        const storeApiChained = [
            'addResource',
            'addResources',
            'addResourceBundle',
            'removeResourceBundle'
        ];
        storeApiChained.forEach((fcName)=>{
            this[fcName] = function() {
                _this.store[fcName](...arguments);
                return _this;
            };
        });
        const deferred = $5367a5ae783d4618$var$defer();
        const load = ()=>{
            const finish = (err, t)=>{
                this.isInitializing = false;
                if (this.isInitialized && !this.initializedStoreOnce) this.logger.warn('init: i18next is already initialized. You should call init just once!');
                this.isInitialized = true;
                if (!this.options.isClone) this.logger.log('initialized', this.options);
                this.emit('initialized', this.options);
                deferred.resolve(t);
                callback(err, t);
            };
            if (this.languages && this.options.compatibilityAPI !== 'v1' && !this.isInitialized) return finish(null, this.t.bind(this));
            this.changeLanguage(this.options.lng, finish);
        };
        if (this.options.resources || !this.options.initImmediate) load();
        else setTimeout(load, 0);
        return deferred;
    }
    loadResources(language) {
        let callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $5367a5ae783d4618$var$noop;
        let usedCallback = callback;
        const usedLng = $5367a5ae783d4618$var$isString(language) ? language : this.language;
        if (typeof language === 'function') usedCallback = language;
        if (!this.options.resources || this.options.partialBundledLanguages) {
            if (usedLng && usedLng.toLowerCase() === 'cimode' && (!this.options.preload || this.options.preload.length === 0)) return usedCallback();
            const toLoad = [];
            const append = (lng)=>{
                if (!lng) return;
                if (lng === 'cimode') return;
                const lngs = this.services.languageUtils.toResolveHierarchy(lng);
                lngs.forEach((l)=>{
                    if (l === 'cimode') return;
                    if (toLoad.indexOf(l) < 0) toLoad.push(l);
                });
            };
            if (!usedLng) {
                const fallbacks = this.services.languageUtils.getFallbackCodes(this.options.fallbackLng);
                fallbacks.forEach((l)=>append(l));
            } else append(usedLng);
            if (this.options.preload) this.options.preload.forEach((l)=>append(l));
            this.services.backendConnector.load(toLoad, this.options.ns, (e)=>{
                if (!e && !this.resolvedLanguage && this.language) this.setResolvedLanguage(this.language);
                usedCallback(e);
            });
        } else usedCallback(null);
    }
    reloadResources(lngs, ns, callback) {
        const deferred = $5367a5ae783d4618$var$defer();
        if (typeof lngs === 'function') {
            callback = lngs;
            lngs = undefined;
        }
        if (typeof ns === 'function') {
            callback = ns;
            ns = undefined;
        }
        if (!lngs) lngs = this.languages;
        if (!ns) ns = this.options.ns;
        if (!callback) callback = $5367a5ae783d4618$var$noop;
        this.services.backendConnector.reload(lngs, ns, (err)=>{
            deferred.resolve();
            callback(err);
        });
        return deferred;
    }
    use(module) {
        if (!module) throw new Error('You are passing an undefined module! Please check the object you are passing to i18next.use()');
        if (!module.type) throw new Error('You are passing a wrong module! Please check the object you are passing to i18next.use()');
        if (module.type === 'backend') this.modules.backend = module;
        if (module.type === 'logger' || module.log && module.warn && module.error) this.modules.logger = module;
        if (module.type === 'languageDetector') this.modules.languageDetector = module;
        if (module.type === 'i18nFormat') this.modules.i18nFormat = module;
        if (module.type === 'postProcessor') $5367a5ae783d4618$var$postProcessor.addPostProcessor(module);
        if (module.type === 'formatter') this.modules.formatter = module;
        if (module.type === '3rdParty') this.modules.external.push(module);
        return this;
    }
    setResolvedLanguage(l) {
        if (!l || !this.languages) return;
        if ([
            'cimode',
            'dev'
        ].indexOf(l) > -1) return;
        for(let li = 0; li < this.languages.length; li++){
            const lngInLngs = this.languages[li];
            if ([
                'cimode',
                'dev'
            ].indexOf(lngInLngs) > -1) continue;
            if (this.store.hasLanguageSomeTranslations(lngInLngs)) {
                this.resolvedLanguage = lngInLngs;
                break;
            }
        }
    }
    changeLanguage(lng, callback) {
        var _this2 = this;
        this.isLanguageChangingTo = lng;
        const deferred = $5367a5ae783d4618$var$defer();
        this.emit('languageChanging', lng);
        const setLngProps = (l)=>{
            this.language = l;
            this.languages = this.services.languageUtils.toResolveHierarchy(l);
            this.resolvedLanguage = undefined;
            this.setResolvedLanguage(l);
        };
        const done = (err, l)=>{
            if (l) {
                setLngProps(l);
                this.translator.changeLanguage(l);
                this.isLanguageChangingTo = undefined;
                this.emit('languageChanged', l);
                this.logger.log('languageChanged', l);
            } else this.isLanguageChangingTo = undefined;
            deferred.resolve(function() {
                return _this2.t(...arguments);
            });
            if (callback) callback(err, function() {
                return _this2.t(...arguments);
            });
        };
        const setLng = (lngs)=>{
            if (!lng && !lngs && this.services.languageDetector) lngs = [];
            const l = $5367a5ae783d4618$var$isString(lngs) ? lngs : this.services.languageUtils.getBestMatchFromCodes(lngs);
            if (l) {
                if (!this.language) setLngProps(l);
                if (!this.translator.language) this.translator.changeLanguage(l);
                if (this.services.languageDetector && this.services.languageDetector.cacheUserLanguage) this.services.languageDetector.cacheUserLanguage(l);
            }
            this.loadResources(l, (err)=>{
                done(err, l);
            });
        };
        if (!lng && this.services.languageDetector && !this.services.languageDetector.async) setLng(this.services.languageDetector.detect());
        else if (!lng && this.services.languageDetector && this.services.languageDetector.async) {
            if (this.services.languageDetector.detect.length === 0) this.services.languageDetector.detect().then(setLng);
            else this.services.languageDetector.detect(setLng);
        } else setLng(lng);
        return deferred;
    }
    getFixedT(lng, ns, keyPrefix) {
        var _this3 = this;
        const fixedT = function(key, opts) {
            let options;
            if (typeof opts !== 'object') {
                for(var _len3 = arguments.length, rest = new Array(_len3 > 2 ? _len3 - 2 : 0), _key3 = 2; _key3 < _len3; _key3++)rest[_key3 - 2] = arguments[_key3];
                options = _this3.options.overloadTranslationOptionHandler([
                    key,
                    opts
                ].concat(rest));
            } else options = {
                ...opts
            };
            options.lng = options.lng || fixedT.lng;
            options.lngs = options.lngs || fixedT.lngs;
            options.ns = options.ns || fixedT.ns;
            if (options.keyPrefix !== '') options.keyPrefix = options.keyPrefix || keyPrefix || fixedT.keyPrefix;
            const keySeparator = _this3.options.keySeparator || '.';
            let resultKey;
            if (options.keyPrefix && Array.isArray(key)) resultKey = key.map((k)=>`${options.keyPrefix}${keySeparator}${k}`);
            else resultKey = options.keyPrefix ? `${options.keyPrefix}${keySeparator}${key}` : key;
            return _this3.t(resultKey, options);
        };
        if ($5367a5ae783d4618$var$isString(lng)) fixedT.lng = lng;
        else fixedT.lngs = lng;
        fixedT.ns = ns;
        fixedT.keyPrefix = keyPrefix;
        return fixedT;
    }
    t() {
        return this.translator && this.translator.translate(...arguments);
    }
    exists() {
        return this.translator && this.translator.exists(...arguments);
    }
    setDefaultNamespace(ns) {
        this.options.defaultNS = ns;
    }
    hasLoadedNamespace(ns) {
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        if (!this.isInitialized) {
            this.logger.warn('hasLoadedNamespace: i18next was not initialized', this.languages);
            return false;
        }
        if (!this.languages || !this.languages.length) {
            this.logger.warn('hasLoadedNamespace: i18n.languages were undefined or empty', this.languages);
            return false;
        }
        const lng = options.lng || this.resolvedLanguage || this.languages[0];
        const fallbackLng = this.options ? this.options.fallbackLng : false;
        const lastLng = this.languages[this.languages.length - 1];
        if (lng.toLowerCase() === 'cimode') return true;
        const loadNotPending = (l, n)=>{
            const loadState = this.services.backendConnector.state[`${l}|${n}`];
            return loadState === -1 || loadState === 0 || loadState === 2;
        };
        if (options.precheck) {
            const preResult = options.precheck(this, loadNotPending);
            if (preResult !== undefined) return preResult;
        }
        if (this.hasResourceBundle(lng, ns)) return true;
        if (!this.services.backendConnector.backend || this.options.resources && !this.options.partialBundledLanguages) return true;
        if (loadNotPending(lng, ns) && (!fallbackLng || loadNotPending(lastLng, ns))) return true;
        return false;
    }
    loadNamespaces(ns, callback) {
        const deferred = $5367a5ae783d4618$var$defer();
        if (!this.options.ns) {
            if (callback) callback();
            return Promise.resolve();
        }
        if ($5367a5ae783d4618$var$isString(ns)) ns = [
            ns
        ];
        ns.forEach((n)=>{
            if (this.options.ns.indexOf(n) < 0) this.options.ns.push(n);
        });
        this.loadResources((err)=>{
            deferred.resolve();
            if (callback) callback(err);
        });
        return deferred;
    }
    loadLanguages(lngs, callback) {
        const deferred = $5367a5ae783d4618$var$defer();
        if ($5367a5ae783d4618$var$isString(lngs)) lngs = [
            lngs
        ];
        const preloaded = this.options.preload || [];
        const newLngs = lngs.filter((lng)=>preloaded.indexOf(lng) < 0 && this.services.languageUtils.isSupportedCode(lng));
        if (!newLngs.length) {
            if (callback) callback();
            return Promise.resolve();
        }
        this.options.preload = preloaded.concat(newLngs);
        this.loadResources((err)=>{
            deferred.resolve();
            if (callback) callback(err);
        });
        return deferred;
    }
    dir(lng) {
        if (!lng) lng = this.resolvedLanguage || (this.languages && this.languages.length > 0 ? this.languages[0] : this.language);
        if (!lng) return 'rtl';
        const rtlLngs = [
            'ar',
            'shu',
            'sqr',
            'ssh',
            'xaa',
            'yhd',
            'yud',
            'aao',
            'abh',
            'abv',
            'acm',
            'acq',
            'acw',
            'acx',
            'acy',
            'adf',
            'ads',
            'aeb',
            'aec',
            'afb',
            'ajp',
            'apc',
            'apd',
            'arb',
            'arq',
            'ars',
            'ary',
            'arz',
            'auz',
            'avl',
            'ayh',
            'ayl',
            'ayn',
            'ayp',
            'bbz',
            'pga',
            'he',
            'iw',
            'ps',
            'pbt',
            'pbu',
            'pst',
            'prp',
            'prd',
            'ug',
            'ur',
            'ydd',
            'yds',
            'yih',
            'ji',
            'yi',
            'hbo',
            'men',
            'xmn',
            'fa',
            'jpr',
            'peo',
            'pes',
            'prs',
            'dv',
            'sam',
            'ckb'
        ];
        const languageUtils = this.services && this.services.languageUtils || new $5367a5ae783d4618$var$LanguageUtil($5367a5ae783d4618$var$get());
        return rtlLngs.indexOf(languageUtils.getLanguagePartFromCode(lng)) > -1 || lng.toLowerCase().indexOf('-arab') > 1 ? 'rtl' : 'ltr';
    }
    static createInstance() {
        let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        let callback = arguments.length > 1 ? arguments[1] : undefined;
        return new $5367a5ae783d4618$var$I18n(options, callback);
    }
    cloneInstance() {
        let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        let callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $5367a5ae783d4618$var$noop;
        const forkResourceStore = options.forkResourceStore;
        if (forkResourceStore) delete options.forkResourceStore;
        const mergedOptions = {
            ...this.options,
            ...options,
            isClone: true
        };
        const clone = new $5367a5ae783d4618$var$I18n(mergedOptions);
        if (options.debug !== undefined || options.prefix !== undefined) clone.logger = clone.logger.clone(options);
        const membersToCopy = [
            'store',
            'services',
            'language'
        ];
        membersToCopy.forEach((m)=>{
            clone[m] = this[m];
        });
        clone.services = {
            ...this.services
        };
        clone.services.utils = {
            hasLoadedNamespace: clone.hasLoadedNamespace.bind(clone)
        };
        if (forkResourceStore) {
            clone.store = new $5367a5ae783d4618$var$ResourceStore(this.store.data, mergedOptions);
            clone.services.resourceStore = clone.store;
        }
        clone.translator = new $5367a5ae783d4618$var$Translator(clone.services, mergedOptions);
        clone.translator.on('*', function(event) {
            for(var _len4 = arguments.length, args = new Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++)args[_key4 - 1] = arguments[_key4];
            clone.emit(event, ...args);
        });
        clone.init(mergedOptions, callback);
        clone.translator.options = mergedOptions;
        clone.translator.backendConnector.services.utils = {
            hasLoadedNamespace: clone.hasLoadedNamespace.bind(clone)
        };
        return clone;
    }
    toJSON() {
        return {
            options: this.options,
            store: this.store,
            language: this.language,
            languages: this.languages,
            resolvedLanguage: this.resolvedLanguage
        };
    }
    constructor(){
        let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        let callback = arguments.length > 1 ? arguments[1] : undefined;
        super();
        this.options = $5367a5ae783d4618$var$transformOptions(options);
        this.services = {};
        this.logger = $5367a5ae783d4618$var$baseLogger;
        this.modules = {
            external: []
        };
        $5367a5ae783d4618$var$bindMemberFunctions(this);
        if (callback && !this.isInitialized && !options.isClone) {
            if (!this.options.initImmediate) {
                this.init(options, callback);
                return this;
            }
            setTimeout(()=>{
                this.init(options, callback);
            }, 0);
        }
    }
}
const $5367a5ae783d4618$export$2e2bcd8739ae039 = $5367a5ae783d4618$var$I18n.createInstance();
$5367a5ae783d4618$export$2e2bcd8739ae039.createInstance = $5367a5ae783d4618$var$I18n.createInstance;
const $5367a5ae783d4618$export$99152e8d49ca4e7d = $5367a5ae783d4618$export$2e2bcd8739ae039.createInstance;
const $5367a5ae783d4618$export$147ec2801e896265 = $5367a5ae783d4618$export$2e2bcd8739ae039.dir;
const $5367a5ae783d4618$export$2cd8252107eb640b = $5367a5ae783d4618$export$2e2bcd8739ae039.init;
const $5367a5ae783d4618$export$d3d08d944062d7e = $5367a5ae783d4618$export$2e2bcd8739ae039.loadResources;
const $5367a5ae783d4618$export$a5d9bf5d83fcab09 = $5367a5ae783d4618$export$2e2bcd8739ae039.reloadResources;
const $5367a5ae783d4618$export$1f96ae73734a86cc = $5367a5ae783d4618$export$2e2bcd8739ae039.use;
const $5367a5ae783d4618$export$61465194746e7fd2 = $5367a5ae783d4618$export$2e2bcd8739ae039.changeLanguage;
const $5367a5ae783d4618$export$f90d180fc7da3b3b = $5367a5ae783d4618$export$2e2bcd8739ae039.getFixedT;
const $5367a5ae783d4618$export$625550452a3fa3ec = $5367a5ae783d4618$export$2e2bcd8739ae039.t;
const $5367a5ae783d4618$export$f7e9f41ea797a17 = $5367a5ae783d4618$export$2e2bcd8739ae039.exists;
const $5367a5ae783d4618$export$2b4b218e406d2d00 = $5367a5ae783d4618$export$2e2bcd8739ae039.setDefaultNamespace;
const $5367a5ae783d4618$export$93d9ee97c1ad3f31 = $5367a5ae783d4618$export$2e2bcd8739ae039.hasLoadedNamespace;
const $5367a5ae783d4618$export$83be934b53fff43b = $5367a5ae783d4618$export$2e2bcd8739ae039.loadNamespaces;
const $5367a5ae783d4618$export$8cd7e7a54fa865bc = $5367a5ae783d4618$export$2e2bcd8739ae039.loadLanguages;


function $11f76ce1b556f6c2$export$2e2bcd8739ae039(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}


function $0a0e53ee46edf545$export$2e2bcd8739ae039(o) {
    "@babel/helpers - typeof";
    return $0a0e53ee46edf545$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $0a0e53ee46edf545$export$2e2bcd8739ae039(o);
}



function $23a3af53c0e57961$export$2e2bcd8739ae039(t, r) {
    if ("object" != (0, $0a0e53ee46edf545$export$2e2bcd8739ae039)(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != (0, $0a0e53ee46edf545$export$2e2bcd8739ae039)(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}


function $f819de973bfc92ac$export$2e2bcd8739ae039(t) {
    var i = (0, $23a3af53c0e57961$export$2e2bcd8739ae039)(t, "string");
    return "symbol" == (0, $0a0e53ee46edf545$export$2e2bcd8739ae039)(i) ? i : i + "";
}


function $ff30f649bc95bc11$var$_defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, (0, $f819de973bfc92ac$export$2e2bcd8739ae039)(o.key), o);
    }
}
function $ff30f649bc95bc11$export$2e2bcd8739ae039(e, r, t) {
    return r && $ff30f649bc95bc11$var$_defineProperties(e.prototype, r), t && $ff30f649bc95bc11$var$_defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}


var $6087f953ce026243$var$arr = [];
var $6087f953ce026243$var$each = $6087f953ce026243$var$arr.forEach;
var $6087f953ce026243$var$slice = $6087f953ce026243$var$arr.slice;
function $6087f953ce026243$var$defaults(obj) {
    $6087f953ce026243$var$each.call($6087f953ce026243$var$slice.call(arguments, 1), function(source) {
        if (source) {
            for(var prop in source)if (obj[prop] === undefined) obj[prop] = source[prop];
        }
    });
    return obj;
}
// eslint-disable-next-line no-control-regex
var $6087f953ce026243$var$fieldContentRegExp = /^[\u0009\u0020-\u007e\u0080-\u00ff]+$/;
var $6087f953ce026243$var$serializeCookie = function serializeCookie(name, val, options) {
    var opt = options || {};
    opt.path = opt.path || '/';
    var value = encodeURIComponent(val);
    var str = "".concat(name, "=").concat(value);
    if (opt.maxAge > 0) {
        var maxAge = opt.maxAge - 0;
        if (Number.isNaN(maxAge)) throw new Error('maxAge should be a Number');
        str += "; Max-Age=".concat(Math.floor(maxAge));
    }
    if (opt.domain) {
        if (!$6087f953ce026243$var$fieldContentRegExp.test(opt.domain)) throw new TypeError('option domain is invalid');
        str += "; Domain=".concat(opt.domain);
    }
    if (opt.path) {
        if (!$6087f953ce026243$var$fieldContentRegExp.test(opt.path)) throw new TypeError('option path is invalid');
        str += "; Path=".concat(opt.path);
    }
    if (opt.expires) {
        if (typeof opt.expires.toUTCString !== 'function') throw new TypeError('option expires is invalid');
        str += "; Expires=".concat(opt.expires.toUTCString());
    }
    if (opt.httpOnly) str += '; HttpOnly';
    if (opt.secure) str += '; Secure';
    if (opt.sameSite) {
        var sameSite = typeof opt.sameSite === 'string' ? opt.sameSite.toLowerCase() : opt.sameSite;
        switch(sameSite){
            case true:
                str += '; SameSite=Strict';
                break;
            case 'lax':
                str += '; SameSite=Lax';
                break;
            case 'strict':
                str += '; SameSite=Strict';
                break;
            case 'none':
                str += '; SameSite=None';
                break;
            default:
                throw new TypeError('option sameSite is invalid');
        }
    }
    return str;
};
var $6087f953ce026243$var$cookie = {
    create: function create(name, value, minutes, domain) {
        var cookieOptions = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {
            path: '/',
            sameSite: 'strict'
        };
        if (minutes) {
            cookieOptions.expires = new Date();
            cookieOptions.expires.setTime(cookieOptions.expires.getTime() + minutes * 60000);
        }
        if (domain) cookieOptions.domain = domain;
        document.cookie = $6087f953ce026243$var$serializeCookie(name, encodeURIComponent(value), cookieOptions);
    },
    read: function read(name) {
        var nameEQ = "".concat(name, "=");
        var ca = document.cookie.split(';');
        for(var i = 0; i < ca.length; i++){
            var c = ca[i];
            while(c.charAt(0) === ' ')c = c.substring(1, c.length);
            if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
        }
        return null;
    },
    remove: function remove(name) {
        this.create(name, '', -1);
    }
};
var $6087f953ce026243$var$cookie$1 = {
    name: 'cookie',
    lookup: function lookup(options) {
        var found;
        if (options.lookupCookie && typeof document !== 'undefined') {
            var c = $6087f953ce026243$var$cookie.read(options.lookupCookie);
            if (c) found = c;
        }
        return found;
    },
    cacheUserLanguage: function cacheUserLanguage(lng, options) {
        if (options.lookupCookie && typeof document !== 'undefined') $6087f953ce026243$var$cookie.create(options.lookupCookie, lng, options.cookieMinutes, options.cookieDomain, options.cookieOptions);
    }
};
var $6087f953ce026243$var$querystring = {
    name: 'querystring',
    lookup: function lookup(options) {
        var found;
        if (typeof window !== 'undefined') {
            var search = window.location.search;
            if (!window.location.search && window.location.hash && window.location.hash.indexOf('?') > -1) search = window.location.hash.substring(window.location.hash.indexOf('?'));
            var query = search.substring(1);
            var params = query.split('&');
            for(var i = 0; i < params.length; i++){
                var pos = params[i].indexOf('=');
                if (pos > 0) {
                    var key = params[i].substring(0, pos);
                    if (key === options.lookupQuerystring) found = params[i].substring(pos + 1);
                }
            }
        }
        return found;
    }
};
var $6087f953ce026243$var$hasLocalStorageSupport = null;
var $6087f953ce026243$var$localStorageAvailable = function localStorageAvailable() {
    if ($6087f953ce026243$var$hasLocalStorageSupport !== null) return $6087f953ce026243$var$hasLocalStorageSupport;
    try {
        $6087f953ce026243$var$hasLocalStorageSupport = window !== 'undefined' && window.localStorage !== null;
        var testKey = 'i18next.translate.boo';
        window.localStorage.setItem(testKey, 'foo');
        window.localStorage.removeItem(testKey);
    } catch (e) {
        $6087f953ce026243$var$hasLocalStorageSupport = false;
    }
    return $6087f953ce026243$var$hasLocalStorageSupport;
};
var $6087f953ce026243$var$localStorage = {
    name: 'localStorage',
    lookup: function lookup(options) {
        var found;
        if (options.lookupLocalStorage && $6087f953ce026243$var$localStorageAvailable()) {
            var lng = window.localStorage.getItem(options.lookupLocalStorage);
            if (lng) found = lng;
        }
        return found;
    },
    cacheUserLanguage: function cacheUserLanguage(lng, options) {
        if (options.lookupLocalStorage && $6087f953ce026243$var$localStorageAvailable()) window.localStorage.setItem(options.lookupLocalStorage, lng);
    }
};
var $6087f953ce026243$var$hasSessionStorageSupport = null;
var $6087f953ce026243$var$sessionStorageAvailable = function sessionStorageAvailable() {
    if ($6087f953ce026243$var$hasSessionStorageSupport !== null) return $6087f953ce026243$var$hasSessionStorageSupport;
    try {
        $6087f953ce026243$var$hasSessionStorageSupport = window !== 'undefined' && window.sessionStorage !== null;
        var testKey = 'i18next.translate.boo';
        window.sessionStorage.setItem(testKey, 'foo');
        window.sessionStorage.removeItem(testKey);
    } catch (e) {
        $6087f953ce026243$var$hasSessionStorageSupport = false;
    }
    return $6087f953ce026243$var$hasSessionStorageSupport;
};
var $6087f953ce026243$var$sessionStorage = {
    name: 'sessionStorage',
    lookup: function lookup(options) {
        var found;
        if (options.lookupSessionStorage && $6087f953ce026243$var$sessionStorageAvailable()) {
            var lng = window.sessionStorage.getItem(options.lookupSessionStorage);
            if (lng) found = lng;
        }
        return found;
    },
    cacheUserLanguage: function cacheUserLanguage(lng, options) {
        if (options.lookupSessionStorage && $6087f953ce026243$var$sessionStorageAvailable()) window.sessionStorage.setItem(options.lookupSessionStorage, lng);
    }
};
var $6087f953ce026243$var$navigator$1 = {
    name: 'navigator',
    lookup: function lookup(options) {
        var found = [];
        if (typeof navigator !== 'undefined') {
            if (navigator.languages) // chrome only; not an array, so can't use .push.apply instead of iterating
            for(var i = 0; i < navigator.languages.length; i++)found.push(navigator.languages[i]);
            if (navigator.userLanguage) found.push(navigator.userLanguage);
            if (navigator.language) found.push(navigator.language);
        }
        return found.length > 0 ? found : undefined;
    }
};
var $6087f953ce026243$var$htmlTag = {
    name: 'htmlTag',
    lookup: function lookup(options) {
        var found;
        var htmlTag = options.htmlTag || (typeof document !== 'undefined' ? document.documentElement : null);
        if (htmlTag && typeof htmlTag.getAttribute === 'function') found = htmlTag.getAttribute('lang');
        return found;
    }
};
var $6087f953ce026243$var$path = {
    name: 'path',
    lookup: function lookup(options) {
        var found;
        if (typeof window !== 'undefined') {
            var language = window.location.pathname.match(/\/([a-zA-Z-]*)/g);
            if (language instanceof Array) {
                if (typeof options.lookupFromPathIndex === 'number') {
                    if (typeof language[options.lookupFromPathIndex] !== 'string') return undefined;
                    found = language[options.lookupFromPathIndex].replace('/', '');
                } else found = language[0].replace('/', '');
            }
        }
        return found;
    }
};
var $6087f953ce026243$var$subdomain = {
    name: 'subdomain',
    lookup: function lookup(options) {
        // If given get the subdomain index else 1
        var lookupFromSubdomainIndex = typeof options.lookupFromSubdomainIndex === 'number' ? options.lookupFromSubdomainIndex + 1 : 1;
        // get all matches if window.location. is existing
        // first item of match is the match itself and the second is the first group macht which sould be the first subdomain match
        // is the hostname no public domain get the or option of localhost
        var language = typeof window !== 'undefined' && window.location && window.location.hostname && window.location.hostname.match(/^(\w{2,5})\.(([a-z0-9-]{1,63}\.[a-z]{2,6})|localhost)/i);
        // if there is no match (null) return undefined
        if (!language) return undefined;
        // return the given group match
        return language[lookupFromSubdomainIndex];
    }
};
// some environments, throws when accessing document.cookie
var $6087f953ce026243$var$canCookies = false;
try {
    // eslint-disable-next-line no-unused-expressions
    document.cookie;
    $6087f953ce026243$var$canCookies = true;
// eslint-disable-next-line no-empty
} catch (e) {}
var $6087f953ce026243$var$order = [
    'querystring',
    'cookie',
    'localStorage',
    'sessionStorage',
    'navigator',
    'htmlTag'
];
if (!$6087f953ce026243$var$canCookies) $6087f953ce026243$var$order.splice(1, 1);
function $6087f953ce026243$var$getDefaults() {
    return {
        order: $6087f953ce026243$var$order,
        lookupQuerystring: 'lng',
        lookupCookie: 'i18next',
        lookupLocalStorage: 'i18nextLng',
        lookupSessionStorage: 'i18nextLng',
        // cache user language
        caches: [
            'localStorage'
        ],
        excludeCacheFor: [
            'cimode'
        ],
        // cookieMinutes: 10,
        // cookieDomain: 'myDomain'
        convertDetectedLanguage: function convertDetectedLanguage(l) {
            return l;
        }
    };
}
var $6087f953ce026243$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function Browser(services) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        (0, $11f76ce1b556f6c2$export$2e2bcd8739ae039)(this, Browser);
        this.type = 'languageDetector';
        this.detectors = {};
        this.init(services, options);
    }
    return (0, $ff30f649bc95bc11$export$2e2bcd8739ae039)(Browser, [
        {
            key: "init",
            value: function init(services) {
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var i18nOptions = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                this.services = services || {
                    languageUtils: {}
                }; // this way the language detector can be used without i18next
                this.options = $6087f953ce026243$var$defaults(options, this.options || {}, $6087f953ce026243$var$getDefaults());
                if (typeof this.options.convertDetectedLanguage === 'string' && this.options.convertDetectedLanguage.indexOf('15897') > -1) this.options.convertDetectedLanguage = function(l) {
                    return l.replace('-', '_');
                };
                // backwards compatibility
                if (this.options.lookupFromUrlIndex) this.options.lookupFromPathIndex = this.options.lookupFromUrlIndex;
                this.i18nOptions = i18nOptions;
                this.addDetector($6087f953ce026243$var$cookie$1);
                this.addDetector($6087f953ce026243$var$querystring);
                this.addDetector($6087f953ce026243$var$localStorage);
                this.addDetector($6087f953ce026243$var$sessionStorage);
                this.addDetector($6087f953ce026243$var$navigator$1);
                this.addDetector($6087f953ce026243$var$htmlTag);
                this.addDetector($6087f953ce026243$var$path);
                this.addDetector($6087f953ce026243$var$subdomain);
            }
        },
        {
            key: "addDetector",
            value: function addDetector(detector) {
                this.detectors[detector.name] = detector;
                return this;
            }
        },
        {
            key: "detect",
            value: function detect(detectionOrder) {
                var _this = this;
                if (!detectionOrder) detectionOrder = this.options.order;
                var detected = [];
                detectionOrder.forEach(function(detectorName) {
                    if (_this.detectors[detectorName]) {
                        var lookup = _this.detectors[detectorName].lookup(_this.options);
                        if (lookup && typeof lookup === 'string') lookup = [
                            lookup
                        ];
                        if (lookup) detected = detected.concat(lookup);
                    }
                });
                detected = detected.map(function(d) {
                    return _this.options.convertDetectedLanguage(d);
                });
                if (this.services.languageUtils.getBestMatchFromCodes) return detected; // new i18next v19.5.0
                return detected.length > 0 ? detected[0] : null; // a little backward compatibility
            }
        },
        {
            key: "cacheUserLanguage",
            value: function cacheUserLanguage(lng, caches) {
                var _this2 = this;
                if (!caches) caches = this.options.caches;
                if (!caches) return;
                if (this.options.excludeCacheFor && this.options.excludeCacheFor.indexOf(lng) > -1) return;
                caches.forEach(function(cacheName) {
                    if (_this2.detectors[cacheName]) _this2.detectors[cacheName].cacheUserLanguage(lng, _this2.options);
                });
            }
        }
    ]);
}();
$6087f953ce026243$export$2e2bcd8739ae039.type = 'languageDetector';


var $d9ba9e2b9a952cf5$exports = {};
$d9ba9e2b9a952cf5$exports = JSON.parse('{"landing":{"hero-title":"\u041D\u0430\u0439\u0434\u0438\u0442\u0435 \u043F\u0440\u0438\u043A\u043B\u044E\u0447\u0435\u043D\u0438\u044F, \u043F\u0440\u0430\u0437\u0434\u043D\u0438\u043A\u0438 \u0438 \u043F\u043E\u0437\u043D\u0430\u0432\u0430\u0442\u0435\u043B\u044C\u043D\u044B\u0439 \u043E\u043F\u044B\u0442","title2":"\u0417\u0430\u0431\u0440\u043E\u043D\u0438\u0440\u0443\u0439\u0442\u0435 \u0443\u043D\u0438\u043A\u0430\u043B\u044C\u043D\u044B\u0435 \u0432\u043F\u0435\u0447\u0430\u0442\u043B\u0435\u043D\u0438\u044F","subtitle2":"\u041A\u043E\u0442\u043E\u0440\u044B\u0435 \u0432\u044B \u0434\u043E\u043B\u0433\u043E \u043D\u0435 \u0437\u0430\u0431\u0443\u0434\u0435\u0442\u0435","bouldering":"\u0421\u043A\u0430\u043B\u043E\u043B\u0430\u0437\u0430\u043D\u0438\u0435","paintball":"\u041F\u0438\u043D\u0442\u0431\u043E\u043B","escape-rooms":"\u041A\u0432\u0435\u0441\u0442\u044B","kids-play-rooms":"\u0414\u0435\u0442\u0441\u043A\u0438\u0435 \u0438\u0433\u0440\u043E\u0432\u044B\u0435 \u043A\u043E\u043C\u043D\u0430\u0442\u044B","museums":"\u0412 \u043C\u0443\u0437\u0435\u044F\u0445","outside":"\u041D\u0430 \u043E\u0442\u043A\u0440\u044B\u0442\u043E\u043C \u0432\u043E\u0437\u0434\u0443\u0445\u0435","vr":"\u0412\u0438\u0440\u0442\u0443\u0430\u043B\u044C\u043D\u0430\u044F \u0440\u0435\u0430\u043B\u044C\u043D\u043E\u0441\u0442\u044C","calligraphy":"\u041A\u0430\u043B\u043B\u0438\u0433\u0440\u0430\u0444\u0438\u044F"},"filter":{"all":"\u0412\u0441\u0435","city":"\u0413\u043E\u0440\u043E\u0434","selectCity":"\u0412\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u0433\u043E\u0440\u043E\u0434","age":"\u0412\u043E\u0437\u0440\u0430\u0441\u0442","selectAge":"\u0414\u043B\u044F \u043A\u043E\u0433\u043E","activity":"\u0412\u0438\u0434 \u0434\u0435\u044F\u0442\u0435\u043B\u044C\u043D\u043E\u0441\u0442\u0438","selectActivity":"\u0422\u0438\u043F \u043F\u0440\u0430\u0437\u0434\u043D\u0438\u043A\u0430","Tallinn":"\u0422\u0430\u043B\u043B\u0438\u043D\u043D","kids":"\u0414\u043B\u044F \u0434\u0435\u0442\u0435\u0439","adults":"\u0414\u043B\u044F \u0432\u0437\u0440\u043E\u0441\u043B\u044B\u0445","teenager":"\u0414\u043B\u044F \u043F\u043E\u0434\u0440\u043E\u0441\u0442\u043A\u043E\u0432","birthdays":"\u0414\u0435\u0442\u0441\u043A\u0438\u0435 \u043F\u0440\u0430\u0437\u0434\u043D\u0438\u043A\u0438","sport":"\u0421\u043F\u043E\u0440\u0442\u0438\u0432\u043D\u044B\u0435 \u043C\u0435\u0440\u043E\u043F\u0440\u0438\u044F\u0442\u0438\u044F","art":"\u041A\u0440\u0430\u0444\u0442 \u0438 \u0434\u0438\u0437\u0430\u0439\u043D","education":"\u041E\u0431\u0440\u0430\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044C\u043D\u044B\u0435","teambuilding":"\u0422\u0438\u043C \u0431\u0438\u043B\u0434\u0438\u043D\u0433","picnic":"\u041F\u0438\u043A\u043D\u0438\u043A","events":"\u041C\u0435\u0440\u043E\u043F\u0440\u0438\u044F\u0442\u0438\u044F"},"ads":{"showing":"\u041E\u0442\u043E\u0431\u0440\u0430\u0436\u0430\u044E\u0442\u0441\u044F","out-of":"\u0438\u0437","ads":"\u043E\u0431\u044A\u044F\u0432\u043B\u0435\u043D\u0438\u0439"},"selectors":{"find":"\u041D\u0430\u0439\u0442\u0438"},"footer":{"contacts":"\u041A\u043E\u043D\u0442\u0430\u043A\u0442\u044B","terms":"\u0423\u0441\u043B\u043E\u0432\u0438\u044F \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u0438\u044F","faq":"\u0427\u0430\u0441\u0442\u044B\u0435 \u0432\u043E\u043F\u0440\u043E\u0441\u044B"},"contacts":{"title":"\u041A\u043E\u043D\u0442\u0430\u043A\u0442\u044B"},"faq":{"title":"\u0427\u0430\u0441\u0442\u044B\u0435 \u0432\u043E\u043F\u0440\u043E\u0441\u044B","question-1":"- \u0427\u0442\u043E \u0437\u0434\u0435\u0441\u044C \u043F\u0440\u043E\u0438\u0441\u0445\u043E\u0434\u0438\u0442?","answer-1":"- \u041D\u0430 \u0441\u0430\u0439\u0442\u0435 \u0441\u043E\u0431\u0440\u0430\u043D \u043A\u0430\u0442\u0430\u043B\u043E\u0433 \u043F\u0440\u0435\u0434\u043F\u0440\u0438\u0442\u0438\u044F \u0434\u043B\u044F \u043F\u0440\u043E\u0432\u0435\u0434\u0435\u043D\u0438\u044F \u043F\u0440\u0430\u0437\u0434\u043D\u0438\u043A\u043E\u0432 \u043D\u0430\u043F\u0440\u0438\u043C\u0435\u0440 \u043A\u043E\u0440\u043F\u043E\u0440\u0430\u0442\u0438\u0432\u043E\u0432 \u0438\u043B\u0438 \u0434\u0435\u043D\u044C \u0440\u043E\u0436\u0434\u0435\u043D\u0438\u0439","question-2":"- \u041D\u0443\u0436\u043D\u043E \u043B\u0438 \u043F\u043B\u0430\u0442\u0438\u0442\u044C \u0438\u043B\u0438 \u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0438\u0440\u043E\u0432\u0430\u0442\u044C\u0441\u044F?","answer-2":"- \u041D\u0435\u0442, \u043C\u044B \u043A\u0430\u0442\u0430\u043B\u043E\u0433, \u043F\u043E\u043C\u043E\u0433\u0430\u0435\u043C \u043D\u0430\u0439\u0442\u0438 \u043C\u0435\u0441\u0442\u0430 \u0434\u043B\u044F \u043F\u0440\u043E\u0432\u0435\u0434\u0435\u043D\u0438\u044F \u043F\u0440\u0430\u0437\u0434\u043D\u0438\u043A\u043E\u0432 \u0438 \u0441 \u043D\u0438\u043C\u0438 \u0441\u0432\u044F\u0437\u0430\u0442\u044C\u0441\u044F","question-3":"- \u041A\u043E\u0433\u0434\u0430 \u044F \u043E\u043F\u0440\u0430\u0432\u043B\u044F\u044E \u043F\u0438\u0441\u044C\u043C\u043E \u043D\u0430 \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0435 \u043F\u0440\u0435\u0434\u043F\u0440\u0438\u044F\u0442\u0438\u044F \u0441 \u0434\u0430\u0442\u043E\u0439 \u0438 \u043A\u043E\u043C\u043C\u0435\u043D\u0442\u0430\u0440\u0438\u0435\u043C \u0447\u0442\u043E \u043F\u0440\u043E\u0438\u0441\u0445\u043E\u0434\u0438\u0442?","answer-3":"- \u041C\u044B \u043F\u0435\u0440\u0435\u043D\u0430\u043F\u0440\u0430\u0432\u043B\u044F\u0435\u043C \u0435\u0433\u043E \u043D\u0430 \u0435\u043C\u0435\u0439\u043B \u043F\u0440\u0435\u0434\u043F\u0440\u0438\u044F\u0442\u0438\u044F, \u0447\u0442\u043E\u0431\u044B \u043E\u043D\u0438 \u0441\u043C\u043E\u0433\u043B\u0438 \u0441 \u0432\u0430\u043C\u0438 \u0441\u0432\u044F\u0437\u0430\u0442\u044C\u0441\u044F"},"terms":{"title":"\u0423\u0441\u043B\u043E\u0432\u0438\u044F \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u0438\u044F \u0441\u0430\u0439\u0442\u0430:","paragraph-1":"\u0412\u043B\u0430\u0434\u0435\u043B\u044C\u0446\u0435\u043C \u0434\u0430\u043D\u043D\u043E\u0433\u043E \u0441\u0430\u0439\u0442\u0430 \u044F\u0432\u043B\u044F\u0435\u0442\u0441\u044F O\xdc Firm and steady (Reg: 17047649), \u043F\u0440\u043E\u0436\u0438\u0432\u0430\u044E\u0449\u0438\u0439 \u0432 \u042D\u0441\u0442\u043E\u043D\u0438\u0438. \u0421\u0430\u0439\u0442 \u043F\u0440\u0435\u0434\u043E\u0441\u0442\u0430\u0432\u043B\u044F\u0435\u0442 \u0441\u0432\u043E\u0431\u043E\u0434\u043D\u044B\u0439 \u0438 \u0431\u0435\u0441\u043F\u043B\u0430\u0442\u043D\u044B\u0439 \u0434\u043E\u0441\u0442\u0443\u043F \u0434\u043B\u044F \u0432\u0441\u0435\u0445 \u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u0435\u0439 \u0438\u043D\u0442\u0435\u0440\u043D\u0435\u0442\u0430. \u041E\u0441\u043D\u043E\u0432\u043D\u0430\u044F \u0446\u0435\u043B\u044C \u0441\u0430\u0439\u0442\u0430 - \u043F\u0440\u0435\u0434\u043E\u0441\u0442\u0430\u0432\u0438\u0442\u044C \u0443\u0441\u043B\u0443\u0433\u0443 \u043A\u0430\u0442\u0430\u043B\u043E\u0433\u0430 \u043F\u0440\u0435\u0434\u043F\u0440\u0438\u044F\u0442\u0438\u0439, \u0433\u0434\u0435 \u043C\u043E\u0436\u043D\u043E \u043E\u0440\u0433\u0430\u043D\u0438\u0437\u043E\u0432\u0430\u0442\u044C \u043F\u0440\u0430\u0437\u0434\u043D\u0438\u043A\u0438 \u0438 \u043A\u043E\u0440\u043F\u043E\u0440\u0430\u0442\u0438\u0432\u043D\u044B\u0435 \u043C\u0435\u0440\u043E\u043F\u0440\u0438\u044F\u0442\u0438\u044F, \u0430 \u0442\u0430\u043A\u0436\u0435 \u043E\u0431\u0435\u0441\u043F\u0435\u0447\u0438\u0442\u044C \u0432\u043E\u0437\u043C\u043E\u0436\u043D\u043E\u0441\u0442\u044C \u0441\u0432\u044F\u0437\u0430\u0442\u044C\u0441\u044F \u0441 \u0434\u0430\u043D\u043D\u044B\u043C\u0438 \u043F\u0440\u0435\u0434\u043F\u0440\u0438\u044F\u0442\u0438\u044F\u043C\u0438.","paragraph-2":"\u0412\u0430\u0436\u043D\u043E \u043E\u0442\u043C\u0435\u0442\u0438\u0442\u044C, \u0447\u0442\u043E \u0434\u0430\u043D\u043D\u044B\u0439 \u0441\u0430\u0439\u0442 \u043D\u0435 \u0441\u043E\u0431\u0438\u0440\u0430\u0435\u0442 \u0438\u043B\u0438 \u0445\u0440\u0430\u043D\u0438\u0442 \u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044C\u0441\u043A\u0438\u0435 \u0434\u0430\u043D\u043D\u044B\u0435. \u0412\u0441\u044F \u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u044F, \u043F\u0440\u0435\u0434\u043E\u0441\u0442\u0430\u0432\u043B\u0435\u043D\u043D\u0430\u044F \u043D\u0430 \u0441\u0430\u0439\u0442\u0435, \u044F\u0432\u043B\u044F\u0435\u0442\u0441\u044F \u043E\u0431\u0449\u0435\u0434\u043E\u0441\u0442\u0443\u043F\u043D\u043E\u0439 \u0438 \u043C\u043E\u0436\u0435\u0442 \u0431\u044B\u0442\u044C \u0438\u0437\u043C\u0435\u043D\u0435\u043D\u0430 \u043F\u0440\u0435\u0434\u043F\u0440\u0438\u044F\u0442\u0438\u044F\u043C\u0438 \u0431\u0435\u0437 \u043F\u0440\u0435\u0434\u0432\u0430\u0440\u0438\u0442\u0435\u043B\u044C\u043D\u043E\u0433\u043E \u0443\u0432\u0435\u0434\u043E\u043C\u043B\u0435\u043D\u0438\u044F. \u0421\u0430\u0439\u0442 \u043D\u0435 \u043D\u0435\u0441\u0435\u0442 \u043E\u0442\u0432\u0435\u0442\u0441\u0442\u0432\u0435\u043D\u043D\u043E\u0441\u0442\u0438 \u0437\u0430 \u0434\u043E\u0441\u0442\u043E\u0432\u0435\u0440\u043D\u043E\u0441\u0442\u044C \u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u0438 \u043E \u043C\u0435\u0441\u0442\u0430\u0445 \u0438 \u0432\u0440\u0435\u043C\u0435\u043D\u0438 \u043F\u0440\u043E\u0432\u0435\u0434\u0435\u043D\u0438\u044F \u043F\u0440\u0430\u0437\u0434\u043D\u0438\u043A\u043E\u0432, \u0430 \u0442\u0430\u043A\u0436\u0435 \u0437\u0430 \u043F\u043E\u0434\u0442\u0432\u0435\u0440\u0436\u0434\u0435\u043D\u0438\u0435 \u0438\u0445 \u0440\u0435\u0430\u043B\u044C\u043D\u043E\u0441\u0442\u0438. \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u0438 \u0434\u043E\u043B\u0436\u043D\u044B \u0441\u0430\u043C\u043E\u0441\u0442\u043E\u044F\u0442\u0435\u043B\u044C\u043D\u043E \u043F\u0440\u043E\u0432\u0435\u0440\u044F\u0442\u044C \u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u044E \u0438 \u0443\u0442\u043E\u0447\u043D\u044F\u0442\u044C \u0434\u0435\u0442\u0430\u043B\u0438 \u043D\u0430\u043F\u0440\u044F\u043C\u0443\u044E \u0443 \u043F\u0440\u0435\u0434\u043F\u0440\u0438\u044F\u0442\u0438\u0439.","paragraph-3":"\u0418\u0441\u043F\u043E\u043B\u044C\u0437\u0443\u044F \u0434\u0430\u043D\u043D\u044B\u0439 \u0441\u0430\u0439\u0442, \u0432\u044B \u0430\u0432\u0442\u043E\u043C\u0430\u0442\u0438\u0447\u0435\u0441\u043A\u0438 \u0441\u043E\u0433\u043B\u0430\u0448\u0430\u0435\u0442\u0435\u0441\u044C \u0441 \u0432\u044B\u0448\u0435\u0443\u043A\u0430\u0437\u0430\u043D\u043D\u044B\u043C\u0438 \u0443\u0441\u043B\u043E\u0432\u0438\u044F\u043C\u0438. \u0415\u0441\u043B\u0438 \u0443 \u0432\u0430\u0441 \u0435\u0441\u0442\u044C \u043A\u0430\u043A\u0438\u0435-\u043B\u0438\u0431\u043E \u0432\u043E\u043F\u0440\u043E\u0441\u044B \u0438\u043B\u0438 \u043F\u0440\u0435\u0434\u043B\u043E\u0436\u0435\u043D\u0438\u044F \u043E\u0442\u043D\u043E\u0441\u0438\u0442\u0435\u043B\u044C\u043D\u043E \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u0438\u044F \u0441\u0430\u0439\u0442\u0430, \u043F\u043E\u0436\u0430\u043B\u0443\u0439\u0441\u0442\u0430, \u0441\u0432\u044F\u0436\u0438\u0442\u0435\u0441\u044C \u0441 \u043D\u0430\u043C\u0438 \u0447\u0435\u0440\u0435\u0437 \u043F\u0440\u0435\u0434\u043E\u0441\u0442\u0430\u0432\u043B\u0435\u043D\u043D\u044B\u0435 \u043A\u043E\u043D\u0442\u0430\u043A\u0442\u043D\u044B\u0435 \u0434\u0430\u043D\u043D\u044B\u0435"}}');


var $2c013d18b2790e88$exports = {};
$2c013d18b2790e88$exports = JSON.parse('{"landing":{"hero-title":"Leia seiklus ja t\xe4histamine ja \xf5ppimise kogemusi","title2":"Broneeri h\xe4mmastav kogemus","subtitle2":"\xdcks, mida m\xe4letate pikka aega","bouldering":"Bouldering","paintball":"Paintball","escape-rooms":"P\xf5genemistoad","kids-play-rooms":"Laste m\xe4ngutoad","museums":"Muuseumides","outside":"V\xe4ljaspool osapooli","vr":"VR","calligraphy":"Kalligraafia"},"filter":{"all":"K\xf5ik","city":"Linn","selectCity":"Valige linn","age":"Vanus","selectAge":"Valige vanus","activity":"Tegevus","selectActivity":"Valige tegevuse t\xfc\xfcp","Tallinn":"Tallinn","kids":"lapsed","adults":"t\xe4iskasvanud","teenager":"teismeline","birthdays":"Laste S\xfcnnip\xe4evadeks","sport":"Sport ja vaba aeg","art":"Kunst Ja K\xe4sit\xf6\xf6","education":"Haridus","teambuilding":"Team building","picnic":"Picnic","events":"Events"},"ads":{"showing":"Kuvatakse","out-of":"/","ads":"reklaami"},"selectors":{"find":"Leia"},"footer":{"contacts":"\xdchendus","terms":"Kasutustingimused","faq":"KKK"},"contacts":{"title":"\xdchendus"},"faq":{"title":"KKK","question-1":"- Mis siin toimub?","answer-1":"- Veebisaidil kogutakse kataloogi \xfcrituspaikadest nagu ettev\xf5tte\xfcritused v\xf5i s\xfcnnip\xe4evad.","question-2":"- Kas ma pean maksma v\xf5i registreeruma?","answer-2":"- Ei, me oleme kataloog, aitame leida \xfcrituskohti ja nendega \xfchendust v\xf5tta.","question-3":"- Kui ma saadan ettev\xf5tte lehele s\xf5numi kuup\xe4eva ja kommentaariga, mis juhtub?","answer-3":"- Suuname selle ettev\xf5tte e-posti, et nad saaksid teiega \xfchendust v\xf5tta."},"terms":{"title":"Kasutustingimused","paragraph-1":"Seda veebisaiti omab O\xdc Firm and steady (Reg: 17047649), kes elab Eestis. Sait pakub k\xf5igile internetikasutajatele tasuta ja piiramatut juurdep\xe4\xe4su. Veebisaidi peamine eesm\xe4rk on pakkuda ettev\xf5tete kataloogiteenust, kus saab korraldada pidustusi ja ettev\xf5tte\xfcritusi, ning v\xf5imaldada nende ettev\xf5tetega kontakteerumist.","paragraph-2":"Oluline on m\xe4rkida, et see veebisait ei kogu ega salvesta kasutajaandmeid. Kogu veebisaidil pakutav teave on avalikult k\xe4ttesaadav ja ettev\xf5tete poolt v\xf5ib seda muuta eelneva teatamiseta. Sait ei vastuta pidustuste toimumiskohtade ja aegade t\xe4psuse eest ega kinnita nende autentsust. Kasutajatel soovitatakse teavet iseseisvalt kontrollida ja selgitada detaile otse ettev\xf5tetega.","paragraph-3":"Kasutades seda veebisaiti, n\xf5ustute automaatselt eespool nimetatud tingimustega. Kui teil on k\xfcsimusi v\xf5i ettepanekuid veebisaidi kasutamise kohta, v\xf5tke meiega \xfchendust pakutud kontaktandmete kaudu."}}');


var $93bc3c784b86efe9$exports = {};
$93bc3c784b86efe9$exports = JSON.parse('{"landing":{"hero-title":"Find Adventure & Celebration & Learning experiences","title2":"Book amazing experience","subtitle2":" The one you will remember for a long time","bouldering":"Bouldering","paintball":"Paintball","escape-rooms":"Escape rooms","kids-play-rooms":"Kids play rooms","museums":"In museums","outside":"Outside parties","vr":"VR","calligraphy":"Calligraphy"},"filter":{"all":"All","city":"City","selectCity":"Select a city","age":"Age","selectAge":"Select for whom","activity":"Activity","selectActivity":"Select type of activity","Tallinn":"Tallinn","kids":"Kids","adults":"Adults","teenager":"Teenagers","birthdays":"Kids playground for birthdays","sport":"Sport & Recreation","art":"Arts & Crafts","education":"Educations","teambuilding":"Team building","picnic":"Picnic","events":"Events"},"ads":{"showing":"Showing","out-of":"out of","ads":"locations"},"selectors":{"find":"Find"},"footer":{"contacts":"Contacts","terms":"Terms of usage","faq":"FAQ"},"contacts":{"title":"Contacts"},"faq":{"title":"FAQ","question-1":"- What is happening here?","answer-1":"- The website collects a catalog of venues for events such as corporate parties or birthdays.","question-2":"- Do I need to pay or register?","answer-2":"- No, we\'re a catalog, we help find venues for events and get in touch with them.","question-3":"- When I send a message on the company\'s page with the date and a comment, what happens?","answer-3":"- We redirect it to the company\'s email so they can get in touch with you."},"terms":{"title":"Terms of usage","paragraph-1":"This website is owned by O\xdc Firm and steady (Reg: 17047649), residing in Estonia. The site provides free and unrestricted access to all internet users. The main purpose of the website is to offer a directory service of establishments where celebrations and corporate events can be organized, as well as to facilitate contact with these establishments.","paragraph-2":"It is important to note that this website does not collect or store user data. All information provided on the website is publicly accessible and subject to change by the establishments without prior notice. The site does not take responsibility for the accuracy of information regarding the locations and times of celebrations, nor does it verify their authenticity. Users are advised to independently verify information and clarify details directly with the establishments.","paragraph-3":"By using this website, you automatically agree to the above terms. If you have any questions or suggestions regarding the use of the website, please contact us through the provided contact information."}}');


const $eb1ed0e5f9d934f1$export$d3e6bfdec6667716 = 'en';
const $eb1ed0e5f9d934f1$export$d0d68bb9ed2c643d = [
    $eb1ed0e5f9d934f1$export$d3e6bfdec6667716,
    'ru',
    'ee'
];
const $eb1ed0e5f9d934f1$export$d29cf4180255d829 = 'translations';
const $eb1ed0e5f9d934f1$var$resources = {
    en: {
        translations: (0, (/*@__PURE__*/$parcel$interopDefault($93bc3c784b86efe9$exports)))
    },
    ru: {
        translations: (0, (/*@__PURE__*/$parcel$interopDefault($d9ba9e2b9a952cf5$exports)))
    },
    ee: {
        translations: (0, (/*@__PURE__*/$parcel$interopDefault($2c013d18b2790e88$exports)))
    }
};
(0, $5367a5ae783d4618$export$2e2bcd8739ae039).use((0, $1f9e801d6ace9094$export$ae7e14d40d89f296)).use((0, $6087f953ce026243$export$2e2bcd8739ae039)).init({
    resources: $eb1ed0e5f9d934f1$var$resources,
    debug: true,
    supportedLngs: $eb1ed0e5f9d934f1$export$d0d68bb9ed2c643d,
    fallbackLng: $eb1ed0e5f9d934f1$export$d3e6bfdec6667716,
    fallbackNS: $eb1ed0e5f9d934f1$export$d29cf4180255d829,
    defaultNS: $eb1ed0e5f9d934f1$export$d29cf4180255d829
});



var $3vNtX = parcelRequire("3vNtX");
var $3VnFq = parcelRequire("3VnFq");

var $cTAWX = parcelRequire("cTAWX");
parcelRequire("gJYWc");


var $3VnFq = parcelRequire("3VnFq");

var $gJYWc = parcelRequire("gJYWc");


var $3VnFq = parcelRequire("3VnFq");

var $gJYWc = parcelRequire("gJYWc");



var $gJYWc = parcelRequire("gJYWc");
const $135eed7b79a7ed79$var$ThemeContext = /*#__PURE__*/ $gJYWc.createContext(null);
var $135eed7b79a7ed79$export$2e2bcd8739ae039 = $135eed7b79a7ed79$var$ThemeContext;



var $gJYWc = parcelRequire("gJYWc");

function $b7187f80ae0fd80a$export$2e2bcd8739ae039() {
    const theme = $gJYWc.useContext((0, $135eed7b79a7ed79$export$2e2bcd8739ae039));
    return theme;
}


const $b88cb0fb2ceef6bc$var$hasSymbol = typeof Symbol === 'function' && Symbol.for;
var $b88cb0fb2ceef6bc$export$2e2bcd8739ae039 = $b88cb0fb2ceef6bc$var$hasSymbol ? Symbol.for('mui.nested') : '__THEME_NESTED__';



var $9wx12 = parcelRequire("9wx12");
function $7c80ce411ed70d1f$var$mergeOuterLocalTheme(outerTheme, localTheme) {
    if (typeof localTheme === 'function') {
        const mergedTheme = localTheme(outerTheme);
        return mergedTheme;
    }
    return (0, $3VnFq.default)({}, outerTheme, localTheme);
}
/**
 * This component takes a `theme` prop.
 * It makes the `theme` available down the React tree thanks to React context.
 * This component should preferably be used at **the root of your component tree**.
 */ function $7c80ce411ed70d1f$var$ThemeProvider(props) {
    const { children: children, theme: localTheme } = props;
    const outerTheme = (0, $b7187f80ae0fd80a$export$2e2bcd8739ae039)();
    const theme = $gJYWc.useMemo(()=>{
        const output = outerTheme === null ? localTheme : $7c80ce411ed70d1f$var$mergeOuterLocalTheme(outerTheme, localTheme);
        if (output != null) output[0, $b88cb0fb2ceef6bc$export$2e2bcd8739ae039] = outerTheme !== null;
        return output;
    }, [
        localTheme,
        outerTheme
    ]);
    return /*#__PURE__*/ (0, $9wx12.jsx)((0, $135eed7b79a7ed79$export$2e2bcd8739ae039).Provider, {
        value: theme,
        children: children
    });
}
var $7c80ce411ed70d1f$export$2e2bcd8739ae039 = $7c80ce411ed70d1f$var$ThemeProvider;



parcelRequire("d0nrV");
var $ll1Nc = parcelRequire("ll1Nc");

var $gJYWc = parcelRequire("gJYWc");
parcelRequire("d0nrV");
var $ll1Nc = parcelRequire("ll1Nc");
'use client';
function $2aefe0c034e4c8e0$var$isObjectEmpty(obj) {
    return Object.keys(obj).length === 0;
}
function $2aefe0c034e4c8e0$var$useTheme(defaultTheme = null) {
    const contextTheme = $gJYWc.useContext((0, $ll1Nc.T));
    return !contextTheme || $2aefe0c034e4c8e0$var$isObjectEmpty(contextTheme) ? defaultTheme : contextTheme;
}
var $2aefe0c034e4c8e0$export$2e2bcd8739ae039 = $2aefe0c034e4c8e0$var$useTheme;



var $3VnFq = parcelRequire("3VnFq");

var $cTAWX = parcelRequire("cTAWX");

var $gJYWc = parcelRequire("gJYWc");


var $9wx12 = parcelRequire("9wx12");
const $bc397899d0b95ae5$var$_excluded = [
    "value"
];
const $bc397899d0b95ae5$var$RtlContext = /*#__PURE__*/ $gJYWc.createContext();
function $bc397899d0b95ae5$var$RtlProvider(_ref) {
    let { value: value } = _ref, props = (0, $cTAWX.default)(_ref, $bc397899d0b95ae5$var$_excluded);
    return /*#__PURE__*/ (0, $9wx12.jsx)($bc397899d0b95ae5$var$RtlContext.Provider, (0, $3VnFq.default)({
        value: value != null ? value : true
    }, props));
}
const $bc397899d0b95ae5$export$b2dd014b6c321cb = ()=>{
    const value = $gJYWc.useContext($bc397899d0b95ae5$var$RtlContext);
    return value != null ? value : false;
};
var $bc397899d0b95ae5$export$2e2bcd8739ae039 = $bc397899d0b95ae5$var$RtlProvider;



var $43DQp = parcelRequire("43DQp");

var $9wx12 = parcelRequire("9wx12");
'use client';
const $7032c81c3cd95d70$var$EMPTY_THEME = {};
function $7032c81c3cd95d70$var$useThemeScoping(themeId, upperTheme, localTheme, isPrivate = false) {
    return $gJYWc.useMemo(()=>{
        const resolvedTheme = themeId ? upperTheme[themeId] || upperTheme : upperTheme;
        if (typeof localTheme === 'function') {
            const mergedTheme = localTheme(resolvedTheme);
            const result = themeId ? (0, $3VnFq.default)({}, upperTheme, {
                [themeId]: mergedTheme
            }) : mergedTheme;
            // must return a function for the private theme to NOT merge with the upper theme.
            // see the test case "use provided theme from a callback" in ThemeProvider.test.js
            if (isPrivate) return ()=>result;
            return result;
        }
        return themeId ? (0, $3VnFq.default)({}, upperTheme, {
            [themeId]: localTheme
        }) : (0, $3VnFq.default)({}, upperTheme, localTheme);
    }, [
        themeId,
        upperTheme,
        localTheme,
        isPrivate
    ]);
}
/**
 * This component makes the `theme` available down the React tree.
 * It should preferably be used at **the root of your component tree**.
 *
 * <ThemeProvider theme={theme}> // existing use case
 * <ThemeProvider theme={{ id: theme }}> // theme scoping
 */ function $7032c81c3cd95d70$var$ThemeProvider(props) {
    const { children: children, theme: localTheme, themeId: themeId } = props;
    const upperTheme = (0, $2aefe0c034e4c8e0$export$2e2bcd8739ae039)($7032c81c3cd95d70$var$EMPTY_THEME);
    const upperPrivateTheme = (0, $b7187f80ae0fd80a$export$2e2bcd8739ae039)() || $7032c81c3cd95d70$var$EMPTY_THEME;
    const engineTheme = $7032c81c3cd95d70$var$useThemeScoping(themeId, upperTheme, localTheme);
    const privateTheme = $7032c81c3cd95d70$var$useThemeScoping(themeId, upperPrivateTheme, localTheme, true);
    const rtlValue = engineTheme.direction === 'rtl';
    return /*#__PURE__*/ (0, $9wx12.jsx)((0, $7c80ce411ed70d1f$export$2e2bcd8739ae039), {
        theme: privateTheme,
        children: /*#__PURE__*/ (0, $9wx12.jsx)((0, $ll1Nc.T).Provider, {
            value: engineTheme,
            children: /*#__PURE__*/ (0, $9wx12.jsx)((0, $bc397899d0b95ae5$export$2e2bcd8739ae039), {
                value: rtlValue,
                children: /*#__PURE__*/ (0, $9wx12.jsx)((0, $43DQp.default), {
                    value: engineTheme == null ? void 0 : engineTheme.components,
                    children: children
                })
            })
        })
    });
}
var $7032c81c3cd95d70$export$2e2bcd8739ae039 = $7032c81c3cd95d70$var$ThemeProvider;



var $8Ho5h = parcelRequire("8Ho5h");

var $9wx12 = parcelRequire("9wx12");
'use client';
const $ec109688d3887965$var$_excluded = [
    "theme"
];
function $ec109688d3887965$export$2e2bcd8739ae039(_ref) {
    let { theme: themeInput } = _ref, props = (0, $cTAWX.default)(_ref, $ec109688d3887965$var$_excluded);
    const scopedTheme = themeInput[0, $8Ho5h.default];
    let finalTheme = scopedTheme || themeInput;
    if (typeof themeInput !== 'function') {
        if (scopedTheme && !scopedTheme.vars) finalTheme = (0, $3VnFq.default)({}, scopedTheme, {
            vars: null
        });
        else if (themeInput && !themeInput.vars) finalTheme = (0, $3VnFq.default)({}, themeInput, {
            vars: null
        });
    }
    return /*#__PURE__*/ (0, $9wx12.jsx)((0, $7032c81c3cd95d70$export$2e2bcd8739ae039), (0, $3VnFq.default)({}, props, {
        themeId: scopedTheme ? (0, $8Ho5h.default) : undefined,
        theme: finalTheme
    }));
}



var $3VnFq = parcelRequire("3VnFq");

var $cTAWX = parcelRequire("cTAWX");

var $gJYWc = parcelRequire("gJYWc");


var $11GxC = parcelRequire("11GxC");
function $8a44b6862528b26f$export$2e2bcd8739ae039(params) {
    const { theme: theme, name: name, props: props } = params;
    if (!theme || !theme.components || !theme.components[name] || !theme.components[name].defaultProps) return props;
    return (0, $11GxC.default)(theme.components[name].defaultProps, props);
}



var $hvWfk = parcelRequire("hvWfk");

'use client';
const $81fc44edf20e1517$export$35e57303dbd8a66 = (0, $hvWfk.default)();
function $81fc44edf20e1517$var$useTheme(defaultTheme = $81fc44edf20e1517$export$35e57303dbd8a66) {
    return (0, $2aefe0c034e4c8e0$export$2e2bcd8739ae039)(defaultTheme);
}
var $81fc44edf20e1517$export$2e2bcd8739ae039 = $81fc44edf20e1517$var$useTheme;


'use client';
function $011a0d2b53945cef$export$2e2bcd8739ae039({ props: props, name: name, defaultTheme: defaultTheme, themeId: themeId }) {
    let theme = (0, $81fc44edf20e1517$export$2e2bcd8739ae039)(defaultTheme);
    if (themeId) theme = theme[themeId] || theme;
    const mergedProps = (0, $8a44b6862528b26f$export$2e2bcd8739ae039)({
        theme: theme,
        name: name,
        props: props
    });
    return mergedProps;
}



var $iNcPC = parcelRequire("iNcPC");

var $8Ho5h = parcelRequire("8Ho5h");
'use client';
function $6959428021af84ce$export$2e2bcd8739ae039({ props: props, name: name }) {
    return (0, $011a0d2b53945cef$export$2e2bcd8739ae039)({
        props: props,
        name: name,
        defaultTheme: $iNcPC.default,
        themeId: (0, $8Ho5h.default)
    });
}



var $9wx12 = parcelRequire("9wx12");
const $38b9c61d570d1b88$var$_excluded = [
    "localeText"
];
const $38b9c61d570d1b88$export$544976378534cf9 = /*#__PURE__*/ $gJYWc.createContext(null);
const $38b9c61d570d1b88$export$dc45bdc734ce6f1e = function LocalizationProvider(inProps) {
    var _React$useContext;
    const { localeText: inLocaleText } = inProps, otherInProps = (0, $cTAWX.default)(inProps, $38b9c61d570d1b88$var$_excluded);
    const { utils: parentUtils, localeText: parentLocaleText } = (_React$useContext = $gJYWc.useContext($38b9c61d570d1b88$export$544976378534cf9)) != null ? _React$useContext : {
        utils: undefined,
        localeText: undefined
    };
    const props = (0, $6959428021af84ce$export$2e2bcd8739ae039)({
        // We don't want to pass the `localeText` prop to the theme, that way it will always return the theme value,
        // We will then merge this theme value with our value manually
        props: otherInProps,
        name: 'MuiLocalizationProvider'
    });
    const { children: children, dateAdapter: DateAdapter, dateFormats: dateFormats, dateLibInstance: dateLibInstance, adapterLocale: adapterLocale, localeText: themeLocaleText } = props;
    const localeText = $gJYWc.useMemo(()=>(0, $3VnFq.default)({}, themeLocaleText, parentLocaleText, inLocaleText), [
        themeLocaleText,
        parentLocaleText,
        inLocaleText
    ]);
    const utils = $gJYWc.useMemo(()=>{
        if (!DateAdapter) {
            if (parentUtils) return parentUtils;
            return null;
        }
        const adapter = new DateAdapter({
            locale: adapterLocale,
            formats: dateFormats,
            instance: dateLibInstance
        });
        if (!adapter.isMUIAdapter) throw new Error([
            'MUI: The date adapter should be imported from `@mui/x-date-pickers` or `@mui/x-date-pickers-pro`, not from `@date-io`',
            "For example, `import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'` instead of `import AdapterDayjs from '@date-io/dayjs'`",
            'More information on the installation documentation: https://mui.com/x/react-date-pickers/getting-started/#installation'
        ].join(`\n`));
        return adapter;
    }, [
        DateAdapter,
        adapterLocale,
        dateFormats,
        dateLibInstance,
        parentUtils
    ]);
    const defaultDates = $gJYWc.useMemo(()=>{
        if (!utils) return null;
        return {
            minDate: utils.date('1900-01-01T00:00:00.000'),
            maxDate: utils.date('2099-12-31T00:00:00.000')
        };
    }, [
        utils
    ]);
    const contextValue = $gJYWc.useMemo(()=>{
        return {
            utils: utils,
            defaultDates: defaultDates,
            localeText: localeText
        };
    }, [
        defaultDates,
        utils,
        localeText
    ]);
    return /*#__PURE__*/ (0, $9wx12.jsx)($38b9c61d570d1b88$export$544976378534cf9.Provider, {
        value: contextValue,
        children: children
    });
};



var $3VnFq = parcelRequire("3VnFq");
var $9334e2afb1a2ce43$exports = {};
!function(t, e) {
    $9334e2afb1a2ce43$exports = e();
}($9334e2afb1a2ce43$exports, function() {
    "use strict";
    var t = 1e3, e = 6e4, n = 36e5, r = "millisecond", i = "second", s = "minute", u = "hour", a = "day", o = "week", c = "month", f = "quarter", h = "year", d = "date", l = "Invalid Date", $ = /^(\d{4})[-/]?(\d{1,2})?[-/]?(\d{0,2})[Tt\s]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?[.:]?(\d+)?$/, y = /\[([^\]]+)]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g, M = {
        name: "en",
        weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),
        months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_"),
        ordinal: function(t) {
            var e = [
                "th",
                "st",
                "nd",
                "rd"
            ], n = t % 100;
            return "[" + t + (e[(n - 20) % 10] || e[n] || e[0]) + "]";
        }
    }, m = function(t, e, n) {
        var r = String(t);
        return !r || r.length >= e ? t : "" + Array(e + 1 - r.length).join(n) + t;
    }, v = {
        s: m,
        z: function(t) {
            var e = -t.utcOffset(), n = Math.abs(e), r = Math.floor(n / 60), i = n % 60;
            return (e <= 0 ? "+" : "-") + m(r, 2, "0") + ":" + m(i, 2, "0");
        },
        m: function t(e, n) {
            if (e.date() < n.date()) return -t(n, e);
            var r = 12 * (n.year() - e.year()) + (n.month() - e.month()), i = e.clone().add(r, c), s = n - i < 0, u = e.clone().add(r + (s ? -1 : 1), c);
            return +(-(r + (n - i) / (s ? i - u : u - i)) || 0);
        },
        a: function(t) {
            return t < 0 ? Math.ceil(t) || 0 : Math.floor(t);
        },
        p: function(t) {
            return ({
                M: c,
                y: h,
                w: o,
                d: a,
                D: d,
                h: u,
                m: s,
                s: i,
                ms: r,
                Q: f
            })[t] || String(t || "").toLowerCase().replace(/s$/, "");
        },
        u: function(t) {
            return void 0 === t;
        }
    }, g = "en", D = {};
    D[g] = M;
    var p = "$isDayjsObject", S = function(t) {
        return t instanceof _ || !(!t || !t[p]);
    }, w = function t(e, n, r) {
        var i;
        if (!e) return g;
        if ("string" == typeof e) {
            var s = e.toLowerCase();
            D[s] && (i = s), n && (D[s] = n, i = s);
            var u = e.split("-");
            if (!i && u.length > 1) return t(u[0]);
        } else {
            var a = e.name;
            D[a] = e, i = a;
        }
        return !r && i && (g = i), i || !r && g;
    }, O = function(t, e) {
        if (S(t)) return t.clone();
        var n = "object" == typeof e ? e : {};
        return n.date = t, n.args = arguments, new _(n);
    }, b = v;
    b.l = w, b.i = S, b.w = function(t, e) {
        return O(t, {
            locale: e.$L,
            utc: e.$u,
            x: e.$x,
            $offset: e.$offset
        });
    };
    var _ = function() {
        function M(t) {
            this.$L = w(t.locale, null, !0), this.parse(t), this.$x = this.$x || t.x || {}, this[p] = !0;
        }
        var m = M.prototype;
        return m.parse = function(t) {
            this.$d = function(t) {
                var e = t.date, n = t.utc;
                if (null === e) return new Date(NaN);
                if (b.u(e)) return new Date;
                if (e instanceof Date) return new Date(e);
                if ("string" == typeof e && !/Z$/i.test(e)) {
                    var r = e.match($);
                    if (r) {
                        var i = r[2] - 1 || 0, s = (r[7] || "0").substring(0, 3);
                        return n ? new Date(Date.UTC(r[1], i, r[3] || 1, r[4] || 0, r[5] || 0, r[6] || 0, s)) : new Date(r[1], i, r[3] || 1, r[4] || 0, r[5] || 0, r[6] || 0, s);
                    }
                }
                return new Date(e);
            }(t), this.init();
        }, m.init = function() {
            var t = this.$d;
            this.$y = t.getFullYear(), this.$M = t.getMonth(), this.$D = t.getDate(), this.$W = t.getDay(), this.$H = t.getHours(), this.$m = t.getMinutes(), this.$s = t.getSeconds(), this.$ms = t.getMilliseconds();
        }, m.$utils = function() {
            return b;
        }, m.isValid = function() {
            return !(this.$d.toString() === l);
        }, m.isSame = function(t, e) {
            var n = O(t);
            return this.startOf(e) <= n && n <= this.endOf(e);
        }, m.isAfter = function(t, e) {
            return O(t) < this.startOf(e);
        }, m.isBefore = function(t, e) {
            return this.endOf(e) < O(t);
        }, m.$g = function(t, e, n) {
            return b.u(t) ? this[e] : this.set(n, t);
        }, m.unix = function() {
            return Math.floor(this.valueOf() / 1e3);
        }, m.valueOf = function() {
            return this.$d.getTime();
        }, m.startOf = function(t, e) {
            var n = this, r = !!b.u(e) || e, f = b.p(t), l = function(t, e) {
                var i = b.w(n.$u ? Date.UTC(n.$y, e, t) : new Date(n.$y, e, t), n);
                return r ? i : i.endOf(a);
            }, $ = function(t, e) {
                return b.w(n.toDate()[t].apply(n.toDate("s"), (r ? [
                    0,
                    0,
                    0,
                    0
                ] : [
                    23,
                    59,
                    59,
                    999
                ]).slice(e)), n);
            }, y = this.$W, M = this.$M, m = this.$D, v = "set" + (this.$u ? "UTC" : "");
            switch(f){
                case h:
                    return r ? l(1, 0) : l(31, 11);
                case c:
                    return r ? l(1, M) : l(0, M + 1);
                case o:
                    var g = this.$locale().weekStart || 0, D = (y < g ? y + 7 : y) - g;
                    return l(r ? m - D : m + (6 - D), M);
                case a:
                case d:
                    return $(v + "Hours", 0);
                case u:
                    return $(v + "Minutes", 1);
                case s:
                    return $(v + "Seconds", 2);
                case i:
                    return $(v + "Milliseconds", 3);
                default:
                    return this.clone();
            }
        }, m.endOf = function(t) {
            return this.startOf(t, !1);
        }, m.$set = function(t, e) {
            var n, o = b.p(t), f = "set" + (this.$u ? "UTC" : ""), l = (n = {}, n[a] = f + "Date", n[d] = f + "Date", n[c] = f + "Month", n[h] = f + "FullYear", n[u] = f + "Hours", n[s] = f + "Minutes", n[i] = f + "Seconds", n[r] = f + "Milliseconds", n)[o], $ = o === a ? this.$D + (e - this.$W) : e;
            if (o === c || o === h) {
                var y = this.clone().set(d, 1);
                y.$d[l]($), y.init(), this.$d = y.set(d, Math.min(this.$D, y.daysInMonth())).$d;
            } else l && this.$d[l]($);
            return this.init(), this;
        }, m.set = function(t, e) {
            return this.clone().$set(t, e);
        }, m.get = function(t) {
            return this[b.p(t)]();
        }, m.add = function(r, f) {
            var d, l = this;
            r = Number(r);
            var $ = b.p(f), y = function(t) {
                var e = O(l);
                return b.w(e.date(e.date() + Math.round(t * r)), l);
            };
            if ($ === c) return this.set(c, this.$M + r);
            if ($ === h) return this.set(h, this.$y + r);
            if ($ === a) return y(1);
            if ($ === o) return y(7);
            var M = (d = {}, d[s] = e, d[u] = n, d[i] = t, d)[$] || 1, m = this.$d.getTime() + r * M;
            return b.w(m, this);
        }, m.subtract = function(t, e) {
            return this.add(-1 * t, e);
        }, m.format = function(t) {
            var e = this, n = this.$locale();
            if (!this.isValid()) return n.invalidDate || l;
            var r = t || "YYYY-MM-DDTHH:mm:ssZ", i = b.z(this), s = this.$H, u = this.$m, a = this.$M, o = n.weekdays, c = n.months, f = n.meridiem, h = function(t, n, i, s) {
                return t && (t[n] || t(e, r)) || i[n].slice(0, s);
            }, d = function(t) {
                return b.s(s % 12 || 12, t, "0");
            }, $ = f || function(t, e, n) {
                var r = t < 12 ? "AM" : "PM";
                return n ? r.toLowerCase() : r;
            };
            return r.replace(y, function(t, r) {
                return r || function(t) {
                    switch(t){
                        case "YY":
                            return String(e.$y).slice(-2);
                        case "YYYY":
                            return b.s(e.$y, 4, "0");
                        case "M":
                            return a + 1;
                        case "MM":
                            return b.s(a + 1, 2, "0");
                        case "MMM":
                            return h(n.monthsShort, a, c, 3);
                        case "MMMM":
                            return h(c, a);
                        case "D":
                            return e.$D;
                        case "DD":
                            return b.s(e.$D, 2, "0");
                        case "d":
                            return String(e.$W);
                        case "dd":
                            return h(n.weekdaysMin, e.$W, o, 2);
                        case "ddd":
                            return h(n.weekdaysShort, e.$W, o, 3);
                        case "dddd":
                            return o[e.$W];
                        case "H":
                            return String(s);
                        case "HH":
                            return b.s(s, 2, "0");
                        case "h":
                            return d(1);
                        case "hh":
                            return d(2);
                        case "a":
                            return $(s, u, !0);
                        case "A":
                            return $(s, u, !1);
                        case "m":
                            return String(u);
                        case "mm":
                            return b.s(u, 2, "0");
                        case "s":
                            return String(e.$s);
                        case "ss":
                            return b.s(e.$s, 2, "0");
                        case "SSS":
                            return b.s(e.$ms, 3, "0");
                        case "Z":
                            return i;
                    }
                    return null;
                }(t) || i.replace(":", "");
            });
        }, m.utcOffset = function() {
            return 15 * -Math.round(this.$d.getTimezoneOffset() / 15);
        }, m.diff = function(r, d, l) {
            var $, y = this, M = b.p(d), m = O(r), v = (m.utcOffset() - this.utcOffset()) * e, g = this - m, D = function() {
                return b.m(y, m);
            };
            switch(M){
                case h:
                    $ = D() / 12;
                    break;
                case c:
                    $ = D();
                    break;
                case f:
                    $ = D() / 3;
                    break;
                case o:
                    $ = (g - v) / 6048e5;
                    break;
                case a:
                    $ = (g - v) / 864e5;
                    break;
                case u:
                    $ = g / n;
                    break;
                case s:
                    $ = g / e;
                    break;
                case i:
                    $ = g / t;
                    break;
                default:
                    $ = g;
            }
            return l ? $ : b.a($);
        }, m.daysInMonth = function() {
            return this.endOf(c).$D;
        }, m.$locale = function() {
            return D[this.$L];
        }, m.locale = function(t, e) {
            if (!t) return this.$L;
            var n = this.clone(), r = w(t, e, !0);
            return r && (n.$L = r), n;
        }, m.clone = function() {
            return b.w(this.$d, this);
        }, m.toDate = function() {
            return new Date(this.valueOf());
        }, m.toJSON = function() {
            return this.isValid() ? this.toISOString() : null;
        }, m.toISOString = function() {
            return this.$d.toISOString();
        }, m.toString = function() {
            return this.$d.toUTCString();
        }, M;
    }(), k = _.prototype;
    return O.prototype = k, [
        [
            "$ms",
            r
        ],
        [
            "$s",
            i
        ],
        [
            "$m",
            s
        ],
        [
            "$H",
            u
        ],
        [
            "$W",
            a
        ],
        [
            "$M",
            c
        ],
        [
            "$y",
            h
        ],
        [
            "$D",
            d
        ]
    ].forEach(function(t) {
        k[t[1]] = function(e) {
            return this.$g(e, t[0], t[1]);
        };
    }), O.extend = function(t, e) {
        return t.$i || (t(e, _, O), t.$i = !0), O;
    }, O.locale = w, O.isDayjs = S, O.unix = function(t) {
        return O(1e3 * t);
    }, O.en = D[g], O.Ls = D, O.p = {}, O;
});


var $4c8fdbf43bda9a16$exports = {};
!function(e, t) {
    $4c8fdbf43bda9a16$exports = t();
}($4c8fdbf43bda9a16$exports, function() {
    "use strict";
    var e = "week", t = "year";
    return function(i, n, r) {
        var f = n.prototype;
        f.week = function(i) {
            if (void 0 === i && (i = null), null !== i) return this.add(7 * (i - this.week()), "day");
            var n = this.$locale().yearStart || 1;
            if (11 === this.month() && this.date() > 25) {
                var f = r(this).startOf(t).add(1, t).date(n), s = r(this).endOf(e);
                if (f.isBefore(s)) return 1;
            }
            var a = r(this).startOf(t).date(n).startOf(e).subtract(1, "millisecond"), o = this.diff(a, e, !0);
            return o < 0 ? r(this).startOf("week").week() : Math.ceil(o);
        }, f.weeks = function(e) {
            return void 0 === e && (e = null), this.week(e);
        };
    };
});


var $ec057641b203da3a$exports = {};
!function(e, t) {
    $ec057641b203da3a$exports = t();
}($ec057641b203da3a$exports, function() {
    "use strict";
    var e = {
        LTS: "h:mm:ss A",
        LT: "h:mm A",
        L: "MM/DD/YYYY",
        LL: "MMMM D, YYYY",
        LLL: "MMMM D, YYYY h:mm A",
        LLLL: "dddd, MMMM D, YYYY h:mm A"
    }, t = /(\[[^[]*\])|([-_:/.,()\s]+)|(A|a|Q|YYYY|YY?|ww?|MM?M?M?|Do|DD?|hh?|HH?|mm?|ss?|S{1,3}|z|ZZ?)/g, n = /\d/, r = /\d\d/, i = /\d\d?/, o = /\d*[^-_:/,()\s\d]+/, s = {}, a = function(e) {
        return (e = +e) + (e > 68 ? 1900 : 2e3);
    };
    var f = function(e) {
        return function(t) {
            this[e] = +t;
        };
    }, h = [
        /[+-]\d\d:?(\d\d)?|Z/,
        function(e) {
            (this.zone || (this.zone = {})).offset = function(e) {
                if (!e) return 0;
                if ("Z" === e) return 0;
                var t = e.match(/([+-]|\d\d)/g), n = 60 * t[1] + (+t[2] || 0);
                return 0 === n ? 0 : "+" === t[0] ? -n : n;
            }(e);
        }
    ], u = function(e) {
        var t = s[e];
        return t && (t.indexOf ? t : t.s.concat(t.f));
    }, d = function(e, t) {
        var n, r = s.meridiem;
        if (r) {
            for(var i = 1; i <= 24; i += 1)if (e.indexOf(r(i, 0, t)) > -1) {
                n = i > 12;
                break;
            }
        } else n = e === (t ? "pm" : "PM");
        return n;
    }, c = {
        A: [
            o,
            function(e) {
                this.afternoon = d(e, !1);
            }
        ],
        a: [
            o,
            function(e) {
                this.afternoon = d(e, !0);
            }
        ],
        Q: [
            n,
            function(e) {
                this.month = 3 * (e - 1) + 1;
            }
        ],
        S: [
            n,
            function(e) {
                this.milliseconds = 100 * +e;
            }
        ],
        SS: [
            r,
            function(e) {
                this.milliseconds = 10 * +e;
            }
        ],
        SSS: [
            /\d{3}/,
            function(e) {
                this.milliseconds = +e;
            }
        ],
        s: [
            i,
            f("seconds")
        ],
        ss: [
            i,
            f("seconds")
        ],
        m: [
            i,
            f("minutes")
        ],
        mm: [
            i,
            f("minutes")
        ],
        H: [
            i,
            f("hours")
        ],
        h: [
            i,
            f("hours")
        ],
        HH: [
            i,
            f("hours")
        ],
        hh: [
            i,
            f("hours")
        ],
        D: [
            i,
            f("day")
        ],
        DD: [
            r,
            f("day")
        ],
        Do: [
            o,
            function(e) {
                var t = s.ordinal, n = e.match(/\d+/);
                if (this.day = n[0], t) for(var r = 1; r <= 31; r += 1)t(r).replace(/\[|\]/g, "") === e && (this.day = r);
            }
        ],
        w: [
            i,
            f("week")
        ],
        ww: [
            r,
            f("week")
        ],
        M: [
            i,
            f("month")
        ],
        MM: [
            r,
            f("month")
        ],
        MMM: [
            o,
            function(e) {
                var t = u("months"), n = (u("monthsShort") || t.map(function(e) {
                    return e.slice(0, 3);
                })).indexOf(e) + 1;
                if (n < 1) throw new Error;
                this.month = n % 12 || n;
            }
        ],
        MMMM: [
            o,
            function(e) {
                var t = u("months").indexOf(e) + 1;
                if (t < 1) throw new Error;
                this.month = t % 12 || t;
            }
        ],
        Y: [
            /[+-]?\d+/,
            f("year")
        ],
        YY: [
            r,
            function(e) {
                this.year = a(e);
            }
        ],
        YYYY: [
            /\d{4}/,
            f("year")
        ],
        Z: h,
        ZZ: h
    };
    function l(n) {
        var r, i;
        r = n, i = s && s.formats;
        for(var o = (n = r.replace(/(\[[^\]]+])|(LTS?|l{1,4}|L{1,4})/g, function(t, n, r) {
            var o = r && r.toUpperCase();
            return n || i[r] || e[r] || i[o].replace(/(\[[^\]]+])|(MMMM|MM|DD|dddd)/g, function(e, t, n) {
                return t || n.slice(1);
            });
        })).match(t), a = o.length, f = 0; f < a; f += 1){
            var h = o[f], u = c[h], d = u && u[0], l = u && u[1];
            o[f] = l ? {
                regex: d,
                parser: l
            } : h.replace(/^\[|\]$/g, "");
        }
        return function(e) {
            for(var t = {}, n = 0, r = 0; n < a; n += 1){
                var i = o[n];
                if ("string" == typeof i) r += i.length;
                else {
                    var s = i.regex, f = i.parser, h = e.slice(r), u = s.exec(h)[0];
                    f.call(t, u), e = e.replace(u, "");
                }
            }
            return function(e) {
                var t = e.afternoon;
                if (void 0 !== t) {
                    var n = e.hours;
                    t ? n < 12 && (e.hours += 12) : 12 === n && (e.hours = 0), delete e.afternoon;
                }
            }(t), t;
        };
    }
    return function(e, t, n) {
        n.p.customParseFormat = !0, e && e.parseTwoDigitYear && (a = e.parseTwoDigitYear);
        var r = t.prototype, i = r.parse;
        r.parse = function(e) {
            var t = e.date, r = e.utc, o = e.args;
            this.$u = r;
            var a = o[1];
            if ("string" == typeof a) {
                var f = !0 === o[2], h = !0 === o[3], u = f || h, d = o[2];
                h && (d = o[2]), s = this.$locale(), !f && d && (s = n.Ls[d]), this.$d = function(e, t, n, r) {
                    try {
                        if ([
                            "x",
                            "X"
                        ].indexOf(t) > -1) return new Date(("X" === t ? 1e3 : 1) * e);
                        var i = l(t)(e), o = i.year, s = i.month, a = i.day, f = i.hours, h = i.minutes, u = i.seconds, d = i.milliseconds, c = i.zone, m = i.week, M = new Date, Y = a || (o || s ? 1 : M.getDate()), p = o || M.getFullYear(), v = 0;
                        o && !s || (v = s > 0 ? s - 1 : M.getMonth());
                        var D, w = f || 0, g = h || 0, y = u || 0, L = d || 0;
                        return c ? new Date(Date.UTC(p, v, Y, w, g, y, L + 60 * c.offset * 1e3)) : n ? new Date(Date.UTC(p, v, Y, w, g, y, L)) : (D = new Date(p, v, Y, w, g, y, L), m && (D = r(D).week(m).toDate()), D);
                    } catch (e) {
                        return new Date("");
                    }
                }(t, a, r, n), this.init(), d && !0 !== d && (this.$L = this.locale(d).$L), u && t != this.format(a) && (this.$d = new Date("")), s = {};
            } else if (a instanceof Array) for(var c = a.length, m = 1; m <= c; m += 1){
                o[1] = a[m - 1];
                var M = n.apply(this, o);
                if (M.isValid()) {
                    this.$d = M.$d, this.$L = M.$L, this.init();
                    break;
                }
                m === c && (this.$d = new Date(""));
            }
            else i.call(this, e);
        };
    };
});


var $593890d129eeca2e$exports = {};
!function(e, t) {
    $593890d129eeca2e$exports = t();
}($593890d129eeca2e$exports, function() {
    "use strict";
    var e = {
        LTS: "h:mm:ss A",
        LT: "h:mm A",
        L: "MM/DD/YYYY",
        LL: "MMMM D, YYYY",
        LLL: "MMMM D, YYYY h:mm A",
        LLLL: "dddd, MMMM D, YYYY h:mm A"
    };
    return function(t, o, n) {
        var r = o.prototype, i = r.format;
        n.en.formats = e, r.format = function(t) {
            void 0 === t && (t = "YYYY-MM-DDTHH:mm:ssZ");
            var o = this.$locale().formats, n = function(t, o) {
                return t.replace(/(\[[^\]]+])|(LTS?|l{1,4}|L{1,4})/g, function(t, n, r) {
                    var i = r && r.toUpperCase();
                    return n || o[r] || e[r] || o[i].replace(/(\[[^\]]+])|(MMMM|MM|DD|dddd)/g, function(e, t, o) {
                        return t || o.slice(1);
                    });
                });
            }(t, void 0 === o ? {} : o);
            return i.call(this, n);
        };
    };
});


var $412891423eadb958$exports = {};
!function(e, i) {
    $412891423eadb958$exports = i();
}($412891423eadb958$exports, function() {
    "use strict";
    return function(e, i, t) {
        i.prototype.isBetween = function(e, i, s, f) {
            var n = t(e), o = t(i), r = "(" === (f = f || "()")[0], u = ")" === f[1];
            return (r ? this.isAfter(n, s) : !this.isBefore(n, s)) && (u ? this.isBefore(o, s) : !this.isAfter(o, s)) || (r ? this.isBefore(n, s) : !this.isAfter(n, s)) && (u ? this.isAfter(o, s) : !this.isBefore(o, s));
        };
    };
});


const $e8329ce24b20e515$export$be61413ca3629f52 = (message)=>{
    let alreadyWarned = false;
    var deprecatedProps;
    return ()=>{};
};
const $e8329ce24b20e515$export$baf331755d84b871 = (message, gravity = 'warning')=>{
    let alreadyWarned = false;
    const cleanMessage = Array.isArray(message) ? message.join('\n') : message;
    return ()=>{
        if (!alreadyWarned) {
            alreadyWarned = true;
            if (gravity === 'error') console.error(cleanMessage);
            else console.warn(cleanMessage);
        }
    };
};


(0, (/*@__PURE__*/$parcel$interopDefault($9334e2afb1a2ce43$exports))).extend((0, (/*@__PURE__*/$parcel$interopDefault($ec057641b203da3a$exports))));
(0, (/*@__PURE__*/$parcel$interopDefault($9334e2afb1a2ce43$exports))).extend((0, (/*@__PURE__*/$parcel$interopDefault($593890d129eeca2e$exports))));
(0, (/*@__PURE__*/$parcel$interopDefault($9334e2afb1a2ce43$exports))).extend((0, (/*@__PURE__*/$parcel$interopDefault($412891423eadb958$exports))));
const $849ce0a30691b194$var$localeNotFoundWarning = (0, $e8329ce24b20e515$export$baf331755d84b871)([
    'Your locale has not been found.',
    'Either the locale key is not a supported one. Locales supported by dayjs are available here: https://github.com/iamkun/dayjs/tree/dev/src/locale',
    "Or you forget to import the locale from 'dayjs/locale/{localeUsed}'",
    'fallback on English locale'
]);
const $849ce0a30691b194$var$formatTokenMap = {
    // Year
    YY: 'year',
    YYYY: {
        sectionType: 'year',
        contentType: 'digit',
        maxLength: 4
    },
    // Month
    M: {
        sectionType: 'month',
        contentType: 'digit',
        maxLength: 2
    },
    MM: 'month',
    MMM: {
        sectionType: 'month',
        contentType: 'letter'
    },
    MMMM: {
        sectionType: 'month',
        contentType: 'letter'
    },
    // Day of the month
    D: {
        sectionType: 'day',
        contentType: 'digit',
        maxLength: 2
    },
    DD: 'day',
    Do: {
        sectionType: 'day',
        contentType: 'digit-with-letter'
    },
    // Day of the week
    d: {
        sectionType: 'weekDay',
        contentType: 'digit',
        maxLength: 2
    },
    dd: {
        sectionType: 'weekDay',
        contentType: 'letter'
    },
    ddd: {
        sectionType: 'weekDay',
        contentType: 'letter'
    },
    dddd: {
        sectionType: 'weekDay',
        contentType: 'letter'
    },
    // Meridiem
    A: 'meridiem',
    a: 'meridiem',
    // Hours
    H: {
        sectionType: 'hours',
        contentType: 'digit',
        maxLength: 2
    },
    HH: 'hours',
    h: {
        sectionType: 'hours',
        contentType: 'digit',
        maxLength: 2
    },
    hh: 'hours',
    // Minutes
    m: {
        sectionType: 'minutes',
        contentType: 'digit',
        maxLength: 2
    },
    mm: 'minutes',
    // Seconds
    s: {
        sectionType: 'seconds',
        contentType: 'digit',
        maxLength: 2
    },
    ss: 'seconds'
};
const $849ce0a30691b194$var$defaultFormats = {
    year: 'YYYY',
    month: 'MMMM',
    monthShort: 'MMM',
    dayOfMonth: 'D',
    weekday: 'dddd',
    weekdayShort: 'dd',
    hours24h: 'HH',
    hours12h: 'hh',
    meridiem: 'A',
    minutes: 'mm',
    seconds: 'ss',
    fullDate: 'll',
    fullDateWithWeekday: 'dddd, LL',
    keyboardDate: 'L',
    shortDate: 'MMM D',
    normalDate: 'D MMMM',
    normalDateWithWeekday: 'ddd, MMM D',
    monthAndYear: 'MMMM YYYY',
    monthAndDate: 'MMMM D',
    fullTime: 'LT',
    fullTime12h: 'hh:mm A',
    fullTime24h: 'HH:mm',
    fullDateTime: 'lll',
    fullDateTime12h: 'll hh:mm A',
    fullDateTime24h: 'll HH:mm',
    keyboardDateTime: 'L LT',
    keyboardDateTime12h: 'L hh:mm A',
    keyboardDateTime24h: 'L HH:mm'
};
const $849ce0a30691b194$var$MISSING_UTC_PLUGIN = [
    'Missing UTC plugin',
    'To be able to use UTC or timezones, you have to enable the `utc` plugin',
    'Find more information on https://mui.com/x/react-date-pickers/timezone/#day-js-and-utc'
].join('\n');
const $849ce0a30691b194$var$MISSING_TIMEZONE_PLUGIN = [
    'Missing timezone plugin',
    'To be able to use timezones, you have to enable both the `utc` and the `timezone` plugin',
    'Find more information on https://mui.com/x/react-date-pickers/timezone/#day-js-and-timezone'
].join('\n');
const $849ce0a30691b194$var$withLocale = (dayjs, locale)=>!locale ? dayjs : (...args)=>dayjs(...args).locale(locale);
class $849ce0a30691b194$export$33545c6a80bae043 {
    constructor({ locale: _locale, formats: formats, instance: instance } = {}){
        var _this$rawDayJsInstanc;
        this.isMUIAdapter = true;
        this.isTimezoneCompatible = true;
        this.lib = 'dayjs';
        this.rawDayJsInstance = void 0;
        this.dayjs = void 0;
        this.locale = void 0;
        this.formats = void 0;
        this.escapedCharacters = {
            start: '[',
            end: ']'
        };
        this.formatTokenMap = $849ce0a30691b194$var$formatTokenMap;
        this.setLocaleToValue = (value)=>{
            const expectedLocale = this.getCurrentLocaleCode();
            if (expectedLocale === value.locale()) return value;
            return value.locale(expectedLocale);
        };
        this.hasUTCPlugin = ()=>typeof (0, (/*@__PURE__*/$parcel$interopDefault($9334e2afb1a2ce43$exports))).utc !== 'undefined';
        this.hasTimezonePlugin = ()=>typeof (0, (/*@__PURE__*/$parcel$interopDefault($9334e2afb1a2ce43$exports))).tz !== 'undefined';
        this.isSame = (value, comparing, comparisonTemplate)=>{
            const comparingInValueTimezone = this.setTimezone(comparing, this.getTimezone(value));
            return value.format(comparisonTemplate) === comparingInValueTimezone.format(comparisonTemplate);
        };
        /**
     * Replaces "default" by undefined and "system" by the system timezone before passing it to `dayjs`.
     */ this.cleanTimezone = (timezone)=>{
            switch(timezone){
                case 'default':
                    return undefined;
                case 'system':
                    return (0, (/*@__PURE__*/$parcel$interopDefault($9334e2afb1a2ce43$exports))).tz.guess();
                default:
                    return timezone;
            }
        };
        this.createSystemDate = (value)=>{
            // TODO v7: Stop using `this.rawDayJsInstance` (drop the `instance` param on the adapters)
            /* istanbul ignore next */ if (this.rawDayJsInstance) return this.rawDayJsInstance(value);
            if (this.hasUTCPlugin() && this.hasTimezonePlugin()) {
                const timezone = (0, (/*@__PURE__*/$parcel$interopDefault($9334e2afb1a2ce43$exports))).tz.guess();
                // We can't change the system timezone in the tests
                /* istanbul ignore next */ if (timezone !== 'UTC') return (0, (/*@__PURE__*/$parcel$interopDefault($9334e2afb1a2ce43$exports))).tz(value, timezone);
                return (0, (/*@__PURE__*/$parcel$interopDefault($9334e2afb1a2ce43$exports)))(value);
            }
            return (0, (/*@__PURE__*/$parcel$interopDefault($9334e2afb1a2ce43$exports)))(value);
        };
        this.createUTCDate = (value)=>{
            /* istanbul ignore next */ if (!this.hasUTCPlugin()) throw new Error($849ce0a30691b194$var$MISSING_UTC_PLUGIN);
            return (0, (/*@__PURE__*/$parcel$interopDefault($9334e2afb1a2ce43$exports))).utc(value);
        };
        this.createTZDate = (value, timezone)=>{
            /* istanbul ignore next */ if (!this.hasUTCPlugin()) throw new Error($849ce0a30691b194$var$MISSING_UTC_PLUGIN);
            /* istanbul ignore next */ if (!this.hasTimezonePlugin()) throw new Error($849ce0a30691b194$var$MISSING_TIMEZONE_PLUGIN);
            const keepLocalTime = value !== undefined && !value.endsWith('Z');
            return (0, (/*@__PURE__*/$parcel$interopDefault($9334e2afb1a2ce43$exports)))(value).tz(this.cleanTimezone(timezone), keepLocalTime);
        };
        this.getLocaleFormats = ()=>{
            const locales = (0, (/*@__PURE__*/$parcel$interopDefault($9334e2afb1a2ce43$exports))).Ls;
            const locale = this.locale || 'en';
            let localeObject = locales[locale];
            if (localeObject === undefined) {
                $849ce0a30691b194$var$localeNotFoundWarning();
                localeObject = locales.en;
            }
            return localeObject.formats;
        };
        /**
     * If the new day does not have the same offset as the old one (when switching to summer day time for example),
     * Then dayjs will not automatically adjust the offset (moment does).
     * We have to parse again the value to make sure the `fixOffset` method is applied.
     * See https://github.com/iamkun/dayjs/blob/b3624de619d6e734cd0ffdbbd3502185041c1b60/src/plugin/timezone/index.js#L72
     */ this.adjustOffset = (value)=>{
            if (!this.hasTimezonePlugin()) return value;
            const timezone = this.getTimezone(value);
            if (timezone !== 'UTC') {
                var _fixedValue$$offset, _value$$offset;
                const fixedValue = value.tz(this.cleanTimezone(timezone), true);
                // @ts-ignore
                if (((_fixedValue$$offset = fixedValue.$offset) != null ? _fixedValue$$offset : 0) === ((_value$$offset = value.$offset) != null ? _value$$offset : 0)) return value;
                // Change only what is needed to avoid creating a new object with unwanted data
                // Especially important when used in an environment where utc or timezone dates are used only in some places
                // Reference: https://github.com/mui/mui-x/issues/13290
                // @ts-ignore
                value.$offset = fixedValue.$offset;
            }
            return value;
        };
        this.date = (value)=>{
            if (value === null) return null;
            return this.dayjs(value);
        };
        this.dateWithTimezone = (value, timezone)=>{
            if (value === null) return null;
            let parsedValue;
            if (timezone === 'UTC') parsedValue = this.createUTCDate(value);
            else if (timezone === 'system' || timezone === 'default' && !this.hasTimezonePlugin()) parsedValue = this.createSystemDate(value);
            else parsedValue = this.createTZDate(value, timezone);
            if (this.locale === undefined) return parsedValue;
            return parsedValue.locale(this.locale);
        };
        this.getTimezone = (value)=>{
            if (this.hasTimezonePlugin()) {
                var _value$$x;
                // @ts-ignore
                const zone = (_value$$x = value.$x) == null ? void 0 : _value$$x.$timezone;
                if (zone) return zone;
            }
            if (this.hasUTCPlugin() && value.isUTC()) return 'UTC';
            return 'system';
        };
        this.setTimezone = (value, timezone)=>{
            if (this.getTimezone(value) === timezone) return value;
            if (timezone === 'UTC') {
                /* istanbul ignore next */ if (!this.hasUTCPlugin()) throw new Error($849ce0a30691b194$var$MISSING_UTC_PLUGIN);
                return value.utc();
            }
            // We know that we have the UTC plugin.
            // Otherwise, the value timezone would always equal "system".
            // And it would be caught by the first "if" of this method.
            if (timezone === 'system') return value.local();
            if (!this.hasTimezonePlugin()) {
                if (timezone === 'default') return value;
                /* istanbul ignore next */ throw new Error($849ce0a30691b194$var$MISSING_TIMEZONE_PLUGIN);
            }
            return (0, (/*@__PURE__*/$parcel$interopDefault($9334e2afb1a2ce43$exports))).tz(value, this.cleanTimezone(timezone));
        };
        this.toJsDate = (value)=>{
            return value.toDate();
        };
        this.parseISO = (isoString)=>{
            return this.dayjs(isoString);
        };
        this.toISO = (value)=>{
            return value.toISOString();
        };
        this.parse = (value, format)=>{
            if (value === '') return null;
            return this.dayjs(value, format, this.locale, true);
        };
        this.getCurrentLocaleCode = ()=>{
            return this.locale || 'en';
        };
        this.is12HourCycleInCurrentLocale = ()=>{
            /* istanbul ignore next */ return /A|a/.test(this.getLocaleFormats().LT || '');
        };
        this.expandFormat = (format)=>{
            const localeFormats = this.getLocaleFormats();
            // @see https://github.com/iamkun/dayjs/blob/dev/src/plugin/localizedFormat/index.js
            const t = (formatBis)=>formatBis.replace(/(\[[^\]]+])|(MMMM|MM|DD|dddd)/g, (_, a, b)=>a || b.slice(1));
            return format.replace(/(\[[^\]]+])|(LTS?|l{1,4}|L{1,4})/g, (_, a, b)=>{
                const B = b && b.toUpperCase();
                return a || localeFormats[b] || t(localeFormats[B]);
            });
        };
        this.getFormatHelperText = (format)=>{
            return this.expandFormat(format).replace(/a/gi, '(a|p)m').toLocaleLowerCase();
        };
        this.isNull = (value)=>{
            return value === null;
        };
        this.isValid = (value)=>{
            return this.dayjs(value).isValid();
        };
        this.format = (value, formatKey)=>{
            return this.formatByString(value, this.formats[formatKey]);
        };
        this.formatByString = (value, formatString)=>{
            return this.dayjs(value).format(formatString);
        };
        this.formatNumber = (numberToFormat)=>{
            return numberToFormat;
        };
        this.getDiff = (value, comparing, unit)=>{
            return value.diff(comparing, unit);
        };
        this.isEqual = (value, comparing)=>{
            if (value === null && comparing === null) return true;
            return this.dayjs(value).toDate().getTime() === this.dayjs(comparing).toDate().getTime();
        };
        this.isSameYear = (value, comparing)=>{
            return this.isSame(value, comparing, 'YYYY');
        };
        this.isSameMonth = (value, comparing)=>{
            return this.isSame(value, comparing, 'YYYY-MM');
        };
        this.isSameDay = (value, comparing)=>{
            return this.isSame(value, comparing, 'YYYY-MM-DD');
        };
        this.isSameHour = (value, comparing)=>{
            return value.isSame(comparing, 'hour');
        };
        this.isAfter = (value, comparing)=>{
            return value > comparing;
        };
        this.isAfterYear = (value, comparing)=>{
            if (!this.hasUTCPlugin()) return value.isAfter(comparing, 'year');
            return !this.isSameYear(value, comparing) && value.utc() > comparing.utc();
        };
        this.isAfterDay = (value, comparing)=>{
            if (!this.hasUTCPlugin()) return value.isAfter(comparing, 'day');
            return !this.isSameDay(value, comparing) && value.utc() > comparing.utc();
        };
        this.isBefore = (value, comparing)=>{
            return value < comparing;
        };
        this.isBeforeYear = (value, comparing)=>{
            if (!this.hasUTCPlugin()) return value.isBefore(comparing, 'year');
            return !this.isSameYear(value, comparing) && value.utc() < comparing.utc();
        };
        this.isBeforeDay = (value, comparing)=>{
            if (!this.hasUTCPlugin()) return value.isBefore(comparing, 'day');
            return !this.isSameDay(value, comparing) && value.utc() < comparing.utc();
        };
        this.isWithinRange = (value, [start, end])=>{
            return value >= start && value <= end;
        };
        this.startOfYear = (value)=>{
            return this.adjustOffset(value.startOf('year'));
        };
        this.startOfMonth = (value)=>{
            return this.adjustOffset(value.startOf('month'));
        };
        this.startOfWeek = (value)=>{
            return this.adjustOffset(value.startOf('week'));
        };
        this.startOfDay = (value)=>{
            return this.adjustOffset(value.startOf('day'));
        };
        this.endOfYear = (value)=>{
            return this.adjustOffset(value.endOf('year'));
        };
        this.endOfMonth = (value)=>{
            return this.adjustOffset(value.endOf('month'));
        };
        this.endOfWeek = (value)=>{
            return this.adjustOffset(value.endOf('week'));
        };
        this.endOfDay = (value)=>{
            return this.adjustOffset(value.endOf('day'));
        };
        this.addYears = (value, amount)=>{
            return this.adjustOffset(amount < 0 ? value.subtract(Math.abs(amount), 'year') : value.add(amount, 'year'));
        };
        this.addMonths = (value, amount)=>{
            return this.adjustOffset(amount < 0 ? value.subtract(Math.abs(amount), 'month') : value.add(amount, 'month'));
        };
        this.addWeeks = (value, amount)=>{
            return this.adjustOffset(amount < 0 ? value.subtract(Math.abs(amount), 'week') : value.add(amount, 'week'));
        };
        this.addDays = (value, amount)=>{
            return this.adjustOffset(amount < 0 ? value.subtract(Math.abs(amount), 'day') : value.add(amount, 'day'));
        };
        this.addHours = (value, amount)=>{
            return this.adjustOffset(amount < 0 ? value.subtract(Math.abs(amount), 'hour') : value.add(amount, 'hour'));
        };
        this.addMinutes = (value, amount)=>{
            return this.adjustOffset(amount < 0 ? value.subtract(Math.abs(amount), 'minute') : value.add(amount, 'minute'));
        };
        this.addSeconds = (value, amount)=>{
            return this.adjustOffset(amount < 0 ? value.subtract(Math.abs(amount), 'second') : value.add(amount, 'second'));
        };
        this.getYear = (value)=>{
            return value.year();
        };
        this.getMonth = (value)=>{
            return value.month();
        };
        this.getDate = (value)=>{
            return value.date();
        };
        this.getHours = (value)=>{
            return value.hour();
        };
        this.getMinutes = (value)=>{
            return value.minute();
        };
        this.getSeconds = (value)=>{
            return value.second();
        };
        this.getMilliseconds = (value)=>{
            return value.millisecond();
        };
        this.setYear = (value, year)=>{
            return this.adjustOffset(value.set('year', year));
        };
        this.setMonth = (value, month)=>{
            return this.adjustOffset(value.set('month', month));
        };
        this.setDate = (value, date)=>{
            return this.adjustOffset(value.set('date', date));
        };
        this.setHours = (value, hours)=>{
            return this.adjustOffset(value.set('hour', hours));
        };
        this.setMinutes = (value, minutes)=>{
            return this.adjustOffset(value.set('minute', minutes));
        };
        this.setSeconds = (value, seconds)=>{
            return this.adjustOffset(value.set('second', seconds));
        };
        this.setMilliseconds = (value, milliseconds)=>{
            return this.adjustOffset(value.set('millisecond', milliseconds));
        };
        this.getDaysInMonth = (value)=>{
            return value.daysInMonth();
        };
        this.getNextMonth = (value)=>{
            return this.addMonths(value, 1);
        };
        this.getPreviousMonth = (value)=>{
            return this.addMonths(value, -1);
        };
        this.getMonthArray = (value)=>{
            const firstMonth = value.startOf('year');
            const monthArray = [
                firstMonth
            ];
            while(monthArray.length < 12){
                const prevMonth = monthArray[monthArray.length - 1];
                monthArray.push(this.addMonths(prevMonth, 1));
            }
            return monthArray;
        };
        this.mergeDateAndTime = (dateParam, timeParam)=>{
            return dateParam.hour(timeParam.hour()).minute(timeParam.minute()).second(timeParam.second());
        };
        this.getWeekdays = ()=>{
            const start = this.dayjs().startOf('week');
            return [
                0,
                1,
                2,
                3,
                4,
                5,
                6
            ].map((diff)=>this.formatByString(this.addDays(start, diff), 'dd'));
        };
        this.getWeekArray = (value)=>{
            const cleanValue = this.setLocaleToValue(value);
            const start = cleanValue.startOf('month').startOf('week');
            const end = cleanValue.endOf('month').endOf('week');
            let count = 0;
            let current = start;
            const nestedWeeks = [];
            while(current < end){
                const weekNumber = Math.floor(count / 7);
                nestedWeeks[weekNumber] = nestedWeeks[weekNumber] || [];
                nestedWeeks[weekNumber].push(current);
                current = this.addDays(current, 1);
                count += 1;
            }
            return nestedWeeks;
        };
        this.getWeekNumber = (value)=>{
            return value.week();
        };
        this.getYearRange = (start, end)=>{
            const startDate = start.startOf('year');
            const endDate = end.endOf('year');
            const years = [];
            let current = startDate;
            while(current < endDate){
                years.push(current);
                current = this.addYears(current, 1);
            }
            return years;
        };
        this.getMeridiemText = (ampm)=>{
            return ampm === 'am' ? 'AM' : 'PM';
        };
        this.rawDayJsInstance = instance;
        this.dayjs = $849ce0a30691b194$var$withLocale((_this$rawDayJsInstanc = this.rawDayJsInstance) != null ? _this$rawDayJsInstanc : (0, (/*@__PURE__*/$parcel$interopDefault($9334e2afb1a2ce43$exports))), _locale);
        this.locale = _locale;
        this.formats = (0, $3VnFq.default)({}, $849ce0a30691b194$var$defaultFormats, formats);
        (0, (/*@__PURE__*/$parcel$interopDefault($9334e2afb1a2ce43$exports))).extend((0, (/*@__PURE__*/$parcel$interopDefault($4c8fdbf43bda9a16$exports))));
    }
}


/**
 * React Router DOM v6.30.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $gJYWc = parcelRequire("gJYWc");

/**
 * @remix-run/router v1.23.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ function $ed8eb2d58084204c$var$_extends() {
    $ed8eb2d58084204c$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $ed8eb2d58084204c$var$_extends.apply(this, arguments);
}
////////////////////////////////////////////////////////////////////////////////
//#region Types and Constants
////////////////////////////////////////////////////////////////////////////////
/**
 * Actions represent the type of change to a location value.
 */ var $ed8eb2d58084204c$export$e19cd5f9376f8cee;
(function(Action) {
    /**
   * A POP indicates a change to an arbitrary index in the history stack, such
   * as a back or forward navigation. It does not describe the direction of the
   * navigation, only that the current index changed.
   *
   * Note: This is the default action for newly created history objects.
   */ Action["Pop"] = "POP";
    /**
   * A PUSH indicates a new entry being added to the history stack, such as when
   * a link is clicked and a new page loads. When this happens, all subsequent
   * entries in the stack are lost.
   */ Action["Push"] = "PUSH";
    /**
   * A REPLACE indicates the entry at the current index in the history stack
   * being replaced by a new one.
   */ Action["Replace"] = "REPLACE";
})($ed8eb2d58084204c$export$e19cd5f9376f8cee || ($ed8eb2d58084204c$export$e19cd5f9376f8cee = {}));
const $ed8eb2d58084204c$var$PopStateEventType = "popstate";
/**
 * Memory history stores the current location in memory. It is designed for use
 * in stateful non-browser environments like tests and React Native.
 */ function $ed8eb2d58084204c$export$2b76ad033c6e6d08(options) {
    if (options === void 0) options = {};
    let { initialEntries: initialEntries = [
        "/"
    ], initialIndex: initialIndex, v5Compat: v5Compat = false } = options;
    let entries; // Declare so we can access from createMemoryLocation
    entries = initialEntries.map((entry, index)=>createMemoryLocation(entry, typeof entry === "string" ? null : entry.state, index === 0 ? "default" : undefined));
    let index = clampIndex(initialIndex == null ? entries.length - 1 : initialIndex);
    let action = $ed8eb2d58084204c$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    function clampIndex(n) {
        return Math.min(Math.max(n, 0), entries.length - 1);
    }
    function getCurrentLocation() {
        return entries[index];
    }
    function createMemoryLocation(to, state, key) {
        if (state === void 0) state = null;
        let location = $ed8eb2d58084204c$var$createLocation(entries ? getCurrentLocation().pathname : "/", to, state, key);
        $ed8eb2d58084204c$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in memory history: " + JSON.stringify(to));
        return location;
    }
    function createHref(to) {
        return typeof to === "string" ? to : $ed8eb2d58084204c$export$fe53371bee54353d(to);
    }
    let history = {
        get index () {
            return index;
        },
        get action () {
            return action;
        },
        get location () {
            return getCurrentLocation();
        },
        createHref: createHref,
        createURL (to) {
            return new URL(createHref(to), "http://localhost");
        },
        encodeLocation (to) {
            let path = typeof to === "string" ? $ed8eb2d58084204c$export$8ccf933b0513f8d0(to) : to;
            return {
                pathname: path.pathname || "",
                search: path.search || "",
                hash: path.hash || ""
            };
        },
        push (to, state) {
            action = $ed8eb2d58084204c$export$e19cd5f9376f8cee.Push;
            let nextLocation = createMemoryLocation(to, state);
            index += 1;
            entries.splice(index, entries.length, nextLocation);
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 1
            });
        },
        replace (to, state) {
            action = $ed8eb2d58084204c$export$e19cd5f9376f8cee.Replace;
            let nextLocation = createMemoryLocation(to, state);
            entries[index] = nextLocation;
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 0
            });
        },
        go (delta) {
            action = $ed8eb2d58084204c$export$e19cd5f9376f8cee.Pop;
            let nextIndex = clampIndex(index + delta);
            let nextLocation = entries[nextIndex];
            index = nextIndex;
            if (listener) listener({
                action: action,
                location: nextLocation,
                delta: delta
            });
        },
        listen (fn) {
            listener = fn;
            return ()=>{
                listener = null;
            };
        }
    };
    return history;
}
/**
 * Browser history stores the location in regular URLs. This is the standard for
 * most web apps, but it requires some configuration on the server to ensure you
 * serve the same app at multiple URLs.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createbrowserhistory
 */ function $ed8eb2d58084204c$export$719fc203c4e16dee(options) {
    if (options === void 0) options = {};
    function createBrowserLocation(window1, globalHistory) {
        let { pathname: pathname, search: search, hash: hash } = window1.location;
        return $ed8eb2d58084204c$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createBrowserHref(window1, to) {
        return typeof to === "string" ? to : $ed8eb2d58084204c$export$fe53371bee54353d(to);
    }
    return $ed8eb2d58084204c$var$getUrlBasedHistory(createBrowserLocation, createBrowserHref, null, options);
}
/**
 * Hash history stores the location in window.location.hash. This makes it ideal
 * for situations where you don't want to send the location to the server for
 * some reason, either because you do cannot configure it or the URL space is
 * reserved for something else.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createhashhistory
 */ function $ed8eb2d58084204c$export$b71fdd3798280242(options) {
    if (options === void 0) options = {};
    function createHashLocation(window1, globalHistory) {
        let { pathname: pathname = "/", search: search = "", hash: hash = "" } = $ed8eb2d58084204c$export$8ccf933b0513f8d0(window1.location.hash.substr(1));
        // Hash URL should always have a leading / just like window.location.pathname
        // does, so if an app ends up at a route like /#something then we add a
        // leading slash so all of our path-matching behaves the same as if it would
        // in a browser router.  This is particularly important when there exists a
        // root splat route (<Route path="*">) since that matches internally against
        // "/*" and we'd expect /#something to 404 in a hash router app.
        if (!pathname.startsWith("/") && !pathname.startsWith(".")) pathname = "/" + pathname;
        return $ed8eb2d58084204c$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createHashHref(window1, to) {
        let base = window1.document.querySelector("base");
        let href = "";
        if (base && base.getAttribute("href")) {
            let url = window1.location.href;
            let hashIndex = url.indexOf("#");
            href = hashIndex === -1 ? url : url.slice(0, hashIndex);
        }
        return href + "#" + (typeof to === "string" ? to : $ed8eb2d58084204c$export$fe53371bee54353d(to));
    }
    function validateHashLocation(location, to) {
        $ed8eb2d58084204c$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in hash history.push(" + JSON.stringify(to) + ")");
    }
    return $ed8eb2d58084204c$var$getUrlBasedHistory(createHashLocation, createHashHref, validateHashLocation, options);
}
function $ed8eb2d58084204c$export$3e9cee6b33872309(value, message) {
    if (value === false || value === null || typeof value === "undefined") throw new Error(message);
}
function $ed8eb2d58084204c$export$c0e02632e14916fd(cond, message) {
    if (!cond) {
        // eslint-disable-next-line no-console
        if (typeof console !== "undefined") console.warn(message);
        try {
            // Welcome to debugging history!
            //
            // This error is thrown as a convenience, so you can more easily
            // find the source for a warning that appears in the console by
            // enabling "pause on exceptions" in your JavaScript debugger.
            throw new Error(message);
        // eslint-disable-next-line no-empty
        } catch (e) {}
    }
}
function $ed8eb2d58084204c$var$createKey() {
    return Math.random().toString(36).substr(2, 8);
}
/**
 * For browser-based histories, we combine the state and key into an object
 */ function $ed8eb2d58084204c$var$getHistoryState(location, index) {
    return {
        usr: location.state,
        key: location.key,
        idx: index
    };
}
/**
 * Creates a Location object with a unique key from the given Path
 */ function $ed8eb2d58084204c$var$createLocation(current, to, state, key) {
    if (state === void 0) state = null;
    let location = $ed8eb2d58084204c$var$_extends({
        pathname: typeof current === "string" ? current : current.pathname,
        search: "",
        hash: ""
    }, typeof to === "string" ? $ed8eb2d58084204c$export$8ccf933b0513f8d0(to) : to, {
        state: state,
        // TODO: This could be cleaned up.  push/replace should probably just take
        // full Locations now and avoid the need to run through this flow at all
        // But that's a pretty big refactor to the current test suite so going to
        // keep as is for the time being and just let any incoming keys take precedence
        key: to && to.key || key || $ed8eb2d58084204c$var$createKey()
    });
    return location;
}
/**
 * Creates a string URL path from the given pathname, search, and hash components.
 */ function $ed8eb2d58084204c$export$fe53371bee54353d(_ref) {
    let { pathname: pathname = "/", search: search = "", hash: hash = "" } = _ref;
    if (search && search !== "?") pathname += search.charAt(0) === "?" ? search : "?" + search;
    if (hash && hash !== "#") pathname += hash.charAt(0) === "#" ? hash : "#" + hash;
    return pathname;
}
/**
 * Parses a string URL path into its separate pathname, search, and hash components.
 */ function $ed8eb2d58084204c$export$8ccf933b0513f8d0(path) {
    let parsedPath = {};
    if (path) {
        let hashIndex = path.indexOf("#");
        if (hashIndex >= 0) {
            parsedPath.hash = path.substr(hashIndex);
            path = path.substr(0, hashIndex);
        }
        let searchIndex = path.indexOf("?");
        if (searchIndex >= 0) {
            parsedPath.search = path.substr(searchIndex);
            path = path.substr(0, searchIndex);
        }
        if (path) parsedPath.pathname = path;
    }
    return parsedPath;
}
function $ed8eb2d58084204c$var$getUrlBasedHistory(getLocation, createHref, validateLocation, options) {
    if (options === void 0) options = {};
    let { window: window1 = document.defaultView, v5Compat: v5Compat = false } = options;
    let globalHistory = window1.history;
    let action = $ed8eb2d58084204c$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    let index = getIndex();
    // Index should only be null when we initialize. If not, it's because the
    // user called history.pushState or history.replaceState directly, in which
    // case we should log a warning as it will result in bugs.
    if (index == null) {
        index = 0;
        globalHistory.replaceState($ed8eb2d58084204c$var$_extends({}, globalHistory.state, {
            idx: index
        }), "");
    }
    function getIndex() {
        let state = globalHistory.state || {
            idx: null
        };
        return state.idx;
    }
    function handlePop() {
        action = $ed8eb2d58084204c$export$e19cd5f9376f8cee.Pop;
        let nextIndex = getIndex();
        let delta = nextIndex == null ? null : nextIndex - index;
        index = nextIndex;
        if (listener) listener({
            action: action,
            location: history.location,
            delta: delta
        });
    }
    function push(to, state) {
        action = $ed8eb2d58084204c$export$e19cd5f9376f8cee.Push;
        let location = $ed8eb2d58084204c$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex() + 1;
        let historyState = $ed8eb2d58084204c$var$getHistoryState(location, index);
        let url = history.createHref(location);
        // try...catch because iOS limits us to 100 pushState calls :/
        try {
            globalHistory.pushState(historyState, "", url);
        } catch (error) {
            // If the exception is because `state` can't be serialized, let that throw
            // outwards just like a replace call would so the dev knows the cause
            // https://html.spec.whatwg.org/multipage/nav-history-apis.html#shared-history-push/replace-state-steps
            // https://html.spec.whatwg.org/multipage/structured-data.html#structuredserializeinternal
            if (error instanceof DOMException && error.name === "DataCloneError") throw error;
            // They are going to lose state here, but there is no real
            // way to warn them about it since the page will refresh...
            window1.location.assign(url);
        }
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 1
        });
    }
    function replace(to, state) {
        action = $ed8eb2d58084204c$export$e19cd5f9376f8cee.Replace;
        let location = $ed8eb2d58084204c$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex();
        let historyState = $ed8eb2d58084204c$var$getHistoryState(location, index);
        let url = history.createHref(location);
        globalHistory.replaceState(historyState, "", url);
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 0
        });
    }
    function createURL(to) {
        // window.location.origin is "null" (the literal string value) in Firefox
        // under certain conditions, notably when serving from a local HTML file
        // See https://bugzilla.mozilla.org/show_bug.cgi?id=878297
        let base = window1.location.origin !== "null" ? window1.location.origin : window1.location.href;
        let href = typeof to === "string" ? to : $ed8eb2d58084204c$export$fe53371bee54353d(to);
        // Treating this as a full URL will strip any trailing spaces so we need to
        // pre-encode them since they might be part of a matching splat param from
        // an ancestor route
        href = href.replace(/ $/, "%20");
        $ed8eb2d58084204c$export$3e9cee6b33872309(base, "No window.location.(origin|href) available to create URL for href: " + href);
        return new URL(href, base);
    }
    let history = {
        get action () {
            return action;
        },
        get location () {
            return getLocation(window1, globalHistory);
        },
        listen (fn) {
            if (listener) throw new Error("A history only accepts one active listener");
            window1.addEventListener($ed8eb2d58084204c$var$PopStateEventType, handlePop);
            listener = fn;
            return ()=>{
                window1.removeEventListener($ed8eb2d58084204c$var$PopStateEventType, handlePop);
                listener = null;
            };
        },
        createHref (to) {
            return createHref(window1, to);
        },
        createURL: createURL,
        encodeLocation (to) {
            // Encode a Location the same way window.location would
            let url = createURL(to);
            return {
                pathname: url.pathname,
                search: url.search,
                hash: url.hash
            };
        },
        push: push,
        replace: replace,
        go (n) {
            return globalHistory.go(n);
        }
    };
    return history;
}
//#endregion
var $ed8eb2d58084204c$var$ResultType;
(function(ResultType) {
    ResultType["data"] = "data";
    ResultType["deferred"] = "deferred";
    ResultType["redirect"] = "redirect";
    ResultType["error"] = "error";
})($ed8eb2d58084204c$var$ResultType || ($ed8eb2d58084204c$var$ResultType = {}));
const $ed8eb2d58084204c$var$immutableRouteKeys = new Set([
    "lazy",
    "caseSensitive",
    "path",
    "id",
    "index",
    "children"
]);
function $ed8eb2d58084204c$var$isIndexRoute(route) {
    return route.index === true;
}
// Walk the route tree generating unique IDs where necessary, so we are working
// solely with AgnosticDataRouteObject's within the Router
function $ed8eb2d58084204c$export$4a6d22b32134ea5d(routes, mapRouteProperties, parentPath, manifest) {
    if (parentPath === void 0) parentPath = [];
    if (manifest === void 0) manifest = {};
    return routes.map((route, index)=>{
        let treePath = [
            ...parentPath,
            String(index)
        ];
        let id = typeof route.id === "string" ? route.id : treePath.join("-");
        $ed8eb2d58084204c$export$3e9cee6b33872309(route.index !== true || !route.children, "Cannot specify children on an index route");
        $ed8eb2d58084204c$export$3e9cee6b33872309(!manifest[id], "Found a route id collision on id \"" + id + "\".  Route " + "id's must be globally unique within Data Router usages");
        if ($ed8eb2d58084204c$var$isIndexRoute(route)) {
            let indexRoute = $ed8eb2d58084204c$var$_extends({}, route, mapRouteProperties(route), {
                id: id
            });
            manifest[id] = indexRoute;
            return indexRoute;
        } else {
            let pathOrLayoutRoute = $ed8eb2d58084204c$var$_extends({}, route, mapRouteProperties(route), {
                id: id,
                children: undefined
            });
            manifest[id] = pathOrLayoutRoute;
            if (route.children) pathOrLayoutRoute.children = $ed8eb2d58084204c$export$4a6d22b32134ea5d(route.children, mapRouteProperties, treePath, manifest);
            return pathOrLayoutRoute;
        }
    });
}
/**
 * Matches the given routes to a location and returns the match data.
 *
 * @see https://reactrouter.com/v6/utils/match-routes
 */ function $ed8eb2d58084204c$export$2708184779ceb39d(routes, locationArg, basename) {
    if (basename === void 0) basename = "/";
    return $ed8eb2d58084204c$var$matchRoutesImpl(routes, locationArg, basename, false);
}
function $ed8eb2d58084204c$var$matchRoutesImpl(routes, locationArg, basename, allowPartial) {
    let location = typeof locationArg === "string" ? $ed8eb2d58084204c$export$8ccf933b0513f8d0(locationArg) : locationArg;
    let pathname = $ed8eb2d58084204c$export$b69e3301ce081aa3(location.pathname || "/", basename);
    if (pathname == null) return null;
    let branches = $ed8eb2d58084204c$var$flattenRoutes(routes);
    $ed8eb2d58084204c$var$rankRouteBranches(branches);
    let matches = null;
    for(let i = 0; matches == null && i < branches.length; ++i){
        // Incoming pathnames are generally encoded from either window.location
        // or from router.navigate, but we want to match against the unencoded
        // paths in the route definitions.  Memory router locations won't be
        // encoded here but there also shouldn't be anything to decode so this
        // should be a safe operation.  This avoids needing matchRoutes to be
        // history-aware.
        let decoded = $ed8eb2d58084204c$export$30d21fd6d7295f52(pathname);
        matches = $ed8eb2d58084204c$var$matchRouteBranch(branches[i], decoded, allowPartial);
    }
    return matches;
}
function $ed8eb2d58084204c$export$b3fac024fad9e8ff(match, loaderData) {
    let { route: route, pathname: pathname, params: params } = match;
    return {
        id: route.id,
        pathname: pathname,
        params: params,
        data: loaderData[route.id],
        handle: route.handle
    };
}
function $ed8eb2d58084204c$var$flattenRoutes(routes, branches, parentsMeta, parentPath) {
    if (branches === void 0) branches = [];
    if (parentsMeta === void 0) parentsMeta = [];
    if (parentPath === void 0) parentPath = "";
    let flattenRoute = (route, index, relativePath)=>{
        let meta = {
            relativePath: relativePath === undefined ? route.path || "" : relativePath,
            caseSensitive: route.caseSensitive === true,
            childrenIndex: index,
            route: route
        };
        if (meta.relativePath.startsWith("/")) {
            $ed8eb2d58084204c$export$3e9cee6b33872309(meta.relativePath.startsWith(parentPath), "Absolute route path \"" + meta.relativePath + "\" nested under path " + ("\"" + parentPath + "\" is not valid. An absolute child route path ") + "must start with the combined path of all its parent routes.");
            meta.relativePath = meta.relativePath.slice(parentPath.length);
        }
        let path = $ed8eb2d58084204c$export$86d9a7913e44197e([
            parentPath,
            meta.relativePath
        ]);
        let routesMeta = parentsMeta.concat(meta);
        // Add the children before adding this route to the array, so we traverse the
        // route tree depth-first and child routes appear before their parents in
        // the "flattened" version.
        if (route.children && route.children.length > 0) {
            $ed8eb2d58084204c$export$3e9cee6b33872309(// Our types know better, but runtime JS may not!
            // @ts-expect-error
            route.index !== true, "Index routes must not have child routes. Please remove " + ("all child routes from route path \"" + path + "\"."));
            $ed8eb2d58084204c$var$flattenRoutes(route.children, branches, routesMeta, path);
        }
        // Routes without a path shouldn't ever match by themselves unless they are
        // index routes, so don't add them to the list of possible branches.
        if (route.path == null && !route.index) return;
        branches.push({
            path: path,
            score: $ed8eb2d58084204c$var$computeScore(path, route.index),
            routesMeta: routesMeta
        });
    };
    routes.forEach((route, index)=>{
        var _route$path;
        // coarse-grain check for optional params
        if (route.path === "" || !((_route$path = route.path) != null && _route$path.includes("?"))) flattenRoute(route, index);
        else for (let exploded of $ed8eb2d58084204c$var$explodeOptionalSegments(route.path))flattenRoute(route, index, exploded);
    });
    return branches;
}
/**
 * Computes all combinations of optional path segments for a given path,
 * excluding combinations that are ambiguous and of lower priority.
 *
 * For example, `/one/:two?/three/:four?/:five?` explodes to:
 * - `/one/three`
 * - `/one/:two/three`
 * - `/one/three/:four`
 * - `/one/three/:five`
 * - `/one/:two/three/:four`
 * - `/one/:two/three/:five`
 * - `/one/three/:four/:five`
 * - `/one/:two/three/:four/:five`
 */ function $ed8eb2d58084204c$var$explodeOptionalSegments(path) {
    let segments = path.split("/");
    if (segments.length === 0) return [];
    let [first, ...rest] = segments;
    // Optional path segments are denoted by a trailing `?`
    let isOptional = first.endsWith("?");
    // Compute the corresponding required segment: `foo?` -> `foo`
    let required = first.replace(/\?$/, "");
    if (rest.length === 0) // Intepret empty string as omitting an optional segment
    // `["one", "", "three"]` corresponds to omitting `:two` from `/one/:two?/three` -> `/one/three`
    return isOptional ? [
        required,
        ""
    ] : [
        required
    ];
    let restExploded = $ed8eb2d58084204c$var$explodeOptionalSegments(rest.join("/"));
    let result = [];
    // All child paths with the prefix.  Do this for all children before the
    // optional version for all children, so we get consistent ordering where the
    // parent optional aspect is preferred as required.  Otherwise, we can get
    // child sections interspersed where deeper optional segments are higher than
    // parent optional segments, where for example, /:two would explode _earlier_
    // then /:one.  By always including the parent as required _for all children_
    // first, we avoid this issue
    result.push(...restExploded.map((subpath)=>subpath === "" ? required : [
            required,
            subpath
        ].join("/")));
    // Then, if this is an optional value, add all child versions without
    if (isOptional) result.push(...restExploded);
    // for absolute paths, ensure `/` instead of empty segment
    return result.map((exploded)=>path.startsWith("/") && exploded === "" ? "/" : exploded);
}
function $ed8eb2d58084204c$var$rankRouteBranches(branches) {
    branches.sort((a, b)=>a.score !== b.score ? b.score - a.score // Higher score first
         : $ed8eb2d58084204c$var$compareIndexes(a.routesMeta.map((meta)=>meta.childrenIndex), b.routesMeta.map((meta)=>meta.childrenIndex)));
}
const $ed8eb2d58084204c$var$paramRe = /^:[\w-]+$/;
const $ed8eb2d58084204c$var$dynamicSegmentValue = 3;
const $ed8eb2d58084204c$var$indexRouteValue = 2;
const $ed8eb2d58084204c$var$emptySegmentValue = 1;
const $ed8eb2d58084204c$var$staticSegmentValue = 10;
const $ed8eb2d58084204c$var$splatPenalty = -2;
const $ed8eb2d58084204c$var$isSplat = (s)=>s === "*";
function $ed8eb2d58084204c$var$computeScore(path, index) {
    let segments = path.split("/");
    let initialScore = segments.length;
    if (segments.some($ed8eb2d58084204c$var$isSplat)) initialScore += $ed8eb2d58084204c$var$splatPenalty;
    if (index) initialScore += $ed8eb2d58084204c$var$indexRouteValue;
    return segments.filter((s)=>!$ed8eb2d58084204c$var$isSplat(s)).reduce((score, segment)=>score + ($ed8eb2d58084204c$var$paramRe.test(segment) ? $ed8eb2d58084204c$var$dynamicSegmentValue : segment === "" ? $ed8eb2d58084204c$var$emptySegmentValue : $ed8eb2d58084204c$var$staticSegmentValue), initialScore);
}
function $ed8eb2d58084204c$var$compareIndexes(a, b) {
    let siblings = a.length === b.length && a.slice(0, -1).every((n, i)=>n === b[i]);
    return siblings ? // If two routes are siblings, we should try to match the earlier sibling
    // first. This allows people to have fine-grained control over the matching
    // behavior by simply putting routes with identical paths in the order they
    // want them tried.
    a[a.length - 1] - b[b.length - 1] : // Otherwise, it doesn't really make sense to rank non-siblings by index,
    // so they sort equally.
    0;
}
function $ed8eb2d58084204c$var$matchRouteBranch(branch, pathname, allowPartial) {
    if (allowPartial === void 0) allowPartial = false;
    let { routesMeta: routesMeta } = branch;
    let matchedParams = {};
    let matchedPathname = "/";
    let matches = [];
    for(let i = 0; i < routesMeta.length; ++i){
        let meta = routesMeta[i];
        let end = i === routesMeta.length - 1;
        let remainingPathname = matchedPathname === "/" ? pathname : pathname.slice(matchedPathname.length) || "/";
        let match = $ed8eb2d58084204c$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: end
        }, remainingPathname);
        let route = meta.route;
        if (!match && end && allowPartial && !routesMeta[routesMeta.length - 1].route.index) match = $ed8eb2d58084204c$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: false
        }, remainingPathname);
        if (!match) return null;
        Object.assign(matchedParams, match.params);
        matches.push({
            // TODO: Can this as be avoided?
            params: matchedParams,
            pathname: $ed8eb2d58084204c$export$86d9a7913e44197e([
                matchedPathname,
                match.pathname
            ]),
            pathnameBase: $ed8eb2d58084204c$export$a5c6d149b50c1d86($ed8eb2d58084204c$export$86d9a7913e44197e([
                matchedPathname,
                match.pathnameBase
            ])),
            route: route
        });
        if (match.pathnameBase !== "/") matchedPathname = $ed8eb2d58084204c$export$86d9a7913e44197e([
            matchedPathname,
            match.pathnameBase
        ]);
    }
    return matches;
}
/**
 * Returns a path with params interpolated.
 *
 * @see https://reactrouter.com/v6/utils/generate-path
 */ function $ed8eb2d58084204c$export$82476f982757e71e(originalPath, params) {
    if (params === void 0) params = {};
    let path = originalPath;
    if (path.endsWith("*") && path !== "*" && !path.endsWith("/*")) {
        $ed8eb2d58084204c$export$c0e02632e14916fd(false, "Route path \"" + path + "\" will be treated as if it were " + ("\"" + path.replace(/\*$/, "/*") + "\" because the `*` character must ") + "always follow a `/` in the pattern. To get rid of this warning, " + ("please change the route path to \"" + path.replace(/\*$/, "/*") + "\"."));
        path = path.replace(/\*$/, "/*");
    }
    // ensure `/` is added at the beginning if the path is absolute
    const prefix = path.startsWith("/") ? "/" : "";
    const stringify = (p)=>p == null ? "" : typeof p === "string" ? p : String(p);
    const segments = path.split(/\/+/).map((segment, index, array)=>{
        const isLastSegment = index === array.length - 1;
        // only apply the splat if it's the last segment
        if (isLastSegment && segment === "*") {
            const star = "*";
            // Apply the splat
            return stringify(params[star]);
        }
        const keyMatch = segment.match(/^:([\w-]+)(\??)$/);
        if (keyMatch) {
            const [, key, optional] = keyMatch;
            let param = params[key];
            $ed8eb2d58084204c$export$3e9cee6b33872309(optional === "?" || param != null, "Missing \":" + key + "\" param");
            return stringify(param);
        }
        // Remove any optional markers from optional static segments
        return segment.replace(/\?$/g, "");
    })// Remove empty segments
    .filter((segment)=>!!segment);
    return prefix + segments.join("/");
}
/**
 * Performs pattern matching on a URL pathname and returns information about
 * the match.
 *
 * @see https://reactrouter.com/v6/utils/match-path
 */ function $ed8eb2d58084204c$export$81336c211d5ff295(pattern, pathname) {
    if (typeof pattern === "string") pattern = {
        path: pattern,
        caseSensitive: false,
        end: true
    };
    let [matcher, compiledParams] = $ed8eb2d58084204c$var$compilePath(pattern.path, pattern.caseSensitive, pattern.end);
    let match = pathname.match(matcher);
    if (!match) return null;
    let matchedPathname = match[0];
    let pathnameBase = matchedPathname.replace(/(.)\/+$/, "$1");
    let captureGroups = match.slice(1);
    let params = compiledParams.reduce((memo, _ref, index)=>{
        let { paramName: paramName, isOptional: isOptional } = _ref;
        // We need to compute the pathnameBase here using the raw splat value
        // instead of using params["*"] later because it will be decoded then
        if (paramName === "*") {
            let splatValue = captureGroups[index] || "";
            pathnameBase = matchedPathname.slice(0, matchedPathname.length - splatValue.length).replace(/(.)\/+$/, "$1");
        }
        const value = captureGroups[index];
        if (isOptional && !value) memo[paramName] = undefined;
        else memo[paramName] = (value || "").replace(/%2F/g, "/");
        return memo;
    }, {});
    return {
        params: params,
        pathname: matchedPathname,
        pathnameBase: pathnameBase,
        pattern: pattern
    };
}
function $ed8eb2d58084204c$var$compilePath(path, caseSensitive, end) {
    if (caseSensitive === void 0) caseSensitive = false;
    if (end === void 0) end = true;
    $ed8eb2d58084204c$export$c0e02632e14916fd(path === "*" || !path.endsWith("*") || path.endsWith("/*"), "Route path \"" + path + "\" will be treated as if it were " + ("\"" + path.replace(/\*$/, "/*") + "\" because the `*` character must ") + "always follow a `/` in the pattern. To get rid of this warning, " + ("please change the route path to \"" + path.replace(/\*$/, "/*") + "\"."));
    let params = [];
    let regexpSource = "^" + path.replace(/\/*\*?$/, "") // Ignore trailing / and /*, we'll handle it below
    .replace(/^\/*/, "/") // Make sure it has a leading /
    .replace(/[\\.*+^${}|()[\]]/g, "\\$&") // Escape special regex chars
    .replace(/\/:([\w-]+)(\?)?/g, (_, paramName, isOptional)=>{
        params.push({
            paramName: paramName,
            isOptional: isOptional != null
        });
        return isOptional ? "/?([^\\/]+)?" : "/([^\\/]+)";
    });
    if (path.endsWith("*")) {
        params.push({
            paramName: "*"
        });
        regexpSource += path === "*" || path === "/*" ? "(.*)$" // Already matched the initial /, just match the rest
         : "(?:\\/(.+)|\\/*)$"; // Don't include the / in params["*"]
    } else if (end) // When matching to the end, ignore trailing slashes
    regexpSource += "\\/*$";
    else if (path !== "" && path !== "/") // If our path is non-empty and contains anything beyond an initial slash,
    // then we have _some_ form of path in our regex, so we should expect to
    // match only if we find the end of this path segment.  Look for an optional
    // non-captured trailing slash (to match a portion of the URL) or the end
    // of the path (if we've matched to the end).  We used to do this with a
    // word boundary but that gives false positives on routes like
    // /user-preferences since `-` counts as a word boundary.
    regexpSource += "(?:(?=\\/|$))";
    let matcher = new RegExp(regexpSource, caseSensitive ? undefined : "i");
    return [
        matcher,
        params
    ];
}
function $ed8eb2d58084204c$export$30d21fd6d7295f52(value) {
    try {
        return value.split("/").map((v)=>decodeURIComponent(v).replace(/\//g, "%2F")).join("/");
    } catch (error) {
        $ed8eb2d58084204c$export$c0e02632e14916fd(false, "The URL path \"" + value + "\" could not be decoded because it is is a " + "malformed URL segment. This is probably due to a bad percent " + ("encoding (" + error + ")."));
        return value;
    }
}
/**
 * @private
 */ function $ed8eb2d58084204c$export$b69e3301ce081aa3(pathname, basename) {
    if (basename === "/") return pathname;
    if (!pathname.toLowerCase().startsWith(basename.toLowerCase())) return null;
    // We want to leave trailing slash behavior in the user's control, so if they
    // specify a basename with a trailing slash, we should support it
    let startIndex = basename.endsWith("/") ? basename.length - 1 : basename.length;
    let nextChar = pathname.charAt(startIndex);
    if (nextChar && nextChar !== "/") // pathname does not start with basename/
    return null;
    return pathname.slice(startIndex) || "/";
}
/**
 * Returns a resolved path object relative to the given pathname.
 *
 * @see https://reactrouter.com/v6/utils/resolve-path
 */ function $ed8eb2d58084204c$export$b09f2ff0bbcb43c7(to, fromPathname) {
    if (fromPathname === void 0) fromPathname = "/";
    let { pathname: toPathname, search: search = "", hash: hash = "" } = typeof to === "string" ? $ed8eb2d58084204c$export$8ccf933b0513f8d0(to) : to;
    let pathname = toPathname ? toPathname.startsWith("/") ? toPathname : $ed8eb2d58084204c$var$resolvePathname(toPathname, fromPathname) : fromPathname;
    return {
        pathname: pathname,
        search: $ed8eb2d58084204c$var$normalizeSearch(search),
        hash: $ed8eb2d58084204c$var$normalizeHash(hash)
    };
}
function $ed8eb2d58084204c$var$resolvePathname(relativePath, fromPathname) {
    let segments = fromPathname.replace(/\/+$/, "").split("/");
    let relativeSegments = relativePath.split("/");
    relativeSegments.forEach((segment)=>{
        if (segment === "..") // Keep the root "" segment so the pathname starts at /
        {
            if (segments.length > 1) segments.pop();
        } else if (segment !== ".") segments.push(segment);
    });
    return segments.length > 1 ? segments.join("/") : "/";
}
function $ed8eb2d58084204c$var$getInvalidPathError(char, field, dest, path) {
    return "Cannot include a '" + char + "' character in a manually specified " + ("`to." + field + "` field [" + JSON.stringify(path) + "].  Please separate it out to the ") + ("`to." + dest + "` field. Alternatively you may provide the full path as ") + "a string in <Link to=\"...\"> and the router will parse it for you.";
}
/**
 * @private
 *
 * When processing relative navigation we want to ignore ancestor routes that
 * do not contribute to the path, such that index/pathless layout routes don't
 * interfere.
 *
 * For example, when moving a route element into an index route and/or a
 * pathless layout route, relative link behavior contained within should stay
 * the same.  Both of the following examples should link back to the root:
 *
 *   <Route path="/">
 *     <Route path="accounts" element={<Link to=".."}>
 *   </Route>
 *
 *   <Route path="/">
 *     <Route path="accounts">
 *       <Route element={<AccountsLayout />}>       // <-- Does not contribute
 *         <Route index element={<Link to=".."} />  // <-- Does not contribute
 *       </Route
 *     </Route>
 *   </Route>
 */ function $ed8eb2d58084204c$var$getPathContributingMatches(matches) {
    return matches.filter((match, index)=>index === 0 || match.route.path && match.route.path.length > 0);
}
// Return the array of pathnames for the current route matches - used to
// generate the routePathnames input for resolveTo()
function $ed8eb2d58084204c$export$a5784978eca585fa(matches, v7_relativeSplatPath) {
    let pathMatches = $ed8eb2d58084204c$var$getPathContributingMatches(matches);
    // When v7_relativeSplatPath is enabled, use the full pathname for the leaf
    // match so we include splat values for "." links.  See:
    // https://github.com/remix-run/react-router/issues/11052#issuecomment-1836589329
    if (v7_relativeSplatPath) return pathMatches.map((match, idx)=>idx === pathMatches.length - 1 ? match.pathname : match.pathnameBase);
    return pathMatches.map((match)=>match.pathnameBase);
}
/**
 * @private
 */ function $ed8eb2d58084204c$export$cae722b0cc860f13(toArg, routePathnames, locationPathname, isPathRelative) {
    if (isPathRelative === void 0) isPathRelative = false;
    let to;
    if (typeof toArg === "string") to = $ed8eb2d58084204c$export$8ccf933b0513f8d0(toArg);
    else {
        to = $ed8eb2d58084204c$var$_extends({}, toArg);
        $ed8eb2d58084204c$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("?"), $ed8eb2d58084204c$var$getInvalidPathError("?", "pathname", "search", to));
        $ed8eb2d58084204c$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("#"), $ed8eb2d58084204c$var$getInvalidPathError("#", "pathname", "hash", to));
        $ed8eb2d58084204c$export$3e9cee6b33872309(!to.search || !to.search.includes("#"), $ed8eb2d58084204c$var$getInvalidPathError("#", "search", "hash", to));
    }
    let isEmptyPath = toArg === "" || to.pathname === "";
    let toPathname = isEmptyPath ? "/" : to.pathname;
    let from;
    // Routing is relative to the current pathname if explicitly requested.
    //
    // If a pathname is explicitly provided in `to`, it should be relative to the
    // route context. This is explained in `Note on `<Link to>` values` in our
    // migration guide from v5 as a means of disambiguation between `to` values
    // that begin with `/` and those that do not. However, this is problematic for
    // `to` values that do not provide a pathname. `to` can simply be a search or
    // hash string, in which case we should assume that the navigation is relative
    // to the current location's pathname and *not* the route pathname.
    if (toPathname == null) from = locationPathname;
    else {
        let routePathnameIndex = routePathnames.length - 1;
        // With relative="route" (the default), each leading .. segment means
        // "go up one route" instead of "go up one URL segment".  This is a key
        // difference from how <a href> works and a major reason we call this a
        // "to" value instead of a "href".
        if (!isPathRelative && toPathname.startsWith("..")) {
            let toSegments = toPathname.split("/");
            while(toSegments[0] === ".."){
                toSegments.shift();
                routePathnameIndex -= 1;
            }
            to.pathname = toSegments.join("/");
        }
        from = routePathnameIndex >= 0 ? routePathnames[routePathnameIndex] : "/";
    }
    let path = $ed8eb2d58084204c$export$b09f2ff0bbcb43c7(to, from);
    // Ensure the pathname has a trailing slash if the original "to" had one
    let hasExplicitTrailingSlash = toPathname && toPathname !== "/" && toPathname.endsWith("/");
    // Or if this was a link to the current path which has a trailing slash
    let hasCurrentTrailingSlash = (isEmptyPath || toPathname === ".") && locationPathname.endsWith("/");
    if (!path.pathname.endsWith("/") && (hasExplicitTrailingSlash || hasCurrentTrailingSlash)) path.pathname += "/";
    return path;
}
/**
 * @private
 */ function $ed8eb2d58084204c$export$f5655dfea9d981c7(to) {
    // Empty strings should be treated the same as / paths
    return to === "" || to.pathname === "" ? "/" : typeof to === "string" ? $ed8eb2d58084204c$export$8ccf933b0513f8d0(to).pathname : to.pathname;
}
/**
 * @private
 */ const $ed8eb2d58084204c$export$86d9a7913e44197e = (paths)=>paths.join("/").replace(/\/\/+/g, "/");
/**
 * @private
 */ const $ed8eb2d58084204c$export$a5c6d149b50c1d86 = (pathname)=>pathname.replace(/\/+$/, "").replace(/^\/*/, "/");
/**
 * @private
 */ const $ed8eb2d58084204c$var$normalizeSearch = (search)=>!search || search === "?" ? "" : search.startsWith("?") ? search : "?" + search;
/**
 * @private
 */ const $ed8eb2d58084204c$var$normalizeHash = (hash)=>!hash || hash === "#" ? "" : hash.startsWith("#") ? hash : "#" + hash;
/**
 * This is a shortcut for creating `application/json` responses. Converts `data`
 * to JSON and sets the `Content-Type` header.
 *
 * @deprecated The `json` method is deprecated in favor of returning raw objects.
 * This method will be removed in v7.
 */ const $ed8eb2d58084204c$export$7b419323e6ed4f31 = function json(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    let headers = new Headers(responseInit.headers);
    if (!headers.has("Content-Type")) headers.set("Content-Type", "application/json; charset=utf-8");
    return new Response(JSON.stringify(data), $ed8eb2d58084204c$var$_extends({}, responseInit, {
        headers: headers
    }));
};
class $ed8eb2d58084204c$var$DataWithResponseInit {
    constructor(data, init){
        this.type = "DataWithResponseInit";
        this.data = data;
        this.init = init || null;
    }
}
/**
 * Create "responses" that contain `status`/`headers` without forcing
 * serialization into an actual `Response` - used by Remix single fetch
 */ function $ed8eb2d58084204c$export$4051a07651545597(data, init) {
    return new $ed8eb2d58084204c$var$DataWithResponseInit(data, typeof init === "number" ? {
        status: init
    } : init);
}
class $ed8eb2d58084204c$export$42a99a7a4bc0e76a extends Error {
}
class $ed8eb2d58084204c$export$61d759255b4eec65 {
    trackPromise(key, value) {
        if (!(value instanceof Promise)) return value;
        this.deferredKeys.push(key);
        this.pendingKeysSet.add(key);
        // We store a little wrapper promise that will be extended with
        // _data/_error props upon resolve/reject
        let promise = Promise.race([
            value,
            this.abortPromise
        ]).then((data)=>this.onSettle(promise, key, undefined, data), (error)=>this.onSettle(promise, key, error));
        // Register rejection listeners to avoid uncaught promise rejections on
        // errors or aborted deferred values
        promise.catch(()=>{});
        Object.defineProperty(promise, "_tracked", {
            get: ()=>true
        });
        return promise;
    }
    onSettle(promise, key, error, data) {
        if (this.controller.signal.aborted && error instanceof $ed8eb2d58084204c$export$42a99a7a4bc0e76a) {
            this.unlistenAbortSignal();
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            return Promise.reject(error);
        }
        this.pendingKeysSet.delete(key);
        if (this.done) // Nothing left to abort!
        this.unlistenAbortSignal();
        // If the promise was resolved/rejected with undefined, we'll throw an error as you
        // should always resolve with a value or null
        if (error === undefined && data === undefined) {
            let undefinedError = new Error("Deferred data for key \"" + key + "\" resolved/rejected with `undefined`, " + "you must resolve/reject with a value or `null`.");
            Object.defineProperty(promise, "_error", {
                get: ()=>undefinedError
            });
            this.emit(false, key);
            return Promise.reject(undefinedError);
        }
        if (data === undefined) {
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            this.emit(false, key);
            return Promise.reject(error);
        }
        Object.defineProperty(promise, "_data", {
            get: ()=>data
        });
        this.emit(false, key);
        return data;
    }
    emit(aborted, settledKey) {
        this.subscribers.forEach((subscriber)=>subscriber(aborted, settledKey));
    }
    subscribe(fn) {
        this.subscribers.add(fn);
        return ()=>this.subscribers.delete(fn);
    }
    cancel() {
        this.controller.abort();
        this.pendingKeysSet.forEach((v, k)=>this.pendingKeysSet.delete(k));
        this.emit(true);
    }
    async resolveData(signal) {
        let aborted = false;
        if (!this.done) {
            let onAbort = ()=>this.cancel();
            signal.addEventListener("abort", onAbort);
            aborted = await new Promise((resolve)=>{
                this.subscribe((aborted)=>{
                    signal.removeEventListener("abort", onAbort);
                    if (aborted || this.done) resolve(aborted);
                });
            });
        }
        return aborted;
    }
    get done() {
        return this.pendingKeysSet.size === 0;
    }
    get unwrappedData() {
        $ed8eb2d58084204c$export$3e9cee6b33872309(this.data !== null && this.done, "Can only unwrap data on initialized and settled deferreds");
        return Object.entries(this.data).reduce((acc, _ref3)=>{
            let [key, value] = _ref3;
            return Object.assign(acc, {
                [key]: $ed8eb2d58084204c$var$unwrapTrackedPromise(value)
            });
        }, {});
    }
    get pendingKeys() {
        return Array.from(this.pendingKeysSet);
    }
    constructor(data, responseInit){
        this.pendingKeysSet = new Set();
        this.subscribers = new Set();
        this.deferredKeys = [];
        $ed8eb2d58084204c$export$3e9cee6b33872309(data && typeof data === "object" && !Array.isArray(data), "defer() only accepts plain objects");
        // Set up an AbortController + Promise we can race against to exit early
        // cancellation
        let reject;
        this.abortPromise = new Promise((_, r)=>reject = r);
        this.controller = new AbortController();
        let onAbort = ()=>reject(new $ed8eb2d58084204c$export$42a99a7a4bc0e76a("Deferred data aborted"));
        this.unlistenAbortSignal = ()=>this.controller.signal.removeEventListener("abort", onAbort);
        this.controller.signal.addEventListener("abort", onAbort);
        this.data = Object.entries(data).reduce((acc, _ref2)=>{
            let [key, value] = _ref2;
            return Object.assign(acc, {
                [key]: this.trackPromise(key, value)
            });
        }, {});
        if (this.done) // All incoming values were resolved
        this.unlistenAbortSignal();
        this.init = responseInit;
    }
}
function $ed8eb2d58084204c$var$isTrackedPromise(value) {
    return value instanceof Promise && value._tracked === true;
}
function $ed8eb2d58084204c$var$unwrapTrackedPromise(value) {
    if (!$ed8eb2d58084204c$var$isTrackedPromise(value)) return value;
    if (value._error) throw value._error;
    return value._data;
}
/**
 * @deprecated The `defer` method is deprecated in favor of returning raw
 * objects. This method will be removed in v7.
 */ const $ed8eb2d58084204c$export$260e5c0943f31606 = function defer(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    return new $ed8eb2d58084204c$export$61d759255b4eec65(data, responseInit);
};
/**
 * A redirect response. Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $ed8eb2d58084204c$export$89e12c5b50f7529d = function redirect(url, init) {
    if (init === void 0) init = 302;
    let responseInit = init;
    if (typeof responseInit === "number") responseInit = {
        status: responseInit
    };
    else if (typeof responseInit.status === "undefined") responseInit.status = 302;
    let headers = new Headers(responseInit.headers);
    headers.set("Location", url);
    return new Response(null, $ed8eb2d58084204c$var$_extends({}, responseInit, {
        headers: headers
    }));
};
/**
 * A redirect response that will force a document reload to the new location.
 * Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $ed8eb2d58084204c$export$a6cd19cd1951a23c = (url, init)=>{
    let response = $ed8eb2d58084204c$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Reload-Document", "true");
    return response;
};
/**
 * A redirect response that will perform a `history.replaceState` instead of a
 * `history.pushState` for client-side navigation redirects.
 * Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $ed8eb2d58084204c$export$77ad94ebf1c2b9ed = (url, init)=>{
    let response = $ed8eb2d58084204c$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Replace", "true");
    return response;
};
/**
 * @private
 * Utility class we use to hold auto-unwrapped 4xx/5xx Response bodies
 *
 * We don't export the class for public use since it's an implementation
 * detail, but we export the interface above so folks can build their own
 * abstractions around instances via isRouteErrorResponse()
 */ class $ed8eb2d58084204c$export$6c6580e81da25755 {
    constructor(status, statusText, data, internal){
        if (internal === void 0) internal = false;
        this.status = status;
        this.statusText = statusText || "";
        this.internal = internal;
        if (data instanceof Error) {
            this.data = data.toString();
            this.error = data;
        } else this.data = data;
    }
}
/**
 * Check if the given error is an ErrorResponse generated from a 4xx/5xx
 * Response thrown from an action/loader
 */ function $ed8eb2d58084204c$export$972111febbeef05b(error) {
    return error != null && typeof error.status === "number" && typeof error.statusText === "string" && typeof error.internal === "boolean" && "data" in error;
}
const $ed8eb2d58084204c$var$validMutationMethodsArr = [
    "post",
    "put",
    "patch",
    "delete"
];
const $ed8eb2d58084204c$var$validMutationMethods = new Set($ed8eb2d58084204c$var$validMutationMethodsArr);
const $ed8eb2d58084204c$var$validRequestMethodsArr = [
    "get",
    ...$ed8eb2d58084204c$var$validMutationMethodsArr
];
const $ed8eb2d58084204c$var$validRequestMethods = new Set($ed8eb2d58084204c$var$validRequestMethodsArr);
const $ed8eb2d58084204c$var$redirectStatusCodes = new Set([
    301,
    302,
    303,
    307,
    308
]);
const $ed8eb2d58084204c$var$redirectPreserveMethodStatusCodes = new Set([
    307,
    308
]);
const $ed8eb2d58084204c$export$ed3e14b2f9e105d0 = {
    state: "idle",
    location: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const $ed8eb2d58084204c$export$52eace9c284d3585 = {
    state: "idle",
    data: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const $ed8eb2d58084204c$export$386d57f03f0b2883 = {
    state: "unblocked",
    proceed: undefined,
    reset: undefined,
    location: undefined
};
const $ed8eb2d58084204c$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
const $ed8eb2d58084204c$var$defaultMapRouteProperties = (route)=>({
        hasErrorBoundary: Boolean(route.hasErrorBoundary)
    });
const $ed8eb2d58084204c$var$TRANSITIONS_STORAGE_KEY = "remix-router-transitions";
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createRouter
////////////////////////////////////////////////////////////////////////////////
/**
 * Create a router and listen to history POP navigations
 */ function $ed8eb2d58084204c$export$baddd0131ee8c05b(init) {
    const routerWindow = init.window ? init.window : typeof window !== "undefined" ? window : undefined;
    const isBrowser = typeof routerWindow !== "undefined" && typeof routerWindow.document !== "undefined" && typeof routerWindow.document.createElement !== "undefined";
    const isServer = !isBrowser;
    $ed8eb2d58084204c$export$3e9cee6b33872309(init.routes.length > 0, "You must provide a non-empty routes array to createRouter");
    let mapRouteProperties;
    if (init.mapRouteProperties) mapRouteProperties = init.mapRouteProperties;
    else if (init.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = init.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $ed8eb2d58084204c$var$defaultMapRouteProperties;
    // Routes keyed by ID
    let manifest = {};
    // Routes in tree format for matching
    let dataRoutes = $ed8eb2d58084204c$export$4a6d22b32134ea5d(init.routes, mapRouteProperties, undefined, manifest);
    let inFlightDataRoutes;
    let basename = init.basename || "/";
    let dataStrategyImpl = init.dataStrategy || $ed8eb2d58084204c$var$defaultDataStrategy;
    let patchRoutesOnNavigationImpl = init.patchRoutesOnNavigation;
    // Config driven behavior flags
    let future = $ed8eb2d58084204c$var$_extends({
        v7_fetcherPersist: false,
        v7_normalizeFormMethod: false,
        v7_partialHydration: false,
        v7_prependBasename: false,
        v7_relativeSplatPath: false,
        v7_skipActionErrorRevalidation: false
    }, init.future);
    // Cleanup function for history
    let unlistenHistory = null;
    // Externally-provided functions to call on all state changes
    let subscribers = new Set();
    // Externally-provided object to hold scroll restoration locations during routing
    let savedScrollPositions = null;
    // Externally-provided function to get scroll restoration keys
    let getScrollRestorationKey = null;
    // Externally-provided function to get current scroll position
    let getScrollPosition = null;
    // One-time flag to control the initial hydration scroll restoration.  Because
    // we don't get the saved positions from <ScrollRestoration /> until _after_
    // the initial render, we need to manually trigger a separate updateState to
    // send along the restoreScrollPosition
    // Set to true if we have `hydrationData` since we assume we were SSR'd and that
    // SSR did the initial scroll restoration.
    let initialScrollRestored = init.hydrationData != null;
    let initialMatches = $ed8eb2d58084204c$export$2708184779ceb39d(dataRoutes, init.history.location, basename);
    let initialMatchesIsFOW = false;
    let initialErrors = null;
    if (initialMatches == null && !patchRoutesOnNavigationImpl) {
        // If we do not match a user-provided-route, fall back to the root
        // to allow the error boundary to take over
        let error = $ed8eb2d58084204c$var$getInternalRouterError(404, {
            pathname: init.history.location.pathname
        });
        let { matches: matches, route: route } = $ed8eb2d58084204c$var$getShortCircuitMatches(dataRoutes);
        initialMatches = matches;
        initialErrors = {
            [route.id]: error
        };
    }
    // In SPA apps, if the user provided a patchRoutesOnNavigation implementation and
    // our initial match is a splat route, clear them out so we run through lazy
    // discovery on hydration in case there's a more accurate lazy route match.
    // In SSR apps (with `hydrationData`), we expect that the server will send
    // up the proper matched routes so we don't want to run lazy discovery on
    // initial hydration and want to hydrate into the splat route.
    if (initialMatches && !init.hydrationData) {
        let fogOfWar = checkFogOfWar(initialMatches, dataRoutes, init.history.location.pathname);
        if (fogOfWar.active) initialMatches = null;
    }
    let initialized;
    if (!initialMatches) {
        initialized = false;
        initialMatches = [];
        // If partial hydration and fog of war is enabled, we will be running
        // `patchRoutesOnNavigation` during hydration so include any partial matches as
        // the initial matches so we can properly render `HydrateFallback`'s
        if (future.v7_partialHydration) {
            let fogOfWar = checkFogOfWar(null, dataRoutes, init.history.location.pathname);
            if (fogOfWar.active && fogOfWar.matches) {
                initialMatchesIsFOW = true;
                initialMatches = fogOfWar.matches;
            }
        }
    } else if (initialMatches.some((m)=>m.route.lazy)) // All initialMatches need to be loaded before we're ready.  If we have lazy
    // functions around still then we'll need to run them in initialize()
    initialized = false;
    else if (!initialMatches.some((m)=>m.route.loader)) // If we've got no loaders to run, then we're good to go
    initialized = true;
    else if (future.v7_partialHydration) {
        // If partial hydration is enabled, we're initialized so long as we were
        // provided with hydrationData for every route with a loader, and no loaders
        // were marked for explicit hydration
        let loaderData = init.hydrationData ? init.hydrationData.loaderData : null;
        let errors = init.hydrationData ? init.hydrationData.errors : null;
        // If errors exist, don't consider routes below the boundary
        if (errors) {
            let idx = initialMatches.findIndex((m)=>errors[m.route.id] !== undefined);
            initialized = initialMatches.slice(0, idx + 1).every((m)=>!$ed8eb2d58084204c$var$shouldLoadRouteOnHydration(m.route, loaderData, errors));
        } else initialized = initialMatches.every((m)=>!$ed8eb2d58084204c$var$shouldLoadRouteOnHydration(m.route, loaderData, errors));
    } else // Without partial hydration - we're initialized if we were provided any
    // hydrationData - which is expected to be complete
    initialized = init.hydrationData != null;
    let router;
    let state = {
        historyAction: init.history.action,
        location: init.history.location,
        matches: initialMatches,
        initialized: initialized,
        navigation: $ed8eb2d58084204c$export$ed3e14b2f9e105d0,
        // Don't restore on initial updateState() if we were SSR'd
        restoreScrollPosition: init.hydrationData != null ? false : null,
        preventScrollReset: false,
        revalidation: "idle",
        loaderData: init.hydrationData && init.hydrationData.loaderData || {},
        actionData: init.hydrationData && init.hydrationData.actionData || null,
        errors: init.hydrationData && init.hydrationData.errors || initialErrors,
        fetchers: new Map(),
        blockers: new Map()
    };
    // -- Stateful internal variables to manage navigations --
    // Current navigation in progress (to be committed in completeNavigation)
    let pendingAction = $ed8eb2d58084204c$export$e19cd5f9376f8cee.Pop;
    // Should the current navigation prevent the scroll reset if scroll cannot
    // be restored?
    let pendingPreventScrollReset = false;
    // AbortController for the active navigation
    let pendingNavigationController;
    // Should the current navigation enable document.startViewTransition?
    let pendingViewTransitionEnabled = false;
    // Store applied view transitions so we can apply them on POP
    let appliedViewTransitions = new Map();
    // Cleanup function for persisting applied transitions to sessionStorage
    let removePageHideEventListener = null;
    // We use this to avoid touching history in completeNavigation if a
    // revalidation is entirely uninterrupted
    let isUninterruptedRevalidation = false;
    // Use this internal flag to force revalidation of all loaders:
    //  - submissions (completed or interrupted)
    //  - useRevalidator()
    //  - X-Remix-Revalidate (from redirect)
    let isRevalidationRequired = false;
    // Use this internal array to capture routes that require revalidation due
    // to a cancelled deferred on action submission
    let cancelledDeferredRoutes = [];
    // Use this internal array to capture fetcher loads that were cancelled by an
    // action navigation and require revalidation
    let cancelledFetcherLoads = new Set();
    // AbortControllers for any in-flight fetchers
    let fetchControllers = new Map();
    // Track loads based on the order in which they started
    let incrementingLoadId = 0;
    // Track the outstanding pending navigation data load to be compared against
    // the globally incrementing load when a fetcher load lands after a completed
    // navigation
    let pendingNavigationLoadId = -1;
    // Fetchers that triggered data reloads as a result of their actions
    let fetchReloadIds = new Map();
    // Fetchers that triggered redirect navigations
    let fetchRedirectIds = new Set();
    // Most recent href/match for fetcher.load calls for fetchers
    let fetchLoadMatches = new Map();
    // Ref-count mounted fetchers so we know when it's ok to clean them up
    let activeFetchers = new Map();
    // Fetchers that have requested a delete when using v7_fetcherPersist,
    // they'll be officially removed after they return to idle
    let deletedFetchers = new Set();
    // Store DeferredData instances for active route matches.  When a
    // route loader returns defer() we stick one in here.  Then, when a nested
    // promise resolves we update loaderData.  If a new navigation starts we
    // cancel active deferreds for eliminated routes.
    let activeDeferreds = new Map();
    // Store blocker functions in a separate Map outside of router state since
    // we don't need to update UI state if they change
    let blockerFunctions = new Map();
    // Flag to ignore the next history update, so we can revert the URL change on
    // a POP navigation that was blocked by the user without touching router state
    let unblockBlockerHistoryUpdate = undefined;
    // Initialize the router, all side effects should be kicked off from here.
    // Implemented as a Fluent API for ease of:
    //   let router = createRouter(init).initialize();
    function initialize() {
        // If history informs us of a POP navigation, start the navigation but do not update
        // state.  We'll update our own state once the navigation completes
        unlistenHistory = init.history.listen((_ref)=>{
            let { action: historyAction, location: location, delta: delta } = _ref;
            // Ignore this event if it was just us resetting the URL from a
            // blocked POP navigation
            if (unblockBlockerHistoryUpdate) {
                unblockBlockerHistoryUpdate();
                unblockBlockerHistoryUpdate = undefined;
                return;
            }
            $ed8eb2d58084204c$export$c0e02632e14916fd(blockerFunctions.size === 0 || delta != null, "You are trying to use a blocker on a POP navigation to a location that was not created by @remix-run/router. This will fail silently in production. This can happen if you are navigating outside the router via `window.history.pushState`/`window.location.hash` instead of using router navigation APIs.  This can also happen if you are using createHashRouter and the user manually changes the URL.");
            let blockerKey = shouldBlockNavigation({
                currentLocation: state.location,
                nextLocation: location,
                historyAction: historyAction
            });
            if (blockerKey && delta != null) {
                // Restore the URL to match the current UI, but don't update router state
                let nextHistoryUpdatePromise = new Promise((resolve)=>{
                    unblockBlockerHistoryUpdate = resolve;
                });
                init.history.go(delta * -1);
                // Put the blocker into a blocked state
                updateBlocker(blockerKey, {
                    state: "blocked",
                    location: location,
                    proceed () {
                        updateBlocker(blockerKey, {
                            state: "proceeding",
                            proceed: undefined,
                            reset: undefined,
                            location: location
                        });
                        // Re-do the same POP navigation we just blocked, after the url
                        // restoration is also complete.  See:
                        // https://github.com/remix-run/react-router/issues/11613
                        nextHistoryUpdatePromise.then(()=>init.history.go(delta));
                    },
                    reset () {
                        let blockers = new Map(state.blockers);
                        blockers.set(blockerKey, $ed8eb2d58084204c$export$386d57f03f0b2883);
                        updateState({
                            blockers: blockers
                        });
                    }
                });
                return;
            }
            return startNavigation(historyAction, location);
        });
        if (isBrowser) {
            // FIXME: This feels gross.  How can we cleanup the lines between
            // scrollRestoration/appliedTransitions persistance?
            $ed8eb2d58084204c$var$restoreAppliedTransitions(routerWindow, appliedViewTransitions);
            let _saveAppliedTransitions = ()=>$ed8eb2d58084204c$var$persistAppliedTransitions(routerWindow, appliedViewTransitions);
            routerWindow.addEventListener("pagehide", _saveAppliedTransitions);
            removePageHideEventListener = ()=>routerWindow.removeEventListener("pagehide", _saveAppliedTransitions);
        }
        // Kick off initial data load if needed.  Use Pop to avoid modifying history
        // Note we don't do any handling of lazy here.  For SPA's it'll get handled
        // in the normal navigation flow.  For SSR it's expected that lazy modules are
        // resolved prior to router creation since we can't go into a fallbackElement
        // UI for SSR'd apps
        if (!state.initialized) startNavigation($ed8eb2d58084204c$export$e19cd5f9376f8cee.Pop, state.location, {
            initialHydration: true
        });
        return router;
    }
    // Clean up a router and it's side effects
    function dispose() {
        if (unlistenHistory) unlistenHistory();
        if (removePageHideEventListener) removePageHideEventListener();
        subscribers.clear();
        pendingNavigationController && pendingNavigationController.abort();
        state.fetchers.forEach((_, key)=>deleteFetcher(key));
        state.blockers.forEach((_, key)=>deleteBlocker(key));
    }
    // Subscribe to state updates for the router
    function subscribe(fn) {
        subscribers.add(fn);
        return ()=>subscribers.delete(fn);
    }
    // Update our state and notify the calling context of the change
    function updateState(newState, opts) {
        if (opts === void 0) opts = {};
        state = $ed8eb2d58084204c$var$_extends({}, state, newState);
        // Prep fetcher cleanup so we can tell the UI which fetcher data entries
        // can be removed
        let completedFetchers = [];
        let deletedFetchersKeys = [];
        if (future.v7_fetcherPersist) state.fetchers.forEach((fetcher, key)=>{
            if (fetcher.state === "idle") {
                if (deletedFetchers.has(key)) // Unmounted from the UI and can be totally removed
                deletedFetchersKeys.push(key);
                else // Returned to idle but still mounted in the UI, so semi-remains for
                // revalidations and such
                completedFetchers.push(key);
            }
        });
        // Remove any lingering deleted fetchers that have already been removed
        // from state.fetchers
        deletedFetchers.forEach((key)=>{
            if (!state.fetchers.has(key) && !fetchControllers.has(key)) deletedFetchersKeys.push(key);
        });
        // Iterate over a local copy so that if flushSync is used and we end up
        // removing and adding a new subscriber due to the useCallback dependencies,
        // we don't get ourselves into a loop calling the new subscriber immediately
        [
            ...subscribers
        ].forEach((subscriber)=>subscriber(state, {
                deletedFetchers: deletedFetchersKeys,
                viewTransitionOpts: opts.viewTransitionOpts,
                flushSync: opts.flushSync === true
            }));
        // Remove idle fetchers from state since we only care about in-flight fetchers.
        if (future.v7_fetcherPersist) {
            completedFetchers.forEach((key)=>state.fetchers.delete(key));
            deletedFetchersKeys.forEach((key)=>deleteFetcher(key));
        } else // We already called deleteFetcher() on these, can remove them from this
        // Set now that we've handed the keys off to the data layer
        deletedFetchersKeys.forEach((key)=>deletedFetchers.delete(key));
    }
    // Complete a navigation returning the state.navigation back to the IDLE_NAVIGATION
    // and setting state.[historyAction/location/matches] to the new route.
    // - Location is a required param
    // - Navigation will always be set to IDLE_NAVIGATION
    // - Can pass any other state in newState
    function completeNavigation(location, newState, _temp) {
        var _location$state, _location$state2;
        let { flushSync: flushSync } = _temp === void 0 ? {} : _temp;
        // Deduce if we're in a loading/actionReload state:
        // - We have committed actionData in the store
        // - The current navigation was a mutation submission
        // - We're past the submitting state and into the loading state
        // - The location being loaded is not the result of a redirect
        let isActionReload = state.actionData != null && state.navigation.formMethod != null && $ed8eb2d58084204c$var$isMutationMethod(state.navigation.formMethod) && state.navigation.state === "loading" && ((_location$state = location.state) == null ? void 0 : _location$state._isRedirect) !== true;
        let actionData;
        if (newState.actionData) {
            if (Object.keys(newState.actionData).length > 0) actionData = newState.actionData;
            else // Empty actionData -> clear prior actionData due to an action error
            actionData = null;
        } else if (isActionReload) // Keep the current data if we're wrapping up the action reload
        actionData = state.actionData;
        else // Clear actionData on any other completed navigations
        actionData = null;
        // Always preserve any existing loaderData from re-used routes
        let loaderData = newState.loaderData ? $ed8eb2d58084204c$var$mergeLoaderData(state.loaderData, newState.loaderData, newState.matches || [], newState.errors) : state.loaderData;
        // On a successful navigation we can assume we got through all blockers
        // so we can start fresh
        let blockers = state.blockers;
        if (blockers.size > 0) {
            blockers = new Map(blockers);
            blockers.forEach((_, k)=>blockers.set(k, $ed8eb2d58084204c$export$386d57f03f0b2883));
        }
        // Always respect the user flag.  Otherwise don't reset on mutation
        // submission navigations unless they redirect
        let preventScrollReset = pendingPreventScrollReset === true || state.navigation.formMethod != null && $ed8eb2d58084204c$var$isMutationMethod(state.navigation.formMethod) && ((_location$state2 = location.state) == null ? void 0 : _location$state2._isRedirect) !== true;
        // Commit any in-flight routes at the end of the HMR revalidation "navigation"
        if (inFlightDataRoutes) {
            dataRoutes = inFlightDataRoutes;
            inFlightDataRoutes = undefined;
        }
        if (isUninterruptedRevalidation) ;
        else if (pendingAction === $ed8eb2d58084204c$export$e19cd5f9376f8cee.Pop) ;
        else if (pendingAction === $ed8eb2d58084204c$export$e19cd5f9376f8cee.Push) init.history.push(location, location.state);
        else if (pendingAction === $ed8eb2d58084204c$export$e19cd5f9376f8cee.Replace) init.history.replace(location, location.state);
        let viewTransitionOpts;
        // On POP, enable transitions if they were enabled on the original navigation
        if (pendingAction === $ed8eb2d58084204c$export$e19cd5f9376f8cee.Pop) {
            // Forward takes precedence so they behave like the original navigation
            let priorPaths = appliedViewTransitions.get(state.location.pathname);
            if (priorPaths && priorPaths.has(location.pathname)) viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
            else if (appliedViewTransitions.has(location.pathname)) // If we don't have a previous forward nav, assume we're popping back to
            // the new location and enable if that location previously enabled
            viewTransitionOpts = {
                currentLocation: location,
                nextLocation: state.location
            };
        } else if (pendingViewTransitionEnabled) {
            // Store the applied transition on PUSH/REPLACE
            let toPaths = appliedViewTransitions.get(state.location.pathname);
            if (toPaths) toPaths.add(location.pathname);
            else {
                toPaths = new Set([
                    location.pathname
                ]);
                appliedViewTransitions.set(state.location.pathname, toPaths);
            }
            viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
        }
        updateState($ed8eb2d58084204c$var$_extends({}, newState, {
            actionData: actionData,
            loaderData: loaderData,
            historyAction: pendingAction,
            location: location,
            initialized: true,
            navigation: $ed8eb2d58084204c$export$ed3e14b2f9e105d0,
            revalidation: "idle",
            restoreScrollPosition: getSavedScrollPosition(location, newState.matches || state.matches),
            preventScrollReset: preventScrollReset,
            blockers: blockers
        }), {
            viewTransitionOpts: viewTransitionOpts,
            flushSync: flushSync === true
        });
        // Reset stateful navigation vars
        pendingAction = $ed8eb2d58084204c$export$e19cd5f9376f8cee.Pop;
        pendingPreventScrollReset = false;
        pendingViewTransitionEnabled = false;
        isUninterruptedRevalidation = false;
        isRevalidationRequired = false;
        cancelledDeferredRoutes = [];
    }
    // Trigger a navigation event, which can either be a numerical POP or a PUSH
    // replace with an optional submission
    async function navigate(to, opts) {
        if (typeof to === "number") {
            init.history.go(to);
            return;
        }
        let normalizedPath = $ed8eb2d58084204c$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, to, future.v7_relativeSplatPath, opts == null ? void 0 : opts.fromRouteId, opts == null ? void 0 : opts.relative);
        let { path: path, submission: submission, error: error } = $ed8eb2d58084204c$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, false, normalizedPath, opts);
        let currentLocation = state.location;
        let nextLocation = $ed8eb2d58084204c$var$createLocation(state.location, path, opts && opts.state);
        // When using navigate as a PUSH/REPLACE we aren't reading an already-encoded
        // URL from window.location, so we need to encode it here so the behavior
        // remains the same as POP and non-data-router usages.  new URL() does all
        // the same encoding we'd get from a history.pushState/window.location read
        // without having to touch history
        nextLocation = $ed8eb2d58084204c$var$_extends({}, nextLocation, init.history.encodeLocation(nextLocation));
        let userReplace = opts && opts.replace != null ? opts.replace : undefined;
        let historyAction = $ed8eb2d58084204c$export$e19cd5f9376f8cee.Push;
        if (userReplace === true) historyAction = $ed8eb2d58084204c$export$e19cd5f9376f8cee.Replace;
        else if (userReplace === false) ;
        else if (submission != null && $ed8eb2d58084204c$var$isMutationMethod(submission.formMethod) && submission.formAction === state.location.pathname + state.location.search) // By default on submissions to the current location we REPLACE so that
        // users don't have to double-click the back button to get to the prior
        // location.  If the user redirects to a different location from the
        // action/loader this will be ignored and the redirect will be a PUSH
        historyAction = $ed8eb2d58084204c$export$e19cd5f9376f8cee.Replace;
        let preventScrollReset = opts && "preventScrollReset" in opts ? opts.preventScrollReset === true : undefined;
        let flushSync = (opts && opts.flushSync) === true;
        let blockerKey = shouldBlockNavigation({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        });
        if (blockerKey) {
            // Put the blocker into a blocked state
            updateBlocker(blockerKey, {
                state: "blocked",
                location: nextLocation,
                proceed () {
                    updateBlocker(blockerKey, {
                        state: "proceeding",
                        proceed: undefined,
                        reset: undefined,
                        location: nextLocation
                    });
                    // Send the same navigation through
                    navigate(to, opts);
                },
                reset () {
                    let blockers = new Map(state.blockers);
                    blockers.set(blockerKey, $ed8eb2d58084204c$export$386d57f03f0b2883);
                    updateState({
                        blockers: blockers
                    });
                }
            });
            return;
        }
        return await startNavigation(historyAction, nextLocation, {
            submission: submission,
            // Send through the formData serialization error if we have one so we can
            // render at the right error boundary after we match routes
            pendingError: error,
            preventScrollReset: preventScrollReset,
            replace: opts && opts.replace,
            enableViewTransition: opts && opts.viewTransition,
            flushSync: flushSync
        });
    }
    // Revalidate all current loaders.  If a navigation is in progress or if this
    // is interrupted by a navigation, allow this to "succeed" by calling all
    // loaders during the next loader round
    function revalidate() {
        interruptActiveLoads();
        updateState({
            revalidation: "loading"
        });
        // If we're currently submitting an action, we don't need to start a new
        // navigation, we'll just let the follow up loader execution call all loaders
        if (state.navigation.state === "submitting") return;
        // If we're currently in an idle state, start a new navigation for the current
        // action/location and mark it as uninterrupted, which will skip the history
        // update in completeNavigation
        if (state.navigation.state === "idle") {
            startNavigation(state.historyAction, state.location, {
                startUninterruptedRevalidation: true
            });
            return;
        }
        // Otherwise, if we're currently in a loading state, just start a new
        // navigation to the navigation.location but do not trigger an uninterrupted
        // revalidation so that history correctly updates once the navigation completes
        startNavigation(pendingAction || state.historyAction, state.navigation.location, {
            overrideNavigation: state.navigation,
            // Proxy through any rending view transition
            enableViewTransition: pendingViewTransitionEnabled === true
        });
    }
    // Start a navigation to the given action/location.  Can optionally provide a
    // overrideNavigation which will override the normalLoad in the case of a redirect
    // navigation
    async function startNavigation(historyAction, location, opts) {
        // Abort any in-progress navigations and start a new one. Unset any ongoing
        // uninterrupted revalidations unless told otherwise, since we want this
        // new navigation to update history normally
        pendingNavigationController && pendingNavigationController.abort();
        pendingNavigationController = null;
        pendingAction = historyAction;
        isUninterruptedRevalidation = (opts && opts.startUninterruptedRevalidation) === true;
        // Save the current scroll position every time we start a new navigation,
        // and track whether we should reset scroll on completion
        saveScrollPosition(state.location, state.matches);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        pendingViewTransitionEnabled = (opts && opts.enableViewTransition) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let loadingNavigation = opts && opts.overrideNavigation;
        let matches = opts != null && opts.initialHydration && state.matches && state.matches.length > 0 && !initialMatchesIsFOW ? // `matchRoutes()` has already been called if we're in here via `router.initialize()`
        state.matches : $ed8eb2d58084204c$export$2708184779ceb39d(routesToUse, location, basename);
        let flushSync = (opts && opts.flushSync) === true;
        // Short circuit if it's only a hash change and not a revalidation or
        // mutation submission.
        //
        // Ignore on initial page loads because since the initial hydration will always
        // be "same hash".  For example, on /page#hash and submit a <Form method="post">
        // which will default to a navigation to /page
        if (matches && state.initialized && !isRevalidationRequired && $ed8eb2d58084204c$var$isHashChangeOnly(state.location, location) && !(opts && opts.submission && $ed8eb2d58084204c$var$isMutationMethod(opts.submission.formMethod))) {
            completeNavigation(location, {
                matches: matches
            }, {
                flushSync: flushSync
            });
            return;
        }
        let fogOfWar = checkFogOfWar(matches, routesToUse, location.pathname);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        // Short circuit with a 404 on the root error boundary if we match nothing
        if (!matches) {
            let { error: error, notFoundMatches: notFoundMatches, route: route } = handleNavigational404(location.pathname);
            completeNavigation(location, {
                matches: notFoundMatches,
                loaderData: {},
                errors: {
                    [route.id]: error
                }
            }, {
                flushSync: flushSync
            });
            return;
        }
        // Create a controller/Request for this navigation
        pendingNavigationController = new AbortController();
        let request = $ed8eb2d58084204c$var$createClientSideRequest(init.history, location, pendingNavigationController.signal, opts && opts.submission);
        let pendingActionResult;
        if (opts && opts.pendingError) // If we have a pendingError, it means the user attempted a GET submission
        // with binary FormData so assign here and skip to handleLoaders.  That
        // way we handle calling loaders above the boundary etc.  It's not really
        // different from an actionError in that sense.
        pendingActionResult = [
            $ed8eb2d58084204c$var$findNearestBoundary(matches).route.id,
            {
                type: $ed8eb2d58084204c$var$ResultType.error,
                error: opts.pendingError
            }
        ];
        else if (opts && opts.submission && $ed8eb2d58084204c$var$isMutationMethod(opts.submission.formMethod)) {
            // Call action if we received an action submission
            let actionResult = await handleAction(request, location, opts.submission, matches, fogOfWar.active, {
                replace: opts.replace,
                flushSync: flushSync
            });
            if (actionResult.shortCircuited) return;
            // If we received a 404 from handleAction, it's because we couldn't lazily
            // discover the destination route so we don't want to call loaders
            if (actionResult.pendingActionResult) {
                let [routeId, result] = actionResult.pendingActionResult;
                if ($ed8eb2d58084204c$var$isErrorResult(result) && $ed8eb2d58084204c$export$972111febbeef05b(result.error) && result.error.status === 404) {
                    pendingNavigationController = null;
                    completeNavigation(location, {
                        matches: actionResult.matches,
                        loaderData: {},
                        errors: {
                            [routeId]: result.error
                        }
                    });
                    return;
                }
            }
            matches = actionResult.matches || matches;
            pendingActionResult = actionResult.pendingActionResult;
            loadingNavigation = $ed8eb2d58084204c$var$getLoadingNavigation(location, opts.submission);
            flushSync = false;
            // No need to do fog of war matching again on loader execution
            fogOfWar.active = false;
            // Create a GET request for the loaders
            request = $ed8eb2d58084204c$var$createClientSideRequest(init.history, request.url, request.signal);
        }
        // Call loaders
        let { shortCircuited: shortCircuited, matches: updatedMatches, loaderData: loaderData, errors: errors } = await handleLoaders(request, location, matches, fogOfWar.active, loadingNavigation, opts && opts.submission, opts && opts.fetcherSubmission, opts && opts.replace, opts && opts.initialHydration === true, flushSync, pendingActionResult);
        if (shortCircuited) return;
        // Clean up now that the action/loaders have completed.  Don't clean up if
        // we short circuited because pendingNavigationController will have already
        // been assigned to a new controller for the next navigation
        pendingNavigationController = null;
        completeNavigation(location, $ed8eb2d58084204c$var$_extends({
            matches: updatedMatches || matches
        }, $ed8eb2d58084204c$var$getActionDataForCommit(pendingActionResult), {
            loaderData: loaderData,
            errors: errors
        }));
    }
    // Call the action matched by the leaf route for this navigation and handle
    // redirects/errors
    async function handleAction(request, location, submission, matches, isFogOfWar, opts) {
        if (opts === void 0) opts = {};
        interruptActiveLoads();
        // Put us in a submitting state
        let navigation = $ed8eb2d58084204c$var$getSubmittingNavigation(location, submission);
        updateState({
            navigation: navigation
        }, {
            flushSync: opts.flushSync === true
        });
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(matches, location.pathname, request.signal);
            if (discoverResult.type === "aborted") return {
                shortCircuited: true
            };
            else if (discoverResult.type === "error") {
                let boundaryId = $ed8eb2d58084204c$var$findNearestBoundary(discoverResult.partialMatches).route.id;
                return {
                    matches: discoverResult.partialMatches,
                    pendingActionResult: [
                        boundaryId,
                        {
                            type: $ed8eb2d58084204c$var$ResultType.error,
                            error: discoverResult.error
                        }
                    ]
                };
            } else if (!discoverResult.matches) {
                let { notFoundMatches: notFoundMatches, error: error, route: route } = handleNavigational404(location.pathname);
                return {
                    matches: notFoundMatches,
                    pendingActionResult: [
                        route.id,
                        {
                            type: $ed8eb2d58084204c$var$ResultType.error,
                            error: error
                        }
                    ]
                };
            } else matches = discoverResult.matches;
        }
        // Call our action and get the result
        let result;
        let actionMatch = $ed8eb2d58084204c$var$getTargetMatch(matches, location);
        if (!actionMatch.route.action && !actionMatch.route.lazy) result = {
            type: $ed8eb2d58084204c$var$ResultType.error,
            error: $ed8eb2d58084204c$var$getInternalRouterError(405, {
                method: request.method,
                pathname: location.pathname,
                routeId: actionMatch.route.id
            })
        };
        else {
            let results = await callDataStrategy("action", state, request, [
                actionMatch
            ], matches, null);
            result = results[actionMatch.route.id];
            if (request.signal.aborted) return {
                shortCircuited: true
            };
        }
        if ($ed8eb2d58084204c$var$isRedirectResult(result)) {
            let replace;
            if (opts && opts.replace != null) replace = opts.replace;
            else {
                // If the user didn't explicity indicate replace behavior, replace if
                // we redirected to the exact same location we're currently at to avoid
                // double back-buttons
                let location = $ed8eb2d58084204c$var$normalizeRedirectLocation(result.response.headers.get("Location"), new URL(request.url), basename);
                replace = location === state.location.pathname + state.location.search;
            }
            await startRedirectNavigation(request, result, true, {
                submission: submission,
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        if ($ed8eb2d58084204c$var$isDeferredResult(result)) throw $ed8eb2d58084204c$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        if ($ed8eb2d58084204c$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = $ed8eb2d58084204c$var$findNearestBoundary(matches, actionMatch.route.id);
            // By default, all submissions to the current location are REPLACE
            // navigations, but if the action threw an error that'll be rendered in
            // an errorElement, we fall back to PUSH so that the user can use the
            // back button to get back to the pre-submission form location to try
            // again
            if ((opts && opts.replace) !== true) pendingAction = $ed8eb2d58084204c$export$e19cd5f9376f8cee.Push;
            return {
                matches: matches,
                pendingActionResult: [
                    boundaryMatch.route.id,
                    result
                ]
            };
        }
        return {
            matches: matches,
            pendingActionResult: [
                actionMatch.route.id,
                result
            ]
        };
    }
    // Call all applicable loaders for the given matches, handling redirects,
    // errors, etc.
    async function handleLoaders(request, location, matches, isFogOfWar, overrideNavigation, submission, fetcherSubmission, replace, initialHydration, flushSync, pendingActionResult) {
        // Figure out the right navigation we want to use for data loading
        let loadingNavigation = overrideNavigation || $ed8eb2d58084204c$var$getLoadingNavigation(location, submission);
        // If this was a redirect from an action we don't have a "submission" but
        // we have it on the loading navigation so use that if available
        let activeSubmission = submission || fetcherSubmission || $ed8eb2d58084204c$var$getSubmissionFromNavigation(loadingNavigation);
        // If this is an uninterrupted revalidation, we remain in our current idle
        // state.  If not, we need to switch to our loading state and load data,
        // preserving any new action data or existing action data (in the case of
        // a revalidation interrupting an actionReload)
        // If we have partialHydration enabled, then don't update the state for the
        // initial data load since it's not a "navigation"
        let shouldUpdateNavigationState = !isUninterruptedRevalidation && (!future.v7_partialHydration || !initialHydration);
        // When fog of war is enabled, we enter our `loading` state earlier so we
        // can discover new routes during the `loading` state.  We skip this if
        // we've already run actions since we would have done our matching already.
        // If the children() function threw then, we want to proceed with the
        // partial matches it discovered.
        if (isFogOfWar) {
            if (shouldUpdateNavigationState) {
                let actionData = getUpdatedActionData(pendingActionResult);
                updateState($ed8eb2d58084204c$var$_extends({
                    navigation: loadingNavigation
                }, actionData !== undefined ? {
                    actionData: actionData
                } : {}), {
                    flushSync: flushSync
                });
            }
            let discoverResult = await discoverRoutes(matches, location.pathname, request.signal);
            if (discoverResult.type === "aborted") return {
                shortCircuited: true
            };
            else if (discoverResult.type === "error") {
                let boundaryId = $ed8eb2d58084204c$var$findNearestBoundary(discoverResult.partialMatches).route.id;
                return {
                    matches: discoverResult.partialMatches,
                    loaderData: {},
                    errors: {
                        [boundaryId]: discoverResult.error
                    }
                };
            } else if (!discoverResult.matches) {
                let { error: error, notFoundMatches: notFoundMatches, route: route } = handleNavigational404(location.pathname);
                return {
                    matches: notFoundMatches,
                    loaderData: {},
                    errors: {
                        [route.id]: error
                    }
                };
            } else matches = discoverResult.matches;
        }
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let [matchesToLoad, revalidatingFetchers] = $ed8eb2d58084204c$var$getMatchesToLoad(init.history, state, matches, activeSubmission, location, future.v7_partialHydration && initialHydration === true, future.v7_skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionResult);
        // Cancel pending deferreds for no-longer-matched routes or routes we're
        // about to reload.  Note that if this is an action reload we would have
        // already cancelled all pending deferreds so this would be a no-op
        cancelActiveDeferreds((routeId)=>!(matches && matches.some((m)=>m.route.id === routeId)) || matchesToLoad && matchesToLoad.some((m)=>m.route.id === routeId));
        pendingNavigationLoadId = ++incrementingLoadId;
        // Short circuit if we have no loaders to run
        if (matchesToLoad.length === 0 && revalidatingFetchers.length === 0) {
            let updatedFetchers = markFetchRedirectsDone();
            completeNavigation(location, $ed8eb2d58084204c$var$_extends({
                matches: matches,
                loaderData: {},
                // Commit pending error if we're short circuiting
                errors: pendingActionResult && $ed8eb2d58084204c$var$isErrorResult(pendingActionResult[1]) ? {
                    [pendingActionResult[0]]: pendingActionResult[1].error
                } : null
            }, $ed8eb2d58084204c$var$getActionDataForCommit(pendingActionResult), updatedFetchers ? {
                fetchers: new Map(state.fetchers)
            } : {}), {
                flushSync: flushSync
            });
            return {
                shortCircuited: true
            };
        }
        if (shouldUpdateNavigationState) {
            let updates = {};
            if (!isFogOfWar) {
                // Only update navigation/actionNData if we didn't already do it above
                updates.navigation = loadingNavigation;
                let actionData = getUpdatedActionData(pendingActionResult);
                if (actionData !== undefined) updates.actionData = actionData;
            }
            if (revalidatingFetchers.length > 0) updates.fetchers = getUpdatedRevalidatingFetchers(revalidatingFetchers);
            updateState(updates, {
                flushSync: flushSync
            });
        }
        revalidatingFetchers.forEach((rf)=>{
            abortFetcher(rf.key);
            if (rf.controller) // Fetchers use an independent AbortController so that aborting a fetcher
            // (via deleteFetcher) does not abort the triggering navigation that
            // triggered the revalidation
            fetchControllers.set(rf.key, rf.controller);
        });
        // Proxy navigation abort through to revalidation fetchers
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((f)=>abortFetcher(f.key));
        if (pendingNavigationController) pendingNavigationController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state, matches, matchesToLoad, revalidatingFetchers, request);
        if (request.signal.aborted) return {
            shortCircuited: true
        };
        // Clean up _after_ loaders have completed.  Don't clean up if we short
        // circuited because fetchControllers would have been aborted and
        // reassigned to new controllers for the next navigation
        if (pendingNavigationController) pendingNavigationController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        revalidatingFetchers.forEach((rf)=>fetchControllers.delete(rf.key));
        // If any loaders returned a redirect Response, start a new REPLACE navigation
        let redirect = $ed8eb2d58084204c$var$findRedirect(loaderResults);
        if (redirect) {
            await startRedirectNavigation(request, redirect.result, true, {
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        redirect = $ed8eb2d58084204c$var$findRedirect(fetcherResults);
        if (redirect) {
            // If this redirect came from a fetcher make sure we mark it in
            // fetchRedirectIds so it doesn't get revalidated on the next set of
            // loader executions
            fetchRedirectIds.add(redirect.key);
            await startRedirectNavigation(request, redirect.result, true, {
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $ed8eb2d58084204c$var$processLoaderData(state, matches, loaderResults, pendingActionResult, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Wire up subscribers to update loaderData as promises settle
        activeDeferreds.forEach((deferredData, routeId)=>{
            deferredData.subscribe((aborted)=>{
                // Note: No need to updateState here since the TrackedPromise on
                // loaderData is stable across resolve/reject
                // Remove this instance if we were aborted or if promises have settled
                if (aborted || deferredData.done) activeDeferreds.delete(routeId);
            });
        });
        // Preserve SSR errors during partial hydration
        if (future.v7_partialHydration && initialHydration && state.errors) errors = $ed8eb2d58084204c$var$_extends({}, state.errors, errors);
        let updatedFetchers = markFetchRedirectsDone();
        let didAbortFetchLoads = abortStaleFetchLoads(pendingNavigationLoadId);
        let shouldUpdateFetchers = updatedFetchers || didAbortFetchLoads || revalidatingFetchers.length > 0;
        return $ed8eb2d58084204c$var$_extends({
            matches: matches,
            loaderData: loaderData,
            errors: errors
        }, shouldUpdateFetchers ? {
            fetchers: new Map(state.fetchers)
        } : {});
    }
    function getUpdatedActionData(pendingActionResult) {
        if (pendingActionResult && !$ed8eb2d58084204c$var$isErrorResult(pendingActionResult[1])) // This is cast to `any` currently because `RouteData`uses any and it
        // would be a breaking change to use any.
        // TODO: v7 - change `RouteData` to use `unknown` instead of `any`
        return {
            [pendingActionResult[0]]: pendingActionResult[1].data
        };
        else if (state.actionData) {
            if (Object.keys(state.actionData).length === 0) return null;
            else return state.actionData;
        }
    }
    function getUpdatedRevalidatingFetchers(revalidatingFetchers) {
        revalidatingFetchers.forEach((rf)=>{
            let fetcher = state.fetchers.get(rf.key);
            let revalidatingFetcher = $ed8eb2d58084204c$var$getLoadingFetcher(undefined, fetcher ? fetcher.data : undefined);
            state.fetchers.set(rf.key, revalidatingFetcher);
        });
        return new Map(state.fetchers);
    }
    // Trigger a fetcher load/submit for the given fetcher key
    function fetch(key, routeId, href, opts) {
        if (isServer) throw new Error("router.fetch() was called during the server render, but it shouldn't be. You are likely calling a useFetcher() method in the body of your component. Try moving it to a useEffect or a callback.");
        abortFetcher(key);
        let flushSync = (opts && opts.flushSync) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let normalizedPath = $ed8eb2d58084204c$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, href, future.v7_relativeSplatPath, routeId, opts == null ? void 0 : opts.relative);
        let matches = $ed8eb2d58084204c$export$2708184779ceb39d(routesToUse, normalizedPath, basename);
        let fogOfWar = checkFogOfWar(matches, routesToUse, normalizedPath);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        if (!matches) {
            setFetcherError(key, routeId, $ed8eb2d58084204c$var$getInternalRouterError(404, {
                pathname: normalizedPath
            }), {
                flushSync: flushSync
            });
            return;
        }
        let { path: path, submission: submission, error: error } = $ed8eb2d58084204c$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, true, normalizedPath, opts);
        if (error) {
            setFetcherError(key, routeId, error, {
                flushSync: flushSync
            });
            return;
        }
        let match = $ed8eb2d58084204c$var$getTargetMatch(matches, path);
        let preventScrollReset = (opts && opts.preventScrollReset) === true;
        if (submission && $ed8eb2d58084204c$var$isMutationMethod(submission.formMethod)) {
            handleFetcherAction(key, routeId, path, match, matches, fogOfWar.active, flushSync, preventScrollReset, submission);
            return;
        }
        // Store off the match so we can call it's shouldRevalidate on subsequent
        // revalidations
        fetchLoadMatches.set(key, {
            routeId: routeId,
            path: path
        });
        handleFetcherLoader(key, routeId, path, match, matches, fogOfWar.active, flushSync, preventScrollReset, submission);
    }
    // Call the action for the matched fetcher.submit(), and then handle redirects,
    // errors, and revalidation
    async function handleFetcherAction(key, routeId, path, match, requestMatches, isFogOfWar, flushSync, preventScrollReset, submission) {
        interruptActiveLoads();
        fetchLoadMatches.delete(key);
        function detectAndHandle405Error(m) {
            if (!m.route.action && !m.route.lazy) {
                let error = $ed8eb2d58084204c$var$getInternalRouterError(405, {
                    method: submission.formMethod,
                    pathname: path,
                    routeId: routeId
                });
                setFetcherError(key, routeId, error, {
                    flushSync: flushSync
                });
                return true;
            }
            return false;
        }
        if (!isFogOfWar && detectAndHandle405Error(match)) return;
        // Put this fetcher into it's submitting state
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $ed8eb2d58084204c$var$getSubmittingFetcher(submission, existingFetcher), {
            flushSync: flushSync
        });
        let abortController = new AbortController();
        let fetchRequest = $ed8eb2d58084204c$var$createClientSideRequest(init.history, path, abortController.signal, submission);
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(requestMatches, new URL(fetchRequest.url).pathname, fetchRequest.signal, key);
            if (discoverResult.type === "aborted") return;
            else if (discoverResult.type === "error") {
                setFetcherError(key, routeId, discoverResult.error, {
                    flushSync: flushSync
                });
                return;
            } else if (!discoverResult.matches) {
                setFetcherError(key, routeId, $ed8eb2d58084204c$var$getInternalRouterError(404, {
                    pathname: path
                }), {
                    flushSync: flushSync
                });
                return;
            } else {
                requestMatches = discoverResult.matches;
                match = $ed8eb2d58084204c$var$getTargetMatch(requestMatches, path);
                if (detectAndHandle405Error(match)) return;
            }
        }
        // Call the action for the fetcher
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let actionResults = await callDataStrategy("action", state, fetchRequest, [
            match
        ], requestMatches, key);
        let actionResult = actionResults[match.route.id];
        if (fetchRequest.signal.aborted) {
            // We can delete this so long as we weren't aborted by our own fetcher
            // re-submit which would have put _new_ controller is in fetchControllers
            if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
            return;
        }
        // When using v7_fetcherPersist, we don't want errors bubbling up to the UI
        // or redirects processed for unmounted fetchers so we just revert them to
        // idle
        if (future.v7_fetcherPersist && deletedFetchers.has(key)) {
            if ($ed8eb2d58084204c$var$isRedirectResult(actionResult) || $ed8eb2d58084204c$var$isErrorResult(actionResult)) {
                updateFetcherState(key, $ed8eb2d58084204c$var$getDoneFetcher(undefined));
                return;
            }
        } else {
            if ($ed8eb2d58084204c$var$isRedirectResult(actionResult)) {
                fetchControllers.delete(key);
                if (pendingNavigationLoadId > originatingLoadId) {
                    // A new navigation was kicked off after our action started, so that
                    // should take precedence over this redirect navigation.  We already
                    // set isRevalidationRequired so all loaders for the new route should
                    // fire unless opted out via shouldRevalidate
                    updateFetcherState(key, $ed8eb2d58084204c$var$getDoneFetcher(undefined));
                    return;
                } else {
                    fetchRedirectIds.add(key);
                    updateFetcherState(key, $ed8eb2d58084204c$var$getLoadingFetcher(submission));
                    return startRedirectNavigation(fetchRequest, actionResult, false, {
                        fetcherSubmission: submission,
                        preventScrollReset: preventScrollReset
                    });
                }
            }
            // Process any non-redirect errors thrown
            if ($ed8eb2d58084204c$var$isErrorResult(actionResult)) {
                setFetcherError(key, routeId, actionResult.error);
                return;
            }
        }
        if ($ed8eb2d58084204c$var$isDeferredResult(actionResult)) throw $ed8eb2d58084204c$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        // Start the data load for current matches, or the next location if we're
        // in the middle of a navigation
        let nextLocation = state.navigation.location || state.location;
        let revalidationRequest = $ed8eb2d58084204c$var$createClientSideRequest(init.history, nextLocation, abortController.signal);
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let matches = state.navigation.state !== "idle" ? $ed8eb2d58084204c$export$2708184779ceb39d(routesToUse, state.navigation.location, basename) : state.matches;
        $ed8eb2d58084204c$export$3e9cee6b33872309(matches, "Didn't find any matches after fetcher action");
        let loadId = ++incrementingLoadId;
        fetchReloadIds.set(key, loadId);
        let loadFetcher = $ed8eb2d58084204c$var$getLoadingFetcher(submission, actionResult.data);
        state.fetchers.set(key, loadFetcher);
        let [matchesToLoad, revalidatingFetchers] = $ed8eb2d58084204c$var$getMatchesToLoad(init.history, state, matches, submission, nextLocation, false, future.v7_skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, [
            match.route.id,
            actionResult
        ]);
        // Put all revalidating fetchers into the loading state, except for the
        // current fetcher which we want to keep in it's current loading state which
        // contains it's action submission info + action data
        revalidatingFetchers.filter((rf)=>rf.key !== key).forEach((rf)=>{
            let staleKey = rf.key;
            let existingFetcher = state.fetchers.get(staleKey);
            let revalidatingFetcher = $ed8eb2d58084204c$var$getLoadingFetcher(undefined, existingFetcher ? existingFetcher.data : undefined);
            state.fetchers.set(staleKey, revalidatingFetcher);
            abortFetcher(staleKey);
            if (rf.controller) fetchControllers.set(staleKey, rf.controller);
        });
        updateState({
            fetchers: new Map(state.fetchers)
        });
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((rf)=>abortFetcher(rf.key));
        abortController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state, matches, matchesToLoad, revalidatingFetchers, revalidationRequest);
        if (abortController.signal.aborted) return;
        abortController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        fetchReloadIds.delete(key);
        fetchControllers.delete(key);
        revalidatingFetchers.forEach((r)=>fetchControllers.delete(r.key));
        let redirect = $ed8eb2d58084204c$var$findRedirect(loaderResults);
        if (redirect) return startRedirectNavigation(revalidationRequest, redirect.result, false, {
            preventScrollReset: preventScrollReset
        });
        redirect = $ed8eb2d58084204c$var$findRedirect(fetcherResults);
        if (redirect) {
            // If this redirect came from a fetcher make sure we mark it in
            // fetchRedirectIds so it doesn't get revalidated on the next set of
            // loader executions
            fetchRedirectIds.add(redirect.key);
            return startRedirectNavigation(revalidationRequest, redirect.result, false, {
                preventScrollReset: preventScrollReset
            });
        }
        // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $ed8eb2d58084204c$var$processLoaderData(state, matches, loaderResults, undefined, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Since we let revalidations complete even if the submitting fetcher was
        // deleted, only put it back to idle if it hasn't been deleted
        if (state.fetchers.has(key)) {
            let doneFetcher = $ed8eb2d58084204c$var$getDoneFetcher(actionResult.data);
            state.fetchers.set(key, doneFetcher);
        }
        abortStaleFetchLoads(loadId);
        // If we are currently in a navigation loading state and this fetcher is
        // more recent than the navigation, we want the newer data so abort the
        // navigation and complete it with the fetcher data
        if (state.navigation.state === "loading" && loadId > pendingNavigationLoadId) {
            $ed8eb2d58084204c$export$3e9cee6b33872309(pendingAction, "Expected pending action");
            pendingNavigationController && pendingNavigationController.abort();
            completeNavigation(state.navigation.location, {
                matches: matches,
                loaderData: loaderData,
                errors: errors,
                fetchers: new Map(state.fetchers)
            });
        } else {
            // otherwise just update with the fetcher data, preserving any existing
            // loaderData for loaders that did not need to reload.  We have to
            // manually merge here since we aren't going through completeNavigation
            updateState({
                errors: errors,
                loaderData: $ed8eb2d58084204c$var$mergeLoaderData(state.loaderData, loaderData, matches, errors),
                fetchers: new Map(state.fetchers)
            });
            isRevalidationRequired = false;
        }
    }
    // Call the matched loader for fetcher.load(), handling redirects, errors, etc.
    async function handleFetcherLoader(key, routeId, path, match, matches, isFogOfWar, flushSync, preventScrollReset, submission) {
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $ed8eb2d58084204c$var$getLoadingFetcher(submission, existingFetcher ? existingFetcher.data : undefined), {
            flushSync: flushSync
        });
        let abortController = new AbortController();
        let fetchRequest = $ed8eb2d58084204c$var$createClientSideRequest(init.history, path, abortController.signal);
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(matches, new URL(fetchRequest.url).pathname, fetchRequest.signal, key);
            if (discoverResult.type === "aborted") return;
            else if (discoverResult.type === "error") {
                setFetcherError(key, routeId, discoverResult.error, {
                    flushSync: flushSync
                });
                return;
            } else if (!discoverResult.matches) {
                setFetcherError(key, routeId, $ed8eb2d58084204c$var$getInternalRouterError(404, {
                    pathname: path
                }), {
                    flushSync: flushSync
                });
                return;
            } else {
                matches = discoverResult.matches;
                match = $ed8eb2d58084204c$var$getTargetMatch(matches, path);
            }
        }
        // Call the loader for this fetcher route match
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let results = await callDataStrategy("loader", state, fetchRequest, [
            match
        ], matches, key);
        let result = results[match.route.id];
        // Deferred isn't supported for fetcher loads, await everything and treat it
        // as a normal load.  resolveDeferredData will return undefined if this
        // fetcher gets aborted, so we just leave result untouched and short circuit
        // below if that happens
        if ($ed8eb2d58084204c$var$isDeferredResult(result)) result = await $ed8eb2d58084204c$var$resolveDeferredData(result, fetchRequest.signal, true) || result;
        // We can delete this so long as we weren't aborted by our our own fetcher
        // re-load which would have put _new_ controller is in fetchControllers
        if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
        if (fetchRequest.signal.aborted) return;
        // We don't want errors bubbling up or redirects followed for unmounted
        // fetchers, so short circuit here if it was removed from the UI
        if (deletedFetchers.has(key)) {
            updateFetcherState(key, $ed8eb2d58084204c$var$getDoneFetcher(undefined));
            return;
        }
        // If the loader threw a redirect Response, start a new REPLACE navigation
        if ($ed8eb2d58084204c$var$isRedirectResult(result)) {
            if (pendingNavigationLoadId > originatingLoadId) {
                // A new navigation was kicked off after our loader started, so that
                // should take precedence over this redirect navigation
                updateFetcherState(key, $ed8eb2d58084204c$var$getDoneFetcher(undefined));
                return;
            } else {
                fetchRedirectIds.add(key);
                await startRedirectNavigation(fetchRequest, result, false, {
                    preventScrollReset: preventScrollReset
                });
                return;
            }
        }
        // Process any non-redirect errors thrown
        if ($ed8eb2d58084204c$var$isErrorResult(result)) {
            setFetcherError(key, routeId, result.error);
            return;
        }
        $ed8eb2d58084204c$export$3e9cee6b33872309(!$ed8eb2d58084204c$var$isDeferredResult(result), "Unhandled fetcher deferred data");
        // Put the fetcher back into an idle state
        updateFetcherState(key, $ed8eb2d58084204c$var$getDoneFetcher(result.data));
    }
    /**
   * Utility function to handle redirects returned from an action or loader.
   * Normally, a redirect "replaces" the navigation that triggered it.  So, for
   * example:
   *
   *  - user is on /a
   *  - user clicks a link to /b
   *  - loader for /b redirects to /c
   *
   * In a non-JS app the browser would track the in-flight navigation to /b and
   * then replace it with /c when it encountered the redirect response.  In
   * the end it would only ever update the URL bar with /c.
   *
   * In client-side routing using pushState/replaceState, we aim to emulate
   * this behavior and we also do not update history until the end of the
   * navigation (including processed redirects).  This means that we never
   * actually touch history until we've processed redirects, so we just use
   * the history action from the original navigation (PUSH or REPLACE).
   */ async function startRedirectNavigation(request, redirect, isNavigation, _temp2) {
        let { submission: submission, fetcherSubmission: fetcherSubmission, preventScrollReset: preventScrollReset, replace: replace } = _temp2 === void 0 ? {} : _temp2;
        if (redirect.response.headers.has("X-Remix-Revalidate")) isRevalidationRequired = true;
        let location = redirect.response.headers.get("Location");
        $ed8eb2d58084204c$export$3e9cee6b33872309(location, "Expected a Location header on the redirect Response");
        location = $ed8eb2d58084204c$var$normalizeRedirectLocation(location, new URL(request.url), basename);
        let redirectLocation = $ed8eb2d58084204c$var$createLocation(state.location, location, {
            _isRedirect: true
        });
        if (isBrowser) {
            let isDocumentReload = false;
            if (redirect.response.headers.has("X-Remix-Reload-Document")) // Hard reload if the response contained X-Remix-Reload-Document
            isDocumentReload = true;
            else if ($ed8eb2d58084204c$var$ABSOLUTE_URL_REGEX.test(location)) {
                const url = init.history.createURL(location);
                isDocumentReload = // Hard reload if it's an absolute URL to a new origin
                url.origin !== routerWindow.location.origin || // Hard reload if it's an absolute URL that does not match our basename
                $ed8eb2d58084204c$export$b69e3301ce081aa3(url.pathname, basename) == null;
            }
            if (isDocumentReload) {
                if (replace) routerWindow.location.replace(location);
                else routerWindow.location.assign(location);
                return;
            }
        }
        // There's no need to abort on redirects, since we don't detect the
        // redirect until the action/loaders have settled
        pendingNavigationController = null;
        let redirectHistoryAction = replace === true || redirect.response.headers.has("X-Remix-Replace") ? $ed8eb2d58084204c$export$e19cd5f9376f8cee.Replace : $ed8eb2d58084204c$export$e19cd5f9376f8cee.Push;
        // Use the incoming submission if provided, fallback on the active one in
        // state.navigation
        let { formMethod: formMethod, formAction: formAction, formEncType: formEncType } = state.navigation;
        if (!submission && !fetcherSubmission && formMethod && formAction && formEncType) submission = $ed8eb2d58084204c$var$getSubmissionFromNavigation(state.navigation);
        // If this was a 307/308 submission we want to preserve the HTTP method and
        // re-submit the GET/POST/PUT/PATCH/DELETE as a submission navigation to the
        // redirected location
        let activeSubmission = submission || fetcherSubmission;
        if ($ed8eb2d58084204c$var$redirectPreserveMethodStatusCodes.has(redirect.response.status) && activeSubmission && $ed8eb2d58084204c$var$isMutationMethod(activeSubmission.formMethod)) await startNavigation(redirectHistoryAction, redirectLocation, {
            submission: $ed8eb2d58084204c$var$_extends({}, activeSubmission, {
                formAction: location
            }),
            // Preserve these flags across redirects
            preventScrollReset: preventScrollReset || pendingPreventScrollReset,
            enableViewTransition: isNavigation ? pendingViewTransitionEnabled : undefined
        });
        else {
            // If we have a navigation submission, we will preserve it through the
            // redirect navigation
            let overrideNavigation = $ed8eb2d58084204c$var$getLoadingNavigation(redirectLocation, submission);
            await startNavigation(redirectHistoryAction, redirectLocation, {
                overrideNavigation: overrideNavigation,
                fetcherSubmission: // Send fetcher submissions through for shouldRevalidate
                fetcherSubmission,
                // Preserve these flags across redirects
                preventScrollReset: preventScrollReset || pendingPreventScrollReset,
                enableViewTransition: isNavigation ? pendingViewTransitionEnabled : undefined
            });
        }
    }
    // Utility wrapper for calling dataStrategy client-side without having to
    // pass around the manifest, mapRouteProperties, etc.
    async function callDataStrategy(type, state, request, matchesToLoad, matches, fetcherKey) {
        let results;
        let dataResults = {};
        try {
            results = await $ed8eb2d58084204c$var$callDataStrategyImpl(dataStrategyImpl, type, state, request, matchesToLoad, matches, fetcherKey, manifest, mapRouteProperties);
        } catch (e) {
            // If the outer dataStrategy method throws, just return the error for all
            // matches - and it'll naturally bubble to the root
            matchesToLoad.forEach((m)=>{
                dataResults[m.route.id] = {
                    type: $ed8eb2d58084204c$var$ResultType.error,
                    error: e
                };
            });
            return dataResults;
        }
        for (let [routeId, result] of Object.entries(results))if ($ed8eb2d58084204c$var$isRedirectDataStrategyResultResult(result)) {
            let response = result.result;
            dataResults[routeId] = {
                type: $ed8eb2d58084204c$var$ResultType.redirect,
                response: $ed8eb2d58084204c$var$normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename, future.v7_relativeSplatPath)
            };
        } else dataResults[routeId] = await $ed8eb2d58084204c$var$convertDataStrategyResultToDataResult(result);
        return dataResults;
    }
    async function callLoadersAndMaybeResolveData(state, matches, matchesToLoad, fetchersToLoad, request) {
        let currentMatches = state.matches;
        // Kick off loaders and fetchers in parallel
        let loaderResultsPromise = callDataStrategy("loader", state, request, matchesToLoad, matches, null);
        let fetcherResultsPromise = Promise.all(fetchersToLoad.map(async (f)=>{
            if (f.matches && f.match && f.controller) {
                let results = await callDataStrategy("loader", state, $ed8eb2d58084204c$var$createClientSideRequest(init.history, f.path, f.controller.signal), [
                    f.match
                ], f.matches, f.key);
                let result = results[f.match.route.id];
                // Fetcher results are keyed by fetcher key from here on out, not routeId
                return {
                    [f.key]: result
                };
            } else return Promise.resolve({
                [f.key]: {
                    type: $ed8eb2d58084204c$var$ResultType.error,
                    error: $ed8eb2d58084204c$var$getInternalRouterError(404, {
                        pathname: f.path
                    })
                }
            });
        }));
        let loaderResults = await loaderResultsPromise;
        let fetcherResults = (await fetcherResultsPromise).reduce((acc, r)=>Object.assign(acc, r), {});
        await Promise.all([
            $ed8eb2d58084204c$var$resolveNavigationDeferredResults(matches, loaderResults, request.signal, currentMatches, state.loaderData),
            $ed8eb2d58084204c$var$resolveFetcherDeferredResults(matches, fetcherResults, fetchersToLoad)
        ]);
        return {
            loaderResults: loaderResults,
            fetcherResults: fetcherResults
        };
    }
    function interruptActiveLoads() {
        // Every interruption triggers a revalidation
        isRevalidationRequired = true;
        // Cancel pending route-level deferreds and mark cancelled routes for
        // revalidation
        cancelledDeferredRoutes.push(...cancelActiveDeferreds());
        // Abort in-flight fetcher loads
        fetchLoadMatches.forEach((_, key)=>{
            if (fetchControllers.has(key)) cancelledFetcherLoads.add(key);
            abortFetcher(key);
        });
    }
    function updateFetcherState(key, fetcher, opts) {
        if (opts === void 0) opts = {};
        state.fetchers.set(key, fetcher);
        updateState({
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function setFetcherError(key, routeId, error, opts) {
        if (opts === void 0) opts = {};
        let boundaryMatch = $ed8eb2d58084204c$var$findNearestBoundary(state.matches, routeId);
        deleteFetcher(key);
        updateState({
            errors: {
                [boundaryMatch.route.id]: error
            },
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function getFetcher(key) {
        activeFetchers.set(key, (activeFetchers.get(key) || 0) + 1);
        // If this fetcher was previously marked for deletion, unmark it since we
        // have a new instance
        if (deletedFetchers.has(key)) deletedFetchers.delete(key);
        return state.fetchers.get(key) || $ed8eb2d58084204c$export$52eace9c284d3585;
    }
    function deleteFetcher(key) {
        let fetcher = state.fetchers.get(key);
        // Don't abort the controller if this is a deletion of a fetcher.submit()
        // in it's loading phase since - we don't want to abort the corresponding
        // revalidation and want them to complete and land
        if (fetchControllers.has(key) && !(fetcher && fetcher.state === "loading" && fetchReloadIds.has(key))) abortFetcher(key);
        fetchLoadMatches.delete(key);
        fetchReloadIds.delete(key);
        fetchRedirectIds.delete(key);
        // If we opted into the flag we can clear this now since we're calling
        // deleteFetcher() at the end of updateState() and we've already handed the
        // deleted fetcher keys off to the data layer.
        // If not, we're eagerly calling deleteFetcher() and we need to keep this
        // Set populated until the next updateState call, and we'll clear
        // `deletedFetchers` then
        if (future.v7_fetcherPersist) deletedFetchers.delete(key);
        cancelledFetcherLoads.delete(key);
        state.fetchers.delete(key);
    }
    function deleteFetcherAndUpdateState(key) {
        let count = (activeFetchers.get(key) || 0) - 1;
        if (count <= 0) {
            activeFetchers.delete(key);
            deletedFetchers.add(key);
            if (!future.v7_fetcherPersist) deleteFetcher(key);
        } else activeFetchers.set(key, count);
        updateState({
            fetchers: new Map(state.fetchers)
        });
    }
    function abortFetcher(key) {
        let controller = fetchControllers.get(key);
        if (controller) {
            controller.abort();
            fetchControllers.delete(key);
        }
    }
    function markFetchersDone(keys) {
        for (let key of keys){
            let fetcher = getFetcher(key);
            let doneFetcher = $ed8eb2d58084204c$var$getDoneFetcher(fetcher.data);
            state.fetchers.set(key, doneFetcher);
        }
    }
    function markFetchRedirectsDone() {
        let doneKeys = [];
        let updatedFetchers = false;
        for (let key of fetchRedirectIds){
            let fetcher = state.fetchers.get(key);
            $ed8eb2d58084204c$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                fetchRedirectIds.delete(key);
                doneKeys.push(key);
                updatedFetchers = true;
            }
        }
        markFetchersDone(doneKeys);
        return updatedFetchers;
    }
    function abortStaleFetchLoads(landedId) {
        let yeetedKeys = [];
        for (let [key, id] of fetchReloadIds)if (id < landedId) {
            let fetcher = state.fetchers.get(key);
            $ed8eb2d58084204c$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                abortFetcher(key);
                fetchReloadIds.delete(key);
                yeetedKeys.push(key);
            }
        }
        markFetchersDone(yeetedKeys);
        return yeetedKeys.length > 0;
    }
    function getBlocker(key, fn) {
        let blocker = state.blockers.get(key) || $ed8eb2d58084204c$export$386d57f03f0b2883;
        if (blockerFunctions.get(key) !== fn) blockerFunctions.set(key, fn);
        return blocker;
    }
    function deleteBlocker(key) {
        state.blockers.delete(key);
        blockerFunctions.delete(key);
    }
    // Utility function to update blockers, ensuring valid state transitions
    function updateBlocker(key, newBlocker) {
        let blocker = state.blockers.get(key) || $ed8eb2d58084204c$export$386d57f03f0b2883;
        // Poor mans state machine :)
        // https://mermaid.live/edit#pako:eNqVkc9OwzAMxl8l8nnjAYrEtDIOHEBIgwvKJTReGy3_lDpIqO27k6awMG0XcrLlnz87nwdonESogKXXBuE79rq75XZO3-yHds0RJVuv70YrPlUrCEe2HfrORS3rubqZfuhtpg5C9wk5tZ4VKcRUq88q9Z8RS0-48cE1iHJkL0ugbHuFLus9L6spZy8nX9MP2CNdomVaposqu3fGayT8T8-jJQwhepo_UtpgBQaDEUom04dZhAN1aJBDlUKJBxE1ceB2Smj0Mln-IBW5AFU2dwUiktt_2Qaq2dBfaKdEup85UV7Yd-dKjlnkabl2Pvr0DTkTreM
        $ed8eb2d58084204c$export$3e9cee6b33872309(blocker.state === "unblocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "proceeding" || blocker.state === "blocked" && newBlocker.state === "unblocked" || blocker.state === "proceeding" && newBlocker.state === "unblocked", "Invalid blocker state transition: " + blocker.state + " -> " + newBlocker.state);
        let blockers = new Map(state.blockers);
        blockers.set(key, newBlocker);
        updateState({
            blockers: blockers
        });
    }
    function shouldBlockNavigation(_ref2) {
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = _ref2;
        if (blockerFunctions.size === 0) return;
        // We ony support a single active blocker at the moment since we don't have
        // any compelling use cases for multi-blocker yet
        if (blockerFunctions.size > 1) $ed8eb2d58084204c$export$c0e02632e14916fd(false, "A router only supports one blocker at a time");
        let entries = Array.from(blockerFunctions.entries());
        let [blockerKey, blockerFunction] = entries[entries.length - 1];
        let blocker = state.blockers.get(blockerKey);
        if (blocker && blocker.state === "proceeding") // If the blocker is currently proceeding, we don't need to re-check
        // it and can let this navigation continue
        return;
        // At this point, we know we're unblocked/blocked so we need to check the
        // user-provided blocker function
        if (blockerFunction({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        })) return blockerKey;
    }
    function handleNavigational404(pathname) {
        let error = $ed8eb2d58084204c$var$getInternalRouterError(404, {
            pathname: pathname
        });
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let { matches: matches, route: route } = $ed8eb2d58084204c$var$getShortCircuitMatches(routesToUse);
        // Cancel all pending deferred on 404s since we don't keep any routes
        cancelActiveDeferreds();
        return {
            notFoundMatches: matches,
            route: route,
            error: error
        };
    }
    function cancelActiveDeferreds(predicate) {
        let cancelledRouteIds = [];
        activeDeferreds.forEach((dfd, routeId)=>{
            if (!predicate || predicate(routeId)) {
                // Cancel the deferred - but do not remove from activeDeferreds here -
                // we rely on the subscribers to do that so our tests can assert proper
                // cleanup via _internalActiveDeferreds
                dfd.cancel();
                cancelledRouteIds.push(routeId);
                activeDeferreds.delete(routeId);
            }
        });
        return cancelledRouteIds;
    }
    // Opt in to capturing and reporting scroll positions during navigations,
    // used by the <ScrollRestoration> component
    function enableScrollRestoration(positions, getPosition, getKey) {
        savedScrollPositions = positions;
        getScrollPosition = getPosition;
        getScrollRestorationKey = getKey || null;
        // Perform initial hydration scroll restoration, since we miss the boat on
        // the initial updateState() because we've not yet rendered <ScrollRestoration/>
        // and therefore have no savedScrollPositions available
        if (!initialScrollRestored && state.navigation === $ed8eb2d58084204c$export$ed3e14b2f9e105d0) {
            initialScrollRestored = true;
            let y = getSavedScrollPosition(state.location, state.matches);
            if (y != null) updateState({
                restoreScrollPosition: y
            });
        }
        return ()=>{
            savedScrollPositions = null;
            getScrollPosition = null;
            getScrollRestorationKey = null;
        };
    }
    function getScrollKey(location, matches) {
        if (getScrollRestorationKey) {
            let key = getScrollRestorationKey(location, matches.map((m)=>$ed8eb2d58084204c$export$b3fac024fad9e8ff(m, state.loaderData)));
            return key || location.key;
        }
        return location.key;
    }
    function saveScrollPosition(location, matches) {
        if (savedScrollPositions && getScrollPosition) {
            let key = getScrollKey(location, matches);
            savedScrollPositions[key] = getScrollPosition();
        }
    }
    function getSavedScrollPosition(location, matches) {
        if (savedScrollPositions) {
            let key = getScrollKey(location, matches);
            let y = savedScrollPositions[key];
            if (typeof y === "number") return y;
        }
        return null;
    }
    function checkFogOfWar(matches, routesToUse, pathname) {
        if (patchRoutesOnNavigationImpl) {
            if (!matches) {
                let fogMatches = $ed8eb2d58084204c$var$matchRoutesImpl(routesToUse, pathname, basename, true);
                return {
                    active: true,
                    matches: fogMatches || []
                };
            } else if (Object.keys(matches[0].params).length > 0) {
                // If we matched a dynamic param or a splat, it might only be because
                // we haven't yet discovered other routes that would match with a
                // higher score.  Call patchRoutesOnNavigation just to be sure
                let partialMatches = $ed8eb2d58084204c$var$matchRoutesImpl(routesToUse, pathname, basename, true);
                return {
                    active: true,
                    matches: partialMatches
                };
            }
        }
        return {
            active: false,
            matches: null
        };
    }
    async function discoverRoutes(matches, pathname, signal, fetcherKey) {
        if (!patchRoutesOnNavigationImpl) return {
            type: "success",
            matches: matches
        };
        let partialMatches = matches;
        while(true){
            let isNonHMR = inFlightDataRoutes == null;
            let routesToUse = inFlightDataRoutes || dataRoutes;
            let localManifest = manifest;
            try {
                await patchRoutesOnNavigationImpl({
                    signal: signal,
                    path: pathname,
                    matches: partialMatches,
                    fetcherKey: fetcherKey,
                    patch: (routeId, children)=>{
                        if (signal.aborted) return;
                        $ed8eb2d58084204c$var$patchRoutesImpl(routeId, children, routesToUse, localManifest, mapRouteProperties);
                    }
                });
            } catch (e) {
                return {
                    type: "error",
                    error: e,
                    partialMatches: partialMatches
                };
            } finally{
                // If we are not in the middle of an HMR revalidation and we changed the
                // routes, provide a new identity so when we `updateState` at the end of
                // this navigation/fetch `router.routes` will be a new identity and
                // trigger a re-run of memoized `router.routes` dependencies.
                // HMR will already update the identity and reflow when it lands
                // `inFlightDataRoutes` in `completeNavigation`
                if (isNonHMR && !signal.aborted) dataRoutes = [
                    ...dataRoutes
                ];
            }
            if (signal.aborted) return {
                type: "aborted"
            };
            let newMatches = $ed8eb2d58084204c$export$2708184779ceb39d(routesToUse, pathname, basename);
            if (newMatches) return {
                type: "success",
                matches: newMatches
            };
            let newPartialMatches = $ed8eb2d58084204c$var$matchRoutesImpl(routesToUse, pathname, basename, true);
            // Avoid loops if the second pass results in the same partial matches
            if (!newPartialMatches || partialMatches.length === newPartialMatches.length && partialMatches.every((m, i)=>m.route.id === newPartialMatches[i].route.id)) return {
                type: "success",
                matches: null
            };
            partialMatches = newPartialMatches;
        }
    }
    function _internalSetRoutes(newRoutes) {
        manifest = {};
        inFlightDataRoutes = $ed8eb2d58084204c$export$4a6d22b32134ea5d(newRoutes, mapRouteProperties, undefined, manifest);
    }
    function patchRoutes(routeId, children) {
        let isNonHMR = inFlightDataRoutes == null;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        $ed8eb2d58084204c$var$patchRoutesImpl(routeId, children, routesToUse, manifest, mapRouteProperties);
        // If we are not in the middle of an HMR revalidation and we changed the
        // routes, provide a new identity and trigger a reflow via `updateState`
        // to re-run memoized `router.routes` dependencies.
        // HMR will already update the identity and reflow when it lands
        // `inFlightDataRoutes` in `completeNavigation`
        if (isNonHMR) {
            dataRoutes = [
                ...dataRoutes
            ];
            updateState({});
        }
    }
    router = {
        get basename () {
            return basename;
        },
        get future () {
            return future;
        },
        get state () {
            return state;
        },
        get routes () {
            return dataRoutes;
        },
        get window () {
            return routerWindow;
        },
        initialize: initialize,
        subscribe: subscribe,
        enableScrollRestoration: enableScrollRestoration,
        navigate: navigate,
        fetch: fetch,
        revalidate: revalidate,
        // Passthrough to history-aware createHref used by useHref so we get proper
        // hash-aware URLs in DOM paths
        createHref: (to)=>init.history.createHref(to),
        encodeLocation: (to)=>init.history.encodeLocation(to),
        getFetcher: getFetcher,
        deleteFetcher: deleteFetcherAndUpdateState,
        dispose: dispose,
        getBlocker: getBlocker,
        deleteBlocker: deleteBlocker,
        patchRoutes: patchRoutes,
        _internalFetchControllers: fetchControllers,
        _internalActiveDeferreds: activeDeferreds,
        _internalSetRoutes: // TODO: Remove setRoutes, it's temporary to avoid dealing with
        // updating the tree while validating the update algorithm.
        _internalSetRoutes
    };
    return router;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createStaticHandler
////////////////////////////////////////////////////////////////////////////////
const $ed8eb2d58084204c$export$4d0306f8f6a4585b = Symbol("deferred");
function $ed8eb2d58084204c$export$3336b097a6fbc59a(routes, opts) {
    $ed8eb2d58084204c$export$3e9cee6b33872309(routes.length > 0, "You must provide a non-empty routes array to createStaticHandler");
    let manifest = {};
    let basename = (opts ? opts.basename : null) || "/";
    let mapRouteProperties;
    if (opts != null && opts.mapRouteProperties) mapRouteProperties = opts.mapRouteProperties;
    else if (opts != null && opts.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = opts.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $ed8eb2d58084204c$var$defaultMapRouteProperties;
    // Config driven behavior flags
    let future = $ed8eb2d58084204c$var$_extends({
        v7_relativeSplatPath: false,
        v7_throwAbortReason: false
    }, opts ? opts.future : null);
    let dataRoutes = $ed8eb2d58084204c$export$4a6d22b32134ea5d(routes, mapRouteProperties, undefined, manifest);
    /**
   * The query() method is intended for document requests, in which we want to
   * call an optional action and potentially multiple loaders for all nested
   * routes.  It returns a StaticHandlerContext object, which is very similar
   * to the router state (location, loaderData, actionData, errors, etc.) and
   * also adds SSR-specific information such as the statusCode and headers
   * from action/loaders Responses.
   *
   * It _should_ never throw and should report all errors through the
   * returned context.errors object, properly associating errors to their error
   * boundary.  Additionally, it tracks _deepestRenderedBoundaryId which can be
   * used to emulate React error boundaries during SSr by performing a second
   * pass only down to the boundaryId.
   *
   * The one exception where we do not return a StaticHandlerContext is when a
   * redirect response is returned or thrown from any action/loader.  We
   * propagate that out and return the raw Response so the HTTP server can
   * return it directly.
   *
   * - `opts.requestContext` is an optional server context that will be passed
   *   to actions/loaders in the `context` parameter
   * - `opts.skipLoaderErrorBubbling` is an optional parameter that will prevent
   *   the bubbling of errors which allows single-fetch-type implementations
   *   where the client will handle the bubbling and we may need to return data
   *   for the handling route
   */ async function query(request, _temp3) {
        let { requestContext: requestContext, skipLoaderErrorBubbling: skipLoaderErrorBubbling, dataStrategy: dataStrategy } = _temp3 === void 0 ? {} : _temp3;
        let url = new URL(request.url);
        let method = request.method;
        let location = $ed8eb2d58084204c$var$createLocation("", $ed8eb2d58084204c$export$fe53371bee54353d(url), null, "default");
        let matches = $ed8eb2d58084204c$export$2708184779ceb39d(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!$ed8eb2d58084204c$var$isValidMethod(method) && method !== "HEAD") {
            let error = $ed8eb2d58084204c$var$getInternalRouterError(405, {
                method: method
            });
            let { matches: methodNotAllowedMatches, route: route } = $ed8eb2d58084204c$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: methodNotAllowedMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        } else if (!matches) {
            let error = $ed8eb2d58084204c$var$getInternalRouterError(404, {
                pathname: location.pathname
            });
            let { matches: notFoundMatches, route: route } = $ed8eb2d58084204c$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: notFoundMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        let result = await queryImpl(request, location, matches, requestContext, dataStrategy || null, skipLoaderErrorBubbling === true, null);
        if ($ed8eb2d58084204c$var$isResponse(result)) return result;
        // When returning StaticHandlerContext, we patch back in the location here
        // since we need it for React Context.  But this helps keep our submit and
        // loadRouteData operating on a Request instead of a Location
        return $ed8eb2d58084204c$var$_extends({
            location: location,
            basename: basename
        }, result);
    }
    /**
   * The queryRoute() method is intended for targeted route requests, either
   * for fetch ?_data requests or resource route requests.  In this case, we
   * are only ever calling a single action or loader, and we are returning the
   * returned value directly.  In most cases, this will be a Response returned
   * from the action/loader, but it may be a primitive or other value as well -
   * and in such cases the calling context should handle that accordingly.
   *
   * We do respect the throw/return differentiation, so if an action/loader
   * throws, then this method will throw the value.  This is important so we
   * can do proper boundary identification in Remix where a thrown Response
   * must go to the Catch Boundary but a returned Response is happy-path.
   *
   * One thing to note is that any Router-initiated Errors that make sense
   * to associate with a status code will be thrown as an ErrorResponse
   * instance which include the raw Error, such that the calling context can
   * serialize the error as they see fit while including the proper response
   * code.  Examples here are 404 and 405 errors that occur prior to reaching
   * any user-defined loaders.
   *
   * - `opts.routeId` allows you to specify the specific route handler to call.
   *   If not provided the handler will determine the proper route by matching
   *   against `request.url`
   * - `opts.requestContext` is an optional server context that will be passed
   *    to actions/loaders in the `context` parameter
   */ async function queryRoute(request, _temp4) {
        let { routeId: routeId, requestContext: requestContext, dataStrategy: dataStrategy } = _temp4 === void 0 ? {} : _temp4;
        let url = new URL(request.url);
        let method = request.method;
        let location = $ed8eb2d58084204c$var$createLocation("", $ed8eb2d58084204c$export$fe53371bee54353d(url), null, "default");
        let matches = $ed8eb2d58084204c$export$2708184779ceb39d(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!$ed8eb2d58084204c$var$isValidMethod(method) && method !== "HEAD" && method !== "OPTIONS") throw $ed8eb2d58084204c$var$getInternalRouterError(405, {
            method: method
        });
        else if (!matches) throw $ed8eb2d58084204c$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let match = routeId ? matches.find((m)=>m.route.id === routeId) : $ed8eb2d58084204c$var$getTargetMatch(matches, location);
        if (routeId && !match) throw $ed8eb2d58084204c$var$getInternalRouterError(403, {
            pathname: location.pathname,
            routeId: routeId
        });
        else if (!match) // This should never hit I don't think?
        throw $ed8eb2d58084204c$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let result = await queryImpl(request, location, matches, requestContext, dataStrategy || null, false, match);
        if ($ed8eb2d58084204c$var$isResponse(result)) return result;
        let error = result.errors ? Object.values(result.errors)[0] : undefined;
        if (error !== undefined) // If we got back result.errors, that means the loader/action threw
        // _something_ that wasn't a Response, but it's not guaranteed/required
        // to be an `instanceof Error` either, so we have to use throw here to
        // preserve the "error" state outside of queryImpl.
        throw error;
        // Pick off the right state value to return
        if (result.actionData) return Object.values(result.actionData)[0];
        if (result.loaderData) {
            var _result$activeDeferre;
            let data = Object.values(result.loaderData)[0];
            if ((_result$activeDeferre = result.activeDeferreds) != null && _result$activeDeferre[match.route.id]) data[$ed8eb2d58084204c$export$4d0306f8f6a4585b] = result.activeDeferreds[match.route.id];
            return data;
        }
        return undefined;
    }
    async function queryImpl(request, location, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch) {
        $ed8eb2d58084204c$export$3e9cee6b33872309(request.signal, "query()/queryRoute() requests must contain an AbortController signal");
        try {
            if ($ed8eb2d58084204c$var$isMutationMethod(request.method.toLowerCase())) {
                let result = await submit(request, matches, routeMatch || $ed8eb2d58084204c$var$getTargetMatch(matches, location), requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch != null);
                return result;
            }
            let result = await loadRouteData(request, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch);
            return $ed8eb2d58084204c$var$isResponse(result) ? result : $ed8eb2d58084204c$var$_extends({}, result, {
                actionData: null,
                actionHeaders: {}
            });
        } catch (e) {
            // If the user threw/returned a Response in callLoaderOrAction for a
            // `queryRoute` call, we throw the `DataStrategyResult` to bail out early
            // and then return or throw the raw Response here accordingly
            if ($ed8eb2d58084204c$var$isDataStrategyResult(e) && $ed8eb2d58084204c$var$isResponse(e.result)) {
                if (e.type === $ed8eb2d58084204c$var$ResultType.error) throw e.result;
                return e.result;
            }
            // Redirects are always returned since they don't propagate to catch
            // boundaries
            if ($ed8eb2d58084204c$var$isRedirectResponse(e)) return e;
            throw e;
        }
    }
    async function submit(request, matches, actionMatch, requestContext, dataStrategy, skipLoaderErrorBubbling, isRouteRequest) {
        let result;
        if (!actionMatch.route.action && !actionMatch.route.lazy) {
            let error = $ed8eb2d58084204c$var$getInternalRouterError(405, {
                method: request.method,
                pathname: new URL(request.url).pathname,
                routeId: actionMatch.route.id
            });
            if (isRouteRequest) throw error;
            result = {
                type: $ed8eb2d58084204c$var$ResultType.error,
                error: error
            };
        } else {
            let results = await callDataStrategy("action", request, [
                actionMatch
            ], matches, isRouteRequest, requestContext, dataStrategy);
            result = results[actionMatch.route.id];
            if (request.signal.aborted) $ed8eb2d58084204c$var$throwStaticHandlerAbortedError(request, isRouteRequest, future);
        }
        if ($ed8eb2d58084204c$var$isRedirectResult(result)) // Uhhhh - this should never happen, we should always throw these from
        // callLoaderOrAction, but the type narrowing here keeps TS happy and we
        // can get back on the "throw all redirect responses" train here should
        // this ever happen :/
        throw new Response(null, {
            status: result.response.status,
            headers: {
                Location: result.response.headers.get("Location")
            }
        });
        if ($ed8eb2d58084204c$var$isDeferredResult(result)) {
            let error = $ed8eb2d58084204c$var$getInternalRouterError(400, {
                type: "defer-action"
            });
            if (isRouteRequest) throw error;
            result = {
                type: $ed8eb2d58084204c$var$ResultType.error,
                error: error
            };
        }
        if (isRouteRequest) {
            // Note: This should only be non-Response values if we get here, since
            // isRouteRequest should throw any Response received in callLoaderOrAction
            if ($ed8eb2d58084204c$var$isErrorResult(result)) throw result.error;
            return {
                matches: [
                    actionMatch
                ],
                loaderData: {},
                actionData: {
                    [actionMatch.route.id]: result.data
                },
                errors: null,
                // Note: statusCode + headers are unused here since queryRoute will
                // return the raw Response or value
                statusCode: 200,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        // Create a GET request for the loaders
        let loaderRequest = new Request(request.url, {
            headers: request.headers,
            redirect: request.redirect,
            signal: request.signal
        });
        if ($ed8eb2d58084204c$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = skipLoaderErrorBubbling ? actionMatch : $ed8eb2d58084204c$var$findNearestBoundary(matches, actionMatch.route.id);
            let context = await loadRouteData(loaderRequest, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, null, [
                boundaryMatch.route.id,
                result
            ]);
            // action status codes take precedence over loader status codes
            return $ed8eb2d58084204c$var$_extends({}, context, {
                statusCode: $ed8eb2d58084204c$export$972111febbeef05b(result.error) ? result.error.status : result.statusCode != null ? result.statusCode : 500,
                actionData: null,
                actionHeaders: $ed8eb2d58084204c$var$_extends({}, result.headers ? {
                    [actionMatch.route.id]: result.headers
                } : {})
            });
        }
        let context = await loadRouteData(loaderRequest, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, null);
        return $ed8eb2d58084204c$var$_extends({}, context, {
            actionData: {
                [actionMatch.route.id]: result.data
            }
        }, result.statusCode ? {
            statusCode: result.statusCode
        } : {}, {
            actionHeaders: result.headers ? {
                [actionMatch.route.id]: result.headers
            } : {}
        });
    }
    async function loadRouteData(request, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch, pendingActionResult) {
        let isRouteRequest = routeMatch != null;
        // Short circuit if we have no loaders to run (queryRoute())
        if (isRouteRequest && !(routeMatch != null && routeMatch.route.loader) && !(routeMatch != null && routeMatch.route.lazy)) throw $ed8eb2d58084204c$var$getInternalRouterError(400, {
            method: request.method,
            pathname: new URL(request.url).pathname,
            routeId: routeMatch == null ? void 0 : routeMatch.route.id
        });
        let requestMatches = routeMatch ? [
            routeMatch
        ] : pendingActionResult && $ed8eb2d58084204c$var$isErrorResult(pendingActionResult[1]) ? $ed8eb2d58084204c$var$getLoaderMatchesUntilBoundary(matches, pendingActionResult[0]) : matches;
        let matchesToLoad = requestMatches.filter((m)=>m.route.loader || m.route.lazy);
        // Short circuit if we have no loaders to run (query())
        if (matchesToLoad.length === 0) return {
            matches: matches,
            // Add a null for all matched routes for proper revalidation on the client
            loaderData: matches.reduce((acc, m)=>Object.assign(acc, {
                    [m.route.id]: null
                }), {}),
            errors: pendingActionResult && $ed8eb2d58084204c$var$isErrorResult(pendingActionResult[1]) ? {
                [pendingActionResult[0]]: pendingActionResult[1].error
            } : null,
            statusCode: 200,
            loaderHeaders: {},
            activeDeferreds: null
        };
        let results = await callDataStrategy("loader", request, matchesToLoad, matches, isRouteRequest, requestContext, dataStrategy);
        if (request.signal.aborted) $ed8eb2d58084204c$var$throwStaticHandlerAbortedError(request, isRouteRequest, future);
        // Process and commit output from loaders
        let activeDeferreds = new Map();
        let context = $ed8eb2d58084204c$var$processRouteLoaderData(matches, results, pendingActionResult, activeDeferreds, skipLoaderErrorBubbling);
        // Add a null for any non-loader matches for proper revalidation on the client
        let executedLoaders = new Set(matchesToLoad.map((match)=>match.route.id));
        matches.forEach((match)=>{
            if (!executedLoaders.has(match.route.id)) context.loaderData[match.route.id] = null;
        });
        return $ed8eb2d58084204c$var$_extends({}, context, {
            matches: matches,
            activeDeferreds: activeDeferreds.size > 0 ? Object.fromEntries(activeDeferreds.entries()) : null
        });
    }
    // Utility wrapper for calling dataStrategy server-side without having to
    // pass around the manifest, mapRouteProperties, etc.
    async function callDataStrategy(type, request, matchesToLoad, matches, isRouteRequest, requestContext, dataStrategy) {
        let results = await $ed8eb2d58084204c$var$callDataStrategyImpl(dataStrategy || $ed8eb2d58084204c$var$defaultDataStrategy, type, null, request, matchesToLoad, matches, null, manifest, mapRouteProperties, requestContext);
        let dataResults = {};
        await Promise.all(matches.map(async (match)=>{
            if (!(match.route.id in results)) return;
            let result = results[match.route.id];
            if ($ed8eb2d58084204c$var$isRedirectDataStrategyResultResult(result)) {
                let response = result.result;
                // Throw redirects and let the server handle them with an HTTP redirect
                throw $ed8eb2d58084204c$var$normalizeRelativeRoutingRedirectResponse(response, request, match.route.id, matches, basename, future.v7_relativeSplatPath);
            }
            if ($ed8eb2d58084204c$var$isResponse(result.result) && isRouteRequest) // For SSR single-route requests, we want to hand Responses back
            // directly without unwrapping
            throw result;
            dataResults[match.route.id] = await $ed8eb2d58084204c$var$convertDataStrategyResultToDataResult(result);
        }));
        return dataResults;
    }
    return {
        dataRoutes: dataRoutes,
        query: query,
        queryRoute: queryRoute
    };
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Helpers
////////////////////////////////////////////////////////////////////////////////
/**
 * Given an existing StaticHandlerContext and an error thrown at render time,
 * provide an updated StaticHandlerContext suitable for a second SSR render
 */ function $ed8eb2d58084204c$export$fec11da027c70692(routes, context, error) {
    let newContext = $ed8eb2d58084204c$var$_extends({}, context, {
        statusCode: $ed8eb2d58084204c$export$972111febbeef05b(error) ? error.status : 500,
        errors: {
            [context._deepestRenderedBoundaryId || routes[0].id]: error
        }
    });
    return newContext;
}
function $ed8eb2d58084204c$var$throwStaticHandlerAbortedError(request, isRouteRequest, future) {
    if (future.v7_throwAbortReason && request.signal.reason !== undefined) throw request.signal.reason;
    let method = isRouteRequest ? "queryRoute" : "query";
    throw new Error(method + "() call aborted: " + request.method + " " + request.url);
}
function $ed8eb2d58084204c$var$isSubmissionNavigation(opts) {
    return opts != null && ("formData" in opts && opts.formData != null || "body" in opts && opts.body !== undefined);
}
function $ed8eb2d58084204c$var$normalizeTo(location, matches, basename, prependBasename, to, v7_relativeSplatPath, fromRouteId, relative) {
    let contextualMatches;
    let activeRouteMatch;
    if (fromRouteId) {
        // Grab matches up to the calling route so our route-relative logic is
        // relative to the correct source route
        contextualMatches = [];
        for (let match of matches){
            contextualMatches.push(match);
            if (match.route.id === fromRouteId) {
                activeRouteMatch = match;
                break;
            }
        }
    } else {
        contextualMatches = matches;
        activeRouteMatch = matches[matches.length - 1];
    }
    // Resolve the relative path
    let path = $ed8eb2d58084204c$export$cae722b0cc860f13(to ? to : ".", $ed8eb2d58084204c$export$a5784978eca585fa(contextualMatches, v7_relativeSplatPath), $ed8eb2d58084204c$export$b69e3301ce081aa3(location.pathname, basename) || location.pathname, relative === "path");
    // When `to` is not specified we inherit search/hash from the current
    // location, unlike when to="." and we just inherit the path.
    // See https://github.com/remix-run/remix/issues/927
    if (to == null) {
        path.search = location.search;
        path.hash = location.hash;
    }
    // Account for `?index` params when routing to the current location
    if ((to == null || to === "" || to === ".") && activeRouteMatch) {
        let nakedIndex = $ed8eb2d58084204c$var$hasNakedIndexQuery(path.search);
        if (activeRouteMatch.route.index && !nakedIndex) // Add one when we're targeting an index route
        path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
        else if (!activeRouteMatch.route.index && nakedIndex) {
            // Remove existing ones when we're not
            let params = new URLSearchParams(path.search);
            let indexValues = params.getAll("index");
            params.delete("index");
            indexValues.filter((v)=>v).forEach((v)=>params.append("index", v));
            let qs = params.toString();
            path.search = qs ? "?" + qs : "";
        }
    }
    // If we're operating within a basename, prepend it to the pathname.  If
    // this is a root navigation, then just use the raw basename which allows
    // the basename to have full control over the presence of a trailing slash
    // on root actions
    if (prependBasename && basename !== "/") path.pathname = path.pathname === "/" ? basename : $ed8eb2d58084204c$export$86d9a7913e44197e([
        basename,
        path.pathname
    ]);
    return $ed8eb2d58084204c$export$fe53371bee54353d(path);
}
// Normalize navigation options by converting formMethod=GET formData objects to
// URLSearchParams so they behave identically to links with query params
function $ed8eb2d58084204c$var$normalizeNavigateOptions(normalizeFormMethod, isFetcher, path, opts) {
    // Return location verbatim on non-submission navigations
    if (!opts || !$ed8eb2d58084204c$var$isSubmissionNavigation(opts)) return {
        path: path
    };
    if (opts.formMethod && !$ed8eb2d58084204c$var$isValidMethod(opts.formMethod)) return {
        path: path,
        error: $ed8eb2d58084204c$var$getInternalRouterError(405, {
            method: opts.formMethod
        })
    };
    let getInvalidBodyError = ()=>({
            path: path,
            error: $ed8eb2d58084204c$var$getInternalRouterError(400, {
                type: "invalid-body"
            })
        });
    // Create a Submission on non-GET navigations
    let rawFormMethod = opts.formMethod || "get";
    let formMethod = normalizeFormMethod ? rawFormMethod.toUpperCase() : rawFormMethod.toLowerCase();
    let formAction = $ed8eb2d58084204c$var$stripHashFromPath(path);
    if (opts.body !== undefined) {
        if (opts.formEncType === "text/plain") {
            // text only support POST/PUT/PATCH/DELETE submissions
            if (!$ed8eb2d58084204c$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            let text = typeof opts.body === "string" ? opts.body : opts.body instanceof FormData || opts.body instanceof URLSearchParams ? // https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#plain-text-form-data
            Array.from(opts.body.entries()).reduce((acc, _ref3)=>{
                let [name, value] = _ref3;
                return "" + acc + name + "=" + value + "\n";
            }, "") : String(opts.body);
            return {
                path: path,
                submission: {
                    formMethod: formMethod,
                    formAction: formAction,
                    formEncType: opts.formEncType,
                    formData: undefined,
                    json: undefined,
                    text: text
                }
            };
        } else if (opts.formEncType === "application/json") {
            // json only supports POST/PUT/PATCH/DELETE submissions
            if (!$ed8eb2d58084204c$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            try {
                let json = typeof opts.body === "string" ? JSON.parse(opts.body) : opts.body;
                return {
                    path: path,
                    submission: {
                        formMethod: formMethod,
                        formAction: formAction,
                        formEncType: opts.formEncType,
                        formData: undefined,
                        json: json,
                        text: undefined
                    }
                };
            } catch (e) {
                return getInvalidBodyError();
            }
        }
    }
    $ed8eb2d58084204c$export$3e9cee6b33872309(typeof FormData === "function", "FormData is not available in this environment");
    let searchParams;
    let formData;
    if (opts.formData) {
        searchParams = $ed8eb2d58084204c$var$convertFormDataToSearchParams(opts.formData);
        formData = opts.formData;
    } else if (opts.body instanceof FormData) {
        searchParams = $ed8eb2d58084204c$var$convertFormDataToSearchParams(opts.body);
        formData = opts.body;
    } else if (opts.body instanceof URLSearchParams) {
        searchParams = opts.body;
        formData = $ed8eb2d58084204c$var$convertSearchParamsToFormData(searchParams);
    } else if (opts.body == null) {
        searchParams = new URLSearchParams();
        formData = new FormData();
    } else try {
        searchParams = new URLSearchParams(opts.body);
        formData = $ed8eb2d58084204c$var$convertSearchParamsToFormData(searchParams);
    } catch (e) {
        return getInvalidBodyError();
    }
    let submission = {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: opts && opts.formEncType || "application/x-www-form-urlencoded",
        formData: formData,
        json: undefined,
        text: undefined
    };
    if ($ed8eb2d58084204c$var$isMutationMethod(submission.formMethod)) return {
        path: path,
        submission: submission
    };
    // Flatten submission onto URLSearchParams for GET submissions
    let parsedPath = $ed8eb2d58084204c$export$8ccf933b0513f8d0(path);
    // On GET navigation submissions we can drop the ?index param from the
    // resulting location since all loaders will run.  But fetcher GET submissions
    // only run a single loader so we need to preserve any incoming ?index params
    if (isFetcher && parsedPath.search && $ed8eb2d58084204c$var$hasNakedIndexQuery(parsedPath.search)) searchParams.append("index", "");
    parsedPath.search = "?" + searchParams;
    return {
        path: $ed8eb2d58084204c$export$fe53371bee54353d(parsedPath),
        submission: submission
    };
}
// Filter out all routes at/below any caught error as they aren't going to
// render so we don't need to load them
function $ed8eb2d58084204c$var$getLoaderMatchesUntilBoundary(matches, boundaryId, includeBoundary) {
    if (includeBoundary === void 0) includeBoundary = false;
    let index = matches.findIndex((m)=>m.route.id === boundaryId);
    if (index >= 0) return matches.slice(0, includeBoundary ? index + 1 : index);
    return matches;
}
function $ed8eb2d58084204c$var$getMatchesToLoad(history, state, matches, submission, location, initialHydration, skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionResult) {
    let actionResult = pendingActionResult ? $ed8eb2d58084204c$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : pendingActionResult[1].data : undefined;
    let currentUrl = history.createURL(state.location);
    let nextUrl = history.createURL(location);
    // Pick navigation matches that are net-new or qualify for revalidation
    let boundaryMatches = matches;
    if (initialHydration && state.errors) // On initial hydration, only consider matches up to _and including_ the boundary.
    // This is inclusive to handle cases where a server loader ran successfully,
    // a child server loader bubbled up to this route, but this route has
    // `clientLoader.hydrate` so we want to still run the `clientLoader` so that
    // we have a complete version of `loaderData`
    boundaryMatches = $ed8eb2d58084204c$var$getLoaderMatchesUntilBoundary(matches, Object.keys(state.errors)[0], true);
    else if (pendingActionResult && $ed8eb2d58084204c$var$isErrorResult(pendingActionResult[1])) // If an action threw an error, we call loaders up to, but not including the
    // boundary
    boundaryMatches = $ed8eb2d58084204c$var$getLoaderMatchesUntilBoundary(matches, pendingActionResult[0]);
    // Don't revalidate loaders by default after action 4xx/5xx responses
    // when the flag is enabled.  They can still opt-into revalidation via
    // `shouldRevalidate` via `actionResult`
    let actionStatus = pendingActionResult ? pendingActionResult[1].statusCode : undefined;
    let shouldSkipRevalidation = skipActionErrorRevalidation && actionStatus && actionStatus >= 400;
    let navigationMatches = boundaryMatches.filter((match, index)=>{
        let { route: route } = match;
        if (route.lazy) // We haven't loaded this route yet so we don't know if it's got a loader!
        return true;
        if (route.loader == null) return false;
        if (initialHydration) return $ed8eb2d58084204c$var$shouldLoadRouteOnHydration(route, state.loaderData, state.errors);
        // Always call the loader on new route instances and pending defer cancellations
        if ($ed8eb2d58084204c$var$isNewLoader(state.loaderData, state.matches[index], match) || cancelledDeferredRoutes.some((id)=>id === match.route.id)) return true;
        // This is the default implementation for when we revalidate.  If the route
        // provides it's own implementation, then we give them full control but
        // provide this value so they can leverage it if needed after they check
        // their own specific use cases
        let currentRouteMatch = state.matches[index];
        let nextRouteMatch = match;
        return $ed8eb2d58084204c$var$shouldRevalidateLoader(match, $ed8eb2d58084204c$var$_extends({
            currentUrl: currentUrl,
            currentParams: currentRouteMatch.params,
            nextUrl: nextUrl,
            nextParams: nextRouteMatch.params
        }, submission, {
            actionResult: actionResult,
            actionStatus: actionStatus,
            defaultShouldRevalidate: shouldSkipRevalidation ? false : // Forced revalidation due to submission, useRevalidator, or X-Remix-Revalidate
            isRevalidationRequired || currentUrl.pathname + currentUrl.search === nextUrl.pathname + nextUrl.search || // Search params affect all loaders
            currentUrl.search !== nextUrl.search || $ed8eb2d58084204c$var$isNewRouteInstance(currentRouteMatch, nextRouteMatch)
        }));
    });
    // Pick fetcher.loads that need to be revalidated
    let revalidatingFetchers = [];
    fetchLoadMatches.forEach((f, key)=>{
        // Don't revalidate:
        //  - on initial hydration (shouldn't be any fetchers then anyway)
        //  - if fetcher won't be present in the subsequent render
        //    - no longer matches the URL (v7_fetcherPersist=false)
        //    - was unmounted but persisted due to v7_fetcherPersist=true
        if (initialHydration || !matches.some((m)=>m.route.id === f.routeId) || deletedFetchers.has(key)) return;
        let fetcherMatches = $ed8eb2d58084204c$export$2708184779ceb39d(routesToUse, f.path, basename);
        // If the fetcher path no longer matches, push it in with null matches so
        // we can trigger a 404 in callLoadersAndMaybeResolveData.  Note this is
        // currently only a use-case for Remix HMR where the route tree can change
        // at runtime and remove a route previously loaded via a fetcher
        if (!fetcherMatches) {
            revalidatingFetchers.push({
                key: key,
                routeId: f.routeId,
                path: f.path,
                matches: null,
                match: null,
                controller: null
            });
            return;
        }
        // Revalidating fetchers are decoupled from the route matches since they
        // load from a static href.  They revalidate based on explicit revalidation
        // (submission, useRevalidator, or X-Remix-Revalidate)
        let fetcher = state.fetchers.get(key);
        let fetcherMatch = $ed8eb2d58084204c$var$getTargetMatch(fetcherMatches, f.path);
        let shouldRevalidate = false;
        if (fetchRedirectIds.has(key)) // Never trigger a revalidation of an actively redirecting fetcher
        shouldRevalidate = false;
        else if (cancelledFetcherLoads.has(key)) {
            // Always mark for revalidation if the fetcher was cancelled
            cancelledFetcherLoads.delete(key);
            shouldRevalidate = true;
        } else if (fetcher && fetcher.state !== "idle" && fetcher.data === undefined) // If the fetcher hasn't ever completed loading yet, then this isn't a
        // revalidation, it would just be a brand new load if an explicit
        // revalidation is required
        shouldRevalidate = isRevalidationRequired;
        else // Otherwise fall back on any user-defined shouldRevalidate, defaulting
        // to explicit revalidations only
        shouldRevalidate = $ed8eb2d58084204c$var$shouldRevalidateLoader(fetcherMatch, $ed8eb2d58084204c$var$_extends({
            currentUrl: currentUrl,
            currentParams: state.matches[state.matches.length - 1].params,
            nextUrl: nextUrl,
            nextParams: matches[matches.length - 1].params
        }, submission, {
            actionResult: actionResult,
            actionStatus: actionStatus,
            defaultShouldRevalidate: shouldSkipRevalidation ? false : isRevalidationRequired
        }));
        if (shouldRevalidate) revalidatingFetchers.push({
            key: key,
            routeId: f.routeId,
            path: f.path,
            matches: fetcherMatches,
            match: fetcherMatch,
            controller: new AbortController()
        });
    });
    return [
        navigationMatches,
        revalidatingFetchers
    ];
}
function $ed8eb2d58084204c$var$shouldLoadRouteOnHydration(route, loaderData, errors) {
    // We dunno if we have a loader - gotta find out!
    if (route.lazy) return true;
    // No loader, nothing to initialize
    if (!route.loader) return false;
    let hasData = loaderData != null && loaderData[route.id] !== undefined;
    let hasError = errors != null && errors[route.id] !== undefined;
    // Don't run if we error'd during SSR
    if (!hasData && hasError) return false;
    // Explicitly opting-in to running on hydration
    if (typeof route.loader === "function" && route.loader.hydrate === true) return true;
    // Otherwise, run if we're not yet initialized with anything
    return !hasData && !hasError;
}
function $ed8eb2d58084204c$var$isNewLoader(currentLoaderData, currentMatch, match) {
    let isNew = // [a] -> [a, b]
    !currentMatch || // [a, b] -> [a, c]
    match.route.id !== currentMatch.route.id;
    // Handle the case that we don't have data for a re-used route, potentially
    // from a prior error or from a cancelled pending deferred
    let isMissingData = currentLoaderData[match.route.id] === undefined;
    // Always load if this is a net-new route or we don't yet have data
    return isNew || isMissingData;
}
function $ed8eb2d58084204c$var$isNewRouteInstance(currentMatch, match) {
    let currentPath = currentMatch.route.path;
    return(// param change for this match, /users/123 -> /users/456
    currentMatch.pathname !== match.pathname || // splat param changed, which is not present in match.path
    // e.g. /files/images/avatar.jpg -> files/finances.xls
    currentPath != null && currentPath.endsWith("*") && currentMatch.params["*"] !== match.params["*"]);
}
function $ed8eb2d58084204c$var$shouldRevalidateLoader(loaderMatch, arg) {
    if (loaderMatch.route.shouldRevalidate) {
        let routeChoice = loaderMatch.route.shouldRevalidate(arg);
        if (typeof routeChoice === "boolean") return routeChoice;
    }
    return arg.defaultShouldRevalidate;
}
function $ed8eb2d58084204c$var$patchRoutesImpl(routeId, children, routesToUse, manifest, mapRouteProperties) {
    var _childrenToPatch;
    let childrenToPatch;
    if (routeId) {
        let route = manifest[routeId];
        $ed8eb2d58084204c$export$3e9cee6b33872309(route, "No route found to patch children into: routeId = " + routeId);
        if (!route.children) route.children = [];
        childrenToPatch = route.children;
    } else childrenToPatch = routesToUse;
    // Don't patch in routes we already know about so that `patch` is idempotent
    // to simplify user-land code. This is useful because we re-call the
    // `patchRoutesOnNavigation` function for matched routes with params.
    let uniqueChildren = children.filter((newRoute)=>!childrenToPatch.some((existingRoute)=>$ed8eb2d58084204c$var$isSameRoute(newRoute, existingRoute)));
    let newRoutes = $ed8eb2d58084204c$export$4a6d22b32134ea5d(uniqueChildren, mapRouteProperties, [
        routeId || "_",
        "patch",
        String(((_childrenToPatch = childrenToPatch) == null ? void 0 : _childrenToPatch.length) || "0")
    ], manifest);
    childrenToPatch.push(...newRoutes);
}
function $ed8eb2d58084204c$var$isSameRoute(newRoute, existingRoute) {
    // Most optimal check is by id
    if ("id" in newRoute && "id" in existingRoute && newRoute.id === existingRoute.id) return true;
    // Second is by pathing differences
    if (!(newRoute.index === existingRoute.index && newRoute.path === existingRoute.path && newRoute.caseSensitive === existingRoute.caseSensitive)) return false;
    // Pathless layout routes are trickier since we need to check children.
    // If they have no children then they're the same as far as we can tell
    if ((!newRoute.children || newRoute.children.length === 0) && (!existingRoute.children || existingRoute.children.length === 0)) return true;
    // Otherwise, we look to see if every child in the new route is already
    // represented in the existing route's children
    return newRoute.children.every((aChild, i)=>{
        var _existingRoute$childr;
        return (_existingRoute$childr = existingRoute.children) == null ? void 0 : _existingRoute$childr.some((bChild)=>$ed8eb2d58084204c$var$isSameRoute(aChild, bChild));
    });
}
/**
 * Execute route.lazy() methods to lazily load route modules (loader, action,
 * shouldRevalidate) and update the routeManifest in place which shares objects
 * with dataRoutes so those get updated as well.
 */ async function $ed8eb2d58084204c$var$loadLazyRouteModule(route, mapRouteProperties, manifest) {
    if (!route.lazy) return;
    let lazyRoute = await route.lazy();
    // If the lazy route function was executed and removed by another parallel
    // call then we can return - first lazy() to finish wins because the return
    // value of lazy is expected to be static
    if (!route.lazy) return;
    let routeToUpdate = manifest[route.id];
    $ed8eb2d58084204c$export$3e9cee6b33872309(routeToUpdate, "No route found in manifest");
    // Update the route in place.  This should be safe because there's no way
    // we could yet be sitting on this route as we can't get there without
    // resolving lazy() first.
    //
    // This is different than the HMR "update" use-case where we may actively be
    // on the route being updated.  The main concern boils down to "does this
    // mutation affect any ongoing navigations or any current state.matches
    // values?".  If not, it should be safe to update in place.
    let routeUpdates = {};
    for(let lazyRouteProperty in lazyRoute){
        let staticRouteValue = routeToUpdate[lazyRouteProperty];
        let isPropertyStaticallyDefined = staticRouteValue !== undefined && // This property isn't static since it should always be updated based
        // on the route updates
        lazyRouteProperty !== "hasErrorBoundary";
        $ed8eb2d58084204c$export$c0e02632e14916fd(!isPropertyStaticallyDefined, "Route \"" + routeToUpdate.id + "\" has a static property \"" + lazyRouteProperty + "\" " + "defined but its lazy function is also returning a value for this property. " + ("The lazy route property \"" + lazyRouteProperty + "\" will be ignored."));
        if (!isPropertyStaticallyDefined && !$ed8eb2d58084204c$var$immutableRouteKeys.has(lazyRouteProperty)) routeUpdates[lazyRouteProperty] = lazyRoute[lazyRouteProperty];
    }
    // Mutate the route with the provided updates.  Do this first so we pass
    // the updated version to mapRouteProperties
    Object.assign(routeToUpdate, routeUpdates);
    // Mutate the `hasErrorBoundary` property on the route based on the route
    // updates and remove the `lazy` function so we don't resolve the lazy
    // route again.
    Object.assign(routeToUpdate, $ed8eb2d58084204c$var$_extends({}, mapRouteProperties(routeToUpdate), {
        lazy: undefined
    }));
}
// Default implementation of `dataStrategy` which fetches all loaders in parallel
async function $ed8eb2d58084204c$var$defaultDataStrategy(_ref4) {
    let { matches: matches } = _ref4;
    let matchesToLoad = matches.filter((m)=>m.shouldLoad);
    let results = await Promise.all(matchesToLoad.map((m)=>m.resolve()));
    return results.reduce((acc, result, i)=>Object.assign(acc, {
            [matchesToLoad[i].route.id]: result
        }), {});
}
async function $ed8eb2d58084204c$var$callDataStrategyImpl(dataStrategyImpl, type, state, request, matchesToLoad, matches, fetcherKey, manifest, mapRouteProperties, requestContext) {
    let loadRouteDefinitionsPromises = matches.map((m)=>m.route.lazy ? $ed8eb2d58084204c$var$loadLazyRouteModule(m.route, mapRouteProperties, manifest) : undefined);
    let dsMatches = matches.map((match, i)=>{
        let loadRoutePromise = loadRouteDefinitionsPromises[i];
        let shouldLoad = matchesToLoad.some((m)=>m.route.id === match.route.id);
        // `resolve` encapsulates route.lazy(), executing the loader/action,
        // and mapping return values/thrown errors to a `DataStrategyResult`.  Users
        // can pass a callback to take fine-grained control over the execution
        // of the loader/action
        let resolve = async (handlerOverride)=>{
            if (handlerOverride && request.method === "GET" && (match.route.lazy || match.route.loader)) shouldLoad = true;
            return shouldLoad ? $ed8eb2d58084204c$var$callLoaderOrAction(type, request, match, loadRoutePromise, handlerOverride, requestContext) : Promise.resolve({
                type: $ed8eb2d58084204c$var$ResultType.data,
                result: undefined
            });
        };
        return $ed8eb2d58084204c$var$_extends({}, match, {
            shouldLoad: shouldLoad,
            resolve: resolve
        });
    });
    // Send all matches here to allow for a middleware-type implementation.
    // handler will be a no-op for unneeded routes and we filter those results
    // back out below.
    let results = await dataStrategyImpl({
        matches: dsMatches,
        request: request,
        params: matches[0].params,
        fetcherKey: fetcherKey,
        context: requestContext
    });
    // Wait for all routes to load here but 'swallow the error since we want
    // it to bubble up from the `await loadRoutePromise` in `callLoaderOrAction` -
    // called from `match.resolve()`
    try {
        await Promise.all(loadRouteDefinitionsPromises);
    } catch (e) {
    // No-op
    }
    return results;
}
// Default logic for calling a loader/action is the user has no specified a dataStrategy
async function $ed8eb2d58084204c$var$callLoaderOrAction(type, request, match, loadRoutePromise, handlerOverride, staticContext) {
    let result;
    let onReject;
    let runHandler = (handler)=>{
        // Setup a promise we can race against so that abort signals short circuit
        let reject;
        // This will never resolve so safe to type it as Promise<DataStrategyResult> to
        // satisfy the function return value
        let abortPromise = new Promise((_, r)=>reject = r);
        onReject = ()=>reject();
        request.signal.addEventListener("abort", onReject);
        let actualHandler = (ctx)=>{
            if (typeof handler !== "function") return Promise.reject(new Error("You cannot call the handler for a route which defines a boolean " + ("\"" + type + "\" [routeId: " + match.route.id + "]")));
            return handler({
                request: request,
                params: match.params,
                context: staticContext
            }, ...ctx !== undefined ? [
                ctx
            ] : []);
        };
        let handlerPromise = (async ()=>{
            try {
                let val = await (handlerOverride ? handlerOverride((ctx)=>actualHandler(ctx)) : actualHandler());
                return {
                    type: "data",
                    result: val
                };
            } catch (e) {
                return {
                    type: "error",
                    result: e
                };
            }
        })();
        return Promise.race([
            handlerPromise,
            abortPromise
        ]);
    };
    try {
        let handler = match.route[type];
        // If we have a route.lazy promise, await that first
        if (loadRoutePromise) {
            if (handler) {
                // Run statically defined handler in parallel with lazy()
                let handlerError;
                let [value] = await Promise.all([
                    // If the handler throws, don't let it immediately bubble out,
                    // since we need to let the lazy() execution finish so we know if this
                    // route has a boundary that can handle the error
                    runHandler(handler).catch((e)=>{
                        handlerError = e;
                    }),
                    loadRoutePromise
                ]);
                if (handlerError !== undefined) throw handlerError;
                result = value;
            } else {
                // Load lazy route module, then run any returned handler
                await loadRoutePromise;
                handler = match.route[type];
                if (handler) // Handler still runs even if we got interrupted to maintain consistency
                // with un-abortable behavior of handler execution on non-lazy or
                // previously-lazy-loaded routes
                result = await runHandler(handler);
                else if (type === "action") {
                    let url = new URL(request.url);
                    let pathname = url.pathname + url.search;
                    throw $ed8eb2d58084204c$var$getInternalRouterError(405, {
                        method: request.method,
                        pathname: pathname,
                        routeId: match.route.id
                    });
                } else // lazy() route has no loader to run.  Short circuit here so we don't
                // hit the invariant below that errors on returning undefined.
                return {
                    type: $ed8eb2d58084204c$var$ResultType.data,
                    result: undefined
                };
            }
        } else if (!handler) {
            let url = new URL(request.url);
            let pathname = url.pathname + url.search;
            throw $ed8eb2d58084204c$var$getInternalRouterError(404, {
                pathname: pathname
            });
        } else result = await runHandler(handler);
        $ed8eb2d58084204c$export$3e9cee6b33872309(result.result !== undefined, "You defined " + (type === "action" ? "an action" : "a loader") + " for route " + ("\"" + match.route.id + "\" but didn't return anything from your `" + type + "` ") + "function. Please return a value or `null`.");
    } catch (e) {
        // We should already be catching and converting normal handler executions to
        // DataStrategyResults and returning them, so anything that throws here is an
        // unexpected error we still need to wrap
        return {
            type: $ed8eb2d58084204c$var$ResultType.error,
            result: e
        };
    } finally{
        if (onReject) request.signal.removeEventListener("abort", onReject);
    }
    return result;
}
async function $ed8eb2d58084204c$var$convertDataStrategyResultToDataResult(dataStrategyResult) {
    let { result: result, type: type } = dataStrategyResult;
    if ($ed8eb2d58084204c$var$isResponse(result)) {
        let data;
        try {
            let contentType = result.headers.get("Content-Type");
            // Check between word boundaries instead of startsWith() due to the last
            // paragraph of https://httpwg.org/specs/rfc9110.html#field.content-type
            if (contentType && /\bapplication\/json\b/.test(contentType)) {
                if (result.body == null) data = null;
                else data = await result.json();
            } else data = await result.text();
        } catch (e) {
            return {
                type: $ed8eb2d58084204c$var$ResultType.error,
                error: e
            };
        }
        if (type === $ed8eb2d58084204c$var$ResultType.error) return {
            type: $ed8eb2d58084204c$var$ResultType.error,
            error: new $ed8eb2d58084204c$export$6c6580e81da25755(result.status, result.statusText, data),
            statusCode: result.status,
            headers: result.headers
        };
        return {
            type: $ed8eb2d58084204c$var$ResultType.data,
            data: data,
            statusCode: result.status,
            headers: result.headers
        };
    }
    if (type === $ed8eb2d58084204c$var$ResultType.error) {
        if ($ed8eb2d58084204c$export$e0163cfdf7bc9cfa(result)) {
            var _result$init3, _result$init4;
            if (result.data instanceof Error) {
                var _result$init, _result$init2;
                return {
                    type: $ed8eb2d58084204c$var$ResultType.error,
                    error: result.data,
                    statusCode: (_result$init = result.init) == null ? void 0 : _result$init.status,
                    headers: (_result$init2 = result.init) != null && _result$init2.headers ? new Headers(result.init.headers) : undefined
                };
            }
            // Convert thrown data() to ErrorResponse instances
            return {
                type: $ed8eb2d58084204c$var$ResultType.error,
                error: new $ed8eb2d58084204c$export$6c6580e81da25755(((_result$init3 = result.init) == null ? void 0 : _result$init3.status) || 500, undefined, result.data),
                statusCode: $ed8eb2d58084204c$export$972111febbeef05b(result) ? result.status : undefined,
                headers: (_result$init4 = result.init) != null && _result$init4.headers ? new Headers(result.init.headers) : undefined
            };
        }
        return {
            type: $ed8eb2d58084204c$var$ResultType.error,
            error: result,
            statusCode: $ed8eb2d58084204c$export$972111febbeef05b(result) ? result.status : undefined
        };
    }
    if ($ed8eb2d58084204c$export$fbcedacb60443473(result)) {
        var _result$init5, _result$init6;
        return {
            type: $ed8eb2d58084204c$var$ResultType.deferred,
            deferredData: result,
            statusCode: (_result$init5 = result.init) == null ? void 0 : _result$init5.status,
            headers: ((_result$init6 = result.init) == null ? void 0 : _result$init6.headers) && new Headers(result.init.headers)
        };
    }
    if ($ed8eb2d58084204c$export$e0163cfdf7bc9cfa(result)) {
        var _result$init7, _result$init8;
        return {
            type: $ed8eb2d58084204c$var$ResultType.data,
            data: result.data,
            statusCode: (_result$init7 = result.init) == null ? void 0 : _result$init7.status,
            headers: (_result$init8 = result.init) != null && _result$init8.headers ? new Headers(result.init.headers) : undefined
        };
    }
    return {
        type: $ed8eb2d58084204c$var$ResultType.data,
        data: result
    };
}
// Support relative routing in internal redirects
function $ed8eb2d58084204c$var$normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename, v7_relativeSplatPath) {
    let location = response.headers.get("Location");
    $ed8eb2d58084204c$export$3e9cee6b33872309(location, "Redirects returned/thrown from loaders/actions must have a Location header");
    if (!$ed8eb2d58084204c$var$ABSOLUTE_URL_REGEX.test(location)) {
        let trimmedMatches = matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1);
        location = $ed8eb2d58084204c$var$normalizeTo(new URL(request.url), trimmedMatches, basename, true, location, v7_relativeSplatPath);
        response.headers.set("Location", location);
    }
    return response;
}
function $ed8eb2d58084204c$var$normalizeRedirectLocation(location, currentUrl, basename) {
    if ($ed8eb2d58084204c$var$ABSOLUTE_URL_REGEX.test(location)) {
        // Strip off the protocol+origin for same-origin + same-basename absolute redirects
        let normalizedLocation = location;
        let url = normalizedLocation.startsWith("//") ? new URL(currentUrl.protocol + normalizedLocation) : new URL(normalizedLocation);
        let isSameBasename = $ed8eb2d58084204c$export$b69e3301ce081aa3(url.pathname, basename) != null;
        if (url.origin === currentUrl.origin && isSameBasename) return url.pathname + url.search + url.hash;
    }
    return location;
}
// Utility method for creating the Request instances for loaders/actions during
// client-side navigations and fetches.  During SSR we will always have a
// Request instance from the static handler (query/queryRoute)
function $ed8eb2d58084204c$var$createClientSideRequest(history, location, signal, submission) {
    let url = history.createURL($ed8eb2d58084204c$var$stripHashFromPath(location)).toString();
    let init = {
        signal: signal
    };
    if (submission && $ed8eb2d58084204c$var$isMutationMethod(submission.formMethod)) {
        let { formMethod: formMethod, formEncType: formEncType } = submission;
        // Didn't think we needed this but it turns out unlike other methods, patch
        // won't be properly normalized to uppercase and results in a 405 error.
        // See: https://fetch.spec.whatwg.org/#concept-method
        init.method = formMethod.toUpperCase();
        if (formEncType === "application/json") {
            init.headers = new Headers({
                "Content-Type": formEncType
            });
            init.body = JSON.stringify(submission.json);
        } else if (formEncType === "text/plain") // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.text;
        else if (formEncType === "application/x-www-form-urlencoded" && submission.formData) // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = $ed8eb2d58084204c$var$convertFormDataToSearchParams(submission.formData);
        else // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.formData;
    }
    return new Request(url, init);
}
function $ed8eb2d58084204c$var$convertFormDataToSearchParams(formData) {
    let searchParams = new URLSearchParams();
    for (let [key, value] of formData.entries())// https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#converting-an-entry-list-to-a-list-of-name-value-pairs
    searchParams.append(key, typeof value === "string" ? value : value.name);
    return searchParams;
}
function $ed8eb2d58084204c$var$convertSearchParamsToFormData(searchParams) {
    let formData = new FormData();
    for (let [key, value] of searchParams.entries())formData.append(key, value);
    return formData;
}
function $ed8eb2d58084204c$var$processRouteLoaderData(matches, results, pendingActionResult, activeDeferreds, skipLoaderErrorBubbling) {
    // Fill in loaderData/errors from our loaders
    let loaderData = {};
    let errors = null;
    let statusCode;
    let foundError = false;
    let loaderHeaders = {};
    let pendingError = pendingActionResult && $ed8eb2d58084204c$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : undefined;
    // Process loader results into state.loaderData/state.errors
    matches.forEach((match)=>{
        if (!(match.route.id in results)) return;
        let id = match.route.id;
        let result = results[id];
        $ed8eb2d58084204c$export$3e9cee6b33872309(!$ed8eb2d58084204c$var$isRedirectResult(result), "Cannot handle redirect results in processLoaderData");
        if ($ed8eb2d58084204c$var$isErrorResult(result)) {
            let error = result.error;
            // If we have a pending action error, we report it at the highest-route
            // that throws a loader error, and then clear it out to indicate that
            // it was consumed
            if (pendingError !== undefined) {
                error = pendingError;
                pendingError = undefined;
            }
            errors = errors || {};
            if (skipLoaderErrorBubbling) errors[id] = error;
            else {
                // Look upwards from the matched route for the closest ancestor error
                // boundary, defaulting to the root match.  Prefer higher error values
                // if lower errors bubble to the same boundary
                let boundaryMatch = $ed8eb2d58084204c$var$findNearestBoundary(matches, id);
                if (errors[boundaryMatch.route.id] == null) errors[boundaryMatch.route.id] = error;
            }
            // Clear our any prior loaderData for the throwing route
            loaderData[id] = undefined;
            // Once we find our first (highest) error, we set the status code and
            // prevent deeper status codes from overriding
            if (!foundError) {
                foundError = true;
                statusCode = $ed8eb2d58084204c$export$972111febbeef05b(result.error) ? result.error.status : 500;
            }
            if (result.headers) loaderHeaders[id] = result.headers;
        } else if ($ed8eb2d58084204c$var$isDeferredResult(result)) {
            activeDeferreds.set(id, result.deferredData);
            loaderData[id] = result.deferredData.data;
            // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode != null && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        } else {
            loaderData[id] = result.data;
            // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        }
    });
    // If we didn't consume the pending action error (i.e., all loaders
    // resolved), then consume it here.  Also clear out any loaderData for the
    // throwing route
    if (pendingError !== undefined && pendingActionResult) {
        errors = {
            [pendingActionResult[0]]: pendingError
        };
        loaderData[pendingActionResult[0]] = undefined;
    }
    return {
        loaderData: loaderData,
        errors: errors,
        statusCode: statusCode || 200,
        loaderHeaders: loaderHeaders
    };
}
function $ed8eb2d58084204c$var$processLoaderData(state, matches, results, pendingActionResult, revalidatingFetchers, fetcherResults, activeDeferreds) {
    let { loaderData: loaderData, errors: errors } = $ed8eb2d58084204c$var$processRouteLoaderData(matches, results, pendingActionResult, activeDeferreds, false // This method is only called client side so we always want to bubble
    );
    // Process results from our revalidating fetchers
    revalidatingFetchers.forEach((rf)=>{
        let { key: key, match: match, controller: controller } = rf;
        let result = fetcherResults[key];
        $ed8eb2d58084204c$export$3e9cee6b33872309(result, "Did not find corresponding fetcher result");
        // Process fetcher non-redirect errors
        if (controller && controller.signal.aborted) // Nothing to do for aborted fetchers
        return;
        else if ($ed8eb2d58084204c$var$isErrorResult(result)) {
            let boundaryMatch = $ed8eb2d58084204c$var$findNearestBoundary(state.matches, match == null ? void 0 : match.route.id);
            if (!(errors && errors[boundaryMatch.route.id])) errors = $ed8eb2d58084204c$var$_extends({}, errors, {
                [boundaryMatch.route.id]: result.error
            });
            state.fetchers.delete(key);
        } else if ($ed8eb2d58084204c$var$isRedirectResult(result)) // Should never get here, redirects should get processed above, but we
        // keep this to type narrow to a success result in the else
        $ed8eb2d58084204c$export$3e9cee6b33872309(false, "Unhandled fetcher revalidation redirect");
        else if ($ed8eb2d58084204c$var$isDeferredResult(result)) // Should never get here, deferred data should be awaited for fetchers
        // in resolveDeferredResults
        $ed8eb2d58084204c$export$3e9cee6b33872309(false, "Unhandled fetcher deferred data");
        else {
            let doneFetcher = $ed8eb2d58084204c$var$getDoneFetcher(result.data);
            state.fetchers.set(key, doneFetcher);
        }
    });
    return {
        loaderData: loaderData,
        errors: errors
    };
}
function $ed8eb2d58084204c$var$mergeLoaderData(loaderData, newLoaderData, matches, errors) {
    let mergedLoaderData = $ed8eb2d58084204c$var$_extends({}, newLoaderData);
    for (let match of matches){
        let id = match.route.id;
        if (newLoaderData.hasOwnProperty(id)) {
            if (newLoaderData[id] !== undefined) mergedLoaderData[id] = newLoaderData[id];
        } else if (loaderData[id] !== undefined && match.route.loader) // Preserve existing keys not included in newLoaderData and where a loader
        // wasn't removed by HMR
        mergedLoaderData[id] = loaderData[id];
        if (errors && errors.hasOwnProperty(id)) break;
    }
    return mergedLoaderData;
}
function $ed8eb2d58084204c$var$getActionDataForCommit(pendingActionResult) {
    if (!pendingActionResult) return {};
    return $ed8eb2d58084204c$var$isErrorResult(pendingActionResult[1]) ? {
        // Clear out prior actionData on errors
        actionData: {}
    } : {
        actionData: {
            [pendingActionResult[0]]: pendingActionResult[1].data
        }
    };
}
// Find the nearest error boundary, looking upwards from the leaf route (or the
// route specified by routeId) for the closest ancestor error boundary,
// defaulting to the root match
function $ed8eb2d58084204c$var$findNearestBoundary(matches, routeId) {
    let eligibleMatches = routeId ? matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1) : [
        ...matches
    ];
    return eligibleMatches.reverse().find((m)=>m.route.hasErrorBoundary === true) || matches[0];
}
function $ed8eb2d58084204c$var$getShortCircuitMatches(routes) {
    // Prefer a root layout route if present, otherwise shim in a route object
    let route = routes.length === 1 ? routes[0] : routes.find((r)=>r.index || !r.path || r.path === "/") || {
        id: "__shim-error-route__"
    };
    return {
        matches: [
            {
                params: {},
                pathname: "",
                pathnameBase: "",
                route: route
            }
        ],
        route: route
    };
}
function $ed8eb2d58084204c$var$getInternalRouterError(status, _temp5) {
    let { pathname: pathname, routeId: routeId, method: method, type: type, message: message } = _temp5 === void 0 ? {} : _temp5;
    let statusText = "Unknown Server Error";
    let errorMessage = "Unknown @remix-run/router error";
    if (status === 400) {
        statusText = "Bad Request";
        if (method && pathname && routeId) errorMessage = "You made a " + method + " request to \"" + pathname + "\" but " + ("did not provide a `loader` for route \"" + routeId + "\", ") + "so there is no way to handle the request.";
        else if (type === "defer-action") errorMessage = "defer() is not supported in actions";
        else if (type === "invalid-body") errorMessage = "Unable to encode submission body";
    } else if (status === 403) {
        statusText = "Forbidden";
        errorMessage = "Route \"" + routeId + "\" does not match URL \"" + pathname + "\"";
    } else if (status === 404) {
        statusText = "Not Found";
        errorMessage = "No route matches URL \"" + pathname + "\"";
    } else if (status === 405) {
        statusText = "Method Not Allowed";
        if (method && pathname && routeId) errorMessage = "You made a " + method.toUpperCase() + " request to \"" + pathname + "\" but " + ("did not provide an `action` for route \"" + routeId + "\", ") + "so there is no way to handle the request.";
        else if (method) errorMessage = "Invalid request method \"" + method.toUpperCase() + "\"";
    }
    return new $ed8eb2d58084204c$export$6c6580e81da25755(status || 500, statusText, new Error(errorMessage), true);
}
// Find any returned redirect errors, starting from the lowest match
function $ed8eb2d58084204c$var$findRedirect(results) {
    let entries = Object.entries(results);
    for(let i = entries.length - 1; i >= 0; i--){
        let [key, result] = entries[i];
        if ($ed8eb2d58084204c$var$isRedirectResult(result)) return {
            key: key,
            result: result
        };
    }
}
function $ed8eb2d58084204c$var$stripHashFromPath(path) {
    let parsedPath = typeof path === "string" ? $ed8eb2d58084204c$export$8ccf933b0513f8d0(path) : path;
    return $ed8eb2d58084204c$export$fe53371bee54353d($ed8eb2d58084204c$var$_extends({}, parsedPath, {
        hash: ""
    }));
}
function $ed8eb2d58084204c$var$isHashChangeOnly(a, b) {
    if (a.pathname !== b.pathname || a.search !== b.search) return false;
    if (a.hash === "") // /page -> /page#hash
    return b.hash !== "";
    else if (a.hash === b.hash) // /page#hash -> /page#hash
    return true;
    else if (b.hash !== "") // /page#hash -> /page#other
    return true;
    // If the hash is removed the browser will re-perform a request to the server
    // /page#hash -> /page
    return false;
}
function $ed8eb2d58084204c$var$isDataStrategyResult(result) {
    return result != null && typeof result === "object" && "type" in result && "result" in result && (result.type === $ed8eb2d58084204c$var$ResultType.data || result.type === $ed8eb2d58084204c$var$ResultType.error);
}
function $ed8eb2d58084204c$var$isRedirectDataStrategyResultResult(result) {
    return $ed8eb2d58084204c$var$isResponse(result.result) && $ed8eb2d58084204c$var$redirectStatusCodes.has(result.result.status);
}
function $ed8eb2d58084204c$var$isDeferredResult(result) {
    return result.type === $ed8eb2d58084204c$var$ResultType.deferred;
}
function $ed8eb2d58084204c$var$isErrorResult(result) {
    return result.type === $ed8eb2d58084204c$var$ResultType.error;
}
function $ed8eb2d58084204c$var$isRedirectResult(result) {
    return (result && result.type) === $ed8eb2d58084204c$var$ResultType.redirect;
}
function $ed8eb2d58084204c$export$e0163cfdf7bc9cfa(value) {
    return typeof value === "object" && value != null && "type" in value && "data" in value && "init" in value && value.type === "DataWithResponseInit";
}
function $ed8eb2d58084204c$export$fbcedacb60443473(value) {
    let deferred = value;
    return deferred && typeof deferred === "object" && typeof deferred.data === "object" && typeof deferred.subscribe === "function" && typeof deferred.cancel === "function" && typeof deferred.resolveData === "function";
}
function $ed8eb2d58084204c$var$isResponse(value) {
    return value != null && typeof value.status === "number" && typeof value.statusText === "string" && typeof value.headers === "object" && typeof value.body !== "undefined";
}
function $ed8eb2d58084204c$var$isRedirectResponse(result) {
    if (!$ed8eb2d58084204c$var$isResponse(result)) return false;
    let status = result.status;
    let location = result.headers.get("Location");
    return status >= 300 && status <= 399 && location != null;
}
function $ed8eb2d58084204c$var$isValidMethod(method) {
    return $ed8eb2d58084204c$var$validRequestMethods.has(method.toLowerCase());
}
function $ed8eb2d58084204c$var$isMutationMethod(method) {
    return $ed8eb2d58084204c$var$validMutationMethods.has(method.toLowerCase());
}
async function $ed8eb2d58084204c$var$resolveNavigationDeferredResults(matches, results, signal, currentMatches, currentLoaderData) {
    let entries = Object.entries(results);
    for(let index = 0; index < entries.length; index++){
        let [routeId, result] = entries[index];
        let match = matches.find((m)=>(m == null ? void 0 : m.route.id) === routeId);
        // If we don't have a match, then we can have a deferred result to do
        // anything with.  This is for revalidating fetchers where the route was
        // removed during HMR
        if (!match) continue;
        let currentMatch = currentMatches.find((m)=>m.route.id === match.route.id);
        let isRevalidatingLoader = currentMatch != null && !$ed8eb2d58084204c$var$isNewRouteInstance(currentMatch, match) && (currentLoaderData && currentLoaderData[match.route.id]) !== undefined;
        if ($ed8eb2d58084204c$var$isDeferredResult(result) && isRevalidatingLoader) // Note: we do not have to touch activeDeferreds here since we race them
        // against the signal in resolveDeferredData and they'll get aborted
        // there if needed
        await $ed8eb2d58084204c$var$resolveDeferredData(result, signal, false).then((result)=>{
            if (result) results[routeId] = result;
        });
    }
}
async function $ed8eb2d58084204c$var$resolveFetcherDeferredResults(matches, results, revalidatingFetchers) {
    for(let index = 0; index < revalidatingFetchers.length; index++){
        let { key: key, routeId: routeId, controller: controller } = revalidatingFetchers[index];
        let result = results[key];
        let match = matches.find((m)=>(m == null ? void 0 : m.route.id) === routeId);
        // If we don't have a match, then we can have a deferred result to do
        // anything with.  This is for revalidating fetchers where the route was
        // removed during HMR
        if (!match) continue;
        if ($ed8eb2d58084204c$var$isDeferredResult(result)) {
            // Note: we do not have to touch activeDeferreds here since we race them
            // against the signal in resolveDeferredData and they'll get aborted
            // there if needed
            $ed8eb2d58084204c$export$3e9cee6b33872309(controller, "Expected an AbortController for revalidating fetcher deferred result");
            await $ed8eb2d58084204c$var$resolveDeferredData(result, controller.signal, true).then((result)=>{
                if (result) results[key] = result;
            });
        }
    }
}
async function $ed8eb2d58084204c$var$resolveDeferredData(result, signal, unwrap) {
    if (unwrap === void 0) unwrap = false;
    let aborted = await result.deferredData.resolveData(signal);
    if (aborted) return;
    if (unwrap) try {
        return {
            type: $ed8eb2d58084204c$var$ResultType.data,
            data: result.deferredData.unwrappedData
        };
    } catch (e) {
        // Handle any TrackedPromise._error values encountered while unwrapping
        return {
            type: $ed8eb2d58084204c$var$ResultType.error,
            error: e
        };
    }
    return {
        type: $ed8eb2d58084204c$var$ResultType.data,
        data: result.deferredData.data
    };
}
function $ed8eb2d58084204c$var$hasNakedIndexQuery(search) {
    return new URLSearchParams(search).getAll("index").some((v)=>v === "");
}
function $ed8eb2d58084204c$var$getTargetMatch(matches, location) {
    let search = typeof location === "string" ? $ed8eb2d58084204c$export$8ccf933b0513f8d0(location).search : location.search;
    if (matches[matches.length - 1].route.index && $ed8eb2d58084204c$var$hasNakedIndexQuery(search || "")) // Return the leaf index route when index is present
    return matches[matches.length - 1];
    // Otherwise grab the deepest "path contributing" match (ignoring index and
    // pathless layout routes)
    let pathMatches = $ed8eb2d58084204c$var$getPathContributingMatches(matches);
    return pathMatches[pathMatches.length - 1];
}
function $ed8eb2d58084204c$var$getSubmissionFromNavigation(navigation) {
    let { formMethod: formMethod, formAction: formAction, formEncType: formEncType, text: text, formData: formData, json: json } = navigation;
    if (!formMethod || !formAction || !formEncType) return;
    if (text != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: undefined,
        text: text
    };
    else if (formData != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: formData,
        json: undefined,
        text: undefined
    };
    else if (json !== undefined) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: json,
        text: undefined
    };
}
function $ed8eb2d58084204c$var$getLoadingNavigation(location, submission) {
    if (submission) {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text
        };
        return navigation;
    } else {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined
        };
        return navigation;
    }
}
function $ed8eb2d58084204c$var$getSubmittingNavigation(location, submission) {
    let navigation = {
        state: "submitting",
        location: location,
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text
    };
    return navigation;
}
function $ed8eb2d58084204c$var$getLoadingFetcher(submission, data) {
    if (submission) {
        let fetcher = {
            state: "loading",
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text,
            data: data
        };
        return fetcher;
    } else {
        let fetcher = {
            state: "loading",
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined,
            data: data
        };
        return fetcher;
    }
}
function $ed8eb2d58084204c$var$getSubmittingFetcher(submission, existingFetcher) {
    let fetcher = {
        state: "submitting",
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text,
        data: existingFetcher ? existingFetcher.data : undefined
    };
    return fetcher;
}
function $ed8eb2d58084204c$var$getDoneFetcher(data) {
    let fetcher = {
        state: "idle",
        formMethod: undefined,
        formAction: undefined,
        formEncType: undefined,
        formData: undefined,
        json: undefined,
        text: undefined,
        data: data
    };
    return fetcher;
}
function $ed8eb2d58084204c$var$restoreAppliedTransitions(_window, transitions) {
    try {
        let sessionPositions = _window.sessionStorage.getItem($ed8eb2d58084204c$var$TRANSITIONS_STORAGE_KEY);
        if (sessionPositions) {
            let json = JSON.parse(sessionPositions);
            for (let [k, v] of Object.entries(json || {}))if (v && Array.isArray(v)) transitions.set(k, new Set(v || []));
        }
    } catch (e) {
    // no-op, use default empty object
    }
}
function $ed8eb2d58084204c$var$persistAppliedTransitions(_window, transitions) {
    if (transitions.size > 0) {
        let json = {};
        for (let [k, v] of transitions)json[k] = [
            ...v
        ];
        try {
            _window.sessionStorage.setItem($ed8eb2d58084204c$var$TRANSITIONS_STORAGE_KEY, JSON.stringify(json));
        } catch (error) {
            $ed8eb2d58084204c$export$c0e02632e14916fd(false, "Failed to save applied view transitions in sessionStorage (" + error + ").");
        }
    }
}

/**
 * React Router v6.30.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $gJYWc = parcelRequire("gJYWc");

function $a35327dc535bf969$var$_extends() {
    $a35327dc535bf969$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $a35327dc535bf969$var$_extends.apply(this, arguments);
}
// Create react-specific types from the agnostic types in @remix-run/router to
// export from react-router
const $a35327dc535bf969$export$3add0d5dce533e2e = /*#__PURE__*/ $gJYWc.createContext(null);
const $a35327dc535bf969$export$145dfa71566a64dc = /*#__PURE__*/ $gJYWc.createContext(null);
const $a35327dc535bf969$var$AwaitContext = /*#__PURE__*/ $gJYWc.createContext(null);
/**
 * A Navigator is a "location changer"; it's how you get to different locations.
 *
 * Every history instance conforms to the Navigator interface, but the
 * distinction is useful primarily when it comes to the low-level `<Router>` API
 * where both the location and a navigator must be provided separately in order
 * to avoid "tearing" that may occur in a suspense-enabled app if the action
 * and/or location were to be read directly from the history instance.
 */ const $a35327dc535bf969$export$26749e8557646306 = /*#__PURE__*/ $gJYWc.createContext(null);
const $a35327dc535bf969$export$c7914228fb69b0f5 = /*#__PURE__*/ $gJYWc.createContext(null);
const $a35327dc535bf969$export$9072aa6dd1f93057 = /*#__PURE__*/ $gJYWc.createContext({
    outlet: null,
    matches: [],
    isDataRoute: false
});
const $a35327dc535bf969$var$RouteErrorContext = /*#__PURE__*/ $gJYWc.createContext(null);
/**
 * Returns the full href for the given "to" value. This is useful for building
 * custom links that are also accessible and preserve right-click behavior.
 *
 * @see https://reactrouter.com/v6/hooks/use-href
 */ function $a35327dc535bf969$export$b66bb29c5006f12f(to, _temp) {
    let { relative: relative } = _temp === void 0 ? {} : _temp;
    !$a35327dc535bf969$export$9c954a9d03d32f4a() && (0, $ed8eb2d58084204c$export$3e9cee6b33872309)(false);
    let { basename: basename, navigator: navigator } = $gJYWc.useContext($a35327dc535bf969$export$26749e8557646306);
    let { hash: hash, pathname: pathname, search: search } = $a35327dc535bf969$export$e75d2a2d1b3c245b(to, {
        relative: relative
    });
    let joinedPathname = pathname;
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the href.  If this is a root navigation, then just use the raw
    // basename which allows the basename to have full control over the presence
    // of a trailing slash on root links
    if (basename !== "/") joinedPathname = pathname === "/" ? basename : (0, $ed8eb2d58084204c$export$86d9a7913e44197e)([
        basename,
        pathname
    ]);
    return navigator.createHref({
        pathname: joinedPathname,
        search: search,
        hash: hash
    });
}
/**
 * Returns true if this component is a descendant of a `<Router>`.
 *
 * @see https://reactrouter.com/v6/hooks/use-in-router-context
 */ function $a35327dc535bf969$export$9c954a9d03d32f4a() {
    return $gJYWc.useContext($a35327dc535bf969$export$c7914228fb69b0f5) != null;
}
/**
 * Returns the current location object, which represents the current URL in web
 * browsers.
 *
 * Note: If you're using this it may mean you're doing some of your own
 * "routing" in your app, and we'd like to know what your use case is. We may
 * be able to provide something higher-level to better suit your needs.
 *
 * @see https://reactrouter.com/v6/hooks/use-location
 */ function $a35327dc535bf969$export$45d76561a5302f2b() {
    !$a35327dc535bf969$export$9c954a9d03d32f4a() && (0, $ed8eb2d58084204c$export$3e9cee6b33872309)(false);
    return $gJYWc.useContext($a35327dc535bf969$export$c7914228fb69b0f5).location;
}
/**
 * Returns the current navigation action which describes how the router came to
 * the current location, either by a pop, push, or replace on the history stack.
 *
 * @see https://reactrouter.com/v6/hooks/use-navigation-type
 */ function $a35327dc535bf969$export$1b3f31771c5d07c() {
    return $gJYWc.useContext($a35327dc535bf969$export$c7914228fb69b0f5).navigationType;
}
/**
 * Returns a PathMatch object if the given pattern matches the current URL.
 * This is useful for components that need to know "active" state, e.g.
 * `<NavLink>`.
 *
 * @see https://reactrouter.com/v6/hooks/use-match
 */ function $a35327dc535bf969$export$6c330e8992e8a295(pattern) {
    !$a35327dc535bf969$export$9c954a9d03d32f4a() && (0, $ed8eb2d58084204c$export$3e9cee6b33872309)(false);
    let { pathname: pathname } = $a35327dc535bf969$export$45d76561a5302f2b();
    return $gJYWc.useMemo(()=>(0, $ed8eb2d58084204c$export$81336c211d5ff295)(pattern, (0, $ed8eb2d58084204c$export$30d21fd6d7295f52)(pathname)), [
        pathname,
        pattern
    ]);
}
/**
 * The interface for the navigate() function returned from useNavigate().
 */ const $a35327dc535bf969$var$navigateEffectWarning = "You should call navigate() in a React.useEffect(), not when your component is first rendered.";
// Mute warnings for calls to useNavigate in SSR environments
function $a35327dc535bf969$var$useIsomorphicLayoutEffect(cb) {
    let isStatic = $gJYWc.useContext($a35327dc535bf969$export$26749e8557646306).static;
    if (!isStatic) // We should be able to get rid of this once react 18.3 is released
    // See: https://github.com/facebook/react/pull/26395
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $gJYWc.useLayoutEffect(cb);
}
/**
 * Returns an imperative method for changing the location. Used by `<Link>`s, but
 * may also be used by other elements to change the location.
 *
 * @see https://reactrouter.com/v6/hooks/use-navigate
 */ function $a35327dc535bf969$export$9770f232ac06a008() {
    let { isDataRoute: isDataRoute } = $gJYWc.useContext($a35327dc535bf969$export$9072aa6dd1f93057);
    // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return isDataRoute ? $a35327dc535bf969$var$useNavigateStable() : $a35327dc535bf969$var$useNavigateUnstable();
}
function $a35327dc535bf969$var$useNavigateUnstable() {
    !$a35327dc535bf969$export$9c954a9d03d32f4a() && (0, $ed8eb2d58084204c$export$3e9cee6b33872309)(false);
    let dataRouterContext = $gJYWc.useContext($a35327dc535bf969$export$3add0d5dce533e2e);
    let { basename: basename, future: future, navigator: navigator } = $gJYWc.useContext($a35327dc535bf969$export$26749e8557646306);
    let { matches: matches } = $gJYWc.useContext($a35327dc535bf969$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $a35327dc535bf969$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $ed8eb2d58084204c$export$a5784978eca585fa)(matches, future.v7_relativeSplatPath));
    let activeRef = $gJYWc.useRef(false);
    $a35327dc535bf969$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $gJYWc.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our history listener yet
        if (!activeRef.current) return;
        if (typeof to === "number") {
            navigator.go(to);
            return;
        }
        let path = (0, $ed8eb2d58084204c$export$cae722b0cc860f13)(to, JSON.parse(routePathnamesJson), locationPathname, options.relative === "path");
        // If we're operating within a basename, prepend it to the pathname prior
        // to handing off to history (but only if we're not in a data router,
        // otherwise it'll prepend the basename inside of the router).
        // If this is a root navigation, then we navigate to the raw basename
        // which allows the basename to have full control over the presence of a
        // trailing slash on root links
        if (dataRouterContext == null && basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $ed8eb2d58084204c$export$86d9a7913e44197e)([
            basename,
            path.pathname
        ]);
        (!!options.replace ? navigator.replace : navigator.push)(path, options.state, options);
    }, [
        basename,
        navigator,
        routePathnamesJson,
        locationPathname,
        dataRouterContext
    ]);
    return navigate;
}
const $a35327dc535bf969$var$OutletContext = /*#__PURE__*/ $gJYWc.createContext(null);
/**
 * Returns the context (if provided) for the child route at this level of the route
 * hierarchy.
 * @see https://reactrouter.com/v6/hooks/use-outlet-context
 */ function $a35327dc535bf969$export$4138103a3ae699cc() {
    return $gJYWc.useContext($a35327dc535bf969$var$OutletContext);
}
/**
 * Returns the element for the child route at this level of the route
 * hierarchy. Used internally by `<Outlet>` to render child routes.
 *
 * @see https://reactrouter.com/v6/hooks/use-outlet
 */ function $a35327dc535bf969$export$a3be3530d8e40d0b(context) {
    let outlet = $gJYWc.useContext($a35327dc535bf969$export$9072aa6dd1f93057).outlet;
    if (outlet) return /*#__PURE__*/ $gJYWc.createElement($a35327dc535bf969$var$OutletContext.Provider, {
        value: context
    }, outlet);
    return outlet;
}
/**
 * Returns an object of key/value pairs of the dynamic params from the current
 * URL that were matched by the route path.
 *
 * @see https://reactrouter.com/v6/hooks/use-params
 */ function $a35327dc535bf969$export$99eaa27ddbbb95ef() {
    let { matches: matches } = $gJYWc.useContext($a35327dc535bf969$export$9072aa6dd1f93057);
    let routeMatch = matches[matches.length - 1];
    return routeMatch ? routeMatch.params : {};
}
/**
 * Resolves the pathname of the given `to` value against the current location.
 *
 * @see https://reactrouter.com/v6/hooks/use-resolved-path
 */ function $a35327dc535bf969$export$e75d2a2d1b3c245b(to, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { future: future } = $gJYWc.useContext($a35327dc535bf969$export$26749e8557646306);
    let { matches: matches } = $gJYWc.useContext($a35327dc535bf969$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $a35327dc535bf969$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $ed8eb2d58084204c$export$a5784978eca585fa)(matches, future.v7_relativeSplatPath));
    return $gJYWc.useMemo(()=>(0, $ed8eb2d58084204c$export$cae722b0cc860f13)(to, JSON.parse(routePathnamesJson), locationPathname, relative === "path"), [
        to,
        routePathnamesJson,
        locationPathname,
        relative
    ]);
}
/**
 * Returns the element of the route that matched the current location, prepared
 * with the correct context to render the remainder of the route tree. Route
 * elements in the tree must render an `<Outlet>` to render their child route's
 * element.
 *
 * @see https://reactrouter.com/v6/hooks/use-routes
 */ function $a35327dc535bf969$export$5d3fca4a98652595(routes, locationArg) {
    return $a35327dc535bf969$export$5fcee62552a12fbf(routes, locationArg);
}
// Internal implementation with accept optional param for RouterProvider usage
function $a35327dc535bf969$export$5fcee62552a12fbf(routes, locationArg, dataRouterState, future) {
    !$a35327dc535bf969$export$9c954a9d03d32f4a() && (0, $ed8eb2d58084204c$export$3e9cee6b33872309)(false);
    let { navigator: navigator, static: isStatic } = $gJYWc.useContext($a35327dc535bf969$export$26749e8557646306);
    let { matches: parentMatches } = $gJYWc.useContext($a35327dc535bf969$export$9072aa6dd1f93057);
    let routeMatch = parentMatches[parentMatches.length - 1];
    let parentParams = routeMatch ? routeMatch.params : {};
    let parentPathname = routeMatch ? routeMatch.pathname : "/";
    let parentPathnameBase = routeMatch ? routeMatch.pathnameBase : "/";
    let parentRoute = routeMatch && routeMatch.route;
    let locationFromContext = $a35327dc535bf969$export$45d76561a5302f2b();
    let location;
    if (locationArg) {
        var _parsedLocationArg$pa;
        let parsedLocationArg = typeof locationArg === "string" ? (0, $ed8eb2d58084204c$export$8ccf933b0513f8d0)(locationArg) : locationArg;
        !(parentPathnameBase === "/" || ((_parsedLocationArg$pa = parsedLocationArg.pathname) == null ? void 0 : _parsedLocationArg$pa.startsWith(parentPathnameBase))) && (0, $ed8eb2d58084204c$export$3e9cee6b33872309)(false);
        location = parsedLocationArg;
    } else location = locationFromContext;
    let pathname = location.pathname || "/";
    let remainingPathname = pathname;
    if (parentPathnameBase !== "/") {
        // Determine the remaining pathname by removing the # of URL segments the
        // parentPathnameBase has, instead of removing based on character count.
        // This is because we can't guarantee that incoming/outgoing encodings/
        // decodings will match exactly.
        // We decode paths before matching on a per-segment basis with
        // decodeURIComponent(), but we re-encode pathnames via `new URL()` so they
        // match what `window.location.pathname` would reflect.  Those don't 100%
        // align when it comes to encoded URI characters such as % and &.
        //
        // So we may end up with:
        //   pathname:           "/descendant/a%25b/match"
        //   parentPathnameBase: "/descendant/a%b"
        //
        // And the direct substring removal approach won't work :/
        let parentSegments = parentPathnameBase.replace(/^\//, "").split("/");
        let segments = pathname.replace(/^\//, "").split("/");
        remainingPathname = "/" + segments.slice(parentSegments.length).join("/");
    }
    let matches = !isStatic && dataRouterState && dataRouterState.matches && dataRouterState.matches.length > 0 ? dataRouterState.matches : (0, $ed8eb2d58084204c$export$2708184779ceb39d)(routes, {
        pathname: remainingPathname
    });
    let renderedMatches = $a35327dc535bf969$var$_renderMatches(matches && matches.map((match)=>Object.assign({}, match, {
            params: Object.assign({}, parentParams, match.params),
            pathname: (0, $ed8eb2d58084204c$export$86d9a7913e44197e)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathname).pathname : match.pathname
            ]),
            pathnameBase: match.pathnameBase === "/" ? parentPathnameBase : (0, $ed8eb2d58084204c$export$86d9a7913e44197e)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathnameBase).pathname : match.pathnameBase
            ])
        })), parentMatches, dataRouterState, future);
    // When a user passes in a `locationArg`, the associated routes need to
    // be wrapped in a new `LocationContext.Provider` in order for `useLocation`
    // to use the scoped location instead of the global location.
    if (locationArg && renderedMatches) return /*#__PURE__*/ $gJYWc.createElement($a35327dc535bf969$export$c7914228fb69b0f5.Provider, {
        value: {
            location: $a35327dc535bf969$var$_extends({
                pathname: "/",
                search: "",
                hash: "",
                state: null,
                key: "default"
            }, location),
            navigationType: (0, $ed8eb2d58084204c$export$e19cd5f9376f8cee).Pop
        }
    }, renderedMatches);
    return renderedMatches;
}
function $a35327dc535bf969$var$DefaultErrorComponent() {
    let error = $a35327dc535bf969$export$ed527bf60f6e05f2();
    let message = (0, $ed8eb2d58084204c$export$972111febbeef05b)(error) ? error.status + " " + error.statusText : error instanceof Error ? error.message : JSON.stringify(error);
    let stack = error instanceof Error ? error.stack : null;
    let lightgrey = "rgba(200,200,200, 0.5)";
    let preStyles = {
        padding: "0.5rem",
        backgroundColor: lightgrey
    };
    let codeStyles = {
        padding: "2px 4px",
        backgroundColor: lightgrey
    };
    let devInfo = null;
    return /*#__PURE__*/ $gJYWc.createElement($gJYWc.Fragment, null, /*#__PURE__*/ $gJYWc.createElement("h2", null, "Unexpected Application Error!"), /*#__PURE__*/ $gJYWc.createElement("h3", {
        style: {
            fontStyle: "italic"
        }
    }, message), stack ? /*#__PURE__*/ $gJYWc.createElement("pre", {
        style: preStyles
    }, stack) : null, devInfo);
}
const $a35327dc535bf969$var$defaultErrorElement = /*#__PURE__*/ $gJYWc.createElement($a35327dc535bf969$var$DefaultErrorComponent, null);
class $a35327dc535bf969$var$RenderErrorBoundary extends $gJYWc.Component {
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    static getDerivedStateFromProps(props, state) {
        // When we get into an error state, the user will likely click "back" to the
        // previous page that didn't have an error. Because this wraps the entire
        // application, that will have no effect--the error page continues to display.
        // This gives us a mechanism to recover from the error when the location changes.
        //
        // Whether we're in an error state or not, we update the location in state
        // so that when we are in an error state, it gets reset when a new location
        // comes in and the user recovers from the error.
        if (state.location !== props.location || state.revalidation !== "idle" && props.revalidation === "idle") return {
            error: props.error,
            location: props.location,
            revalidation: props.revalidation
        };
        // If we're not changing locations, preserve the location but still surface
        // any new errors that may come through. We retain the existing error, we do
        // this because the error provided from the app state may be cleared without
        // the location changing.
        return {
            error: props.error !== undefined ? props.error : state.error,
            location: state.location,
            revalidation: props.revalidation || state.revalidation
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("React Router caught the following error during render", error, errorInfo);
    }
    render() {
        return this.state.error !== undefined ? /*#__PURE__*/ $gJYWc.createElement($a35327dc535bf969$export$9072aa6dd1f93057.Provider, {
            value: this.props.routeContext
        }, /*#__PURE__*/ $gJYWc.createElement($a35327dc535bf969$var$RouteErrorContext.Provider, {
            value: this.state.error,
            children: this.props.component
        })) : this.props.children;
    }
    constructor(props){
        super(props);
        this.state = {
            location: props.location,
            revalidation: props.revalidation,
            error: props.error
        };
    }
}
function $a35327dc535bf969$var$RenderedRoute(_ref) {
    let { routeContext: routeContext, match: match, children: children } = _ref;
    let dataRouterContext = $gJYWc.useContext($a35327dc535bf969$export$3add0d5dce533e2e);
    // Track how deep we got in our render pass to emulate SSR componentDidCatch
    // in a DataStaticRouter
    if (dataRouterContext && dataRouterContext.static && dataRouterContext.staticContext && (match.route.errorElement || match.route.ErrorBoundary)) dataRouterContext.staticContext._deepestRenderedBoundaryId = match.route.id;
    return /*#__PURE__*/ $gJYWc.createElement($a35327dc535bf969$export$9072aa6dd1f93057.Provider, {
        value: routeContext
    }, children);
}
function $a35327dc535bf969$var$_renderMatches(matches, parentMatches, dataRouterState, future) {
    var _dataRouterState;
    if (parentMatches === void 0) parentMatches = [];
    if (dataRouterState === void 0) dataRouterState = null;
    if (future === void 0) future = null;
    if (matches == null) {
        var _future;
        if (!dataRouterState) return null;
        if (dataRouterState.errors) // Don't bail if we have data router errors so we can render them in the
        // boundary.  Use the pre-matched (or shimmed) matches
        matches = dataRouterState.matches;
        else if ((_future = future) != null && _future.v7_partialHydration && parentMatches.length === 0 && !dataRouterState.initialized && dataRouterState.matches.length > 0) // Don't bail if we're initializing with partial hydration and we have
        // router matches.  That means we're actively running `patchRoutesOnNavigation`
        // so we should render down the partial matches to the appropriate
        // `HydrateFallback`.  We only do this if `parentMatches` is empty so it
        // only impacts the root matches for `RouterProvider` and no descendant
        // `<Routes>`
        matches = dataRouterState.matches;
        else return null;
    }
    let renderedMatches = matches;
    // If we have data errors, trim matches to the highest error boundary
    let errors = (_dataRouterState = dataRouterState) == null ? void 0 : _dataRouterState.errors;
    if (errors != null) {
        let errorIndex = renderedMatches.findIndex((m)=>m.route.id && (errors == null ? void 0 : errors[m.route.id]) !== undefined);
        !(errorIndex >= 0) && (0, $ed8eb2d58084204c$export$3e9cee6b33872309)(false);
        renderedMatches = renderedMatches.slice(0, Math.min(renderedMatches.length, errorIndex + 1));
    }
    // If we're in a partial hydration mode, detect if we need to render down to
    // a given HydrateFallback while we load the rest of the hydration data
    let renderFallback = false;
    let fallbackIndex = -1;
    if (dataRouterState && future && future.v7_partialHydration) for(let i = 0; i < renderedMatches.length; i++){
        let match = renderedMatches[i];
        // Track the deepest fallback up until the first route without data
        if (match.route.HydrateFallback || match.route.hydrateFallbackElement) fallbackIndex = i;
        if (match.route.id) {
            let { loaderData: loaderData, errors: errors } = dataRouterState;
            let needsToRunLoader = match.route.loader && loaderData[match.route.id] === undefined && (!errors || errors[match.route.id] === undefined);
            if (match.route.lazy || needsToRunLoader) {
                // We found the first route that's not ready to render (waiting on
                // lazy, or has a loader that hasn't run yet).  Flag that we need to
                // render a fallback and render up until the appropriate fallback
                renderFallback = true;
                if (fallbackIndex >= 0) renderedMatches = renderedMatches.slice(0, fallbackIndex + 1);
                else renderedMatches = [
                    renderedMatches[0]
                ];
                break;
            }
        }
    }
    return renderedMatches.reduceRight((outlet, match, index)=>{
        // Only data routers handle errors/fallbacks
        let error;
        let shouldRenderHydrateFallback = false;
        let errorElement = null;
        let hydrateFallbackElement = null;
        if (dataRouterState) {
            error = errors && match.route.id ? errors[match.route.id] : undefined;
            errorElement = match.route.errorElement || $a35327dc535bf969$var$defaultErrorElement;
            if (renderFallback) {
                if (fallbackIndex < 0 && index === 0) {
                    $a35327dc535bf969$var$warningOnce("route-fallback", false, "No `HydrateFallback` element provided to render during initial hydration");
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = null;
                } else if (fallbackIndex === index) {
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = match.route.hydrateFallbackElement || null;
                }
            }
        }
        let matches = parentMatches.concat(renderedMatches.slice(0, index + 1));
        let getChildren = ()=>{
            let children;
            if (error) children = errorElement;
            else if (shouldRenderHydrateFallback) children = hydrateFallbackElement;
            else if (match.route.Component) // Note: This is a de-optimized path since React won't re-use the
            // ReactElement since it's identity changes with each new
            // React.createElement call.  We keep this so folks can use
            // `<Route Component={...}>` in `<Routes>` but generally `Component`
            // usage is only advised in `RouterProvider` when we can convert it to
            // `element` ahead of time.
            children = /*#__PURE__*/ $gJYWc.createElement(match.route.Component, null);
            else if (match.route.element) children = match.route.element;
            else children = outlet;
            return /*#__PURE__*/ $gJYWc.createElement($a35327dc535bf969$var$RenderedRoute, {
                match: match,
                routeContext: {
                    outlet: outlet,
                    matches: matches,
                    isDataRoute: dataRouterState != null
                },
                children: children
            });
        };
        // Only wrap in an error boundary within data router usages when we have an
        // ErrorBoundary/errorElement on this route.  Otherwise let it bubble up to
        // an ancestor ErrorBoundary/errorElement
        return dataRouterState && (match.route.ErrorBoundary || match.route.errorElement || index === 0) ? /*#__PURE__*/ $gJYWc.createElement($a35327dc535bf969$var$RenderErrorBoundary, {
            location: dataRouterState.location,
            revalidation: dataRouterState.revalidation,
            component: errorElement,
            error: error,
            children: getChildren(),
            routeContext: {
                outlet: null,
                matches: matches,
                isDataRoute: true
            }
        }) : getChildren();
    }, null);
}
var $a35327dc535bf969$var$DataRouterHook = /*#__PURE__*/ function(DataRouterHook) {
    DataRouterHook["UseBlocker"] = "useBlocker";
    DataRouterHook["UseRevalidator"] = "useRevalidator";
    DataRouterHook["UseNavigateStable"] = "useNavigate";
    return DataRouterHook;
}($a35327dc535bf969$var$DataRouterHook || {});
var $a35327dc535bf969$var$DataRouterStateHook = /*#__PURE__*/ function(DataRouterStateHook) {
    DataRouterStateHook["UseBlocker"] = "useBlocker";
    DataRouterStateHook["UseLoaderData"] = "useLoaderData";
    DataRouterStateHook["UseActionData"] = "useActionData";
    DataRouterStateHook["UseRouteError"] = "useRouteError";
    DataRouterStateHook["UseNavigation"] = "useNavigation";
    DataRouterStateHook["UseRouteLoaderData"] = "useRouteLoaderData";
    DataRouterStateHook["UseMatches"] = "useMatches";
    DataRouterStateHook["UseRevalidator"] = "useRevalidator";
    DataRouterStateHook["UseNavigateStable"] = "useNavigate";
    DataRouterStateHook["UseRouteId"] = "useRouteId";
    return DataRouterStateHook;
}($a35327dc535bf969$var$DataRouterStateHook || {});
function $a35327dc535bf969$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/v6/routers/picking-a-router.";
}
function $a35327dc535bf969$var$useDataRouterContext(hookName) {
    let ctx = $gJYWc.useContext($a35327dc535bf969$export$3add0d5dce533e2e);
    !ctx && (0, $ed8eb2d58084204c$export$3e9cee6b33872309)(false);
    return ctx;
}
function $a35327dc535bf969$var$useDataRouterState(hookName) {
    let state = $gJYWc.useContext($a35327dc535bf969$export$145dfa71566a64dc);
    !state && (0, $ed8eb2d58084204c$export$3e9cee6b33872309)(false);
    return state;
}
function $a35327dc535bf969$var$useRouteContext(hookName) {
    let route = $gJYWc.useContext($a35327dc535bf969$export$9072aa6dd1f93057);
    !route && (0, $ed8eb2d58084204c$export$3e9cee6b33872309)(false);
    return route;
}
// Internal version with hookName-aware debugging
function $a35327dc535bf969$var$useCurrentRouteId(hookName) {
    let route = $a35327dc535bf969$var$useRouteContext(hookName);
    let thisRoute = route.matches[route.matches.length - 1];
    !thisRoute.route.id && (0, $ed8eb2d58084204c$export$3e9cee6b33872309)(false);
    return thisRoute.route.id;
}
/**
 * Returns the ID for the nearest contextual route
 */ function $a35327dc535bf969$export$5fc8298006ad9e58() {
    return $a35327dc535bf969$var$useCurrentRouteId($a35327dc535bf969$var$DataRouterStateHook.UseRouteId);
}
/**
 * Returns the current navigation, defaulting to an "idle" navigation when
 * no navigation is in progress
 */ function $a35327dc535bf969$export$d0fd4b7106de2769() {
    let state = $a35327dc535bf969$var$useDataRouterState($a35327dc535bf969$var$DataRouterStateHook.UseNavigation);
    return state.navigation;
}
/**
 * Returns a revalidate function for manually triggering revalidation, as well
 * as the current state of any manual revalidations
 */ function $a35327dc535bf969$export$600dc272ed516c15() {
    let dataRouterContext = $a35327dc535bf969$var$useDataRouterContext($a35327dc535bf969$var$DataRouterHook.UseRevalidator);
    let state = $a35327dc535bf969$var$useDataRouterState($a35327dc535bf969$var$DataRouterStateHook.UseRevalidator);
    return $gJYWc.useMemo(()=>({
            revalidate: dataRouterContext.router.revalidate,
            state: state.revalidation
        }), [
        dataRouterContext.router.revalidate,
        state.revalidation
    ]);
}
/**
 * Returns the active route matches, useful for accessing loaderData for
 * parent/child routes or the route "handle" property
 */ function $a35327dc535bf969$export$2378eb7f5ff86053() {
    let { matches: matches, loaderData: loaderData } = $a35327dc535bf969$var$useDataRouterState($a35327dc535bf969$var$DataRouterStateHook.UseMatches);
    return $gJYWc.useMemo(()=>matches.map((m)=>(0, $ed8eb2d58084204c$export$b3fac024fad9e8ff)(m, loaderData)), [
        matches,
        loaderData
    ]);
}
/**
 * Returns the loader data for the nearest ancestor Route loader
 */ function $a35327dc535bf969$export$1448a5050d252c4d() {
    let state = $a35327dc535bf969$var$useDataRouterState($a35327dc535bf969$var$DataRouterStateHook.UseLoaderData);
    let routeId = $a35327dc535bf969$var$useCurrentRouteId($a35327dc535bf969$var$DataRouterStateHook.UseLoaderData);
    if (state.errors && state.errors[routeId] != null) {
        console.error("You cannot `useLoaderData` in an errorElement (routeId: " + routeId + ")");
        return undefined;
    }
    return state.loaderData[routeId];
}
/**
 * Returns the loaderData for the given routeId
 */ function $a35327dc535bf969$export$fd5d37484eab868d(routeId) {
    let state = $a35327dc535bf969$var$useDataRouterState($a35327dc535bf969$var$DataRouterStateHook.UseRouteLoaderData);
    return state.loaderData[routeId];
}
/**
 * Returns the action data for the nearest ancestor Route action
 */ function $a35327dc535bf969$export$fdc00f3f26066d5e() {
    let state = $a35327dc535bf969$var$useDataRouterState($a35327dc535bf969$var$DataRouterStateHook.UseActionData);
    let routeId = $a35327dc535bf969$var$useCurrentRouteId($a35327dc535bf969$var$DataRouterStateHook.UseLoaderData);
    return state.actionData ? state.actionData[routeId] : undefined;
}
/**
 * Returns the nearest ancestor Route error, which could be a loader/action
 * error or a render error.  This is intended to be called from your
 * ErrorBoundary/errorElement to display a proper error message.
 */ function $a35327dc535bf969$export$ed527bf60f6e05f2() {
    var _state$errors;
    let error = $gJYWc.useContext($a35327dc535bf969$var$RouteErrorContext);
    let state = $a35327dc535bf969$var$useDataRouterState($a35327dc535bf969$var$DataRouterStateHook.UseRouteError);
    let routeId = $a35327dc535bf969$var$useCurrentRouteId($a35327dc535bf969$var$DataRouterStateHook.UseRouteError);
    // If this was a render error, we put it in a RouteError context inside
    // of RenderErrorBoundary
    if (error !== undefined) return error;
    // Otherwise look for errors from our data router state
    return (_state$errors = state.errors) == null ? void 0 : _state$errors[routeId];
}
/**
 * Returns the happy-path data from the nearest ancestor `<Await />` value
 */ function $a35327dc535bf969$export$78a72ddb39bdd145() {
    let value = $gJYWc.useContext($a35327dc535bf969$var$AwaitContext);
    return value == null ? void 0 : value._data;
}
/**
 * Returns the error from the nearest ancestor `<Await />` value
 */ function $a35327dc535bf969$export$17f53340677d5831() {
    let value = $gJYWc.useContext($a35327dc535bf969$var$AwaitContext);
    return value == null ? void 0 : value._error;
}
let $a35327dc535bf969$var$blockerId = 0;
/**
 * Allow the application to block navigations within the SPA and present the
 * user a confirmation dialog to confirm the navigation.  Mostly used to avoid
 * using half-filled form data.  This does not handle hard-reloads or
 * cross-origin navigations.
 */ function $a35327dc535bf969$export$b273b3273281a049(shouldBlock) {
    let { router: router, basename: basename } = $a35327dc535bf969$var$useDataRouterContext($a35327dc535bf969$var$DataRouterHook.UseBlocker);
    let state = $a35327dc535bf969$var$useDataRouterState($a35327dc535bf969$var$DataRouterStateHook.UseBlocker);
    let [blockerKey, setBlockerKey] = $gJYWc.useState("");
    let blockerFunction = $gJYWc.useCallback((arg)=>{
        if (typeof shouldBlock !== "function") return !!shouldBlock;
        if (basename === "/") return shouldBlock(arg);
        // If they provided us a function and we've got an active basename, strip
        // it from the locations we expose to the user to match the behavior of
        // useLocation
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = arg;
        return shouldBlock({
            currentLocation: $a35327dc535bf969$var$_extends({}, currentLocation, {
                pathname: (0, $ed8eb2d58084204c$export$b69e3301ce081aa3)(currentLocation.pathname, basename) || currentLocation.pathname
            }),
            nextLocation: $a35327dc535bf969$var$_extends({}, nextLocation, {
                pathname: (0, $ed8eb2d58084204c$export$b69e3301ce081aa3)(nextLocation.pathname, basename) || nextLocation.pathname
            }),
            historyAction: historyAction
        });
    }, [
        basename,
        shouldBlock
    ]);
    // This effect is in charge of blocker key assignment and deletion (which is
    // tightly coupled to the key)
    $gJYWc.useEffect(()=>{
        let key = String(++$a35327dc535bf969$var$blockerId);
        setBlockerKey(key);
        return ()=>router.deleteBlocker(key);
    }, [
        router
    ]);
    // This effect handles assigning the blockerFunction.  This is to handle
    // unstable blocker function identities, and happens only after the prior
    // effect so we don't get an orphaned blockerFunction in the router with a
    // key of "".  Until then we just have the IDLE_BLOCKER.
    $gJYWc.useEffect(()=>{
        if (blockerKey !== "") router.getBlocker(blockerKey, blockerFunction);
    }, [
        router,
        blockerKey,
        blockerFunction
    ]);
    // Prefer the blocker from `state` not `router.state` since DataRouterContext
    // is memoized so this ensures we update on blocker state updates
    return blockerKey && state.blockers.has(blockerKey) ? state.blockers.get(blockerKey) : (0, $ed8eb2d58084204c$export$386d57f03f0b2883);
}
/**
 * Stable version of useNavigate that is used when we are in the context of
 * a RouterProvider.
 */ function $a35327dc535bf969$var$useNavigateStable() {
    let { router: router } = $a35327dc535bf969$var$useDataRouterContext($a35327dc535bf969$var$DataRouterHook.UseNavigateStable);
    let id = $a35327dc535bf969$var$useCurrentRouteId($a35327dc535bf969$var$DataRouterStateHook.UseNavigateStable);
    let activeRef = $gJYWc.useRef(false);
    $a35327dc535bf969$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $gJYWc.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our router subscriber yet
        if (!activeRef.current) return;
        if (typeof to === "number") router.navigate(to);
        else router.navigate(to, $a35327dc535bf969$var$_extends({
            fromRouteId: id
        }, options));
    }, [
        router,
        id
    ]);
    return navigate;
}
const $a35327dc535bf969$var$alreadyWarned$1 = {};
function $a35327dc535bf969$var$warningOnce(key, cond, message) {
    if (!cond && !$a35327dc535bf969$var$alreadyWarned$1[key]) $a35327dc535bf969$var$alreadyWarned$1[key] = true;
}
const $a35327dc535bf969$var$alreadyWarned = {};
function $a35327dc535bf969$var$warnOnce(key, message) {}
const $a35327dc535bf969$var$logDeprecation = (flag, msg, link)=>$a35327dc535bf969$var$warnOnce(flag, "\u26A0\uFE0F React Router Future Flag Warning: " + msg + ". " + ("You can use the `" + flag + "` future flag to opt-in early. ") + ("For more information, see " + link + "."));
function $a35327dc535bf969$export$db5148ec97d6af7a(renderFuture, routerFuture) {
    if ((renderFuture == null ? void 0 : renderFuture.v7_startTransition) === undefined) $a35327dc535bf969$var$logDeprecation("v7_startTransition", "React Router will begin wrapping state updates in `React.startTransition` in v7", "https://reactrouter.com/v6/upgrading/future#v7_starttransition");
    if ((renderFuture == null ? void 0 : renderFuture.v7_relativeSplatPath) === undefined && (!routerFuture || !routerFuture.v7_relativeSplatPath)) $a35327dc535bf969$var$logDeprecation("v7_relativeSplatPath", "Relative route resolution within Splat routes is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_relativesplatpath");
    if (routerFuture) {
        if (routerFuture.v7_fetcherPersist === undefined) $a35327dc535bf969$var$logDeprecation("v7_fetcherPersist", "The persistence behavior of fetchers is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_fetcherpersist");
        if (routerFuture.v7_normalizeFormMethod === undefined) $a35327dc535bf969$var$logDeprecation("v7_normalizeFormMethod", "Casing of `formMethod` fields is being normalized to uppercase in v7", "https://reactrouter.com/v6/upgrading/future#v7_normalizeformmethod");
        if (routerFuture.v7_partialHydration === undefined) $a35327dc535bf969$var$logDeprecation("v7_partialHydration", "`RouterProvider` hydration behavior is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_partialhydration");
        if (routerFuture.v7_skipActionErrorRevalidation === undefined) $a35327dc535bf969$var$logDeprecation("v7_skipActionErrorRevalidation", "The revalidation behavior after 4xx/5xx `action` responses is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_skipactionerrorrevalidation");
    }
}
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const $a35327dc535bf969$var$START_TRANSITION = "startTransition";
const $a35327dc535bf969$var$startTransitionImpl = $gJYWc[$a35327dc535bf969$var$START_TRANSITION];
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $a35327dc535bf969$export$323e4fc2fa4753fb(_ref) {
    let { fallbackElement: fallbackElement, router: router, future: future } = _ref;
    let [state, setStateImpl] = $gJYWc.useState(router.state);
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $gJYWc.useCallback((newState)=>{
        if (v7_startTransition && $a35327dc535bf969$var$startTransitionImpl) $a35327dc535bf969$var$startTransitionImpl(()=>setStateImpl(newState));
        else setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    $gJYWc.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    $gJYWc.useEffect(()=>{
    // Only log this once on initial mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    let navigator = $gJYWc.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $gJYWc.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        }), [
        router,
        navigator,
        basename
    ]);
    $gJYWc.useEffect(()=>$a35327dc535bf969$export$db5148ec97d6af7a(future, router.future), [
        router,
        future
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $gJYWc.createElement($gJYWc.Fragment, null, /*#__PURE__*/ $gJYWc.createElement($a35327dc535bf969$export$3add0d5dce533e2e.Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $gJYWc.createElement($a35327dc535bf969$export$145dfa71566a64dc.Provider, {
        value: state
    }, /*#__PURE__*/ $gJYWc.createElement($a35327dc535bf969$export$55185c17a0fcbe46, {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        future: {
            v7_relativeSplatPath: router.future.v7_relativeSplatPath
        }
    }, state.initialized || router.future.v7_partialHydration ? /*#__PURE__*/ $gJYWc.createElement($a35327dc535bf969$var$DataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state
    }) : fallbackElement))), null);
}
function $a35327dc535bf969$var$DataRoutes(_ref2) {
    let { routes: routes, future: future, state: state } = _ref2;
    return $a35327dc535bf969$export$5fcee62552a12fbf(routes, undefined, state, future);
}
/**
 * A `<Router>` that stores all entries in memory.
 *
 * @see https://reactrouter.com/v6/router-components/memory-router
 */ function $a35327dc535bf969$export$ae46f04cfaffe093(_ref3) {
    let { basename: basename, children: children, initialEntries: initialEntries, initialIndex: initialIndex, future: future } = _ref3;
    let historyRef = $gJYWc.useRef();
    if (historyRef.current == null) historyRef.current = (0, $ed8eb2d58084204c$export$2b76ad033c6e6d08)({
        initialEntries: initialEntries,
        initialIndex: initialIndex,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $gJYWc.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $gJYWc.useCallback((newState)=>{
        v7_startTransition && $a35327dc535bf969$var$startTransitionImpl ? $a35327dc535bf969$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $gJYWc.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    $gJYWc.useEffect(()=>$a35327dc535bf969$export$db5148ec97d6af7a(future), [
        future
    ]);
    return /*#__PURE__*/ $gJYWc.createElement($a35327dc535bf969$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * Changes the current location.
 *
 * Note: This API is mostly useful in React.Component subclasses that are not
 * able to use hooks. In functional components, we recommend you use the
 * `useNavigate` hook instead.
 *
 * @see https://reactrouter.com/v6/components/navigate
 */ function $a35327dc535bf969$export$444b3ab0cb9aec40(_ref4) {
    let { to: to, replace: replace, state: state, relative: relative } = _ref4;
    !$a35327dc535bf969$export$9c954a9d03d32f4a() && (0, $ed8eb2d58084204c$export$3e9cee6b33872309)(false);
    let { future: future, static: isStatic } = $gJYWc.useContext($a35327dc535bf969$export$26749e8557646306);
    let { matches: matches } = $gJYWc.useContext($a35327dc535bf969$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $a35327dc535bf969$export$45d76561a5302f2b();
    let navigate = $a35327dc535bf969$export$9770f232ac06a008();
    // Resolve the path outside of the effect so that when effects run twice in
    // StrictMode they navigate to the same place
    let path = (0, $ed8eb2d58084204c$export$cae722b0cc860f13)(to, (0, $ed8eb2d58084204c$export$a5784978eca585fa)(matches, future.v7_relativeSplatPath), locationPathname, relative === "path");
    let jsonPath = JSON.stringify(path);
    $gJYWc.useEffect(()=>navigate(JSON.parse(jsonPath), {
            replace: replace,
            state: state,
            relative: relative
        }), [
        navigate,
        jsonPath,
        relative,
        replace,
        state
    ]);
    return null;
}
/**
 * Renders the child route's element, if there is one.
 *
 * @see https://reactrouter.com/v6/components/outlet
 */ function $a35327dc535bf969$export$910ae8079b2c2852(props) {
    return $a35327dc535bf969$export$a3be3530d8e40d0b(props.context);
}
/**
 * Declares an element that should be rendered at a certain URL path.
 *
 * @see https://reactrouter.com/v6/components/route
 */ function $a35327dc535bf969$export$e7b0ac011bb776c6(_props) {
    (0, $ed8eb2d58084204c$export$3e9cee6b33872309)(false);
}
/**
 * Provides location context for the rest of the app.
 *
 * Note: You usually won't render a `<Router>` directly. Instead, you'll render a
 * router that is more specific to your environment such as a `<BrowserRouter>`
 * in web browsers or a `<StaticRouter>` for server rendering.
 *
 * @see https://reactrouter.com/v6/router-components/router
 */ function $a35327dc535bf969$export$55185c17a0fcbe46(_ref5) {
    let { basename: basenameProp = "/", children: children = null, location: locationProp, navigationType: navigationType = (0, $ed8eb2d58084204c$export$e19cd5f9376f8cee).Pop, navigator: navigator, static: staticProp = false, future: future } = _ref5;
    !!$a35327dc535bf969$export$9c954a9d03d32f4a() && (0, $ed8eb2d58084204c$export$3e9cee6b33872309)(false);
    // Preserve trailing slashes on basename, so we can let the user control
    // the enforcement of trailing slashes throughout the app
    let basename = basenameProp.replace(/^\/*/, "/");
    let navigationContext = $gJYWc.useMemo(()=>({
            basename: basename,
            navigator: navigator,
            static: staticProp,
            future: $a35327dc535bf969$var$_extends({
                v7_relativeSplatPath: false
            }, future)
        }), [
        basename,
        future,
        navigator,
        staticProp
    ]);
    if (typeof locationProp === "string") locationProp = (0, $ed8eb2d58084204c$export$8ccf933b0513f8d0)(locationProp);
    let { pathname: pathname = "/", search: search = "", hash: hash = "", state: state = null, key: key = "default" } = locationProp;
    let locationContext = $gJYWc.useMemo(()=>{
        let trailingPathname = (0, $ed8eb2d58084204c$export$b69e3301ce081aa3)(pathname, basename);
        if (trailingPathname == null) return null;
        return {
            location: {
                pathname: trailingPathname,
                search: search,
                hash: hash,
                state: state,
                key: key
            },
            navigationType: navigationType
        };
    }, [
        basename,
        pathname,
        search,
        hash,
        state,
        key,
        navigationType
    ]);
    if (locationContext == null) return null;
    return /*#__PURE__*/ $gJYWc.createElement($a35327dc535bf969$export$26749e8557646306.Provider, {
        value: navigationContext
    }, /*#__PURE__*/ $gJYWc.createElement($a35327dc535bf969$export$c7914228fb69b0f5.Provider, {
        children: children,
        value: locationContext
    }));
}
/**
 * A container for a nested tree of `<Route>` elements that renders the branch
 * that best matches the current location.
 *
 * @see https://reactrouter.com/v6/components/routes
 */ function $a35327dc535bf969$export$3565eb3d00ca5a74(_ref6) {
    let { children: children, location: location } = _ref6;
    return $a35327dc535bf969$export$5d3fca4a98652595($a35327dc535bf969$export$16da398f5434bdec(children), location);
}
/**
 * Component to use for rendering lazily loaded data from returning defer()
 * in a loader function
 */ function $a35327dc535bf969$export$6ddabde395c8c576(_ref7) {
    let { children: children, errorElement: errorElement, resolve: resolve } = _ref7;
    return /*#__PURE__*/ $gJYWc.createElement($a35327dc535bf969$var$AwaitErrorBoundary, {
        resolve: resolve,
        errorElement: errorElement
    }, /*#__PURE__*/ $gJYWc.createElement($a35327dc535bf969$var$ResolveAwait, null, children));
}
var $a35327dc535bf969$var$AwaitRenderStatus = /*#__PURE__*/ function(AwaitRenderStatus) {
    AwaitRenderStatus[AwaitRenderStatus["pending"] = 0] = "pending";
    AwaitRenderStatus[AwaitRenderStatus["success"] = 1] = "success";
    AwaitRenderStatus[AwaitRenderStatus["error"] = 2] = "error";
    return AwaitRenderStatus;
}($a35327dc535bf969$var$AwaitRenderStatus || {});
const $a35327dc535bf969$var$neverSettledPromise = new Promise(()=>{});
class $a35327dc535bf969$var$AwaitErrorBoundary extends $gJYWc.Component {
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("<Await> caught the following error during render", error, errorInfo);
    }
    render() {
        let { children: children, errorElement: errorElement, resolve: resolve } = this.props;
        let promise = null;
        let status = $a35327dc535bf969$var$AwaitRenderStatus.pending;
        if (!(resolve instanceof Promise)) {
            // Didn't get a promise - provide as a resolved promise
            status = $a35327dc535bf969$var$AwaitRenderStatus.success;
            promise = Promise.resolve();
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_data", {
                get: ()=>resolve
            });
        } else if (this.state.error) {
            // Caught a render error, provide it as a rejected promise
            status = $a35327dc535bf969$var$AwaitRenderStatus.error;
            let renderError = this.state.error;
            promise = Promise.reject().catch(()=>{}); // Avoid unhandled rejection warnings
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_error", {
                get: ()=>renderError
            });
        } else if (resolve._tracked) {
            // Already tracked promise - check contents
            promise = resolve;
            status = "_error" in promise ? $a35327dc535bf969$var$AwaitRenderStatus.error : "_data" in promise ? $a35327dc535bf969$var$AwaitRenderStatus.success : $a35327dc535bf969$var$AwaitRenderStatus.pending;
        } else {
            // Raw (untracked) promise - track it
            status = $a35327dc535bf969$var$AwaitRenderStatus.pending;
            Object.defineProperty(resolve, "_tracked", {
                get: ()=>true
            });
            promise = resolve.then((data)=>Object.defineProperty(resolve, "_data", {
                    get: ()=>data
                }), (error)=>Object.defineProperty(resolve, "_error", {
                    get: ()=>error
                }));
        }
        if (status === $a35327dc535bf969$var$AwaitRenderStatus.error && promise._error instanceof (0, $ed8eb2d58084204c$export$42a99a7a4bc0e76a)) // Freeze the UI by throwing a never resolved promise
        throw $a35327dc535bf969$var$neverSettledPromise;
        if (status === $a35327dc535bf969$var$AwaitRenderStatus.error && !errorElement) // No errorElement, throw to the nearest route-level error boundary
        throw promise._error;
        if (status === $a35327dc535bf969$var$AwaitRenderStatus.error) // Render via our errorElement
        return /*#__PURE__*/ $gJYWc.createElement($a35327dc535bf969$var$AwaitContext.Provider, {
            value: promise,
            children: errorElement
        });
        if (status === $a35327dc535bf969$var$AwaitRenderStatus.success) // Render children with resolved value
        return /*#__PURE__*/ $gJYWc.createElement($a35327dc535bf969$var$AwaitContext.Provider, {
            value: promise,
            children: children
        });
        // Throw to the suspense boundary
        throw promise;
    }
    constructor(props){
        super(props);
        this.state = {
            error: null
        };
    }
}
/**
 * @private
 * Indirection to leverage useAsyncValue for a render-prop API on `<Await>`
 */ function $a35327dc535bf969$var$ResolveAwait(_ref8) {
    let { children: children } = _ref8;
    let data = $a35327dc535bf969$export$78a72ddb39bdd145();
    let toRender = typeof children === "function" ? children(data) : children;
    return /*#__PURE__*/ $gJYWc.createElement($gJYWc.Fragment, null, toRender);
}
///////////////////////////////////////////////////////////////////////////////
// UTILS
///////////////////////////////////////////////////////////////////////////////
/**
 * Creates a route config from a React "children" object, which is usually
 * either a `<Route>` element or an array of them. Used internally by
 * `<Routes>` to create a route config from its children.
 *
 * @see https://reactrouter.com/v6/utils/create-routes-from-children
 */ function $a35327dc535bf969$export$16da398f5434bdec(children, parentPath) {
    if (parentPath === void 0) parentPath = [];
    let routes = [];
    $gJYWc.Children.forEach(children, (element, index)=>{
        if (!/*#__PURE__*/ $gJYWc.isValidElement(element)) // Ignore non-elements. This allows people to more easily inline
        // conditionals in their route config.
        return;
        let treePath = [
            ...parentPath,
            index
        ];
        if (element.type === $gJYWc.Fragment) {
            // Transparently support React.Fragment and its children.
            routes.push.apply(routes, $a35327dc535bf969$export$16da398f5434bdec(element.props.children, treePath));
            return;
        }
        !(element.type === $a35327dc535bf969$export$e7b0ac011bb776c6) && (0, $ed8eb2d58084204c$export$3e9cee6b33872309)(false);
        !(!element.props.index || !element.props.children) && (0, $ed8eb2d58084204c$export$3e9cee6b33872309)(false);
        let route = {
            id: element.props.id || treePath.join("-"),
            caseSensitive: element.props.caseSensitive,
            element: element.props.element,
            Component: element.props.Component,
            index: element.props.index,
            path: element.props.path,
            loader: element.props.loader,
            action: element.props.action,
            errorElement: element.props.errorElement,
            ErrorBoundary: element.props.ErrorBoundary,
            hasErrorBoundary: element.props.ErrorBoundary != null || element.props.errorElement != null,
            shouldRevalidate: element.props.shouldRevalidate,
            handle: element.props.handle,
            lazy: element.props.lazy
        };
        if (element.props.children) route.children = $a35327dc535bf969$export$16da398f5434bdec(element.props.children, treePath);
        routes.push(route);
    });
    return routes;
}
/**
 * Renders the result of `matchRoutes()` into a React element.
 */ function $a35327dc535bf969$export$daf73786167a7f72(matches) {
    return $a35327dc535bf969$var$_renderMatches(matches);
}
function $a35327dc535bf969$export$52b333d321859367(route) {
    let updates = {
        // Note: this check also occurs in createRoutesFromChildren so update
        // there if you change this -- please and thank you!
        hasErrorBoundary: route.ErrorBoundary != null || route.errorElement != null
    };
    if (route.Component) Object.assign(updates, {
        element: /*#__PURE__*/ $gJYWc.createElement(route.Component),
        Component: undefined
    });
    if (route.HydrateFallback) Object.assign(updates, {
        hydrateFallbackElement: /*#__PURE__*/ $gJYWc.createElement(route.HydrateFallback),
        HydrateFallback: undefined
    });
    if (route.ErrorBoundary) Object.assign(updates, {
        errorElement: /*#__PURE__*/ $gJYWc.createElement(route.ErrorBoundary),
        ErrorBoundary: undefined
    });
    return updates;
}
function $a35327dc535bf969$export$f30f7e456d254e83(routes, opts) {
    return (0, $ed8eb2d58084204c$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $a35327dc535bf969$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $ed8eb2d58084204c$export$2b76ad033c6e6d08)({
            initialEntries: opts == null ? void 0 : opts.initialEntries,
            initialIndex: opts == null ? void 0 : opts.initialIndex
        }),
        hydrationData: opts == null ? void 0 : opts.hydrationData,
        routes: routes,
        mapRouteProperties: $a35327dc535bf969$export$52b333d321859367,
        dataStrategy: opts == null ? void 0 : opts.dataStrategy,
        patchRoutesOnNavigation: opts == null ? void 0 : opts.patchRoutesOnNavigation
    }).initialize();
}



function $8384e1b28fff68bc$var$_extends() {
    $8384e1b28fff68bc$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $8384e1b28fff68bc$var$_extends.apply(this, arguments);
}
function $8384e1b28fff68bc$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
const $8384e1b28fff68bc$var$defaultMethod = "get";
const $8384e1b28fff68bc$var$defaultEncType = "application/x-www-form-urlencoded";
function $8384e1b28fff68bc$var$isHtmlElement(object) {
    return object != null && typeof object.tagName === "string";
}
function $8384e1b28fff68bc$var$isButtonElement(object) {
    return $8384e1b28fff68bc$var$isHtmlElement(object) && object.tagName.toLowerCase() === "button";
}
function $8384e1b28fff68bc$var$isFormElement(object) {
    return $8384e1b28fff68bc$var$isHtmlElement(object) && object.tagName.toLowerCase() === "form";
}
function $8384e1b28fff68bc$var$isInputElement(object) {
    return $8384e1b28fff68bc$var$isHtmlElement(object) && object.tagName.toLowerCase() === "input";
}
function $8384e1b28fff68bc$var$isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
function $8384e1b28fff68bc$var$shouldProcessLinkClick(event, target) {
    return event.button === 0 && // Ignore everything but left clicks
    (!target || target === "_self") && // Let browser handle "target=_blank" etc.
    !$8384e1b28fff68bc$var$isModifiedEvent(event) // Ignore clicks with modifier keys
    ;
}
/**
 * Creates a URLSearchParams object using the given initializer.
 *
 * This is identical to `new URLSearchParams(init)` except it also
 * supports arrays as values in the object form of the initializer
 * instead of just strings. This is convenient when you need multiple
 * values for a given key, but don't want to use an array initializer.
 *
 * For example, instead of:
 *
 *   let searchParams = new URLSearchParams([
 *     ['sort', 'name'],
 *     ['sort', 'price']
 *   ]);
 *
 * you can do:
 *
 *   let searchParams = createSearchParams({
 *     sort: ['name', 'price']
 *   });
 */ function $8384e1b28fff68bc$export$a2e4e2dcc7b1f22f(init) {
    if (init === void 0) init = "";
    return new URLSearchParams(typeof init === "string" || Array.isArray(init) || init instanceof URLSearchParams ? init : Object.keys(init).reduce((memo, key)=>{
        let value = init[key];
        return memo.concat(Array.isArray(value) ? value.map((v)=>[
                key,
                v
            ]) : [
            [
                key,
                value
            ]
        ]);
    }, []));
}
function $8384e1b28fff68bc$var$getSearchParamsForLocation(locationSearch, defaultSearchParams) {
    let searchParams = $8384e1b28fff68bc$export$a2e4e2dcc7b1f22f(locationSearch);
    if (defaultSearchParams) // Use `defaultSearchParams.forEach(...)` here instead of iterating of
    // `defaultSearchParams.keys()` to work-around a bug in Firefox related to
    // web extensions. Relevant Bugzilla tickets:
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1414602
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1023984
    defaultSearchParams.forEach((_, key)=>{
        if (!searchParams.has(key)) defaultSearchParams.getAll(key).forEach((value)=>{
            searchParams.append(key, value);
        });
    });
    return searchParams;
}
// One-time check for submitter support
let $8384e1b28fff68bc$var$_formDataSupportsSubmitter = null;
function $8384e1b28fff68bc$var$isFormDataSubmitterSupported() {
    if ($8384e1b28fff68bc$var$_formDataSupportsSubmitter === null) try {
        new FormData(document.createElement("form"), // @ts-expect-error if FormData supports the submitter parameter, this will throw
        0);
        $8384e1b28fff68bc$var$_formDataSupportsSubmitter = false;
    } catch (e) {
        $8384e1b28fff68bc$var$_formDataSupportsSubmitter = true;
    }
    return $8384e1b28fff68bc$var$_formDataSupportsSubmitter;
}
const $8384e1b28fff68bc$var$supportedFormEncTypes = new Set([
    "application/x-www-form-urlencoded",
    "multipart/form-data",
    "text/plain"
]);
function $8384e1b28fff68bc$var$getFormEncType(encType) {
    if (encType != null && !$8384e1b28fff68bc$var$supportedFormEncTypes.has(encType)) return null;
    return encType;
}
function $8384e1b28fff68bc$var$getFormSubmissionInfo(target, basename) {
    let method;
    let action;
    let encType;
    let formData;
    let body;
    if ($8384e1b28fff68bc$var$isFormElement(target)) {
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        let attr = target.getAttribute("action");
        action = attr ? (0, $ed8eb2d58084204c$export$b69e3301ce081aa3)(attr, basename) : null;
        method = target.getAttribute("method") || $8384e1b28fff68bc$var$defaultMethod;
        encType = $8384e1b28fff68bc$var$getFormEncType(target.getAttribute("enctype")) || $8384e1b28fff68bc$var$defaultEncType;
        formData = new FormData(target);
    } else if ($8384e1b28fff68bc$var$isButtonElement(target) || $8384e1b28fff68bc$var$isInputElement(target) && (target.type === "submit" || target.type === "image")) {
        let form = target.form;
        if (form == null) throw new Error("Cannot submit a <button> or <input type=\"submit\"> without a <form>");
        // <button>/<input type="submit"> may override attributes of <form>
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        let attr = target.getAttribute("formaction") || form.getAttribute("action");
        action = attr ? (0, $ed8eb2d58084204c$export$b69e3301ce081aa3)(attr, basename) : null;
        method = target.getAttribute("formmethod") || form.getAttribute("method") || $8384e1b28fff68bc$var$defaultMethod;
        encType = $8384e1b28fff68bc$var$getFormEncType(target.getAttribute("formenctype")) || $8384e1b28fff68bc$var$getFormEncType(form.getAttribute("enctype")) || $8384e1b28fff68bc$var$defaultEncType;
        // Build a FormData object populated from a form and submitter
        formData = new FormData(form, target);
        // If this browser doesn't support the `FormData(el, submitter)` format,
        // then tack on the submitter value at the end.  This is a lightweight
        // solution that is not 100% spec compliant.  For complete support in older
        // browsers, consider using the `formdata-submitter-polyfill` package
        if (!$8384e1b28fff68bc$var$isFormDataSubmitterSupported()) {
            let { name: name, type: type, value: value } = target;
            if (type === "image") {
                let prefix = name ? name + "." : "";
                formData.append(prefix + "x", "0");
                formData.append(prefix + "y", "0");
            } else if (name) formData.append(name, value);
        }
    } else if ($8384e1b28fff68bc$var$isHtmlElement(target)) throw new Error('Cannot submit element that is not <form>, <button>, or <input type="submit|image">');
    else {
        method = $8384e1b28fff68bc$var$defaultMethod;
        action = null;
        encType = $8384e1b28fff68bc$var$defaultEncType;
        body = target;
    }
    // Send body for <Form encType="text/plain" so we encode it into text
    if (formData && encType === "text/plain") {
        body = formData;
        formData = undefined;
    }
    return {
        action: action,
        method: method.toLowerCase(),
        encType: encType,
        formData: formData,
        body: body
    };
}
const $8384e1b28fff68bc$var$_excluded = [
    "onClick",
    "relative",
    "reloadDocument",
    "replace",
    "state",
    "target",
    "to",
    "preventScrollReset",
    "viewTransition"
], $8384e1b28fff68bc$var$_excluded2 = [
    "aria-current",
    "caseSensitive",
    "className",
    "end",
    "style",
    "to",
    "viewTransition",
    "children"
], $8384e1b28fff68bc$var$_excluded3 = [
    "fetcherKey",
    "navigate",
    "reloadDocument",
    "replace",
    "state",
    "method",
    "action",
    "onSubmit",
    "relative",
    "preventScrollReset",
    "viewTransition"
];
// HEY YOU! DON'T TOUCH THIS VARIABLE!
//
// It is replaced with the proper version at build time via a babel plugin in
// the rollup config.
//
// Export a global property onto the window for React Router detection by the
// Core Web Vitals Technology Report.  This way they can configure the `wappalyzer`
// to detect and properly classify live websites as being built with React Router:
// https://github.com/HTTPArchive/wappalyzer/blob/main/src/technologies/r.json
const $8384e1b28fff68bc$var$REACT_ROUTER_VERSION = "6";
try {
    window.__reactRouterVersion = $8384e1b28fff68bc$var$REACT_ROUTER_VERSION;
} catch (e) {
// no-op
}
function $8384e1b28fff68bc$export$1f3f55432a00e06d(routes, opts) {
    return (0, $ed8eb2d58084204c$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $8384e1b28fff68bc$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $ed8eb2d58084204c$export$719fc203c4e16dee)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $8384e1b28fff68bc$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $a35327dc535bf969$export$52b333d321859367),
        dataStrategy: opts == null ? void 0 : opts.dataStrategy,
        patchRoutesOnNavigation: opts == null ? void 0 : opts.patchRoutesOnNavigation,
        window: opts == null ? void 0 : opts.window
    }).initialize();
}
function $8384e1b28fff68bc$export$1ba7ed8a3a7b3765(routes, opts) {
    return (0, $ed8eb2d58084204c$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $8384e1b28fff68bc$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $ed8eb2d58084204c$export$b71fdd3798280242)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $8384e1b28fff68bc$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $a35327dc535bf969$export$52b333d321859367),
        dataStrategy: opts == null ? void 0 : opts.dataStrategy,
        patchRoutesOnNavigation: opts == null ? void 0 : opts.patchRoutesOnNavigation,
        window: opts == null ? void 0 : opts.window
    }).initialize();
}
function $8384e1b28fff68bc$var$parseHydrationData() {
    var _window;
    let state = (_window = window) == null ? void 0 : _window.__staticRouterHydrationData;
    if (state && state.errors) state = $8384e1b28fff68bc$var$_extends({}, state, {
        errors: $8384e1b28fff68bc$var$deserializeErrors(state.errors)
    });
    return state;
}
function $8384e1b28fff68bc$var$deserializeErrors(errors) {
    if (!errors) return null;
    let entries = Object.entries(errors);
    let serialized = {};
    for (let [key, val] of entries){
        // Hey you!  If you change this, please change the corresponding logic in
        // serializeErrors in react-router-dom/server.tsx :)
        if (val && val.__type === "RouteErrorResponse") serialized[key] = new (0, $ed8eb2d58084204c$export$6c6580e81da25755)(val.status, val.statusText, val.data, val.internal === true);
        else if (val && val.__type === "Error") {
            // Attempt to reconstruct the right type of Error (i.e., ReferenceError)
            if (val.__subType) {
                let ErrorConstructor = window[val.__subType];
                if (typeof ErrorConstructor === "function") try {
                    // @ts-expect-error
                    let error = new ErrorConstructor(val.message);
                    // Wipe away the client-side stack trace.  Nothing to fill it in with
                    // because we don't serialize SSR stack traces for security reasons
                    error.stack = "";
                    serialized[key] = error;
                } catch (e) {
                // no-op - fall through and create a normal Error
                }
            }
            if (serialized[key] == null) {
                let error = new Error(val.message);
                // Wipe away the client-side stack trace.  Nothing to fill it in with
                // because we don't serialize SSR stack traces for security reasons
                error.stack = "";
                serialized[key] = error;
            }
        } else serialized[key] = val;
    }
    return serialized;
}
const $8384e1b28fff68bc$export$7ad602f0e94e62d1 = /*#__PURE__*/ $gJYWc.createContext({
    isTransitioning: false
});
const $8384e1b28fff68bc$export$148fd98d095596d4 = /*#__PURE__*/ $gJYWc.createContext(new Map());
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Components
////////////////////////////////////////////////////////////////////////////////
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const $8384e1b28fff68bc$var$START_TRANSITION = "startTransition";
const $8384e1b28fff68bc$var$startTransitionImpl = $gJYWc[$8384e1b28fff68bc$var$START_TRANSITION];
const $8384e1b28fff68bc$var$FLUSH_SYNC = "flushSync";
const $8384e1b28fff68bc$var$flushSyncImpl = $b5d6c7fd13e04efb$exports[$8384e1b28fff68bc$var$FLUSH_SYNC];
const $8384e1b28fff68bc$var$USE_ID = "useId";
const $8384e1b28fff68bc$var$useIdImpl = $gJYWc[$8384e1b28fff68bc$var$USE_ID];
function $8384e1b28fff68bc$var$startTransitionSafe(cb) {
    if ($8384e1b28fff68bc$var$startTransitionImpl) $8384e1b28fff68bc$var$startTransitionImpl(cb);
    else cb();
}
function $8384e1b28fff68bc$var$flushSyncSafe(cb) {
    if ($8384e1b28fff68bc$var$flushSyncImpl) $8384e1b28fff68bc$var$flushSyncImpl(cb);
    else cb();
}
class $8384e1b28fff68bc$var$Deferred {
    constructor(){
        this.status = "pending";
        this.promise = new Promise((resolve, reject)=>{
            this.resolve = (value)=>{
                if (this.status === "pending") {
                    this.status = "resolved";
                    resolve(value);
                }
            };
            this.reject = (reason)=>{
                if (this.status === "pending") {
                    this.status = "rejected";
                    reject(reason);
                }
            };
        });
    }
}
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $8384e1b28fff68bc$export$323e4fc2fa4753fb(_ref) {
    let { fallbackElement: fallbackElement, router: router, future: future } = _ref;
    let [state, setStateImpl] = $gJYWc.useState(router.state);
    let [pendingState, setPendingState] = $gJYWc.useState();
    let [vtContext, setVtContext] = $gJYWc.useState({
        isTransitioning: false
    });
    let [renderDfd, setRenderDfd] = $gJYWc.useState();
    let [transition, setTransition] = $gJYWc.useState();
    let [interruption, setInterruption] = $gJYWc.useState();
    let fetcherData = $gJYWc.useRef(new Map());
    let { v7_startTransition: v7_startTransition } = future || {};
    let optInStartTransition = $gJYWc.useCallback((cb)=>{
        if (v7_startTransition) $8384e1b28fff68bc$var$startTransitionSafe(cb);
        else cb();
    }, [
        v7_startTransition
    ]);
    let setState = $gJYWc.useCallback((newState, _ref2)=>{
        let { deletedFetchers: deletedFetchers, flushSync: flushSync, viewTransitionOpts: viewTransitionOpts } = _ref2;
        newState.fetchers.forEach((fetcher, key)=>{
            if (fetcher.data !== undefined) fetcherData.current.set(key, fetcher.data);
        });
        deletedFetchers.forEach((key)=>fetcherData.current.delete(key));
        let isViewTransitionUnavailable = router.window == null || router.window.document == null || typeof router.window.document.startViewTransition !== "function";
        // If this isn't a view transition or it's not available in this browser,
        // just update and be done with it
        if (!viewTransitionOpts || isViewTransitionUnavailable) {
            if (flushSync) $8384e1b28fff68bc$var$flushSyncSafe(()=>setStateImpl(newState));
            else optInStartTransition(()=>setStateImpl(newState));
            return;
        }
        // flushSync + startViewTransition
        if (flushSync) {
            // Flush through the context to mark DOM elements as transition=ing
            $8384e1b28fff68bc$var$flushSyncSafe(()=>{
                // Cancel any pending transitions
                if (transition) {
                    renderDfd && renderDfd.resolve();
                    transition.skipTransition();
                }
                setVtContext({
                    isTransitioning: true,
                    flushSync: true,
                    currentLocation: viewTransitionOpts.currentLocation,
                    nextLocation: viewTransitionOpts.nextLocation
                });
            });
            // Update the DOM
            let t = router.window.document.startViewTransition(()=>{
                $8384e1b28fff68bc$var$flushSyncSafe(()=>setStateImpl(newState));
            });
            // Clean up after the animation completes
            t.finished.finally(()=>{
                $8384e1b28fff68bc$var$flushSyncSafe(()=>{
                    setRenderDfd(undefined);
                    setTransition(undefined);
                    setPendingState(undefined);
                    setVtContext({
                        isTransitioning: false
                    });
                });
            });
            $8384e1b28fff68bc$var$flushSyncSafe(()=>setTransition(t));
            return;
        }
        // startTransition + startViewTransition
        if (transition) {
            // Interrupting an in-progress transition, cancel and let everything flush
            // out, and then kick off a new transition from the interruption state
            renderDfd && renderDfd.resolve();
            transition.skipTransition();
            setInterruption({
                state: newState,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        } else {
            // Completed navigation update with opted-in view transitions, let 'er rip
            setPendingState(newState);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        }
    }, [
        router.window,
        transition,
        renderDfd,
        fetcherData,
        optInStartTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    $gJYWc.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    // When we start a view transition, create a Deferred we can use for the
    // eventual "completed" render
    $gJYWc.useEffect(()=>{
        if (vtContext.isTransitioning && !vtContext.flushSync) setRenderDfd(new $8384e1b28fff68bc$var$Deferred());
    }, [
        vtContext
    ]);
    // Once the deferred is created, kick off startViewTransition() to update the
    // DOM and then wait on the Deferred to resolve (indicating the DOM update has
    // happened)
    $gJYWc.useEffect(()=>{
        if (renderDfd && pendingState && router.window) {
            let newState = pendingState;
            let renderPromise = renderDfd.promise;
            let transition = router.window.document.startViewTransition(async ()=>{
                optInStartTransition(()=>setStateImpl(newState));
                await renderPromise;
            });
            transition.finished.finally(()=>{
                setRenderDfd(undefined);
                setTransition(undefined);
                setPendingState(undefined);
                setVtContext({
                    isTransitioning: false
                });
            });
            setTransition(transition);
        }
    }, [
        optInStartTransition,
        pendingState,
        renderDfd,
        router.window
    ]);
    // When the new location finally renders and is committed to the DOM, this
    // effect will run to resolve the transition
    $gJYWc.useEffect(()=>{
        if (renderDfd && pendingState && state.location.key === pendingState.location.key) renderDfd.resolve();
    }, [
        renderDfd,
        transition,
        state.location,
        pendingState
    ]);
    // If we get interrupted with a new navigation during a transition, we skip
    // the active transition, let it cleanup, then kick it off again here
    $gJYWc.useEffect(()=>{
        if (!vtContext.isTransitioning && interruption) {
            setPendingState(interruption.state);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: interruption.currentLocation,
                nextLocation: interruption.nextLocation
            });
            setInterruption(undefined);
        }
    }, [
        vtContext.isTransitioning,
        interruption
    ]);
    $gJYWc.useEffect(()=>{
    // Only log this once on initial mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    let navigator = $gJYWc.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $gJYWc.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        }), [
        router,
        navigator,
        basename
    ]);
    let routerFuture = $gJYWc.useMemo(()=>({
            v7_relativeSplatPath: router.future.v7_relativeSplatPath
        }), [
        router.future.v7_relativeSplatPath
    ]);
    $gJYWc.useEffect(()=>(0, $a35327dc535bf969$export$db5148ec97d6af7a)(future, router.future), [
        future,
        router.future
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $gJYWc.createElement($gJYWc.Fragment, null, /*#__PURE__*/ $gJYWc.createElement((0, $a35327dc535bf969$export$3add0d5dce533e2e).Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $gJYWc.createElement((0, $a35327dc535bf969$export$145dfa71566a64dc).Provider, {
        value: state
    }, /*#__PURE__*/ $gJYWc.createElement($8384e1b28fff68bc$export$148fd98d095596d4.Provider, {
        value: fetcherData.current
    }, /*#__PURE__*/ $gJYWc.createElement($8384e1b28fff68bc$export$7ad602f0e94e62d1.Provider, {
        value: vtContext
    }, /*#__PURE__*/ $gJYWc.createElement((0, $a35327dc535bf969$export$55185c17a0fcbe46), {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        future: routerFuture
    }, state.initialized || router.future.v7_partialHydration ? /*#__PURE__*/ $gJYWc.createElement($8384e1b28fff68bc$var$MemoizedDataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state
    }) : fallbackElement))))), null);
}
// Memoize to avoid re-renders when updating `ViewTransitionContext`
const $8384e1b28fff68bc$var$MemoizedDataRoutes = /*#__PURE__*/ $gJYWc.memo($8384e1b28fff68bc$var$DataRoutes);
function $8384e1b28fff68bc$var$DataRoutes(_ref3) {
    let { routes: routes, future: future, state: state } = _ref3;
    return (0, $a35327dc535bf969$export$5fcee62552a12fbf)(routes, undefined, state, future);
}
/**
 * A `<Router>` for use in web browsers. Provides the cleanest URLs.
 */ function $8384e1b28fff68bc$export$9ba4e89fdfa1fc54(_ref4) {
    let { basename: basename, children: children, future: future, window: window1 } = _ref4;
    let historyRef = $gJYWc.useRef();
    if (historyRef.current == null) historyRef.current = (0, $ed8eb2d58084204c$export$719fc203c4e16dee)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $gJYWc.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $gJYWc.useCallback((newState)=>{
        v7_startTransition && $8384e1b28fff68bc$var$startTransitionImpl ? $8384e1b28fff68bc$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $gJYWc.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    $gJYWc.useEffect(()=>(0, $a35327dc535bf969$export$db5148ec97d6af7a)(future), [
        future
    ]);
    return /*#__PURE__*/ $gJYWc.createElement((0, $a35327dc535bf969$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * A `<Router>` for use in web browsers. Stores the location in the hash
 * portion of the URL so it is not sent to the server.
 */ function $8384e1b28fff68bc$export$7221d69dcfc8e36b(_ref5) {
    let { basename: basename, children: children, future: future, window: window1 } = _ref5;
    let historyRef = $gJYWc.useRef();
    if (historyRef.current == null) historyRef.current = (0, $ed8eb2d58084204c$export$b71fdd3798280242)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $gJYWc.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $gJYWc.useCallback((newState)=>{
        v7_startTransition && $8384e1b28fff68bc$var$startTransitionImpl ? $8384e1b28fff68bc$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $gJYWc.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    $gJYWc.useEffect(()=>(0, $a35327dc535bf969$export$db5148ec97d6af7a)(future), [
        future
    ]);
    return /*#__PURE__*/ $gJYWc.createElement((0, $a35327dc535bf969$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * A `<Router>` that accepts a pre-instantiated history object. It's important
 * to note that using your own history object is highly discouraged and may add
 * two versions of the history library to your bundles unless you use the same
 * version of the history library that React Router uses internally.
 */ function $8384e1b28fff68bc$export$eefb0c834599897e(_ref6) {
    let { basename: basename, children: children, future: future, history: history } = _ref6;
    let [state, setStateImpl] = $gJYWc.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $gJYWc.useCallback((newState)=>{
        v7_startTransition && $8384e1b28fff68bc$var$startTransitionImpl ? $8384e1b28fff68bc$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $gJYWc.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    $gJYWc.useEffect(()=>(0, $a35327dc535bf969$export$db5148ec97d6af7a)(future), [
        future
    ]);
    return /*#__PURE__*/ $gJYWc.createElement((0, $a35327dc535bf969$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
const $8384e1b28fff68bc$var$isBrowser = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined";
const $8384e1b28fff68bc$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
/**
 * The public API for rendering a history-aware `<a>`.
 */ const $8384e1b28fff68bc$export$a6c7ac8248d6e38a = /*#__PURE__*/ $gJYWc.forwardRef(function LinkWithRef(_ref7, ref) {
    let { onClick: onClick, relative: relative, reloadDocument: reloadDocument, replace: replace, state: state, target: target, to: to, preventScrollReset: preventScrollReset, viewTransition: viewTransition } = _ref7, rest = $8384e1b28fff68bc$var$_objectWithoutPropertiesLoose(_ref7, $8384e1b28fff68bc$var$_excluded);
    let { basename: basename } = $gJYWc.useContext((0, $a35327dc535bf969$export$26749e8557646306));
    // Rendered into <a href> for absolute URLs
    let absoluteHref;
    let isExternal = false;
    if (typeof to === "string" && $8384e1b28fff68bc$var$ABSOLUTE_URL_REGEX.test(to)) {
        // Render the absolute href server- and client-side
        absoluteHref = to;
        // Only check for external origins client-side
        if ($8384e1b28fff68bc$var$isBrowser) try {
            let currentUrl = new URL(window.location.href);
            let targetUrl = to.startsWith("//") ? new URL(currentUrl.protocol + to) : new URL(to);
            let path = (0, $ed8eb2d58084204c$export$b69e3301ce081aa3)(targetUrl.pathname, basename);
            if (targetUrl.origin === currentUrl.origin && path != null) // Strip the protocol/origin/basename for same-origin absolute URLs
            to = path + targetUrl.search + targetUrl.hash;
            else isExternal = true;
        } catch (e) {}
    }
    // Rendered into <a href> for relative URLs
    let href = (0, $a35327dc535bf969$export$b66bb29c5006f12f)(to, {
        relative: relative
    });
    let internalOnClick = $8384e1b28fff68bc$export$67621102c14d847(to, {
        replace: replace,
        state: state,
        target: target,
        preventScrollReset: preventScrollReset,
        relative: relative,
        viewTransition: viewTransition
    });
    function handleClick(event) {
        if (onClick) onClick(event);
        if (!event.defaultPrevented) internalOnClick(event);
    }
    return(/*#__PURE__*/ // eslint-disable-next-line jsx-a11y/anchor-has-content
    $gJYWc.createElement("a", $8384e1b28fff68bc$var$_extends({}, rest, {
        href: absoluteHref || href,
        onClick: isExternal || reloadDocument ? onClick : handleClick,
        ref: ref,
        target: target
    })));
});
/**
 * A `<Link>` wrapper that knows if it's "active" or not.
 */ const $8384e1b28fff68bc$export$b0d92dbee9b5b60d = /*#__PURE__*/ $gJYWc.forwardRef(function NavLinkWithRef(_ref8, ref) {
    let { "aria-current": ariaCurrentProp = "page", caseSensitive: caseSensitive = false, className: classNameProp = "", end: end = false, style: styleProp, to: to, viewTransition: viewTransition, children: children } = _ref8, rest = $8384e1b28fff68bc$var$_objectWithoutPropertiesLoose(_ref8, $8384e1b28fff68bc$var$_excluded2);
    let path = (0, $a35327dc535bf969$export$e75d2a2d1b3c245b)(to, {
        relative: rest.relative
    });
    let location = (0, $a35327dc535bf969$export$45d76561a5302f2b)();
    let routerState = $gJYWc.useContext((0, $a35327dc535bf969$export$145dfa71566a64dc));
    let { navigator: navigator, basename: basename } = $gJYWc.useContext((0, $a35327dc535bf969$export$26749e8557646306));
    let isTransitioning = routerState != null && // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $8384e1b28fff68bc$export$e262bd1977bea848(path) && viewTransition === true;
    let toPathname = navigator.encodeLocation ? navigator.encodeLocation(path).pathname : path.pathname;
    let locationPathname = location.pathname;
    let nextLocationPathname = routerState && routerState.navigation && routerState.navigation.location ? routerState.navigation.location.pathname : null;
    if (!caseSensitive) {
        locationPathname = locationPathname.toLowerCase();
        nextLocationPathname = nextLocationPathname ? nextLocationPathname.toLowerCase() : null;
        toPathname = toPathname.toLowerCase();
    }
    if (nextLocationPathname && basename) nextLocationPathname = (0, $ed8eb2d58084204c$export$b69e3301ce081aa3)(nextLocationPathname, basename) || nextLocationPathname;
    // If the `to` has a trailing slash, look at that exact spot.  Otherwise,
    // we're looking for a slash _after_ what's in `to`.  For example:
    //
    // <NavLink to="/users"> and <NavLink to="/users/">
    // both want to look for a / at index 6 to match URL `/users/matt`
    const endSlashPosition = toPathname !== "/" && toPathname.endsWith("/") ? toPathname.length - 1 : toPathname.length;
    let isActive = locationPathname === toPathname || !end && locationPathname.startsWith(toPathname) && locationPathname.charAt(endSlashPosition) === "/";
    let isPending = nextLocationPathname != null && (nextLocationPathname === toPathname || !end && nextLocationPathname.startsWith(toPathname) && nextLocationPathname.charAt(toPathname.length) === "/");
    let renderProps = {
        isActive: isActive,
        isPending: isPending,
        isTransitioning: isTransitioning
    };
    let ariaCurrent = isActive ? ariaCurrentProp : undefined;
    let className;
    if (typeof classNameProp === "function") className = classNameProp(renderProps);
    else // If the className prop is not a function, we use a default `active`
    // class for <NavLink />s that are active. In v5 `active` was the default
    // value for `activeClassName`, but we are removing that API and can still
    // use the old default behavior for a cleaner upgrade path and keep the
    // simple styling rules working as they currently do.
    className = [
        classNameProp,
        isActive ? "active" : null,
        isPending ? "pending" : null,
        isTransitioning ? "transitioning" : null
    ].filter(Boolean).join(" ");
    let style = typeof styleProp === "function" ? styleProp(renderProps) : styleProp;
    return /*#__PURE__*/ $gJYWc.createElement($8384e1b28fff68bc$export$a6c7ac8248d6e38a, $8384e1b28fff68bc$var$_extends({}, rest, {
        "aria-current": ariaCurrent,
        className: className,
        ref: ref,
        style: style,
        to: to,
        viewTransition: viewTransition
    }), typeof children === "function" ? children(renderProps) : children);
});
/**
 * A `@remix-run/router`-aware `<form>`. It behaves like a normal form except
 * that the interaction with the server is with `fetch` instead of new document
 * requests, allowing components to add nicer UX to the page as the form is
 * submitted and returns with data.
 */ const $8384e1b28fff68bc$export$a7fed597f4b8afd8 = /*#__PURE__*/ $gJYWc.forwardRef((_ref9, forwardedRef)=>{
    let { fetcherKey: fetcherKey, navigate: navigate, reloadDocument: reloadDocument, replace: replace, state: state, method: method = $8384e1b28fff68bc$var$defaultMethod, action: action, onSubmit: onSubmit, relative: relative, preventScrollReset: preventScrollReset, viewTransition: viewTransition } = _ref9, props = $8384e1b28fff68bc$var$_objectWithoutPropertiesLoose(_ref9, $8384e1b28fff68bc$var$_excluded3);
    let submit = $8384e1b28fff68bc$export$47c85c6e3a081d3();
    let formAction = $8384e1b28fff68bc$export$89a6bd6db0d97c56(action, {
        relative: relative
    });
    let formMethod = method.toLowerCase() === "get" ? "get" : "post";
    let submitHandler = (event)=>{
        onSubmit && onSubmit(event);
        if (event.defaultPrevented) return;
        event.preventDefault();
        let submitter = event.nativeEvent.submitter;
        let submitMethod = (submitter == null ? void 0 : submitter.getAttribute("formmethod")) || method;
        submit(submitter || event.currentTarget, {
            fetcherKey: fetcherKey,
            method: submitMethod,
            navigate: navigate,
            replace: replace,
            state: state,
            relative: relative,
            preventScrollReset: preventScrollReset,
            viewTransition: viewTransition
        });
    };
    return /*#__PURE__*/ $gJYWc.createElement("form", $8384e1b28fff68bc$var$_extends({
        ref: forwardedRef,
        method: formMethod,
        action: formAction,
        onSubmit: reloadDocument ? onSubmit : submitHandler
    }, props));
});
/**
 * This component will emulate the browser's scroll restoration on location
 * changes.
 */ function $8384e1b28fff68bc$export$11aac1aab828f1fa(_ref10) {
    let { getKey: getKey, storageKey: storageKey } = _ref10;
    $8384e1b28fff68bc$export$25057cfe5591e3e9({
        getKey: getKey,
        storageKey: storageKey
    });
    return null;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Hooks
////////////////////////////////////////////////////////////////////////////////
var $8384e1b28fff68bc$var$DataRouterHook;
(function(DataRouterHook) {
    DataRouterHook["UseScrollRestoration"] = "useScrollRestoration";
    DataRouterHook["UseSubmit"] = "useSubmit";
    DataRouterHook["UseSubmitFetcher"] = "useSubmitFetcher";
    DataRouterHook["UseFetcher"] = "useFetcher";
    DataRouterHook["useViewTransitionState"] = "useViewTransitionState";
})($8384e1b28fff68bc$var$DataRouterHook || ($8384e1b28fff68bc$var$DataRouterHook = {}));
var $8384e1b28fff68bc$var$DataRouterStateHook;
(function(DataRouterStateHook) {
    DataRouterStateHook["UseFetcher"] = "useFetcher";
    DataRouterStateHook["UseFetchers"] = "useFetchers";
    DataRouterStateHook["UseScrollRestoration"] = "useScrollRestoration";
})($8384e1b28fff68bc$var$DataRouterStateHook || ($8384e1b28fff68bc$var$DataRouterStateHook = {}));
// Internal hooks
function $8384e1b28fff68bc$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/v6/routers/picking-a-router.";
}
function $8384e1b28fff68bc$var$useDataRouterContext(hookName) {
    let ctx = $gJYWc.useContext((0, $a35327dc535bf969$export$3add0d5dce533e2e));
    !ctx && (0, $ed8eb2d58084204c$export$3e9cee6b33872309)(false);
    return ctx;
}
function $8384e1b28fff68bc$var$useDataRouterState(hookName) {
    let state = $gJYWc.useContext((0, $a35327dc535bf969$export$145dfa71566a64dc));
    !state && (0, $ed8eb2d58084204c$export$3e9cee6b33872309)(false);
    return state;
}
// External hooks
/**
 * Handles the click behavior for router `<Link>` components. This is useful if
 * you need to create custom `<Link>` components with the same click behavior we
 * use in our exported `<Link>`.
 */ function $8384e1b28fff68bc$export$67621102c14d847(to, _temp) {
    let { target: target, replace: replaceProp, state: state, preventScrollReset: preventScrollReset, relative: relative, viewTransition: viewTransition } = _temp === void 0 ? {} : _temp;
    let navigate = (0, $a35327dc535bf969$export$9770f232ac06a008)();
    let location = (0, $a35327dc535bf969$export$45d76561a5302f2b)();
    let path = (0, $a35327dc535bf969$export$e75d2a2d1b3c245b)(to, {
        relative: relative
    });
    return $gJYWc.useCallback((event)=>{
        if ($8384e1b28fff68bc$var$shouldProcessLinkClick(event, target)) {
            event.preventDefault();
            // If the URL hasn't changed, a regular <a> will do a replace instead of
            // a push, so do the same here unless the replace prop is explicitly set
            let replace = replaceProp !== undefined ? replaceProp : (0, $ed8eb2d58084204c$export$fe53371bee54353d)(location) === (0, $ed8eb2d58084204c$export$fe53371bee54353d)(path);
            navigate(to, {
                replace: replace,
                state: state,
                preventScrollReset: preventScrollReset,
                relative: relative,
                viewTransition: viewTransition
            });
        }
    }, [
        location,
        navigate,
        path,
        replaceProp,
        state,
        target,
        to,
        preventScrollReset,
        relative,
        viewTransition
    ]);
}
/**
 * A convenient wrapper for reading and writing search parameters via the
 * URLSearchParams interface.
 */ function $8384e1b28fff68bc$export$f1a78c17382fe22a(defaultInit) {
    let defaultSearchParamsRef = $gJYWc.useRef($8384e1b28fff68bc$export$a2e4e2dcc7b1f22f(defaultInit));
    let hasSetSearchParamsRef = $gJYWc.useRef(false);
    let location = (0, $a35327dc535bf969$export$45d76561a5302f2b)();
    let searchParams = $gJYWc.useMemo(()=>// Only merge in the defaults if we haven't yet called setSearchParams.
        // Once we call that we want those to take precedence, otherwise you can't
        // remove a param with setSearchParams({}) if it has an initial value
        $8384e1b28fff68bc$var$getSearchParamsForLocation(location.search, hasSetSearchParamsRef.current ? null : defaultSearchParamsRef.current), [
        location.search
    ]);
    let navigate = (0, $a35327dc535bf969$export$9770f232ac06a008)();
    let setSearchParams = $gJYWc.useCallback((nextInit, navigateOptions)=>{
        const newSearchParams = $8384e1b28fff68bc$export$a2e4e2dcc7b1f22f(typeof nextInit === "function" ? nextInit(searchParams) : nextInit);
        hasSetSearchParamsRef.current = true;
        navigate("?" + newSearchParams, navigateOptions);
    }, [
        navigate,
        searchParams
    ]);
    return [
        searchParams,
        setSearchParams
    ];
}
function $8384e1b28fff68bc$var$validateClientSideSubmission() {
    if (typeof document === "undefined") throw new Error("You are calling submit during the server render. Try calling submit within a `useEffect` or callback instead.");
}
let $8384e1b28fff68bc$var$fetcherId = 0;
let $8384e1b28fff68bc$var$getUniqueFetcherId = ()=>"__" + String(++$8384e1b28fff68bc$var$fetcherId) + "__";
/**
 * Returns a function that may be used to programmatically submit a form (or
 * some arbitrary data) to the server.
 */ function $8384e1b28fff68bc$export$47c85c6e3a081d3() {
    let { router: router } = $8384e1b28fff68bc$var$useDataRouterContext($8384e1b28fff68bc$var$DataRouterHook.UseSubmit);
    let { basename: basename } = $gJYWc.useContext((0, $a35327dc535bf969$export$26749e8557646306));
    let currentRouteId = (0, $a35327dc535bf969$export$5fc8298006ad9e58)();
    return $gJYWc.useCallback(function(target, options) {
        if (options === void 0) options = {};
        $8384e1b28fff68bc$var$validateClientSideSubmission();
        let { action: action, method: method, encType: encType, formData: formData, body: body } = $8384e1b28fff68bc$var$getFormSubmissionInfo(target, basename);
        if (options.navigate === false) {
            let key = options.fetcherKey || $8384e1b28fff68bc$var$getUniqueFetcherId();
            router.fetch(key, currentRouteId, options.action || action, {
                preventScrollReset: options.preventScrollReset,
                formData: formData,
                body: body,
                formMethod: options.method || method,
                formEncType: options.encType || encType,
                flushSync: options.flushSync
            });
        } else router.navigate(options.action || action, {
            preventScrollReset: options.preventScrollReset,
            formData: formData,
            body: body,
            formMethod: options.method || method,
            formEncType: options.encType || encType,
            replace: options.replace,
            state: options.state,
            fromRouteId: currentRouteId,
            flushSync: options.flushSync,
            viewTransition: options.viewTransition
        });
    }, [
        router,
        basename,
        currentRouteId
    ]);
}
// v7: Eventually we should deprecate this entirely in favor of using the
// router method directly?
function $8384e1b28fff68bc$export$89a6bd6db0d97c56(action, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { basename: basename } = $gJYWc.useContext((0, $a35327dc535bf969$export$26749e8557646306));
    let routeContext = $gJYWc.useContext((0, $a35327dc535bf969$export$9072aa6dd1f93057));
    !routeContext && (0, $ed8eb2d58084204c$export$3e9cee6b33872309)(false);
    let [match] = routeContext.matches.slice(-1);
    // Shallow clone path so we can modify it below, otherwise we modify the
    // object referenced by useMemo inside useResolvedPath
    let path = $8384e1b28fff68bc$var$_extends({}, (0, $a35327dc535bf969$export$e75d2a2d1b3c245b)(action ? action : ".", {
        relative: relative
    }));
    // If no action was specified, browsers will persist current search params
    // when determining the path, so match that behavior
    // https://github.com/remix-run/remix/issues/927
    let location = (0, $a35327dc535bf969$export$45d76561a5302f2b)();
    if (action == null) {
        // Safe to write to this directly here since if action was undefined, we
        // would have called useResolvedPath(".") which will never include a search
        path.search = location.search;
        // When grabbing search params from the URL, remove any included ?index param
        // since it might not apply to our contextual route.  We add it back based
        // on match.route.index below
        let params = new URLSearchParams(path.search);
        let indexValues = params.getAll("index");
        let hasNakedIndexParam = indexValues.some((v)=>v === "");
        if (hasNakedIndexParam) {
            params.delete("index");
            indexValues.filter((v)=>v).forEach((v)=>params.append("index", v));
            let qs = params.toString();
            path.search = qs ? "?" + qs : "";
        }
    }
    if ((!action || action === ".") && match.route.index) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the form action.  If this is a root navigation, then just use
    // the raw basename which allows the basename to have full control over the
    // presence of a trailing slash on root actions
    if (basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $ed8eb2d58084204c$export$86d9a7913e44197e)([
        basename,
        path.pathname
    ]);
    return (0, $ed8eb2d58084204c$export$fe53371bee54353d)(path);
}
// TODO: (v7) Change the useFetcher generic default from `any` to `unknown`
/**
 * Interacts with route loaders and actions without causing a navigation. Great
 * for any interaction that stays on the same page.
 */ function $8384e1b28fff68bc$export$5b0d2d9a9921565a(_temp3) {
    var _route$matches;
    let { key: key } = _temp3 === void 0 ? {} : _temp3;
    let { router: router } = $8384e1b28fff68bc$var$useDataRouterContext($8384e1b28fff68bc$var$DataRouterHook.UseFetcher);
    let state = $8384e1b28fff68bc$var$useDataRouterState($8384e1b28fff68bc$var$DataRouterStateHook.UseFetcher);
    let fetcherData = $gJYWc.useContext($8384e1b28fff68bc$export$148fd98d095596d4);
    let route = $gJYWc.useContext((0, $a35327dc535bf969$export$9072aa6dd1f93057));
    let routeId = (_route$matches = route.matches[route.matches.length - 1]) == null ? void 0 : _route$matches.route.id;
    !fetcherData && (0, $ed8eb2d58084204c$export$3e9cee6b33872309)(false);
    !route && (0, $ed8eb2d58084204c$export$3e9cee6b33872309)(false);
    !(routeId != null) && (0, $ed8eb2d58084204c$export$3e9cee6b33872309)(false);
    // Fetcher key handling
    // OK to call conditionally to feature detect `useId`
    // eslint-disable-next-line react-hooks/rules-of-hooks
    let defaultKey = $8384e1b28fff68bc$var$useIdImpl ? $8384e1b28fff68bc$var$useIdImpl() : "";
    let [fetcherKey, setFetcherKey] = $gJYWc.useState(key || defaultKey);
    if (key && key !== fetcherKey) setFetcherKey(key);
    else if (!fetcherKey) // We will only fall through here when `useId` is not available
    setFetcherKey($8384e1b28fff68bc$var$getUniqueFetcherId());
    // Registration/cleanup
    $gJYWc.useEffect(()=>{
        router.getFetcher(fetcherKey);
        return ()=>{
            // Tell the router we've unmounted - if v7_fetcherPersist is enabled this
            // will not delete immediately but instead queue up a delete after the
            // fetcher returns to an `idle` state
            router.deleteFetcher(fetcherKey);
        };
    }, [
        router,
        fetcherKey
    ]);
    // Fetcher additions
    let load = $gJYWc.useCallback((href, opts)=>{
        !routeId && (0, $ed8eb2d58084204c$export$3e9cee6b33872309)(false);
        router.fetch(fetcherKey, routeId, href, opts);
    }, [
        fetcherKey,
        routeId,
        router
    ]);
    let submitImpl = $8384e1b28fff68bc$export$47c85c6e3a081d3();
    let submit = $gJYWc.useCallback((target, opts)=>{
        submitImpl(target, $8384e1b28fff68bc$var$_extends({}, opts, {
            navigate: false,
            fetcherKey: fetcherKey
        }));
    }, [
        fetcherKey,
        submitImpl
    ]);
    let FetcherForm = $gJYWc.useMemo(()=>{
        let FetcherForm = /*#__PURE__*/ $gJYWc.forwardRef((props, ref)=>{
            return /*#__PURE__*/ $gJYWc.createElement($8384e1b28fff68bc$export$a7fed597f4b8afd8, $8384e1b28fff68bc$var$_extends({}, props, {
                navigate: false,
                fetcherKey: fetcherKey,
                ref: ref
            }));
        });
        return FetcherForm;
    }, [
        fetcherKey
    ]);
    // Exposed FetcherWithComponents
    let fetcher = state.fetchers.get(fetcherKey) || (0, $ed8eb2d58084204c$export$52eace9c284d3585);
    let data = fetcherData.get(fetcherKey);
    let fetcherWithComponents = $gJYWc.useMemo(()=>$8384e1b28fff68bc$var$_extends({
            Form: FetcherForm,
            submit: submit,
            load: load
        }, fetcher, {
            data: data
        }), [
        FetcherForm,
        submit,
        load,
        fetcher,
        data
    ]);
    return fetcherWithComponents;
}
/**
 * Provides all fetchers currently on the page. Useful for layouts and parent
 * routes that need to provide pending/optimistic UI regarding the fetch.
 */ function $8384e1b28fff68bc$export$fa996778a3a31087() {
    let state = $8384e1b28fff68bc$var$useDataRouterState($8384e1b28fff68bc$var$DataRouterStateHook.UseFetchers);
    return Array.from(state.fetchers.entries()).map((_ref11)=>{
        let [key, fetcher] = _ref11;
        return $8384e1b28fff68bc$var$_extends({}, fetcher, {
            key: key
        });
    });
}
const $8384e1b28fff68bc$var$SCROLL_RESTORATION_STORAGE_KEY = "react-router-scroll-positions";
let $8384e1b28fff68bc$var$savedScrollPositions = {};
/**
 * When rendered inside a RouterProvider, will restore scroll positions on navigations
 */ function $8384e1b28fff68bc$export$25057cfe5591e3e9(_temp4) {
    let { getKey: getKey, storageKey: storageKey } = _temp4 === void 0 ? {} : _temp4;
    let { router: router } = $8384e1b28fff68bc$var$useDataRouterContext($8384e1b28fff68bc$var$DataRouterHook.UseScrollRestoration);
    let { restoreScrollPosition: restoreScrollPosition, preventScrollReset: preventScrollReset } = $8384e1b28fff68bc$var$useDataRouterState($8384e1b28fff68bc$var$DataRouterStateHook.UseScrollRestoration);
    let { basename: basename } = $gJYWc.useContext((0, $a35327dc535bf969$export$26749e8557646306));
    let location = (0, $a35327dc535bf969$export$45d76561a5302f2b)();
    let matches = (0, $a35327dc535bf969$export$2378eb7f5ff86053)();
    let navigation = (0, $a35327dc535bf969$export$d0fd4b7106de2769)();
    // Trigger manual scroll restoration while we're active
    $gJYWc.useEffect(()=>{
        window.history.scrollRestoration = "manual";
        return ()=>{
            window.history.scrollRestoration = "auto";
        };
    }, []);
    // Save positions on pagehide
    $8384e1b28fff68bc$var$usePageHide($gJYWc.useCallback(()=>{
        if (navigation.state === "idle") {
            let key = (getKey ? getKey(location, matches) : null) || location.key;
            $8384e1b28fff68bc$var$savedScrollPositions[key] = window.scrollY;
        }
        try {
            sessionStorage.setItem(storageKey || $8384e1b28fff68bc$var$SCROLL_RESTORATION_STORAGE_KEY, JSON.stringify($8384e1b28fff68bc$var$savedScrollPositions));
        } catch (error) {}
        window.history.scrollRestoration = "auto";
    }, [
        storageKey,
        getKey,
        navigation.state,
        location,
        matches
    ]));
    // Read in any saved scroll locations
    if (typeof document !== "undefined") {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $gJYWc.useLayoutEffect(()=>{
            try {
                let sessionPositions = sessionStorage.getItem(storageKey || $8384e1b28fff68bc$var$SCROLL_RESTORATION_STORAGE_KEY);
                if (sessionPositions) $8384e1b28fff68bc$var$savedScrollPositions = JSON.parse(sessionPositions);
            } catch (e) {
            // no-op, use default empty object
            }
        }, [
            storageKey
        ]);
        // Enable scroll restoration in the router
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $gJYWc.useLayoutEffect(()=>{
            let getKeyWithoutBasename = getKey && basename !== "/" ? (location, matches)=>getKey($8384e1b28fff68bc$var$_extends({}, location, {
                    pathname: (0, $ed8eb2d58084204c$export$b69e3301ce081aa3)(location.pathname, basename) || location.pathname
                }), matches) : getKey;
            let disableScrollRestoration = router == null ? void 0 : router.enableScrollRestoration($8384e1b28fff68bc$var$savedScrollPositions, ()=>window.scrollY, getKeyWithoutBasename);
            return ()=>disableScrollRestoration && disableScrollRestoration();
        }, [
            router,
            basename,
            getKey
        ]);
        // Restore scrolling when state.restoreScrollPosition changes
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $gJYWc.useLayoutEffect(()=>{
            // Explicit false means don't do anything (used for submissions)
            if (restoreScrollPosition === false) return;
            // been here before, scroll to it
            if (typeof restoreScrollPosition === "number") {
                window.scrollTo(0, restoreScrollPosition);
                return;
            }
            // try to scroll to the hash
            if (location.hash) {
                let el = document.getElementById(decodeURIComponent(location.hash.slice(1)));
                if (el) {
                    el.scrollIntoView();
                    return;
                }
            }
            // Don't reset if this navigation opted out
            if (preventScrollReset === true) return;
            // otherwise go to the top on new locations
            window.scrollTo(0, 0);
        }, [
            location,
            restoreScrollPosition,
            preventScrollReset
        ]);
    }
}
/**
 * Setup a callback to be fired on the window's `beforeunload` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $8384e1b28fff68bc$export$c0a586b329cae57d(callback, options) {
    let { capture: capture } = options || {};
    $gJYWc.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("beforeunload", callback, opts);
        return ()=>{
            window.removeEventListener("beforeunload", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Setup a callback to be fired on the window's `pagehide` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.  This event is better supported than beforeunload across browsers.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $8384e1b28fff68bc$var$usePageHide(callback, options) {
    let { capture: capture } = options || {};
    $gJYWc.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("pagehide", callback, opts);
        return ()=>{
            window.removeEventListener("pagehide", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Wrapper around useBlocker to show a window.confirm prompt to users instead
 * of building a custom UI with useBlocker.
 *
 * Warning: This has *a lot of rough edges* and behaves very differently (and
 * very incorrectly in some cases) across browsers if user click addition
 * back/forward navigations while the confirm is open.  Use at your own risk.
 */ function $8384e1b28fff68bc$export$39f4eb3dbd812741(_ref12) {
    let { when: when, message: message } = _ref12;
    let blocker = (0, $a35327dc535bf969$export$b273b3273281a049)(when);
    $gJYWc.useEffect(()=>{
        if (blocker.state === "blocked") {
            let proceed = window.confirm(message);
            if (proceed) // This timeout is needed to avoid a weird "race" on POP navigations
            // between the `window.history` revert navigation and the result of
            // `window.confirm`
            setTimeout(blocker.proceed, 0);
            else blocker.reset();
        }
    }, [
        blocker,
        message
    ]);
    $gJYWc.useEffect(()=>{
        if (blocker.state === "blocked" && !when) blocker.reset();
    }, [
        blocker,
        when
    ]);
}
/**
 * Return a boolean indicating if there is an active view transition to the
 * given href.  You can use this value to render CSS classes or viewTransitionName
 * styles onto your elements
 *
 * @param href The destination href
 * @param [opts.relative] Relative routing type ("route" | "path")
 */ function $8384e1b28fff68bc$export$e262bd1977bea848(to, opts) {
    if (opts === void 0) opts = {};
    let vtContext = $gJYWc.useContext($8384e1b28fff68bc$export$7ad602f0e94e62d1);
    !(vtContext != null) && (0, $ed8eb2d58084204c$export$3e9cee6b33872309)(false);
    let { basename: basename } = $8384e1b28fff68bc$var$useDataRouterContext($8384e1b28fff68bc$var$DataRouterHook.useViewTransitionState);
    let path = (0, $a35327dc535bf969$export$e75d2a2d1b3c245b)(to, {
        relative: opts.relative
    });
    if (!vtContext.isTransitioning) return false;
    let currentPath = (0, $ed8eb2d58084204c$export$b69e3301ce081aa3)(vtContext.currentLocation.pathname, basename) || vtContext.currentLocation.pathname;
    let nextPath = (0, $ed8eb2d58084204c$export$b69e3301ce081aa3)(vtContext.nextLocation.pathname, basename) || vtContext.nextLocation.pathname;
    // Transition is active if we're going to or coming from the indicated
    // destination.  This ensures that other PUSH navigations that reverse
    // an indicated transition apply.  I.e., on the list view you have:
    //
    //   <NavLink to="/details/1" viewTransition>
    //
    // If you click the breadcrumb back to the list view:
    //
    //   <NavLink to="/list" viewTransition>
    //
    // We should apply the transition because it's indicated as active going
    // from /list -> /details/1 and therefore should be active on the reverse
    // (even though this isn't strictly a POP reverse)
    return (0, $ed8eb2d58084204c$export$81336c211d5ff295)(path.pathname, nextPath) != null || (0, $ed8eb2d58084204c$export$81336c211d5ff295)(path.pathname, currentPath) != null;
}



var $9wx12 = parcelRequire("9wx12");
parcelRequire("gJYWc");

var $9wx12 = parcelRequire("9wx12");
parcelRequire("gJYWc");

var $3VnFq = parcelRequire("3VnFq");

var $cTAWX = parcelRequire("cTAWX");

var $gJYWc = parcelRequire("gJYWc");


var $2w6IV = parcelRequire("2w6IV");

var $3e4LV = parcelRequire("3e4LV");

var $8pLcn = parcelRequire("8pLcn");

var $HGmne = parcelRequire("HGmne");

var $i8nzj = parcelRequire("i8nzj");

var $1kRHf = parcelRequire("1kRHf");
function $e06fdfa8203247d2$export$ee5828fb8c43a48e(slot) {
    return (0, $1kRHf.default)('MuiCardActionArea', slot);
}
const $e06fdfa8203247d2$var$cardActionAreaClasses = (0, $i8nzj.default)('MuiCardActionArea', [
    'root',
    'focusVisible',
    'focusHighlight'
]);
var $e06fdfa8203247d2$export$2e2bcd8739ae039 = $e06fdfa8203247d2$var$cardActionAreaClasses;



var $fNSZE = parcelRequire("fNSZE");

var $9wx12 = parcelRequire("9wx12");
'use client';
const $7fd75e6b57001627$var$_excluded = [
    "children",
    "className",
    "focusVisibleClassName"
];
const $7fd75e6b57001627$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ],
        focusHighlight: [
            'focusHighlight'
        ]
    };
    return (0, $3e4LV.default)(slots, (0, $e06fdfa8203247d2$export$ee5828fb8c43a48e), classes);
};
const $7fd75e6b57001627$var$CardActionAreaRoot = (0, $HGmne.default)((0, $fNSZE.default), {
    name: 'MuiCardActionArea',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})(({ theme: theme })=>({
        display: 'block',
        textAlign: 'inherit',
        borderRadius: 'inherit',
        // for Safari to work https://github.com/mui/material-ui/issues/36285.
        width: '100%',
        [`&:hover .${(0, $e06fdfa8203247d2$export$2e2bcd8739ae039).focusHighlight}`]: {
            opacity: (theme.vars || theme).palette.action.hoverOpacity,
            '@media (hover: none)': {
                opacity: 0
            }
        },
        [`&.${(0, $e06fdfa8203247d2$export$2e2bcd8739ae039).focusVisible} .${(0, $e06fdfa8203247d2$export$2e2bcd8739ae039).focusHighlight}`]: {
            opacity: (theme.vars || theme).palette.action.focusOpacity
        }
    }));
const $7fd75e6b57001627$var$CardActionAreaFocusHighlight = (0, $HGmne.default)('span', {
    name: 'MuiCardActionArea',
    slot: 'FocusHighlight',
    overridesResolver: (props, styles)=>styles.focusHighlight
})(({ theme: theme })=>({
        overflow: 'hidden',
        pointerEvents: 'none',
        position: 'absolute',
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
        borderRadius: 'inherit',
        opacity: 0,
        backgroundColor: 'currentcolor',
        transition: theme.transitions.create('opacity', {
            duration: theme.transitions.duration.short
        })
    }));
const $7fd75e6b57001627$var$CardActionArea = /*#__PURE__*/ $gJYWc.forwardRef(function CardActionArea(inProps, ref) {
    const props = (0, $8pLcn.useDefaultProps)({
        props: inProps,
        name: 'MuiCardActionArea'
    });
    const { children: children, className: className, focusVisibleClassName: focusVisibleClassName } = props, other = (0, $cTAWX.default)(props, $7fd75e6b57001627$var$_excluded);
    const ownerState = props;
    const classes = $7fd75e6b57001627$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $9wx12.jsxs)($7fd75e6b57001627$var$CardActionAreaRoot, (0, $3VnFq.default)({
        className: (0, $2w6IV.default)(classes.root, className),
        focusVisibleClassName: (0, $2w6IV.default)(focusVisibleClassName, classes.focusVisible),
        ref: ref,
        ownerState: ownerState
    }, other, {
        children: [
            children,
            /*#__PURE__*/ (0, $9wx12.jsx)($7fd75e6b57001627$var$CardActionAreaFocusHighlight, {
                className: classes.focusHighlight,
                ownerState: ownerState
            })
        ]
    }));
});
var $7fd75e6b57001627$export$2e2bcd8739ae039 = $7fd75e6b57001627$var$CardActionArea;


var $cTAWX = parcelRequire("cTAWX");

var $3VnFq = parcelRequire("3VnFq");

var $gJYWc = parcelRequire("gJYWc");


var $2w6IV = parcelRequire("2w6IV");


var $3e4LV = parcelRequire("3e4LV");

var $8pLcn = parcelRequire("8pLcn");

var $HGmne = parcelRequire("HGmne");

var $i8nzj = parcelRequire("i8nzj");

var $1kRHf = parcelRequire("1kRHf");
function $2865092e6461d173$export$5f5333fe417019a7(slot) {
    return (0, $1kRHf.default)('MuiCardMedia', slot);
}
const $2865092e6461d173$var$cardMediaClasses = (0, $i8nzj.default)('MuiCardMedia', [
    'root',
    'media',
    'img'
]);
var $2865092e6461d173$export$2e2bcd8739ae039 = $2865092e6461d173$var$cardMediaClasses;



var $9wx12 = parcelRequire("9wx12");
'use client';
const $7cffc73c3124b15c$var$_excluded = [
    "children",
    "className",
    "component",
    "image",
    "src",
    "style"
];
const $7cffc73c3124b15c$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, isMediaComponent: isMediaComponent, isImageComponent: isImageComponent } = ownerState;
    const slots = {
        root: [
            'root',
            isMediaComponent && 'media',
            isImageComponent && 'img'
        ]
    };
    return (0, $3e4LV.default)(slots, (0, $2865092e6461d173$export$5f5333fe417019a7), classes);
};
const $7cffc73c3124b15c$var$CardMediaRoot = (0, $HGmne.default)('div', {
    name: 'MuiCardMedia',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        const { isMediaComponent: isMediaComponent, isImageComponent: isImageComponent } = ownerState;
        return [
            styles.root,
            isMediaComponent && styles.media,
            isImageComponent && styles.img
        ];
    }
})(({ ownerState: ownerState })=>(0, $3VnFq.default)({
        display: 'block',
        backgroundSize: 'cover',
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center'
    }, ownerState.isMediaComponent && {
        width: '100%'
    }, ownerState.isImageComponent && {
        // ⚠️ object-fit is not supported by IE11.
        objectFit: 'cover'
    }));
const $7cffc73c3124b15c$var$MEDIA_COMPONENTS = [
    'video',
    'audio',
    'picture',
    'iframe',
    'img'
];
const $7cffc73c3124b15c$var$IMAGE_COMPONENTS = [
    'picture',
    'img'
];
const $7cffc73c3124b15c$var$CardMedia = /*#__PURE__*/ $gJYWc.forwardRef(function CardMedia(inProps, ref) {
    const props = (0, $8pLcn.useDefaultProps)({
        props: inProps,
        name: 'MuiCardMedia'
    });
    const { children: children, className: className, component: component = 'div', image: image, src: src, style: style } = props, other = (0, $cTAWX.default)(props, $7cffc73c3124b15c$var$_excluded);
    const isMediaComponent = $7cffc73c3124b15c$var$MEDIA_COMPONENTS.indexOf(component) !== -1;
    const composedStyle = !isMediaComponent && image ? (0, $3VnFq.default)({
        backgroundImage: `url("${image}")`
    }, style) : style;
    const ownerState = (0, $3VnFq.default)({}, props, {
        component: component,
        isMediaComponent: isMediaComponent,
        isImageComponent: $7cffc73c3124b15c$var$IMAGE_COMPONENTS.indexOf(component) !== -1
    });
    const classes = $7cffc73c3124b15c$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $9wx12.jsx)($7cffc73c3124b15c$var$CardMediaRoot, (0, $3VnFq.default)({
        className: (0, $2w6IV.default)(classes.root, className),
        as: component,
        role: !isMediaComponent && image ? 'img' : undefined,
        ref: ref,
        style: composedStyle,
        ownerState: ownerState,
        src: isMediaComponent ? image || src : undefined
    }, other, {
        children: children
    }));
});
var $7cffc73c3124b15c$export$2e2bcd8739ae039 = $7cffc73c3124b15c$var$CardMedia;



var $3VnFq = parcelRequire("3VnFq");

var $cTAWX = parcelRequire("cTAWX");

var $gJYWc = parcelRequire("gJYWc");


var $2w6IV = parcelRequire("2w6IV");

var $3e4LV = parcelRequire("3e4LV");

var $HGmne = parcelRequire("HGmne");

var $8pLcn = parcelRequire("8pLcn");

var $i8nzj = parcelRequire("i8nzj");

var $1kRHf = parcelRequire("1kRHf");
function $c2c5f7e84776f447$export$964336739a8c7119(slot) {
    return (0, $1kRHf.default)('MuiCardContent', slot);
}
const $c2c5f7e84776f447$var$cardContentClasses = (0, $i8nzj.default)('MuiCardContent', [
    'root'
]);
var $c2c5f7e84776f447$export$2e2bcd8739ae039 = $c2c5f7e84776f447$var$cardContentClasses;



var $9wx12 = parcelRequire("9wx12");
'use client';
const $f1b4cb86cd061e99$var$_excluded = [
    "className",
    "component"
];
const $f1b4cb86cd061e99$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ]
    };
    return (0, $3e4LV.default)(slots, (0, $c2c5f7e84776f447$export$964336739a8c7119), classes);
};
const $f1b4cb86cd061e99$var$CardContentRoot = (0, $HGmne.default)('div', {
    name: 'MuiCardContent',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})(()=>{
    return {
        padding: 16,
        '&:last-child': {
            paddingBottom: 24
        }
    };
});
const $f1b4cb86cd061e99$var$CardContent = /*#__PURE__*/ $gJYWc.forwardRef(function CardContent(inProps, ref) {
    const props = (0, $8pLcn.useDefaultProps)({
        props: inProps,
        name: 'MuiCardContent'
    });
    const { className: className, component: component = 'div' } = props, other = (0, $cTAWX.default)(props, $f1b4cb86cd061e99$var$_excluded);
    const ownerState = (0, $3VnFq.default)({}, props, {
        component: component
    });
    const classes = $f1b4cb86cd061e99$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $9wx12.jsx)($f1b4cb86cd061e99$var$CardContentRoot, (0, $3VnFq.default)({
        as: component,
        className: (0, $2w6IV.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref
    }, other));
});
var $f1b4cb86cd061e99$export$2e2bcd8739ae039 = $f1b4cb86cd061e99$var$CardContent;



var $cTAWX = parcelRequire("cTAWX");

var $3VnFq = parcelRequire("3VnFq");

var $gJYWc = parcelRequire("gJYWc");


var $2w6IV = parcelRequire("2w6IV");

var $01deC = parcelRequire("01deC");

var $3e4LV = parcelRequire("3e4LV");

var $HGmne = parcelRequire("HGmne");

var $8pLcn = parcelRequire("8pLcn");

var $cVrVk = parcelRequire("cVrVk");

var $i8nzj = parcelRequire("i8nzj");

var $1kRHf = parcelRequire("1kRHf");
function $e207b6b6da7ad223$export$24c1f8f60cbac79e(slot) {
    return (0, $1kRHf.default)('MuiTypography', slot);
}
const $e207b6b6da7ad223$var$typographyClasses = (0, $i8nzj.default)('MuiTypography', [
    'root',
    'h1',
    'h2',
    'h3',
    'h4',
    'h5',
    'h6',
    'subtitle1',
    'subtitle2',
    'body1',
    'body2',
    'inherit',
    'button',
    'caption',
    'overline',
    'alignLeft',
    'alignRight',
    'alignCenter',
    'alignJustify',
    'noWrap',
    'gutterBottom',
    'paragraph'
]);
var $e207b6b6da7ad223$export$2e2bcd8739ae039 = $e207b6b6da7ad223$var$typographyClasses;



var $9wx12 = parcelRequire("9wx12");
'use client';
const $b4083ea3a052dee9$var$_excluded = [
    "align",
    "className",
    "component",
    "gutterBottom",
    "noWrap",
    "paragraph",
    "variant",
    "variantMapping"
];
const $b4083ea3a052dee9$var$useUtilityClasses = (ownerState)=>{
    const { align: align, gutterBottom: gutterBottom, noWrap: noWrap, paragraph: paragraph, variant: variant, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            variant,
            ownerState.align !== 'inherit' && `align${(0, $cVrVk.default)(align)}`,
            gutterBottom && 'gutterBottom',
            noWrap && 'noWrap',
            paragraph && 'paragraph'
        ]
    };
    return (0, $3e4LV.default)(slots, (0, $e207b6b6da7ad223$export$24c1f8f60cbac79e), classes);
};
const $b4083ea3a052dee9$export$140e2f5526d3cad8 = (0, $HGmne.default)('span', {
    name: 'MuiTypography',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.variant && styles[ownerState.variant],
            ownerState.align !== 'inherit' && styles[`align${(0, $cVrVk.default)(ownerState.align)}`],
            ownerState.noWrap && styles.noWrap,
            ownerState.gutterBottom && styles.gutterBottom,
            ownerState.paragraph && styles.paragraph
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $3VnFq.default)({
        margin: 0
    }, ownerState.variant === 'inherit' && {
        // Some elements, like <button> on Chrome have default font that doesn't inherit, reset this.
        font: 'inherit'
    }, ownerState.variant !== 'inherit' && theme.typography[ownerState.variant], ownerState.align !== 'inherit' && {
        textAlign: ownerState.align
    }, ownerState.noWrap && {
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap'
    }, ownerState.gutterBottom && {
        marginBottom: '0.35em'
    }, ownerState.paragraph && {
        marginBottom: 16
    }));
const $b4083ea3a052dee9$var$defaultVariantMapping = {
    h1: 'h1',
    h2: 'h2',
    h3: 'h3',
    h4: 'h4',
    h5: 'h5',
    h6: 'h6',
    subtitle1: 'h6',
    subtitle2: 'h6',
    body1: 'p',
    body2: 'p',
    inherit: 'p'
};
// TODO v6: deprecate these color values in v5.x and remove the transformation in v6
const $b4083ea3a052dee9$var$colorTransformations = {
    primary: 'primary.main',
    textPrimary: 'text.primary',
    secondary: 'secondary.main',
    textSecondary: 'text.secondary',
    error: 'error.main'
};
const $b4083ea3a052dee9$var$transformDeprecatedColors = (color)=>{
    return $b4083ea3a052dee9$var$colorTransformations[color] || color;
};
const $b4083ea3a052dee9$var$Typography = /*#__PURE__*/ $gJYWc.forwardRef(function Typography(inProps, ref) {
    const themeProps = (0, $8pLcn.useDefaultProps)({
        props: inProps,
        name: 'MuiTypography'
    });
    const color = $b4083ea3a052dee9$var$transformDeprecatedColors(themeProps.color);
    const props = (0, $01deC.default)((0, $3VnFq.default)({}, themeProps, {
        color: color
    }));
    const { align: align = 'inherit', className: className, component: component, gutterBottom: gutterBottom = false, noWrap: noWrap = false, paragraph: paragraph = false, variant: variant = 'body1', variantMapping: variantMapping = $b4083ea3a052dee9$var$defaultVariantMapping } = props, other = (0, $cTAWX.default)(props, $b4083ea3a052dee9$var$_excluded);
    const ownerState = (0, $3VnFq.default)({}, props, {
        align: align,
        color: color,
        className: className,
        component: component,
        gutterBottom: gutterBottom,
        noWrap: noWrap,
        paragraph: paragraph,
        variant: variant,
        variantMapping: variantMapping
    });
    const Component = component || (paragraph ? 'p' : variantMapping[variant] || $b4083ea3a052dee9$var$defaultVariantMapping[variant]) || 'span';
    const classes = $b4083ea3a052dee9$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $9wx12.jsx)($b4083ea3a052dee9$export$140e2f5526d3cad8, (0, $3VnFq.default)({
        as: Component,
        ref: ref,
        ownerState: ownerState,
        className: (0, $2w6IV.default)(classes.root, className)
    }, other));
});
var $b4083ea3a052dee9$export$2e2bcd8739ae039 = $b4083ea3a052dee9$var$Typography;



var $3VnFq = parcelRequire("3VnFq");

var $cTAWX = parcelRequire("cTAWX");

var $gJYWc = parcelRequire("gJYWc");


var $2w6IV = parcelRequire("2w6IV");


var $3e4LV = parcelRequire("3e4LV");

var $HGmne = parcelRequire("HGmne");

var $8pLcn = parcelRequire("8pLcn");

var $cTAWX = parcelRequire("cTAWX");

var $3VnFq = parcelRequire("3VnFq");

var $gJYWc = parcelRequire("gJYWc");


var $2w6IV = parcelRequire("2w6IV");



var $3e4LV = parcelRequire("3e4LV");

var $fwsmC = parcelRequire("fwsmC");

var $HGmne = parcelRequire("HGmne");
// Inspired by https://github.com/material-components/material-components-ios/blob/bca36107405594d5b7b16265a5b0ed698f85a5ee/components/Elevation/src/UIColor%2BMaterialElevation.m#L61
const $d2da43fc3fa142ff$var$getOverlayAlpha = (elevation)=>{
    let alphaValue;
    if (elevation < 1) alphaValue = 5.11916 * elevation ** 2;
    else alphaValue = 4.5 * Math.log(elevation + 1) + 2;
    return (alphaValue / 100).toFixed(2);
};
var $d2da43fc3fa142ff$export$2e2bcd8739ae039 = $d2da43fc3fa142ff$var$getOverlayAlpha;



var $8pLcn = parcelRequire("8pLcn");


var $i8nzj = parcelRequire("i8nzj");

var $1kRHf = parcelRequire("1kRHf");
function $adf424089a380404$export$29cdb466b9b6f20b(slot) {
    return (0, $1kRHf.default)('MuiPaper', slot);
}
const $adf424089a380404$var$paperClasses = (0, $i8nzj.default)('MuiPaper', [
    'root',
    'rounded',
    'outlined',
    'elevation',
    'elevation0',
    'elevation1',
    'elevation2',
    'elevation3',
    'elevation4',
    'elevation5',
    'elevation6',
    'elevation7',
    'elevation8',
    'elevation9',
    'elevation10',
    'elevation11',
    'elevation12',
    'elevation13',
    'elevation14',
    'elevation15',
    'elevation16',
    'elevation17',
    'elevation18',
    'elevation19',
    'elevation20',
    'elevation21',
    'elevation22',
    'elevation23',
    'elevation24'
]);
var $adf424089a380404$export$2e2bcd8739ae039 = $adf424089a380404$var$paperClasses;



var $9wx12 = parcelRequire("9wx12");
'use client';
const $db3ddac601361ae3$var$_excluded = [
    "className",
    "component",
    "elevation",
    "square",
    "variant"
];
const $db3ddac601361ae3$var$useUtilityClasses = (ownerState)=>{
    const { square: square, elevation: elevation, variant: variant, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            variant,
            !square && 'rounded',
            variant === 'elevation' && `elevation${elevation}`
        ]
    };
    return (0, $3e4LV.default)(slots, (0, $adf424089a380404$export$29cdb466b9b6f20b), classes);
};
const $db3ddac601361ae3$var$PaperRoot = (0, $HGmne.default)('div', {
    name: 'MuiPaper',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.variant],
            !ownerState.square && styles.rounded,
            ownerState.variant === 'elevation' && styles[`elevation${ownerState.elevation}`]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>{
    var _theme$vars$overlays;
    return (0, $3VnFq.default)({
        backgroundColor: (theme.vars || theme).palette.background.paper,
        color: (theme.vars || theme).palette.text.primary,
        transition: theme.transitions.create('box-shadow')
    }, !ownerState.square && {
        borderRadius: theme.shape.borderRadius
    }, ownerState.variant === 'outlined' && {
        border: `1px solid ${(theme.vars || theme).palette.divider}`
    }, ownerState.variant === 'elevation' && (0, $3VnFq.default)({
        boxShadow: (theme.vars || theme).shadows[ownerState.elevation]
    }, !theme.vars && theme.palette.mode === 'dark' && {
        backgroundImage: `linear-gradient(${(0, $fwsmC.alpha)('#fff', (0, $d2da43fc3fa142ff$export$2e2bcd8739ae039)(ownerState.elevation))}, ${(0, $fwsmC.alpha)('#fff', (0, $d2da43fc3fa142ff$export$2e2bcd8739ae039)(ownerState.elevation))})`
    }, theme.vars && {
        backgroundImage: (_theme$vars$overlays = theme.vars.overlays) == null ? void 0 : _theme$vars$overlays[ownerState.elevation]
    }));
});
const $db3ddac601361ae3$var$Paper = /*#__PURE__*/ $gJYWc.forwardRef(function Paper(inProps, ref) {
    const props = (0, $8pLcn.useDefaultProps)({
        props: inProps,
        name: 'MuiPaper'
    });
    const { className: className, component: component = 'div', elevation: elevation = 1, square: square = false, variant: variant = 'elevation' } = props, other = (0, $cTAWX.default)(props, $db3ddac601361ae3$var$_excluded);
    const ownerState = (0, $3VnFq.default)({}, props, {
        component: component,
        elevation: elevation,
        square: square,
        variant: variant
    });
    const classes = $db3ddac601361ae3$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $9wx12.jsx)($db3ddac601361ae3$var$PaperRoot, (0, $3VnFq.default)({
        as: component,
        ownerState: ownerState,
        className: (0, $2w6IV.default)(classes.root, className),
        ref: ref
    }, other));
});
var $db3ddac601361ae3$export$2e2bcd8739ae039 = $db3ddac601361ae3$var$Paper;



var $i8nzj = parcelRequire("i8nzj");

var $1kRHf = parcelRequire("1kRHf");
function $9c3bc685c8ebee6b$export$f3b76d2cce458caa(slot) {
    return (0, $1kRHf.default)('MuiCard', slot);
}
const $9c3bc685c8ebee6b$var$cardClasses = (0, $i8nzj.default)('MuiCard', [
    'root'
]);
var $9c3bc685c8ebee6b$export$2e2bcd8739ae039 = $9c3bc685c8ebee6b$var$cardClasses;



var $9wx12 = parcelRequire("9wx12");
'use client';
const $0f9f0d79038d27f1$var$_excluded = [
    "className",
    "raised"
];
const $0f9f0d79038d27f1$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ]
    };
    return (0, $3e4LV.default)(slots, (0, $9c3bc685c8ebee6b$export$f3b76d2cce458caa), classes);
};
const $0f9f0d79038d27f1$var$CardRoot = (0, $HGmne.default)((0, $db3ddac601361ae3$export$2e2bcd8739ae039), {
    name: 'MuiCard',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})(()=>{
    return {
        overflow: 'hidden'
    };
});
const $0f9f0d79038d27f1$var$Card = /*#__PURE__*/ $gJYWc.forwardRef(function Card(inProps, ref) {
    const props = (0, $8pLcn.useDefaultProps)({
        props: inProps,
        name: 'MuiCard'
    });
    const { className: className, raised: raised = false } = props, other = (0, $cTAWX.default)(props, $0f9f0d79038d27f1$var$_excluded);
    const ownerState = (0, $3VnFq.default)({}, props, {
        raised: raised
    });
    const classes = $0f9f0d79038d27f1$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $9wx12.jsx)($0f9f0d79038d27f1$var$CardRoot, (0, $3VnFq.default)({
        className: (0, $2w6IV.default)(classes.root, className),
        elevation: raised ? 8 : undefined,
        ref: ref,
        ownerState: ownerState
    }, other));
});
var $0f9f0d79038d27f1$export$2e2bcd8739ae039 = $0f9f0d79038d27f1$var$Card;


const $9f659597088bfd69$export$97116c7f2754eba5 = ({ title: title, photoUrl: photoUrl })=>{
    return /*#__PURE__*/ (0, $9wx12.jsx)((0, $0f9f0d79038d27f1$export$2e2bcd8739ae039), {
        children: /*#__PURE__*/ (0, $9wx12.jsxs)((0, $7fd75e6b57001627$export$2e2bcd8739ae039), {
            children: [
                /*#__PURE__*/ (0, $9wx12.jsx)((0, $7cffc73c3124b15c$export$2e2bcd8739ae039), {
                    sx: {
                        height: 230,
                        width: 345
                    },
                    component: "img",
                    image: photoUrl
                }),
                /*#__PURE__*/ (0, $9wx12.jsx)((0, $f1b4cb86cd061e99$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $9wx12.jsx)((0, $b4083ea3a052dee9$export$2e2bcd8739ae039), {
                        textAlign: "center",
                        gutterBottom: true,
                        variant: "h5",
                        component: "div",
                        children: title
                    })
                })
            ]
        })
    });
};




var $9wx12 = parcelRequire("9wx12");

var $gJYWc = parcelRequire("gJYWc");



var $9wx12 = parcelRequire("9wx12");
parcelRequire("gJYWc");
var $7e951fd1c0b9fd8e$exports = {};
"use strict";
"use client";

var $hrFuR = parcelRequire("hrFuR");
Object.defineProperty($7e951fd1c0b9fd8e$exports, "__esModule", {
    value: true
});
$7e951fd1c0b9fd8e$exports.default = void 0;

var $7e951fd1c0b9fd8e$var$_createSvgIcon = $hrFuR((parcelRequire("lXMfO")));

var $9wx12 = parcelRequire("9wx12");
var $7e951fd1c0b9fd8e$var$_default = $7e951fd1c0b9fd8e$exports.default = (0, $7e951fd1c0b9fd8e$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $9wx12.jsx)("path", {
    d: "M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14"
}), 'Search');



var $HGmne = parcelRequire("HGmne");

var $cTAWX = parcelRequire("cTAWX");

var $3VnFq = parcelRequire("3VnFq");

var $gJYWc = parcelRequire("gJYWc");


var $2w6IV = parcelRequire("2w6IV");

var $11GxC = parcelRequire("11GxC");

var $3e4LV = parcelRequire("3e4LV");

var $fwsmC = parcelRequire("fwsmC");

var $HGmne = parcelRequire("HGmne");
var $8ttSm = parcelRequire("8ttSm");

var $8pLcn = parcelRequire("8pLcn");

var $fNSZE = parcelRequire("fNSZE");

var $cVrVk = parcelRequire("cVrVk");

var $i8nzj = parcelRequire("i8nzj");

var $1kRHf = parcelRequire("1kRHf");
function $e42ed2295e095b84$export$5a6f9035944c8119(slot) {
    return (0, $1kRHf.default)('MuiButton', slot);
}
const $e42ed2295e095b84$var$buttonClasses = (0, $i8nzj.default)('MuiButton', [
    'root',
    'text',
    'textInherit',
    'textPrimary',
    'textSecondary',
    'textSuccess',
    'textError',
    'textInfo',
    'textWarning',
    'outlined',
    'outlinedInherit',
    'outlinedPrimary',
    'outlinedSecondary',
    'outlinedSuccess',
    'outlinedError',
    'outlinedInfo',
    'outlinedWarning',
    'contained',
    'containedInherit',
    'containedPrimary',
    'containedSecondary',
    'containedSuccess',
    'containedError',
    'containedInfo',
    'containedWarning',
    'disableElevation',
    'focusVisible',
    'disabled',
    'colorInherit',
    'colorPrimary',
    'colorSecondary',
    'colorSuccess',
    'colorError',
    'colorInfo',
    'colorWarning',
    'textSizeSmall',
    'textSizeMedium',
    'textSizeLarge',
    'outlinedSizeSmall',
    'outlinedSizeMedium',
    'outlinedSizeLarge',
    'containedSizeSmall',
    'containedSizeMedium',
    'containedSizeLarge',
    'sizeMedium',
    'sizeSmall',
    'sizeLarge',
    'fullWidth',
    'startIcon',
    'endIcon',
    'icon',
    'iconSizeSmall',
    'iconSizeMedium',
    'iconSizeLarge'
]);
var $e42ed2295e095b84$export$2e2bcd8739ae039 = $e42ed2295e095b84$var$buttonClasses;



var $gJYWc = parcelRequire("gJYWc");
/**
 * @ignore - internal component.
 */ const $5eabc4556057b84f$var$ButtonGroupContext = /*#__PURE__*/ $gJYWc.createContext({});
var $5eabc4556057b84f$export$2e2bcd8739ae039 = $5eabc4556057b84f$var$ButtonGroupContext;



var $gJYWc = parcelRequire("gJYWc");
/**
 * @ignore - internal component.
 */ const $998e8799c4a1fd72$var$ButtonGroupButtonContext = /*#__PURE__*/ $gJYWc.createContext(undefined);
var $998e8799c4a1fd72$export$2e2bcd8739ae039 = $998e8799c4a1fd72$var$ButtonGroupButtonContext;



var $9wx12 = parcelRequire("9wx12");
'use client';
const $95b3a1ef1ddc1e78$var$_excluded = [
    "children",
    "color",
    "component",
    "className",
    "disabled",
    "disableElevation",
    "disableFocusRipple",
    "endIcon",
    "focusVisibleClassName",
    "fullWidth",
    "size",
    "startIcon",
    "type",
    "variant"
];
const $95b3a1ef1ddc1e78$var$useUtilityClasses = (ownerState)=>{
    const { color: color, disableElevation: disableElevation, fullWidth: fullWidth, size: size, variant: variant, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            variant,
            `${variant}${(0, $cVrVk.default)(color)}`,
            `size${(0, $cVrVk.default)(size)}`,
            `${variant}Size${(0, $cVrVk.default)(size)}`,
            `color${(0, $cVrVk.default)(color)}`,
            disableElevation && 'disableElevation',
            fullWidth && 'fullWidth'
        ],
        label: [
            'label'
        ],
        startIcon: [
            'icon',
            'startIcon',
            `iconSize${(0, $cVrVk.default)(size)}`
        ],
        endIcon: [
            'icon',
            'endIcon',
            `iconSize${(0, $cVrVk.default)(size)}`
        ]
    };
    const composedClasses = (0, $3e4LV.default)(slots, (0, $e42ed2295e095b84$export$5a6f9035944c8119), classes);
    return (0, $3VnFq.default)({}, classes, composedClasses);
};
const $95b3a1ef1ddc1e78$var$commonIconStyles = (ownerState)=>(0, $3VnFq.default)({}, ownerState.size === 'small' && {
        '& > *:nth-of-type(1)': {
            fontSize: 18
        }
    }, ownerState.size === 'medium' && {
        '& > *:nth-of-type(1)': {
            fontSize: 20
        }
    }, ownerState.size === 'large' && {
        '& > *:nth-of-type(1)': {
            fontSize: 22
        }
    });
const $95b3a1ef1ddc1e78$var$ButtonRoot = (0, $HGmne.default)((0, $fNSZE.default), {
    shouldForwardProp: (prop)=>(0, $8ttSm.default)(prop) || prop === 'classes',
    name: 'MuiButton',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.variant],
            styles[`${ownerState.variant}${(0, $cVrVk.default)(ownerState.color)}`],
            styles[`size${(0, $cVrVk.default)(ownerState.size)}`],
            styles[`${ownerState.variant}Size${(0, $cVrVk.default)(ownerState.size)}`],
            ownerState.color === 'inherit' && styles.colorInherit,
            ownerState.disableElevation && styles.disableElevation,
            ownerState.fullWidth && styles.fullWidth
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>{
    var _theme$palette$getCon, _theme$palette;
    const inheritContainedBackgroundColor = theme.palette.mode === 'light' ? theme.palette.grey[300] : theme.palette.grey[800];
    const inheritContainedHoverBackgroundColor = theme.palette.mode === 'light' ? theme.palette.grey.A100 : theme.palette.grey[700];
    return (0, $3VnFq.default)({}, theme.typography.button, {
        minWidth: 64,
        padding: '6px 16px',
        borderRadius: (theme.vars || theme).shape.borderRadius,
        transition: theme.transitions.create([
            'background-color',
            'box-shadow',
            'border-color',
            'color'
        ], {
            duration: theme.transitions.duration.short
        }),
        '&:hover': (0, $3VnFq.default)({
            textDecoration: 'none',
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.text.primaryChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $fwsmC.alpha)(theme.palette.text.primary, theme.palette.action.hoverOpacity),
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                backgroundColor: 'transparent'
            }
        }, ownerState.variant === 'text' && ownerState.color !== 'inherit' && {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette[ownerState.color].mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $fwsmC.alpha)(theme.palette[ownerState.color].main, theme.palette.action.hoverOpacity),
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                backgroundColor: 'transparent'
            }
        }, ownerState.variant === 'outlined' && ownerState.color !== 'inherit' && {
            border: `1px solid ${(theme.vars || theme).palette[ownerState.color].main}`,
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette[ownerState.color].mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $fwsmC.alpha)(theme.palette[ownerState.color].main, theme.palette.action.hoverOpacity),
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                backgroundColor: 'transparent'
            }
        }, ownerState.variant === 'contained' && {
            backgroundColor: theme.vars ? theme.vars.palette.Button.inheritContainedHoverBg : inheritContainedHoverBackgroundColor,
            boxShadow: (theme.vars || theme).shadows[4],
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                boxShadow: (theme.vars || theme).shadows[2],
                backgroundColor: (theme.vars || theme).palette.grey[300]
            }
        }, ownerState.variant === 'contained' && ownerState.color !== 'inherit' && {
            backgroundColor: (theme.vars || theme).palette[ownerState.color].dark,
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                backgroundColor: (theme.vars || theme).palette[ownerState.color].main
            }
        }),
        '&:active': (0, $3VnFq.default)({}, ownerState.variant === 'contained' && {
            boxShadow: (theme.vars || theme).shadows[8]
        }),
        [`&.${(0, $e42ed2295e095b84$export$2e2bcd8739ae039).focusVisible}`]: (0, $3VnFq.default)({}, ownerState.variant === 'contained' && {
            boxShadow: (theme.vars || theme).shadows[6]
        }),
        [`&.${(0, $e42ed2295e095b84$export$2e2bcd8739ae039).disabled}`]: (0, $3VnFq.default)({
            color: (theme.vars || theme).palette.action.disabled
        }, ownerState.variant === 'outlined' && {
            border: `1px solid ${(theme.vars || theme).palette.action.disabledBackground}`
        }, ownerState.variant === 'contained' && {
            color: (theme.vars || theme).palette.action.disabled,
            boxShadow: (theme.vars || theme).shadows[0],
            backgroundColor: (theme.vars || theme).palette.action.disabledBackground
        })
    }, ownerState.variant === 'text' && {
        padding: '6px 8px'
    }, ownerState.variant === 'text' && ownerState.color !== 'inherit' && {
        color: (theme.vars || theme).palette[ownerState.color].main
    }, ownerState.variant === 'outlined' && {
        padding: '5px 15px',
        border: '1px solid currentColor'
    }, ownerState.variant === 'outlined' && ownerState.color !== 'inherit' && {
        color: (theme.vars || theme).palette[ownerState.color].main,
        border: theme.vars ? `1px solid rgba(${theme.vars.palette[ownerState.color].mainChannel} / 0.5)` : `1px solid ${(0, $fwsmC.alpha)(theme.palette[ownerState.color].main, 0.5)}`
    }, ownerState.variant === 'contained' && {
        color: theme.vars ? // this is safe because grey does not change between default light/dark mode
        theme.vars.palette.text.primary : (_theme$palette$getCon = (_theme$palette = theme.palette).getContrastText) == null ? void 0 : _theme$palette$getCon.call(_theme$palette, theme.palette.grey[300]),
        backgroundColor: theme.vars ? theme.vars.palette.Button.inheritContainedBg : inheritContainedBackgroundColor,
        boxShadow: (theme.vars || theme).shadows[2]
    }, ownerState.variant === 'contained' && ownerState.color !== 'inherit' && {
        color: (theme.vars || theme).palette[ownerState.color].contrastText,
        backgroundColor: (theme.vars || theme).palette[ownerState.color].main
    }, ownerState.color === 'inherit' && {
        color: 'inherit',
        borderColor: 'currentColor'
    }, ownerState.size === 'small' && ownerState.variant === 'text' && {
        padding: '4px 5px',
        fontSize: theme.typography.pxToRem(13)
    }, ownerState.size === 'large' && ownerState.variant === 'text' && {
        padding: '8px 11px',
        fontSize: theme.typography.pxToRem(15)
    }, ownerState.size === 'small' && ownerState.variant === 'outlined' && {
        padding: '3px 9px',
        fontSize: theme.typography.pxToRem(13)
    }, ownerState.size === 'large' && ownerState.variant === 'outlined' && {
        padding: '7px 21px',
        fontSize: theme.typography.pxToRem(15)
    }, ownerState.size === 'small' && ownerState.variant === 'contained' && {
        padding: '4px 10px',
        fontSize: theme.typography.pxToRem(13)
    }, ownerState.size === 'large' && ownerState.variant === 'contained' && {
        padding: '8px 22px',
        fontSize: theme.typography.pxToRem(15)
    }, ownerState.fullWidth && {
        width: '100%'
    });
}, ({ ownerState: ownerState })=>ownerState.disableElevation && {
        boxShadow: 'none',
        '&:hover': {
            boxShadow: 'none'
        },
        [`&.${(0, $e42ed2295e095b84$export$2e2bcd8739ae039).focusVisible}`]: {
            boxShadow: 'none'
        },
        '&:active': {
            boxShadow: 'none'
        },
        [`&.${(0, $e42ed2295e095b84$export$2e2bcd8739ae039).disabled}`]: {
            boxShadow: 'none'
        }
    });
const $95b3a1ef1ddc1e78$var$ButtonStartIcon = (0, $HGmne.default)('span', {
    name: 'MuiButton',
    slot: 'StartIcon',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.startIcon,
            styles[`iconSize${(0, $cVrVk.default)(ownerState.size)}`]
        ];
    }
})(({ ownerState: ownerState })=>(0, $3VnFq.default)({
        display: 'inherit',
        marginRight: 8,
        marginLeft: -4
    }, ownerState.size === 'small' && {
        marginLeft: -2
    }, $95b3a1ef1ddc1e78$var$commonIconStyles(ownerState)));
const $95b3a1ef1ddc1e78$var$ButtonEndIcon = (0, $HGmne.default)('span', {
    name: 'MuiButton',
    slot: 'EndIcon',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.endIcon,
            styles[`iconSize${(0, $cVrVk.default)(ownerState.size)}`]
        ];
    }
})(({ ownerState: ownerState })=>(0, $3VnFq.default)({
        display: 'inherit',
        marginRight: -4,
        marginLeft: 8
    }, ownerState.size === 'small' && {
        marginRight: -2
    }, $95b3a1ef1ddc1e78$var$commonIconStyles(ownerState)));
const $95b3a1ef1ddc1e78$var$Button = /*#__PURE__*/ $gJYWc.forwardRef(function Button(inProps, ref) {
    // props priority: `inProps` > `contextProps` > `themeDefaultProps`
    const contextProps = $gJYWc.useContext((0, $5eabc4556057b84f$export$2e2bcd8739ae039));
    const buttonGroupButtonContextPositionClassName = $gJYWc.useContext((0, $998e8799c4a1fd72$export$2e2bcd8739ae039));
    const resolvedProps = (0, $11GxC.default)(contextProps, inProps);
    const props = (0, $8pLcn.useDefaultProps)({
        props: resolvedProps,
        name: 'MuiButton'
    });
    const { children: children, color: color = 'primary', component: component = 'button', className: className, disabled: disabled = false, disableElevation: disableElevation = false, disableFocusRipple: disableFocusRipple = false, endIcon: endIconProp, focusVisibleClassName: focusVisibleClassName, fullWidth: fullWidth = false, size: size = 'medium', startIcon: startIconProp, type: type, variant: variant = 'text' } = props, other = (0, $cTAWX.default)(props, $95b3a1ef1ddc1e78$var$_excluded);
    const ownerState = (0, $3VnFq.default)({}, props, {
        color: color,
        component: component,
        disabled: disabled,
        disableElevation: disableElevation,
        disableFocusRipple: disableFocusRipple,
        fullWidth: fullWidth,
        size: size,
        type: type,
        variant: variant
    });
    const classes = $95b3a1ef1ddc1e78$var$useUtilityClasses(ownerState);
    const startIcon = startIconProp && /*#__PURE__*/ (0, $9wx12.jsx)($95b3a1ef1ddc1e78$var$ButtonStartIcon, {
        className: classes.startIcon,
        ownerState: ownerState,
        children: startIconProp
    });
    const endIcon = endIconProp && /*#__PURE__*/ (0, $9wx12.jsx)($95b3a1ef1ddc1e78$var$ButtonEndIcon, {
        className: classes.endIcon,
        ownerState: ownerState,
        children: endIconProp
    });
    const positionClassName = buttonGroupButtonContextPositionClassName || '';
    return /*#__PURE__*/ (0, $9wx12.jsxs)($95b3a1ef1ddc1e78$var$ButtonRoot, (0, $3VnFq.default)({
        ownerState: ownerState,
        className: (0, $2w6IV.default)(contextProps.className, classes.root, className, positionClassName),
        component: component,
        disabled: disabled,
        focusRipple: !disableFocusRipple,
        focusVisibleClassName: (0, $2w6IV.default)(classes.focusVisible, focusVisibleClassName),
        ref: ref,
        type: type
    }, other, {
        classes: classes,
        children: [
            startIcon,
            children,
            endIcon
        ]
    }));
});
var $95b3a1ef1ddc1e78$export$2e2bcd8739ae039 = $95b3a1ef1ddc1e78$var$Button;



var $9wx12 = parcelRequire("9wx12");

var $gJYWc = parcelRequire("gJYWc");


var $cTAWX = parcelRequire("cTAWX");

var $3VnFq = parcelRequire("3VnFq");

var $gJYWc = parcelRequire("gJYWc");


var $2w6IV = parcelRequire("2w6IV");

var $3e4LV = parcelRequire("3e4LV");

var $fwsmC = parcelRequire("fwsmC");

var $HGmne = parcelRequire("HGmne");
var $8ttSm = parcelRequire("8ttSm");

var $8pLcn = parcelRequire("8pLcn");

var $fNSZE = parcelRequire("fNSZE");

var $4z2O6 = parcelRequire("4z2O6");
'use client';
var $288db5e5dece4e0b$export$2e2bcd8739ae039 = (0, $4z2O6.default);



var $il32z = parcelRequire("il32z");

var $gJYWc = parcelRequire("gJYWc");
'use client';
/**
 * @ignore - internal component.
 */ const $3d14c289610745c4$var$ListContext = /*#__PURE__*/ $gJYWc.createContext({});
var $3d14c289610745c4$export$2e2bcd8739ae039 = $3d14c289610745c4$var$ListContext;



var $i8nzj = parcelRequire("i8nzj");

var $1kRHf = parcelRequire("1kRHf");
function $52a4139062008855$export$c09531d8563c67a5(slot) {
    return (0, $1kRHf.default)('MuiListItemButton', slot);
}
const $52a4139062008855$var$listItemButtonClasses = (0, $i8nzj.default)('MuiListItemButton', [
    'root',
    'focusVisible',
    'dense',
    'alignItemsFlexStart',
    'disabled',
    'divider',
    'gutters',
    'selected'
]);
var $52a4139062008855$export$2e2bcd8739ae039 = $52a4139062008855$var$listItemButtonClasses;



var $9wx12 = parcelRequire("9wx12");
'use client';
const $fccb9ee5b10abda3$var$_excluded = [
    "alignItems",
    "autoFocus",
    "component",
    "children",
    "dense",
    "disableGutters",
    "divider",
    "focusVisibleClassName",
    "selected",
    "className"
];
const $fccb9ee5b10abda3$export$4334bb34c76fef24 = (props, styles)=>{
    const { ownerState: ownerState } = props;
    return [
        styles.root,
        ownerState.dense && styles.dense,
        ownerState.alignItems === 'flex-start' && styles.alignItemsFlexStart,
        ownerState.divider && styles.divider,
        !ownerState.disableGutters && styles.gutters
    ];
};
const $fccb9ee5b10abda3$var$useUtilityClasses = (ownerState)=>{
    const { alignItems: alignItems, classes: classes, dense: dense, disabled: disabled, disableGutters: disableGutters, divider: divider, selected: selected } = ownerState;
    const slots = {
        root: [
            'root',
            dense && 'dense',
            !disableGutters && 'gutters',
            divider && 'divider',
            disabled && 'disabled',
            alignItems === 'flex-start' && 'alignItemsFlexStart',
            selected && 'selected'
        ]
    };
    const composedClasses = (0, $3e4LV.default)(slots, (0, $52a4139062008855$export$c09531d8563c67a5), classes);
    return (0, $3VnFq.default)({}, classes, composedClasses);
};
const $fccb9ee5b10abda3$var$ListItemButtonRoot = (0, $HGmne.default)((0, $fNSZE.default), {
    shouldForwardProp: (prop)=>(0, $8ttSm.default)(prop) || prop === 'classes',
    name: 'MuiListItemButton',
    slot: 'Root',
    overridesResolver: $fccb9ee5b10abda3$export$4334bb34c76fef24
})(({ theme: theme, ownerState: ownerState })=>(0, $3VnFq.default)({
        display: 'flex',
        flexGrow: 1,
        justifyContent: 'flex-start',
        alignItems: 'center',
        position: 'relative',
        textDecoration: 'none',
        minWidth: 0,
        boxSizing: 'border-box',
        textAlign: 'left',
        paddingTop: 8,
        paddingBottom: 8,
        transition: theme.transitions.create('background-color', {
            duration: theme.transitions.duration.shortest
        }),
        '&:hover': {
            textDecoration: 'none',
            backgroundColor: (theme.vars || theme).palette.action.hover,
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                backgroundColor: 'transparent'
            }
        },
        [`&.${(0, $52a4139062008855$export$2e2bcd8739ae039).selected}`]: {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.selectedOpacity})` : (0, $fwsmC.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity),
            [`&.${(0, $52a4139062008855$export$2e2bcd8739ae039).focusVisible}`]: {
                backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.focusOpacity}))` : (0, $fwsmC.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity + theme.palette.action.focusOpacity)
            }
        },
        [`&.${(0, $52a4139062008855$export$2e2bcd8739ae039).selected}:hover`]: {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.hoverOpacity}))` : (0, $fwsmC.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity + theme.palette.action.hoverOpacity),
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.selectedOpacity})` : (0, $fwsmC.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity)
            }
        },
        [`&.${(0, $52a4139062008855$export$2e2bcd8739ae039).focusVisible}`]: {
            backgroundColor: (theme.vars || theme).palette.action.focus
        },
        [`&.${(0, $52a4139062008855$export$2e2bcd8739ae039).disabled}`]: {
            opacity: (theme.vars || theme).palette.action.disabledOpacity
        }
    }, ownerState.divider && {
        borderBottom: `1px solid ${(theme.vars || theme).palette.divider}`,
        backgroundClip: 'padding-box'
    }, ownerState.alignItems === 'flex-start' && {
        alignItems: 'flex-start'
    }, !ownerState.disableGutters && {
        paddingLeft: 16,
        paddingRight: 16
    }, ownerState.dense && {
        paddingTop: 4,
        paddingBottom: 4
    }));
const $fccb9ee5b10abda3$var$ListItemButton = /*#__PURE__*/ $gJYWc.forwardRef(function ListItemButton(inProps, ref) {
    const props = (0, $8pLcn.useDefaultProps)({
        props: inProps,
        name: 'MuiListItemButton'
    });
    const { alignItems: alignItems = 'center', autoFocus: autoFocus = false, component: component = 'div', children: children, dense: dense = false, disableGutters: disableGutters = false, divider: divider = false, focusVisibleClassName: focusVisibleClassName, selected: selected = false, className: className } = props, other = (0, $cTAWX.default)(props, $fccb9ee5b10abda3$var$_excluded);
    const context = $gJYWc.useContext((0, $3d14c289610745c4$export$2e2bcd8739ae039));
    const childContext = $gJYWc.useMemo(()=>({
            dense: dense || context.dense || false,
            alignItems: alignItems,
            disableGutters: disableGutters
        }), [
        alignItems,
        context.dense,
        dense,
        disableGutters
    ]);
    const listItemRef = $gJYWc.useRef(null);
    (0, $288db5e5dece4e0b$export$2e2bcd8739ae039)(()=>{
        if (autoFocus) {
            if (listItemRef.current) listItemRef.current.focus();
        }
    }, [
        autoFocus
    ]);
    const ownerState = (0, $3VnFq.default)({}, props, {
        alignItems: alignItems,
        dense: childContext.dense,
        disableGutters: disableGutters,
        divider: divider,
        selected: selected
    });
    const classes = $fccb9ee5b10abda3$var$useUtilityClasses(ownerState);
    const handleRef = (0, $il32z.default)(listItemRef, ref);
    return /*#__PURE__*/ (0, $9wx12.jsx)((0, $3d14c289610745c4$export$2e2bcd8739ae039).Provider, {
        value: childContext,
        children: /*#__PURE__*/ (0, $9wx12.jsx)($fccb9ee5b10abda3$var$ListItemButtonRoot, (0, $3VnFq.default)({
            ref: handleRef,
            href: other.href || other.to,
            component: (other.href || other.to) && component === 'div' ? 'button' : component,
            focusVisibleClassName: (0, $2w6IV.default)(classes.focusVisible, focusVisibleClassName),
            ownerState: ownerState,
            className: (0, $2w6IV.default)(classes.root, className)
        }, other, {
            classes: classes,
            children: children
        }))
    });
});
var $fccb9ee5b10abda3$export$2e2bcd8739ae039 = $fccb9ee5b10abda3$var$ListItemButton;


var $3VnFq = parcelRequire("3VnFq");

var $cTAWX = parcelRequire("cTAWX");

var $gJYWc = parcelRequire("gJYWc");


var $2w6IV = parcelRequire("2w6IV");

var $3e4LV = parcelRequire("3e4LV");






var $3VnFq = parcelRequire("3VnFq");

var $cTAWX = parcelRequire("cTAWX");

var $4gWBK = parcelRequire("4gWBK");

var $3VnFq = parcelRequire("3VnFq");
/**
 * Determines if a given element is a DOM element name (i.e. not a React component).
 */ function $50e7d669fe712af8$var$isHostComponent(element) {
    return typeof element === 'string';
}
var $50e7d669fe712af8$export$2e2bcd8739ae039 = $50e7d669fe712af8$var$isHostComponent;


/**
 * Type of the ownerState based on the type of an element it applies to.
 * This resolves to the provided OwnerState for React components and `undefined` for host components.
 * Falls back to `OwnerState | undefined` when the exact type can't be determined in development time.
 */ /**
 * Appends the ownerState object to the props, merging with the existing one if necessary.
 *
 * @param elementType Type of the element that owns the `existingProps`. If the element is a DOM node or undefined, `ownerState` is not applied.
 * @param otherProps Props of the element.
 * @param ownerState
 */ function $7fabec4faf29aefb$var$appendOwnerState(elementType, otherProps, ownerState) {
    if (elementType === undefined || (0, $50e7d669fe712af8$export$2e2bcd8739ae039)(elementType)) return otherProps;
    return (0, $3VnFq.default)({}, otherProps, {
        ownerState: (0, $3VnFq.default)({}, otherProps.ownerState, ownerState)
    });
}
var $7fabec4faf29aefb$export$2e2bcd8739ae039 = $7fabec4faf29aefb$var$appendOwnerState;



var $3VnFq = parcelRequire("3VnFq");

var $2w6IV = parcelRequire("2w6IV");
/**
 * Extracts event handlers from a given object.
 * A prop is considered an event handler if it is a function and its name starts with `on`.
 *
 * @param object An object to extract event handlers from.
 * @param excludeKeys An array of keys to exclude from the returned object.
 */ function $d869d422b46f9b96$var$extractEventHandlers(object, excludeKeys = []) {
    if (object === undefined) return {};
    const result = {};
    Object.keys(object).filter((prop)=>prop.match(/^on[A-Z]/) && typeof object[prop] === 'function' && !excludeKeys.includes(prop)).forEach((prop)=>{
        result[prop] = object[prop];
    });
    return result;
}
var $d869d422b46f9b96$export$2e2bcd8739ae039 = $d869d422b46f9b96$var$extractEventHandlers;


/**
 * Removes event handlers from the given object.
 * A field is considered an event handler if it is a function with a name beginning with `on`.
 *
 * @param object Object to remove event handlers from.
 * @returns Object with event handlers removed.
 */ function $473b19799d955062$var$omitEventHandlers(object) {
    if (object === undefined) return {};
    const result = {};
    Object.keys(object).filter((prop)=>!(prop.match(/^on[A-Z]/) && typeof object[prop] === 'function')).forEach((prop)=>{
        result[prop] = object[prop];
    });
    return result;
}
var $473b19799d955062$export$2e2bcd8739ae039 = $473b19799d955062$var$omitEventHandlers;


/**
 * Merges the slot component internal props (usually coming from a hook)
 * with the externally provided ones.
 *
 * The merge order is (the latter overrides the former):
 * 1. The internal props (specified as a getter function to work with get*Props hook result)
 * 2. Additional props (specified internally on a Base UI component)
 * 3. External props specified on the owner component. These should only be used on a root slot.
 * 4. External props specified in the `slotProps.*` prop.
 * 5. The `className` prop - combined from all the above.
 * @param parameters
 * @returns
 */ function $d8ededa61c3c28ce$var$mergeSlotProps(parameters) {
    const { getSlotProps: getSlotProps, additionalProps: additionalProps, externalSlotProps: externalSlotProps, externalForwardedProps: externalForwardedProps, className: className } = parameters;
    if (!getSlotProps) {
        // The simpler case - getSlotProps is not defined, so no internal event handlers are defined,
        // so we can simply merge all the props without having to worry about extracting event handlers.
        const joinedClasses = (0, $2w6IV.default)(additionalProps == null ? void 0 : additionalProps.className, className, externalForwardedProps == null ? void 0 : externalForwardedProps.className, externalSlotProps == null ? void 0 : externalSlotProps.className);
        const mergedStyle = (0, $3VnFq.default)({}, additionalProps == null ? void 0 : additionalProps.style, externalForwardedProps == null ? void 0 : externalForwardedProps.style, externalSlotProps == null ? void 0 : externalSlotProps.style);
        const props = (0, $3VnFq.default)({}, additionalProps, externalForwardedProps, externalSlotProps);
        if (joinedClasses.length > 0) props.className = joinedClasses;
        if (Object.keys(mergedStyle).length > 0) props.style = mergedStyle;
        return {
            props: props,
            internalRef: undefined
        };
    }
    // In this case, getSlotProps is responsible for calling the external event handlers.
    // We don't need to include them in the merged props because of this.
    const eventHandlers = (0, $d869d422b46f9b96$export$2e2bcd8739ae039)((0, $3VnFq.default)({}, externalForwardedProps, externalSlotProps));
    const componentsPropsWithoutEventHandlers = (0, $473b19799d955062$export$2e2bcd8739ae039)(externalSlotProps);
    const otherPropsWithoutEventHandlers = (0, $473b19799d955062$export$2e2bcd8739ae039)(externalForwardedProps);
    const internalSlotProps = getSlotProps(eventHandlers);
    // The order of classes is important here.
    // Emotion (that we use in libraries consuming Base UI) depends on this order
    // to properly override style. It requires the most important classes to be last
    // (see https://github.com/mui/material-ui/pull/33205) for the related discussion.
    const joinedClasses = (0, $2w6IV.default)(internalSlotProps == null ? void 0 : internalSlotProps.className, additionalProps == null ? void 0 : additionalProps.className, className, externalForwardedProps == null ? void 0 : externalForwardedProps.className, externalSlotProps == null ? void 0 : externalSlotProps.className);
    const mergedStyle = (0, $3VnFq.default)({}, internalSlotProps == null ? void 0 : internalSlotProps.style, additionalProps == null ? void 0 : additionalProps.style, externalForwardedProps == null ? void 0 : externalForwardedProps.style, externalSlotProps == null ? void 0 : externalSlotProps.style);
    const props = (0, $3VnFq.default)({}, internalSlotProps, additionalProps, otherPropsWithoutEventHandlers, componentsPropsWithoutEventHandlers);
    if (joinedClasses.length > 0) props.className = joinedClasses;
    if (Object.keys(mergedStyle).length > 0) props.style = mergedStyle;
    return {
        props: props,
        internalRef: internalSlotProps.ref
    };
}
var $d8ededa61c3c28ce$export$2e2bcd8739ae039 = $d8ededa61c3c28ce$var$mergeSlotProps;


/**
 * If `componentProps` is a function, calls it with the provided `ownerState`.
 * Otherwise, just returns `componentProps`.
 */ function $9ebc0bbfbd31d09f$var$resolveComponentProps(componentProps, ownerState, slotState) {
    if (typeof componentProps === 'function') return componentProps(ownerState, slotState);
    return componentProps;
}
var $9ebc0bbfbd31d09f$export$2e2bcd8739ae039 = $9ebc0bbfbd31d09f$var$resolveComponentProps;


'use client';
const $2f70e5a04f888acc$var$_excluded = [
    "elementType",
    "externalSlotProps",
    "ownerState",
    "skipResolvingSlotProps"
];
/**
 * @ignore - do not document.
 * Builds the props to be passed into the slot of an unstyled component.
 * It merges the internal props of the component with the ones supplied by the user, allowing to customize the behavior.
 * If the slot component is not a host component, it also merges in the `ownerState`.
 *
 * @param parameters.getSlotProps - A function that returns the props to be passed to the slot component.
 */ function $2f70e5a04f888acc$var$useSlotProps(parameters) {
    var _parameters$additiona;
    const { elementType: elementType, externalSlotProps: externalSlotProps, ownerState: ownerState, skipResolvingSlotProps: skipResolvingSlotProps = false } = parameters, rest = (0, $cTAWX.default)(parameters, $2f70e5a04f888acc$var$_excluded);
    const resolvedComponentsProps = skipResolvingSlotProps ? {} : (0, $9ebc0bbfbd31d09f$export$2e2bcd8739ae039)(externalSlotProps, ownerState);
    const { props: mergedProps, internalRef: internalRef } = (0, $d8ededa61c3c28ce$export$2e2bcd8739ae039)((0, $3VnFq.default)({}, rest, {
        externalSlotProps: resolvedComponentsProps
    }));
    const ref = (0, $4gWBK.default)(internalRef, resolvedComponentsProps == null ? void 0 : resolvedComponentsProps.ref, (_parameters$additiona = parameters.additionalProps) == null ? void 0 : _parameters$additiona.ref);
    const props = (0, $7fabec4faf29aefb$export$2e2bcd8739ae039)(elementType, (0, $3VnFq.default)({}, mergedProps, {
        ref: ref
    }), ownerState);
    return props;
}
var $2f70e5a04f888acc$export$2e2bcd8739ae039 = $2f70e5a04f888acc$var$useSlotProps;




var $HGmne = parcelRequire("HGmne");

var $8pLcn = parcelRequire("8pLcn");
// Corresponds to 10 frames at 60 Hz.
// A few bytes payload overhead when lodash/debounce is ~3 kB and debounce ~300 B.
function $c4af489a164f5db3$export$2e2bcd8739ae039(func, wait = 166) {
    let timeout;
    function debounced(...args) {
        const later = ()=>{
            // @ts-ignore
            func.apply(this, args);
        };
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
    }
    debounced.clear = ()=>{
        clearTimeout(timeout);
    };
    return debounced;
}


var $05f705bdb0679e55$export$2e2bcd8739ae039 = (0, $c4af489a164f5db3$export$2e2bcd8739ae039);


function $1c0f680786bc49ff$export$2e2bcd8739ae039(node) {
    return node && node.ownerDocument || document;
}


var $755167b4f9e6f571$export$2e2bcd8739ae039 = (0, $1c0f680786bc49ff$export$2e2bcd8739ae039);



function $ba6d5d10c948f9ac$export$2e2bcd8739ae039(node) {
    const doc = (0, $1c0f680786bc49ff$export$2e2bcd8739ae039)(node);
    return doc.defaultView || window;
}


var $44c7bb85922f3310$export$2e2bcd8739ae039 = (0, $ba6d5d10c948f9ac$export$2e2bcd8739ae039);



var $il32z = parcelRequire("il32z");

var $3VnFq = parcelRequire("3VnFq");

var $cTAWX = parcelRequire("cTAWX");

var $gJYWc = parcelRequire("gJYWc");


var $4LiUz = parcelRequire("4LiUz");


var $gJYWc = parcelRequire("gJYWc");
function $5e9a5fb2b833225d$export$2e2bcd8739ae039(element) {
    // 'ref' is passed as prop in React 19, whereas 'ref' is directly attached to children in older versions
    if (parseInt($gJYWc.version, 10) >= 19) {
        var _element$props;
        return (element == null || (_element$props = element.props) == null ? void 0 : _element$props.ref) || null;
    }
    // @ts-expect-error element.ref is not included in the ReactElement type
    // https://github.com/DefinitelyTyped/DefinitelyTyped/discussions/70189
    return (element == null ? void 0 : element.ref) || null;
}



var $cTAWX = parcelRequire("cTAWX");

var $4yJFC = parcelRequire("4yJFC");


var $gJYWc = parcelRequire("gJYWc");

var $c284c47e3a796029$export$2e2bcd8739ae039 = {
    disabled: false
};




var $l6PtU = parcelRequire("l6PtU");
var $a942f4454771225e$export$7d26bbb1236dafd6 = function forceReflow(node) {
    return node.scrollTop;
};


var $a305bfcf210dcb16$export$bb38bb9a1161268 = 'unmounted';
var $a305bfcf210dcb16$export$84cbff306f539230 = 'exited';
var $a305bfcf210dcb16$export$df38205c966be359 = 'entering';
var $a305bfcf210dcb16$export$78e9e6e3e014d60a = 'entered';
var $a305bfcf210dcb16$export$4aacc83d4d59139f = 'exiting';
/**
 * The Transition component lets you describe a transition from one component
 * state to another _over time_ with a simple declarative API. Most commonly
 * it's used to animate the mounting and unmounting of a component, but can also
 * be used to describe in-place transition states as well.
 *
 * ---
 *
 * **Note**: `Transition` is a platform-agnostic base component. If you're using
 * transitions in CSS, you'll probably want to use
 * [`CSSTransition`](https://reactcommunity.org/react-transition-group/css-transition)
 * instead. It inherits all the features of `Transition`, but contains
 * additional features necessary to play nice with CSS transitions (hence the
 * name of the component).
 *
 * ---
 *
 * By default the `Transition` component does not alter the behavior of the
 * component it renders, it only tracks "enter" and "exit" states for the
 * components. It's up to you to give meaning and effect to those states. For
 * example we can add styles to a component when it enters or exits:
 *
 * ```jsx
 * import { Transition } from 'react-transition-group';
 *
 * const duration = 300;
 *
 * const defaultStyle = {
 *   transition: `opacity ${duration}ms ease-in-out`,
 *   opacity: 0,
 * }
 *
 * const transitionStyles = {
 *   entering: { opacity: 1 },
 *   entered:  { opacity: 1 },
 *   exiting:  { opacity: 0 },
 *   exited:  { opacity: 0 },
 * };
 *
 * const Fade = ({ in: inProp }) => (
 *   <Transition in={inProp} timeout={duration}>
 *     {state => (
 *       <div style={{
 *         ...defaultStyle,
 *         ...transitionStyles[state]
 *       }}>
 *         I'm a fade Transition!
 *       </div>
 *     )}
 *   </Transition>
 * );
 * ```
 *
 * There are 4 main states a Transition can be in:
 *  - `'entering'`
 *  - `'entered'`
 *  - `'exiting'`
 *  - `'exited'`
 *
 * Transition state is toggled via the `in` prop. When `true` the component
 * begins the "Enter" stage. During this stage, the component will shift from
 * its current transition state, to `'entering'` for the duration of the
 * transition and then to the `'entered'` stage once it's complete. Let's take
 * the following example (we'll use the
 * [useState](https://reactjs.org/docs/hooks-reference.html#usestate) hook):
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <Transition in={inProp} timeout={500}>
 *         {state => (
 *           // ...
 *         )}
 *       </Transition>
 *       <button onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the button is clicked the component will shift to the `'entering'` state
 * and stay there for 500ms (the value of `timeout`) before it finally switches
 * to `'entered'`.
 *
 * When `in` is `false` the same thing happens except the state moves from
 * `'exiting'` to `'exited'`.
 */ var $a305bfcf210dcb16$var$Transition = /*#__PURE__*/ function(_React$Component) {
    (0, $4yJFC.default)(Transition, _React$Component);
    function Transition(props, context) {
        var _this;
        _this = _React$Component.call(this, props, context) || this;
        var parentGroup = context; // In the context of a TransitionGroup all enters are really appears
        var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
        var initialStatus;
        _this.appearStatus = null;
        if (props.in) {
            if (appear) {
                initialStatus = $a305bfcf210dcb16$export$84cbff306f539230;
                _this.appearStatus = $a305bfcf210dcb16$export$df38205c966be359;
            } else initialStatus = $a305bfcf210dcb16$export$78e9e6e3e014d60a;
        } else if (props.unmountOnExit || props.mountOnEnter) initialStatus = $a305bfcf210dcb16$export$bb38bb9a1161268;
        else initialStatus = $a305bfcf210dcb16$export$84cbff306f539230;
        _this.state = {
            status: initialStatus
        };
        _this.nextCallback = null;
        return _this;
    }
    Transition.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
        var nextIn = _ref.in;
        if (nextIn && prevState.status === $a305bfcf210dcb16$export$bb38bb9a1161268) return {
            status: $a305bfcf210dcb16$export$84cbff306f539230
        };
        return null;
    } // getSnapshotBeforeUpdate(prevProps) {
    ;
    var _proto = Transition.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this.updateStatus(true, this.appearStatus);
    };
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        var nextStatus = null;
        if (prevProps !== this.props) {
            var status = this.state.status;
            if (this.props.in) {
                if (status !== $a305bfcf210dcb16$export$df38205c966be359 && status !== $a305bfcf210dcb16$export$78e9e6e3e014d60a) nextStatus = $a305bfcf210dcb16$export$df38205c966be359;
            } else if (status === $a305bfcf210dcb16$export$df38205c966be359 || status === $a305bfcf210dcb16$export$78e9e6e3e014d60a) nextStatus = $a305bfcf210dcb16$export$4aacc83d4d59139f;
        }
        this.updateStatus(false, nextStatus);
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.cancelNextCallback();
    };
    _proto.getTimeouts = function getTimeouts() {
        var timeout = this.props.timeout;
        var exit, enter, appear;
        exit = enter = appear = timeout;
        if (timeout != null && typeof timeout !== 'number') {
            exit = timeout.exit;
            enter = timeout.enter; // TODO: remove fallback for next major
            appear = timeout.appear !== undefined ? timeout.appear : enter;
        }
        return {
            exit: exit,
            enter: enter,
            appear: appear
        };
    };
    _proto.updateStatus = function updateStatus(mounting, nextStatus) {
        if (mounting === void 0) mounting = false;
        if (nextStatus !== null) {
            // nextStatus will always be ENTERING or EXITING.
            this.cancelNextCallback();
            if (nextStatus === $a305bfcf210dcb16$export$df38205c966be359) {
                if (this.props.unmountOnExit || this.props.mountOnEnter) {
                    var node = this.props.nodeRef ? this.props.nodeRef.current : (0, (/*@__PURE__*/$parcel$interopDefault($b5d6c7fd13e04efb$exports))).findDOMNode(this); // https://github.com/reactjs/react-transition-group/pull/749
                    // With unmountOnExit or mountOnEnter, the enter animation should happen at the transition between `exited` and `entering`.
                    // To make the animation happen,  we have to separate each rendering and avoid being processed as batched.
                    if (node) (0, $a942f4454771225e$export$7d26bbb1236dafd6)(node);
                }
                this.performEnter(mounting);
            } else this.performExit();
        } else if (this.props.unmountOnExit && this.state.status === $a305bfcf210dcb16$export$84cbff306f539230) this.setState({
            status: $a305bfcf210dcb16$export$bb38bb9a1161268
        });
    };
    _proto.performEnter = function performEnter(mounting) {
        var _this2 = this;
        var enter = this.props.enter;
        var appearing = this.context ? this.context.isMounting : mounting;
        var _ref2 = this.props.nodeRef ? [
            appearing
        ] : [
            (0, (/*@__PURE__*/$parcel$interopDefault($b5d6c7fd13e04efb$exports))).findDOMNode(this),
            appearing
        ], maybeNode = _ref2[0], maybeAppearing = _ref2[1];
        var timeouts = this.getTimeouts();
        var enterTimeout = appearing ? timeouts.appear : timeouts.enter; // no enter animation skip right to ENTERED
        // if we are mounting and running this it means appear _must_ be set
        if (!mounting && !enter || (0, $c284c47e3a796029$export$2e2bcd8739ae039).disabled) {
            this.safeSetState({
                status: $a305bfcf210dcb16$export$78e9e6e3e014d60a
            }, function() {
                _this2.props.onEntered(maybeNode);
            });
            return;
        }
        this.props.onEnter(maybeNode, maybeAppearing);
        this.safeSetState({
            status: $a305bfcf210dcb16$export$df38205c966be359
        }, function() {
            _this2.props.onEntering(maybeNode, maybeAppearing);
            _this2.onTransitionEnd(enterTimeout, function() {
                _this2.safeSetState({
                    status: $a305bfcf210dcb16$export$78e9e6e3e014d60a
                }, function() {
                    _this2.props.onEntered(maybeNode, maybeAppearing);
                });
            });
        });
    };
    _proto.performExit = function performExit() {
        var _this3 = this;
        var exit = this.props.exit;
        var timeouts = this.getTimeouts();
        var maybeNode = this.props.nodeRef ? undefined : (0, (/*@__PURE__*/$parcel$interopDefault($b5d6c7fd13e04efb$exports))).findDOMNode(this); // no exit animation skip right to EXITED
        if (!exit || (0, $c284c47e3a796029$export$2e2bcd8739ae039).disabled) {
            this.safeSetState({
                status: $a305bfcf210dcb16$export$84cbff306f539230
            }, function() {
                _this3.props.onExited(maybeNode);
            });
            return;
        }
        this.props.onExit(maybeNode);
        this.safeSetState({
            status: $a305bfcf210dcb16$export$4aacc83d4d59139f
        }, function() {
            _this3.props.onExiting(maybeNode);
            _this3.onTransitionEnd(timeouts.exit, function() {
                _this3.safeSetState({
                    status: $a305bfcf210dcb16$export$84cbff306f539230
                }, function() {
                    _this3.props.onExited(maybeNode);
                });
            });
        });
    };
    _proto.cancelNextCallback = function cancelNextCallback() {
        if (this.nextCallback !== null) {
            this.nextCallback.cancel();
            this.nextCallback = null;
        }
    };
    _proto.safeSetState = function safeSetState(nextState, callback) {
        // This shouldn't be necessary, but there are weird race conditions with
        // setState callbacks and unmounting in testing, so always make sure that
        // we can cancel any pending setState callbacks after we unmount.
        callback = this.setNextCallback(callback);
        this.setState(nextState, callback);
    };
    _proto.setNextCallback = function setNextCallback(callback) {
        var _this4 = this;
        var active = true;
        this.nextCallback = function(event) {
            if (active) {
                active = false;
                _this4.nextCallback = null;
                callback(event);
            }
        };
        this.nextCallback.cancel = function() {
            active = false;
        };
        return this.nextCallback;
    };
    _proto.onTransitionEnd = function onTransitionEnd(timeout, handler) {
        this.setNextCallback(handler);
        var node = this.props.nodeRef ? this.props.nodeRef.current : (0, (/*@__PURE__*/$parcel$interopDefault($b5d6c7fd13e04efb$exports))).findDOMNode(this);
        var doesNotHaveTimeoutOrListener = timeout == null && !this.props.addEndListener;
        if (!node || doesNotHaveTimeoutOrListener) {
            setTimeout(this.nextCallback, 0);
            return;
        }
        if (this.props.addEndListener) {
            var _ref3 = this.props.nodeRef ? [
                this.nextCallback
            ] : [
                node,
                this.nextCallback
            ], maybeNode = _ref3[0], maybeNextCallback = _ref3[1];
            this.props.addEndListener(maybeNode, maybeNextCallback);
        }
        if (timeout != null) setTimeout(this.nextCallback, timeout);
    };
    _proto.render = function render() {
        var status = this.state.status;
        if (status === $a305bfcf210dcb16$export$bb38bb9a1161268) return null;
        var _this$props = this.props, children = _this$props.children, _in = _this$props.in, _mountOnEnter = _this$props.mountOnEnter, _unmountOnExit = _this$props.unmountOnExit, _appear = _this$props.appear, _enter = _this$props.enter, _exit = _this$props.exit, _timeout = _this$props.timeout, _addEndListener = _this$props.addEndListener, _onEnter = _this$props.onEnter, _onEntering = _this$props.onEntering, _onEntered = _this$props.onEntered, _onExit = _this$props.onExit, _onExiting = _this$props.onExiting, _onExited = _this$props.onExited, _nodeRef = _this$props.nodeRef, childProps = (0, $cTAWX.default)(_this$props, [
            "children",
            "in",
            "mountOnEnter",
            "unmountOnExit",
            "appear",
            "enter",
            "exit",
            "timeout",
            "addEndListener",
            "onEnter",
            "onEntering",
            "onEntered",
            "onExit",
            "onExiting",
            "onExited",
            "nodeRef"
        ]);
        return(/*#__PURE__*/ // allows for nested Transitions
        (0, (/*@__PURE__*/$parcel$interopDefault($gJYWc))).createElement((0, $l6PtU.default).Provider, {
            value: null
        }, typeof children === 'function' ? children(status, childProps) : (0, (/*@__PURE__*/$parcel$interopDefault($gJYWc))).cloneElement((0, (/*@__PURE__*/$parcel$interopDefault($gJYWc))).Children.only(children), childProps)));
    };
    return Transition;
}((0, (/*@__PURE__*/$parcel$interopDefault($gJYWc))).Component);
$a305bfcf210dcb16$var$Transition.contextType = (0, $l6PtU.default);
$a305bfcf210dcb16$var$Transition.propTypes = {}; // Name the function so it is clearer in the documentation
function $a305bfcf210dcb16$var$noop() {}
$a305bfcf210dcb16$var$Transition.defaultProps = {
    in: false,
    mountOnEnter: false,
    unmountOnExit: false,
    appear: false,
    enter: true,
    exit: true,
    onEnter: $a305bfcf210dcb16$var$noop,
    onEntering: $a305bfcf210dcb16$var$noop,
    onEntered: $a305bfcf210dcb16$var$noop,
    onExit: $a305bfcf210dcb16$var$noop,
    onExiting: $a305bfcf210dcb16$var$noop,
    onExited: $a305bfcf210dcb16$var$noop
};
$a305bfcf210dcb16$var$Transition.UNMOUNTED = $a305bfcf210dcb16$export$bb38bb9a1161268;
$a305bfcf210dcb16$var$Transition.EXITED = $a305bfcf210dcb16$export$84cbff306f539230;
$a305bfcf210dcb16$var$Transition.ENTERING = $a305bfcf210dcb16$export$df38205c966be359;
$a305bfcf210dcb16$var$Transition.ENTERED = $a305bfcf210dcb16$export$78e9e6e3e014d60a;
$a305bfcf210dcb16$var$Transition.EXITING = $a305bfcf210dcb16$export$4aacc83d4d59139f;
var $a305bfcf210dcb16$export$2e2bcd8739ae039 = $a305bfcf210dcb16$var$Transition;


parcelRequire("gJYWc");


var $iNcPC = parcelRequire("iNcPC");

var $8Ho5h = parcelRequire("8Ho5h");
'use client';
function $ae968105fc5c093e$export$2e2bcd8739ae039() {
    const theme = (0, $81fc44edf20e1517$export$2e2bcd8739ae039)((0, $iNcPC.default));
    return theme[0, $8Ho5h.default] || theme;
}


const $0abbc08f64007151$export$b7a864e1eaef9de5 = (node)=>node.scrollTop;
function $0abbc08f64007151$export$8cb1e9b404609ae9(props, options) {
    var _style$transitionDura, _style$transitionTimi;
    const { timeout: timeout, easing: easing, style: style = {} } = props;
    return {
        duration: (_style$transitionDura = style.transitionDuration) != null ? _style$transitionDura : typeof timeout === 'number' ? timeout : timeout[options.mode] || 0,
        easing: (_style$transitionTimi = style.transitionTimingFunction) != null ? _style$transitionTimi : typeof easing === 'object' ? easing[options.mode] : easing,
        delay: style.transitionDelay
    };
}



var $il32z = parcelRequire("il32z");

var $9wx12 = parcelRequire("9wx12");
'use client';
const $b8a567fe6aaea15d$var$_excluded = [
    "addEndListener",
    "appear",
    "children",
    "easing",
    "in",
    "onEnter",
    "onEntered",
    "onEntering",
    "onExit",
    "onExited",
    "onExiting",
    "style",
    "timeout",
    "TransitionComponent"
];
function $b8a567fe6aaea15d$var$getScale(value) {
    return `scale(${value}, ${value ** 2})`;
}
const $b8a567fe6aaea15d$var$styles = {
    entering: {
        opacity: 1,
        transform: $b8a567fe6aaea15d$var$getScale(1)
    },
    entered: {
        opacity: 1,
        transform: 'none'
    }
};
/*
 TODO v6: remove
 Conditionally apply a workaround for the CSS transition bug in Safari 15.4 / WebKit browsers.
 */ const $b8a567fe6aaea15d$var$isWebKit154 = typeof navigator !== 'undefined' && /^((?!chrome|android).)*(safari|mobile)/i.test(navigator.userAgent) && /(os |version\/)15(.|_)4/i.test(navigator.userAgent);
/**
 * The Grow transition is used by the [Tooltip](/material-ui/react-tooltip/) and
 * [Popover](/material-ui/react-popover/) components.
 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
 */ const $b8a567fe6aaea15d$var$Grow = /*#__PURE__*/ $gJYWc.forwardRef(function Grow(props, ref) {
    const { addEndListener: addEndListener, appear: appear = true, children: children, easing: easing, in: inProp, onEnter: onEnter, onEntered: onEntered, onEntering: onEntering, onExit: onExit, onExited: onExited, onExiting: onExiting, style: style, timeout: timeout = 'auto', TransitionComponent: // eslint-disable-next-line react/prop-types
    TransitionComponent = (0, $a305bfcf210dcb16$export$2e2bcd8739ae039) } = props, other = (0, $cTAWX.default)(props, $b8a567fe6aaea15d$var$_excluded);
    const timer = (0, $4LiUz.default)();
    const autoTimeout = $gJYWc.useRef();
    const theme = (0, $ae968105fc5c093e$export$2e2bcd8739ae039)();
    const nodeRef = $gJYWc.useRef(null);
    const handleRef = (0, $il32z.default)(nodeRef, (0, $5e9a5fb2b833225d$export$2e2bcd8739ae039)(children), ref);
    const normalizedTransitionCallback = (callback)=>(maybeIsAppearing)=>{
            if (callback) {
                const node = nodeRef.current;
                // onEnterXxx and onExitXxx callbacks have a different arguments.length value.
                if (maybeIsAppearing === undefined) callback(node);
                else callback(node, maybeIsAppearing);
            }
        };
    const handleEntering = normalizedTransitionCallback(onEntering);
    const handleEnter = normalizedTransitionCallback((node, isAppearing)=>{
        (0, $0abbc08f64007151$export$b7a864e1eaef9de5)(node); // So the animation always start from the start.
        const { duration: transitionDuration, delay: delay, easing: transitionTimingFunction } = (0, $0abbc08f64007151$export$8cb1e9b404609ae9)({
            style: style,
            timeout: timeout,
            easing: easing
        }, {
            mode: 'enter'
        });
        let duration;
        if (timeout === 'auto') {
            duration = theme.transitions.getAutoHeightDuration(node.clientHeight);
            autoTimeout.current = duration;
        } else duration = transitionDuration;
        node.style.transition = [
            theme.transitions.create('opacity', {
                duration: duration,
                delay: delay
            }),
            theme.transitions.create('transform', {
                duration: $b8a567fe6aaea15d$var$isWebKit154 ? duration : duration * 0.666,
                delay: delay,
                easing: transitionTimingFunction
            })
        ].join(',');
        if (onEnter) onEnter(node, isAppearing);
    });
    const handleEntered = normalizedTransitionCallback(onEntered);
    const handleExiting = normalizedTransitionCallback(onExiting);
    const handleExit = normalizedTransitionCallback((node)=>{
        const { duration: transitionDuration, delay: delay, easing: transitionTimingFunction } = (0, $0abbc08f64007151$export$8cb1e9b404609ae9)({
            style: style,
            timeout: timeout,
            easing: easing
        }, {
            mode: 'exit'
        });
        let duration;
        if (timeout === 'auto') {
            duration = theme.transitions.getAutoHeightDuration(node.clientHeight);
            autoTimeout.current = duration;
        } else duration = transitionDuration;
        node.style.transition = [
            theme.transitions.create('opacity', {
                duration: duration,
                delay: delay
            }),
            theme.transitions.create('transform', {
                duration: $b8a567fe6aaea15d$var$isWebKit154 ? duration : duration * 0.666,
                delay: $b8a567fe6aaea15d$var$isWebKit154 ? delay : delay || duration * 0.333,
                easing: transitionTimingFunction
            })
        ].join(',');
        node.style.opacity = 0;
        node.style.transform = $b8a567fe6aaea15d$var$getScale(0.75);
        if (onExit) onExit(node);
    });
    const handleExited = normalizedTransitionCallback(onExited);
    const handleAddEndListener = (next)=>{
        if (timeout === 'auto') timer.start(autoTimeout.current || 0, next);
        if (addEndListener) // Old call signature before `react-transition-group` implemented `nodeRef`
        addEndListener(nodeRef.current, next);
    };
    return /*#__PURE__*/ (0, $9wx12.jsx)(TransitionComponent, (0, $3VnFq.default)({
        appear: appear,
        in: inProp,
        nodeRef: nodeRef,
        onEnter: handleEnter,
        onEntered: handleEntered,
        onEntering: handleEntering,
        onExit: handleExit,
        onExited: handleExited,
        onExiting: handleExiting,
        addEndListener: handleAddEndListener,
        timeout: timeout === 'auto' ? null : timeout
    }, other, {
        children: (state, childProps)=>{
            return /*#__PURE__*/ $gJYWc.cloneElement(children, (0, $3VnFq.default)({
                style: (0, $3VnFq.default)({
                    opacity: 0,
                    transform: $b8a567fe6aaea15d$var$getScale(0.75),
                    visibility: state === 'exited' && !inProp ? 'hidden' : undefined
                }, $b8a567fe6aaea15d$var$styles[state], style, children.props.style),
                ref: handleRef
            }, childProps));
        }
    }));
});
$b8a567fe6aaea15d$var$Grow.muiSupportAuto = true;
var $b8a567fe6aaea15d$export$2e2bcd8739ae039 = $b8a567fe6aaea15d$var$Grow;



var $cTAWX = parcelRequire("cTAWX");

var $3VnFq = parcelRequire("3VnFq");

var $gJYWc = parcelRequire("gJYWc");


var $2w6IV = parcelRequire("2w6IV");



var $3e4LV = parcelRequire("3e4LV");


var $gJYWc = parcelRequire("gJYWc");


var $4gWBK = parcelRequire("4gWBK");

var $9wx12 = parcelRequire("9wx12");
'use client';
// Inspired by https://github.com/focus-trap/tabbable
const $535bee45e267492c$var$candidatesSelector = [
    'input',
    'select',
    'textarea',
    'a[href]',
    'button',
    '[tabindex]',
    'audio[controls]',
    'video[controls]',
    '[contenteditable]:not([contenteditable="false"])'
].join(',');
function $535bee45e267492c$var$getTabIndex(node) {
    const tabindexAttr = parseInt(node.getAttribute('tabindex') || '', 10);
    if (!Number.isNaN(tabindexAttr)) return tabindexAttr;
    // Browsers do not return `tabIndex` correctly for contentEditable nodes;
    // https://bugs.chromium.org/p/chromium/issues/detail?id=661108&q=contenteditable%20tabindex&can=2
    // so if they don't have a tabindex attribute specifically set, assume it's 0.
    // in Chrome, <details/>, <audio controls/> and <video controls/> elements get a default
    //  `tabIndex` of -1 when the 'tabindex' attribute isn't specified in the DOM,
    //  yet they are still part of the regular tab order; in FF, they get a default
    //  `tabIndex` of 0; since Chrome still puts those elements in the regular tab
    //  order, consider their tab index to be 0.
    if (node.contentEditable === 'true' || (node.nodeName === 'AUDIO' || node.nodeName === 'VIDEO' || node.nodeName === 'DETAILS') && node.getAttribute('tabindex') === null) return 0;
    return node.tabIndex;
}
function $535bee45e267492c$var$isNonTabbableRadio(node) {
    if (node.tagName !== 'INPUT' || node.type !== 'radio') return false;
    if (!node.name) return false;
    const getRadio = (selector)=>node.ownerDocument.querySelector(`input[type="radio"]${selector}`);
    let roving = getRadio(`[name="${node.name}"]:checked`);
    if (!roving) roving = getRadio(`[name="${node.name}"]`);
    return roving !== node;
}
function $535bee45e267492c$var$isNodeMatchingSelectorFocusable(node) {
    if (node.disabled || node.tagName === 'INPUT' && node.type === 'hidden' || $535bee45e267492c$var$isNonTabbableRadio(node)) return false;
    return true;
}
function $535bee45e267492c$var$defaultGetTabbable(root) {
    const regularTabNodes = [];
    const orderedTabNodes = [];
    Array.from(root.querySelectorAll($535bee45e267492c$var$candidatesSelector)).forEach((node, i)=>{
        const nodeTabIndex = $535bee45e267492c$var$getTabIndex(node);
        if (nodeTabIndex === -1 || !$535bee45e267492c$var$isNodeMatchingSelectorFocusable(node)) return;
        if (nodeTabIndex === 0) regularTabNodes.push(node);
        else orderedTabNodes.push({
            documentOrder: i,
            tabIndex: nodeTabIndex,
            node: node
        });
    });
    return orderedTabNodes.sort((a, b)=>a.tabIndex === b.tabIndex ? a.documentOrder - b.documentOrder : a.tabIndex - b.tabIndex).map((a)=>a.node).concat(regularTabNodes);
}
function $535bee45e267492c$var$defaultIsEnabled() {
    return true;
}
/**
 * @ignore - internal component.
 */ function $535bee45e267492c$var$FocusTrap(props) {
    const { children: children, disableAutoFocus: disableAutoFocus = false, disableEnforceFocus: disableEnforceFocus = false, disableRestoreFocus: disableRestoreFocus = false, getTabbable: getTabbable = $535bee45e267492c$var$defaultGetTabbable, isEnabled: isEnabled = $535bee45e267492c$var$defaultIsEnabled, open: open } = props;
    const ignoreNextEnforceFocus = $gJYWc.useRef(false);
    const sentinelStart = $gJYWc.useRef(null);
    const sentinelEnd = $gJYWc.useRef(null);
    const nodeToRestore = $gJYWc.useRef(null);
    const reactFocusEventTarget = $gJYWc.useRef(null);
    // This variable is useful when disableAutoFocus is true.
    // It waits for the active element to move into the component to activate.
    const activated = $gJYWc.useRef(false);
    const rootRef = $gJYWc.useRef(null);
    const handleRef = (0, $4gWBK.default)((0, $5e9a5fb2b833225d$export$2e2bcd8739ae039)(children), rootRef);
    const lastKeydown = $gJYWc.useRef(null);
    $gJYWc.useEffect(()=>{
        // We might render an empty child.
        if (!open || !rootRef.current) return;
        activated.current = !disableAutoFocus;
    }, [
        disableAutoFocus,
        open
    ]);
    $gJYWc.useEffect(()=>{
        // We might render an empty child.
        if (!open || !rootRef.current) return;
        const doc = (0, $1c0f680786bc49ff$export$2e2bcd8739ae039)(rootRef.current);
        if (!rootRef.current.contains(doc.activeElement)) {
            if (!rootRef.current.hasAttribute('tabIndex')) rootRef.current.setAttribute('tabIndex', '-1');
            if (activated.current) rootRef.current.focus();
        }
        return ()=>{
            // restoreLastFocus()
            if (!disableRestoreFocus) {
                // In IE11 it is possible for document.activeElement to be null resulting
                // in nodeToRestore.current being null.
                // Not all elements in IE11 have a focus method.
                // Once IE11 support is dropped the focus() call can be unconditional.
                if (nodeToRestore.current && nodeToRestore.current.focus) {
                    ignoreNextEnforceFocus.current = true;
                    nodeToRestore.current.focus();
                }
                nodeToRestore.current = null;
            }
        };
    // Missing `disableRestoreFocus` which is fine.
    // We don't support changing that prop on an open FocusTrap
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        open
    ]);
    $gJYWc.useEffect(()=>{
        // We might render an empty child.
        if (!open || !rootRef.current) return;
        const doc = (0, $1c0f680786bc49ff$export$2e2bcd8739ae039)(rootRef.current);
        const loopFocus = (nativeEvent)=>{
            lastKeydown.current = nativeEvent;
            if (disableEnforceFocus || !isEnabled() || nativeEvent.key !== 'Tab') return;
            // Make sure the next tab starts from the right place.
            // doc.activeElement refers to the origin.
            if (doc.activeElement === rootRef.current && nativeEvent.shiftKey) {
                // We need to ignore the next contain as
                // it will try to move the focus back to the rootRef element.
                ignoreNextEnforceFocus.current = true;
                if (sentinelEnd.current) sentinelEnd.current.focus();
            }
        };
        const contain = ()=>{
            const rootElement = rootRef.current;
            // Cleanup functions are executed lazily in React 17.
            // Contain can be called between the component being unmounted and its cleanup function being run.
            if (rootElement === null) return;
            if (!doc.hasFocus() || !isEnabled() || ignoreNextEnforceFocus.current) {
                ignoreNextEnforceFocus.current = false;
                return;
            }
            // The focus is already inside
            if (rootElement.contains(doc.activeElement)) return;
            // The disableEnforceFocus is set and the focus is outside of the focus trap (and sentinel nodes)
            if (disableEnforceFocus && doc.activeElement !== sentinelStart.current && doc.activeElement !== sentinelEnd.current) return;
            // if the focus event is not coming from inside the children's react tree, reset the refs
            if (doc.activeElement !== reactFocusEventTarget.current) reactFocusEventTarget.current = null;
            else if (reactFocusEventTarget.current !== null) return;
            if (!activated.current) return;
            let tabbable = [];
            if (doc.activeElement === sentinelStart.current || doc.activeElement === sentinelEnd.current) tabbable = getTabbable(rootRef.current);
            // one of the sentinel nodes was focused, so move the focus
            // to the first/last tabbable element inside the focus trap
            if (tabbable.length > 0) {
                var _lastKeydown$current, _lastKeydown$current2;
                const isShiftTab = Boolean(((_lastKeydown$current = lastKeydown.current) == null ? void 0 : _lastKeydown$current.shiftKey) && ((_lastKeydown$current2 = lastKeydown.current) == null ? void 0 : _lastKeydown$current2.key) === 'Tab');
                const focusNext = tabbable[0];
                const focusPrevious = tabbable[tabbable.length - 1];
                if (typeof focusNext !== 'string' && typeof focusPrevious !== 'string') {
                    if (isShiftTab) focusPrevious.focus();
                    else focusNext.focus();
                }
            // no tabbable elements in the trap focus or the focus was outside of the focus trap
            } else rootElement.focus();
        };
        doc.addEventListener('focusin', contain);
        doc.addEventListener('keydown', loopFocus, true);
        // With Edge, Safari and Firefox, no focus related events are fired when the focused area stops being a focused area.
        // for example https://bugzilla.mozilla.org/show_bug.cgi?id=559561.
        // Instead, we can look if the active element was restored on the BODY element.
        //
        // The whatwg spec defines how the browser should behave but does not explicitly mention any events:
        // https://html.spec.whatwg.org/multipage/interaction.html#focus-fixup-rule.
        const interval = setInterval(()=>{
            if (doc.activeElement && doc.activeElement.tagName === 'BODY') contain();
        }, 50);
        return ()=>{
            clearInterval(interval);
            doc.removeEventListener('focusin', contain);
            doc.removeEventListener('keydown', loopFocus, true);
        };
    }, [
        disableAutoFocus,
        disableEnforceFocus,
        disableRestoreFocus,
        isEnabled,
        open,
        getTabbable
    ]);
    const onFocus = (event)=>{
        if (nodeToRestore.current === null) nodeToRestore.current = event.relatedTarget;
        activated.current = true;
        reactFocusEventTarget.current = event.target;
        const childrenPropsHandler = children.props.onFocus;
        if (childrenPropsHandler) childrenPropsHandler(event);
    };
    const handleFocusSentinel = (event)=>{
        if (nodeToRestore.current === null) nodeToRestore.current = event.relatedTarget;
        activated.current = true;
    };
    return /*#__PURE__*/ (0, $9wx12.jsxs)($gJYWc.Fragment, {
        children: [
            /*#__PURE__*/ (0, $9wx12.jsx)("div", {
                tabIndex: open ? 0 : -1,
                onFocus: handleFocusSentinel,
                ref: sentinelStart,
                "data-testid": "sentinelStart"
            }),
            /*#__PURE__*/ $gJYWc.cloneElement(children, {
                ref: handleRef,
                onFocus: onFocus
            }),
            /*#__PURE__*/ (0, $9wx12.jsx)("div", {
                tabIndex: open ? 0 : -1,
                onFocus: handleFocusSentinel,
                ref: sentinelEnd,
                "data-testid": "sentinelEnd"
            })
        ]
    });
}
var $535bee45e267492c$export$2e2bcd8739ae039 = $535bee45e267492c$var$FocusTrap;



var $gJYWc = parcelRequire("gJYWc");



var $anPBZ = parcelRequire("anPBZ");
var $4z2O6 = parcelRequire("4z2O6");
var $4gWBK = parcelRequire("4gWBK");

var $9wx12 = parcelRequire("9wx12");
'use client';
function $5e1b47cd36bb0590$var$getContainer(container) {
    return typeof container === 'function' ? container() : container;
}
/**
 * Portals provide a first-class way to render children into a DOM node
 * that exists outside the DOM hierarchy of the parent component.
 *
 * Demos:
 *
 * - [Portal](https://mui.com/material-ui/react-portal/)
 *
 * API:
 *
 * - [Portal API](https://mui.com/material-ui/api/portal/)
 */ const $5e1b47cd36bb0590$var$Portal = /*#__PURE__*/ $gJYWc.forwardRef(function Portal(props, forwardedRef) {
    const { children: children, container: container, disablePortal: disablePortal = false } = props;
    const [mountNode, setMountNode] = $gJYWc.useState(null);
    const handleRef = (0, $4gWBK.default)(/*#__PURE__*/ $gJYWc.isValidElement(children) ? (0, $5e9a5fb2b833225d$export$2e2bcd8739ae039)(children) : null, forwardedRef);
    (0, $4z2O6.default)(()=>{
        if (!disablePortal) setMountNode($5e1b47cd36bb0590$var$getContainer(container) || document.body);
    }, [
        container,
        disablePortal
    ]);
    (0, $4z2O6.default)(()=>{
        if (mountNode && !disablePortal) {
            (0, $anPBZ.default)(forwardedRef, mountNode);
            return ()=>{
                (0, $anPBZ.default)(forwardedRef, null);
            };
        }
        return undefined;
    }, [
        forwardedRef,
        mountNode,
        disablePortal
    ]);
    if (disablePortal) {
        if (/*#__PURE__*/ $gJYWc.isValidElement(children)) {
            const newProps = {
                ref: handleRef
            };
            return /*#__PURE__*/ $gJYWc.cloneElement(children, newProps);
        }
        return /*#__PURE__*/ (0, $9wx12.jsx)($gJYWc.Fragment, {
            children: children
        });
    }
    return /*#__PURE__*/ (0, $9wx12.jsx)($gJYWc.Fragment, {
        children: mountNode ? /*#__PURE__*/ $b5d6c7fd13e04efb$exports.createPortal(children, mountNode) : mountNode
    });
});
var $5e1b47cd36bb0590$export$2e2bcd8739ae039 = $5e1b47cd36bb0590$var$Portal;



var $HGmne = parcelRequire("HGmne");

var $8pLcn = parcelRequire("8pLcn");

var $cTAWX = parcelRequire("cTAWX");

var $3VnFq = parcelRequire("3VnFq");

var $gJYWc = parcelRequire("gJYWc");


var $2w6IV = parcelRequire("2w6IV");

var $3e4LV = parcelRequire("3e4LV");

var $HGmne = parcelRequire("HGmne");

var $8pLcn = parcelRequire("8pLcn");

var $3VnFq = parcelRequire("3VnFq");

var $cTAWX = parcelRequire("cTAWX");

var $gJYWc = parcelRequire("gJYWc");







var $il32z = parcelRequire("il32z");

var $9wx12 = parcelRequire("9wx12");
'use client';
const $5d4a7e2c608c4487$var$_excluded = [
    "addEndListener",
    "appear",
    "children",
    "easing",
    "in",
    "onEnter",
    "onEntered",
    "onEntering",
    "onExit",
    "onExited",
    "onExiting",
    "style",
    "timeout",
    "TransitionComponent"
];
const $5d4a7e2c608c4487$var$styles = {
    entering: {
        opacity: 1
    },
    entered: {
        opacity: 1
    }
};
/**
 * The Fade transition is used by the [Modal](/material-ui/react-modal/) component.
 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
 */ const $5d4a7e2c608c4487$var$Fade = /*#__PURE__*/ $gJYWc.forwardRef(function Fade(props, ref) {
    const theme = (0, $ae968105fc5c093e$export$2e2bcd8739ae039)();
    const defaultTimeout = {
        enter: theme.transitions.duration.enteringScreen,
        exit: theme.transitions.duration.leavingScreen
    };
    const { addEndListener: addEndListener, appear: appear = true, children: children, easing: easing, in: inProp, onEnter: onEnter, onEntered: onEntered, onEntering: onEntering, onExit: onExit, onExited: onExited, onExiting: onExiting, style: style, timeout: timeout = defaultTimeout, TransitionComponent: // eslint-disable-next-line react/prop-types
    TransitionComponent = (0, $a305bfcf210dcb16$export$2e2bcd8739ae039) } = props, other = (0, $cTAWX.default)(props, $5d4a7e2c608c4487$var$_excluded);
    const enableStrictModeCompat = true;
    const nodeRef = $gJYWc.useRef(null);
    const handleRef = (0, $il32z.default)(nodeRef, (0, $5e9a5fb2b833225d$export$2e2bcd8739ae039)(children), ref);
    const normalizedTransitionCallback = (callback)=>(maybeIsAppearing)=>{
            if (callback) {
                const node = nodeRef.current;
                // onEnterXxx and onExitXxx callbacks have a different arguments.length value.
                if (maybeIsAppearing === undefined) callback(node);
                else callback(node, maybeIsAppearing);
            }
        };
    const handleEntering = normalizedTransitionCallback(onEntering);
    const handleEnter = normalizedTransitionCallback((node, isAppearing)=>{
        (0, $0abbc08f64007151$export$b7a864e1eaef9de5)(node); // So the animation always start from the start.
        const transitionProps = (0, $0abbc08f64007151$export$8cb1e9b404609ae9)({
            style: style,
            timeout: timeout,
            easing: easing
        }, {
            mode: 'enter'
        });
        node.style.webkitTransition = theme.transitions.create('opacity', transitionProps);
        node.style.transition = theme.transitions.create('opacity', transitionProps);
        if (onEnter) onEnter(node, isAppearing);
    });
    const handleEntered = normalizedTransitionCallback(onEntered);
    const handleExiting = normalizedTransitionCallback(onExiting);
    const handleExit = normalizedTransitionCallback((node)=>{
        const transitionProps = (0, $0abbc08f64007151$export$8cb1e9b404609ae9)({
            style: style,
            timeout: timeout,
            easing: easing
        }, {
            mode: 'exit'
        });
        node.style.webkitTransition = theme.transitions.create('opacity', transitionProps);
        node.style.transition = theme.transitions.create('opacity', transitionProps);
        if (onExit) onExit(node);
    });
    const handleExited = normalizedTransitionCallback(onExited);
    const handleAddEndListener = (next)=>{
        if (addEndListener) // Old call signature before `react-transition-group` implemented `nodeRef`
        addEndListener(nodeRef.current, next);
    };
    return /*#__PURE__*/ (0, $9wx12.jsx)(TransitionComponent, (0, $3VnFq.default)({
        appear: appear,
        in: inProp,
        nodeRef: enableStrictModeCompat ? nodeRef : undefined,
        onEnter: handleEnter,
        onEntered: handleEntered,
        onEntering: handleEntering,
        onExit: handleExit,
        onExited: handleExited,
        onExiting: handleExiting,
        addEndListener: handleAddEndListener,
        timeout: timeout
    }, other, {
        children: (state, childProps)=>{
            return /*#__PURE__*/ $gJYWc.cloneElement(children, (0, $3VnFq.default)({
                style: (0, $3VnFq.default)({
                    opacity: 0,
                    visibility: state === 'exited' && !inProp ? 'hidden' : undefined
                }, $5d4a7e2c608c4487$var$styles[state], style, children.props.style),
                ref: handleRef
            }, childProps));
        }
    }));
});
var $5d4a7e2c608c4487$export$2e2bcd8739ae039 = $5d4a7e2c608c4487$var$Fade;



var $i8nzj = parcelRequire("i8nzj");

var $1kRHf = parcelRequire("1kRHf");
function $d9dcdc5b6b54cb0b$export$9927a91fd93152bd(slot) {
    return (0, $1kRHf.default)('MuiBackdrop', slot);
}
const $d9dcdc5b6b54cb0b$var$backdropClasses = (0, $i8nzj.default)('MuiBackdrop', [
    'root',
    'invisible'
]);
var $d9dcdc5b6b54cb0b$export$2e2bcd8739ae039 = $d9dcdc5b6b54cb0b$var$backdropClasses;



var $9wx12 = parcelRequire("9wx12");
'use client';
const $826f007e2fc51e5c$var$_excluded = [
    "children",
    "className",
    "component",
    "components",
    "componentsProps",
    "invisible",
    "open",
    "slotProps",
    "slots",
    "TransitionComponent",
    "transitionDuration"
];
const $826f007e2fc51e5c$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, invisible: invisible } = ownerState;
    const slots = {
        root: [
            'root',
            invisible && 'invisible'
        ]
    };
    return (0, $3e4LV.default)(slots, (0, $d9dcdc5b6b54cb0b$export$9927a91fd93152bd), classes);
};
const $826f007e2fc51e5c$var$BackdropRoot = (0, $HGmne.default)('div', {
    name: 'MuiBackdrop',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.invisible && styles.invisible
        ];
    }
})(({ ownerState: ownerState })=>(0, $3VnFq.default)({
        position: 'fixed',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        right: 0,
        bottom: 0,
        top: 0,
        left: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
        WebkitTapHighlightColor: 'transparent'
    }, ownerState.invisible && {
        backgroundColor: 'transparent'
    }));
const $826f007e2fc51e5c$var$Backdrop = /*#__PURE__*/ $gJYWc.forwardRef(function Backdrop(inProps, ref) {
    var _slotProps$root, _ref, _slots$root;
    const props = (0, $8pLcn.useDefaultProps)({
        props: inProps,
        name: 'MuiBackdrop'
    });
    const { children: children, className: className, component: component = 'div', components: components = {}, componentsProps: componentsProps = {}, invisible: invisible = false, open: open, slotProps: slotProps = {}, slots: slots = {}, TransitionComponent: TransitionComponent = (0, $5d4a7e2c608c4487$export$2e2bcd8739ae039), transitionDuration: transitionDuration } = props, other = (0, $cTAWX.default)(props, $826f007e2fc51e5c$var$_excluded);
    const ownerState = (0, $3VnFq.default)({}, props, {
        component: component,
        invisible: invisible
    });
    const classes = $826f007e2fc51e5c$var$useUtilityClasses(ownerState);
    const rootSlotProps = (_slotProps$root = slotProps.root) != null ? _slotProps$root : componentsProps.root;
    return /*#__PURE__*/ (0, $9wx12.jsx)(TransitionComponent, (0, $3VnFq.default)({
        in: open,
        timeout: transitionDuration
    }, other, {
        children: /*#__PURE__*/ (0, $9wx12.jsx)($826f007e2fc51e5c$var$BackdropRoot, (0, $3VnFq.default)({
            "aria-hidden": true
        }, rootSlotProps, {
            as: (_ref = (_slots$root = slots.root) != null ? _slots$root : components.Root) != null ? _ref : component,
            className: (0, $2w6IV.default)(classes.root, className, rootSlotProps == null ? void 0 : rootSlotProps.className),
            ownerState: (0, $3VnFq.default)({}, ownerState, rootSlotProps == null ? void 0 : rootSlotProps.ownerState),
            classes: classes,
            ref: ref,
            children: children
        }))
    }));
});
var $826f007e2fc51e5c$export$2e2bcd8739ae039 = $826f007e2fc51e5c$var$Backdrop;



var $3VnFq = parcelRequire("3VnFq");

var $gJYWc = parcelRequire("gJYWc");
/**
 * Safe chained function.
 *
 * Will only create a new function if needed,
 * otherwise will pass back existing functions or null.
 */ function $87953551827e77e7$export$2e2bcd8739ae039(...funcs) {
    return funcs.reduce((acc, func)=>{
        if (func == null) return acc;
        return function chainedFunction(...args) {
            acc.apply(this, args);
            func.apply(this, args);
        };
    }, ()=>{});
}


var $92UcI = parcelRequire("92UcI");
var $4gWBK = parcelRequire("4gWBK");

// A change of the browser zoom change the scrollbar size.
// Credit https://github.com/twbs/bootstrap/blob/488fd8afc535ca3a6ad4dc581f5e89217b6a36ac/js/src/util/scrollbar.js#L14-L18
function $a87ca72e028a1761$export$2e2bcd8739ae039(doc) {
    // https://developer.mozilla.org/en-US/docs/Web/API/Window/innerWidth#usage_notes
    const documentWidth = doc.documentElement.clientWidth;
    return Math.abs(window.innerWidth - documentWidth);
}


// Is a vertical scrollbar displayed?
function $5bb5c48d69b8e15b$var$isOverflowing(container) {
    const doc = (0, $1c0f680786bc49ff$export$2e2bcd8739ae039)(container);
    if (doc.body === container) return (0, $ba6d5d10c948f9ac$export$2e2bcd8739ae039)(container).innerWidth > doc.documentElement.clientWidth;
    return container.scrollHeight > container.clientHeight;
}
function $5bb5c48d69b8e15b$export$e1bd0c6150f13d96(element, show) {
    if (show) element.setAttribute('aria-hidden', 'true');
    else element.removeAttribute('aria-hidden');
}
function $5bb5c48d69b8e15b$var$getPaddingRight(element) {
    return parseInt((0, $ba6d5d10c948f9ac$export$2e2bcd8739ae039)(element).getComputedStyle(element).paddingRight, 10) || 0;
}
function $5bb5c48d69b8e15b$var$isAriaHiddenForbiddenOnElement(element) {
    // The forbidden HTML tags are the ones from ARIA specification that
    // can be children of body and can't have aria-hidden attribute.
    // cf. https://www.w3.org/TR/html-aria/#docconformance
    const forbiddenTagNames = [
        'TEMPLATE',
        'SCRIPT',
        'STYLE',
        'LINK',
        'MAP',
        'META',
        'NOSCRIPT',
        'PICTURE',
        'COL',
        'COLGROUP',
        'PARAM',
        'SLOT',
        'SOURCE',
        'TRACK'
    ];
    const isForbiddenTagName = forbiddenTagNames.indexOf(element.tagName) !== -1;
    const isInputHidden = element.tagName === 'INPUT' && element.getAttribute('type') === 'hidden';
    return isForbiddenTagName || isInputHidden;
}
function $5bb5c48d69b8e15b$var$ariaHiddenSiblings(container, mountElement, currentElement, elementsToExclude, show) {
    const blacklist = [
        mountElement,
        currentElement,
        ...elementsToExclude
    ];
    [].forEach.call(container.children, (element)=>{
        const isNotExcludedElement = blacklist.indexOf(element) === -1;
        const isNotForbiddenElement = !$5bb5c48d69b8e15b$var$isAriaHiddenForbiddenOnElement(element);
        if (isNotExcludedElement && isNotForbiddenElement) $5bb5c48d69b8e15b$export$e1bd0c6150f13d96(element, show);
    });
}
function $5bb5c48d69b8e15b$var$findIndexOf(items, callback) {
    let idx = -1;
    items.some((item, index)=>{
        if (callback(item)) {
            idx = index;
            return true;
        }
        return false;
    });
    return idx;
}
function $5bb5c48d69b8e15b$var$handleContainer(containerInfo, props) {
    const restoreStyle = [];
    const container = containerInfo.container;
    if (!props.disableScrollLock) {
        if ($5bb5c48d69b8e15b$var$isOverflowing(container)) {
            // Compute the size before applying overflow hidden to avoid any scroll jumps.
            const scrollbarSize = (0, $a87ca72e028a1761$export$2e2bcd8739ae039)((0, $1c0f680786bc49ff$export$2e2bcd8739ae039)(container));
            restoreStyle.push({
                value: container.style.paddingRight,
                property: 'padding-right',
                el: container
            });
            // Use computed style, here to get the real padding to add our scrollbar width.
            container.style.paddingRight = `${$5bb5c48d69b8e15b$var$getPaddingRight(container) + scrollbarSize}px`;
            // .mui-fixed is a global helper.
            const fixedElements = (0, $1c0f680786bc49ff$export$2e2bcd8739ae039)(container).querySelectorAll('.mui-fixed');
            [].forEach.call(fixedElements, (element)=>{
                restoreStyle.push({
                    value: element.style.paddingRight,
                    property: 'padding-right',
                    el: element
                });
                element.style.paddingRight = `${$5bb5c48d69b8e15b$var$getPaddingRight(element) + scrollbarSize}px`;
            });
        }
        let scrollContainer;
        if (container.parentNode instanceof DocumentFragment) scrollContainer = (0, $1c0f680786bc49ff$export$2e2bcd8739ae039)(container).body;
        else {
            // Support html overflow-y: auto for scroll stability between pages
            // https://css-tricks.com/snippets/css/force-vertical-scrollbar/
            const parent = container.parentElement;
            const containerWindow = (0, $ba6d5d10c948f9ac$export$2e2bcd8739ae039)(container);
            scrollContainer = (parent == null ? void 0 : parent.nodeName) === 'HTML' && containerWindow.getComputedStyle(parent).overflowY === 'scroll' ? parent : container;
        }
        // Block the scroll even if no scrollbar is visible to account for mobile keyboard
        // screensize shrink.
        restoreStyle.push({
            value: scrollContainer.style.overflow,
            property: 'overflow',
            el: scrollContainer
        }, {
            value: scrollContainer.style.overflowX,
            property: 'overflow-x',
            el: scrollContainer
        }, {
            value: scrollContainer.style.overflowY,
            property: 'overflow-y',
            el: scrollContainer
        });
        scrollContainer.style.overflow = 'hidden';
    }
    const restore = ()=>{
        restoreStyle.forEach(({ value: value, el: el, property: property })=>{
            if (value) el.style.setProperty(property, value);
            else el.style.removeProperty(property);
        });
    };
    return restore;
}
function $5bb5c48d69b8e15b$var$getHiddenSiblings(container) {
    const hiddenSiblings = [];
    [].forEach.call(container.children, (element)=>{
        if (element.getAttribute('aria-hidden') === 'true') hiddenSiblings.push(element);
    });
    return hiddenSiblings;
}
class $5bb5c48d69b8e15b$export$ce11c4ecd08cea67 {
    add(modal, container) {
        let modalIndex = this.modals.indexOf(modal);
        if (modalIndex !== -1) return modalIndex;
        modalIndex = this.modals.length;
        this.modals.push(modal);
        // If the modal we are adding is already in the DOM.
        if (modal.modalRef) $5bb5c48d69b8e15b$export$e1bd0c6150f13d96(modal.modalRef, false);
        const hiddenSiblings = $5bb5c48d69b8e15b$var$getHiddenSiblings(container);
        $5bb5c48d69b8e15b$var$ariaHiddenSiblings(container, modal.mount, modal.modalRef, hiddenSiblings, true);
        const containerIndex = $5bb5c48d69b8e15b$var$findIndexOf(this.containers, (item)=>item.container === container);
        if (containerIndex !== -1) {
            this.containers[containerIndex].modals.push(modal);
            return modalIndex;
        }
        this.containers.push({
            modals: [
                modal
            ],
            container: container,
            restore: null,
            hiddenSiblings: hiddenSiblings
        });
        return modalIndex;
    }
    mount(modal, props) {
        const containerIndex = $5bb5c48d69b8e15b$var$findIndexOf(this.containers, (item)=>item.modals.indexOf(modal) !== -1);
        const containerInfo = this.containers[containerIndex];
        if (!containerInfo.restore) containerInfo.restore = $5bb5c48d69b8e15b$var$handleContainer(containerInfo, props);
    }
    remove(modal, ariaHiddenState = true) {
        const modalIndex = this.modals.indexOf(modal);
        if (modalIndex === -1) return modalIndex;
        const containerIndex = $5bb5c48d69b8e15b$var$findIndexOf(this.containers, (item)=>item.modals.indexOf(modal) !== -1);
        const containerInfo = this.containers[containerIndex];
        containerInfo.modals.splice(containerInfo.modals.indexOf(modal), 1);
        this.modals.splice(modalIndex, 1);
        // If that was the last modal in a container, clean up the container.
        if (containerInfo.modals.length === 0) {
            // The modal might be closed before it had the chance to be mounted in the DOM.
            if (containerInfo.restore) containerInfo.restore();
            if (modal.modalRef) // In case the modal wasn't in the DOM yet.
            $5bb5c48d69b8e15b$export$e1bd0c6150f13d96(modal.modalRef, ariaHiddenState);
            $5bb5c48d69b8e15b$var$ariaHiddenSiblings(containerInfo.container, modal.mount, modal.modalRef, containerInfo.hiddenSiblings, false);
            this.containers.splice(containerIndex, 1);
        } else {
            // Otherwise make sure the next top modal is visible to a screen reader.
            const nextTop = containerInfo.modals[containerInfo.modals.length - 1];
            // as soon as a modal is adding its modalRef is undefined. it can't set
            // aria-hidden because the dom element doesn't exist either
            // when modal was unmounted before modalRef gets null
            if (nextTop.modalRef) $5bb5c48d69b8e15b$export$e1bd0c6150f13d96(nextTop.modalRef, false);
        }
        return modalIndex;
    }
    isTopModal(modal) {
        return this.modals.length > 0 && this.modals[this.modals.length - 1] === modal;
    }
    constructor(){
        this.containers = void 0;
        this.modals = void 0;
        this.modals = [];
        this.containers = [];
    }
}


'use client';
function $dfbe80c7f509efe0$var$getContainer(container) {
    return typeof container === 'function' ? container() : container;
}
function $dfbe80c7f509efe0$var$getHasTransition(children) {
    return children ? children.props.hasOwnProperty('in') : false;
}
// A modal manager used to track and manage the state of open Modals.
// Modals don't open on the server so this won't conflict with concurrent requests.
const $dfbe80c7f509efe0$var$defaultManager = new (0, $5bb5c48d69b8e15b$export$ce11c4ecd08cea67)();
/**
 *
 * Demos:
 *
 * - [Modal](https://mui.com/base-ui/react-modal/#hook)
 *
 * API:
 *
 * - [useModal API](https://mui.com/base-ui/react-modal/hooks-api/#use-modal)
 */ function $dfbe80c7f509efe0$var$useModal(parameters) {
    const { container: container, disableEscapeKeyDown: disableEscapeKeyDown = false, disableScrollLock: disableScrollLock = false, manager: // @ts-ignore internal logic - Base UI supports the manager as a prop too
    manager = $dfbe80c7f509efe0$var$defaultManager, closeAfterTransition: closeAfterTransition = false, onTransitionEnter: onTransitionEnter, onTransitionExited: onTransitionExited, children: children, onClose: onClose, open: open, rootRef: rootRef } = parameters;
    // @ts-ignore internal logic
    const modal = $gJYWc.useRef({});
    const mountNodeRef = $gJYWc.useRef(null);
    const modalRef = $gJYWc.useRef(null);
    const handleRef = (0, $4gWBK.default)(modalRef, rootRef);
    const [exited, setExited] = $gJYWc.useState(!open);
    const hasTransition = $dfbe80c7f509efe0$var$getHasTransition(children);
    let ariaHiddenProp = true;
    if (parameters['aria-hidden'] === 'false' || parameters['aria-hidden'] === false) ariaHiddenProp = false;
    const getDoc = ()=>(0, $1c0f680786bc49ff$export$2e2bcd8739ae039)(mountNodeRef.current);
    const getModal = ()=>{
        modal.current.modalRef = modalRef.current;
        modal.current.mount = mountNodeRef.current;
        return modal.current;
    };
    const handleMounted = ()=>{
        manager.mount(getModal(), {
            disableScrollLock: disableScrollLock
        });
        // Fix a bug on Chrome where the scroll isn't initially 0.
        if (modalRef.current) modalRef.current.scrollTop = 0;
    };
    const handleOpen = (0, $92UcI.default)(()=>{
        const resolvedContainer = $dfbe80c7f509efe0$var$getContainer(container) || getDoc().body;
        manager.add(getModal(), resolvedContainer);
        // The element was already mounted.
        if (modalRef.current) handleMounted();
    });
    const isTopModal = $gJYWc.useCallback(()=>manager.isTopModal(getModal()), [
        manager
    ]);
    const handlePortalRef = (0, $92UcI.default)((node)=>{
        mountNodeRef.current = node;
        if (!node) return;
        if (open && isTopModal()) handleMounted();
        else if (modalRef.current) (0, $5bb5c48d69b8e15b$export$e1bd0c6150f13d96)(modalRef.current, ariaHiddenProp);
    });
    const handleClose = $gJYWc.useCallback(()=>{
        manager.remove(getModal(), ariaHiddenProp);
    }, [
        ariaHiddenProp,
        manager
    ]);
    $gJYWc.useEffect(()=>{
        return ()=>{
            handleClose();
        };
    }, [
        handleClose
    ]);
    $gJYWc.useEffect(()=>{
        if (open) handleOpen();
        else if (!hasTransition || !closeAfterTransition) handleClose();
    }, [
        open,
        handleClose,
        hasTransition,
        closeAfterTransition,
        handleOpen
    ]);
    const createHandleKeyDown = (otherHandlers)=>(event)=>{
            var _otherHandlers$onKeyD;
            (_otherHandlers$onKeyD = otherHandlers.onKeyDown) == null || _otherHandlers$onKeyD.call(otherHandlers, event);
            // The handler doesn't take event.defaultPrevented into account:
            //
            // event.preventDefault() is meant to stop default behaviors like
            // clicking a checkbox to check it, hitting a button to submit a form,
            // and hitting left arrow to move the cursor in a text input etc.
            // Only special HTML elements have these default behaviors.
            if (event.key !== 'Escape' || event.which === 229 || // Wait until IME is settled.
            !isTopModal()) return;
            if (!disableEscapeKeyDown) {
                // Swallow the event, in case someone is listening for the escape key on the body.
                event.stopPropagation();
                if (onClose) onClose(event, 'escapeKeyDown');
            }
        };
    const createHandleBackdropClick = (otherHandlers)=>(event)=>{
            var _otherHandlers$onClic;
            (_otherHandlers$onClic = otherHandlers.onClick) == null || _otherHandlers$onClic.call(otherHandlers, event);
            if (event.target !== event.currentTarget) return;
            if (onClose) onClose(event, 'backdropClick');
        };
    const getRootProps = (otherHandlers = {})=>{
        const propsEventHandlers = (0, $d869d422b46f9b96$export$2e2bcd8739ae039)(parameters);
        // The custom event handlers shouldn't be spread on the root element
        delete propsEventHandlers.onTransitionEnter;
        delete propsEventHandlers.onTransitionExited;
        const externalEventHandlers = (0, $3VnFq.default)({}, propsEventHandlers, otherHandlers);
        return (0, $3VnFq.default)({
            role: 'presentation'
        }, externalEventHandlers, {
            onKeyDown: createHandleKeyDown(externalEventHandlers),
            ref: handleRef
        });
    };
    const getBackdropProps = (otherHandlers = {})=>{
        const externalEventHandlers = otherHandlers;
        return (0, $3VnFq.default)({
            'aria-hidden': true
        }, externalEventHandlers, {
            onClick: createHandleBackdropClick(externalEventHandlers),
            open: open
        });
    };
    const getTransitionProps = ()=>{
        const handleEnter = ()=>{
            setExited(false);
            if (onTransitionEnter) onTransitionEnter();
        };
        const handleExited = ()=>{
            setExited(true);
            if (onTransitionExited) onTransitionExited();
            if (closeAfterTransition) handleClose();
        };
        return {
            onEnter: (0, $87953551827e77e7$export$2e2bcd8739ae039)(handleEnter, children == null ? void 0 : children.props.onEnter),
            onExited: (0, $87953551827e77e7$export$2e2bcd8739ae039)(handleExited, children == null ? void 0 : children.props.onExited)
        };
    };
    return {
        getRootProps: getRootProps,
        getBackdropProps: getBackdropProps,
        getTransitionProps: getTransitionProps,
        rootRef: handleRef,
        portalRef: handlePortalRef,
        isTopModal: isTopModal,
        exited: exited,
        hasTransition: hasTransition
    };
}
var $dfbe80c7f509efe0$export$2e2bcd8739ae039 = $dfbe80c7f509efe0$var$useModal;



var $i8nzj = parcelRequire("i8nzj");

var $1kRHf = parcelRequire("1kRHf");
function $2546250aa35d8c60$export$67960e22b12a638d(slot) {
    return (0, $1kRHf.default)('MuiModal', slot);
}
const $2546250aa35d8c60$var$modalClasses = (0, $i8nzj.default)('MuiModal', [
    'root',
    'hidden',
    'backdrop'
]);
var $2546250aa35d8c60$export$2e2bcd8739ae039 = $2546250aa35d8c60$var$modalClasses;



var $9wx12 = parcelRequire("9wx12");
'use client';
const $9479e61072db3f56$var$_excluded = [
    "BackdropComponent",
    "BackdropProps",
    "classes",
    "className",
    "closeAfterTransition",
    "children",
    "container",
    "component",
    "components",
    "componentsProps",
    "disableAutoFocus",
    "disableEnforceFocus",
    "disableEscapeKeyDown",
    "disablePortal",
    "disableRestoreFocus",
    "disableScrollLock",
    "hideBackdrop",
    "keepMounted",
    "onBackdropClick",
    "onClose",
    "onTransitionEnter",
    "onTransitionExited",
    "open",
    "slotProps",
    "slots",
    "theme"
];
const $9479e61072db3f56$var$useUtilityClasses = (ownerState)=>{
    const { open: open, exited: exited, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            !open && exited && 'hidden'
        ],
        backdrop: [
            'backdrop'
        ]
    };
    return (0, $3e4LV.default)(slots, (0, $2546250aa35d8c60$export$67960e22b12a638d), classes);
};
const $9479e61072db3f56$var$ModalRoot = (0, $HGmne.default)('div', {
    name: 'MuiModal',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            !ownerState.open && ownerState.exited && styles.hidden
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $3VnFq.default)({
        position: 'fixed',
        zIndex: (theme.vars || theme).zIndex.modal,
        right: 0,
        bottom: 0,
        top: 0,
        left: 0
    }, !ownerState.open && ownerState.exited && {
        visibility: 'hidden'
    }));
const $9479e61072db3f56$var$ModalBackdrop = (0, $HGmne.default)((0, $826f007e2fc51e5c$export$2e2bcd8739ae039), {
    name: 'MuiModal',
    slot: 'Backdrop',
    overridesResolver: (props, styles)=>{
        return styles.backdrop;
    }
})({
    zIndex: -1
});
/**
 * Modal is a lower-level construct that is leveraged by the following components:
 *
 * - [Dialog](/material-ui/api/dialog/)
 * - [Drawer](/material-ui/api/drawer/)
 * - [Menu](/material-ui/api/menu/)
 * - [Popover](/material-ui/api/popover/)
 *
 * If you are creating a modal dialog, you probably want to use the [Dialog](/material-ui/api/dialog/) component
 * rather than directly using Modal.
 *
 * This component shares many concepts with [react-overlays](https://react-bootstrap.github.io/react-overlays/#modals).
 */ const $9479e61072db3f56$var$Modal = /*#__PURE__*/ $gJYWc.forwardRef(function Modal(inProps, ref) {
    var _ref, _slots$root, _ref2, _slots$backdrop, _slotProps$root, _slotProps$backdrop;
    const props = (0, $8pLcn.useDefaultProps)({
        name: 'MuiModal',
        props: inProps
    });
    const { BackdropComponent: BackdropComponent = $9479e61072db3f56$var$ModalBackdrop, BackdropProps: BackdropProps, className: className, closeAfterTransition: closeAfterTransition = false, children: children, container: container, component: component, components: components = {}, componentsProps: componentsProps = {}, disableAutoFocus: disableAutoFocus = false, disableEnforceFocus: disableEnforceFocus = false, disableEscapeKeyDown: disableEscapeKeyDown = false, disablePortal: disablePortal = false, disableRestoreFocus: disableRestoreFocus = false, disableScrollLock: disableScrollLock = false, hideBackdrop: hideBackdrop = false, keepMounted: keepMounted = false, onBackdropClick: onBackdropClick, open: open, slotProps: slotProps, slots: slots } = props, other = (0, $cTAWX.default)(props, $9479e61072db3f56$var$_excluded);
    const propsWithDefaults = (0, $3VnFq.default)({}, props, {
        closeAfterTransition: closeAfterTransition,
        disableAutoFocus: disableAutoFocus,
        disableEnforceFocus: disableEnforceFocus,
        disableEscapeKeyDown: disableEscapeKeyDown,
        disablePortal: disablePortal,
        disableRestoreFocus: disableRestoreFocus,
        disableScrollLock: disableScrollLock,
        hideBackdrop: hideBackdrop,
        keepMounted: keepMounted
    });
    const { getRootProps: getRootProps, getBackdropProps: getBackdropProps, getTransitionProps: getTransitionProps, portalRef: portalRef, isTopModal: isTopModal, exited: exited, hasTransition: hasTransition } = (0, $dfbe80c7f509efe0$export$2e2bcd8739ae039)((0, $3VnFq.default)({}, propsWithDefaults, {
        rootRef: ref
    }));
    const ownerState = (0, $3VnFq.default)({}, propsWithDefaults, {
        exited: exited
    });
    const classes = $9479e61072db3f56$var$useUtilityClasses(ownerState);
    const childProps = {};
    if (children.props.tabIndex === undefined) childProps.tabIndex = '-1';
    // It's a Transition like component
    if (hasTransition) {
        const { onEnter: onEnter, onExited: onExited } = getTransitionProps();
        childProps.onEnter = onEnter;
        childProps.onExited = onExited;
    }
    const RootSlot = (_ref = (_slots$root = slots == null ? void 0 : slots.root) != null ? _slots$root : components.Root) != null ? _ref : $9479e61072db3f56$var$ModalRoot;
    const BackdropSlot = (_ref2 = (_slots$backdrop = slots == null ? void 0 : slots.backdrop) != null ? _slots$backdrop : components.Backdrop) != null ? _ref2 : BackdropComponent;
    const rootSlotProps = (_slotProps$root = slotProps == null ? void 0 : slotProps.root) != null ? _slotProps$root : componentsProps.root;
    const backdropSlotProps = (_slotProps$backdrop = slotProps == null ? void 0 : slotProps.backdrop) != null ? _slotProps$backdrop : componentsProps.backdrop;
    const rootProps = (0, $2f70e5a04f888acc$export$2e2bcd8739ae039)({
        elementType: RootSlot,
        externalSlotProps: rootSlotProps,
        externalForwardedProps: other,
        getSlotProps: getRootProps,
        additionalProps: {
            ref: ref,
            as: component
        },
        ownerState: ownerState,
        className: (0, $2w6IV.default)(className, rootSlotProps == null ? void 0 : rootSlotProps.className, classes == null ? void 0 : classes.root, !ownerState.open && ownerState.exited && (classes == null ? void 0 : classes.hidden))
    });
    const backdropProps = (0, $2f70e5a04f888acc$export$2e2bcd8739ae039)({
        elementType: BackdropSlot,
        externalSlotProps: backdropSlotProps,
        additionalProps: BackdropProps,
        getSlotProps: (otherHandlers)=>{
            return getBackdropProps((0, $3VnFq.default)({}, otherHandlers, {
                onClick: (e)=>{
                    if (onBackdropClick) onBackdropClick(e);
                    if (otherHandlers != null && otherHandlers.onClick) otherHandlers.onClick(e);
                }
            }));
        },
        className: (0, $2w6IV.default)(backdropSlotProps == null ? void 0 : backdropSlotProps.className, BackdropProps == null ? void 0 : BackdropProps.className, classes == null ? void 0 : classes.backdrop),
        ownerState: ownerState
    });
    if (!keepMounted && !open && (!hasTransition || exited)) return null;
    return /*#__PURE__*/ (0, $9wx12.jsx)((0, $5e1b47cd36bb0590$export$2e2bcd8739ae039), {
        ref: portalRef,
        container: container,
        disablePortal: disablePortal,
        children: /*#__PURE__*/ (0, $9wx12.jsxs)(RootSlot, (0, $3VnFq.default)({}, rootProps, {
            children: [
                !hideBackdrop && BackdropComponent ? /*#__PURE__*/ (0, $9wx12.jsx)(BackdropSlot, (0, $3VnFq.default)({}, backdropProps)) : null,
                /*#__PURE__*/ (0, $9wx12.jsx)((0, $535bee45e267492c$export$2e2bcd8739ae039), {
                    disableEnforceFocus: disableEnforceFocus,
                    disableAutoFocus: disableAutoFocus,
                    disableRestoreFocus: disableRestoreFocus,
                    isEnabled: isTopModal,
                    open: open,
                    children: /*#__PURE__*/ $gJYWc.cloneElement(children, childProps)
                })
            ]
        }))
    });
});
var $9479e61072db3f56$export$2e2bcd8739ae039 = $9479e61072db3f56$var$Modal;




var $i8nzj = parcelRequire("i8nzj");

var $1kRHf = parcelRequire("1kRHf");
function $5d380e5be716a2db$export$88f455dd56c95edb(slot) {
    return (0, $1kRHf.default)('MuiPopover', slot);
}
const $5d380e5be716a2db$var$popoverClasses = (0, $i8nzj.default)('MuiPopover', [
    'root',
    'paper'
]);
var $5d380e5be716a2db$export$2e2bcd8739ae039 = $5d380e5be716a2db$var$popoverClasses;



var $9wx12 = parcelRequire("9wx12");
'use client';
const $3a28566a3952ccba$var$_excluded = [
    "onEntering"
], $3a28566a3952ccba$var$_excluded2 = [
    "action",
    "anchorEl",
    "anchorOrigin",
    "anchorPosition",
    "anchorReference",
    "children",
    "className",
    "container",
    "elevation",
    "marginThreshold",
    "open",
    "PaperProps",
    "slots",
    "slotProps",
    "transformOrigin",
    "TransitionComponent",
    "transitionDuration",
    "TransitionProps",
    "disableScrollLock"
], $3a28566a3952ccba$var$_excluded3 = [
    "slotProps"
];
function $3a28566a3952ccba$export$6fcff0dc60346367(rect, vertical) {
    let offset = 0;
    if (typeof vertical === 'number') offset = vertical;
    else if (vertical === 'center') offset = rect.height / 2;
    else if (vertical === 'bottom') offset = rect.height;
    return offset;
}
function $3a28566a3952ccba$export$a6a488ff68b1bf7b(rect, horizontal) {
    let offset = 0;
    if (typeof horizontal === 'number') offset = horizontal;
    else if (horizontal === 'center') offset = rect.width / 2;
    else if (horizontal === 'right') offset = rect.width;
    return offset;
}
function $3a28566a3952ccba$var$getTransformOriginValue(transformOrigin) {
    return [
        transformOrigin.horizontal,
        transformOrigin.vertical
    ].map((n)=>typeof n === 'number' ? `${n}px` : n).join(' ');
}
function $3a28566a3952ccba$var$resolveAnchorEl(anchorEl) {
    return typeof anchorEl === 'function' ? anchorEl() : anchorEl;
}
const $3a28566a3952ccba$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ],
        paper: [
            'paper'
        ]
    };
    return (0, $3e4LV.default)(slots, (0, $5d380e5be716a2db$export$88f455dd56c95edb), classes);
};
const $3a28566a3952ccba$export$bcce13685275fc99 = (0, $HGmne.default)((0, $9479e61072db3f56$export$2e2bcd8739ae039), {
    name: 'MuiPopover',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})({});
const $3a28566a3952ccba$export$821346c38a2d9390 = (0, $HGmne.default)((0, $db3ddac601361ae3$export$2e2bcd8739ae039), {
    name: 'MuiPopover',
    slot: 'Paper',
    overridesResolver: (props, styles)=>styles.paper
})({
    position: 'absolute',
    overflowY: 'auto',
    overflowX: 'hidden',
    // So we see the popover when it's empty.
    // It's most likely on issue on userland.
    minWidth: 16,
    minHeight: 16,
    maxWidth: 'calc(100% - 32px)',
    maxHeight: 'calc(100% - 32px)',
    // We disable the focus ring for mouse, touch and keyboard users.
    outline: 0
});
const $3a28566a3952ccba$var$Popover = /*#__PURE__*/ $gJYWc.forwardRef(function Popover(inProps, ref) {
    var _slotProps$paper, _slots$root, _slots$paper;
    const props = (0, $8pLcn.useDefaultProps)({
        props: inProps,
        name: 'MuiPopover'
    });
    const { action: action, anchorEl: anchorEl, anchorOrigin: anchorOrigin = {
        vertical: 'top',
        horizontal: 'left'
    }, anchorPosition: anchorPosition, anchorReference: anchorReference = 'anchorEl', children: children, className: className, container: containerProp, elevation: elevation = 8, marginThreshold: marginThreshold = 16, open: open, PaperProps: PaperPropsProp = {}, slots: slots, slotProps: slotProps, transformOrigin: transformOrigin = {
        vertical: 'top',
        horizontal: 'left'
    }, TransitionComponent: TransitionComponent = (0, $b8a567fe6aaea15d$export$2e2bcd8739ae039), transitionDuration: transitionDurationProp = 'auto', TransitionProps: { onEntering: onEntering } = {}, disableScrollLock: disableScrollLock = false } = props, TransitionProps = (0, $cTAWX.default)(props.TransitionProps, $3a28566a3952ccba$var$_excluded), other = (0, $cTAWX.default)(props, $3a28566a3952ccba$var$_excluded2);
    const externalPaperSlotProps = (_slotProps$paper = slotProps == null ? void 0 : slotProps.paper) != null ? _slotProps$paper : PaperPropsProp;
    const paperRef = $gJYWc.useRef();
    const handlePaperRef = (0, $il32z.default)(paperRef, externalPaperSlotProps.ref);
    const ownerState = (0, $3VnFq.default)({}, props, {
        anchorOrigin: anchorOrigin,
        anchorReference: anchorReference,
        elevation: elevation,
        marginThreshold: marginThreshold,
        externalPaperSlotProps: externalPaperSlotProps,
        transformOrigin: transformOrigin,
        TransitionComponent: TransitionComponent,
        transitionDuration: transitionDurationProp,
        TransitionProps: TransitionProps
    });
    const classes = $3a28566a3952ccba$var$useUtilityClasses(ownerState);
    // Returns the top/left offset of the position
    // to attach to on the anchor element (or body if none is provided)
    const getAnchorOffset = $gJYWc.useCallback(()=>{
        if (anchorReference === 'anchorPosition') return anchorPosition;
        const resolvedAnchorEl = $3a28566a3952ccba$var$resolveAnchorEl(anchorEl);
        // If an anchor element wasn't provided, just use the parent body element of this Popover
        const anchorElement = resolvedAnchorEl && resolvedAnchorEl.nodeType === 1 ? resolvedAnchorEl : (0, $755167b4f9e6f571$export$2e2bcd8739ae039)(paperRef.current).body;
        const anchorRect = anchorElement.getBoundingClientRect();
        return {
            top: anchorRect.top + $3a28566a3952ccba$export$6fcff0dc60346367(anchorRect, anchorOrigin.vertical),
            left: anchorRect.left + $3a28566a3952ccba$export$a6a488ff68b1bf7b(anchorRect, anchorOrigin.horizontal)
        };
    }, [
        anchorEl,
        anchorOrigin.horizontal,
        anchorOrigin.vertical,
        anchorPosition,
        anchorReference
    ]);
    // Returns the base transform origin using the element
    const getTransformOrigin = $gJYWc.useCallback((elemRect)=>{
        return {
            vertical: $3a28566a3952ccba$export$6fcff0dc60346367(elemRect, transformOrigin.vertical),
            horizontal: $3a28566a3952ccba$export$a6a488ff68b1bf7b(elemRect, transformOrigin.horizontal)
        };
    }, [
        transformOrigin.horizontal,
        transformOrigin.vertical
    ]);
    const getPositioningStyle = $gJYWc.useCallback((element)=>{
        const elemRect = {
            width: element.offsetWidth,
            height: element.offsetHeight
        };
        // Get the transform origin point on the element itself
        const elemTransformOrigin = getTransformOrigin(elemRect);
        if (anchorReference === 'none') return {
            top: null,
            left: null,
            transformOrigin: $3a28566a3952ccba$var$getTransformOriginValue(elemTransformOrigin)
        };
        // Get the offset of the anchoring element
        const anchorOffset = getAnchorOffset();
        // Calculate element positioning
        let top = anchorOffset.top - elemTransformOrigin.vertical;
        let left = anchorOffset.left - elemTransformOrigin.horizontal;
        const bottom = top + elemRect.height;
        const right = left + elemRect.width;
        // Use the parent window of the anchorEl if provided
        const containerWindow = (0, $44c7bb85922f3310$export$2e2bcd8739ae039)($3a28566a3952ccba$var$resolveAnchorEl(anchorEl));
        // Window thresholds taking required margin into account
        const heightThreshold = containerWindow.innerHeight - marginThreshold;
        const widthThreshold = containerWindow.innerWidth - marginThreshold;
        // Check if the vertical axis needs shifting
        if (marginThreshold !== null && top < marginThreshold) {
            const diff = top - marginThreshold;
            top -= diff;
            elemTransformOrigin.vertical += diff;
        } else if (marginThreshold !== null && bottom > heightThreshold) {
            const diff = bottom - heightThreshold;
            top -= diff;
            elemTransformOrigin.vertical += diff;
        }
        // Check if the horizontal axis needs shifting
        if (marginThreshold !== null && left < marginThreshold) {
            const diff = left - marginThreshold;
            left -= diff;
            elemTransformOrigin.horizontal += diff;
        } else if (right > widthThreshold) {
            const diff = right - widthThreshold;
            left -= diff;
            elemTransformOrigin.horizontal += diff;
        }
        return {
            top: `${Math.round(top)}px`,
            left: `${Math.round(left)}px`,
            transformOrigin: $3a28566a3952ccba$var$getTransformOriginValue(elemTransformOrigin)
        };
    }, [
        anchorEl,
        anchorReference,
        getAnchorOffset,
        getTransformOrigin,
        marginThreshold
    ]);
    const [isPositioned, setIsPositioned] = $gJYWc.useState(open);
    const setPositioningStyles = $gJYWc.useCallback(()=>{
        const element = paperRef.current;
        if (!element) return;
        const positioning = getPositioningStyle(element);
        if (positioning.top !== null) element.style.top = positioning.top;
        if (positioning.left !== null) element.style.left = positioning.left;
        element.style.transformOrigin = positioning.transformOrigin;
        setIsPositioned(true);
    }, [
        getPositioningStyle
    ]);
    $gJYWc.useEffect(()=>{
        if (disableScrollLock) window.addEventListener('scroll', setPositioningStyles);
        return ()=>window.removeEventListener('scroll', setPositioningStyles);
    }, [
        anchorEl,
        disableScrollLock,
        setPositioningStyles
    ]);
    const handleEntering = (element, isAppearing)=>{
        if (onEntering) onEntering(element, isAppearing);
        setPositioningStyles();
    };
    const handleExited = ()=>{
        setIsPositioned(false);
    };
    $gJYWc.useEffect(()=>{
        if (open) setPositioningStyles();
    });
    $gJYWc.useImperativeHandle(action, ()=>open ? {
            updatePosition: ()=>{
                setPositioningStyles();
            }
        } : null, [
        open,
        setPositioningStyles
    ]);
    $gJYWc.useEffect(()=>{
        if (!open) return undefined;
        const handleResize = (0, $05f705bdb0679e55$export$2e2bcd8739ae039)(()=>{
            setPositioningStyles();
        });
        const containerWindow = (0, $44c7bb85922f3310$export$2e2bcd8739ae039)(anchorEl);
        containerWindow.addEventListener('resize', handleResize);
        return ()=>{
            handleResize.clear();
            containerWindow.removeEventListener('resize', handleResize);
        };
    }, [
        anchorEl,
        open,
        setPositioningStyles
    ]);
    let transitionDuration = transitionDurationProp;
    if (transitionDurationProp === 'auto' && !TransitionComponent.muiSupportAuto) transitionDuration = undefined;
    // If the container prop is provided, use that
    // If the anchorEl prop is provided, use its parent body element as the container
    // If neither are provided let the Modal take care of choosing the container
    const container = containerProp || (anchorEl ? (0, $755167b4f9e6f571$export$2e2bcd8739ae039)($3a28566a3952ccba$var$resolveAnchorEl(anchorEl)).body : undefined);
    const RootSlot = (_slots$root = slots == null ? void 0 : slots.root) != null ? _slots$root : $3a28566a3952ccba$export$bcce13685275fc99;
    const PaperSlot = (_slots$paper = slots == null ? void 0 : slots.paper) != null ? _slots$paper : $3a28566a3952ccba$export$821346c38a2d9390;
    const paperProps = (0, $2f70e5a04f888acc$export$2e2bcd8739ae039)({
        elementType: PaperSlot,
        externalSlotProps: (0, $3VnFq.default)({}, externalPaperSlotProps, {
            style: isPositioned ? externalPaperSlotProps.style : (0, $3VnFq.default)({}, externalPaperSlotProps.style, {
                opacity: 0
            })
        }),
        additionalProps: {
            elevation: elevation,
            ref: handlePaperRef
        },
        ownerState: ownerState,
        className: (0, $2w6IV.default)(classes.paper, externalPaperSlotProps == null ? void 0 : externalPaperSlotProps.className)
    });
    const _useSlotProps = (0, $2f70e5a04f888acc$export$2e2bcd8739ae039)({
        elementType: RootSlot,
        externalSlotProps: (slotProps == null ? void 0 : slotProps.root) || {},
        externalForwardedProps: other,
        additionalProps: {
            ref: ref,
            slotProps: {
                backdrop: {
                    invisible: true
                }
            },
            container: container,
            open: open
        },
        ownerState: ownerState,
        className: (0, $2w6IV.default)(classes.root, className)
    }), { slotProps: rootSlotPropsProp } = _useSlotProps, rootProps = (0, $cTAWX.default)(_useSlotProps, $3a28566a3952ccba$var$_excluded3);
    return /*#__PURE__*/ (0, $9wx12.jsx)(RootSlot, (0, $3VnFq.default)({}, rootProps, !(0, $50e7d669fe712af8$export$2e2bcd8739ae039)(RootSlot) && {
        slotProps: rootSlotPropsProp,
        disableScrollLock: disableScrollLock
    }, {
        children: /*#__PURE__*/ (0, $9wx12.jsx)(TransitionComponent, (0, $3VnFq.default)({
            appear: true,
            in: open,
            onEntering: handleEntering,
            onExited: handleExited,
            timeout: transitionDuration
        }, TransitionProps, {
            children: /*#__PURE__*/ (0, $9wx12.jsx)(PaperSlot, (0, $3VnFq.default)({}, paperProps, {
                children: children
            }))
        }))
    }));
});
var $3a28566a3952ccba$export$2e2bcd8739ae039 = $3a28566a3952ccba$var$Popover;



var $cTAWX = parcelRequire("cTAWX");

var $3VnFq = parcelRequire("3VnFq");

var $gJYWc = parcelRequire("gJYWc");


var $2w6IV = parcelRequire("2w6IV");

var $3e4LV = parcelRequire("3e4LV");

var $HGmne = parcelRequire("HGmne");

var $8pLcn = parcelRequire("8pLcn");


var $i8nzj = parcelRequire("i8nzj");

var $1kRHf = parcelRequire("1kRHf");
function $8940916aa5bb997a$export$c6bd6795ed6e3203(slot) {
    return (0, $1kRHf.default)('MuiList', slot);
}
const $8940916aa5bb997a$var$listClasses = (0, $i8nzj.default)('MuiList', [
    'root',
    'padding',
    'dense',
    'subheader'
]);
var $8940916aa5bb997a$export$2e2bcd8739ae039 = $8940916aa5bb997a$var$listClasses;



var $9wx12 = parcelRequire("9wx12");
'use client';
const $e247548612617cb3$var$_excluded = [
    "children",
    "className",
    "component",
    "dense",
    "disablePadding",
    "subheader"
];
const $e247548612617cb3$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disablePadding: disablePadding, dense: dense, subheader: subheader } = ownerState;
    const slots = {
        root: [
            'root',
            !disablePadding && 'padding',
            dense && 'dense',
            subheader && 'subheader'
        ]
    };
    return (0, $3e4LV.default)(slots, (0, $8940916aa5bb997a$export$c6bd6795ed6e3203), classes);
};
const $e247548612617cb3$var$ListRoot = (0, $HGmne.default)('ul', {
    name: 'MuiList',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            !ownerState.disablePadding && styles.padding,
            ownerState.dense && styles.dense,
            ownerState.subheader && styles.subheader
        ];
    }
})(({ ownerState: ownerState })=>(0, $3VnFq.default)({
        listStyle: 'none',
        margin: 0,
        padding: 0,
        position: 'relative'
    }, !ownerState.disablePadding && {
        paddingTop: 8,
        paddingBottom: 8
    }, ownerState.subheader && {
        paddingTop: 0
    }));
const $e247548612617cb3$var$List = /*#__PURE__*/ $gJYWc.forwardRef(function List(inProps, ref) {
    const props = (0, $8pLcn.useDefaultProps)({
        props: inProps,
        name: 'MuiList'
    });
    const { children: children, className: className, component: component = 'ul', dense: dense = false, disablePadding: disablePadding = false, subheader: subheader } = props, other = (0, $cTAWX.default)(props, $e247548612617cb3$var$_excluded);
    const context = $gJYWc.useMemo(()=>({
            dense: dense
        }), [
        dense
    ]);
    const ownerState = (0, $3VnFq.default)({}, props, {
        component: component,
        dense: dense,
        disablePadding: disablePadding
    });
    const classes = $e247548612617cb3$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $9wx12.jsx)((0, $3d14c289610745c4$export$2e2bcd8739ae039).Provider, {
        value: context,
        children: /*#__PURE__*/ (0, $9wx12.jsxs)($e247548612617cb3$var$ListRoot, (0, $3VnFq.default)({
            as: component,
            className: (0, $2w6IV.default)(classes.root, className),
            ref: ref,
            ownerState: ownerState
        }, other, {
            children: [
                subheader,
                children
            ]
        }))
    });
});
var $e247548612617cb3$export$2e2bcd8739ae039 = $e247548612617cb3$var$List;



var $cTAWX = parcelRequire("cTAWX");

var $3VnFq = parcelRequire("3VnFq");

var $gJYWc = parcelRequire("gJYWc");


var $2w6IV = parcelRequire("2w6IV");

var $3e4LV = parcelRequire("3e4LV");



var $8pLcn = parcelRequire("8pLcn");

var $HGmne = parcelRequire("HGmne");

var $i8nzj = parcelRequire("i8nzj");

var $1kRHf = parcelRequire("1kRHf");
function $d2e859f656a8df91$export$1061006a0db3aeb5(slot) {
    return (0, $1kRHf.default)('MuiListItemText', slot);
}
const $d2e859f656a8df91$var$listItemTextClasses = (0, $i8nzj.default)('MuiListItemText', [
    'root',
    'multiline',
    'dense',
    'inset',
    'primary',
    'secondary'
]);
var $d2e859f656a8df91$export$2e2bcd8739ae039 = $d2e859f656a8df91$var$listItemTextClasses;



var $9wx12 = parcelRequire("9wx12");
'use client';
const $7e347bdafa1acea0$var$_excluded = [
    "children",
    "className",
    "disableTypography",
    "inset",
    "primary",
    "primaryTypographyProps",
    "secondary",
    "secondaryTypographyProps"
];
const $7e347bdafa1acea0$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, inset: inset, primary: primary, secondary: secondary, dense: dense } = ownerState;
    const slots = {
        root: [
            'root',
            inset && 'inset',
            dense && 'dense',
            primary && secondary && 'multiline'
        ],
        primary: [
            'primary'
        ],
        secondary: [
            'secondary'
        ]
    };
    return (0, $3e4LV.default)(slots, (0, $d2e859f656a8df91$export$1061006a0db3aeb5), classes);
};
const $7e347bdafa1acea0$var$ListItemTextRoot = (0, $HGmne.default)('div', {
    name: 'MuiListItemText',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            {
                [`& .${(0, $d2e859f656a8df91$export$2e2bcd8739ae039).primary}`]: styles.primary
            },
            {
                [`& .${(0, $d2e859f656a8df91$export$2e2bcd8739ae039).secondary}`]: styles.secondary
            },
            styles.root,
            ownerState.inset && styles.inset,
            ownerState.primary && ownerState.secondary && styles.multiline,
            ownerState.dense && styles.dense
        ];
    }
})(({ ownerState: ownerState })=>(0, $3VnFq.default)({
        flex: '1 1 auto',
        minWidth: 0,
        marginTop: 4,
        marginBottom: 4
    }, ownerState.primary && ownerState.secondary && {
        marginTop: 6,
        marginBottom: 6
    }, ownerState.inset && {
        paddingLeft: 56
    }));
const $7e347bdafa1acea0$var$ListItemText = /*#__PURE__*/ $gJYWc.forwardRef(function ListItemText(inProps, ref) {
    const props = (0, $8pLcn.useDefaultProps)({
        props: inProps,
        name: 'MuiListItemText'
    });
    const { children: children, className: className, disableTypography: disableTypography = false, inset: inset = false, primary: primaryProp, primaryTypographyProps: primaryTypographyProps, secondary: secondaryProp, secondaryTypographyProps: secondaryTypographyProps } = props, other = (0, $cTAWX.default)(props, $7e347bdafa1acea0$var$_excluded);
    const { dense: dense } = $gJYWc.useContext((0, $3d14c289610745c4$export$2e2bcd8739ae039));
    let primary = primaryProp != null ? primaryProp : children;
    let secondary = secondaryProp;
    const ownerState = (0, $3VnFq.default)({}, props, {
        disableTypography: disableTypography,
        inset: inset,
        primary: !!primary,
        secondary: !!secondary,
        dense: dense
    });
    const classes = $7e347bdafa1acea0$var$useUtilityClasses(ownerState);
    if (primary != null && primary.type !== (0, $b4083ea3a052dee9$export$2e2bcd8739ae039) && !disableTypography) primary = /*#__PURE__*/ (0, $9wx12.jsx)((0, $b4083ea3a052dee9$export$2e2bcd8739ae039), (0, $3VnFq.default)({
        variant: dense ? 'body2' : 'body1',
        className: classes.primary,
        component: primaryTypographyProps != null && primaryTypographyProps.variant ? undefined : 'span',
        display: "block"
    }, primaryTypographyProps, {
        children: primary
    }));
    if (secondary != null && secondary.type !== (0, $b4083ea3a052dee9$export$2e2bcd8739ae039) && !disableTypography) secondary = /*#__PURE__*/ (0, $9wx12.jsx)((0, $b4083ea3a052dee9$export$2e2bcd8739ae039), (0, $3VnFq.default)({
        variant: "body2",
        className: classes.secondary,
        color: "text.secondary",
        display: "block"
    }, secondaryTypographyProps, {
        children: secondary
    }));
    return /*#__PURE__*/ (0, $9wx12.jsxs)($7e347bdafa1acea0$var$ListItemTextRoot, (0, $3VnFq.default)({
        className: (0, $2w6IV.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref
    }, other, {
        children: [
            primary,
            secondary
        ]
    }));
});
var $7e347bdafa1acea0$export$2e2bcd8739ae039 = $7e347bdafa1acea0$var$ListItemText;



const $6486f186cae9684a$export$5c51ca97d2a9b4db = ({ options: options, onOptionChange: onOptionChange, name: name, description: description, preselectedValue: preselectedValue = '' })=>{
    const { t: t } = (0, $980e4b3a97f1ad67$export$9fc83ad70ead8663)();
    const [anchorEl, setAnchorEl] = (0, (/*@__PURE__*/$parcel$interopDefault($gJYWc))).useState(null);
    const [option, setOption] = (0, $gJYWc.useState)(preselectedValue);
    const isOnlyOption = options.length === 1;
    const handleClick = (event)=>{
        setAnchorEl(event.currentTarget);
    };
    const onTypeSelect = (option)=>{
        setOption(option);
        handleClose();
        onOptionChange(option);
    };
    const handleClose = ()=>{
        setAnchorEl(null);
    };
    const open = Boolean(anchorEl);
    const id = open ? 'option-selector' : undefined;
    return /*#__PURE__*/ (0, $9wx12.jsxs)((0, $9wx12.Fragment), {
        children: [
            /*#__PURE__*/ (0, $9wx12.jsxs)("div", {
                onClick: handleClick,
                className: "hover:bg-slate-100 rounded-3xl py-4 px-6 flex-1 cursor-pointer",
                children: [
                    /*#__PURE__*/ (0, $9wx12.jsx)((0, $b4083ea3a052dee9$export$2e2bcd8739ae039), {
                        children: name
                    }),
                    /*#__PURE__*/ (0, $9wx12.jsx)((0, $b4083ea3a052dee9$export$2e2bcd8739ae039), {
                        color: "text.secondary",
                        children: option ? t(`filter.${option}`) : description
                    })
                ]
            }),
            /*#__PURE__*/ (0, $9wx12.jsx)((0, $3a28566a3952ccba$export$2e2bcd8739ae039), {
                id: id,
                open: open,
                anchorEl: anchorEl,
                onClose: handleClose,
                anchorOrigin: {
                    vertical: 'bottom',
                    horizontal: 'left'
                },
                children: /*#__PURE__*/ (0, $9wx12.jsxs)((0, $e247548612617cb3$export$2e2bcd8739ae039), {
                    children: [
                        /*#__PURE__*/ (0, $9wx12.jsx)((0, $fccb9ee5b10abda3$export$2e2bcd8739ae039), {
                            onClick: ()=>onTypeSelect(''),
                            sx: {
                                px: 5
                            },
                            children: /*#__PURE__*/ (0, $9wx12.jsx)((0, $7e347bdafa1acea0$export$2e2bcd8739ae039), {
                                primary: t('filter.all')
                            })
                        }),
                        options.map((option)=>/*#__PURE__*/ (0, $9wx12.jsx)((0, $fccb9ee5b10abda3$export$2e2bcd8739ae039), {
                                onClick: ()=>onTypeSelect(option),
                                sx: {
                                    px: 5
                                },
                                children: /*#__PURE__*/ (0, $9wx12.jsx)((0, $7e347bdafa1acea0$export$2e2bcd8739ae039), {
                                    primary: t(`filter.${option}`)
                                })
                            }, option))
                    ]
                })
            })
        ]
    });
};



const $5bb3c03eb951988c$var$CustomButtonRoot = (0, $HGmne.default)((0, $95b3a1ef1ddc1e78$export$2e2bcd8739ae039))(({ theme: theme })=>`
    background: rgb(234, 91, 112);
    border-radius: 100%;
    transform: scale(0.7);
    &:hover {
        background: rgb(255, 142, 158);
}`);
const $5bb3c03eb951988c$export$820e4d34d59f5d7f = (props)=>{
    const { cities: cities, setCity: setCity, ages: ages, setAge: setAge, activities: activities, setActivity: setActivity, selectedAge: selectedAge, selectedCity: selectedCity, selectedActivity: selectedActivity, onSearch: onSearch } = props;
    const { t: t } = (0, $980e4b3a97f1ad67$export$9fc83ad70ead8663)();
    return /*#__PURE__*/ (0, $9wx12.jsx)((0, $9wx12.Fragment), {
        children: /*#__PURE__*/ (0, $9wx12.jsx)("div", {
            id: "search-bar-holder",
            className: "lg:flex items-center justify-center mt-5 hidden",
            children: /*#__PURE__*/ (0, $9wx12.jsxs)("div", {
                id: "search-bar",
                className: "shadow shadow-gray-300 rounded-3xl w-[850px] h-[76px] flex justify-between bg-white",
                children: [
                    /*#__PURE__*/ (0, $9wx12.jsx)((0, $6486f186cae9684a$export$5c51ca97d2a9b4db), {
                        preselectedValue: selectedCity,
                        name: t("filter.city"),
                        description: t("filter.selectCity"),
                        options: cities,
                        onOptionChange: setCity
                    }),
                    /*#__PURE__*/ (0, $9wx12.jsx)((0, $6486f186cae9684a$export$5c51ca97d2a9b4db), {
                        preselectedValue: selectedAge,
                        name: t("filter.age"),
                        description: t("filter.selectAge"),
                        options: ages,
                        onOptionChange: setAge
                    }),
                    /*#__PURE__*/ (0, $9wx12.jsx)((0, $6486f186cae9684a$export$5c51ca97d2a9b4db), {
                        preselectedValue: selectedActivity,
                        name: t("filter.activity"),
                        description: t("filter.selectActivity"),
                        options: activities,
                        onOptionChange: setActivity
                    }),
                    /*#__PURE__*/ (0, $9wx12.jsx)($5bb3c03eb951988c$var$CustomButtonRoot, {
                        variant: "contained",
                        onClick: onSearch,
                        children: /*#__PURE__*/ (0, $9wx12.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($7e951fd1c0b9fd8e$exports))), {
                            fontSize: "large"
                        })
                    })
                ]
            })
        })
    });
};



const $5382b31aaf69a3b1$export$98d92b1aa79f8cc7 = (customFetch)=>{
    let _fetch;
    if (customFetch) _fetch = customFetch;
    else if (typeof fetch === 'undefined') _fetch = (...args)=>Promise.resolve((parcelRequire("ff1Or"))).then(({ default: fetch1 })=>fetch1(...args));
    else _fetch = fetch;
    return (...args)=>_fetch(...args);
};


class $695f7fc81e5cba5e$export$738689d52335bb3c extends Error {
    constructor(message, name = 'FunctionsError', context){
        super(message);
        this.name = name;
        this.context = context;
    }
}
class $695f7fc81e5cba5e$export$14f2b6540d498ce extends $695f7fc81e5cba5e$export$738689d52335bb3c {
    constructor(context){
        super('Failed to send a request to the Edge Function', 'FunctionsFetchError', context);
    }
}
class $695f7fc81e5cba5e$export$d08a45df86040161 extends $695f7fc81e5cba5e$export$738689d52335bb3c {
    constructor(context){
        super('Relay Error invoking the Edge Function', 'FunctionsRelayError', context);
    }
}
class $695f7fc81e5cba5e$export$761f8c0e0fa4624f extends $695f7fc81e5cba5e$export$738689d52335bb3c {
    constructor(context){
        super('Edge Function returned a non-2xx status code', 'FunctionsHttpError', context);
    }
}
var $695f7fc81e5cba5e$export$9b19f1a5abf91e06;
(function(FunctionRegion) {
    FunctionRegion["Any"] = "any";
    FunctionRegion["ApNortheast1"] = "ap-northeast-1";
    FunctionRegion["ApNortheast2"] = "ap-northeast-2";
    FunctionRegion["ApSouth1"] = "ap-south-1";
    FunctionRegion["ApSoutheast1"] = "ap-southeast-1";
    FunctionRegion["ApSoutheast2"] = "ap-southeast-2";
    FunctionRegion["CaCentral1"] = "ca-central-1";
    FunctionRegion["EuCentral1"] = "eu-central-1";
    FunctionRegion["EuWest1"] = "eu-west-1";
    FunctionRegion["EuWest2"] = "eu-west-2";
    FunctionRegion["EuWest3"] = "eu-west-3";
    FunctionRegion["SaEast1"] = "sa-east-1";
    FunctionRegion["UsEast1"] = "us-east-1";
    FunctionRegion["UsWest1"] = "us-west-1";
    FunctionRegion["UsWest2"] = "us-west-2";
})($695f7fc81e5cba5e$export$9b19f1a5abf91e06 || ($695f7fc81e5cba5e$export$9b19f1a5abf91e06 = {}));


var $9532b5b75d740796$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
class $9532b5b75d740796$export$1d0b400bf8a0fa55 {
    /**
     * Updates the authorization header
     * @param token - the new jwt token sent in the authorisation header
     */ setAuth(token) {
        this.headers.Authorization = `Bearer ${token}`;
    }
    /**
     * Invokes a function
     * @param functionName - The name of the Function to invoke.
     * @param options - Options for invoking the Function.
     */ invoke(functionName, options = {}) {
        var _a;
        return $9532b5b75d740796$var$__awaiter(this, void 0, void 0, function*() {
            try {
                const { headers: headers, method: method, body: functionArgs } = options;
                let _headers = {};
                let { region: region } = options;
                if (!region) region = this.region;
                if (region && region !== 'any') _headers['x-region'] = region;
                let body;
                if (functionArgs && (headers && !Object.prototype.hasOwnProperty.call(headers, 'Content-Type') || !headers)) {
                    if (typeof Blob !== 'undefined' && functionArgs instanceof Blob || functionArgs instanceof ArrayBuffer) {
                        // will work for File as File inherits Blob
                        // also works for ArrayBuffer as it is the same underlying structure as a Blob
                        _headers['Content-Type'] = 'application/octet-stream';
                        body = functionArgs;
                    } else if (typeof functionArgs === 'string') {
                        // plain string
                        _headers['Content-Type'] = 'text/plain';
                        body = functionArgs;
                    } else if (typeof FormData !== 'undefined' && functionArgs instanceof FormData) // don't set content-type headers
                    // Request will automatically add the right boundary value
                    body = functionArgs;
                    else {
                        // default, assume this is JSON
                        _headers['Content-Type'] = 'application/json';
                        body = JSON.stringify(functionArgs);
                    }
                }
                const response = yield this.fetch(`${this.url}/${functionName}`, {
                    method: method || 'POST',
                    // headers priority is (high to low):
                    // 1. invoke-level headers
                    // 2. client-level headers
                    // 3. default Content-Type header
                    headers: Object.assign(Object.assign(Object.assign({}, _headers), this.headers), headers),
                    body: body
                }).catch((fetchError)=>{
                    throw new (0, $695f7fc81e5cba5e$export$14f2b6540d498ce)(fetchError);
                });
                const isRelayError = response.headers.get('x-relay-error');
                if (isRelayError && isRelayError === 'true') throw new (0, $695f7fc81e5cba5e$export$d08a45df86040161)(response);
                if (!response.ok) throw new (0, $695f7fc81e5cba5e$export$761f8c0e0fa4624f)(response);
                let responseType = ((_a = response.headers.get('Content-Type')) !== null && _a !== void 0 ? _a : 'text/plain').split(';')[0].trim();
                let data;
                if (responseType === 'application/json') data = yield response.json();
                else if (responseType === 'application/octet-stream') data = yield response.blob();
                else if (responseType === 'text/event-stream') data = response;
                else if (responseType === 'multipart/form-data') data = yield response.formData();
                else // default to text
                data = yield response.text();
                return {
                    data: data,
                    error: null
                };
            } catch (error) {
                return {
                    data: null,
                    error: error
                };
            }
        });
    }
    constructor(url, { headers: headers = {}, customFetch: customFetch, region: region = (0, $695f7fc81e5cba5e$export$9b19f1a5abf91e06).Any } = {}){
        this.url = url;
        this.headers = headers;
        this.region = region;
        this.fetch = (0, $5382b31aaf69a3b1$export$98d92b1aa79f8cc7)(customFetch);
    }
}


var $fc55e26fc72f8d20$exports = {};
"use strict";
var $fc55e26fc72f8d20$var$__importDefault = $fc55e26fc72f8d20$exports && $fc55e26fc72f8d20$exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty($fc55e26fc72f8d20$exports, "__esModule", {
    value: true
});
$fc55e26fc72f8d20$exports.PostgrestError = $fc55e26fc72f8d20$exports.PostgrestBuilder = $fc55e26fc72f8d20$exports.PostgrestTransformBuilder = $fc55e26fc72f8d20$exports.PostgrestFilterBuilder = $fc55e26fc72f8d20$exports.PostgrestQueryBuilder = $fc55e26fc72f8d20$exports.PostgrestClient = void 0;

// Always update wrapper.mjs when updating this file.
const $fc55e26fc72f8d20$var$PostgrestClient_1 = $fc55e26fc72f8d20$var$__importDefault((parcelRequire("8xWNp")));
$fc55e26fc72f8d20$exports.PostgrestClient = $fc55e26fc72f8d20$var$PostgrestClient_1.default;

const $fc55e26fc72f8d20$var$PostgrestQueryBuilder_1 = $fc55e26fc72f8d20$var$__importDefault((parcelRequire("cVXnb")));
$fc55e26fc72f8d20$exports.PostgrestQueryBuilder = $fc55e26fc72f8d20$var$PostgrestQueryBuilder_1.default;

const $fc55e26fc72f8d20$var$PostgrestFilterBuilder_1 = $fc55e26fc72f8d20$var$__importDefault((parcelRequire("fXZ9e")));
$fc55e26fc72f8d20$exports.PostgrestFilterBuilder = $fc55e26fc72f8d20$var$PostgrestFilterBuilder_1.default;

const $fc55e26fc72f8d20$var$PostgrestTransformBuilder_1 = $fc55e26fc72f8d20$var$__importDefault((parcelRequire("kJn3v")));
$fc55e26fc72f8d20$exports.PostgrestTransformBuilder = $fc55e26fc72f8d20$var$PostgrestTransformBuilder_1.default;

const $fc55e26fc72f8d20$var$PostgrestBuilder_1 = $fc55e26fc72f8d20$var$__importDefault((parcelRequire("4YeQi")));
$fc55e26fc72f8d20$exports.PostgrestBuilder = $fc55e26fc72f8d20$var$PostgrestBuilder_1.default;

const $fc55e26fc72f8d20$var$PostgrestError_1 = $fc55e26fc72f8d20$var$__importDefault((parcelRequire("7LSLT")));
$fc55e26fc72f8d20$exports.PostgrestError = $fc55e26fc72f8d20$var$PostgrestError_1.default;
$fc55e26fc72f8d20$exports.default = {
    PostgrestClient: $fc55e26fc72f8d20$var$PostgrestClient_1.default,
    PostgrestQueryBuilder: $fc55e26fc72f8d20$var$PostgrestQueryBuilder_1.default,
    PostgrestFilterBuilder: $fc55e26fc72f8d20$var$PostgrestFilterBuilder_1.default,
    PostgrestTransformBuilder: $fc55e26fc72f8d20$var$PostgrestTransformBuilder_1.default,
    PostgrestBuilder: $fc55e26fc72f8d20$var$PostgrestBuilder_1.default,
    PostgrestError: $fc55e26fc72f8d20$var$PostgrestError_1.default
};


const { PostgrestClient: $9d547cd278c5aefb$export$796f32e2ee984aaa, PostgrestQueryBuilder: $9d547cd278c5aefb$export$a81993b50ca081ad, PostgrestFilterBuilder: $9d547cd278c5aefb$export$3158317c13bdc93a, PostgrestTransformBuilder: $9d547cd278c5aefb$export$7b4361bb87e3030c, PostgrestBuilder: $9d547cd278c5aefb$export$3106e21688a06353, PostgrestError: $9d547cd278c5aefb$export$445b7e3a323f992f } = (0, (/*@__PURE__*/$parcel$interopDefault($fc55e26fc72f8d20$exports)));
var // compatibility with CJS output
$9d547cd278c5aefb$export$2e2bcd8739ae039 = {
    PostgrestClient: $9d547cd278c5aefb$export$796f32e2ee984aaa,
    PostgrestQueryBuilder: $9d547cd278c5aefb$export$a81993b50ca081ad,
    PostgrestFilterBuilder: $9d547cd278c5aefb$export$3158317c13bdc93a,
    PostgrestTransformBuilder: $9d547cd278c5aefb$export$7b4361bb87e3030c,
    PostgrestBuilder: $9d547cd278c5aefb$export$3106e21688a06353,
    PostgrestError: $9d547cd278c5aefb$export$445b7e3a323f992f
};


const $d42d5d74cbb777b7$export$83d89fbfd8236492 = '2.11.2';


const $8b2031009ae9dcb1$export$88a84136db6a4b64 = {
    'X-Client-Info': `realtime-js/${(0, $d42d5d74cbb777b7$export$83d89fbfd8236492)}`
};
const $8b2031009ae9dcb1$export$df3f558bb9a9c991 = '1.0.0';
const $8b2031009ae9dcb1$export$7bd623b29ec8e1eb = 10000;
const $8b2031009ae9dcb1$export$5e80cf62e56a877b = 1000;
var $8b2031009ae9dcb1$export$a6d0320a1563d49e;
(function(SOCKET_STATES) {
    SOCKET_STATES[SOCKET_STATES["connecting"] = 0] = "connecting";
    SOCKET_STATES[SOCKET_STATES["open"] = 1] = "open";
    SOCKET_STATES[SOCKET_STATES["closing"] = 2] = "closing";
    SOCKET_STATES[SOCKET_STATES["closed"] = 3] = "closed";
})($8b2031009ae9dcb1$export$a6d0320a1563d49e || ($8b2031009ae9dcb1$export$a6d0320a1563d49e = {}));
var $8b2031009ae9dcb1$export$b83816118db74fe7;
(function(CHANNEL_STATES) {
    CHANNEL_STATES["closed"] = "closed";
    CHANNEL_STATES["errored"] = "errored";
    CHANNEL_STATES["joined"] = "joined";
    CHANNEL_STATES["joining"] = "joining";
    CHANNEL_STATES["leaving"] = "leaving";
})($8b2031009ae9dcb1$export$b83816118db74fe7 || ($8b2031009ae9dcb1$export$b83816118db74fe7 = {}));
var $8b2031009ae9dcb1$export$8db7548e65d6ea55;
(function(CHANNEL_EVENTS) {
    CHANNEL_EVENTS["close"] = "phx_close";
    CHANNEL_EVENTS["error"] = "phx_error";
    CHANNEL_EVENTS["join"] = "phx_join";
    CHANNEL_EVENTS["reply"] = "phx_reply";
    CHANNEL_EVENTS["leave"] = "phx_leave";
    CHANNEL_EVENTS["access_token"] = "access_token";
})($8b2031009ae9dcb1$export$8db7548e65d6ea55 || ($8b2031009ae9dcb1$export$8db7548e65d6ea55 = {}));
var $8b2031009ae9dcb1$export$b2688bfb999f5751;
(function(TRANSPORTS) {
    TRANSPORTS["websocket"] = "websocket";
})($8b2031009ae9dcb1$export$b2688bfb999f5751 || ($8b2031009ae9dcb1$export$b2688bfb999f5751 = {}));
var $8b2031009ae9dcb1$export$deda39003d27273;
(function(CONNECTION_STATE) {
    CONNECTION_STATE["Connecting"] = "connecting";
    CONNECTION_STATE["Open"] = "open";
    CONNECTION_STATE["Closing"] = "closing";
    CONNECTION_STATE["Closed"] = "closed";
})($8b2031009ae9dcb1$export$deda39003d27273 || ($8b2031009ae9dcb1$export$deda39003d27273 = {}));


// This file draws heavily from https://github.com/phoenixframework/phoenix/commit/cf098e9cf7a44ee6479d31d911a97d3c7430c6fe
// License: https://github.com/phoenixframework/phoenix/blob/master/LICENSE.md
class $1d08bc1ca729af48$export$2e2bcd8739ae039 {
    decode(rawPayload, callback) {
        if (rawPayload.constructor === ArrayBuffer) return callback(this._binaryDecode(rawPayload));
        if (typeof rawPayload === 'string') return callback(JSON.parse(rawPayload));
        return callback({});
    }
    _binaryDecode(buffer) {
        const view = new DataView(buffer);
        const decoder = new TextDecoder();
        return this._decodeBroadcast(buffer, view, decoder);
    }
    _decodeBroadcast(buffer, view, decoder) {
        const topicSize = view.getUint8(1);
        const eventSize = view.getUint8(2);
        let offset = this.HEADER_LENGTH + 2;
        const topic = decoder.decode(buffer.slice(offset, offset + topicSize));
        offset = offset + topicSize;
        const event = decoder.decode(buffer.slice(offset, offset + eventSize));
        offset = offset + eventSize;
        const data = JSON.parse(decoder.decode(buffer.slice(offset, buffer.byteLength)));
        return {
            ref: null,
            topic: topic,
            event: event,
            payload: data
        };
    }
    constructor(){
        this.HEADER_LENGTH = 1;
    }
}


/**
 * Creates a timer that accepts a `timerCalc` function to perform calculated timeout retries, such as exponential backoff.
 *
 * @example
 *    let reconnectTimer = new Timer(() => this.connect(), function(tries){
 *      return [1000, 5000, 10000][tries - 1] || 10000
 *    })
 *    reconnectTimer.scheduleTimeout() // fires after 1000
 *    reconnectTimer.scheduleTimeout() // fires after 5000
 *    reconnectTimer.reset()
 *    reconnectTimer.scheduleTimeout() // fires after 1000
 */ class $6d6ed1c5f76a59fa$export$2e2bcd8739ae039 {
    reset() {
        this.tries = 0;
        clearTimeout(this.timer);
    }
    // Cancels any previous scheduleTimeout and schedules callback
    scheduleTimeout() {
        clearTimeout(this.timer);
        this.timer = setTimeout(()=>{
            this.tries = this.tries + 1;
            this.callback();
        }, this.timerCalc(this.tries + 1));
    }
    constructor(callback, timerCalc){
        this.callback = callback;
        this.timerCalc = timerCalc;
        this.timer = undefined;
        this.tries = 0;
        this.callback = callback;
        this.timerCalc = timerCalc;
    }
}


/**
 * Helpers to convert the change Payload into native JS types.
 */ // Adapted from epgsql (src/epgsql_binary.erl), this module licensed under
// 3-clause BSD found here: https://raw.githubusercontent.com/epgsql/epgsql/devel/LICENSE
var $e10f566fa6faed34$export$4d213a7d364021dc;
(function(PostgresTypes) {
    PostgresTypes["abstime"] = "abstime";
    PostgresTypes["bool"] = "bool";
    PostgresTypes["date"] = "date";
    PostgresTypes["daterange"] = "daterange";
    PostgresTypes["float4"] = "float4";
    PostgresTypes["float8"] = "float8";
    PostgresTypes["int2"] = "int2";
    PostgresTypes["int4"] = "int4";
    PostgresTypes["int4range"] = "int4range";
    PostgresTypes["int8"] = "int8";
    PostgresTypes["int8range"] = "int8range";
    PostgresTypes["json"] = "json";
    PostgresTypes["jsonb"] = "jsonb";
    PostgresTypes["money"] = "money";
    PostgresTypes["numeric"] = "numeric";
    PostgresTypes["oid"] = "oid";
    PostgresTypes["reltime"] = "reltime";
    PostgresTypes["text"] = "text";
    PostgresTypes["time"] = "time";
    PostgresTypes["timestamp"] = "timestamp";
    PostgresTypes["timestamptz"] = "timestamptz";
    PostgresTypes["timetz"] = "timetz";
    PostgresTypes["tsrange"] = "tsrange";
    PostgresTypes["tstzrange"] = "tstzrange";
})($e10f566fa6faed34$export$4d213a7d364021dc || ($e10f566fa6faed34$export$4d213a7d364021dc = {}));
const $e10f566fa6faed34$export$20ce708a1f594c5e = (columns, record, options = {})=>{
    var _a;
    const skipTypes = (_a = options.skipTypes) !== null && _a !== void 0 ? _a : [];
    return Object.keys(record).reduce((acc, rec_key)=>{
        acc[rec_key] = $e10f566fa6faed34$export$c054edfec1afa88d(rec_key, columns, record, skipTypes);
        return acc;
    }, {});
};
const $e10f566fa6faed34$export$c054edfec1afa88d = (columnName, columns, record, skipTypes)=>{
    const column = columns.find((x)=>x.name === columnName);
    const colType = column === null || column === void 0 ? void 0 : column.type;
    const value = record[columnName];
    if (colType && !skipTypes.includes(colType)) return $e10f566fa6faed34$export$3df02a362b86a91(colType, value);
    return $e10f566fa6faed34$var$noop(value);
};
const $e10f566fa6faed34$export$3df02a362b86a91 = (type, value)=>{
    // if data type is an array
    if (type.charAt(0) === '_') {
        const dataType = type.slice(1, type.length);
        return $e10f566fa6faed34$export$45b10814cc054894(value, dataType);
    }
    // If not null, convert to correct type.
    switch(type){
        case $e10f566fa6faed34$export$4d213a7d364021dc.bool:
            return $e10f566fa6faed34$export$3c2e6d1b7583eee6(value);
        case $e10f566fa6faed34$export$4d213a7d364021dc.float4:
        case $e10f566fa6faed34$export$4d213a7d364021dc.float8:
        case $e10f566fa6faed34$export$4d213a7d364021dc.int2:
        case $e10f566fa6faed34$export$4d213a7d364021dc.int4:
        case $e10f566fa6faed34$export$4d213a7d364021dc.int8:
        case $e10f566fa6faed34$export$4d213a7d364021dc.numeric:
        case $e10f566fa6faed34$export$4d213a7d364021dc.oid:
            return $e10f566fa6faed34$export$a0a81dc3380ce7d3(value);
        case $e10f566fa6faed34$export$4d213a7d364021dc.json:
        case $e10f566fa6faed34$export$4d213a7d364021dc.jsonb:
            return $e10f566fa6faed34$export$d5b7a8bf56ee1fe2(value);
        case $e10f566fa6faed34$export$4d213a7d364021dc.timestamp:
            return $e10f566fa6faed34$export$eccf8c5d91d19e3a(value); // Format to be consistent with PostgREST
        case $e10f566fa6faed34$export$4d213a7d364021dc.abstime:
        case $e10f566fa6faed34$export$4d213a7d364021dc.date:
        case $e10f566fa6faed34$export$4d213a7d364021dc.daterange:
        case $e10f566fa6faed34$export$4d213a7d364021dc.int4range:
        case $e10f566fa6faed34$export$4d213a7d364021dc.int8range:
        case $e10f566fa6faed34$export$4d213a7d364021dc.money:
        case $e10f566fa6faed34$export$4d213a7d364021dc.reltime:
        case $e10f566fa6faed34$export$4d213a7d364021dc.text:
        case $e10f566fa6faed34$export$4d213a7d364021dc.time:
        case $e10f566fa6faed34$export$4d213a7d364021dc.timestamptz:
        case $e10f566fa6faed34$export$4d213a7d364021dc.timetz:
        case $e10f566fa6faed34$export$4d213a7d364021dc.tsrange:
        case $e10f566fa6faed34$export$4d213a7d364021dc.tstzrange:
            return $e10f566fa6faed34$var$noop(value);
        default:
            // Return the value for remaining types
            return $e10f566fa6faed34$var$noop(value);
    }
};
const $e10f566fa6faed34$var$noop = (value)=>{
    return value;
};
const $e10f566fa6faed34$export$3c2e6d1b7583eee6 = (value)=>{
    switch(value){
        case 't':
            return true;
        case 'f':
            return false;
        default:
            return value;
    }
};
const $e10f566fa6faed34$export$a0a81dc3380ce7d3 = (value)=>{
    if (typeof value === 'string') {
        const parsedValue = parseFloat(value);
        if (!Number.isNaN(parsedValue)) return parsedValue;
    }
    return value;
};
const $e10f566fa6faed34$export$d5b7a8bf56ee1fe2 = (value)=>{
    if (typeof value === 'string') try {
        return JSON.parse(value);
    } catch (error) {
        console.log(`JSON parse error: ${error}`);
        return value;
    }
    return value;
};
const $e10f566fa6faed34$export$45b10814cc054894 = (value, type)=>{
    if (typeof value !== 'string') return value;
    const lastIdx = value.length - 1;
    const closeBrace = value[lastIdx];
    const openBrace = value[0];
    // Confirm value is a Postgres array by checking curly brackets
    if (openBrace === '{' && closeBrace === '}') {
        let arr;
        const valTrim = value.slice(1, lastIdx);
        // TODO: find a better solution to separate Postgres array data
        try {
            arr = JSON.parse('[' + valTrim + ']');
        } catch (_) {
            // WARNING: splitting on comma does not cover all edge cases
            arr = valTrim ? valTrim.split(',') : [];
        }
        return arr.map((val)=>$e10f566fa6faed34$export$3df02a362b86a91(type, val));
    }
    return value;
};
const $e10f566fa6faed34$export$eccf8c5d91d19e3a = (value)=>{
    if (typeof value === 'string') return value.replace(' ', 'T');
    return value;
};
const $e10f566fa6faed34$export$976fda7151b30cae = (socketUrl)=>{
    let url = socketUrl;
    url = url.replace(/^ws/i, 'http');
    url = url.replace(/(\/socket\/websocket|\/socket|\/websocket)\/?$/i, '');
    return url.replace(/\/+$/, '');
};




class $3785fda85e307754$export$2e2bcd8739ae039 {
    resend(timeout) {
        this.timeout = timeout;
        this._cancelRefEvent();
        this.ref = '';
        this.refEvent = null;
        this.receivedResp = null;
        this.sent = false;
        this.send();
    }
    send() {
        if (this._hasReceived('timeout')) return;
        this.startTimeout();
        this.sent = true;
        this.channel.socket.push({
            topic: this.channel.topic,
            event: this.event,
            payload: this.payload,
            ref: this.ref,
            join_ref: this.channel._joinRef()
        });
    }
    updatePayload(payload) {
        this.payload = Object.assign(Object.assign({}, this.payload), payload);
    }
    receive(status, callback) {
        var _a;
        if (this._hasReceived(status)) callback((_a = this.receivedResp) === null || _a === void 0 ? void 0 : _a.response);
        this.recHooks.push({
            status: status,
            callback: callback
        });
        return this;
    }
    startTimeout() {
        if (this.timeoutTimer) return;
        this.ref = this.channel.socket._makeRef();
        this.refEvent = this.channel._replyEventName(this.ref);
        const callback = (payload)=>{
            this._cancelRefEvent();
            this._cancelTimeout();
            this.receivedResp = payload;
            this._matchReceive(payload);
        };
        this.channel._on(this.refEvent, {}, callback);
        this.timeoutTimer = setTimeout(()=>{
            this.trigger('timeout', {});
        }, this.timeout);
    }
    trigger(status, response) {
        if (this.refEvent) this.channel._trigger(this.refEvent, {
            status: status,
            response: response
        });
    }
    destroy() {
        this._cancelRefEvent();
        this._cancelTimeout();
    }
    _cancelRefEvent() {
        if (!this.refEvent) return;
        this.channel._off(this.refEvent, {});
    }
    _cancelTimeout() {
        clearTimeout(this.timeoutTimer);
        this.timeoutTimer = undefined;
    }
    _matchReceive({ status: status, response: response }) {
        this.recHooks.filter((h)=>h.status === status).forEach((h)=>h.callback(response));
    }
    _hasReceived(status) {
        return this.receivedResp && this.receivedResp.status === status;
    }
    /**
     * Initializes the Push
     *
     * @param channel The Channel
     * @param event The event, for example `"phx_join"`
     * @param payload The payload, for example `{user_id: 123}`
     * @param timeout The push timeout in milliseconds
     */ constructor(channel, event, payload = {}, timeout = (0, $8b2031009ae9dcb1$export$7bd623b29ec8e1eb)){
        this.channel = channel;
        this.event = event;
        this.payload = payload;
        this.timeout = timeout;
        this.sent = false;
        this.timeoutTimer = undefined;
        this.ref = '';
        this.receivedResp = null;
        this.recHooks = [];
        this.refEvent = null;
    }
}



/*
  This file draws heavily from https://github.com/phoenixframework/phoenix/blob/d344ec0a732ab4ee204215b31de69cf4be72e3bf/assets/js/phoenix/presence.js
  License: https://github.com/phoenixframework/phoenix/blob/d344ec0a732ab4ee204215b31de69cf4be72e3bf/LICENSE.md
*/ var $a09b9d1dfd3983b5$export$f1ce049df2794fb4;
(function(REALTIME_PRESENCE_LISTEN_EVENTS) {
    REALTIME_PRESENCE_LISTEN_EVENTS["SYNC"] = "sync";
    REALTIME_PRESENCE_LISTEN_EVENTS["JOIN"] = "join";
    REALTIME_PRESENCE_LISTEN_EVENTS["LEAVE"] = "leave";
})($a09b9d1dfd3983b5$export$f1ce049df2794fb4 || ($a09b9d1dfd3983b5$export$f1ce049df2794fb4 = {}));
class $a09b9d1dfd3983b5$export$2e2bcd8739ae039 {
    /**
     * Used to sync the list of presences on the server with the
     * client's state.
     *
     * An optional `onJoin` and `onLeave` callback can be provided to
     * react to changes in the client's local presences across
     * disconnects and reconnects with the server.
     *
     * @internal
     */ static syncState(currentState, newState, onJoin, onLeave) {
        const state = this.cloneDeep(currentState);
        const transformedState = this.transformState(newState);
        const joins = {};
        const leaves = {};
        this.map(state, (key, presences)=>{
            if (!transformedState[key]) leaves[key] = presences;
        });
        this.map(transformedState, (key, newPresences)=>{
            const currentPresences = state[key];
            if (currentPresences) {
                const newPresenceRefs = newPresences.map((m)=>m.presence_ref);
                const curPresenceRefs = currentPresences.map((m)=>m.presence_ref);
                const joinedPresences = newPresences.filter((m)=>curPresenceRefs.indexOf(m.presence_ref) < 0);
                const leftPresences = currentPresences.filter((m)=>newPresenceRefs.indexOf(m.presence_ref) < 0);
                if (joinedPresences.length > 0) joins[key] = joinedPresences;
                if (leftPresences.length > 0) leaves[key] = leftPresences;
            } else joins[key] = newPresences;
        });
        return this.syncDiff(state, {
            joins: joins,
            leaves: leaves
        }, onJoin, onLeave);
    }
    /**
     * Used to sync a diff of presence join and leave events from the
     * server, as they happen.
     *
     * Like `syncState`, `syncDiff` accepts optional `onJoin` and
     * `onLeave` callbacks to react to a user joining or leaving from a
     * device.
     *
     * @internal
     */ static syncDiff(state, diff, onJoin, onLeave) {
        const { joins: joins, leaves: leaves } = {
            joins: this.transformState(diff.joins),
            leaves: this.transformState(diff.leaves)
        };
        if (!onJoin) onJoin = ()=>{};
        if (!onLeave) onLeave = ()=>{};
        this.map(joins, (key, newPresences)=>{
            var _a;
            const currentPresences = (_a = state[key]) !== null && _a !== void 0 ? _a : [];
            state[key] = this.cloneDeep(newPresences);
            if (currentPresences.length > 0) {
                const joinedPresenceRefs = state[key].map((m)=>m.presence_ref);
                const curPresences = currentPresences.filter((m)=>joinedPresenceRefs.indexOf(m.presence_ref) < 0);
                state[key].unshift(...curPresences);
            }
            onJoin(key, currentPresences, newPresences);
        });
        this.map(leaves, (key, leftPresences)=>{
            let currentPresences = state[key];
            if (!currentPresences) return;
            const presenceRefsToRemove = leftPresences.map((m)=>m.presence_ref);
            currentPresences = currentPresences.filter((m)=>presenceRefsToRemove.indexOf(m.presence_ref) < 0);
            state[key] = currentPresences;
            onLeave(key, currentPresences, leftPresences);
            if (currentPresences.length === 0) delete state[key];
        });
        return state;
    }
    /** @internal */ static map(obj, func) {
        return Object.getOwnPropertyNames(obj).map((key)=>func(key, obj[key]));
    }
    /**
     * Remove 'metas' key
     * Change 'phx_ref' to 'presence_ref'
     * Remove 'phx_ref' and 'phx_ref_prev'
     *
     * @example
     * // returns {
     *  abc123: [
     *    { presence_ref: '2', user_id: 1 },
     *    { presence_ref: '3', user_id: 2 }
     *  ]
     * }
     * RealtimePresence.transformState({
     *  abc123: {
     *    metas: [
     *      { phx_ref: '2', phx_ref_prev: '1' user_id: 1 },
     *      { phx_ref: '3', user_id: 2 }
     *    ]
     *  }
     * })
     *
     * @internal
     */ static transformState(state) {
        state = this.cloneDeep(state);
        return Object.getOwnPropertyNames(state).reduce((newState, key)=>{
            const presences = state[key];
            if ('metas' in presences) newState[key] = presences.metas.map((presence)=>{
                presence['presence_ref'] = presence['phx_ref'];
                delete presence['phx_ref'];
                delete presence['phx_ref_prev'];
                return presence;
            });
            else newState[key] = presences;
            return newState;
        }, {});
    }
    /** @internal */ static cloneDeep(obj) {
        return JSON.parse(JSON.stringify(obj));
    }
    /** @internal */ onJoin(callback) {
        this.caller.onJoin = callback;
    }
    /** @internal */ onLeave(callback) {
        this.caller.onLeave = callback;
    }
    /** @internal */ onSync(callback) {
        this.caller.onSync = callback;
    }
    /** @internal */ inPendingSyncState() {
        return !this.joinRef || this.joinRef !== this.channel._joinRef();
    }
    /**
     * Initializes the Presence.
     *
     * @param channel - The RealtimeChannel
     * @param opts - The options,
     *        for example `{events: {state: 'state', diff: 'diff'}}`
     */ constructor(channel, opts){
        this.channel = channel;
        this.state = {};
        this.pendingDiffs = [];
        this.joinRef = null;
        this.caller = {
            onJoin: ()=>{},
            onLeave: ()=>{},
            onSync: ()=>{}
        };
        const events = (opts === null || opts === void 0 ? void 0 : opts.events) || {
            state: 'presence_state',
            diff: 'presence_diff'
        };
        this.channel._on(events.state, {}, (newState)=>{
            const { onJoin: onJoin, onLeave: onLeave, onSync: onSync } = this.caller;
            this.joinRef = this.channel._joinRef();
            this.state = $a09b9d1dfd3983b5$export$2e2bcd8739ae039.syncState(this.state, newState, onJoin, onLeave);
            this.pendingDiffs.forEach((diff)=>{
                this.state = $a09b9d1dfd3983b5$export$2e2bcd8739ae039.syncDiff(this.state, diff, onJoin, onLeave);
            });
            this.pendingDiffs = [];
            onSync();
        });
        this.channel._on(events.diff, {}, (diff)=>{
            const { onJoin: onJoin, onLeave: onLeave, onSync: onSync } = this.caller;
            if (this.inPendingSyncState()) this.pendingDiffs.push(diff);
            else {
                this.state = $a09b9d1dfd3983b5$export$2e2bcd8739ae039.syncDiff(this.state, diff, onJoin, onLeave);
                onSync();
            }
        });
        this.onJoin((key, currentPresences, newPresences)=>{
            this.channel._trigger('presence', {
                event: 'join',
                key: key,
                currentPresences: currentPresences,
                newPresences: newPresences
            });
        });
        this.onLeave((key, currentPresences, leftPresences)=>{
            this.channel._trigger('presence', {
                event: 'leave',
                key: key,
                currentPresences: currentPresences,
                leftPresences: leftPresences
            });
        });
        this.onSync(()=>{
            this.channel._trigger('presence', {
                event: 'sync'
            });
        });
    }
}



var $63618391b80a2edd$export$bc171c571098b6c4;
(function(REALTIME_POSTGRES_CHANGES_LISTEN_EVENT) {
    REALTIME_POSTGRES_CHANGES_LISTEN_EVENT["ALL"] = "*";
    REALTIME_POSTGRES_CHANGES_LISTEN_EVENT["INSERT"] = "INSERT";
    REALTIME_POSTGRES_CHANGES_LISTEN_EVENT["UPDATE"] = "UPDATE";
    REALTIME_POSTGRES_CHANGES_LISTEN_EVENT["DELETE"] = "DELETE";
})($63618391b80a2edd$export$bc171c571098b6c4 || ($63618391b80a2edd$export$bc171c571098b6c4 = {}));
var $63618391b80a2edd$export$9e3fe8e487ef792e;
(function(REALTIME_LISTEN_TYPES) {
    REALTIME_LISTEN_TYPES["BROADCAST"] = "broadcast";
    REALTIME_LISTEN_TYPES["PRESENCE"] = "presence";
    REALTIME_LISTEN_TYPES["POSTGRES_CHANGES"] = "postgres_changes";
    REALTIME_LISTEN_TYPES["SYSTEM"] = "system";
})($63618391b80a2edd$export$9e3fe8e487ef792e || ($63618391b80a2edd$export$9e3fe8e487ef792e = {}));
var $63618391b80a2edd$export$a6885b926af646a2;
(function(REALTIME_SUBSCRIBE_STATES) {
    REALTIME_SUBSCRIBE_STATES["SUBSCRIBED"] = "SUBSCRIBED";
    REALTIME_SUBSCRIBE_STATES["TIMED_OUT"] = "TIMED_OUT";
    REALTIME_SUBSCRIBE_STATES["CLOSED"] = "CLOSED";
    REALTIME_SUBSCRIBE_STATES["CHANNEL_ERROR"] = "CHANNEL_ERROR";
})($63618391b80a2edd$export$a6885b926af646a2 || ($63618391b80a2edd$export$a6885b926af646a2 = {}));
const $63618391b80a2edd$export$154db638d9c0559e = (0, $8b2031009ae9dcb1$export$b83816118db74fe7);
class $63618391b80a2edd$export$2e2bcd8739ae039 {
    /** Subscribe registers your client with the server */ subscribe(callback, timeout = this.timeout) {
        var _a, _b;
        if (!this.socket.isConnected()) this.socket.connect();
        if (this.joinedOnce) throw `tried to subscribe multiple times. 'subscribe' can only be called a single time per channel instance`;
        else {
            const { config: { broadcast: broadcast, presence: presence, private: isPrivate } } = this.params;
            this._onError((e)=>callback === null || callback === void 0 ? void 0 : callback($63618391b80a2edd$export$a6885b926af646a2.CHANNEL_ERROR, e));
            this._onClose(()=>callback === null || callback === void 0 ? void 0 : callback($63618391b80a2edd$export$a6885b926af646a2.CLOSED));
            const accessTokenPayload = {};
            const config = {
                broadcast: broadcast,
                presence: presence,
                postgres_changes: (_b = (_a = this.bindings.postgres_changes) === null || _a === void 0 ? void 0 : _a.map((r)=>r.filter)) !== null && _b !== void 0 ? _b : [],
                private: isPrivate
            };
            if (this.socket.accessTokenValue) accessTokenPayload.access_token = this.socket.accessTokenValue;
            this.updateJoinPayload(Object.assign({
                config: config
            }, accessTokenPayload));
            this.joinedOnce = true;
            this._rejoin(timeout);
            this.joinPush.receive('ok', async ({ postgres_changes: postgres_changes })=>{
                var _a;
                this.socket.setAuth();
                if (postgres_changes === undefined) {
                    callback === null || callback === void 0 || callback($63618391b80a2edd$export$a6885b926af646a2.SUBSCRIBED);
                    return;
                } else {
                    const clientPostgresBindings = this.bindings.postgres_changes;
                    const bindingsLen = (_a = clientPostgresBindings === null || clientPostgresBindings === void 0 ? void 0 : clientPostgresBindings.length) !== null && _a !== void 0 ? _a : 0;
                    const newPostgresBindings = [];
                    for(let i = 0; i < bindingsLen; i++){
                        const clientPostgresBinding = clientPostgresBindings[i];
                        const { filter: { event: event, schema: schema, table: table, filter: filter } } = clientPostgresBinding;
                        const serverPostgresFilter = postgres_changes && postgres_changes[i];
                        if (serverPostgresFilter && serverPostgresFilter.event === event && serverPostgresFilter.schema === schema && serverPostgresFilter.table === table && serverPostgresFilter.filter === filter) newPostgresBindings.push(Object.assign(Object.assign({}, clientPostgresBinding), {
                            id: serverPostgresFilter.id
                        }));
                        else {
                            this.unsubscribe();
                            callback === null || callback === void 0 || callback($63618391b80a2edd$export$a6885b926af646a2.CHANNEL_ERROR, new Error('mismatch between server and client bindings for postgres changes'));
                            return;
                        }
                    }
                    this.bindings.postgres_changes = newPostgresBindings;
                    callback && callback($63618391b80a2edd$export$a6885b926af646a2.SUBSCRIBED);
                    return;
                }
            }).receive('error', (error)=>{
                callback === null || callback === void 0 || callback($63618391b80a2edd$export$a6885b926af646a2.CHANNEL_ERROR, new Error(JSON.stringify(Object.values(error).join(', ') || 'error')));
                return;
            }).receive('timeout', ()=>{
                callback === null || callback === void 0 || callback($63618391b80a2edd$export$a6885b926af646a2.TIMED_OUT);
                return;
            });
        }
        return this;
    }
    presenceState() {
        return this.presence.state;
    }
    async track(payload, opts = {}) {
        return await this.send({
            type: 'presence',
            event: 'track',
            payload: payload
        }, opts.timeout || this.timeout);
    }
    async untrack(opts = {}) {
        return await this.send({
            type: 'presence',
            event: 'untrack'
        }, opts);
    }
    on(type, filter, callback) {
        return this._on(type, filter, callback);
    }
    /**
     * Sends a message into the channel.
     *
     * @param args Arguments to send to channel
     * @param args.type The type of event to send
     * @param args.event The name of the event being sent
     * @param args.payload Payload to be sent
     * @param opts Options to be used during the send process
     */ async send(args, opts = {}) {
        var _a, _b;
        if (!this._canPush() && args.type === 'broadcast') {
            const { event: event, payload: endpoint_payload } = args;
            const authorization = this.socket.accessTokenValue ? `Bearer ${this.socket.accessTokenValue}` : '';
            const options = {
                method: 'POST',
                headers: {
                    Authorization: authorization,
                    apikey: this.socket.apiKey ? this.socket.apiKey : '',
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    messages: [
                        {
                            topic: this.subTopic,
                            event: event,
                            payload: endpoint_payload,
                            private: this.private
                        }
                    ]
                })
            };
            try {
                const response = await this._fetchWithTimeout(this.broadcastEndpointURL, options, (_a = opts.timeout) !== null && _a !== void 0 ? _a : this.timeout);
                await ((_b = response.body) === null || _b === void 0 ? void 0 : _b.cancel());
                return response.ok ? 'ok' : 'error';
            } catch (error) {
                if (error.name === 'AbortError') return 'timed out';
                else return 'error';
            }
        } else return new Promise((resolve)=>{
            var _a, _b, _c;
            const push = this._push(args.type, args, opts.timeout || this.timeout);
            if (args.type === 'broadcast' && !((_c = (_b = (_a = this.params) === null || _a === void 0 ? void 0 : _a.config) === null || _b === void 0 ? void 0 : _b.broadcast) === null || _c === void 0 ? void 0 : _c.ack)) resolve('ok');
            push.receive('ok', ()=>resolve('ok'));
            push.receive('error', ()=>resolve('error'));
            push.receive('timeout', ()=>resolve('timed out'));
        });
    }
    updateJoinPayload(payload) {
        this.joinPush.updatePayload(payload);
    }
    /**
     * Leaves the channel.
     *
     * Unsubscribes from server events, and instructs channel to terminate on server.
     * Triggers onClose() hooks.
     *
     * To receive leave acknowledgements, use the a `receive` hook to bind to the server ack, ie:
     * channel.unsubscribe().receive("ok", () => alert("left!") )
     */ unsubscribe(timeout = this.timeout) {
        this.state = (0, $8b2031009ae9dcb1$export$b83816118db74fe7).leaving;
        const onClose = ()=>{
            this.socket.log('channel', `leave ${this.topic}`);
            this._trigger((0, $8b2031009ae9dcb1$export$8db7548e65d6ea55).close, 'leave', this._joinRef());
        };
        this.rejoinTimer.reset();
        // Destroy joinPush to avoid connection timeouts during unscription phase
        this.joinPush.destroy();
        return new Promise((resolve)=>{
            const leavePush = new (0, $3785fda85e307754$export$2e2bcd8739ae039)(this, (0, $8b2031009ae9dcb1$export$8db7548e65d6ea55).leave, {}, timeout);
            leavePush.receive('ok', ()=>{
                onClose();
                resolve('ok');
            }).receive('timeout', ()=>{
                onClose();
                resolve('timed out');
            }).receive('error', ()=>{
                resolve('error');
            });
            leavePush.send();
            if (!this._canPush()) leavePush.trigger('ok', {});
        });
    }
    /** @internal */ async _fetchWithTimeout(url, options, timeout) {
        const controller = new AbortController();
        const id = setTimeout(()=>controller.abort(), timeout);
        const response = await this.socket.fetch(url, Object.assign(Object.assign({}, options), {
            signal: controller.signal
        }));
        clearTimeout(id);
        return response;
    }
    /** @internal */ _push(event, payload, timeout = this.timeout) {
        if (!this.joinedOnce) throw `tried to push '${event}' to '${this.topic}' before joining. Use channel.subscribe() before pushing events`;
        let pushEvent = new (0, $3785fda85e307754$export$2e2bcd8739ae039)(this, event, payload, timeout);
        if (this._canPush()) pushEvent.send();
        else {
            pushEvent.startTimeout();
            this.pushBuffer.push(pushEvent);
        }
        return pushEvent;
    }
    /**
     * Overridable message hook
     *
     * Receives all events for specialized message handling before dispatching to the channel callbacks.
     * Must return the payload, modified or unmodified.
     *
     * @internal
     */ _onMessage(_event, payload, _ref) {
        return payload;
    }
    /** @internal */ _isMember(topic) {
        return this.topic === topic;
    }
    /** @internal */ _joinRef() {
        return this.joinPush.ref;
    }
    /** @internal */ _trigger(type, payload, ref) {
        var _a, _b;
        const typeLower = type.toLocaleLowerCase();
        const { close: close, error: error, leave: leave, join: join } = (0, $8b2031009ae9dcb1$export$8db7548e65d6ea55);
        const events = [
            close,
            error,
            leave,
            join
        ];
        if (ref && events.indexOf(typeLower) >= 0 && ref !== this._joinRef()) return;
        let handledPayload = this._onMessage(typeLower, payload, ref);
        if (payload && !handledPayload) throw 'channel onMessage callbacks must return the payload, modified or unmodified';
        if ([
            'insert',
            'update',
            'delete'
        ].includes(typeLower)) (_a = this.bindings.postgres_changes) === null || _a === void 0 || _a.filter((bind)=>{
            var _a, _b, _c;
            return ((_a = bind.filter) === null || _a === void 0 ? void 0 : _a.event) === '*' || ((_c = (_b = bind.filter) === null || _b === void 0 ? void 0 : _b.event) === null || _c === void 0 ? void 0 : _c.toLocaleLowerCase()) === typeLower;
        }).map((bind)=>bind.callback(handledPayload, ref));
        else (_b = this.bindings[typeLower]) === null || _b === void 0 || _b.filter((bind)=>{
            var _a, _b, _c, _d, _e, _f;
            if ([
                'broadcast',
                'presence',
                'postgres_changes'
            ].includes(typeLower)) {
                if ('id' in bind) {
                    const bindId = bind.id;
                    const bindEvent = (_a = bind.filter) === null || _a === void 0 ? void 0 : _a.event;
                    return bindId && ((_b = payload.ids) === null || _b === void 0 ? void 0 : _b.includes(bindId)) && (bindEvent === '*' || (bindEvent === null || bindEvent === void 0 ? void 0 : bindEvent.toLocaleLowerCase()) === ((_c = payload.data) === null || _c === void 0 ? void 0 : _c.type.toLocaleLowerCase()));
                } else {
                    const bindEvent = (_e = (_d = bind === null || bind === void 0 ? void 0 : bind.filter) === null || _d === void 0 ? void 0 : _d.event) === null || _e === void 0 ? void 0 : _e.toLocaleLowerCase();
                    return bindEvent === '*' || bindEvent === ((_f = payload === null || payload === void 0 ? void 0 : payload.event) === null || _f === void 0 ? void 0 : _f.toLocaleLowerCase());
                }
            } else return bind.type.toLocaleLowerCase() === typeLower;
        }).map((bind)=>{
            if (typeof handledPayload === 'object' && 'ids' in handledPayload) {
                const postgresChanges = handledPayload.data;
                const { schema: schema, table: table, commit_timestamp: commit_timestamp, type: type, errors: errors } = postgresChanges;
                const enrichedPayload = {
                    schema: schema,
                    table: table,
                    commit_timestamp: commit_timestamp,
                    eventType: type,
                    new: {},
                    old: {},
                    errors: errors
                };
                handledPayload = Object.assign(Object.assign({}, enrichedPayload), this._getPayloadRecords(postgresChanges));
            }
            bind.callback(handledPayload, ref);
        });
    }
    /** @internal */ _isClosed() {
        return this.state === (0, $8b2031009ae9dcb1$export$b83816118db74fe7).closed;
    }
    /** @internal */ _isJoined() {
        return this.state === (0, $8b2031009ae9dcb1$export$b83816118db74fe7).joined;
    }
    /** @internal */ _isJoining() {
        return this.state === (0, $8b2031009ae9dcb1$export$b83816118db74fe7).joining;
    }
    /** @internal */ _isLeaving() {
        return this.state === (0, $8b2031009ae9dcb1$export$b83816118db74fe7).leaving;
    }
    /** @internal */ _replyEventName(ref) {
        return `chan_reply_${ref}`;
    }
    /** @internal */ _on(type, filter, callback) {
        const typeLower = type.toLocaleLowerCase();
        const binding = {
            type: typeLower,
            filter: filter,
            callback: callback
        };
        if (this.bindings[typeLower]) this.bindings[typeLower].push(binding);
        else this.bindings[typeLower] = [
            binding
        ];
        return this;
    }
    /** @internal */ _off(type, filter) {
        const typeLower = type.toLocaleLowerCase();
        this.bindings[typeLower] = this.bindings[typeLower].filter((bind)=>{
            var _a;
            return !(((_a = bind.type) === null || _a === void 0 ? void 0 : _a.toLocaleLowerCase()) === typeLower && $63618391b80a2edd$export$2e2bcd8739ae039.isEqual(bind.filter, filter));
        });
        return this;
    }
    /** @internal */ static isEqual(obj1, obj2) {
        if (Object.keys(obj1).length !== Object.keys(obj2).length) return false;
        for(const k in obj1){
            if (obj1[k] !== obj2[k]) return false;
        }
        return true;
    }
    /** @internal */ _rejoinUntilConnected() {
        this.rejoinTimer.scheduleTimeout();
        if (this.socket.isConnected()) this._rejoin();
    }
    /**
     * Registers a callback that will be executed when the channel closes.
     *
     * @internal
     */ _onClose(callback) {
        this._on((0, $8b2031009ae9dcb1$export$8db7548e65d6ea55).close, {}, callback);
    }
    /**
     * Registers a callback that will be executed when the channel encounteres an error.
     *
     * @internal
     */ _onError(callback) {
        this._on((0, $8b2031009ae9dcb1$export$8db7548e65d6ea55).error, {}, (reason)=>callback(reason));
    }
    /**
     * Returns `true` if the socket is connected and the channel has been joined.
     *
     * @internal
     */ _canPush() {
        return this.socket.isConnected() && this._isJoined();
    }
    /** @internal */ _rejoin(timeout = this.timeout) {
        if (this._isLeaving()) return;
        this.socket._leaveOpenTopic(this.topic);
        this.state = (0, $8b2031009ae9dcb1$export$b83816118db74fe7).joining;
        this.joinPush.resend(timeout);
    }
    /** @internal */ _getPayloadRecords(payload) {
        const records = {
            new: {},
            old: {}
        };
        if (payload.type === 'INSERT' || payload.type === 'UPDATE') records.new = $e10f566fa6faed34$export$20ce708a1f594c5e(payload.columns, payload.record);
        if (payload.type === 'UPDATE' || payload.type === 'DELETE') records.old = $e10f566fa6faed34$export$20ce708a1f594c5e(payload.columns, payload.old_record);
        return records;
    }
    constructor(/** Topic name can be any string. */ topic, params = {
        config: {}
    }, socket){
        this.topic = topic;
        this.params = params;
        this.socket = socket;
        this.bindings = {};
        this.state = (0, $8b2031009ae9dcb1$export$b83816118db74fe7).closed;
        this.joinedOnce = false;
        this.pushBuffer = [];
        this.subTopic = topic.replace(/^realtime:/i, '');
        this.params.config = Object.assign({
            broadcast: {
                ack: false,
                self: false
            },
            presence: {
                key: ''
            },
            private: false
        }, params.config);
        this.timeout = this.socket.timeout;
        this.joinPush = new (0, $3785fda85e307754$export$2e2bcd8739ae039)(this, (0, $8b2031009ae9dcb1$export$8db7548e65d6ea55).join, this.params, this.timeout);
        this.rejoinTimer = new (0, $6d6ed1c5f76a59fa$export$2e2bcd8739ae039)(()=>this._rejoinUntilConnected(), this.socket.reconnectAfterMs);
        this.joinPush.receive('ok', ()=>{
            this.state = (0, $8b2031009ae9dcb1$export$b83816118db74fe7).joined;
            this.rejoinTimer.reset();
            this.pushBuffer.forEach((pushEvent)=>pushEvent.send());
            this.pushBuffer = [];
        });
        this._onClose(()=>{
            this.rejoinTimer.reset();
            this.socket.log('channel', `close ${this.topic} ${this._joinRef()}`);
            this.state = (0, $8b2031009ae9dcb1$export$b83816118db74fe7).closed;
            this.socket._remove(this);
        });
        this._onError((reason)=>{
            if (this._isLeaving() || this._isClosed()) return;
            this.socket.log('channel', `error ${this.topic}`, reason);
            this.state = (0, $8b2031009ae9dcb1$export$b83816118db74fe7).errored;
            this.rejoinTimer.scheduleTimeout();
        });
        this.joinPush.receive('timeout', ()=>{
            if (!this._isJoining()) return;
            this.socket.log('channel', `timeout ${this.topic}`, this.joinPush.timeout);
            this.state = (0, $8b2031009ae9dcb1$export$b83816118db74fe7).errored;
            this.rejoinTimer.scheduleTimeout();
        });
        this._on((0, $8b2031009ae9dcb1$export$8db7548e65d6ea55).reply, {}, (payload, ref)=>{
            this._trigger(this._replyEventName(ref), payload);
        });
        this.presence = new (0, $a09b9d1dfd3983b5$export$2e2bcd8739ae039)(this);
        this.broadcastEndpointURL = (0, $e10f566fa6faed34$export$976fda7151b30cae)(this.socket.endPoint) + '/api/broadcast';
        this.private = this.params.config.private || false;
    }
}


const $79dca8bb970bd1bc$var$noop = ()=>{};
const $79dca8bb970bd1bc$var$NATIVE_WEBSOCKET_AVAILABLE = typeof WebSocket !== 'undefined';
const $79dca8bb970bd1bc$var$WORKER_SCRIPT = `
  addEventListener("message", (e) => {
    if (e.data.event === "start") {
      setInterval(() => postMessage({ event: "keepAlive" }), e.data.interval);
    }
  });`;


class $79dca8bb970bd1bc$export$2e2bcd8739ae039 {
    /**
     * Connects the socket, unless already connected.
     */ connect() {
        if (this.conn) return;
        if (this.transport) {
            this.conn = new this.transport(this.endpointURL(), undefined, {
                headers: this.headers
            });
            return;
        }
        if ($79dca8bb970bd1bc$var$NATIVE_WEBSOCKET_AVAILABLE) {
            this.conn = new WebSocket(this.endpointURL());
            this.setupConnection();
            return;
        }
        this.conn = new $79dca8bb970bd1bc$var$WSWebSocketDummy(this.endpointURL(), undefined, {
            close: ()=>{
                this.conn = null;
            }
        });
        (parcelRequire("jwdj5")).then(({ default: WS })=>{
            this.conn = new WS(this.endpointURL(), undefined, {
                headers: this.headers
            });
            this.setupConnection();
        });
    }
    /**
     * Returns the URL of the websocket.
     * @returns string The URL of the websocket.
     */ endpointURL() {
        return this._appendParams(this.endPoint, Object.assign({}, this.params, {
            vsn: (0, $8b2031009ae9dcb1$export$df3f558bb9a9c991)
        }));
    }
    /**
     * Disconnects the socket.
     *
     * @param code A numeric status code to send on disconnect.
     * @param reason A custom reason for the disconnect.
     */ disconnect(code, reason) {
        if (this.conn) {
            this.conn.onclose = function() {}; // noop
            if (code) this.conn.close(code, reason !== null && reason !== void 0 ? reason : '');
            else this.conn.close();
            this.conn = null;
            // remove open handles
            this.heartbeatTimer && clearInterval(this.heartbeatTimer);
            this.reconnectTimer.reset();
        }
    }
    /**
     * Returns all created channels
     */ getChannels() {
        return this.channels;
    }
    /**
     * Unsubscribes and removes a single channel
     * @param channel A RealtimeChannel instance
     */ async removeChannel(channel) {
        const status = await channel.unsubscribe();
        if (this.channels.length === 0) this.disconnect();
        return status;
    }
    /**
     * Unsubscribes and removes all channels
     */ async removeAllChannels() {
        const values_1 = await Promise.all(this.channels.map((channel)=>channel.unsubscribe()));
        this.disconnect();
        return values_1;
    }
    /**
     * Logs the message.
     *
     * For customized logging, `this.logger` can be overridden.
     */ log(kind, msg, data) {
        this.logger(kind, msg, data);
    }
    /**
     * Returns the current state of the socket.
     */ connectionState() {
        switch(this.conn && this.conn.readyState){
            case (0, $8b2031009ae9dcb1$export$a6d0320a1563d49e).connecting:
                return (0, $8b2031009ae9dcb1$export$deda39003d27273).Connecting;
            case (0, $8b2031009ae9dcb1$export$a6d0320a1563d49e).open:
                return (0, $8b2031009ae9dcb1$export$deda39003d27273).Open;
            case (0, $8b2031009ae9dcb1$export$a6d0320a1563d49e).closing:
                return (0, $8b2031009ae9dcb1$export$deda39003d27273).Closing;
            default:
                return (0, $8b2031009ae9dcb1$export$deda39003d27273).Closed;
        }
    }
    /**
     * Returns `true` is the connection is open.
     */ isConnected() {
        return this.connectionState() === (0, $8b2031009ae9dcb1$export$deda39003d27273).Open;
    }
    channel(topic, params = {
        config: {}
    }) {
        const chan = new (0, $63618391b80a2edd$export$2e2bcd8739ae039)(`realtime:${topic}`, params, this);
        this.channels.push(chan);
        return chan;
    }
    /**
     * Push out a message if the socket is connected.
     *
     * If the socket is not connected, the message gets enqueued within a local buffer, and sent out when a connection is next established.
     */ push(data) {
        const { topic: topic, event: event, payload: payload, ref: ref } = data;
        const callback = ()=>{
            this.encode(data, (result)=>{
                var _a;
                (_a = this.conn) === null || _a === void 0 || _a.send(result);
            });
        };
        this.log('push', `${topic} ${event} (${ref})`, payload);
        if (this.isConnected()) callback();
        else this.sendBuffer.push(callback);
    }
    /**
     * Sets the JWT access token used for channel subscription authorization and Realtime RLS.
     *
     * If param is null it will use the `accessToken` callback function or the token set on the client.
     *
     * On callback used, it will set the value of the token internal to the client.
     *
     * @param token A JWT string to override the token set on the client.
     */ async setAuth(token = null) {
        let tokenToSend = token || this.accessToken && await this.accessToken() || this.accessTokenValue;
        if (tokenToSend) {
            let parsed = null;
            try {
                parsed = JSON.parse(atob(tokenToSend.split('.')[1]));
            } catch (_error) {}
            if (parsed && parsed.exp) {
                let now = Math.floor(Date.now() / 1000);
                let valid = now - parsed.exp < 0;
                if (!valid) {
                    this.log('auth', `InvalidJWTToken: Invalid value for JWT claim "exp" with value ${parsed.exp}`);
                    return Promise.reject(`InvalidJWTToken: Invalid value for JWT claim "exp" with value ${parsed.exp}`);
                }
            }
            this.accessTokenValue = tokenToSend;
            this.channels.forEach((channel)=>{
                tokenToSend && channel.updateJoinPayload({
                    access_token: tokenToSend
                });
                if (channel.joinedOnce && channel._isJoined()) channel._push((0, $8b2031009ae9dcb1$export$8db7548e65d6ea55).access_token, {
                    access_token: tokenToSend
                });
            });
        }
    }
    /**
     * Sends a heartbeat message if the socket is connected.
     */ async sendHeartbeat() {
        var _a;
        if (!this.isConnected()) return;
        if (this.pendingHeartbeatRef) {
            this.pendingHeartbeatRef = null;
            this.log('transport', 'heartbeat timeout. Attempting to re-establish connection');
            (_a = this.conn) === null || _a === void 0 || _a.close((0, $8b2031009ae9dcb1$export$5e80cf62e56a877b), 'hearbeat timeout');
            return;
        }
        this.pendingHeartbeatRef = this._makeRef();
        this.push({
            topic: 'phoenix',
            event: 'heartbeat',
            payload: {},
            ref: this.pendingHeartbeatRef
        });
        this.setAuth();
    }
    /**
     * Flushes send buffer
     */ flushSendBuffer() {
        if (this.isConnected() && this.sendBuffer.length > 0) {
            this.sendBuffer.forEach((callback)=>callback());
            this.sendBuffer = [];
        }
    }
    /**
     * Return the next message ref, accounting for overflows
     *
     * @internal
     */ _makeRef() {
        let newRef = this.ref + 1;
        if (newRef === this.ref) this.ref = 0;
        else this.ref = newRef;
        return this.ref.toString();
    }
    /**
     * Unsubscribe from channels with the specified topic.
     *
     * @internal
     */ _leaveOpenTopic(topic) {
        let dupChannel = this.channels.find((c)=>c.topic === topic && (c._isJoined() || c._isJoining()));
        if (dupChannel) {
            this.log('transport', `leaving duplicate topic "${topic}"`);
            dupChannel.unsubscribe();
        }
    }
    /**
     * Removes a subscription from the socket.
     *
     * @param channel An open subscription.
     *
     * @internal
     */ _remove(channel) {
        this.channels = this.channels.filter((c)=>c._joinRef() !== channel._joinRef());
    }
    /**
     * Sets up connection handlers.
     *
     * @internal
     */ setupConnection() {
        if (this.conn) {
            this.conn.binaryType = 'arraybuffer';
            this.conn.onopen = ()=>this._onConnOpen();
            this.conn.onerror = (error)=>this._onConnError(error);
            this.conn.onmessage = (event)=>this._onConnMessage(event);
            this.conn.onclose = (event)=>this._onConnClose(event);
        }
    }
    /** @internal */ _onConnMessage(rawMessage) {
        this.decode(rawMessage.data, (msg)=>{
            let { topic: topic, event: event, payload: payload, ref: ref } = msg;
            if (ref && ref === this.pendingHeartbeatRef) this.pendingHeartbeatRef = null;
            this.log('receive', `${payload.status || ''} ${topic} ${event} ${ref && '(' + ref + ')' || ''}`, payload);
            this.channels.filter((channel)=>channel._isMember(topic)).forEach((channel)=>channel._trigger(event, payload, ref));
            this.stateChangeCallbacks.message.forEach((callback)=>callback(msg));
        });
    }
    /** @internal */ async _onConnOpen() {
        this.log('transport', `connected to ${this.endpointURL()}`);
        this.flushSendBuffer();
        this.reconnectTimer.reset();
        if (!this.worker) {
            this.heartbeatTimer && clearInterval(this.heartbeatTimer);
            this.heartbeatTimer = setInterval(()=>this.sendHeartbeat(), this.heartbeatIntervalMs);
        } else {
            if (this.workerUrl) this.log('worker', `starting worker for from ${this.workerUrl}`);
            else this.log('worker', `starting default worker`);
            const objectUrl = this._workerObjectUrl(this.workerUrl);
            this.workerRef = new Worker(objectUrl);
            this.workerRef.onerror = (error)=>{
                this.log('worker', 'worker error', error.message);
                this.workerRef.terminate();
            };
            this.workerRef.onmessage = (event)=>{
                if (event.data.event === 'keepAlive') this.sendHeartbeat();
            };
            this.workerRef.postMessage({
                event: 'start',
                interval: this.heartbeatIntervalMs
            });
        }
        this.stateChangeCallbacks.open.forEach((callback)=>callback());
    }
    /** @internal */ _onConnClose(event) {
        this.log('transport', 'close', event);
        this._triggerChanError();
        this.heartbeatTimer && clearInterval(this.heartbeatTimer);
        this.reconnectTimer.scheduleTimeout();
        this.stateChangeCallbacks.close.forEach((callback)=>callback(event));
    }
    /** @internal */ _onConnError(error) {
        this.log('transport', error.message);
        this._triggerChanError();
        this.stateChangeCallbacks.error.forEach((callback)=>callback(error));
    }
    /** @internal */ _triggerChanError() {
        this.channels.forEach((channel)=>channel._trigger((0, $8b2031009ae9dcb1$export$8db7548e65d6ea55).error));
    }
    /** @internal */ _appendParams(url, params) {
        if (Object.keys(params).length === 0) return url;
        const prefix = url.match(/\?/) ? '&' : '?';
        const query = new URLSearchParams(params);
        return `${url}${prefix}${query}`;
    }
    _workerObjectUrl(url) {
        let result_url;
        if (url) result_url = url;
        else {
            const blob = new Blob([
                $79dca8bb970bd1bc$var$WORKER_SCRIPT
            ], {
                type: 'application/javascript'
            });
            result_url = URL.createObjectURL(blob);
        }
        return result_url;
    }
    /**
     * Initializes the Socket.
     *
     * @param endPoint The string WebSocket endpoint, ie, "ws://example.com/socket", "wss://example.com", "/socket" (inherited host & protocol)
     * @param httpEndpoint The string HTTP endpoint, ie, "https://example.com", "/" (inherited host & protocol)
     * @param options.transport The Websocket Transport, for example WebSocket.
     * @param options.timeout The default timeout in milliseconds to trigger push timeouts.
     * @param options.params The optional params to pass when connecting.
     * @param options.headers The optional headers to pass when connecting.
     * @param options.heartbeatIntervalMs The millisec interval to send a heartbeat message.
     * @param options.logger The optional function for specialized logging, ie: logger: (kind, msg, data) => { console.log(`${kind}: ${msg}`, data) }
     * @param options.encode The function to encode outgoing messages. Defaults to JSON: (payload, callback) => callback(JSON.stringify(payload))
     * @param options.decode The function to decode incoming messages. Defaults to Serializer's decode.
     * @param options.reconnectAfterMs he optional function that returns the millsec reconnect interval. Defaults to stepped backoff off.
     * @param options.worker Use Web Worker to set a side flow. Defaults to false.
     * @param options.workerUrl The URL of the worker script. Defaults to https://realtime.supabase.com/worker.js that includes a heartbeat event call to keep the connection alive.
     */ constructor(endPoint, options){
        var _a;
        this.accessTokenValue = null;
        this.apiKey = null;
        this.channels = [];
        this.endPoint = '';
        this.httpEndpoint = '';
        this.headers = (0, $8b2031009ae9dcb1$export$88a84136db6a4b64);
        this.params = {};
        this.timeout = (0, $8b2031009ae9dcb1$export$7bd623b29ec8e1eb);
        this.heartbeatIntervalMs = 30000;
        this.heartbeatTimer = undefined;
        this.pendingHeartbeatRef = null;
        this.ref = 0;
        this.logger = $79dca8bb970bd1bc$var$noop;
        this.conn = null;
        this.sendBuffer = [];
        this.serializer = new (0, $1d08bc1ca729af48$export$2e2bcd8739ae039)();
        this.stateChangeCallbacks = {
            open: [],
            close: [],
            error: [],
            message: []
        };
        this.accessToken = null;
        /**
         * Use either custom fetch, if provided, or default fetch to make HTTP requests
         *
         * @internal
         */ this._resolveFetch = (customFetch)=>{
            let _fetch;
            if (customFetch) _fetch = customFetch;
            else if (typeof fetch === 'undefined') _fetch = (...args)=>Promise.resolve((parcelRequire("ff1Or"))).then(({ default: fetch1 })=>fetch1(...args));
            else _fetch = fetch;
            return (...args)=>_fetch(...args);
        };
        this.endPoint = `${endPoint}/${(0, $8b2031009ae9dcb1$export$b2688bfb999f5751).websocket}`;
        this.httpEndpoint = (0, $e10f566fa6faed34$export$976fda7151b30cae)(endPoint);
        if (options === null || options === void 0 ? void 0 : options.transport) this.transport = options.transport;
        else this.transport = null;
        if (options === null || options === void 0 ? void 0 : options.params) this.params = options.params;
        if (options === null || options === void 0 ? void 0 : options.headers) this.headers = Object.assign(Object.assign({}, this.headers), options.headers);
        if (options === null || options === void 0 ? void 0 : options.timeout) this.timeout = options.timeout;
        if (options === null || options === void 0 ? void 0 : options.logger) this.logger = options.logger;
        if (options === null || options === void 0 ? void 0 : options.heartbeatIntervalMs) this.heartbeatIntervalMs = options.heartbeatIntervalMs;
        const accessTokenValue = (_a = options === null || options === void 0 ? void 0 : options.params) === null || _a === void 0 ? void 0 : _a.apikey;
        if (accessTokenValue) {
            this.accessTokenValue = accessTokenValue;
            this.apiKey = accessTokenValue;
        }
        this.reconnectAfterMs = (options === null || options === void 0 ? void 0 : options.reconnectAfterMs) ? options.reconnectAfterMs : (tries)=>{
            return [
                1000,
                2000,
                5000,
                10000
            ][tries - 1] || 10000;
        };
        this.encode = (options === null || options === void 0 ? void 0 : options.encode) ? options.encode : (payload, callback)=>{
            return callback(JSON.stringify(payload));
        };
        this.decode = (options === null || options === void 0 ? void 0 : options.decode) ? options.decode : this.serializer.decode.bind(this.serializer);
        this.reconnectTimer = new (0, $6d6ed1c5f76a59fa$export$2e2bcd8739ae039)(async ()=>{
            this.disconnect();
            this.connect();
        }, this.reconnectAfterMs);
        this.fetch = this._resolveFetch(options === null || options === void 0 ? void 0 : options.fetch);
        if (options === null || options === void 0 ? void 0 : options.worker) {
            if (typeof window !== 'undefined' && !window.Worker) throw new Error('Web Worker is not supported');
            this.worker = (options === null || options === void 0 ? void 0 : options.worker) || false;
            this.workerUrl = options === null || options === void 0 ? void 0 : options.workerUrl;
        }
        this.accessToken = (options === null || options === void 0 ? void 0 : options.accessToken) || null;
    }
}
class $79dca8bb970bd1bc$var$WSWebSocketDummy {
    constructor(address, _protocols, options){
        this.binaryType = 'arraybuffer';
        this.onclose = ()=>{};
        this.onerror = ()=>{};
        this.onmessage = ()=>{};
        this.onopen = ()=>{};
        this.readyState = (0, $8b2031009ae9dcb1$export$a6d0320a1563d49e).connecting;
        this.send = ()=>{};
        this.url = null;
        this.url = address;
        this.close = options.close;
    }
}






class $51c78ec6155f1b91$export$697502632950e9d3 extends Error {
    constructor(message){
        super(message);
        this.__isStorageError = true;
        this.name = 'StorageError';
    }
}
function $51c78ec6155f1b91$export$5a322e77e5eb0561(error) {
    return typeof error === 'object' && error !== null && '__isStorageError' in error;
}
class $51c78ec6155f1b91$export$ca9ecfd959b3871c extends $51c78ec6155f1b91$export$697502632950e9d3 {
    toJSON() {
        return {
            name: this.name,
            message: this.message,
            status: this.status
        };
    }
    constructor(message, status){
        super(message);
        this.name = 'StorageApiError';
        this.status = status;
    }
}
class $51c78ec6155f1b91$export$29127ca2e1a271d extends $51c78ec6155f1b91$export$697502632950e9d3 {
    constructor(message, originalError){
        super(message);
        this.name = 'StorageUnknownError';
        this.originalError = originalError;
    }
}



var $f1a416fa3294a9bc$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};

const $f1a416fa3294a9bc$export$98d92b1aa79f8cc7 = (customFetch)=>{
    let _fetch;
    if (customFetch) _fetch = customFetch;
    else if (typeof fetch === 'undefined') _fetch = (...args)=>Promise.resolve((parcelRequire("ff1Or"))).then(({ default: fetch1 })=>fetch1(...args));
    else _fetch = fetch;
    return (...args)=>_fetch(...args);
};

const $f1a416fa3294a9bc$export$ace1d6afc438cf26 = ()=>$f1a416fa3294a9bc$var$__awaiter(void 0, void 0, void 0, function*() {
        if (typeof Response === 'undefined') // @ts-ignore
        return (yield Promise.resolve((parcelRequire("ff1Or")))).Response;
        return Response;
    });
const $f1a416fa3294a9bc$export$69d519e35e6fc3d4 = (item)=>{
    if (Array.isArray(item)) return item.map((el)=>$f1a416fa3294a9bc$export$69d519e35e6fc3d4(el));
    else if (typeof item === 'function' || item !== Object(item)) return item;
    const result = {};
    Object.entries(item).forEach(([key, value])=>{
        const newKey = key.replace(/([-_][a-z])/gi, (c)=>c.toUpperCase().replace(/[-_]/g, ''));
        result[newKey] = $f1a416fa3294a9bc$export$69d519e35e6fc3d4(value);
    });
    return result;
};


var $5f83d619f3d04456$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const $5f83d619f3d04456$var$_getErrorMessage = (err)=>err.msg || err.message || err.error_description || err.error || JSON.stringify(err);
const $5f83d619f3d04456$var$handleError = (error, reject, options)=>$5f83d619f3d04456$var$__awaiter(void 0, void 0, void 0, function*() {
        const Res = yield (0, $f1a416fa3294a9bc$export$ace1d6afc438cf26)();
        if (error instanceof Res && !(options === null || options === void 0 ? void 0 : options.noResolveJson)) error.json().then((err)=>{
            reject(new (0, $51c78ec6155f1b91$export$ca9ecfd959b3871c)($5f83d619f3d04456$var$_getErrorMessage(err), error.status || 500));
        }).catch((err)=>{
            reject(new (0, $51c78ec6155f1b91$export$29127ca2e1a271d)($5f83d619f3d04456$var$_getErrorMessage(err), err));
        });
        else reject(new (0, $51c78ec6155f1b91$export$29127ca2e1a271d)($5f83d619f3d04456$var$_getErrorMessage(error), error));
    });
const $5f83d619f3d04456$var$_getRequestParams = (method, options, parameters, body)=>{
    const params = {
        method: method,
        headers: (options === null || options === void 0 ? void 0 : options.headers) || {}
    };
    if (method === 'GET') return params;
    params.headers = Object.assign({
        'Content-Type': 'application/json'
    }, options === null || options === void 0 ? void 0 : options.headers);
    if (body) params.body = JSON.stringify(body);
    return Object.assign(Object.assign({}, params), parameters);
};
function $5f83d619f3d04456$var$_handleRequest(fetcher, method, url, options, parameters, body) {
    return $5f83d619f3d04456$var$__awaiter(this, void 0, void 0, function*() {
        return new Promise((resolve, reject)=>{
            fetcher(url, $5f83d619f3d04456$var$_getRequestParams(method, options, parameters, body)).then((result)=>{
                if (!result.ok) throw result;
                if (options === null || options === void 0 ? void 0 : options.noResolveJson) return result;
                return result.json();
            }).then((data)=>resolve(data)).catch((error)=>$5f83d619f3d04456$var$handleError(error, reject, options));
        });
    });
}
function $5f83d619f3d04456$export$3988ae62b71be9a3(fetcher, url, options, parameters) {
    return $5f83d619f3d04456$var$__awaiter(this, void 0, void 0, function*() {
        return $5f83d619f3d04456$var$_handleRequest(fetcher, 'GET', url, options, parameters);
    });
}
function $5f83d619f3d04456$export$299ba2dee77727e9(fetcher, url, body, options, parameters) {
    return $5f83d619f3d04456$var$__awaiter(this, void 0, void 0, function*() {
        return $5f83d619f3d04456$var$_handleRequest(fetcher, 'POST', url, options, parameters, body);
    });
}
function $5f83d619f3d04456$export$327f7b26ebf455db(fetcher, url, body, options, parameters) {
    return $5f83d619f3d04456$var$__awaiter(this, void 0, void 0, function*() {
        return $5f83d619f3d04456$var$_handleRequest(fetcher, 'PUT', url, options, parameters, body);
    });
}
function $5f83d619f3d04456$export$5fd5031fecdacec3(fetcher, url, options, parameters) {
    return $5f83d619f3d04456$var$__awaiter(this, void 0, void 0, function*() {
        return $5f83d619f3d04456$var$_handleRequest(fetcher, 'HEAD', url, Object.assign(Object.assign({}, options), {
            noResolveJson: true
        }), parameters);
    });
}
function $5f83d619f3d04456$export$cd7f480d6b8286c3(fetcher, url, body, options, parameters) {
    return $5f83d619f3d04456$var$__awaiter(this, void 0, void 0, function*() {
        return $5f83d619f3d04456$var$_handleRequest(fetcher, 'DELETE', url, options, parameters, body);
    });
}



/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $524ab3360ae8bc25$export$a143d493d941bafc;
var $524ab3360ae8bc25$export$e4cf37d7f6fb9e0a;
var $524ab3360ae8bc25$export$f99ded8fe4b79145;
var $524ab3360ae8bc25$export$599f31c3813fae4d;
'use strict';
var $78fa89e0eb190ae0$export$a48f0734ac7c2329;
var $78fa89e0eb190ae0$export$d622b2ad8d90c771;
var $78fa89e0eb190ae0$export$6100ba28696e12de;
'use strict';
$78fa89e0eb190ae0$export$a48f0734ac7c2329 = $78fa89e0eb190ae0$var$byteLength;
$78fa89e0eb190ae0$export$d622b2ad8d90c771 = $78fa89e0eb190ae0$var$toByteArray;
$78fa89e0eb190ae0$export$6100ba28696e12de = $78fa89e0eb190ae0$var$fromByteArray;
var $78fa89e0eb190ae0$var$lookup = [];
var $78fa89e0eb190ae0$var$revLookup = [];
var $78fa89e0eb190ae0$var$Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array;
var $78fa89e0eb190ae0$var$code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
for(var $78fa89e0eb190ae0$var$i = 0, $78fa89e0eb190ae0$var$len = $78fa89e0eb190ae0$var$code.length; $78fa89e0eb190ae0$var$i < $78fa89e0eb190ae0$var$len; ++$78fa89e0eb190ae0$var$i){
    $78fa89e0eb190ae0$var$lookup[$78fa89e0eb190ae0$var$i] = $78fa89e0eb190ae0$var$code[$78fa89e0eb190ae0$var$i];
    $78fa89e0eb190ae0$var$revLookup[$78fa89e0eb190ae0$var$code.charCodeAt($78fa89e0eb190ae0$var$i)] = $78fa89e0eb190ae0$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$78fa89e0eb190ae0$var$revLookup['-'.charCodeAt(0)] = 62;
$78fa89e0eb190ae0$var$revLookup['_'.charCodeAt(0)] = 63;
function $78fa89e0eb190ae0$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error('Invalid string. Length must be a multiple of 4');
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf('=');
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $78fa89e0eb190ae0$var$byteLength(b64) {
    var lens = $78fa89e0eb190ae0$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $78fa89e0eb190ae0$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $78fa89e0eb190ae0$var$toByteArray(b64) {
    var tmp;
    var lens = $78fa89e0eb190ae0$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $78fa89e0eb190ae0$var$Arr($78fa89e0eb190ae0$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $78fa89e0eb190ae0$var$revLookup[b64.charCodeAt(i)] << 18 | $78fa89e0eb190ae0$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $78fa89e0eb190ae0$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $78fa89e0eb190ae0$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $78fa89e0eb190ae0$var$revLookup[b64.charCodeAt(i)] << 2 | $78fa89e0eb190ae0$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $78fa89e0eb190ae0$var$revLookup[b64.charCodeAt(i)] << 10 | $78fa89e0eb190ae0$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $78fa89e0eb190ae0$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $78fa89e0eb190ae0$var$tripletToBase64(num) {
    return $78fa89e0eb190ae0$var$lookup[num >> 18 & 0x3F] + $78fa89e0eb190ae0$var$lookup[num >> 12 & 0x3F] + $78fa89e0eb190ae0$var$lookup[num >> 6 & 0x3F] + $78fa89e0eb190ae0$var$lookup[num & 0x3F];
}
function $78fa89e0eb190ae0$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($78fa89e0eb190ae0$var$tripletToBase64(tmp));
    }
    return output.join('');
}
function $78fa89e0eb190ae0$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($78fa89e0eb190ae0$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($78fa89e0eb190ae0$var$lookup[tmp >> 2] + $78fa89e0eb190ae0$var$lookup[tmp << 4 & 0x3F] + '==');
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($78fa89e0eb190ae0$var$lookup[tmp >> 10] + $78fa89e0eb190ae0$var$lookup[tmp >> 4 & 0x3F] + $78fa89e0eb190ae0$var$lookup[tmp << 2 & 0x3F] + '=');
    }
    return parts.join('');
}


/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $ebbbfcdbce5bf42e$export$aafa59e2e03f2942;
var $ebbbfcdbce5bf42e$export$68d8715fc104d294;
$ebbbfcdbce5bf42e$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$ebbbfcdbce5bf42e$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};


const $524ab3360ae8bc25$var$customInspectSymbol = typeof Symbol === 'function' && typeof Symbol['for'] === 'function' // eslint-disable-line dot-notation
 ? Symbol['for']('nodejs.util.inspect.custom') // eslint-disable-line dot-notation
 : null;
$524ab3360ae8bc25$export$a143d493d941bafc = $524ab3360ae8bc25$var$Buffer;
$524ab3360ae8bc25$export$e4cf37d7f6fb9e0a = $524ab3360ae8bc25$var$SlowBuffer;
$524ab3360ae8bc25$export$f99ded8fe4b79145 = 50;
const $524ab3360ae8bc25$var$K_MAX_LENGTH = 0x7fffffff;
$524ab3360ae8bc25$export$599f31c3813fae4d = $524ab3360ae8bc25$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $524ab3360ae8bc25$var$Buffer.TYPED_ARRAY_SUPPORT = $524ab3360ae8bc25$var$typedArraySupport();
if (!$524ab3360ae8bc25$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' && typeof console.error === 'function') console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $524ab3360ae8bc25$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        const arr = new Uint8Array(1);
        const proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($524ab3360ae8bc25$var$Buffer.prototype, 'parent', {
    enumerable: true,
    get: function() {
        if (!$524ab3360ae8bc25$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($524ab3360ae8bc25$var$Buffer.prototype, 'offset', {
    enumerable: true,
    get: function() {
        if (!$524ab3360ae8bc25$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $524ab3360ae8bc25$var$createBuffer(length) {
    if (length > $524ab3360ae8bc25$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    const buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $524ab3360ae8bc25$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $524ab3360ae8bc25$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === 'number') {
        if (typeof encodingOrOffset === 'string') throw new TypeError('The "string" argument must be of type string. Received type number');
        return $524ab3360ae8bc25$var$allocUnsafe(arg);
    }
    return $524ab3360ae8bc25$var$from(arg, encodingOrOffset, length);
}
$524ab3360ae8bc25$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $524ab3360ae8bc25$var$from(value, encodingOrOffset, length) {
    if (typeof value === 'string') return $524ab3360ae8bc25$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $524ab3360ae8bc25$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($524ab3360ae8bc25$var$isInstance(value, ArrayBuffer) || value && $524ab3360ae8bc25$var$isInstance(value.buffer, ArrayBuffer)) return $524ab3360ae8bc25$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== 'undefined' && ($524ab3360ae8bc25$var$isInstance(value, SharedArrayBuffer) || value && $524ab3360ae8bc25$var$isInstance(value.buffer, SharedArrayBuffer))) return $524ab3360ae8bc25$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === 'number') throw new TypeError('The "value" argument must not be of type number. Received type number');
    const valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $524ab3360ae8bc25$var$Buffer.from(valueOf, encodingOrOffset, length);
    const b = $524ab3360ae8bc25$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === 'function') return $524ab3360ae8bc25$var$Buffer.from(value[Symbol.toPrimitive]('string'), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $524ab3360ae8bc25$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $524ab3360ae8bc25$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($524ab3360ae8bc25$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($524ab3360ae8bc25$var$Buffer, Uint8Array);
function $524ab3360ae8bc25$var$assertSize(size) {
    if (typeof size !== 'number') throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $524ab3360ae8bc25$var$alloc(size, fill, encoding) {
    $524ab3360ae8bc25$var$assertSize(size);
    if (size <= 0) return $524ab3360ae8bc25$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === 'string' ? $524ab3360ae8bc25$var$createBuffer(size).fill(fill, encoding) : $524ab3360ae8bc25$var$createBuffer(size).fill(fill);
    return $524ab3360ae8bc25$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $524ab3360ae8bc25$var$Buffer.alloc = function(size, fill, encoding) {
    return $524ab3360ae8bc25$var$alloc(size, fill, encoding);
};
function $524ab3360ae8bc25$var$allocUnsafe(size) {
    $524ab3360ae8bc25$var$assertSize(size);
    return $524ab3360ae8bc25$var$createBuffer(size < 0 ? 0 : $524ab3360ae8bc25$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $524ab3360ae8bc25$var$Buffer.allocUnsafe = function(size) {
    return $524ab3360ae8bc25$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $524ab3360ae8bc25$var$Buffer.allocUnsafeSlow = function(size) {
    return $524ab3360ae8bc25$var$allocUnsafe(size);
};
function $524ab3360ae8bc25$var$fromString(string, encoding) {
    if (typeof encoding !== 'string' || encoding === '') encoding = 'utf8';
    if (!$524ab3360ae8bc25$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
    const length = $524ab3360ae8bc25$var$byteLength(string, encoding) | 0;
    let buf = $524ab3360ae8bc25$var$createBuffer(length);
    const actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $524ab3360ae8bc25$var$fromArrayLike(array) {
    const length = array.length < 0 ? 0 : $524ab3360ae8bc25$var$checked(array.length) | 0;
    const buf = $524ab3360ae8bc25$var$createBuffer(length);
    for(let i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $524ab3360ae8bc25$var$fromArrayView(arrayView) {
    if ($524ab3360ae8bc25$var$isInstance(arrayView, Uint8Array)) {
        const copy = new Uint8Array(arrayView);
        return $524ab3360ae8bc25$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $524ab3360ae8bc25$var$fromArrayLike(arrayView);
}
function $524ab3360ae8bc25$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    let buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $524ab3360ae8bc25$var$Buffer.prototype);
    return buf;
}
function $524ab3360ae8bc25$var$fromObject(obj) {
    if ($524ab3360ae8bc25$var$Buffer.isBuffer(obj)) {
        const len = $524ab3360ae8bc25$var$checked(obj.length) | 0;
        const buf = $524ab3360ae8bc25$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== 'number' || $524ab3360ae8bc25$var$numberIsNaN(obj.length)) return $524ab3360ae8bc25$var$createBuffer(0);
        return $524ab3360ae8bc25$var$fromArrayLike(obj);
    }
    if (obj.type === 'Buffer' && Array.isArray(obj.data)) return $524ab3360ae8bc25$var$fromArrayLike(obj.data);
}
function $524ab3360ae8bc25$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $524ab3360ae8bc25$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $524ab3360ae8bc25$var$K_MAX_LENGTH.toString(16) + ' bytes');
    return length | 0;
}
function $524ab3360ae8bc25$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $524ab3360ae8bc25$var$Buffer.alloc(+length);
}
$524ab3360ae8bc25$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $524ab3360ae8bc25$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$524ab3360ae8bc25$var$Buffer.compare = function compare(a, b) {
    if ($524ab3360ae8bc25$var$isInstance(a, Uint8Array)) a = $524ab3360ae8bc25$var$Buffer.from(a, a.offset, a.byteLength);
    if ($524ab3360ae8bc25$var$isInstance(b, Uint8Array)) b = $524ab3360ae8bc25$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$524ab3360ae8bc25$var$Buffer.isBuffer(a) || !$524ab3360ae8bc25$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    let x = a.length;
    let y = b.length;
    for(let i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$524ab3360ae8bc25$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'latin1':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return true;
        default:
            return false;
    }
};
$524ab3360ae8bc25$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $524ab3360ae8bc25$var$Buffer.alloc(0);
    let i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    const buffer = $524ab3360ae8bc25$var$Buffer.allocUnsafe(length);
    let pos = 0;
    for(i = 0; i < list.length; ++i){
        let buf = list[i];
        if ($524ab3360ae8bc25$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!$524ab3360ae8bc25$var$Buffer.isBuffer(buf)) buf = $524ab3360ae8bc25$var$Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$524ab3360ae8bc25$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $524ab3360ae8bc25$var$byteLength(string, encoding) {
    if ($524ab3360ae8bc25$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $524ab3360ae8bc25$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== 'string') throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    const len = string.length;
    const mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'ascii':
        case 'latin1':
        case 'binary':
            return len;
        case 'utf8':
        case 'utf-8':
            return $524ab3360ae8bc25$var$utf8ToBytes(string).length;
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return len * 2;
        case 'hex':
            return len >>> 1;
        case 'base64':
            return $524ab3360ae8bc25$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $524ab3360ae8bc25$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
}
$524ab3360ae8bc25$var$Buffer.byteLength = $524ab3360ae8bc25$var$byteLength;
function $524ab3360ae8bc25$var$slowToString(encoding, start, end) {
    let loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return '';
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return '';
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return '';
    if (!encoding) encoding = 'utf8';
    while(true)switch(encoding){
        case 'hex':
            return $524ab3360ae8bc25$var$hexSlice(this, start, end);
        case 'utf8':
        case 'utf-8':
            return $524ab3360ae8bc25$var$utf8Slice(this, start, end);
        case 'ascii':
            return $524ab3360ae8bc25$var$asciiSlice(this, start, end);
        case 'latin1':
        case 'binary':
            return $524ab3360ae8bc25$var$latin1Slice(this, start, end);
        case 'base64':
            return $524ab3360ae8bc25$var$base64Slice(this, start, end);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $524ab3360ae8bc25$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = (encoding + '').toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$524ab3360ae8bc25$var$Buffer.prototype._isBuffer = true;
function $524ab3360ae8bc25$var$swap(b, n, m) {
    const i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$524ab3360ae8bc25$var$Buffer.prototype.swap16 = function swap16() {
    const len = this.length;
    if (len % 2 !== 0) throw new RangeError('Buffer size must be a multiple of 16-bits');
    for(let i = 0; i < len; i += 2)$524ab3360ae8bc25$var$swap(this, i, i + 1);
    return this;
};
$524ab3360ae8bc25$var$Buffer.prototype.swap32 = function swap32() {
    const len = this.length;
    if (len % 4 !== 0) throw new RangeError('Buffer size must be a multiple of 32-bits');
    for(let i = 0; i < len; i += 4){
        $524ab3360ae8bc25$var$swap(this, i, i + 3);
        $524ab3360ae8bc25$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$524ab3360ae8bc25$var$Buffer.prototype.swap64 = function swap64() {
    const len = this.length;
    if (len % 8 !== 0) throw new RangeError('Buffer size must be a multiple of 64-bits');
    for(let i = 0; i < len; i += 8){
        $524ab3360ae8bc25$var$swap(this, i, i + 7);
        $524ab3360ae8bc25$var$swap(this, i + 1, i + 6);
        $524ab3360ae8bc25$var$swap(this, i + 2, i + 5);
        $524ab3360ae8bc25$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$524ab3360ae8bc25$var$Buffer.prototype.toString = function toString() {
    const length = this.length;
    if (length === 0) return '';
    if (arguments.length === 0) return $524ab3360ae8bc25$var$utf8Slice(this, 0, length);
    return $524ab3360ae8bc25$var$slowToString.apply(this, arguments);
};
$524ab3360ae8bc25$var$Buffer.prototype.toLocaleString = $524ab3360ae8bc25$var$Buffer.prototype.toString;
$524ab3360ae8bc25$var$Buffer.prototype.equals = function equals(b) {
    if (!$524ab3360ae8bc25$var$Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer');
    if (this === b) return true;
    return $524ab3360ae8bc25$var$Buffer.compare(this, b) === 0;
};
$524ab3360ae8bc25$var$Buffer.prototype.inspect = function inspect() {
    let str = '';
    const max = $524ab3360ae8bc25$export$f99ded8fe4b79145;
    str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim();
    if (this.length > max) str += ' ... ';
    return '<Buffer ' + str + '>';
};
if ($524ab3360ae8bc25$var$customInspectSymbol) $524ab3360ae8bc25$var$Buffer.prototype[$524ab3360ae8bc25$var$customInspectSymbol] = $524ab3360ae8bc25$var$Buffer.prototype.inspect;
$524ab3360ae8bc25$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($524ab3360ae8bc25$var$isInstance(target, Uint8Array)) target = $524ab3360ae8bc25$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$524ab3360ae8bc25$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError('out of range index');
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    let x = thisEnd - thisStart;
    let y = end - start;
    const len = Math.min(x, y);
    const thisCopy = this.slice(thisStart, thisEnd);
    const targetCopy = target.slice(start, end);
    for(let i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $524ab3360ae8bc25$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === 'string') {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($524ab3360ae8bc25$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === 'string') val = $524ab3360ae8bc25$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($524ab3360ae8bc25$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $524ab3360ae8bc25$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === 'number') {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === 'function') {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $524ab3360ae8bc25$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError('val must be string, number or Buffer');
}
function $524ab3360ae8bc25$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    let indexSize = 1;
    let arrLength = arr.length;
    let valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === 'ucs2' || encoding === 'ucs-2' || encoding === 'utf16le' || encoding === 'utf-16le') {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    let i;
    if (dir) {
        let foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            let found = true;
            for(let j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$524ab3360ae8bc25$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$524ab3360ae8bc25$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $524ab3360ae8bc25$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$524ab3360ae8bc25$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $524ab3360ae8bc25$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $524ab3360ae8bc25$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    const remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    const strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    let i;
    for(i = 0; i < length; ++i){
        const parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($524ab3360ae8bc25$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $524ab3360ae8bc25$var$utf8Write(buf, string, offset, length) {
    return $524ab3360ae8bc25$var$blitBuffer($524ab3360ae8bc25$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $524ab3360ae8bc25$var$asciiWrite(buf, string, offset, length) {
    return $524ab3360ae8bc25$var$blitBuffer($524ab3360ae8bc25$var$asciiToBytes(string), buf, offset, length);
}
function $524ab3360ae8bc25$var$base64Write(buf, string, offset, length) {
    return $524ab3360ae8bc25$var$blitBuffer($524ab3360ae8bc25$var$base64ToBytes(string), buf, offset, length);
}
function $524ab3360ae8bc25$var$ucs2Write(buf, string, offset, length) {
    return $524ab3360ae8bc25$var$blitBuffer($524ab3360ae8bc25$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$524ab3360ae8bc25$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = 'utf8';
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === 'string') {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = 'utf8';
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error('Buffer.write(string, encoding, offset[, length]) is no longer supported');
    const remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError('Attempt to write outside buffer bounds');
    if (!encoding) encoding = 'utf8';
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'hex':
            return $524ab3360ae8bc25$var$hexWrite(this, string, offset, length);
        case 'utf8':
        case 'utf-8':
            return $524ab3360ae8bc25$var$utf8Write(this, string, offset, length);
        case 'ascii':
        case 'latin1':
        case 'binary':
            return $524ab3360ae8bc25$var$asciiWrite(this, string, offset, length);
        case 'base64':
            // Warning: maxLength not taken into account in base64Write
            return $524ab3360ae8bc25$var$base64Write(this, string, offset, length);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $524ab3360ae8bc25$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
};
$524ab3360ae8bc25$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: 'Buffer',
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $524ab3360ae8bc25$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $78fa89e0eb190ae0$export$6100ba28696e12de(buf);
    else return $78fa89e0eb190ae0$export$6100ba28696e12de(buf.slice(start, end));
}
function $524ab3360ae8bc25$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    const res = [];
    let i = start;
    while(i < end){
        const firstByte = buf[i];
        let codePoint = null;
        let bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            let secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $524ab3360ae8bc25$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
const $524ab3360ae8bc25$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $524ab3360ae8bc25$var$decodeCodePointsArray(codePoints) {
    const len = codePoints.length;
    if (len <= $524ab3360ae8bc25$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    let res = '';
    let i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $524ab3360ae8bc25$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $524ab3360ae8bc25$var$asciiSlice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $524ab3360ae8bc25$var$latin1Slice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $524ab3360ae8bc25$var$hexSlice(buf, start, end) {
    const len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    let out = '';
    for(let i = start; i < end; ++i)out += $524ab3360ae8bc25$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $524ab3360ae8bc25$var$utf16leSlice(buf, start, end) {
    const bytes = buf.slice(start, end);
    let res = '';
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(let i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$524ab3360ae8bc25$var$Buffer.prototype.slice = function slice(start, end) {
    const len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    const newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $524ab3360ae8bc25$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $524ab3360ae8bc25$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError('offset is not uint');
    if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length');
}
$524ab3360ae8bc25$var$Buffer.prototype.readUintLE = $524ab3360ae8bc25$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $524ab3360ae8bc25$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$524ab3360ae8bc25$var$Buffer.prototype.readUintBE = $524ab3360ae8bc25$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $524ab3360ae8bc25$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset + --byteLength];
    let mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$524ab3360ae8bc25$var$Buffer.prototype.readUint8 = $524ab3360ae8bc25$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $524ab3360ae8bc25$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$524ab3360ae8bc25$var$Buffer.prototype.readUint16LE = $524ab3360ae8bc25$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $524ab3360ae8bc25$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$524ab3360ae8bc25$var$Buffer.prototype.readUint16BE = $524ab3360ae8bc25$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $524ab3360ae8bc25$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$524ab3360ae8bc25$var$Buffer.prototype.readUint32LE = $524ab3360ae8bc25$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $524ab3360ae8bc25$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$524ab3360ae8bc25$var$Buffer.prototype.readUint32BE = $524ab3360ae8bc25$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $524ab3360ae8bc25$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$524ab3360ae8bc25$var$Buffer.prototype.readBigUInt64LE = $524ab3360ae8bc25$var$defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    $524ab3360ae8bc25$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $524ab3360ae8bc25$var$boundsError(offset, this.length - 8);
    const lo = first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24;
    const hi = this[++offset] + this[++offset] * 256 + this[++offset] * 2 ** 16 + last * 2 ** 24;
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
$524ab3360ae8bc25$var$Buffer.prototype.readBigUInt64BE = $524ab3360ae8bc25$var$defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    $524ab3360ae8bc25$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $524ab3360ae8bc25$var$boundsError(offset, this.length - 8);
    const hi = first * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    const lo = this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
$524ab3360ae8bc25$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $524ab3360ae8bc25$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$524ab3360ae8bc25$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $524ab3360ae8bc25$var$checkOffset(offset, byteLength, this.length);
    let i = byteLength;
    let mul = 1;
    let val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$524ab3360ae8bc25$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $524ab3360ae8bc25$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$524ab3360ae8bc25$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $524ab3360ae8bc25$var$checkOffset(offset, 2, this.length);
    const val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$524ab3360ae8bc25$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $524ab3360ae8bc25$var$checkOffset(offset, 2, this.length);
    const val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$524ab3360ae8bc25$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $524ab3360ae8bc25$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$524ab3360ae8bc25$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $524ab3360ae8bc25$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$524ab3360ae8bc25$var$Buffer.prototype.readBigInt64LE = $524ab3360ae8bc25$var$defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    $524ab3360ae8bc25$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $524ab3360ae8bc25$var$boundsError(offset, this.length - 8);
    const val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * 2 ** 16 + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24);
});
$524ab3360ae8bc25$var$Buffer.prototype.readBigInt64BE = $524ab3360ae8bc25$var$defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    $524ab3360ae8bc25$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $524ab3360ae8bc25$var$boundsError(offset, this.length - 8);
    const val = (first << 24) + // Overflow
    this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last);
});
$524ab3360ae8bc25$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $524ab3360ae8bc25$var$checkOffset(offset, 4, this.length);
    return $ebbbfcdbce5bf42e$export$aafa59e2e03f2942(this, offset, true, 23, 4);
};
$524ab3360ae8bc25$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $524ab3360ae8bc25$var$checkOffset(offset, 4, this.length);
    return $ebbbfcdbce5bf42e$export$aafa59e2e03f2942(this, offset, false, 23, 4);
};
$524ab3360ae8bc25$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $524ab3360ae8bc25$var$checkOffset(offset, 8, this.length);
    return $ebbbfcdbce5bf42e$export$aafa59e2e03f2942(this, offset, true, 52, 8);
};
$524ab3360ae8bc25$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $524ab3360ae8bc25$var$checkOffset(offset, 8, this.length);
    return $ebbbfcdbce5bf42e$export$aafa59e2e03f2942(this, offset, false, 52, 8);
};
function $524ab3360ae8bc25$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$524ab3360ae8bc25$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
}
$524ab3360ae8bc25$var$Buffer.prototype.writeUintLE = $524ab3360ae8bc25$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $524ab3360ae8bc25$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let mul = 1;
    let i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$524ab3360ae8bc25$var$Buffer.prototype.writeUintBE = $524ab3360ae8bc25$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $524ab3360ae8bc25$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let i = byteLength - 1;
    let mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$524ab3360ae8bc25$var$Buffer.prototype.writeUint8 = $524ab3360ae8bc25$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $524ab3360ae8bc25$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$524ab3360ae8bc25$var$Buffer.prototype.writeUint16LE = $524ab3360ae8bc25$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $524ab3360ae8bc25$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$524ab3360ae8bc25$var$Buffer.prototype.writeUint16BE = $524ab3360ae8bc25$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $524ab3360ae8bc25$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$524ab3360ae8bc25$var$Buffer.prototype.writeUint32LE = $524ab3360ae8bc25$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $524ab3360ae8bc25$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$524ab3360ae8bc25$var$Buffer.prototype.writeUint32BE = $524ab3360ae8bc25$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $524ab3360ae8bc25$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $524ab3360ae8bc25$var$wrtBigUInt64LE(buf, value, offset, min, max) {
    $524ab3360ae8bc25$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function $524ab3360ae8bc25$var$wrtBigUInt64BE(buf, value, offset, min, max) {
    $524ab3360ae8bc25$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
$524ab3360ae8bc25$var$Buffer.prototype.writeBigUInt64LE = $524ab3360ae8bc25$var$defineBigIntMethod(function writeBigUInt64LE(value, offset = 0) {
    return $524ab3360ae8bc25$var$wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$524ab3360ae8bc25$var$Buffer.prototype.writeBigUInt64BE = $524ab3360ae8bc25$var$defineBigIntMethod(function writeBigUInt64BE(value, offset = 0) {
    return $524ab3360ae8bc25$var$wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$524ab3360ae8bc25$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $524ab3360ae8bc25$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = 0;
    let mul = 1;
    let sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$524ab3360ae8bc25$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $524ab3360ae8bc25$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = byteLength - 1;
    let mul = 1;
    let sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$524ab3360ae8bc25$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $524ab3360ae8bc25$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$524ab3360ae8bc25$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $524ab3360ae8bc25$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$524ab3360ae8bc25$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $524ab3360ae8bc25$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$524ab3360ae8bc25$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $524ab3360ae8bc25$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$524ab3360ae8bc25$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $524ab3360ae8bc25$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$524ab3360ae8bc25$var$Buffer.prototype.writeBigInt64LE = $524ab3360ae8bc25$var$defineBigIntMethod(function writeBigInt64LE(value, offset = 0) {
    return $524ab3360ae8bc25$var$wrtBigUInt64LE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
$524ab3360ae8bc25$var$Buffer.prototype.writeBigInt64BE = $524ab3360ae8bc25$var$defineBigIntMethod(function writeBigInt64BE(value, offset = 0) {
    return $524ab3360ae8bc25$var$wrtBigUInt64BE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
function $524ab3360ae8bc25$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
    if (offset < 0) throw new RangeError('Index out of range');
}
function $524ab3360ae8bc25$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $524ab3360ae8bc25$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $ebbbfcdbce5bf42e$export$68d8715fc104d294(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$524ab3360ae8bc25$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $524ab3360ae8bc25$var$writeFloat(this, value, offset, true, noAssert);
};
$524ab3360ae8bc25$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $524ab3360ae8bc25$var$writeFloat(this, value, offset, false, noAssert);
};
function $524ab3360ae8bc25$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $524ab3360ae8bc25$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $ebbbfcdbce5bf42e$export$68d8715fc104d294(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$524ab3360ae8bc25$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $524ab3360ae8bc25$var$writeDouble(this, value, offset, true, noAssert);
};
$524ab3360ae8bc25$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $524ab3360ae8bc25$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$524ab3360ae8bc25$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$524ab3360ae8bc25$var$Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer');
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError('targetStart out of bounds');
    if (start < 0 || start >= this.length) throw new RangeError('Index out of range');
    if (end < 0) throw new RangeError('sourceEnd out of bounds');
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    const len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$524ab3360ae8bc25$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === 'string') {
        if (typeof start === 'string') {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === 'string') {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== 'string') throw new TypeError('encoding must be a string');
        if (typeof encoding === 'string' && !$524ab3360ae8bc25$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
        if (val.length === 1) {
            const code = val.charCodeAt(0);
            if (encoding === 'utf8' && code < 128 || encoding === 'latin1') // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === 'number') val = val & 255;
    else if (typeof val === 'boolean') val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError('Out of range index');
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    let i;
    if (typeof val === 'number') for(i = start; i < end; ++i)this[i] = val;
    else {
        const bytes = $524ab3360ae8bc25$var$Buffer.isBuffer(val) ? val : $524ab3360ae8bc25$var$Buffer.from(val, encoding);
        const len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
const $524ab3360ae8bc25$var$errors = {};
function $524ab3360ae8bc25$var$E(sym, getMessage, Base) {
    $524ab3360ae8bc25$var$errors[sym] = class NodeError extends Base {
        get code() {
            return sym;
        }
        set code(value) {
            Object.defineProperty(this, 'code', {
                configurable: true,
                enumerable: true,
                value: value,
                writable: true
            });
        }
        toString() {
            return `${this.name} [${sym}]: ${this.message}`;
        }
        constructor(){
            super();
            Object.defineProperty(this, 'message', {
                value: getMessage.apply(this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            this.name = `${this.name} [${sym}]`;
            // Access the stack to generate the error message including the error code
            // from the name.
            this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete this.name;
        }
    };
}
$524ab3360ae8bc25$var$E('ERR_BUFFER_OUT_OF_BOUNDS', function(name) {
    if (name) return `${name} is outside of buffer bounds`;
    return 'Attempt to access memory outside buffer bounds';
}, RangeError);
$524ab3360ae8bc25$var$E('ERR_INVALID_ARG_TYPE', function(name, actual) {
    return `The "${name}" argument must be of type number. Received type ${typeof actual}`;
}, TypeError);
$524ab3360ae8bc25$var$E('ERR_OUT_OF_RANGE', function(str, range, input) {
    let msg = `The value of "${str}" is out of range.`;
    let received = input;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = $524ab3360ae8bc25$var$addNumericalSeparator(String(input));
    else if (typeof input === 'bigint') {
        received = String(input);
        if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) received = $524ab3360ae8bc25$var$addNumericalSeparator(received);
        received += 'n';
    }
    msg += ` It must be ${range}. Received ${received}`;
    return msg;
}, RangeError);
function $524ab3360ae8bc25$var$addNumericalSeparator(val) {
    let res = '';
    let i = val.length;
    const start = val[0] === '-' ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
    return `${val.slice(0, i)}${res}`;
}
// CHECK FUNCTIONS
// ===============
function $524ab3360ae8bc25$var$checkBounds(buf, offset, byteLength) {
    $524ab3360ae8bc25$var$validateNumber(offset, 'offset');
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) $524ab3360ae8bc25$var$boundsError(offset, buf.length - (byteLength + 1));
}
function $524ab3360ae8bc25$var$checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        const n = typeof min === 'bigint' ? 'n' : '';
        let range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = `>= 0${n} and < 2${n} ** ${(byteLength + 1) * 8}${n}`;
            else range = `>= -(2${n} ** ${(byteLength + 1) * 8 - 1}${n}) and < 2 ** ` + `${(byteLength + 1) * 8 - 1}${n}`;
        } else range = `>= ${min}${n} and <= ${max}${n}`;
        throw new $524ab3360ae8bc25$var$errors.ERR_OUT_OF_RANGE('value', range, value);
    }
    $524ab3360ae8bc25$var$checkBounds(buf, offset, byteLength);
}
function $524ab3360ae8bc25$var$validateNumber(value, name) {
    if (typeof value !== 'number') throw new $524ab3360ae8bc25$var$errors.ERR_INVALID_ARG_TYPE(name, 'number', value);
}
function $524ab3360ae8bc25$var$boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        $524ab3360ae8bc25$var$validateNumber(value, type);
        throw new $524ab3360ae8bc25$var$errors.ERR_OUT_OF_RANGE(type || 'offset', 'an integer', value);
    }
    if (length < 0) throw new $524ab3360ae8bc25$var$errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new $524ab3360ae8bc25$var$errors.ERR_OUT_OF_RANGE(type || 'offset', `>= ${type ? 1 : 0} and <= ${length}`, value);
}
// HELPER FUNCTIONS
// ================
const $524ab3360ae8bc25$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $524ab3360ae8bc25$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split('=')[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($524ab3360ae8bc25$var$INVALID_BASE64_RE, '');
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return '';
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + '=';
    return str;
}
function $524ab3360ae8bc25$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    let codePoint;
    const length = string.length;
    let leadSurrogate = null;
    const bytes = [];
    for(let i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error('Invalid code point');
    }
    return bytes;
}
function $524ab3360ae8bc25$var$asciiToBytes(str) {
    const byteArray = [];
    for(let i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $524ab3360ae8bc25$var$utf16leToBytes(str, units) {
    let c, hi, lo;
    const byteArray = [];
    for(let i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $524ab3360ae8bc25$var$base64ToBytes(str) {
    return $78fa89e0eb190ae0$export$d622b2ad8d90c771($524ab3360ae8bc25$var$base64clean(str));
}
function $524ab3360ae8bc25$var$blitBuffer(src, dst, offset, length) {
    let i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $524ab3360ae8bc25$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $524ab3360ae8bc25$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
const $524ab3360ae8bc25$var$hexSliceLookupTable = function() {
    const alphabet = '0123456789abcdef';
    const table = new Array(256);
    for(let i = 0; i < 16; ++i){
        const i16 = i * 16;
        for(let j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function $524ab3360ae8bc25$var$defineBigIntMethod(fn) {
    return typeof BigInt === 'undefined' ? $524ab3360ae8bc25$var$BufferBigIntNotDefined : fn;
}
function $524ab3360ae8bc25$var$BufferBigIntNotDefined() {
    throw new Error('BigInt not supported');
}


var $40cfbfe1395c20c9$require$Buffer = $524ab3360ae8bc25$export$a143d493d941bafc;
var $40cfbfe1395c20c9$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const $40cfbfe1395c20c9$var$DEFAULT_SEARCH_OPTIONS = {
    limit: 100,
    offset: 0,
    sortBy: {
        column: 'name',
        order: 'asc'
    }
};
const $40cfbfe1395c20c9$var$DEFAULT_FILE_OPTIONS = {
    cacheControl: '3600',
    contentType: 'text/plain;charset=UTF-8',
    upsert: false
};
class $40cfbfe1395c20c9$export$2e2bcd8739ae039 {
    /**
     * Uploads a file to an existing bucket or replaces an existing file at the specified path with a new one.
     *
     * @param method HTTP method.
     * @param path The relative file path. Should be of the format `folder/subfolder/filename.png`. The bucket must already exist before attempting to upload.
     * @param fileBody The body of the file to be stored in the bucket.
     */ uploadOrUpdate(method, path, fileBody, fileOptions) {
        return $40cfbfe1395c20c9$var$__awaiter(this, void 0, void 0, function*() {
            try {
                let body;
                const options = Object.assign(Object.assign({}, $40cfbfe1395c20c9$var$DEFAULT_FILE_OPTIONS), fileOptions);
                let headers = Object.assign(Object.assign({}, this.headers), method === 'POST' && {
                    'x-upsert': String(options.upsert)
                });
                const metadata = options.metadata;
                if (typeof Blob !== 'undefined' && fileBody instanceof Blob) {
                    body = new FormData();
                    body.append('cacheControl', options.cacheControl);
                    if (metadata) body.append('metadata', this.encodeMetadata(metadata));
                    body.append('', fileBody);
                } else if (typeof FormData !== 'undefined' && fileBody instanceof FormData) {
                    body = fileBody;
                    body.append('cacheControl', options.cacheControl);
                    if (metadata) body.append('metadata', this.encodeMetadata(metadata));
                } else {
                    body = fileBody;
                    headers['cache-control'] = `max-age=${options.cacheControl}`;
                    headers['content-type'] = options.contentType;
                    if (metadata) headers['x-metadata'] = this.toBase64(this.encodeMetadata(metadata));
                }
                if (fileOptions === null || fileOptions === void 0 ? void 0 : fileOptions.headers) headers = Object.assign(Object.assign({}, headers), fileOptions.headers);
                const cleanPath = this._removeEmptyFolders(path);
                const _path = this._getFinalPath(cleanPath);
                const res = yield this.fetch(`${this.url}/object/${_path}`, Object.assign({
                    method: method,
                    body: body,
                    headers: headers
                }, (options === null || options === void 0 ? void 0 : options.duplex) ? {
                    duplex: options.duplex
                } : {}));
                const data = yield res.json();
                if (res.ok) return {
                    data: {
                        path: cleanPath,
                        id: data.Id,
                        fullPath: data.Key
                    },
                    error: null
                };
                else {
                    const error = data;
                    return {
                        data: null,
                        error: error
                    };
                }
            } catch (error) {
                if ((0, $51c78ec6155f1b91$export$5a322e77e5eb0561)(error)) return {
                    data: null,
                    error: error
                };
                throw error;
            }
        });
    }
    /**
     * Uploads a file to an existing bucket.
     *
     * @param path The file path, including the file name. Should be of the format `folder/subfolder/filename.png`. The bucket must already exist before attempting to upload.
     * @param fileBody The body of the file to be stored in the bucket.
     */ upload(path, fileBody, fileOptions) {
        return $40cfbfe1395c20c9$var$__awaiter(this, void 0, void 0, function*() {
            return this.uploadOrUpdate('POST', path, fileBody, fileOptions);
        });
    }
    /**
     * Upload a file with a token generated from `createSignedUploadUrl`.
     * @param path The file path, including the file name. Should be of the format `folder/subfolder/filename.png`. The bucket must already exist before attempting to upload.
     * @param token The token generated from `createSignedUploadUrl`
     * @param fileBody The body of the file to be stored in the bucket.
     */ uploadToSignedUrl(path, token, fileBody, fileOptions) {
        return $40cfbfe1395c20c9$var$__awaiter(this, void 0, void 0, function*() {
            const cleanPath = this._removeEmptyFolders(path);
            const _path = this._getFinalPath(cleanPath);
            const url = new URL(this.url + `/object/upload/sign/${_path}`);
            url.searchParams.set('token', token);
            try {
                let body;
                const options = Object.assign({
                    upsert: $40cfbfe1395c20c9$var$DEFAULT_FILE_OPTIONS.upsert
                }, fileOptions);
                const headers = Object.assign(Object.assign({}, this.headers), {
                    'x-upsert': String(options.upsert)
                });
                if (typeof Blob !== 'undefined' && fileBody instanceof Blob) {
                    body = new FormData();
                    body.append('cacheControl', options.cacheControl);
                    body.append('', fileBody);
                } else if (typeof FormData !== 'undefined' && fileBody instanceof FormData) {
                    body = fileBody;
                    body.append('cacheControl', options.cacheControl);
                } else {
                    body = fileBody;
                    headers['cache-control'] = `max-age=${options.cacheControl}`;
                    headers['content-type'] = options.contentType;
                }
                const res = yield this.fetch(url.toString(), {
                    method: 'PUT',
                    body: body,
                    headers: headers
                });
                const data = yield res.json();
                if (res.ok) return {
                    data: {
                        path: cleanPath,
                        fullPath: data.Key
                    },
                    error: null
                };
                else {
                    const error = data;
                    return {
                        data: null,
                        error: error
                    };
                }
            } catch (error) {
                if ((0, $51c78ec6155f1b91$export$5a322e77e5eb0561)(error)) return {
                    data: null,
                    error: error
                };
                throw error;
            }
        });
    }
    /**
     * Creates a signed upload URL.
     * Signed upload URLs can be used to upload files to the bucket without further authentication.
     * They are valid for 2 hours.
     * @param path The file path, including the current file name. For example `folder/image.png`.
     * @param options.upsert If set to true, allows the file to be overwritten if it already exists.
     */ createSignedUploadUrl(path, options) {
        return $40cfbfe1395c20c9$var$__awaiter(this, void 0, void 0, function*() {
            try {
                let _path = this._getFinalPath(path);
                const headers = Object.assign({}, this.headers);
                if (options === null || options === void 0 ? void 0 : options.upsert) headers['x-upsert'] = 'true';
                const data = yield (0, $5f83d619f3d04456$export$299ba2dee77727e9)(this.fetch, `${this.url}/object/upload/sign/${_path}`, {}, {
                    headers: headers
                });
                const url = new URL(this.url + data.url);
                const token = url.searchParams.get('token');
                if (!token) throw new (0, $51c78ec6155f1b91$export$697502632950e9d3)('No token returned by API');
                return {
                    data: {
                        signedUrl: url.toString(),
                        path: path,
                        token: token
                    },
                    error: null
                };
            } catch (error) {
                if ((0, $51c78ec6155f1b91$export$5a322e77e5eb0561)(error)) return {
                    data: null,
                    error: error
                };
                throw error;
            }
        });
    }
    /**
     * Replaces an existing file at the specified path with a new one.
     *
     * @param path The relative file path. Should be of the format `folder/subfolder/filename.png`. The bucket must already exist before attempting to update.
     * @param fileBody The body of the file to be stored in the bucket.
     */ update(path, fileBody, fileOptions) {
        return $40cfbfe1395c20c9$var$__awaiter(this, void 0, void 0, function*() {
            return this.uploadOrUpdate('PUT', path, fileBody, fileOptions);
        });
    }
    /**
     * Moves an existing file to a new path in the same bucket.
     *
     * @param fromPath The original file path, including the current file name. For example `folder/image.png`.
     * @param toPath The new file path, including the new file name. For example `folder/image-new.png`.
     * @param options The destination options.
     */ move(fromPath, toPath, options) {
        return $40cfbfe1395c20c9$var$__awaiter(this, void 0, void 0, function*() {
            try {
                const data = yield (0, $5f83d619f3d04456$export$299ba2dee77727e9)(this.fetch, `${this.url}/object/move`, {
                    bucketId: this.bucketId,
                    sourceKey: fromPath,
                    destinationKey: toPath,
                    destinationBucket: options === null || options === void 0 ? void 0 : options.destinationBucket
                }, {
                    headers: this.headers
                });
                return {
                    data: data,
                    error: null
                };
            } catch (error) {
                if ((0, $51c78ec6155f1b91$export$5a322e77e5eb0561)(error)) return {
                    data: null,
                    error: error
                };
                throw error;
            }
        });
    }
    /**
     * Copies an existing file to a new path in the same bucket.
     *
     * @param fromPath The original file path, including the current file name. For example `folder/image.png`.
     * @param toPath The new file path, including the new file name. For example `folder/image-copy.png`.
     * @param options The destination options.
     */ copy(fromPath, toPath, options) {
        return $40cfbfe1395c20c9$var$__awaiter(this, void 0, void 0, function*() {
            try {
                const data = yield (0, $5f83d619f3d04456$export$299ba2dee77727e9)(this.fetch, `${this.url}/object/copy`, {
                    bucketId: this.bucketId,
                    sourceKey: fromPath,
                    destinationKey: toPath,
                    destinationBucket: options === null || options === void 0 ? void 0 : options.destinationBucket
                }, {
                    headers: this.headers
                });
                return {
                    data: {
                        path: data.Key
                    },
                    error: null
                };
            } catch (error) {
                if ((0, $51c78ec6155f1b91$export$5a322e77e5eb0561)(error)) return {
                    data: null,
                    error: error
                };
                throw error;
            }
        });
    }
    /**
     * Creates a signed URL. Use a signed URL to share a file for a fixed amount of time.
     *
     * @param path The file path, including the current file name. For example `folder/image.png`.
     * @param expiresIn The number of seconds until the signed URL expires. For example, `60` for a URL which is valid for one minute.
     * @param options.download triggers the file as a download if set to true. Set this parameter as the name of the file if you want to trigger the download with a different filename.
     * @param options.transform Transform the asset before serving it to the client.
     */ createSignedUrl(path, expiresIn, options) {
        return $40cfbfe1395c20c9$var$__awaiter(this, void 0, void 0, function*() {
            try {
                let _path = this._getFinalPath(path);
                let data = yield (0, $5f83d619f3d04456$export$299ba2dee77727e9)(this.fetch, `${this.url}/object/sign/${_path}`, Object.assign({
                    expiresIn: expiresIn
                }, (options === null || options === void 0 ? void 0 : options.transform) ? {
                    transform: options.transform
                } : {}), {
                    headers: this.headers
                });
                const downloadQueryParam = (options === null || options === void 0 ? void 0 : options.download) ? `&download=${options.download === true ? '' : options.download}` : '';
                const signedUrl = encodeURI(`${this.url}${data.signedURL}${downloadQueryParam}`);
                data = {
                    signedUrl: signedUrl
                };
                return {
                    data: data,
                    error: null
                };
            } catch (error) {
                if ((0, $51c78ec6155f1b91$export$5a322e77e5eb0561)(error)) return {
                    data: null,
                    error: error
                };
                throw error;
            }
        });
    }
    /**
     * Creates multiple signed URLs. Use a signed URL to share a file for a fixed amount of time.
     *
     * @param paths The file paths to be downloaded, including the current file names. For example `['folder/image.png', 'folder2/image2.png']`.
     * @param expiresIn The number of seconds until the signed URLs expire. For example, `60` for URLs which are valid for one minute.
     * @param options.download triggers the file as a download if set to true. Set this parameter as the name of the file if you want to trigger the download with a different filename.
     */ createSignedUrls(paths, expiresIn, options) {
        return $40cfbfe1395c20c9$var$__awaiter(this, void 0, void 0, function*() {
            try {
                const data = yield (0, $5f83d619f3d04456$export$299ba2dee77727e9)(this.fetch, `${this.url}/object/sign/${this.bucketId}`, {
                    expiresIn: expiresIn,
                    paths: paths
                }, {
                    headers: this.headers
                });
                const downloadQueryParam = (options === null || options === void 0 ? void 0 : options.download) ? `&download=${options.download === true ? '' : options.download}` : '';
                return {
                    data: data.map((datum)=>Object.assign(Object.assign({}, datum), {
                            signedUrl: datum.signedURL ? encodeURI(`${this.url}${datum.signedURL}${downloadQueryParam}`) : null
                        })),
                    error: null
                };
            } catch (error) {
                if ((0, $51c78ec6155f1b91$export$5a322e77e5eb0561)(error)) return {
                    data: null,
                    error: error
                };
                throw error;
            }
        });
    }
    /**
     * Downloads a file from a private bucket. For public buckets, make a request to the URL returned from `getPublicUrl` instead.
     *
     * @param path The full path and file name of the file to be downloaded. For example `folder/image.png`.
     * @param options.transform Transform the asset before serving it to the client.
     */ download(path, options) {
        return $40cfbfe1395c20c9$var$__awaiter(this, void 0, void 0, function*() {
            const wantsTransformation = typeof (options === null || options === void 0 ? void 0 : options.transform) !== 'undefined';
            const renderPath = wantsTransformation ? 'render/image/authenticated' : 'object';
            const transformationQuery = this.transformOptsToQueryString((options === null || options === void 0 ? void 0 : options.transform) || {});
            const queryString = transformationQuery ? `?${transformationQuery}` : '';
            try {
                const _path = this._getFinalPath(path);
                const res = yield (0, $5f83d619f3d04456$export$3988ae62b71be9a3)(this.fetch, `${this.url}/${renderPath}/${_path}${queryString}`, {
                    headers: this.headers,
                    noResolveJson: true
                });
                const data = yield res.blob();
                return {
                    data: data,
                    error: null
                };
            } catch (error) {
                if ((0, $51c78ec6155f1b91$export$5a322e77e5eb0561)(error)) return {
                    data: null,
                    error: error
                };
                throw error;
            }
        });
    }
    /**
     * Retrieves the details of an existing file.
     * @param path
     */ info(path) {
        return $40cfbfe1395c20c9$var$__awaiter(this, void 0, void 0, function*() {
            const _path = this._getFinalPath(path);
            try {
                const data = yield (0, $5f83d619f3d04456$export$3988ae62b71be9a3)(this.fetch, `${this.url}/object/info/${_path}`, {
                    headers: this.headers
                });
                return {
                    data: (0, $f1a416fa3294a9bc$export$69d519e35e6fc3d4)(data),
                    error: null
                };
            } catch (error) {
                if ((0, $51c78ec6155f1b91$export$5a322e77e5eb0561)(error)) return {
                    data: null,
                    error: error
                };
                throw error;
            }
        });
    }
    /**
     * Checks the existence of a file.
     * @param path
     */ exists(path) {
        return $40cfbfe1395c20c9$var$__awaiter(this, void 0, void 0, function*() {
            const _path = this._getFinalPath(path);
            try {
                yield (0, $5f83d619f3d04456$export$5fd5031fecdacec3)(this.fetch, `${this.url}/object/${_path}`, {
                    headers: this.headers
                });
                return {
                    data: true,
                    error: null
                };
            } catch (error) {
                if ((0, $51c78ec6155f1b91$export$5a322e77e5eb0561)(error) && error instanceof (0, $51c78ec6155f1b91$export$29127ca2e1a271d)) {
                    const originalError = error.originalError;
                    if ([
                        400,
                        404
                    ].includes(originalError === null || originalError === void 0 ? void 0 : originalError.status)) return {
                        data: false,
                        error: error
                    };
                }
                throw error;
            }
        });
    }
    /**
     * A simple convenience function to get the URL for an asset in a public bucket. If you do not want to use this function, you can construct the public URL by concatenating the bucket URL with the path to the asset.
     * This function does not verify if the bucket is public. If a public URL is created for a bucket which is not public, you will not be able to download the asset.
     *
     * @param path The path and name of the file to generate the public URL for. For example `folder/image.png`.
     * @param options.download Triggers the file as a download if set to true. Set this parameter as the name of the file if you want to trigger the download with a different filename.
     * @param options.transform Transform the asset before serving it to the client.
     */ getPublicUrl(path, options) {
        const _path = this._getFinalPath(path);
        const _queryString = [];
        const downloadQueryParam = (options === null || options === void 0 ? void 0 : options.download) ? `download=${options.download === true ? '' : options.download}` : '';
        if (downloadQueryParam !== '') _queryString.push(downloadQueryParam);
        const wantsTransformation = typeof (options === null || options === void 0 ? void 0 : options.transform) !== 'undefined';
        const renderPath = wantsTransformation ? 'render/image' : 'object';
        const transformationQuery = this.transformOptsToQueryString((options === null || options === void 0 ? void 0 : options.transform) || {});
        if (transformationQuery !== '') _queryString.push(transformationQuery);
        let queryString = _queryString.join('&');
        if (queryString !== '') queryString = `?${queryString}`;
        return {
            data: {
                publicUrl: encodeURI(`${this.url}/${renderPath}/public/${_path}${queryString}`)
            }
        };
    }
    /**
     * Deletes files within the same bucket
     *
     * @param paths An array of files to delete, including the path and file name. For example [`'folder/image.png'`].
     */ remove(paths) {
        return $40cfbfe1395c20c9$var$__awaiter(this, void 0, void 0, function*() {
            try {
                const data = yield (0, $5f83d619f3d04456$export$cd7f480d6b8286c3)(this.fetch, `${this.url}/object/${this.bucketId}`, {
                    prefixes: paths
                }, {
                    headers: this.headers
                });
                return {
                    data: data,
                    error: null
                };
            } catch (error) {
                if ((0, $51c78ec6155f1b91$export$5a322e77e5eb0561)(error)) return {
                    data: null,
                    error: error
                };
                throw error;
            }
        });
    }
    /**
     * Get file metadata
     * @param id the file id to retrieve metadata
     */ // async getMetadata(
    //   id: string
    // ): Promise<
    //   | {
    //       data: Metadata
    //       error: null
    //     }
    //   | {
    //       data: null
    //       error: StorageError
    //     }
    // > {
    //   try {
    //     const data = await get(this.fetch, `${this.url}/metadata/${id}`, { headers: this.headers })
    //     return { data, error: null }
    //   } catch (error) {
    //     if (isStorageError(error)) {
    //       return { data: null, error }
    //     }
    //     throw error
    //   }
    // }
    /**
     * Update file metadata
     * @param id the file id to update metadata
     * @param meta the new file metadata
     */ // async updateMetadata(
    //   id: string,
    //   meta: Metadata
    // ): Promise<
    //   | {
    //       data: Metadata
    //       error: null
    //     }
    //   | {
    //       data: null
    //       error: StorageError
    //     }
    // > {
    //   try {
    //     const data = await post(
    //       this.fetch,
    //       `${this.url}/metadata/${id}`,
    //       { ...meta },
    //       { headers: this.headers }
    //     )
    //     return { data, error: null }
    //   } catch (error) {
    //     if (isStorageError(error)) {
    //       return { data: null, error }
    //     }
    //     throw error
    //   }
    // }
    /**
     * Lists all the files within a bucket.
     * @param path The folder path.
     */ list(path, options, parameters) {
        return $40cfbfe1395c20c9$var$__awaiter(this, void 0, void 0, function*() {
            try {
                const body = Object.assign(Object.assign(Object.assign({}, $40cfbfe1395c20c9$var$DEFAULT_SEARCH_OPTIONS), options), {
                    prefix: path || ''
                });
                const data = yield (0, $5f83d619f3d04456$export$299ba2dee77727e9)(this.fetch, `${this.url}/object/list/${this.bucketId}`, body, {
                    headers: this.headers
                }, parameters);
                return {
                    data: data,
                    error: null
                };
            } catch (error) {
                if ((0, $51c78ec6155f1b91$export$5a322e77e5eb0561)(error)) return {
                    data: null,
                    error: error
                };
                throw error;
            }
        });
    }
    encodeMetadata(metadata) {
        return JSON.stringify(metadata);
    }
    toBase64(data) {
        if (typeof $40cfbfe1395c20c9$require$Buffer !== 'undefined') return $40cfbfe1395c20c9$require$Buffer.from(data).toString('base64');
        return btoa(data);
    }
    _getFinalPath(path) {
        return `${this.bucketId}/${path}`;
    }
    _removeEmptyFolders(path) {
        return path.replace(/^\/|\/$/g, '').replace(/\/+/g, '/');
    }
    transformOptsToQueryString(transform) {
        const params = [];
        if (transform.width) params.push(`width=${transform.width}`);
        if (transform.height) params.push(`height=${transform.height}`);
        if (transform.resize) params.push(`resize=${transform.resize}`);
        if (transform.format) params.push(`format=${transform.format}`);
        if (transform.quality) params.push(`quality=${transform.quality}`);
        return params.join('&');
    }
    constructor(url, headers = {}, bucketId, fetch){
        this.url = url;
        this.headers = headers;
        this.bucketId = bucketId;
        this.fetch = (0, $f1a416fa3294a9bc$export$98d92b1aa79f8cc7)(fetch);
    }
}


// generated by genversion
const $33d296acc14c2440$export$83d89fbfd8236492 = '2.7.1';


const $1f82243fb190c11f$export$88a84136db6a4b64 = {
    'X-Client-Info': `storage-js/${(0, $33d296acc14c2440$export$83d89fbfd8236492)}`
};





var $9229078fb800f75f$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
class $9229078fb800f75f$export$2e2bcd8739ae039 {
    /**
     * Retrieves the details of all Storage buckets within an existing project.
     */ listBuckets() {
        return $9229078fb800f75f$var$__awaiter(this, void 0, void 0, function*() {
            try {
                const data = yield (0, $5f83d619f3d04456$export$3988ae62b71be9a3)(this.fetch, `${this.url}/bucket`, {
                    headers: this.headers
                });
                return {
                    data: data,
                    error: null
                };
            } catch (error) {
                if ((0, $51c78ec6155f1b91$export$5a322e77e5eb0561)(error)) return {
                    data: null,
                    error: error
                };
                throw error;
            }
        });
    }
    /**
     * Retrieves the details of an existing Storage bucket.
     *
     * @param id The unique identifier of the bucket you would like to retrieve.
     */ getBucket(id) {
        return $9229078fb800f75f$var$__awaiter(this, void 0, void 0, function*() {
            try {
                const data = yield (0, $5f83d619f3d04456$export$3988ae62b71be9a3)(this.fetch, `${this.url}/bucket/${id}`, {
                    headers: this.headers
                });
                return {
                    data: data,
                    error: null
                };
            } catch (error) {
                if ((0, $51c78ec6155f1b91$export$5a322e77e5eb0561)(error)) return {
                    data: null,
                    error: error
                };
                throw error;
            }
        });
    }
    /**
     * Creates a new Storage bucket
     *
     * @param id A unique identifier for the bucket you are creating.
     * @param options.public The visibility of the bucket. Public buckets don't require an authorization token to download objects, but still require a valid token for all other operations. By default, buckets are private.
     * @param options.fileSizeLimit specifies the max file size in bytes that can be uploaded to this bucket.
     * The global file size limit takes precedence over this value.
     * The default value is null, which doesn't set a per bucket file size limit.
     * @param options.allowedMimeTypes specifies the allowed mime types that this bucket can accept during upload.
     * The default value is null, which allows files with all mime types to be uploaded.
     * Each mime type specified can be a wildcard, e.g. image/*, or a specific mime type, e.g. image/png.
     * @returns newly created bucket id
     */ createBucket(id, options = {
        public: false
    }) {
        return $9229078fb800f75f$var$__awaiter(this, void 0, void 0, function*() {
            try {
                const data = yield (0, $5f83d619f3d04456$export$299ba2dee77727e9)(this.fetch, `${this.url}/bucket`, {
                    id: id,
                    name: id,
                    public: options.public,
                    file_size_limit: options.fileSizeLimit,
                    allowed_mime_types: options.allowedMimeTypes
                }, {
                    headers: this.headers
                });
                return {
                    data: data,
                    error: null
                };
            } catch (error) {
                if ((0, $51c78ec6155f1b91$export$5a322e77e5eb0561)(error)) return {
                    data: null,
                    error: error
                };
                throw error;
            }
        });
    }
    /**
     * Updates a Storage bucket
     *
     * @param id A unique identifier for the bucket you are updating.
     * @param options.public The visibility of the bucket. Public buckets don't require an authorization token to download objects, but still require a valid token for all other operations.
     * @param options.fileSizeLimit specifies the max file size in bytes that can be uploaded to this bucket.
     * The global file size limit takes precedence over this value.
     * The default value is null, which doesn't set a per bucket file size limit.
     * @param options.allowedMimeTypes specifies the allowed mime types that this bucket can accept during upload.
     * The default value is null, which allows files with all mime types to be uploaded.
     * Each mime type specified can be a wildcard, e.g. image/*, or a specific mime type, e.g. image/png.
     */ updateBucket(id, options) {
        return $9229078fb800f75f$var$__awaiter(this, void 0, void 0, function*() {
            try {
                const data = yield (0, $5f83d619f3d04456$export$327f7b26ebf455db)(this.fetch, `${this.url}/bucket/${id}`, {
                    id: id,
                    name: id,
                    public: options.public,
                    file_size_limit: options.fileSizeLimit,
                    allowed_mime_types: options.allowedMimeTypes
                }, {
                    headers: this.headers
                });
                return {
                    data: data,
                    error: null
                };
            } catch (error) {
                if ((0, $51c78ec6155f1b91$export$5a322e77e5eb0561)(error)) return {
                    data: null,
                    error: error
                };
                throw error;
            }
        });
    }
    /**
     * Removes all objects inside a single bucket.
     *
     * @param id The unique identifier of the bucket you would like to empty.
     */ emptyBucket(id) {
        return $9229078fb800f75f$var$__awaiter(this, void 0, void 0, function*() {
            try {
                const data = yield (0, $5f83d619f3d04456$export$299ba2dee77727e9)(this.fetch, `${this.url}/bucket/${id}/empty`, {}, {
                    headers: this.headers
                });
                return {
                    data: data,
                    error: null
                };
            } catch (error) {
                if ((0, $51c78ec6155f1b91$export$5a322e77e5eb0561)(error)) return {
                    data: null,
                    error: error
                };
                throw error;
            }
        });
    }
    /**
     * Deletes an existing bucket. A bucket can't be deleted with existing objects inside it.
     * You must first `empty()` the bucket.
     *
     * @param id The unique identifier of the bucket you would like to delete.
     */ deleteBucket(id) {
        return $9229078fb800f75f$var$__awaiter(this, void 0, void 0, function*() {
            try {
                const data = yield (0, $5f83d619f3d04456$export$cd7f480d6b8286c3)(this.fetch, `${this.url}/bucket/${id}`, {}, {
                    headers: this.headers
                });
                return {
                    data: data,
                    error: null
                };
            } catch (error) {
                if ((0, $51c78ec6155f1b91$export$5a322e77e5eb0561)(error)) return {
                    data: null,
                    error: error
                };
                throw error;
            }
        });
    }
    constructor(url, headers = {}, fetch){
        this.url = url;
        this.headers = Object.assign(Object.assign({}, (0, $1f82243fb190c11f$export$88a84136db6a4b64)), headers);
        this.fetch = (0, $f1a416fa3294a9bc$export$98d92b1aa79f8cc7)(fetch);
    }
}


class $ae1ec3d8e6babc3e$export$6c85f5032e75eff9 extends (0, $9229078fb800f75f$export$2e2bcd8739ae039) {
    /**
     * Perform file operation in a bucket.
     *
     * @param id The bucket id to operate on.
     */ from(id) {
        return new (0, $40cfbfe1395c20c9$export$2e2bcd8739ae039)(this.url, this.headers, id, this.fetch);
    }
    constructor(url, headers = {}, fetch){
        super(url, headers, fetch);
    }
}


const $359e1f1210cc352f$export$83d89fbfd8236492 = '2.49.3';


let $629a1707574c5be4$var$JS_ENV = '';
// @ts-ignore
if (typeof Deno !== 'undefined') $629a1707574c5be4$var$JS_ENV = 'deno';
else if (typeof document !== 'undefined') $629a1707574c5be4$var$JS_ENV = 'web';
else if (typeof navigator !== 'undefined' && navigator.product === 'ReactNative') $629a1707574c5be4$var$JS_ENV = 'react-native';
else $629a1707574c5be4$var$JS_ENV = 'node';
const $629a1707574c5be4$export$88a84136db6a4b64 = {
    'X-Client-Info': `supabase-js-${$629a1707574c5be4$var$JS_ENV}/${(0, $359e1f1210cc352f$export$83d89fbfd8236492)}`
};
const $629a1707574c5be4$export$b63a5c3a2e5becd2 = {
    headers: $629a1707574c5be4$export$88a84136db6a4b64
};
const $629a1707574c5be4$export$b31378ae815bea6b = {
    schema: 'public'
};
const $629a1707574c5be4$export$af122550cc2345b3 = {
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: true,
    flowType: 'implicit'
};
const $629a1707574c5be4$export$59685507ca0a3912 = {};



var $ff1Or = parcelRequire("ff1Or");
var $39db868b9e47c5c5$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const $39db868b9e47c5c5$export$98d92b1aa79f8cc7 = (customFetch)=>{
    let _fetch;
    if (customFetch) _fetch = customFetch;
    else if (typeof fetch === 'undefined') _fetch = (0, $ff1Or.default);
    else _fetch = fetch;
    return (...args)=>_fetch(...args);
};
const $39db868b9e47c5c5$export$3d2cf54f85b7fc8a = ()=>{
    if (typeof Headers === 'undefined') return 0, $ff1Or.Headers;
    return Headers;
};
const $39db868b9e47c5c5$export$651dd5aef824521f = (supabaseKey, getAccessToken, customFetch)=>{
    const fetch1 = $39db868b9e47c5c5$export$98d92b1aa79f8cc7(customFetch);
    const HeadersConstructor = $39db868b9e47c5c5$export$3d2cf54f85b7fc8a();
    return (input, init)=>$39db868b9e47c5c5$var$__awaiter(void 0, void 0, void 0, function*() {
            var _a;
            const accessToken = (_a = yield getAccessToken()) !== null && _a !== void 0 ? _a : supabaseKey;
            let headers = new HeadersConstructor(init === null || init === void 0 ? void 0 : init.headers);
            if (!headers.has('apikey')) headers.set('apikey', supabaseKey);
            if (!headers.has('Authorization')) headers.set('Authorization', `Bearer ${accessToken}`);
            return fetch1(input, Object.assign(Object.assign({}, init), {
                headers: headers
            }));
        });
};


var $4866e60a3003b032$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
function $4866e60a3003b032$export$31b40729666a4ae0() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
        var r = Math.random() * 16 | 0, v = c == 'x' ? r : r & 0x3 | 0x8;
        return v.toString(16);
    });
}
function $4866e60a3003b032$export$d95b4586d238a081(url) {
    return url.replace(/\/$/, '');
}
const $4866e60a3003b032$export$4e09c449d6c407f7 = ()=>typeof window !== 'undefined';
function $4866e60a3003b032$export$da186dc3f8eace71(options, defaults) {
    const { db: dbOptions, auth: authOptions, realtime: realtimeOptions, global: globalOptions } = options;
    const { db: DEFAULT_DB_OPTIONS, auth: DEFAULT_AUTH_OPTIONS, realtime: DEFAULT_REALTIME_OPTIONS, global: DEFAULT_GLOBAL_OPTIONS } = defaults;
    const result = {
        db: Object.assign(Object.assign({}, DEFAULT_DB_OPTIONS), dbOptions),
        auth: Object.assign(Object.assign({}, DEFAULT_AUTH_OPTIONS), authOptions),
        realtime: Object.assign(Object.assign({}, DEFAULT_REALTIME_OPTIONS), realtimeOptions),
        global: Object.assign(Object.assign({}, DEFAULT_GLOBAL_OPTIONS), globalOptions),
        accessToken: ()=>$4866e60a3003b032$var$__awaiter(this, void 0, void 0, function*() {
                return '';
            })
    };
    if (options.accessToken) result.accessToken = options.accessToken;
    else // hack around Required<>
    delete result.accessToken;
    return result;
}


const $678a7a6add38cca5$export$83d89fbfd8236492 = '2.69.1';


const $9242f83a1032aa7a$export$a4558fee79d6c8ae = 30000;
const $9242f83a1032aa7a$export$f20a97df8f5fe223 = 3;
const $9242f83a1032aa7a$export$a36ad0026e55ac00 = $9242f83a1032aa7a$export$f20a97df8f5fe223 * $9242f83a1032aa7a$export$a4558fee79d6c8ae;
const $9242f83a1032aa7a$export$7fedf552187f0c3d = 'http://localhost:9999';
const $9242f83a1032aa7a$export$86880b4b2e1a2384 = 'supabase.auth.token';
const $9242f83a1032aa7a$export$2f9161bad044dacb = '';
const $9242f83a1032aa7a$export$88a84136db6a4b64 = {
    'X-Client-Info': `gotrue-js/${(0, $678a7a6add38cca5$export$83d89fbfd8236492)}`
};
const $9242f83a1032aa7a$export$5615c708618ee858 = {
    MAX_RETRIES: 10,
    RETRY_INTERVAL: 2
};
const $9242f83a1032aa7a$export$e4f5507f88977535 = 'X-Supabase-Api-Version';
const $9242f83a1032aa7a$export$1f9a66038489bdeb = {
    '2024-01-01': {
        timestamp: Date.parse('2024-01-01T00:00:00.0Z'),
        name: '2024-01-01'
    }
};
const $9242f83a1032aa7a$export$7a68c9e70b9d3911 = /^([a-z0-9_-]{4})*($|[a-z0-9_-]{3}$|[a-z0-9_-]{2}$)$/i;
const $9242f83a1032aa7a$export$5bd768495200f133 = 600000; // 10 minutes



class $23e204244b27914e$export$145273558d58e0ac extends Error {
    constructor(message, status, code){
        super(message);
        this.__isAuthError = true;
        this.name = 'AuthError';
        this.status = status;
        this.code = code;
    }
}
function $23e204244b27914e$export$cde1786a482f9a1c(error) {
    return typeof error === 'object' && error !== null && '__isAuthError' in error;
}
class $23e204244b27914e$export$45fde0b55b14f37b extends $23e204244b27914e$export$145273558d58e0ac {
    constructor(message, status, code){
        super(message, status, code);
        this.name = 'AuthApiError';
        this.status = status;
        this.code = code;
    }
}
function $23e204244b27914e$export$4fe744aeb810d543(error) {
    return $23e204244b27914e$export$cde1786a482f9a1c(error) && error.name === 'AuthApiError';
}
class $23e204244b27914e$export$f7559805d4a50078 extends $23e204244b27914e$export$145273558d58e0ac {
    constructor(message, originalError){
        super(message);
        this.name = 'AuthUnknownError';
        this.originalError = originalError;
    }
}
class $23e204244b27914e$export$823c745ae0673c5e extends $23e204244b27914e$export$145273558d58e0ac {
    constructor(message, name, status, code){
        super(message, status, code);
        this.name = name;
        this.status = status;
    }
}
class $23e204244b27914e$export$403b3fc0d3ad5f0c extends $23e204244b27914e$export$823c745ae0673c5e {
    constructor(){
        super('Auth session missing!', 'AuthSessionMissingError', 400, undefined);
    }
}
function $23e204244b27914e$export$3e849aa4db565c1d(error) {
    return $23e204244b27914e$export$cde1786a482f9a1c(error) && error.name === 'AuthSessionMissingError';
}
class $23e204244b27914e$export$7e277b620449c1b4 extends $23e204244b27914e$export$823c745ae0673c5e {
    constructor(){
        super('Auth session or user missing', 'AuthInvalidTokenResponseError', 500, undefined);
    }
}
class $23e204244b27914e$export$9ef583f0381b4cc extends $23e204244b27914e$export$823c745ae0673c5e {
    constructor(message){
        super(message, 'AuthInvalidCredentialsError', 400, undefined);
    }
}
class $23e204244b27914e$export$bf5df8e043856ef5 extends $23e204244b27914e$export$823c745ae0673c5e {
    toJSON() {
        return {
            name: this.name,
            message: this.message,
            status: this.status,
            details: this.details
        };
    }
    constructor(message, details = null){
        super(message, 'AuthImplicitGrantRedirectError', 500, undefined);
        this.details = null;
        this.details = details;
    }
}
function $23e204244b27914e$export$45edea3999507afd(error) {
    return $23e204244b27914e$export$cde1786a482f9a1c(error) && error.name === 'AuthImplicitGrantRedirectError';
}
class $23e204244b27914e$export$39583657eb2a7027 extends $23e204244b27914e$export$823c745ae0673c5e {
    toJSON() {
        return {
            name: this.name,
            message: this.message,
            status: this.status,
            details: this.details
        };
    }
    constructor(message, details = null){
        super(message, 'AuthPKCEGrantCodeExchangeError', 500, undefined);
        this.details = null;
        this.details = details;
    }
}
class $23e204244b27914e$export$2423b763f68be1b4 extends $23e204244b27914e$export$823c745ae0673c5e {
    constructor(message, status){
        super(message, 'AuthRetryableFetchError', status, undefined);
    }
}
function $23e204244b27914e$export$a77af358da5fb874(error) {
    return $23e204244b27914e$export$cde1786a482f9a1c(error) && error.name === 'AuthRetryableFetchError';
}
class $23e204244b27914e$export$b034076aa04913a6 extends $23e204244b27914e$export$823c745ae0673c5e {
    constructor(message, status, reasons){
        super(message, 'AuthWeakPasswordError', status, 'weak_password');
        this.reasons = reasons;
    }
}
function $23e204244b27914e$export$dac36143fd8a46ef(error) {
    return $23e204244b27914e$export$cde1786a482f9a1c(error) && error.name === 'AuthWeakPasswordError';
}
class $23e204244b27914e$export$d04cb18528f2043e extends $23e204244b27914e$export$823c745ae0673c5e {
    constructor(message){
        super(message, 'AuthInvalidJwtError', 400, 'invalid_jwt');
    }
}


/**
 * Avoid modifying this file. It's part of
 * https://github.com/supabase-community/base64url-js.  Submit all fixes on
 * that repo!
 */ /**
 * An array of characters that encode 6 bits into a Base64-URL alphabet
 * character.
 */ const $d7ec53d3b9daae46$var$TO_BASE64URL = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_'.split('');
/**
 * An array of characters that can appear in a Base64-URL encoded string but
 * should be ignored.
 */ const $d7ec53d3b9daae46$var$IGNORE_BASE64URL = ' \t\n\r='.split('');
/**
 * An array of 128 numbers that map a Base64-URL character to 6 bits, or if -2
 * used to skip the character, or if -1 used to error out.
 */ const $d7ec53d3b9daae46$var$FROM_BASE64URL = (()=>{
    const charMap = new Array(128);
    for(let i = 0; i < charMap.length; i += 1)charMap[i] = -1;
    for(let i = 0; i < $d7ec53d3b9daae46$var$IGNORE_BASE64URL.length; i += 1)charMap[$d7ec53d3b9daae46$var$IGNORE_BASE64URL[i].charCodeAt(0)] = -2;
    for(let i = 0; i < $d7ec53d3b9daae46$var$TO_BASE64URL.length; i += 1)charMap[$d7ec53d3b9daae46$var$TO_BASE64URL[i].charCodeAt(0)] = i;
    return charMap;
})();
function $d7ec53d3b9daae46$export$744f452403189a3e(byte, state, emit) {
    if (byte !== null) {
        state.queue = state.queue << 8 | byte;
        state.queuedBits += 8;
        while(state.queuedBits >= 6){
            const pos = state.queue >> state.queuedBits - 6 & 63;
            emit($d7ec53d3b9daae46$var$TO_BASE64URL[pos]);
            state.queuedBits -= 6;
        }
    } else if (state.queuedBits > 0) {
        state.queue = state.queue << 6 - state.queuedBits;
        state.queuedBits = 6;
        while(state.queuedBits >= 6){
            const pos = state.queue >> state.queuedBits - 6 & 63;
            emit($d7ec53d3b9daae46$var$TO_BASE64URL[pos]);
            state.queuedBits -= 6;
        }
    }
}
function $d7ec53d3b9daae46$export$403e86c86002a137(charCode, state, emit) {
    const bits = $d7ec53d3b9daae46$var$FROM_BASE64URL[charCode];
    if (bits > -1) {
        // valid Base64-URL character
        state.queue = state.queue << 6 | bits;
        state.queuedBits += 6;
        while(state.queuedBits >= 8){
            emit(state.queue >> state.queuedBits - 8 & 0xff);
            state.queuedBits -= 8;
        }
    } else if (bits === -2) // ignore spaces, tabs, newlines, =
    return;
    else throw new Error(`Invalid Base64-URL character "${String.fromCharCode(charCode)}"`);
}
function $d7ec53d3b9daae46$export$abe65c864cc3fd34(str) {
    const base64 = [];
    const emitter = (char)=>{
        base64.push(char);
    };
    const state = {
        queue: 0,
        queuedBits: 0
    };
    $d7ec53d3b9daae46$export$caccae6095ceb6da(str, (byte)=>{
        $d7ec53d3b9daae46$export$744f452403189a3e(byte, state, emitter);
    });
    $d7ec53d3b9daae46$export$744f452403189a3e(null, state, emitter);
    return base64.join('');
}
function $d7ec53d3b9daae46$export$bd5d476f823ea024(str) {
    const conv = [];
    const utf8Emit = (codepoint)=>{
        conv.push(String.fromCodePoint(codepoint));
    };
    const utf8State = {
        utf8seq: 0,
        codepoint: 0
    };
    const b64State = {
        queue: 0,
        queuedBits: 0
    };
    const byteEmit = (byte)=>{
        $d7ec53d3b9daae46$export$719b4117b3270757(byte, utf8State, utf8Emit);
    };
    for(let i = 0; i < str.length; i += 1)$d7ec53d3b9daae46$export$403e86c86002a137(str.charCodeAt(i), b64State, byteEmit);
    return conv.join('');
}
function $d7ec53d3b9daae46$export$d203cd9136753332(codepoint, emit) {
    if (codepoint <= 0x7f) {
        emit(codepoint);
        return;
    } else if (codepoint <= 0x7ff) {
        emit(0xc0 | codepoint >> 6);
        emit(0x80 | codepoint & 0x3f);
        return;
    } else if (codepoint <= 0xffff) {
        emit(0xe0 | codepoint >> 12);
        emit(0x80 | codepoint >> 6 & 0x3f);
        emit(0x80 | codepoint & 0x3f);
        return;
    } else if (codepoint <= 0x10ffff) {
        emit(0xf0 | codepoint >> 18);
        emit(0x80 | codepoint >> 12 & 0x3f);
        emit(0x80 | codepoint >> 6 & 0x3f);
        emit(0x80 | codepoint & 0x3f);
        return;
    }
    throw new Error(`Unrecognized Unicode codepoint: ${codepoint.toString(16)}`);
}
function $d7ec53d3b9daae46$export$caccae6095ceb6da(str, emit) {
    for(let i = 0; i < str.length; i += 1){
        let codepoint = str.charCodeAt(i);
        if (codepoint > 0xd7ff && codepoint <= 0xdbff) {
            // most UTF-16 codepoints are Unicode codepoints, except values in this
            // range where the next UTF-16 codepoint needs to be combined with the
            // current one to get the Unicode codepoint
            const highSurrogate = (codepoint - 0xd800) * 0x400 & 0xffff;
            const lowSurrogate = str.charCodeAt(i + 1) - 0xdc00 & 0xffff;
            codepoint = (lowSurrogate | highSurrogate) + 0x10000;
            i += 1;
        }
        $d7ec53d3b9daae46$export$d203cd9136753332(codepoint, emit);
    }
}
function $d7ec53d3b9daae46$export$719b4117b3270757(byte, state, emit) {
    if (state.utf8seq === 0) {
        if (byte <= 0x7f) {
            emit(byte);
            return;
        }
        // count the number of 1 leading bits until you reach 0
        for(let leadingBit = 1; leadingBit < 6; leadingBit += 1)if ((byte >> 7 - leadingBit & 1) === 0) {
            state.utf8seq = leadingBit;
            break;
        }
        if (state.utf8seq === 2) state.codepoint = byte & 31;
        else if (state.utf8seq === 3) state.codepoint = byte & 15;
        else if (state.utf8seq === 4) state.codepoint = byte & 7;
        else throw new Error('Invalid UTF-8 sequence');
        state.utf8seq -= 1;
    } else if (state.utf8seq > 0) {
        if (byte <= 0x7f) throw new Error('Invalid UTF-8 sequence');
        state.codepoint = state.codepoint << 6 | byte & 63;
        state.utf8seq -= 1;
        if (state.utf8seq === 0) emit(state.codepoint);
    }
}
function $d7ec53d3b9daae46$export$9cae2cd6076b8fb6(str) {
    const result = [];
    const state = {
        queue: 0,
        queuedBits: 0
    };
    const onByte = (byte)=>{
        result.push(byte);
    };
    for(let i = 0; i < str.length; i += 1)$d7ec53d3b9daae46$export$403e86c86002a137(str.charCodeAt(i), state, onByte);
    return new Uint8Array(result);
}
function $d7ec53d3b9daae46$export$a098e7b533f96db3(str) {
    const result = [];
    $d7ec53d3b9daae46$export$caccae6095ceb6da(str, (byte)=>result.push(byte));
    return new Uint8Array(result);
}


function $851629df92f77955$export$e02d0a488392f690(expiresIn) {
    const timeNow = Math.round(Date.now() / 1000);
    return timeNow + expiresIn;
}
function $851629df92f77955$export$31b40729666a4ae0() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
        const r = Math.random() * 16 | 0, v = c == 'x' ? r : r & 0x3 | 0x8;
        return v.toString(16);
    });
}
const $851629df92f77955$export$4e09c449d6c407f7 = ()=>typeof window !== 'undefined' && typeof document !== 'undefined';
const $851629df92f77955$var$localStorageWriteTests = {
    tested: false,
    writable: false
};
const $851629df92f77955$export$9ec034ee80211814 = ()=>{
    if (!$851629df92f77955$export$4e09c449d6c407f7()) return false;
    try {
        if (typeof globalThis.localStorage !== 'object') return false;
    } catch (e) {
        // DOM exception when accessing `localStorage`
        return false;
    }
    if ($851629df92f77955$var$localStorageWriteTests.tested) return $851629df92f77955$var$localStorageWriteTests.writable;
    const randomKey = `lswt-${Math.random()}${Math.random()}`;
    try {
        globalThis.localStorage.setItem(randomKey, randomKey);
        globalThis.localStorage.removeItem(randomKey);
        $851629df92f77955$var$localStorageWriteTests.tested = true;
        $851629df92f77955$var$localStorageWriteTests.writable = true;
    } catch (e) {
        // localStorage can't be written to
        // https://www.chromium.org/for-testers/bug-reporting-guidelines/uncaught-securityerror-failed-to-read-the-localstorage-property-from-window-access-is-denied-for-this-document
        $851629df92f77955$var$localStorageWriteTests.tested = true;
        $851629df92f77955$var$localStorageWriteTests.writable = false;
    }
    return $851629df92f77955$var$localStorageWriteTests.writable;
};
function $851629df92f77955$export$7a29392fb778224c(href) {
    const result = {};
    const url = new URL(href);
    if (url.hash && url.hash[0] === '#') try {
        const hashSearchParams = new URLSearchParams(url.hash.substring(1));
        hashSearchParams.forEach((value, key)=>{
            result[key] = value;
        });
    } catch (e) {
    // hash is not a query string
    }
    // search parameters take precedence over hash parameters
    url.searchParams.forEach((value, key)=>{
        result[key] = value;
    });
    return result;
}

const $851629df92f77955$export$98d92b1aa79f8cc7 = (customFetch)=>{
    let _fetch;
    if (customFetch) _fetch = customFetch;
    else if (typeof fetch === 'undefined') _fetch = (...args)=>Promise.resolve((parcelRequire("ff1Or"))).then(({ default: fetch1 })=>fetch1(...args));
    else _fetch = fetch;
    return (...args)=>_fetch(...args);
};
const $851629df92f77955$export$e8ad6599be1036a7 = (maybeResponse)=>{
    return typeof maybeResponse === 'object' && maybeResponse !== null && 'status' in maybeResponse && 'ok' in maybeResponse && 'json' in maybeResponse && typeof maybeResponse.json === 'function';
};
const $851629df92f77955$export$e82c36d29078a87f = async (storage, key, data)=>{
    await storage.setItem(key, JSON.stringify(data));
};
const $851629df92f77955$export$ba6fcb7c333d32c0 = async (storage, key)=>{
    const value = await storage.getItem(key);
    if (!value) return null;
    try {
        return JSON.parse(value);
    } catch (_a) {
        return value;
    }
};
const $851629df92f77955$export$d35c645d585317ec = async (storage, key)=>{
    await storage.removeItem(key);
};
class $851629df92f77955$export$85f6557964517f1a {
    constructor(){
        this.promise = new $851629df92f77955$export$85f6557964517f1a.promiseConstructor((res, rej)=>{
            this.resolve = res;
            this.reject = rej;
        });
    }
}
$851629df92f77955$export$85f6557964517f1a.promiseConstructor = Promise;
function $851629df92f77955$export$9a62e6c0a30e00bc(token) {
    const parts = token.split('.');
    if (parts.length !== 3) throw new (0, $23e204244b27914e$export$d04cb18528f2043e)('Invalid JWT structure');
    // Regex checks for base64url format
    for(let i = 0; i < parts.length; i++){
        if (!(0, $9242f83a1032aa7a$export$7a68c9e70b9d3911).test(parts[i])) throw new (0, $23e204244b27914e$export$d04cb18528f2043e)('JWT not in base64url format');
    }
    const data = {
        // using base64url lib
        header: JSON.parse((0, $d7ec53d3b9daae46$export$bd5d476f823ea024)(parts[0])),
        payload: JSON.parse((0, $d7ec53d3b9daae46$export$bd5d476f823ea024)(parts[1])),
        signature: (0, $d7ec53d3b9daae46$export$9cae2cd6076b8fb6)(parts[2]),
        raw: {
            header: parts[0],
            payload: parts[1]
        }
    };
    return data;
}
async function $851629df92f77955$export$e772c8ff12451969(time) {
    return await new Promise((accept)=>{
        setTimeout(()=>accept(null), time);
    });
}
function $851629df92f77955$export$9e1b8e833f44ff21(fn, isRetryable) {
    const promise = new Promise((accept, reject)=>{
        (async ()=>{
            for(let attempt = 0; attempt < Infinity; attempt++)try {
                const result = await fn(attempt);
                if (!isRetryable(attempt, null, result)) {
                    accept(result);
                    return;
                }
            } catch (e) {
                if (!isRetryable(attempt, e)) {
                    reject(e);
                    return;
                }
            }
        })();
    });
    return promise;
}
function $851629df92f77955$var$dec2hex(dec) {
    return ('0' + dec.toString(16)).substr(-2);
}
function $851629df92f77955$export$b6c3b8498f152f15() {
    const verifierLength = 56;
    const array = new Uint32Array(verifierLength);
    if (typeof crypto === 'undefined') {
        const charSet = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-._~';
        const charSetLen = charSet.length;
        let verifier = '';
        for(let i = 0; i < verifierLength; i++)verifier += charSet.charAt(Math.floor(Math.random() * charSetLen));
        return verifier;
    }
    crypto.getRandomValues(array);
    return Array.from(array, $851629df92f77955$var$dec2hex).join('');
}
async function $851629df92f77955$var$sha256(randomString) {
    const encoder = new TextEncoder();
    const encodedData = encoder.encode(randomString);
    const hash = await crypto.subtle.digest('SHA-256', encodedData);
    const bytes = new Uint8Array(hash);
    return Array.from(bytes).map((c)=>String.fromCharCode(c)).join('');
}
async function $851629df92f77955$export$eb79e16bb8189148(verifier) {
    const hasCryptoSupport = typeof crypto !== 'undefined' && typeof crypto.subtle !== 'undefined' && typeof TextEncoder !== 'undefined';
    if (!hasCryptoSupport) {
        console.warn('WebCrypto API is not supported. Code challenge method will default to use plain instead of sha256.');
        return verifier;
    }
    const hashed = await $851629df92f77955$var$sha256(verifier);
    return btoa(hashed).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
}
async function $851629df92f77955$export$81b177cadfcf873c(storage, storageKey, isPasswordRecovery = false) {
    const codeVerifier = $851629df92f77955$export$b6c3b8498f152f15();
    let storedCodeVerifier = codeVerifier;
    if (isPasswordRecovery) storedCodeVerifier += '/PASSWORD_RECOVERY';
    await $851629df92f77955$export$e82c36d29078a87f(storage, `${storageKey}-code-verifier`, storedCodeVerifier);
    const codeChallenge = await $851629df92f77955$export$eb79e16bb8189148(codeVerifier);
    const codeChallengeMethod = codeVerifier === codeChallenge ? 'plain' : 's256';
    return [
        codeChallenge,
        codeChallengeMethod
    ];
}
/** Parses the API version which is 2YYY-MM-DD. */ const $851629df92f77955$var$API_VERSION_REGEX = /^2[0-9]{3}-(0[1-9]|1[0-2])-(0[1-9]|1[0-9]|2[0-9]|3[0-1])$/i;
function $851629df92f77955$export$5f69ecf1c14d56fd(response) {
    const apiVersion = response.headers.get((0, $9242f83a1032aa7a$export$e4f5507f88977535));
    if (!apiVersion) return null;
    if (!apiVersion.match($851629df92f77955$var$API_VERSION_REGEX)) return null;
    try {
        const date = new Date(`${apiVersion}T00:00:00.0Z`);
        return date;
    } catch (e) {
        return null;
    }
}
function $851629df92f77955$export$a5850868adeb9253(exp) {
    if (!exp) throw new Error('Missing exp claim');
    const timeNow = Math.floor(Date.now() / 1000);
    if (exp <= timeNow) throw new Error('JWT has expired');
}
function $851629df92f77955$export$fa59f625ab60cb91(alg) {
    switch(alg){
        case 'RS256':
            return {
                name: 'RSASSA-PKCS1-v1_5',
                hash: {
                    name: 'SHA-256'
                }
            };
        case 'ES256':
            return {
                name: 'ECDSA',
                namedCurve: 'P-256',
                hash: {
                    name: 'SHA-256'
                }
            };
        default:
            throw new Error('Invalid alg claim');
    }
}



var $fb7af5ea5edbf7d2$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
const $fb7af5ea5edbf7d2$var$_getErrorMessage = (err)=>err.msg || err.message || err.error_description || err.error || JSON.stringify(err);
const $fb7af5ea5edbf7d2$var$NETWORK_ERROR_CODES = [
    502,
    503,
    504
];
async function $fb7af5ea5edbf7d2$export$d3da1ecaf1206c58(error) {
    var _a;
    if (!(0, $851629df92f77955$export$e8ad6599be1036a7)(error)) throw new (0, $23e204244b27914e$export$2423b763f68be1b4)($fb7af5ea5edbf7d2$var$_getErrorMessage(error), 0);
    if ($fb7af5ea5edbf7d2$var$NETWORK_ERROR_CODES.includes(error.status)) // status in 500...599 range - server had an error, request might be retryed.
    throw new (0, $23e204244b27914e$export$2423b763f68be1b4)($fb7af5ea5edbf7d2$var$_getErrorMessage(error), error.status);
    let data;
    try {
        data = await error.json();
    } catch (e) {
        throw new (0, $23e204244b27914e$export$f7559805d4a50078)($fb7af5ea5edbf7d2$var$_getErrorMessage(e), e);
    }
    let errorCode = undefined;
    const responseAPIVersion = (0, $851629df92f77955$export$5f69ecf1c14d56fd)(error);
    if (responseAPIVersion && responseAPIVersion.getTime() >= (0, $9242f83a1032aa7a$export$1f9a66038489bdeb)['2024-01-01'].timestamp && typeof data === 'object' && data && typeof data.code === 'string') errorCode = data.code;
    else if (typeof data === 'object' && data && typeof data.error_code === 'string') errorCode = data.error_code;
    if (!errorCode) {
        // Legacy support for weak password errors, when there were no error codes
        if (typeof data === 'object' && data && typeof data.weak_password === 'object' && data.weak_password && Array.isArray(data.weak_password.reasons) && data.weak_password.reasons.length && data.weak_password.reasons.reduce((a, i)=>a && typeof i === 'string', true)) throw new (0, $23e204244b27914e$export$b034076aa04913a6)($fb7af5ea5edbf7d2$var$_getErrorMessage(data), error.status, data.weak_password.reasons);
    } else if (errorCode === 'weak_password') throw new (0, $23e204244b27914e$export$b034076aa04913a6)($fb7af5ea5edbf7d2$var$_getErrorMessage(data), error.status, ((_a = data.weak_password) === null || _a === void 0 ? void 0 : _a.reasons) || []);
    else if (errorCode === 'session_not_found') // The `session_id` inside the JWT does not correspond to a row in the
    // `sessions` table. This usually means the user has signed out, has been
    // deleted, or their session has somehow been terminated.
    throw new (0, $23e204244b27914e$export$403b3fc0d3ad5f0c)();
    throw new (0, $23e204244b27914e$export$45fde0b55b14f37b)($fb7af5ea5edbf7d2$var$_getErrorMessage(data), error.status || 500, errorCode);
}
const $fb7af5ea5edbf7d2$var$_getRequestParams = (method, options, parameters, body)=>{
    const params = {
        method: method,
        headers: (options === null || options === void 0 ? void 0 : options.headers) || {}
    };
    if (method === 'GET') return params;
    params.headers = Object.assign({
        'Content-Type': 'application/json;charset=UTF-8'
    }, options === null || options === void 0 ? void 0 : options.headers);
    params.body = JSON.stringify(body);
    return Object.assign(Object.assign({}, params), parameters);
};
async function $fb7af5ea5edbf7d2$export$8969b3850ca2cdfd(fetcher, method, url, options) {
    var _a;
    const headers = Object.assign({}, options === null || options === void 0 ? void 0 : options.headers);
    if (!headers[0, $9242f83a1032aa7a$export$e4f5507f88977535]) headers[0, $9242f83a1032aa7a$export$e4f5507f88977535] = (0, $9242f83a1032aa7a$export$1f9a66038489bdeb)['2024-01-01'].name;
    if (options === null || options === void 0 ? void 0 : options.jwt) headers['Authorization'] = `Bearer ${options.jwt}`;
    const qs = (_a = options === null || options === void 0 ? void 0 : options.query) !== null && _a !== void 0 ? _a : {};
    if (options === null || options === void 0 ? void 0 : options.redirectTo) qs['redirect_to'] = options.redirectTo;
    const queryString = Object.keys(qs).length ? '?' + new URLSearchParams(qs).toString() : '';
    const data = await $fb7af5ea5edbf7d2$var$_handleRequest(fetcher, method, url + queryString, {
        headers: headers,
        noResolveJson: options === null || options === void 0 ? void 0 : options.noResolveJson
    }, {}, options === null || options === void 0 ? void 0 : options.body);
    return (options === null || options === void 0 ? void 0 : options.xform) ? options === null || options === void 0 ? void 0 : options.xform(data) : {
        data: Object.assign({}, data),
        error: null
    };
}
async function $fb7af5ea5edbf7d2$var$_handleRequest(fetcher, method, url, options, parameters, body) {
    const requestParams = $fb7af5ea5edbf7d2$var$_getRequestParams(method, options, parameters, body);
    let result;
    try {
        result = await fetcher(url, Object.assign({}, requestParams));
    } catch (e) {
        console.error(e);
        // fetch failed, likely due to a network or CORS error
        throw new (0, $23e204244b27914e$export$2423b763f68be1b4)($fb7af5ea5edbf7d2$var$_getErrorMessage(e), 0);
    }
    if (!result.ok) await $fb7af5ea5edbf7d2$export$d3da1ecaf1206c58(result);
    if (options === null || options === void 0 ? void 0 : options.noResolveJson) return result;
    try {
        return await result.json();
    } catch (e) {
        await $fb7af5ea5edbf7d2$export$d3da1ecaf1206c58(e);
    }
}
function $fb7af5ea5edbf7d2$export$273fe4673a018c2e(data) {
    var _a;
    let session = null;
    if ($fb7af5ea5edbf7d2$var$hasSession(data)) {
        session = Object.assign({}, data);
        if (!data.expires_at) session.expires_at = (0, $851629df92f77955$export$e02d0a488392f690)(data.expires_in);
    }
    const user = (_a = data.user) !== null && _a !== void 0 ? _a : data;
    return {
        data: {
            session: session,
            user: user
        },
        error: null
    };
}
function $fb7af5ea5edbf7d2$export$db83aade1c2922c7(data) {
    const response = $fb7af5ea5edbf7d2$export$273fe4673a018c2e(data);
    if (!response.error && data.weak_password && typeof data.weak_password === 'object' && Array.isArray(data.weak_password.reasons) && data.weak_password.reasons.length && data.weak_password.message && typeof data.weak_password.message === 'string' && data.weak_password.reasons.reduce((a, i)=>a && typeof i === 'string', true)) response.data.weak_password = data.weak_password;
    return response;
}
function $fb7af5ea5edbf7d2$export$e20f488897843593(data) {
    var _a;
    const user = (_a = data.user) !== null && _a !== void 0 ? _a : data;
    return {
        data: {
            user: user
        },
        error: null
    };
}
function $fb7af5ea5edbf7d2$export$b04785c46dcd8f8b(data) {
    return {
        data: data,
        error: null
    };
}
function $fb7af5ea5edbf7d2$export$f5eaa950605b2146(data) {
    const { action_link: action_link, email_otp: email_otp, hashed_token: hashed_token, redirect_to: redirect_to, verification_type: verification_type } = data, rest = $fb7af5ea5edbf7d2$var$__rest(data, [
        "action_link",
        "email_otp",
        "hashed_token",
        "redirect_to",
        "verification_type"
    ]);
    const properties = {
        action_link: action_link,
        email_otp: email_otp,
        hashed_token: hashed_token,
        redirect_to: redirect_to,
        verification_type: verification_type
    };
    const user = Object.assign({}, rest);
    return {
        data: {
            properties: properties,
            user: user
        },
        error: null
    };
}
function $fb7af5ea5edbf7d2$export$7aed01df6e045e31(data) {
    return data;
}
/**
 * hasSession checks if the response object contains a valid session
 * @param data A response object
 * @returns true if a session is in the response
 */ function $fb7af5ea5edbf7d2$var$hasSession(data) {
    return data.access_token && data.refresh_token && data.expires_in;
}




var $22cc145af22a62fe$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
class $22cc145af22a62fe$export$2e2bcd8739ae039 {
    /**
     * Removes a logged-in session.
     * @param jwt A valid, logged-in JWT.
     * @param scope The logout sope.
     */ async signOut(jwt, scope = 'global') {
        try {
            await (0, $fb7af5ea5edbf7d2$export$8969b3850ca2cdfd)(this.fetch, 'POST', `${this.url}/logout?scope=${scope}`, {
                headers: this.headers,
                jwt: jwt,
                noResolveJson: true
            });
            return {
                data: null,
                error: null
            };
        } catch (error) {
            if ((0, $23e204244b27914e$export$cde1786a482f9a1c)(error)) return {
                data: null,
                error: error
            };
            throw error;
        }
    }
    /**
     * Sends an invite link to an email address.
     * @param email The email address of the user.
     * @param options Additional options to be included when inviting.
     */ async inviteUserByEmail(email, options = {}) {
        try {
            return await (0, $fb7af5ea5edbf7d2$export$8969b3850ca2cdfd)(this.fetch, 'POST', `${this.url}/invite`, {
                body: {
                    email: email,
                    data: options.data
                },
                headers: this.headers,
                redirectTo: options.redirectTo,
                xform: (0, $fb7af5ea5edbf7d2$export$e20f488897843593)
            });
        } catch (error) {
            if ((0, $23e204244b27914e$export$cde1786a482f9a1c)(error)) return {
                data: {
                    user: null
                },
                error: error
            };
            throw error;
        }
    }
    /**
     * Generates email links and OTPs to be sent via a custom email provider.
     * @param email The user's email.
     * @param options.password User password. For signup only.
     * @param options.data Optional user metadata. For signup only.
     * @param options.redirectTo The redirect url which should be appended to the generated link
     */ async generateLink(params) {
        try {
            const { options: options } = params, rest = $22cc145af22a62fe$var$__rest(params, [
                "options"
            ]);
            const body = Object.assign(Object.assign({}, rest), options);
            if ('newEmail' in rest) {
                // replace newEmail with new_email in request body
                body.new_email = rest === null || rest === void 0 ? void 0 : rest.newEmail;
                delete body['newEmail'];
            }
            return await (0, $fb7af5ea5edbf7d2$export$8969b3850ca2cdfd)(this.fetch, 'POST', `${this.url}/admin/generate_link`, {
                body: body,
                headers: this.headers,
                xform: (0, $fb7af5ea5edbf7d2$export$f5eaa950605b2146),
                redirectTo: options === null || options === void 0 ? void 0 : options.redirectTo
            });
        } catch (error) {
            if ((0, $23e204244b27914e$export$cde1786a482f9a1c)(error)) return {
                data: {
                    properties: null,
                    user: null
                },
                error: error
            };
            throw error;
        }
    }
    // User Admin API
    /**
     * Creates a new user.
     * This function should only be called on a server. Never expose your `service_role` key in the browser.
     */ async createUser(attributes) {
        try {
            return await (0, $fb7af5ea5edbf7d2$export$8969b3850ca2cdfd)(this.fetch, 'POST', `${this.url}/admin/users`, {
                body: attributes,
                headers: this.headers,
                xform: (0, $fb7af5ea5edbf7d2$export$e20f488897843593)
            });
        } catch (error) {
            if ((0, $23e204244b27914e$export$cde1786a482f9a1c)(error)) return {
                data: {
                    user: null
                },
                error: error
            };
            throw error;
        }
    }
    /**
     * Get a list of users.
     *
     * This function should only be called on a server. Never expose your `service_role` key in the browser.
     * @param params An object which supports `page` and `perPage` as numbers, to alter the paginated results.
     */ async listUsers(params) {
        var _a, _b, _c, _d, _e, _f, _g;
        try {
            const pagination = {
                nextPage: null,
                lastPage: 0,
                total: 0
            };
            const response = await (0, $fb7af5ea5edbf7d2$export$8969b3850ca2cdfd)(this.fetch, 'GET', `${this.url}/admin/users`, {
                headers: this.headers,
                noResolveJson: true,
                query: {
                    page: (_b = (_a = params === null || params === void 0 ? void 0 : params.page) === null || _a === void 0 ? void 0 : _a.toString()) !== null && _b !== void 0 ? _b : '',
                    per_page: (_d = (_c = params === null || params === void 0 ? void 0 : params.perPage) === null || _c === void 0 ? void 0 : _c.toString()) !== null && _d !== void 0 ? _d : ''
                },
                xform: (0, $fb7af5ea5edbf7d2$export$7aed01df6e045e31)
            });
            if (response.error) throw response.error;
            const users = await response.json();
            const total = (_e = response.headers.get('x-total-count')) !== null && _e !== void 0 ? _e : 0;
            const links = (_g = (_f = response.headers.get('link')) === null || _f === void 0 ? void 0 : _f.split(',')) !== null && _g !== void 0 ? _g : [];
            if (links.length > 0) {
                links.forEach((link)=>{
                    const page = parseInt(link.split(';')[0].split('=')[1].substring(0, 1));
                    const rel = JSON.parse(link.split(';')[1].split('=')[1]);
                    pagination[`${rel}Page`] = page;
                });
                pagination.total = parseInt(total);
            }
            return {
                data: Object.assign(Object.assign({}, users), pagination),
                error: null
            };
        } catch (error) {
            if ((0, $23e204244b27914e$export$cde1786a482f9a1c)(error)) return {
                data: {
                    users: []
                },
                error: error
            };
            throw error;
        }
    }
    /**
     * Get user by id.
     *
     * @param uid The user's unique identifier
     *
     * This function should only be called on a server. Never expose your `service_role` key in the browser.
     */ async getUserById(uid) {
        try {
            return await (0, $fb7af5ea5edbf7d2$export$8969b3850ca2cdfd)(this.fetch, 'GET', `${this.url}/admin/users/${uid}`, {
                headers: this.headers,
                xform: (0, $fb7af5ea5edbf7d2$export$e20f488897843593)
            });
        } catch (error) {
            if ((0, $23e204244b27914e$export$cde1786a482f9a1c)(error)) return {
                data: {
                    user: null
                },
                error: error
            };
            throw error;
        }
    }
    /**
     * Updates the user data.
     *
     * @param attributes The data you want to update.
     *
     * This function should only be called on a server. Never expose your `service_role` key in the browser.
     */ async updateUserById(uid, attributes) {
        try {
            return await (0, $fb7af5ea5edbf7d2$export$8969b3850ca2cdfd)(this.fetch, 'PUT', `${this.url}/admin/users/${uid}`, {
                body: attributes,
                headers: this.headers,
                xform: (0, $fb7af5ea5edbf7d2$export$e20f488897843593)
            });
        } catch (error) {
            if ((0, $23e204244b27914e$export$cde1786a482f9a1c)(error)) return {
                data: {
                    user: null
                },
                error: error
            };
            throw error;
        }
    }
    /**
     * Delete a user. Requires a `service_role` key.
     *
     * @param id The user id you want to remove.
     * @param shouldSoftDelete If true, then the user will be soft-deleted from the auth schema. Soft deletion allows user identification from the hashed user ID but is not reversible.
     * Defaults to false for backward compatibility.
     *
     * This function should only be called on a server. Never expose your `service_role` key in the browser.
     */ async deleteUser(id, shouldSoftDelete = false) {
        try {
            return await (0, $fb7af5ea5edbf7d2$export$8969b3850ca2cdfd)(this.fetch, 'DELETE', `${this.url}/admin/users/${id}`, {
                headers: this.headers,
                body: {
                    should_soft_delete: shouldSoftDelete
                },
                xform: (0, $fb7af5ea5edbf7d2$export$e20f488897843593)
            });
        } catch (error) {
            if ((0, $23e204244b27914e$export$cde1786a482f9a1c)(error)) return {
                data: {
                    user: null
                },
                error: error
            };
            throw error;
        }
    }
    async _listFactors(params) {
        try {
            const { data: data, error: error } = await (0, $fb7af5ea5edbf7d2$export$8969b3850ca2cdfd)(this.fetch, 'GET', `${this.url}/admin/users/${params.userId}/factors`, {
                headers: this.headers,
                xform: (factors)=>{
                    return {
                        data: {
                            factors: factors
                        },
                        error: null
                    };
                }
            });
            return {
                data: data,
                error: error
            };
        } catch (error) {
            if ((0, $23e204244b27914e$export$cde1786a482f9a1c)(error)) return {
                data: null,
                error: error
            };
            throw error;
        }
    }
    async _deleteFactor(params) {
        try {
            const data = await (0, $fb7af5ea5edbf7d2$export$8969b3850ca2cdfd)(this.fetch, 'DELETE', `${this.url}/admin/users/${params.userId}/factors/${params.id}`, {
                headers: this.headers
            });
            return {
                data: data,
                error: null
            };
        } catch (error) {
            if ((0, $23e204244b27914e$export$cde1786a482f9a1c)(error)) return {
                data: null,
                error: error
            };
            throw error;
        }
    }
    constructor({ url: url = '', headers: headers = {}, fetch: fetch }){
        this.url = url;
        this.headers = headers;
        this.fetch = (0, $851629df92f77955$export$98d92b1aa79f8cc7)(fetch);
        this.mfa = {
            listFactors: this._listFactors.bind(this),
            deleteFactor: this._deleteFactor.bind(this)
        };
    }
}








const $313fd1bd7f8b7ad9$export$bba7b6c94612d04b = {
    getItem: (key)=>{
        if (!(0, $851629df92f77955$export$9ec034ee80211814)()) return null;
        return globalThis.localStorage.getItem(key);
    },
    setItem: (key, value)=>{
        if (!(0, $851629df92f77955$export$9ec034ee80211814)()) return;
        globalThis.localStorage.setItem(key, value);
    },
    removeItem: (key)=>{
        if (!(0, $851629df92f77955$export$9ec034ee80211814)()) return;
        globalThis.localStorage.removeItem(key);
    }
};
function $313fd1bd7f8b7ad9$export$d791f66d7e5710cf(store = {}) {
    return {
        getItem: (key)=>{
            return store[key] || null;
        },
        setItem: (key, value)=>{
            store[key] = value;
        },
        removeItem: (key)=>{
            delete store[key];
        }
    };
}


/**
 * https://mathiasbynens.be/notes/globalthis
 */ function $a393e0715ca20d31$export$ad067ce270531206() {
    if (typeof globalThis === 'object') return;
    try {
        Object.defineProperty(Object.prototype, '__magic__', {
            get: function() {
                return this;
            },
            configurable: true
        });
        // @ts-expect-error 'Allow access to magic'
        __magic__.globalThis = __magic__;
        // @ts-expect-error 'Allow access to magic'
        delete Object.prototype.__magic__;
    } catch (e) {
        if (typeof self !== 'undefined') // @ts-expect-error 'Allow access to globals'
        self.globalThis = self;
    }
}




const $b1040c32bf2597eb$export$e368aba7747330f2 = {
    /**
     * @experimental
     */ debug: !!(globalThis && (0, $851629df92f77955$export$9ec034ee80211814)() && globalThis.localStorage && globalThis.localStorage.getItem('supabase.gotrue-js.locks.debug') === 'true')
};
class $b1040c32bf2597eb$export$23e9464cc010dff9 extends Error {
    constructor(message){
        super(message);
        this.isAcquireTimeout = true;
    }
}
class $b1040c32bf2597eb$export$4aa56776043a4631 extends $b1040c32bf2597eb$export$23e9464cc010dff9 {
}
class $b1040c32bf2597eb$export$4b982ee840d3d915 extends $b1040c32bf2597eb$export$23e9464cc010dff9 {
}
async function $b1040c32bf2597eb$export$f4ff21938fb7af3c(name, acquireTimeout, fn) {
    if ($b1040c32bf2597eb$export$e368aba7747330f2.debug) console.log('@supabase/gotrue-js: navigatorLock: acquire lock', name, acquireTimeout);
    const abortController = new globalThis.AbortController();
    if (acquireTimeout > 0) setTimeout(()=>{
        abortController.abort();
        if ($b1040c32bf2597eb$export$e368aba7747330f2.debug) console.log('@supabase/gotrue-js: navigatorLock acquire timed out', name);
    }, acquireTimeout);
    // MDN article: https://developer.mozilla.org/en-US/docs/Web/API/LockManager/request
    // Wrapping navigator.locks.request() with a plain Promise is done as some
    // libraries like zone.js patch the Promise object to track the execution
    // context. However, it appears that most browsers use an internal promise
    // implementation when using the navigator.locks.request() API causing them
    // to lose context and emit confusing log messages or break certain features.
    // This wrapping is believed to help zone.js track the execution context
    // better.
    return await Promise.resolve().then(()=>globalThis.navigator.locks.request(name, acquireTimeout === 0 ? {
            mode: 'exclusive',
            ifAvailable: true
        } : {
            mode: 'exclusive',
            signal: abortController.signal
        }, async (lock)=>{
            if (lock) {
                if ($b1040c32bf2597eb$export$e368aba7747330f2.debug) console.log('@supabase/gotrue-js: navigatorLock: acquired', name, lock.name);
                try {
                    return await fn();
                } finally{
                    if ($b1040c32bf2597eb$export$e368aba7747330f2.debug) console.log('@supabase/gotrue-js: navigatorLock: released', name, lock.name);
                }
            } else if (acquireTimeout === 0) {
                if ($b1040c32bf2597eb$export$e368aba7747330f2.debug) console.log('@supabase/gotrue-js: navigatorLock: not immediately available', name);
                throw new $b1040c32bf2597eb$export$4aa56776043a4631(`Acquiring an exclusive Navigator LockManager lock "${name}" immediately failed`);
            } else {
                if ($b1040c32bf2597eb$export$e368aba7747330f2.debug) try {
                    const result = await globalThis.navigator.locks.query();
                    console.log('@supabase/gotrue-js: Navigator LockManager state', JSON.stringify(result, null, '  '));
                } catch (e) {
                    console.warn('@supabase/gotrue-js: Error when querying Navigator LockManager state', e);
                }
                // Browser is not following the Navigator LockManager spec, it
                // returned a null lock when we didn't use ifAvailable. So we can
                // pretend the lock is acquired in the name of backward compatibility
                // and user experience and just run the function.
                console.warn('@supabase/gotrue-js: Navigator LockManager returned a null lock when using #request without ifAvailable set to true, it appears this browser is not following the LockManager spec https://developer.mozilla.org/en-US/docs/Web/API/LockManager/request');
                return await fn();
            }
        }));
}
const $b1040c32bf2597eb$var$PROCESS_LOCKS = {};
async function $b1040c32bf2597eb$export$b21ec9b2268372c7(name, acquireTimeout, fn) {
    var _a;
    const previousOperation = (_a = $b1040c32bf2597eb$var$PROCESS_LOCKS[name]) !== null && _a !== void 0 ? _a : Promise.resolve();
    const currentOperation = Promise.race([
        previousOperation.catch(()=>{
            // ignore error of previous operation that we're waiting to finish
            return null;
        }),
        acquireTimeout >= 0 ? new Promise((_, reject)=>{
            setTimeout(()=>{
                reject(new $b1040c32bf2597eb$export$4b982ee840d3d915(`Acquring process lock with name "${name}" timed out`));
            }, acquireTimeout);
        }) : null
    ].filter((x)=>x)).catch((e)=>{
        if (e && e.isAcquireTimeout) throw e;
        return null;
    }).then(async ()=>{
        // previous operations finished and we didn't get a race on the acquire
        // timeout, so the current operation can finally start
        return await fn();
    });
    $b1040c32bf2597eb$var$PROCESS_LOCKS[name] = currentOperation.catch(async (e)=>{
        if (e && e.isAcquireTimeout) {
            // if the current operation timed out, it doesn't mean that the previous
            // operation finished, so we need contnue waiting for it to finish
            await previousOperation;
            return null;
        }
        throw e;
    });
    // finally wait for the current operation to finish successfully, with an
    // error or with an acquire timeout error
    return await currentOperation;
}



(0, $a393e0715ca20d31$export$ad067ce270531206)(); // Make "globalThis" available
const $060b3eed510a76bb$var$DEFAULT_OPTIONS = {
    url: (0, $9242f83a1032aa7a$export$7fedf552187f0c3d),
    storageKey: (0, $9242f83a1032aa7a$export$86880b4b2e1a2384),
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: true,
    headers: (0, $9242f83a1032aa7a$export$88a84136db6a4b64),
    flowType: 'implicit',
    debug: false,
    hasCustomAuthorizationHeader: false
};
async function $060b3eed510a76bb$var$lockNoOp(name, acquireTimeout, fn) {
    return await fn();
}
class $060b3eed510a76bb$export$2e2bcd8739ae039 {
    _debug(...args) {
        if (this.logDebugMessages) this.logger(`GoTrueClient@${this.instanceID} (${(0, $678a7a6add38cca5$export$83d89fbfd8236492)}) ${new Date().toISOString()}`, ...args);
        return this;
    }
    /**
     * Initializes the client session either from the url or from storage.
     * This method is automatically called when instantiating the client, but should also be called
     * manually when checking for an error from an auth redirect (oauth, magiclink, password recovery, etc).
     */ async initialize() {
        if (this.initializePromise) return await this.initializePromise;
        this.initializePromise = (async ()=>{
            return await this._acquireLock(-1, async ()=>{
                return await this._initialize();
            });
        })();
        return await this.initializePromise;
    }
    /**
     * IMPORTANT:
     * 1. Never throw in this method, as it is called from the constructor
     * 2. Never return a session from this method as it would be cached over
     *    the whole lifetime of the client
     */ async _initialize() {
        var _a;
        try {
            const params = (0, $851629df92f77955$export$7a29392fb778224c)(window.location.href);
            let callbackUrlType = 'none';
            if (this._isImplicitGrantCallback(params)) callbackUrlType = 'implicit';
            else if (await this._isPKCECallback(params)) callbackUrlType = 'pkce';
            /**
             * Attempt to get the session from the URL only if these conditions are fulfilled
             *
             * Note: If the URL isn't one of the callback url types (implicit or pkce),
             * then there could be an existing session so we don't want to prematurely remove it
             */ if ((0, $851629df92f77955$export$4e09c449d6c407f7)() && this.detectSessionInUrl && callbackUrlType !== 'none') {
                const { data: data, error: error } = await this._getSessionFromURL(params, callbackUrlType);
                if (error) {
                    this._debug('#_initialize()', 'error detecting session from URL', error);
                    if ((0, $23e204244b27914e$export$45edea3999507afd)(error)) {
                        const errorCode = (_a = error.details) === null || _a === void 0 ? void 0 : _a.code;
                        if (errorCode === 'identity_already_exists' || errorCode === 'identity_not_found' || errorCode === 'single_identity_not_deletable') return {
                            error: error
                        };
                    }
                    // failed login attempt via url,
                    // remove old session as in verifyOtp, signUp and signInWith*
                    await this._removeSession();
                    return {
                        error: error
                    };
                }
                const { session: session, redirectType: redirectType } = data;
                this._debug('#_initialize()', 'detected session in URL', session, 'redirect type', redirectType);
                await this._saveSession(session);
                setTimeout(async ()=>{
                    if (redirectType === 'recovery') await this._notifyAllSubscribers('PASSWORD_RECOVERY', session);
                    else await this._notifyAllSubscribers('SIGNED_IN', session);
                }, 0);
                return {
                    error: null
                };
            }
            // no login attempt via callback url try to recover session from storage
            await this._recoverAndRefresh();
            return {
                error: null
            };
        } catch (error) {
            if ((0, $23e204244b27914e$export$cde1786a482f9a1c)(error)) return {
                error: error
            };
            return {
                error: new (0, $23e204244b27914e$export$f7559805d4a50078)('Unexpected error during initialization', error)
            };
        } finally{
            await this._handleVisibilityChange();
            this._debug('#_initialize()', 'end');
        }
    }
    /**
     * Creates a new anonymous user.
     *
     * @returns A session where the is_anonymous claim in the access token JWT set to true
     */ async signInAnonymously(credentials) {
        var _a, _b, _c;
        try {
            const res = await (0, $fb7af5ea5edbf7d2$export$8969b3850ca2cdfd)(this.fetch, 'POST', `${this.url}/signup`, {
                headers: this.headers,
                body: {
                    data: (_b = (_a = credentials === null || credentials === void 0 ? void 0 : credentials.options) === null || _a === void 0 ? void 0 : _a.data) !== null && _b !== void 0 ? _b : {},
                    gotrue_meta_security: {
                        captcha_token: (_c = credentials === null || credentials === void 0 ? void 0 : credentials.options) === null || _c === void 0 ? void 0 : _c.captchaToken
                    }
                },
                xform: (0, $fb7af5ea5edbf7d2$export$273fe4673a018c2e)
            });
            const { data: data, error: error } = res;
            if (error || !data) return {
                data: {
                    user: null,
                    session: null
                },
                error: error
            };
            const session = data.session;
            const user = data.user;
            if (data.session) {
                await this._saveSession(data.session);
                await this._notifyAllSubscribers('SIGNED_IN', session);
            }
            return {
                data: {
                    user: user,
                    session: session
                },
                error: null
            };
        } catch (error) {
            if ((0, $23e204244b27914e$export$cde1786a482f9a1c)(error)) return {
                data: {
                    user: null,
                    session: null
                },
                error: error
            };
            throw error;
        }
    }
    /**
     * Creates a new user.
     *
     * Be aware that if a user account exists in the system you may get back an
     * error message that attempts to hide this information from the user.
     * This method has support for PKCE via email signups. The PKCE flow cannot be used when autoconfirm is enabled.
     *
     * @returns A logged-in session if the server has "autoconfirm" ON
     * @returns A user if the server has "autoconfirm" OFF
     */ async signUp(credentials) {
        var _a, _b, _c;
        try {
            let res;
            if ('email' in credentials) {
                const { email: email, password: password, options: options } = credentials;
                let codeChallenge = null;
                let codeChallengeMethod = null;
                if (this.flowType === 'pkce') [codeChallenge, codeChallengeMethod] = await (0, $851629df92f77955$export$81b177cadfcf873c)(this.storage, this.storageKey);
                res = await (0, $fb7af5ea5edbf7d2$export$8969b3850ca2cdfd)(this.fetch, 'POST', `${this.url}/signup`, {
                    headers: this.headers,
                    redirectTo: options === null || options === void 0 ? void 0 : options.emailRedirectTo,
                    body: {
                        email: email,
                        password: password,
                        data: (_a = options === null || options === void 0 ? void 0 : options.data) !== null && _a !== void 0 ? _a : {},
                        gotrue_meta_security: {
                            captcha_token: options === null || options === void 0 ? void 0 : options.captchaToken
                        },
                        code_challenge: codeChallenge,
                        code_challenge_method: codeChallengeMethod
                    },
                    xform: (0, $fb7af5ea5edbf7d2$export$273fe4673a018c2e)
                });
            } else if ('phone' in credentials) {
                const { phone: phone, password: password, options: options } = credentials;
                res = await (0, $fb7af5ea5edbf7d2$export$8969b3850ca2cdfd)(this.fetch, 'POST', `${this.url}/signup`, {
                    headers: this.headers,
                    body: {
                        phone: phone,
                        password: password,
                        data: (_b = options === null || options === void 0 ? void 0 : options.data) !== null && _b !== void 0 ? _b : {},
                        channel: (_c = options === null || options === void 0 ? void 0 : options.channel) !== null && _c !== void 0 ? _c : 'sms',
                        gotrue_meta_security: {
                            captcha_token: options === null || options === void 0 ? void 0 : options.captchaToken
                        }
                    },
                    xform: (0, $fb7af5ea5edbf7d2$export$273fe4673a018c2e)
                });
            } else throw new (0, $23e204244b27914e$export$9ef583f0381b4cc)('You must provide either an email or phone number and a password');
            const { data: data, error: error } = res;
            if (error || !data) return {
                data: {
                    user: null,
                    session: null
                },
                error: error
            };
            const session = data.session;
            const user = data.user;
            if (data.session) {
                await this._saveSession(data.session);
                await this._notifyAllSubscribers('SIGNED_IN', session);
            }
            return {
                data: {
                    user: user,
                    session: session
                },
                error: null
            };
        } catch (error) {
            if ((0, $23e204244b27914e$export$cde1786a482f9a1c)(error)) return {
                data: {
                    user: null,
                    session: null
                },
                error: error
            };
            throw error;
        }
    }
    /**
     * Log in an existing user with an email and password or phone and password.
     *
     * Be aware that you may get back an error message that will not distinguish
     * between the cases where the account does not exist or that the
     * email/phone and password combination is wrong or that the account can only
     * be accessed via social login.
     */ async signInWithPassword(credentials) {
        try {
            let res;
            if ('email' in credentials) {
                const { email: email, password: password, options: options } = credentials;
                res = await (0, $fb7af5ea5edbf7d2$export$8969b3850ca2cdfd)(this.fetch, 'POST', `${this.url}/token?grant_type=password`, {
                    headers: this.headers,
                    body: {
                        email: email,
                        password: password,
                        gotrue_meta_security: {
                            captcha_token: options === null || options === void 0 ? void 0 : options.captchaToken
                        }
                    },
                    xform: (0, $fb7af5ea5edbf7d2$export$db83aade1c2922c7)
                });
            } else if ('phone' in credentials) {
                const { phone: phone, password: password, options: options } = credentials;
                res = await (0, $fb7af5ea5edbf7d2$export$8969b3850ca2cdfd)(this.fetch, 'POST', `${this.url}/token?grant_type=password`, {
                    headers: this.headers,
                    body: {
                        phone: phone,
                        password: password,
                        gotrue_meta_security: {
                            captcha_token: options === null || options === void 0 ? void 0 : options.captchaToken
                        }
                    },
                    xform: (0, $fb7af5ea5edbf7d2$export$db83aade1c2922c7)
                });
            } else throw new (0, $23e204244b27914e$export$9ef583f0381b4cc)('You must provide either an email or phone number and a password');
            const { data: data, error: error } = res;
            if (error) return {
                data: {
                    user: null,
                    session: null
                },
                error: error
            };
            else if (!data || !data.session || !data.user) return {
                data: {
                    user: null,
                    session: null
                },
                error: new (0, $23e204244b27914e$export$7e277b620449c1b4)()
            };
            if (data.session) {
                await this._saveSession(data.session);
                await this._notifyAllSubscribers('SIGNED_IN', data.session);
            }
            return {
                data: Object.assign({
                    user: data.user,
                    session: data.session
                }, data.weak_password ? {
                    weakPassword: data.weak_password
                } : null),
                error: error
            };
        } catch (error) {
            if ((0, $23e204244b27914e$export$cde1786a482f9a1c)(error)) return {
                data: {
                    user: null,
                    session: null
                },
                error: error
            };
            throw error;
        }
    }
    /**
     * Log in an existing user via a third-party provider.
     * This method supports the PKCE flow.
     */ async signInWithOAuth(credentials) {
        var _a, _b, _c, _d;
        return await this._handleProviderSignIn(credentials.provider, {
            redirectTo: (_a = credentials.options) === null || _a === void 0 ? void 0 : _a.redirectTo,
            scopes: (_b = credentials.options) === null || _b === void 0 ? void 0 : _b.scopes,
            queryParams: (_c = credentials.options) === null || _c === void 0 ? void 0 : _c.queryParams,
            skipBrowserRedirect: (_d = credentials.options) === null || _d === void 0 ? void 0 : _d.skipBrowserRedirect
        });
    }
    /**
     * Log in an existing user by exchanging an Auth Code issued during the PKCE flow.
     */ async exchangeCodeForSession(authCode) {
        await this.initializePromise;
        return this._acquireLock(-1, async ()=>{
            return this._exchangeCodeForSession(authCode);
        });
    }
    async _exchangeCodeForSession(authCode) {
        const storageItem = await (0, $851629df92f77955$export$ba6fcb7c333d32c0)(this.storage, `${this.storageKey}-code-verifier`);
        const [codeVerifier, redirectType] = (storageItem !== null && storageItem !== void 0 ? storageItem : '').split('/');
        try {
            const { data: data, error: error } = await (0, $fb7af5ea5edbf7d2$export$8969b3850ca2cdfd)(this.fetch, 'POST', `${this.url}/token?grant_type=pkce`, {
                headers: this.headers,
                body: {
                    auth_code: authCode,
                    code_verifier: codeVerifier
                },
                xform: (0, $fb7af5ea5edbf7d2$export$273fe4673a018c2e)
            });
            await (0, $851629df92f77955$export$d35c645d585317ec)(this.storage, `${this.storageKey}-code-verifier`);
            if (error) throw error;
            if (!data || !data.session || !data.user) return {
                data: {
                    user: null,
                    session: null,
                    redirectType: null
                },
                error: new (0, $23e204244b27914e$export$7e277b620449c1b4)()
            };
            if (data.session) {
                await this._saveSession(data.session);
                await this._notifyAllSubscribers('SIGNED_IN', data.session);
            }
            return {
                data: Object.assign(Object.assign({}, data), {
                    redirectType: redirectType !== null && redirectType !== void 0 ? redirectType : null
                }),
                error: error
            };
        } catch (error) {
            if ((0, $23e204244b27914e$export$cde1786a482f9a1c)(error)) return {
                data: {
                    user: null,
                    session: null,
                    redirectType: null
                },
                error: error
            };
            throw error;
        }
    }
    /**
     * Allows signing in with an OIDC ID token. The authentication provider used
     * should be enabled and configured.
     */ async signInWithIdToken(credentials) {
        try {
            const { options: options, provider: provider, token: token, access_token: access_token, nonce: nonce } = credentials;
            const res = await (0, $fb7af5ea5edbf7d2$export$8969b3850ca2cdfd)(this.fetch, 'POST', `${this.url}/token?grant_type=id_token`, {
                headers: this.headers,
                body: {
                    provider: provider,
                    id_token: token,
                    access_token: access_token,
                    nonce: nonce,
                    gotrue_meta_security: {
                        captcha_token: options === null || options === void 0 ? void 0 : options.captchaToken
                    }
                },
                xform: (0, $fb7af5ea5edbf7d2$export$273fe4673a018c2e)
            });
            const { data: data, error: error } = res;
            if (error) return {
                data: {
                    user: null,
                    session: null
                },
                error: error
            };
            else if (!data || !data.session || !data.user) return {
                data: {
                    user: null,
                    session: null
                },
                error: new (0, $23e204244b27914e$export$7e277b620449c1b4)()
            };
            if (data.session) {
                await this._saveSession(data.session);
                await this._notifyAllSubscribers('SIGNED_IN', data.session);
            }
            return {
                data: data,
                error: error
            };
        } catch (error) {
            if ((0, $23e204244b27914e$export$cde1786a482f9a1c)(error)) return {
                data: {
                    user: null,
                    session: null
                },
                error: error
            };
            throw error;
        }
    }
    /**
     * Log in a user using magiclink or a one-time password (OTP).
     *
     * If the `{{ .ConfirmationURL }}` variable is specified in the email template, a magiclink will be sent.
     * If the `{{ .Token }}` variable is specified in the email template, an OTP will be sent.
     * If you're using phone sign-ins, only an OTP will be sent. You won't be able to send a magiclink for phone sign-ins.
     *
     * Be aware that you may get back an error message that will not distinguish
     * between the cases where the account does not exist or, that the account
     * can only be accessed via social login.
     *
     * Do note that you will need to configure a Whatsapp sender on Twilio
     * if you are using phone sign in with the 'whatsapp' channel. The whatsapp
     * channel is not supported on other providers
     * at this time.
     * This method supports PKCE when an email is passed.
     */ async signInWithOtp(credentials) {
        var _a, _b, _c, _d, _e;
        try {
            if ('email' in credentials) {
                const { email: email, options: options } = credentials;
                let codeChallenge = null;
                let codeChallengeMethod = null;
                if (this.flowType === 'pkce') [codeChallenge, codeChallengeMethod] = await (0, $851629df92f77955$export$81b177cadfcf873c)(this.storage, this.storageKey);
                const { error: error } = await (0, $fb7af5ea5edbf7d2$export$8969b3850ca2cdfd)(this.fetch, 'POST', `${this.url}/otp`, {
                    headers: this.headers,
                    body: {
                        email: email,
                        data: (_a = options === null || options === void 0 ? void 0 : options.data) !== null && _a !== void 0 ? _a : {},
                        create_user: (_b = options === null || options === void 0 ? void 0 : options.shouldCreateUser) !== null && _b !== void 0 ? _b : true,
                        gotrue_meta_security: {
                            captcha_token: options === null || options === void 0 ? void 0 : options.captchaToken
                        },
                        code_challenge: codeChallenge,
                        code_challenge_method: codeChallengeMethod
                    },
                    redirectTo: options === null || options === void 0 ? void 0 : options.emailRedirectTo
                });
                return {
                    data: {
                        user: null,
                        session: null
                    },
                    error: error
                };
            }
            if ('phone' in credentials) {
                const { phone: phone, options: options } = credentials;
                const { data: data, error: error } = await (0, $fb7af5ea5edbf7d2$export$8969b3850ca2cdfd)(this.fetch, 'POST', `${this.url}/otp`, {
                    headers: this.headers,
                    body: {
                        phone: phone,
                        data: (_c = options === null || options === void 0 ? void 0 : options.data) !== null && _c !== void 0 ? _c : {},
                        create_user: (_d = options === null || options === void 0 ? void 0 : options.shouldCreateUser) !== null && _d !== void 0 ? _d : true,
                        gotrue_meta_security: {
                            captcha_token: options === null || options === void 0 ? void 0 : options.captchaToken
                        },
                        channel: (_e = options === null || options === void 0 ? void 0 : options.channel) !== null && _e !== void 0 ? _e : 'sms'
                    }
                });
                return {
                    data: {
                        user: null,
                        session: null,
                        messageId: data === null || data === void 0 ? void 0 : data.message_id
                    },
                    error: error
                };
            }
            throw new (0, $23e204244b27914e$export$9ef583f0381b4cc)('You must provide either an email or phone number.');
        } catch (error) {
            if ((0, $23e204244b27914e$export$cde1786a482f9a1c)(error)) return {
                data: {
                    user: null,
                    session: null
                },
                error: error
            };
            throw error;
        }
    }
    /**
     * Log in a user given a User supplied OTP or TokenHash received through mobile or email.
     */ async verifyOtp(params) {
        var _a, _b;
        try {
            let redirectTo = undefined;
            let captchaToken = undefined;
            if ('options' in params) {
                redirectTo = (_a = params.options) === null || _a === void 0 ? void 0 : _a.redirectTo;
                captchaToken = (_b = params.options) === null || _b === void 0 ? void 0 : _b.captchaToken;
            }
            const { data: data, error: error } = await (0, $fb7af5ea5edbf7d2$export$8969b3850ca2cdfd)(this.fetch, 'POST', `${this.url}/verify`, {
                headers: this.headers,
                body: Object.assign(Object.assign({}, params), {
                    gotrue_meta_security: {
                        captcha_token: captchaToken
                    }
                }),
                redirectTo: redirectTo,
                xform: (0, $fb7af5ea5edbf7d2$export$273fe4673a018c2e)
            });
            if (error) throw error;
            if (!data) throw new Error('An error occurred on token verification.');
            const session = data.session;
            const user = data.user;
            if (session === null || session === void 0 ? void 0 : session.access_token) {
                await this._saveSession(session);
                await this._notifyAllSubscribers(params.type == 'recovery' ? 'PASSWORD_RECOVERY' : 'SIGNED_IN', session);
            }
            return {
                data: {
                    user: user,
                    session: session
                },
                error: null
            };
        } catch (error) {
            if ((0, $23e204244b27914e$export$cde1786a482f9a1c)(error)) return {
                data: {
                    user: null,
                    session: null
                },
                error: error
            };
            throw error;
        }
    }
    /**
     * Attempts a single-sign on using an enterprise Identity Provider. A
     * successful SSO attempt will redirect the current page to the identity
     * provider authorization page. The redirect URL is implementation and SSO
     * protocol specific.
     *
     * You can use it by providing a SSO domain. Typically you can extract this
     * domain by asking users for their email address. If this domain is
     * registered on the Auth instance the redirect will use that organization's
     * currently active SSO Identity Provider for the login.
     *
     * If you have built an organization-specific login page, you can use the
     * organization's SSO Identity Provider UUID directly instead.
     */ async signInWithSSO(params) {
        var _a, _b, _c;
        try {
            let codeChallenge = null;
            let codeChallengeMethod = null;
            if (this.flowType === 'pkce') [codeChallenge, codeChallengeMethod] = await (0, $851629df92f77955$export$81b177cadfcf873c)(this.storage, this.storageKey);
            return await (0, $fb7af5ea5edbf7d2$export$8969b3850ca2cdfd)(this.fetch, 'POST', `${this.url}/sso`, {
                body: Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, 'providerId' in params ? {
                    provider_id: params.providerId
                } : null), 'domain' in params ? {
                    domain: params.domain
                } : null), {
                    redirect_to: (_b = (_a = params.options) === null || _a === void 0 ? void 0 : _a.redirectTo) !== null && _b !== void 0 ? _b : undefined
                }), ((_c = params === null || params === void 0 ? void 0 : params.options) === null || _c === void 0 ? void 0 : _c.captchaToken) ? {
                    gotrue_meta_security: {
                        captcha_token: params.options.captchaToken
                    }
                } : null), {
                    skip_http_redirect: true,
                    code_challenge: codeChallenge,
                    code_challenge_method: codeChallengeMethod
                }),
                headers: this.headers,
                xform: (0, $fb7af5ea5edbf7d2$export$b04785c46dcd8f8b)
            });
        } catch (error) {
            if ((0, $23e204244b27914e$export$cde1786a482f9a1c)(error)) return {
                data: null,
                error: error
            };
            throw error;
        }
    }
    /**
     * Sends a reauthentication OTP to the user's email or phone number.
     * Requires the user to be signed-in.
     */ async reauthenticate() {
        await this.initializePromise;
        return await this._acquireLock(-1, async ()=>{
            return await this._reauthenticate();
        });
    }
    async _reauthenticate() {
        try {
            return await this._useSession(async (result)=>{
                const { data: { session: session }, error: sessionError } = result;
                if (sessionError) throw sessionError;
                if (!session) throw new (0, $23e204244b27914e$export$403b3fc0d3ad5f0c)();
                const { error: error } = await (0, $fb7af5ea5edbf7d2$export$8969b3850ca2cdfd)(this.fetch, 'GET', `${this.url}/reauthenticate`, {
                    headers: this.headers,
                    jwt: session.access_token
                });
                return {
                    data: {
                        user: null,
                        session: null
                    },
                    error: error
                };
            });
        } catch (error) {
            if ((0, $23e204244b27914e$export$cde1786a482f9a1c)(error)) return {
                data: {
                    user: null,
                    session: null
                },
                error: error
            };
            throw error;
        }
    }
    /**
     * Resends an existing signup confirmation email, email change email, SMS OTP or phone change OTP.
     */ async resend(credentials) {
        try {
            const endpoint = `${this.url}/resend`;
            if ('email' in credentials) {
                const { email: email, type: type, options: options } = credentials;
                const { error: error } = await (0, $fb7af5ea5edbf7d2$export$8969b3850ca2cdfd)(this.fetch, 'POST', endpoint, {
                    headers: this.headers,
                    body: {
                        email: email,
                        type: type,
                        gotrue_meta_security: {
                            captcha_token: options === null || options === void 0 ? void 0 : options.captchaToken
                        }
                    },
                    redirectTo: options === null || options === void 0 ? void 0 : options.emailRedirectTo
                });
                return {
                    data: {
                        user: null,
                        session: null
                    },
                    error: error
                };
            } else if ('phone' in credentials) {
                const { phone: phone, type: type, options: options } = credentials;
                const { data: data, error: error } = await (0, $fb7af5ea5edbf7d2$export$8969b3850ca2cdfd)(this.fetch, 'POST', endpoint, {
                    headers: this.headers,
                    body: {
                        phone: phone,
                        type: type,
                        gotrue_meta_security: {
                            captcha_token: options === null || options === void 0 ? void 0 : options.captchaToken
                        }
                    }
                });
                return {
                    data: {
                        user: null,
                        session: null,
                        messageId: data === null || data === void 0 ? void 0 : data.message_id
                    },
                    error: error
                };
            }
            throw new (0, $23e204244b27914e$export$9ef583f0381b4cc)('You must provide either an email or phone number and a type');
        } catch (error) {
            if ((0, $23e204244b27914e$export$cde1786a482f9a1c)(error)) return {
                data: {
                    user: null,
                    session: null
                },
                error: error
            };
            throw error;
        }
    }
    /**
     * Returns the session, refreshing it if necessary.
     *
     * The session returned can be null if the session is not detected which can happen in the event a user is not signed-in or has logged out.
     *
     * **IMPORTANT:** This method loads values directly from the storage attached
     * to the client. If that storage is based on request cookies for example,
     * the values in it may not be authentic and therefore it's strongly advised
     * against using this method and its results in such circumstances. A warning
     * will be emitted if this is detected. Use {@link #getUser()} instead.
     */ async getSession() {
        await this.initializePromise;
        const result = await this._acquireLock(-1, async ()=>{
            return this._useSession(async (result)=>{
                return result;
            });
        });
        return result;
    }
    /**
     * Acquires a global lock based on the storage key.
     */ async _acquireLock(acquireTimeout, fn) {
        this._debug('#_acquireLock', 'begin', acquireTimeout);
        try {
            if (this.lockAcquired) {
                const last = this.pendingInLock.length ? this.pendingInLock[this.pendingInLock.length - 1] : Promise.resolve();
                const result = (async ()=>{
                    await last;
                    return await fn();
                })();
                this.pendingInLock.push((async ()=>{
                    try {
                        await result;
                    } catch (e) {
                    // we just care if it finished
                    }
                })());
                return result;
            }
            return await this.lock(`lock:${this.storageKey}`, acquireTimeout, async ()=>{
                this._debug('#_acquireLock', 'lock acquired for storage key', this.storageKey);
                try {
                    this.lockAcquired = true;
                    const result = fn();
                    this.pendingInLock.push((async ()=>{
                        try {
                            await result;
                        } catch (e) {
                        // we just care if it finished
                        }
                    })());
                    await result;
                    // keep draining the queue until there's nothing to wait on
                    while(this.pendingInLock.length){
                        const waitOn = [
                            ...this.pendingInLock
                        ];
                        await Promise.all(waitOn);
                        this.pendingInLock.splice(0, waitOn.length);
                    }
                    return await result;
                } finally{
                    this._debug('#_acquireLock', 'lock released for storage key', this.storageKey);
                    this.lockAcquired = false;
                }
            });
        } finally{
            this._debug('#_acquireLock', 'end');
        }
    }
    /**
     * Use instead of {@link #getSession} inside the library. It is
     * semantically usually what you want, as getting a session involves some
     * processing afterwards that requires only one client operating on the
     * session at once across multiple tabs or processes.
     */ async _useSession(fn) {
        this._debug('#_useSession', 'begin');
        try {
            // the use of __loadSession here is the only correct use of the function!
            const result = await this.__loadSession();
            return await fn(result);
        } finally{
            this._debug('#_useSession', 'end');
        }
    }
    /**
     * NEVER USE DIRECTLY!
     *
     * Always use {@link #_useSession}.
     */ async __loadSession() {
        this._debug('#__loadSession()', 'begin');
        if (!this.lockAcquired) this._debug('#__loadSession()', 'used outside of an acquired lock!', new Error().stack);
        try {
            let currentSession = null;
            const maybeSession = await (0, $851629df92f77955$export$ba6fcb7c333d32c0)(this.storage, this.storageKey);
            this._debug('#getSession()', 'session from storage', maybeSession);
            if (maybeSession !== null) {
                if (this._isValidSession(maybeSession)) currentSession = maybeSession;
                else {
                    this._debug('#getSession()', 'session from storage is not valid');
                    await this._removeSession();
                }
            }
            if (!currentSession) return {
                data: {
                    session: null
                },
                error: null
            };
            // A session is considered expired before the access token _actually_
            // expires. When the autoRefreshToken option is off (or when the tab is
            // in the background), very eager users of getSession() -- like
            // realtime-js -- might send a valid JWT which will expire by the time it
            // reaches the server.
            const hasExpired = currentSession.expires_at ? currentSession.expires_at * 1000 - Date.now() < (0, $9242f83a1032aa7a$export$a36ad0026e55ac00) : false;
            this._debug('#__loadSession()', `session has${hasExpired ? '' : ' not'} expired`, 'expires_at', currentSession.expires_at);
            if (!hasExpired) {
                if (this.storage.isServer) {
                    let suppressWarning = this.suppressGetSessionWarning;
                    const proxySession = new Proxy(currentSession, {
                        get: (target, prop, receiver)=>{
                            if (!suppressWarning && prop === 'user') {
                                // only show warning when the user object is being accessed from the server
                                console.warn('Using the user object as returned from supabase.auth.getSession() or from some supabase.auth.onAuthStateChange() events could be insecure! This value comes directly from the storage medium (usually cookies on the server) and may not be authentic. Use supabase.auth.getUser() instead which authenticates the data by contacting the Supabase Auth server.');
                                suppressWarning = true; // keeps this proxy instance from logging additional warnings
                                this.suppressGetSessionWarning = true; // keeps this client's future proxy instances from warning
                            }
                            return Reflect.get(target, prop, receiver);
                        }
                    });
                    currentSession = proxySession;
                }
                return {
                    data: {
                        session: currentSession
                    },
                    error: null
                };
            }
            const { session: session, error: error } = await this._callRefreshToken(currentSession.refresh_token);
            if (error) return {
                data: {
                    session: null
                },
                error: error
            };
            return {
                data: {
                    session: session
                },
                error: null
            };
        } finally{
            this._debug('#__loadSession()', 'end');
        }
    }
    /**
     * Gets the current user details if there is an existing session. This method
     * performs a network request to the Supabase Auth server, so the returned
     * value is authentic and can be used to base authorization rules on.
     *
     * @param jwt Takes in an optional access token JWT. If no JWT is provided, the JWT from the current session is used.
     */ async getUser(jwt) {
        if (jwt) return await this._getUser(jwt);
        await this.initializePromise;
        const result = await this._acquireLock(-1, async ()=>{
            return await this._getUser();
        });
        return result;
    }
    async _getUser(jwt) {
        try {
            if (jwt) return await (0, $fb7af5ea5edbf7d2$export$8969b3850ca2cdfd)(this.fetch, 'GET', `${this.url}/user`, {
                headers: this.headers,
                jwt: jwt,
                xform: (0, $fb7af5ea5edbf7d2$export$e20f488897843593)
            });
            return await this._useSession(async (result)=>{
                var _a, _b, _c;
                const { data: data, error: error } = result;
                if (error) throw error;
                // returns an error if there is no access_token or custom authorization header
                if (!((_a = data.session) === null || _a === void 0 ? void 0 : _a.access_token) && !this.hasCustomAuthorizationHeader) return {
                    data: {
                        user: null
                    },
                    error: new (0, $23e204244b27914e$export$403b3fc0d3ad5f0c)()
                };
                return await (0, $fb7af5ea5edbf7d2$export$8969b3850ca2cdfd)(this.fetch, 'GET', `${this.url}/user`, {
                    headers: this.headers,
                    jwt: (_c = (_b = data.session) === null || _b === void 0 ? void 0 : _b.access_token) !== null && _c !== void 0 ? _c : undefined,
                    xform: (0, $fb7af5ea5edbf7d2$export$e20f488897843593)
                });
            });
        } catch (error) {
            if ((0, $23e204244b27914e$export$cde1786a482f9a1c)(error)) {
                if ((0, $23e204244b27914e$export$3e849aa4db565c1d)(error)) {
                    // JWT contains a `session_id` which does not correspond to an active
                    // session in the database, indicating the user is signed out.
                    await this._removeSession();
                    await (0, $851629df92f77955$export$d35c645d585317ec)(this.storage, `${this.storageKey}-code-verifier`);
                }
                return {
                    data: {
                        user: null
                    },
                    error: error
                };
            }
            throw error;
        }
    }
    /**
     * Updates user data for a logged in user.
     */ async updateUser(attributes, options = {}) {
        await this.initializePromise;
        return await this._acquireLock(-1, async ()=>{
            return await this._updateUser(attributes, options);
        });
    }
    async _updateUser(attributes, options = {}) {
        try {
            return await this._useSession(async (result)=>{
                const { data: sessionData, error: sessionError } = result;
                if (sessionError) throw sessionError;
                if (!sessionData.session) throw new (0, $23e204244b27914e$export$403b3fc0d3ad5f0c)();
                const session = sessionData.session;
                let codeChallenge = null;
                let codeChallengeMethod = null;
                if (this.flowType === 'pkce' && attributes.email != null) [codeChallenge, codeChallengeMethod] = await (0, $851629df92f77955$export$81b177cadfcf873c)(this.storage, this.storageKey);
                const { data: data, error: userError } = await (0, $fb7af5ea5edbf7d2$export$8969b3850ca2cdfd)(this.fetch, 'PUT', `${this.url}/user`, {
                    headers: this.headers,
                    redirectTo: options === null || options === void 0 ? void 0 : options.emailRedirectTo,
                    body: Object.assign(Object.assign({}, attributes), {
                        code_challenge: codeChallenge,
                        code_challenge_method: codeChallengeMethod
                    }),
                    jwt: session.access_token,
                    xform: (0, $fb7af5ea5edbf7d2$export$e20f488897843593)
                });
                if (userError) throw userError;
                session.user = data.user;
                await this._saveSession(session);
                await this._notifyAllSubscribers('USER_UPDATED', session);
                return {
                    data: {
                        user: session.user
                    },
                    error: null
                };
            });
        } catch (error) {
            if ((0, $23e204244b27914e$export$cde1786a482f9a1c)(error)) return {
                data: {
                    user: null
                },
                error: error
            };
            throw error;
        }
    }
    /**
     * Sets the session data from the current session. If the current session is expired, setSession will take care of refreshing it to obtain a new session.
     * If the refresh token or access token in the current session is invalid, an error will be thrown.
     * @param currentSession The current session that minimally contains an access token and refresh token.
     */ async setSession(currentSession) {
        await this.initializePromise;
        return await this._acquireLock(-1, async ()=>{
            return await this._setSession(currentSession);
        });
    }
    async _setSession(currentSession) {
        try {
            if (!currentSession.access_token || !currentSession.refresh_token) throw new (0, $23e204244b27914e$export$403b3fc0d3ad5f0c)();
            const timeNow = Date.now() / 1000;
            let expiresAt = timeNow;
            let hasExpired = true;
            let session = null;
            const { payload: payload } = (0, $851629df92f77955$export$9a62e6c0a30e00bc)(currentSession.access_token);
            if (payload.exp) {
                expiresAt = payload.exp;
                hasExpired = expiresAt <= timeNow;
            }
            if (hasExpired) {
                const { session: refreshedSession, error: error } = await this._callRefreshToken(currentSession.refresh_token);
                if (error) return {
                    data: {
                        user: null,
                        session: null
                    },
                    error: error
                };
                if (!refreshedSession) return {
                    data: {
                        user: null,
                        session: null
                    },
                    error: null
                };
                session = refreshedSession;
            } else {
                const { data: data, error: error } = await this._getUser(currentSession.access_token);
                if (error) throw error;
                session = {
                    access_token: currentSession.access_token,
                    refresh_token: currentSession.refresh_token,
                    user: data.user,
                    token_type: 'bearer',
                    expires_in: expiresAt - timeNow,
                    expires_at: expiresAt
                };
                await this._saveSession(session);
                await this._notifyAllSubscribers('SIGNED_IN', session);
            }
            return {
                data: {
                    user: session.user,
                    session: session
                },
                error: null
            };
        } catch (error) {
            if ((0, $23e204244b27914e$export$cde1786a482f9a1c)(error)) return {
                data: {
                    session: null,
                    user: null
                },
                error: error
            };
            throw error;
        }
    }
    /**
     * Returns a new session, regardless of expiry status.
     * Takes in an optional current session. If not passed in, then refreshSession() will attempt to retrieve it from getSession().
     * If the current session's refresh token is invalid, an error will be thrown.
     * @param currentSession The current session. If passed in, it must contain a refresh token.
     */ async refreshSession(currentSession) {
        await this.initializePromise;
        return await this._acquireLock(-1, async ()=>{
            return await this._refreshSession(currentSession);
        });
    }
    async _refreshSession(currentSession) {
        try {
            return await this._useSession(async (result)=>{
                var _a;
                if (!currentSession) {
                    const { data: data, error: error } = result;
                    if (error) throw error;
                    currentSession = (_a = data.session) !== null && _a !== void 0 ? _a : undefined;
                }
                if (!(currentSession === null || currentSession === void 0 ? void 0 : currentSession.refresh_token)) throw new (0, $23e204244b27914e$export$403b3fc0d3ad5f0c)();
                const { session: session, error: error } = await this._callRefreshToken(currentSession.refresh_token);
                if (error) return {
                    data: {
                        user: null,
                        session: null
                    },
                    error: error
                };
                if (!session) return {
                    data: {
                        user: null,
                        session: null
                    },
                    error: null
                };
                return {
                    data: {
                        user: session.user,
                        session: session
                    },
                    error: null
                };
            });
        } catch (error) {
            if ((0, $23e204244b27914e$export$cde1786a482f9a1c)(error)) return {
                data: {
                    user: null,
                    session: null
                },
                error: error
            };
            throw error;
        }
    }
    /**
     * Gets the session data from a URL string
     */ async _getSessionFromURL(params, callbackUrlType) {
        try {
            if (!(0, $851629df92f77955$export$4e09c449d6c407f7)()) throw new (0, $23e204244b27914e$export$bf5df8e043856ef5)('No browser detected.');
            // If there's an error in the URL, it doesn't matter what flow it is, we just return the error.
            if (params.error || params.error_description || params.error_code) // The error class returned implies that the redirect is from an implicit grant flow
            // but it could also be from a redirect error from a PKCE flow.
            throw new (0, $23e204244b27914e$export$bf5df8e043856ef5)(params.error_description || 'Error in URL with unspecified error_description', {
                error: params.error || 'unspecified_error',
                code: params.error_code || 'unspecified_code'
            });
            // Checks for mismatches between the flowType initialised in the client and the URL parameters
            switch(callbackUrlType){
                case 'implicit':
                    if (this.flowType === 'pkce') throw new (0, $23e204244b27914e$export$39583657eb2a7027)('Not a valid PKCE flow url.');
                    break;
                case 'pkce':
                    if (this.flowType === 'implicit') throw new (0, $23e204244b27914e$export$bf5df8e043856ef5)('Not a valid implicit grant flow url.');
                    break;
                default:
            }
            // Since this is a redirect for PKCE, we attempt to retrieve the code from the URL for the code exchange
            if (callbackUrlType === 'pkce') {
                this._debug('#_initialize()', 'begin', 'is PKCE flow', true);
                if (!params.code) throw new (0, $23e204244b27914e$export$39583657eb2a7027)('No code detected.');
                const { data: data, error: error } = await this._exchangeCodeForSession(params.code);
                if (error) throw error;
                const url = new URL(window.location.href);
                url.searchParams.delete('code');
                window.history.replaceState(window.history.state, '', url.toString());
                return {
                    data: {
                        session: data.session,
                        redirectType: null
                    },
                    error: null
                };
            }
            const { provider_token: provider_token, provider_refresh_token: provider_refresh_token, access_token: access_token, refresh_token: refresh_token, expires_in: expires_in, expires_at: expires_at, token_type: token_type } = params;
            if (!access_token || !expires_in || !refresh_token || !token_type) throw new (0, $23e204244b27914e$export$bf5df8e043856ef5)('No session defined in URL');
            const timeNow = Math.round(Date.now() / 1000);
            const expiresIn = parseInt(expires_in);
            let expiresAt = timeNow + expiresIn;
            if (expires_at) expiresAt = parseInt(expires_at);
            const actuallyExpiresIn = expiresAt - timeNow;
            if (actuallyExpiresIn * 1000 <= (0, $9242f83a1032aa7a$export$a4558fee79d6c8ae)) console.warn(`@supabase/gotrue-js: Session as retrieved from URL expires in ${actuallyExpiresIn}s, should have been closer to ${expiresIn}s`);
            const issuedAt = expiresAt - expiresIn;
            if (timeNow - issuedAt >= 120) console.warn('@supabase/gotrue-js: Session as retrieved from URL was issued over 120s ago, URL could be stale', issuedAt, expiresAt, timeNow);
            else if (timeNow - issuedAt < 0) console.warn('@supabase/gotrue-js: Session as retrieved from URL was issued in the future? Check the device clock for skew', issuedAt, expiresAt, timeNow);
            const { data: data, error: error } = await this._getUser(access_token);
            if (error) throw error;
            const session = {
                provider_token: provider_token,
                provider_refresh_token: provider_refresh_token,
                access_token: access_token,
                expires_in: expiresIn,
                expires_at: expiresAt,
                refresh_token: refresh_token,
                token_type: token_type,
                user: data.user
            };
            // Remove tokens from URL
            window.location.hash = '';
            this._debug('#_getSessionFromURL()', 'clearing window.location.hash');
            return {
                data: {
                    session: session,
                    redirectType: params.type
                },
                error: null
            };
        } catch (error) {
            if ((0, $23e204244b27914e$export$cde1786a482f9a1c)(error)) return {
                data: {
                    session: null,
                    redirectType: null
                },
                error: error
            };
            throw error;
        }
    }
    /**
     * Checks if the current URL contains parameters given by an implicit oauth grant flow (https://www.rfc-editor.org/rfc/rfc6749.html#section-4.2)
     */ _isImplicitGrantCallback(params) {
        return Boolean(params.access_token || params.error_description);
    }
    /**
     * Checks if the current URL and backing storage contain parameters given by a PKCE flow
     */ async _isPKCECallback(params) {
        const currentStorageContent = await (0, $851629df92f77955$export$ba6fcb7c333d32c0)(this.storage, `${this.storageKey}-code-verifier`);
        return !!(params.code && currentStorageContent);
    }
    /**
     * Inside a browser context, `signOut()` will remove the logged in user from the browser session and log them out - removing all items from localstorage and then trigger a `"SIGNED_OUT"` event.
     *
     * For server-side management, you can revoke all refresh tokens for a user by passing a user's JWT through to `auth.api.signOut(JWT: string)`.
     * There is no way to revoke a user's access token jwt until it expires. It is recommended to set a shorter expiry on the jwt for this reason.
     *
     * If using `others` scope, no `SIGNED_OUT` event is fired!
     */ async signOut(options = {
        scope: 'global'
    }) {
        await this.initializePromise;
        return await this._acquireLock(-1, async ()=>{
            return await this._signOut(options);
        });
    }
    async _signOut({ scope: scope } = {
        scope: 'global'
    }) {
        return await this._useSession(async (result)=>{
            var _a;
            const { data: data, error: sessionError } = result;
            if (sessionError) return {
                error: sessionError
            };
            const accessToken = (_a = data.session) === null || _a === void 0 ? void 0 : _a.access_token;
            if (accessToken) {
                const { error: error } = await this.admin.signOut(accessToken, scope);
                if (error) {
                    // ignore 404s since user might not exist anymore
                    // ignore 401s since an invalid or expired JWT should sign out the current session
                    if (!((0, $23e204244b27914e$export$4fe744aeb810d543)(error) && (error.status === 404 || error.status === 401 || error.status === 403))) return {
                        error: error
                    };
                }
            }
            if (scope !== 'others') {
                await this._removeSession();
                await (0, $851629df92f77955$export$d35c645d585317ec)(this.storage, `${this.storageKey}-code-verifier`);
            }
            return {
                error: null
            };
        });
    }
    /**
     * Receive a notification every time an auth event happens.
     * @param callback A callback function to be invoked when an auth event happens.
     */ onAuthStateChange(callback) {
        const id = (0, $851629df92f77955$export$31b40729666a4ae0)();
        const subscription = {
            id: id,
            callback: callback,
            unsubscribe: ()=>{
                this._debug('#unsubscribe()', 'state change callback with id removed', id);
                this.stateChangeEmitters.delete(id);
            }
        };
        this._debug('#onAuthStateChange()', 'registered callback with id', id);
        this.stateChangeEmitters.set(id, subscription);
        (async ()=>{
            await this.initializePromise;
            await this._acquireLock(-1, async ()=>{
                this._emitInitialSession(id);
            });
        })();
        return {
            data: {
                subscription: subscription
            }
        };
    }
    async _emitInitialSession(id) {
        return await this._useSession(async (result)=>{
            var _a, _b;
            try {
                const { data: { session: session }, error: error } = result;
                if (error) throw error;
                await ((_a = this.stateChangeEmitters.get(id)) === null || _a === void 0 ? void 0 : _a.callback('INITIAL_SESSION', session));
                this._debug('INITIAL_SESSION', 'callback id', id, 'session', session);
            } catch (err) {
                await ((_b = this.stateChangeEmitters.get(id)) === null || _b === void 0 ? void 0 : _b.callback('INITIAL_SESSION', null));
                this._debug('INITIAL_SESSION', 'callback id', id, 'error', err);
                console.error(err);
            }
        });
    }
    /**
     * Sends a password reset request to an email address. This method supports the PKCE flow.
     *
     * @param email The email address of the user.
     * @param options.redirectTo The URL to send the user to after they click the password reset link.
     * @param options.captchaToken Verification token received when the user completes the captcha on the site.
     */ async resetPasswordForEmail(email, options = {}) {
        let codeChallenge = null;
        let codeChallengeMethod = null;
        if (this.flowType === 'pkce') [codeChallenge, codeChallengeMethod] = await (0, $851629df92f77955$export$81b177cadfcf873c)(this.storage, this.storageKey, true // isPasswordRecovery
        );
        try {
            return await (0, $fb7af5ea5edbf7d2$export$8969b3850ca2cdfd)(this.fetch, 'POST', `${this.url}/recover`, {
                body: {
                    email: email,
                    code_challenge: codeChallenge,
                    code_challenge_method: codeChallengeMethod,
                    gotrue_meta_security: {
                        captcha_token: options.captchaToken
                    }
                },
                headers: this.headers,
                redirectTo: options.redirectTo
            });
        } catch (error) {
            if ((0, $23e204244b27914e$export$cde1786a482f9a1c)(error)) return {
                data: null,
                error: error
            };
            throw error;
        }
    }
    /**
     * Gets all the identities linked to a user.
     */ async getUserIdentities() {
        var _a;
        try {
            const { data: data, error: error } = await this.getUser();
            if (error) throw error;
            return {
                data: {
                    identities: (_a = data.user.identities) !== null && _a !== void 0 ? _a : []
                },
                error: null
            };
        } catch (error) {
            if ((0, $23e204244b27914e$export$cde1786a482f9a1c)(error)) return {
                data: null,
                error: error
            };
            throw error;
        }
    }
    /**
     * Links an oauth identity to an existing user.
     * This method supports the PKCE flow.
     */ async linkIdentity(credentials) {
        var _a;
        try {
            const { data: data, error: error } = await this._useSession(async (result)=>{
                var _a, _b, _c, _d, _e;
                const { data: data, error: error } = result;
                if (error) throw error;
                const url = await this._getUrlForProvider(`${this.url}/user/identities/authorize`, credentials.provider, {
                    redirectTo: (_a = credentials.options) === null || _a === void 0 ? void 0 : _a.redirectTo,
                    scopes: (_b = credentials.options) === null || _b === void 0 ? void 0 : _b.scopes,
                    queryParams: (_c = credentials.options) === null || _c === void 0 ? void 0 : _c.queryParams,
                    skipBrowserRedirect: true
                });
                return await (0, $fb7af5ea5edbf7d2$export$8969b3850ca2cdfd)(this.fetch, 'GET', url, {
                    headers: this.headers,
                    jwt: (_e = (_d = data.session) === null || _d === void 0 ? void 0 : _d.access_token) !== null && _e !== void 0 ? _e : undefined
                });
            });
            if (error) throw error;
            if ((0, $851629df92f77955$export$4e09c449d6c407f7)() && !((_a = credentials.options) === null || _a === void 0 ? void 0 : _a.skipBrowserRedirect)) window.location.assign(data === null || data === void 0 ? void 0 : data.url);
            return {
                data: {
                    provider: credentials.provider,
                    url: data === null || data === void 0 ? void 0 : data.url
                },
                error: null
            };
        } catch (error) {
            if ((0, $23e204244b27914e$export$cde1786a482f9a1c)(error)) return {
                data: {
                    provider: credentials.provider,
                    url: null
                },
                error: error
            };
            throw error;
        }
    }
    /**
     * Unlinks an identity from a user by deleting it. The user will no longer be able to sign in with that identity once it's unlinked.
     */ async unlinkIdentity(identity) {
        try {
            return await this._useSession(async (result)=>{
                var _a, _b;
                const { data: data, error: error } = result;
                if (error) throw error;
                return await (0, $fb7af5ea5edbf7d2$export$8969b3850ca2cdfd)(this.fetch, 'DELETE', `${this.url}/user/identities/${identity.identity_id}`, {
                    headers: this.headers,
                    jwt: (_b = (_a = data.session) === null || _a === void 0 ? void 0 : _a.access_token) !== null && _b !== void 0 ? _b : undefined
                });
            });
        } catch (error) {
            if ((0, $23e204244b27914e$export$cde1786a482f9a1c)(error)) return {
                data: null,
                error: error
            };
            throw error;
        }
    }
    /**
     * Generates a new JWT.
     * @param refreshToken A valid refresh token that was returned on login.
     */ async _refreshAccessToken(refreshToken) {
        const debugName = `#_refreshAccessToken(${refreshToken.substring(0, 5)}...)`;
        this._debug(debugName, 'begin');
        try {
            const startedAt = Date.now();
            // will attempt to refresh the token with exponential backoff
            return await (0, $851629df92f77955$export$9e1b8e833f44ff21)(async (attempt)=>{
                if (attempt > 0) await (0, $851629df92f77955$export$e772c8ff12451969)(200 * Math.pow(2, attempt - 1)); // 200, 400, 800, ...
                this._debug(debugName, 'refreshing attempt', attempt);
                return await (0, $fb7af5ea5edbf7d2$export$8969b3850ca2cdfd)(this.fetch, 'POST', `${this.url}/token?grant_type=refresh_token`, {
                    body: {
                        refresh_token: refreshToken
                    },
                    headers: this.headers,
                    xform: (0, $fb7af5ea5edbf7d2$export$273fe4673a018c2e)
                });
            }, (attempt, error)=>{
                const nextBackOffInterval = 200 * Math.pow(2, attempt);
                return error && (0, $23e204244b27914e$export$a77af358da5fb874)(error) && // retryable only if the request can be sent before the backoff overflows the tick duration
                Date.now() + nextBackOffInterval - startedAt < (0, $9242f83a1032aa7a$export$a4558fee79d6c8ae);
            });
        } catch (error) {
            this._debug(debugName, 'error', error);
            if ((0, $23e204244b27914e$export$cde1786a482f9a1c)(error)) return {
                data: {
                    session: null,
                    user: null
                },
                error: error
            };
            throw error;
        } finally{
            this._debug(debugName, 'end');
        }
    }
    _isValidSession(maybeSession) {
        const isValidSession = typeof maybeSession === 'object' && maybeSession !== null && 'access_token' in maybeSession && 'refresh_token' in maybeSession && 'expires_at' in maybeSession;
        return isValidSession;
    }
    async _handleProviderSignIn(provider, options) {
        const url = await this._getUrlForProvider(`${this.url}/authorize`, provider, {
            redirectTo: options.redirectTo,
            scopes: options.scopes,
            queryParams: options.queryParams
        });
        this._debug('#_handleProviderSignIn()', 'provider', provider, 'options', options, 'url', url);
        // try to open on the browser
        if ((0, $851629df92f77955$export$4e09c449d6c407f7)() && !options.skipBrowserRedirect) window.location.assign(url);
        return {
            data: {
                provider: provider,
                url: url
            },
            error: null
        };
    }
    /**
     * Recovers the session from LocalStorage and refreshes the token
     * Note: this method is async to accommodate for AsyncStorage e.g. in React native.
     */ async _recoverAndRefresh() {
        var _a;
        const debugName = '#_recoverAndRefresh()';
        this._debug(debugName, 'begin');
        try {
            const currentSession = await (0, $851629df92f77955$export$ba6fcb7c333d32c0)(this.storage, this.storageKey);
            this._debug(debugName, 'session from storage', currentSession);
            if (!this._isValidSession(currentSession)) {
                this._debug(debugName, 'session is not valid');
                if (currentSession !== null) await this._removeSession();
                return;
            }
            const expiresWithMargin = ((_a = currentSession.expires_at) !== null && _a !== void 0 ? _a : Infinity) * 1000 - Date.now() < (0, $9242f83a1032aa7a$export$a36ad0026e55ac00);
            this._debug(debugName, `session has${expiresWithMargin ? '' : ' not'} expired with margin of ${(0, $9242f83a1032aa7a$export$a36ad0026e55ac00)}s`);
            if (expiresWithMargin) {
                if (this.autoRefreshToken && currentSession.refresh_token) {
                    const { error: error } = await this._callRefreshToken(currentSession.refresh_token);
                    if (error) {
                        console.error(error);
                        if (!(0, $23e204244b27914e$export$a77af358da5fb874)(error)) {
                            this._debug(debugName, 'refresh failed with a non-retryable error, removing the session', error);
                            await this._removeSession();
                        }
                    }
                }
            } else // no need to persist currentSession again, as we just loaded it from
            // local storage; persisting it again may overwrite a value saved by
            // another client with access to the same local storage
            await this._notifyAllSubscribers('SIGNED_IN', currentSession);
        } catch (err) {
            this._debug(debugName, 'error', err);
            console.error(err);
            return;
        } finally{
            this._debug(debugName, 'end');
        }
    }
    async _callRefreshToken(refreshToken) {
        var _a, _b;
        if (!refreshToken) throw new (0, $23e204244b27914e$export$403b3fc0d3ad5f0c)();
        // refreshing is already in progress
        if (this.refreshingDeferred) return this.refreshingDeferred.promise;
        const debugName = `#_callRefreshToken(${refreshToken.substring(0, 5)}...)`;
        this._debug(debugName, 'begin');
        try {
            this.refreshingDeferred = new (0, $851629df92f77955$export$85f6557964517f1a)();
            const { data: data, error: error } = await this._refreshAccessToken(refreshToken);
            if (error) throw error;
            if (!data.session) throw new (0, $23e204244b27914e$export$403b3fc0d3ad5f0c)();
            await this._saveSession(data.session);
            await this._notifyAllSubscribers('TOKEN_REFRESHED', data.session);
            const result = {
                session: data.session,
                error: null
            };
            this.refreshingDeferred.resolve(result);
            return result;
        } catch (error) {
            this._debug(debugName, 'error', error);
            if ((0, $23e204244b27914e$export$cde1786a482f9a1c)(error)) {
                const result = {
                    session: null,
                    error: error
                };
                if (!(0, $23e204244b27914e$export$a77af358da5fb874)(error)) await this._removeSession();
                (_a = this.refreshingDeferred) === null || _a === void 0 || _a.resolve(result);
                return result;
            }
            (_b = this.refreshingDeferred) === null || _b === void 0 || _b.reject(error);
            throw error;
        } finally{
            this.refreshingDeferred = null;
            this._debug(debugName, 'end');
        }
    }
    async _notifyAllSubscribers(event, session, broadcast = true) {
        const debugName = `#_notifyAllSubscribers(${event})`;
        this._debug(debugName, 'begin', session, `broadcast = ${broadcast}`);
        try {
            if (this.broadcastChannel && broadcast) this.broadcastChannel.postMessage({
                event: event,
                session: session
            });
            const errors = [];
            const promises = Array.from(this.stateChangeEmitters.values()).map(async (x)=>{
                try {
                    await x.callback(event, session);
                } catch (e) {
                    errors.push(e);
                }
            });
            await Promise.all(promises);
            if (errors.length > 0) {
                for(let i = 0; i < errors.length; i += 1)console.error(errors[i]);
                throw errors[0];
            }
        } finally{
            this._debug(debugName, 'end');
        }
    }
    /**
     * set currentSession and currentUser
     * process to _startAutoRefreshToken if possible
     */ async _saveSession(session) {
        this._debug('#_saveSession()', session);
        // _saveSession is always called whenever a new session has been acquired
        // so we can safely suppress the warning returned by future getSession calls
        this.suppressGetSessionWarning = true;
        await (0, $851629df92f77955$export$e82c36d29078a87f)(this.storage, this.storageKey, session);
    }
    async _removeSession() {
        this._debug('#_removeSession()');
        await (0, $851629df92f77955$export$d35c645d585317ec)(this.storage, this.storageKey);
        await this._notifyAllSubscribers('SIGNED_OUT', null);
    }
    /**
     * Removes any registered visibilitychange callback.
     *
     * {@see #startAutoRefresh}
     * {@see #stopAutoRefresh}
     */ _removeVisibilityChangedCallback() {
        this._debug('#_removeVisibilityChangedCallback()');
        const callback = this.visibilityChangedCallback;
        this.visibilityChangedCallback = null;
        try {
            if (callback && (0, $851629df92f77955$export$4e09c449d6c407f7)() && (window === null || window === void 0 ? void 0 : window.removeEventListener)) window.removeEventListener('visibilitychange', callback);
        } catch (e) {
            console.error('removing visibilitychange callback failed', e);
        }
    }
    /**
     * This is the private implementation of {@link #startAutoRefresh}. Use this
     * within the library.
     */ async _startAutoRefresh() {
        await this._stopAutoRefresh();
        this._debug('#_startAutoRefresh()');
        const ticker = setInterval(()=>this._autoRefreshTokenTick(), (0, $9242f83a1032aa7a$export$a4558fee79d6c8ae));
        this.autoRefreshTicker = ticker;
        if (ticker && typeof ticker === 'object' && typeof ticker.unref === 'function') // ticker is a NodeJS Timeout object that has an `unref` method
        // https://nodejs.org/api/timers.html#timeoutunref
        // When auto refresh is used in NodeJS (like for testing) the
        // `setInterval` is preventing the process from being marked as
        // finished and tests run endlessly. This can be prevented by calling
        // `unref()` on the returned object.
        ticker.unref();
        else if (typeof Deno !== 'undefined' && typeof Deno.unrefTimer === 'function') // similar like for NodeJS, but with the Deno API
        // https://deno.land/api@latest?unstable&s=Deno.unrefTimer
        // @ts-expect-error TS has no context of Deno
        Deno.unrefTimer(ticker);
        // run the tick immediately, but in the next pass of the event loop so that
        // #_initialize can be allowed to complete without recursively waiting on
        // itself
        setTimeout(async ()=>{
            await this.initializePromise;
            await this._autoRefreshTokenTick();
        }, 0);
    }
    /**
     * This is the private implementation of {@link #stopAutoRefresh}. Use this
     * within the library.
     */ async _stopAutoRefresh() {
        this._debug('#_stopAutoRefresh()');
        const ticker = this.autoRefreshTicker;
        this.autoRefreshTicker = null;
        if (ticker) clearInterval(ticker);
    }
    /**
     * Starts an auto-refresh process in the background. The session is checked
     * every few seconds. Close to the time of expiration a process is started to
     * refresh the session. If refreshing fails it will be retried for as long as
     * necessary.
     *
     * If you set the {@link GoTrueClientOptions#autoRefreshToken} you don't need
     * to call this function, it will be called for you.
     *
     * On browsers the refresh process works only when the tab/window is in the
     * foreground to conserve resources as well as prevent race conditions and
     * flooding auth with requests. If you call this method any managed
     * visibility change callback will be removed and you must manage visibility
     * changes on your own.
     *
     * On non-browser platforms the refresh process works *continuously* in the
     * background, which may not be desirable. You should hook into your
     * platform's foreground indication mechanism and call these methods
     * appropriately to conserve resources.
     *
     * {@see #stopAutoRefresh}
     */ async startAutoRefresh() {
        this._removeVisibilityChangedCallback();
        await this._startAutoRefresh();
    }
    /**
     * Stops an active auto refresh process running in the background (if any).
     *
     * If you call this method any managed visibility change callback will be
     * removed and you must manage visibility changes on your own.
     *
     * See {@link #startAutoRefresh} for more details.
     */ async stopAutoRefresh() {
        this._removeVisibilityChangedCallback();
        await this._stopAutoRefresh();
    }
    /**
     * Runs the auto refresh token tick.
     */ async _autoRefreshTokenTick() {
        this._debug('#_autoRefreshTokenTick()', 'begin');
        try {
            await this._acquireLock(0, async ()=>{
                try {
                    const now = Date.now();
                    try {
                        return await this._useSession(async (result)=>{
                            const { data: { session: session } } = result;
                            if (!session || !session.refresh_token || !session.expires_at) {
                                this._debug('#_autoRefreshTokenTick()', 'no session');
                                return;
                            }
                            // session will expire in this many ticks (or has already expired if <= 0)
                            const expiresInTicks = Math.floor((session.expires_at * 1000 - now) / (0, $9242f83a1032aa7a$export$a4558fee79d6c8ae));
                            this._debug('#_autoRefreshTokenTick()', `access token expires in ${expiresInTicks} ticks, a tick lasts ${(0, $9242f83a1032aa7a$export$a4558fee79d6c8ae)}ms, refresh threshold is ${(0, $9242f83a1032aa7a$export$f20a97df8f5fe223)} ticks`);
                            if (expiresInTicks <= (0, $9242f83a1032aa7a$export$f20a97df8f5fe223)) await this._callRefreshToken(session.refresh_token);
                        });
                    } catch (e) {
                        console.error('Auto refresh tick failed with error. This is likely a transient error.', e);
                    }
                } finally{
                    this._debug('#_autoRefreshTokenTick()', 'end');
                }
            });
        } catch (e) {
            if (e.isAcquireTimeout || e instanceof (0, $b1040c32bf2597eb$export$23e9464cc010dff9)) this._debug('auto refresh token tick lock not available');
            else throw e;
        }
    }
    /**
     * Registers callbacks on the browser / platform, which in-turn run
     * algorithms when the browser window/tab are in foreground. On non-browser
     * platforms it assumes always foreground.
     */ async _handleVisibilityChange() {
        this._debug('#_handleVisibilityChange()');
        if (!(0, $851629df92f77955$export$4e09c449d6c407f7)() || !(window === null || window === void 0 ? void 0 : window.addEventListener)) {
            if (this.autoRefreshToken) // in non-browser environments the refresh token ticker runs always
            this.startAutoRefresh();
            return false;
        }
        try {
            this.visibilityChangedCallback = async ()=>await this._onVisibilityChanged(false);
            window === null || window === void 0 || window.addEventListener('visibilitychange', this.visibilityChangedCallback);
            // now immediately call the visbility changed callback to setup with the
            // current visbility state
            await this._onVisibilityChanged(true); // initial call
        } catch (error) {
            console.error('_handleVisibilityChange', error);
        }
    }
    /**
     * Callback registered with `window.addEventListener('visibilitychange')`.
     */ async _onVisibilityChanged(calledFromInitialize) {
        const methodName = `#_onVisibilityChanged(${calledFromInitialize})`;
        this._debug(methodName, 'visibilityState', document.visibilityState);
        if (document.visibilityState === 'visible') {
            if (this.autoRefreshToken) // in browser environments the refresh token ticker runs only on focused tabs
            // which prevents race conditions
            this._startAutoRefresh();
            if (!calledFromInitialize) {
                // called when the visibility has changed, i.e. the browser
                // transitioned from hidden -> visible so we need to see if the session
                // should be recovered immediately... but to do that we need to acquire
                // the lock first asynchronously
                await this.initializePromise;
                await this._acquireLock(-1, async ()=>{
                    if (document.visibilityState !== 'visible') {
                        this._debug(methodName, 'acquired the lock to recover the session, but the browser visibilityState is no longer visible, aborting');
                        // visibility has changed while waiting for the lock, abort
                        return;
                    }
                    // recover the session
                    await this._recoverAndRefresh();
                });
            }
        } else if (document.visibilityState === 'hidden') {
            if (this.autoRefreshToken) this._stopAutoRefresh();
        }
    }
    /**
     * Generates the relevant login URL for a third-party provider.
     * @param options.redirectTo A URL or mobile address to send the user to after they are confirmed.
     * @param options.scopes A space-separated list of scopes granted to the OAuth application.
     * @param options.queryParams An object of key-value pairs containing query parameters granted to the OAuth application.
     */ async _getUrlForProvider(url, provider, options) {
        const urlParams = [
            `provider=${encodeURIComponent(provider)}`
        ];
        if (options === null || options === void 0 ? void 0 : options.redirectTo) urlParams.push(`redirect_to=${encodeURIComponent(options.redirectTo)}`);
        if (options === null || options === void 0 ? void 0 : options.scopes) urlParams.push(`scopes=${encodeURIComponent(options.scopes)}`);
        if (this.flowType === 'pkce') {
            const [codeChallenge, codeChallengeMethod] = await (0, $851629df92f77955$export$81b177cadfcf873c)(this.storage, this.storageKey);
            const flowParams = new URLSearchParams({
                code_challenge: `${encodeURIComponent(codeChallenge)}`,
                code_challenge_method: `${encodeURIComponent(codeChallengeMethod)}`
            });
            urlParams.push(flowParams.toString());
        }
        if (options === null || options === void 0 ? void 0 : options.queryParams) {
            const query = new URLSearchParams(options.queryParams);
            urlParams.push(query.toString());
        }
        if (options === null || options === void 0 ? void 0 : options.skipBrowserRedirect) urlParams.push(`skip_http_redirect=${options.skipBrowserRedirect}`);
        return `${url}?${urlParams.join('&')}`;
    }
    async _unenroll(params) {
        try {
            return await this._useSession(async (result)=>{
                var _a;
                const { data: sessionData, error: sessionError } = result;
                if (sessionError) return {
                    data: null,
                    error: sessionError
                };
                return await (0, $fb7af5ea5edbf7d2$export$8969b3850ca2cdfd)(this.fetch, 'DELETE', `${this.url}/factors/${params.factorId}`, {
                    headers: this.headers,
                    jwt: (_a = sessionData === null || sessionData === void 0 ? void 0 : sessionData.session) === null || _a === void 0 ? void 0 : _a.access_token
                });
            });
        } catch (error) {
            if ((0, $23e204244b27914e$export$cde1786a482f9a1c)(error)) return {
                data: null,
                error: error
            };
            throw error;
        }
    }
    async _enroll(params) {
        try {
            return await this._useSession(async (result)=>{
                var _a, _b;
                const { data: sessionData, error: sessionError } = result;
                if (sessionError) return {
                    data: null,
                    error: sessionError
                };
                const body = Object.assign({
                    friendly_name: params.friendlyName,
                    factor_type: params.factorType
                }, params.factorType === 'phone' ? {
                    phone: params.phone
                } : {
                    issuer: params.issuer
                });
                const { data: data, error: error } = await (0, $fb7af5ea5edbf7d2$export$8969b3850ca2cdfd)(this.fetch, 'POST', `${this.url}/factors`, {
                    body: body,
                    headers: this.headers,
                    jwt: (_a = sessionData === null || sessionData === void 0 ? void 0 : sessionData.session) === null || _a === void 0 ? void 0 : _a.access_token
                });
                if (error) return {
                    data: null,
                    error: error
                };
                if (params.factorType === 'totp' && ((_b = data === null || data === void 0 ? void 0 : data.totp) === null || _b === void 0 ? void 0 : _b.qr_code)) data.totp.qr_code = `data:image/svg+xml;utf-8,${data.totp.qr_code}`;
                return {
                    data: data,
                    error: null
                };
            });
        } catch (error) {
            if ((0, $23e204244b27914e$export$cde1786a482f9a1c)(error)) return {
                data: null,
                error: error
            };
            throw error;
        }
    }
    /**
     * {@see GoTrueMFAApi#verify}
     */ async _verify(params) {
        return this._acquireLock(-1, async ()=>{
            try {
                return await this._useSession(async (result)=>{
                    var _a;
                    const { data: sessionData, error: sessionError } = result;
                    if (sessionError) return {
                        data: null,
                        error: sessionError
                    };
                    const { data: data, error: error } = await (0, $fb7af5ea5edbf7d2$export$8969b3850ca2cdfd)(this.fetch, 'POST', `${this.url}/factors/${params.factorId}/verify`, {
                        body: {
                            code: params.code,
                            challenge_id: params.challengeId
                        },
                        headers: this.headers,
                        jwt: (_a = sessionData === null || sessionData === void 0 ? void 0 : sessionData.session) === null || _a === void 0 ? void 0 : _a.access_token
                    });
                    if (error) return {
                        data: null,
                        error: error
                    };
                    await this._saveSession(Object.assign({
                        expires_at: Math.round(Date.now() / 1000) + data.expires_in
                    }, data));
                    await this._notifyAllSubscribers('MFA_CHALLENGE_VERIFIED', data);
                    return {
                        data: data,
                        error: error
                    };
                });
            } catch (error) {
                if ((0, $23e204244b27914e$export$cde1786a482f9a1c)(error)) return {
                    data: null,
                    error: error
                };
                throw error;
            }
        });
    }
    /**
     * {@see GoTrueMFAApi#challenge}
     */ async _challenge(params) {
        return this._acquireLock(-1, async ()=>{
            try {
                return await this._useSession(async (result)=>{
                    var _a;
                    const { data: sessionData, error: sessionError } = result;
                    if (sessionError) return {
                        data: null,
                        error: sessionError
                    };
                    return await (0, $fb7af5ea5edbf7d2$export$8969b3850ca2cdfd)(this.fetch, 'POST', `${this.url}/factors/${params.factorId}/challenge`, {
                        body: {
                            channel: params.channel
                        },
                        headers: this.headers,
                        jwt: (_a = sessionData === null || sessionData === void 0 ? void 0 : sessionData.session) === null || _a === void 0 ? void 0 : _a.access_token
                    });
                });
            } catch (error) {
                if ((0, $23e204244b27914e$export$cde1786a482f9a1c)(error)) return {
                    data: null,
                    error: error
                };
                throw error;
            }
        });
    }
    /**
     * {@see GoTrueMFAApi#challengeAndVerify}
     */ async _challengeAndVerify(params) {
        // both _challenge and _verify independently acquire the lock, so no need
        // to acquire it here
        const { data: challengeData, error: challengeError } = await this._challenge({
            factorId: params.factorId
        });
        if (challengeError) return {
            data: null,
            error: challengeError
        };
        return await this._verify({
            factorId: params.factorId,
            challengeId: challengeData.id,
            code: params.code
        });
    }
    /**
     * {@see GoTrueMFAApi#listFactors}
     */ async _listFactors() {
        // use #getUser instead of #_getUser as the former acquires a lock
        const { data: { user: user }, error: userError } = await this.getUser();
        if (userError) return {
            data: null,
            error: userError
        };
        const factors = (user === null || user === void 0 ? void 0 : user.factors) || [];
        const totp = factors.filter((factor)=>factor.factor_type === 'totp' && factor.status === 'verified');
        const phone = factors.filter((factor)=>factor.factor_type === 'phone' && factor.status === 'verified');
        return {
            data: {
                all: factors,
                totp: totp,
                phone: phone
            },
            error: null
        };
    }
    /**
     * {@see GoTrueMFAApi#getAuthenticatorAssuranceLevel}
     */ async _getAuthenticatorAssuranceLevel() {
        return this._acquireLock(-1, async ()=>{
            return await this._useSession(async (result)=>{
                var _a, _b;
                const { data: { session: session }, error: sessionError } = result;
                if (sessionError) return {
                    data: null,
                    error: sessionError
                };
                if (!session) return {
                    data: {
                        currentLevel: null,
                        nextLevel: null,
                        currentAuthenticationMethods: []
                    },
                    error: null
                };
                const { payload: payload } = (0, $851629df92f77955$export$9a62e6c0a30e00bc)(session.access_token);
                let currentLevel = null;
                if (payload.aal) currentLevel = payload.aal;
                let nextLevel = currentLevel;
                const verifiedFactors = (_b = (_a = session.user.factors) === null || _a === void 0 ? void 0 : _a.filter((factor)=>factor.status === 'verified')) !== null && _b !== void 0 ? _b : [];
                if (verifiedFactors.length > 0) nextLevel = 'aal2';
                const currentAuthenticationMethods = payload.amr || [];
                return {
                    data: {
                        currentLevel: currentLevel,
                        nextLevel: nextLevel,
                        currentAuthenticationMethods: currentAuthenticationMethods
                    },
                    error: null
                };
            });
        });
    }
    async fetchJwk(kid, jwks = {
        keys: []
    }) {
        // try fetching from the supplied jwks
        let jwk = jwks.keys.find((key)=>key.kid === kid);
        if (jwk) return jwk;
        // try fetching from cache
        jwk = this.jwks.keys.find((key)=>key.kid === kid);
        // jwk exists and jwks isn't stale
        if (jwk && this.jwks_cached_at + (0, $9242f83a1032aa7a$export$5bd768495200f133) > Date.now()) return jwk;
        // jwk isn't cached in memory so we need to fetch it from the well-known endpoint
        const { data: data, error: error } = await (0, $fb7af5ea5edbf7d2$export$8969b3850ca2cdfd)(this.fetch, 'GET', `${this.url}/.well-known/jwks.json`, {
            headers: this.headers
        });
        if (error) throw error;
        if (!data.keys || data.keys.length === 0) throw new (0, $23e204244b27914e$export$d04cb18528f2043e)('JWKS is empty');
        this.jwks = data;
        this.jwks_cached_at = Date.now();
        // Find the signing key
        jwk = data.keys.find((key)=>key.kid === kid);
        if (!jwk) throw new (0, $23e204244b27914e$export$d04cb18528f2043e)('No matching signing key found in JWKS');
        return jwk;
    }
    /**
     * @experimental This method may change in future versions.
     * @description Gets the claims from a JWT. If the JWT is symmetric JWTs, it will call getUser() to verify against the server. If the JWT is asymmetric, it will be verified against the JWKS using the WebCrypto API.
     */ async getClaims(jwt, jwks = {
        keys: []
    }) {
        try {
            let token = jwt;
            if (!token) {
                const { data: data, error: error } = await this.getSession();
                if (error || !data.session) return {
                    data: null,
                    error: error
                };
                token = data.session.access_token;
            }
            const { header: header, payload: payload, signature: signature, raw: { header: rawHeader, payload: rawPayload } } = (0, $851629df92f77955$export$9a62e6c0a30e00bc)(token);
            // Reject expired JWTs
            (0, $851629df92f77955$export$a5850868adeb9253)(payload.exp);
            // If symmetric algorithm or WebCrypto API is unavailable, fallback to getUser()
            if (!header.kid || header.alg === 'HS256' || !('crypto' in globalThis && 'subtle' in globalThis.crypto)) {
                const { error: error } = await this.getUser(token);
                if (error) throw error;
                // getUser succeeds so the claims in the JWT can be trusted
                return {
                    data: {
                        claims: payload,
                        header: header,
                        signature: signature
                    },
                    error: null
                };
            }
            const algorithm = (0, $851629df92f77955$export$fa59f625ab60cb91)(header.alg);
            const signingKey = await this.fetchJwk(header.kid, jwks);
            // Convert JWK to CryptoKey
            const publicKey = await crypto.subtle.importKey('jwk', signingKey, algorithm, true, [
                'verify'
            ]);
            // Verify the signature
            const isValid = await crypto.subtle.verify(algorithm, publicKey, signature, (0, $d7ec53d3b9daae46$export$a098e7b533f96db3)(`${rawHeader}.${rawPayload}`));
            if (!isValid) throw new (0, $23e204244b27914e$export$d04cb18528f2043e)('Invalid JWT signature');
            // If verification succeeds, decode and return claims
            return {
                data: {
                    claims: payload,
                    header: header,
                    signature: signature
                },
                error: null
            };
        } catch (error) {
            if ((0, $23e204244b27914e$export$cde1786a482f9a1c)(error)) return {
                data: null,
                error: error
            };
            throw error;
        }
    }
    /**
     * Create a new client for use in the browser.
     */ constructor(options){
        var _a, _b;
        this.memoryStorage = null;
        this.stateChangeEmitters = new Map();
        this.autoRefreshTicker = null;
        this.visibilityChangedCallback = null;
        this.refreshingDeferred = null;
        /**
         * Keeps track of the async client initialization.
         * When null or not yet resolved the auth state is `unknown`
         * Once resolved the the auth state is known and it's save to call any further client methods.
         * Keep extra care to never reject or throw uncaught errors
         */ this.initializePromise = null;
        this.detectSessionInUrl = true;
        this.hasCustomAuthorizationHeader = false;
        this.suppressGetSessionWarning = false;
        this.lockAcquired = false;
        this.pendingInLock = [];
        /**
         * Used to broadcast state change events to other tabs listening.
         */ this.broadcastChannel = null;
        this.logger = console.log;
        this.instanceID = $060b3eed510a76bb$export$2e2bcd8739ae039.nextInstanceID;
        $060b3eed510a76bb$export$2e2bcd8739ae039.nextInstanceID += 1;
        if (this.instanceID > 0 && (0, $851629df92f77955$export$4e09c449d6c407f7)()) console.warn('Multiple GoTrueClient instances detected in the same browser context. It is not an error, but this should be avoided as it may produce undefined behavior when used concurrently under the same storage key.');
        const settings = Object.assign(Object.assign({}, $060b3eed510a76bb$var$DEFAULT_OPTIONS), options);
        this.logDebugMessages = !!settings.debug;
        if (typeof settings.debug === 'function') this.logger = settings.debug;
        this.persistSession = settings.persistSession;
        this.storageKey = settings.storageKey;
        this.autoRefreshToken = settings.autoRefreshToken;
        this.admin = new (0, $22cc145af22a62fe$export$2e2bcd8739ae039)({
            url: settings.url,
            headers: settings.headers,
            fetch: settings.fetch
        });
        this.url = settings.url;
        this.headers = settings.headers;
        this.fetch = (0, $851629df92f77955$export$98d92b1aa79f8cc7)(settings.fetch);
        this.lock = settings.lock || $060b3eed510a76bb$var$lockNoOp;
        this.detectSessionInUrl = settings.detectSessionInUrl;
        this.flowType = settings.flowType;
        this.hasCustomAuthorizationHeader = settings.hasCustomAuthorizationHeader;
        if (settings.lock) this.lock = settings.lock;
        else if ((0, $851629df92f77955$export$4e09c449d6c407f7)() && ((_a = globalThis === null || globalThis === void 0 ? void 0 : globalThis.navigator) === null || _a === void 0 ? void 0 : _a.locks)) this.lock = (0, $b1040c32bf2597eb$export$f4ff21938fb7af3c);
        else this.lock = $060b3eed510a76bb$var$lockNoOp;
        this.jwks = {
            keys: []
        };
        this.jwks_cached_at = Number.MIN_SAFE_INTEGER;
        this.mfa = {
            verify: this._verify.bind(this),
            enroll: this._enroll.bind(this),
            unenroll: this._unenroll.bind(this),
            challenge: this._challenge.bind(this),
            listFactors: this._listFactors.bind(this),
            challengeAndVerify: this._challengeAndVerify.bind(this),
            getAuthenticatorAssuranceLevel: this._getAuthenticatorAssuranceLevel.bind(this)
        };
        if (this.persistSession) {
            if (settings.storage) this.storage = settings.storage;
            else if ((0, $851629df92f77955$export$9ec034ee80211814)()) this.storage = (0, $313fd1bd7f8b7ad9$export$bba7b6c94612d04b);
            else {
                this.memoryStorage = {};
                this.storage = (0, $313fd1bd7f8b7ad9$export$d791f66d7e5710cf)(this.memoryStorage);
            }
        } else {
            this.memoryStorage = {};
            this.storage = (0, $313fd1bd7f8b7ad9$export$d791f66d7e5710cf)(this.memoryStorage);
        }
        if ((0, $851629df92f77955$export$4e09c449d6c407f7)() && globalThis.BroadcastChannel && this.persistSession && this.storageKey) {
            try {
                this.broadcastChannel = new globalThis.BroadcastChannel(this.storageKey);
            } catch (e) {
                console.error('Failed to create a new BroadcastChannel, multi-tab state changes will not be available', e);
            }
            (_b = this.broadcastChannel) === null || _b === void 0 || _b.addEventListener('message', async (event)=>{
                this._debug('received broadcast notification from other tab or client', event);
                await this._notifyAllSubscribers(event.data.event, event.data.session, false); // broadcast = false so we don't get an endless loop of messages
            });
        }
        this.initialize();
    }
}
$060b3eed510a76bb$export$2e2bcd8739ae039.nextInstanceID = 0;



const $7fb8e4ac9f507473$var$AuthAdminApi = (0, $22cc145af22a62fe$export$2e2bcd8739ae039);
var $7fb8e4ac9f507473$export$2e2bcd8739ae039 = $7fb8e4ac9f507473$var$AuthAdminApi;



const $daee0ff6560bd5d8$var$AuthClient = (0, $060b3eed510a76bb$export$2e2bcd8739ae039);
var $daee0ff6560bd5d8$export$2e2bcd8739ae039 = $daee0ff6560bd5d8$var$AuthClient;








class $b58d2c9c032caa6c$export$8199a418bb09bd56 extends (0, $daee0ff6560bd5d8$export$2e2bcd8739ae039) {
    constructor(options){
        super(options);
    }
}


var $834df9e44c1b14f5$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
class $834df9e44c1b14f5$export$2e2bcd8739ae039 {
    /**
     * Supabase Functions allows you to deploy and invoke edge functions.
     */ get functions() {
        return new (0, $9532b5b75d740796$export$1d0b400bf8a0fa55)(this.functionsUrl, {
            headers: this.headers,
            customFetch: this.fetch
        });
    }
    /**
     * Supabase Storage allows you to manage user-generated content, such as photos or videos.
     */ get storage() {
        return new (0, $ae1ec3d8e6babc3e$export$6c85f5032e75eff9)(this.storageUrl, this.headers, this.fetch);
    }
    /**
     * Perform a query on a table or a view.
     *
     * @param relation - The table or view name to query
     */ from(relation) {
        return this.rest.from(relation);
    }
    // NOTE: signatures must be kept in sync with PostgrestClient.schema
    /**
     * Select a schema to query or perform an function (rpc) call.
     *
     * The schema needs to be on the list of exposed schemas inside Supabase.
     *
     * @param schema - The schema to query
     */ schema(schema) {
        return this.rest.schema(schema);
    }
    // NOTE: signatures must be kept in sync with PostgrestClient.rpc
    /**
     * Perform a function call.
     *
     * @param fn - The function name to call
     * @param args - The arguments to pass to the function call
     * @param options - Named parameters
     * @param options.head - When set to `true`, `data` will not be returned.
     * Useful if you only need the count.
     * @param options.get - When set to `true`, the function will be called with
     * read-only access mode.
     * @param options.count - Count algorithm to use to count rows returned by the
     * function. Only applicable for [set-returning
     * functions](https://www.postgresql.org/docs/current/functions-srf.html).
     *
     * `"exact"`: Exact but slow count algorithm. Performs a `COUNT(*)` under the
     * hood.
     *
     * `"planned"`: Approximated but fast count algorithm. Uses the Postgres
     * statistics under the hood.
     *
     * `"estimated"`: Uses exact count for low numbers and planned count for high
     * numbers.
     */ rpc(fn, args = {}, options = {}) {
        return this.rest.rpc(fn, args, options);
    }
    /**
     * Creates a Realtime channel with Broadcast, Presence, and Postgres Changes.
     *
     * @param {string} name - The name of the Realtime channel.
     * @param {Object} opts - The options to pass to the Realtime channel.
     *
     */ channel(name, opts = {
        config: {}
    }) {
        return this.realtime.channel(name, opts);
    }
    /**
     * Returns all Realtime channels.
     */ getChannels() {
        return this.realtime.getChannels();
    }
    /**
     * Unsubscribes and removes Realtime channel from Realtime client.
     *
     * @param {RealtimeChannel} channel - The name of the Realtime channel.
     *
     */ removeChannel(channel) {
        return this.realtime.removeChannel(channel);
    }
    /**
     * Unsubscribes and removes all Realtime channels from Realtime client.
     */ removeAllChannels() {
        return this.realtime.removeAllChannels();
    }
    _getAccessToken() {
        var _a, _b;
        return $834df9e44c1b14f5$var$__awaiter(this, void 0, void 0, function*() {
            if (this.accessToken) return yield this.accessToken();
            const { data: data } = yield this.auth.getSession();
            return (_b = (_a = data.session) === null || _a === void 0 ? void 0 : _a.access_token) !== null && _b !== void 0 ? _b : null;
        });
    }
    _initSupabaseAuthClient({ autoRefreshToken: autoRefreshToken, persistSession: persistSession, detectSessionInUrl: detectSessionInUrl, storage: storage, storageKey: storageKey, flowType: flowType, lock: lock, debug: debug }, headers, fetch) {
        const authHeaders = {
            Authorization: `Bearer ${this.supabaseKey}`,
            apikey: `${this.supabaseKey}`
        };
        return new (0, $b58d2c9c032caa6c$export$8199a418bb09bd56)({
            url: this.authUrl,
            headers: Object.assign(Object.assign({}, authHeaders), headers),
            storageKey: storageKey,
            autoRefreshToken: autoRefreshToken,
            persistSession: persistSession,
            detectSessionInUrl: detectSessionInUrl,
            storage: storage,
            flowType: flowType,
            lock: lock,
            debug: debug,
            fetch: fetch,
            // auth checks if there is a custom authorizaiton header using this flag
            // so it knows whether to return an error when getUser is called with no session
            hasCustomAuthorizationHeader: 'Authorization' in this.headers
        });
    }
    _initRealtimeClient(options) {
        return new (0, $79dca8bb970bd1bc$export$2e2bcd8739ae039)(this.realtimeUrl, Object.assign(Object.assign({}, options), {
            params: Object.assign({
                apikey: this.supabaseKey
            }, options === null || options === void 0 ? void 0 : options.params)
        }));
    }
    _listenForAuthEvents() {
        let data = this.auth.onAuthStateChange((event, session)=>{
            this._handleTokenChanged(event, 'CLIENT', session === null || session === void 0 ? void 0 : session.access_token);
        });
        return data;
    }
    _handleTokenChanged(event, source, token) {
        if ((event === 'TOKEN_REFRESHED' || event === 'SIGNED_IN') && this.changedAccessToken !== token) this.changedAccessToken = token;
        else if (event === 'SIGNED_OUT') {
            this.realtime.setAuth();
            if (source == 'STORAGE') this.auth.signOut();
            this.changedAccessToken = undefined;
        }
    }
    /**
     * Create a new client for use in the browser.
     * @param supabaseUrl The unique Supabase URL which is supplied when you create a new project in your project dashboard.
     * @param supabaseKey The unique Supabase Key which is supplied when you create a new project in your project dashboard.
     * @param options.db.schema You can switch in between schemas. The schema needs to be on the list of exposed schemas inside Supabase.
     * @param options.auth.autoRefreshToken Set to "true" if you want to automatically refresh the token before expiring.
     * @param options.auth.persistSession Set to "true" if you want to automatically save the user session into local storage.
     * @param options.auth.detectSessionInUrl Set to "true" if you want to automatically detects OAuth grants in the URL and signs in the user.
     * @param options.realtime Options passed along to realtime-js constructor.
     * @param options.global.fetch A custom fetch implementation.
     * @param options.global.headers Any additional headers to send with each network request.
     */ constructor(supabaseUrl, supabaseKey, options){
        var _a, _b, _c;
        this.supabaseUrl = supabaseUrl;
        this.supabaseKey = supabaseKey;
        if (!supabaseUrl) throw new Error('supabaseUrl is required.');
        if (!supabaseKey) throw new Error('supabaseKey is required.');
        const _supabaseUrl = (0, $4866e60a3003b032$export$d95b4586d238a081)(supabaseUrl);
        this.realtimeUrl = `${_supabaseUrl}/realtime/v1`.replace(/^http/i, 'ws');
        this.authUrl = `${_supabaseUrl}/auth/v1`;
        this.storageUrl = `${_supabaseUrl}/storage/v1`;
        this.functionsUrl = `${_supabaseUrl}/functions/v1`;
        // default storage key uses the supabase project ref as a namespace
        const defaultStorageKey = `sb-${new URL(this.authUrl).hostname.split('.')[0]}-auth-token`;
        const DEFAULTS = {
            db: (0, $629a1707574c5be4$export$b31378ae815bea6b),
            realtime: (0, $629a1707574c5be4$export$59685507ca0a3912),
            auth: Object.assign(Object.assign({}, (0, $629a1707574c5be4$export$af122550cc2345b3)), {
                storageKey: defaultStorageKey
            }),
            global: (0, $629a1707574c5be4$export$b63a5c3a2e5becd2)
        };
        const settings = (0, $4866e60a3003b032$export$da186dc3f8eace71)(options !== null && options !== void 0 ? options : {}, DEFAULTS);
        this.storageKey = (_a = settings.auth.storageKey) !== null && _a !== void 0 ? _a : '';
        this.headers = (_b = settings.global.headers) !== null && _b !== void 0 ? _b : {};
        if (!settings.accessToken) this.auth = this._initSupabaseAuthClient((_c = settings.auth) !== null && _c !== void 0 ? _c : {}, this.headers, settings.global.fetch);
        else {
            this.accessToken = settings.accessToken;
            this.auth = new Proxy({}, {
                get: (_, prop)=>{
                    throw new Error(`@supabase/supabase-js: Supabase Client is configured with the accessToken option, accessing supabase.auth.${String(prop)} is not possible`);
                }
            });
        }
        this.fetch = (0, $39db868b9e47c5c5$export$651dd5aef824521f)(supabaseKey, this._getAccessToken.bind(this), settings.global.fetch);
        this.realtime = this._initRealtimeClient(Object.assign({
            headers: this.headers,
            accessToken: this._getAccessToken.bind(this)
        }, settings.realtime));
        this.rest = new (0, $9d547cd278c5aefb$export$796f32e2ee984aaa)(`${_supabaseUrl}/rest/v1`, {
            headers: this.headers,
            schema: settings.db.schema,
            fetch: this.fetch
        });
        if (!settings.accessToken) this._listenForAuthEvents();
    }
}






const $ec241ebebf801734$export$5d730b7aed1a3eb0 = (supabaseUrl, supabaseKey, options)=>{
    return new (0, $834df9e44c1b14f5$export$2e2bcd8739ae039)(supabaseUrl, supabaseKey, options);
};


// Create a single supabase client for interacting with your database
const $70a97169caddc04c$var$supabase = (0, $ec241ebebf801734$export$5d730b7aed1a3eb0)("https://gvrefpegsgolavyjaswz.supabase.co", "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Imd2cmVmcGVnc2dvbGF2eWphc3d6Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3MzI5ODgyNjksImV4cCI6MjA0ODU2NDI2OX0.8CVLQwkgjXp0C4KzzDCiB7QZot6HLOrgAzsAgC-SL5E");
const $70a97169caddc04c$export$10bf54e825e44464 = async (currentLanguage = 'en')=>{
    let { data: data, error: error } = await $70a97169caddc04c$var$supabase.from('ads').select('*').eq("is_published", true);
    console.log(data, error);
    return data.map((ad)=>$70a97169caddc04c$var$getFieldsFilteredByLanguage(ad, currentLanguage));
};
const $70a97169caddc04c$export$2192e8c52b17d09e = async (currentLanguage = 'en')=>{
    let { data: data, error: error } = await $70a97169caddc04c$var$supabase.from('ads').select('*');
    return data.map((ad)=>$70a97169caddc04c$var$getFieldsFilteredByLanguage(ad, currentLanguage));
};
const $70a97169caddc04c$export$e335e813e295bb79 = async (id, currentLanguage = 'en')=>{
    let { data: data, error: error } = await $70a97169caddc04c$var$supabase.from('ads').select('*').eq('id', id);
    console.log(data, error);
    return $70a97169caddc04c$var$getFieldsFilteredByLanguage(data[0], currentLanguage);
};
const $70a97169caddc04c$var$getFieldsFilteredByLanguage = (ad, language)=>{
    if (language === 'ee') return {
        ...ad,
        title: ad.title_ee || ad.title,
        description: ad.description_ee || ad.description,
        addons: ad.addons_ee && ad.addons_ee.length ? ad.addons_ee : ad.addons,
        rules: ad.rules_ee && ad.rules_ee.length ? ad.rules_ee : ad.rules,
        price_includes: ad.price_includes_ee && ad.price_includes_ee.length ? ad.price_includes_ee : ad.price_includes
    };
    if (language === 'ru') return {
        ...ad,
        title: ad.title_ru || ad.title,
        description: ad.description_ru || ad.description,
        addons: ad.addons_ru && ad.addons_ru.length ? ad.addons_ru : ad.addons,
        rules: ad.rules_ru && ad.rules_ru.length ? ad.rules_ru : ad.rules,
        price_includes: ad.price_includes_ru && ad.price_includes_ru.length ? ad.price_includes_ru : ad.price_includes
    };
    return ad;
};



var $HGmne = parcelRequire("HGmne");


const $58d5e477c8f3715b$var$CustomButtonRootMobile = (0, $HGmne.default)((0, $95b3a1ef1ddc1e78$export$2e2bcd8739ae039))(({ theme: theme })=>`
    background: linear-gradient(135deg, rgb(234, 91, 112), rgb(255, 142, 158));
    border-radius: 12px;
    width: 100%;
    max-width: 300px;
    height: 52px;
    margin-top: 40px;
    color: white;
    font-weight: 600;
    font-size: 24px;
    padding: 20px 40px;
    font-family: ${theme.typography.fontFamily};
    text-transform: none;
    box-shadow: 0 4px 12px rgba(234, 91, 112, 0.4);
    transition: all 0.3s ease;
    display: flex;
    align-items: center;
    justify-content: space-between;

    &:hover {
      background: linear-gradient(135deg, rgb(255, 100, 130), rgb(255, 160, 180));
      box-shadow: 0 6px 18px rgba(234, 91, 112, 0.5);
      transform: translateY(-1px);
    }

    &:active {
      transform: translateY(0);
      box-shadow: 0 3px 8px rgba(234, 91, 112, 0.3);
    }
  `);
const $58d5e477c8f3715b$export$87e9c2ff338a8575 = ()=>{
    const [ads, setAdds] = (0, $gJYWc.useState)([]);
    const [selectedCity, setSelectedCity] = (0, $gJYWc.useState)("");
    const [selectedAge, setSelectedAge] = (0, $gJYWc.useState)("");
    const [selectedActivity, setSelectedActivity] = (0, $gJYWc.useState)("");
    const { i18n: i18n, t: t } = (0, $980e4b3a97f1ad67$export$9fc83ad70ead8663)();
    const currentLanguage = i18n.resolvedLanguage;
    const allCities = [
        ...new Set(ads.map((ad)=>ad.city).filter(Boolean))
    ];
    const allAges = [
        ...new Set(ads.map((ad)=>ad.age_tags).flat().filter(Boolean))
    ];
    const allActivities = [
        ...new Set(ads.map((ad)=>ad.activity_tags).flat().filter(Boolean))
    ];
    const navigate = (0, $a35327dc535bf969$export$9770f232ac06a008)();
    const onSearch = ()=>{
        navigate("/map", {
            state: {
                city: selectedCity,
                age: selectedAge,
                activity: selectedActivity
            }
        });
    };
    (0, $gJYWc.useEffect)(()=>{
        const fetchAds = async ()=>{
            const ads = await (0, $70a97169caddc04c$export$10bf54e825e44464)(currentLanguage);
            setAdds(ads);
        };
        fetchAds().catch(console.error);
    }, [
        currentLanguage
    ]);
    return /*#__PURE__*/ (0, $9wx12.jsxs)("div", {
        className: "flex w-full justify-center flex-wrap gap-x-3 gap-y-3",
        id: "selectors2",
        children: [
            /*#__PURE__*/ (0, $9wx12.jsx)((0, $5bb3c03eb951988c$export$820e4d34d59f5d7f), {
                onSearch: onSearch,
                selectedAge: selectedAge,
                ages: allAges,
                setAge: setSelectedAge,
                selectedActivity: selectedActivity,
                activities: allActivities,
                setActivity: setSelectedActivity,
                selectedCity: selectedCity,
                cities: allCities,
                setCity: setSelectedCity
            }),
            /*#__PURE__*/ (0, $9wx12.jsx)("div", {
                className: "lg:hidden",
                children: /*#__PURE__*/ (0, $9wx12.jsxs)($58d5e477c8f3715b$var$CustomButtonRootMobile, {
                    variant: "contained",
                    onClick: onSearch,
                    children: [
                        /*#__PURE__*/ (0, $9wx12.jsx)("span", {
                            className: "m-10",
                            children: t("selectors.find")
                        }),
                        /*#__PURE__*/ (0, $9wx12.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($7e951fd1c0b9fd8e$exports))), {
                            fontSize: "large"
                        })
                    ]
                })
            })
        ]
    });
};



var $9wx12 = parcelRequire("9wx12");
parcelRequire("gJYWc");


const $56201fc8fe14bcc5$export$a06f1c675e846f6f = ()=>{
    const { t: t } = (0, $980e4b3a97f1ad67$export$9fc83ad70ead8663)();
    return /*#__PURE__*/ (0, $9wx12.jsxs)("div", {
        className: "w-full bg-slate-900 p-11 text-white flex justify-between flex-wrap",
        id: "footer",
        children: [
            /*#__PURE__*/ (0, $9wx12.jsxs)("div", {
                className: "flex",
                children: [
                    /*#__PURE__*/ (0, $9wx12.jsx)("div", {
                        className: "mx-4",
                        children: /*#__PURE__*/ (0, $9wx12.jsx)((0, $8384e1b28fff68bc$export$a6c7ac8248d6e38a), {
                            to: "/contacts",
                            children: t("footer.contacts")
                        })
                    }),
                    /*#__PURE__*/ (0, $9wx12.jsx)("div", {
                        className: "mx-4",
                        children: /*#__PURE__*/ (0, $9wx12.jsx)((0, $8384e1b28fff68bc$export$a6c7ac8248d6e38a), {
                            to: "/terms",
                            children: t("footer.terms")
                        })
                    }),
                    /*#__PURE__*/ (0, $9wx12.jsx)("div", {
                        children: /*#__PURE__*/ (0, $9wx12.jsx)((0, $8384e1b28fff68bc$export$a6c7ac8248d6e38a), {
                            to: "/faq",
                            children: t("footer.faq")
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $9wx12.jsxs)("div", {
                className: "text-right mx-5 flex-1 mt-5 flex flex-col items-center md:block md:mt-0",
                children: [
                    /*#__PURE__*/ (0, $9wx12.jsx)("div", {
                        children: "\xae Trallid.ee"
                    }),
                    /*#__PURE__*/ (0, $9wx12.jsx)("div", {
                        children: "O\xdc Firm and steady"
                    }),
                    /*#__PURE__*/ (0, $9wx12.jsx)("div", {
                        children: "Reg. 17047649"
                    }),
                    /*#__PURE__*/ (0, $9wx12.jsx)("div", {
                        children: "Tallinn"
                    })
                ]
            })
        ]
    });
};




var $9wx12 = parcelRequire("9wx12");
parcelRequire("gJYWc");


var $9wx12 = parcelRequire("9wx12");
parcelRequire("gJYWc");

const $288bf61e202622b0$var$languages = {
    ee: {
        nativeName: "Eesti",
        icon: 'https://res.cloudinary.com/dhlzvktzj/image/upload/v1709304493/sunni/estonia_eklyi2.png'
    },
    en: {
        nativeName: "English",
        icon: 'https://res.cloudinary.com/dhlzvktzj/image/upload/v1709304493/sunni/united-kingdom_zko7rq.png'
    },
    ru: {
        nativeName: "\u0420\u0443\u0441\u0441\u043A\u0438\u0439",
        icon: 'https://res.cloudinary.com/dhlzvktzj/image/upload/v1709304493/sunni/russia_q7oosv.png'
    }
};
const $288bf61e202622b0$export$57776a505fcc1846 = ()=>{
    const { t: t, i18n: i18n } = (0, $980e4b3a97f1ad67$export$9fc83ad70ead8663)();
    return /*#__PURE__*/ (0, $9wx12.jsx)("div", {
        className: "flex",
        children: Object.keys($288bf61e202622b0$var$languages).map((lng)=>/*#__PURE__*/ (0, $9wx12.jsx)("div", {
                className: "w-[30px] h-[30px] bg-cover bg-center mr-2 cursor-pointer",
                style: {
                    backgroundImage: `url(${$288bf61e202622b0$var$languages[lng].icon})`
                },
                onClick: ()=>i18n.changeLanguage(lng)
            }, lng))
    });
};


const $fc72cc536184e560$export$8b251419efc915eb = ({ children: children, withBorder: withBorder })=>/*#__PURE__*/ (0, $9wx12.jsx)("header", {
        className: `min-h-20 items-center flex p-4 w-full ${withBorder ? 'shadow shadow-gray-10' : ''}`,
        children: /*#__PURE__*/ (0, $9wx12.jsxs)("nav", {
            className: "items-center flex w-full justify-between",
            children: [
                /*#__PURE__*/ (0, $9wx12.jsx)((0, $8384e1b28fff68bc$export$a6c7ac8248d6e38a), {
                    to: "/",
                    children: /*#__PURE__*/ (0, $9wx12.jsx)("div", {
                        className: "flex-1",
                        children: /*#__PURE__*/ (0, $9wx12.jsxs)("div", {
                            style: {
                                fontFamily: 'Cherry Bomb One'
                            },
                            className: "text-4xl flex justify-center items-center",
                            children: [
                                /*#__PURE__*/ (0, $9wx12.jsx)("div", {
                                    className: "w-[80px] h-[60px] bg-contain bg-center inline-block  bg-no-repeat",
                                    style: {
                                        backgroundImage: `url(https://res.cloudinary.com/dhlzvktzj/image/upload/v1710584946/sunni/stars2_jfrilw.png)`
                                    }
                                }),
                                "Trallid.ee"
                            ]
                        })
                    })
                }),
                /*#__PURE__*/ (0, $9wx12.jsx)("div", {
                    className: "flex-1",
                    children: children
                }),
                /*#__PURE__*/ (0, $9wx12.jsx)("div", {
                    className: "flex justify-end",
                    children: /*#__PURE__*/ (0, $9wx12.jsx)((0, $288bf61e202622b0$export$57776a505fcc1846), {})
                })
            ]
        })
    });


const $0c1b138fe2f5cc06$var$CARDS = [
    {
        key: 'bouldering',
        photoUrl: 'https://res.cloudinary.com/dhlzvktzj/image/upload/v1710586853/sunni/bouldering_hsus6e.jpg'
    },
    {
        key: 'paintball',
        photoUrl: 'https://res.cloudinary.com/dhlzvktzj/image/upload/v1710586853/sunni/paintball_onxx8z.jpg'
    },
    {
        key: 'escape-rooms',
        photoUrl: 'https://res.cloudinary.com/dhlzvktzj/image/upload/v1710586842/sunni/escaperoom_m4gf8j.jpg'
    },
    {
        key: 'kids-play-rooms',
        photoUrl: 'https://res.cloudinary.com/dhlzvktzj/image/upload/v1710586844/sunni/mangutube_zpmv7e.jpg'
    },
    {
        key: 'museums',
        photoUrl: 'https://res.cloudinary.com/dhlzvktzj/image/upload/v1710586846/sunni/museum_jd4knr.jpg'
    },
    {
        key: 'outside',
        photoUrl: 'https://res.cloudinary.com/dhlzvktzj/image/upload/v1710586844/sunni/hourse_qvkplh.jpg'
    },
    {
        key: 'vr',
        photoUrl: 'https://res.cloudinary.com/dhlzvktzj/image/upload/v1710586853/sunni/vr_hlejt2.jpg'
    },
    {
        key: 'calligraphy',
        photoUrl: 'https://res.cloudinary.com/dhlzvktzj/image/upload/v1710586853/sunni/calligraphy_zggdvh.jpg'
    }
];
const $0c1b138fe2f5cc06$export$a1a51819ebd9fc5d = [
    'bouldering',
    'paintball',
    'escape-rooms',
    'kids-play-rooms',
    'museums',
    'outside',
    'vr',
    'calligraphy'
];
const $0c1b138fe2f5cc06$export$71e2eef3cf6c1535 = (key)=>$0c1b138fe2f5cc06$var$CARDS.find((card)=>card.key === key).photoUrl;


const $4284c25e4429de7b$export$12449a31c6671d53 = ()=>{
    const { t: t } = (0, $980e4b3a97f1ad67$export$9fc83ad70ead8663)();
    return /*#__PURE__*/ (0, $9wx12.jsxs)("main", {
        children: [
            /*#__PURE__*/ (0, $9wx12.jsxs)("div", {
                id: "hero",
                className: "h-[700px] bg-cover bg-bottom w-full relative flex  justify-center items-center flex-col",
                style: {
                    backgroundImage: `url(https://res.cloudinary.com/dhlzvktzj/image/upload/v1710424121/sunni/kristina-evstifeeva-y3h6gh2fpaI-unsplash_fst2xv.jpg)`,
                    boxShadow: 'inset 0 0 0 10000px rgba(0, 0, 0, 0.5)'
                },
                children: [
                    /*#__PURE__*/ (0, $9wx12.jsx)("div", {
                        className: "absolute top-0 left-0 right-0 flex justify-between items-center",
                        children: /*#__PURE__*/ (0, $9wx12.jsx)((0, $fc72cc536184e560$export$8b251419efc915eb), {})
                    }),
                    /*#__PURE__*/ (0, $9wx12.jsx)("h1", {
                        className: "text-3xl text-white px-3 text-center",
                        children: t('landing.hero-title')
                    }),
                    /*#__PURE__*/ (0, $9wx12.jsx)((0, $58d5e477c8f3715b$export$87e9c2ff338a8575), {})
                ]
            }),
            /*#__PURE__*/ (0, $9wx12.jsxs)("div", {
                className: "mb-5",
                id: "under-hero",
                children: [
                    /*#__PURE__*/ (0, $9wx12.jsx)((0, $b4083ea3a052dee9$export$2e2bcd8739ae039), {
                        variant: "h4",
                        mt: 5,
                        gutterBottom: true,
                        className: "text-3xl my-10 text-center",
                        children: t('landing.title2')
                    }),
                    /*#__PURE__*/ (0, $9wx12.jsx)((0, $b4083ea3a052dee9$export$2e2bcd8739ae039), {
                        variant: "h6",
                        mb: 4,
                        gutterBottom: true,
                        color: "text.secondary",
                        className: "text-3xl my-10 text-center",
                        children: t('landing.subtitle2')
                    }),
                    /*#__PURE__*/ (0, $9wx12.jsx)("div", {
                        id: "slider",
                        className: "flex justify-center items-center gap-4 flex-wrap",
                        children: (0, $0c1b138fe2f5cc06$export$a1a51819ebd9fc5d).map((key)=>/*#__PURE__*/ (0, $9wx12.jsx)((0, $9f659597088bfd69$export$97116c7f2754eba5), {
                                title: t(`landing.${key}`),
                                photoUrl: (0, $0c1b138fe2f5cc06$export$71e2eef3cf6c1535)(key)
                            }, key))
                    })
                ]
            }),
            /*#__PURE__*/ (0, $9wx12.jsx)((0, $56201fc8fe14bcc5$export$a06f1c675e846f6f), {})
        ]
    });
};



var $9wx12 = parcelRequire("9wx12");

var $gJYWc = parcelRequire("gJYWc");

var $9wx12 = parcelRequire("9wx12");
parcelRequire("gJYWc");


var $cTAWX = parcelRequire("cTAWX");

var $3VnFq = parcelRequire("3VnFq");

var $gJYWc = parcelRequire("gJYWc");


var $2w6IV = parcelRequire("2w6IV");


var $3e4LV = parcelRequire("3e4LV");

var $fwsmC = parcelRequire("fwsmC");

var $cVrVk = parcelRequire("cVrVk");

var $cTAWX = parcelRequire("cTAWX");

var $3VnFq = parcelRequire("3VnFq");

var $gJYWc = parcelRequire("gJYWc");


var $2w6IV = parcelRequire("2w6IV");


var $3e4LV = parcelRequire("3e4LV");

var $cVrVk = parcelRequire("cVrVk");

var $HGmne = parcelRequire("HGmne");
var $8ttSm = parcelRequire("8ttSm");

var $gJYWc = parcelRequire("gJYWc");
'use client';
function $778a260509dda869$export$2e2bcd8739ae039({ controlled: controlled, default: defaultProp, name: name, state: state = 'value' }) {
    // isControlled is ignored in the hook dependency lists as it should never change.
    const { current: isControlled } = $gJYWc.useRef(controlled !== undefined);
    const [valueState, setValue] = $gJYWc.useState(defaultProp);
    const value = isControlled ? controlled : valueState;
    const setValueIfUncontrolled = $gJYWc.useCallback((newValue)=>{
        if (!isControlled) setValue(newValue);
    }, []);
    return [
        value,
        setValueIfUncontrolled
    ];
}


'use client';
var $acfba98c2e325db8$export$2e2bcd8739ae039 = (0, $778a260509dda869$export$2e2bcd8739ae039);



var $gJYWc = parcelRequire("gJYWc");

var $gJYWc = parcelRequire("gJYWc");
/**
 * @ignore - internal component.
 */ const $ae835169353fee9c$var$FormControlContext = /*#__PURE__*/ $gJYWc.createContext(undefined);
var $ae835169353fee9c$export$2e2bcd8739ae039 = $ae835169353fee9c$var$FormControlContext;


'use client';
function $7d9d5024ca7b136a$export$2e2bcd8739ae039() {
    return $gJYWc.useContext((0, $ae835169353fee9c$export$2e2bcd8739ae039));
}



var $fNSZE = parcelRequire("fNSZE");

var $i8nzj = parcelRequire("i8nzj");

var $1kRHf = parcelRequire("1kRHf");
function $1b8bb7cc830c18f7$export$baa0faa0c7ad8085(slot) {
    return (0, $1kRHf.default)('PrivateSwitchBase', slot);
}
const $1b8bb7cc830c18f7$var$switchBaseClasses = (0, $i8nzj.default)('PrivateSwitchBase', [
    'root',
    'checked',
    'disabled',
    'input',
    'edgeStart',
    'edgeEnd'
]);
var $1b8bb7cc830c18f7$export$2e2bcd8739ae039 = $1b8bb7cc830c18f7$var$switchBaseClasses;



var $9wx12 = parcelRequire("9wx12");
'use client';
const $a3bc8e0e3b20b96e$var$_excluded = [
    "autoFocus",
    "checked",
    "checkedIcon",
    "className",
    "defaultChecked",
    "disabled",
    "disableFocusRipple",
    "edge",
    "icon",
    "id",
    "inputProps",
    "inputRef",
    "name",
    "onBlur",
    "onChange",
    "onFocus",
    "readOnly",
    "required",
    "tabIndex",
    "type",
    "value"
];
const $a3bc8e0e3b20b96e$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, checked: checked, disabled: disabled, edge: edge } = ownerState;
    const slots = {
        root: [
            'root',
            checked && 'checked',
            disabled && 'disabled',
            edge && `edge${(0, $cVrVk.default)(edge)}`
        ],
        input: [
            'input'
        ]
    };
    return (0, $3e4LV.default)(slots, (0, $1b8bb7cc830c18f7$export$baa0faa0c7ad8085), classes);
};
const $a3bc8e0e3b20b96e$var$SwitchBaseRoot = (0, $HGmne.default)((0, $fNSZE.default))(({ ownerState: ownerState })=>(0, $3VnFq.default)({
        padding: 9,
        borderRadius: '50%'
    }, ownerState.edge === 'start' && {
        marginLeft: ownerState.size === 'small' ? -3 : -12
    }, ownerState.edge === 'end' && {
        marginRight: ownerState.size === 'small' ? -3 : -12
    }));
const $a3bc8e0e3b20b96e$var$SwitchBaseInput = (0, $HGmne.default)('input', {
    shouldForwardProp: (0, $8ttSm.default)
})({
    cursor: 'inherit',
    position: 'absolute',
    opacity: 0,
    width: '100%',
    height: '100%',
    top: 0,
    left: 0,
    margin: 0,
    padding: 0,
    zIndex: 1
});
/**
 * @ignore - internal component.
 */ const $a3bc8e0e3b20b96e$var$SwitchBase = /*#__PURE__*/ $gJYWc.forwardRef(function SwitchBase(props, ref) {
    const { autoFocus: autoFocus, checked: checkedProp, checkedIcon: checkedIcon, className: className, defaultChecked: defaultChecked, disabled: disabledProp, disableFocusRipple: disableFocusRipple = false, edge: edge = false, icon: icon, id: id, inputProps: inputProps, inputRef: inputRef, name: name, onBlur: onBlur, onChange: onChange, onFocus: onFocus, readOnly: readOnly, required: required = false, tabIndex: tabIndex, type: type, value: value } = props, other = (0, $cTAWX.default)(props, $a3bc8e0e3b20b96e$var$_excluded);
    const [checked, setCheckedState] = (0, $acfba98c2e325db8$export$2e2bcd8739ae039)({
        controlled: checkedProp,
        default: Boolean(defaultChecked),
        name: 'SwitchBase',
        state: 'checked'
    });
    const muiFormControl = (0, $7d9d5024ca7b136a$export$2e2bcd8739ae039)();
    const handleFocus = (event)=>{
        if (onFocus) onFocus(event);
        if (muiFormControl && muiFormControl.onFocus) muiFormControl.onFocus(event);
    };
    const handleBlur = (event)=>{
        if (onBlur) onBlur(event);
        if (muiFormControl && muiFormControl.onBlur) muiFormControl.onBlur(event);
    };
    const handleInputChange = (event)=>{
        // Workaround for https://github.com/facebook/react/issues/9023
        if (event.nativeEvent.defaultPrevented) return;
        const newChecked = event.target.checked;
        setCheckedState(newChecked);
        if (onChange) // TODO v6: remove the second argument.
        onChange(event, newChecked);
    };
    let disabled = disabledProp;
    if (muiFormControl) {
        if (typeof disabled === 'undefined') disabled = muiFormControl.disabled;
    }
    const hasLabelFor = type === 'checkbox' || type === 'radio';
    const ownerState = (0, $3VnFq.default)({}, props, {
        checked: checked,
        disabled: disabled,
        disableFocusRipple: disableFocusRipple,
        edge: edge
    });
    const classes = $a3bc8e0e3b20b96e$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $9wx12.jsxs)($a3bc8e0e3b20b96e$var$SwitchBaseRoot, (0, $3VnFq.default)({
        component: "span",
        className: (0, $2w6IV.default)(classes.root, className),
        centerRipple: true,
        focusRipple: !disableFocusRipple,
        disabled: disabled,
        tabIndex: null,
        role: undefined,
        onFocus: handleFocus,
        onBlur: handleBlur,
        ownerState: ownerState,
        ref: ref
    }, other, {
        children: [
            /*#__PURE__*/ (0, $9wx12.jsx)($a3bc8e0e3b20b96e$var$SwitchBaseInput, (0, $3VnFq.default)({
                autoFocus: autoFocus,
                checked: checkedProp,
                defaultChecked: defaultChecked,
                className: classes.input,
                disabled: disabled,
                id: hasLabelFor ? id : undefined,
                name: name,
                onChange: handleInputChange,
                readOnly: readOnly,
                ref: inputRef,
                required: required,
                ownerState: ownerState,
                tabIndex: tabIndex,
                type: type
            }, type === 'checkbox' && value === undefined ? {} : {
                value: value
            }, inputProps)),
            checked ? checkedIcon : icon
        ]
    }));
});
var $a3bc8e0e3b20b96e$export$2e2bcd8739ae039 = $a3bc8e0e3b20b96e$var$SwitchBase;



var $HGmne = parcelRequire("HGmne");

var $8pLcn = parcelRequire("8pLcn");

var $i8nzj = parcelRequire("i8nzj");

var $1kRHf = parcelRequire("1kRHf");
function $dd0d3118476421f2$export$39f6debbec19b3ba(slot) {
    return (0, $1kRHf.default)('MuiSwitch', slot);
}
const $dd0d3118476421f2$var$switchClasses = (0, $i8nzj.default)('MuiSwitch', [
    'root',
    'edgeStart',
    'edgeEnd',
    'switchBase',
    'colorPrimary',
    'colorSecondary',
    'sizeSmall',
    'sizeMedium',
    'checked',
    'disabled',
    'input',
    'thumb',
    'track'
]);
var $dd0d3118476421f2$export$2e2bcd8739ae039 = $dd0d3118476421f2$var$switchClasses;



var $9wx12 = parcelRequire("9wx12");
'use client';
const $c69e86b3c89ddcdf$var$_excluded = [
    "className",
    "color",
    "edge",
    "size",
    "sx"
];
const $c69e86b3c89ddcdf$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, edge: edge, size: size, color: color, checked: checked, disabled: disabled } = ownerState;
    const slots = {
        root: [
            'root',
            edge && `edge${(0, $cVrVk.default)(edge)}`,
            `size${(0, $cVrVk.default)(size)}`
        ],
        switchBase: [
            'switchBase',
            `color${(0, $cVrVk.default)(color)}`,
            checked && 'checked',
            disabled && 'disabled'
        ],
        thumb: [
            'thumb'
        ],
        track: [
            'track'
        ],
        input: [
            'input'
        ]
    };
    const composedClasses = (0, $3e4LV.default)(slots, (0, $dd0d3118476421f2$export$39f6debbec19b3ba), classes);
    return (0, $3VnFq.default)({}, classes, composedClasses);
};
const $c69e86b3c89ddcdf$var$SwitchRoot = (0, $HGmne.default)('span', {
    name: 'MuiSwitch',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.edge && styles[`edge${(0, $cVrVk.default)(ownerState.edge)}`],
            styles[`size${(0, $cVrVk.default)(ownerState.size)}`]
        ];
    }
})({
    display: 'inline-flex',
    width: 58,
    height: 38,
    overflow: 'hidden',
    padding: 12,
    boxSizing: 'border-box',
    position: 'relative',
    flexShrink: 0,
    zIndex: 0,
    // Reset the stacking context.
    verticalAlign: 'middle',
    // For correct alignment with the text.
    '@media print': {
        colorAdjust: 'exact'
    },
    variants: [
        {
            props: {
                edge: 'start'
            },
            style: {
                marginLeft: -8
            }
        },
        {
            props: {
                edge: 'end'
            },
            style: {
                marginRight: -8
            }
        },
        {
            props: {
                size: 'small'
            },
            style: {
                width: 40,
                height: 24,
                padding: 7,
                [`& .${(0, $dd0d3118476421f2$export$2e2bcd8739ae039).thumb}`]: {
                    width: 16,
                    height: 16
                },
                [`& .${(0, $dd0d3118476421f2$export$2e2bcd8739ae039).switchBase}`]: {
                    padding: 4,
                    [`&.${(0, $dd0d3118476421f2$export$2e2bcd8739ae039).checked}`]: {
                        transform: 'translateX(16px)'
                    }
                }
            }
        }
    ]
});
const $c69e86b3c89ddcdf$var$SwitchSwitchBase = (0, $HGmne.default)((0, $a3bc8e0e3b20b96e$export$2e2bcd8739ae039), {
    name: 'MuiSwitch',
    slot: 'SwitchBase',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.switchBase,
            {
                [`& .${(0, $dd0d3118476421f2$export$2e2bcd8739ae039).input}`]: styles.input
            },
            ownerState.color !== 'default' && styles[`color${(0, $cVrVk.default)(ownerState.color)}`]
        ];
    }
})(({ theme: theme })=>({
        position: 'absolute',
        top: 0,
        left: 0,
        zIndex: 1,
        // Render above the focus ripple.
        color: theme.vars ? theme.vars.palette.Switch.defaultColor : `${theme.palette.mode === 'light' ? theme.palette.common.white : theme.palette.grey[300]}`,
        transition: theme.transitions.create([
            'left',
            'transform'
        ], {
            duration: theme.transitions.duration.shortest
        }),
        [`&.${(0, $dd0d3118476421f2$export$2e2bcd8739ae039).checked}`]: {
            transform: 'translateX(20px)'
        },
        [`&.${(0, $dd0d3118476421f2$export$2e2bcd8739ae039).disabled}`]: {
            color: theme.vars ? theme.vars.palette.Switch.defaultDisabledColor : `${theme.palette.mode === 'light' ? theme.palette.grey[100] : theme.palette.grey[600]}`
        },
        [`&.${(0, $dd0d3118476421f2$export$2e2bcd8739ae039).checked} + .${(0, $dd0d3118476421f2$export$2e2bcd8739ae039).track}`]: {
            opacity: 0.5
        },
        [`&.${(0, $dd0d3118476421f2$export$2e2bcd8739ae039).disabled} + .${(0, $dd0d3118476421f2$export$2e2bcd8739ae039).track}`]: {
            opacity: theme.vars ? theme.vars.opacity.switchTrackDisabled : `${theme.palette.mode === 'light' ? 0.12 : 0.2}`
        },
        [`& .${(0, $dd0d3118476421f2$export$2e2bcd8739ae039).input}`]: {
            left: '-100%',
            width: '300%'
        }
    }), ({ theme: theme })=>({
        '&:hover': {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.action.activeChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $fwsmC.alpha)(theme.palette.action.active, theme.palette.action.hoverOpacity),
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                backgroundColor: 'transparent'
            }
        },
        variants: [
            ...Object.entries(theme.palette).filter(([, value])=>value.main && value.light) // check all the used fields in the style below
            .map(([color])=>({
                    props: {
                        color: color
                    },
                    style: {
                        [`&.${(0, $dd0d3118476421f2$export$2e2bcd8739ae039).checked}`]: {
                            color: (theme.vars || theme).palette[color].main,
                            '&:hover': {
                                backgroundColor: theme.vars ? `rgba(${theme.vars.palette[color].mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $fwsmC.alpha)(theme.palette[color].main, theme.palette.action.hoverOpacity),
                                '@media (hover: none)': {
                                    backgroundColor: 'transparent'
                                }
                            },
                            [`&.${(0, $dd0d3118476421f2$export$2e2bcd8739ae039).disabled}`]: {
                                color: theme.vars ? theme.vars.palette.Switch[`${color}DisabledColor`] : `${theme.palette.mode === 'light' ? (0, $fwsmC.lighten)(theme.palette[color].main, 0.62) : (0, $fwsmC.darken)(theme.palette[color].main, 0.55)}`
                            }
                        },
                        [`&.${(0, $dd0d3118476421f2$export$2e2bcd8739ae039).checked} + .${(0, $dd0d3118476421f2$export$2e2bcd8739ae039).track}`]: {
                            backgroundColor: (theme.vars || theme).palette[color].main
                        }
                    }
                }))
        ]
    }));
const $c69e86b3c89ddcdf$var$SwitchTrack = (0, $HGmne.default)('span', {
    name: 'MuiSwitch',
    slot: 'Track',
    overridesResolver: (props, styles)=>styles.track
})(({ theme: theme })=>({
        height: '100%',
        width: '100%',
        borderRadius: 7,
        zIndex: -1,
        transition: theme.transitions.create([
            'opacity',
            'background-color'
        ], {
            duration: theme.transitions.duration.shortest
        }),
        backgroundColor: theme.vars ? theme.vars.palette.common.onBackground : `${theme.palette.mode === 'light' ? theme.palette.common.black : theme.palette.common.white}`,
        opacity: theme.vars ? theme.vars.opacity.switchTrack : `${theme.palette.mode === 'light' ? 0.38 : 0.3}`
    }));
const $c69e86b3c89ddcdf$var$SwitchThumb = (0, $HGmne.default)('span', {
    name: 'MuiSwitch',
    slot: 'Thumb',
    overridesResolver: (props, styles)=>styles.thumb
})(({ theme: theme })=>({
        boxShadow: (theme.vars || theme).shadows[1],
        backgroundColor: 'currentColor',
        width: 20,
        height: 20,
        borderRadius: '50%'
    }));
const $c69e86b3c89ddcdf$var$Switch = /*#__PURE__*/ $gJYWc.forwardRef(function Switch(inProps, ref) {
    const props = (0, $8pLcn.useDefaultProps)({
        props: inProps,
        name: 'MuiSwitch'
    });
    const { className: className, color: color = 'primary', edge: edge = false, size: size = 'medium', sx: sx } = props, other = (0, $cTAWX.default)(props, $c69e86b3c89ddcdf$var$_excluded);
    const ownerState = (0, $3VnFq.default)({}, props, {
        color: color,
        edge: edge,
        size: size
    });
    const classes = $c69e86b3c89ddcdf$var$useUtilityClasses(ownerState);
    const icon = /*#__PURE__*/ (0, $9wx12.jsx)($c69e86b3c89ddcdf$var$SwitchThumb, {
        className: classes.thumb,
        ownerState: ownerState
    });
    return /*#__PURE__*/ (0, $9wx12.jsxs)($c69e86b3c89ddcdf$var$SwitchRoot, {
        className: (0, $2w6IV.default)(classes.root, className),
        sx: sx,
        ownerState: ownerState,
        children: [
            /*#__PURE__*/ (0, $9wx12.jsx)($c69e86b3c89ddcdf$var$SwitchSwitchBase, (0, $3VnFq.default)({
                type: "checkbox",
                icon: icon,
                checkedIcon: icon,
                ref: ref,
                ownerState: ownerState
            }, other, {
                classes: (0, $3VnFq.default)({}, classes, {
                    root: classes.switchBase
                })
            })),
            /*#__PURE__*/ (0, $9wx12.jsx)($c69e86b3c89ddcdf$var$SwitchTrack, {
                className: classes.track,
                ownerState: ownerState
            })
        ]
    });
});
var $c69e86b3c89ddcdf$export$2e2bcd8739ae039 = $c69e86b3c89ddcdf$var$Switch;



var $cTAWX = parcelRequire("cTAWX");

var $3VnFq = parcelRequire("3VnFq");

var $gJYWc = parcelRequire("gJYWc");


var $2w6IV = parcelRequire("2w6IV");


var $3e4LV = parcelRequire("3e4LV");



var $cTAWX = parcelRequire("cTAWX");

var $3VnFq = parcelRequire("3VnFq");

var $gJYWc = parcelRequire("gJYWc");


var $2w6IV = parcelRequire("2w6IV");

var $dvHXN = parcelRequire("dvHXN");

var $1kRHf = parcelRequire("1kRHf");

var $3e4LV = parcelRequire("3e4LV");

var $3VnFq = parcelRequire("3VnFq");

var $cTAWX = parcelRequire("cTAWX");

var $9Ie0W = parcelRequire("9Ie0W");

var $dvHXN = parcelRequire("dvHXN");



var $hvWfk = parcelRequire("hvWfk");

var $k1l9i = parcelRequire("k1l9i");
const $fe80dd4f59ccf75f$var$_excluded = [
    "ownerState"
], $fe80dd4f59ccf75f$var$_excluded2 = [
    "variants"
], $fe80dd4f59ccf75f$var$_excluded3 = [
    "name",
    "slot",
    "skipVariantsResolver",
    "skipSx",
    "overridesResolver"
];
function $fe80dd4f59ccf75f$var$isEmpty(obj) {
    return Object.keys(obj).length === 0;
}
// https://github.com/emotion-js/emotion/blob/26ded6109fcd8ca9875cc2ce4564fee678a3f3c5/packages/styled/src/utils.js#L40
function $fe80dd4f59ccf75f$var$isStringTag(tag) {
    return typeof tag === 'string' && // 96 is one less than the char code
    // for "a" so this is checking that
    // it's a lowercase character
    tag.charCodeAt(0) > 96;
}
function $fe80dd4f59ccf75f$export$3ba67b570e26eea0(prop) {
    return prop !== 'ownerState' && prop !== 'theme' && prop !== 'sx' && prop !== 'as';
}
const $fe80dd4f59ccf75f$export$35e57303dbd8a66 = (0, $hvWfk.default)();
const $fe80dd4f59ccf75f$var$lowercaseFirstLetter = (string)=>{
    if (!string) return string;
    return string.charAt(0).toLowerCase() + string.slice(1);
};
function $fe80dd4f59ccf75f$var$resolveTheme({ defaultTheme: defaultTheme, theme: theme, themeId: themeId }) {
    return $fe80dd4f59ccf75f$var$isEmpty(theme) ? defaultTheme : theme[themeId] || theme;
}
function $fe80dd4f59ccf75f$var$defaultOverridesResolver(slot) {
    if (!slot) return null;
    return (props, styles)=>styles[slot];
}
function $fe80dd4f59ccf75f$var$processStyleArg(callableStyle, _ref) {
    let { ownerState: ownerState } = _ref, props = (0, $cTAWX.default)(_ref, $fe80dd4f59ccf75f$var$_excluded);
    const resolvedStylesArg = typeof callableStyle === 'function' ? callableStyle((0, $3VnFq.default)({
        ownerState: ownerState
    }, props)) : callableStyle;
    if (Array.isArray(resolvedStylesArg)) return resolvedStylesArg.flatMap((resolvedStyle)=>$fe80dd4f59ccf75f$var$processStyleArg(resolvedStyle, (0, $3VnFq.default)({
            ownerState: ownerState
        }, props)));
    if (!!resolvedStylesArg && typeof resolvedStylesArg === 'object' && Array.isArray(resolvedStylesArg.variants)) {
        const { variants: variants = [] } = resolvedStylesArg, otherStyles = (0, $cTAWX.default)(resolvedStylesArg, $fe80dd4f59ccf75f$var$_excluded2);
        let result = otherStyles;
        variants.forEach((variant)=>{
            let isMatch = true;
            if (typeof variant.props === 'function') isMatch = variant.props((0, $3VnFq.default)({
                ownerState: ownerState
            }, props, ownerState));
            else Object.keys(variant.props).forEach((key)=>{
                if ((ownerState == null ? void 0 : ownerState[key]) !== variant.props[key] && props[key] !== variant.props[key]) isMatch = false;
            });
            if (isMatch) {
                if (!Array.isArray(result)) result = [
                    result
                ];
                result.push(typeof variant.style === 'function' ? variant.style((0, $3VnFq.default)({
                    ownerState: ownerState
                }, props, ownerState)) : variant.style);
            }
        });
        return result;
    }
    return resolvedStylesArg;
}
function $fe80dd4f59ccf75f$export$2e2bcd8739ae039(input = {}) {
    const { themeId: themeId, defaultTheme: defaultTheme = $fe80dd4f59ccf75f$export$35e57303dbd8a66, rootShouldForwardProp: rootShouldForwardProp = $fe80dd4f59ccf75f$export$3ba67b570e26eea0, slotShouldForwardProp: slotShouldForwardProp = $fe80dd4f59ccf75f$export$3ba67b570e26eea0 } = input;
    const systemSx = (props)=>{
        return (0, $k1l9i.default)((0, $3VnFq.default)({}, props, {
            theme: $fe80dd4f59ccf75f$var$resolveTheme((0, $3VnFq.default)({}, props, {
                defaultTheme: defaultTheme,
                themeId: themeId
            }))
        }));
    };
    systemSx.__mui_systemSx = true;
    return (tag, inputOptions = {})=>{
        // Filter out the `sx` style function from the previous styled component to prevent unnecessary styles generated by the composite components.
        (0, $9Ie0W.internal_processStyles)(tag, (styles)=>styles.filter((style)=>!(style != null && style.__mui_systemSx)));
        const { name: componentName, slot: componentSlot, skipVariantsResolver: inputSkipVariantsResolver, skipSx: inputSkipSx, overridesResolver: // TODO v6: remove `lowercaseFirstLetter()` in the next major release
        // For more details: https://github.com/mui/material-ui/pull/37908
        overridesResolver = $fe80dd4f59ccf75f$var$defaultOverridesResolver($fe80dd4f59ccf75f$var$lowercaseFirstLetter(componentSlot)) } = inputOptions, options = (0, $cTAWX.default)(inputOptions, $fe80dd4f59ccf75f$var$_excluded3);
        // if skipVariantsResolver option is defined, take the value, otherwise, true for root and false for other slots.
        const skipVariantsResolver = inputSkipVariantsResolver !== undefined ? inputSkipVariantsResolver : // TODO v6: remove `Root` in the next major release
        // For more details: https://github.com/mui/material-ui/pull/37908
        componentSlot && componentSlot !== 'Root' && componentSlot !== 'root' || false;
        const skipSx = inputSkipSx || false;
        let label;
        let shouldForwardPropOption = $fe80dd4f59ccf75f$export$3ba67b570e26eea0;
        // TODO v6: remove `Root` in the next major release
        // For more details: https://github.com/mui/material-ui/pull/37908
        if (componentSlot === 'Root' || componentSlot === 'root') shouldForwardPropOption = rootShouldForwardProp;
        else if (componentSlot) // any other slot specified
        shouldForwardPropOption = slotShouldForwardProp;
        else if ($fe80dd4f59ccf75f$var$isStringTag(tag)) // for string (html) tag, preserve the behavior in emotion & styled-components.
        shouldForwardPropOption = undefined;
        const defaultStyledResolver = (0, $9Ie0W.default)(tag, (0, $3VnFq.default)({
            shouldForwardProp: shouldForwardPropOption,
            label: label
        }, options));
        const transformStyleArg = (stylesArg)=>{
            // On the server Emotion doesn't use React.forwardRef for creating components, so the created
            // component stays as a function. This condition makes sure that we do not interpolate functions
            // which are basically components used as a selectors.
            if (typeof stylesArg === 'function' && stylesArg.__emotion_real !== stylesArg || (0, $dvHXN.isPlainObject)(stylesArg)) return (props)=>$fe80dd4f59ccf75f$var$processStyleArg(stylesArg, (0, $3VnFq.default)({}, props, {
                    theme: $fe80dd4f59ccf75f$var$resolveTheme({
                        theme: props.theme,
                        defaultTheme: defaultTheme,
                        themeId: themeId
                    })
                }));
            return stylesArg;
        };
        const muiStyledResolver = (styleArg, ...expressions)=>{
            let transformedStyleArg = transformStyleArg(styleArg);
            const expressionsWithDefaultTheme = expressions ? expressions.map(transformStyleArg) : [];
            if (componentName && overridesResolver) expressionsWithDefaultTheme.push((props)=>{
                const theme = $fe80dd4f59ccf75f$var$resolveTheme((0, $3VnFq.default)({}, props, {
                    defaultTheme: defaultTheme,
                    themeId: themeId
                }));
                if (!theme.components || !theme.components[componentName] || !theme.components[componentName].styleOverrides) return null;
                const styleOverrides = theme.components[componentName].styleOverrides;
                const resolvedStyleOverrides = {};
                // TODO: v7 remove iteration and use `resolveStyleArg(styleOverrides[slot])` directly
                Object.entries(styleOverrides).forEach(([slotKey, slotStyle])=>{
                    resolvedStyleOverrides[slotKey] = $fe80dd4f59ccf75f$var$processStyleArg(slotStyle, (0, $3VnFq.default)({}, props, {
                        theme: theme
                    }));
                });
                return overridesResolver(props, resolvedStyleOverrides);
            });
            if (componentName && !skipVariantsResolver) expressionsWithDefaultTheme.push((props)=>{
                var _theme$components;
                const theme = $fe80dd4f59ccf75f$var$resolveTheme((0, $3VnFq.default)({}, props, {
                    defaultTheme: defaultTheme,
                    themeId: themeId
                }));
                const themeVariants = theme == null || (_theme$components = theme.components) == null || (_theme$components = _theme$components[componentName]) == null ? void 0 : _theme$components.variants;
                return $fe80dd4f59ccf75f$var$processStyleArg({
                    variants: themeVariants
                }, (0, $3VnFq.default)({}, props, {
                    theme: theme
                }));
            });
            if (!skipSx) expressionsWithDefaultTheme.push(systemSx);
            const numOfCustomFnsApplied = expressionsWithDefaultTheme.length - expressions.length;
            if (Array.isArray(styleArg) && numOfCustomFnsApplied > 0) {
                const placeholders = new Array(numOfCustomFnsApplied).fill('');
                // If the type is array, than we need to add placeholders in the template for the overrides, variants and the sx styles.
                transformedStyleArg = [
                    ...styleArg,
                    ...placeholders
                ];
                transformedStyleArg.raw = [
                    ...styleArg.raw,
                    ...placeholders
                ];
            }
            const Component = defaultStyledResolver(transformedStyleArg, ...expressionsWithDefaultTheme);
            if (tag.muiName) Component.muiName = tag.muiName;
            return Component;
        };
        if (defaultStyledResolver.withConfig) muiStyledResolver.withConfig = defaultStyledResolver.withConfig;
        return muiStyledResolver;
    };
}


const $c3d933f756d7a878$var$styled = (0, $fe80dd4f59ccf75f$export$2e2bcd8739ae039)();
var $c3d933f756d7a878$export$2e2bcd8739ae039 = $c3d933f756d7a878$var$styled;




var $01deC = parcelRequire("01deC");

var $hvWfk = parcelRequire("hvWfk");

var $dEfmb = parcelRequire("dEfmb");

var $9xkBg = parcelRequire("9xkBg");

var $9wx12 = parcelRequire("9wx12");
const $5cbcdfea1c2e7e61$var$_excluded = [
    "component",
    "direction",
    "spacing",
    "divider",
    "children",
    "className",
    "useFlexGap"
];
const $5cbcdfea1c2e7e61$var$defaultTheme = (0, $hvWfk.default)();
// widening Theme to any so that the consumer can own the theme structure.
const $5cbcdfea1c2e7e61$var$defaultCreateStyledComponent = (0, $c3d933f756d7a878$export$2e2bcd8739ae039)('div', {
    name: 'MuiStack',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
});
function $5cbcdfea1c2e7e61$var$useThemePropsDefault(props) {
    return (0, $011a0d2b53945cef$export$2e2bcd8739ae039)({
        props: props,
        name: 'MuiStack',
        defaultTheme: $5cbcdfea1c2e7e61$var$defaultTheme
    });
}
/**
 * Return an array with the separator React element interspersed between
 * each React node of the input children.
 *
 * > joinChildren([1,2,3], 0)
 * [1,0,2,0,3]
 */ function $5cbcdfea1c2e7e61$var$joinChildren(children, separator) {
    const childrenArray = $gJYWc.Children.toArray(children).filter(Boolean);
    return childrenArray.reduce((output, child, index)=>{
        output.push(child);
        if (index < childrenArray.length - 1) output.push(/*#__PURE__*/ $gJYWc.cloneElement(separator, {
            key: `separator-${index}`
        }));
        return output;
    }, []);
}
const $5cbcdfea1c2e7e61$var$getSideFromDirection = (direction)=>{
    return ({
        row: 'Left',
        'row-reverse': 'Right',
        column: 'Top',
        'column-reverse': 'Bottom'
    })[direction];
};
const $5cbcdfea1c2e7e61$export$1d567c320f4763bc = ({ ownerState: ownerState, theme: theme })=>{
    let styles = (0, $3VnFq.default)({
        display: 'flex',
        flexDirection: 'column'
    }, (0, $dEfmb.handleBreakpoints)({
        theme: theme
    }, (0, $dEfmb.resolveBreakpointValues)({
        values: ownerState.direction,
        breakpoints: theme.breakpoints.values
    }), (propValue)=>({
            flexDirection: propValue
        })));
    if (ownerState.spacing) {
        const transformer = (0, $9xkBg.createUnarySpacing)(theme);
        const base = Object.keys(theme.breakpoints.values).reduce((acc, breakpoint)=>{
            if (typeof ownerState.spacing === 'object' && ownerState.spacing[breakpoint] != null || typeof ownerState.direction === 'object' && ownerState.direction[breakpoint] != null) acc[breakpoint] = true;
            return acc;
        }, {});
        const directionValues = (0, $dEfmb.resolveBreakpointValues)({
            values: ownerState.direction,
            base: base
        });
        const spacingValues = (0, $dEfmb.resolveBreakpointValues)({
            values: ownerState.spacing,
            base: base
        });
        if (typeof directionValues === 'object') Object.keys(directionValues).forEach((breakpoint, index, breakpoints)=>{
            const directionValue = directionValues[breakpoint];
            if (!directionValue) {
                const previousDirectionValue = index > 0 ? directionValues[breakpoints[index - 1]] : 'column';
                directionValues[breakpoint] = previousDirectionValue;
            }
        });
        const styleFromPropValue = (propValue, breakpoint)=>{
            if (ownerState.useFlexGap) return {
                gap: (0, $9xkBg.getValue)(transformer, propValue)
            };
            return {
                // The useFlexGap={false} implement relies on each child to give up control of the margin.
                // We need to reset the margin to avoid double spacing.
                '& > :not(style):not(style)': {
                    margin: 0
                },
                '& > :not(style) ~ :not(style)': {
                    [`margin${$5cbcdfea1c2e7e61$var$getSideFromDirection(breakpoint ? directionValues[breakpoint] : ownerState.direction)}`]: (0, $9xkBg.getValue)(transformer, propValue)
                }
            };
        };
        styles = (0, $dvHXN.default)(styles, (0, $dEfmb.handleBreakpoints)({
            theme: theme
        }, spacingValues, styleFromPropValue));
    }
    styles = (0, $dEfmb.mergeBreakpointsInOrder)(theme.breakpoints, styles);
    return styles;
};
function $5cbcdfea1c2e7e61$export$2e2bcd8739ae039(options = {}) {
    const { createStyledComponent: // This will allow adding custom styled fn (for example for custom sx style function)
    createStyledComponent = $5cbcdfea1c2e7e61$var$defaultCreateStyledComponent, useThemeProps: useThemeProps = $5cbcdfea1c2e7e61$var$useThemePropsDefault, componentName: componentName = 'MuiStack' } = options;
    const useUtilityClasses = ()=>{
        const slots = {
            root: [
                'root'
            ]
        };
        return (0, $3e4LV.default)(slots, (slot)=>(0, $1kRHf.default)(componentName, slot), {});
    };
    const StackRoot = createStyledComponent($5cbcdfea1c2e7e61$export$1d567c320f4763bc);
    const Stack = /*#__PURE__*/ $gJYWc.forwardRef(function Grid(inProps, ref) {
        const themeProps = useThemeProps(inProps);
        const props = (0, $01deC.default)(themeProps); // `color` type conflicts with html color attribute.
        const { component: component = 'div', direction: direction = 'column', spacing: spacing = 0, divider: divider, children: children, className: className, useFlexGap: useFlexGap = false } = props, other = (0, $cTAWX.default)(props, $5cbcdfea1c2e7e61$var$_excluded);
        const ownerState = {
            direction: direction,
            spacing: spacing,
            useFlexGap: useFlexGap
        };
        const classes = useUtilityClasses();
        return /*#__PURE__*/ (0, $9wx12.jsx)(StackRoot, (0, $3VnFq.default)({
            as: component,
            ownerState: ownerState,
            ref: ref,
            className: (0, $2w6IV.default)(classes.root, className)
        }, other, {
            children: divider ? $5cbcdfea1c2e7e61$var$joinChildren(children, divider) : children
        }));
    });
    return Stack;
}



var $HGmne = parcelRequire("HGmne");

var $8pLcn = parcelRequire("8pLcn");
'use client';
const $14e613f2bd3f5146$var$Stack = (0, $5cbcdfea1c2e7e61$export$2e2bcd8739ae039)({
    createStyledComponent: (0, $HGmne.default)('div', {
        name: 'MuiStack',
        slot: 'Root',
        overridesResolver: (props, styles)=>styles.root
    }),
    useThemeProps: (inProps)=>(0, $8pLcn.useDefaultProps)({
            props: inProps,
            name: 'MuiStack'
        })
});
var $14e613f2bd3f5146$export$2e2bcd8739ae039 = $14e613f2bd3f5146$var$Stack;




var $cVrVk = parcelRequire("cVrVk");

var $HGmne = parcelRequire("HGmne");

var $8pLcn = parcelRequire("8pLcn");

var $i8nzj = parcelRequire("i8nzj");

var $1kRHf = parcelRequire("1kRHf");
function $23284cd338755acc$export$717666c39ec07e12(slot) {
    return (0, $1kRHf.default)('MuiFormControlLabel', slot);
}
const $23284cd338755acc$var$formControlLabelClasses = (0, $i8nzj.default)('MuiFormControlLabel', [
    'root',
    'labelPlacementStart',
    'labelPlacementTop',
    'labelPlacementBottom',
    'disabled',
    'label',
    'error',
    'required',
    'asterisk'
]);
var $23284cd338755acc$export$2e2bcd8739ae039 = $23284cd338755acc$var$formControlLabelClasses;


function $7f6a615e712efb52$export$2e2bcd8739ae039({ props: props, states: states, muiFormControl: muiFormControl }) {
    return states.reduce((acc, state)=>{
        acc[state] = props[state];
        if (muiFormControl) {
            if (typeof props[state] === 'undefined') acc[state] = muiFormControl[state];
        }
        return acc;
    }, {});
}



var $9wx12 = parcelRequire("9wx12");
'use client';
const $0ead88154c59e96d$var$_excluded = [
    "checked",
    "className",
    "componentsProps",
    "control",
    "disabled",
    "disableTypography",
    "inputRef",
    "label",
    "labelPlacement",
    "name",
    "onChange",
    "required",
    "slotProps",
    "value"
];
const $0ead88154c59e96d$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disabled: disabled, labelPlacement: labelPlacement, error: error, required: required } = ownerState;
    const slots = {
        root: [
            'root',
            disabled && 'disabled',
            `labelPlacement${(0, $cVrVk.default)(labelPlacement)}`,
            error && 'error',
            required && 'required'
        ],
        label: [
            'label',
            disabled && 'disabled'
        ],
        asterisk: [
            'asterisk',
            error && 'error'
        ]
    };
    return (0, $3e4LV.default)(slots, (0, $23284cd338755acc$export$717666c39ec07e12), classes);
};
const $0ead88154c59e96d$export$1b479270917a5676 = (0, $HGmne.default)('label', {
    name: 'MuiFormControlLabel',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            {
                [`& .${(0, $23284cd338755acc$export$2e2bcd8739ae039).label}`]: styles.label
            },
            styles.root,
            styles[`labelPlacement${(0, $cVrVk.default)(ownerState.labelPlacement)}`]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $3VnFq.default)({
        display: 'inline-flex',
        alignItems: 'center',
        cursor: 'pointer',
        // For correct alignment with the text.
        verticalAlign: 'middle',
        WebkitTapHighlightColor: 'transparent',
        marginLeft: -11,
        marginRight: 16,
        // used for row presentation of radio/checkbox
        [`&.${(0, $23284cd338755acc$export$2e2bcd8739ae039).disabled}`]: {
            cursor: 'default'
        }
    }, ownerState.labelPlacement === 'start' && {
        flexDirection: 'row-reverse',
        marginLeft: 16,
        // used for row presentation of radio/checkbox
        marginRight: -11
    }, ownerState.labelPlacement === 'top' && {
        flexDirection: 'column-reverse',
        marginLeft: 16
    }, ownerState.labelPlacement === 'bottom' && {
        flexDirection: 'column',
        marginLeft: 16
    }, {
        [`& .${(0, $23284cd338755acc$export$2e2bcd8739ae039).label}`]: {
            [`&.${(0, $23284cd338755acc$export$2e2bcd8739ae039).disabled}`]: {
                color: (theme.vars || theme).palette.text.disabled
            }
        }
    }));
const $0ead88154c59e96d$var$AsteriskComponent = (0, $HGmne.default)('span', {
    name: 'MuiFormControlLabel',
    slot: 'Asterisk',
    overridesResolver: (props, styles)=>styles.asterisk
})(({ theme: theme })=>({
        [`&.${(0, $23284cd338755acc$export$2e2bcd8739ae039).error}`]: {
            color: (theme.vars || theme).palette.error.main
        }
    }));
/**
 * Drop-in replacement of the `Radio`, `Switch` and `Checkbox` component.
 * Use this component if you want to display an extra label.
 */ const $0ead88154c59e96d$var$FormControlLabel = /*#__PURE__*/ $gJYWc.forwardRef(function FormControlLabel(inProps, ref) {
    var _ref, _slotProps$typography;
    const props = (0, $8pLcn.useDefaultProps)({
        props: inProps,
        name: 'MuiFormControlLabel'
    });
    const { className: className, componentsProps: componentsProps = {}, control: control, disabled: disabledProp, disableTypography: disableTypography, label: labelProp, labelPlacement: labelPlacement = 'end', required: requiredProp, slotProps: slotProps = {} } = props, other = (0, $cTAWX.default)(props, $0ead88154c59e96d$var$_excluded);
    const muiFormControl = (0, $7d9d5024ca7b136a$export$2e2bcd8739ae039)();
    const disabled = (_ref = disabledProp != null ? disabledProp : control.props.disabled) != null ? _ref : muiFormControl == null ? void 0 : muiFormControl.disabled;
    const required = requiredProp != null ? requiredProp : control.props.required;
    const controlProps = {
        disabled: disabled,
        required: required
    };
    [
        'checked',
        'name',
        'onChange',
        'value',
        'inputRef'
    ].forEach((key)=>{
        if (typeof control.props[key] === 'undefined' && typeof props[key] !== 'undefined') controlProps[key] = props[key];
    });
    const fcs = (0, $7f6a615e712efb52$export$2e2bcd8739ae039)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            'error'
        ]
    });
    const ownerState = (0, $3VnFq.default)({}, props, {
        disabled: disabled,
        labelPlacement: labelPlacement,
        required: required,
        error: fcs.error
    });
    const classes = $0ead88154c59e96d$var$useUtilityClasses(ownerState);
    const typographySlotProps = (_slotProps$typography = slotProps.typography) != null ? _slotProps$typography : componentsProps.typography;
    let label = labelProp;
    if (label != null && label.type !== (0, $b4083ea3a052dee9$export$2e2bcd8739ae039) && !disableTypography) label = /*#__PURE__*/ (0, $9wx12.jsx)((0, $b4083ea3a052dee9$export$2e2bcd8739ae039), (0, $3VnFq.default)({
        component: "span"
    }, typographySlotProps, {
        className: (0, $2w6IV.default)(classes.label, typographySlotProps == null ? void 0 : typographySlotProps.className),
        children: label
    }));
    return /*#__PURE__*/ (0, $9wx12.jsxs)($0ead88154c59e96d$export$1b479270917a5676, (0, $3VnFq.default)({
        className: (0, $2w6IV.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref
    }, other, {
        children: [
            /*#__PURE__*/ $gJYWc.cloneElement(control, controlProps),
            required ? /*#__PURE__*/ (0, $9wx12.jsxs)((0, $14e613f2bd3f5146$export$2e2bcd8739ae039), {
                display: "block",
                children: [
                    label,
                    /*#__PURE__*/ (0, $9wx12.jsxs)($0ead88154c59e96d$var$AsteriskComponent, {
                        ownerState: ownerState,
                        "aria-hidden": true,
                        className: classes.asterisk,
                        children: [
                            "\u2009",
                            '*'
                        ]
                    })
                ]
            }) : label
        ]
    }));
});
var $0ead88154c59e96d$export$2e2bcd8739ae039 = $0ead88154c59e96d$var$FormControlLabel;




var $9wx12 = parcelRequire("9wx12");
parcelRequire("gJYWc");


var $cTAWX = parcelRequire("cTAWX");

var $3VnFq = parcelRequire("3VnFq");

var $gJYWc = parcelRequire("gJYWc");


var $2w6IV = parcelRequire("2w6IV");

var $3e4LV = parcelRequire("3e4LV");

var $fwsmC = parcelRequire("fwsmC");
parcelRequire("gJYWc");

var $ezPqr = parcelRequire("ezPqr");

var $9wx12 = parcelRequire("9wx12");
'use client';
var $b807756077cc313b$export$2e2bcd8739ae039 = (0, $ezPqr.default)(/*#__PURE__*/ (0, $9wx12.jsx)("path", {
    d: "M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm5 13.59L15.59 17 12 13.41 8.41 17 7 15.59 10.59 12 7 8.41 8.41 7 12 10.59 15.59 7 17 8.41 13.41 12 17 15.59z"
}), 'Cancel');



var $il32z = parcelRequire("il32z");


var $cVrVk = parcelRequire("cVrVk");

var $fNSZE = parcelRequire("fNSZE");

var $8pLcn = parcelRequire("8pLcn");

var $HGmne = parcelRequire("HGmne");

var $i8nzj = parcelRequire("i8nzj");

var $1kRHf = parcelRequire("1kRHf");
function $9672c702e463ec89$export$31444911e4ee6fdd(slot) {
    return (0, $1kRHf.default)('MuiChip', slot);
}
const $9672c702e463ec89$var$chipClasses = (0, $i8nzj.default)('MuiChip', [
    'root',
    'sizeSmall',
    'sizeMedium',
    'colorError',
    'colorInfo',
    'colorPrimary',
    'colorSecondary',
    'colorSuccess',
    'colorWarning',
    'disabled',
    'clickable',
    'clickableColorPrimary',
    'clickableColorSecondary',
    'deletable',
    'deletableColorPrimary',
    'deletableColorSecondary',
    'outlined',
    'filled',
    'outlinedPrimary',
    'outlinedSecondary',
    'filledPrimary',
    'filledSecondary',
    'avatar',
    'avatarSmall',
    'avatarMedium',
    'avatarColorPrimary',
    'avatarColorSecondary',
    'icon',
    'iconSmall',
    'iconMedium',
    'iconColorPrimary',
    'iconColorSecondary',
    'label',
    'labelSmall',
    'labelMedium',
    'deleteIcon',
    'deleteIconSmall',
    'deleteIconMedium',
    'deleteIconColorPrimary',
    'deleteIconColorSecondary',
    'deleteIconOutlinedColorPrimary',
    'deleteIconOutlinedColorSecondary',
    'deleteIconFilledColorPrimary',
    'deleteIconFilledColorSecondary',
    'focusVisible'
]);
var $9672c702e463ec89$export$2e2bcd8739ae039 = $9672c702e463ec89$var$chipClasses;



var $9wx12 = parcelRequire("9wx12");
'use client';
const $d3e26472a67ba319$var$_excluded = [
    "avatar",
    "className",
    "clickable",
    "color",
    "component",
    "deleteIcon",
    "disabled",
    "icon",
    "label",
    "onClick",
    "onDelete",
    "onKeyDown",
    "onKeyUp",
    "size",
    "variant",
    "tabIndex",
    "skipFocusWhenDisabled"
];
const $d3e26472a67ba319$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disabled: disabled, size: size, color: color, iconColor: iconColor, onDelete: onDelete, clickable: clickable, variant: variant } = ownerState;
    const slots = {
        root: [
            'root',
            variant,
            disabled && 'disabled',
            `size${(0, $cVrVk.default)(size)}`,
            `color${(0, $cVrVk.default)(color)}`,
            clickable && 'clickable',
            clickable && `clickableColor${(0, $cVrVk.default)(color)}`,
            onDelete && 'deletable',
            onDelete && `deletableColor${(0, $cVrVk.default)(color)}`,
            `${variant}${(0, $cVrVk.default)(color)}`
        ],
        label: [
            'label',
            `label${(0, $cVrVk.default)(size)}`
        ],
        avatar: [
            'avatar',
            `avatar${(0, $cVrVk.default)(size)}`,
            `avatarColor${(0, $cVrVk.default)(color)}`
        ],
        icon: [
            'icon',
            `icon${(0, $cVrVk.default)(size)}`,
            `iconColor${(0, $cVrVk.default)(iconColor)}`
        ],
        deleteIcon: [
            'deleteIcon',
            `deleteIcon${(0, $cVrVk.default)(size)}`,
            `deleteIconColor${(0, $cVrVk.default)(color)}`,
            `deleteIcon${(0, $cVrVk.default)(variant)}Color${(0, $cVrVk.default)(color)}`
        ]
    };
    return (0, $3e4LV.default)(slots, (0, $9672c702e463ec89$export$31444911e4ee6fdd), classes);
};
const $d3e26472a67ba319$var$ChipRoot = (0, $HGmne.default)('div', {
    name: 'MuiChip',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        const { color: color, iconColor: iconColor, clickable: clickable, onDelete: onDelete, size: size, variant: variant } = ownerState;
        return [
            {
                [`& .${(0, $9672c702e463ec89$export$2e2bcd8739ae039).avatar}`]: styles.avatar
            },
            {
                [`& .${(0, $9672c702e463ec89$export$2e2bcd8739ae039).avatar}`]: styles[`avatar${(0, $cVrVk.default)(size)}`]
            },
            {
                [`& .${(0, $9672c702e463ec89$export$2e2bcd8739ae039).avatar}`]: styles[`avatarColor${(0, $cVrVk.default)(color)}`]
            },
            {
                [`& .${(0, $9672c702e463ec89$export$2e2bcd8739ae039).icon}`]: styles.icon
            },
            {
                [`& .${(0, $9672c702e463ec89$export$2e2bcd8739ae039).icon}`]: styles[`icon${(0, $cVrVk.default)(size)}`]
            },
            {
                [`& .${(0, $9672c702e463ec89$export$2e2bcd8739ae039).icon}`]: styles[`iconColor${(0, $cVrVk.default)(iconColor)}`]
            },
            {
                [`& .${(0, $9672c702e463ec89$export$2e2bcd8739ae039).deleteIcon}`]: styles.deleteIcon
            },
            {
                [`& .${(0, $9672c702e463ec89$export$2e2bcd8739ae039).deleteIcon}`]: styles[`deleteIcon${(0, $cVrVk.default)(size)}`]
            },
            {
                [`& .${(0, $9672c702e463ec89$export$2e2bcd8739ae039).deleteIcon}`]: styles[`deleteIconColor${(0, $cVrVk.default)(color)}`]
            },
            {
                [`& .${(0, $9672c702e463ec89$export$2e2bcd8739ae039).deleteIcon}`]: styles[`deleteIcon${(0, $cVrVk.default)(variant)}Color${(0, $cVrVk.default)(color)}`]
            },
            styles.root,
            styles[`size${(0, $cVrVk.default)(size)}`],
            styles[`color${(0, $cVrVk.default)(color)}`],
            clickable && styles.clickable,
            clickable && color !== 'default' && styles[`clickableColor${(0, $cVrVk.default)(color)})`],
            onDelete && styles.deletable,
            onDelete && color !== 'default' && styles[`deletableColor${(0, $cVrVk.default)(color)}`],
            styles[variant],
            styles[`${variant}${(0, $cVrVk.default)(color)}`]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>{
    const textColor = theme.palette.mode === 'light' ? theme.palette.grey[700] : theme.palette.grey[300];
    return (0, $3VnFq.default)({
        maxWidth: '100%',
        fontFamily: theme.typography.fontFamily,
        fontSize: theme.typography.pxToRem(13),
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        height: 32,
        color: (theme.vars || theme).palette.text.primary,
        backgroundColor: (theme.vars || theme).palette.action.selected,
        borderRadius: 16,
        whiteSpace: 'nowrap',
        transition: theme.transitions.create([
            'background-color',
            'box-shadow'
        ]),
        // reset cursor explicitly in case ButtonBase is used
        cursor: 'unset',
        // We disable the focus ring for mouse, touch and keyboard users.
        outline: 0,
        textDecoration: 'none',
        border: 0,
        // Remove `button` border
        padding: 0,
        // Remove `button` padding
        verticalAlign: 'middle',
        boxSizing: 'border-box',
        [`&.${(0, $9672c702e463ec89$export$2e2bcd8739ae039).disabled}`]: {
            opacity: (theme.vars || theme).palette.action.disabledOpacity,
            pointerEvents: 'none'
        },
        [`& .${(0, $9672c702e463ec89$export$2e2bcd8739ae039).avatar}`]: {
            marginLeft: 5,
            marginRight: -6,
            width: 24,
            height: 24,
            color: theme.vars ? theme.vars.palette.Chip.defaultAvatarColor : textColor,
            fontSize: theme.typography.pxToRem(12)
        },
        [`& .${(0, $9672c702e463ec89$export$2e2bcd8739ae039).avatarColorPrimary}`]: {
            color: (theme.vars || theme).palette.primary.contrastText,
            backgroundColor: (theme.vars || theme).palette.primary.dark
        },
        [`& .${(0, $9672c702e463ec89$export$2e2bcd8739ae039).avatarColorSecondary}`]: {
            color: (theme.vars || theme).palette.secondary.contrastText,
            backgroundColor: (theme.vars || theme).palette.secondary.dark
        },
        [`& .${(0, $9672c702e463ec89$export$2e2bcd8739ae039).avatarSmall}`]: {
            marginLeft: 4,
            marginRight: -4,
            width: 18,
            height: 18,
            fontSize: theme.typography.pxToRem(10)
        },
        [`& .${(0, $9672c702e463ec89$export$2e2bcd8739ae039).icon}`]: (0, $3VnFq.default)({
            marginLeft: 5,
            marginRight: -6
        }, ownerState.size === 'small' && {
            fontSize: 18,
            marginLeft: 4,
            marginRight: -4
        }, ownerState.iconColor === ownerState.color && (0, $3VnFq.default)({
            color: theme.vars ? theme.vars.palette.Chip.defaultIconColor : textColor
        }, ownerState.color !== 'default' && {
            color: 'inherit'
        })),
        [`& .${(0, $9672c702e463ec89$export$2e2bcd8739ae039).deleteIcon}`]: (0, $3VnFq.default)({
            WebkitTapHighlightColor: 'transparent',
            color: theme.vars ? `rgba(${theme.vars.palette.text.primaryChannel} / 0.26)` : (0, $fwsmC.alpha)(theme.palette.text.primary, 0.26),
            fontSize: 22,
            cursor: 'pointer',
            margin: '0 5px 0 -6px',
            '&:hover': {
                color: theme.vars ? `rgba(${theme.vars.palette.text.primaryChannel} / 0.4)` : (0, $fwsmC.alpha)(theme.palette.text.primary, 0.4)
            }
        }, ownerState.size === 'small' && {
            fontSize: 16,
            marginRight: 4,
            marginLeft: -4
        }, ownerState.color !== 'default' && {
            color: theme.vars ? `rgba(${theme.vars.palette[ownerState.color].contrastTextChannel} / 0.7)` : (0, $fwsmC.alpha)(theme.palette[ownerState.color].contrastText, 0.7),
            '&:hover, &:active': {
                color: (theme.vars || theme).palette[ownerState.color].contrastText
            }
        })
    }, ownerState.size === 'small' && {
        height: 24
    }, ownerState.color !== 'default' && {
        backgroundColor: (theme.vars || theme).palette[ownerState.color].main,
        color: (theme.vars || theme).palette[ownerState.color].contrastText
    }, ownerState.onDelete && {
        [`&.${(0, $9672c702e463ec89$export$2e2bcd8739ae039).focusVisible}`]: {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.action.selectedChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.focusOpacity}))` : (0, $fwsmC.alpha)(theme.palette.action.selected, theme.palette.action.selectedOpacity + theme.palette.action.focusOpacity)
        }
    }, ownerState.onDelete && ownerState.color !== 'default' && {
        [`&.${(0, $9672c702e463ec89$export$2e2bcd8739ae039).focusVisible}`]: {
            backgroundColor: (theme.vars || theme).palette[ownerState.color].dark
        }
    });
}, ({ theme: theme, ownerState: ownerState })=>(0, $3VnFq.default)({}, ownerState.clickable && {
        userSelect: 'none',
        WebkitTapHighlightColor: 'transparent',
        cursor: 'pointer',
        '&:hover': {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.action.selectedChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.hoverOpacity}))` : (0, $fwsmC.alpha)(theme.palette.action.selected, theme.palette.action.selectedOpacity + theme.palette.action.hoverOpacity)
        },
        [`&.${(0, $9672c702e463ec89$export$2e2bcd8739ae039).focusVisible}`]: {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.action.selectedChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.focusOpacity}))` : (0, $fwsmC.alpha)(theme.palette.action.selected, theme.palette.action.selectedOpacity + theme.palette.action.focusOpacity)
        },
        '&:active': {
            boxShadow: (theme.vars || theme).shadows[1]
        }
    }, ownerState.clickable && ownerState.color !== 'default' && {
        [`&:hover, &.${(0, $9672c702e463ec89$export$2e2bcd8739ae039).focusVisible}`]: {
            backgroundColor: (theme.vars || theme).palette[ownerState.color].dark
        }
    }), ({ theme: theme, ownerState: ownerState })=>(0, $3VnFq.default)({}, ownerState.variant === 'outlined' && {
        backgroundColor: 'transparent',
        border: theme.vars ? `1px solid ${theme.vars.palette.Chip.defaultBorder}` : `1px solid ${theme.palette.mode === 'light' ? theme.palette.grey[400] : theme.palette.grey[700]}`,
        [`&.${(0, $9672c702e463ec89$export$2e2bcd8739ae039).clickable}:hover`]: {
            backgroundColor: (theme.vars || theme).palette.action.hover
        },
        [`&.${(0, $9672c702e463ec89$export$2e2bcd8739ae039).focusVisible}`]: {
            backgroundColor: (theme.vars || theme).palette.action.focus
        },
        [`& .${(0, $9672c702e463ec89$export$2e2bcd8739ae039).avatar}`]: {
            marginLeft: 4
        },
        [`& .${(0, $9672c702e463ec89$export$2e2bcd8739ae039).avatarSmall}`]: {
            marginLeft: 2
        },
        [`& .${(0, $9672c702e463ec89$export$2e2bcd8739ae039).icon}`]: {
            marginLeft: 4
        },
        [`& .${(0, $9672c702e463ec89$export$2e2bcd8739ae039).iconSmall}`]: {
            marginLeft: 2
        },
        [`& .${(0, $9672c702e463ec89$export$2e2bcd8739ae039).deleteIcon}`]: {
            marginRight: 5
        },
        [`& .${(0, $9672c702e463ec89$export$2e2bcd8739ae039).deleteIconSmall}`]: {
            marginRight: 3
        }
    }, ownerState.variant === 'outlined' && ownerState.color !== 'default' && {
        color: (theme.vars || theme).palette[ownerState.color].main,
        border: `1px solid ${theme.vars ? `rgba(${theme.vars.palette[ownerState.color].mainChannel} / 0.7)` : (0, $fwsmC.alpha)(theme.palette[ownerState.color].main, 0.7)}`,
        [`&.${(0, $9672c702e463ec89$export$2e2bcd8739ae039).clickable}:hover`]: {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette[ownerState.color].mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $fwsmC.alpha)(theme.palette[ownerState.color].main, theme.palette.action.hoverOpacity)
        },
        [`&.${(0, $9672c702e463ec89$export$2e2bcd8739ae039).focusVisible}`]: {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette[ownerState.color].mainChannel} / ${theme.vars.palette.action.focusOpacity})` : (0, $fwsmC.alpha)(theme.palette[ownerState.color].main, theme.palette.action.focusOpacity)
        },
        [`& .${(0, $9672c702e463ec89$export$2e2bcd8739ae039).deleteIcon}`]: {
            color: theme.vars ? `rgba(${theme.vars.palette[ownerState.color].mainChannel} / 0.7)` : (0, $fwsmC.alpha)(theme.palette[ownerState.color].main, 0.7),
            '&:hover, &:active': {
                color: (theme.vars || theme).palette[ownerState.color].main
            }
        }
    }));
const $d3e26472a67ba319$var$ChipLabel = (0, $HGmne.default)('span', {
    name: 'MuiChip',
    slot: 'Label',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        const { size: size } = ownerState;
        return [
            styles.label,
            styles[`label${(0, $cVrVk.default)(size)}`]
        ];
    }
})(({ ownerState: ownerState })=>(0, $3VnFq.default)({
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        paddingLeft: 12,
        paddingRight: 12,
        whiteSpace: 'nowrap'
    }, ownerState.variant === 'outlined' && {
        paddingLeft: 11,
        paddingRight: 11
    }, ownerState.size === 'small' && {
        paddingLeft: 8,
        paddingRight: 8
    }, ownerState.size === 'small' && ownerState.variant === 'outlined' && {
        paddingLeft: 7,
        paddingRight: 7
    }));
function $d3e26472a67ba319$var$isDeleteKeyboardEvent(keyboardEvent) {
    return keyboardEvent.key === 'Backspace' || keyboardEvent.key === 'Delete';
}
/**
 * Chips represent complex entities in small blocks, such as a contact.
 */ const $d3e26472a67ba319$var$Chip = /*#__PURE__*/ $gJYWc.forwardRef(function Chip(inProps, ref) {
    const props = (0, $8pLcn.useDefaultProps)({
        props: inProps,
        name: 'MuiChip'
    });
    const { avatar: avatarProp, className: className, clickable: clickableProp, color: color = 'default', component: ComponentProp, deleteIcon: deleteIconProp, disabled: disabled = false, icon: iconProp, label: label, onClick: onClick, onDelete: onDelete, onKeyDown: onKeyDown, onKeyUp: onKeyUp, size: size = 'medium', variant: variant = 'filled', tabIndex: tabIndex, skipFocusWhenDisabled: skipFocusWhenDisabled = false // TODO v6: Rename to `focusableWhenDisabled`.
     } = props, other = (0, $cTAWX.default)(props, $d3e26472a67ba319$var$_excluded);
    const chipRef = $gJYWc.useRef(null);
    const handleRef = (0, $il32z.default)(chipRef, ref);
    const handleDeleteIconClick = (event)=>{
        // Stop the event from bubbling up to the `Chip`
        event.stopPropagation();
        if (onDelete) onDelete(event);
    };
    const handleKeyDown = (event)=>{
        // Ignore events from children of `Chip`.
        if (event.currentTarget === event.target && $d3e26472a67ba319$var$isDeleteKeyboardEvent(event)) // Will be handled in keyUp, otherwise some browsers
        // might init navigation
        event.preventDefault();
        if (onKeyDown) onKeyDown(event);
    };
    const handleKeyUp = (event)=>{
        // Ignore events from children of `Chip`.
        if (event.currentTarget === event.target) {
            if (onDelete && $d3e26472a67ba319$var$isDeleteKeyboardEvent(event)) onDelete(event);
            else if (event.key === 'Escape' && chipRef.current) chipRef.current.blur();
        }
        if (onKeyUp) onKeyUp(event);
    };
    const clickable = clickableProp !== false && onClick ? true : clickableProp;
    const component = clickable || onDelete ? (0, $fNSZE.default) : ComponentProp || 'div';
    const ownerState = (0, $3VnFq.default)({}, props, {
        component: component,
        disabled: disabled,
        size: size,
        color: color,
        iconColor: /*#__PURE__*/ $gJYWc.isValidElement(iconProp) ? iconProp.props.color || color : color,
        onDelete: !!onDelete,
        clickable: clickable,
        variant: variant
    });
    const classes = $d3e26472a67ba319$var$useUtilityClasses(ownerState);
    const moreProps = component === (0, $fNSZE.default) ? (0, $3VnFq.default)({
        component: ComponentProp || 'div',
        focusVisibleClassName: classes.focusVisible
    }, onDelete && {
        disableRipple: true
    }) : {};
    let deleteIcon = null;
    if (onDelete) deleteIcon = deleteIconProp && /*#__PURE__*/ $gJYWc.isValidElement(deleteIconProp) ? /*#__PURE__*/ $gJYWc.cloneElement(deleteIconProp, {
        className: (0, $2w6IV.default)(deleteIconProp.props.className, classes.deleteIcon),
        onClick: handleDeleteIconClick
    }) : /*#__PURE__*/ (0, $9wx12.jsx)((0, $b807756077cc313b$export$2e2bcd8739ae039), {
        className: (0, $2w6IV.default)(classes.deleteIcon),
        onClick: handleDeleteIconClick
    });
    let avatar = null;
    if (avatarProp && /*#__PURE__*/ $gJYWc.isValidElement(avatarProp)) avatar = /*#__PURE__*/ $gJYWc.cloneElement(avatarProp, {
        className: (0, $2w6IV.default)(classes.avatar, avatarProp.props.className)
    });
    let icon = null;
    if (iconProp && /*#__PURE__*/ $gJYWc.isValidElement(iconProp)) icon = /*#__PURE__*/ $gJYWc.cloneElement(iconProp, {
        className: (0, $2w6IV.default)(classes.icon, iconProp.props.className)
    });
    return /*#__PURE__*/ (0, $9wx12.jsxs)($d3e26472a67ba319$var$ChipRoot, (0, $3VnFq.default)({
        as: component,
        className: (0, $2w6IV.default)(classes.root, className),
        disabled: clickable && disabled ? true : undefined,
        onClick: onClick,
        onKeyDown: handleKeyDown,
        onKeyUp: handleKeyUp,
        ref: handleRef,
        tabIndex: skipFocusWhenDisabled && disabled ? -1 : tabIndex,
        ownerState: ownerState
    }, moreProps, other, {
        children: [
            avatar || icon,
            /*#__PURE__*/ (0, $9wx12.jsx)($d3e26472a67ba319$var$ChipLabel, {
                className: (0, $2w6IV.default)(classes.label),
                ownerState: ownerState,
                children: label
            }),
            deleteIcon
        ]
    }));
});
var $d3e26472a67ba319$export$2e2bcd8739ae039 = $d3e26472a67ba319$var$Chip;





const $17c769015ed16526$export$b56e55a3645a3ec = ({ id: id, title: title, district: district, name: name, image: image, to: to = `/places/${id}`, is_published: is_published, showStatus: showStatus })=>/*#__PURE__*/ (0, $9wx12.jsx)((0, $8384e1b28fff68bc$export$a6c7ac8248d6e38a), {
        className: "flex-1",
        to: to,
        children: /*#__PURE__*/ (0, $9wx12.jsx)((0, $0f9f0d79038d27f1$export$2e2bcd8739ae039), {
            sx: {
                border: 'none',
                minWidth: '250px'
            },
            variant: "outlined",
            children: /*#__PURE__*/ (0, $9wx12.jsxs)((0, $7fd75e6b57001627$export$2e2bcd8739ae039), {
                children: [
                    /*#__PURE__*/ (0, $9wx12.jsx)((0, $7cffc73c3124b15c$export$2e2bcd8739ae039), {
                        className: "transition-all",
                        sx: {
                            height: 200,
                            width: '100%'
                        },
                        component: "div",
                        image: image
                    }),
                    showStatus && /*#__PURE__*/ (0, $9wx12.jsx)("div", {
                        className: "absolute top-5 left-5",
                        children: /*#__PURE__*/ (0, $9wx12.jsx)((0, $d3e26472a67ba319$export$2e2bcd8739ae039), {
                            label: is_published ? 'published' : 'unpublished',
                            color: is_published ? 'success' : 'warning',
                            size: "small"
                        })
                    }),
                    /*#__PURE__*/ (0, $9wx12.jsxs)((0, $f1b4cb86cd061e99$export$2e2bcd8739ae039), {
                        children: [
                            /*#__PURE__*/ (0, $9wx12.jsx)((0, $b4083ea3a052dee9$export$2e2bcd8739ae039), {
                                sx: {
                                    fontWeight: 600
                                },
                                className: "font-bold two-line-truncate",
                                children: title
                            }),
                            /*#__PURE__*/ (0, $9wx12.jsxs)((0, $b4083ea3a052dee9$export$2e2bcd8739ae039), {
                                color: "text.secondary",
                                component: "span",
                                children: [
                                    name,
                                    " - ",
                                    district
                                ]
                            })
                        ]
                    })
                ]
            })
        })
    }, title);


const $62d4562a7043f33d$export$51d95724e2f95a4d = ({ ads: ads, totalAdNumber: totalAdNumber, setShowMap: setShowMap, showMap: showMap })=>{
    const { t: t } = (0, $980e4b3a97f1ad67$export$9fc83ad70ead8663)();
    return /*#__PURE__*/ (0, $9wx12.jsxs)("div", {
        className: "px-5 min-w-[70%] w-full overflow-scroll",
        children: [
            /*#__PURE__*/ (0, $9wx12.jsxs)("div", {
                className: "py-5 justify-between flex",
                children: [
                    /*#__PURE__*/ (0, $9wx12.jsxs)((0, $b4083ea3a052dee9$export$2e2bcd8739ae039), {
                        children: [
                            t('ads.showing'),
                            " ",
                            ads.length,
                            " ",
                            t('ads.out-of'),
                            " ",
                            totalAdNumber,
                            " ",
                            t('ads.ads')
                        ]
                    }),
                    /*#__PURE__*/ (0, $9wx12.jsx)("div", {
                        className: "hidden lg:block",
                        children: /*#__PURE__*/ (0, $9wx12.jsx)((0, $b4083ea3a052dee9$export$2e2bcd8739ae039), {
                            children: /*#__PURE__*/ (0, $9wx12.jsx)((0, $0ead88154c59e96d$export$2e2bcd8739ae039), {
                                control: /*#__PURE__*/ (0, $9wx12.jsx)((0, $c69e86b3c89ddcdf$export$2e2bcd8739ae039), {
                                    checked: showMap,
                                    onChange: (e)=>setShowMap(e.target.checked)
                                }),
                                label: "Show map",
                                labelPlacement: "start"
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $9wx12.jsx)("div", {
                className: "grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4",
                children: ads.map(({ district: district, title: title, id: id, hero_images: hero_images, name: name })=>/*#__PURE__*/ (0, $9wx12.jsx)((0, $17c769015ed16526$export$b56e55a3645a3ec), {
                        id: id,
                        to: `/places/${id}`,
                        title: title,
                        district: district,
                        image: hero_images[0],
                        name: name
                    }, title + id))
            })
        ]
    });
};



var $9wx12 = parcelRequire("9wx12");

var $gJYWc = parcelRequire("gJYWc");

var $gJYWc = parcelRequire("gJYWc");

var $gJYWc = parcelRequire("gJYWc");

var $gJYWc = parcelRequire("gJYWc");

const $d807c1b4a01bf299$export$c6c68f6e4db55944 = $gJYWc.createContext(null);
const $d807c1b4a01bf299$export$507c997ee09bb471 = (props)=>{
    const [maps, setMaps] = (0, $gJYWc.useState)({});
    const onMapMount = (0, $gJYWc.useCallback)((map, id = 'default')=>{
        setMaps((currMaps)=>{
            if (id === 'current') throw new Error("'current' cannot be used as map id");
            if (currMaps[id]) throw new Error(`Multiple maps with the same id: ${id}`);
            return {
                ...currMaps,
                [id]: map
            };
        });
    }, []);
    const onMapUnmount = (0, $gJYWc.useCallback)((id = 'default')=>{
        setMaps((currMaps)=>{
            if (currMaps[id]) {
                const nextMaps = {
                    ...currMaps
                };
                delete nextMaps[id];
                return nextMaps;
            }
            return currMaps;
        });
    }, []);
    return $gJYWc.createElement($d807c1b4a01bf299$export$c6c68f6e4db55944.Provider, {
        value: {
            maps: maps,
            onMapMount: onMapMount,
            onMapUnmount: onMapUnmount
        }
    }, props.children);
};
function $d807c1b4a01bf299$export$86f8f9f08863e403() {
    var _a;
    const maps = (_a = (0, $gJYWc.useContext)($d807c1b4a01bf299$export$c6c68f6e4db55944)) === null || _a === void 0 ? void 0 : _a.maps;
    const currentMap = (0, $gJYWc.useContext)((0, $657820df3c73cfea$export$dc7344301ae78f85));
    const mapsWithCurrent = (0, $gJYWc.useMemo)(()=>{
        return {
            ...maps,
            current: currentMap === null || currentMap === void 0 ? void 0 : currentMap.map
        };
    }, [
        maps,
        currentMap
    ]);
    return mapsWithCurrent;
}


/**
 * Compare two points
 * @param a
 * @param b
 * @returns true if the points are equal
 */ function $9e58cf7543d2f80a$export$cb7477365ef68362(a, b) {
    const ax = Array.isArray(a) ? a[0] : a ? a.x : 0;
    const ay = Array.isArray(a) ? a[1] : a ? a.y : 0;
    const bx = Array.isArray(b) ? b[0] : b ? b.x : 0;
    const by = Array.isArray(b) ? b[1] : b ? b.y : 0;
    return ax === bx && ay === by;
}
function $9e58cf7543d2f80a$export$9cb4719e2e525b7a(a, b) {
    if (a === b) return true;
    if (!a || !b) return false;
    if (Array.isArray(a)) {
        if (!Array.isArray(b) || a.length !== b.length) return false;
        for(let i = 0; i < a.length; i++){
            if (!$9e58cf7543d2f80a$export$9cb4719e2e525b7a(a[i], b[i])) return false;
        }
        return true;
    } else if (Array.isArray(b)) return false;
    if (typeof a === 'object' && typeof b === 'object') {
        const aKeys = Object.keys(a);
        const bKeys = Object.keys(b);
        if (aKeys.length !== bKeys.length) return false;
        for (const key of aKeys){
            if (!b.hasOwnProperty(key)) return false;
            if (!$9e58cf7543d2f80a$export$9cb4719e2e525b7a(a[key], b[key])) return false;
        }
        return true;
    }
    return false;
}


function $a62c86cc4f0e913b$export$dd516654c5f598fb(tr) {
    const newTransform = tr.clone();
    // Work around mapbox bug - this value is not assigned in clone(), only in resize()
    newTransform.pixelsToGLUnits = tr.pixelsToGLUnits;
    return newTransform;
}
function $a62c86cc4f0e913b$export$7bd220dfde473c56(src, dest) {
    if (!src.getProjection) return;
    const srcProjection = src.getProjection();
    const destProjection = dest.getProjection();
    if (!(0, $9e58cf7543d2f80a$export$9cb4719e2e525b7a)(srcProjection, destProjection)) dest.setProjection(srcProjection);
}
function $a62c86cc4f0e913b$export$6a605c5aa5bd97a8(tr) {
    return {
        longitude: tr.center.lng,
        latitude: tr.center.lat,
        zoom: tr.zoom,
        pitch: tr.pitch,
        bearing: tr.bearing,
        padding: tr.padding
    };
}
function $a62c86cc4f0e913b$export$5cf06eaeb862e3ce(tr, props) {
    const v = props.viewState || props;
    let changed = false;
    if ('zoom' in v) {
        const zoom = tr.zoom;
        tr.zoom = v.zoom;
        changed = changed || zoom !== tr.zoom;
    }
    if ('bearing' in v) {
        const bearing = tr.bearing;
        tr.bearing = v.bearing;
        changed = changed || bearing !== tr.bearing;
    }
    if ('pitch' in v) {
        const pitch = tr.pitch;
        tr.pitch = v.pitch;
        changed = changed || pitch !== tr.pitch;
    }
    if (v.padding && !tr.isPaddingEqual(v.padding)) {
        changed = true;
        tr.padding = v.padding;
    }
    if ('longitude' in v && 'latitude' in v) {
        const center = tr.center;
        // @ts-ignore
        tr.center = new center.constructor(v.longitude, v.latitude);
        changed = changed || center !== tr.center;
    }
    return changed;
}


const $d63dd3e3cd003cb0$var$refProps = [
    'type',
    'source',
    'source-layer',
    'minzoom',
    'maxzoom',
    'filter',
    'layout'
];
function $d63dd3e3cd003cb0$export$8756898546458274(style) {
    if (!style) return null;
    if (typeof style === 'string') return style;
    if ('toJS' in style) style = style.toJS();
    if (!style.layers) return style;
    const layerIndex = {};
    for (const layer of style.layers)layerIndex[layer.id] = layer;
    const layers = style.layers.map((layer)=>{
        let normalizedLayer = null;
        if ('interactive' in layer) {
            normalizedLayer = Object.assign({}, layer);
            // Breaks style diffing :(
            // @ts-ignore legacy field not typed
            delete normalizedLayer.interactive;
        }
        // Style diffing doesn't work with refs so expand them out manually before diffing.
        // @ts-ignore legacy field not typed
        const layerRef = layerIndex[layer.ref];
        if (layerRef) {
            normalizedLayer = normalizedLayer || Object.assign({}, layer);
            // @ts-ignore
            delete normalizedLayer.ref;
            // https://github.com/mapbox/mapbox-gl-js/blob/master/src/style-spec/deref.js
            for (const propName of $d63dd3e3cd003cb0$var$refProps)if (propName in layerRef) normalizedLayer[propName] = layerRef[propName];
        }
        return normalizedLayer || layer;
    });
    // Do not mutate the style object provided by the user
    return {
        ...style,
        layers: layers
    };
}



const $f2ad7bd9d576eca4$var$DEFAULT_STYLE = {
    version: 8,
    sources: {},
    layers: []
};
const $f2ad7bd9d576eca4$var$pointerEvents = {
    mousedown: 'onMouseDown',
    mouseup: 'onMouseUp',
    mouseover: 'onMouseOver',
    mousemove: 'onMouseMove',
    click: 'onClick',
    dblclick: 'onDblClick',
    mouseenter: 'onMouseEnter',
    mouseleave: 'onMouseLeave',
    mouseout: 'onMouseOut',
    contextmenu: 'onContextMenu',
    touchstart: 'onTouchStart',
    touchend: 'onTouchEnd',
    touchmove: 'onTouchMove',
    touchcancel: 'onTouchCancel'
};
const $f2ad7bd9d576eca4$var$cameraEvents = {
    movestart: 'onMoveStart',
    move: 'onMove',
    moveend: 'onMoveEnd',
    dragstart: 'onDragStart',
    drag: 'onDrag',
    dragend: 'onDragEnd',
    zoomstart: 'onZoomStart',
    zoom: 'onZoom',
    zoomend: 'onZoomEnd',
    rotatestart: 'onRotateStart',
    rotate: 'onRotate',
    rotateend: 'onRotateEnd',
    pitchstart: 'onPitchStart',
    pitch: 'onPitch',
    pitchend: 'onPitchEnd'
};
const $f2ad7bd9d576eca4$var$otherEvents = {
    wheel: 'onWheel',
    boxzoomstart: 'onBoxZoomStart',
    boxzoomend: 'onBoxZoomEnd',
    boxzoomcancel: 'onBoxZoomCancel',
    resize: 'onResize',
    load: 'onLoad',
    render: 'onRender',
    idle: 'onIdle',
    remove: 'onRemove',
    data: 'onData',
    styledata: 'onStyleData',
    sourcedata: 'onSourceData',
    error: 'onError'
};
const $f2ad7bd9d576eca4$var$settingNames = [
    'minZoom',
    'maxZoom',
    'minPitch',
    'maxPitch',
    'maxBounds',
    'projection',
    'renderWorldCopies'
];
const $f2ad7bd9d576eca4$var$handlerNames = [
    'scrollZoom',
    'boxZoom',
    'dragRotate',
    'dragPan',
    'keyboard',
    'doubleClickZoom',
    'touchZoomRotate',
    'touchPitch'
];
class $f2ad7bd9d576eca4$export$2e2bcd8739ae039 {
    get map() {
        return this._map;
    }
    get transform() {
        return this._renderTransform;
    }
    setProps(props) {
        const oldProps = this.props;
        this.props = props;
        const settingsChanged = this._updateSettings(props, oldProps);
        if (settingsChanged) this._createShadowTransform(this._map);
        const sizeChanged = this._updateSize(props);
        const viewStateChanged = this._updateViewState(props, true);
        this._updateStyle(props, oldProps);
        this._updateStyleComponents(props, oldProps);
        this._updateHandlers(props, oldProps);
        // If 1) view state has changed to match props and
        //    2) the props change is not triggered by map events,
        // it's driven by an external state change. Redraw immediately
        if (settingsChanged || sizeChanged || viewStateChanged && !this._map.isMoving()) this.redraw();
    }
    static reuse(props, container) {
        const that = $f2ad7bd9d576eca4$export$2e2bcd8739ae039.savedMaps.pop();
        if (!that) return null;
        const map = that.map;
        // When reusing the saved map, we need to reparent the map(canvas) and other child nodes
        // intoto the new container from the props.
        // Step 1: reparenting child nodes from old container to new container
        const oldContainer = map.getContainer();
        container.className = oldContainer.className;
        while(oldContainer.childNodes.length > 0)container.appendChild(oldContainer.childNodes[0]);
        // Step 2: replace the internal container with new container from the react component
        // @ts-ignore
        map._container = container;
        // With maplibre-gl as mapLib, map uses ResizeObserver to observe when its container resizes.
        // When reusing the saved map, we need to disconnect the observer and observe the new container.
        // Step 3: telling the ResizeObserver to disconnect and observe the new container
        // @ts-ignore
        const resizeObserver = map._resizeObserver;
        if (resizeObserver) {
            resizeObserver.disconnect();
            resizeObserver.observe(container);
        }
        // Step 4: apply new props
        that.setProps({
            ...props,
            styleDiffing: false
        });
        map.resize();
        const { initialViewState: initialViewState } = props;
        if (initialViewState) {
            if (initialViewState.bounds) map.fitBounds(initialViewState.bounds, {
                ...initialViewState.fitBoundsOptions,
                duration: 0
            });
            else that._updateViewState(initialViewState, false);
        }
        // Simulate load event
        if (map.isStyleLoaded()) map.fire('load');
        else map.once('styledata', ()=>map.fire('load'));
        // Force reload
        // @ts-ignore
        map._update();
        return that;
    }
    /* eslint-disable complexity,max-statements */ _initialize(container) {
        const { props: props } = this;
        const { mapStyle: mapStyle = $f2ad7bd9d576eca4$var$DEFAULT_STYLE } = props;
        const mapOptions = {
            ...props,
            ...props.initialViewState,
            accessToken: props.mapboxAccessToken || $f2ad7bd9d576eca4$var$getAccessTokenFromEnv() || null,
            container: container,
            style: (0, $d63dd3e3cd003cb0$export$8756898546458274)(mapStyle)
        };
        const viewState = mapOptions.initialViewState || mapOptions.viewState || mapOptions;
        Object.assign(mapOptions, {
            center: [
                viewState.longitude || 0,
                viewState.latitude || 0
            ],
            zoom: viewState.zoom || 0,
            pitch: viewState.pitch || 0,
            bearing: viewState.bearing || 0
        });
        if (props.gl) {
            // eslint-disable-next-line
            const getContext = HTMLCanvasElement.prototype.getContext;
            // Hijack canvas.getContext to return our own WebGLContext
            // This will be called inside the mapboxgl.Map constructor
            // @ts-expect-error
            HTMLCanvasElement.prototype.getContext = ()=>{
                // Unhijack immediately
                HTMLCanvasElement.prototype.getContext = getContext;
                return props.gl;
            };
        }
        const map = new this._MapClass(mapOptions);
        // Props that are not part of constructor options
        if (viewState.padding) map.setPadding(viewState.padding);
        if (props.cursor) map.getCanvas().style.cursor = props.cursor;
        this._createShadowTransform(map);
        // Hack
        // Insert code into map's render cycle
        const renderMap = map._render;
        map._render = (arg)=>{
            this._inRender = true;
            renderMap.call(map, arg);
            this._inRender = false;
        };
        const runRenderTaskQueue = map._renderTaskQueue.run;
        map._renderTaskQueue.run = (arg)=>{
            runRenderTaskQueue.call(map._renderTaskQueue, arg);
            this._onBeforeRepaint();
        };
        map.on('render', ()=>this._onAfterRepaint());
        // Insert code into map's event pipeline
        // eslint-disable-next-line @typescript-eslint/unbound-method
        const fireEvent = map.fire;
        map.fire = this._fireEvent.bind(this, fireEvent);
        // add listeners
        map.on('resize', ()=>{
            this._renderTransform.resize(map.transform.width, map.transform.height);
        });
        map.on('styledata', ()=>{
            this._updateStyleComponents(this.props, {});
            // Projection can be set in stylesheet
            (0, $a62c86cc4f0e913b$export$7bd220dfde473c56)(map.transform, this._renderTransform);
        });
        map.on('sourcedata', ()=>this._updateStyleComponents(this.props, {}));
        for(const eventName in $f2ad7bd9d576eca4$var$pointerEvents)map.on(eventName, this._onPointerEvent);
        for(const eventName in $f2ad7bd9d576eca4$var$cameraEvents)map.on(eventName, this._onCameraEvent);
        for(const eventName in $f2ad7bd9d576eca4$var$otherEvents)map.on(eventName, this._onEvent);
        this._map = map;
    }
    /* eslint-enable complexity,max-statements */ recycle() {
        // Clean up unnecessary elements before storing for reuse.
        const container = this.map.getContainer();
        const children = container.querySelector('[mapboxgl-children]');
        children === null || children === void 0 || children.remove();
        $f2ad7bd9d576eca4$export$2e2bcd8739ae039.savedMaps.push(this);
    }
    destroy() {
        this._map.remove();
    }
    // Force redraw the map now. Typically resize() and jumpTo() is reflected in the next
    // render cycle, which is managed by Mapbox's animation loop.
    // This removes the synchronization issue caused by requestAnimationFrame.
    redraw() {
        const map = this._map;
        // map._render will throw error if style does not exist
        // https://github.com/mapbox/mapbox-gl-js/blob/fb9fc316da14e99ff4368f3e4faa3888fb43c513
        //   /src/ui/map.js#L1834
        if (!this._inRender && map.style) {
            // cancel the scheduled update
            if (map._frame) {
                map._frame.cancel();
                map._frame = null;
            }
            // the order is important - render() may schedule another update
            map._render();
        }
    }
    _createShadowTransform(map) {
        const renderTransform = (0, $a62c86cc4f0e913b$export$dd516654c5f598fb)(map.transform);
        map.painter.transform = renderTransform;
        this._renderTransform = renderTransform;
    }
    /* Trigger map resize if size is controlled
       @param {object} nextProps
       @returns {bool} true if size has changed
     */ _updateSize(nextProps) {
        // Check if size is controlled
        const { viewState: viewState } = nextProps;
        if (viewState) {
            const map = this._map;
            if (viewState.width !== map.transform.width || viewState.height !== map.transform.height) {
                map.resize();
                return true;
            }
        }
        return false;
    }
    // Adapted from map.jumpTo
    /* Update camera to match props
       @param {object} nextProps
       @param {bool} triggerEvents - should fire camera events
       @returns {bool} true if anything is changed
     */ _updateViewState(nextProps, triggerEvents) {
        if (this._internalUpdate) return false;
        const map = this._map;
        const tr = this._renderTransform;
        // Take a snapshot of the transform before mutation
        const { zoom: zoom, pitch: pitch, bearing: bearing } = tr;
        const isMoving = map.isMoving();
        if (isMoving) // All movement of the camera is done relative to the sea level
        tr.cameraElevationReference = 'sea';
        const changed = (0, $a62c86cc4f0e913b$export$5cf06eaeb862e3ce)(tr, {
            ...(0, $a62c86cc4f0e913b$export$6a605c5aa5bd97a8)(map.transform),
            ...nextProps
        });
        if (isMoving) // Reset camera reference
        tr.cameraElevationReference = 'ground';
        if (changed && triggerEvents) {
            const deferredEvents = this._deferredEvents;
            // Delay DOM control updates to the next render cycle
            deferredEvents.move = true;
            deferredEvents.zoom || (deferredEvents.zoom = zoom !== tr.zoom);
            deferredEvents.rotate || (deferredEvents.rotate = bearing !== tr.bearing);
            deferredEvents.pitch || (deferredEvents.pitch = pitch !== tr.pitch);
        }
        // Avoid manipulating the real transform when interaction/animation is ongoing
        // as it would interfere with Mapbox's handlers
        if (!isMoving) (0, $a62c86cc4f0e913b$export$5cf06eaeb862e3ce)(map.transform, nextProps);
        return changed;
    }
    /* Update camera constraints and projection settings to match props
       @param {object} nextProps
       @param {object} currProps
       @returns {bool} true if anything is changed
     */ _updateSettings(nextProps, currProps) {
        const map = this._map;
        let changed = false;
        for (const propName of $f2ad7bd9d576eca4$var$settingNames)if (propName in nextProps && !(0, $9e58cf7543d2f80a$export$9cb4719e2e525b7a)(nextProps[propName], currProps[propName])) {
            changed = true;
            const setter = map[`set${propName[0].toUpperCase()}${propName.slice(1)}`];
            setter === null || setter === void 0 || setter.call(map, nextProps[propName]);
        }
        return changed;
    }
    /* Update map style to match props
       @param {object} nextProps
       @param {object} currProps
       @returns {bool} true if style is changed
     */ _updateStyle(nextProps, currProps) {
        if (nextProps.cursor !== currProps.cursor) this._map.getCanvas().style.cursor = nextProps.cursor || '';
        if (nextProps.mapStyle !== currProps.mapStyle) {
            const { mapStyle: mapStyle = $f2ad7bd9d576eca4$var$DEFAULT_STYLE, styleDiffing: styleDiffing = true } = nextProps;
            const options = {
                diff: styleDiffing
            };
            if ('localIdeographFontFamily' in nextProps) // @ts-ignore Mapbox specific prop
            options.localIdeographFontFamily = nextProps.localIdeographFontFamily;
            this._map.setStyle((0, $d63dd3e3cd003cb0$export$8756898546458274)(mapStyle), options);
            return true;
        }
        return false;
    }
    /* Update fog, light and terrain to match props
       @param {object} nextProps
       @param {object} currProps
       @returns {bool} true if anything is changed
     */ _updateStyleComponents(nextProps, currProps) {
        const map = this._map;
        let changed = false;
        if (map.isStyleLoaded()) {
            if ('light' in nextProps && map.setLight && !(0, $9e58cf7543d2f80a$export$9cb4719e2e525b7a)(nextProps.light, currProps.light)) {
                changed = true;
                map.setLight(nextProps.light);
            }
            if ('fog' in nextProps && map.setFog && !(0, $9e58cf7543d2f80a$export$9cb4719e2e525b7a)(nextProps.fog, currProps.fog)) {
                changed = true;
                map.setFog(nextProps.fog);
            }
            if ('terrain' in nextProps && map.setTerrain && !(0, $9e58cf7543d2f80a$export$9cb4719e2e525b7a)(nextProps.terrain, currProps.terrain)) {
                if (!nextProps.terrain || map.getSource(nextProps.terrain.source)) {
                    changed = true;
                    map.setTerrain(nextProps.terrain);
                }
            }
        }
        return changed;
    }
    /* Update interaction handlers to match props
       @param {object} nextProps
       @param {object} currProps
       @returns {bool} true if anything is changed
     */ _updateHandlers(nextProps, currProps) {
        var _a, _b;
        const map = this._map;
        let changed = false;
        for (const propName of $f2ad7bd9d576eca4$var$handlerNames){
            const newValue = (_a = nextProps[propName]) !== null && _a !== void 0 ? _a : true;
            const oldValue = (_b = currProps[propName]) !== null && _b !== void 0 ? _b : true;
            if (!(0, $9e58cf7543d2f80a$export$9cb4719e2e525b7a)(newValue, oldValue)) {
                changed = true;
                if (newValue) map[propName].enable(newValue);
                else map[propName].disable();
            }
        }
        return changed;
    }
    _queryRenderedFeatures(point) {
        const map = this._map;
        const tr = map.transform;
        const { interactiveLayerIds: interactiveLayerIds = [] } = this.props;
        try {
            map.transform = this._renderTransform;
            return map.queryRenderedFeatures(point, {
                layers: interactiveLayerIds.filter(map.getLayer.bind(map))
            });
        } catch (_a) {
            // May fail if style is not loaded
            return [];
        } finally{
            map.transform = tr;
        }
    }
    _updateHover(e) {
        var _a;
        const { props: props } = this;
        const shouldTrackHoveredFeatures = props.interactiveLayerIds && (props.onMouseMove || props.onMouseEnter || props.onMouseLeave);
        if (shouldTrackHoveredFeatures) {
            const eventType = e.type;
            const wasHovering = ((_a = this._hoveredFeatures) === null || _a === void 0 ? void 0 : _a.length) > 0;
            const features = this._queryRenderedFeatures(e.point);
            const isHovering = features.length > 0;
            if (!isHovering && wasHovering) {
                e.type = 'mouseleave';
                this._onPointerEvent(e);
            }
            this._hoveredFeatures = features;
            if (isHovering && !wasHovering) {
                e.type = 'mouseenter';
                this._onPointerEvent(e);
            }
            e.type = eventType;
        } else this._hoveredFeatures = null;
    }
    _fireEvent(baseFire, event, properties) {
        const map = this._map;
        const tr = map.transform;
        const eventType = typeof event === 'string' ? event : event.type;
        if (eventType === 'move') this._updateViewState(this.props, false);
        if (eventType in $f2ad7bd9d576eca4$var$cameraEvents) {
            if (typeof event === 'object') event.viewState = (0, $a62c86cc4f0e913b$export$6a605c5aa5bd97a8)(tr);
            if (this._map.isMoving()) {
                // Replace map.transform with ours during the callbacks
                map.transform = this._renderTransform;
                baseFire.call(map, event, properties);
                map.transform = tr;
                return map;
            }
        }
        baseFire.call(map, event, properties);
        return map;
    }
    // All camera manipulations are complete, ready to repaint
    _onBeforeRepaint() {
        const map = this._map;
        // If there are camera changes driven by props, invoke camera events so that DOM controls are synced
        this._internalUpdate = true;
        for(const eventType in this._deferredEvents)if (this._deferredEvents[eventType]) map.fire(eventType);
        this._internalUpdate = false;
        const tr = this._map.transform;
        // Make sure camera matches the current props
        map.transform = this._renderTransform;
        this._onAfterRepaint = ()=>{
            // Mapbox transitions between non-mercator projection and mercator during render time
            // Copy it back to the other
            (0, $a62c86cc4f0e913b$export$7bd220dfde473c56)(this._renderTransform, tr);
            // Restores camera state before render/load events are fired
            map.transform = tr;
        };
    }
    constructor(MapClass, props, container){
        // mapboxgl.Map instance
        this._map = null;
        // Internal states
        this._internalUpdate = false;
        this._inRender = false;
        this._hoveredFeatures = null;
        this._deferredEvents = {
            move: false,
            zoom: false,
            pitch: false,
            rotate: false
        };
        this._onEvent = (e)=>{
            // @ts-ignore
            const cb = this.props[$f2ad7bd9d576eca4$var$otherEvents[e.type]];
            if (cb) cb(e);
            else if (e.type === 'error') console.error(e.error); // eslint-disable-line
        };
        this._onPointerEvent = (e)=>{
            if (e.type === 'mousemove' || e.type === 'mouseout') this._updateHover(e);
            // @ts-ignore
            const cb = this.props[$f2ad7bd9d576eca4$var$pointerEvents[e.type]];
            if (cb) {
                if (this.props.interactiveLayerIds && e.type !== 'mouseover' && e.type !== 'mouseout') e.features = this._hoveredFeatures || this._queryRenderedFeatures(e.point);
                cb(e);
                delete e.features;
            }
        };
        this._onCameraEvent = (e)=>{
            if (!this._internalUpdate) {
                // @ts-ignore
                const cb = this.props[$f2ad7bd9d576eca4$var$cameraEvents[e.type]];
                if (cb) cb(e);
            }
            if (e.type in this._deferredEvents) this._deferredEvents[e.type] = false;
        };
        this._MapClass = MapClass;
        this.props = props;
        this._initialize(container);
    }
}
$f2ad7bd9d576eca4$export$2e2bcd8739ae039.savedMaps = [];
/**
 * Access token can be provided via one of:
 *   mapboxAccessToken prop
 *   access_token query parameter
 *   MapboxAccessToken environment variable
 *   REACT_APP_MAPBOX_ACCESS_TOKEN environment variable
 * @returns access token
 */ function $f2ad7bd9d576eca4$var$getAccessTokenFromEnv() {
    let accessToken = null;
    /* global location, process */ if (typeof location !== 'undefined') {
        const match = /access_token=([^&\/]*)/.exec(location.search);
        accessToken = match && match[1];
    }
    // Note: This depends on bundler plugins (e.g. webpack) importing environment correctly
    try {
        accessToken = accessToken || undefined;
    } catch (_a) {
    // ignore
    }
    try {
        accessToken = accessToken || undefined;
    } catch (_b) {
    // ignore
    }
    return accessToken;
}


/** These methods may break the react binding if called directly */ const $37811a23a98eaf70$var$skipMethods = [
    'setMaxBounds',
    'setMinZoom',
    'setMaxZoom',
    'setMinPitch',
    'setMaxPitch',
    'setRenderWorldCopies',
    'setProjection',
    'setStyle',
    'addSource',
    'removeSource',
    'addLayer',
    'removeLayer',
    'setLayerZoomRange',
    'setFilter',
    'setPaintProperty',
    'setLayoutProperty',
    'setLight',
    'setTerrain',
    'setFog',
    'remove'
];
function $37811a23a98eaf70$export$2e2bcd8739ae039(mapInstance) {
    if (!mapInstance) return null;
    const map = mapInstance.map;
    const result = {
        getMap: ()=>map,
        // Overwrite getters to use our shadow transform
        getCenter: ()=>mapInstance.transform.center,
        getZoom: ()=>mapInstance.transform.zoom,
        getBearing: ()=>mapInstance.transform.bearing,
        getPitch: ()=>mapInstance.transform.pitch,
        getPadding: ()=>mapInstance.transform.padding,
        getBounds: ()=>mapInstance.transform.getBounds(),
        project: (lnglat)=>{
            const tr = map.transform;
            map.transform = mapInstance.transform;
            const result = map.project(lnglat);
            map.transform = tr;
            return result;
        },
        unproject: (point)=>{
            const tr = map.transform;
            map.transform = mapInstance.transform;
            const result = map.unproject(point);
            map.transform = tr;
            return result;
        },
        // options diverge between mapbox and maplibre
        queryTerrainElevation: (lnglat, options)=>{
            const tr = map.transform;
            map.transform = mapInstance.transform;
            const result = map.queryTerrainElevation(lnglat, options);
            map.transform = tr;
            return result;
        },
        queryRenderedFeatures: (geometry, options)=>{
            const tr = map.transform;
            map.transform = mapInstance.transform;
            const result = map.queryRenderedFeatures(geometry, options);
            map.transform = tr;
            return result;
        }
    };
    for (const key of $37811a23a98eaf70$var$getMethodNames(map))// @ts-expect-error
    if (!(key in result) && !$37811a23a98eaf70$var$skipMethods.includes(key)) result[key] = map[key].bind(map);
    return result;
}
function $37811a23a98eaf70$var$getMethodNames(obj) {
    const result = new Set();
    let proto = obj;
    while(proto){
        for (const key of Object.getOwnPropertyNames(proto))if (key[0] !== '_' && typeof obj[key] === 'function' && key !== 'fire' && key !== 'setEventedParent') result.add(key);
        proto = Object.getPrototypeOf(proto);
    }
    return Array.from(result);
}


// From https://github.com/streamich/react-use/blob/master/src/useIsomorphicLayoutEffect.ts
// useLayoutEffect but does not trigger warning in server-side rendering

var $gJYWc = parcelRequire("gJYWc");
const $36867c76dea5f87a$var$useIsomorphicLayoutEffect = typeof document !== 'undefined' ? (0, $gJYWc.useLayoutEffect) : (0, $gJYWc.useEffect);
var $36867c76dea5f87a$export$2e2bcd8739ae039 = $36867c76dea5f87a$var$useIsomorphicLayoutEffect;


const $be02ee68cdf4726e$var$globalSettings = [
    'baseApiUrl',
    'maxParallelImageRequests',
    'workerClass',
    'workerCount',
    'workerUrl'
];
function $be02ee68cdf4726e$export$2e2bcd8739ae039(mapLib, props) {
    for (const key of $be02ee68cdf4726e$var$globalSettings)if (key in props) mapLib[key] = props[key];
    const { RTLTextPlugin: RTLTextPlugin = 'https://api.mapbox.com/mapbox-gl-js/plugins/mapbox-gl-rtl-text/v0.2.3/mapbox-gl-rtl-text.js' } = props;
    if (RTLTextPlugin && mapLib.getRTLTextPluginStatus && mapLib.getRTLTextPluginStatus() === 'unavailable') mapLib.setRTLTextPlugin(RTLTextPlugin, (error)=>{
        if (error) // eslint-disable-next-line
        console.error(error);
    }, true);
}


const $657820df3c73cfea$export$dc7344301ae78f85 = $gJYWc.createContext(null);
function $657820df3c73cfea$export$2e2bcd8739ae039(props, ref, defaultLib) {
    const mountedMapsContext = (0, $gJYWc.useContext)((0, $d807c1b4a01bf299$export$c6c68f6e4db55944));
    const [mapInstance, setMapInstance] = (0, $gJYWc.useState)(null);
    const containerRef = (0, $gJYWc.useRef)();
    const { current: contextValue } = (0, $gJYWc.useRef)({
        mapLib: null,
        map: null
    });
    (0, $gJYWc.useEffect)(()=>{
        const mapLib = props.mapLib;
        let isMounted = true;
        let mapbox;
        Promise.resolve(mapLib || defaultLib).then((module)=>{
            if (!isMounted) return;
            if (!module) throw new Error('Invalid mapLib');
            const mapboxgl = 'Map' in module ? module : module.default;
            if (!mapboxgl.Map) throw new Error('Invalid mapLib');
            // workerUrl & workerClass may change the result of supported()
            // https://github.com/visgl/react-map-gl/discussions/2027
            (0, $be02ee68cdf4726e$export$2e2bcd8739ae039)(mapboxgl, props);
            if (!mapboxgl.supported || mapboxgl.supported(props)) {
                if (props.reuseMaps) mapbox = (0, $f2ad7bd9d576eca4$export$2e2bcd8739ae039).reuse(props, containerRef.current);
                if (!mapbox) mapbox = new (0, $f2ad7bd9d576eca4$export$2e2bcd8739ae039)(mapboxgl.Map, props, containerRef.current);
                contextValue.map = (0, $37811a23a98eaf70$export$2e2bcd8739ae039)(mapbox);
                contextValue.mapLib = mapboxgl;
                setMapInstance(mapbox);
                mountedMapsContext === null || mountedMapsContext === void 0 || mountedMapsContext.onMapMount(contextValue.map, props.id);
            } else throw new Error('Map is not supported by this browser');
        }).catch((error)=>{
            const { onError: onError } = props;
            if (onError) onError({
                type: 'error',
                target: null,
                originalEvent: null,
                error: error
            });
            else console.error(error); // eslint-disable-line
        });
        return ()=>{
            isMounted = false;
            if (mapbox) {
                mountedMapsContext === null || mountedMapsContext === void 0 || mountedMapsContext.onMapUnmount(props.id);
                if (props.reuseMaps) mapbox.recycle();
                else mapbox.destroy();
            }
        };
    }, []);
    (0, $36867c76dea5f87a$export$2e2bcd8739ae039)(()=>{
        if (mapInstance) mapInstance.setProps(props);
    });
    (0, $gJYWc.useImperativeHandle)(ref, ()=>contextValue.map, [
        mapInstance
    ]);
    const style = (0, $gJYWc.useMemo)(()=>({
            position: 'relative',
            width: '100%',
            height: '100%',
            ...props.style
        }), [
        props.style
    ]);
    const CHILD_CONTAINER_STYLE = {
        height: '100%'
    };
    return $gJYWc.createElement("div", {
        id: props.id,
        ref: containerRef,
        style: style
    }, mapInstance && $gJYWc.createElement($657820df3c73cfea$export$dc7344301ae78f85.Provider, {
        value: contextValue
    }, $gJYWc.createElement("div", {
        "mapboxgl-children": "",
        style: CHILD_CONTAINER_STYLE
    }, props.children)));
}


/* global document */ 
var $gJYWc = parcelRequire("gJYWc");

// This is a simplified version of
// https://github.com/facebook/react/blob/4131af3e4bf52f3a003537ec95a1655147c81270/src/renderers/dom/shared/CSSPropertyOperations.js#L62
const $dd9ba8d53f7ec118$var$unitlessNumber = /box|flex|grid|column|lineHeight|fontWeight|opacity|order|tabSize|zIndex/;
function $dd9ba8d53f7ec118$export$cd93e47e6d398387(element, styles) {
    if (!element || !styles) return;
    const style = element.style;
    for(const key in styles){
        const value = styles[key];
        if (Number.isFinite(value) && !$dd9ba8d53f7ec118$var$unitlessNumber.test(key)) style[key] = `${value}px`;
        else style[key] = value;
    }
}




/* eslint-disable complexity,max-statements */ function $e118a169fbf58a53$var$Marker(props, ref) {
    const { map: map, mapLib: mapLib } = (0, $gJYWc.useContext)((0, $657820df3c73cfea$export$dc7344301ae78f85));
    const thisRef = (0, $gJYWc.useRef)({
        props: props
    });
    thisRef.current.props = props;
    const marker = (0, $gJYWc.useMemo)(()=>{
        let hasChildren = false;
        $gJYWc.Children.forEach(props.children, (el)=>{
            if (el) hasChildren = true;
        });
        const options = {
            ...props,
            element: hasChildren ? document.createElement('div') : null
        };
        const mk = new mapLib.Marker(options);
        mk.setLngLat([
            props.longitude,
            props.latitude
        ]);
        mk.getElement().addEventListener('click', (e)=>{
            var _a, _b;
            (_b = (_a = thisRef.current.props).onClick) === null || _b === void 0 || _b.call(_a, {
                type: 'click',
                target: mk,
                originalEvent: e
            });
        });
        mk.on('dragstart', (e)=>{
            var _a, _b;
            const evt = e;
            evt.lngLat = marker.getLngLat();
            (_b = (_a = thisRef.current.props).onDragStart) === null || _b === void 0 || _b.call(_a, evt);
        });
        mk.on('drag', (e)=>{
            var _a, _b;
            const evt = e;
            evt.lngLat = marker.getLngLat();
            (_b = (_a = thisRef.current.props).onDrag) === null || _b === void 0 || _b.call(_a, evt);
        });
        mk.on('dragend', (e)=>{
            var _a, _b;
            const evt = e;
            evt.lngLat = marker.getLngLat();
            (_b = (_a = thisRef.current.props).onDragEnd) === null || _b === void 0 || _b.call(_a, evt);
        });
        return mk;
    }, []);
    (0, $gJYWc.useEffect)(()=>{
        marker.addTo(map.getMap());
        return ()=>{
            marker.remove();
        };
    }, []);
    const { longitude: longitude, latitude: latitude, offset: offset, style: style, draggable: draggable = false, popup: popup = null, rotation: rotation = 0, rotationAlignment: rotationAlignment = 'auto', pitchAlignment: pitchAlignment = 'auto' } = props;
    (0, $gJYWc.useEffect)(()=>{
        (0, $dd9ba8d53f7ec118$export$cd93e47e6d398387)(marker.getElement(), style);
    }, [
        style
    ]);
    (0, $gJYWc.useImperativeHandle)(ref, ()=>marker, []);
    if (marker.getLngLat().lng !== longitude || marker.getLngLat().lat !== latitude) marker.setLngLat([
        longitude,
        latitude
    ]);
    if (offset && !(0, $9e58cf7543d2f80a$export$cb7477365ef68362)(marker.getOffset(), offset)) marker.setOffset(offset);
    if (marker.isDraggable() !== draggable) marker.setDraggable(draggable);
    if (marker.getRotation() !== rotation) marker.setRotation(rotation);
    if (marker.getRotationAlignment() !== rotationAlignment) marker.setRotationAlignment(rotationAlignment);
    if (marker.getPitchAlignment() !== pitchAlignment) marker.setPitchAlignment(pitchAlignment);
    if (marker.getPopup() !== popup) marker.setPopup(popup);
    return (0, $b5d6c7fd13e04efb$exports.createPortal)(props.children, marker.getElement());
}
var $e118a169fbf58a53$export$2e2bcd8739ae039 = (0, $gJYWc.memo)((0, $gJYWc.forwardRef)($e118a169fbf58a53$var$Marker));




var $gJYWc = parcelRequire("gJYWc");



// Adapted from https://github.com/mapbox/mapbox-gl-js/blob/v1.13.0/src/ui/popup.js
function $e9003cf2dff7eb99$var$getClassList(className) {
    return new Set(className ? className.trim().split(/\s+/) : []);
}
/* eslint-disable complexity,max-statements */ function $e9003cf2dff7eb99$var$Popup(props, ref) {
    const { map: map, mapLib: mapLib } = (0, $gJYWc.useContext)((0, $657820df3c73cfea$export$dc7344301ae78f85));
    const container = (0, $gJYWc.useMemo)(()=>{
        return document.createElement('div');
    }, []);
    const thisRef = (0, $gJYWc.useRef)({
        props: props
    });
    thisRef.current.props = props;
    const popup = (0, $gJYWc.useMemo)(()=>{
        const options = {
            ...props
        };
        const pp = new mapLib.Popup(options);
        pp.setLngLat([
            props.longitude,
            props.latitude
        ]);
        pp.once('open', (e)=>{
            var _a, _b;
            (_b = (_a = thisRef.current.props).onOpen) === null || _b === void 0 || _b.call(_a, e);
        });
        return pp;
    }, []);
    (0, $gJYWc.useEffect)(()=>{
        const onClose = (e)=>{
            var _a, _b;
            (_b = (_a = thisRef.current.props).onClose) === null || _b === void 0 || _b.call(_a, e);
        };
        popup.on('close', onClose);
        popup.setDOMContent(container).addTo(map.getMap());
        return ()=>{
            // https://github.com/visgl/react-map-gl/issues/1825
            // onClose should not be fired if the popup is removed by unmounting
            // When using React strict mode, the component is mounted twice.
            // Firing the onClose callback here would be a false signal to remove the component.
            popup.off('close', onClose);
            if (popup.isOpen()) popup.remove();
        };
    }, []);
    (0, $gJYWc.useEffect)(()=>{
        (0, $dd9ba8d53f7ec118$export$cd93e47e6d398387)(popup.getElement(), props.style);
    }, [
        props.style
    ]);
    (0, $gJYWc.useImperativeHandle)(ref, ()=>popup, []);
    if (popup.isOpen()) {
        if (popup.getLngLat().lng !== props.longitude || popup.getLngLat().lat !== props.latitude) popup.setLngLat([
            props.longitude,
            props.latitude
        ]);
        if (props.offset && !(0, $9e58cf7543d2f80a$export$9cb4719e2e525b7a)(popup.options.offset, props.offset)) popup.setOffset(props.offset);
        if (popup.options.anchor !== props.anchor || popup.options.maxWidth !== props.maxWidth) {
            popup.options.anchor = props.anchor;
            popup.setMaxWidth(props.maxWidth);
        }
        if (popup.options.className !== props.className) {
            const prevClassList = $e9003cf2dff7eb99$var$getClassList(popup.options.className);
            const nextClassList = $e9003cf2dff7eb99$var$getClassList(props.className);
            for (const c of prevClassList)if (!nextClassList.has(c)) popup.removeClassName(c);
            for (const c of nextClassList)if (!prevClassList.has(c)) popup.addClassName(c);
            popup.options.className = props.className;
        }
    }
    return (0, $b5d6c7fd13e04efb$exports.createPortal)(props.children, container);
}
var $e9003cf2dff7eb99$export$2e2bcd8739ae039 = (0, $gJYWc.memo)((0, $gJYWc.forwardRef)($e9003cf2dff7eb99$var$Popup));



var $gJYWc = parcelRequire("gJYWc");


var $gJYWc = parcelRequire("gJYWc");

function $306f49bf73dc72b4$var$useControl(onCreate, arg1, arg2, arg3) {
    const context = (0, $gJYWc.useContext)((0, $657820df3c73cfea$export$dc7344301ae78f85));
    const ctrl = (0, $gJYWc.useMemo)(()=>onCreate(context), []);
    (0, $gJYWc.useEffect)(()=>{
        const opts = arg3 || arg2 || arg1;
        const onAdd = typeof arg1 === 'function' && typeof arg2 === 'function' ? arg1 : null;
        const onRemove = typeof arg2 === 'function' ? arg2 : typeof arg1 === 'function' ? arg1 : null;
        const { map: map } = context;
        if (!map.hasControl(ctrl)) {
            map.addControl(ctrl, opts === null || opts === void 0 ? void 0 : opts.position);
            if (onAdd) onAdd(context);
        }
        return ()=>{
            if (onRemove) onRemove(context);
            // Map might have been removed (parent effects are destroyed before child ones)
            if (map.hasControl(ctrl)) map.removeControl(ctrl);
        };
    }, []);
    return ctrl;
}
var $306f49bf73dc72b4$export$2e2bcd8739ae039 = $306f49bf73dc72b4$var$useControl;


function $88b03177a2616a1a$var$AttributionControl(props) {
    const ctrl = (0, $306f49bf73dc72b4$export$2e2bcd8739ae039)(({ mapLib: mapLib })=>new mapLib.AttributionControl(props), {
        position: props.position
    });
    (0, $gJYWc.useEffect)(()=>{
        (0, $dd9ba8d53f7ec118$export$cd93e47e6d398387)(ctrl._container, props.style);
    }, [
        props.style
    ]);
    return null;
}
var $88b03177a2616a1a$export$2e2bcd8739ae039 = (0, $gJYWc.memo)($88b03177a2616a1a$var$AttributionControl);



var $gJYWc = parcelRequire("gJYWc");


function $d46236873605e2e4$var$FullscreenControl(props) {
    const ctrl = (0, $306f49bf73dc72b4$export$2e2bcd8739ae039)(({ mapLib: mapLib })=>new mapLib.FullscreenControl({
            container: props.containerId && document.getElementById(props.containerId)
        }), {
        position: props.position
    });
    (0, $gJYWc.useEffect)(()=>{
        (0, $dd9ba8d53f7ec118$export$cd93e47e6d398387)(ctrl._controlContainer, props.style);
    }, [
        props.style
    ]);
    return null;
}
var $d46236873605e2e4$export$2e2bcd8739ae039 = (0, $gJYWc.memo)($d46236873605e2e4$var$FullscreenControl);



var $gJYWc = parcelRequire("gJYWc");


function $7a76cd57cf68f6d7$var$GeolocateControl(props, ref) {
    const thisRef = (0, $gJYWc.useRef)({
        props: props
    });
    const ctrl = (0, $306f49bf73dc72b4$export$2e2bcd8739ae039)(({ mapLib: mapLib })=>{
        const gc = new mapLib.GeolocateControl(props);
        // Hack: fix GeolocateControl reuse
        // When using React strict mode, the component is mounted twice.
        // GeolocateControl's UI creation is asynchronous. Removing and adding it back causes the UI to be initialized twice.
        // @ts-expect-error private method
        const setupUI = gc._setupUI;
        // @ts-expect-error private method
        gc._setupUI = (args)=>{
            if (!gc._container.hasChildNodes()) setupUI(args);
        };
        gc.on('geolocate', (e)=>{
            var _a, _b;
            (_b = (_a = thisRef.current.props).onGeolocate) === null || _b === void 0 || _b.call(_a, e);
        });
        gc.on('error', (e)=>{
            var _a, _b;
            (_b = (_a = thisRef.current.props).onError) === null || _b === void 0 || _b.call(_a, e);
        });
        gc.on('outofmaxbounds', (e)=>{
            var _a, _b;
            (_b = (_a = thisRef.current.props).onOutOfMaxBounds) === null || _b === void 0 || _b.call(_a, e);
        });
        gc.on('trackuserlocationstart', (e)=>{
            var _a, _b;
            (_b = (_a = thisRef.current.props).onTrackUserLocationStart) === null || _b === void 0 || _b.call(_a, e);
        });
        gc.on('trackuserlocationend', (e)=>{
            var _a, _b;
            (_b = (_a = thisRef.current.props).onTrackUserLocationEnd) === null || _b === void 0 || _b.call(_a, e);
        });
        return gc;
    }, {
        position: props.position
    });
    thisRef.current.props = props;
    (0, $gJYWc.useImperativeHandle)(ref, ()=>ctrl, []);
    (0, $gJYWc.useEffect)(()=>{
        (0, $dd9ba8d53f7ec118$export$cd93e47e6d398387)(ctrl._container, props.style);
    }, [
        props.style
    ]);
    return null;
}
var $7a76cd57cf68f6d7$export$2e2bcd8739ae039 = (0, $gJYWc.memo)((0, $gJYWc.forwardRef)($7a76cd57cf68f6d7$var$GeolocateControl));



var $gJYWc = parcelRequire("gJYWc");


function $4540478b42bd4c16$var$NavigationControl(props) {
    const ctrl = (0, $306f49bf73dc72b4$export$2e2bcd8739ae039)(({ mapLib: mapLib })=>new mapLib.NavigationControl(props), {
        position: props.position
    });
    (0, $gJYWc.useEffect)(()=>{
        (0, $dd9ba8d53f7ec118$export$cd93e47e6d398387)(ctrl._container, props.style);
    }, [
        props.style
    ]);
    return null;
}
var $4540478b42bd4c16$export$2e2bcd8739ae039 = (0, $gJYWc.memo)($4540478b42bd4c16$var$NavigationControl);



var $gJYWc = parcelRequire("gJYWc");


function $090329ff6de36bc5$var$ScaleControl(props) {
    const ctrl = (0, $306f49bf73dc72b4$export$2e2bcd8739ae039)(({ mapLib: mapLib })=>new mapLib.ScaleControl(props), {
        position: props.position
    });
    const propsRef = (0, $gJYWc.useRef)(props);
    const prevProps = propsRef.current;
    propsRef.current = props;
    const { style: style } = props;
    if (props.maxWidth !== undefined && props.maxWidth !== prevProps.maxWidth) ctrl.options.maxWidth = props.maxWidth;
    if (props.unit !== undefined && props.unit !== prevProps.unit) ctrl.setUnit(props.unit);
    (0, $gJYWc.useEffect)(()=>{
        (0, $dd9ba8d53f7ec118$export$cd93e47e6d398387)(ctrl._container, style);
    }, [
        style
    ]);
    return null;
}
var $090329ff6de36bc5$export$2e2bcd8739ae039 = (0, $gJYWc.memo)($090329ff6de36bc5$var$ScaleControl);



var $gJYWc = parcelRequire("gJYWc");

function $e49a9aba0459f8ad$export$2e2bcd8739ae039(condition, message) {
    if (!condition) throw new Error(message);
}



/* eslint-disable complexity, max-statements */ function $4f74a9e82784a13c$var$updateLayer(map, id, props, prevProps) {
    (0, $e49a9aba0459f8ad$export$2e2bcd8739ae039)(props.id === prevProps.id, 'layer id changed');
    (0, $e49a9aba0459f8ad$export$2e2bcd8739ae039)(props.type === prevProps.type, 'layer type changed');
    if (props.type === 'custom' || prevProps.type === 'custom') return;
    const { layout: layout = {}, paint: paint = {}, filter: filter, minzoom: minzoom, maxzoom: maxzoom, beforeId: beforeId } = props;
    if (beforeId !== prevProps.beforeId) map.moveLayer(id, beforeId);
    if (layout !== prevProps.layout) {
        const prevLayout = prevProps.layout || {};
        for(const key in layout)if (!(0, $9e58cf7543d2f80a$export$9cb4719e2e525b7a)(layout[key], prevLayout[key])) map.setLayoutProperty(id, key, layout[key]);
        for(const key in prevLayout)if (!layout.hasOwnProperty(key)) map.setLayoutProperty(id, key, undefined);
    }
    if (paint !== prevProps.paint) {
        const prevPaint = prevProps.paint || {};
        for(const key in paint)if (!(0, $9e58cf7543d2f80a$export$9cb4719e2e525b7a)(paint[key], prevPaint[key])) map.setPaintProperty(id, key, paint[key]);
        for(const key in prevPaint)if (!paint.hasOwnProperty(key)) map.setPaintProperty(id, key, undefined);
    }
    if (!(0, $9e58cf7543d2f80a$export$9cb4719e2e525b7a)(filter, prevProps.filter)) map.setFilter(id, filter);
    if (minzoom !== prevProps.minzoom || maxzoom !== prevProps.maxzoom) map.setLayerZoomRange(id, minzoom, maxzoom);
}
function $4f74a9e82784a13c$var$createLayer(map, id, props) {
    // @ts-ignore
    if (map.style && map.style._loaded && (!('source' in props) || map.getSource(props.source))) {
        const options = {
            ...props,
            id: id
        };
        delete options.beforeId;
        // @ts-ignore
        map.addLayer(options, props.beforeId);
    }
}
/* eslint-enable complexity, max-statements */ let $4f74a9e82784a13c$var$layerCounter = 0;
function $4f74a9e82784a13c$var$Layer(props) {
    const map = (0, $gJYWc.useContext)((0, $657820df3c73cfea$export$dc7344301ae78f85)).map.getMap();
    const propsRef = (0, $gJYWc.useRef)(props);
    const [, setStyleLoaded] = (0, $gJYWc.useState)(0);
    const id = (0, $gJYWc.useMemo)(()=>props.id || `jsx-layer-${$4f74a9e82784a13c$var$layerCounter++}`, []);
    (0, $gJYWc.useEffect)(()=>{
        if (map) {
            const forceUpdate = ()=>setStyleLoaded((version)=>version + 1);
            map.on('styledata', forceUpdate);
            forceUpdate();
            return ()=>{
                map.off('styledata', forceUpdate);
                // @ts-ignore
                if (map.style && map.style._loaded && map.getLayer(id)) map.removeLayer(id);
            };
        }
        return undefined;
    }, [
        map
    ]);
    // @ts-ignore
    const layer = map && map.style && map.getLayer(id);
    if (layer) try {
        $4f74a9e82784a13c$var$updateLayer(map, id, props, propsRef.current);
    } catch (error) {
        console.warn(error); // eslint-disable-line
    }
    else $4f74a9e82784a13c$var$createLayer(map, id, props);
    // Store last rendered props
    propsRef.current = props;
    return null;
}
var $4f74a9e82784a13c$export$2e2bcd8739ae039 = $4f74a9e82784a13c$var$Layer;



var $gJYWc = parcelRequire("gJYWc");



let $ea5940a9fd60e695$var$sourceCounter = 0;
function $ea5940a9fd60e695$var$createSource(map, id, props) {
    // @ts-ignore
    if (map.style && map.style._loaded) {
        const options = {
            ...props
        };
        delete options.id;
        delete options.children;
        // @ts-ignore
        map.addSource(id, options);
        return map.getSource(id);
    }
    return null;
}
/* eslint-disable complexity */ function $ea5940a9fd60e695$var$updateSource(source, props, prevProps) {
    (0, $e49a9aba0459f8ad$export$2e2bcd8739ae039)(props.id === prevProps.id, 'source id changed');
    (0, $e49a9aba0459f8ad$export$2e2bcd8739ae039)(props.type === prevProps.type, 'source type changed');
    let changedKey = '';
    let changedKeyCount = 0;
    for(const key in props)if (key !== 'children' && key !== 'id' && !(0, $9e58cf7543d2f80a$export$9cb4719e2e525b7a)(prevProps[key], props[key])) {
        changedKey = key;
        changedKeyCount++;
    }
    if (!changedKeyCount) return;
    const type = props.type;
    if (type === 'geojson') source.setData(props.data);
    else if (type === 'image') source.updateImage({
        url: props.url,
        coordinates: props.coordinates
    });
    else if ('setCoordinates' in source && changedKeyCount === 1 && changedKey === 'coordinates') source.setCoordinates(props.coordinates);
    else if ('setUrl' in source && changedKey === 'url') source.setUrl(props.url);
    else if ('setTiles' in source && changedKey === 'tiles') source.setTiles(props.tiles);
    else // eslint-disable-next-line
    console.warn(`Unable to update <Source> prop: ${changedKey}`);
}
/* eslint-enable complexity */ function $ea5940a9fd60e695$var$Source(props) {
    const map = (0, $gJYWc.useContext)((0, $657820df3c73cfea$export$dc7344301ae78f85)).map.getMap();
    const propsRef = (0, $gJYWc.useRef)(props);
    const [, setStyleLoaded] = (0, $gJYWc.useState)(0);
    const id = (0, $gJYWc.useMemo)(()=>props.id || `jsx-source-${$ea5940a9fd60e695$var$sourceCounter++}`, []);
    (0, $gJYWc.useEffect)(()=>{
        if (map) {
            /* global setTimeout */ const forceUpdate = ()=>setTimeout(()=>setStyleLoaded((version)=>version + 1), 0);
            map.on('styledata', forceUpdate);
            forceUpdate();
            return ()=>{
                var _a;
                map.off('styledata', forceUpdate);
                // @ts-ignore
                if (map.style && map.style._loaded && map.getSource(id)) {
                    // Parent effects are destroyed before child ones, see
                    // https://github.com/facebook/react/issues/16728
                    // Source can only be removed after all child layers are removed
                    const allLayers = (_a = map.getStyle()) === null || _a === void 0 ? void 0 : _a.layers;
                    if (allLayers) {
                        for (const layer of allLayers)// @ts-ignore (2339) source does not exist on all layer types
                        if (layer.source === id) map.removeLayer(layer.id);
                    }
                    map.removeSource(id);
                }
            };
        }
        return undefined;
    }, [
        map
    ]);
    // @ts-ignore
    let source = map && map.style && map.getSource(id);
    if (source) $ea5940a9fd60e695$var$updateSource(source, props, propsRef.current);
    else source = $ea5940a9fd60e695$var$createSource(map, id, props);
    propsRef.current = props;
    return source && $gJYWc.Children.map(props.children, (child)=>child && (0, $gJYWc.cloneElement)(child, {
            source: id
        })) || null;
}
var $ea5940a9fd60e695$export$2e2bcd8739ae039 = $ea5940a9fd60e695$var$Source;








function $c682e4ee44c53528$export$86f8f9f08863e403() {
    return (0, $d807c1b4a01bf299$export$86f8f9f08863e403)();
}

const $c682e4ee44c53528$var$mapLib = Promise.resolve((parcelRequire("5ASxT")));
const $c682e4ee44c53528$export$a5c7b93649eaf8f8 = (()=>{
    return $gJYWc.forwardRef(function Map(props, ref) {
        return (0, $657820df3c73cfea$export$2e2bcd8739ae039)(props, ref, $c682e4ee44c53528$var$mapLib);
    });
})();
const $c682e4ee44c53528$export$e98856a975cab58e = (0, $e118a169fbf58a53$export$2e2bcd8739ae039);
const $c682e4ee44c53528$export$129a32eedafa97c5 = (0, $e9003cf2dff7eb99$export$2e2bcd8739ae039);
const $c682e4ee44c53528$export$5af5c3cc9905683 = (0, $88b03177a2616a1a$export$2e2bcd8739ae039);
const $c682e4ee44c53528$export$91e8ffb52c2b32c5 = (0, $d46236873605e2e4$export$2e2bcd8739ae039);
const $c682e4ee44c53528$export$49a437922edc1bd9 = (0, $4540478b42bd4c16$export$2e2bcd8739ae039);
const $c682e4ee44c53528$export$15e4ff48f7e9d8e0 = (0, $7a76cd57cf68f6d7$export$2e2bcd8739ae039);
const $c682e4ee44c53528$export$1fb16e435eedcce9 = (0, $090329ff6de36bc5$export$2e2bcd8739ae039);
const $c682e4ee44c53528$export$936d0764594b6eb3 = (0, $4f74a9e82784a13c$export$2e2bcd8739ae039);
const $c682e4ee44c53528$export$1d2df86270c81ecb = (0, $ea5940a9fd60e695$export$2e2bcd8739ae039);
var $c682e4ee44c53528$export$2e2bcd8739ae039 = $c682e4ee44c53528$export$a5c7b93649eaf8f8;





var $5ASxT = parcelRequire("5ASxT");
const $49258b57e8c45fb3$export$ea96287b3c159ce4 = ({ ads: ads })=>{
    const mapRef = (0, $gJYWc.useRef)();
    const bounds = new (0, (/*@__PURE__*/$parcel$interopDefault($5ASxT))).LngLatBounds();
    const popup = (text)=>{
        return new (0, (/*@__PURE__*/$parcel$interopDefault($5ASxT))).Popup().setText(text);
    };
    ads.forEach((ad)=>{
        bounds.extend([
            ad.longitude,
            ad.latitude
        ]);
    });
    mapRef.current?.fitBounds(bounds, {
        padding: 100,
        duration: 1000
    });
    return /*#__PURE__*/ (0, $9wx12.jsx)((0, $c682e4ee44c53528$export$2e2bcd8739ae039), {
        ref: mapRef,
        mapboxAccessToken: "pk.eyJ1IjoibWlraGV5cm9qbyIsImEiOiJjbHN0NnNxaXowbzZhMmxxc2pkN2FsaWJ5In0.OTcPpx4BlZlCR4VF4FofAg",
        cooperativeGestures: true,
        initialViewState: {
            longitude: 24.75229102451432,
            latitude: 59.436508167483744,
            zoom: 10
        },
        style: {
            height: '100%'
        },
        mapStyle: "mapbox://styles/mapbox/streets-v9",
        children: ads.map(({ title: title, id: id, longitude: longitude, latitude: latitude })=>/*#__PURE__*/ (0, $9wx12.jsx)((0, $c682e4ee44c53528$export$e98856a975cab58e), {
                longitude: longitude,
                latitude: latitude,
                popup: popup(title),
                color: "red",
                onClick: (args)=>console.log(args)
            }, title + id))
    });
};







const $8b4d84056d9f0adb$export$30f8d45547b3f2cd = ()=>{
    const { state: state } = (0, $a35327dc535bf969$export$45d76561a5302f2b)();
    const [ads, setAdds] = (0, $gJYWc.useState)([]);
    const [selectedCity, setSelectedCity] = (0, $gJYWc.useState)(state?.city || '');
    const [selectedAge, setSelectedAge] = (0, $gJYWc.useState)(state?.age || '');
    const [selectedActivity, setSelectedActivity] = (0, $gJYWc.useState)(state?.activity || '');
    const { i18n: i18n } = (0, $980e4b3a97f1ad67$export$9fc83ad70ead8663)();
    const [showMap, setShowMap] = (0, $gJYWc.useState)(true);
    const currentLanguage = i18n.resolvedLanguage;
    const allCities = [
        ...new Set(ads.map((ad)=>ad.city).filter(Boolean))
    ];
    const allAges = [
        ...new Set(ads.map((ad)=>ad.age_tags).flat().filter(Boolean))
    ];
    const allActivities = [
        ...new Set(ads.map((ad)=>ad.activity_tags).flat().filter(Boolean))
    ];
    (0, $gJYWc.useEffect)(()=>{
        const fetchAds = async ()=>{
            const ads = await (0, $70a97169caddc04c$export$10bf54e825e44464)(currentLanguage);
            setAdds(ads);
        };
        fetchAds().catch(console.error);
    }, [
        currentLanguage
    ]);
    const filteredAds = ads.filter((ad)=>{
        // @ts-ignore
        const ageFilter = Boolean(selectedAge) ? ad?.age_tags?.includes(selectedAge) : true;
        // @ts-ignore
        const activityFilter = Boolean(selectedActivity) ? ad?.activity_tags?.includes(selectedActivity) : true;
        const cityFilter = Boolean(selectedCity) ? ad?.city === selectedCity : true;
        return cityFilter && activityFilter && ageFilter;
    });
    return /*#__PURE__*/ (0, $9wx12.jsxs)((0, $9wx12.Fragment), {
        children: [
            /*#__PURE__*/ (0, $9wx12.jsx)("div", {
                className: "shadow shadow-gray-10",
                children: /*#__PURE__*/ (0, $9wx12.jsx)((0, $fc72cc536184e560$export$8b251419efc915eb), {
                    children: /*#__PURE__*/ (0, $9wx12.jsx)((0, $5bb3c03eb951988c$export$820e4d34d59f5d7f), {
                        selectedAge: state?.age,
                        ages: allAges,
                        setAge: setSelectedAge,
                        selectedActivity: state?.activity,
                        activities: allActivities,
                        setActivity: setSelectedActivity,
                        selectedCity: state?.city,
                        cities: allCities,
                        setCity: setSelectedCity
                    })
                })
            }),
            /*#__PURE__*/ (0, $9wx12.jsxs)("div", {
                className: "h-[calc(100%-120px)] flex",
                children: [
                    /*#__PURE__*/ (0, $9wx12.jsx)((0, $62d4562a7043f33d$export$51d95724e2f95a4d), {
                        showMap: showMap,
                        setShowMap: setShowMap,
                        ads: filteredAds,
                        totalAdNumber: ads.length
                    }),
                    showMap && /*#__PURE__*/ (0, $9wx12.jsx)("div", {
                        className: "w-[30%] h-full",
                        children: /*#__PURE__*/ (0, $9wx12.jsx)((0, $49258b57e8c45fb3$export$ea96287b3c159ce4), {
                            ads: filteredAds
                        })
                    })
                ]
            })
        ]
    });
};



var $9wx12 = parcelRequire("9wx12");

var $gJYWc = parcelRequire("gJYWc");




var $9wx12 = parcelRequire("9wx12");
parcelRequire("gJYWc");
var $75f302a421e7b1fd$exports = {};
"use strict";
var $75f302a421e7b1fd$var$__importDefault = $75f302a421e7b1fd$exports && $75f302a421e7b1fd$exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty($75f302a421e7b1fd$exports, "__esModule", {
    value: true
});

var $75f302a421e7b1fd$var$Carousel_1 = $75f302a421e7b1fd$var$__importDefault((parcelRequire("3Fezy")));
$75f302a421e7b1fd$exports.default = $75f302a421e7b1fd$var$Carousel_1.default;


const $b615a63ae467164a$export$73051e5675ca1011 = ({ images: images })=>{
    return images && /*#__PURE__*/ (0, $9wx12.jsxs)((0, $9wx12.Fragment), {
        children: [
            /*#__PURE__*/ (0, $9wx12.jsx)($b615a63ae467164a$var$DesktopCarousel, {
                images: images
            }),
            /*#__PURE__*/ (0, $9wx12.jsx)($b615a63ae467164a$export$d1db766a9490651f, {
                images: images
            })
        ]
    });
};
const $b615a63ae467164a$var$DesktopCarousel = ({ images: images })=>/*#__PURE__*/ (0, $9wx12.jsxs)("div", {
        className: "lg:flex h-[600px] hidden",
        id: "carousel",
        children: [
            /*#__PURE__*/ (0, $9wx12.jsx)("div", {
                className: "w-full",
                id: "main-image",
                children: /*#__PURE__*/ (0, $9wx12.jsx)("div", {
                    style: {
                        backgroundImage: `url(${images[0]})`
                    },
                    className: "flex items-end justify-center pb-10 bg-cover bg-center h-full w-full border-white border-y-4 border-r-2"
                })
            }),
            /*#__PURE__*/ (0, $9wx12.jsxs)("div", {
                className: "w-full flex items-end justify-center flex-wrap",
                id: "secondary-image",
                children: [
                    /*#__PURE__*/ (0, $9wx12.jsx)("div", {
                        style: {
                            backgroundImage: `url(${images[1]})`
                        },
                        className: "bg-cover bg-center h-1/2 w-1/2 border-4 border-white"
                    }),
                    /*#__PURE__*/ (0, $9wx12.jsx)("div", {
                        style: {
                            backgroundImage: `url(${images[2]})`
                        },
                        className: "bg-cover bg-center h-1/2 w-1/2 border-4 border-white border-r-0"
                    }),
                    /*#__PURE__*/ (0, $9wx12.jsx)("div", {
                        style: {
                            backgroundImage: `url(${images[3]})`
                        },
                        className: "bg-cover bg-center  h-1/2 w-1/2 border-4 border-white"
                    }),
                    /*#__PURE__*/ (0, $9wx12.jsx)("div", {
                        style: {
                            backgroundImage: `url(${images[4]})`
                        },
                        className: "bg-cover bg-center h-1/2 w-1/2 border-4 border-white border-r-0"
                    })
                ]
            })
        ]
    });
const $b615a63ae467164a$export$d1db766a9490651f = ({ images: images = [] })=>{
    return images && /*#__PURE__*/ (0, $9wx12.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($75f302a421e7b1fd$exports))), {
        animation: "slide",
        navButtonsAlwaysVisible: true,
        className: "lg:hidden",
        children: images.map((image, i)=>/*#__PURE__*/ (0, $9wx12.jsx)("div", {
                style: {
                    backgroundImage: `url(${image})`,
                    height: '500px'
                },
                className: "flex items-end justify-center pb-10 bg-cover bg-center h-full w-full border-white border-y-4 border-r-2"
            }, i))
    });
};



var $9wx12 = parcelRequire("9wx12");

var $gJYWc = parcelRequire("gJYWc");

var $9wx12 = parcelRequire("9wx12");
parcelRequire("gJYWc");


var $5ASxT = parcelRequire("5ASxT");
const $f4a86a43186ca043$export$b1289b5cf6bef983 = ({ longitude: longitude, latitude: latitude, title: title })=>{
    const popup = (text)=>{
        return new (0, (/*@__PURE__*/$parcel$interopDefault($5ASxT))).Popup().setText(text);
    };
    return longitude && latitude && /*#__PURE__*/ (0, $9wx12.jsx)("div", {
        className: "lg:w-[600px] h-[410px] w-full",
        children: /*#__PURE__*/ (0, $9wx12.jsx)((0, $c682e4ee44c53528$export$2e2bcd8739ae039), {
            mapboxAccessToken: "pk.eyJ1IjoibWlraGV5cm9qbyIsImEiOiJjbHN0NnNxaXowbzZhMmxxc2pkN2FsaWJ5In0.OTcPpx4BlZlCR4VF4FofAg",
            cooperativeGestures: true,
            initialViewState: {
                longitude: longitude,
                latitude: latitude,
                zoom: 12
            },
            style: {
                height: '100%',
                width: '100%'
            },
            mapStyle: "mapbox://styles/mapbox/streets-v9",
            children: /*#__PURE__*/ (0, $9wx12.jsx)((0, $c682e4ee44c53528$export$e98856a975cab58e), {
                longitude: longitude,
                latitude: latitude,
                popup: popup(title),
                color: "red",
                onClick: (args)=>console.log(args)
            }, title)
        })
    });
};




var $cTAWX = parcelRequire("cTAWX");

var $3VnFq = parcelRequire("3VnFq");

var $gJYWc = parcelRequire("gJYWc");


var $2w6IV = parcelRequire("2w6IV");

var $3e4LV = parcelRequire("3e4LV");



var $fwsmC = parcelRequire("fwsmC");


var $HGmne = parcelRequire("HGmne");

var $8pLcn = parcelRequire("8pLcn");

var $fNSZE = parcelRequire("fNSZE");

var $gJYWc = parcelRequire("gJYWc");
function $b9c0787e2e8457f3$export$2e2bcd8739ae039(element, muiNames) {
    var _muiName, _element$type;
    return /*#__PURE__*/ $gJYWc.isValidElement(element) && muiNames.indexOf(// relevant info - https://github.com/facebook/react/blob/2807d781a08db8e9873687fccc25c0f12b4fb3d4/packages/react/src/ReactLazy.js#L45
    // eslint-disable-next-line no-underscore-dangle
    (_muiName = element.type.muiName) != null ? _muiName : (_element$type = element.type) == null || (_element$type = _element$type._payload) == null || (_element$type = _element$type.value) == null ? void 0 : _element$type.muiName) !== -1;
}


var $7cf0f7eb93e7e254$export$2e2bcd8739ae039 = (0, $b9c0787e2e8457f3$export$2e2bcd8739ae039);




var $il32z = parcelRequire("il32z");


var $i8nzj = parcelRequire("i8nzj");

var $1kRHf = parcelRequire("1kRHf");
function $8c536798aad91a84$export$5682c366c0c669d9(slot) {
    return (0, $1kRHf.default)('MuiListItem', slot);
}
const $8c536798aad91a84$var$listItemClasses = (0, $i8nzj.default)('MuiListItem', [
    'root',
    'container',
    'focusVisible',
    'dense',
    'alignItemsFlexStart',
    'disabled',
    'divider',
    'gutters',
    'padding',
    'button',
    'secondaryAction',
    'selected'
]);
var $8c536798aad91a84$export$2e2bcd8739ae039 = $8c536798aad91a84$var$listItemClasses;




var $cTAWX = parcelRequire("cTAWX");

var $3VnFq = parcelRequire("3VnFq");

var $gJYWc = parcelRequire("gJYWc");


var $2w6IV = parcelRequire("2w6IV");

var $3e4LV = parcelRequire("3e4LV");

var $HGmne = parcelRequire("HGmne");

var $8pLcn = parcelRequire("8pLcn");


var $i8nzj = parcelRequire("i8nzj");

var $1kRHf = parcelRequire("1kRHf");
function $8b49b1bd9098d580$export$ccdb26aeba48a86e(slot) {
    return (0, $1kRHf.default)('MuiListItemSecondaryAction', slot);
}
const $8b49b1bd9098d580$var$listItemSecondaryActionClasses = (0, $i8nzj.default)('MuiListItemSecondaryAction', [
    'root',
    'disableGutters'
]);
var $8b49b1bd9098d580$export$2e2bcd8739ae039 = $8b49b1bd9098d580$var$listItemSecondaryActionClasses;



var $9wx12 = parcelRequire("9wx12");
'use client';
const $2314d614b379b4be$var$_excluded = [
    "className"
];
const $2314d614b379b4be$var$useUtilityClasses = (ownerState)=>{
    const { disableGutters: disableGutters, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            disableGutters && 'disableGutters'
        ]
    };
    return (0, $3e4LV.default)(slots, (0, $8b49b1bd9098d580$export$ccdb26aeba48a86e), classes);
};
const $2314d614b379b4be$var$ListItemSecondaryActionRoot = (0, $HGmne.default)('div', {
    name: 'MuiListItemSecondaryAction',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.disableGutters && styles.disableGutters
        ];
    }
})(({ ownerState: ownerState })=>(0, $3VnFq.default)({
        position: 'absolute',
        right: 16,
        top: '50%',
        transform: 'translateY(-50%)'
    }, ownerState.disableGutters && {
        right: 0
    }));
/**
 * Must be used as the last child of ListItem to function properly.
 */ const $2314d614b379b4be$var$ListItemSecondaryAction = /*#__PURE__*/ $gJYWc.forwardRef(function ListItemSecondaryAction(inProps, ref) {
    const props = (0, $8pLcn.useDefaultProps)({
        props: inProps,
        name: 'MuiListItemSecondaryAction'
    });
    const { className: className } = props, other = (0, $cTAWX.default)(props, $2314d614b379b4be$var$_excluded);
    const context = $gJYWc.useContext((0, $3d14c289610745c4$export$2e2bcd8739ae039));
    const ownerState = (0, $3VnFq.default)({}, props, {
        disableGutters: context.disableGutters
    });
    const classes = $2314d614b379b4be$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $9wx12.jsx)($2314d614b379b4be$var$ListItemSecondaryActionRoot, (0, $3VnFq.default)({
        className: (0, $2w6IV.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref
    }, other));
});
$2314d614b379b4be$var$ListItemSecondaryAction.muiName = 'ListItemSecondaryAction';
var $2314d614b379b4be$export$2e2bcd8739ae039 = $2314d614b379b4be$var$ListItemSecondaryAction;



var $9wx12 = parcelRequire("9wx12");
'use client';
const $fbd2d21ccc73b907$var$_excluded = [
    "className"
], $fbd2d21ccc73b907$var$_excluded2 = [
    "alignItems",
    "autoFocus",
    "button",
    "children",
    "className",
    "component",
    "components",
    "componentsProps",
    "ContainerComponent",
    "ContainerProps",
    "dense",
    "disabled",
    "disableGutters",
    "disablePadding",
    "divider",
    "focusVisibleClassName",
    "secondaryAction",
    "selected",
    "slotProps",
    "slots"
];
const $fbd2d21ccc73b907$export$4334bb34c76fef24 = (props, styles)=>{
    const { ownerState: ownerState } = props;
    return [
        styles.root,
        ownerState.dense && styles.dense,
        ownerState.alignItems === 'flex-start' && styles.alignItemsFlexStart,
        ownerState.divider && styles.divider,
        !ownerState.disableGutters && styles.gutters,
        !ownerState.disablePadding && styles.padding,
        ownerState.button && styles.button,
        ownerState.hasSecondaryAction && styles.secondaryAction
    ];
};
const $fbd2d21ccc73b907$var$useUtilityClasses = (ownerState)=>{
    const { alignItems: alignItems, button: button, classes: classes, dense: dense, disabled: disabled, disableGutters: disableGutters, disablePadding: disablePadding, divider: divider, hasSecondaryAction: hasSecondaryAction, selected: selected } = ownerState;
    const slots = {
        root: [
            'root',
            dense && 'dense',
            !disableGutters && 'gutters',
            !disablePadding && 'padding',
            divider && 'divider',
            disabled && 'disabled',
            button && 'button',
            alignItems === 'flex-start' && 'alignItemsFlexStart',
            hasSecondaryAction && 'secondaryAction',
            selected && 'selected'
        ],
        container: [
            'container'
        ]
    };
    return (0, $3e4LV.default)(slots, (0, $8c536798aad91a84$export$5682c366c0c669d9), classes);
};
const $fbd2d21ccc73b907$export$aed538f7519abe89 = (0, $HGmne.default)('div', {
    name: 'MuiListItem',
    slot: 'Root',
    overridesResolver: $fbd2d21ccc73b907$export$4334bb34c76fef24
})(({ theme: theme, ownerState: ownerState })=>(0, $3VnFq.default)({
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'center',
        position: 'relative',
        textDecoration: 'none',
        width: '100%',
        boxSizing: 'border-box',
        textAlign: 'left'
    }, !ownerState.disablePadding && (0, $3VnFq.default)({
        paddingTop: 8,
        paddingBottom: 8
    }, ownerState.dense && {
        paddingTop: 4,
        paddingBottom: 4
    }, !ownerState.disableGutters && {
        paddingLeft: 16,
        paddingRight: 16
    }, !!ownerState.secondaryAction && {
        // Add some space to avoid collision as `ListItemSecondaryAction`
        // is absolutely positioned.
        paddingRight: 48
    }), !!ownerState.secondaryAction && {
        [`& > .${(0, $52a4139062008855$export$2e2bcd8739ae039).root}`]: {
            paddingRight: 48
        }
    }, {
        [`&.${(0, $8c536798aad91a84$export$2e2bcd8739ae039).focusVisible}`]: {
            backgroundColor: (theme.vars || theme).palette.action.focus
        },
        [`&.${(0, $8c536798aad91a84$export$2e2bcd8739ae039).selected}`]: {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.selectedOpacity})` : (0, $fwsmC.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity),
            [`&.${(0, $8c536798aad91a84$export$2e2bcd8739ae039).focusVisible}`]: {
                backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.focusOpacity}))` : (0, $fwsmC.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity + theme.palette.action.focusOpacity)
            }
        },
        [`&.${(0, $8c536798aad91a84$export$2e2bcd8739ae039).disabled}`]: {
            opacity: (theme.vars || theme).palette.action.disabledOpacity
        }
    }, ownerState.alignItems === 'flex-start' && {
        alignItems: 'flex-start'
    }, ownerState.divider && {
        borderBottom: `1px solid ${(theme.vars || theme).palette.divider}`,
        backgroundClip: 'padding-box'
    }, ownerState.button && {
        transition: theme.transitions.create('background-color', {
            duration: theme.transitions.duration.shortest
        }),
        '&:hover': {
            textDecoration: 'none',
            backgroundColor: (theme.vars || theme).palette.action.hover,
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                backgroundColor: 'transparent'
            }
        },
        [`&.${(0, $8c536798aad91a84$export$2e2bcd8739ae039).selected}:hover`]: {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.hoverOpacity}))` : (0, $fwsmC.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity + theme.palette.action.hoverOpacity),
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.selectedOpacity})` : (0, $fwsmC.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity)
            }
        }
    }, ownerState.hasSecondaryAction && {
        // Add some space to avoid collision as `ListItemSecondaryAction`
        // is absolutely positioned.
        paddingRight: 48
    }));
const $fbd2d21ccc73b907$var$ListItemContainer = (0, $HGmne.default)('li', {
    name: 'MuiListItem',
    slot: 'Container',
    overridesResolver: (props, styles)=>styles.container
})({
    position: 'relative'
});
/**
 * Uses an additional container component if `ListItemSecondaryAction` is the last child.
 */ const $fbd2d21ccc73b907$var$ListItem = /*#__PURE__*/ $gJYWc.forwardRef(function ListItem(inProps, ref) {
    const props = (0, $8pLcn.useDefaultProps)({
        props: inProps,
        name: 'MuiListItem'
    });
    const { alignItems: alignItems = 'center', autoFocus: autoFocus = false, button: button = false, children: childrenProp, className: className, component: componentProp, components: components = {}, componentsProps: componentsProps = {}, ContainerComponent: ContainerComponent = 'li', ContainerProps: { className: ContainerClassName } = {}, dense: dense = false, disabled: disabled = false, disableGutters: disableGutters = false, disablePadding: disablePadding = false, divider: divider = false, focusVisibleClassName: focusVisibleClassName, secondaryAction: secondaryAction, selected: selected = false, slotProps: slotProps = {}, slots: slots = {} } = props, ContainerProps = (0, $cTAWX.default)(props.ContainerProps, $fbd2d21ccc73b907$var$_excluded), other = (0, $cTAWX.default)(props, $fbd2d21ccc73b907$var$_excluded2);
    const context = $gJYWc.useContext((0, $3d14c289610745c4$export$2e2bcd8739ae039));
    const childContext = $gJYWc.useMemo(()=>({
            dense: dense || context.dense || false,
            alignItems: alignItems,
            disableGutters: disableGutters
        }), [
        alignItems,
        context.dense,
        dense,
        disableGutters
    ]);
    const listItemRef = $gJYWc.useRef(null);
    (0, $288db5e5dece4e0b$export$2e2bcd8739ae039)(()=>{
        if (autoFocus) {
            if (listItemRef.current) listItemRef.current.focus();
        }
    }, [
        autoFocus
    ]);
    const children = $gJYWc.Children.toArray(childrenProp);
    // v4 implementation, deprecated in v5, will be removed in v6
    const hasSecondaryAction = children.length && (0, $7cf0f7eb93e7e254$export$2e2bcd8739ae039)(children[children.length - 1], [
        'ListItemSecondaryAction'
    ]);
    const ownerState = (0, $3VnFq.default)({}, props, {
        alignItems: alignItems,
        autoFocus: autoFocus,
        button: button,
        dense: childContext.dense,
        disabled: disabled,
        disableGutters: disableGutters,
        disablePadding: disablePadding,
        divider: divider,
        hasSecondaryAction: hasSecondaryAction,
        selected: selected
    });
    const classes = $fbd2d21ccc73b907$var$useUtilityClasses(ownerState);
    const handleRef = (0, $il32z.default)(listItemRef, ref);
    const Root = slots.root || components.Root || $fbd2d21ccc73b907$export$aed538f7519abe89;
    const rootProps = slotProps.root || componentsProps.root || {};
    const componentProps = (0, $3VnFq.default)({
        className: (0, $2w6IV.default)(classes.root, rootProps.className, className),
        disabled: disabled
    }, other);
    let Component = componentProp || 'li';
    if (button) {
        componentProps.component = componentProp || 'div';
        componentProps.focusVisibleClassName = (0, $2w6IV.default)((0, $8c536798aad91a84$export$2e2bcd8739ae039).focusVisible, focusVisibleClassName);
        Component = (0, $fNSZE.default);
    }
    // v4 implementation, deprecated in v5, will be removed in v6
    if (hasSecondaryAction) {
        // Use div by default.
        Component = !componentProps.component && !componentProp ? 'div' : Component;
        // Avoid nesting of li > li.
        if (ContainerComponent === 'li') {
            if (Component === 'li') Component = 'div';
            else if (componentProps.component === 'li') componentProps.component = 'div';
        }
        return /*#__PURE__*/ (0, $9wx12.jsx)((0, $3d14c289610745c4$export$2e2bcd8739ae039).Provider, {
            value: childContext,
            children: /*#__PURE__*/ (0, $9wx12.jsxs)($fbd2d21ccc73b907$var$ListItemContainer, (0, $3VnFq.default)({
                as: ContainerComponent,
                className: (0, $2w6IV.default)(classes.container, ContainerClassName),
                ref: handleRef,
                ownerState: ownerState
            }, ContainerProps, {
                children: [
                    /*#__PURE__*/ (0, $9wx12.jsx)(Root, (0, $3VnFq.default)({}, rootProps, !(0, $50e7d669fe712af8$export$2e2bcd8739ae039)(Root) && {
                        as: Component,
                        ownerState: (0, $3VnFq.default)({}, ownerState, rootProps.ownerState)
                    }, componentProps, {
                        children: children
                    })),
                    children.pop()
                ]
            }))
        });
    }
    return /*#__PURE__*/ (0, $9wx12.jsx)((0, $3d14c289610745c4$export$2e2bcd8739ae039).Provider, {
        value: childContext,
        children: /*#__PURE__*/ (0, $9wx12.jsxs)(Root, (0, $3VnFq.default)({}, rootProps, {
            as: Component,
            ref: handleRef
        }, !(0, $50e7d669fe712af8$export$2e2bcd8739ae039)(Root) && {
            ownerState: (0, $3VnFq.default)({}, ownerState, rootProps.ownerState)
        }, componentProps, {
            children: [
                children,
                secondaryAction && /*#__PURE__*/ (0, $9wx12.jsx)((0, $2314d614b379b4be$export$2e2bcd8739ae039), {
                    children: secondaryAction
                })
            ]
        }))
    });
});
var $fbd2d21ccc73b907$export$2e2bcd8739ae039 = $fbd2d21ccc73b907$var$ListItem;




const $1a9b81bce114f748$export$393edc798c47379d = (ad)=>{
    const { description: description, title: title, longitude: longitude, latitude: latitude, name: name } = ad;
    const areIcons = ad.max_people || ad.min_time || ad.total_area || ad.room_number;
    return /*#__PURE__*/ (0, $9wx12.jsxs)("div", {
        className: "lg:max-w-[650px]",
        id: "content",
        children: [
            /*#__PURE__*/ (0, $9wx12.jsx)((0, $b4083ea3a052dee9$export$2e2bcd8739ae039), {
                className: "text-5xl lg:mb-5 pl-2",
                variant: "h4",
                children: title
            }),
            /*#__PURE__*/ (0, $9wx12.jsxs)((0, $e247548612617cb3$export$2e2bcd8739ae039), {
                sx: {
                    width: '100%',
                    bgcolor: 'background.paper'
                },
                children: [
                    /*#__PURE__*/ (0, $9wx12.jsx)((0, $fbd2d21ccc73b907$export$2e2bcd8739ae039), {
                        alignItems: "flex-start",
                        children: /*#__PURE__*/ (0, $9wx12.jsx)((0, $7e347bdafa1acea0$export$2e2bcd8739ae039), {
                            primary: /*#__PURE__*/ (0, $9wx12.jsx)("div", {
                                className: "font-bold",
                                children: "Description"
                            }),
                            secondary: /*#__PURE__*/ (0, $9wx12.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($gJYWc))).Fragment, {
                                children: /*#__PURE__*/ (0, $9wx12.jsxs)((0, $b4083ea3a052dee9$export$2e2bcd8739ae039), {
                                    sx: {
                                        display: 'inline'
                                    },
                                    component: "span",
                                    variant: "body2",
                                    color: "text.primary",
                                    children: [
                                        description,
                                        " "
                                    ]
                                })
                            })
                        })
                    }),
                    ad?.price_includes?.length && /*#__PURE__*/ (0, $9wx12.jsx)((0, $9wx12.Fragment), {
                        children: /*#__PURE__*/ (0, $9wx12.jsx)((0, $fbd2d21ccc73b907$export$2e2bcd8739ae039), {
                            alignItems: "flex-start",
                            children: /*#__PURE__*/ (0, $9wx12.jsx)((0, $7e347bdafa1acea0$export$2e2bcd8739ae039), {
                                primary: /*#__PURE__*/ (0, $9wx12.jsx)("div", {
                                    className: "font-bold",
                                    children: "Price includes:"
                                }),
                                secondary: /*#__PURE__*/ (0, $9wx12.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($gJYWc))).Fragment, {
                                    children: /*#__PURE__*/ (0, $9wx12.jsx)((0, $b4083ea3a052dee9$export$2e2bcd8739ae039), {
                                        sx: {
                                            display: 'inline'
                                        },
                                        component: "span",
                                        variant: "body2",
                                        color: "text.primary",
                                        children: /*#__PURE__*/ (0, $9wx12.jsx)("ul", {
                                            children: ad?.price_includes?.map((incl, key)=>/*#__PURE__*/ (0, $9wx12.jsx)("li", {
                                                    children: incl
                                                }, key))
                                        })
                                    })
                                })
                            })
                        })
                    }),
                    ad?.addons?.length && /*#__PURE__*/ (0, $9wx12.jsx)((0, $9wx12.Fragment), {
                        children: /*#__PURE__*/ (0, $9wx12.jsx)((0, $fbd2d21ccc73b907$export$2e2bcd8739ae039), {
                            alignItems: "flex-start",
                            children: /*#__PURE__*/ (0, $9wx12.jsx)((0, $7e347bdafa1acea0$export$2e2bcd8739ae039), {
                                primary: /*#__PURE__*/ (0, $9wx12.jsx)("div", {
                                    className: "font-bold",
                                    children: "Add-ons"
                                }),
                                secondary: /*#__PURE__*/ (0, $9wx12.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($gJYWc))).Fragment, {
                                    children: /*#__PURE__*/ (0, $9wx12.jsx)((0, $b4083ea3a052dee9$export$2e2bcd8739ae039), {
                                        sx: {
                                            display: 'inline'
                                        },
                                        component: "span",
                                        variant: "body2",
                                        color: "text.primary",
                                        children: /*#__PURE__*/ (0, $9wx12.jsx)("ul", {
                                            children: ad?.addons?.map((addon)=>/*#__PURE__*/ (0, $9wx12.jsx)("li", {
                                                    children: addon
                                                }))
                                        })
                                    })
                                })
                            })
                        })
                    }),
                    ad?.rules?.length && /*#__PURE__*/ (0, $9wx12.jsx)((0, $9wx12.Fragment), {
                        children: /*#__PURE__*/ (0, $9wx12.jsx)((0, $fbd2d21ccc73b907$export$2e2bcd8739ae039), {
                            alignItems: "flex-start",
                            children: /*#__PURE__*/ (0, $9wx12.jsx)((0, $7e347bdafa1acea0$export$2e2bcd8739ae039), {
                                primary: /*#__PURE__*/ (0, $9wx12.jsx)("div", {
                                    className: "font-bold",
                                    children: "Rules"
                                }),
                                secondary: /*#__PURE__*/ (0, $9wx12.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($gJYWc))).Fragment, {
                                    children: /*#__PURE__*/ (0, $9wx12.jsx)((0, $b4083ea3a052dee9$export$2e2bcd8739ae039), {
                                        sx: {
                                            display: 'inline'
                                        },
                                        component: "span",
                                        variant: "body2",
                                        color: "text.primary",
                                        children: /*#__PURE__*/ (0, $9wx12.jsx)("ul", {
                                            children: ad?.rules?.map((rule)=>/*#__PURE__*/ (0, $9wx12.jsx)("li", {
                                                    children: rule
                                                }))
                                        })
                                    })
                                })
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $9wx12.jsx)((0, $fbd2d21ccc73b907$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $9wx12.jsx)((0, $f4a86a43186ca043$export$b1289b5cf6bef983), {
                            title: title,
                            longitude: longitude,
                            latitude: latitude
                        })
                    })
                ]
            })
        ]
    });
};



var $9wx12 = parcelRequire("9wx12");

var $gJYWc = parcelRequire("gJYWc");





var $9wx12 = parcelRequire("9wx12");

var $gJYWc = parcelRequire("gJYWc");


var $3VnFq = parcelRequire("3VnFq");

var $cTAWX = parcelRequire("cTAWX");

var $gJYWc = parcelRequire("gJYWc");

var $2w6IV = parcelRequire("2w6IV");

var $9Ie0W = parcelRequire("9Ie0W");

var $k1l9i = parcelRequire("k1l9i");
var $01deC = parcelRequire("01deC");


var $9wx12 = parcelRequire("9wx12");
'use client';
const $4819ad53f25a166d$var$_excluded = [
    "className",
    "component"
];
function $4819ad53f25a166d$export$2e2bcd8739ae039(options = {}) {
    const { themeId: themeId, defaultTheme: defaultTheme, defaultClassName: defaultClassName = 'MuiBox-root', generateClassName: generateClassName } = options;
    const BoxRoot = (0, $9Ie0W.default)('div', {
        shouldForwardProp: (prop)=>prop !== 'theme' && prop !== 'sx' && prop !== 'as'
    })((0, $k1l9i.default));
    const Box = /*#__PURE__*/ $gJYWc.forwardRef(function Box(inProps, ref) {
        const theme = (0, $81fc44edf20e1517$export$2e2bcd8739ae039)(defaultTheme);
        const _extendSxProp = (0, $01deC.default)(inProps), { className: className, component: component = 'div' } = _extendSxProp, other = (0, $cTAWX.default)(_extendSxProp, $4819ad53f25a166d$var$_excluded);
        return /*#__PURE__*/ (0, $9wx12.jsx)(BoxRoot, (0, $3VnFq.default)({
            as: component,
            ref: ref,
            className: (0, $2w6IV.default)(className, generateClassName ? generateClassName(defaultClassName) : defaultClassName),
            theme: themeId ? theme[themeId] || theme : theme
        }, other));
    });
    return Box;
}




var $56WoG = parcelRequire("56WoG");

var $3vNtX = parcelRequire("3vNtX");

var $8Ho5h = parcelRequire("8Ho5h");

var $i8nzj = parcelRequire("i8nzj");
const $7c9924d0ef95c8ba$var$boxClasses = (0, $i8nzj.default)('MuiBox', [
    'root'
]);
var $7c9924d0ef95c8ba$export$2e2bcd8739ae039 = $7c9924d0ef95c8ba$var$boxClasses;


'use client';
const $92216236ada60417$var$defaultTheme = (0, $3vNtX.default)();
const $92216236ada60417$var$Box = (0, $4819ad53f25a166d$export$2e2bcd8739ae039)({
    themeId: (0, $8Ho5h.default),
    defaultTheme: $92216236ada60417$var$defaultTheme,
    defaultClassName: (0, $7c9924d0ef95c8ba$export$2e2bcd8739ae039).root,
    generateClassName: (0, $56WoG.default).generate
});
var $92216236ada60417$export$2e2bcd8739ae039 = $92216236ada60417$var$Box;



var $cTAWX = parcelRequire("cTAWX");

var $3VnFq = parcelRequire("3VnFq");

var $gJYWc = parcelRequire("gJYWc");


var $2w6IV = parcelRequire("2w6IV");


var $3e4LV = parcelRequire("3e4LV");

var $d0nrV = parcelRequire("d0nrV");

var $cVrVk = parcelRequire("cVrVk");

var $8pLcn = parcelRequire("8pLcn");

var $HGmne = parcelRequire("HGmne");

var $i8nzj = parcelRequire("i8nzj");

var $1kRHf = parcelRequire("1kRHf");
function $f13bc26f977a3b6a$export$29cad1383b3f235d(slot) {
    return (0, $1kRHf.default)('MuiCircularProgress', slot);
}
const $f13bc26f977a3b6a$var$circularProgressClasses = (0, $i8nzj.default)('MuiCircularProgress', [
    'root',
    'determinate',
    'indeterminate',
    'colorPrimary',
    'colorSecondary',
    'svg',
    'circle',
    'circleDeterminate',
    'circleIndeterminate',
    'circleDisableShrink'
]);
var $f13bc26f977a3b6a$export$2e2bcd8739ae039 = $f13bc26f977a3b6a$var$circularProgressClasses;



var $9wx12 = parcelRequire("9wx12");
'use client';
const $895ba70d11219ed4$var$_excluded = [
    "className",
    "color",
    "disableShrink",
    "size",
    "style",
    "thickness",
    "value",
    "variant"
];
let $895ba70d11219ed4$var$_ = (t)=>t, $895ba70d11219ed4$var$_t, $895ba70d11219ed4$var$_t2, $895ba70d11219ed4$var$_t3, $895ba70d11219ed4$var$_t4;
const $895ba70d11219ed4$var$SIZE = 44;
const $895ba70d11219ed4$var$circularRotateKeyframe = (0, $d0nrV.keyframes)($895ba70d11219ed4$var$_t || ($895ba70d11219ed4$var$_t = $895ba70d11219ed4$var$_`
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
`));
const $895ba70d11219ed4$var$circularDashKeyframe = (0, $d0nrV.keyframes)($895ba70d11219ed4$var$_t2 || ($895ba70d11219ed4$var$_t2 = $895ba70d11219ed4$var$_`
  0% {
    stroke-dasharray: 1px, 200px;
    stroke-dashoffset: 0;
  }

  50% {
    stroke-dasharray: 100px, 200px;
    stroke-dashoffset: -15px;
  }

  100% {
    stroke-dasharray: 100px, 200px;
    stroke-dashoffset: -125px;
  }
`));
const $895ba70d11219ed4$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, variant: variant, color: color, disableShrink: disableShrink } = ownerState;
    const slots = {
        root: [
            'root',
            variant,
            `color${(0, $cVrVk.default)(color)}`
        ],
        svg: [
            'svg'
        ],
        circle: [
            'circle',
            `circle${(0, $cVrVk.default)(variant)}`,
            disableShrink && 'circleDisableShrink'
        ]
    };
    return (0, $3e4LV.default)(slots, (0, $f13bc26f977a3b6a$export$29cad1383b3f235d), classes);
};
const $895ba70d11219ed4$var$CircularProgressRoot = (0, $HGmne.default)('span', {
    name: 'MuiCircularProgress',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.variant],
            styles[`color${(0, $cVrVk.default)(ownerState.color)}`]
        ];
    }
})(({ ownerState: ownerState, theme: theme })=>(0, $3VnFq.default)({
        display: 'inline-block'
    }, ownerState.variant === 'determinate' && {
        transition: theme.transitions.create('transform')
    }, ownerState.color !== 'inherit' && {
        color: (theme.vars || theme).palette[ownerState.color].main
    }), ({ ownerState: ownerState })=>ownerState.variant === 'indeterminate' && (0, $d0nrV.css)($895ba70d11219ed4$var$_t3 || ($895ba70d11219ed4$var$_t3 = $895ba70d11219ed4$var$_`
      animation: ${0} 1.4s linear infinite;
    `), $895ba70d11219ed4$var$circularRotateKeyframe));
const $895ba70d11219ed4$var$CircularProgressSVG = (0, $HGmne.default)('svg', {
    name: 'MuiCircularProgress',
    slot: 'Svg',
    overridesResolver: (props, styles)=>styles.svg
})({
    display: 'block' // Keeps the progress centered
});
const $895ba70d11219ed4$var$CircularProgressCircle = (0, $HGmne.default)('circle', {
    name: 'MuiCircularProgress',
    slot: 'Circle',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.circle,
            styles[`circle${(0, $cVrVk.default)(ownerState.variant)}`],
            ownerState.disableShrink && styles.circleDisableShrink
        ];
    }
})(({ ownerState: ownerState, theme: theme })=>(0, $3VnFq.default)({
        stroke: 'currentColor'
    }, ownerState.variant === 'determinate' && {
        transition: theme.transitions.create('stroke-dashoffset')
    }, ownerState.variant === 'indeterminate' && {
        // Some default value that looks fine waiting for the animation to kicks in.
        strokeDasharray: '80px, 200px',
        strokeDashoffset: 0 // Add the unit to fix a Edge 16 and below bug.
    }), ({ ownerState: ownerState })=>ownerState.variant === 'indeterminate' && !ownerState.disableShrink && (0, $d0nrV.css)($895ba70d11219ed4$var$_t4 || ($895ba70d11219ed4$var$_t4 = $895ba70d11219ed4$var$_`
      animation: ${0} 1.4s ease-in-out infinite;
    `), $895ba70d11219ed4$var$circularDashKeyframe));
/**
 * ## ARIA
 *
 * If the progress bar is describing the loading progress of a particular region of a page,
 * you should use `aria-describedby` to point to the progress bar, and set the `aria-busy`
 * attribute to `true` on that region until it has finished loading.
 */ const $895ba70d11219ed4$var$CircularProgress = /*#__PURE__*/ $gJYWc.forwardRef(function CircularProgress(inProps, ref) {
    const props = (0, $8pLcn.useDefaultProps)({
        props: inProps,
        name: 'MuiCircularProgress'
    });
    const { className: className, color: color = 'primary', disableShrink: disableShrink = false, size: size = 40, style: style, thickness: thickness = 3.6, value: value = 0, variant: variant = 'indeterminate' } = props, other = (0, $cTAWX.default)(props, $895ba70d11219ed4$var$_excluded);
    const ownerState = (0, $3VnFq.default)({}, props, {
        color: color,
        disableShrink: disableShrink,
        size: size,
        thickness: thickness,
        value: value,
        variant: variant
    });
    const classes = $895ba70d11219ed4$var$useUtilityClasses(ownerState);
    const circleStyle = {};
    const rootStyle = {};
    const rootProps = {};
    if (variant === 'determinate') {
        const circumference = 2 * Math.PI * (($895ba70d11219ed4$var$SIZE - thickness) / 2);
        circleStyle.strokeDasharray = circumference.toFixed(3);
        rootProps['aria-valuenow'] = Math.round(value);
        circleStyle.strokeDashoffset = `${((100 - value) / 100 * circumference).toFixed(3)}px`;
        rootStyle.transform = 'rotate(-90deg)';
    }
    return /*#__PURE__*/ (0, $9wx12.jsx)($895ba70d11219ed4$var$CircularProgressRoot, (0, $3VnFq.default)({
        className: (0, $2w6IV.default)(classes.root, className),
        style: (0, $3VnFq.default)({
            width: size,
            height: size
        }, rootStyle, style),
        ownerState: ownerState,
        ref: ref,
        role: "progressbar"
    }, rootProps, other, {
        children: /*#__PURE__*/ (0, $9wx12.jsx)($895ba70d11219ed4$var$CircularProgressSVG, {
            className: classes.svg,
            ownerState: ownerState,
            viewBox: `${$895ba70d11219ed4$var$SIZE / 2} ${$895ba70d11219ed4$var$SIZE / 2} ${$895ba70d11219ed4$var$SIZE} ${$895ba70d11219ed4$var$SIZE}`,
            children: /*#__PURE__*/ (0, $9wx12.jsx)($895ba70d11219ed4$var$CircularProgressCircle, {
                className: classes.circle,
                style: circleStyle,
                ownerState: ownerState,
                cx: $895ba70d11219ed4$var$SIZE,
                cy: $895ba70d11219ed4$var$SIZE,
                r: ($895ba70d11219ed4$var$SIZE - thickness) / 2,
                fill: "none",
                strokeWidth: thickness
            })
        })
    }));
});
var $895ba70d11219ed4$export$2e2bcd8739ae039 = $895ba70d11219ed4$var$CircularProgress;




var $9wx12 = parcelRequire("9wx12");





var $9wx12 = parcelRequire("9wx12");




var $cTAWX = parcelRequire("cTAWX");

var $3VnFq = parcelRequire("3VnFq");

var $gJYWc = parcelRequire("gJYWc");


var $2w6IV = parcelRequire("2w6IV");

var $3e4LV = parcelRequire("3e4LV");

var $HGmne = parcelRequire("HGmne");

var $8pLcn = parcelRequire("8pLcn");

var $i8nzj = parcelRequire("i8nzj");

var $1kRHf = parcelRequire("1kRHf");
function $7cc24a64203062a7$export$81478e24460c57f2(slot) {
    return (0, $1kRHf.default)('MuiListItemIcon', slot);
}
const $7cc24a64203062a7$var$listItemIconClasses = (0, $i8nzj.default)('MuiListItemIcon', [
    'root',
    'alignItemsFlexStart'
]);
var $7cc24a64203062a7$export$2e2bcd8739ae039 = $7cc24a64203062a7$var$listItemIconClasses;




var $9wx12 = parcelRequire("9wx12");
'use client';
const $e8d442615d7b0381$var$_excluded = [
    "className"
];
const $e8d442615d7b0381$var$useUtilityClasses = (ownerState)=>{
    const { alignItems: alignItems, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            alignItems === 'flex-start' && 'alignItemsFlexStart'
        ]
    };
    return (0, $3e4LV.default)(slots, (0, $7cc24a64203062a7$export$81478e24460c57f2), classes);
};
const $e8d442615d7b0381$var$ListItemIconRoot = (0, $HGmne.default)('div', {
    name: 'MuiListItemIcon',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.alignItems === 'flex-start' && styles.alignItemsFlexStart
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $3VnFq.default)({
        minWidth: 56,
        color: (theme.vars || theme).palette.action.active,
        flexShrink: 0,
        display: 'inline-flex'
    }, ownerState.alignItems === 'flex-start' && {
        marginTop: 8
    }));
/**
 * A simple wrapper to apply `List` styles to an `Icon` or `SvgIcon`.
 */ const $e8d442615d7b0381$var$ListItemIcon = /*#__PURE__*/ $gJYWc.forwardRef(function ListItemIcon(inProps, ref) {
    const props = (0, $8pLcn.useDefaultProps)({
        props: inProps,
        name: 'MuiListItemIcon'
    });
    const { className: className } = props, other = (0, $cTAWX.default)(props, $e8d442615d7b0381$var$_excluded);
    const context = $gJYWc.useContext((0, $3d14c289610745c4$export$2e2bcd8739ae039));
    const ownerState = (0, $3VnFq.default)({}, props, {
        alignItems: context.alignItems
    });
    const classes = $e8d442615d7b0381$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $9wx12.jsx)($e8d442615d7b0381$var$ListItemIconRoot, (0, $3VnFq.default)({
        className: (0, $2w6IV.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref
    }, other));
});
var $e8d442615d7b0381$export$2e2bcd8739ae039 = $e8d442615d7b0381$var$ListItemIcon;


var $78c1f8e207b61beb$exports = {};
"use strict";
"use client";

var $hrFuR = parcelRequire("hrFuR");
Object.defineProperty($78c1f8e207b61beb$exports, "__esModule", {
    value: true
});
$78c1f8e207b61beb$exports.default = void 0;

var $78c1f8e207b61beb$var$_createSvgIcon = $hrFuR((parcelRequire("lXMfO")));

var $9wx12 = parcelRequire("9wx12");
var $78c1f8e207b61beb$var$_default = $78c1f8e207b61beb$exports.default = (0, $78c1f8e207b61beb$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $9wx12.jsx)("path", {
    d: "M12 17.27 18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z"
}), 'Star');



parcelRequire("gJYWc");
const $3c2c4123bc0edf41$export$316b0abfaee5c8dd = ()=>/*#__PURE__*/ (0, $9wx12.jsxs)((0, $e247548612617cb3$export$2e2bcd8739ae039), {
        dense: true,
        disablePadding: true,
        children: [
            /*#__PURE__*/ (0, $9wx12.jsxs)((0, $fbd2d21ccc73b907$export$2e2bcd8739ae039), {
                sx: {
                    paddingLeft: 0
                },
                children: [
                    /*#__PURE__*/ (0, $9wx12.jsxs)((0, $e8d442615d7b0381$export$2e2bcd8739ae039), {
                        sx: {
                            minWidth: '30px'
                        },
                        children: [
                            " ",
                            /*#__PURE__*/ (0, $9wx12.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($78c1f8e207b61beb$exports))), {})
                        ]
                    }),
                    /*#__PURE__*/ (0, $9wx12.jsx)((0, $7e347bdafa1acea0$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $9wx12.jsx)((0, $b4083ea3a052dee9$export$2e2bcd8739ae039), {
                            color: "text.secondary",
                            fontSize: 16,
                            children: "Select dates and times"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $9wx12.jsxs)((0, $fbd2d21ccc73b907$export$2e2bcd8739ae039), {
                sx: {
                    paddingLeft: 0
                },
                children: [
                    /*#__PURE__*/ (0, $9wx12.jsx)((0, $e8d442615d7b0381$export$2e2bcd8739ae039), {
                        sx: {
                            minWidth: '30px'
                        },
                        children: /*#__PURE__*/ (0, $9wx12.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($78c1f8e207b61beb$exports))), {})
                    }),
                    /*#__PURE__*/ (0, $9wx12.jsx)((0, $7e347bdafa1acea0$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $9wx12.jsx)((0, $b4083ea3a052dee9$export$2e2bcd8739ae039), {
                            color: "text.secondary",
                            fontSize: 16,
                            children: "Write comment to the host"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $9wx12.jsxs)((0, $fbd2d21ccc73b907$export$2e2bcd8739ae039), {
                sx: {
                    paddingLeft: 0
                },
                children: [
                    /*#__PURE__*/ (0, $9wx12.jsx)((0, $e8d442615d7b0381$export$2e2bcd8739ae039), {
                        sx: {
                            minWidth: '30px'
                        },
                        children: /*#__PURE__*/ (0, $9wx12.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($78c1f8e207b61beb$exports))), {})
                    }),
                    /*#__PURE__*/ (0, $9wx12.jsx)((0, $7e347bdafa1acea0$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $9wx12.jsx)((0, $b4083ea3a052dee9$export$2e2bcd8739ae039), {
                            color: "text.secondary",
                            fontSize: 16,
                            children: "Let your host know what you need"
                        })
                    })
                ]
            })
        ]
    });



var $3VnFq = parcelRequire("3VnFq");

var $cTAWX = parcelRequire("cTAWX");

var $gJYWc = parcelRequire("gJYWc");


var $gJYWc = parcelRequire("gJYWc");

var $4z2O6 = parcelRequire("4z2O6");


'use client';
/**
 * @deprecated Not used internally. Use `MediaQueryListEvent` from lib.dom.d.ts instead.
 */ /**
 * @deprecated Not used internally. Use `MediaQueryList` from lib.dom.d.ts instead.
 */ /**
 * @deprecated Not used internally. Use `(event: MediaQueryListEvent) => void` instead.
 */ function $94c6dc53e4570cec$var$useMediaQueryOld(query, defaultMatches, matchMedia, ssrMatchMedia, noSsr) {
    const [match, setMatch] = $gJYWc.useState(()=>{
        if (noSsr && matchMedia) return matchMedia(query).matches;
        if (ssrMatchMedia) return ssrMatchMedia(query).matches;
        // Once the component is mounted, we rely on the
        // event listeners to return the correct matches value.
        return defaultMatches;
    });
    (0, $4z2O6.default)(()=>{
        let active = true;
        if (!matchMedia) return undefined;
        const queryList = matchMedia(query);
        const updateMatch = ()=>{
            // Workaround Safari wrong implementation of matchMedia
            // TODO can we remove it?
            // https://github.com/mui/material-ui/pull/17315#issuecomment-528286677
            if (active) setMatch(queryList.matches);
        };
        updateMatch();
        // TODO: Use `addEventListener` once support for Safari < 14 is dropped
        queryList.addListener(updateMatch);
        return ()=>{
            active = false;
            queryList.removeListener(updateMatch);
        };
    }, [
        query,
        matchMedia
    ]);
    return match;
}
// eslint-disable-next-line no-useless-concat -- Workaround for https://github.com/webpack/webpack/issues/14814
const $94c6dc53e4570cec$var$maybeReactUseSyncExternalStore = $gJYWc.useSyncExternalStore;
function $94c6dc53e4570cec$var$useMediaQueryNew(query, defaultMatches, matchMedia, ssrMatchMedia, noSsr) {
    const getDefaultSnapshot = $gJYWc.useCallback(()=>defaultMatches, [
        defaultMatches
    ]);
    const getServerSnapshot = $gJYWc.useMemo(()=>{
        if (noSsr && matchMedia) return ()=>matchMedia(query).matches;
        if (ssrMatchMedia !== null) {
            const { matches: matches } = ssrMatchMedia(query);
            return ()=>matches;
        }
        return getDefaultSnapshot;
    }, [
        getDefaultSnapshot,
        query,
        ssrMatchMedia,
        noSsr,
        matchMedia
    ]);
    const [getSnapshot, subscribe] = $gJYWc.useMemo(()=>{
        if (matchMedia === null) return [
            getDefaultSnapshot,
            ()=>()=>{}
        ];
        const mediaQueryList = matchMedia(query);
        return [
            ()=>mediaQueryList.matches,
            (notify)=>{
                // TODO: Use `addEventListener` once support for Safari < 14 is dropped
                mediaQueryList.addListener(notify);
                return ()=>{
                    mediaQueryList.removeListener(notify);
                };
            }
        ];
    }, [
        getDefaultSnapshot,
        matchMedia,
        query
    ]);
    const match = $94c6dc53e4570cec$var$maybeReactUseSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
    return match;
}
function $94c6dc53e4570cec$export$2e2bcd8739ae039(queryInput, options = {}) {
    const theme = (0, $2aefe0c034e4c8e0$export$2e2bcd8739ae039)();
    // Wait for jsdom to support the match media feature.
    // All the browsers MUI support have this built-in.
    // This defensive check is here for simplicity.
    // Most of the time, the match media logic isn't central to people tests.
    const supportMatchMedia = typeof window !== 'undefined' && typeof window.matchMedia !== 'undefined';
    const { defaultMatches: defaultMatches = false, matchMedia: matchMedia = supportMatchMedia ? window.matchMedia : null, ssrMatchMedia: ssrMatchMedia = null, noSsr: noSsr = false } = (0, $8a44b6862528b26f$export$2e2bcd8739ae039)({
        name: 'MuiUseMediaQuery',
        props: options,
        theme: theme
    });
    let query = typeof queryInput === 'function' ? queryInput(theme) : queryInput;
    query = query.replace(/^@media( ?)/m, '');
    // TODO: Drop `useMediaQueryOld` and use  `use-sync-external-store` shim in `useMediaQueryNew` once the package is stable
    const useMediaQueryImplementation = $94c6dc53e4570cec$var$maybeReactUseSyncExternalStore !== undefined ? $94c6dc53e4570cec$var$useMediaQueryNew : $94c6dc53e4570cec$var$useMediaQueryOld;
    const match = useMediaQueryImplementation(query, defaultMatches, matchMedia, ssrMatchMedia, noSsr);
    return match;
}





var $3VnFq = parcelRequire("3VnFq");

var $gJYWc = parcelRequire("gJYWc");

var $3Zour = parcelRequire("3Zour");
/**
 * If `componentProps` is a function, calls it with the provided `ownerState`.
 * Otherwise, just returns `componentProps`.
 */ function $1cf868609b280c1d$export$308c24034cde71de(componentProps, ownerState, slotState) {
    if (typeof componentProps === 'function') return componentProps(ownerState, slotState);
    return componentProps;
}



var $3Zour = parcelRequire("3Zour");
const $82c4d2ab89e86c16$var$refType = (0, (/*@__PURE__*/$parcel$interopDefault($3Zour))).oneOfType([
    (0, (/*@__PURE__*/$parcel$interopDefault($3Zour))).func,
    (0, (/*@__PURE__*/$parcel$interopDefault($3Zour))).object
]);
var $82c4d2ab89e86c16$export$2e2bcd8739ae039 = $82c4d2ab89e86c16$var$refType;



var $cTAWX = parcelRequire("cTAWX");
const $fd452c2a61e4326f$export$f07872cd524bec98 = (views, expectedViews)=>{
    if (views.length !== expectedViews.length) return false;
    return expectedViews.every((expectedView)=>views.includes(expectedView));
};
const $fd452c2a61e4326f$export$bdf8d867ddc968e = ({ openTo: openTo, defaultOpenTo: defaultOpenTo, views: views, defaultViews: defaultViews })=>{
    const viewsWithDefault = views != null ? views : defaultViews;
    let openToWithDefault;
    if (openTo != null) openToWithDefault = openTo;
    else if (viewsWithDefault.includes(defaultOpenTo)) openToWithDefault = defaultOpenTo;
    else if (viewsWithDefault.length > 0) openToWithDefault = viewsWithDefault[0];
    else throw new Error('MUI: The `views` prop must contain at least one view');
    return {
        views: viewsWithDefault,
        openTo: openToWithDefault
    };
};


const $00e6d022b450825d$export$a98b123b8f29e004 = (utils, dateParam, timeParam)=>{
    let mergedDate = dateParam;
    mergedDate = utils.setHours(mergedDate, utils.getHours(timeParam));
    mergedDate = utils.setMinutes(mergedDate, utils.getMinutes(timeParam));
    mergedDate = utils.setSeconds(mergedDate, utils.getSeconds(timeParam));
    return mergedDate;
};
const $00e6d022b450825d$export$ca1f317ae8db2ee8 = ({ date: date, disableFuture: disableFuture, disablePast: disablePast, maxDate: maxDate, minDate: minDate, isDateDisabled: isDateDisabled, utils: utils, timezone: timezone })=>{
    const today = $00e6d022b450825d$export$a98b123b8f29e004(utils, utils.dateWithTimezone(undefined, timezone), date);
    if (disablePast && utils.isBefore(minDate, today)) minDate = today;
    if (disableFuture && utils.isAfter(maxDate, today)) maxDate = today;
    let forward = date;
    let backward = date;
    if (utils.isBefore(date, minDate)) {
        forward = minDate;
        backward = null;
    }
    if (utils.isAfter(date, maxDate)) {
        if (backward) backward = maxDate;
        forward = null;
    }
    while(forward || backward){
        if (forward && utils.isAfter(forward, maxDate)) forward = null;
        if (backward && utils.isBefore(backward, minDate)) backward = null;
        if (forward) {
            if (!isDateDisabled(forward)) return forward;
            forward = utils.addDays(forward, 1);
        }
        if (backward) {
            if (!isDateDisabled(backward)) return backward;
            backward = utils.addDays(backward, -1);
        }
    }
    return null;
};
const $00e6d022b450825d$export$36ca889e039badd5 = (utils, value)=>value == null || !utils.isValid(value) ? null : value;
const $00e6d022b450825d$export$eb73579ccade48fd = (utils, value, defaultValue)=>{
    if (value == null || !utils.isValid(value)) return defaultValue;
    return value;
};
const $00e6d022b450825d$export$8fabf9a4cbada414 = (utils, a, b)=>{
    if (!utils.isValid(a) && a != null && !utils.isValid(b) && b != null) return true;
    return utils.isEqual(a, b);
};
const $00e6d022b450825d$export$62591b96a734eacd = (utils, year)=>{
    const firstMonth = utils.startOfYear(year);
    const months = [
        firstMonth
    ];
    while(months.length < 12){
        const prevMonth = months[months.length - 1];
        months.push(utils.addMonths(prevMonth, 1));
    }
    return months;
};
const $00e6d022b450825d$export$1118e4272ea1e258 = (utils, timezone, valueType)=>valueType === 'date' ? utils.startOfDay(utils.dateWithTimezone(undefined, timezone)) : utils.dateWithTimezone(undefined, timezone);
const $00e6d022b450825d$export$fae94c0a662107ef = (utils, meridiem)=>{
    const date = utils.setHours(utils.date(), meridiem === 'am' ? 2 : 14);
    return utils.format(date, 'meridiem');
};
const $00e6d022b450825d$var$dateViews = [
    'year',
    'month',
    'day'
];
const $00e6d022b450825d$export$b32dfef9f07dea64 = (view)=>$00e6d022b450825d$var$dateViews.includes(view);
const $00e6d022b450825d$export$bb1c921f313ec928 = (utils, { format: format, views: views }, isInToolbar)=>{
    if (format != null) return format;
    const formats = utils.formats;
    if ((0, $fd452c2a61e4326f$export$f07872cd524bec98)(views, [
        'year'
    ])) return formats.year;
    if ((0, $fd452c2a61e4326f$export$f07872cd524bec98)(views, [
        'month'
    ])) return formats.month;
    if ((0, $fd452c2a61e4326f$export$f07872cd524bec98)(views, [
        'day'
    ])) return formats.dayOfMonth;
    if ((0, $fd452c2a61e4326f$export$f07872cd524bec98)(views, [
        'month',
        'year'
    ])) return `${formats.month} ${formats.year}`;
    if ((0, $fd452c2a61e4326f$export$f07872cd524bec98)(views, [
        'day',
        'month'
    ])) return `${formats.month} ${formats.dayOfMonth}`;
    if (isInToolbar) // Little localization hack (Google is doing the same for android native pickers):
    // For english localization it is convenient to include weekday into the date "Mon, Jun 1".
    // For other locales using strings like "June 1", without weekday.
    return /en/.test(utils.getCurrentLocaleCode()) ? formats.normalDateWithWeekday : formats.normalDate;
    return formats.keyboardDate;
};
const $00e6d022b450825d$export$24c38139da66592d = (utils, date)=>{
    const start = utils.startOfWeek(date);
    return [
        0,
        1,
        2,
        3,
        4,
        5,
        6
    ].map((diff)=>utils.addDays(start, diff));
};



const $ab68d4157b5096ce$var$timeViews = [
    'hours',
    'minutes',
    'seconds'
];
const $ab68d4157b5096ce$export$8f04d380cefd5a0d = (view)=>$ab68d4157b5096ce$var$timeViews.includes(view);
const $ab68d4157b5096ce$export$a3328136ac50623d = (view)=>$ab68d4157b5096ce$var$timeViews.includes(view) || view === 'meridiem';
const $ab68d4157b5096ce$export$c3352ead7b032236 = (date, utils)=>{
    if (!date) return null;
    return utils.getHours(date) >= 12 ? 'pm' : 'am';
};
const $ab68d4157b5096ce$export$4159dc823695870e = (value, meridiem, ampm)=>{
    if (ampm) {
        const currentMeridiem = value >= 12 ? 'pm' : 'am';
        if (currentMeridiem !== meridiem) return meridiem === 'am' ? value - 12 : value + 12;
    }
    return value;
};
const $ab68d4157b5096ce$export$c368d4ff66779998 = (time, meridiem, ampm, utils)=>{
    const newHoursAmount = $ab68d4157b5096ce$export$4159dc823695870e(utils.getHours(time), meridiem, ampm);
    return utils.setHours(time, newHoursAmount);
};
const $ab68d4157b5096ce$export$888a1ce13aa61986 = (date, utils)=>{
    return utils.getHours(date) * 3600 + utils.getMinutes(date) * 60 + utils.getSeconds(date);
};
const $ab68d4157b5096ce$export$fb87c80b35a46b89 = (disableIgnoringDatePartForTimeValidation, utils)=>(dateLeft, dateRight)=>{
        if (disableIgnoringDatePartForTimeValidation) return utils.isAfter(dateLeft, dateRight);
        return $ab68d4157b5096ce$export$888a1ce13aa61986(dateLeft, utils) > $ab68d4157b5096ce$export$888a1ce13aa61986(dateRight, utils);
    };
const $ab68d4157b5096ce$export$3a6776b3863772fe = (utils, { format: format, views: views, ampm: ampm })=>{
    if (format != null) return format;
    const formats = utils.formats;
    if ((0, $fd452c2a61e4326f$export$f07872cd524bec98)(views, [
        'hours'
    ])) return ampm ? `${formats.hours12h} ${formats.meridiem}` : formats.hours24h;
    if ((0, $fd452c2a61e4326f$export$f07872cd524bec98)(views, [
        'minutes'
    ])) return formats.minutes;
    if ((0, $fd452c2a61e4326f$export$f07872cd524bec98)(views, [
        'seconds'
    ])) return formats.seconds;
    if ((0, $fd452c2a61e4326f$export$f07872cd524bec98)(views, [
        'minutes',
        'seconds'
    ])) return `${formats.minutes}:${formats.seconds}`;
    if ((0, $fd452c2a61e4326f$export$f07872cd524bec98)(views, [
        'hours',
        'minutes',
        'seconds'
    ])) return ampm ? `${formats.hours12h}:${formats.minutes}:${formats.seconds} ${formats.meridiem}` : `${formats.hours24h}:${formats.minutes}:${formats.seconds}`;
    return ampm ? `${formats.hours12h}:${formats.minutes} ${formats.meridiem}` : `${formats.hours24h}:${formats.minutes}`;
};



const $d8b7b2aeaa0755b4$export$8f74e8f4ed8ae0ac = {
    year: 1,
    month: 2,
    day: 3,
    hours: 4,
    minutes: 5,
    seconds: 6,
    milliseconds: 7
};
const $d8b7b2aeaa0755b4$export$3f2547ddf892237a = (sections)=>Math.max(...sections.map((section)=>{
        var _SECTION_TYPE_GRANULA;
        return (_SECTION_TYPE_GRANULA = $d8b7b2aeaa0755b4$export$8f74e8f4ed8ae0ac[section.type]) != null ? _SECTION_TYPE_GRANULA : 1;
    }));
const $d8b7b2aeaa0755b4$export$e7c8ae702868847 = (views)=>Math.max(...views.map((view)=>{
        var _SECTION_TYPE_GRANULA2;
        return (_SECTION_TYPE_GRANULA2 = $d8b7b2aeaa0755b4$export$8f74e8f4ed8ae0ac[view]) != null ? _SECTION_TYPE_GRANULA2 : 1;
    }));
const $d8b7b2aeaa0755b4$var$roundDate = (utils, granularity, date)=>{
    if (granularity === $d8b7b2aeaa0755b4$export$8f74e8f4ed8ae0ac.year) return utils.startOfYear(date);
    if (granularity === $d8b7b2aeaa0755b4$export$8f74e8f4ed8ae0ac.month) return utils.startOfMonth(date);
    if (granularity === $d8b7b2aeaa0755b4$export$8f74e8f4ed8ae0ac.day) return utils.startOfDay(date);
    // We don't have startOfHour / startOfMinute / startOfSecond
    let roundedDate = date;
    if (granularity < $d8b7b2aeaa0755b4$export$8f74e8f4ed8ae0ac.minutes) roundedDate = utils.setMinutes(roundedDate, 0);
    if (granularity < $d8b7b2aeaa0755b4$export$8f74e8f4ed8ae0ac.seconds) roundedDate = utils.setSeconds(roundedDate, 0);
    if (granularity < $d8b7b2aeaa0755b4$export$8f74e8f4ed8ae0ac.milliseconds) roundedDate = utils.setMilliseconds(roundedDate, 0);
    return roundedDate;
};
const $d8b7b2aeaa0755b4$export$6a31d56794238e4e = ({ props: props, utils: utils, granularity: granularity, timezone: timezone, getTodayDate: inGetTodayDate })=>{
    var _props$disableIgnorin;
    let referenceDate = inGetTodayDate ? inGetTodayDate() : $d8b7b2aeaa0755b4$var$roundDate(utils, granularity, (0, $00e6d022b450825d$export$1118e4272ea1e258)(utils, timezone));
    if (props.minDate != null && utils.isAfterDay(props.minDate, referenceDate)) referenceDate = $d8b7b2aeaa0755b4$var$roundDate(utils, granularity, props.minDate);
    if (props.maxDate != null && utils.isBeforeDay(props.maxDate, referenceDate)) referenceDate = $d8b7b2aeaa0755b4$var$roundDate(utils, granularity, props.maxDate);
    const isAfter = (0, $ab68d4157b5096ce$export$fb87c80b35a46b89)((_props$disableIgnorin = props.disableIgnoringDatePartForTimeValidation) != null ? _props$disableIgnorin : false, utils);
    if (props.minTime != null && isAfter(props.minTime, referenceDate)) referenceDate = $d8b7b2aeaa0755b4$var$roundDate(utils, granularity, props.disableIgnoringDatePartForTimeValidation ? props.minTime : (0, $00e6d022b450825d$export$a98b123b8f29e004)(utils, referenceDate, props.minTime));
    if (props.maxTime != null && isAfter(referenceDate, props.maxTime)) referenceDate = $d8b7b2aeaa0755b4$var$roundDate(utils, granularity, props.disableIgnoringDatePartForTimeValidation ? props.maxTime : (0, $00e6d022b450825d$export$a98b123b8f29e004)(utils, referenceDate, props.maxTime));
    return referenceDate;
};



var $3VnFq = parcelRequire("3VnFq");

const $5a21afc6f4ba9c13$export$2f3c5fac7a2a65f6 = (utils, formatToken)=>{
    const config = utils.formatTokenMap[formatToken];
    if (config == null) throw new Error([
        `MUI: The token "${formatToken}" is not supported by the Date and Time Pickers.`,
        'Please try using another token or open an issue on https://github.com/mui/mui-x/issues/new/choose if you think it should be supported.'
    ].join('\n'));
    if (typeof config === 'string') return {
        type: config,
        contentType: config === 'meridiem' ? 'letter' : 'digit',
        maxLength: undefined
    };
    return {
        type: config.sectionType,
        contentType: config.contentType,
        maxLength: config.maxLength
    };
};
const $5a21afc6f4ba9c13$var$getDeltaFromKeyCode = (keyCode)=>{
    switch(keyCode){
        case 'ArrowUp':
            return 1;
        case 'ArrowDown':
            return -1;
        case 'PageUp':
            return 5;
        case 'PageDown':
            return -5;
        default:
            return 0;
    }
};
const $5a21afc6f4ba9c13$export$c65c7173f879039f = (utils, timezone, format)=>{
    const elements = [];
    const now = utils.dateWithTimezone(undefined, timezone);
    const startDate = utils.startOfWeek(now);
    const endDate = utils.endOfWeek(now);
    let current = startDate;
    while(utils.isBefore(current, endDate)){
        elements.push(current);
        current = utils.addDays(current, 1);
    }
    return elements.map((weekDay)=>utils.formatByString(weekDay, format));
};
const $5a21afc6f4ba9c13$export$3ee1e7e19c2b047a = (utils, timezone, sectionType, format)=>{
    switch(sectionType){
        case 'month':
            return (0, $00e6d022b450825d$export$62591b96a734eacd)(utils, utils.dateWithTimezone(undefined, timezone)).map((month)=>utils.formatByString(month, format));
        case 'weekDay':
            return $5a21afc6f4ba9c13$export$c65c7173f879039f(utils, timezone, format);
        case 'meridiem':
            {
                const now = utils.dateWithTimezone(undefined, timezone);
                return [
                    utils.startOfDay(now),
                    utils.endOfDay(now)
                ].map((date)=>utils.formatByString(date, format));
            }
        default:
            return [];
    }
};
const $5a21afc6f4ba9c13$export$713c6d756c12fc27 = (utils, valueStr, size)=>{
    let cleanValueStr = valueStr;
    // Remove the leading zeros
    cleanValueStr = Number(cleanValueStr).toString();
    // Add enough leading zeros to fill the section
    while(cleanValueStr.length < size)cleanValueStr = `0${cleanValueStr}`;
    return cleanValueStr;
};
const $5a21afc6f4ba9c13$export$ef88db4bceade9fd = (utils, timezone, value, sectionBoundaries, section)=>{
    if (section.type === 'day' && section.contentType === 'digit-with-letter') {
        const date = utils.setDate(sectionBoundaries.longestMonth, value);
        return utils.formatByString(date, section.format);
    }
    // queryValue without leading `0` (`01` => `1`)
    const valueStr = value.toString();
    if (section.hasLeadingZerosInInput) return $5a21afc6f4ba9c13$export$713c6d756c12fc27(utils, valueStr, section.maxLength);
    return valueStr;
};
const $5a21afc6f4ba9c13$export$5ed0f22513e58fe3 = (utils, timezone, section, keyCode, sectionsValueBoundaries, activeDate, stepsAttributes)=>{
    const delta = $5a21afc6f4ba9c13$var$getDeltaFromKeyCode(keyCode);
    const isStart = keyCode === 'Home';
    const isEnd = keyCode === 'End';
    const shouldSetAbsolute = section.value === '' || isStart || isEnd;
    const adjustDigitSection = ()=>{
        const sectionBoundaries = sectionsValueBoundaries[section.type]({
            currentDate: activeDate,
            format: section.format,
            contentType: section.contentType
        });
        const getCleanValue = (value)=>$5a21afc6f4ba9c13$export$ef88db4bceade9fd(utils, timezone, value, sectionBoundaries, section);
        const step = section.type === 'minutes' && stepsAttributes != null && stepsAttributes.minutesStep ? stepsAttributes.minutesStep : 1;
        const currentSectionValue = parseInt(section.value, 10);
        let newSectionValueNumber = currentSectionValue + delta * step;
        if (shouldSetAbsolute) {
            if (section.type === 'year' && !isEnd && !isStart) return utils.formatByString(utils.dateWithTimezone(undefined, timezone), section.format);
            if (delta > 0 || isStart) newSectionValueNumber = sectionBoundaries.minimum;
            else newSectionValueNumber = sectionBoundaries.maximum;
        }
        if (newSectionValueNumber % step !== 0) {
            if (delta < 0 || isStart) newSectionValueNumber += step - (step + newSectionValueNumber) % step; // for JS -3 % 5 = -3 (should be 2)
            if (delta > 0 || isEnd) newSectionValueNumber -= newSectionValueNumber % step;
        }
        if (newSectionValueNumber > sectionBoundaries.maximum) return getCleanValue(sectionBoundaries.minimum + (newSectionValueNumber - sectionBoundaries.maximum - 1) % (sectionBoundaries.maximum - sectionBoundaries.minimum + 1));
        if (newSectionValueNumber < sectionBoundaries.minimum) return getCleanValue(sectionBoundaries.maximum - (sectionBoundaries.minimum - newSectionValueNumber - 1) % (sectionBoundaries.maximum - sectionBoundaries.minimum + 1));
        return getCleanValue(newSectionValueNumber);
    };
    const adjustLetterSection = ()=>{
        const options = $5a21afc6f4ba9c13$export$3ee1e7e19c2b047a(utils, timezone, section.type, section.format);
        if (options.length === 0) return section.value;
        if (shouldSetAbsolute) {
            if (delta > 0 || isStart) return options[0];
            return options[options.length - 1];
        }
        const currentOptionIndex = options.indexOf(section.value);
        const newOptionIndex = (currentOptionIndex + options.length + delta) % options.length;
        return options[newOptionIndex];
    };
    if (section.contentType === 'digit' || section.contentType === 'digit-with-letter') return adjustDigitSection();
    return adjustLetterSection();
};
const $5a21afc6f4ba9c13$export$85daa91f6c6e875f = (section, target)=>{
    let value = section.value || section.placeholder;
    const hasLeadingZeros = target === 'non-input' ? section.hasLeadingZerosInFormat : section.hasLeadingZerosInInput;
    if (target === 'non-input' && section.hasLeadingZerosInInput && !section.hasLeadingZerosInFormat) value = Number(value).toString();
    // In the input, we add an empty character at the end of each section without leading zeros.
    // This makes sure that `onChange` will always be fired.
    // Otherwise, when your input value equals `1/dd/yyyy` (format `M/DD/YYYY` on DayJs),
    // If you press `1`, on the first section, the new value is also `1/dd/yyyy`,
    // So the browser will not fire the input `onChange`.
    const shouldAddInvisibleSpace = [
        'input-rtl',
        'input-ltr'
    ].includes(target) && section.contentType === 'digit' && !hasLeadingZeros && value.length === 1;
    if (shouldAddInvisibleSpace) value = `${value}\u200e`;
    if (target === 'input-rtl') value = `\u2068${value}\u2069`;
    return value;
};
const $5a21afc6f4ba9c13$export$cb0bbc88c7f09596 = (dirtyString)=>dirtyString.replace(/[\u2066\u2067\u2068\u2069]/g, '');
const $5a21afc6f4ba9c13$export$8bb5d1c9951d10ca = (sections, isRTL)=>{
    let position = 0;
    let positionInInput = isRTL ? 1 : 0;
    const newSections = [];
    for(let i = 0; i < sections.length; i += 1){
        const section = sections[i];
        const renderedValue = $5a21afc6f4ba9c13$export$85daa91f6c6e875f(section, isRTL ? 'input-rtl' : 'input-ltr');
        const sectionStr = `${section.startSeparator}${renderedValue}${section.endSeparator}`;
        const sectionLength = $5a21afc6f4ba9c13$export$cb0bbc88c7f09596(sectionStr).length;
        const sectionLengthInInput = sectionStr.length;
        // The ...InInput values consider the unicode characters but do include them in their indexes
        const cleanedValue = $5a21afc6f4ba9c13$export$cb0bbc88c7f09596(renderedValue);
        const startInInput = positionInInput + renderedValue.indexOf(cleanedValue[0]) + section.startSeparator.length;
        const endInInput = startInInput + cleanedValue.length;
        newSections.push((0, $3VnFq.default)({}, section, {
            start: position,
            end: position + sectionLength,
            startInInput: startInInput,
            endInInput: endInInput
        }));
        position += sectionLength;
        // Move position to the end of string associated to the current section
        positionInInput += sectionLengthInInput;
    }
    return newSections;
};
const $5a21afc6f4ba9c13$var$getSectionPlaceholder = (utils, timezone, localeText, sectionConfig, sectionFormat)=>{
    switch(sectionConfig.type){
        case 'year':
            return localeText.fieldYearPlaceholder({
                digitAmount: utils.formatByString(utils.dateWithTimezone(undefined, timezone), sectionFormat).length,
                format: sectionFormat
            });
        case 'month':
            return localeText.fieldMonthPlaceholder({
                contentType: sectionConfig.contentType,
                format: sectionFormat
            });
        case 'day':
            return localeText.fieldDayPlaceholder({
                format: sectionFormat
            });
        case 'weekDay':
            return localeText.fieldWeekDayPlaceholder({
                contentType: sectionConfig.contentType,
                format: sectionFormat
            });
        case 'hours':
            return localeText.fieldHoursPlaceholder({
                format: sectionFormat
            });
        case 'minutes':
            return localeText.fieldMinutesPlaceholder({
                format: sectionFormat
            });
        case 'seconds':
            return localeText.fieldSecondsPlaceholder({
                format: sectionFormat
            });
        case 'meridiem':
            return localeText.fieldMeridiemPlaceholder({
                format: sectionFormat
            });
        default:
            return sectionFormat;
    }
};
const $5a21afc6f4ba9c13$export$2816862a602354ce = (utils, valueStr, currentFormat, newFormat)=>{
    return utils.formatByString(utils.parse(valueStr, currentFormat), newFormat);
};
const $5a21afc6f4ba9c13$var$isFourDigitYearFormat = (utils, timezone, format)=>utils.formatByString(utils.dateWithTimezone(undefined, timezone), format).length === 4;
const $5a21afc6f4ba9c13$export$78b5830e2dd2de49 = (utils, timezone, contentType, sectionType, format)=>{
    if (contentType !== 'digit') return false;
    const now = utils.dateWithTimezone(undefined, timezone);
    switch(sectionType){
        // We can't use `changeSectionValueFormat`, because  `utils.parse('1', 'YYYY')` returns `1971` instead of `1`.
        case 'year':
            {
                if ($5a21afc6f4ba9c13$var$isFourDigitYearFormat(utils, timezone, format)) {
                    const formatted0001 = utils.formatByString(utils.setYear(now, 1), format);
                    return formatted0001 === '0001';
                }
                const formatted2001 = utils.formatByString(utils.setYear(now, 2001), format);
                return formatted2001 === '01';
            }
        case 'month':
            return utils.formatByString(utils.startOfYear(now), format).length > 1;
        case 'day':
            return utils.formatByString(utils.startOfMonth(now), format).length > 1;
        case 'weekDay':
            return utils.formatByString(utils.startOfWeek(now), format).length > 1;
        case 'hours':
            return utils.formatByString(utils.setHours(now, 1), format).length > 1;
        case 'minutes':
            return utils.formatByString(utils.setMinutes(now, 1), format).length > 1;
        case 'seconds':
            return utils.formatByString(utils.setSeconds(now, 1), format).length > 1;
        default:
            throw new Error('Invalid section type');
    }
};
const $5a21afc6f4ba9c13$var$getEscapedPartsFromFormat = (utils, format)=>{
    const escapedParts = [];
    const { start: startChar, end: endChar } = utils.escapedCharacters;
    const regExp = new RegExp(`(\\${startChar}[^\\${endChar}]*\\${endChar})+`, 'g');
    let match = null;
    // eslint-disable-next-line no-cond-assign
    while(match = regExp.exec(format))escapedParts.push({
        start: match.index,
        end: regExp.lastIndex - 1
    });
    return escapedParts;
};
const $5a21afc6f4ba9c13$export$fd71d82fe42bada1 = (utils, timezone, localeText, format, date, formatDensity, shouldRespectLeadingZeros, isRTL)=>{
    let startSeparator = '';
    const sections = [];
    const now = utils.date();
    const commitToken = (token)=>{
        if (token === '') return null;
        const sectionConfig = $5a21afc6f4ba9c13$export$2f3c5fac7a2a65f6(utils, token);
        const hasLeadingZerosInFormat = $5a21afc6f4ba9c13$export$78b5830e2dd2de49(utils, timezone, sectionConfig.contentType, sectionConfig.type, token);
        const hasLeadingZerosInInput = shouldRespectLeadingZeros ? hasLeadingZerosInFormat : sectionConfig.contentType === 'digit';
        const isValidDate = date != null && utils.isValid(date);
        let sectionValue = isValidDate ? utils.formatByString(date, token) : '';
        let maxLength = null;
        if (hasLeadingZerosInInput) {
            if (hasLeadingZerosInFormat) maxLength = sectionValue === '' ? utils.formatByString(now, token).length : sectionValue.length;
            else {
                if (sectionConfig.maxLength == null) throw new Error(`MUI: The token ${token} should have a 'maxDigitNumber' property on it's adapter`);
                maxLength = sectionConfig.maxLength;
                if (isValidDate) sectionValue = $5a21afc6f4ba9c13$export$713c6d756c12fc27(utils, sectionValue, maxLength);
            }
        }
        sections.push((0, $3VnFq.default)({}, sectionConfig, {
            format: token,
            maxLength: maxLength,
            value: sectionValue,
            placeholder: $5a21afc6f4ba9c13$var$getSectionPlaceholder(utils, timezone, localeText, sectionConfig, token),
            hasLeadingZeros: hasLeadingZerosInFormat,
            hasLeadingZerosInFormat: hasLeadingZerosInFormat,
            hasLeadingZerosInInput: hasLeadingZerosInInput,
            startSeparator: sections.length === 0 ? startSeparator : '',
            endSeparator: '',
            modified: false
        }));
        return null;
    };
    // Expand the provided format
    let formatExpansionOverflow = 10;
    let prevFormat = format;
    let nextFormat = utils.expandFormat(format);
    while(nextFormat !== prevFormat){
        prevFormat = nextFormat;
        nextFormat = utils.expandFormat(prevFormat);
        formatExpansionOverflow -= 1;
        if (formatExpansionOverflow < 0) throw new Error('MUI: The format expansion seems to be  enter in an infinite loop. Please open an issue with the format passed to the picker component');
    }
    const expandedFormat = nextFormat;
    // Get start/end indexes of escaped sections
    const escapedParts = $5a21afc6f4ba9c13$var$getEscapedPartsFromFormat(utils, expandedFormat);
    // This RegExp test if the beginning of a string correspond to a supported token
    const isTokenStartRegExp = new RegExp(`^(${Object.keys(utils.formatTokenMap).sort((a, b)=>b.length - a.length) // Sort to put longest word first
    .join('|')})`, 'g') // used to get access to lastIndex state
    ;
    let currentTokenValue = '';
    for(let i = 0; i < expandedFormat.length; i += 1){
        const escapedPartOfCurrentChar = escapedParts.find((escapeIndex)=>escapeIndex.start <= i && escapeIndex.end >= i);
        const char = expandedFormat[i];
        const isEscapedChar = escapedPartOfCurrentChar != null;
        const potentialToken = `${currentTokenValue}${expandedFormat.slice(i)}`;
        const regExpMatch = isTokenStartRegExp.test(potentialToken);
        if (!isEscapedChar && char.match(/([A-Za-z]+)/) && regExpMatch) {
            currentTokenValue = potentialToken.slice(0, isTokenStartRegExp.lastIndex);
            i += isTokenStartRegExp.lastIndex - 1;
        } else {
            // If we are on the opening or closing character of an escaped part of the format,
            // Then we ignore this character.
            const isEscapeBoundary = isEscapedChar && (escapedPartOfCurrentChar == null ? void 0 : escapedPartOfCurrentChar.start) === i || (escapedPartOfCurrentChar == null ? void 0 : escapedPartOfCurrentChar.end) === i;
            if (!isEscapeBoundary) {
                commitToken(currentTokenValue);
                currentTokenValue = '';
                if (sections.length === 0) startSeparator += char;
                else sections[sections.length - 1].endSeparator += char;
            }
        }
    }
    commitToken(currentTokenValue);
    return sections.map((section)=>{
        const cleanSeparator = (separator)=>{
            let cleanedSeparator = separator;
            if (isRTL && cleanedSeparator !== null && cleanedSeparator.includes(' ')) cleanedSeparator = `\u2069${cleanedSeparator}\u2066`;
            if (formatDensity === 'spacious' && [
                '/',
                '.',
                '-'
            ].includes(cleanedSeparator)) cleanedSeparator = ` ${cleanedSeparator} `;
            return cleanedSeparator;
        };
        section.startSeparator = cleanSeparator(section.startSeparator);
        section.endSeparator = cleanSeparator(section.endSeparator);
        return section;
    });
};
const $5a21afc6f4ba9c13$export$b0c1bfd065bfe742 = (utils, sections)=>{
    // If we have both a day and a weekDay section,
    // Then we skip the weekDay in the parsing because libraries like dayjs can't parse complicated formats containing a weekDay.
    // dayjs(dayjs().format('dddd MMMM D YYYY'), 'dddd MMMM D YYYY')) // returns `Invalid Date` even if the format is valid.
    const shouldSkipWeekDays = sections.some((section)=>section.type === 'day');
    const sectionFormats = [];
    const sectionValues = [];
    for(let i = 0; i < sections.length; i += 1){
        const section = sections[i];
        const shouldSkip = shouldSkipWeekDays && section.type === 'weekDay';
        if (!shouldSkip) {
            sectionFormats.push(section.format);
            sectionValues.push($5a21afc6f4ba9c13$export$85daa91f6c6e875f(section, 'non-input'));
        }
    }
    const formatWithoutSeparator = sectionFormats.join(' ');
    const dateWithoutSeparatorStr = sectionValues.join(' ');
    return utils.parse(dateWithoutSeparatorStr, formatWithoutSeparator);
};
const $5a21afc6f4ba9c13$export$e990c4332a617e3d = (sections, isRTL)=>{
    const formattedSections = sections.map((section)=>{
        const dateValue = $5a21afc6f4ba9c13$export$85daa91f6c6e875f(section, isRTL ? 'input-rtl' : 'input-ltr');
        return `${section.startSeparator}${dateValue}${section.endSeparator}`;
    });
    const dateStr = formattedSections.join('');
    if (!isRTL) return dateStr;
    // \u2066: start left-to-right isolation
    // \u2067: start right-to-left isolation
    // \u2068: start first strong character isolation
    // \u2069: pop isolation
    // wrap into an isolated group such that separators can split the string in smaller ones by adding \u2069\u2068
    return `\u2066${dateStr}\u2069`;
};
const $5a21afc6f4ba9c13$export$360600f456ea7d5f = (utils, timezone)=>{
    const today = utils.dateWithTimezone(undefined, timezone);
    const endOfYear = utils.endOfYear(today);
    const endOfDay = utils.endOfDay(today);
    const { maxDaysInMonth: maxDaysInMonth, longestMonth: longestMonth } = (0, $00e6d022b450825d$export$62591b96a734eacd)(utils, today).reduce((acc, month)=>{
        const daysInMonth = utils.getDaysInMonth(month);
        if (daysInMonth > acc.maxDaysInMonth) return {
            maxDaysInMonth: daysInMonth,
            longestMonth: month
        };
        return acc;
    }, {
        maxDaysInMonth: 0,
        longestMonth: null
    });
    return {
        year: ({ format: format })=>({
                minimum: 0,
                maximum: $5a21afc6f4ba9c13$var$isFourDigitYearFormat(utils, timezone, format) ? 9999 : 99
            }),
        month: ()=>({
                minimum: 1,
                // Assumption: All years have the same amount of months
                maximum: utils.getMonth(endOfYear) + 1
            }),
        day: ({ currentDate: currentDate })=>({
                minimum: 1,
                maximum: currentDate != null && utils.isValid(currentDate) ? utils.getDaysInMonth(currentDate) : maxDaysInMonth,
                longestMonth: longestMonth
            }),
        weekDay: ({ format: format, contentType: contentType })=>{
            if (contentType === 'digit') {
                const daysInWeek = $5a21afc6f4ba9c13$export$c65c7173f879039f(utils, timezone, format).map(Number);
                return {
                    minimum: Math.min(...daysInWeek),
                    maximum: Math.max(...daysInWeek)
                };
            }
            return {
                minimum: 1,
                maximum: 7
            };
        },
        hours: ({ format: format })=>{
            const lastHourInDay = utils.getHours(endOfDay);
            const hasMeridiem = utils.formatByString(utils.endOfDay(today), format) !== lastHourInDay.toString();
            if (hasMeridiem) return {
                minimum: 1,
                maximum: Number(utils.formatByString(utils.startOfDay(today), format))
            };
            return {
                minimum: 0,
                maximum: lastHourInDay
            };
        },
        minutes: ()=>({
                minimum: 0,
                // Assumption: All years have the same amount of minutes
                maximum: utils.getMinutes(endOfDay)
            }),
        seconds: ()=>({
                minimum: 0,
                // Assumption: All years have the same amount of seconds
                maximum: utils.getSeconds(endOfDay)
            }),
        meridiem: ()=>({
                minimum: 0,
                maximum: 0
            })
    };
};
let $5a21afc6f4ba9c13$var$warnedOnceInvalidSection = false;
const $5a21afc6f4ba9c13$export$ef6fbc09372bd65c = (sections, valueType)=>{};
const $5a21afc6f4ba9c13$var$transferDateSectionValue = (utils, timezone, section, dateToTransferFrom, dateToTransferTo)=>{
    switch(section.type){
        case 'year':
            return utils.setYear(dateToTransferTo, utils.getYear(dateToTransferFrom));
        case 'month':
            return utils.setMonth(dateToTransferTo, utils.getMonth(dateToTransferFrom));
        case 'weekDay':
            {
                const formattedDaysInWeek = $5a21afc6f4ba9c13$export$c65c7173f879039f(utils, timezone, section.format);
                const dayInWeekStrOfActiveDate = utils.formatByString(dateToTransferFrom, section.format);
                const dayInWeekOfActiveDate = formattedDaysInWeek.indexOf(dayInWeekStrOfActiveDate);
                const dayInWeekOfNewSectionValue = formattedDaysInWeek.indexOf(section.value);
                const diff = dayInWeekOfNewSectionValue - dayInWeekOfActiveDate;
                return utils.addDays(dateToTransferFrom, diff);
            }
        case 'day':
            return utils.setDate(dateToTransferTo, utils.getDate(dateToTransferFrom));
        case 'meridiem':
            {
                const isAM = utils.getHours(dateToTransferFrom) < 12;
                const mergedDateHours = utils.getHours(dateToTransferTo);
                if (isAM && mergedDateHours >= 12) return utils.addHours(dateToTransferTo, -12);
                if (!isAM && mergedDateHours < 12) return utils.addHours(dateToTransferTo, 12);
                return dateToTransferTo;
            }
        case 'hours':
            return utils.setHours(dateToTransferTo, utils.getHours(dateToTransferFrom));
        case 'minutes':
            return utils.setMinutes(dateToTransferTo, utils.getMinutes(dateToTransferFrom));
        case 'seconds':
            return utils.setSeconds(dateToTransferTo, utils.getSeconds(dateToTransferFrom));
        default:
            return dateToTransferTo;
    }
};
const $5a21afc6f4ba9c13$var$reliableSectionModificationOrder = {
    year: 1,
    month: 2,
    day: 3,
    weekDay: 4,
    hours: 5,
    minutes: 6,
    seconds: 7,
    meridiem: 8
};
const $5a21afc6f4ba9c13$export$6c6df982c77f60a9 = (utils, timezone, dateToTransferFrom, sections, referenceDate, shouldLimitToEditedSections)=>// cloning sections before sort to avoid mutating it
    [
        ...sections
    ].sort((a, b)=>$5a21afc6f4ba9c13$var$reliableSectionModificationOrder[a.type] - $5a21afc6f4ba9c13$var$reliableSectionModificationOrder[b.type]).reduce((mergedDate, section)=>{
        if (!shouldLimitToEditedSections || section.modified) return $5a21afc6f4ba9c13$var$transferDateSectionValue(utils, timezone, section, dateToTransferFrom, mergedDate);
        return mergedDate;
    }, referenceDate);
const $5a21afc6f4ba9c13$export$a11b0059900ceec8 = ()=>navigator.userAgent.toLowerCase().indexOf('android') > -1;
const $5a21afc6f4ba9c13$export$7725fd6fe0a2aadf = (sections, isRTL)=>{
    const neighbors = {};
    if (!isRTL) {
        sections.forEach((_, index)=>{
            const leftIndex = index === 0 ? null : index - 1;
            const rightIndex = index === sections.length - 1 ? null : index + 1;
            neighbors[index] = {
                leftIndex: leftIndex,
                rightIndex: rightIndex
            };
        });
        return {
            neighbors: neighbors,
            startIndex: 0,
            endIndex: sections.length - 1
        };
    }
    const rtl2ltr = {};
    const ltr2rtl = {};
    let groupedSectionsStart = 0;
    let groupedSectionsEnd = 0;
    let RTLIndex = sections.length - 1;
    while(RTLIndex >= 0){
        groupedSectionsEnd = sections.findIndex(// eslint-disable-next-line @typescript-eslint/no-loop-func
        (section, index)=>{
            var _section$endSeparator;
            return index >= groupedSectionsStart && ((_section$endSeparator = section.endSeparator) == null ? void 0 : _section$endSeparator.includes(' ')) && // Special case where the spaces were not there in the initial input
            section.endSeparator !== ' / ';
        });
        if (groupedSectionsEnd === -1) groupedSectionsEnd = sections.length - 1;
        for(let i = groupedSectionsEnd; i >= groupedSectionsStart; i -= 1){
            ltr2rtl[i] = RTLIndex;
            rtl2ltr[RTLIndex] = i;
            RTLIndex -= 1;
        }
        groupedSectionsStart = groupedSectionsEnd + 1;
    }
    sections.forEach((_, index)=>{
        const rtlIndex = ltr2rtl[index];
        const leftIndex = rtlIndex === 0 ? null : rtl2ltr[rtlIndex - 1];
        const rightIndex = rtlIndex === sections.length - 1 ? null : rtl2ltr[rtlIndex + 1];
        neighbors[index] = {
            leftIndex: leftIndex,
            rightIndex: rightIndex
        };
    });
    return {
        neighbors: neighbors,
        startIndex: rtl2ltr[0],
        endIndex: rtl2ltr[sections.length - 1]
    };
};


const $15cde65cbd91c944$var$_excluded = [
    "value",
    "referenceDate"
];
const $15cde65cbd91c944$export$2764b246aa3b75ba = {
    emptyValue: null,
    getTodayValue: (0, $00e6d022b450825d$export$1118e4272ea1e258),
    getInitialReferenceValue: (_ref)=>{
        let { value: value, referenceDate: referenceDate } = _ref, params = (0, $cTAWX.default)(_ref, $15cde65cbd91c944$var$_excluded);
        if (value != null && params.utils.isValid(value)) return value;
        if (referenceDate != null) return referenceDate;
        return (0, $d8b7b2aeaa0755b4$export$6a31d56794238e4e)(params);
    },
    cleanValue: (0, $00e6d022b450825d$export$36ca889e039badd5),
    areValuesEqual: (0, $00e6d022b450825d$export$8fabf9a4cbada414),
    isSameError: (a, b)=>a === b,
    hasError: (error)=>error != null,
    defaultErrorState: null,
    getTimezone: (utils, value)=>value == null || !utils.isValid(value) ? null : utils.getTimezone(value),
    setTimezone: (utils, timezone, value)=>value == null ? null : utils.setTimezone(value, timezone)
};
const $15cde65cbd91c944$export$b602c94f557316b4 = {
    updateReferenceValue: (utils, value, prevReferenceValue)=>value == null || !utils.isValid(value) ? prevReferenceValue : value,
    getSectionsFromValue: (utils, date, prevSections, isRTL, getSectionsFromDate)=>{
        const shouldReUsePrevDateSections = !utils.isValid(date) && !!prevSections;
        if (shouldReUsePrevDateSections) return prevSections;
        return (0, $5a21afc6f4ba9c13$export$8bb5d1c9951d10ca)(getSectionsFromDate(date), isRTL);
    },
    getValueStrFromSections: (0, $5a21afc6f4ba9c13$export$e990c4332a617e3d),
    getActiveDateManager: (utils, state)=>({
            date: state.value,
            referenceDate: state.referenceValue,
            getSections: (sections)=>sections,
            getNewValuesFromNewActiveDate: (newActiveDate)=>({
                    value: newActiveDate,
                    referenceValue: newActiveDate == null || !utils.isValid(newActiveDate) ? state.referenceValue : newActiveDate
                })
        }),
    parseValueStr: (valueStr, referenceValue, parseDate)=>parseDate(valueStr.trim(), referenceValue)
};



var $3VnFq = parcelRequire("3VnFq");

var $gJYWc = parcelRequire("gJYWc");


var $3VnFq = parcelRequire("3VnFq");

var $gJYWc = parcelRequire("gJYWc");


var $3VnFq = parcelRequire("3VnFq");
const $b968d9420c19b0b5$export$67c96d35a1b010b3 = (pickersTranslations)=>{
    return {
        components: {
            MuiLocalizationProvider: {
                defaultProps: {
                    localeText: (0, $3VnFq.default)({}, pickersTranslations)
                }
            }
        }
    };
};


// This object is not Partial<PickersLocaleText> because it is the default values
const $4b59d265875902da$var$enUSPickers = {
    // Calendar navigation
    previousMonth: 'Previous month',
    nextMonth: 'Next month',
    // View navigation
    openPreviousView: 'open previous view',
    openNextView: 'open next view',
    calendarViewSwitchingButtonAriaLabel: (view)=>view === 'year' ? 'year view is open, switch to calendar view' : 'calendar view is open, switch to year view',
    // DateRange placeholders
    start: 'Start',
    end: 'End',
    // Action bar
    cancelButtonLabel: 'Cancel',
    clearButtonLabel: 'Clear',
    okButtonLabel: 'OK',
    todayButtonLabel: 'Today',
    // Toolbar titles
    datePickerToolbarTitle: 'Select date',
    dateTimePickerToolbarTitle: 'Select date & time',
    timePickerToolbarTitle: 'Select time',
    dateRangePickerToolbarTitle: 'Select date range',
    // Clock labels
    clockLabelText: (view, time, adapter)=>`Select ${view}. ${time === null ? 'No time selected' : `Selected time is ${adapter.format(time, 'fullTime')}`}`,
    hoursClockNumberText: (hours)=>`${hours} hours`,
    minutesClockNumberText: (minutes)=>`${minutes} minutes`,
    secondsClockNumberText: (seconds)=>`${seconds} seconds`,
    // Digital clock labels
    selectViewText: (view)=>`Select ${view}`,
    // Calendar labels
    calendarWeekNumberHeaderLabel: 'Week number',
    calendarWeekNumberHeaderText: '#',
    calendarWeekNumberAriaLabelText: (weekNumber)=>`Week ${weekNumber}`,
    calendarWeekNumberText: (weekNumber)=>`${weekNumber}`,
    // Open picker labels
    openDatePickerDialogue: (value, utils)=>value !== null && utils.isValid(value) ? `Choose date, selected date is ${utils.format(value, 'fullDate')}` : 'Choose date',
    openTimePickerDialogue: (value, utils)=>value !== null && utils.isValid(value) ? `Choose time, selected time is ${utils.format(value, 'fullTime')}` : 'Choose time',
    fieldClearLabel: 'Clear value',
    // Table labels
    timeTableLabel: 'pick time',
    dateTableLabel: 'pick date',
    // Field section placeholders
    fieldYearPlaceholder: (params)=>'Y'.repeat(params.digitAmount),
    fieldMonthPlaceholder: (params)=>params.contentType === 'letter' ? 'MMMM' : 'MM',
    fieldDayPlaceholder: ()=>'DD',
    fieldWeekDayPlaceholder: (params)=>params.contentType === 'letter' ? 'EEEE' : 'EE',
    fieldHoursPlaceholder: ()=>'hh',
    fieldMinutesPlaceholder: ()=>'mm',
    fieldSecondsPlaceholder: ()=>'ss',
    fieldMeridiemPlaceholder: ()=>'aa'
};
const $4b59d265875902da$export$1af4c7e47ad72f44 = $4b59d265875902da$var$enUSPickers;
const $4b59d265875902da$export$137380d9ce54f7f = (0, $b968d9420c19b0b5$export$67c96d35a1b010b3)($4b59d265875902da$var$enUSPickers);


const $98220f21a8625472$export$4b5a24245de9f7f9 = ()=>{
    const localization = $gJYWc.useContext((0, $38b9c61d570d1b88$export$544976378534cf9));
    if (localization === null) throw new Error([
        'MUI: Can not find the date and time pickers localization context.',
        'It looks like you forgot to wrap your component in LocalizationProvider.',
        'This can also happen if you are bundling multiple versions of the `@mui/x-date-pickers` package'
    ].join('\n'));
    if (localization.utils === null) throw new Error([
        'MUI: Can not find the date and time pickers adapter from its localization context.',
        'It looks like you forgot to pass a `dateAdapter` to your LocalizationProvider.'
    ].join('\n'));
    const localeText = $gJYWc.useMemo(()=>(0, $3VnFq.default)({}, (0, $4b59d265875902da$export$1af4c7e47ad72f44), localization.localeText), [
        localization.localeText
    ]);
    return $gJYWc.useMemo(()=>(0, $3VnFq.default)({}, localization, {
            localeText: localeText
        }), [
        localization,
        localeText
    ]);
};
const $98220f21a8625472$export$1163b47e39508a46 = ()=>$98220f21a8625472$export$4b5a24245de9f7f9().utils;
const $98220f21a8625472$export$7c38da3a2e90fa83 = ()=>$98220f21a8625472$export$4b5a24245de9f7f9().defaultDates;
const $98220f21a8625472$export$24fdeaa0f591a73e = ()=>$98220f21a8625472$export$4b5a24245de9f7f9().localeText;
const $98220f21a8625472$export$3a404aece3dff2fa = (timezone)=>{
    const utils = $98220f21a8625472$export$1163b47e39508a46();
    const now = $gJYWc.useRef();
    if (now.current === undefined) now.current = utils.dateWithTimezone(undefined, timezone);
    return now.current;
};





var $cTAWX = parcelRequire("cTAWX");

var $3VnFq = parcelRequire("3VnFq");

var $gJYWc = parcelRequire("gJYWc");

var $2w6IV = parcelRequire("2w6IV");



var $HGmne = parcelRequire("HGmne");

var $3e4LV = parcelRequire("3e4LV");

var $3VnFq = parcelRequire("3VnFq");

var $gJYWc = parcelRequire("gJYWc");

var $2w6IV = parcelRequire("2w6IV");


var $HGmne = parcelRequire("HGmne");

var $3e4LV = parcelRequire("3e4LV");

var $1kRHf = parcelRequire("1kRHf");
var $i8nzj = parcelRequire("i8nzj");
function $21ec14a9fd047156$export$b109c489973c3d80(slot) {
    return (0, $1kRHf.default)('MuiPickersToolbar', slot);
}
const $21ec14a9fd047156$export$59f09e5e2b3d9913 = (0, $i8nzj.default)('MuiPickersToolbar', [
    'root',
    'content'
]);



var $9wx12 = parcelRequire("9wx12");
const $a88992c4502f3019$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, isLandscape: isLandscape } = ownerState;
    const slots = {
        root: [
            'root'
        ],
        content: [
            'content'
        ],
        penIconButton: [
            'penIconButton',
            isLandscape && 'penIconButtonLandscape'
        ]
    };
    return (0, $3e4LV.default)(slots, (0, $21ec14a9fd047156$export$b109c489973c3d80), classes);
};
const $a88992c4502f3019$var$PickersToolbarRoot = (0, $HGmne.default)('div', {
    name: 'MuiPickersToolbar',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})(({ theme: theme, ownerState: ownerState })=>(0, $3VnFq.default)({
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        justifyContent: 'space-between',
        padding: theme.spacing(2, 3)
    }, ownerState.isLandscape && {
        height: 'auto',
        maxWidth: 160,
        padding: 16,
        justifyContent: 'flex-start',
        flexWrap: 'wrap'
    }));
const $a88992c4502f3019$var$PickersToolbarContent = (0, $HGmne.default)('div', {
    name: 'MuiPickersToolbar',
    slot: 'Content',
    overridesResolver: (props, styles)=>styles.content
})(({ ownerState: ownerState })=>{
    var _ownerState$landscape;
    return {
        display: 'flex',
        flexWrap: 'wrap',
        width: '100%',
        justifyContent: ownerState.isLandscape ? 'flex-start' : 'space-between',
        flexDirection: ownerState.isLandscape ? (_ownerState$landscape = ownerState.landscapeDirection) != null ? _ownerState$landscape : 'column' : 'row',
        flex: 1,
        alignItems: ownerState.isLandscape ? 'flex-start' : 'center'
    };
});
const $a88992c4502f3019$export$eb3c4d84783d6feb = /*#__PURE__*/ $gJYWc.forwardRef(function PickersToolbar(inProps, ref) {
    const props = (0, $6959428021af84ce$export$2e2bcd8739ae039)({
        props: inProps,
        name: 'MuiPickersToolbar'
    });
    const { children: children, className: className, toolbarTitle: toolbarTitle, hidden: hidden, titleId: titleId } = props;
    const ownerState = props;
    const classes = $a88992c4502f3019$var$useUtilityClasses(ownerState);
    if (hidden) return null;
    return /*#__PURE__*/ (0, $9wx12.jsxs)($a88992c4502f3019$var$PickersToolbarRoot, {
        ref: ref,
        className: (0, $2w6IV.default)(classes.root, className),
        ownerState: ownerState,
        children: [
            /*#__PURE__*/ (0, $9wx12.jsx)((0, $b4083ea3a052dee9$export$2e2bcd8739ae039), {
                color: "text.secondary",
                variant: "overline",
                id: titleId,
                children: toolbarTitle
            }),
            /*#__PURE__*/ (0, $9wx12.jsx)($a88992c4502f3019$var$PickersToolbarContent, {
                className: classes.content,
                ownerState: ownerState,
                children: children
            })
        ]
    });
});




var $1kRHf = parcelRequire("1kRHf");
var $i8nzj = parcelRequire("i8nzj");
function $041963ddd9c514a7$export$a1c3879af2c3b694(slot) {
    return (0, $1kRHf.default)('MuiDatePickerToolbar', slot);
}
const $041963ddd9c514a7$export$2e35fa7d24ef4179 = (0, $i8nzj.default)('MuiDatePickerToolbar', [
    'root',
    'title'
]);




var $9wx12 = parcelRequire("9wx12");
const $9acd47986a2e591d$var$_excluded = [
    "value",
    "isLandscape",
    "onChange",
    "toolbarFormat",
    "toolbarPlaceholder",
    "views",
    "className"
];
const $9acd47986a2e591d$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ],
        title: [
            'title'
        ]
    };
    return (0, $3e4LV.default)(slots, (0, $041963ddd9c514a7$export$a1c3879af2c3b694), classes);
};
const $9acd47986a2e591d$var$DatePickerToolbarRoot = (0, $HGmne.default)((0, $a88992c4502f3019$export$eb3c4d84783d6feb), {
    name: 'MuiDatePickerToolbar',
    slot: 'Root',
    overridesResolver: (_, styles)=>styles.root
})({});
const $9acd47986a2e591d$var$DatePickerToolbarTitle = (0, $HGmne.default)((0, $b4083ea3a052dee9$export$2e2bcd8739ae039), {
    name: 'MuiDatePickerToolbar',
    slot: 'Title',
    overridesResolver: (_, styles)=>styles.title
})(({ ownerState: ownerState })=>(0, $3VnFq.default)({}, ownerState.isLandscape && {
        margin: 'auto 16px auto auto'
    }));
const $9acd47986a2e591d$export$21b7f8ea763109eb = /*#__PURE__*/ $gJYWc.forwardRef(function DatePickerToolbar(inProps, ref) {
    const props = (0, $6959428021af84ce$export$2e2bcd8739ae039)({
        props: inProps,
        name: 'MuiDatePickerToolbar'
    });
    const { value: value, isLandscape: isLandscape, toolbarFormat: toolbarFormat, toolbarPlaceholder: toolbarPlaceholder = "\u2013\u2013", views: views, className: className } = props, other = (0, $cTAWX.default)(props, $9acd47986a2e591d$var$_excluded);
    const utils = (0, $98220f21a8625472$export$1163b47e39508a46)();
    const localeText = (0, $98220f21a8625472$export$24fdeaa0f591a73e)();
    const classes = $9acd47986a2e591d$var$useUtilityClasses(props);
    const dateText = $gJYWc.useMemo(()=>{
        if (!value) return toolbarPlaceholder;
        const formatFromViews = (0, $00e6d022b450825d$export$bb1c921f313ec928)(utils, {
            format: toolbarFormat,
            views: views
        }, true);
        return utils.formatByString(value, formatFromViews);
    }, [
        value,
        toolbarFormat,
        toolbarPlaceholder,
        utils,
        views
    ]);
    const ownerState = props;
    return /*#__PURE__*/ (0, $9wx12.jsx)($9acd47986a2e591d$var$DatePickerToolbarRoot, (0, $3VnFq.default)({
        ref: ref,
        toolbarTitle: localeText.datePickerToolbarTitle,
        isLandscape: isLandscape,
        className: (0, $2w6IV.default)(classes.root, className)
    }, other, {
        children: /*#__PURE__*/ (0, $9wx12.jsx)($9acd47986a2e591d$var$DatePickerToolbarTitle, {
            variant: "h4",
            align: isLandscape ? 'left' : 'center',
            ownerState: ownerState,
            className: classes.title,
            children: dateText
        })
    }));
});



var $3VnFq = parcelRequire("3VnFq");
const $d1cac1848baa1211$export$ee17bc394843b249 = (capitalizedObject)=>{
    if (capitalizedObject === undefined) return undefined;
    return Object.keys(capitalizedObject).reduce((acc, key)=>(0, $3VnFq.default)({}, acc, {
            [`${key.slice(0, 1).toLowerCase()}${key.slice(1)}`]: capitalizedObject[key]
        }), {});
};


function $3774dc0cfe958d2e$export$a552c17ed3587731(props, name) {
    var _themeProps$slots, _themeProps$disableFu, _themeProps$disablePa, _themeProps$slotProps;
    const utils = (0, $98220f21a8625472$export$1163b47e39508a46)();
    const defaultDates = (0, $98220f21a8625472$export$7c38da3a2e90fa83)();
    const themeProps = (0, $6959428021af84ce$export$2e2bcd8739ae039)({
        props: props,
        name: name
    });
    const localeText = $gJYWc.useMemo(()=>{
        var _themeProps$localeTex;
        if (((_themeProps$localeTex = themeProps.localeText) == null ? void 0 : _themeProps$localeTex.toolbarTitle) == null) return themeProps.localeText;
        return (0, $3VnFq.default)({}, themeProps.localeText, {
            datePickerToolbarTitle: themeProps.localeText.toolbarTitle
        });
    }, [
        themeProps.localeText
    ]);
    const slots = (_themeProps$slots = themeProps.slots) != null ? _themeProps$slots : (0, $d1cac1848baa1211$export$ee17bc394843b249)(themeProps.components);
    return (0, $3VnFq.default)({}, themeProps, {
        localeText: localeText
    }, (0, $fd452c2a61e4326f$export$bdf8d867ddc968e)({
        views: themeProps.views,
        openTo: themeProps.openTo,
        defaultViews: [
            'year',
            'day'
        ],
        defaultOpenTo: 'day'
    }), {
        disableFuture: (_themeProps$disableFu = themeProps.disableFuture) != null ? _themeProps$disableFu : false,
        disablePast: (_themeProps$disablePa = themeProps.disablePast) != null ? _themeProps$disablePa : false,
        minDate: (0, $00e6d022b450825d$export$eb73579ccade48fd)(utils, themeProps.minDate, defaultDates.minDate),
        maxDate: (0, $00e6d022b450825d$export$eb73579ccade48fd)(utils, themeProps.maxDate, defaultDates.maxDate),
        slots: (0, $3VnFq.default)({
            toolbar: (0, $9acd47986a2e591d$export$21b7f8ea763109eb)
        }, slots),
        slotProps: (_themeProps$slotProps = themeProps.slotProps) != null ? _themeProps$slotProps : themeProps.componentsProps
    });
}



const $857e489bb4dc7e4f$export$ffb3d0046ef3a2 = ({ props: props, value: value, adapter: adapter })=>{
    if (value === null) return null;
    const { shouldDisableDate: shouldDisableDate, shouldDisableMonth: shouldDisableMonth, shouldDisableYear: shouldDisableYear, disablePast: disablePast, disableFuture: disableFuture, timezone: timezone } = props;
    const now = adapter.utils.dateWithTimezone(undefined, timezone);
    const minDate = (0, $00e6d022b450825d$export$eb73579ccade48fd)(adapter.utils, props.minDate, adapter.defaultDates.minDate);
    const maxDate = (0, $00e6d022b450825d$export$eb73579ccade48fd)(adapter.utils, props.maxDate, adapter.defaultDates.maxDate);
    switch(true){
        case !adapter.utils.isValid(value):
            return 'invalidDate';
        case Boolean(shouldDisableDate && shouldDisableDate(value)):
            return 'shouldDisableDate';
        case Boolean(shouldDisableMonth && shouldDisableMonth(value)):
            return 'shouldDisableMonth';
        case Boolean(shouldDisableYear && shouldDisableYear(value)):
            return 'shouldDisableYear';
        case Boolean(disableFuture && adapter.utils.isAfterDay(value, now)):
            return 'disableFuture';
        case Boolean(disablePast && adapter.utils.isBeforeDay(value, now)):
            return 'disablePast';
        case Boolean(minDate && adapter.utils.isBeforeDay(value, minDate)):
            return 'minDate';
        case Boolean(maxDate && adapter.utils.isAfterDay(value, maxDate)):
            return 'maxDate';
        default:
            return null;
    }
};



var $3VnFq = parcelRequire("3VnFq");

var $cTAWX = parcelRequire("cTAWX");

var $gJYWc = parcelRequire("gJYWc");

var $gJYWc = parcelRequire("gJYWc");
/**
 * TODO v5: consider making it private
 *
 * passes {value} to {ref}
 *
 * WARNING: Be sure to only call this inside a callback that is passed as a ref.
 * Otherwise, make sure to cleanup the previous {ref} if it changes. See
 * https://github.com/mui/material-ui/issues/13539
 *
 * Useful if you want to expose the ref of an inner component to the public API
 * while still using it inside the component.
 * @param ref A ref callback or ref object. If anything falsy, this is a no-op.
 */ function $dc06a65ffd6ec52f$export$2e2bcd8739ae039(ref, value) {
    if (typeof ref === 'function') ref(value);
    else if (ref) ref.current = value;
}


'use client';
function $8e672f0939e39396$export$2e2bcd8739ae039(...refs) {
    /**
   * This will create a new function if the refs passed to this hook change and are all defined.
   * This means react will call the old forkRef with `null` and the new forkRef
   * with the ref. Cleanup naturally emerges from this behavior.
   */ return $gJYWc.useMemo(()=>{
        if (refs.every((ref)=>ref == null)) return null;
        return (instance)=>{
            refs.forEach((ref)=>{
                (0, $dc06a65ffd6ec52f$export$2e2bcd8739ae039)(ref, instance);
            });
        };
    // TODO: uncomment once we enable eslint-plugin-react-compiler // eslint-disable-next-line react-compiler/react-compiler -- intentionally ignoring that the dependency array must be an array literal
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, refs);
}


/**
 * Determines if a given element is a DOM element name (i.e. not a React component).
 */ function $2ab927394cb41878$var$isHostComponent(element) {
    return typeof element === 'string';
}
var $2ab927394cb41878$export$2e2bcd8739ae039 = $2ab927394cb41878$var$isHostComponent;


/**
 * Type of the ownerState based on the type of an element it applies to.
 * This resolves to the provided OwnerState for React components and `undefined` for host components.
 * Falls back to `OwnerState | undefined` when the exact type can't be determined in development time.
 */ /**
 * Appends the ownerState object to the props, merging with the existing one if necessary.
 *
 * @param elementType Type of the element that owns the `existingProps`. If the element is a DOM node or undefined, `ownerState` is not applied.
 * @param otherProps Props of the element.
 * @param ownerState
 */ function $f3ad141c045f0207$var$appendOwnerState(elementType, otherProps, ownerState) {
    if (elementType === undefined || (0, $2ab927394cb41878$export$2e2bcd8739ae039)(elementType)) return otherProps;
    return {
        ...otherProps,
        ownerState: {
            ...otherProps.ownerState,
            ...ownerState
        }
    };
}
var $f3ad141c045f0207$export$2e2bcd8739ae039 = $f3ad141c045f0207$var$appendOwnerState;



var $2w6IV = parcelRequire("2w6IV");
/**
 * Extracts event handlers from a given object.
 * A prop is considered an event handler if it is a function and its name starts with `on`.
 *
 * @param object An object to extract event handlers from.
 * @param excludeKeys An array of keys to exclude from the returned object.
 */ function $fd3fc9449ab767b5$var$extractEventHandlers(object, excludeKeys = []) {
    if (object === undefined) return {};
    const result = {};
    Object.keys(object).filter((prop)=>prop.match(/^on[A-Z]/) && typeof object[prop] === 'function' && !excludeKeys.includes(prop)).forEach((prop)=>{
        result[prop] = object[prop];
    });
    return result;
}
var $fd3fc9449ab767b5$export$2e2bcd8739ae039 = $fd3fc9449ab767b5$var$extractEventHandlers;


/**
 * Removes event handlers from the given object.
 * A field is considered an event handler if it is a function with a name beginning with `on`.
 *
 * @param object Object to remove event handlers from.
 * @returns Object with event handlers removed.
 */ function $547f7f36f202f449$var$omitEventHandlers(object) {
    if (object === undefined) return {};
    const result = {};
    Object.keys(object).filter((prop)=>!(prop.match(/^on[A-Z]/) && typeof object[prop] === 'function')).forEach((prop)=>{
        result[prop] = object[prop];
    });
    return result;
}
var $547f7f36f202f449$export$2e2bcd8739ae039 = $547f7f36f202f449$var$omitEventHandlers;


/**
 * Merges the slot component internal props (usually coming from a hook)
 * with the externally provided ones.
 *
 * The merge order is (the latter overrides the former):
 * 1. The internal props (specified as a getter function to work with get*Props hook result)
 * 2. Additional props (specified internally on a Base UI component)
 * 3. External props specified on the owner component. These should only be used on a root slot.
 * 4. External props specified in the `slotProps.*` prop.
 * 5. The `className` prop - combined from all the above.
 * @param parameters
 * @returns
 */ function $e7c584ea49475582$var$mergeSlotProps(parameters) {
    const { getSlotProps: getSlotProps, additionalProps: additionalProps, externalSlotProps: externalSlotProps, externalForwardedProps: externalForwardedProps, className: className } = parameters;
    if (!getSlotProps) {
        // The simpler case - getSlotProps is not defined, so no internal event handlers are defined,
        // so we can simply merge all the props without having to worry about extracting event handlers.
        const joinedClasses = (0, $2w6IV.default)(additionalProps?.className, className, externalForwardedProps?.className, externalSlotProps?.className);
        const mergedStyle = {
            ...additionalProps?.style,
            ...externalForwardedProps?.style,
            ...externalSlotProps?.style
        };
        const props = {
            ...additionalProps,
            ...externalForwardedProps,
            ...externalSlotProps
        };
        if (joinedClasses.length > 0) props.className = joinedClasses;
        if (Object.keys(mergedStyle).length > 0) props.style = mergedStyle;
        return {
            props: props,
            internalRef: undefined
        };
    }
    // In this case, getSlotProps is responsible for calling the external event handlers.
    // We don't need to include them in the merged props because of this.
    const eventHandlers = (0, $fd3fc9449ab767b5$export$2e2bcd8739ae039)({
        ...externalForwardedProps,
        ...externalSlotProps
    });
    const componentsPropsWithoutEventHandlers = (0, $547f7f36f202f449$export$2e2bcd8739ae039)(externalSlotProps);
    const otherPropsWithoutEventHandlers = (0, $547f7f36f202f449$export$2e2bcd8739ae039)(externalForwardedProps);
    const internalSlotProps = getSlotProps(eventHandlers);
    // The order of classes is important here.
    // Emotion (that we use in libraries consuming Base UI) depends on this order
    // to properly override style. It requires the most important classes to be last
    // (see https://github.com/mui/material-ui/pull/33205) for the related discussion.
    const joinedClasses = (0, $2w6IV.default)(internalSlotProps?.className, additionalProps?.className, className, externalForwardedProps?.className, externalSlotProps?.className);
    const mergedStyle = {
        ...internalSlotProps?.style,
        ...additionalProps?.style,
        ...externalForwardedProps?.style,
        ...externalSlotProps?.style
    };
    const props = {
        ...internalSlotProps,
        ...additionalProps,
        ...otherPropsWithoutEventHandlers,
        ...componentsPropsWithoutEventHandlers
    };
    if (joinedClasses.length > 0) props.className = joinedClasses;
    if (Object.keys(mergedStyle).length > 0) props.style = mergedStyle;
    return {
        props: props,
        internalRef: internalSlotProps.ref
    };
}
var $e7c584ea49475582$export$2e2bcd8739ae039 = $e7c584ea49475582$var$mergeSlotProps;


/**
 * If `componentProps` is a function, calls it with the provided `ownerState`.
 * Otherwise, just returns `componentProps`.
 */ function $3d6c66a6cf46f4af$var$resolveComponentProps(componentProps, ownerState, slotState) {
    if (typeof componentProps === 'function') return componentProps(ownerState, slotState);
    return componentProps;
}
var $3d6c66a6cf46f4af$export$2e2bcd8739ae039 = $3d6c66a6cf46f4af$var$resolveComponentProps;


'use client';
/**
 * @ignore - do not document.
 * Builds the props to be passed into the slot of an unstyled component.
 * It merges the internal props of the component with the ones supplied by the user, allowing to customize the behavior.
 * If the slot component is not a host component, it also merges in the `ownerState`.
 *
 * @param parameters.getSlotProps - A function that returns the props to be passed to the slot component.
 */ function $2082854bb194ebf1$var$useSlotProps(parameters) {
    const { elementType: elementType, externalSlotProps: externalSlotProps, ownerState: ownerState, skipResolvingSlotProps: skipResolvingSlotProps = false, ...other } = parameters;
    const resolvedComponentsProps = skipResolvingSlotProps ? {} : (0, $3d6c66a6cf46f4af$export$2e2bcd8739ae039)(externalSlotProps, ownerState);
    const { props: mergedProps, internalRef: internalRef } = (0, $e7c584ea49475582$export$2e2bcd8739ae039)({
        ...other,
        externalSlotProps: resolvedComponentsProps
    });
    const ref = (0, $8e672f0939e39396$export$2e2bcd8739ae039)(internalRef, resolvedComponentsProps?.ref, parameters.additionalProps?.ref);
    const props = (0, $f3ad141c045f0207$export$2e2bcd8739ae039)(elementType, {
        ...mergedProps,
        ref: ref
    }, ownerState);
    return props;
}
var $2082854bb194ebf1$export$2e2bcd8739ae039 = $2082854bb194ebf1$var$useSlotProps;



var $cTAWX = parcelRequire("cTAWX");

var $3VnFq = parcelRequire("3VnFq");

var $gJYWc = parcelRequire("gJYWc");


var $2w6IV = parcelRequire("2w6IV");

var $3e4LV = parcelRequire("3e4LV");

var $cVrVk = parcelRequire("cVrVk");




var $HGmne = parcelRequire("HGmne");

var $i8nzj = parcelRequire("i8nzj");

var $1kRHf = parcelRequire("1kRHf");
function $2861cb2c0c714f8e$export$4b135a4b3a6c4550(slot) {
    return (0, $1kRHf.default)('MuiInputAdornment', slot);
}
const $2861cb2c0c714f8e$var$inputAdornmentClasses = (0, $i8nzj.default)('MuiInputAdornment', [
    'root',
    'filled',
    'standard',
    'outlined',
    'positionStart',
    'positionEnd',
    'disablePointerEvents',
    'hiddenLabel',
    'sizeSmall'
]);
var $2861cb2c0c714f8e$export$2e2bcd8739ae039 = $2861cb2c0c714f8e$var$inputAdornmentClasses;



var $8pLcn = parcelRequire("8pLcn");

var $9wx12 = parcelRequire("9wx12");
'use client';
var $aee6aba0933a8c2f$var$_span;
const $aee6aba0933a8c2f$var$_excluded = [
    "children",
    "className",
    "component",
    "disablePointerEvents",
    "disableTypography",
    "position",
    "variant"
];
const $aee6aba0933a8c2f$var$overridesResolver = (props, styles)=>{
    const { ownerState: ownerState } = props;
    return [
        styles.root,
        styles[`position${(0, $cVrVk.default)(ownerState.position)}`],
        ownerState.disablePointerEvents === true && styles.disablePointerEvents,
        styles[ownerState.variant]
    ];
};
const $aee6aba0933a8c2f$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disablePointerEvents: disablePointerEvents, hiddenLabel: hiddenLabel, position: position, size: size, variant: variant } = ownerState;
    const slots = {
        root: [
            'root',
            disablePointerEvents && 'disablePointerEvents',
            position && `position${(0, $cVrVk.default)(position)}`,
            variant,
            hiddenLabel && 'hiddenLabel',
            size && `size${(0, $cVrVk.default)(size)}`
        ]
    };
    return (0, $3e4LV.default)(slots, (0, $2861cb2c0c714f8e$export$4b135a4b3a6c4550), classes);
};
const $aee6aba0933a8c2f$var$InputAdornmentRoot = (0, $HGmne.default)('div', {
    name: 'MuiInputAdornment',
    slot: 'Root',
    overridesResolver: $aee6aba0933a8c2f$var$overridesResolver
})(({ theme: theme, ownerState: ownerState })=>(0, $3VnFq.default)({
        display: 'flex',
        height: '0.01em',
        // Fix IE11 flexbox alignment. To remove at some point.
        maxHeight: '2em',
        alignItems: 'center',
        whiteSpace: 'nowrap',
        color: (theme.vars || theme).palette.action.active
    }, ownerState.variant === 'filled' && {
        // Styles applied to the root element if `variant="filled"`.
        [`&.${(0, $2861cb2c0c714f8e$export$2e2bcd8739ae039).positionStart}&:not(.${(0, $2861cb2c0c714f8e$export$2e2bcd8739ae039).hiddenLabel})`]: {
            marginTop: 16
        }
    }, ownerState.position === 'start' && {
        // Styles applied to the root element if `position="start"`.
        marginRight: 8
    }, ownerState.position === 'end' && {
        // Styles applied to the root element if `position="end"`.
        marginLeft: 8
    }, ownerState.disablePointerEvents === true && {
        // Styles applied to the root element if `disablePointerEvents={true}`.
        pointerEvents: 'none'
    }));
const $aee6aba0933a8c2f$var$InputAdornment = /*#__PURE__*/ $gJYWc.forwardRef(function InputAdornment(inProps, ref) {
    const props = (0, $8pLcn.useDefaultProps)({
        props: inProps,
        name: 'MuiInputAdornment'
    });
    const { children: children, className: className, component: component = 'div', disablePointerEvents: disablePointerEvents = false, disableTypography: disableTypography = false, position: position, variant: variantProp } = props, other = (0, $cTAWX.default)(props, $aee6aba0933a8c2f$var$_excluded);
    const muiFormControl = (0, $7d9d5024ca7b136a$export$2e2bcd8739ae039)() || {};
    let variant = variantProp;
    variantProp && muiFormControl.variant;
    if (muiFormControl && !variant) variant = muiFormControl.variant;
    const ownerState = (0, $3VnFq.default)({}, props, {
        hiddenLabel: muiFormControl.hiddenLabel,
        size: muiFormControl.size,
        disablePointerEvents: disablePointerEvents,
        position: position,
        variant: variant
    });
    const classes = $aee6aba0933a8c2f$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $9wx12.jsx)((0, $ae835169353fee9c$export$2e2bcd8739ae039).Provider, {
        value: null,
        children: /*#__PURE__*/ (0, $9wx12.jsx)($aee6aba0933a8c2f$var$InputAdornmentRoot, (0, $3VnFq.default)({
            as: component,
            ownerState: ownerState,
            className: (0, $2w6IV.default)(classes.root, className),
            ref: ref
        }, other, {
            children: typeof children === 'string' && !disableTypography ? /*#__PURE__*/ (0, $9wx12.jsx)((0, $b4083ea3a052dee9$export$2e2bcd8739ae039), {
                color: "text.secondary",
                children: children
            }) : /*#__PURE__*/ (0, $9wx12.jsxs)($gJYWc.Fragment, {
                children: [
                    position === 'start' ? /* notranslate needed while Google Translate will not fix zero-width space issue */ $aee6aba0933a8c2f$var$_span || ($aee6aba0933a8c2f$var$_span = /*#__PURE__*/ (0, $9wx12.jsx)("span", {
                        className: "notranslate",
                        children: "\u200B"
                    })) : null,
                    children
                ]
            })
        }))
    });
});
var $aee6aba0933a8c2f$export$2e2bcd8739ae039 = $aee6aba0933a8c2f$var$InputAdornment;



var $17CRd = parcelRequire("17CRd");

var $4gWBK = parcelRequire("4gWBK");

var $gJYWc = parcelRequire("gJYWc");
'use client';
let $8fee44a510de4e75$var$globalId = 0;
function $8fee44a510de4e75$var$useGlobalId(idOverride) {
    const [defaultId, setDefaultId] = $gJYWc.useState(idOverride);
    const id = idOverride || defaultId;
    $gJYWc.useEffect(()=>{
        if (defaultId == null) {
            // Fallback to this default id when possible.
            // Use the incrementing value for client-side rendering only.
            // We can't use it server-side.
            // If you want to use random values please consider the Birthday Problem: https://en.wikipedia.org/wiki/Birthday_problem
            $8fee44a510de4e75$var$globalId += 1;
            setDefaultId(`mui-${$8fee44a510de4e75$var$globalId}`);
        }
    }, [
        defaultId
    ]);
    return id;
}
// downstream bundlers may remove unnecessary concatenation, but won't remove toString call -- Workaround for https://github.com/webpack/webpack/issues/14814
const $8fee44a510de4e75$var$maybeReactUseId = $gJYWc['useId'.toString()];
function $8fee44a510de4e75$export$2e2bcd8739ae039(idOverride) {
    if ($8fee44a510de4e75$var$maybeReactUseId !== undefined) {
        const reactId = $8fee44a510de4e75$var$maybeReactUseId();
        return idOverride != null ? idOverride : reactId;
    }
    // eslint-disable-next-line react-hooks/rules-of-hooks -- `React.useId` is invariant at runtime.
    return $8fee44a510de4e75$var$useGlobalId(idOverride);
}



var $cTAWX = parcelRequire("cTAWX");

var $3VnFq = parcelRequire("3VnFq");

var $gJYWc = parcelRequire("gJYWc");





var $3VnFq = parcelRequire("3VnFq");

var $cTAWX = parcelRequire("cTAWX");
var $10eca53e8d6234ae$exports = {};
"use strict";
'use client';
Object.defineProperty($10eca53e8d6234ae$exports, "__esModule", {
    value: true
});
$10eca53e8d6234ae$exports.default = void 0;

var $10eca53e8d6234ae$var$React = $10eca53e8d6234ae$var$_interopRequireWildcard((parcelRequire("gJYWc")));
parcelRequire("d0nrV");
var $ll1Nc = parcelRequire("ll1Nc");
function $10eca53e8d6234ae$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($10eca53e8d6234ae$var$_getRequireWildcardCache = function(e) {
        return e ? t : r;
    })(e);
}
function $10eca53e8d6234ae$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        default: e
    };
    var t = $10eca53e8d6234ae$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n.default = e, t && t.set(e, n), n;
}
function $10eca53e8d6234ae$var$isObjectEmpty(obj) {
    return Object.keys(obj).length === 0;
}
function $10eca53e8d6234ae$var$useTheme(defaultTheme = null) {
    const contextTheme = $10eca53e8d6234ae$var$React.useContext($ll1Nc.T);
    return !contextTheme || $10eca53e8d6234ae$var$isObjectEmpty(contextTheme) ? defaultTheme : contextTheme;
}
var $10eca53e8d6234ae$var$_default = $10eca53e8d6234ae$exports.default = $10eca53e8d6234ae$var$useTheme;






var $gJYWc = parcelRequire("gJYWc");

var $3VnFq = parcelRequire("3VnFq");

var $cTAWX = parcelRequire("cTAWX");

var $gJYWc = parcelRequire("gJYWc");

var $4z2O6 = parcelRequire("4z2O6");
var $4gWBK = parcelRequire("4gWBK");
function $51822b2d1b9ce85d$export$2e2bcd8739ae039(node) {
    if (node == null) return window;
    if (node.toString() !== '[object Window]') {
        var ownerDocument = node.ownerDocument;
        return ownerDocument ? ownerDocument.defaultView || window : window;
    }
    return node;
}


function $f6d32abb4309953c$export$45a5e7f76e0caa8d(node) {
    var OwnElement = (0, $51822b2d1b9ce85d$export$2e2bcd8739ae039)(node).Element;
    return node instanceof OwnElement || node instanceof Element;
}
function $f6d32abb4309953c$export$1b3bfaa9684536aa(node) {
    var OwnElement = (0, $51822b2d1b9ce85d$export$2e2bcd8739ae039)(node).HTMLElement;
    return node instanceof OwnElement || node instanceof HTMLElement;
}
function $f6d32abb4309953c$export$af51f0f06c0f328a(node) {
    // IE 11 has no ShadowRoot
    if (typeof ShadowRoot === 'undefined') return false;
    var OwnElement = (0, $51822b2d1b9ce85d$export$2e2bcd8739ae039)(node).ShadowRoot;
    return node instanceof OwnElement || node instanceof ShadowRoot;
}


var $a648b2d87eb6107b$export$8960430cfd85939f = Math.max;
var $a648b2d87eb6107b$export$96ec731ed4dcb222 = Math.min;
var $a648b2d87eb6107b$export$2077e0241d6afd3c = Math.round;



function $c8d7fb5a5e3cbda4$export$2e2bcd8739ae039() {
    var uaData = navigator.userAgentData;
    if (uaData != null && uaData.brands && Array.isArray(uaData.brands)) return uaData.brands.map(function(item) {
        return item.brand + "/" + item.version;
    }).join(' ');
    return navigator.userAgent;
}


function $655c371d9bfb24a9$export$2e2bcd8739ae039() {
    return !/^((?!chrome|android).)*safari/i.test((0, $c8d7fb5a5e3cbda4$export$2e2bcd8739ae039)());
}


function $ee81caf1e37998e9$export$2e2bcd8739ae039(element, includeScale, isFixedStrategy) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    var clientRect = element.getBoundingClientRect();
    var scaleX = 1;
    var scaleY = 1;
    if (includeScale && (0, $f6d32abb4309953c$export$1b3bfaa9684536aa)(element)) {
        scaleX = element.offsetWidth > 0 ? (0, $a648b2d87eb6107b$export$2077e0241d6afd3c)(clientRect.width) / element.offsetWidth || 1 : 1;
        scaleY = element.offsetHeight > 0 ? (0, $a648b2d87eb6107b$export$2077e0241d6afd3c)(clientRect.height) / element.offsetHeight || 1 : 1;
    }
    var _ref = (0, $f6d32abb4309953c$export$45a5e7f76e0caa8d)(element) ? (0, $51822b2d1b9ce85d$export$2e2bcd8739ae039)(element) : window, visualViewport = _ref.visualViewport;
    var addVisualOffsets = !(0, $655c371d9bfb24a9$export$2e2bcd8739ae039)() && isFixedStrategy;
    var x = (clientRect.left + (addVisualOffsets && visualViewport ? visualViewport.offsetLeft : 0)) / scaleX;
    var y = (clientRect.top + (addVisualOffsets && visualViewport ? visualViewport.offsetTop : 0)) / scaleY;
    var width = clientRect.width / scaleX;
    var height = clientRect.height / scaleY;
    return {
        width: width,
        height: height,
        top: y,
        right: x + width,
        bottom: y + height,
        left: x,
        x: x,
        y: y
    };
}



function $21860a066a5f8348$export$2e2bcd8739ae039(node) {
    var win = (0, $51822b2d1b9ce85d$export$2e2bcd8739ae039)(node);
    var scrollLeft = win.pageXOffset;
    var scrollTop = win.pageYOffset;
    return {
        scrollLeft: scrollLeft,
        scrollTop: scrollTop
    };
}




function $f18a6954f106fec3$export$2e2bcd8739ae039(element) {
    return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
}


function $3ef01fce428e42ca$export$2e2bcd8739ae039(node) {
    if (node === (0, $51822b2d1b9ce85d$export$2e2bcd8739ae039)(node) || !(0, $f6d32abb4309953c$export$1b3bfaa9684536aa)(node)) return (0, $21860a066a5f8348$export$2e2bcd8739ae039)(node);
    else return (0, $f18a6954f106fec3$export$2e2bcd8739ae039)(node);
}


function $0b191fc852445ef6$export$2e2bcd8739ae039(element) {
    return element ? (element.nodeName || '').toLowerCase() : null;
}





function $289fe7956da49aa6$export$2e2bcd8739ae039(element) {
    // $FlowFixMe[incompatible-return]: assume body is always available
    return (((0, $f6d32abb4309953c$export$45a5e7f76e0caa8d)(element) ? element.ownerDocument : element.document) || window.document).documentElement;
}



function $c1ac98119f6bfcf7$export$2e2bcd8739ae039(element) {
    // If <html> has a CSS width greater than the viewport, then this will be
    // incorrect for RTL.
    // Popper 1 is broken in this case and never had a bug report so let's assume
    // it's not an issue. I don't think anyone ever specifies width on <html>
    // anyway.
    // Browsers where the left scrollbar doesn't cause an issue report `0` for
    // this (e.g. Edge 2019, IE11, Safari)
    return (0, $ee81caf1e37998e9$export$2e2bcd8739ae039)((0, $289fe7956da49aa6$export$2e2bcd8739ae039)(element)).left + (0, $21860a066a5f8348$export$2e2bcd8739ae039)(element).scrollLeft;
}




function $9ea06628acc2b5d8$export$2e2bcd8739ae039(element) {
    return (0, $51822b2d1b9ce85d$export$2e2bcd8739ae039)(element).getComputedStyle(element);
}


function $c9b47944f8a023ed$export$2e2bcd8739ae039(element) {
    // Firefox wants us to check `-x` and `-y` variations as well
    var _getComputedStyle = (0, $9ea06628acc2b5d8$export$2e2bcd8739ae039)(element), overflow = _getComputedStyle.overflow, overflowX = _getComputedStyle.overflowX, overflowY = _getComputedStyle.overflowY;
    return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
}



function $1b2248aea3a2cdf3$var$isElementScaled(element) {
    var rect = element.getBoundingClientRect();
    var scaleX = (0, $a648b2d87eb6107b$export$2077e0241d6afd3c)(rect.width) / element.offsetWidth || 1;
    var scaleY = (0, $a648b2d87eb6107b$export$2077e0241d6afd3c)(rect.height) / element.offsetHeight || 1;
    return scaleX !== 1 || scaleY !== 1;
} // Returns the composite rect of an element relative to its offsetParent.
function $1b2248aea3a2cdf3$export$2e2bcd8739ae039(elementOrVirtualElement, offsetParent, isFixed) {
    if (isFixed === void 0) isFixed = false;
    var isOffsetParentAnElement = (0, $f6d32abb4309953c$export$1b3bfaa9684536aa)(offsetParent);
    var offsetParentIsScaled = (0, $f6d32abb4309953c$export$1b3bfaa9684536aa)(offsetParent) && $1b2248aea3a2cdf3$var$isElementScaled(offsetParent);
    var documentElement = (0, $289fe7956da49aa6$export$2e2bcd8739ae039)(offsetParent);
    var rect = (0, $ee81caf1e37998e9$export$2e2bcd8739ae039)(elementOrVirtualElement, offsetParentIsScaled, isFixed);
    var scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    var offsets = {
        x: 0,
        y: 0
    };
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $0b191fc852445ef6$export$2e2bcd8739ae039)(offsetParent) !== 'body' || // https://github.com/popperjs/popper-core/issues/1078
        (0, $c9b47944f8a023ed$export$2e2bcd8739ae039)(documentElement)) scroll = (0, $3ef01fce428e42ca$export$2e2bcd8739ae039)(offsetParent);
        if ((0, $f6d32abb4309953c$export$1b3bfaa9684536aa)(offsetParent)) {
            offsets = (0, $ee81caf1e37998e9$export$2e2bcd8739ae039)(offsetParent, true);
            offsets.x += offsetParent.clientLeft;
            offsets.y += offsetParent.clientTop;
        } else if (documentElement) offsets.x = (0, $c1ac98119f6bfcf7$export$2e2bcd8739ae039)(documentElement);
    }
    return {
        x: rect.left + scroll.scrollLeft - offsets.x,
        y: rect.top + scroll.scrollTop - offsets.y,
        width: rect.width,
        height: rect.height
    };
}



function $446da4420f84bd5e$export$2e2bcd8739ae039(element) {
    var clientRect = (0, $ee81caf1e37998e9$export$2e2bcd8739ae039)(element); // Use the clientRect sizes if it's not been transformed.
    // Fixes https://github.com/popperjs/popper-core/issues/1223
    var width = element.offsetWidth;
    var height = element.offsetHeight;
    if (Math.abs(clientRect.width - width) <= 1) width = clientRect.width;
    if (Math.abs(clientRect.height - height) <= 1) height = clientRect.height;
    return {
        x: element.offsetLeft,
        y: element.offsetTop,
        width: width,
        height: height
    };
}





function $2c33be3e8a776f0d$export$2e2bcd8739ae039(element) {
    if ((0, $0b191fc852445ef6$export$2e2bcd8739ae039)(element) === 'html') return element;
    return(// $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    element.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    element.parentNode || ((0, $f6d32abb4309953c$export$af51f0f06c0f328a)(element) ? element.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    (0, $289fe7956da49aa6$export$2e2bcd8739ae039)(element) // fallback
    );
}





function $1bbdffcb9ee87d4a$export$2e2bcd8739ae039(node) {
    if ([
        'html',
        'body',
        '#document'
    ].indexOf((0, $0b191fc852445ef6$export$2e2bcd8739ae039)(node)) >= 0) // $FlowFixMe[incompatible-return]: assume body is always available
    return node.ownerDocument.body;
    if ((0, $f6d32abb4309953c$export$1b3bfaa9684536aa)(node) && (0, $c9b47944f8a023ed$export$2e2bcd8739ae039)(node)) return node;
    return $1bbdffcb9ee87d4a$export$2e2bcd8739ae039((0, $2c33be3e8a776f0d$export$2e2bcd8739ae039)(node));
}





function $0a850cd6997ce56c$export$2e2bcd8739ae039(element, list) {
    var _element$ownerDocumen;
    if (list === void 0) list = [];
    var scrollParent = (0, $1bbdffcb9ee87d4a$export$2e2bcd8739ae039)(element);
    var isBody = scrollParent === ((_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body);
    var win = (0, $51822b2d1b9ce85d$export$2e2bcd8739ae039)(scrollParent);
    var target = isBody ? [
        win
    ].concat(win.visualViewport || [], (0, $c9b47944f8a023ed$export$2e2bcd8739ae039)(scrollParent) ? scrollParent : []) : scrollParent;
    var updatedList = list.concat(target);
    return isBody ? updatedList : updatedList.concat($0a850cd6997ce56c$export$2e2bcd8739ae039((0, $2c33be3e8a776f0d$export$2e2bcd8739ae039)(target)));
}







function $c687855b8cd751a8$export$2e2bcd8739ae039(element) {
    return [
        'table',
        'td',
        'th'
    ].indexOf((0, $0b191fc852445ef6$export$2e2bcd8739ae039)(element)) >= 0;
}




function $f37189b3639e250b$var$getTrueOffsetParent(element) {
    if (!(0, $f6d32abb4309953c$export$1b3bfaa9684536aa)(element) || // https://github.com/popperjs/popper-core/issues/837
    (0, $9ea06628acc2b5d8$export$2e2bcd8739ae039)(element).position === 'fixed') return null;
    return element.offsetParent;
} // `.offsetParent` reports `null` for fixed elements, while absolute elements
// return the containing block
function $f37189b3639e250b$var$getContainingBlock(element) {
    var isFirefox = /firefox/i.test((0, $c8d7fb5a5e3cbda4$export$2e2bcd8739ae039)());
    var isIE = /Trident/i.test((0, $c8d7fb5a5e3cbda4$export$2e2bcd8739ae039)());
    if (isIE && (0, $f6d32abb4309953c$export$1b3bfaa9684536aa)(element)) {
        // In IE 9, 10 and 11 fixed elements containing block is always established by the viewport
        var elementCss = (0, $9ea06628acc2b5d8$export$2e2bcd8739ae039)(element);
        if (elementCss.position === 'fixed') return null;
    }
    var currentNode = (0, $2c33be3e8a776f0d$export$2e2bcd8739ae039)(element);
    if ((0, $f6d32abb4309953c$export$af51f0f06c0f328a)(currentNode)) currentNode = currentNode.host;
    while((0, $f6d32abb4309953c$export$1b3bfaa9684536aa)(currentNode) && [
        'html',
        'body'
    ].indexOf((0, $0b191fc852445ef6$export$2e2bcd8739ae039)(currentNode)) < 0){
        var css = (0, $9ea06628acc2b5d8$export$2e2bcd8739ae039)(currentNode); // This is non-exhaustive but covers the most common CSS properties that
        // create a containing block.
        // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
        if (css.transform !== 'none' || css.perspective !== 'none' || css.contain === 'paint' || [
            'transform',
            'perspective'
        ].indexOf(css.willChange) !== -1 || isFirefox && css.willChange === 'filter' || isFirefox && css.filter && css.filter !== 'none') return currentNode;
        else currentNode = currentNode.parentNode;
    }
    return null;
} // Gets the closest ancestor positioned element. Handles some edge cases,
function $f37189b3639e250b$export$2e2bcd8739ae039(element) {
    var window = (0, $51822b2d1b9ce85d$export$2e2bcd8739ae039)(element);
    var offsetParent = $f37189b3639e250b$var$getTrueOffsetParent(element);
    while(offsetParent && (0, $c687855b8cd751a8$export$2e2bcd8739ae039)(offsetParent) && (0, $9ea06628acc2b5d8$export$2e2bcd8739ae039)(offsetParent).position === 'static')offsetParent = $f37189b3639e250b$var$getTrueOffsetParent(offsetParent);
    if (offsetParent && ((0, $0b191fc852445ef6$export$2e2bcd8739ae039)(offsetParent) === 'html' || (0, $0b191fc852445ef6$export$2e2bcd8739ae039)(offsetParent) === 'body' && (0, $9ea06628acc2b5d8$export$2e2bcd8739ae039)(offsetParent).position === 'static')) return window;
    return offsetParent || $f37189b3639e250b$var$getContainingBlock(element) || window;
}


var $efb5382c81aaa170$export$1e95b668f3b82d = 'top';
var $efb5382c81aaa170$export$40e543e69a8b3fbb = 'bottom';
var $efb5382c81aaa170$export$79ffe56a765070d2 = 'right';
var $efb5382c81aaa170$export$eabcd2c8791e7bf4 = 'left';
var $efb5382c81aaa170$export$dfb5619354ba860 = 'auto';
var $efb5382c81aaa170$export$aec2ce47c367b8c3 = [
    $efb5382c81aaa170$export$1e95b668f3b82d,
    $efb5382c81aaa170$export$40e543e69a8b3fbb,
    $efb5382c81aaa170$export$79ffe56a765070d2,
    $efb5382c81aaa170$export$eabcd2c8791e7bf4
];
var $efb5382c81aaa170$export$b3571188c770cc5a = 'start';
var $efb5382c81aaa170$export$bd5df0f255a350f8 = 'end';
var $efb5382c81aaa170$export$390fd549c5303b4d = 'clippingParents';
var $efb5382c81aaa170$export$d7b7311ec04a3e8f = 'viewport';
var $efb5382c81aaa170$export$ae5ab1c730825774 = 'popper';
var $efb5382c81aaa170$export$ca50aac9f3ba507f = 'reference';
var $efb5382c81aaa170$export$368f9a87e87fa4e1 = /*#__PURE__*/ $efb5382c81aaa170$export$aec2ce47c367b8c3.reduce(function(acc, placement) {
    return acc.concat([
        placement + "-" + $efb5382c81aaa170$export$b3571188c770cc5a,
        placement + "-" + $efb5382c81aaa170$export$bd5df0f255a350f8
    ]);
}, []);
var $efb5382c81aaa170$export$803cd8101b6c182b = /*#__PURE__*/ [].concat($efb5382c81aaa170$export$aec2ce47c367b8c3, [
    $efb5382c81aaa170$export$dfb5619354ba860
]).reduce(function(acc, placement) {
    return acc.concat([
        placement,
        placement + "-" + $efb5382c81aaa170$export$b3571188c770cc5a,
        placement + "-" + $efb5382c81aaa170$export$bd5df0f255a350f8
    ]);
}, []); // modifiers that need to read the DOM
var $efb5382c81aaa170$export$421679a7c3d56e = 'beforeRead';
var $efb5382c81aaa170$export$aafa59e2e03f2942 = 'read';
var $efb5382c81aaa170$export$6964f6c886723980 = 'afterRead'; // pure-logic modifiers
var $efb5382c81aaa170$export$c65e99957a05207c = 'beforeMain';
var $efb5382c81aaa170$export$f22da7240b7add18 = 'main';
var $efb5382c81aaa170$export$bab79516f2d662fe = 'afterMain'; // modifier with the purpose to write to the DOM (or write into a framework state)
var $efb5382c81aaa170$export$8d4d2d70e7d46032 = 'beforeWrite';
var $efb5382c81aaa170$export$68d8715fc104d294 = 'write';
var $efb5382c81aaa170$export$70a6e5159acce2e6 = 'afterWrite';
var $efb5382c81aaa170$export$d087d3878fdf71d5 = [
    $efb5382c81aaa170$export$421679a7c3d56e,
    $efb5382c81aaa170$export$aafa59e2e03f2942,
    $efb5382c81aaa170$export$6964f6c886723980,
    $efb5382c81aaa170$export$c65e99957a05207c,
    $efb5382c81aaa170$export$f22da7240b7add18,
    $efb5382c81aaa170$export$bab79516f2d662fe,
    $efb5382c81aaa170$export$8d4d2d70e7d46032,
    $efb5382c81aaa170$export$68d8715fc104d294,
    $efb5382c81aaa170$export$70a6e5159acce2e6
];


function $b20e5946215911a1$var$order(modifiers) {
    var map = new Map();
    var visited = new Set();
    var result = [];
    modifiers.forEach(function(modifier) {
        map.set(modifier.name, modifier);
    }); // On visiting object, check for its dependencies and visit them recursively
    function sort(modifier) {
        visited.add(modifier.name);
        var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
        requires.forEach(function(dep) {
            if (!visited.has(dep)) {
                var depModifier = map.get(dep);
                if (depModifier) sort(depModifier);
            }
        });
        result.push(modifier);
    }
    modifiers.forEach(function(modifier) {
        if (!visited.has(modifier.name)) // check for visited object
        sort(modifier);
    });
    return result;
}
function $b20e5946215911a1$export$2e2bcd8739ae039(modifiers) {
    // order based on dependencies
    var orderedModifiers = $b20e5946215911a1$var$order(modifiers); // order based on phase
    return (0, $efb5382c81aaa170$export$d087d3878fdf71d5).reduce(function(acc, phase) {
        return acc.concat(orderedModifiers.filter(function(modifier) {
            return modifier.phase === phase;
        }));
    }, []);
}


function $82b059f3395b61cd$export$2e2bcd8739ae039(fn) {
    var pending;
    return function() {
        if (!pending) pending = new Promise(function(resolve) {
            Promise.resolve().then(function() {
                pending = undefined;
                resolve(fn());
            });
        });
        return pending;
    };
}


function $16e9a5fc44bcc981$export$2e2bcd8739ae039(modifiers) {
    var merged = modifiers.reduce(function(merged, current) {
        var existing = merged[current.name];
        merged[current.name] = existing ? Object.assign({}, existing, current, {
            options: Object.assign({}, existing.options, current.options),
            data: Object.assign({}, existing.data, current.data)
        }) : current;
        return merged;
    }, {}); // IE11 does not support Object.values
    return Object.keys(merged).map(function(key) {
        return merged[key];
    });
}




var $9da309eeb9a6ad0d$var$DEFAULT_OPTIONS = {
    placement: 'bottom',
    modifiers: [],
    strategy: 'absolute'
};
function $9da309eeb9a6ad0d$var$areValidElements() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return !args.some(function(element) {
        return !(element && typeof element.getBoundingClientRect === 'function');
    });
}
function $9da309eeb9a6ad0d$export$ed5e13716264f202(generatorOptions) {
    if (generatorOptions === void 0) generatorOptions = {};
    var _generatorOptions = generatorOptions, _generatorOptions$def = _generatorOptions.defaultModifiers, defaultModifiers = _generatorOptions$def === void 0 ? [] : _generatorOptions$def, _generatorOptions$def2 = _generatorOptions.defaultOptions, defaultOptions = _generatorOptions$def2 === void 0 ? $9da309eeb9a6ad0d$var$DEFAULT_OPTIONS : _generatorOptions$def2;
    return function createPopper(reference, popper, options) {
        if (options === void 0) options = defaultOptions;
        var state = {
            placement: 'bottom',
            orderedModifiers: [],
            options: Object.assign({}, $9da309eeb9a6ad0d$var$DEFAULT_OPTIONS, defaultOptions),
            modifiersData: {},
            elements: {
                reference: reference,
                popper: popper
            },
            attributes: {},
            styles: {}
        };
        var effectCleanupFns = [];
        var isDestroyed = false;
        var instance = {
            state: state,
            setOptions: function setOptions(setOptionsAction) {
                var options = typeof setOptionsAction === 'function' ? setOptionsAction(state.options) : setOptionsAction;
                cleanupModifierEffects();
                state.options = Object.assign({}, defaultOptions, state.options, options);
                state.scrollParents = {
                    reference: (0, $f6d32abb4309953c$export$45a5e7f76e0caa8d)(reference) ? (0, $0a850cd6997ce56c$export$2e2bcd8739ae039)(reference) : reference.contextElement ? (0, $0a850cd6997ce56c$export$2e2bcd8739ae039)(reference.contextElement) : [],
                    popper: (0, $0a850cd6997ce56c$export$2e2bcd8739ae039)(popper)
                }; // Orders the modifiers based on their dependencies and `phase`
                // properties
                var orderedModifiers = (0, $b20e5946215911a1$export$2e2bcd8739ae039)((0, $16e9a5fc44bcc981$export$2e2bcd8739ae039)([].concat(defaultModifiers, state.options.modifiers))); // Strip out disabled modifiers
                state.orderedModifiers = orderedModifiers.filter(function(m) {
                    return m.enabled;
                });
                runModifierEffects();
                return instance.update();
            },
            // Sync update – it will always be executed, even if not necessary. This
            // is useful for low frequency updates where sync behavior simplifies the
            // logic.
            // For high frequency updates (e.g. `resize` and `scroll` events), always
            // prefer the async Popper#update method
            forceUpdate: function forceUpdate() {
                if (isDestroyed) return;
                var _state$elements = state.elements, reference = _state$elements.reference, popper = _state$elements.popper; // Don't proceed if `reference` or `popper` are not valid elements
                // anymore
                if (!$9da309eeb9a6ad0d$var$areValidElements(reference, popper)) return;
                 // Store the reference and popper rects to be read by modifiers
                state.rects = {
                    reference: (0, $1b2248aea3a2cdf3$export$2e2bcd8739ae039)(reference, (0, $f37189b3639e250b$export$2e2bcd8739ae039)(popper), state.options.strategy === 'fixed'),
                    popper: (0, $446da4420f84bd5e$export$2e2bcd8739ae039)(popper)
                }; // Modifiers have the ability to reset the current update cycle. The
                // most common use case for this is the `flip` modifier changing the
                // placement, which then needs to re-run all the modifiers, because the
                // logic was previously ran for the previous placement and is therefore
                // stale/incorrect
                state.reset = false;
                state.placement = state.options.placement; // On each update cycle, the `modifiersData` property for each modifier
                // is filled with the initial data specified by the modifier. This means
                // it doesn't persist and is fresh on each update.
                // To ensure persistent data, use `${name}#persistent`
                state.orderedModifiers.forEach(function(modifier) {
                    return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
                });
                for(var index = 0; index < state.orderedModifiers.length; index++){
                    if (state.reset === true) {
                        state.reset = false;
                        index = -1;
                        continue;
                    }
                    var _state$orderedModifie = state.orderedModifiers[index], fn = _state$orderedModifie.fn, _state$orderedModifie2 = _state$orderedModifie.options, _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2, name = _state$orderedModifie.name;
                    if (typeof fn === 'function') state = fn({
                        state: state,
                        options: _options,
                        name: name,
                        instance: instance
                    }) || state;
                }
            },
            // Async and optimistically optimized update – it will not be executed if
            // not necessary (debounced to run at most once-per-tick)
            update: (0, $82b059f3395b61cd$export$2e2bcd8739ae039)(function() {
                return new Promise(function(resolve) {
                    instance.forceUpdate();
                    resolve(state);
                });
            }),
            destroy: function destroy() {
                cleanupModifierEffects();
                isDestroyed = true;
            }
        };
        if (!$9da309eeb9a6ad0d$var$areValidElements(reference, popper)) return instance;
        instance.setOptions(options).then(function(state) {
            if (!isDestroyed && options.onFirstUpdate) options.onFirstUpdate(state);
        }); // Modifiers have the ability to execute arbitrary code before the first
        // update cycle runs. They will be executed in the same order as the update
        // cycle. This is useful when a modifier adds some persistent data that
        // other modifiers need to use, but the modifier is run after the dependent
        // one.
        function runModifierEffects() {
            state.orderedModifiers.forEach(function(_ref) {
                var name = _ref.name, _ref$options = _ref.options, options = _ref$options === void 0 ? {} : _ref$options, effect = _ref.effect;
                if (typeof effect === 'function') {
                    var cleanupFn = effect({
                        state: state,
                        name: name,
                        instance: instance,
                        options: options
                    });
                    var noopFn = function noopFn() {};
                    effectCleanupFns.push(cleanupFn || noopFn);
                }
            });
        }
        function cleanupModifierEffects() {
            effectCleanupFns.forEach(function(fn) {
                return fn();
            });
            effectCleanupFns = [];
        }
        return instance;
    };
}
var $9da309eeb9a6ad0d$export$8f7491d57c8f97a9 = /*#__PURE__*/ $9da309eeb9a6ad0d$export$ed5e13716264f202(); // eslint-disable-next-line import/no-unused-modules



var $2000633d5b236d6d$var$passive = {
    passive: true
};
function $2000633d5b236d6d$var$effect(_ref) {
    var state = _ref.state, instance = _ref.instance, options = _ref.options;
    var _options$scroll = options.scroll, scroll = _options$scroll === void 0 ? true : _options$scroll, _options$resize = options.resize, resize = _options$resize === void 0 ? true : _options$resize;
    var window = (0, $51822b2d1b9ce85d$export$2e2bcd8739ae039)(state.elements.popper);
    var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);
    if (scroll) scrollParents.forEach(function(scrollParent) {
        scrollParent.addEventListener('scroll', instance.update, $2000633d5b236d6d$var$passive);
    });
    if (resize) window.addEventListener('resize', instance.update, $2000633d5b236d6d$var$passive);
    return function() {
        if (scroll) scrollParents.forEach(function(scrollParent) {
            scrollParent.removeEventListener('scroll', instance.update, $2000633d5b236d6d$var$passive);
        });
        if (resize) window.removeEventListener('resize', instance.update, $2000633d5b236d6d$var$passive);
    };
} // eslint-disable-next-line import/no-unused-modules
var $2000633d5b236d6d$export$2e2bcd8739ae039 = {
    name: 'eventListeners',
    enabled: true,
    phase: 'write',
    fn: function fn() {},
    effect: $2000633d5b236d6d$var$effect,
    data: {}
};



function $c7fb149c5a3855e3$export$2e2bcd8739ae039(placement) {
    return placement.split('-')[0];
}


function $72d39783263c9619$export$2e2bcd8739ae039(placement) {
    return placement.split('-')[1];
}


function $29e733e6d8dc66a0$export$2e2bcd8739ae039(placement) {
    return [
        'top',
        'bottom'
    ].indexOf(placement) >= 0 ? 'x' : 'y';
}



function $4ad3dc56fcddcd07$export$2e2bcd8739ae039(_ref) {
    var reference = _ref.reference, element = _ref.element, placement = _ref.placement;
    var basePlacement = placement ? (0, $c7fb149c5a3855e3$export$2e2bcd8739ae039)(placement) : null;
    var variation = placement ? (0, $72d39783263c9619$export$2e2bcd8739ae039)(placement) : null;
    var commonX = reference.x + reference.width / 2 - element.width / 2;
    var commonY = reference.y + reference.height / 2 - element.height / 2;
    var offsets;
    switch(basePlacement){
        case 0, $efb5382c81aaa170$export$1e95b668f3b82d:
            offsets = {
                x: commonX,
                y: reference.y - element.height
            };
            break;
        case 0, $efb5382c81aaa170$export$40e543e69a8b3fbb:
            offsets = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case 0, $efb5382c81aaa170$export$79ffe56a765070d2:
            offsets = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case 0, $efb5382c81aaa170$export$eabcd2c8791e7bf4:
            offsets = {
                x: reference.x - element.width,
                y: commonY
            };
            break;
        default:
            offsets = {
                x: reference.x,
                y: reference.y
            };
    }
    var mainAxis = basePlacement ? (0, $29e733e6d8dc66a0$export$2e2bcd8739ae039)(basePlacement) : null;
    if (mainAxis != null) {
        var len = mainAxis === 'y' ? 'height' : 'width';
        switch(variation){
            case 0, $efb5382c81aaa170$export$b3571188c770cc5a:
                offsets[mainAxis] = offsets[mainAxis] - (reference[len] / 2 - element[len] / 2);
                break;
            case 0, $efb5382c81aaa170$export$bd5df0f255a350f8:
                offsets[mainAxis] = offsets[mainAxis] + (reference[len] / 2 - element[len] / 2);
                break;
            default:
        }
    }
    return offsets;
}


function $59aaebe45f10b31a$var$popperOffsets(_ref) {
    var state = _ref.state, name = _ref.name;
    // Offsets are the actual position the popper needs to have to be
    // properly positioned near its reference element
    // This is the most basic placement, and will be adjusted by
    // the modifiers in the next step
    state.modifiersData[name] = (0, $4ad3dc56fcddcd07$export$2e2bcd8739ae039)({
        reference: state.rects.reference,
        element: state.rects.popper,
        strategy: 'absolute',
        placement: state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $59aaebe45f10b31a$export$2e2bcd8739ae039 = {
    name: 'popperOffsets',
    enabled: true,
    phase: 'read',
    fn: $59aaebe45f10b31a$var$popperOffsets,
    data: {}
};










var $a064d43b2317d513$var$unsetSides = {
    top: 'auto',
    right: 'auto',
    bottom: 'auto',
    left: 'auto'
}; // Round the offsets to the nearest suitable subpixel based on the DPR.
// Zooming can change the DPR, but it seems to report a value that will
// cleanly divide the values into the appropriate subpixels.
function $a064d43b2317d513$var$roundOffsetsByDPR(_ref, win) {
    var x = _ref.x, y = _ref.y;
    var dpr = win.devicePixelRatio || 1;
    return {
        x: (0, $a648b2d87eb6107b$export$2077e0241d6afd3c)(x * dpr) / dpr || 0,
        y: (0, $a648b2d87eb6107b$export$2077e0241d6afd3c)(y * dpr) / dpr || 0
    };
}
function $a064d43b2317d513$export$378fa78a8fea596f(_ref2) {
    var _Object$assign2;
    var popper = _ref2.popper, popperRect = _ref2.popperRect, placement = _ref2.placement, variation = _ref2.variation, offsets = _ref2.offsets, position = _ref2.position, gpuAcceleration = _ref2.gpuAcceleration, adaptive = _ref2.adaptive, roundOffsets = _ref2.roundOffsets, isFixed = _ref2.isFixed;
    var _offsets$x = offsets.x, x = _offsets$x === void 0 ? 0 : _offsets$x, _offsets$y = offsets.y, y = _offsets$y === void 0 ? 0 : _offsets$y;
    var _ref3 = typeof roundOffsets === 'function' ? roundOffsets({
        x: x,
        y: y
    }) : {
        x: x,
        y: y
    };
    x = _ref3.x;
    y = _ref3.y;
    var hasX = offsets.hasOwnProperty('x');
    var hasY = offsets.hasOwnProperty('y');
    var sideX = (0, $efb5382c81aaa170$export$eabcd2c8791e7bf4);
    var sideY = (0, $efb5382c81aaa170$export$1e95b668f3b82d);
    var win = window;
    if (adaptive) {
        var offsetParent = (0, $f37189b3639e250b$export$2e2bcd8739ae039)(popper);
        var heightProp = 'clientHeight';
        var widthProp = 'clientWidth';
        if (offsetParent === (0, $51822b2d1b9ce85d$export$2e2bcd8739ae039)(popper)) {
            offsetParent = (0, $289fe7956da49aa6$export$2e2bcd8739ae039)(popper);
            if ((0, $9ea06628acc2b5d8$export$2e2bcd8739ae039)(offsetParent).position !== 'static' && position === 'absolute') {
                heightProp = 'scrollHeight';
                widthProp = 'scrollWidth';
            }
        } // $FlowFixMe[incompatible-cast]: force type refinement, we compare offsetParent with window above, but Flow doesn't detect it
        offsetParent;
        if (placement === (0, $efb5382c81aaa170$export$1e95b668f3b82d) || (placement === (0, $efb5382c81aaa170$export$eabcd2c8791e7bf4) || placement === (0, $efb5382c81aaa170$export$79ffe56a765070d2)) && variation === (0, $efb5382c81aaa170$export$bd5df0f255a350f8)) {
            sideY = (0, $efb5382c81aaa170$export$40e543e69a8b3fbb);
            var offsetY = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.height : offsetParent[heightProp];
            y -= offsetY - popperRect.height;
            y *= gpuAcceleration ? 1 : -1;
        }
        if (placement === (0, $efb5382c81aaa170$export$eabcd2c8791e7bf4) || (placement === (0, $efb5382c81aaa170$export$1e95b668f3b82d) || placement === (0, $efb5382c81aaa170$export$40e543e69a8b3fbb)) && variation === (0, $efb5382c81aaa170$export$bd5df0f255a350f8)) {
            sideX = (0, $efb5382c81aaa170$export$79ffe56a765070d2);
            var offsetX = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.width : offsetParent[widthProp];
            x -= offsetX - popperRect.width;
            x *= gpuAcceleration ? 1 : -1;
        }
    }
    var commonStyles = Object.assign({
        position: position
    }, adaptive && $a064d43b2317d513$var$unsetSides);
    var _ref4 = roundOffsets === true ? $a064d43b2317d513$var$roundOffsetsByDPR({
        x: x,
        y: y
    }, (0, $51822b2d1b9ce85d$export$2e2bcd8739ae039)(popper)) : {
        x: x,
        y: y
    };
    x = _ref4.x;
    y = _ref4.y;
    if (gpuAcceleration) {
        var _Object$assign;
        return Object.assign({}, commonStyles, (_Object$assign = {}, _Object$assign[sideY] = hasY ? '0' : '', _Object$assign[sideX] = hasX ? '0' : '', _Object$assign.transform = (win.devicePixelRatio || 1) <= 1 ? "translate(" + x + "px, " + y + "px)" : "translate3d(" + x + "px, " + y + "px, 0)", _Object$assign));
    }
    return Object.assign({}, commonStyles, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y + "px" : '', _Object$assign2[sideX] = hasX ? x + "px" : '', _Object$assign2.transform = '', _Object$assign2));
}
function $a064d43b2317d513$var$computeStyles(_ref5) {
    var state = _ref5.state, options = _ref5.options;
    var _options$gpuAccelerat = options.gpuAcceleration, gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat, _options$adaptive = options.adaptive, adaptive = _options$adaptive === void 0 ? true : _options$adaptive, _options$roundOffsets = options.roundOffsets, roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;
    var commonStyles = {
        placement: (0, $c7fb149c5a3855e3$export$2e2bcd8739ae039)(state.placement),
        variation: (0, $72d39783263c9619$export$2e2bcd8739ae039)(state.placement),
        popper: state.elements.popper,
        popperRect: state.rects.popper,
        gpuAcceleration: gpuAcceleration,
        isFixed: state.options.strategy === 'fixed'
    };
    if (state.modifiersData.popperOffsets != null) state.styles.popper = Object.assign({}, state.styles.popper, $a064d43b2317d513$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.popperOffsets,
        position: state.options.strategy,
        adaptive: adaptive,
        roundOffsets: roundOffsets
    })));
    if (state.modifiersData.arrow != null) state.styles.arrow = Object.assign({}, state.styles.arrow, $a064d43b2317d513$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.arrow,
        position: 'absolute',
        adaptive: false,
        roundOffsets: roundOffsets
    })));
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        'data-popper-placement': state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $a064d43b2317d513$export$2e2bcd8739ae039 = {
    name: 'computeStyles',
    enabled: true,
    phase: 'beforeWrite',
    fn: $a064d43b2317d513$var$computeStyles,
    data: {}
};




// and applies them to the HTMLElements such as popper and arrow
function $f9a32ceb825091fe$var$applyStyles(_ref) {
    var state = _ref.state;
    Object.keys(state.elements).forEach(function(name) {
        var style = state.styles[name] || {};
        var attributes = state.attributes[name] || {};
        var element = state.elements[name]; // arrow is optional + virtual elements
        if (!(0, $f6d32abb4309953c$export$1b3bfaa9684536aa)(element) || !(0, $0b191fc852445ef6$export$2e2bcd8739ae039)(element)) return;
         // Flow doesn't support to extend this property, but it's the most
        // effective way to apply styles to an HTMLElement
        // $FlowFixMe[cannot-write]
        Object.assign(element.style, style);
        Object.keys(attributes).forEach(function(name) {
            var value = attributes[name];
            if (value === false) element.removeAttribute(name);
            else element.setAttribute(name, value === true ? '' : value);
        });
    });
}
function $f9a32ceb825091fe$var$effect(_ref2) {
    var state = _ref2.state;
    var initialStyles = {
        popper: {
            position: state.options.strategy,
            left: '0',
            top: '0',
            margin: '0'
        },
        arrow: {
            position: 'absolute'
        },
        reference: {}
    };
    Object.assign(state.elements.popper.style, initialStyles.popper);
    state.styles = initialStyles;
    if (state.elements.arrow) Object.assign(state.elements.arrow.style, initialStyles.arrow);
    return function() {
        Object.keys(state.elements).forEach(function(name) {
            var element = state.elements[name];
            var attributes = state.attributes[name] || {};
            var styleProperties = Object.keys(state.styles.hasOwnProperty(name) ? state.styles[name] : initialStyles[name]); // Set all values to an empty string to unset them
            var style = styleProperties.reduce(function(style, property) {
                style[property] = '';
                return style;
            }, {}); // arrow is optional + virtual elements
            if (!(0, $f6d32abb4309953c$export$1b3bfaa9684536aa)(element) || !(0, $0b191fc852445ef6$export$2e2bcd8739ae039)(element)) return;
            Object.assign(element.style, style);
            Object.keys(attributes).forEach(function(attribute) {
                element.removeAttribute(attribute);
            });
        });
    };
} // eslint-disable-next-line import/no-unused-modules
var $f9a32ceb825091fe$export$2e2bcd8739ae039 = {
    name: 'applyStyles',
    enabled: true,
    phase: 'write',
    fn: $f9a32ceb825091fe$var$applyStyles,
    effect: $f9a32ceb825091fe$var$effect,
    requires: [
        'computeStyles'
    ]
};




function $f4e8c51424a17a32$export$7fa02d8595b015ed(placement, rects, offset) {
    var basePlacement = (0, $c7fb149c5a3855e3$export$2e2bcd8739ae039)(placement);
    var invertDistance = [
        (0, $efb5382c81aaa170$export$eabcd2c8791e7bf4),
        (0, $efb5382c81aaa170$export$1e95b668f3b82d)
    ].indexOf(basePlacement) >= 0 ? -1 : 1;
    var _ref = typeof offset === 'function' ? offset(Object.assign({}, rects, {
        placement: placement
    })) : offset, skidding = _ref[0], distance = _ref[1];
    skidding = skidding || 0;
    distance = (distance || 0) * invertDistance;
    return [
        (0, $efb5382c81aaa170$export$eabcd2c8791e7bf4),
        (0, $efb5382c81aaa170$export$79ffe56a765070d2)
    ].indexOf(basePlacement) >= 0 ? {
        x: distance,
        y: skidding
    } : {
        x: skidding,
        y: distance
    };
}
function $f4e8c51424a17a32$var$offset(_ref2) {
    var state = _ref2.state, options = _ref2.options, name = _ref2.name;
    var _options$offset = options.offset, offset = _options$offset === void 0 ? [
        0,
        0
    ] : _options$offset;
    var data = (0, $efb5382c81aaa170$export$803cd8101b6c182b).reduce(function(acc, placement) {
        acc[placement] = $f4e8c51424a17a32$export$7fa02d8595b015ed(placement, state.rects, offset);
        return acc;
    }, {});
    var _data$state$placement = data[state.placement], x = _data$state$placement.x, y = _data$state$placement.y;
    if (state.modifiersData.popperOffsets != null) {
        state.modifiersData.popperOffsets.x += x;
        state.modifiersData.popperOffsets.y += y;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $f4e8c51424a17a32$export$2e2bcd8739ae039 = {
    name: 'offset',
    enabled: true,
    phase: 'main',
    requires: [
        'popperOffsets'
    ],
    fn: $f4e8c51424a17a32$var$offset
};


var $64e4d2853e52f2ad$var$hash = {
    left: 'right',
    right: 'left',
    bottom: 'top',
    top: 'bottom'
};
function $64e4d2853e52f2ad$export$2e2bcd8739ae039(placement) {
    return placement.replace(/left|right|bottom|top/g, function(matched) {
        return $64e4d2853e52f2ad$var$hash[matched];
    });
}



var $787ac286ac65e788$var$hash = {
    start: 'end',
    end: 'start'
};
function $787ac286ac65e788$export$2e2bcd8739ae039(placement) {
    return placement.replace(/start|end/g, function(matched) {
        return $787ac286ac65e788$var$hash[matched];
    });
}







function $33067b8cce050350$export$2e2bcd8739ae039(element, strategy) {
    var win = (0, $51822b2d1b9ce85d$export$2e2bcd8739ae039)(element);
    var html = (0, $289fe7956da49aa6$export$2e2bcd8739ae039)(element);
    var visualViewport = win.visualViewport;
    var width = html.clientWidth;
    var height = html.clientHeight;
    var x = 0;
    var y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        var layoutViewport = (0, $655c371d9bfb24a9$export$2e2bcd8739ae039)();
        if (layoutViewport || !layoutViewport && strategy === 'fixed') {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    return {
        width: width,
        height: height,
        x: x + (0, $c1ac98119f6bfcf7$export$2e2bcd8739ae039)(element),
        y: y
    };
}







function $972a1a08ba3bed53$export$2e2bcd8739ae039(element) {
    var _element$ownerDocumen;
    var html = (0, $289fe7956da49aa6$export$2e2bcd8739ae039)(element);
    var winScroll = (0, $21860a066a5f8348$export$2e2bcd8739ae039)(element);
    var body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
    var width = (0, $a648b2d87eb6107b$export$8960430cfd85939f)(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
    var height = (0, $a648b2d87eb6107b$export$8960430cfd85939f)(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
    var x = -winScroll.scrollLeft + (0, $c1ac98119f6bfcf7$export$2e2bcd8739ae039)(element);
    var y = -winScroll.scrollTop;
    if ((0, $9ea06628acc2b5d8$export$2e2bcd8739ae039)(body || html).direction === 'rtl') x += (0, $a648b2d87eb6107b$export$8960430cfd85939f)(html.clientWidth, body ? body.clientWidth : 0) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}










function $58b2c9496045651d$export$2e2bcd8739ae039(parent, child) {
    var rootNode = child.getRootNode && child.getRootNode(); // First, attempt with faster native method
    if (parent.contains(child)) return true;
    else if (rootNode && (0, $f6d32abb4309953c$export$af51f0f06c0f328a)(rootNode)) {
        var next = child;
        do {
            if (next && parent.isSameNode(next)) return true;
             // $FlowFixMe[prop-missing]: need a better way to handle this...
            next = next.parentNode || next.host;
        }while (next);
    } // Give up, the result is false
    return false;
}



function $73d15a506b13c4bf$export$2e2bcd8739ae039(rect) {
    return Object.assign({}, rect, {
        left: rect.x,
        top: rect.y,
        right: rect.x + rect.width,
        bottom: rect.y + rect.height
    });
}



function $377860c6c06d46c3$var$getInnerBoundingClientRect(element, strategy) {
    var rect = (0, $ee81caf1e37998e9$export$2e2bcd8739ae039)(element, false, strategy === 'fixed');
    rect.top = rect.top + element.clientTop;
    rect.left = rect.left + element.clientLeft;
    rect.bottom = rect.top + element.clientHeight;
    rect.right = rect.left + element.clientWidth;
    rect.width = element.clientWidth;
    rect.height = element.clientHeight;
    rect.x = rect.left;
    rect.y = rect.top;
    return rect;
}
function $377860c6c06d46c3$var$getClientRectFromMixedType(element, clippingParent, strategy) {
    return clippingParent === (0, $efb5382c81aaa170$export$d7b7311ec04a3e8f) ? (0, $73d15a506b13c4bf$export$2e2bcd8739ae039)((0, $33067b8cce050350$export$2e2bcd8739ae039)(element, strategy)) : (0, $f6d32abb4309953c$export$45a5e7f76e0caa8d)(clippingParent) ? $377860c6c06d46c3$var$getInnerBoundingClientRect(clippingParent, strategy) : (0, $73d15a506b13c4bf$export$2e2bcd8739ae039)((0, $972a1a08ba3bed53$export$2e2bcd8739ae039)((0, $289fe7956da49aa6$export$2e2bcd8739ae039)(element)));
} // A "clipping parent" is an overflowable container with the characteristic of
// clipping (or hiding) overflowing elements with a position different from
// `initial`
function $377860c6c06d46c3$var$getClippingParents(element) {
    var clippingParents = (0, $0a850cd6997ce56c$export$2e2bcd8739ae039)((0, $2c33be3e8a776f0d$export$2e2bcd8739ae039)(element));
    var canEscapeClipping = [
        'absolute',
        'fixed'
    ].indexOf((0, $9ea06628acc2b5d8$export$2e2bcd8739ae039)(element).position) >= 0;
    var clipperElement = canEscapeClipping && (0, $f6d32abb4309953c$export$1b3bfaa9684536aa)(element) ? (0, $f37189b3639e250b$export$2e2bcd8739ae039)(element) : element;
    if (!(0, $f6d32abb4309953c$export$45a5e7f76e0caa8d)(clipperElement)) return [];
     // $FlowFixMe[incompatible-return]: https://github.com/facebook/flow/issues/1414
    return clippingParents.filter(function(clippingParent) {
        return (0, $f6d32abb4309953c$export$45a5e7f76e0caa8d)(clippingParent) && (0, $58b2c9496045651d$export$2e2bcd8739ae039)(clippingParent, clipperElement) && (0, $0b191fc852445ef6$export$2e2bcd8739ae039)(clippingParent) !== 'body';
    });
} // Gets the maximum area that the element is visible in due to any number of
function $377860c6c06d46c3$export$2e2bcd8739ae039(element, boundary, rootBoundary, strategy) {
    var mainClippingParents = boundary === 'clippingParents' ? $377860c6c06d46c3$var$getClippingParents(element) : [].concat(boundary);
    var clippingParents = [].concat(mainClippingParents, [
        rootBoundary
    ]);
    var firstClippingParent = clippingParents[0];
    var clippingRect = clippingParents.reduce(function(accRect, clippingParent) {
        var rect = $377860c6c06d46c3$var$getClientRectFromMixedType(element, clippingParent, strategy);
        accRect.top = (0, $a648b2d87eb6107b$export$8960430cfd85939f)(rect.top, accRect.top);
        accRect.right = (0, $a648b2d87eb6107b$export$96ec731ed4dcb222)(rect.right, accRect.right);
        accRect.bottom = (0, $a648b2d87eb6107b$export$96ec731ed4dcb222)(rect.bottom, accRect.bottom);
        accRect.left = (0, $a648b2d87eb6107b$export$8960430cfd85939f)(rect.left, accRect.left);
        return accRect;
    }, $377860c6c06d46c3$var$getClientRectFromMixedType(element, firstClippingParent, strategy));
    clippingRect.width = clippingRect.right - clippingRect.left;
    clippingRect.height = clippingRect.bottom - clippingRect.top;
    clippingRect.x = clippingRect.left;
    clippingRect.y = clippingRect.top;
    return clippingRect;
}








function $49aa9deab310a37f$export$2e2bcd8739ae039() {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
    };
}


function $5ff53f1e92af6255$export$2e2bcd8739ae039(paddingObject) {
    return Object.assign({}, (0, $49aa9deab310a37f$export$2e2bcd8739ae039)(), paddingObject);
}


function $58cc7bf892210b21$export$2e2bcd8739ae039(value, keys) {
    return keys.reduce(function(hashMap, key) {
        hashMap[key] = value;
        return hashMap;
    }, {});
}


function $8ae8b96d9fd77b28$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, _options$placement = _options.placement, placement = _options$placement === void 0 ? state.placement : _options$placement, _options$strategy = _options.strategy, strategy = _options$strategy === void 0 ? state.strategy : _options$strategy, _options$boundary = _options.boundary, boundary = _options$boundary === void 0 ? (0, $efb5382c81aaa170$export$390fd549c5303b4d) : _options$boundary, _options$rootBoundary = _options.rootBoundary, rootBoundary = _options$rootBoundary === void 0 ? (0, $efb5382c81aaa170$export$d7b7311ec04a3e8f) : _options$rootBoundary, _options$elementConte = _options.elementContext, elementContext = _options$elementConte === void 0 ? (0, $efb5382c81aaa170$export$ae5ab1c730825774) : _options$elementConte, _options$altBoundary = _options.altBoundary, altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary, _options$padding = _options.padding, padding = _options$padding === void 0 ? 0 : _options$padding;
    var paddingObject = (0, $5ff53f1e92af6255$export$2e2bcd8739ae039)(typeof padding !== 'number' ? padding : (0, $58cc7bf892210b21$export$2e2bcd8739ae039)(padding, (0, $efb5382c81aaa170$export$aec2ce47c367b8c3)));
    var altContext = elementContext === (0, $efb5382c81aaa170$export$ae5ab1c730825774) ? (0, $efb5382c81aaa170$export$ca50aac9f3ba507f) : (0, $efb5382c81aaa170$export$ae5ab1c730825774);
    var popperRect = state.rects.popper;
    var element = state.elements[altBoundary ? altContext : elementContext];
    var clippingClientRect = (0, $377860c6c06d46c3$export$2e2bcd8739ae039)((0, $f6d32abb4309953c$export$45a5e7f76e0caa8d)(element) ? element : element.contextElement || (0, $289fe7956da49aa6$export$2e2bcd8739ae039)(state.elements.popper), boundary, rootBoundary, strategy);
    var referenceClientRect = (0, $ee81caf1e37998e9$export$2e2bcd8739ae039)(state.elements.reference);
    var popperOffsets = (0, $4ad3dc56fcddcd07$export$2e2bcd8739ae039)({
        reference: referenceClientRect,
        element: popperRect,
        strategy: 'absolute',
        placement: placement
    });
    var popperClientRect = (0, $73d15a506b13c4bf$export$2e2bcd8739ae039)(Object.assign({}, popperRect, popperOffsets));
    var elementClientRect = elementContext === (0, $efb5382c81aaa170$export$ae5ab1c730825774) ? popperClientRect : referenceClientRect; // positive = overflowing the clipping rect
    // 0 or negative = within the clipping rect
    var overflowOffsets = {
        top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
        bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
        left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
        right: elementClientRect.right - clippingClientRect.right + paddingObject.right
    };
    var offsetData = state.modifiersData.offset; // Offsets can be applied only to the popper element
    if (elementContext === (0, $efb5382c81aaa170$export$ae5ab1c730825774) && offsetData) {
        var offset = offsetData[placement];
        Object.keys(overflowOffsets).forEach(function(key) {
            var multiply = [
                (0, $efb5382c81aaa170$export$79ffe56a765070d2),
                (0, $efb5382c81aaa170$export$40e543e69a8b3fbb)
            ].indexOf(key) >= 0 ? 1 : -1;
            var axis = [
                (0, $efb5382c81aaa170$export$1e95b668f3b82d),
                (0, $efb5382c81aaa170$export$40e543e69a8b3fbb)
            ].indexOf(key) >= 0 ? 'y' : 'x';
            overflowOffsets[key] += offset[axis] * multiply;
        });
    }
    return overflowOffsets;
}






function $b78f67f020e4c245$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, placement = _options.placement, boundary = _options.boundary, rootBoundary = _options.rootBoundary, padding = _options.padding, flipVariations = _options.flipVariations, _options$allowedAutoP = _options.allowedAutoPlacements, allowedAutoPlacements = _options$allowedAutoP === void 0 ? (0, $efb5382c81aaa170$export$803cd8101b6c182b) : _options$allowedAutoP;
    var variation = (0, $72d39783263c9619$export$2e2bcd8739ae039)(placement);
    var placements = variation ? flipVariations ? (0, $efb5382c81aaa170$export$368f9a87e87fa4e1) : (0, $efb5382c81aaa170$export$368f9a87e87fa4e1).filter(function(placement) {
        return (0, $72d39783263c9619$export$2e2bcd8739ae039)(placement) === variation;
    }) : (0, $efb5382c81aaa170$export$aec2ce47c367b8c3);
    var allowedPlacements = placements.filter(function(placement) {
        return allowedAutoPlacements.indexOf(placement) >= 0;
    });
    if (allowedPlacements.length === 0) allowedPlacements = placements;
     // $FlowFixMe[incompatible-type]: Flow seems to have problems with two array unions...
    var overflows = allowedPlacements.reduce(function(acc, placement) {
        acc[placement] = (0, $8ae8b96d9fd77b28$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding
        })[(0, $c7fb149c5a3855e3$export$2e2bcd8739ae039)(placement)];
        return acc;
    }, {});
    return Object.keys(overflows).sort(function(a, b) {
        return overflows[a] - overflows[b];
    });
}




function $b186652725a0752d$var$getExpandedFallbackPlacements(placement) {
    if ((0, $c7fb149c5a3855e3$export$2e2bcd8739ae039)(placement) === (0, $efb5382c81aaa170$export$dfb5619354ba860)) return [];
    var oppositePlacement = (0, $64e4d2853e52f2ad$export$2e2bcd8739ae039)(placement);
    return [
        (0, $787ac286ac65e788$export$2e2bcd8739ae039)(placement),
        oppositePlacement,
        (0, $787ac286ac65e788$export$2e2bcd8739ae039)(oppositePlacement)
    ];
}
function $b186652725a0752d$var$flip(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    if (state.modifiersData[name]._skip) return;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis, specifiedFallbackPlacements = options.fallbackPlacements, padding = options.padding, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, _options$flipVariatio = options.flipVariations, flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio, allowedAutoPlacements = options.allowedAutoPlacements;
    var preferredPlacement = state.options.placement;
    var basePlacement = (0, $c7fb149c5a3855e3$export$2e2bcd8739ae039)(preferredPlacement);
    var isBasePlacement = basePlacement === preferredPlacement;
    var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [
        (0, $64e4d2853e52f2ad$export$2e2bcd8739ae039)(preferredPlacement)
    ] : $b186652725a0752d$var$getExpandedFallbackPlacements(preferredPlacement));
    var placements = [
        preferredPlacement
    ].concat(fallbackPlacements).reduce(function(acc, placement) {
        return acc.concat((0, $c7fb149c5a3855e3$export$2e2bcd8739ae039)(placement) === (0, $efb5382c81aaa170$export$dfb5619354ba860) ? (0, $b78f67f020e4c245$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding,
            flipVariations: flipVariations,
            allowedAutoPlacements: allowedAutoPlacements
        }) : placement);
    }, []);
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var checksMap = new Map();
    var makeFallbackChecks = true;
    var firstFittingPlacement = placements[0];
    for(var i = 0; i < placements.length; i++){
        var placement = placements[i];
        var _basePlacement = (0, $c7fb149c5a3855e3$export$2e2bcd8739ae039)(placement);
        var isStartVariation = (0, $72d39783263c9619$export$2e2bcd8739ae039)(placement) === (0, $efb5382c81aaa170$export$b3571188c770cc5a);
        var isVertical = [
            (0, $efb5382c81aaa170$export$1e95b668f3b82d),
            (0, $efb5382c81aaa170$export$40e543e69a8b3fbb)
        ].indexOf(_basePlacement) >= 0;
        var len = isVertical ? 'width' : 'height';
        var overflow = (0, $8ae8b96d9fd77b28$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            altBoundary: altBoundary,
            padding: padding
        });
        var mainVariationSide = isVertical ? isStartVariation ? (0, $efb5382c81aaa170$export$79ffe56a765070d2) : (0, $efb5382c81aaa170$export$eabcd2c8791e7bf4) : isStartVariation ? (0, $efb5382c81aaa170$export$40e543e69a8b3fbb) : (0, $efb5382c81aaa170$export$1e95b668f3b82d);
        if (referenceRect[len] > popperRect[len]) mainVariationSide = (0, $64e4d2853e52f2ad$export$2e2bcd8739ae039)(mainVariationSide);
        var altVariationSide = (0, $64e4d2853e52f2ad$export$2e2bcd8739ae039)(mainVariationSide);
        var checks = [];
        if (checkMainAxis) checks.push(overflow[_basePlacement] <= 0);
        if (checkAltAxis) checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
        if (checks.every(function(check) {
            return check;
        })) {
            firstFittingPlacement = placement;
            makeFallbackChecks = false;
            break;
        }
        checksMap.set(placement, checks);
    }
    if (makeFallbackChecks) {
        // `2` may be desired in some cases – research later
        var numberOfChecks = flipVariations ? 3 : 1;
        var _loop = function _loop(_i) {
            var fittingPlacement = placements.find(function(placement) {
                var checks = checksMap.get(placement);
                if (checks) return checks.slice(0, _i).every(function(check) {
                    return check;
                });
            });
            if (fittingPlacement) {
                firstFittingPlacement = fittingPlacement;
                return "break";
            }
        };
        for(var _i = numberOfChecks; _i > 0; _i--){
            var _ret = _loop(_i);
            if (_ret === "break") break;
        }
    }
    if (state.placement !== firstFittingPlacement) {
        state.modifiersData[name]._skip = true;
        state.placement = firstFittingPlacement;
        state.reset = true;
    }
} // eslint-disable-next-line import/no-unused-modules
var $b186652725a0752d$export$2e2bcd8739ae039 = {
    name: 'flip',
    enabled: true,
    phase: 'main',
    fn: $b186652725a0752d$var$flip,
    requiresIfExists: [
        'offset'
    ],
    data: {
        _skip: false
    }
};





function $927a49b450467637$export$2e2bcd8739ae039(axis) {
    return axis === 'x' ? 'y' : 'x';
}



function $02060654084d0358$export$f28d906d67a997f3(min, value, max) {
    return (0, $a648b2d87eb6107b$export$8960430cfd85939f)(min, (0, $a648b2d87eb6107b$export$96ec731ed4dcb222)(value, max));
}
function $02060654084d0358$export$86c8af6d3ef0b4a(min, value, max) {
    var v = $02060654084d0358$export$f28d906d67a997f3(min, value, max);
    return v > max ? max : v;
}








function $07c17637be301bb1$var$preventOverflow(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, padding = options.padding, _options$tether = options.tether, tether = _options$tether === void 0 ? true : _options$tether, _options$tetherOffset = options.tetherOffset, tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
    var overflow = (0, $8ae8b96d9fd77b28$export$2e2bcd8739ae039)(state, {
        boundary: boundary,
        rootBoundary: rootBoundary,
        padding: padding,
        altBoundary: altBoundary
    });
    var basePlacement = (0, $c7fb149c5a3855e3$export$2e2bcd8739ae039)(state.placement);
    var variation = (0, $72d39783263c9619$export$2e2bcd8739ae039)(state.placement);
    var isBasePlacement = !variation;
    var mainAxis = (0, $29e733e6d8dc66a0$export$2e2bcd8739ae039)(basePlacement);
    var altAxis = (0, $927a49b450467637$export$2e2bcd8739ae039)(mainAxis);
    var popperOffsets = state.modifiersData.popperOffsets;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var tetherOffsetValue = typeof tetherOffset === 'function' ? tetherOffset(Object.assign({}, state.rects, {
        placement: state.placement
    })) : tetherOffset;
    var normalizedTetherOffsetValue = typeof tetherOffsetValue === 'number' ? {
        mainAxis: tetherOffsetValue,
        altAxis: tetherOffsetValue
    } : Object.assign({
        mainAxis: 0,
        altAxis: 0
    }, tetherOffsetValue);
    var offsetModifierState = state.modifiersData.offset ? state.modifiersData.offset[state.placement] : null;
    var data = {
        x: 0,
        y: 0
    };
    if (!popperOffsets) return;
    if (checkMainAxis) {
        var _offsetModifierState$;
        var mainSide = mainAxis === 'y' ? (0, $efb5382c81aaa170$export$1e95b668f3b82d) : (0, $efb5382c81aaa170$export$eabcd2c8791e7bf4);
        var altSide = mainAxis === 'y' ? (0, $efb5382c81aaa170$export$40e543e69a8b3fbb) : (0, $efb5382c81aaa170$export$79ffe56a765070d2);
        var len = mainAxis === 'y' ? 'height' : 'width';
        var offset = popperOffsets[mainAxis];
        var min = offset + overflow[mainSide];
        var max = offset - overflow[altSide];
        var additive = tether ? -popperRect[len] / 2 : 0;
        var minLen = variation === (0, $efb5382c81aaa170$export$b3571188c770cc5a) ? referenceRect[len] : popperRect[len];
        var maxLen = variation === (0, $efb5382c81aaa170$export$b3571188c770cc5a) ? -popperRect[len] : -referenceRect[len]; // We need to include the arrow in the calculation so the arrow doesn't go
        // outside the reference bounds
        var arrowElement = state.elements.arrow;
        var arrowRect = tether && arrowElement ? (0, $446da4420f84bd5e$export$2e2bcd8739ae039)(arrowElement) : {
            width: 0,
            height: 0
        };
        var arrowPaddingObject = state.modifiersData['arrow#persistent'] ? state.modifiersData['arrow#persistent'].padding : (0, $49aa9deab310a37f$export$2e2bcd8739ae039)();
        var arrowPaddingMin = arrowPaddingObject[mainSide];
        var arrowPaddingMax = arrowPaddingObject[altSide]; // If the reference length is smaller than the arrow length, we don't want
        // to include its full size in the calculation. If the reference is small
        // and near the edge of a boundary, the popper can overflow even if the
        // reference is not overflowing as well (e.g. virtual elements with no
        // width or height)
        var arrowLen = (0, $02060654084d0358$export$f28d906d67a997f3)(0, referenceRect[len], arrowRect[len]);
        var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis : minLen - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis;
        var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis : maxLen + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis;
        var arrowOffsetParent = state.elements.arrow && (0, $f37189b3639e250b$export$2e2bcd8739ae039)(state.elements.arrow);
        var clientOffset = arrowOffsetParent ? mainAxis === 'y' ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
        var offsetModifierValue = (_offsetModifierState$ = offsetModifierState == null ? void 0 : offsetModifierState[mainAxis]) != null ? _offsetModifierState$ : 0;
        var tetherMin = offset + minOffset - offsetModifierValue - clientOffset;
        var tetherMax = offset + maxOffset - offsetModifierValue;
        var preventedOffset = (0, $02060654084d0358$export$f28d906d67a997f3)(tether ? (0, $a648b2d87eb6107b$export$96ec731ed4dcb222)(min, tetherMin) : min, offset, tether ? (0, $a648b2d87eb6107b$export$8960430cfd85939f)(max, tetherMax) : max);
        popperOffsets[mainAxis] = preventedOffset;
        data[mainAxis] = preventedOffset - offset;
    }
    if (checkAltAxis) {
        var _offsetModifierState$2;
        var _mainSide = mainAxis === 'x' ? (0, $efb5382c81aaa170$export$1e95b668f3b82d) : (0, $efb5382c81aaa170$export$eabcd2c8791e7bf4);
        var _altSide = mainAxis === 'x' ? (0, $efb5382c81aaa170$export$40e543e69a8b3fbb) : (0, $efb5382c81aaa170$export$79ffe56a765070d2);
        var _offset = popperOffsets[altAxis];
        var _len = altAxis === 'y' ? 'height' : 'width';
        var _min = _offset + overflow[_mainSide];
        var _max = _offset - overflow[_altSide];
        var isOriginSide = [
            (0, $efb5382c81aaa170$export$1e95b668f3b82d),
            (0, $efb5382c81aaa170$export$eabcd2c8791e7bf4)
        ].indexOf(basePlacement) !== -1;
        var _offsetModifierValue = (_offsetModifierState$2 = offsetModifierState == null ? void 0 : offsetModifierState[altAxis]) != null ? _offsetModifierState$2 : 0;
        var _tetherMin = isOriginSide ? _min : _offset - referenceRect[_len] - popperRect[_len] - _offsetModifierValue + normalizedTetherOffsetValue.altAxis;
        var _tetherMax = isOriginSide ? _offset + referenceRect[_len] + popperRect[_len] - _offsetModifierValue - normalizedTetherOffsetValue.altAxis : _max;
        var _preventedOffset = tether && isOriginSide ? (0, $02060654084d0358$export$86c8af6d3ef0b4a)(_tetherMin, _offset, _tetherMax) : (0, $02060654084d0358$export$f28d906d67a997f3)(tether ? _tetherMin : _min, _offset, tether ? _tetherMax : _max);
        popperOffsets[altAxis] = _preventedOffset;
        data[altAxis] = _preventedOffset - _offset;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $07c17637be301bb1$export$2e2bcd8739ae039 = {
    name: 'preventOverflow',
    enabled: true,
    phase: 'main',
    fn: $07c17637be301bb1$var$preventOverflow,
    requiresIfExists: [
        'offset'
    ]
};











var $7e80c9989e060a56$var$toPaddingObject = function toPaddingObject(padding, state) {
    padding = typeof padding === 'function' ? padding(Object.assign({}, state.rects, {
        placement: state.placement
    })) : padding;
    return (0, $5ff53f1e92af6255$export$2e2bcd8739ae039)(typeof padding !== 'number' ? padding : (0, $58cc7bf892210b21$export$2e2bcd8739ae039)(padding, (0, $efb5382c81aaa170$export$aec2ce47c367b8c3)));
};
function $7e80c9989e060a56$var$arrow(_ref) {
    var _state$modifiersData$;
    var state = _ref.state, name = _ref.name, options = _ref.options;
    var arrowElement = state.elements.arrow;
    var popperOffsets = state.modifiersData.popperOffsets;
    var basePlacement = (0, $c7fb149c5a3855e3$export$2e2bcd8739ae039)(state.placement);
    var axis = (0, $29e733e6d8dc66a0$export$2e2bcd8739ae039)(basePlacement);
    var isVertical = [
        (0, $efb5382c81aaa170$export$eabcd2c8791e7bf4),
        (0, $efb5382c81aaa170$export$79ffe56a765070d2)
    ].indexOf(basePlacement) >= 0;
    var len = isVertical ? 'height' : 'width';
    if (!arrowElement || !popperOffsets) return;
    var paddingObject = $7e80c9989e060a56$var$toPaddingObject(options.padding, state);
    var arrowRect = (0, $446da4420f84bd5e$export$2e2bcd8739ae039)(arrowElement);
    var minProp = axis === 'y' ? (0, $efb5382c81aaa170$export$1e95b668f3b82d) : (0, $efb5382c81aaa170$export$eabcd2c8791e7bf4);
    var maxProp = axis === 'y' ? (0, $efb5382c81aaa170$export$40e543e69a8b3fbb) : (0, $efb5382c81aaa170$export$79ffe56a765070d2);
    var endDiff = state.rects.reference[len] + state.rects.reference[axis] - popperOffsets[axis] - state.rects.popper[len];
    var startDiff = popperOffsets[axis] - state.rects.reference[axis];
    var arrowOffsetParent = (0, $f37189b3639e250b$export$2e2bcd8739ae039)(arrowElement);
    var clientSize = arrowOffsetParent ? axis === 'y' ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
    var centerToReference = endDiff / 2 - startDiff / 2; // Make sure the arrow doesn't overflow the popper if the center point is
    // outside of the popper bounds
    var min = paddingObject[minProp];
    var max = clientSize - arrowRect[len] - paddingObject[maxProp];
    var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
    var offset = (0, $02060654084d0358$export$f28d906d67a997f3)(min, center, max); // Prevents breaking syntax highlighting...
    var axisProp = axis;
    state.modifiersData[name] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset, _state$modifiersData$.centerOffset = offset - center, _state$modifiersData$);
}
function $7e80c9989e060a56$var$effect(_ref2) {
    var state = _ref2.state, options = _ref2.options;
    var _options$element = options.element, arrowElement = _options$element === void 0 ? '[data-popper-arrow]' : _options$element;
    if (arrowElement == null) return;
     // CSS selector
    if (typeof arrowElement === 'string') {
        arrowElement = state.elements.popper.querySelector(arrowElement);
        if (!arrowElement) return;
    }
    if (!(0, $58b2c9496045651d$export$2e2bcd8739ae039)(state.elements.popper, arrowElement)) return;
    state.elements.arrow = arrowElement;
} // eslint-disable-next-line import/no-unused-modules
var $7e80c9989e060a56$export$2e2bcd8739ae039 = {
    name: 'arrow',
    enabled: true,
    phase: 'main',
    fn: $7e80c9989e060a56$var$arrow,
    effect: $7e80c9989e060a56$var$effect,
    requires: [
        'popperOffsets'
    ],
    requiresIfExists: [
        'preventOverflow'
    ]
};




function $30ea82620d911a65$var$getSideOffsets(overflow, rect, preventedOffsets) {
    if (preventedOffsets === void 0) preventedOffsets = {
        x: 0,
        y: 0
    };
    return {
        top: overflow.top - rect.height - preventedOffsets.y,
        right: overflow.right - rect.width + preventedOffsets.x,
        bottom: overflow.bottom - rect.height + preventedOffsets.y,
        left: overflow.left - rect.width - preventedOffsets.x
    };
}
function $30ea82620d911a65$var$isAnySideFullyClipped(overflow) {
    return [
        (0, $efb5382c81aaa170$export$1e95b668f3b82d),
        (0, $efb5382c81aaa170$export$79ffe56a765070d2),
        (0, $efb5382c81aaa170$export$40e543e69a8b3fbb),
        (0, $efb5382c81aaa170$export$eabcd2c8791e7bf4)
    ].some(function(side) {
        return overflow[side] >= 0;
    });
}
function $30ea82620d911a65$var$hide(_ref) {
    var state = _ref.state, name = _ref.name;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var preventedOffsets = state.modifiersData.preventOverflow;
    var referenceOverflow = (0, $8ae8b96d9fd77b28$export$2e2bcd8739ae039)(state, {
        elementContext: 'reference'
    });
    var popperAltOverflow = (0, $8ae8b96d9fd77b28$export$2e2bcd8739ae039)(state, {
        altBoundary: true
    });
    var referenceClippingOffsets = $30ea82620d911a65$var$getSideOffsets(referenceOverflow, referenceRect);
    var popperEscapeOffsets = $30ea82620d911a65$var$getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
    var isReferenceHidden = $30ea82620d911a65$var$isAnySideFullyClipped(referenceClippingOffsets);
    var hasPopperEscaped = $30ea82620d911a65$var$isAnySideFullyClipped(popperEscapeOffsets);
    state.modifiersData[name] = {
        referenceClippingOffsets: referenceClippingOffsets,
        popperEscapeOffsets: popperEscapeOffsets,
        isReferenceHidden: isReferenceHidden,
        hasPopperEscaped: hasPopperEscaped
    };
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        'data-popper-reference-hidden': isReferenceHidden,
        'data-popper-escaped': hasPopperEscaped
    });
} // eslint-disable-next-line import/no-unused-modules
var $30ea82620d911a65$export$2e2bcd8739ae039 = {
    name: 'hide',
    enabled: true,
    phase: 'main',
    requiresIfExists: [
        'preventOverflow'
    ],
    fn: $30ea82620d911a65$var$hide
};




var $33c8a04aeb9011f9$export$d34966752335dd47 = [
    (0, $2000633d5b236d6d$export$2e2bcd8739ae039),
    (0, $59aaebe45f10b31a$export$2e2bcd8739ae039),
    (0, $a064d43b2317d513$export$2e2bcd8739ae039),
    (0, $f9a32ceb825091fe$export$2e2bcd8739ae039),
    (0, $f4e8c51424a17a32$export$2e2bcd8739ae039),
    (0, $b186652725a0752d$export$2e2bcd8739ae039),
    (0, $07c17637be301bb1$export$2e2bcd8739ae039),
    (0, $7e80c9989e060a56$export$2e2bcd8739ae039),
    (0, $30ea82620d911a65$export$2e2bcd8739ae039)
];
var $33c8a04aeb9011f9$export$8f7491d57c8f97a9 = /*#__PURE__*/ (0, $9da309eeb9a6ad0d$export$ed5e13716264f202)({
    defaultModifiers: $33c8a04aeb9011f9$export$d34966752335dd47
}); // eslint-disable-next-line import/no-unused-modules




var $3e4LV = parcelRequire("3e4LV");



var $i8nzj = parcelRequire("i8nzj");

var $1kRHf = parcelRequire("1kRHf");
function $0ea6454a6b4eda3b$export$1b69b6cd0fa638a1(slot) {
    return (0, $1kRHf.default)('MuiPopper', slot);
}
const $0ea6454a6b4eda3b$var$popperClasses = (0, $i8nzj.default)('MuiPopper', [
    'root'
]);
var $0ea6454a6b4eda3b$export$2e2bcd8739ae039 = $0ea6454a6b4eda3b$var$popperClasses;



var $9wx12 = parcelRequire("9wx12");
'use client';
const $d09a384d356a1576$var$_excluded = [
    "anchorEl",
    "children",
    "direction",
    "disablePortal",
    "modifiers",
    "open",
    "placement",
    "popperOptions",
    "popperRef",
    "slotProps",
    "slots",
    "TransitionProps",
    "ownerState"
], $d09a384d356a1576$var$_excluded2 = [
    "anchorEl",
    "children",
    "container",
    "direction",
    "disablePortal",
    "keepMounted",
    "modifiers",
    "open",
    "placement",
    "popperOptions",
    "popperRef",
    "style",
    "transition",
    "slotProps",
    "slots"
];
function $d09a384d356a1576$var$flipPlacement(placement, direction) {
    if (direction === 'ltr') return placement;
    switch(placement){
        case 'bottom-end':
            return 'bottom-start';
        case 'bottom-start':
            return 'bottom-end';
        case 'top-end':
            return 'top-start';
        case 'top-start':
            return 'top-end';
        default:
            return placement;
    }
}
function $d09a384d356a1576$var$resolveAnchorEl(anchorEl) {
    return typeof anchorEl === 'function' ? anchorEl() : anchorEl;
}
function $d09a384d356a1576$var$isHTMLElement(element) {
    return element.nodeType !== undefined;
}
function $d09a384d356a1576$var$isVirtualElement(element) {
    return !$d09a384d356a1576$var$isHTMLElement(element);
}
const $d09a384d356a1576$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ]
    };
    return (0, $3e4LV.default)(slots, (0, $0ea6454a6b4eda3b$export$1b69b6cd0fa638a1), classes);
};
const $d09a384d356a1576$var$defaultPopperOptions = {};
const $d09a384d356a1576$var$PopperTooltip = /*#__PURE__*/ $gJYWc.forwardRef(function PopperTooltip(props, forwardedRef) {
    var _slots$root;
    const { anchorEl: anchorEl, children: children, direction: direction, disablePortal: disablePortal, modifiers: modifiers, open: open, placement: initialPlacement, popperOptions: popperOptions, popperRef: popperRefProp, slotProps: slotProps = {}, slots: slots = {}, TransitionProps: TransitionProps } = props, other = (0, $cTAWX.default)(props, $d09a384d356a1576$var$_excluded);
    const tooltipRef = $gJYWc.useRef(null);
    const ownRef = (0, $4gWBK.default)(tooltipRef, forwardedRef);
    const popperRef = $gJYWc.useRef(null);
    const handlePopperRef = (0, $4gWBK.default)(popperRef, popperRefProp);
    const handlePopperRefRef = $gJYWc.useRef(handlePopperRef);
    (0, $4z2O6.default)(()=>{
        handlePopperRefRef.current = handlePopperRef;
    }, [
        handlePopperRef
    ]);
    $gJYWc.useImperativeHandle(popperRefProp, ()=>popperRef.current, []);
    const rtlPlacement = $d09a384d356a1576$var$flipPlacement(initialPlacement, direction);
    /**
   * placement initialized from prop but can change during lifetime if modifiers.flip.
   * modifiers.flip is essentially a flip for controlled/uncontrolled behavior
   */ const [placement, setPlacement] = $gJYWc.useState(rtlPlacement);
    const [resolvedAnchorElement, setResolvedAnchorElement] = $gJYWc.useState($d09a384d356a1576$var$resolveAnchorEl(anchorEl));
    $gJYWc.useEffect(()=>{
        if (popperRef.current) popperRef.current.forceUpdate();
    });
    $gJYWc.useEffect(()=>{
        if (anchorEl) setResolvedAnchorElement($d09a384d356a1576$var$resolveAnchorEl(anchorEl));
    }, [
        anchorEl
    ]);
    (0, $4z2O6.default)(()=>{
        if (!resolvedAnchorElement || !open) return undefined;
        const handlePopperUpdate = (data)=>{
            setPlacement(data.placement);
        };
        let popperModifiers = [
            {
                name: 'preventOverflow',
                options: {
                    altBoundary: disablePortal
                }
            },
            {
                name: 'flip',
                options: {
                    altBoundary: disablePortal
                }
            },
            {
                name: 'onUpdate',
                enabled: true,
                phase: 'afterWrite',
                fn: ({ state: state })=>{
                    handlePopperUpdate(state);
                }
            }
        ];
        if (modifiers != null) popperModifiers = popperModifiers.concat(modifiers);
        if (popperOptions && popperOptions.modifiers != null) popperModifiers = popperModifiers.concat(popperOptions.modifiers);
        const popper = (0, $33c8a04aeb9011f9$export$8f7491d57c8f97a9)(resolvedAnchorElement, tooltipRef.current, (0, $3VnFq.default)({
            placement: rtlPlacement
        }, popperOptions, {
            modifiers: popperModifiers
        }));
        handlePopperRefRef.current(popper);
        return ()=>{
            popper.destroy();
            handlePopperRefRef.current(null);
        };
    }, [
        resolvedAnchorElement,
        disablePortal,
        modifiers,
        open,
        popperOptions,
        rtlPlacement
    ]);
    const childProps = {
        placement: placement
    };
    if (TransitionProps !== null) childProps.TransitionProps = TransitionProps;
    const classes = $d09a384d356a1576$var$useUtilityClasses(props);
    const Root = (_slots$root = slots.root) != null ? _slots$root : 'div';
    const rootProps = (0, $2f70e5a04f888acc$export$2e2bcd8739ae039)({
        elementType: Root,
        externalSlotProps: slotProps.root,
        externalForwardedProps: other,
        additionalProps: {
            role: 'tooltip',
            ref: ownRef
        },
        ownerState: props,
        className: classes.root
    });
    return /*#__PURE__*/ (0, $9wx12.jsx)(Root, (0, $3VnFq.default)({}, rootProps, {
        children: typeof children === 'function' ? children(childProps) : children
    }));
});
/**
 * @ignore - internal component.
 */ const $d09a384d356a1576$var$Popper = /*#__PURE__*/ $gJYWc.forwardRef(function Popper(props, forwardedRef) {
    const { anchorEl: anchorEl, children: children, container: containerProp, direction: direction = 'ltr', disablePortal: disablePortal = false, keepMounted: keepMounted = false, modifiers: modifiers, open: open, placement: placement = 'bottom', popperOptions: popperOptions = $d09a384d356a1576$var$defaultPopperOptions, popperRef: popperRef, style: style, transition: transition = false, slotProps: slotProps = {}, slots: slots = {} } = props, other = (0, $cTAWX.default)(props, $d09a384d356a1576$var$_excluded2);
    const [exited, setExited] = $gJYWc.useState(true);
    const handleEnter = ()=>{
        setExited(false);
    };
    const handleExited = ()=>{
        setExited(true);
    };
    if (!keepMounted && !open && (!transition || exited)) return null;
    // If the container prop is provided, use that
    // If the anchorEl prop is provided, use its parent body element as the container
    // If neither are provided let the Modal take care of choosing the container
    let container;
    if (containerProp) container = containerProp;
    else if (anchorEl) {
        const resolvedAnchorEl = $d09a384d356a1576$var$resolveAnchorEl(anchorEl);
        container = resolvedAnchorEl && $d09a384d356a1576$var$isHTMLElement(resolvedAnchorEl) ? (0, $1c0f680786bc49ff$export$2e2bcd8739ae039)(resolvedAnchorEl).body : (0, $1c0f680786bc49ff$export$2e2bcd8739ae039)(null).body;
    }
    const display = !open && keepMounted && (!transition || exited) ? 'none' : undefined;
    const transitionProps = transition ? {
        in: open,
        onEnter: handleEnter,
        onExited: handleExited
    } : undefined;
    return /*#__PURE__*/ (0, $9wx12.jsx)((0, $5e1b47cd36bb0590$export$2e2bcd8739ae039), {
        disablePortal: disablePortal,
        container: container,
        children: /*#__PURE__*/ (0, $9wx12.jsx)($d09a384d356a1576$var$PopperTooltip, (0, $3VnFq.default)({
            anchorEl: anchorEl,
            direction: direction,
            disablePortal: disablePortal,
            modifiers: modifiers,
            ref: forwardedRef,
            open: transition ? !exited : open,
            placement: placement,
            popperOptions: popperOptions,
            popperRef: popperRef,
            slotProps: slotProps,
            slots: slots
        }, other, {
            style: (0, $3VnFq.default)({
                // Prevents scroll issue, waiting for Popper.js to add this style once initiated.
                position: 'fixed',
                // Fix Popper.js display issue
                top: 0,
                left: 0,
                display: display
            }, style),
            TransitionProps: transitionProps,
            children: children
        }))
    });
});
var $d09a384d356a1576$export$2e2bcd8739ae039 = $d09a384d356a1576$var$Popper;



var $HGmne = parcelRequire("HGmne");

var $8pLcn = parcelRequire("8pLcn");

var $9wx12 = parcelRequire("9wx12");
'use client';
const $2d51cb80e36e4740$var$_excluded = [
    "anchorEl",
    "component",
    "components",
    "componentsProps",
    "container",
    "disablePortal",
    "keepMounted",
    "modifiers",
    "open",
    "placement",
    "popperOptions",
    "popperRef",
    "transition",
    "slots",
    "slotProps"
];
const $2d51cb80e36e4740$var$PopperRoot = (0, $HGmne.default)((0, $d09a384d356a1576$export$2e2bcd8739ae039), {
    name: 'MuiPopper',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})({});
/**
 *
 * Demos:
 *
 * - [Autocomplete](https://mui.com/material-ui/react-autocomplete/)
 * - [Menu](https://mui.com/material-ui/react-menu/)
 * - [Popper](https://mui.com/material-ui/react-popper/)
 *
 * API:
 *
 * - [Popper API](https://mui.com/material-ui/api/popper/)
 */ const $2d51cb80e36e4740$var$Popper = /*#__PURE__*/ $gJYWc.forwardRef(function Popper(inProps, ref) {
    var _slots$root;
    const theme = (0, (/*@__PURE__*/$parcel$interopDefault($10eca53e8d6234ae$exports)))();
    const props = (0, $8pLcn.useDefaultProps)({
        props: inProps,
        name: 'MuiPopper'
    });
    const { anchorEl: anchorEl, component: component, components: components, componentsProps: componentsProps, container: container, disablePortal: disablePortal, keepMounted: keepMounted, modifiers: modifiers, open: open, placement: placement, popperOptions: popperOptions, popperRef: popperRef, transition: transition, slots: slots, slotProps: slotProps } = props, other = (0, $cTAWX.default)(props, $2d51cb80e36e4740$var$_excluded);
    const RootComponent = (_slots$root = slots == null ? void 0 : slots.root) != null ? _slots$root : components == null ? void 0 : components.Root;
    const otherProps = (0, $3VnFq.default)({
        anchorEl: anchorEl,
        container: container,
        disablePortal: disablePortal,
        keepMounted: keepMounted,
        modifiers: modifiers,
        open: open,
        placement: placement,
        popperOptions: popperOptions,
        popperRef: popperRef,
        transition: transition
    }, other);
    return /*#__PURE__*/ (0, $9wx12.jsx)($2d51cb80e36e4740$var$PopperRoot, (0, $3VnFq.default)({
        as: component,
        direction: theme == null ? void 0 : theme.direction,
        slots: {
            root: RootComponent
        },
        slotProps: slotProps != null ? slotProps : componentsProps
    }, otherProps, {
        ref: ref
    }));
});
var $2d51cb80e36e4740$export$2e2bcd8739ae039 = $2d51cb80e36e4740$var$Popper;




var $3e4LV = parcelRequire("3e4LV");
var $92UcI = parcelRequire("92UcI");
var $4gWBK = parcelRequire("4gWBK");

var $HGmne = parcelRequire("HGmne");

var $1kRHf = parcelRequire("1kRHf");
var $i8nzj = parcelRequire("i8nzj");
function $70c6460fe0e7a2be$export$5519b4d4bf80ce6f(slot) {
    return (0, $1kRHf.default)('MuiPickersPopper', slot);
}
const $70c6460fe0e7a2be$export$46e9184c9b1af0ce = (0, $i8nzj.default)('MuiPickersPopper', [
    'root',
    'paper'
]);


/* Use it instead of .includes method for IE support */ function $870e97cd00438bdc$export$22012a5c726bef55(array, itemOrItems) {
    if (Array.isArray(itemOrItems)) return itemOrItems.every((item)=>array.indexOf(item) !== -1);
    return array.indexOf(itemOrItems) !== -1;
}
const $870e97cd00438bdc$export$4467fe8634707c85 = (innerFn, externalEvent)=>(event)=>{
        if (event.key === 'Enter' || event.key === ' ') {
            innerFn(event);
            // prevent any side effects
            event.preventDefault();
            event.stopPropagation();
        }
        if (externalEvent) externalEvent(event);
    };
const $870e97cd00438bdc$export$2e03bc8dde24716b = (fn)=>{
    setTimeout(fn, 0);
};
const $870e97cd00438bdc$export$cd4e5573fbe2b576 = (root = document)=>{
    const activeEl = root.activeElement;
    if (!activeEl) return null;
    if (activeEl.shadowRoot) return $870e97cd00438bdc$export$cd4e5573fbe2b576(activeEl.shadowRoot);
    return activeEl;
};
const $870e97cd00438bdc$export$9ae5b19305db48ce = '@media (pointer: fine)';



const $63fcfcb91f1a0bc4$var$PREFERS_REDUCED_MOTION = '@media (prefers-reduced-motion: reduce)';
// detect if user agent has Android version < 10 or iOS version < 13
const $63fcfcb91f1a0bc4$var$mobileVersionMatches = typeof navigator !== 'undefined' && navigator.userAgent.match(/android\s(\d+)|OS\s(\d+)/i);
const $63fcfcb91f1a0bc4$var$androidVersion = $63fcfcb91f1a0bc4$var$mobileVersionMatches && $63fcfcb91f1a0bc4$var$mobileVersionMatches[1] ? parseInt($63fcfcb91f1a0bc4$var$mobileVersionMatches[1], 10) : null;
const $63fcfcb91f1a0bc4$var$iOSVersion = $63fcfcb91f1a0bc4$var$mobileVersionMatches && $63fcfcb91f1a0bc4$var$mobileVersionMatches[2] ? parseInt($63fcfcb91f1a0bc4$var$mobileVersionMatches[2], 10) : null;
const $63fcfcb91f1a0bc4$export$7e3b2a595fb375e5 = $63fcfcb91f1a0bc4$var$androidVersion && $63fcfcb91f1a0bc4$var$androidVersion < 10 || $63fcfcb91f1a0bc4$var$iOSVersion && $63fcfcb91f1a0bc4$var$iOSVersion < 13 || false;
const $63fcfcb91f1a0bc4$export$ce40fb97be7f02d9 = ()=>{
    const prefersReduced = (0, $94c6dc53e4570cec$export$2e2bcd8739ae039)($63fcfcb91f1a0bc4$var$PREFERS_REDUCED_MOTION, {
        defaultMatches: false
    });
    return prefersReduced || $63fcfcb91f1a0bc4$export$7e3b2a595fb375e5;
};



var $9wx12 = parcelRequire("9wx12");
const $5e2d3439b72ffd70$var$_excluded = [
    "PaperComponent",
    "popperPlacement",
    "ownerState",
    "children",
    "paperSlotProps",
    "paperClasses",
    "onPaperClick",
    "onPaperTouchStart"
];
const $5e2d3439b72ffd70$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ],
        paper: [
            'paper'
        ]
    };
    return (0, $3e4LV.default)(slots, (0, $70c6460fe0e7a2be$export$5519b4d4bf80ce6f), classes);
};
const $5e2d3439b72ffd70$var$PickersPopperRoot = (0, $HGmne.default)((0, $2d51cb80e36e4740$export$2e2bcd8739ae039), {
    name: 'MuiPickersPopper',
    slot: 'Root',
    overridesResolver: (_, styles)=>styles.root
})(({ theme: theme })=>({
        zIndex: theme.zIndex.modal
    }));
const $5e2d3439b72ffd70$var$PickersPopperPaper = (0, $HGmne.default)((0, $db3ddac601361ae3$export$2e2bcd8739ae039), {
    name: 'MuiPickersPopper',
    slot: 'Paper',
    overridesResolver: (_, styles)=>styles.paper
})(({ ownerState: ownerState })=>(0, $3VnFq.default)({
        outline: 0,
        transformOrigin: 'top center'
    }, ownerState.placement.includes('top') && {
        transformOrigin: 'bottom center'
    }));
function $5e2d3439b72ffd70$var$clickedRootScrollbar(event, doc) {
    return doc.documentElement.clientWidth < event.clientX || doc.documentElement.clientHeight < event.clientY;
}
/**
 * Based on @mui/material/ClickAwayListener without the customization.
 * We can probably strip away even more since children won't be portaled.
 * @param {boolean} active Only listen to clicks when the popper is opened.
 * @param {(event: MouseEvent | TouchEvent) => void} onClickAway The callback to call when clicking outside the popper.
 * @returns {Array} The ref and event handler to listen to the outside clicks.
 */ function $5e2d3439b72ffd70$var$useClickAwayListener(active, onClickAway) {
    const movedRef = $gJYWc.useRef(false);
    const syntheticEventRef = $gJYWc.useRef(false);
    const nodeRef = $gJYWc.useRef(null);
    const activatedRef = $gJYWc.useRef(false);
    $gJYWc.useEffect(()=>{
        if (!active) return undefined;
        // Ensure that this hook is not "activated" synchronously.
        // https://github.com/facebook/react/issues/20074
        function armClickAwayListener() {
            activatedRef.current = true;
        }
        document.addEventListener('mousedown', armClickAwayListener, true);
        document.addEventListener('touchstart', armClickAwayListener, true);
        return ()=>{
            document.removeEventListener('mousedown', armClickAwayListener, true);
            document.removeEventListener('touchstart', armClickAwayListener, true);
            activatedRef.current = false;
        };
    }, [
        active
    ]);
    // The handler doesn't take event.defaultPrevented into account:
    //
    // event.preventDefault() is meant to stop default behaviors like
    // clicking a checkbox to check it, hitting a button to submit a form,
    // and hitting left arrow to move the cursor in a text input etc.
    // Only special HTML elements have these default behaviors.
    const handleClickAway = (0, $92UcI.default)((event)=>{
        if (!activatedRef.current) return;
        // Given developers can stop the propagation of the synthetic event,
        // we can only be confident with a positive value.
        const insideReactTree = syntheticEventRef.current;
        syntheticEventRef.current = false;
        const doc = (0, $1c0f680786bc49ff$export$2e2bcd8739ae039)(nodeRef.current);
        // 1. IE11 support, which trigger the handleClickAway even after the unbind
        // 2. The child might render null.
        // 3. Behave like a blur listener.
        if (!nodeRef.current || // is a TouchEvent?
        'clientX' in event && $5e2d3439b72ffd70$var$clickedRootScrollbar(event, doc)) return;
        // Do not act if user performed touchmove
        if (movedRef.current) {
            movedRef.current = false;
            return;
        }
        let insideDOM;
        // If not enough, can use https://github.com/DieterHolvoet/event-propagation-path/blob/master/propagationPath.js
        if (event.composedPath) insideDOM = event.composedPath().indexOf(nodeRef.current) > -1;
        else insideDOM = !doc.documentElement.contains(event.target) || nodeRef.current.contains(event.target);
        if (!insideDOM && !insideReactTree) onClickAway(event);
    });
    // Keep track of mouse/touch events that bubbled up through the portal.
    const handleSynthetic = ()=>{
        syntheticEventRef.current = true;
    };
    $gJYWc.useEffect(()=>{
        if (active) {
            const doc = (0, $1c0f680786bc49ff$export$2e2bcd8739ae039)(nodeRef.current);
            const handleTouchMove = ()=>{
                movedRef.current = true;
            };
            doc.addEventListener('touchstart', handleClickAway);
            doc.addEventListener('touchmove', handleTouchMove);
            return ()=>{
                doc.removeEventListener('touchstart', handleClickAway);
                doc.removeEventListener('touchmove', handleTouchMove);
            };
        }
        return undefined;
    }, [
        active,
        handleClickAway
    ]);
    $gJYWc.useEffect(()=>{
        // TODO This behavior is not tested automatically
        // It's unclear whether this is due to different update semantics in test (batched in act() vs discrete on click).
        // Or if this is a timing related issues due to different Transition components
        // Once we get rid of all the manual scheduling (e.g. setTimeout(update, 0)) we can revisit this code+test.
        if (active) {
            const doc = (0, $1c0f680786bc49ff$export$2e2bcd8739ae039)(nodeRef.current);
            doc.addEventListener('click', handleClickAway);
            return ()=>{
                doc.removeEventListener('click', handleClickAway);
                // cleanup `handleClickAway`
                syntheticEventRef.current = false;
            };
        }
        return undefined;
    }, [
        active,
        handleClickAway
    ]);
    return [
        nodeRef,
        handleSynthetic,
        handleSynthetic
    ];
}
const $5e2d3439b72ffd70$var$PickersPopperPaperWrapper = /*#__PURE__*/ $gJYWc.forwardRef((props, ref)=>{
    const { PaperComponent: PaperComponent, popperPlacement: popperPlacement, ownerState: inOwnerState, children: children, paperSlotProps: paperSlotProps, paperClasses: paperClasses, onPaperClick: onPaperClick, onPaperTouchStart: onPaperTouchStart } = props, other = (0, $cTAWX.default)(props, $5e2d3439b72ffd70$var$_excluded);
    const ownerState = (0, $3VnFq.default)({}, inOwnerState, {
        placement: popperPlacement
    });
    const paperProps = (0, $2082854bb194ebf1$export$2e2bcd8739ae039)({
        elementType: PaperComponent,
        externalSlotProps: paperSlotProps,
        additionalProps: {
            tabIndex: -1,
            elevation: 8,
            ref: ref
        },
        className: paperClasses,
        ownerState: ownerState
    });
    return /*#__PURE__*/ (0, $9wx12.jsx)(PaperComponent, (0, $3VnFq.default)({}, other, paperProps, {
        onClick: (event)=>{
            var _paperProps$onClick;
            onPaperClick(event);
            (_paperProps$onClick = paperProps.onClick) == null || _paperProps$onClick.call(paperProps, event);
        },
        onTouchStart: (event)=>{
            var _paperProps$onTouchSt;
            onPaperTouchStart(event);
            (_paperProps$onTouchSt = paperProps.onTouchStart) == null || _paperProps$onTouchSt.call(paperProps, event);
        },
        ownerState: ownerState,
        children: children
    }));
});
function $5e2d3439b72ffd70$export$96ce8482474de8a5(inProps) {
    var _slots$desktopTransit, _slots$desktopTrapFoc, _slots$desktopPaper, _slots$popper;
    const props = (0, $6959428021af84ce$export$2e2bcd8739ae039)({
        props: inProps,
        name: 'MuiPickersPopper'
    });
    const { anchorEl: anchorEl, children: children, containerRef: containerRef = null, shouldRestoreFocus: shouldRestoreFocus, onBlur: onBlur, onDismiss: onDismiss, open: open, role: role, placement: placement, slots: slots, slotProps: slotProps, reduceAnimations: inReduceAnimations } = props;
    $gJYWc.useEffect(()=>{
        function handleKeyDown(nativeEvent) {
            // IE11, Edge (prior to using Blink?) use 'Esc'
            if (open && (nativeEvent.key === 'Escape' || nativeEvent.key === 'Esc')) onDismiss();
        }
        document.addEventListener('keydown', handleKeyDown);
        return ()=>{
            document.removeEventListener('keydown', handleKeyDown);
        };
    }, [
        onDismiss,
        open
    ]);
    const lastFocusedElementRef = $gJYWc.useRef(null);
    $gJYWc.useEffect(()=>{
        if (role === 'tooltip' || shouldRestoreFocus && !shouldRestoreFocus()) return;
        if (open) lastFocusedElementRef.current = (0, $870e97cd00438bdc$export$cd4e5573fbe2b576)(document);
        else if (lastFocusedElementRef.current && lastFocusedElementRef.current instanceof HTMLElement) // make sure the button is flushed with updated label, before returning focus to it
        // avoids issue, where screen reader could fail to announce selected date after selection
        setTimeout(()=>{
            if (lastFocusedElementRef.current instanceof HTMLElement) lastFocusedElementRef.current.focus();
        });
    }, [
        open,
        role,
        shouldRestoreFocus
    ]);
    const [clickAwayRef, onPaperClick, onPaperTouchStart] = $5e2d3439b72ffd70$var$useClickAwayListener(open, onBlur != null ? onBlur : onDismiss);
    const paperRef = $gJYWc.useRef(null);
    const handleRef = (0, $4gWBK.default)(paperRef, containerRef);
    const handlePaperRef = (0, $4gWBK.default)(handleRef, clickAwayRef);
    const ownerState = props;
    const classes = $5e2d3439b72ffd70$var$useUtilityClasses(ownerState);
    const defaultReduceAnimations = (0, $63fcfcb91f1a0bc4$export$ce40fb97be7f02d9)();
    const reduceAnimations = inReduceAnimations != null ? inReduceAnimations : defaultReduceAnimations;
    const handleKeyDown = (event)=>{
        if (event.key === 'Escape') {
            // stop the propagation to avoid closing parent modal
            event.stopPropagation();
            onDismiss();
        }
    };
    const Transition = ((_slots$desktopTransit = slots == null ? void 0 : slots.desktopTransition) != null ? _slots$desktopTransit : reduceAnimations) ? (0, $5d4a7e2c608c4487$export$2e2bcd8739ae039) : (0, $b8a567fe6aaea15d$export$2e2bcd8739ae039);
    const FocusTrap = (_slots$desktopTrapFoc = slots == null ? void 0 : slots.desktopTrapFocus) != null ? _slots$desktopTrapFoc : (0, $535bee45e267492c$export$2e2bcd8739ae039);
    const Paper = (_slots$desktopPaper = slots == null ? void 0 : slots.desktopPaper) != null ? _slots$desktopPaper : $5e2d3439b72ffd70$var$PickersPopperPaper;
    const Popper = (_slots$popper = slots == null ? void 0 : slots.popper) != null ? _slots$popper : $5e2d3439b72ffd70$var$PickersPopperRoot;
    const popperProps = (0, $2082854bb194ebf1$export$2e2bcd8739ae039)({
        elementType: Popper,
        externalSlotProps: slotProps == null ? void 0 : slotProps.popper,
        additionalProps: {
            transition: true,
            role: role,
            open: open,
            anchorEl: anchorEl,
            placement: placement,
            onKeyDown: handleKeyDown
        },
        className: classes.root,
        ownerState: props
    });
    return /*#__PURE__*/ (0, $9wx12.jsx)(Popper, (0, $3VnFq.default)({}, popperProps, {
        children: ({ TransitionProps: TransitionProps, placement: popperPlacement })=>/*#__PURE__*/ (0, $9wx12.jsx)(FocusTrap, (0, $3VnFq.default)({
                open: open,
                disableAutoFocus: true,
                disableRestoreFocus: true,
                disableEnforceFocus: role === 'tooltip',
                isEnabled: ()=>true
            }, slotProps == null ? void 0 : slotProps.desktopTrapFocus, {
                children: /*#__PURE__*/ (0, $9wx12.jsx)(Transition, (0, $3VnFq.default)({}, TransitionProps, slotProps == null ? void 0 : slotProps.desktopTransition, {
                    children: /*#__PURE__*/ (0, $9wx12.jsx)($5e2d3439b72ffd70$var$PickersPopperPaperWrapper, {
                        PaperComponent: Paper,
                        ownerState: ownerState,
                        popperPlacement: popperPlacement,
                        ref: handlePaperRef,
                        onPaperClick: onPaperClick,
                        onPaperTouchStart: onPaperTouchStart,
                        paperClasses: classes.paper,
                        paperSlotProps: slotProps == null ? void 0 : slotProps.desktopPaper,
                        children: children
                    })
                }))
            }))
    }));
}




var $3VnFq = parcelRequire("3VnFq");

var $gJYWc = parcelRequire("gJYWc");


var $92UcI = parcelRequire("92UcI");

var $gJYWc = parcelRequire("gJYWc");
const $6cb7a97f69826121$export$7d3a09d5141ab1f4 = ({ open: open, onOpen: onOpen, onClose: onClose })=>{
    const isControllingOpenProp = $gJYWc.useRef(typeof open === 'boolean').current;
    const [openState, setIsOpenState] = $gJYWc.useState(false);
    // It is required to update inner state in useEffect in order to avoid situation when
    // Our component is not mounted yet, but `open` state is set to `true` (e.g. initially opened)
    $gJYWc.useEffect(()=>{
        if (isControllingOpenProp) {
            if (typeof open !== 'boolean') throw new Error('You must not mix controlling and uncontrolled mode for `open` prop');
            setIsOpenState(open);
        }
    }, [
        isControllingOpenProp,
        open
    ]);
    const setIsOpen = $gJYWc.useCallback((newIsOpen)=>{
        if (!isControllingOpenProp) setIsOpenState(newIsOpen);
        if (newIsOpen && onOpen) onOpen();
        if (!newIsOpen && onClose) onClose();
    }, [
        isControllingOpenProp,
        onOpen,
        onClose
    ]);
    return {
        isOpen: openState,
        setIsOpen: setIsOpen
    };
};




var $gJYWc = parcelRequire("gJYWc");

function $472026ded0a307f1$export$87fe492f99f25a20(props, validate, isSameError, defaultErrorState) {
    const { value: value, onError: onError } = props;
    const adapter = (0, $98220f21a8625472$export$4b5a24245de9f7f9)();
    const previousValidationErrorRef = $gJYWc.useRef(defaultErrorState);
    const validationError = validate({
        adapter: adapter,
        value: value,
        props: props
    });
    $gJYWc.useEffect(()=>{
        if (onError && !isSameError(validationError, previousValidationErrorRef.current)) onError(validationError, value);
        previousValidationErrorRef.current = validationError;
    }, [
        isSameError,
        onError,
        previousValidationErrorRef,
        validationError,
        value
    ]);
    return validationError;
}



var $gJYWc = parcelRequire("gJYWc");

var $92UcI = parcelRequire("92UcI");


const $666e75003bf5e8d6$export$c7e050e908c1b2bc = ({ timezone: timezoneProp, value: valueProp, defaultValue: defaultValue, onChange: onChange, valueManager: valueManager })=>{
    var _ref, _ref2;
    const utils = (0, $98220f21a8625472$export$1163b47e39508a46)();
    const firstDefaultValue = $gJYWc.useRef(defaultValue);
    const inputValue = (_ref = valueProp != null ? valueProp : firstDefaultValue.current) != null ? _ref : valueManager.emptyValue;
    const inputTimezone = $gJYWc.useMemo(()=>valueManager.getTimezone(utils, inputValue), [
        utils,
        valueManager,
        inputValue
    ]);
    const setInputTimezone = (0, $92UcI.default)((newValue)=>{
        if (inputTimezone == null) return newValue;
        return valueManager.setTimezone(utils, inputTimezone, newValue);
    });
    const timezoneToRender = (_ref2 = timezoneProp != null ? timezoneProp : inputTimezone) != null ? _ref2 : 'default';
    const valueWithTimezoneToRender = $gJYWc.useMemo(()=>valueManager.setTimezone(utils, timezoneToRender, inputValue), [
        valueManager,
        utils,
        timezoneToRender,
        inputValue
    ]);
    const handleValueChange = (0, $92UcI.default)((newValue, ...otherParams)=>{
        const newValueWithInputTimezone = setInputTimezone(newValue);
        onChange == null || onChange(newValueWithInputTimezone, ...otherParams);
    });
    return {
        value: valueWithTimezoneToRender,
        handleValueChange: handleValueChange,
        timezone: timezoneToRender
    };
};
const $666e75003bf5e8d6$export$174d749f3b4c0f49 = ({ name: name, timezone: timezoneProp, value: valueProp, defaultValue: defaultValue, onChange: onChangeProp, valueManager: valueManager })=>{
    const [valueWithInputTimezone, setValue] = (0, $778a260509dda869$export$2e2bcd8739ae039)({
        name: name,
        state: 'value',
        controlled: valueProp,
        default: defaultValue != null ? defaultValue : valueManager.emptyValue
    });
    const onChange = (0, $92UcI.default)((newValue, ...otherParams)=>{
        setValue(newValue);
        onChangeProp == null || onChangeProp(newValue, ...otherParams);
    });
    return $666e75003bf5e8d6$export$c7e050e908c1b2bc({
        timezone: timezoneProp,
        value: valueWithInputTimezone,
        defaultValue: undefined,
        onChange: onChange,
        valueManager: valueManager
    });
};


/**
 * Decide if the new value should be published
 * The published value will be passed to `onChange` if defined.
 */ const $4a49e0f5f07efb82$var$shouldPublishValue = (params)=>{
    const { action: action, hasChanged: hasChanged, dateState: dateState, isControlled: isControlled } = params;
    const isCurrentValueTheDefaultValue = !isControlled && !dateState.hasBeenModifiedSinceMount;
    // The field is responsible for only calling `onChange` when needed.
    if (action.name === 'setValueFromField') return true;
    if (action.name === 'setValueFromAction') {
        // If the component is not controlled, and the value has not been modified since the mount,
        // Then we want to publish the default value whenever the user pressed the "Accept", "Today" or "Clear" button.
        if (isCurrentValueTheDefaultValue && [
            'accept',
            'today',
            'clear'
        ].includes(action.pickerAction)) return true;
        return hasChanged(dateState.lastPublishedValue);
    }
    if (action.name === 'setValueFromView' && action.selectionState !== 'shallow') {
        // On the first view,
        // If the value is not controlled, then clicking on any value (including the one equal to `defaultValue`) should call `onChange`
        if (isCurrentValueTheDefaultValue) return true;
        return hasChanged(dateState.lastPublishedValue);
    }
    if (action.name === 'setValueFromShortcut') {
        // On the first view,
        // If the value is not controlled, then clicking on any value (including the one equal to `defaultValue`) should call `onChange`
        if (isCurrentValueTheDefaultValue) return true;
        return hasChanged(dateState.lastPublishedValue);
    }
    return false;
};
/**
 * Decide if the new value should be committed.
 * The committed value will be passed to `onAccept` if defined.
 * It will also be used as a reset target when calling the `cancel` picker action (when clicking on the "Cancel" button).
 */ const $4a49e0f5f07efb82$var$shouldCommitValue = (params)=>{
    const { action: action, hasChanged: hasChanged, dateState: dateState, isControlled: isControlled, closeOnSelect: closeOnSelect } = params;
    const isCurrentValueTheDefaultValue = !isControlled && !dateState.hasBeenModifiedSinceMount;
    if (action.name === 'setValueFromAction') {
        // If the component is not controlled, and the value has not been modified since the mount,
        // Then we want to commit the default value whenever the user pressed the "Accept", "Today" or "Clear" button.
        if (isCurrentValueTheDefaultValue && [
            'accept',
            'today',
            'clear'
        ].includes(action.pickerAction)) return true;
        return hasChanged(dateState.lastCommittedValue);
    }
    if (action.name === 'setValueFromView' && action.selectionState === 'finish' && closeOnSelect) {
        // On picker where the 1st view is also the last view,
        // If the value is not controlled, then clicking on any value (including the one equal to `defaultValue`) should call `onAccept`
        if (isCurrentValueTheDefaultValue) return true;
        return hasChanged(dateState.lastCommittedValue);
    }
    if (action.name === 'setValueFromShortcut') return action.changeImportance === 'accept' && hasChanged(dateState.lastCommittedValue);
    return false;
};
/**
 * Decide if the picker should be closed after the value is updated.
 */ const $4a49e0f5f07efb82$var$shouldClosePicker = (params)=>{
    const { action: action, closeOnSelect: closeOnSelect } = params;
    if (action.name === 'setValueFromAction') return true;
    if (action.name === 'setValueFromView') return action.selectionState === 'finish' && closeOnSelect;
    if (action.name === 'setValueFromShortcut') return action.changeImportance === 'accept';
    return false;
};
const $4a49e0f5f07efb82$export$799b22a7b7fffaa3 = ({ props: props, valueManager: valueManager, valueType: valueType, wrapperVariant: wrapperVariant, validator: validator })=>{
    const { onAccept: onAccept, onChange: onChange, value: inValue, defaultValue: inDefaultValue, closeOnSelect: closeOnSelect = wrapperVariant === 'desktop', selectedSections: selectedSectionsProp, onSelectedSectionsChange: onSelectedSectionsChange, timezone: timezoneProp } = props;
    const { current: defaultValue } = $gJYWc.useRef(inDefaultValue);
    const { current: isControlled } = $gJYWc.useRef(inValue !== undefined);
    /* eslint-enable react-hooks/rules-of-hooks, react-hooks/exhaustive-deps */ const utils = (0, $98220f21a8625472$export$1163b47e39508a46)();
    const adapter = (0, $98220f21a8625472$export$4b5a24245de9f7f9)();
    const [selectedSections, setSelectedSections] = (0, $778a260509dda869$export$2e2bcd8739ae039)({
        controlled: selectedSectionsProp,
        default: null,
        name: 'usePickerValue',
        state: 'selectedSections'
    });
    const { isOpen: isOpen, setIsOpen: setIsOpen } = (0, $6cb7a97f69826121$export$7d3a09d5141ab1f4)(props);
    const [dateState, setDateState] = $gJYWc.useState(()=>{
        let initialValue;
        if (inValue !== undefined) initialValue = inValue;
        else if (defaultValue !== undefined) initialValue = defaultValue;
        else initialValue = valueManager.emptyValue;
        return {
            draft: initialValue,
            lastPublishedValue: initialValue,
            lastCommittedValue: initialValue,
            lastControlledValue: inValue,
            hasBeenModifiedSinceMount: false
        };
    });
    const { timezone: timezone, handleValueChange: handleValueChange } = (0, $666e75003bf5e8d6$export$c7e050e908c1b2bc)({
        timezone: timezoneProp,
        value: inValue,
        defaultValue: defaultValue,
        onChange: onChange,
        valueManager: valueManager
    });
    (0, $472026ded0a307f1$export$87fe492f99f25a20)((0, $3VnFq.default)({}, props, {
        value: dateState.draft,
        timezone: timezone
    }), validator, valueManager.isSameError, valueManager.defaultErrorState);
    const updateDate = (0, $92UcI.default)((action)=>{
        const updaterParams = {
            action: action,
            dateState: dateState,
            hasChanged: (comparison)=>!valueManager.areValuesEqual(utils, action.value, comparison),
            isControlled: isControlled,
            closeOnSelect: closeOnSelect
        };
        const shouldPublish = $4a49e0f5f07efb82$var$shouldPublishValue(updaterParams);
        const shouldCommit = $4a49e0f5f07efb82$var$shouldCommitValue(updaterParams);
        const shouldClose = $4a49e0f5f07efb82$var$shouldClosePicker(updaterParams);
        setDateState((prev)=>(0, $3VnFq.default)({}, prev, {
                draft: action.value,
                lastPublishedValue: shouldPublish ? action.value : prev.lastPublishedValue,
                lastCommittedValue: shouldCommit ? action.value : prev.lastCommittedValue,
                hasBeenModifiedSinceMount: true
            }));
        if (shouldPublish) {
            const validationError = action.name === 'setValueFromField' ? action.context.validationError : validator({
                adapter: adapter,
                value: action.value,
                props: (0, $3VnFq.default)({}, props, {
                    value: action.value,
                    timezone: timezone
                })
            });
            const context = {
                validationError: validationError
            };
            // TODO v7: Remove 2nd condition
            if (action.name === 'setValueFromShortcut' && action.shortcut != null) context.shortcut = action.shortcut;
            handleValueChange(action.value, context);
        }
        if (shouldCommit && onAccept) onAccept(action.value);
        if (shouldClose) setIsOpen(false);
    });
    if (inValue !== undefined && (dateState.lastControlledValue === undefined || !valueManager.areValuesEqual(utils, dateState.lastControlledValue, inValue))) {
        const isUpdateComingFromPicker = valueManager.areValuesEqual(utils, dateState.draft, inValue);
        setDateState((prev)=>(0, $3VnFq.default)({}, prev, {
                lastControlledValue: inValue
            }, isUpdateComingFromPicker ? {} : {
                lastCommittedValue: inValue,
                lastPublishedValue: inValue,
                draft: inValue,
                hasBeenModifiedSinceMount: true
            }));
    }
    const handleClear = (0, $92UcI.default)(()=>{
        updateDate({
            value: valueManager.emptyValue,
            name: 'setValueFromAction',
            pickerAction: 'clear'
        });
    });
    const handleAccept = (0, $92UcI.default)(()=>{
        updateDate({
            value: dateState.lastPublishedValue,
            name: 'setValueFromAction',
            pickerAction: 'accept'
        });
    });
    const handleDismiss = (0, $92UcI.default)(()=>{
        updateDate({
            value: dateState.lastPublishedValue,
            name: 'setValueFromAction',
            pickerAction: 'dismiss'
        });
    });
    const handleCancel = (0, $92UcI.default)(()=>{
        updateDate({
            value: dateState.lastCommittedValue,
            name: 'setValueFromAction',
            pickerAction: 'cancel'
        });
    });
    const handleSetToday = (0, $92UcI.default)(()=>{
        updateDate({
            value: valueManager.getTodayValue(utils, timezone, valueType),
            name: 'setValueFromAction',
            pickerAction: 'today'
        });
    });
    const handleOpen = (0, $92UcI.default)(()=>setIsOpen(true));
    const handleClose = (0, $92UcI.default)(()=>setIsOpen(false));
    const handleChange = (0, $92UcI.default)((newValue, selectionState = 'partial')=>updateDate({
            name: 'setValueFromView',
            value: newValue,
            selectionState: selectionState
        }));
    // TODO v7: Make changeImportance and label mandatory.
    const handleSelectShortcut = (0, $92UcI.default)((newValue, changeImportance, shortcut)=>updateDate({
            name: 'setValueFromShortcut',
            value: newValue,
            changeImportance: changeImportance != null ? changeImportance : 'accept',
            shortcut: shortcut
        }));
    const handleChangeFromField = (0, $92UcI.default)((newValue, context)=>updateDate({
            name: 'setValueFromField',
            value: newValue,
            context: context
        }));
    const handleFieldSelectedSectionsChange = (0, $92UcI.default)((newSelectedSections)=>{
        setSelectedSections(newSelectedSections);
        onSelectedSectionsChange == null || onSelectedSectionsChange(newSelectedSections);
    });
    const actions = {
        onClear: handleClear,
        onAccept: handleAccept,
        onDismiss: handleDismiss,
        onCancel: handleCancel,
        onSetToday: handleSetToday,
        onOpen: handleOpen,
        onClose: handleClose
    };
    const fieldResponse = {
        value: dateState.draft,
        onChange: handleChangeFromField,
        selectedSections: selectedSections,
        onSelectedSectionsChange: handleFieldSelectedSectionsChange
    };
    const viewValue = $gJYWc.useMemo(()=>valueManager.cleanValue(utils, dateState.draft), [
        utils,
        valueManager,
        dateState.draft
    ]);
    const viewResponse = {
        value: viewValue,
        onChange: handleChange,
        onClose: handleClose,
        open: isOpen,
        onSelectedSectionsChange: handleFieldSelectedSectionsChange
    };
    const isValid = (testedValue)=>{
        const error = validator({
            adapter: adapter,
            value: testedValue,
            props: (0, $3VnFq.default)({}, props, {
                value: testedValue,
                timezone: timezone
            })
        });
        return !valueManager.hasError(error);
    };
    const layoutResponse = (0, $3VnFq.default)({}, actions, {
        value: viewValue,
        onChange: handleChange,
        onSelectShortcut: handleSelectShortcut,
        isValid: isValid
    });
    return {
        open: isOpen,
        fieldProps: fieldResponse,
        viewProps: viewResponse,
        layoutProps: layoutResponse,
        actions: actions
    };
};



var $3VnFq = parcelRequire("3VnFq");

var $cTAWX = parcelRequire("cTAWX");

var $gJYWc = parcelRequire("gJYWc");

var $4z2O6 = parcelRequire("4z2O6");

var $92UcI = parcelRequire("92UcI");

var $gJYWc = parcelRequire("gJYWc");

var $92UcI = parcelRequire("92UcI");

let $d3a5b60d8c1fb6e1$var$warnedOnceNotValidView = false;
function $d3a5b60d8c1fb6e1$export$9b46cba8f8ccd954({ onChange: onChange, onViewChange: onViewChange, openTo: openTo, view: inView, views: views, autoFocus: autoFocus, focusedView: inFocusedView, onFocusedViewChange: onFocusedViewChange }) {
    var _views, _views2;
    const previousOpenTo = $gJYWc.useRef(openTo);
    const previousViews = $gJYWc.useRef(views);
    const defaultView = $gJYWc.useRef(views.includes(openTo) ? openTo : views[0]);
    const [view, setView] = (0, $778a260509dda869$export$2e2bcd8739ae039)({
        name: 'useViews',
        state: 'view',
        controlled: inView,
        default: defaultView.current
    });
    const defaultFocusedView = $gJYWc.useRef(autoFocus ? view : null);
    const [focusedView, setFocusedView] = (0, $778a260509dda869$export$2e2bcd8739ae039)({
        name: 'useViews',
        state: 'focusedView',
        controlled: inFocusedView,
        default: defaultFocusedView.current
    });
    $gJYWc.useEffect(()=>{
        // Update the current view when `openTo` or `views` props change
        if (previousOpenTo.current && previousOpenTo.current !== openTo || previousViews.current && previousViews.current.some((previousView)=>!views.includes(previousView))) {
            setView(views.includes(openTo) ? openTo : views[0]);
            previousViews.current = views;
            previousOpenTo.current = openTo;
        }
    }, [
        openTo,
        setView,
        view,
        views
    ]);
    const viewIndex = views.indexOf(view);
    const previousView = (_views = views[viewIndex - 1]) != null ? _views : null;
    const nextView = (_views2 = views[viewIndex + 1]) != null ? _views2 : null;
    const handleFocusedViewChange = (0, $92UcI.default)((viewToFocus, hasFocus)=>{
        if (hasFocus) // Focus event
        setFocusedView(viewToFocus);
        else // Blur event
        setFocusedView((prevFocusedView)=>viewToFocus === prevFocusedView ? null : prevFocusedView // If false the blur is due to view switching
        );
        onFocusedViewChange == null || onFocusedViewChange(viewToFocus, hasFocus);
    });
    const handleChangeView = (0, $92UcI.default)((newView)=>{
        // always keep the focused view in sync
        handleFocusedViewChange(newView, true);
        if (newView === view) return;
        setView(newView);
        if (onViewChange) onViewChange(newView);
    });
    const goToNextView = (0, $92UcI.default)(()=>{
        if (nextView) handleChangeView(nextView);
    });
    const setValueAndGoToNextView = (0, $92UcI.default)((value, currentViewSelectionState, selectedView)=>{
        const isSelectionFinishedOnCurrentView = currentViewSelectionState === 'finish';
        const hasMoreViews = selectedView ? // handles case like `DateTimePicker`, where a view might return a `finish` selection state
        // but we it's not the final view given all `views` -> overall selection state should be `partial`.
        views.indexOf(selectedView) < views.length - 1 : Boolean(nextView);
        const globalSelectionState = isSelectionFinishedOnCurrentView && hasMoreViews ? 'partial' : currentViewSelectionState;
        onChange(value, globalSelectionState, selectedView);
        // Detects if the selected view is not the active one.
        // Can happen if multiple views are displayed, like in `DesktopDateTimePicker` or `MultiSectionDigitalClock`.
        if (selectedView && selectedView !== view) {
            const nextViewAfterSelected = views[views.indexOf(selectedView) + 1];
            if (nextViewAfterSelected) // move to next view after the selected one
            handleChangeView(nextViewAfterSelected);
        } else if (isSelectionFinishedOnCurrentView) goToNextView();
    });
    return {
        view: view,
        setView: handleChangeView,
        focusedView: focusedView,
        setFocusedView: handleFocusedViewChange,
        nextView: nextView,
        previousView: previousView,
        // Always return up to date default view instead of the initial one (i.e. defaultView.current)
        defaultView: views.includes(openTo) ? openTo : views[0],
        goToNextView: goToNextView,
        setValueAndGoToNextView: setValueAndGoToNextView
    };
}



const $98e12b0614fc3528$var$_excluded = [
    "className",
    "sx"
];
const $98e12b0614fc3528$export$c0a71b697a2df210 = ({ props: props, propsFromPickerValue: propsFromPickerValue, additionalViewProps: additionalViewProps, inputRef: inputRef, autoFocusView: autoFocusView })=>{
    const { onChange: onChange, open: open, onSelectedSectionsChange: onSelectedSectionsChange, onClose: onClose } = propsFromPickerValue;
    const { view: inView, views: views, openTo: openTo, onViewChange: onViewChange, viewRenderers: viewRenderers, timezone: timezone } = props;
    const propsToForwardToView = (0, $cTAWX.default)(props, $98e12b0614fc3528$var$_excluded);
    const { view: view, setView: setView, defaultView: defaultView, focusedView: focusedView, setFocusedView: setFocusedView, setValueAndGoToNextView: setValueAndGoToNextView } = (0, $d3a5b60d8c1fb6e1$export$9b46cba8f8ccd954)({
        view: inView,
        views: views,
        openTo: openTo,
        onChange: onChange,
        onViewChange: onViewChange,
        autoFocus: autoFocusView
    });
    const { hasUIView: hasUIView, viewModeLookup: viewModeLookup } = $gJYWc.useMemo(()=>views.reduce((acc, viewForReduce)=>{
            let viewMode;
            if (viewRenderers[viewForReduce] != null) viewMode = 'UI';
            else viewMode = 'field';
            acc.viewModeLookup[viewForReduce] = viewMode;
            if (viewMode === 'UI') acc.hasUIView = true;
            return acc;
        }, {
            hasUIView: false,
            viewModeLookup: {}
        }), [
        viewRenderers,
        views
    ]);
    const timeViewsCount = $gJYWc.useMemo(()=>views.reduce((acc, viewForReduce)=>{
            if (viewRenderers[viewForReduce] != null && (0, $ab68d4157b5096ce$export$8f04d380cefd5a0d)(viewForReduce)) return acc + 1;
            return acc;
        }, 0), [
        viewRenderers,
        views
    ]);
    const currentViewMode = viewModeLookup[view];
    const shouldRestoreFocus = (0, $92UcI.default)(()=>currentViewMode === 'UI');
    const [popperView, setPopperView] = $gJYWc.useState(currentViewMode === 'UI' ? view : null);
    if (popperView !== view && viewModeLookup[view] === 'UI') setPopperView(view);
    (0, $4z2O6.default)(()=>{
        // Handle case of `DateTimePicker` without time renderers
        if (currentViewMode === 'field' && open) {
            onClose();
            setTimeout(()=>{
                // focusing the input before the range selection is done
                // calling `onSelectedSectionsChange` outside of timeout results in an inconsistent behavior between Safari And Chrome
                inputRef == null || inputRef.current.focus();
                onSelectedSectionsChange(view);
            });
        }
    }, [
        view
    ]); // eslint-disable-line react-hooks/exhaustive-deps
    (0, $4z2O6.default)(()=>{
        if (!open) return;
        let newView = view;
        // If the current view is a field view, go to the last popper view
        if (currentViewMode === 'field' && popperView != null) newView = popperView;
        // If the current view is not the default view and both are UI views
        if (newView !== defaultView && viewModeLookup[newView] === 'UI' && viewModeLookup[defaultView] === 'UI') newView = defaultView;
        if (newView !== view) setView(newView);
        setFocusedView(newView, true);
    }, [
        open
    ]); // eslint-disable-line react-hooks/exhaustive-deps
    const layoutProps = {
        views: views,
        view: popperView,
        onViewChange: setView
    };
    return {
        hasUIView: hasUIView,
        shouldRestoreFocus: shouldRestoreFocus,
        layoutProps: layoutProps,
        renderCurrentView: ()=>{
            if (popperView == null) return null;
            const renderer = viewRenderers[popperView];
            if (renderer == null) return null;
            return renderer((0, $3VnFq.default)({}, propsToForwardToView, additionalViewProps, propsFromPickerValue, {
                views: views,
                timezone: timezone,
                onChange: setValueAndGoToNextView,
                view: popperView,
                onViewChange: setView,
                focusedView: focusedView,
                onFocusedViewChange: setFocusedView,
                showViewSwitcher: timeViewsCount > 1,
                timeViewsCount: timeViewsCount
            }));
        }
    };
};



var $3VnFq = parcelRequire("3VnFq");

var $gJYWc = parcelRequire("gJYWc");

var $4z2O6 = parcelRequire("4z2O6");

function $4f9c36cf61448725$var$getOrientation() {
    if (typeof window === 'undefined') return 'portrait';
    if (window.screen && window.screen.orientation && window.screen.orientation.angle) return Math.abs(window.screen.orientation.angle) === 90 ? 'landscape' : 'portrait';
    // Support IOS safari
    if (window.orientation) return Math.abs(Number(window.orientation)) === 90 ? 'landscape' : 'portrait';
    return 'portrait';
}
const $4f9c36cf61448725$export$6f60b24e37af6448 = (views, customOrientation)=>{
    const [orientation, setOrientation] = $gJYWc.useState($4f9c36cf61448725$var$getOrientation);
    (0, $4z2O6.default)(()=>{
        const eventHandler = ()=>{
            setOrientation($4f9c36cf61448725$var$getOrientation());
        };
        window.addEventListener('orientationchange', eventHandler);
        return ()=>{
            window.removeEventListener('orientationchange', eventHandler);
        };
    }, []);
    if ((0, $870e97cd00438bdc$export$22012a5c726bef55)(views, [
        'hours',
        'minutes',
        'seconds'
    ])) // could not display 13:34:44 in landscape mode
    return false;
    const orientationToUse = customOrientation || orientation;
    return orientationToUse === 'landscape';
};


const $b6420c33cfbf0054$export$4e5139e5825b7b27 = ({ props: props, propsFromPickerValue: propsFromPickerValue, propsFromPickerViews: propsFromPickerViews, wrapperVariant: wrapperVariant })=>{
    const { orientation: orientation } = props;
    const isLandscape = (0, $4f9c36cf61448725$export$6f60b24e37af6448)(propsFromPickerViews.views, orientation);
    const layoutProps = (0, $3VnFq.default)({}, propsFromPickerViews, propsFromPickerValue, {
        isLandscape: isLandscape,
        wrapperVariant: wrapperVariant,
        disabled: props.disabled,
        readOnly: props.readOnly
    });
    return {
        layoutProps: layoutProps
    };
};



const $a038f94f25841f0e$var$warnRenderInputIsDefined = (0, $e8329ce24b20e515$export$baf331755d84b871)([
    'The `renderInput` prop has been removed in version 6.0 of the Date and Time Pickers.',
    'You can replace it with the `textField` component slot in most cases.',
    'For more information, please have a look at the migration guide (https://mui.com/x/migration/migration-pickers-v5/#input-renderer-required-in-v5).'
]);
const $a038f94f25841f0e$export$fc3313977ac596c4 = ({ props: props, valueManager: valueManager, valueType: valueType, wrapperVariant: wrapperVariant, inputRef: inputRef, additionalViewProps: additionalViewProps, validator: validator, autoFocusView: autoFocusView })=>{
    const pickerValueResponse = (0, $4a49e0f5f07efb82$export$799b22a7b7fffaa3)({
        props: props,
        valueManager: valueManager,
        valueType: valueType,
        wrapperVariant: wrapperVariant,
        validator: validator
    });
    const pickerViewsResponse = (0, $98e12b0614fc3528$export$c0a71b697a2df210)({
        props: props,
        inputRef: inputRef,
        additionalViewProps: additionalViewProps,
        autoFocusView: autoFocusView,
        propsFromPickerValue: pickerValueResponse.viewProps
    });
    const pickerLayoutResponse = (0, $b6420c33cfbf0054$export$4e5139e5825b7b27)({
        props: props,
        wrapperVariant: wrapperVariant,
        propsFromPickerValue: pickerValueResponse.layoutProps,
        propsFromPickerViews: pickerViewsResponse.layoutProps
    });
    return {
        // Picker value
        open: pickerValueResponse.open,
        actions: pickerValueResponse.actions,
        fieldProps: pickerValueResponse.fieldProps,
        // Picker views
        renderCurrentView: pickerViewsResponse.renderCurrentView,
        hasUIView: pickerViewsResponse.hasUIView,
        shouldRestoreFocus: pickerViewsResponse.shouldRestoreFocus,
        // Picker layout
        layoutProps: pickerLayoutResponse.layoutProps
    };
};




var $gJYWc = parcelRequire("gJYWc");

var $3Zour = parcelRequire("3Zour");

var $2w6IV = parcelRequire("2w6IV");

var $HGmne = parcelRequire("HGmne");

var $3e4LV = parcelRequire("3e4LV");

var $1kRHf = parcelRequire("1kRHf");

var $i8nzj = parcelRequire("i8nzj");
function $0d29542979783564$export$1671c31de798d429(slot) {
    return (0, $1kRHf.default)('MuiPickersLayout', slot);
}
const $0d29542979783564$export$7a6dac186703fe4c = (0, $i8nzj.default)('MuiPickersLayout', [
    'root',
    'landscape',
    'contentWrapper',
    'toolbar',
    'actionBar',
    'tabs',
    'shortcuts'
]);



var $3VnFq = parcelRequire("3VnFq");
parcelRequire("gJYWc");


var $3e4LV = parcelRequire("3e4LV");

var $3VnFq = parcelRequire("3VnFq");

var $cTAWX = parcelRequire("cTAWX");
parcelRequire("gJYWc");



var $cTAWX = parcelRequire("cTAWX");

var $3VnFq = parcelRequire("3VnFq");

var $gJYWc = parcelRequire("gJYWc");


var $2w6IV = parcelRequire("2w6IV");

var $3e4LV = parcelRequire("3e4LV");

var $HGmne = parcelRequire("HGmne");

var $8pLcn = parcelRequire("8pLcn");

var $i8nzj = parcelRequire("i8nzj");

var $1kRHf = parcelRequire("1kRHf");
function $8b3a7e8e8cd15cb1$export$5e57a444791c63be(slot) {
    return (0, $1kRHf.default)('MuiDialogActions', slot);
}
const $8b3a7e8e8cd15cb1$var$dialogActionsClasses = (0, $i8nzj.default)('MuiDialogActions', [
    'root',
    'spacing'
]);
var $8b3a7e8e8cd15cb1$export$2e2bcd8739ae039 = $8b3a7e8e8cd15cb1$var$dialogActionsClasses;



var $9wx12 = parcelRequire("9wx12");
'use client';
const $12a01918017adcae$var$_excluded = [
    "className",
    "disableSpacing"
];
const $12a01918017adcae$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disableSpacing: disableSpacing } = ownerState;
    const slots = {
        root: [
            'root',
            !disableSpacing && 'spacing'
        ]
    };
    return (0, $3e4LV.default)(slots, (0, $8b3a7e8e8cd15cb1$export$5e57a444791c63be), classes);
};
const $12a01918017adcae$var$DialogActionsRoot = (0, $HGmne.default)('div', {
    name: 'MuiDialogActions',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            !ownerState.disableSpacing && styles.spacing
        ];
    }
})(({ ownerState: ownerState })=>(0, $3VnFq.default)({
        display: 'flex',
        alignItems: 'center',
        padding: 8,
        justifyContent: 'flex-end',
        flex: '0 0 auto'
    }, !ownerState.disableSpacing && {
        '& > :not(style) ~ :not(style)': {
            marginLeft: 8
        }
    }));
const $12a01918017adcae$var$DialogActions = /*#__PURE__*/ $gJYWc.forwardRef(function DialogActions(inProps, ref) {
    const props = (0, $8pLcn.useDefaultProps)({
        props: inProps,
        name: 'MuiDialogActions'
    });
    const { className: className, disableSpacing: disableSpacing = false } = props, other = (0, $cTAWX.default)(props, $12a01918017adcae$var$_excluded);
    const ownerState = (0, $3VnFq.default)({}, props, {
        disableSpacing: disableSpacing
    });
    const classes = $12a01918017adcae$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $9wx12.jsx)($12a01918017adcae$var$DialogActionsRoot, (0, $3VnFq.default)({
        className: (0, $2w6IV.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref
    }, other));
});
var $12a01918017adcae$export$2e2bcd8739ae039 = $12a01918017adcae$var$DialogActions;




var $9wx12 = parcelRequire("9wx12");
const $bc43d467da2ccead$var$_excluded = [
    "onAccept",
    "onClear",
    "onCancel",
    "onSetToday",
    "actions"
];
/**
 * Demos:
 *
 * - [Custom slots and subcomponents](https://mui.com/x/react-date-pickers/custom-components/)
 * - [Custom layout](https://mui.com/x/react-date-pickers/custom-layout/)
 *
 * API:
 *
 * - [PickersActionBar API](https://mui.com/x/api/date-pickers/pickers-action-bar/)
 */ function $bc43d467da2ccead$export$72ffda3bb7ecf665(props) {
    const { onAccept: onAccept, onClear: onClear, onCancel: onCancel, onSetToday: onSetToday, actions: actions } = props, other = (0, $cTAWX.default)(props, $bc43d467da2ccead$var$_excluded);
    const localeText = (0, $98220f21a8625472$export$24fdeaa0f591a73e)();
    if (actions == null || actions.length === 0) return null;
    const buttons = actions == null ? void 0 : actions.map((actionType)=>{
        switch(actionType){
            case 'clear':
                return /*#__PURE__*/ (0, $9wx12.jsx)((0, $95b3a1ef1ddc1e78$export$2e2bcd8739ae039), {
                    onClick: onClear,
                    children: localeText.clearButtonLabel
                }, actionType);
            case 'cancel':
                return /*#__PURE__*/ (0, $9wx12.jsx)((0, $95b3a1ef1ddc1e78$export$2e2bcd8739ae039), {
                    onClick: onCancel,
                    children: localeText.cancelButtonLabel
                }, actionType);
            case 'accept':
                return /*#__PURE__*/ (0, $9wx12.jsx)((0, $95b3a1ef1ddc1e78$export$2e2bcd8739ae039), {
                    onClick: onAccept,
                    children: localeText.okButtonLabel
                }, actionType);
            case 'today':
                return /*#__PURE__*/ (0, $9wx12.jsx)((0, $95b3a1ef1ddc1e78$export$2e2bcd8739ae039), {
                    onClick: onSetToday,
                    children: localeText.todayButtonLabel
                }, actionType);
            default:
                return null;
        }
    });
    return /*#__PURE__*/ (0, $9wx12.jsx)((0, $12a01918017adcae$export$2e2bcd8739ae039), (0, $3VnFq.default)({}, other, {
        children: buttons
    }));
}




var $3VnFq = parcelRequire("3VnFq");

var $cTAWX = parcelRequire("cTAWX");
parcelRequire("gJYWc");




const $8450780b4b9a6f99$export$3f0060ce4cc8f4d0 = 36;
const $8450780b4b9a6f99$export$dde58b009b497666 = 2;
const $8450780b4b9a6f99$export$ee46b8a74d6c94d3 = 320;
const $8450780b4b9a6f99$export$73724491020e90c7 = 280;
const $8450780b4b9a6f99$export$f2fef360e2df0cb7 = 334;
const $8450780b4b9a6f99$export$1c2eabda4acea0e4 = 232;
const $8450780b4b9a6f99$export$a462ceb9cfdb5d71 = 48;



var $9wx12 = parcelRequire("9wx12");
const $114bd763aa83ef50$var$_excluded = [
    "items",
    "changeImportance",
    "isLandscape",
    "onChange",
    "isValid"
], $114bd763aa83ef50$var$_excluded2 = [
    "getValue"
];
/**
 * Demos:
 *
 * - [Shortcuts](https://mui.com/x/react-date-pickers/shortcuts/)
 *
 * API:
 *
 * - [PickersShortcuts API](https://mui.com/x/api/date-pickers/pickers-shortcuts/)
 */ function $114bd763aa83ef50$export$8ba8fc65919fa1fe(props) {
    const { items: items, changeImportance: changeImportance, onChange: onChange, isValid: isValid } = props, other = (0, $cTAWX.default)(props, $114bd763aa83ef50$var$_excluded);
    if (items == null || items.length === 0) return null;
    const resolvedItems = items.map((_ref)=>{
        let { getValue: getValue } = _ref, item = (0, $cTAWX.default)(_ref, $114bd763aa83ef50$var$_excluded2);
        const newValue = getValue({
            isValid: isValid
        });
        return {
            label: item.label,
            onClick: ()=>{
                onChange(newValue, changeImportance, item);
            },
            disabled: !isValid(newValue)
        };
    });
    return /*#__PURE__*/ (0, $9wx12.jsx)((0, $e247548612617cb3$export$2e2bcd8739ae039), (0, $3VnFq.default)({
        dense: true,
        sx: [
            {
                maxHeight: (0, $8450780b4b9a6f99$export$f2fef360e2df0cb7),
                maxWidth: 200,
                overflow: 'auto'
            },
            ...Array.isArray(other.sx) ? other.sx : [
                other.sx
            ]
        ]
    }, other, {
        children: resolvedItems.map((item)=>{
            return /*#__PURE__*/ (0, $9wx12.jsx)((0, $fbd2d21ccc73b907$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $9wx12.jsx)((0, $d3e26472a67ba319$export$2e2bcd8739ae039), (0, $3VnFq.default)({}, item))
            }, item.label);
        })
    }));
}




var $9wx12 = parcelRequire("9wx12");
function $a47ccc33efa5e6a8$var$toolbarHasView(toolbarProps) {
    return toolbarProps.view !== null;
}
const $a47ccc33efa5e6a8$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, isLandscape: isLandscape } = ownerState;
    const slots = {
        root: [
            'root',
            isLandscape && 'landscape'
        ],
        contentWrapper: [
            'contentWrapper'
        ],
        toolbar: [
            'toolbar'
        ],
        actionBar: [
            'actionBar'
        ],
        tabs: [
            'tabs'
        ],
        landscape: [
            'landscape'
        ],
        shortcuts: [
            'shortcuts'
        ]
    };
    return (0, $3e4LV.default)(slots, (0, $0d29542979783564$export$1671c31de798d429), classes);
};
const $a47ccc33efa5e6a8$var$usePickerLayout = (props)=>{
    var _slots$actionBar, _slots$shortcuts;
    const { wrapperVariant: wrapperVariant, onAccept: onAccept, onClear: onClear, onCancel: onCancel, onSetToday: onSetToday, view: view, views: views, onViewChange: onViewChange, value: value, onChange: onChange, onSelectShortcut: onSelectShortcut, isValid: isValid, isLandscape: isLandscape, disabled: disabled, readOnly: readOnly, children: children, components: components, componentsProps: componentsProps, slots: innerSlots, slotProps: innerSlotProps } = props;
    const slots = innerSlots != null ? innerSlots : (0, $d1cac1848baa1211$export$ee17bc394843b249)(components);
    const slotProps = innerSlotProps != null ? innerSlotProps : componentsProps;
    const classes = $a47ccc33efa5e6a8$var$useUtilityClasses(props);
    // Action bar
    const ActionBar = (_slots$actionBar = slots == null ? void 0 : slots.actionBar) != null ? _slots$actionBar : (0, $bc43d467da2ccead$export$72ffda3bb7ecf665);
    const actionBarProps = (0, $2082854bb194ebf1$export$2e2bcd8739ae039)({
        elementType: ActionBar,
        externalSlotProps: slotProps == null ? void 0 : slotProps.actionBar,
        additionalProps: {
            onAccept: onAccept,
            onClear: onClear,
            onCancel: onCancel,
            onSetToday: onSetToday,
            actions: wrapperVariant === 'desktop' ? [] : [
                'cancel',
                'accept'
            ],
            className: classes.actionBar
        },
        ownerState: (0, $3VnFq.default)({}, props, {
            wrapperVariant: wrapperVariant
        })
    });
    const actionBar = /*#__PURE__*/ (0, $9wx12.jsx)(ActionBar, (0, $3VnFq.default)({}, actionBarProps));
    // Toolbar
    const Toolbar = slots == null ? void 0 : slots.toolbar;
    const toolbarProps = (0, $2082854bb194ebf1$export$2e2bcd8739ae039)({
        elementType: Toolbar,
        externalSlotProps: slotProps == null ? void 0 : slotProps.toolbar,
        additionalProps: {
            isLandscape: isLandscape,
            onChange: onChange,
            value: value,
            view: view,
            onViewChange: onViewChange,
            views: views,
            disabled: disabled,
            readOnly: readOnly,
            className: classes.toolbar
        },
        ownerState: (0, $3VnFq.default)({}, props, {
            wrapperVariant: wrapperVariant
        })
    });
    const toolbar = $a47ccc33efa5e6a8$var$toolbarHasView(toolbarProps) && !!Toolbar ? /*#__PURE__*/ (0, $9wx12.jsx)(Toolbar, (0, $3VnFq.default)({}, toolbarProps)) : null;
    // Content
    const content = children;
    // Tabs
    const Tabs = slots == null ? void 0 : slots.tabs;
    const tabs = view && Tabs ? /*#__PURE__*/ (0, $9wx12.jsx)(Tabs, (0, $3VnFq.default)({
        view: view,
        onViewChange: onViewChange,
        className: classes.tabs
    }, slotProps == null ? void 0 : slotProps.tabs)) : null;
    // Shortcuts
    const Shortcuts = (_slots$shortcuts = slots == null ? void 0 : slots.shortcuts) != null ? _slots$shortcuts : (0, $114bd763aa83ef50$export$8ba8fc65919fa1fe);
    const shortcutsProps = (0, $2082854bb194ebf1$export$2e2bcd8739ae039)({
        elementType: Shortcuts,
        externalSlotProps: slotProps == null ? void 0 : slotProps.shortcuts,
        additionalProps: {
            isValid: isValid,
            isLandscape: isLandscape,
            onChange: onSelectShortcut,
            className: classes.shortcuts
        },
        ownerState: {
            isValid: isValid,
            isLandscape: isLandscape,
            onChange: onSelectShortcut,
            className: classes.shortcuts,
            wrapperVariant: wrapperVariant
        }
    });
    const shortcuts = view && !!Shortcuts ? /*#__PURE__*/ (0, $9wx12.jsx)(Shortcuts, (0, $3VnFq.default)({}, shortcutsProps)) : null;
    return {
        toolbar: toolbar,
        content: content,
        tabs: tabs,
        actionBar: actionBar,
        shortcuts: shortcuts
    };
};
var $a47ccc33efa5e6a8$export$2e2bcd8739ae039 = $a47ccc33efa5e6a8$var$usePickerLayout;



var $9wx12 = parcelRequire("9wx12");
const $ef1e028794d25d4b$var$useUtilityClasses = (ownerState)=>{
    const { isLandscape: isLandscape, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            isLandscape && 'landscape'
        ],
        contentWrapper: [
            'contentWrapper'
        ]
    };
    return (0, $3e4LV.default)(slots, (0, $0d29542979783564$export$1671c31de798d429), classes);
};
const $ef1e028794d25d4b$export$9a9363506c13836 = (0, $HGmne.default)('div', {
    name: 'MuiPickersLayout',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})(({ theme: theme, ownerState: ownerState })=>({
        display: 'grid',
        gridAutoColumns: 'max-content auto max-content',
        gridAutoRows: 'max-content auto max-content',
        [`& .${(0, $0d29542979783564$export$7a6dac186703fe4c).toolbar}`]: ownerState.isLandscape ? {
            gridColumn: theme.direction === 'rtl' ? 3 : 1,
            gridRow: '2 / 3'
        } : {
            gridColumn: '2 / 4',
            gridRow: 1
        },
        [`.${(0, $0d29542979783564$export$7a6dac186703fe4c).shortcuts}`]: ownerState.isLandscape ? {
            gridColumn: '2 / 4',
            gridRow: 1
        } : {
            gridColumn: theme.direction === 'rtl' ? 3 : 1,
            gridRow: '2 / 3'
        },
        [`& .${(0, $0d29542979783564$export$7a6dac186703fe4c).actionBar}`]: {
            gridColumn: '1 / 4',
            gridRow: 3
        }
    }));
$ef1e028794d25d4b$export$9a9363506c13836.propTypes = {
    // ----------------------------- Warning --------------------------------
    // | These PropTypes are generated from the TypeScript type definitions |
    // | To update them edit the TypeScript types and run "yarn proptypes"  |
    // ----------------------------------------------------------------------
    as: (0, (/*@__PURE__*/$parcel$interopDefault($3Zour))).elementType,
    ownerState: (0, (/*@__PURE__*/$parcel$interopDefault($3Zour))).shape({
        isLandscape: (0, (/*@__PURE__*/$parcel$interopDefault($3Zour))).bool.isRequired
    }).isRequired,
    sx: (0, (/*@__PURE__*/$parcel$interopDefault($3Zour))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($3Zour))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($3Zour))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($3Zour))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($3Zour))).object,
            (0, (/*@__PURE__*/$parcel$interopDefault($3Zour))).bool
        ])),
        (0, (/*@__PURE__*/$parcel$interopDefault($3Zour))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($3Zour))).object
    ])
};
const $ef1e028794d25d4b$export$bc1494d918129235 = (0, $HGmne.default)('div', {
    name: 'MuiPickersLayout',
    slot: 'ContentWrapper',
    overridesResolver: (props, styles)=>styles.contentWrapper
})({
    gridColumn: 2,
    gridRow: 2,
    display: 'flex',
    flexDirection: 'column'
});
/**
 * Demos:
 *
 * - [Custom layout](https://mui.com/x/react-date-pickers/custom-layout/)
 *
 * API:
 *
 * - [PickersLayout API](https://mui.com/x/api/date-pickers/pickers-layout/)
 */ const $ef1e028794d25d4b$export$647f604ea2397c05 = function PickersLayout(inProps) {
    const props = (0, $6959428021af84ce$export$2e2bcd8739ae039)({
        props: inProps,
        name: 'MuiPickersLayout'
    });
    const { toolbar: toolbar, content: content, tabs: tabs, actionBar: actionBar, shortcuts: shortcuts } = (0, $a47ccc33efa5e6a8$export$2e2bcd8739ae039)(props);
    const { sx: sx, className: className, isLandscape: isLandscape, ref: ref, wrapperVariant: wrapperVariant } = props;
    const ownerState = props;
    const classes = $ef1e028794d25d4b$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $9wx12.jsxs)($ef1e028794d25d4b$export$9a9363506c13836, {
        ref: ref,
        sx: sx,
        className: (0, $2w6IV.default)(className, classes.root),
        ownerState: ownerState,
        children: [
            isLandscape ? shortcuts : toolbar,
            isLandscape ? toolbar : shortcuts,
            /*#__PURE__*/ (0, $9wx12.jsx)($ef1e028794d25d4b$export$bc1494d918129235, {
                className: classes.contentWrapper,
                children: wrapperVariant === 'desktop' ? /*#__PURE__*/ (0, $9wx12.jsxs)($gJYWc.Fragment, {
                    children: [
                        content,
                        tabs
                    ]
                }) : /*#__PURE__*/ (0, $9wx12.jsxs)($gJYWc.Fragment, {
                    children: [
                        tabs,
                        content
                    ]
                })
            }),
            actionBar
        ]
    });
};



var $9wx12 = parcelRequire("9wx12");
const $af0dd03ad3aebb23$var$_excluded = [
    "props",
    "getOpenDialogAriaText"
], $af0dd03ad3aebb23$var$_excluded2 = [
    "ownerState"
], $af0dd03ad3aebb23$var$_excluded3 = [
    "ownerState"
];
const $af0dd03ad3aebb23$export$b1b70bc56ac5be0e = (_ref)=>{
    var _innerSlotProps$toolb, _innerSlotProps$toolb2, _slots$inputAdornment, _slots$openPickerButt, _slots$layout;
    let { props: props, getOpenDialogAriaText: getOpenDialogAriaText } = _ref, pickerParams = (0, $cTAWX.default)(_ref, $af0dd03ad3aebb23$var$_excluded);
    const { slots: slots, slotProps: innerSlotProps, className: className, sx: sx, format: format, formatDensity: formatDensity, timezone: timezone, name: name, label: label, inputRef: inputRef, readOnly: readOnly, disabled: disabled, autoFocus: autoFocus, localeText: localeText, reduceAnimations: reduceAnimations } = props;
    const utils = (0, $98220f21a8625472$export$1163b47e39508a46)();
    const internalInputRef = $gJYWc.useRef(null);
    const containerRef = $gJYWc.useRef(null);
    const labelId = (0, $8fee44a510de4e75$export$2e2bcd8739ae039)();
    const isToolbarHidden = (_innerSlotProps$toolb = innerSlotProps == null || (_innerSlotProps$toolb2 = innerSlotProps.toolbar) == null ? void 0 : _innerSlotProps$toolb2.hidden) != null ? _innerSlotProps$toolb : false;
    const { open: open, actions: actions, hasUIView: hasUIView, layoutProps: layoutProps, renderCurrentView: renderCurrentView, shouldRestoreFocus: shouldRestoreFocus, fieldProps: pickerFieldProps } = (0, $a038f94f25841f0e$export$fc3313977ac596c4)((0, $3VnFq.default)({}, pickerParams, {
        props: props,
        inputRef: internalInputRef,
        autoFocusView: true,
        additionalViewProps: {},
        wrapperVariant: 'desktop'
    }));
    const InputAdornment = (_slots$inputAdornment = slots.inputAdornment) != null ? _slots$inputAdornment : (0, $aee6aba0933a8c2f$export$2e2bcd8739ae039);
    const _useSlotProps = (0, $2082854bb194ebf1$export$2e2bcd8739ae039)({
        elementType: InputAdornment,
        externalSlotProps: innerSlotProps == null ? void 0 : innerSlotProps.inputAdornment,
        additionalProps: {
            position: 'end'
        },
        ownerState: props
    }), inputAdornmentProps = (0, $cTAWX.default)(_useSlotProps, $af0dd03ad3aebb23$var$_excluded2);
    const OpenPickerButton = (_slots$openPickerButt = slots.openPickerButton) != null ? _slots$openPickerButt : (0, $17CRd.default);
    const _useSlotProps2 = (0, $2082854bb194ebf1$export$2e2bcd8739ae039)({
        elementType: OpenPickerButton,
        externalSlotProps: innerSlotProps == null ? void 0 : innerSlotProps.openPickerButton,
        additionalProps: {
            disabled: disabled || readOnly,
            onClick: open ? actions.onClose : actions.onOpen,
            'aria-label': getOpenDialogAriaText(pickerFieldProps.value, utils),
            edge: inputAdornmentProps.position
        },
        ownerState: props
    }), openPickerButtonProps = (0, $cTAWX.default)(_useSlotProps2, $af0dd03ad3aebb23$var$_excluded3);
    const OpenPickerIcon = slots.openPickerIcon;
    const Field = slots.field;
    const fieldProps = (0, $2082854bb194ebf1$export$2e2bcd8739ae039)({
        elementType: Field,
        externalSlotProps: innerSlotProps == null ? void 0 : innerSlotProps.field,
        additionalProps: (0, $3VnFq.default)({}, pickerFieldProps, isToolbarHidden && {
            id: labelId
        }, {
            readOnly: readOnly,
            disabled: disabled,
            className: className,
            sx: sx,
            format: format,
            formatDensity: formatDensity,
            timezone: timezone,
            label: label,
            name: name,
            autoFocus: autoFocus && !props.open,
            focused: open ? true : undefined
        }),
        ownerState: props
    });
    // TODO: Move to `useSlotProps` when https://github.com/mui/material-ui/pull/35088 will be merged
    if (hasUIView) fieldProps.InputProps = (0, $3VnFq.default)({}, fieldProps.InputProps, {
        ref: containerRef
    }, !props.disableOpenPicker && {
        [`${inputAdornmentProps.position}Adornment`]: /*#__PURE__*/ (0, $9wx12.jsx)(InputAdornment, (0, $3VnFq.default)({}, inputAdornmentProps, {
            children: /*#__PURE__*/ (0, $9wx12.jsx)(OpenPickerButton, (0, $3VnFq.default)({}, openPickerButtonProps, {
                children: /*#__PURE__*/ (0, $9wx12.jsx)(OpenPickerIcon, (0, $3VnFq.default)({}, innerSlotProps == null ? void 0 : innerSlotProps.openPickerIcon))
            }))
        }))
    });
    const slotsForField = (0, $3VnFq.default)({
        textField: slots.textField,
        clearIcon: slots.clearIcon,
        clearButton: slots.clearButton
    }, fieldProps.slots);
    const Layout = (_slots$layout = slots.layout) != null ? _slots$layout : (0, $ef1e028794d25d4b$export$647f604ea2397c05);
    const handleInputRef = (0, $4gWBK.default)(internalInputRef, fieldProps.inputRef, inputRef);
    let labelledById = labelId;
    if (isToolbarHidden) {
        if (label) labelledById = `${labelId}-label`;
        else labelledById = undefined;
    }
    const slotProps = (0, $3VnFq.default)({}, innerSlotProps, {
        toolbar: (0, $3VnFq.default)({}, innerSlotProps == null ? void 0 : innerSlotProps.toolbar, {
            titleId: labelId
        }),
        popper: (0, $3VnFq.default)({
            'aria-labelledby': labelledById
        }, innerSlotProps == null ? void 0 : innerSlotProps.popper)
    });
    const renderPicker = ()=>/*#__PURE__*/ (0, $9wx12.jsxs)((0, $38b9c61d570d1b88$export$dc45bdc734ce6f1e), {
            localeText: localeText,
            children: [
                /*#__PURE__*/ (0, $9wx12.jsx)(Field, (0, $3VnFq.default)({}, fieldProps, {
                    slots: slotsForField,
                    slotProps: slotProps,
                    inputRef: handleInputRef
                })),
                /*#__PURE__*/ (0, $9wx12.jsx)((0, $5e2d3439b72ffd70$export$96ce8482474de8a5), (0, $3VnFq.default)({
                    role: "dialog",
                    placement: "bottom-start",
                    anchorEl: containerRef.current
                }, actions, {
                    open: open,
                    slots: slots,
                    slotProps: slotProps,
                    shouldRestoreFocus: shouldRestoreFocus,
                    reduceAnimations: reduceAnimations,
                    children: /*#__PURE__*/ (0, $9wx12.jsx)(Layout, (0, $3VnFq.default)({}, layoutProps, slotProps == null ? void 0 : slotProps.layout, {
                        slots: slots,
                        slotProps: slotProps,
                        children: renderCurrentView()
                    }))
                }))
            ]
        });
    return {
        renderPicker: renderPicker
    };
};



var $ezPqr = parcelRequire("ezPqr");

var $gJYWc = parcelRequire("gJYWc");

var $9wx12 = parcelRequire("9wx12");
const $fc9c2dee5d88174c$export$ed0fe318cc298673 = (0, $ezPqr.default)(/*#__PURE__*/ (0, $9wx12.jsx)("path", {
    d: "M7 10l5 5 5-5z"
}), 'ArrowDropDown');
const $fc9c2dee5d88174c$export$8afed21ef5c2afa5 = (0, $ezPqr.default)(/*#__PURE__*/ (0, $9wx12.jsx)("path", {
    d: "M15.41 16.59L10.83 12l4.58-4.59L14 6l-6 6 6 6 1.41-1.41z"
}), 'ArrowLeft');
const $fc9c2dee5d88174c$export$9ca09caa9c849d9c = (0, $ezPqr.default)(/*#__PURE__*/ (0, $9wx12.jsx)("path", {
    d: "M8.59 16.59L13.17 12 8.59 7.41 10 6l6 6-6 6-1.41-1.41z"
}), 'ArrowRight');
const $fc9c2dee5d88174c$export$5fda1783bb83f57b = (0, $ezPqr.default)(/*#__PURE__*/ (0, $9wx12.jsx)("path", {
    d: "M17 12h-5v5h5v-5zM16 1v2H8V1H6v2H5c-1.11 0-1.99.9-1.99 2L3 19c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2h-1V1h-2zm3 18H5V8h14v11z"
}), 'Calendar');
const $fc9c2dee5d88174c$export$8099ab97743c966c = (0, $ezPqr.default)(/*#__PURE__*/ (0, $9wx12.jsxs)($gJYWc.Fragment, {
    children: [
        /*#__PURE__*/ (0, $9wx12.jsx)("path", {
            d: "M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
        }),
        /*#__PURE__*/ (0, $9wx12.jsx)("path", {
            d: "M12.5 7H11v6l5.25 3.15.75-1.23-4.5-2.67z"
        })
    ]
}), 'Clock');
const $fc9c2dee5d88174c$export$90a8eab2a2411720 = (0, $ezPqr.default)(/*#__PURE__*/ (0, $9wx12.jsx)("path", {
    d: "M9 11H7v2h2v-2zm4 0h-2v2h2v-2zm4 0h-2v2h2v-2zm2-7h-1V2h-2v2H8V2H6v2H5c-1.11 0-1.99.9-1.99 2L3 20c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 16H5V9h14v11z"
}), 'DateRange');
const $fc9c2dee5d88174c$export$7e95adcf912503e3 = (0, $ezPqr.default)(/*#__PURE__*/ (0, $9wx12.jsxs)($gJYWc.Fragment, {
    children: [
        /*#__PURE__*/ (0, $9wx12.jsx)("path", {
            d: "M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
        }),
        /*#__PURE__*/ (0, $9wx12.jsx)("path", {
            d: "M12.5 7H11v6l5.25 3.15.75-1.23-4.5-2.67z"
        })
    ]
}), 'Time');
const $fc9c2dee5d88174c$export$cefbac224a47f32 = (0, $ezPqr.default)(/*#__PURE__*/ (0, $9wx12.jsx)("path", {
    d: "M19 6.41 17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
}), 'Clear');



var $3VnFq = parcelRequire("3VnFq");

var $cTAWX = parcelRequire("cTAWX");

var $gJYWc = parcelRequire("gJYWc");


var $3VnFq = parcelRequire("3VnFq");

var $cTAWX = parcelRequire("cTAWX");

var $gJYWc = parcelRequire("gJYWc");


var $2w6IV = parcelRequire("2w6IV");

var $3e4LV = parcelRequire("3e4LV");



var $HGmne = parcelRequire("HGmne");

var $8pLcn = parcelRequire("8pLcn");

var $cTAWX = parcelRequire("cTAWX");

var $3VnFq = parcelRequire("3VnFq");

var $gJYWc = parcelRequire("gJYWc");


var $3e4LV = parcelRequire("3e4LV");

var $dvHXN = parcelRequire("dvHXN");


var $cTAWX = parcelRequire("cTAWX");

var $3VnFq = parcelRequire("3VnFq");

var $lqJfJ = parcelRequire("lqJfJ");

var $gJYWc = parcelRequire("gJYWc");


var $2w6IV = parcelRequire("2w6IV");



var $3e4LV = parcelRequire("3e4LV");


var $3VnFq = parcelRequire("3VnFq");

var $cTAWX = parcelRequire("cTAWX");

var $gJYWc = parcelRequire("gJYWc");


var $4z2O6 = parcelRequire("4z2O6");
var $92UcI = parcelRequire("92UcI");
var $4gWBK = parcelRequire("4gWBK");

var $9wx12 = parcelRequire("9wx12");
'use client';
const $3e5c7f9e66bd56b6$var$_excluded = [
    "onChange",
    "maxRows",
    "minRows",
    "style",
    "value"
];
function $3e5c7f9e66bd56b6$var$getStyleValue(value) {
    return parseInt(value, 10) || 0;
}
const $3e5c7f9e66bd56b6$var$styles = {
    shadow: {
        // Visibility needed to hide the extra text area on iPads
        visibility: 'hidden',
        // Remove from the content flow
        position: 'absolute',
        // Ignore the scrollbar width
        overflow: 'hidden',
        height: 0,
        top: 0,
        left: 0,
        // Create a new layer, increase the isolation of the computed values
        transform: 'translateZ(0)'
    }
};
function $3e5c7f9e66bd56b6$var$isObjectEmpty(object) {
    // eslint-disable-next-line
    for(const _ in object)return false;
    return true;
}
function $3e5c7f9e66bd56b6$var$isEmpty(obj) {
    return $3e5c7f9e66bd56b6$var$isObjectEmpty(obj) || obj.outerHeightStyle === 0 && !obj.overflowing;
}
/**
 *
 * Demos:
 *
 * - [Textarea Autosize](https://mui.com/material-ui/react-textarea-autosize/)
 *
 * API:
 *
 * - [TextareaAutosize API](https://mui.com/material-ui/api/textarea-autosize/)
 */ const $3e5c7f9e66bd56b6$var$TextareaAutosize = /*#__PURE__*/ $gJYWc.forwardRef(function TextareaAutosize(props, forwardedRef) {
    const { onChange: onChange, maxRows: maxRows, minRows: minRows = 1, style: style, value: value } = props, other = (0, $cTAWX.default)(props, $3e5c7f9e66bd56b6$var$_excluded);
    const { current: isControlled } = $gJYWc.useRef(value != null);
    const textareaRef = $gJYWc.useRef(null);
    const handleRef = (0, $4gWBK.default)(forwardedRef, textareaRef);
    const heightRef = $gJYWc.useRef(null);
    const hiddenTextareaRef = $gJYWc.useRef(null);
    const calculateTextareaStyles = $gJYWc.useCallback(()=>{
        const textarea = textareaRef.current;
        const hiddenTextarea = hiddenTextareaRef.current;
        if (!textarea || !hiddenTextarea) return undefined;
        const containerWindow = (0, $ba6d5d10c948f9ac$export$2e2bcd8739ae039)(textarea);
        const computedStyle = containerWindow.getComputedStyle(textarea);
        // If input's width is shrunk and it's not visible, don't sync height.
        if (computedStyle.width === '0px') return {
            outerHeightStyle: 0,
            overflowing: false
        };
        hiddenTextarea.style.width = computedStyle.width;
        hiddenTextarea.value = textarea.value || props.placeholder || 'x';
        if (hiddenTextarea.value.slice(-1) === '\n') // Certain fonts which overflow the line height will cause the textarea
        // to report a different scrollHeight depending on whether the last line
        // is empty. Make it non-empty to avoid this issue.
        hiddenTextarea.value += ' ';
        const boxSizing = computedStyle.boxSizing;
        const padding = $3e5c7f9e66bd56b6$var$getStyleValue(computedStyle.paddingBottom) + $3e5c7f9e66bd56b6$var$getStyleValue(computedStyle.paddingTop);
        const border = $3e5c7f9e66bd56b6$var$getStyleValue(computedStyle.borderBottomWidth) + $3e5c7f9e66bd56b6$var$getStyleValue(computedStyle.borderTopWidth);
        // The height of the inner content
        const innerHeight = hiddenTextarea.scrollHeight;
        // Measure height of a textarea with a single row
        hiddenTextarea.value = 'x';
        const singleRowHeight = hiddenTextarea.scrollHeight;
        // The height of the outer content
        let outerHeight = innerHeight;
        if (minRows) outerHeight = Math.max(Number(minRows) * singleRowHeight, outerHeight);
        if (maxRows) outerHeight = Math.min(Number(maxRows) * singleRowHeight, outerHeight);
        outerHeight = Math.max(outerHeight, singleRowHeight);
        // Take the box sizing into account for applying this value as a style.
        const outerHeightStyle = outerHeight + (boxSizing === 'border-box' ? padding + border : 0);
        const overflowing = Math.abs(outerHeight - innerHeight) <= 1;
        return {
            outerHeightStyle: outerHeightStyle,
            overflowing: overflowing
        };
    }, [
        maxRows,
        minRows,
        props.placeholder
    ]);
    const didHeightChange = (0, $92UcI.default)(()=>{
        const textarea = textareaRef.current;
        const textareaStyles = calculateTextareaStyles();
        if (!textarea || !textareaStyles || $3e5c7f9e66bd56b6$var$isEmpty(textareaStyles)) return false;
        const outerHeightStyle = textareaStyles.outerHeightStyle;
        return heightRef.current != null && heightRef.current !== outerHeightStyle;
    });
    const syncHeight = $gJYWc.useCallback(()=>{
        const textarea = textareaRef.current;
        const textareaStyles = calculateTextareaStyles();
        if (!textarea || !textareaStyles || $3e5c7f9e66bd56b6$var$isEmpty(textareaStyles)) return;
        const outerHeightStyle = textareaStyles.outerHeightStyle;
        if (heightRef.current !== outerHeightStyle) {
            heightRef.current = outerHeightStyle;
            textarea.style.height = `${outerHeightStyle}px`;
        }
        textarea.style.overflow = textareaStyles.overflowing ? 'hidden' : '';
    }, [
        calculateTextareaStyles
    ]);
    const frameRef = $gJYWc.useRef(-1);
    (0, $4z2O6.default)(()=>{
        const debouncedHandleResize = (0, $c4af489a164f5db3$export$2e2bcd8739ae039)(syncHeight);
        const textarea = textareaRef == null ? void 0 : textareaRef.current;
        if (!textarea) return undefined;
        const containerWindow = (0, $ba6d5d10c948f9ac$export$2e2bcd8739ae039)(textarea);
        containerWindow.addEventListener('resize', debouncedHandleResize);
        let resizeObserver;
        if (typeof ResizeObserver !== 'undefined') {
            resizeObserver = new ResizeObserver(()=>{
                if (didHeightChange()) {
                    // avoid "ResizeObserver loop completed with undelivered notifications" error
                    // by temporarily unobserving the textarea element while manipulating the height
                    // and reobserving one frame later
                    resizeObserver.unobserve(textarea);
                    cancelAnimationFrame(frameRef.current);
                    syncHeight();
                    frameRef.current = requestAnimationFrame(()=>{
                        resizeObserver.observe(textarea);
                    });
                }
            });
            resizeObserver.observe(textarea);
        }
        return ()=>{
            debouncedHandleResize.clear();
            cancelAnimationFrame(frameRef.current);
            containerWindow.removeEventListener('resize', debouncedHandleResize);
            if (resizeObserver) resizeObserver.disconnect();
        };
    }, [
        calculateTextareaStyles,
        syncHeight,
        didHeightChange
    ]);
    (0, $4z2O6.default)(()=>{
        syncHeight();
    });
    const handleChange = (event)=>{
        if (!isControlled) syncHeight();
        if (onChange) onChange(event);
    };
    return /*#__PURE__*/ (0, $9wx12.jsxs)($gJYWc.Fragment, {
        children: [
            /*#__PURE__*/ (0, $9wx12.jsx)("textarea", (0, $3VnFq.default)({
                value: value,
                onChange: handleChange,
                ref: handleRef,
                rows: minRows,
                style: style
            }, other)),
            /*#__PURE__*/ (0, $9wx12.jsx)("textarea", {
                "aria-hidden": true,
                className: props.className,
                readOnly: true,
                ref: hiddenTextareaRef,
                tabIndex: -1,
                style: (0, $3VnFq.default)({}, $3e5c7f9e66bd56b6$var$styles.shadow, style, {
                    paddingTop: 0,
                    paddingBottom: 0
                })
            })
        ]
    });
});
var $3e5c7f9e66bd56b6$export$2e2bcd8739ae039 = $3e5c7f9e66bd56b6$var$TextareaAutosize;






var $HGmne = parcelRequire("HGmne");

var $8pLcn = parcelRequire("8pLcn");

var $cVrVk = parcelRequire("cVrVk");

var $il32z = parcelRequire("il32z");


var $3VnFq = parcelRequire("3VnFq");
parcelRequire("gJYWc");

parcelRequire("gJYWc");


var $TgYhg = parcelRequire("TgYhg");


var $9wx12 = parcelRequire("9wx12");
'use client';
function $f79447e31931eb8c$var$GlobalStyles({ styles: styles, themeId: themeId, defaultTheme: defaultTheme = {} }) {
    const upperTheme = (0, $81fc44edf20e1517$export$2e2bcd8739ae039)(defaultTheme);
    const globalStyles = typeof styles === 'function' ? styles(themeId ? upperTheme[themeId] || upperTheme : upperTheme) : styles;
    return /*#__PURE__*/ (0, $9wx12.jsx)((0, $TgYhg.default), {
        styles: globalStyles
    });
}
var $f79447e31931eb8c$export$2e2bcd8739ae039 = $f79447e31931eb8c$var$GlobalStyles;



var $iNcPC = parcelRequire("iNcPC");

var $8Ho5h = parcelRequire("8Ho5h");

var $9wx12 = parcelRequire("9wx12");
'use client';
function $af57873fe48181e2$var$GlobalStyles(props) {
    return /*#__PURE__*/ (0, $9wx12.jsx)((0, $f79447e31931eb8c$export$2e2bcd8739ae039), (0, $3VnFq.default)({}, props, {
        defaultTheme: (0, $iNcPC.default),
        themeId: (0, $8Ho5h.default)
    }));
}
var $af57873fe48181e2$export$2e2bcd8739ae039 = $af57873fe48181e2$var$GlobalStyles;


// Supports determination of isControlled().
// Controlled input accepts its current value as a prop.
//
// @see https://facebook.github.io/react/docs/forms.html#controlled-components
// @param value
// @returns {boolean} true if string (including '') or number (including zero)
function $100e54cdfcc16a4b$export$96bdbc84526f3739(value) {
    return value != null && !(Array.isArray(value) && value.length === 0);
}
function $100e54cdfcc16a4b$export$d652b828d7fdeff8(obj, SSR = false) {
    return obj && ($100e54cdfcc16a4b$export$96bdbc84526f3739(obj.value) && obj.value !== '' || SSR && $100e54cdfcc16a4b$export$96bdbc84526f3739(obj.defaultValue) && obj.defaultValue !== '');
}
function $100e54cdfcc16a4b$export$1b68bdfa56faeb5d(obj) {
    return obj.startAdornment;
}



var $i8nzj = parcelRequire("i8nzj");

var $1kRHf = parcelRequire("1kRHf");
function $279b963301a4d28b$export$ef57d5c8ca2278f6(slot) {
    return (0, $1kRHf.default)('MuiInputBase', slot);
}
const $279b963301a4d28b$var$inputBaseClasses = (0, $i8nzj.default)('MuiInputBase', [
    'root',
    'formControl',
    'focused',
    'disabled',
    'adornedStart',
    'adornedEnd',
    'error',
    'sizeSmall',
    'multiline',
    'colorSecondary',
    'fullWidth',
    'hiddenLabel',
    'readOnly',
    'input',
    'inputSizeSmall',
    'inputMultiline',
    'inputTypeSearch',
    'inputAdornedStart',
    'inputAdornedEnd',
    'inputHiddenLabel'
]);
var $279b963301a4d28b$export$2e2bcd8739ae039 = $279b963301a4d28b$var$inputBaseClasses;



var $9wx12 = parcelRequire("9wx12");
'use client';
const $f1f657db6b2cf37c$var$_excluded = [
    "aria-describedby",
    "autoComplete",
    "autoFocus",
    "className",
    "color",
    "components",
    "componentsProps",
    "defaultValue",
    "disabled",
    "disableInjectingGlobalStyles",
    "endAdornment",
    "error",
    "fullWidth",
    "id",
    "inputComponent",
    "inputProps",
    "inputRef",
    "margin",
    "maxRows",
    "minRows",
    "multiline",
    "name",
    "onBlur",
    "onChange",
    "onClick",
    "onFocus",
    "onKeyDown",
    "onKeyUp",
    "placeholder",
    "readOnly",
    "renderSuffix",
    "rows",
    "size",
    "slotProps",
    "slots",
    "startAdornment",
    "type",
    "value"
];
const $f1f657db6b2cf37c$export$965edad20a84fa75 = (props, styles)=>{
    const { ownerState: ownerState } = props;
    return [
        styles.root,
        ownerState.formControl && styles.formControl,
        ownerState.startAdornment && styles.adornedStart,
        ownerState.endAdornment && styles.adornedEnd,
        ownerState.error && styles.error,
        ownerState.size === 'small' && styles.sizeSmall,
        ownerState.multiline && styles.multiline,
        ownerState.color && styles[`color${(0, $cVrVk.default)(ownerState.color)}`],
        ownerState.fullWidth && styles.fullWidth,
        ownerState.hiddenLabel && styles.hiddenLabel
    ];
};
const $f1f657db6b2cf37c$export$cf507b112810e72d = (props, styles)=>{
    const { ownerState: ownerState } = props;
    return [
        styles.input,
        ownerState.size === 'small' && styles.inputSizeSmall,
        ownerState.multiline && styles.inputMultiline,
        ownerState.type === 'search' && styles.inputTypeSearch,
        ownerState.startAdornment && styles.inputAdornedStart,
        ownerState.endAdornment && styles.inputAdornedEnd,
        ownerState.hiddenLabel && styles.inputHiddenLabel
    ];
};
const $f1f657db6b2cf37c$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, color: color, disabled: disabled, error: error, endAdornment: endAdornment, focused: focused, formControl: formControl, fullWidth: fullWidth, hiddenLabel: hiddenLabel, multiline: multiline, readOnly: readOnly, size: size, startAdornment: startAdornment, type: type } = ownerState;
    const slots = {
        root: [
            'root',
            `color${(0, $cVrVk.default)(color)}`,
            disabled && 'disabled',
            error && 'error',
            fullWidth && 'fullWidth',
            focused && 'focused',
            formControl && 'formControl',
            size && size !== 'medium' && `size${(0, $cVrVk.default)(size)}`,
            multiline && 'multiline',
            startAdornment && 'adornedStart',
            endAdornment && 'adornedEnd',
            hiddenLabel && 'hiddenLabel',
            readOnly && 'readOnly'
        ],
        input: [
            'input',
            disabled && 'disabled',
            type === 'search' && 'inputTypeSearch',
            multiline && 'inputMultiline',
            size === 'small' && 'inputSizeSmall',
            hiddenLabel && 'inputHiddenLabel',
            startAdornment && 'inputAdornedStart',
            endAdornment && 'inputAdornedEnd',
            readOnly && 'readOnly'
        ]
    };
    return (0, $3e4LV.default)(slots, (0, $279b963301a4d28b$export$ef57d5c8ca2278f6), classes);
};
const $f1f657db6b2cf37c$export$298a043133d72a38 = (0, $HGmne.default)('div', {
    name: 'MuiInputBase',
    slot: 'Root',
    overridesResolver: $f1f657db6b2cf37c$export$965edad20a84fa75
})(({ theme: theme, ownerState: ownerState })=>(0, $3VnFq.default)({}, theme.typography.body1, {
        color: (theme.vars || theme).palette.text.primary,
        lineHeight: '1.4375em',
        // 23px
        boxSizing: 'border-box',
        // Prevent padding issue with fullWidth.
        position: 'relative',
        cursor: 'text',
        display: 'inline-flex',
        alignItems: 'center',
        [`&.${(0, $279b963301a4d28b$export$2e2bcd8739ae039).disabled}`]: {
            color: (theme.vars || theme).palette.text.disabled,
            cursor: 'default'
        }
    }, ownerState.multiline && (0, $3VnFq.default)({
        padding: '4px 0 5px'
    }, ownerState.size === 'small' && {
        paddingTop: 1
    }), ownerState.fullWidth && {
        width: '100%'
    }));
const $f1f657db6b2cf37c$export$a1ad29c901026019 = (0, $HGmne.default)('input', {
    name: 'MuiInputBase',
    slot: 'Input',
    overridesResolver: $f1f657db6b2cf37c$export$cf507b112810e72d
})(({ theme: theme, ownerState: ownerState })=>{
    const light = theme.palette.mode === 'light';
    const placeholder = (0, $3VnFq.default)({
        color: 'currentColor'
    }, theme.vars ? {
        opacity: theme.vars.opacity.inputPlaceholder
    } : {
        opacity: light ? 0.42 : 0.5
    }, {
        transition: theme.transitions.create('opacity', {
            duration: theme.transitions.duration.shorter
        })
    });
    const placeholderHidden = {
        opacity: '0 !important'
    };
    const placeholderVisible = theme.vars ? {
        opacity: theme.vars.opacity.inputPlaceholder
    } : {
        opacity: light ? 0.42 : 0.5
    };
    return (0, $3VnFq.default)({
        font: 'inherit',
        letterSpacing: 'inherit',
        color: 'currentColor',
        padding: '4px 0 5px',
        border: 0,
        boxSizing: 'content-box',
        background: 'none',
        height: '1.4375em',
        // Reset 23pxthe native input line-height
        margin: 0,
        // Reset for Safari
        WebkitTapHighlightColor: 'transparent',
        display: 'block',
        // Make the flex item shrink with Firefox
        minWidth: 0,
        width: '100%',
        // Fix IE11 width issue
        animationName: 'mui-auto-fill-cancel',
        animationDuration: '10ms',
        '&::-webkit-input-placeholder': placeholder,
        '&::-moz-placeholder': placeholder,
        // Firefox 19+
        '&:-ms-input-placeholder': placeholder,
        // IE11
        '&::-ms-input-placeholder': placeholder,
        // Edge
        '&:focus': {
            outline: 0
        },
        // Reset Firefox invalid required input style
        '&:invalid': {
            boxShadow: 'none'
        },
        '&::-webkit-search-decoration': {
            // Remove the padding when type=search.
            WebkitAppearance: 'none'
        },
        // Show and hide the placeholder logic
        [`label[data-shrink=false] + .${(0, $279b963301a4d28b$export$2e2bcd8739ae039).formControl} &`]: {
            '&::-webkit-input-placeholder': placeholderHidden,
            '&::-moz-placeholder': placeholderHidden,
            // Firefox 19+
            '&:-ms-input-placeholder': placeholderHidden,
            // IE11
            '&::-ms-input-placeholder': placeholderHidden,
            // Edge
            '&:focus::-webkit-input-placeholder': placeholderVisible,
            '&:focus::-moz-placeholder': placeholderVisible,
            // Firefox 19+
            '&:focus:-ms-input-placeholder': placeholderVisible,
            // IE11
            '&:focus::-ms-input-placeholder': placeholderVisible // Edge
        },
        [`&.${(0, $279b963301a4d28b$export$2e2bcd8739ae039).disabled}`]: {
            opacity: 1,
            // Reset iOS opacity
            WebkitTextFillColor: (theme.vars || theme).palette.text.disabled // Fix opacity Safari bug
        },
        '&:-webkit-autofill': {
            animationDuration: '5000s',
            animationName: 'mui-auto-fill'
        }
    }, ownerState.size === 'small' && {
        paddingTop: 1
    }, ownerState.multiline && {
        height: 'auto',
        resize: 'none',
        padding: 0,
        paddingTop: 0
    }, ownerState.type === 'search' && {
        // Improve type search style.
        MozAppearance: 'textfield'
    });
});
const $f1f657db6b2cf37c$var$inputGlobalStyles = /*#__PURE__*/ (0, $9wx12.jsx)((0, $af57873fe48181e2$export$2e2bcd8739ae039), {
    styles: {
        '@keyframes mui-auto-fill': {
            from: {
                display: 'block'
            }
        },
        '@keyframes mui-auto-fill-cancel': {
            from: {
                display: 'block'
            }
        }
    }
});
/**
 * `InputBase` contains as few styles as possible.
 * It aims to be a simple building block for creating an input.
 * It contains a load of style reset and some state logic.
 */ const $f1f657db6b2cf37c$var$InputBase = /*#__PURE__*/ $gJYWc.forwardRef(function InputBase(inProps, ref) {
    var _slotProps$input;
    const props = (0, $8pLcn.useDefaultProps)({
        props: inProps,
        name: 'MuiInputBase'
    });
    const { 'aria-describedby': ariaDescribedby, autoComplete: autoComplete, autoFocus: autoFocus, className: className, components: components = {}, componentsProps: componentsProps = {}, defaultValue: defaultValue, disabled: disabled, disableInjectingGlobalStyles: disableInjectingGlobalStyles, endAdornment: endAdornment, fullWidth: fullWidth = false, id: id, inputComponent: inputComponent = 'input', inputProps: inputPropsProp = {}, inputRef: inputRefProp, maxRows: maxRows, minRows: minRows, multiline: multiline = false, name: name, onBlur: onBlur, onChange: onChange, onClick: onClick, onFocus: onFocus, onKeyDown: onKeyDown, onKeyUp: onKeyUp, placeholder: placeholder, readOnly: readOnly, renderSuffix: renderSuffix, rows: rows, slotProps: slotProps = {}, slots: slots = {}, startAdornment: startAdornment, type: type = 'text', value: valueProp } = props, other = (0, $cTAWX.default)(props, $f1f657db6b2cf37c$var$_excluded);
    const value = inputPropsProp.value != null ? inputPropsProp.value : valueProp;
    const { current: isControlled } = $gJYWc.useRef(value != null);
    const inputRef = $gJYWc.useRef();
    const handleInputRefWarning = $gJYWc.useCallback((instance)=>{}, []);
    const handleInputRef = (0, $il32z.default)(inputRef, inputRefProp, inputPropsProp.ref, handleInputRefWarning);
    const [focused, setFocused] = $gJYWc.useState(false);
    const muiFormControl = (0, $7d9d5024ca7b136a$export$2e2bcd8739ae039)();
    const fcs = (0, $7f6a615e712efb52$export$2e2bcd8739ae039)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            'color',
            'disabled',
            'error',
            'hiddenLabel',
            'size',
            'required',
            'filled'
        ]
    });
    fcs.focused = muiFormControl ? muiFormControl.focused : focused;
    // The blur won't fire when the disabled state is set on a focused input.
    // We need to book keep the focused state manually.
    $gJYWc.useEffect(()=>{
        if (!muiFormControl && disabled && focused) {
            setFocused(false);
            if (onBlur) onBlur();
        }
    }, [
        muiFormControl,
        disabled,
        focused,
        onBlur
    ]);
    const onFilled = muiFormControl && muiFormControl.onFilled;
    const onEmpty = muiFormControl && muiFormControl.onEmpty;
    const checkDirty = $gJYWc.useCallback((obj)=>{
        if ((0, $100e54cdfcc16a4b$export$d652b828d7fdeff8)(obj)) {
            if (onFilled) onFilled();
        } else if (onEmpty) onEmpty();
    }, [
        onFilled,
        onEmpty
    ]);
    (0, $288db5e5dece4e0b$export$2e2bcd8739ae039)(()=>{
        if (isControlled) checkDirty({
            value: value
        });
    }, [
        value,
        checkDirty,
        isControlled
    ]);
    const handleFocus = (event)=>{
        // Fix a bug with IE11 where the focus/blur events are triggered
        // while the component is disabled.
        if (fcs.disabled) {
            event.stopPropagation();
            return;
        }
        if (onFocus) onFocus(event);
        if (inputPropsProp.onFocus) inputPropsProp.onFocus(event);
        if (muiFormControl && muiFormControl.onFocus) muiFormControl.onFocus(event);
        else setFocused(true);
    };
    const handleBlur = (event)=>{
        if (onBlur) onBlur(event);
        if (inputPropsProp.onBlur) inputPropsProp.onBlur(event);
        if (muiFormControl && muiFormControl.onBlur) muiFormControl.onBlur(event);
        else setFocused(false);
    };
    const handleChange = (event, ...args)=>{
        if (!isControlled) {
            const element = event.target || inputRef.current;
            if (element == null) throw new Error((0, $lqJfJ.default)(1));
            checkDirty({
                value: element.value
            });
        }
        if (inputPropsProp.onChange) inputPropsProp.onChange(event, ...args);
        // Perform in the willUpdate
        if (onChange) onChange(event, ...args);
    };
    // Check the input state on mount, in case it was filled by the user
    // or auto filled by the browser before the hydration (for SSR).
    $gJYWc.useEffect(()=>{
        checkDirty(inputRef.current);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const handleClick = (event)=>{
        if (inputRef.current && event.currentTarget === event.target) inputRef.current.focus();
        if (onClick) onClick(event);
    };
    let InputComponent = inputComponent;
    let inputProps = inputPropsProp;
    if (multiline && InputComponent === 'input') {
        if (rows) inputProps = (0, $3VnFq.default)({
            type: undefined,
            minRows: rows,
            maxRows: rows
        }, inputProps);
        else inputProps = (0, $3VnFq.default)({
            type: undefined,
            maxRows: maxRows,
            minRows: minRows
        }, inputProps);
        InputComponent = (0, $3e5c7f9e66bd56b6$export$2e2bcd8739ae039);
    }
    const handleAutoFill = (event)=>{
        // Provide a fake value as Chrome might not let you access it for security reasons.
        checkDirty(event.animationName === 'mui-auto-fill-cancel' ? inputRef.current : {
            value: 'x'
        });
    };
    $gJYWc.useEffect(()=>{
        if (muiFormControl) muiFormControl.setAdornedStart(Boolean(startAdornment));
    }, [
        muiFormControl,
        startAdornment
    ]);
    const ownerState = (0, $3VnFq.default)({}, props, {
        color: fcs.color || 'primary',
        disabled: fcs.disabled,
        endAdornment: endAdornment,
        error: fcs.error,
        focused: fcs.focused,
        formControl: muiFormControl,
        fullWidth: fullWidth,
        hiddenLabel: fcs.hiddenLabel,
        multiline: multiline,
        size: fcs.size,
        startAdornment: startAdornment,
        type: type
    });
    const classes = $f1f657db6b2cf37c$var$useUtilityClasses(ownerState);
    const Root = slots.root || components.Root || $f1f657db6b2cf37c$export$298a043133d72a38;
    const rootProps = slotProps.root || componentsProps.root || {};
    const Input = slots.input || components.Input || $f1f657db6b2cf37c$export$a1ad29c901026019;
    inputProps = (0, $3VnFq.default)({}, inputProps, (_slotProps$input = slotProps.input) != null ? _slotProps$input : componentsProps.input);
    return /*#__PURE__*/ (0, $9wx12.jsxs)($gJYWc.Fragment, {
        children: [
            !disableInjectingGlobalStyles && $f1f657db6b2cf37c$var$inputGlobalStyles,
            /*#__PURE__*/ (0, $9wx12.jsxs)(Root, (0, $3VnFq.default)({}, rootProps, !(0, $50e7d669fe712af8$export$2e2bcd8739ae039)(Root) && {
                ownerState: (0, $3VnFq.default)({}, ownerState, rootProps.ownerState)
            }, {
                ref: ref,
                onClick: handleClick
            }, other, {
                className: (0, $2w6IV.default)(classes.root, rootProps.className, className, readOnly && 'MuiInputBase-readOnly'),
                children: [
                    startAdornment,
                    /*#__PURE__*/ (0, $9wx12.jsx)((0, $ae835169353fee9c$export$2e2bcd8739ae039).Provider, {
                        value: null,
                        children: /*#__PURE__*/ (0, $9wx12.jsx)(Input, (0, $3VnFq.default)({
                            ownerState: ownerState,
                            "aria-invalid": fcs.error,
                            "aria-describedby": ariaDescribedby,
                            autoComplete: autoComplete,
                            autoFocus: autoFocus,
                            defaultValue: defaultValue,
                            disabled: fcs.disabled,
                            id: id,
                            onAnimationStart: handleAutoFill,
                            name: name,
                            placeholder: placeholder,
                            readOnly: readOnly,
                            required: fcs.required,
                            rows: rows,
                            value: value,
                            onKeyDown: onKeyDown,
                            onKeyUp: onKeyUp,
                            type: type
                        }, inputProps, !(0, $50e7d669fe712af8$export$2e2bcd8739ae039)(Input) && {
                            as: InputComponent,
                            ownerState: (0, $3VnFq.default)({}, ownerState, inputProps.ownerState)
                        }, {
                            ref: handleInputRef,
                            className: (0, $2w6IV.default)(classes.input, inputProps.className, readOnly && 'MuiInputBase-readOnly'),
                            onBlur: handleBlur,
                            onChange: handleChange,
                            onFocus: handleFocus
                        }))
                    }),
                    endAdornment,
                    renderSuffix ? renderSuffix((0, $3VnFq.default)({}, fcs, {
                        startAdornment: startAdornment
                    })) : null
                ]
            }))
        ]
    });
});
var $f1f657db6b2cf37c$export$2e2bcd8739ae039 = $f1f657db6b2cf37c$var$InputBase;



var $HGmne = parcelRequire("HGmne");
var $8ttSm = parcelRequire("8ttSm");

var $8pLcn = parcelRequire("8pLcn");

var $3VnFq = parcelRequire("3VnFq");

var $i8nzj = parcelRequire("i8nzj");

var $1kRHf = parcelRequire("1kRHf");

function $ed982e5ca00bc433$export$cdb270390122322b(slot) {
    return (0, $1kRHf.default)('MuiInput', slot);
}
const $ed982e5ca00bc433$var$inputClasses = (0, $3VnFq.default)({}, (0, $279b963301a4d28b$export$2e2bcd8739ae039), (0, $i8nzj.default)('MuiInput', [
    'root',
    'underline',
    'input'
]));
var $ed982e5ca00bc433$export$2e2bcd8739ae039 = $ed982e5ca00bc433$var$inputClasses;




var $9wx12 = parcelRequire("9wx12");
'use client';
const $afeaec9eaf2af5ae$var$_excluded = [
    "disableUnderline",
    "components",
    "componentsProps",
    "fullWidth",
    "inputComponent",
    "multiline",
    "slotProps",
    "slots",
    "type"
];
const $afeaec9eaf2af5ae$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disableUnderline: disableUnderline } = ownerState;
    const slots = {
        root: [
            'root',
            !disableUnderline && 'underline'
        ],
        input: [
            'input'
        ]
    };
    const composedClasses = (0, $3e4LV.default)(slots, (0, $ed982e5ca00bc433$export$cdb270390122322b), classes);
    return (0, $3VnFq.default)({}, classes, composedClasses);
};
const $afeaec9eaf2af5ae$var$InputRoot = (0, $HGmne.default)((0, $f1f657db6b2cf37c$export$298a043133d72a38), {
    shouldForwardProp: (prop)=>(0, $8ttSm.default)(prop) || prop === 'classes',
    name: 'MuiInput',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            ...(0, $f1f657db6b2cf37c$export$965edad20a84fa75)(props, styles),
            !ownerState.disableUnderline && styles.underline
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>{
    const light = theme.palette.mode === 'light';
    let bottomLineColor = light ? 'rgba(0, 0, 0, 0.42)' : 'rgba(255, 255, 255, 0.7)';
    if (theme.vars) bottomLineColor = `rgba(${theme.vars.palette.common.onBackgroundChannel} / ${theme.vars.opacity.inputUnderline})`;
    return (0, $3VnFq.default)({
        position: 'relative'
    }, ownerState.formControl && {
        'label + &': {
            marginTop: 16
        }
    }, !ownerState.disableUnderline && {
        '&::after': {
            borderBottom: `2px solid ${(theme.vars || theme).palette[ownerState.color].main}`,
            left: 0,
            bottom: 0,
            // Doing the other way around crash on IE11 "''" https://github.com/cssinjs/jss/issues/242
            content: '""',
            position: 'absolute',
            right: 0,
            transform: 'scaleX(0)',
            transition: theme.transitions.create('transform', {
                duration: theme.transitions.duration.shorter,
                easing: theme.transitions.easing.easeOut
            }),
            pointerEvents: 'none' // Transparent to the hover style.
        },
        [`&.${(0, $ed982e5ca00bc433$export$2e2bcd8739ae039).focused}:after`]: {
            // translateX(0) is a workaround for Safari transform scale bug
            // See https://github.com/mui/material-ui/issues/31766
            transform: 'scaleX(1) translateX(0)'
        },
        [`&.${(0, $ed982e5ca00bc433$export$2e2bcd8739ae039).error}`]: {
            '&::before, &::after': {
                borderBottomColor: (theme.vars || theme).palette.error.main
            }
        },
        '&::before': {
            borderBottom: `1px solid ${bottomLineColor}`,
            left: 0,
            bottom: 0,
            // Doing the other way around crash on IE11 "''" https://github.com/cssinjs/jss/issues/242
            content: '"\\00a0"',
            position: 'absolute',
            right: 0,
            transition: theme.transitions.create('border-bottom-color', {
                duration: theme.transitions.duration.shorter
            }),
            pointerEvents: 'none' // Transparent to the hover style.
        },
        [`&:hover:not(.${(0, $ed982e5ca00bc433$export$2e2bcd8739ae039).disabled}, .${(0, $ed982e5ca00bc433$export$2e2bcd8739ae039).error}):before`]: {
            borderBottom: `2px solid ${(theme.vars || theme).palette.text.primary}`,
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                borderBottom: `1px solid ${bottomLineColor}`
            }
        },
        [`&.${(0, $ed982e5ca00bc433$export$2e2bcd8739ae039).disabled}:before`]: {
            borderBottomStyle: 'dotted'
        }
    });
});
const $afeaec9eaf2af5ae$var$InputInput = (0, $HGmne.default)((0, $f1f657db6b2cf37c$export$a1ad29c901026019), {
    name: 'MuiInput',
    slot: 'Input',
    overridesResolver: (0, $f1f657db6b2cf37c$export$cf507b112810e72d)
})({});
const $afeaec9eaf2af5ae$var$Input = /*#__PURE__*/ $gJYWc.forwardRef(function Input(inProps, ref) {
    var _ref, _slots$root, _ref2, _slots$input;
    const props = (0, $8pLcn.useDefaultProps)({
        props: inProps,
        name: 'MuiInput'
    });
    const { disableUnderline: disableUnderline, components: components = {}, componentsProps: componentsPropsProp, fullWidth: fullWidth = false, inputComponent: inputComponent = 'input', multiline: multiline = false, slotProps: slotProps, slots: slots = {}, type: type = 'text' } = props, other = (0, $cTAWX.default)(props, $afeaec9eaf2af5ae$var$_excluded);
    const classes = $afeaec9eaf2af5ae$var$useUtilityClasses(props);
    const ownerState = {
        disableUnderline: disableUnderline
    };
    const inputComponentsProps = {
        root: {
            ownerState: ownerState
        }
    };
    const componentsProps = (slotProps != null ? slotProps : componentsPropsProp) ? (0, $dvHXN.default)(slotProps != null ? slotProps : componentsPropsProp, inputComponentsProps) : inputComponentsProps;
    const RootSlot = (_ref = (_slots$root = slots.root) != null ? _slots$root : components.Root) != null ? _ref : $afeaec9eaf2af5ae$var$InputRoot;
    const InputSlot = (_ref2 = (_slots$input = slots.input) != null ? _slots$input : components.Input) != null ? _ref2 : $afeaec9eaf2af5ae$var$InputInput;
    return /*#__PURE__*/ (0, $9wx12.jsx)((0, $f1f657db6b2cf37c$export$2e2bcd8739ae039), (0, $3VnFq.default)({
        slots: {
            root: RootSlot,
            input: InputSlot
        },
        slotProps: componentsProps,
        fullWidth: fullWidth,
        inputComponent: inputComponent,
        multiline: multiline,
        ref: ref,
        type: type
    }, other, {
        classes: classes
    }));
});
$afeaec9eaf2af5ae$var$Input.muiName = 'Input';
var $afeaec9eaf2af5ae$export$2e2bcd8739ae039 = $afeaec9eaf2af5ae$var$Input;



var $cTAWX = parcelRequire("cTAWX");

var $3VnFq = parcelRequire("3VnFq");

var $gJYWc = parcelRequire("gJYWc");

var $dvHXN = parcelRequire("dvHXN");



var $3e4LV = parcelRequire("3e4LV");


var $HGmne = parcelRequire("HGmne");
var $8ttSm = parcelRequire("8ttSm");

var $8pLcn = parcelRequire("8pLcn");

var $3VnFq = parcelRequire("3VnFq");

var $i8nzj = parcelRequire("i8nzj");

var $1kRHf = parcelRequire("1kRHf");

function $6a6bc3c8060994e7$export$3331e419f1a48437(slot) {
    return (0, $1kRHf.default)('MuiFilledInput', slot);
}
const $6a6bc3c8060994e7$var$filledInputClasses = (0, $3VnFq.default)({}, (0, $279b963301a4d28b$export$2e2bcd8739ae039), (0, $i8nzj.default)('MuiFilledInput', [
    'root',
    'underline',
    'input'
]));
var $6a6bc3c8060994e7$export$2e2bcd8739ae039 = $6a6bc3c8060994e7$var$filledInputClasses;




var $9wx12 = parcelRequire("9wx12");
'use client';
const $ae69e2a5d495b952$var$_excluded = [
    "disableUnderline",
    "components",
    "componentsProps",
    "fullWidth",
    "hiddenLabel",
    "inputComponent",
    "multiline",
    "slotProps",
    "slots",
    "type"
];
const $ae69e2a5d495b952$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disableUnderline: disableUnderline } = ownerState;
    const slots = {
        root: [
            'root',
            !disableUnderline && 'underline'
        ],
        input: [
            'input'
        ]
    };
    const composedClasses = (0, $3e4LV.default)(slots, (0, $6a6bc3c8060994e7$export$3331e419f1a48437), classes);
    return (0, $3VnFq.default)({}, classes, composedClasses);
};
const $ae69e2a5d495b952$var$FilledInputRoot = (0, $HGmne.default)((0, $f1f657db6b2cf37c$export$298a043133d72a38), {
    shouldForwardProp: (prop)=>(0, $8ttSm.default)(prop) || prop === 'classes',
    name: 'MuiFilledInput',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            ...(0, $f1f657db6b2cf37c$export$965edad20a84fa75)(props, styles),
            !ownerState.disableUnderline && styles.underline
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>{
    var _palette;
    const light = theme.palette.mode === 'light';
    const bottomLineColor = light ? 'rgba(0, 0, 0, 0.42)' : 'rgba(255, 255, 255, 0.7)';
    const backgroundColor = light ? 'rgba(0, 0, 0, 0.06)' : 'rgba(255, 255, 255, 0.09)';
    const hoverBackground = light ? 'rgba(0, 0, 0, 0.09)' : 'rgba(255, 255, 255, 0.13)';
    const disabledBackground = light ? 'rgba(0, 0, 0, 0.12)' : 'rgba(255, 255, 255, 0.12)';
    return (0, $3VnFq.default)({
        position: 'relative',
        backgroundColor: theme.vars ? theme.vars.palette.FilledInput.bg : backgroundColor,
        borderTopLeftRadius: (theme.vars || theme).shape.borderRadius,
        borderTopRightRadius: (theme.vars || theme).shape.borderRadius,
        transition: theme.transitions.create('background-color', {
            duration: theme.transitions.duration.shorter,
            easing: theme.transitions.easing.easeOut
        }),
        '&:hover': {
            backgroundColor: theme.vars ? theme.vars.palette.FilledInput.hoverBg : hoverBackground,
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                backgroundColor: theme.vars ? theme.vars.palette.FilledInput.bg : backgroundColor
            }
        },
        [`&.${(0, $6a6bc3c8060994e7$export$2e2bcd8739ae039).focused}`]: {
            backgroundColor: theme.vars ? theme.vars.palette.FilledInput.bg : backgroundColor
        },
        [`&.${(0, $6a6bc3c8060994e7$export$2e2bcd8739ae039).disabled}`]: {
            backgroundColor: theme.vars ? theme.vars.palette.FilledInput.disabledBg : disabledBackground
        }
    }, !ownerState.disableUnderline && {
        '&::after': {
            borderBottom: `2px solid ${(_palette = (theme.vars || theme).palette[ownerState.color || 'primary']) == null ? void 0 : _palette.main}`,
            left: 0,
            bottom: 0,
            // Doing the other way around crash on IE11 "''" https://github.com/cssinjs/jss/issues/242
            content: '""',
            position: 'absolute',
            right: 0,
            transform: 'scaleX(0)',
            transition: theme.transitions.create('transform', {
                duration: theme.transitions.duration.shorter,
                easing: theme.transitions.easing.easeOut
            }),
            pointerEvents: 'none' // Transparent to the hover style.
        },
        [`&.${(0, $6a6bc3c8060994e7$export$2e2bcd8739ae039).focused}:after`]: {
            // translateX(0) is a workaround for Safari transform scale bug
            // See https://github.com/mui/material-ui/issues/31766
            transform: 'scaleX(1) translateX(0)'
        },
        [`&.${(0, $6a6bc3c8060994e7$export$2e2bcd8739ae039).error}`]: {
            '&::before, &::after': {
                borderBottomColor: (theme.vars || theme).palette.error.main
            }
        },
        '&::before': {
            borderBottom: `1px solid ${theme.vars ? `rgba(${theme.vars.palette.common.onBackgroundChannel} / ${theme.vars.opacity.inputUnderline})` : bottomLineColor}`,
            left: 0,
            bottom: 0,
            // Doing the other way around crash on IE11 "''" https://github.com/cssinjs/jss/issues/242
            content: '"\\00a0"',
            position: 'absolute',
            right: 0,
            transition: theme.transitions.create('border-bottom-color', {
                duration: theme.transitions.duration.shorter
            }),
            pointerEvents: 'none' // Transparent to the hover style.
        },
        [`&:hover:not(.${(0, $6a6bc3c8060994e7$export$2e2bcd8739ae039).disabled}, .${(0, $6a6bc3c8060994e7$export$2e2bcd8739ae039).error}):before`]: {
            borderBottom: `1px solid ${(theme.vars || theme).palette.text.primary}`
        },
        [`&.${(0, $6a6bc3c8060994e7$export$2e2bcd8739ae039).disabled}:before`]: {
            borderBottomStyle: 'dotted'
        }
    }, ownerState.startAdornment && {
        paddingLeft: 12
    }, ownerState.endAdornment && {
        paddingRight: 12
    }, ownerState.multiline && (0, $3VnFq.default)({
        padding: '25px 12px 8px'
    }, ownerState.size === 'small' && {
        paddingTop: 21,
        paddingBottom: 4
    }, ownerState.hiddenLabel && {
        paddingTop: 16,
        paddingBottom: 17
    }, ownerState.hiddenLabel && ownerState.size === 'small' && {
        paddingTop: 8,
        paddingBottom: 9
    }));
});
const $ae69e2a5d495b952$var$FilledInputInput = (0, $HGmne.default)((0, $f1f657db6b2cf37c$export$a1ad29c901026019), {
    name: 'MuiFilledInput',
    slot: 'Input',
    overridesResolver: (0, $f1f657db6b2cf37c$export$cf507b112810e72d)
})(({ theme: theme, ownerState: ownerState })=>(0, $3VnFq.default)({
        paddingTop: 25,
        paddingRight: 12,
        paddingBottom: 8,
        paddingLeft: 12
    }, !theme.vars && {
        '&:-webkit-autofill': {
            WebkitBoxShadow: theme.palette.mode === 'light' ? null : '0 0 0 100px #266798 inset',
            WebkitTextFillColor: theme.palette.mode === 'light' ? null : '#fff',
            caretColor: theme.palette.mode === 'light' ? null : '#fff',
            borderTopLeftRadius: 'inherit',
            borderTopRightRadius: 'inherit'
        }
    }, theme.vars && {
        '&:-webkit-autofill': {
            borderTopLeftRadius: 'inherit',
            borderTopRightRadius: 'inherit'
        },
        [theme.getColorSchemeSelector('dark')]: {
            '&:-webkit-autofill': {
                WebkitBoxShadow: '0 0 0 100px #266798 inset',
                WebkitTextFillColor: '#fff',
                caretColor: '#fff'
            }
        }
    }, ownerState.size === 'small' && {
        paddingTop: 21,
        paddingBottom: 4
    }, ownerState.hiddenLabel && {
        paddingTop: 16,
        paddingBottom: 17
    }, ownerState.startAdornment && {
        paddingLeft: 0
    }, ownerState.endAdornment && {
        paddingRight: 0
    }, ownerState.hiddenLabel && ownerState.size === 'small' && {
        paddingTop: 8,
        paddingBottom: 9
    }, ownerState.multiline && {
        paddingTop: 0,
        paddingBottom: 0,
        paddingLeft: 0,
        paddingRight: 0
    }));
const $ae69e2a5d495b952$var$FilledInput = /*#__PURE__*/ $gJYWc.forwardRef(function FilledInput(inProps, ref) {
    var _ref, _slots$root, _ref2, _slots$input;
    const props = (0, $8pLcn.useDefaultProps)({
        props: inProps,
        name: 'MuiFilledInput'
    });
    const { components: components = {}, componentsProps: componentsPropsProp, fullWidth: fullWidth = false, inputComponent: // declare here to prevent spreading to DOM
    inputComponent = 'input', multiline: multiline = false, slotProps: slotProps, slots: slots = {}, type: type = 'text' } = props, other = (0, $cTAWX.default)(props, $ae69e2a5d495b952$var$_excluded);
    const ownerState = (0, $3VnFq.default)({}, props, {
        fullWidth: fullWidth,
        inputComponent: inputComponent,
        multiline: multiline,
        type: type
    });
    const classes = $ae69e2a5d495b952$var$useUtilityClasses(props);
    const filledInputComponentsProps = {
        root: {
            ownerState: ownerState
        },
        input: {
            ownerState: ownerState
        }
    };
    const componentsProps = (slotProps != null ? slotProps : componentsPropsProp) ? (0, $dvHXN.default)(filledInputComponentsProps, slotProps != null ? slotProps : componentsPropsProp) : filledInputComponentsProps;
    const RootSlot = (_ref = (_slots$root = slots.root) != null ? _slots$root : components.Root) != null ? _ref : $ae69e2a5d495b952$var$FilledInputRoot;
    const InputSlot = (_ref2 = (_slots$input = slots.input) != null ? _slots$input : components.Input) != null ? _ref2 : $ae69e2a5d495b952$var$FilledInputInput;
    return /*#__PURE__*/ (0, $9wx12.jsx)((0, $f1f657db6b2cf37c$export$2e2bcd8739ae039), (0, $3VnFq.default)({
        slots: {
            root: RootSlot,
            input: InputSlot
        },
        componentsProps: componentsProps,
        fullWidth: fullWidth,
        inputComponent: inputComponent,
        multiline: multiline,
        ref: ref,
        type: type
    }, other, {
        classes: classes
    }));
});
$ae69e2a5d495b952$var$FilledInput.muiName = 'Input';
var $ae69e2a5d495b952$export$2e2bcd8739ae039 = $ae69e2a5d495b952$var$FilledInput;



var $cTAWX = parcelRequire("cTAWX");

var $3VnFq = parcelRequire("3VnFq");

var $gJYWc = parcelRequire("gJYWc");



var $3e4LV = parcelRequire("3e4LV");

var $cTAWX = parcelRequire("cTAWX");

var $3VnFq = parcelRequire("3VnFq");
parcelRequire("gJYWc");


var $HGmne = parcelRequire("HGmne");
var $8ttSm = parcelRequire("8ttSm");

var $9wx12 = parcelRequire("9wx12");
'use client';
var $a6e072faf3f75d49$var$_span;
const $a6e072faf3f75d49$var$_excluded = [
    "children",
    "classes",
    "className",
    "label",
    "notched"
];
const $a6e072faf3f75d49$var$NotchedOutlineRoot = (0, $HGmne.default)('fieldset', {
    shouldForwardProp: (0, $8ttSm.default)
})({
    textAlign: 'left',
    position: 'absolute',
    bottom: 0,
    right: 0,
    top: -5,
    left: 0,
    margin: 0,
    padding: '0 8px',
    pointerEvents: 'none',
    borderRadius: 'inherit',
    borderStyle: 'solid',
    borderWidth: 1,
    overflow: 'hidden',
    minWidth: '0%'
});
const $a6e072faf3f75d49$var$NotchedOutlineLegend = (0, $HGmne.default)('legend', {
    shouldForwardProp: (0, $8ttSm.default)
})(({ ownerState: ownerState, theme: theme })=>(0, $3VnFq.default)({
        float: 'unset',
        // Fix conflict with bootstrap
        width: 'auto',
        // Fix conflict with bootstrap
        overflow: 'hidden'
    }, !ownerState.withLabel && {
        padding: 0,
        lineHeight: '11px',
        // sync with `height` in `legend` styles
        transition: theme.transitions.create('width', {
            duration: 150,
            easing: theme.transitions.easing.easeOut
        })
    }, ownerState.withLabel && (0, $3VnFq.default)({
        display: 'block',
        // Fix conflict with normalize.css and sanitize.css
        padding: 0,
        height: 11,
        // sync with `lineHeight` in `legend` styles
        fontSize: '0.75em',
        visibility: 'hidden',
        maxWidth: 0.01,
        transition: theme.transitions.create('max-width', {
            duration: 50,
            easing: theme.transitions.easing.easeOut
        }),
        whiteSpace: 'nowrap',
        '& > span': {
            paddingLeft: 5,
            paddingRight: 5,
            display: 'inline-block',
            opacity: 0,
            visibility: 'visible'
        }
    }, ownerState.notched && {
        maxWidth: '100%',
        transition: theme.transitions.create('max-width', {
            duration: 100,
            easing: theme.transitions.easing.easeOut,
            delay: 50
        })
    })));
function $a6e072faf3f75d49$export$2e2bcd8739ae039(props) {
    const { className: className, label: label, notched: notched } = props, other = (0, $cTAWX.default)(props, $a6e072faf3f75d49$var$_excluded);
    const withLabel = label != null && label !== '';
    const ownerState = (0, $3VnFq.default)({}, props, {
        notched: notched,
        withLabel: withLabel
    });
    return /*#__PURE__*/ (0, $9wx12.jsx)($a6e072faf3f75d49$var$NotchedOutlineRoot, (0, $3VnFq.default)({
        "aria-hidden": true,
        className: className,
        ownerState: ownerState
    }, other, {
        children: /*#__PURE__*/ (0, $9wx12.jsx)($a6e072faf3f75d49$var$NotchedOutlineLegend, {
            ownerState: ownerState,
            children: withLabel ? /*#__PURE__*/ (0, $9wx12.jsx)("span", {
                children: label
            }) : $a6e072faf3f75d49$var$_span || ($a6e072faf3f75d49$var$_span = /*#__PURE__*/ (0, $9wx12.jsx)("span", {
                className: "notranslate",
                children: "\u200B"
            }))
        })
    }));
}





var $HGmne = parcelRequire("HGmne");
var $8ttSm = parcelRequire("8ttSm");

var $3VnFq = parcelRequire("3VnFq");

var $i8nzj = parcelRequire("i8nzj");

var $1kRHf = parcelRequire("1kRHf");

function $921dd6ba38af76db$export$89922944c7227687(slot) {
    return (0, $1kRHf.default)('MuiOutlinedInput', slot);
}
const $921dd6ba38af76db$var$outlinedInputClasses = (0, $3VnFq.default)({}, (0, $279b963301a4d28b$export$2e2bcd8739ae039), (0, $i8nzj.default)('MuiOutlinedInput', [
    'root',
    'notchedOutline',
    'input'
]));
var $921dd6ba38af76db$export$2e2bcd8739ae039 = $921dd6ba38af76db$var$outlinedInputClasses;




var $8pLcn = parcelRequire("8pLcn");

var $9wx12 = parcelRequire("9wx12");
'use client';
const $be3fe96c8bc9d690$var$_excluded = [
    "components",
    "fullWidth",
    "inputComponent",
    "label",
    "multiline",
    "notched",
    "slots",
    "type"
];
const $be3fe96c8bc9d690$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ],
        notchedOutline: [
            'notchedOutline'
        ],
        input: [
            'input'
        ]
    };
    const composedClasses = (0, $3e4LV.default)(slots, (0, $921dd6ba38af76db$export$89922944c7227687), classes);
    return (0, $3VnFq.default)({}, classes, composedClasses);
};
const $be3fe96c8bc9d690$var$OutlinedInputRoot = (0, $HGmne.default)((0, $f1f657db6b2cf37c$export$298a043133d72a38), {
    shouldForwardProp: (prop)=>(0, $8ttSm.default)(prop) || prop === 'classes',
    name: 'MuiOutlinedInput',
    slot: 'Root',
    overridesResolver: (0, $f1f657db6b2cf37c$export$965edad20a84fa75)
})(({ theme: theme, ownerState: ownerState })=>{
    const borderColor = theme.palette.mode === 'light' ? 'rgba(0, 0, 0, 0.23)' : 'rgba(255, 255, 255, 0.23)';
    return (0, $3VnFq.default)({
        position: 'relative',
        borderRadius: (theme.vars || theme).shape.borderRadius,
        [`&:hover .${(0, $921dd6ba38af76db$export$2e2bcd8739ae039).notchedOutline}`]: {
            borderColor: (theme.vars || theme).palette.text.primary
        },
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
            [`&:hover .${(0, $921dd6ba38af76db$export$2e2bcd8739ae039).notchedOutline}`]: {
                borderColor: theme.vars ? `rgba(${theme.vars.palette.common.onBackgroundChannel} / 0.23)` : borderColor
            }
        },
        [`&.${(0, $921dd6ba38af76db$export$2e2bcd8739ae039).focused} .${(0, $921dd6ba38af76db$export$2e2bcd8739ae039).notchedOutline}`]: {
            borderColor: (theme.vars || theme).palette[ownerState.color].main,
            borderWidth: 2
        },
        [`&.${(0, $921dd6ba38af76db$export$2e2bcd8739ae039).error} .${(0, $921dd6ba38af76db$export$2e2bcd8739ae039).notchedOutline}`]: {
            borderColor: (theme.vars || theme).palette.error.main
        },
        [`&.${(0, $921dd6ba38af76db$export$2e2bcd8739ae039).disabled} .${(0, $921dd6ba38af76db$export$2e2bcd8739ae039).notchedOutline}`]: {
            borderColor: (theme.vars || theme).palette.action.disabled
        }
    }, ownerState.startAdornment && {
        paddingLeft: 14
    }, ownerState.endAdornment && {
        paddingRight: 14
    }, ownerState.multiline && (0, $3VnFq.default)({
        padding: '16.5px 14px'
    }, ownerState.size === 'small' && {
        padding: '8.5px 14px'
    }));
});
const $be3fe96c8bc9d690$var$NotchedOutlineRoot = (0, $HGmne.default)((0, $a6e072faf3f75d49$export$2e2bcd8739ae039), {
    name: 'MuiOutlinedInput',
    slot: 'NotchedOutline',
    overridesResolver: (props, styles)=>styles.notchedOutline
})(({ theme: theme })=>{
    const borderColor = theme.palette.mode === 'light' ? 'rgba(0, 0, 0, 0.23)' : 'rgba(255, 255, 255, 0.23)';
    return {
        borderColor: theme.vars ? `rgba(${theme.vars.palette.common.onBackgroundChannel} / 0.23)` : borderColor
    };
});
const $be3fe96c8bc9d690$var$OutlinedInputInput = (0, $HGmne.default)((0, $f1f657db6b2cf37c$export$a1ad29c901026019), {
    name: 'MuiOutlinedInput',
    slot: 'Input',
    overridesResolver: (0, $f1f657db6b2cf37c$export$cf507b112810e72d)
})(({ theme: theme, ownerState: ownerState })=>(0, $3VnFq.default)({
        padding: '16.5px 14px'
    }, !theme.vars && {
        '&:-webkit-autofill': {
            WebkitBoxShadow: theme.palette.mode === 'light' ? null : '0 0 0 100px #266798 inset',
            WebkitTextFillColor: theme.palette.mode === 'light' ? null : '#fff',
            caretColor: theme.palette.mode === 'light' ? null : '#fff',
            borderRadius: 'inherit'
        }
    }, theme.vars && {
        '&:-webkit-autofill': {
            borderRadius: 'inherit'
        },
        [theme.getColorSchemeSelector('dark')]: {
            '&:-webkit-autofill': {
                WebkitBoxShadow: '0 0 0 100px #266798 inset',
                WebkitTextFillColor: '#fff',
                caretColor: '#fff'
            }
        }
    }, ownerState.size === 'small' && {
        padding: '8.5px 14px'
    }, ownerState.multiline && {
        padding: 0
    }, ownerState.startAdornment && {
        paddingLeft: 0
    }, ownerState.endAdornment && {
        paddingRight: 0
    }));
const $be3fe96c8bc9d690$var$OutlinedInput = /*#__PURE__*/ $gJYWc.forwardRef(function OutlinedInput(inProps, ref) {
    var _ref, _slots$root, _ref2, _slots$input, _React$Fragment;
    const props = (0, $8pLcn.useDefaultProps)({
        props: inProps,
        name: 'MuiOutlinedInput'
    });
    const { components: components = {}, fullWidth: fullWidth = false, inputComponent: inputComponent = 'input', label: label, multiline: multiline = false, notched: notched, slots: slots = {}, type: type = 'text' } = props, other = (0, $cTAWX.default)(props, $be3fe96c8bc9d690$var$_excluded);
    const classes = $be3fe96c8bc9d690$var$useUtilityClasses(props);
    const muiFormControl = (0, $7d9d5024ca7b136a$export$2e2bcd8739ae039)();
    const fcs = (0, $7f6a615e712efb52$export$2e2bcd8739ae039)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            'color',
            'disabled',
            'error',
            'focused',
            'hiddenLabel',
            'size',
            'required'
        ]
    });
    const ownerState = (0, $3VnFq.default)({}, props, {
        color: fcs.color || 'primary',
        disabled: fcs.disabled,
        error: fcs.error,
        focused: fcs.focused,
        formControl: muiFormControl,
        fullWidth: fullWidth,
        hiddenLabel: fcs.hiddenLabel,
        multiline: multiline,
        size: fcs.size,
        type: type
    });
    const RootSlot = (_ref = (_slots$root = slots.root) != null ? _slots$root : components.Root) != null ? _ref : $be3fe96c8bc9d690$var$OutlinedInputRoot;
    const InputSlot = (_ref2 = (_slots$input = slots.input) != null ? _slots$input : components.Input) != null ? _ref2 : $be3fe96c8bc9d690$var$OutlinedInputInput;
    return /*#__PURE__*/ (0, $9wx12.jsx)((0, $f1f657db6b2cf37c$export$2e2bcd8739ae039), (0, $3VnFq.default)({
        slots: {
            root: RootSlot,
            input: InputSlot
        },
        renderSuffix: (state)=>/*#__PURE__*/ (0, $9wx12.jsx)($be3fe96c8bc9d690$var$NotchedOutlineRoot, {
                ownerState: ownerState,
                className: classes.notchedOutline,
                label: label != null && label !== '' && fcs.required ? _React$Fragment || (_React$Fragment = /*#__PURE__*/ (0, $9wx12.jsxs)($gJYWc.Fragment, {
                    children: [
                        label,
                        "\u2009",
                        '*'
                    ]
                })) : label,
                notched: typeof notched !== 'undefined' ? notched : Boolean(state.startAdornment || state.filled || state.focused)
            }),
        fullWidth: fullWidth,
        inputComponent: inputComponent,
        multiline: multiline,
        ref: ref,
        type: type
    }, other, {
        classes: (0, $3VnFq.default)({}, classes, {
            notchedOutline: null
        })
    }));
});
$be3fe96c8bc9d690$var$OutlinedInput.muiName = 'Input';
var $be3fe96c8bc9d690$export$2e2bcd8739ae039 = $be3fe96c8bc9d690$var$OutlinedInput;



var $cTAWX = parcelRequire("cTAWX");

var $3VnFq = parcelRequire("3VnFq");

var $gJYWc = parcelRequire("gJYWc");


var $3e4LV = parcelRequire("3e4LV");

var $2w6IV = parcelRequire("2w6IV");



var $cTAWX = parcelRequire("cTAWX");

var $3VnFq = parcelRequire("3VnFq");

var $gJYWc = parcelRequire("gJYWc");


var $2w6IV = parcelRequire("2w6IV");

var $3e4LV = parcelRequire("3e4LV");



var $cVrVk = parcelRequire("cVrVk");

var $8pLcn = parcelRequire("8pLcn");

var $HGmne = parcelRequire("HGmne");

var $i8nzj = parcelRequire("i8nzj");

var $1kRHf = parcelRequire("1kRHf");
function $b79fe2218e7268cd$export$f7d501e40371cd17(slot) {
    return (0, $1kRHf.default)('MuiFormLabel', slot);
}
const $b79fe2218e7268cd$var$formLabelClasses = (0, $i8nzj.default)('MuiFormLabel', [
    'root',
    'colorSecondary',
    'focused',
    'disabled',
    'error',
    'filled',
    'required',
    'asterisk'
]);
var $b79fe2218e7268cd$export$2e2bcd8739ae039 = $b79fe2218e7268cd$var$formLabelClasses;



var $9wx12 = parcelRequire("9wx12");
'use client';
const $2479ce1cfcfb6b99$var$_excluded = [
    "children",
    "className",
    "color",
    "component",
    "disabled",
    "error",
    "filled",
    "focused",
    "required"
];
const $2479ce1cfcfb6b99$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, color: color, focused: focused, disabled: disabled, error: error, filled: filled, required: required } = ownerState;
    const slots = {
        root: [
            'root',
            `color${(0, $cVrVk.default)(color)}`,
            disabled && 'disabled',
            error && 'error',
            filled && 'filled',
            focused && 'focused',
            required && 'required'
        ],
        asterisk: [
            'asterisk',
            error && 'error'
        ]
    };
    return (0, $3e4LV.default)(slots, (0, $b79fe2218e7268cd$export$f7d501e40371cd17), classes);
};
const $2479ce1cfcfb6b99$export$aa5bc7f8a4705b27 = (0, $HGmne.default)('label', {
    name: 'MuiFormLabel',
    slot: 'Root',
    overridesResolver: ({ ownerState: ownerState }, styles)=>{
        return (0, $3VnFq.default)({}, styles.root, ownerState.color === 'secondary' && styles.colorSecondary, ownerState.filled && styles.filled);
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $3VnFq.default)({
        color: (theme.vars || theme).palette.text.secondary
    }, theme.typography.body1, {
        lineHeight: '1.4375em',
        padding: 0,
        position: 'relative',
        [`&.${(0, $b79fe2218e7268cd$export$2e2bcd8739ae039).focused}`]: {
            color: (theme.vars || theme).palette[ownerState.color].main
        },
        [`&.${(0, $b79fe2218e7268cd$export$2e2bcd8739ae039).disabled}`]: {
            color: (theme.vars || theme).palette.text.disabled
        },
        [`&.${(0, $b79fe2218e7268cd$export$2e2bcd8739ae039).error}`]: {
            color: (theme.vars || theme).palette.error.main
        }
    }));
const $2479ce1cfcfb6b99$var$AsteriskComponent = (0, $HGmne.default)('span', {
    name: 'MuiFormLabel',
    slot: 'Asterisk',
    overridesResolver: (props, styles)=>styles.asterisk
})(({ theme: theme })=>({
        [`&.${(0, $b79fe2218e7268cd$export$2e2bcd8739ae039).error}`]: {
            color: (theme.vars || theme).palette.error.main
        }
    }));
const $2479ce1cfcfb6b99$var$FormLabel = /*#__PURE__*/ $gJYWc.forwardRef(function FormLabel(inProps, ref) {
    const props = (0, $8pLcn.useDefaultProps)({
        props: inProps,
        name: 'MuiFormLabel'
    });
    const { children: children, className: className, component: component = 'label' } = props, other = (0, $cTAWX.default)(props, $2479ce1cfcfb6b99$var$_excluded);
    const muiFormControl = (0, $7d9d5024ca7b136a$export$2e2bcd8739ae039)();
    const fcs = (0, $7f6a615e712efb52$export$2e2bcd8739ae039)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            'color',
            'required',
            'focused',
            'disabled',
            'error',
            'filled'
        ]
    });
    const ownerState = (0, $3VnFq.default)({}, props, {
        color: fcs.color || 'primary',
        component: component,
        disabled: fcs.disabled,
        error: fcs.error,
        filled: fcs.filled,
        focused: fcs.focused,
        required: fcs.required
    });
    const classes = $2479ce1cfcfb6b99$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $9wx12.jsxs)($2479ce1cfcfb6b99$export$aa5bc7f8a4705b27, (0, $3VnFq.default)({
        as: component,
        ownerState: ownerState,
        className: (0, $2w6IV.default)(classes.root, className),
        ref: ref
    }, other, {
        children: [
            children,
            fcs.required && /*#__PURE__*/ (0, $9wx12.jsxs)($2479ce1cfcfb6b99$var$AsteriskComponent, {
                ownerState: ownerState,
                "aria-hidden": true,
                className: classes.asterisk,
                children: [
                    "\u2009",
                    '*'
                ]
            })
        ]
    }));
});
var $2479ce1cfcfb6b99$export$2e2bcd8739ae039 = $2479ce1cfcfb6b99$var$FormLabel;



var $8pLcn = parcelRequire("8pLcn");

var $cVrVk = parcelRequire("cVrVk");

var $HGmne = parcelRequire("HGmne");
var $8ttSm = parcelRequire("8ttSm");

var $i8nzj = parcelRequire("i8nzj");

var $1kRHf = parcelRequire("1kRHf");
function $30f2b2ee9de07b17$export$c1c4b4545ad2ea5f(slot) {
    return (0, $1kRHf.default)('MuiInputLabel', slot);
}
const $30f2b2ee9de07b17$var$inputLabelClasses = (0, $i8nzj.default)('MuiInputLabel', [
    'root',
    'focused',
    'disabled',
    'error',
    'required',
    'asterisk',
    'formControl',
    'sizeSmall',
    'shrink',
    'animated',
    'standard',
    'filled',
    'outlined'
]);
var $30f2b2ee9de07b17$export$2e2bcd8739ae039 = $30f2b2ee9de07b17$var$inputLabelClasses;



var $9wx12 = parcelRequire("9wx12");
'use client';
const $3fd7bb066fed2d52$var$_excluded = [
    "disableAnimation",
    "margin",
    "shrink",
    "variant",
    "className"
];
const $3fd7bb066fed2d52$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, formControl: formControl, size: size, shrink: shrink, disableAnimation: disableAnimation, variant: variant, required: required } = ownerState;
    const slots = {
        root: [
            'root',
            formControl && 'formControl',
            !disableAnimation && 'animated',
            shrink && 'shrink',
            size && size !== 'normal' && `size${(0, $cVrVk.default)(size)}`,
            variant
        ],
        asterisk: [
            required && 'asterisk'
        ]
    };
    const composedClasses = (0, $3e4LV.default)(slots, (0, $30f2b2ee9de07b17$export$c1c4b4545ad2ea5f), classes);
    return (0, $3VnFq.default)({}, classes, composedClasses);
};
const $3fd7bb066fed2d52$var$InputLabelRoot = (0, $HGmne.default)((0, $2479ce1cfcfb6b99$export$2e2bcd8739ae039), {
    shouldForwardProp: (prop)=>(0, $8ttSm.default)(prop) || prop === 'classes',
    name: 'MuiInputLabel',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            {
                [`& .${(0, $b79fe2218e7268cd$export$2e2bcd8739ae039).asterisk}`]: styles.asterisk
            },
            styles.root,
            ownerState.formControl && styles.formControl,
            ownerState.size === 'small' && styles.sizeSmall,
            ownerState.shrink && styles.shrink,
            !ownerState.disableAnimation && styles.animated,
            ownerState.focused && styles.focused,
            styles[ownerState.variant]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $3VnFq.default)({
        display: 'block',
        transformOrigin: 'top left',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        maxWidth: '100%'
    }, ownerState.formControl && {
        position: 'absolute',
        left: 0,
        top: 0,
        // slight alteration to spec spacing to match visual spec result
        transform: 'translate(0, 20px) scale(1)'
    }, ownerState.size === 'small' && {
        // Compensation for the `Input.inputSizeSmall` style.
        transform: 'translate(0, 17px) scale(1)'
    }, ownerState.shrink && {
        transform: 'translate(0, -1.5px) scale(0.75)',
        transformOrigin: 'top left',
        maxWidth: '133%'
    }, !ownerState.disableAnimation && {
        transition: theme.transitions.create([
            'color',
            'transform',
            'max-width'
        ], {
            duration: theme.transitions.duration.shorter,
            easing: theme.transitions.easing.easeOut
        })
    }, ownerState.variant === 'filled' && (0, $3VnFq.default)({
        // Chrome's autofill feature gives the input field a yellow background.
        // Since the input field is behind the label in the HTML tree,
        // the input field is drawn last and hides the label with an opaque background color.
        // zIndex: 1 will raise the label above opaque background-colors of input.
        zIndex: 1,
        pointerEvents: 'none',
        transform: 'translate(12px, 16px) scale(1)',
        maxWidth: 'calc(100% - 24px)'
    }, ownerState.size === 'small' && {
        transform: 'translate(12px, 13px) scale(1)'
    }, ownerState.shrink && (0, $3VnFq.default)({
        userSelect: 'none',
        pointerEvents: 'auto',
        transform: 'translate(12px, 7px) scale(0.75)',
        maxWidth: 'calc(133% - 24px)'
    }, ownerState.size === 'small' && {
        transform: 'translate(12px, 4px) scale(0.75)'
    })), ownerState.variant === 'outlined' && (0, $3VnFq.default)({
        // see comment above on filled.zIndex
        zIndex: 1,
        pointerEvents: 'none',
        transform: 'translate(14px, 16px) scale(1)',
        maxWidth: 'calc(100% - 24px)'
    }, ownerState.size === 'small' && {
        transform: 'translate(14px, 9px) scale(1)'
    }, ownerState.shrink && {
        userSelect: 'none',
        pointerEvents: 'auto',
        // Theoretically, we should have (8+5)*2/0.75 = 34px
        // but it feels a better when it bleeds a bit on the left, so 32px.
        maxWidth: 'calc(133% - 32px)',
        transform: 'translate(14px, -9px) scale(0.75)'
    })));
const $3fd7bb066fed2d52$var$InputLabel = /*#__PURE__*/ $gJYWc.forwardRef(function InputLabel(inProps, ref) {
    const props = (0, $8pLcn.useDefaultProps)({
        name: 'MuiInputLabel',
        props: inProps
    });
    const { disableAnimation: disableAnimation = false, shrink: shrinkProp, className: className } = props, other = (0, $cTAWX.default)(props, $3fd7bb066fed2d52$var$_excluded);
    const muiFormControl = (0, $7d9d5024ca7b136a$export$2e2bcd8739ae039)();
    let shrink = shrinkProp;
    if (typeof shrink === 'undefined' && muiFormControl) shrink = muiFormControl.filled || muiFormControl.focused || muiFormControl.adornedStart;
    const fcs = (0, $7f6a615e712efb52$export$2e2bcd8739ae039)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            'size',
            'variant',
            'required',
            'focused'
        ]
    });
    const ownerState = (0, $3VnFq.default)({}, props, {
        disableAnimation: disableAnimation,
        formControl: muiFormControl,
        shrink: shrink,
        size: fcs.size,
        variant: fcs.variant,
        required: fcs.required,
        focused: fcs.focused
    });
    const classes = $3fd7bb066fed2d52$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $9wx12.jsx)($3fd7bb066fed2d52$var$InputLabelRoot, (0, $3VnFq.default)({
        "data-shrink": shrink,
        ownerState: ownerState,
        ref: ref,
        className: (0, $2w6IV.default)(classes.root, className)
    }, other, {
        classes: classes
    }));
});
var $3fd7bb066fed2d52$export$2e2bcd8739ae039 = $3fd7bb066fed2d52$var$InputLabel;



var $cTAWX = parcelRequire("cTAWX");

var $3VnFq = parcelRequire("3VnFq");

var $gJYWc = parcelRequire("gJYWc");


var $2w6IV = parcelRequire("2w6IV");

var $3e4LV = parcelRequire("3e4LV");

var $8pLcn = parcelRequire("8pLcn");

var $HGmne = parcelRequire("HGmne");


var $cVrVk = parcelRequire("cVrVk");



var $i8nzj = parcelRequire("i8nzj");

var $1kRHf = parcelRequire("1kRHf");
function $8965730525e470db$export$149c8b8bab2289d1(slot) {
    return (0, $1kRHf.default)('MuiFormControl', slot);
}
const $8965730525e470db$var$formControlClasses = (0, $i8nzj.default)('MuiFormControl', [
    'root',
    'marginNone',
    'marginNormal',
    'marginDense',
    'fullWidth',
    'disabled'
]);
var $8965730525e470db$export$2e2bcd8739ae039 = $8965730525e470db$var$formControlClasses;



var $9wx12 = parcelRequire("9wx12");
'use client';
const $3acfb6ba72cad9c7$var$_excluded = [
    "children",
    "className",
    "color",
    "component",
    "disabled",
    "error",
    "focused",
    "fullWidth",
    "hiddenLabel",
    "margin",
    "required",
    "size",
    "variant"
];
const $3acfb6ba72cad9c7$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, margin: margin, fullWidth: fullWidth } = ownerState;
    const slots = {
        root: [
            'root',
            margin !== 'none' && `margin${(0, $cVrVk.default)(margin)}`,
            fullWidth && 'fullWidth'
        ]
    };
    return (0, $3e4LV.default)(slots, (0, $8965730525e470db$export$149c8b8bab2289d1), classes);
};
const $3acfb6ba72cad9c7$var$FormControlRoot = (0, $HGmne.default)('div', {
    name: 'MuiFormControl',
    slot: 'Root',
    overridesResolver: ({ ownerState: ownerState }, styles)=>{
        return (0, $3VnFq.default)({}, styles.root, styles[`margin${(0, $cVrVk.default)(ownerState.margin)}`], ownerState.fullWidth && styles.fullWidth);
    }
})(({ ownerState: ownerState })=>(0, $3VnFq.default)({
        display: 'inline-flex',
        flexDirection: 'column',
        position: 'relative',
        // Reset fieldset default style.
        minWidth: 0,
        padding: 0,
        margin: 0,
        border: 0,
        verticalAlign: 'top'
    }, ownerState.margin === 'normal' && {
        marginTop: 16,
        marginBottom: 8
    }, ownerState.margin === 'dense' && {
        marginTop: 8,
        marginBottom: 4
    }, ownerState.fullWidth && {
        width: '100%'
    }));
/**
 * Provides context such as filled/focused/error/required for form inputs.
 * Relying on the context provides high flexibility and ensures that the state always stays
 * consistent across the children of the `FormControl`.
 * This context is used by the following components:
 *
 *  - FormLabel
 *  - FormHelperText
 *  - Input
 *  - InputLabel
 *
 * You can find one composition example below and more going to [the demos](/material-ui/react-text-field/#components).
 *
 * ```jsx
 * <FormControl>
 *   <InputLabel htmlFor="my-input">Email address</InputLabel>
 *   <Input id="my-input" aria-describedby="my-helper-text" />
 *   <FormHelperText id="my-helper-text">We'll never share your email.</FormHelperText>
 * </FormControl>
 * ```
 *
 * ⚠️ Only one `InputBase` can be used within a FormControl because it creates visual inconsistencies.
 * For instance, only one input can be focused at the same time, the state shouldn't be shared.
 */ const $3acfb6ba72cad9c7$var$FormControl = /*#__PURE__*/ $gJYWc.forwardRef(function FormControl(inProps, ref) {
    const props = (0, $8pLcn.useDefaultProps)({
        props: inProps,
        name: 'MuiFormControl'
    });
    const { children: children, className: className, color: color = 'primary', component: component = 'div', disabled: disabled = false, error: error = false, focused: visuallyFocused, fullWidth: fullWidth = false, hiddenLabel: hiddenLabel = false, margin: margin = 'none', required: required = false, size: size = 'medium', variant: variant = 'outlined' } = props, other = (0, $cTAWX.default)(props, $3acfb6ba72cad9c7$var$_excluded);
    const ownerState = (0, $3VnFq.default)({}, props, {
        color: color,
        component: component,
        disabled: disabled,
        error: error,
        fullWidth: fullWidth,
        hiddenLabel: hiddenLabel,
        margin: margin,
        required: required,
        size: size,
        variant: variant
    });
    const classes = $3acfb6ba72cad9c7$var$useUtilityClasses(ownerState);
    const [adornedStart, setAdornedStart] = $gJYWc.useState(()=>{
        // We need to iterate through the children and find the Input in order
        // to fully support server-side rendering.
        let initialAdornedStart = false;
        if (children) $gJYWc.Children.forEach(children, (child)=>{
            if (!(0, $7cf0f7eb93e7e254$export$2e2bcd8739ae039)(child, [
                'Input',
                'Select'
            ])) return;
            const input = (0, $7cf0f7eb93e7e254$export$2e2bcd8739ae039)(child, [
                'Select'
            ]) ? child.props.input : child;
            if (input && (0, $100e54cdfcc16a4b$export$1b68bdfa56faeb5d)(input.props)) initialAdornedStart = true;
        });
        return initialAdornedStart;
    });
    const [filled, setFilled] = $gJYWc.useState(()=>{
        // We need to iterate through the children and find the Input in order
        // to fully support server-side rendering.
        let initialFilled = false;
        if (children) $gJYWc.Children.forEach(children, (child)=>{
            if (!(0, $7cf0f7eb93e7e254$export$2e2bcd8739ae039)(child, [
                'Input',
                'Select'
            ])) return;
            if ((0, $100e54cdfcc16a4b$export$d652b828d7fdeff8)(child.props, true) || (0, $100e54cdfcc16a4b$export$d652b828d7fdeff8)(child.props.inputProps, true)) initialFilled = true;
        });
        return initialFilled;
    });
    const [focusedState, setFocused] = $gJYWc.useState(false);
    if (disabled && focusedState) setFocused(false);
    const focused = visuallyFocused !== undefined && !disabled ? visuallyFocused : focusedState;
    let registerEffect;
    const childContext = $gJYWc.useMemo(()=>{
        return {
            adornedStart: adornedStart,
            setAdornedStart: setAdornedStart,
            color: color,
            disabled: disabled,
            error: error,
            filled: filled,
            focused: focused,
            fullWidth: fullWidth,
            hiddenLabel: hiddenLabel,
            size: size,
            onBlur: ()=>{
                setFocused(false);
            },
            onEmpty: ()=>{
                setFilled(false);
            },
            onFilled: ()=>{
                setFilled(true);
            },
            onFocus: ()=>{
                setFocused(true);
            },
            registerEffect: registerEffect,
            required: required,
            variant: variant
        };
    }, [
        adornedStart,
        color,
        disabled,
        error,
        filled,
        focused,
        fullWidth,
        hiddenLabel,
        registerEffect,
        required,
        size,
        variant
    ]);
    return /*#__PURE__*/ (0, $9wx12.jsx)((0, $ae835169353fee9c$export$2e2bcd8739ae039).Provider, {
        value: childContext,
        children: /*#__PURE__*/ (0, $9wx12.jsx)($3acfb6ba72cad9c7$var$FormControlRoot, (0, $3VnFq.default)({
            as: component,
            ownerState: ownerState,
            className: (0, $2w6IV.default)(classes.root, className),
            ref: ref
        }, other, {
            children: children
        }))
    });
});
var $3acfb6ba72cad9c7$export$2e2bcd8739ae039 = $3acfb6ba72cad9c7$var$FormControl;



var $cTAWX = parcelRequire("cTAWX");

var $3VnFq = parcelRequire("3VnFq");

var $gJYWc = parcelRequire("gJYWc");


var $2w6IV = parcelRequire("2w6IV");

var $3e4LV = parcelRequire("3e4LV");



var $HGmne = parcelRequire("HGmne");

var $cVrVk = parcelRequire("cVrVk");

var $i8nzj = parcelRequire("i8nzj");

var $1kRHf = parcelRequire("1kRHf");
function $234be1dcd943745b$export$a394fa61b1d583a9(slot) {
    return (0, $1kRHf.default)('MuiFormHelperText', slot);
}
const $234be1dcd943745b$var$formHelperTextClasses = (0, $i8nzj.default)('MuiFormHelperText', [
    'root',
    'error',
    'disabled',
    'sizeSmall',
    'sizeMedium',
    'contained',
    'focused',
    'filled',
    'required'
]);
var $234be1dcd943745b$export$2e2bcd8739ae039 = $234be1dcd943745b$var$formHelperTextClasses;



var $8pLcn = parcelRequire("8pLcn");

var $9wx12 = parcelRequire("9wx12");
'use client';
var $cd07031769fd9ace$var$_span;
const $cd07031769fd9ace$var$_excluded = [
    "children",
    "className",
    "component",
    "disabled",
    "error",
    "filled",
    "focused",
    "margin",
    "required",
    "variant"
];
const $cd07031769fd9ace$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, contained: contained, size: size, disabled: disabled, error: error, filled: filled, focused: focused, required: required } = ownerState;
    const slots = {
        root: [
            'root',
            disabled && 'disabled',
            error && 'error',
            size && `size${(0, $cVrVk.default)(size)}`,
            contained && 'contained',
            focused && 'focused',
            filled && 'filled',
            required && 'required'
        ]
    };
    return (0, $3e4LV.default)(slots, (0, $234be1dcd943745b$export$a394fa61b1d583a9), classes);
};
const $cd07031769fd9ace$var$FormHelperTextRoot = (0, $HGmne.default)('p', {
    name: 'MuiFormHelperText',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.size && styles[`size${(0, $cVrVk.default)(ownerState.size)}`],
            ownerState.contained && styles.contained,
            ownerState.filled && styles.filled
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $3VnFq.default)({
        color: (theme.vars || theme).palette.text.secondary
    }, theme.typography.caption, {
        textAlign: 'left',
        marginTop: 3,
        marginRight: 0,
        marginBottom: 0,
        marginLeft: 0,
        [`&.${(0, $234be1dcd943745b$export$2e2bcd8739ae039).disabled}`]: {
            color: (theme.vars || theme).palette.text.disabled
        },
        [`&.${(0, $234be1dcd943745b$export$2e2bcd8739ae039).error}`]: {
            color: (theme.vars || theme).palette.error.main
        }
    }, ownerState.size === 'small' && {
        marginTop: 4
    }, ownerState.contained && {
        marginLeft: 14,
        marginRight: 14
    }));
const $cd07031769fd9ace$var$FormHelperText = /*#__PURE__*/ $gJYWc.forwardRef(function FormHelperText(inProps, ref) {
    const props = (0, $8pLcn.useDefaultProps)({
        props: inProps,
        name: 'MuiFormHelperText'
    });
    const { children: children, className: className, component: component = 'p' } = props, other = (0, $cTAWX.default)(props, $cd07031769fd9ace$var$_excluded);
    const muiFormControl = (0, $7d9d5024ca7b136a$export$2e2bcd8739ae039)();
    const fcs = (0, $7f6a615e712efb52$export$2e2bcd8739ae039)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            'variant',
            'size',
            'disabled',
            'error',
            'filled',
            'focused',
            'required'
        ]
    });
    const ownerState = (0, $3VnFq.default)({}, props, {
        component: component,
        contained: fcs.variant === 'filled' || fcs.variant === 'outlined',
        variant: fcs.variant,
        size: fcs.size,
        disabled: fcs.disabled,
        error: fcs.error,
        filled: fcs.filled,
        focused: fcs.focused,
        required: fcs.required
    });
    const classes = $cd07031769fd9ace$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $9wx12.jsx)($cd07031769fd9ace$var$FormHelperTextRoot, (0, $3VnFq.default)({
        as: component,
        ownerState: ownerState,
        className: (0, $2w6IV.default)(classes.root, className),
        ref: ref
    }, other, {
        children: children === ' ' ? $cd07031769fd9ace$var$_span || ($cd07031769fd9ace$var$_span = /*#__PURE__*/ (0, $9wx12.jsx)("span", {
            className: "notranslate",
            children: "\u200B"
        })) : children
    }));
});
var $cd07031769fd9ace$export$2e2bcd8739ae039 = $cd07031769fd9ace$var$FormHelperText;



var $3VnFq = parcelRequire("3VnFq");

var $cTAWX = parcelRequire("cTAWX");

var $gJYWc = parcelRequire("gJYWc");


var $2w6IV = parcelRequire("2w6IV");

var $dvHXN = parcelRequire("dvHXN");


var $3VnFq = parcelRequire("3VnFq");

var $cTAWX = parcelRequire("cTAWX");

var $lqJfJ = parcelRequire("lqJfJ");

var $gJYWc = parcelRequire("gJYWc");



var $2w6IV = parcelRequire("2w6IV");

var $3e4LV = parcelRequire("3e4LV");




var $cVrVk = parcelRequire("cVrVk");

var $3VnFq = parcelRequire("3VnFq");

var $cTAWX = parcelRequire("cTAWX");

var $gJYWc = parcelRequire("gJYWc");



var $2w6IV = parcelRequire("2w6IV");

var $3e4LV = parcelRequire("3e4LV");




var $3VnFq = parcelRequire("3VnFq");

var $cTAWX = parcelRequire("cTAWX");

var $gJYWc = parcelRequire("gJYWc");





var $467d8d482dc99c22$export$2e2bcd8739ae039 = (0, $a87ca72e028a1761$export$2e2bcd8739ae039);



var $il32z = parcelRequire("il32z");


var $9wx12 = parcelRequire("9wx12");
'use client';
const $b767fae8cf0de5d7$var$_excluded = [
    "actions",
    "autoFocus",
    "autoFocusItem",
    "children",
    "className",
    "disabledItemsFocusable",
    "disableListWrap",
    "onKeyDown",
    "variant"
];
function $b767fae8cf0de5d7$var$nextItem(list, item, disableListWrap) {
    if (list === item) return list.firstChild;
    if (item && item.nextElementSibling) return item.nextElementSibling;
    return disableListWrap ? null : list.firstChild;
}
function $b767fae8cf0de5d7$var$previousItem(list, item, disableListWrap) {
    if (list === item) return disableListWrap ? list.firstChild : list.lastChild;
    if (item && item.previousElementSibling) return item.previousElementSibling;
    return disableListWrap ? null : list.lastChild;
}
function $b767fae8cf0de5d7$var$textCriteriaMatches(nextFocus, textCriteria) {
    if (textCriteria === undefined) return true;
    let text = nextFocus.innerText;
    if (text === undefined) // jsdom doesn't support innerText
    text = nextFocus.textContent;
    text = text.trim().toLowerCase();
    if (text.length === 0) return false;
    if (textCriteria.repeating) return text[0] === textCriteria.keys[0];
    return text.indexOf(textCriteria.keys.join('')) === 0;
}
function $b767fae8cf0de5d7$var$moveFocus(list, currentFocus, disableListWrap, disabledItemsFocusable, traversalFunction, textCriteria) {
    let wrappedOnce = false;
    let nextFocus = traversalFunction(list, currentFocus, currentFocus ? disableListWrap : false);
    while(nextFocus){
        // Prevent infinite loop.
        if (nextFocus === list.firstChild) {
            if (wrappedOnce) return false;
            wrappedOnce = true;
        }
        // Same logic as useAutocomplete.js
        const nextFocusDisabled = disabledItemsFocusable ? false : nextFocus.disabled || nextFocus.getAttribute('aria-disabled') === 'true';
        if (!nextFocus.hasAttribute('tabindex') || !$b767fae8cf0de5d7$var$textCriteriaMatches(nextFocus, textCriteria) || nextFocusDisabled) // Move to the next element.
        nextFocus = traversalFunction(list, nextFocus, disableListWrap);
        else {
            nextFocus.focus();
            return true;
        }
    }
    return false;
}
/**
 * A permanently displayed menu following https://www.w3.org/WAI/ARIA/apg/patterns/menu-button/.
 * It's exposed to help customization of the [`Menu`](/material-ui/api/menu/) component if you
 * use it separately you need to move focus into the component manually. Once
 * the focus is placed inside the component it is fully keyboard accessible.
 */ const $b767fae8cf0de5d7$var$MenuList = /*#__PURE__*/ $gJYWc.forwardRef(function MenuList(props, ref) {
    const { actions: // private
    // eslint-disable-next-line react/prop-types
    actions, autoFocus: autoFocus = false, autoFocusItem: autoFocusItem = false, children: children, className: className, disabledItemsFocusable: disabledItemsFocusable = false, disableListWrap: disableListWrap = false, onKeyDown: onKeyDown, variant: variant = 'selectedMenu' } = props, other = (0, $cTAWX.default)(props, $b767fae8cf0de5d7$var$_excluded);
    const listRef = $gJYWc.useRef(null);
    const textCriteriaRef = $gJYWc.useRef({
        keys: [],
        repeating: true,
        previousKeyMatched: true,
        lastTime: null
    });
    (0, $288db5e5dece4e0b$export$2e2bcd8739ae039)(()=>{
        if (autoFocus) listRef.current.focus();
    }, [
        autoFocus
    ]);
    $gJYWc.useImperativeHandle(actions, ()=>({
            adjustStyleForScrollbar: (containerElement, { direction: direction })=>{
                // Let's ignore that piece of logic if users are already overriding the width
                // of the menu.
                const noExplicitWidth = !listRef.current.style.width;
                if (containerElement.clientHeight < listRef.current.clientHeight && noExplicitWidth) {
                    const scrollbarSize = `${(0, $467d8d482dc99c22$export$2e2bcd8739ae039)((0, $755167b4f9e6f571$export$2e2bcd8739ae039)(containerElement))}px`;
                    listRef.current.style[direction === 'rtl' ? 'paddingLeft' : 'paddingRight'] = scrollbarSize;
                    listRef.current.style.width = `calc(100% + ${scrollbarSize})`;
                }
                return listRef.current;
            }
        }), []);
    const handleKeyDown = (event)=>{
        const list = listRef.current;
        const key = event.key;
        /**
     * @type {Element} - will always be defined since we are in a keydown handler
     * attached to an element. A keydown event is either dispatched to the activeElement
     * or document.body or document.documentElement. Only the first case will
     * trigger this specific handler.
     */ const currentFocus = (0, $755167b4f9e6f571$export$2e2bcd8739ae039)(list).activeElement;
        if (key === 'ArrowDown') {
            // Prevent scroll of the page
            event.preventDefault();
            $b767fae8cf0de5d7$var$moveFocus(list, currentFocus, disableListWrap, disabledItemsFocusable, $b767fae8cf0de5d7$var$nextItem);
        } else if (key === 'ArrowUp') {
            event.preventDefault();
            $b767fae8cf0de5d7$var$moveFocus(list, currentFocus, disableListWrap, disabledItemsFocusable, $b767fae8cf0de5d7$var$previousItem);
        } else if (key === 'Home') {
            event.preventDefault();
            $b767fae8cf0de5d7$var$moveFocus(list, null, disableListWrap, disabledItemsFocusable, $b767fae8cf0de5d7$var$nextItem);
        } else if (key === 'End') {
            event.preventDefault();
            $b767fae8cf0de5d7$var$moveFocus(list, null, disableListWrap, disabledItemsFocusable, $b767fae8cf0de5d7$var$previousItem);
        } else if (key.length === 1) {
            const criteria = textCriteriaRef.current;
            const lowerKey = key.toLowerCase();
            const currTime = performance.now();
            if (criteria.keys.length > 0) {
                // Reset
                if (currTime - criteria.lastTime > 500) {
                    criteria.keys = [];
                    criteria.repeating = true;
                    criteria.previousKeyMatched = true;
                } else if (criteria.repeating && lowerKey !== criteria.keys[0]) criteria.repeating = false;
            }
            criteria.lastTime = currTime;
            criteria.keys.push(lowerKey);
            const keepFocusOnCurrent = currentFocus && !criteria.repeating && $b767fae8cf0de5d7$var$textCriteriaMatches(currentFocus, criteria);
            if (criteria.previousKeyMatched && (keepFocusOnCurrent || $b767fae8cf0de5d7$var$moveFocus(list, currentFocus, false, disabledItemsFocusable, $b767fae8cf0de5d7$var$nextItem, criteria))) event.preventDefault();
            else criteria.previousKeyMatched = false;
        }
        if (onKeyDown) onKeyDown(event);
    };
    const handleRef = (0, $il32z.default)(listRef, ref);
    /**
   * the index of the item should receive focus
   * in a `variant="selectedMenu"` it's the first `selected` item
   * otherwise it's the very first item.
   */ let activeItemIndex = -1;
    // since we inject focus related props into children we have to do a lookahead
    // to check if there is a `selected` item. We're looking for the last `selected`
    // item and use the first valid item as a fallback
    $gJYWc.Children.forEach(children, (child, index)=>{
        if (!/*#__PURE__*/ $gJYWc.isValidElement(child)) {
            if (activeItemIndex === index) {
                activeItemIndex += 1;
                if (activeItemIndex >= children.length) // there are no focusable items within the list.
                activeItemIndex = -1;
            }
            return;
        }
        if (!child.props.disabled) {
            if (variant === 'selectedMenu' && child.props.selected) activeItemIndex = index;
            else if (activeItemIndex === -1) activeItemIndex = index;
        }
        if (activeItemIndex === index && (child.props.disabled || child.props.muiSkipListHighlight || child.type.muiSkipListHighlight)) {
            activeItemIndex += 1;
            if (activeItemIndex >= children.length) // there are no focusable items within the list.
            activeItemIndex = -1;
        }
    });
    const items = $gJYWc.Children.map(children, (child, index)=>{
        if (index === activeItemIndex) {
            const newChildProps = {};
            if (autoFocusItem) newChildProps.autoFocus = true;
            if (child.props.tabIndex === undefined && variant === 'selectedMenu') newChildProps.tabIndex = 0;
            return /*#__PURE__*/ $gJYWc.cloneElement(child, newChildProps);
        }
        return child;
    });
    return /*#__PURE__*/ (0, $9wx12.jsx)((0, $e247548612617cb3$export$2e2bcd8739ae039), (0, $3VnFq.default)({
        role: "menu",
        ref: handleRef,
        className: className,
        onKeyDown: handleKeyDown,
        tabIndex: autoFocus ? 0 : -1
    }, other, {
        children: items
    }));
});
var $b767fae8cf0de5d7$export$2e2bcd8739ae039 = $b767fae8cf0de5d7$var$MenuList;




var $HGmne = parcelRequire("HGmne");
var $8ttSm = parcelRequire("8ttSm");

var $8pLcn = parcelRequire("8pLcn");

var $i8nzj = parcelRequire("i8nzj");

var $1kRHf = parcelRequire("1kRHf");
function $3d75912326ea6c7d$export$2cf86a63a84fe23d(slot) {
    return (0, $1kRHf.default)('MuiMenu', slot);
}
const $3d75912326ea6c7d$var$menuClasses = (0, $i8nzj.default)('MuiMenu', [
    'root',
    'paper',
    'list'
]);
var $3d75912326ea6c7d$export$2e2bcd8739ae039 = $3d75912326ea6c7d$var$menuClasses;



var $9wx12 = parcelRequire("9wx12");
'use client';
const $85bf06d3d7325d0c$var$_excluded = [
    "onEntering"
], $85bf06d3d7325d0c$var$_excluded2 = [
    "autoFocus",
    "children",
    "className",
    "disableAutoFocusItem",
    "MenuListProps",
    "onClose",
    "open",
    "PaperProps",
    "PopoverClasses",
    "transitionDuration",
    "TransitionProps",
    "variant",
    "slots",
    "slotProps"
];
const $85bf06d3d7325d0c$var$RTL_ORIGIN = {
    vertical: 'top',
    horizontal: 'right'
};
const $85bf06d3d7325d0c$var$LTR_ORIGIN = {
    vertical: 'top',
    horizontal: 'left'
};
const $85bf06d3d7325d0c$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ],
        paper: [
            'paper'
        ],
        list: [
            'list'
        ]
    };
    return (0, $3e4LV.default)(slots, (0, $3d75912326ea6c7d$export$2cf86a63a84fe23d), classes);
};
const $85bf06d3d7325d0c$var$MenuRoot = (0, $HGmne.default)((0, $3a28566a3952ccba$export$2e2bcd8739ae039), {
    shouldForwardProp: (prop)=>(0, $8ttSm.default)(prop) || prop === 'classes',
    name: 'MuiMenu',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})({});
const $85bf06d3d7325d0c$export$4f7c51a5920c9f33 = (0, $HGmne.default)((0, $3a28566a3952ccba$export$821346c38a2d9390), {
    name: 'MuiMenu',
    slot: 'Paper',
    overridesResolver: (props, styles)=>styles.paper
})({
    // specZ: The maximum height of a simple menu should be one or more rows less than the view
    // height. This ensures a tappable area outside of the simple menu with which to dismiss
    // the menu.
    maxHeight: 'calc(100% - 96px)',
    // Add iOS momentum scrolling for iOS < 13.0
    WebkitOverflowScrolling: 'touch'
});
const $85bf06d3d7325d0c$var$MenuMenuList = (0, $HGmne.default)((0, $b767fae8cf0de5d7$export$2e2bcd8739ae039), {
    name: 'MuiMenu',
    slot: 'List',
    overridesResolver: (props, styles)=>styles.list
})({
    // We disable the focus ring for mouse, touch and keyboard users.
    outline: 0
});
const $85bf06d3d7325d0c$var$Menu = /*#__PURE__*/ $gJYWc.forwardRef(function Menu(inProps, ref) {
    var _slots$paper, _slotProps$paper;
    const props = (0, $8pLcn.useDefaultProps)({
        props: inProps,
        name: 'MuiMenu'
    });
    const { autoFocus: autoFocus = true, children: children, className: className, disableAutoFocusItem: disableAutoFocusItem = false, MenuListProps: MenuListProps = {}, onClose: onClose, open: open, PaperProps: PaperProps = {}, PopoverClasses: PopoverClasses, transitionDuration: transitionDuration = 'auto', TransitionProps: { onEntering: onEntering } = {}, variant: variant = 'selectedMenu', slots: slots = {}, slotProps: slotProps = {} } = props, TransitionProps = (0, $cTAWX.default)(props.TransitionProps, $85bf06d3d7325d0c$var$_excluded), other = (0, $cTAWX.default)(props, $85bf06d3d7325d0c$var$_excluded2);
    const isRtl = (0, $bc397899d0b95ae5$export$b2dd014b6c321cb)();
    const ownerState = (0, $3VnFq.default)({}, props, {
        autoFocus: autoFocus,
        disableAutoFocusItem: disableAutoFocusItem,
        MenuListProps: MenuListProps,
        onEntering: onEntering,
        PaperProps: PaperProps,
        transitionDuration: transitionDuration,
        TransitionProps: TransitionProps,
        variant: variant
    });
    const classes = $85bf06d3d7325d0c$var$useUtilityClasses(ownerState);
    const autoFocusItem = autoFocus && !disableAutoFocusItem && open;
    const menuListActionsRef = $gJYWc.useRef(null);
    const handleEntering = (element, isAppearing)=>{
        if (menuListActionsRef.current) menuListActionsRef.current.adjustStyleForScrollbar(element, {
            direction: isRtl ? 'rtl' : 'ltr'
        });
        if (onEntering) onEntering(element, isAppearing);
    };
    const handleListKeyDown = (event)=>{
        if (event.key === 'Tab') {
            event.preventDefault();
            if (onClose) onClose(event, 'tabKeyDown');
        }
    };
    /**
   * the index of the item should receive focus
   * in a `variant="selectedMenu"` it's the first `selected` item
   * otherwise it's the very first item.
   */ let activeItemIndex = -1;
    // since we inject focus related props into children we have to do a lookahead
    // to check if there is a `selected` item. We're looking for the last `selected`
    // item and use the first valid item as a fallback
    $gJYWc.Children.map(children, (child, index)=>{
        if (!/*#__PURE__*/ $gJYWc.isValidElement(child)) return;
        if (!child.props.disabled) {
            if (variant === 'selectedMenu' && child.props.selected) activeItemIndex = index;
            else if (activeItemIndex === -1) activeItemIndex = index;
        }
    });
    const PaperSlot = (_slots$paper = slots.paper) != null ? _slots$paper : $85bf06d3d7325d0c$export$4f7c51a5920c9f33;
    const paperExternalSlotProps = (_slotProps$paper = slotProps.paper) != null ? _slotProps$paper : PaperProps;
    const rootSlotProps = (0, $2f70e5a04f888acc$export$2e2bcd8739ae039)({
        elementType: slots.root,
        externalSlotProps: slotProps.root,
        ownerState: ownerState,
        className: [
            classes.root,
            className
        ]
    });
    const paperSlotProps = (0, $2f70e5a04f888acc$export$2e2bcd8739ae039)({
        elementType: PaperSlot,
        externalSlotProps: paperExternalSlotProps,
        ownerState: ownerState,
        className: classes.paper
    });
    return /*#__PURE__*/ (0, $9wx12.jsx)($85bf06d3d7325d0c$var$MenuRoot, (0, $3VnFq.default)({
        onClose: onClose,
        anchorOrigin: {
            vertical: 'bottom',
            horizontal: isRtl ? 'right' : 'left'
        },
        transformOrigin: isRtl ? $85bf06d3d7325d0c$var$RTL_ORIGIN : $85bf06d3d7325d0c$var$LTR_ORIGIN,
        slots: {
            paper: PaperSlot,
            root: slots.root
        },
        slotProps: {
            root: rootSlotProps,
            paper: paperSlotProps
        },
        open: open,
        ref: ref,
        transitionDuration: transitionDuration,
        TransitionProps: (0, $3VnFq.default)({
            onEntering: handleEntering
        }, TransitionProps),
        ownerState: ownerState
    }, other, {
        classes: PopoverClasses,
        children: /*#__PURE__*/ (0, $9wx12.jsx)($85bf06d3d7325d0c$var$MenuMenuList, (0, $3VnFq.default)({
            onKeyDown: handleListKeyDown,
            actions: menuListActionsRef,
            autoFocus: autoFocus && (activeItemIndex === -1 || disableAutoFocusItem),
            autoFocusItem: autoFocusItem,
            variant: variant
        }, MenuListProps, {
            className: (0, $2w6IV.default)(classes.list, MenuListProps.className),
            children: children
        }))
    }));
});
var $85bf06d3d7325d0c$export$2e2bcd8739ae039 = $85bf06d3d7325d0c$var$Menu;



var $cTAWX = parcelRequire("cTAWX");

var $3VnFq = parcelRequire("3VnFq");

var $gJYWc = parcelRequire("gJYWc");


var $2w6IV = parcelRequire("2w6IV");


var $3e4LV = parcelRequire("3e4LV");

var $cVrVk = parcelRequire("cVrVk");

var $i8nzj = parcelRequire("i8nzj");

var $1kRHf = parcelRequire("1kRHf");
function $e7d9fa3144b538a4$export$1ee13051fd9e2ab5(slot) {
    return (0, $1kRHf.default)('MuiNativeSelect', slot);
}
const $e7d9fa3144b538a4$var$nativeSelectClasses = (0, $i8nzj.default)('MuiNativeSelect', [
    'root',
    'select',
    'multiple',
    'filled',
    'outlined',
    'standard',
    'disabled',
    'icon',
    'iconOpen',
    'iconFilled',
    'iconOutlined',
    'iconStandard',
    'nativeInput',
    'error'
]);
var $e7d9fa3144b538a4$export$2e2bcd8739ae039 = $e7d9fa3144b538a4$var$nativeSelectClasses;



var $HGmne = parcelRequire("HGmne");
var $8ttSm = parcelRequire("8ttSm");

var $9wx12 = parcelRequire("9wx12");
'use client';
const $af862ae563a9409c$var$_excluded = [
    "className",
    "disabled",
    "error",
    "IconComponent",
    "inputRef",
    "variant"
];
const $af862ae563a9409c$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, variant: variant, disabled: disabled, multiple: multiple, open: open, error: error } = ownerState;
    const slots = {
        select: [
            'select',
            variant,
            disabled && 'disabled',
            multiple && 'multiple',
            error && 'error'
        ],
        icon: [
            'icon',
            `icon${(0, $cVrVk.default)(variant)}`,
            open && 'iconOpen',
            disabled && 'disabled'
        ]
    };
    return (0, $3e4LV.default)(slots, (0, $e7d9fa3144b538a4$export$1ee13051fd9e2ab5), classes);
};
const $af862ae563a9409c$export$c1eccd1617458c87 = ({ ownerState: ownerState, theme: theme })=>(0, $3VnFq.default)({
        MozAppearance: 'none',
        // Reset
        WebkitAppearance: 'none',
        // Reset
        // When interacting quickly, the text can end up selected.
        // Native select can't be selected either.
        userSelect: 'none',
        borderRadius: 0,
        // Reset
        cursor: 'pointer',
        '&:focus': (0, $3VnFq.default)({}, theme.vars ? {
            backgroundColor: `rgba(${theme.vars.palette.common.onBackgroundChannel} / 0.05)`
        } : {
            backgroundColor: theme.palette.mode === 'light' ? 'rgba(0, 0, 0, 0.05)' : 'rgba(255, 255, 255, 0.05)'
        }, {
            borderRadius: 0 // Reset Chrome style
        }),
        // Remove IE11 arrow
        '&::-ms-expand': {
            display: 'none'
        },
        [`&.${(0, $e7d9fa3144b538a4$export$2e2bcd8739ae039).disabled}`]: {
            cursor: 'default'
        },
        '&[multiple]': {
            height: 'auto'
        },
        '&:not([multiple]) option, &:not([multiple]) optgroup': {
            backgroundColor: (theme.vars || theme).palette.background.paper
        },
        // Bump specificity to allow extending custom inputs
        '&&&': {
            paddingRight: 24,
            minWidth: 16 // So it doesn't collapse.
        }
    }, ownerState.variant === 'filled' && {
        '&&&': {
            paddingRight: 32
        }
    }, ownerState.variant === 'outlined' && {
        borderRadius: (theme.vars || theme).shape.borderRadius,
        '&:focus': {
            borderRadius: (theme.vars || theme).shape.borderRadius // Reset the reset for Chrome style
        },
        '&&&': {
            paddingRight: 32
        }
    });
const $af862ae563a9409c$var$NativeSelectSelect = (0, $HGmne.default)('select', {
    name: 'MuiNativeSelect',
    slot: 'Select',
    shouldForwardProp: (0, $8ttSm.default),
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.select,
            styles[ownerState.variant],
            ownerState.error && styles.error,
            {
                [`&.${(0, $e7d9fa3144b538a4$export$2e2bcd8739ae039).multiple}`]: styles.multiple
            }
        ];
    }
})($af862ae563a9409c$export$c1eccd1617458c87);
const $af862ae563a9409c$export$e7a817afd12a40d0 = ({ ownerState: ownerState, theme: theme })=>(0, $3VnFq.default)({
        // We use a position absolute over a flexbox in order to forward the pointer events
        // to the input and to support wrapping tags..
        position: 'absolute',
        right: 0,
        top: 'calc(50% - .5em)',
        // Center vertically, height is 1em
        pointerEvents: 'none',
        // Don't block pointer events on the select under the icon.
        color: (theme.vars || theme).palette.action.active,
        [`&.${(0, $e7d9fa3144b538a4$export$2e2bcd8739ae039).disabled}`]: {
            color: (theme.vars || theme).palette.action.disabled
        }
    }, ownerState.open && {
        transform: 'rotate(180deg)'
    }, ownerState.variant === 'filled' && {
        right: 7
    }, ownerState.variant === 'outlined' && {
        right: 7
    });
const $af862ae563a9409c$var$NativeSelectIcon = (0, $HGmne.default)('svg', {
    name: 'MuiNativeSelect',
    slot: 'Icon',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.icon,
            ownerState.variant && styles[`icon${(0, $cVrVk.default)(ownerState.variant)}`],
            ownerState.open && styles.iconOpen
        ];
    }
})($af862ae563a9409c$export$e7a817afd12a40d0);
/**
 * @ignore - internal component.
 */ const $af862ae563a9409c$var$NativeSelectInput = /*#__PURE__*/ $gJYWc.forwardRef(function NativeSelectInput(props, ref) {
    const { className: className, disabled: disabled, error: error, IconComponent: IconComponent, inputRef: inputRef, variant: variant = 'standard' } = props, other = (0, $cTAWX.default)(props, $af862ae563a9409c$var$_excluded);
    const ownerState = (0, $3VnFq.default)({}, props, {
        disabled: disabled,
        variant: variant,
        error: error
    });
    const classes = $af862ae563a9409c$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $9wx12.jsxs)($gJYWc.Fragment, {
        children: [
            /*#__PURE__*/ (0, $9wx12.jsx)($af862ae563a9409c$var$NativeSelectSelect, (0, $3VnFq.default)({
                ownerState: ownerState,
                className: (0, $2w6IV.default)(classes.select, className),
                disabled: disabled,
                ref: inputRef || ref
            }, other)),
            props.multiple ? null : /*#__PURE__*/ (0, $9wx12.jsx)($af862ae563a9409c$var$NativeSelectIcon, {
                as: IconComponent,
                ownerState: ownerState,
                className: classes.icon
            })
        ]
    });
});
var $af862ae563a9409c$export$2e2bcd8739ae039 = $af862ae563a9409c$var$NativeSelectInput;




var $HGmne = parcelRequire("HGmne");
var $67P0f = parcelRequire("67P0f");

var $il32z = parcelRequire("il32z");


var $i8nzj = parcelRequire("i8nzj");

var $1kRHf = parcelRequire("1kRHf");
function $5043994fdb5fca7f$export$2c0c1ee5a3392e(slot) {
    return (0, $1kRHf.default)('MuiSelect', slot);
}
const $5043994fdb5fca7f$var$selectClasses = (0, $i8nzj.default)('MuiSelect', [
    'root',
    'select',
    'multiple',
    'filled',
    'outlined',
    'standard',
    'disabled',
    'focused',
    'icon',
    'iconOpen',
    'iconFilled',
    'iconOutlined',
    'iconStandard',
    'nativeInput',
    'error'
]);
var $5043994fdb5fca7f$export$2e2bcd8739ae039 = $5043994fdb5fca7f$var$selectClasses;



var $9wx12 = parcelRequire("9wx12");
'use client';
var $c5d0c6af39ec6031$var$_span;
const $c5d0c6af39ec6031$var$_excluded = [
    "aria-describedby",
    "aria-label",
    "autoFocus",
    "autoWidth",
    "children",
    "className",
    "defaultOpen",
    "defaultValue",
    "disabled",
    "displayEmpty",
    "error",
    "IconComponent",
    "inputRef",
    "labelId",
    "MenuProps",
    "multiple",
    "name",
    "onBlur",
    "onChange",
    "onClose",
    "onFocus",
    "onOpen",
    "open",
    "readOnly",
    "renderValue",
    "SelectDisplayProps",
    "tabIndex",
    "type",
    "value",
    "variant"
];
const $c5d0c6af39ec6031$var$SelectSelect = (0, $HGmne.default)('div', {
    name: 'MuiSelect',
    slot: 'Select',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            // Win specificity over the input base
            {
                [`&.${(0, $5043994fdb5fca7f$export$2e2bcd8739ae039).select}`]: styles.select
            },
            {
                [`&.${(0, $5043994fdb5fca7f$export$2e2bcd8739ae039).select}`]: styles[ownerState.variant]
            },
            {
                [`&.${(0, $5043994fdb5fca7f$export$2e2bcd8739ae039).error}`]: styles.error
            },
            {
                [`&.${(0, $5043994fdb5fca7f$export$2e2bcd8739ae039).multiple}`]: styles.multiple
            }
        ];
    }
})((0, $af862ae563a9409c$export$c1eccd1617458c87), {
    // Win specificity over the input base
    [`&.${(0, $5043994fdb5fca7f$export$2e2bcd8739ae039).select}`]: {
        height: 'auto',
        // Resets for multiple select with chips
        minHeight: '1.4375em',
        // Required for select\text-field height consistency
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        overflow: 'hidden'
    }
});
const $c5d0c6af39ec6031$var$SelectIcon = (0, $HGmne.default)('svg', {
    name: 'MuiSelect',
    slot: 'Icon',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.icon,
            ownerState.variant && styles[`icon${(0, $cVrVk.default)(ownerState.variant)}`],
            ownerState.open && styles.iconOpen
        ];
    }
})((0, $af862ae563a9409c$export$e7a817afd12a40d0));
const $c5d0c6af39ec6031$var$SelectNativeInput = (0, $HGmne.default)('input', {
    shouldForwardProp: (prop)=>(0, $67P0f.default)(prop) && prop !== 'classes',
    name: 'MuiSelect',
    slot: 'NativeInput',
    overridesResolver: (props, styles)=>styles.nativeInput
})({
    bottom: 0,
    left: 0,
    position: 'absolute',
    opacity: 0,
    pointerEvents: 'none',
    width: '100%',
    boxSizing: 'border-box'
});
function $c5d0c6af39ec6031$var$areEqualValues(a, b) {
    if (typeof b === 'object' && b !== null) return a === b;
    // The value could be a number, the DOM will stringify it anyway.
    return String(a) === String(b);
}
function $c5d0c6af39ec6031$var$isEmpty(display) {
    return display == null || typeof display === 'string' && !display.trim();
}
const $c5d0c6af39ec6031$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, variant: variant, disabled: disabled, multiple: multiple, open: open, error: error } = ownerState;
    const slots = {
        select: [
            'select',
            variant,
            disabled && 'disabled',
            multiple && 'multiple',
            error && 'error'
        ],
        icon: [
            'icon',
            `icon${(0, $cVrVk.default)(variant)}`,
            open && 'iconOpen',
            disabled && 'disabled'
        ],
        nativeInput: [
            'nativeInput'
        ]
    };
    return (0, $3e4LV.default)(slots, (0, $5043994fdb5fca7f$export$2c0c1ee5a3392e), classes);
};
/**
 * @ignore - internal component.
 */ const $c5d0c6af39ec6031$var$SelectInput = /*#__PURE__*/ $gJYWc.forwardRef(function SelectInput(props, ref) {
    var _MenuProps$slotProps;
    const { 'aria-describedby': ariaDescribedby, 'aria-label': ariaLabel, autoFocus: autoFocus, autoWidth: autoWidth, children: children, className: className, defaultOpen: defaultOpen, defaultValue: defaultValue, disabled: disabled, displayEmpty: displayEmpty, error: error = false, IconComponent: IconComponent, inputRef: inputRefProp, labelId: labelId, MenuProps: MenuProps = {}, multiple: multiple, name: name, onBlur: onBlur, onChange: onChange, onClose: onClose, onFocus: onFocus, onOpen: onOpen, open: openProp, readOnly: readOnly, renderValue: renderValue, SelectDisplayProps: SelectDisplayProps = {}, tabIndex: tabIndexProp, value: valueProp, variant: variant = 'standard' } = props, other = (0, $cTAWX.default)(props, $c5d0c6af39ec6031$var$_excluded);
    const [value, setValueState] = (0, $acfba98c2e325db8$export$2e2bcd8739ae039)({
        controlled: valueProp,
        default: defaultValue,
        name: 'Select'
    });
    const [openState, setOpenState] = (0, $acfba98c2e325db8$export$2e2bcd8739ae039)({
        controlled: openProp,
        default: defaultOpen,
        name: 'Select'
    });
    const inputRef = $gJYWc.useRef(null);
    const displayRef = $gJYWc.useRef(null);
    const [displayNode, setDisplayNode] = $gJYWc.useState(null);
    const { current: isOpenControlled } = $gJYWc.useRef(openProp != null);
    const [menuMinWidthState, setMenuMinWidthState] = $gJYWc.useState();
    const handleRef = (0, $il32z.default)(ref, inputRefProp);
    const handleDisplayRef = $gJYWc.useCallback((node)=>{
        displayRef.current = node;
        if (node) setDisplayNode(node);
    }, []);
    const anchorElement = displayNode == null ? void 0 : displayNode.parentNode;
    $gJYWc.useImperativeHandle(handleRef, ()=>({
            focus: ()=>{
                displayRef.current.focus();
            },
            node: inputRef.current,
            value: value
        }), [
        value
    ]);
    // Resize menu on `defaultOpen` automatic toggle.
    $gJYWc.useEffect(()=>{
        if (defaultOpen && openState && displayNode && !isOpenControlled) {
            setMenuMinWidthState(autoWidth ? null : anchorElement.clientWidth);
            displayRef.current.focus();
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        displayNode,
        autoWidth
    ]);
    // `isOpenControlled` is ignored because the component should never switch between controlled and uncontrolled modes.
    // `defaultOpen` and `openState` are ignored to avoid unnecessary callbacks.
    $gJYWc.useEffect(()=>{
        if (autoFocus) displayRef.current.focus();
    }, [
        autoFocus
    ]);
    $gJYWc.useEffect(()=>{
        if (!labelId) return undefined;
        const label = (0, $755167b4f9e6f571$export$2e2bcd8739ae039)(displayRef.current).getElementById(labelId);
        if (label) {
            const handler = ()=>{
                if (getSelection().isCollapsed) displayRef.current.focus();
            };
            label.addEventListener('click', handler);
            return ()=>{
                label.removeEventListener('click', handler);
            };
        }
        return undefined;
    }, [
        labelId
    ]);
    const update = (open, event)=>{
        if (open) {
            if (onOpen) onOpen(event);
        } else if (onClose) onClose(event);
        if (!isOpenControlled) {
            setMenuMinWidthState(autoWidth ? null : anchorElement.clientWidth);
            setOpenState(open);
        }
    };
    const handleMouseDown = (event)=>{
        // Ignore everything but left-click
        if (event.button !== 0) return;
        // Hijack the default focus behavior.
        event.preventDefault();
        displayRef.current.focus();
        update(true, event);
    };
    const handleClose = (event)=>{
        update(false, event);
    };
    const childrenArray = $gJYWc.Children.toArray(children);
    // Support autofill.
    const handleChange = (event)=>{
        const child = childrenArray.find((childItem)=>childItem.props.value === event.target.value);
        if (child === undefined) return;
        setValueState(child.props.value);
        if (onChange) onChange(event, child);
    };
    const handleItemClick = (child)=>(event)=>{
            let newValue;
            // We use the tabindex attribute to signal the available options.
            if (!event.currentTarget.hasAttribute('tabindex')) return;
            if (multiple) {
                newValue = Array.isArray(value) ? value.slice() : [];
                const itemIndex = value.indexOf(child.props.value);
                if (itemIndex === -1) newValue.push(child.props.value);
                else newValue.splice(itemIndex, 1);
            } else newValue = child.props.value;
            if (child.props.onClick) child.props.onClick(event);
            if (value !== newValue) {
                setValueState(newValue);
                if (onChange) {
                    // Redefine target to allow name and value to be read.
                    // This allows seamless integration with the most popular form libraries.
                    // https://github.com/mui/material-ui/issues/13485#issuecomment-676048492
                    // Clone the event to not override `target` of the original event.
                    const nativeEvent = event.nativeEvent || event;
                    const clonedEvent = new nativeEvent.constructor(nativeEvent.type, nativeEvent);
                    Object.defineProperty(clonedEvent, 'target', {
                        writable: true,
                        value: {
                            value: newValue,
                            name: name
                        }
                    });
                    onChange(clonedEvent, child);
                }
            }
            if (!multiple) update(false, event);
        };
    const handleKeyDown = (event)=>{
        if (!readOnly) {
            const validKeys = [
                ' ',
                'ArrowUp',
                'ArrowDown',
                // The native select doesn't respond to enter on macOS, but it's recommended by
                // https://www.w3.org/WAI/ARIA/apg/patterns/combobox/examples/combobox-select-only/
                'Enter'
            ];
            if (validKeys.indexOf(event.key) !== -1) {
                event.preventDefault();
                update(true, event);
            }
        }
    };
    const open = displayNode !== null && openState;
    const handleBlur = (event)=>{
        // if open event.stopImmediatePropagation
        if (!open && onBlur) {
            // Preact support, target is read only property on a native event.
            Object.defineProperty(event, 'target', {
                writable: true,
                value: {
                    value: value,
                    name: name
                }
            });
            onBlur(event);
        }
    };
    delete other['aria-invalid'];
    let display;
    let displaySingle;
    const displayMultiple = [];
    let computeDisplay = false;
    let foundMatch = false;
    // No need to display any value if the field is empty.
    if ((0, $100e54cdfcc16a4b$export$d652b828d7fdeff8)({
        value: value
    }) || displayEmpty) {
        if (renderValue) display = renderValue(value);
        else computeDisplay = true;
    }
    const items = childrenArray.map((child)=>{
        if (!/*#__PURE__*/ $gJYWc.isValidElement(child)) return null;
        let selected;
        if (multiple) {
            if (!Array.isArray(value)) throw new Error((0, $lqJfJ.default)(2));
            selected = value.some((v)=>$c5d0c6af39ec6031$var$areEqualValues(v, child.props.value));
            if (selected && computeDisplay) displayMultiple.push(child.props.children);
        } else {
            selected = $c5d0c6af39ec6031$var$areEqualValues(value, child.props.value);
            if (selected && computeDisplay) displaySingle = child.props.children;
        }
        if (selected) foundMatch = true;
        return /*#__PURE__*/ $gJYWc.cloneElement(child, {
            'aria-selected': selected ? 'true' : 'false',
            onClick: handleItemClick(child),
            onKeyUp: (event)=>{
                if (event.key === ' ') // otherwise our MenuItems dispatches a click event
                // it's not behavior of the native <option> and causes
                // the select to close immediately since we open on space keydown
                event.preventDefault();
                if (child.props.onKeyUp) child.props.onKeyUp(event);
            },
            role: 'option',
            selected: selected,
            value: undefined,
            // The value is most likely not a valid HTML attribute.
            'data-value': child.props.value // Instead, we provide it as a data attribute.
        });
    });
    var x, x1;
    if (computeDisplay) {
        if (multiple) {
            if (displayMultiple.length === 0) display = null;
            else display = displayMultiple.reduce((output, child, index)=>{
                output.push(child);
                if (index < displayMultiple.length - 1) output.push(', ');
                return output;
            }, []);
        } else display = displaySingle;
    }
    // Avoid performing a layout computation in the render method.
    let menuMinWidth = menuMinWidthState;
    if (!autoWidth && isOpenControlled && displayNode) menuMinWidth = anchorElement.clientWidth;
    let tabIndex;
    if (typeof tabIndexProp !== 'undefined') tabIndex = tabIndexProp;
    else tabIndex = disabled ? null : 0;
    const buttonId = SelectDisplayProps.id || (name ? `mui-component-select-${name}` : undefined);
    const ownerState = (0, $3VnFq.default)({}, props, {
        variant: variant,
        value: value,
        open: open,
        error: error
    });
    const classes = $c5d0c6af39ec6031$var$useUtilityClasses(ownerState);
    const paperProps = (0, $3VnFq.default)({}, MenuProps.PaperProps, (_MenuProps$slotProps = MenuProps.slotProps) == null ? void 0 : _MenuProps$slotProps.paper);
    const listboxId = (0, $8fee44a510de4e75$export$2e2bcd8739ae039)();
    return /*#__PURE__*/ (0, $9wx12.jsxs)($gJYWc.Fragment, {
        children: [
            /*#__PURE__*/ (0, $9wx12.jsx)($c5d0c6af39ec6031$var$SelectSelect, (0, $3VnFq.default)({
                ref: handleDisplayRef,
                tabIndex: tabIndex,
                role: "combobox",
                "aria-controls": listboxId,
                "aria-disabled": disabled ? 'true' : undefined,
                "aria-expanded": open ? 'true' : 'false',
                "aria-haspopup": "listbox",
                "aria-label": ariaLabel,
                "aria-labelledby": [
                    labelId,
                    buttonId
                ].filter(Boolean).join(' ') || undefined,
                "aria-describedby": ariaDescribedby,
                onKeyDown: handleKeyDown,
                onMouseDown: disabled || readOnly ? null : handleMouseDown,
                onBlur: handleBlur,
                onFocus: onFocus
            }, SelectDisplayProps, {
                ownerState: ownerState,
                className: (0, $2w6IV.default)(SelectDisplayProps.className, classes.select, className),
                id: buttonId,
                children: $c5d0c6af39ec6031$var$isEmpty(display) ? $c5d0c6af39ec6031$var$_span || ($c5d0c6af39ec6031$var$_span = /*#__PURE__*/ (0, $9wx12.jsx)("span", {
                    className: "notranslate",
                    children: "\u200B"
                })) : display
            })),
            /*#__PURE__*/ (0, $9wx12.jsx)($c5d0c6af39ec6031$var$SelectNativeInput, (0, $3VnFq.default)({
                "aria-invalid": error,
                value: Array.isArray(value) ? value.join(',') : value,
                name: name,
                ref: inputRef,
                "aria-hidden": true,
                onChange: handleChange,
                tabIndex: -1,
                disabled: disabled,
                className: classes.nativeInput,
                autoFocus: autoFocus,
                ownerState: ownerState
            }, other)),
            /*#__PURE__*/ (0, $9wx12.jsx)($c5d0c6af39ec6031$var$SelectIcon, {
                as: IconComponent,
                className: classes.icon,
                ownerState: ownerState
            }),
            /*#__PURE__*/ (0, $9wx12.jsx)((0, $85bf06d3d7325d0c$export$2e2bcd8739ae039), (0, $3VnFq.default)({
                id: `menu-${name || ''}`,
                anchorEl: anchorElement,
                open: open,
                onClose: handleClose,
                anchorOrigin: {
                    vertical: 'bottom',
                    horizontal: 'center'
                },
                transformOrigin: {
                    vertical: 'top',
                    horizontal: 'center'
                }
            }, MenuProps, {
                MenuListProps: (0, $3VnFq.default)({
                    'aria-labelledby': labelId,
                    role: 'listbox',
                    'aria-multiselectable': multiple ? 'true' : undefined,
                    disableListWrap: true,
                    id: listboxId
                }, MenuProps.MenuListProps),
                slotProps: (0, $3VnFq.default)({}, MenuProps.slotProps, {
                    paper: (0, $3VnFq.default)({}, paperProps, {
                        style: (0, $3VnFq.default)({
                            minWidth: menuMinWidth
                        }, paperProps != null ? paperProps.style : null)
                    })
                }),
                children: items
            }))
        ]
    });
});
var $c5d0c6af39ec6031$export$2e2bcd8739ae039 = $c5d0c6af39ec6031$var$SelectInput;




parcelRequire("gJYWc");

var $ezPqr = parcelRequire("ezPqr");

var $9wx12 = parcelRequire("9wx12");
'use client';
var $32f9421941536b0c$export$2e2bcd8739ae039 = (0, $ezPqr.default)(/*#__PURE__*/ (0, $9wx12.jsx)("path", {
    d: "M7 10l5 5 5-5z"
}), 'ArrowDropDown');







var $8pLcn = parcelRequire("8pLcn");

var $il32z = parcelRequire("il32z");

var $HGmne = parcelRequire("HGmne");
var $8ttSm = parcelRequire("8ttSm");

var $9wx12 = parcelRequire("9wx12");
'use client';
const $5d97f150061e6360$var$_excluded = [
    "autoWidth",
    "children",
    "classes",
    "className",
    "defaultOpen",
    "displayEmpty",
    "IconComponent",
    "id",
    "input",
    "inputProps",
    "label",
    "labelId",
    "MenuProps",
    "multiple",
    "native",
    "onClose",
    "onOpen",
    "open",
    "renderValue",
    "SelectDisplayProps",
    "variant"
], $5d97f150061e6360$var$_excluded2 = [
    "root"
];
const $5d97f150061e6360$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    return classes;
};
const $5d97f150061e6360$var$styledRootConfig = {
    name: 'MuiSelect',
    overridesResolver: (props, styles)=>styles.root,
    shouldForwardProp: (prop)=>(0, $8ttSm.default)(prop) && prop !== 'variant',
    slot: 'Root'
};
const $5d97f150061e6360$var$StyledInput = (0, $HGmne.default)((0, $afeaec9eaf2af5ae$export$2e2bcd8739ae039), $5d97f150061e6360$var$styledRootConfig)('');
const $5d97f150061e6360$var$StyledOutlinedInput = (0, $HGmne.default)((0, $be3fe96c8bc9d690$export$2e2bcd8739ae039), $5d97f150061e6360$var$styledRootConfig)('');
const $5d97f150061e6360$var$StyledFilledInput = (0, $HGmne.default)((0, $ae69e2a5d495b952$export$2e2bcd8739ae039), $5d97f150061e6360$var$styledRootConfig)('');
const $5d97f150061e6360$var$Select = /*#__PURE__*/ $gJYWc.forwardRef(function Select(inProps, ref) {
    const props = (0, $8pLcn.useDefaultProps)({
        name: 'MuiSelect',
        props: inProps
    });
    const { autoWidth: autoWidth = false, children: children, classes: classesProp = {}, className: className, defaultOpen: defaultOpen = false, displayEmpty: displayEmpty = false, IconComponent: IconComponent = (0, $32f9421941536b0c$export$2e2bcd8739ae039), id: id, input: input, inputProps: inputProps, label: label, labelId: labelId, MenuProps: MenuProps, multiple: multiple = false, native: native = false, onClose: onClose, onOpen: onOpen, open: open, renderValue: renderValue, SelectDisplayProps: SelectDisplayProps, variant: variantProp = 'outlined' } = props, other = (0, $cTAWX.default)(props, $5d97f150061e6360$var$_excluded);
    const inputComponent = native ? (0, $af862ae563a9409c$export$2e2bcd8739ae039) : (0, $c5d0c6af39ec6031$export$2e2bcd8739ae039);
    const muiFormControl = (0, $7d9d5024ca7b136a$export$2e2bcd8739ae039)();
    const fcs = (0, $7f6a615e712efb52$export$2e2bcd8739ae039)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            'variant',
            'error'
        ]
    });
    const variant = fcs.variant || variantProp;
    const ownerState = (0, $3VnFq.default)({}, props, {
        variant: variant,
        classes: classesProp
    });
    const classes = $5d97f150061e6360$var$useUtilityClasses(ownerState);
    const restOfClasses = (0, $cTAWX.default)(classes, $5d97f150061e6360$var$_excluded2);
    const InputComponent = input || ({
        standard: /*#__PURE__*/ (0, $9wx12.jsx)($5d97f150061e6360$var$StyledInput, {
            ownerState: ownerState
        }),
        outlined: /*#__PURE__*/ (0, $9wx12.jsx)($5d97f150061e6360$var$StyledOutlinedInput, {
            label: label,
            ownerState: ownerState
        }),
        filled: /*#__PURE__*/ (0, $9wx12.jsx)($5d97f150061e6360$var$StyledFilledInput, {
            ownerState: ownerState
        })
    })[variant];
    const inputComponentRef = (0, $il32z.default)(ref, (0, $5e9a5fb2b833225d$export$2e2bcd8739ae039)(InputComponent));
    return /*#__PURE__*/ (0, $9wx12.jsx)($gJYWc.Fragment, {
        children: /*#__PURE__*/ $gJYWc.cloneElement(InputComponent, (0, $3VnFq.default)({
            inputComponent: // Most of the logic is implemented in `SelectInput`.
            // The `Select` component is a simple API wrapper to expose something better to play with.
            inputComponent,
            inputProps: (0, $3VnFq.default)({
                children: children,
                error: fcs.error,
                IconComponent: IconComponent,
                variant: variant,
                type: undefined,
                multiple: // We render a select. We can ignore the type provided by the `Input`.
                multiple
            }, native ? {
                id: id
            } : {
                autoWidth: autoWidth,
                defaultOpen: defaultOpen,
                displayEmpty: displayEmpty,
                labelId: labelId,
                MenuProps: MenuProps,
                onClose: onClose,
                onOpen: onOpen,
                open: open,
                renderValue: renderValue,
                SelectDisplayProps: (0, $3VnFq.default)({
                    id: id
                }, SelectDisplayProps)
            }, inputProps, {
                classes: inputProps ? (0, $dvHXN.default)(restOfClasses, inputProps.classes) : restOfClasses
            }, input ? input.props.inputProps : {})
        }, (multiple && native || displayEmpty) && variant === 'outlined' ? {
            notched: true
        } : {}, {
            ref: inputComponentRef,
            className: (0, $2w6IV.default)(InputComponent.props.className, className, classes.root)
        }, !input && {
            variant: variant
        }, other))
    });
});
$5d97f150061e6360$var$Select.muiName = 'Select';
var $5d97f150061e6360$export$2e2bcd8739ae039 = $5d97f150061e6360$var$Select;



var $i8nzj = parcelRequire("i8nzj");

var $1kRHf = parcelRequire("1kRHf");
function $78737d40ad94c70d$export$c1bdcbaf0596aeda(slot) {
    return (0, $1kRHf.default)('MuiTextField', slot);
}
const $78737d40ad94c70d$var$textFieldClasses = (0, $i8nzj.default)('MuiTextField', [
    'root'
]);
var $78737d40ad94c70d$export$2e2bcd8739ae039 = $78737d40ad94c70d$var$textFieldClasses;



var $9wx12 = parcelRequire("9wx12");
'use client';
const $1f9512c77b4eaf9c$var$_excluded = [
    "autoComplete",
    "autoFocus",
    "children",
    "className",
    "color",
    "defaultValue",
    "disabled",
    "error",
    "FormHelperTextProps",
    "fullWidth",
    "helperText",
    "id",
    "InputLabelProps",
    "inputProps",
    "InputProps",
    "inputRef",
    "label",
    "maxRows",
    "minRows",
    "multiline",
    "name",
    "onBlur",
    "onChange",
    "onFocus",
    "placeholder",
    "required",
    "rows",
    "select",
    "SelectProps",
    "type",
    "value",
    "variant"
];
const $1f9512c77b4eaf9c$var$variantComponent = {
    standard: (0, $afeaec9eaf2af5ae$export$2e2bcd8739ae039),
    filled: (0, $ae69e2a5d495b952$export$2e2bcd8739ae039),
    outlined: (0, $be3fe96c8bc9d690$export$2e2bcd8739ae039)
};
const $1f9512c77b4eaf9c$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ]
    };
    return (0, $3e4LV.default)(slots, (0, $78737d40ad94c70d$export$c1bdcbaf0596aeda), classes);
};
const $1f9512c77b4eaf9c$var$TextFieldRoot = (0, $HGmne.default)((0, $3acfb6ba72cad9c7$export$2e2bcd8739ae039), {
    name: 'MuiTextField',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})({});
/**
 * The `TextField` is a convenience wrapper for the most common cases (80%).
 * It cannot be all things to all people, otherwise the API would grow out of control.
 *
 * ## Advanced Configuration
 *
 * It's important to understand that the text field is a simple abstraction
 * on top of the following components:
 *
 * - [FormControl](/material-ui/api/form-control/)
 * - [InputLabel](/material-ui/api/input-label/)
 * - [FilledInput](/material-ui/api/filled-input/)
 * - [OutlinedInput](/material-ui/api/outlined-input/)
 * - [Input](/material-ui/api/input/)
 * - [FormHelperText](/material-ui/api/form-helper-text/)
 *
 * If you wish to alter the props applied to the `input` element, you can do so as follows:
 *
 * ```jsx
 * const inputProps = {
 *   step: 300,
 * };
 *
 * return <TextField id="time" type="time" inputProps={inputProps} />;
 * ```
 *
 * For advanced cases, please look at the source of TextField by clicking on the
 * "Edit this page" button above. Consider either:
 *
 * - using the upper case props for passing values directly to the components
 * - using the underlying components directly as shown in the demos
 */ const $1f9512c77b4eaf9c$var$TextField = /*#__PURE__*/ $gJYWc.forwardRef(function TextField(inProps, ref) {
    const props = (0, $8pLcn.useDefaultProps)({
        props: inProps,
        name: 'MuiTextField'
    });
    const { autoComplete: autoComplete, autoFocus: autoFocus = false, children: children, className: className, color: color = 'primary', defaultValue: defaultValue, disabled: disabled = false, error: error = false, FormHelperTextProps: FormHelperTextProps, fullWidth: fullWidth = false, helperText: helperText, id: idOverride, InputLabelProps: InputLabelProps, inputProps: inputProps, InputProps: InputProps, inputRef: inputRef, label: label, maxRows: maxRows, minRows: minRows, multiline: multiline = false, name: name, onBlur: onBlur, onChange: onChange, onFocus: onFocus, placeholder: placeholder, required: required = false, rows: rows, select: select = false, SelectProps: SelectProps, type: type, value: value, variant: variant = 'outlined' } = props, other = (0, $cTAWX.default)(props, $1f9512c77b4eaf9c$var$_excluded);
    const ownerState = (0, $3VnFq.default)({}, props, {
        autoFocus: autoFocus,
        color: color,
        disabled: disabled,
        error: error,
        fullWidth: fullWidth,
        multiline: multiline,
        required: required,
        select: select,
        variant: variant
    });
    const classes = $1f9512c77b4eaf9c$var$useUtilityClasses(ownerState);
    const InputMore = {};
    if (variant === 'outlined') {
        if (InputLabelProps && typeof InputLabelProps.shrink !== 'undefined') InputMore.notched = InputLabelProps.shrink;
        InputMore.label = label;
    }
    if (select) {
        // unset defaults from textbox inputs
        if (!SelectProps || !SelectProps.native) InputMore.id = undefined;
        InputMore['aria-describedby'] = undefined;
    }
    const id = (0, $8fee44a510de4e75$export$2e2bcd8739ae039)(idOverride);
    const helperTextId = helperText && id ? `${id}-helper-text` : undefined;
    const inputLabelId = label && id ? `${id}-label` : undefined;
    const InputComponent = $1f9512c77b4eaf9c$var$variantComponent[variant];
    const InputElement = /*#__PURE__*/ (0, $9wx12.jsx)(InputComponent, (0, $3VnFq.default)({
        "aria-describedby": helperTextId,
        autoComplete: autoComplete,
        autoFocus: autoFocus,
        defaultValue: defaultValue,
        fullWidth: fullWidth,
        multiline: multiline,
        name: name,
        rows: rows,
        maxRows: maxRows,
        minRows: minRows,
        type: type,
        value: value,
        id: id,
        inputRef: inputRef,
        onBlur: onBlur,
        onChange: onChange,
        onFocus: onFocus,
        placeholder: placeholder,
        inputProps: inputProps
    }, InputMore, InputProps));
    return /*#__PURE__*/ (0, $9wx12.jsxs)($1f9512c77b4eaf9c$var$TextFieldRoot, (0, $3VnFq.default)({
        className: (0, $2w6IV.default)(classes.root, className),
        disabled: disabled,
        error: error,
        fullWidth: fullWidth,
        ref: ref,
        required: required,
        color: color,
        variant: variant,
        ownerState: ownerState
    }, other, {
        children: [
            label != null && label !== '' && /*#__PURE__*/ (0, $9wx12.jsx)((0, $3fd7bb066fed2d52$export$2e2bcd8739ae039), (0, $3VnFq.default)({
                htmlFor: id,
                id: inputLabelId
            }, InputLabelProps, {
                children: label
            })),
            select ? /*#__PURE__*/ (0, $9wx12.jsx)((0, $5d97f150061e6360$export$2e2bcd8739ae039), (0, $3VnFq.default)({
                "aria-describedby": helperTextId,
                id: id,
                labelId: inputLabelId,
                value: value,
                input: InputElement
            }, SelectProps, {
                children: children
            })) : InputElement,
            helperText && /*#__PURE__*/ (0, $9wx12.jsx)((0, $cd07031769fd9ace$export$2e2bcd8739ae039), (0, $3VnFq.default)({
                id: helperTextId
            }, FormHelperTextProps, {
                children: helperText
            }))
        ]
    }));
});
var $1f9512c77b4eaf9c$export$2e2bcd8739ae039 = $1f9512c77b4eaf9c$var$TextField;






var $3VnFq = parcelRequire("3VnFq");


var $3VnFq = parcelRequire("3VnFq");

var $cTAWX = parcelRequire("cTAWX");

var $gJYWc = parcelRequire("gJYWc");

var $4z2O6 = parcelRequire("4z2O6");

var $92UcI = parcelRequire("92UcI");

var $4gWBK = parcelRequire("4gWBK");





var $3VnFq = parcelRequire("3VnFq");

var $gJYWc = parcelRequire("gJYWc");






const $435b1799011d9294$export$4e8d6353e50062e7 = (params)=>{
    const utils = (0, $98220f21a8625472$export$1163b47e39508a46)();
    const localeText = (0, $98220f21a8625472$export$24fdeaa0f591a73e)();
    const adapter = (0, $98220f21a8625472$export$4b5a24245de9f7f9)();
    const theme = (0, $ae968105fc5c093e$export$2e2bcd8739ae039)();
    const isRTL = theme.direction === 'rtl';
    const { valueManager: valueManager, fieldValueManager: fieldValueManager, valueType: valueType, validator: validator, internalProps: internalProps, internalProps: { value: valueProp, defaultValue: defaultValue, referenceDate: referenceDateProp, onChange: onChange, format: format, formatDensity: formatDensity = 'dense', selectedSections: selectedSectionsProp, onSelectedSectionsChange: onSelectedSectionsChange, shouldRespectLeadingZeros: shouldRespectLeadingZeros = false, timezone: timezoneProp } } = params;
    const { timezone: timezone, value: valueFromTheOutside, handleValueChange: handleValueChange } = (0, $666e75003bf5e8d6$export$c7e050e908c1b2bc)({
        timezone: timezoneProp,
        value: valueProp,
        defaultValue: defaultValue,
        onChange: onChange,
        valueManager: valueManager
    });
    const sectionsValueBoundaries = $gJYWc.useMemo(()=>(0, $5a21afc6f4ba9c13$export$360600f456ea7d5f)(utils, timezone), [
        utils,
        timezone
    ]);
    const getSectionsFromValue = $gJYWc.useCallback((value, fallbackSections = null)=>fieldValueManager.getSectionsFromValue(utils, value, fallbackSections, isRTL, (date)=>(0, $5a21afc6f4ba9c13$export$fd71d82fe42bada1)(utils, timezone, localeText, format, date, formatDensity, shouldRespectLeadingZeros, isRTL)), [
        fieldValueManager,
        format,
        localeText,
        isRTL,
        shouldRespectLeadingZeros,
        utils,
        formatDensity,
        timezone
    ]);
    const placeholder = $gJYWc.useMemo(()=>fieldValueManager.getValueStrFromSections(getSectionsFromValue(valueManager.emptyValue), isRTL), [
        fieldValueManager,
        getSectionsFromValue,
        valueManager.emptyValue,
        isRTL
    ]);
    const [state, setState] = $gJYWc.useState(()=>{
        const sections = getSectionsFromValue(valueFromTheOutside);
        (0, $5a21afc6f4ba9c13$export$ef6fbc09372bd65c)(sections, valueType);
        const stateWithoutReferenceDate = {
            sections: sections,
            value: valueFromTheOutside,
            referenceValue: valueManager.emptyValue,
            tempValueStrAndroid: null
        };
        const granularity = (0, $d8b7b2aeaa0755b4$export$3f2547ddf892237a)(sections);
        const referenceValue = valueManager.getInitialReferenceValue({
            referenceDate: referenceDateProp,
            value: valueFromTheOutside,
            utils: utils,
            props: internalProps,
            granularity: granularity,
            timezone: timezone
        });
        return (0, $3VnFq.default)({}, stateWithoutReferenceDate, {
            referenceValue: referenceValue
        });
    });
    const [selectedSections, innerSetSelectedSections] = (0, $778a260509dda869$export$2e2bcd8739ae039)({
        controlled: selectedSectionsProp,
        default: null,
        name: 'useField',
        state: 'selectedSectionIndexes'
    });
    const setSelectedSections = (newSelectedSections)=>{
        innerSetSelectedSections(newSelectedSections);
        onSelectedSectionsChange == null || onSelectedSectionsChange(newSelectedSections);
        setState((prevState)=>(0, $3VnFq.default)({}, prevState, {
                selectedSectionQuery: null
            }));
    };
    const selectedSectionIndexes = $gJYWc.useMemo(()=>{
        if (selectedSections == null) return null;
        if (selectedSections === 'all') return {
            startIndex: 0,
            endIndex: state.sections.length - 1,
            shouldSelectBoundarySelectors: true
        };
        if (typeof selectedSections === 'number') return {
            startIndex: selectedSections,
            endIndex: selectedSections
        };
        if (typeof selectedSections === 'string') {
            const selectedSectionIndex = state.sections.findIndex((section)=>section.type === selectedSections);
            return {
                startIndex: selectedSectionIndex,
                endIndex: selectedSectionIndex
            };
        }
        return selectedSections;
    }, [
        selectedSections,
        state.sections
    ]);
    const publishValue = ({ value: value, referenceValue: referenceValue, sections: sections })=>{
        setState((prevState)=>(0, $3VnFq.default)({}, prevState, {
                sections: sections,
                value: value,
                referenceValue: referenceValue,
                tempValueStrAndroid: null
            }));
        if (valueManager.areValuesEqual(utils, state.value, value)) return;
        const context = {
            validationError: validator({
                adapter: adapter,
                value: value,
                props: (0, $3VnFq.default)({}, internalProps, {
                    value: value,
                    timezone: timezone
                })
            })
        };
        handleValueChange(value, context);
    };
    const setSectionValue = (sectionIndex, newSectionValue)=>{
        const newSections = [
            ...state.sections
        ];
        newSections[sectionIndex] = (0, $3VnFq.default)({}, newSections[sectionIndex], {
            value: newSectionValue,
            modified: true
        });
        return (0, $5a21afc6f4ba9c13$export$8bb5d1c9951d10ca)(newSections, isRTL);
    };
    const clearValue = ()=>{
        publishValue({
            value: valueManager.emptyValue,
            referenceValue: state.referenceValue,
            sections: getSectionsFromValue(valueManager.emptyValue)
        });
    };
    const clearActiveSection = ()=>{
        if (selectedSectionIndexes == null) return;
        const activeSection = state.sections[selectedSectionIndexes.startIndex];
        const activeDateManager = fieldValueManager.getActiveDateManager(utils, state, activeSection);
        const nonEmptySectionCountBefore = activeDateManager.getSections(state.sections).filter((section)=>section.value !== '').length;
        const hasNoOtherNonEmptySections = nonEmptySectionCountBefore === (activeSection.value === '' ? 0 : 1);
        const newSections = setSectionValue(selectedSectionIndexes.startIndex, '');
        const newActiveDate = hasNoOtherNonEmptySections ? null : utils.date(new Date(''));
        const newValues = activeDateManager.getNewValuesFromNewActiveDate(newActiveDate);
        if ((newActiveDate != null && !utils.isValid(newActiveDate)) !== (activeDateManager.date != null && !utils.isValid(activeDateManager.date))) publishValue((0, $3VnFq.default)({}, newValues, {
            sections: newSections
        }));
        else setState((prevState)=>(0, $3VnFq.default)({}, prevState, newValues, {
                sections: newSections,
                tempValueStrAndroid: null
            }));
    };
    const updateValueFromValueStr = (valueStr)=>{
        const parseDateStr = (dateStr, referenceDate)=>{
            const date = utils.parse(dateStr, format);
            if (date == null || !utils.isValid(date)) return null;
            const sections = (0, $5a21afc6f4ba9c13$export$fd71d82fe42bada1)(utils, timezone, localeText, format, date, formatDensity, shouldRespectLeadingZeros, isRTL);
            return (0, $5a21afc6f4ba9c13$export$6c6df982c77f60a9)(utils, timezone, date, sections, referenceDate, false);
        };
        const newValue = fieldValueManager.parseValueStr(valueStr, state.referenceValue, parseDateStr);
        const newReferenceValue = fieldValueManager.updateReferenceValue(utils, newValue, state.referenceValue);
        publishValue({
            value: newValue,
            referenceValue: newReferenceValue,
            sections: getSectionsFromValue(newValue, state.sections)
        });
    };
    const updateSectionValue = ({ activeSection: activeSection, newSectionValue: newSectionValue, shouldGoToNextSection: shouldGoToNextSection })=>{
        /**
     * 1. Decide which section should be focused
     */ if (shouldGoToNextSection && selectedSectionIndexes && selectedSectionIndexes.startIndex < state.sections.length - 1) setSelectedSections(selectedSectionIndexes.startIndex + 1);
        else if (selectedSectionIndexes && selectedSectionIndexes.startIndex !== selectedSectionIndexes.endIndex) setSelectedSections(selectedSectionIndexes.startIndex);
        /**
     * 2. Try to build a valid date from the new section value
     */ const activeDateManager = fieldValueManager.getActiveDateManager(utils, state, activeSection);
        const newSections = setSectionValue(selectedSectionIndexes.startIndex, newSectionValue);
        const newActiveDateSections = activeDateManager.getSections(newSections);
        const newActiveDate = (0, $5a21afc6f4ba9c13$export$b0c1bfd065bfe742)(utils, newActiveDateSections);
        let values;
        let shouldPublish;
        /**
     * If the new date is valid,
     * Then we merge the value of the modified sections into the reference date.
     * This makes sure that we don't lose some information of the initial date (like the time on a date field).
     */ if (newActiveDate != null && utils.isValid(newActiveDate)) {
            const mergedDate = (0, $5a21afc6f4ba9c13$export$6c6df982c77f60a9)(utils, timezone, newActiveDate, newActiveDateSections, activeDateManager.referenceDate, true);
            values = activeDateManager.getNewValuesFromNewActiveDate(mergedDate);
            shouldPublish = true;
        } else {
            values = activeDateManager.getNewValuesFromNewActiveDate(newActiveDate);
            shouldPublish = (newActiveDate != null && !utils.isValid(newActiveDate)) !== (activeDateManager.date != null && !utils.isValid(activeDateManager.date));
        }
        /**
     * Publish or update the internal state with the new value and sections.
     */ if (shouldPublish) return publishValue((0, $3VnFq.default)({}, values, {
            sections: newSections
        }));
        return setState((prevState)=>(0, $3VnFq.default)({}, prevState, values, {
                sections: newSections,
                tempValueStrAndroid: null
            }));
    };
    const setTempAndroidValueStr = (tempValueStrAndroid)=>setState((prev)=>(0, $3VnFq.default)({}, prev, {
                tempValueStrAndroid: tempValueStrAndroid
            }));
    $gJYWc.useEffect(()=>{
        const sections = getSectionsFromValue(state.value);
        (0, $5a21afc6f4ba9c13$export$ef6fbc09372bd65c)(sections, valueType);
        setState((prevState)=>(0, $3VnFq.default)({}, prevState, {
                sections: sections
            }));
    }, [
        format,
        utils.locale
    ]); // eslint-disable-line react-hooks/exhaustive-deps
    $gJYWc.useEffect(()=>{
        let shouldUpdate = false;
        if (!valueManager.areValuesEqual(utils, state.value, valueFromTheOutside)) shouldUpdate = true;
        else shouldUpdate = valueManager.getTimezone(utils, state.value) !== valueManager.getTimezone(utils, valueFromTheOutside);
        if (shouldUpdate) setState((prevState)=>(0, $3VnFq.default)({}, prevState, {
                value: valueFromTheOutside,
                referenceValue: fieldValueManager.updateReferenceValue(utils, valueFromTheOutside, prevState.referenceValue),
                sections: getSectionsFromValue(valueFromTheOutside)
            }));
    }, [
        valueFromTheOutside
    ]); // eslint-disable-line react-hooks/exhaustive-deps
    return {
        state: state,
        selectedSectionIndexes: selectedSectionIndexes,
        setSelectedSections: setSelectedSections,
        clearValue: clearValue,
        clearActiveSection: clearActiveSection,
        updateSectionValue: updateSectionValue,
        updateValueFromValueStr: updateValueFromValueStr,
        setTempAndroidValueStr: setTempAndroidValueStr,
        sectionsValueBoundaries: sectionsValueBoundaries,
        placeholder: placeholder,
        timezone: timezone
    };
};



var $3VnFq = parcelRequire("3VnFq");

var $gJYWc = parcelRequire("gJYWc");

var $92UcI = parcelRequire("92UcI");


/**
 * The letter editing and the numeric editing each define a `CharacterEditingApplier`.
 * This function decides what the new section value should be and if the focus should switch to the next section.
 *
 * If it returns `null`, then the section value is not updated and the focus does not move.
 */ /**
 * Function called by `applyQuery` which decides:
 * - what is the new section value ?
 * - should the query used to get this value be stored for the next key press ?
 *
 * If it returns `{ sectionValue: string; shouldGoToNextSection: boolean }`,
 * Then we store the query and update the section with the new value.
 *
 * If it returns `{ saveQuery: true` },
 * Then we store the query and don't update the section.
 *
 * If it returns `{ saveQuery: false },
 * Then we do nothing.
 */ const $28d0e87c87491f32$var$QUERY_LIFE_DURATION_MS = 5000;
const $28d0e87c87491f32$var$isQueryResponseWithoutValue = (response)=>response.saveQuery != null;
const $28d0e87c87491f32$export$66d00048b8bb82f6 = ({ sections: sections, updateSectionValue: updateSectionValue, sectionsValueBoundaries: sectionsValueBoundaries, setTempAndroidValueStr: setTempAndroidValueStr, timezone: timezone })=>{
    const utils = (0, $98220f21a8625472$export$1163b47e39508a46)();
    const [query, setQuery] = $gJYWc.useState(null);
    const resetQuery = (0, $92UcI.default)(()=>setQuery(null));
    $gJYWc.useEffect(()=>{
        var _sections$query$secti;
        if (query != null && ((_sections$query$secti = sections[query.sectionIndex]) == null ? void 0 : _sections$query$secti.type) !== query.sectionType) resetQuery();
    }, [
        sections,
        query,
        resetQuery
    ]);
    $gJYWc.useEffect(()=>{
        if (query != null) {
            const timeout = setTimeout(()=>resetQuery(), $28d0e87c87491f32$var$QUERY_LIFE_DURATION_MS);
            return ()=>{
                window.clearTimeout(timeout);
            };
        }
        return ()=>{};
    }, [
        query,
        resetQuery
    ]);
    const applyQuery = ({ keyPressed: keyPressed, sectionIndex: sectionIndex }, getFirstSectionValueMatchingWithQuery, isValidQueryValue)=>{
        const cleanKeyPressed = keyPressed.toLowerCase();
        const activeSection = sections[sectionIndex];
        // The current query targets the section being editing
        // We can try to concatenated value
        if (query != null && (!isValidQueryValue || isValidQueryValue(query.value)) && query.sectionIndex === sectionIndex) {
            const concatenatedQueryValue = `${query.value}${cleanKeyPressed}`;
            const queryResponse = getFirstSectionValueMatchingWithQuery(concatenatedQueryValue, activeSection);
            if (!$28d0e87c87491f32$var$isQueryResponseWithoutValue(queryResponse)) {
                setQuery({
                    sectionIndex: sectionIndex,
                    value: concatenatedQueryValue,
                    sectionType: activeSection.type
                });
                return queryResponse;
            }
        }
        const queryResponse = getFirstSectionValueMatchingWithQuery(cleanKeyPressed, activeSection);
        if ($28d0e87c87491f32$var$isQueryResponseWithoutValue(queryResponse) && !queryResponse.saveQuery) {
            resetQuery();
            return null;
        }
        setQuery({
            sectionIndex: sectionIndex,
            value: cleanKeyPressed,
            sectionType: activeSection.type
        });
        if ($28d0e87c87491f32$var$isQueryResponseWithoutValue(queryResponse)) return null;
        return queryResponse;
    };
    const applyLetterEditing = (params)=>{
        const findMatchingOptions = (format, options, queryValue)=>{
            const matchingValues = options.filter((option)=>option.toLowerCase().startsWith(queryValue));
            if (matchingValues.length === 0) return {
                saveQuery: false
            };
            return {
                sectionValue: matchingValues[0],
                shouldGoToNextSection: matchingValues.length === 1
            };
        };
        const testQueryOnFormatAndFallbackFormat = (queryValue, activeSection, fallbackFormat, formatFallbackValue)=>{
            const getOptions = (format)=>(0, $5a21afc6f4ba9c13$export$3ee1e7e19c2b047a)(utils, timezone, activeSection.type, format);
            if (activeSection.contentType === 'letter') return findMatchingOptions(activeSection.format, getOptions(activeSection.format), queryValue);
            // When editing a digit-format month / weekDay and the user presses a letter,
            // We can support the letter editing by using the letter-format month / weekDay and re-formatting the result.
            // We just have to make sure that the default month / weekDay format is a letter format,
            if (fallbackFormat && formatFallbackValue != null && (0, $5a21afc6f4ba9c13$export$2f3c5fac7a2a65f6)(utils, fallbackFormat).contentType === 'letter') {
                const fallbackOptions = getOptions(fallbackFormat);
                const response = findMatchingOptions(fallbackFormat, fallbackOptions, queryValue);
                if ($28d0e87c87491f32$var$isQueryResponseWithoutValue(response)) return {
                    saveQuery: false
                };
                return (0, $3VnFq.default)({}, response, {
                    sectionValue: formatFallbackValue(response.sectionValue, fallbackOptions)
                });
            }
            return {
                saveQuery: false
            };
        };
        const getFirstSectionValueMatchingWithQuery = (queryValue, activeSection)=>{
            switch(activeSection.type){
                case 'month':
                    {
                        const formatFallbackValue = (fallbackValue)=>(0, $5a21afc6f4ba9c13$export$2816862a602354ce)(utils, fallbackValue, utils.formats.month, activeSection.format);
                        return testQueryOnFormatAndFallbackFormat(queryValue, activeSection, utils.formats.month, formatFallbackValue);
                    }
                case 'weekDay':
                    {
                        const formatFallbackValue = (fallbackValue, fallbackOptions)=>fallbackOptions.indexOf(fallbackValue).toString();
                        return testQueryOnFormatAndFallbackFormat(queryValue, activeSection, utils.formats.weekday, formatFallbackValue);
                    }
                case 'meridiem':
                    return testQueryOnFormatAndFallbackFormat(queryValue, activeSection);
                default:
                    return {
                        saveQuery: false
                    };
            }
        };
        return applyQuery(params, getFirstSectionValueMatchingWithQuery);
    };
    const applyNumericEditing = (params)=>{
        const getNewSectionValue = (queryValue, section)=>{
            const queryValueNumber = Number(`${queryValue}`);
            const sectionBoundaries = sectionsValueBoundaries[section.type]({
                currentDate: null,
                format: section.format,
                contentType: section.contentType
            });
            if (queryValueNumber > sectionBoundaries.maximum) return {
                saveQuery: false
            };
            // If the user types `0` on a month section,
            // It is below the minimum, but we want to store the `0` in the query,
            // So that when he pressed `1`, it will store `01` and move to the next section.
            if (queryValueNumber < sectionBoundaries.minimum) return {
                saveQuery: true
            };
            const shouldGoToNextSection = Number(`${queryValue}0`) > sectionBoundaries.maximum || queryValue.length === sectionBoundaries.maximum.toString().length;
            const newSectionValue = (0, $5a21afc6f4ba9c13$export$ef88db4bceade9fd)(utils, timezone, queryValueNumber, sectionBoundaries, section);
            return {
                sectionValue: newSectionValue,
                shouldGoToNextSection: shouldGoToNextSection
            };
        };
        const getFirstSectionValueMatchingWithQuery = (queryValue, activeSection)=>{
            if (activeSection.contentType === 'digit' || activeSection.contentType === 'digit-with-letter') return getNewSectionValue(queryValue, activeSection);
            // When editing a letter-format month and the user presses a digit,
            // We can support the numeric editing by using the digit-format month and re-formatting the result.
            if (activeSection.type === 'month') {
                const hasLeadingZerosInFormat = (0, $5a21afc6f4ba9c13$export$78b5830e2dd2de49)(utils, timezone, 'digit', 'month', 'MM');
                const response = getNewSectionValue(queryValue, {
                    type: activeSection.type,
                    format: 'MM',
                    hasLeadingZerosInFormat: hasLeadingZerosInFormat,
                    hasLeadingZerosInInput: true,
                    contentType: 'digit',
                    maxLength: 2
                });
                if ($28d0e87c87491f32$var$isQueryResponseWithoutValue(response)) return response;
                const formattedValue = (0, $5a21afc6f4ba9c13$export$2816862a602354ce)(utils, response.sectionValue, 'MM', activeSection.format);
                return (0, $3VnFq.default)({}, response, {
                    sectionValue: formattedValue
                });
            }
            // When editing a letter-format weekDay and the user presses a digit,
            // We can support the numeric editing by returning the nth day in the week day array.
            if (activeSection.type === 'weekDay') {
                const response = getNewSectionValue(queryValue, activeSection);
                if ($28d0e87c87491f32$var$isQueryResponseWithoutValue(response)) return response;
                const formattedValue = (0, $5a21afc6f4ba9c13$export$c65c7173f879039f)(utils, timezone, activeSection.format)[Number(response.sectionValue) - 1];
                return (0, $3VnFq.default)({}, response, {
                    sectionValue: formattedValue
                });
            }
            return {
                saveQuery: false
            };
        };
        return applyQuery(params, getFirstSectionValueMatchingWithQuery, (queryValue)=>!Number.isNaN(Number(queryValue)));
    };
    const applyCharacterEditing = (0, $92UcI.default)((params)=>{
        const activeSection = sections[params.sectionIndex];
        const isNumericEditing = params.keyPressed !== ' ' && !Number.isNaN(Number(params.keyPressed));
        const response = isNumericEditing ? applyNumericEditing(params) : applyLetterEditing(params);
        if (response == null) setTempAndroidValueStr(null);
        else updateSectionValue({
            activeSection: activeSection,
            newSectionValue: response.sectionValue,
            shouldGoToNextSection: response.shouldGoToNextSection
        });
    });
    return {
        applyCharacterEditing: applyCharacterEditing,
        resetCharacterQuery: resetQuery
    };
};



const $5bbb9f44cfbbf3b7$var$_excluded = [
    "onClick",
    "onKeyDown",
    "onFocus",
    "onBlur",
    "onMouseUp",
    "onPaste",
    "error",
    "clearable",
    "onClear",
    "disabled"
];
const $5bbb9f44cfbbf3b7$export$294aa081a6c6f55d = (params)=>{
    const utils = (0, $98220f21a8625472$export$1163b47e39508a46)();
    const { state: state, selectedSectionIndexes: selectedSectionIndexes, setSelectedSections: setSelectedSections, clearValue: clearValue, clearActiveSection: clearActiveSection, updateSectionValue: updateSectionValue, updateValueFromValueStr: updateValueFromValueStr, setTempAndroidValueStr: setTempAndroidValueStr, sectionsValueBoundaries: sectionsValueBoundaries, placeholder: placeholder, timezone: timezone } = (0, $435b1799011d9294$export$4e8d6353e50062e7)(params);
    const { inputRef: inputRefProp, internalProps: internalProps, internalProps: { readOnly: readOnly = false, unstableFieldRef: unstableFieldRef, minutesStep: minutesStep }, forwardedProps: { onClick: onClick, onKeyDown: onKeyDown, onFocus: onFocus, onBlur: onBlur, onMouseUp: onMouseUp, onPaste: onPaste, error: error, clearable: clearable, onClear: onClear, disabled: disabled }, fieldValueManager: fieldValueManager, valueManager: valueManager, validator: validator } = params, otherForwardedProps = (0, $cTAWX.default)(params.forwardedProps, $5bbb9f44cfbbf3b7$var$_excluded);
    const { applyCharacterEditing: applyCharacterEditing, resetCharacterQuery: resetCharacterQuery } = (0, $28d0e87c87491f32$export$66d00048b8bb82f6)({
        sections: state.sections,
        updateSectionValue: updateSectionValue,
        sectionsValueBoundaries: sectionsValueBoundaries,
        setTempAndroidValueStr: setTempAndroidValueStr,
        timezone: timezone
    });
    const inputRef = $gJYWc.useRef(null);
    const handleRef = (0, $4gWBK.default)(inputRefProp, inputRef);
    const focusTimeoutRef = $gJYWc.useRef(undefined);
    const theme = (0, $ae968105fc5c093e$export$2e2bcd8739ae039)();
    const isRTL = theme.direction === 'rtl';
    const sectionOrder = $gJYWc.useMemo(()=>(0, $5a21afc6f4ba9c13$export$7725fd6fe0a2aadf)(state.sections, isRTL), [
        state.sections,
        isRTL
    ]);
    const syncSelectionFromDOM = ()=>{
        var _selectionStart;
        if (readOnly) {
            setSelectedSections(null);
            return;
        }
        const browserStartIndex = (_selectionStart = inputRef.current.selectionStart) != null ? _selectionStart : 0;
        let nextSectionIndex;
        if (browserStartIndex <= state.sections[0].startInInput) // Special case if browser index is in invisible characters at the beginning
        nextSectionIndex = 1;
        else if (browserStartIndex >= state.sections[state.sections.length - 1].endInInput) // If the click is after the last character of the input, then we want to select the 1st section.
        nextSectionIndex = 1;
        else nextSectionIndex = state.sections.findIndex((section)=>section.startInInput - section.startSeparator.length > browserStartIndex);
        const sectionIndex = nextSectionIndex === -1 ? state.sections.length - 1 : nextSectionIndex - 1;
        setSelectedSections(sectionIndex);
    };
    const handleInputClick = (0, $92UcI.default)((event, ...args)=>{
        // The click event on the clear button would propagate to the input, trigger this handler and result in a wrong section selection.
        // We avoid this by checking if the call of `handleInputClick` is actually intended, or a side effect.
        if (event.isDefaultPrevented()) return;
        onClick == null || onClick(event, ...args);
        syncSelectionFromDOM();
    });
    const handleInputMouseUp = (0, $92UcI.default)((event)=>{
        onMouseUp == null || onMouseUp(event);
        // Without this, the browser will remove the selected when clicking inside an already-selected section.
        event.preventDefault();
    });
    const handleInputFocus = (0, $92UcI.default)((...args)=>{
        onFocus == null || onFocus(...args);
        // The ref is guaranteed to be resolved at this point.
        const input = inputRef.current;
        window.clearTimeout(focusTimeoutRef.current);
        focusTimeoutRef.current = setTimeout(()=>{
            // The ref changed, the component got remounted, the focus event is no longer relevant.
            if (!input || input !== inputRef.current) return;
            if (selectedSectionIndexes != null || readOnly) return;
            if (// avoid selecting all sections when focusing empty field without value
            input.value.length && Number(input.selectionEnd) - Number(input.selectionStart) === input.value.length) setSelectedSections('all');
            else syncSelectionFromDOM();
        });
    });
    const handleInputBlur = (0, $92UcI.default)((...args)=>{
        onBlur == null || onBlur(...args);
        setSelectedSections(null);
    });
    const handleInputPaste = (0, $92UcI.default)((event)=>{
        onPaste == null || onPaste(event);
        if (readOnly) {
            event.preventDefault();
            return;
        }
        const pastedValue = event.clipboardData.getData('text');
        if (selectedSectionIndexes && selectedSectionIndexes.startIndex === selectedSectionIndexes.endIndex) {
            const activeSection = state.sections[selectedSectionIndexes.startIndex];
            const lettersOnly = /^[a-zA-Z]+$/.test(pastedValue);
            const digitsOnly = /^[0-9]+$/.test(pastedValue);
            const digitsAndLetterOnly = /^(([a-zA-Z]+)|)([0-9]+)(([a-zA-Z]+)|)$/.test(pastedValue);
            const isValidPastedValue = activeSection.contentType === 'letter' && lettersOnly || activeSection.contentType === 'digit' && digitsOnly || activeSection.contentType === 'digit-with-letter' && digitsAndLetterOnly;
            if (isValidPastedValue) {
                resetCharacterQuery();
                updateSectionValue({
                    activeSection: activeSection,
                    newSectionValue: pastedValue,
                    shouldGoToNextSection: true
                });
                // prevent default to avoid the input change handler being called
                event.preventDefault();
                return;
            }
            if (lettersOnly || digitsOnly) {
                // The pasted value correspond to a single section but not the expected type
                // skip the modification
                event.preventDefault();
                return;
            }
        }
        event.preventDefault();
        resetCharacterQuery();
        updateValueFromValueStr(pastedValue);
    });
    const handleInputChange = (0, $92UcI.default)((event)=>{
        if (readOnly) return;
        const targetValue = event.target.value;
        if (targetValue === '') {
            resetCharacterQuery();
            clearValue();
            return;
        }
        const eventData = event.nativeEvent.data;
        // Calling `.fill(04/11/2022)` in playwright will trigger a change event with the requested content to insert in `event.nativeEvent.data`
        // usual changes have only the currently typed character in the `event.nativeEvent.data`
        const shouldUseEventData = eventData && eventData.length > 1;
        const valueStr = shouldUseEventData ? eventData : targetValue;
        const cleanValueStr = (0, $5a21afc6f4ba9c13$export$cb0bbc88c7f09596)(valueStr);
        // If no section is selected or eventData should be used, we just try to parse the new value
        // This line is mostly triggered by imperative code / application tests.
        if (selectedSectionIndexes == null || shouldUseEventData) {
            updateValueFromValueStr(shouldUseEventData ? eventData : cleanValueStr);
            return;
        }
        let keyPressed;
        if (selectedSectionIndexes.startIndex === 0 && selectedSectionIndexes.endIndex === state.sections.length - 1 && cleanValueStr.length === 1) keyPressed = cleanValueStr;
        else {
            const prevValueStr = (0, $5a21afc6f4ba9c13$export$cb0bbc88c7f09596)(fieldValueManager.getValueStrFromSections(state.sections, isRTL));
            let startOfDiffIndex = -1;
            let endOfDiffIndex = -1;
            for(let i = 0; i < prevValueStr.length; i += 1){
                if (startOfDiffIndex === -1 && prevValueStr[i] !== cleanValueStr[i]) startOfDiffIndex = i;
                if (endOfDiffIndex === -1 && prevValueStr[prevValueStr.length - i - 1] !== cleanValueStr[cleanValueStr.length - i - 1]) endOfDiffIndex = i;
            }
            const activeSection = state.sections[selectedSectionIndexes.startIndex];
            const hasDiffOutsideOfActiveSection = startOfDiffIndex < activeSection.start || prevValueStr.length - endOfDiffIndex - 1 > activeSection.end;
            if (hasDiffOutsideOfActiveSection) // TODO: Support if the new date is valid
            return;
            // The active section being selected, the browser has replaced its value with the key pressed by the user.
            const activeSectionEndRelativeToNewValue = cleanValueStr.length - prevValueStr.length + activeSection.end - (0, $5a21afc6f4ba9c13$export$cb0bbc88c7f09596)(activeSection.endSeparator || '').length;
            keyPressed = cleanValueStr.slice(activeSection.start + (0, $5a21afc6f4ba9c13$export$cb0bbc88c7f09596)(activeSection.startSeparator || '').length, activeSectionEndRelativeToNewValue);
        }
        if (keyPressed.length === 0) {
            if ((0, $5a21afc6f4ba9c13$export$a11b0059900ceec8)()) setTempAndroidValueStr(valueStr);
            else {
                resetCharacterQuery();
                clearActiveSection();
            }
            return;
        }
        applyCharacterEditing({
            keyPressed: keyPressed,
            sectionIndex: selectedSectionIndexes.startIndex
        });
    });
    const handleInputKeyDown = (0, $92UcI.default)((event)=>{
        onKeyDown == null || onKeyDown(event);
        // eslint-disable-next-line default-case
        switch(true){
            // Select all
            case event.key === 'a' && (event.ctrlKey || event.metaKey):
                // prevent default to make sure that the next line "select all" while updating
                // the internal state at the same time.
                event.preventDefault();
                setSelectedSections('all');
                break;
            // Move selection to next section
            case event.key === 'ArrowRight':
                event.preventDefault();
                if (selectedSectionIndexes == null) setSelectedSections(sectionOrder.startIndex);
                else if (selectedSectionIndexes.startIndex !== selectedSectionIndexes.endIndex) setSelectedSections(selectedSectionIndexes.endIndex);
                else {
                    const nextSectionIndex = sectionOrder.neighbors[selectedSectionIndexes.startIndex].rightIndex;
                    if (nextSectionIndex !== null) setSelectedSections(nextSectionIndex);
                }
                break;
            // Move selection to previous section
            case event.key === 'ArrowLeft':
                event.preventDefault();
                if (selectedSectionIndexes == null) setSelectedSections(sectionOrder.endIndex);
                else if (selectedSectionIndexes.startIndex !== selectedSectionIndexes.endIndex) setSelectedSections(selectedSectionIndexes.startIndex);
                else {
                    const nextSectionIndex = sectionOrder.neighbors[selectedSectionIndexes.startIndex].leftIndex;
                    if (nextSectionIndex !== null) setSelectedSections(nextSectionIndex);
                }
                break;
            // Reset the value of the selected section
            case event.key === 'Delete':
                event.preventDefault();
                if (readOnly) break;
                if (selectedSectionIndexes == null || selectedSectionIndexes.startIndex === 0 && selectedSectionIndexes.endIndex === state.sections.length - 1) clearValue();
                else clearActiveSection();
                resetCharacterQuery();
                break;
            // Increment / decrement the selected section value
            case [
                'ArrowUp',
                'ArrowDown',
                'Home',
                'End',
                'PageUp',
                'PageDown'
            ].includes(event.key):
                {
                    event.preventDefault();
                    if (readOnly || selectedSectionIndexes == null) break;
                    const activeSection = state.sections[selectedSectionIndexes.startIndex];
                    const activeDateManager = fieldValueManager.getActiveDateManager(utils, state, activeSection);
                    const newSectionValue = (0, $5a21afc6f4ba9c13$export$5ed0f22513e58fe3)(utils, timezone, activeSection, event.key, sectionsValueBoundaries, activeDateManager.date, {
                        minutesStep: minutesStep
                    });
                    updateSectionValue({
                        activeSection: activeSection,
                        newSectionValue: newSectionValue,
                        shouldGoToNextSection: false
                    });
                    break;
                }
        }
    });
    (0, $4z2O6.default)(()=>{
        if (!inputRef.current) return;
        if (selectedSectionIndexes == null) {
            if (inputRef.current.scrollLeft) // Ensure that input content is not marked as selected.
            // setting selection range to 0 causes issues in Safari.
            // https://bugs.webkit.org/show_bug.cgi?id=224425
            inputRef.current.scrollLeft = 0;
            return;
        }
        const firstSelectedSection = state.sections[selectedSectionIndexes.startIndex];
        const lastSelectedSection = state.sections[selectedSectionIndexes.endIndex];
        let selectionStart = firstSelectedSection.startInInput;
        let selectionEnd = lastSelectedSection.endInInput;
        if (selectedSectionIndexes.shouldSelectBoundarySelectors) {
            selectionStart -= firstSelectedSection.startSeparator.length;
            selectionEnd += lastSelectedSection.endSeparator.length;
        }
        if (selectionStart !== inputRef.current.selectionStart || selectionEnd !== inputRef.current.selectionEnd) {
            // Fix scroll jumping on iOS browser: https://github.com/mui/mui-x/issues/8321
            const currentScrollTop = inputRef.current.scrollTop;
            // On multi input range pickers we want to update selection range only for the active input
            // This helps to avoid the focus jumping on Safari https://github.com/mui/mui-x/issues/9003
            // because WebKit implements the `setSelectionRange` based on the spec: https://bugs.webkit.org/show_bug.cgi?id=224425
            if (inputRef.current === (0, $870e97cd00438bdc$export$cd4e5573fbe2b576)(document)) inputRef.current.setSelectionRange(selectionStart, selectionEnd);
            // Even reading this variable seems to do the trick, but also setting it just to make use of it
            inputRef.current.scrollTop = currentScrollTop;
        }
    });
    const validationError = (0, $472026ded0a307f1$export$87fe492f99f25a20)((0, $3VnFq.default)({}, internalProps, {
        value: state.value,
        timezone: timezone
    }), validator, valueManager.isSameError, valueManager.defaultErrorState);
    const inputError = $gJYWc.useMemo(()=>{
        // only override when `error` is undefined.
        // in case of multi input fields, the `error` value is provided externally and will always be defined.
        if (error !== undefined) return error;
        return valueManager.hasError(validationError);
    }, [
        valueManager,
        validationError,
        error
    ]);
    $gJYWc.useEffect(()=>{
        if (!inputError && !selectedSectionIndexes) resetCharacterQuery();
    }, [
        state.referenceValue,
        selectedSectionIndexes,
        inputError
    ]); // eslint-disable-line react-hooks/exhaustive-deps
    $gJYWc.useEffect(()=>{
        // Select the right section when focused on mount (`autoFocus = true` on the input)
        if (inputRef.current && inputRef.current === document.activeElement) setSelectedSections('all');
        return ()=>window.clearTimeout(focusTimeoutRef.current);
    }, []); // eslint-disable-line react-hooks/exhaustive-deps
    // If `state.tempValueStrAndroid` is still defined when running `useEffect`,
    // Then `onChange` has only been called once, which means the user pressed `Backspace` to reset the section.
    // This causes a small flickering on Android,
    // But we can't use `useEnhancedEffect` which is always called before the second `onChange` call and then would cause false positives.
    $gJYWc.useEffect(()=>{
        if (state.tempValueStrAndroid != null && selectedSectionIndexes != null) {
            resetCharacterQuery();
            clearActiveSection();
        }
    }, [
        state.tempValueStrAndroid
    ]); // eslint-disable-line react-hooks/exhaustive-deps
    const valueStr = $gJYWc.useMemo(()=>{
        var _state$tempValueStrAn;
        return (_state$tempValueStrAn = state.tempValueStrAndroid) != null ? _state$tempValueStrAn : fieldValueManager.getValueStrFromSections(state.sections, isRTL);
    }, [
        state.sections,
        fieldValueManager,
        state.tempValueStrAndroid,
        isRTL
    ]);
    const inputMode = $gJYWc.useMemo(()=>{
        if (selectedSectionIndexes == null) return 'text';
        if (state.sections[selectedSectionIndexes.startIndex].contentType === 'letter') return 'text';
        return 'numeric';
    }, [
        selectedSectionIndexes,
        state.sections
    ]);
    const inputHasFocus = inputRef.current && inputRef.current === (0, $870e97cd00438bdc$export$cd4e5573fbe2b576)(document);
    const areAllSectionsEmpty = valueManager.areValuesEqual(utils, state.value, valueManager.emptyValue);
    const shouldShowPlaceholder = !inputHasFocus && areAllSectionsEmpty;
    $gJYWc.useImperativeHandle(unstableFieldRef, ()=>({
            getSections: ()=>state.sections,
            getActiveSectionIndex: ()=>{
                var _selectionStart2, _selectionEnd, _inputRef$current;
                const browserStartIndex = (_selectionStart2 = inputRef.current.selectionStart) != null ? _selectionStart2 : 0;
                const browserEndIndex = (_selectionEnd = inputRef.current.selectionEnd) != null ? _selectionEnd : 0;
                const isInputReadOnly = !!((_inputRef$current = inputRef.current) != null && _inputRef$current.readOnly);
                if (browserStartIndex === 0 && browserEndIndex === 0 || isInputReadOnly) return null;
                const nextSectionIndex = browserStartIndex <= state.sections[0].startInInput ? 1 // Special case if browser index is in invisible characters at the beginning.
                 : state.sections.findIndex((section)=>section.startInInput - section.startSeparator.length > browserStartIndex);
                return nextSectionIndex === -1 ? state.sections.length - 1 : nextSectionIndex - 1;
            },
            setSelectedSections: (activeSectionIndex)=>setSelectedSections(activeSectionIndex)
        }));
    const handleClearValue = (0, $92UcI.default)((event, ...args)=>{
        var _inputRef$current2;
        event.preventDefault();
        onClear == null || onClear(event, ...args);
        clearValue();
        inputRef == null || (_inputRef$current2 = inputRef.current) == null || _inputRef$current2.focus();
        setSelectedSections(0);
    });
    return (0, $3VnFq.default)({
        placeholder: placeholder,
        autoComplete: 'off',
        disabled: Boolean(disabled)
    }, otherForwardedProps, {
        value: shouldShowPlaceholder ? '' : valueStr,
        inputMode: inputMode,
        readOnly: readOnly,
        onClick: handleInputClick,
        onFocus: handleInputFocus,
        onBlur: handleInputBlur,
        onPaste: handleInputPaste,
        onChange: handleInputChange,
        onKeyDown: handleInputKeyDown,
        onMouseUp: handleInputMouseUp,
        onClear: handleClearValue,
        error: inputError,
        ref: handleRef,
        clearable: Boolean(clearable && !areAllSectionsEmpty && !readOnly && !disabled)
    });
};






var $3VnFq = parcelRequire("3VnFq");
const $e3a0d6a34962839a$export$430d9fc64cf058d6 = [
    'disablePast',
    'disableFuture',
    'minDate',
    'maxDate',
    'shouldDisableDate',
    'shouldDisableMonth',
    'shouldDisableYear'
];
const $e3a0d6a34962839a$export$fd5e0f8b4115a8c7 = [
    'disablePast',
    'disableFuture',
    'minTime',
    'maxTime',
    'shouldDisableClock',
    'shouldDisableTime',
    'minutesStep',
    'ampm',
    'disableIgnoringDatePartForTimeValidation'
];
const $e3a0d6a34962839a$export$1df62d3ba2121371 = [
    'minDateTime',
    'maxDateTime'
];
const $e3a0d6a34962839a$var$VALIDATION_PROP_NAMES = [
    ...$e3a0d6a34962839a$export$430d9fc64cf058d6,
    ...$e3a0d6a34962839a$export$fd5e0f8b4115a8c7,
    ...$e3a0d6a34962839a$export$1df62d3ba2121371
];
const $e3a0d6a34962839a$export$5890f750904acddb = (props)=>$e3a0d6a34962839a$var$VALIDATION_PROP_NAMES.reduce((extractedProps, propName)=>{
        if (props.hasOwnProperty(propName)) extractedProps[propName] = props[propName];
        return extractedProps;
    }, {});


const $3cac403015a35eb6$var$SHARED_FIELD_INTERNAL_PROP_NAMES = [
    'value',
    'defaultValue',
    'referenceDate',
    'format',
    'formatDensity',
    'onChange',
    'timezone',
    'readOnly',
    'onError',
    'shouldRespectLeadingZeros',
    'selectedSections',
    'onSelectedSectionsChange',
    'unstableFieldRef'
];
const $3cac403015a35eb6$export$cdde224d2939fd84 = (props, valueType)=>{
    const forwardedProps = (0, $3VnFq.default)({}, props);
    const internalProps = {};
    const extractProp = (propName)=>{
        if (forwardedProps.hasOwnProperty(propName)) {
            // @ts-ignore
            internalProps[propName] = forwardedProps[propName];
            delete forwardedProps[propName];
        }
    };
    $3cac403015a35eb6$var$SHARED_FIELD_INTERNAL_PROP_NAMES.forEach(extractProp);
    if (valueType === 'date') (0, $e3a0d6a34962839a$export$430d9fc64cf058d6).forEach(extractProp);
    else if (valueType === 'time') (0, $e3a0d6a34962839a$export$fd5e0f8b4115a8c7).forEach(extractProp);
    else if (valueType === 'date-time') {
        (0, $e3a0d6a34962839a$export$430d9fc64cf058d6).forEach(extractProp);
        (0, $e3a0d6a34962839a$export$fd5e0f8b4115a8c7).forEach(extractProp);
        (0, $e3a0d6a34962839a$export$1df62d3ba2121371).forEach(extractProp);
    }
    return {
        forwardedProps: forwardedProps,
        internalProps: internalProps
    };
};


const $3291269b4d96bfa5$var$useDefaultizedDateField = (props)=>{
    var _props$disablePast, _props$disableFuture, _props$format;
    const utils = (0, $98220f21a8625472$export$1163b47e39508a46)();
    const defaultDates = (0, $98220f21a8625472$export$7c38da3a2e90fa83)();
    return (0, $3VnFq.default)({}, props, {
        disablePast: (_props$disablePast = props.disablePast) != null ? _props$disablePast : false,
        disableFuture: (_props$disableFuture = props.disableFuture) != null ? _props$disableFuture : false,
        format: (_props$format = props.format) != null ? _props$format : utils.formats.keyboardDate,
        minDate: (0, $00e6d022b450825d$export$eb73579ccade48fd)(utils, props.minDate, defaultDates.minDate),
        maxDate: (0, $00e6d022b450825d$export$eb73579ccade48fd)(utils, props.maxDate, defaultDates.maxDate)
    });
};
const $3291269b4d96bfa5$export$5591b0b878c1a989 = ({ props: inProps, inputRef: inputRef })=>{
    const props = $3291269b4d96bfa5$var$useDefaultizedDateField(inProps);
    const { forwardedProps: forwardedProps, internalProps: internalProps } = (0, $3cac403015a35eb6$export$cdde224d2939fd84)(props, 'date');
    return (0, $5bbb9f44cfbbf3b7$export$294aa081a6c6f55d)({
        inputRef: inputRef,
        forwardedProps: forwardedProps,
        internalProps: internalProps,
        valueManager: (0, $15cde65cbd91c944$export$2764b246aa3b75ba),
        fieldValueManager: (0, $15cde65cbd91c944$export$b602c94f557316b4),
        validator: (0, $857e489bb4dc7e4f$export$ffb3d0046ef3a2),
        valueType: 'date'
    });
};



var $3VnFq = parcelRequire("3VnFq");

var $cTAWX = parcelRequire("cTAWX");

var $gJYWc = parcelRequire("gJYWc");


var $17CRd = parcelRequire("17CRd");




var $9wx12 = parcelRequire("9wx12");
const $6ce5f2c03b6ee06a$var$_excluded = [
    "ownerState"
];
const $6ce5f2c03b6ee06a$export$db9644cdb7e3d432 = ({ clearable: clearable, fieldProps: forwardedFieldProps, InputProps: ForwardedInputProps, onClear: onClear, slots: slots, slotProps: slotProps, components: components, componentsProps: componentsProps })=>{
    var _ref, _slots$clearButton, _slotProps$clearButto, _ref2, _slots$clearIcon, _slotProps$clearIcon;
    const localeText = (0, $98220f21a8625472$export$24fdeaa0f591a73e)();
    const IconButton = (_ref = (_slots$clearButton = slots == null ? void 0 : slots.clearButton) != null ? _slots$clearButton : components == null ? void 0 : components.ClearButton) != null ? _ref : (0, $17CRd.default);
    // The spread is here to avoid this bug mui/material-ui#34056
    const _useSlotProps = (0, $2082854bb194ebf1$export$2e2bcd8739ae039)({
        elementType: IconButton,
        externalSlotProps: (_slotProps$clearButto = slotProps == null ? void 0 : slotProps.clearButton) != null ? _slotProps$clearButto : componentsProps == null ? void 0 : componentsProps.clearButton,
        ownerState: {},
        className: 'clearButton',
        additionalProps: {
            title: localeText.fieldClearLabel
        }
    }), iconButtonProps = (0, $cTAWX.default)(_useSlotProps, $6ce5f2c03b6ee06a$var$_excluded);
    const EndClearIcon = (_ref2 = (_slots$clearIcon = slots == null ? void 0 : slots.clearIcon) != null ? _slots$clearIcon : components == null ? void 0 : components.ClearIcon) != null ? _ref2 : (0, $fc9c2dee5d88174c$export$cefbac224a47f32);
    const endClearIconProps = (0, $2082854bb194ebf1$export$2e2bcd8739ae039)({
        elementType: EndClearIcon,
        externalSlotProps: (_slotProps$clearIcon = slotProps == null ? void 0 : slotProps.clearIcon) != null ? _slotProps$clearIcon : componentsProps == null ? void 0 : componentsProps.clearIcon,
        ownerState: {}
    });
    const InputProps = (0, $3VnFq.default)({}, ForwardedInputProps, {
        endAdornment: /*#__PURE__*/ (0, $9wx12.jsxs)($gJYWc.Fragment, {
            children: [
                clearable && /*#__PURE__*/ (0, $9wx12.jsx)((0, $aee6aba0933a8c2f$export$2e2bcd8739ae039), {
                    position: "end",
                    sx: {
                        marginRight: ForwardedInputProps != null && ForwardedInputProps.endAdornment ? -1 : -1.5
                    },
                    children: /*#__PURE__*/ (0, $9wx12.jsx)(IconButton, (0, $3VnFq.default)({}, iconButtonProps, {
                        onClick: onClear,
                        children: /*#__PURE__*/ (0, $9wx12.jsx)(EndClearIcon, (0, $3VnFq.default)({
                            fontSize: "small"
                        }, endClearIconProps))
                    }))
                }),
                ForwardedInputProps == null ? void 0 : ForwardedInputProps.endAdornment
            ]
        })
    });
    const fieldProps = (0, $3VnFq.default)({}, forwardedFieldProps, {
        sx: [
            {
                '& .clearButton': {
                    opacity: 1
                },
                '@media (pointer: fine)': {
                    '& .clearButton': {
                        opacity: 0
                    },
                    '&:hover, &:focus-within': {
                        '.clearButton': {
                            opacity: 1
                        }
                    }
                }
            },
            ...Array.isArray(forwardedFieldProps.sx) ? forwardedFieldProps.sx : [
                forwardedFieldProps.sx
            ]
        ]
    });
    return {
        InputProps: InputProps,
        fieldProps: fieldProps
    };
};



var $9wx12 = parcelRequire("9wx12");
const $fe27ec7048b8cc71$var$_excluded = [
    "components",
    "componentsProps",
    "slots",
    "slotProps",
    "InputProps",
    "inputProps"
], $fe27ec7048b8cc71$var$_excluded2 = [
    "inputRef"
], $fe27ec7048b8cc71$var$_excluded3 = [
    "ref",
    "onPaste",
    "onKeyDown",
    "inputMode",
    "readOnly",
    "clearable",
    "onClear"
];
/**
 * Demos:
 *
 * - [DateField](http://mui.com/x/react-date-pickers/date-field/)
 * - [Fields](https://mui.com/x/react-date-pickers/fields/)
 *
 * API:
 *
 * - [DateField API](https://mui.com/x/api/date-pickers/date-field/)
 */ const $fe27ec7048b8cc71$export$d9781c7894a82487 = /*#__PURE__*/ $gJYWc.forwardRef(function DateField(inProps, ref) {
    var _ref, _slots$textField, _slotProps$textField;
    const themeProps = (0, $6959428021af84ce$export$2e2bcd8739ae039)({
        props: inProps,
        name: 'MuiDateField'
    });
    const { components: components, componentsProps: componentsProps, slots: slots, slotProps: slotProps, InputProps: InputProps, inputProps: inputProps } = themeProps, other = (0, $cTAWX.default)(themeProps, $fe27ec7048b8cc71$var$_excluded);
    const ownerState = themeProps;
    const TextField = (_ref = (_slots$textField = slots == null ? void 0 : slots.textField) != null ? _slots$textField : components == null ? void 0 : components.TextField) != null ? _ref : (0, $1f9512c77b4eaf9c$export$2e2bcd8739ae039);
    const _useSlotProps = (0, $2082854bb194ebf1$export$2e2bcd8739ae039)({
        elementType: TextField,
        externalSlotProps: (_slotProps$textField = slotProps == null ? void 0 : slotProps.textField) != null ? _slotProps$textField : componentsProps == null ? void 0 : componentsProps.textField,
        externalForwardedProps: other,
        ownerState: ownerState
    }), { inputRef: externalInputRef } = _useSlotProps, textFieldProps = (0, $cTAWX.default)(_useSlotProps, $fe27ec7048b8cc71$var$_excluded2);
    // TODO: Remove when mui/material-ui#35088 will be merged
    textFieldProps.inputProps = (0, $3VnFq.default)({}, inputProps, textFieldProps.inputProps);
    textFieldProps.InputProps = (0, $3VnFq.default)({}, InputProps, textFieldProps.InputProps);
    const _useDateField = (0, $3291269b4d96bfa5$export$5591b0b878c1a989)({
        props: textFieldProps,
        inputRef: externalInputRef
    }), { ref: inputRef, onPaste: onPaste, onKeyDown: onKeyDown, inputMode: inputMode, readOnly: readOnly, clearable: clearable, onClear: onClear } = _useDateField, fieldProps = (0, $cTAWX.default)(_useDateField, $fe27ec7048b8cc71$var$_excluded3);
    const { InputProps: ProcessedInputProps, fieldProps: processedFieldProps } = (0, $6ce5f2c03b6ee06a$export$db9644cdb7e3d432)({
        onClear: onClear,
        clearable: clearable,
        fieldProps: fieldProps,
        InputProps: fieldProps.InputProps,
        slots: slots,
        slotProps: slotProps,
        components: components,
        componentsProps: componentsProps
    });
    return /*#__PURE__*/ (0, $9wx12.jsx)(TextField, (0, $3VnFq.default)({
        ref: ref
    }, processedFieldProps, {
        InputProps: (0, $3VnFq.default)({}, ProcessedInputProps, {
            readOnly: readOnly
        }),
        inputProps: (0, $3VnFq.default)({}, fieldProps.inputProps, {
            inputMode: inputMode,
            onPaste: onPaste,
            onKeyDown: onKeyDown,
            ref: inputRef
        })
    }));
});



parcelRequire("gJYWc");

var $cTAWX = parcelRequire("cTAWX");

var $3VnFq = parcelRequire("3VnFq");

var $gJYWc = parcelRequire("gJYWc");


var $2w6IV = parcelRequire("2w6IV");


var $HGmne = parcelRequire("HGmne");

var $3e4LV = parcelRequire("3e4LV");
var $92UcI = parcelRequire("92UcI");

var $3VnFq = parcelRequire("3VnFq");

var $gJYWc = parcelRequire("gJYWc");

var $92UcI = parcelRequire("92UcI");

var $gJYWc = parcelRequire("gJYWc");


const $30dffcea4c73c048$export$7d1a419f34475191 = ({ shouldDisableDate: shouldDisableDate, shouldDisableMonth: shouldDisableMonth, shouldDisableYear: shouldDisableYear, minDate: minDate, maxDate: maxDate, disableFuture: disableFuture, disablePast: disablePast, timezone: timezone })=>{
    const adapter = (0, $98220f21a8625472$export$4b5a24245de9f7f9)();
    return $gJYWc.useCallback((day)=>(0, $857e489bb4dc7e4f$export$ffb3d0046ef3a2)({
            adapter: adapter,
            value: day,
            props: {
                shouldDisableDate: shouldDisableDate,
                shouldDisableMonth: shouldDisableMonth,
                shouldDisableYear: shouldDisableYear,
                minDate: minDate,
                maxDate: maxDate,
                disableFuture: disableFuture,
                disablePast: disablePast,
                timezone: timezone
            }
        }) !== null, [
        adapter,
        shouldDisableDate,
        shouldDisableMonth,
        shouldDisableYear,
        minDate,
        maxDate,
        disableFuture,
        disablePast,
        timezone
    ]);
};





const $45e7422db76ba2e3$export$2aba07ea6b6cf430 = (reduceAnimations, disableSwitchToMonthOnDayFocus, utils)=>(state, action)=>{
        switch(action.type){
            case 'changeMonth':
                return (0, $3VnFq.default)({}, state, {
                    slideDirection: action.direction,
                    currentMonth: action.newMonth,
                    isMonthSwitchingAnimating: !reduceAnimations
                });
            case 'finishMonthSwitchingAnimation':
                return (0, $3VnFq.default)({}, state, {
                    isMonthSwitchingAnimating: false
                });
            case 'changeFocusedDay':
                {
                    if (state.focusedDay != null && action.focusedDay != null && utils.isSameDay(action.focusedDay, state.focusedDay)) return state;
                    const needMonthSwitch = action.focusedDay != null && !disableSwitchToMonthOnDayFocus && !utils.isSameMonth(state.currentMonth, action.focusedDay);
                    return (0, $3VnFq.default)({}, state, {
                        focusedDay: action.focusedDay,
                        isMonthSwitchingAnimating: needMonthSwitch && !reduceAnimations && !action.withoutMonthSwitchingAnimation,
                        currentMonth: needMonthSwitch ? utils.startOfMonth(action.focusedDay) : state.currentMonth,
                        slideDirection: action.focusedDay != null && utils.isAfterDay(action.focusedDay, state.currentMonth) ? 'left' : 'right'
                    });
                }
            default:
                throw new Error('missing support');
        }
    };
const $45e7422db76ba2e3$export$6d095e787d2b5e1f = (params)=>{
    const { value: value, referenceDate: referenceDateProp, defaultCalendarMonth: defaultCalendarMonth, disableFuture: disableFuture, disablePast: disablePast, disableSwitchToMonthOnDayFocus: disableSwitchToMonthOnDayFocus = false, maxDate: maxDate, minDate: minDate, onMonthChange: onMonthChange, reduceAnimations: reduceAnimations, shouldDisableDate: shouldDisableDate, timezone: timezone } = params;
    const utils = (0, $98220f21a8625472$export$1163b47e39508a46)();
    const reducerFn = $gJYWc.useRef($45e7422db76ba2e3$export$2aba07ea6b6cf430(Boolean(reduceAnimations), disableSwitchToMonthOnDayFocus, utils)).current;
    const referenceDate = $gJYWc.useMemo(()=>{
        let externalReferenceDate = null;
        if (referenceDateProp) externalReferenceDate = referenceDateProp;
        else if (defaultCalendarMonth) // For `defaultCalendarMonth`, we just want to keep the month and the year to avoid a behavior change.
        externalReferenceDate = utils.startOfMonth(defaultCalendarMonth);
        return (0, $15cde65cbd91c944$export$2764b246aa3b75ba).getInitialReferenceValue({
            value: value,
            utils: utils,
            timezone: timezone,
            props: params,
            referenceDate: externalReferenceDate,
            granularity: (0, $d8b7b2aeaa0755b4$export$8f74e8f4ed8ae0ac).day
        });
    }, [] // eslint-disable-line react-hooks/exhaustive-deps
    );
    const [calendarState, dispatch] = $gJYWc.useReducer(reducerFn, {
        isMonthSwitchingAnimating: false,
        focusedDay: referenceDate,
        currentMonth: utils.startOfMonth(referenceDate),
        slideDirection: 'left'
    });
    const handleChangeMonth = $gJYWc.useCallback((payload)=>{
        dispatch((0, $3VnFq.default)({
            type: 'changeMonth'
        }, payload));
        if (onMonthChange) onMonthChange(payload.newMonth);
    }, [
        onMonthChange
    ]);
    const changeMonth = $gJYWc.useCallback((newDate)=>{
        const newDateRequested = newDate;
        if (utils.isSameMonth(newDateRequested, calendarState.currentMonth)) return;
        handleChangeMonth({
            newMonth: utils.startOfMonth(newDateRequested),
            direction: utils.isAfterDay(newDateRequested, calendarState.currentMonth) ? 'left' : 'right'
        });
    }, [
        calendarState.currentMonth,
        handleChangeMonth,
        utils
    ]);
    const isDateDisabled = (0, $30dffcea4c73c048$export$7d1a419f34475191)({
        shouldDisableDate: shouldDisableDate,
        minDate: minDate,
        maxDate: maxDate,
        disableFuture: disableFuture,
        disablePast: disablePast,
        timezone: timezone
    });
    const onMonthSwitchingAnimationEnd = $gJYWc.useCallback(()=>{
        dispatch({
            type: 'finishMonthSwitchingAnimation'
        });
    }, []);
    const changeFocusedDay = (0, $92UcI.default)((newFocusedDate, withoutMonthSwitchingAnimation)=>{
        if (!isDateDisabled(newFocusedDate)) dispatch({
            type: 'changeFocusedDay',
            focusedDay: newFocusedDate,
            withoutMonthSwitchingAnimation: withoutMonthSwitchingAnimation
        });
    });
    return {
        referenceDate: referenceDate,
        calendarState: calendarState,
        changeMonth: changeMonth,
        changeFocusedDay: changeFocusedDay,
        isDateDisabled: isDateDisabled,
        onMonthSwitchingAnimationEnd: onMonthSwitchingAnimationEnd,
        handleChangeMonth: handleChangeMonth
    };
};



parcelRequire("gJYWc");

var $2w6IV = parcelRequire("2w6IV");

var $wvXl9 = parcelRequire("wvXl9");


var $HGmne = parcelRequire("HGmne");

var $3e4LV = parcelRequire("3e4LV");

var $1kRHf = parcelRequire("1kRHf");
var $i8nzj = parcelRequire("i8nzj");
const $cfdb5994d56e0284$export$5b0bb0174eb448ca = (slot)=>(0, $1kRHf.default)('MuiPickersFadeTransitionGroup', slot);
const $cfdb5994d56e0284$export$1461f245817ac559 = (0, $i8nzj.default)('MuiPickersFadeTransitionGroup', [
    'root'
]);



var $9wx12 = parcelRequire("9wx12");
const $c575666c4c3d2d8a$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ]
    };
    return (0, $3e4LV.default)(slots, (0, $cfdb5994d56e0284$export$5b0bb0174eb448ca), classes);
};
const $c575666c4c3d2d8a$var$PickersFadeTransitionGroupRoot = (0, $HGmne.default)((0, $wvXl9.default), {
    name: 'MuiPickersFadeTransitionGroup',
    slot: 'Root',
    overridesResolver: (_, styles)=>styles.root
})({
    display: 'block',
    position: 'relative'
});
function $c575666c4c3d2d8a$export$5262185daf493fee(inProps) {
    const props = (0, $6959428021af84ce$export$2e2bcd8739ae039)({
        props: inProps,
        name: 'MuiPickersFadeTransitionGroup'
    });
    const { children: children, className: className, reduceAnimations: reduceAnimations, transKey: transKey } = props;
    const classes = $c575666c4c3d2d8a$var$useUtilityClasses(props);
    const theme = (0, $ae968105fc5c093e$export$2e2bcd8739ae039)();
    if (reduceAnimations) return children;
    return /*#__PURE__*/ (0, $9wx12.jsx)($c575666c4c3d2d8a$var$PickersFadeTransitionGroupRoot, {
        className: (0, $2w6IV.default)(classes.root, className),
        children: /*#__PURE__*/ (0, $9wx12.jsx)((0, $5d4a7e2c608c4487$export$2e2bcd8739ae039), {
            appear: false,
            mountOnEnter: true,
            unmountOnExit: true,
            timeout: {
                appear: theme.transitions.duration.enteringScreen,
                enter: theme.transitions.duration.enteringScreen,
                exit: 0
            },
            children: children
        }, transKey)
    });
}



var $cTAWX = parcelRequire("cTAWX");

var $3VnFq = parcelRequire("3VnFq");

var $gJYWc = parcelRequire("gJYWc");

var $92UcI = parcelRequire("92UcI");



var $HGmne = parcelRequire("HGmne");

var $3e4LV = parcelRequire("3e4LV");

var $2w6IV = parcelRequire("2w6IV");

var $cTAWX = parcelRequire("cTAWX");

var $3VnFq = parcelRequire("3VnFq");

var $gJYWc = parcelRequire("gJYWc");


var $2w6IV = parcelRequire("2w6IV");

var $fNSZE = parcelRequire("fNSZE");

var $3e4LV = parcelRequire("3e4LV");
var $4z2O6 = parcelRequire("4z2O6");
var $4gWBK = parcelRequire("4gWBK");

var $lqJfJ = parcelRequire("lqJfJ");

var $cGwaF = parcelRequire("cGwaF");
/**
 * Returns a number whose value is limited to the given range.
 * @param {number} value The value to be clamped
 * @param {number} min The lower boundary of the output range
 * @param {number} max The upper boundary of the output range
 * @returns {number} A number in the range [min, max]
 */ function $cf4e4db1b4d926c1$var$clampWrapper(value, min = 0, max = 1) {
    return (0, $cGwaF.default)(value, min, max);
}
function $cf4e4db1b4d926c1$export$5a544e13ad4e1fa5(color) {
    color = color.slice(1);
    const re = new RegExp(`.{1,${color.length >= 6 ? 2 : 1}}`, 'g');
    let colors = color.match(re);
    if (colors && colors[0].length === 1) colors = colors.map((n)=>n + n);
    return colors ? `rgb${colors.length === 4 ? 'a' : ''}(${colors.map((n, index)=>{
        return index < 3 ? parseInt(n, 16) : Math.round(parseInt(n, 16) / 255 * 1000) / 1000;
    }).join(', ')})` : '';
}
function $cf4e4db1b4d926c1$var$intToHex(int) {
    const hex = int.toString(16);
    return hex.length === 1 ? `0${hex}` : hex;
}
function $cf4e4db1b4d926c1$export$677b39864803984e(color) {
    // Idempotent
    if (color.type) return color;
    if (color.charAt(0) === '#') return $cf4e4db1b4d926c1$export$677b39864803984e($cf4e4db1b4d926c1$export$5a544e13ad4e1fa5(color));
    const marker = color.indexOf('(');
    const type = color.substring(0, marker);
    if ([
        'rgb',
        'rgba',
        'hsl',
        'hsla',
        'color'
    ].indexOf(type) === -1) throw new Error((0, $lqJfJ.default)(9, color));
    let values = color.substring(marker + 1, color.length - 1);
    let colorSpace;
    if (type === 'color') {
        values = values.split(' ');
        colorSpace = values.shift();
        if (values.length === 4 && values[3].charAt(0) === '/') values[3] = values[3].slice(1);
        if ([
            'srgb',
            'display-p3',
            'a98-rgb',
            'prophoto-rgb',
            'rec-2020'
        ].indexOf(colorSpace) === -1) throw new Error((0, $lqJfJ.default)(10, colorSpace));
    } else values = values.split(',');
    values = values.map((value)=>parseFloat(value));
    return {
        type: type,
        values: values,
        colorSpace: colorSpace
    };
}
const $cf4e4db1b4d926c1$export$1b91fc959f7ee5a7 = (color)=>{
    const decomposedColor = $cf4e4db1b4d926c1$export$677b39864803984e(color);
    return decomposedColor.values.slice(0, 3).map((val, idx)=>decomposedColor.type.indexOf('hsl') !== -1 && idx !== 0 ? `${val}%` : val).join(' ');
};
const $cf4e4db1b4d926c1$export$427365fc3db6fc5e = (color, warning)=>{
    try {
        return $cf4e4db1b4d926c1$export$1b91fc959f7ee5a7(color);
    } catch (error) {
        return color;
    }
};
function $cf4e4db1b4d926c1$export$211a73f2b8c10ce4(color) {
    const { type: type, colorSpace: colorSpace } = color;
    let { values: values } = color;
    if (type.indexOf('rgb') !== -1) // Only convert the first 3 values to int (i.e. not alpha)
    values = values.map((n, i)=>i < 3 ? parseInt(n, 10) : n);
    else if (type.indexOf('hsl') !== -1) {
        values[1] = `${values[1]}%`;
        values[2] = `${values[2]}%`;
    }
    if (type.indexOf('color') !== -1) values = `${colorSpace} ${values.join(' ')}`;
    else values = `${values.join(', ')}`;
    return `${type}(${values})`;
}
function $cf4e4db1b4d926c1$export$34d09c4a771c46ef(color) {
    // Idempotent
    if (color.indexOf('#') === 0) return color;
    const { values: values } = $cf4e4db1b4d926c1$export$677b39864803984e(color);
    return `#${values.map((n, i)=>$cf4e4db1b4d926c1$var$intToHex(i === 3 ? Math.round(255 * n) : n)).join('')}`;
}
function $cf4e4db1b4d926c1$export$29fb7152bd3f781a(color) {
    color = $cf4e4db1b4d926c1$export$677b39864803984e(color);
    const { values: values } = color;
    const h = values[0];
    const s = values[1] / 100;
    const l = values[2] / 100;
    const a = s * Math.min(l, 1 - l);
    const f = (n, k = (n + h / 30) % 12)=>l - a * Math.max(Math.min(k - 3, 9 - k, 1), -1);
    let type = 'rgb';
    const rgb = [
        Math.round(f(0) * 255),
        Math.round(f(8) * 255),
        Math.round(f(4) * 255)
    ];
    if (color.type === 'hsla') {
        type += 'a';
        rgb.push(values[3]);
    }
    return $cf4e4db1b4d926c1$export$211a73f2b8c10ce4({
        type: type,
        values: rgb
    });
}
function $cf4e4db1b4d926c1$export$c852d90bf7403b62(color) {
    color = $cf4e4db1b4d926c1$export$677b39864803984e(color);
    let rgb = color.type === 'hsl' || color.type === 'hsla' ? $cf4e4db1b4d926c1$export$677b39864803984e($cf4e4db1b4d926c1$export$29fb7152bd3f781a(color)).values : color.values;
    rgb = rgb.map((val)=>{
        if (color.type !== 'color') val /= 255; // normalized
        return val <= 0.03928 ? val / 12.92 : ((val + 0.055) / 1.055) ** 2.4;
    });
    // Truncate at 3 digits
    return Number((0.2126 * rgb[0] + 0.7152 * rgb[1] + 0.0722 * rgb[2]).toFixed(3));
}
function $cf4e4db1b4d926c1$export$d061e26956a60b0a(foreground, background) {
    const lumA = $cf4e4db1b4d926c1$export$c852d90bf7403b62(foreground);
    const lumB = $cf4e4db1b4d926c1$export$c852d90bf7403b62(background);
    return (Math.max(lumA, lumB) + 0.05) / (Math.min(lumA, lumB) + 0.05);
}
function $cf4e4db1b4d926c1$export$58f0f39f63f3cf42(color, value) {
    color = $cf4e4db1b4d926c1$export$677b39864803984e(color);
    value = $cf4e4db1b4d926c1$var$clampWrapper(value);
    if (color.type === 'rgb' || color.type === 'hsl') color.type += 'a';
    if (color.type === 'color') color.values[3] = `/${value}`;
    else color.values[3] = value;
    return $cf4e4db1b4d926c1$export$211a73f2b8c10ce4(color);
}
function $cf4e4db1b4d926c1$export$34109543fc7f43f8(color, value, warning) {
    try {
        return $cf4e4db1b4d926c1$export$58f0f39f63f3cf42(color, value);
    } catch (error) {
        return color;
    }
}
function $cf4e4db1b4d926c1$export$4b073707ff63303(color, coefficient) {
    color = $cf4e4db1b4d926c1$export$677b39864803984e(color);
    coefficient = $cf4e4db1b4d926c1$var$clampWrapper(coefficient);
    if (color.type.indexOf('hsl') !== -1) color.values[2] *= 1 - coefficient;
    else if (color.type.indexOf('rgb') !== -1 || color.type.indexOf('color') !== -1) for(let i = 0; i < 3; i += 1)color.values[i] *= 1 - coefficient;
    return $cf4e4db1b4d926c1$export$211a73f2b8c10ce4(color);
}
function $cf4e4db1b4d926c1$export$eaaef2dca3e9e512(color, coefficient, warning) {
    try {
        return $cf4e4db1b4d926c1$export$4b073707ff63303(color, coefficient);
    } catch (error) {
        return color;
    }
}
function $cf4e4db1b4d926c1$export$c0816ed86df316af(color, coefficient) {
    color = $cf4e4db1b4d926c1$export$677b39864803984e(color);
    coefficient = $cf4e4db1b4d926c1$var$clampWrapper(coefficient);
    if (color.type.indexOf('hsl') !== -1) color.values[2] += (100 - color.values[2]) * coefficient;
    else if (color.type.indexOf('rgb') !== -1) for(let i = 0; i < 3; i += 1)color.values[i] += (255 - color.values[i]) * coefficient;
    else if (color.type.indexOf('color') !== -1) for(let i = 0; i < 3; i += 1)color.values[i] += (1 - color.values[i]) * coefficient;
    return $cf4e4db1b4d926c1$export$211a73f2b8c10ce4(color);
}
function $cf4e4db1b4d926c1$export$aeeda94ef1d01275(color, coefficient, warning) {
    try {
        return $cf4e4db1b4d926c1$export$c0816ed86df316af(color, coefficient);
    } catch (error) {
        return color;
    }
}
function $cf4e4db1b4d926c1$export$e665714f76e581fd(color, coefficient = 0.15) {
    return $cf4e4db1b4d926c1$export$c852d90bf7403b62(color) > 0.5 ? $cf4e4db1b4d926c1$export$4b073707ff63303(color, coefficient) : $cf4e4db1b4d926c1$export$c0816ed86df316af(color, coefficient);
}
function $cf4e4db1b4d926c1$export$11bb74ba10c85505(color, coefficient, warning) {
    try {
        return $cf4e4db1b4d926c1$export$e665714f76e581fd(color, coefficient);
    } catch (error) {
        return color;
    }
}
function $cf4e4db1b4d926c1$export$fdb28526eb2966c3(background, overlay, opacity, gamma = 1.0) {
    const blendChannel = (b, o)=>Math.round((b ** (1 / gamma) * (1 - opacity) + o ** (1 / gamma) * opacity) ** gamma);
    const backgroundColor = $cf4e4db1b4d926c1$export$677b39864803984e(background);
    const overlayColor = $cf4e4db1b4d926c1$export$677b39864803984e(overlay);
    const rgb = [
        blendChannel(backgroundColor.values[0], overlayColor.values[0]),
        blendChannel(backgroundColor.values[1], overlayColor.values[1]),
        blendChannel(backgroundColor.values[2], overlayColor.values[2])
    ];
    return $cf4e4db1b4d926c1$export$211a73f2b8c10ce4({
        type: 'rgb',
        values: rgb
    });
}


var $HGmne = parcelRequire("HGmne");



var $1kRHf = parcelRequire("1kRHf");
var $i8nzj = parcelRequire("i8nzj");
function $e7ad0a82241534cf$export$4b25deb0350d3e53(slot) {
    return (0, $1kRHf.default)('MuiPickersDay', slot);
}
const $e7ad0a82241534cf$export$68b221ad3c35e288 = (0, $i8nzj.default)('MuiPickersDay', [
    'root',
    'dayWithMargin',
    'dayOutsideMonth',
    'hiddenDaySpacingFiller',
    'today',
    'selected',
    'disabled'
]);



var $9wx12 = parcelRequire("9wx12");
const $a5553328c1dee6a7$var$_excluded = [
    "autoFocus",
    "className",
    "day",
    "disabled",
    "disableHighlightToday",
    "disableMargin",
    "hidden",
    "isAnimating",
    "onClick",
    "onDaySelect",
    "onFocus",
    "onBlur",
    "onKeyDown",
    "onMouseDown",
    "onMouseEnter",
    "outsideCurrentMonth",
    "selected",
    "showDaysOutsideCurrentMonth",
    "children",
    "today",
    "isFirstVisibleCell",
    "isLastVisibleCell"
];
const $a5553328c1dee6a7$var$useUtilityClasses = (ownerState)=>{
    const { selected: selected, disableMargin: disableMargin, disableHighlightToday: disableHighlightToday, today: today, disabled: disabled, outsideCurrentMonth: outsideCurrentMonth, showDaysOutsideCurrentMonth: showDaysOutsideCurrentMonth, classes: classes } = ownerState;
    const isHiddenDaySpacingFiller = outsideCurrentMonth && !showDaysOutsideCurrentMonth;
    const slots = {
        root: [
            'root',
            selected && !isHiddenDaySpacingFiller && 'selected',
            disabled && 'disabled',
            !disableMargin && 'dayWithMargin',
            !disableHighlightToday && today && 'today',
            outsideCurrentMonth && showDaysOutsideCurrentMonth && 'dayOutsideMonth',
            isHiddenDaySpacingFiller && 'hiddenDaySpacingFiller'
        ],
        hiddenDaySpacingFiller: [
            'hiddenDaySpacingFiller'
        ]
    };
    return (0, $3e4LV.default)(slots, (0, $e7ad0a82241534cf$export$4b25deb0350d3e53), classes);
};
const $a5553328c1dee6a7$var$styleArg = ({ theme: theme, ownerState: ownerState })=>(0, $3VnFq.default)({}, theme.typography.caption, {
        width: (0, $8450780b4b9a6f99$export$3f0060ce4cc8f4d0),
        height: (0, $8450780b4b9a6f99$export$3f0060ce4cc8f4d0),
        borderRadius: '50%',
        padding: 0,
        // explicitly setting to `transparent` to avoid potentially getting impacted by change from the overridden component
        backgroundColor: 'transparent',
        transition: theme.transitions.create('background-color', {
            duration: theme.transitions.duration.short
        }),
        color: (theme.vars || theme).palette.text.primary,
        '@media (pointer: fine)': {
            '&:hover': {
                backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $cf4e4db1b4d926c1$export$58f0f39f63f3cf42)(theme.palette.primary.main, theme.palette.action.hoverOpacity)
            }
        },
        '&:focus': {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.focusOpacity})` : (0, $cf4e4db1b4d926c1$export$58f0f39f63f3cf42)(theme.palette.primary.main, theme.palette.action.focusOpacity),
            [`&.${(0, $e7ad0a82241534cf$export$68b221ad3c35e288).selected}`]: {
                willChange: 'background-color',
                backgroundColor: (theme.vars || theme).palette.primary.dark
            }
        },
        [`&.${(0, $e7ad0a82241534cf$export$68b221ad3c35e288).selected}`]: {
            color: (theme.vars || theme).palette.primary.contrastText,
            backgroundColor: (theme.vars || theme).palette.primary.main,
            fontWeight: theme.typography.fontWeightMedium,
            '&:hover': {
                willChange: 'background-color',
                backgroundColor: (theme.vars || theme).palette.primary.dark
            }
        },
        [`&.${(0, $e7ad0a82241534cf$export$68b221ad3c35e288).disabled}:not(.${(0, $e7ad0a82241534cf$export$68b221ad3c35e288).selected})`]: {
            color: (theme.vars || theme).palette.text.disabled
        },
        [`&.${(0, $e7ad0a82241534cf$export$68b221ad3c35e288).disabled}&.${(0, $e7ad0a82241534cf$export$68b221ad3c35e288).selected}`]: {
            opacity: 0.6
        }
    }, !ownerState.disableMargin && {
        margin: `0 ${0, $8450780b4b9a6f99$export$dde58b009b497666}px`
    }, ownerState.outsideCurrentMonth && ownerState.showDaysOutsideCurrentMonth && {
        color: (theme.vars || theme).palette.text.secondary
    }, !ownerState.disableHighlightToday && ownerState.today && {
        [`&:not(.${(0, $e7ad0a82241534cf$export$68b221ad3c35e288).selected})`]: {
            border: `1px solid ${(theme.vars || theme).palette.text.secondary}`
        }
    });
const $a5553328c1dee6a7$var$overridesResolver = (props, styles)=>{
    const { ownerState: ownerState } = props;
    return [
        styles.root,
        !ownerState.disableMargin && styles.dayWithMargin,
        !ownerState.disableHighlightToday && ownerState.today && styles.today,
        !ownerState.outsideCurrentMonth && ownerState.showDaysOutsideCurrentMonth && styles.dayOutsideMonth,
        ownerState.outsideCurrentMonth && !ownerState.showDaysOutsideCurrentMonth && styles.hiddenDaySpacingFiller
    ];
};
const $a5553328c1dee6a7$var$PickersDayRoot = (0, $HGmne.default)((0, $fNSZE.default), {
    name: 'MuiPickersDay',
    slot: 'Root',
    overridesResolver: $a5553328c1dee6a7$var$overridesResolver
})($a5553328c1dee6a7$var$styleArg);
const $a5553328c1dee6a7$var$PickersDayFiller = (0, $HGmne.default)('div', {
    name: 'MuiPickersDay',
    slot: 'Root',
    overridesResolver: $a5553328c1dee6a7$var$overridesResolver
})(({ theme: theme, ownerState: ownerState })=>(0, $3VnFq.default)({}, $a5553328c1dee6a7$var$styleArg({
        theme: theme,
        ownerState: ownerState
    }), {
        // visibility: 'hidden' does not work here as it hides the element from screen readers as well
        opacity: 0,
        pointerEvents: 'none'
    }));
const $a5553328c1dee6a7$var$noop = ()=>{};
const $a5553328c1dee6a7$var$PickersDayRaw = /*#__PURE__*/ $gJYWc.forwardRef(function PickersDay(inProps, forwardedRef) {
    const props = (0, $6959428021af84ce$export$2e2bcd8739ae039)({
        props: inProps,
        name: 'MuiPickersDay'
    });
    const { autoFocus: autoFocus = false, className: className, day: day, disabled: disabled = false, disableHighlightToday: disableHighlightToday = false, disableMargin: disableMargin = false, isAnimating: isAnimating, onClick: onClick, onDaySelect: onDaySelect, onFocus: onFocus = $a5553328c1dee6a7$var$noop, onBlur: onBlur = $a5553328c1dee6a7$var$noop, onKeyDown: onKeyDown = $a5553328c1dee6a7$var$noop, onMouseDown: onMouseDown = $a5553328c1dee6a7$var$noop, onMouseEnter: onMouseEnter = $a5553328c1dee6a7$var$noop, outsideCurrentMonth: outsideCurrentMonth, selected: selected = false, showDaysOutsideCurrentMonth: showDaysOutsideCurrentMonth = false, children: children, today: isToday = false } = props, other = (0, $cTAWX.default)(props, $a5553328c1dee6a7$var$_excluded);
    const ownerState = (0, $3VnFq.default)({}, props, {
        autoFocus: autoFocus,
        disabled: disabled,
        disableHighlightToday: disableHighlightToday,
        disableMargin: disableMargin,
        selected: selected,
        showDaysOutsideCurrentMonth: showDaysOutsideCurrentMonth,
        today: isToday
    });
    const classes = $a5553328c1dee6a7$var$useUtilityClasses(ownerState);
    const utils = (0, $98220f21a8625472$export$1163b47e39508a46)();
    const ref = $gJYWc.useRef(null);
    const handleRef = (0, $4gWBK.default)(ref, forwardedRef);
    // Since this is rendered when a Popper is opened we can't use passive effects.
    // Focusing in passive effects in Popper causes scroll jump.
    (0, $4z2O6.default)(()=>{
        if (autoFocus && !disabled && !isAnimating && !outsideCurrentMonth) // ref.current being null would be a bug in MUI
        ref.current.focus();
    }, [
        autoFocus,
        disabled,
        isAnimating,
        outsideCurrentMonth
    ]);
    // For day outside of current month, move focus from mouseDown to mouseUp
    // Goal: have the onClick ends before sliding to the new month
    const handleMouseDown = (event)=>{
        onMouseDown(event);
        if (outsideCurrentMonth) event.preventDefault();
    };
    const handleClick = (event)=>{
        if (!disabled) onDaySelect(day);
        if (outsideCurrentMonth) event.currentTarget.focus();
        if (onClick) onClick(event);
    };
    if (outsideCurrentMonth && !showDaysOutsideCurrentMonth) return /*#__PURE__*/ (0, $9wx12.jsx)($a5553328c1dee6a7$var$PickersDayFiller, {
        className: (0, $2w6IV.default)(classes.root, classes.hiddenDaySpacingFiller, className),
        ownerState: ownerState,
        role: other.role
    });
    return /*#__PURE__*/ (0, $9wx12.jsx)($a5553328c1dee6a7$var$PickersDayRoot, (0, $3VnFq.default)({
        className: (0, $2w6IV.default)(classes.root, className),
        ref: handleRef,
        centerRipple: true,
        disabled: disabled,
        tabIndex: selected ? 0 : -1,
        onKeyDown: (event)=>onKeyDown(event, day),
        onFocus: (event)=>onFocus(event, day),
        onBlur: (event)=>onBlur(event, day),
        onMouseEnter: (event)=>onMouseEnter(event, day),
        onClick: handleClick,
        onMouseDown: handleMouseDown
    }, other, {
        ownerState: ownerState,
        children: !children ? utils.format(day, 'dayOfMonth') : children
    }));
});
const $a5553328c1dee6a7$export$d7378e6e864346fa = /*#__PURE__*/ $gJYWc.memo($a5553328c1dee6a7$var$PickersDayRaw);





var $3VnFq = parcelRequire("3VnFq");

var $cTAWX = parcelRequire("cTAWX");

var $gJYWc = parcelRequire("gJYWc");

var $2w6IV = parcelRequire("2w6IV");

var $HGmne = parcelRequire("HGmne");

var $3e4LV = parcelRequire("3e4LV");

var $3VnFq = parcelRequire("3VnFq");

var $cTAWX = parcelRequire("cTAWX");

var $4yJFC = parcelRequire("4yJFC");

/**
 * Checks if a given element has a CSS class.
 * 
 * @param element the element
 * @param className the CSS class name
 */ function $2031a5a198ccd4b0$export$2e2bcd8739ae039(element, className) {
    if (element.classList) return !!className && element.classList.contains(className);
    return (" " + (element.className.baseVal || element.className) + " ").indexOf(" " + className + " ") !== -1;
}


function $161708826a1b1e21$export$2e2bcd8739ae039(element, className) {
    if (element.classList) element.classList.add(className);
    else if (!(0, $2031a5a198ccd4b0$export$2e2bcd8739ae039)(element, className)) {
        if (typeof element.className === 'string') element.className = element.className + " " + className;
        else element.setAttribute('class', (element.className && element.className.baseVal || '') + " " + className);
    }
}


function $b421719e07e275b6$var$replaceClassName(origClass, classToRemove) {
    return origClass.replace(new RegExp("(^|\\s)" + classToRemove + "(?:\\s|$)", 'g'), '$1').replace(/\s+/g, ' ').replace(/^\s*|\s*$/g, '');
}
function $b421719e07e275b6$export$2e2bcd8739ae039(element, className) {
    if (element.classList) element.classList.remove(className);
    else if (typeof element.className === 'string') element.className = $b421719e07e275b6$var$replaceClassName(element.className, className);
    else element.setAttribute('class', $b421719e07e275b6$var$replaceClassName(element.className && element.className.baseVal || '', className));
}



var $gJYWc = parcelRequire("gJYWc");



var $b969308961c96f2e$var$_addClass = function addClass(node, classes) {
    return node && classes && classes.split(' ').forEach(function(c) {
        return (0, $161708826a1b1e21$export$2e2bcd8739ae039)(node, c);
    });
};
var $b969308961c96f2e$var$removeClass = function removeClass(node, classes) {
    return node && classes && classes.split(' ').forEach(function(c) {
        return (0, $b421719e07e275b6$export$2e2bcd8739ae039)(node, c);
    });
};
/**
 * A transition component inspired by the excellent
 * [ng-animate](https://docs.angularjs.org/api/ngAnimate) library, you should
 * use it if you're using CSS transitions or animations. It's built upon the
 * [`Transition`](https://reactcommunity.org/react-transition-group/transition)
 * component, so it inherits all of its props.
 *
 * `CSSTransition` applies a pair of class names during the `appear`, `enter`,
 * and `exit` states of the transition. The first class is applied and then a
 * second `*-active` class in order to activate the CSS transition. After the
 * transition, matching `*-done` class names are applied to persist the
 * transition state.
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <CSSTransition in={inProp} timeout={200} classNames="my-node">
 *         <div>
 *           {"I'll receive my-node-* classes"}
 *         </div>
 *       </CSSTransition>
 *       <button type="button" onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the `in` prop is set to `true`, the child component will first receive
 * the class `example-enter`, then the `example-enter-active` will be added in
 * the next tick. `CSSTransition` [forces a
 * reflow](https://github.com/reactjs/react-transition-group/blob/5007303e729a74be66a21c3e2205e4916821524b/src/CSSTransition.js#L208-L215)
 * between before adding the `example-enter-active`. This is an important trick
 * because it allows us to transition between `example-enter` and
 * `example-enter-active` even though they were added immediately one after
 * another. Most notably, this is what makes it possible for us to animate
 * _appearance_.
 *
 * ```css
 * .my-node-enter {
 *   opacity: 0;
 * }
 * .my-node-enter-active {
 *   opacity: 1;
 *   transition: opacity 200ms;
 * }
 * .my-node-exit {
 *   opacity: 1;
 * }
 * .my-node-exit-active {
 *   opacity: 0;
 *   transition: opacity 200ms;
 * }
 * ```
 *
 * `*-active` classes represent which styles you want to animate **to**, so it's
 * important to add `transition` declaration only to them, otherwise transitions
 * might not behave as intended! This might not be obvious when the transitions
 * are symmetrical, i.e. when `*-enter-active` is the same as `*-exit`, like in
 * the example above (minus `transition`), but it becomes apparent in more
 * complex transitions.
 *
 * **Note**: If you're using the
 * [`appear`](http://reactcommunity.org/react-transition-group/transition#Transition-prop-appear)
 * prop, make sure to define styles for `.appear-*` classes as well.
 */ var $b969308961c96f2e$var$CSSTransition = /*#__PURE__*/ function(_React$Component) {
    (0, $4yJFC.default)(CSSTransition, _React$Component);
    function CSSTransition() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.appliedClasses = {
            appear: {},
            enter: {},
            exit: {}
        };
        _this.onEnter = function(maybeNode, maybeAppearing) {
            var _this$resolveArgument = _this.resolveArguments(maybeNode, maybeAppearing), node = _this$resolveArgument[0], appearing = _this$resolveArgument[1];
            _this.removeClasses(node, 'exit');
            _this.addClass(node, appearing ? 'appear' : 'enter', 'base');
            if (_this.props.onEnter) _this.props.onEnter(maybeNode, maybeAppearing);
        };
        _this.onEntering = function(maybeNode, maybeAppearing) {
            var _this$resolveArgument2 = _this.resolveArguments(maybeNode, maybeAppearing), node = _this$resolveArgument2[0], appearing = _this$resolveArgument2[1];
            var type = appearing ? 'appear' : 'enter';
            _this.addClass(node, type, 'active');
            if (_this.props.onEntering) _this.props.onEntering(maybeNode, maybeAppearing);
        };
        _this.onEntered = function(maybeNode, maybeAppearing) {
            var _this$resolveArgument3 = _this.resolveArguments(maybeNode, maybeAppearing), node = _this$resolveArgument3[0], appearing = _this$resolveArgument3[1];
            var type = appearing ? 'appear' : 'enter';
            _this.removeClasses(node, type);
            _this.addClass(node, type, 'done');
            if (_this.props.onEntered) _this.props.onEntered(maybeNode, maybeAppearing);
        };
        _this.onExit = function(maybeNode) {
            var _this$resolveArgument4 = _this.resolveArguments(maybeNode), node = _this$resolveArgument4[0];
            _this.removeClasses(node, 'appear');
            _this.removeClasses(node, 'enter');
            _this.addClass(node, 'exit', 'base');
            if (_this.props.onExit) _this.props.onExit(maybeNode);
        };
        _this.onExiting = function(maybeNode) {
            var _this$resolveArgument5 = _this.resolveArguments(maybeNode), node = _this$resolveArgument5[0];
            _this.addClass(node, 'exit', 'active');
            if (_this.props.onExiting) _this.props.onExiting(maybeNode);
        };
        _this.onExited = function(maybeNode) {
            var _this$resolveArgument6 = _this.resolveArguments(maybeNode), node = _this$resolveArgument6[0];
            _this.removeClasses(node, 'exit');
            _this.addClass(node, 'exit', 'done');
            if (_this.props.onExited) _this.props.onExited(maybeNode);
        };
        _this.resolveArguments = function(maybeNode, maybeAppearing) {
            return _this.props.nodeRef ? [
                _this.props.nodeRef.current,
                maybeNode
            ] // here `maybeNode` is actually `appearing`
             : [
                maybeNode,
                maybeAppearing
            ];
        };
        _this.getClassNames = function(type) {
            var classNames = _this.props.classNames;
            var isStringClassNames = typeof classNames === 'string';
            var prefix = isStringClassNames && classNames ? classNames + "-" : '';
            var baseClassName = isStringClassNames ? "" + prefix + type : classNames[type];
            var activeClassName = isStringClassNames ? baseClassName + "-active" : classNames[type + "Active"];
            var doneClassName = isStringClassNames ? baseClassName + "-done" : classNames[type + "Done"];
            return {
                baseClassName: baseClassName,
                activeClassName: activeClassName,
                doneClassName: doneClassName
            };
        };
        return _this;
    }
    var _proto = CSSTransition.prototype;
    _proto.addClass = function addClass(node, type, phase) {
        var className = this.getClassNames(type)[phase + "ClassName"];
        var _this$getClassNames = this.getClassNames('enter'), doneClassName = _this$getClassNames.doneClassName;
        if (type === 'appear' && phase === 'done' && doneClassName) className += " " + doneClassName;
         // This is to force a repaint,
        // which is necessary in order to transition styles when adding a class name.
        if (phase === 'active') {
            if (node) (0, $a942f4454771225e$export$7d26bbb1236dafd6)(node);
        }
        if (className) {
            this.appliedClasses[type][phase] = className;
            $b969308961c96f2e$var$_addClass(node, className);
        }
    };
    _proto.removeClasses = function removeClasses(node, type) {
        var _this$appliedClasses$ = this.appliedClasses[type], baseClassName = _this$appliedClasses$.base, activeClassName = _this$appliedClasses$.active, doneClassName = _this$appliedClasses$.done;
        this.appliedClasses[type] = {};
        if (baseClassName) $b969308961c96f2e$var$removeClass(node, baseClassName);
        if (activeClassName) $b969308961c96f2e$var$removeClass(node, activeClassName);
        if (doneClassName) $b969308961c96f2e$var$removeClass(node, doneClassName);
    };
    _proto.render = function render() {
        var _this$props = this.props, _ = _this$props.classNames, props = (0, $cTAWX.default)(_this$props, [
            "classNames"
        ]);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gJYWc))).createElement((0, $a305bfcf210dcb16$export$2e2bcd8739ae039), (0, $3VnFq.default)({}, props, {
            onEnter: this.onEnter,
            onEntered: this.onEntered,
            onEntering: this.onEntering,
            onExit: this.onExit,
            onExiting: this.onExiting,
            onExited: this.onExited
        }));
    };
    return CSSTransition;
}((0, (/*@__PURE__*/$parcel$interopDefault($gJYWc))).Component);
$b969308961c96f2e$var$CSSTransition.defaultProps = {
    classNames: ''
};
$b969308961c96f2e$var$CSSTransition.propTypes = {};
var $b969308961c96f2e$export$2e2bcd8739ae039 = $b969308961c96f2e$var$CSSTransition;


var $wvXl9 = parcelRequire("wvXl9");

var $1kRHf = parcelRequire("1kRHf");
var $i8nzj = parcelRequire("i8nzj");
const $6c8af8960ac75503$export$e98c1b6c3bbc3c59 = (slot)=>(0, $1kRHf.default)('MuiPickersSlideTransition', slot);
const $6c8af8960ac75503$export$d251a58673156a67 = (0, $i8nzj.default)('MuiPickersSlideTransition', [
    'root',
    'slideEnter-left',
    'slideEnter-right',
    'slideEnterActive',
    'slideExit',
    'slideExitActiveLeft-left',
    'slideExitActiveLeft-right'
]);



var $9wx12 = parcelRequire("9wx12");
const $0ed82243f63c02d0$var$_excluded = [
    "children",
    "className",
    "reduceAnimations",
    "slideDirection",
    "transKey",
    "classes"
];
const $0ed82243f63c02d0$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, slideDirection: slideDirection } = ownerState;
    const slots = {
        root: [
            'root'
        ],
        exit: [
            'slideExit'
        ],
        enterActive: [
            'slideEnterActive'
        ],
        enter: [
            `slideEnter-${slideDirection}`
        ],
        exitActive: [
            `slideExitActiveLeft-${slideDirection}`
        ]
    };
    return (0, $3e4LV.default)(slots, (0, $6c8af8960ac75503$export$e98c1b6c3bbc3c59), classes);
};
const $0ed82243f63c02d0$var$PickersSlideTransitionRoot = (0, $HGmne.default)((0, $wvXl9.default), {
    name: 'MuiPickersSlideTransition',
    slot: 'Root',
    overridesResolver: (_, styles)=>[
            styles.root,
            {
                [`.${(0, $6c8af8960ac75503$export$d251a58673156a67)['slideEnter-left']}`]: styles['slideEnter-left']
            },
            {
                [`.${(0, $6c8af8960ac75503$export$d251a58673156a67)['slideEnter-right']}`]: styles['slideEnter-right']
            },
            {
                [`.${(0, $6c8af8960ac75503$export$d251a58673156a67).slideEnterActive}`]: styles.slideEnterActive
            },
            {
                [`.${(0, $6c8af8960ac75503$export$d251a58673156a67).slideExit}`]: styles.slideExit
            },
            {
                [`.${(0, $6c8af8960ac75503$export$d251a58673156a67)['slideExitActiveLeft-left']}`]: styles['slideExitActiveLeft-left']
            },
            {
                [`.${(0, $6c8af8960ac75503$export$d251a58673156a67)['slideExitActiveLeft-right']}`]: styles['slideExitActiveLeft-right']
            }
        ]
})(({ theme: theme })=>{
    const slideTransition = theme.transitions.create('transform', {
        duration: theme.transitions.duration.complex,
        easing: 'cubic-bezier(0.35, 0.8, 0.4, 1)'
    });
    return {
        display: 'block',
        position: 'relative',
        overflowX: 'hidden',
        '& > *': {
            position: 'absolute',
            top: 0,
            right: 0,
            left: 0
        },
        [`& .${(0, $6c8af8960ac75503$export$d251a58673156a67)['slideEnter-left']}`]: {
            willChange: 'transform',
            transform: 'translate(100%)',
            zIndex: 1
        },
        [`& .${(0, $6c8af8960ac75503$export$d251a58673156a67)['slideEnter-right']}`]: {
            willChange: 'transform',
            transform: 'translate(-100%)',
            zIndex: 1
        },
        [`& .${(0, $6c8af8960ac75503$export$d251a58673156a67).slideEnterActive}`]: {
            transform: 'translate(0%)',
            transition: slideTransition
        },
        [`& .${(0, $6c8af8960ac75503$export$d251a58673156a67).slideExit}`]: {
            transform: 'translate(0%)'
        },
        [`& .${(0, $6c8af8960ac75503$export$d251a58673156a67)['slideExitActiveLeft-left']}`]: {
            willChange: 'transform',
            transform: 'translate(-100%)',
            transition: slideTransition,
            zIndex: 0
        },
        [`& .${(0, $6c8af8960ac75503$export$d251a58673156a67)['slideExitActiveLeft-right']}`]: {
            willChange: 'transform',
            transform: 'translate(100%)',
            transition: slideTransition,
            zIndex: 0
        }
    };
});
function $0ed82243f63c02d0$export$e868fcc7557d3a06(inProps) {
    const props = (0, $6959428021af84ce$export$2e2bcd8739ae039)({
        props: inProps,
        name: 'MuiPickersSlideTransition'
    });
    const { children: children, className: className, reduceAnimations: reduceAnimations, transKey: transKey } = props, other = (0, $cTAWX.default)(props, $0ed82243f63c02d0$var$_excluded);
    const classes = $0ed82243f63c02d0$var$useUtilityClasses(props);
    const theme = (0, $ae968105fc5c093e$export$2e2bcd8739ae039)();
    if (reduceAnimations) return /*#__PURE__*/ (0, $9wx12.jsx)("div", {
        className: (0, $2w6IV.default)(classes.root, className),
        children: children
    });
    const transitionClasses = {
        exit: classes.exit,
        enterActive: classes.enterActive,
        enter: classes.enter,
        exitActive: classes.exitActive
    };
    return /*#__PURE__*/ (0, $9wx12.jsx)($0ed82243f63c02d0$var$PickersSlideTransitionRoot, {
        className: (0, $2w6IV.default)(classes.root, className),
        childFactory: (element)=>/*#__PURE__*/ $gJYWc.cloneElement(element, {
                classNames: transitionClasses
            }),
        role: "presentation",
        children: /*#__PURE__*/ (0, $9wx12.jsx)((0, $b969308961c96f2e$export$2e2bcd8739ae039), (0, $3VnFq.default)({
            mountOnEnter: true,
            unmountOnExit: true,
            timeout: theme.transitions.duration.complex,
            classNames: transitionClasses
        }, other, {
            children: children
        }), transKey)
    });
}





var $1kRHf = parcelRequire("1kRHf");
var $i8nzj = parcelRequire("i8nzj");
const $02c14df245114790$export$fbe827982a69894a = (slot)=>(0, $1kRHf.default)('MuiDayCalendar', slot);
const $02c14df245114790$export$e0770f35b28ac552 = (0, $i8nzj.default)('MuiDayCalendar', [
    'root',
    'header',
    'weekDayLabel',
    'loadingContainer',
    'slideTransition',
    'monthContainer',
    'weekContainer',
    'weekNumberLabel',
    'weekNumber'
]);



var $9wx12 = parcelRequire("9wx12");
const $72c0fa39224d4a3d$var$_excluded = [
    "parentProps",
    "day",
    "focusableDay",
    "selectedDays",
    "isDateDisabled",
    "currentMonthNumber",
    "isViewFocused"
], $72c0fa39224d4a3d$var$_excluded2 = [
    "ownerState"
];
const $72c0fa39224d4a3d$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ],
        header: [
            'header'
        ],
        weekDayLabel: [
            'weekDayLabel'
        ],
        loadingContainer: [
            'loadingContainer'
        ],
        slideTransition: [
            'slideTransition'
        ],
        monthContainer: [
            'monthContainer'
        ],
        weekContainer: [
            'weekContainer'
        ],
        weekNumberLabel: [
            'weekNumberLabel'
        ],
        weekNumber: [
            'weekNumber'
        ]
    };
    return (0, $3e4LV.default)(slots, (0, $02c14df245114790$export$fbe827982a69894a), classes);
};
const $72c0fa39224d4a3d$var$weeksContainerHeight = ((0, $8450780b4b9a6f99$export$3f0060ce4cc8f4d0) + (0, $8450780b4b9a6f99$export$dde58b009b497666) * 2) * 6;
const $72c0fa39224d4a3d$var$PickersCalendarDayRoot = (0, $HGmne.default)('div', {
    name: 'MuiDayCalendar',
    slot: 'Root',
    overridesResolver: (_, styles)=>styles.root
})({});
const $72c0fa39224d4a3d$var$PickersCalendarDayHeader = (0, $HGmne.default)('div', {
    name: 'MuiDayCalendar',
    slot: 'Header',
    overridesResolver: (_, styles)=>styles.header
})({
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
});
const $72c0fa39224d4a3d$var$PickersCalendarWeekDayLabel = (0, $HGmne.default)((0, $b4083ea3a052dee9$export$2e2bcd8739ae039), {
    name: 'MuiDayCalendar',
    slot: 'WeekDayLabel',
    overridesResolver: (_, styles)=>styles.weekDayLabel
})(({ theme: theme })=>({
        width: 36,
        height: 40,
        margin: '0 2px',
        textAlign: 'center',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        color: (theme.vars || theme).palette.text.secondary
    }));
const $72c0fa39224d4a3d$var$PickersCalendarWeekNumberLabel = (0, $HGmne.default)((0, $b4083ea3a052dee9$export$2e2bcd8739ae039), {
    name: 'MuiDayCalendar',
    slot: 'WeekNumberLabel',
    overridesResolver: (_, styles)=>styles.weekNumberLabel
})(({ theme: theme })=>({
        width: 36,
        height: 40,
        margin: '0 2px',
        textAlign: 'center',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        color: theme.palette.text.disabled
    }));
const $72c0fa39224d4a3d$var$PickersCalendarWeekNumber = (0, $HGmne.default)((0, $b4083ea3a052dee9$export$2e2bcd8739ae039), {
    name: 'MuiDayCalendar',
    slot: 'WeekNumber',
    overridesResolver: (_, styles)=>styles.weekNumber
})(({ theme: theme })=>(0, $3VnFq.default)({}, theme.typography.caption, {
        width: (0, $8450780b4b9a6f99$export$3f0060ce4cc8f4d0),
        height: (0, $8450780b4b9a6f99$export$3f0060ce4cc8f4d0),
        padding: 0,
        margin: `0 ${(0, $8450780b4b9a6f99$export$dde58b009b497666)}px`,
        color: theme.palette.text.disabled,
        fontSize: '0.75rem',
        alignItems: 'center',
        justifyContent: 'center',
        display: 'inline-flex'
    }));
const $72c0fa39224d4a3d$var$PickersCalendarLoadingContainer = (0, $HGmne.default)('div', {
    name: 'MuiDayCalendar',
    slot: 'LoadingContainer',
    overridesResolver: (_, styles)=>styles.loadingContainer
})({
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    minHeight: $72c0fa39224d4a3d$var$weeksContainerHeight
});
const $72c0fa39224d4a3d$var$PickersCalendarSlideTransition = (0, $HGmne.default)((0, $0ed82243f63c02d0$export$e868fcc7557d3a06), {
    name: 'MuiDayCalendar',
    slot: 'SlideTransition',
    overridesResolver: (_, styles)=>styles.slideTransition
})({
    minHeight: $72c0fa39224d4a3d$var$weeksContainerHeight
});
const $72c0fa39224d4a3d$var$PickersCalendarWeekContainer = (0, $HGmne.default)('div', {
    name: 'MuiDayCalendar',
    slot: 'MonthContainer',
    overridesResolver: (_, styles)=>styles.monthContainer
})({
    overflow: 'hidden'
});
const $72c0fa39224d4a3d$var$PickersCalendarWeek = (0, $HGmne.default)('div', {
    name: 'MuiDayCalendar',
    slot: 'WeekContainer',
    overridesResolver: (_, styles)=>styles.weekContainer
})({
    margin: `${(0, $8450780b4b9a6f99$export$dde58b009b497666)}px 0`,
    display: 'flex',
    justifyContent: 'center'
});
function $72c0fa39224d4a3d$var$WrappedDay(_ref) {
    var _ref2, _slots$day, _slotProps$day;
    let { parentProps: parentProps, day: day, focusableDay: focusableDay, selectedDays: selectedDays, isDateDisabled: isDateDisabled, currentMonthNumber: currentMonthNumber, isViewFocused: isViewFocused } = _ref, other = (0, $cTAWX.default)(_ref, $72c0fa39224d4a3d$var$_excluded);
    const { disabled: disabled, disableHighlightToday: disableHighlightToday, isMonthSwitchingAnimating: isMonthSwitchingAnimating, showDaysOutsideCurrentMonth: showDaysOutsideCurrentMonth, components: components, componentsProps: componentsProps, slots: slots, slotProps: slotProps, timezone: timezone } = parentProps;
    const utils = (0, $98220f21a8625472$export$1163b47e39508a46)();
    const now = (0, $98220f21a8625472$export$3a404aece3dff2fa)(timezone);
    const isFocusableDay = focusableDay !== null && utils.isSameDay(day, focusableDay);
    const isSelected = selectedDays.some((selectedDay)=>utils.isSameDay(selectedDay, day));
    const isToday = utils.isSameDay(day, now);
    const Day = (_ref2 = (_slots$day = slots == null ? void 0 : slots.day) != null ? _slots$day : components == null ? void 0 : components.Day) != null ? _ref2 : (0, $a5553328c1dee6a7$export$d7378e6e864346fa);
    // We don't want to pass to ownerState down, to avoid re-rendering all the day whenever a prop changes.
    const _useSlotProps = (0, $2082854bb194ebf1$export$2e2bcd8739ae039)({
        elementType: Day,
        externalSlotProps: (_slotProps$day = slotProps == null ? void 0 : slotProps.day) != null ? _slotProps$day : componentsProps == null ? void 0 : componentsProps.day,
        additionalProps: (0, $3VnFq.default)({
            disableHighlightToday: disableHighlightToday,
            showDaysOutsideCurrentMonth: showDaysOutsideCurrentMonth,
            role: 'gridcell',
            isAnimating: isMonthSwitchingAnimating,
            // it is used in date range dragging logic by accessing `dataset.timestamp`
            'data-timestamp': utils.toJsDate(day).valueOf()
        }, other),
        ownerState: (0, $3VnFq.default)({}, parentProps, {
            day: day,
            selected: isSelected
        })
    }), dayProps = (0, $cTAWX.default)(_useSlotProps, $72c0fa39224d4a3d$var$_excluded2);
    const isDisabled = $gJYWc.useMemo(()=>disabled || isDateDisabled(day), [
        disabled,
        isDateDisabled,
        day
    ]);
    const outsideCurrentMonth = $gJYWc.useMemo(()=>utils.getMonth(day) !== currentMonthNumber, [
        utils,
        day,
        currentMonthNumber
    ]);
    const isFirstVisibleCell = $gJYWc.useMemo(()=>{
        const startOfMonth = utils.startOfMonth(utils.setMonth(day, currentMonthNumber));
        if (!showDaysOutsideCurrentMonth) return utils.isSameDay(day, startOfMonth);
        return utils.isSameDay(day, utils.startOfWeek(startOfMonth));
    }, [
        currentMonthNumber,
        day,
        showDaysOutsideCurrentMonth,
        utils
    ]);
    const isLastVisibleCell = $gJYWc.useMemo(()=>{
        const endOfMonth = utils.endOfMonth(utils.setMonth(day, currentMonthNumber));
        if (!showDaysOutsideCurrentMonth) return utils.isSameDay(day, endOfMonth);
        return utils.isSameDay(day, utils.endOfWeek(endOfMonth));
    }, [
        currentMonthNumber,
        day,
        showDaysOutsideCurrentMonth,
        utils
    ]);
    return /*#__PURE__*/ (0, $9wx12.jsx)(Day, (0, $3VnFq.default)({}, dayProps, {
        day: day,
        disabled: isDisabled,
        autoFocus: isViewFocused && isFocusableDay,
        today: isToday,
        outsideCurrentMonth: outsideCurrentMonth,
        isFirstVisibleCell: isFirstVisibleCell,
        isLastVisibleCell: isLastVisibleCell,
        selected: isSelected,
        tabIndex: isFocusableDay ? 0 : -1,
        "aria-selected": isSelected,
        "aria-current": isToday ? 'date' : undefined
    }));
}
function $72c0fa39224d4a3d$export$8fb56b32a5df6314(inProps) {
    const props = (0, $6959428021af84ce$export$2e2bcd8739ae039)({
        props: inProps,
        name: 'MuiDayCalendar'
    });
    const { onFocusedDayChange: onFocusedDayChange, className: className, currentMonth: currentMonth, selectedDays: selectedDays, focusedDay: focusedDay, loading: loading, onSelectedDaysChange: onSelectedDaysChange, onMonthSwitchingAnimationEnd: onMonthSwitchingAnimationEnd, readOnly: readOnly, reduceAnimations: reduceAnimations, renderLoading: renderLoading = ()=>/*#__PURE__*/ (0, $9wx12.jsx)("span", {
            children: "..."
        }), slideDirection: slideDirection, TransitionProps: TransitionProps, disablePast: disablePast, disableFuture: disableFuture, minDate: minDate, maxDate: maxDate, shouldDisableDate: shouldDisableDate, shouldDisableMonth: shouldDisableMonth, shouldDisableYear: shouldDisableYear, dayOfWeekFormatter: dayOfWeekFormatterFromProps, hasFocus: hasFocus, onFocusedViewChange: onFocusedViewChange, gridLabelId: gridLabelId, displayWeekNumber: displayWeekNumber, fixedWeekNumber: fixedWeekNumber, autoFocus: autoFocus, timezone: timezone } = props;
    const now = (0, $98220f21a8625472$export$3a404aece3dff2fa)(timezone);
    const utils = (0, $98220f21a8625472$export$1163b47e39508a46)();
    const classes = $72c0fa39224d4a3d$var$useUtilityClasses(props);
    const theme = (0, $ae968105fc5c093e$export$2e2bcd8739ae039)();
    const isRTL = theme.direction === 'rtl';
    // before we could define this outside of the component scope, but now we need utils, which is only defined here
    const dayOfWeekFormatter = dayOfWeekFormatterFromProps || ((_day, date)=>utils.format(date, 'weekdayShort').charAt(0).toUpperCase());
    const isDateDisabled = (0, $30dffcea4c73c048$export$7d1a419f34475191)({
        shouldDisableDate: shouldDisableDate,
        shouldDisableMonth: shouldDisableMonth,
        shouldDisableYear: shouldDisableYear,
        minDate: minDate,
        maxDate: maxDate,
        disablePast: disablePast,
        disableFuture: disableFuture,
        timezone: timezone
    });
    const localeText = (0, $98220f21a8625472$export$24fdeaa0f591a73e)();
    const [internalHasFocus, setInternalHasFocus] = (0, $778a260509dda869$export$2e2bcd8739ae039)({
        name: 'DayCalendar',
        state: 'hasFocus',
        controlled: hasFocus,
        default: autoFocus != null ? autoFocus : false
    });
    const [internalFocusedDay, setInternalFocusedDay] = $gJYWc.useState(()=>focusedDay || now);
    const handleDaySelect = (0, $92UcI.default)((day)=>{
        if (readOnly) return;
        onSelectedDaysChange(day);
    });
    const focusDay = (day)=>{
        if (!isDateDisabled(day)) {
            onFocusedDayChange(day);
            setInternalFocusedDay(day);
            onFocusedViewChange == null || onFocusedViewChange(true);
            setInternalHasFocus(true);
        }
    };
    const handleKeyDown = (0, $92UcI.default)((event, day)=>{
        switch(event.key){
            case 'ArrowUp':
                focusDay(utils.addDays(day, -7));
                event.preventDefault();
                break;
            case 'ArrowDown':
                focusDay(utils.addDays(day, 7));
                event.preventDefault();
                break;
            case 'ArrowLeft':
                {
                    const newFocusedDayDefault = utils.addDays(day, isRTL ? 1 : -1);
                    const nextAvailableMonth = utils.addMonths(day, isRTL ? 1 : -1);
                    const closestDayToFocus = (0, $00e6d022b450825d$export$ca1f317ae8db2ee8)({
                        utils: utils,
                        date: newFocusedDayDefault,
                        minDate: isRTL ? newFocusedDayDefault : utils.startOfMonth(nextAvailableMonth),
                        maxDate: isRTL ? utils.endOfMonth(nextAvailableMonth) : newFocusedDayDefault,
                        isDateDisabled: isDateDisabled,
                        timezone: timezone
                    });
                    focusDay(closestDayToFocus || newFocusedDayDefault);
                    event.preventDefault();
                    break;
                }
            case 'ArrowRight':
                {
                    const newFocusedDayDefault = utils.addDays(day, isRTL ? -1 : 1);
                    const nextAvailableMonth = utils.addMonths(day, isRTL ? -1 : 1);
                    const closestDayToFocus = (0, $00e6d022b450825d$export$ca1f317ae8db2ee8)({
                        utils: utils,
                        date: newFocusedDayDefault,
                        minDate: isRTL ? utils.startOfMonth(nextAvailableMonth) : newFocusedDayDefault,
                        maxDate: isRTL ? newFocusedDayDefault : utils.endOfMonth(nextAvailableMonth),
                        isDateDisabled: isDateDisabled,
                        timezone: timezone
                    });
                    focusDay(closestDayToFocus || newFocusedDayDefault);
                    event.preventDefault();
                    break;
                }
            case 'Home':
                focusDay(utils.startOfWeek(day));
                event.preventDefault();
                break;
            case 'End':
                focusDay(utils.endOfWeek(day));
                event.preventDefault();
                break;
            case 'PageUp':
                focusDay(utils.addMonths(day, 1));
                event.preventDefault();
                break;
            case 'PageDown':
                focusDay(utils.addMonths(day, -1));
                event.preventDefault();
                break;
            default:
                break;
        }
    });
    const handleFocus = (0, $92UcI.default)((event, day)=>focusDay(day));
    const handleBlur = (0, $92UcI.default)((event, day)=>{
        if (internalHasFocus && utils.isSameDay(internalFocusedDay, day)) onFocusedViewChange == null || onFocusedViewChange(false);
    });
    const currentMonthNumber = utils.getMonth(currentMonth);
    const validSelectedDays = $gJYWc.useMemo(()=>selectedDays.filter((day)=>!!day).map((day)=>utils.startOfDay(day)), [
        utils,
        selectedDays
    ]);
    // need a new ref whenever the `key` of the transition changes: http://reactcommunity.org/react-transition-group/transition/#Transition-prop-nodeRef.
    const transitionKey = currentMonthNumber;
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const slideNodeRef = $gJYWc.useMemo(()=>/*#__PURE__*/ $gJYWc.createRef(), [
        transitionKey
    ]);
    const startOfCurrentWeek = utils.startOfWeek(now);
    const focusableDay = $gJYWc.useMemo(()=>{
        const startOfMonth = utils.startOfMonth(currentMonth);
        const endOfMonth = utils.endOfMonth(currentMonth);
        if (isDateDisabled(internalFocusedDay) || utils.isAfterDay(internalFocusedDay, endOfMonth) || utils.isBeforeDay(internalFocusedDay, startOfMonth)) return (0, $00e6d022b450825d$export$ca1f317ae8db2ee8)({
            utils: utils,
            date: internalFocusedDay,
            minDate: startOfMonth,
            maxDate: endOfMonth,
            disablePast: disablePast,
            disableFuture: disableFuture,
            isDateDisabled: isDateDisabled,
            timezone: timezone
        });
        return internalFocusedDay;
    }, [
        currentMonth,
        disableFuture,
        disablePast,
        internalFocusedDay,
        isDateDisabled,
        utils,
        timezone
    ]);
    const weeksToDisplay = $gJYWc.useMemo(()=>{
        const currentMonthWithTimezone = utils.setTimezone(currentMonth, timezone);
        const toDisplay = utils.getWeekArray(currentMonthWithTimezone);
        let nextMonth = utils.addMonths(currentMonthWithTimezone, 1);
        while(fixedWeekNumber && toDisplay.length < fixedWeekNumber){
            const additionalWeeks = utils.getWeekArray(nextMonth);
            const hasCommonWeek = utils.isSameDay(toDisplay[toDisplay.length - 1][0], additionalWeeks[0][0]);
            additionalWeeks.slice(hasCommonWeek ? 1 : 0).forEach((week)=>{
                if (toDisplay.length < fixedWeekNumber) toDisplay.push(week);
            });
            nextMonth = utils.addMonths(nextMonth, 1);
        }
        return toDisplay;
    }, [
        currentMonth,
        fixedWeekNumber,
        utils,
        timezone
    ]);
    return /*#__PURE__*/ (0, $9wx12.jsxs)($72c0fa39224d4a3d$var$PickersCalendarDayRoot, {
        role: "grid",
        "aria-labelledby": gridLabelId,
        className: classes.root,
        children: [
            /*#__PURE__*/ (0, $9wx12.jsxs)($72c0fa39224d4a3d$var$PickersCalendarDayHeader, {
                role: "row",
                className: classes.header,
                children: [
                    displayWeekNumber && /*#__PURE__*/ (0, $9wx12.jsx)($72c0fa39224d4a3d$var$PickersCalendarWeekNumberLabel, {
                        variant: "caption",
                        role: "columnheader",
                        "aria-label": localeText.calendarWeekNumberHeaderLabel,
                        className: classes.weekNumberLabel,
                        children: localeText.calendarWeekNumberHeaderText
                    }),
                    (0, $00e6d022b450825d$export$24c38139da66592d)(utils, now).map((weekday, i)=>{
                        var _dayOfWeekFormatter;
                        const day = utils.format(weekday, 'weekdayShort');
                        return /*#__PURE__*/ (0, $9wx12.jsx)($72c0fa39224d4a3d$var$PickersCalendarWeekDayLabel, {
                            variant: "caption",
                            role: "columnheader",
                            "aria-label": utils.format(utils.addDays(startOfCurrentWeek, i), 'weekday'),
                            className: classes.weekDayLabel,
                            children: (_dayOfWeekFormatter = dayOfWeekFormatter == null ? void 0 : dayOfWeekFormatter(day, weekday)) != null ? _dayOfWeekFormatter : day
                        }, day + i.toString());
                    })
                ]
            }),
            loading ? /*#__PURE__*/ (0, $9wx12.jsx)($72c0fa39224d4a3d$var$PickersCalendarLoadingContainer, {
                className: classes.loadingContainer,
                children: renderLoading()
            }) : /*#__PURE__*/ (0, $9wx12.jsx)($72c0fa39224d4a3d$var$PickersCalendarSlideTransition, (0, $3VnFq.default)({
                transKey: transitionKey,
                onExited: onMonthSwitchingAnimationEnd,
                reduceAnimations: reduceAnimations,
                slideDirection: slideDirection,
                className: (0, $2w6IV.default)(className, classes.slideTransition)
            }, TransitionProps, {
                nodeRef: slideNodeRef,
                children: /*#__PURE__*/ (0, $9wx12.jsx)($72c0fa39224d4a3d$var$PickersCalendarWeekContainer, {
                    ref: slideNodeRef,
                    role: "rowgroup",
                    className: classes.monthContainer,
                    children: weeksToDisplay.map((week, index)=>/*#__PURE__*/ (0, $9wx12.jsxs)($72c0fa39224d4a3d$var$PickersCalendarWeek, {
                            role: "row",
                            className: classes.weekContainer,
                            "aria-rowindex": index + 1,
                            children: [
                                displayWeekNumber && /*#__PURE__*/ (0, $9wx12.jsx)($72c0fa39224d4a3d$var$PickersCalendarWeekNumber, {
                                    className: classes.weekNumber,
                                    role: "rowheader",
                                    "aria-label": localeText.calendarWeekNumberAriaLabelText(utils.getWeekNumber(week[0])),
                                    children: localeText.calendarWeekNumberText(utils.getWeekNumber(week[0]))
                                }),
                                week.map((day, dayIndex)=>/*#__PURE__*/ (0, $9wx12.jsx)($72c0fa39224d4a3d$var$WrappedDay, {
                                        parentProps: props,
                                        day: day,
                                        selectedDays: validSelectedDays,
                                        focusableDay: focusableDay,
                                        onKeyDown: handleKeyDown,
                                        onFocus: handleFocus,
                                        onBlur: handleBlur,
                                        onDaySelect: handleDaySelect,
                                        isDateDisabled: isDateDisabled,
                                        currentMonthNumber: currentMonthNumber,
                                        isViewFocused: internalHasFocus,
                                        "aria-colindex": dayIndex + 1
                                    }, day.toString()))
                            ]
                        }, `week-${week[0]}`))
                })
            }))
        ]
    });
}



var $cTAWX = parcelRequire("cTAWX");

var $3VnFq = parcelRequire("3VnFq");

var $gJYWc = parcelRequire("gJYWc");


var $2w6IV = parcelRequire("2w6IV");


var $HGmne = parcelRequire("HGmne");

var $3e4LV = parcelRequire("3e4LV");
var $92UcI = parcelRequire("92UcI");

var $cTAWX = parcelRequire("cTAWX");

var $3VnFq = parcelRequire("3VnFq");

var $gJYWc = parcelRequire("gJYWc");

var $HGmne = parcelRequire("HGmne");

var $3e4LV = parcelRequire("3e4LV");
var $4z2O6 = parcelRequire("4z2O6");

var $1kRHf = parcelRequire("1kRHf");
var $i8nzj = parcelRequire("i8nzj");
function $6a42f98caa99513b$export$db90a620ac957a73(slot) {
    return (0, $1kRHf.default)('MuiPickersMonth', slot);
}
const $6a42f98caa99513b$export$911e3973fa70a12b = (0, $i8nzj.default)('MuiPickersMonth', [
    'root',
    'monthButton',
    'disabled',
    'selected'
]);



var $9wx12 = parcelRequire("9wx12");
const $dfd3554fed92a4a0$var$_excluded = [
    "autoFocus",
    "children",
    "disabled",
    "selected",
    "value",
    "tabIndex",
    "onClick",
    "onKeyDown",
    "onFocus",
    "onBlur",
    "aria-current",
    "aria-label",
    "monthsPerRow"
];
const $dfd3554fed92a4a0$var$useUtilityClasses = (ownerState)=>{
    const { disabled: disabled, selected: selected, classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ],
        monthButton: [
            'monthButton',
            disabled && 'disabled',
            selected && 'selected'
        ]
    };
    return (0, $3e4LV.default)(slots, (0, $6a42f98caa99513b$export$db90a620ac957a73), classes);
};
const $dfd3554fed92a4a0$var$PickersMonthRoot = (0, $HGmne.default)('div', {
    name: 'MuiPickersMonth',
    slot: 'Root',
    overridesResolver: (_, styles)=>[
            styles.root
        ]
})(({ ownerState: ownerState })=>({
        flexBasis: ownerState.monthsPerRow === 3 ? '33.3%' : '25%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
    }));
const $dfd3554fed92a4a0$var$PickersMonthButton = (0, $HGmne.default)('button', {
    name: 'MuiPickersMonth',
    slot: 'MonthButton',
    overridesResolver: (_, styles)=>[
            styles.monthButton,
            {
                [`&.${(0, $6a42f98caa99513b$export$911e3973fa70a12b).disabled}`]: styles.disabled
            },
            {
                [`&.${(0, $6a42f98caa99513b$export$911e3973fa70a12b).selected}`]: styles.selected
            }
        ]
})(({ theme: theme })=>(0, $3VnFq.default)({
        color: 'unset',
        backgroundColor: 'transparent',
        border: 0,
        outline: 0
    }, theme.typography.subtitle1, {
        margin: '8px 0',
        height: 36,
        width: 72,
        borderRadius: 18,
        cursor: 'pointer',
        '&:focus': {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.action.activeChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $cf4e4db1b4d926c1$export$58f0f39f63f3cf42)(theme.palette.action.active, theme.palette.action.hoverOpacity)
        },
        '&:hover': {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.action.activeChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $cf4e4db1b4d926c1$export$58f0f39f63f3cf42)(theme.palette.action.active, theme.palette.action.hoverOpacity)
        },
        '&:disabled': {
            cursor: 'auto',
            pointerEvents: 'none'
        },
        [`&.${(0, $6a42f98caa99513b$export$911e3973fa70a12b).disabled}`]: {
            color: (theme.vars || theme).palette.text.secondary
        },
        [`&.${(0, $6a42f98caa99513b$export$911e3973fa70a12b).selected}`]: {
            color: (theme.vars || theme).palette.primary.contrastText,
            backgroundColor: (theme.vars || theme).palette.primary.main,
            '&:focus, &:hover': {
                backgroundColor: (theme.vars || theme).palette.primary.dark
            }
        }
    }));
const $dfd3554fed92a4a0$export$bc52fdb7f02f591a = /*#__PURE__*/ $gJYWc.memo(function PickersMonth(inProps) {
    const props = (0, $6959428021af84ce$export$2e2bcd8739ae039)({
        props: inProps,
        name: 'MuiPickersMonth'
    });
    const { autoFocus: autoFocus, children: children, disabled: disabled, selected: selected, value: value, tabIndex: tabIndex, onClick: onClick, onKeyDown: onKeyDown, onFocus: onFocus, onBlur: onBlur, 'aria-current': ariaCurrent, 'aria-label': ariaLabel } = props, other = (0, $cTAWX.default)(props, $dfd3554fed92a4a0$var$_excluded);
    const ref = $gJYWc.useRef(null);
    const classes = $dfd3554fed92a4a0$var$useUtilityClasses(props);
    (0, $4z2O6.default)(()=>{
        if (autoFocus) {
            var _ref$current;
            (_ref$current = ref.current) == null || _ref$current.focus();
        }
    }, [
        autoFocus
    ]);
    return /*#__PURE__*/ (0, $9wx12.jsx)($dfd3554fed92a4a0$var$PickersMonthRoot, (0, $3VnFq.default)({
        className: classes.root,
        ownerState: props
    }, other, {
        children: /*#__PURE__*/ (0, $9wx12.jsx)($dfd3554fed92a4a0$var$PickersMonthButton, {
            ref: ref,
            disabled: disabled,
            type: "button",
            role: "radio",
            tabIndex: disabled ? -1 : tabIndex,
            "aria-current": ariaCurrent,
            "aria-checked": selected,
            "aria-label": ariaLabel,
            onClick: (event)=>onClick(event, value),
            onKeyDown: (event)=>onKeyDown(event, value),
            onFocus: (event)=>onFocus(event, value),
            onBlur: (event)=>onBlur(event, value),
            className: classes.monthButton,
            ownerState: props,
            children: children
        })
    }));
});




var $1kRHf = parcelRequire("1kRHf");
var $i8nzj = parcelRequire("i8nzj");
function $5b58281bd9510249$export$da0c97315339ebd9(slot) {
    return (0, $1kRHf.default)('MuiMonthCalendar', slot);
}
const $5b58281bd9510249$export$edf77d5566c7007c = (0, $i8nzj.default)('MuiMonthCalendar', [
    'root'
]);








var $9wx12 = parcelRequire("9wx12");
const $763b3bb5560e7609$var$_excluded = [
    "className",
    "value",
    "defaultValue",
    "referenceDate",
    "disabled",
    "disableFuture",
    "disablePast",
    "maxDate",
    "minDate",
    "onChange",
    "shouldDisableMonth",
    "readOnly",
    "disableHighlightToday",
    "autoFocus",
    "onMonthFocus",
    "hasFocus",
    "onFocusedViewChange",
    "monthsPerRow",
    "timezone",
    "gridLabelId"
];
const $763b3bb5560e7609$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ]
    };
    return (0, $3e4LV.default)(slots, (0, $5b58281bd9510249$export$da0c97315339ebd9), classes);
};
function $763b3bb5560e7609$export$5b6e066572408095(props, name) {
    const utils = (0, $98220f21a8625472$export$1163b47e39508a46)();
    const defaultDates = (0, $98220f21a8625472$export$7c38da3a2e90fa83)();
    const themeProps = (0, $6959428021af84ce$export$2e2bcd8739ae039)({
        props: props,
        name: name
    });
    return (0, $3VnFq.default)({
        disableFuture: false,
        disablePast: false
    }, themeProps, {
        minDate: (0, $00e6d022b450825d$export$eb73579ccade48fd)(utils, themeProps.minDate, defaultDates.minDate),
        maxDate: (0, $00e6d022b450825d$export$eb73579ccade48fd)(utils, themeProps.maxDate, defaultDates.maxDate)
    });
}
const $763b3bb5560e7609$var$MonthCalendarRoot = (0, $HGmne.default)('div', {
    name: 'MuiMonthCalendar',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})({
    display: 'flex',
    flexWrap: 'wrap',
    alignContent: 'stretch',
    padding: '0 4px',
    width: (0, $8450780b4b9a6f99$export$ee46b8a74d6c94d3),
    // avoid padding increasing width over defined
    boxSizing: 'border-box'
});
const $763b3bb5560e7609$export$d7a7c85c0f5afc4a = /*#__PURE__*/ $gJYWc.forwardRef(function MonthCalendar(inProps, ref) {
    const props = $763b3bb5560e7609$export$5b6e066572408095(inProps, 'MuiMonthCalendar');
    const { className: className, value: valueProp, defaultValue: defaultValue, referenceDate: referenceDateProp, disabled: disabled, disableFuture: disableFuture, disablePast: disablePast, maxDate: maxDate, minDate: minDate, onChange: onChange, shouldDisableMonth: shouldDisableMonth, readOnly: readOnly, disableHighlightToday: disableHighlightToday, autoFocus: autoFocus = false, onMonthFocus: onMonthFocus, hasFocus: hasFocus, onFocusedViewChange: onFocusedViewChange, monthsPerRow: monthsPerRow = 3, timezone: timezoneProp, gridLabelId: gridLabelId } = props, other = (0, $cTAWX.default)(props, $763b3bb5560e7609$var$_excluded);
    const { value: value, handleValueChange: handleValueChange, timezone: timezone } = (0, $666e75003bf5e8d6$export$174d749f3b4c0f49)({
        name: 'MonthCalendar',
        timezone: timezoneProp,
        value: valueProp,
        defaultValue: defaultValue,
        onChange: onChange,
        valueManager: (0, $15cde65cbd91c944$export$2764b246aa3b75ba)
    });
    const now = (0, $98220f21a8625472$export$3a404aece3dff2fa)(timezone);
    const theme = (0, $81fc44edf20e1517$export$2e2bcd8739ae039)();
    const utils = (0, $98220f21a8625472$export$1163b47e39508a46)();
    const referenceDate = $gJYWc.useMemo(()=>(0, $15cde65cbd91c944$export$2764b246aa3b75ba).getInitialReferenceValue({
            value: value,
            utils: utils,
            props: props,
            timezone: timezone,
            referenceDate: referenceDateProp,
            granularity: (0, $d8b7b2aeaa0755b4$export$8f74e8f4ed8ae0ac).month
        }), [] // eslint-disable-line react-hooks/exhaustive-deps
    );
    const ownerState = props;
    const classes = $763b3bb5560e7609$var$useUtilityClasses(ownerState);
    const todayMonth = $gJYWc.useMemo(()=>utils.getMonth(now), [
        utils,
        now
    ]);
    const selectedMonth = $gJYWc.useMemo(()=>{
        if (value != null) return utils.getMonth(value);
        if (disableHighlightToday) return null;
        return utils.getMonth(referenceDate);
    }, [
        value,
        utils,
        disableHighlightToday,
        referenceDate
    ]);
    const [focusedMonth, setFocusedMonth] = $gJYWc.useState(()=>selectedMonth || todayMonth);
    const [internalHasFocus, setInternalHasFocus] = (0, $778a260509dda869$export$2e2bcd8739ae039)({
        name: 'MonthCalendar',
        state: 'hasFocus',
        controlled: hasFocus,
        default: autoFocus != null ? autoFocus : false
    });
    const changeHasFocus = (0, $92UcI.default)((newHasFocus)=>{
        setInternalHasFocus(newHasFocus);
        if (onFocusedViewChange) onFocusedViewChange(newHasFocus);
    });
    const isMonthDisabled = $gJYWc.useCallback((dateToValidate)=>{
        const firstEnabledMonth = utils.startOfMonth(disablePast && utils.isAfter(now, minDate) ? now : minDate);
        const lastEnabledMonth = utils.startOfMonth(disableFuture && utils.isBefore(now, maxDate) ? now : maxDate);
        const monthToValidate = utils.startOfMonth(dateToValidate);
        if (utils.isBefore(monthToValidate, firstEnabledMonth)) return true;
        if (utils.isAfter(monthToValidate, lastEnabledMonth)) return true;
        if (!shouldDisableMonth) return false;
        return shouldDisableMonth(monthToValidate);
    }, [
        disableFuture,
        disablePast,
        maxDate,
        minDate,
        now,
        shouldDisableMonth,
        utils
    ]);
    const handleMonthSelection = (0, $92UcI.default)((event, month)=>{
        if (readOnly) return;
        const newDate = utils.setMonth(value != null ? value : referenceDate, month);
        handleValueChange(newDate);
    });
    const focusMonth = (0, $92UcI.default)((month)=>{
        if (!isMonthDisabled(utils.setMonth(value != null ? value : referenceDate, month))) {
            setFocusedMonth(month);
            changeHasFocus(true);
            if (onMonthFocus) onMonthFocus(month);
        }
    });
    $gJYWc.useEffect(()=>{
        setFocusedMonth((prevFocusedMonth)=>selectedMonth !== null && prevFocusedMonth !== selectedMonth ? selectedMonth : prevFocusedMonth);
    }, [
        selectedMonth
    ]);
    const handleKeyDown = (0, $92UcI.default)((event, month)=>{
        const monthsInYear = 12;
        const monthsInRow = 3;
        switch(event.key){
            case 'ArrowUp':
                focusMonth((monthsInYear + month - monthsInRow) % monthsInYear);
                event.preventDefault();
                break;
            case 'ArrowDown':
                focusMonth((monthsInYear + month + monthsInRow) % monthsInYear);
                event.preventDefault();
                break;
            case 'ArrowLeft':
                focusMonth((monthsInYear + month + (theme.direction === 'ltr' ? -1 : 1)) % monthsInYear);
                event.preventDefault();
                break;
            case 'ArrowRight':
                focusMonth((monthsInYear + month + (theme.direction === 'ltr' ? 1 : -1)) % monthsInYear);
                event.preventDefault();
                break;
            default:
                break;
        }
    });
    const handleMonthFocus = (0, $92UcI.default)((event, month)=>{
        focusMonth(month);
    });
    const handleMonthBlur = (0, $92UcI.default)((event, month)=>{
        if (focusedMonth === month) changeHasFocus(false);
    });
    return /*#__PURE__*/ (0, $9wx12.jsx)($763b3bb5560e7609$var$MonthCalendarRoot, (0, $3VnFq.default)({
        ref: ref,
        className: (0, $2w6IV.default)(classes.root, className),
        ownerState: ownerState,
        role: "radiogroup",
        "aria-labelledby": gridLabelId
    }, other, {
        children: (0, $00e6d022b450825d$export$62591b96a734eacd)(utils, value != null ? value : referenceDate).map((month)=>{
            const monthNumber = utils.getMonth(month);
            const monthText = utils.format(month, 'monthShort');
            const monthLabel = utils.format(month, 'month');
            const isSelected = monthNumber === selectedMonth;
            const isDisabled = disabled || isMonthDisabled(month);
            return /*#__PURE__*/ (0, $9wx12.jsx)((0, $dfd3554fed92a4a0$export$bc52fdb7f02f591a), {
                selected: isSelected,
                value: monthNumber,
                onClick: handleMonthSelection,
                onKeyDown: handleKeyDown,
                autoFocus: internalHasFocus && monthNumber === focusedMonth,
                disabled: isDisabled,
                tabIndex: monthNumber === focusedMonth ? 0 : -1,
                onFocus: handleMonthFocus,
                onBlur: handleMonthBlur,
                "aria-current": todayMonth === monthNumber ? 'date' : undefined,
                "aria-label": monthLabel,
                monthsPerRow: monthsPerRow,
                children: monthText
            }, monthText);
        })
    }));
});



var $cTAWX = parcelRequire("cTAWX");

var $3VnFq = parcelRequire("3VnFq");

var $gJYWc = parcelRequire("gJYWc");


var $2w6IV = parcelRequire("2w6IV");


var $HGmne = parcelRequire("HGmne");

var $3e4LV = parcelRequire("3e4LV");
var $92UcI = parcelRequire("92UcI");
var $4gWBK = parcelRequire("4gWBK");

var $cTAWX = parcelRequire("cTAWX");

var $3VnFq = parcelRequire("3VnFq");

var $gJYWc = parcelRequire("gJYWc");

var $2w6IV = parcelRequire("2w6IV");

var $3e4LV = parcelRequire("3e4LV");

var $HGmne = parcelRequire("HGmne");

var $1kRHf = parcelRequire("1kRHf");
var $i8nzj = parcelRequire("i8nzj");
function $8702d49c07447687$export$183c9f339a61cd79(slot) {
    return (0, $1kRHf.default)('MuiPickersYear', slot);
}
const $8702d49c07447687$export$4ef58a3d9c6f4296 = (0, $i8nzj.default)('MuiPickersYear', [
    'root',
    'yearButton',
    'selected',
    'disabled'
]);



var $9wx12 = parcelRequire("9wx12");
const $488c7e807dbad5a5$var$_excluded = [
    "autoFocus",
    "className",
    "children",
    "disabled",
    "selected",
    "value",
    "tabIndex",
    "onClick",
    "onKeyDown",
    "onFocus",
    "onBlur",
    "aria-current",
    "yearsPerRow"
];
const $488c7e807dbad5a5$var$useUtilityClasses = (ownerState)=>{
    const { disabled: disabled, selected: selected, classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ],
        yearButton: [
            'yearButton',
            disabled && 'disabled',
            selected && 'selected'
        ]
    };
    return (0, $3e4LV.default)(slots, (0, $8702d49c07447687$export$183c9f339a61cd79), classes);
};
const $488c7e807dbad5a5$var$PickersYearRoot = (0, $HGmne.default)('div', {
    name: 'MuiPickersYear',
    slot: 'Root',
    overridesResolver: (_, styles)=>[
            styles.root
        ]
})(({ ownerState: ownerState })=>({
        flexBasis: ownerState.yearsPerRow === 3 ? '33.3%' : '25%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
    }));
const $488c7e807dbad5a5$var$PickersYearButton = (0, $HGmne.default)('button', {
    name: 'MuiPickersYear',
    slot: 'YearButton',
    overridesResolver: (_, styles)=>[
            styles.yearButton,
            {
                [`&.${(0, $8702d49c07447687$export$4ef58a3d9c6f4296).disabled}`]: styles.disabled
            },
            {
                [`&.${(0, $8702d49c07447687$export$4ef58a3d9c6f4296).selected}`]: styles.selected
            }
        ]
})(({ theme: theme })=>(0, $3VnFq.default)({
        color: 'unset',
        backgroundColor: 'transparent',
        border: 0,
        outline: 0
    }, theme.typography.subtitle1, {
        margin: '6px 0',
        height: 36,
        width: 72,
        borderRadius: 18,
        cursor: 'pointer',
        '&:focus': {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.action.activeChannel} / ${theme.vars.palette.action.focusOpacity})` : (0, $cf4e4db1b4d926c1$export$58f0f39f63f3cf42)(theme.palette.action.active, theme.palette.action.focusOpacity)
        },
        '&:hover': {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.action.activeChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $cf4e4db1b4d926c1$export$58f0f39f63f3cf42)(theme.palette.action.active, theme.palette.action.hoverOpacity)
        },
        '&:disabled': {
            cursor: 'auto',
            pointerEvents: 'none'
        },
        [`&.${(0, $8702d49c07447687$export$4ef58a3d9c6f4296).disabled}`]: {
            color: (theme.vars || theme).palette.text.secondary
        },
        [`&.${(0, $8702d49c07447687$export$4ef58a3d9c6f4296).selected}`]: {
            color: (theme.vars || theme).palette.primary.contrastText,
            backgroundColor: (theme.vars || theme).palette.primary.main,
            '&:focus, &:hover': {
                backgroundColor: (theme.vars || theme).palette.primary.dark
            }
        }
    }));
const $488c7e807dbad5a5$export$261f3fbd5fd5814d = /*#__PURE__*/ $gJYWc.memo(function PickersYear(inProps) {
    const props = (0, $6959428021af84ce$export$2e2bcd8739ae039)({
        props: inProps,
        name: 'MuiPickersYear'
    });
    const { autoFocus: autoFocus, className: className, children: children, disabled: disabled, selected: selected, value: value, tabIndex: tabIndex, onClick: onClick, onKeyDown: onKeyDown, onFocus: onFocus, onBlur: onBlur, 'aria-current': ariaCurrent } = props, other = (0, $cTAWX.default)(props, $488c7e807dbad5a5$var$_excluded);
    const ref = $gJYWc.useRef(null);
    const classes = $488c7e807dbad5a5$var$useUtilityClasses(props);
    // We can't forward the `autoFocus` to the button because it is a native button, not a MUI Button
    $gJYWc.useEffect(()=>{
        if (autoFocus) // `ref.current` being `null` would be a bug in MUI.
        ref.current.focus();
    }, [
        autoFocus
    ]);
    return /*#__PURE__*/ (0, $9wx12.jsx)($488c7e807dbad5a5$var$PickersYearRoot, (0, $3VnFq.default)({
        className: (0, $2w6IV.default)(classes.root, className),
        ownerState: props
    }, other, {
        children: /*#__PURE__*/ (0, $9wx12.jsx)($488c7e807dbad5a5$var$PickersYearButton, {
            ref: ref,
            disabled: disabled,
            type: "button",
            role: "radio",
            tabIndex: disabled ? -1 : tabIndex,
            "aria-current": ariaCurrent,
            "aria-checked": selected,
            onClick: (event)=>onClick(event, value),
            onKeyDown: (event)=>onKeyDown(event, value),
            onFocus: (event)=>onFocus(event, value),
            onBlur: (event)=>onBlur(event, value),
            className: classes.yearButton,
            ownerState: props,
            children: children
        })
    }));
});




var $1kRHf = parcelRequire("1kRHf");
var $i8nzj = parcelRequire("i8nzj");
function $4d8bcc54d2f194c2$export$4477acc520094dec(slot) {
    return (0, $1kRHf.default)('MuiYearCalendar', slot);
}
const $4d8bcc54d2f194c2$export$e42d427cd9fe5fd7 = (0, $i8nzj.default)('MuiYearCalendar', [
    'root'
]);








var $9wx12 = parcelRequire("9wx12");
const $59a758f5e7d34634$var$_excluded = [
    "autoFocus",
    "className",
    "value",
    "defaultValue",
    "referenceDate",
    "disabled",
    "disableFuture",
    "disablePast",
    "maxDate",
    "minDate",
    "onChange",
    "readOnly",
    "shouldDisableYear",
    "disableHighlightToday",
    "onYearFocus",
    "hasFocus",
    "onFocusedViewChange",
    "yearsPerRow",
    "timezone",
    "gridLabelId"
];
const $59a758f5e7d34634$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ]
    };
    return (0, $3e4LV.default)(slots, (0, $4d8bcc54d2f194c2$export$4477acc520094dec), classes);
};
function $59a758f5e7d34634$var$useYearCalendarDefaultizedProps(props, name) {
    var _themeProps$yearsPerR;
    const utils = (0, $98220f21a8625472$export$1163b47e39508a46)();
    const defaultDates = (0, $98220f21a8625472$export$7c38da3a2e90fa83)();
    const themeProps = (0, $6959428021af84ce$export$2e2bcd8739ae039)({
        props: props,
        name: name
    });
    return (0, $3VnFq.default)({
        disablePast: false,
        disableFuture: false
    }, themeProps, {
        yearsPerRow: (_themeProps$yearsPerR = themeProps.yearsPerRow) != null ? _themeProps$yearsPerR : 3,
        minDate: (0, $00e6d022b450825d$export$eb73579ccade48fd)(utils, themeProps.minDate, defaultDates.minDate),
        maxDate: (0, $00e6d022b450825d$export$eb73579ccade48fd)(utils, themeProps.maxDate, defaultDates.maxDate)
    });
}
const $59a758f5e7d34634$var$YearCalendarRoot = (0, $HGmne.default)('div', {
    name: 'MuiYearCalendar',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})({
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    overflowY: 'auto',
    height: '100%',
    padding: '0 4px',
    width: (0, $8450780b4b9a6f99$export$ee46b8a74d6c94d3),
    maxHeight: (0, $8450780b4b9a6f99$export$73724491020e90c7),
    // avoid padding increasing width over defined
    boxSizing: 'border-box',
    position: 'relative'
});
const $59a758f5e7d34634$export$657f9200591b2b71 = /*#__PURE__*/ $gJYWc.forwardRef(function YearCalendar(inProps, ref) {
    const props = $59a758f5e7d34634$var$useYearCalendarDefaultizedProps(inProps, 'MuiYearCalendar');
    const { autoFocus: autoFocus, className: className, value: valueProp, defaultValue: defaultValue, referenceDate: referenceDateProp, disabled: disabled, disableFuture: disableFuture, disablePast: disablePast, maxDate: maxDate, minDate: minDate, onChange: onChange, readOnly: readOnly, shouldDisableYear: shouldDisableYear, disableHighlightToday: disableHighlightToday, onYearFocus: onYearFocus, hasFocus: hasFocus, onFocusedViewChange: onFocusedViewChange, yearsPerRow: yearsPerRow, timezone: timezoneProp, gridLabelId: gridLabelId } = props, other = (0, $cTAWX.default)(props, $59a758f5e7d34634$var$_excluded);
    const { value: value, handleValueChange: handleValueChange, timezone: timezone } = (0, $666e75003bf5e8d6$export$174d749f3b4c0f49)({
        name: 'YearCalendar',
        timezone: timezoneProp,
        value: valueProp,
        defaultValue: defaultValue,
        onChange: onChange,
        valueManager: (0, $15cde65cbd91c944$export$2764b246aa3b75ba)
    });
    const now = (0, $98220f21a8625472$export$3a404aece3dff2fa)(timezone);
    const theme = (0, $81fc44edf20e1517$export$2e2bcd8739ae039)();
    const utils = (0, $98220f21a8625472$export$1163b47e39508a46)();
    const referenceDate = $gJYWc.useMemo(()=>(0, $15cde65cbd91c944$export$2764b246aa3b75ba).getInitialReferenceValue({
            value: value,
            utils: utils,
            props: props,
            timezone: timezone,
            referenceDate: referenceDateProp,
            granularity: (0, $d8b7b2aeaa0755b4$export$8f74e8f4ed8ae0ac).year
        }), [] // eslint-disable-line react-hooks/exhaustive-deps
    );
    const ownerState = props;
    const classes = $59a758f5e7d34634$var$useUtilityClasses(ownerState);
    const todayYear = $gJYWc.useMemo(()=>utils.getYear(now), [
        utils,
        now
    ]);
    const selectedYear = $gJYWc.useMemo(()=>{
        if (value != null) return utils.getYear(value);
        if (disableHighlightToday) return null;
        return utils.getYear(referenceDate);
    }, [
        value,
        utils,
        disableHighlightToday,
        referenceDate
    ]);
    const [focusedYear, setFocusedYear] = $gJYWc.useState(()=>selectedYear || todayYear);
    const [internalHasFocus, setInternalHasFocus] = (0, $778a260509dda869$export$2e2bcd8739ae039)({
        name: 'YearCalendar',
        state: 'hasFocus',
        controlled: hasFocus,
        default: autoFocus != null ? autoFocus : false
    });
    const changeHasFocus = (0, $92UcI.default)((newHasFocus)=>{
        setInternalHasFocus(newHasFocus);
        if (onFocusedViewChange) onFocusedViewChange(newHasFocus);
    });
    const isYearDisabled = $gJYWc.useCallback((dateToValidate)=>{
        if (disablePast && utils.isBeforeYear(dateToValidate, now)) return true;
        if (disableFuture && utils.isAfterYear(dateToValidate, now)) return true;
        if (minDate && utils.isBeforeYear(dateToValidate, minDate)) return true;
        if (maxDate && utils.isAfterYear(dateToValidate, maxDate)) return true;
        if (!shouldDisableYear) return false;
        const yearToValidate = utils.startOfYear(dateToValidate);
        return shouldDisableYear(yearToValidate);
    }, [
        disableFuture,
        disablePast,
        maxDate,
        minDate,
        now,
        shouldDisableYear,
        utils
    ]);
    const handleYearSelection = (0, $92UcI.default)((event, year)=>{
        if (readOnly) return;
        const newDate = utils.setYear(value != null ? value : referenceDate, year);
        handleValueChange(newDate);
    });
    const focusYear = (0, $92UcI.default)((year)=>{
        if (!isYearDisabled(utils.setYear(value != null ? value : referenceDate, year))) {
            setFocusedYear(year);
            changeHasFocus(true);
            onYearFocus == null || onYearFocus(year);
        }
    });
    $gJYWc.useEffect(()=>{
        setFocusedYear((prevFocusedYear)=>selectedYear !== null && prevFocusedYear !== selectedYear ? selectedYear : prevFocusedYear);
    }, [
        selectedYear
    ]);
    const handleKeyDown = (0, $92UcI.default)((event, year)=>{
        switch(event.key){
            case 'ArrowUp':
                focusYear(year - yearsPerRow);
                event.preventDefault();
                break;
            case 'ArrowDown':
                focusYear(year + yearsPerRow);
                event.preventDefault();
                break;
            case 'ArrowLeft':
                focusYear(year + (theme.direction === 'ltr' ? -1 : 1));
                event.preventDefault();
                break;
            case 'ArrowRight':
                focusYear(year + (theme.direction === 'ltr' ? 1 : -1));
                event.preventDefault();
                break;
            default:
                break;
        }
    });
    const handleYearFocus = (0, $92UcI.default)((event, year)=>{
        focusYear(year);
    });
    const handleYearBlur = (0, $92UcI.default)((event, year)=>{
        if (focusedYear === year) changeHasFocus(false);
    });
    const scrollerRef = $gJYWc.useRef(null);
    const handleRef = (0, $4gWBK.default)(ref, scrollerRef);
    $gJYWc.useEffect(()=>{
        if (autoFocus || scrollerRef.current === null) return;
        const tabbableButton = scrollerRef.current.querySelector('[tabindex="0"]');
        if (!tabbableButton) return;
        // Taken from useScroll in x-data-grid, but vertically centered
        const offsetHeight = tabbableButton.offsetHeight;
        const offsetTop = tabbableButton.offsetTop;
        const clientHeight = scrollerRef.current.clientHeight;
        const scrollTop = scrollerRef.current.scrollTop;
        const elementBottom = offsetTop + offsetHeight;
        if (offsetHeight > clientHeight || offsetTop < scrollTop) // Button already visible
        return;
        scrollerRef.current.scrollTop = elementBottom - clientHeight / 2 - offsetHeight / 2;
    }, [
        autoFocus
    ]);
    return /*#__PURE__*/ (0, $9wx12.jsx)($59a758f5e7d34634$var$YearCalendarRoot, (0, $3VnFq.default)({
        ref: handleRef,
        className: (0, $2w6IV.default)(classes.root, className),
        ownerState: ownerState,
        role: "radiogroup",
        "aria-labelledby": gridLabelId
    }, other, {
        children: utils.getYearRange(minDate, maxDate).map((year)=>{
            const yearNumber = utils.getYear(year);
            const isSelected = yearNumber === selectedYear;
            const isDisabled = disabled || isYearDisabled(year);
            return /*#__PURE__*/ (0, $9wx12.jsx)((0, $488c7e807dbad5a5$export$261f3fbd5fd5814d), {
                selected: isSelected,
                value: yearNumber,
                onClick: handleYearSelection,
                onKeyDown: handleKeyDown,
                autoFocus: internalHasFocus && yearNumber === focusedYear,
                disabled: isDisabled,
                tabIndex: yearNumber === focusedYear ? 0 : -1,
                onFocus: handleYearFocus,
                onBlur: handleYearBlur,
                "aria-current": todayYear === yearNumber ? 'date' : undefined,
                yearsPerRow: yearsPerRow,
                children: utils.format(year, 'year')
            }, utils.format(year, 'year'));
        })
    }));
});




var $cTAWX = parcelRequire("cTAWX");

var $3VnFq = parcelRequire("3VnFq");

var $gJYWc = parcelRequire("gJYWc");


var $2w6IV = parcelRequire("2w6IV");


var $HGmne = parcelRequire("HGmne");


var $3e4LV = parcelRequire("3e4LV");

var $17CRd = parcelRequire("17CRd");




var $cTAWX = parcelRequire("cTAWX");

var $3VnFq = parcelRequire("3VnFq");

var $gJYWc = parcelRequire("gJYWc");

var $2w6IV = parcelRequire("2w6IV");


var $HGmne = parcelRequire("HGmne");

var $3e4LV = parcelRequire("3e4LV");


var $17CRd = parcelRequire("17CRd");


var $1kRHf = parcelRequire("1kRHf");
var $i8nzj = parcelRequire("i8nzj");
function $c6d9f4e6ab443d12$export$cef978c25740de90(slot) {
    return (0, $1kRHf.default)('MuiPickersArrowSwitcher', slot);
}
const $c6d9f4e6ab443d12$export$f8819209558cd362 = (0, $i8nzj.default)('MuiPickersArrowSwitcher', [
    'root',
    'spacer',
    'button'
]);



var $9wx12 = parcelRequire("9wx12");
const $27a06ee7c6118b43$var$_excluded = [
    "children",
    "className",
    "slots",
    "slotProps",
    "isNextDisabled",
    "isNextHidden",
    "onGoToNext",
    "nextLabel",
    "isPreviousDisabled",
    "isPreviousHidden",
    "onGoToPrevious",
    "previousLabel"
], $27a06ee7c6118b43$var$_excluded2 = [
    "ownerState"
], $27a06ee7c6118b43$var$_excluded3 = [
    "ownerState"
];
const $27a06ee7c6118b43$var$PickersArrowSwitcherRoot = (0, $HGmne.default)('div', {
    name: 'MuiPickersArrowSwitcher',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})({
    display: 'flex'
});
const $27a06ee7c6118b43$var$PickersArrowSwitcherSpacer = (0, $HGmne.default)('div', {
    name: 'MuiPickersArrowSwitcher',
    slot: 'Spacer',
    overridesResolver: (props, styles)=>styles.spacer
})(({ theme: theme })=>({
        width: theme.spacing(3)
    }));
const $27a06ee7c6118b43$var$PickersArrowSwitcherButton = (0, $HGmne.default)((0, $17CRd.default), {
    name: 'MuiPickersArrowSwitcher',
    slot: 'Button',
    overridesResolver: (props, styles)=>styles.button
})(({ ownerState: ownerState })=>(0, $3VnFq.default)({}, ownerState.hidden && {
        visibility: 'hidden'
    }));
const $27a06ee7c6118b43$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ],
        spacer: [
            'spacer'
        ],
        button: [
            'button'
        ]
    };
    return (0, $3e4LV.default)(slots, (0, $c6d9f4e6ab443d12$export$cef978c25740de90), classes);
};
const $27a06ee7c6118b43$export$597b7cbdb7b2a24c = /*#__PURE__*/ $gJYWc.forwardRef(function PickersArrowSwitcher(inProps, ref) {
    var _slots$previousIconBu, _slots$nextIconButton, _slots$leftArrowIcon, _slots$rightArrowIcon;
    const theme = (0, $ae968105fc5c093e$export$2e2bcd8739ae039)();
    const isRTL = theme.direction === 'rtl';
    const props = (0, $6959428021af84ce$export$2e2bcd8739ae039)({
        props: inProps,
        name: 'MuiPickersArrowSwitcher'
    });
    const { children: children, className: className, slots: slots, slotProps: slotProps, isNextDisabled: isNextDisabled, isNextHidden: isNextHidden, onGoToNext: onGoToNext, nextLabel: nextLabel, isPreviousDisabled: isPreviousDisabled, isPreviousHidden: isPreviousHidden, onGoToPrevious: onGoToPrevious, previousLabel: previousLabel } = props, other = (0, $cTAWX.default)(props, $27a06ee7c6118b43$var$_excluded);
    const ownerState = props;
    const classes = $27a06ee7c6118b43$var$useUtilityClasses(ownerState);
    const nextProps = {
        isDisabled: isNextDisabled,
        isHidden: isNextHidden,
        goTo: onGoToNext,
        label: nextLabel
    };
    const previousProps = {
        isDisabled: isPreviousDisabled,
        isHidden: isPreviousHidden,
        goTo: onGoToPrevious,
        label: previousLabel
    };
    const PreviousIconButton = (_slots$previousIconBu = slots == null ? void 0 : slots.previousIconButton) != null ? _slots$previousIconBu : $27a06ee7c6118b43$var$PickersArrowSwitcherButton;
    const previousIconButtonProps = (0, $2082854bb194ebf1$export$2e2bcd8739ae039)({
        elementType: PreviousIconButton,
        externalSlotProps: slotProps == null ? void 0 : slotProps.previousIconButton,
        additionalProps: {
            size: 'medium',
            title: previousProps.label,
            'aria-label': previousProps.label,
            disabled: previousProps.isDisabled,
            edge: 'end',
            onClick: previousProps.goTo
        },
        ownerState: (0, $3VnFq.default)({}, ownerState, {
            hidden: previousProps.isHidden
        }),
        className: classes.button
    });
    const NextIconButton = (_slots$nextIconButton = slots == null ? void 0 : slots.nextIconButton) != null ? _slots$nextIconButton : $27a06ee7c6118b43$var$PickersArrowSwitcherButton;
    const nextIconButtonProps = (0, $2082854bb194ebf1$export$2e2bcd8739ae039)({
        elementType: NextIconButton,
        externalSlotProps: slotProps == null ? void 0 : slotProps.nextIconButton,
        additionalProps: {
            size: 'medium',
            title: nextProps.label,
            'aria-label': nextProps.label,
            disabled: nextProps.isDisabled,
            edge: 'start',
            onClick: nextProps.goTo
        },
        ownerState: (0, $3VnFq.default)({}, ownerState, {
            hidden: nextProps.isHidden
        }),
        className: classes.button
    });
    const LeftArrowIcon = (_slots$leftArrowIcon = slots == null ? void 0 : slots.leftArrowIcon) != null ? _slots$leftArrowIcon : (0, $fc9c2dee5d88174c$export$8afed21ef5c2afa5);
    // The spread is here to avoid this bug mui/material-ui#34056
    const _useSlotProps = (0, $2082854bb194ebf1$export$2e2bcd8739ae039)({
        elementType: LeftArrowIcon,
        externalSlotProps: slotProps == null ? void 0 : slotProps.leftArrowIcon,
        additionalProps: {
            fontSize: 'inherit'
        },
        ownerState: undefined
    }), leftArrowIconProps = (0, $cTAWX.default)(_useSlotProps, $27a06ee7c6118b43$var$_excluded2);
    const RightArrowIcon = (_slots$rightArrowIcon = slots == null ? void 0 : slots.rightArrowIcon) != null ? _slots$rightArrowIcon : (0, $fc9c2dee5d88174c$export$9ca09caa9c849d9c);
    // The spread is here to avoid this bug mui/material-ui#34056
    const _useSlotProps2 = (0, $2082854bb194ebf1$export$2e2bcd8739ae039)({
        elementType: RightArrowIcon,
        externalSlotProps: slotProps == null ? void 0 : slotProps.rightArrowIcon,
        additionalProps: {
            fontSize: 'inherit'
        },
        ownerState: undefined
    }), rightArrowIconProps = (0, $cTAWX.default)(_useSlotProps2, $27a06ee7c6118b43$var$_excluded3);
    return /*#__PURE__*/ (0, $9wx12.jsxs)($27a06ee7c6118b43$var$PickersArrowSwitcherRoot, (0, $3VnFq.default)({
        ref: ref,
        className: (0, $2w6IV.default)(classes.root, className),
        ownerState: ownerState
    }, other, {
        children: [
            /*#__PURE__*/ (0, $9wx12.jsx)(PreviousIconButton, (0, $3VnFq.default)({}, previousIconButtonProps, {
                children: isRTL ? /*#__PURE__*/ (0, $9wx12.jsx)(RightArrowIcon, (0, $3VnFq.default)({}, rightArrowIconProps)) : /*#__PURE__*/ (0, $9wx12.jsx)(LeftArrowIcon, (0, $3VnFq.default)({}, leftArrowIconProps))
            })),
            children ? /*#__PURE__*/ (0, $9wx12.jsx)((0, $b4083ea3a052dee9$export$2e2bcd8739ae039), {
                variant: "subtitle1",
                component: "span",
                children: children
            }) : /*#__PURE__*/ (0, $9wx12.jsx)($27a06ee7c6118b43$var$PickersArrowSwitcherSpacer, {
                className: classes.spacer,
                ownerState: ownerState
            }),
            /*#__PURE__*/ (0, $9wx12.jsx)(NextIconButton, (0, $3VnFq.default)({}, nextIconButtonProps, {
                children: isRTL ? /*#__PURE__*/ (0, $9wx12.jsx)(LeftArrowIcon, (0, $3VnFq.default)({}, leftArrowIconProps)) : /*#__PURE__*/ (0, $9wx12.jsx)(RightArrowIcon, (0, $3VnFq.default)({}, rightArrowIconProps))
            }))
        ]
    }));
});



var $gJYWc = parcelRequire("gJYWc");


function $9474454c4c9ffb68$export$923e8cc135843169(month, { disableFuture: disableFuture, maxDate: maxDate, timezone: timezone }) {
    const utils = (0, $98220f21a8625472$export$1163b47e39508a46)();
    return $gJYWc.useMemo(()=>{
        const now = utils.dateWithTimezone(undefined, timezone);
        const lastEnabledMonth = utils.startOfMonth(disableFuture && utils.isBefore(now, maxDate) ? now : maxDate);
        return !utils.isAfter(lastEnabledMonth, month);
    }, [
        disableFuture,
        maxDate,
        month,
        utils,
        timezone
    ]);
}
function $9474454c4c9ffb68$export$3b46d38ff4932cf7(month, { disablePast: disablePast, minDate: minDate, timezone: timezone }) {
    const utils = (0, $98220f21a8625472$export$1163b47e39508a46)();
    return $gJYWc.useMemo(()=>{
        const now = utils.dateWithTimezone(undefined, timezone);
        const firstEnabledMonth = utils.startOfMonth(disablePast && utils.isAfter(now, minDate) ? now : minDate);
        return !utils.isBefore(firstEnabledMonth, month);
    }, [
        disablePast,
        minDate,
        month,
        utils,
        timezone
    ]);
}
function $9474454c4c9ffb68$export$6aaabc31cb076d17(date, ampm, onChange, selectionState) {
    const utils = (0, $98220f21a8625472$export$1163b47e39508a46)();
    const meridiemMode = (0, $ab68d4157b5096ce$export$c3352ead7b032236)(date, utils);
    const handleMeridiemChange = $gJYWc.useCallback((mode)=>{
        const timeWithMeridiem = date == null ? null : (0, $ab68d4157b5096ce$export$c368d4ff66779998)(date, mode, Boolean(ampm), utils);
        onChange(timeWithMeridiem, selectionState != null ? selectionState : 'partial');
    }, [
        ampm,
        date,
        onChange,
        selectionState,
        utils
    ]);
    return {
        meridiemMode: meridiemMode,
        handleMeridiemChange: handleMeridiemChange
    };
}



var $1kRHf = parcelRequire("1kRHf");
var $i8nzj = parcelRequire("i8nzj");
const $87e0f5e988668721$export$457ac4d3a1ad92b4 = (slot)=>(0, $1kRHf.default)('MuiPickersCalendarHeader', slot);
const $87e0f5e988668721$export$63db7afb9247cb91 = (0, $i8nzj.default)('MuiPickersCalendarHeader', [
    'root',
    'labelContainer',
    'label',
    'switchViewButton',
    'switchViewIcon'
]);



var $9wx12 = parcelRequire("9wx12");
const $0fa39d4ab8f38880$var$_excluded = [
    "slots",
    "slotProps",
    "components",
    "componentsProps",
    "currentMonth",
    "disabled",
    "disableFuture",
    "disablePast",
    "maxDate",
    "minDate",
    "onMonthChange",
    "onViewChange",
    "view",
    "reduceAnimations",
    "views",
    "labelId",
    "className",
    "timezone"
], $0fa39d4ab8f38880$var$_excluded2 = [
    "ownerState"
];
const $0fa39d4ab8f38880$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ],
        labelContainer: [
            'labelContainer'
        ],
        label: [
            'label'
        ],
        switchViewButton: [
            'switchViewButton'
        ],
        switchViewIcon: [
            'switchViewIcon'
        ]
    };
    return (0, $3e4LV.default)(slots, (0, $87e0f5e988668721$export$457ac4d3a1ad92b4), classes);
};
const $0fa39d4ab8f38880$var$PickersCalendarHeaderRoot = (0, $HGmne.default)('div', {
    name: 'MuiPickersCalendarHeader',
    slot: 'Root',
    overridesResolver: (_, styles)=>styles.root
})({
    display: 'flex',
    alignItems: 'center',
    marginTop: 16,
    marginBottom: 8,
    paddingLeft: 24,
    paddingRight: 12,
    // prevent jumping in safari
    maxHeight: 30,
    minHeight: 30
});
const $0fa39d4ab8f38880$var$PickersCalendarHeaderLabelContainer = (0, $HGmne.default)('div', {
    name: 'MuiPickersCalendarHeader',
    slot: 'LabelContainer',
    overridesResolver: (_, styles)=>styles.labelContainer
})(({ theme: theme })=>(0, $3VnFq.default)({
        display: 'flex',
        overflow: 'hidden',
        alignItems: 'center',
        cursor: 'pointer',
        marginRight: 'auto'
    }, theme.typography.body1, {
        fontWeight: theme.typography.fontWeightMedium
    }));
const $0fa39d4ab8f38880$var$PickersCalendarHeaderLabel = (0, $HGmne.default)('div', {
    name: 'MuiPickersCalendarHeader',
    slot: 'Label',
    overridesResolver: (_, styles)=>styles.label
})({
    marginRight: 6
});
const $0fa39d4ab8f38880$var$PickersCalendarHeaderSwitchViewButton = (0, $HGmne.default)((0, $17CRd.default), {
    name: 'MuiPickersCalendarHeader',
    slot: 'SwitchViewButton',
    overridesResolver: (_, styles)=>styles.switchViewButton
})(({ ownerState: ownerState })=>(0, $3VnFq.default)({
        marginRight: 'auto'
    }, ownerState.view === 'year' && {
        [`.${(0, $87e0f5e988668721$export$63db7afb9247cb91).switchViewIcon}`]: {
            transform: 'rotate(180deg)'
        }
    }));
const $0fa39d4ab8f38880$var$PickersCalendarHeaderSwitchViewIcon = (0, $HGmne.default)((0, $fc9c2dee5d88174c$export$ed0fe318cc298673), {
    name: 'MuiPickersCalendarHeader',
    slot: 'SwitchViewIcon',
    overridesResolver: (_, styles)=>styles.switchViewIcon
})(({ theme: theme })=>({
        willChange: 'transform',
        transition: theme.transitions.create('transform'),
        transform: 'rotate(0deg)'
    }));
/**
 * Demos:
 *
 * - [DateCalendar](https://mui.com/x/react-date-pickers/date-calendar/)
 * - [DateRangeCalendar](https://mui.com/x/react-date-pickers/date-range-calendar/)
 * - [Custom slots and subcomponents](https://mui.com/x/react-date-pickers/custom-components/)
 *
 * API:
 *
 * - [PickersCalendarHeader API](https://mui.com/x/api/date-pickers/pickers-calendar-header/)
 */ const $0fa39d4ab8f38880$export$6801ffebb353f473 = /*#__PURE__*/ $gJYWc.forwardRef(function PickersCalendarHeader(inProps, ref) {
    var _ref, _slots$switchViewButt, _ref2, _slots$switchViewIcon;
    const localeText = (0, $98220f21a8625472$export$24fdeaa0f591a73e)();
    const utils = (0, $98220f21a8625472$export$1163b47e39508a46)();
    const props = (0, $6959428021af84ce$export$2e2bcd8739ae039)({
        props: inProps,
        name: 'MuiPickersCalendarHeader'
    });
    const { slots: slots, slotProps: slotProps, components: components, currentMonth: month, disabled: disabled, disableFuture: disableFuture, disablePast: disablePast, maxDate: maxDate, minDate: minDate, onMonthChange: onMonthChange, onViewChange: onViewChange, view: view, reduceAnimations: reduceAnimations, views: views, labelId: labelId, className: className, timezone: timezone } = props, other = (0, $cTAWX.default)(props, $0fa39d4ab8f38880$var$_excluded);
    const ownerState = props;
    const classes = $0fa39d4ab8f38880$var$useUtilityClasses(props);
    const SwitchViewButton = (_ref = (_slots$switchViewButt = slots == null ? void 0 : slots.switchViewButton) != null ? _slots$switchViewButt : components == null ? void 0 : components.SwitchViewButton) != null ? _ref : $0fa39d4ab8f38880$var$PickersCalendarHeaderSwitchViewButton;
    const switchViewButtonProps = (0, $2082854bb194ebf1$export$2e2bcd8739ae039)({
        elementType: SwitchViewButton,
        externalSlotProps: slotProps == null ? void 0 : slotProps.switchViewButton,
        additionalProps: {
            size: 'small',
            'aria-label': localeText.calendarViewSwitchingButtonAriaLabel(view)
        },
        ownerState: ownerState,
        className: classes.switchViewButton
    });
    const SwitchViewIcon = (_ref2 = (_slots$switchViewIcon = slots == null ? void 0 : slots.switchViewIcon) != null ? _slots$switchViewIcon : components == null ? void 0 : components.SwitchViewIcon) != null ? _ref2 : $0fa39d4ab8f38880$var$PickersCalendarHeaderSwitchViewIcon;
    // The spread is here to avoid this bug mui/material-ui#34056
    const _useSlotProps = (0, $2082854bb194ebf1$export$2e2bcd8739ae039)({
        elementType: SwitchViewIcon,
        externalSlotProps: slotProps == null ? void 0 : slotProps.switchViewIcon,
        ownerState: undefined,
        className: classes.switchViewIcon
    }), switchViewIconProps = (0, $cTAWX.default)(_useSlotProps, $0fa39d4ab8f38880$var$_excluded2);
    const selectNextMonth = ()=>onMonthChange(utils.addMonths(month, 1), 'left');
    const selectPreviousMonth = ()=>onMonthChange(utils.addMonths(month, -1), 'right');
    const isNextMonthDisabled = (0, $9474454c4c9ffb68$export$923e8cc135843169)(month, {
        disableFuture: disableFuture,
        maxDate: maxDate,
        timezone: timezone
    });
    const isPreviousMonthDisabled = (0, $9474454c4c9ffb68$export$3b46d38ff4932cf7)(month, {
        disablePast: disablePast,
        minDate: minDate,
        timezone: timezone
    });
    const handleToggleView = ()=>{
        if (views.length === 1 || !onViewChange || disabled) return;
        if (views.length === 2) onViewChange(views.find((el)=>el !== view) || views[0]);
        else {
            // switching only between first 2
            const nextIndexToOpen = views.indexOf(view) !== 0 ? 0 : 1;
            onViewChange(views[nextIndexToOpen]);
        }
    };
    // No need to display more information
    if (views.length === 1 && views[0] === 'year') return null;
    return /*#__PURE__*/ (0, $9wx12.jsxs)($0fa39d4ab8f38880$var$PickersCalendarHeaderRoot, (0, $3VnFq.default)({}, other, {
        ownerState: ownerState,
        className: (0, $2w6IV.default)(className, classes.root),
        ref: ref,
        children: [
            /*#__PURE__*/ (0, $9wx12.jsxs)($0fa39d4ab8f38880$var$PickersCalendarHeaderLabelContainer, {
                role: "presentation",
                onClick: handleToggleView,
                ownerState: ownerState,
                "aria-live": "polite",
                className: classes.labelContainer,
                children: [
                    /*#__PURE__*/ (0, $9wx12.jsx)((0, $c575666c4c3d2d8a$export$5262185daf493fee), {
                        reduceAnimations: reduceAnimations,
                        transKey: utils.format(month, 'monthAndYear'),
                        children: /*#__PURE__*/ (0, $9wx12.jsx)($0fa39d4ab8f38880$var$PickersCalendarHeaderLabel, {
                            id: labelId,
                            ownerState: ownerState,
                            className: classes.label,
                            children: utils.format(month, 'monthAndYear')
                        })
                    }),
                    views.length > 1 && !disabled && /*#__PURE__*/ (0, $9wx12.jsx)(SwitchViewButton, (0, $3VnFq.default)({}, switchViewButtonProps, {
                        children: /*#__PURE__*/ (0, $9wx12.jsx)(SwitchViewIcon, (0, $3VnFq.default)({}, switchViewIconProps))
                    }))
                ]
            }),
            /*#__PURE__*/ (0, $9wx12.jsx)((0, $5d4a7e2c608c4487$export$2e2bcd8739ae039), {
                in: view === 'day',
                children: /*#__PURE__*/ (0, $9wx12.jsx)((0, $27a06ee7c6118b43$export$597b7cbdb7b2a24c), {
                    slots: slots,
                    slotProps: slotProps,
                    onGoToPrevious: selectPreviousMonth,
                    isPreviousDisabled: isPreviousMonthDisabled,
                    previousLabel: localeText.previousMonth,
                    onGoToNext: selectNextMonth,
                    isNextDisabled: isNextMonthDisabled,
                    nextLabel: localeText.nextMonth
                })
            })
        ]
    }));
});




var $HGmne = parcelRequire("HGmne");

const $b034d353ecc5f692$export$512b066b8abdfde4 = (0, $HGmne.default)('div')({
    overflow: 'hidden',
    width: (0, $8450780b4b9a6f99$export$ee46b8a74d6c94d3),
    maxHeight: (0, $8450780b4b9a6f99$export$f2fef360e2df0cb7),
    display: 'flex',
    flexDirection: 'column',
    margin: '0 auto'
});




var $1kRHf = parcelRequire("1kRHf");
var $i8nzj = parcelRequire("i8nzj");
const $549cff6178ecfef6$export$da8c2318897a6672 = (slot)=>(0, $1kRHf.default)('MuiDateCalendar', slot);
const $549cff6178ecfef6$export$d0237e2bb9598e8d = (0, $i8nzj.default)('MuiDateCalendar', [
    'root',
    'viewTransitionContainer'
]);






var $9wx12 = parcelRequire("9wx12");
const $8b21b397d33cf27c$var$_excluded = [
    "autoFocus",
    "onViewChange",
    "value",
    "defaultValue",
    "referenceDate",
    "disableFuture",
    "disablePast",
    "defaultCalendarMonth",
    "onChange",
    "onYearChange",
    "onMonthChange",
    "reduceAnimations",
    "shouldDisableDate",
    "shouldDisableMonth",
    "shouldDisableYear",
    "view",
    "views",
    "openTo",
    "className",
    "disabled",
    "readOnly",
    "minDate",
    "maxDate",
    "disableHighlightToday",
    "focusedView",
    "onFocusedViewChange",
    "showDaysOutsideCurrentMonth",
    "fixedWeekNumber",
    "dayOfWeekFormatter",
    "components",
    "componentsProps",
    "slots",
    "slotProps",
    "loading",
    "renderLoading",
    "displayWeekNumber",
    "yearsPerRow",
    "monthsPerRow",
    "timezone"
];
const $8b21b397d33cf27c$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ],
        viewTransitionContainer: [
            'viewTransitionContainer'
        ]
    };
    return (0, $3e4LV.default)(slots, (0, $549cff6178ecfef6$export$da8c2318897a6672), classes);
};
function $8b21b397d33cf27c$var$useDateCalendarDefaultizedProps(props, name) {
    var _themeProps$loading, _themeProps$disablePa, _themeProps$disableFu, _themeProps$openTo, _themeProps$views, _themeProps$reduceAni, _themeProps$renderLoa;
    const utils = (0, $98220f21a8625472$export$1163b47e39508a46)();
    const defaultDates = (0, $98220f21a8625472$export$7c38da3a2e90fa83)();
    const defaultReduceAnimations = (0, $63fcfcb91f1a0bc4$export$ce40fb97be7f02d9)();
    const themeProps = (0, $6959428021af84ce$export$2e2bcd8739ae039)({
        props: props,
        name: name
    });
    return (0, $3VnFq.default)({}, themeProps, {
        loading: (_themeProps$loading = themeProps.loading) != null ? _themeProps$loading : false,
        disablePast: (_themeProps$disablePa = themeProps.disablePast) != null ? _themeProps$disablePa : false,
        disableFuture: (_themeProps$disableFu = themeProps.disableFuture) != null ? _themeProps$disableFu : false,
        openTo: (_themeProps$openTo = themeProps.openTo) != null ? _themeProps$openTo : 'day',
        views: (_themeProps$views = themeProps.views) != null ? _themeProps$views : [
            'year',
            'day'
        ],
        reduceAnimations: (_themeProps$reduceAni = themeProps.reduceAnimations) != null ? _themeProps$reduceAni : defaultReduceAnimations,
        renderLoading: (_themeProps$renderLoa = themeProps.renderLoading) != null ? _themeProps$renderLoa : ()=>/*#__PURE__*/ (0, $9wx12.jsx)("span", {
                children: "..."
            }),
        minDate: (0, $00e6d022b450825d$export$eb73579ccade48fd)(utils, themeProps.minDate, defaultDates.minDate),
        maxDate: (0, $00e6d022b450825d$export$eb73579ccade48fd)(utils, themeProps.maxDate, defaultDates.maxDate)
    });
}
const $8b21b397d33cf27c$var$DateCalendarRoot = (0, $HGmne.default)((0, $b034d353ecc5f692$export$512b066b8abdfde4), {
    name: 'MuiDateCalendar',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})({
    display: 'flex',
    flexDirection: 'column',
    height: (0, $8450780b4b9a6f99$export$f2fef360e2df0cb7)
});
const $8b21b397d33cf27c$var$DateCalendarViewTransitionContainer = (0, $HGmne.default)((0, $c575666c4c3d2d8a$export$5262185daf493fee), {
    name: 'MuiDateCalendar',
    slot: 'ViewTransitionContainer',
    overridesResolver: (props, styles)=>styles.viewTransitionContainer
})({});
const $8b21b397d33cf27c$export$68078fe5d2bf8909 = /*#__PURE__*/ $gJYWc.forwardRef(function DateCalendar(inProps, ref) {
    var _ref, _slots$calendarHeader, _slotProps$calendarHe;
    const utils = (0, $98220f21a8625472$export$1163b47e39508a46)();
    const id = (0, $8fee44a510de4e75$export$2e2bcd8739ae039)();
    const props = $8b21b397d33cf27c$var$useDateCalendarDefaultizedProps(inProps, 'MuiDateCalendar');
    const { autoFocus: autoFocus, onViewChange: onViewChange, value: valueProp, defaultValue: defaultValue, referenceDate: referenceDateProp, disableFuture: disableFuture, disablePast: disablePast, defaultCalendarMonth: defaultCalendarMonth, onChange: onChange, onYearChange: onYearChange, onMonthChange: onMonthChange, reduceAnimations: reduceAnimations, shouldDisableDate: shouldDisableDate, shouldDisableMonth: shouldDisableMonth, shouldDisableYear: shouldDisableYear, view: inView, views: views, openTo: openTo, className: className, disabled: disabled, readOnly: readOnly, minDate: minDate, maxDate: maxDate, disableHighlightToday: disableHighlightToday, focusedView: inFocusedView, onFocusedViewChange: onFocusedViewChange, showDaysOutsideCurrentMonth: showDaysOutsideCurrentMonth, fixedWeekNumber: fixedWeekNumber, dayOfWeekFormatter: dayOfWeekFormatter, components: components, componentsProps: componentsProps, slots: slots, slotProps: slotProps, loading: loading, renderLoading: renderLoading, displayWeekNumber: displayWeekNumber, yearsPerRow: yearsPerRow, monthsPerRow: monthsPerRow, timezone: timezoneProp } = props, other = (0, $cTAWX.default)(props, $8b21b397d33cf27c$var$_excluded);
    const { value: value, handleValueChange: handleValueChange, timezone: timezone } = (0, $666e75003bf5e8d6$export$174d749f3b4c0f49)({
        name: 'DateCalendar',
        timezone: timezoneProp,
        value: valueProp,
        defaultValue: defaultValue,
        onChange: onChange,
        valueManager: (0, $15cde65cbd91c944$export$2764b246aa3b75ba)
    });
    const { view: view, setView: setView, focusedView: focusedView, setFocusedView: setFocusedView, goToNextView: goToNextView, setValueAndGoToNextView: setValueAndGoToNextView } = (0, $d3a5b60d8c1fb6e1$export$9b46cba8f8ccd954)({
        view: inView,
        views: views,
        openTo: openTo,
        onChange: handleValueChange,
        onViewChange: onViewChange,
        autoFocus: autoFocus,
        focusedView: inFocusedView,
        onFocusedViewChange: onFocusedViewChange
    });
    const { referenceDate: referenceDate, calendarState: calendarState, changeFocusedDay: changeFocusedDay, changeMonth: changeMonth, handleChangeMonth: handleChangeMonth, isDateDisabled: isDateDisabled, onMonthSwitchingAnimationEnd: onMonthSwitchingAnimationEnd } = (0, $45e7422db76ba2e3$export$6d095e787d2b5e1f)({
        value: value,
        defaultCalendarMonth: defaultCalendarMonth,
        referenceDate: referenceDateProp,
        reduceAnimations: reduceAnimations,
        onMonthChange: onMonthChange,
        minDate: minDate,
        maxDate: maxDate,
        shouldDisableDate: shouldDisableDate,
        disablePast: disablePast,
        disableFuture: disableFuture,
        timezone: timezone
    });
    // When disabled, limit the view to the selected date
    const minDateWithDisabled = disabled && value || minDate;
    const maxDateWithDisabled = disabled && value || maxDate;
    const gridLabelId = `${id}-grid-label`;
    const hasFocus = focusedView !== null;
    const CalendarHeader = (_ref = (_slots$calendarHeader = slots == null ? void 0 : slots.calendarHeader) != null ? _slots$calendarHeader : components == null ? void 0 : components.CalendarHeader) != null ? _ref : (0, $0fa39d4ab8f38880$export$6801ffebb353f473);
    const calendarHeaderProps = (0, $2082854bb194ebf1$export$2e2bcd8739ae039)({
        elementType: CalendarHeader,
        externalSlotProps: (_slotProps$calendarHe = slotProps == null ? void 0 : slotProps.calendarHeader) != null ? _slotProps$calendarHe : componentsProps == null ? void 0 : componentsProps.calendarHeader,
        additionalProps: {
            views: views,
            view: view,
            currentMonth: calendarState.currentMonth,
            onViewChange: setView,
            onMonthChange: (newMonth, direction)=>handleChangeMonth({
                    newMonth: newMonth,
                    direction: direction
                }),
            minDate: minDateWithDisabled,
            maxDate: maxDateWithDisabled,
            disabled: disabled,
            disablePast: disablePast,
            disableFuture: disableFuture,
            reduceAnimations: reduceAnimations,
            timezone: timezone,
            labelId: gridLabelId,
            slots: slots,
            slotProps: slotProps
        },
        ownerState: props
    });
    const handleDateMonthChange = (0, $92UcI.default)((newDate)=>{
        const startOfMonth = utils.startOfMonth(newDate);
        const endOfMonth = utils.endOfMonth(newDate);
        const closestEnabledDate = isDateDisabled(newDate) ? (0, $00e6d022b450825d$export$ca1f317ae8db2ee8)({
            utils: utils,
            date: newDate,
            minDate: utils.isBefore(minDate, startOfMonth) ? startOfMonth : minDate,
            maxDate: utils.isAfter(maxDate, endOfMonth) ? endOfMonth : maxDate,
            disablePast: disablePast,
            disableFuture: disableFuture,
            isDateDisabled: isDateDisabled,
            timezone: timezone
        }) : newDate;
        if (closestEnabledDate) {
            setValueAndGoToNextView(closestEnabledDate, 'finish');
            onMonthChange == null || onMonthChange(startOfMonth);
        } else {
            goToNextView();
            changeMonth(startOfMonth);
        }
        changeFocusedDay(closestEnabledDate, true);
    });
    const handleDateYearChange = (0, $92UcI.default)((newDate)=>{
        const startOfYear = utils.startOfYear(newDate);
        const endOfYear = utils.endOfYear(newDate);
        const closestEnabledDate = isDateDisabled(newDate) ? (0, $00e6d022b450825d$export$ca1f317ae8db2ee8)({
            utils: utils,
            date: newDate,
            minDate: utils.isBefore(minDate, startOfYear) ? startOfYear : minDate,
            maxDate: utils.isAfter(maxDate, endOfYear) ? endOfYear : maxDate,
            disablePast: disablePast,
            disableFuture: disableFuture,
            isDateDisabled: isDateDisabled,
            timezone: timezone
        }) : newDate;
        if (closestEnabledDate) {
            setValueAndGoToNextView(closestEnabledDate, 'finish');
            onYearChange == null || onYearChange(closestEnabledDate);
        } else {
            goToNextView();
            changeMonth(startOfYear);
        }
        changeFocusedDay(closestEnabledDate, true);
    });
    const handleSelectedDayChange = (0, $92UcI.default)((day)=>{
        if (day) // If there is a date already selected, then we want to keep its time
        return handleValueChange((0, $00e6d022b450825d$export$a98b123b8f29e004)(utils, day, value != null ? value : referenceDate), 'finish', view);
        return handleValueChange(day, 'finish', view);
    });
    $gJYWc.useEffect(()=>{
        if (value != null && utils.isValid(value)) changeMonth(value);
    }, [
        value
    ]); // eslint-disable-line
    const ownerState = props;
    const classes = $8b21b397d33cf27c$var$useUtilityClasses(ownerState);
    const baseDateValidationProps = {
        disablePast: disablePast,
        disableFuture: disableFuture,
        maxDate: maxDate,
        minDate: minDate
    };
    const commonViewProps = {
        disableHighlightToday: disableHighlightToday,
        readOnly: readOnly,
        disabled: disabled,
        timezone: timezone,
        gridLabelId: gridLabelId
    };
    const prevOpenViewRef = $gJYWc.useRef(view);
    $gJYWc.useEffect(()=>{
        // If the view change and the focus was on the previous view
        // Then we update the focus.
        if (prevOpenViewRef.current === view) return;
        if (focusedView === prevOpenViewRef.current) setFocusedView(view, true);
        prevOpenViewRef.current = view;
    }, [
        focusedView,
        setFocusedView,
        view
    ]);
    const selectedDays = $gJYWc.useMemo(()=>[
            value
        ], [
        value
    ]);
    return /*#__PURE__*/ (0, $9wx12.jsxs)($8b21b397d33cf27c$var$DateCalendarRoot, (0, $3VnFq.default)({
        ref: ref,
        className: (0, $2w6IV.default)(classes.root, className),
        ownerState: ownerState
    }, other, {
        children: [
            /*#__PURE__*/ (0, $9wx12.jsx)(CalendarHeader, (0, $3VnFq.default)({}, calendarHeaderProps)),
            /*#__PURE__*/ (0, $9wx12.jsx)($8b21b397d33cf27c$var$DateCalendarViewTransitionContainer, {
                reduceAnimations: reduceAnimations,
                className: classes.viewTransitionContainer,
                transKey: view,
                ownerState: ownerState,
                children: /*#__PURE__*/ (0, $9wx12.jsxs)("div", {
                    children: [
                        view === 'year' && /*#__PURE__*/ (0, $9wx12.jsx)((0, $59a758f5e7d34634$export$657f9200591b2b71), (0, $3VnFq.default)({}, baseDateValidationProps, commonViewProps, {
                            value: value,
                            onChange: handleDateYearChange,
                            shouldDisableYear: shouldDisableYear,
                            hasFocus: hasFocus,
                            onFocusedViewChange: (isViewFocused)=>setFocusedView('year', isViewFocused),
                            yearsPerRow: yearsPerRow,
                            referenceDate: referenceDate
                        })),
                        view === 'month' && /*#__PURE__*/ (0, $9wx12.jsx)((0, $763b3bb5560e7609$export$d7a7c85c0f5afc4a), (0, $3VnFq.default)({}, baseDateValidationProps, commonViewProps, {
                            hasFocus: hasFocus,
                            className: className,
                            value: value,
                            onChange: handleDateMonthChange,
                            shouldDisableMonth: shouldDisableMonth,
                            onFocusedViewChange: (isViewFocused)=>setFocusedView('month', isViewFocused),
                            monthsPerRow: monthsPerRow,
                            referenceDate: referenceDate
                        })),
                        view === 'day' && /*#__PURE__*/ (0, $9wx12.jsx)((0, $72c0fa39224d4a3d$export$8fb56b32a5df6314), (0, $3VnFq.default)({}, calendarState, baseDateValidationProps, commonViewProps, {
                            onMonthSwitchingAnimationEnd: onMonthSwitchingAnimationEnd,
                            onFocusedDayChange: changeFocusedDay,
                            reduceAnimations: reduceAnimations,
                            selectedDays: selectedDays,
                            onSelectedDaysChange: handleSelectedDayChange,
                            shouldDisableDate: shouldDisableDate,
                            shouldDisableMonth: shouldDisableMonth,
                            shouldDisableYear: shouldDisableYear,
                            hasFocus: hasFocus,
                            onFocusedViewChange: (isViewFocused)=>setFocusedView('day', isViewFocused),
                            showDaysOutsideCurrentMonth: showDaysOutsideCurrentMonth,
                            fixedWeekNumber: fixedWeekNumber,
                            dayOfWeekFormatter: dayOfWeekFormatter,
                            displayWeekNumber: displayWeekNumber,
                            components: components,
                            componentsProps: componentsProps,
                            slots: slots,
                            slotProps: slotProps,
                            loading: loading,
                            renderLoading: renderLoading
                        }))
                    ]
                })
            })
        ]
    }));
});




var $9wx12 = parcelRequire("9wx12");
const $b04e633fdda956fa$export$69888ffe06193e5e = ({ view: view, onViewChange: onViewChange, views: views, focusedView: focusedView, onFocusedViewChange: onFocusedViewChange, value: value, defaultValue: defaultValue, referenceDate: referenceDate, onChange: onChange, className: className, classes: classes, disableFuture: disableFuture, disablePast: disablePast, minDate: minDate, maxDate: maxDate, shouldDisableDate: shouldDisableDate, shouldDisableMonth: shouldDisableMonth, shouldDisableYear: shouldDisableYear, reduceAnimations: reduceAnimations, onMonthChange: onMonthChange, monthsPerRow: monthsPerRow, onYearChange: onYearChange, yearsPerRow: yearsPerRow, defaultCalendarMonth: defaultCalendarMonth, components: components, componentsProps: componentsProps, slots: slots, slotProps: slotProps, loading: loading, renderLoading: renderLoading, disableHighlightToday: disableHighlightToday, readOnly: readOnly, disabled: disabled, showDaysOutsideCurrentMonth: showDaysOutsideCurrentMonth, dayOfWeekFormatter: dayOfWeekFormatter, sx: sx, autoFocus: autoFocus, fixedWeekNumber: fixedWeekNumber, displayWeekNumber: displayWeekNumber, timezone: timezone })=>/*#__PURE__*/ (0, $9wx12.jsx)((0, $8b21b397d33cf27c$export$68078fe5d2bf8909), {
        view: view,
        onViewChange: onViewChange,
        views: views.filter((0, $00e6d022b450825d$export$b32dfef9f07dea64)),
        focusedView: focusedView && (0, $00e6d022b450825d$export$b32dfef9f07dea64)(focusedView) ? focusedView : null,
        onFocusedViewChange: onFocusedViewChange,
        value: value,
        defaultValue: defaultValue,
        referenceDate: referenceDate,
        onChange: onChange,
        className: className,
        classes: classes,
        disableFuture: disableFuture,
        disablePast: disablePast,
        minDate: minDate,
        maxDate: maxDate,
        shouldDisableDate: shouldDisableDate,
        shouldDisableMonth: shouldDisableMonth,
        shouldDisableYear: shouldDisableYear,
        reduceAnimations: reduceAnimations,
        onMonthChange: onMonthChange,
        monthsPerRow: monthsPerRow,
        onYearChange: onYearChange,
        yearsPerRow: yearsPerRow,
        defaultCalendarMonth: defaultCalendarMonth,
        components: components,
        componentsProps: componentsProps,
        slots: slots,
        slotProps: slotProps,
        loading: loading,
        renderLoading: renderLoading,
        disableHighlightToday: disableHighlightToday,
        readOnly: readOnly,
        disabled: disabled,
        showDaysOutsideCurrentMonth: showDaysOutsideCurrentMonth,
        dayOfWeekFormatter: dayOfWeekFormatter,
        sx: sx,
        autoFocus: autoFocus,
        fixedWeekNumber: fixedWeekNumber,
        displayWeekNumber: displayWeekNumber,
        timezone: timezone
    });



/**
 * Demos:
 *
 * - [DatePicker](https://mui.com/x/react-date-pickers/date-picker/)
 * - [Validation](https://mui.com/x/react-date-pickers/validation/)
 *
 * API:
 *
 * - [DesktopDatePicker API](https://mui.com/x/api/date-pickers/desktop-date-picker/)
 */ const $70786dd07bd3e0bf$export$5a73641f0156e1e4 = /*#__PURE__*/ $gJYWc.forwardRef(function DesktopDatePicker(inProps, ref) {
    var _defaultizedProps$yea, _defaultizedProps$slo2, _props$localeText$ope, _props$localeText;
    const localeText = (0, $98220f21a8625472$export$24fdeaa0f591a73e)();
    const utils = (0, $98220f21a8625472$export$1163b47e39508a46)();
    // Props with the default values common to all date pickers
    const defaultizedProps = (0, $3774dc0cfe958d2e$export$a552c17ed3587731)(inProps, 'MuiDesktopDatePicker');
    const viewRenderers = (0, $3VnFq.default)({
        day: (0, $b04e633fdda956fa$export$69888ffe06193e5e),
        month: (0, $b04e633fdda956fa$export$69888ffe06193e5e),
        year: (0, $b04e633fdda956fa$export$69888ffe06193e5e)
    }, defaultizedProps.viewRenderers);
    // Props with the default values specific to the desktop variant
    const props = (0, $3VnFq.default)({}, defaultizedProps, {
        viewRenderers: viewRenderers,
        format: (0, $00e6d022b450825d$export$bb1c921f313ec928)(utils, defaultizedProps, false),
        yearsPerRow: (_defaultizedProps$yea = defaultizedProps.yearsPerRow) != null ? _defaultizedProps$yea : 4,
        slots: (0, $3VnFq.default)({
            openPickerIcon: (0, $fc9c2dee5d88174c$export$5fda1783bb83f57b),
            field: (0, $fe27ec7048b8cc71$export$d9781c7894a82487)
        }, defaultizedProps.slots),
        slotProps: (0, $3VnFq.default)({}, defaultizedProps.slotProps, {
            field: (ownerState)=>{
                var _defaultizedProps$slo;
                return (0, $3VnFq.default)({}, (0, $1cf868609b280c1d$export$308c24034cde71de)((_defaultizedProps$slo = defaultizedProps.slotProps) == null ? void 0 : _defaultizedProps$slo.field, ownerState), (0, $e3a0d6a34962839a$export$5890f750904acddb)(defaultizedProps), {
                    ref: ref
                });
            },
            toolbar: (0, $3VnFq.default)({
                hidden: true
            }, (_defaultizedProps$slo2 = defaultizedProps.slotProps) == null ? void 0 : _defaultizedProps$slo2.toolbar)
        })
    });
    const { renderPicker: renderPicker } = (0, $af0dd03ad3aebb23$export$b1b70bc56ac5be0e)({
        props: props,
        valueManager: (0, $15cde65cbd91c944$export$2764b246aa3b75ba),
        valueType: 'date',
        getOpenDialogAriaText: (_props$localeText$ope = (_props$localeText = props.localeText) == null ? void 0 : _props$localeText.openDatePickerDialogue) != null ? _props$localeText$ope : localeText.openDatePickerDialogue,
        validator: (0, $857e489bb4dc7e4f$export$ffb3d0046ef3a2)
    });
    return renderPicker();
});
$70786dd07bd3e0bf$export$5a73641f0156e1e4.propTypes = {
    // ----------------------------- Warning --------------------------------
    // | These PropTypes are generated from the TypeScript type definitions |
    // | To update them edit the TypeScript types and run "yarn proptypes"  |
    // ----------------------------------------------------------------------
    /**
   * If `true`, the main element is focused during the first mount.
   * This main element is:
   * - the element chosen by the visible view if any (i.e: the selected day on the `day` view).
   * - the `input` element if there is a field rendered.
   */ autoFocus: (0, (/*@__PURE__*/$parcel$interopDefault($3Zour))).bool,
    /**
   * Class name applied to the root element.
   */ className: (0, (/*@__PURE__*/$parcel$interopDefault($3Zour))).string,
    /**
   * If `true`, the popover or modal will close after submitting the full date.
   * @default `true` for desktop, `false` for mobile (based on the chosen wrapper and `desktopModeMediaQuery` prop).
   */ closeOnSelect: (0, (/*@__PURE__*/$parcel$interopDefault($3Zour))).bool,
    /**
   * Overridable components.
   * @default {}
   * @deprecated Please use `slots`.
   */ components: (0, (/*@__PURE__*/$parcel$interopDefault($3Zour))).object,
    /**
   * The props used for each component slot.
   * @default {}
   * @deprecated Please use `slotProps`.
   */ componentsProps: (0, (/*@__PURE__*/$parcel$interopDefault($3Zour))).object,
    /**
   * Formats the day of week displayed in the calendar header.
   * @param {string} day The day of week provided by the adapter.  Deprecated, will be removed in v7: Use `date` instead.
   * @param {TDate} date The date of the day of week provided by the adapter.
   * @returns {string} The name to display.
   * @default (_day: string, date: TDate) => adapter.format(date, 'weekdayShort').charAt(0).toUpperCase()
   */ dayOfWeekFormatter: (0, (/*@__PURE__*/$parcel$interopDefault($3Zour))).func,
    /**
   * Default calendar month displayed when `value` and `defaultValue` are empty.
   * @deprecated Consider using `referenceDate` instead.
   */ defaultCalendarMonth: (0, (/*@__PURE__*/$parcel$interopDefault($3Zour))).any,
    /**
   * The default value.
   * Used when the component is not controlled.
   */ defaultValue: (0, (/*@__PURE__*/$parcel$interopDefault($3Zour))).any,
    /**
   * If `true`, the picker and text field are disabled.
   * @default false
   */ disabled: (0, (/*@__PURE__*/$parcel$interopDefault($3Zour))).bool,
    /**
   * If `true`, disable values after the current date for date components, time for time components and both for date time components.
   * @default false
   */ disableFuture: (0, (/*@__PURE__*/$parcel$interopDefault($3Zour))).bool,
    /**
   * If `true`, today's date is rendering without highlighting with circle.
   * @default false
   */ disableHighlightToday: (0, (/*@__PURE__*/$parcel$interopDefault($3Zour))).bool,
    /**
   * If `true`, the open picker button will not be rendered (renders only the field).
   * @default false
   */ disableOpenPicker: (0, (/*@__PURE__*/$parcel$interopDefault($3Zour))).bool,
    /**
   * If `true`, disable values before the current date for date components, time for time components and both for date time components.
   * @default false
   */ disablePast: (0, (/*@__PURE__*/$parcel$interopDefault($3Zour))).bool,
    /**
   * If `true`, the week number will be display in the calendar.
   */ displayWeekNumber: (0, (/*@__PURE__*/$parcel$interopDefault($3Zour))).bool,
    /**
   * Calendar will show more weeks in order to match this value.
   * Put it to 6 for having fix number of week in Gregorian calendars
   * @default undefined
   */ fixedWeekNumber: (0, (/*@__PURE__*/$parcel$interopDefault($3Zour))).number,
    /**
   * Format of the date when rendered in the input(s).
   * Defaults to localized format based on the used `views`.
   */ format: (0, (/*@__PURE__*/$parcel$interopDefault($3Zour))).string,
    /**
   * Density of the format when rendered in the input.
   * Setting `formatDensity` to `"spacious"` will add a space before and after each `/`, `-` and `.` character.
   * @default "dense"
   */ formatDensity: (0, (/*@__PURE__*/$parcel$interopDefault($3Zour))).oneOf([
        'dense',
        'spacious'
    ]),
    /**
   * Pass a ref to the `input` element.
   */ inputRef: (0, $82c4d2ab89e86c16$export$2e2bcd8739ae039),
    /**
   * The label content.
   */ label: (0, (/*@__PURE__*/$parcel$interopDefault($3Zour))).node,
    /**
   * If `true`, calls `renderLoading` instead of rendering the day calendar.
   * Can be used to preload information and show it in calendar.
   * @default false
   */ loading: (0, (/*@__PURE__*/$parcel$interopDefault($3Zour))).bool,
    /**
   * Locale for components texts.
   * Allows overriding texts coming from `LocalizationProvider` and `theme`.
   */ localeText: (0, (/*@__PURE__*/$parcel$interopDefault($3Zour))).object,
    /**
   * Maximal selectable date.
   */ maxDate: (0, (/*@__PURE__*/$parcel$interopDefault($3Zour))).any,
    /**
   * Minimal selectable date.
   */ minDate: (0, (/*@__PURE__*/$parcel$interopDefault($3Zour))).any,
    /**
   * Months rendered per row.
   * @default 3
   */ monthsPerRow: (0, (/*@__PURE__*/$parcel$interopDefault($3Zour))).oneOf([
        3,
        4
    ]),
    /**
   * Name attribute used by the `input` element in the Field.
   */ name: (0, (/*@__PURE__*/$parcel$interopDefault($3Zour))).string,
    /**
   * Callback fired when the value is accepted.
   * @template TValue The value type. Will be either the same type as `value` or `null`. Can be in `[start, end]` format in case of range value.
   * @param {TValue} value The value that was just accepted.
   */ onAccept: (0, (/*@__PURE__*/$parcel$interopDefault($3Zour))).func,
    /**
   * Callback fired when the value changes.
   * @template TValue The value type. Will be either the same type as `value` or `null`. Can be in `[start, end]` format in case of range value.
   * @template TError The validation error type. Will be either `string` or a `null`. Can be in `[start, end]` format in case of range value.
   * @param {TValue} value The new value.
   * @param {FieldChangeHandlerContext<TError>} context The context containing the validation result of the current value.
   */ onChange: (0, (/*@__PURE__*/$parcel$interopDefault($3Zour))).func,
    /**
   * Callback fired when the popup requests to be closed.
   * Use in controlled mode (see `open`).
   */ onClose: (0, (/*@__PURE__*/$parcel$interopDefault($3Zour))).func,
    /**
   * Callback fired when the error associated to the current value changes.
   * If the error has a non-null value, then the `TextField` will be rendered in `error` state.
   *
   * @template TValue The value type. Will be either the same type as `value` or `null`. Can be in `[start, end]` format in case of range value.
   * @template TError The validation error type. Will be either `string` or a `null`. Can be in `[start, end]` format in case of range value.
   * @param {TError} error The new error describing why the current value is not valid.
   * @param {TValue} value The value associated to the error.
   */ onError: (0, (/*@__PURE__*/$parcel$interopDefault($3Zour))).func,
    /**
   * Callback fired on month change.
   * @template TDate
   * @param {TDate} month The new month.
   */ onMonthChange: (0, (/*@__PURE__*/$parcel$interopDefault($3Zour))).func,
    /**
   * Callback fired when the popup requests to be opened.
   * Use in controlled mode (see `open`).
   */ onOpen: (0, (/*@__PURE__*/$parcel$interopDefault($3Zour))).func,
    /**
   * Callback fired when the selected sections change.
   * @param {FieldSelectedSections} newValue The new selected sections.
   */ onSelectedSectionsChange: (0, (/*@__PURE__*/$parcel$interopDefault($3Zour))).func,
    /**
   * Callback fired on view change.
   * @template TView
   * @param {TView} view The new view.
   */ onViewChange: (0, (/*@__PURE__*/$parcel$interopDefault($3Zour))).func,
    /**
   * Callback fired on year change.
   * @template TDate
   * @param {TDate} year The new year.
   */ onYearChange: (0, (/*@__PURE__*/$parcel$interopDefault($3Zour))).func,
    /**
   * Control the popup or dialog open state.
   * @default false
   */ open: (0, (/*@__PURE__*/$parcel$interopDefault($3Zour))).bool,
    /**
   * The default visible view.
   * Used when the component view is not controlled.
   * Must be a valid option from `views` list.
   */ openTo: (0, (/*@__PURE__*/$parcel$interopDefault($3Zour))).oneOf([
        'day',
        'month',
        'year'
    ]),
    /**
   * Force rendering in particular orientation.
   */ orientation: (0, (/*@__PURE__*/$parcel$interopDefault($3Zour))).oneOf([
        'landscape',
        'portrait'
    ]),
    readOnly: (0, (/*@__PURE__*/$parcel$interopDefault($3Zour))).bool,
    /**
   * If `true`, disable heavy animations.
   * @default `@media(prefers-reduced-motion: reduce)` || `navigator.userAgent` matches Android <10 or iOS <13
   */ reduceAnimations: (0, (/*@__PURE__*/$parcel$interopDefault($3Zour))).bool,
    /**
   * The date used to generate the new value when both `value` and `defaultValue` are empty.
   * @default The closest valid date-time using the validation props, except callbacks like `shouldDisable<...>`.
   */ referenceDate: (0, (/*@__PURE__*/$parcel$interopDefault($3Zour))).any,
    /**
   * Component displaying when passed `loading` true.
   * @returns {React.ReactNode} The node to render when loading.
   * @default () => <span data-mui-test="loading-progress">...</span>
   */ renderLoading: (0, (/*@__PURE__*/$parcel$interopDefault($3Zour))).func,
    /**
   * The currently selected sections.
   * This prop accept four formats:
   * 1. If a number is provided, the section at this index will be selected.
   * 2. If an object with a `startIndex` and `endIndex` properties are provided, the sections between those two indexes will be selected.
   * 3. If a string of type `FieldSectionType` is provided, the first section with that name will be selected.
   * 4. If `null` is provided, no section will be selected
   * If not provided, the selected sections will be handled internally.
   */ selectedSections: (0, (/*@__PURE__*/$parcel$interopDefault($3Zour))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($3Zour))).oneOf([
            'all',
            'day',
            'hours',
            'meridiem',
            'minutes',
            'month',
            'seconds',
            'weekDay',
            'year'
        ]),
        (0, (/*@__PURE__*/$parcel$interopDefault($3Zour))).number,
        (0, (/*@__PURE__*/$parcel$interopDefault($3Zour))).shape({
            endIndex: (0, (/*@__PURE__*/$parcel$interopDefault($3Zour))).number.isRequired,
            startIndex: (0, (/*@__PURE__*/$parcel$interopDefault($3Zour))).number.isRequired
        })
    ]),
    /**
   * Disable specific date.
   *
   * Warning: This function can be called multiple times (e.g. when rendering date calendar, checking if focus can be moved to a certain date, etc.). Expensive computations can impact performance.
   *
   * @template TDate
   * @param {TDate} day The date to test.
   * @returns {boolean} If `true` the date will be disabled.
   */ shouldDisableDate: (0, (/*@__PURE__*/$parcel$interopDefault($3Zour))).func,
    /**
   * Disable specific month.
   * @template TDate
   * @param {TDate} month The month to test.
   * @returns {boolean} If `true`, the month will be disabled.
   */ shouldDisableMonth: (0, (/*@__PURE__*/$parcel$interopDefault($3Zour))).func,
    /**
   * Disable specific year.
   * @template TDate
   * @param {TDate} year The year to test.
   * @returns {boolean} If `true`, the year will be disabled.
   */ shouldDisableYear: (0, (/*@__PURE__*/$parcel$interopDefault($3Zour))).func,
    /**
   * If `true`, days outside the current month are rendered:
   *
   * - if `fixedWeekNumber` is defined, renders days to have the weeks requested.
   *
   * - if `fixedWeekNumber` is not defined, renders day to fill the first and last week of the current month.
   *
   * - ignored if `calendars` equals more than `1` on range pickers.
   * @default false
   */ showDaysOutsideCurrentMonth: (0, (/*@__PURE__*/$parcel$interopDefault($3Zour))).bool,
    /**
   * The props used for each component slot.
   * @default {}
   */ slotProps: (0, (/*@__PURE__*/$parcel$interopDefault($3Zour))).object,
    /**
   * Overridable component slots.
   * @default {}
   */ slots: (0, (/*@__PURE__*/$parcel$interopDefault($3Zour))).object,
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: (0, (/*@__PURE__*/$parcel$interopDefault($3Zour))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($3Zour))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($3Zour))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($3Zour))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($3Zour))).object,
            (0, (/*@__PURE__*/$parcel$interopDefault($3Zour))).bool
        ])),
        (0, (/*@__PURE__*/$parcel$interopDefault($3Zour))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($3Zour))).object
    ]),
    /**
   * Choose which timezone to use for the value.
   * Example: "default", "system", "UTC", "America/New_York".
   * If you pass values from other timezones to some props, they will be converted to this timezone before being used.
   * @see See the {@link https://mui.com/x/react-date-pickers/timezone/ timezones documention} for more details.
   * @default The timezone of the `value` or `defaultValue` prop is defined, 'default' otherwise.
   */ timezone: (0, (/*@__PURE__*/$parcel$interopDefault($3Zour))).string,
    /**
   * The selected value.
   * Used when the component is controlled.
   */ value: (0, (/*@__PURE__*/$parcel$interopDefault($3Zour))).any,
    /**
   * The visible view.
   * Used when the component view is controlled.
   * Must be a valid option from `views` list.
   */ view: (0, (/*@__PURE__*/$parcel$interopDefault($3Zour))).oneOf([
        'day',
        'month',
        'year'
    ]),
    /**
   * Define custom view renderers for each section.
   * If `null`, the section will only have field editing.
   * If `undefined`, internally defined view will be the used.
   */ viewRenderers: (0, (/*@__PURE__*/$parcel$interopDefault($3Zour))).shape({
        day: (0, (/*@__PURE__*/$parcel$interopDefault($3Zour))).func,
        month: (0, (/*@__PURE__*/$parcel$interopDefault($3Zour))).func,
        year: (0, (/*@__PURE__*/$parcel$interopDefault($3Zour))).func
    }),
    /**
   * Available views.
   */ views: (0, (/*@__PURE__*/$parcel$interopDefault($3Zour))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($3Zour))).oneOf([
        'day',
        'month',
        'year'
    ]).isRequired),
    /**
   * Years rendered per row.
   * @default 4
   */ yearsPerRow: (0, (/*@__PURE__*/$parcel$interopDefault($3Zour))).oneOf([
        3,
        4
    ])
};



var $3VnFq = parcelRequire("3VnFq");

var $gJYWc = parcelRequire("gJYWc");

var $3Zour = parcelRequire("3Zour");



var $3VnFq = parcelRequire("3VnFq");

var $cTAWX = parcelRequire("cTAWX");

var $gJYWc = parcelRequire("gJYWc");


var $4gWBK = parcelRequire("4gWBK");


var $3VnFq = parcelRequire("3VnFq");
parcelRequire("gJYWc");

var $cTAWX = parcelRequire("cTAWX");

var $3VnFq = parcelRequire("3VnFq");

var $gJYWc = parcelRequire("gJYWc");


var $2w6IV = parcelRequire("2w6IV");

var $3e4LV = parcelRequire("3e4LV");

var $HGmne = parcelRequire("HGmne");

var $8pLcn = parcelRequire("8pLcn");

var $i8nzj = parcelRequire("i8nzj");

var $1kRHf = parcelRequire("1kRHf");
function $85679c1dc79da806$export$61b0ee1f05fb344e(slot) {
    return (0, $1kRHf.default)('MuiDialogContent', slot);
}
const $85679c1dc79da806$var$dialogContentClasses = (0, $i8nzj.default)('MuiDialogContent', [
    'root',
    'dividers'
]);
var $85679c1dc79da806$export$2e2bcd8739ae039 = $85679c1dc79da806$var$dialogContentClasses;



var $i8nzj = parcelRequire("i8nzj");

var $1kRHf = parcelRequire("1kRHf");
function $f5ef80708e2816a6$export$f5d2ec7e4c47e088(slot) {
    return (0, $1kRHf.default)('MuiDialogTitle', slot);
}
const $f5ef80708e2816a6$var$dialogTitleClasses = (0, $i8nzj.default)('MuiDialogTitle', [
    'root'
]);
var $f5ef80708e2816a6$export$2e2bcd8739ae039 = $f5ef80708e2816a6$var$dialogTitleClasses;



var $9wx12 = parcelRequire("9wx12");
'use client';
const $2f56abc7ae074cc3$var$_excluded = [
    "className",
    "dividers"
];
const $2f56abc7ae074cc3$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, dividers: dividers } = ownerState;
    const slots = {
        root: [
            'root',
            dividers && 'dividers'
        ]
    };
    return (0, $3e4LV.default)(slots, (0, $85679c1dc79da806$export$61b0ee1f05fb344e), classes);
};
const $2f56abc7ae074cc3$var$DialogContentRoot = (0, $HGmne.default)('div', {
    name: 'MuiDialogContent',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.dividers && styles.dividers
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $3VnFq.default)({
        flex: '1 1 auto',
        // Add iOS momentum scrolling for iOS < 13.0
        WebkitOverflowScrolling: 'touch',
        overflowY: 'auto',
        padding: '20px 24px'
    }, ownerState.dividers ? {
        padding: '16px 24px',
        borderTop: `1px solid ${(theme.vars || theme).palette.divider}`,
        borderBottom: `1px solid ${(theme.vars || theme).palette.divider}`
    } : {
        [`.${(0, $f5ef80708e2816a6$export$2e2bcd8739ae039).root} + &`]: {
            paddingTop: 0
        }
    }));
const $2f56abc7ae074cc3$var$DialogContent = /*#__PURE__*/ $gJYWc.forwardRef(function DialogContent(inProps, ref) {
    const props = (0, $8pLcn.useDefaultProps)({
        props: inProps,
        name: 'MuiDialogContent'
    });
    const { className: className, dividers: dividers = false } = props, other = (0, $cTAWX.default)(props, $2f56abc7ae074cc3$var$_excluded);
    const ownerState = (0, $3VnFq.default)({}, props, {
        dividers: dividers
    });
    const classes = $2f56abc7ae074cc3$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $9wx12.jsx)($2f56abc7ae074cc3$var$DialogContentRoot, (0, $3VnFq.default)({
        className: (0, $2w6IV.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref
    }, other));
});
var $2f56abc7ae074cc3$export$2e2bcd8739ae039 = $2f56abc7ae074cc3$var$DialogContent;




var $cTAWX = parcelRequire("cTAWX");

var $3VnFq = parcelRequire("3VnFq");

var $gJYWc = parcelRequire("gJYWc");


var $2w6IV = parcelRequire("2w6IV");

var $3e4LV = parcelRequire("3e4LV");


var $cVrVk = parcelRequire("cVrVk");




var $8pLcn = parcelRequire("8pLcn");

var $HGmne = parcelRequire("HGmne");

var $i8nzj = parcelRequire("i8nzj");

var $1kRHf = parcelRequire("1kRHf");
function $a328a75714229b8f$export$2177af0aa15c34c2(slot) {
    return (0, $1kRHf.default)('MuiDialog', slot);
}
const $a328a75714229b8f$var$dialogClasses = (0, $i8nzj.default)('MuiDialog', [
    'root',
    'scrollPaper',
    'scrollBody',
    'container',
    'paper',
    'paperScrollPaper',
    'paperScrollBody',
    'paperWidthFalse',
    'paperWidthXs',
    'paperWidthSm',
    'paperWidthMd',
    'paperWidthLg',
    'paperWidthXl',
    'paperFullWidth',
    'paperFullScreen'
]);
var $a328a75714229b8f$export$2e2bcd8739ae039 = $a328a75714229b8f$var$dialogClasses;



var $gJYWc = parcelRequire("gJYWc");
const $4257dd75db5cf2d0$var$DialogContext = /*#__PURE__*/ $gJYWc.createContext({});
var $4257dd75db5cf2d0$export$2e2bcd8739ae039 = $4257dd75db5cf2d0$var$DialogContext;





var $9wx12 = parcelRequire("9wx12");
'use client';
const $114dcbd93ef0f896$var$_excluded = [
    "aria-describedby",
    "aria-labelledby",
    "BackdropComponent",
    "BackdropProps",
    "children",
    "className",
    "disableEscapeKeyDown",
    "fullScreen",
    "fullWidth",
    "maxWidth",
    "onBackdropClick",
    "onClick",
    "onClose",
    "open",
    "PaperComponent",
    "PaperProps",
    "scroll",
    "TransitionComponent",
    "transitionDuration",
    "TransitionProps"
];
const $114dcbd93ef0f896$var$DialogBackdrop = (0, $HGmne.default)((0, $826f007e2fc51e5c$export$2e2bcd8739ae039), {
    name: 'MuiDialog',
    slot: 'Backdrop',
    overrides: (props, styles)=>styles.backdrop
})({
    // Improve scrollable dialog support.
    zIndex: -1
});
const $114dcbd93ef0f896$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, scroll: scroll, maxWidth: maxWidth, fullWidth: fullWidth, fullScreen: fullScreen } = ownerState;
    const slots = {
        root: [
            'root'
        ],
        container: [
            'container',
            `scroll${(0, $cVrVk.default)(scroll)}`
        ],
        paper: [
            'paper',
            `paperScroll${(0, $cVrVk.default)(scroll)}`,
            `paperWidth${(0, $cVrVk.default)(String(maxWidth))}`,
            fullWidth && 'paperFullWidth',
            fullScreen && 'paperFullScreen'
        ]
    };
    return (0, $3e4LV.default)(slots, (0, $a328a75714229b8f$export$2177af0aa15c34c2), classes);
};
const $114dcbd93ef0f896$var$DialogRoot = (0, $HGmne.default)((0, $9479e61072db3f56$export$2e2bcd8739ae039), {
    name: 'MuiDialog',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})({
    '@media print': {
        // Use !important to override the Modal inline-style.
        position: 'absolute !important'
    }
});
const $114dcbd93ef0f896$var$DialogContainer = (0, $HGmne.default)('div', {
    name: 'MuiDialog',
    slot: 'Container',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.container,
            styles[`scroll${(0, $cVrVk.default)(ownerState.scroll)}`]
        ];
    }
})(({ ownerState: ownerState })=>(0, $3VnFq.default)({
        height: '100%',
        '@media print': {
            height: 'auto'
        },
        // We disable the focus ring for mouse, touch and keyboard users.
        outline: 0
    }, ownerState.scroll === 'paper' && {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
    }, ownerState.scroll === 'body' && {
        overflowY: 'auto',
        overflowX: 'hidden',
        textAlign: 'center',
        '&::after': {
            content: '""',
            display: 'inline-block',
            verticalAlign: 'middle',
            height: '100%',
            width: '0'
        }
    }));
const $114dcbd93ef0f896$var$DialogPaper = (0, $HGmne.default)((0, $db3ddac601361ae3$export$2e2bcd8739ae039), {
    name: 'MuiDialog',
    slot: 'Paper',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.paper,
            styles[`scrollPaper${(0, $cVrVk.default)(ownerState.scroll)}`],
            styles[`paperWidth${(0, $cVrVk.default)(String(ownerState.maxWidth))}`],
            ownerState.fullWidth && styles.paperFullWidth,
            ownerState.fullScreen && styles.paperFullScreen
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $3VnFq.default)({
        margin: 32,
        position: 'relative',
        overflowY: 'auto',
        // Fix IE11 issue, to remove at some point.
        '@media print': {
            overflowY: 'visible',
            boxShadow: 'none'
        }
    }, ownerState.scroll === 'paper' && {
        display: 'flex',
        flexDirection: 'column',
        maxHeight: 'calc(100% - 64px)'
    }, ownerState.scroll === 'body' && {
        display: 'inline-block',
        verticalAlign: 'middle',
        textAlign: 'left' // 'initial' doesn't work on IE11
    }, !ownerState.maxWidth && {
        maxWidth: 'calc(100% - 64px)'
    }, ownerState.maxWidth === 'xs' && {
        maxWidth: theme.breakpoints.unit === 'px' ? Math.max(theme.breakpoints.values.xs, 444) : `max(${theme.breakpoints.values.xs}${theme.breakpoints.unit}, 444px)`,
        [`&.${(0, $a328a75714229b8f$export$2e2bcd8739ae039).paperScrollBody}`]: {
            [theme.breakpoints.down(Math.max(theme.breakpoints.values.xs, 444) + 64)]: {
                maxWidth: 'calc(100% - 64px)'
            }
        }
    }, ownerState.maxWidth && ownerState.maxWidth !== 'xs' && {
        maxWidth: `${theme.breakpoints.values[ownerState.maxWidth]}${theme.breakpoints.unit}`,
        [`&.${(0, $a328a75714229b8f$export$2e2bcd8739ae039).paperScrollBody}`]: {
            [theme.breakpoints.down(theme.breakpoints.values[ownerState.maxWidth] + 64)]: {
                maxWidth: 'calc(100% - 64px)'
            }
        }
    }, ownerState.fullWidth && {
        width: 'calc(100% - 64px)'
    }, ownerState.fullScreen && {
        margin: 0,
        width: '100%',
        maxWidth: '100%',
        height: '100%',
        maxHeight: 'none',
        borderRadius: 0,
        [`&.${(0, $a328a75714229b8f$export$2e2bcd8739ae039).paperScrollBody}`]: {
            margin: 0,
            maxWidth: '100%'
        }
    }));
/**
 * Dialogs are overlaid modal paper based components with a backdrop.
 */ const $114dcbd93ef0f896$var$Dialog = /*#__PURE__*/ $gJYWc.forwardRef(function Dialog(inProps, ref) {
    const props = (0, $8pLcn.useDefaultProps)({
        props: inProps,
        name: 'MuiDialog'
    });
    const theme = (0, $ae968105fc5c093e$export$2e2bcd8739ae039)();
    const defaultTransitionDuration = {
        enter: theme.transitions.duration.enteringScreen,
        exit: theme.transitions.duration.leavingScreen
    };
    const { 'aria-describedby': ariaDescribedby, 'aria-labelledby': ariaLabelledbyProp, BackdropComponent: BackdropComponent, BackdropProps: BackdropProps, children: children, className: className, disableEscapeKeyDown: disableEscapeKeyDown = false, fullScreen: fullScreen = false, fullWidth: fullWidth = false, maxWidth: maxWidth = 'sm', onBackdropClick: onBackdropClick, onClick: onClick, onClose: onClose, open: open, PaperComponent: PaperComponent = (0, $db3ddac601361ae3$export$2e2bcd8739ae039), PaperProps: PaperProps = {}, scroll: scroll = 'paper', TransitionComponent: TransitionComponent = (0, $5d4a7e2c608c4487$export$2e2bcd8739ae039), transitionDuration: transitionDuration = defaultTransitionDuration, TransitionProps: TransitionProps } = props, other = (0, $cTAWX.default)(props, $114dcbd93ef0f896$var$_excluded);
    const ownerState = (0, $3VnFq.default)({}, props, {
        disableEscapeKeyDown: disableEscapeKeyDown,
        fullScreen: fullScreen,
        fullWidth: fullWidth,
        maxWidth: maxWidth,
        scroll: scroll
    });
    const classes = $114dcbd93ef0f896$var$useUtilityClasses(ownerState);
    const backdropClick = $gJYWc.useRef();
    const handleMouseDown = (event)=>{
        // We don't want to close the dialog when clicking the dialog content.
        // Make sure the event starts and ends on the same DOM element.
        backdropClick.current = event.target === event.currentTarget;
    };
    const handleBackdropClick = (event)=>{
        if (onClick) onClick(event);
        // Ignore the events not coming from the "backdrop".
        if (!backdropClick.current) return;
        backdropClick.current = null;
        if (onBackdropClick) onBackdropClick(event);
        if (onClose) onClose(event, 'backdropClick');
    };
    const ariaLabelledby = (0, $8fee44a510de4e75$export$2e2bcd8739ae039)(ariaLabelledbyProp);
    const dialogContextValue = $gJYWc.useMemo(()=>{
        return {
            titleId: ariaLabelledby
        };
    }, [
        ariaLabelledby
    ]);
    return /*#__PURE__*/ (0, $9wx12.jsx)($114dcbd93ef0f896$var$DialogRoot, (0, $3VnFq.default)({
        className: (0, $2w6IV.default)(classes.root, className),
        closeAfterTransition: true,
        components: {
            Backdrop: $114dcbd93ef0f896$var$DialogBackdrop
        },
        componentsProps: {
            backdrop: (0, $3VnFq.default)({
                transitionDuration: transitionDuration,
                as: BackdropComponent
            }, BackdropProps)
        },
        disableEscapeKeyDown: disableEscapeKeyDown,
        onClose: onClose,
        open: open,
        ref: ref,
        onClick: handleBackdropClick,
        ownerState: ownerState
    }, other, {
        children: /*#__PURE__*/ (0, $9wx12.jsx)(TransitionComponent, (0, $3VnFq.default)({
            appear: true,
            in: open,
            timeout: transitionDuration,
            role: "presentation"
        }, TransitionProps, {
            children: /*#__PURE__*/ (0, $9wx12.jsx)($114dcbd93ef0f896$var$DialogContainer, {
                className: (0, $2w6IV.default)(classes.container),
                onMouseDown: handleMouseDown,
                ownerState: ownerState,
                children: /*#__PURE__*/ (0, $9wx12.jsx)($114dcbd93ef0f896$var$DialogPaper, (0, $3VnFq.default)({
                    as: PaperComponent,
                    elevation: 24,
                    role: "dialog",
                    "aria-describedby": ariaDescribedby,
                    "aria-labelledby": ariaLabelledby
                }, PaperProps, {
                    className: (0, $2w6IV.default)(classes.paper, PaperProps.className),
                    ownerState: ownerState,
                    children: /*#__PURE__*/ (0, $9wx12.jsx)((0, $4257dd75db5cf2d0$export$2e2bcd8739ae039).Provider, {
                        value: dialogContextValue,
                        children: children
                    })
                }))
            })
        }))
    }));
});
var $114dcbd93ef0f896$export$2e2bcd8739ae039 = $114dcbd93ef0f896$var$Dialog;



var $HGmne = parcelRequire("HGmne");


var $9wx12 = parcelRequire("9wx12");
const $699584f67c3e8bc9$var$PickersModalDialogRoot = (0, $HGmne.default)((0, $114dcbd93ef0f896$export$2e2bcd8739ae039))({
    [`& .${(0, $a328a75714229b8f$export$2e2bcd8739ae039).container}`]: {
        outline: 0
    },
    [`& .${(0, $a328a75714229b8f$export$2e2bcd8739ae039).paper}`]: {
        outline: 0,
        minWidth: (0, $8450780b4b9a6f99$export$ee46b8a74d6c94d3)
    }
});
const $699584f67c3e8bc9$var$PickersModalDialogContent = (0, $HGmne.default)((0, $2f56abc7ae074cc3$export$2e2bcd8739ae039))({
    '&:first-of-type': {
        padding: 0
    }
});
function $699584f67c3e8bc9$export$99f83c99e1491f77(props) {
    var _slots$dialog, _slots$mobileTransiti;
    const { children: children, onDismiss: onDismiss, open: open, slots: slots, slotProps: slotProps } = props;
    const Dialog = (_slots$dialog = slots == null ? void 0 : slots.dialog) != null ? _slots$dialog : $699584f67c3e8bc9$var$PickersModalDialogRoot;
    const Transition = (_slots$mobileTransiti = slots == null ? void 0 : slots.mobileTransition) != null ? _slots$mobileTransiti : (0, $5d4a7e2c608c4487$export$2e2bcd8739ae039);
    return /*#__PURE__*/ (0, $9wx12.jsx)(Dialog, (0, $3VnFq.default)({
        open: open,
        onClose: onDismiss
    }, slotProps == null ? void 0 : slotProps.dialog, {
        TransitionComponent: Transition,
        TransitionProps: slotProps == null ? void 0 : slotProps.mobileTransition,
        PaperComponent: slots == null ? void 0 : slots.mobilePaper,
        PaperProps: slotProps == null ? void 0 : slotProps.mobilePaper,
        children: /*#__PURE__*/ (0, $9wx12.jsx)($699584f67c3e8bc9$var$PickersModalDialogContent, {
            children: children
        })
    }));
}








var $9wx12 = parcelRequire("9wx12");
const $5691ee540aea8f7e$var$_excluded = [
    "props",
    "getOpenDialogAriaText"
];
const $5691ee540aea8f7e$export$5ca0153a626a7dd7 = (_ref)=>{
    var _innerSlotProps$toolb, _innerSlotProps$toolb2, _slots$layout;
    let { props: props, getOpenDialogAriaText: getOpenDialogAriaText } = _ref, pickerParams = (0, $cTAWX.default)(_ref, $5691ee540aea8f7e$var$_excluded);
    const { slots: slots, slotProps: innerSlotProps, className: className, sx: sx, format: format, formatDensity: formatDensity, timezone: timezone, name: name, label: label, inputRef: inputRef, readOnly: readOnly, disabled: disabled, localeText: localeText } = props;
    const utils = (0, $98220f21a8625472$export$1163b47e39508a46)();
    const internalInputRef = $gJYWc.useRef(null);
    const labelId = (0, $8fee44a510de4e75$export$2e2bcd8739ae039)();
    const isToolbarHidden = (_innerSlotProps$toolb = innerSlotProps == null || (_innerSlotProps$toolb2 = innerSlotProps.toolbar) == null ? void 0 : _innerSlotProps$toolb2.hidden) != null ? _innerSlotProps$toolb : false;
    const { open: open, actions: actions, layoutProps: layoutProps, renderCurrentView: renderCurrentView, fieldProps: pickerFieldProps } = (0, $a038f94f25841f0e$export$fc3313977ac596c4)((0, $3VnFq.default)({}, pickerParams, {
        props: props,
        inputRef: internalInputRef,
        autoFocusView: true,
        additionalViewProps: {},
        wrapperVariant: 'mobile'
    }));
    const Field = slots.field;
    const fieldProps = (0, $2082854bb194ebf1$export$2e2bcd8739ae039)({
        elementType: Field,
        externalSlotProps: innerSlotProps == null ? void 0 : innerSlotProps.field,
        additionalProps: (0, $3VnFq.default)({}, pickerFieldProps, isToolbarHidden && {
            id: labelId
        }, !(disabled || readOnly) && {
            onClick: actions.onOpen,
            onKeyDown: (0, $870e97cd00438bdc$export$4467fe8634707c85)(actions.onOpen)
        }, {
            readOnly: readOnly != null ? readOnly : true,
            disabled: disabled,
            className: className,
            sx: sx,
            format: format,
            formatDensity: formatDensity,
            timezone: timezone,
            label: label,
            name: name
        }),
        ownerState: props
    });
    // TODO: Move to `useSlotProps` when https://github.com/mui/material-ui/pull/35088 will be merged
    fieldProps.inputProps = (0, $3VnFq.default)({}, fieldProps.inputProps, {
        'aria-label': getOpenDialogAriaText(pickerFieldProps.value, utils)
    });
    const slotsForField = (0, $3VnFq.default)({
        textField: slots.textField
    }, fieldProps.slots);
    const Layout = (_slots$layout = slots.layout) != null ? _slots$layout : (0, $ef1e028794d25d4b$export$647f604ea2397c05);
    const handleInputRef = (0, $4gWBK.default)(internalInputRef, fieldProps.inputRef, inputRef);
    let labelledById = labelId;
    if (isToolbarHidden) {
        if (label) labelledById = `${labelId}-label`;
        else labelledById = undefined;
    }
    const slotProps = (0, $3VnFq.default)({}, innerSlotProps, {
        toolbar: (0, $3VnFq.default)({}, innerSlotProps == null ? void 0 : innerSlotProps.toolbar, {
            titleId: labelId
        }),
        mobilePaper: (0, $3VnFq.default)({
            'aria-labelledby': labelledById
        }, innerSlotProps == null ? void 0 : innerSlotProps.mobilePaper)
    });
    const renderPicker = ()=>/*#__PURE__*/ (0, $9wx12.jsxs)((0, $38b9c61d570d1b88$export$dc45bdc734ce6f1e), {
            localeText: localeText,
            children: [
                /*#__PURE__*/ (0, $9wx12.jsx)(Field, (0, $3VnFq.default)({}, fieldProps, {
                    slots: slotsForField,
                    slotProps: slotProps,
                    inputRef: handleInputRef
                })),
                /*#__PURE__*/ (0, $9wx12.jsx)((0, $699584f67c3e8bc9$export$99f83c99e1491f77), (0, $3VnFq.default)({}, actions, {
                    open: open,
                    slots: slots,
                    slotProps: slotProps,
                    children: /*#__PURE__*/ (0, $9wx12.jsx)(Layout, (0, $3VnFq.default)({}, layoutProps, slotProps == null ? void 0 : slotProps.layout, {
                        slots: slots,
                        slotProps: slotProps,
                        children: renderCurrentView()
                    }))
                }))
            ]
        });
    return {
        renderPicker: renderPicker
    };
};









/**
 * Demos:
 *
 * - [DatePicker](https://mui.com/x/react-date-pickers/date-picker/)
 * - [Validation](https://mui.com/x/react-date-pickers/validation/)
 *
 * API:
 *
 * - [MobileDatePicker API](https://mui.com/x/api/date-pickers/mobile-date-picker/)
 */ const $d51370e6e1baabed$export$97b476d7a92fee62 = /*#__PURE__*/ $gJYWc.forwardRef(function MobileDatePicker(inProps, ref) {
    var _defaultizedProps$slo2, _props$localeText$ope, _props$localeText;
    const localeText = (0, $98220f21a8625472$export$24fdeaa0f591a73e)();
    const utils = (0, $98220f21a8625472$export$1163b47e39508a46)();
    // Props with the default values common to all date pickers
    const defaultizedProps = (0, $3774dc0cfe958d2e$export$a552c17ed3587731)(inProps, 'MuiMobileDatePicker');
    const viewRenderers = (0, $3VnFq.default)({
        day: (0, $b04e633fdda956fa$export$69888ffe06193e5e),
        month: (0, $b04e633fdda956fa$export$69888ffe06193e5e),
        year: (0, $b04e633fdda956fa$export$69888ffe06193e5e)
    }, defaultizedProps.viewRenderers);
    // Props with the default values specific to the mobile variant
    const props = (0, $3VnFq.default)({}, defaultizedProps, {
        viewRenderers: viewRenderers,
        format: (0, $00e6d022b450825d$export$bb1c921f313ec928)(utils, defaultizedProps, false),
        slots: (0, $3VnFq.default)({
            field: (0, $fe27ec7048b8cc71$export$d9781c7894a82487)
        }, defaultizedProps.slots),
        slotProps: (0, $3VnFq.default)({}, defaultizedProps.slotProps, {
            field: (ownerState)=>{
                var _defaultizedProps$slo;
                return (0, $3VnFq.default)({}, (0, $1cf868609b280c1d$export$308c24034cde71de)((_defaultizedProps$slo = defaultizedProps.slotProps) == null ? void 0 : _defaultizedProps$slo.field, ownerState), (0, $e3a0d6a34962839a$export$5890f750904acddb)(defaultizedProps), {
                    ref: ref
                });
            },
            toolbar: (0, $3VnFq.default)({
                hidden: false
            }, (_defaultizedProps$slo2 = defaultizedProps.slotProps) == null ? void 0 : _defaultizedProps$slo2.toolbar)
        })
    });
    const { renderPicker: renderPicker } = (0, $5691ee540aea8f7e$export$5ca0153a626a7dd7)({
        props: props,
        valueManager: (0, $15cde65cbd91c944$export$2764b246aa3b75ba),
        valueType: 'date',
        getOpenDialogAriaText: (_props$localeText$ope = (_props$localeText = props.localeText) == null ? void 0 : _props$localeText.openDatePickerDialogue) != null ? _props$localeText$ope : localeText.openDatePickerDialogue,
        validator: (0, $857e489bb4dc7e4f$export$ffb3d0046ef3a2)
    });
    return renderPicker();
});
$d51370e6e1baabed$export$97b476d7a92fee62.propTypes = {
    // ----------------------------- Warning --------------------------------
    // | These PropTypes are generated from the TypeScript type definitions |
    // | To update them edit the TypeScript types and run "yarn proptypes"  |
    // ----------------------------------------------------------------------
    /**
   * If `true`, the main element is focused during the first mount.
   * This main element is:
   * - the element chosen by the visible view if any (i.e: the selected day on the `day` view).
   * - the `input` element if there is a field rendered.
   */ autoFocus: (0, (/*@__PURE__*/$parcel$interopDefault($3Zour))).bool,
    /**
   * Class name applied to the root element.
   */ className: (0, (/*@__PURE__*/$parcel$interopDefault($3Zour))).string,
    /**
   * If `true`, the popover or modal will close after submitting the full date.
   * @default `true` for desktop, `false` for mobile (based on the chosen wrapper and `desktopModeMediaQuery` prop).
   */ closeOnSelect: (0, (/*@__PURE__*/$parcel$interopDefault($3Zour))).bool,
    /**
   * Overridable components.
   * @default {}
   * @deprecated Please use `slots`.
   */ components: (0, (/*@__PURE__*/$parcel$interopDefault($3Zour))).object,
    /**
   * The props used for each component slot.
   * @default {}
   * @deprecated Please use `slotProps`.
   */ componentsProps: (0, (/*@__PURE__*/$parcel$interopDefault($3Zour))).object,
    /**
   * Formats the day of week displayed in the calendar header.
   * @param {string} day The day of week provided by the adapter.  Deprecated, will be removed in v7: Use `date` instead.
   * @param {TDate} date The date of the day of week provided by the adapter.
   * @returns {string} The name to display.
   * @default (_day: string, date: TDate) => adapter.format(date, 'weekdayShort').charAt(0).toUpperCase()
   */ dayOfWeekFormatter: (0, (/*@__PURE__*/$parcel$interopDefault($3Zour))).func,
    /**
   * Default calendar month displayed when `value` and `defaultValue` are empty.
   * @deprecated Consider using `referenceDate` instead.
   */ defaultCalendarMonth: (0, (/*@__PURE__*/$parcel$interopDefault($3Zour))).any,
    /**
   * The default value.
   * Used when the component is not controlled.
   */ defaultValue: (0, (/*@__PURE__*/$parcel$interopDefault($3Zour))).any,
    /**
   * If `true`, the picker and text field are disabled.
   * @default false
   */ disabled: (0, (/*@__PURE__*/$parcel$interopDefault($3Zour))).bool,
    /**
   * If `true`, disable values after the current date for date components, time for time components and both for date time components.
   * @default false
   */ disableFuture: (0, (/*@__PURE__*/$parcel$interopDefault($3Zour))).bool,
    /**
   * If `true`, today's date is rendering without highlighting with circle.
   * @default false
   */ disableHighlightToday: (0, (/*@__PURE__*/$parcel$interopDefault($3Zour))).bool,
    /**
   * If `true`, the open picker button will not be rendered (renders only the field).
   * @default false
   */ disableOpenPicker: (0, (/*@__PURE__*/$parcel$interopDefault($3Zour))).bool,
    /**
   * If `true`, disable values before the current date for date components, time for time components and both for date time components.
   * @default false
   */ disablePast: (0, (/*@__PURE__*/$parcel$interopDefault($3Zour))).bool,
    /**
   * If `true`, the week number will be display in the calendar.
   */ displayWeekNumber: (0, (/*@__PURE__*/$parcel$interopDefault($3Zour))).bool,
    /**
   * Calendar will show more weeks in order to match this value.
   * Put it to 6 for having fix number of week in Gregorian calendars
   * @default undefined
   */ fixedWeekNumber: (0, (/*@__PURE__*/$parcel$interopDefault($3Zour))).number,
    /**
   * Format of the date when rendered in the input(s).
   * Defaults to localized format based on the used `views`.
   */ format: (0, (/*@__PURE__*/$parcel$interopDefault($3Zour))).string,
    /**
   * Density of the format when rendered in the input.
   * Setting `formatDensity` to `"spacious"` will add a space before and after each `/`, `-` and `.` character.
   * @default "dense"
   */ formatDensity: (0, (/*@__PURE__*/$parcel$interopDefault($3Zour))).oneOf([
        'dense',
        'spacious'
    ]),
    /**
   * Pass a ref to the `input` element.
   */ inputRef: (0, $82c4d2ab89e86c16$export$2e2bcd8739ae039),
    /**
   * The label content.
   */ label: (0, (/*@__PURE__*/$parcel$interopDefault($3Zour))).node,
    /**
   * If `true`, calls `renderLoading` instead of rendering the day calendar.
   * Can be used to preload information and show it in calendar.
   * @default false
   */ loading: (0, (/*@__PURE__*/$parcel$interopDefault($3Zour))).bool,
    /**
   * Locale for components texts.
   * Allows overriding texts coming from `LocalizationProvider` and `theme`.
   */ localeText: (0, (/*@__PURE__*/$parcel$interopDefault($3Zour))).object,
    /**
   * Maximal selectable date.
   */ maxDate: (0, (/*@__PURE__*/$parcel$interopDefault($3Zour))).any,
    /**
   * Minimal selectable date.
   */ minDate: (0, (/*@__PURE__*/$parcel$interopDefault($3Zour))).any,
    /**
   * Months rendered per row.
   * @default 3
   */ monthsPerRow: (0, (/*@__PURE__*/$parcel$interopDefault($3Zour))).oneOf([
        3,
        4
    ]),
    /**
   * Name attribute used by the `input` element in the Field.
   */ name: (0, (/*@__PURE__*/$parcel$interopDefault($3Zour))).string,
    /**
   * Callback fired when the value is accepted.
   * @template TValue The value type. Will be either the same type as `value` or `null`. Can be in `[start, end]` format in case of range value.
   * @param {TValue} value The value that was just accepted.
   */ onAccept: (0, (/*@__PURE__*/$parcel$interopDefault($3Zour))).func,
    /**
   * Callback fired when the value changes.
   * @template TValue The value type. Will be either the same type as `value` or `null`. Can be in `[start, end]` format in case of range value.
   * @template TError The validation error type. Will be either `string` or a `null`. Can be in `[start, end]` format in case of range value.
   * @param {TValue} value The new value.
   * @param {FieldChangeHandlerContext<TError>} context The context containing the validation result of the current value.
   */ onChange: (0, (/*@__PURE__*/$parcel$interopDefault($3Zour))).func,
    /**
   * Callback fired when the popup requests to be closed.
   * Use in controlled mode (see `open`).
   */ onClose: (0, (/*@__PURE__*/$parcel$interopDefault($3Zour))).func,
    /**
   * Callback fired when the error associated to the current value changes.
   * If the error has a non-null value, then the `TextField` will be rendered in `error` state.
   *
   * @template TValue The value type. Will be either the same type as `value` or `null`. Can be in `[start, end]` format in case of range value.
   * @template TError The validation error type. Will be either `string` or a `null`. Can be in `[start, end]` format in case of range value.
   * @param {TError} error The new error describing why the current value is not valid.
   * @param {TValue} value The value associated to the error.
   */ onError: (0, (/*@__PURE__*/$parcel$interopDefault($3Zour))).func,
    /**
   * Callback fired on month change.
   * @template TDate
   * @param {TDate} month The new month.
   */ onMonthChange: (0, (/*@__PURE__*/$parcel$interopDefault($3Zour))).func,
    /**
   * Callback fired when the popup requests to be opened.
   * Use in controlled mode (see `open`).
   */ onOpen: (0, (/*@__PURE__*/$parcel$interopDefault($3Zour))).func,
    /**
   * Callback fired when the selected sections change.
   * @param {FieldSelectedSections} newValue The new selected sections.
   */ onSelectedSectionsChange: (0, (/*@__PURE__*/$parcel$interopDefault($3Zour))).func,
    /**
   * Callback fired on view change.
   * @template TView
   * @param {TView} view The new view.
   */ onViewChange: (0, (/*@__PURE__*/$parcel$interopDefault($3Zour))).func,
    /**
   * Callback fired on year change.
   * @template TDate
   * @param {TDate} year The new year.
   */ onYearChange: (0, (/*@__PURE__*/$parcel$interopDefault($3Zour))).func,
    /**
   * Control the popup or dialog open state.
   * @default false
   */ open: (0, (/*@__PURE__*/$parcel$interopDefault($3Zour))).bool,
    /**
   * The default visible view.
   * Used when the component view is not controlled.
   * Must be a valid option from `views` list.
   */ openTo: (0, (/*@__PURE__*/$parcel$interopDefault($3Zour))).oneOf([
        'day',
        'month',
        'year'
    ]),
    /**
   * Force rendering in particular orientation.
   */ orientation: (0, (/*@__PURE__*/$parcel$interopDefault($3Zour))).oneOf([
        'landscape',
        'portrait'
    ]),
    readOnly: (0, (/*@__PURE__*/$parcel$interopDefault($3Zour))).bool,
    /**
   * If `true`, disable heavy animations.
   * @default `@media(prefers-reduced-motion: reduce)` || `navigator.userAgent` matches Android <10 or iOS <13
   */ reduceAnimations: (0, (/*@__PURE__*/$parcel$interopDefault($3Zour))).bool,
    /**
   * The date used to generate the new value when both `value` and `defaultValue` are empty.
   * @default The closest valid date-time using the validation props, except callbacks like `shouldDisable<...>`.
   */ referenceDate: (0, (/*@__PURE__*/$parcel$interopDefault($3Zour))).any,
    /**
   * Component displaying when passed `loading` true.
   * @returns {React.ReactNode} The node to render when loading.
   * @default () => <span data-mui-test="loading-progress">...</span>
   */ renderLoading: (0, (/*@__PURE__*/$parcel$interopDefault($3Zour))).func,
    /**
   * The currently selected sections.
   * This prop accept four formats:
   * 1. If a number is provided, the section at this index will be selected.
   * 2. If an object with a `startIndex` and `endIndex` properties are provided, the sections between those two indexes will be selected.
   * 3. If a string of type `FieldSectionType` is provided, the first section with that name will be selected.
   * 4. If `null` is provided, no section will be selected
   * If not provided, the selected sections will be handled internally.
   */ selectedSections: (0, (/*@__PURE__*/$parcel$interopDefault($3Zour))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($3Zour))).oneOf([
            'all',
            'day',
            'hours',
            'meridiem',
            'minutes',
            'month',
            'seconds',
            'weekDay',
            'year'
        ]),
        (0, (/*@__PURE__*/$parcel$interopDefault($3Zour))).number,
        (0, (/*@__PURE__*/$parcel$interopDefault($3Zour))).shape({
            endIndex: (0, (/*@__PURE__*/$parcel$interopDefault($3Zour))).number.isRequired,
            startIndex: (0, (/*@__PURE__*/$parcel$interopDefault($3Zour))).number.isRequired
        })
    ]),
    /**
   * Disable specific date.
   *
   * Warning: This function can be called multiple times (e.g. when rendering date calendar, checking if focus can be moved to a certain date, etc.). Expensive computations can impact performance.
   *
   * @template TDate
   * @param {TDate} day The date to test.
   * @returns {boolean} If `true` the date will be disabled.
   */ shouldDisableDate: (0, (/*@__PURE__*/$parcel$interopDefault($3Zour))).func,
    /**
   * Disable specific month.
   * @template TDate
   * @param {TDate} month The month to test.
   * @returns {boolean} If `true`, the month will be disabled.
   */ shouldDisableMonth: (0, (/*@__PURE__*/$parcel$interopDefault($3Zour))).func,
    /**
   * Disable specific year.
   * @template TDate
   * @param {TDate} year The year to test.
   * @returns {boolean} If `true`, the year will be disabled.
   */ shouldDisableYear: (0, (/*@__PURE__*/$parcel$interopDefault($3Zour))).func,
    /**
   * If `true`, days outside the current month are rendered:
   *
   * - if `fixedWeekNumber` is defined, renders days to have the weeks requested.
   *
   * - if `fixedWeekNumber` is not defined, renders day to fill the first and last week of the current month.
   *
   * - ignored if `calendars` equals more than `1` on range pickers.
   * @default false
   */ showDaysOutsideCurrentMonth: (0, (/*@__PURE__*/$parcel$interopDefault($3Zour))).bool,
    /**
   * The props used for each component slot.
   * @default {}
   */ slotProps: (0, (/*@__PURE__*/$parcel$interopDefault($3Zour))).object,
    /**
   * Overridable component slots.
   * @default {}
   */ slots: (0, (/*@__PURE__*/$parcel$interopDefault($3Zour))).object,
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: (0, (/*@__PURE__*/$parcel$interopDefault($3Zour))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($3Zour))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($3Zour))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($3Zour))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($3Zour))).object,
            (0, (/*@__PURE__*/$parcel$interopDefault($3Zour))).bool
        ])),
        (0, (/*@__PURE__*/$parcel$interopDefault($3Zour))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($3Zour))).object
    ]),
    /**
   * Choose which timezone to use for the value.
   * Example: "default", "system", "UTC", "America/New_York".
   * If you pass values from other timezones to some props, they will be converted to this timezone before being used.
   * @see See the {@link https://mui.com/x/react-date-pickers/timezone/ timezones documention} for more details.
   * @default The timezone of the `value` or `defaultValue` prop is defined, 'default' otherwise.
   */ timezone: (0, (/*@__PURE__*/$parcel$interopDefault($3Zour))).string,
    /**
   * The selected value.
   * Used when the component is controlled.
   */ value: (0, (/*@__PURE__*/$parcel$interopDefault($3Zour))).any,
    /**
   * The visible view.
   * Used when the component view is controlled.
   * Must be a valid option from `views` list.
   */ view: (0, (/*@__PURE__*/$parcel$interopDefault($3Zour))).oneOf([
        'day',
        'month',
        'year'
    ]),
    /**
   * Define custom view renderers for each section.
   * If `null`, the section will only have field editing.
   * If `undefined`, internally defined view will be the used.
   */ viewRenderers: (0, (/*@__PURE__*/$parcel$interopDefault($3Zour))).shape({
        day: (0, (/*@__PURE__*/$parcel$interopDefault($3Zour))).func,
        month: (0, (/*@__PURE__*/$parcel$interopDefault($3Zour))).func,
        year: (0, (/*@__PURE__*/$parcel$interopDefault($3Zour))).func
    }),
    /**
   * Available views.
   */ views: (0, (/*@__PURE__*/$parcel$interopDefault($3Zour))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($3Zour))).oneOf([
        'day',
        'month',
        'year'
    ]).isRequired),
    /**
   * Years rendered per row.
   * @default 3
   */ yearsPerRow: (0, (/*@__PURE__*/$parcel$interopDefault($3Zour))).oneOf([
        3,
        4
    ])
};




var $9wx12 = parcelRequire("9wx12");
const $b1e4eb69ad197794$var$_excluded = [
    "desktopModeMediaQuery"
];
/**
 * Demos:
 *
 * - [DatePicker](https://mui.com/x/react-date-pickers/date-picker/)
 * - [Validation](https://mui.com/x/react-date-pickers/validation/)
 *
 * API:
 *
 * - [DatePicker API](https://mui.com/x/api/date-pickers/date-picker/)
 */ const $b1e4eb69ad197794$export$5109c6dd95d8fb00 = /*#__PURE__*/ $gJYWc.forwardRef(function DatePicker(inProps, ref) {
    const props = (0, $6959428021af84ce$export$2e2bcd8739ae039)({
        props: inProps,
        name: 'MuiDatePicker'
    });
    const { desktopModeMediaQuery: desktopModeMediaQuery = (0, $870e97cd00438bdc$export$9ae5b19305db48ce) } = props, other = (0, $cTAWX.default)(props, $b1e4eb69ad197794$var$_excluded);
    // defaults to `true` in environments where `window.matchMedia` would not be available (i.e. test/jsdom)
    const isDesktop = (0, $94c6dc53e4570cec$export$2e2bcd8739ae039)(desktopModeMediaQuery, {
        defaultMatches: true
    });
    if (isDesktop) return /*#__PURE__*/ (0, $9wx12.jsx)((0, $70786dd07bd3e0bf$export$5a73641f0156e1e4), (0, $3VnFq.default)({
        ref: ref
    }, other));
    return /*#__PURE__*/ (0, $9wx12.jsx)((0, $d51370e6e1baabed$export$97b476d7a92fee62), (0, $3VnFq.default)({
        ref: ref
    }, other));
});



var $3VnFq = parcelRequire("3VnFq");

var $cTAWX = parcelRequire("cTAWX");

var $gJYWc = parcelRequire("gJYWc");





var $3VnFq = parcelRequire("3VnFq");

var $gJYWc = parcelRequire("gJYWc");

var $3Zour = parcelRequire("3Zour");




var $3VnFq = parcelRequire("3VnFq");

var $cTAWX = parcelRequire("cTAWX");

var $gJYWc = parcelRequire("gJYWc");






var $3VnFq = parcelRequire("3VnFq");



const $25036a0b58cac589$export$7bd013ac69eb590c = ({ adapter: adapter, value: value, props: props })=>{
    if (value === null) return null;
    const { minTime: minTime, maxTime: maxTime, minutesStep: minutesStep, shouldDisableClock: shouldDisableClock, shouldDisableTime: shouldDisableTime, disableIgnoringDatePartForTimeValidation: disableIgnoringDatePartForTimeValidation = false, disablePast: disablePast, disableFuture: disableFuture, timezone: timezone } = props;
    const now = adapter.utils.dateWithTimezone(undefined, timezone);
    const isAfter = (0, $ab68d4157b5096ce$export$fb87c80b35a46b89)(disableIgnoringDatePartForTimeValidation, adapter.utils);
    switch(true){
        case !adapter.utils.isValid(value):
            return 'invalidDate';
        case Boolean(minTime && isAfter(minTime, value)):
            return 'minTime';
        case Boolean(maxTime && isAfter(value, maxTime)):
            return 'maxTime';
        case Boolean(disableFuture && adapter.utils.isAfter(value, now)):
            return 'disableFuture';
        case Boolean(disablePast && adapter.utils.isBefore(value, now)):
            return 'disablePast';
        case Boolean(shouldDisableTime && shouldDisableTime(value, 'hours')):
            return 'shouldDisableTime-hours';
        case Boolean(shouldDisableTime && shouldDisableTime(value, 'minutes')):
            return 'shouldDisableTime-minutes';
        case Boolean(shouldDisableTime && shouldDisableTime(value, 'seconds')):
            return 'shouldDisableTime-seconds';
        case Boolean(shouldDisableClock && shouldDisableClock(adapter.utils.getHours(value), 'hours')):
            return 'shouldDisableClock-hours';
        case Boolean(shouldDisableClock && shouldDisableClock(adapter.utils.getMinutes(value), 'minutes')):
            return 'shouldDisableClock-minutes';
        case Boolean(shouldDisableClock && shouldDisableClock(adapter.utils.getSeconds(value), 'seconds')):
            return 'shouldDisableClock-seconds';
        case Boolean(minutesStep && adapter.utils.getMinutes(value) % minutesStep !== 0):
            return 'minutesStep';
        default:
            return null;
    }
};




const $e89237209343ef08$var$useDefaultizedTimeField = (props)=>{
    var _props$ampm, _props$disablePast, _props$disableFuture, _props$format;
    const utils = (0, $98220f21a8625472$export$1163b47e39508a46)();
    const ampm = (_props$ampm = props.ampm) != null ? _props$ampm : utils.is12HourCycleInCurrentLocale();
    const defaultFormat = ampm ? utils.formats.fullTime12h : utils.formats.fullTime24h;
    return (0, $3VnFq.default)({}, props, {
        disablePast: (_props$disablePast = props.disablePast) != null ? _props$disablePast : false,
        disableFuture: (_props$disableFuture = props.disableFuture) != null ? _props$disableFuture : false,
        format: (_props$format = props.format) != null ? _props$format : defaultFormat
    });
};
const $e89237209343ef08$export$4c842f6a241dc825 = ({ props: inProps, inputRef: inputRef })=>{
    const props = $e89237209343ef08$var$useDefaultizedTimeField(inProps);
    const { forwardedProps: forwardedProps, internalProps: internalProps } = (0, $3cac403015a35eb6$export$cdde224d2939fd84)(props, 'time');
    return (0, $5bbb9f44cfbbf3b7$export$294aa081a6c6f55d)({
        inputRef: inputRef,
        forwardedProps: forwardedProps,
        internalProps: internalProps,
        valueManager: (0, $15cde65cbd91c944$export$2764b246aa3b75ba),
        fieldValueManager: (0, $15cde65cbd91c944$export$b602c94f557316b4),
        validator: (0, $25036a0b58cac589$export$7bd013ac69eb590c),
        valueType: 'time'
    });
};




var $9wx12 = parcelRequire("9wx12");
const $7b9f323337367d9e$var$_excluded = [
    "slots",
    "slotProps",
    "components",
    "componentsProps",
    "InputProps",
    "inputProps"
], $7b9f323337367d9e$var$_excluded2 = [
    "inputRef"
], $7b9f323337367d9e$var$_excluded3 = [
    "ref",
    "onPaste",
    "onKeyDown",
    "inputMode",
    "readOnly",
    "clearable",
    "onClear"
];
/**
 * Demos:
 *
 * - [TimeField](http://mui.com/x/react-date-pickers/time-field/)
 * - [Fields](https://mui.com/x/react-date-pickers/fields/)
 *
 * API:
 *
 * - [TimeField API](https://mui.com/x/api/date-pickers/time-field/)
 */ const $7b9f323337367d9e$export$5eaee2322dd727eb = /*#__PURE__*/ $gJYWc.forwardRef(function TimeField(inProps, ref) {
    var _ref, _slots$textField, _slotProps$textField;
    const themeProps = (0, $6959428021af84ce$export$2e2bcd8739ae039)({
        props: inProps,
        name: 'MuiTimeField'
    });
    const { slots: slots, slotProps: slotProps, components: components, componentsProps: componentsProps, InputProps: InputProps, inputProps: inputProps } = themeProps, other = (0, $cTAWX.default)(themeProps, $7b9f323337367d9e$var$_excluded);
    const ownerState = themeProps;
    const TextField = (_ref = (_slots$textField = slots == null ? void 0 : slots.textField) != null ? _slots$textField : components == null ? void 0 : components.TextField) != null ? _ref : (0, $1f9512c77b4eaf9c$export$2e2bcd8739ae039);
    const _useSlotProps = (0, $2082854bb194ebf1$export$2e2bcd8739ae039)({
        elementType: TextField,
        externalSlotProps: (_slotProps$textField = slotProps == null ? void 0 : slotProps.textField) != null ? _slotProps$textField : componentsProps == null ? void 0 : componentsProps.textField,
        externalForwardedProps: other,
        ownerState: ownerState
    }), { inputRef: externalInputRef } = _useSlotProps, textFieldProps = (0, $cTAWX.default)(_useSlotProps, $7b9f323337367d9e$var$_excluded2);
    // TODO: Remove when mui/material-ui#35088 will be merged
    textFieldProps.inputProps = (0, $3VnFq.default)({}, inputProps, textFieldProps.inputProps);
    textFieldProps.InputProps = (0, $3VnFq.default)({}, InputProps, textFieldProps.InputProps);
    const _useTimeField = (0, $e89237209343ef08$export$4c842f6a241dc825)({
        props: textFieldProps,
        inputRef: externalInputRef
    }), { ref: inputRef, onPaste: onPaste, onKeyDown: onKeyDown, inputMode: inputMode, readOnly: readOnly, clearable: clearable, onClear: onClear } = _useTimeField, fieldProps = (0, $cTAWX.default)(_useTimeField, $7b9f323337367d9e$var$_excluded3);
    const { InputProps: ProcessedInputProps, fieldProps: processedFieldProps } = (0, $6ce5f2c03b6ee06a$export$db9644cdb7e3d432)({
        onClear: onClear,
        clearable: clearable,
        fieldProps: fieldProps,
        InputProps: fieldProps.InputProps,
        slots: slots,
        slotProps: slotProps,
        components: components,
        componentsProps: componentsProps
    });
    return /*#__PURE__*/ (0, $9wx12.jsx)(TextField, (0, $3VnFq.default)({
        ref: ref
    }, processedFieldProps, {
        InputProps: (0, $3VnFq.default)({}, ProcessedInputProps, {
            readOnly: readOnly
        }),
        inputProps: (0, $3VnFq.default)({}, fieldProps.inputProps, {
            inputMode: inputMode,
            onPaste: onPaste,
            onKeyDown: onKeyDown,
            ref: inputRef
        })
    }));
});



var $3VnFq = parcelRequire("3VnFq");

var $gJYWc = parcelRequire("gJYWc");



var $cTAWX = parcelRequire("cTAWX");

var $3VnFq = parcelRequire("3VnFq");
parcelRequire("gJYWc");

var $2w6IV = parcelRequire("2w6IV");

var $3Zour = parcelRequire("3Zour");

var $HGmne = parcelRequire("HGmne");

var $3e4LV = parcelRequire("3e4LV");

var $3VnFq = parcelRequire("3VnFq");

var $cTAWX = parcelRequire("cTAWX");

var $gJYWc = parcelRequire("gJYWc");

var $2w6IV = parcelRequire("2w6IV");


var $HGmne = parcelRequire("HGmne");

var $3e4LV = parcelRequire("3e4LV");

var $1kRHf = parcelRequire("1kRHf");
var $i8nzj = parcelRequire("i8nzj");
function $ef3cc3f57e26c91e$export$2aab7addfa1bc589(slot) {
    return (0, $1kRHf.default)('MuiPickersToolbarText', slot);
}
const $ef3cc3f57e26c91e$export$4ca7b92014bf2e56 = (0, $i8nzj.default)('MuiPickersToolbarText', [
    'root',
    'selected'
]);



var $9wx12 = parcelRequire("9wx12");
const $59e7469b3b949ed6$var$_excluded = [
    "className",
    "selected",
    "value"
];
const $59e7469b3b949ed6$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, selected: selected } = ownerState;
    const slots = {
        root: [
            'root',
            selected && 'selected'
        ]
    };
    return (0, $3e4LV.default)(slots, (0, $ef3cc3f57e26c91e$export$2aab7addfa1bc589), classes);
};
const $59e7469b3b949ed6$var$PickersToolbarTextRoot = (0, $HGmne.default)((0, $b4083ea3a052dee9$export$2e2bcd8739ae039), {
    name: 'MuiPickersToolbarText',
    slot: 'Root',
    overridesResolver: (_, styles)=>[
            styles.root,
            {
                [`&.${(0, $ef3cc3f57e26c91e$export$4ca7b92014bf2e56).selected}`]: styles.selected
            }
        ]
})(({ theme: theme })=>({
        transition: theme.transitions.create('color'),
        color: (theme.vars || theme).palette.text.secondary,
        [`&.${(0, $ef3cc3f57e26c91e$export$4ca7b92014bf2e56).selected}`]: {
            color: (theme.vars || theme).palette.text.primary
        }
    }));
const $59e7469b3b949ed6$export$2006bc630443fa2 = /*#__PURE__*/ $gJYWc.forwardRef(function PickersToolbarText(inProps, ref) {
    const props = (0, $6959428021af84ce$export$2e2bcd8739ae039)({
        props: inProps,
        name: 'MuiPickersToolbarText'
    });
    const { className: className, value: value } = props, other = (0, $cTAWX.default)(props, $59e7469b3b949ed6$var$_excluded);
    const classes = $59e7469b3b949ed6$var$useUtilityClasses(props);
    return /*#__PURE__*/ (0, $9wx12.jsx)($59e7469b3b949ed6$var$PickersToolbarTextRoot, (0, $3VnFq.default)({
        ref: ref,
        className: (0, $2w6IV.default)(className, classes.root),
        component: "span"
    }, other, {
        children: value
    }));
});



var $3VnFq = parcelRequire("3VnFq");

var $cTAWX = parcelRequire("cTAWX");

var $gJYWc = parcelRequire("gJYWc");

var $2w6IV = parcelRequire("2w6IV");


var $HGmne = parcelRequire("HGmne");

var $3e4LV = parcelRequire("3e4LV");



var $9wx12 = parcelRequire("9wx12");
const $d77c3ada009b73e4$var$_excluded = [
    "align",
    "className",
    "selected",
    "typographyClassName",
    "value",
    "variant",
    "width"
];
const $d77c3ada009b73e4$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ]
    };
    return (0, $3e4LV.default)(slots, (0, $21ec14a9fd047156$export$b109c489973c3d80), classes);
};
const $d77c3ada009b73e4$var$PickersToolbarButtonRoot = (0, $HGmne.default)((0, $95b3a1ef1ddc1e78$export$2e2bcd8739ae039), {
    name: 'MuiPickersToolbarButton',
    slot: 'Root',
    overridesResolver: (_, styles)=>styles.root
})({
    padding: 0,
    minWidth: 16,
    textTransform: 'none'
});
const $d77c3ada009b73e4$export$614ed940168c780c = /*#__PURE__*/ $gJYWc.forwardRef(function PickersToolbarButton(inProps, ref) {
    const props = (0, $6959428021af84ce$export$2e2bcd8739ae039)({
        props: inProps,
        name: 'MuiPickersToolbarButton'
    });
    const { align: align, className: className, selected: selected, typographyClassName: typographyClassName, value: value, variant: variant, width: width } = props, other = (0, $cTAWX.default)(props, $d77c3ada009b73e4$var$_excluded);
    const classes = $d77c3ada009b73e4$var$useUtilityClasses(props);
    return /*#__PURE__*/ (0, $9wx12.jsx)($d77c3ada009b73e4$var$PickersToolbarButtonRoot, (0, $3VnFq.default)({
        variant: "text",
        ref: ref,
        className: (0, $2w6IV.default)(className, classes.root)
    }, width ? {
        sx: {
            width: width
        }
    } : {}, other, {
        children: /*#__PURE__*/ (0, $9wx12.jsx)((0, $59e7469b3b949ed6$export$2006bc630443fa2), {
            align: align,
            className: typographyClassName,
            variant: variant,
            value: value,
            selected: selected
        })
    }));
});







var $1kRHf = parcelRequire("1kRHf");
var $i8nzj = parcelRequire("i8nzj");
function $ed2b5a8aaa184d6d$export$56e751cdf7deddcb(slot) {
    return (0, $1kRHf.default)('MuiTimePickerToolbar', slot);
}
const $ed2b5a8aaa184d6d$export$b6febfcac6caa550 = (0, $i8nzj.default)('MuiTimePickerToolbar', [
    'root',
    'separator',
    'hourMinuteLabel',
    'hourMinuteLabelLandscape',
    'hourMinuteLabelReverse',
    'ampmSelection',
    'ampmLandscape',
    'ampmLabel'
]);




var $9wx12 = parcelRequire("9wx12");
const $2cb3e3e44e3c5f11$var$_excluded = [
    "ampm",
    "ampmInClock",
    "value",
    "isLandscape",
    "onChange",
    "view",
    "onViewChange",
    "views",
    "disabled",
    "readOnly",
    "className"
];
const $2cb3e3e44e3c5f11$var$useUtilityClasses = (ownerState)=>{
    const { theme: theme, isLandscape: isLandscape, classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ],
        separator: [
            'separator'
        ],
        hourMinuteLabel: [
            'hourMinuteLabel',
            isLandscape && 'hourMinuteLabelLandscape',
            theme.direction === 'rtl' && 'hourMinuteLabelReverse'
        ],
        ampmSelection: [
            'ampmSelection',
            isLandscape && 'ampmLandscape'
        ],
        ampmLabel: [
            'ampmLabel'
        ]
    };
    return (0, $3e4LV.default)(slots, (0, $ed2b5a8aaa184d6d$export$56e751cdf7deddcb), classes);
};
const $2cb3e3e44e3c5f11$var$TimePickerToolbarRoot = (0, $HGmne.default)((0, $a88992c4502f3019$export$eb3c4d84783d6feb), {
    name: 'MuiTimePickerToolbar',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})({});
const $2cb3e3e44e3c5f11$var$TimePickerToolbarSeparator = (0, $HGmne.default)((0, $59e7469b3b949ed6$export$2006bc630443fa2), {
    name: 'MuiTimePickerToolbar',
    slot: 'Separator',
    overridesResolver: (props, styles)=>styles.separator
})({
    outline: 0,
    margin: '0 4px 0 2px',
    cursor: 'default'
});
const $2cb3e3e44e3c5f11$var$TimePickerToolbarHourMinuteLabel = (0, $HGmne.default)('div', {
    name: 'MuiTimePickerToolbar',
    slot: 'HourMinuteLabel',
    overridesResolver: (props, styles)=>[
            {
                [`&.${(0, $ed2b5a8aaa184d6d$export$b6febfcac6caa550).hourMinuteLabelLandscape}`]: styles.hourMinuteLabelLandscape,
                [`&.${(0, $ed2b5a8aaa184d6d$export$b6febfcac6caa550).hourMinuteLabelReverse}`]: styles.hourMinuteLabelReverse
            },
            styles.hourMinuteLabel
        ]
})(({ theme: theme, ownerState: ownerState })=>(0, $3VnFq.default)({
        display: 'flex',
        justifyContent: 'flex-end',
        alignItems: 'flex-end'
    }, ownerState.isLandscape && {
        marginTop: 'auto'
    }, theme.direction === 'rtl' && {
        flexDirection: 'row-reverse'
    }));
$2cb3e3e44e3c5f11$var$TimePickerToolbarHourMinuteLabel.propTypes = {
    // ----------------------------- Warning --------------------------------
    // | These PropTypes are generated from the TypeScript type definitions |
    // | To update them edit the TypeScript types and run "yarn proptypes"  |
    // ----------------------------------------------------------------------
    as: (0, (/*@__PURE__*/$parcel$interopDefault($3Zour))).elementType,
    ownerState: (0, (/*@__PURE__*/$parcel$interopDefault($3Zour))).object.isRequired,
    sx: (0, (/*@__PURE__*/$parcel$interopDefault($3Zour))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($3Zour))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($3Zour))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($3Zour))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($3Zour))).object,
            (0, (/*@__PURE__*/$parcel$interopDefault($3Zour))).bool
        ])),
        (0, (/*@__PURE__*/$parcel$interopDefault($3Zour))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($3Zour))).object
    ])
};
const $2cb3e3e44e3c5f11$var$TimePickerToolbarAmPmSelection = (0, $HGmne.default)('div', {
    name: 'MuiTimePickerToolbar',
    slot: 'AmPmSelection',
    overridesResolver: (props, styles)=>[
            {
                [`.${(0, $ed2b5a8aaa184d6d$export$b6febfcac6caa550).ampmLabel}`]: styles.ampmLabel
            },
            {
                [`&.${(0, $ed2b5a8aaa184d6d$export$b6febfcac6caa550).ampmLandscape}`]: styles.ampmLandscape
            },
            styles.ampmSelection
        ]
})(({ ownerState: ownerState })=>(0, $3VnFq.default)({
        display: 'flex',
        flexDirection: 'column',
        marginRight: 'auto',
        marginLeft: 12
    }, ownerState.isLandscape && {
        margin: '4px 0 auto',
        flexDirection: 'row',
        justifyContent: 'space-around',
        flexBasis: '100%'
    }, {
        [`& .${(0, $ed2b5a8aaa184d6d$export$b6febfcac6caa550).ampmLabel}`]: {
            fontSize: 17
        }
    }));
$2cb3e3e44e3c5f11$var$TimePickerToolbarAmPmSelection.propTypes = {
    // ----------------------------- Warning --------------------------------
    // | These PropTypes are generated from the TypeScript type definitions |
    // | To update them edit the TypeScript types and run "yarn proptypes"  |
    // ----------------------------------------------------------------------
    as: (0, (/*@__PURE__*/$parcel$interopDefault($3Zour))).elementType,
    ownerState: (0, (/*@__PURE__*/$parcel$interopDefault($3Zour))).object.isRequired,
    sx: (0, (/*@__PURE__*/$parcel$interopDefault($3Zour))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($3Zour))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($3Zour))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($3Zour))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($3Zour))).object,
            (0, (/*@__PURE__*/$parcel$interopDefault($3Zour))).bool
        ])),
        (0, (/*@__PURE__*/$parcel$interopDefault($3Zour))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($3Zour))).object
    ])
};
/**
 * Demos:
 *
 * - [TimePicker](https://mui.com/x/react-date-pickers/time-picker/)
 * - [Custom components](https://mui.com/x/react-date-pickers/custom-components/)
 *
 * API:
 *
 * - [TimePickerToolbar API](https://mui.com/x/api/date-pickers/time-picker-toolbar/)
 */ function $2cb3e3e44e3c5f11$export$76f7aa019fd43cd9(inProps) {
    const props = (0, $6959428021af84ce$export$2e2bcd8739ae039)({
        props: inProps,
        name: 'MuiTimePickerToolbar'
    });
    const { ampm: ampm, ampmInClock: ampmInClock, value: value, isLandscape: isLandscape, onChange: onChange, view: view, onViewChange: onViewChange, views: views, disabled: disabled, readOnly: readOnly, className: className } = props, other = (0, $cTAWX.default)(props, $2cb3e3e44e3c5f11$var$_excluded);
    const utils = (0, $98220f21a8625472$export$1163b47e39508a46)();
    const localeText = (0, $98220f21a8625472$export$24fdeaa0f591a73e)();
    const theme = (0, $ae968105fc5c093e$export$2e2bcd8739ae039)();
    const showAmPmControl = Boolean(ampm && !ampmInClock && views.includes('hours'));
    const { meridiemMode: meridiemMode, handleMeridiemChange: handleMeridiemChange } = (0, $9474454c4c9ffb68$export$6aaabc31cb076d17)(value, ampm, onChange);
    const formatHours = (time)=>ampm ? utils.format(time, 'hours12h') : utils.format(time, 'hours24h');
    const ownerState = props;
    const classes = $2cb3e3e44e3c5f11$var$useUtilityClasses((0, $3VnFq.default)({}, ownerState, {
        theme: theme
    }));
    const separator = /*#__PURE__*/ (0, $9wx12.jsx)($2cb3e3e44e3c5f11$var$TimePickerToolbarSeparator, {
        tabIndex: -1,
        value: ":",
        variant: "h3",
        selected: false,
        className: classes.separator
    });
    return /*#__PURE__*/ (0, $9wx12.jsxs)($2cb3e3e44e3c5f11$var$TimePickerToolbarRoot, (0, $3VnFq.default)({
        landscapeDirection: "row",
        toolbarTitle: localeText.timePickerToolbarTitle,
        isLandscape: isLandscape,
        ownerState: ownerState,
        className: (0, $2w6IV.default)(classes.root, className)
    }, other, {
        children: [
            /*#__PURE__*/ (0, $9wx12.jsxs)($2cb3e3e44e3c5f11$var$TimePickerToolbarHourMinuteLabel, {
                className: classes.hourMinuteLabel,
                ownerState: ownerState,
                children: [
                    (0, $870e97cd00438bdc$export$22012a5c726bef55)(views, 'hours') && /*#__PURE__*/ (0, $9wx12.jsx)((0, $d77c3ada009b73e4$export$614ed940168c780c), {
                        tabIndex: -1,
                        variant: "h3",
                        onClick: ()=>onViewChange('hours'),
                        selected: view === 'hours',
                        value: value ? formatHours(value) : '--'
                    }),
                    (0, $870e97cd00438bdc$export$22012a5c726bef55)(views, [
                        'hours',
                        'minutes'
                    ]) && separator,
                    (0, $870e97cd00438bdc$export$22012a5c726bef55)(views, 'minutes') && /*#__PURE__*/ (0, $9wx12.jsx)((0, $d77c3ada009b73e4$export$614ed940168c780c), {
                        tabIndex: -1,
                        variant: "h3",
                        onClick: ()=>onViewChange('minutes'),
                        selected: view === 'minutes',
                        value: value ? utils.format(value, 'minutes') : '--'
                    }),
                    (0, $870e97cd00438bdc$export$22012a5c726bef55)(views, [
                        'minutes',
                        'seconds'
                    ]) && separator,
                    (0, $870e97cd00438bdc$export$22012a5c726bef55)(views, 'seconds') && /*#__PURE__*/ (0, $9wx12.jsx)((0, $d77c3ada009b73e4$export$614ed940168c780c), {
                        variant: "h3",
                        onClick: ()=>onViewChange('seconds'),
                        selected: view === 'seconds',
                        value: value ? utils.format(value, 'seconds') : '--'
                    })
                ]
            }),
            showAmPmControl && /*#__PURE__*/ (0, $9wx12.jsxs)($2cb3e3e44e3c5f11$var$TimePickerToolbarAmPmSelection, {
                className: classes.ampmSelection,
                ownerState: ownerState,
                children: [
                    /*#__PURE__*/ (0, $9wx12.jsx)((0, $d77c3ada009b73e4$export$614ed940168c780c), {
                        disableRipple: true,
                        variant: "subtitle2",
                        selected: meridiemMode === 'am',
                        typographyClassName: classes.ampmLabel,
                        value: (0, $00e6d022b450825d$export$fae94c0a662107ef)(utils, 'am'),
                        onClick: readOnly ? undefined : ()=>handleMeridiemChange('am'),
                        disabled: disabled
                    }),
                    /*#__PURE__*/ (0, $9wx12.jsx)((0, $d77c3ada009b73e4$export$614ed940168c780c), {
                        disableRipple: true,
                        variant: "subtitle2",
                        selected: meridiemMode === 'pm',
                        typographyClassName: classes.ampmLabel,
                        value: (0, $00e6d022b450825d$export$fae94c0a662107ef)(utils, 'pm'),
                        onClick: readOnly ? undefined : ()=>handleMeridiemChange('pm'),
                        disabled: disabled
                    })
                ]
            })
        ]
    }));
}




function $f32fda7ce15f7631$export$586c31b46cc238ba(props, name) {
    var _themeProps$ampm, _themeProps$slots, _themeProps$slotProps, _themeProps$disableFu, _themeProps$disablePa;
    const utils = (0, $98220f21a8625472$export$1163b47e39508a46)();
    const themeProps = (0, $6959428021af84ce$export$2e2bcd8739ae039)({
        props: props,
        name: name
    });
    const ampm = (_themeProps$ampm = themeProps.ampm) != null ? _themeProps$ampm : utils.is12HourCycleInCurrentLocale();
    const localeText = $gJYWc.useMemo(()=>{
        var _themeProps$localeTex;
        if (((_themeProps$localeTex = themeProps.localeText) == null ? void 0 : _themeProps$localeTex.toolbarTitle) == null) return themeProps.localeText;
        return (0, $3VnFq.default)({}, themeProps.localeText, {
            timePickerToolbarTitle: themeProps.localeText.toolbarTitle
        });
    }, [
        themeProps.localeText
    ]);
    const slots = (_themeProps$slots = themeProps.slots) != null ? _themeProps$slots : (0, $d1cac1848baa1211$export$ee17bc394843b249)(themeProps.components);
    const slotProps = (_themeProps$slotProps = themeProps.slotProps) != null ? _themeProps$slotProps : themeProps.componentsProps;
    return (0, $3VnFq.default)({}, themeProps, {
        ampm: ampm,
        localeText: localeText
    }, (0, $fd452c2a61e4326f$export$bdf8d867ddc968e)({
        views: themeProps.views,
        openTo: themeProps.openTo,
        defaultViews: [
            'hours',
            'minutes'
        ],
        defaultOpenTo: 'hours'
    }), {
        disableFuture: (_themeProps$disableFu = themeProps.disableFuture) != null ? _themeProps$disableFu : false,
        disablePast: (_themeProps$disablePa = themeProps.disablePast) != null ? _themeProps$disablePa : false,
        slots: (0, $3VnFq.default)({
            toolbar: (0, $2cb3e3e44e3c5f11$export$76f7aa019fd43cd9)
        }, slots),
        slotProps: (0, $3VnFq.default)({}, slotProps, {
            toolbar: (0, $3VnFq.default)({
                ampm: ampm,
                ampmInClock: themeProps.ampmInClock
            }, slotProps == null ? void 0 : slotProps.toolbar)
        })
    });
}







parcelRequire("gJYWc");

var $3VnFq = parcelRequire("3VnFq");

var $cTAWX = parcelRequire("cTAWX");

var $gJYWc = parcelRequire("gJYWc");

var $2w6IV = parcelRequire("2w6IV");


var $HGmne = parcelRequire("HGmne");

var $3e4LV = parcelRequire("3e4LV");







var $1kRHf = parcelRequire("1kRHf");
var $i8nzj = parcelRequire("i8nzj");
function $4688d9831b8ae1a9$export$148b188041a720e4(slot) {
    return (0, $1kRHf.default)('MuiTimeClock', slot);
}
const $4688d9831b8ae1a9$export$191dec874db3257b = (0, $i8nzj.default)('MuiTimeClock', [
    'root',
    'arrowSwitcher'
]);



var $3VnFq = parcelRequire("3VnFq");

var $gJYWc = parcelRequire("gJYWc");

var $2w6IV = parcelRequire("2w6IV");

var $17CRd = parcelRequire("17CRd");


var $HGmne = parcelRequire("HGmne");

var $3e4LV = parcelRequire("3e4LV");
var $4z2O6 = parcelRequire("4z2O6");

var $cTAWX = parcelRequire("cTAWX");

var $3VnFq = parcelRequire("3VnFq");

var $gJYWc = parcelRequire("gJYWc");

var $2w6IV = parcelRequire("2w6IV");

var $HGmne = parcelRequire("HGmne");

var $3e4LV = parcelRequire("3e4LV");
const $5c20a416de6186be$export$8c8ec20d3854d7e6 = 220;
const $5c20a416de6186be$export$729c0e543e4dc21d = 36;
const $5c20a416de6186be$var$clockCenter = {
    x: $5c20a416de6186be$export$8c8ec20d3854d7e6 / 2,
    y: $5c20a416de6186be$export$8c8ec20d3854d7e6 / 2
};
const $5c20a416de6186be$var$baseClockPoint = {
    x: $5c20a416de6186be$var$clockCenter.x,
    y: 0
};
const $5c20a416de6186be$var$cx = $5c20a416de6186be$var$baseClockPoint.x - $5c20a416de6186be$var$clockCenter.x;
const $5c20a416de6186be$var$cy = $5c20a416de6186be$var$baseClockPoint.y - $5c20a416de6186be$var$clockCenter.y;
const $5c20a416de6186be$var$rad2deg = (rad)=>rad * (180 / Math.PI);
const $5c20a416de6186be$var$getAngleValue = (step, offsetX, offsetY)=>{
    const x = offsetX - $5c20a416de6186be$var$clockCenter.x;
    const y = offsetY - $5c20a416de6186be$var$clockCenter.y;
    const atan = Math.atan2($5c20a416de6186be$var$cx, $5c20a416de6186be$var$cy) - Math.atan2(x, y);
    let deg = $5c20a416de6186be$var$rad2deg(atan);
    deg = Math.round(deg / step) * step;
    deg %= 360;
    const value = Math.floor(deg / step) || 0;
    const delta = x ** 2 + y ** 2;
    const distance = Math.sqrt(delta);
    return {
        value: value,
        distance: distance
    };
};
const $5c20a416de6186be$export$b7f1bc3ea3ac4145 = (offsetX, offsetY, step = 1)=>{
    const angleStep = step * 6;
    let { value: value } = $5c20a416de6186be$var$getAngleValue(angleStep, offsetX, offsetY);
    value = value * step % 60;
    return value;
};
const $5c20a416de6186be$export$257b40f71c07d58f = (offsetX, offsetY, ampm)=>{
    const { value: value, distance: distance } = $5c20a416de6186be$var$getAngleValue(30, offsetX, offsetY);
    let hour = value || 12;
    if (!ampm) {
        if (distance < $5c20a416de6186be$export$8c8ec20d3854d7e6 / 2 - $5c20a416de6186be$export$729c0e543e4dc21d) {
            hour += 12;
            hour %= 24;
        }
    } else hour %= 12;
    return hour;
};



var $1kRHf = parcelRequire("1kRHf");
var $i8nzj = parcelRequire("i8nzj");
function $8098913f1150d34c$export$12faa62796978e2f(slot) {
    return (0, $1kRHf.default)('MuiClockPointer', slot);
}
const $8098913f1150d34c$export$64afeec9352615cb = (0, $i8nzj.default)('MuiClockPointer', [
    'root',
    'thumb'
]);



var $9wx12 = parcelRequire("9wx12");
const $573b703a94af2ceb$var$_excluded = [
    "className",
    "hasSelected",
    "isInner",
    "type",
    "viewValue"
];
const $573b703a94af2ceb$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ],
        thumb: [
            'thumb'
        ]
    };
    return (0, $3e4LV.default)(slots, (0, $8098913f1150d34c$export$12faa62796978e2f), classes);
};
const $573b703a94af2ceb$var$ClockPointerRoot = (0, $HGmne.default)('div', {
    name: 'MuiClockPointer',
    slot: 'Root',
    overridesResolver: (_, styles)=>styles.root
})(({ theme: theme, ownerState: ownerState })=>(0, $3VnFq.default)({
        width: 2,
        backgroundColor: (theme.vars || theme).palette.primary.main,
        position: 'absolute',
        left: 'calc(50% - 1px)',
        bottom: '50%',
        transformOrigin: 'center bottom 0px'
    }, ownerState.shouldAnimate && {
        transition: theme.transitions.create([
            'transform',
            'height'
        ])
    }));
const $573b703a94af2ceb$var$ClockPointerThumb = (0, $HGmne.default)('div', {
    name: 'MuiClockPointer',
    slot: 'Thumb',
    overridesResolver: (_, styles)=>styles.thumb
})(({ theme: theme, ownerState: ownerState })=>(0, $3VnFq.default)({
        width: 4,
        height: 4,
        backgroundColor: (theme.vars || theme).palette.primary.contrastText,
        borderRadius: '50%',
        position: 'absolute',
        top: -21,
        left: `calc(50% - ${(0, $5c20a416de6186be$export$729c0e543e4dc21d) / 2}px)`,
        border: `${((0, $5c20a416de6186be$export$729c0e543e4dc21d) - 4) / 2}px solid ${(theme.vars || theme).palette.primary.main}`,
        boxSizing: 'content-box'
    }, ownerState.hasSelected && {
        backgroundColor: (theme.vars || theme).palette.primary.main
    }));
function $573b703a94af2ceb$export$f257f213e6c08f97(inProps) {
    const props = (0, $6959428021af84ce$export$2e2bcd8739ae039)({
        props: inProps,
        name: 'MuiClockPointer'
    });
    const { className: className, isInner: isInner, type: type, viewValue: viewValue } = props, other = (0, $cTAWX.default)(props, $573b703a94af2ceb$var$_excluded);
    const previousType = $gJYWc.useRef(type);
    $gJYWc.useEffect(()=>{
        previousType.current = type;
    }, [
        type
    ]);
    const ownerState = (0, $3VnFq.default)({}, props, {
        shouldAnimate: previousType.current !== type
    });
    const classes = $573b703a94af2ceb$var$useUtilityClasses(ownerState);
    const getAngleStyle = ()=>{
        const max = type === 'hours' ? 12 : 60;
        let angle = 360 / max * viewValue;
        if (type === 'hours' && viewValue > 12) angle -= 360; // round up angle to max 360 degrees
        return {
            height: Math.round((isInner ? 0.26 : 0.4) * (0, $5c20a416de6186be$export$8c8ec20d3854d7e6)),
            transform: `rotateZ(${angle}deg)`
        };
    };
    return /*#__PURE__*/ (0, $9wx12.jsx)($573b703a94af2ceb$var$ClockPointerRoot, (0, $3VnFq.default)({
        style: getAngleStyle(),
        className: (0, $2w6IV.default)(className, classes.root),
        ownerState: ownerState
    }, other, {
        children: /*#__PURE__*/ (0, $9wx12.jsx)($573b703a94af2ceb$var$ClockPointerThumb, {
            ownerState: ownerState,
            className: classes.thumb
        })
    }));
}





var $1kRHf = parcelRequire("1kRHf");
var $i8nzj = parcelRequire("i8nzj");
function $8f4e9a8dab470860$export$e44ecab24167799b(slot) {
    return (0, $1kRHf.default)('MuiClock', slot);
}
const $8f4e9a8dab470860$export$4626e3a61e161c64 = (0, $i8nzj.default)('MuiClock', [
    'root',
    'clock',
    'wrapper',
    'squareMask',
    'pin',
    'amButton',
    'pmButton',
    'meridiemText'
]);




var $9wx12 = parcelRequire("9wx12");
const $396fded592c832a3$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ],
        clock: [
            'clock'
        ],
        wrapper: [
            'wrapper'
        ],
        squareMask: [
            'squareMask'
        ],
        pin: [
            'pin'
        ],
        amButton: [
            'amButton'
        ],
        pmButton: [
            'pmButton'
        ],
        meridiemText: [
            'meridiemText'
        ]
    };
    return (0, $3e4LV.default)(slots, (0, $8f4e9a8dab470860$export$e44ecab24167799b), classes);
};
const $396fded592c832a3$var$ClockRoot = (0, $HGmne.default)('div', {
    name: 'MuiClock',
    slot: 'Root',
    overridesResolver: (_, styles)=>styles.root
})(({ theme: theme })=>({
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        margin: theme.spacing(2)
    }));
const $396fded592c832a3$var$ClockClock = (0, $HGmne.default)('div', {
    name: 'MuiClock',
    slot: 'Clock',
    overridesResolver: (_, styles)=>styles.clock
})({
    backgroundColor: 'rgba(0,0,0,.07)',
    borderRadius: '50%',
    height: 220,
    width: 220,
    flexShrink: 0,
    position: 'relative',
    pointerEvents: 'none'
});
const $396fded592c832a3$var$ClockWrapper = (0, $HGmne.default)('div', {
    name: 'MuiClock',
    slot: 'Wrapper',
    overridesResolver: (_, styles)=>styles.wrapper
})({
    '&:focus': {
        outline: 'none'
    }
});
const $396fded592c832a3$var$ClockSquareMask = (0, $HGmne.default)('div', {
    name: 'MuiClock',
    slot: 'SquareMask',
    overridesResolver: (_, styles)=>styles.squareMask
})(({ ownerState: ownerState })=>(0, $3VnFq.default)({
        width: '100%',
        height: '100%',
        position: 'absolute',
        pointerEvents: 'auto',
        outline: 0,
        // Disable scroll capabilities.
        touchAction: 'none',
        userSelect: 'none'
    }, ownerState.disabled ? {} : {
        '@media (pointer: fine)': {
            cursor: 'pointer',
            borderRadius: '50%'
        },
        '&:active': {
            cursor: 'move'
        }
    }));
const $396fded592c832a3$var$ClockPin = (0, $HGmne.default)('div', {
    name: 'MuiClock',
    slot: 'Pin',
    overridesResolver: (_, styles)=>styles.pin
})(({ theme: theme })=>({
        width: 6,
        height: 6,
        borderRadius: '50%',
        backgroundColor: (theme.vars || theme).palette.primary.main,
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)'
    }));
const $396fded592c832a3$var$ClockAmButton = (0, $HGmne.default)((0, $17CRd.default), {
    name: 'MuiClock',
    slot: 'AmButton',
    overridesResolver: (_, styles)=>styles.amButton
})(({ theme: theme, ownerState: ownerState })=>(0, $3VnFq.default)({
        zIndex: 1,
        position: 'absolute',
        bottom: 8,
        left: 8,
        paddingLeft: 4,
        paddingRight: 4,
        width: (0, $5c20a416de6186be$export$729c0e543e4dc21d)
    }, ownerState.meridiemMode === 'am' && {
        backgroundColor: (theme.vars || theme).palette.primary.main,
        color: (theme.vars || theme).palette.primary.contrastText,
        '&:hover': {
            backgroundColor: (theme.vars || theme).palette.primary.light
        }
    }));
const $396fded592c832a3$var$ClockPmButton = (0, $HGmne.default)((0, $17CRd.default), {
    name: 'MuiClock',
    slot: 'PmButton',
    overridesResolver: (_, styles)=>styles.pmButton
})(({ theme: theme, ownerState: ownerState })=>(0, $3VnFq.default)({
        zIndex: 1,
        position: 'absolute',
        bottom: 8,
        right: 8,
        paddingLeft: 4,
        paddingRight: 4,
        width: (0, $5c20a416de6186be$export$729c0e543e4dc21d)
    }, ownerState.meridiemMode === 'pm' && {
        backgroundColor: (theme.vars || theme).palette.primary.main,
        color: (theme.vars || theme).palette.primary.contrastText,
        '&:hover': {
            backgroundColor: (theme.vars || theme).palette.primary.light
        }
    }));
const $396fded592c832a3$var$ClockMeridiemText = (0, $HGmne.default)((0, $b4083ea3a052dee9$export$2e2bcd8739ae039), {
    name: 'MuiClock',
    slot: 'meridiemText',
    overridesResolver: (_, styles)=>styles.meridiemText
})({
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis'
});
function $396fded592c832a3$export$9735c82c4bae3302(inProps) {
    const props = (0, $6959428021af84ce$export$2e2bcd8739ae039)({
        props: inProps,
        name: 'MuiClock'
    });
    const { ampm: ampm, ampmInClock: ampmInClock, autoFocus: autoFocus, children: children, value: value, handleMeridiemChange: handleMeridiemChange, isTimeDisabled: isTimeDisabled, meridiemMode: meridiemMode, minutesStep: minutesStep = 1, onChange: onChange, selectedId: selectedId, type: type, viewValue: viewValue, disabled: disabled, readOnly: readOnly, className: className } = props;
    const ownerState = props;
    const utils = (0, $98220f21a8625472$export$1163b47e39508a46)();
    const localeText = (0, $98220f21a8625472$export$24fdeaa0f591a73e)();
    const isMoving = $gJYWc.useRef(false);
    const classes = $396fded592c832a3$var$useUtilityClasses(ownerState);
    const isSelectedTimeDisabled = isTimeDisabled(viewValue, type);
    const isPointerInner = !ampm && type === 'hours' && (viewValue < 1 || viewValue > 12);
    const handleValueChange = (newValue, isFinish)=>{
        if (disabled || readOnly) return;
        if (isTimeDisabled(newValue, type)) return;
        onChange(newValue, isFinish);
    };
    const setTime = (event, isFinish)=>{
        let { offsetX: offsetX, offsetY: offsetY } = event;
        if (offsetX === undefined) {
            const rect = event.target.getBoundingClientRect();
            offsetX = event.changedTouches[0].clientX - rect.left;
            offsetY = event.changedTouches[0].clientY - rect.top;
        }
        const newSelectedValue = type === 'seconds' || type === 'minutes' ? (0, $5c20a416de6186be$export$b7f1bc3ea3ac4145)(offsetX, offsetY, minutesStep) : (0, $5c20a416de6186be$export$257b40f71c07d58f)(offsetX, offsetY, Boolean(ampm));
        handleValueChange(newSelectedValue, isFinish);
    };
    const handleTouchMove = (event)=>{
        isMoving.current = true;
        setTime(event, 'shallow');
    };
    const handleTouchEnd = (event)=>{
        if (isMoving.current) {
            setTime(event, 'finish');
            isMoving.current = false;
        }
    };
    const handleMouseMove = (event)=>{
        // event.buttons & PRIMARY_MOUSE_BUTTON
        if (event.buttons > 0) setTime(event.nativeEvent, 'shallow');
    };
    const handleMouseUp = (event)=>{
        if (isMoving.current) isMoving.current = false;
        setTime(event.nativeEvent, 'finish');
    };
    const hasSelected = $gJYWc.useMemo(()=>{
        if (type === 'hours') return true;
        return viewValue % 5 === 0;
    }, [
        type,
        viewValue
    ]);
    const keyboardControlStep = type === 'minutes' ? minutesStep : 1;
    const listboxRef = $gJYWc.useRef(null);
    // Since this is rendered when a Popper is opened we can't use passive effects.
    // Focusing in passive effects in Popper causes scroll jump.
    (0, $4z2O6.default)(()=>{
        if (autoFocus) // The ref not being resolved would be a bug in MUI.
        listboxRef.current.focus();
    }, [
        autoFocus
    ]);
    const handleKeyDown = (event)=>{
        // TODO: Why this early exit?
        if (isMoving.current) return;
        switch(event.key){
            case 'Home':
                // annulate both hours and minutes
                handleValueChange(0, 'partial');
                event.preventDefault();
                break;
            case 'End':
                handleValueChange(type === 'minutes' ? 59 : 23, 'partial');
                event.preventDefault();
                break;
            case 'ArrowUp':
                handleValueChange(viewValue + keyboardControlStep, 'partial');
                event.preventDefault();
                break;
            case 'ArrowDown':
                handleValueChange(viewValue - keyboardControlStep, 'partial');
                event.preventDefault();
                break;
            default:
        }
    };
    return /*#__PURE__*/ (0, $9wx12.jsxs)($396fded592c832a3$var$ClockRoot, {
        className: (0, $2w6IV.default)(className, classes.root),
        children: [
            /*#__PURE__*/ (0, $9wx12.jsxs)($396fded592c832a3$var$ClockClock, {
                className: classes.clock,
                children: [
                    /*#__PURE__*/ (0, $9wx12.jsx)($396fded592c832a3$var$ClockSquareMask, {
                        onTouchMove: handleTouchMove,
                        onTouchEnd: handleTouchEnd,
                        onMouseUp: handleMouseUp,
                        onMouseMove: handleMouseMove,
                        ownerState: {
                            disabled: disabled
                        },
                        className: classes.squareMask
                    }),
                    !isSelectedTimeDisabled && /*#__PURE__*/ (0, $9wx12.jsxs)($gJYWc.Fragment, {
                        children: [
                            /*#__PURE__*/ (0, $9wx12.jsx)($396fded592c832a3$var$ClockPin, {
                                className: classes.pin
                            }),
                            value != null && /*#__PURE__*/ (0, $9wx12.jsx)((0, $573b703a94af2ceb$export$f257f213e6c08f97), {
                                type: type,
                                viewValue: viewValue,
                                isInner: isPointerInner,
                                hasSelected: hasSelected
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $9wx12.jsx)($396fded592c832a3$var$ClockWrapper, {
                        "aria-activedescendant": selectedId,
                        "aria-label": localeText.clockLabelText(type, value, utils),
                        ref: listboxRef,
                        role: "listbox",
                        onKeyDown: handleKeyDown,
                        tabIndex: 0,
                        className: classes.wrapper,
                        children: children
                    })
                ]
            }),
            ampm && ampmInClock && /*#__PURE__*/ (0, $9wx12.jsxs)($gJYWc.Fragment, {
                children: [
                    /*#__PURE__*/ (0, $9wx12.jsx)($396fded592c832a3$var$ClockAmButton, {
                        onClick: readOnly ? undefined : ()=>handleMeridiemChange('am'),
                        disabled: disabled || meridiemMode === null,
                        ownerState: ownerState,
                        className: classes.amButton,
                        title: (0, $00e6d022b450825d$export$fae94c0a662107ef)(utils, 'am'),
                        children: /*#__PURE__*/ (0, $9wx12.jsx)($396fded592c832a3$var$ClockMeridiemText, {
                            variant: "caption",
                            className: classes.meridiemText,
                            children: (0, $00e6d022b450825d$export$fae94c0a662107ef)(utils, 'am')
                        })
                    }),
                    /*#__PURE__*/ (0, $9wx12.jsx)($396fded592c832a3$var$ClockPmButton, {
                        disabled: disabled || meridiemMode === null,
                        onClick: readOnly ? undefined : ()=>handleMeridiemChange('pm'),
                        ownerState: ownerState,
                        className: classes.pmButton,
                        title: (0, $00e6d022b450825d$export$fae94c0a662107ef)(utils, 'pm'),
                        children: /*#__PURE__*/ (0, $9wx12.jsx)($396fded592c832a3$var$ClockMeridiemText, {
                            variant: "caption",
                            className: classes.meridiemText,
                            children: (0, $00e6d022b450825d$export$fae94c0a662107ef)(utils, 'pm')
                        })
                    })
                ]
            })
        ]
    });
}


parcelRequire("gJYWc");

var $cTAWX = parcelRequire("cTAWX");

var $3VnFq = parcelRequire("3VnFq");
parcelRequire("gJYWc");

var $2w6IV = parcelRequire("2w6IV");

var $HGmne = parcelRequire("HGmne");

var $3e4LV = parcelRequire("3e4LV");


var $1kRHf = parcelRequire("1kRHf");
var $i8nzj = parcelRequire("i8nzj");
function $ce3ba915690dbbcb$export$527226d166658911(slot) {
    return (0, $1kRHf.default)('MuiClockNumber', slot);
}
const $ce3ba915690dbbcb$export$c8efb3a779c9844a = (0, $i8nzj.default)('MuiClockNumber', [
    'root',
    'selected',
    'disabled'
]);



var $9wx12 = parcelRequire("9wx12");
const $9b141ff0bcccfb94$var$_excluded = [
    "className",
    "disabled",
    "index",
    "inner",
    "label",
    "selected"
];
const $9b141ff0bcccfb94$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, selected: selected, disabled: disabled } = ownerState;
    const slots = {
        root: [
            'root',
            selected && 'selected',
            disabled && 'disabled'
        ]
    };
    return (0, $3e4LV.default)(slots, (0, $ce3ba915690dbbcb$export$527226d166658911), classes);
};
const $9b141ff0bcccfb94$var$ClockNumberRoot = (0, $HGmne.default)('span', {
    name: 'MuiClockNumber',
    slot: 'Root',
    overridesResolver: (_, styles)=>[
            styles.root,
            {
                [`&.${(0, $ce3ba915690dbbcb$export$c8efb3a779c9844a).disabled}`]: styles.disabled
            },
            {
                [`&.${(0, $ce3ba915690dbbcb$export$c8efb3a779c9844a).selected}`]: styles.selected
            }
        ]
})(({ theme: theme, ownerState: ownerState })=>(0, $3VnFq.default)({
        height: (0, $5c20a416de6186be$export$729c0e543e4dc21d),
        width: (0, $5c20a416de6186be$export$729c0e543e4dc21d),
        position: 'absolute',
        left: `calc((100% - ${(0, $5c20a416de6186be$export$729c0e543e4dc21d)}px) / 2)`,
        display: 'inline-flex',
        justifyContent: 'center',
        alignItems: 'center',
        borderRadius: '50%',
        color: (theme.vars || theme).palette.text.primary,
        fontFamily: theme.typography.fontFamily,
        '&:focused': {
            backgroundColor: (theme.vars || theme).palette.background.paper
        },
        [`&.${(0, $ce3ba915690dbbcb$export$c8efb3a779c9844a).selected}`]: {
            color: (theme.vars || theme).palette.primary.contrastText
        },
        [`&.${(0, $ce3ba915690dbbcb$export$c8efb3a779c9844a).disabled}`]: {
            pointerEvents: 'none',
            color: (theme.vars || theme).palette.text.disabled
        }
    }, ownerState.inner && (0, $3VnFq.default)({}, theme.typography.body2, {
        color: (theme.vars || theme).palette.text.secondary
    })));
function $9b141ff0bcccfb94$export$6d5c4c748c9cc92c(inProps) {
    const props = (0, $6959428021af84ce$export$2e2bcd8739ae039)({
        props: inProps,
        name: 'MuiClockNumber'
    });
    const { className: className, disabled: disabled, index: index, inner: inner, label: label, selected: selected } = props, other = (0, $cTAWX.default)(props, $9b141ff0bcccfb94$var$_excluded);
    const ownerState = props;
    const classes = $9b141ff0bcccfb94$var$useUtilityClasses(ownerState);
    const angle = index % 12 / 12 * Math.PI * 2 - Math.PI / 2;
    const length = ((0, $5c20a416de6186be$export$8c8ec20d3854d7e6) - (0, $5c20a416de6186be$export$729c0e543e4dc21d) - 2) / 2 * (inner ? 0.65 : 1);
    const x = Math.round(Math.cos(angle) * length);
    const y = Math.round(Math.sin(angle) * length);
    return /*#__PURE__*/ (0, $9wx12.jsx)($9b141ff0bcccfb94$var$ClockNumberRoot, (0, $3VnFq.default)({
        className: (0, $2w6IV.default)(className, classes.root),
        "aria-disabled": disabled ? true : undefined,
        "aria-selected": selected ? true : undefined,
        role: "option",
        style: {
            transform: `translate(${x}px, ${y + ((0, $5c20a416de6186be$export$8c8ec20d3854d7e6) - (0, $5c20a416de6186be$export$729c0e543e4dc21d)) / 2}px`
        },
        ownerState: ownerState
    }, other, {
        children: label
    }));
}



var $9wx12 = parcelRequire("9wx12");
const $1265a879f45f234d$export$10850582eda9a8c7 = ({ ampm: ampm, value: value, getClockNumberText: getClockNumberText, isDisabled: isDisabled, selectedId: selectedId, utils: utils })=>{
    const currentHours = value ? utils.getHours(value) : null;
    const hourNumbers = [];
    const startHour = ampm ? 1 : 0;
    const endHour = ampm ? 12 : 23;
    const isSelected = (hour)=>{
        if (currentHours === null) return false;
        if (ampm) {
            if (hour === 12) return currentHours === 12 || currentHours === 0;
            return currentHours === hour || currentHours - 12 === hour;
        }
        return currentHours === hour;
    };
    for(let hour = startHour; hour <= endHour; hour += 1){
        let label = hour.toString();
        if (hour === 0) label = '00';
        const inner = !ampm && (hour === 0 || hour > 12);
        label = utils.formatNumber(label);
        const selected = isSelected(hour);
        hourNumbers.push(/*#__PURE__*/ (0, $9wx12.jsx)((0, $9b141ff0bcccfb94$export$6d5c4c748c9cc92c), {
            id: selected ? selectedId : undefined,
            index: hour,
            inner: inner,
            selected: selected,
            disabled: isDisabled(hour),
            label: label,
            "aria-label": getClockNumberText(label)
        }, hour));
    }
    return hourNumbers;
};
const $1265a879f45f234d$export$2c440057d7a731e4 = ({ utils: utils, value: value, isDisabled: isDisabled, getClockNumberText: getClockNumberText, selectedId: selectedId })=>{
    const f = utils.formatNumber;
    return [
        [
            5,
            f('05')
        ],
        [
            10,
            f('10')
        ],
        [
            15,
            f('15')
        ],
        [
            20,
            f('20')
        ],
        [
            25,
            f('25')
        ],
        [
            30,
            f('30')
        ],
        [
            35,
            f('35')
        ],
        [
            40,
            f('40')
        ],
        [
            45,
            f('45')
        ],
        [
            50,
            f('50')
        ],
        [
            55,
            f('55')
        ],
        [
            0,
            f('00')
        ]
    ].map(([numberValue, label], index)=>{
        const selected = numberValue === value;
        return /*#__PURE__*/ (0, $9wx12.jsx)((0, $9b141ff0bcccfb94$export$6d5c4c748c9cc92c), {
            label: label,
            id: selected ? selectedId : undefined,
            index: index + 1,
            inner: false,
            disabled: isDisabled(numberValue),
            selected: selected,
            "aria-label": getClockNumberText(label)
        }, numberValue);
    });
};






var $gJYWc = parcelRequire("gJYWc");



const $be0be177042d0203$export$86ee3b7a301faaa3 = ({ value: value, referenceDate: referenceDateProp, utils: utils, props: props, timezone: timezone })=>{
    const referenceDate = $gJYWc.useMemo(()=>(0, $15cde65cbd91c944$export$2764b246aa3b75ba).getInitialReferenceValue({
            value: value,
            utils: utils,
            props: props,
            referenceDate: referenceDateProp,
            granularity: (0, $d8b7b2aeaa0755b4$export$8f74e8f4ed8ae0ac).day,
            timezone: timezone,
            getTodayDate: ()=>(0, $00e6d022b450825d$export$1118e4272ea1e258)(utils, timezone, 'date')
        }), // We only want to compute the reference date on mount.
    [] // eslint-disable-line react-hooks/exhaustive-deps
    );
    return value != null ? value : referenceDate;
};



var $9wx12 = parcelRequire("9wx12");
const $4318aa45ff6b0af3$var$_excluded = [
    "ampm",
    "ampmInClock",
    "autoFocus",
    "components",
    "componentsProps",
    "slots",
    "slotProps",
    "value",
    "defaultValue",
    "referenceDate",
    "disableIgnoringDatePartForTimeValidation",
    "maxTime",
    "minTime",
    "disableFuture",
    "disablePast",
    "minutesStep",
    "shouldDisableClock",
    "shouldDisableTime",
    "showViewSwitcher",
    "onChange",
    "view",
    "views",
    "openTo",
    "onViewChange",
    "focusedView",
    "onFocusedViewChange",
    "className",
    "disabled",
    "readOnly",
    "timezone"
];
const $4318aa45ff6b0af3$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ],
        arrowSwitcher: [
            'arrowSwitcher'
        ]
    };
    return (0, $3e4LV.default)(slots, (0, $4688d9831b8ae1a9$export$148b188041a720e4), classes);
};
const $4318aa45ff6b0af3$var$TimeClockRoot = (0, $HGmne.default)((0, $b034d353ecc5f692$export$512b066b8abdfde4), {
    name: 'MuiTimeClock',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})({
    display: 'flex',
    flexDirection: 'column',
    position: 'relative'
});
const $4318aa45ff6b0af3$var$TimeClockArrowSwitcher = (0, $HGmne.default)((0, $27a06ee7c6118b43$export$597b7cbdb7b2a24c), {
    name: 'MuiTimeClock',
    slot: 'ArrowSwitcher',
    overridesResolver: (props, styles)=>styles.arrowSwitcher
})({
    position: 'absolute',
    right: 12,
    top: 15
});
const $4318aa45ff6b0af3$var$TIME_CLOCK_DEFAULT_VIEWS = [
    'hours',
    'minutes'
];
const $4318aa45ff6b0af3$export$7e96244e18c4be57 = /*#__PURE__*/ $gJYWc.forwardRef(function TimeClock(inProps, ref) {
    const utils = (0, $98220f21a8625472$export$1163b47e39508a46)();
    const props = (0, $6959428021af84ce$export$2e2bcd8739ae039)({
        props: inProps,
        name: 'MuiTimeClock'
    });
    const { ampm: ampm = utils.is12HourCycleInCurrentLocale(), ampmInClock: ampmInClock = false, autoFocus: autoFocus, components: components, componentsProps: componentsProps, slots: innerSlots, slotProps: innerSlotProps, value: valueProp, defaultValue: defaultValue, referenceDate: referenceDateProp, disableIgnoringDatePartForTimeValidation: disableIgnoringDatePartForTimeValidation = false, maxTime: maxTime, minTime: minTime, disableFuture: disableFuture, disablePast: disablePast, minutesStep: minutesStep = 1, shouldDisableClock: shouldDisableClock, shouldDisableTime: shouldDisableTime, showViewSwitcher: showViewSwitcher, onChange: onChange, view: inView, views: views = $4318aa45ff6b0af3$var$TIME_CLOCK_DEFAULT_VIEWS, openTo: openTo, onViewChange: onViewChange, focusedView: focusedView, onFocusedViewChange: onFocusedViewChange, className: className, disabled: disabled, readOnly: readOnly, timezone: timezoneProp } = props, other = (0, $cTAWX.default)(props, $4318aa45ff6b0af3$var$_excluded);
    const slots = innerSlots != null ? innerSlots : (0, $d1cac1848baa1211$export$ee17bc394843b249)(components);
    const slotProps = innerSlotProps != null ? innerSlotProps : componentsProps;
    const { value: value, handleValueChange: handleValueChange, timezone: timezone } = (0, $666e75003bf5e8d6$export$174d749f3b4c0f49)({
        name: 'TimeClock',
        timezone: timezoneProp,
        value: valueProp,
        defaultValue: defaultValue,
        onChange: onChange,
        valueManager: (0, $15cde65cbd91c944$export$2764b246aa3b75ba)
    });
    const valueOrReferenceDate = (0, $be0be177042d0203$export$86ee3b7a301faaa3)({
        value: value,
        referenceDate: referenceDateProp,
        utils: utils,
        props: props,
        timezone: timezone
    });
    const localeText = (0, $98220f21a8625472$export$24fdeaa0f591a73e)();
    const now = (0, $98220f21a8625472$export$3a404aece3dff2fa)(timezone);
    const { view: view, setView: setView, previousView: previousView, nextView: nextView, setValueAndGoToNextView: setValueAndGoToNextView } = (0, $d3a5b60d8c1fb6e1$export$9b46cba8f8ccd954)({
        view: inView,
        views: views,
        openTo: openTo,
        onViewChange: onViewChange,
        onChange: handleValueChange,
        focusedView: focusedView,
        onFocusedViewChange: onFocusedViewChange
    });
    const { meridiemMode: meridiemMode, handleMeridiemChange: handleMeridiemChange } = (0, $9474454c4c9ffb68$export$6aaabc31cb076d17)(valueOrReferenceDate, ampm, setValueAndGoToNextView);
    const isTimeDisabled = $gJYWc.useCallback((rawValue, viewType)=>{
        const isAfter = (0, $ab68d4157b5096ce$export$fb87c80b35a46b89)(disableIgnoringDatePartForTimeValidation, utils);
        const shouldCheckPastEnd = viewType === 'hours' || viewType === 'minutes' && views.includes('seconds');
        const containsValidTime = ({ start: start, end: end })=>{
            if (minTime && isAfter(minTime, end)) return false;
            if (maxTime && isAfter(start, maxTime)) return false;
            if (disableFuture && isAfter(start, now)) return false;
            if (disablePast && isAfter(now, shouldCheckPastEnd ? end : start)) return false;
            return true;
        };
        const isValidValue = (timeValue, step = 1)=>{
            if (timeValue % step !== 0) return false;
            if (shouldDisableClock != null && shouldDisableClock(timeValue, viewType)) return false;
            if (shouldDisableTime) switch(viewType){
                case 'hours':
                    return !shouldDisableTime(utils.setHours(valueOrReferenceDate, timeValue), 'hours');
                case 'minutes':
                    return !shouldDisableTime(utils.setMinutes(valueOrReferenceDate, timeValue), 'minutes');
                case 'seconds':
                    return !shouldDisableTime(utils.setSeconds(valueOrReferenceDate, timeValue), 'seconds');
                default:
                    return false;
            }
            return true;
        };
        switch(viewType){
            case 'hours':
                {
                    const valueWithMeridiem = (0, $ab68d4157b5096ce$export$4159dc823695870e)(rawValue, meridiemMode, ampm);
                    const dateWithNewHours = utils.setHours(valueOrReferenceDate, valueWithMeridiem);
                    const start = utils.setSeconds(utils.setMinutes(dateWithNewHours, 0), 0);
                    const end = utils.setSeconds(utils.setMinutes(dateWithNewHours, 59), 59);
                    return !containsValidTime({
                        start: start,
                        end: end
                    }) || !isValidValue(valueWithMeridiem);
                }
            case 'minutes':
                {
                    const dateWithNewMinutes = utils.setMinutes(valueOrReferenceDate, rawValue);
                    const start = utils.setSeconds(dateWithNewMinutes, 0);
                    const end = utils.setSeconds(dateWithNewMinutes, 59);
                    return !containsValidTime({
                        start: start,
                        end: end
                    }) || !isValidValue(rawValue, minutesStep);
                }
            case 'seconds':
                {
                    const dateWithNewSeconds = utils.setSeconds(valueOrReferenceDate, rawValue);
                    const start = dateWithNewSeconds;
                    const end = dateWithNewSeconds;
                    return !containsValidTime({
                        start: start,
                        end: end
                    }) || !isValidValue(rawValue);
                }
            default:
                throw new Error('not supported');
        }
    }, [
        ampm,
        valueOrReferenceDate,
        disableIgnoringDatePartForTimeValidation,
        maxTime,
        meridiemMode,
        minTime,
        minutesStep,
        shouldDisableClock,
        shouldDisableTime,
        utils,
        disableFuture,
        disablePast,
        now,
        views
    ]);
    const selectedId = (0, $8fee44a510de4e75$export$2e2bcd8739ae039)();
    const viewProps = $gJYWc.useMemo(()=>{
        switch(view){
            case 'hours':
                {
                    const handleHoursChange = (hourValue, isFinish)=>{
                        const valueWithMeridiem = (0, $ab68d4157b5096ce$export$4159dc823695870e)(hourValue, meridiemMode, ampm);
                        setValueAndGoToNextView(utils.setHours(valueOrReferenceDate, valueWithMeridiem), isFinish);
                    };
                    return {
                        onChange: handleHoursChange,
                        viewValue: utils.getHours(valueOrReferenceDate),
                        children: (0, $1265a879f45f234d$export$10850582eda9a8c7)({
                            value: value,
                            utils: utils,
                            ampm: ampm,
                            onChange: handleHoursChange,
                            getClockNumberText: localeText.hoursClockNumberText,
                            isDisabled: (hourValue)=>disabled || isTimeDisabled(hourValue, 'hours'),
                            selectedId: selectedId
                        })
                    };
                }
            case 'minutes':
                {
                    const minutesValue = utils.getMinutes(valueOrReferenceDate);
                    const handleMinutesChange = (minuteValue, isFinish)=>{
                        setValueAndGoToNextView(utils.setMinutes(valueOrReferenceDate, minuteValue), isFinish);
                    };
                    return {
                        viewValue: minutesValue,
                        onChange: handleMinutesChange,
                        children: (0, $1265a879f45f234d$export$2c440057d7a731e4)({
                            utils: utils,
                            value: minutesValue,
                            onChange: handleMinutesChange,
                            getClockNumberText: localeText.minutesClockNumberText,
                            isDisabled: (minuteValue)=>disabled || isTimeDisabled(minuteValue, 'minutes'),
                            selectedId: selectedId
                        })
                    };
                }
            case 'seconds':
                {
                    const secondsValue = utils.getSeconds(valueOrReferenceDate);
                    const handleSecondsChange = (secondValue, isFinish)=>{
                        setValueAndGoToNextView(utils.setSeconds(valueOrReferenceDate, secondValue), isFinish);
                    };
                    return {
                        viewValue: secondsValue,
                        onChange: handleSecondsChange,
                        children: (0, $1265a879f45f234d$export$2c440057d7a731e4)({
                            utils: utils,
                            value: secondsValue,
                            onChange: handleSecondsChange,
                            getClockNumberText: localeText.secondsClockNumberText,
                            isDisabled: (secondValue)=>disabled || isTimeDisabled(secondValue, 'seconds'),
                            selectedId: selectedId
                        })
                    };
                }
            default:
                throw new Error('You must provide the type for ClockView');
        }
    }, [
        view,
        utils,
        value,
        ampm,
        localeText.hoursClockNumberText,
        localeText.minutesClockNumberText,
        localeText.secondsClockNumberText,
        meridiemMode,
        setValueAndGoToNextView,
        valueOrReferenceDate,
        isTimeDisabled,
        selectedId,
        disabled
    ]);
    const ownerState = props;
    const classes = $4318aa45ff6b0af3$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $9wx12.jsxs)($4318aa45ff6b0af3$var$TimeClockRoot, (0, $3VnFq.default)({
        ref: ref,
        className: (0, $2w6IV.default)(classes.root, className),
        ownerState: ownerState
    }, other, {
        children: [
            /*#__PURE__*/ (0, $9wx12.jsx)((0, $396fded592c832a3$export$9735c82c4bae3302), (0, $3VnFq.default)({
                autoFocus: autoFocus != null ? autoFocus : !!focusedView,
                ampmInClock: ampmInClock && views.includes('hours'),
                value: value,
                type: view,
                ampm: ampm,
                minutesStep: minutesStep,
                isTimeDisabled: isTimeDisabled,
                meridiemMode: meridiemMode,
                handleMeridiemChange: handleMeridiemChange,
                selectedId: selectedId,
                disabled: disabled,
                readOnly: readOnly
            }, viewProps)),
            showViewSwitcher && /*#__PURE__*/ (0, $9wx12.jsx)($4318aa45ff6b0af3$var$TimeClockArrowSwitcher, {
                className: classes.arrowSwitcher,
                slots: slots,
                slotProps: slotProps,
                onGoToPrevious: ()=>setView(previousView),
                isPreviousDisabled: !previousView,
                previousLabel: localeText.openPreviousView,
                onGoToNext: ()=>setView(nextView),
                isNextDisabled: !nextView,
                nextLabel: localeText.openNextView,
                ownerState: ownerState
            })
        ]
    }));
});



var $3VnFq = parcelRequire("3VnFq");

var $cTAWX = parcelRequire("cTAWX");

var $gJYWc = parcelRequire("gJYWc");

var $2w6IV = parcelRequire("2w6IV");



var $HGmne = parcelRequire("HGmne");

var $92UcI = parcelRequire("92UcI");

var $3e4LV = parcelRequire("3e4LV");

var $cTAWX = parcelRequire("cTAWX");

var $3VnFq = parcelRequire("3VnFq");

var $gJYWc = parcelRequire("gJYWc");


var $2w6IV = parcelRequire("2w6IV");

var $3e4LV = parcelRequire("3e4LV");

var $fwsmC = parcelRequire("fwsmC");

var $HGmne = parcelRequire("HGmne");
var $8ttSm = parcelRequire("8ttSm");

var $8pLcn = parcelRequire("8pLcn");


var $fNSZE = parcelRequire("fNSZE");


var $il32z = parcelRequire("il32z");

var $i8nzj = parcelRequire("i8nzj");

var $1kRHf = parcelRequire("1kRHf");
function $d3db737b0aba5542$export$46f01d01378ec5a2(slot) {
    return (0, $1kRHf.default)('MuiDivider', slot);
}
const $d3db737b0aba5542$var$dividerClasses = (0, $i8nzj.default)('MuiDivider', [
    'root',
    'absolute',
    'fullWidth',
    'inset',
    'middle',
    'flexItem',
    'light',
    'vertical',
    'withChildren',
    'withChildrenVertical',
    'textAlignRight',
    'textAlignLeft',
    'wrapper',
    'wrapperVertical'
]);
var $d3db737b0aba5542$export$2e2bcd8739ae039 = $d3db737b0aba5542$var$dividerClasses;





var $i8nzj = parcelRequire("i8nzj");

var $1kRHf = parcelRequire("1kRHf");
function $db09b88340fa834a$export$515f8c67b5305377(slot) {
    return (0, $1kRHf.default)('MuiMenuItem', slot);
}
const $db09b88340fa834a$var$menuItemClasses = (0, $i8nzj.default)('MuiMenuItem', [
    'root',
    'focusVisible',
    'dense',
    'disabled',
    'divider',
    'gutters',
    'selected'
]);
var $db09b88340fa834a$export$2e2bcd8739ae039 = $db09b88340fa834a$var$menuItemClasses;



var $9wx12 = parcelRequire("9wx12");
'use client';
const $32a7693600202a38$var$_excluded = [
    "autoFocus",
    "component",
    "dense",
    "divider",
    "disableGutters",
    "focusVisibleClassName",
    "role",
    "tabIndex",
    "className"
];
const $32a7693600202a38$export$4334bb34c76fef24 = (props, styles)=>{
    const { ownerState: ownerState } = props;
    return [
        styles.root,
        ownerState.dense && styles.dense,
        ownerState.divider && styles.divider,
        !ownerState.disableGutters && styles.gutters
    ];
};
const $32a7693600202a38$var$useUtilityClasses = (ownerState)=>{
    const { disabled: disabled, dense: dense, divider: divider, disableGutters: disableGutters, selected: selected, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            dense && 'dense',
            disabled && 'disabled',
            !disableGutters && 'gutters',
            divider && 'divider',
            selected && 'selected'
        ]
    };
    const composedClasses = (0, $3e4LV.default)(slots, (0, $db09b88340fa834a$export$515f8c67b5305377), classes);
    return (0, $3VnFq.default)({}, classes, composedClasses);
};
const $32a7693600202a38$var$MenuItemRoot = (0, $HGmne.default)((0, $fNSZE.default), {
    shouldForwardProp: (prop)=>(0, $8ttSm.default)(prop) || prop === 'classes',
    name: 'MuiMenuItem',
    slot: 'Root',
    overridesResolver: $32a7693600202a38$export$4334bb34c76fef24
})(({ theme: theme, ownerState: ownerState })=>(0, $3VnFq.default)({}, theme.typography.body1, {
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'center',
        position: 'relative',
        textDecoration: 'none',
        minHeight: 48,
        paddingTop: 6,
        paddingBottom: 6,
        boxSizing: 'border-box',
        whiteSpace: 'nowrap'
    }, !ownerState.disableGutters && {
        paddingLeft: 16,
        paddingRight: 16
    }, ownerState.divider && {
        borderBottom: `1px solid ${(theme.vars || theme).palette.divider}`,
        backgroundClip: 'padding-box'
    }, {
        '&:hover': {
            textDecoration: 'none',
            backgroundColor: (theme.vars || theme).palette.action.hover,
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                backgroundColor: 'transparent'
            }
        },
        [`&.${(0, $db09b88340fa834a$export$2e2bcd8739ae039).selected}`]: {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.selectedOpacity})` : (0, $fwsmC.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity),
            [`&.${(0, $db09b88340fa834a$export$2e2bcd8739ae039).focusVisible}`]: {
                backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.focusOpacity}))` : (0, $fwsmC.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity + theme.palette.action.focusOpacity)
            }
        },
        [`&.${(0, $db09b88340fa834a$export$2e2bcd8739ae039).selected}:hover`]: {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.hoverOpacity}))` : (0, $fwsmC.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity + theme.palette.action.hoverOpacity),
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.selectedOpacity})` : (0, $fwsmC.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity)
            }
        },
        [`&.${(0, $db09b88340fa834a$export$2e2bcd8739ae039).focusVisible}`]: {
            backgroundColor: (theme.vars || theme).palette.action.focus
        },
        [`&.${(0, $db09b88340fa834a$export$2e2bcd8739ae039).disabled}`]: {
            opacity: (theme.vars || theme).palette.action.disabledOpacity
        },
        [`& + .${(0, $d3db737b0aba5542$export$2e2bcd8739ae039).root}`]: {
            marginTop: theme.spacing(1),
            marginBottom: theme.spacing(1)
        },
        [`& + .${(0, $d3db737b0aba5542$export$2e2bcd8739ae039).inset}`]: {
            marginLeft: 52
        },
        [`& .${(0, $d2e859f656a8df91$export$2e2bcd8739ae039).root}`]: {
            marginTop: 0,
            marginBottom: 0
        },
        [`& .${(0, $d2e859f656a8df91$export$2e2bcd8739ae039).inset}`]: {
            paddingLeft: 36
        },
        [`& .${(0, $7cc24a64203062a7$export$2e2bcd8739ae039).root}`]: {
            minWidth: 36
        }
    }, !ownerState.dense && {
        [theme.breakpoints.up('sm')]: {
            minHeight: 'auto'
        }
    }, ownerState.dense && (0, $3VnFq.default)({
        minHeight: 32,
        // https://m2.material.io/components/menus#specs > Dense
        paddingTop: 4,
        paddingBottom: 4
    }, theme.typography.body2, {
        [`& .${(0, $7cc24a64203062a7$export$2e2bcd8739ae039).root} svg`]: {
            fontSize: '1.25rem'
        }
    })));
const $32a7693600202a38$var$MenuItem = /*#__PURE__*/ $gJYWc.forwardRef(function MenuItem(inProps, ref) {
    const props = (0, $8pLcn.useDefaultProps)({
        props: inProps,
        name: 'MuiMenuItem'
    });
    const { autoFocus: autoFocus = false, component: component = 'li', dense: dense = false, divider: divider = false, disableGutters: disableGutters = false, focusVisibleClassName: focusVisibleClassName, role: role = 'menuitem', tabIndex: tabIndexProp, className: className } = props, other = (0, $cTAWX.default)(props, $32a7693600202a38$var$_excluded);
    const context = $gJYWc.useContext((0, $3d14c289610745c4$export$2e2bcd8739ae039));
    const childContext = $gJYWc.useMemo(()=>({
            dense: dense || context.dense || false,
            disableGutters: disableGutters
        }), [
        context.dense,
        dense,
        disableGutters
    ]);
    const menuItemRef = $gJYWc.useRef(null);
    (0, $288db5e5dece4e0b$export$2e2bcd8739ae039)(()=>{
        if (autoFocus) {
            if (menuItemRef.current) menuItemRef.current.focus();
        }
    }, [
        autoFocus
    ]);
    const ownerState = (0, $3VnFq.default)({}, props, {
        dense: childContext.dense,
        divider: divider,
        disableGutters: disableGutters
    });
    const classes = $32a7693600202a38$var$useUtilityClasses(props);
    const handleRef = (0, $il32z.default)(menuItemRef, ref);
    let tabIndex;
    if (!props.disabled) tabIndex = tabIndexProp !== undefined ? tabIndexProp : -1;
    return /*#__PURE__*/ (0, $9wx12.jsx)((0, $3d14c289610745c4$export$2e2bcd8739ae039).Provider, {
        value: childContext,
        children: /*#__PURE__*/ (0, $9wx12.jsx)($32a7693600202a38$var$MenuItemRoot, (0, $3VnFq.default)({
            ref: handleRef,
            role: role,
            tabIndex: tabIndex,
            component: component,
            focusVisibleClassName: (0, $2w6IV.default)(classes.focusVisible, focusVisibleClassName),
            className: (0, $2w6IV.default)(classes.root, className)
        }, other, {
            ownerState: ownerState,
            classes: classes
        }))
    });
});
var $32a7693600202a38$export$2e2bcd8739ae039 = $32a7693600202a38$var$MenuItem;




var $4gWBK = parcelRequire("4gWBK");




var $1kRHf = parcelRequire("1kRHf");

var $i8nzj = parcelRequire("i8nzj");
function $2859aee70d56eb68$export$aeb645018b209578(slot) {
    return (0, $1kRHf.default)('MuiDigitalClock', slot);
}
const $2859aee70d56eb68$export$baf91642e79c8163 = (0, $i8nzj.default)('MuiDigitalClock', [
    'root',
    'list',
    'item'
]);








var $9wx12 = parcelRequire("9wx12");
const $494adec554d6ce6f$var$_excluded = [
    "ampm",
    "timeStep",
    "autoFocus",
    "components",
    "componentsProps",
    "slots",
    "slotProps",
    "value",
    "defaultValue",
    "referenceDate",
    "disableIgnoringDatePartForTimeValidation",
    "maxTime",
    "minTime",
    "disableFuture",
    "disablePast",
    "minutesStep",
    "shouldDisableClock",
    "shouldDisableTime",
    "onChange",
    "view",
    "openTo",
    "onViewChange",
    "focusedView",
    "onFocusedViewChange",
    "className",
    "disabled",
    "readOnly",
    "views",
    "skipDisabled",
    "timezone"
];
const $494adec554d6ce6f$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ],
        list: [
            'list'
        ],
        item: [
            'item'
        ]
    };
    return (0, $3e4LV.default)(slots, (0, $2859aee70d56eb68$export$aeb645018b209578), classes);
};
const $494adec554d6ce6f$var$DigitalClockRoot = (0, $HGmne.default)((0, $b034d353ecc5f692$export$512b066b8abdfde4), {
    name: 'MuiDigitalClock',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})(({ ownerState: ownerState })=>({
        overflowY: 'auto',
        width: '100%',
        '@media (prefers-reduced-motion: no-preference)': {
            scrollBehavior: ownerState.alreadyRendered ? 'smooth' : 'auto'
        },
        maxHeight: (0, $8450780b4b9a6f99$export$1c2eabda4acea0e4)
    }));
const $494adec554d6ce6f$var$DigitalClockList = (0, $HGmne.default)((0, $b767fae8cf0de5d7$export$2e2bcd8739ae039), {
    name: 'MuiDigitalClock',
    slot: 'List',
    overridesResolver: (props, styles)=>styles.list
})({
    padding: 0
});
const $494adec554d6ce6f$var$DigitalClockItem = (0, $HGmne.default)((0, $32a7693600202a38$export$2e2bcd8739ae039), {
    name: 'MuiDigitalClock',
    slot: 'Item',
    overridesResolver: (props, styles)=>styles.item
})(({ theme: theme })=>({
        padding: '8px 16px',
        margin: '2px 4px',
        '&:first-of-type': {
            marginTop: 4
        },
        '&:hover': {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $cf4e4db1b4d926c1$export$58f0f39f63f3cf42)(theme.palette.primary.main, theme.palette.action.hoverOpacity)
        },
        '&.Mui-selected': {
            backgroundColor: (theme.vars || theme).palette.primary.main,
            color: (theme.vars || theme).palette.primary.contrastText,
            '&:focus-visible, &:hover': {
                backgroundColor: (theme.vars || theme).palette.primary.dark
            }
        },
        '&.Mui-focusVisible': {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.focusOpacity})` : (0, $cf4e4db1b4d926c1$export$58f0f39f63f3cf42)(theme.palette.primary.main, theme.palette.action.focusOpacity)
        }
    }));
const $494adec554d6ce6f$export$9a2b219a5b06deb7 = /*#__PURE__*/ $gJYWc.forwardRef(function DigitalClock(inProps, ref) {
    var _ref, _slots$digitalClockIt, _slotProps$digitalClo;
    const utils = (0, $98220f21a8625472$export$1163b47e39508a46)();
    const containerRef = $gJYWc.useRef(null);
    const handleRef = (0, $4gWBK.default)(ref, containerRef);
    const props = (0, $6959428021af84ce$export$2e2bcd8739ae039)({
        props: inProps,
        name: 'MuiDigitalClock'
    });
    const { ampm: ampm = utils.is12HourCycleInCurrentLocale(), timeStep: timeStep = 30, autoFocus: autoFocus, components: components, componentsProps: componentsProps, slots: slots, slotProps: slotProps, value: valueProp, defaultValue: defaultValue, referenceDate: referenceDateProp, disableIgnoringDatePartForTimeValidation: disableIgnoringDatePartForTimeValidation = false, maxTime: maxTime, minTime: minTime, disableFuture: disableFuture, disablePast: disablePast, minutesStep: minutesStep = 1, shouldDisableClock: shouldDisableClock, shouldDisableTime: shouldDisableTime, onChange: onChange, view: inView, openTo: openTo, onViewChange: onViewChange, focusedView: focusedView, onFocusedViewChange: onFocusedViewChange, className: className, disabled: disabled, readOnly: readOnly, views: views = [
        'hours'
    ], skipDisabled: skipDisabled = false, timezone: timezoneProp } = props, other = (0, $cTAWX.default)(props, $494adec554d6ce6f$var$_excluded);
    const { value: value, handleValueChange: handleRawValueChange, timezone: timezone } = (0, $666e75003bf5e8d6$export$174d749f3b4c0f49)({
        name: 'DigitalClock',
        timezone: timezoneProp,
        value: valueProp,
        defaultValue: defaultValue,
        onChange: onChange,
        valueManager: (0, $15cde65cbd91c944$export$2764b246aa3b75ba)
    });
    const localeText = (0, $98220f21a8625472$export$24fdeaa0f591a73e)();
    const now = (0, $98220f21a8625472$export$3a404aece3dff2fa)(timezone);
    const ownerState = $gJYWc.useMemo(()=>(0, $3VnFq.default)({}, props, {
            alreadyRendered: !!containerRef.current
        }), [
        props
    ]);
    const classes = $494adec554d6ce6f$var$useUtilityClasses(ownerState);
    const ClockItem = (_ref = (_slots$digitalClockIt = slots == null ? void 0 : slots.digitalClockItem) != null ? _slots$digitalClockIt : components == null ? void 0 : components.DigitalClockItem) != null ? _ref : $494adec554d6ce6f$var$DigitalClockItem;
    const clockItemProps = (0, $2082854bb194ebf1$export$2e2bcd8739ae039)({
        elementType: ClockItem,
        externalSlotProps: (_slotProps$digitalClo = slotProps == null ? void 0 : slotProps.digitalClockItem) != null ? _slotProps$digitalClo : componentsProps == null ? void 0 : componentsProps.digitalClockItem,
        ownerState: {},
        className: classes.item
    });
    const valueOrReferenceDate = (0, $be0be177042d0203$export$86ee3b7a301faaa3)({
        value: value,
        referenceDate: referenceDateProp,
        utils: utils,
        props: props,
        timezone: timezone
    });
    const handleValueChange = (0, $92UcI.default)((newValue)=>handleRawValueChange(newValue, 'finish', 'hours'));
    const { setValueAndGoToNextView: setValueAndGoToNextView } = (0, $d3a5b60d8c1fb6e1$export$9b46cba8f8ccd954)({
        view: inView,
        views: views,
        openTo: openTo,
        onViewChange: onViewChange,
        onChange: handleValueChange,
        focusedView: focusedView,
        onFocusedViewChange: onFocusedViewChange
    });
    const handleItemSelect = (0, $92UcI.default)((newValue)=>{
        setValueAndGoToNextView(newValue, 'finish');
    });
    $gJYWc.useEffect(()=>{
        if (containerRef.current === null) return;
        const selectedItem = containerRef.current.querySelector('[role="listbox"] [role="option"][aria-selected="true"]');
        if (!selectedItem) return;
        const offsetTop = selectedItem.offsetTop;
        // Subtracting the 4px of extra margin intended for the first visible section item
        containerRef.current.scrollTop = offsetTop - 4;
    });
    const isTimeDisabled = $gJYWc.useCallback((valueToCheck)=>{
        const isAfter = (0, $ab68d4157b5096ce$export$fb87c80b35a46b89)(disableIgnoringDatePartForTimeValidation, utils);
        const containsValidTime = ()=>{
            if (minTime && isAfter(minTime, valueToCheck)) return false;
            if (maxTime && isAfter(valueToCheck, maxTime)) return false;
            if (disableFuture && isAfter(valueToCheck, now)) return false;
            if (disablePast && isAfter(now, valueToCheck)) return false;
            return true;
        };
        const isValidValue = ()=>{
            if (utils.getMinutes(valueToCheck) % minutesStep !== 0) return false;
            if (shouldDisableClock != null && shouldDisableClock(utils.toJsDate(valueToCheck).getTime(), 'hours')) return false;
            if (shouldDisableTime) return !shouldDisableTime(valueToCheck, 'hours');
            return true;
        };
        return !containsValidTime() || !isValidValue();
    }, [
        disableIgnoringDatePartForTimeValidation,
        utils,
        minTime,
        maxTime,
        disableFuture,
        now,
        disablePast,
        minutesStep,
        shouldDisableClock,
        shouldDisableTime
    ]);
    const timeOptions = $gJYWc.useMemo(()=>{
        const startOfDay = utils.startOfDay(valueOrReferenceDate);
        return [
            startOfDay,
            ...Array.from({
                length: Math.ceil(1440 / timeStep) - 1
            }, (_, index)=>utils.addMinutes(startOfDay, timeStep * (index + 1)))
        ];
    }, [
        valueOrReferenceDate,
        timeStep,
        utils
    ]);
    return /*#__PURE__*/ (0, $9wx12.jsx)($494adec554d6ce6f$var$DigitalClockRoot, (0, $3VnFq.default)({
        ref: handleRef,
        className: (0, $2w6IV.default)(classes.root, className),
        ownerState: ownerState
    }, other, {
        children: /*#__PURE__*/ (0, $9wx12.jsx)($494adec554d6ce6f$var$DigitalClockList, {
            autoFocusItem: autoFocus || !!focusedView,
            role: "listbox",
            "aria-label": localeText.timePickerToolbarTitle,
            className: classes.list,
            children: timeOptions.map((option)=>{
                if (skipDisabled && isTimeDisabled(option)) return null;
                const isSelected = utils.isEqual(option, value);
                return /*#__PURE__*/ (0, $9wx12.jsx)(ClockItem, (0, $3VnFq.default)({
                    onClick: ()=>!readOnly && handleItemSelect(option),
                    selected: isSelected,
                    disabled: disabled || isTimeDisabled(option),
                    disableRipple: readOnly,
                    role: "option",
                    "aria-disabled": readOnly,
                    "aria-selected": isSelected
                }, clockItemProps, {
                    children: utils.format(option, ampm ? 'fullTime12h' : 'fullTime24h')
                }), utils.toISO(option));
            })
        })
    }));
});



var $3VnFq = parcelRequire("3VnFq");

var $cTAWX = parcelRequire("cTAWX");

var $gJYWc = parcelRequire("gJYWc");

var $2w6IV = parcelRequire("2w6IV");


var $HGmne = parcelRequire("HGmne");

var $92UcI = parcelRequire("92UcI");

var $3e4LV = parcelRequire("3e4LV");






var $1kRHf = parcelRequire("1kRHf");

var $i8nzj = parcelRequire("i8nzj");
function $cb32127971c60a96$export$b828b7724b7b2890(slot) {
    return (0, $1kRHf.default)('MuiMultiSectionDigitalClock', slot);
}
const $cb32127971c60a96$export$f2277d947b8f7a8a = (0, $i8nzj.default)('MuiMultiSectionDigitalClock', [
    'root'
]);



var $3VnFq = parcelRequire("3VnFq");

var $cTAWX = parcelRequire("cTAWX");

var $gJYWc = parcelRequire("gJYWc");

var $2w6IV = parcelRequire("2w6IV");

var $HGmne = parcelRequire("HGmne");

var $3e4LV = parcelRequire("3e4LV");



var $4gWBK = parcelRequire("4gWBK");

var $1kRHf = parcelRequire("1kRHf");

var $i8nzj = parcelRequire("i8nzj");
function $aae16d3921af0478$export$ab23463cad6963ff(slot) {
    return (0, $1kRHf.default)('MuiMultiSectionDigitalClockSection', slot);
}
const $aae16d3921af0478$export$eaf2b63fa45eff23 = (0, $i8nzj.default)('MuiMultiSectionDigitalClockSection', [
    'root',
    'item'
]);




var $9wx12 = parcelRequire("9wx12");
const $0785854c5459b415$var$_excluded = [
    "autoFocus",
    "onChange",
    "className",
    "disabled",
    "readOnly",
    "items",
    "active",
    "slots",
    "slotProps",
    "skipDisabled"
];
const $0785854c5459b415$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ],
        item: [
            'item'
        ]
    };
    return (0, $3e4LV.default)(slots, (0, $aae16d3921af0478$export$ab23463cad6963ff), classes);
};
const $0785854c5459b415$var$MultiSectionDigitalClockSectionRoot = (0, $HGmne.default)((0, $b767fae8cf0de5d7$export$2e2bcd8739ae039), {
    name: 'MuiMultiSectionDigitalClockSection',
    slot: 'Root',
    overridesResolver: (_, styles)=>styles.root
})(({ theme: theme, ownerState: ownerState })=>({
        maxHeight: (0, $8450780b4b9a6f99$export$1c2eabda4acea0e4),
        width: 56,
        padding: 0,
        overflow: 'hidden',
        '@media (prefers-reduced-motion: no-preference)': {
            scrollBehavior: ownerState.alreadyRendered ? 'smooth' : 'auto'
        },
        '@media (pointer: fine)': {
            '&:hover': {
                overflowY: 'auto'
            }
        },
        '@media (pointer: none), (pointer: coarse)': {
            overflowY: 'auto'
        },
        '&:not(:first-of-type)': {
            borderLeft: `1px solid ${(theme.vars || theme).palette.divider}`
        },
        '&:after': {
            display: 'block',
            content: '""',
            // subtracting the height of one item, extra margin and borders to make sure the max height is correct
            height: 'calc(100% - 40px - 6px)'
        }
    }));
const $0785854c5459b415$var$MultiSectionDigitalClockSectionItem = (0, $HGmne.default)((0, $32a7693600202a38$export$2e2bcd8739ae039), {
    name: 'MuiMultiSectionDigitalClockSection',
    slot: 'Item',
    overridesResolver: (_, styles)=>styles.item
})(({ theme: theme })=>({
        padding: 8,
        margin: '2px 4px',
        width: (0, $8450780b4b9a6f99$export$a462ceb9cfdb5d71),
        justifyContent: 'center',
        '&:first-of-type': {
            marginTop: 4
        },
        '&:hover': {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $cf4e4db1b4d926c1$export$58f0f39f63f3cf42)(theme.palette.primary.main, theme.palette.action.hoverOpacity)
        },
        '&.Mui-selected': {
            backgroundColor: (theme.vars || theme).palette.primary.main,
            color: (theme.vars || theme).palette.primary.contrastText,
            '&:focus-visible, &:hover': {
                backgroundColor: (theme.vars || theme).palette.primary.dark
            }
        },
        '&.Mui-focusVisible': {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.focusOpacity})` : (0, $cf4e4db1b4d926c1$export$58f0f39f63f3cf42)(theme.palette.primary.main, theme.palette.action.focusOpacity)
        }
    }));
const $0785854c5459b415$export$f971f93dc8464c = /*#__PURE__*/ $gJYWc.forwardRef(function MultiSectionDigitalClockSection(inProps, ref) {
    var _slots$digitalClockSe;
    const containerRef = $gJYWc.useRef(null);
    const handleRef = (0, $4gWBK.default)(ref, containerRef);
    const previousActive = $gJYWc.useRef(null);
    const props = (0, $6959428021af84ce$export$2e2bcd8739ae039)({
        props: inProps,
        name: 'MuiMultiSectionDigitalClockSection'
    });
    const { autoFocus: autoFocus, onChange: onChange, className: className, disabled: disabled, readOnly: readOnly, items: items, active: active, slots: slots, slotProps: slotProps, skipDisabled: skipDisabled } = props, other = (0, $cTAWX.default)(props, $0785854c5459b415$var$_excluded);
    const ownerState = $gJYWc.useMemo(()=>(0, $3VnFq.default)({}, props, {
            alreadyRendered: !!containerRef.current
        }), [
        props
    ]);
    const classes = $0785854c5459b415$var$useUtilityClasses(ownerState);
    const DigitalClockSectionItem = (_slots$digitalClockSe = slots == null ? void 0 : slots.digitalClockSectionItem) != null ? _slots$digitalClockSe : $0785854c5459b415$var$MultiSectionDigitalClockSectionItem;
    $gJYWc.useEffect(()=>{
        if (containerRef.current === null) return;
        const activeItem = containerRef.current.querySelector('[role="option"][aria-selected="true"]');
        if (active && autoFocus && activeItem) activeItem.focus();
        if (!activeItem || previousActive.current === activeItem) return;
        previousActive.current = activeItem;
        const offsetTop = activeItem.offsetTop;
        // Subtracting the 4px of extra margin intended for the first visible section item
        containerRef.current.scrollTop = offsetTop - 4;
    });
    return /*#__PURE__*/ (0, $9wx12.jsx)($0785854c5459b415$var$MultiSectionDigitalClockSectionRoot, (0, $3VnFq.default)({
        ref: handleRef,
        className: (0, $2w6IV.default)(classes.root, className),
        ownerState: ownerState,
        autoFocusItem: autoFocus && active,
        role: "listbox"
    }, other, {
        children: items.map((option)=>{
            var _option$isDisabled, _option$isDisabled2;
            if (skipDisabled && (_option$isDisabled = option.isDisabled) != null && _option$isDisabled.call(option, option.value)) return null;
            const isSelected = option.isSelected(option.value);
            return /*#__PURE__*/ (0, $9wx12.jsx)(DigitalClockSectionItem, (0, $3VnFq.default)({
                onClick: ()=>!readOnly && onChange(option.value),
                selected: isSelected,
                disabled: disabled || ((_option$isDisabled2 = option.isDisabled) == null ? void 0 : _option$isDisabled2.call(option, option.value)),
                disableRipple: readOnly,
                role: "option",
                "aria-disabled": readOnly,
                "aria-label": option.ariaLabel,
                "aria-selected": isSelected,
                className: classes.item
            }, slotProps == null ? void 0 : slotProps.digitalClockSectionItem, {
                children: option.label
            }), option.label);
        })
    }));
});


const $39faefaa0211ecf1$export$9101aa7ba362bb4e = ({ now: now, value: value, utils: utils, ampm: ampm, isDisabled: isDisabled, resolveAriaLabel: resolveAriaLabel, timeStep: timeStep })=>{
    const currentHours = value ? utils.getHours(value) : null;
    const result = [];
    const isSelected = (hour)=>{
        if (currentHours === null) return false;
        if (ampm) {
            if (hour === 12) return currentHours === 12 || currentHours === 0;
            return currentHours === hour || currentHours - 12 === hour;
        }
        return currentHours === hour;
    };
    const endHour = ampm ? 11 : 23;
    for(let hour = 0; hour <= endHour; hour += timeStep){
        let label = utils.format(utils.setHours(now, hour), ampm ? 'hours12h' : 'hours24h');
        const ariaLabel = resolveAriaLabel(parseInt(label, 10).toString());
        label = utils.formatNumber(label);
        result.push({
            value: hour,
            label: label,
            isSelected: isSelected,
            isDisabled: isDisabled,
            ariaLabel: ariaLabel
        });
    }
    return result;
};
const $39faefaa0211ecf1$export$e7b56db95f8a7b9c = ({ value: value, utils: utils, isDisabled: isDisabled, timeStep: timeStep, resolveLabel: resolveLabel, resolveAriaLabel: resolveAriaLabel, hasValue: hasValue = true })=>{
    const isSelected = (timeValue)=>{
        if (value === null) return false;
        return hasValue && value === timeValue;
    };
    return [
        ...Array.from({
            length: Math.ceil(60 / timeStep)
        }, (_, index)=>{
            const timeValue = timeStep * index;
            return {
                value: timeValue,
                label: utils.formatNumber(resolveLabel(timeValue)),
                isDisabled: isDisabled,
                isSelected: isSelected,
                ariaLabel: resolveAriaLabel(timeValue.toString())
            };
        })
    ];
};







var $9wx12 = parcelRequire("9wx12");
const $27752aabb01c3a0a$var$_excluded = [
    "ampm",
    "timeSteps",
    "autoFocus",
    "components",
    "componentsProps",
    "slots",
    "slotProps",
    "value",
    "defaultValue",
    "referenceDate",
    "disableIgnoringDatePartForTimeValidation",
    "maxTime",
    "minTime",
    "disableFuture",
    "disablePast",
    "minutesStep",
    "shouldDisableClock",
    "shouldDisableTime",
    "onChange",
    "view",
    "views",
    "openTo",
    "onViewChange",
    "focusedView",
    "onFocusedViewChange",
    "className",
    "disabled",
    "readOnly",
    "skipDisabled",
    "timezone"
];
const $27752aabb01c3a0a$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ]
    };
    return (0, $3e4LV.default)(slots, (0, $cb32127971c60a96$export$b828b7724b7b2890), classes);
};
const $27752aabb01c3a0a$var$MultiSectionDigitalClockRoot = (0, $HGmne.default)((0, $b034d353ecc5f692$export$512b066b8abdfde4), {
    name: 'MuiMultiSectionDigitalClock',
    slot: 'Root',
    overridesResolver: (_, styles)=>styles.root
})(({ theme: theme })=>({
        display: 'flex',
        flexDirection: 'row',
        width: '100%',
        borderBottom: `1px solid ${(theme.vars || theme).palette.divider}`
    }));
const $27752aabb01c3a0a$export$c48dada788ff933b = /*#__PURE__*/ $gJYWc.forwardRef(function MultiSectionDigitalClock(inProps, ref) {
    const utils = (0, $98220f21a8625472$export$1163b47e39508a46)();
    const props = (0, $6959428021af84ce$export$2e2bcd8739ae039)({
        props: inProps,
        name: 'MuiMultiSectionDigitalClock'
    });
    const { ampm: ampm = utils.is12HourCycleInCurrentLocale(), timeSteps: inTimeSteps, autoFocus: autoFocus, components: components, componentsProps: componentsProps, slots: slots, slotProps: slotProps, value: valueProp, defaultValue: defaultValue, referenceDate: referenceDateProp, disableIgnoringDatePartForTimeValidation: disableIgnoringDatePartForTimeValidation = false, maxTime: maxTime, minTime: minTime, disableFuture: disableFuture, disablePast: disablePast, minutesStep: minutesStep = 1, shouldDisableClock: shouldDisableClock, shouldDisableTime: shouldDisableTime, onChange: onChange, view: inView, views: inViews = [
        'hours',
        'minutes'
    ], openTo: openTo, onViewChange: onViewChange, focusedView: inFocusedView, onFocusedViewChange: onFocusedViewChange, className: className, disabled: disabled, readOnly: readOnly, skipDisabled: skipDisabled = false, timezone: timezoneProp } = props, other = (0, $cTAWX.default)(props, $27752aabb01c3a0a$var$_excluded);
    const { value: value, handleValueChange: handleRawValueChange, timezone: timezone } = (0, $666e75003bf5e8d6$export$174d749f3b4c0f49)({
        name: 'MultiSectionDigitalClock',
        timezone: timezoneProp,
        value: valueProp,
        defaultValue: defaultValue,
        onChange: onChange,
        valueManager: (0, $15cde65cbd91c944$export$2764b246aa3b75ba)
    });
    const localeText = (0, $98220f21a8625472$export$24fdeaa0f591a73e)();
    const now = (0, $98220f21a8625472$export$3a404aece3dff2fa)(timezone);
    const timeSteps = $gJYWc.useMemo(()=>(0, $3VnFq.default)({
            hours: 1,
            minutes: 5,
            seconds: 5
        }, inTimeSteps), [
        inTimeSteps
    ]);
    const valueOrReferenceDate = (0, $be0be177042d0203$export$86ee3b7a301faaa3)({
        value: value,
        referenceDate: referenceDateProp,
        utils: utils,
        props: props,
        timezone: timezone
    });
    const handleValueChange = (0, $92UcI.default)((newValue, selectionState, selectedView)=>handleRawValueChange(newValue, selectionState, selectedView));
    const views = $gJYWc.useMemo(()=>{
        if (!ampm || !inViews.includes('hours')) return inViews;
        return inViews.includes('meridiem') ? inViews : [
            ...inViews,
            'meridiem'
        ];
    }, [
        ampm,
        inViews
    ]);
    const { view: view, setValueAndGoToNextView: setValueAndGoToNextView, focusedView: focusedView } = (0, $d3a5b60d8c1fb6e1$export$9b46cba8f8ccd954)({
        view: inView,
        views: views,
        openTo: openTo,
        onViewChange: onViewChange,
        onChange: handleValueChange,
        focusedView: inFocusedView,
        onFocusedViewChange: onFocusedViewChange
    });
    const handleMeridiemValueChange = (0, $92UcI.default)((newValue)=>{
        setValueAndGoToNextView(newValue, 'finish', 'meridiem');
    });
    const { meridiemMode: meridiemMode, handleMeridiemChange: handleMeridiemChange } = (0, $9474454c4c9ffb68$export$6aaabc31cb076d17)(valueOrReferenceDate, ampm, handleMeridiemValueChange, 'finish');
    const isTimeDisabled = $gJYWc.useCallback((rawValue, viewType)=>{
        const isAfter = (0, $ab68d4157b5096ce$export$fb87c80b35a46b89)(disableIgnoringDatePartForTimeValidation, utils);
        const shouldCheckPastEnd = viewType === 'hours' || viewType === 'minutes' && views.includes('seconds');
        const containsValidTime = ({ start: start, end: end })=>{
            if (minTime && isAfter(minTime, end)) return false;
            if (maxTime && isAfter(start, maxTime)) return false;
            if (disableFuture && isAfter(start, now)) return false;
            if (disablePast && isAfter(now, shouldCheckPastEnd ? end : start)) return false;
            return true;
        };
        const isValidValue = (timeValue, step = 1)=>{
            if (timeValue % step !== 0) return false;
            if (shouldDisableClock != null && shouldDisableClock(timeValue, viewType)) return false;
            if (shouldDisableTime) switch(viewType){
                case 'hours':
                    return !shouldDisableTime(utils.setHours(valueOrReferenceDate, timeValue), 'hours');
                case 'minutes':
                    return !shouldDisableTime(utils.setMinutes(valueOrReferenceDate, timeValue), 'minutes');
                case 'seconds':
                    return !shouldDisableTime(utils.setSeconds(valueOrReferenceDate, timeValue), 'seconds');
                default:
                    return false;
            }
            return true;
        };
        switch(viewType){
            case 'hours':
                {
                    const valueWithMeridiem = (0, $ab68d4157b5096ce$export$4159dc823695870e)(rawValue, meridiemMode, ampm);
                    const dateWithNewHours = utils.setHours(valueOrReferenceDate, valueWithMeridiem);
                    const start = utils.setSeconds(utils.setMinutes(dateWithNewHours, 0), 0);
                    const end = utils.setSeconds(utils.setMinutes(dateWithNewHours, 59), 59);
                    return !containsValidTime({
                        start: start,
                        end: end
                    }) || !isValidValue(valueWithMeridiem);
                }
            case 'minutes':
                {
                    const dateWithNewMinutes = utils.setMinutes(valueOrReferenceDate, rawValue);
                    const start = utils.setSeconds(dateWithNewMinutes, 0);
                    const end = utils.setSeconds(dateWithNewMinutes, 59);
                    return !containsValidTime({
                        start: start,
                        end: end
                    }) || !isValidValue(rawValue, minutesStep);
                }
            case 'seconds':
                {
                    const dateWithNewSeconds = utils.setSeconds(valueOrReferenceDate, rawValue);
                    const start = dateWithNewSeconds;
                    const end = dateWithNewSeconds;
                    return !containsValidTime({
                        start: start,
                        end: end
                    }) || !isValidValue(rawValue);
                }
            default:
                throw new Error('not supported');
        }
    }, [
        ampm,
        valueOrReferenceDate,
        disableIgnoringDatePartForTimeValidation,
        maxTime,
        meridiemMode,
        minTime,
        minutesStep,
        shouldDisableClock,
        shouldDisableTime,
        utils,
        disableFuture,
        disablePast,
        now,
        views
    ]);
    const buildViewProps = $gJYWc.useCallback((viewToBuild)=>{
        switch(viewToBuild){
            case 'hours':
                return {
                    onChange: (hours)=>{
                        const valueWithMeridiem = (0, $ab68d4157b5096ce$export$4159dc823695870e)(hours, meridiemMode, ampm);
                        setValueAndGoToNextView(utils.setHours(valueOrReferenceDate, valueWithMeridiem), 'finish', 'hours');
                    },
                    items: (0, $39faefaa0211ecf1$export$9101aa7ba362bb4e)({
                        now: now,
                        value: value,
                        ampm: ampm,
                        utils: utils,
                        isDisabled: (hours)=>disabled || isTimeDisabled(hours, 'hours'),
                        timeStep: timeSteps.hours,
                        resolveAriaLabel: localeText.hoursClockNumberText
                    })
                };
            case 'minutes':
                return {
                    onChange: (minutes)=>{
                        setValueAndGoToNextView(utils.setMinutes(valueOrReferenceDate, minutes), 'finish', 'minutes');
                    },
                    items: (0, $39faefaa0211ecf1$export$e7b56db95f8a7b9c)({
                        value: utils.getMinutes(valueOrReferenceDate),
                        utils: utils,
                        isDisabled: (minutes)=>disabled || isTimeDisabled(minutes, 'minutes'),
                        resolveLabel: (minutes)=>utils.format(utils.setMinutes(now, minutes), 'minutes'),
                        timeStep: timeSteps.minutes,
                        hasValue: !!value,
                        resolveAriaLabel: localeText.minutesClockNumberText
                    })
                };
            case 'seconds':
                return {
                    onChange: (seconds)=>{
                        setValueAndGoToNextView(utils.setSeconds(valueOrReferenceDate, seconds), 'finish', 'seconds');
                    },
                    items: (0, $39faefaa0211ecf1$export$e7b56db95f8a7b9c)({
                        value: utils.getSeconds(valueOrReferenceDate),
                        utils: utils,
                        isDisabled: (seconds)=>disabled || isTimeDisabled(seconds, 'seconds'),
                        resolveLabel: (seconds)=>utils.format(utils.setSeconds(now, seconds), 'seconds'),
                        timeStep: timeSteps.seconds,
                        hasValue: !!value,
                        resolveAriaLabel: localeText.secondsClockNumberText
                    })
                };
            case 'meridiem':
                {
                    const amLabel = (0, $00e6d022b450825d$export$fae94c0a662107ef)(utils, 'am');
                    const pmLabel = (0, $00e6d022b450825d$export$fae94c0a662107ef)(utils, 'pm');
                    return {
                        onChange: handleMeridiemChange,
                        items: [
                            {
                                value: 'am',
                                label: amLabel,
                                isSelected: ()=>!!value && meridiemMode === 'am',
                                ariaLabel: amLabel
                            },
                            {
                                value: 'pm',
                                label: pmLabel,
                                isSelected: ()=>!!value && meridiemMode === 'pm',
                                ariaLabel: pmLabel
                            }
                        ]
                    };
                }
            default:
                throw new Error(`Unknown view: ${viewToBuild} found.`);
        }
    }, [
        now,
        value,
        ampm,
        utils,
        timeSteps.hours,
        timeSteps.minutes,
        timeSteps.seconds,
        localeText.hoursClockNumberText,
        localeText.minutesClockNumberText,
        localeText.secondsClockNumberText,
        meridiemMode,
        setValueAndGoToNextView,
        valueOrReferenceDate,
        disabled,
        isTimeDisabled,
        handleMeridiemChange
    ]);
    const viewTimeOptions = $gJYWc.useMemo(()=>{
        return views.reduce((result, currentView)=>{
            return (0, $3VnFq.default)({}, result, {
                [currentView]: buildViewProps(currentView)
            });
        }, {});
    }, [
        views,
        buildViewProps
    ]);
    const ownerState = props;
    const classes = $27752aabb01c3a0a$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $9wx12.jsx)($27752aabb01c3a0a$var$MultiSectionDigitalClockRoot, (0, $3VnFq.default)({
        ref: ref,
        className: (0, $2w6IV.default)(classes.root, className),
        ownerState: ownerState,
        role: "group"
    }, other, {
        children: Object.entries(viewTimeOptions).map(([timeView, viewOptions])=>/*#__PURE__*/ (0, $9wx12.jsx)((0, $0785854c5459b415$export$f971f93dc8464c), {
                items: viewOptions.items,
                onChange: viewOptions.onChange,
                active: view === timeView,
                autoFocus: autoFocus != null ? autoFocus : focusedView === timeView,
                disabled: disabled,
                readOnly: readOnly,
                slots: slots != null ? slots : components,
                slotProps: slotProps != null ? slotProps : componentsProps,
                skipDisabled: skipDisabled,
                "aria-label": localeText.selectViewText(timeView)
            }, timeView))
    }));
});




var $9wx12 = parcelRequire("9wx12");
const $aaa0aa13f492eecc$export$a3ad21a1b07c504f = ({ view: view, onViewChange: onViewChange, focusedView: focusedView, onFocusedViewChange: onFocusedViewChange, views: views, value: value, defaultValue: defaultValue, referenceDate: referenceDate, onChange: onChange, className: className, classes: classes, disableFuture: disableFuture, disablePast: disablePast, minTime: minTime, maxTime: maxTime, shouldDisableTime: shouldDisableTime, shouldDisableClock: shouldDisableClock, minutesStep: minutesStep, ampm: ampm, ampmInClock: ampmInClock, components: components, componentsProps: componentsProps, slots: slots, slotProps: slotProps, readOnly: readOnly, disabled: disabled, sx: sx, autoFocus: autoFocus, showViewSwitcher: showViewSwitcher, disableIgnoringDatePartForTimeValidation: disableIgnoringDatePartForTimeValidation, timezone: timezone })=>/*#__PURE__*/ (0, $9wx12.jsx)((0, $4318aa45ff6b0af3$export$7e96244e18c4be57), {
        view: view,
        onViewChange: onViewChange,
        focusedView: focusedView && (0, $ab68d4157b5096ce$export$8f04d380cefd5a0d)(focusedView) ? focusedView : null,
        onFocusedViewChange: onFocusedViewChange,
        views: views.filter((0, $ab68d4157b5096ce$export$8f04d380cefd5a0d)),
        value: value,
        defaultValue: defaultValue,
        referenceDate: referenceDate,
        onChange: onChange,
        className: className,
        classes: classes,
        disableFuture: disableFuture,
        disablePast: disablePast,
        minTime: minTime,
        maxTime: maxTime,
        shouldDisableTime: shouldDisableTime,
        shouldDisableClock: shouldDisableClock,
        minutesStep: minutesStep,
        ampm: ampm,
        ampmInClock: ampmInClock,
        components: components,
        componentsProps: componentsProps,
        slots: slots,
        slotProps: slotProps,
        readOnly: readOnly,
        disabled: disabled,
        sx: sx,
        autoFocus: autoFocus,
        showViewSwitcher: showViewSwitcher,
        disableIgnoringDatePartForTimeValidation: disableIgnoringDatePartForTimeValidation,
        timezone: timezone
    });
const $aaa0aa13f492eecc$export$a2917c76dc0aa7e = ({ view: view, onViewChange: onViewChange, focusedView: focusedView, onFocusedViewChange: onFocusedViewChange, views: views, value: value, defaultValue: defaultValue, referenceDate: referenceDate, onChange: onChange, className: className, classes: classes, disableFuture: disableFuture, disablePast: disablePast, minTime: minTime, maxTime: maxTime, shouldDisableTime: shouldDisableTime, shouldDisableClock: shouldDisableClock, minutesStep: minutesStep, ampm: ampm, components: components, componentsProps: componentsProps, slots: slots, slotProps: slotProps, readOnly: readOnly, disabled: disabled, sx: sx, autoFocus: autoFocus, disableIgnoringDatePartForTimeValidation: disableIgnoringDatePartForTimeValidation, timeSteps: timeSteps, skipDisabled: skipDisabled, timezone: timezone })=>/*#__PURE__*/ (0, $9wx12.jsx)((0, $494adec554d6ce6f$export$9a2b219a5b06deb7), {
        view: view,
        onViewChange: onViewChange,
        focusedView: focusedView,
        onFocusedViewChange: onFocusedViewChange,
        views: views.filter((0, $ab68d4157b5096ce$export$8f04d380cefd5a0d)),
        value: value,
        defaultValue: defaultValue,
        referenceDate: referenceDate,
        onChange: onChange,
        className: className,
        classes: classes,
        disableFuture: disableFuture,
        disablePast: disablePast,
        minTime: minTime,
        maxTime: maxTime,
        shouldDisableTime: shouldDisableTime,
        shouldDisableClock: shouldDisableClock,
        minutesStep: minutesStep,
        ampm: ampm,
        components: components,
        componentsProps: componentsProps,
        slots: slots,
        slotProps: slotProps,
        readOnly: readOnly,
        disabled: disabled,
        sx: sx,
        autoFocus: autoFocus,
        disableIgnoringDatePartForTimeValidation: disableIgnoringDatePartForTimeValidation,
        timeStep: timeSteps == null ? void 0 : timeSteps.minutes,
        skipDisabled: skipDisabled,
        timezone: timezone
    });
const $aaa0aa13f492eecc$export$48a290886291c531 = ({ view: view, onViewChange: onViewChange, focusedView: focusedView, onFocusedViewChange: onFocusedViewChange, views: views, value: value, defaultValue: defaultValue, referenceDate: referenceDate, onChange: onChange, className: className, classes: classes, disableFuture: disableFuture, disablePast: disablePast, minTime: minTime, maxTime: maxTime, shouldDisableTime: shouldDisableTime, shouldDisableClock: shouldDisableClock, minutesStep: minutesStep, ampm: ampm, components: components, componentsProps: componentsProps, slots: slots, slotProps: slotProps, readOnly: readOnly, disabled: disabled, sx: sx, autoFocus: autoFocus, disableIgnoringDatePartForTimeValidation: disableIgnoringDatePartForTimeValidation, timeSteps: timeSteps, skipDisabled: skipDisabled, timezone: timezone })=>/*#__PURE__*/ (0, $9wx12.jsx)((0, $27752aabb01c3a0a$export$c48dada788ff933b), {
        view: view,
        onViewChange: onViewChange,
        focusedView: focusedView,
        onFocusedViewChange: onFocusedViewChange,
        views: views.filter((0, $ab68d4157b5096ce$export$8f04d380cefd5a0d)),
        value: value,
        defaultValue: defaultValue,
        referenceDate: referenceDate,
        onChange: onChange,
        className: className,
        classes: classes,
        disableFuture: disableFuture,
        disablePast: disablePast,
        minTime: minTime,
        maxTime: maxTime,
        shouldDisableTime: shouldDisableTime,
        shouldDisableClock: shouldDisableClock,
        minutesStep: minutesStep,
        ampm: ampm,
        components: components,
        componentsProps: componentsProps,
        slots: slots,
        slotProps: slotProps,
        readOnly: readOnly,
        disabled: disabled,
        sx: sx,
        autoFocus: autoFocus,
        disableIgnoringDatePartForTimeValidation: disableIgnoringDatePartForTimeValidation,
        timeSteps: timeSteps,
        skipDisabled: skipDisabled,
        timezone: timezone
    });




var $3VnFq = parcelRequire("3VnFq");

var $cTAWX = parcelRequire("cTAWX");


const $54339bb854b9ed61$var$_excluded = [
    "views",
    "format"
];
const $54339bb854b9ed61$export$ebf7b30b32db6f57 = (utils, _ref)=>{
    let { views: views, format: format } = _ref, other = (0, $cTAWX.default)(_ref, $54339bb854b9ed61$var$_excluded);
    if (format) return format;
    const dateViews = [];
    const timeViews = [];
    views.forEach((view)=>{
        if ((0, $ab68d4157b5096ce$export$8f04d380cefd5a0d)(view)) timeViews.push(view);
        else dateViews.push(view);
    });
    if (timeViews.length === 0) return (0, $00e6d022b450825d$export$bb1c921f313ec928)(utils, (0, $3VnFq.default)({
        views: dateViews
    }, other), false);
    if (dateViews.length === 0) return (0, $ab68d4157b5096ce$export$3a6776b3863772fe)(utils, (0, $3VnFq.default)({
        views: timeViews
    }, other));
    const timeFormat = (0, $ab68d4157b5096ce$export$3a6776b3863772fe)(utils, (0, $3VnFq.default)({
        views: timeViews
    }, other));
    const dateFormat = (0, $00e6d022b450825d$export$bb1c921f313ec928)(utils, (0, $3VnFq.default)({
        views: dateViews
    }, other), false);
    return `${dateFormat} ${timeFormat}`;
};
const $54339bb854b9ed61$var$resolveViews = (ampm, views, shouldUseSingleColumn)=>{
    if (shouldUseSingleColumn) return views.filter((view)=>!(0, $ab68d4157b5096ce$export$a3328136ac50623d)(view) || view === 'hours');
    return ampm ? [
        ...views,
        'meridiem'
    ] : views;
};
const $54339bb854b9ed61$var$resolveShouldRenderTimeInASingleColumn = (timeSteps, threshold)=>{
    var _timeSteps$hours, _timeSteps$minutes;
    return 1440 / (((_timeSteps$hours = timeSteps.hours) != null ? _timeSteps$hours : 1) * ((_timeSteps$minutes = timeSteps.minutes) != null ? _timeSteps$minutes : 5)) <= threshold;
};
function $54339bb854b9ed61$export$e2d664f2dd4d34bc({ thresholdToRenderTimeInASingleColumn: inThreshold, ampm: ampm, timeSteps: inTimeSteps, views: views }) {
    const thresholdToRenderTimeInASingleColumn = inThreshold != null ? inThreshold : 24;
    const timeSteps = (0, $3VnFq.default)({
        hours: 1,
        minutes: 5,
        seconds: 5
    }, inTimeSteps);
    const shouldRenderTimeInASingleColumn = $54339bb854b9ed61$var$resolveShouldRenderTimeInASingleColumn(timeSteps, thresholdToRenderTimeInASingleColumn);
    return {
        thresholdToRenderTimeInASingleColumn: thresholdToRenderTimeInASingleColumn,
        timeSteps: timeSteps,
        shouldRenderTimeInASingleColumn: shouldRenderTimeInASingleColumn,
        views: $54339bb854b9ed61$var$resolveViews(ampm, views, shouldRenderTimeInASingleColumn)
    };
}


/**
 * Demos:
 *
 * - [TimePicker](https://mui.com/x/react-date-pickers/time-picker/)
 * - [Validation](https://mui.com/x/react-date-pickers/validation/)
 *
 * API:
 *
 * - [DesktopTimePicker API](https://mui.com/x/api/date-pickers/desktop-time-picker/)
 */ const $680bff3bce231f47$export$c2eea9c279c6035b = /*#__PURE__*/ $gJYWc.forwardRef(function DesktopTimePicker(inProps, ref) {
    var _defaultizedProps$amp, _viewRenderers$hours, _defaultizedProps$slo2, _defaultizedProps$slo3, _props$localeText$ope, _props$localeText;
    const localeText = (0, $98220f21a8625472$export$24fdeaa0f591a73e)();
    const utils = (0, $98220f21a8625472$export$1163b47e39508a46)();
    // Props with the default values common to all time pickers
    const defaultizedProps = (0, $f32fda7ce15f7631$export$586c31b46cc238ba)(inProps, 'MuiDesktopTimePicker');
    const { shouldRenderTimeInASingleColumn: shouldRenderTimeInASingleColumn, views: resolvedViews, timeSteps: timeSteps } = (0, $54339bb854b9ed61$export$e2d664f2dd4d34bc)(defaultizedProps);
    const renderTimeView = shouldRenderTimeInASingleColumn ? (0, $aaa0aa13f492eecc$export$a2917c76dc0aa7e) : (0, $aaa0aa13f492eecc$export$48a290886291c531);
    const viewRenderers = (0, $3VnFq.default)({
        hours: renderTimeView,
        minutes: renderTimeView,
        seconds: renderTimeView,
        meridiem: renderTimeView
    }, defaultizedProps.viewRenderers);
    const ampmInClock = (_defaultizedProps$amp = defaultizedProps.ampmInClock) != null ? _defaultizedProps$amp : true;
    const actionBarActions = shouldRenderTimeInASingleColumn ? [] : [
        'accept'
    ];
    // Need to avoid adding the `meridiem` view when unexpected renderer is specified
    const shouldHoursRendererContainMeridiemView = ((_viewRenderers$hours = viewRenderers.hours) == null ? void 0 : _viewRenderers$hours.name) === (0, $aaa0aa13f492eecc$export$48a290886291c531).name;
    const views = !shouldHoursRendererContainMeridiemView ? resolvedViews.filter((view)=>view !== 'meridiem') : resolvedViews;
    // Props with the default values specific to the desktop variant
    const props = (0, $3VnFq.default)({}, defaultizedProps, {
        ampmInClock: ampmInClock,
        timeSteps: timeSteps,
        viewRenderers: viewRenderers,
        format: (0, $ab68d4157b5096ce$export$3a6776b3863772fe)(utils, defaultizedProps),
        // Setting only `hours` time view in case of single column time picker
        // Allows for easy view lifecycle management
        views: shouldRenderTimeInASingleColumn ? [
            'hours'
        ] : views,
        slots: (0, $3VnFq.default)({
            field: (0, $7b9f323337367d9e$export$5eaee2322dd727eb),
            openPickerIcon: (0, $fc9c2dee5d88174c$export$8099ab97743c966c)
        }, defaultizedProps.slots),
        slotProps: (0, $3VnFq.default)({}, defaultizedProps.slotProps, {
            field: (ownerState)=>{
                var _defaultizedProps$slo;
                return (0, $3VnFq.default)({}, (0, $1cf868609b280c1d$export$308c24034cde71de)((_defaultizedProps$slo = defaultizedProps.slotProps) == null ? void 0 : _defaultizedProps$slo.field, ownerState), (0, $e3a0d6a34962839a$export$5890f750904acddb)(defaultizedProps), {
                    ref: ref
                });
            },
            toolbar: (0, $3VnFq.default)({
                hidden: true,
                ampmInClock: ampmInClock
            }, (_defaultizedProps$slo2 = defaultizedProps.slotProps) == null ? void 0 : _defaultizedProps$slo2.toolbar),
            actionBar: (0, $3VnFq.default)({
                actions: actionBarActions
            }, (_defaultizedProps$slo3 = defaultizedProps.slotProps) == null ? void 0 : _defaultizedProps$slo3.actionBar)
        })
    });
    const { renderPicker: renderPicker } = (0, $af0dd03ad3aebb23$export$b1b70bc56ac5be0e)({
        props: props,
        valueManager: (0, $15cde65cbd91c944$export$2764b246aa3b75ba),
        valueType: 'time',
        getOpenDialogAriaText: (_props$localeText$ope = (_props$localeText = props.localeText) == null ? void 0 : _props$localeText.openTimePickerDialogue) != null ? _props$localeText$ope : localeText.openTimePickerDialogue,
        validator: (0, $25036a0b58cac589$export$7bd013ac69eb590c)
    });
    return renderPicker();
});
$680bff3bce231f47$export$c2eea9c279c6035b.propTypes = {
    // ----------------------------- Warning --------------------------------
    // | These PropTypes are generated from the TypeScript type definitions |
    // | To update them edit the TypeScript types and run "yarn proptypes"  |
    // ----------------------------------------------------------------------
    /**
   * 12h/24h view for hour selection clock.
   * @default `utils.is12HourCycleInCurrentLocale()`
   */ ampm: (0, (/*@__PURE__*/$parcel$interopDefault($3Zour))).bool,
    /**
   * Display ampm controls under the clock (instead of in the toolbar).
   * @default true on desktop, false on mobile
   */ ampmInClock: (0, (/*@__PURE__*/$parcel$interopDefault($3Zour))).bool,
    /**
   * If `true`, the main element is focused during the first mount.
   * This main element is:
   * - the element chosen by the visible view if any (i.e: the selected day on the `day` view).
   * - the `input` element if there is a field rendered.
   */ autoFocus: (0, (/*@__PURE__*/$parcel$interopDefault($3Zour))).bool,
    /**
   * Class name applied to the root element.
   */ className: (0, (/*@__PURE__*/$parcel$interopDefault($3Zour))).string,
    /**
   * If `true`, the popover or modal will close after submitting the full date.
   * @default `true` for desktop, `false` for mobile (based on the chosen wrapper and `desktopModeMediaQuery` prop).
   */ closeOnSelect: (0, (/*@__PURE__*/$parcel$interopDefault($3Zour))).bool,
    /**
   * Overridable components.
   * @default {}
   * @deprecated Please use `slots`.
   */ components: (0, (/*@__PURE__*/$parcel$interopDefault($3Zour))).object,
    /**
   * The props used for each component slot.
   * @default {}
   * @deprecated Please use `slotProps`.
   */ componentsProps: (0, (/*@__PURE__*/$parcel$interopDefault($3Zour))).object,
    /**
   * The default value.
   * Used when the component is not controlled.
   */ defaultValue: (0, (/*@__PURE__*/$parcel$interopDefault($3Zour))).any,
    /**
   * If `true`, the picker and text field are disabled.
   * @default false
   */ disabled: (0, (/*@__PURE__*/$parcel$interopDefault($3Zour))).bool,
    /**
   * If `true`, disable values after the current date for date components, time for time components and both for date time components.
   * @default false
   */ disableFuture: (0, (/*@__PURE__*/$parcel$interopDefault($3Zour))).bool,
    /**
   * Do not ignore date part when validating min/max time.
   * @default false
   */ disableIgnoringDatePartForTimeValidation: (0, (/*@__PURE__*/$parcel$interopDefault($3Zour))).bool,
    /**
   * If `true`, the open picker button will not be rendered (renders only the field).
   * @default false
   */ disableOpenPicker: (0, (/*@__PURE__*/$parcel$interopDefault($3Zour))).bool,
    /**
   * If `true`, disable values before the current date for date components, time for time components and both for date time components.
   * @default false
   */ disablePast: (0, (/*@__PURE__*/$parcel$interopDefault($3Zour))).bool,
    /**
   * Format of the date when rendered in the input(s).
   * Defaults to localized format based on the used `views`.
   */ format: (0, (/*@__PURE__*/$parcel$interopDefault($3Zour))).string,
    /**
   * Density of the format when rendered in the input.
   * Setting `formatDensity` to `"spacious"` will add a space before and after each `/`, `-` and `.` character.
   * @default "dense"
   */ formatDensity: (0, (/*@__PURE__*/$parcel$interopDefault($3Zour))).oneOf([
        'dense',
        'spacious'
    ]),
    /**
   * Pass a ref to the `input` element.
   */ inputRef: (0, $82c4d2ab89e86c16$export$2e2bcd8739ae039),
    /**
   * The label content.
   */ label: (0, (/*@__PURE__*/$parcel$interopDefault($3Zour))).node,
    /**
   * Locale for components texts.
   * Allows overriding texts coming from `LocalizationProvider` and `theme`.
   */ localeText: (0, (/*@__PURE__*/$parcel$interopDefault($3Zour))).object,
    /**
   * Maximal selectable time.
   * The date part of the object will be ignored unless `props.disableIgnoringDatePartForTimeValidation === true`.
   */ maxTime: (0, (/*@__PURE__*/$parcel$interopDefault($3Zour))).any,
    /**
   * Minimal selectable time.
   * The date part of the object will be ignored unless `props.disableIgnoringDatePartForTimeValidation === true`.
   */ minTime: (0, (/*@__PURE__*/$parcel$interopDefault($3Zour))).any,
    /**
   * Step over minutes.
   * @default 1
   */ minutesStep: (0, (/*@__PURE__*/$parcel$interopDefault($3Zour))).number,
    /**
   * Name attribute used by the `input` element in the Field.
   */ name: (0, (/*@__PURE__*/$parcel$interopDefault($3Zour))).string,
    /**
   * Callback fired when the value is accepted.
   * @template TValue The value type. Will be either the same type as `value` or `null`. Can be in `[start, end]` format in case of range value.
   * @param {TValue} value The value that was just accepted.
   */ onAccept: (0, (/*@__PURE__*/$parcel$interopDefault($3Zour))).func,
    /**
   * Callback fired when the value changes.
   * @template TValue The value type. Will be either the same type as `value` or `null`. Can be in `[start, end]` format in case of range value.
   * @template TError The validation error type. Will be either `string` or a `null`. Can be in `[start, end]` format in case of range value.
   * @param {TValue} value The new value.
   * @param {FieldChangeHandlerContext<TError>} context The context containing the validation result of the current value.
   */ onChange: (0, (/*@__PURE__*/$parcel$interopDefault($3Zour))).func,
    /**
   * Callback fired when the popup requests to be closed.
   * Use in controlled mode (see `open`).
   */ onClose: (0, (/*@__PURE__*/$parcel$interopDefault($3Zour))).func,
    /**
   * Callback fired when the error associated to the current value changes.
   * If the error has a non-null value, then the `TextField` will be rendered in `error` state.
   *
   * @template TValue The value type. Will be either the same type as `value` or `null`. Can be in `[start, end]` format in case of range value.
   * @template TError The validation error type. Will be either `string` or a `null`. Can be in `[start, end]` format in case of range value.
   * @param {TError} error The new error describing why the current value is not valid.
   * @param {TValue} value The value associated to the error.
   */ onError: (0, (/*@__PURE__*/$parcel$interopDefault($3Zour))).func,
    /**
   * Callback fired when the popup requests to be opened.
   * Use in controlled mode (see `open`).
   */ onOpen: (0, (/*@__PURE__*/$parcel$interopDefault($3Zour))).func,
    /**
   * Callback fired when the selected sections change.
   * @param {FieldSelectedSections} newValue The new selected sections.
   */ onSelectedSectionsChange: (0, (/*@__PURE__*/$parcel$interopDefault($3Zour))).func,
    /**
   * Callback fired on view change.
   * @template TView
   * @param {TView} view The new view.
   */ onViewChange: (0, (/*@__PURE__*/$parcel$interopDefault($3Zour))).func,
    /**
   * Control the popup or dialog open state.
   * @default false
   */ open: (0, (/*@__PURE__*/$parcel$interopDefault($3Zour))).bool,
    /**
   * The default visible view.
   * Used when the component view is not controlled.
   * Must be a valid option from `views` list.
   */ openTo: (0, (/*@__PURE__*/$parcel$interopDefault($3Zour))).oneOf([
        'hours',
        'meridiem',
        'minutes',
        'seconds'
    ]),
    /**
   * Force rendering in particular orientation.
   */ orientation: (0, (/*@__PURE__*/$parcel$interopDefault($3Zour))).oneOf([
        'landscape',
        'portrait'
    ]),
    readOnly: (0, (/*@__PURE__*/$parcel$interopDefault($3Zour))).bool,
    /**
   * If `true`, disable heavy animations.
   * @default `@media(prefers-reduced-motion: reduce)` || `navigator.userAgent` matches Android <10 or iOS <13
   */ reduceAnimations: (0, (/*@__PURE__*/$parcel$interopDefault($3Zour))).bool,
    /**
   * The date used to generate the new value when both `value` and `defaultValue` are empty.
   * @default The closest valid date-time using the validation props, except callbacks like `shouldDisable<...>`.
   */ referenceDate: (0, (/*@__PURE__*/$parcel$interopDefault($3Zour))).any,
    /**
   * The currently selected sections.
   * This prop accept four formats:
   * 1. If a number is provided, the section at this index will be selected.
   * 2. If an object with a `startIndex` and `endIndex` properties are provided, the sections between those two indexes will be selected.
   * 3. If a string of type `FieldSectionType` is provided, the first section with that name will be selected.
   * 4. If `null` is provided, no section will be selected
   * If not provided, the selected sections will be handled internally.
   */ selectedSections: (0, (/*@__PURE__*/$parcel$interopDefault($3Zour))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($3Zour))).oneOf([
            'all',
            'day',
            'hours',
            'meridiem',
            'minutes',
            'month',
            'seconds',
            'weekDay',
            'year'
        ]),
        (0, (/*@__PURE__*/$parcel$interopDefault($3Zour))).number,
        (0, (/*@__PURE__*/$parcel$interopDefault($3Zour))).shape({
            endIndex: (0, (/*@__PURE__*/$parcel$interopDefault($3Zour))).number.isRequired,
            startIndex: (0, (/*@__PURE__*/$parcel$interopDefault($3Zour))).number.isRequired
        })
    ]),
    /**
   * Disable specific clock time.
   * @param {number} clockValue The value to check.
   * @param {TimeView} view The clock type of the timeValue.
   * @returns {boolean} If `true` the time will be disabled.
   * @deprecated Consider using `shouldDisableTime`.
   */ shouldDisableClock: (0, (/*@__PURE__*/$parcel$interopDefault($3Zour))).func,
    /**
   * Disable specific time.
   * @template TDate
   * @param {TDate} value The value to check.
   * @param {TimeView} view The clock type of the timeValue.
   * @returns {boolean} If `true` the time will be disabled.
   */ shouldDisableTime: (0, (/*@__PURE__*/$parcel$interopDefault($3Zour))).func,
    /**
   * If `true`, disabled digital clock items will not be rendered.
   * @default false
   */ skipDisabled: (0, (/*@__PURE__*/$parcel$interopDefault($3Zour))).bool,
    /**
   * The props used for each component slot.
   * @default {}
   */ slotProps: (0, (/*@__PURE__*/$parcel$interopDefault($3Zour))).object,
    /**
   * Overridable component slots.
   * @default {}
   */ slots: (0, (/*@__PURE__*/$parcel$interopDefault($3Zour))).object,
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: (0, (/*@__PURE__*/$parcel$interopDefault($3Zour))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($3Zour))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($3Zour))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($3Zour))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($3Zour))).object,
            (0, (/*@__PURE__*/$parcel$interopDefault($3Zour))).bool
        ])),
        (0, (/*@__PURE__*/$parcel$interopDefault($3Zour))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($3Zour))).object
    ]),
    /**
   * Amount of time options below or at which the single column time renderer is used.
   * @default 24
   */ thresholdToRenderTimeInASingleColumn: (0, (/*@__PURE__*/$parcel$interopDefault($3Zour))).number,
    /**
   * The time steps between two time unit options.
   * For example, if `timeStep.minutes = 8`, then the available minute options will be `[0, 8, 16, 24, 32, 40, 48, 56]`.
   * When single column time renderer is used, only `timeStep.minutes` will be used.
   * @default{ hours: 1, minutes: 5, seconds: 5 }
   */ timeSteps: (0, (/*@__PURE__*/$parcel$interopDefault($3Zour))).shape({
        hours: (0, (/*@__PURE__*/$parcel$interopDefault($3Zour))).number,
        minutes: (0, (/*@__PURE__*/$parcel$interopDefault($3Zour))).number,
        seconds: (0, (/*@__PURE__*/$parcel$interopDefault($3Zour))).number
    }),
    /**
   * Choose which timezone to use for the value.
   * Example: "default", "system", "UTC", "America/New_York".
   * If you pass values from other timezones to some props, they will be converted to this timezone before being used.
   * @see See the {@link https://mui.com/x/react-date-pickers/timezone/ timezones documention} for more details.
   * @default The timezone of the `value` or `defaultValue` prop is defined, 'default' otherwise.
   */ timezone: (0, (/*@__PURE__*/$parcel$interopDefault($3Zour))).string,
    /**
   * The selected value.
   * Used when the component is controlled.
   */ value: (0, (/*@__PURE__*/$parcel$interopDefault($3Zour))).any,
    /**
   * The visible view.
   * Used when the component view is controlled.
   * Must be a valid option from `views` list.
   */ view: (0, (/*@__PURE__*/$parcel$interopDefault($3Zour))).oneOf([
        'hours',
        'meridiem',
        'minutes',
        'seconds'
    ]),
    /**
   * Define custom view renderers for each section.
   * If `null`, the section will only have field editing.
   * If `undefined`, internally defined view will be the used.
   */ viewRenderers: (0, (/*@__PURE__*/$parcel$interopDefault($3Zour))).shape({
        hours: (0, (/*@__PURE__*/$parcel$interopDefault($3Zour))).func,
        meridiem: (0, (/*@__PURE__*/$parcel$interopDefault($3Zour))).func,
        minutes: (0, (/*@__PURE__*/$parcel$interopDefault($3Zour))).func,
        seconds: (0, (/*@__PURE__*/$parcel$interopDefault($3Zour))).func
    }),
    /**
   * Available views.
   */ views: (0, (/*@__PURE__*/$parcel$interopDefault($3Zour))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($3Zour))).oneOf([
        'hours',
        'minutes',
        'seconds'
    ]).isRequired)
};



var $3VnFq = parcelRequire("3VnFq");

var $gJYWc = parcelRequire("gJYWc");

var $3Zour = parcelRequire("3Zour");











/**
 * Demos:
 *
 * - [TimePicker](https://mui.com/x/react-date-pickers/time-picker/)
 * - [Validation](https://mui.com/x/react-date-pickers/validation/)
 *
 * API:
 *
 * - [MobileTimePicker API](https://mui.com/x/api/date-pickers/mobile-time-picker/)
 */ const $b6689091eefb3e69$export$984018df37898b81 = /*#__PURE__*/ $gJYWc.forwardRef(function MobileTimePicker(inProps, ref) {
    var _defaultizedProps$amp, _defaultizedProps$slo2, _props$localeText$ope, _props$localeText;
    const localeText = (0, $98220f21a8625472$export$24fdeaa0f591a73e)();
    const utils = (0, $98220f21a8625472$export$1163b47e39508a46)();
    // Props with the default values common to all time pickers
    const defaultizedProps = (0, $f32fda7ce15f7631$export$586c31b46cc238ba)(inProps, 'MuiMobileTimePicker');
    const viewRenderers = (0, $3VnFq.default)({
        hours: (0, $aaa0aa13f492eecc$export$a3ad21a1b07c504f),
        minutes: (0, $aaa0aa13f492eecc$export$a3ad21a1b07c504f),
        seconds: (0, $aaa0aa13f492eecc$export$a3ad21a1b07c504f)
    }, defaultizedProps.viewRenderers);
    const ampmInClock = (_defaultizedProps$amp = defaultizedProps.ampmInClock) != null ? _defaultizedProps$amp : false;
    // Props with the default values specific to the mobile variant
    const props = (0, $3VnFq.default)({}, defaultizedProps, {
        ampmInClock: ampmInClock,
        viewRenderers: viewRenderers,
        format: (0, $ab68d4157b5096ce$export$3a6776b3863772fe)(utils, defaultizedProps),
        slots: (0, $3VnFq.default)({
            field: (0, $7b9f323337367d9e$export$5eaee2322dd727eb)
        }, defaultizedProps.slots),
        slotProps: (0, $3VnFq.default)({}, defaultizedProps.slotProps, {
            field: (ownerState)=>{
                var _defaultizedProps$slo;
                return (0, $3VnFq.default)({}, (0, $1cf868609b280c1d$export$308c24034cde71de)((_defaultizedProps$slo = defaultizedProps.slotProps) == null ? void 0 : _defaultizedProps$slo.field, ownerState), (0, $e3a0d6a34962839a$export$5890f750904acddb)(defaultizedProps), {
                    ref: ref
                });
            },
            toolbar: (0, $3VnFq.default)({
                hidden: false,
                ampmInClock: ampmInClock
            }, (_defaultizedProps$slo2 = defaultizedProps.slotProps) == null ? void 0 : _defaultizedProps$slo2.toolbar)
        })
    });
    const { renderPicker: renderPicker } = (0, $5691ee540aea8f7e$export$5ca0153a626a7dd7)({
        props: props,
        valueManager: (0, $15cde65cbd91c944$export$2764b246aa3b75ba),
        valueType: 'time',
        getOpenDialogAriaText: (_props$localeText$ope = (_props$localeText = props.localeText) == null ? void 0 : _props$localeText.openTimePickerDialogue) != null ? _props$localeText$ope : localeText.openTimePickerDialogue,
        validator: (0, $25036a0b58cac589$export$7bd013ac69eb590c)
    });
    return renderPicker();
});
$b6689091eefb3e69$export$984018df37898b81.propTypes = {
    // ----------------------------- Warning --------------------------------
    // | These PropTypes are generated from the TypeScript type definitions |
    // | To update them edit the TypeScript types and run "yarn proptypes"  |
    // ----------------------------------------------------------------------
    /**
   * 12h/24h view for hour selection clock.
   * @default `utils.is12HourCycleInCurrentLocale()`
   */ ampm: (0, (/*@__PURE__*/$parcel$interopDefault($3Zour))).bool,
    /**
   * Display ampm controls under the clock (instead of in the toolbar).
   * @default true on desktop, false on mobile
   */ ampmInClock: (0, (/*@__PURE__*/$parcel$interopDefault($3Zour))).bool,
    /**
   * If `true`, the main element is focused during the first mount.
   * This main element is:
   * - the element chosen by the visible view if any (i.e: the selected day on the `day` view).
   * - the `input` element if there is a field rendered.
   */ autoFocus: (0, (/*@__PURE__*/$parcel$interopDefault($3Zour))).bool,
    /**
   * Class name applied to the root element.
   */ className: (0, (/*@__PURE__*/$parcel$interopDefault($3Zour))).string,
    /**
   * If `true`, the popover or modal will close after submitting the full date.
   * @default `true` for desktop, `false` for mobile (based on the chosen wrapper and `desktopModeMediaQuery` prop).
   */ closeOnSelect: (0, (/*@__PURE__*/$parcel$interopDefault($3Zour))).bool,
    /**
   * Overridable components.
   * @default {}
   * @deprecated Please use `slots`.
   */ components: (0, (/*@__PURE__*/$parcel$interopDefault($3Zour))).object,
    /**
   * The props used for each component slot.
   * @default {}
   * @deprecated Please use `slotProps`.
   */ componentsProps: (0, (/*@__PURE__*/$parcel$interopDefault($3Zour))).object,
    /**
   * The default value.
   * Used when the component is not controlled.
   */ defaultValue: (0, (/*@__PURE__*/$parcel$interopDefault($3Zour))).any,
    /**
   * If `true`, the picker and text field are disabled.
   * @default false
   */ disabled: (0, (/*@__PURE__*/$parcel$interopDefault($3Zour))).bool,
    /**
   * If `true`, disable values after the current date for date components, time for time components and both for date time components.
   * @default false
   */ disableFuture: (0, (/*@__PURE__*/$parcel$interopDefault($3Zour))).bool,
    /**
   * Do not ignore date part when validating min/max time.
   * @default false
   */ disableIgnoringDatePartForTimeValidation: (0, (/*@__PURE__*/$parcel$interopDefault($3Zour))).bool,
    /**
   * If `true`, the open picker button will not be rendered (renders only the field).
   * @default false
   */ disableOpenPicker: (0, (/*@__PURE__*/$parcel$interopDefault($3Zour))).bool,
    /**
   * If `true`, disable values before the current date for date components, time for time components and both for date time components.
   * @default false
   */ disablePast: (0, (/*@__PURE__*/$parcel$interopDefault($3Zour))).bool,
    /**
   * Format of the date when rendered in the input(s).
   * Defaults to localized format based on the used `views`.
   */ format: (0, (/*@__PURE__*/$parcel$interopDefault($3Zour))).string,
    /**
   * Density of the format when rendered in the input.
   * Setting `formatDensity` to `"spacious"` will add a space before and after each `/`, `-` and `.` character.
   * @default "dense"
   */ formatDensity: (0, (/*@__PURE__*/$parcel$interopDefault($3Zour))).oneOf([
        'dense',
        'spacious'
    ]),
    /**
   * Pass a ref to the `input` element.
   */ inputRef: (0, $82c4d2ab89e86c16$export$2e2bcd8739ae039),
    /**
   * The label content.
   */ label: (0, (/*@__PURE__*/$parcel$interopDefault($3Zour))).node,
    /**
   * Locale for components texts.
   * Allows overriding texts coming from `LocalizationProvider` and `theme`.
   */ localeText: (0, (/*@__PURE__*/$parcel$interopDefault($3Zour))).object,
    /**
   * Maximal selectable time.
   * The date part of the object will be ignored unless `props.disableIgnoringDatePartForTimeValidation === true`.
   */ maxTime: (0, (/*@__PURE__*/$parcel$interopDefault($3Zour))).any,
    /**
   * Minimal selectable time.
   * The date part of the object will be ignored unless `props.disableIgnoringDatePartForTimeValidation === true`.
   */ minTime: (0, (/*@__PURE__*/$parcel$interopDefault($3Zour))).any,
    /**
   * Step over minutes.
   * @default 1
   */ minutesStep: (0, (/*@__PURE__*/$parcel$interopDefault($3Zour))).number,
    /**
   * Name attribute used by the `input` element in the Field.
   */ name: (0, (/*@__PURE__*/$parcel$interopDefault($3Zour))).string,
    /**
   * Callback fired when the value is accepted.
   * @template TValue The value type. Will be either the same type as `value` or `null`. Can be in `[start, end]` format in case of range value.
   * @param {TValue} value The value that was just accepted.
   */ onAccept: (0, (/*@__PURE__*/$parcel$interopDefault($3Zour))).func,
    /**
   * Callback fired when the value changes.
   * @template TValue The value type. Will be either the same type as `value` or `null`. Can be in `[start, end]` format in case of range value.
   * @template TError The validation error type. Will be either `string` or a `null`. Can be in `[start, end]` format in case of range value.
   * @param {TValue} value The new value.
   * @param {FieldChangeHandlerContext<TError>} context The context containing the validation result of the current value.
   */ onChange: (0, (/*@__PURE__*/$parcel$interopDefault($3Zour))).func,
    /**
   * Callback fired when the popup requests to be closed.
   * Use in controlled mode (see `open`).
   */ onClose: (0, (/*@__PURE__*/$parcel$interopDefault($3Zour))).func,
    /**
   * Callback fired when the error associated to the current value changes.
   * If the error has a non-null value, then the `TextField` will be rendered in `error` state.
   *
   * @template TValue The value type. Will be either the same type as `value` or `null`. Can be in `[start, end]` format in case of range value.
   * @template TError The validation error type. Will be either `string` or a `null`. Can be in `[start, end]` format in case of range value.
   * @param {TError} error The new error describing why the current value is not valid.
   * @param {TValue} value The value associated to the error.
   */ onError: (0, (/*@__PURE__*/$parcel$interopDefault($3Zour))).func,
    /**
   * Callback fired when the popup requests to be opened.
   * Use in controlled mode (see `open`).
   */ onOpen: (0, (/*@__PURE__*/$parcel$interopDefault($3Zour))).func,
    /**
   * Callback fired when the selected sections change.
   * @param {FieldSelectedSections} newValue The new selected sections.
   */ onSelectedSectionsChange: (0, (/*@__PURE__*/$parcel$interopDefault($3Zour))).func,
    /**
   * Callback fired on view change.
   * @template TView
   * @param {TView} view The new view.
   */ onViewChange: (0, (/*@__PURE__*/$parcel$interopDefault($3Zour))).func,
    /**
   * Control the popup or dialog open state.
   * @default false
   */ open: (0, (/*@__PURE__*/$parcel$interopDefault($3Zour))).bool,
    /**
   * The default visible view.
   * Used when the component view is not controlled.
   * Must be a valid option from `views` list.
   */ openTo: (0, (/*@__PURE__*/$parcel$interopDefault($3Zour))).oneOf([
        'hours',
        'minutes',
        'seconds'
    ]),
    /**
   * Force rendering in particular orientation.
   */ orientation: (0, (/*@__PURE__*/$parcel$interopDefault($3Zour))).oneOf([
        'landscape',
        'portrait'
    ]),
    readOnly: (0, (/*@__PURE__*/$parcel$interopDefault($3Zour))).bool,
    /**
   * If `true`, disable heavy animations.
   * @default `@media(prefers-reduced-motion: reduce)` || `navigator.userAgent` matches Android <10 or iOS <13
   */ reduceAnimations: (0, (/*@__PURE__*/$parcel$interopDefault($3Zour))).bool,
    /**
   * The date used to generate the new value when both `value` and `defaultValue` are empty.
   * @default The closest valid date-time using the validation props, except callbacks like `shouldDisable<...>`.
   */ referenceDate: (0, (/*@__PURE__*/$parcel$interopDefault($3Zour))).any,
    /**
   * The currently selected sections.
   * This prop accept four formats:
   * 1. If a number is provided, the section at this index will be selected.
   * 2. If an object with a `startIndex` and `endIndex` properties are provided, the sections between those two indexes will be selected.
   * 3. If a string of type `FieldSectionType` is provided, the first section with that name will be selected.
   * 4. If `null` is provided, no section will be selected
   * If not provided, the selected sections will be handled internally.
   */ selectedSections: (0, (/*@__PURE__*/$parcel$interopDefault($3Zour))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($3Zour))).oneOf([
            'all',
            'day',
            'hours',
            'meridiem',
            'minutes',
            'month',
            'seconds',
            'weekDay',
            'year'
        ]),
        (0, (/*@__PURE__*/$parcel$interopDefault($3Zour))).number,
        (0, (/*@__PURE__*/$parcel$interopDefault($3Zour))).shape({
            endIndex: (0, (/*@__PURE__*/$parcel$interopDefault($3Zour))).number.isRequired,
            startIndex: (0, (/*@__PURE__*/$parcel$interopDefault($3Zour))).number.isRequired
        })
    ]),
    /**
   * Disable specific clock time.
   * @param {number} clockValue The value to check.
   * @param {TimeView} view The clock type of the timeValue.
   * @returns {boolean} If `true` the time will be disabled.
   * @deprecated Consider using `shouldDisableTime`.
   */ shouldDisableClock: (0, (/*@__PURE__*/$parcel$interopDefault($3Zour))).func,
    /**
   * Disable specific time.
   * @template TDate
   * @param {TDate} value The value to check.
   * @param {TimeView} view The clock type of the timeValue.
   * @returns {boolean} If `true` the time will be disabled.
   */ shouldDisableTime: (0, (/*@__PURE__*/$parcel$interopDefault($3Zour))).func,
    /**
   * The props used for each component slot.
   * @default {}
   */ slotProps: (0, (/*@__PURE__*/$parcel$interopDefault($3Zour))).object,
    /**
   * Overridable component slots.
   * @default {}
   */ slots: (0, (/*@__PURE__*/$parcel$interopDefault($3Zour))).object,
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: (0, (/*@__PURE__*/$parcel$interopDefault($3Zour))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($3Zour))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($3Zour))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($3Zour))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($3Zour))).object,
            (0, (/*@__PURE__*/$parcel$interopDefault($3Zour))).bool
        ])),
        (0, (/*@__PURE__*/$parcel$interopDefault($3Zour))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($3Zour))).object
    ]),
    /**
   * Choose which timezone to use for the value.
   * Example: "default", "system", "UTC", "America/New_York".
   * If you pass values from other timezones to some props, they will be converted to this timezone before being used.
   * @see See the {@link https://mui.com/x/react-date-pickers/timezone/ timezones documention} for more details.
   * @default The timezone of the `value` or `defaultValue` prop is defined, 'default' otherwise.
   */ timezone: (0, (/*@__PURE__*/$parcel$interopDefault($3Zour))).string,
    /**
   * The selected value.
   * Used when the component is controlled.
   */ value: (0, (/*@__PURE__*/$parcel$interopDefault($3Zour))).any,
    /**
   * The visible view.
   * Used when the component view is controlled.
   * Must be a valid option from `views` list.
   */ view: (0, (/*@__PURE__*/$parcel$interopDefault($3Zour))).oneOf([
        'hours',
        'minutes',
        'seconds'
    ]),
    /**
   * Define custom view renderers for each section.
   * If `null`, the section will only have field editing.
   * If `undefined`, internally defined view will be the used.
   */ viewRenderers: (0, (/*@__PURE__*/$parcel$interopDefault($3Zour))).shape({
        hours: (0, (/*@__PURE__*/$parcel$interopDefault($3Zour))).func,
        minutes: (0, (/*@__PURE__*/$parcel$interopDefault($3Zour))).func,
        seconds: (0, (/*@__PURE__*/$parcel$interopDefault($3Zour))).func
    }),
    /**
   * Available views.
   */ views: (0, (/*@__PURE__*/$parcel$interopDefault($3Zour))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($3Zour))).oneOf([
        'hours',
        'minutes',
        'seconds'
    ]).isRequired)
};




var $9wx12 = parcelRequire("9wx12");
const $e1ca61c0f84d2b23$var$_excluded = [
    "desktopModeMediaQuery"
];
/**
 * Demos:
 *
 * - [TimePicker](https://mui.com/x/react-date-pickers/time-picker/)
 * - [Validation](https://mui.com/x/react-date-pickers/validation/)
 *
 * API:
 *
 * - [TimePicker API](https://mui.com/x/api/date-pickers/time-picker/)
 */ const $e1ca61c0f84d2b23$export$5f876910ea565cd3 = /*#__PURE__*/ $gJYWc.forwardRef(function TimePicker(inProps, ref) {
    const props = (0, $6959428021af84ce$export$2e2bcd8739ae039)({
        props: inProps,
        name: 'MuiTimePicker'
    });
    const { desktopModeMediaQuery: desktopModeMediaQuery = (0, $870e97cd00438bdc$export$9ae5b19305db48ce) } = props, other = (0, $cTAWX.default)(props, $e1ca61c0f84d2b23$var$_excluded);
    // defaults to `true` in environments where `window.matchMedia` would not be available (i.e. test/jsdom)
    const isDesktop = (0, $94c6dc53e4570cec$export$2e2bcd8739ae039)(desktopModeMediaQuery, {
        defaultMatches: true
    });
    if (isDesktop) return /*#__PURE__*/ (0, $9wx12.jsx)((0, $680bff3bce231f47$export$c2eea9c279c6035b), (0, $3VnFq.default)({
        ref: ref
    }, other));
    return /*#__PURE__*/ (0, $9wx12.jsx)((0, $b6689091eefb3e69$export$984018df37898b81), (0, $3VnFq.default)({
        ref: ref
    }, other));
});





var $gJYWc = parcelRequire("gJYWc");

const $1df24fc480d4c6b5$export$a7fed597f4b8afd8 = ({ ad: ad, onSubmit: onSubmit })=>{
    const [dateValue, setDate] = (0, $gJYWc.useState)(null);
    const [startTimeValue, setStartTime] = (0, $gJYWc.useState)(null);
    const [endTimeValue, setEndTime] = (0, $gJYWc.useState)(null);
    const [comment, changeComment] = (0, $gJYWc.useState)('');
    const [email, setEmail] = (0, $gJYWc.useState)('');
    const { t: t } = (0, $980e4b3a97f1ad67$export$9fc83ad70ead8663)();
    const [isError, setError] = (0, $gJYWc.useState)(null);
    const onButtonPress = ()=>{
        const isFilledIn = dateValue && startTimeValue && endTimeValue && email;
        if (!isFilledIn) return setError(true);
        onSubmit({
            date: dateValue?.format('DD MMMM YYYY'),
            start: startTimeValue?.format('HH:mm'),
            end: endTimeValue?.format('HH:mm'),
            total: endTimeValue.diff(startTimeValue, 'hours'),
            url: window.location.href,
            venue: ad.name,
            comment: comment,
            email: email
        });
    };
    return /*#__PURE__*/ (0, $9wx12.jsxs)((0, $9wx12.Fragment), {
        children: [
            /*#__PURE__*/ (0, $9wx12.jsx)((0, $92216236ada60417$export$2e2bcd8739ae039), {
                className: "flex-1",
                sx: {
                    minWidth: '260px',
                    mr: '20px'
                },
                children: /*#__PURE__*/ (0, $9wx12.jsx)((0, $0f9f0d79038d27f1$export$2e2bcd8739ae039), {
                    sx: {
                        boxShadow: 'none'
                    },
                    children: /*#__PURE__*/ (0, $9wx12.jsxs)((0, $f1b4cb86cd061e99$export$2e2bcd8739ae039), {
                        children: [
                            /*#__PURE__*/ (0, $9wx12.jsx)((0, $7cffc73c3124b15c$export$2e2bcd8739ae039), {
                                component: "img",
                                height: "140",
                                image: ad.logo
                            }),
                            /*#__PURE__*/ (0, $9wx12.jsx)((0, $b4083ea3a052dee9$export$2e2bcd8739ae039), {
                                fontStyle: "bold",
                                variant: "h6",
                                align: "center",
                                m: 1,
                                children: ad.name
                            }),
                            /*#__PURE__*/ (0, $9wx12.jsx)((0, $3c2c4123bc0edf41$export$316b0abfaee5c8dd), {})
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0, $9wx12.jsxs)((0, $92216236ada60417$export$2e2bcd8739ae039), {
                className: "flex-1",
                sx: {
                    minWidth: '300px'
                },
                children: [
                    /*#__PURE__*/ (0, $9wx12.jsx)((0, $b4083ea3a052dee9$export$2e2bcd8739ae039), {
                        fontWeight: "fontWeightMedium",
                        fontSize: 20,
                        children: "Message Host"
                    }),
                    /*#__PURE__*/ (0, $9wx12.jsxs)("div", {
                        className: "my-5",
                        children: [
                            /*#__PURE__*/ (0, $9wx12.jsx)((0, $b1e4eb69ad197794$export$5109c6dd95d8fb00), {
                                disablePast: true,
                                value: dateValue,
                                onChange: (e)=>setDate(e),
                                sx: {
                                    width: '100%',
                                    mb: 1
                                },
                                className: "my-10",
                                label: "Date"
                            }),
                            /*#__PURE__*/ (0, $9wx12.jsxs)("div", {
                                className: "mb-3",
                                children: [
                                    /*#__PURE__*/ (0, $9wx12.jsx)((0, $e1ca61c0f84d2b23$export$5f876910ea565cd3), {
                                        timeSteps: {
                                            minutes: 60
                                        },
                                        value: startTimeValue,
                                        onChange: (e)=>setStartTime(e),
                                        sx: {
                                            width: '50%'
                                        },
                                        ampm: false,
                                        label: "Start time"
                                    }),
                                    /*#__PURE__*/ (0, $9wx12.jsx)((0, $e1ca61c0f84d2b23$export$5f876910ea565cd3), {
                                        ampm: false,
                                        timeSteps: {
                                            minutes: 60
                                        },
                                        value: endTimeValue,
                                        onChange: (e)=>setEndTime(e),
                                        sx: {
                                            width: '50%'
                                        },
                                        label: "End time"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $9wx12.jsx)((0, $1f9512c77b4eaf9c$export$2e2bcd8739ae039), {
                                label: "Email",
                                type: "email",
                                value: email,
                                onChange: (e)=>setEmail(e.target.value),
                                multiline: true,
                                sx: {
                                    width: '100%',
                                    mb: 1
                                }
                            }),
                            /*#__PURE__*/ (0, $9wx12.jsx)((0, $1f9512c77b4eaf9c$export$2e2bcd8739ae039), {
                                label: "Comment",
                                value: comment,
                                onChange: (e)=>changeComment(e.target.value),
                                multiline: true,
                                rows: 4,
                                sx: {
                                    width: '100%',
                                    mb: 1
                                }
                            }),
                            /*#__PURE__*/ (0, $9wx12.jsx)((0, $95b3a1ef1ddc1e78$export$2e2bcd8739ae039), {
                                sx: {
                                    minWidth: '100%',
                                    mb: 1
                                },
                                variant: "contained",
                                color: "primary",
                                onClick: onButtonPress,
                                children: "Message host"
                            }),
                            /*#__PURE__*/ (0, $9wx12.jsx)((0, $b4083ea3a052dee9$export$2e2bcd8739ae039), {
                                className: "text-orange-800",
                                children: isError && 'Please fill in the date, interval and your email'
                            })
                        ]
                    })
                ]
            })
        ]
    });
};


const $b68acc4fe9dd0d56$export$3877e99530b0c773 = async (params)=>{
    try {
        const response = await fetch(`${"/"}api/booking`, {
            method: 'POST',
            mode: "cors",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify(params)
        });
        const body = await response.json();
        console.log(body);
        return {
            status: 'success',
            body: body
        };
    } catch (e) {
        console.log(e);
        return {
            status: 'error'
        };
    }
};



var $9wx12 = parcelRequire("9wx12");
parcelRequire("gJYWc");



const $09fb0dc966ec1101$export$ffa3d9fee6fd705a = ()=>{
    return /*#__PURE__*/ (0, $9wx12.jsx)((0, $0f9f0d79038d27f1$export$2e2bcd8739ae039), {
        sx: {
            boxShadow: 'none'
        },
        children: /*#__PURE__*/ (0, $9wx12.jsxs)((0, $f1b4cb86cd061e99$export$2e2bcd8739ae039), {
            children: [
                /*#__PURE__*/ (0, $9wx12.jsx)((0, $b4083ea3a052dee9$export$2e2bcd8739ae039), {
                    children: "Your message has been sent"
                }),
                /*#__PURE__*/ (0, $9wx12.jsx)((0, $b4083ea3a052dee9$export$2e2bcd8739ae039), {
                    color: "text.secondary",
                    children: "Your host will contact you shortly"
                })
            ]
        })
    });
};



var $9wx12 = parcelRequire("9wx12");
parcelRequire("gJYWc");



const $cf1333c8223c5f64$export$edf27be85e5f6da0 = ()=>{
    return /*#__PURE__*/ (0, $9wx12.jsx)((0, $0f9f0d79038d27f1$export$2e2bcd8739ae039), {
        sx: {
            boxShadow: 'none'
        },
        children: /*#__PURE__*/ (0, $9wx12.jsxs)((0, $f1b4cb86cd061e99$export$2e2bcd8739ae039), {
            children: [
                /*#__PURE__*/ (0, $9wx12.jsx)((0, $b4083ea3a052dee9$export$2e2bcd8739ae039), {
                    children: "Something went wrong"
                }),
                /*#__PURE__*/ (0, $9wx12.jsx)((0, $b4083ea3a052dee9$export$2e2bcd8739ae039), {
                    color: "text.secondary",
                    children: "Please try sending the request again"
                })
            ]
        })
    });
};


const $ebceecedc69dbfcd$var$style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    bgcolor: 'background.paper',
    boxShadow: 24,
    p: 3,
    outline: 0
};
const $ebceecedc69dbfcd$export$1327ceb49c2c80f0 = ({ isOpen: isOpen, setOpen: setOpen, ad: ad })=>{
    const [isLoading, setLoading] = (0, $gJYWc.useState)(false);
    const [isSuccess, setSuccess] = (0, $gJYWc.useState)(false);
    const [isError, setError] = (0, $gJYWc.useState)(false);
    const onSubmit = async (params)=>{
        setLoading(true);
        const response = await (0, $b68acc4fe9dd0d56$export$3877e99530b0c773)(params);
        if (response.status === 'success') {
            setLoading(false);
            setSuccess(true);
            return;
        }
        if (response.status === 'error') {
            setLoading(false);
            setError(true);
        }
    };
    const onClose = ()=>{
        setOpen(false);
        setError(false);
        setLoading(false);
        setSuccess(false);
    };
    return /*#__PURE__*/ (0, $9wx12.jsx)((0, $9479e61072db3f56$export$2e2bcd8739ae039), {
        open: isOpen,
        onClose: onClose,
        children: /*#__PURE__*/ (0, $9wx12.jsx)((0, $5d4a7e2c608c4487$export$2e2bcd8739ae039), {
            in: isOpen,
            children: /*#__PURE__*/ (0, $9wx12.jsxs)((0, $92216236ada60417$export$2e2bcd8739ae039), {
                className: "flex flex-wrap",
                sx: $ebceecedc69dbfcd$var$style,
                children: [
                    !isLoading && !isSuccess && !isError && /*#__PURE__*/ (0, $9wx12.jsx)((0, $1df24fc480d4c6b5$export$a7fed597f4b8afd8), {
                        ad: ad,
                        onSubmit: onSubmit
                    }),
                    isLoading && /*#__PURE__*/ (0, $9wx12.jsx)((0, $895ba70d11219ed4$export$2e2bcd8739ae039), {}),
                    isSuccess && /*#__PURE__*/ (0, $9wx12.jsx)((0, $09fb0dc966ec1101$export$ffa3d9fee6fd705a), {}),
                    isError && /*#__PURE__*/ (0, $9wx12.jsx)((0, $cf1333c8223c5f64$export$edf27be85e5f6da0), {})
                ]
            })
        })
    });
};



var $9wx12 = parcelRequire("9wx12");
parcelRequire("gJYWc");
var $1e6161f6ac3ea611$exports = {};
"use strict";
'use client';

var $hrFuR = parcelRequire("hrFuR");
Object.defineProperty($1e6161f6ac3ea611$exports, "__esModule", {
    value: true
});
$1e6161f6ac3ea611$exports.default = void 0;

var $1e6161f6ac3ea611$var$React = $1e6161f6ac3ea611$var$_interopRequireWildcard((parcelRequire("gJYWc")));

var $1e6161f6ac3ea611$var$_createSvgIcon = $hrFuR((parcelRequire("lXMfO")));

var $9wx12 = parcelRequire("9wx12");
function $1e6161f6ac3ea611$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($1e6161f6ac3ea611$var$_getRequireWildcardCache = function(e) {
        return e ? t : r;
    })(e);
}
function $1e6161f6ac3ea611$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        default: e
    };
    var t = $1e6161f6ac3ea611$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n.default = e, t && t.set(e, n), n;
}
var $1e6161f6ac3ea611$var$_default = $1e6161f6ac3ea611$exports.default = (0, $1e6161f6ac3ea611$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $9wx12.jsx)("path", {
    d: "M5 3h14a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2m13 2h-2.5A3.5 3.5 0 0 0 12 8.5V11h-2v3h2v7h3v-7h3v-3h-3V9a1 1 0 0 1 1-1h2V5z"
}), 'Facebook');


var $33505fa696f7180c$exports = {};
"use strict";
'use client';

var $hrFuR = parcelRequire("hrFuR");
Object.defineProperty($33505fa696f7180c$exports, "__esModule", {
    value: true
});
$33505fa696f7180c$exports.default = void 0;

var $33505fa696f7180c$var$React = $33505fa696f7180c$var$_interopRequireWildcard((parcelRequire("gJYWc")));

var $33505fa696f7180c$var$_createSvgIcon = $hrFuR((parcelRequire("lXMfO")));

var $9wx12 = parcelRequire("9wx12");
function $33505fa696f7180c$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($33505fa696f7180c$var$_getRequireWildcardCache = function(e) {
        return e ? t : r;
    })(e);
}
function $33505fa696f7180c$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        default: e
    };
    var t = $33505fa696f7180c$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n.default = e, t && t.set(e, n), n;
}
var $33505fa696f7180c$var$_default = $33505fa696f7180c$exports.default = (0, $33505fa696f7180c$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $9wx12.jsx)("path", {
    d: "M7.8 2h8.4C19.4 2 22 4.6 22 7.8v8.4a5.8 5.8 0 0 1-5.8 5.8H7.8C4.6 22 2 19.4 2 16.2V7.8A5.8 5.8 0 0 1 7.8 2m-.2 2A3.6 3.6 0 0 0 4 7.6v8.8C4 18.39 5.61 20 7.6 20h8.8a3.6 3.6 0 0 0 3.6-3.6V7.6C20 5.61 18.39 4 16.4 4H7.6m9.65 1.5a1.25 1.25 0 0 1 1.25 1.25A1.25 1.25 0 0 1 17.25 8 1.25 1.25 0 0 1 16 6.75a1.25 1.25 0 0 1 1.25-1.25M12 7a5 5 0 0 1 5 5 5 5 0 0 1-5 5 5 5 0 0 1-5-5 5 5 0 0 1 5-5m0 2a3 3 0 0 0-3 3 3 3 0 0 0 3 3 3 3 0 0 0 3-3 3 3 0 0 0-3-3z"
}), 'Instagram');


var $5a8c177d582f4d36$exports = {};
"use strict";
"use client";

var $hrFuR = parcelRequire("hrFuR");
Object.defineProperty($5a8c177d582f4d36$exports, "__esModule", {
    value: true
});
$5a8c177d582f4d36$exports.default = void 0;

var $5a8c177d582f4d36$var$_createSvgIcon = $hrFuR((parcelRequire("lXMfO")));

var $9wx12 = parcelRequire("9wx12");
var $5a8c177d582f4d36$var$_default = $5a8c177d582f4d36$exports.default = (0, $5a8c177d582f4d36$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $9wx12.jsx)("path", {
    d: "M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2m6.93 6h-2.95c-.32-1.25-.78-2.45-1.38-3.56 1.84.63 3.37 1.91 4.33 3.56M12 4.04c.83 1.2 1.48 2.53 1.91 3.96h-3.82c.43-1.43 1.08-2.76 1.91-3.96M4.26 14C4.1 13.36 4 12.69 4 12s.1-1.36.26-2h3.38c-.08.66-.14 1.32-.14 2 0 .68.06 1.34.14 2zm.82 2h2.95c.32 1.25.78 2.45 1.38 3.56-1.84-.63-3.37-1.9-4.33-3.56m2.95-8H5.08c.96-1.66 2.49-2.93 4.33-3.56C8.81 5.55 8.35 6.75 8.03 8M12 19.96c-.83-1.2-1.48-2.53-1.91-3.96h3.82c-.43 1.43-1.08 2.76-1.91 3.96M14.34 14H9.66c-.09-.66-.16-1.32-.16-2 0-.68.07-1.35.16-2h4.68c.09.65.16 1.32.16 2 0 .68-.07 1.34-.16 2m.25 5.56c.6-1.11 1.06-2.31 1.38-3.56h2.95c-.96 1.65-2.49 2.93-4.33 3.56M16.36 14c.08-.66.14-1.32.14-2 0-.68-.06-1.34-.14-2h3.38c.16.64.26 1.31.26 2s-.1 1.36-.26 2z"
}), 'Language');


const $37f19802e3445ced$export$c847549a613b9060 = ({ website: website, facebook: facebook, instagram: instagram })=>/*#__PURE__*/ (0, $9wx12.jsxs)("div", {
        className: "text-center mt-4",
        children: [
            facebook && /*#__PURE__*/ (0, $9wx12.jsx)("a", {
                href: facebook,
                target: "_blank",
                children: /*#__PURE__*/ (0, $9wx12.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1e6161f6ac3ea611$exports))), {
                    fontSize: "large",
                    color: "primary"
                })
            }),
            instagram && /*#__PURE__*/ (0, $9wx12.jsx)("a", {
                href: instagram,
                target: "_blank",
                children: /*#__PURE__*/ (0, $9wx12.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($33505fa696f7180c$exports))), {
                    fontSize: "large",
                    color: "primary"
                })
            }),
            website && /*#__PURE__*/ (0, $9wx12.jsx)("a", {
                href: website,
                target: "_blank",
                children: /*#__PURE__*/ (0, $9wx12.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5a8c177d582f4d36$exports))), {
                    fontSize: "large",
                    color: "primary"
                })
            })
        ]
    });


const $d4208330c64e6044$export$ac3bdfe4cb17f64e = (ad)=>{
    const { price: price, id: id, min_time: min_time } = ad;
    const [isOpenModel, setModelOpen] = (0, $gJYWc.useState)(false);
    return /*#__PURE__*/ (0, $9wx12.jsxs)("div", {
        className: "lg:w-[300px] w-full mx-auto sm:max-w-[500px]",
        children: [
            /*#__PURE__*/ (0, $9wx12.jsx)("div", {
                className: "sticky top-0",
                children: /*#__PURE__*/ (0, $9wx12.jsx)((0, $0f9f0d79038d27f1$export$2e2bcd8739ae039), {
                    className: "w-90%",
                    sx: {
                        boxShadow: '0 0 0 1px #0000000f;',
                        mb: 2
                    },
                    children: /*#__PURE__*/ (0, $9wx12.jsxs)((0, $f1b4cb86cd061e99$export$2e2bcd8739ae039), {
                        children: [
                            /*#__PURE__*/ (0, $9wx12.jsx)((0, $7cffc73c3124b15c$export$2e2bcd8739ae039), {
                                component: "img",
                                height: "140",
                                image: ad.logo
                            }),
                            /*#__PURE__*/ (0, $9wx12.jsx)((0, $b4083ea3a052dee9$export$2e2bcd8739ae039), {
                                variant: "h6",
                                align: "center",
                                children: ad.name
                            }),
                            /*#__PURE__*/ (0, $9wx12.jsx)((0, $b4083ea3a052dee9$export$2e2bcd8739ae039), {
                                align: "center",
                                color: "text.secondary",
                                children: ad.address
                            }),
                            /*#__PURE__*/ (0, $9wx12.jsx)((0, $37f19802e3445ced$export$c847549a613b9060), {
                                website: ad.website,
                                facebook: ad.facebook,
                                instagram: ad.instagram
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0, $9wx12.jsx)((0, $ebceecedc69dbfcd$export$1327ceb49c2c80f0), {
                isOpen: isOpenModel,
                setOpen: setModelOpen,
                ad: ad
            })
        ]
    });
};




const $09accb3514a271c7$export$7c799e71f5549651 = ()=>{
    const { id: id } = (0, $a35327dc535bf969$export$99eaa27ddbbb95ef)();
    const [ad, setAdd] = (0, $gJYWc.useState)();
    const { i18n: i18n } = (0, $980e4b3a97f1ad67$export$9fc83ad70ead8663)();
    const currentLanguage = i18n.resolvedLanguage;
    (0, $gJYWc.useEffect)(()=>{
        if (!id) return;
        const fetchAds = async ()=>{
            const ads = await (0, $70a97169caddc04c$export$e335e813e295bb79)(id, currentLanguage);
            setAdd(ads);
        };
        fetchAds().catch(console.error);
    }, [
        currentLanguage
    ]);
    return /*#__PURE__*/ (0, $9wx12.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $9wx12.jsx)((0, $fc72cc536184e560$export$8b251419efc915eb), {}),
            /*#__PURE__*/ (0, $9wx12.jsx)((0, $b615a63ae467164a$export$73051e5675ca1011), {
                images: ad?.hero_images
            }),
            /*#__PURE__*/ (0, $9wx12.jsxs)("div", {
                className: "max-w-[1024px] w-auto m-auto flex my-5 lg:my-20 gap-16 flex-wrap relative",
                children: [
                    /*#__PURE__*/ (0, $9wx12.jsx)((0, $1a9b81bce114f748$export$393edc798c47379d), {
                        ...ad
                    }),
                    /*#__PURE__*/ (0, $9wx12.jsx)((0, $d4208330c64e6044$export$ac3bdfe4cb17f64e), {
                        ...ad
                    })
                ]
            }),
            /*#__PURE__*/ (0, $9wx12.jsx)((0, $56201fc8fe14bcc5$export$a06f1c675e846f6f), {})
        ]
    });
};



var $9wx12 = parcelRequire("9wx12");
parcelRequire("gJYWc");



const $4b4ce03023b20fd7$export$35ce064bf8784099 = ()=>{
    const { t: t } = (0, $980e4b3a97f1ad67$export$9fc83ad70ead8663)();
    return /*#__PURE__*/ (0, $9wx12.jsxs)((0, $9wx12.Fragment), {
        children: [
            /*#__PURE__*/ (0, $9wx12.jsx)((0, $fc72cc536184e560$export$8b251419efc915eb), {}),
            /*#__PURE__*/ (0, $9wx12.jsxs)("div", {
                className: "h-[calc(100%-276px)] flex justify-center items-center flex-col",
                children: [
                    /*#__PURE__*/ (0, $9wx12.jsx)("div", {
                        className: "font-bold",
                        children: t("contacts.title")
                    }),
                    /*#__PURE__*/ (0, $9wx12.jsx)("div", {
                        className: "mb-4",
                        children: "mikheyrojo@gmail.com"
                    }),
                    /*#__PURE__*/ (0, $9wx12.jsxs)("div", {
                        className: "flex gap-4 mb-4",
                        children: [
                            /*#__PURE__*/ (0, $9wx12.jsx)("a", {
                                href: "https://t.me/let_s_family",
                                target: "_blank",
                                rel: "noopener noreferrer",
                                children: /*#__PURE__*/ (0, $9wx12.jsx)("img", {
                                    width: "40",
                                    height: "40",
                                    src: "https://upload.wikimedia.org/wikipedia/commons/8/82/Telegram_logo.svg",
                                    alt: "Telegram"
                                })
                            }),
                            /*#__PURE__*/ (0, $9wx12.jsx)("a", {
                                href: "https://www.instagram.com/let_s_family?igsh=Mmk1d2NlNjVpM3g3",
                                target: "_blank",
                                rel: "noopener noreferrer",
                                children: /*#__PURE__*/ (0, $9wx12.jsx)("img", {
                                    width: "40",
                                    height: "40",
                                    src: "https://upload.wikimedia.org/wikipedia/commons/e/e7/Instagram_logo_2016.svg",
                                    alt: "Instagram"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $9wx12.jsx)("img", {
                        width: "100",
                        height: "100",
                        src: "https://res.cloudinary.com/dhlzvktzj/image/upload/v1710593110/sunni/star-pirate_mpr4hk.svg"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $9wx12.jsx)((0, $56201fc8fe14bcc5$export$a06f1c675e846f6f), {})
        ]
    });
};



var $9wx12 = parcelRequire("9wx12");

var $gJYWc = parcelRequire("gJYWc");







const $dd2b210167fce8db$export$690878eeeaffbdc8 = ()=>{
    const { t: t } = (0, $980e4b3a97f1ad67$export$9fc83ad70ead8663)();
    return /*#__PURE__*/ (0, $9wx12.jsxs)((0, $9wx12.Fragment), {
        children: [
            /*#__PURE__*/ (0, $9wx12.jsx)((0, $fc72cc536184e560$export$8b251419efc915eb), {}),
            /*#__PURE__*/ (0, $9wx12.jsxs)("div", {
                className: "h-[calc(100%-276px)] flex justify-center items-center flex-col",
                children: [
                    /*#__PURE__*/ (0, $9wx12.jsx)("div", {
                        className: "font-bold text-3xl",
                        children: t('faq.title')
                    }),
                    /*#__PURE__*/ (0, $9wx12.jsx)("div", {
                        className: "mb-4",
                        children: /*#__PURE__*/ (0, $9wx12.jsxs)((0, $e247548612617cb3$export$2e2bcd8739ae039), {
                            sx: {
                                width: '100%',
                                bgcolor: 'background.paper'
                            },
                            children: [
                                /*#__PURE__*/ (0, $9wx12.jsx)($dd2b210167fce8db$var$ListUnit, {
                                    question: t('faq.question-1'),
                                    answer: t('faq.answer-1')
                                }),
                                /*#__PURE__*/ (0, $9wx12.jsx)($dd2b210167fce8db$var$ListUnit, {
                                    question: t('faq.question-2'),
                                    answer: t('faq.answer-2')
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $9wx12.jsx)((0, $56201fc8fe14bcc5$export$a06f1c675e846f6f), {})
        ]
    });
};
const $dd2b210167fce8db$var$ListUnit = ({ question: question, answer: answer })=>/*#__PURE__*/ (0, $9wx12.jsx)((0, $fbd2d21ccc73b907$export$2e2bcd8739ae039), {
        alignItems: "flex-start",
        children: /*#__PURE__*/ (0, $9wx12.jsx)((0, $7e347bdafa1acea0$export$2e2bcd8739ae039), {
            primary: question,
            secondary: /*#__PURE__*/ (0, $9wx12.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($gJYWc))).Fragment, {
                children: /*#__PURE__*/ (0, $9wx12.jsxs)((0, $b4083ea3a052dee9$export$2e2bcd8739ae039), {
                    sx: {
                        display: 'inline'
                    },
                    component: "span",
                    variant: "body2",
                    color: "text.primary",
                    children: [
                        answer,
                        " "
                    ]
                })
            })
        })
    });



var $9wx12 = parcelRequire("9wx12");
parcelRequire("gJYWc");




const $60221e927fa06151$export$3131deacacdc712c = ()=>{
    const { t: t } = (0, $980e4b3a97f1ad67$export$9fc83ad70ead8663)();
    return /*#__PURE__*/ (0, $9wx12.jsxs)((0, $9wx12.Fragment), {
        children: [
            /*#__PURE__*/ (0, $9wx12.jsx)((0, $fc72cc536184e560$export$8b251419efc915eb), {}),
            /*#__PURE__*/ (0, $9wx12.jsxs)("div", {
                className: "min-h-[calc(100%-276px)] flex justify-center items-center flex-col",
                children: [
                    /*#__PURE__*/ (0, $9wx12.jsx)("div", {
                        className: "font-bold my-5  text-2xl",
                        children: t('terms.title')
                    }),
                    /*#__PURE__*/ (0, $9wx12.jsxs)("div", {
                        className: "mb-4 max-w-[50%]",
                        children: [
                            /*#__PURE__*/ (0, $9wx12.jsx)((0, $b4083ea3a052dee9$export$2e2bcd8739ae039), {
                                paragraph: true,
                                children: t('terms.paragraph-1')
                            }),
                            /*#__PURE__*/ (0, $9wx12.jsx)((0, $b4083ea3a052dee9$export$2e2bcd8739ae039), {
                                paragraph: true,
                                children: t('terms.paragraph-2')
                            }),
                            /*#__PURE__*/ (0, $9wx12.jsx)((0, $b4083ea3a052dee9$export$2e2bcd8739ae039), {
                                paragraph: true,
                                children: t('terms.paragraph-3')
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $9wx12.jsx)((0, $56201fc8fe14bcc5$export$a06f1c675e846f6f), {})
        ]
    });
};



var $gJYWc = parcelRequire("gJYWc");
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol, Iterator */ var $47f2f2762182381c$var$extendStatics = function(d, b) {
    $47f2f2762182381c$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $47f2f2762182381c$var$extendStatics(d, b);
};
function $47f2f2762182381c$var$__extends(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $47f2f2762182381c$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $47f2f2762182381c$var$__assign = function() {
    $47f2f2762182381c$var$__assign = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $47f2f2762182381c$var$__assign.apply(this, arguments);
};
function $47f2f2762182381c$var$__rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $47f2f2762182381c$var$__awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $47f2f2762182381c$var$__generator(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
typeof SuppressedError === "function" && SuppressedError;
function $47f2f2762182381c$var$e(e, t) {
    var i = {};
    for(var o in e)Object.prototype.hasOwnProperty.call(e, o) && t.indexOf(o) < 0 && (i[o] = e[o]);
    if (null != e && "function" == typeof Object.getOwnPropertySymbols) {
        var n = 0;
        for(o = Object.getOwnPropertySymbols(e); n < o.length; n++)t.indexOf(o[n]) < 0 && Object.prototype.propertyIsEnumerable.call(e, o[n]) && (i[o[n]] = e[o[n]]);
    }
    return i;
}
"function" == typeof SuppressedError && SuppressedError;
var $47f2f2762182381c$var$t = "undefined" != typeof globalThis ? globalThis : "undefined" != typeof window ? window : "undefined" != typeof $parcel$global ? $parcel$global : "undefined" != typeof self ? self : {};
function $47f2f2762182381c$var$i(e) {
    return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
function $47f2f2762182381c$var$o(e, t) {
    return e(t = {
        exports: {}
    }, t.exports), t.exports;
}
var $47f2f2762182381c$var$n = $47f2f2762182381c$var$o(function(e, t) {
    Object.defineProperty(t, "__esModule", {
        value: !0
    });
    var i = function() {
        function e() {
            var e = this;
            this.locked = new Map, this.addToLocked = function(t, i) {
                var o = e.locked.get(t);
                void 0 === o ? void 0 === i ? e.locked.set(t, []) : e.locked.set(t, [
                    i
                ]) : void 0 !== i && (o.unshift(i), e.locked.set(t, o));
            }, this.isLocked = function(t) {
                return e.locked.has(t);
            }, this.lock = function(t) {
                return new Promise(function(i, o) {
                    e.isLocked(t) ? e.addToLocked(t, i) : (e.addToLocked(t), i());
                });
            }, this.unlock = function(t) {
                var i = e.locked.get(t);
                if (void 0 !== i && 0 !== i.length) {
                    var o = i.pop();
                    e.locked.set(t, i), void 0 !== o && setTimeout(o, 0);
                } else e.locked.delete(t);
            };
        }
        return e.getInstance = function() {
            return void 0 === e.instance && (e.instance = new e), e.instance;
        }, e;
    }();
    t.default = function() {
        return i.getInstance();
    };
});
$47f2f2762182381c$var$i($47f2f2762182381c$var$n);
var $47f2f2762182381c$var$a = $47f2f2762182381c$var$i($47f2f2762182381c$var$o(function(e, i) {
    var o = $47f2f2762182381c$var$t && $47f2f2762182381c$var$t.__awaiter || function(e, t, i, o) {
        return new (i || (i = Promise))(function(n, a) {
            function r(e) {
                try {
                    c(o.next(e));
                } catch (e) {
                    a(e);
                }
            }
            function s(e) {
                try {
                    c(o.throw(e));
                } catch (e) {
                    a(e);
                }
            }
            function c(e) {
                e.done ? n(e.value) : new i(function(t) {
                    t(e.value);
                }).then(r, s);
            }
            c((o = o.apply(e, t || [])).next());
        });
    }, a = $47f2f2762182381c$var$t && $47f2f2762182381c$var$t.__generator || function(e, t) {
        var i, o, n, a, r = {
            label: 0,
            sent: function() {
                if (1 & n[0]) throw n[1];
                return n[1];
            },
            trys: [],
            ops: []
        };
        return a = {
            next: s(0),
            throw: s(1),
            return: s(2)
        }, "function" == typeof Symbol && (a[Symbol.iterator] = function() {
            return this;
        }), a;
        function s(a) {
            return function(s) {
                return function(a) {
                    if (i) throw new TypeError("Generator is already executing.");
                    for(; r;)try {
                        if (i = 1, o && (n = 2 & a[0] ? o.return : a[0] ? o.throw || ((n = o.return) && n.call(o), 0) : o.next) && !(n = n.call(o, a[1])).done) return n;
                        switch(o = 0, n && (a = [
                            2 & a[0],
                            n.value
                        ]), a[0]){
                            case 0:
                            case 1:
                                n = a;
                                break;
                            case 4:
                                return r.label++, {
                                    value: a[1],
                                    done: !1
                                };
                            case 5:
                                r.label++, o = a[1], a = [
                                    0
                                ];
                                continue;
                            case 7:
                                a = r.ops.pop(), r.trys.pop();
                                continue;
                            default:
                                if (!(n = r.trys, (n = n.length > 0 && n[n.length - 1]) || 6 !== a[0] && 2 !== a[0])) {
                                    r = 0;
                                    continue;
                                }
                                if (3 === a[0] && (!n || a[1] > n[0] && a[1] < n[3])) {
                                    r.label = a[1];
                                    break;
                                }
                                if (6 === a[0] && r.label < n[1]) {
                                    r.label = n[1], n = a;
                                    break;
                                }
                                if (n && r.label < n[2]) {
                                    r.label = n[2], r.ops.push(a);
                                    break;
                                }
                                n[2] && r.ops.pop(), r.trys.pop();
                                continue;
                        }
                        a = t.call(e, r);
                    } catch (e) {
                        a = [
                            6,
                            e
                        ], o = 0;
                    } finally{
                        i = n = 0;
                    }
                    if (5 & a[0]) throw a[1];
                    return {
                        value: a[0] ? a[1] : void 0,
                        done: !0
                    };
                }([
                    a,
                    s
                ]);
            };
        }
    }, r = $47f2f2762182381c$var$t;
    Object.defineProperty(i, "__esModule", {
        value: !0
    });
    var s = "browser-tabs-lock-key", c = {
        key: function(e) {
            return o(r, void 0, void 0, function() {
                return a(this, function(e) {
                    throw new Error("Unsupported");
                });
            });
        },
        getItem: function(e) {
            return o(r, void 0, void 0, function() {
                return a(this, function(e) {
                    throw new Error("Unsupported");
                });
            });
        },
        clear: function() {
            return o(r, void 0, void 0, function() {
                return a(this, function(e) {
                    return [
                        2,
                        window.localStorage.clear()
                    ];
                });
            });
        },
        removeItem: function(e) {
            return o(r, void 0, void 0, function() {
                return a(this, function(e) {
                    throw new Error("Unsupported");
                });
            });
        },
        setItem: function(e, t) {
            return o(r, void 0, void 0, function() {
                return a(this, function(e) {
                    throw new Error("Unsupported");
                });
            });
        },
        keySync: function(e) {
            return window.localStorage.key(e);
        },
        getItemSync: function(e) {
            return window.localStorage.getItem(e);
        },
        clearSync: function() {
            return window.localStorage.clear();
        },
        removeItemSync: function(e) {
            return window.localStorage.removeItem(e);
        },
        setItemSync: function(e, t) {
            return window.localStorage.setItem(e, t);
        }
    };
    function d(e) {
        return new Promise(function(t) {
            return setTimeout(t, e);
        });
    }
    function u(e) {
        for(var t = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXTZabcdefghiklmnopqrstuvwxyz", i = "", o = 0; o < e; o++)i += t[Math.floor(Math.random() * t.length)];
        return i;
    }
    var l = function() {
        function e(t) {
            this.acquiredIatSet = new Set, this.storageHandler = void 0, this.id = Date.now().toString() + u(15), this.acquireLock = this.acquireLock.bind(this), this.releaseLock = this.releaseLock.bind(this), this.releaseLock__private__ = this.releaseLock__private__.bind(this), this.waitForSomethingToChange = this.waitForSomethingToChange.bind(this), this.refreshLockWhileAcquired = this.refreshLockWhileAcquired.bind(this), this.storageHandler = t, void 0 === e.waiters && (e.waiters = []);
        }
        return e.prototype.acquireLock = function(t, i) {
            return void 0 === i && (i = 5e3), o(this, void 0, void 0, function() {
                var o, n, r, l, h, p, m;
                return a(this, function(a) {
                    switch(a.label){
                        case 0:
                            o = Date.now() + u(4), n = Date.now() + i, r = s + "-" + t, l = void 0 === this.storageHandler ? c : this.storageHandler, a.label = 1;
                        case 1:
                            return Date.now() < n ? [
                                4,
                                d(30)
                            ] : [
                                3,
                                8
                            ];
                        case 2:
                            return a.sent(), null !== l.getItemSync(r) ? [
                                3,
                                5
                            ] : (h = this.id + "-" + t + "-" + o, [
                                4,
                                d(Math.floor(25 * Math.random()))
                            ]);
                        case 3:
                            return a.sent(), l.setItemSync(r, JSON.stringify({
                                id: this.id,
                                iat: o,
                                timeoutKey: h,
                                timeAcquired: Date.now(),
                                timeRefreshed: Date.now()
                            })), [
                                4,
                                d(30)
                            ];
                        case 4:
                            return a.sent(), null !== (p = l.getItemSync(r)) && (m = JSON.parse(p)).id === this.id && m.iat === o ? (this.acquiredIatSet.add(o), this.refreshLockWhileAcquired(r, o), [
                                2,
                                !0
                            ]) : [
                                3,
                                7
                            ];
                        case 5:
                            return e.lockCorrector(void 0 === this.storageHandler ? c : this.storageHandler), [
                                4,
                                this.waitForSomethingToChange(n)
                            ];
                        case 6:
                            a.sent(), a.label = 7;
                        case 7:
                            return o = Date.now() + u(4), [
                                3,
                                1
                            ];
                        case 8:
                            return [
                                2,
                                !1
                            ];
                    }
                });
            });
        }, e.prototype.refreshLockWhileAcquired = function(e, t) {
            return o(this, void 0, void 0, function() {
                var i = this;
                return a(this, function(r) {
                    return setTimeout(function() {
                        return o(i, void 0, void 0, function() {
                            var i, o, r;
                            return a(this, function(a) {
                                switch(a.label){
                                    case 0:
                                        return [
                                            4,
                                            $47f2f2762182381c$var$n.default().lock(t)
                                        ];
                                    case 1:
                                        return a.sent(), this.acquiredIatSet.has(t) ? (i = void 0 === this.storageHandler ? c : this.storageHandler, null === (o = i.getItemSync(e)) ? ($47f2f2762182381c$var$n.default().unlock(t), [
                                            2
                                        ]) : ((r = JSON.parse(o)).timeRefreshed = Date.now(), i.setItemSync(e, JSON.stringify(r)), $47f2f2762182381c$var$n.default().unlock(t), this.refreshLockWhileAcquired(e, t), [
                                            2
                                        ])) : ($47f2f2762182381c$var$n.default().unlock(t), [
                                            2
                                        ]);
                                }
                            });
                        });
                    }, 1e3), [
                        2
                    ];
                });
            });
        }, e.prototype.waitForSomethingToChange = function(t) {
            return o(this, void 0, void 0, function() {
                return a(this, function(i) {
                    switch(i.label){
                        case 0:
                            return [
                                4,
                                new Promise(function(i) {
                                    var o = !1, n = Date.now(), a = !1;
                                    function r() {
                                        if (a || (window.removeEventListener("storage", r), e.removeFromWaiting(r), clearTimeout(s), a = !0), !o) {
                                            o = !0;
                                            var t = 50 - (Date.now() - n);
                                            t > 0 ? setTimeout(i, t) : i(null);
                                        }
                                    }
                                    window.addEventListener("storage", r), e.addToWaiting(r);
                                    var s = setTimeout(r, Math.max(0, t - Date.now()));
                                })
                            ];
                        case 1:
                            return i.sent(), [
                                2
                            ];
                    }
                });
            });
        }, e.addToWaiting = function(t) {
            this.removeFromWaiting(t), void 0 !== e.waiters && e.waiters.push(t);
        }, e.removeFromWaiting = function(t) {
            void 0 !== e.waiters && (e.waiters = e.waiters.filter(function(e) {
                return e !== t;
            }));
        }, e.notifyWaiters = function() {
            void 0 !== e.waiters && e.waiters.slice().forEach(function(e) {
                return e();
            });
        }, e.prototype.releaseLock = function(e) {
            return o(this, void 0, void 0, function() {
                return a(this, function(t) {
                    switch(t.label){
                        case 0:
                            return [
                                4,
                                this.releaseLock__private__(e)
                            ];
                        case 1:
                            return [
                                2,
                                t.sent()
                            ];
                    }
                });
            });
        }, e.prototype.releaseLock__private__ = function(t) {
            return o(this, void 0, void 0, function() {
                var i, o, r, d;
                return a(this, function(a) {
                    switch(a.label){
                        case 0:
                            return i = void 0 === this.storageHandler ? c : this.storageHandler, o = s + "-" + t, null === (r = i.getItemSync(o)) ? [
                                2
                            ] : (d = JSON.parse(r)).id !== this.id ? [
                                3,
                                2
                            ] : [
                                4,
                                $47f2f2762182381c$var$n.default().lock(d.iat)
                            ];
                        case 1:
                            a.sent(), this.acquiredIatSet.delete(d.iat), i.removeItemSync(o), $47f2f2762182381c$var$n.default().unlock(d.iat), e.notifyWaiters(), a.label = 2;
                        case 2:
                            return [
                                2
                            ];
                    }
                });
            });
        }, e.lockCorrector = function(t) {
            for(var i = Date.now() - 5e3, o = t, n = [], a = 0;;){
                var r = o.keySync(a);
                if (null === r) break;
                n.push(r), a++;
            }
            for(var c = !1, d = 0; d < n.length; d++){
                var u = n[d];
                if (u.includes(s)) {
                    var l = o.getItemSync(u);
                    if (null !== l) {
                        var h = JSON.parse(l);
                        (void 0 === h.timeRefreshed && h.timeAcquired < i || void 0 !== h.timeRefreshed && h.timeRefreshed < i) && (o.removeItemSync(u), c = !0);
                    }
                }
            }
            c && e.notifyWaiters();
        }, e.waiters = void 0, e;
    }();
    i.default = l;
}));
const $47f2f2762182381c$var$r = {
    timeoutInSeconds: 60
}, $47f2f2762182381c$var$s = {
    name: "auth0-spa-js",
    version: "2.1.3"
}, $47f2f2762182381c$var$c = ()=>Date.now();
class $47f2f2762182381c$export$7d465be8efa67280 extends Error {
    static fromPayload({ error: e, error_description: t }) {
        return new $47f2f2762182381c$export$7d465be8efa67280(e, t);
    }
    constructor(e, t){
        super(t), this.error = e, this.error_description = t, Object.setPrototypeOf(this, $47f2f2762182381c$export$7d465be8efa67280.prototype);
    }
}
class $47f2f2762182381c$export$cf0c46b07324e9c5 extends $47f2f2762182381c$export$7d465be8efa67280 {
    constructor(e, t, i, o = null){
        super(e, t), this.state = i, this.appState = o, Object.setPrototypeOf(this, $47f2f2762182381c$export$cf0c46b07324e9c5.prototype);
    }
}
class $47f2f2762182381c$export$66d311bf29d5c89c extends $47f2f2762182381c$export$7d465be8efa67280 {
    constructor(){
        super("timeout", "Timeout"), Object.setPrototypeOf(this, $47f2f2762182381c$export$66d311bf29d5c89c.prototype);
    }
}
class $47f2f2762182381c$export$ebbb83fe03f719a4 extends $47f2f2762182381c$export$66d311bf29d5c89c {
    constructor(e){
        super(), this.popup = e, Object.setPrototypeOf(this, $47f2f2762182381c$export$ebbb83fe03f719a4.prototype);
    }
}
class $47f2f2762182381c$export$f1f681f0fb26bb55 extends $47f2f2762182381c$export$7d465be8efa67280 {
    constructor(e){
        super("cancelled", "Popup closed"), this.popup = e, Object.setPrototypeOf(this, $47f2f2762182381c$export$f1f681f0fb26bb55.prototype);
    }
}
class $47f2f2762182381c$export$c59494f4dae44ada extends $47f2f2762182381c$export$7d465be8efa67280 {
    constructor(e, t, i){
        super(e, t), this.mfa_token = i, Object.setPrototypeOf(this, $47f2f2762182381c$export$c59494f4dae44ada.prototype);
    }
}
class $47f2f2762182381c$export$ac1d2a00f8e0a046 extends $47f2f2762182381c$export$7d465be8efa67280 {
    constructor(e, t){
        super("missing_refresh_token", `Missing Refresh Token (audience: '${$47f2f2762182381c$var$g(e, [
            "default"
        ])}', scope: '${$47f2f2762182381c$var$g(t)}')`), this.audience = e, this.scope = t, Object.setPrototypeOf(this, $47f2f2762182381c$export$ac1d2a00f8e0a046.prototype);
    }
}
function $47f2f2762182381c$var$g(e, t = []) {
    return e && !t.includes(e) ? e : "";
}
const $47f2f2762182381c$var$w = ()=>window.crypto, $47f2f2762182381c$var$y = ()=>{
    const e = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz-_~.";
    let t = "";
    return Array.from($47f2f2762182381c$var$w().getRandomValues(new Uint8Array(43))).forEach((i)=>t += e[i % e.length]), t;
}, $47f2f2762182381c$var$k = (e)=>btoa(e), $47f2f2762182381c$var$v = (t)=>{
    var { clientId: i } = t, o = $47f2f2762182381c$var$e(t, [
        "clientId"
    ]);
    return new URLSearchParams(((e)=>Object.keys(e).filter((t)=>void 0 !== e[t]).reduce((t, i)=>Object.assign(Object.assign({}, t), {
                [i]: e[i]
            }), {}))(Object.assign({
        client_id: i
    }, o))).toString();
}, $47f2f2762182381c$var$b = (e)=>((e)=>decodeURIComponent(atob(e).split("").map((e)=>"%" + ("00" + e.charCodeAt(0).toString(16)).slice(-2)).join("")))(e.replace(/_/g, "/").replace(/-/g, "+")), $47f2f2762182381c$var$_ = async (e, t)=>{
    const i = await fetch(e, t);
    return {
        ok: i.ok,
        json: await i.json()
    };
}, $47f2f2762182381c$var$I = async (e, t, i)=>{
    const o = new AbortController;
    let n;
    return t.signal = o.signal, Promise.race([
        $47f2f2762182381c$var$_(e, t),
        new Promise((e, t)=>{
            n = setTimeout(()=>{
                o.abort(), t(new Error("Timeout when executing 'fetch'"));
            }, i);
        })
    ]).finally(()=>{
        clearTimeout(n);
    });
}, $47f2f2762182381c$var$S = async (e, t, i, o, n, a, r)=>{
    var s, c;
    return s = {
        auth: {
            audience: t,
            scope: i
        },
        timeout: n,
        fetchUrl: e,
        fetchOptions: o,
        useFormData: r
    }, c = a, new Promise(function(e, t) {
        const i = new MessageChannel;
        i.port1.onmessage = function(o) {
            o.data.error ? t(new Error(o.data.error)) : e(o.data), i.port1.close();
        }, c.postMessage(s, [
            i.port2
        ]);
    });
}, $47f2f2762182381c$var$O = async (e, t, i, o, n, a, r = 1e4)=>n ? $47f2f2762182381c$var$S(e, t, i, o, r, n, a) : $47f2f2762182381c$var$I(e, o, r);
async function $47f2f2762182381c$var$T(t, i) {
    var { baseUrl: o, timeout: n, audience: a, scope: r, auth0Client: c, useFormData: u } = t, l = $47f2f2762182381c$var$e(t, [
        "baseUrl",
        "timeout",
        "audience",
        "scope",
        "auth0Client",
        "useFormData"
    ]);
    const h = u ? $47f2f2762182381c$var$v(l) : JSON.stringify(l);
    return await async function(t, i, o, n, a, r, s) {
        let c, u = null;
        for(let e = 0; e < 3; e++)try {
            c = await $47f2f2762182381c$var$O(t, o, n, a, r, s, i), u = null;
            break;
        } catch (e) {
            u = e;
        }
        if (u) throw u;
        const l = c.json, { error: h, error_description: p } = l, g = $47f2f2762182381c$var$e(l, [
            "error",
            "error_description"
        ]), { ok: w } = c;
        if (!w) {
            const e = p || `HTTP error. Unable to fetch ${t}`;
            if ("mfa_required" === h) throw new $47f2f2762182381c$export$c59494f4dae44ada(h, e, g.mfa_token);
            if ("missing_refresh_token" === h) throw new $47f2f2762182381c$export$ac1d2a00f8e0a046(o, n);
            throw new $47f2f2762182381c$export$7d465be8efa67280(h || "request_error", e);
        }
        return g;
    }(`${o}/oauth/token`, n, a || "default", r, {
        method: "POST",
        body: h,
        headers: {
            "Content-Type": u ? "application/x-www-form-urlencoded" : "application/json",
            "Auth0-Client": btoa(JSON.stringify(c || $47f2f2762182381c$var$s))
        }
    }, i, u);
}
const $47f2f2762182381c$var$j = (...e)=>{
    var t;
    return (t = e.filter(Boolean).join(" ").trim().split(/\s+/), Array.from(new Set(t))).join(" ");
};
class $47f2f2762182381c$var$C {
    toKey() {
        return [
            this.prefix,
            this.clientId,
            this.audience,
            this.scope,
            this.suffix
        ].filter(Boolean).join("::");
    }
    static fromKey(e) {
        const [t, i, o, n] = e.split("::");
        return new $47f2f2762182381c$var$C({
            clientId: i,
            scope: n,
            audience: o
        }, t);
    }
    static fromCacheEntry(e) {
        const { scope: t, audience: i, client_id: o } = e;
        return new $47f2f2762182381c$var$C({
            scope: t,
            audience: i,
            clientId: o
        });
    }
    constructor(e, t = "@@auth0spajs@@", i){
        this.prefix = t, this.suffix = i, this.clientId = e.clientId, this.scope = e.scope, this.audience = e.audience;
    }
}
class $47f2f2762182381c$export$40ef2cb682e70737 {
    set(e, t) {
        localStorage.setItem(e, JSON.stringify(t));
    }
    get(e) {
        const t = window.localStorage.getItem(e);
        if (t) try {
            return JSON.parse(t);
        } catch (e) {
            return;
        }
    }
    remove(e) {
        localStorage.removeItem(e);
    }
    allKeys() {
        return Object.keys(window.localStorage).filter((e)=>e.startsWith("@@auth0spajs@@"));
    }
}
class $47f2f2762182381c$export$467265324939f47f {
    constructor(){
        this.enclosedCache = function() {
            let e = {};
            return {
                set (t, i) {
                    e[t] = i;
                },
                get (t) {
                    const i = e[t];
                    if (i) return i;
                },
                remove (t) {
                    delete e[t];
                },
                allKeys: ()=>Object.keys(e)
            };
        }();
    }
}
class $47f2f2762182381c$var$x {
    async setIdToken(e, t, i) {
        var o;
        const n = this.getIdTokenCacheKey(e);
        await this.cache.set(n, {
            id_token: t,
            decodedToken: i
        }), await (null === (o = this.keyManifest) || void 0 === o ? void 0 : o.add(n));
    }
    async getIdToken(e) {
        const t = await this.cache.get(this.getIdTokenCacheKey(e.clientId));
        if (!t && e.scope && e.audience) {
            const t = await this.get(e);
            if (!t) return;
            if (!t.id_token || !t.decodedToken) return;
            return {
                id_token: t.id_token,
                decodedToken: t.decodedToken
            };
        }
        if (t) return {
            id_token: t.id_token,
            decodedToken: t.decodedToken
        };
    }
    async get(e, t = 0) {
        var i;
        let o = await this.cache.get(e.toKey());
        if (!o) {
            const t = await this.getCacheKeys();
            if (!t) return;
            const i = this.matchExistingCacheKey(e, t);
            i && (o = await this.cache.get(i));
        }
        if (!o) return;
        const n = await this.nowProvider(), a = Math.floor(n / 1e3);
        return o.expiresAt - t < a ? o.body.refresh_token ? (o.body = {
            refresh_token: o.body.refresh_token
        }, await this.cache.set(e.toKey(), o), o.body) : (await this.cache.remove(e.toKey()), void await (null === (i = this.keyManifest) || void 0 === i ? void 0 : i.remove(e.toKey()))) : o.body;
    }
    async set(e) {
        var t;
        const i = new $47f2f2762182381c$var$C({
            clientId: e.client_id,
            scope: e.scope,
            audience: e.audience
        }), o = await this.wrapCacheEntry(e);
        await this.cache.set(i.toKey(), o), await (null === (t = this.keyManifest) || void 0 === t ? void 0 : t.add(i.toKey()));
    }
    async clear(e) {
        var t;
        const i = await this.getCacheKeys();
        i && (await i.filter((t)=>!e || t.includes(e)).reduce(async (e, t)=>{
            await e, await this.cache.remove(t);
        }, Promise.resolve()), await (null === (t = this.keyManifest) || void 0 === t ? void 0 : t.clear()));
    }
    async wrapCacheEntry(e) {
        const t = await this.nowProvider();
        return {
            body: e,
            expiresAt: Math.floor(t / 1e3) + e.expires_in
        };
    }
    async getCacheKeys() {
        var e;
        return this.keyManifest ? null === (e = await this.keyManifest.get()) || void 0 === e ? void 0 : e.keys : this.cache.allKeys ? this.cache.allKeys() : void 0;
    }
    getIdTokenCacheKey(e) {
        return new $47f2f2762182381c$var$C({
            clientId: e
        }, "@@auth0spajs@@", "@@user@@").toKey();
    }
    matchExistingCacheKey(e, t) {
        return t.filter((t)=>{
            var i;
            const o = $47f2f2762182381c$var$C.fromKey(t), n = new Set(o.scope && o.scope.split(" ")), a = (null === (i = e.scope) || void 0 === i ? void 0 : i.split(" ")) || [], r = o.scope && a.reduce((e, t)=>e && n.has(t), !0);
            return "@@auth0spajs@@" === o.prefix && o.clientId === e.clientId && o.audience === e.audience && r;
        })[0];
    }
    constructor(e, t, i){
        this.cache = e, this.keyManifest = t, this.nowProvider = i || $47f2f2762182381c$var$c;
    }
}
class $47f2f2762182381c$var$Z {
    create(e) {
        this.storage.save(this.storageKey, e, {
            daysUntilExpire: 1,
            cookieDomain: this.cookieDomain
        });
    }
    get() {
        return this.storage.get(this.storageKey);
    }
    remove() {
        this.storage.remove(this.storageKey, {
            cookieDomain: this.cookieDomain
        });
    }
    constructor(e, t, i){
        this.storage = e, this.clientId = t, this.cookieDomain = i, this.storageKey = `a0.spajs.txs.${this.clientId}`;
    }
}
const $47f2f2762182381c$var$K = (e)=>"number" == typeof e, $47f2f2762182381c$var$W = [
    "iss",
    "aud",
    "exp",
    "nbf",
    "iat",
    "jti",
    "azp",
    "nonce",
    "auth_time",
    "at_hash",
    "c_hash",
    "acr",
    "amr",
    "sub_jwk",
    "cnf",
    "sip_from_tag",
    "sip_date",
    "sip_callid",
    "sip_cseq_num",
    "sip_via_branch",
    "orig",
    "dest",
    "mky",
    "events",
    "toe",
    "txn",
    "rph",
    "sid",
    "vot",
    "vtm"
], $47f2f2762182381c$var$E = (e)=>{
    if (!e.id_token) throw new Error("ID token is required but missing");
    const t = ((e)=>{
        const t = e.split("."), [i, o, n] = t;
        if (3 !== t.length || !i || !o || !n) throw new Error("ID token could not be decoded");
        const a = JSON.parse($47f2f2762182381c$var$b(o)), r = {
            __raw: e
        }, s = {};
        return Object.keys(a).forEach((e)=>{
            r[e] = a[e], $47f2f2762182381c$var$W.includes(e) || (s[e] = a[e]);
        }), {
            encoded: {
                header: i,
                payload: o,
                signature: n
            },
            header: JSON.parse($47f2f2762182381c$var$b(i)),
            claims: r,
            user: s
        };
    })(e.id_token);
    if (!t.claims.iss) throw new Error("Issuer (iss) claim must be a string present in the ID token");
    if (t.claims.iss !== e.iss) throw new Error(`Issuer (iss) claim mismatch in the ID token; expected "${e.iss}", found "${t.claims.iss}"`);
    if (!t.user.sub) throw new Error("Subject (sub) claim must be a string present in the ID token");
    if ("RS256" !== t.header.alg) throw new Error(`Signature algorithm of "${t.header.alg}" is not supported. Expected the ID token to be signed with "RS256".`);
    if (!t.claims.aud || "string" != typeof t.claims.aud && !Array.isArray(t.claims.aud)) throw new Error("Audience (aud) claim must be a string or array of strings present in the ID token");
    if (Array.isArray(t.claims.aud)) {
        if (!t.claims.aud.includes(e.aud)) throw new Error(`Audience (aud) claim mismatch in the ID token; expected "${e.aud}" but was not one of "${t.claims.aud.join(", ")}"`);
        if (t.claims.aud.length > 1) {
            if (!t.claims.azp) throw new Error("Authorized Party (azp) claim must be a string present in the ID token when Audience (aud) claim has multiple values");
            if (t.claims.azp !== e.aud) throw new Error(`Authorized Party (azp) claim mismatch in the ID token; expected "${e.aud}", found "${t.claims.azp}"`);
        }
    } else if (t.claims.aud !== e.aud) throw new Error(`Audience (aud) claim mismatch in the ID token; expected "${e.aud}" but found "${t.claims.aud}"`);
    if (e.nonce) {
        if (!t.claims.nonce) throw new Error("Nonce (nonce) claim must be a string present in the ID token");
        if (t.claims.nonce !== e.nonce) throw new Error(`Nonce (nonce) claim mismatch in the ID token; expected "${e.nonce}", found "${t.claims.nonce}"`);
    }
    if (e.max_age && !$47f2f2762182381c$var$K(t.claims.auth_time)) throw new Error("Authentication Time (auth_time) claim must be a number present in the ID token when Max Age (max_age) is specified");
    if (null == t.claims.exp || !$47f2f2762182381c$var$K(t.claims.exp)) throw new Error("Expiration Time (exp) claim must be a number present in the ID token");
    if (!$47f2f2762182381c$var$K(t.claims.iat)) throw new Error("Issued At (iat) claim must be a number present in the ID token");
    const i = e.leeway || 60, o = new Date(e.now || Date.now()), n = new Date(0);
    if (n.setUTCSeconds(t.claims.exp + i), o > n) throw new Error(`Expiration Time (exp) claim error in the ID token; current time (${o}) is after expiration time (${n})`);
    if (null != t.claims.nbf && $47f2f2762182381c$var$K(t.claims.nbf)) {
        const e = new Date(0);
        if (e.setUTCSeconds(t.claims.nbf - i), o < e) throw new Error(`Not Before time (nbf) claim in the ID token indicates that this token can't be used just yet. Current time (${o}) is before ${e}`);
    }
    if (null != t.claims.auth_time && $47f2f2762182381c$var$K(t.claims.auth_time)) {
        const n = new Date(0);
        if (n.setUTCSeconds(parseInt(t.claims.auth_time) + e.max_age + i), o > n) throw new Error(`Authentication Time (auth_time) claim in the ID token indicates that too much time has passed since the last end-user authentication. Current time (${o}) is after last auth at ${n}`);
    }
    if (e.organization) {
        const i = e.organization.trim();
        if (i.startsWith("org_")) {
            const e = i;
            if (!t.claims.org_id) throw new Error("Organization ID (org_id) claim must be a string present in the ID token");
            if (e !== t.claims.org_id) throw new Error(`Organization ID (org_id) claim mismatch in the ID token; expected "${e}", found "${t.claims.org_id}"`);
        } else {
            const e = i.toLowerCase();
            if (!t.claims.org_name) throw new Error("Organization Name (org_name) claim must be a string present in the ID token");
            if (e !== t.claims.org_name) throw new Error(`Organization Name (org_name) claim mismatch in the ID token; expected "${e}", found "${t.claims.org_name}"`);
        }
    }
    return t;
};
var $47f2f2762182381c$var$R = $47f2f2762182381c$var$o(function(e, i) {
    var o = $47f2f2762182381c$var$t && $47f2f2762182381c$var$t.__assign || function() {
        return o = Object.assign || function(e) {
            for(var t, i = 1, o = arguments.length; i < o; i++)for(var n in t = arguments[i])Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
            return e;
        }, o.apply(this, arguments);
    };
    function n(e, t) {
        if (!t) return "";
        var i = "; " + e;
        return !0 === t ? i : i + "=" + t;
    }
    function a(e, t, i) {
        return encodeURIComponent(e).replace(/%(23|24|26|2B|5E|60|7C)/g, decodeURIComponent).replace(/\(/g, "%28").replace(/\)/g, "%29") + "=" + encodeURIComponent(t).replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g, decodeURIComponent) + function(e) {
            if ("number" == typeof e.expires) {
                var t = new Date;
                t.setMilliseconds(t.getMilliseconds() + 864e5 * e.expires), e.expires = t;
            }
            return n("Expires", e.expires ? e.expires.toUTCString() : "") + n("Domain", e.domain) + n("Path", e.path) + n("Secure", e.secure) + n("SameSite", e.sameSite);
        }(i);
    }
    function r(e) {
        for(var t = {}, i = e ? e.split("; ") : [], o = /(%[\dA-F]{2})+/gi, n = 0; n < i.length; n++){
            var a = i[n].split("="), r = a.slice(1).join("=");
            '"' === r.charAt(0) && (r = r.slice(1, -1));
            try {
                t[a[0].replace(o, decodeURIComponent)] = r.replace(o, decodeURIComponent);
            } catch (e) {}
        }
        return t;
    }
    function s() {
        return r(document.cookie);
    }
    function c(e, t, i) {
        document.cookie = a(e, t, o({
            path: "/"
        }, i));
    }
    i.__esModule = !0, i.encode = a, i.parse = r, i.getAll = s, i.get = function(e) {
        return s()[e];
    }, i.set = c, i.remove = function(e, t) {
        c(e, "", o(o({}, t), {
            expires: -1
        }));
    };
});
$47f2f2762182381c$var$i($47f2f2762182381c$var$R), $47f2f2762182381c$var$R.encode, $47f2f2762182381c$var$R.parse, $47f2f2762182381c$var$R.getAll;
var $47f2f2762182381c$var$U = $47f2f2762182381c$var$R.get, $47f2f2762182381c$var$L = $47f2f2762182381c$var$R.set, $47f2f2762182381c$var$D = $47f2f2762182381c$var$R.remove;
const $47f2f2762182381c$var$X = {
    get (e) {
        const t = $47f2f2762182381c$var$U(e);
        if (void 0 !== t) return JSON.parse(t);
    },
    save (e, t, i) {
        let o = {};
        "https:" === window.location.protocol && (o = {
            secure: !0,
            sameSite: "none"
        }), (null == i ? void 0 : i.daysUntilExpire) && (o.expires = i.daysUntilExpire), (null == i ? void 0 : i.cookieDomain) && (o.domain = i.cookieDomain), $47f2f2762182381c$var$L(e, JSON.stringify(t), o);
    },
    remove (e, t) {
        let i = {};
        (null == t ? void 0 : t.cookieDomain) && (i.domain = t.cookieDomain), $47f2f2762182381c$var$D(e, i);
    }
}, $47f2f2762182381c$var$N = {
    get (e) {
        const t = $47f2f2762182381c$var$X.get(e);
        return t || $47f2f2762182381c$var$X.get(`_legacy_${e}`);
    },
    save (e, t, i) {
        let o = {};
        "https:" === window.location.protocol && (o = {
            secure: !0
        }), (null == i ? void 0 : i.daysUntilExpire) && (o.expires = i.daysUntilExpire), (null == i ? void 0 : i.cookieDomain) && (o.domain = i.cookieDomain), $47f2f2762182381c$var$L(`_legacy_${e}`, JSON.stringify(t), o), $47f2f2762182381c$var$X.save(e, t, i);
    },
    remove (e, t) {
        let i = {};
        (null == t ? void 0 : t.cookieDomain) && (i.domain = t.cookieDomain), $47f2f2762182381c$var$D(e, i), $47f2f2762182381c$var$X.remove(e, t), $47f2f2762182381c$var$X.remove(`_legacy_${e}`, t);
    }
}, $47f2f2762182381c$var$J = {
    get (e) {
        if ("undefined" == typeof sessionStorage) return;
        const t = sessionStorage.getItem(e);
        return null != t ? JSON.parse(t) : void 0;
    },
    save (e, t) {
        sessionStorage.setItem(e, JSON.stringify(t));
    },
    remove (e) {
        sessionStorage.removeItem(e);
    }
};
function $47f2f2762182381c$var$F(e, t, i) {
    var o = void 0 === t ? null : t, n = function(e, t) {
        var i = atob(e);
        if (t) {
            for(var o = new Uint8Array(i.length), n = 0, a = i.length; n < a; ++n)o[n] = i.charCodeAt(n);
            return String.fromCharCode.apply(null, new Uint16Array(o.buffer));
        }
        return i;
    }(e, void 0 !== i && i), a = n.indexOf("\n", 10) + 1, r = n.substring(a) + (o ? "//# sourceMappingURL=" + o : ""), s = new Blob([
        r
    ], {
        type: "application/javascript"
    });
    return URL.createObjectURL(s);
}
var $47f2f2762182381c$var$H, $47f2f2762182381c$var$Y, $47f2f2762182381c$var$G, $47f2f2762182381c$var$V, $47f2f2762182381c$var$M = ($47f2f2762182381c$var$H = "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", $47f2f2762182381c$var$Y = null, $47f2f2762182381c$var$G = !1, function(e) {
    return $47f2f2762182381c$var$V = $47f2f2762182381c$var$V || $47f2f2762182381c$var$F($47f2f2762182381c$var$H, $47f2f2762182381c$var$Y, $47f2f2762182381c$var$G), new Worker($47f2f2762182381c$var$V, e);
});
const $47f2f2762182381c$var$A = {};
class $47f2f2762182381c$var$B {
    async add(e) {
        var t;
        const i = new Set((null === (t = await this.cache.get(this.manifestKey)) || void 0 === t ? void 0 : t.keys) || []);
        i.add(e), await this.cache.set(this.manifestKey, {
            keys: [
                ...i
            ]
        });
    }
    async remove(e) {
        const t = await this.cache.get(this.manifestKey);
        if (t) {
            const i = new Set(t.keys);
            return i.delete(e), i.size > 0 ? await this.cache.set(this.manifestKey, {
                keys: [
                    ...i
                ]
            }) : await this.cache.remove(this.manifestKey);
        }
    }
    get() {
        return this.cache.get(this.manifestKey);
    }
    clear() {
        return this.cache.remove(this.manifestKey);
    }
    createManifestKeyFrom(e) {
        return `@@auth0spajs@@::${e}`;
    }
    constructor(e, t){
        this.cache = e, this.clientId = t, this.manifestKey = this.createManifestKeyFrom(this.clientId);
    }
}
const $47f2f2762182381c$var$$ = {
    memory: ()=>(new $47f2f2762182381c$export$467265324939f47f).enclosedCache,
    localstorage: ()=>new $47f2f2762182381c$export$40ef2cb682e70737
}, $47f2f2762182381c$var$q = (e)=>$47f2f2762182381c$var$$[e], $47f2f2762182381c$var$Q = (t)=>{
    const { openUrl: i, onRedirect: o } = t, n = $47f2f2762182381c$var$e(t, [
        "openUrl",
        "onRedirect"
    ]);
    return Object.assign(Object.assign({}, n), {
        openUrl: !1 === i || i ? i : o
    });
}, $47f2f2762182381c$var$ee = new $47f2f2762182381c$var$a;
class $47f2f2762182381c$var$te {
    _url(e) {
        const t = encodeURIComponent(btoa(JSON.stringify(this.options.auth0Client || $47f2f2762182381c$var$s)));
        return `${this.domainUrl}${e}&auth0Client=${t}`;
    }
    _authorizeUrl(e) {
        return this._url(`/authorize?${$47f2f2762182381c$var$v(e)}`);
    }
    async _verifyIdToken(e, t, i) {
        const o = await this.nowProvider();
        var n;
        return $47f2f2762182381c$var$E({
            iss: this.tokenIssuer,
            aud: this.options.clientId,
            id_token: e,
            nonce: t,
            organization: i,
            leeway: this.options.leeway,
            max_age: (n = this.options.authorizationParams.max_age, "string" != typeof n ? n : parseInt(n, 10) || void 0),
            now: o
        });
    }
    _processOrgHint(e) {
        e ? this.cookieStorage.save(this.orgHintCookieName, e, {
            daysUntilExpire: this.sessionCheckExpiryDays,
            cookieDomain: this.options.cookieDomain
        }) : this.cookieStorage.remove(this.orgHintCookieName, {
            cookieDomain: this.options.cookieDomain
        });
    }
    async _prepareAuthorizeUrl(e, t, i) {
        const o = $47f2f2762182381c$var$k($47f2f2762182381c$var$y()), n = $47f2f2762182381c$var$k($47f2f2762182381c$var$y()), a = $47f2f2762182381c$var$y(), r = ((e)=>{
            const t = new Uint8Array(e);
            return ((e)=>{
                const t = {
                    "+": "-",
                    "/": "_",
                    "=": ""
                };
                return e.replace(/[+/=]/g, (e)=>t[e]);
            })(window.btoa(String.fromCharCode(...Array.from(t))));
        })(await (async (e)=>{
            const t = $47f2f2762182381c$var$w().subtle.digest({
                name: "SHA-256"
            }, (new TextEncoder).encode(e));
            return await t;
        })(a)), s = ((e, t, i, o, n, a, r, s)=>Object.assign(Object.assign(Object.assign({
                client_id: e.clientId
            }, e.authorizationParams), i), {
                scope: $47f2f2762182381c$var$j(t, i.scope),
                response_type: "code",
                response_mode: s || "query",
                state: o,
                nonce: n,
                redirect_uri: r || e.authorizationParams.redirect_uri,
                code_challenge: a,
                code_challenge_method: "S256"
            }))(this.options, this.scope, e, o, n, r, e.redirect_uri || this.options.authorizationParams.redirect_uri || i, null == t ? void 0 : t.response_mode), c = this._authorizeUrl(s);
        return {
            nonce: n,
            code_verifier: a,
            scope: s.scope,
            audience: s.audience || "default",
            redirect_uri: s.redirect_uri,
            state: o,
            url: c
        };
    }
    async loginWithPopup(e, t) {
        var i;
        if (e = e || {}, !(t = t || {}).popup && (t.popup = ((e)=>{
            const t = window.screenX + (window.innerWidth - 400) / 2, i = window.screenY + (window.innerHeight - 600) / 2;
            return window.open(e, "auth0:authorize:popup", `left=${t},top=${i},width=400,height=600,resizable,scrollbars=yes,status=1`);
        })(""), !t.popup)) throw new Error("Unable to open a popup for loginWithPopup - window.open returned `null`");
        const o = await this._prepareAuthorizeUrl(e.authorizationParams || {}, {
            response_mode: "web_message"
        }, window.location.origin);
        t.popup.location.href = o.url;
        const n = await ((e)=>new Promise((t, i)=>{
                let o;
                const n = setInterval(()=>{
                    e.popup && e.popup.closed && (clearInterval(n), clearTimeout(a), window.removeEventListener("message", o, !1), i(new $47f2f2762182381c$export$f1f681f0fb26bb55(e.popup)));
                }, 1e3), a = setTimeout(()=>{
                    clearInterval(n), i(new $47f2f2762182381c$export$ebbb83fe03f719a4(e.popup)), window.removeEventListener("message", o, !1);
                }, 1e3 * (e.timeoutInSeconds || 60));
                o = function(r) {
                    if (r.data && "authorization_response" === r.data.type) {
                        if (clearTimeout(a), clearInterval(n), window.removeEventListener("message", o, !1), e.popup.close(), r.data.response.error) return i($47f2f2762182381c$export$7d465be8efa67280.fromPayload(r.data.response));
                        t(r.data.response);
                    }
                }, window.addEventListener("message", o);
            }))(Object.assign(Object.assign({}, t), {
            timeoutInSeconds: t.timeoutInSeconds || this.options.authorizeTimeoutInSeconds || 60
        }));
        if (o.state !== n.state) throw new $47f2f2762182381c$export$7d465be8efa67280("state_mismatch", "Invalid state");
        const a = (null === (i = e.authorizationParams) || void 0 === i ? void 0 : i.organization) || this.options.authorizationParams.organization;
        await this._requestToken({
            audience: o.audience,
            scope: o.scope,
            code_verifier: o.code_verifier,
            grant_type: "authorization_code",
            code: n.code,
            redirect_uri: o.redirect_uri
        }, {
            nonceIn: o.nonce,
            organization: a
        });
    }
    async getUser() {
        var e;
        const t = await this._getIdTokenFromCache();
        return null === (e = null == t ? void 0 : t.decodedToken) || void 0 === e ? void 0 : e.user;
    }
    async getIdTokenClaims() {
        var e;
        const t = await this._getIdTokenFromCache();
        return null === (e = null == t ? void 0 : t.decodedToken) || void 0 === e ? void 0 : e.claims;
    }
    async loginWithRedirect(t = {}) {
        var i;
        const o = $47f2f2762182381c$var$Q(t), { openUrl: n, fragment: a, appState: r } = o, s = $47f2f2762182381c$var$e(o, [
            "openUrl",
            "fragment",
            "appState"
        ]), c = (null === (i = s.authorizationParams) || void 0 === i ? void 0 : i.organization) || this.options.authorizationParams.organization, d = await this._prepareAuthorizeUrl(s.authorizationParams || {}), { url: u } = d, l = $47f2f2762182381c$var$e(d, [
            "url"
        ]);
        this.transactionManager.create(Object.assign(Object.assign(Object.assign({}, l), {
            appState: r
        }), c && {
            organization: c
        }));
        const h = a ? `${u}#${a}` : u;
        n ? await n(h) : window.location.assign(h);
    }
    async handleRedirectCallback(e = window.location.href) {
        const t = e.split("?").slice(1);
        if (0 === t.length) throw new Error("There are no query params available for parsing.");
        const { state: i, code: o, error: n, error_description: a } = ((e)=>{
            e.indexOf("#") > -1 && (e = e.substring(0, e.indexOf("#")));
            const t = new URLSearchParams(e);
            return {
                state: t.get("state"),
                code: t.get("code") || void 0,
                error: t.get("error") || void 0,
                error_description: t.get("error_description") || void 0
            };
        })(t.join("")), r = this.transactionManager.get();
        if (!r) throw new $47f2f2762182381c$export$7d465be8efa67280("missing_transaction", "Invalid state");
        if (this.transactionManager.remove(), n) throw new $47f2f2762182381c$export$cf0c46b07324e9c5(n, a || n, i, r.appState);
        if (!r.code_verifier || r.state && r.state !== i) throw new $47f2f2762182381c$export$7d465be8efa67280("state_mismatch", "Invalid state");
        const s = r.organization, c = r.nonce, l = r.redirect_uri;
        return await this._requestToken(Object.assign({
            audience: r.audience,
            scope: r.scope,
            code_verifier: r.code_verifier,
            grant_type: "authorization_code",
            code: o
        }, l ? {
            redirect_uri: l
        } : {}), {
            nonceIn: c,
            organization: s
        }), {
            appState: r.appState
        };
    }
    async checkSession(e) {
        if (!this.cookieStorage.get(this.isAuthenticatedCookieName)) {
            if (!this.cookieStorage.get("auth0.is.authenticated")) return;
            this.cookieStorage.save(this.isAuthenticatedCookieName, !0, {
                daysUntilExpire: this.sessionCheckExpiryDays,
                cookieDomain: this.options.cookieDomain
            }), this.cookieStorage.remove("auth0.is.authenticated");
        }
        try {
            await this.getTokenSilently(e);
        } catch (e) {}
    }
    async getTokenSilently(e = {}) {
        var t;
        const i = Object.assign(Object.assign({
            cacheMode: "on"
        }, e), {
            authorizationParams: Object.assign(Object.assign(Object.assign({}, this.options.authorizationParams), e.authorizationParams), {
                scope: $47f2f2762182381c$var$j(this.scope, null === (t = e.authorizationParams) || void 0 === t ? void 0 : t.scope)
            })
        }), o = await ((e, t)=>{
            let i = $47f2f2762182381c$var$A[t];
            return i || (i = e().finally(()=>{
                delete $47f2f2762182381c$var$A[t], i = null;
            }), $47f2f2762182381c$var$A[t] = i), i;
        })(()=>this._getTokenSilently(i), `${this.options.clientId}::${i.authorizationParams.audience}::${i.authorizationParams.scope}`);
        return e.detailedResponse ? o : null == o ? void 0 : o.access_token;
    }
    async _getTokenSilently(t) {
        const { cacheMode: i } = t, o = $47f2f2762182381c$var$e(t, [
            "cacheMode"
        ]);
        if ("off" !== i) {
            const e = await this._getEntryFromCache({
                scope: o.authorizationParams.scope,
                audience: o.authorizationParams.audience || "default",
                clientId: this.options.clientId
            });
            if (e) return e;
        }
        if ("cache-only" !== i) {
            if (!await (async (e, t = 3)=>{
                for(let i = 0; i < t; i++)if (await e()) return !0;
                return !1;
            })(()=>$47f2f2762182381c$var$ee.acquireLock("auth0.lock.getTokenSilently", 5e3), 10)) throw new $47f2f2762182381c$export$66d311bf29d5c89c;
            try {
                if (window.addEventListener("pagehide", this._releaseLockOnPageHide), "off" !== i) {
                    const e = await this._getEntryFromCache({
                        scope: o.authorizationParams.scope,
                        audience: o.authorizationParams.audience || "default",
                        clientId: this.options.clientId
                    });
                    if (e) return e;
                }
                const e = this.options.useRefreshTokens ? await this._getTokenUsingRefreshToken(o) : await this._getTokenFromIFrame(o), { id_token: t, access_token: n, oauthTokenScope: a, expires_in: r } = e;
                return Object.assign(Object.assign({
                    id_token: t,
                    access_token: n
                }, a ? {
                    scope: a
                } : null), {
                    expires_in: r
                });
            } finally{
                await $47f2f2762182381c$var$ee.releaseLock("auth0.lock.getTokenSilently"), window.removeEventListener("pagehide", this._releaseLockOnPageHide);
            }
        }
    }
    async getTokenWithPopup(e = {}, t = {}) {
        var i;
        const o = Object.assign(Object.assign({}, e), {
            authorizationParams: Object.assign(Object.assign(Object.assign({}, this.options.authorizationParams), e.authorizationParams), {
                scope: $47f2f2762182381c$var$j(this.scope, null === (i = e.authorizationParams) || void 0 === i ? void 0 : i.scope)
            })
        });
        t = Object.assign(Object.assign({}, $47f2f2762182381c$var$r), t), await this.loginWithPopup(o, t);
        return (await this.cacheManager.get(new $47f2f2762182381c$var$C({
            scope: o.authorizationParams.scope,
            audience: o.authorizationParams.audience || "default",
            clientId: this.options.clientId
        }))).access_token;
    }
    async isAuthenticated() {
        return !!await this.getUser();
    }
    _buildLogoutUrl(t) {
        null !== t.clientId ? t.clientId = t.clientId || this.options.clientId : delete t.clientId;
        const i = t.logoutParams || {}, { federated: o } = i, n = $47f2f2762182381c$var$e(i, [
            "federated"
        ]), a = o ? "&federated" : "";
        return this._url(`/v2/logout?${$47f2f2762182381c$var$v(Object.assign({
            clientId: t.clientId
        }, n))}`) + a;
    }
    async logout(t = {}) {
        const i = $47f2f2762182381c$var$Q(t), { openUrl: o } = i, n = $47f2f2762182381c$var$e(i, [
            "openUrl"
        ]);
        null === t.clientId ? await this.cacheManager.clear() : await this.cacheManager.clear(t.clientId || this.options.clientId), this.cookieStorage.remove(this.orgHintCookieName, {
            cookieDomain: this.options.cookieDomain
        }), this.cookieStorage.remove(this.isAuthenticatedCookieName, {
            cookieDomain: this.options.cookieDomain
        }), this.userCache.remove("@@user@@");
        const a = this._buildLogoutUrl(n);
        o ? await o(a) : !1 !== o && window.location.assign(a);
    }
    async _getTokenFromIFrame(e) {
        const t = Object.assign(Object.assign({}, e.authorizationParams), {
            prompt: "none"
        }), i = this.cookieStorage.get(this.orgHintCookieName);
        i && !t.organization && (t.organization = i);
        const { url: o, state: n, nonce: a, code_verifier: r, redirect_uri: s, scope: c, audience: u } = await this._prepareAuthorizeUrl(t, {
            response_mode: "web_message"
        }, window.location.origin);
        try {
            if (window.crossOriginIsolated) throw new $47f2f2762182381c$export$7d465be8efa67280("login_required", "The application is running in a Cross-Origin Isolated context, silently retrieving a token without refresh token is not possible.");
            const i = e.timeoutInSeconds || this.options.authorizeTimeoutInSeconds, h = await ((e, t, i = 60)=>new Promise((o, n)=>{
                    const a = window.document.createElement("iframe");
                    a.setAttribute("width", "0"), a.setAttribute("height", "0"), a.style.display = "none";
                    const r = ()=>{
                        window.document.body.contains(a) && (window.document.body.removeChild(a), window.removeEventListener("message", s, !1));
                    };
                    let s;
                    const c = setTimeout(()=>{
                        n(new $47f2f2762182381c$export$66d311bf29d5c89c), r();
                    }, 1e3 * i);
                    s = function(e) {
                        if (e.origin != t) return;
                        if (!e.data || "authorization_response" !== e.data.type) return;
                        const i = e.source;
                        i && i.close(), e.data.response.error ? n($47f2f2762182381c$export$7d465be8efa67280.fromPayload(e.data.response)) : o(e.data.response), clearTimeout(c), window.removeEventListener("message", s, !1), setTimeout(r, 2e3);
                    }, window.addEventListener("message", s, !1), window.document.body.appendChild(a), a.setAttribute("src", e);
                }))(o, this.domainUrl, i);
            if (n !== h.state) throw new $47f2f2762182381c$export$7d465be8efa67280("state_mismatch", "Invalid state");
            const p = await this._requestToken(Object.assign(Object.assign({}, e.authorizationParams), {
                code_verifier: r,
                code: h.code,
                grant_type: "authorization_code",
                redirect_uri: s,
                timeout: e.authorizationParams.timeout || this.httpTimeoutMs
            }), {
                nonceIn: a,
                organization: t.organization
            });
            return Object.assign(Object.assign({}, p), {
                scope: c,
                oauthTokenScope: p.scope,
                audience: u
            });
        } catch (e) {
            throw "login_required" === e.error && this.logout({
                openUrl: !1
            }), e;
        }
    }
    async _getTokenUsingRefreshToken(e) {
        const t = await this.cacheManager.get(new $47f2f2762182381c$var$C({
            scope: e.authorizationParams.scope,
            audience: e.authorizationParams.audience || "default",
            clientId: this.options.clientId
        }));
        if (!(t && t.refresh_token || this.worker)) {
            if (this.options.useRefreshTokensFallback) return await this._getTokenFromIFrame(e);
            throw new $47f2f2762182381c$export$ac1d2a00f8e0a046(e.authorizationParams.audience || "default", e.authorizationParams.scope);
        }
        const i = e.authorizationParams.redirect_uri || this.options.authorizationParams.redirect_uri || window.location.origin, o = "number" == typeof e.timeoutInSeconds ? 1e3 * e.timeoutInSeconds : null;
        try {
            const n = await this._requestToken(Object.assign(Object.assign(Object.assign({}, e.authorizationParams), {
                grant_type: "refresh_token",
                refresh_token: t && t.refresh_token,
                redirect_uri: i
            }), o && {
                timeout: o
            }));
            return Object.assign(Object.assign({}, n), {
                scope: e.authorizationParams.scope,
                oauthTokenScope: n.scope,
                audience: e.authorizationParams.audience || "default"
            });
        } catch (t) {
            if ((t.message.indexOf("Missing Refresh Token") > -1 || t.message && t.message.indexOf("invalid refresh token") > -1) && this.options.useRefreshTokensFallback) return await this._getTokenFromIFrame(e);
            throw t;
        }
    }
    async _saveEntryInCache(t) {
        const { id_token: i, decodedToken: o } = t, n = $47f2f2762182381c$var$e(t, [
            "id_token",
            "decodedToken"
        ]);
        this.userCache.set("@@user@@", {
            id_token: i,
            decodedToken: o
        }), await this.cacheManager.setIdToken(this.options.clientId, t.id_token, t.decodedToken), await this.cacheManager.set(n);
    }
    async _getIdTokenFromCache() {
        const e = this.options.authorizationParams.audience || "default", t = await this.cacheManager.getIdToken(new $47f2f2762182381c$var$C({
            clientId: this.options.clientId,
            audience: e,
            scope: this.scope
        })), i = this.userCache.get("@@user@@");
        return t && t.id_token === (null == i ? void 0 : i.id_token) ? i : (this.userCache.set("@@user@@", t), t);
    }
    async _getEntryFromCache({ scope: e, audience: t, clientId: i }) {
        const o = await this.cacheManager.get(new $47f2f2762182381c$var$C({
            scope: e,
            audience: t,
            clientId: i
        }), 60);
        if (o && o.access_token) {
            const { access_token: e, oauthTokenScope: t, expires_in: i } = o, n = await this._getIdTokenFromCache();
            return n && Object.assign(Object.assign({
                id_token: n.id_token,
                access_token: e
            }, t ? {
                scope: t
            } : null), {
                expires_in: i
            });
        }
    }
    async _requestToken(e, t) {
        const { nonceIn: i, organization: o } = t || {}, n = await $47f2f2762182381c$var$T(Object.assign({
            baseUrl: this.domainUrl,
            client_id: this.options.clientId,
            auth0Client: this.options.auth0Client,
            useFormData: this.options.useFormData,
            timeout: this.httpTimeoutMs
        }, e), this.worker), a = await this._verifyIdToken(n.id_token, i, o);
        return await this._saveEntryInCache(Object.assign(Object.assign(Object.assign(Object.assign({}, n), {
            decodedToken: a,
            scope: e.scope,
            audience: e.audience || "default"
        }), n.scope ? {
            oauthTokenScope: n.scope
        } : null), {
            client_id: this.options.clientId
        })), this.cookieStorage.save(this.isAuthenticatedCookieName, !0, {
            daysUntilExpire: this.sessionCheckExpiryDays,
            cookieDomain: this.options.cookieDomain
        }), this._processOrgHint(o || a.claims.org_id), Object.assign(Object.assign({}, n), {
            decodedToken: a
        });
    }
    constructor(e){
        let t, i;
        if (this.userCache = (new $47f2f2762182381c$export$467265324939f47f).enclosedCache, this.defaultOptions = {
            authorizationParams: {
                scope: "openid profile email"
            },
            useRefreshTokensFallback: !1,
            useFormData: !0
        }, this._releaseLockOnPageHide = async ()=>{
            await $47f2f2762182381c$var$ee.releaseLock("auth0.lock.getTokenSilently"), window.removeEventListener("pagehide", this._releaseLockOnPageHide);
        }, this.options = Object.assign(Object.assign(Object.assign({}, this.defaultOptions), e), {
            authorizationParams: Object.assign(Object.assign({}, this.defaultOptions.authorizationParams), e.authorizationParams)
        }), "undefined" != typeof window && (()=>{
            if (!$47f2f2762182381c$var$w()) throw new Error("For security reasons, `window.crypto` is required to run `auth0-spa-js`.");
            if (void 0 === $47f2f2762182381c$var$w().subtle) throw new Error("\n      auth0-spa-js must run on a secure origin. See https://github.com/auth0/auth0-spa-js/blob/main/FAQ.md#why-do-i-get-auth0-spa-js-must-run-on-a-secure-origin for more information.\n    ");
        })(), e.cache && e.cacheLocation && console.warn("Both `cache` and `cacheLocation` options have been specified in the Auth0Client configuration; ignoring `cacheLocation` and using `cache`."), e.cache) i = e.cache;
        else {
            if (t = e.cacheLocation || "memory", !$47f2f2762182381c$var$q(t)) throw new Error(`Invalid cache location "${t}"`);
            i = $47f2f2762182381c$var$q(t)();
        }
        this.httpTimeoutMs = e.httpTimeoutInSeconds ? 1e3 * e.httpTimeoutInSeconds : 1e4, this.cookieStorage = !1 === e.legacySameSiteCookie ? $47f2f2762182381c$var$X : $47f2f2762182381c$var$N, this.orgHintCookieName = `auth0.${this.options.clientId}.organization_hint`, this.isAuthenticatedCookieName = ((e)=>`auth0.${e}.is.authenticated`)(this.options.clientId), this.sessionCheckExpiryDays = e.sessionCheckExpiryDays || 1;
        const o = e.useCookiesForTransactions ? this.cookieStorage : $47f2f2762182381c$var$J;
        var n;
        this.scope = $47f2f2762182381c$var$j("openid", this.options.authorizationParams.scope, this.options.useRefreshTokens ? "offline_access" : ""), this.transactionManager = new $47f2f2762182381c$var$Z(o, this.options.clientId, this.options.cookieDomain), this.nowProvider = this.options.nowProvider || $47f2f2762182381c$var$c, this.cacheManager = new $47f2f2762182381c$var$x(i, i.allKeys ? void 0 : new $47f2f2762182381c$var$B(i, this.options.clientId), this.nowProvider), this.domainUrl = (n = this.options.domain, /^https?:\/\//.test(n) ? n : `https://${n}`), this.tokenIssuer = ((e, t)=>e ? e.startsWith("https://") ? e : `https://${e}/` : `${t}/`)(this.options.issuer, this.domainUrl), "undefined" != typeof window && window.Worker && this.options.useRefreshTokens && "memory" === t && (this.options.workerUrl ? this.worker = new Worker(this.options.workerUrl) : this.worker = new $47f2f2762182381c$var$M);
    }
}
class $47f2f2762182381c$export$1f44aaf2ec115b54 {
}
/**
 * The initial auth state.
 */ var $47f2f2762182381c$var$initialAuthState = {
    isAuthenticated: false,
    isLoading: true
};
/**
 * @ignore
 */ var $47f2f2762182381c$var$stub = function() {
    throw new Error('You forgot to wrap your component in <Auth0Provider>.');
};
/**
 * @ignore
 */ var $47f2f2762182381c$export$1b5d8f0c33515521 = $47f2f2762182381c$var$__assign($47f2f2762182381c$var$__assign({}, $47f2f2762182381c$var$initialAuthState), {
    buildAuthorizeUrl: $47f2f2762182381c$var$stub,
    buildLogoutUrl: $47f2f2762182381c$var$stub,
    getAccessTokenSilently: $47f2f2762182381c$var$stub,
    getAccessTokenWithPopup: $47f2f2762182381c$var$stub,
    getIdTokenClaims: $47f2f2762182381c$var$stub,
    loginWithRedirect: $47f2f2762182381c$var$stub,
    loginWithPopup: $47f2f2762182381c$var$stub,
    logout: $47f2f2762182381c$var$stub,
    handleRedirectCallback: $47f2f2762182381c$var$stub
});
/**
 * The Auth0 Context
 */ var $47f2f2762182381c$export$419e9d660c2a6030 = (0, $gJYWc.createContext)($47f2f2762182381c$export$1b5d8f0c33515521);
/**
 * An OAuth2 error will come from the authorization server and will have at least an `error` property which will
 * be the error code. And possibly an `error_description` property
 *
 * See: https://openid.net/specs/openid-connect-core-1_0.html#rfc.section.3.1.2.6
 */ var $47f2f2762182381c$export$bdc0f363b754b88f = /** @class */ function(_super) {
    $47f2f2762182381c$var$__extends(OAuthError, _super);
    function OAuthError(error, error_description) {
        var _this = _super.call(this, error_description || error) || this;
        _this.error = error;
        _this.error_description = error_description;
        // https://github.com/Microsoft/TypeScript-wiki/blob/master/Breaking-Changes.md#extending-built-ins-like-error-array-and-map-may-no-longer-work
        Object.setPrototypeOf(_this, OAuthError.prototype);
        return _this;
    }
    return OAuthError;
}(Error);
var $47f2f2762182381c$var$CODE_RE = /[?&]code=[^&]+/;
var $47f2f2762182381c$var$STATE_RE = /[?&]state=[^&]+/;
var $47f2f2762182381c$var$ERROR_RE = /[?&]error=[^&]+/;
var $47f2f2762182381c$var$hasAuthParams = function(searchParams) {
    if (searchParams === void 0) searchParams = window.location.search;
    return ($47f2f2762182381c$var$CODE_RE.test(searchParams) || $47f2f2762182381c$var$ERROR_RE.test(searchParams)) && $47f2f2762182381c$var$STATE_RE.test(searchParams);
};
var $47f2f2762182381c$var$normalizeErrorFn = function(fallbackMessage) {
    return function(error) {
        if (error instanceof Error) return error;
        // try to check errors of the following form: {error: string; error_description?: string}
        if (error !== null && typeof error === 'object' && 'error' in error && typeof error.error === 'string') {
            if ('error_description' in error && typeof error.error_description === 'string') return new $47f2f2762182381c$export$bdc0f363b754b88f(error.error, error.error_description);
            return new $47f2f2762182381c$export$bdc0f363b754b88f(error.error);
        }
        return new Error(fallbackMessage);
    };
};
var $47f2f2762182381c$var$loginError = $47f2f2762182381c$var$normalizeErrorFn('Login failed');
var $47f2f2762182381c$var$tokenError = $47f2f2762182381c$var$normalizeErrorFn('Get access token failed');
/**
 * @ignore
 * Helper function to map the v1 `redirectUri` option to the v2 `authorizationParams.redirect_uri`
 * and log a warning.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
var $47f2f2762182381c$var$deprecateRedirectUri = function(options) {
    var _a;
    if (options === null || options === void 0 ? void 0 : options.redirectUri) {
        console.warn('Using `redirectUri` has been deprecated, please use `authorizationParams.redirect_uri` instead as `redirectUri` will be no longer supported in a future version');
        options.authorizationParams = options.authorizationParams || {};
        options.authorizationParams.redirect_uri = options.redirectUri;
        delete options.redirectUri;
    }
    if ((_a = options === null || options === void 0 ? void 0 : options.authorizationParams) === null || _a === void 0 ? void 0 : _a.redirectUri) {
        console.warn('Using `authorizationParams.redirectUri` has been deprecated, please use `authorizationParams.redirect_uri` instead as `authorizationParams.redirectUri` will be removed in a future version');
        options.authorizationParams.redirect_uri = options.authorizationParams.redirectUri;
        delete options.authorizationParams.redirectUri;
    }
};
/**
 * Handles how that state changes in the `useAuth0` hook.
 */ var $47f2f2762182381c$var$reducer = function(state, action) {
    switch(action.type){
        case 'LOGIN_POPUP_STARTED':
            return $47f2f2762182381c$var$__assign($47f2f2762182381c$var$__assign({}, state), {
                isLoading: true
            });
        case 'LOGIN_POPUP_COMPLETE':
        case 'INITIALISED':
            return $47f2f2762182381c$var$__assign($47f2f2762182381c$var$__assign({}, state), {
                isAuthenticated: !!action.user,
                user: action.user,
                isLoading: false,
                error: undefined
            });
        case 'HANDLE_REDIRECT_COMPLETE':
        case 'GET_ACCESS_TOKEN_COMPLETE':
            if (state.user === action.user) return state;
            return $47f2f2762182381c$var$__assign($47f2f2762182381c$var$__assign({}, state), {
                isAuthenticated: !!action.user,
                user: action.user
            });
        case 'LOGOUT':
            return $47f2f2762182381c$var$__assign($47f2f2762182381c$var$__assign({}, state), {
                isAuthenticated: false,
                user: undefined
            });
        case 'ERROR':
            return $47f2f2762182381c$var$__assign($47f2f2762182381c$var$__assign({}, state), {
                isLoading: false,
                error: action.error
            });
    }
};
/**
 * @ignore
 */ var $47f2f2762182381c$var$toAuth0ClientOptions = function(opts) {
    $47f2f2762182381c$var$deprecateRedirectUri(opts);
    return $47f2f2762182381c$var$__assign($47f2f2762182381c$var$__assign({}, opts), {
        auth0Client: {
            name: 'auth0-react',
            version: '2.3.0'
        }
    });
};
/**
 * @ignore
 */ var $47f2f2762182381c$var$defaultOnRedirectCallback = function(appState) {
    window.history.replaceState({}, document.title, (appState === null || appState === void 0 ? void 0 : appState.returnTo) || window.location.pathname);
};
/**
 * ```jsx
 * <Auth0Provider
 *   domain={domain}
 *   clientId={clientId}
 *   authorizationParams={{ redirect_uri: window.location.origin }}>
 *   <MyApp />
 * </Auth0Provider>
 * ```
 *
 * Provides the Auth0Context to its child components.
 */ var $47f2f2762182381c$export$6aefaad9cc4faf3c = function(opts) {
    var children = opts.children, skipRedirectCallback = opts.skipRedirectCallback, _a = opts.onRedirectCallback, onRedirectCallback = _a === void 0 ? $47f2f2762182381c$var$defaultOnRedirectCallback : _a, _b = opts.context, context = _b === void 0 ? $47f2f2762182381c$export$419e9d660c2a6030 : _b, clientOpts = $47f2f2762182381c$var$__rest(opts, [
        "children",
        "skipRedirectCallback",
        "onRedirectCallback",
        "context"
    ]);
    var client = (0, $gJYWc.useState)(function() {
        return new $47f2f2762182381c$var$te($47f2f2762182381c$var$toAuth0ClientOptions(clientOpts));
    })[0];
    var _c = (0, $gJYWc.useReducer)($47f2f2762182381c$var$reducer, $47f2f2762182381c$var$initialAuthState), state = _c[0], dispatch = _c[1];
    var didInitialise = (0, $gJYWc.useRef)(false);
    var handleError = (0, $gJYWc.useCallback)(function(error) {
        dispatch({
            type: 'ERROR',
            error: error
        });
        return error;
    }, []);
    (0, $gJYWc.useEffect)(function() {
        if (didInitialise.current) return;
        didInitialise.current = true;
        (function() {
            return $47f2f2762182381c$var$__awaiter(void 0, void 0, void 0, function() {
                var user, appState, error_1;
                return $47f2f2762182381c$var$__generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            _a.trys.push([
                                0,
                                7,
                                ,
                                8
                            ]);
                            user = void 0;
                            if (!($47f2f2762182381c$var$hasAuthParams() && !skipRedirectCallback)) return [
                                3 /*break*/ ,
                                3
                            ];
                            return [
                                4 /*yield*/ ,
                                client.handleRedirectCallback()
                            ];
                        case 1:
                            appState = _a.sent().appState;
                            return [
                                4 /*yield*/ ,
                                client.getUser()
                            ];
                        case 2:
                            user = _a.sent();
                            onRedirectCallback(appState, user);
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case 3:
                            return [
                                4 /*yield*/ ,
                                client.checkSession()
                            ];
                        case 4:
                            _a.sent();
                            return [
                                4 /*yield*/ ,
                                client.getUser()
                            ];
                        case 5:
                            user = _a.sent();
                            _a.label = 6;
                        case 6:
                            dispatch({
                                type: 'INITIALISED',
                                user: user
                            });
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case 7:
                            error_1 = _a.sent();
                            handleError($47f2f2762182381c$var$loginError(error_1));
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case 8:
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        })();
    }, [
        client,
        onRedirectCallback,
        skipRedirectCallback,
        handleError
    ]);
    var loginWithRedirect = (0, $gJYWc.useCallback)(function(opts) {
        $47f2f2762182381c$var$deprecateRedirectUri(opts);
        return client.loginWithRedirect(opts);
    }, [
        client
    ]);
    var loginWithPopup = (0, $gJYWc.useCallback)(function(options, config) {
        return $47f2f2762182381c$var$__awaiter(void 0, void 0, void 0, function() {
            var error_2, user;
            return $47f2f2762182381c$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        dispatch({
                            type: 'LOGIN_POPUP_STARTED'
                        });
                        _a.label = 1;
                    case 1:
                        _a.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4 /*yield*/ ,
                            client.loginWithPopup(options, config)
                        ];
                    case 2:
                        _a.sent();
                        return [
                            3 /*break*/ ,
                            4
                        ];
                    case 3:
                        error_2 = _a.sent();
                        handleError($47f2f2762182381c$var$loginError(error_2));
                        return [
                            2 /*return*/ 
                        ];
                    case 4:
                        return [
                            4 /*yield*/ ,
                            client.getUser()
                        ];
                    case 5:
                        user = _a.sent();
                        dispatch({
                            type: 'LOGIN_POPUP_COMPLETE',
                            user: user
                        });
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    }, [
        client
    ]);
    var logout = (0, $gJYWc.useCallback)(function(opts) {
        if (opts === void 0) opts = {};
        return $47f2f2762182381c$var$__awaiter(void 0, void 0, void 0, function() {
            return $47f2f2762182381c$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            client.logout(opts)
                        ];
                    case 1:
                        _a.sent();
                        if (opts.openUrl || opts.openUrl === false) dispatch({
                            type: 'LOGOUT'
                        });
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    }, [
        client
    ]);
    var getAccessTokenSilently = (0, $gJYWc.useCallback)(// eslint-disable-next-line @typescript-eslint/no-explicit-any
    function(opts) {
        return $47f2f2762182381c$var$__awaiter(void 0, void 0, void 0, function() {
            var token, error_3, _a;
            var _b;
            return $47f2f2762182381c$var$__generator(this, function(_c) {
                switch(_c.label){
                    case 0:
                        _c.trys.push([
                            0,
                            2,
                            3,
                            5
                        ]);
                        return [
                            4 /*yield*/ ,
                            client.getTokenSilently(opts)
                        ];
                    case 1:
                        token = _c.sent();
                        return [
                            3 /*break*/ ,
                            5
                        ];
                    case 2:
                        error_3 = _c.sent();
                        throw $47f2f2762182381c$var$tokenError(error_3);
                    case 3:
                        _a = dispatch;
                        _b = {
                            type: 'GET_ACCESS_TOKEN_COMPLETE'
                        };
                        return [
                            4 /*yield*/ ,
                            client.getUser()
                        ];
                    case 4:
                        _a.apply(void 0, [
                            (_b.user = _c.sent(), _b)
                        ]);
                        return [
                            7 /*endfinally*/ 
                        ];
                    case 5:
                        return [
                            2 /*return*/ ,
                            token
                        ];
                }
            });
        });
    }, [
        client
    ]);
    var getAccessTokenWithPopup = (0, $gJYWc.useCallback)(function(opts, config) {
        return $47f2f2762182381c$var$__awaiter(void 0, void 0, void 0, function() {
            var token, error_4, _a;
            var _b;
            return $47f2f2762182381c$var$__generator(this, function(_c) {
                switch(_c.label){
                    case 0:
                        _c.trys.push([
                            0,
                            2,
                            3,
                            5
                        ]);
                        return [
                            4 /*yield*/ ,
                            client.getTokenWithPopup(opts, config)
                        ];
                    case 1:
                        token = _c.sent();
                        return [
                            3 /*break*/ ,
                            5
                        ];
                    case 2:
                        error_4 = _c.sent();
                        throw $47f2f2762182381c$var$tokenError(error_4);
                    case 3:
                        _a = dispatch;
                        _b = {
                            type: 'GET_ACCESS_TOKEN_COMPLETE'
                        };
                        return [
                            4 /*yield*/ ,
                            client.getUser()
                        ];
                    case 4:
                        _a.apply(void 0, [
                            (_b.user = _c.sent(), _b)
                        ]);
                        return [
                            7 /*endfinally*/ 
                        ];
                    case 5:
                        return [
                            2 /*return*/ ,
                            token
                        ];
                }
            });
        });
    }, [
        client
    ]);
    var getIdTokenClaims = (0, $gJYWc.useCallback)(function() {
        return client.getIdTokenClaims();
    }, [
        client
    ]);
    var handleRedirectCallback = (0, $gJYWc.useCallback)(function(url) {
        return $47f2f2762182381c$var$__awaiter(void 0, void 0, void 0, function() {
            var error_5, _a;
            var _b;
            return $47f2f2762182381c$var$__generator(this, function(_c) {
                switch(_c.label){
                    case 0:
                        _c.trys.push([
                            0,
                            2,
                            3,
                            5
                        ]);
                        return [
                            4 /*yield*/ ,
                            client.handleRedirectCallback(url)
                        ];
                    case 1:
                        return [
                            2 /*return*/ ,
                            _c.sent()
                        ];
                    case 2:
                        error_5 = _c.sent();
                        throw $47f2f2762182381c$var$tokenError(error_5);
                    case 3:
                        _a = dispatch;
                        _b = {
                            type: 'HANDLE_REDIRECT_COMPLETE'
                        };
                        return [
                            4 /*yield*/ ,
                            client.getUser()
                        ];
                    case 4:
                        _a.apply(void 0, [
                            (_b.user = _c.sent(), _b)
                        ]);
                        return [
                            7 /*endfinally*/ 
                        ];
                    case 5:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    }, [
        client
    ]);
    var contextValue = (0, $gJYWc.useMemo)(function() {
        return $47f2f2762182381c$var$__assign($47f2f2762182381c$var$__assign({}, state), {
            getAccessTokenSilently: getAccessTokenSilently,
            getAccessTokenWithPopup: getAccessTokenWithPopup,
            getIdTokenClaims: getIdTokenClaims,
            loginWithRedirect: loginWithRedirect,
            loginWithPopup: loginWithPopup,
            logout: logout,
            handleRedirectCallback: handleRedirectCallback
        });
    }, [
        state,
        getAccessTokenSilently,
        getAccessTokenWithPopup,
        getIdTokenClaims,
        loginWithRedirect,
        loginWithPopup,
        logout,
        handleRedirectCallback
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($gJYWc))).createElement(context.Provider, {
        value: contextValue
    }, children);
};
/**
 * ```js
 * const {
 *   // Auth state:
 *   error,
 *   isAuthenticated,
 *   isLoading,
 *   user,
 *   // Auth methods:
 *   getAccessTokenSilently,
 *   getAccessTokenWithPopup,
 *   getIdTokenClaims,
 *   loginWithRedirect,
 *   loginWithPopup,
 *   logout,
 * } = useAuth0<TUser>();
 * ```
 *
 * Use the `useAuth0` hook in your components to access the auth state and methods.
 *
 * TUser is an optional type param to provide a type to the `user` field.
 */ var $47f2f2762182381c$export$f2b63d3ca66bb884 = function(context) {
    if (context === void 0) context = $47f2f2762182381c$export$419e9d660c2a6030;
    return (0, $gJYWc.useContext)(context);
};
/**
 * ```jsx
 * class MyComponent extends Component {
 *   render() {
 *     // Access the auth context from the `auth0` prop
 *     const { user } = this.props.auth0;
 *     return <div>Hello {user.name}!</div>
 *   }
 * }
 * // Wrap your class component in withAuth0
 * export default withAuth0(MyComponent);
 * ```
 *
 * Wrap your class components in this Higher Order Component to give them access to the Auth0Context.
 *
 * Providing a context as the second argument allows you to configure the Auth0Provider the Auth0Context
 * should come from f you have multiple within your application.
 */ var $47f2f2762182381c$export$bf0b363fae22b33f = function(Component, context) {
    if (context === void 0) context = $47f2f2762182381c$export$419e9d660c2a6030;
    return function WithAuth(props) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($gJYWc))).createElement(context.Consumer, null, function(auth) {
            return (0, (/*@__PURE__*/$parcel$interopDefault($gJYWc))).createElement(Component, $47f2f2762182381c$var$__assign({}, props, {
                auth0: auth
            }));
        });
    };
};
/**
 * @ignore
 */ var $47f2f2762182381c$var$defaultOnRedirecting = function() {
    return (0, (/*@__PURE__*/$parcel$interopDefault($gJYWc))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gJYWc))).Fragment, null);
};
/**
* @ignore
*/ var $47f2f2762182381c$var$defaultOnBeforeAuthentication = function() {
    return $47f2f2762182381c$var$__awaiter(void 0, void 0, void 0, function() {
        return $47f2f2762182381c$var$__generator(this, function(_a) {
            return [
                2 /*return*/ 
            ];
        });
    });
};
/**
 * @ignore
 */ var $47f2f2762182381c$var$defaultReturnTo = function() {
    return "".concat(window.location.pathname).concat(window.location.search);
};
/**
 * ```js
 * const MyProtectedComponent = withAuthenticationRequired(MyComponent);
 * ```
 *
 * When you wrap your components in this Higher Order Component and an anonymous user visits your component
 * they will be redirected to the login page; after login they will be returned to the page they were redirected from.
 */ var $47f2f2762182381c$export$2cfd0b285ff12c70 = function(Component, options) {
    if (options === void 0) options = {};
    return function WithAuthenticationRequired(props) {
        var _this = this;
        var _a = options.returnTo, returnTo = _a === void 0 ? $47f2f2762182381c$var$defaultReturnTo : _a, _b = options.onRedirecting, onRedirecting = _b === void 0 ? $47f2f2762182381c$var$defaultOnRedirecting : _b, _c = options.onBeforeAuthentication, onBeforeAuthentication = _c === void 0 ? $47f2f2762182381c$var$defaultOnBeforeAuthentication : _c, loginOptions = options.loginOptions, _d = options.context, context = _d === void 0 ? $47f2f2762182381c$export$419e9d660c2a6030 : _d;
        var _e = $47f2f2762182381c$export$f2b63d3ca66bb884(context), isAuthenticated = _e.isAuthenticated, isLoading = _e.isLoading, loginWithRedirect = _e.loginWithRedirect;
        (0, $gJYWc.useEffect)(function() {
            if (isLoading || isAuthenticated) return;
            var opts = $47f2f2762182381c$var$__assign($47f2f2762182381c$var$__assign({}, loginOptions), {
                appState: $47f2f2762182381c$var$__assign($47f2f2762182381c$var$__assign({}, loginOptions && loginOptions.appState), {
                    returnTo: typeof returnTo === 'function' ? returnTo() : returnTo
                })
            });
            (function() {
                return $47f2f2762182381c$var$__awaiter(_this, void 0, void 0, function() {
                    return $47f2f2762182381c$var$__generator(this, function(_a) {
                        switch(_a.label){
                            case 0:
                                return [
                                    4 /*yield*/ ,
                                    onBeforeAuthentication()
                                ];
                            case 1:
                                _a.sent();
                                return [
                                    4 /*yield*/ ,
                                    loginWithRedirect(opts)
                                ];
                            case 2:
                                _a.sent();
                                return [
                                    2 /*return*/ 
                                ];
                        }
                    });
                });
            })();
        }, [
            isLoading,
            isAuthenticated,
            loginWithRedirect,
            onBeforeAuthentication,
            loginOptions,
            returnTo
        ]);
        return isAuthenticated ? (0, (/*@__PURE__*/$parcel$interopDefault($gJYWc))).createElement(Component, $47f2f2762182381c$var$__assign({}, props)) : onRedirecting();
    };
};



var $9wx12 = parcelRequire("9wx12");
parcelRequire("gJYWc");




var $2b06c7a0aed55a49$exports = {};
"use strict";
"use client";

var $hrFuR = parcelRequire("hrFuR");
Object.defineProperty($2b06c7a0aed55a49$exports, "__esModule", {
    value: true
});
$2b06c7a0aed55a49$exports.default = void 0;

var $2b06c7a0aed55a49$var$_createSvgIcon = $hrFuR((parcelRequire("lXMfO")));

var $9wx12 = parcelRequire("9wx12");
var $2b06c7a0aed55a49$var$_default = $2b06c7a0aed55a49$exports.default = (0, $2b06c7a0aed55a49$var$_createSvgIcon.default)([
    /*#__PURE__*/ (0, $9wx12.jsx)("circle", {
        cx: "12",
        cy: "4",
        r: "2"
    }, "0"),
    /*#__PURE__*/ (0, $9wx12.jsx)("path", {
        d: "M15.89 8.11C15.5 7.72 14.83 7 13.53 7h-2.54C8.24 6.99 6 4.75 6 2H4c0 3.16 2.11 5.84 5 6.71V22h2v-6h2v6h2V10.05L18.95 14l1.41-1.41z"
    }, "1")
], 'EmojiPeople');


var $eb8f078589e156c5$exports = {};
"use strict";
"use client";

var $hrFuR = parcelRequire("hrFuR");
Object.defineProperty($eb8f078589e156c5$exports, "__esModule", {
    value: true
});
$eb8f078589e156c5$exports.default = void 0;

var $eb8f078589e156c5$var$_createSvgIcon = $hrFuR((parcelRequire("lXMfO")));

var $9wx12 = parcelRequire("9wx12");
var $eb8f078589e156c5$var$_default = $eb8f078589e156c5$exports.default = (0, $eb8f078589e156c5$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $9wx12.jsx)("path", {
    d: "M22 21V7L12 3 2 7v14h5v-9h10v9zm-11-2H9v2h2zm2-3h-2v2h2zm2 3h-2v2h2z"
}), 'Warehouse');


var $da5f59b68286c85a$exports = {};
"use strict";
"use client";

var $hrFuR = parcelRequire("hrFuR");
Object.defineProperty($da5f59b68286c85a$exports, "__esModule", {
    value: true
});
$da5f59b68286c85a$exports.default = void 0;

var $da5f59b68286c85a$var$_createSvgIcon = $hrFuR((parcelRequire("lXMfO")));

var $9wx12 = parcelRequire("9wx12");
var $da5f59b68286c85a$var$_default = $da5f59b68286c85a$exports.default = (0, $da5f59b68286c85a$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $9wx12.jsx)("path", {
    d: "M21 10h-8.35C11.83 7.67 9.61 6 7 6c-3.31 0-6 2.69-6 6s2.69 6 6 6c2.61 0 4.83-1.67 5.65-4H13l2 2 2-2 2 2 4-4.04zM7 15c-1.65 0-3-1.35-3-3s1.35-3 3-3 3 1.35 3 3-1.35 3-3 3"
}), 'Key');


var $cc6d74c2d4bf0e72$exports = {};
"use strict";
"use client";

var $hrFuR = parcelRequire("hrFuR");
Object.defineProperty($cc6d74c2d4bf0e72$exports, "__esModule", {
    value: true
});
$cc6d74c2d4bf0e72$exports.default = void 0;

var $cc6d74c2d4bf0e72$var$_createSvgIcon = $hrFuR((parcelRequire("lXMfO")));

var $9wx12 = parcelRequire("9wx12");
var $cc6d74c2d4bf0e72$var$_default = $cc6d74c2d4bf0e72$exports.default = (0, $cc6d74c2d4bf0e72$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $9wx12.jsx)("path", {
    d: "M19 2H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h4l3 3 3-3h4c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2m-6 16h-2v-2h2zm2.07-7.75-.9.92C13.45 11.9 13 12.5 13 14h-2v-.5c0-1.1.45-2.1 1.17-2.83l1.24-1.26c.37-.36.59-.86.59-1.41 0-1.1-.9-2-2-2s-2 .9-2 2H8c0-2.21 1.79-4 4-4s4 1.79 4 4c0 .88-.36 1.68-.93 2.25"
}), 'LiveHelp');




const $135535c9b579e2fc$export$1ed4b10e4aba04a7 = ()=>{
    const { user: user } = (0, $47f2f2762182381c$export$f2b63d3ca66bb884)();
    const isAdmin = user?.sub === undefined;
    return /*#__PURE__*/ (0, $9wx12.jsxs)((0, $9wx12.Fragment), {
        children: [
            /*#__PURE__*/ (0, $9wx12.jsx)((0, $fc72cc536184e560$export$8b251419efc915eb), {
                withBorder: true
            }),
            /*#__PURE__*/ (0, $9wx12.jsxs)("div", {
                className: "max-w-screen-lg mx-auto mt-10",
                children: [
                    /*#__PURE__*/ (0, $9wx12.jsx)((0, $b4083ea3a052dee9$export$2e2bcd8739ae039), {
                        variant: "h3",
                        children: "Account"
                    }),
                    /*#__PURE__*/ (0, $9wx12.jsxs)((0, $b4083ea3a052dee9$export$2e2bcd8739ae039), {
                        fontSize: 17,
                        mb: 3,
                        children: [
                            /*#__PURE__*/ (0, $9wx12.jsx)("b", {
                                children: user?.name
                            }),
                            ", ",
                            user?.email
                        ]
                    }),
                    /*#__PURE__*/ (0, $9wx12.jsxs)("div", {
                        className: "grid grid-cols-1 md:grid-cols-3 gap-5",
                        children: [
                            /*#__PURE__*/ (0, $9wx12.jsx)((0, $8384e1b28fff68bc$export$a6c7ac8248d6e38a), {
                                to: "personal",
                                children: /*#__PURE__*/ (0, $9wx12.jsx)((0, $0f9f0d79038d27f1$export$2e2bcd8739ae039), {
                                    children: /*#__PURE__*/ (0, $9wx12.jsxs)((0, $f1b4cb86cd061e99$export$2e2bcd8739ae039), {
                                        children: [
                                            /*#__PURE__*/ (0, $9wx12.jsx)("div", {
                                                className: "mb-5",
                                                children: /*#__PURE__*/ (0, $9wx12.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($2b06c7a0aed55a49$exports))), {
                                                    fontSize: "large"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $9wx12.jsx)((0, $b4083ea3a052dee9$export$2e2bcd8739ae039), {
                                                variant: "h5",
                                                component: "div",
                                                children: "Personal info"
                                            }),
                                            /*#__PURE__*/ (0, $9wx12.jsx)((0, $b4083ea3a052dee9$export$2e2bcd8739ae039), {
                                                variant: "body2",
                                                children: "Personal information and your details"
                                            })
                                        ]
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0, $9wx12.jsx)((0, $8384e1b28fff68bc$export$a6c7ac8248d6e38a), {
                                to: "bookings",
                                children: /*#__PURE__*/ (0, $9wx12.jsx)((0, $0f9f0d79038d27f1$export$2e2bcd8739ae039), {
                                    children: /*#__PURE__*/ (0, $9wx12.jsxs)((0, $f1b4cb86cd061e99$export$2e2bcd8739ae039), {
                                        children: [
                                            /*#__PURE__*/ (0, $9wx12.jsx)("div", {
                                                className: "mb-5",
                                                children: /*#__PURE__*/ (0, $9wx12.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($da5f59b68286c85a$exports))), {
                                                    fontSize: "large"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $9wx12.jsx)((0, $b4083ea3a052dee9$export$2e2bcd8739ae039), {
                                                variant: "h5",
                                                component: "div",
                                                children: "Bookings"
                                            }),
                                            /*#__PURE__*/ (0, $9wx12.jsx)((0, $b4083ea3a052dee9$export$2e2bcd8739ae039), {
                                                variant: "body2",
                                                children: "Bookings have been made by you"
                                            })
                                        ]
                                    })
                                })
                            }),
                            isAdmin && /*#__PURE__*/ (0, $9wx12.jsx)((0, $8384e1b28fff68bc$export$a6c7ac8248d6e38a), {
                                to: "listings",
                                children: /*#__PURE__*/ (0, $9wx12.jsx)((0, $0f9f0d79038d27f1$export$2e2bcd8739ae039), {
                                    children: /*#__PURE__*/ (0, $9wx12.jsxs)((0, $f1b4cb86cd061e99$export$2e2bcd8739ae039), {
                                        children: [
                                            /*#__PURE__*/ (0, $9wx12.jsx)("div", {
                                                className: "mb-5",
                                                children: /*#__PURE__*/ (0, $9wx12.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($eb8f078589e156c5$exports))), {
                                                    fontSize: "large"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $9wx12.jsx)((0, $b4083ea3a052dee9$export$2e2bcd8739ae039), {
                                                variant: "h5",
                                                component: "div",
                                                children: "My properties"
                                            }),
                                            /*#__PURE__*/ (0, $9wx12.jsx)((0, $b4083ea3a052dee9$export$2e2bcd8739ae039), {
                                                variant: "body2",
                                                children: "Listing of properties you offer"
                                            })
                                        ]
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0, $9wx12.jsx)((0, $8384e1b28fff68bc$export$a6c7ac8248d6e38a), {
                                to: "help",
                                children: /*#__PURE__*/ (0, $9wx12.jsx)((0, $0f9f0d79038d27f1$export$2e2bcd8739ae039), {
                                    children: /*#__PURE__*/ (0, $9wx12.jsxs)((0, $f1b4cb86cd061e99$export$2e2bcd8739ae039), {
                                        children: [
                                            /*#__PURE__*/ (0, $9wx12.jsx)("div", {
                                                className: "mb-5",
                                                children: /*#__PURE__*/ (0, $9wx12.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($cc6d74c2d4bf0e72$exports))), {
                                                    fontSize: "large"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $9wx12.jsx)((0, $b4083ea3a052dee9$export$2e2bcd8739ae039), {
                                                variant: "h5",
                                                component: "div",
                                                children: "Help center"
                                            }),
                                            /*#__PURE__*/ (0, $9wx12.jsx)((0, $b4083ea3a052dee9$export$2e2bcd8739ae039), {
                                                variant: "body2",
                                                children: "Submit question and get help"
                                            })
                                        ]
                                    })
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
};



var $9wx12 = parcelRequire("9wx12");

var $gJYWc = parcelRequire("gJYWc");





var $9wx12 = parcelRequire("9wx12");
parcelRequire("gJYWc");



var $540b2e55b46e5951$exports = {};
"use strict";
"use client";

var $hrFuR = parcelRequire("hrFuR");
Object.defineProperty($540b2e55b46e5951$exports, "__esModule", {
    value: true
});
$540b2e55b46e5951$exports.default = void 0;

var $540b2e55b46e5951$var$_createSvgIcon = $hrFuR((parcelRequire("lXMfO")));

var $9wx12 = parcelRequire("9wx12");
var $540b2e55b46e5951$var$_default = $540b2e55b46e5951$exports.default = (0, $540b2e55b46e5951$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $9wx12.jsx)("path", {
    d: "M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6z"
}), 'Add');


const $b67f7806c29145a2$export$df6ba04d914b0c0a = ()=>{
    return /*#__PURE__*/ (0, $9wx12.jsx)((0, $8384e1b28fff68bc$export$a6c7ac8248d6e38a), {
        className: "flex-1 relative",
        to: 'new',
        children: /*#__PURE__*/ (0, $9wx12.jsx)((0, $0f9f0d79038d27f1$export$2e2bcd8739ae039), {
            sx: {
                border: 'none',
                height: 320,
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center'
            },
            children: /*#__PURE__*/ (0, $9wx12.jsx)((0, $7fd75e6b57001627$export$2e2bcd8739ae039), {
                sx: {
                    display: 'flex',
                    transform: 'scale(5)'
                },
                children: /*#__PURE__*/ (0, $9wx12.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($540b2e55b46e5951$exports))), {
                    fontSize: "inherit"
                })
            })
        })
    });
};



const $8093f2f2d86049f5$export$ba6d244036e50401 = ()=>{
    const { user: user } = (0, $47f2f2762182381c$export$f2b63d3ca66bb884)();
    const isMisha = user?.sub === undefined;
    const [ads, setAdds] = (0, $gJYWc.useState)([]);
    (0, $gJYWc.useEffect)(()=>{
        const fetchAds = async ()=>{
            const ads = await (0, $70a97169caddc04c$export$2192e8c52b17d09e)();
            setAdds(ads);
        };
        if (user && isMisha) fetchAds().catch(console.error);
    }, [
        user
    ]);
    return /*#__PURE__*/ (0, $9wx12.jsxs)((0, $9wx12.Fragment), {
        children: [
            /*#__PURE__*/ (0, $9wx12.jsx)((0, $fc72cc536184e560$export$8b251419efc915eb), {
                withBorder: true
            }),
            /*#__PURE__*/ (0, $9wx12.jsxs)("div", {
                className: "max-w-screen-lg mx-auto mt-10",
                children: [
                    /*#__PURE__*/ (0, $9wx12.jsx)((0, $b4083ea3a052dee9$export$2e2bcd8739ae039), {
                        variant: "h3",
                        mb: 3,
                        children: "My listings"
                    }),
                    /*#__PURE__*/ (0, $9wx12.jsxs)("div", {
                        className: "grid grid-cols-1 md:grid-cols-3 gap-5",
                        children: [
                            ads.length ? ads.map(({ district: district, title: title, name: name, price: price, id: id, hero_images: hero_images = [], is_published: is_published })=>/*#__PURE__*/ (0, $9wx12.jsx)((0, $17c769015ed16526$export$b56e55a3645a3ec), {
                                    id: id,
                                    image: hero_images?.['0'],
                                    name: name,
                                    district: district,
                                    title: title,
                                    to: `${id}`,
                                    is_published: is_published,
                                    showStatus: true
                                }, id)) : /*#__PURE__*/ (0, $9wx12.jsx)((0, $b4083ea3a052dee9$export$2e2bcd8739ae039), {
                                children: "No listings yet"
                            }),
                            /*#__PURE__*/ (0, $9wx12.jsx)((0, $b67f7806c29145a2$export$df6ba04d914b0c0a), {})
                        ]
                    })
                ]
            })
        ]
    });
};



var $9wx12 = parcelRequire("9wx12");

var $gJYWc = parcelRequire("gJYWc");




var $gJYWc = parcelRequire("gJYWc");

var $3Zour = parcelRequire("3Zour");
var $8afe3d8bf5ddfcf3$exports = {};
/*!
 * jsoneditor.js
 *
 * @brief
 * JSONEditor is a web-based tool to view, edit, format, and validate JSON.
 * It has various modes such as a tree editor, a code editor, and a plain text
 * editor.
 *
 * Supported browsers: Chrome, Firefox, Safari, Edge
 *
 * @license
 * Licensed under the Apache License, Version 2.0 (the "License"); you may not
 * use this file except in compliance with the License. You may obtain a copy
 * of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied. See the
 * License for the specific language governing permissions and limitations under
 * the License.
 *
 * Copyright (c) 2011-2025 Jos de Jong, http://jsoneditoronline.org
 *
 * @author  Jos de Jong, <wjosdejong@gmail.com>
 * @version 10.1.3
 * @date    2025-02-17
 */ (function webpackUniversalModuleDefinition(root, factory) {
    $8afe3d8bf5ddfcf3$exports = factory();
})(self, function() {
    return /******/ function() {
        /******/ var __webpack_modules__ = {
            /***/ 57: /***/ function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {
                "use strict";
                /* harmony export */ __webpack_require__.d(__webpack_exports__, {
                    /* harmony export */ AI: function() {
                        return /* binding */ setLanguages;
                    },
                    /* harmony export */ Tl: function() {
                        return /* binding */ translate;
                    },
                    /* harmony export */ xC: function() {
                        return /* binding */ setLanguage;
                    }
                });
                /* harmony import */ var _polyfills__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(81);
                /* harmony import */ var _polyfills__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/ __webpack_require__.n(_polyfills__WEBPACK_IMPORTED_MODULE_0__);
                /* eslint-disable no-template-curly-in-string */ var _defs = {
                    en: {
                        array: 'Array',
                        auto: 'Auto',
                        appendText: 'Append',
                        appendTitle: 'Append a new field with type \'auto\' after this field (Ctrl+Shift+Ins)',
                        appendSubmenuTitle: 'Select the type of the field to be appended',
                        appendTitleAuto: 'Append a new field with type \'auto\' (Ctrl+Shift+Ins)',
                        ascending: 'Ascending',
                        ascendingTitle: 'Sort the childs of this ${type} in ascending order',
                        actionsMenu: 'Click to open the actions menu (Ctrl+M)',
                        cannotParseFieldError: 'Cannot parse field into JSON',
                        cannotParseValueError: 'Cannot parse value into JSON',
                        collapseAll: 'Collapse all fields',
                        compactTitle: 'Compact JSON data, remove all whitespaces (Ctrl+Shift+I)',
                        descending: 'Descending',
                        descendingTitle: 'Sort the childs of this ${type} in descending order',
                        drag: 'Drag to move this field (Alt+Shift+Arrows)',
                        duplicateKey: 'duplicate key',
                        duplicateText: 'Duplicate',
                        duplicateTitle: 'Duplicate selected fields (Ctrl+D)',
                        duplicateField: 'Duplicate this field (Ctrl+D)',
                        duplicateFieldError: 'Duplicate field name',
                        empty: 'empty',
                        expandAll: 'Expand all fields',
                        expandTitle: "Click to expand/collapse this field (Ctrl+E). \nCtrl+Click to expand/collapse including all childs.",
                        formatTitle: 'Format JSON data, with proper indentation and line feeds (Ctrl+I)',
                        insert: 'Insert',
                        insertTitle: 'Insert a new field with type \'auto\' before this field (Ctrl+Ins)',
                        insertSub: 'Select the type of the field to be inserted',
                        object: 'Object',
                        ok: 'Ok',
                        redo: 'Redo (Ctrl+Shift+Z)',
                        removeText: 'Remove',
                        removeTitle: 'Remove selected fields (Ctrl+Del)',
                        removeField: 'Remove this field (Ctrl+Del)',
                        repairTitle: 'Repair JSON: fix quotes and escape characters, remove comments and JSONP notation, turn JavaScript objects into JSON.',
                        searchTitle: 'Search fields and values',
                        searchNextResultTitle: 'Next result (Enter)',
                        searchPreviousResultTitle: 'Previous result (Shift + Enter)',
                        selectNode: 'Select a node...',
                        showAll: 'show all',
                        showMore: 'show more',
                        showMoreStatus: 'displaying ${visibleChilds} of ${totalChilds} items.',
                        sort: 'Sort',
                        sortTitle: 'Sort the childs of this ${type}',
                        sortTitleShort: 'Sort contents',
                        sortFieldLabel: 'Field:',
                        sortDirectionLabel: 'Direction:',
                        sortFieldTitle: 'Select the nested field by which to sort the array or object',
                        sortAscending: 'Ascending',
                        sortAscendingTitle: 'Sort the selected field in ascending order',
                        sortDescending: 'Descending',
                        sortDescendingTitle: 'Sort the selected field in descending order',
                        string: 'String',
                        transform: 'Transform',
                        transformTitle: 'Filter, sort, or transform the childs of this ${type}',
                        transformTitleShort: 'Filter, sort, or transform contents',
                        extract: 'Extract',
                        extractTitle: 'Extract this ${type}',
                        transformQueryTitle: 'Enter a JMESPath query',
                        transformWizardLabel: 'Wizard',
                        transformWizardFilter: 'Filter',
                        transformWizardSortBy: 'Sort by',
                        transformWizardSelectFields: 'Select fields',
                        transformQueryLabel: 'Query',
                        transformPreviewLabel: 'Preview',
                        type: 'Type',
                        typeTitle: 'Change the type of this field',
                        openUrl: 'Ctrl+Click or Ctrl+Enter to open url in new window',
                        undo: 'Undo last action (Ctrl+Z)',
                        validationCannotMove: 'Cannot move a field into a child of itself',
                        autoType: 'Field type "auto". The field type is automatically determined from the value and can be a string, number, boolean, or null.',
                        objectType: 'Field type "object". An object contains an unordered set of key/value pairs.',
                        arrayType: 'Field type "array". An array contains an ordered collection of values.',
                        stringType: 'Field type "string". Field type is not determined from the value, but always returned as string.',
                        modeEditorTitle: 'Switch Editor Mode',
                        modeCodeText: 'Code',
                        modeCodeTitle: 'Switch to code highlighter',
                        modeFormText: 'Form',
                        modeFormTitle: 'Switch to form editor',
                        modeTextText: 'Text',
                        modeTextTitle: 'Switch to plain text editor',
                        modeTreeText: 'Tree',
                        modeTreeTitle: 'Switch to tree editor',
                        modeViewText: 'View',
                        modeViewTitle: 'Switch to tree view',
                        modePreviewText: 'Preview',
                        modePreviewTitle: 'Switch to preview mode',
                        examples: 'Examples',
                        "default": 'Default',
                        containsInvalidProperties: 'Contains invalid properties',
                        containsInvalidItems: 'Contains invalid items'
                    },
                    es: {
                        array: 'Matriz',
                        auto: 'Auto',
                        appendText: 'Agregar',
                        appendTitle: "Agregue un nuevo campo con el tipo 'auto' despu\xe9s de este campo (Ctrl + Shift + Ins)",
                        appendSubmenuTitle: "Seleccione el tipo de campo que se agregar\xe1",
                        appendTitleAuto: 'Agregue un nuevo campo con el tipo \'auto\' (Ctrl + Shift + Ins)',
                        ascending: 'Ascendente',
                        ascendingTitle: 'Ordene los elementos secundarios de este ${type} en orden ascendente',
                        actionsMenu: "Haga clic para abrir el men\xfa de acciones (Ctrl + M)",
                        cannotParseFieldError: 'No se puede parsear el campo en JSON',
                        cannotParseValueError: 'No se puede parsear el valor en JSON',
                        collapseAll: 'Contraer todos los campos',
                        compactTitle: 'Compactar datos JSON, eliminar todos los espacios en blanco (Ctrl + Shift + I)',
                        descending: 'Descendente',
                        descendingTitle: 'Ordene los hijos de este ${type} en orden descendente',
                        drag: "Arrastre para mover este campo (Alt + May\xfas + Flechas)",
                        duplicateKey: 'llave duplicada',
                        duplicateText: 'Duplicar',
                        duplicateTitle: 'Duplicar campos seleccionados (Ctrl + D)',
                        duplicateField: 'Duplicar este campo (Ctrl + D)',
                        duplicateFieldError: 'Nombre de campo duplicado',
                        empty: 'vacio',
                        expandAll: 'Expandir todos los campos',
                        expandTitle: "Haga clic para expandir/contraer este campo (Ctrl + E). \n  Ctrl+Clic para expandir/contraer incluyendo todos los ni\xf1os.",
                        formatTitle: "Formatee los datos JSON, con la sangr\xeda y los avances de l\xednea adecuados (Ctrl + I)",
                        insert: 'Insertar',
                        insertTitle: 'Inserte un nuevo campo con el tipo \'auto\' antes de este campo (Ctrl + Ins)',
                        insertSub: 'Seleccione el tipo de campo a insertar',
                        object: 'Objeto',
                        ok: 'Ok',
                        redo: "Rehacer (Ctrl+May\xfas+Z)",
                        removeText: 'Eliminar',
                        removeTitle: 'Eliminar campos seleccionados (Ctrl+Supr)',
                        removeField: 'Eliminar este campo (Ctrl+Supr)',
                        repairTitle: "Reparar JSON: corrija comillas y caracteres de escape, elimine comentarios y notaci\xf3n JSONP, convierta objetos JavaScript en JSON.",
                        searchTitle: "Campos de b\xfasqueda y valores",
                        searchNextResultTitle: 'Siguiente resultado (Entrar)',
                        searchPreviousResultTitle: 'Resultado anterior (Shift + Enter)',
                        selectNode: 'Seleccione un nodo...',
                        showAll: 'mostrar todo',
                        showMore: "mostrar m\xe1s",
                        showMoreStatus: 'mostrando ${visibleChilds} de ${totalChilds} elementos.',
                        sort: 'Ordenar',
                        sortTitle: 'Ordene los hijos de este ${type}',
                        sortTitleShort: 'Ordenar contenidos',
                        sortFieldLabel: 'Campo:',
                        sortDirectionLabel: "Direcci\xf3n:",
                        sortFieldTitle: 'Seleccione el campo anidado por el cual ordenar la matriz u objeto',
                        sortAscending: 'Ascendente',
                        sortAscendingTitle: 'Ordenar el campo seleccionado en orden ascendente',
                        sortDescending: 'Descendente',
                        sortDescendingTitle: 'Ordenar por el campo seleccionado, en orden descendente',
                        string: 'Texto',
                        transform: 'Transformar',
                        transformTitle: 'Filtrar, ordenar o transformar los hijos de este ${type}',
                        transformTitleShort: 'Filtrar, ordenar o transformar contenidos',
                        extract: 'Extraer',
                        extractTitle: 'Extrae este ${type}',
                        transformQueryTitle: 'Ingrese una consulta JMESPath',
                        transformWizardLabel: 'Wizard',
                        transformWizardFilter: 'Filtro',
                        transformWizardSortBy: 'Ordenar por',
                        transformWizardSelectFields: 'Seleccione un campo',
                        transformQueryLabel: 'Consulta',
                        transformPreviewLabel: 'Vista Previa',
                        type: 'Tipo',
                        typeTitle: 'Cambiar el tipo de campo',
                        openUrl: 'Ctrl+Click o Ctrl+Enter para abrir la URL en una nueva ventana',
                        undo: "Deshacer la \xfaltima acci\xf3n (Ctrl+Z)",
                        validationCannotMove: "No se puede mover un campo a un hijo de s\xed mismo.",
                        autoType: 'Tipo de campo "auto". El tipo de campo se determina autom\xe1ticamente a partir del valor y puede ser una cadena, un n\xfamero, un booleano o un valor nulo.',
                        objectType: 'Tipo de campo "objeto".  Un objeto contiene un conjunto desordenado de pares clave/valor.',
                        arrayType: 'Tipo de campo "matriz".  Una matriz contiene una colecci\xf3n ordenada de valores.',
                        stringType: 'Tipo de campo "cadena".  El tipo de campo no se determina a partir del valor,  pero siempre se devuelve como una cadena.',
                        modeEditorTitle: 'Cambiar modo de editor',
                        modeCodeText: "C\xf3digo",
                        modeCodeTitle: "Cambiar al resaltador de c\xf3digo",
                        modeFormText: 'Formulario',
                        modeFormTitle: 'Cambiar al editor de formularios',
                        modeTextText: 'Texto',
                        modeTextTitle: 'Cambiar al editor de texto sin formato',
                        modeTreeText: "\xc1rbol",
                        modeTreeTitle: "Cambiar al editor de \xe1rbol",
                        modeViewText: 'Vista',
                        modeViewTitle: "Cambiar a la vista de \xe1rbol",
                        modePreviewText: 'Vista Previa',
                        modePreviewTitle: 'Cambiar al modo de vista previa',
                        examples: 'Ejemplos',
                        "default": 'Predeterminado',
                        containsInvalidProperties: "Contiene propiedades no v\xe1lidas",
                        containsInvalidItems: "Contiene \xedtems no v\xe1lidos"
                    },
                    'zh-CN': {
                        array: "\u6570\u7EC4",
                        auto: "\u81EA\u52A8",
                        appendText: "\u8FFD\u52A0",
                        appendTitle: "\u5728\u6B64\u5B57\u6BB5\u540E\u8FFD\u52A0\u4E00\u4E2A\u7C7B\u578B\u4E3A\u201Cauto\u201D\u7684\u65B0\u5B57\u6BB5 (Ctrl+Shift+Ins)",
                        appendSubmenuTitle: "\u9009\u62E9\u8981\u8FFD\u52A0\u7684\u5B57\u6BB5\u7C7B\u578B",
                        appendTitleAuto: "\u8FFD\u52A0\u7C7B\u578B\u4E3A\u201Cauto\u201D\u7684\u65B0\u5B57\u6BB5 (Ctrl+Shift+Ins)",
                        ascending: "\u5347\u5E8F",
                        ascendingTitle: "\u5347\u5E8F\u6392\u5217${type}\u7684\u5B50\u8282\u70B9",
                        actionsMenu: "\u70B9\u51FB\u6253\u5F00\u52A8\u4F5C\u83DC\u5355(Ctrl+M)",
                        cannotParseFieldError: "\u65E0\u6CD5\u5C06\u5B57\u6BB5\u89E3\u6790\u4E3AJSON",
                        cannotParseValueError: "\u65E0\u6CD5\u5C06\u503C\u89E3\u6790\u4E3AJSON",
                        collapseAll: "\u7F29\u8FDB\u6240\u6709\u5B57\u6BB5",
                        compactTitle: "\u538B\u7F29JSON\u6570\u636E\uFF0C\u5220\u9664\u6240\u6709\u7A7A\u683C (Ctrl+Shift+I)",
                        descending: "\u964D\u5E8F",
                        descendingTitle: "\u964D\u5E8F\u6392\u5217${type}\u7684\u5B50\u8282\u70B9",
                        drag: "\u62D6\u62FD\u79FB\u52A8\u8BE5\u8282\u70B9(Alt+Shift+Arrows)",
                        duplicateKey: "\u91CD\u590D\u952E",
                        duplicateText: "\u590D\u5236",
                        duplicateTitle: "\u590D\u5236\u9009\u4E2D\u5B57\u6BB5(Ctrl+D)",
                        duplicateField: "\u590D\u5236\u8BE5\u5B57\u6BB5(Ctrl+D)",
                        duplicateFieldError: "\u91CD\u590D\u7684\u5B57\u6BB5\u540D\u79F0",
                        empty: "\u6E05\u7A7A",
                        expandAll: "\u5C55\u5F00\u6240\u6709\u5B57\u6BB5",
                        expandTitle: "\u70B9\u51FB \u5C55\u5F00/\u6536\u7F29 \u8BE5\u5B57\u6BB5(Ctrl+E). \nCtrl+Click \u5C55\u5F00/\u6536\u7F29 \u5305\u542B\u6240\u6709\u5B50\u8282\u70B9.",
                        formatTitle: "\u4F7F\u7528\u9002\u5F53\u7684\u7F29\u8FDB\u548C\u6362\u884C\u7B26\u683C\u5F0F\u5316JSON\u6570\u636E (Ctrl+I)",
                        insert: "\u63D2\u5165",
                        insertTitle: "\u5728\u6B64\u5B57\u6BB5\u524D\u63D2\u5165\u7C7B\u578B\u4E3A\u201Cauto\u201D\u7684\u65B0\u5B57\u6BB5 (Ctrl+Ins)",
                        insertSub: "\u9009\u62E9\u8981\u63D2\u5165\u7684\u5B57\u6BB5\u7C7B\u578B",
                        object: "\u5BF9\u8C61",
                        ok: 'Ok',
                        redo: "\u91CD\u505A (Ctrl+Shift+Z)",
                        removeText: "\u79FB\u9664",
                        removeTitle: "\u79FB\u9664\u9009\u4E2D\u5B57\u6BB5 (Ctrl+Del)",
                        removeField: "\u79FB\u9664\u8BE5\u5B57\u6BB5 (Ctrl+Del)",
                        repairTitle: "\u4FEE\u590DJSON\uFF1A\u4FEE\u590D\u5F15\u53F7\u548C\u8F6C\u4E49\u7B26\uFF0C\u5220\u9664\u6CE8\u91CA\u548CJSONP\u8868\u793A\u6CD5\uFF0C\u5C06JavaScript\u5BF9\u8C61\u8F6C\u6362\u4E3AJSON\u3002",
                        selectNode: "\u9009\u62E9\u4E00\u4E2A\u8282\u70B9...",
                        showAll: "\u5C55\u793A\u5168\u90E8",
                        showMore: "\u5C55\u793A\u66F4\u591A",
                        showMoreStatus: "\u663E\u793A${totalChilds}\u7684${visibleChilds}\u9879\u76EE.",
                        sort: "\u6392\u5E8F",
                        sortTitle: "\u6392\u5E8F${type}\u7684\u5B50\u8282\u70B9",
                        sortTitleShort: "\u5185\u5BB9\u6392\u5E8F",
                        sortFieldLabel: "\u5B57\u6BB5\uFF1A",
                        sortDirectionLabel: "\u65B9\u5411\uFF1A",
                        sortFieldTitle: "\u9009\u62E9\u7528\u4E8E\u5BF9\u6570\u7EC4\u6216\u5BF9\u8C61\u6392\u5E8F\u7684\u5D4C\u5957\u5B57\u6BB5",
                        sortAscending: "\u5347\u5E8F\u6392\u5E8F",
                        sortAscendingTitle: "\u6309\u7167\u8BE5\u5B57\u6BB5\u5347\u5E8F\u6392\u5E8F",
                        sortDescending: "\u964D\u5E8F\u6392\u5E8F",
                        sortDescendingTitle: "\u6309\u7167\u8BE5\u5B57\u6BB5\u964D\u5E8F\u6392\u5E8F",
                        string: "\u5B57\u7B26\u4E32",
                        transform: "\u53D8\u6362",
                        transformTitle: "\u7B5B\u9009\uFF0C\u6392\u5E8F\uFF0C\u6216\u8005\u8F6C\u6362${type}\u7684\u5B50\u8282\u70B9",
                        transformTitleShort: "\u7B5B\u9009\uFF0C\u6392\u5E8F\uFF0C\u6216\u8005\u8F6C\u6362\u5185\u5BB9",
                        extract: "\u63D0\u53D6",
                        extractTitle: "\u63D0\u53D6\u8FD9\u4E2A ${type}",
                        transformQueryTitle: "\u8F93\u5165JMESPath\u67E5\u8BE2",
                        transformWizardLabel: "\u5411\u5BFC",
                        transformWizardFilter: "\u7B5B\u9009",
                        transformWizardSortBy: "\u6392\u5E8F",
                        transformWizardSelectFields: "\u9009\u62E9\u5B57\u6BB5",
                        transformQueryLabel: "\u67E5\u8BE2",
                        transformPreviewLabel: "\u9884\u89C8",
                        type: "\u7C7B\u578B",
                        typeTitle: "\u66F4\u6539\u5B57\u6BB5\u7C7B\u578B",
                        openUrl: "Ctrl+Click \u6216\u8005 Ctrl+Enter \u5728\u65B0\u7A97\u53E3\u6253\u5F00\u94FE\u63A5",
                        undo: "\u64A4\u9500\u4E0A\u6B21\u52A8\u4F5C (Ctrl+Z)",
                        validationCannotMove: "\u65E0\u6CD5\u5C06\u5B57\u6BB5\u79FB\u5165\u5176\u5B50\u8282\u70B9",
                        autoType: '\u5B57\u6BB5\u7C7B\u578B "auto". \u5B57\u6BB5\u7C7B\u578B\u7531\u503C\u81EA\u52A8\u786E\u5B9A \u53EF\u4EE5\u4E3A string\uFF0Cnumber\uFF0Cboolean\uFF0C\u6216\u8005 null.',
                        objectType: '\u5B57\u6BB5\u7C7B\u578B "object". \u5BF9\u8C61\u5305\u542B\u4E00\u7EC4\u65E0\u5E8F\u7684\u952E/\u503C\u5BF9.',
                        arrayType: '\u5B57\u6BB5\u7C7B\u578B "array". \u6570\u7EC4\u5305\u542B\u503C\u7684\u6709\u5E8F\u96C6\u5408.',
                        stringType: '\u5B57\u6BB5\u7C7B\u578B "string". \u5B57\u6BB5\u7C7B\u578B\u7531\u503C\u81EA\u52A8\u786E\u5B9A\uFF0C\u4F46\u59CB\u7EC8\u4F5C\u4E3A\u5B57\u7B26\u4E32\u8FD4\u56DE.',
                        modeCodeText: "\u4EE3\u7801",
                        modeCodeTitle: "\u5207\u6362\u81F3\u4EE3\u7801\u9AD8\u4EAE",
                        modeFormText: "\u8868\u5355",
                        modeFormTitle: "\u5207\u6362\u81F3\u8868\u5355\u7F16\u8F91",
                        modeTextText: "\u6587\u672C",
                        modeTextTitle: "\u5207\u6362\u81F3\u6587\u672C\u7F16\u8F91",
                        modeTreeText: "\u6811",
                        modeTreeTitle: "\u5207\u6362\u81F3\u6811\u7F16\u8F91",
                        modeViewText: "\u89C6\u56FE",
                        modeViewTitle: "\u5207\u6362\u81F3\u6811\u89C6\u56FE",
                        modePreviewText: "\u9884\u89C8",
                        modePreviewTitle: "\u5207\u6362\u81F3\u9884\u89C8\u6A21\u5F0F",
                        examples: "\u4F8B\u5B50",
                        "default": "\u7F3A\u7701",
                        containsInvalidProperties: "\u5305\u542B\u65E0\u6548\u7684\u5C5E\u6027",
                        containsInvalidItems: "\u5305\u542B\u65E0\u6548\u9879\u76EE"
                    },
                    'pt-BR': {
                        array: 'Lista',
                        auto: 'Automatico',
                        appendText: 'Adicionar',
                        appendTitle: 'Adicionar novo campo com tipo \'auto\' depois deste campo (Ctrl+Shift+Ins)',
                        appendSubmenuTitle: 'Selecione o tipo do campo a ser adicionado',
                        appendTitleAuto: 'Adicionar novo campo com tipo \'auto\' (Ctrl+Shift+Ins)',
                        ascending: 'Ascendente',
                        ascendingTitle: 'Organizar filhor do tipo ${type} em crescente',
                        actionsMenu: "Clique para abrir o menu de a\xe7\xf5es (Ctrl+M)",
                        cannotParseFieldError: "N\xe3o \xe9 poss\xedvel analisar o campo no JSON",
                        cannotParseValueError: "N\xe3o \xe9 poss\xedvel analisar o valor em JSON",
                        collapseAll: 'Fechar todos campos',
                        compactTitle: "Dados JSON compactos, remova todos os espa\xe7os em branco (Ctrl+Shift+I)",
                        descending: 'Descendente',
                        descendingTitle: 'Organizar o filhos do tipo ${type} em decrescente',
                        duplicateKey: 'chave duplicada',
                        drag: 'Arraste para mover este campo (Alt+Shift+Arrows)',
                        duplicateText: 'Duplicar',
                        duplicateTitle: 'Duplicar campos selecionados (Ctrl+D)',
                        duplicateField: 'Duplicar este campo (Ctrl+D)',
                        duplicateFieldError: 'Nome do campo duplicado',
                        empty: 'vazio',
                        expandAll: 'Expandir todos campos',
                        expandTitle: "Clique para expandir/encolher este campo (Ctrl+E). \nCtrl+Click para expandir/encolher incluindo todos os filhos.",
                        formatTitle: 'Formate dados JSON, com recuo e feeds de linha adequados (Ctrl+I)',
                        insert: 'Inserir',
                        insertTitle: 'Inserir um novo campo do tipo \'auto\' antes deste campo (Ctrl+Ins)',
                        insertSub: 'Selecionar o tipo de campo a ser inserido',
                        object: 'Objeto',
                        ok: 'Ok',
                        redo: 'Refazer (Ctrl+Shift+Z)',
                        removeText: 'Remover',
                        removeTitle: 'Remover campos selecionados (Ctrl+Del)',
                        removeField: 'Remover este campo (Ctrl+Del)',
                        repairTitle: "Repare JSON: corrija aspas e caracteres de escape, remova coment\xe1rios e nota\xe7\xe3o JSONP, transforme objetos JavaScript em JSON.",
                        selectNode: "Selecione um n\xf3dulo...",
                        showAll: 'mostrar todos',
                        showMore: 'mostrar mais',
                        showMoreStatus: 'exibindo ${visibleChilds} de ${totalChilds} itens.',
                        sort: 'Organizar',
                        sortTitle: 'Organizar os filhos deste ${type}',
                        sortTitleShort: 'Organizar os filhos',
                        sortFieldLabel: 'Campo:',
                        sortDirectionLabel: "Dire\xe7\xe3o:",
                        sortFieldTitle: 'Selecione um campo filho pelo qual ordenar o array ou objeto',
                        sortAscending: 'Ascendente',
                        sortAscendingTitle: 'Ordenar o campo selecionado por ordem ascendente',
                        sortDescending: 'Descendente',
                        sortDescendingTitle: 'Ordenar o campo selecionado por ordem descendente',
                        string: 'Texto',
                        transform: 'Transformar',
                        transformTitle: 'Filtrar, ordenar ou transformar os filhos deste ${type}',
                        transformTitleShort: "Filtrar, ordenar ou transformar conte\xfados",
                        transformQueryTitle: "Insira uma express\xe3o JMESPath",
                        transformWizardLabel: 'Assistente',
                        transformWizardFilter: 'Filtro',
                        transformWizardSortBy: 'Ordenar por',
                        transformWizardSelectFields: 'Selecionar campos',
                        transformQueryLabel: "Express\xe3o",
                        transformPreviewLabel: 'Visualizar',
                        type: 'Tipo',
                        typeTitle: 'Mudar o tipo deste campo',
                        openUrl: 'Ctrl+Click ou Ctrl+Enter para abrir link em nova janela',
                        undo: "Desfazer \xfaltimo a\xe7\xe3o (Ctrl+Z)",
                        validationCannotMove: "N\xe3o pode mover um campo como filho dele mesmo",
                        autoType: 'Campo do tipo "auto". O tipo do campo \xe9 determinao automaticamente a partir do seu valor e pode ser texto, n\xfamero, verdade/falso ou nulo.',
                        objectType: 'Campo do tipo "objeto". Um objeto cont\xe9m uma lista de pares com chave e valor.',
                        arrayType: 'Campo do tipo "lista". Uma lista contem uma cole\xe7\xe3o de valores ordenados.',
                        stringType: 'Campo do tipo "string". Campo do tipo nao \xe9 determinado atrav\xe9s do seu valor, mas sempre retornara um texto.',
                        examples: 'Exemplos',
                        "default": 'Revelia',
                        containsInvalidProperties: "Cont\xe9m propriedades inv\xe1lidas",
                        containsInvalidItems: "Cont\xe9m itens inv\xe1lidos"
                    },
                    tr: {
                        array: 'Dizin',
                        auto: 'Otomatik',
                        appendText: 'Ekle',
                        appendTitle: "Bu alan\u0131n alt\u0131na 'otomatik' tipinde yeni bir alan ekle (Ctrl+Shift+Ins)",
                        appendSubmenuTitle: "Eklenecek alan\u0131n tipini se\xe7",
                        appendTitleAuto: '\'Otomatik\' tipinde yeni bir alan ekle (Ctrl+Shift+Ins)',
                        ascending: 'Artan',
                        ascendingTitle: "${type}'\u0131n alt tiplerini artan d\xfczende s\u0131rala",
                        actionsMenu: "Aksiyon men\xfcs\xfcn\xfc a\xe7mak i\xe7in t\u0131klay\u0131n (Ctrl+M)",
                        collapseAll: "T\xfcm alanlar\u0131 kapat",
                        descending: 'Azalan',
                        descendingTitle: "${type}'\u0131n alt tiplerini azalan d\xfczende s\u0131rala",
                        drag: "Bu alan\u0131 ta\u015F\u0131mak i\xe7in s\xfcr\xfckleyin (Alt+Shift+Arrows)",
                        duplicateKey: 'Var olan anahtar',
                        duplicateText: "A\u015Fa\u011F\u0131ya kopyala",
                        duplicateTitle: "Se\xe7ili alanlardan bir daha olu\u015Ftur (Ctrl+D)",
                        duplicateField: "Bu alandan bir daha olu\u015Ftur (Ctrl+D)",
                        duplicateFieldError: 'Duplicate field name',
                        cannotParseFieldError: "Alan JSON'a ayr\u0131\u015Ft\u0131r\u0131lam\u0131yor",
                        cannotParseValueError: "JSON'a de\u011Fer ayr\u0131\u015Ft\u0131r\u0131lam\u0131yor",
                        empty: "bo\u015F",
                        expandAll: "T\xfcm alanlar\u0131 a\xe7",
                        expandTitle: "Bu alan\u0131 a\xe7mak/kapatmak i\xe7in t\u0131kla (Ctrl+E). \nAlt alanlarda dahil t\xfcm alanlar\u0131 a\xe7mak i\xe7in Ctrl+Click ",
                        insert: 'Ekle',
                        insertTitle: "Bu alan\u0131n \xfcst\xfcne 'otomatik' tipinde yeni bir alan ekle (Ctrl+Ins)",
                        insertSub: "Araya eklenecek alan\u0131n tipini se\xe7",
                        object: 'Nesne',
                        ok: 'Tamam',
                        redo: 'Yeniden yap (Ctrl+Shift+Z)',
                        removeText: "Kald\u0131r",
                        removeTitle: "Se\xe7ilen alanlar\u0131 kald\u0131r (Ctrl+Del)",
                        removeField: "Bu alan\u0131 kald\u0131r (Ctrl+Del)",
                        selectNode: "Bir nesne se\xe7...",
                        showAll: "t\xfcm\xfcn\xfc g\xf6ster",
                        showMore: "daha fazla g\xf6ster",
                        showMoreStatus: "${totalChilds} alan\u0131n ${visibleChilds} alt alanlar\u0131 g\xf6steriliyor",
                        sort: "S\u0131rala",
                        sortTitle: "${type}'\u0131n alt alanlar\u0131n\u0131 s\u0131rala",
                        sortTitleShort: "\u0130\xe7erikleri s\u0131rala",
                        sortFieldLabel: 'Alan:',
                        sortDirectionLabel: "Y\xf6n:",
                        sortFieldTitle: "Diziyi veya nesneyi s\u0131ralamak i\xe7in i\xe7 i\xe7e ge\xe7mi\u015F alan\u0131 se\xe7in",
                        sortAscending: 'Artan',
                        sortAscendingTitle: "Se\xe7ili alan\u0131 artan d\xfczende s\u0131rala",
                        sortDescending: 'Azalan',
                        sortDescendingTitle: "Se\xe7ili alan\u0131 azalan d\xfczende s\u0131rala",
                        string: 'Karakter Dizisi',
                        transform: "D\xf6n\xfc\u015Ft\xfcr",
                        transformTitle: "${type}'\u0131n alt alanlar\u0131n\u0131 filtrele, s\u0131rala veya d\xf6n\xfc\u015Ft\xfcr",
                        transformTitleShort: "\u0130\xe7erikleri filterele, s\u0131rala veya d\xf6n\xfc\u015Ft\xfcr",
                        transformQueryTitle: 'JMESPath sorgusu gir',
                        transformWizardLabel: 'Sihirbaz',
                        transformWizardFilter: 'Filtre',
                        transformWizardSortBy: "S\u0131rala",
                        transformWizardSelectFields: "Alanlar\u0131 se\xe7",
                        transformQueryLabel: 'Sorgu',
                        transformPreviewLabel: "\xd6nizleme",
                        type: 'Tip',
                        typeTitle: "Bu alan\u0131n tipini de\u011Fi\u015Ftir",
                        openUrl: "URL'i yeni bir pencerede a\xe7mak i\xe7in Ctrl+Click veya Ctrl+Enter",
                        undo: "Son de\u011Fi\u015Fikli\u011Fi geri al (Ctrl+Z)",
                        validationCannotMove: "Alt alan olarak ta\u015F\u0131nam\u0131yor",
                        autoType: 'Alan tipi "otomatik". Alan t\xfcr\xfc otomatik olarak de\u011Ferden belirlenirve bir dize, say\u0131, boolean veya null olabilir.',
                        objectType: 'Alan tipi "nesne". Bir nesne, s\u0131ralanmam\u0131\u015F bir anahtar / de\u011Fer \xe7ifti k\xfcmesi i\xe7erir.',
                        arrayType: 'Alan tipi "dizi". Bir dizi, d\xfczenli de\u011Ferler koleksiyonu i\xe7erir.',
                        stringType: 'Alan tipi "karakter dizisi". Alan t\xfcr\xfc de\u011Ferden belirlenmez,ancak her zaman karakter dizisi olarak d\xf6nd\xfcr\xfcl\xfcr.',
                        modeCodeText: 'Kod',
                        modeCodeTitle: "Kod vurgulay\u0131c\u0131ya ge\xe7",
                        modeFormText: 'Form',
                        modeFormTitle: "Form d\xfczenleyiciye ge\xe7",
                        modeTextText: 'Metin',
                        modeTextTitle: "D\xfcz metin d\xfczenleyiciye ge\xe7",
                        modeTreeText: "A\u011Fa\xe7",
                        modeTreeTitle: "A\u011Fa\xe7 d\xfczenleyiciye ge\xe7",
                        modeViewText: "G\xf6r\xfcn\xfcm",
                        modeViewTitle: "A\u011Fa\xe7 g\xf6r\xfcn\xfcm\xfcne ge\xe7",
                        examples: "\xd6rnekler",
                        "default": "Varsay\u0131lan",
                        containsInvalidProperties: "Ge\xe7ersiz \xf6zellikler i\xe7eriyor",
                        containsInvalidItems: "Ge\xe7ersiz \xf6\u011Feler i\xe7eriyor"
                    },
                    ja: {
                        array: "\u914D\u5217",
                        auto: "\u30AA\u30FC\u30C8",
                        appendText: "\u8FFD\u52A0",
                        appendTitle: '\u6B21\u306E\u30D5\u30A3\u30FC\u30EB\u30C9\u306B"\u30AA\u30FC\u30C8"\u306E\u30D5\u30A3\u30FC\u30EB\u30C9\u3092\u8FFD\u52A0 (Ctrl+Shift+Ins)',
                        appendSubmenuTitle: "\u8FFD\u52A0\u3059\u308B\u30D5\u30A3\u30FC\u30EB\u30C9\u306E\u578B\u3092\u9078\u629E\u3057\u3066\u304F\u3060\u3055\u3044",
                        appendTitleAuto: '"\u30AA\u30FC\u30C8"\u306E\u30D5\u30A3\u30FC\u30EB\u30C9\u3092\u8FFD\u52A0 (Ctrl+Shift+Ins)',
                        ascending: "\u6607\u9806",
                        ascendingTitle: "${type}\u306E\u5B50\u8981\u7D20\u3092\u6607\u9806\u306B\u4E26\u3079\u66FF\u3048",
                        actionsMenu: "\u30AF\u30EA\u30C3\u30AF\u3057\u3066\u30A2\u30AF\u30B7\u30E7\u30F3\u30E1\u30CB\u30E5\u30FC\u3092\u958B\u304F (Ctrl+M)",
                        collapseAll: "\u3059\u3079\u3066\u3092\u6298\u308A\u305F\u305F\u3080",
                        descending: "\u964D\u9806",
                        descendingTitle: "${type}\u306E\u5B50\u8981\u7D20\u3092\u964D\u9806\u306B\u4E26\u3079\u66FF\u3048",
                        drag: "\u30C9\u30E9\u30C3\u30B0\u3057\u3066\u9078\u629E\u4E2D\u306E\u30D5\u30A3\u30FC\u30EB\u30C9\u3092\u79FB\u52D5 (Alt+Shift+Arrows)",
                        duplicateKey: "\u8907\u88FD\u30AD\u30FC",
                        duplicateText: "\u8907\u88FD",
                        duplicateTitle: "\u9078\u629E\u4E2D\u306E\u30D5\u30A3\u30FC\u30EB\u30C9\u3092\u8907\u88FD (Ctrl+D)",
                        duplicateField: "\u9078\u629E\u4E2D\u306E\u30D5\u30A3\u30FC\u30EB\u30C9\u3092\u8907\u88FD (Ctrl+D)",
                        duplicateFieldError: "\u30D5\u30A3\u30FC\u30EB\u30C9\u540D\u304C\u91CD\u8907\u3057\u3066\u3044\u307E\u3059",
                        cannotParseFieldError: "JSON\u306E\u30D5\u30A3\u30FC\u30EB\u30C9\u3092\u89E3\u6790\u3067\u304D\u307E\u305B\u3093",
                        cannotParseValueError: "JSON\u306E\u5024\u3092\u89E3\u6790\u3067\u304D\u307E\u305B\u3093",
                        empty: "\u7A7A",
                        expandAll: "\u3059\u3079\u3066\u3092\u5C55\u958B",
                        expandTitle: "\u30AF\u30EA\u30C3\u30AF\u3057\u3066\u30D5\u30A3\u30FC\u30EB\u30C9\u3092\u5C55\u958B/\u6298\u308A\u305F\u305F\u3080 (Ctrl+E). \nCtrl+Click \u3067\u3059\u3079\u3066\u306E\u5B50\u8981\u7D20\u3092\u5C55\u958B/\u6298\u308A\u305F\u305F\u3080",
                        insert: "\u633F\u5165",
                        insertTitle: "\u9078\u629E\u4E2D\u306E\u30D5\u30A3\u30FC\u30EB\u30C9\u306E\u524D\u306B\u65B0\u3057\u3044\u30D5\u30A3\u30FC\u30EB\u30C9\u3092\u633F\u5165 (Ctrl+Ins)",
                        insertSub: "\u633F\u5165\u3059\u308B\u30D5\u30A3\u30FC\u30EB\u30C9\u306E\u578B\u3092\u9078\u629E",
                        object: "\u30AA\u30D6\u30B8\u30A7\u30AF\u30C8",
                        ok: "\u5B9F\u884C",
                        redo: "\u3084\u308A\u76F4\u3059 (Ctrl+Shift+Z)",
                        removeText: "\u524A\u9664",
                        removeTitle: "\u9078\u629E\u4E2D\u306E\u30D5\u30A3\u30FC\u30EB\u30C9\u3092\u524A\u9664 (Ctrl+Del)",
                        removeField: "\u9078\u629E\u4E2D\u306E\u30D5\u30A3\u30FC\u30EB\u30C9\u3092\u524A\u9664 (Ctrl+Del)",
                        selectNode: "\u30CE\u30FC\u30C9\u3092\u9078\u629E...",
                        showAll: "\u3059\u3079\u3066\u3092\u8868\u793A",
                        showMore: "\u3082\u3063\u3068\u898B\u308B",
                        showMoreStatus: "${totalChilds}\u500B\u306E\u30A2\u30A4\u30C6\u30E0\u306E\u3046\u3061 ${visibleChilds}\u500B\u3092\u8868\u793A\u3057\u3066\u3044\u307E\u3059\u3002",
                        sort: "\u4E26\u3079\u66FF\u3048",
                        sortTitle: "${type}\u306E\u5B50\u8981\u7D20\u3092\u4E26\u3079\u66FF\u3048",
                        sortTitleShort: "\u4E26\u3079\u66FF\u3048",
                        sortFieldLabel: "\u30D5\u30A3\u30FC\u30EB\u30C9:",
                        sortDirectionLabel: "\u9806\u5E8F:",
                        sortFieldTitle: "\u914D\u5217\u307E\u305F\u306F\u30AA\u30D6\u30B8\u30A7\u30AF\u30C8\u3092\u4E26\u3073\u66FF\u3048\u308B\u305F\u3081\u306E\u30D5\u30A3\u30FC\u30EB\u30C9\u3092\u9078\u629E",
                        sortAscending: "\u6607\u9806",
                        sortAscendingTitle: "\u9078\u629E\u4E2D\u306E\u30D5\u30A3\u30FC\u30EB\u30C9\u3092\u6607\u9806\u306B\u4E26\u3073\u66FF\u3048",
                        sortDescending: "\u964D\u9806",
                        sortDescendingTitle: "\u9078\u629E\u4E2D\u306E\u30D5\u30A3\u30FC\u30EB\u30C9\u3092\u964D\u9806\u306B\u4E26\u3073\u66FF\u3048",
                        string: "\u6587\u5B57\u5217",
                        transform: "\u5909\u63DB",
                        transformTitle: "${type}\u306E\u5B50\u8981\u7D20\u3092\u30D5\u30A3\u30EB\u30BF\u30FC\u30FB\u4E26\u3073\u66FF\u3048\u30FB\u5909\u63DB\u3059\u308B",
                        transformTitleShort: "\u5185\u5BB9\u3092\u30D5\u30A3\u30EB\u30BF\u30FC\u30FB\u4E26\u3073\u66FF\u3048\u30FB\u5909\u63DB\u3059\u308B",
                        extract: "\u62BD\u51FA",
                        extractTitle: "${type}\u3092\u62BD\u51FA",
                        transformQueryTitle: "JMESPath\u30AF\u30A8\u30EA\u3092\u5165\u529B",
                        transformWizardLabel: "\u30A6\u30A3\u30B6\u30FC\u30C9",
                        transformWizardFilter: "\u30D5\u30A3\u30EB\u30BF\u30FC",
                        transformWizardSortBy: "\u4E26\u3073\u66FF\u3048",
                        transformWizardSelectFields: "\u30D5\u30A3\u30FC\u30EB\u30C9\u3092\u9078\u629E",
                        transformQueryLabel: "\u30AF\u30A8\u30EA",
                        transformPreviewLabel: "\u30D7\u30EC\u30D3\u30E5\u30FC",
                        type: "\u578B",
                        typeTitle: "\u9078\u629E\u4E2D\u306E\u30D5\u30A3\u30FC\u30EB\u30C9\u306E\u578B\u3092\u5909\u66F4",
                        openUrl: "Ctrl+Click \u307E\u305F\u306F Ctrl+Enter \u3067 \u65B0\u898F\u30A6\u30A3\u30F3\u30C9\u30A6\u3067URL\u3092\u958B\u304F",
                        undo: "\u5143\u306B\u623B\u3059 (Ctrl+Z)",
                        validationCannotMove: "\u5B50\u8981\u7D20\u306B\u79FB\u52D5\u3067\u304D\u307E\u305B\u3093 ",
                        autoType: "\u30AA\u30FC\u30C8\uFF1A \u30D5\u30A3\u30FC\u30EB\u30C9\u306E\u578B\u306F\u5024\u304B\u3089\u81EA\u52D5\u7684\u306B\u6C7A\u5B9A\u3055\u308C\u307E\u3059\u3002 (\u6587\u5B57\u5217\u30FB\u6570\u5024\u30FB\u30D6\u30FC\u30EB\u30FBnull)",
                        objectType: "\u30AA\u30D6\u30B8\u30A7\u30AF\u30C8\uFF1A \u30AA\u30D6\u30B8\u30A7\u30AF\u30C8\u306F\u9806\u5E8F\u304C\u6C7A\u307E\u3063\u3066\u3044\u306A\u3044\u30AD\u30FC\u3068\u5024\u306E\u30DA\u30A2\u7D44\u307F\u5408\u308F\u305B\u3067\u3059\u3002",
                        arrayType: "\u914D\u5217\uFF1A \u914D\u5217\u306F\u9806\u5E8F\u304C\u6C7A\u307E\u3063\u3066\u3044\u308B\u5024\u306E\u96C6\u5408\u4F53\u3067\u3059\u3002",
                        stringType: "\u6587\u5B57\u5217\uFF1A \u30D5\u30A3\u30FC\u30EB\u30C9\u578B\u306F\u5024\u304B\u3089\u6C7A\u5B9A\u3055\u308C\u307E\u305B\u3093\u304C\u3001\u5E38\u306B\u6587\u5B57\u5217\u3068\u3057\u3066\u8FD4\u3055\u308C\u307E\u3059\u3002",
                        modeCodeText: "\u30B3\u30FC\u30C9\u30E2\u30FC\u30C9",
                        modeCodeTitle: "\u30CF\u30A4\u30E9\u30A4\u30C8\u30E2\u30FC\u30C9\u306B\u5207\u308A\u66FF\u3048",
                        modeFormText: "\u30D5\u30A9\u30FC\u30E0\u30E2\u30FC\u30C9",
                        modeFormTitle: "\u30D5\u30A9\u30FC\u30E0\u30E2\u30FC\u30C9\u306B\u5207\u308A\u66FF\u3048",
                        modeTextText: "\u30C6\u30AD\u30B9\u30C8\u30E2\u30FC\u30C9",
                        modeTextTitle: "\u30C6\u30AD\u30B9\u30C8\u30E2\u30FC\u30C9\u306B\u5207\u308A\u66FF\u3048",
                        modeTreeText: "\u30C4\u30EA\u30FC\u30E2\u30FC\u30C9",
                        modeTreeTitle: "\u30C4\u30EA\u30FC\u30E2\u30FC\u30C9\u306B\u5207\u308A\u66FF\u3048",
                        modeViewText: "\u30D3\u30E5\u30FC\u30E2\u30FC\u30C9",
                        modeViewTitle: "\u30D3\u30E5\u30FC\u30E2\u30FC\u30C9\u306B\u5207\u308A\u66FF\u3048",
                        modePreviewText: "\u30D7\u30EC\u30D3\u30E5\u30FC",
                        modePreviewTitle: "\u30D7\u30EC\u30D3\u30E5\u30FC\u306B\u5207\u308A\u66FF\u3048",
                        examples: "\u4F8B",
                        "default": "\u30C7\u30D5\u30A9\u30EB\u30C8",
                        containsInvalidProperties: "\u7121\u52B9\u306A\u30D7\u30ED\u30D1\u30C6\u30A3\u304C\u542B\u307E\u308C\u3066\u3044\u307E\u3059",
                        containsInvalidItems: "\u7121\u52B9\u306A\u30A2\u30A4\u30C6\u30E0\u304C\u542B\u307E\u308C\u3066\u3044\u307E\u3059"
                    },
                    'fr-FR': {
                        array: 'Liste',
                        auto: 'Auto',
                        appendText: 'Ajouter',
                        appendTitle: "Ajouter un champ de type 'auto' apr\xe8s ce champ (Ctrl+Shift+Ins)",
                        appendSubmenuTitle: "S\xe9lectionner le type du champ \xe0 ajouter",
                        appendTitleAuto: 'Ajouter un champ de type \'auto\' (Ctrl+Shift+Ins)',
                        ascending: 'Ascendant',
                        ascendingTitle: 'Trier les enfants de ce ${type} par ordre ascendant',
                        actionsMenu: 'Ouvrir le menu des actions (Ctrl+M)',
                        collapseAll: 'Regrouper',
                        descending: 'Descendant',
                        descendingTitle: 'Trier les enfants de ce ${type} par ordre descendant',
                        drag: "D\xe9placer (Alt+Shift+Arrows)",
                        duplicateKey: "Dupliquer la cl\xe9",
                        duplicateText: 'Dupliquer',
                        duplicateTitle: "Dupliquer les champs s\xe9lectionn\xe9s (Ctrl+D)",
                        duplicateField: 'Dupliquer ce champ (Ctrl+D)',
                        duplicateFieldError: 'Dupliquer le nom de champ',
                        cannotParseFieldError: "Champ impossible \xe0 parser en JSON",
                        cannotParseValueError: "Valeur impossible \xe0 parser en JSON",
                        empty: 'vide',
                        expandAll: "\xc9tendre",
                        expandTitle: "\xc9tendre/regrouper ce champ (Ctrl+E). \nCtrl+Click pour \xe9tendre/regrouper avec tous les champs.",
                        insert: "Ins\xe9rer",
                        insertTitle: "Ins\xe9rer un champ de type 'auto' avant ce champ (Ctrl+Ins)",
                        insertSub: "S\xe9lectionner le type de champ \xe0 ins\xe9rer",
                        object: 'Objet',
                        ok: 'Ok',
                        redo: 'Rejouer (Ctrl+Shift+Z)',
                        removeText: 'Supprimer',
                        removeTitle: "Supprimer les champs s\xe9lectionn\xe9s (Ctrl+Del)",
                        removeField: 'Supprimer ce champ (Ctrl+Del)',
                        searchTitle: 'Rechercher champs et valeurs',
                        searchNextResultTitle: "R\xe9sultat suivant (Enter)",
                        searchPreviousResultTitle: "R\xe9sultat pr\xe9c\xe9dent (Shift + Enter)",
                        selectNode: "S\xe9lectionner un n\u0153ud...",
                        showAll: 'voir tout',
                        showMore: 'voir plus',
                        showMoreStatus: "${visibleChilds} \xe9l\xe9ments affich\xe9s de ${totalChilds}.",
                        sort: 'Trier',
                        sortTitle: 'Trier les champs de ce ${type}',
                        sortTitleShort: 'Trier',
                        sortFieldLabel: 'Champ:',
                        sortDirectionLabel: 'Direction:',
                        sortFieldTitle: "S\xe9lectionner les champs permettant de trier les listes et objet",
                        sortAscending: 'Ascendant',
                        sortAscendingTitle: "Trier les champs s\xe9lectionn\xe9s par ordre ascendant",
                        sortDescending: 'Descendant',
                        sortDescendingTitle: "Trier les champs s\xe9lectionn\xe9s par ordre descendant",
                        string: "Cha\xeene",
                        transform: 'Transformer',
                        transformTitle: 'Filtrer, trier, or transformer les enfants de ce ${type}',
                        transformTitleShort: 'Filtrer, trier ou transformer le contenu',
                        extract: 'Extraire',
                        extractTitle: 'Extraire ce ${type}',
                        transformQueryTitle: "Saisir une requ\xeate JMESPath",
                        transformWizardLabel: 'Assistant',
                        transformWizardFilter: 'Filtrer',
                        transformWizardSortBy: 'Trier par',
                        transformWizardSelectFields: "S\xe9lectionner les champs",
                        transformQueryLabel: "Requ\xeate",
                        transformPreviewLabel: "Pr\xe9visualisation",
                        type: 'Type',
                        typeTitle: 'Changer le type de ce champ',
                        openUrl: "Ctrl+Click ou Ctrl+Enter pour ouvrir l'url dans une autre fen\xeatre",
                        undo: "Annuler la derni\xe8re action (Ctrl+Z)",
                        validationCannotMove: 'Cannot move a field into a child of itself',
                        autoType: 'Champe de type "auto". Ce type de champ est automatiquement d\xe9termin\xe9 en fonction de la valeur et peut \xeatre de type "cha\xeene", "nombre", "bool\xe9en" ou null.',
                        objectType: 'Champ de type "objet". Un objet contient un ensemble non ordonn\xe9 de paires cl\xe9/valeur.',
                        arrayType: 'Champ de type "liste". Une liste contient une collection ordonn\xe9e de valeurs.',
                        stringType: 'Champ de type "cha\xeene". Ce type de champ n\'est pas d\xe9termin\xe9 en fonction de la valeur, mais retourne syst\xe9matiquement une cha\xeene de caract\xe8res.',
                        modeEditorTitle: "Changer mode d'\xe9dition",
                        modeCodeText: 'Code',
                        modeCodeTitle: 'Activer surlignage code',
                        modeFormText: 'Formulaire',
                        modeFormTitle: 'Activer formulaire',
                        modeTextText: 'Texte',
                        modeTextTitle: "Activer \xe9diteur texte",
                        modeTreeText: 'Arbre',
                        modeTreeTitle: "Activer \xe9diteur arbre",
                        modeViewText: 'Lecture seule',
                        modeViewTitle: 'Activer vue arbre',
                        modePreviewText: "Pr\xe9visualisation",
                        modePreviewTitle: "Activer mode pr\xe9visualiser",
                        examples: 'Exemples',
                        "default": "D\xe9faut",
                        containsInvalidProperties: "Contient des propri\xe9t\xe9s non valides",
                        containsInvalidItems: "Contient des \xe9l\xe9ments invalides"
                    },
                    de: {
                        array: 'Auflistung',
                        auto: 'Auto',
                        appendText: "anh\xe4ngen",
                        appendTitle: "F\xfcgen Sie nach diesem Feld ein neues Feld mit dem Typ 'auto' ein (Strg+Umschalt+Ein)",
                        appendSubmenuTitle: "W\xe4hlen Sie den Typ des neuen Feldes",
                        appendTitleAuto: "Ein neues Feld vom Typ 'auto' hinzuf\xfcgen (Strg+Umschalt+Ein)",
                        ascending: 'Aufsteigend',
                        ascendingTitle: 'Sortieren Sie die Elemente dieses ${type} in aufsteigender Reihenfolge',
                        actionsMenu: "Klicken Sie zum \xd6ffnen des Aktionsmen\xfcs (Strg+M)",
                        cannotParseFieldError: 'Feld kann nicht in JSON geparst werden',
                        cannotParseValueError: 'Wert kann nicht in JSON geparst werden',
                        collapseAll: 'Alle Felder zuklappen',
                        compactTitle: 'JSON-Daten verdichten, alle Leerzeichen entfernen (Strg+Umschalt+\\)',
                        descending: 'Absteigend',
                        descendingTitle: 'Sortieren Sie die Elemente dieses ${type} in absteigender Reihenfolge',
                        drag: 'Ziehen, um dieses Feld zu verschieben (Alt+Umschalt+Pfeile)',
                        duplicateKey: "Doppelter Schl\xfcssel",
                        duplicateText: 'Duplikat',
                        duplicateTitle: "Ausgew\xe4hlte Felder duplizieren (Strg+D)",
                        duplicateField: 'Dieses Feld duplizieren (Strg+D)',
                        duplicateFieldError: 'Doppelter Feldname',
                        empty: 'leer',
                        expandAll: 'Alle Felder anzeigen',
                        expandTitle: "Klicken Sie, um dieses Feld zu erweitern/zu kollabieren (Strg+E). \nStrg+Klicken Sie, um dieses Feld einschlie\xdflich aller Elemente zu erweitern/zu kollabieren.",
                        formatTitle: "JSON-Daten mit korrekter Einr\xfcckung und Zeilenvorsch\xfcben formatieren (Strg+\\)",
                        insert: "einf\xfcgen",
                        insertTitle: "F\xfcgen Sie vor diesem Feld ein neues Feld mit dem Typ 'auto' ein (Strg+Einfg)",
                        insertSub: "W\xe4hlen Sie den Typ des neuen Feldes",
                        object: 'Objekt',
                        ok: 'Ok',
                        redo: 'Wiederholen (Strg+Umschalt+Z)',
                        removeText: 'entfernen',
                        removeTitle: "Ausgew\xe4hlte Felder entfernen (Strg+Entf)",
                        removeField: 'Dieses Feld entfernen (Strg+Entf)',
                        repairTitle: "JSON reparieren: Anf\xfchrungszeichen und Escape-Zeichen korrigieren, Kommentare und JSONP-Notation entfernen, JavaScript-Objekte in JSON umwandeln.",
                        searchTitle: 'Suchfelder und Werte',
                        searchNextResultTitle: "N\xe4chstes Ergebnis (Enter)",
                        searchPreviousResultTitle: 'Vorheriges Ergebnis (Umschalt + Eingabe)',
                        selectNode: "W\xe4hlen Sie einen Knoten aus...",
                        showAll: 'alle anzeigen',
                        showMore: 'mehr anzeigen',
                        showMoreStatus: 'Anzeige von ${visibleChilds} von ${totalChilds}-Elementen.',
                        sort: 'Sortieren',
                        sortTitle: 'Sortieren Sie die Elemente dieses ${type}',
                        sortTitleShort: 'Inhalt sortieren',
                        sortFieldLabel: 'Feld:',
                        sortDirectionLabel: 'Richtung:',
                        sortFieldTitle: "W\xe4hlen Sie das verschachtelte Feld, nach dem das Array oder Objekt sortiert werden soll.",
                        sortAscending: 'Aufsteigend',
                        sortAscendingTitle: "Sortieren Sie das ausgew\xe4hlte Feld in aufsteigender Reihenfolge",
                        sortDescending: 'Absteigend',
                        sortDescendingTitle: "Sortieren Sie das ausgew\xe4hlte Feld in absteigender Reihenfolge",
                        string: 'Zeichenfolge',
                        transform: 'Verwandeln',
                        transformTitle: 'Die Elemente dieses ${type} filtern, sortieren oder transformieren',
                        transformTitleShort: 'Inhalte filtern, sortieren oder transformieren',
                        extract: 'Auszug',
                        extractTitle: 'Extrahieren Sie diesen ${type}',
                        transformQueryTitle: 'Eine JMESPath-Abfrage eingeben',
                        transformWizardLabel: 'Zauberer',
                        transformWizardFilter: 'Filter',
                        transformWizardSortBy: 'Sortieren nach',
                        transformWizardSelectFields: "Felder ausw\xe4hlen",
                        transformQueryLabel: 'Anfrage',
                        transformPreviewLabel: 'Vorschau',
                        type: 'Geben Sie  ein.',
                        typeTitle: "\xc4ndern Sie den Typ dieses Feldes",
                        openUrl: "Strg+Klicken oder Strg+Eingabe, um die URL in einem neuen Fenster zu \xf6ffnen",
                        undo: "Letzte Aktion r\xfcckg\xe4ngig machen (Strg+Z)",
                        validationCannotMove: 'Kann ein Feld nicht in ein Kind seiner selbst verschieben',
                        autoType: 'Feldtyp "auto". Der Feldtyp wird automatisch aus dem Wert bestimmt und kann ein String, eine Zahl, boolesch oder null sein.',
                        objectType: 'Feldtyp "Objekt". Ein Objekt enth\xe4lt eine ungeordnete Menge von Schl\xfcssel/Wert-Paaren.',
                        arrayType: 'Feldtyp "Array". Ein Array enth\xe4lt eine geordnete Sammlung von Werten.',
                        stringType: 'Feldtyp "Zeichenfolge". Der Feldtyp wird nicht aus dem Wert bestimmt, sondern immer als Zeichenfolge zur\xfcckgegeben.',
                        modeEditorTitle: 'Editor-Modus umschalten',
                        modeCodeText: 'Code',
                        modeCodeTitle: 'Umschalten auf Code-Highlighter',
                        modeFormText: 'Formular',
                        modeFormTitle: 'Zum Formular-Editor wechseln',
                        modeTextText: 'Text',
                        modeTextTitle: "Zum Editor f\xfcr einfachen Text wechseln",
                        modeTreeText: 'Baum',
                        modeTreeTitle: 'Zum Baum-Editor wechseln',
                        modeViewText: 'Siehe',
                        modeViewTitle: 'Zur Baumansicht wechseln',
                        modePreviewText: 'Vorschau',
                        modePreviewTitle: 'In den Vorschau-Modus wechseln',
                        examples: 'Beispiele',
                        "default": "Standardm\xe4\xdfig",
                        containsInvalidProperties: "Enth\xe4lt ung\xfcltige Eigenschaften",
                        containsInvalidItems: "Enth\xe4lt ung\xfcltige Elemente"
                    },
                    ru: {
                        array: "\u041C\u0430\u0441\u0441\u0438\u0432",
                        auto: "\u0410\u0432\u0442\u043E",
                        appendText: "\u0414\u043E\u0431\u0430\u0432\u0438\u0442\u044C",
                        appendTitle: "\u0414\u043E\u0431\u0430\u0432\u0438\u0442\u044C \u043D\u043E\u0432\u043E\u0435 \u043F\u043E\u043B\u0435 \u0441 \u0442\u0438\u043F\u043E\u043C '\u0430\u0432\u0442\u043E' \u043F\u043E\u0441\u043B\u0435 \u044D\u0442\u043E\u0433\u043E \u043F\u043E\u043B\u044F (Ctrl+Shift+Ins)",
                        appendSubmenuTitle: "\u0412\u044B\u0431\u0440\u0430\u0442\u044C \u0442\u0438\u043F \u043F\u043E\u043B\u044F \u0434\u043B\u044F \u0434\u043E\u0431\u0430\u0432\u043B\u0435\u043D\u0438\u044F",
                        appendTitleAuto: "\u0414\u043E\u0431\u0430\u0432\u0438\u0442\u044C \u043D\u043E\u0432\u043E\u0435 \u043F\u043E\u043B\u0435 \u0441 \u0442\u0438\u043F\u043E\u043C '\u0430\u0432\u0442\u043E' (Ctrl+Shift+Ins)",
                        ascending: "\u041F\u043E \u0432\u043E\u0437\u0440\u0430\u0441\u0442\u0430\u043D\u0438\u044E",
                        ascendingTitle: "\u0421\u043E\u0440\u0442\u0438\u0440\u043E\u0432\u0430\u0442\u044C ${type} \u043F\u043E \u0432\u043E\u0437\u0440\u0430\u0441\u0442\u0430\u043D\u0438\u044E",
                        actionsMenu: "\u041D\u0430\u0436\u043C\u0438\u0442\u0435 \u0434\u043B\u044F \u043E\u0442\u043A\u0440\u044B\u0442\u0438\u044F \u043C\u0435\u043D\u044E \u0434\u0435\u0439\u0441\u0442\u0432\u0438\u0439 (Ctrl+M)",
                        cannotParseFieldError: "\u041D\u0435\u0432\u043E\u0437\u043C\u043E\u0436\u043D\u043E \u043F\u0440\u0435\u043E\u0431\u0440\u0430\u0437\u043E\u0432\u0430\u0442\u044C \u043F\u043E\u043B\u0435 \u0432 JSON",
                        cannotParseValueError: "\u041D\u0435\u0432\u043E\u0437\u043C\u043E\u0436\u043D\u043E \u043F\u0440\u0435\u043E\u0431\u0440\u0430\u0437\u043E\u0432\u0430\u0442\u044C \u0437\u043D\u0430\u0447\u0435\u043D\u0438\u0435 \u0432 JSON",
                        collapseAll: "\u0421\u0432\u0435\u0440\u043D\u0443\u0442\u044C \u0432\u0441\u0435",
                        compactTitle: "\u041C\u0438\u043D\u0438\u0444\u0438\u043A\u0430\u0446\u0438\u044F JSON (Ctrl+Shift+I)",
                        descending: "\u041F\u043E \u0443\u0431\u044B\u0432\u0430\u043D\u0438\u044E",
                        descendingTitle: "\u0421\u043E\u0440\u0442\u0438\u0440\u043E\u0432\u0430\u0442\u044C ${type} \u043F\u043E \u0443\u0431\u044B\u0432\u0430\u043D\u0438\u044E",
                        drag: "\u041F\u043E\u0442\u044F\u043D\u0438\u0442\u0435 \u0434\u043B\u044F \u043F\u0435\u0440\u0435\u043C\u0435\u0449\u0435\u043D\u0438\u044F \u044D\u0442\u043E\u0433\u043E \u043F\u043E\u043B\u044F (Alt+Shift+Arrows)",
                        duplicateKey: "\u043F\u043E\u0432\u0442\u043E\u0440\u044F\u044E\u0449\u0438\u0439\u0441\u044F \u043A\u043B\u044E\u0447",
                        duplicateText: "\u0414\u0443\u0431\u043B\u0438\u0440\u043E\u0432\u0430\u0442\u044C",
                        duplicateTitle: "\u0414\u0443\u0431\u043B\u0438\u0440\u043E\u0432\u0430\u043D\u0438\u0435 \u043F\u043E\u043B\u0435\u0439 (Ctrl+D)",
                        duplicateField: "\u0414\u0443\u0431\u043B\u0438\u0440\u043E\u0432\u0430\u0442\u044C \u043F\u043E\u043B\u0435 (Ctrl+D)",
                        duplicateFieldError: "\u0414\u0443\u0431\u043B\u0438\u0440\u043E\u0432\u0430\u043D\u0438\u0435 \u043D\u0430\u0437\u0432\u0430\u043D\u0438\u044F \u043F\u043E\u043B\u044F",
                        empty: "\u043F\u0443\u0441\u0442\u043E\u0439",
                        expandAll: "\u0420\u0430\u0437\u0432\u0435\u0440\u043D\u0443\u0442\u044C \u0432\u0441\u0435",
                        expandTitle: "\u041D\u0430\u0436\u043C\u0438\u0442\u0435 \u0434\u043B\u044F \u0440\u0430\u0441\u043A\u0440\u044B\u0442\u0438\u044F/\u0441\u043A\u0440\u044B\u0442\u0438\u044F \u043F\u043E\u043B\u044F (Ctrl+E)\n\u0438\u043B\u0438 Ctrl+Click \u0434\u043B\u044F \u0440\u0430\u0441\u043A\u0440\u044B\u0442\u0438\u044F/\u0441\u043A\u0440\u044B\u0442\u0438\u044F \u0432\u0441\u0435\u0445 \u043F\u043E\u0442\u043E\u043C\u043A\u043E\u0432.",
                        formatTitle: "\u0424\u043E\u0440\u043C\u0430\u0442\u0438\u0440\u043E\u0432\u0430\u043D\u0438\u0435 JSON (Ctrl+I)",
                        insert: "\u0412\u0441\u0442\u0430\u0432\u0438\u0442\u044C",
                        insertTitle: "\u0412\u0441\u0442\u0430\u0432\u0438\u0442\u044C \u043D\u043E\u0432\u043E\u0435 \u043F\u043E\u043B\u0435 \u0441 \u0442\u0438\u043F\u043E\u043C '\u0430\u0432\u0442\u043E' \u043F\u0435\u0440\u0435\u0434 \u044D\u0442\u0438\u043C \u043F\u043E\u043B\u0435\u043C (Ctrl+Ins)",
                        insertSub: "\u0412\u044B\u0431\u0440\u0430\u0442\u044C \u0442\u0438\u043F \u043F\u043E\u043B\u044F \u0434\u043B\u044F \u0432\u0441\u0442\u0430\u0432\u043A\u0438",
                        object: "\u041E\u0431\u044A\u0435\u043A\u0442",
                        ok: "\u041E\u041A",
                        redo: "\u041F\u043E\u0432\u0442\u043E\u0440\u0438\u0442\u044C (Ctrl+Shift+Z)",
                        removeText: "\u0423\u0434\u0430\u043B\u0438\u0442\u044C",
                        removeTitle: "\u0423\u0434\u0430\u043B\u0438\u0442\u044C \u0432\u044B\u0431\u0440\u0430\u043D\u043D\u044B\u0435 \u043F\u043E\u043B\u044F (Ctrl+Del)",
                        removeField: "\u0423\u0434\u0430\u043B\u0438\u0442\u044C \u043F\u043E\u043B\u0435 (Ctrl+Del)",
                        repairTitle: "\u0412\u043E\u0441\u0441\u0442\u0430\u043D\u043E\u0432\u0438\u0442\u0435 JSON: \u0438\u0441\u043F\u0440\u0430\u0432\u044C\u0442\u0435 \u043A\u0430\u0432\u044B\u0447\u043A\u0438 \u0438 escape-\u0441\u0438\u043C\u0432\u043E\u043B\u044B, \u0443\u0434\u0430\u043B\u0438\u0442\u0435 \u043A\u043E\u043C\u043C\u0435\u043D\u0442\u0430\u0440\u0438\u0438 \u0438 \u043D\u043E\u0442\u0430\u0446\u0438\u044E JSONP, \u043C\u043E\u0434\u0438\u0444\u0438\u0446\u0438\u0440\u0443\u0439\u0442\u0435 \u043E\u0431\u044A\u0435\u043A\u0442\u044B JavaScript \u0432 JSON.",
                        searchTitle: "\u041F\u043E\u0438\u0441\u043A",
                        searchNextResultTitle: "\u0421\u043B\u0435\u0434\u0443\u044E\u0449\u0438\u0439 \u0440\u0435\u0437\u0443\u043B\u044C\u0442\u0430\u0442 (Enter)",
                        searchPreviousResultTitle: "\u041F\u0440\u0435\u0434\u044B\u0434\u0443\u0449\u0438\u0439 \u0440\u0435\u0437\u0443\u043B\u044C\u0442\u0430\u0442 (Shift + Enter)",
                        selectNode: "\u0412\u044B\u0431\u043E\u0440 \u0443\u0437\u043B\u0430...",
                        showAll: "\u043F\u043E\u043A\u0430\u0437\u0430\u0442\u044C \u0432\u0441\u0435",
                        showMore: "\u0431\u043E\u043B\u044C\u0448\u0435",
                        showMoreStatus: "${visibleChilds} \u0438\u0437 ${totalChilds}",
                        sort: "\u0421\u043E\u0440\u0442\u0438\u0440\u043E\u0432\u043A\u0430",
                        sortTitle: "\u0421\u043E\u0440\u0442\u0438\u0440\u043E\u0432\u043A\u0430 \u043F\u043E\u0442\u043E\u043C\u043A\u043E\u0432 \u0442\u0438\u043F\u0430 ${type}",
                        sortTitleShort: "\u0421\u043E\u0440\u0442\u0438\u0440\u043E\u0432\u043A\u0430 \u0441\u043E\u0434\u0435\u0440\u0436\u0438\u043C\u043E\u0433\u043E",
                        sortFieldLabel: "\u041F\u043E\u043B\u0435:",
                        sortDirectionLabel: "\u041D\u0430\u043F\u0440\u0430\u0432\u043B\u0435\u043D\u0438\u0435:",
                        sortFieldTitle: "\u0412\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u043F\u043E\u043B\u0435 \u0434\u043B\u044F \u0441\u043E\u0440\u0442\u0438\u0440\u043E\u0432\u043A\u0438 \u043C\u0430\u0441\u0441\u0438\u0432\u0430 \u0438\u043B\u0438 \u043E\u0431\u044A\u0435\u043A\u0442\u0430",
                        sortAscending: "\u041F\u043E \u0432\u043E\u0437\u0440\u0430\u0441\u0442\u0430\u043D\u0438\u044E",
                        sortAscendingTitle: "\u0421\u043E\u0440\u0442\u0438\u0440\u043E\u0432\u043A\u0430 \u0432\u044B\u0431\u0440\u0430\u043D\u043D\u043E\u0433\u043E \u043F\u043E\u0440\u044F \u043F\u043E \u0432\u043E\u0437\u0440\u0430\u0441\u0442\u0430\u043D\u0438\u044E",
                        sortDescending: "\u041F\u043E \u0443\u0431\u044B\u0432\u0430\u043D\u0438\u044E",
                        sortDescendingTitle: "\u0421\u043E\u0440\u0442\u0438\u0440\u043E\u0432\u043A\u0430 \u0432\u044B\u0431\u0440\u0430\u043D\u043D\u043E\u0433\u043E \u043F\u043E\u0440\u044F \u043F\u043E \u0443\u0431\u044B\u0432\u0430\u043D\u0438\u044E",
                        string: "\u0421\u0442\u0440\u043E\u043A\u0430",
                        transform: "\u041C\u043E\u0434\u0438\u0444\u0438\u043A\u0430\u0446\u0438\u044F",
                        transformTitle: "\u0424\u0438\u043B\u044C\u0442\u0440\u0430\u0446\u0438\u044F, \u0441\u043E\u0440\u0442\u0438\u0440\u043E\u0432\u043A\u0430 \u0438\u043B\u0438 \u043C\u043E\u0434\u0438\u0444\u0438\u043A\u0430\u0446\u0438\u044F \u0434\u0430\u043D\u043D\u044B\u0445 \u0442\u0438\u043F\u0430 ${type}",
                        transformTitleShort: "\u0424\u0438\u043B\u044C\u0442\u0440\u0430\u0446\u0438\u044F, \u0441\u043E\u0440\u0442\u0438\u0440\u043E\u0432\u043A\u0430 \u0438\u043B\u0438 \u043C\u043E\u0434\u0438\u0444\u0438\u043A\u0430\u0446\u0438\u044F \u0434\u0430\u043D\u043D\u044B\u0445",
                        extract: "\u0418\u0437\u0432\u043B\u0435\u0447\u0435\u043D\u0438\u0435",
                        extractTitle: "\u0418\u0437\u0432\u043B\u0435\u0447\u044C \u0442\u0438\u043F ${type}",
                        transformQueryTitle: "\u0412\u0432\u0435\u0434\u0438\u0442\u0435 JMESpath \u0437\u0430\u043F\u0440\u043E\u0441",
                        transformWizardLabel: "\u041C\u0430\u0441\u0442\u0435\u0440",
                        transformWizardFilter: "\u0424\u0438\u043B\u044C\u0442\u0440",
                        transformWizardSortBy: "\u0421\u043E\u0440\u0442\u0438\u0440\u043E\u0432\u043A\u0430",
                        transformWizardSelectFields: "\u041F\u043E\u043B\u044F",
                        transformQueryLabel: "\u0417\u0430\u043F\u0440\u043E\u0441",
                        transformPreviewLabel: "\u041F\u0440\u043E\u0441\u043C\u043E\u0442\u0440",
                        type: "\u0422\u0438\u043F",
                        typeTitle: "\u0418\u0437\u043C\u0435\u043D\u0438\u0442\u044C \u0442\u0438\u043F \u044D\u0442\u043E\u0433\u043E \u043F\u043E\u043B\u044F",
                        openUrl: "Ctrl+Click \u0438\u043B\u0438 Ctrl+Enter \u0434\u043B\u044F \u043E\u0442\u043A\u0440\u044B\u0442\u0438\u044F url \u0432 \u043D\u043E\u0432\u043E\u043C \u043E\u043A\u043D\u0435",
                        undo: "\u041E\u0442\u043C\u0435\u043D\u0438\u0442\u044C (Ctrl+Z)",
                        validationCannotMove: "\u041F\u043E\u043B\u0435 \u043D\u0435 \u043C\u043E\u0436\u0435\u0442 \u0431\u044B\u0442\u044C \u043F\u0435\u0440\u0435\u043C\u0435\u0449\u0435\u043D\u043E \u0432 \u043F\u043E\u0442\u043E\u043C\u043A\u0430",
                        autoType: "\u0422\u0438\u043F \u043F\u043E\u043B\u044F \u0430\u0432\u0442\u043E\u043C\u0430\u0442\u0438\u0447\u0435\u0441\u043A\u0438 \u043E\u043F\u0440\u0435\u0434\u0435\u043B\u044F\u0435\u0442\u0441\u044F \u043F\u043E \u0437\u043D\u0430\u0447\u0435\u043D\u0438\u044E \u0438 \u043C\u043E\u0436\u0435\u0442 \u0431\u044B\u0442\u044C \u0441\u0442\u0440\u043E\u043A\u043E\u0439, \u0447\u0438\u0441\u043B\u043E\u043C, \u043B\u043E\u0433\u0438\u0447\u0435\u0441\u043A\u0438\u043C \u0437\u043D\u0430\u0447\u0435\u043D\u0438\u0435\u043C \u0438\u043B\u0438 null.",
                        objectType: "\u041E\u0431\u044A\u0435\u043A\u0442 \u0441\u043E\u0434\u0435\u0440\u0436\u0438\u0442 \u043D\u0435\u0443\u043F\u043E\u0440\u044F\u0434\u043E\u0447\u0435\u043D\u043D\u044B\u0439 \u043D\u0430\u0431\u043E\u0440 \u043F\u0430\u0440 \u043A\u043B\u044E\u0447/\u0437\u043D\u0430\u0447\u0435\u043D\u0438\u0435.",
                        arrayType: "\u041C\u0430\u0441\u0441\u0438\u0432 \u0441\u043E\u0434\u0435\u0440\u0436\u0438\u0442 \u0443\u043F\u043E\u0440\u044F\u0434\u043E\u0447\u0435\u043D\u043D\u044B\u0439 \u043D\u0430\u0431\u043E\u0440 \u0437\u043D\u0430\u0447\u0435\u043D\u0438\u0439.",
                        stringType: "\u0422\u0438\u043F \u043F\u043E\u043B\u044F \u043D\u0435 \u043E\u043F\u0440\u0435\u0434\u0435\u043B\u044F\u0435\u0442\u0441\u044F \u0438\u0437 \u0437\u043D\u0430\u0447\u0435\u043D\u0438\u044F, \u043D\u043E \u0432\u0441\u0435\u0433\u0434\u0430 \u0432\u043E\u0437\u0432\u0440\u0430\u0449\u0430\u0435\u0442\u0441\u044F \u043A\u0430\u043A \u0441\u0442\u0440\u043E\u043A\u0430.",
                        modeEditorTitle: "\u041F\u0435\u0440\u0435\u043A\u043B\u044E\u0447\u0435\u043D\u0438\u0435 \u0440\u0435\u0436\u0438\u043C\u0430 \u0440\u0435\u0434\u0430\u043A\u0442\u043E\u0440\u0430",
                        modeCodeText: "\u041A\u043E\u0434",
                        modeCodeTitle: "\u041F\u0435\u0440\u0435\u043A\u043B\u044E\u0447\u0438\u0442\u044C \u0432 \u0440\u0435\u0436\u0438\u043C \u0440\u0435\u0434\u0430\u043A\u0442\u043E\u0440\u0430 \u043A\u043E\u0434\u0430",
                        modeFormText: "\u0424\u043E\u0440\u043C\u0430",
                        modeFormTitle: "\u041F\u0435\u0440\u0435\u043A\u043B\u044E\u0447\u0438\u0442\u044C \u0432 \u0440\u0435\u0436\u0438\u043C \u0444\u043E\u0440\u043C\u044B",
                        modeTextText: "\u0422\u0435\u043A\u0441\u0442",
                        modeTextTitle: "\u041F\u0435\u0440\u0435\u043A\u043B\u044E\u0447\u0438\u0442\u044C \u0432 \u0440\u0435\u0436\u0438\u043C \u0440\u0435\u0434\u0430\u043A\u0442\u043E\u0440\u0430 \u0442\u0435\u043A\u0441\u0442\u0430",
                        modeTreeText: "\u0414\u0435\u0440\u0435\u0432\u043E",
                        modeTreeTitle: "\u041F\u0435\u0440\u0435\u043A\u043B\u044E\u0447\u0438\u0442\u044C \u0432 \u0440\u0435\u0436\u0438\u043C \u0440\u0435\u0434\u0430\u043A\u0442\u043E\u0440\u0430 \u0434\u0435\u0440\u0435\u0432\u0430",
                        modeViewText: "\u041F\u0440\u043E\u0441\u043C\u043E\u0442\u0440 \u0434\u0435\u0440\u0435\u0432\u0430",
                        modeViewTitle: "\u041F\u0435\u0440\u0435\u043A\u043B\u044E\u0447\u0438\u0442\u044C \u0432 \u0440\u0435\u0436\u0438\u043C \u043F\u0440\u043E\u0441\u043C\u043E\u0442\u0440\u0430 \u0434\u0435\u0440\u0435\u0432\u0430",
                        modePreviewText: "\u041F\u0440\u043E\u0441\u043C\u043E\u0442\u0440",
                        modePreviewTitle: "\u041F\u0435\u0440\u0435\u043A\u043B\u044E\u0447\u0438\u0442\u044C \u0432 \u0440\u0435\u0436\u0438\u043C \u043F\u0440\u043E\u0441\u043C\u043E\u0442\u0440\u0430",
                        examples: "\u041F\u0440\u0438\u043C\u0435\u0440\u044B",
                        "default": "\u041F\u043E \u0443\u043C\u043E\u043B\u0447\u0430\u043D\u0438\u044E",
                        containsInvalidProperties: "\u0421\u043E\u0434\u0435\u0440\u0436\u0438\u0442 \u043D\u0435\u0434\u043E\u043F\u0443\u0441\u0442\u0438\u043C\u044B\u0435 \u0441\u0432\u043E\u0439\u0441\u0442\u0432\u0430",
                        containsInvalidItems: "\u0421\u043E\u0434\u0435\u0440\u0436\u0438\u0442 \u043D\u0435\u0434\u043E\u043F\u0443\u0441\u0442\u0438\u043C\u044B\u0435 \u044D\u043B\u0435\u043C\u0435\u043D\u0442\u044B"
                    },
                    ko: {
                        array: "\uBC30\uC5F4",
                        auto: "\uC790\uB3D9",
                        appendText: "\uCD94\uAC00",
                        appendTitle: '\uC120\uD0DD\uD55C \uC694\uC18C \uC544\uB798\uC5D0 "\uC790\uB3D9" \uC694\uC18C\uB97C \uCD94\uAC00\uD569\uB2C8\uB2E4. (Ctrl + Shift + Ins)',
                        appendSubmenuTitle: "\uCD94\uAC00\uD560 \uC694\uC18C\uC758 \uC720\uD615\uC744 \uC120\uD0DD\uD574\uC8FC\uC138\uC694.",
                        appendTitleAuto: '"\uC790\uB3D9" \uC694\uC18C\uB97C \uCD94\uAC00\uD569\uB2C8\uB2E4. (Ctrl + Shift + Ins)',
                        ascending: "\uC624\uB984\uCC28\uC21C",
                        ascendingTitle: "\uC120\uD0DD\uD55C ${type}\uC758 \uD558\uC704 \uC694\uC18C\uB97C \uC624\uB984\uCC28\uC21C \uC815\uB82C\uD569\uB2C8\uB2E4.",
                        actionsMenu: "\uBA54\uB274 \uC5F4\uAE30 (Ctrl + M)",
                        cannotParseFieldError: "JSON\uC758 \uC694\uC18C\uB97C \uD574\uC11D\uD560 \uC218 \uC5C6\uC2B5\uB2C8\uB2E4.",
                        cannotParseValueError: "JSON\uC758 \uAC12\uC744 \uD574\uC11D\uD560 \uC218 \uC5C6\uC2B5\uB2C8\uB2E4.",
                        collapseAll: "\uBAA8\uB450 \uC811\uAE30",
                        compactTitle: "\uBAA8\uB4E0 \uACF5\uBC31\uC744 \uC81C\uAC70\uD558\uC5EC JSON \uB370\uC774\uD130\uB97C \uC791\uAC8C \uB9CC\uB4ED\uB2C8\uB2E4. (Ctrl + Shift + I)",
                        descending: "\uB0B4\uB9BC\uCC28\uC21C",
                        descendingTitle: "\uC120\uD0DD\uD55C ${type}\uC758 \uD558\uC704 \uC694\uC18C\uB97C \uB0B4\uB9BC\uCC28\uC21C\uC73C\uB85C \uC815\uB82C",
                        drag: "\uB4DC\uB798\uADF8\uD558\uC5EC \uC694\uC18C\uB97C \uC774\uB3D9\uD569\uB2C8\uB2E4. (Alt + Shift + Arrows)",
                        duplicateKey: "\uBCF5\uC81C\uD0A4",
                        duplicateText: "\uBCF5\uC81C",
                        duplicateTitle: "\uC120\uD0DD\uD55C \uC694\uC18C\uB97C \uBCF5\uC81C\uD569\uB2C8\uB2E4. (Ctrl + D)",
                        duplicateField: "\uC120\uD0DD\uD55C \uC694\uC18C\uB97C \uBCF5\uC81C\uD569\uB2C8\uB2E4. (Ctrl + D)",
                        duplicateFieldError: "\uC694\uC18C \uC774\uB984\uC774 \uC911\uBCF5\uB418\uC5C8\uC2B5\uB2C8\uB2E4.",
                        empty: "\uBE44\uC5B4\uC788\uC74C",
                        expandAll: "\uBAA8\uB450 \uC5F4\uAE30",
                        expandTitle: "\uD074\uB9AD\uD558\uC5EC \uC694\uC18C\uB97C \uC5F4\uAC70\uB098 \uB2EB\uC2B5\uB2C8\uB2E4. (Ctrl + E) \nCtrl + Click\uC73C\uB85C \uBAA8\uB4E0 \uD558\uC704 \uC694\uC18C\uB97C \uC5F4\uAC70\uB098 \uB2EB\uC2B5\uB2C8\uB2E4.",
                        formatTitle: "\uC801\uC808\uD55C \uB4E4\uC5EC\uC4F0\uAE30 \uBC0F \uC904\uBC14\uAFC8\uC73C\uB85C JSON \uB370\uC774\uD130\uB97C \uC815\uD615\uD654\uD569\uB2C8\uB2E4. (Ctrl + I)",
                        insert: "\uC0BD\uC785",
                        insertTitle: "\uC120\uD0DD\uD55C \uC694\uC18C \uC704\uC5D0 \uC0C8\uC694\uC18C\uB97C \uC0BD\uC785\uD569\uB2C8\uB2E4. (Ctrl + Ins)",
                        insertSub: "\uC0BD\uC785\uD560 \uC694\uC18C\uC758 \uC720\uD615\uC744 \uC120\uD0DD\uD574\uC8FC\uC138\uC694.",
                        object: "\uAC1D\uCCB4",
                        ok: "\uD655\uC778",
                        redo: "\uB2E4\uC2DC \uC2E4\uD589 (Ctrl + Shift + Z)",
                        removeText: "\uC0AD\uC81C",
                        removeTitle: "\uC120\uD0DD\uD55C \uC694\uC18C\uB97C \uC0AD\uC81C\uD569\uB2C8\uB2E4. (Ctrl + Del)",
                        removeField: "\uC120\uD0DD\uD55C \uC694\uC18C\uB97C \uC0AD\uC81C\uD569\uB2C8\uB2E4. (Ctrl + Del)",
                        repairTitle: "JSON \uAD50\uC815: JSON \uB0B4\uC758 \uC8FC\uC11D\uACFC JSONP \uD45C\uAE30\uBC95\uC744 \uC9C0\uC6B0\uACE0 \uB530\uC634\uD45C\uC640 \uC774\uC2A4\uCF00\uC774\uD504 \uBB38\uC790\uB97C \uC218\uC815\uD569\uB2C8\uB2E4.",
                        searchTitle: "\uC694\uC18C \uB610\uB294 \uAC12 \uCC3E\uAE30",
                        searchNextResultTitle: "\uB2E4\uC74C\uC73C\uB85C \uCC3E\uAE30 (Enter)",
                        searchPreviousResultTitle: "\uC774\uC804\uC73C\uB85C \uCC3E\uAE30 (Shift + Enter)",
                        selectNode: "\uC694\uC18C\uB97C \uC120\uD0DD\uD574\uC8FC\uC138\uC694...",
                        showAll: "\uBAA8\uB450\uBCF4\uAE30",
                        showMore: "\uB354\uBCF4\uAE30",
                        showMoreStatus: "${totalChilds} \uAC1C\uC758 \uD56D\uBAA9 \uC911 ${visibleChilds} \uAC1C\uB97C \uD45C\uC2DC\uD569\uB2C8\uB2E4.",
                        sort: "\uC815\uB82C",
                        sortTitle: "\uC120\uD0DD\uD55C ${type}\uC758 \uD558\uC704 \uC694\uC18C\uB97C \uC815\uB82C\uD569\uB2C8\uB2E4.",
                        sortTitleShort: "\uC815\uB82C",
                        sortFieldLabel: "\uC694\uC18C:",
                        sortDirectionLabel: "\uC21C\uC11C:",
                        sortFieldTitle: "\uBC30\uC5F4\uC774\uB098 \uAC1D\uCCB4\uB97C \uC815\uB82C\uD558\uB294 \uC694\uC18C\uB97C \uC120\uD0DD\uD574\uC8FC\uC138\uC694.",
                        sortAscending: "\uC624\uB984\uCC28\uC21C",
                        sortAscendingTitle: "\uC120\uD0DD\uD55C \uC694\uC18C\uB97C \uC624\uB984\uCC28\uC21C\uC73C\uB85C \uC815\uB82C\uD569\uB2C8\uB2E4.",
                        sortDescending: "\uB0B4\uB9BC\uCC28\uC21C",
                        sortDescendingTitle: "\uC120\uD0DD\uD55C \uC694\uC18C\uB97C \uB0B4\uB9BC\uCC28\uC21C\uC73C\uB85C \uC815\uB82C\uD569\uB2C8\uB2E4.",
                        string: "\uBB38\uC790",
                        transform: "\uBCC0\uD658",
                        transformTitle: "\uC120\uD0DD\uD55C ${type}\uC758 \uD558\uC704 \uC694\uC18C\uB97C \uD544\uD130\uD558\uAC70\uB098 \uC815\uB82C \uB610\uB294 \uBCC0\uD658\uD569\uB2C8\uB2E4.",
                        transformTitleShort: "\uB0B4\uC6A9\uC744 \uD544\uD130\uD558\uAC70\uB098 \uC815\uB82C \uB610\uB294 \uBCC0\uD658\uD569\uB2C8\uB2E4.",
                        extract: "\uCD94\uCD9C",
                        extractTitle: "\uC120\uD0DD\uD55C ${type}\uC758 \uAC12\uC744 \uCD5C\uC0C1\uC704\uC5D0 \uC704\uCE58\uC2DC\uD0B5\uB2C8\uB2E4.",
                        transformQueryTitle: "JMESPath \uCFFC\uB9AC\uB97C \uC785\uB825\uD574\uC8FC\uC138\uC694.",
                        transformWizardLabel: "\uB9C8\uBC95\uC0AC",
                        transformWizardFilter: "\uD544\uD130",
                        transformWizardSortBy: "\uC815\uB82C",
                        transformWizardSelectFields: "\uC694\uC18C\uB97C \uC120\uD0DD\uD574\uC8FC\uC138\uC694.",
                        transformQueryLabel: "\uCFFC\uB9AC",
                        transformPreviewLabel: "\uBBF8\uB9AC\uBCF4\uAE30",
                        type: "\uC720\uD615",
                        typeTitle: "\uC120\uD0DD\uD55C \uC694\uC18C\uC758 \uC720\uD615\uC744 \uBCC0\uACBD\uD569\uB2C8\uB2E4.",
                        openUrl: "Ctrl + Click \uB610\uB294 Ctrl + Enter\uB85C \uC0C8 \uCC3D\uC5D0\uC11C URL \uC5F4\uAE30",
                        undo: "\uC2E4\uD589 \uCDE8\uC18C (Ctrl + Z)",
                        validationCannotMove: "\uD558\uC704 \uC694\uC18C\uB85C \uC774\uB3D9\uD560 \uC218 \uC5C6\uC2B5\uB2C8\uB2E4.",
                        autoType: "\uC790\uB3D9: \uC694\uC18C\uC758 \uD615\uC2DD\uC774 \uAC12\uC758 \uC720\uD615\uC73C\uB85C \uACB0\uC815\uB429\uB2C8\uB2E4. \uBB38\uC790, \uC22B\uC790, \uBD80\uC6B8, \uB610\uB294 null\uB9CC \uD5C8\uC6A9\uB429\uB2C8\uB2E4.",
                        objectType: "\uAC1D\uCCB4: \uC21C\uC11C\uB300\uB85C \uB098\uC5F4\uB418\uC9C0 \uC54A\uC740 \uC774\uB984/\uAC12 \uC30D\uC73C\uB85C \uC774\uB8E8\uC5B4\uC9C4 \uC9D1\uD569\uC785\uB2C8\uB2E4.",
                        arrayType: "\uBC30\uC5F4: \uC21C\uC11C\uB300\uB85C \uB098\uC5F4\uB41C \uAC12\uC758 \uC9D1\uD569\uC785\uB2C8\uB2E4.",
                        stringType: "\uBB38\uC790: \uC694\uC18C\uC758 \uC720\uD615\uC774 \uAC12\uC5D0\uC11C \uACB0\uC815\uB418\uC9C0 \uC54A\uC9C0\uB9CC \uD56D\uC0C1 \uBB38\uC790\uB85C \uBC18\uD658\uB429\uB2C8\uB2E4.",
                        modeEditorTitle: "\uD3B8\uC9D1\uAE30 \uC720\uD615 \uBCC0\uACBD",
                        modeCodeText: "\uCF54\uB4DC",
                        modeCodeTitle: "\uD615\uC2DD \uAD50\uC815\uC744 \uB3C4\uC640\uC8FC\uB294 \uAE30\uB2A5\uC774 \uD3EC\uD568\uB41C \uBB38\uC790 \uD3B8\uC9D1\uAE30",
                        modeFormText: "\uC785\uB825 \uC591\uC2DD",
                        modeFormTitle: "\uC815\uD574\uC9C4 \uC694\uC18C\uC5D0 \uAC12\uC744 \uC785\uB825\uD558\uB294 \uD3B8\uC9D1\uAE30",
                        modeTextText: "\uBB38\uC790",
                        modeTextTitle: "\uB2E8\uC21C \uBB38\uC790 \uD3B8\uC9D1\uAE30",
                        modeTreeText: "\uD2B8\uB9AC",
                        modeTreeTitle: "\uD2B8\uB9AC \uAD6C\uC870\uB85C \uD45C\uC2DC\uB418\uB294 \uD3B8\uC9D1\uAE30",
                        modeViewText: "\uBCF4\uAE30",
                        modeViewTitle: "\uC77D\uAE30\uC804\uC6A9 \uD2B8\uB9AC \uAD6C\uC870\uB85C JSON\uC744 \uD45C\uC2DC",
                        modePreviewText: "\uBBF8\uB9AC\uBCF4\uAE30",
                        modePreviewTitle: "\uC77D\uAE30\uC804\uC6A9 \uBB38\uC790\uB85C JSON\uC744 \uD45C\uC2DC",
                        examples: "\uC608\uC81C",
                        "default": "\uAE30\uBCF8\uAC12",
                        containsInvalidProperties: "\uC798\uBABB\uB41C \uC18D\uC131\uC774 \uD3EC\uD568\uB418\uC5B4 \uC788\uC2B5\uB2C8\uB2E4.",
                        containsInvalidItems: "\uC798\uBABB\uB41C \uD56D\uBAA9\uC774 \uD3EC\uD568\uB418\uC5B4 \uC788\uC2B5\uB2C8\uB2E4"
                    }
                };
                var _locales = Object.keys(_defs);
                var _defaultLang = 'en';
                var userLang = typeof navigator !== 'undefined' ? navigator.language || navigator.userLanguage : undefined;
                var _lang = _locales.find(function(l) {
                    return l === userLang;
                }) || _defaultLang;
                function setLanguage(lang) {
                    if (!lang) return;
                    var langFound = _locales.find(function(l) {
                        return l === lang;
                    });
                    if (langFound) _lang = langFound;
                    else console.error('Language not found');
                }
                function setLanguages(languages) {
                    if (!languages) return;
                    var _loop = function _loop(language) {
                        var langFound = _locales.find(function(l) {
                            return l === language;
                        });
                        if (!langFound) _locales.push(language);
                        _defs[language] = Object.assign({}, _defs[_defaultLang], _defs[language], languages[language]);
                    };
                    for(var language in languages)_loop(language);
                }
                function translate(key, data, lang) {
                    if (!lang) lang = _lang;
                    var text = _defs[lang][key] || _defs[_defaultLang][key] || key;
                    if (data) for(var dataKey in data)text = text.replace('${' + dataKey + '}', data[dataKey]);
                    return text;
                }
            /***/ },
            /***/ 81: /***/ function() {
                if (typeof Element !== 'undefined') // Polyfill for array remove
                (function() {
                    function polyfill(item) {
                        if (typeof item !== 'undefined') {
                            if ('remove' in item) return;
                            Object.defineProperty(item, 'remove', {
                                configurable: true,
                                enumerable: true,
                                writable: true,
                                value: function remove() {
                                    if (this.parentNode !== undefined) this.parentNode.removeChild(this);
                                }
                            });
                        }
                    }
                    if (typeof window.Element !== 'undefined') polyfill(window.Element.prototype);
                    if (typeof window.CharacterData !== 'undefined') polyfill(window.CharacterData.prototype);
                    if (typeof window.DocumentType !== 'undefined') polyfill(window.DocumentType.prototype);
                })();
                // simple polyfill for Array.findIndex
                if (!Array.prototype.findIndex) // eslint-disable-next-line no-extend-native
                Object.defineProperty(Array.prototype, 'findIndex', {
                    value: function value(predicate) {
                        for(var i = 0; i < this.length; i++){
                            var element = this[i];
                            if (predicate.call(this, element, i, this)) return i;
                        }
                        return -1;
                    },
                    configurable: true,
                    writable: true
                });
                // Polyfill for Array.find
                if (!Array.prototype.find) // eslint-disable-next-line no-extend-native
                Object.defineProperty(Array.prototype, 'find', {
                    value: function value(predicate) {
                        var i = this.findIndex(predicate);
                        return this[i];
                    },
                    configurable: true,
                    writable: true
                });
                // Polyfill for String.trim
                if (!String.prototype.trim) // eslint-disable-next-line no-extend-native
                String.prototype.trim = function() {
                    return this.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, '');
                };
            /***/ },
            /***/ 94: /***/ function(__unused_webpack_module, exports) {
                "use strict";
                var escapedChars = {
                    'b': '\b',
                    'f': '\f',
                    'n': '\n',
                    'r': '\r',
                    't': '\t',
                    '"': '"',
                    '/': '/',
                    '\\': '\\'
                };
                var A_CODE = 'a'.charCodeAt();
                exports.parse = function(source, _, options) {
                    var pointers = {};
                    var line = 0;
                    var column = 0;
                    var pos = 0;
                    var bigint = options && options.bigint && typeof BigInt != 'undefined';
                    return {
                        data: _parse('', true),
                        pointers: pointers
                    };
                    function _parse(ptr, topLevel) {
                        whitespace();
                        var data;
                        map(ptr, 'value');
                        var char = getChar();
                        switch(char){
                            case 't':
                                read('rue');
                                data = true;
                                break;
                            case 'f':
                                read('alse');
                                data = false;
                                break;
                            case 'n':
                                read('ull');
                                data = null;
                                break;
                            case '"':
                                data = parseString();
                                break;
                            case '[':
                                data = parseArray(ptr);
                                break;
                            case '{':
                                data = parseObject(ptr);
                                break;
                            default:
                                backChar();
                                if ('-0123456789'.indexOf(char) >= 0) data = parseNumber();
                                else unexpectedToken();
                        }
                        map(ptr, 'valueEnd');
                        whitespace();
                        if (topLevel && pos < source.length) unexpectedToken();
                        return data;
                    }
                    function whitespace() {
                        loop: while(pos < source.length){
                            switch(source[pos]){
                                case ' ':
                                    column++;
                                    break;
                                case '\t':
                                    column += 4;
                                    break;
                                case '\r':
                                    column = 0;
                                    break;
                                case '\n':
                                    column = 0;
                                    line++;
                                    break;
                                default:
                                    break loop;
                            }
                            pos++;
                        }
                    }
                    function parseString() {
                        var str = '';
                        var char;
                        while(true){
                            char = getChar();
                            if (char == '"') break;
                            else if (char == '\\') {
                                char = getChar();
                                if (char in escapedChars) str += escapedChars[char];
                                else if (char == 'u') str += getCharCode();
                                else wasUnexpectedToken();
                            } else str += char;
                        }
                        return str;
                    }
                    function parseNumber() {
                        var numStr = '';
                        var integer = true;
                        if (source[pos] == '-') numStr += getChar();
                        numStr += source[pos] == '0' ? getChar() : getDigits();
                        if (source[pos] == '.') {
                            numStr += getChar() + getDigits();
                            integer = false;
                        }
                        if (source[pos] == 'e' || source[pos] == 'E') {
                            numStr += getChar();
                            if (source[pos] == '+' || source[pos] == '-') numStr += getChar();
                            numStr += getDigits();
                            integer = false;
                        }
                        var result = +numStr;
                        return bigint && integer && (result > Number.MAX_SAFE_INTEGER || result < Number.MIN_SAFE_INTEGER) ? BigInt(numStr) : result;
                    }
                    function parseArray(ptr) {
                        whitespace();
                        var arr = [];
                        var i = 0;
                        if (getChar() == ']') return arr;
                        backChar();
                        while(true){
                            var itemPtr = ptr + '/' + i;
                            arr.push(_parse(itemPtr));
                            whitespace();
                            var char = getChar();
                            if (char == ']') break;
                            if (char != ',') wasUnexpectedToken();
                            whitespace();
                            i++;
                        }
                        return arr;
                    }
                    function parseObject(ptr) {
                        whitespace();
                        var obj = {};
                        if (getChar() == '}') return obj;
                        backChar();
                        while(true){
                            var loc = getLoc();
                            if (getChar() != '"') wasUnexpectedToken();
                            var key = parseString();
                            var propPtr = ptr + '/' + escapeJsonPointer(key);
                            mapLoc(propPtr, 'key', loc);
                            map(propPtr, 'keyEnd');
                            whitespace();
                            if (getChar() != ':') wasUnexpectedToken();
                            whitespace();
                            obj[key] = _parse(propPtr);
                            whitespace();
                            var char = getChar();
                            if (char == '}') break;
                            if (char != ',') wasUnexpectedToken();
                            whitespace();
                        }
                        return obj;
                    }
                    function read(str) {
                        for(var i = 0; i < str.length; i++)if (getChar() !== str[i]) wasUnexpectedToken();
                    }
                    function getChar() {
                        checkUnexpectedEnd();
                        var char = source[pos];
                        pos++;
                        column++; // new line?
                        return char;
                    }
                    function backChar() {
                        pos--;
                        column--;
                    }
                    function getCharCode() {
                        var count = 4;
                        var code = 0;
                        while(count--){
                            code <<= 4;
                            var char = getChar().toLowerCase();
                            if (char >= 'a' && char <= 'f') code += char.charCodeAt() - A_CODE + 10;
                            else if (char >= '0' && char <= '9') code += +char;
                            else wasUnexpectedToken();
                        }
                        return String.fromCharCode(code);
                    }
                    function getDigits() {
                        var digits = '';
                        while(source[pos] >= '0' && source[pos] <= '9')digits += getChar();
                        if (digits.length) return digits;
                        checkUnexpectedEnd();
                        unexpectedToken();
                    }
                    function map(ptr, prop) {
                        mapLoc(ptr, prop, getLoc());
                    }
                    function mapLoc(ptr, prop, loc) {
                        pointers[ptr] = pointers[ptr] || {};
                        pointers[ptr][prop] = loc;
                    }
                    function getLoc() {
                        return {
                            line: line,
                            column: column,
                            pos: pos
                        };
                    }
                    function unexpectedToken() {
                        throw new SyntaxError('Unexpected token ' + source[pos] + ' in JSON at position ' + pos);
                    }
                    function wasUnexpectedToken() {
                        backChar();
                        unexpectedToken();
                    }
                    function checkUnexpectedEnd() {
                        if (pos >= source.length) throw new SyntaxError('Unexpected end of JSON input');
                    }
                };
                exports.stringify = function(data, _, options) {
                    if (!validType(data)) return;
                    var wsLine = 0;
                    var wsPos, wsColumn;
                    var whitespace = typeof options == 'object' ? options.space : options;
                    switch(typeof whitespace){
                        case 'number':
                            var len = whitespace > 10 ? 10 : whitespace < 0 ? 0 : Math.floor(whitespace);
                            whitespace = len && repeat(len, ' ');
                            wsPos = len;
                            wsColumn = len;
                            break;
                        case 'string':
                            whitespace = whitespace.slice(0, 10);
                            wsPos = 0;
                            wsColumn = 0;
                            for(var j = 0; j < whitespace.length; j++){
                                var char = whitespace[j];
                                switch(char){
                                    case ' ':
                                        wsColumn++;
                                        break;
                                    case '\t':
                                        wsColumn += 4;
                                        break;
                                    case '\r':
                                        wsColumn = 0;
                                        break;
                                    case '\n':
                                        wsColumn = 0;
                                        wsLine++;
                                        break;
                                    default:
                                        throw new Error('whitespace characters not allowed in JSON');
                                }
                                wsPos++;
                            }
                            break;
                        default:
                            whitespace = undefined;
                    }
                    var json = '';
                    var pointers = {};
                    var line = 0;
                    var column = 0;
                    var pos = 0;
                    var es6 = options && options.es6 && typeof Map == 'function';
                    _stringify(data, 0, '');
                    return {
                        json: json,
                        pointers: pointers
                    };
                    function _stringify(_data, lvl, ptr) {
                        map(ptr, 'value');
                        switch(typeof _data){
                            case 'number':
                            case 'bigint':
                            case 'boolean':
                                out('' + _data);
                                break;
                            case 'string':
                                out(quoted(_data));
                                break;
                            case 'object':
                                if (_data === null) out('null');
                                else if (typeof _data.toJSON == 'function') out(quoted(_data.toJSON()));
                                else if (Array.isArray(_data)) stringifyArray();
                                else if (es6) {
                                    if (_data.constructor.BYTES_PER_ELEMENT) stringifyArray();
                                    else if (_data instanceof Map) stringifyMapSet();
                                    else if (_data instanceof Set) stringifyMapSet(true);
                                    else stringifyObject();
                                } else stringifyObject();
                        }
                        map(ptr, 'valueEnd');
                        function stringifyArray() {
                            if (_data.length) {
                                out('[');
                                var itemLvl = lvl + 1;
                                for(var i = 0; i < _data.length; i++){
                                    if (i) out(',');
                                    indent(itemLvl);
                                    var item = validType(_data[i]) ? _data[i] : null;
                                    var itemPtr = ptr + '/' + i;
                                    _stringify(item, itemLvl, itemPtr);
                                }
                                indent(lvl);
                                out(']');
                            } else out('[]');
                        }
                        function stringifyObject() {
                            var keys = Object.keys(_data);
                            if (keys.length) {
                                out('{');
                                var propLvl = lvl + 1;
                                for(var i = 0; i < keys.length; i++){
                                    var key = keys[i];
                                    var value = _data[key];
                                    if (validType(value)) {
                                        if (i) out(',');
                                        var propPtr = ptr + '/' + escapeJsonPointer(key);
                                        indent(propLvl);
                                        map(propPtr, 'key');
                                        out(quoted(key));
                                        map(propPtr, 'keyEnd');
                                        out(':');
                                        if (whitespace) out(' ');
                                        _stringify(value, propLvl, propPtr);
                                    }
                                }
                                indent(lvl);
                                out('}');
                            } else out('{}');
                        }
                        function stringifyMapSet(isSet) {
                            if (_data.size) {
                                out('{');
                                var propLvl = lvl + 1;
                                var first = true;
                                var entries = _data.entries();
                                var entry = entries.next();
                                while(!entry.done){
                                    var item = entry.value;
                                    var key = item[0];
                                    var value = isSet ? true : item[1];
                                    if (validType(value)) {
                                        if (!first) out(',');
                                        first = false;
                                        var propPtr = ptr + '/' + escapeJsonPointer(key);
                                        indent(propLvl);
                                        map(propPtr, 'key');
                                        out(quoted(key));
                                        map(propPtr, 'keyEnd');
                                        out(':');
                                        if (whitespace) out(' ');
                                        _stringify(value, propLvl, propPtr);
                                    }
                                    entry = entries.next();
                                }
                                indent(lvl);
                                out('}');
                            } else out('{}');
                        }
                    }
                    function out(str) {
                        column += str.length;
                        pos += str.length;
                        json += str;
                    }
                    function indent(lvl) {
                        if (whitespace) {
                            json += '\n' + repeat(lvl, whitespace);
                            line++;
                            column = 0;
                            while(lvl--){
                                if (wsLine) {
                                    line += wsLine;
                                    column = wsColumn;
                                } else column += wsColumn;
                                pos += wsPos;
                            }
                            pos += 1; // \n character
                        }
                    }
                    function map(ptr, prop) {
                        pointers[ptr] = pointers[ptr] || {};
                        pointers[ptr][prop] = {
                            line: line,
                            column: column,
                            pos: pos
                        };
                    }
                    function repeat(n, str) {
                        return Array(n + 1).join(str);
                    }
                };
                var VALID_TYPES = [
                    'number',
                    'bigint',
                    'boolean',
                    'string',
                    'object'
                ];
                function validType(data) {
                    return VALID_TYPES.indexOf(typeof data) >= 0;
                }
                var ESC_QUOTE = /"|\\/g;
                var ESC_B = /[\b]/g;
                var ESC_F = /\f/g;
                var ESC_N = /\n/g;
                var ESC_R = /\r/g;
                var ESC_T = /\t/g;
                function quoted(str) {
                    str = str.replace(ESC_QUOTE, '\\$&').replace(ESC_F, '\\f').replace(ESC_B, '\\b').replace(ESC_N, '\\n').replace(ESC_R, '\\r').replace(ESC_T, '\\t');
                    return '"' + str + '"';
                }
                var ESC_0 = /~/g;
                var ESC_1 = /\//g;
                function escapeJsonPointer(str) {
                    return str.replace(ESC_0, '~0').replace(ESC_1, '~1');
                }
            /***/ },
            /***/ 115: /***/ function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {
                "use strict";
                /* harmony export */ __webpack_require__.d(__webpack_exports__, {
                    /* harmony export */ N: function() {
                        return /* binding */ ErrorTable;
                    }
                });
                function _typeof(o) {
                    "@babel/helpers - typeof";
                    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
                        return typeof o;
                    } : function(o) {
                        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
                    }, _typeof(o);
                }
                function _classCallCheck(a, n) {
                    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
                }
                function _defineProperties(e, r) {
                    for(var t = 0; t < r.length; t++){
                        var o = r[t];
                        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
                    }
                }
                function _createClass(e, r, t) {
                    return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
                        writable: !1
                    }), e;
                }
                function _toPropertyKey(t) {
                    var i = _toPrimitive(t, "string");
                    return "symbol" == _typeof(i) ? i : i + "";
                }
                function _toPrimitive(t, r) {
                    if ("object" != _typeof(t) || !t) return t;
                    var e = t[Symbol.toPrimitive];
                    if (void 0 !== e) {
                        var i = e.call(t, r || "default");
                        if ("object" != _typeof(i)) return i;
                        throw new TypeError("@@toPrimitive must return a primitive value.");
                    }
                    return ("string" === r ? String : Number)(t);
                }
                /**
 * Show errors and schema warnings in a clickable table view
 * @param {Object} config
 * @property {boolean} errorTableVisible
 * @property {function (boolean) : void} onToggleVisibility
 * @property {function (number)} [onFocusLine]
 * @property {function (number)} onChangeHeight
 * @constructor
 */ var ErrorTable = /*#__PURE__*/ function() {
                    function ErrorTable(config) {
                        _classCallCheck(this, ErrorTable);
                        this.errorTableVisible = config.errorTableVisible;
                        this.onToggleVisibility = config.onToggleVisibility;
                        this.onFocusLine = config.onFocusLine || function() {};
                        this.onChangeHeight = config.onChangeHeight;
                        this.dom = {};
                        var validationErrorsContainer = document.createElement('div');
                        validationErrorsContainer.className = 'jsoneditor-validation-errors-container';
                        this.dom.validationErrorsContainer = validationErrorsContainer;
                        var additionalErrorsIndication = document.createElement('div');
                        additionalErrorsIndication.style.display = 'none';
                        additionalErrorsIndication.className = 'jsoneditor-additional-errors fadein';
                        additionalErrorsIndication.textContent = "Scroll for more \u25BF";
                        this.dom.additionalErrorsIndication = additionalErrorsIndication;
                        validationErrorsContainer.appendChild(additionalErrorsIndication);
                        var validationErrorIcon = document.createElement('span');
                        validationErrorIcon.className = 'jsoneditor-validation-error-icon';
                        validationErrorIcon.style.display = 'none';
                        this.dom.validationErrorIcon = validationErrorIcon;
                        var validationErrorCount = document.createElement('span');
                        validationErrorCount.className = 'jsoneditor-validation-error-count';
                        validationErrorCount.style.display = 'none';
                        this.dom.validationErrorCount = validationErrorCount;
                        this.dom.parseErrorIndication = document.createElement('span');
                        this.dom.parseErrorIndication.className = 'jsoneditor-parse-error-icon';
                        this.dom.parseErrorIndication.style.display = 'none';
                    }
                    return _createClass(ErrorTable, [
                        {
                            key: "getErrorTable",
                            value: function getErrorTable() {
                                return this.dom.validationErrorsContainer;
                            }
                        },
                        {
                            key: "getErrorCounter",
                            value: function getErrorCounter() {
                                return this.dom.validationErrorCount;
                            }
                        },
                        {
                            key: "getWarningIcon",
                            value: function getWarningIcon() {
                                return this.dom.validationErrorIcon;
                            }
                        },
                        {
                            key: "getErrorIcon",
                            value: function getErrorIcon() {
                                return this.dom.parseErrorIndication;
                            }
                        },
                        {
                            key: "toggleTableVisibility",
                            value: function toggleTableVisibility() {
                                this.errorTableVisible = !this.errorTableVisible;
                                this.onToggleVisibility(this.errorTableVisible);
                            }
                        },
                        {
                            key: "setErrors",
                            value: function setErrors(errors, errorLocations) {
                                var _this = this;
                                // clear any previous errors
                                if (this.dom.validationErrors) {
                                    this.dom.validationErrors.parentNode.removeChild(this.dom.validationErrors);
                                    this.dom.validationErrors = null;
                                    this.dom.additionalErrorsIndication.style.display = 'none';
                                }
                                // create the table with errors
                                // keep default behavior for parse errors
                                if (this.errorTableVisible && errors.length > 0) {
                                    var validationErrors = document.createElement('div');
                                    validationErrors.className = 'jsoneditor-validation-errors';
                                    var table = document.createElement('table');
                                    table.className = 'jsoneditor-text-errors';
                                    validationErrors.appendChild(table);
                                    var tbody = document.createElement('tbody');
                                    table.appendChild(tbody);
                                    errors.forEach(function(error) {
                                        var line;
                                        if (!isNaN(error.line)) line = error.line;
                                        else if (error.dataPath) {
                                            var errLoc = errorLocations.find(function(loc) {
                                                return loc.path === error.dataPath;
                                            });
                                            if (errLoc) line = errLoc.line + 1;
                                        }
                                        var trEl = document.createElement('tr');
                                        trEl.className = !isNaN(line) ? 'jump-to-line' : '';
                                        if (error.type === 'error') trEl.className += ' parse-error';
                                        else trEl.className += ' validation-error';
                                        var td1 = document.createElement('td');
                                        var button = document.createElement('button');
                                        button.className = 'jsoneditor-schema-error';
                                        td1.appendChild(button);
                                        trEl.appendChild(td1);
                                        var td2 = document.createElement('td');
                                        td2.style = 'white-space: nowrap;';
                                        td2.textContent = !isNaN(line) ? 'Ln ' + line : '';
                                        trEl.appendChild(td2);
                                        if (typeof error === 'string') {
                                            var td34 = document.createElement('td');
                                            td34.colSpan = 2;
                                            var pre = document.createElement('pre');
                                            pre.appendChild(document.createTextNode(error));
                                            td34.appendChild(pre);
                                            trEl.appendChild(td34);
                                        } else {
                                            var td3 = document.createElement('td');
                                            td3.appendChild(document.createTextNode(error.dataPath || ''));
                                            trEl.appendChild(td3);
                                            var td4 = document.createElement('td');
                                            var _pre = document.createElement('pre');
                                            _pre.appendChild(document.createTextNode(error.message.replace(/<br>/gi, '\n')));
                                            td4.appendChild(_pre);
                                            trEl.appendChild(td4);
                                        }
                                        trEl.onclick = function() {
                                            _this.onFocusLine(line);
                                        };
                                        tbody.appendChild(trEl);
                                    });
                                    this.dom.validationErrors = validationErrors;
                                    this.dom.validationErrorsContainer.appendChild(validationErrors);
                                    this.dom.additionalErrorsIndication.title = errors.length + ' errors total';
                                    if (this.dom.validationErrorsContainer.clientHeight < this.dom.validationErrorsContainer.scrollHeight) {
                                        this.dom.additionalErrorsIndication.style.display = 'block';
                                        this.dom.validationErrorsContainer.onscroll = function() {
                                            _this.dom.additionalErrorsIndication.style.display = _this.dom.validationErrorsContainer.clientHeight > 0 && _this.dom.validationErrorsContainer.scrollTop === 0 ? 'block' : 'none';
                                        };
                                    } else this.dom.validationErrorsContainer.onscroll = undefined;
                                    var height = this.dom.validationErrorsContainer.clientHeight + (this.dom.statusBar ? this.dom.statusBar.clientHeight : 0);
                                    // this.content.style.marginBottom = (-height) + 'px';
                                    // this.content.style.paddingBottom = height + 'px';
                                    this.onChangeHeight(height);
                                } else this.onChangeHeight(0);
                                // update the status bar
                                var validationErrorsCount = errors.filter(function(error) {
                                    return error.type !== 'error';
                                }).length;
                                if (validationErrorsCount > 0) {
                                    this.dom.validationErrorCount.style.display = 'inline';
                                    this.dom.validationErrorCount.innerText = validationErrorsCount;
                                    this.dom.validationErrorCount.onclick = this.toggleTableVisibility.bind(this);
                                    this.dom.validationErrorIcon.style.display = 'inline';
                                    this.dom.validationErrorIcon.title = validationErrorsCount + ' schema validation error(s) found';
                                    this.dom.validationErrorIcon.onclick = this.toggleTableVisibility.bind(this);
                                } else {
                                    this.dom.validationErrorCount.style.display = 'none';
                                    this.dom.validationErrorIcon.style.display = 'none';
                                }
                                // update the parse error icon
                                var hasParseErrors = errors.some(function(error) {
                                    return error.type === 'error';
                                });
                                if (hasParseErrors) {
                                    var line = errors[0].line;
                                    this.dom.parseErrorIndication.style.display = 'block';
                                    this.dom.parseErrorIndication.title = !isNaN(line) ? 'parse error on line ' + line : 'parse error - check that the json is valid';
                                    this.dom.parseErrorIndication.onclick = this.toggleTableVisibility.bind(this);
                                } else this.dom.parseErrorIndication.style.display = 'none';
                            }
                        }
                    ]);
                }();
            /***/ },
            /***/ 151: /***/ function(__unused_webpack_module, exports) {
                (function(exports) {
                    "use strict";
                    function isArray(obj) {
                        if (obj !== null) return Object.prototype.toString.call(obj) === "[object Array]";
                        else return false;
                    }
                    function isObject(obj) {
                        if (obj !== null) return Object.prototype.toString.call(obj) === "[object Object]";
                        else return false;
                    }
                    function strictDeepEqual(first, second) {
                        // Check the scalar case first.
                        if (first === second) return true;
                        // Check if they are the same type.
                        var firstType = Object.prototype.toString.call(first);
                        if (firstType !== Object.prototype.toString.call(second)) return false;
                        // We know that first and second have the same type so we can just check the
                        // first type from now on.
                        if (isArray(first) === true) {
                            // Short circuit if they're not the same length;
                            if (first.length !== second.length) return false;
                            for(var i = 0; i < first.length; i++){
                                if (strictDeepEqual(first[i], second[i]) === false) return false;
                            }
                            return true;
                        }
                        if (isObject(first) === true) {
                            // An object is equal if it has the same key/value pairs.
                            var keysSeen = {};
                            for(var key in first)if (hasOwnProperty.call(first, key)) {
                                if (strictDeepEqual(first[key], second[key]) === false) return false;
                                keysSeen[key] = true;
                            }
                            // Now check that there aren't any keys in second that weren't
                            // in first.
                            for(var key2 in second)if (hasOwnProperty.call(second, key2)) {
                                if (keysSeen[key2] !== true) return false;
                            }
                            return true;
                        }
                        return false;
                    }
                    function isFalse(obj) {
                        // From the spec:
                        // A false value corresponds to the following values:
                        // Empty list
                        // Empty object
                        // Empty string
                        // False boolean
                        // null value
                        // First check the scalar values.
                        if (obj === "" || obj === false || obj === null) return true;
                        else if (isArray(obj) && obj.length === 0) // Check for an empty array.
                        return true;
                        else if (isObject(obj)) {
                            // Check for an empty object.
                            for(var key in obj){
                                // If there are any keys, then
                                // the object is not empty so the object
                                // is not false.
                                if (obj.hasOwnProperty(key)) return false;
                            }
                            return true;
                        } else return false;
                    }
                    function objValues(obj) {
                        var keys = Object.keys(obj);
                        var values = [];
                        for(var i = 0; i < keys.length; i++)values.push(obj[keys[i]]);
                        return values;
                    }
                    function merge(a, b) {
                        var merged = {};
                        for(var key in a)merged[key] = a[key];
                        for(var key2 in b)merged[key2] = b[key2];
                        return merged;
                    }
                    var trimLeft;
                    if (typeof String.prototype.trimLeft === "function") trimLeft = function(str) {
                        return str.trimLeft();
                    };
                    else trimLeft = function(str) {
                        return str.match(/^\s*(.*)/)[1];
                    };
                    // Type constants used to define functions.
                    var TYPE_NUMBER = 0;
                    var TYPE_ANY = 1;
                    var TYPE_STRING = 2;
                    var TYPE_ARRAY = 3;
                    var TYPE_OBJECT = 4;
                    var TYPE_BOOLEAN = 5;
                    var TYPE_EXPREF = 6;
                    var TYPE_NULL = 7;
                    var TYPE_ARRAY_NUMBER = 8;
                    var TYPE_ARRAY_STRING = 9;
                    var TYPE_NAME_TABLE = {
                        0: 'number',
                        1: 'any',
                        2: 'string',
                        3: 'array',
                        4: 'object',
                        5: 'boolean',
                        6: 'expression',
                        7: 'null',
                        8: 'Array<number>',
                        9: 'Array<string>'
                    };
                    var TOK_EOF = "EOF";
                    var TOK_UNQUOTEDIDENTIFIER = "UnquotedIdentifier";
                    var TOK_QUOTEDIDENTIFIER = "QuotedIdentifier";
                    var TOK_RBRACKET = "Rbracket";
                    var TOK_RPAREN = "Rparen";
                    var TOK_COMMA = "Comma";
                    var TOK_COLON = "Colon";
                    var TOK_RBRACE = "Rbrace";
                    var TOK_NUMBER = "Number";
                    var TOK_CURRENT = "Current";
                    var TOK_EXPREF = "Expref";
                    var TOK_PIPE = "Pipe";
                    var TOK_OR = "Or";
                    var TOK_AND = "And";
                    var TOK_EQ = "EQ";
                    var TOK_GT = "GT";
                    var TOK_LT = "LT";
                    var TOK_GTE = "GTE";
                    var TOK_LTE = "LTE";
                    var TOK_NE = "NE";
                    var TOK_FLATTEN = "Flatten";
                    var TOK_STAR = "Star";
                    var TOK_FILTER = "Filter";
                    var TOK_DOT = "Dot";
                    var TOK_NOT = "Not";
                    var TOK_LBRACE = "Lbrace";
                    var TOK_LBRACKET = "Lbracket";
                    var TOK_LPAREN = "Lparen";
                    var TOK_LITERAL = "Literal";
                    // The "&", "[", "<", ">" tokens
                    // are not in basicToken because
                    // there are two token variants
                    // ("&&", "[?", "<=", ">=").  This is specially handled
                    // below.
                    var basicTokens = {
                        ".": TOK_DOT,
                        "*": TOK_STAR,
                        ",": TOK_COMMA,
                        ":": TOK_COLON,
                        "{": TOK_LBRACE,
                        "}": TOK_RBRACE,
                        "]": TOK_RBRACKET,
                        "(": TOK_LPAREN,
                        ")": TOK_RPAREN,
                        "@": TOK_CURRENT
                    };
                    var operatorStartToken = {
                        "<": true,
                        ">": true,
                        "=": true,
                        "!": true
                    };
                    var skipChars = {
                        " ": true,
                        "\t": true,
                        "\n": true
                    };
                    function isAlpha(ch) {
                        return ch >= "a" && ch <= "z" || ch >= "A" && ch <= "Z" || ch === "_";
                    }
                    function isNum(ch) {
                        return ch >= "0" && ch <= "9" || ch === "-";
                    }
                    function isAlphaNum(ch) {
                        return ch >= "a" && ch <= "z" || ch >= "A" && ch <= "Z" || ch >= "0" && ch <= "9" || ch === "_";
                    }
                    function Lexer() {}
                    Lexer.prototype = {
                        tokenize: function(stream) {
                            var tokens = [];
                            this._current = 0;
                            var start;
                            var identifier;
                            var token;
                            while(this._current < stream.length){
                                if (isAlpha(stream[this._current])) {
                                    start = this._current;
                                    identifier = this._consumeUnquotedIdentifier(stream);
                                    tokens.push({
                                        type: TOK_UNQUOTEDIDENTIFIER,
                                        value: identifier,
                                        start: start
                                    });
                                } else if (basicTokens[stream[this._current]] !== undefined) {
                                    tokens.push({
                                        type: basicTokens[stream[this._current]],
                                        value: stream[this._current],
                                        start: this._current
                                    });
                                    this._current++;
                                } else if (isNum(stream[this._current])) {
                                    token = this._consumeNumber(stream);
                                    tokens.push(token);
                                } else if (stream[this._current] === "[") {
                                    // No need to increment this._current.  This happens
                                    // in _consumeLBracket
                                    token = this._consumeLBracket(stream);
                                    tokens.push(token);
                                } else if (stream[this._current] === "\"") {
                                    start = this._current;
                                    identifier = this._consumeQuotedIdentifier(stream);
                                    tokens.push({
                                        type: TOK_QUOTEDIDENTIFIER,
                                        value: identifier,
                                        start: start
                                    });
                                } else if (stream[this._current] === "'") {
                                    start = this._current;
                                    identifier = this._consumeRawStringLiteral(stream);
                                    tokens.push({
                                        type: TOK_LITERAL,
                                        value: identifier,
                                        start: start
                                    });
                                } else if (stream[this._current] === "`") {
                                    start = this._current;
                                    var literal = this._consumeLiteral(stream);
                                    tokens.push({
                                        type: TOK_LITERAL,
                                        value: literal,
                                        start: start
                                    });
                                } else if (operatorStartToken[stream[this._current]] !== undefined) tokens.push(this._consumeOperator(stream));
                                else if (skipChars[stream[this._current]] !== undefined) // Ignore whitespace.
                                this._current++;
                                else if (stream[this._current] === "&") {
                                    start = this._current;
                                    this._current++;
                                    if (stream[this._current] === "&") {
                                        this._current++;
                                        tokens.push({
                                            type: TOK_AND,
                                            value: "&&",
                                            start: start
                                        });
                                    } else tokens.push({
                                        type: TOK_EXPREF,
                                        value: "&",
                                        start: start
                                    });
                                } else if (stream[this._current] === "|") {
                                    start = this._current;
                                    this._current++;
                                    if (stream[this._current] === "|") {
                                        this._current++;
                                        tokens.push({
                                            type: TOK_OR,
                                            value: "||",
                                            start: start
                                        });
                                    } else tokens.push({
                                        type: TOK_PIPE,
                                        value: "|",
                                        start: start
                                    });
                                } else {
                                    var error = new Error("Unknown character:" + stream[this._current]);
                                    error.name = "LexerError";
                                    throw error;
                                }
                            }
                            return tokens;
                        },
                        _consumeUnquotedIdentifier: function(stream) {
                            var start = this._current;
                            this._current++;
                            while(this._current < stream.length && isAlphaNum(stream[this._current]))this._current++;
                            return stream.slice(start, this._current);
                        },
                        _consumeQuotedIdentifier: function(stream) {
                            var start = this._current;
                            this._current++;
                            var maxLength = stream.length;
                            while(stream[this._current] !== "\"" && this._current < maxLength){
                                // You can escape a double quote and you can escape an escape.
                                var current = this._current;
                                if (stream[current] === "\\" && (stream[current + 1] === "\\" || stream[current + 1] === "\"")) current += 2;
                                else current++;
                                this._current = current;
                            }
                            this._current++;
                            return JSON.parse(stream.slice(start, this._current));
                        },
                        _consumeRawStringLiteral: function(stream) {
                            var start = this._current;
                            this._current++;
                            var maxLength = stream.length;
                            while(stream[this._current] !== "'" && this._current < maxLength){
                                // You can escape a single quote and you can escape an escape.
                                var current = this._current;
                                if (stream[current] === "\\" && (stream[current + 1] === "\\" || stream[current + 1] === "'")) current += 2;
                                else current++;
                                this._current = current;
                            }
                            this._current++;
                            var literal = stream.slice(start + 1, this._current - 1);
                            return literal.replace("\\'", "'");
                        },
                        _consumeNumber: function(stream) {
                            var start = this._current;
                            this._current++;
                            var maxLength = stream.length;
                            while(isNum(stream[this._current]) && this._current < maxLength)this._current++;
                            var value = parseInt(stream.slice(start, this._current));
                            return {
                                type: TOK_NUMBER,
                                value: value,
                                start: start
                            };
                        },
                        _consumeLBracket: function(stream) {
                            var start = this._current;
                            this._current++;
                            if (stream[this._current] === "?") {
                                this._current++;
                                return {
                                    type: TOK_FILTER,
                                    value: "[?",
                                    start: start
                                };
                            } else if (stream[this._current] === "]") {
                                this._current++;
                                return {
                                    type: TOK_FLATTEN,
                                    value: "[]",
                                    start: start
                                };
                            } else return {
                                type: TOK_LBRACKET,
                                value: "[",
                                start: start
                            };
                        },
                        _consumeOperator: function(stream) {
                            var start = this._current;
                            var startingChar = stream[start];
                            this._current++;
                            if (startingChar === "!") {
                                if (stream[this._current] === "=") {
                                    this._current++;
                                    return {
                                        type: TOK_NE,
                                        value: "!=",
                                        start: start
                                    };
                                } else return {
                                    type: TOK_NOT,
                                    value: "!",
                                    start: start
                                };
                            } else if (startingChar === "<") {
                                if (stream[this._current] === "=") {
                                    this._current++;
                                    return {
                                        type: TOK_LTE,
                                        value: "<=",
                                        start: start
                                    };
                                } else return {
                                    type: TOK_LT,
                                    value: "<",
                                    start: start
                                };
                            } else if (startingChar === ">") {
                                if (stream[this._current] === "=") {
                                    this._current++;
                                    return {
                                        type: TOK_GTE,
                                        value: ">=",
                                        start: start
                                    };
                                } else return {
                                    type: TOK_GT,
                                    value: ">",
                                    start: start
                                };
                            } else if (startingChar === "=") {
                                if (stream[this._current] === "=") {
                                    this._current++;
                                    return {
                                        type: TOK_EQ,
                                        value: "==",
                                        start: start
                                    };
                                }
                            }
                        },
                        _consumeLiteral: function(stream) {
                            this._current++;
                            var start = this._current;
                            var maxLength = stream.length;
                            var literal;
                            while(stream[this._current] !== "`" && this._current < maxLength){
                                // You can escape a literal char or you can escape the escape.
                                var current = this._current;
                                if (stream[current] === "\\" && (stream[current + 1] === "\\" || stream[current + 1] === "`")) current += 2;
                                else current++;
                                this._current = current;
                            }
                            var literalString = trimLeft(stream.slice(start, this._current));
                            literalString = literalString.replace("\\`", "`");
                            if (this._looksLikeJSON(literalString)) literal = JSON.parse(literalString);
                            else // Try to JSON parse it as "<literal>"
                            literal = JSON.parse("\"" + literalString + "\"");
                            // +1 gets us to the ending "`", +1 to move on to the next char.
                            this._current++;
                            return literal;
                        },
                        _looksLikeJSON: function(literalString) {
                            var startingChars = "[{\"";
                            var jsonLiterals = [
                                "true",
                                "false",
                                "null"
                            ];
                            var numberLooking = "-0123456789";
                            if (literalString === "") return false;
                            else if (startingChars.indexOf(literalString[0]) >= 0) return true;
                            else if (jsonLiterals.indexOf(literalString) >= 0) return true;
                            else if (numberLooking.indexOf(literalString[0]) >= 0) try {
                                JSON.parse(literalString);
                                return true;
                            } catch (ex) {
                                return false;
                            }
                            else return false;
                        }
                    };
                    var bindingPower = {};
                    bindingPower[TOK_EOF] = 0;
                    bindingPower[TOK_UNQUOTEDIDENTIFIER] = 0;
                    bindingPower[TOK_QUOTEDIDENTIFIER] = 0;
                    bindingPower[TOK_RBRACKET] = 0;
                    bindingPower[TOK_RPAREN] = 0;
                    bindingPower[TOK_COMMA] = 0;
                    bindingPower[TOK_RBRACE] = 0;
                    bindingPower[TOK_NUMBER] = 0;
                    bindingPower[TOK_CURRENT] = 0;
                    bindingPower[TOK_EXPREF] = 0;
                    bindingPower[TOK_PIPE] = 1;
                    bindingPower[TOK_OR] = 2;
                    bindingPower[TOK_AND] = 3;
                    bindingPower[TOK_EQ] = 5;
                    bindingPower[TOK_GT] = 5;
                    bindingPower[TOK_LT] = 5;
                    bindingPower[TOK_GTE] = 5;
                    bindingPower[TOK_LTE] = 5;
                    bindingPower[TOK_NE] = 5;
                    bindingPower[TOK_FLATTEN] = 9;
                    bindingPower[TOK_STAR] = 20;
                    bindingPower[TOK_FILTER] = 21;
                    bindingPower[TOK_DOT] = 40;
                    bindingPower[TOK_NOT] = 45;
                    bindingPower[TOK_LBRACE] = 50;
                    bindingPower[TOK_LBRACKET] = 55;
                    bindingPower[TOK_LPAREN] = 60;
                    function Parser() {}
                    Parser.prototype = {
                        parse: function(expression) {
                            this._loadTokens(expression);
                            this.index = 0;
                            var ast = this.expression(0);
                            if (this._lookahead(0) !== TOK_EOF) {
                                var t = this._lookaheadToken(0);
                                var error = new Error("Unexpected token type: " + t.type + ", value: " + t.value);
                                error.name = "ParserError";
                                throw error;
                            }
                            return ast;
                        },
                        _loadTokens: function(expression) {
                            var lexer = new Lexer();
                            var tokens = lexer.tokenize(expression);
                            tokens.push({
                                type: TOK_EOF,
                                value: "",
                                start: expression.length
                            });
                            this.tokens = tokens;
                        },
                        expression: function(rbp) {
                            var leftToken = this._lookaheadToken(0);
                            this._advance();
                            var left = this.nud(leftToken);
                            var currentToken = this._lookahead(0);
                            while(rbp < bindingPower[currentToken]){
                                this._advance();
                                left = this.led(currentToken, left);
                                currentToken = this._lookahead(0);
                            }
                            return left;
                        },
                        _lookahead: function(number) {
                            return this.tokens[this.index + number].type;
                        },
                        _lookaheadToken: function(number) {
                            return this.tokens[this.index + number];
                        },
                        _advance: function() {
                            this.index++;
                        },
                        nud: function(token) {
                            var left;
                            var right;
                            var expression;
                            switch(token.type){
                                case TOK_LITERAL:
                                    return {
                                        type: "Literal",
                                        value: token.value
                                    };
                                case TOK_UNQUOTEDIDENTIFIER:
                                    return {
                                        type: "Field",
                                        name: token.value
                                    };
                                case TOK_QUOTEDIDENTIFIER:
                                    var node = {
                                        type: "Field",
                                        name: token.value
                                    };
                                    if (this._lookahead(0) === TOK_LPAREN) throw new Error("Quoted identifier not allowed for function names.");
                                    return node;
                                case TOK_NOT:
                                    right = this.expression(bindingPower.Not);
                                    return {
                                        type: "NotExpression",
                                        children: [
                                            right
                                        ]
                                    };
                                case TOK_STAR:
                                    left = {
                                        type: "Identity"
                                    };
                                    right = null;
                                    if (this._lookahead(0) === TOK_RBRACKET) // This can happen in a multiselect,
                                    // [a, b, *]
                                    right = {
                                        type: "Identity"
                                    };
                                    else right = this._parseProjectionRHS(bindingPower.Star);
                                    return {
                                        type: "ValueProjection",
                                        children: [
                                            left,
                                            right
                                        ]
                                    };
                                case TOK_FILTER:
                                    return this.led(token.type, {
                                        type: "Identity"
                                    });
                                case TOK_LBRACE:
                                    return this._parseMultiselectHash();
                                case TOK_FLATTEN:
                                    left = {
                                        type: TOK_FLATTEN,
                                        children: [
                                            {
                                                type: "Identity"
                                            }
                                        ]
                                    };
                                    right = this._parseProjectionRHS(bindingPower.Flatten);
                                    return {
                                        type: "Projection",
                                        children: [
                                            left,
                                            right
                                        ]
                                    };
                                case TOK_LBRACKET:
                                    if (this._lookahead(0) === TOK_NUMBER || this._lookahead(0) === TOK_COLON) {
                                        right = this._parseIndexExpression();
                                        return this._projectIfSlice({
                                            type: "Identity"
                                        }, right);
                                    } else if (this._lookahead(0) === TOK_STAR && this._lookahead(1) === TOK_RBRACKET) {
                                        this._advance();
                                        this._advance();
                                        right = this._parseProjectionRHS(bindingPower.Star);
                                        return {
                                            type: "Projection",
                                            children: [
                                                {
                                                    type: "Identity"
                                                },
                                                right
                                            ]
                                        };
                                    }
                                    return this._parseMultiselectList();
                                case TOK_CURRENT:
                                    return {
                                        type: TOK_CURRENT
                                    };
                                case TOK_EXPREF:
                                    expression = this.expression(bindingPower.Expref);
                                    return {
                                        type: "ExpressionReference",
                                        children: [
                                            expression
                                        ]
                                    };
                                case TOK_LPAREN:
                                    var args = [];
                                    while(this._lookahead(0) !== TOK_RPAREN){
                                        if (this._lookahead(0) === TOK_CURRENT) {
                                            expression = {
                                                type: TOK_CURRENT
                                            };
                                            this._advance();
                                        } else expression = this.expression(0);
                                        args.push(expression);
                                    }
                                    this._match(TOK_RPAREN);
                                    return args[0];
                                default:
                                    this._errorToken(token);
                            }
                        },
                        led: function(tokenName, left) {
                            var right;
                            switch(tokenName){
                                case TOK_DOT:
                                    var rbp = bindingPower.Dot;
                                    if (this._lookahead(0) !== TOK_STAR) {
                                        right = this._parseDotRHS(rbp);
                                        return {
                                            type: "Subexpression",
                                            children: [
                                                left,
                                                right
                                            ]
                                        };
                                    }
                                    // Creating a projection.
                                    this._advance();
                                    right = this._parseProjectionRHS(rbp);
                                    return {
                                        type: "ValueProjection",
                                        children: [
                                            left,
                                            right
                                        ]
                                    };
                                case TOK_PIPE:
                                    right = this.expression(bindingPower.Pipe);
                                    return {
                                        type: TOK_PIPE,
                                        children: [
                                            left,
                                            right
                                        ]
                                    };
                                case TOK_OR:
                                    right = this.expression(bindingPower.Or);
                                    return {
                                        type: "OrExpression",
                                        children: [
                                            left,
                                            right
                                        ]
                                    };
                                case TOK_AND:
                                    right = this.expression(bindingPower.And);
                                    return {
                                        type: "AndExpression",
                                        children: [
                                            left,
                                            right
                                        ]
                                    };
                                case TOK_LPAREN:
                                    var name = left.name;
                                    var args = [];
                                    var expression, node;
                                    while(this._lookahead(0) !== TOK_RPAREN){
                                        if (this._lookahead(0) === TOK_CURRENT) {
                                            expression = {
                                                type: TOK_CURRENT
                                            };
                                            this._advance();
                                        } else expression = this.expression(0);
                                        if (this._lookahead(0) === TOK_COMMA) this._match(TOK_COMMA);
                                        args.push(expression);
                                    }
                                    this._match(TOK_RPAREN);
                                    node = {
                                        type: "Function",
                                        name: name,
                                        children: args
                                    };
                                    return node;
                                case TOK_FILTER:
                                    var condition = this.expression(0);
                                    this._match(TOK_RBRACKET);
                                    if (this._lookahead(0) === TOK_FLATTEN) right = {
                                        type: "Identity"
                                    };
                                    else right = this._parseProjectionRHS(bindingPower.Filter);
                                    return {
                                        type: "FilterProjection",
                                        children: [
                                            left,
                                            right,
                                            condition
                                        ]
                                    };
                                case TOK_FLATTEN:
                                    var leftNode = {
                                        type: TOK_FLATTEN,
                                        children: [
                                            left
                                        ]
                                    };
                                    var rightNode = this._parseProjectionRHS(bindingPower.Flatten);
                                    return {
                                        type: "Projection",
                                        children: [
                                            leftNode,
                                            rightNode
                                        ]
                                    };
                                case TOK_EQ:
                                case TOK_NE:
                                case TOK_GT:
                                case TOK_GTE:
                                case TOK_LT:
                                case TOK_LTE:
                                    return this._parseComparator(left, tokenName);
                                case TOK_LBRACKET:
                                    var token = this._lookaheadToken(0);
                                    if (token.type === TOK_NUMBER || token.type === TOK_COLON) {
                                        right = this._parseIndexExpression();
                                        return this._projectIfSlice(left, right);
                                    }
                                    this._match(TOK_STAR);
                                    this._match(TOK_RBRACKET);
                                    right = this._parseProjectionRHS(bindingPower.Star);
                                    return {
                                        type: "Projection",
                                        children: [
                                            left,
                                            right
                                        ]
                                    };
                                default:
                                    this._errorToken(this._lookaheadToken(0));
                            }
                        },
                        _match: function(tokenType) {
                            if (this._lookahead(0) === tokenType) this._advance();
                            else {
                                var t = this._lookaheadToken(0);
                                var error = new Error("Expected " + tokenType + ", got: " + t.type);
                                error.name = "ParserError";
                                throw error;
                            }
                        },
                        _errorToken: function(token) {
                            var error = new Error("Invalid token (" + token.type + "): \"" + token.value + "\"");
                            error.name = "ParserError";
                            throw error;
                        },
                        _parseIndexExpression: function() {
                            if (this._lookahead(0) === TOK_COLON || this._lookahead(1) === TOK_COLON) return this._parseSliceExpression();
                            else {
                                var node = {
                                    type: "Index",
                                    value: this._lookaheadToken(0).value
                                };
                                this._advance();
                                this._match(TOK_RBRACKET);
                                return node;
                            }
                        },
                        _projectIfSlice: function(left, right) {
                            var indexExpr = {
                                type: "IndexExpression",
                                children: [
                                    left,
                                    right
                                ]
                            };
                            if (right.type === "Slice") return {
                                type: "Projection",
                                children: [
                                    indexExpr,
                                    this._parseProjectionRHS(bindingPower.Star)
                                ]
                            };
                            else return indexExpr;
                        },
                        _parseSliceExpression: function() {
                            // [start:end:step] where each part is optional, as well as the last
                            // colon.
                            var parts = [
                                null,
                                null,
                                null
                            ];
                            var index = 0;
                            var currentToken = this._lookahead(0);
                            while(currentToken !== TOK_RBRACKET && index < 3){
                                if (currentToken === TOK_COLON) {
                                    index++;
                                    this._advance();
                                } else if (currentToken === TOK_NUMBER) {
                                    parts[index] = this._lookaheadToken(0).value;
                                    this._advance();
                                } else {
                                    var t = this._lookahead(0);
                                    var error = new Error("Syntax error, unexpected token: " + t.value + "(" + t.type + ")");
                                    error.name = "Parsererror";
                                    throw error;
                                }
                                currentToken = this._lookahead(0);
                            }
                            this._match(TOK_RBRACKET);
                            return {
                                type: "Slice",
                                children: parts
                            };
                        },
                        _parseComparator: function(left, comparator) {
                            var right = this.expression(bindingPower[comparator]);
                            return {
                                type: "Comparator",
                                name: comparator,
                                children: [
                                    left,
                                    right
                                ]
                            };
                        },
                        _parseDotRHS: function(rbp) {
                            var lookahead = this._lookahead(0);
                            var exprTokens = [
                                TOK_UNQUOTEDIDENTIFIER,
                                TOK_QUOTEDIDENTIFIER,
                                TOK_STAR
                            ];
                            if (exprTokens.indexOf(lookahead) >= 0) return this.expression(rbp);
                            else if (lookahead === TOK_LBRACKET) {
                                this._match(TOK_LBRACKET);
                                return this._parseMultiselectList();
                            } else if (lookahead === TOK_LBRACE) {
                                this._match(TOK_LBRACE);
                                return this._parseMultiselectHash();
                            }
                        },
                        _parseProjectionRHS: function(rbp) {
                            var right;
                            if (bindingPower[this._lookahead(0)] < 10) right = {
                                type: "Identity"
                            };
                            else if (this._lookahead(0) === TOK_LBRACKET) right = this.expression(rbp);
                            else if (this._lookahead(0) === TOK_FILTER) right = this.expression(rbp);
                            else if (this._lookahead(0) === TOK_DOT) {
                                this._match(TOK_DOT);
                                right = this._parseDotRHS(rbp);
                            } else {
                                var t = this._lookaheadToken(0);
                                var error = new Error("Sytanx error, unexpected token: " + t.value + "(" + t.type + ")");
                                error.name = "ParserError";
                                throw error;
                            }
                            return right;
                        },
                        _parseMultiselectList: function() {
                            var expressions = [];
                            while(this._lookahead(0) !== TOK_RBRACKET){
                                var expression = this.expression(0);
                                expressions.push(expression);
                                if (this._lookahead(0) === TOK_COMMA) {
                                    this._match(TOK_COMMA);
                                    if (this._lookahead(0) === TOK_RBRACKET) throw new Error("Unexpected token Rbracket");
                                }
                            }
                            this._match(TOK_RBRACKET);
                            return {
                                type: "MultiSelectList",
                                children: expressions
                            };
                        },
                        _parseMultiselectHash: function() {
                            var pairs = [];
                            var identifierTypes = [
                                TOK_UNQUOTEDIDENTIFIER,
                                TOK_QUOTEDIDENTIFIER
                            ];
                            var keyToken, keyName, value, node;
                            for(;;){
                                keyToken = this._lookaheadToken(0);
                                if (identifierTypes.indexOf(keyToken.type) < 0) throw new Error("Expecting an identifier token, got: " + keyToken.type);
                                keyName = keyToken.value;
                                this._advance();
                                this._match(TOK_COLON);
                                value = this.expression(0);
                                node = {
                                    type: "KeyValuePair",
                                    name: keyName,
                                    value: value
                                };
                                pairs.push(node);
                                if (this._lookahead(0) === TOK_COMMA) this._match(TOK_COMMA);
                                else if (this._lookahead(0) === TOK_RBRACE) {
                                    this._match(TOK_RBRACE);
                                    break;
                                }
                            }
                            return {
                                type: "MultiSelectHash",
                                children: pairs
                            };
                        }
                    };
                    function TreeInterpreter(runtime) {
                        this.runtime = runtime;
                    }
                    TreeInterpreter.prototype = {
                        search: function(node, value) {
                            return this.visit(node, value);
                        },
                        visit: function(node, value) {
                            var matched, current, result, first, second, field, left, right, collected, i;
                            switch(node.type){
                                case "Field":
                                    if (value !== null && isObject(value)) {
                                        field = value[node.name];
                                        if (field === undefined) return null;
                                        else return field;
                                    }
                                    return null;
                                case "Subexpression":
                                    result = this.visit(node.children[0], value);
                                    for(i = 1; i < node.children.length; i++){
                                        result = this.visit(node.children[1], result);
                                        if (result === null) return null;
                                    }
                                    return result;
                                case "IndexExpression":
                                    left = this.visit(node.children[0], value);
                                    right = this.visit(node.children[1], left);
                                    return right;
                                case "Index":
                                    if (!isArray(value)) return null;
                                    var index = node.value;
                                    if (index < 0) index = value.length + index;
                                    result = value[index];
                                    if (result === undefined) result = null;
                                    return result;
                                case "Slice":
                                    if (!isArray(value)) return null;
                                    var sliceParams = node.children.slice(0);
                                    var computed = this.computeSliceParams(value.length, sliceParams);
                                    var start = computed[0];
                                    var stop = computed[1];
                                    var step = computed[2];
                                    result = [];
                                    if (step > 0) for(i = start; i < stop; i += step)result.push(value[i]);
                                    else for(i = start; i > stop; i += step)result.push(value[i]);
                                    return result;
                                case "Projection":
                                    // Evaluate left child.
                                    var base = this.visit(node.children[0], value);
                                    if (!isArray(base)) return null;
                                    collected = [];
                                    for(i = 0; i < base.length; i++){
                                        current = this.visit(node.children[1], base[i]);
                                        if (current !== null) collected.push(current);
                                    }
                                    return collected;
                                case "ValueProjection":
                                    // Evaluate left child.
                                    base = this.visit(node.children[0], value);
                                    if (!isObject(base)) return null;
                                    collected = [];
                                    var values = objValues(base);
                                    for(i = 0; i < values.length; i++){
                                        current = this.visit(node.children[1], values[i]);
                                        if (current !== null) collected.push(current);
                                    }
                                    return collected;
                                case "FilterProjection":
                                    base = this.visit(node.children[0], value);
                                    if (!isArray(base)) return null;
                                    var filtered = [];
                                    var finalResults = [];
                                    for(i = 0; i < base.length; i++){
                                        matched = this.visit(node.children[2], base[i]);
                                        if (!isFalse(matched)) filtered.push(base[i]);
                                    }
                                    for(var j = 0; j < filtered.length; j++){
                                        current = this.visit(node.children[1], filtered[j]);
                                        if (current !== null) finalResults.push(current);
                                    }
                                    return finalResults;
                                case "Comparator":
                                    first = this.visit(node.children[0], value);
                                    second = this.visit(node.children[1], value);
                                    switch(node.name){
                                        case TOK_EQ:
                                            result = strictDeepEqual(first, second);
                                            break;
                                        case TOK_NE:
                                            result = !strictDeepEqual(first, second);
                                            break;
                                        case TOK_GT:
                                            result = first > second;
                                            break;
                                        case TOK_GTE:
                                            result = first >= second;
                                            break;
                                        case TOK_LT:
                                            result = first < second;
                                            break;
                                        case TOK_LTE:
                                            result = first <= second;
                                            break;
                                        default:
                                            throw new Error("Unknown comparator: " + node.name);
                                    }
                                    return result;
                                case TOK_FLATTEN:
                                    var original = this.visit(node.children[0], value);
                                    if (!isArray(original)) return null;
                                    var merged = [];
                                    for(i = 0; i < original.length; i++){
                                        current = original[i];
                                        if (isArray(current)) merged.push.apply(merged, current);
                                        else merged.push(current);
                                    }
                                    return merged;
                                case "Identity":
                                    return value;
                                case "MultiSelectList":
                                    if (value === null) return null;
                                    collected = [];
                                    for(i = 0; i < node.children.length; i++)collected.push(this.visit(node.children[i], value));
                                    return collected;
                                case "MultiSelectHash":
                                    if (value === null) return null;
                                    collected = {};
                                    var child;
                                    for(i = 0; i < node.children.length; i++){
                                        child = node.children[i];
                                        collected[child.name] = this.visit(child.value, value);
                                    }
                                    return collected;
                                case "OrExpression":
                                    matched = this.visit(node.children[0], value);
                                    if (isFalse(matched)) matched = this.visit(node.children[1], value);
                                    return matched;
                                case "AndExpression":
                                    first = this.visit(node.children[0], value);
                                    if (isFalse(first) === true) return first;
                                    return this.visit(node.children[1], value);
                                case "NotExpression":
                                    first = this.visit(node.children[0], value);
                                    return isFalse(first);
                                case "Literal":
                                    return node.value;
                                case TOK_PIPE:
                                    left = this.visit(node.children[0], value);
                                    return this.visit(node.children[1], left);
                                case TOK_CURRENT:
                                    return value;
                                case "Function":
                                    var resolvedArgs = [];
                                    for(i = 0; i < node.children.length; i++)resolvedArgs.push(this.visit(node.children[i], value));
                                    return this.runtime.callFunction(node.name, resolvedArgs);
                                case "ExpressionReference":
                                    var refNode = node.children[0];
                                    // Tag the node with a specific attribute so the type
                                    // checker verify the type.
                                    refNode.jmespathType = TOK_EXPREF;
                                    return refNode;
                                default:
                                    throw new Error("Unknown node type: " + node.type);
                            }
                        },
                        computeSliceParams: function(arrayLength, sliceParams) {
                            var start = sliceParams[0];
                            var stop = sliceParams[1];
                            var step = sliceParams[2];
                            var computed = [
                                null,
                                null,
                                null
                            ];
                            if (step === null) step = 1;
                            else if (step === 0) {
                                var error = new Error("Invalid slice, step cannot be 0");
                                error.name = "RuntimeError";
                                throw error;
                            }
                            var stepValueNegative = step < 0 ? true : false;
                            if (start === null) start = stepValueNegative ? arrayLength - 1 : 0;
                            else start = this.capSliceRange(arrayLength, start, step);
                            if (stop === null) stop = stepValueNegative ? -1 : arrayLength;
                            else stop = this.capSliceRange(arrayLength, stop, step);
                            computed[0] = start;
                            computed[1] = stop;
                            computed[2] = step;
                            return computed;
                        },
                        capSliceRange: function(arrayLength, actualValue, step) {
                            if (actualValue < 0) {
                                actualValue += arrayLength;
                                if (actualValue < 0) actualValue = step < 0 ? -1 : 0;
                            } else if (actualValue >= arrayLength) actualValue = step < 0 ? arrayLength - 1 : arrayLength;
                            return actualValue;
                        }
                    };
                    function Runtime(interpreter) {
                        this._interpreter = interpreter;
                        this.functionTable = {
                            // name: [function, <signature>]
                            // The <signature> can be:
                            //
                            // {
                            //   args: [[type1, type2], [type1, type2]],
                            //   variadic: true|false
                            // }
                            //
                            // Each arg in the arg list is a list of valid types
                            // (if the function is overloaded and supports multiple
                            // types.  If the type is "any" then no type checking
                            // occurs on the argument.  Variadic is optional
                            // and if not provided is assumed to be false.
                            abs: {
                                _func: this._functionAbs,
                                _signature: [
                                    {
                                        types: [
                                            TYPE_NUMBER
                                        ]
                                    }
                                ]
                            },
                            avg: {
                                _func: this._functionAvg,
                                _signature: [
                                    {
                                        types: [
                                            TYPE_ARRAY_NUMBER
                                        ]
                                    }
                                ]
                            },
                            ceil: {
                                _func: this._functionCeil,
                                _signature: [
                                    {
                                        types: [
                                            TYPE_NUMBER
                                        ]
                                    }
                                ]
                            },
                            contains: {
                                _func: this._functionContains,
                                _signature: [
                                    {
                                        types: [
                                            TYPE_STRING,
                                            TYPE_ARRAY
                                        ]
                                    },
                                    {
                                        types: [
                                            TYPE_ANY
                                        ]
                                    }
                                ]
                            },
                            "ends_with": {
                                _func: this._functionEndsWith,
                                _signature: [
                                    {
                                        types: [
                                            TYPE_STRING
                                        ]
                                    },
                                    {
                                        types: [
                                            TYPE_STRING
                                        ]
                                    }
                                ]
                            },
                            floor: {
                                _func: this._functionFloor,
                                _signature: [
                                    {
                                        types: [
                                            TYPE_NUMBER
                                        ]
                                    }
                                ]
                            },
                            length: {
                                _func: this._functionLength,
                                _signature: [
                                    {
                                        types: [
                                            TYPE_STRING,
                                            TYPE_ARRAY,
                                            TYPE_OBJECT
                                        ]
                                    }
                                ]
                            },
                            map: {
                                _func: this._functionMap,
                                _signature: [
                                    {
                                        types: [
                                            TYPE_EXPREF
                                        ]
                                    },
                                    {
                                        types: [
                                            TYPE_ARRAY
                                        ]
                                    }
                                ]
                            },
                            max: {
                                _func: this._functionMax,
                                _signature: [
                                    {
                                        types: [
                                            TYPE_ARRAY_NUMBER,
                                            TYPE_ARRAY_STRING
                                        ]
                                    }
                                ]
                            },
                            "merge": {
                                _func: this._functionMerge,
                                _signature: [
                                    {
                                        types: [
                                            TYPE_OBJECT
                                        ],
                                        variadic: true
                                    }
                                ]
                            },
                            "max_by": {
                                _func: this._functionMaxBy,
                                _signature: [
                                    {
                                        types: [
                                            TYPE_ARRAY
                                        ]
                                    },
                                    {
                                        types: [
                                            TYPE_EXPREF
                                        ]
                                    }
                                ]
                            },
                            sum: {
                                _func: this._functionSum,
                                _signature: [
                                    {
                                        types: [
                                            TYPE_ARRAY_NUMBER
                                        ]
                                    }
                                ]
                            },
                            "starts_with": {
                                _func: this._functionStartsWith,
                                _signature: [
                                    {
                                        types: [
                                            TYPE_STRING
                                        ]
                                    },
                                    {
                                        types: [
                                            TYPE_STRING
                                        ]
                                    }
                                ]
                            },
                            min: {
                                _func: this._functionMin,
                                _signature: [
                                    {
                                        types: [
                                            TYPE_ARRAY_NUMBER,
                                            TYPE_ARRAY_STRING
                                        ]
                                    }
                                ]
                            },
                            "min_by": {
                                _func: this._functionMinBy,
                                _signature: [
                                    {
                                        types: [
                                            TYPE_ARRAY
                                        ]
                                    },
                                    {
                                        types: [
                                            TYPE_EXPREF
                                        ]
                                    }
                                ]
                            },
                            type: {
                                _func: this._functionType,
                                _signature: [
                                    {
                                        types: [
                                            TYPE_ANY
                                        ]
                                    }
                                ]
                            },
                            keys: {
                                _func: this._functionKeys,
                                _signature: [
                                    {
                                        types: [
                                            TYPE_OBJECT
                                        ]
                                    }
                                ]
                            },
                            values: {
                                _func: this._functionValues,
                                _signature: [
                                    {
                                        types: [
                                            TYPE_OBJECT
                                        ]
                                    }
                                ]
                            },
                            sort: {
                                _func: this._functionSort,
                                _signature: [
                                    {
                                        types: [
                                            TYPE_ARRAY_STRING,
                                            TYPE_ARRAY_NUMBER
                                        ]
                                    }
                                ]
                            },
                            "sort_by": {
                                _func: this._functionSortBy,
                                _signature: [
                                    {
                                        types: [
                                            TYPE_ARRAY
                                        ]
                                    },
                                    {
                                        types: [
                                            TYPE_EXPREF
                                        ]
                                    }
                                ]
                            },
                            join: {
                                _func: this._functionJoin,
                                _signature: [
                                    {
                                        types: [
                                            TYPE_STRING
                                        ]
                                    },
                                    {
                                        types: [
                                            TYPE_ARRAY_STRING
                                        ]
                                    }
                                ]
                            },
                            reverse: {
                                _func: this._functionReverse,
                                _signature: [
                                    {
                                        types: [
                                            TYPE_STRING,
                                            TYPE_ARRAY
                                        ]
                                    }
                                ]
                            },
                            "to_array": {
                                _func: this._functionToArray,
                                _signature: [
                                    {
                                        types: [
                                            TYPE_ANY
                                        ]
                                    }
                                ]
                            },
                            "to_string": {
                                _func: this._functionToString,
                                _signature: [
                                    {
                                        types: [
                                            TYPE_ANY
                                        ]
                                    }
                                ]
                            },
                            "to_number": {
                                _func: this._functionToNumber,
                                _signature: [
                                    {
                                        types: [
                                            TYPE_ANY
                                        ]
                                    }
                                ]
                            },
                            "not_null": {
                                _func: this._functionNotNull,
                                _signature: [
                                    {
                                        types: [
                                            TYPE_ANY
                                        ],
                                        variadic: true
                                    }
                                ]
                            }
                        };
                    }
                    Runtime.prototype = {
                        callFunction: function(name, resolvedArgs) {
                            var functionEntry = this.functionTable[name];
                            if (functionEntry === undefined) throw new Error("Unknown function: " + name + "()");
                            this._validateArgs(name, resolvedArgs, functionEntry._signature);
                            return functionEntry._func.call(this, resolvedArgs);
                        },
                        _validateArgs: function(name, args, signature) {
                            // Validating the args requires validating
                            // the correct arity and the correct type of each arg.
                            // If the last argument is declared as variadic, then we need
                            // a minimum number of args to be required.  Otherwise it has to
                            // be an exact amount.
                            var pluralized;
                            if (signature[signature.length - 1].variadic) {
                                if (args.length < signature.length) {
                                    pluralized = signature.length === 1 ? " argument" : " arguments";
                                    throw new Error("ArgumentError: " + name + "() " + "takes at least" + signature.length + pluralized + " but received " + args.length);
                                }
                            } else if (args.length !== signature.length) {
                                pluralized = signature.length === 1 ? " argument" : " arguments";
                                throw new Error("ArgumentError: " + name + "() " + "takes " + signature.length + pluralized + " but received " + args.length);
                            }
                            var currentSpec;
                            var actualType;
                            var typeMatched;
                            for(var i = 0; i < signature.length; i++){
                                typeMatched = false;
                                currentSpec = signature[i].types;
                                actualType = this._getTypeName(args[i]);
                                for(var j = 0; j < currentSpec.length; j++)if (this._typeMatches(actualType, currentSpec[j], args[i])) {
                                    typeMatched = true;
                                    break;
                                }
                                if (!typeMatched) {
                                    var expected = currentSpec.map(function(typeIdentifier) {
                                        return TYPE_NAME_TABLE[typeIdentifier];
                                    }).join(',');
                                    throw new Error("TypeError: " + name + "() " + "expected argument " + (i + 1) + " to be type " + expected + " but received type " + TYPE_NAME_TABLE[actualType] + " instead.");
                                }
                            }
                        },
                        _typeMatches: function(actual, expected, argValue) {
                            if (expected === TYPE_ANY) return true;
                            if (expected === TYPE_ARRAY_STRING || expected === TYPE_ARRAY_NUMBER || expected === TYPE_ARRAY) {
                                // The expected type can either just be array,
                                // or it can require a specific subtype (array of numbers).
                                //
                                // The simplest case is if "array" with no subtype is specified.
                                if (expected === TYPE_ARRAY) return actual === TYPE_ARRAY;
                                else if (actual === TYPE_ARRAY) {
                                    // Otherwise we need to check subtypes.
                                    // I think this has potential to be improved.
                                    var subtype;
                                    if (expected === TYPE_ARRAY_NUMBER) subtype = TYPE_NUMBER;
                                    else if (expected === TYPE_ARRAY_STRING) subtype = TYPE_STRING;
                                    for(var i = 0; i < argValue.length; i++){
                                        if (!this._typeMatches(this._getTypeName(argValue[i]), subtype, argValue[i])) return false;
                                    }
                                    return true;
                                }
                            } else return actual === expected;
                        },
                        _getTypeName: function(obj) {
                            switch(Object.prototype.toString.call(obj)){
                                case "[object String]":
                                    return TYPE_STRING;
                                case "[object Number]":
                                    return TYPE_NUMBER;
                                case "[object Array]":
                                    return TYPE_ARRAY;
                                case "[object Boolean]":
                                    return TYPE_BOOLEAN;
                                case "[object Null]":
                                    return TYPE_NULL;
                                case "[object Object]":
                                    // Check if it's an expref.  If it has, it's been
                                    // tagged with a jmespathType attr of 'Expref';
                                    if (obj.jmespathType === TOK_EXPREF) return TYPE_EXPREF;
                                    else return TYPE_OBJECT;
                            }
                        },
                        _functionStartsWith: function(resolvedArgs) {
                            return resolvedArgs[0].lastIndexOf(resolvedArgs[1]) === 0;
                        },
                        _functionEndsWith: function(resolvedArgs) {
                            var searchStr = resolvedArgs[0];
                            var suffix = resolvedArgs[1];
                            return searchStr.indexOf(suffix, searchStr.length - suffix.length) !== -1;
                        },
                        _functionReverse: function(resolvedArgs) {
                            var typeName = this._getTypeName(resolvedArgs[0]);
                            if (typeName === TYPE_STRING) {
                                var originalStr = resolvedArgs[0];
                                var reversedStr = "";
                                for(var i = originalStr.length - 1; i >= 0; i--)reversedStr += originalStr[i];
                                return reversedStr;
                            } else {
                                var reversedArray = resolvedArgs[0].slice(0);
                                reversedArray.reverse();
                                return reversedArray;
                            }
                        },
                        _functionAbs: function(resolvedArgs) {
                            return Math.abs(resolvedArgs[0]);
                        },
                        _functionCeil: function(resolvedArgs) {
                            return Math.ceil(resolvedArgs[0]);
                        },
                        _functionAvg: function(resolvedArgs) {
                            var sum = 0;
                            var inputArray = resolvedArgs[0];
                            for(var i = 0; i < inputArray.length; i++)sum += inputArray[i];
                            return sum / inputArray.length;
                        },
                        _functionContains: function(resolvedArgs) {
                            return resolvedArgs[0].indexOf(resolvedArgs[1]) >= 0;
                        },
                        _functionFloor: function(resolvedArgs) {
                            return Math.floor(resolvedArgs[0]);
                        },
                        _functionLength: function(resolvedArgs) {
                            if (!isObject(resolvedArgs[0])) return resolvedArgs[0].length;
                            else // As far as I can tell, there's no way to get the length
                            // of an object without O(n) iteration through the object.
                            return Object.keys(resolvedArgs[0]).length;
                        },
                        _functionMap: function(resolvedArgs) {
                            var mapped = [];
                            var interpreter = this._interpreter;
                            var exprefNode = resolvedArgs[0];
                            var elements = resolvedArgs[1];
                            for(var i = 0; i < elements.length; i++)mapped.push(interpreter.visit(exprefNode, elements[i]));
                            return mapped;
                        },
                        _functionMerge: function(resolvedArgs) {
                            var merged = {};
                            for(var i = 0; i < resolvedArgs.length; i++){
                                var current = resolvedArgs[i];
                                for(var key in current)merged[key] = current[key];
                            }
                            return merged;
                        },
                        _functionMax: function(resolvedArgs) {
                            if (resolvedArgs[0].length > 0) {
                                var typeName = this._getTypeName(resolvedArgs[0][0]);
                                if (typeName === TYPE_NUMBER) return Math.max.apply(Math, resolvedArgs[0]);
                                else {
                                    var elements = resolvedArgs[0];
                                    var maxElement = elements[0];
                                    for(var i = 1; i < elements.length; i++)if (maxElement.localeCompare(elements[i]) < 0) maxElement = elements[i];
                                    return maxElement;
                                }
                            } else return null;
                        },
                        _functionMin: function(resolvedArgs) {
                            if (resolvedArgs[0].length > 0) {
                                var typeName = this._getTypeName(resolvedArgs[0][0]);
                                if (typeName === TYPE_NUMBER) return Math.min.apply(Math, resolvedArgs[0]);
                                else {
                                    var elements = resolvedArgs[0];
                                    var minElement = elements[0];
                                    for(var i = 1; i < elements.length; i++)if (elements[i].localeCompare(minElement) < 0) minElement = elements[i];
                                    return minElement;
                                }
                            } else return null;
                        },
                        _functionSum: function(resolvedArgs) {
                            var sum = 0;
                            var listToSum = resolvedArgs[0];
                            for(var i = 0; i < listToSum.length; i++)sum += listToSum[i];
                            return sum;
                        },
                        _functionType: function(resolvedArgs) {
                            switch(this._getTypeName(resolvedArgs[0])){
                                case TYPE_NUMBER:
                                    return "number";
                                case TYPE_STRING:
                                    return "string";
                                case TYPE_ARRAY:
                                    return "array";
                                case TYPE_OBJECT:
                                    return "object";
                                case TYPE_BOOLEAN:
                                    return "boolean";
                                case TYPE_EXPREF:
                                    return "expref";
                                case TYPE_NULL:
                                    return "null";
                            }
                        },
                        _functionKeys: function(resolvedArgs) {
                            return Object.keys(resolvedArgs[0]);
                        },
                        _functionValues: function(resolvedArgs) {
                            var obj = resolvedArgs[0];
                            var keys = Object.keys(obj);
                            var values = [];
                            for(var i = 0; i < keys.length; i++)values.push(obj[keys[i]]);
                            return values;
                        },
                        _functionJoin: function(resolvedArgs) {
                            var joinChar = resolvedArgs[0];
                            var listJoin = resolvedArgs[1];
                            return listJoin.join(joinChar);
                        },
                        _functionToArray: function(resolvedArgs) {
                            if (this._getTypeName(resolvedArgs[0]) === TYPE_ARRAY) return resolvedArgs[0];
                            else return [
                                resolvedArgs[0]
                            ];
                        },
                        _functionToString: function(resolvedArgs) {
                            if (this._getTypeName(resolvedArgs[0]) === TYPE_STRING) return resolvedArgs[0];
                            else return JSON.stringify(resolvedArgs[0]);
                        },
                        _functionToNumber: function(resolvedArgs) {
                            var typeName = this._getTypeName(resolvedArgs[0]);
                            var convertedValue;
                            if (typeName === TYPE_NUMBER) return resolvedArgs[0];
                            else if (typeName === TYPE_STRING) {
                                convertedValue = +resolvedArgs[0];
                                if (!isNaN(convertedValue)) return convertedValue;
                            }
                            return null;
                        },
                        _functionNotNull: function(resolvedArgs) {
                            for(var i = 0; i < resolvedArgs.length; i++){
                                if (this._getTypeName(resolvedArgs[i]) !== TYPE_NULL) return resolvedArgs[i];
                            }
                            return null;
                        },
                        _functionSort: function(resolvedArgs) {
                            var sortedArray = resolvedArgs[0].slice(0);
                            sortedArray.sort();
                            return sortedArray;
                        },
                        _functionSortBy: function(resolvedArgs) {
                            var sortedArray = resolvedArgs[0].slice(0);
                            if (sortedArray.length === 0) return sortedArray;
                            var interpreter = this._interpreter;
                            var exprefNode = resolvedArgs[1];
                            var requiredType = this._getTypeName(interpreter.visit(exprefNode, sortedArray[0]));
                            if ([
                                TYPE_NUMBER,
                                TYPE_STRING
                            ].indexOf(requiredType) < 0) throw new Error("TypeError");
                            var that = this;
                            // In order to get a stable sort out of an unstable
                            // sort algorithm, we decorate/sort/undecorate (DSU)
                            // by creating a new list of [index, element] pairs.
                            // In the cmp function, if the evaluated elements are
                            // equal, then the index will be used as the tiebreaker.
                            // After the decorated list has been sorted, it will be
                            // undecorated to extract the original elements.
                            var decorated = [];
                            for(var i = 0; i < sortedArray.length; i++)decorated.push([
                                i,
                                sortedArray[i]
                            ]);
                            decorated.sort(function(a, b) {
                                var exprA = interpreter.visit(exprefNode, a[1]);
                                var exprB = interpreter.visit(exprefNode, b[1]);
                                if (that._getTypeName(exprA) !== requiredType) throw new Error("TypeError: expected " + requiredType + ", received " + that._getTypeName(exprA));
                                else if (that._getTypeName(exprB) !== requiredType) throw new Error("TypeError: expected " + requiredType + ", received " + that._getTypeName(exprB));
                                if (exprA > exprB) return 1;
                                else if (exprA < exprB) return -1;
                                else // If they're equal compare the items by their
                                // order to maintain relative order of equal keys
                                // (i.e. to get a stable sort).
                                return a[0] - b[0];
                            });
                            // Undecorate: extract out the original list elements.
                            for(var j = 0; j < decorated.length; j++)sortedArray[j] = decorated[j][1];
                            return sortedArray;
                        },
                        _functionMaxBy: function(resolvedArgs) {
                            var exprefNode = resolvedArgs[1];
                            var resolvedArray = resolvedArgs[0];
                            var keyFunction = this.createKeyFunction(exprefNode, [
                                TYPE_NUMBER,
                                TYPE_STRING
                            ]);
                            var maxNumber = -Infinity;
                            var maxRecord;
                            var current;
                            for(var i = 0; i < resolvedArray.length; i++){
                                current = keyFunction(resolvedArray[i]);
                                if (current > maxNumber) {
                                    maxNumber = current;
                                    maxRecord = resolvedArray[i];
                                }
                            }
                            return maxRecord;
                        },
                        _functionMinBy: function(resolvedArgs) {
                            var exprefNode = resolvedArgs[1];
                            var resolvedArray = resolvedArgs[0];
                            var keyFunction = this.createKeyFunction(exprefNode, [
                                TYPE_NUMBER,
                                TYPE_STRING
                            ]);
                            var minNumber = Infinity;
                            var minRecord;
                            var current;
                            for(var i = 0; i < resolvedArray.length; i++){
                                current = keyFunction(resolvedArray[i]);
                                if (current < minNumber) {
                                    minNumber = current;
                                    minRecord = resolvedArray[i];
                                }
                            }
                            return minRecord;
                        },
                        createKeyFunction: function(exprefNode, allowedTypes) {
                            var that = this;
                            var interpreter = this._interpreter;
                            var keyFunc = function(x) {
                                var current = interpreter.visit(exprefNode, x);
                                if (allowedTypes.indexOf(that._getTypeName(current)) < 0) {
                                    var msg = "TypeError: expected one of " + allowedTypes + ", received " + that._getTypeName(current);
                                    throw new Error(msg);
                                }
                                return current;
                            };
                            return keyFunc;
                        }
                    };
                    function compile(stream) {
                        var parser = new Parser();
                        var ast = parser.parse(stream);
                        return ast;
                    }
                    function tokenize(stream) {
                        var lexer = new Lexer();
                        return lexer.tokenize(stream);
                    }
                    function search(data, expression) {
                        var parser = new Parser();
                        // This needs to be improved.  Both the interpreter and runtime depend on
                        // each other.  The runtime needs the interpreter to support exprefs.
                        // There's likely a clean way to avoid the cyclic dependency.
                        var runtime = new Runtime();
                        var interpreter = new TreeInterpreter(runtime);
                        runtime._interpreter = interpreter;
                        var node = parser.parse(expression);
                        return interpreter.search(node, data);
                    }
                    exports.tokenize = tokenize;
                    exports.compile = compile;
                    exports.search = search;
                    exports.strictDeepEqual = strictDeepEqual;
                })(exports);
            /***/ },
            /***/ 237: /***/ function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {
                "use strict";
                __webpack_require__.r(__webpack_exports__);
                /* harmony export */ __webpack_require__.d(__webpack_exports__, {
                    /* harmony export */ addClassName: function() {
                        return /* binding */ addClassName;
                    },
                    /* harmony export */ addEventListener: function() {
                        return /* binding */ addEventListener;
                    },
                    /* harmony export */ asyncExec: function() {
                        return /* binding */ asyncExec;
                    },
                    /* harmony export */ clear: function() {
                        return /* binding */ clear;
                    },
                    /* harmony export */ compileJSONPointer: function() {
                        return /* binding */ compileJSONPointer;
                    },
                    /* harmony export */ contains: function() {
                        return /* binding */ contains;
                    },
                    /* harmony export */ debounce: function() {
                        return /* binding */ debounce;
                    },
                    /* harmony export */ escapeUnicodeChars: function() {
                        return /* binding */ escapeUnicodeChars;
                    },
                    /* harmony export */ extend: function() {
                        return /* binding */ extend;
                    },
                    /* harmony export */ findUniqueName: function() {
                        return /* binding */ findUniqueName;
                    },
                    /* harmony export */ formatSize: function() {
                        return /* binding */ formatSize;
                    },
                    /* harmony export */ get: function() {
                        return /* binding */ get;
                    },
                    /* harmony export */ getAbsoluteLeft: function() {
                        return /* binding */ getAbsoluteLeft;
                    },
                    /* harmony export */ getAbsoluteTop: function() {
                        return /* binding */ getAbsoluteTop;
                    },
                    /* harmony export */ getChildPaths: function() {
                        return /* binding */ getChildPaths;
                    },
                    /* harmony export */ getColorCSS: function() {
                        return /* binding */ getColorCSS;
                    },
                    /* harmony export */ getIndexForPosition: function() {
                        return /* binding */ getIndexForPosition;
                    },
                    /* harmony export */ getInnerText: function() {
                        return /* binding */ getInnerText;
                    },
                    /* harmony export */ getInputSelection: function() {
                        return /* binding */ getInputSelection;
                    },
                    /* harmony export */ getInternetExplorerVersion: function() {
                        return /* binding */ getInternetExplorerVersion;
                    },
                    /* harmony export */ getPositionForPath: function() {
                        return /* binding */ getPositionForPath;
                    },
                    /* harmony export */ getSelection: function() {
                        return /* binding */ getSelection;
                    },
                    /* harmony export */ getSelectionOffset: function() {
                        return /* binding */ getSelectionOffset;
                    },
                    /* harmony export */ getType: function() {
                        return /* binding */ getType;
                    },
                    /* harmony export */ getWindow: function() {
                        return /* binding */ getWindow;
                    },
                    /* harmony export */ hasParentNode: function() {
                        return /* binding */ hasParentNode;
                    },
                    /* harmony export */ improveSchemaError: function() {
                        return /* binding */ improveSchemaError;
                    },
                    /* harmony export */ insideRect: function() {
                        return /* binding */ insideRect;
                    },
                    /* harmony export */ isArray: function() {
                        return /* binding */ isArray;
                    },
                    /* harmony export */ isChildOf: function() {
                        return /* binding */ isChildOf;
                    },
                    /* harmony export */ isFirefox: function() {
                        return /* binding */ isFirefox;
                    },
                    /* harmony export */ isObject: function() {
                        return /* binding */ isObject;
                    },
                    /* harmony export */ isPromise: function() {
                        return /* binding */ isPromise;
                    },
                    /* harmony export */ isTimestamp: function() {
                        return /* binding */ isTimestamp;
                    },
                    /* harmony export */ isUrl: function() {
                        return /* binding */ isUrl;
                    },
                    /* harmony export */ isValidColor: function() {
                        return /* binding */ isValidColor;
                    },
                    /* harmony export */ isValidValidationError: function() {
                        return /* binding */ isValidValidationError;
                    },
                    /* harmony export */ isValidationErrorChanged: function() {
                        return /* binding */ isValidationErrorChanged;
                    },
                    /* harmony export */ limitCharacters: function() {
                        return /* binding */ limitCharacters;
                    },
                    /* harmony export */ makeFieldTooltip: function() {
                        return /* binding */ makeFieldTooltip;
                    },
                    /* harmony export */ parse: function() {
                        return /* binding */ parse;
                    },
                    /* harmony export */ parsePath: function() {
                        return /* binding */ parsePath;
                    },
                    /* harmony export */ parseString: function() {
                        return /* binding */ parseString;
                    },
                    /* harmony export */ removeAllClassNames: function() {
                        return /* binding */ removeAllClassNames;
                    },
                    /* harmony export */ removeClassName: function() {
                        return /* binding */ removeClassName;
                    },
                    /* harmony export */ removeEventListener: function() {
                        return /* binding */ removeEventListener;
                    },
                    /* harmony export */ removeReturnsAndSurroundingWhitespace: function() {
                        return /* binding */ removeReturnsAndSurroundingWhitespace;
                    },
                    /* harmony export */ selectContentEditable: function() {
                        return /* binding */ selectContentEditable;
                    },
                    /* harmony export */ setEndOfContentEditable: function() {
                        return /* binding */ setEndOfContentEditable;
                    },
                    /* harmony export */ setSelection: function() {
                        return /* binding */ setSelection;
                    },
                    /* harmony export */ setSelectionOffset: function() {
                        return /* binding */ setSelectionOffset;
                    },
                    /* harmony export */ sort: function() {
                        return /* binding */ sort;
                    },
                    /* harmony export */ sortObjectKeys: function() {
                        return /* binding */ sortObjectKeys;
                    },
                    /* harmony export */ stringifyPath: function() {
                        return /* binding */ stringifyPath;
                    },
                    /* harmony export */ stripFormatting: function() {
                        return /* binding */ stripFormatting;
                    },
                    /* harmony export */ textDiff: function() {
                        return /* binding */ textDiff;
                    },
                    /* harmony export */ tryJsonRepair: function() {
                        return /* binding */ tryJsonRepair;
                    },
                    /* harmony export */ uniqueMergeArrays: function() {
                        return /* binding */ uniqueMergeArrays;
                    },
                    /* harmony export */ validate: function() {
                        return /* binding */ validate;
                    }
                });
                /* harmony import */ var _polyfills__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(81);
                /* harmony import */ var _polyfills__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/ __webpack_require__.n(_polyfills__WEBPACK_IMPORTED_MODULE_0__);
                /* harmony import */ var javascript_natural_sort__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(342);
                /* harmony import */ var javascript_natural_sort__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/ __webpack_require__.n(javascript_natural_sort__WEBPACK_IMPORTED_MODULE_1__);
                /* harmony import */ var jsonrepair__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(857);
                /* harmony import */ var _assets_jsonlint_jsonlint__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(736);
                /* harmony import */ var json_source_map__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(94);
                /* harmony import */ var _i18n__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(57);
                function _toConsumableArray(r) {
                    return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread();
                }
                function _nonIterableSpread() {
                    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                }
                function _unsupportedIterableToArray(r, a) {
                    if (r) {
                        if ("string" == typeof r) return _arrayLikeToArray(r, a);
                        var t = ({}).toString.call(r).slice(8, -1);
                        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
                    }
                }
                function _iterableToArray(r) {
                    if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
                }
                function _arrayWithoutHoles(r) {
                    if (Array.isArray(r)) return _arrayLikeToArray(r);
                }
                function _arrayLikeToArray(r, a) {
                    (null == a || a > r.length) && (a = r.length);
                    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
                    return n;
                }
                function _typeof(o) {
                    "@babel/helpers - typeof";
                    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
                        return typeof o;
                    } : function(o) {
                        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
                    }, _typeof(o);
                }
                var MAX_ITEMS_FIELDS_COLLECTION = 10000;
                var YEAR_2000 = 946684800000;
                /**
 * Parse JSON using the parser built-in in the browser.
 * On exception, the jsonString is validated and a detailed error is thrown.
 * @param {String} jsonString
 * @return {JSON} json
 */ function parse(jsonString) {
                    try {
                        return JSON.parse(jsonString);
                    } catch (err) {
                        // try to throw a more detailed error message using validate
                        validate(jsonString);
                        // rethrow the original error
                        throw err;
                    }
                }
                /**
 * Try to fix the JSON string. If not successful, return the original string
 * @param {string} jsonString
 */ function tryJsonRepair(jsonString) {
                    try {
                        return (0, jsonrepair__WEBPACK_IMPORTED_MODULE_5__ /* .jsonrepair */ .m)(jsonString);
                    } catch (err) {
                        // repair was not successful, return original text
                        return jsonString;
                    }
                }
                /**
 * Escape unicode characters.
 * For example input '\u2661' (length 1) will output '\\u2661' (length 5).
 * @param {string} text
 * @return {string}
 */ function escapeUnicodeChars(// see https://www.wikiwand.com/en/UTF-16
                text) {
                    return(// note: we leave surrogate pairs as two individual chars,
                    // as JSON doesn't interpret them as a single unicode char.
                    text.replace(/[\u007F-\uFFFF]/g, function(c) {
                        return "\\u" + ('0000' + c.charCodeAt(0).toString(16)).slice(-4);
                    }));
                }
                /**
 * Validate a string containing a JSON object
 * This method uses JSONLint to validate the String. If JSONLint is not
 * available, the built-in JSON parser of the browser is used.
 * @param {String} jsonString   String with an (invalid) JSON object
 * @throws Error
 */ function validate(jsonString) {
                    if (typeof _assets_jsonlint_jsonlint__WEBPACK_IMPORTED_MODULE_2__ !== 'undefined') _assets_jsonlint_jsonlint__WEBPACK_IMPORTED_MODULE_2__.parse(jsonString);
                    else JSON.parse(jsonString);
                }
                /**
 * Extend object a with the properties of object b
 * @param {Object} a
 * @param {Object} b
 * @return {Object} a
 */ function extend(a, b) {
                    for(var prop in b)if (hasOwnProperty1(b, prop)) a[prop] = b[prop];
                    return a;
                }
                /**
 * Remove all properties from object a
 * @param {Object} a
 * @return {Object} a
 */ function clear(a) {
                    for(var prop in a)if (hasOwnProperty1(a, prop)) delete a[prop];
                    return a;
                }
                /**
 * Get the type of an object
 * @param {*} object
 * @return {String} type
 */ function getType(object) {
                    if (object === null) return 'null';
                    if (object === undefined) return 'undefined';
                    if (object instanceof Number || typeof object === 'number') return 'number';
                    if (object instanceof String || typeof object === 'string') return 'string';
                    if (object instanceof Boolean || typeof object === 'boolean') return 'boolean';
                    if (object instanceof RegExp) return 'regexp';
                    if (isArray(object)) return 'array';
                    return 'object';
                }
                /**
 * Test whether a text contains a url (matches when a string starts
 * with 'http://*' or 'https://*' and has no whitespace characters)
 * @param {String} text
 */ var isUrlRegex = /^https?:\/\/\S+$/;
                function isUrl(text) {
                    return (typeof text === 'string' || text instanceof String) && isUrlRegex.test(text);
                }
                /**
 * Tes whether given object is an Array
 * @param {*} obj
 * @returns {boolean} returns true when obj is an array
 */ function isArray(obj) {
                    return Object.prototype.toString.call(obj) === '[object Array]';
                }
                /**
 * Gets a DOM element's Window.  This is normally just the global `window`
 * variable, but if we opened a child window, it may be different.
 * @param {HTMLElement} element
 * @return {Window}
 */ function getWindow(element) {
                    return element.ownerDocument.defaultView;
                }
                /**
 * Retrieve the absolute left value of a DOM element
 * @param {Element} elem    A dom element, for example a div
 * @return {Number} left    The absolute left position of this element
 *                          in the browser page.
 */ function getAbsoluteLeft(elem) {
                    var rect = elem.getBoundingClientRect();
                    return rect.left + window.pageXOffset || document.scrollLeft || 0;
                }
                /**
 * Retrieve the absolute top value of a DOM element
 * @param {Element} elem    A dom element, for example a div
 * @return {Number} top     The absolute top position of this element
 *                          in the browser page.
 */ function getAbsoluteTop(elem) {
                    var rect = elem.getBoundingClientRect();
                    return rect.top + window.pageYOffset || document.scrollTop || 0;
                }
                /**
 * add a className to the given elements style
 * @param {Element} elem
 * @param {String} className
 */ function addClassName(elem, className) {
                    var classes = elem.className.split(' ');
                    if (classes.indexOf(className) === -1) {
                        classes.push(className); // add the class to the array
                        elem.className = classes.join(' ');
                    }
                }
                /**
 * remove all classes from the given elements style
 * @param {Element} elem
 */ function removeAllClassNames(elem) {
                    elem.className = '';
                }
                /**
 * add a className to the given elements style
 * @param {Element} elem
 * @param {String} className
 */ function removeClassName(elem, className) {
                    var classes = elem.className.split(' ');
                    var index = classes.indexOf(className);
                    if (index !== -1) {
                        classes.splice(index, 1); // remove the class from the array
                        elem.className = classes.join(' ');
                    }
                }
                /**
 * Strip the formatting from the contents of a div
 * the formatting from the div itself is not stripped, only from its childs.
 * @param {Element} divElement
 */ function stripFormatting(divElement) {
                    var childs = divElement.childNodes;
                    for(var i = 0, iMax = childs.length; i < iMax; i++){
                        var child = childs[i];
                        // remove the style
                        if (child.style) // TODO: test if child.attributes does contain style
                        child.removeAttribute('style');
                        // remove all attributes
                        var attributes = child.attributes;
                        if (attributes) for(var j = attributes.length - 1; j >= 0; j--){
                            var attribute = attributes[j];
                            if (attribute.specified === true) child.removeAttribute(attribute.name);
                        }
                        // recursively strip childs
                        stripFormatting(child);
                    }
                }
                /**
 * Set focus to the end of an editable div
 * code from Nico Burns
 * http://stackoverflow.com/users/140293/nico-burns
 * http://stackoverflow.com/questions/1125292/how-to-move-cursor-to-end-of-contenteditable-entity
 * @param {Element} contentEditableElement   A content editable div
 */ function setEndOfContentEditable(contentEditableElement) {
                    var range, selection;
                    if (document.createRange) {
                        range = document.createRange(); // Create a range (a range is a like the selection but invisible)
                        range.selectNodeContents(contentEditableElement); // Select the entire contents of the element with the range
                        range.collapse(false); // collapse the range to the end point. false means collapse to end rather than the start
                        selection = window.getSelection(); // get the selection object (allows you to change selection)
                        selection.removeAllRanges(); // remove any selections already made
                        selection.addRange(range); // make the range you have just created the visible selection
                    }
                }
                /**
 * Select all text of a content editable div.
 * http://stackoverflow.com/a/3806004/1262753
 * @param {Element} contentEditableElement   A content editable div
 */ function selectContentEditable(contentEditableElement) {
                    if (!contentEditableElement || contentEditableElement.nodeName !== 'DIV') return;
                    var sel, range;
                    if (window.getSelection && document.createRange) {
                        range = document.createRange();
                        range.selectNodeContents(contentEditableElement);
                        sel = window.getSelection();
                        sel.removeAllRanges();
                        sel.addRange(range);
                    }
                }
                /**
 * Get text selection
 * http://stackoverflow.com/questions/4687808/contenteditable-selected-text-save-and-restore
 * @return {Range | TextRange | null} range
 */ function getSelection() {
                    if (window.getSelection) {
                        var sel = window.getSelection();
                        if (sel.getRangeAt && sel.rangeCount) return sel.getRangeAt(0);
                    }
                    return null;
                }
                /**
 * Set text selection
 * http://stackoverflow.com/questions/4687808/contenteditable-selected-text-save-and-restore
 * @param {Range | TextRange | null} range
 */ function setSelection(range) {
                    if (range) {
                        if (window.getSelection) {
                            var sel = window.getSelection();
                            sel.removeAllRanges();
                            sel.addRange(range);
                        }
                    }
                }
                /**
 * Get selected text range
 * @return {Object} params  object containing parameters:
 *                              {Number}  startOffset
 *                              {Number}  endOffset
 *                              {Element} container  HTML element holding the
 *                                                   selected text element
 *                          Returns null if no text selection is found
 */ function getSelectionOffset() {
                    var range = getSelection();
                    if (range && 'startOffset' in range && 'endOffset' in range && range.startContainer && range.startContainer === range.endContainer) return {
                        startOffset: range.startOffset,
                        endOffset: range.endOffset,
                        container: range.startContainer.parentNode
                    };
                    return null;
                }
                /**
 * Set selected text range in given element
 * @param {Object} params   An object containing:
 *                              {Element} container
 *                              {Number} startOffset
 *                              {Number} endOffset
 */ function setSelectionOffset(params) {
                    if (document.createRange && window.getSelection) {
                        var selection = window.getSelection();
                        if (selection) {
                            var range = document.createRange();
                            if (!params.container.firstChild) params.container.appendChild(document.createTextNode(''));
                            // TODO: do not suppose that the first child of the container is a textnode,
                            //       but recursively find the textnodes
                            range.setStart(params.container.firstChild, params.startOffset);
                            range.setEnd(params.container.firstChild, params.endOffset);
                            setSelection(range);
                        }
                    }
                }
                /**
 * Get the inner text of an HTML element (for example a div element)
 * @param {Element} element
 * @param {Object} [buffer]
 * @return {String} innerText
 */ function getInnerText(element, buffer) {
                    var first = buffer === undefined;
                    if (first) buffer = {
                        _text: '',
                        flush: function flush() {
                            var text = this._text;
                            this._text = '';
                            return text;
                        },
                        set: function set(text) {
                            this._text = text;
                        }
                    };
                    // text node
                    if (element.nodeValue) {
                        // remove return characters and the whitespaces surrounding those return characters
                        var trimmedValue = removeReturnsAndSurroundingWhitespace(element.nodeValue);
                        if (trimmedValue !== '') return buffer.flush() + trimmedValue;
                        else // ignore empty text
                        return '';
                    }
                    // divs or other HTML elements
                    if (element.hasChildNodes()) {
                        var childNodes = element.childNodes;
                        var innerText = '';
                        for(var i = 0, iMax = childNodes.length; i < iMax; i++){
                            var child = childNodes[i];
                            if (child.nodeName === 'DIV' || child.nodeName === 'P') {
                                var prevChild = childNodes[i - 1];
                                var prevName = prevChild ? prevChild.nodeName : undefined;
                                if (prevName && prevName !== 'DIV' && prevName !== 'P' && prevName !== 'BR') {
                                    if (innerText !== '') innerText += '\n';
                                    buffer.flush();
                                }
                                innerText += getInnerText(child, buffer);
                                buffer.set('\n');
                            } else if (child.nodeName === 'BR') {
                                innerText += buffer.flush();
                                buffer.set('\n');
                            } else innerText += getInnerText(child, buffer);
                        }
                        return innerText;
                    }
                    // br or unknown
                    return '';
                }
                // regular expression matching one or multiple return characters with all their
                // enclosing white spaces
                function removeReturnsAndSurroundingWhitespace(text) {
                    return text.replace(/(\b|^)\s*(\b|$)/g, function(match) {
                        return /\n/.exec(match) ? '' : match;
                    });
                }
                /**
 * Test whether an element has the provided parent node somewhere up the node tree.
 * @param {Element} elem
 * @param {Element} parent
 * @return {boolean}
 */ function hasParentNode(elem, parent) {
                    var e = elem ? elem.parentNode : undefined;
                    while(e){
                        if (e === parent) return true;
                        e = e.parentNode;
                    }
                    return false;
                }
                /**
 * Returns the version of Internet Explorer or a -1
 * (indicating the use of another browser).
 * Source: http://msdn.microsoft.com/en-us/library/ms537509(v=vs.85).aspx
 * @return {Number} Internet Explorer version, or -1 in case of an other browser
 */ function getInternetExplorerVersion() {
                    if (_ieVersion === -1) {
                        var rv = -1; // Return value assumes failure.
                        if (typeof navigator !== 'undefined' && navigator.appName === 'Microsoft Internet Explorer') {
                            var ua = navigator.userAgent;
                            var re = /MSIE ([0-9]+[.0-9]+)/;
                            if (re.exec(ua) != null) rv = parseFloat(RegExp.$1);
                        }
                        _ieVersion = rv;
                    }
                    return _ieVersion;
                }
                /**
 * cached internet explorer version
 * @type {Number}
 * @private
 */ var _ieVersion = -1;
                /**
 * Test whether the current browser is Firefox
 * @returns {boolean} isFirefox
 */ function isFirefox() {
                    return typeof navigator !== 'undefined' && navigator.userAgent.indexOf('Firefox') !== -1;
                }
                /**
 * Add an event listener. Works for all browsers
 * @param {Element}     element    An html element
 * @param {string}      action     The action, for example "click",
 *                                 without the prefix "on"
 * @param {function}    listener   The callback function to be executed
 * @param {boolean}     [useCapture] false by default
 * @return {function}   the created event listener
 */ function addEventListener(element, action, listener, useCapture) {
                    if (element.addEventListener) {
                        if (useCapture === undefined) useCapture = false;
                        if (action === 'mousewheel' && isFirefox()) action = 'DOMMouseScroll'; // For Firefox
                        element.addEventListener(action, listener, useCapture);
                        return listener;
                    } else if (element.attachEvent) {
                        // Old IE browsers
                        var f = function f() {
                            return listener.call(element, window.event);
                        };
                        element.attachEvent('on' + action, f);
                        return f;
                    }
                }
                /**
 * Remove an event listener from an element
 * @param {Element}  element   An html dom element
 * @param {string}   action    The name of the event, for example "mousedown"
 * @param {function} listener  The listener function
 * @param {boolean}  [useCapture]   false by default
 */ function removeEventListener(element, action, listener, useCapture) {
                    if (element.removeEventListener) {
                        if (useCapture === undefined) useCapture = false;
                        if (action === 'mousewheel' && isFirefox()) action = 'DOMMouseScroll'; // For Firefox
                        element.removeEventListener(action, listener, useCapture);
                    } else if (element.detachEvent) // Old IE browsers
                    element.detachEvent('on' + action, listener);
                }
                /**
 * Test if an element is a child of a parent element.
 * @param {Element} elem
 * @param {Element} parent
 * @return {boolean} returns true if elem is a child of the parent
 */ function isChildOf(elem, parent) {
                    var e = elem.parentNode;
                    while(e){
                        if (e === parent) return true;
                        e = e.parentNode;
                    }
                    return false;
                }
                /**
 * Parse a JSON path like '.items[3].name' into an array
 * @param {string} jsonPath
 * @return {Array}
 */ function parsePath(jsonPath) {
                    var path = [];
                    var i = 0;
                    function parseProperty() {
                        var prop = '';
                        while(jsonPath[i] !== undefined && /[\w$]/.test(jsonPath[i])){
                            prop += jsonPath[i];
                            i++;
                        }
                        if (prop === '') throw new Error('Invalid JSON path: property name expected at index ' + i);
                        return prop;
                    }
                    function parseIndex(end) {
                        var name = '';
                        while(jsonPath[i] !== undefined && jsonPath[i] !== end){
                            name += jsonPath[i];
                            i++;
                        }
                        if (jsonPath[i] !== end) throw new Error('Invalid JSON path: unexpected end, character ' + end + ' expected');
                        return name;
                    }
                    while(jsonPath[i] !== undefined){
                        if (jsonPath[i] === '.') {
                            i++;
                            path.push(parseProperty());
                        } else if (jsonPath[i] === '[') {
                            i++;
                            if (jsonPath[i] === '\'' || jsonPath[i] === '"') {
                                var end = jsonPath[i];
                                i++;
                                path.push(parseIndex(end));
                                if (jsonPath[i] !== end) throw new Error('Invalid JSON path: closing quote \' expected at index ' + i);
                                i++;
                            } else {
                                var index = parseIndex(']').trim();
                                if (index.length === 0) throw new Error('Invalid JSON path: array value expected at index ' + i);
                                // Coerce numeric indices to numbers, but ignore star
                                index = index === '*' ? index : JSON.parse(index);
                                path.push(index);
                            }
                            if (jsonPath[i] !== ']') throw new Error('Invalid JSON path: closing bracket ] expected at index ' + i);
                            i++;
                        } else throw new Error('Invalid JSON path: unexpected character "' + jsonPath[i] + '" at index ' + i);
                    }
                    return path;
                }
                /**
 * Stringify an array with a path in a JSON path like '.items[3].name'
 * @param {Array.<string | number>} path
 * @returns {string}
 */ function stringifyPath(path) {
                    return path.map(function(p) {
                        if (typeof p === 'number') return '[' + p + ']';
                        else if (typeof p === 'string' && p.match(/^[A-Za-z0-9_$]+$/)) return '.' + p;
                        else return '["' + p + '"]';
                    }).join('');
                }
                /**
 * Improve the error message of a JSON schema error
 * @param {Object} error
 * @return {Object} The error
 */ function improveSchemaError(error) {
                    if (error.keyword === 'enum' && Array.isArray(error.schema)) {
                        var enums = error.schema;
                        if (enums) {
                            enums = enums.map(function(value) {
                                return JSON.stringify(value);
                            });
                            if (enums.length > 5) {
                                var more = [
                                    '(' + (enums.length - 5) + ' more...)'
                                ];
                                enums = enums.slice(0, 5);
                                enums.push(more);
                            }
                            error.message = 'should be equal to one of: ' + enums.join(', ');
                        }
                    }
                    if (error.keyword === 'additionalProperties') error.message = 'should NOT have additional property: ' + error.params.additionalProperty;
                    return error;
                }
                /**
 * Test whether something is a Promise
 * @param {*} object
 * @returns {boolean} Returns true when object is a promise, false otherwise
 */ function isPromise(object) {
                    return object && typeof object.then === 'function' && typeof object["catch"] === 'function';
                }
                /**
 * Test whether a custom validation error has the correct structure
 * @param {*} validationError The error to be checked.
 * @returns {boolean} Returns true if the structure is ok, false otherwise
 */ function isValidValidationError(validationError) {
                    return _typeof(validationError) === 'object' && Array.isArray(validationError.path) && typeof validationError.message === 'string';
                }
                /**
 * Test whether the child rect fits completely inside the parent rect.
 * @param {ClientRect} parent
 * @param {ClientRect} child
 * @param {number} margin
 */ function insideRect(parent, child, margin) {
                    var _margin = margin !== undefined ? margin : 0;
                    return child.left - _margin >= parent.left && child.right + _margin <= parent.right && child.top - _margin >= parent.top && child.bottom + _margin <= parent.bottom;
                }
                /**
 * Returns a function, that, as long as it continues to be invoked, will not
 * be triggered. The function will be called after it stops being called for
 * N milliseconds.
 *
 * Source: https://davidwalsh.name/javascript-debounce-function
 *
 * @param {function} func
 * @param {number} wait                 Number in milliseconds
 * @param {boolean} [immediate=false]   If `immediate` is passed, trigger the
 *                                      function on the leading edge, instead
 *                                      of the trailing.
 * @return {function} Return the debounced function
 */ function debounce(func, wait, immediate) {
                    var timeout;
                    return function() {
                        var context = this;
                        var args = arguments;
                        var later = function later() {
                            timeout = null;
                            if (!immediate) func.apply(context, args);
                        };
                        var callNow = immediate && !timeout;
                        clearTimeout(timeout);
                        timeout = setTimeout(later, wait);
                        if (callNow) func.apply(context, args);
                    };
                }
                /**
 * Determines the difference between two texts.
 * Can only detect one removed or inserted block of characters.
 * @param {string} oldText
 * @param {string} newText
 * @return {{start: number, end: number}} Returns the start and end
 *                                        of the changed part in newText.
 */ function textDiff(oldText, newText) {
                    var len = newText.length;
                    var start = 0;
                    var oldEnd = oldText.length;
                    var newEnd = newText.length;
                    while(newText.charAt(start) === oldText.charAt(start) && start < len)start++;
                    while(newText.charAt(newEnd - 1) === oldText.charAt(oldEnd - 1) && newEnd > start && oldEnd > 0){
                        newEnd--;
                        oldEnd--;
                    }
                    return {
                        start: start,
                        end: newEnd
                    };
                }
                /**
 * Return an object with the selection range or cursor position (if both have the same value)
 * Support also old browsers (IE8-)
 * Source: http://ourcodeworld.com/articles/read/282/how-to-get-the-current-cursor-position-and-selection-within-a-text-input-or-textarea-in-javascript
 * @param {DOMElement} el A dom element of a textarea or input text.
 * @return {Object} reference Object with 2 properties (start and end) with the identifier of the location of the cursor and selected text.
 **/ function getInputSelection(el) {
                    var startIndex = 0;
                    var endIndex = 0;
                    var normalizedValue;
                    var range;
                    var textInputRange;
                    var len;
                    var endRange;
                    if (typeof el.selectionStart === 'number' && typeof el.selectionEnd === 'number') {
                        startIndex = el.selectionStart;
                        endIndex = el.selectionEnd;
                    } else {
                        range = document.selection.createRange();
                        if (range && range.parentElement() === el) {
                            len = el.value.length;
                            normalizedValue = el.value.replace(/\r\n/g, '\n');
                            // Create a working TextRange that lives only in the input
                            textInputRange = el.createTextRange();
                            textInputRange.moveToBookmark(range.getBookmark());
                            // Check if the startIndex and endIndex of the selection are at the very end
                            // of the input, since moveStart/moveEnd doesn't return what we want
                            // in those cases
                            endRange = el.createTextRange();
                            endRange.collapse(false);
                            if (textInputRange.compareEndPoints('StartToEnd', endRange) > -1) startIndex = endIndex = len;
                            else {
                                startIndex = -textInputRange.moveStart('character', -len);
                                startIndex += normalizedValue.slice(0, startIndex).split('\n').length - 1;
                                if (textInputRange.compareEndPoints('EndToEnd', endRange) > -1) endIndex = len;
                                else {
                                    endIndex = -textInputRange.moveEnd('character', -len);
                                    endIndex += normalizedValue.slice(0, endIndex).split('\n').length - 1;
                                }
                            }
                        }
                    }
                    return {
                        startIndex: startIndex,
                        endIndex: endIndex,
                        start: _positionForIndex(startIndex),
                        end: _positionForIndex(endIndex)
                    };
                    /**
   * Returns textarea row and column position for certain index
   * @param {Number} index text index
   * @returns {{row: Number, column: Number}}
   */ function _positionForIndex(index) {
                        var textTillIndex = el.value.substring(0, index);
                        var row = (textTillIndex.match(/\n/g) || []).length + 1;
                        var col = textTillIndex.length - textTillIndex.lastIndexOf('\n');
                        return {
                            row: row,
                            column: col
                        };
                    }
                }
                /**
 * Returns the index for certain position in text element
 * @param {DOMElement} el A dom element of a textarea or input text.
 * @param {Number} row row value, > 0, if exceeds rows number - last row will be returned
 * @param {Number} column column value, > 0, if exceeds column length - end of column will be returned
 * @returns {Number} index of position in text, -1 if not found
 */ function getIndexForPosition(el, row, column) {
                    var text = el.value || '';
                    if (row > 0 && column > 0) {
                        var rows = text.split('\n', row);
                        row = Math.min(rows.length, row);
                        column = Math.min(rows[row - 1].length, column - 1);
                        var columnCount = row === 1 ? column : column + 1; // count new line on multiple rows
                        return rows.slice(0, row - 1).join('\n').length + columnCount;
                    }
                    return -1;
                }
                /**
 * Returns location of json paths in certain json string
 * @param {String} text json string
 * @param {Array<String>} paths array of json paths
 * @returns {Array<{path: String, line: Number, row: Number}>}
 */ function getPositionForPath(text, paths) {
                    var result = [];
                    var jsmap;
                    if (!paths || !paths.length) return result;
                    try {
                        jsmap = json_source_map__WEBPACK_IMPORTED_MODULE_3__.parse(text);
                    } catch (err) {
                        return result;
                    }
                    paths.forEach(function(path) {
                        var pathArr = parsePath(path);
                        var pointerName = compileJSONPointer(pathArr);
                        var pointer = jsmap.pointers[pointerName];
                        if (pointer) result.push({
                            path: path,
                            line: pointer.key ? pointer.key.line : pointer.value ? pointer.value.line : 0,
                            column: pointer.key ? pointer.key.column : pointer.value ? pointer.value.column : 0
                        });
                    });
                    return result;
                }
                /**
 * Compile a JSON Pointer
 * WARNING: this is an incomplete implementation
 * @param {Array.<string | number>} path
 * @return {string}
 */ function compileJSONPointer(path) {
                    return path.map(function(p) {
                        return '/' + String(p).replace(/~/g, '~0').replace(/\//g, '~1');
                    }).join('');
                }
                /**
 * Get the applied color given a color name or code
 * Source: https://stackoverflow.com/questions/6386090/validating-css-color-names/33184805
 * @param {string} color
 * @returns {string | null} returns the color if the input is a valid
 *                   color, and returns null otherwise. Example output:
 *                   'rgba(255,0,0,0.7)' or 'rgb(255,0,0)'
 */ function getColorCSS(color) {
                    var ele = document.createElement('div');
                    ele.style.color = color;
                    return ele.style.color.split(/\s+/).join('').toLowerCase() || null;
                }
                /**
 * Test if a string contains a valid color name or code.
 * @param {string} color
 * @returns {boolean} returns true if a valid color, false otherwise
 */ function isValidColor(color) {
                    return !!getColorCSS(color);
                }
                /**
 * Make a tooltip for a field based on the field's schema.
 * @param {object} schema JSON schema
 * @param {string} [locale] Locale code (for example, zh-CN)
 * @returns {string} Field tooltip, may be empty string if all relevant schema properties are missing
 */ function makeFieldTooltip(schema, locale) {
                    if (!schema) return '';
                    var tooltip = '';
                    if (schema.title) tooltip += schema.title;
                    if (schema.description) {
                        if (tooltip.length > 0) tooltip += '\n';
                        tooltip += schema.description;
                    }
                    if (schema["default"]) {
                        if (tooltip.length > 0) tooltip += '\n\n';
                        tooltip += (0, _i18n__WEBPACK_IMPORTED_MODULE_4__ /* .translate */ .Tl)('default', undefined, locale) + '\n';
                        tooltip += JSON.stringify(schema["default"], null, 2);
                    }
                    if (Array.isArray(schema.examples) && schema.examples.length > 0) {
                        if (tooltip.length > 0) tooltip += '\n\n';
                        tooltip += (0, _i18n__WEBPACK_IMPORTED_MODULE_4__ /* .translate */ .Tl)('examples', undefined, locale) + '\n';
                        schema.examples.forEach(function(example, index) {
                            tooltip += JSON.stringify(example, null, 2);
                            if (index !== schema.examples.length - 1) tooltip += '\n';
                        });
                    }
                    return tooltip;
                }
                /**
 * Get a nested property from an object.
 * Returns undefined when the property does not exist.
 * @param {Object} object
 * @param {string[]} path
 * @return {*}
 */ function get(object, path) {
                    var value = object;
                    for(var i = 0; i < path.length && value !== undefined && value !== null; i++)value = value[path[i]];
                    return value;
                }
                /**
 * Find a unique name. Suffix the name with ' (copy)', '(copy 2)', etc
 * until a unique name is found
 * @param {string} name
 * @param {Array} existingPropNames    Array with existing prop names
 */ function findUniqueName(name, existingPropNames) {
                    if (existingPropNames.indexOf(name) === -1) return name;
                    var strippedName = name.replace(/ \(copy( \d+)?\)$/, '');
                    var validName = strippedName;
                    var i = 1;
                    while(existingPropNames.indexOf(validName) !== -1){
                        var copy = 'copy' + (i > 1 ? ' ' + i : '');
                        validName = strippedName + ' (' + copy + ')';
                        i++;
                    }
                    return validName;
                }
                /**
 * Get the child paths of an array
 * @param {JSON} json
 * @param {boolean} [includeObjects=false] If true, object and array paths are returned as well
 * @return {string[]}
 */ function getChildPaths(json, includeObjects) {
                    var pathsMap = {};
                    function getObjectChildPaths(json, pathsMap, rootPath, includeObjects) {
                        var isValue = !Array.isArray(json) && !isObject(json);
                        if (isValue || includeObjects) pathsMap[rootPath || ''] = true;
                        if (isObject(json)) Object.keys(json).forEach(function(field) {
                            getObjectChildPaths(json[field], pathsMap, rootPath + '.' + field, includeObjects);
                        });
                    }
                    if (Array.isArray(json)) {
                        var max = Math.min(json.length, MAX_ITEMS_FIELDS_COLLECTION);
                        for(var i = 0; i < max; i++){
                            var item = json[i];
                            getObjectChildPaths(item, pathsMap, '', includeObjects);
                        }
                    } else pathsMap[''] = true;
                    return Object.keys(pathsMap).sort();
                }
                /**
 * Sort object keys using natural sort
 * @param {Array} array
 * @param {String} [path] JSON pointer
 * @param {'asc' | 'desc'} [direction]
 */ function sort(array, path, direction) {
                    var parsedPath = path && path !== '.' ? parsePath(path) : [];
                    var sign = direction === 'desc' ? -1 : 1;
                    var sortedArray = array.slice();
                    sortedArray.sort(function(a, b) {
                        var aValue = get(a, parsedPath);
                        var bValue = get(b, parsedPath);
                        return sign * (aValue > bValue ? 1 : aValue < bValue ? -1 : 0);
                    });
                    return sortedArray;
                }
                /**
 * Sort object keys using natural sort
 * @param {Object} object
 * @param {'asc' | 'desc'} [direction]
 */ function sortObjectKeys(object, direction) {
                    var sign = direction === 'desc' ? -1 : 1;
                    var sortedFields = Object.keys(object).sort(function(a, b) {
                        return sign * javascript_natural_sort__WEBPACK_IMPORTED_MODULE_1___default()(a, b);
                    });
                    var sortedObject = {};
                    sortedFields.forEach(function(field) {
                        sortedObject[field] = object[field];
                    });
                    return sortedObject;
                }
                /**
 * Cast contents of a string to the correct type.
 * This can be a string, a number, a boolean, etc
 * @param {String} str
 * @return {*} castedStr
 * @private
 */ function parseString(str) {
                    if (str === '') return '';
                    var lower = str.toLowerCase();
                    if (lower === 'null') return null;
                    if (lower === 'true') return true;
                    if (lower === 'false') return false;
                    var containsLeadingZero = /^0\d+$/;
                    var startsWithZeroPrefix = /^0[xbo]/i; // hex, binary, octal numbers
                    if (containsLeadingZero.test(str) || startsWithZeroPrefix.test(str)) // treat '001', '0x1A', '0b1101', and '0o3700' as a string
                    return str;
                    var num = Number(str); // will nicely fail with '123ab'
                    var numFloat = parseFloat(str); // will nicely fail with '  '
                    if (!isNaN(num) && !isNaN(numFloat)) return num;
                    return str;
                }
                /**
 * Test whether some field contains a timestamp in milliseconds after the year 2000.
 * @param {string} field
 * @param {number} value
 * @return {boolean}
 */ function isTimestamp(field, value) {
                    return typeof value === 'number' && value > YEAR_2000 && isFinite(value) && Math.floor(value) === value && !isNaN(new Date(value).valueOf());
                }
                /**
 * Return a human readable document size
 * For example formatSize(7570718) outputs '7.6 MB'
 * @param {number} size
 * @return {string} Returns a human readable size
 */ function formatSize(size) {
                    if (size < 900) return size.toFixed() + ' B';
                    var KB = size / 1000;
                    if (KB < 900) return KB.toFixed(1) + ' KB';
                    var MB = KB / 1000;
                    if (MB < 900) return MB.toFixed(1) + ' MB';
                    var GB = MB / 1000;
                    if (GB < 900) return GB.toFixed(1) + ' GB';
                    var TB = GB / 1000;
                    return TB.toFixed(1) + ' TB';
                }
                /**
 * Limit text to a maximum number of characters
 * @param {string} text
 * @param {number} maxCharacterCount
 * @return {string} Returns the limited text,
 *                  ending with '...' if the max was exceeded
 */ function limitCharacters(text, maxCharacterCount) {
                    if (text.length <= maxCharacterCount) return text;
                    return text.slice(0, maxCharacterCount) + '...';
                }
                /**
 * Test whether a value is an Object
 * @param {*} value
 * @return {boolean}
 */ function isObject(value) {
                    return _typeof(value) === 'object' && value !== null && !Array.isArray(value);
                }
                /**
 * Helper function to test whether an array contains an item
 * @param {Array} array
 * @param {*} item
 * @return {boolean} Returns true if `item` is in `array`, returns false otherwise.
 */ function contains(array, item) {
                    return array.indexOf(item) !== -1;
                }
                /**
 * Checks if validation has changed from the previous execution
 * @param {Array} currErr current validation errors
 * @param {Array} prevErr previous validation errors
 */ function isValidationErrorChanged(currErr, prevErr) {
                    if (!currErr && !prevErr) return false;
                    if (!Array.isArray(currErr) || !Array.isArray(prevErr) || prevErr.length !== currErr.length) return true;
                    for(var i = 0; i < currErr.length; i++){
                        var currItem = currErr[i];
                        var prevItem = prevErr[i];
                        if (currItem.type !== prevItem.type || JSON.stringify(currItem.error) !== JSON.stringify(prevItem.error)) return true;
                    }
                    return false;
                }
                /**
 * Uniquely merge array of elements
 * @param {Array<string|number>} inputArray1
 * @param {Array<string|number>} inputArray2
 * @returns {Array<string|number>} an array with unique merged elements
 */ function uniqueMergeArrays(inputArray1, inputArray2) {
                    var arr1 = inputArray1 !== null && inputArray1 !== void 0 && inputArray1.length ? inputArray1 : [];
                    var arr2 = inputArray2 !== null && inputArray2 !== void 0 && inputArray2.length ? inputArray2 : [];
                    return _toConsumableArray(new Set(arr1.concat(arr2)));
                }
                function asyncExec(callback) {
                    setTimeout(callback);
                }
                function hasOwnProperty1(object, key) {
                    return Object.prototype.hasOwnProperty.call(object, key);
                }
            /***/ },
            /***/ 340: /***/ function(module1, exports) {
                var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__; /**
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */ 
                (function(root, factory) {
                    "use strict";
                    __WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = factory, __WEBPACK_AMD_DEFINE_RESULT__ = typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? __WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__) : __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module1.exports = __WEBPACK_AMD_DEFINE_RESULT__);
                })(this, function() {
                    /**
     * A self-contained modal library
     */ "use strict";
                    /** Returns whether a value is a dom node */ function isNode(value) {
                        if (typeof Node === "object") return value instanceof Node;
                        else return value && typeof value === "object" && typeof value.nodeType === "number";
                    }
                    /** Returns whether a value is a string */ function isString(value) {
                        return typeof value === "string";
                    }
                    /**
     * Generates observable objects that can be watched and triggered
     */ function observable() {
                        var callbacks = [];
                        return {
                            watch: callbacks.push.bind(callbacks),
                            trigger: function(context, detail) {
                                var unprevented = true;
                                var event = {
                                    detail: detail,
                                    preventDefault: function preventDefault() {
                                        unprevented = false;
                                    }
                                };
                                for(var i = 0; i < callbacks.length; i++)callbacks[i](context, event);
                                return unprevented;
                            }
                        };
                    }
                    /** Whether an element is hidden */ function isHidden(elem) {
                        // @see http://stackoverflow.com/questions/19669786
                        return window.getComputedStyle(elem).display === 'none';
                    }
                    /**
     * A small interface for creating and managing a dom element
     */ function Elem(elem) {
                        this.elem = elem;
                    }
                    /** Creates a new div */ Elem.make = function(parent, tag) {
                        if (typeof parent === "string") parent = document.querySelector(parent);
                        var elem = document.createElement(tag || 'div');
                        (parent || document.body).appendChild(elem);
                        return new Elem(elem);
                    };
                    Elem.prototype = {
                        /** Creates a child of this node */ child: function(tag) {
                            return Elem.make(this.elem, tag);
                        },
                        /** Applies a set of styles to an element */ stylize: function(styles) {
                            styles = styles || {};
                            if (typeof styles.opacity !== "undefined") styles.filter = "alpha(opacity=" + styles.opacity * 100 + ")";
                            for(var prop in styles)if (styles.hasOwnProperty(prop)) this.elem.style[prop] = styles[prop];
                            return this;
                        },
                        /** Adds a class name */ clazz: function(clazz) {
                            this.elem.className += " " + clazz;
                            return this;
                        },
                        /** Sets the HTML */ html: function(content) {
                            if (isNode(content)) this.elem.appendChild(content);
                            else this.elem.innerHTML = content;
                            return this;
                        },
                        /** Adds a click handler to this element */ onClick: function(callback) {
                            this.elem.addEventListener('click', callback);
                            return this;
                        },
                        /** Removes this element from the DOM */ destroy: function() {
                            this.elem.parentNode.removeChild(this.elem);
                        },
                        /** Hides this element */ hide: function() {
                            this.elem.style.display = "none";
                        },
                        /** Shows this element */ show: function() {
                            this.elem.style.display = "block";
                        },
                        /** Sets an attribute on this element */ attr: function(name, value) {
                            if (value !== undefined) this.elem.setAttribute(name, value);
                            return this;
                        },
                        /** Executes a callback on all the ancestors of an element */ anyAncestor: function(predicate) {
                            var elem = this.elem;
                            while(elem){
                                if (predicate(new Elem(elem))) return true;
                                else elem = elem.parentNode;
                            }
                            return false;
                        },
                        /** Whether this element is visible */ isVisible: function() {
                            return !isHidden(this.elem);
                        }
                    };
                    /** Generates the grey-out effect */ function buildOverlay(getOption, close) {
                        return Elem.make(getOption("parent")).clazz("pico-overlay").clazz(getOption("overlayClass", "")).stylize({
                            display: "none",
                            position: "fixed",
                            top: "0px",
                            left: "0px",
                            height: "100%",
                            width: "100%",
                            zIndex: 10000
                        }).stylize(getOption('overlayStyles', {
                            opacity: 0.5,
                            background: "#000"
                        })).onClick(function() {
                            if (getOption('overlayClose', true)) close();
                        });
                    }
                    // An auto incrementing ID assigned to each modal
                    var autoinc = 1;
                    /** Builds the content of a modal */ function buildModal(getOption, close) {
                        var width = getOption('width', 'auto');
                        if (typeof width === "number") width = "" + width + "px";
                        var id = getOption("modalId", "pico-" + autoinc++);
                        var elem = Elem.make(getOption("parent")).clazz("pico-content").clazz(getOption("modalClass", "")).stylize({
                            display: 'none',
                            position: 'fixed',
                            zIndex: 10001,
                            left: "50%",
                            top: "38.1966%",
                            maxHeight: '90%',
                            boxSizing: 'border-box',
                            width: width,
                            '-ms-transform': 'translate(-50%,-38.1966%)',
                            '-moz-transform': 'translate(-50%,-38.1966%)',
                            '-webkit-transform': 'translate(-50%,-38.1966%)',
                            '-o-transform': 'translate(-50%,-38.1966%)',
                            transform: 'translate(-50%,-38.1966%)'
                        }).stylize(getOption('modalStyles', {
                            overflow: 'auto',
                            backgroundColor: "white",
                            padding: "20px",
                            borderRadius: "5px"
                        })).html(getOption('content')).attr("id", id).attr("role", "dialog").attr("aria-labelledby", getOption("ariaLabelledBy")).attr("aria-describedby", getOption("ariaDescribedBy", id)).onClick(function(event) {
                            var isCloseClick = new Elem(event.target).anyAncestor(function(elem) {
                                return /\bpico-close\b/.test(elem.elem.className);
                            });
                            if (isCloseClick) close();
                        });
                        return elem;
                    }
                    /** Builds the close button */ function buildClose(elem, getOption) {
                        if (getOption('closeButton', true)) return elem.child('button').html(getOption('closeHtml', "&#xD7;")).clazz("pico-close").clazz(getOption("closeClass", "")).stylize(getOption('closeStyles', {
                            borderRadius: "2px",
                            border: 0,
                            padding: 0,
                            cursor: "pointer",
                            height: "15px",
                            width: "15px",
                            position: "absolute",
                            top: "5px",
                            right: "5px",
                            fontSize: "16px",
                            textAlign: "center",
                            lineHeight: "15px",
                            background: "#CCC"
                        })).attr("aria-label", getOption("close-label", "Close"));
                    }
                    /** Builds a method that calls a method and returns an element */ function buildElemAccessor(builder) {
                        return function() {
                            return builder().elem;
                        };
                    }
                    // An observable that is triggered whenever the escape key is pressed
                    var escapeKey = observable();
                    // An observable that is triggered when the user hits the tab key
                    var tabKey = observable();
                    /** A global event handler to detect the escape key being pressed */ document.documentElement.addEventListener('keydown', function onKeyPress(event) {
                        var keycode = event.which || event.keyCode;
                        // If this is the escape key
                        if (keycode === 27) escapeKey.trigger();
                        else if (keycode === 9) tabKey.trigger(event);
                    });
                    /** Attaches focus management events */ function manageFocus(iface, isEnabled) {
                        /** Whether an element matches a selector */ function matches(elem, selector) {
                            var fn = elem.msMatchesSelector || elem.webkitMatchesSelector || elem.matches;
                            return fn.call(elem, selector);
                        }
                        /**
         * Returns whether an element is focusable
         * @see http://stackoverflow.com/questions/18261595
         */ function canFocus(elem) {
                            if (isHidden(elem) || matches(elem, ":disabled") || elem.hasAttribute("contenteditable")) return false;
                            else return elem.hasAttribute("tabindex") || matches(elem, "input,select,textarea,button,a[href],area[href],iframe");
                        }
                        /** Returns the first descendant that can be focused */ function firstFocusable(elem) {
                            var items = elem.getElementsByTagName("*");
                            for(var i = 0; i < items.length; i++){
                                if (canFocus(items[i])) return items[i];
                            }
                        }
                        /** Returns the last descendant that can be focused */ function lastFocusable(elem) {
                            var items = elem.getElementsByTagName("*");
                            for(var i = items.length; i--;){
                                if (canFocus(items[i])) return items[i];
                            }
                        }
                        // The element focused before the modal opens
                        var focused;
                        // Records the currently focused element so state can be returned
                        // after the modal closes
                        iface.beforeShow(function getActiveFocus() {
                            focused = document.activeElement;
                        });
                        // Shift focus into the modal
                        iface.afterShow(function focusModal() {
                            if (isEnabled()) {
                                var focusable = firstFocusable(iface.modalElem());
                                if (focusable) focusable.focus();
                            }
                        });
                        // Restore the previously focused element when the modal closes
                        iface.afterClose(function returnFocus() {
                            if (isEnabled() && focused) focused.focus();
                            focused = null;
                        });
                        // Capture tab key presses and loop them within the modal
                        tabKey.watch(function tabKeyPress(event) {
                            if (isEnabled() && iface.isVisible()) {
                                var first = firstFocusable(iface.modalElem());
                                var last = lastFocusable(iface.modalElem());
                                var from = event.shiftKey ? first : last;
                                if (from === document.activeElement) {
                                    (event.shiftKey ? last : first).focus();
                                    event.preventDefault();
                                }
                            }
                        });
                    }
                    /** Manages setting the 'overflow: hidden' on the body tag */ function manageBodyOverflow(iface, isEnabled) {
                        var origOverflow;
                        var body = new Elem(document.body);
                        iface.beforeShow(function() {
                            // Capture the current values so they can be restored
                            origOverflow = body.elem.style.overflow;
                            if (isEnabled()) body.stylize({
                                overflow: "hidden"
                            });
                        });
                        iface.afterClose(function() {
                            body.stylize({
                                overflow: origOverflow
                            });
                        });
                    }
                    /**
     * Displays a modal
     */ return function picoModal(options) {
                        if (isString(options) || isNode(options)) options = {
                            content: options
                        };
                        var afterCreateEvent = observable();
                        var beforeShowEvent = observable();
                        var afterShowEvent = observable();
                        var beforeCloseEvent = observable();
                        var afterCloseEvent = observable();
                        /**
         * Returns a named option if it has been explicitly defined. Otherwise,
         * it returns the given default value
         */ function getOption(opt, defaultValue) {
                            var value = options[opt];
                            if (typeof value === "function") value = value(defaultValue);
                            return value === undefined ? defaultValue : value;
                        }
                        // The various DOM elements that constitute the modal
                        var modalElem = build.bind(window, 'modal');
                        var shadowElem = build.bind(window, 'overlay');
                        var closeElem = build.bind(window, 'close');
                        // This will eventually contain the modal API returned to the user
                        var iface;
                        /** Hides this modal */ function forceClose(detail) {
                            shadowElem().hide();
                            modalElem().hide();
                            afterCloseEvent.trigger(iface, detail);
                        }
                        /** Gracefully hides this modal */ function close(detail) {
                            if (beforeCloseEvent.trigger(iface, detail)) forceClose(detail);
                        }
                        /** Wraps a method so it returns the modal interface */ function returnIface(callback) {
                            return function() {
                                callback.apply(this, arguments);
                                return iface;
                            };
                        }
                        // The constructed dom nodes
                        var built;
                        /** Builds a method that calls a method and returns an element */ function build(name, detail) {
                            if (!built) {
                                var modal = buildModal(getOption, close);
                                built = {
                                    modal: modal,
                                    overlay: buildOverlay(getOption, close),
                                    close: buildClose(modal, getOption)
                                };
                                afterCreateEvent.trigger(iface, detail);
                            }
                            return built[name];
                        }
                        iface = {
                            /** Returns the wrapping modal element */ modalElem: buildElemAccessor(modalElem),
                            /** Returns the close button element */ closeElem: buildElemAccessor(closeElem),
                            /** Returns the overlay element */ overlayElem: buildElemAccessor(shadowElem),
                            /** Builds the dom without showing the modal */ buildDom: returnIface(build.bind(null, null)),
                            /** Returns whether this modal is currently being shown */ isVisible: function() {
                                return !!(built && modalElem && modalElem().isVisible());
                            },
                            /** Shows this modal */ show: function(detail) {
                                if (beforeShowEvent.trigger(iface, detail)) {
                                    shadowElem().show();
                                    closeElem();
                                    modalElem().show();
                                    afterShowEvent.trigger(iface, detail);
                                }
                                return this;
                            },
                            /** Hides this modal */ close: returnIface(close),
                            /**
             * Force closes this modal. This will not call beforeClose
             * events and will just immediately hide the modal
             */ forceClose: returnIface(forceClose),
                            /** Destroys this modal */ destroy: function() {
                                modalElem().destroy();
                                shadowElem().destroy();
                                shadowElem = modalElem = closeElem = undefined;
                            },
                            /**
             * Updates the options for this modal. This will only let you
             * change options that are re-evaluted regularly, such as
             * `overlayClose`.
             */ options: function(opts) {
                                Object.keys(opts).map(function(key) {
                                    options[key] = opts[key];
                                });
                            },
                            /** Executes after the DOM nodes are created */ afterCreate: returnIface(afterCreateEvent.watch),
                            /** Executes a callback before this modal is closed */ beforeShow: returnIface(beforeShowEvent.watch),
                            /** Executes a callback after this modal is shown */ afterShow: returnIface(afterShowEvent.watch),
                            /** Executes a callback before this modal is closed */ beforeClose: returnIface(beforeCloseEvent.watch),
                            /** Executes a callback after this modal is closed */ afterClose: returnIface(afterCloseEvent.watch)
                        };
                        manageFocus(iface, getOption.bind(null, "focus", true));
                        manageBodyOverflow(iface, getOption.bind(null, "bodyOverflow", true));
                        // If a user presses the 'escape' key, close the modal.
                        escapeKey.watch(function escapeKeyPress() {
                            if (getOption("escCloses", true) && iface.isVisible()) iface.close();
                        });
                        return iface;
                    };
                });
            /***/ },
            /***/ 342: /***/ function(module1) {
                /*
 * Natural Sort algorithm for Javascript - Version 0.7 - Released under MIT license
 * Author: Jim Palmer (based on chunking idea from Dave Koelle)
 */ /*jshint unused:false */ module1.exports = function naturalSort(a, b) {
                    "use strict";
                    var re = /(^([+\-]?(?:0|[1-9]\d*)(?:\.\d*)?(?:[eE][+\-]?\d+)?)?$|^0x[0-9a-f]+$|\d+)/gi, sre = /(^[ ]*|[ ]*$)/g, dre = /(^([\w ]+,?[\w ]+)?[\w ]+,?[\w ]+\d+:\d+(:\d+)?[\w ]?|^\d{1,4}[\/\-]\d{1,4}[\/\-]\d{1,4}|^\w+, \w+ \d+, \d{4})/, hre = /^0x[0-9a-f]+$/i, ore = /^0/, i = function(s) {
                        return naturalSort.insensitive && ('' + s).toLowerCase() || '' + s;
                    }, // convert all to strings strip whitespace
                    x = i(a).replace(sre, '') || '', y = i(b).replace(sre, '') || '', // chunk/tokenize
                    xN = x.replace(re, '\0$1\0').replace(/\0$/, '').replace(/^\0/, '').split('\0'), yN = y.replace(re, '\0$1\0').replace(/\0$/, '').replace(/^\0/, '').split('\0'), // numeric, hex or date detection
                    xD = parseInt(x.match(hre), 16) || xN.length !== 1 && x.match(dre) && Date.parse(x), yD = parseInt(y.match(hre), 16) || xD && y.match(dre) && Date.parse(y) || null, oFxNcL, oFyNcL;
                    // first try and sort Hex codes or Dates
                    if (yD) {
                        if (xD < yD) return -1;
                        else if (xD > yD) return 1;
                    }
                    // natural sorting through split numeric strings and default strings
                    for(var cLoc = 0, numS = Math.max(xN.length, yN.length); cLoc < numS; cLoc++){
                        // find floats not starting with '0', string or 0 if not defined (Clint Priest)
                        oFxNcL = !(xN[cLoc] || '').match(ore) && parseFloat(xN[cLoc]) || xN[cLoc] || 0;
                        oFyNcL = !(yN[cLoc] || '').match(ore) && parseFloat(yN[cLoc]) || yN[cLoc] || 0;
                        // handle numeric vs string comparison - number < string - (Kyle Adams)
                        if (isNaN(oFxNcL) !== isNaN(oFyNcL)) return isNaN(oFxNcL) ? 1 : -1;
                        else if (typeof oFxNcL !== typeof oFyNcL) {
                            oFxNcL += '';
                            oFyNcL += '';
                        }
                        if (oFxNcL < oFyNcL) return -1;
                        if (oFxNcL > oFyNcL) return 1;
                    }
                    return 0;
                };
            /***/ },
            /***/ 346: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                "use strict";
                var ace = __webpack_require__(413); // may be undefined in case of minimalist bundle
                var VanillaPicker = __webpack_require__(746); // may be undefined in case of minimalist bundle
                var _require = __webpack_require__(633), treeModeMixins = _require.treeModeMixins;
                var _require2 = __webpack_require__(948), textModeMixins = _require2.textModeMixins;
                var _require3 = __webpack_require__(483), previewModeMixins = _require3.previewModeMixins;
                var _require4 = __webpack_require__(237), clear = _require4.clear, extend = _require4.extend, getInnerText = _require4.getInnerText, getInternetExplorerVersion = _require4.getInternetExplorerVersion, parse = _require4.parse;
                var _require5 = __webpack_require__(870), tryRequireAjv = _require5.tryRequireAjv;
                var _require6 = __webpack_require__(609), showTransformModal = _require6.showTransformModal;
                var _require7 = __webpack_require__(915), showSortModal = _require7.showSortModal;
                var Ajv = tryRequireAjv();
                if (typeof Promise === 'undefined') console.error('Promise undefined. Please load a Promise polyfill in the browser in order to use JSONEditor');
                /**
 * @constructor JSONEditor
 * @param {Element} container    Container element
 * @param {Object}  [options]    Object with options. available options:
 *                               {String} mode        Editor mode. Available values:
 *                                                    'tree' (default), 'view',
 *                                                    'form', 'text', and 'code'.
 *                               {function} onChange  Callback method, triggered
 *                                                    on change of contents.
 *                                                    Does not pass the contents itself.
 *                                                    See also `onChangeJSON` and
 *                                                    `onChangeText`.
 *                               {function} onChangeJSON  Callback method, triggered
 *                                                        in modes on change of contents,
 *                                                        passing the changed contents
 *                                                        as JSON.
 *                                                        Only applicable for modes
 *                                                        'tree', 'view', and 'form'.
 *                               {function} onChangeText  Callback method, triggered
 *                                                        in modes on change of contents,
 *                                                        passing the changed contents
 *                                                        as stringified JSON.
 *                               {function} onError   Callback method, triggered
 *                                                    when an error occurs
 *                               {Boolean} search     Enable search box.
 *                                                    True by default
 *                                                    Only applicable for modes
 *                                                    'tree', 'view', and 'form'
 *                               {Boolean} history    Enable history (undo/redo).
 *                                                    True by default
 *                                                    Only applicable for modes
 *                                                    'tree', 'view', and 'form'
 *                               {String} name        Field name for the root node.
 *                                                    Only applicable for modes
 *                                                    'tree', 'view', and 'form'
 *                               {Number} indentation     Number of indentation
 *                                                        spaces. 4 by default.
 *                                                        Only applicable for
 *                                                        modes 'text' and 'code'
 *                               {boolean} escapeUnicode  If true, unicode
 *                                                        characters are escaped.
 *                                                        false by default.
 *                               {boolean} sortObjectKeys If true, object keys are
 *                                                        sorted before display.
 *                                                        false by default.
 *                               {function} onSelectionChange Callback method,
 *                                                            triggered on node selection change
 *                                                            Only applicable for modes
 *                                                            'tree', 'view', and 'form'
 *                               {function} onTextSelectionChange Callback method,
 *                                                                triggered on text selection change
 *                                                                Only applicable for modes
 *                               {HTMLElement} modalAnchor        The anchor element to apply an
 *                                                                overlay and display the modals in a
 *                                                                centered location.
 *                                                                Defaults to document.body
 *                                                                'text' and 'code'
 *                               {function} onEvent Callback method, triggered
 *                                                  when an event occurs in
 *                                                  a JSON field or value.
 *                                                  Only applicable for
 *                                                  modes 'form', 'tree' and
 *                                                  'view'
 *                               {function} onFocus  Callback method, triggered
 *                                                   when the editor comes into focus,
 *                                                   passing an object {type, target},
 *                                                   Applicable for all modes
 *                               {function} onBlur   Callback method, triggered
 *                                                   when the editor goes out of focus,
 *                                                   passing an object {type, target},
 *                                                   Applicable for all modes
 *                               {function} onClassName Callback method, triggered
 *                                                  when a Node DOM is rendered. Function returns
 *                                                  a css class name to be set on a node.
 *                                                  Only applicable for
 *                                                  modes 'form', 'tree' and
 *                                                  'view'
 *                               {Number} maxVisibleChilds Number of children allowed for a node
 *                                                         in 'tree', 'view', or 'form' mode before
 *                                                         the "show more/show all" buttons appear.
 *                                                         100 by default.
 *
 * @param {Object | undefined} json JSON object
 */ function JSONEditor(container, options, json) {
                    if (!(this instanceof JSONEditor)) throw new Error('JSONEditor constructor called without "new".');
                    // check for unsupported browser (IE8 and older)
                    var ieVersion = getInternetExplorerVersion();
                    if (ieVersion !== -1 && ieVersion < 9) throw new Error("Unsupported browser, IE9 or newer required. Please install the newest version of your browser.");
                    if (options) {
                        // check for deprecated options
                        if (options.error) {
                            console.warn('Option "error" has been renamed to "onError"');
                            options.onError = options.error;
                            delete options.error;
                        }
                        if (options.change) {
                            console.warn('Option "change" has been renamed to "onChange"');
                            options.onChange = options.change;
                            delete options.change;
                        }
                        if (options.editable) {
                            console.warn('Option "editable" has been renamed to "onEditable"');
                            options.onEditable = options.editable;
                            delete options.editable;
                        }
                        // warn if onChangeJSON is used when mode can be `text` or `code`
                        if (options.onChangeJSON) {
                            if (options.mode === 'text' || options.mode === 'code' || options.modes && (options.modes.indexOf('text') !== -1 || options.modes.indexOf('code') !== -1)) console.warn('Option "onChangeJSON" is not applicable to modes "text" and "code". Use "onChangeText" or "onChange" instead.');
                        }
                        // validate options
                        if (options) Object.keys(options).forEach(function(option) {
                            if (JSONEditor.VALID_OPTIONS.indexOf(option) === -1) console.warn('Unknown option "' + option + '". This option will be ignored');
                        });
                    }
                    if (arguments.length) this._create(container, options, json);
                }
                /**
 * Configuration for all registered modes. Example:
 * {
 *     tree: {
 *         mixin: TreeEditor,
 *         data: 'json'
 *     },
 *     text: {
 *         mixin: TextEditor,
 *         data: 'text'
 *     }
 * }
 *
 * @type { Object.<String, {mixin: Object, data: String} > }
 */ JSONEditor.modes = {};
                // debounce interval for JSON schema validation in milliseconds
                JSONEditor.prototype.DEBOUNCE_INTERVAL = 150;
                JSONEditor.VALID_OPTIONS = [
                    'ajv',
                    'schema',
                    'schemaRefs',
                    'templates',
                    'ace',
                    'theme',
                    'autocomplete',
                    'onChange',
                    'onChangeJSON',
                    'onChangeText',
                    'onExpand',
                    'onEditable',
                    'onError',
                    'onEvent',
                    'onModeChange',
                    'onNodeName',
                    'onValidate',
                    'onCreateMenu',
                    'onSelectionChange',
                    'onTextSelectionChange',
                    'onClassName',
                    'onFocus',
                    'onBlur',
                    'colorPicker',
                    'onColorPicker',
                    'timestampTag',
                    'timestampFormat',
                    'escapeUnicode',
                    'history',
                    'search',
                    'mode',
                    'modes',
                    'name',
                    'indentation',
                    'sortObjectKeys',
                    'navigationBar',
                    'statusBar',
                    'mainMenuBar',
                    'languages',
                    'language',
                    'enableSort',
                    'enableTransform',
                    'limitDragging',
                    'maxVisibleChilds',
                    'onValidationError',
                    'modalAnchor',
                    'popupAnchor',
                    'createQuery',
                    'executeQuery',
                    'queryDescription',
                    'allowSchemaSuggestions',
                    'showErrorTable'
                ];
                /**
 * Create the JSONEditor
 * @param {Element} container    Container element
 * @param {Object}  [options]    See description in constructor
 * @param {Object | undefined} json JSON object
 * @private
 */ JSONEditor.prototype._create = function(container, options, json) {
                    this.container = container;
                    this.options = options || {};
                    this.json = json || {};
                    var mode = this.options.mode || this.options.modes && this.options.modes[0] || 'tree';
                    this.setMode(mode);
                };
                /**
 * Destroy the editor. Clean up DOM, event listeners, and web workers.
 */ JSONEditor.prototype.destroy = function() {};
                /**
 * Set JSON object in editor
 * @param {Object | undefined} json      JSON data
 */ JSONEditor.prototype.set = function(json) {
                    this.json = json;
                };
                /**
 * Get JSON from the editor
 * @returns {Object} json
 */ JSONEditor.prototype.get = function() {
                    return this.json;
                };
                /**
 * Set string containing JSON for the editor
 * @param {String | undefined} jsonText
 */ JSONEditor.prototype.setText = function(jsonText) {
                    this.json = parse(jsonText);
                };
                /**
 * Get stringified JSON contents from the editor
 * @returns {String} jsonText
 */ JSONEditor.prototype.getText = function() {
                    return JSON.stringify(this.json);
                };
                /**
 * Set a field name for the root node.
 * @param {String | undefined} name
 */ JSONEditor.prototype.setName = function(name) {
                    if (!this.options) this.options = {};
                    this.options.name = name;
                };
                /**
 * Get the field name for the root node.
 * @return {String | undefined} name
 */ JSONEditor.prototype.getName = function() {
                    return this.options && this.options.name;
                };
                /**
 * Change the mode of the editor.
 * JSONEditor will be extended with all methods needed for the chosen mode.
 * @param {String} mode     Available modes: 'tree' (default), 'view', 'form',
 *                          'text', and 'code'.
 */ JSONEditor.prototype.setMode = function(mode) {
                    // if the mode is the same as current mode (and it's not the first time), do nothing.
                    if (mode === this.options.mode && this.create) return;
                    var container = this.container;
                    var options = extend({}, this.options);
                    var oldMode = options.mode;
                    options.mode = mode;
                    var config = JSONEditor.modes[mode];
                    if (!config) throw new Error('Unknown mode "' + options.mode + '"');
                    var asText = config.data === 'text';
                    var name = this.getName();
                    var data = this[asText ? 'getText' : 'get'](); // get text or json
                    this.destroy();
                    clear(this);
                    extend(this, config.mixin);
                    this.create(container, options);
                    this.setName(name);
                    this[asText ? 'setText' : 'set'](data); // set text or json
                    if (typeof config.load === 'function') try {
                        config.load.call(this);
                    } catch (err) {
                        console.error(err);
                    }
                    if (typeof options.onModeChange === 'function' && mode !== oldMode) try {
                        options.onModeChange(mode, oldMode);
                    } catch (err) {
                        console.error(err);
                    }
                };
                /**
 * Get the current mode
 * @return {string}
 */ JSONEditor.prototype.getMode = function() {
                    return this.options.mode;
                };
                /**
 * Throw an error. If an error callback is configured in options.error, this
 * callback will be invoked. Else, a basic alert window with the error message
 * will be shown to the user.
 * @param {Error} err
 * @private
 */ JSONEditor.prototype._onError = function(err) {
                    if (this.options && typeof this.options.onError === 'function') this.options.onError(err);
                    else window.alert(err.toString());
                };
                /**
 * Set a JSON schema for validation of the JSON object.
 * To remove the schema, call JSONEditor.setSchema(null)
 * @param {Object | null} schema
 * @param {Object.<string, Object>=} schemaRefs Schemas that are referenced using the `$ref` property from the JSON schema that are set in the `schema` option,
 +  the object structure in the form of `{reference_key: schemaObject}`
 */ JSONEditor.prototype.setSchema = function(schema, schemaRefs) {
                    // compile a JSON schema validator if a JSON schema is provided
                    if (schema) {
                        var ajv;
                        try {
                            // grab ajv from options if provided, else create a new instance
                            if (this.options.ajv) ajv = this.options.ajv;
                            else {
                                ajv = Ajv({
                                    allErrors: true,
                                    verbose: true,
                                    schemaId: 'auto',
                                    $data: true
                                });
                                // support both draft-04 and draft-06 alongside the latest draft-07
                                ajv.addMetaSchema(__webpack_require__(Object(function webpackMissingModule() {
                                    var e = new Error("Cannot find module 'ajv/lib/refs/json-schema-draft-04.json'");
                                    e.code = 'MODULE_NOT_FOUND';
                                    throw e;
                                }())));
                                ajv.addMetaSchema(__webpack_require__(Object(function webpackMissingModule() {
                                    var e = new Error("Cannot find module 'ajv/lib/refs/json-schema-draft-06.json'");
                                    e.code = 'MODULE_NOT_FOUND';
                                    throw e;
                                }())));
                            }
                        } catch (err) {
                            console.warn('Failed to create an instance of Ajv, JSON Schema validation is not available. Please use a JSONEditor bundle including Ajv, or pass an instance of Ajv as via the configuration option `ajv`.');
                        }
                        if (ajv) {
                            if (schemaRefs) {
                                for(var ref in schemaRefs){
                                    ajv.removeSchema(ref); // When updating a schema - old refs has to be removed first
                                    if (schemaRefs[ref]) ajv.addSchema(schemaRefs[ref], ref);
                                }
                                this.options.schemaRefs = schemaRefs;
                            }
                            this.validateSchema = ajv.compile(schema);
                            // add schema to the options, so that when switching to an other mode,
                            // the set schema is not lost
                            this.options.schema = schema;
                            this.options.schemaRefs = schemaRefs;
                            // validate now
                            this.validate();
                        }
                        this.refresh(); // update DOM
                    } else {
                        // remove current schema
                        this.validateSchema = null;
                        this.options.schema = null;
                        this.options.schemaRefs = null;
                        this.validate(); // to clear current error messages
                        this.refresh(); // update DOM
                    }
                    if (typeof this._onSchemaChange === 'function') this._onSchemaChange(schema, schemaRefs);
                };
                /**
 * Validate current JSON object against the configured JSON schema
 * Throws an exception when no JSON schema is configured
 */ JSONEditor.prototype.validate = function() {
                // must be implemented by treemode and textmode
                };
                /**
 * Refresh the rendered contents
 */ JSONEditor.prototype.refresh = function() {
                // can be implemented by treemode and textmode
                };
                /**
 * Register a plugin with one ore multiple modes for the JSON Editor.
 *
 * A mode is described as an object with properties:
 *
 * - `mode: String`           The name of the mode.
 * - `mixin: Object`          An object containing the mixin functions which
 *                            will be added to the JSONEditor. Must contain functions
 *                            create, get, getText, set, and setText. May have
 *                            additional functions.
 *                            When the JSONEditor switches to a mixin, all mixin
 *                            functions are added to the JSONEditor, and then
 *                            the function `create(container, options)` is executed.
 * - `data: 'text' | 'json'`  The type of data that will be used to load the mixin.
 * - `[load: function]`       An optional function called after the mixin
 *                            has been loaded.
 *
 * @param {Object | Array} mode  A mode object or an array with multiple mode objects.
 */ JSONEditor.registerMode = function(mode) {
                    var i, prop;
                    if (Array.isArray(mode)) // multiple modes
                    for(i = 0; i < mode.length; i++)JSONEditor.registerMode(mode[i]);
                    else {
                        // validate the new mode
                        if (!('mode' in mode)) throw new Error('Property "mode" missing');
                        if (!('mixin' in mode)) throw new Error('Property "mixin" missing');
                        if (!('data' in mode)) throw new Error('Property "data" missing');
                        var name = mode.mode;
                        if (name in JSONEditor.modes) throw new Error('Mode "' + name + '" already registered');
                        // validate the mixin
                        if (typeof mode.mixin.create !== 'function') throw new Error('Required function "create" missing on mixin');
                        var reserved = [
                            'setMode',
                            'registerMode',
                            'modes'
                        ];
                        for(i = 0; i < reserved.length; i++){
                            prop = reserved[i];
                            if (prop in mode.mixin) throw new Error('Reserved property "' + prop + '" not allowed in mixin');
                        }
                        JSONEditor.modes[name] = mode;
                    }
                };
                // register tree, text, and preview modes
                JSONEditor.registerMode(treeModeMixins);
                JSONEditor.registerMode(textModeMixins);
                JSONEditor.registerMode(previewModeMixins);
                // expose some of the libraries that can be used customized
                JSONEditor.ace = ace;
                JSONEditor.Ajv = Ajv;
                JSONEditor.VanillaPicker = VanillaPicker;
                // expose some utils (this is undocumented, unofficial)
                JSONEditor.showTransformModal = showTransformModal;
                JSONEditor.showSortModal = showSortModal;
                JSONEditor.getInnerText = getInnerText;
                // default export for TypeScript ES6 projects
                JSONEditor["default"] = JSONEditor;
                module1.exports = JSONEditor;
            /***/ },
            /***/ 359: /***/ function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {
                "use strict";
                /* harmony export */ __webpack_require__.d(__webpack_exports__, {
                    /* harmony export */ V: function() {
                        return /* binding */ createQuery;
                    },
                    /* harmony export */ e: function() {
                        return /* binding */ executeQuery;
                    }
                });
                /* harmony import */ var jmespath__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(151);
                /* harmony import */ var jmespath__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/ __webpack_require__.n(jmespath__WEBPACK_IMPORTED_MODULE_0__);
                /* harmony import */ var _util__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(237);
                /**
 * Build a JMESPath query based on query options coming from the wizard
 * @param {JSON} json   The JSON document for which to build the query.
 *                      Used for context information like determining
 *                      the type of values (string or number)
 * @param {QueryOptions} queryOptions
 * @return {string} Returns a query (as string)
 */ function createQuery(json, queryOptions) {
                    var sort = queryOptions.sort, filter = queryOptions.filter, projection = queryOptions.projection;
                    var query = '';
                    if (filter) {
                        var examplePath = filter.field !== '@' ? [
                            '0'
                        ].concat((0, _util__WEBPACK_IMPORTED_MODULE_1__.parsePath)('.' + filter.field)) : [
                            '0'
                        ];
                        var exampleValue = (0, _util__WEBPACK_IMPORTED_MODULE_1__.get)(json, examplePath);
                        var value1 = typeof exampleValue === 'string' ? filter.value : (0, _util__WEBPACK_IMPORTED_MODULE_1__.parseString)(filter.value);
                        query += '[? ' + filter.field + ' ' + filter.relation + ' ' + '`' + JSON.stringify(value1) + '`' + ']';
                    } else query += Array.isArray(json) ? '[*]' : '@';
                    if (sort) {
                        if (sort.direction === 'desc') query += ' | reverse(sort_by(@, &' + sort.field + '))';
                        else query += ' | sort_by(@, &' + sort.field + ')';
                    }
                    if (projection) {
                        if (query[query.length - 1] !== ']') query += ' | [*]';
                        if (projection.fields.length === 1) query += '.' + projection.fields[0];
                        else if (projection.fields.length > 1) query += '.{' + projection.fields.map(function(value) {
                            var parts = value.split('.');
                            var last = parts[parts.length - 1];
                            return last + ': ' + value;
                        }).join(', ') + '}';
                    }
                    return query;
                }
                /**
 * Execute a JMESPath query
 * @param {JSON} json
 * @param {string} query
 * @return {JSON} Returns the transformed JSON
 */ function executeQuery(json, query) {
                    return jmespath__WEBPACK_IMPORTED_MODULE_0___default().search(json, query);
                }
            /***/ },
            /***/ 389: /***/ function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {
                "use strict";
                /* harmony export */ __webpack_require__.d(__webpack_exports__, {
                    /* harmony export */ n: function() {
                        return /* binding */ ModeSwitcher;
                    }
                });
                /* harmony import */ var _ContextMenu__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(545);
                /* harmony import */ var _i18n__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(57);
                function _typeof(o) {
                    "@babel/helpers - typeof";
                    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
                        return typeof o;
                    } : function(o) {
                        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
                    }, _typeof(o);
                }
                function _classCallCheck(a, n) {
                    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
                }
                function _defineProperties(e, r) {
                    for(var t = 0; t < r.length; t++){
                        var o = r[t];
                        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
                    }
                }
                function _createClass(e, r, t) {
                    return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
                        writable: !1
                    }), e;
                }
                function _toPropertyKey(t) {
                    var i = _toPrimitive(t, "string");
                    return "symbol" == _typeof(i) ? i : i + "";
                }
                function _toPrimitive(t, r) {
                    if ("object" != _typeof(t) || !t) return t;
                    var e = t[Symbol.toPrimitive];
                    if (void 0 !== e) {
                        var i = e.call(t, r || "default");
                        if ("object" != _typeof(i)) return i;
                        throw new TypeError("@@toPrimitive must return a primitive value.");
                    }
                    return ("string" === r ? String : Number)(t);
                }
                /**
 * Create a select box to be used in the editor menu's, which allows to switch mode
 * @param {HTMLElement} container
 * @param {String[]} modes  Available modes: 'code', 'form', 'text', 'tree', 'view', 'preview'
 * @param {String} current  Available modes: 'code', 'form', 'text', 'tree', 'view', 'preview'
 * @param {function(mode: string)} onSwitch  Callback invoked on switch
 * @constructor
 */ var ModeSwitcher = /*#__PURE__*/ function() {
                    function ModeSwitcher(container, modes, current, onSwitch) {
                        _classCallCheck(this, ModeSwitcher);
                        // available modes
                        var availableModes = {
                            code: {
                                text: (0, _i18n__WEBPACK_IMPORTED_MODULE_1__ /* .translate */ .Tl)('modeCodeText'),
                                title: (0, _i18n__WEBPACK_IMPORTED_MODULE_1__ /* .translate */ .Tl)('modeCodeTitle'),
                                click: function click() {
                                    onSwitch('code');
                                }
                            },
                            form: {
                                text: (0, _i18n__WEBPACK_IMPORTED_MODULE_1__ /* .translate */ .Tl)('modeFormText'),
                                title: (0, _i18n__WEBPACK_IMPORTED_MODULE_1__ /* .translate */ .Tl)('modeFormTitle'),
                                click: function click() {
                                    onSwitch('form');
                                }
                            },
                            text: {
                                text: (0, _i18n__WEBPACK_IMPORTED_MODULE_1__ /* .translate */ .Tl)('modeTextText'),
                                title: (0, _i18n__WEBPACK_IMPORTED_MODULE_1__ /* .translate */ .Tl)('modeTextTitle'),
                                click: function click() {
                                    onSwitch('text');
                                }
                            },
                            tree: {
                                text: (0, _i18n__WEBPACK_IMPORTED_MODULE_1__ /* .translate */ .Tl)('modeTreeText'),
                                title: (0, _i18n__WEBPACK_IMPORTED_MODULE_1__ /* .translate */ .Tl)('modeTreeTitle'),
                                click: function click() {
                                    onSwitch('tree');
                                }
                            },
                            view: {
                                text: (0, _i18n__WEBPACK_IMPORTED_MODULE_1__ /* .translate */ .Tl)('modeViewText'),
                                title: (0, _i18n__WEBPACK_IMPORTED_MODULE_1__ /* .translate */ .Tl)('modeViewTitle'),
                                click: function click() {
                                    onSwitch('view');
                                }
                            },
                            preview: {
                                text: (0, _i18n__WEBPACK_IMPORTED_MODULE_1__ /* .translate */ .Tl)('modePreviewText'),
                                title: (0, _i18n__WEBPACK_IMPORTED_MODULE_1__ /* .translate */ .Tl)('modePreviewTitle'),
                                click: function click() {
                                    onSwitch('preview');
                                }
                            }
                        };
                        // list the selected modes
                        var items = [];
                        for(var i = 0; i < modes.length; i++){
                            var mode = modes[i];
                            var item = availableModes[mode];
                            if (!item) throw new Error('Unknown mode "' + mode + '"');
                            item.className = 'jsoneditor-type-modes' + (current === mode ? ' jsoneditor-selected' : '');
                            items.push(item);
                        }
                        // retrieve the title of current mode
                        var currentMode = availableModes[current];
                        if (!currentMode) throw new Error('Unknown mode "' + current + '"');
                        var currentTitle = currentMode.text;
                        // create the html element
                        var box = document.createElement('button');
                        box.type = 'button';
                        box.className = 'jsoneditor-modes jsoneditor-separator';
                        box.textContent = currentTitle + " \u25BE";
                        box.title = (0, _i18n__WEBPACK_IMPORTED_MODULE_1__ /* .translate */ .Tl)('modeEditorTitle');
                        box.onclick = function() {
                            var menu = new _ContextMenu__WEBPACK_IMPORTED_MODULE_0__ /* .ContextMenu */ .t(items);
                            menu.show(box, container);
                        };
                        var frame = document.createElement('div');
                        frame.className = 'jsoneditor-modes';
                        frame.style.position = 'relative';
                        frame.appendChild(box);
                        container.appendChild(frame);
                        this.dom = {
                            container: container,
                            box: box,
                            frame: frame
                        };
                    }
                    /**
   * Set focus to switcher
   */ return _createClass(ModeSwitcher, [
                        {
                            key: "focus",
                            value: function focus() {
                                this.dom.box.focus();
                            }
                        },
                        {
                            key: "destroy",
                            value: function destroy() {
                                if (this.dom && this.dom.frame && this.dom.frame.parentNode) this.dom.frame.parentNode.removeChild(this.dom.frame);
                                this.dom = null;
                            }
                        }
                    ]);
                }();
            /***/ },
            /***/ 413: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                var ace;
                if (window.ace) // use the already loaded instance of Ace
                ace = window.ace;
                else try {
                    // load Ace editor
                    ace = __webpack_require__(Object(function webpackMissingModule() {
                        var e = new Error("Cannot find module 'ace-builds/src-noconflict/ace'");
                        e.code = 'MODULE_NOT_FOUND';
                        throw e;
                    }()));
                    // load required Ace plugins
                    __webpack_require__(Object(function webpackMissingModule() {
                        var e = new Error("Cannot find module 'ace-builds/src-noconflict/mode-json'");
                        e.code = 'MODULE_NOT_FOUND';
                        throw e;
                    }()));
                    __webpack_require__(Object(function webpackMissingModule() {
                        var e = new Error("Cannot find module 'ace-builds/src-noconflict/ext-searchbox'");
                        e.code = 'MODULE_NOT_FOUND';
                        throw e;
                    }()));
                    __webpack_require__(Object(function webpackMissingModule() {
                        var e = new Error("Cannot find module 'ace-builds/src-noconflict/ext-language_tools'");
                        e.code = 'MODULE_NOT_FOUND';
                        throw e;
                    }()));
                    // embed Ace json worker
                    // https://github.com/ajaxorg/ace/issues/3913
                    var jsonWorkerDataUrl = __webpack_require__(Object(function webpackMissingModule() {
                        var e = new Error("Cannot find module '../generated/worker-json-data-url'");
                        e.code = 'MODULE_NOT_FOUND';
                        throw e;
                    }()));
                    ace.config.setModuleUrl('ace/mode/json_worker', jsonWorkerDataUrl);
                } catch (err) {
                // failed to load Ace (can be minimalist bundle).
                // No worries, the editor will fall back to plain text if needed.
                }
                module1.exports = ace;
            /***/ },
            /***/ 467: /***/ function(__unused_webpack_module, exports, __webpack_require__) {
                exports.J = function() {
                    try {
                        __webpack_require__(762);
                    } catch (err) {
                        console.error(err);
                    }
                };
            /***/ },
            /***/ 483: /***/ function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {
                "use strict";
                // ESM COMPAT FLAG
                __webpack_require__.r(__webpack_exports__);
                // EXPORTS
                __webpack_require__.d(__webpack_exports__, {
                    previewModeMixins: function() {
                        return /* binding */ previewModeMixins;
                    }
                });
                // EXTERNAL MODULE: ./node_modules/jsonrepair/lib/esm/regular/jsonrepair.js + 2 modules
                var jsonrepair = __webpack_require__(857);
                // EXTERNAL MODULE: ./src/js/constants.js
                var constants = __webpack_require__(660);
                // EXTERNAL MODULE: ./src/js/ErrorTable.js
                var ErrorTable = __webpack_require__(115);
                // EXTERNAL MODULE: ./src/js/FocusTracker.js
                var FocusTracker = __webpack_require__(877);
                function _typeof(o) {
                    "@babel/helpers - typeof";
                    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
                        return typeof o;
                    } : function(o) {
                        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
                    }, _typeof(o);
                }
                function _classCallCheck(a, n) {
                    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
                }
                function _defineProperties(e, r) {
                    for(var t = 0; t < r.length; t++){
                        var o = r[t];
                        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
                    }
                }
                function _createClass(e, r, t) {
                    return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
                        writable: !1
                    }), e;
                }
                function _toPropertyKey(t) {
                    var i = _toPrimitive(t, "string");
                    return "symbol" == _typeof(i) ? i : i + "";
                }
                function _toPrimitive(t, r) {
                    if ("object" != _typeof(t) || !t) return t;
                    var e = t[Symbol.toPrimitive];
                    if (void 0 !== e) {
                        var i = e.call(t, r || "default");
                        if ("object" != _typeof(i)) return i;
                        throw new TypeError("@@toPrimitive must return a primitive value.");
                    }
                    return ("string" === r ? String : Number)(t);
                }
                /**
 * Keep track on any history, be able
 * @param {function} onChange
 * @param {function} calculateItemSize
 * @param {number} limit    Maximum size of all items in history
 * @constructor
 */ var History = /*#__PURE__*/ function() {
                    function History(onChange, calculateItemSize, limit) {
                        _classCallCheck(this, History);
                        this.onChange = onChange;
                        this.calculateItemSize = calculateItemSize || function() {
                            return 1;
                        };
                        this.limit = limit;
                        this.items = [];
                        this.index = -1;
                    }
                    return _createClass(History, [
                        {
                            key: "add",
                            value: function add(item) {
                                // limit number of items in history so that the total size doesn't
                                // always keep at least one item in memory
                                while(this._calculateHistorySize() > this.limit && this.items.length > 1){
                                    this.items.shift();
                                    this.index--;
                                }
                                // cleanup any redo action that are not valid anymore
                                this.items = this.items.slice(0, this.index + 1);
                                this.items.push(item);
                                this.index++;
                                this.onChange();
                            }
                        },
                        {
                            key: "_calculateHistorySize",
                            value: function _calculateHistorySize() {
                                var calculateItemSize = this.calculateItemSize;
                                var totalSize = 0;
                                this.items.forEach(function(item) {
                                    totalSize += calculateItemSize(item);
                                });
                                return totalSize;
                            }
                        },
                        {
                            key: "undo",
                            value: function undo() {
                                if (!this.canUndo()) return;
                                this.index--;
                                this.onChange();
                                return this.items[this.index];
                            }
                        },
                        {
                            key: "redo",
                            value: function redo() {
                                if (!this.canRedo()) return;
                                this.index++;
                                this.onChange();
                                return this.items[this.index];
                            }
                        },
                        {
                            key: "canUndo",
                            value: function canUndo() {
                                return this.index > 0;
                            }
                        },
                        {
                            key: "canRedo",
                            value: function canRedo() {
                                return this.index < this.items.length - 1;
                            }
                        },
                        {
                            key: "clear",
                            value: function clear() {
                                this.items = [];
                                this.index = -1;
                                this.onChange();
                            }
                        }
                    ]);
                }();
                // EXTERNAL MODULE: ./src/js/i18n.js
                var i18n = __webpack_require__(57);
                // EXTERNAL MODULE: ./src/js/jmespathQuery.js
                var jmespathQuery = __webpack_require__(359);
                // EXTERNAL MODULE: ./src/js/ModeSwitcher.js
                var ModeSwitcher = __webpack_require__(389);
                // EXTERNAL MODULE: ./src/js/showSortModal.js
                var showSortModal = __webpack_require__(915);
                // EXTERNAL MODULE: ./src/js/showTransformModal.js + 1 modules
                var showTransformModal = __webpack_require__(609);
                // EXTERNAL MODULE: ./src/js/textmode.js + 2 modules
                var textmode = __webpack_require__(948);
                // EXTERNAL MODULE: ./src/js/util.js
                var util = __webpack_require__(237);
                var previewmode_textmode = textmode.textModeMixins[0].mixin;
                // create a mixin with the functions for text mode
                var previewmode = {};
                /**
 * Create a JSON document preview, suitable for processing of large documents
 * @param {Element} container
 * @param {Object} [options]   Object with options. See docs for details.
 * @private
 */ previewmode.create = function(container) {
                    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                    if (typeof options.statusBar === 'undefined') options.statusBar = true;
                    // setting default for previewmode
                    options.mainMenuBar = options.mainMenuBar !== false;
                    options.enableSort = options.enableSort !== false;
                    options.enableTransform = options.enableTransform !== false;
                    options.createQuery = options.createQuery || jmespathQuery /* createQuery */ .V;
                    options.executeQuery = options.executeQuery || jmespathQuery /* executeQuery */ .e;
                    this.options = options;
                    // indentation
                    if (typeof options.indentation === 'number') this.indentation = Number(options.indentation);
                    else this.indentation = 2; // number of spaces
                    // language
                    (0, i18n /* setLanguages */ .AI)(this.options.languages);
                    (0, i18n /* setLanguage */ .xC)(this.options.language);
                    // determine mode
                    this.mode = 'preview';
                    var me = this;
                    this.container = container;
                    this.dom = {};
                    this.json = undefined;
                    this.text = '';
                    // TODO: JSON Schema support
                    // create a debounced validate function
                    this._debouncedValidate = (0, util.debounce)(this.validate.bind(this), this.DEBOUNCE_INTERVAL);
                    this.width = container.clientWidth;
                    this.height = container.clientHeight;
                    this.frame = document.createElement('div');
                    this.frame.className = 'jsoneditor jsoneditor-mode-preview';
                    this.frame.onclick = function(event) {
                        // prevent default submit action when the editor is located inside a form
                        event.preventDefault();
                    };
                    // setting the FocusTracker on 'this.frame' to track the editor's focus event
                    var focusTrackerConfig = {
                        target: this.frame,
                        onFocus: this.options.onFocus || null,
                        onBlur: this.options.onBlur || null
                    };
                    this.frameFocusTracker = new FocusTracker /* FocusTracker */ .$(focusTrackerConfig);
                    this.content = document.createElement('div');
                    this.content.className = 'jsoneditor-outer';
                    this.dom.busy = document.createElement('div');
                    this.dom.busy.className = 'jsoneditor-busy';
                    this.dom.busyContent = document.createElement('span');
                    this.dom.busyContent.textContent = 'busy...';
                    this.dom.busy.appendChild(this.dom.busyContent);
                    this.content.appendChild(this.dom.busy);
                    this.dom.previewContent = document.createElement('pre');
                    this.dom.previewContent.className = 'jsoneditor-preview';
                    this.dom.previewText = document.createTextNode('');
                    this.dom.previewContent.appendChild(this.dom.previewText);
                    this.content.appendChild(this.dom.previewContent);
                    if (this.options.mainMenuBar) {
                        (0, util.addClassName)(this.content, 'has-main-menu-bar');
                        // create menu
                        this.menu = document.createElement('div');
                        this.menu.className = 'jsoneditor-menu';
                        this.frame.appendChild(this.menu);
                        // create format button
                        var buttonFormat = document.createElement('button');
                        buttonFormat.type = 'button';
                        buttonFormat.className = 'jsoneditor-format';
                        buttonFormat.title = (0, i18n /* translate */ .Tl)('formatTitle');
                        this.menu.appendChild(buttonFormat);
                        buttonFormat.onclick = function handleFormat() {
                            me.executeWithBusyMessage(function() {
                                try {
                                    me.format();
                                } catch (err) {
                                    me._onError(err);
                                }
                            }, 'formatting...');
                        };
                        // create compact button
                        var buttonCompact = document.createElement('button');
                        buttonCompact.type = 'button';
                        buttonCompact.className = 'jsoneditor-compact';
                        buttonCompact.title = (0, i18n /* translate */ .Tl)('compactTitle');
                        this.menu.appendChild(buttonCompact);
                        buttonCompact.onclick = function handleCompact() {
                            me.executeWithBusyMessage(function() {
                                try {
                                    me.compact();
                                } catch (err) {
                                    me._onError(err);
                                }
                            }, 'compacting...');
                        };
                        // create sort button
                        if (this.options.enableSort) {
                            var _sort = document.createElement('button');
                            _sort.type = 'button';
                            _sort.className = 'jsoneditor-sort';
                            _sort.title = (0, i18n /* translate */ .Tl)('sortTitleShort');
                            _sort.onclick = function() {
                                me._showSortModal();
                            };
                            this.menu.appendChild(_sort);
                        }
                        // create transform button
                        if (this.options.enableTransform) {
                            var transform = document.createElement('button');
                            transform.type = 'button';
                            transform.title = (0, i18n /* translate */ .Tl)('transformTitleShort');
                            transform.className = 'jsoneditor-transform';
                            transform.onclick = function() {
                                me._showTransformModal();
                            };
                            this.dom.transform = transform;
                            this.menu.appendChild(transform);
                        }
                        // create repair button
                        var buttonRepair = document.createElement('button');
                        buttonRepair.type = 'button';
                        buttonRepair.className = 'jsoneditor-repair';
                        buttonRepair.title = (0, i18n /* translate */ .Tl)('repairTitle');
                        this.menu.appendChild(buttonRepair);
                        buttonRepair.onclick = function() {
                            if (me.json === undefined) // only repair if we don't have valid JSON
                            me.executeWithBusyMessage(function() {
                                try {
                                    me.repair();
                                } catch (err) {
                                    me._onError(err);
                                }
                            }, 'repairing...');
                        };
                        // create history and undo/redo buttons
                        if (this.options.history !== false) {
                            // default option value is true
                            var onHistoryChange = function onHistoryChange() {
                                me.dom.undo.disabled = !me.history.canUndo();
                                me.dom.redo.disabled = !me.history.canRedo();
                            };
                            var calculateItemSize = function calculateItemSize(item) {
                                return(// times two to account for the json object
                                item.text.length * 2);
                            };
                            this.history = new History(onHistoryChange, calculateItemSize, constants /* PREVIEW_HISTORY_LIMIT */ .SC);
                            // create undo button
                            var undo = document.createElement('button');
                            undo.type = 'button';
                            undo.className = 'jsoneditor-undo jsoneditor-separator';
                            undo.title = (0, i18n /* translate */ .Tl)('undo');
                            undo.onclick = function() {
                                var action = me.history.undo();
                                if (action) me._applyHistory(action);
                            };
                            this.menu.appendChild(undo);
                            this.dom.undo = undo;
                            // create redo button
                            var redo = document.createElement('button');
                            redo.type = 'button';
                            redo.className = 'jsoneditor-redo';
                            redo.title = (0, i18n /* translate */ .Tl)('redo');
                            redo.onclick = function() {
                                var action = me.history.redo();
                                if (action) me._applyHistory(action);
                            };
                            this.menu.appendChild(redo);
                            this.dom.redo = redo;
                            // force enabling/disabling the undo/redo button
                            this.history.onChange();
                        }
                        // create mode box
                        if (this.options && this.options.modes && this.options.modes.length) this.modeSwitcher = new ModeSwitcher /* ModeSwitcher */ .n(this.menu, this.options.modes, this.options.mode, function onSwitch(mode) {
                            // switch mode and restore focus
                            try {
                                me.setMode(mode);
                                me.modeSwitcher.focus();
                            } catch (err) {
                                me._onError(err);
                            }
                        });
                    }
                    var errorTableVisible = Array.isArray(this.options.showErrorTable) ? this.options.showErrorTable.includes(this.mode) : this.options.showErrorTable === true;
                    this.errorTable = new ErrorTable /* ErrorTable */ .N({
                        errorTableVisible: errorTableVisible,
                        onToggleVisibility: function onToggleVisibility() {
                            me.validate();
                        },
                        onFocusLine: null,
                        onChangeHeight: function onChangeHeight(height) {
                            // TODO: change CSS to using flex box, remove setting height using JavaScript
                            var statusBarHeight = me.dom.statusBar ? me.dom.statusBar.clientHeight : 0;
                            var totalHeight = height + statusBarHeight + 1;
                            me.content.style.marginBottom = -totalHeight + 'px';
                            me.content.style.paddingBottom = totalHeight + 'px';
                        }
                    });
                    this.frame.appendChild(this.content);
                    this.frame.appendChild(this.errorTable.getErrorTable());
                    this.container.appendChild(this.frame);
                    if (options.statusBar) {
                        (0, util.addClassName)(this.content, 'has-status-bar');
                        var statusBar = document.createElement('div');
                        this.dom.statusBar = statusBar;
                        statusBar.className = 'jsoneditor-statusbar';
                        this.frame.appendChild(statusBar);
                        this.dom.fileSizeInfo = document.createElement('span');
                        this.dom.fileSizeInfo.className = 'jsoneditor-size-info';
                        this.dom.fileSizeInfo.innerText = '';
                        statusBar.appendChild(this.dom.fileSizeInfo);
                        this.dom.arrayInfo = document.createElement('span');
                        this.dom.arrayInfo.className = 'jsoneditor-size-info';
                        this.dom.arrayInfo.innerText = '';
                        statusBar.appendChild(this.dom.arrayInfo);
                        statusBar.appendChild(this.errorTable.getErrorCounter());
                        statusBar.appendChild(this.errorTable.getWarningIcon());
                        statusBar.appendChild(this.errorTable.getErrorIcon());
                    }
                    this._renderPreview();
                    this.setSchema(this.options.schema, this.options.schemaRefs);
                };
                previewmode._renderPreview = function() {
                    var text = this.getText();
                    this.dom.previewText.nodeValue = (0, util.limitCharacters)(text, constants /* MAX_PREVIEW_CHARACTERS */ .hJ);
                    if (this.dom.fileSizeInfo) this.dom.fileSizeInfo.innerText = 'Size: ' + (0, util.formatSize)(text.length);
                    if (this.dom.arrayInfo) {
                        if (Array.isArray(this.json)) this.dom.arrayInfo.innerText = 'Array: ' + this.json.length + ' items';
                        else this.dom.arrayInfo.innerText = '';
                    }
                };
                /**
 * Handle a change:
 * - Validate JSON schema
 * - Send a callback to the onChange listener if provided
 * @private
 */ previewmode._onChange = function() {
                    // validate JSON schema (if configured)
                    this._debouncedValidate();
                    // trigger the onChange callback
                    if (this.options.onChange) try {
                        this.options.onChange();
                    } catch (err) {
                        console.error('Error in onChange callback: ', err);
                    }
                    // trigger the onChangeJSON callback
                    if (this.options.onChangeJSON) try {
                        this.options.onChangeJSON(this.get());
                    } catch (err) {
                        console.error('Error in onChangeJSON callback: ', err);
                    }
                    // trigger the onChangeText callback
                    if (this.options.onChangeText) try {
                        this.options.onChangeText(this.getText());
                    } catch (err) {
                        console.error('Error in onChangeText callback: ', err);
                    }
                };
                /**
 * Open a sort modal
 * @private
 */ previewmode._showSortModal = function() {
                    var me = this;
                    function onSort(json, sortedBy) {
                        if (Array.isArray(json)) {
                            var sortedArray = (0, util.sort)(json, sortedBy.path, sortedBy.direction);
                            me.sortedBy = sortedBy;
                            me._setAndFireOnChange(sortedArray);
                        }
                        if ((0, util.isObject)(json)) {
                            var sortedObject = (0, util.sortObjectKeys)(json, sortedBy.direction);
                            me.sortedBy = sortedBy;
                            me._setAndFireOnChange(sortedObject);
                        }
                    }
                    this.executeWithBusyMessage(function() {
                        var container = me.options.modalAnchor || constants /* DEFAULT_MODAL_ANCHOR */ .ai;
                        var json = me.get();
                        me._renderPreview(); // update array count
                        (0, showSortModal.showSortModal)(container, json, function(sortedBy) {
                            me.executeWithBusyMessage(function() {
                                onSort(json, sortedBy);
                            }, 'sorting...');
                        }, me.sortedBy);
                    }, 'parsing...');
                };
                /**
 * Open a transform modal
 * @private
 */ previewmode._showTransformModal = function() {
                    var _this = this;
                    this.executeWithBusyMessage(function() {
                        var _this$options = _this.options, createQuery = _this$options.createQuery, executeQuery = _this$options.executeQuery, modalAnchor = _this$options.modalAnchor, queryDescription = _this$options.queryDescription;
                        var json = _this.get();
                        _this._renderPreview(); // update array count
                        (0, showTransformModal.showTransformModal)({
                            container: modalAnchor || constants /* DEFAULT_MODAL_ANCHOR */ .ai,
                            json: json,
                            queryDescription: queryDescription,
                            // can be undefined
                            createQuery: createQuery,
                            executeQuery: executeQuery,
                            onTransform: function onTransform(query) {
                                _this.executeWithBusyMessage(function() {
                                    var updatedJson = executeQuery(json, query);
                                    _this._setAndFireOnChange(updatedJson);
                                }, 'transforming...');
                            }
                        });
                    }, 'parsing...');
                };
                /**
 * Destroy the editor. Clean up DOM, event listeners, and web workers.
 */ previewmode.destroy = function() {
                    if (this.frame && this.container && this.frame.parentNode === this.container) this.container.removeChild(this.frame);
                    if (this.modeSwitcher) {
                        this.modeSwitcher.destroy();
                        this.modeSwitcher = null;
                    }
                    this._debouncedValidate = null;
                    if (this.history) {
                        this.history.clear();
                        this.history = null;
                    }
                    // Removing the FocusTracker set to track the editor's focus event
                    this.frameFocusTracker.destroy();
                };
                /**
 * Compact the code in the text editor
 */ previewmode.compact = function() {
                    var json = this.get();
                    var text = JSON.stringify(json);
                    // we know that in this case the json is still the same, so we pass json too
                    this._setTextAndFireOnChange(text, json);
                };
                /**
 * Format the code in the text editor
 */ previewmode.format = function() {
                    var json = this.get();
                    var text = JSON.stringify(json, null, this.indentation);
                    // we know that in this case the json is still the same, so we pass json too
                    this._setTextAndFireOnChange(text, json);
                };
                /**
 * Repair the code in the text editor
 */ previewmode.repair = function() {
                    var text = this.getText();
                    try {
                        var repairedText = (0, jsonrepair /* jsonrepair */ .m)(text);
                        this._setTextAndFireOnChange(repairedText);
                    } catch (err) {
                    // repair was not successful, do nothing
                    }
                };
                /**
 * Set focus to the editor
 */ previewmode.focus = function() {
                    // we don't really have a place to focus,
                    // let's focus on the transform button
                    this.dom.transform.focus();
                };
                /**
 * Set json data in the editor
 * @param {*} json
 */ previewmode.set = function(json) {
                    if (this.history) this.history.clear();
                    this._set(json);
                };
                /**
 * Update data. Same as calling `set` in text/code mode.
 * @param {*} json
 */ previewmode.update = function(json) {
                    this._set(json);
                };
                /**
 * Set json data
 * @param {*} json
 */ previewmode._set = function(json) {
                    this.text = undefined;
                    this.json = json;
                    this._renderPreview();
                    this._pushHistory();
                    // validate JSON schema
                    this._debouncedValidate();
                };
                previewmode._setAndFireOnChange = function(json) {
                    this._set(json);
                    this._onChange();
                };
                /**
 * Get json data
 * @return {*} json
 */ previewmode.get = function() {
                    if (this.json === undefined) {
                        var text = this.getText();
                        this.json = (0, util.parse)(text); // this can throw an error
                    }
                    return this.json;
                };
                /**
 * Get the text contents of the editor
 * @return {String} jsonText
 */ previewmode.getText = function() {
                    if (this.text === undefined) {
                        this.text = JSON.stringify(this.json, null, this.indentation);
                        if (this.options.escapeUnicode === true) this.text = (0, util.escapeUnicodeChars)(this.text);
                    }
                    return this.text;
                };
                /**
 * Set the text contents of the editor
 * @param {String} jsonText
 */ previewmode.setText = function(jsonText) {
                    if (this.history) this.history.clear();
                    this._setText(jsonText);
                };
                /**
 * Update the text contents
 * @param {string} jsonText
 */ previewmode.updateText = function(jsonText) {
                    // don't update if there are no changes
                    if (this.getText() === jsonText) return;
                    this._setText(jsonText);
                };
                /**
 * Set the text contents of the editor
 * @param {string} jsonText
 * @param {*} [json] Optional JSON instance of the text
 * @private
 */ previewmode._setText = function(jsonText, json) {
                    if (this.options.escapeUnicode === true) this.text = (0, util.escapeUnicodeChars)(jsonText);
                    else this.text = jsonText;
                    this.json = json;
                    this._renderPreview();
                    if (this.json === undefined) {
                        var me = this;
                        this.executeWithBusyMessage(function() {
                            try {
                                // force parsing the json now, else it will be done in validate without feedback
                                me.json = me.get();
                                me._renderPreview();
                                me._pushHistory();
                            } catch (err) {
                            // no need to throw an error, validation will show an error
                            }
                        }, 'parsing...');
                    } else this._pushHistory();
                    this._debouncedValidate();
                };
                /**
 * Set text and fire onChange callback
 * @param {string} jsonText
 * @param {*} [json] Optional JSON instance of the text
 * @private
 */ previewmode._setTextAndFireOnChange = function(jsonText, json) {
                    this._setText(jsonText, json);
                    this._onChange();
                };
                /**
 * Apply history to the current state
 * @param {{json?: JSON, text?: string}} action
 * @private
 */ previewmode._applyHistory = function(action) {
                    this.json = action.json;
                    this.text = action.text;
                    this._renderPreview();
                    this._debouncedValidate();
                };
                /**
 * Push the current state to history
 * @private
 */ previewmode._pushHistory = function() {
                    if (!this.history) return;
                    var action = {
                        text: this.text,
                        json: this.json
                    };
                    this.history.add(action);
                };
                /**
 * Execute a heavy, blocking action.
 * Before starting the action, show a message on screen like "parsing..."
 * @param {function} fn
 * @param {string} message
 */ previewmode.executeWithBusyMessage = function(fn, message) {
                    var size = this.getText().length;
                    if (size > constants /* SIZE_LARGE */ .Oq) {
                        var me = this;
                        (0, util.addClassName)(me.frame, 'busy');
                        me.dom.busyContent.innerText = message;
                        setTimeout(function() {
                            fn();
                            (0, util.removeClassName)(me.frame, 'busy');
                            me.dom.busyContent.innerText = '';
                        }, 100);
                    } else fn();
                };
                // TODO: refactor into composable functions instead of this shaky mixin-like structure
                previewmode.validate = previewmode_textmode.validate;
                previewmode._renderErrors = previewmode_textmode._renderErrors;
                // define modes
                var previewModeMixins = [
                    {
                        mode: 'preview',
                        mixin: previewmode,
                        data: 'json'
                    }
                ];
            /***/ },
            /***/ 545: /***/ function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {
                "use strict";
                /* harmony export */ __webpack_require__.d(__webpack_exports__, {
                    /* harmony export */ t: function() {
                        return /* binding */ ContextMenu;
                    }
                });
                /* harmony import */ var _createAbsoluteAnchor__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(925);
                /* harmony import */ var _util__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(237);
                /* harmony import */ var _i18n__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(57);
                function _typeof(o) {
                    "@babel/helpers - typeof";
                    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
                        return typeof o;
                    } : function(o) {
                        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
                    }, _typeof(o);
                }
                function _classCallCheck(a, n) {
                    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
                }
                function _defineProperties(e, r) {
                    for(var t = 0; t < r.length; t++){
                        var o = r[t];
                        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
                    }
                }
                function _createClass(e, r, t) {
                    return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
                        writable: !1
                    }), e;
                }
                function _toPropertyKey(t) {
                    var i = _toPrimitive(t, "string");
                    return "symbol" == _typeof(i) ? i : i + "";
                }
                function _toPrimitive(t, r) {
                    if ("object" != _typeof(t) || !t) return t;
                    var e = t[Symbol.toPrimitive];
                    if (void 0 !== e) {
                        var i = e.call(t, r || "default");
                        if ("object" != _typeof(i)) return i;
                        throw new TypeError("@@toPrimitive must return a primitive value.");
                    }
                    return ("string" === r ? String : Number)(t);
                }
                /**
 * A context menu
 * @param {Object[]} items    Array containing the menu structure
 *                            TODO: describe structure
 * @param {Object} [options]  Object with options. Available options:
 *                            {function} close        Callback called when the
 *                                                    context menu is being closed.
 *                            {boolean} limitHeight   Whether ContextMenu height should be
 *                                                    limited or not.
 * @constructor
 */ var ContextMenu = /*#__PURE__*/ function() {
                    function ContextMenu(items, options) {
                        _classCallCheck(this, ContextMenu);
                        this.dom = {};
                        var me = this;
                        var dom = this.dom;
                        this.anchor = undefined;
                        this.items = items;
                        this.eventListeners = {};
                        this.selection = undefined; // holds the selection before the menu was opened
                        this.onClose = options ? options.close : undefined;
                        this.limitHeight = options ? options.limitHeight : false;
                        // create root element
                        var root = document.createElement('div');
                        root.className = 'jsoneditor-contextmenu-root';
                        dom.root = root;
                        // create a container element
                        var menu = document.createElement('div');
                        menu.className = 'jsoneditor-contextmenu';
                        dom.menu = menu;
                        root.appendChild(menu);
                        // create a list to hold the menu items
                        var list = document.createElement('ul');
                        list.className = 'jsoneditor-menu';
                        menu.appendChild(list);
                        dom.list = list;
                        dom.items = []; // list with all buttons
                        // create a (non-visible) button to set the focus to the menu
                        var focusButton = document.createElement('button');
                        focusButton.type = 'button';
                        dom.focusButton = focusButton;
                        var li = document.createElement('li');
                        li.style.overflow = 'hidden';
                        li.style.height = '0';
                        li.appendChild(focusButton);
                        list.appendChild(li);
                        function createMenuItems(list, domItems, items) {
                            items.forEach(function(item) {
                                if (item.type === 'separator') {
                                    // create a separator
                                    var separator = document.createElement('div');
                                    separator.className = 'jsoneditor-separator';
                                    var _li = document.createElement('li');
                                    _li.appendChild(separator);
                                    list.appendChild(_li);
                                } else {
                                    var domItem = {};
                                    // create a menu item
                                    var _li2 = document.createElement('li');
                                    list.appendChild(_li2);
                                    // create a button in the menu item
                                    var button = document.createElement('button');
                                    button.type = 'button';
                                    button.className = item.className;
                                    domItem.button = button;
                                    if (item.title) button.title = item.title;
                                    if (item.click) button.onclick = function(event) {
                                        event.preventDefault();
                                        me.hide();
                                        item.click();
                                    };
                                    _li2.appendChild(button);
                                    // create the contents of the button
                                    if (item.submenu) {
                                        // add the icon to the button
                                        var divIcon = document.createElement('div');
                                        divIcon.className = 'jsoneditor-icon';
                                        button.appendChild(divIcon);
                                        var divText = document.createElement('div');
                                        divText.className = 'jsoneditor-text' + (item.click ? '' : ' jsoneditor-right-margin');
                                        divText.appendChild(document.createTextNode(item.text));
                                        button.appendChild(divText);
                                        var buttonSubmenu;
                                        if (item.click) {
                                            // submenu and a button with a click handler
                                            button.className += ' jsoneditor-default';
                                            var buttonExpand = document.createElement('button');
                                            buttonExpand.type = 'button';
                                            domItem.buttonExpand = buttonExpand;
                                            buttonExpand.className = 'jsoneditor-expand';
                                            var buttonExpandInner = document.createElement('div');
                                            buttonExpandInner.className = 'jsoneditor-expand';
                                            buttonExpand.appendChild(buttonExpandInner);
                                            _li2.appendChild(buttonExpand);
                                            if (item.submenuTitle) buttonExpand.title = item.submenuTitle;
                                            buttonSubmenu = buttonExpand;
                                        } else {
                                            // submenu and a button without a click handler
                                            var divExpand = document.createElement('div');
                                            divExpand.className = 'jsoneditor-expand';
                                            button.appendChild(divExpand);
                                            buttonSubmenu = button;
                                        }
                                        // attach a handler to expand/collapse the submenu
                                        buttonSubmenu.onclick = function(event) {
                                            event.preventDefault();
                                            me._onExpandItem(domItem);
                                            buttonSubmenu.focus();
                                        };
                                        // create the submenu
                                        var domSubItems = [];
                                        domItem.subItems = domSubItems;
                                        var ul = document.createElement('ul');
                                        domItem.ul = ul;
                                        ul.className = 'jsoneditor-menu';
                                        ul.style.height = '0';
                                        _li2.appendChild(ul);
                                        createMenuItems(ul, domSubItems, item.submenu);
                                    } else {
                                        // no submenu, just a button with clickhandler
                                        var icon = document.createElement('div');
                                        icon.className = 'jsoneditor-icon';
                                        button.appendChild(icon);
                                        var text = document.createElement('div');
                                        text.className = 'jsoneditor-text';
                                        text.appendChild(document.createTextNode((0, _i18n__WEBPACK_IMPORTED_MODULE_2__ /* .translate */ .Tl)(item.text)));
                                        button.appendChild(text);
                                    }
                                    domItems.push(domItem);
                                }
                            });
                        }
                        createMenuItems(list, this.dom.items, items);
                        // TODO: when the editor is small, show the submenu on the right instead of inline?
                        // calculate the max height of the menu with one submenu expanded
                        this.maxHeight = 0; // height in pixels
                        items.forEach(function(item) {
                            var height = (items.length + (item.submenu ? item.submenu.length : 0)) * 24;
                            me.maxHeight = Math.max(me.maxHeight, height);
                        });
                    }
                    /**
   * Get the currently visible buttons
   * @return {Array.<HTMLElement>} buttons
   * @private
   */ return _createClass(ContextMenu, [
                        {
                            key: "_getVisibleButtons",
                            value: function _getVisibleButtons() {
                                var buttons = [];
                                var me = this;
                                this.dom.items.forEach(function(item) {
                                    buttons.push(item.button);
                                    if (item.buttonExpand) buttons.push(item.buttonExpand);
                                    if (item.subItems && item === me.expandedItem) item.subItems.forEach(function(subItem) {
                                        buttons.push(subItem.button);
                                        if (subItem.buttonExpand) buttons.push(subItem.buttonExpand);
                                    // TODO: change to fully recursive method
                                    });
                                });
                                return buttons;
                            }
                        },
                        {
                            key: "show",
                            value: function show(anchor, frame, ignoreParent) {
                                this.hide();
                                // determine whether to display the menu below or above the anchor
                                var showBelow = true;
                                var parent = anchor.parentNode;
                                var anchorRect = anchor.getBoundingClientRect();
                                var parentRect = parent.getBoundingClientRect();
                                var frameRect = frame.getBoundingClientRect();
                                var me = this;
                                this.dom.absoluteAnchor = (0, _createAbsoluteAnchor__WEBPACK_IMPORTED_MODULE_0__ /* .createAbsoluteAnchor */ .p)(anchor, frame, function() {
                                    me.hide();
                                });
                                if (anchorRect.bottom + this.maxHeight < frameRect.bottom) ;
                                else if (anchorRect.top - this.maxHeight > frameRect.top) // fits above -> show above
                                showBelow = false;
                                var topGap = ignoreParent ? 0 : anchorRect.top - parentRect.top;
                                // position the menu
                                if (showBelow) {
                                    // display the menu below the anchor
                                    var anchorHeight = anchor.offsetHeight;
                                    this.dom.menu.style.left = '0';
                                    this.dom.menu.style.top = topGap + anchorHeight + 'px';
                                    this.dom.menu.style.bottom = '';
                                } else {
                                    // display the menu above the anchor
                                    this.dom.menu.style.left = '0';
                                    this.dom.menu.style.top = '';
                                    this.dom.menu.style.bottom = '0px';
                                }
                                if (this.limitHeight) {
                                    var margin = 10; // make sure there is a little margin left
                                    var maxPossibleMenuHeight = showBelow ? frameRect.bottom - anchorRect.bottom - margin : anchorRect.top - frameRect.top - margin;
                                    this.dom.list.style.maxHeight = maxPossibleMenuHeight + 'px';
                                    this.dom.list.style.overflowY = 'auto';
                                }
                                // attach the menu to the temporary, absolute anchor
                                // parent.insertBefore(this.dom.root, anchor);
                                this.dom.absoluteAnchor.appendChild(this.dom.root);
                                // move focus to the first button in the context menu
                                this.selection = (0, _util__WEBPACK_IMPORTED_MODULE_1__.getSelection)();
                                this.anchor = anchor;
                                setTimeout(function() {
                                    me.dom.focusButton.focus();
                                }, 0);
                                if (ContextMenu.visibleMenu) ContextMenu.visibleMenu.hide();
                                ContextMenu.visibleMenu = this;
                            }
                        },
                        {
                            key: "hide",
                            value: function hide() {
                                // remove temporary absolutely positioned anchor
                                if (this.dom.absoluteAnchor) {
                                    this.dom.absoluteAnchor.destroy();
                                    delete this.dom.absoluteAnchor;
                                }
                                // remove the menu from the DOM
                                if (this.dom.root.parentNode) {
                                    this.dom.root.parentNode.removeChild(this.dom.root);
                                    if (this.onClose) this.onClose();
                                }
                                if (ContextMenu.visibleMenu === this) ContextMenu.visibleMenu = undefined;
                            }
                        },
                        {
                            key: "_onExpandItem",
                            value: function _onExpandItem(domItem) {
                                var me = this;
                                var alreadyVisible = domItem === this.expandedItem;
                                // hide the currently visible submenu
                                var expandedItem = this.expandedItem;
                                if (expandedItem) {
                                    // var ul = expandedItem.ul;
                                    expandedItem.ul.style.height = '0';
                                    expandedItem.ul.style.padding = '';
                                    setTimeout(function() {
                                        if (me.expandedItem !== expandedItem) {
                                            expandedItem.ul.style.display = '';
                                            (0, _util__WEBPACK_IMPORTED_MODULE_1__.removeClassName)(expandedItem.ul.parentNode, 'jsoneditor-selected');
                                        }
                                    }, 300); // timeout duration must match the css transition duration
                                    this.expandedItem = undefined;
                                }
                                if (!alreadyVisible) {
                                    var ul = domItem.ul;
                                    ul.style.display = 'block';
                                    // eslint-disable-next-line no-unused-expressions
                                    ul.clientHeight; // force a reflow in Firefox
                                    setTimeout(function() {
                                        if (me.expandedItem === domItem) {
                                            var childsHeight = 0;
                                            for(var i = 0; i < ul.childNodes.length; i++)childsHeight += ul.childNodes[i].clientHeight;
                                            ul.style.height = childsHeight + 'px';
                                            ul.style.padding = '5px 10px';
                                        }
                                    }, 0);
                                    (0, _util__WEBPACK_IMPORTED_MODULE_1__.addClassName)(ul.parentNode, 'jsoneditor-selected');
                                    this.expandedItem = domItem;
                                }
                            }
                        },
                        {
                            key: "_onKeyDown",
                            value: function _onKeyDown(event) {
                                var target = event.target;
                                var keynum = event.which;
                                var handled = false;
                                var buttons, targetIndex, prevButton, nextButton;
                                if (keynum === 27) {
                                    // ESC
                                    // hide the menu on ESC key
                                    // restore previous selection and focus
                                    if (this.selection) (0, _util__WEBPACK_IMPORTED_MODULE_1__.setSelection)(this.selection);
                                    if (this.anchor) this.anchor.focus();
                                    this.hide();
                                    handled = true;
                                } else if (keynum === 9) {
                                    // Tab
                                    if (!event.shiftKey) {
                                        // Tab
                                        buttons = this._getVisibleButtons();
                                        targetIndex = buttons.indexOf(target);
                                        if (targetIndex === buttons.length - 1) {
                                            // move to first button
                                            buttons[0].focus();
                                            handled = true;
                                        }
                                    } else {
                                        // Shift+Tab
                                        buttons = this._getVisibleButtons();
                                        targetIndex = buttons.indexOf(target);
                                        if (targetIndex === 0) {
                                            // move to last button
                                            buttons[buttons.length - 1].focus();
                                            handled = true;
                                        }
                                    }
                                } else if (keynum === 37) {
                                    // Arrow Left
                                    if (target.className === 'jsoneditor-expand') {
                                        buttons = this._getVisibleButtons();
                                        targetIndex = buttons.indexOf(target);
                                        prevButton = buttons[targetIndex - 1];
                                        if (prevButton) prevButton.focus();
                                    }
                                    handled = true;
                                } else if (keynum === 38) {
                                    // Arrow Up
                                    buttons = this._getVisibleButtons();
                                    targetIndex = buttons.indexOf(target);
                                    prevButton = buttons[targetIndex - 1];
                                    if (prevButton && prevButton.className === 'jsoneditor-expand') // skip expand button
                                    prevButton = buttons[targetIndex - 2];
                                    if (!prevButton) // move to last button
                                    prevButton = buttons[buttons.length - 1];
                                    if (prevButton) prevButton.focus();
                                    handled = true;
                                } else if (keynum === 39) {
                                    // Arrow Right
                                    buttons = this._getVisibleButtons();
                                    targetIndex = buttons.indexOf(target);
                                    nextButton = buttons[targetIndex + 1];
                                    if (nextButton && nextButton.className === 'jsoneditor-expand') nextButton.focus();
                                    handled = true;
                                } else if (keynum === 40) {
                                    // Arrow Down
                                    buttons = this._getVisibleButtons();
                                    targetIndex = buttons.indexOf(target);
                                    nextButton = buttons[targetIndex + 1];
                                    if (nextButton && nextButton.className === 'jsoneditor-expand') // skip expand button
                                    nextButton = buttons[targetIndex + 2];
                                    if (!nextButton) // move to first button
                                    nextButton = buttons[0];
                                    if (nextButton) {
                                        nextButton.focus();
                                        handled = true;
                                    }
                                    handled = true;
                                }
                                // TODO: arrow left and right
                                if (handled) {
                                    event.stopPropagation();
                                    event.preventDefault();
                                }
                            }
                        }
                    ]);
                }();
                // currently displayed context menu, a singleton. We may only have one visible context menu
                ContextMenu.visibleMenu = undefined;
            /***/ },
            /***/ 609: /***/ function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {
                "use strict";
                // ESM COMPAT FLAG
                __webpack_require__.r(__webpack_exports__);
                // EXPORTS
                __webpack_require__.d(__webpack_exports__, {
                    showTransformModal: function() {
                        return /* binding */ showTransformModal;
                    }
                });
                // EXTERNAL MODULE: ./node_modules/picomodal/src/picoModal.js
                var picoModal = __webpack_require__(340);
                var picoModal_default = /*#__PURE__*/ __webpack_require__.n(picoModal);
                // EXTERNAL MODULE: ./src/js/assets/selectr/selectr.js
                var selectr = __webpack_require__(772);
                var selectr_default = /*#__PURE__*/ __webpack_require__.n(selectr);
                // EXTERNAL MODULE: ./src/js/i18n.js
                var i18n = __webpack_require__(57);
                /**
 * Convert part of a JSON object to a JSON string.
 * Use case is to stringify a small part of a large JSON object so you can see
 * a preview.
 *
 * @param {*} value
 * The value to convert to a JSON string.
 *
 * @param {number | string | null} [space]
 * A String or Number object that's used to insert white space into the output
 * JSON string for readability purposes. If this is a Number, it indicates the
 * number of space characters to use as white space; this number is capped at 10
 * if it's larger than that. Values less than 1 indicate that no space should be
 * used. If this is a String, the string (or the first 10 characters of the string,
 * if it's longer than that) is used as white space. If this parameter is not
 * provided (or is null), no white space is used.
 *
 * @param {number} [limit] Maximum size of the string output.
 *
 * @returns {string | undefined} Returns the string representation of the JSON object.
 */ function _typeof(o) {
                    "@babel/helpers - typeof";
                    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
                        return typeof o;
                    } : function(o) {
                        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
                    }, _typeof(o);
                }
                function stringifyPartial(value, space, limit) {
                    var _space; // undefined by default
                    if (typeof space === 'number') {
                        if (space > 10) _space = repeat(' ', 10);
                        else if (space >= 1) _space = repeat(' ', space);
                    // else ignore
                    } else if (typeof space === 'string' && space !== '') _space = space;
                    var output = stringifyValue(value, _space, '', limit);
                    return output.length > limit ? slice(output, limit) + '...' : output;
                }
                /**
 * Stringify a value
 * @param {*} value
 * @param {string} space
 * @param {string} indent
 * @param {number} limit
 * @return {string | undefined}
 */ function stringifyValue(value, space, indent, limit) {
                    // boolean, null, number, string, or date
                    if (typeof value === 'boolean' || value instanceof Boolean || value === null || typeof value === 'number' || value instanceof Number || typeof value === 'string' || value instanceof String || value instanceof Date) return JSON.stringify(value);
                    // array
                    if (Array.isArray(value)) return stringifyArray(value, space, indent, limit);
                    // object (test lastly!)
                    if (value && _typeof(value) === 'object') return stringifyObject(value, space, indent, limit);
                    return undefined;
                }
                /**
 * Stringify an array
 * @param {Array} array
 * @param {string} space
 * @param {string} indent
 * @param {number} limit
 * @return {string}
 */ function stringifyArray(array, space, indent, limit) {
                    var childIndent = space ? indent + space : undefined;
                    var str = space ? '[\n' : '[';
                    for(var i = 0; i < array.length; i++){
                        var item = array[i];
                        if (space) str += childIndent;
                        if (typeof item !== 'undefined' && typeof item !== 'function') str += stringifyValue(item, space, childIndent, limit);
                        else str += 'null';
                        if (i < array.length - 1) str += space ? ',\n' : ',';
                        // stop as soon as we're exceeding the limit
                        if (str.length > limit) return str + '...';
                    }
                    str += space ? '\n' + indent + ']' : ']';
                    return str;
                }
                /**
 * Stringify an object
 * @param {Object} object
 * @param {string} space
 * @param {string} indent
 * @param {number} limit
 * @return {string}
 */ function stringifyObject(object, space, indent, limit) {
                    var childIndent = space ? indent + space : undefined;
                    var first = true;
                    var str = space ? '{\n' : '{';
                    if (typeof object.toJSON === 'function') return stringifyValue(object.toJSON(), space, indent, limit);
                    for(var key in object)if (jsonUtils_hasOwnProperty(object, key)) {
                        var value = object[key];
                        if (first) first = false;
                        else str += space ? ',\n' : ',';
                        str += space ? childIndent + '"' + key + '": ' : '"' + key + '":';
                        str += stringifyValue(value, space, childIndent, limit);
                        // stop as soon as we're exceeding the limit
                        if (str.length > limit) return str + '...';
                    }
                    str += space ? '\n' + indent + '}' : '}';
                    return str;
                }
                /**
 * Repeat a string a number of times.
 * Simple linear solution, we only need up to 10 iterations in practice
 * @param {string} text
 * @param {number} times
 * @return {string}
 */ function repeat(text, times) {
                    var res = '';
                    while(times-- > 0)res += text;
                    return res;
                }
                /**
 * Limit the length of text
 * @param {string} text
 * @param {number} [limit]
 * @return {string}
 */ function slice(text, limit) {
                    return typeof limit === 'number' ? text.slice(0, limit) : text;
                }
                /**
 * Test whether some text contains a JSON array, i.e. the first
 * non-white space character is a [
 * @param {string} jsonText
 * @return {boolean}
 */ function containsArray(jsonText) {
                    return /^\s*\[/.test(jsonText);
                }
                function jsonUtils_hasOwnProperty(object, key) {
                    return Object.prototype.hasOwnProperty.call(object, key);
                }
                // EXTERNAL MODULE: ./src/js/util.js
                var util = __webpack_require__(237);
                // EXTERNAL MODULE: ./src/js/constants.js
                var constants = __webpack_require__(660);
                var DEFAULT_DESCRIPTION = 'Enter a <a href="http://jmespath.org" target="_blank">JMESPath</a> query to filter, sort, or transform the JSON data.<br/>To learn JMESPath, go to <a href="http://jmespath.org/tutorial.html" target="_blank">the interactive tutorial</a>.';
                /**
 * Show advanced filter and transform modal using JMESPath
 * @param {Object} params
 * @property {HTMLElement} container   The container where to center
 *                                     the modal and create an overlay
 * @property {JSON} json               The json data to be transformed
 * @property {string} [queryDescription] Optional custom description explaining
 *                                       the transform functionality
 * @property {function} createQuery    Function called to create a query
 *                                     from the wizard form
 * @property {function} executeQuery   Execute a query for the preview pane
 * @property {function} onTransform    Callback invoked with the created
 *                                     query as callback
 */ function showTransformModal(_ref) {
                    var container = _ref.container, json = _ref.json, _ref$queryDescription = _ref.queryDescription, queryDescription = _ref$queryDescription === void 0 ? DEFAULT_DESCRIPTION : _ref$queryDescription, createQuery = _ref.createQuery, executeQuery = _ref.executeQuery, onTransform = _ref.onTransform;
                    var value = json;
                    var content = '<div class="pico-modal-contents"><div class="pico-modal-header">' + (0, i18n /* translate */ .Tl)('transform') + '</div>' + '<p>' + queryDescription + '</p>' + '<div class="jsoneditor-jmespath-label">' + (0, i18n /* translate */ .Tl)('transformWizardLabel') + ' </div>' + '<div id="wizard" class="jsoneditor-jmespath-block jsoneditor-jmespath-wizard">' + '  <table class="jsoneditor-jmespath-wizard-table">' + '    <tbody>' + '      <tr>' + '        <th>' + (0, i18n /* translate */ .Tl)('transformWizardFilter') + '</th>' + '        <td class="jsoneditor-jmespath-filter">' + '          <div class="jsoneditor-inline jsoneditor-jmespath-filter-field" >' + '            <select id="filterField">' + '            </select>' + '          </div>' + '          <div class="jsoneditor-inline jsoneditor-jmespath-filter-relation" >' + '            <select id="filterRelation">' + '              <option value="==">==</option>' + '              <option value="!=">!=</option>' + '              <option value="<">&lt;</option>' + '              <option value="<=">&lt;=</option>' + '              <option value=">">&gt;</option>' + '              <option value=">=">&gt;=</option>' + '            </select>' + '          </div>' + '          <div class="jsoneditor-inline jsoneditor-jmespath-filter-value" >' + '            <input type="text" class="value" placeholder="value..." id="filterValue" />' + '          </div>' + '        </td>' + '      </tr>' + '      <tr>' + '        <th>' + (0, i18n /* translate */ .Tl)('transformWizardSortBy') + '</th>' + '        <td class="jsoneditor-jmespath-filter">' + '          <div class="jsoneditor-inline jsoneditor-jmespath-sort-field">' + '            <select id="sortField">' + '            </select>' + '          </div>' + '          <div class="jsoneditor-inline jsoneditor-jmespath-sort-order" >' + '            <select id="sortOrder">' + '              <option value="asc">Ascending</option>' + '              <option value="desc">Descending</option>' + '            </select>' + '          </div>' + '        </td>' + '      </tr>' + '      <tr id="selectFieldsPart">' + '        <th>' + (0, i18n /* translate */ .Tl)('transformWizardSelectFields') + '</th>' + '        <td class="jsoneditor-jmespath-filter">' + '          <select class="jsoneditor-jmespath-select-fields" id="selectFields" multiple></select>' + '        </td>' + '      </tr>' + '    </tbody>' + '  </table>' + '</div>' + '<div class="jsoneditor-jmespath-label">' + (0, i18n /* translate */ .Tl)('transformQueryLabel') + ' </div>' + '<div class="jsoneditor-jmespath-block">' + '  <textarea id="query" ' + '            rows="4" ' + '            autocomplete="off" ' + '            autocorrect="off" ' + '            autocapitalize="off" ' + '            spellcheck="false"' + '            title="' + (0, i18n /* translate */ .Tl)('transformQueryTitle') + '">[*]</textarea>' + '</div>' + '<div class="jsoneditor-jmespath-label">' + (0, i18n /* translate */ .Tl)('transformPreviewLabel') + ' </div>' + '<div class="jsoneditor-jmespath-block">' + '  <textarea id="preview" ' + '      class="jsoneditor-transform-preview"' + '      readonly> </textarea>' + '</div>' + '<div class="jsoneditor-jmespath-block jsoneditor-modal-actions">' + '  <input type="submit" id="ok" value="' + (0, i18n /* translate */ .Tl)('ok') + '" autofocus />' + '</div>' + '</div>';
                    picoModal_default()({
                        parent: container,
                        content: content,
                        overlayClass: 'jsoneditor-modal-overlay',
                        overlayStyles: {
                            backgroundColor: 'rgb(1,1,1)',
                            opacity: 0.3
                        },
                        modalClass: 'jsoneditor-modal jsoneditor-modal-transform',
                        focus: false
                    }).afterCreate(function(modal) {
                        var elem = modal.modalElem();
                        var wizard = elem.querySelector('#wizard');
                        var ok = elem.querySelector('#ok');
                        var filterField = elem.querySelector('#filterField');
                        var filterRelation = elem.querySelector('#filterRelation');
                        var filterValue = elem.querySelector('#filterValue');
                        var sortField = elem.querySelector('#sortField');
                        var sortOrder = elem.querySelector('#sortOrder');
                        var selectFields = elem.querySelector('#selectFields');
                        var query = elem.querySelector('#query');
                        var preview = elem.querySelector('#preview');
                        if (!Array.isArray(value)) {
                            wizard.style.fontStyle = 'italic';
                            wizard.textContent = '(wizard not available for objects, only for arrays)';
                        }
                        var sortablePaths = (0, util.getChildPaths)(json);
                        sortablePaths.forEach(function(path) {
                            var formattedPath = preprocessPath(path);
                            var filterOption = document.createElement('option');
                            filterOption.text = formattedPath;
                            filterOption.value = formattedPath;
                            filterField.appendChild(filterOption);
                            var sortOption = document.createElement('option');
                            sortOption.text = formattedPath;
                            sortOption.value = formattedPath;
                            sortField.appendChild(sortOption);
                        });
                        var selectablePaths = (0, util.getChildPaths)(json, true).filter(function(path) {
                            return path !== '';
                        });
                        if (selectablePaths.length > 0) selectablePaths.forEach(function(path) {
                            var formattedPath = preprocessPath(path);
                            var option = document.createElement('option');
                            option.text = formattedPath;
                            option.value = formattedPath;
                            selectFields.appendChild(option);
                        });
                        else {
                            var selectFieldsPart = elem.querySelector('#selectFieldsPart');
                            if (selectFieldsPart) selectFieldsPart.style.display = 'none';
                        }
                        var selectrFilterField = new (selectr_default())(filterField, {
                            defaultSelected: false,
                            clearable: true,
                            allowDeselect: true,
                            placeholder: 'field...'
                        });
                        var selectrFilterRelation = new (selectr_default())(filterRelation, {
                            defaultSelected: false,
                            clearable: true,
                            allowDeselect: true,
                            placeholder: 'compare...'
                        });
                        var selectrSortField = new (selectr_default())(sortField, {
                            defaultSelected: false,
                            clearable: true,
                            allowDeselect: true,
                            placeholder: 'field...'
                        });
                        var selectrSortOrder = new (selectr_default())(sortOrder, {
                            defaultSelected: false,
                            clearable: true,
                            allowDeselect: true,
                            placeholder: 'order...'
                        });
                        var selectrSelectFields = new (selectr_default())(selectFields, {
                            multiple: true,
                            clearable: true,
                            defaultSelected: false,
                            placeholder: 'select fields...'
                        });
                        selectrFilterField.on('selectr.change', generateQueryFromWizard);
                        selectrFilterRelation.on('selectr.change', generateQueryFromWizard);
                        filterValue.oninput = generateQueryFromWizard;
                        selectrSortField.on('selectr.change', generateQueryFromWizard);
                        selectrSortOrder.on('selectr.change', generateQueryFromWizard);
                        selectrSelectFields.on('selectr.change', generateQueryFromWizard);
                        elem.querySelector('.pico-modal-contents').onclick = function(event) {
                            // prevent the first clear button (in any select box) from getting
                            // focus when clicking anywhere in the modal. Only allow clicking links.
                            if (event.target.nodeName !== 'A') event.preventDefault();
                        };
                        function preprocessPath(path) {
                            return path === '' ? '@' : path[0] === '.' ? path.slice(1) : path;
                        }
                        function updatePreview() {
                            try {
                                var transformed = executeQuery(value, query.value);
                                preview.className = 'jsoneditor-transform-preview';
                                preview.value = stringifyPartial(transformed, 2, constants /* MAX_PREVIEW_CHARACTERS */ .hJ);
                                ok.disabled = false;
                            } catch (err) {
                                preview.className = 'jsoneditor-transform-preview jsoneditor-error';
                                preview.value = err.toString();
                                ok.disabled = true;
                            }
                        }
                        var debouncedUpdatePreview = (0, util.debounce)(updatePreview, 300);
                        function tryCreateQuery(json, queryOptions) {
                            try {
                                query.value = createQuery(json, queryOptions);
                                ok.disabled = false;
                                debouncedUpdatePreview();
                            } catch (err) {
                                var message = 'Error: an error happened when executing "createQuery": ' + (err.message || err.toString());
                                query.value = '';
                                ok.disabled = true;
                                preview.className = 'jsoneditor-transform-preview jsoneditor-error';
                                preview.value = message;
                            }
                        }
                        function generateQueryFromWizard() {
                            var queryOptions = {};
                            if (filterField.value && filterRelation.value && filterValue.value) queryOptions.filter = {
                                field: filterField.value,
                                relation: filterRelation.value,
                                value: filterValue.value
                            };
                            if (sortField.value && sortOrder.value) queryOptions.sort = {
                                field: sortField.value,
                                direction: sortOrder.value
                            };
                            if (selectFields.value) {
                                var fields = [];
                                for(var i = 0; i < selectFields.options.length; i++)if (selectFields.options[i].selected) {
                                    var selectedField = selectFields.options[i].value;
                                    fields.push(selectedField);
                                }
                                queryOptions.projection = {
                                    fields: fields
                                };
                            }
                            tryCreateQuery(json, queryOptions);
                        }
                        query.oninput = debouncedUpdatePreview;
                        ok.onclick = function(event) {
                            event.preventDefault();
                            event.stopPropagation();
                            modal.close();
                            onTransform(query.value);
                        };
                        // initialize with empty query
                        tryCreateQuery(json, {});
                        setTimeout(function() {
                            query.select();
                            query.focus();
                            query.selectionStart = 3;
                            query.selectionEnd = 3;
                        });
                    }).afterClose(function(modal) {
                        modal.destroy();
                    }).show();
                }
            /***/ },
            /***/ 633: /***/ function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {
                "use strict";
                // ESM COMPAT FLAG
                __webpack_require__.r(__webpack_exports__);
                // EXPORTS
                __webpack_require__.d(__webpack_exports__, {
                    treeModeMixins: function() {
                        return /* binding */ treeModeMixins;
                    }
                });
                var defaultFilterFunction = {
                    start: function start(token, match, config) {
                        return match.indexOf(token) === 0;
                    },
                    contain: function contain(token, match, config) {
                        return match.indexOf(token) > -1;
                    }
                };
                function autocomplete(config) {
                    config = config || {};
                    config.filter = config.filter || 'start';
                    config.trigger = config.trigger || 'keydown';
                    config.confirmKeys = config.confirmKeys || [
                        39,
                        35,
                        9
                    ]; // right, end, tab
                    config.caseSensitive = config.caseSensitive || false; // autocomplete case sensitive
                    var fontSize = '';
                    var fontFamily = '';
                    var wrapper = document.createElement('div');
                    wrapper.style.position = 'relative';
                    wrapper.style.outline = '0';
                    wrapper.style.border = '0';
                    wrapper.style.margin = '0';
                    wrapper.style.padding = '0';
                    var dropDown = document.createElement('div');
                    dropDown.className = 'autocomplete dropdown';
                    dropDown.style.position = 'absolute';
                    dropDown.style.visibility = 'hidden';
                    var spacer;
                    var leftSide; // <-- it will contain the leftSide part of the textfield (the bit that was already autocompleted)
                    var createDropDownController = function createDropDownController(elem, rs) {
                        var rows = [];
                        var ix = 0;
                        var oldIndex = -1;
                        // TODO: move this styling in JS to SCSS
                        var onMouseOver = function onMouseOver() {
                            this.style.backgroundColor = '#ddd';
                        };
                        var onMouseOut = function onMouseOut() {
                            this.style.backgroundColor = '';
                        };
                        var onMouseDown = function onMouseDown() {
                            p.hide();
                            p.onmouseselection(this.__hint, p.rs);
                        };
                        var p = {
                            rs: rs,
                            hide: function hide() {
                                elem.style.visibility = 'hidden';
                            // rs.hideDropDown();
                            },
                            refresh: function refresh(token, array) {
                                elem.style.visibility = 'hidden';
                                ix = 0;
                                elem.textContent = '';
                                var vph = window.innerHeight || document.documentElement.clientHeight;
                                var rect = elem.parentNode.getBoundingClientRect();
                                var distanceToTop = rect.top - 6; // heuristic give 6px
                                var distanceToBottom = vph - rect.bottom - 6; // distance from the browser border.
                                rows = [];
                                var filterFn = typeof config.filter === 'function' ? config.filter : defaultFilterFunction[config.filter];
                                var filtered = !filterFn ? [] : array.filter(function(match) {
                                    return filterFn(config.caseSensitive ? token : token.toLowerCase(), config.caseSensitive ? match : match.toLowerCase(), config);
                                });
                                rows = filtered.map(function(row) {
                                    var divRow = document.createElement('div');
                                    divRow.className = 'item';
                                    // divRow.style.color = config.color;
                                    divRow.onmouseover = onMouseOver;
                                    divRow.onmouseout = onMouseOut;
                                    divRow.onmousedown = onMouseDown;
                                    divRow.__hint = row;
                                    divRow.textContent = '';
                                    divRow.appendChild(document.createTextNode(row.substring(0, token.length)));
                                    var b = document.createElement('b');
                                    b.appendChild(document.createTextNode(row.substring(token.length)));
                                    divRow.appendChild(b);
                                    elem.appendChild(divRow);
                                    return divRow;
                                });
                                if (rows.length === 0) return; // nothing to show.
                                if (rows.length === 1 && (token.toLowerCase() === rows[0].__hint.toLowerCase() && !config.caseSensitive || token === rows[0].__hint && config.caseSensitive)) return; // do not show the dropDown if it has only one element which matches what we have just displayed.
                                if (rows.length < 2) return;
                                p.highlight(0);
                                if (distanceToTop > distanceToBottom * 3) {
                                    // Heuristic (only when the distance to the to top is 4 times more than distance to the bottom
                                    elem.style.maxHeight = distanceToTop + 'px'; // we display the dropDown on the top of the input text
                                    elem.style.top = '';
                                    elem.style.bottom = '100%';
                                } else {
                                    elem.style.top = '100%';
                                    elem.style.bottom = '';
                                    elem.style.maxHeight = distanceToBottom + 'px';
                                }
                                elem.style.visibility = 'visible';
                            },
                            highlight: function highlight(index) {
                                if (oldIndex !== -1 && rows[oldIndex]) rows[oldIndex].className = 'item';
                                rows[index].className = 'item hover';
                                oldIndex = index;
                            },
                            move: function move(step) {
                                // moves the selection either up or down (unless it's not possible) step is either +1 or -1.
                                if (elem.style.visibility === 'hidden') return ''; // nothing to move if there is no dropDown. (this happens if the user hits escape and then down or up)
                                if (ix + step === -1 || ix + step === rows.length) return rows[ix].__hint; // NO CIRCULAR SCROLLING.
                                ix += step;
                                p.highlight(ix);
                                return rows[ix].__hint; // txtShadow.value = uRows[uIndex].__hint ;
                            },
                            onmouseselection: function onmouseselection() {} // it will be overwritten.
                        };
                        return p;
                    };
                    function setEndOfContenteditable(contentEditableElement) {
                        var range, selection;
                        if (document.createRange) {
                            // Firefox, Chrome, Opera, Safari, IE 9+
                            range = document.createRange(); // Create a range (a range is a like the selection but invisible)
                            range.selectNodeContents(contentEditableElement); // Select the entire contents of the element with the range
                            range.collapse(false); // collapse the range to the end point. false means collapse to end rather than the start
                            selection = window.getSelection(); // get the selection object (allows you to change selection)
                            selection.removeAllRanges(); // remove any selections already made
                            selection.addRange(range); // make the range you have just created the visible selection
                        } else if (document.selection) {
                            // IE 8 and lower
                            range = document.body.createTextRange(); // Create a range (a range is a like the selection but invisible)
                            range.moveToElementText(contentEditableElement); // Select the entire contents of the element with the range
                            range.collapse(false); // collapse the range to the end point. false means collapse to end rather than the start
                            range.select(); // Select the range (make it the visible selection
                        }
                    }
                    function calculateWidthForText(text) {
                        if (spacer === undefined) {
                            // on first call only.
                            spacer = document.createElement('span');
                            spacer.style.visibility = 'hidden';
                            spacer.style.position = 'fixed';
                            spacer.style.outline = '0';
                            spacer.style.margin = '0';
                            spacer.style.padding = '0';
                            spacer.style.border = '0';
                            spacer.style.left = '0';
                            spacer.style.whiteSpace = 'pre';
                            spacer.style.fontSize = fontSize;
                            spacer.style.fontFamily = fontFamily;
                            spacer.style.fontWeight = 'normal';
                            document.body.appendChild(spacer);
                        }
                        spacer.textContent = text;
                        return spacer.getBoundingClientRect().right;
                    }
                    var rs = {
                        onArrowDown: function onArrowDown() {},
                        // defaults to no action.
                        onArrowUp: function onArrowUp() {},
                        // defaults to no action.
                        onEnter: function onEnter() {},
                        // defaults to no action.
                        onTab: function onTab() {},
                        // defaults to no action.
                        startFrom: 0,
                        options: [],
                        element: null,
                        elementHint: null,
                        elementStyle: null,
                        wrapper: wrapper,
                        // Only to allow  easy access to the HTML elements to the final user (possibly for minor customizations)
                        show: function show(element, startPos, options) {
                            var _this = this;
                            this.startFrom = startPos;
                            this.wrapper.remove();
                            if (this.elementHint) {
                                this.elementHint.remove();
                                this.elementHint = null;
                            }
                            if (fontSize === '') fontSize = window.getComputedStyle(element).getPropertyValue('font-size');
                            if (fontFamily === '') fontFamily = window.getComputedStyle(element).getPropertyValue('font-family');
                            dropDown.style.marginLeft = '0';
                            dropDown.style.marginTop = element.getBoundingClientRect().height + 'px';
                            this.options = options.map(String);
                            if (this.element !== element) {
                                this.element = element;
                                this.elementStyle = {
                                    zIndex: this.element.style.zIndex,
                                    position: this.element.style.position,
                                    backgroundColor: this.element.style.backgroundColor,
                                    borderColor: this.element.style.borderColor
                                };
                            }
                            this.element.style.zIndex = 3;
                            this.element.style.position = 'relative';
                            this.element.style.backgroundColor = 'transparent';
                            this.element.style.borderColor = 'transparent';
                            this.elementHint = element.cloneNode();
                            this.elementHint.className = 'autocomplete hint';
                            this.elementHint.style.zIndex = 2;
                            this.elementHint.style.position = 'absolute';
                            this.elementHint.onfocus = function() {
                                _this.element.focus();
                            };
                            if (this.element.addEventListener) {
                                this.element.removeEventListener('keydown', keyDownHandler);
                                this.element.addEventListener('keydown', keyDownHandler, false);
                                this.element.removeEventListener('blur', onBlurHandler);
                                this.element.addEventListener('blur', onBlurHandler, false);
                            }
                            wrapper.appendChild(this.elementHint);
                            wrapper.appendChild(dropDown);
                            element.parentElement.appendChild(wrapper);
                            this.repaint(element);
                        },
                        setText: function setText(text) {
                            this.element.innerText = text;
                        },
                        getText: function getText() {
                            return this.element.innerText;
                        },
                        hideDropDown: function hideDropDown() {
                            this.wrapper.remove();
                            if (this.elementHint) {
                                this.elementHint.remove();
                                this.elementHint = null;
                                dropDownController.hide();
                                this.element.style.zIndex = this.elementStyle.zIndex;
                                this.element.style.position = this.elementStyle.position;
                                this.element.style.backgroundColor = this.elementStyle.backgroundColor;
                                this.element.style.borderColor = this.elementStyle.borderColor;
                            }
                        },
                        repaint: function repaint(element) {
                            var text = element.innerText;
                            text = text.replace('\n', '');
                            var optionsLength = this.options.length;
                            // breaking text in leftSide and token.
                            var token = text.substring(this.startFrom);
                            leftSide = text.substring(0, this.startFrom);
                            for(var i = 0; i < optionsLength; i++){
                                var opt = this.options[i];
                                if (!config.caseSensitive && opt.toLowerCase().indexOf(token.toLowerCase()) === 0 || config.caseSensitive && opt.indexOf(token) === 0) {
                                    // <-- how about upperCase vs. lowercase
                                    this.elementHint.innerText = leftSide + token + opt.substring(token.length);
                                    this.elementHint.realInnerText = leftSide + opt;
                                    break;
                                }
                            }
                            // moving the dropDown and refreshing it.
                            dropDown.style.left = calculateWidthForText(leftSide) + 'px';
                            dropDownController.refresh(token, this.options);
                            this.elementHint.style.width = calculateWidthForText(this.elementHint.innerText) + 10 + 'px';
                            var wasDropDownHidden = dropDown.style.visibility === 'hidden';
                            if (!wasDropDownHidden) this.elementHint.style.width = calculateWidthForText(this.elementHint.innerText) + dropDown.clientWidth + 'px';
                        }
                    };
                    var dropDownController = createDropDownController(dropDown, rs);
                    var keyDownHandler = (function(e) {
                        // console.log("Keydown:" + e.keyCode);
                        e = e || window.event;
                        var keyCode = e.keyCode;
                        if (this.elementHint == null) return;
                        if (keyCode === 33) return;
                         // page up (do nothing)
                        if (keyCode === 34) return;
                         // page down (do nothing);
                        if (keyCode === 27) {
                            // escape
                            rs.hideDropDown();
                            rs.element.focus();
                            e.preventDefault();
                            e.stopPropagation();
                            return;
                        }
                        var text = this.element.innerText;
                        text = text.replace('\n', '');
                        if (config.confirmKeys.indexOf(keyCode) >= 0) {
                            //  (autocomplete triggered)
                            if (keyCode === 9) {
                                if (this.elementHint.innerText.length === 0) rs.onTab();
                            }
                            if (this.elementHint.innerText.length > 0) // if there is a hint
                            {
                                if (this.element.innerText !== this.elementHint.realInnerText) {
                                    this.element.innerText = this.elementHint.realInnerText;
                                    rs.hideDropDown();
                                    setEndOfContenteditable(this.element);
                                    if (keyCode === 9) {
                                        rs.element.focus();
                                        e.preventDefault();
                                        e.stopPropagation();
                                    }
                                }
                            }
                            return;
                        }
                        if (keyCode === 13) {
                            // enter  (autocomplete triggered)
                            if (this.elementHint.innerText.length === 0) // if there is a hint
                            rs.onEnter();
                            else {
                                var wasDropDownHidden = dropDown.style.visibility === 'hidden';
                                dropDownController.hide();
                                if (wasDropDownHidden) {
                                    rs.hideDropDown();
                                    rs.element.focus();
                                    rs.onEnter();
                                    return;
                                }
                                this.element.innerText = this.elementHint.realInnerText;
                                rs.hideDropDown();
                                setEndOfContenteditable(this.element);
                                e.preventDefault();
                                e.stopPropagation();
                            }
                            return;
                        }
                        if (keyCode === 40) {
                            // down
                            var token = text.substring(this.startFrom);
                            var m = dropDownController.move(1);
                            if (m === '') rs.onArrowDown();
                            this.elementHint.innerText = leftSide + token + m.substring(token.length);
                            this.elementHint.realInnerText = leftSide + m;
                            e.preventDefault();
                            e.stopPropagation();
                            return;
                        }
                        if (keyCode === 38) {
                            // up
                            var _token = text.substring(this.startFrom);
                            var _m = dropDownController.move(-1);
                            if (_m === '') rs.onArrowUp();
                            this.elementHint.innerText = leftSide + _token + _m.substring(_token.length);
                            this.elementHint.realInnerText = leftSide + _m;
                            e.preventDefault();
                            e.stopPropagation();
                        }
                    }).bind(rs);
                    var onBlurHandler = function onBlurHandler(e) {
                        rs.hideDropDown();
                    // console.log("Lost focus.");
                    };
                    dropDownController.onmouseselection = function(text, rs) {
                        rs.element.innerText = rs.elementHint.innerText = leftSide + text;
                        rs.hideDropDown();
                        window.setTimeout(function() {
                            rs.element.focus();
                            setEndOfContenteditable(rs.element);
                        }, 1);
                    };
                    return rs;
                }
                // EXTERNAL MODULE: ./src/js/ContextMenu.js
                var ContextMenu = __webpack_require__(545);
                // EXTERNAL MODULE: ./src/js/FocusTracker.js
                var FocusTracker = __webpack_require__(877);
                /**
 * The highlighter can highlight/unhighlight a node, and
 * animate the visibility of a context menu.
 * @constructor Highlighter
 */ function _typeof(o) {
                    "@babel/helpers - typeof";
                    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
                        return typeof o;
                    } : function(o) {
                        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
                    }, _typeof(o);
                }
                function _classCallCheck(a, n) {
                    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
                }
                function _defineProperties(e, r) {
                    for(var t = 0; t < r.length; t++){
                        var o = r[t];
                        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
                    }
                }
                function _createClass(e, r, t) {
                    return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
                        writable: !1
                    }), e;
                }
                function _toPropertyKey(t) {
                    var i = _toPrimitive(t, "string");
                    return "symbol" == _typeof(i) ? i : i + "";
                }
                function _toPrimitive(t, r) {
                    if ("object" != _typeof(t) || !t) return t;
                    var e = t[Symbol.toPrimitive];
                    if (void 0 !== e) {
                        var i = e.call(t, r || "default");
                        if ("object" != _typeof(i)) return i;
                        throw new TypeError("@@toPrimitive must return a primitive value.");
                    }
                    return ("string" === r ? String : Number)(t);
                }
                var Highlighter = /*#__PURE__*/ function() {
                    function Highlighter() {
                        _classCallCheck(this, Highlighter);
                        this.locked = false;
                    }
                    /**
   * Hightlight given node and its childs
   * @param {Node} node
   */ return _createClass(Highlighter, [
                        {
                            key: "highlight",
                            value: function highlight(node) {
                                if (this.locked) return;
                                if (this.node !== node) {
                                    // unhighlight current node
                                    if (this.node) this.node.setHighlight(false);
                                    // highlight new node
                                    this.node = node;
                                    this.node.setHighlight(true);
                                }
                                // cancel any current timeout
                                this._cancelUnhighlight();
                            }
                        },
                        {
                            key: "unhighlight",
                            value: function unhighlight() {
                                if (this.locked) return;
                                var me = this;
                                if (this.node) {
                                    this._cancelUnhighlight();
                                    // do the unhighlighting after a small delay, to prevent re-highlighting
                                    // the same node when moving from the drag-icon to the contextmenu-icon
                                    // or vice versa.
                                    this.unhighlightTimer = setTimeout(function() {
                                        me.node.setHighlight(false);
                                        me.node = undefined;
                                        me.unhighlightTimer = undefined;
                                    }, 0);
                                }
                            }
                        },
                        {
                            key: "_cancelUnhighlight",
                            value: function _cancelUnhighlight() {
                                if (this.unhighlightTimer) {
                                    clearTimeout(this.unhighlightTimer);
                                    this.unhighlightTimer = undefined;
                                }
                            }
                        },
                        {
                            key: "lock",
                            value: function lock() {
                                this.locked = true;
                            }
                        },
                        {
                            key: "unlock",
                            value: function unlock() {
                                this.locked = false;
                            }
                        }
                    ]);
                }();
                // EXTERNAL MODULE: ./src/js/i18n.js
                var i18n = __webpack_require__(57);
                // EXTERNAL MODULE: ./src/js/jmespathQuery.js
                var jmespathQuery = __webpack_require__(359);
                // EXTERNAL MODULE: ./src/js/ModeSwitcher.js
                var ModeSwitcher = __webpack_require__(389);
                // EXTERNAL MODULE: ./node_modules/javascript-natural-sort/naturalSort.js
                var naturalSort = __webpack_require__(342);
                var naturalSort_default = /*#__PURE__*/ __webpack_require__.n(naturalSort);
                // EXTERNAL MODULE: ./src/js/createAbsoluteAnchor.js
                var createAbsoluteAnchor = __webpack_require__(925);
                // EXTERNAL MODULE: ./src/js/util.js
                var util = __webpack_require__(237);
                /**
 * A factory function to create an AppendNode, which depends on a Node
 * @param {Node} Node
 */ function appendNodeFactory(Node1) {
                    /**
   * @constructor AppendNode
   * @extends Node
   * @param {TreeEditor} editor
   * Create a new AppendNode. This is a special node which is created at the
   * end of the list with childs for an object or array
   */ function AppendNode(editor) {
                        /** @type {TreeEditor} */ this.editor = editor;
                        this.dom = {};
                    }
                    AppendNode.prototype = new Node1();
                    /**
   * Return a table row with an append button.
   * @return {Element} dom   TR element
   */ AppendNode.prototype.getDom = function() {
                        // TODO: implement a new solution for the append node
                        var dom = this.dom;
                        if (dom.tr) return dom.tr;
                        this._updateEditability();
                        // a row for the append button
                        var trAppend = document.createElement('tr');
                        trAppend.className = 'jsoneditor-append';
                        trAppend.node = this;
                        dom.tr = trAppend;
                        // TODO: consistent naming
                        if (this.editor.options.mode === 'tree') {
                            // a cell for the dragarea column
                            dom.tdDrag = document.createElement('td');
                            // create context menu
                            var tdMenu = document.createElement('td');
                            dom.tdMenu = tdMenu;
                            var menu = document.createElement('button');
                            menu.type = 'button';
                            menu.className = 'jsoneditor-button jsoneditor-contextmenu-button';
                            menu.title = 'Click to open the actions menu (Ctrl+M)';
                            dom.menu = menu;
                            tdMenu.appendChild(dom.menu);
                        }
                        // a cell for the contents (showing text 'empty')
                        var tdAppend = document.createElement('td');
                        var domText = document.createElement('div');
                        domText.appendChild(document.createTextNode('(' + (0, i18n /* translate */ .Tl)('empty') + ')'));
                        domText.className = 'jsoneditor-readonly';
                        tdAppend.appendChild(domText);
                        dom.td = tdAppend;
                        dom.text = domText;
                        this.updateDom();
                        return trAppend;
                    };
                    /**
   * Append node doesn't have a path
   * @returns {null}
   */ AppendNode.prototype.getPath = function() {
                        return null;
                    };
                    /**
   * Append node doesn't have an index
   * @returns {null}
   */ AppendNode.prototype.getIndex = function() {
                        return null;
                    };
                    /**
   * Update the HTML dom of the Node
   */ AppendNode.prototype.updateDom = function(options) {
                        var dom = this.dom;
                        var tdAppend = dom.td;
                        if (tdAppend) tdAppend.style.paddingLeft = this.getLevel() * 24 + 26 + 'px';
                        var domText = dom.text;
                        if (domText) domText.firstChild.nodeValue = '(' + (0, i18n /* translate */ .Tl)('empty') + ' ' + this.parent.type + ')';
                        // attach or detach the contents of the append node:
                        // hide when the parent has childs, show when the parent has no childs
                        var trAppend = dom.tr;
                        if (!this.isVisible()) {
                            if (dom.tr.firstChild) {
                                if (dom.tdDrag) trAppend.removeChild(dom.tdDrag);
                                if (dom.tdMenu) trAppend.removeChild(dom.tdMenu);
                                trAppend.removeChild(tdAppend);
                            }
                        } else if (!dom.tr.firstChild) {
                            if (dom.tdDrag) trAppend.appendChild(dom.tdDrag);
                            if (dom.tdMenu) trAppend.appendChild(dom.tdMenu);
                            trAppend.appendChild(tdAppend);
                        }
                    };
                    /**
   * Check whether the AppendNode is currently visible.
   * the AppendNode is visible when its parent has no childs (i.e. is empty).
   * @return {boolean} isVisible
   */ AppendNode.prototype.isVisible = function() {
                        return this.parent.childs.length === 0;
                    };
                    /**
   * Show a contextmenu for this node
   * @param {HTMLElement} anchor   The element to attach the menu to.
   * @param {function} [onClose]   Callback method called when the context menu
   *                               is being closed.
   */ AppendNode.prototype.showContextMenu = function(anchor, onClose) {
                        var node = this;
                        var appendSubmenu = [
                            {
                                text: (0, i18n /* translate */ .Tl)('auto'),
                                className: 'jsoneditor-type-auto',
                                title: (0, i18n /* translate */ .Tl)('autoType'),
                                click: function click() {
                                    node._onAppend('', '', 'auto');
                                }
                            },
                            {
                                text: (0, i18n /* translate */ .Tl)('array'),
                                className: 'jsoneditor-type-array',
                                title: (0, i18n /* translate */ .Tl)('arrayType'),
                                click: function click() {
                                    node._onAppend('', []);
                                }
                            },
                            {
                                text: (0, i18n /* translate */ .Tl)('object'),
                                className: 'jsoneditor-type-object',
                                title: (0, i18n /* translate */ .Tl)('objectType'),
                                click: function click() {
                                    node._onAppend('', {});
                                }
                            },
                            {
                                text: (0, i18n /* translate */ .Tl)('string'),
                                className: 'jsoneditor-type-string',
                                title: (0, i18n /* translate */ .Tl)('stringType'),
                                click: function click() {
                                    node._onAppend('', '', 'string');
                                }
                            }
                        ];
                        node.addTemplates(appendSubmenu, true);
                        var items = [
                            // create append button
                            {
                                text: (0, i18n /* translate */ .Tl)('appendText'),
                                title: (0, i18n /* translate */ .Tl)('appendTitleAuto'),
                                submenuTitle: (0, i18n /* translate */ .Tl)('appendSubmenuTitle'),
                                className: 'jsoneditor-insert',
                                click: function click() {
                                    node._onAppend('', '', 'auto');
                                },
                                submenu: appendSubmenu
                            }
                        ];
                        if (this.editor.options.onCreateMenu) {
                            var path = node.parent.getPath();
                            items = this.editor.options.onCreateMenu(items, {
                                type: 'append',
                                path: path,
                                paths: [
                                    path
                                ]
                            });
                        }
                        var menu = new ContextMenu /* ContextMenu */ .t(items, {
                            close: onClose
                        });
                        menu.show(anchor, this.editor.getPopupAnchor());
                    };
                    /**
   * Handle an event. The event is caught centrally by the editor
   * @param {Event} event
   */ AppendNode.prototype.onEvent = function(event) {
                        var type = event.type;
                        var target = event.target || event.srcElement;
                        var dom = this.dom;
                        // highlight the append nodes parent
                        var menu = dom.menu;
                        if (target === menu) {
                            if (type === 'mouseover') this.editor.highlighter.highlight(this.parent);
                            else if (type === 'mouseout') this.editor.highlighter.unhighlight();
                        }
                        // context menu events
                        if (type === 'click' && target === dom.menu) {
                            var highlighter = this.editor.highlighter;
                            highlighter.highlight(this.parent);
                            highlighter.lock();
                            (0, util.addClassName)(dom.menu, 'jsoneditor-selected');
                            this.showContextMenu(dom.menu, function() {
                                (0, util.removeClassName)(dom.menu, 'jsoneditor-selected');
                                highlighter.unlock();
                                highlighter.unhighlight();
                            });
                        }
                        if (type === 'keydown') this.onKeyDown(event);
                    };
                    return AppendNode;
                }
                /**
 * A factory function to create an ShowMoreNode, which depends on a Node
 * @param {function} Node
 */ function showMoreNodeFactory(Node1) {
                    /**
   * @constructor ShowMoreNode
   * @extends Node
   * @param {TreeEditor} editor
   * @param {Node} parent
   * Create a new ShowMoreNode. This is a special node which is created
   * for arrays or objects having more than 100 items
   */ function ShowMoreNode(editor, parent) {
                        /** @type {TreeEditor} */ this.editor = editor;
                        this.parent = parent;
                        this.dom = {};
                    }
                    ShowMoreNode.prototype = new Node1();
                    /**
   * Return a table row with an append button.
   * @return {Element} dom   TR element
   */ ShowMoreNode.prototype.getDom = function() {
                        if (this.dom.tr) return this.dom.tr;
                        this._updateEditability();
                        // display "show more"
                        if (!this.dom.tr) {
                            var me = this;
                            var parent = this.parent;
                            var showMoreButton = document.createElement('a');
                            showMoreButton.appendChild(document.createTextNode((0, i18n /* translate */ .Tl)('showMore')));
                            showMoreButton.href = '#';
                            showMoreButton.onclick = function(event) {
                                // TODO: use callback instead of accessing a method of the parent
                                parent.visibleChilds = Math.floor(parent.visibleChilds / parent.getMaxVisibleChilds() + 1) * parent.getMaxVisibleChilds();
                                me.updateDom();
                                parent.showChilds();
                                event.preventDefault();
                                return false;
                            };
                            var showAllButton = document.createElement('a');
                            showAllButton.appendChild(document.createTextNode((0, i18n /* translate */ .Tl)('showAll')));
                            showAllButton.href = '#';
                            showAllButton.onclick = function(event) {
                                // TODO: use callback instead of accessing a method of the parent
                                parent.visibleChilds = Infinity;
                                me.updateDom();
                                parent.showChilds();
                                event.preventDefault();
                                return false;
                            };
                            var moreContents = document.createElement('div');
                            var moreText = document.createTextNode(this._getShowMoreText());
                            moreContents.className = 'jsoneditor-show-more';
                            moreContents.appendChild(moreText);
                            moreContents.appendChild(showMoreButton);
                            moreContents.appendChild(document.createTextNode('. '));
                            moreContents.appendChild(showAllButton);
                            moreContents.appendChild(document.createTextNode('. '));
                            var tdContents = document.createElement('td');
                            tdContents.appendChild(moreContents);
                            var moreTr = document.createElement('tr');
                            if (this.editor.options.mode === 'tree') {
                                moreTr.appendChild(document.createElement('td'));
                                moreTr.appendChild(document.createElement('td'));
                            }
                            moreTr.appendChild(tdContents);
                            moreTr.className = 'jsoneditor-show-more';
                            this.dom.tr = moreTr;
                            this.dom.moreContents = moreContents;
                            this.dom.moreText = moreText;
                        }
                        this.updateDom();
                        return this.dom.tr;
                    };
                    /**
   * Update the HTML dom of the Node
   */ ShowMoreNode.prototype.updateDom = function(options) {
                        if (this.isVisible()) {
                            // attach to the right child node (the first non-visible child)
                            this.dom.tr.node = this.parent.childs[this.parent.visibleChilds];
                            if (!this.dom.tr.parentNode) {
                                var nextTr = this.parent._getNextTr();
                                if (nextTr) nextTr.parentNode.insertBefore(this.dom.tr, nextTr);
                            }
                            // update the counts in the text
                            this.dom.moreText.nodeValue = this._getShowMoreText();
                            // update left margin
                            this.dom.moreContents.style.marginLeft = (this.getLevel() + 1) * 24 + 'px';
                        } else if (this.dom.tr && this.dom.tr.parentNode) this.dom.tr.parentNode.removeChild(this.dom.tr);
                    };
                    ShowMoreNode.prototype._getShowMoreText = function() {
                        return (0, i18n /* translate */ .Tl)('showMoreStatus', {
                            visibleChilds: this.parent.visibleChilds,
                            totalChilds: this.parent.childs.length
                        }) + ' ';
                    };
                    /**
   * Check whether the ShowMoreNode is currently visible.
   * the ShowMoreNode is visible when it's parent has more childs than
   * the current visibleChilds
   * @return {boolean} isVisible
   */ ShowMoreNode.prototype.isVisible = function() {
                        return this.parent.expanded && this.parent.childs.length > this.parent.visibleChilds;
                    };
                    /**
   * Handle an event. The event is caught centrally by the editor
   * @param {Event} event
   */ ShowMoreNode.prototype.onEvent = function(event) {
                        var type = event.type;
                        if (type === 'keydown') this.onKeyDown(event);
                    };
                    return ShowMoreNode;
                }
                // EXTERNAL MODULE: ./src/js/showSortModal.js
                var js_showSortModal = __webpack_require__(915);
                // EXTERNAL MODULE: ./src/js/showTransformModal.js + 1 modules
                var js_showTransformModal = __webpack_require__(609);
                // EXTERNAL MODULE: ./src/js/constants.js
                var constants = __webpack_require__(660);
                function _toConsumableArray(r) {
                    return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread();
                }
                function _nonIterableSpread() {
                    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                }
                function _iterableToArray(r) {
                    if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
                }
                function _arrayWithoutHoles(r) {
                    if (Array.isArray(r)) return _arrayLikeToArray(r);
                }
                function _slicedToArray(r, e) {
                    return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest();
                }
                function _nonIterableRest() {
                    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                }
                function _iterableToArrayLimit(r, l) {
                    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
                    if (null != t) {
                        var e, n, i, u, a = [], f = !0, o = !1;
                        try {
                            if (i = (t = t.call(r)).next, 0 === l) {
                                if (Object(t) !== t) return;
                                f = !1;
                            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
                        } catch (r) {
                            o = !0, n = r;
                        } finally{
                            try {
                                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
                            } finally{
                                if (o) throw n;
                            }
                        }
                        return a;
                    }
                }
                function _arrayWithHoles(r) {
                    if (Array.isArray(r)) return r;
                }
                function _createForOfIteratorHelper(r, e) {
                    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
                    if (!t) {
                        if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
                            t && (r = t);
                            var _n = 0, F = function F() {};
                            return {
                                s: F,
                                n: function n() {
                                    return _n >= r.length ? {
                                        done: !0
                                    } : {
                                        done: !1,
                                        value: r[_n++]
                                    };
                                },
                                e: function e(r) {
                                    throw r;
                                },
                                f: F
                            };
                        }
                        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                    }
                    var o, a = !0, u = !1;
                    return {
                        s: function s() {
                            t = t.call(r);
                        },
                        n: function n() {
                            var r = t.next();
                            return a = r.done, r;
                        },
                        e: function e(r) {
                            u = !0, o = r;
                        },
                        f: function f() {
                            try {
                                a || null == t["return"] || t["return"]();
                            } finally{
                                if (u) throw o;
                            }
                        }
                    };
                }
                function _unsupportedIterableToArray(r, a) {
                    if (r) {
                        if ("string" == typeof r) return _arrayLikeToArray(r, a);
                        var t = ({}).toString.call(r).slice(8, -1);
                        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
                    }
                }
                function _arrayLikeToArray(r, a) {
                    (null == a || a > r.length) && (a = r.length);
                    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
                    return n;
                }
                function _readOnlyError(r) {
                    throw new TypeError('"' + r + '" is read-only');
                }
                function Node_typeof(o) {
                    "@babel/helpers - typeof";
                    return Node_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
                        return typeof o;
                    } : function(o) {
                        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
                    }, Node_typeof(o);
                }
                function Node_classCallCheck(a, n) {
                    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
                }
                function Node_defineProperties(e, r) {
                    for(var t = 0; t < r.length; t++){
                        var o = r[t];
                        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, Node_toPropertyKey(o.key), o);
                    }
                }
                function Node_createClass(e, r, t) {
                    return r && Node_defineProperties(e.prototype, r), t && Node_defineProperties(e, t), Object.defineProperty(e, "prototype", {
                        writable: !1
                    }), e;
                }
                function Node_toPropertyKey(t) {
                    var i = Node_toPrimitive(t, "string");
                    return "symbol" == Node_typeof(i) ? i : i + "";
                }
                function Node_toPrimitive(t, r) {
                    if ("object" != Node_typeof(t) || !t) return t;
                    var e = t[Symbol.toPrimitive];
                    if (void 0 !== e) {
                        var i = e.call(t, r || "default");
                        if ("object" != Node_typeof(i)) return i;
                        throw new TypeError("@@toPrimitive must return a primitive value.");
                    }
                    return ("string" === r ? String : Number)(t);
                }
                /**
 * @constructor Node
 * Create a new Node
 * @param {./treemode} editor
 * @param {Object} [params] Can contain parameters:
 *                          {string}  field
 *                          {boolean} fieldEditable
 *                          {*}       value
 *                          {String}  type  Can have values 'auto', 'array',
 *                                          'object', or 'string'.
 */ var Node1 = /*#__PURE__*/ function() {
                    function Node1(editor, params) {
                        Node_classCallCheck(this, Node1);
                        /** @type {./treemode} */ this.editor = editor;
                        this.dom = {};
                        this.expanded = false;
                        if (params && params instanceof Object) {
                            this.setField(params.field, params.fieldEditable);
                            if ('value' in params) this.setValue(params.value, params.type);
                            if ('internalValue' in params) this.setInternalValue(params.internalValue);
                        } else {
                            this.setField('');
                            this.setValue(null);
                        }
                        this._debouncedOnChangeValue = (0, util.debounce)(this._onChangeValue.bind(this), Node1.prototype.DEBOUNCE_INTERVAL);
                        this._debouncedOnChangeField = (0, util.debounce)(this._onChangeField.bind(this), Node1.prototype.DEBOUNCE_INTERVAL);
                        // starting value for visible children
                        this.visibleChilds = this.getMaxVisibleChilds();
                    }
                    return Node_createClass(Node1, [
                        {
                            key: "getMaxVisibleChilds",
                            value: function getMaxVisibleChilds() {
                                return this.editor && this.editor.options && this.editor.options.maxVisibleChilds ? this.editor.options.maxVisibleChilds : DEFAULT_MAX_VISIBLE_CHILDS;
                            }
                        },
                        {
                            key: "_updateEditability",
                            value: function _updateEditability() {
                                this.editable = {
                                    field: true,
                                    value: true
                                };
                                if (this.editor) {
                                    this.editable.field = this.editor.options.mode === 'tree';
                                    this.editable.value = this.editor.options.mode !== 'view';
                                    if ((this.editor.options.mode === 'tree' || this.editor.options.mode === 'form') && typeof this.editor.options.onEditable === 'function') {
                                        var getValue = this.getValue.bind(this);
                                        var editable = this.editor.options.onEditable({
                                            field: this.field,
                                            get value () {
                                                return getValue();
                                            },
                                            path: this.getPath()
                                        });
                                        if (typeof editable === 'boolean') {
                                            this.editable.field = editable;
                                            this.editable.value = editable;
                                        } else if (Node_typeof(editable) === 'object' && editable !== null) {
                                            if (typeof editable.field === 'boolean') this.editable.field = editable.field;
                                            if (typeof editable.value === 'boolean') this.editable.value = editable.value;
                                        } else {
                                            console.error('Invalid return value for function onEditable.', 'Actual value:', editable, '.', 'Either a boolean or object { field: boolean, value: boolean } expected.');
                                            this.editable.field = false;
                                            this.editable.value = false;
                                        }
                                    }
                                }
                            }
                        },
                        {
                            key: "getPath",
                            value: function getPath() {
                                var node = this;
                                var path = [];
                                while(node){
                                    var field = node.getName();
                                    if (field !== undefined) path.unshift(field);
                                    node = node.parent;
                                }
                                return path;
                            }
                        },
                        {
                            key: "getInternalPath",
                            value: function getInternalPath() {
                                var node = this;
                                var internalPath = [];
                                while(node){
                                    if (node.parent) internalPath.unshift(node.getIndex());
                                    node = node.parent;
                                }
                                return internalPath;
                            }
                        },
                        {
                            key: "getName",
                            value: function getName() {
                                return !this.parent ? undefined // do not add an (optional) field name of the root node
                                 : this.parent.type !== 'array' ? this.field : this.index;
                            }
                        },
                        {
                            key: "findNodeByPath",
                            value: function findNodeByPath(path) {
                                if (!path) return;
                                if (path.length === 0) return this;
                                if (path.length && this.childs && this.childs.length) for(var i = 0; i < this.childs.length; ++i){
                                    if ('' + path[0] === '' + this.childs[i].getName()) return this.childs[i].findNodeByPath(path.slice(1));
                                }
                            }
                        },
                        {
                            key: "findNodeByInternalPath",
                            value: function findNodeByInternalPath(internalPath) {
                                if (!internalPath) return undefined;
                                var node = this;
                                for(var i = 0; i < internalPath.length && node; i++){
                                    var childIndex = internalPath[i];
                                    node = node.childs[childIndex];
                                }
                                return node;
                            }
                        },
                        {
                            key: "serialize",
                            value: function serialize() {
                                return {
                                    value: this.getValue(),
                                    path: this.getPath()
                                };
                            }
                        },
                        {
                            key: "findNode",
                            value: function findNode(jsonPath) {
                                var path = (0, util.parsePath)(jsonPath);
                                var node = this;
                                var _loop = function _loop() {
                                    var prop = path.shift();
                                    if (typeof prop === 'number') {
                                        if (node.type !== 'array') throw new Error('Cannot get child node at index ' + prop + ': node is no array');
                                        node = node.childs[prop];
                                    } else {
                                        // string
                                        if (node.type !== 'object') throw new Error('Cannot get child node ' + prop + ': node is no object');
                                        node = node.childs.filter(function(child) {
                                            return child.field === prop;
                                        })[0];
                                    }
                                };
                                while(node && path.length > 0)_loop();
                                return node;
                            }
                        },
                        {
                            key: "findParents",
                            value: function findParents() {
                                var parents = [];
                                var parent = this.parent;
                                while(parent){
                                    parents.unshift(parent);
                                    parent = parent.parent;
                                }
                                return parents;
                            }
                        },
                        {
                            key: "setError",
                            value: function setError(error, child) {
                                this.error = error;
                                this.errorChild = child;
                                if (this.dom && this.dom.tr) this.updateError();
                            }
                        },
                        {
                            key: "updateError",
                            value: function updateError() {
                                var _this = this;
                                var error = this.fieldError || this.valueError || this.error;
                                var tdError = this.dom.tdError;
                                if (error && this.dom && this.dom.tr) {
                                    (0, util.addClassName)(this.dom.tr, 'jsoneditor-validation-error');
                                    if (!tdError) {
                                        tdError = document.createElement('td');
                                        this.dom.tdError = tdError;
                                        this.dom.tdValue.parentNode.appendChild(tdError);
                                    }
                                    var button = document.createElement('button');
                                    button.type = 'button';
                                    button.className = 'jsoneditor-button jsoneditor-schema-error';
                                    var destroy = function destroy() {
                                        if (_this.dom.popupAnchor) _this.dom.popupAnchor.destroy(); // this will trigger the onDestroy callback
                                    };
                                    var onDestroy = function onDestroy() {
                                        delete _this.dom.popupAnchor;
                                    };
                                    var createPopup = function createPopup(destroyOnMouseOut) {
                                        var frame = _this.editor.frame;
                                        _this.dom.popupAnchor = (0, createAbsoluteAnchor /* createAbsoluteAnchor */ .p)(button, _this.editor.getPopupAnchor(), onDestroy, destroyOnMouseOut);
                                        var popupWidth = 200; // must correspond to what's configured in the CSS
                                        var buttonRect = button.getBoundingClientRect();
                                        var frameRect = frame.getBoundingClientRect();
                                        var position = frameRect.width - buttonRect.x > popupWidth / 2 + 20 ? 'jsoneditor-above' : 'jsoneditor-left';
                                        var popover = document.createElement('div');
                                        popover.className = 'jsoneditor-popover ' + position;
                                        popover.appendChild(document.createTextNode(error.message));
                                        _this.dom.popupAnchor.appendChild(popover);
                                    };
                                    button.onmouseover = function() {
                                        if (!_this.dom.popupAnchor) createPopup(true);
                                    };
                                    button.onfocus = function() {
                                        destroy();
                                        createPopup(false);
                                    };
                                    button.onblur = function() {
                                        destroy();
                                    };
                                    // when clicking the error icon, expand all nodes towards the invalid
                                    // child node, and set focus to the child node
                                    var child = this.errorChild;
                                    if (child) button.onclick = function showInvalidNode() {
                                        child.findParents().forEach(function(parent) {
                                            parent.expand(false);
                                        });
                                        child.scrollTo(function() {
                                            child.focus();
                                        });
                                    };
                                    // apply the error message to the node
                                    while(tdError.firstChild)tdError.removeChild(tdError.firstChild);
                                    tdError.appendChild(button);
                                } else {
                                    if (this.dom.tr) (0, util.removeClassName)(this.dom.tr, 'jsoneditor-validation-error');
                                    if (tdError) {
                                        this.dom.tdError.parentNode.removeChild(this.dom.tdError);
                                        delete this.dom.tdError;
                                    }
                                }
                            }
                        },
                        {
                            key: "getIndex",
                            value: function getIndex() {
                                if (this.parent) {
                                    var index = this.parent.childs.indexOf(this);
                                    return index !== -1 ? index : null;
                                } else return -1;
                            }
                        },
                        {
                            key: "setParent",
                            value: function setParent(parent) {
                                this.parent = parent;
                            }
                        },
                        {
                            key: "setField",
                            value: function setField(field, fieldEditable) {
                                this.field = field;
                                this.previousField = field;
                                this.fieldEditable = fieldEditable === true;
                            }
                        },
                        {
                            key: "getField",
                            value: function getField() {
                                if (this.field === undefined) this._getDomField();
                                return this.field;
                            }
                        },
                        {
                            key: "setValue",
                            value: function setValue(value, type) {
                                var childValue, child;
                                var i, j;
                                var updateDom = false;
                                var previousChilds = this.childs;
                                this.type = this._getType(value);
                                // check if type corresponds with the provided type
                                if (type && type !== this.type) {
                                    if (type === 'string' && this.type === 'auto') this.type = type;
                                    else throw new Error('Type mismatch: cannot cast value of type "' + this.type + ' to the specified type "' + type + '"');
                                }
                                if (this.type === 'array') {
                                    // array
                                    if (!this.childs) this.childs = [];
                                    for(i = 0; i < value.length; i++){
                                        childValue = value[i];
                                        if (childValue !== undefined && !(childValue instanceof Function)) {
                                            if (i < this.childs.length) {
                                                // reuse existing child, keep its state
                                                child = this.childs[i];
                                                child.fieldEditable = false;
                                                child.index = i;
                                                child.setValue(childValue);
                                            } else {
                                                // create a new child
                                                child = new Node1(this.editor, {
                                                    value: childValue
                                                });
                                                var visible = i < this.getMaxVisibleChilds();
                                                this.appendChild(child, visible, updateDom);
                                            }
                                        }
                                    }
                                    // cleanup redundant childs
                                    // we loop backward to prevent issues with shifting index numbers
                                    for(j = this.childs.length; j >= value.length; j--)this.removeChild(this.childs[j], updateDom);
                                } else if (this.type === 'object') {
                                    // object
                                    if (!this.childs) this.childs = [];
                                    // cleanup redundant childs
                                    // we loop backward to prevent issues with shifting index numbers
                                    for(j = this.childs.length - 1; j >= 0; j--)if (!Node_hasOwnProperty(value, this.childs[j].field)) this.removeChild(this.childs[j], updateDom);
                                    i = 0;
                                    for(var childField in value)if (Node_hasOwnProperty(value, childField)) {
                                        childValue = value[childField];
                                        if (childValue !== undefined && !(childValue instanceof Function)) {
                                            var _child = this.findChildByProperty(childField);
                                            if (_child) {
                                                // reuse existing child, keep its state
                                                _child.setField(childField, true);
                                                _child.setValue(childValue);
                                            } else {
                                                // create a new child, append to the end
                                                var newChild = new Node1(this.editor, {
                                                    field: childField,
                                                    value: childValue
                                                });
                                                var _visible = i < this.getMaxVisibleChilds();
                                                this.appendChild(newChild, _visible, updateDom);
                                            }
                                        }
                                        i++;
                                    }
                                    this.value = '';
                                    // sort object keys during initialization. Must not trigger an onChange action
                                    if (this.editor.options.sortObjectKeys === true) {
                                        var triggerAction = false;
                                        this.sort([], 'asc', triggerAction);
                                    }
                                } else {
                                    // value
                                    this.hideChilds();
                                    delete this.append;
                                    delete this.showMore;
                                    delete this.expanded;
                                    delete this.childs;
                                    this.value = value;
                                }
                                // recreate the DOM if switching from an object/array to auto/string or vice versa
                                // needed to recreated the expand button for example
                                if (Array.isArray(previousChilds) !== Array.isArray(this.childs)) this.recreateDom();
                                this.updateDom({
                                    updateIndexes: true
                                });
                                this.previousValue = this.value; // used only to check for changes in DOM vs JS model
                            }
                        },
                        {
                            key: "setInternalValue",
                            value: function setInternalValue(internalValue) {
                                var childValue, child, visible;
                                var i, j;
                                var notUpdateDom = false;
                                var previousChilds = this.childs;
                                this.type = internalValue.type;
                                if (internalValue.type === 'array') {
                                    // array
                                    if (!this.childs) this.childs = [];
                                    for(i = 0; i < internalValue.childs.length; i++){
                                        childValue = internalValue.childs[i];
                                        if (childValue !== undefined && !(childValue instanceof Function)) {
                                            if (i < this.childs.length) {
                                                // reuse existing child, keep its state
                                                child = this.childs[i];
                                                child.fieldEditable = false;
                                                child.index = i;
                                                child.setInternalValue(childValue);
                                            } else {
                                                // create a new child
                                                child = new Node1(this.editor, {
                                                    internalValue: childValue
                                                });
                                                visible = i < this.getMaxVisibleChilds();
                                                this.appendChild(child, visible, notUpdateDom);
                                            }
                                        }
                                    }
                                    // cleanup redundant childs
                                    // we loop backward to prevent issues with shifting index numbers
                                    for(j = this.childs.length; j >= internalValue.childs.length; j--)this.removeChild(this.childs[j], notUpdateDom);
                                } else if (internalValue.type === 'object') {
                                    // object
                                    if (!this.childs) this.childs = [];
                                    for(i = 0; i < internalValue.childs.length; i++){
                                        childValue = internalValue.childs[i];
                                        if (childValue !== undefined && !(childValue instanceof Function)) {
                                            if (i < this.childs.length) {
                                                // reuse existing child, keep its state
                                                child = this.childs[i];
                                                delete child.index;
                                                child.setField(childValue.field, true);
                                                child.setInternalValue(childValue.value);
                                            } else {
                                                // create a new child
                                                child = new Node1(this.editor, {
                                                    field: childValue.field,
                                                    internalValue: childValue.value
                                                });
                                                visible = i < this.getMaxVisibleChilds();
                                                this.appendChild(child, visible, notUpdateDom);
                                            }
                                        }
                                    }
                                    // cleanup redundant childs
                                    // we loop backward to prevent issues with shifting index numbers
                                    for(j = this.childs.length; j >= internalValue.childs.length; j--)this.removeChild(this.childs[j], notUpdateDom);
                                } else {
                                    // value
                                    this.hideChilds();
                                    delete this.append;
                                    delete this.showMore;
                                    delete this.expanded;
                                    delete this.childs;
                                    this.value = internalValue.value;
                                }
                                // recreate the DOM if switching from an object/array to auto/string or vice versa
                                // needed to recreated the expand button for example
                                if (Array.isArray(previousChilds) !== Array.isArray(this.childs)) this.recreateDom();
                                this.updateDom({
                                    updateIndexes: true
                                });
                                this.previousValue = this.value; // used only to check for changes in DOM vs JS model
                            }
                        },
                        {
                            key: "recreateDom",
                            value: function recreateDom() {
                                if (this.dom && this.dom.tr && this.dom.tr.parentNode) {
                                    var domAnchor = this._detachFromDom();
                                    this.clearDom();
                                    this._attachToDom(domAnchor);
                                } else this.clearDom();
                            }
                        },
                        {
                            key: "getValue",
                            value: function getValue() {
                                if (this.type === 'array') {
                                    var arr = [];
                                    this.childs.forEach(function(child) {
                                        arr.push(child.getValue());
                                    });
                                    return arr;
                                } else if (this.type === 'object') {
                                    var obj = {};
                                    this.childs.forEach(function(child) {
                                        obj[child.getField()] = child.getValue();
                                    });
                                    return obj;
                                } else {
                                    if (this.value === undefined) this._getDomValue();
                                    return this.value;
                                }
                            }
                        },
                        {
                            key: "getInternalValue",
                            value: function getInternalValue() {
                                if (this.type === 'array') return {
                                    type: this.type,
                                    childs: this.childs.map(function(child) {
                                        return child.getInternalValue();
                                    })
                                };
                                else if (this.type === 'object') return {
                                    type: this.type,
                                    childs: this.childs.map(function(child) {
                                        return {
                                            field: child.getField(),
                                            value: child.getInternalValue()
                                        };
                                    })
                                };
                                else {
                                    if (this.value === undefined) this._getDomValue();
                                    return {
                                        type: this.type,
                                        value: this.value
                                    };
                                }
                            }
                        },
                        {
                            key: "getLevel",
                            value: function getLevel() {
                                return this.parent ? this.parent.getLevel() + 1 : 0;
                            }
                        },
                        {
                            key: "getNodePath",
                            value: function getNodePath() {
                                var path = this.parent ? this.parent.getNodePath() : [];
                                path.push(this);
                                return path;
                            }
                        },
                        {
                            key: "clone",
                            value: function clone() {
                                var clone = new Node1(this.editor);
                                clone.type = this.type;
                                clone.field = this.field;
                                clone.fieldInnerText = this.fieldInnerText;
                                clone.fieldEditable = this.fieldEditable;
                                clone.previousField = this.previousField;
                                clone.value = this.value;
                                clone.valueInnerText = this.valueInnerText;
                                clone.previousValue = this.previousValue;
                                clone.expanded = this.expanded;
                                clone.visibleChilds = this.visibleChilds;
                                if (this.childs) {
                                    // an object or array
                                    var cloneChilds = [];
                                    this.childs.forEach(function(child) {
                                        var childClone = child.clone();
                                        childClone.setParent(clone);
                                        cloneChilds.push(childClone);
                                    });
                                    clone.childs = cloneChilds;
                                } else // a value
                                clone.childs = undefined;
                                return clone;
                            }
                        },
                        {
                            key: "expand",
                            value: function expand(recurse) {
                                if (!this.childs) return;
                                // set this node expanded
                                this.expanded = true;
                                if (this.dom.expand) this.dom.expand.className = 'jsoneditor-button jsoneditor-expanded';
                                this.showChilds();
                                if (recurse !== false) this.childs.forEach(function(child) {
                                    child.expand(recurse);
                                });
                                // update the css classes of table row, and fire onClassName etc
                                this.updateDom({
                                    recurse: false
                                });
                            }
                        },
                        {
                            key: "collapse",
                            value: function collapse(recurse) {
                                if (!this.childs) return;
                                this.hideChilds();
                                // collapse childs in case of recurse
                                if (recurse !== false) this.childs.forEach(function(child) {
                                    child.collapse(recurse);
                                });
                                // make this node collapsed
                                if (this.dom.expand) this.dom.expand.className = 'jsoneditor-button jsoneditor-collapsed';
                                this.expanded = false;
                                // update the css classes of table row, and fire onClassName etc
                                this.updateDom({
                                    recurse: false
                                });
                            }
                        },
                        {
                            key: "showChilds",
                            value: function showChilds() {
                                var childs = this.childs;
                                if (!childs) return;
                                if (!this.expanded) return;
                                var tr = this.dom.tr;
                                var nextTr;
                                var table = tr ? tr.parentNode : undefined;
                                if (table) {
                                    // show row with append button
                                    var append = this.getAppendDom();
                                    if (!append.parentNode) {
                                        nextTr = tr.nextSibling;
                                        if (nextTr) table.insertBefore(append, nextTr);
                                        else table.appendChild(append);
                                    }
                                    // show childs
                                    var iMax = Math.min(this.childs.length, this.visibleChilds);
                                    nextTr = this._getNextTr();
                                    for(var i = 0; i < iMax; i++){
                                        var child = this.childs[i];
                                        if (!child.getDom().parentNode) table.insertBefore(child.getDom(), nextTr);
                                        child.showChilds();
                                    }
                                    // show "show more childs" if limited
                                    var showMore = this.getShowMoreDom();
                                    nextTr = this._getNextTr();
                                    if (!showMore.parentNode) table.insertBefore(showMore, nextTr);
                                    this.showMore.updateDom(); // to update the counter
                                }
                            }
                        },
                        {
                            key: "_getNextTr",
                            value: function _getNextTr() {
                                if (this.showMore && this.showMore.getDom().parentNode) return this.showMore.getDom();
                                if (this.append && this.append.getDom().parentNode) return this.append.getDom();
                            }
                        },
                        {
                            key: "hide",
                            value: function hide(options) {
                                var tr = this.dom.tr;
                                var table = tr ? tr.parentNode : undefined;
                                if (table) table.removeChild(tr);
                                if (this.dom.popupAnchor) this.dom.popupAnchor.destroy();
                                this.hideChilds(options);
                            }
                        },
                        {
                            key: "hideChilds",
                            value: function hideChilds(options) {
                                var childs = this.childs;
                                if (!childs) return;
                                if (!this.expanded) return;
                                // hide append row
                                var append = this.getAppendDom();
                                if (append.parentNode) append.parentNode.removeChild(append);
                                // hide childs
                                this.childs.forEach(function(child) {
                                    child.hide();
                                });
                                // hide "show more" row
                                var showMore = this.getShowMoreDom();
                                if (showMore.parentNode) showMore.parentNode.removeChild(showMore);
                                // reset max visible childs
                                if (!options || options.resetVisibleChilds) this.visibleChilds = this.getMaxVisibleChilds();
                            }
                        },
                        {
                            key: "_updateCssClassName",
                            value: function _updateCssClassName() {
                                if (this.dom.field && this.editor && this.editor.options && typeof this.editor.options.onClassName === 'function' && this.dom.tree) {
                                    (0, util.removeAllClassNames)(this.dom.tree);
                                    var getValue = this.getValue.bind(this);
                                    var addClasses = this.editor.options.onClassName({
                                        path: this.getPath(),
                                        field: this.field,
                                        get value () {
                                            return getValue();
                                        }
                                    }) || '';
                                    (0, util.addClassName)(this.dom.tree, 'jsoneditor-values ' + addClasses);
                                }
                            }
                        },
                        {
                            key: "recursivelyUpdateCssClassesOnNodes",
                            value: function recursivelyUpdateCssClassesOnNodes() {
                                this._updateCssClassName();
                                if (Array.isArray(this.childs)) for(var i = 0; i < this.childs.length; i++)this.childs[i].recursivelyUpdateCssClassesOnNodes();
                            }
                        },
                        {
                            key: "expandTo",
                            value: function expandTo() {
                                var currentNode = this.parent;
                                while(currentNode){
                                    if (!currentNode.expanded) currentNode.expand();
                                    currentNode = currentNode.parent;
                                }
                            }
                        },
                        {
                            key: "appendChild",
                            value: function appendChild(node, visible, updateDom) {
                                if (this._hasChilds()) {
                                    // adjust the link to the parent
                                    node.setParent(this);
                                    node.fieldEditable = this.type === 'object';
                                    if (this.type === 'array') node.index = this.childs.length;
                                    if (this.type === 'object' && node.field === undefined) // initialize field value if needed
                                    node.setField('');
                                    this.childs.push(node);
                                    if (this.expanded && visible !== false) {
                                        // insert into the DOM, before the appendRow
                                        var newTr = node.getDom();
                                        var nextTr = this._getNextTr();
                                        var table = nextTr ? nextTr.parentNode : undefined;
                                        if (nextTr && table) table.insertBefore(newTr, nextTr);
                                        node.showChilds();
                                        this.visibleChilds++;
                                    }
                                    if (updateDom !== false) {
                                        this.updateDom({
                                            updateIndexes: true
                                        });
                                        node.updateDom({
                                            recurse: true
                                        });
                                    }
                                }
                            }
                        },
                        {
                            key: "moveBefore",
                            value: function moveBefore(node, beforeNode, updateDom) {
                                if (this._hasChilds()) {
                                    // create a temporary row, to prevent the scroll position from jumping
                                    // when removing the node
                                    var tbody = this.dom.tr ? this.dom.tr.parentNode : undefined;
                                    var trTemp;
                                    if (tbody) {
                                        trTemp = document.createElement('tr');
                                        trTemp.style.height = tbody.clientHeight + 'px';
                                        tbody.appendChild(trTemp);
                                    }
                                    if (node.parent) node.parent.removeChild(node);
                                    if (beforeNode instanceof AppendNode || !beforeNode) {
                                        // the this.childs.length + 1 is to reckon with the node that we're about to add
                                        if (this.childs.length + 1 > this.visibleChilds) {
                                            var lastVisibleNode = this.childs[this.visibleChilds - 1];
                                            this.insertBefore(node, lastVisibleNode, updateDom);
                                        } else {
                                            var visible = true;
                                            this.appendChild(node, visible, updateDom);
                                        }
                                    } else this.insertBefore(node, beforeNode, updateDom);
                                    if (tbody && trTemp) tbody.removeChild(trTemp);
                                }
                            }
                        },
                        {
                            key: "insertBefore",
                            value: function insertBefore(node, beforeNode, updateDom) {
                                if (this._hasChilds()) {
                                    this.visibleChilds++;
                                    // initialize field value if needed
                                    if (this.type === 'object' && node.field === undefined) node.setField('');
                                    if (beforeNode === this.append) {
                                        // append to the child nodes
                                        // adjust the link to the parent
                                        node.setParent(this);
                                        node.fieldEditable = this.type === 'object';
                                        this.childs.push(node);
                                    } else {
                                        // insert before a child node
                                        var index = this.childs.indexOf(beforeNode);
                                        if (index === -1) throw new Error('Node not found');
                                        // adjust the link to the parent
                                        node.setParent(this);
                                        node.fieldEditable = this.type === 'object';
                                        this.childs.splice(index, 0, node);
                                    }
                                    if (this.expanded) {
                                        // insert into the DOM
                                        var newTr = node.getDom();
                                        var nextTr = beforeNode.getDom();
                                        var table = nextTr ? nextTr.parentNode : undefined;
                                        if (nextTr && table) table.insertBefore(newTr, nextTr);
                                        node.showChilds();
                                        this.showChilds();
                                    }
                                    if (updateDom !== false) {
                                        this.updateDom({
                                            updateIndexes: true
                                        });
                                        node.updateDom({
                                            recurse: true
                                        });
                                    }
                                }
                            }
                        },
                        {
                            key: "insertAfter",
                            value: function insertAfter(node, afterNode) {
                                if (this._hasChilds()) {
                                    var index = this.childs.indexOf(afterNode);
                                    var beforeNode = this.childs[index + 1];
                                    if (beforeNode) this.insertBefore(node, beforeNode);
                                    else this.appendChild(node);
                                }
                            }
                        },
                        {
                            key: "search",
                            value: function search(text, results) {
                                if (!Array.isArray(results)) results = [];
                                var index;
                                var search = text ? text.toLowerCase() : undefined;
                                // delete old search data
                                delete this.searchField;
                                delete this.searchValue;
                                // search in field
                                if (this.field !== undefined && results.length <= this.MAX_SEARCH_RESULTS) {
                                    var field = String(this.field).toLowerCase();
                                    index = field.indexOf(search);
                                    if (index !== -1) {
                                        this.searchField = true;
                                        results.push({
                                            node: this,
                                            elem: 'field'
                                        });
                                    }
                                    // update dom
                                    this._updateDomField();
                                }
                                // search in value
                                if (this._hasChilds()) // array, object
                                // search the nodes childs
                                {
                                    if (this.childs) this.childs.forEach(function(child) {
                                        child.search(text, results);
                                    });
                                } else // string, auto
                                if (this.value !== undefined && results.length <= this.MAX_SEARCH_RESULTS) {
                                    var value = String(this.value).toLowerCase();
                                    index = value.indexOf(search);
                                    if (index !== -1) {
                                        this.searchValue = true;
                                        results.push({
                                            node: this,
                                            elem: 'value'
                                        });
                                    }
                                    // update dom
                                    this._updateDomValue();
                                }
                                return results;
                            }
                        },
                        {
                            key: "scrollTo",
                            value: function scrollTo(callback) {
                                this.expandPathToNode();
                                if (this.dom.tr && this.dom.tr.parentNode) this.editor.scrollTo(this.dom.tr.offsetTop, callback);
                            }
                        },
                        {
                            key: "expandPathToNode",
                            value: function expandPathToNode() {
                                var node = this;
                                var recurse = false;
                                while(node && node.parent){
                                    // expand visible childs of the parent if needed
                                    var index = node.parent.type === 'array' ? node.index : node.parent.childs.indexOf(node);
                                    while(node.parent.visibleChilds < index + 1)node.parent.visibleChilds += this.getMaxVisibleChilds();
                                    // expand the parent itself
                                    node.parent.expand(recurse);
                                    node = node.parent;
                                }
                            }
                        },
                        {
                            key: "focus",
                            value: function focus(elementName) {
                                Node1.focusElement = elementName;
                                if (this.dom.tr && this.dom.tr.parentNode) {
                                    var dom = this.dom;
                                    switch(elementName){
                                        case 'drag':
                                            if (dom.drag) dom.drag.focus();
                                            else dom.menu.focus();
                                            break;
                                        case 'menu':
                                            dom.menu.focus();
                                            break;
                                        case 'expand':
                                            if (this._hasChilds()) dom.expand.focus();
                                            else if (dom.field && this.fieldEditable) {
                                                dom.field.focus();
                                                (0, util.selectContentEditable)(dom.field);
                                            } else if (dom.value && !this._hasChilds()) {
                                                dom.value.focus();
                                                (0, util.selectContentEditable)(dom.value);
                                            } else dom.menu.focus();
                                            break;
                                        case 'field':
                                            if (dom.field && this.fieldEditable) {
                                                dom.field.focus();
                                                (0, util.selectContentEditable)(dom.field);
                                            } else if (dom.value && !this._hasChilds()) {
                                                dom.value.focus();
                                                (0, util.selectContentEditable)(dom.value);
                                            } else if (this._hasChilds()) dom.expand.focus();
                                            else dom.menu.focus();
                                            break;
                                        case 'value':
                                        default:
                                            if (dom.select) // enum select box
                                            dom.select.focus();
                                            else if (dom.value && !this._hasChilds()) {
                                                dom.value.focus();
                                                (0, util.selectContentEditable)(dom.value);
                                            } else if (dom.field && this.fieldEditable) {
                                                dom.field.focus();
                                                (0, util.selectContentEditable)(dom.field);
                                            } else if (this._hasChilds()) dom.expand.focus();
                                            else dom.menu.focus();
                                            break;
                                    }
                                }
                            }
                        },
                        {
                            key: "containsNode",
                            value: function containsNode(node) {
                                if (this === node) return true;
                                var childs = this.childs;
                                if (childs) // TODO: use the js5 Array.some() here?
                                for(var i = 0, iMax = childs.length; i < iMax; i++){
                                    if (childs[i].containsNode(node)) return true;
                                }
                                return false;
                            }
                        },
                        {
                            key: "removeChild",
                            value: function removeChild(node, updateDom) {
                                if (this.childs) {
                                    var index = this.childs.indexOf(node);
                                    if (index !== -1) {
                                        if (index < this.visibleChilds && this.expanded) this.visibleChilds--;
                                        node.hide();
                                        // delete old search results
                                        delete node.searchField;
                                        delete node.searchValue;
                                        var removedNode = this.childs.splice(index, 1)[0];
                                        removedNode.parent = null;
                                        if (updateDom !== false) this.updateDom({
                                            updateIndexes: true
                                        });
                                        return removedNode;
                                    }
                                }
                                return undefined;
                            }
                        },
                        {
                            key: "_remove",
                            value: function _remove(node) {
                                this.removeChild(node);
                            }
                        },
                        {
                            key: "changeType",
                            value: function changeType(newType) {
                                var oldType = this.type;
                                if (oldType === newType) // type is not changed
                                return;
                                if ((newType === 'string' || newType === 'auto') && (oldType === 'string' || oldType === 'auto')) // this is an easy change
                                this.type = newType;
                                else {
                                    // change from array to object, or from string/auto to object/array
                                    var domAnchor = this._detachFromDom();
                                    // delete the old DOM
                                    this.clearDom();
                                    // adjust the field and the value
                                    this.type = newType;
                                    // adjust childs
                                    if (newType === 'object') {
                                        if (!this.childs) this.childs = [];
                                        this.childs.forEach(function(child) {
                                            child.clearDom();
                                            delete child.index;
                                            child.fieldEditable = true;
                                            if (child.field === undefined) child.field = '';
                                        });
                                        if (oldType === 'string' || oldType === 'auto') this.expanded = true;
                                    } else if (newType === 'array') {
                                        if (!this.childs) this.childs = [];
                                        this.childs.forEach(function(child, index) {
                                            child.clearDom();
                                            child.fieldEditable = false;
                                            child.index = index;
                                        });
                                        if (oldType === 'string' || oldType === 'auto') this.expanded = true;
                                    } else this.expanded = false;
                                    this._attachToDom(domAnchor);
                                }
                                if (newType === 'auto' || newType === 'string') {
                                    // cast value to the correct type
                                    if (newType === 'string') this.value = String(this.value);
                                    else this.value = (0, util.parseString)(String(this.value));
                                    this.focus();
                                }
                                this.updateDom({
                                    updateIndexes: true
                                });
                            }
                        },
                        {
                            key: "deepEqual",
                            value: function deepEqual(json) {
                                var i;
                                if (this.type === 'array') {
                                    if (!Array.isArray(json)) return false;
                                    if (this.childs.length !== json.length) return false;
                                    for(i = 0; i < this.childs.length; i++){
                                        if (!this.childs[i].deepEqual(json[i])) return false;
                                    }
                                } else if (this.type === 'object') {
                                    if (Node_typeof(json) !== 'object' || !json) return false;
                                    // we reckon with the order of the properties too.
                                    var props = Object.keys(json);
                                    if (this.childs.length !== props.length) return false;
                                    for(i = 0; i < props.length; i++){
                                        var child = this.childs[i];
                                        if (child.field !== props[i] || !child.deepEqual(json[child.field])) return false;
                                    }
                                } else {
                                    if (this.value !== json) return false;
                                }
                                return true;
                            }
                        },
                        {
                            key: "_getDomValue",
                            value: function _getDomValue() {
                                this._clearValueError();
                                if (this.dom.value && this.type !== 'array' && this.type !== 'object') {
                                    this.valueInnerText = (0, util.getInnerText)(this.dom.value);
                                    if (this.valueInnerText === '' && this.dom.value.innerHTML !== '') // When clearing the contents, often a <br/> remains, messing up the
                                    // styling of the empty text box. Therefore we remove the <br/>
                                    this.dom.value.textContent = '';
                                }
                                if (this.valueInnerText !== undefined) try {
                                    // retrieve the value
                                    var value;
                                    if (this.type === 'string') value = this._unescapeHTML(this.valueInnerText);
                                    else {
                                        var str = this._unescapeHTML(this.valueInnerText);
                                        value = (0, util.parseString)(str);
                                    }
                                    if (value !== this.value) {
                                        this.value = value;
                                        this._debouncedOnChangeValue();
                                    }
                                } catch (err) {
                                    // keep the previous value
                                    this._setValueError((0, i18n /* translate */ .Tl)('cannotParseValueError'));
                                }
                            }
                        },
                        {
                            key: "_setValueError",
                            value: function _setValueError(message) {
                                this.valueError = {
                                    message: message
                                };
                                this.updateError();
                            }
                        },
                        {
                            key: "_clearValueError",
                            value: function _clearValueError() {
                                if (this.valueError) {
                                    this.valueError = null;
                                    this.updateError();
                                }
                            }
                        },
                        {
                            key: "_setFieldError",
                            value: function _setFieldError(message) {
                                this.fieldError = {
                                    message: message
                                };
                                this.updateError();
                            }
                        },
                        {
                            key: "_clearFieldError",
                            value: function _clearFieldError() {
                                if (this.fieldError) {
                                    this.fieldError = null;
                                    this.updateError();
                                }
                            }
                        },
                        {
                            key: "_onChangeValue",
                            value: function _onChangeValue() {
                                // get current selection, then override the range such that we can select
                                // the added/removed text on undo/redo
                                var oldSelection = this.editor.getDomSelection();
                                if (oldSelection.range) {
                                    var undoDiff = (0, util.textDiff)(String(this.value), String(this.previousValue));
                                    oldSelection.range.startOffset = undoDiff.start;
                                    oldSelection.range.endOffset = undoDiff.end;
                                }
                                var newSelection = this.editor.getDomSelection();
                                if (newSelection.range) {
                                    var redoDiff = (0, util.textDiff)(String(this.previousValue), String(this.value));
                                    newSelection.range.startOffset = redoDiff.start;
                                    newSelection.range.endOffset = redoDiff.end;
                                }
                                this.editor._onAction('editValue', {
                                    path: this.getInternalPath(),
                                    oldValue: this.previousValue,
                                    newValue: this.value,
                                    oldSelection: oldSelection,
                                    newSelection: newSelection
                                });
                                this.previousValue = this.value;
                            }
                        },
                        {
                            key: "_onChangeField",
                            value: function _onChangeField() {
                                // get current selection, then override the range such that we can select
                                // the added/removed text on undo/redo
                                var oldSelection = this.editor.getDomSelection();
                                var previous = this.previousField || '';
                                if (oldSelection.range) {
                                    var undoDiff = (0, util.textDiff)(this.field, previous);
                                    oldSelection.range.startOffset = undoDiff.start;
                                    oldSelection.range.endOffset = undoDiff.end;
                                }
                                var newSelection = this.editor.getDomSelection();
                                if (newSelection.range) {
                                    var redoDiff = (0, util.textDiff)(previous, this.field);
                                    newSelection.range.startOffset = redoDiff.start;
                                    newSelection.range.endOffset = redoDiff.end;
                                }
                                this.editor._onAction('editField', {
                                    parentPath: this.parent.getInternalPath(),
                                    index: this.getIndex(),
                                    oldValue: this.previousField,
                                    newValue: this.field,
                                    oldSelection: oldSelection,
                                    newSelection: newSelection
                                });
                                this.previousField = this.field;
                            }
                        },
                        {
                            key: "_updateDomValue",
                            value: function _updateDomValue() {
                                var domValue = this.dom.value;
                                if (domValue) {
                                    var classNames = [
                                        'jsoneditor-value'
                                    ];
                                    // set text color depending on value type
                                    var value = this.value;
                                    var valueType = this.type === 'auto' ? (0, util.getType)(value) : this.type;
                                    var valueIsUrl = valueType === 'string' && (0, util.isUrl)(value);
                                    classNames.push('jsoneditor-' + valueType);
                                    if (valueIsUrl) classNames.push('jsoneditor-url');
                                    // visual styling when empty
                                    var isEmpty = String(this.value) === '' && this.type !== 'array' && this.type !== 'object';
                                    if (isEmpty) classNames.push('jsoneditor-empty');
                                    // highlight when there is a search result
                                    if (this.searchValueActive) classNames.push('jsoneditor-highlight-active');
                                    if (this.searchValue) classNames.push('jsoneditor-highlight');
                                    domValue.className = classNames.join(' ');
                                    // update title
                                    if (valueType === 'array' || valueType === 'object') {
                                        var count = this.childs ? this.childs.length : 0;
                                        domValue.title = this.type + ' containing ' + count + ' items';
                                    } else if (valueIsUrl && this.editable.value) domValue.title = (0, i18n /* translate */ .Tl)('openUrl');
                                    else domValue.title = '';
                                    // show checkbox when the value is a boolean
                                    if (valueType === 'boolean' && this.editable.value) {
                                        if (!this.dom.checkbox) {
                                            this.dom.checkbox = document.createElement('input');
                                            this.dom.checkbox.type = 'checkbox';
                                            this.dom.tdCheckbox = document.createElement('td');
                                            this.dom.tdCheckbox.className = 'jsoneditor-tree';
                                            this.dom.tdCheckbox.appendChild(this.dom.checkbox);
                                            this.dom.tdValue.parentNode.insertBefore(this.dom.tdCheckbox, this.dom.tdValue);
                                        }
                                        this.dom.checkbox.checked = this.value;
                                    } else // cleanup checkbox when displayed
                                    if (this.dom.tdCheckbox) {
                                        this.dom.tdCheckbox.parentNode.removeChild(this.dom.tdCheckbox);
                                        delete this.dom.tdCheckbox;
                                        delete this.dom.checkbox;
                                    }
                                    // create select box when this node has an enum object
                                    if (this["enum"] && this.editable.value) {
                                        if (!this.dom.select) {
                                            this.dom.select = document.createElement('select');
                                            this.id = this.field + '_' + new Date().getUTCMilliseconds();
                                            this.dom.select.id = this.id;
                                            this.dom.select.name = this.dom.select.id;
                                            // Create the default empty option
                                            var defaultOption = document.createElement('option');
                                            defaultOption.value = '';
                                            defaultOption.textContent = '--';
                                            this.dom.select.appendChild(defaultOption);
                                            // Iterate all enum values and add them as options
                                            this._updateEnumOptions();
                                            this.dom.tdSelect = document.createElement('td');
                                            this.dom.tdSelect.className = 'jsoneditor-tree';
                                            this.dom.tdSelect.appendChild(this.dom.select);
                                            this.dom.tdValue.parentNode.insertBefore(this.dom.tdSelect, this.dom.tdValue);
                                        }
                                        // Select the matching value
                                        this.dom.select.value = this["enum"].indexOf(this.value) !== -1 ? this.value : ''; // default
                                        // If the enum is inside a composite type display
                                        // both the simple input and the dropdown field
                                        if (this.schema && !Node_hasOwnProperty(this.schema, 'oneOf') && !Node_hasOwnProperty(this.schema, 'anyOf') && !Node_hasOwnProperty(this.schema, 'allOf')) {
                                            this.valueFieldHTML = this.dom.tdValue.innerHTML;
                                            this.dom.tdValue.style.visibility = 'hidden';
                                            this.dom.tdValue.textContent = '';
                                        } else delete this.valueFieldHTML;
                                    } else // cleanup select box when displayed, and attach the editable div instead
                                    if (this.dom.tdSelect) {
                                        this.dom.tdSelect.parentNode.removeChild(this.dom.tdSelect);
                                        delete this.dom.tdSelect;
                                        delete this.dom.select;
                                        this.dom.tdValue.innerHTML = this.valueFieldHTML;
                                        this.dom.tdValue.style.visibility = '';
                                        delete this.valueFieldHTML;
                                        this.dom.tdValue.appendChild(this.dom.value);
                                    }
                                    // show color picker when value is a color
                                    if (this.editor.options.colorPicker && typeof value === 'string' && (0, util.isValidColor)(value)) {
                                        if (!this.dom.color) {
                                            this.dom.color = document.createElement('div');
                                            this.dom.color.className = 'jsoneditor-color';
                                            this.dom.tdColor = document.createElement('td');
                                            this.dom.tdColor.className = 'jsoneditor-tree';
                                            this.dom.tdColor.appendChild(this.dom.color);
                                            this.dom.tdValue.parentNode.insertBefore(this.dom.tdColor, this.dom.tdValue);
                                        }
                                        // update styling of value and color background
                                        (0, util.addClassName)(this.dom.value, 'jsoneditor-color-value');
                                        if (!this.editable.value) (0, util.addClassName)(this.dom.color, 'jsoneditor-color-readonly');
                                        else (0, util.removeClassName)(this.dom.color, 'jsoneditor-color-readonly');
                                        this.dom.color.style.backgroundColor = value;
                                    } else // cleanup color picker when displayed
                                    this._deleteDomColor();
                                    // show date tag when value is a timestamp in milliseconds
                                    if (this._showTimestampTag()) {
                                        if (!this.dom.date) {
                                            this.dom.date = document.createElement('div');
                                            this.dom.date.className = 'jsoneditor-date';
                                            this.dom.value.parentNode.appendChild(this.dom.date);
                                        }
                                        var title = null;
                                        if (typeof this.editor.options.timestampFormat === 'function') title = this.editor.options.timestampFormat({
                                            field: this.field,
                                            value: this.value,
                                            path: this.getPath()
                                        });
                                        if (!title) this.dom.date.textContent = new Date(value).toISOString();
                                        else {
                                            while(this.dom.date.firstChild)this.dom.date.removeChild(this.dom.date.firstChild);
                                            this.dom.date.appendChild(document.createTextNode(title));
                                        }
                                        this.dom.date.title = new Date(value).toString();
                                    } else // cleanup date tag
                                    if (this.dom.date) {
                                        this.dom.date.parentNode.removeChild(this.dom.date);
                                        delete this.dom.date;
                                    }
                                    // strip formatting from the contents of the editable div
                                    (0, util.stripFormatting)(domValue);
                                    this._updateDomDefault();
                                }
                            }
                        },
                        {
                            key: "_updateEnumOptions",
                            value: function _updateEnumOptions() {
                                if (!this["enum"] || !this.dom.select) return;
                                // clear the existing options
                                this.dom.select.innerHTML = '';
                                // Iterate all enum values and add them as options
                                for(var i = 0; i < this["enum"].length; i++){
                                    var option = document.createElement('option');
                                    option.value = this["enum"][i];
                                    option.textContent = this["enum"][i];
                                    this.dom.select.appendChild(option);
                                }
                            }
                        },
                        {
                            key: "_deleteDomColor",
                            value: function _deleteDomColor() {
                                if (this.dom.color) {
                                    this.dom.tdColor.parentNode.removeChild(this.dom.tdColor);
                                    delete this.dom.tdColor;
                                    delete this.dom.color;
                                    (0, util.removeClassName)(this.dom.value, 'jsoneditor-color-value');
                                }
                            }
                        },
                        {
                            key: "_updateDomField",
                            value: function _updateDomField() {
                                var domField = this.dom.field;
                                if (domField) {
                                    var tooltip = (0, util.makeFieldTooltip)(this.schema, this.editor.options.language);
                                    if (tooltip) domField.title = tooltip;
                                    // make background color lightgray when empty
                                    var isEmpty = String(this.field) === '' && this.parent && this.parent.type !== 'array';
                                    if (isEmpty) (0, util.addClassName)(domField, 'jsoneditor-empty');
                                    else (0, util.removeClassName)(domField, 'jsoneditor-empty');
                                    // highlight when there is a search result
                                    if (this.searchFieldActive) (0, util.addClassName)(domField, 'jsoneditor-highlight-active');
                                    else (0, util.removeClassName)(domField, 'jsoneditor-highlight-active');
                                    if (this.searchField) (0, util.addClassName)(domField, 'jsoneditor-highlight');
                                    else (0, util.removeClassName)(domField, 'jsoneditor-highlight');
                                    // strip formatting from the contents of the editable div
                                    (0, util.stripFormatting)(domField);
                                }
                            }
                        },
                        {
                            key: "_getDomField",
                            value: function _getDomField(forceUnique) {
                                this._clearFieldError();
                                if (this.dom.field && this.fieldEditable) {
                                    this.fieldInnerText = (0, util.getInnerText)(this.dom.field);
                                    if (this.fieldInnerText === '' && this.dom.field.innerHTML !== '') // When clearing the contents, often a <br/> remains, messing up the
                                    // styling of the empty text box. Therefore we remove the <br/>
                                    this.dom.field.textContent = '';
                                }
                                if (this.fieldInnerText !== undefined) try {
                                    var field = this._unescapeHTML(this.fieldInnerText);
                                    var existingFieldNames = this.parent.getFieldNames(this);
                                    var isDuplicate = existingFieldNames.indexOf(field) !== -1;
                                    if (!isDuplicate) {
                                        if (field !== this.field) {
                                            this.field = field;
                                            this._debouncedOnChangeField();
                                        }
                                    } else if (forceUnique) {
                                        // fix duplicate field: change it into a unique name
                                        field = (0, util.findUniqueName)(field, existingFieldNames);
                                        if (field !== this.field) {
                                            this.field = field;
                                            // TODO: don't debounce but resolve right away, and cancel current debounce
                                            this._debouncedOnChangeField();
                                        }
                                    } else this._setFieldError((0, i18n /* translate */ .Tl)('duplicateFieldError'));
                                } catch (err) {
                                    // keep the previous field value
                                    this._setFieldError((0, i18n /* translate */ .Tl)('cannotParseFieldError'));
                                }
                            }
                        },
                        {
                            key: "_updateDomDefault",
                            value: function _updateDomDefault() {
                                // Short-circuit if schema is missing, has no default, or if Node has children
                                if (!this.schema || this.schema["default"] === undefined || this._hasChilds()) return;
                                // select either enum dropdown (select) or input value
                                var inputElement = this.dom.select ? this.dom.select : this.dom.value;
                                if (!inputElement) return;
                                if (this.value === this.schema["default"]) {
                                    inputElement.title = (0, i18n /* translate */ .Tl)('default');
                                    (0, util.addClassName)(inputElement, 'jsoneditor-is-default');
                                    (0, util.removeClassName)(inputElement, 'jsoneditor-is-not-default');
                                } else {
                                    inputElement.removeAttribute('title');
                                    (0, util.removeClassName)(inputElement, 'jsoneditor-is-default');
                                    (0, util.addClassName)(inputElement, 'jsoneditor-is-not-default');
                                }
                            }
                        },
                        {
                            key: "_showTimestampTag",
                            value: function _showTimestampTag() {
                                if (typeof this.value !== 'number') return false;
                                var timestampTag = this.editor.options.timestampTag;
                                if (typeof timestampTag === 'function') {
                                    var result = timestampTag({
                                        field: this.field,
                                        value: this.value,
                                        path: this.getPath()
                                    });
                                    if (typeof result === 'boolean') return result;
                                    else return (0, util.isTimestamp)(this.field, this.value);
                                } else if (timestampTag === true) return (0, util.isTimestamp)(this.field, this.value);
                                else return false;
                            }
                        },
                        {
                            key: "clearDom",
                            value: function clearDom() {
                                // TODO: hide the node first?
                                // this.hide();
                                // TODO: recursively clear dom?
                                this.dom = {};
                            }
                        },
                        {
                            key: "getDom",
                            value: function getDom() {
                                var dom = this.dom;
                                if (dom.tr) return dom.tr;
                                this._updateEditability();
                                // create row
                                dom.tr = document.createElement('tr');
                                dom.tr.node = this;
                                if (this.editor.options.mode === 'tree') {
                                    // note: we take here the global setting
                                    var tdDrag = document.createElement('td');
                                    if (this.editable.field) // create draggable area
                                    {
                                        if (this.parent) {
                                            var domDrag = document.createElement('button');
                                            domDrag.type = 'button';
                                            dom.drag = domDrag;
                                            domDrag.className = 'jsoneditor-button jsoneditor-dragarea';
                                            domDrag.title = (0, i18n /* translate */ .Tl)('drag');
                                            tdDrag.appendChild(domDrag);
                                        }
                                    }
                                    dom.tr.appendChild(tdDrag);
                                    // create context menu
                                    var tdMenu = document.createElement('td');
                                    var menu = document.createElement('button');
                                    menu.type = 'button';
                                    dom.menu = menu;
                                    menu.className = 'jsoneditor-button jsoneditor-contextmenu-button';
                                    menu.title = (0, i18n /* translate */ .Tl)('actionsMenu');
                                    tdMenu.appendChild(dom.menu);
                                    dom.tr.appendChild(tdMenu);
                                }
                                // create tree and field
                                var tdField = document.createElement('td');
                                dom.tr.appendChild(tdField);
                                dom.tree = this._createDomTree();
                                tdField.appendChild(dom.tree);
                                this.updateDom({
                                    updateIndexes: true
                                });
                                return dom.tr;
                            }
                        },
                        {
                            key: "isVisible",
                            value: function isVisible() {
                                return this.dom && this.dom.tr && this.dom.tr.parentNode || false;
                            }
                        },
                        {
                            key: "isDescendantOf",
                            value: function isDescendantOf(node) {
                                var n = this.parent;
                                while(n){
                                    if (n === node) return true;
                                    n = n.parent;
                                }
                                return false;
                            }
                        },
                        {
                            key: "_createDomField",
                            value: function _createDomField() {
                                return document.createElement('div');
                            }
                        },
                        {
                            key: "setHighlight",
                            value: function setHighlight(highlight) {
                                if (this.dom.tr) {
                                    if (highlight) (0, util.addClassName)(this.dom.tr, 'jsoneditor-highlight');
                                    else (0, util.removeClassName)(this.dom.tr, 'jsoneditor-highlight');
                                    if (this.append) this.append.setHighlight(highlight);
                                    if (this.childs) this.childs.forEach(function(child) {
                                        child.setHighlight(highlight);
                                    });
                                }
                            }
                        },
                        {
                            key: "setSelected",
                            value: function setSelected(selected, isFirst) {
                                this.selected = selected;
                                if (this.dom.tr) {
                                    if (selected) (0, util.addClassName)(this.dom.tr, 'jsoneditor-selected');
                                    else (0, util.removeClassName)(this.dom.tr, 'jsoneditor-selected');
                                    if (isFirst) (0, util.addClassName)(this.dom.tr, 'jsoneditor-first');
                                    else (0, util.removeClassName)(this.dom.tr, 'jsoneditor-first');
                                    if (this.append) this.append.setSelected(selected);
                                    if (this.showMore) this.showMore.setSelected(selected);
                                    if (this.childs) this.childs.forEach(function(child) {
                                        child.setSelected(selected);
                                    });
                                }
                            }
                        },
                        {
                            key: "updateValue",
                            value: function updateValue(value) {
                                this.value = value;
                                this.previousValue = value;
                                this.valueError = undefined;
                                this.updateDom();
                            }
                        },
                        {
                            key: "updateField",
                            value: function updateField(field) {
                                this.field = field;
                                this.previousField = field;
                                this.fieldError = undefined;
                                this.updateDom();
                            }
                        },
                        {
                            key: "updateDom",
                            value: function updateDom(options) {
                                // update level indentation
                                var domTree = this.dom.tree;
                                if (domTree) domTree.style.marginLeft = this.getLevel() * 24 + 'px';
                                // apply field to DOM
                                var domField = this.dom.field;
                                if (domField) {
                                    if (this.fieldEditable) {
                                        // parent is an object
                                        domField.contentEditable = this.editable.field;
                                        domField.spellcheck = false;
                                        domField.className = 'jsoneditor-field';
                                    } else {
                                        // parent is an array this is the root node
                                        domField.contentEditable = false;
                                        domField.className = 'jsoneditor-readonly';
                                    }
                                    var fieldText;
                                    if (this.index !== undefined) fieldText = this.index;
                                    else if (this.field !== undefined) fieldText = this.field;
                                    else {
                                        var schema = this.editor.options.schema ? Node1._findSchema(this.editor.options.schema, this.editor.options.schemaRefs || {}, this.getPath()) : undefined;
                                        if (schema && schema.title) fieldText = schema.title;
                                        else if (this._hasChilds()) fieldText = this.type;
                                        else fieldText = '';
                                    }
                                    var escapedField = this._escapeHTML(fieldText);
                                    if (document.activeElement !== domField && escapedField !== this._unescapeHTML((0, util.getInnerText)(domField))) // only update if it not has the focus or when there is an actual change,
                                    // else you would needlessly loose the caret position when changing tabs
                                    // or whilst typing
                                    domField.innerHTML = escapedField;
                                    this._updateSchema();
                                    this._updateEnumOptions();
                                }
                                // apply value to DOM
                                var domValue = this.dom.value;
                                if (domValue) {
                                    if (this.type === 'array' || this.type === 'object') this.updateNodeName();
                                    else {
                                        var escapedValue = this._escapeHTML(this.value);
                                        if (document.activeElement !== domValue && escapedValue !== this._unescapeHTML((0, util.getInnerText)(domValue))) // only update if it not has the focus or when there is an actual change,
                                        // else you would needlessly loose the caret position when changing tabs
                                        // or whilst typing
                                        domValue.innerHTML = escapedValue;
                                    }
                                }
                                // apply styling to the table row
                                var tr = this.dom.tr;
                                if (tr) {
                                    if (this.type === 'array' || this.type === 'object') {
                                        (0, util.addClassName)(tr, 'jsoneditor-expandable');
                                        if (this.expanded) {
                                            (0, util.addClassName)(tr, 'jsoneditor-expanded');
                                            (0, util.removeClassName)(tr, 'jsoneditor-collapsed');
                                        } else {
                                            (0, util.addClassName)(tr, 'jsoneditor-collapsed');
                                            (0, util.removeClassName)(tr, 'jsoneditor-expanded');
                                        }
                                    } else {
                                        (0, util.removeClassName)(tr, 'jsoneditor-expandable');
                                        (0, util.removeClassName)(tr, 'jsoneditor-expanded');
                                        (0, util.removeClassName)(tr, 'jsoneditor-collapsed');
                                    }
                                }
                                // update field and value
                                this._updateDomField();
                                this._updateDomValue();
                                // update childs indexes
                                if (options && options.updateIndexes === true) // updateIndexes is true or undefined
                                this._updateDomIndexes();
                                // update childs recursively
                                if (options && options.recurse === true) {
                                    if (this.childs) this.childs.forEach(function(child) {
                                        child.updateDom(options);
                                    });
                                }
                                // update rendering of error
                                if (this.error) this.updateError();
                                // update row with append button
                                if (this.append) this.append.updateDom();
                                // update "show more" text at the bottom of large arrays
                                if (this.showMore) this.showMore.updateDom();
                                // fire onClassName
                                this._updateCssClassName();
                            }
                        },
                        {
                            key: "_updateSchema",
                            value: function _updateSchema() {
                                // Locating the schema of the node and checking for any enum type
                                if (this.editor && this.editor.options) {
                                    // find the part of the json schema matching this nodes path
                                    this.schema = this.editor.options.schema ? Node1._findSchema(this.editor.options.schema, this.editor.options.schemaRefs || {}, this.getPath()) : null;
                                    if (this.schema) this["enum"] = Node1._findEnum(this.schema);
                                    else delete this["enum"];
                                }
                            }
                        },
                        {
                            key: "_updateDomIndexes",
                            value: function _updateDomIndexes() {
                                var domValue = this.dom.value;
                                var childs = this.childs;
                                if (domValue && childs) {
                                    if (this.type === 'array') childs.forEach(function(child, index) {
                                        child.index = index;
                                        var childField = child.dom.field;
                                        if (childField) childField.textContent = index;
                                    });
                                    else if (this.type === 'object') childs.forEach(function(child) {
                                        if (child.index !== undefined) {
                                            delete child.index;
                                            if (child.field === undefined) child.field = '';
                                        }
                                    });
                                }
                            }
                        },
                        {
                            key: "_createDomValue",
                            value: function _createDomValue() {
                                var domValue;
                                if (this.type === 'array') {
                                    domValue = document.createElement('div');
                                    domValue.textContent = '[...]';
                                } else if (this.type === 'object') {
                                    domValue = document.createElement('div');
                                    domValue.textContent = '{...}';
                                } else if (!this.editable.value && (0, util.isUrl)(this.value)) {
                                    // create a link in case of read-only editor and value containing an url
                                    domValue = document.createElement('a');
                                    domValue.href = this.value;
                                    domValue.innerHTML = this._escapeHTML(this.value);
                                } else {
                                    // create an editable or read-only div
                                    domValue = document.createElement('div');
                                    domValue.contentEditable = this.editable.value;
                                    domValue.spellcheck = false;
                                    domValue.innerHTML = this._escapeHTML(this.value);
                                }
                                return domValue;
                            }
                        },
                        {
                            key: "_createDomExpandButton",
                            value: function _createDomExpandButton() {
                                // create expand button
                                var expand = document.createElement('button');
                                expand.type = 'button';
                                if (this._hasChilds()) {
                                    expand.className = this.expanded ? 'jsoneditor-button jsoneditor-expanded' : 'jsoneditor-button jsoneditor-collapsed';
                                    expand.title = (0, i18n /* translate */ .Tl)('expandTitle');
                                } else {
                                    expand.className = 'jsoneditor-button jsoneditor-invisible';
                                    expand.title = '';
                                }
                                return expand;
                            }
                        },
                        {
                            key: "_createDomTree",
                            value: function _createDomTree() {
                                var dom = this.dom;
                                var domTree = document.createElement('table');
                                var tbody = document.createElement('tbody');
                                domTree.style.borderCollapse = 'collapse'; // TODO: put in css
                                domTree.className = 'jsoneditor-values';
                                domTree.appendChild(tbody);
                                var tr = document.createElement('tr');
                                tbody.appendChild(tr);
                                // create expand button
                                var tdExpand = document.createElement('td');
                                tdExpand.className = 'jsoneditor-tree';
                                tr.appendChild(tdExpand);
                                dom.expand = this._createDomExpandButton();
                                tdExpand.appendChild(dom.expand);
                                dom.tdExpand = tdExpand;
                                // create the field
                                var tdField = document.createElement('td');
                                tdField.className = 'jsoneditor-tree';
                                tr.appendChild(tdField);
                                dom.field = this._createDomField();
                                tdField.appendChild(dom.field);
                                dom.tdField = tdField;
                                // create a separator
                                var tdSeparator = document.createElement('td');
                                tdSeparator.className = 'jsoneditor-tree';
                                tr.appendChild(tdSeparator);
                                if (this.type !== 'object' && this.type !== 'array') {
                                    tdSeparator.appendChild(document.createTextNode(':'));
                                    tdSeparator.className = 'jsoneditor-separator';
                                }
                                dom.tdSeparator = tdSeparator;
                                // create the value
                                var tdValue = document.createElement('td');
                                tdValue.className = 'jsoneditor-tree';
                                tr.appendChild(tdValue);
                                dom.value = this._createDomValue();
                                tdValue.appendChild(dom.value);
                                dom.tdValue = tdValue;
                                return domTree;
                            }
                        },
                        {
                            key: "onEvent",
                            value: function onEvent(event) {
                                var type = event.type;
                                var target = event.target || event.srcElement;
                                var dom = this.dom;
                                var node = this;
                                var expandable = this._hasChilds();
                                // check if mouse is on menu or on dragarea.
                                // If so, highlight current row and its childs
                                if (target === dom.drag || target === dom.menu) {
                                    if (type === 'mouseover') this.editor.highlighter.highlight(this);
                                    else if (type === 'mouseout') this.editor.highlighter.unhighlight();
                                }
                                // context menu events
                                if (type === 'click' && target === dom.menu) {
                                    var highlighter = node.editor.highlighter;
                                    highlighter.highlight(node);
                                    highlighter.lock();
                                    (0, util.addClassName)(dom.menu, 'jsoneditor-selected');
                                    this.showContextMenu(dom.menu, function() {
                                        (0, util.removeClassName)(dom.menu, 'jsoneditor-selected');
                                        highlighter.unlock();
                                        highlighter.unhighlight();
                                    });
                                }
                                // expand events
                                if (type === 'click') {
                                    if (target === dom.expand) {
                                        if (expandable) {
                                            var recurse = event.ctrlKey; // with ctrl-key, expand/collapse all
                                            this._onExpand(recurse);
                                        }
                                    }
                                }
                                if (type === 'click' && (event.target === node.dom.tdColor || event.target === node.dom.color) && this.editable.value) this._showColorPicker();
                                // swap the value of a boolean when the checkbox displayed left is clicked
                                if (type === 'change' && target === dom.checkbox) {
                                    this.dom.value.textContent = String(!this.value);
                                    this._getDomValue();
                                    this._updateDomDefault();
                                }
                                // update the value of the node based on the selected option
                                if (type === 'change' && target === dom.select) {
                                    this.dom.value.innerHTML = this._escapeHTML(dom.select.value);
                                    this._getDomValue();
                                    this._updateDomValue();
                                }
                                // value events
                                var domValue = dom.value;
                                if (target === domValue) // noinspection FallthroughInSwitchStatementJS
                                switch(type){
                                    case 'blur':
                                    case 'change':
                                        this._getDomValue();
                                        this._clearValueError();
                                        this._updateDomValue();
                                        var escapedValue = this._escapeHTML(this.value);
                                        if (escapedValue !== this._unescapeHTML((0, util.getInnerText)(domValue))) // only update when there is an actual change, else you loose the
                                        // caret position when changing tabs or whilst typing
                                        domValue.innerHTML = escapedValue;
                                        break;
                                    case 'input':
                                        // this._debouncedGetDomValue(true); // TODO
                                        this._getDomValue();
                                        this._updateDomValue();
                                        break;
                                    case 'keydown':
                                    case 'mousedown':
                                        // TODO: cleanup
                                        this.editor.selection = this.editor.getDomSelection();
                                        break;
                                    case 'click':
                                        if (event.ctrlKey && this.editable.value) // if read-only, we use the regular click behavior of an anchor
                                        {
                                            if ((0, util.isUrl)(this.value)) {
                                                event.preventDefault();
                                                window.open(this.value, '_blank', 'noreferrer');
                                            }
                                        }
                                        break;
                                    case 'keyup':
                                        // this._debouncedGetDomValue(true); // TODO
                                        this._getDomValue();
                                        this._updateDomValue();
                                        break;
                                    case 'cut':
                                    case 'paste':
                                        setTimeout(function() {
                                            node._getDomValue();
                                            node._updateDomValue();
                                        }, 1);
                                        break;
                                }
                                // field events
                                var domField = dom.field;
                                if (target === domField) switch(type){
                                    case 'blur':
                                        this._getDomField(true);
                                        this._updateDomField();
                                        var escapedField = this._escapeHTML(this.field);
                                        if (escapedField !== this._unescapeHTML((0, util.getInnerText)(domField))) // only update when there is an actual change, else you loose the
                                        // caret position when changing tabs or whilst typing
                                        domField.innerHTML = escapedField;
                                        break;
                                    case 'input':
                                        this._getDomField();
                                        this._updateSchema();
                                        this._updateDomField();
                                        this._updateDomValue();
                                        break;
                                    case 'keydown':
                                    case 'mousedown':
                                        this.editor.selection = this.editor.getDomSelection();
                                        break;
                                    case 'keyup':
                                        this._getDomField();
                                        this._updateDomField();
                                        break;
                                    case 'cut':
                                    case 'paste':
                                        setTimeout(function() {
                                            node._getDomField();
                                            node._updateDomField();
                                        }, 1);
                                        break;
                                }
                                // focus
                                // when clicked in whitespace left or right from the field or value, set focus
                                var domTree = dom.tree;
                                if (domTree && target === domTree.parentNode && type === 'click' && !event.hasMoved) {
                                    var left = event.offsetX !== undefined ? event.offsetX < (this.getLevel() + 1) * 24 : event.pageX < (0, util.getAbsoluteLeft)(dom.tdSeparator); // for FF
                                    if (left || expandable) // node is expandable when it is an object or array
                                    {
                                        if (domField) {
                                            (0, util.setEndOfContentEditable)(domField);
                                            domField.focus();
                                        }
                                    } else if (domValue && !this["enum"]) {
                                        (0, util.setEndOfContentEditable)(domValue);
                                        domValue.focus();
                                    }
                                }
                                if ((target === dom.tdExpand && !expandable || target === dom.tdField || target === dom.tdSeparator) && type === 'click' && !event.hasMoved) {
                                    if (domField) {
                                        (0, util.setEndOfContentEditable)(domField);
                                        domField.focus();
                                    }
                                }
                                if (type === 'keydown') this.onKeyDown(event);
                                // fire after applying for example a change by clicking a checkbox
                                if (typeof this.editor.options.onEvent === 'function') this._onEvent(event);
                            }
                        },
                        {
                            key: "_onEvent",
                            value: function _onEvent(event) {
                                var element = event.target;
                                var isField = element === this.dom.field;
                                var isValue = element === this.dom.value || element === this.dom.checkbox || element === this.dom.select;
                                if (isField || isValue) {
                                    var info = {
                                        field: this.getField(),
                                        path: this.getPath()
                                    };
                                    // For leaf values, include value
                                    if (isValue && !this._hasChilds()) info.value = this.getValue();
                                    this.editor.options.onEvent(info, event);
                                }
                            }
                        },
                        {
                            key: "onKeyDown",
                            value: function onKeyDown(event) {
                                var keynum = event.which || event.keyCode;
                                var target = event.target || event.srcElement;
                                var ctrlKey = event.ctrlKey;
                                var shiftKey = event.shiftKey;
                                var altKey = event.altKey;
                                var handled = false;
                                var prevNode, nextNode, nextDom, nextDom2;
                                var editable = this.editor.options.mode === 'tree';
                                var oldSelection;
                                var oldNextNode;
                                var oldParent;
                                var oldIndexRedo;
                                var newIndexRedo;
                                var oldParentPathRedo;
                                var newParentPathRedo;
                                var nodes;
                                var multiselection;
                                var selectedNodes = this.editor.multiselection.nodes.length > 0 ? this.editor.multiselection.nodes : [
                                    this
                                ];
                                var firstNode = selectedNodes[0];
                                var lastNode = selectedNodes[selectedNodes.length - 1];
                                // console.log(ctrlKey, keynum, event.charCode); // TODO: cleanup
                                if (keynum === 13) {
                                    // Enter
                                    if (target === this.dom.value) {
                                        if (!this.editable.value || event.ctrlKey) {
                                            if ((0, util.isUrl)(this.value)) {
                                                window.open(this.value, '_blank', 'noreferrer');
                                                handled = true;
                                            }
                                        }
                                    } else if (target === this.dom.expand) {
                                        var expandable = this._hasChilds();
                                        if (expandable) {
                                            var recurse = event.ctrlKey; // with ctrl-key, expand/collapse all
                                            this._onExpand(recurse);
                                            target.focus();
                                            handled = true;
                                        }
                                    }
                                } else if (keynum === 68) // D
                                {
                                    if (ctrlKey && editable) {
                                        // Ctrl+D
                                        Node1.onDuplicate(selectedNodes);
                                        handled = true;
                                    }
                                } else if (keynum === 69) // E
                                {
                                    if (ctrlKey) {
                                        // Ctrl+E and Ctrl+Shift+E
                                        this._onExpand(shiftKey); // recurse = shiftKey
                                        target.focus(); // TODO: should restore focus in case of recursing expand (which takes DOM offline)
                                        handled = true;
                                    }
                                } else if (keynum === 77 && editable) // M
                                {
                                    if (ctrlKey) {
                                        // Ctrl+M
                                        this.showContextMenu(target);
                                        handled = true;
                                    }
                                } else if (keynum === 46 && editable) // Del
                                {
                                    if (ctrlKey) {
                                        // Ctrl+Del
                                        Node1.onRemove(selectedNodes);
                                        handled = true;
                                    }
                                } else if (keynum === 45 && editable) {
                                    // Ins
                                    if (ctrlKey && !shiftKey) {
                                        // Ctrl+Ins
                                        this._onInsertBefore();
                                        handled = true;
                                    } else if (ctrlKey && shiftKey) {
                                        // Ctrl+Shift+Ins
                                        this._onInsertAfter();
                                        handled = true;
                                    }
                                } else if (keynum === 35) // End
                                {
                                    if (altKey) {
                                        // Alt+End
                                        // find the last node
                                        var endNode = this._lastNode();
                                        if (endNode) endNode.focus(Node1.focusElement || this._getElementName(target));
                                        handled = true;
                                    }
                                } else if (keynum === 36) // Home
                                {
                                    if (altKey) {
                                        // Alt+Home
                                        // find the first node
                                        var homeNode = this._firstNode();
                                        if (homeNode) homeNode.focus(Node1.focusElement || this._getElementName(target));
                                        handled = true;
                                    }
                                } else if (keynum === 37) {
                                    // Arrow Left
                                    if (altKey && !shiftKey) {
                                        // Alt + Arrow Left
                                        // move to left element
                                        var prevElement = this._previousElement(target);
                                        if (prevElement) this.focus(this._getElementName(prevElement));
                                        handled = true;
                                    } else if (altKey && shiftKey && editable) {
                                        // Alt + Shift + Arrow left
                                        if (lastNode.expanded) {
                                            var appendDom = lastNode.getAppendDom();
                                            nextDom = appendDom ? appendDom.nextSibling : undefined;
                                        } else {
                                            var dom = lastNode.getDom();
                                            nextDom = dom.nextSibling;
                                        }
                                        if (nextDom) {
                                            nextNode = Node1.getNodeFromTarget(nextDom);
                                            nextDom2 = nextDom.nextSibling;
                                            var nextNode2 = Node1.getNodeFromTarget(nextDom2);
                                            if (nextNode && nextNode instanceof AppendNode && !(lastNode.parent.childs.length === 1) && nextNode2 && nextNode2.parent) {
                                                oldSelection = this.editor.getDomSelection();
                                                oldParent = firstNode.parent;
                                                oldNextNode = oldParent.childs[lastNode.getIndex() + 1] || oldParent.append;
                                                oldIndexRedo = firstNode.getIndex();
                                                newIndexRedo = nextNode2.getIndex();
                                                oldParentPathRedo = oldParent.getInternalPath();
                                                newParentPathRedo = nextNode2.parent.getInternalPath();
                                                selectedNodes.forEach(function(node) {
                                                    nextNode2.parent.moveBefore(node, nextNode2);
                                                });
                                                this.focus(Node1.focusElement || this._getElementName(target));
                                                this.editor._onAction('moveNodes', {
                                                    count: selectedNodes.length,
                                                    fieldNames: selectedNodes.map(getField),
                                                    oldParentPath: oldParent.getInternalPath(),
                                                    newParentPath: firstNode.parent.getInternalPath(),
                                                    oldIndex: oldNextNode.getIndex(),
                                                    newIndex: firstNode.getIndex(),
                                                    oldIndexRedo: oldIndexRedo,
                                                    newIndexRedo: newIndexRedo,
                                                    oldParentPathRedo: oldParentPathRedo,
                                                    newParentPathRedo: newParentPathRedo,
                                                    oldSelection: oldSelection,
                                                    newSelection: this.editor.getDomSelection()
                                                });
                                            }
                                        }
                                    }
                                } else if (keynum === 38) {
                                    // Arrow Up
                                    if (altKey && !shiftKey) {
                                        // Alt + Arrow Up
                                        // find the previous node
                                        prevNode = this._previousNode();
                                        if (prevNode) {
                                            this.editor.deselect(true);
                                            prevNode.focus(Node1.focusElement || this._getElementName(target));
                                        }
                                        handled = true;
                                    } else if (!altKey && ctrlKey && shiftKey && editable) {
                                        // Ctrl + Shift + Arrow Up
                                        // select multiple nodes
                                        prevNode = this._previousNode();
                                        if (prevNode) {
                                            multiselection = this.editor.multiselection;
                                            multiselection.start = multiselection.start || this;
                                            multiselection.end = prevNode;
                                            nodes = this.editor._findTopLevelNodes(multiselection.start, multiselection.end);
                                            this.editor.select(nodes);
                                            prevNode.focus('field'); // select field as we know this always exists
                                        }
                                        handled = true;
                                    } else if (altKey && shiftKey && editable) {
                                        // Alt + Shift + Arrow Up
                                        // find the previous node
                                        prevNode = firstNode._previousNode();
                                        if (prevNode && prevNode.parent) {
                                            oldSelection = this.editor.getDomSelection();
                                            oldParent = firstNode.parent;
                                            oldNextNode = oldParent.childs[lastNode.getIndex() + 1] || oldParent.append;
                                            oldIndexRedo = firstNode.getIndex();
                                            newIndexRedo = prevNode.getIndex();
                                            oldParentPathRedo = oldParent.getInternalPath();
                                            newParentPathRedo = prevNode.parent.getInternalPath();
                                            selectedNodes.forEach(function(node) {
                                                prevNode.parent.moveBefore(node, prevNode);
                                            });
                                            this.focus(Node1.focusElement || this._getElementName(target));
                                            this.editor._onAction('moveNodes', {
                                                count: selectedNodes.length,
                                                fieldNames: selectedNodes.map(getField),
                                                oldParentPath: oldParent.getInternalPath(),
                                                newParentPath: firstNode.parent.getInternalPath(),
                                                oldIndex: oldNextNode.getIndex(),
                                                newIndex: firstNode.getIndex(),
                                                oldIndexRedo: oldIndexRedo,
                                                newIndexRedo: newIndexRedo,
                                                oldParentPathRedo: oldParentPathRedo,
                                                newParentPathRedo: newParentPathRedo,
                                                oldSelection: oldSelection,
                                                newSelection: this.editor.getDomSelection()
                                            });
                                        }
                                        handled = true;
                                    }
                                } else if (keynum === 39) {
                                    // Arrow Right
                                    if (altKey && !shiftKey) {
                                        // Alt + Arrow Right
                                        // move to right element
                                        var nextElement = this._nextElement(target);
                                        if (nextElement) this.focus(this._getElementName(nextElement));
                                        handled = true;
                                    } else if (altKey && shiftKey && editable) {
                                        // Alt + Shift + Arrow Right
                                        var _dom = firstNode.getDom();
                                        var prevDom = _dom.previousSibling;
                                        if (prevDom) {
                                            prevNode = Node1.getNodeFromTarget(prevDom);
                                            if (prevNode && prevNode.parent && !prevNode.isVisible()) {
                                                oldSelection = this.editor.getDomSelection();
                                                oldParent = firstNode.parent;
                                                oldNextNode = oldParent.childs[lastNode.getIndex() + 1] || oldParent.append;
                                                oldIndexRedo = firstNode.getIndex();
                                                newIndexRedo = prevNode.getIndex();
                                                oldParentPathRedo = oldParent.getInternalPath();
                                                newParentPathRedo = prevNode.parent.getInternalPath();
                                                selectedNodes.forEach(function(node) {
                                                    prevNode.parent.moveBefore(node, prevNode);
                                                });
                                                this.focus(Node1.focusElement || this._getElementName(target));
                                                this.editor._onAction('moveNodes', {
                                                    count: selectedNodes.length,
                                                    fieldNames: selectedNodes.map(getField),
                                                    oldParentPath: oldParent.getInternalPath(),
                                                    newParentPath: firstNode.parent.getInternalPath(),
                                                    oldIndex: oldNextNode.getIndex(),
                                                    newIndex: firstNode.getIndex(),
                                                    oldIndexRedo: oldIndexRedo,
                                                    newIndexRedo: newIndexRedo,
                                                    oldParentPathRedo: oldParentPathRedo,
                                                    newParentPathRedo: newParentPathRedo,
                                                    oldSelection: oldSelection,
                                                    newSelection: this.editor.getDomSelection()
                                                });
                                            }
                                        }
                                    }
                                } else if (keynum === 40) {
                                    // Arrow Down
                                    if (altKey && !shiftKey) {
                                        // Alt + Arrow Down
                                        // find the next node
                                        nextNode = this._nextNode();
                                        if (nextNode) {
                                            this.editor.deselect(true);
                                            nextNode.focus(Node1.focusElement || this._getElementName(target));
                                        }
                                        handled = true;
                                    } else if (!altKey && ctrlKey && shiftKey && editable) {
                                        // Ctrl + Shift + Arrow Down
                                        // select multiple nodes
                                        nextNode = this._nextNode();
                                        if (nextNode) {
                                            multiselection = this.editor.multiselection;
                                            multiselection.start = multiselection.start || this;
                                            multiselection.end = nextNode;
                                            nodes = this.editor._findTopLevelNodes(multiselection.start, multiselection.end);
                                            this.editor.select(nodes);
                                            nextNode.focus('field'); // select field as we know this always exists
                                        }
                                        handled = true;
                                    } else if (altKey && shiftKey && editable) {
                                        // Alt + Shift + Arrow Down
                                        // find the 2nd next node and move before that one
                                        if (lastNode.expanded) nextNode = lastNode.append ? lastNode.append._nextNode() : undefined;
                                        else nextNode = lastNode._nextNode();
                                        // when the next node is not visible, we've reached the "showMore" buttons
                                        if (nextNode && !nextNode.isVisible()) nextNode = nextNode.parent.showMore;
                                        if (nextNode && nextNode instanceof AppendNode) nextNode = lastNode;
                                        var _nextNode2 = nextNode && (nextNode._nextNode() || nextNode.parent.append);
                                        if (_nextNode2 && _nextNode2.parent) {
                                            oldSelection = this.editor.getDomSelection();
                                            oldParent = firstNode.parent;
                                            oldNextNode = oldParent.childs[lastNode.getIndex() + 1] || oldParent.append;
                                            oldIndexRedo = firstNode.getIndex();
                                            newIndexRedo = _nextNode2.getIndex();
                                            oldParentPathRedo = oldParent.getInternalPath();
                                            newParentPathRedo = _nextNode2.parent.getInternalPath();
                                            selectedNodes.forEach(function(node) {
                                                _nextNode2.parent.moveBefore(node, _nextNode2);
                                            });
                                            this.focus(Node1.focusElement || this._getElementName(target));
                                            this.editor._onAction('moveNodes', {
                                                count: selectedNodes.length,
                                                fieldNames: selectedNodes.map(getField),
                                                oldParentPath: oldParent.getInternalPath(),
                                                newParentPath: firstNode.parent.getInternalPath(),
                                                oldParentPathRedo: oldParentPathRedo,
                                                newParentPathRedo: newParentPathRedo,
                                                oldIndexRedo: oldIndexRedo,
                                                newIndexRedo: newIndexRedo,
                                                oldIndex: oldNextNode.getIndex(),
                                                newIndex: firstNode.getIndex(),
                                                oldSelection: oldSelection,
                                                newSelection: this.editor.getDomSelection()
                                            });
                                        }
                                        handled = true;
                                    }
                                }
                                if (handled) {
                                    event.preventDefault();
                                    event.stopPropagation();
                                }
                            }
                        },
                        {
                            key: "_onExpand",
                            value: function _onExpand(recurse) {
                                var table;
                                var frame;
                                var scrollTop;
                                if (recurse) {
                                    // Take the table offline
                                    table = this.dom.tr.parentNode; // TODO: not nice to access the main table like this
                                    frame = table.parentNode;
                                    scrollTop = frame.scrollTop;
                                    frame.removeChild(table);
                                }
                                if (this.expanded) this.collapse(recurse);
                                else this.expand(recurse);
                                if (recurse) {
                                    // Put the table online again
                                    frame.appendChild(table);
                                    frame.scrollTop = scrollTop;
                                }
                                if (typeof this.editor.options.onExpand === 'function') this.editor.options.onExpand({
                                    path: this.getPath(),
                                    isExpand: this.expanded,
                                    recursive: recurse
                                });
                            }
                        },
                        {
                            key: "_showColorPicker",
                            value: function _showColorPicker() {
                                if (typeof this.editor.options.onColorPicker === 'function' && this.dom.color) {
                                    var node = this;
                                    // force deleting current color picker (if any)
                                    node._deleteDomColor();
                                    node.updateDom();
                                    var colorAnchor = (0, createAbsoluteAnchor /* createAbsoluteAnchor */ .p)(this.dom.color, this.editor.getPopupAnchor());
                                    this.editor.options.onColorPicker(colorAnchor, this.value, function onChange(value) {
                                        if (typeof value === 'string' && value !== node.value) {
                                            // force recreating the color block, to cleanup any attached color picker
                                            node._deleteDomColor();
                                            node.value = value;
                                            node.updateDom();
                                            node._debouncedOnChangeValue();
                                        }
                                    });
                                }
                            }
                        },
                        {
                            key: "getFieldNames",
                            value: function getFieldNames(excludeNode) {
                                if (this.type === 'object') return this.childs.filter(function(child) {
                                    return child !== excludeNode;
                                }).map(function(child) {
                                    return child.field;
                                });
                                return [];
                            }
                        },
                        {
                            key: "_onInsertBefore",
                            value: function _onInsertBefore(field, value, type) {
                                var oldSelection = this.editor.getDomSelection();
                                var newNode = new Node1(this.editor, {
                                    field: field !== undefined ? field : '',
                                    value: value !== undefined ? value : '',
                                    type: type
                                });
                                newNode.expand(true);
                                var beforePath = this.getInternalPath();
                                this.parent.insertBefore(newNode, this);
                                this.editor.highlighter.unhighlight();
                                newNode.focus('field');
                                var newSelection = this.editor.getDomSelection();
                                this.editor._onAction('insertBeforeNodes', {
                                    nodes: [
                                        newNode
                                    ],
                                    paths: [
                                        newNode.getInternalPath()
                                    ],
                                    beforePath: beforePath,
                                    parentPath: this.parent.getInternalPath(),
                                    oldSelection: oldSelection,
                                    newSelection: newSelection
                                });
                            }
                        },
                        {
                            key: "_onInsertAfter",
                            value: function _onInsertAfter(field, value, type) {
                                var oldSelection = this.editor.getDomSelection();
                                var newNode = new Node1(this.editor, {
                                    field: field !== undefined ? field : '',
                                    value: value !== undefined ? value : '',
                                    type: type
                                });
                                newNode.expand(true);
                                this.parent.insertAfter(newNode, this);
                                this.editor.highlighter.unhighlight();
                                newNode.focus('field');
                                var newSelection = this.editor.getDomSelection();
                                this.editor._onAction('insertAfterNodes', {
                                    nodes: [
                                        newNode
                                    ],
                                    paths: [
                                        newNode.getInternalPath()
                                    ],
                                    afterPath: this.getInternalPath(),
                                    parentPath: this.parent.getInternalPath(),
                                    oldSelection: oldSelection,
                                    newSelection: newSelection
                                });
                            }
                        },
                        {
                            key: "_onAppend",
                            value: function _onAppend(field, value, type) {
                                var oldSelection = this.editor.getDomSelection();
                                var newNode = new Node1(this.editor, {
                                    field: field !== undefined ? field : '',
                                    value: value !== undefined ? value : '',
                                    type: type
                                });
                                newNode.expand(true);
                                this.parent.appendChild(newNode);
                                this.editor.highlighter.unhighlight();
                                newNode.focus('field');
                                var newSelection = this.editor.getDomSelection();
                                this.editor._onAction('appendNodes', {
                                    nodes: [
                                        newNode
                                    ],
                                    paths: [
                                        newNode.getInternalPath()
                                    ],
                                    parentPath: this.parent.getInternalPath(),
                                    oldSelection: oldSelection,
                                    newSelection: newSelection
                                });
                            }
                        },
                        {
                            key: "_onChangeType",
                            value: function _onChangeType(newType) {
                                var oldType = this.type;
                                if (newType !== oldType) {
                                    var oldSelection = this.editor.getDomSelection();
                                    this.changeType(newType);
                                    var newSelection = this.editor.getDomSelection();
                                    this.editor._onAction('changeType', {
                                        path: this.getInternalPath(),
                                        oldType: oldType,
                                        newType: newType,
                                        oldSelection: oldSelection,
                                        newSelection: newSelection
                                    });
                                }
                            }
                        },
                        {
                            key: "sort",
                            value: function sort(path, direction) {
                                var triggerAction = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
                                if (typeof path === 'string') path = (0, util.parsePath)(path);
                                if (!this._hasChilds()) return;
                                this.hideChilds(); // sorting is faster when the childs are not attached to the dom
                                // copy the childs array (the old one will be kept for an undo action
                                var oldChilds = this.childs;
                                this.childs = this.childs.concat();
                                // sort the childs array
                                var order = direction === 'desc' ? -1 : 1;
                                if (this.type === 'object') this.childs.sort(function(a, b) {
                                    return order * naturalSort_default()(a.field, b.field);
                                });
                                else // this.type === 'array'
                                this.childs.sort(function(a, b) {
                                    var nodeA = a.getNestedChild(path);
                                    var nodeB = b.getNestedChild(path);
                                    if (!nodeA) return order;
                                    if (!nodeB) return -order;
                                    var valueA = nodeA.value;
                                    var valueB = nodeB.value;
                                    if (typeof valueA !== 'string' && typeof valueB !== 'string') // both values are a number, boolean, or null -> use simple, fast sorting
                                    return valueA > valueB ? order : valueA < valueB ? -order : 0;
                                    return order * naturalSort_default()(valueA, valueB);
                                });
                                // update the index numbering
                                this._updateDomIndexes();
                                this.showChilds();
                                if (triggerAction === true) this.editor._onAction('sort', {
                                    path: this.getInternalPath(),
                                    oldChilds: oldChilds,
                                    newChilds: this.childs
                                });
                            }
                        },
                        {
                            key: "update",
                            value: function update(newValue) {
                                var oldValue = this.getInternalValue();
                                this.setValue(newValue);
                                this.editor._onAction('transform', {
                                    path: this.getInternalPath(),
                                    oldValue: oldValue,
                                    newValue: this.getInternalValue()
                                });
                            }
                        },
                        {
                            key: "_detachFromDom",
                            value: function _detachFromDom() {
                                var table = this.dom.tr ? this.dom.tr.parentNode : undefined;
                                var lastTr;
                                if (this.expanded) lastTr = this.getAppendDom();
                                else lastTr = this.getDom();
                                var nextTr = lastTr && lastTr.parentNode ? lastTr.nextSibling : undefined;
                                this.hide({
                                    resetVisibleChilds: false
                                });
                                return {
                                    table: table,
                                    nextTr: nextTr
                                };
                            }
                        },
                        {
                            key: "_attachToDom",
                            value: function _attachToDom(domAnchor) {
                                if (domAnchor.table) {
                                    if (domAnchor.nextTr) domAnchor.table.insertBefore(this.getDom(), domAnchor.nextTr);
                                    else domAnchor.table.appendChild(this.getDom());
                                }
                                if (this.expanded) this.showChilds();
                            }
                        },
                        {
                            key: "transform",
                            value: function transform(query) {
                                if (!this._hasChilds()) return;
                                this.hideChilds(); // sorting is faster when the childs are not attached to the dom
                                try {
                                    var oldInternalValue = this.getInternalValue();
                                    // apply the JMESPath query
                                    var oldValue = this.getValue();
                                    var newValue = this.editor.options.executeQuery(oldValue, query);
                                    this.setValue(newValue);
                                    var newInternalValue = this.getInternalValue();
                                    this.editor._onAction('transform', {
                                        path: this.getInternalPath(),
                                        oldValue: oldInternalValue,
                                        newValue: newInternalValue
                                    });
                                    this.showChilds();
                                } catch (err) {
                                    this.showChilds();
                                    this.editor._onError(err);
                                }
                            }
                        },
                        {
                            key: "extract",
                            value: function extract() {
                                this.editor.node.hideChilds();
                                this.hideChilds();
                                try {
                                    var oldInternalValue = this.editor.node.getInternalValue();
                                    this.editor._setRoot(this);
                                    var newInternalValue = this.editor.node.getInternalValue();
                                    this.editor._onAction('transform', {
                                        path: this.editor.node.getInternalPath(),
                                        oldValue: oldInternalValue,
                                        newValue: newInternalValue
                                    });
                                } catch (err) {
                                    this.editor._onError(err);
                                } finally{
                                    this.updateDom({
                                        recurse: true
                                    });
                                    this.showChilds();
                                }
                            }
                        },
                        {
                            key: "getNestedChild",
                            value: function getNestedChild(path) {
                                var i = 0;
                                var child = this;
                                while(child && i < path.length){
                                    child = child.findChildByProperty(path[i]);
                                    i++;
                                }
                                return child;
                            }
                        },
                        {
                            key: "findChildByProperty",
                            value: function findChildByProperty(prop) {
                                if (this.type !== 'object') return undefined;
                                return this.childs.find(function(child) {
                                    return child.field === prop;
                                });
                            }
                        },
                        {
                            key: "getAppendDom",
                            value: function getAppendDom() {
                                if (!this.append) {
                                    this.append = new AppendNode(this.editor);
                                    this.append.setParent(this);
                                }
                                return this.append.getDom();
                            }
                        },
                        {
                            key: "getShowMoreDom",
                            value: function getShowMoreDom() {
                                if (!this.showMore) this.showMore = new ShowMoreNode(this.editor, this);
                                return this.showMore.getDom();
                            }
                        },
                        {
                            key: "nextSibling",
                            value: function nextSibling() {
                                var index = this.parent.childs.indexOf(this);
                                return this.parent.childs[index + 1] || this.parent.append;
                            }
                        },
                        {
                            key: "_previousNode",
                            value: function _previousNode() {
                                var prevNode = null;
                                var dom = this.getDom();
                                if (dom && dom.parentNode) {
                                    // find the previous field
                                    var prevDom = dom;
                                    do {
                                        prevDom = prevDom.previousSibling;
                                        prevNode = Node1.getNodeFromTarget(prevDom);
                                    }while (prevDom && prevNode && prevNode instanceof AppendNode && !prevNode.isVisible());
                                }
                                return prevNode;
                            }
                        },
                        {
                            key: "_nextNode",
                            value: function _nextNode() {
                                var nextNode = null;
                                var dom = this.getDom();
                                if (dom && dom.parentNode) {
                                    // find the previous field
                                    var nextDom = dom;
                                    do {
                                        nextDom = nextDom.nextSibling;
                                        nextNode = Node1.getNodeFromTarget(nextDom);
                                    }while (nextDom && nextNode && nextNode instanceof AppendNode && !nextNode.isVisible());
                                }
                                return nextNode;
                            }
                        },
                        {
                            key: "_firstNode",
                            value: function _firstNode() {
                                var firstNode = null;
                                var dom = this.getDom();
                                if (dom && dom.parentNode) {
                                    var firstDom = dom.parentNode.firstChild;
                                    firstNode = Node1.getNodeFromTarget(firstDom);
                                }
                                return firstNode;
                            }
                        },
                        {
                            key: "_lastNode",
                            value: function _lastNode() {
                                var lastNode = null;
                                var dom = this.getDom();
                                if (dom && dom.parentNode) {
                                    var lastDom = dom.parentNode.lastChild;
                                    lastNode = Node1.getNodeFromTarget(lastDom);
                                    while(lastDom && lastNode && !lastNode.isVisible()){
                                        lastDom = lastDom.previousSibling;
                                        lastNode = Node1.getNodeFromTarget(lastDom);
                                    }
                                }
                                return lastNode;
                            }
                        },
                        {
                            key: "_previousElement",
                            value: function _previousElement(elem) {
                                var dom = this.dom;
                                // noinspection FallthroughInSwitchStatementJS
                                switch(elem){
                                    case dom.value:
                                        if (this.fieldEditable) return dom.field;
                                    // intentional fall through
                                    case dom.field:
                                        if (this._hasChilds()) return dom.expand;
                                    // intentional fall through
                                    case dom.expand:
                                        return dom.menu;
                                    case dom.menu:
                                        if (dom.drag) return dom.drag;
                                    // intentional fall through
                                    default:
                                        return null;
                                }
                            }
                        },
                        {
                            key: "_nextElement",
                            value: function _nextElement(elem) {
                                var dom = this.dom;
                                // noinspection FallthroughInSwitchStatementJS
                                switch(elem){
                                    case dom.drag:
                                        return dom.menu;
                                    case dom.menu:
                                        if (this._hasChilds()) return dom.expand;
                                    // intentional fall through
                                    case dom.expand:
                                        if (this.fieldEditable) return dom.field;
                                    // intentional fall through
                                    case dom.field:
                                        if (!this._hasChilds()) return dom.value;
                                    // intentional fall through
                                    default:
                                        return null;
                                }
                            }
                        },
                        {
                            key: "_getElementName",
                            value: function _getElementName(element) {
                                var _this2 = this;
                                return Object.keys(this.dom).find(function(name) {
                                    return _this2.dom[name] === element;
                                });
                            }
                        },
                        {
                            key: "_hasChilds",
                            value: function _hasChilds() {
                                return this.type === 'array' || this.type === 'object';
                            }
                        },
                        {
                            key: "addTemplates",
                            value: function addTemplates(menu, append) {
                                var node = this;
                                var templates = node.editor.options.templates;
                                if (templates == null) return;
                                if (templates.length) // create a separator
                                menu.push({
                                    type: 'separator'
                                });
                                var appendData = function appendData(name, data) {
                                    node._onAppend(name, data);
                                };
                                var insertData = function insertData(name, data) {
                                    node._onInsertBefore(name, data);
                                };
                                templates.forEach(function(template) {
                                    menu.push({
                                        text: template.text,
                                        className: template.className || 'jsoneditor-type-object',
                                        title: template.title,
                                        click: append ? appendData.bind(this, template.field, template.value) : insertData.bind(this, template.field, template.value)
                                    });
                                });
                            }
                        },
                        {
                            key: "showContextMenu",
                            value: function showContextMenu(anchor, onClose) {
                                var node = this;
                                var items = [];
                                if (this.editable.value) items.push({
                                    text: (0, i18n /* translate */ .Tl)('type'),
                                    title: (0, i18n /* translate */ .Tl)('typeTitle'),
                                    className: 'jsoneditor-type-' + this.type,
                                    submenu: [
                                        {
                                            text: (0, i18n /* translate */ .Tl)('auto'),
                                            className: 'jsoneditor-type-auto' + (this.type === 'auto' ? ' jsoneditor-selected' : ''),
                                            title: (0, i18n /* translate */ .Tl)('autoType'),
                                            click: function click() {
                                                node._onChangeType('auto');
                                            }
                                        },
                                        {
                                            text: (0, i18n /* translate */ .Tl)('array'),
                                            className: 'jsoneditor-type-array' + (this.type === 'array' ? ' jsoneditor-selected' : ''),
                                            title: (0, i18n /* translate */ .Tl)('arrayType'),
                                            click: function click() {
                                                node._onChangeType('array');
                                            }
                                        },
                                        {
                                            text: (0, i18n /* translate */ .Tl)('object'),
                                            className: 'jsoneditor-type-object' + (this.type === 'object' ? ' jsoneditor-selected' : ''),
                                            title: (0, i18n /* translate */ .Tl)('objectType'),
                                            click: function click() {
                                                node._onChangeType('object');
                                            }
                                        },
                                        {
                                            text: (0, i18n /* translate */ .Tl)('string'),
                                            className: 'jsoneditor-type-string' + (this.type === 'string' ? ' jsoneditor-selected' : ''),
                                            title: (0, i18n /* translate */ .Tl)('stringType'),
                                            click: function click() {
                                                node._onChangeType('string');
                                            }
                                        }
                                    ]
                                });
                                if (this._hasChilds()) {
                                    if (this.editor.options.enableSort) items.push({
                                        text: (0, i18n /* translate */ .Tl)('sort'),
                                        title: (0, i18n /* translate */ .Tl)('sortTitle', {
                                            type: this.type
                                        }),
                                        className: 'jsoneditor-sort-asc',
                                        click: function click() {
                                            node.showSortModal();
                                        }
                                    });
                                    if (this.editor.options.enableTransform) items.push({
                                        text: (0, i18n /* translate */ .Tl)('transform'),
                                        title: (0, i18n /* translate */ .Tl)('transformTitle', {
                                            type: this.type
                                        }),
                                        className: 'jsoneditor-transform',
                                        click: function click() {
                                            node.showTransformModal();
                                        }
                                    });
                                    if (this.parent) items.push({
                                        text: (0, i18n /* translate */ .Tl)('extract'),
                                        title: (0, i18n /* translate */ .Tl)('extractTitle', {
                                            type: this.type
                                        }),
                                        className: 'jsoneditor-extract',
                                        click: function click() {
                                            node.extract();
                                        }
                                    });
                                }
                                if (this.parent && this.parent._hasChilds()) {
                                    if (items.length) // create a separator
                                    items.push({
                                        type: 'separator'
                                    });
                                    // create append button (for last child node only)
                                    var childs = node.parent.childs;
                                    if (node === childs[childs.length - 1]) {
                                        var appendSubmenu = [
                                            {
                                                text: (0, i18n /* translate */ .Tl)('auto'),
                                                className: 'jsoneditor-type-auto',
                                                title: (0, i18n /* translate */ .Tl)('autoType'),
                                                click: function click() {
                                                    node._onAppend('', '', 'auto');
                                                }
                                            },
                                            {
                                                text: (0, i18n /* translate */ .Tl)('array'),
                                                className: 'jsoneditor-type-array',
                                                title: (0, i18n /* translate */ .Tl)('arrayType'),
                                                click: function click() {
                                                    node._onAppend('', []);
                                                }
                                            },
                                            {
                                                text: (0, i18n /* translate */ .Tl)('object'),
                                                className: 'jsoneditor-type-object',
                                                title: (0, i18n /* translate */ .Tl)('objectType'),
                                                click: function click() {
                                                    node._onAppend('', {});
                                                }
                                            },
                                            {
                                                text: (0, i18n /* translate */ .Tl)('string'),
                                                className: 'jsoneditor-type-string',
                                                title: (0, i18n /* translate */ .Tl)('stringType'),
                                                click: function click() {
                                                    node._onAppend('', '', 'string');
                                                }
                                            }
                                        ];
                                        node.addTemplates(appendSubmenu, true);
                                        items.push({
                                            text: (0, i18n /* translate */ .Tl)('appendText'),
                                            title: (0, i18n /* translate */ .Tl)('appendTitle'),
                                            submenuTitle: (0, i18n /* translate */ .Tl)('appendSubmenuTitle'),
                                            className: 'jsoneditor-append',
                                            click: function click() {
                                                node._onAppend('', '', 'auto');
                                            },
                                            submenu: appendSubmenu
                                        });
                                    }
                                    // create insert button
                                    var insertSubmenu = [
                                        {
                                            text: (0, i18n /* translate */ .Tl)('auto'),
                                            className: 'jsoneditor-type-auto',
                                            title: (0, i18n /* translate */ .Tl)('autoType'),
                                            click: function click() {
                                                node._onInsertBefore('', '', 'auto');
                                            }
                                        },
                                        {
                                            text: (0, i18n /* translate */ .Tl)('array'),
                                            className: 'jsoneditor-type-array',
                                            title: (0, i18n /* translate */ .Tl)('arrayType'),
                                            click: function click() {
                                                node._onInsertBefore('', []);
                                            }
                                        },
                                        {
                                            text: (0, i18n /* translate */ .Tl)('object'),
                                            className: 'jsoneditor-type-object',
                                            title: (0, i18n /* translate */ .Tl)('objectType'),
                                            click: function click() {
                                                node._onInsertBefore('', {});
                                            }
                                        },
                                        {
                                            text: (0, i18n /* translate */ .Tl)('string'),
                                            className: 'jsoneditor-type-string',
                                            title: (0, i18n /* translate */ .Tl)('stringType'),
                                            click: function click() {
                                                node._onInsertBefore('', '', 'string');
                                            }
                                        }
                                    ];
                                    node.addTemplates(insertSubmenu, false);
                                    items.push({
                                        text: (0, i18n /* translate */ .Tl)('insert'),
                                        title: (0, i18n /* translate */ .Tl)('insertTitle'),
                                        submenuTitle: (0, i18n /* translate */ .Tl)('insertSub'),
                                        className: 'jsoneditor-insert',
                                        click: function click() {
                                            node._onInsertBefore('', '', 'auto');
                                        },
                                        submenu: insertSubmenu
                                    });
                                    if (this.editable.field) {
                                        // create duplicate button
                                        items.push({
                                            text: (0, i18n /* translate */ .Tl)('duplicateText'),
                                            title: (0, i18n /* translate */ .Tl)('duplicateField'),
                                            className: 'jsoneditor-duplicate',
                                            click: function click() {
                                                Node1.onDuplicate(node);
                                            }
                                        });
                                        // create remove button
                                        items.push({
                                            text: (0, i18n /* translate */ .Tl)('removeText'),
                                            title: (0, i18n /* translate */ .Tl)('removeField'),
                                            className: 'jsoneditor-remove',
                                            click: function click() {
                                                Node1.onRemove(node);
                                            }
                                        });
                                    }
                                }
                                if (this.editor.options.onCreateMenu) {
                                    var path = node.getPath();
                                    items = this.editor.options.onCreateMenu(items, {
                                        type: 'single',
                                        path: path,
                                        paths: [
                                            path
                                        ]
                                    });
                                }
                                var menu = new ContextMenu /* ContextMenu */ .t(items, {
                                    close: onClose
                                });
                                menu.show(anchor, this.editor.getPopupAnchor());
                            }
                        },
                        {
                            key: "showSortModal",
                            value: function showSortModal() {
                                var node = this;
                                var container = this.editor.options.modalAnchor || constants /* DEFAULT_MODAL_ANCHOR */ .ai;
                                var json = this.getValue();
                                function onSort(sortedBy) {
                                    var path = sortedBy.path;
                                    var pathArray = (0, util.parsePath)(path);
                                    node.sortedBy = sortedBy;
                                    node.sort(pathArray, sortedBy.direction);
                                }
                                (0, js_showSortModal.showSortModal)(container, json, onSort, node.sortedBy);
                            }
                        },
                        {
                            key: "showTransformModal",
                            value: function showTransformModal() {
                                var _this3 = this;
                                var _this$editor$options = this.editor.options, modalAnchor = _this$editor$options.modalAnchor, createQuery = _this$editor$options.createQuery, executeQuery = _this$editor$options.executeQuery, queryDescription = _this$editor$options.queryDescription;
                                var json = this.getValue();
                                (0, js_showTransformModal.showTransformModal)({
                                    container: modalAnchor || constants /* DEFAULT_MODAL_ANCHOR */ .ai,
                                    json: json,
                                    queryDescription: queryDescription,
                                    // can be undefined
                                    createQuery: createQuery,
                                    executeQuery: executeQuery,
                                    onTransform: function onTransform(query) {
                                        _this3.transform(query);
                                    }
                                });
                            }
                        },
                        {
                            key: "_getType",
                            value: function _getType(value) {
                                if (value instanceof Array) return 'array';
                                if (value instanceof Object) return 'object';
                                if (typeof value === 'string' && typeof (0, util.parseString)(value) !== 'string') return 'string';
                                return 'auto';
                            }
                        },
                        {
                            key: "_escapeHTML",
                            value: function _escapeHTML(text) {
                                if (typeof text !== 'string') return String(text);
                                else {
                                    var htmlEscaped = String(text).replace(/&/g, '&amp;') // must be replaced first!
                                    .replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/ {2}/g, ' &nbsp;') // replace double space with an nbsp and space
                                    .replace(/^ /, '&nbsp;') // space at start
                                    .replace(/ $/, '&nbsp;'); // space at end
                                    var json = JSON.stringify(htmlEscaped);
                                    var html = json.substring(1, json.length - 1);
                                    if (this.editor.options.escapeUnicode === true) html = (0, util.escapeUnicodeChars)(html);
                                    return html;
                                }
                            }
                        },
                        {
                            key: "_unescapeHTML",
                            value: function _unescapeHTML(escapedText) {
                                var json = '"' + this._escapeJSON(escapedText) + '"';
                                var htmlEscaped = (0, util.parse)(json);
                                return htmlEscaped.replace(/&lt;/g, '<').replace(/&gt;/g, '>').replace(/&nbsp;|\u00A0/g, ' ').replace(/&amp;/g, '&'); // must be replaced last
                            }
                        },
                        {
                            key: "_escapeJSON",
                            value: function _escapeJSON(text) {
                                // TODO: replace with some smart regex (only when a new solution is faster!)
                                var escaped = '';
                                var i = 0;
                                while(i < text.length){
                                    var c = text.charAt(i);
                                    if (c === '\n') escaped += '\\n';
                                    else if (c === '\\') {
                                        escaped += c;
                                        i++;
                                        c = text.charAt(i);
                                        if (c === '' || '"\\/bfnrtu'.indexOf(c) === -1) escaped += '\\'; // no valid escape character
                                        escaped += c;
                                    } else if (c === '"') escaped += '\\"';
                                    else escaped += c;
                                    i++;
                                }
                                return escaped;
                            }
                        },
                        {
                            key: "updateNodeName",
                            value: function updateNodeName() {
                                var count = this.childs ? this.childs.length : 0;
                                var nodeName;
                                if (this.type === 'object' || this.type === 'array') {
                                    if (this.editor.options.onNodeName) try {
                                        var getValue = this.getValue.bind(this);
                                        nodeName = this.editor.options.onNodeName({
                                            path: this.getPath(),
                                            size: count,
                                            type: this.type,
                                            get value () {
                                                return getValue();
                                            }
                                        });
                                    } catch (err) {
                                        console.error('Error in onNodeName callback: ', err);
                                    }
                                    this.dom.value.textContent = this.type === 'object' ? '{' + (nodeName || count) + '}' : '[' + (nodeName || count) + ']';
                                }
                            }
                        },
                        {
                            key: "recursivelyUpdateNodeName",
                            value: function recursivelyUpdateNodeName() {
                                if (this.expanded) {
                                    this.updateNodeName();
                                    if (this.childs !== 'undefined') {
                                        var i;
                                        for(i in this.childs)this.childs[i].recursivelyUpdateNodeName();
                                    }
                                }
                            }
                        }
                    ]);
                }();
                // debounce interval for keyboard input in milliseconds
                Node1.prototype.DEBOUNCE_INTERVAL = 150;
                // search will stop iterating as soon as the max is reached
                Node1.prototype.MAX_SEARCH_RESULTS = 999;
                // default number of child nodes to display
                var DEFAULT_MAX_VISIBLE_CHILDS = 100;
                // stores the element name currently having the focus
                Node1.focusElement = undefined;
                /**
 * Select all text in an editable div after a delay of 0 ms
 * @param {Element} editableDiv
 */ Node1.select = function(editableDiv) {
                    setTimeout(function() {
                        (0, util.selectContentEditable)(editableDiv);
                    }, 0);
                };
                /**
 * DragStart event, fired on mousedown on the dragarea at the left side of a Node
 * @param {Node[] | Node} nodes
 * @param {Event} event
 */ Node1.onDragStart = function(nodes, event) {
                    if (!Array.isArray(nodes)) return Node1.onDragStart([
                        nodes
                    ], event);
                    if (nodes.length === 0) return;
                    var firstNode = nodes[0];
                    var lastNode = nodes[nodes.length - 1];
                    var parent = firstNode.parent;
                    var draggedNode = Node1.getNodeFromTarget(event.target);
                    var editor = firstNode.editor;
                    // in case of multiple selected nodes, offsetY prevents the selection from
                    // jumping when you start dragging one of the lower down nodes in the selection
                    var offsetY = (0, util.getAbsoluteTop)(draggedNode.dom.tr) - (0, util.getAbsoluteTop)(firstNode.dom.tr);
                    if (!editor.mousemove) editor.mousemove = (0, util.addEventListener)(event.view, 'mousemove', function(event) {
                        Node1.onDrag(nodes, event);
                    });
                    if (!editor.mouseup) editor.mouseup = (0, util.addEventListener)(event.view, 'mouseup', function(event) {
                        Node1.onDragEnd(nodes, event);
                    });
                    editor.highlighter.lock();
                    editor.drag = {
                        oldCursor: document.body.style.cursor,
                        oldSelection: editor.getDomSelection(),
                        oldPaths: nodes.map(getInternalPath),
                        oldParent: parent,
                        oldNextNode: parent.childs[lastNode.getIndex() + 1] || parent.append,
                        oldParentPathRedo: parent.getInternalPath(),
                        oldIndexRedo: firstNode.getIndex(),
                        mouseX: event.pageX,
                        offsetY: offsetY,
                        level: firstNode.getLevel()
                    };
                    document.body.style.cursor = 'move';
                    event.preventDefault();
                };
                /**
 * Drag event, fired when moving the mouse while dragging a Node
 * @param {Node[] | Node} nodes
 * @param {Event} event
 */ Node1.onDrag = function(nodes, event) {
                    if (!Array.isArray(nodes)) return Node1.onDrag([
                        nodes
                    ], event);
                    if (nodes.length === 0) return;
                    // TODO: this method has grown too large. Split it in a number of methods
                    var editor = nodes[0].editor;
                    var mouseY = event.pageY - editor.drag.offsetY;
                    var mouseX = event.pageX;
                    var trPrev, trNext, trFirst, trLast, trRoot;
                    var nodePrev, nodeNext;
                    var topPrev, topFirst, bottomNext, heightNext;
                    var moved = false;
                    // TODO: add an ESC option, which resets to the original position
                    // move up/down
                    var firstNode = nodes[0];
                    var trThis = firstNode.dom.tr;
                    var topThis = (0, util.getAbsoluteTop)(trThis);
                    var heightThis = trThis.offsetHeight;
                    if (mouseY < topThis) {
                        // move up
                        trPrev = trThis;
                        do {
                            trPrev = trPrev.previousSibling;
                            nodePrev = Node1.getNodeFromTarget(trPrev);
                            topPrev = trPrev ? (0, util.getAbsoluteTop)(trPrev) : 0;
                        }while (trPrev && mouseY < topPrev);
                        if (nodePrev && !nodePrev.parent) nodePrev = undefined;
                        if (!nodePrev) {
                            // move to the first node
                            trRoot = trThis.parentNode.firstChild;
                            trPrev = trRoot ? trRoot.nextSibling : undefined;
                            nodePrev = Node1.getNodeFromTarget(trPrev);
                            if (nodePrev === firstNode) nodePrev = undefined;
                        }
                        if (nodePrev && nodePrev.isVisible()) {
                            // check if mouseY is really inside the found node
                            trPrev = nodePrev.dom.tr;
                            topPrev = trPrev ? (0, util.getAbsoluteTop)(trPrev) : 0;
                            if (mouseY > topPrev + heightThis) nodePrev = undefined;
                        }
                        if (nodePrev && (editor.options.limitDragging === false || nodePrev.parent === nodes[0].parent)) {
                            nodes.forEach(function(node) {
                                nodePrev.parent.moveBefore(node, nodePrev);
                            });
                            moved = true;
                        }
                    } else {
                        // move down
                        var lastNode = nodes[nodes.length - 1];
                        trLast = lastNode.expanded && lastNode.append ? lastNode.append.getDom() : lastNode.dom.tr;
                        trFirst = trLast ? trLast.nextSibling : undefined;
                        if (trFirst) {
                            topFirst = (0, util.getAbsoluteTop)(trFirst);
                            trNext = trFirst;
                            do {
                                nodeNext = Node1.getNodeFromTarget(trNext);
                                if (trNext) {
                                    bottomNext = trNext.nextSibling ? (0, util.getAbsoluteTop)(trNext.nextSibling) : 0;
                                    heightNext = trNext ? bottomNext - topFirst : 0;
                                    if (nodeNext && nodeNext.parent.childs.length === nodes.length && nodeNext.parent.childs[nodes.length - 1] === lastNode) // We are about to remove the last child of this parent,
                                    // which will make the parents appendNode visible.
                                    topThis += 27;
                                    trNext = trNext.nextSibling;
                                }
                            }while (trNext && mouseY > topThis + heightNext);
                            if (nodeNext && nodeNext.parent) {
                                // calculate the desired level
                                var diffX = mouseX - editor.drag.mouseX;
                                var diffLevel = Math.round(diffX / 24 / 2);
                                var level = editor.drag.level + diffLevel; // desired level
                                var levelNext = nodeNext.getLevel(); // level to be
                                // find the best fitting level (move upwards over the append nodes)
                                trPrev = nodeNext.dom.tr && nodeNext.dom.tr.previousSibling;
                                while(levelNext < level && trPrev){
                                    nodePrev = Node1.getNodeFromTarget(trPrev);
                                    var isDraggedNode = nodes.some(function(node) {
                                        return node === nodePrev || nodePrev.isDescendantOf(node);
                                    });
                                    if (isDraggedNode) ;
                                    else if (nodePrev instanceof AppendNode) {
                                        var childs = nodePrev.parent.childs;
                                        if (childs.length !== nodes.length || childs[nodes.length - 1] !== lastNode) {
                                            // non-visible append node of a list of childs
                                            // consisting of not only this node (else the
                                            // append node will change into a visible "empty"
                                            // text when removing this node).
                                            nodeNext = Node1.getNodeFromTarget(trPrev);
                                            levelNext = nodeNext.getLevel();
                                        } else break;
                                    } else break;
                                    trPrev = trPrev.previousSibling;
                                }
                                if (nodeNext instanceof AppendNode && !nodeNext.isVisible() && nodeNext.parent.showMore.isVisible()) nodeNext = nodeNext._nextNode();
                                // move the node when its position is changed
                                if (nodeNext && (editor.options.limitDragging === false || nodeNext.parent === nodes[0].parent) && nodeNext.dom.tr && nodeNext.dom.tr !== trLast.nextSibling) {
                                    nodes.forEach(function(node) {
                                        nodeNext.parent.moveBefore(node, nodeNext);
                                    });
                                    moved = true;
                                }
                            }
                        }
                    }
                    if (moved) {
                        // update the dragging parameters when moved
                        editor.drag.mouseX = mouseX;
                        editor.drag.level = firstNode.getLevel();
                    }
                    // auto scroll when hovering around the top of the editor
                    editor.startAutoScroll(mouseY);
                    event.preventDefault();
                };
                /**
 * Drag event, fired on mouseup after having dragged a node
 * @param {Node[] | Node} nodes
 * @param {Event} event
 */ Node1.onDragEnd = function(nodes, event) {
                    if (!Array.isArray(nodes)) return Node1.onDrag([
                        nodes
                    ], event);
                    if (nodes.length === 0) return;
                    var firstNode = nodes[0];
                    var editor = firstNode.editor;
                    // set focus to the context menu button of the first node
                    if (firstNode && firstNode.dom.menu) firstNode.dom.menu.focus();
                    var oldParentPath = editor.drag.oldParent.getInternalPath();
                    var newParentPath = firstNode.parent.getInternalPath();
                    var sameParent = editor.drag.oldParent === firstNode.parent;
                    var oldIndex = editor.drag.oldNextNode.getIndex();
                    var newIndex = firstNode.getIndex();
                    var oldParentPathRedo = editor.drag.oldParentPathRedo;
                    var oldIndexRedo = editor.drag.oldIndexRedo;
                    var newIndexRedo = sameParent && oldIndexRedo < newIndex ? newIndex + nodes.length : newIndex;
                    if (!sameParent || oldIndexRedo !== newIndex) // only register this action if the node is actually moved to another place
                    editor._onAction('moveNodes', {
                        count: nodes.length,
                        fieldNames: nodes.map(getField),
                        oldParentPath: oldParentPath,
                        newParentPath: newParentPath,
                        oldIndex: oldIndex,
                        newIndex: newIndex,
                        oldIndexRedo: oldIndexRedo,
                        newIndexRedo: newIndexRedo,
                        oldParentPathRedo: oldParentPathRedo,
                        newParentPathRedo: null,
                        // This is a hack, value will be filled in during undo
                        oldSelection: editor.drag.oldSelection,
                        newSelection: editor.getDomSelection()
                    });
                    document.body.style.cursor = editor.drag.oldCursor;
                    editor.highlighter.unlock();
                    nodes.forEach(function(node) {
                        node.updateDom();
                        if (event.target !== node.dom.drag && event.target !== node.dom.menu) editor.highlighter.unhighlight();
                    });
                    delete editor.drag;
                    if (editor.mousemove) {
                        (0, util.removeEventListener)(event.view, 'mousemove', editor.mousemove);
                        delete editor.mousemove;
                    }
                    if (editor.mouseup) {
                        (0, util.removeEventListener)(event.view, 'mouseup', editor.mouseup);
                        delete editor.mouseup;
                    }
                    // Stop any running auto scroll
                    editor.stopAutoScroll();
                    event.preventDefault();
                };
                /**
 * find an enum definition in a JSON schema, as property `enum` or inside
 * one of the schemas composites (`oneOf`, `anyOf`, `allOf`)
 * @param  {Object} schema
 * @return {Array | null} Returns the enum when found, null otherwise.
 * @private
 */ Node1._findEnum = function(schema) {
                    if (schema["enum"]) return schema["enum"];
                    var composite = schema.oneOf || schema.anyOf || schema.allOf;
                    if (composite) {
                        var match = composite.filter(function(entry) {
                            return entry["enum"];
                        });
                        if (match.length > 0) return match[0]["enum"];
                    }
                    return null;
                };
                /**
 * Implementation for _findSchema
 * @param {Object} topLevelSchema
 * @param {Object} schemaRefs
 * @param {Array.<string | number>} path
 * @param {Object} currentSchema
 * @return {Object | boolean | null}
 * @private
 */ Node1._findOneSchema = function(topLevelSchema, schemaRefs, path, currentSchema) {
                    var nextPath = path.slice(1, path.length);
                    var nextKey = path[0];
                    if (Node_typeof(currentSchema) === 'object' && '$ref' in currentSchema && typeof currentSchema.$ref === 'string') {
                        var _ref$match;
                        var ref = currentSchema.$ref;
                        if (ref in schemaRefs) currentSchema = schemaRefs[ref];
                        else if (ref.startsWith('#/')) {
                            var refPath = ref.substring(2).split('/');
                            currentSchema = topLevelSchema;
                            var _iterator = _createForOfIteratorHelper(refPath), _step;
                            try {
                                for(_iterator.s(); !(_step = _iterator.n()).done;){
                                    var segment = _step.value;
                                    if (segment in currentSchema) currentSchema = currentSchema[segment];
                                    else throw Error("Unable to resolve reference ".concat(ref));
                                }
                            } catch (err) {
                                _iterator.e(err);
                            } finally{
                                _iterator.f();
                            }
                        } else if (((_ref$match = ref.match(/#\//g)) === null || _ref$match === void 0 ? void 0 : _ref$match.length) === 1) {
                            var _ref$split = ref.split('#/'), _ref$split2 = _slicedToArray(_ref$split, 2), schemaUrl = _ref$split2[0], relativePath = _ref$split2[1];
                            if (schemaUrl in schemaRefs) {
                                var referencedSchema = schemaRefs[schemaUrl];
                                var reference = {
                                    $ref: '#/'.concat(relativePath)
                                };
                                var auxNextPath = [];
                                auxNextPath.push(nextKey);
                                if (nextPath.length > 0) auxNextPath.push.apply(auxNextPath, _toConsumableArray(nextPath));
                                return Node1._findSchema(referencedSchema, schemaRefs, auxNextPath, reference);
                            } else throw Error("Unable to resolve reference ".concat(ref));
                        } else throw Error("Unable to resolve reference ".concat(ref));
                    }
                    // We have no more path segments to resolve, return the currently found schema
                    // We do this here, after resolving references, in case of the leaf schema beeing a reference
                    if (nextKey === undefined) return currentSchema;
                    if (typeof nextKey === 'string') {
                        if (Node_typeof(currentSchema.properties) === 'object' && currentSchema.properties !== null && nextKey in currentSchema.properties) {
                            currentSchema = currentSchema.properties[nextKey];
                            return Node1._findSchema(topLevelSchema, schemaRefs, nextPath, currentSchema);
                        }
                        if (Node_typeof(currentSchema.patternProperties) === 'object' && currentSchema.patternProperties !== null) {
                            for(var prop in currentSchema.patternProperties)if (nextKey.match(prop)) {
                                currentSchema = currentSchema.patternProperties[prop];
                                return Node1._findSchema(topLevelSchema, schemaRefs, nextPath, currentSchema);
                            }
                        }
                        if (Node_typeof(currentSchema.additionalProperties) === 'object') {
                            currentSchema = currentSchema.additionalProperties;
                            return Node1._findSchema(topLevelSchema, schemaRefs, nextPath, currentSchema);
                        }
                        return null;
                    }
                    if (typeof nextKey === 'number' && Node_typeof(currentSchema.items) === 'object' && currentSchema.items !== null) {
                        currentSchema = currentSchema.items;
                        return Node1._findSchema(topLevelSchema, schemaRefs, nextPath, currentSchema);
                    }
                    return null;
                };
                /**
 * Return the part of a JSON schema matching given path.
 *
 * Note that this attempts to find *a* schema matching the path, not necessarily
 * the best / most appropriate.  For example, oneOf vs. anyOf vs. allOf may
 * result in different schemas being applied in practice.
 *
 * @param {Object} topLevelSchema
 * @param {Object} schemaRefs
 * @param {Array.<string | number>} path
 * @param {Object} currentSchema
 * @return {Object | null}
 * @private
 */ Node1._findSchema = function(topLevelSchema, schemaRefs, path) {
                    var currentSchema = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : topLevelSchema;
                    var possibleSchemas = [
                        currentSchema
                    ];
                    for(var _i = 0, _arr = [
                        currentSchema.oneOf,
                        currentSchema.anyOf,
                        currentSchema.allOf
                    ]; _i < _arr.length; _i++){
                        var subSchemas = _arr[_i];
                        if (Array.isArray(subSchemas)) possibleSchemas = possibleSchemas.concat(subSchemas);
                    }
                    var fallback = null;
                    var _iterator2 = _createForOfIteratorHelper(possibleSchemas), _step2;
                    try {
                        for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                            var schema = _step2.value;
                            var result = Node1._findOneSchema(topLevelSchema, schemaRefs, path, schema);
                            // Although we don't attempt to find the best / most appropriate schema, we
                            // can at least attempt to find something more specific than `true`.
                            if (result === true) {
                                fallback = true;
                                continue;
                            } else if (result !== null) return result;
                        }
                    } catch (err) {
                        _iterator2.e(err);
                    } finally{
                        _iterator2.f();
                    }
                    return fallback;
                };
                /**
 * Remove nodes
 * @param {Node[] | Node} nodes
 */ Node1.onRemove = function(nodes) {
                    if (!Array.isArray(nodes)) return Node1.onRemove([
                        nodes
                    ]);
                    if (nodes && nodes.length > 0) {
                        var firstNode = nodes[0];
                        var parent = firstNode.parent;
                        var editor = firstNode.editor;
                        var firstIndex = firstNode.getIndex();
                        editor.highlighter.unhighlight();
                        // adjust the focus
                        var oldSelection = editor.getDomSelection();
                        Node1.blurNodes(nodes);
                        var newSelection = editor.getDomSelection();
                        // store the paths before removing them (needed for history)
                        var paths = nodes.map(getInternalPath);
                        // remove the nodes
                        nodes.forEach(function(node) {
                            node.parent._remove(node);
                        });
                        // store history action
                        editor._onAction('removeNodes', {
                            nodes: nodes,
                            paths: paths,
                            parentPath: parent.getInternalPath(),
                            index: firstIndex,
                            oldSelection: oldSelection,
                            newSelection: newSelection
                        });
                    }
                };
                /**
 * Duplicate nodes
 * duplicated nodes will be added right after the original nodes
 * @param {Node[] | Node} nodes
 */ Node1.onDuplicate = function(nodes) {
                    if (!Array.isArray(nodes)) return Node1.onDuplicate([
                        nodes
                    ]);
                    if (nodes && nodes.length > 0) {
                        var lastNode = nodes[nodes.length - 1];
                        var parent = lastNode.parent;
                        var editor = lastNode.editor;
                        editor.deselect(editor.multiselection.nodes);
                        // duplicate the nodes
                        var oldSelection = editor.getDomSelection();
                        var afterNode = lastNode;
                        var clones = nodes.map(function(node) {
                            var clone = node.clone();
                            if (node.parent.type === 'object') {
                                var existingFieldNames = node.parent.getFieldNames();
                                clone.field = (0, util.findUniqueName)(node.field, existingFieldNames);
                            }
                            parent.insertAfter(clone, afterNode);
                            afterNode = clone;
                            return clone;
                        });
                        // set selection to the duplicated nodes
                        if (nodes.length === 1) {
                            if (clones[0].parent.type === 'object') {
                                // when duplicating a single object property,
                                // set focus to the field and keep the original field name
                                clones[0].dom.field.innerHTML = nodes[0]._escapeHTML(nodes[0].field);
                                clones[0].focus('field');
                            } else clones[0].focus();
                        } else editor.select(clones);
                        var newSelection = editor.getDomSelection();
                        editor._onAction('duplicateNodes', {
                            paths: nodes.map(getInternalPath),
                            clonePaths: clones.map(getInternalPath),
                            afterPath: lastNode.getInternalPath(),
                            parentPath: parent.getInternalPath(),
                            oldSelection: oldSelection,
                            newSelection: newSelection
                        });
                    }
                };
                /**
 * Find the node from an event target
 * @param {HTMLElement} target
 * @return {Node | undefined} node  or undefined when not found
 * @static
 */ Node1.getNodeFromTarget = function(target) {
                    while(target){
                        if (target.node) return target.node;
                        target = target.parentNode;
                    }
                    return undefined;
                };
                /**
 * Test whether target is a child of the color DOM of a node
 * @param {HTMLElement} target
 * @returns {boolean}
 */ Node1.targetIsColorPicker = function(target) {
                    var node = Node1.getNodeFromTarget(target);
                    if (node) {
                        var parent = target && target.parentNode;
                        while(parent){
                            if (parent === node.dom.color) return true;
                            parent = parent.parentNode;
                        }
                    }
                    return false;
                };
                /**
 * Remove the focus of given nodes, and move the focus to the (a) node before,
 * (b) the node after, or (c) the parent node.
 * @param {Array.<Node> | Node} nodes
 */ Node1.blurNodes = function(nodes) {
                    if (!Array.isArray(nodes)) {
                        Node1.blurNodes([
                            nodes
                        ]);
                        return;
                    }
                    var firstNode = nodes[0];
                    var parent = firstNode.parent;
                    var firstIndex = firstNode.getIndex();
                    if (parent.childs[firstIndex + nodes.length]) parent.childs[firstIndex + nodes.length].focus();
                    else if (parent.childs[firstIndex - 1]) parent.childs[firstIndex - 1].focus();
                    else parent.focus();
                };
                // helper function to get the internal path of a node
                function getInternalPath(node) {
                    return node.getInternalPath();
                }
                // helper function to get the field of a node
                function getField(node) {
                    return node.getField();
                }
                function Node_hasOwnProperty(object, key) {
                    return Object.prototype.hasOwnProperty.call(object, key);
                }
                // TODO: find a nicer solution to resolve this circular dependency between Node and AppendNode
                //       idea: introduce properties .isAppendNode and .isNode and use that instead of instanceof AppendNode checks
                var AppendNode = appendNodeFactory(Node1);
                var ShowMoreNode = showMoreNodeFactory(Node1);
                function NodeHistory_typeof(o) {
                    "@babel/helpers - typeof";
                    return NodeHistory_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
                        return typeof o;
                    } : function(o) {
                        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
                    }, NodeHistory_typeof(o);
                }
                function NodeHistory_classCallCheck(a, n) {
                    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
                }
                function NodeHistory_defineProperties(e, r) {
                    for(var t = 0; t < r.length; t++){
                        var o = r[t];
                        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, NodeHistory_toPropertyKey(o.key), o);
                    }
                }
                function NodeHistory_createClass(e, r, t) {
                    return r && NodeHistory_defineProperties(e.prototype, r), t && NodeHistory_defineProperties(e, t), Object.defineProperty(e, "prototype", {
                        writable: !1
                    }), e;
                }
                function NodeHistory_toPropertyKey(t) {
                    var i = NodeHistory_toPrimitive(t, "string");
                    return "symbol" == NodeHistory_typeof(i) ? i : i + "";
                }
                function NodeHistory_toPrimitive(t, r) {
                    if ("object" != NodeHistory_typeof(t) || !t) return t;
                    var e = t[Symbol.toPrimitive];
                    if (void 0 !== e) {
                        var i = e.call(t, r || "default");
                        if ("object" != NodeHistory_typeof(i)) return i;
                        throw new TypeError("@@toPrimitive must return a primitive value.");
                    }
                    return ("string" === r ? String : Number)(t);
                }
                /**
 * @constructor History
 * Store action history, enables undo and redo
 * @param {JSONEditor} editor
 */ var NodeHistory = /*#__PURE__*/ function() {
                    function NodeHistory(editor) {
                        NodeHistory_classCallCheck(this, NodeHistory);
                        this.editor = editor;
                        this.history = [];
                        this.index = -1;
                        this.clear();
                        // helper function to find a Node from a path
                        function findNode(path) {
                            return editor.node.findNodeByInternalPath(path);
                        }
                        // map with all supported actions
                        this.actions = {
                            editField: {
                                undo: function undo(params) {
                                    var parentNode = findNode(params.parentPath);
                                    var node = parentNode.childs[params.index];
                                    node.updateField(params.oldValue);
                                },
                                redo: function redo(params) {
                                    var parentNode = findNode(params.parentPath);
                                    var node = parentNode.childs[params.index];
                                    node.updateField(params.newValue);
                                }
                            },
                            editValue: {
                                undo: function undo(params) {
                                    findNode(params.path).updateValue(params.oldValue);
                                },
                                redo: function redo(params) {
                                    findNode(params.path).updateValue(params.newValue);
                                }
                            },
                            changeType: {
                                undo: function undo(params) {
                                    findNode(params.path).changeType(params.oldType);
                                },
                                redo: function redo(params) {
                                    findNode(params.path).changeType(params.newType);
                                }
                            },
                            appendNodes: {
                                undo: function undo(params) {
                                    var parentNode = findNode(params.parentPath);
                                    params.paths.map(findNode).forEach(function(node) {
                                        parentNode.removeChild(node);
                                    });
                                },
                                redo: function redo(params) {
                                    var parentNode = findNode(params.parentPath);
                                    params.nodes.forEach(function(node) {
                                        parentNode.appendChild(node);
                                    });
                                }
                            },
                            insertBeforeNodes: {
                                undo: function undo(params) {
                                    var parentNode = findNode(params.parentPath);
                                    params.paths.map(findNode).forEach(function(node) {
                                        parentNode.removeChild(node);
                                    });
                                },
                                redo: function redo(params) {
                                    var parentNode = findNode(params.parentPath);
                                    var beforeNode = findNode(params.beforePath);
                                    params.nodes.forEach(function(node) {
                                        parentNode.insertBefore(node, beforeNode);
                                    });
                                }
                            },
                            insertAfterNodes: {
                                undo: function undo(params) {
                                    var parentNode = findNode(params.parentPath);
                                    params.paths.map(findNode).forEach(function(node) {
                                        parentNode.removeChild(node);
                                    });
                                },
                                redo: function redo(params) {
                                    var parentNode = findNode(params.parentPath);
                                    var afterNode = findNode(params.afterPath);
                                    params.nodes.forEach(function(node) {
                                        parentNode.insertAfter(node, afterNode);
                                        afterNode = node;
                                    });
                                }
                            },
                            removeNodes: {
                                undo: function undo(params) {
                                    var parentNode = findNode(params.parentPath);
                                    var beforeNode = parentNode.childs[params.index] || parentNode.append;
                                    params.nodes.forEach(function(node) {
                                        parentNode.insertBefore(node, beforeNode);
                                    });
                                },
                                redo: function redo(params) {
                                    var parentNode = findNode(params.parentPath);
                                    params.paths.map(findNode).forEach(function(node) {
                                        parentNode.removeChild(node);
                                    });
                                }
                            },
                            duplicateNodes: {
                                undo: function undo(params) {
                                    var parentNode = findNode(params.parentPath);
                                    params.clonePaths.map(findNode).forEach(function(node) {
                                        parentNode.removeChild(node);
                                    });
                                },
                                redo: function redo(params) {
                                    var parentNode = findNode(params.parentPath);
                                    var afterNode = findNode(params.afterPath);
                                    var nodes = params.paths.map(findNode);
                                    nodes.forEach(function(node) {
                                        var clone = node.clone();
                                        if (parentNode.type === 'object') {
                                            var existingFieldNames = parentNode.getFieldNames();
                                            clone.field = (0, util.findUniqueName)(node.field, existingFieldNames);
                                        }
                                        parentNode.insertAfter(clone, afterNode);
                                        afterNode = clone;
                                    });
                                }
                            },
                            moveNodes: {
                                undo: function undo(params) {
                                    var oldParentNode = findNode(params.oldParentPath);
                                    var newParentNode = findNode(params.newParentPath);
                                    var oldBeforeNode = oldParentNode.childs[params.oldIndex] || oldParentNode.append;
                                    // first copy the nodes, then move them
                                    var nodes = newParentNode.childs.slice(params.newIndex, params.newIndex + params.count);
                                    nodes.forEach(function(node, index) {
                                        node.field = params.fieldNames[index];
                                        oldParentNode.moveBefore(node, oldBeforeNode);
                                    });
                                    // This is a hack to work around an issue that we don't know tha original
                                    // path of the new parent after dragging, as the node is already moved at that time.
                                    if (params.newParentPathRedo === null) params.newParentPathRedo = newParentNode.getInternalPath();
                                },
                                redo: function redo(params) {
                                    var oldParentNode = findNode(params.oldParentPathRedo);
                                    var newParentNode = findNode(params.newParentPathRedo);
                                    var newBeforeNode = newParentNode.childs[params.newIndexRedo] || newParentNode.append;
                                    // first copy the nodes, then move them
                                    var nodes = oldParentNode.childs.slice(params.oldIndexRedo, params.oldIndexRedo + params.count);
                                    nodes.forEach(function(node, index) {
                                        node.field = params.fieldNames[index];
                                        newParentNode.moveBefore(node, newBeforeNode);
                                    });
                                }
                            },
                            sort: {
                                undo: function undo(params) {
                                    var node = findNode(params.path);
                                    node.hideChilds();
                                    node.childs = params.oldChilds;
                                    node.updateDom({
                                        updateIndexes: true
                                    });
                                    node.showChilds();
                                },
                                redo: function redo(params) {
                                    var node = findNode(params.path);
                                    node.hideChilds();
                                    node.childs = params.newChilds;
                                    node.updateDom({
                                        updateIndexes: true
                                    });
                                    node.showChilds();
                                }
                            },
                            transform: {
                                undo: function undo(params) {
                                    findNode(params.path).setInternalValue(params.oldValue);
                                // TODO: would be nice to restore the state of the node and childs
                                },
                                redo: function redo(params) {
                                    findNode(params.path).setInternalValue(params.newValue);
                                // TODO: would be nice to restore the state of the node and childs
                                }
                            }
                        };
                    }
                    /**
   * The method onChange is executed when the History is changed, and can
   * be overloaded.
   */ return NodeHistory_createClass(NodeHistory, [
                        {
                            key: "onChange",
                            value: function onChange() {}
                        },
                        {
                            key: "add",
                            value: function add(action, params) {
                                this.index++;
                                this.history[this.index] = {
                                    action: action,
                                    params: params,
                                    timestamp: new Date()
                                };
                                // remove redo actions which are invalid now
                                if (this.index < this.history.length - 1) this.history.splice(this.index + 1, this.history.length - this.index - 1);
                                // fire onchange event
                                this.onChange();
                            }
                        },
                        {
                            key: "clear",
                            value: function clear() {
                                this.history = [];
                                this.index = -1;
                                // fire onchange event
                                this.onChange();
                            }
                        },
                        {
                            key: "canUndo",
                            value: function canUndo() {
                                return this.index >= 0;
                            }
                        },
                        {
                            key: "canRedo",
                            value: function canRedo() {
                                return this.index < this.history.length - 1;
                            }
                        },
                        {
                            key: "undo",
                            value: function undo() {
                                if (this.canUndo()) {
                                    var obj = this.history[this.index];
                                    if (obj) {
                                        var action = this.actions[obj.action];
                                        if (action && action.undo) {
                                            action.undo(obj.params);
                                            if (obj.params.oldSelection) try {
                                                this.editor.setDomSelection(obj.params.oldSelection);
                                            } catch (err) {
                                                console.error(err);
                                            }
                                        } else console.error(new Error('unknown action "' + obj.action + '"'));
                                    }
                                    this.index--;
                                    // fire onchange event
                                    this.onChange();
                                }
                            }
                        },
                        {
                            key: "redo",
                            value: function redo() {
                                if (this.canRedo()) {
                                    this.index++;
                                    var obj = this.history[this.index];
                                    if (obj) {
                                        var action = this.actions[obj.action];
                                        if (action && action.redo) {
                                            action.redo(obj.params);
                                            if (obj.params.newSelection) try {
                                                this.editor.setDomSelection(obj.params.newSelection);
                                            } catch (err) {
                                                console.error(err);
                                            }
                                        } else console.error(new Error('unknown action "' + obj.action + '"'));
                                    }
                                    // fire onchange event
                                    this.onChange();
                                }
                            }
                        },
                        {
                            key: "destroy",
                            value: function destroy() {
                                this.editor = null;
                                this.history = [];
                                this.index = -1;
                            }
                        }
                    ]);
                }();
                function SearchBox_typeof(o) {
                    "@babel/helpers - typeof";
                    return SearchBox_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
                        return typeof o;
                    } : function(o) {
                        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
                    }, SearchBox_typeof(o);
                }
                function SearchBox_classCallCheck(a, n) {
                    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
                }
                function SearchBox_defineProperties(e, r) {
                    for(var t = 0; t < r.length; t++){
                        var o = r[t];
                        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, SearchBox_toPropertyKey(o.key), o);
                    }
                }
                function SearchBox_createClass(e, r, t) {
                    return r && SearchBox_defineProperties(e.prototype, r), t && SearchBox_defineProperties(e, t), Object.defineProperty(e, "prototype", {
                        writable: !1
                    }), e;
                }
                function SearchBox_toPropertyKey(t) {
                    var i = SearchBox_toPrimitive(t, "string");
                    return "symbol" == SearchBox_typeof(i) ? i : i + "";
                }
                function SearchBox_toPrimitive(t, r) {
                    if ("object" != SearchBox_typeof(t) || !t) return t;
                    var e = t[Symbol.toPrimitive];
                    if (void 0 !== e) {
                        var i = e.call(t, r || "default");
                        if ("object" != SearchBox_typeof(i)) return i;
                        throw new TypeError("@@toPrimitive must return a primitive value.");
                    }
                    return ("string" === r ? String : Number)(t);
                }
                /**
 * @constructor SearchBox
 * Create a search box in given HTML container
 * @param {JSONEditor} editor    The JSON Editor to attach to
 * @param {Element} container               HTML container element of where to
 *                                          create the search box
 */ var SearchBox = /*#__PURE__*/ function() {
                    function SearchBox(editor, container) {
                        SearchBox_classCallCheck(this, SearchBox);
                        var searchBox = this;
                        this.editor = editor;
                        this.timeout = undefined;
                        this.delay = 200; // ms
                        this.lastText = undefined;
                        this.results = null;
                        this.dom = {};
                        this.dom.container = container;
                        var wrapper = document.createElement('div');
                        this.dom.wrapper = wrapper;
                        wrapper.className = 'jsoneditor-search';
                        container.appendChild(wrapper);
                        var results = document.createElement('div');
                        this.dom.results = results;
                        results.className = 'jsoneditor-results';
                        wrapper.appendChild(results);
                        var divInput = document.createElement('div');
                        this.dom.input = divInput;
                        divInput.className = 'jsoneditor-frame';
                        divInput.title = (0, i18n /* translate */ .Tl)('searchTitle');
                        wrapper.appendChild(divInput);
                        var refreshSearch = document.createElement('button');
                        refreshSearch.type = 'button';
                        refreshSearch.className = 'jsoneditor-refresh';
                        divInput.appendChild(refreshSearch);
                        var search = document.createElement('input');
                        search.type = 'text';
                        this.dom.search = search;
                        search.oninput = function(event) {
                            searchBox._onDelayedSearch(event);
                        };
                        search.onchange = function(event) {
                            // For IE 9
                            searchBox._onSearch();
                        };
                        search.onkeydown = function(event) {
                            searchBox._onKeyDown(event);
                        };
                        search.onkeyup = function(event) {
                            searchBox._onKeyUp(event);
                        };
                        refreshSearch.onclick = function(event) {
                            search.select();
                        };
                        // TODO: ESC in FF restores the last input, is a FF bug, https://bugzilla.mozilla.org/show_bug.cgi?id=598819
                        divInput.appendChild(search);
                        var searchNext = document.createElement('button');
                        searchNext.type = 'button';
                        searchNext.title = (0, i18n /* translate */ .Tl)('searchNextResultTitle');
                        searchNext.className = 'jsoneditor-next';
                        searchNext.onclick = function() {
                            searchBox.next();
                        };
                        divInput.appendChild(searchNext);
                        var searchPrevious = document.createElement('button');
                        searchPrevious.type = 'button';
                        searchPrevious.title = (0, i18n /* translate */ .Tl)('searchPreviousResultTitle');
                        searchPrevious.className = 'jsoneditor-previous';
                        searchPrevious.onclick = function() {
                            searchBox.previous();
                        };
                        divInput.appendChild(searchPrevious);
                    }
                    /**
   * Go to the next search result
   * @param {boolean} [focus]   If true, focus will be set to the next result
   *                            focus is false by default.
   */ return SearchBox_createClass(SearchBox, [
                        {
                            key: "next",
                            value: function next(focus) {
                                if (this.results) {
                                    var index = this.resultIndex !== null ? this.resultIndex + 1 : 0;
                                    if (index > this.results.length - 1) index = 0;
                                    this._setActiveResult(index, focus);
                                }
                            }
                        },
                        {
                            key: "previous",
                            value: function previous(focus) {
                                if (this.results) {
                                    var max = this.results.length - 1;
                                    var index = this.resultIndex !== null ? this.resultIndex - 1 : max;
                                    if (index < 0) index = max;
                                    this._setActiveResult(index, focus);
                                }
                            }
                        },
                        {
                            key: "_setActiveResult",
                            value: function _setActiveResult(index, focus) {
                                // de-activate current active result
                                if (this.activeResult) {
                                    var prevNode = this.activeResult.node;
                                    var prevElem = this.activeResult.elem;
                                    if (prevElem === 'field') delete prevNode.searchFieldActive;
                                    else delete prevNode.searchValueActive;
                                    prevNode.updateDom();
                                }
                                if (!this.results || !this.results[index]) {
                                    // out of range, set to undefined
                                    this.resultIndex = undefined;
                                    this.activeResult = undefined;
                                    return;
                                }
                                this.resultIndex = index;
                                // set new node active
                                var node = this.results[this.resultIndex].node;
                                var elem = this.results[this.resultIndex].elem;
                                if (elem === 'field') node.searchFieldActive = true;
                                else node.searchValueActive = true;
                                this.activeResult = this.results[this.resultIndex];
                                node.updateDom();
                                // TODO: not so nice that the focus is only set after the animation is finished
                                node.scrollTo(function() {
                                    if (focus) node.focus(elem);
                                });
                            }
                        },
                        {
                            key: "_clearDelay",
                            value: function _clearDelay() {
                                if (this.timeout !== undefined) {
                                    clearTimeout(this.timeout);
                                    delete this.timeout;
                                }
                            }
                        },
                        {
                            key: "_onDelayedSearch",
                            value: function _onDelayedSearch(event) {
                                // execute the search after a short delay (reduces the number of
                                // search actions while typing in the search text box)
                                this._clearDelay();
                                var searchBox = this;
                                this.timeout = setTimeout(function(event) {
                                    searchBox._onSearch();
                                }, this.delay);
                            }
                        },
                        {
                            key: "_onSearch",
                            value: function _onSearch(forceSearch) {
                                this._clearDelay();
                                var value = this.dom.search.value;
                                var text = value.length > 0 ? value : undefined;
                                if (text !== this.lastText || forceSearch) {
                                    // only search again when changed
                                    this.lastText = text;
                                    this.results = this.editor.search(text);
                                    var MAX_SEARCH_RESULTS = this.results[0] ? this.results[0].node.MAX_SEARCH_RESULTS : Infinity;
                                    // try to maintain the current active result if this is still part of the new search results
                                    var activeResultIndex = 0;
                                    if (this.activeResult) {
                                        for(var i = 0; i < this.results.length; i++)if (this.results[i].node === this.activeResult.node) {
                                            activeResultIndex = i;
                                            break;
                                        }
                                    }
                                    this._setActiveResult(activeResultIndex, false);
                                    // display search results
                                    if (text !== undefined) {
                                        var resultCount = this.results.length;
                                        if (resultCount === 0) this.dom.results.textContent = "no\xA0results";
                                        else if (resultCount === 1) this.dom.results.textContent = "1\xA0result";
                                        else if (resultCount > MAX_SEARCH_RESULTS) this.dom.results.textContent = MAX_SEARCH_RESULTS + "+\xA0results";
                                        else this.dom.results.textContent = resultCount + "\xA0results";
                                    } else this.dom.results.textContent = '';
                                }
                            }
                        },
                        {
                            key: "_onKeyDown",
                            value: function _onKeyDown(event) {
                                var keynum = event.which;
                                if (keynum === 27) {
                                    // ESC
                                    this.dom.search.value = ''; // clear search
                                    this._onSearch();
                                    event.preventDefault();
                                    event.stopPropagation();
                                } else if (keynum === 13) {
                                    // Enter
                                    if (event.ctrlKey) // force to search again
                                    this._onSearch(true);
                                    else if (event.shiftKey) // move to the previous search result
                                    this.previous();
                                    else // move to the next search result
                                    this.next();
                                    event.preventDefault();
                                    event.stopPropagation();
                                }
                            }
                        },
                        {
                            key: "_onKeyUp",
                            value: function _onKeyUp(event) {
                                var keynum = event.keyCode;
                                if (keynum !== 27 && keynum !== 13) // !show and !Enter
                                this._onDelayedSearch(event); // For IE 9
                            }
                        },
                        {
                            key: "clear",
                            value: function clear() {
                                this.dom.search.value = '';
                                this._onSearch();
                            }
                        },
                        {
                            key: "forceSearch",
                            value: function forceSearch() {
                                this._onSearch(true);
                            }
                        },
                        {
                            key: "isEmpty",
                            value: function isEmpty() {
                                return this.dom.search.value === '';
                            }
                        },
                        {
                            key: "destroy",
                            value: function destroy() {
                                this.editor = null;
                                this.dom.container.removeChild(this.dom.wrapper);
                                this.dom = null;
                                this.results = null;
                                this.activeResult = null;
                                this._clearDelay();
                            }
                        }
                    ]);
                }();
                function TreePath_typeof(o) {
                    "@babel/helpers - typeof";
                    return TreePath_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
                        return typeof o;
                    } : function(o) {
                        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
                    }, TreePath_typeof(o);
                }
                function TreePath_classCallCheck(a, n) {
                    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
                }
                function TreePath_defineProperties(e, r) {
                    for(var t = 0; t < r.length; t++){
                        var o = r[t];
                        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, TreePath_toPropertyKey(o.key), o);
                    }
                }
                function TreePath_createClass(e, r, t) {
                    return r && TreePath_defineProperties(e.prototype, r), t && TreePath_defineProperties(e, t), Object.defineProperty(e, "prototype", {
                        writable: !1
                    }), e;
                }
                function TreePath_toPropertyKey(t) {
                    var i = TreePath_toPrimitive(t, "string");
                    return "symbol" == TreePath_typeof(i) ? i : i + "";
                }
                function TreePath_toPrimitive(t, r) {
                    if ("object" != TreePath_typeof(t) || !t) return t;
                    var e = t[Symbol.toPrimitive];
                    if (void 0 !== e) {
                        var i = e.call(t, r || "default");
                        if ("object" != TreePath_typeof(i)) return i;
                        throw new TypeError("@@toPrimitive must return a primitive value.");
                    }
                    return ("string" === r ? String : Number)(t);
                }
                /**
 * Creates a component that visualize path selection in tree based editors
 * @param {HTMLElement} container
 * @param {HTMLElement} root
 * @constructor
 */ var TreePath = /*#__PURE__*/ function() {
                    function TreePath(container, root) {
                        TreePath_classCallCheck(this, TreePath);
                        if (container) {
                            this.root = root;
                            this.path = document.createElement('div');
                            this.path.className = 'jsoneditor-treepath';
                            this.path.setAttribute('tabindex', 0);
                            this.contentMenuClicked = false;
                            container.appendChild(this.path);
                            this.reset();
                        }
                    }
                    /**
   * Reset component to initial status
   */ return TreePath_createClass(TreePath, [
                        {
                            key: "reset",
                            value: function reset() {
                                this.path.textContent = (0, i18n /* translate */ .Tl)('selectNode');
                            }
                        },
                        {
                            key: "setPath",
                            value: function setPath(pathObjs) {
                                var me = this;
                                this.path.textContent = '';
                                if (pathObjs && pathObjs.length) pathObjs.forEach(function(pathObj, idx) {
                                    var pathEl = document.createElement('span');
                                    var sepEl;
                                    pathEl.className = 'jsoneditor-treepath-element';
                                    pathEl.innerText = pathObj.name;
                                    pathEl.onclick = _onSegmentClick.bind(me, pathObj);
                                    me.path.appendChild(pathEl);
                                    if (pathObj.children.length) {
                                        sepEl = document.createElement('span');
                                        sepEl.className = 'jsoneditor-treepath-seperator';
                                        sepEl.textContent = "\u25BA";
                                        sepEl.onclick = function() {
                                            me.contentMenuClicked = true;
                                            var items = [];
                                            pathObj.children.forEach(function(child) {
                                                items.push({
                                                    text: child.name,
                                                    className: 'jsoneditor-type-modes' + (pathObjs[idx + 1] + 1 && pathObjs[idx + 1].name === child.name ? ' jsoneditor-selected' : ''),
                                                    click: _onContextMenuItemClick.bind(me, pathObj, child.name)
                                                });
                                            });
                                            var menu = new ContextMenu /* ContextMenu */ .t(items, {
                                                limitHeight: true
                                            });
                                            menu.show(sepEl, me.root, true);
                                        };
                                        me.path.appendChild(sepEl);
                                    }
                                    if (idx === pathObjs.length - 1) {
                                        var leftRectPos = (sepEl || pathEl).getBoundingClientRect().right;
                                        if (me.path.offsetWidth < leftRectPos) me.path.scrollLeft = leftRectPos;
                                        if (me.path.scrollLeft) {
                                            var showAllBtn = document.createElement('span');
                                            showAllBtn.className = 'jsoneditor-treepath-show-all-btn';
                                            showAllBtn.title = 'show all path';
                                            showAllBtn.textContent = '...';
                                            showAllBtn.onclick = _onShowAllClick.bind(me, pathObjs);
                                            me.path.insertBefore(showAllBtn, me.path.firstChild);
                                        }
                                    }
                                });
                                function _onShowAllClick(pathObjs) {
                                    me.contentMenuClicked = false;
                                    (0, util.addClassName)(me.path, 'show-all');
                                    me.path.style.width = me.path.parentNode.getBoundingClientRect().width - 10 + 'px';
                                    me.path.onblur = function() {
                                        if (me.contentMenuClicked) {
                                            me.contentMenuClicked = false;
                                            me.path.focus();
                                            return;
                                        }
                                        (0, util.removeClassName)(me.path, 'show-all');
                                        me.path.onblur = undefined;
                                        me.path.style.width = '';
                                        me.setPath(pathObjs);
                                    };
                                }
                                function _onSegmentClick(pathObj) {
                                    if (this.selectionCallback) this.selectionCallback(pathObj);
                                }
                                function _onContextMenuItemClick(pathObj, selection) {
                                    if (this.contextMenuCallback) this.contextMenuCallback(pathObj, selection);
                                }
                            }
                        },
                        {
                            key: "onSectionSelected",
                            value: function onSectionSelected(callback) {
                                if (typeof callback === 'function') this.selectionCallback = callback;
                            }
                        },
                        {
                            key: "onContextMenuItemSelected",
                            value: function onContextMenuItemSelected(callback) {
                                if (typeof callback === 'function') this.contextMenuCallback = callback;
                            }
                        }
                    ]);
                }();
                // EXTERNAL MODULE: ./src/js/vanilla-picker/index.js
                var vanilla_picker = __webpack_require__(746);
                var vanilla_picker_default = /*#__PURE__*/ __webpack_require__.n(vanilla_picker);
                // create a mixin with the functions for tree mode
                var treemode = {};
                /**
 * Create a tree editor
 * @param {Element} container    Container element
 * @param {Object} [options]   Object with options. See docs for details.
 * @private
 */ treemode.create = function(container, options) {
                    if (!container) throw new Error('No container element provided.');
                    this.container = container;
                    this.dom = {};
                    this.highlighter = new Highlighter();
                    this.selection = undefined; // will hold the last input selection
                    this.multiselection = {
                        nodes: []
                    };
                    this.validateSchema = null; // will be set in .setSchema(schema)
                    this.validationSequence = 0;
                    this.errorNodes = [];
                    this.lastSchemaErrors = undefined;
                    this.node = null;
                    this.focusTarget = null;
                    this._setOptions(options);
                    if (options.autocomplete) this.autocomplete = autocomplete(options.autocomplete);
                    if (this.options.history && this.options.mode !== 'view') this.history = new NodeHistory(this);
                    this._createFrame();
                    this._createTable();
                };
                /**
 * Destroy the editor. Clean up DOM, event listeners, and web workers.
 */ treemode.destroy = function() {
                    if (this.frame && this.container && this.frame.parentNode === this.container) {
                        this.container.removeChild(this.frame);
                        this.frame = null;
                    }
                    this.container = null;
                    this.dom = null;
                    this.clear();
                    this.node = null;
                    this.focusTarget = null;
                    this.selection = null;
                    this.multiselection = null;
                    this.errorNodes = null;
                    this.validateSchema = null;
                    this._debouncedValidate = null;
                    if (this.history) {
                        this.history.destroy();
                        this.history = null;
                    }
                    if (this.searchBox) {
                        this.searchBox.destroy();
                        this.searchBox = null;
                    }
                    if (this.modeSwitcher) {
                        this.modeSwitcher.destroy();
                        this.modeSwitcher = null;
                    }
                    // Removing the FocusTracker set to track the editor's focus event
                    this.frameFocusTracker.destroy();
                };
                /**
 * Initialize and set default options
 * @param {Object}  [options]    See description in constructor
 * @private
 */ treemode._setOptions = function(options) {
                    var _this = this;
                    this.options = {
                        search: true,
                        history: true,
                        mode: 'tree',
                        name: undefined,
                        // field name of root node
                        schema: null,
                        schemaRefs: null,
                        autocomplete: null,
                        navigationBar: true,
                        mainMenuBar: true,
                        limitDragging: false,
                        onSelectionChange: null,
                        colorPicker: true,
                        onColorPicker: function onColorPicker(parent, color, onChange) {
                            if (vanilla_picker_default()) {
                                // we'll render the color picker on top
                                // when there is not enough space below, and there is enough space above
                                var pickerHeight = 300; // estimated height of the color picker
                                var top = parent.getBoundingClientRect().top;
                                var windowHeight = (0, util.getWindow)(parent).innerHeight;
                                var showOnTop = windowHeight - top < pickerHeight && top > pickerHeight;
                                new (vanilla_picker_default())({
                                    parent: parent,
                                    color: color,
                                    popup: showOnTop ? 'top' : 'bottom',
                                    onDone: function onDone(color) {
                                        var alpha = color.rgba[3];
                                        var hex = alpha === 1 ? color.hex.substr(0, 7) // return #RRGGBB
                                         : color.hex; // return #RRGGBBAA
                                        onChange(hex);
                                    }
                                }).show();
                            } else console.warn("Cannot open color picker: the `vanilla-picker` library is not included in the bundle. Either use the full bundle or implement your own color picker using `onColorPicker`.");
                        },
                        timestampTag: true,
                        timestampFormat: null,
                        createQuery: jmespathQuery /* createQuery */ .V,
                        executeQuery: jmespathQuery /* executeQuery */ .e,
                        onEvent: null,
                        enableSort: true,
                        enableTransform: true
                    };
                    // copy all options
                    if (options) {
                        Object.keys(options).forEach(function(prop) {
                            _this.options[prop] = options[prop];
                        });
                        // default limitDragging to true when a JSON schema is defined
                        if (options.limitDragging == null && options.schema != null) this.options.limitDragging = true;
                    }
                    // compile a JSON schema validator if a JSON schema is provided
                    this.setSchema(this.options.schema, this.options.schemaRefs);
                    // create a debounced validate function
                    this._debouncedValidate = (0, util.debounce)(this._validateAndCatch.bind(this), this.DEBOUNCE_INTERVAL);
                    if (options.onSelectionChange) this.onSelectionChange(options.onSelectionChange);
                    (0, i18n /* setLanguages */ .AI)(this.options.languages);
                    (0, i18n /* setLanguage */ .xC)(this.options.language);
                };
                /**
 * Set new JSON object in editor.
 * Resets the state of the editor (expanded nodes, search, selection).
 *
 * @param {*} json
 */ treemode.set = function(json) {
                    // verify if json is valid JSON, ignore when a function
                    if (json instanceof Function || json === undefined) this.clear();
                    else {
                        this.content.removeChild(this.table); // Take the table offline
                        // replace the root node
                        var params = {
                            field: this.options.name,
                            value: json
                        };
                        var node = new Node1(this, params);
                        this._setRoot(node);
                        // validate JSON schema (if configured)
                        this._validateAndCatch();
                        // expand
                        var recurse = false;
                        this.node.expand(recurse);
                        this.content.appendChild(this.table); // Put the table online again
                    }
                    // TODO: maintain history, store last state and previous document
                    if (this.history) this.history.clear();
                    // clear search
                    if (this.searchBox) this.searchBox.clear();
                };
                /**
 * Update JSON object in editor.
 * Maintains the state of the editor (expanded nodes, search, selection).
 *
 * @param {*} json
 */ treemode.update = function(json) {
                    // don't update if there are no changes
                    if (this.node.deepEqual(json)) return;
                    var selection = this.getSelection();
                    // apply the changed json
                    this.onChangeDisabled = true; // don't fire an onChange event
                    this.node.update(json);
                    this.onChangeDisabled = false;
                    // validate JSON schema
                    this._validateAndCatch();
                    // update search result if any
                    if (this.searchBox && !this.searchBox.isEmpty()) this.searchBox.forceSearch();
                    // update selection if any
                    if (selection && selection.start && selection.end) {
                        // only keep/update the selection if both start and end node still exists,
                        // else we clear the selection
                        var startNode = this.node.findNodeByPath(selection.start.path);
                        var endNode = this.node.findNodeByPath(selection.end.path);
                        if (startNode && endNode) this.setSelection(selection.start, selection.end);
                        else this.setSelection({}, {}); // clear selection
                    } else this.setSelection({}, {}); // clear selection
                };
                /**
 * Get JSON object from editor
 * @return {Object | undefined} json
 */ treemode.get = function() {
                    // TODO: resolve pending debounced input changes if any, but do not resolve invalid inputs
                    if (this.node) return this.node.getValue();
                    else return undefined;
                };
                /**
 * Get the text contents of the editor
 * @return {String} jsonText
 */ treemode.getText = function() {
                    return JSON.stringify(this.get());
                };
                /**
 * Set the text contents of the editor.
 * Resets the state of the editor (expanded nodes, search, selection).
 * @param {String} jsonText
 */ treemode.setText = function(jsonText) {
                    try {
                        this.set((0, util.parse)(jsonText)); // this can throw an error
                    } catch (err) {
                        // try to repair json, replace JavaScript notation with JSON notation
                        var repairedJsonText = (0, util.tryJsonRepair)(jsonText);
                        // try to parse again
                        this.set((0, util.parse)(repairedJsonText)); // this can throw an error
                    }
                };
                /**
 * Update the text contents of the editor.
 * Maintains the state of the editor (expanded nodes, search, selection).
 * @param {String} jsonText
 */ treemode.updateText = function(jsonText) {
                    try {
                        this.update((0, util.parse)(jsonText)); // this can throw an error
                    } catch (err) {
                        // try to repair json, replace JavaScript notation with JSON notation
                        var repairJsonText = (0, util.tryJsonRepair)(jsonText);
                        // try to parse again
                        this.update((0, util.parse)(repairJsonText)); // this can throw an error
                    }
                };
                /**
 * Set a field name for the root node.
 * @param {String | undefined} name
 */ treemode.setName = function(name) {
                    this.options.name = name;
                    if (this.node) this.node.updateField(this.options.name);
                };
                /**
 * Get the field name for the root node.
 * @return {String | undefined} name
 */ treemode.getName = function() {
                    return this.options.name;
                };
                /**
 * Set focus to the editor. Focus will be set to:
 * - the first editable field or value, or else
 * - to the expand button of the root node, or else
 * - to the context menu button of the root node, or else
 * - to the first button in the top menu
 */ treemode.focus = function() {
                    var input = this.scrollableContent.querySelector('[contenteditable=true]');
                    if (input) input.focus();
                    else if (this.node.dom.expand) this.node.dom.expand.focus();
                    else if (this.node.dom.menu) this.node.dom.menu.focus();
                    else {
                        // focus to the first button in the menu
                        input = this.frame.querySelector('button');
                        if (input) input.focus();
                    }
                };
                /**
 * Remove the root node from the editor
 */ treemode.clear = function() {
                    if (this.node) {
                        this.node.hide();
                        delete this.node;
                    }
                    if (this.treePath) this.treePath.reset();
                };
                /**
 * Set the root node for the json editor
 * @param {Node} node
 * @private
 */ treemode._setRoot = function(node) {
                    this.clear();
                    this.node = node;
                    node.setParent(null);
                    node.setField(this.getName(), false);
                    delete node.index;
                    // append to the dom
                    this.tbody.appendChild(node.getDom());
                };
                /**
 * Search text in all nodes
 * The nodes will be expanded when the text is found one of its childs,
 * else it will be collapsed. Searches are case insensitive.
 * @param {String} text
 * @return {Object[]} results  Array with nodes containing the search results
 *                             The result objects contains fields:
 *                             - {Node} node,
 *                             - {String} elem  the dom element name where
 *                                              the result is found ('field' or
 *                                              'value')
 */ treemode.search = function(text) {
                    var results;
                    if (this.node) {
                        this.content.removeChild(this.table); // Take the table offline
                        results = this.node.search(text);
                        this.content.appendChild(this.table); // Put the table online again
                    } else results = [];
                    return results;
                };
                /**
 * Expand all nodes
 */ treemode.expandAll = function() {
                    if (this.node) {
                        this.content.removeChild(this.table); // Take the table offline
                        this.node.expand();
                        this.content.appendChild(this.table); // Put the table online again
                    }
                };
                /**
 * Collapse all nodes
 */ treemode.collapseAll = function() {
                    if (this.node) {
                        this.content.removeChild(this.table); // Take the table offline
                        this.node.collapse();
                        this.content.appendChild(this.table); // Put the table online again
                    }
                };
                /**
 * Expand/collapse a given JSON node.
 * @param {Object} [options] Available parameters:
 *                         {Array<String>} [path] Path for the node to expand/collapse.
 *                         {Boolean} [isExpand]  Whether to expand the node (else collapse).
 *                         {Boolean} [recursive]  Whether to expand/collapse child nodes recursively.
 */ treemode.expand = function(options) {
                    if (!options) return;
                    var node = this.node ? this.node.findNodeByPath(options.path) : null;
                    if (!node) return;
                    if (options.isExpand) node.expand(options.recursive);
                    else node.collapse(options.recursive);
                };
                /**
 * The method onChange is called whenever a field or value is changed, created,
 * deleted, duplicated, etc.
 * @param {String} action  Change action. Available values: "editField",
 *                         "editValue", "changeType", "appendNode",
 *                         "removeNode", "duplicateNode", "moveNode", "expand",
 *                         "collapse".
 * @param {Object} params  Object containing parameters describing the change.
 *                         The parameters in params depend on the action (for
 *                         example for "editValue" the Node, old value, and new
 *                         value are provided). params contains all information
 *                         needed to undo or redo the action.
 * @private
 */ treemode._onAction = function(action, params) {
                    // add an action to the history
                    if (this.history) this.history.add(action, params);
                    this._onChange();
                };
                /**
 * Handle a change:
 * - Validate JSON schema
 * - Send a callback to the onChange listener if provided
 * @private
 */ treemode._onChange = function() {
                    if (this.onChangeDisabled) return;
                    // selection can be changed after undo/redo
                    this.selection = this.getDomSelection();
                    // validate JSON schema (if configured)
                    this._debouncedValidate();
                    if (this.treePath) {
                        var selectedNode = this.node && this.selection ? this.node.findNodeByInternalPath(this.selection.path) : this.multiselection ? this.multiselection.nodes[0] : undefined;
                        if (selectedNode) this._updateTreePath(selectedNode.getNodePath());
                        else this.treePath.reset();
                    }
                    // trigger the onChange callback
                    if (this.options.onChange) try {
                        this.options.onChange();
                    } catch (err) {
                        console.error('Error in onChange callback: ', err);
                    }
                    // trigger the onChangeJSON callback
                    if (this.options.onChangeJSON) try {
                        this.options.onChangeJSON(this.get());
                    } catch (err) {
                        console.error('Error in onChangeJSON callback: ', err);
                    }
                    // trigger the onChangeText callback
                    if (this.options.onChangeText) try {
                        this.options.onChangeText(this.getText());
                    } catch (err) {
                        console.error('Error in onChangeText callback: ', err);
                    }
                    // trigger the onClassName callback
                    if (this.options.onClassName) this.node.recursivelyUpdateCssClassesOnNodes();
                    // trigger the onNodeName callback
                    if (this.options.onNodeName && this.node.childs) try {
                        this.node.recursivelyUpdateNodeName();
                    } catch (err) {
                        console.error('Error in onNodeName callback: ', err);
                    }
                };
                /**
 * Validate current JSON object against the configured JSON schema
 * Throws an exception when no JSON schema is configured
 */ treemode.validate = function() {
                    var _this2 = this;
                    var root = this.node;
                    if (!root) // TODO: this should be redundant but is needed on mode switch
                    return;
                    var json = root.getValue();
                    // execute JSON schema validation
                    var schemaErrors = [];
                    if (this.validateSchema) {
                        var valid = this.validateSchema(json);
                        if (!valid) // apply all new errors
                        schemaErrors = this.validateSchema.errors.map(function(error) {
                            return (0, util.improveSchemaError)(error);
                        }).map(function findNode(error) {
                            return {
                                node: root.findNode(error.dataPath),
                                error: error,
                                type: 'validation'
                            };
                        }).filter(function hasNode(entry) {
                            return entry.node != null;
                        });
                    }
                    // execute custom validation and after than merge and render all errors
                    try {
                        this.validationSequence++;
                        var me = this;
                        var seq = this.validationSequence;
                        return this._validateCustom(json).then(function(customValidationErrors) {
                            // only apply when there was no other validation started whilst resolving async results
                            if (seq === me.validationSequence) {
                                var errorNodes = [].concat(schemaErrors, customValidationErrors || []);
                                me._renderValidationErrors(errorNodes);
                                if (typeof _this2.options.onValidationError === 'function' && (0, util.isValidationErrorChanged)(errorNodes, _this2.lastSchemaErrors)) _this2.options.onValidationError.call(_this2, errorNodes);
                                _this2.lastSchemaErrors = errorNodes;
                            }
                            return _this2.lastSchemaErrors;
                        });
                    } catch (err) {
                        return Promise.reject(err);
                    }
                };
                treemode._validateAndCatch = function() {
                    this.validate()["catch"](function(err) {
                        console.error('Error running validation:', err);
                    });
                };
                treemode._renderValidationErrors = function(errorNodes) {
                    // clear all current errors
                    if (this.errorNodes) this.errorNodes.forEach(function(node) {
                        node.setError(null);
                    });
                    // render the new errors
                    var parentPairs = errorNodes.reduce(function(all, entry) {
                        return entry.node.findParents().filter(function(parent) {
                            return !all.some(function(pair) {
                                return pair[0] === parent;
                            });
                        }).map(function(parent) {
                            return [
                                parent,
                                entry.node
                            ];
                        }).concat(all);
                    }, []);
                    this.errorNodes = parentPairs.map(function(pair) {
                        return {
                            node: pair[0],
                            child: pair[1],
                            error: {
                                message: pair[0].type === 'object' ? (0, i18n /* translate */ .Tl)('containsInvalidProperties') // object
                                 : (0, i18n /* translate */ .Tl)('containsInvalidItems') // array
                            }
                        };
                    }).concat(errorNodes).map(function setError(entry) {
                        entry.node.setError(entry.error, entry.child);
                        return entry.node;
                    });
                };
                /**
 * Execute custom validation if configured.
 *
 * Returns a promise resolving with the custom errors (or nothing).
 */ treemode._validateCustom = function(json) {
                    try {
                        if (this.options.onValidate) {
                            var root = this.node;
                            var customValidateResults = this.options.onValidate(json);
                            var resultPromise = (0, util.isPromise)(customValidateResults) ? customValidateResults : Promise.resolve(customValidateResults);
                            return resultPromise.then(function(customValidationPathErrors) {
                                if (Array.isArray(customValidationPathErrors)) return customValidationPathErrors.filter(function(error) {
                                    var valid = (0, util.isValidValidationError)(error);
                                    if (!valid) console.warn('Ignoring a custom validation error with invalid structure. Expected structure: {path: [...], message: "..."}. Actual error:', error);
                                    return valid;
                                }).map(function(error) {
                                    var node;
                                    try {
                                        node = error && error.path ? root.findNodeByPath(error.path) : null;
                                    } catch (err) {
                                    // stay silent here, we throw a generic warning if no node is found
                                    }
                                    if (!node) console.warn('Ignoring validation error: node not found. Path:', error.path, 'Error:', error);
                                    return {
                                        node: node,
                                        error: error,
                                        type: 'customValidation'
                                    };
                                }).filter(function(entry) {
                                    return entry && entry.node && entry.error && entry.error.message;
                                });
                                else return null;
                            });
                        }
                    } catch (err) {
                        return Promise.reject(err);
                    }
                    return Promise.resolve(null);
                };
                /**
 * Refresh the rendered contents
 */ treemode.refresh = function() {
                    if (this.node) this.node.updateDom({
                        recurse: true
                    });
                };
                /**
 * Start autoscrolling when given mouse position is above the top of the
 * editor contents, or below the bottom.
 * @param {Number} mouseY  Absolute mouse position in pixels
 */ treemode.startAutoScroll = function(mouseY) {
                    var me = this;
                    var content = this.scrollableContent;
                    var top = (0, util.getAbsoluteTop)(content);
                    var height = content.clientHeight;
                    var bottom = top + height;
                    var margin = 24;
                    var interval = 50; // ms
                    if (mouseY < top + margin && content.scrollTop > 0) this.autoScrollStep = (top + margin - mouseY) / 3;
                    else if (mouseY > bottom - margin && height + content.scrollTop < content.scrollHeight) this.autoScrollStep = (bottom - margin - mouseY) / 3;
                    else this.autoScrollStep = undefined;
                    if (this.autoScrollStep) {
                        if (!this.autoScrollTimer) this.autoScrollTimer = setInterval(function() {
                            if (me.autoScrollStep) content.scrollTop -= me.autoScrollStep;
                            else me.stopAutoScroll();
                        }, interval);
                    } else this.stopAutoScroll();
                };
                /**
 * Stop auto scrolling. Only applicable when scrolling
 */ treemode.stopAutoScroll = function() {
                    if (this.autoScrollTimer) {
                        clearTimeout(this.autoScrollTimer);
                        delete this.autoScrollTimer;
                    }
                    if (this.autoScrollStep) delete this.autoScrollStep;
                };
                /**
 * Set the focus to an element in the editor, set text selection, and
 * set scroll position.
 * @param {Object} selection  An object containing fields:
 *                            {Element | undefined} dom     The dom element
 *                                                          which has focus
 *                            {Range | TextRange} range     A text selection
 *                            {Node[]} nodes                Nodes in case of multi selection
 *                            {Number} scrollTop            Scroll position
 */ treemode.setDomSelection = function(selection) {
                    if (!selection) return;
                    if ('scrollTop' in selection && this.scrollableContent) // TODO: animated scroll
                    this.scrollableContent.scrollTop = selection.scrollTop;
                    if (selection.paths) {
                        // multi-select
                        var me = this;
                        var nodes = selection.paths.map(function(path) {
                            return me.node.findNodeByInternalPath(path);
                        });
                        this.select(nodes);
                    } else {
                        // find the actual DOM element where to apply the focus
                        var node = selection.path ? this.node.findNodeByInternalPath(selection.path) : null;
                        var container = node && selection.domName ? node.dom[selection.domName] : null;
                        if (selection.range && container) {
                            var range = Object.assign({}, selection.range, {
                                container: container
                            });
                            (0, util.setSelectionOffset)(range);
                        } else if (node) // just a fallback
                        node.focus();
                    }
                };
                /**
 * Get the current focus
 * @return {Object} selection An object containing fields:
 *                            {Element | undefined} dom     The dom element
 *                                                          which has focus
 *                            {Range | TextRange} range     A text selection
 *                            {Node[]} nodes                Nodes in case of multi selection
 *                            {Number} scrollTop            Scroll position
 */ treemode.getDomSelection = function() {
                    // find the node and field name of the current target,
                    // so we can store the current selection in a serializable
                    // way (internal node path and domName)
                    var node = Node1.getNodeFromTarget(this.focusTarget);
                    var focusTarget = this.focusTarget;
                    var domName = node ? Object.keys(node.dom).find(function(domName) {
                        return node.dom[domName] === focusTarget;
                    }) : null;
                    var range = (0, util.getSelectionOffset)();
                    if (range && range.container.nodeName !== 'DIV') // filter on (editable) divs)
                    range = null;
                    if (range && range.container !== focusTarget) range = null;
                    if (range) // we cannot rely on the current instance of the container,
                    // we need to store the internal node path and field and
                    // find the actual DOM field when applying the selection
                    delete range.container;
                    return {
                        path: node ? node.getInternalPath() : null,
                        domName: domName,
                        range: range,
                        paths: this.multiselection.length > 0 ? this.multiselection.nodes.map(function(node) {
                            return node.getInternalPath();
                        }) : null,
                        scrollTop: this.scrollableContent ? this.scrollableContent.scrollTop : 0
                    };
                };
                /**
 * Adjust the scroll position such that given top position is shown at 1/4
 * of the window height.
 * @param {Number} top
 * @param {function(boolean)} [animateCallback] Callback, executed when animation is
 *                                              finished. The callback returns true
 *                                              when animation is finished, or false
 *                                              when not.
 */ treemode.scrollTo = function(top, animateCallback) {
                    var content = this.scrollableContent;
                    if (content) {
                        var editor = this;
                        // cancel any running animation
                        if (editor.animateTimeout) {
                            clearTimeout(editor.animateTimeout);
                            delete editor.animateTimeout;
                        }
                        if (editor.animateCallback) {
                            editor.animateCallback(false);
                            delete editor.animateCallback;
                        }
                        // calculate final scroll position
                        var height = content.clientHeight;
                        var bottom = content.scrollHeight - height;
                        var finalScrollTop = Math.min(Math.max(top - height / 4, 0), bottom);
                        // animate towards the new scroll position
                        var _animate = function animate() {
                            var scrollTop = content.scrollTop;
                            var diff = finalScrollTop - scrollTop;
                            if (Math.abs(diff) > 3) {
                                content.scrollTop += diff / 3;
                                editor.animateCallback = animateCallback;
                                editor.animateTimeout = setTimeout(_animate, 50);
                            } else {
                                // finished
                                if (animateCallback) animateCallback(true);
                                content.scrollTop = finalScrollTop;
                                delete editor.animateTimeout;
                                delete editor.animateCallback;
                            }
                        };
                        _animate();
                    } else if (animateCallback) animateCallback(false);
                };
                /**
 * Create main frame
 * @private
 */ treemode._createFrame = function() {
                    var _this3 = this;
                    // create the frame
                    this.frame = document.createElement('div');
                    this.frame.className = 'jsoneditor jsoneditor-mode-' + this.options.mode;
                    // this.frame.setAttribute("tabindex","0");
                    this.container.appendChild(this.frame);
                    this.contentOuter = document.createElement('div');
                    this.contentOuter.className = 'jsoneditor-outer';
                    // create one global event listener to handle all events from all nodes
                    var editor = this;
                    function onEvent(event) {
                        // when switching to mode "code" or "text" via the menu, some events
                        // are still fired whilst the _onEvent methods is already removed.
                        if (editor._onEvent) editor._onEvent(event);
                    }
                    // setting the FocusTracker on 'this.frame' to track the editor's focus event
                    var focusTrackerConfig = {
                        target: this.frame,
                        onFocus: this.options.onFocus || null,
                        onBlur: this.options.onBlur || null
                    };
                    this.frameFocusTracker = new FocusTracker /* FocusTracker */ .$(focusTrackerConfig);
                    this.frame.onclick = function(event) {
                        var target = event.target; // || event.srcElement;
                        onEvent(event);
                        // prevent default submit action of buttons when editor is located
                        // inside a form
                        if (target.nodeName === 'BUTTON') event.preventDefault();
                    };
                    this.frame.oninput = onEvent;
                    this.frame.onchange = onEvent;
                    this.frame.onkeydown = onEvent;
                    this.frame.onkeyup = onEvent;
                    this.frame.oncut = onEvent;
                    this.frame.onpaste = onEvent;
                    this.frame.onmousedown = onEvent;
                    this.frame.onmouseup = onEvent;
                    this.frame.onmouseover = onEvent;
                    this.frame.onmouseout = onEvent;
                    // Note: focus and blur events do not propagate, therefore they defined
                    // using an eventListener with useCapture=true
                    // see http://www.quirksmode.org/blog/archives/2008/04/delegating_the.html
                    (0, util.addEventListener)(this.frame, 'focus', onEvent, true);
                    (0, util.addEventListener)(this.frame, 'blur', onEvent, true);
                    this.frame.onfocusin = onEvent; // for IE
                    this.frame.onfocusout = onEvent; // for IE
                    if (this.options.mainMenuBar) {
                        (0, util.addClassName)(this.contentOuter, 'has-main-menu-bar');
                        // create menu
                        this.menu = document.createElement('div');
                        this.menu.className = 'jsoneditor-menu';
                        this.frame.appendChild(this.menu);
                        // create expand all button
                        var expandAll = document.createElement('button');
                        expandAll.type = 'button';
                        expandAll.className = 'jsoneditor-expand-all';
                        expandAll.title = (0, i18n /* translate */ .Tl)('expandAll');
                        expandAll.onclick = function() {
                            editor.expandAll();
                            if (typeof _this3.options.onExpand === 'function') _this3.options.onExpand({
                                path: [],
                                isExpand: true,
                                recursive: true
                            });
                        };
                        this.menu.appendChild(expandAll);
                        // create collapse all button
                        var collapseAll = document.createElement('button');
                        collapseAll.type = 'button';
                        collapseAll.title = (0, i18n /* translate */ .Tl)('collapseAll');
                        collapseAll.className = 'jsoneditor-collapse-all';
                        collapseAll.onclick = function() {
                            editor.collapseAll();
                            if (typeof _this3.options.onExpand === 'function') _this3.options.onExpand({
                                path: [],
                                isExpand: false,
                                recursive: true
                            });
                        };
                        this.menu.appendChild(collapseAll);
                        // create sort button
                        if (this.options.enableSort) {
                            var sort = document.createElement('button');
                            sort.type = 'button';
                            sort.className = 'jsoneditor-sort';
                            sort.title = (0, i18n /* translate */ .Tl)('sortTitleShort');
                            sort.onclick = function() {
                                editor.node.showSortModal();
                            };
                            this.menu.appendChild(sort);
                        }
                        // create transform button
                        if (this.options.enableTransform) {
                            var transform = document.createElement('button');
                            transform.type = 'button';
                            transform.title = (0, i18n /* translate */ .Tl)('transformTitleShort');
                            transform.className = 'jsoneditor-transform';
                            transform.onclick = function() {
                                editor.node.showTransformModal();
                            };
                            this.menu.appendChild(transform);
                        }
                        // create undo/redo buttons
                        if (this.history) {
                            // create undo button
                            var undo = document.createElement('button');
                            undo.type = 'button';
                            undo.className = 'jsoneditor-undo jsoneditor-separator';
                            undo.title = (0, i18n /* translate */ .Tl)('undo');
                            undo.onclick = function() {
                                editor._onUndo();
                            };
                            this.menu.appendChild(undo);
                            this.dom.undo = undo;
                            // create redo button
                            var redo = document.createElement('button');
                            redo.type = 'button';
                            redo.className = 'jsoneditor-redo';
                            redo.title = (0, i18n /* translate */ .Tl)('redo');
                            redo.onclick = function() {
                                editor._onRedo();
                            };
                            this.menu.appendChild(redo);
                            this.dom.redo = redo;
                            // register handler for onchange of history
                            this.history.onChange = function() {
                                undo.disabled = !editor.history.canUndo();
                                redo.disabled = !editor.history.canRedo();
                            };
                            this.history.onChange();
                        }
                        // create mode box
                        if (this.options && this.options.modes && this.options.modes.length) {
                            var me = this;
                            this.modeSwitcher = new ModeSwitcher /* ModeSwitcher */ .n(this.menu, this.options.modes, this.options.mode, function onSwitch(mode) {
                                // switch mode and restore focus
                                try {
                                    me.setMode(mode);
                                    me.modeSwitcher.focus();
                                } catch (err) {
                                    me._onError(err);
                                }
                            });
                        }
                        // create search box
                        if (this.options.search) this.searchBox = new SearchBox(this, this.menu);
                    }
                    if (this.options.navigationBar) {
                        // create second menu row for treepath
                        this.navBar = document.createElement('div');
                        this.navBar.className = 'jsoneditor-navigation-bar nav-bar-empty';
                        this.frame.appendChild(this.navBar);
                        this.treePath = new TreePath(this.navBar, this.getPopupAnchor());
                        this.treePath.onSectionSelected(this._onTreePathSectionSelected.bind(this));
                        this.treePath.onContextMenuItemSelected(this._onTreePathMenuItemSelected.bind(this));
                    }
                };
                /**
 * Perform an undo action
 * @private
 */ treemode._onUndo = function() {
                    if (this.history) {
                        // undo last action
                        this.history.undo();
                        // fire change event
                        this._onChange();
                    }
                };
                /**
 * Perform a redo action
 * @private
 */ treemode._onRedo = function() {
                    if (this.history) {
                        // redo last action
                        this.history.redo();
                        // fire change event
                        this._onChange();
                    }
                };
                /**
 * Event handler
 * @param event
 * @private
 */ treemode._onEvent = function(event) {
                    // don't process events when coming from the color picker
                    if (Node1.targetIsColorPicker(event.target)) return;
                    var node = Node1.getNodeFromTarget(event.target);
                    if (event.type === 'keydown') this._onKeyDown(event);
                    if (node && event.type === 'focus') {
                        this.focusTarget = event.target;
                        if (this.options.autocomplete && this.options.autocomplete.trigger === 'focus') this._showAutoComplete(event.target);
                    }
                    if (event.type === 'mousedown') this._startDragDistance(event);
                    if (event.type === 'mousemove' || event.type === 'mouseup' || event.type === 'click') this._updateDragDistance(event);
                    if (node && this.options && this.options.navigationBar && node && (event.type === 'keydown' || event.type === 'mousedown')) {
                        // apply on next tick, right after the new key press is applied
                        var me = this;
                        setTimeout(function() {
                            me._updateTreePath(node.getNodePath());
                        });
                    }
                    if (node && node.selected) {
                        if (event.type === 'click') {
                            if (event.target === node.dom.menu) {
                                this.showContextMenu(event.target);
                                // stop propagation (else we will open the context menu of a single node)
                                return;
                            }
                            // deselect a multi selection
                            if (!event.hasMoved) this.deselect();
                        }
                        if (event.type === 'mousedown') // drag multiple nodes
                        Node1.onDragStart(this.multiselection.nodes, event);
                    } else // filter mouse events in the contents part of the editor (not the main menu)
                    if (event.type === 'mousedown' && (0, util.hasParentNode)(event.target, this.content)) {
                        this.deselect();
                        if (node && event.target === node.dom.drag) // drag a singe node
                        Node1.onDragStart(node, event);
                        else if (!node || event.target !== node.dom.field && event.target !== node.dom.value && event.target !== node.dom.select) // select multiple nodes
                        this._onMultiSelectStart(event);
                    }
                    if (node) node.onEvent(event);
                };
                /**
 * Update TreePath components
 * @param {Array<Node>} pathNodes list of nodes in path from root to selection
 * @private
 */ treemode._updateTreePath = function(pathNodes) {
                    if (pathNodes && pathNodes.length) {
                        (0, util.removeClassName)(this.navBar, 'nav-bar-empty');
                        var pathObjs = [];
                        pathNodes.forEach(function(node) {
                            var pathObj = {
                                name: getName(node),
                                node: node,
                                children: []
                            };
                            if (node.childs && node.childs.length) node.childs.forEach(function(childNode) {
                                pathObj.children.push({
                                    name: getName(childNode),
                                    node: childNode
                                });
                            });
                            pathObjs.push(pathObj);
                        });
                        this.treePath.setPath(pathObjs);
                    } else (0, util.addClassName)(this.navBar, 'nav-bar-empty');
                    function getName(node) {
                        return node.parent ? node.parent.type === 'array' ? node.index : node.field : node.field || node.type;
                    }
                };
                /**
 * Callback for tree path section selection - focus the selected node in the tree
 * @param {Object} pathObj path object that was represents the selected section node
 * @private
 */ treemode._onTreePathSectionSelected = function(pathObj) {
                    if (pathObj && pathObj.node) {
                        pathObj.node.expandTo();
                        pathObj.node.focus();
                    }
                };
                /**
 * Callback for tree path menu item selection - rebuild the path accrding to the new selection and focus the selected node in the tree
 * @param {Object} pathObj path object that was represents the parent section node
 * @param {String} selection selected section child
 * @private
 */ treemode._onTreePathMenuItemSelected = function(pathObj, selection) {
                    if (pathObj && pathObj.children.length) {
                        var selectionObj = pathObj.children.find(function(obj) {
                            return obj.name === selection;
                        });
                        if (selectionObj && selectionObj.node) {
                            this._updateTreePath(selectionObj.node.getNodePath());
                            selectionObj.node.expandTo();
                            selectionObj.node.focus();
                        }
                    }
                };
                treemode._startDragDistance = function(event) {
                    this.dragDistanceEvent = {
                        initialTarget: event.target,
                        initialPageX: event.pageX,
                        initialPageY: event.pageY,
                        dragDistance: 0,
                        hasMoved: false
                    };
                };
                treemode._updateDragDistance = function(event) {
                    if (!this.dragDistanceEvent) this._startDragDistance(event);
                    var diffX = event.pageX - this.dragDistanceEvent.initialPageX;
                    var diffY = event.pageY - this.dragDistanceEvent.initialPageY;
                    this.dragDistanceEvent.dragDistance = Math.sqrt(diffX * diffX + diffY * diffY);
                    this.dragDistanceEvent.hasMoved = this.dragDistanceEvent.hasMoved || this.dragDistanceEvent.dragDistance > 10;
                    event.dragDistance = this.dragDistanceEvent.dragDistance;
                    event.hasMoved = this.dragDistanceEvent.hasMoved;
                    return event.dragDistance;
                };
                /**
 * Start multi selection of nodes by dragging the mouse
 * @param {MouseEvent} event
 * @private
 */ treemode._onMultiSelectStart = function(event) {
                    var node = Node1.getNodeFromTarget(event.target);
                    if (this.options.mode !== 'tree' || this.options.onEditable !== undefined) // dragging not allowed in modes 'view' and 'form'
                    // TODO: allow multiselection of items when option onEditable is specified
                    return;
                    this.multiselection = {
                        start: node || null,
                        end: null,
                        nodes: []
                    };
                    this._startDragDistance(event);
                    var editor = this;
                    if (!this.mousemove) this.mousemove = (0, util.addEventListener)(event.view, 'mousemove', function(event) {
                        editor._onMultiSelect(event);
                    });
                    if (!this.mouseup) this.mouseup = (0, util.addEventListener)(event.view, 'mouseup', function(event) {
                        editor._onMultiSelectEnd(event);
                    });
                    event.preventDefault();
                };
                /**
 * Multiselect nodes by dragging
 * @param {MouseEvent} event
 * @private
 */ treemode._onMultiSelect = function(event) {
                    event.preventDefault();
                    this._updateDragDistance(event);
                    if (!event.hasMoved) return;
                    var node = Node1.getNodeFromTarget(event.target);
                    if (node) {
                        if (this.multiselection.start == null) this.multiselection.start = node;
                        this.multiselection.end = node;
                    }
                    // deselect previous selection
                    this.deselect();
                    // find the selected nodes in the range from first to last
                    var start = this.multiselection.start;
                    var end = this.multiselection.end || this.multiselection.start;
                    if (start && end) {
                        // find the top level childs, all having the same parent
                        this.multiselection.nodes = this._findTopLevelNodes(start, end);
                        if (this.multiselection.nodes && this.multiselection.nodes.length) {
                            var firstNode = this.multiselection.nodes[0];
                            if (this.multiselection.start === firstNode || this.multiselection.start.isDescendantOf(firstNode)) this.multiselection.direction = 'down';
                            else this.multiselection.direction = 'up';
                        }
                        this.select(this.multiselection.nodes);
                    }
                };
                /**
 * End of multiselect nodes by dragging
 * @param {MouseEvent} event
 * @private
 */ treemode._onMultiSelectEnd = function(event) {
                    // set focus to the context menu button of the first node
                    var firstNode = this.multiselection.nodes[0];
                    if (firstNode && firstNode.dom.menu) firstNode.dom.menu.focus();
                    this.multiselection.start = null;
                    this.multiselection.end = null;
                    // cleanup global event listeners
                    if (this.mousemove) {
                        (0, util.removeEventListener)(event.view, 'mousemove', this.mousemove);
                        delete this.mousemove;
                    }
                    if (this.mouseup) {
                        (0, util.removeEventListener)(event.view, 'mouseup', this.mouseup);
                        delete this.mouseup;
                    }
                };
                /**
 * deselect currently selected nodes
 * @param {boolean} [clearStartAndEnd=false]  If true, the `start` and `end`
 *                                            state is cleared too.
 */ treemode.deselect = function(clearStartAndEnd) {
                    var selectionChanged = !!this.multiselection.nodes.length;
                    this.multiselection.nodes.forEach(function(node) {
                        node.setSelected(false);
                    });
                    this.multiselection.nodes = [];
                    if (clearStartAndEnd) {
                        this.multiselection.start = null;
                        this.multiselection.end = null;
                    }
                    if (selectionChanged) {
                        if (this._selectionChangedHandler) this._selectionChangedHandler();
                    }
                };
                /**
 * select nodes
 * @param {Node[] | Node} nodes
 */ treemode.select = function(nodes) {
                    if (!Array.isArray(nodes)) return this.select([
                        nodes
                    ]);
                    if (nodes) {
                        this.deselect();
                        this.multiselection.nodes = nodes.slice(0);
                        var first = nodes[0];
                        nodes.forEach(function(node) {
                            node.expandPathToNode();
                            node.setSelected(true, node === first);
                        });
                        if (this._selectionChangedHandler) {
                            var selection = this.getSelection();
                            this._selectionChangedHandler(selection.start, selection.end);
                        }
                    }
                };
                /**
 * From two arbitrary selected nodes, find their shared parent node.
 * From that parent node, select the two child nodes in the brances going to
 * nodes `start` and `end`, and select all childs in between.
 * @param {Node} start
 * @param {Node} end
 * @return {Array.<Node>} Returns an ordered list with child nodes
 * @private
 */ treemode._findTopLevelNodes = function(start, end) {
                    var startPath = start.getNodePath();
                    var endPath = end.getNodePath();
                    var i = 0;
                    while(i < startPath.length && startPath[i] === endPath[i])i++;
                    var root = startPath[i - 1];
                    var startChild = startPath[i];
                    var endChild = endPath[i];
                    if (!startChild || !endChild) {
                        if (root.parent) {
                            // startChild is a parent of endChild or vice versa
                            startChild = root;
                            endChild = root;
                            root = root.parent;
                        } else {
                            // we have selected the root node (which doesn't have a parent)
                            startChild = root.childs[0];
                            endChild = root.childs[root.childs.length - 1];
                        }
                    }
                    if (root && startChild && endChild) {
                        var startIndex = root.childs.indexOf(startChild);
                        var endIndex = root.childs.indexOf(endChild);
                        var firstIndex = Math.min(startIndex, endIndex);
                        var lastIndex = Math.max(startIndex, endIndex);
                        return root.childs.slice(firstIndex, lastIndex + 1);
                    } else return [];
                };
                /**
 * Show autocomplete menu
 * @param {HTMLElement} element
 * @private
 */ treemode._showAutoComplete = function(element) {
                    var node = Node1.getNodeFromTarget(element);
                    var jsonElementType = '';
                    if (element.className.indexOf('jsoneditor-value') >= 0) jsonElementType = 'value';
                    if (element.className.indexOf('jsoneditor-field') >= 0) jsonElementType = 'field';
                    if (jsonElementType === '') // Unknown element field. Could be a button or something else
                    return;
                    var self1 = this;
                    setTimeout(function() {
                        if (node && (self1.options.autocomplete.trigger === 'focus' || element.innerText.length > 0)) {
                            var result = self1.options.autocomplete.getOptions(element.innerText, node.getPath(), jsonElementType, node.editor);
                            if (result === null) self1.autocomplete.hideDropDown();
                            else if (typeof result.then === 'function') // probably a promise
                            result.then(function(obj) {
                                if (obj === null) self1.autocomplete.hideDropDown();
                                else if (obj.options) self1.autocomplete.show(element, obj.startFrom, obj.options);
                                else self1.autocomplete.show(element, 0, obj);
                            })["catch"](function(err) {
                                console.error(err);
                            });
                            else // definitely not a promise
                            if (result.options) self1.autocomplete.show(element, result.startFrom, result.options);
                            else self1.autocomplete.show(element, 0, result);
                        } else self1.autocomplete.hideDropDown();
                    }, 50);
                };
                /**
 * Event handler for keydown. Handles shortcut keys
 * @param {Event} event
 * @private
 */ treemode._onKeyDown = function(event) {
                    var keynum = event.which || event.keyCode;
                    var altKey = event.altKey;
                    var ctrlKey = event.ctrlKey;
                    var metaKey = event.metaKey;
                    var shiftKey = event.shiftKey;
                    var handled = false;
                    var currentTarget = this.focusTarget;
                    if (keynum === 9) {
                        // Tab or Shift+Tab
                        var me = this;
                        setTimeout(function() {
                            /*
          - Checking for change in focusTarget
          - Without the check,
            pressing tab after reaching the final DOM element in the editor will
            set the focus back to it than passing focus outside the editor
      */ if (me.focusTarget !== currentTarget) // select all text when moving focus to an editable div
                            (0, util.selectContentEditable)(me.focusTarget);
                        }, 0);
                    }
                    if (this.searchBox) {
                        if (ctrlKey && keynum === 70) {
                            // Ctrl+F
                            this.searchBox.dom.search.focus();
                            this.searchBox.dom.search.select();
                            handled = true;
                        } else if (keynum === 114 || ctrlKey && keynum === 71) {
                            // F3 or Ctrl+G
                            var focus = true;
                            if (!shiftKey) // select next search result (F3 or Ctrl+G)
                            this.searchBox.next(focus);
                            else // select previous search result (Shift+F3 or Ctrl+Shift+G)
                            this.searchBox.previous(focus);
                            handled = true;
                        }
                    }
                    if (this.history) {
                        if (ctrlKey && !shiftKey && keynum === 90) {
                            // Ctrl+Z
                            // undo
                            this._onUndo();
                            handled = true;
                        } else if (ctrlKey && shiftKey && keynum === 90) {
                            // Ctrl+Shift+Z
                            // redo
                            this._onRedo();
                            handled = true;
                        }
                    }
                    if (this.options.autocomplete && !handled) {
                        if (!ctrlKey && !altKey && !metaKey && (event.key.length === 1 || keynum === 8 || keynum === 46)) {
                            handled = false;
                            // Activate autocomplete
                            this._showAutoComplete(event.target);
                        }
                    }
                    if (handled) {
                        event.preventDefault();
                        event.stopPropagation();
                    }
                };
                /**
 * Create main table
 * @private
 */ treemode._createTable = function() {
                    if (this.options.navigationBar) (0, util.addClassName)(this.contentOuter, 'has-nav-bar');
                    this.scrollableContent = document.createElement('div');
                    this.scrollableContent.className = 'jsoneditor-tree';
                    this.contentOuter.appendChild(this.scrollableContent);
                    // the jsoneditor-tree-inner div with bottom padding is here to
                    // keep space for the action menu dropdown. It's created as a
                    // separate div instead of using scrollableContent to work around
                    // and issue in the Chrome browser showing scrollable contents outside of the div
                    // see https://github.com/josdejong/jsoneditor/issues/557
                    this.content = document.createElement('div');
                    this.content.className = 'jsoneditor-tree-inner';
                    this.scrollableContent.appendChild(this.content);
                    this.table = document.createElement('table');
                    this.table.className = 'jsoneditor-tree';
                    this.content.appendChild(this.table);
                    // create colgroup where the first two columns don't have a fixed
                    // width, and the edit columns do have a fixed width
                    var col;
                    this.colgroupContent = document.createElement('colgroup');
                    if (this.options.mode === 'tree') {
                        col = document.createElement('col');
                        col.width = '24px';
                        this.colgroupContent.appendChild(col);
                    }
                    col = document.createElement('col');
                    col.width = '24px';
                    this.colgroupContent.appendChild(col);
                    col = document.createElement('col');
                    this.colgroupContent.appendChild(col);
                    this.table.appendChild(this.colgroupContent);
                    this.tbody = document.createElement('tbody');
                    this.table.appendChild(this.tbody);
                    this.frame.appendChild(this.contentOuter);
                };
                /**
 * Show a contextmenu for this node.
 * Used for multiselection
 * @param {HTMLElement} anchor   Anchor element to attach the context menu to.
 * @param {function} [onClose]   Callback method called when the context menu
 *                               is being closed.
 */ treemode.showContextMenu = function(anchor, onClose) {
                    var items = [];
                    var selectedNodes = this.multiselection.nodes.slice();
                    // create duplicate button
                    items.push({
                        text: (0, i18n /* translate */ .Tl)('duplicateText'),
                        title: (0, i18n /* translate */ .Tl)('duplicateTitle'),
                        className: 'jsoneditor-duplicate',
                        click: function click() {
                            Node1.onDuplicate(selectedNodes);
                        }
                    });
                    // create remove button
                    items.push({
                        text: (0, i18n /* translate */ .Tl)('remove'),
                        title: (0, i18n /* translate */ .Tl)('removeTitle'),
                        className: 'jsoneditor-remove',
                        click: function click() {
                            Node1.onRemove(selectedNodes);
                        }
                    });
                    if (this.options.onCreateMenu) {
                        var paths = selectedNodes.map(function(node) {
                            return node.getPath();
                        });
                        items = this.options.onCreateMenu(items, {
                            type: 'multiple',
                            path: paths[0],
                            paths: paths
                        });
                    }
                    var menu = new ContextMenu /* ContextMenu */ .t(items, {
                        close: onClose
                    });
                    menu.show(anchor, this.getPopupAnchor());
                };
                treemode.getPopupAnchor = function() {
                    return this.options.popupAnchor || this.frame;
                };
                /**
 * Get current selected nodes
 * @return {{start:SerializableNode, end: SerializableNode}}
 */ treemode.getSelection = function() {
                    var selection = {
                        start: null,
                        end: null
                    };
                    if (this.multiselection.nodes && this.multiselection.nodes.length) {
                        if (this.multiselection.nodes.length) {
                            var selection1 = this.multiselection.nodes[0];
                            var selection2 = this.multiselection.nodes[this.multiselection.nodes.length - 1];
                            if (this.multiselection.direction === 'down') {
                                selection.start = selection1.serialize();
                                selection.end = selection2.serialize();
                            } else {
                                selection.start = selection2.serialize();
                                selection.end = selection1.serialize();
                            }
                        }
                    }
                    return selection;
                };
                /**
 * Callback registration for selection change
 * @param {selectionCallback} callback
 *
 * @callback selectionCallback
 */ treemode.onSelectionChange = function(callback) {
                    if (typeof callback === 'function') this._selectionChangedHandler = (0, util.debounce)(callback, this.DEBOUNCE_INTERVAL);
                };
                /**
 * Select range of nodes.
 * For selecting single node send only the start parameter
 * For clear the selection do not send any parameter
 * If the nodes are not from the same level the first common parent will be selected
 * @param {{path: Array.<String>}} start object contains the path for selection start
 * @param {{path: Array.<String>}} end object contains the path for selection end
 */ treemode.setSelection = function(start, end) {
                    // check for old usage
                    if (start && start.dom && start.range) {
                        console.warn('setSelection/getSelection usage for text selection is deprecated and should not be used, see documentation for supported selection options');
                        this.setDomSelection(start);
                    }
                    var nodes = this._getNodeInstancesByRange(start, end);
                    nodes.forEach(function(node) {
                        node.expandTo();
                    });
                    this.select(nodes);
                };
                /**
 * Returns a set of Nodes according to a range of selection
 * @param {{path: Array.<String>}} start object contains the path for range start
 * @param {{path: Array.<String>}=} end object contains the path for range end
 * @return {Array.<Node>} Node instances on the given range
 * @private
 */ treemode._getNodeInstancesByRange = function(start, end) {
                    var startNode, endNode;
                    if (start && start.path) {
                        startNode = this.node.findNodeByPath(start.path);
                        if (end && end.path) endNode = this.node.findNodeByPath(end.path);
                    }
                    var nodes = [];
                    if (startNode instanceof Node1) {
                        if (endNode instanceof Node1 && endNode !== startNode) {
                            if (startNode.parent === endNode.parent) {
                                if (startNode.getIndex() < endNode.getIndex()) {
                                    start = startNode;
                                    end = endNode;
                                } else {
                                    start = endNode;
                                    end = startNode;
                                }
                                var current = start;
                                nodes.push(current);
                                do {
                                    current = current.nextSibling();
                                    nodes.push(current);
                                }while (current && current !== end);
                            } else nodes = this._findTopLevelNodes(startNode, endNode);
                        } else nodes.push(startNode);
                    }
                    return nodes;
                };
                treemode.getNodesByRange = function(start, end) {
                    var nodes = this._getNodeInstancesByRange(start, end);
                    var serializableNodes = [];
                    nodes.forEach(function(node) {
                        serializableNodes.push(node.serialize());
                    });
                    return serializableNodes;
                };
                // define modes
                var treeModeMixins = [
                    {
                        mode: 'tree',
                        mixin: treemode,
                        data: 'json'
                    },
                    {
                        mode: 'view',
                        mixin: treemode,
                        data: 'json'
                    },
                    {
                        mode: 'form',
                        mixin: treemode,
                        data: 'json'
                    }
                ];
            /***/ },
            /***/ 660: /***/ function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {
                "use strict";
                /* harmony export */ __webpack_require__.d(__webpack_exports__, {
                    /* harmony export */ Oq: function() {
                        return /* binding */ SIZE_LARGE;
                    },
                    /* harmony export */ SC: function() {
                        return /* binding */ PREVIEW_HISTORY_LIMIT;
                    },
                    /* harmony export */ ai: function() {
                        return /* binding */ DEFAULT_MODAL_ANCHOR;
                    },
                    /* harmony export */ hJ: function() {
                        return /* binding */ MAX_PREVIEW_CHARACTERS;
                    }
                });
                var DEFAULT_MODAL_ANCHOR = document.body;
                var SIZE_LARGE = 10485760; // 10 MB
                var MAX_PREVIEW_CHARACTERS = 20000;
                var PREVIEW_HISTORY_LIMIT = 2147483648; // 2 GB
            /***/ },
            /***/ 736: /***/ function(__unused_webpack_module, exports) {
                /* Jison generated parser */ var jsonlint = function() {
                    var parser = {
                        trace: function trace() {},
                        yy: {},
                        symbols_: {
                            "error": 2,
                            "JSONString": 3,
                            "STRING": 4,
                            "JSONNumber": 5,
                            "NUMBER": 6,
                            "JSONNullLiteral": 7,
                            "NULL": 8,
                            "JSONBooleanLiteral": 9,
                            "TRUE": 10,
                            "FALSE": 11,
                            "JSONText": 12,
                            "JSONValue": 13,
                            "EOF": 14,
                            "JSONObject": 15,
                            "JSONArray": 16,
                            "{": 17,
                            "}": 18,
                            "JSONMemberList": 19,
                            "JSONMember": 20,
                            ":": 21,
                            ",": 22,
                            "[": 23,
                            "]": 24,
                            "JSONElementList": 25,
                            "$accept": 0,
                            "$end": 1
                        },
                        terminals_: {
                            2: "error",
                            4: "STRING",
                            6: "NUMBER",
                            8: "NULL",
                            10: "TRUE",
                            11: "FALSE",
                            14: "EOF",
                            17: "{",
                            18: "}",
                            21: ":",
                            22: ",",
                            23: "[",
                            24: "]"
                        },
                        productions_: [
                            0,
                            [
                                3,
                                1
                            ],
                            [
                                5,
                                1
                            ],
                            [
                                7,
                                1
                            ],
                            [
                                9,
                                1
                            ],
                            [
                                9,
                                1
                            ],
                            [
                                12,
                                2
                            ],
                            [
                                13,
                                1
                            ],
                            [
                                13,
                                1
                            ],
                            [
                                13,
                                1
                            ],
                            [
                                13,
                                1
                            ],
                            [
                                13,
                                1
                            ],
                            [
                                13,
                                1
                            ],
                            [
                                15,
                                2
                            ],
                            [
                                15,
                                3
                            ],
                            [
                                20,
                                3
                            ],
                            [
                                19,
                                1
                            ],
                            [
                                19,
                                3
                            ],
                            [
                                16,
                                2
                            ],
                            [
                                16,
                                3
                            ],
                            [
                                25,
                                1
                            ],
                            [
                                25,
                                3
                            ]
                        ],
                        performAction: function anonymous(yytext, yyleng, yylineno, yy, yystate, $$, _$) {
                            var $0 = $$.length - 1;
                            switch(yystate){
                                case 1:
                                    // replace escaped characters with actual character
                                    this.$ = yytext.replace(/\\(\\|")/g, "$1").replace(/\\n/g, '\n').replace(/\\r/g, '\r').replace(/\\t/g, '\t').replace(/\\v/g, '\v').replace(/\\f/g, '\f').replace(/\\b/g, '\b');
                                    break;
                                case 2:
                                    this.$ = Number(yytext);
                                    break;
                                case 3:
                                    this.$ = null;
                                    break;
                                case 4:
                                    this.$ = true;
                                    break;
                                case 5:
                                    this.$ = false;
                                    break;
                                case 6:
                                    return this.$ = $$[$0 - 1];
                                case 13:
                                    this.$ = {};
                                    break;
                                case 14:
                                    this.$ = $$[$0 - 1];
                                    break;
                                case 15:
                                    this.$ = [
                                        $$[$0 - 2],
                                        $$[$0]
                                    ];
                                    break;
                                case 16:
                                    this.$ = {};
                                    this.$[$$[$0][0]] = $$[$0][1];
                                    break;
                                case 17:
                                    this.$ = $$[$0 - 2];
                                    $$[$0 - 2][$$[$0][0]] = $$[$0][1];
                                    break;
                                case 18:
                                    this.$ = [];
                                    break;
                                case 19:
                                    this.$ = $$[$0 - 1];
                                    break;
                                case 20:
                                    this.$ = [
                                        $$[$0]
                                    ];
                                    break;
                                case 21:
                                    this.$ = $$[$0 - 2];
                                    $$[$0 - 2].push($$[$0]);
                                    break;
                            }
                        },
                        table: [
                            {
                                3: 5,
                                4: [
                                    1,
                                    12
                                ],
                                5: 6,
                                6: [
                                    1,
                                    13
                                ],
                                7: 3,
                                8: [
                                    1,
                                    9
                                ],
                                9: 4,
                                10: [
                                    1,
                                    10
                                ],
                                11: [
                                    1,
                                    11
                                ],
                                12: 1,
                                13: 2,
                                15: 7,
                                16: 8,
                                17: [
                                    1,
                                    14
                                ],
                                23: [
                                    1,
                                    15
                                ]
                            },
                            {
                                1: [
                                    3
                                ]
                            },
                            {
                                14: [
                                    1,
                                    16
                                ]
                            },
                            {
                                14: [
                                    2,
                                    7
                                ],
                                18: [
                                    2,
                                    7
                                ],
                                22: [
                                    2,
                                    7
                                ],
                                24: [
                                    2,
                                    7
                                ]
                            },
                            {
                                14: [
                                    2,
                                    8
                                ],
                                18: [
                                    2,
                                    8
                                ],
                                22: [
                                    2,
                                    8
                                ],
                                24: [
                                    2,
                                    8
                                ]
                            },
                            {
                                14: [
                                    2,
                                    9
                                ],
                                18: [
                                    2,
                                    9
                                ],
                                22: [
                                    2,
                                    9
                                ],
                                24: [
                                    2,
                                    9
                                ]
                            },
                            {
                                14: [
                                    2,
                                    10
                                ],
                                18: [
                                    2,
                                    10
                                ],
                                22: [
                                    2,
                                    10
                                ],
                                24: [
                                    2,
                                    10
                                ]
                            },
                            {
                                14: [
                                    2,
                                    11
                                ],
                                18: [
                                    2,
                                    11
                                ],
                                22: [
                                    2,
                                    11
                                ],
                                24: [
                                    2,
                                    11
                                ]
                            },
                            {
                                14: [
                                    2,
                                    12
                                ],
                                18: [
                                    2,
                                    12
                                ],
                                22: [
                                    2,
                                    12
                                ],
                                24: [
                                    2,
                                    12
                                ]
                            },
                            {
                                14: [
                                    2,
                                    3
                                ],
                                18: [
                                    2,
                                    3
                                ],
                                22: [
                                    2,
                                    3
                                ],
                                24: [
                                    2,
                                    3
                                ]
                            },
                            {
                                14: [
                                    2,
                                    4
                                ],
                                18: [
                                    2,
                                    4
                                ],
                                22: [
                                    2,
                                    4
                                ],
                                24: [
                                    2,
                                    4
                                ]
                            },
                            {
                                14: [
                                    2,
                                    5
                                ],
                                18: [
                                    2,
                                    5
                                ],
                                22: [
                                    2,
                                    5
                                ],
                                24: [
                                    2,
                                    5
                                ]
                            },
                            {
                                14: [
                                    2,
                                    1
                                ],
                                18: [
                                    2,
                                    1
                                ],
                                21: [
                                    2,
                                    1
                                ],
                                22: [
                                    2,
                                    1
                                ],
                                24: [
                                    2,
                                    1
                                ]
                            },
                            {
                                14: [
                                    2,
                                    2
                                ],
                                18: [
                                    2,
                                    2
                                ],
                                22: [
                                    2,
                                    2
                                ],
                                24: [
                                    2,
                                    2
                                ]
                            },
                            {
                                3: 20,
                                4: [
                                    1,
                                    12
                                ],
                                18: [
                                    1,
                                    17
                                ],
                                19: 18,
                                20: 19
                            },
                            {
                                3: 5,
                                4: [
                                    1,
                                    12
                                ],
                                5: 6,
                                6: [
                                    1,
                                    13
                                ],
                                7: 3,
                                8: [
                                    1,
                                    9
                                ],
                                9: 4,
                                10: [
                                    1,
                                    10
                                ],
                                11: [
                                    1,
                                    11
                                ],
                                13: 23,
                                15: 7,
                                16: 8,
                                17: [
                                    1,
                                    14
                                ],
                                23: [
                                    1,
                                    15
                                ],
                                24: [
                                    1,
                                    21
                                ],
                                25: 22
                            },
                            {
                                1: [
                                    2,
                                    6
                                ]
                            },
                            {
                                14: [
                                    2,
                                    13
                                ],
                                18: [
                                    2,
                                    13
                                ],
                                22: [
                                    2,
                                    13
                                ],
                                24: [
                                    2,
                                    13
                                ]
                            },
                            {
                                18: [
                                    1,
                                    24
                                ],
                                22: [
                                    1,
                                    25
                                ]
                            },
                            {
                                18: [
                                    2,
                                    16
                                ],
                                22: [
                                    2,
                                    16
                                ]
                            },
                            {
                                21: [
                                    1,
                                    26
                                ]
                            },
                            {
                                14: [
                                    2,
                                    18
                                ],
                                18: [
                                    2,
                                    18
                                ],
                                22: [
                                    2,
                                    18
                                ],
                                24: [
                                    2,
                                    18
                                ]
                            },
                            {
                                22: [
                                    1,
                                    28
                                ],
                                24: [
                                    1,
                                    27
                                ]
                            },
                            {
                                22: [
                                    2,
                                    20
                                ],
                                24: [
                                    2,
                                    20
                                ]
                            },
                            {
                                14: [
                                    2,
                                    14
                                ],
                                18: [
                                    2,
                                    14
                                ],
                                22: [
                                    2,
                                    14
                                ],
                                24: [
                                    2,
                                    14
                                ]
                            },
                            {
                                3: 20,
                                4: [
                                    1,
                                    12
                                ],
                                20: 29
                            },
                            {
                                3: 5,
                                4: [
                                    1,
                                    12
                                ],
                                5: 6,
                                6: [
                                    1,
                                    13
                                ],
                                7: 3,
                                8: [
                                    1,
                                    9
                                ],
                                9: 4,
                                10: [
                                    1,
                                    10
                                ],
                                11: [
                                    1,
                                    11
                                ],
                                13: 30,
                                15: 7,
                                16: 8,
                                17: [
                                    1,
                                    14
                                ],
                                23: [
                                    1,
                                    15
                                ]
                            },
                            {
                                14: [
                                    2,
                                    19
                                ],
                                18: [
                                    2,
                                    19
                                ],
                                22: [
                                    2,
                                    19
                                ],
                                24: [
                                    2,
                                    19
                                ]
                            },
                            {
                                3: 5,
                                4: [
                                    1,
                                    12
                                ],
                                5: 6,
                                6: [
                                    1,
                                    13
                                ],
                                7: 3,
                                8: [
                                    1,
                                    9
                                ],
                                9: 4,
                                10: [
                                    1,
                                    10
                                ],
                                11: [
                                    1,
                                    11
                                ],
                                13: 31,
                                15: 7,
                                16: 8,
                                17: [
                                    1,
                                    14
                                ],
                                23: [
                                    1,
                                    15
                                ]
                            },
                            {
                                18: [
                                    2,
                                    17
                                ],
                                22: [
                                    2,
                                    17
                                ]
                            },
                            {
                                18: [
                                    2,
                                    15
                                ],
                                22: [
                                    2,
                                    15
                                ]
                            },
                            {
                                22: [
                                    2,
                                    21
                                ],
                                24: [
                                    2,
                                    21
                                ]
                            }
                        ],
                        defaultActions: {
                            16: [
                                2,
                                6
                            ]
                        },
                        parseError: function parseError(str, hash) {
                            throw new Error(str);
                        },
                        parse: function parse(input) {
                            var self1 = this, stack = [
                                0
                            ], vstack = [
                                null
                            ], // semantic value stack
                            lstack = [], // location stack
                            table = this.table, yytext = '', yylineno = 0, yyleng = 0, recovering = 0, TERROR = 2, EOF = 1;
                            //this.reductionCount = this.shiftCount = 0;
                            this.lexer.setInput(input);
                            this.lexer.yy = this.yy;
                            this.yy.lexer = this.lexer;
                            if (typeof this.lexer.yylloc == 'undefined') this.lexer.yylloc = {};
                            var yyloc = this.lexer.yylloc;
                            lstack.push(yyloc);
                            if (typeof this.yy.parseError === 'function') this.parseError = this.yy.parseError;
                            function popStack(n) {
                                stack.length = stack.length - 2 * n;
                                vstack.length = vstack.length - n;
                                lstack.length = lstack.length - n;
                            }
                            function lex() {
                                var token;
                                token = self1.lexer.lex() || 1; // $end = 1
                                // if token isn't its numeric value, convert
                                if (typeof token !== 'number') token = self1.symbols_[token] || token;
                                return token;
                            }
                            var symbol, preErrorSymbol, state, action, a, r, yyval = {}, p, len, newState, expected;
                            while(true){
                                // retreive state number from top of stack
                                state = stack[stack.length - 1];
                                // use default actions if available
                                if (this.defaultActions[state]) action = this.defaultActions[state];
                                else {
                                    if (symbol == null) symbol = lex();
                                    // read action for current state and first input
                                    action = table[state] && table[state][symbol];
                                }
                                // handle parse error
                                _handle_error: if (typeof action === 'undefined' || !action.length || !action[0]) {
                                    if (!recovering) {
                                        // Report error
                                        expected = [];
                                        for(p in table[state])if (this.terminals_[p] && p > 2) expected.push("'" + this.terminals_[p] + "'");
                                        var errStr = '';
                                        if (this.lexer.showPosition) errStr = 'Parse error on line ' + (yylineno + 1) + ":\n" + this.lexer.showPosition() + "\nExpecting " + expected.join(', ') + ", got '" + this.terminals_[symbol] + "'";
                                        else errStr = 'Parse error on line ' + (yylineno + 1) + ": Unexpected " + (symbol == 1 /*EOF*/  ? "end of input" : "'" + (this.terminals_[symbol] || symbol) + "'");
                                        this.parseError(errStr, {
                                            text: this.lexer.match,
                                            token: this.terminals_[symbol] || symbol,
                                            line: this.lexer.yylineno,
                                            loc: yyloc,
                                            expected: expected
                                        });
                                    }
                                    // just recovered from another error
                                    if (recovering == 3) {
                                        if (symbol == EOF) throw new Error(errStr || 'Parsing halted.');
                                        // discard current lookahead and grab another
                                        yyleng = this.lexer.yyleng;
                                        yytext = this.lexer.yytext;
                                        yylineno = this.lexer.yylineno;
                                        yyloc = this.lexer.yylloc;
                                        symbol = lex();
                                    }
                                    // try to recover from error
                                    while(true){
                                        // check for error recovery rule in this state
                                        if (TERROR.toString() in table[state]) break;
                                        if (state == 0) throw new Error(errStr || 'Parsing halted.');
                                        popStack(1);
                                        state = stack[stack.length - 1];
                                    }
                                    preErrorSymbol = symbol; // save the lookahead token
                                    symbol = TERROR; // insert generic error symbol as new lookahead
                                    state = stack[stack.length - 1];
                                    action = table[state] && table[state][TERROR];
                                    recovering = 3; // allow 3 real symbols to be shifted before reporting a new error
                                }
                                // this shouldn't happen, unless resolve defaults are off
                                if (action[0] instanceof Array && action.length > 1) throw new Error('Parse Error: multiple actions possible at state: ' + state + ', token: ' + symbol);
                                switch(action[0]){
                                    case 1:
                                        // shift
                                        //this.shiftCount++;
                                        stack.push(symbol);
                                        vstack.push(this.lexer.yytext);
                                        lstack.push(this.lexer.yylloc);
                                        stack.push(action[1]); // push state
                                        symbol = null;
                                        if (!preErrorSymbol) {
                                            // normal execution/no error
                                            yyleng = this.lexer.yyleng;
                                            yytext = this.lexer.yytext;
                                            yylineno = this.lexer.yylineno;
                                            yyloc = this.lexer.yylloc;
                                            if (recovering > 0) recovering--;
                                        } else {
                                            // error just occurred, resume old lookahead f/ before error
                                            symbol = preErrorSymbol;
                                            preErrorSymbol = null;
                                        }
                                        break;
                                    case 2:
                                        // reduce
                                        //this.reductionCount++;
                                        len = this.productions_[action[1]][1];
                                        // perform semantic action
                                        yyval.$ = vstack[vstack.length - len]; // default to $$ = $1
                                        // default location, uses first token for firsts, last for lasts
                                        yyval._$ = {
                                            first_line: lstack[lstack.length - (len || 1)].first_line,
                                            last_line: lstack[lstack.length - 1].last_line,
                                            first_column: lstack[lstack.length - (len || 1)].first_column,
                                            last_column: lstack[lstack.length - 1].last_column
                                        };
                                        r = this.performAction.call(yyval, yytext, yyleng, yylineno, this.yy, action[1], vstack, lstack);
                                        if (typeof r !== 'undefined') return r;
                                        // pop off stack
                                        if (len) {
                                            stack = stack.slice(0, -1 * len * 2);
                                            vstack = vstack.slice(0, -1 * len);
                                            lstack = lstack.slice(0, -1 * len);
                                        }
                                        stack.push(this.productions_[action[1]][0]); // push nonterminal (reduce)
                                        vstack.push(yyval.$);
                                        lstack.push(yyval._$);
                                        // goto new state = table[STATE][NONTERMINAL]
                                        newState = table[stack[stack.length - 2]][stack[stack.length - 1]];
                                        stack.push(newState);
                                        break;
                                    case 3:
                                        // accept
                                        return true;
                                }
                            }
                            return true;
                        }
                    };
                    /* Jison generated lexer */ var lexer = function() {
                        var lexer = {
                            EOF: 1,
                            parseError: function parseError(str, hash) {
                                if (this.yy.parseError) this.yy.parseError(str, hash);
                                else throw new Error(str);
                            },
                            setInput: function setInput(input) {
                                this._input = input;
                                this._more = this._less = this.done = false;
                                this.yylineno = this.yyleng = 0;
                                this.yytext = this.matched = this.match = '';
                                this.conditionStack = [
                                    'INITIAL'
                                ];
                                this.yylloc = {
                                    first_line: 1,
                                    first_column: 0,
                                    last_line: 1,
                                    last_column: 0
                                };
                                return this;
                            },
                            input: function input() {
                                var ch = this._input[0];
                                this.yytext += ch;
                                this.yyleng++;
                                this.match += ch;
                                this.matched += ch;
                                var lines = ch.match(/\n/);
                                if (lines) this.yylineno++;
                                this._input = this._input.slice(1);
                                return ch;
                            },
                            unput: function unput(ch) {
                                this._input = ch + this._input;
                                return this;
                            },
                            more: function more() {
                                this._more = true;
                                return this;
                            },
                            less: function less(n) {
                                this._input = this.match.slice(n) + this._input;
                            },
                            pastInput: function pastInput() {
                                var past = this.matched.substr(0, this.matched.length - this.match.length);
                                return (past.length > 20 ? '...' : '') + past.substr(-20).replace(/\n/g, "");
                            },
                            upcomingInput: function upcomingInput() {
                                var next = this.match;
                                if (next.length < 20) next += this._input.substr(0, 20 - next.length);
                                return (next.substr(0, 20) + (next.length > 20 ? '...' : '')).replace(/\n/g, "");
                            },
                            showPosition: function showPosition() {
                                var pre = this.pastInput();
                                var c = new Array(pre.length + 1).join("-");
                                return pre + this.upcomingInput() + "\n" + c + "^";
                            },
                            next: function next() {
                                if (this.done) return this.EOF;
                                if (!this._input) this.done = true;
                                var token, match, tempMatch, index, col, lines;
                                if (!this._more) {
                                    this.yytext = '';
                                    this.match = '';
                                }
                                var rules = this._currentRules();
                                for(var i = 0; i < rules.length; i++){
                                    tempMatch = this._input.match(this.rules[rules[i]]);
                                    if (tempMatch && (!match || tempMatch[0].length > match[0].length)) {
                                        match = tempMatch;
                                        index = i;
                                        if (!this.options.flex) break;
                                    }
                                }
                                if (match) {
                                    lines = match[0].match(/\n.*/g);
                                    if (lines) this.yylineno += lines.length;
                                    this.yylloc = {
                                        first_line: this.yylloc.last_line,
                                        last_line: this.yylineno + 1,
                                        first_column: this.yylloc.last_column,
                                        last_column: lines ? lines[lines.length - 1].length - 1 : this.yylloc.last_column + match[0].length
                                    };
                                    this.yytext += match[0];
                                    this.match += match[0];
                                    this.yyleng = this.yytext.length;
                                    this._more = false;
                                    this._input = this._input.slice(match[0].length);
                                    this.matched += match[0];
                                    token = this.performAction.call(this, this.yy, this, rules[index], this.conditionStack[this.conditionStack.length - 1]);
                                    if (this.done && this._input) this.done = false;
                                    if (token) return token;
                                    else return;
                                }
                                if (this._input === "") return this.EOF;
                                else this.parseError('Lexical error on line ' + (this.yylineno + 1) + '. Unrecognized text.\n' + this.showPosition(), {
                                    text: "",
                                    token: null,
                                    line: this.yylineno
                                });
                            },
                            lex: function lex() {
                                var r = this.next();
                                if (typeof r !== 'undefined') return r;
                                else return this.lex();
                            },
                            begin: function begin(condition) {
                                this.conditionStack.push(condition);
                            },
                            popState: function popState() {
                                return this.conditionStack.pop();
                            },
                            _currentRules: function _currentRules() {
                                return this.conditions[this.conditionStack[this.conditionStack.length - 1]].rules;
                            },
                            topState: function topState() {
                                return this.conditionStack[this.conditionStack.length - 2];
                            },
                            pushState: function begin(condition) {
                                this.begin(condition);
                            }
                        };
                        lexer.options = {};
                        lexer.performAction = function anonymous(yy, yy_, $avoiding_name_collisions, YY_START) {
                            var YYSTATE = YY_START;
                            switch($avoiding_name_collisions){
                                case 0:
                                    break;
                                case 1:
                                    return 6;
                                case 2:
                                    yy_.yytext = yy_.yytext.substr(1, yy_.yyleng - 2);
                                    return 4;
                                case 3:
                                    return 17;
                                case 4:
                                    return 18;
                                case 5:
                                    return 23;
                                case 6:
                                    return 24;
                                case 7:
                                    return 22;
                                case 8:
                                    return 21;
                                case 9:
                                    return 10;
                                case 10:
                                    return 11;
                                case 11:
                                    return 8;
                                case 12:
                                    return 14;
                                case 13:
                                    return 'INVALID';
                            }
                        };
                        lexer.rules = [
                            /^(?:\s+)/,
                            /^(?:(-?([0-9]|[1-9][0-9]+))(\.[0-9]+)?([eE][-+]?[0-9]+)?\b)/,
                            /^(?:"(?:\\[\\"bfnrt/]|\\u[a-fA-F0-9]{4}|[^\\\0-\x09\x0a-\x1f"])*")/,
                            /^(?:\{)/,
                            /^(?:\})/,
                            /^(?:\[)/,
                            /^(?:\])/,
                            /^(?:,)/,
                            /^(?::)/,
                            /^(?:true\b)/,
                            /^(?:false\b)/,
                            /^(?:null\b)/,
                            /^(?:$)/,
                            /^(?:.)/
                        ];
                        lexer.conditions = {
                            "INITIAL": {
                                "rules": [
                                    0,
                                    1,
                                    2,
                                    3,
                                    4,
                                    5,
                                    6,
                                    7,
                                    8,
                                    9,
                                    10,
                                    11,
                                    12,
                                    13
                                ],
                                "inclusive": true
                            }
                        };
                        return lexer;
                    }();
                    parser.lexer = lexer;
                    return parser;
                }();
                exports.parser = jsonlint;
                exports.parse = jsonlint.parse.bind(jsonlint);
            /***/ },
            /***/ 746: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                var VanillaPicker;
                if (window.Picker) // use the already loaded instance of VanillaPicker
                VanillaPicker = window.Picker;
                else try {
                    // load color picker
                    VanillaPicker = __webpack_require__(Object(function webpackMissingModule() {
                        var e = new Error("Cannot find module 'vanilla-picker'");
                        e.code = 'MODULE_NOT_FOUND';
                        throw e;
                    }()));
                } catch (err) {
                // probably running the minimalist bundle
                }
                module1.exports = VanillaPicker;
            /***/ },
            /***/ 762: /***/ function() {
                /* ***** BEGIN LICENSE BLOCK *****
 * Distributed under the BSD license:
 *
 * Copyright (c) 2010, Ajax.org B.V.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, are permitted provided that the following conditions are met:
 *     * Redistributions of source code must retain the above copyright
 *       notice, this list of conditions and the following disclaimer.
 *     * Redistributions in binary form must reproduce the above copyright
 *       notice, this list of conditions and the following disclaimer in the
 *       documentation and/or other materials provided with the distribution.
 *     * Neither the name of Ajax.org B.V. nor the
 *       names of its contributors may be used to endorse or promote products
 *       derived from this software without specific prior written permission.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND
 * ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 * WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
 * DISCLAIMED. IN NO EVENT SHALL AJAX.ORG B.V. BE LIABLE FOR ANY
 * DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
 * (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES;
 * LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND
 * ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
 * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
 * SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 *
 * ***** END LICENSE BLOCK ***** */ window.ace.define('ace/theme/jsoneditor', [
                    'require',
                    'exports',
                    'module',
                    'ace/lib/dom'
                ], function(acequire, exports, module1) {
                    exports.isDark = false;
                    exports.cssClass = 'ace-jsoneditor';
                    exports.cssText = ".ace-jsoneditor .ace_gutter {\nbackground: #ebebeb;\ncolor: #333\n}\n\n.ace-jsoneditor.ace_editor {\nline-height: 1.3;\nbackground-color: #fff;\n}\n.ace-jsoneditor .ace_print-margin {\nwidth: 1px;\nbackground: #e8e8e8\n}\n.ace-jsoneditor .ace_scroller {\nbackground-color: #FFFFFF\n}\n.ace-jsoneditor .ace_text-layer {\ncolor: gray\n}\n.ace-jsoneditor .ace_variable {\ncolor: #1a1a1a\n}\n.ace-jsoneditor .ace_cursor {\nborder-left: 2px solid #000000\n}\n.ace-jsoneditor .ace_overwrite-cursors .ace_cursor {\nborder-left: 0px;\nborder-bottom: 1px solid #000000\n}\n.ace-jsoneditor .ace_marker-layer .ace_selection {\nbackground: lightgray\n}\n.ace-jsoneditor.ace_multiselect .ace_selection.ace_start {\nbox-shadow: 0 0 3px 0px #FFFFFF;\nborder-radius: 2px\n}\n.ace-jsoneditor .ace_marker-layer .ace_step {\nbackground: rgb(255, 255, 0)\n}\n.ace-jsoneditor .ace_marker-layer .ace_bracket {\nmargin: -1px 0 0 -1px;\nborder: 1px solid #BFBFBF\n}\n.ace-jsoneditor .ace_marker-layer .ace_active-line {\nbackground: #FFFBD1\n}\n.ace-jsoneditor .ace_gutter-active-line {\nbackground-color : #dcdcdc\n}\n.ace-jsoneditor .ace_marker-layer .ace_selected-word {\nborder: 1px solid lightgray\n}\n.ace-jsoneditor .ace_invisible {\ncolor: #BFBFBF\n}\n.ace-jsoneditor .ace_keyword,\n.ace-jsoneditor .ace_meta,\n.ace-jsoneditor .ace_support.ace_constant.ace_property-value {\ncolor: #AF956F\n}\n.ace-jsoneditor .ace_keyword.ace_operator {\ncolor: #484848\n}\n.ace-jsoneditor .ace_keyword.ace_other.ace_unit {\ncolor: #96DC5F\n}\n.ace-jsoneditor .ace_constant.ace_language {\ncolor: darkorange\n}\n.ace-jsoneditor .ace_constant.ace_numeric {\ncolor: red\n}\n.ace-jsoneditor .ace_constant.ace_character.ace_entity {\ncolor: #BF78CC\n}\n.ace-jsoneditor .ace_invalid {\ncolor: #FFFFFF;\nbackground-color: #FF002A;\n}\n.ace-jsoneditor .ace_fold {\nbackground-color: #AF956F;\nborder-color: #000000\n}\n.ace-jsoneditor .ace_storage,\n.ace-jsoneditor .ace_support.ace_class,\n.ace-jsoneditor .ace_support.ace_function,\n.ace-jsoneditor .ace_support.ace_other,\n.ace-jsoneditor .ace_support.ace_type {\ncolor: #C52727\n}\n.ace-jsoneditor .ace_string {\ncolor: green\n}\n.ace-jsoneditor .ace_comment {\ncolor: #BCC8BA\n}\n.ace-jsoneditor .ace_entity.ace_name.ace_tag,\n.ace-jsoneditor .ace_entity.ace_other.ace_attribute-name {\ncolor: #606060\n}\n.ace-jsoneditor .ace_markup.ace_underline {\ntext-decoration: underline\n}\n.ace-jsoneditor .ace_indent-guide {\nbackground: url(\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAACCAYAAACZgbYnAAAAE0lEQVQImWP4////f4bLly//BwAmVgd1/w11/gAAAABJRU5ErkJggg==\") right repeat-y\n}";
                    var dom = acequire('../lib/dom');
                    dom.importCssString(exports.cssText, exports.cssClass);
                });
            /***/ },
            /***/ 772: /***/ function(module1) {
                "use strict";
                /*!
 * Selectr 2.4.13
 * http://mobius.ovh/docs/selectr
 *
 * Released under the MIT license
 */ /**
 * Event Emitter
 */ var Events = function Events() {};
                /**
 * Event Prototype
 * @type {Object}
 */ Events.prototype = {
                    /**
   * Add custom event listener
   * @param  {String} event Event type
   * @param  {Function} func   Callback
   * @return {Void}
   */ on: function on(event, func) {
                        this._events = this._events || {};
                        this._events[event] = this._events[event] || [];
                        this._events[event].push(func);
                    },
                    /**
   * Remove custom event listener
   * @param  {String} event Event type
   * @param  {Function} func   Callback
   * @return {Void}
   */ off: function off(event, func) {
                        this._events = this._events || {};
                        if (event in this._events === false) return;
                        this._events[event].splice(this._events[event].indexOf(func), 1);
                    },
                    /**
   * Fire a custom event
   * @param  {String} event Event type
   * @return {Void}
   */ emit: function emit(event /* , args... */ ) {
                        this._events = this._events || {};
                        if (event in this._events === false) return;
                        for(var i = 0; i < this._events[event].length; i++)this._events[event][i].apply(this, Array.prototype.slice.call(arguments, 1));
                    }
                };
                /**
 * Event mixin
 * @param  {Object} obj
 * @return {Object}
 */ Events.mixin = function(obj) {
                    var props = [
                        'on',
                        'off',
                        'emit'
                    ];
                    for(var i = 0; i < props.length; i++)if (typeof obj === 'function') obj.prototype[props[i]] = Events.prototype[props[i]];
                    else obj[props[i]] = Events.prototype[props[i]];
                    return obj;
                };
                /**
 * Helpers
 * @type {Object}
 */ var util = {
                    escapeRegExp: function escapeRegExp(str) {
                        // source from lodash 3.0.0
                        var _reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
                        var _reHasRegExpChar = new RegExp(_reRegExpChar.source);
                        return str && _reHasRegExpChar.test(str) ? str.replace(_reRegExpChar, '\\$&') : str;
                    },
                    extend: function extend(src, props) {
                        for(var prop in props)if (props.hasOwnProperty(prop)) {
                            var val = props[prop];
                            if (val && Object.prototype.toString.call(val) === "[object Object]") {
                                src[prop] = src[prop] || {};
                                util.extend(src[prop], val);
                            } else src[prop] = val;
                        }
                        return src;
                    },
                    each: function each(a, b, c) {
                        if ("[object Object]" === Object.prototype.toString.call(a)) {
                            for(var d in a)if (Object.prototype.hasOwnProperty.call(a, d)) b.call(c, d, a[d], a);
                        } else for(var e = 0, f = a.length; e < f; e++)b.call(c, e, a[e], a);
                    },
                    createElement: function createElement(e, a) {
                        var d = document, el = d.createElement(e);
                        if (a && "[object Object]" === Object.prototype.toString.call(a)) {
                            var i;
                            for(i in a)if (i in el) el[i] = a[i];
                            else if ("html" === i) el.innerHTML = a[i];
                            else el.setAttribute(i, a[i]);
                        }
                        return el;
                    },
                    hasClass: function hasClass(a, b) {
                        if (a) return a.classList ? a.classList.contains(b) : !!a.className && !!a.className.match(new RegExp("(\\s|^)" + b + "(\\s|$)"));
                    },
                    addClass: function addClass(a, b) {
                        if (!util.hasClass(a, b)) {
                            if (a.classList) a.classList.add(b);
                            else a.className = a.className.trim() + " " + b;
                        }
                    },
                    removeClass: function removeClass(a, b) {
                        if (util.hasClass(a, b)) {
                            if (a.classList) a.classList.remove(b);
                            else a.className = a.className.replace(new RegExp("(^|\\s)" + b.split(" ").join("|") + "(\\s|$)", "gi"), " ");
                        }
                    },
                    closest: function closest(el, fn) {
                        return el && el !== document.body && (fn(el) ? el : util.closest(el.parentNode, fn));
                    },
                    isInt: function isInt(val) {
                        return typeof val === 'number' && isFinite(val) && Math.floor(val) === val;
                    },
                    debounce: function debounce(a, b, c) {
                        var d;
                        return function() {
                            var e = this, f = arguments, g = function g() {
                                d = null;
                                if (!c) a.apply(e, f);
                            }, h = c && !d;
                            clearTimeout(d);
                            d = setTimeout(g, b);
                            if (h) a.apply(e, f);
                        };
                    },
                    rect: function rect(el, abs) {
                        var w = window;
                        var r = el.getBoundingClientRect();
                        var x = abs ? w.pageXOffset : 0;
                        var y = abs ? w.pageYOffset : 0;
                        return {
                            bottom: r.bottom + y,
                            height: r.height,
                            left: r.left + x,
                            right: r.right + x,
                            top: r.top + y,
                            width: r.width
                        };
                    },
                    includes: function includes(a, b) {
                        return a.indexOf(b) > -1;
                    },
                    startsWith: function startsWith(a, b) {
                        return a.substr(0, b.length) === b;
                    },
                    truncate: function truncate(el) {
                        while(el.firstChild)el.removeChild(el.firstChild);
                    }
                };
                function isset(obj, prop) {
                    return obj.hasOwnProperty(prop) && (obj[prop] === true || obj[prop].length);
                }
                /**
 * Append an item to the list
 * @param  {Object} item
 * @param  {Object} custom
 * @return {Void}
 */ function appendItem(item, parent, custom) {
                    if (item.parentNode) {
                        if (!item.parentNode.parentNode) parent.appendChild(item.parentNode);
                    } else parent.appendChild(item);
                    util.removeClass(item, "excluded");
                    if (!custom) // remove any <span> highlighting, without xss
                    item.textContent = item.textContent;
                }
                /**
 * Render the item list
 * @return {Void}
 */ var render = function render() {
                    if (this.items.length) {
                        var f = document.createDocumentFragment();
                        if (this.config.pagination) {
                            var pages = this.pages.slice(0, this.pageIndex);
                            util.each(pages, function(i, items) {
                                util.each(items, function(j, item) {
                                    appendItem(item, f, this.customOption);
                                }, this);
                            }, this);
                        } else util.each(this.items, function(i, item) {
                            appendItem(item, f, this.customOption);
                        }, this);
                        // highlight first selected option if any; first option otherwise
                        if (f.childElementCount) {
                            util.removeClass(this.items[this.navIndex], "active");
                            this.navIndex = (f.querySelector(".selectr-option.selected") || f.querySelector(".selectr-option")).idx;
                            util.addClass(this.items[this.navIndex], "active");
                        }
                        this.tree.appendChild(f);
                    }
                };
                /**
 * Dismiss / close the dropdown
 * @param  {obj} e
 * @return {void}
 */ var dismiss = function dismiss(e) {
                    var target = e.target;
                    if (!this.container.contains(target) && (this.opened || util.hasClass(this.container, "notice"))) this.close();
                };
                /**
 * Build a list item from the HTMLOptionElement
 * @param  {int} i      HTMLOptionElement index
 * @param  {HTMLOptionElement} option
 * @param  {bool} group  Has parent optgroup
 * @return {void}
 */ var createItem = function createItem(option, data) {
                    data = data || option;
                    var elementData = {
                        "class": "selectr-option",
                        role: "treeitem",
                        "aria-selected": false
                    };
                    if (this.customOption) elementData.html = this.config.renderOption(data); // asume xss prevention in custom render function
                    else elementData.textContent = option.textContent; // treat all as plain text
                    var opt = util.createElement("li", elementData);
                    opt.idx = option.idx;
                    this.items.push(opt);
                    if (option.defaultSelected) this.defaultSelected.push(option.idx);
                    if (option.disabled) {
                        opt.disabled = true;
                        util.addClass(opt, "disabled");
                    }
                    return opt;
                };
                /**
 * Build the container
 * @return {Void}
 */ var build = function build() {
                    this.requiresPagination = this.config.pagination && this.config.pagination > 0;
                    // Set width
                    if (isset(this.config, "width")) {
                        if (util.isInt(this.config.width)) this.width = this.config.width + "px";
                        else {
                            if (this.config.width === "auto") this.width = "100%";
                            else if (util.includes(this.config.width, "%")) this.width = this.config.width;
                        }
                    }
                    this.container = util.createElement("div", {
                        "class": "selectr-container"
                    });
                    // Custom className
                    if (this.config.customClass) util.addClass(this.container, this.config.customClass);
                    // Mobile device
                    if (this.mobileDevice) util.addClass(this.container, "selectr-mobile");
                    else util.addClass(this.container, "selectr-desktop");
                    // Hide the HTMLSelectElement and prevent focus
                    this.el.tabIndex = -1;
                    // Native dropdown
                    if (this.config.nativeDropdown || this.mobileDevice) util.addClass(this.el, "selectr-visible");
                    else util.addClass(this.el, "selectr-hidden");
                    this.selected = util.createElement("div", {
                        "class": "selectr-selected",
                        disabled: this.disabled,
                        tabIndex: 0,
                        "aria-expanded": false
                    });
                    this.label = util.createElement(this.el.multiple ? "ul" : "span", {
                        "class": "selectr-label"
                    });
                    var dropdown = util.createElement("div", {
                        "class": "selectr-options-container"
                    });
                    this.tree = util.createElement("ul", {
                        "class": "selectr-options",
                        role: "tree",
                        "aria-hidden": true,
                        "aria-expanded": false
                    });
                    this.notice = util.createElement("div", {
                        "class": "selectr-notice"
                    });
                    this.el.setAttribute("aria-hidden", true);
                    if (this.disabled) this.el.disabled = true;
                    if (this.el.multiple) {
                        util.addClass(this.label, "selectr-tags");
                        util.addClass(this.container, "multiple");
                        // Collection of tags
                        this.tags = [];
                        // Collection of selected values
                        // #93 defaultSelected = false did not work as expected
                        this.selectedValues = this.config.defaultSelected ? this.getSelectedProperties('value') : [];
                        // Collection of selected indexes
                        this.selectedIndexes = this.getSelectedProperties('idx');
                    } else {
                        // #93 defaultSelected = false did not work as expected
                        // these values were undefined
                        this.selectedValue = null;
                        this.selectedIndex = -1;
                    }
                    this.selected.appendChild(this.label);
                    if (this.config.clearable) {
                        this.selectClear = util.createElement("button", {
                            "class": "selectr-clear",
                            type: "button"
                        });
                        this.container.appendChild(this.selectClear);
                        util.addClass(this.container, "clearable");
                    }
                    if (this.config.taggable) {
                        var li = util.createElement('li', {
                            "class": 'input-tag'
                        });
                        this.input = util.createElement("input", {
                            "class": "selectr-tag-input",
                            placeholder: this.config.tagPlaceholder,
                            tagIndex: 0,
                            autocomplete: "off",
                            autocorrect: "off",
                            autocapitalize: "off",
                            spellcheck: "false",
                            role: "textbox",
                            type: "search"
                        });
                        li.appendChild(this.input);
                        this.label.appendChild(li);
                        util.addClass(this.container, "taggable");
                        this.tagSeperators = [
                            ","
                        ];
                        if (this.config.tagSeperators) {
                            this.tagSeperators = this.tagSeperators.concat(this.config.tagSeperators);
                            var _aTempEscapedSeperators = [];
                            for(var _nTagSeperatorStepCount = 0; _nTagSeperatorStepCount < this.tagSeperators.length; _nTagSeperatorStepCount++)_aTempEscapedSeperators.push(util.escapeRegExp(this.tagSeperators[_nTagSeperatorStepCount]));
                            this.tagSeperatorsRegex = new RegExp(_aTempEscapedSeperators.join('|'), 'i');
                        } else this.tagSeperatorsRegex = new RegExp(',', 'i');
                    }
                    if (this.config.searchable) {
                        this.input = util.createElement("input", {
                            "class": "selectr-input",
                            tagIndex: -1,
                            autocomplete: "off",
                            autocorrect: "off",
                            autocapitalize: "off",
                            spellcheck: "false",
                            role: "textbox",
                            type: "search",
                            placeholder: this.config.messages.searchPlaceholder
                        });
                        this.inputClear = util.createElement("button", {
                            "class": "selectr-input-clear",
                            type: "button"
                        });
                        this.inputContainer = util.createElement("div", {
                            "class": "selectr-input-container"
                        });
                        this.inputContainer.appendChild(this.input);
                        this.inputContainer.appendChild(this.inputClear);
                        dropdown.appendChild(this.inputContainer);
                    }
                    dropdown.appendChild(this.notice);
                    dropdown.appendChild(this.tree);
                    // List of items for the dropdown
                    this.items = [];
                    // Establish options
                    this.options = [];
                    // Check for options in the element
                    if (this.el.options.length) this.options = [].slice.call(this.el.options);
                    // Element may have optgroups so
                    // iterate element.children instead of element.options
                    var group = false, j = 0;
                    if (this.el.children.length) util.each(this.el.children, function(i, element) {
                        if (element.nodeName === "OPTGROUP") {
                            group = util.createElement("ul", {
                                "class": "selectr-optgroup",
                                role: "group",
                                html: "<li class='selectr-optgroup--label'>" + element.label + "</li>"
                            });
                            util.each(element.children, function(x, el) {
                                el.idx = j;
                                group.appendChild(createItem.call(this, el, group));
                                j++;
                            }, this);
                        } else {
                            element.idx = j;
                            createItem.call(this, element);
                            j++;
                        }
                    }, this);
                    // Options defined by the data option
                    if (this.config.data && Array.isArray(this.config.data)) {
                        this.data = [];
                        var optgroup = false, option;
                        group = false;
                        j = 0;
                        util.each(this.config.data, function(i, opt) {
                            // Check for group options
                            if (isset(opt, "children")) {
                                optgroup = util.createElement("optgroup", {
                                    label: opt.text
                                });
                                group = util.createElement("ul", {
                                    "class": "selectr-optgroup",
                                    role: "group",
                                    html: "<li class='selectr-optgroup--label'>" + opt.text + "</li>"
                                });
                                util.each(opt.children, function(x, data) {
                                    option = new Option(data.text, data.value, false, data.hasOwnProperty("selected") && data.selected === true);
                                    option.disabled = isset(data, "disabled");
                                    this.options.push(option);
                                    optgroup.appendChild(option);
                                    option.idx = j;
                                    group.appendChild(createItem.call(this, option, data));
                                    this.data[j] = data;
                                    j++;
                                }, this);
                                this.el.appendChild(optgroup);
                            } else {
                                option = new Option(opt.text, opt.value, false, opt.hasOwnProperty("selected") && opt.selected === true);
                                option.disabled = isset(opt, "disabled");
                                this.options.push(option);
                                option.idx = j;
                                createItem.call(this, option, opt);
                                this.data[j] = opt;
                                j++;
                            }
                        }, this);
                    }
                    this.setSelected(true);
                    var first;
                    this.navIndex = 0;
                    for(var i = 0; i < this.items.length; i++){
                        first = this.items[i];
                        if (!util.hasClass(first, "disabled")) {
                            util.addClass(first, "active");
                            this.navIndex = i;
                            break;
                        }
                    }
                    // Check for pagination / infinite scroll
                    if (this.requiresPagination) {
                        this.pageIndex = 1;
                        // Create the pages
                        this.paginate();
                    }
                    this.container.appendChild(this.selected);
                    this.container.appendChild(dropdown);
                    this.placeEl = util.createElement("div", {
                        "class": "selectr-placeholder"
                    });
                    // Set the placeholder
                    this.setPlaceholder();
                    this.selected.appendChild(this.placeEl);
                    // Disable if required
                    if (this.disabled) this.disable();
                    this.el.parentNode.insertBefore(this.container, this.el);
                    this.container.appendChild(this.el);
                };
                /**
 * Navigate through the dropdown
 * @param  {obj} e
 * @return {void}
 */ var navigate = function navigate(e) {
                    e = e || window.event;
                    // Filter out the keys we don"t want
                    if (!this.items.length || !this.opened || !util.includes([
                        13,
                        38,
                        40
                    ], e.which)) {
                        this.navigating = false;
                        return;
                    }
                    e.preventDefault();
                    if (e.which === 13) {
                        if (this.noResults || this.config.taggable && this.input.value.length > 0) return false;
                        return this.change(this.navIndex);
                    }
                    var direction, prevEl = this.items[this.navIndex];
                    var lastIndex = this.navIndex;
                    switch(e.which){
                        case 38:
                            direction = 0;
                            if (this.navIndex > 0) this.navIndex--;
                            break;
                        case 40:
                            direction = 1;
                            if (this.navIndex < this.items.length - 1) this.navIndex++;
                    }
                    this.navigating = true;
                    // Instead of wasting memory holding a copy of this.items
                    // with disabled / excluded options omitted, skip them instead
                    while(util.hasClass(this.items[this.navIndex], "disabled") || util.hasClass(this.items[this.navIndex], "excluded")){
                        if (this.navIndex > 0 && this.navIndex < this.items.length - 1) {
                            if (direction) this.navIndex++;
                            else this.navIndex--;
                        } else {
                            this.navIndex = lastIndex;
                            break;
                        }
                        if (this.searching) {
                            if (this.navIndex > this.tree.lastElementChild.idx) {
                                this.navIndex = this.tree.lastElementChild.idx;
                                break;
                            } else if (this.navIndex < this.tree.firstElementChild.idx) {
                                this.navIndex = this.tree.firstElementChild.idx;
                                break;
                            }
                        }
                    }
                    // Autoscroll the dropdown during navigation
                    var r = util.rect(this.items[this.navIndex]);
                    if (!direction) {
                        if (this.navIndex === 0) this.tree.scrollTop = 0;
                        else if (r.top - this.optsRect.top < 0) this.tree.scrollTop = this.tree.scrollTop + (r.top - this.optsRect.top);
                    } else {
                        if (this.navIndex === 0) this.tree.scrollTop = 0;
                        else if (r.top + r.height > this.optsRect.top + this.optsRect.height) this.tree.scrollTop = this.tree.scrollTop + (r.top + r.height - (this.optsRect.top + this.optsRect.height));
                        // Load another page if needed
                        if (this.navIndex === this.tree.childElementCount - 1 && this.requiresPagination) load.call(this);
                    }
                    if (prevEl) util.removeClass(prevEl, "active");
                    util.addClass(this.items[this.navIndex], "active");
                };
                /**
 * Add a tag
 * @param  {HTMLElement} item
 */ var addTag = function addTag(item) {
                    var that = this, r;
                    var docFrag = document.createDocumentFragment();
                    var option = this.options[item.idx];
                    var data = this.data ? this.data[item.idx] : option;
                    var elementData = {
                        "class": "selectr-tag"
                    };
                    if (this.customSelected) elementData.html = this.config.renderSelection(data); // asume xss prevention in custom render function
                    else elementData.textContent = option.textContent;
                    var tag = util.createElement("li", elementData);
                    var btn = util.createElement("button", {
                        "class": "selectr-tag-remove",
                        type: "button"
                    });
                    tag.appendChild(btn);
                    // Set property to check against later
                    tag.idx = item.idx;
                    tag.tag = option.value;
                    this.tags.push(tag);
                    if (this.config.sortSelected) {
                        var tags = this.tags.slice();
                        // Deal with values that contain numbers
                        r = function r(val, arr) {
                            val.replace(/(\d+)|(\D+)/g, function(that, $1, $2) {
                                arr.push([
                                    $1 || Infinity,
                                    $2 || ""
                                ]);
                            });
                        };
                        tags.sort(function(a, b) {
                            var x = [], y = [], ac, bc;
                            if (that.config.sortSelected === true) {
                                ac = a.tag;
                                bc = b.tag;
                            } else if (that.config.sortSelected === 'text') {
                                ac = a.textContent;
                                bc = b.textContent;
                            }
                            r(ac, x);
                            r(bc, y);
                            while(x.length && y.length){
                                var ax = x.shift();
                                var by = y.shift();
                                var nn = ax[0] - by[0] || ax[1].localeCompare(by[1]);
                                if (nn) return nn;
                            }
                            return x.length - y.length;
                        });
                        util.each(tags, function(i, tg) {
                            docFrag.appendChild(tg);
                        });
                        this.label.innerHTML = "";
                    } else docFrag.appendChild(tag);
                    if (this.config.taggable) this.label.insertBefore(docFrag, this.input.parentNode);
                    else this.label.appendChild(docFrag);
                };
                /**
 * Remove a tag
 * @param  {HTMLElement} item
 * @return {void}
 */ var removeTag = function removeTag(item) {
                    var tag = false;
                    util.each(this.tags, function(i, t) {
                        if (t.idx === item.idx) tag = t;
                    }, this);
                    if (tag) {
                        this.label.removeChild(tag);
                        this.tags.splice(this.tags.indexOf(tag), 1);
                    }
                };
                /**
 * Load the next page of items
 * @return {void}
 */ var load = function load() {
                    var tree = this.tree;
                    var scrollTop = tree.scrollTop;
                    var scrollHeight = tree.scrollHeight;
                    var offsetHeight = tree.offsetHeight;
                    var atBottom = scrollTop >= scrollHeight - offsetHeight;
                    if (atBottom && this.pageIndex < this.pages.length) {
                        var f = document.createDocumentFragment();
                        util.each(this.pages[this.pageIndex], function(i, item) {
                            appendItem(item, f, this.customOption);
                        }, this);
                        tree.appendChild(f);
                        this.pageIndex++;
                        this.emit("selectr.paginate", {
                            items: this.items.length,
                            total: this.data.length,
                            page: this.pageIndex,
                            pages: this.pages.length
                        });
                    }
                };
                /**
 * Clear a search
 * @return {void}
 */ var clearSearch = function clearSearch() {
                    if (this.config.searchable || this.config.taggable) {
                        this.input.value = null;
                        this.searching = false;
                        if (this.config.searchable) util.removeClass(this.inputContainer, "active");
                        if (util.hasClass(this.container, "notice")) {
                            util.removeClass(this.container, "notice");
                            util.addClass(this.container, "open");
                            this.input.focus();
                        }
                        util.each(this.items, function(i, item) {
                            // Items that didn't match need the class
                            // removing to make them visible again
                            util.removeClass(item, "excluded");
                            // Remove the span element for underlining matched items
                            if (!this.customOption) // without xss
                            item.textContent = item.textContent;
                        }, this);
                    }
                };
                /**
 * Query matching for searches.
 * Wraps matching text in a span.selectr-match.
 *
 * @param  {string} query
 * @param  {HTMLOptionElement} option element
 * @return {bool} true if matched; false otherwise
 */ var match = function match(query, option) {
                    var text = option.textContent;
                    var RX = new RegExp(query, "ig");
                    var result = RX.exec(text);
                    if (result) {
                        // #102 stop xss
                        option.innerHTML = "";
                        var span = document.createElement("span");
                        span.classList.add("selectr-match");
                        span.textContent = result[0];
                        option.appendChild(document.createTextNode(text.substring(0, result.index)));
                        option.appendChild(span);
                        option.appendChild(document.createTextNode(text.substring(RX.lastIndex)));
                        return true;
                    }
                    return false;
                };
                // Main Lib
                var Selectr = function Selectr(el, config) {
                    if (!el) throw new Error("You must supply either a HTMLSelectElement or a CSS3 selector string.");
                    this.el = el;
                    // CSS3 selector string
                    if (typeof el === "string") this.el = document.querySelector(el);
                    if (this.el === null) throw new Error("The element you passed to Selectr can not be found.");
                    if (this.el.nodeName.toLowerCase() !== "select") throw new Error("The element you passed to Selectr is not a HTMLSelectElement.");
                    this.render(config);
                };
                /**
 * Render the instance
 * @param  {object} config
 * @return {void}
 */ Selectr.prototype.render = function(config) {
                    if (this.rendered) return;
                    /**
   * Default configuration options
   * @type {Object}
   */ var defaultConfig = {
                        /**
     * Emulates browser behaviour by selecting the first option by default
     * @type {Boolean}
     */ defaultSelected: true,
                        /**
     * Sets the width of the container
     * @type {String}
     */ width: "auto",
                        /**
     * Enables/ disables the container
     * @type {Boolean}
     */ disabled: false,
                        /**
     * Enables/ disables logic for mobile
     * @type {Boolean}
     */ disabledMobile: false,
                        /**
     * Enables / disables the search function
     * @type {Boolean}
     */ searchable: true,
                        /**
     * Enable disable the clear button
     * @type {Boolean}
     */ clearable: false,
                        /**
     * Sort the tags / multiselect options
     * @type {Boolean}
     */ sortSelected: false,
                        /**
     * Allow deselecting of select-one options
     * @type {Boolean}
     */ allowDeselect: false,
                        /**
     * Close the dropdown when scrolling (@AlexanderReiswich, #11)
     * @type {Boolean}
     */ closeOnScroll: false,
                        /**
     * Allow the use of the native dropdown (@jonnyscholes, #14)
     * @type {Boolean}
     */ nativeDropdown: false,
                        /**
     * Allow the use of native typing behavior for toggling, searching, selecting
     * @type {boolean}
     */ nativeKeyboard: false,
                        /**
     * Set the main placeholder
     * @type {String}
     */ placeholder: "Select an option...",
                        /**
     * Allow the tagging feature
     * @type {Boolean}
     */ taggable: false,
                        /**
     * Set the tag input placeholder (@labikmartin, #21, #22)
     * @type {String}
     */ tagPlaceholder: "Enter a tag...",
                        messages: {
                            noResults: "No results.",
                            noOptions: "No options available.",
                            maxSelections: "A maximum of {max} items can be selected.",
                            tagDuplicate: "That tag is already in use.",
                            searchPlaceholder: "Search options..."
                        }
                    };
                    // add instance reference (#87)
                    this.el.selectr = this;
                    // Merge defaults with user set config
                    this.config = util.extend(defaultConfig, config);
                    // Store type
                    this.originalType = this.el.type;
                    // Store tabIndex
                    this.originalIndex = this.el.tabIndex;
                    // Store defaultSelected options for form reset
                    this.defaultSelected = [];
                    // Store the original option count
                    this.originalOptionCount = this.el.options.length;
                    if (this.config.multiple || this.config.taggable) this.el.multiple = true;
                    // Disabled?
                    this.disabled = isset(this.config, "disabled");
                    this.opened = false;
                    if (this.config.taggable) this.config.searchable = false;
                    this.navigating = false;
                    this.mobileDevice = false;
                    if (!this.config.disabledMobile && /Android|webOS|iPhone|iPad|BlackBerry|Windows Phone|Opera Mini|IEMobile|Mobile/i.test(navigator.userAgent)) this.mobileDevice = true;
                    this.customOption = this.config.hasOwnProperty("renderOption") && typeof this.config.renderOption === "function";
                    this.customSelected = this.config.hasOwnProperty("renderSelection") && typeof this.config.renderSelection === "function";
                    this.supportsEventPassiveOption = this.detectEventPassiveOption();
                    // Enable event emitter
                    Events.mixin(this);
                    build.call(this);
                    this.bindEvents();
                    this.update();
                    this.optsRect = util.rect(this.tree);
                    this.rendered = true;
                    // Fixes macOS Safari bug #28
                    if (!this.el.multiple) this.el.selectedIndex = this.selectedIndex;
                    var that = this;
                    setTimeout(function() {
                        that.emit("selectr.init");
                    }, 20);
                };
                Selectr.prototype.getSelected = function() {
                    var selected = this.el.querySelectorAll('option:checked');
                    return selected;
                };
                Selectr.prototype.getSelectedProperties = function(prop) {
                    var selected = this.getSelected();
                    var values = [].slice.call(selected).map(function(option) {
                        return option[prop];
                    }).filter(function(i) {
                        return i !== null && i !== undefined;
                    });
                    return values;
                };
                /**
 * Feature detection: addEventListener passive option
 * https://dom.spec.whatwg.org/#dom-addeventlisteneroptions-passive
 * https://github.com/WICG/EventListenerOptions/blob/gh-pages/explainer.md
 */ Selectr.prototype.detectEventPassiveOption = function() {
                    var supportsPassiveOption = false;
                    try {
                        var opts = Object.defineProperty({}, 'passive', {
                            get: function get() {
                                supportsPassiveOption = true;
                            }
                        });
                        window.addEventListener('test', null, opts);
                    } catch (e) {}
                    return supportsPassiveOption;
                };
                /**
 * Attach the required event listeners
 */ Selectr.prototype.bindEvents = function() {
                    var that = this;
                    this.events = {};
                    this.events.dismiss = dismiss.bind(this);
                    this.events.navigate = navigate.bind(this);
                    this.events.reset = this.reset.bind(this);
                    if (this.config.nativeDropdown || this.mobileDevice) {
                        this.container.addEventListener("touchstart", function(e) {
                            if (e.changedTouches[0].target === that.el) that.toggle();
                        }, this.supportsEventPassiveOption ? {
                            passive: true
                        } : false);
                        this.container.addEventListener("click", function(e) {
                            if (e.target === that.el) that.toggle();
                        });
                        var getChangedOptions = function getChangedOptions(last, current) {
                            var added = [], removed = last.slice(0);
                            var idx;
                            for(var i = 0; i < current.length; i++){
                                idx = removed.indexOf(current[i]);
                                if (idx > -1) removed.splice(idx, 1);
                                else added.push(current[i]);
                            }
                            return [
                                added,
                                removed
                            ];
                        };
                        // Listen for the change on the native select
                        // and update accordingly
                        this.el.addEventListener("change", function(e) {
                            if (e.__selfTriggered) return;
                            if (that.el.multiple) {
                                var indexes = that.getSelectedProperties('idx');
                                var changes = getChangedOptions(that.selectedIndexes, indexes);
                                util.each(changes[0], function(i, idx) {
                                    that.select(idx);
                                }, that);
                                util.each(changes[1], function(i, idx) {
                                    that.deselect(idx);
                                }, that);
                            } else if (that.el.selectedIndex > -1) that.select(that.el.selectedIndex);
                        });
                    }
                    // Open the dropdown with Enter key if focused
                    if (this.config.nativeDropdown) this.container.addEventListener("keydown", function(e) {
                        if (e.key === "Enter" && that.selected === document.activeElement) {
                            // show native dropdown
                            that.toggle();
                            // focus on it
                            setTimeout(function() {
                                that.el.focus();
                            }, 200);
                        }
                    });
                    // Non-native dropdown
                    this.selected.addEventListener("click", function(e) {
                        if (!that.disabled) that.toggle();
                        e.preventDefault();
                    });
                    if (this.config.nativeKeyboard) {
                        var typing = '';
                        var typingTimeout = null;
                        this.selected.addEventListener("keydown", function(e) {
                            // Do nothing if disabled, not focused, or modifier keys are pressed
                            if (that.disabled || that.selected !== document.activeElement || e.altKey || e.ctrlKey || e.metaKey) return;
                            // Open the dropdown on [enter], [ ], [↓], and [↑] keys
                            if (e.key === " " || !that.opened && [
                                "Enter",
                                "ArrowUp",
                                "ArrowDown"
                            ].indexOf(e.key) > -1) {
                                that.toggle();
                                e.preventDefault();
                                e.stopPropagation();
                                return;
                            }
                            // Type to search if multiple; type to select otherwise
                            // make sure e.key is a single, printable character
                            // .length check is a short-circut to skip checking keys like "ArrowDown", etc.
                            // prefer "codePoint" methods; they work with the full range of unicode
                            if (e.key.length <= 2 && String[String.fromCodePoint ? "fromCodePoint" : "fromCharCode"](e.key[String.codePointAt ? "codePointAt" : "charCodeAt"](0)) === e.key) {
                                if (that.config.multiple) {
                                    that.open();
                                    if (that.config.searchable) {
                                        that.input.value = e.key;
                                        that.input.focus();
                                        that.search(null, true);
                                    }
                                } else {
                                    if (typingTimeout) clearTimeout(typingTimeout);
                                    typing += e.key;
                                    var found = that.search(typing, true);
                                    if (found && found.length) {
                                        that.clear();
                                        that.setValue(found[0].value);
                                    }
                                    setTimeout(function() {
                                        typing = '';
                                    }, 1000);
                                }
                                e.preventDefault();
                                e.stopPropagation();
                                return;
                            }
                        });
                        // Close the dropdown on [esc] key
                        this.container.addEventListener("keyup", function(e) {
                            if (that.opened && e.key === "Escape") {
                                that.close();
                                e.stopPropagation();
                                // keep focus so we can re-open easily if desired
                                that.selected.focus();
                            }
                        });
                    }
                    // Remove tag
                    this.label.addEventListener("click", function(e) {
                        if (util.hasClass(e.target, "selectr-tag-remove")) that.deselect(e.target.parentNode.idx);
                    });
                    // Clear input
                    if (this.selectClear) this.selectClear.addEventListener("click", this.clear.bind(this));
                    // Prevent text selection
                    this.tree.addEventListener("mousedown", function(e) {
                        e.preventDefault();
                    });
                    // Select / deselect items
                    this.tree.addEventListener("click", function(e) {
                        var item = util.closest(e.target, function(el) {
                            return el && util.hasClass(el, "selectr-option");
                        });
                        if (item) {
                            if (!util.hasClass(item, "disabled")) {
                                if (util.hasClass(item, "selected")) {
                                    if (that.el.multiple || !that.el.multiple && that.config.allowDeselect) that.deselect(item.idx);
                                } else that.select(item.idx);
                                if (that.opened && !that.el.multiple) that.close();
                            }
                        }
                        e.preventDefault();
                        e.stopPropagation();
                    });
                    // Mouseover list items
                    this.tree.addEventListener("mouseover", function(e) {
                        if (util.hasClass(e.target, "selectr-option")) {
                            if (!util.hasClass(e.target, "disabled")) {
                                util.removeClass(that.items[that.navIndex], "active");
                                util.addClass(e.target, "active");
                                that.navIndex = [].slice.call(that.items).indexOf(e.target);
                            }
                        }
                    });
                    // Searchable
                    if (this.config.searchable) {
                        // Show / hide the search input clear button
                        this.input.addEventListener("focus", function(e) {
                            that.searching = true;
                        });
                        this.input.addEventListener("blur", function(e) {
                            that.searching = false;
                        });
                        this.input.addEventListener("keyup", function(e) {
                            that.search();
                            if (!that.config.taggable) {
                                // Show / hide the search input clear button
                                if (this.value.length) util.addClass(this.parentNode, "active");
                                else util.removeClass(this.parentNode, "active");
                            }
                        });
                        // Clear the search input
                        this.inputClear.addEventListener("click", function(e) {
                            that.input.value = null;
                            clearSearch.call(that);
                            if (!that.tree.childElementCount) render.call(that);
                        });
                    }
                    if (this.config.taggable) this.input.addEventListener("keyup", function(e) {
                        that.search();
                        if (that.config.taggable && this.value.length) {
                            var _sVal = this.value.trim();
                            if (_sVal.length && (e.which === 13 || that.tagSeperatorsRegex.test(_sVal))) {
                                var _sGrabbedTagValue = _sVal.replace(that.tagSeperatorsRegex, '');
                                _sGrabbedTagValue = util.escapeRegExp(_sGrabbedTagValue);
                                _sGrabbedTagValue = _sGrabbedTagValue.trim();
                                var _oOption;
                                if (_sGrabbedTagValue.length) _oOption = that.add({
                                    value: _sGrabbedTagValue,
                                    textContent: _sGrabbedTagValue,
                                    selected: true
                                }, true);
                                if (_oOption) {
                                    that.close();
                                    clearSearch.call(that);
                                } else {
                                    this.value = '';
                                    that.setMessage(that.config.messages.tagDuplicate);
                                }
                            }
                        }
                    });
                    this.update = util.debounce(function() {
                        // Optionally close dropdown on scroll / resize (#11)
                        if (that.opened && that.config.closeOnScroll) that.close();
                        if (that.width) that.container.style.width = that.width;
                        that.invert();
                    }, 50);
                    if (this.requiresPagination) {
                        this.paginateItems = util.debounce(function() {
                            load.call(this);
                        }, 50);
                        this.tree.addEventListener("scroll", this.paginateItems.bind(this));
                    }
                    // Dismiss when clicking outside the container
                    document.addEventListener("click", this.events.dismiss);
                    window.addEventListener("keydown", this.events.navigate);
                    window.addEventListener("resize", this.update);
                    window.addEventListener("scroll", this.update);
                    // remove event listeners on destroy()
                    this.on('selectr.destroy', function() {
                        document.removeEventListener("click", this.events.dismiss);
                        window.removeEventListener("keydown", this.events.navigate);
                        window.removeEventListener("resize", this.update);
                        window.removeEventListener("scroll", this.update);
                    });
                    // Listen for form.reset() (@ambrooks, #13)
                    if (this.el.form) {
                        this.el.form.addEventListener("reset", this.events.reset);
                        // remove listener on destroy()
                        this.on('selectr.destroy', function() {
                            this.el.form.removeEventListener("reset", this.events.reset);
                        });
                    }
                };
                /**
 * Check for selected options
 * @param {bool} reset
 */ Selectr.prototype.setSelected = function(reset) {
                    // Select first option as with a native select-one element - #21, #24
                    if (!this.config.data && !this.el.multiple && this.el.options.length) {
                        // Browser has selected the first option by default
                        if (this.el.selectedIndex === 0) {
                            if (!this.el.options[0].defaultSelected && !this.config.defaultSelected) this.el.selectedIndex = -1;
                        }
                        this.selectedIndex = this.el.selectedIndex;
                        if (this.selectedIndex > -1) this.select(this.selectedIndex);
                    }
                    // If we're changing a select-one to select-multiple via the config
                    // and there are no selected options, the first option will be selected by the browser
                    // Let's prevent that here.
                    if (this.config.multiple && this.originalType === "select-one" && !this.config.data) {
                        if (this.el.options[0].selected && !this.el.options[0].defaultSelected) this.el.options[0].selected = false;
                    }
                    util.each(this.options, function(i, option) {
                        if (option.selected && option.defaultSelected) this.select(option.idx);
                    }, this);
                    if (this.config.selectedValue) this.setValue(this.config.selectedValue);
                    if (this.config.data) {
                        if (!this.el.multiple && this.config.defaultSelected && this.el.selectedIndex < 0 && this.config.data.length > 0) this.select(0);
                        var j = 0;
                        util.each(this.config.data, function(i, opt) {
                            // Check for group options
                            if (isset(opt, "children")) util.each(opt.children, function(x, item) {
                                if (item.hasOwnProperty("selected") && item.selected === true) this.select(j);
                                j++;
                            }, this);
                            else {
                                if (opt.hasOwnProperty("selected") && opt.selected === true) this.select(j);
                                j++;
                            }
                        }, this);
                    }
                };
                /**
 * Destroy the instance
 * @return {void}
 */ Selectr.prototype.destroy = function() {
                    if (!this.rendered) return;
                    this.emit("selectr.destroy");
                    // Revert to select-single if programtically set to multiple
                    if (this.originalType === 'select-one') this.el.multiple = false;
                    if (this.config.data) this.el.innerHTML = "";
                    // Remove the className from select element
                    util.removeClass(this.el, 'selectr-hidden');
                    // Replace the container with the original select element
                    this.container.parentNode.replaceChild(this.el, this.container);
                    this.rendered = false;
                    // remove reference
                    delete this.el.selectr;
                };
                /**
 * Change an options state
 * @param  {Number} index
 * @return {void}
 */ Selectr.prototype.change = function(index) {
                    var item = this.items[index], option = this.options[index];
                    if (option.disabled) return;
                    if (option.selected && util.hasClass(item, "selected")) this.deselect(index);
                    else this.select(index);
                    if (this.opened && !this.el.multiple) this.close();
                };
                /**
 * Select an option
 * @param  {Number} index
 * @return {void}
 */ Selectr.prototype.select = function(index) {
                    var item = this.items[index], options = [].slice.call(this.el.options), option = this.options[index];
                    if (this.el.multiple) {
                        if (util.includes(this.selectedIndexes, index)) return false;
                        if (this.config.maxSelections && this.tags.length === this.config.maxSelections) {
                            this.setMessage(this.config.messages.maxSelections.replace("{max}", this.config.maxSelections), true);
                            return false;
                        }
                        this.selectedValues.push(option.value);
                        this.selectedIndexes.push(index);
                        addTag.call(this, item);
                    } else {
                        var data = this.data ? this.data[index] : option;
                        if (this.customSelected) this.label.innerHTML = this.config.renderSelection(data);
                        else // no xss
                        this.label.textContent = option.textContent;
                        this.selectedValue = option.value;
                        this.selectedIndex = index;
                        util.each(this.options, function(i, o) {
                            var opt = this.items[i];
                            if (i !== index) {
                                if (opt) util.removeClass(opt, "selected");
                                o.selected = false;
                                o.removeAttribute("selected");
                            }
                        }, this);
                    }
                    if (!util.includes(options, option)) this.el.add(option);
                    item.setAttribute("aria-selected", true);
                    util.addClass(item, "selected");
                    util.addClass(this.container, "has-selected");
                    option.selected = true;
                    option.setAttribute("selected", "");
                    this.emit("selectr.change", option);
                    this.emit("selectr.select", option);
                    // fire native change event
                    if ("createEvent" in document) {
                        var evt = document.createEvent("HTMLEvents");
                        evt.initEvent("change", true, true);
                        evt.__selfTriggered = true;
                        this.el.dispatchEvent(evt);
                    } else this.el.fireEvent("onchange");
                };
                /**
 * Deselect an option
 * @param  {Number} index
 * @return {void}
 */ Selectr.prototype.deselect = function(index, force) {
                    var item = this.items[index], option = this.options[index];
                    if (this.el.multiple) {
                        var selIndex = this.selectedIndexes.indexOf(index);
                        this.selectedIndexes.splice(selIndex, 1);
                        var valIndex = this.selectedValues.indexOf(option.value);
                        this.selectedValues.splice(valIndex, 1);
                        removeTag.call(this, item);
                        if (!this.tags.length) util.removeClass(this.container, "has-selected");
                    } else {
                        if (!force && !this.config.clearable && !this.config.allowDeselect) return false;
                        this.label.innerHTML = "";
                        this.selectedValue = null;
                        this.el.selectedIndex = this.selectedIndex = -1;
                        util.removeClass(this.container, "has-selected");
                    }
                    this.items[index].setAttribute("aria-selected", false);
                    util.removeClass(this.items[index], "selected");
                    option.selected = false;
                    option.removeAttribute("selected");
                    this.emit("selectr.change", null);
                    this.emit("selectr.deselect", option);
                    // fire native change event
                    if ("createEvent" in document) {
                        var evt = document.createEvent("HTMLEvents");
                        evt.initEvent("change", true, true);
                        evt.__selfTriggered = true;
                        this.el.dispatchEvent(evt);
                    } else this.el.fireEvent("onchange");
                };
                /**
 * Programmatically set selected values
 * @param {String|Array} value - A string or an array of strings
 */ Selectr.prototype.setValue = function(value) {
                    var isArray = Array.isArray(value);
                    if (!isArray) value = value.toString().trim();
                    // Can't pass array to select-one
                    if (!this.el.multiple && isArray) return false;
                    util.each(this.options, function(i, option) {
                        if (isArray && value.indexOf(option.value) > -1 || option.value === value) this.change(option.idx);
                    }, this);
                };
                /**
 * Set the selected value(s)
 * @param  {bool} toObject Return only the raw values or an object
 * @param  {bool} toJson   Return the object as a JSON string
 * @return {mixed}         Array or String
 */ Selectr.prototype.getValue = function(toObject, toJson) {
                    var value;
                    if (this.el.multiple) {
                        if (toObject) {
                            if (this.selectedIndexes.length) {
                                value = {};
                                value.values = [];
                                util.each(this.selectedIndexes, function(i, index) {
                                    var option = this.options[index];
                                    value.values[i] = {
                                        value: option.value,
                                        text: option.textContent
                                    };
                                }, this);
                            }
                        } else value = this.selectedValues.slice();
                    } else if (toObject) {
                        var option = this.options[this.selectedIndex];
                        value = {
                            value: option.value,
                            text: option.textContent
                        };
                    } else value = this.selectedValue;
                    if (toObject && toJson) value = JSON.stringify(value);
                    return value;
                };
                /**
 * Add a new option or options
 * @param {object} data
 */ Selectr.prototype.add = function(data, checkDuplicate) {
                    if (data) {
                        this.data = this.data || [];
                        this.items = this.items || [];
                        this.options = this.options || [];
                        if (Array.isArray(data)) // We have an array on items
                        util.each(data, function(i, obj) {
                            this.add(obj, checkDuplicate);
                        }, this);
                        else if ("[object Object]" === Object.prototype.toString.call(data)) {
                            if (checkDuplicate) {
                                var dupe = false;
                                util.each(this.options, function(i, option) {
                                    if (option.value.toLowerCase() === data.value.toLowerCase()) dupe = true;
                                });
                                if (dupe) return false;
                            }
                            var option = util.createElement('option', data);
                            this.data.push(data);
                            // fix for native iOS dropdown otherwise the native dropdown will be empty
                            if (this.mobileDevice) this.el.add(option);
                            // Add the new option to the list
                            this.options.push(option);
                            // Add the index for later use
                            option.idx = this.options.length > 0 ? this.options.length - 1 : 0;
                            // Create a new item
                            createItem.call(this, option);
                            // Select the item if required
                            if (data.selected) this.select(option.idx);
                            // We may have had an empty select so update
                            // the placeholder to reflect the changes.
                            this.setPlaceholder();
                            return option;
                        }
                        // Recount the pages
                        if (this.config.pagination) this.paginate();
                        return true;
                    }
                };
                /**
 * Remove an option or options
 * @param  {Mixed} o Array, integer (index) or string (value)
 * @return {Void}
 */ Selectr.prototype.remove = function(o) {
                    var options = [];
                    if (Array.isArray(o)) util.each(o, function(i, opt) {
                        if (util.isInt(opt)) options.push(this.getOptionByIndex(opt));
                        else if (typeof opt === "string") options.push(this.getOptionByValue(opt));
                    }, this);
                    else if (util.isInt(o)) options.push(this.getOptionByIndex(o));
                    else if (typeof o === "string") options.push(this.getOptionByValue(o));
                    if (options.length) {
                        var index;
                        util.each(options, function(i, option) {
                            index = option.idx;
                            // Remove the HTMLOptionElement
                            this.el.remove(option);
                            // Remove the reference from the option array
                            this.options.splice(index, 1);
                            // If the item has a parentNode (group element) it needs to be removed
                            // otherwise the render function will still append it to the dropdown
                            var parentNode = this.items[index].parentNode;
                            if (parentNode) parentNode.removeChild(this.items[index]);
                            // Remove reference from the items array
                            this.items.splice(index, 1);
                            // Reset the indexes
                            util.each(this.options, function(i, opt) {
                                opt.idx = i;
                                this.items[i].idx = i;
                            }, this);
                        }, this);
                        // We may have had an empty select now so update
                        // the placeholder to reflect the changes.
                        this.setPlaceholder();
                        // Recount the pages
                        if (this.config.pagination) this.paginate();
                    }
                };
                /**
 * Remove all options
 */ Selectr.prototype.removeAll = function() {
                    // Clear any selected options
                    this.clear(true);
                    // Remove the HTMLOptionElements
                    util.each(this.el.options, function(i, option) {
                        this.el.remove(option);
                    }, this);
                    // Empty the dropdown
                    util.truncate(this.tree);
                    // Reset variables
                    this.items = [];
                    this.options = [];
                    this.data = [];
                    this.navIndex = 0;
                    if (this.requiresPagination) {
                        this.requiresPagination = false;
                        this.pageIndex = 1;
                        this.pages = [];
                    }
                    // Update the placeholder
                    this.setPlaceholder();
                };
                /**
 * Perform a search
 * @param {string}|{null} query The query string (taken from user input if null)
 * @param {boolean} anchor Anchor search to beginning of strings (defaults to false)?
 * @return {Array} Search results, as an array of {text, value} objects
 */ Selectr.prototype.search = function(string, anchor) {
                    if (this.navigating) return;
                    // we're only going to alter the DOM for "live" searches
                    var live = false;
                    if (!string) {
                        string = this.input.value;
                        live = true;
                        // Remove message and clear dropdown
                        this.removeMessage();
                        util.truncate(this.tree);
                    }
                    var results = [];
                    var f = document.createDocumentFragment();
                    string = string.trim().toLowerCase();
                    if (string.length > 0) {
                        var compare = anchor ? util.startsWith : util.includes;
                        util.each(this.options, function(i, option) {
                            var item = this.items[option.idx];
                            var matches = compare(option.textContent.trim().toLowerCase(), string);
                            if (matches && !option.disabled) {
                                results.push({
                                    text: option.textContent,
                                    value: option.value
                                });
                                if (live) {
                                    appendItem(item, f, this.customOption);
                                    util.removeClass(item, "excluded");
                                    // Underline the matching results
                                    if (!this.customOption) match(string, option);
                                }
                            } else if (live) util.addClass(item, "excluded");
                        }, this);
                        if (live) {
                            // Append results
                            if (!f.childElementCount) {
                                if (!this.config.taggable) {
                                    this.noResults = true;
                                    this.setMessage(this.config.messages.noResults);
                                }
                            } else {
                                // Highlight top result (@binary-koan #26)
                                var prevEl = this.items[this.navIndex];
                                var firstEl = f.querySelector(".selectr-option:not(.excluded)");
                                this.noResults = false;
                                util.removeClass(prevEl, "active");
                                this.navIndex = firstEl.idx;
                                util.addClass(firstEl, "active");
                            }
                            this.tree.appendChild(f);
                        }
                    } else render.call(this);
                    return results;
                };
                /**
 * Toggle the dropdown
 * @return {void}
 */ Selectr.prototype.toggle = function() {
                    if (!this.disabled) {
                        if (this.opened) this.close();
                        else this.open();
                    }
                };
                /**
 * Open the dropdown
 * @return {void}
 */ Selectr.prototype.open = function() {
                    var that = this;
                    if (!this.options.length) return false;
                    if (!this.opened) this.emit("selectr.open");
                    this.opened = true;
                    if (this.mobileDevice || this.config.nativeDropdown) {
                        util.addClass(this.container, "native-open");
                        if (this.config.data) // Dump the options into the select
                        // otherwise the native dropdown will be empty
                        util.each(this.options, function(i, option) {
                            this.el.add(option);
                        }, this);
                        return;
                    }
                    util.addClass(this.container, "open");
                    render.call(this);
                    this.invert();
                    this.tree.scrollTop = 0;
                    util.removeClass(this.container, "notice");
                    this.selected.setAttribute("aria-expanded", true);
                    this.tree.setAttribute("aria-hidden", false);
                    this.tree.setAttribute("aria-expanded", true);
                    if (this.config.searchable && !this.config.taggable) setTimeout(function() {
                        that.input.focus();
                        // Allow tab focus
                        that.input.tabIndex = 0;
                    }, 10);
                };
                /**
 * Close the dropdown
 * @return {void}
 */ Selectr.prototype.close = function() {
                    if (this.opened) this.emit("selectr.close");
                    this.opened = false;
                    this.navigating = false;
                    if (this.mobileDevice || this.config.nativeDropdown) {
                        util.removeClass(this.container, "native-open");
                        return;
                    }
                    var notice = util.hasClass(this.container, "notice");
                    if (this.config.searchable && !notice) {
                        this.input.blur();
                        // Disable tab focus
                        this.input.tabIndex = -1;
                        this.searching = false;
                    }
                    if (notice) {
                        util.removeClass(this.container, "notice");
                        this.notice.textContent = "";
                    }
                    util.removeClass(this.container, "open");
                    util.removeClass(this.container, "native-open");
                    this.selected.setAttribute("aria-expanded", false);
                    this.tree.setAttribute("aria-hidden", true);
                    this.tree.setAttribute("aria-expanded", false);
                    util.truncate(this.tree);
                    clearSearch.call(this);
                };
                /**
 * Enable the element
 * @return {void}
 */ Selectr.prototype.enable = function() {
                    this.disabled = false;
                    this.el.disabled = false;
                    this.selected.tabIndex = this.originalIndex;
                    if (this.el.multiple) util.each(this.tags, function(i, t) {
                        t.lastElementChild.tabIndex = 0;
                    });
                    util.removeClass(this.container, "selectr-disabled");
                };
                /**
 * Disable the element
 * @param  {boolean} container Disable the container only (allow value submit with form)
 * @return {void}
 */ Selectr.prototype.disable = function(container) {
                    if (!container) this.el.disabled = true;
                    this.selected.tabIndex = -1;
                    if (this.el.multiple) util.each(this.tags, function(i, t) {
                        t.lastElementChild.tabIndex = -1;
                    });
                    this.disabled = true;
                    util.addClass(this.container, "selectr-disabled");
                };
                /**
 * Reset to initial state
 * @return {void}
 */ Selectr.prototype.reset = function() {
                    if (!this.disabled) {
                        this.clear();
                        this.setSelected(true);
                        util.each(this.defaultSelected, function(i, idx) {
                            this.select(idx);
                        }, this);
                        this.emit("selectr.reset");
                    }
                };
                /**
 * Clear all selections
 * @return {void}
 */ Selectr.prototype.clear = function(force, isClearLast) {
                    if (this.el.multiple) // Loop over the selectedIndexes so we don't have to loop over all the options
                    // which can be costly if there are a lot of them
                    {
                        if (this.selectedIndexes.length) {
                            // Copy the array or we'll get an error
                            var indexes = this.selectedIndexes.slice();
                            if (isClearLast) this.deselect(indexes.slice(-1)[0]);
                            else util.each(indexes, function(i, idx) {
                                this.deselect(idx);
                            }, this);
                        }
                    } else if (this.selectedIndex > -1) this.deselect(this.selectedIndex, force);
                    this.emit("selectr.clear");
                };
                /**
 * Return serialised data
 * @param  {boolean} toJson
 * @return {mixed} Returns either an object or JSON string
 */ Selectr.prototype.serialise = function(toJson) {
                    var data = [];
                    util.each(this.options, function(i, option) {
                        var obj = {
                            value: option.value,
                            text: option.textContent
                        };
                        if (option.selected) obj.selected = true;
                        if (option.disabled) obj.disabled = true;
                        data[i] = obj;
                    });
                    return toJson ? JSON.stringify(data) : data;
                };
                /**
 * Localised version of serialise() method
 */ Selectr.prototype.serialize = function(toJson) {
                    return this.serialise(toJson);
                };
                /**
 * Sets the placeholder
 * @param {String} placeholder
 */ Selectr.prototype.setPlaceholder = function(placeholder) {
                    // Set the placeholder
                    placeholder = placeholder || this.config.placeholder || this.el.getAttribute("placeholder");
                    if (!this.options.length) placeholder = this.config.messages.noOptions;
                    this.placeEl.innerHTML = placeholder;
                };
                /**
 * Paginate the option list
 * @return {Array}
 */ Selectr.prototype.paginate = function() {
                    if (this.items.length) {
                        var that = this;
                        this.pages = this.items.map(function(v, i) {
                            return i % that.config.pagination === 0 ? that.items.slice(i, i + that.config.pagination) : null;
                        }).filter(function(pages) {
                            return pages;
                        });
                        return this.pages;
                    }
                };
                /**
 * Display a message
 * @param  {String} message The message
 */ Selectr.prototype.setMessage = function(message, close) {
                    if (close) this.close();
                    util.addClass(this.container, "notice");
                    this.notice.textContent = message;
                };
                /**
 * Dismiss the current message
 */ Selectr.prototype.removeMessage = function() {
                    util.removeClass(this.container, "notice");
                    this.notice.innerHTML = "";
                };
                /**
 * Keep the dropdown within the window
 * @return {void}
 */ Selectr.prototype.invert = function() {
                    var rt = util.rect(this.selected), oh = this.tree.parentNode.offsetHeight, wh = window.innerHeight, doInvert = rt.top + rt.height + oh > wh;
                    if (doInvert) {
                        util.addClass(this.container, "inverted");
                        this.isInverted = true;
                    } else {
                        util.removeClass(this.container, "inverted");
                        this.isInverted = false;
                    }
                    this.optsRect = util.rect(this.tree);
                };
                /**
 * Get an option via it's index
 * @param  {Integer} index The index of the HTMLOptionElement required
 * @return {HTMLOptionElement}
 */ Selectr.prototype.getOptionByIndex = function(index) {
                    return this.options[index];
                };
                /**
 * Get an option via it's value
 * @param  {String} value The value of the HTMLOptionElement required
 * @return {HTMLOptionElement}
 */ Selectr.prototype.getOptionByValue = function(value) {
                    var option = false;
                    for(var i = 0, l = this.options.length; i < l; i++)if (this.options[i].value.trim() === value.toString().trim()) {
                        option = this.options[i];
                        break;
                    }
                    return option;
                };
                module1.exports = Selectr;
            /***/ },
            /***/ 857: /***/ function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {
                "use strict";
                // EXPORTS
                __webpack_require__.d(__webpack_exports__, {
                    m: function() {
                        return /* binding */ jsonrepair;
                    }
                });
                class JSONRepairError extends Error {
                    constructor(message, position){
                        super("".concat(message, " at position ").concat(position));
                        this.position = position;
                    }
                }
                const codeSpace = 0x20; // " "
                const codeNewline = 0xa; // "\n"
                const codeTab = 0x9; // "\t"
                const codeReturn = 0xd; // "\r"
                const codeNonBreakingSpace = 0xa0;
                const codeEnQuad = 0x2000;
                const codeHairSpace = 0x200a;
                const codeNarrowNoBreakSpace = 0x202f;
                const codeMediumMathematicalSpace = 0x205f;
                const codeIdeographicSpace = 0x3000;
                function isHex(char) {
                    return /^[0-9A-Fa-f]$/.test(char);
                }
                function isDigit(char) {
                    return char >= '0' && char <= '9';
                }
                function isValidStringCharacter(char) {
                    // note that the valid range is between \u{0020} and \u{10ffff},
                    // but in JavaScript it is not possible to create a code point larger than
                    // \u{10ffff}, so there is no need to test for that here.
                    return char >= '\u0020';
                }
                function isDelimiter(char) {
                    return ',:[]/{}()\n+'.includes(char);
                }
                function isFunctionNameCharStart(char) {
                    return char >= 'a' && char <= 'z' || char >= 'A' && char <= 'Z' || char === '_' || char === '$';
                }
                function isFunctionNameChar(char) {
                    return char >= 'a' && char <= 'z' || char >= 'A' && char <= 'Z' || char === '_' || char === '$' || char >= '0' && char <= '9';
                }
                // matches "https://" and other schemas
                const regexUrlStart = /^(http|https|ftp|mailto|file|data|irc):\/\/$/;
                // matches all valid URL characters EXCEPT "[", "]", and ",", since that are important JSON delimiters
                const regexUrlChar = /^[A-Za-z0-9-._~:/?#@!$&'()*+;=]$/;
                function isUnquotedStringDelimiter(char) {
                    return ',[]/{}\n+'.includes(char);
                }
                function isStartOfValue(char) {
                    return isQuote(char) || regexStartOfValue.test(char);
                }
                // alpha, number, minus, or opening bracket or brace
                const regexStartOfValue = /^[[{\w-]$/;
                function isControlCharacter(char) {
                    return char === '\n' || char === '\r' || char === '\t' || char === '\b' || char === '\f';
                }
                /**
 * Check if the given character is a whitespace character like space, tab, or
 * newline
 */ function isWhitespace(text, index) {
                    const code = text.charCodeAt(index);
                    return code === codeSpace || code === codeNewline || code === codeTab || code === codeReturn;
                }
                /**
 * Check if the given character is a whitespace character like space or tab,
 * but NOT a newline
 */ function isWhitespaceExceptNewline(text, index) {
                    const code = text.charCodeAt(index);
                    return code === codeSpace || code === codeTab || code === codeReturn;
                }
                /**
 * Check if the given character is a special whitespace character, some
 * unicode variant
 */ function isSpecialWhitespace(text, index) {
                    const code = text.charCodeAt(index);
                    return code === codeNonBreakingSpace || code >= codeEnQuad && code <= codeHairSpace || code === codeNarrowNoBreakSpace || code === codeMediumMathematicalSpace || code === codeIdeographicSpace;
                }
                /**
 * Test whether the given character is a quote or double quote character.
 * Also tests for special variants of quotes.
 */ function isQuote(char) {
                    // the first check double quotes, since that occurs most often
                    return isDoubleQuoteLike(char) || isSingleQuoteLike(char);
                }
                /**
 * Test whether the given character is a double quote character.
 * Also tests for special variants of double quotes.
 */ function isDoubleQuoteLike(char) {
                    return char === '"' || char === '\u201c' || char === '\u201d';
                }
                /**
 * Test whether the given character is a double quote character.
 * Does NOT test for special variants of double quotes.
 */ function isDoubleQuote(char) {
                    return char === '"';
                }
                /**
 * Test whether the given character is a single quote character.
 * Also tests for special variants of single quotes.
 */ function isSingleQuoteLike(char) {
                    return char === "'" || char === '\u2018' || char === '\u2019' || char === '\u0060' || char === '\u00b4';
                }
                /**
 * Test whether the given character is a single quote character.
 * Does NOT test for special variants of single quotes.
 */ function isSingleQuote(char) {
                    return char === "'";
                }
                /**
 * Strip last occurrence of textToStrip from text
 */ function stripLastOccurrence(text, textToStrip) {
                    let stripRemainingText = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
                    const index = text.lastIndexOf(textToStrip);
                    return index !== -1 ? text.substring(0, index) + (stripRemainingText ? '' : text.substring(index + 1)) : text;
                }
                function insertBeforeLastWhitespace(text, textToInsert) {
                    let index = text.length;
                    if (!isWhitespace(text, index - 1)) // no trailing whitespaces
                    return text + textToInsert;
                    while(isWhitespace(text, index - 1))index--;
                    return text.substring(0, index) + textToInsert + text.substring(index);
                }
                function removeAtIndex(text, start, count) {
                    return text.substring(0, start) + text.substring(start + count);
                }
                /**
 * Test whether a string ends with a newline or comma character and optional whitespace
 */ function endsWithCommaOrNewline(text) {
                    return /[,\n][ \t\r]*$/.test(text);
                }
                const controlCharacters = {
                    '\b': '\\b',
                    '\f': '\\f',
                    '\n': '\\n',
                    '\r': '\\r',
                    '\t': '\\t'
                };
                // map with all escape characters
                const escapeCharacters = {
                    '"': '"',
                    '\\': '\\',
                    '/': '/',
                    b: '\b',
                    f: '\f',
                    n: '\n',
                    r: '\r',
                    t: '\t'
                };
                /**
 * Repair a string containing an invalid JSON document.
 * For example changes JavaScript notation into JSON notation.
 *
 * Example:
 *
 *     try {
 *       const json = "{name: 'John'}"
 *       const repaired = jsonrepair(json)
 *       console.log(repaired)
 *       // '{"name": "John"}'
 *     } catch (err) {
 *       console.error(err)
 *     }
 *
 */ function jsonrepair(text) {
                    let i = 0; // current index in text
                    let output = ''; // generated output
                    parseMarkdownCodeBlock();
                    const processed = parseValue();
                    if (!processed) throwUnexpectedEnd();
                    parseMarkdownCodeBlock();
                    const processedComma = parseCharacter(',');
                    if (processedComma) parseWhitespaceAndSkipComments();
                    if (isStartOfValue(text[i]) && endsWithCommaOrNewline(output)) {
                        // start of a new value after end of the root level object: looks like
                        // newline delimited JSON -> turn into a root level array
                        if (!processedComma) // repair missing comma
                        output = insertBeforeLastWhitespace(output, ',');
                        parseNewlineDelimitedJSON();
                    } else if (processedComma) // repair: remove trailing comma
                    output = stripLastOccurrence(output, ',');
                    // repair redundant end quotes
                    while(text[i] === '}' || text[i] === ']'){
                        i++;
                        parseWhitespaceAndSkipComments();
                    }
                    if (i >= text.length) // reached the end of the document properly
                    return output;
                    throwUnexpectedCharacter();
                    function parseValue() {
                        parseWhitespaceAndSkipComments();
                        const processed = parseObject() || parseArray() || parseString() || parseNumber() || parseKeywords() || parseUnquotedString(false) || parseRegex();
                        parseWhitespaceAndSkipComments();
                        return processed;
                    }
                    function parseWhitespaceAndSkipComments() {
                        let skipNewline = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
                        const start = i;
                        let changed = parseWhitespace(skipNewline);
                        do {
                            changed = parseComment();
                            if (changed) changed = parseWhitespace(skipNewline);
                        }while (changed);
                        return i > start;
                    }
                    function parseWhitespace(skipNewline) {
                        const _isWhiteSpace = skipNewline ? isWhitespace : isWhitespaceExceptNewline;
                        let whitespace = '';
                        while(true){
                            if (_isWhiteSpace(text, i)) {
                                whitespace += text[i];
                                i++;
                            } else if (isSpecialWhitespace(text, i)) {
                                // repair special whitespace
                                whitespace += ' ';
                                i++;
                            } else break;
                        }
                        if (whitespace.length > 0) {
                            output += whitespace;
                            return true;
                        }
                        return false;
                    }
                    function parseComment() {
                        // find a block comment '/* ... */'
                        if (text[i] === '/' && text[i + 1] === '*') {
                            // repair block comment by skipping it
                            while(i < text.length && !atEndOfBlockComment(text, i))i++;
                            i += 2;
                            return true;
                        }
                        // find a line comment '// ...'
                        if (text[i] === '/' && text[i + 1] === '/') {
                            // repair line comment by skipping it
                            while(i < text.length && text[i] !== '\n')i++;
                            return true;
                        }
                        return false;
                    }
                    function parseMarkdownCodeBlock() {
                        // find and skip over a Markdown fenced code block:
                        //     ``` ... ```
                        // or
                        //     ```json ... ```
                        if (text.slice(i, i + 3) === '```') {
                            i += 3;
                            if (isFunctionNameCharStart(text[i])) // strip the optional language specifier like "json"
                            while(i < text.length && isFunctionNameChar(text[i]))i++;
                            parseWhitespaceAndSkipComments();
                            return true;
                        }
                        return false;
                    }
                    function parseCharacter(char) {
                        if (text[i] === char) {
                            output += text[i];
                            i++;
                            return true;
                        }
                        return false;
                    }
                    function skipCharacter(char) {
                        if (text[i] === char) {
                            i++;
                            return true;
                        }
                        return false;
                    }
                    function skipEscapeCharacter() {
                        return skipCharacter('\\');
                    }
                    /**
   * Skip ellipsis like "[1,2,3,...]" or "[1,2,3,...,9]" or "[...,7,8,9]"
   * or a similar construct in objects.
   */ function skipEllipsis() {
                        parseWhitespaceAndSkipComments();
                        if (text[i] === '.' && text[i + 1] === '.' && text[i + 2] === '.') {
                            // repair: remove the ellipsis (three dots) and optionally a comma
                            i += 3;
                            parseWhitespaceAndSkipComments();
                            skipCharacter(',');
                            return true;
                        }
                        return false;
                    }
                    /**
   * Parse an object like '{"key": "value"}'
   */ function parseObject() {
                        if (text[i] === '{') {
                            output += '{';
                            i++;
                            parseWhitespaceAndSkipComments();
                            // repair: skip leading comma like in {, message: "hi"}
                            if (skipCharacter(',')) parseWhitespaceAndSkipComments();
                            let initial = true;
                            while(i < text.length && text[i] !== '}'){
                                let processedComma;
                                if (!initial) {
                                    processedComma = parseCharacter(',');
                                    if (!processedComma) // repair missing comma
                                    output = insertBeforeLastWhitespace(output, ',');
                                    parseWhitespaceAndSkipComments();
                                } else {
                                    processedComma = true;
                                    initial = false;
                                }
                                skipEllipsis();
                                const processedKey = parseString() || parseUnquotedString(true);
                                if (!processedKey) {
                                    if (text[i] === '}' || text[i] === '{' || text[i] === ']' || text[i] === '[' || text[i] === undefined) // repair trailing comma
                                    output = stripLastOccurrence(output, ',');
                                    else throwObjectKeyExpected();
                                    break;
                                }
                                parseWhitespaceAndSkipComments();
                                const processedColon = parseCharacter(':');
                                const truncatedText = i >= text.length;
                                if (!processedColon) {
                                    if (isStartOfValue(text[i]) || truncatedText) // repair missing colon
                                    output = insertBeforeLastWhitespace(output, ':');
                                    else throwColonExpected();
                                }
                                const processedValue = parseValue();
                                if (!processedValue) {
                                    if (processedColon || truncatedText) // repair missing object value
                                    output += 'null';
                                    else throwColonExpected();
                                }
                            }
                            if (text[i] === '}') {
                                output += '}';
                                i++;
                            } else // repair missing end bracket
                            output = insertBeforeLastWhitespace(output, '}');
                            return true;
                        }
                        return false;
                    }
                    /**
   * Parse an array like '["item1", "item2", ...]'
   */ function parseArray() {
                        if (text[i] === '[') {
                            output += '[';
                            i++;
                            parseWhitespaceAndSkipComments();
                            // repair: skip leading comma like in [,1,2,3]
                            if (skipCharacter(',')) parseWhitespaceAndSkipComments();
                            let initial = true;
                            while(i < text.length && text[i] !== ']'){
                                if (!initial) {
                                    const processedComma = parseCharacter(',');
                                    if (!processedComma) // repair missing comma
                                    output = insertBeforeLastWhitespace(output, ',');
                                } else initial = false;
                                skipEllipsis();
                                const processedValue = parseValue();
                                if (!processedValue) {
                                    // repair trailing comma
                                    output = stripLastOccurrence(output, ',');
                                    break;
                                }
                            }
                            if (text[i] === ']') {
                                output += ']';
                                i++;
                            } else // repair missing closing array bracket
                            output = insertBeforeLastWhitespace(output, ']');
                            return true;
                        }
                        return false;
                    }
                    /**
   * Parse and repair Newline Delimited JSON (NDJSON):
   * multiple JSON objects separated by a newline character
   */ function parseNewlineDelimitedJSON() {
                        // repair NDJSON
                        let initial = true;
                        let processedValue = true;
                        while(processedValue){
                            if (!initial) {
                                // parse optional comma, insert when missing
                                const processedComma = parseCharacter(',');
                                if (!processedComma) // repair: add missing comma
                                output = insertBeforeLastWhitespace(output, ',');
                            } else initial = false;
                            processedValue = parseValue();
                        }
                        if (!processedValue) // repair: remove trailing comma
                        output = stripLastOccurrence(output, ',');
                        // repair: wrap the output inside array brackets
                        output = "[\n".concat(output, "\n]");
                    }
                    /**
   * Parse a string enclosed by double quotes "...". Can contain escaped quotes
   * Repair strings enclosed in single quotes or special quotes
   * Repair an escaped string
   *
   * The function can run in two stages:
   * - First, it assumes the string has a valid end quote
   * - If it turns out that the string does not have a valid end quote followed
   *   by a delimiter (which should be the case), the function runs again in a
   *   more conservative way, stopping the string at the first next delimiter
   *   and fixing the string by inserting a quote there, or stopping at a
   *   stop index detected in the first iteration.
   */ function parseString() {
                        let stopAtDelimiter = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
                        let stopAtIndex = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : -1;
                        let skipEscapeChars = text[i] === '\\';
                        if (skipEscapeChars) {
                            // repair: remove the first escape character
                            i++;
                            skipEscapeChars = true;
                        }
                        if (isQuote(text[i])) {
                            // double quotes are correct JSON,
                            // single quotes come from JavaScript for example, we assume it will have a correct single end quote too
                            // otherwise, we will match any double-quote-like start with a double-quote-like end,
                            // or any single-quote-like start with a single-quote-like end
                            const isEndQuote = isDoubleQuote(text[i]) ? isDoubleQuote : isSingleQuote(text[i]) ? isSingleQuote : isSingleQuoteLike(text[i]) ? isSingleQuoteLike : isDoubleQuoteLike;
                            const iBefore = i;
                            const oBefore = output.length;
                            let str = '"';
                            i++;
                            while(true){
                                if (i >= text.length) {
                                    // end of text, we are missing an end quote
                                    const iPrev = prevNonWhitespaceIndex(i - 1);
                                    if (!stopAtDelimiter && isDelimiter(text.charAt(iPrev))) {
                                        // if the text ends with a delimiter, like ["hello],
                                        // so the missing end quote should be inserted before this delimiter
                                        // retry parsing the string, stopping at the first next delimiter
                                        i = iBefore;
                                        output = output.substring(0, oBefore);
                                        return parseString(true);
                                    }
                                    // repair missing quote
                                    str = insertBeforeLastWhitespace(str, '"');
                                    output += str;
                                    return true;
                                // biome-ignore lint/style/noUselessElse: <explanation>
                                } else if (i === stopAtIndex) {
                                    // use the stop index detected in the first iteration, and repair end quote
                                    str = insertBeforeLastWhitespace(str, '"');
                                    output += str;
                                    return true;
                                // biome-ignore lint/style/noUselessElse: <explanation>
                                } else if (isEndQuote(text[i])) {
                                    // end quote
                                    // let us check what is before and after the quote to verify whether this is a legit end quote
                                    const iQuote = i;
                                    const oQuote = str.length;
                                    str += '"';
                                    i++;
                                    output += str;
                                    parseWhitespaceAndSkipComments(false);
                                    if (stopAtDelimiter || i >= text.length || isDelimiter(text[i]) || isQuote(text[i]) || isDigit(text[i])) {
                                        // The quote is followed by the end of the text, a delimiter,
                                        // or a next value. So the quote is indeed the end of the string.
                                        parseConcatenatedString();
                                        return true;
                                    }
                                    const iPrevChar = prevNonWhitespaceIndex(iQuote - 1);
                                    const prevChar = text.charAt(iPrevChar);
                                    if (prevChar === ',') {
                                        // A comma followed by a quote, like '{"a":"b,c,"d":"e"}'.
                                        // We assume that the quote is a start quote, and that the end quote
                                        // should have been located right before the comma but is missing.
                                        i = iBefore;
                                        output = output.substring(0, oBefore);
                                        return parseString(false, iPrevChar);
                                    }
                                    if (isDelimiter(prevChar)) {
                                        // This is not the right end quote: it is preceded by a delimiter,
                                        // and NOT followed by a delimiter. So, there is an end quote missing
                                        // parse the string again and then stop at the first next delimiter
                                        i = iBefore;
                                        output = output.substring(0, oBefore);
                                        return parseString(true);
                                    }
                                    // revert to right after the quote but before any whitespace, and continue parsing the string
                                    output = output.substring(0, oBefore);
                                    i = iQuote + 1;
                                    // repair unescaped quote
                                    str = "".concat(str.substring(0, oQuote), "\\").concat(str.substring(oQuote));
                                } else if (stopAtDelimiter && isUnquotedStringDelimiter(text[i])) {
                                    // we're in the mode to stop the string at the first delimiter
                                    // because there is an end quote missing
                                    // test start of an url like "https://..." (this would be parsed as a comment)
                                    if (text[i - 1] === ':' && regexUrlStart.test(text.substring(iBefore + 1, i + 2))) while(i < text.length && regexUrlChar.test(text[i])){
                                        str += text[i];
                                        i++;
                                    }
                                    // repair missing quote
                                    str = insertBeforeLastWhitespace(str, '"');
                                    output += str;
                                    parseConcatenatedString();
                                    return true;
                                } else if (text[i] === '\\') {
                                    // handle escaped content like \n or \u2605
                                    const char = text.charAt(i + 1);
                                    const escapeChar = escapeCharacters[char];
                                    if (escapeChar !== undefined) {
                                        str += text.slice(i, i + 2);
                                        i += 2;
                                    } else if (char === 'u') {
                                        let j = 2;
                                        while(j < 6 && isHex(text[i + j]))j++;
                                        if (j === 6) {
                                            str += text.slice(i, i + 6);
                                            i += 6;
                                        } else if (i + j >= text.length) // repair invalid or truncated unicode char at the end of the text
                                        // by removing the unicode char and ending the string here
                                        i = text.length;
                                        else throwInvalidUnicodeCharacter();
                                    } else {
                                        // repair invalid escape character: remove it
                                        str += char;
                                        i += 2;
                                    }
                                } else {
                                    // handle regular characters
                                    const char = text.charAt(i);
                                    if (char === '"' && text[i - 1] !== '\\') {
                                        // repair unescaped double quote
                                        str += "\\".concat(char);
                                        i++;
                                    } else if (isControlCharacter(char)) {
                                        // unescaped control character
                                        str += controlCharacters[char];
                                        i++;
                                    } else {
                                        if (!isValidStringCharacter(char)) throwInvalidCharacter(char);
                                        str += char;
                                        i++;
                                    }
                                }
                                if (skipEscapeChars) // repair: skipped escape character (nothing to do)
                                skipEscapeCharacter();
                            }
                        }
                        return false;
                    }
                    /**
   * Repair concatenated strings like "hello" + "world", change this into "helloworld"
   */ function parseConcatenatedString() {
                        let processed = false;
                        parseWhitespaceAndSkipComments();
                        while(text[i] === '+'){
                            processed = true;
                            i++;
                            parseWhitespaceAndSkipComments();
                            // repair: remove the end quote of the first string
                            output = stripLastOccurrence(output, '"', true);
                            const start = output.length;
                            const parsedStr = parseString();
                            if (parsedStr) // repair: remove the start quote of the second string
                            output = removeAtIndex(output, start, 1);
                            else // repair: remove the + because it is not followed by a string
                            output = insertBeforeLastWhitespace(output, '"');
                        }
                        return processed;
                    }
                    /**
   * Parse a number like 2.4 or 2.4e6
   */ function parseNumber() {
                        const start = i;
                        if (text[i] === '-') {
                            i++;
                            if (atEndOfNumber()) {
                                repairNumberEndingWithNumericSymbol(start);
                                return true;
                            }
                            if (!isDigit(text[i])) {
                                i = start;
                                return false;
                            }
                        }
                        // Note that in JSON leading zeros like "00789" are not allowed.
                        // We will allow all leading zeros here though and at the end of parseNumber
                        // check against trailing zeros and repair that if needed.
                        // Leading zeros can have meaning, so we should not clear them.
                        while(isDigit(text[i]))i++;
                        if (text[i] === '.') {
                            i++;
                            if (atEndOfNumber()) {
                                repairNumberEndingWithNumericSymbol(start);
                                return true;
                            }
                            if (!isDigit(text[i])) {
                                i = start;
                                return false;
                            }
                            while(isDigit(text[i]))i++;
                        }
                        if (text[i] === 'e' || text[i] === 'E') {
                            i++;
                            if (text[i] === '-' || text[i] === '+') i++;
                            if (atEndOfNumber()) {
                                repairNumberEndingWithNumericSymbol(start);
                                return true;
                            }
                            if (!isDigit(text[i])) {
                                i = start;
                                return false;
                            }
                            while(isDigit(text[i]))i++;
                        }
                        // if we're not at the end of the number by this point, allow this to be parsed as another type
                        if (!atEndOfNumber()) {
                            i = start;
                            return false;
                        }
                        if (i > start) {
                            // repair a number with leading zeros like "00789"
                            const num = text.slice(start, i);
                            const hasInvalidLeadingZero = /^0\d/.test(num);
                            output += hasInvalidLeadingZero ? "\"".concat(num, "\"") : num;
                            return true;
                        }
                        return false;
                    }
                    /**
   * Parse keywords true, false, null
   * Repair Python keywords True, False, None
   */ function parseKeywords() {
                        return parseKeyword('true', 'true') || parseKeyword('false', 'false') || parseKeyword('null', 'null') || // repair Python keywords True, False, None
                        parseKeyword('True', 'true') || parseKeyword('False', 'false') || parseKeyword('None', 'null');
                    }
                    function parseKeyword(name, value) {
                        if (text.slice(i, i + name.length) === name) {
                            output += value;
                            i += name.length;
                            return true;
                        }
                        return false;
                    }
                    /**
   * Repair an unquoted string by adding quotes around it
   * Repair a MongoDB function call like NumberLong("2")
   * Repair a JSONP function call like callback({...});
   */ function parseUnquotedString(isKey) {
                        // note that the symbol can end with whitespaces: we stop at the next delimiter
                        // also, note that we allow strings to contain a slash / in order to support repairing regular expressions
                        const start = i;
                        if (isFunctionNameCharStart(text[i])) {
                            while(i < text.length && isFunctionNameChar(text[i]))i++;
                            let j = i;
                            while(isWhitespace(text, j))j++;
                            if (text[j] === '(') {
                                // repair a MongoDB function call like NumberLong("2")
                                // repair a JSONP function call like callback({...});
                                i = j + 1;
                                parseValue();
                                if (text[i] === ')') {
                                    // repair: skip close bracket of function call
                                    i++;
                                    if (text[i] === ';') // repair: skip semicolon after JSONP call
                                    i++;
                                }
                                return true;
                            }
                        }
                        while(i < text.length && !isUnquotedStringDelimiter(text[i]) && !isQuote(text[i]) && (!isKey || text[i] !== ':'))i++;
                        // test start of an url like "https://..." (this would be parsed as a comment)
                        if (text[i - 1] === ':' && regexUrlStart.test(text.substring(start, i + 2))) while(i < text.length && regexUrlChar.test(text[i]))i++;
                        if (i > start) {
                            // repair unquoted string
                            // also, repair undefined into null
                            // first, go back to prevent getting trailing whitespaces in the string
                            while(isWhitespace(text, i - 1) && i > 0)i--;
                            const symbol = text.slice(start, i);
                            output += symbol === 'undefined' ? 'null' : JSON.stringify(symbol);
                            if (text[i] === '"') // we had a missing start quote, but now we encountered the end quote, so we can skip that one
                            i++;
                            return true;
                        }
                    }
                    function parseRegex() {
                        if (text[i] === '/') {
                            const start = i;
                            i++;
                            while(i < text.length && (text[i] !== '/' || text[i - 1] === '\\'))i++;
                            i++;
                            output += "\"".concat(text.substring(start, i), "\"");
                            return true;
                        }
                    }
                    function prevNonWhitespaceIndex(start) {
                        let prev = start;
                        while(prev > 0 && isWhitespace(text, prev))prev--;
                        return prev;
                    }
                    function atEndOfNumber() {
                        return i >= text.length || isDelimiter(text[i]) || isWhitespace(text, i);
                    }
                    function repairNumberEndingWithNumericSymbol(start) {
                        // repair numbers cut off at the end
                        // this will only be called when we end after a '.', '-', or 'e' and does not
                        // change the number more than it needs to make it valid JSON
                        output += "".concat(text.slice(start, i), "0");
                    }
                    function throwInvalidCharacter(char) {
                        throw new JSONRepairError("Invalid character ".concat(JSON.stringify(char)), i);
                    }
                    function throwUnexpectedCharacter() {
                        throw new JSONRepairError("Unexpected character ".concat(JSON.stringify(text[i])), i);
                    }
                    function throwUnexpectedEnd() {
                        throw new JSONRepairError('Unexpected end of json string', text.length);
                    }
                    function throwObjectKeyExpected() {
                        throw new JSONRepairError('Object key expected', i);
                    }
                    function throwColonExpected() {
                        throw new JSONRepairError('Colon expected', i);
                    }
                    function throwInvalidUnicodeCharacter() {
                        const chars = text.slice(i, i + 6);
                        throw new JSONRepairError("Invalid unicode character \"".concat(chars, "\""), i);
                    }
                }
                function atEndOfBlockComment(text, i) {
                    return text[i] === '*' && text[i + 1] === '/';
                }
            /***/ },
            /***/ 870: /***/ function(__unused_webpack_module, exports, __webpack_require__) {
                exports.tryRequireAjv = function() {
                    try {
                        return __webpack_require__(Object(function webpackMissingModule() {
                            var e = new Error("Cannot find module 'ajv'");
                            e.code = 'MODULE_NOT_FOUND';
                            throw e;
                        }()));
                    } catch (err) {
                    // no problem... when we need Ajv we will throw a neat exception
                    }
                };
            /***/ },
            /***/ 877: /***/ function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {
                "use strict";
                /* harmony export */ __webpack_require__.d(__webpack_exports__, {
                    /* harmony export */ $: function() {
                        return /* binding */ FocusTracker;
                    }
                });
                /**
 * @constructor FocusTracker
 * A custom focus tracker for a DOM element with complex internal DOM structure
 * @param  {[Object]} config    A set of configurations for the FocusTracker
 *                {DOM Object} target *    The DOM object to track (required)
 *                {Function}   onFocus     onFocus callback
 *                {Function}   onBlur      onBlur callback
 *
 * @return
 */ function _typeof(o) {
                    "@babel/helpers - typeof";
                    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
                        return typeof o;
                    } : function(o) {
                        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
                    }, _typeof(o);
                }
                function _classCallCheck(a, n) {
                    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
                }
                function _defineProperties(e, r) {
                    for(var t = 0; t < r.length; t++){
                        var o = r[t];
                        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
                    }
                }
                function _createClass(e, r, t) {
                    return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
                        writable: !1
                    }), e;
                }
                function _toPropertyKey(t) {
                    var i = _toPrimitive(t, "string");
                    return "symbol" == _typeof(i) ? i : i + "";
                }
                function _toPrimitive(t, r) {
                    if ("object" != _typeof(t) || !t) return t;
                    var e = t[Symbol.toPrimitive];
                    if (void 0 !== e) {
                        var i = e.call(t, r || "default");
                        if ("object" != _typeof(i)) return i;
                        throw new TypeError("@@toPrimitive must return a primitive value.");
                    }
                    return ("string" === r ? String : Number)(t);
                }
                var FocusTracker = /*#__PURE__*/ function() {
                    function FocusTracker(config) {
                        _classCallCheck(this, FocusTracker);
                        this.target = config.target || null;
                        if (!this.target) throw new Error('FocusTracker constructor called without a "target" to track.');
                        this.onFocus = typeof config.onFocus === 'function' ? config.onFocus : null;
                        this.onBlur = typeof config.onBlur === 'function' ? config.onBlur : null;
                        this._onClick = this._onEvent.bind(this);
                        this._onKeyUp = (function(event) {
                            if (event.which === 9 || event.keyCode === 9) this._onEvent(event);
                        }).bind(this);
                        this._onBlur = this._onEvent.bind(this);
                        this.focusFlag = false;
                        this.firstEventFlag = true;
                        /*
      Adds required (click and keyup) event listeners to the 'document' object
      to track the focus of the given 'target'
     */ if (this.onFocus || this.onBlur) {
                            document.addEventListener('click', this._onClick);
                            document.addEventListener('keyup', this._onKeyUp);
                            document.addEventListener('blur', this._onBlur);
                        }
                    }
                    /**
     * Removes the event listeners on the 'document' object
     * that were added to track the focus of the given 'target'
     */ return _createClass(FocusTracker, [
                        {
                            key: "destroy",
                            value: function destroy() {
                                document.removeEventListener('click', this._onClick);
                                document.removeEventListener('keyup', this._onKeyUp);
                                document.removeEventListener('blur', this._onBlur);
                                this._onEvent({
                                    target: document.body
                                }); // calling _onEvent with body element in the hope that the FocusTracker is added to an element inside the body tag
                            }
                        },
                        {
                            key: "_onEvent",
                            value: function _onEvent(event) {
                                var target = event.target;
                                var focusFlag;
                                if (target === this.target) focusFlag = true;
                                else if (this.target.contains(target) || this.target.contains(document.activeElement)) focusFlag = true;
                                else focusFlag = false;
                                if (focusFlag) {
                                    if (!this.focusFlag) {
                                        // trigger the onFocus callback
                                        if (this.onFocus) this.onFocus({
                                            type: 'focus',
                                            target: this.target
                                        });
                                        this.focusFlag = true;
                                    }
                                } else if (this.focusFlag || this.firstEventFlag) {
                                    // trigger the onBlur callback
                                    if (this.onBlur) this.onBlur({
                                        type: 'blur',
                                        target: this.target
                                    });
                                    this.focusFlag = false;
                                    /*
            When switching from one mode to another in the editor, the FocusTracker gets recreated.
            At that time, this.focusFlag will be init to 'false' and will fail the above if condition, when blur occurs
            this.firstEventFlag is added to overcome that issue
           */ if (this.firstEventFlag) this.firstEventFlag = false;
                                }
                            }
                        }
                    ]);
                }();
            /***/ },
            /***/ 915: /***/ function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {
                "use strict";
                __webpack_require__.r(__webpack_exports__);
                /* harmony export */ __webpack_require__.d(__webpack_exports__, {
                    /* harmony export */ showSortModal: function() {
                        return /* binding */ showSortModal;
                    }
                });
                /* harmony import */ var picomodal__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(340);
                /* harmony import */ var picomodal__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/ __webpack_require__.n(picomodal__WEBPACK_IMPORTED_MODULE_0__);
                /* harmony import */ var _i18n__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(57);
                /* harmony import */ var _util__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(237);
                /**
 * Show advanced sorting modal
 * @param {HTMLElement} container   The container where to center
 *                                  the modal and create an overlay
 * @param {JSON} json               The JSON data to be sorted.
 * @param {function} onSort         Callback function, invoked with
 *                                  an object containing the selected
 *                                  path and direction
 * @param {Object} options
 *            Available options:
 *                - {string} path              The selected path
 *                - {'asc' | 'desc'} direction The selected direction
 */ function showSortModal(container, json, onSort, options) {
                    var paths = Array.isArray(json) ? (0, _util__WEBPACK_IMPORTED_MODULE_2__.getChildPaths)(json) : [
                        ''
                    ];
                    var selectedPath = options && options.path && (0, _util__WEBPACK_IMPORTED_MODULE_2__.contains)(paths, options.path) ? options.path : paths[0];
                    var selectedDirection = options && options.direction || 'asc';
                    var content = '<div class="pico-modal-contents"><div class="pico-modal-header">' + (0, _i18n__WEBPACK_IMPORTED_MODULE_1__ /* .translate */ .Tl)('sort') + '</div>' + '<form>' + '<table>' + '<tbody>' + '<tr>' + '  <td>' + (0, _i18n__WEBPACK_IMPORTED_MODULE_1__ /* .translate */ .Tl)('sortFieldLabel') + ' </td>' + '  <td class="jsoneditor-modal-input">' + '  <div class="jsoneditor-select-wrapper">' + '    <select id="field" title="' + (0, _i18n__WEBPACK_IMPORTED_MODULE_1__ /* .translate */ .Tl)('sortFieldTitle') + '">' + '    </select>' + '  </div>' + '  </td>' + '</tr>' + '<tr>' + '  <td>' + (0, _i18n__WEBPACK_IMPORTED_MODULE_1__ /* .translate */ .Tl)('sortDirectionLabel') + ' </td>' + '  <td class="jsoneditor-modal-input">' + '  <div id="direction" class="jsoneditor-button-group">' + '<input type="button" ' + 'value="' + (0, _i18n__WEBPACK_IMPORTED_MODULE_1__ /* .translate */ .Tl)('sortAscending') + '" ' + 'title="' + (0, _i18n__WEBPACK_IMPORTED_MODULE_1__ /* .translate */ .Tl)('sortAscendingTitle') + '" ' + 'data-value="asc" ' + 'class="jsoneditor-button-first jsoneditor-button-asc"/>' + '<input type="button" ' + 'value="' + (0, _i18n__WEBPACK_IMPORTED_MODULE_1__ /* .translate */ .Tl)('sortDescending') + '" ' + 'title="' + (0, _i18n__WEBPACK_IMPORTED_MODULE_1__ /* .translate */ .Tl)('sortDescendingTitle') + '" ' + 'data-value="desc" ' + 'class="jsoneditor-button-last jsoneditor-button-desc"/>' + '  </div>' + '  </td>' + '</tr>' + '<tr>' + '<td colspan="2" class="jsoneditor-modal-input jsoneditor-modal-actions">' + '  <input type="submit" id="ok" value="' + (0, _i18n__WEBPACK_IMPORTED_MODULE_1__ /* .translate */ .Tl)('ok') + '" />' + '</td>' + '</tr>' + '</tbody>' + '</table>' + '</form>' + '</div>';
                    picomodal__WEBPACK_IMPORTED_MODULE_0___default()({
                        parent: container,
                        content: content,
                        overlayClass: 'jsoneditor-modal-overlay',
                        overlayStyles: {
                            backgroundColor: 'rgb(1,1,1)',
                            opacity: 0.3
                        },
                        modalClass: 'jsoneditor-modal jsoneditor-modal-sort'
                    }).afterCreate(function(modal) {
                        var form = modal.modalElem().querySelector('form');
                        var ok = modal.modalElem().querySelector('#ok');
                        var field = modal.modalElem().querySelector('#field');
                        var direction = modal.modalElem().querySelector('#direction');
                        function preprocessPath(path) {
                            return path === '' ? '@' : path[0] === '.' ? path.slice(1) : path;
                        }
                        paths.forEach(function(path) {
                            var option = document.createElement('option');
                            option.text = preprocessPath(path);
                            option.value = path;
                            field.appendChild(option);
                        });
                        function setDirection(value) {
                            direction.value = value;
                            direction.className = 'jsoneditor-button-group jsoneditor-button-group-value-' + direction.value;
                        }
                        field.value = selectedPath || paths[0];
                        setDirection(selectedDirection || 'asc');
                        direction.onclick = function(event) {
                            setDirection(event.target.getAttribute('data-value'));
                        };
                        ok.onclick = function(event) {
                            event.preventDefault();
                            event.stopPropagation();
                            modal.close();
                            onSort({
                                path: field.value,
                                direction: direction.value
                            });
                        };
                        if (form) // form is not available when JSONEditor is created inside a form
                        form.onsubmit = ok.onclick;
                    }).afterClose(function(modal) {
                        modal.destroy();
                    }).show();
                }
            /***/ },
            /***/ 925: /***/ function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {
                "use strict";
                /* harmony export */ __webpack_require__.d(__webpack_exports__, {
                    /* harmony export */ p: function() {
                        return /* binding */ createAbsoluteAnchor;
                    }
                });
                /* harmony import */ var _util__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(237);
                /**
 * Create an anchor element absolutely positioned in the `parent`
 * element.
 * @param {HTMLElement} anchor
 * @param {HTMLElement} parent
 * @param {function(HTMLElement)} [onDestroy]  Callback when the anchor is destroyed
 * @param {boolean} [destroyOnMouseOut=false] If true, anchor will be removed on mouse out
 * @returns {HTMLElement}
 */ function createAbsoluteAnchor(anchor, parent, onDestroy) {
                    var destroyOnMouseOut = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
                    var root = getRootNode(anchor);
                    var eventListeners = {};
                    var anchorRect = anchor.getBoundingClientRect();
                    var parentRect = parent.getBoundingClientRect();
                    var absoluteAnchor = document.createElement('div');
                    absoluteAnchor.className = 'jsoneditor-anchor';
                    absoluteAnchor.style.position = 'absolute';
                    absoluteAnchor.style.left = anchorRect.left - parentRect.left + 'px';
                    absoluteAnchor.style.top = anchorRect.top - parentRect.top + 'px';
                    absoluteAnchor.style.width = anchorRect.width - 2 + 'px';
                    absoluteAnchor.style.height = anchorRect.height - 2 + 'px';
                    absoluteAnchor.style.boxSizing = 'border-box';
                    parent.appendChild(absoluteAnchor);
                    function destroy() {
                        // remove temporary absolutely positioned anchor
                        if (absoluteAnchor && absoluteAnchor.parentNode) {
                            absoluteAnchor.parentNode.removeChild(absoluteAnchor);
                            // remove all event listeners
                            // all event listeners are supposed to be attached to document.
                            for(var name in eventListeners)if (hasOwnProperty1(eventListeners, name)) {
                                var fn = eventListeners[name];
                                if (fn) (0, _util__WEBPACK_IMPORTED_MODULE_0__.removeEventListener)(root, name, fn);
                                delete eventListeners[name];
                            }
                            if (typeof onDestroy === 'function') onDestroy(anchor);
                        }
                    }
                    function isOutside(target) {
                        return target !== absoluteAnchor && !(0, _util__WEBPACK_IMPORTED_MODULE_0__.isChildOf)(target, absoluteAnchor);
                    }
                    // create and attach event listeners
                    function destroyIfOutside(event) {
                        if (isOutside(event.target)) destroy();
                    }
                    eventListeners.mousedown = (0, _util__WEBPACK_IMPORTED_MODULE_0__.addEventListener)(root, 'mousedown', destroyIfOutside);
                    eventListeners.mousewheel = (0, _util__WEBPACK_IMPORTED_MODULE_0__.addEventListener)(root, 'mousewheel', destroyIfOutside);
                    if (destroyOnMouseOut) {
                        var destroyTimer = null;
                        absoluteAnchor.onmouseover = function() {
                            clearTimeout(destroyTimer);
                            destroyTimer = null;
                        };
                        absoluteAnchor.onmouseout = function() {
                            if (!destroyTimer) destroyTimer = setTimeout(destroy, 200);
                        };
                    }
                    absoluteAnchor.destroy = destroy;
                    return absoluteAnchor;
                }
                /**
 * Node.getRootNode shim
 * @param  {HTMLElement} node node to check
 * @return {HTMLElement}      node's rootNode or `window` if there is ShadowDOM is not supported.
 */ function getRootNode(node) {
                    return typeof node.getRootNode === 'function' ? node.getRootNode() : window;
                }
                function hasOwnProperty1(object, key) {
                    return Object.prototype.hasOwnProperty.call(object, key);
                }
            /***/ },
            /***/ 948: /***/ function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {
                "use strict";
                // ESM COMPAT FLAG
                __webpack_require__.r(__webpack_exports__);
                // EXPORTS
                __webpack_require__.d(__webpack_exports__, {
                    textModeMixins: function() {
                        return /* binding */ textModeMixins;
                    }
                });
                // EXTERNAL MODULE: ./node_modules/jsonrepair/lib/esm/regular/jsonrepair.js + 2 modules
                var jsonrepair = __webpack_require__(857);
                // EXTERNAL MODULE: ./src/js/ace/index.js
                var ace = __webpack_require__(413);
                var ace_default = /*#__PURE__*/ __webpack_require__.n(ace);
                // EXTERNAL MODULE: ./src/js/constants.js
                var constants = __webpack_require__(660);
                // EXTERNAL MODULE: ./src/js/ErrorTable.js
                var ErrorTable = __webpack_require__(115);
                // EXTERNAL MODULE: ./src/js/FocusTracker.js
                var FocusTracker = __webpack_require__(877);
                // EXTERNAL MODULE: ./src/js/i18n.js
                var i18n = __webpack_require__(57);
                // EXTERNAL MODULE: ./src/js/jmespathQuery.js
                var jmespathQuery = __webpack_require__(359);
                // EXTERNAL MODULE: ./src/js/ModeSwitcher.js
                var ModeSwitcher = __webpack_require__(389);
                // EXTERNAL MODULE: ./src/js/showSortModal.js
                var showSortModal = __webpack_require__(915);
                // EXTERNAL MODULE: ./src/js/showTransformModal.js + 1 modules
                var showTransformModal = __webpack_require__(609);
                // EXTERNAL MODULE: ./src/js/tryRequireThemeJsonEditor.js
                var tryRequireThemeJsonEditor = __webpack_require__(467);
                // EXTERNAL MODULE: ./node_modules/json-source-map/index.js
                var json_source_map = __webpack_require__(94);
                // EXTERNAL MODULE: ./src/js/util.js
                var util = __webpack_require__(237);
                function _typeof(o) {
                    "@babel/helpers - typeof";
                    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
                        return typeof o;
                    } : function(o) {
                        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
                    }, _typeof(o);
                }
                function _classCallCheck(a, n) {
                    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
                }
                function _defineProperties(e, r) {
                    for(var t = 0; t < r.length; t++){
                        var o = r[t];
                        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
                    }
                }
                function _createClass(e, r, t) {
                    return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
                        writable: !1
                    }), e;
                }
                function _toPropertyKey(t) {
                    var i = _toPrimitive(t, "string");
                    return "symbol" == _typeof(i) ? i : i + "";
                }
                function _toPrimitive(t, r) {
                    if ("object" != _typeof(t) || !t) return t;
                    var e = t[Symbol.toPrimitive];
                    if (void 0 !== e) {
                        var i = e.call(t, r || "default");
                        if ("object" != _typeof(i)) return i;
                        throw new TypeError("@@toPrimitive must return a primitive value.");
                    }
                    return ("string" === r ? String : Number)(t);
                }
                /**
 * SchemaTextCompleter class implements the ace ext-language_tools completer API,
 * and suggests completions for the text editor that are relative
 * to the cursor position and the json schema
 */ var SchemaTextCompleter = /*#__PURE__*/ function() {
                    function SchemaTextCompleter(schema, schemaRefs) {
                        _classCallCheck(this, SchemaTextCompleter);
                        this.schema = schema;
                        this.schemaRefs = schemaRefs || {};
                        this.suggestions = {};
                        this.suggestionsRefs = {};
                        this._buildSuggestions();
                    }
                    return _createClass(SchemaTextCompleter, [
                        {
                            key: "_buildSuggestions",
                            value: function _buildSuggestions() {
                                this._handleSchemaEntry('', this.schema, this.suggestions);
                                for(var refName in this.schemaRefs){
                                    this.suggestionsRefs[refName] = {};
                                    this._handleSchemaEntry('', this.schemaRefs[refName], this.suggestionsRefs[refName]);
                                }
                            }
                        },
                        {
                            key: "_handleRef",
                            value: function _handleRef(currectPath, refName, suggestionsObj) {
                                suggestionsObj[currectPath] = suggestionsObj[currectPath] || {};
                                suggestionsObj[currectPath].refs = suggestionsObj[currectPath].refs || [];
                                suggestionsObj[currectPath].refs = (0, util.uniqueMergeArrays)(suggestionsObj[currectPath].refs, [
                                    refName
                                ]);
                            }
                        },
                        {
                            key: "_handleSchemaEntry",
                            value: function _handleSchemaEntry(currectPath, schemaNode, suggestionsObj) {
                                if (!schemaNode) {
                                    console.error('SchemaTextCompleter: schema node is missing for path', currectPath);
                                    return;
                                }
                                if (schemaNode.$ref) {
                                    this._handleRef(currectPath, schemaNode.$ref, suggestionsObj);
                                    return;
                                }
                                var ofConditionEntry = this._checkOfConditon(schemaNode);
                                if (ofConditionEntry) {
                                    this._handleOfCondition(currectPath, schemaNode[ofConditionEntry], suggestionsObj);
                                    return;
                                }
                                switch(schemaNode.type){
                                    case 'object':
                                        this._handleObject(currectPath, schemaNode, suggestionsObj);
                                        break;
                                    case 'string':
                                    case 'number':
                                    case 'integer':
                                        this._handlePrimitive(currectPath, schemaNode, suggestionsObj);
                                        break;
                                    case 'boolean':
                                        this._handleBoolean(currectPath, schemaNode, suggestionsObj);
                                        break;
                                    case 'array':
                                        this._handleArray(currectPath, schemaNode, suggestionsObj);
                                }
                            }
                        },
                        {
                            key: "_handleObject",
                            value: function _handleObject(currectPath, schemaNode, suggestionsObj) {
                                var _this = this;
                                if ((0, util.isObject)(schemaNode.properties)) {
                                    var props = Object.keys(schemaNode.properties);
                                    suggestionsObj[currectPath] = suggestionsObj[currectPath] || {};
                                    suggestionsObj[currectPath].props = suggestionsObj[currectPath].props || [];
                                    suggestionsObj[currectPath].props = (0, util.uniqueMergeArrays)(suggestionsObj[currectPath].props, props);
                                    props.forEach(function(prop) {
                                        (0, util.asyncExec)(function() {
                                            _this._handleSchemaEntry("".concat(currectPath, "/").concat(prop), schemaNode.properties[prop], suggestionsObj);
                                        });
                                    });
                                }
                            }
                        },
                        {
                            key: "_handlePrimitive",
                            value: function _handlePrimitive(currectPath, schemaNode, suggestionsObj) {
                                suggestionsObj[currectPath] = suggestionsObj[currectPath] || {};
                                if ((0, util.isArray)(schemaNode.examples)) {
                                    suggestionsObj[currectPath].examples = suggestionsObj[currectPath].examples || [];
                                    suggestionsObj[currectPath].examples = (0, util.uniqueMergeArrays)(suggestionsObj[currectPath].examples, schemaNode.examples);
                                }
                                if ((0, util.isArray)(schemaNode["enum"])) {
                                    suggestionsObj[currectPath]["enum"] = suggestionsObj[currectPath]["enum"] || [];
                                    suggestionsObj[currectPath]["enum"] = (0, util.uniqueMergeArrays)(suggestionsObj[currectPath]["enum"], schemaNode["enum"]);
                                }
                            }
                        },
                        {
                            key: "_handleBoolean",
                            value: function _handleBoolean(currectPath, schemaNode, suggestionsObj) {
                                if (!suggestionsObj[currectPath]) suggestionsObj[currectPath] = {
                                    bool: [
                                        true,
                                        false
                                    ]
                                };
                            }
                        },
                        {
                            key: "_handleArray",
                            value: function _handleArray(currectPath, schemaNode, suggestionsObj) {
                                var _this2 = this;
                                if (schemaNode.items) (0, util.asyncExec)(function() {
                                    _this2._handleSchemaEntry("".concat(currectPath, "/\\d+"), schemaNode.items, suggestionsObj);
                                });
                            }
                        },
                        {
                            key: "_handleOfCondition",
                            value: function _handleOfCondition(currectPath, schemaNode, suggestionsObj) {
                                var _this3 = this;
                                if (schemaNode && schemaNode.length) schemaNode.forEach(function(schemaEntry) {
                                    (0, util.asyncExec)(function() {
                                        _this3._handleSchemaEntry(currectPath, schemaEntry, suggestionsObj);
                                    });
                                });
                            }
                        },
                        {
                            key: "_checkOfConditon",
                            value: function _checkOfConditon(entry) {
                                if (!entry) return;
                                if (entry.oneOf) return 'oneOf';
                                if (entry.anyOf) return 'anyOf';
                                if (entry.allOf) return 'allOf';
                            }
                        },
                        {
                            key: "getCompletions",
                            value: function getCompletions(editor, session, pos, prefix, callback) {
                                var _this4 = this;
                                try {
                                    var map = json_source_map.parse(session.getValue());
                                    var pointers = map.pointers || {};
                                    var processCompletionsCallback = function processCompletionsCallback(suggestions) {
                                        var completions = [];
                                        var score = 0;
                                        var appendSuggesions = function appendSuggesions(type) {
                                            var _suggestions$type;
                                            var typeTitle = {
                                                props: 'property',
                                                "enum": 'enum',
                                                bool: 'boolean',
                                                examples: 'examples'
                                            };
                                            if (suggestions && (_suggestions$type = suggestions[type]) !== null && _suggestions$type !== void 0 && _suggestions$type.length) completions = completions.concat(suggestions[type].map(function(term) {
                                                return {
                                                    caption: term + '',
                                                    meta: "schema [".concat(typeTitle[type], "]"),
                                                    score: score++,
                                                    value: term + ''
                                                };
                                            }));
                                        };
                                        appendSuggesions('props');
                                        appendSuggesions('enum');
                                        appendSuggesions('bool');
                                        appendSuggesions('examples');
                                        if (completions.length) callback(null, completions);
                                    };
                                    Object.keys(pointers).forEach(function(ptr) {
                                        (0, util.asyncExec)(function() {
                                            var _pointers$ptr$key, _pointers$ptr$value, _pointers$ptr$value2, _pointers$ptr$valueEn;
                                            var _matchPointersToPath = function matchPointersToPath(pointer, currentSuggestions, path) {
                                                var option = Object.keys(currentSuggestions).reduce(function(last, key) {
                                                    if (new RegExp("^".concat(path).concat(key)).test(pointer)) {
                                                        if (!last || last.length < key.length) return key;
                                                    }
                                                    return last;
                                                }, null);
                                                if (typeof option === 'string') {
                                                    var _currentSuggestions$o;
                                                    if ((_currentSuggestions$o = currentSuggestions[option]) !== null && _currentSuggestions$o !== void 0 && (_currentSuggestions$o = _currentSuggestions$o.refs) !== null && _currentSuggestions$o !== void 0 && _currentSuggestions$o.length) {
                                                        var mergedSuggestions = {};
                                                        for(var idx in currentSuggestions[option].refs){
                                                            var refName = currentSuggestions[option].refs[idx];
                                                            if (_this4.suggestionsRefs[refName]) {
                                                                var refSuggestion = _matchPointersToPath(pointer, _this4.suggestionsRefs[refName], "".concat(path).concat(option));
                                                                if (refSuggestion !== null && refSuggestion !== void 0 && refSuggestion["enum"]) mergedSuggestions["enum"] = (0, util.uniqueMergeArrays)(mergedSuggestions["enum"], refSuggestion["enum"]);
                                                                if (refSuggestion !== null && refSuggestion !== void 0 && refSuggestion.examples) mergedSuggestions.examples = (0, util.uniqueMergeArrays)(mergedSuggestions.examples, refSuggestion.examples);
                                                                if (refSuggestion !== null && refSuggestion !== void 0 && refSuggestion.bool) mergedSuggestions.bool = (0, util.uniqueMergeArrays)(mergedSuggestions.bool, refSuggestion.bool);
                                                                if (refSuggestion !== null && refSuggestion !== void 0 && refSuggestion.props) mergedSuggestions.props = (0, util.uniqueMergeArrays)(mergedSuggestions.props, refSuggestion.props);
                                                            }
                                                        }
                                                        return mergedSuggestions;
                                                    } else if (new RegExp("^".concat(path).concat(option, "$")).test(pointer)) // console.log('SchemaTextCompleter: Text suggestion match', { path: pointer, schemaPath: `${path}${option}`, suggestions: currentSuggestions[option] })
                                                    return currentSuggestions[option];
                                                }
                                            };
                                            var selectedPtr;
                                            if (((_pointers$ptr$key = pointers[ptr].key) === null || _pointers$ptr$key === void 0 ? void 0 : _pointers$ptr$key.line) === pos.row) {
                                                if (pos.column >= pointers[ptr].key.column && pos.column <= pointers[ptr].keyEnd.column) selectedPtr = ptr.slice(0, ptr.lastIndexOf('/'));
                                            }
                                            if (((_pointers$ptr$value = pointers[ptr].value) === null || _pointers$ptr$value === void 0 ? void 0 : _pointers$ptr$value.line) === pos.row && ((_pointers$ptr$value2 = pointers[ptr].value) === null || _pointers$ptr$value2 === void 0 ? void 0 : _pointers$ptr$value2.line) === ((_pointers$ptr$valueEn = pointers[ptr].valueEnd) === null || _pointers$ptr$valueEn === void 0 ? void 0 : _pointers$ptr$valueEn.line)) // multiline values are objects
                                            {
                                                if (pos.column >= pointers[ptr].value.column && pos.column <= pointers[ptr].valueEnd.column) selectedPtr = ptr;
                                            }
                                            if (selectedPtr) {
                                                var chosenCompletions = _matchPointersToPath(selectedPtr, _this4.suggestions, '');
                                                processCompletionsCallback(chosenCompletions);
                                            }
                                        });
                                    });
                                } catch (e) {
                                // probably not valid json, ignore.
                                }
                            }
                        }
                    ]);
                }();
                /**
 * Execute custom validation if configured.
 *
 * Returns a promise resolving with the custom errors (or an empty array).
 */ function validateCustom(json, onValidate) {
                    if (!onValidate) return Promise.resolve([]);
                    try {
                        var customValidateResults = onValidate(json);
                        var resultPromise = (0, util.isPromise)(customValidateResults) ? customValidateResults : Promise.resolve(customValidateResults);
                        return resultPromise.then(function(customValidationPathErrors) {
                            if (Array.isArray(customValidationPathErrors)) return customValidationPathErrors.filter(function(error) {
                                var valid = (0, util.isValidValidationError)(error);
                                if (!valid) console.warn('Ignoring a custom validation error with invalid structure. Expected structure: {path: [...], message: "..."}. Actual error:', error);
                                return valid;
                            }).map(function(error) {
                                return(// change data structure into the structure matching the JSON schema errors
                                {
                                    dataPath: (0, util.stringifyPath)(error.path),
                                    message: error.message,
                                    type: 'customValidation'
                                });
                            });
                            else return [];
                        });
                    } catch (err) {
                        return Promise.reject(err);
                    }
                }
                function textmode_typeof(o) {
                    "@babel/helpers - typeof";
                    return textmode_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
                        return typeof o;
                    } : function(o) {
                        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
                    }, textmode_typeof(o);
                }
                // create a mixin with the functions for text mode
                var textmode = {};
                var DEFAULT_THEME = 'ace/theme/jsoneditor';
                /**
 * Create a text editor
 * @param {Element} container
 * @param {Object} [options]   Object with options. See docs for details.
 * @private
 */ textmode.create = function(container) {
                    var _this = this;
                    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                    if (typeof options.statusBar === 'undefined') options.statusBar = true;
                    // setting default for textmode
                    options.mainMenuBar = options.mainMenuBar !== false;
                    options.enableSort = options.enableSort !== false;
                    options.enableTransform = options.enableTransform !== false;
                    options.createQuery = options.createQuery || jmespathQuery /* createQuery */ .V;
                    options.executeQuery = options.executeQuery || jmespathQuery /* executeQuery */ .e;
                    options.showErrorTable = options.showErrorTable !== undefined ? options.showErrorTable : [
                        'text',
                        'preview'
                    ];
                    this.options = options;
                    // indentation
                    if (typeof options.indentation === 'number') this.indentation = Number(options.indentation);
                    else this.indentation = 2; // number of spaces
                    // language
                    (0, i18n /* setLanguages */ .AI)(this.options.languages);
                    (0, i18n /* setLanguage */ .xC)(this.options.language);
                    // grab ace from options if provided
                    var _ace = options.ace ? options.ace : ace_default();
                    // TODO: make the option options.ace deprecated, it's not needed anymore (see #309)
                    // determine mode
                    this.mode = options.mode === 'code' ? 'code' : 'text';
                    if (this.mode === 'code') // verify whether Ace editor is available and supported
                    {
                        if (typeof _ace === 'undefined') {
                            this.mode = 'text';
                            console.warn('Failed to load Ace editor, falling back to plain text mode. Please use a JSONEditor bundle including Ace, or pass Ace as via the configuration option `ace`.');
                        }
                    }
                    // determine theme
                    this.theme = options.theme || DEFAULT_THEME;
                    if (this.theme === DEFAULT_THEME && _ace) (0, tryRequireThemeJsonEditor /* tryRequireThemeJsonEditor */ .J)();
                    if (options.onTextSelectionChange) this.onTextSelectionChange(options.onTextSelectionChange);
                    var me = this;
                    this.container = container;
                    this.dom = {};
                    this.aceEditor = undefined; // ace code editor
                    this.textarea = undefined; // plain text editor (fallback when Ace is not available)
                    this.validateSchema = null;
                    this.annotations = [];
                    this.lastSchemaErrors = undefined;
                    // create a debounced validate function
                    this._debouncedValidate = (0, util.debounce)(this._validateAndCatch.bind(this), this.DEBOUNCE_INTERVAL);
                    this.width = container.clientWidth;
                    this.height = container.clientHeight;
                    this.frame = document.createElement('div');
                    this.frame.className = 'jsoneditor jsoneditor-mode-' + this.options.mode;
                    this.frame.onclick = function(event) {
                        // prevent default submit action when the editor is located inside a form
                        event.preventDefault();
                    };
                    this.frame.onkeydown = function(event) {
                        me._onKeyDown(event);
                    };
                    // setting the FocusTracker on 'this.frame' to track the editor's focus event
                    var focusTrackerConfig = {
                        target: this.frame,
                        onFocus: this.options.onFocus || null,
                        onBlur: this.options.onBlur || null
                    };
                    this.frameFocusTracker = new FocusTracker /* FocusTracker */ .$(focusTrackerConfig);
                    this.content = document.createElement('div');
                    this.content.className = 'jsoneditor-outer';
                    if (this.options.mainMenuBar) {
                        (0, util.addClassName)(this.content, 'has-main-menu-bar');
                        // create menu
                        this.menu = document.createElement('div');
                        this.menu.className = 'jsoneditor-menu';
                        this.frame.appendChild(this.menu);
                        // create format button
                        var buttonFormat = document.createElement('button');
                        buttonFormat.type = 'button';
                        buttonFormat.className = 'jsoneditor-format';
                        buttonFormat.title = (0, i18n /* translate */ .Tl)('formatTitle');
                        this.menu.appendChild(buttonFormat);
                        buttonFormat.onclick = function() {
                            try {
                                me.format();
                                me._onChange();
                            } catch (err) {
                                me._onError(err);
                            }
                        };
                        // create compact button
                        var buttonCompact = document.createElement('button');
                        buttonCompact.type = 'button';
                        buttonCompact.className = 'jsoneditor-compact';
                        buttonCompact.title = (0, i18n /* translate */ .Tl)('compactTitle');
                        this.menu.appendChild(buttonCompact);
                        buttonCompact.onclick = function() {
                            try {
                                me.compact();
                                me._onChange();
                            } catch (err) {
                                me._onError(err);
                            }
                        };
                        // create sort button
                        if (this.options.enableSort) {
                            var _sort = document.createElement('button');
                            _sort.type = 'button';
                            _sort.className = 'jsoneditor-sort';
                            _sort.title = (0, i18n /* translate */ .Tl)('sortTitleShort');
                            _sort.onclick = function() {
                                me._showSortModal();
                            };
                            this.menu.appendChild(_sort);
                        }
                        // create transform button
                        if (this.options.enableTransform) {
                            var transform = document.createElement('button');
                            transform.type = 'button';
                            transform.title = (0, i18n /* translate */ .Tl)('transformTitleShort');
                            transform.className = 'jsoneditor-transform';
                            transform.onclick = function() {
                                me._showTransformModal();
                            };
                            this.menu.appendChild(transform);
                        }
                        // create repair button
                        var buttonRepair = document.createElement('button');
                        buttonRepair.type = 'button';
                        buttonRepair.className = 'jsoneditor-repair';
                        buttonRepair.title = (0, i18n /* translate */ .Tl)('repairTitle');
                        this.menu.appendChild(buttonRepair);
                        buttonRepair.onclick = function() {
                            try {
                                me.repair();
                                me._onChange();
                            } catch (err) {
                                me._onError(err);
                            }
                        };
                        // create undo/redo buttons
                        if (this.mode === 'code') {
                            // create undo button
                            var undo = document.createElement('button');
                            undo.type = 'button';
                            undo.className = 'jsoneditor-undo jsoneditor-separator';
                            undo.title = (0, i18n /* translate */ .Tl)('undo');
                            undo.onclick = function() {
                                _this.aceEditor.getSession().getUndoManager().undo();
                            };
                            this.menu.appendChild(undo);
                            this.dom.undo = undo;
                            // create redo button
                            var redo = document.createElement('button');
                            redo.type = 'button';
                            redo.className = 'jsoneditor-redo';
                            redo.title = (0, i18n /* translate */ .Tl)('redo');
                            redo.onclick = function() {
                                _this.aceEditor.getSession().getUndoManager().redo();
                            };
                            this.menu.appendChild(redo);
                            this.dom.redo = redo;
                        }
                        // create mode box
                        if (this.options && this.options.modes && this.options.modes.length) this.modeSwitcher = new ModeSwitcher /* ModeSwitcher */ .n(this.menu, this.options.modes, this.options.mode, function onSwitch(mode) {
                            // switch mode and restore focus
                            try {
                                me.setMode(mode);
                                me.modeSwitcher.focus();
                            } catch (err) {
                                me._onError(err);
                            }
                        });
                        if (this.mode === 'code') {
                            var poweredBy = document.createElement('a');
                            poweredBy.appendChild(document.createTextNode('powered by ace'));
                            poweredBy.href = 'https://ace.c9.io/';
                            poweredBy.target = '_blank';
                            poweredBy.className = 'jsoneditor-poweredBy';
                            poweredBy.onclick = function() {
                                // TODO: this anchor falls below the margin of the content,
                                // therefore the normal a.href does not work. We use a click event
                                // for now, but this should be fixed.
                                window.open(poweredBy.href, poweredBy.target, 'noreferrer');
                            };
                            this.menu.appendChild(poweredBy);
                        }
                    }
                    var emptyNode = {};
                    var isReadOnly = this.options.onEditable && textmode_typeof(this.options.onEditable === 'function') && !this.options.onEditable(emptyNode);
                    this.frame.appendChild(this.content);
                    this.container.appendChild(this.frame);
                    if (this.mode === 'code') {
                        this.editorDom = document.createElement('div');
                        this.editorDom.style.height = '100%'; // TODO: move to css
                        this.editorDom.style.width = '100%'; // TODO: move to css
                        this.content.appendChild(this.editorDom);
                        var aceEditor = _ace.edit(this.editorDom);
                        var aceSession = aceEditor.getSession();
                        aceEditor.$blockScrolling = Infinity;
                        aceEditor.setTheme(this.theme);
                        aceEditor.setOptions({
                            readOnly: isReadOnly
                        });
                        aceEditor.setShowPrintMargin(false);
                        aceEditor.setFontSize('14px');
                        aceSession.setMode('ace/mode/json');
                        aceSession.setTabSize(this.indentation);
                        aceSession.setUseSoftTabs(true);
                        aceSession.setUseWrapMode(true);
                        // replace ace setAnnotations with custom function that also covers jsoneditor annotations
                        var originalSetAnnotations = aceSession.setAnnotations;
                        aceSession.setAnnotations = function(annotations) {
                            originalSetAnnotations.call(this, annotations && annotations.length ? annotations : me.annotations);
                        };
                        // disable Ctrl+L quickkey of Ace (is used by the browser to select the address bar)
                        aceEditor.commands.bindKey('Ctrl-L', null);
                        aceEditor.commands.bindKey('Command-L', null);
                        // disable the quickkeys we want to use for Format and Compact
                        aceEditor.commands.bindKey('Ctrl-\\', null);
                        aceEditor.commands.bindKey('Command-\\', null);
                        aceEditor.commands.bindKey('Ctrl-Shift-\\', null);
                        aceEditor.commands.bindKey('Command-Shift-\\', null);
                        this.aceEditor = aceEditor;
                        // register onchange event
                        aceEditor.on('change', this._onChange.bind(this));
                        aceEditor.on('changeSelection', this._onSelect.bind(this));
                    } else {
                        // load a plain text textarea
                        var textarea = document.createElement('textarea');
                        textarea.className = 'jsoneditor-text';
                        textarea.spellcheck = false;
                        this.content.appendChild(textarea);
                        this.textarea = textarea;
                        this.textarea.readOnly = isReadOnly;
                        // register onchange event
                        if (this.textarea.oninput === null) this.textarea.oninput = this._onChange.bind(this);
                        else // oninput is undefined. For IE8-
                        this.textarea.onchange = this._onChange.bind(this);
                        textarea.onselect = this._onSelect.bind(this);
                        textarea.onmousedown = this._onMouseDown.bind(this);
                        textarea.onblur = this._onBlur.bind(this);
                    }
                    this._updateHistoryButtons();
                    var errorTableVisible = Array.isArray(this.options.showErrorTable) ? this.options.showErrorTable.includes(this.mode) : this.options.showErrorTable === true;
                    this.errorTable = new ErrorTable /* ErrorTable */ .N({
                        errorTableVisible: errorTableVisible,
                        onToggleVisibility: function onToggleVisibility() {
                            me._validateAndCatch();
                        },
                        onFocusLine: function onFocusLine(line) {
                            me.isFocused = true;
                            if (!isNaN(line)) me.setTextSelection({
                                row: line,
                                column: 1
                            }, {
                                row: line,
                                column: 1000
                            });
                        },
                        onChangeHeight: function onChangeHeight(height) {
                            // TODO: change CSS to using flex box, remove setting height using JavaScript
                            var statusBarHeight = me.dom.statusBar ? me.dom.statusBar.clientHeight : 0;
                            var totalHeight = height + statusBarHeight + 1;
                            me.content.style.marginBottom = -totalHeight + 'px';
                            me.content.style.paddingBottom = totalHeight + 'px';
                        }
                    });
                    this.frame.appendChild(this.errorTable.getErrorTable());
                    if (options.statusBar) {
                        (0, util.addClassName)(this.content, 'has-status-bar');
                        this.curserInfoElements = {};
                        var statusBar = document.createElement('div');
                        this.dom.statusBar = statusBar;
                        statusBar.className = 'jsoneditor-statusbar';
                        this.frame.appendChild(statusBar);
                        var lnLabel = document.createElement('span');
                        lnLabel.className = 'jsoneditor-curserinfo-label';
                        lnLabel.innerText = 'Ln:';
                        var lnVal = document.createElement('span');
                        lnVal.className = 'jsoneditor-curserinfo-val';
                        lnVal.innerText = '1';
                        statusBar.appendChild(lnLabel);
                        statusBar.appendChild(lnVal);
                        var colLabel = document.createElement('span');
                        colLabel.className = 'jsoneditor-curserinfo-label';
                        colLabel.innerText = 'Col:';
                        var colVal = document.createElement('span');
                        colVal.className = 'jsoneditor-curserinfo-val';
                        colVal.innerText = '1';
                        statusBar.appendChild(colLabel);
                        statusBar.appendChild(colVal);
                        this.curserInfoElements.colVal = colVal;
                        this.curserInfoElements.lnVal = lnVal;
                        var countLabel = document.createElement('span');
                        countLabel.className = 'jsoneditor-curserinfo-label';
                        countLabel.innerText = 'characters selected';
                        countLabel.style.display = 'none';
                        var countVal = document.createElement('span');
                        countVal.className = 'jsoneditor-curserinfo-count';
                        countVal.innerText = '0';
                        countVal.style.display = 'none';
                        this.curserInfoElements.countLabel = countLabel;
                        this.curserInfoElements.countVal = countVal;
                        statusBar.appendChild(countVal);
                        statusBar.appendChild(countLabel);
                        statusBar.appendChild(this.errorTable.getErrorCounter());
                        statusBar.appendChild(this.errorTable.getWarningIcon());
                        statusBar.appendChild(this.errorTable.getErrorIcon());
                    }
                    this.setSchema(this.options.schema, this.options.schemaRefs);
                };
                textmode._onSchemaChange = function(schema, schemaRefs) {
                    if (!this.aceEditor) return;
                    if (this.options.allowSchemaSuggestions && schema) {
                        this.aceEditor.setOption('enableBasicAutocompletion', [
                            new SchemaTextCompleter(schema, schemaRefs)
                        ]);
                        this.aceEditor.setOption('enableLiveAutocompletion', true);
                    } else {
                        this.aceEditor.setOption('enableBasicAutocompletion', undefined);
                        this.aceEditor.setOption('enableLiveAutocompletion', false);
                    }
                };
                /**
 * Handle a change:
 * - Validate JSON schema
 * - Send a callback to the onChange listener if provided
 * @private
 */ textmode._onChange = function() {
                    var _this2 = this;
                    if (this.onChangeDisabled) return;
                    // enable/disable undo/redo buttons
                    setTimeout(function() {
                        if (_this2._updateHistoryButtons) _this2._updateHistoryButtons();
                    });
                    // validate JSON schema (if configured)
                    this._debouncedValidate();
                    // trigger the onChange callback
                    if (this.options.onChange) try {
                        this.options.onChange();
                    } catch (err) {
                        console.error('Error in onChange callback: ', err);
                    }
                    // trigger the onChangeText callback
                    if (this.options.onChangeText) try {
                        this.options.onChangeText(this.getText());
                    } catch (err) {
                        console.error('Error in onChangeText callback: ', err);
                    }
                };
                textmode._updateHistoryButtons = function() {
                    if (this.aceEditor && this.dom.undo && this.dom.redo) {
                        var undoManager = this.aceEditor.getSession().getUndoManager();
                        if (undoManager && undoManager.hasUndo && undoManager.hasRedo) {
                            this.dom.undo.disabled = !undoManager.hasUndo();
                            this.dom.redo.disabled = !undoManager.hasRedo();
                        }
                    }
                };
                /**
 * Open a sort modal
 * @private
 */ textmode._showSortModal = function() {
                    try {
                        var onSort = function onSort(sortedBy) {
                            if (Array.isArray(json)) {
                                var sortedJson = (0, util.sort)(json, sortedBy.path, sortedBy.direction);
                                me.sortedBy = sortedBy;
                                me.update(sortedJson);
                            }
                            if ((0, util.isObject)(json)) {
                                var _sortedJson = (0, util.sortObjectKeys)(json, sortedBy.direction);
                                me.sortedBy = sortedBy;
                                me.update(_sortedJson);
                            }
                        };
                        var me = this;
                        var container = this.options.modalAnchor || constants /* DEFAULT_MODAL_ANCHOR */ .ai;
                        var json = this.get();
                        (0, showSortModal.showSortModal)(container, json, onSort, me.sortedBy);
                    } catch (err) {
                        this._onError(err);
                    }
                };
                /**
 * Open a transform modal
 * @private
 */ textmode._showTransformModal = function() {
                    var _this3 = this;
                    try {
                        var _this$options = this.options, modalAnchor = _this$options.modalAnchor, _createQuery = _this$options.createQuery, _executeQuery = _this$options.executeQuery, queryDescription = _this$options.queryDescription;
                        var json = this.get();
                        (0, showTransformModal.showTransformModal)({
                            container: modalAnchor || constants /* DEFAULT_MODAL_ANCHOR */ .ai,
                            json: json,
                            queryDescription: queryDescription,
                            // can be undefined
                            createQuery: _createQuery,
                            executeQuery: _executeQuery,
                            onTransform: function onTransform(query) {
                                var updatedJson = _executeQuery(json, query);
                                _this3.update(updatedJson);
                            }
                        });
                    } catch (err) {
                        this._onError(err);
                    }
                };
                /**
 * Handle text selection
 * Calculates the cursor position and selection range and updates menu
 * @private
 */ textmode._onSelect = function() {
                    this._updateCursorInfo();
                    this._emitSelectionChange();
                };
                /**
 * Event handler for keydown. Handles shortcut keys
 * @param {Event} event
 * @private
 */ textmode._onKeyDown = function(event) {
                    var keynum = event.which || event.keyCode;
                    var handled = false;
                    if (keynum === 73 && event.ctrlKey) {
                        if (event.shiftKey) {
                            // Ctrl+Shift+I
                            this.compact();
                            this._onChange();
                        } else {
                            // Ctrl+I
                            this.format();
                            this._onChange();
                        }
                        handled = true;
                    }
                    if (handled) {
                        event.preventDefault();
                        event.stopPropagation();
                    }
                    this._updateCursorInfo();
                    this._emitSelectionChange();
                };
                /**
 * Event handler for mousedown.
 * @private
 */ textmode._onMouseDown = function() {
                    this._updateCursorInfo();
                    this._emitSelectionChange();
                };
                /**
 * Event handler for blur.
 * @private
 */ textmode._onBlur = function() {
                    var me = this;
                    // this allows to avoid blur when clicking inner elements (like the errors panel)
                    // just make sure to set the isFocused to true on the inner element onclick callback
                    setTimeout(function() {
                        if (!me.isFocused) {
                            me._updateCursorInfo();
                            me._emitSelectionChange();
                        }
                        me.isFocused = false;
                    });
                };
                /**
 * Update the cursor info and the status bar, if presented
 */ textmode._updateCursorInfo = function() {
                    var me = this;
                    var line, col, count;
                    if (this.textarea) setTimeout(function() {
                        // this to verify we get the most updated textarea cursor selection
                        var selectionRange = (0, util.getInputSelection)(me.textarea);
                        if (selectionRange.startIndex !== selectionRange.endIndex) count = selectionRange.endIndex - selectionRange.startIndex;
                        if (count && me.cursorInfo && me.cursorInfo.line === selectionRange.end.row && me.cursorInfo.column === selectionRange.end.column) {
                            line = selectionRange.start.row;
                            col = selectionRange.start.column;
                        } else {
                            line = selectionRange.end.row;
                            col = selectionRange.end.column;
                        }
                        me.cursorInfo = {
                            line: line,
                            column: col,
                            count: count
                        };
                        if (me.options.statusBar) updateDisplay();
                    }, 0);
                    else if (this.aceEditor && this.curserInfoElements) {
                        var curserPos = this.aceEditor.getCursorPosition();
                        var selectedText = this.aceEditor.getSelectedText();
                        line = curserPos.row + 1;
                        col = curserPos.column + 1;
                        count = selectedText.length;
                        me.cursorInfo = {
                            line: line,
                            column: col,
                            count: count
                        };
                        if (this.options.statusBar) updateDisplay();
                    }
                    function updateDisplay() {
                        if (me.curserInfoElements.countVal.innerText !== count) {
                            me.curserInfoElements.countVal.innerText = count;
                            me.curserInfoElements.countVal.style.display = count ? 'inline' : 'none';
                            me.curserInfoElements.countLabel.style.display = count ? 'inline' : 'none';
                        }
                        me.curserInfoElements.lnVal.innerText = line;
                        me.curserInfoElements.colVal.innerText = col;
                    }
                };
                /**
 * emits selection change callback, if given
 * @private
 */ textmode._emitSelectionChange = function() {
                    if (this._selectionChangedHandler) {
                        var currentSelection = this.getTextSelection();
                        this._selectionChangedHandler(currentSelection.start, currentSelection.end, currentSelection.text);
                    }
                };
                /**
 * refresh ERROR annotations state
 * error annotations are handled by the ace json mode (ace/mode/json)
 * validation annotations are handled by this mode
 * therefore in order to refresh we send only the annotations of error type in order to maintain its state
 * @private
 */ textmode._refreshAnnotations = function() {
                    var session = this.aceEditor && this.aceEditor.getSession();
                    if (session) {
                        var errEnnotations = session.getAnnotations().filter(function(annotation) {
                            return annotation.type === 'error';
                        });
                        session.setAnnotations(errEnnotations);
                    }
                };
                /**
 * Destroy the editor. Clean up DOM, event listeners, and web workers.
 */ textmode.destroy = function() {
                    // remove old ace editor
                    if (this.aceEditor) {
                        this.aceEditor.destroy();
                        this.aceEditor = null;
                    }
                    if (this.frame && this.container && this.frame.parentNode === this.container) this.container.removeChild(this.frame);
                    if (this.modeSwitcher) {
                        this.modeSwitcher.destroy();
                        this.modeSwitcher = null;
                    }
                    this.textarea = null;
                    this._debouncedValidate = null;
                    // Removing the FocusTracker set to track the editor's focus event
                    this.frameFocusTracker.destroy();
                };
                /**
 * Compact the code in the text editor
 */ textmode.compact = function() {
                    var json = this.get();
                    var text = JSON.stringify(json);
                    this.updateText(text);
                };
                /**
 * Format the code in the text editor
 */ textmode.format = function() {
                    var json = this.get();
                    var text = JSON.stringify(json, null, this.indentation);
                    this.updateText(text);
                };
                /**
 * Repair the code in the text editor
 */ textmode.repair = function() {
                    var text = this.getText();
                    try {
                        var repairedText = (0, jsonrepair /* jsonrepair */ .m)(text);
                        this.updateText(repairedText);
                    } catch (err) {
                    // repair was not successful, do nothing
                    }
                };
                /**
 * Set focus to the formatter
 */ textmode.focus = function() {
                    if (this.textarea) this.textarea.focus();
                    if (this.aceEditor) this.aceEditor.focus();
                };
                /**
 * Resize the formatter
 */ textmode.resize = function() {
                    if (this.aceEditor) {
                        var force = false;
                        this.aceEditor.resize(force);
                    }
                };
                /**
 * Set json data in the formatter
 * @param {*} json
 */ textmode.set = function(json) {
                    this.setText(JSON.stringify(json, null, this.indentation));
                };
                /**
 * Update data. Same as calling `set` in text/code mode.
 * @param {*} json
 */ textmode.update = function(json) {
                    this.updateText(JSON.stringify(json, null, this.indentation));
                };
                /**
 * Get json data from the formatter
 * @return {*} json
 */ textmode.get = function() {
                    var text = this.getText();
                    return (0, util.parse)(text); // this can throw an error
                };
                /**
 * Get the text contents of the editor
 * @return {String} jsonText
 */ textmode.getText = function() {
                    if (this.textarea) return this.textarea.value;
                    if (this.aceEditor) return this.aceEditor.getValue();
                    return '';
                };
                /**
 * Set the text contents of the editor and optionally clear the history
 * @param {String} jsonText
 * @param {boolean} clearHistory   Only applicable for mode 'code'
 * @private
 */ textmode._setText = function(jsonText, clearHistory) {
                    var _this4 = this;
                    var text = this.options.escapeUnicode === true ? (0, util.escapeUnicodeChars)(jsonText) : jsonText;
                    if (this.textarea) this.textarea.value = text;
                    if (this.aceEditor) {
                        // prevent emitting onChange events while setting new text
                        this.onChangeDisabled = true;
                        this.aceEditor.setValue(text, -1);
                        this.onChangeDisabled = false;
                        if (clearHistory) {
                            // prevent initial undo action clearing the initial contents
                            var me = this;
                            setTimeout(function() {
                                if (me.aceEditor) me.aceEditor.session.getUndoManager().reset();
                            });
                        }
                        setTimeout(function() {
                            if (_this4._updateHistoryButtons) _this4._updateHistoryButtons();
                        });
                    }
                    // validate JSON schema
                    this._debouncedValidate();
                };
                /**
 * Set the text contents of the editor
 * @param {String} jsonText
 */ textmode.setText = function(jsonText) {
                    this._setText(jsonText, true);
                };
                /**
 * Update the text contents
 * @param {string} jsonText
 */ textmode.updateText = function(jsonText) {
                    // don't update if there are no changes
                    if (this.getText() === jsonText) return;
                    this._setText(jsonText, false);
                };
                /**
 * Validate current JSON object against the configured JSON schema
 * Throws an exception when no JSON schema is configured
 */ textmode.validate = function() {
                    var _this5 = this;
                    var schemaErrors = [];
                    var parseErrors = [];
                    var json;
                    try {
                        json = this.get(); // this can fail when there is no valid json
                        // execute JSON schema validation (ajv)
                        if (this.validateSchema) {
                            var valid = this.validateSchema(json);
                            if (!valid) schemaErrors = this.validateSchema.errors.map(function(error) {
                                error.type = 'validation';
                                return (0, util.improveSchemaError)(error);
                            });
                        }
                        // execute custom validation and after than merge and render all errors
                        // TODO: implement a better mechanism for only using the last validation action
                        this.validationSequence = (this.validationSequence || 0) + 1;
                        var me = this;
                        var seq = this.validationSequence;
                        return validateCustom(json, this.options.onValidate).then(function(customValidationErrors) {
                            // only apply when there was no other validation started whilst resolving async results
                            if (seq === me.validationSequence) {
                                var errors = schemaErrors.concat(parseErrors).concat(customValidationErrors);
                                me._renderErrors(errors);
                                if (typeof _this5.options.onValidationError === 'function' && (0, util.isValidationErrorChanged)(errors, _this5.lastSchemaErrors)) _this5.options.onValidationError.call(_this5, errors);
                                _this5.lastSchemaErrors = errors;
                            }
                            return _this5.lastSchemaErrors;
                        });
                    } catch (err) {
                        if (this.getText()) {
                            // try to extract the line number from the jsonlint error message
                            var match = /\w*line\s*(\d+)\w*/g.exec(err.message);
                            var line;
                            if (match) line = +match[1];
                            parseErrors = [
                                {
                                    type: 'error',
                                    message: err.message.replace(/\n/g, '<br>'),
                                    line: line
                                }
                            ];
                        }
                        this._renderErrors(parseErrors);
                        if (typeof this.options.onValidationError === 'function' && (0, util.isValidationErrorChanged)(parseErrors, this.lastSchemaErrors)) this.options.onValidationError.call(this, parseErrors);
                        this.lastSchemaErrors = parseErrors;
                        return Promise.resolve(this.lastSchemaErrors);
                    }
                };
                textmode._validateAndCatch = function() {
                    this.validate()["catch"](function(err) {
                        console.error('Error running validation:', err);
                    });
                };
                textmode._renderErrors = function(errors) {
                    var jsonText = this.getText();
                    var errorPaths = [];
                    errors.reduce(function(acc, curr) {
                        if (typeof curr.dataPath === 'string' && acc.indexOf(curr.dataPath) === -1) acc.push(curr.dataPath);
                        return acc;
                    }, errorPaths);
                    var errorLocations = (0, util.getPositionForPath)(jsonText, errorPaths);
                    // render annotations in Ace Editor (if any)
                    if (this.aceEditor) {
                        this.annotations = errorLocations.map(function(errLoc) {
                            var validationErrors = errors.filter(function(err) {
                                return err.dataPath === errLoc.path;
                            });
                            var message = validationErrors.map(function(err) {
                                return err.message;
                            }).join('\n');
                            if (message) return {
                                row: errLoc.line,
                                column: errLoc.column,
                                text: 'Schema validation error' + (validationErrors.length !== 1 ? 's' : '') + ': \n' + message,
                                type: 'warning',
                                source: 'jsoneditor'
                            };
                            return {};
                        });
                        this._refreshAnnotations();
                    }
                    // render errors in the errors table (if any)
                    this.errorTable.setErrors(errors, errorLocations);
                    // update the height of the ace editor
                    if (this.aceEditor) {
                        var force = false;
                        this.aceEditor.resize(force);
                    }
                };
                /**
 * Get the selection details
 * @returns {{start:{row:Number, column:Number},end:{row:Number, column:Number},text:String}}
 */ textmode.getTextSelection = function() {
                    var selection = {};
                    if (this.textarea) {
                        var selectionRange = (0, util.getInputSelection)(this.textarea);
                        if (this.cursorInfo && this.cursorInfo.line === selectionRange.end.row && this.cursorInfo.column === selectionRange.end.column) {
                            // selection direction is bottom => up
                            selection.start = selectionRange.end;
                            selection.end = selectionRange.start;
                        } else selection = selectionRange;
                        return {
                            start: selection.start,
                            end: selection.end,
                            text: this.textarea.value.substring(selectionRange.startIndex, selectionRange.endIndex)
                        };
                    }
                    if (this.aceEditor) {
                        var aceSelection = this.aceEditor.getSelection();
                        var selectedText = this.aceEditor.getSelectedText();
                        var range = aceSelection.getRange();
                        var lead = aceSelection.getSelectionLead();
                        if (lead.row === range.end.row && lead.column === range.end.column) selection = range;
                        else {
                            // selection direction is bottom => up
                            selection.start = range.end;
                            selection.end = range.start;
                        }
                        return {
                            start: {
                                row: selection.start.row + 1,
                                column: selection.start.column + 1
                            },
                            end: {
                                row: selection.end.row + 1,
                                column: selection.end.column + 1
                            },
                            text: selectedText
                        };
                    }
                };
                /**
 * Callback registration for selection change
 * @param {selectionCallback} callback
 *
 * @callback selectionCallback
 */ textmode.onTextSelectionChange = function(callback) {
                    if (typeof callback === 'function') this._selectionChangedHandler = (0, util.debounce)(callback, this.DEBOUNCE_INTERVAL);
                };
                /**
 * Set selection on editor's text
 * @param {{row:Number, column:Number}} startPos selection start position
 * @param {{row:Number, column:Number}} endPos selected end position
 */ textmode.setTextSelection = function(startPos, endPos) {
                    if (!startPos || !endPos) return;
                    if (this.textarea) {
                        var startIndex = (0, util.getIndexForPosition)(this.textarea, startPos.row, startPos.column);
                        var endIndex = (0, util.getIndexForPosition)(this.textarea, endPos.row, endPos.column);
                        if (startIndex > -1 && endIndex > -1) {
                            if (this.textarea.setSelectionRange) {
                                this.textarea.focus();
                                this.textarea.setSelectionRange(startIndex, endIndex);
                            } else if (this.textarea.createTextRange) {
                                // IE < 9
                                var range = this.textarea.createTextRange();
                                range.collapse(true);
                                range.moveEnd('character', endIndex);
                                range.moveStart('character', startIndex);
                                range.select();
                            }
                            var rows = (this.textarea.value.match(/\n/g) || []).length + 1;
                            var lineHeight = this.textarea.scrollHeight / rows;
                            var selectionScrollPos = startPos.row * lineHeight;
                            this.textarea.scrollTop = selectionScrollPos > this.textarea.clientHeight ? selectionScrollPos - this.textarea.clientHeight / 2 : 0;
                        }
                    } else if (this.aceEditor) {
                        var _range = {
                            start: {
                                row: startPos.row - 1,
                                column: startPos.column - 1
                            },
                            end: {
                                row: endPos.row - 1,
                                column: endPos.column - 1
                            }
                        };
                        this.aceEditor.selection.setRange(_range);
                        this.aceEditor.scrollToLine(startPos.row - 1, true);
                    }
                };
                function load() {
                    try {
                        this.format();
                    } catch (err) {
                    // in case of an error, just move on, failing formatting is not a big deal
                    }
                }
                // define modes
                var textModeMixins = [
                    {
                        mode: 'text',
                        mixin: textmode,
                        data: 'text',
                        load: load
                    },
                    {
                        mode: 'code',
                        mixin: textmode,
                        data: 'text',
                        load: load
                    }
                ];
            /***/ }
        };
        /************************************************************************/ /******/ // The module cache
        /******/ var __webpack_module_cache__ = {};
        /******/ /******/ // The require function
        /******/ function __webpack_require__(moduleId) {
            /******/ // Check if module is in cache
            /******/ var cachedModule = __webpack_module_cache__[moduleId];
            /******/ if (cachedModule !== undefined) /******/ return cachedModule.exports;
            /******/ // Create a new module (and put it into the cache)
            /******/ var module1 = __webpack_module_cache__[moduleId] = {
                /******/ // no module.id needed
                /******/ // no module.loaded needed
                /******/ exports: {}
            };
            /******/ /******/ // Execute the module function
            /******/ __webpack_modules__[moduleId].call(module1.exports, module1, module1.exports, __webpack_require__);
            /******/ /******/ // Return the exports of the module
            /******/ return module1.exports;
        /******/ }
        /******/ /************************************************************************/ /******/ /* webpack/runtime/compat get default export */ /******/ !function() {
            /******/ // getDefaultExport function for compatibility with non-harmony modules
            /******/ __webpack_require__.n = function(module1) {
                /******/ var getter = module1 && module1.__esModule ? /******/ function() {
                    return module1['default'];
                } : /******/ function() {
                    return module1;
                };
                /******/ __webpack_require__.d(getter, {
                    a: getter
                });
                /******/ return getter;
            /******/ };
        /******/ }();
        /******/ /******/ /* webpack/runtime/define property getters */ /******/ !function() {
            /******/ // define getter functions for harmony exports
            /******/ __webpack_require__.d = function(exports, definition) {
                /******/ for(var key in definition)/******/ if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) /******/ Object.defineProperty(exports, key, {
                    enumerable: true,
                    get: definition[key]
                });
            /******/ };
        /******/ }();
        /******/ /******/ /* webpack/runtime/hasOwnProperty shorthand */ /******/ !function() {
            /******/ __webpack_require__.o = function(obj, prop) {
                return Object.prototype.hasOwnProperty.call(obj, prop);
            };
        /******/ }();
        /******/ /******/ /* webpack/runtime/make namespace object */ /******/ !function() {
            /******/ // define __esModule on exports
            /******/ __webpack_require__.r = function(exports) {
                /******/ if (typeof Symbol !== 'undefined' && Symbol.toStringTag) /******/ Object.defineProperty(exports, Symbol.toStringTag, {
                    value: 'Module'
                });
                /******/ Object.defineProperty(exports, '__esModule', {
                    value: true
                });
            /******/ };
        /******/ }();
        /******/ /************************************************************************/ /******/ /******/ // startup
        /******/ // Load entry module and return exports
        /******/ // This entry module is referenced by other modules so it can't be inlined
        /******/ var __webpack_exports__ = __webpack_require__(346);
        /******/ /******/ return __webpack_exports__;
    /******/ }();
});



function $f7ab5a703d867f18$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $f7ab5a703d867f18$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $f7ab5a703d867f18$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $f7ab5a703d867f18$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $f7ab5a703d867f18$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $f7ab5a703d867f18$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $f7ab5a703d867f18$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $f7ab5a703d867f18$var$_objectSpread2(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $f7ab5a703d867f18$var$ownKeys(Object(source), true).forEach(function(key) {
            $f7ab5a703d867f18$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $f7ab5a703d867f18$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $f7ab5a703d867f18$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $f7ab5a703d867f18$var$_setPrototypeOf(subClass, superClass);
}
function $f7ab5a703d867f18$var$_getPrototypeOf(o) {
    $f7ab5a703d867f18$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $f7ab5a703d867f18$var$_getPrototypeOf(o);
}
function $f7ab5a703d867f18$var$_setPrototypeOf(o, p) {
    $f7ab5a703d867f18$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $f7ab5a703d867f18$var$_setPrototypeOf(o, p);
}
function $f7ab5a703d867f18$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $f7ab5a703d867f18$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $f7ab5a703d867f18$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $f7ab5a703d867f18$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $f7ab5a703d867f18$var$_possibleConstructorReturn(self, call) {
    if (call && (typeof call === "object" || typeof call === "function")) return call;
    return $f7ab5a703d867f18$var$_assertThisInitialized(self);
}
/**
 * @typedef {{
 * tree: string,
 * view: string,
 * form: string,
 * code: string,
 * text: string,
 * allValues: Array<string>
 * }} TJsonEditorModes
 */ var $f7ab5a703d867f18$var$modes = {
    tree: 'tree',
    view: 'view',
    form: 'form',
    code: 'code',
    text: 'text'
};
var $f7ab5a703d867f18$var$values = Object.values($f7ab5a703d867f18$var$modes);
$f7ab5a703d867f18$var$modes.allValues = $f7ab5a703d867f18$var$values;
/**
 * @type {object}
 * @property {object} [value]
 * @property {string} [mode='tree'] - Set the editor mode.
 * @property {string} [name=undefined] - Initial field name for the root node
 * @property {object} [schema] - Validate the JSON object against a JSON schema.
 * @property {object} [schemaRefs] - Schemas that are referenced using
 * the $ref property
 * @property {Function} [onChange] - Set a callback function
 * triggered when json in the JSONEditor change.
 * Will only be triggered on changes made by the user.
 * @property {Function} [onError] - Set a callback function triggered when an error occurs.
 * Invoked with the error as first argument.
 * The callback is only invoked for errors triggered by a users action,
 * like switching from code mode to tree mode or clicking
 * the Format button whilst the editor doesn't contain valid JSON.
 * @property {Function} [onModeChange] - Set a callback function
 * triggered right after the mode is changed by the user.
 * @property {object} [ace] - Provide a version of the Ace editor.
 * Only applicable when mode is code
 * @property {object} [ajv] - Provide a instance of ajv,
 * the library used for JSON schema validation.
 * @property {string} [theme] - Set the Ace editor theme,
 * uses included 'ace/theme/jsoneditor' by default.
 * @property {boolean} [history=false] - Enables history,
 * adds a button Undo and Redo to the menu of the JSONEditor. Only applicable when
 * mode is 'tree' or 'form'
 * @property {boolean} [navigationBar=true] - Adds navigation bar to the menu
 * the navigation bar visualize the current position on the
 * tree structure as well as allows breadcrumbs navigation.
 * @property {boolean} [statusBar=true] - Adds status bar to the buttom of the editor
 * the status bar shows the cursor position and a count of the selected characters.
 * Only applicable when mode is 'code' or 'text'.
 * @property {boolean} [search=true] - Enables a search box in
 * the upper right corner of the JSONEditor.
 * @property {Array<string>} [allowedModes] - Create a box in the editor menu where
 * the user can switch between the specified modes.
 * @property {(string|PropTypes.elementType)} [tag='div'] - Html element, or react element to render
 * @property {object} [htmlElementProps] - html element custom props
 * @property {Function} [innerRef] - callback to get html element reference
 * @property {boolean} [sortObjectKeys=false] If true, object keys in 'tree',
 * 'view' or 'form' mode list be listed alphabetically instead by their insertion order..
 */ var $f7ab5a703d867f18$export$6ceb3ecfc2648a0d = /*#__PURE__*/ function(_Component) {
    $f7ab5a703d867f18$var$_inherits(Editor, _Component);
    function Editor(props) {
        var _this;
        $f7ab5a703d867f18$var$_classCallCheck(this, Editor);
        _this = $f7ab5a703d867f18$var$_possibleConstructorReturn(this, $f7ab5a703d867f18$var$_getPrototypeOf(Editor).call(this, props));
        _this.htmlElementRef = null;
        _this.jsonEditor = null;
        _this.handleChange = _this.handleChange.bind($f7ab5a703d867f18$var$_assertThisInitialized(_this));
        _this.setRef = _this.setRef.bind($f7ab5a703d867f18$var$_assertThisInitialized(_this));
        _this.collapseAll = _this.collapseAll.bind($f7ab5a703d867f18$var$_assertThisInitialized(_this));
        _this.expandAll = _this.expandAll.bind($f7ab5a703d867f18$var$_assertThisInitialized(_this));
        _this.focus = _this.focus.bind($f7ab5a703d867f18$var$_assertThisInitialized(_this));
        return _this;
    }
    $f7ab5a703d867f18$var$_createClass(Editor, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                var _this$props = this.props, allowedModes = _this$props.allowedModes, innerRef = _this$props.innerRef, htmlElementProps = _this$props.htmlElementProps, tag = _this$props.tag, onChange = _this$props.onChange, rest = $f7ab5a703d867f18$var$_objectWithoutProperties(_this$props, [
                    "allowedModes",
                    "innerRef",
                    "htmlElementProps",
                    "tag",
                    "onChange"
                ]);
                this.createEditor($f7ab5a703d867f18$var$_objectSpread2({}, rest, {
                    modes: allowedModes
                }));
            } // eslint-disable-next-line react/sort-comp
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(_ref) {
                var allowedModes = _ref.allowedModes, schema = _ref.schema, name = _ref.name, theme = _ref.theme, schemaRefs = _ref.schemaRefs, innerRef = _ref.innerRef, htmlElementProps = _ref.htmlElementProps, tag = _ref.tag, onChange = _ref.onChange, rest = $f7ab5a703d867f18$var$_objectWithoutProperties(_ref, [
                    "allowedModes",
                    "schema",
                    "name",
                    "theme",
                    "schemaRefs",
                    "innerRef",
                    "htmlElementProps",
                    "tag",
                    "onChange"
                ]);
                if (this.jsonEditor) {
                    if (theme !== this.props.theme) this.createEditor($f7ab5a703d867f18$var$_objectSpread2({}, rest, {
                        theme: theme,
                        modes: allowedModes
                    }));
                    else {
                        if (schema !== this.props.schema || schemaRefs !== this.props.schemaRefs) this.jsonEditor.setSchema(schema, schemaRefs);
                        if (name !== this.jsonEditor.getName()) this.jsonEditor.setName(name);
                    }
                }
            }
        },
        {
            key: "shouldComponentUpdate",
            value: function shouldComponentUpdate(_ref2) {
                var htmlElementProps = _ref2.htmlElementProps;
                return htmlElementProps !== this.props.htmlElementProps;
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                if (this.jsonEditor) {
                    this.jsonEditor.destroy();
                    this.jsonEditor = null;
                }
            }
        },
        {
            key: "setRef",
            value: function setRef(element) {
                this.htmlElementRef = element;
                if (this.props.innerRef) this.props.innerRef(element);
            }
        },
        {
            key: "createEditor",
            value: function createEditor(_ref3) {
                var value = _ref3.value, rest = $f7ab5a703d867f18$var$_objectWithoutProperties(_ref3, [
                    "value"
                ]);
                if (this.jsonEditor) this.jsonEditor.destroy();
                this.jsonEditor = new (0, (/*@__PURE__*/$parcel$interopDefault($8afe3d8bf5ddfcf3$exports)))(this.htmlElementRef, $f7ab5a703d867f18$var$_objectSpread2({
                    onChange: this.handleChange
                }, rest));
                this.jsonEditor.set(value);
            }
        },
        {
            key: "handleChange",
            value: function handleChange() {
                if (this.props.onChange) try {
                    this.err = null;
                    var text = this.jsonEditor.getText();
                    if (text === '') this.props.onChange(null);
                    var currentJson = this.jsonEditor.get();
                    if (this.props.value !== currentJson) this.props.onChange(currentJson);
                } catch (err) {
                    this.err = err;
                }
            }
        },
        {
            key: "collapseAll",
            value: function collapseAll() {
                if (this.jsonEditor) this.jsonEditor.collapseAll();
            }
        },
        {
            key: "expandAll",
            value: function expandAll() {
                if (this.jsonEditor) this.jsonEditor.expandAll();
            }
        },
        {
            key: "focus",
            value: function focus() {
                if (this.jsonEditor) this.jsonEditor.focus();
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$props2 = this.props, htmlElementProps = _this$props2.htmlElementProps, tag = _this$props2.tag;
                return (0, (/*@__PURE__*/$parcel$interopDefault($gJYWc))).createElement(tag, $f7ab5a703d867f18$var$_objectSpread2({}, htmlElementProps, {
                    ref: this.setRef
                }));
            }
        }
    ]);
    return Editor;
}((0, $gJYWc.Component));
$f7ab5a703d867f18$export$6ceb3ecfc2648a0d.propTypes = {
    //  jsoneditor props
    value: (0, (/*@__PURE__*/$parcel$interopDefault($3Zour))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($3Zour))).object,
        (0, (/*@__PURE__*/$parcel$interopDefault($3Zour))).array,
        (0, (/*@__PURE__*/$parcel$interopDefault($3Zour))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($3Zour))).bool,
        (0, (/*@__PURE__*/$parcel$interopDefault($3Zour))).number
    ]),
    mode: (0, (/*@__PURE__*/$parcel$interopDefault($3Zour))).oneOf($f7ab5a703d867f18$var$values),
    name: (0, (/*@__PURE__*/$parcel$interopDefault($3Zour))).string,
    schema: (0, (/*@__PURE__*/$parcel$interopDefault($3Zour))).object,
    schemaRefs: (0, (/*@__PURE__*/$parcel$interopDefault($3Zour))).object,
    sortObjectKeys: (0, (/*@__PURE__*/$parcel$interopDefault($3Zour))).bool,
    onChange: (0, (/*@__PURE__*/$parcel$interopDefault($3Zour))).func,
    onError: (0, (/*@__PURE__*/$parcel$interopDefault($3Zour))).func,
    onModeChange: (0, (/*@__PURE__*/$parcel$interopDefault($3Zour))).func,
    ace: (0, (/*@__PURE__*/$parcel$interopDefault($3Zour))).object,
    ajv: (0, (/*@__PURE__*/$parcel$interopDefault($3Zour))).object,
    theme: (0, (/*@__PURE__*/$parcel$interopDefault($3Zour))).string,
    history: (0, (/*@__PURE__*/$parcel$interopDefault($3Zour))).bool,
    navigationBar: (0, (/*@__PURE__*/$parcel$interopDefault($3Zour))).bool,
    statusBar: (0, (/*@__PURE__*/$parcel$interopDefault($3Zour))).bool,
    search: (0, (/*@__PURE__*/$parcel$interopDefault($3Zour))).bool,
    allowedModes: (0, (/*@__PURE__*/$parcel$interopDefault($3Zour))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($3Zour))).oneOf($f7ab5a703d867f18$var$values)),
    //  custom props
    tag: (0, (/*@__PURE__*/$parcel$interopDefault($3Zour))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($3Zour))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($3Zour))).elementType
    ]),
    htmlElementProps: (0, (/*@__PURE__*/$parcel$interopDefault($3Zour))).object,
    innerRef: (0, (/*@__PURE__*/$parcel$interopDefault($3Zour))).func
};
$f7ab5a703d867f18$export$6ceb3ecfc2648a0d.defaultProps = {
    tag: 'div',
    mode: $f7ab5a703d867f18$var$modes.tree,
    history: false,
    search: true,
    navigationBar: true,
    statusBar: true,
    sortObjectKeys: false
};
/**
 * @type TJsonEditorModes
 */ $f7ab5a703d867f18$export$6ceb3ecfc2648a0d.modes = $f7ab5a703d867f18$var$modes;




const $21b9fa09c5ee7612$export$16a92831a5852837 = ()=>{
    const { id: id } = (0, $a35327dc535bf969$export$99eaa27ddbbb95ef)();
    const { user: user } = (0, $47f2f2762182381c$export$f2b63d3ca66bb884)();
    const isMisha = user?.sub === undefined;
    const [ad, setAdd] = (0, $gJYWc.useState)(null);
    const onJsonChange = (json)=>console.log(json);
    (0, $gJYWc.useEffect)(()=>{
        const fetchAds = async ()=>{
            const ad = await (0, $70a97169caddc04c$export$e335e813e295bb79)(id);
            setAdd(ad);
        };
        if (user && isMisha) fetchAds().catch(console.error);
    }, [
        user
    ]);
    console.log(ad);
    return /*#__PURE__*/ (0, $9wx12.jsxs)((0, $9wx12.Fragment), {
        children: [
            /*#__PURE__*/ (0, $9wx12.jsx)((0, $fc72cc536184e560$export$8b251419efc915eb), {
                withBorder: true
            }),
            /*#__PURE__*/ (0, $9wx12.jsxs)("div", {
                className: "max-w-screen-lg mx-auto mt-10",
                children: [
                    ad ? /*#__PURE__*/ (0, $9wx12.jsx)((0, $f7ab5a703d867f18$export$6ceb3ecfc2648a0d), {
                        value: ad,
                        onChange: setAdd
                    }) : 'Loading...',
                    /*#__PURE__*/ (0, $9wx12.jsx)("div", {
                        className: "text-right",
                        children: /*#__PURE__*/ (0, $9wx12.jsx)((0, $95b3a1ef1ddc1e78$export$2e2bcd8739ae039), {
                            variant: "outlined",
                            onClick: console.log,
                            children: "Save"
                        })
                    })
                ]
            })
        ]
    });
};


const $20633ff73aa38006$var$root = (0, $2eecfe30d0392fb8$export$882461b6382ed46c)(document.getElementById('root'));
const $20633ff73aa38006$var$theme = (0, $3vNtX.default)({
    typography: {
        fontFamily: [
            'Lato',
            '-apple-system',
            'BlinkMacSystemFont',
            '"Segoe UI"',
            'Roboto',
            '"Helvetica Neue"',
            'Arial',
            'sans-serif',
            '"Apple Color Emoji"',
            '"Segoe UI Emoji"',
            '"Segoe UI Symbol"'
        ].join(',')
    }
});
$20633ff73aa38006$var$root.render(/*#__PURE__*/ (0, $9wx12.jsx)((0, $47f2f2762182381c$export$6aefaad9cc4faf3c), {
    domain: undefined,
    clientId: undefined,
    authorizationParams: {
        redirect_uri: window.location.origin
    },
    children: /*#__PURE__*/ (0, $9wx12.jsx)((0, $ec109688d3887965$export$2e2bcd8739ae039), {
        theme: $20633ff73aa38006$var$theme,
        children: /*#__PURE__*/ (0, $9wx12.jsx)((0, $38b9c61d570d1b88$export$dc45bdc734ce6f1e), {
            dateAdapter: (0, $849ce0a30691b194$export$33545c6a80bae043),
            children: /*#__PURE__*/ (0, $9wx12.jsx)((0, $8384e1b28fff68bc$export$9ba4e89fdfa1fc54), {
                children: /*#__PURE__*/ (0, $9wx12.jsxs)((0, $a35327dc535bf969$export$3565eb3d00ca5a74), {
                    children: [
                        /*#__PURE__*/ (0, $9wx12.jsx)((0, $a35327dc535bf969$export$e7b0ac011bb776c6), {
                            path: "/",
                            element: /*#__PURE__*/ (0, $9wx12.jsx)((0, $4284c25e4429de7b$export$12449a31c6671d53), {})
                        }),
                        /*#__PURE__*/ (0, $9wx12.jsx)((0, $a35327dc535bf969$export$e7b0ac011bb776c6), {
                            path: "map",
                            element: /*#__PURE__*/ (0, $9wx12.jsx)((0, $8b4d84056d9f0adb$export$30f8d45547b3f2cd), {})
                        }),
                        /*#__PURE__*/ (0, $9wx12.jsx)((0, $a35327dc535bf969$export$e7b0ac011bb776c6), {
                            path: "places/:id",
                            element: /*#__PURE__*/ (0, $9wx12.jsx)((0, $09accb3514a271c7$export$7c799e71f5549651), {})
                        }),
                        /*#__PURE__*/ (0, $9wx12.jsx)((0, $a35327dc535bf969$export$e7b0ac011bb776c6), {
                            path: "contacts",
                            element: /*#__PURE__*/ (0, $9wx12.jsx)((0, $4b4ce03023b20fd7$export$35ce064bf8784099), {})
                        }),
                        /*#__PURE__*/ (0, $9wx12.jsx)((0, $a35327dc535bf969$export$e7b0ac011bb776c6), {
                            path: "faq",
                            element: /*#__PURE__*/ (0, $9wx12.jsx)((0, $dd2b210167fce8db$export$690878eeeaffbdc8), {})
                        }),
                        /*#__PURE__*/ (0, $9wx12.jsx)((0, $a35327dc535bf969$export$e7b0ac011bb776c6), {
                            path: "terms",
                            element: /*#__PURE__*/ (0, $9wx12.jsx)((0, $60221e927fa06151$export$3131deacacdc712c), {})
                        }),
                        /*#__PURE__*/ (0, $9wx12.jsx)((0, $a35327dc535bf969$export$e7b0ac011bb776c6), {
                            path: "account",
                            element: /*#__PURE__*/ (0, $9wx12.jsx)((0, $135535c9b579e2fc$export$1ed4b10e4aba04a7), {})
                        }),
                        /*#__PURE__*/ (0, $9wx12.jsx)((0, $a35327dc535bf969$export$e7b0ac011bb776c6), {
                            path: "account/listings",
                            element: /*#__PURE__*/ (0, $9wx12.jsx)((0, $8093f2f2d86049f5$export$ba6d244036e50401), {})
                        }),
                        /*#__PURE__*/ (0, $9wx12.jsx)((0, $a35327dc535bf969$export$e7b0ac011bb776c6), {
                            path: "account/listings/:id",
                            element: /*#__PURE__*/ (0, $9wx12.jsx)((0, $21b9fa09c5ee7612$export$16a92831a5852837), {})
                        })
                    ]
                })
            })
        })
    })
}));


//# sourceMappingURL=path0.ff22bf73.js.map
